/**
 * AXIS Gestión Empresarial — Plataforma Legal para PYMES
 * © 2026 Todos los derechos reservados
 *
 * Concebido, diseñado y desarrollado por AXIS Asesoría Legal Corporativa
 * Socios: Javier Iván Acuña López · Marco Aurelio Hernández Parada · Lixandro Fabián Gutiérrez Ortiz
 * AXIS Asesoría Legal Corporativa · Aguascalientes, México
 * axislegalags.com · 449 425 11 28
 *
 * Obra protegida por la Ley Federal del Derecho de Autor (LFDA)
 * Registro ante INDAUTOR en trámite
 *
 * Módulo de gestión de trabajadores: cuentas, tareas, checador y flotilla.
 */
import React, { useState, useMemo, useEffect, useLayoutEffect, useCallback, useRef, useContext } from "react";
import { createPortal } from "react-dom";
import logo from "./logo.png";
// Logo AXIS (AXIS_logo_firma.png) embebido en base64 para membrete de documentos
// generados (PDF/print). Embebido => carga sin red, funciona en html2canvas y en
// window.print(); defensivo: si por algo no pinta, el <img> se oculta (onerror).
const AXIS_LOGO_FIRMA_B64 = "data:image/png;base64,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";
import { initializeApp, getApps } from "firebase/app";
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut, onAuthStateChanged, GoogleAuthProvider, signInWithPopup, updateProfile, sendPasswordResetEmail, setPersistence, browserLocalPersistence, browserSessionPersistence, deleteUser, getAdditionalUserInfo, inMemoryPersistence, signInWithCredential } from "firebase/auth";
import { getFirestore, collection, addDoc, getDocs, query, orderBy, where, Timestamp, doc, updateDoc, deleteDoc, setDoc, getDoc, writeBatch, serverTimestamp, getCountFromServer, increment, arrayUnion, runTransaction, onSnapshot } from "firebase/firestore";
import { getStorage, ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
import { getMessaging, getToken, onMessage, isSupported as fcmIsSupported } from "firebase/messaging";

// ─── FIREBASE ─────────────────────────────────────────────────────────────────
const firebaseConfig = {
  apiKey: "AIzaSyBFUKrPkSqwOJcAAQDUE22Ev5-Qtw2Poeo",
  authDomain: "axis-gestion-empresarial.firebaseapp.com",
  projectId: "axis-gestion-empresarial",
  storageBucket: "axis-gestion-empresarial.firebasestorage.app",
  messagingSenderId: "950584737393",
  appId: "1:950584737393:web:e5c3317793ab4ec066e5d0",
};
const firebaseApp = initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp);
const storage = getStorage(firebaseApp);
;

// ═══ NOTIFICACIONES — EL DISEÑO, ANTES QUE EL CÓDIGO ═══════════════════════
//
// Esto se escribe aquí, y no en una nota aparte, porque es el sitio por donde
// pasa cualquiera que vaya a emitir un aviso. Si alguien lo deshace, que sea
// habiéndolo leído.
//
// TRES SUPERFICIES, Y NO SON LA MISMA LISTA EN TRES TAMAÑOS:
//
//   · REGISTRO DE ACTIVIDAD — recibe TODO. Es bitácora: se consulta cuando
//     alguien quiere saber qué pasó. NO lleva contador ni punto: nada de lo que
//     hay ahí reclama atención por estar ahí.
//
//   · CAMPANA — solo EVENTOS: hechos que ocurrieron y que se apagan al verlos.
//     Su contador TIENE QUE PODER LLEGAR A CERO. Una campana que siempre trae
//     número se deja de leer en una semana, y entonces no sirve el día que
//     traiga algo importante. (Por eso las actividades por confirmar salieron de
//     su contador: eran pendientes, no eventos, y nunca se apagaban.)
//
//   · PUSH — la lista MÁS CORTA de las tres. Solo lo que amerita interrumpir un
//     teléfono. Lo que no interrumpiría a una persona por teléfono no va aquí,
//     por mucho que quepa en las otras dos.
//
// TRES REGLAS DE EMISIÓN:
//
//   1. NO SE NOTIFICA LO ESPERADO; SE NOTIFICA LO QUE SE SALIÓ DE LO ESPERADO.
//      Que quince personas checaran entrada es que el día empezó bien. El aviso
//      es "faltan 3 por checar", y UNA vez.
//
//   2. UN HECHO QUE PUEDE OCURRIR N VECES EL MISMO DÍA VA EN UNA SOLA LÍNEA,
//      con el número adentro. Nunca una notificación por persona.
//
//   3. NO SE TE NOTIFICA LO QUE TÚ HICISTE. Se compara quién capturó contra
//      quién recibe. Si el patrón registra él mismo la salida de un vehículo, no
//      le llega. Hoy el único campo que permite ese cotejo es
//      `registradoPorRol` en la colección `flotilla`.
//
// Y LA REGLA QUE YA ESTABA FIJADA: LAS NOTIFICACIONES LAS EMITE LA PLATAFORMA,
// NUNCA AXIOR. Ni su icono ni su voz. Un aviso de que un documento venció es un
// hecho de los datos del patrón; con la cara del asistente encima se leería como
// una opinión de la IA. Cuando habla la plataforma es un hecho; cuando habla
// AXIOR es una opinión, y no se mezclan.
//
// ─── NOTIFICACIONES PUSH (FCM) ──────────────────────────────────────────────
// VAPID key del proyecto (Firebase Console → Cloud Messaging → Web Push certificates).
// IVÁN: pega aquí la clave. Mientras diga "PEGAR_AQUI" no se captura token (no rompe nada).
const VAPID_KEY = "BKlkmT8Bl4nTAapsGwyRaRKfFzLU5mmtj_CclhEWo8ELBDJOdSEfSIqfnhCkEPEeGNdfhoqaKRZ-MH9tZMISDBk";

// ⚠️ ESTE HOOK SE MONTA SOLO EN EL ARMAZÓN DEL PATRÓN, Y ASÍ SE QUEDA.
//
// El portal del trabajador NO lo llama, y no es un olvido. Hoy no existe ni un
// solo aviso dirigido a un trabajador: el único que manda el servidor
// —"faltan N por checar entrada"— es para el patrón, sobre su equipo. Pedirle al
// trabajador el permiso del navegador sería pedirle algo que no vamos a usar, que
// es exactamente el error que acabamos de corregir en la tarjeta del patrón: se
// activa, no llega nada, y a las dos semanas la conclusión no es "falta una pieza"
// sino "esto no sirve". Y esa conclusión no se desanda.
//
// SE MONTA EL DÍA QUE EXISTA SU PRIMER AVISO, no antes. Cuando lo haya, hará falta
// además una puerta propia con SU texto —lo que se le avisa a él no es lo que se
// le avisa al patrón— y decidir dónde vive; la pestaña Notificaciones de su portal
// es el sitio natural, porque es donde ya mira lo que le llega.
//
// (13-oct-2026) YA EXISTE: el recordatorio de entrada. Y se hizo como dice arriba:
// el trabajador NO monta este hook, tiene el suyo —`useRecordatorioTrabajador`—,
// con su propia puerta y su texto (`PanelRecordatorioEntrada`, en su pestaña
// Notificaciones), sus teléfonos en `dispositivos_trabajador/{uid}` y no en
// `usuarios`, y solo si la cuenta de su patrón tiene encendido el interruptor.
//
// Hook de notificaciones push (lado cliente):
// - Captura silenciosa del token si el usuario YA dio permiso antes.
// - activar(): pide permiso y, si acepta, obtiene el token FCM y lo guarda en
//   usuarios/{uid}.fcmDispositivos, bajo la clave estable de ESTE navegador,
//   de modo que renovar el token reemplace en vez de acumular.
// - onMessage: si llega un push con la app en primer plano, muestra notificación.
// Todo es a prueba de fallos: si el navegador no soporta o el usuario niega, no rompe.
// LA CLAVE ESTABLE DE ESTE NAVEGADOR.
//
// Se genera UNA vez y se queda en `localStorage`: sobrevive a cerrar sesión, a
// recargar y a que el token de FCM se renueve, que es justo lo que hacía falta
// para que renovar reemplace en vez de añadir.
//
// Si `localStorage` no está disponible —modo privado, almacenamiento bloqueado—
// se devuelve una clave de sesión: se pierde la ventaja al recargar, pero es
// preferible a no registrar el dispositivo. Los caracteres se acotan porque esto
// va como NOMBRE DE CAMPO en Firestore.
const CLAVE_DISPOSITIVO = "axis_dispositivo";
let _idDispositivoMemoria = "";
function idDeEsteDispositivo(): string {
  const nuevo = () => "d" + Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
  try {
    let id = window.localStorage.getItem(CLAVE_DISPOSITIVO) || "";
    if (!/^[A-Za-z0-9_-]{4,64}$/.test(id)) { id = nuevo(); window.localStorage.setItem(CLAVE_DISPOSITIVO, id); }
    return id;
  } catch (_e) {
    if (!_idDispositivoMemoria) _idDispositivoMemoria = nuevo();
    return _idDispositivoMemoria;
  }
}

// ═══ LA PLATAFORMA APROXIMADA DE ESTE APARATO ═══════════════════════════════
// android, ios o escritorio, y nada más: se guarda junto al token para que el
// registro de un envío diga a qué CLASE de aparato fue (ver `desgloseDeEnvio` en
// src/logica/push.js). NO se guarda el navegador completo: el userAgent se lee
// aquí y se reduce a una de tres palabras antes de salir del aparato.
function plataformaDeEsteAparato(): "android" | "ios" | "escritorio" {
  if (_esIOS()) return "ios";
  const ua = typeof navigator !== "undefined" ? String(navigator.userAgent || "") : "";
  return /android/i.test(ua) ? "android" : "escritorio";
}
function _esAndroid(): boolean { return plataformaDeEsteAparato() === "android"; }

// ═══ UN AVISO QUE LLEGA CON LA PÁGINA ABIERTA ═══════════════════════════════
//
// EL DEFECTO QUE ESTO CORRIGE, Y ESTABA EN PRODUCCIÓN. Con la plataforma abierta
// en primer plano, FCM no despierta al service worker: entrega el aviso a ESTA
// página (`onMessage`). Aquí se hacía `new Notification(...)`, y Chrome en
// Android NO permite ese constructor —"Illegal constructor. Use
// ServiceWorkerRegistration.showNotification()"—. El error se tragaba en un
// `catch` vacío: el servidor decía "avisamos", Google lo había aceptado, y en el
// teléfono del patrón no aparecía nada.
//
// AHORA, con el service worker de los avisos —el MISMO que pinta el aviso con la
// página cerrada (`firebase-messaging-sw.js`)—: mismo título, cuerpo, iconos,
// etiqueta y, al tocarlo, el mismo `notificationclick`. Se pide su registro por
// su ámbito; el de `/sw.js` (el de la caché) no sabe qué hacer al tocarlo.
//
// SI NO SE PUEDE, NO SE TRAGA: se dice por qué en la consola y se pinta un aviso
// DENTRO de la página (`AvisosEnPagina`), para que el patrón lo vea igual. Vale
// para todos los avisos que llegan por aquí: accidente, checador, leads.
const AMBITO_SW_AVISOS = "/firebase-cloud-messaging-push-scope";
const EVENTO_AVISO_EN_PAGINA = "avisos:enPagina";
async function mostrarAvisoEnPrimerPlano(d: any): Promise<"service_worker"|"pagina"> {
  const titulo = String((d && d.title) || "AXIS Legaltech");
  // LAS MISMAS OPCIONES QUE `onBackgroundMessage` en firebase-messaging-sw.js.
  const opciones: any = {
    body: String((d && d.body) || ""),
    icon: "/logo.png?v=4",
    badge: "/badge.png",
    tag: (d && (d.etiqueta || d.tipo)) || "axis",
    renotify: false,
    data: d || {},
  };
  let motivo = "";
  try {
    if (typeof Notification !== "undefined" && Notification.permission !== "granted") motivo = "el permiso de notificaciones no está concedido";
    else if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) motivo = "este navegador no tiene service worker";
    else {
      const reg: any = await navigator.serviceWorker.getRegistration(AMBITO_SW_AVISOS);
      if (!reg || typeof reg.showNotification !== "function") motivo = "no está registrado el service worker de los avisos";
      else { await reg.showNotification(titulo, opciones); return "service_worker"; }
    }
  } catch (e: any) {
    motivo = "showNotification falló: " + ((e && (e.name || e.message)) || String(e));
  }
  console.error("aviso en primer plano · no se pudo mostrar con el service worker (" + motivo + "); se muestra dentro de la página");
  try { window.dispatchEvent(new CustomEvent(EVENTO_AVISO_EN_PAGINA, { detail: { titulo, cuerpo: opciones.body, etiqueta: opciones.tag } })); }
  catch (e) { console.error("aviso en primer plano · tampoco se pudo pintar dentro de la página:", e); }
  return "pagina";
}

// ═══ ¿ESTE APARATO YA CORRE EL SERVICE WORKER NUEVO DE LOS AVISOS? ═══════════
// La MISMA cadena que `VERSION_AVISOS` en public/firebase-messaging-sw.js: se
// cambian juntas, y `prueba-sw-avisos` exige que coincidan.
const VERSION_SW_AVISOS = "2026-10-13.1";
type EstadoSwAvisos = { estado: "al_dia" | "anterior" | "sin_registrar" | "no_disponible"; version: string };
// Pide al navegador que busque la versión nueva del archivo (`update`), espera
// un momento a que se instale si la había, y le PREGUNTA su versión. Un service
// worker anterior al 4-oct no sabe contestar: eso es "anterior".
async function versionDelServiceWorkerDeAvisos(): Promise<EstadoSwAvisos> {
  try {
    if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return {estado: "no_disponible", version: ""};
    const reg: any = await navigator.serviceWorker.getRegistration(AMBITO_SW_AVISOS);
    if (!reg) return {estado: "sin_registrar", version: ""};
    try { await reg.update(); } catch (e) { /* sin red: se pregunta al que haya */ }
    const nuevo: any = reg.installing || reg.waiting;
    if (nuevo) await new Promise<void>((listo) => {
      const t = setTimeout(listo, 5000);
      nuevo.addEventListener("statechange", () => {
        if (nuevo.state === "activated" || nuevo.state === "redundant") { clearTimeout(t); listo(); }
      });
    });
    const sw: any = reg.active;
    if (!sw) return {estado: "sin_registrar", version: ""};
    const version = await new Promise<string>((listo) => {
      const canal = new MessageChannel();
      const t = setTimeout(() => listo(""), 2500);
      canal.port1.onmessage = (ev: any) => { clearTimeout(t); listo(String((ev && ev.data && ev.data.version) || "")); };
      sw.postMessage({tipo: "axis:version-avisos"}, [canal.port2]);
    });
    if (!version) return {estado: "anterior", version: ""};
    return {estado: version === VERSION_SW_AVISOS ? "al_dia" : "anterior", version};
  } catch (e) {
    return {estado: "no_disponible", version: ""};
  }
}
function textoEstadoSwAvisos(e: EstadoSwAvisos): string {
  if (e.estado === "al_dia") return "Avisos en este aparato: versión " + e.version + ", al día.";
  if (e.estado === "anterior") return "Avisos en este aparato: versión anterior"
    + (e.version ? " (" + e.version + ")" : "") + ". Cierra AXIS por completo y vuelve a abrirlo.";
  if (e.estado === "sin_registrar") return "Los avisos todavía no están instalados en este aparato.";
  return "";
}

// LA NOTA DEL AHORRO DE BATERÍA, SOLO EN ANDROID. Factual y sin detección: la web
// no puede saber si Chrome está en suspensión, así que no se finge. Dos usos:
//   · debajo de los avisos recién activados, con "Cerrar", y no vuelve a salir en
//     este aparato;
//   · fija en el perfil, donde se ve el estado de los avisos.
const CLAVE_NOTA_BATERIA = "axis_nota_bateria_cerrada";
const TEXTO_NOTA_BATERIA = "Si tu celular es Samsung u otro Android con ahorro de batería, revisa que Chrome no esté en suspensión: Ajustes → Batería → Límites de uso en segundo plano. Si está ahí, los avisos pueden no llegar.";
function NotaBateriaAndroid({c, fontSans, onCerrar}: {c: {fondo: string; borde: string; texto: string; textoSuave: string}; fontSans: string; onCerrar?: () => void}) {
  if (!_esAndroid()) return null;
  return (
    <div style={{marginTop: 8, background: c.fondo, border: "1px solid " + c.borde, borderRadius: 10, padding: "9px 12px",
      fontFamily: fontSans, display: "flex", gap: 10, alignItems: "flex-start"}}>
      <div style={{flex: 1, fontSize: 11.5, color: c.textoSuave, lineHeight: 1.5}}>{TEXTO_NOTA_BATERIA}</div>
      {onCerrar && (
        <button onClick={onCerrar} aria-label="Cerrar nota"
          style={{background: "transparent", border: "1px solid " + c.borde, color: c.texto, borderRadius: 8,
            padding: "4px 10px", cursor: "pointer", fontSize: 11.5, fontWeight: 700, fontFamily: fontSans, flexShrink: 0}}>Cerrar</button>
      )}
    </div>
  );
}
function EstadoSwAvisosLinea({c, fontSans}: {c: {textoSuave: string}; fontSans: string}) {
  const [e, setE] = useState<EstadoSwAvisos | null>(null);
  useEffect(() => { let vivo = true; versionDelServiceWorkerDeAvisos().then((x) => { if (vivo) setE(x); }); return () => { vivo = false; }; }, []);
  const texto = e ? textoEstadoSwAvisos(e) : "";
  if (!texto) return null;
  return <div style={{marginTop: 6, fontSize: 11, color: c.textoSuave, lineHeight: 1.45, fontFamily: fontSans}}>{texto}</div>;
}

// EL AVISO DENTRO DE LA PÁGINA, cuando el del sistema no se puede mostrar. Va
// montado en la raíz, encima de cualquier pantalla. Un aviso por etiqueta: si
// llega otro con la misma, lo sustituye, igual que en el teléfono.
function AvisosEnPagina() {
  const [avisos, setAvisos] = useState<{titulo:string; cuerpo:string; etiqueta:string}[]>([]);
  useEffect(() => {
    const llega = (ev: any) => {
      const a = ev && ev.detail; if (!a) return;
      setAvisos((prev) => [...prev.filter((x) => x.etiqueta !== a.etiqueta), a].slice(-3));
    };
    window.addEventListener(EVENTO_AVISO_EN_PAGINA, llega as EventListener);
    return () => window.removeEventListener(EVENTO_AVISO_EN_PAGINA, llega as EventListener);
  }, []);
  if (!avisos.length) return null;
  return (
    <div role="alert" style={{position:"fixed" as const, top:12, left:12, right:12, zIndex:2147483000, display:"flex", flexDirection:"column" as const, alignItems:"center", gap:8, pointerEvents:"none" as const}}>
      {avisos.map((a) => (
        <div key={a.etiqueta} style={{pointerEvents:"auto" as const, width:"100%", maxWidth:440, background:"#0B1829", color:"#ECE6D8", border:"1px solid rgba(184,147,42,0.55)", borderRadius:12,
          padding:"12px 14px", boxShadow:"0 10px 30px rgba(0,0,0,0.35)", display:"flex", gap:10, alignItems:"flex-start", fontFamily:"'DM Sans', sans-serif"}}>
          <img src="/logo.png?v=4" alt="" width={28} height={28} style={{borderRadius:6, flexShrink:0}}/>
          <div style={{flex:1, minWidth:0}}>
            <div style={{fontSize:13.5, fontWeight:800, color:"#D4A843", marginBottom:2}}>{a.titulo}</div>
            {a.cuerpo && <div style={{fontSize:12.5, lineHeight:1.5}}>{a.cuerpo}</div>}
          </div>
          <button onClick={() => setAvisos((prev) => prev.filter((x) => x.etiqueta !== a.etiqueta))} aria-label="Cerrar aviso"
            style={{background:"transparent", border:"none", color:"#ECE6D8", fontSize:18, lineHeight:1, cursor:"pointer", padding:"0 2px"}}>×</button>
        </div>
      ))}
    </div>
  );
}

function useNotificacionesPush(currentUser: any) {
  const [permiso, setPermiso] = useState<string>(
    typeof Notification !== "undefined" ? Notification.permission : "unsupported"
  );

  // EL TOKEN SE GUARDA POR DISPOSITIVO, Y ESE ES EL PUNTO.
  //
  // Antes iba a `usuarios/{uid}.fcmTokens` con `arrayUnion`, un arreglo de
  // cadenas sueltas. Los tokens de FCM ROTAN, y `arrayUnion` solo sabe no
  // repetir cadenas iguales: al renovarse, el nuevo se AÑADÍA y el viejo se
  // quedaba. Dos tokens vivos del mismo teléfono son DOS notificaciones
  // idénticas, y purgar los muertos no arregla eso porque los dos están vivos.
  //
  // Con la clave del dispositivo, renovar ESCRIBE SOBRE la misma entrada. No hay
  // nada que recordar limpiar: no puede duplicarse porque la forma no lo permite.
  const guardarToken = async (token: string) => {
    if (!token || !currentUser?.uid) return;
    try {
      await updateDoc(doc(db, "usuarios", currentUser.uid), {
        // CON SU PLATAFORMA Y SU DOMINIO (4-oct). Esto corre en CADA apertura con
        // el permiso dado (`capturarToken`), así que un aparato registrado antes
        // se completa solo la próxima vez que abra la plataforma; hasta entonces
        // el registro del envío lo cuenta como "sin dato".
        ["fcmDispositivos." + idDeEsteDispositivo()]: {
          token, actualizado: new Date().toISOString(),
          plataforma: plataformaDeEsteAparato(),
          origen: typeof window !== "undefined" ? String(window.location.host || "") : "",
        },
      });
    } catch (e) { console.warn("guardar fcmToken:", e); }
  };

  const capturarToken = async () => {
    try {
      if (!(await fcmIsSupported())) return;
      if (typeof Notification === "undefined" || Notification.permission !== "granted") return;
      if (!VAPID_KEY || VAPID_KEY === "PEGAR_AQUI") { console.warn("FCM: falta VAPID_KEY (pendiente de configurar)."); return; }
      const messaging = getMessaging(firebaseApp);
      const token = await getToken(messaging, { vapidKey: VAPID_KEY });
      if (token) await guardarToken(token);
    } catch (e) { console.warn("FCM getToken:", e); }
  };

  // Captura silenciosa para usuarios que ya aceptaron antes.
  useEffect(() => {
    if (!currentUser?.uid || currentUser.isAnonymous) return;
    if (typeof Notification !== "undefined" && Notification.permission === "granted") { capturarToken(); }
    // eslint-disable-next-line
  }, [currentUser?.uid]);

  // Mensajes en primer plano (cuando exista backend que envíe push).
  useEffect(() => {
    let unsub: any;
    (async () => {
      try {
        if (!(await fcmIsSupported())) return;
        const messaging = getMessaging(firebaseApp);
        unsub = onMessage(messaging, (payload: any) => {
          // DE `data`, NO DE `notification`. El servidor ya no manda bloque
          // `notification`: con él, el SDK pintaba una notificación por su cuenta
          // y el service worker pintaba otra, y llegaban dos avisos idénticos.
          // Ver `mensajePush` en api/avisos-checador.js.
          const d = (payload && payload.data) || {};
          // LA MISMA ETIQUETA QUE EL SERVICE WORKER, decidida por el servidor. Si
          // cada superficie decidiera la suya, un accidente se borraría en una y
          // no en la otra. Ver `seReemplaza` en src/logica/push.js.
          // CON EL SERVICE WORKER, NO CON `new Notification`: ver
          // `mostrarAvisoEnPrimerPlano`. Si no se puede, se pinta en la página.
          mostrarAvisoEnPrimerPlano(d);
        });
      } catch (e) { console.error("avisos en primer plano · no se pudo escuchar onMessage:", e); }
    })();
    return () => { if (typeof unsub === "function") unsub(); };
  }, []);

  const activar = async () => {
    try {
      if (typeof Notification === "undefined") { setPermiso("unsupported"); return; }
      const p = await Notification.requestPermission();
      setPermiso(p);
      if (p === "granted") await capturarToken();
    } catch (e) { console.warn("permiso notificaciones:", e); }
  };

  // "COMPROBAR DE NUEVO" (13-oct-2026). Vuelve a leer el permiso SIN RECARGAR —quien
  // lo desbloqueó en los ajustes vuelve a la plataforma y lo ve al momento— y, si ya
  // está concedido, captura el token como al abrir. Y donde el navegador avisa del
  // cambio de permiso (`navigator.permissions`), se escucha y se hace lo mismo solo.
  const comprobar = () => {
    const p = typeof Notification !== "undefined" ? Notification.permission : "unsupported";
    setPermiso(p);
    if (p === "granted") capturarToken();
  };
  useEffect(() => escucharCambioDePermiso(comprobar),
    // eslint-disable-next-line
    [currentUser?.uid]);

  return { permiso, activar, comprobar };
}

// ═══ EL ENTORNO, DICHO UNA VEZ ══════════════════════════════════════════════
// Estas dos preguntas ya se hacían dentro de `InstallBanner`, en línea. Ahora las
// necesita también la puerta de los avisos, y dos copias de la misma pregunta se
// separan en cuanto alguien toque una: es el defecto que lleva toda la serie
// cerrándose. Se declaran aquí y las usan las dos.
function _esStandalone(): boolean {
  if (typeof window === "undefined") return false;
  try {
    return (window.navigator as any).standalone === true
      || window.matchMedia("(display-mode: standalone)").matches;
  } catch (e) { return false; }
}
function _esIOS(): boolean {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  // El iPad moderno se anuncia como Mac. Se distingue porque tiene pantalla táctil.
  return /iphone|ipad|ipod/i.test(ua)
    || (/Macintosh/i.test(ua) && typeof document !== "undefined" && "ontouchend" in document);
}

// ═══ ¿EN QUÉ ESTADO ESTÁN LOS AVISOS? ═══════════════════════════════════════
// UNA función, y las DOS puertas la llaman: la tarjeta que aparece sola y la
// entrada permanente del perfil. Si cada una decidiera por su cuenta, acabarían
// diciendo cosas distintas del mismo navegador.
//
// ⚠️ EL CASO DE iPHONE ES EL QUE MÁS FÁCIL SE PASA POR ALTO. En iOS las
// notificaciones web SOLO funcionan si la plataforma está añadida a la pantalla de
// inicio y se abre desde ahí; desde una pestaña de Safari no llegan, y el navegador
// ni siquiera ofrece el permiso —`window.Notification` no existe—. Pedirlo ahí no
// falla con un error: no pasa nada, que es peor. Por eso se detecta antes y se
// explica el paso que sí sirve.
type EstadoAvisos = "activos" | "puede_pedir" | "bloqueado" | "ios_sin_instalar" | "no_soportado";
function estadoDeAvisos(permiso: string): EstadoAvisos {
  // El orden importa: en iPhone sin instalar el permiso vale "unsupported", y sin
  // esta rama se leería como "tu navegador no puede", que es falso —sí puede, pero
  // instalado— y deja al patrón sin la salida que sí tiene.
  if (_esIOS() && !_esStandalone()) return "ios_sin_instalar";
  if (permiso === "granted") return "activos";
  if (permiso === "denied") return "bloqueado";
  if (permiso === "default") return "puede_pedir";
  return "no_soportado";
}

// ═══ QUÉ SE AVISA, DICHO UNA VEZ Y SIN PROMETER DE MÁS ══════════════════════
// El texto viejo decía "recibe una notificación cuando tus trabajadores marquen
// actividades, chequen entrada/salida o registren flotilla". Eso es exactamente lo
// que decidimos NO hacer: notificar cada hecho es ruido, y prometerlo es peor que
// no ofrecerlo, porque quien lo activa y no recibe nada concluye que la plataforma
// no sirve.
//
// Este texto describe lo que el servidor manda HOY, ni una palabra más y —esto es
// lo que se añadió— NI UNA MENOS.
//
// ⚠️ AQUÍ DECÍA "Hoy es una sola cosa", Y SE ROMPIÓ. El conteo caducó en cuanto el
// aviso de accidente entró en producción: la puerta seguía prometiendo un solo
// aviso y ya mandaba dos. Un número en un texto se rompe por aritmética cada vez
// que añadimos algo, así que se fue: ahora se enumeran los avisos y no se cuentan.
//
// LA PROMESA DE MODERACIÓN SE QUEDA —"nada más"—, porque es lo que convence a
// alguien de conceder el permiso, y es cierta.
//
// EL ACCIDENTE VA PRIMERO. Es el que justifica el permiso; el del checador, solo,
// no mueve a nadie a concederlo.
//
// Y QUIÉN VIGILA QUE ESTO NO VUELVA A CADUCAR: `prueba-puerta-avisos` deriva de
// `api/` los tipos de aviso que el servidor manda hoy, se queda con los que van a
// un PATRÓN —el catálogo de `src/logica/push.js` dice a quién va cada uno— y exige
// que esta frase mencione cada uno. Añadir un tercer aviso sin nombrarlo aquí sale
// rojo; quitar uno y dejarlo escrito, también.
const AVISOS_QUE_HOY_SE_MANDAN = "cuando alguien de tu equipo reporta un accidente, y cuando pasa la hora de entrada y alguien no ha checado";

// ═══ PERMISO BLOQUEADO: CÓMO SE DESBLOQUEA, SEGÚN DÓNDE SE ABRIÓ (13-oct-2026) ═══
// Antes había una sola instrucción —el candado junto a la dirección— y en la
// aplicación instalada no hay dirección ni candado: el permiso vive en los ajustes
// del teléfono. Tres contextos, y en los tres la misma última línea: el cambio no
// siempre se nota con la aplicación abierta. La usan la puerta del patrón y el
// panel del recordatorio del trabajador; "Comprobar de nuevo" está junto a ella.
//
// EL NOMBRE ES EL QUE SE VE EN EL TELÉFONO (`short_name` de public/manifest.json):
// es el que hay que buscar en los ajustes. `prueba-recordatorio-entrada` exige que
// coincidan.
type ContextoAvisos = "navegador" | "android_instalada" | "iphone_instalada";
function contextoDeAvisos(): ContextoAvisos {
  if (_esStandalone() && _esIOS()) return "iphone_instalada";
  if (_esStandalone() && _esAndroid()) return "android_instalada";
  return "navegador";
}
const NOMBRE_EN_EL_TELEFONO = "AXIS Legaltech";
const LINEA_CERRAR_Y_VOLVER_A_ABRIR = "Si ya lo cambiaste, cierra la aplicación por completo y vuelve a abrirla.";
const PASOS_DESBLOQUEO: Record<ContextoAvisos, string> = {
  navegador: "Toca el candado o el ícono a la izquierda de la dirección → Permisos → Notificaciones → Permitir.",
  android_instalada: "Mantén presionado el ícono de " + NOMBRE_EN_EL_TELEFONO + " → Información de la app → Notificaciones → Permitir. "
    + "O bien: Ajustes → Aplicaciones → " + NOMBRE_EN_EL_TELEFONO + " → Notificaciones.",
  iphone_instalada: "Ajustes → Notificaciones → " + NOMBRE_EN_EL_TELEFONO + " → Permitir notificaciones.",
};
function instruccionesDesbloqueo(ctx: ContextoAvisos): string {
  return PASOS_DESBLOQUEO[ctx] + " " + LINEA_CERRAR_Y_VOLVER_A_ABRIR;
}
function textoBloqueado(ctx: ContextoAvisos): string {
  return (ctx === "navegador"
    ? "Tu navegador los bloqueó y ya no vuelve a preguntar, así que el botón no serviría de nada. "
    : "Están bloqueados en los ajustes del teléfono y la plataforma ya no puede volver a preguntar, así que el botón no serviría de nada. ")
    + "Para desbloquearlos: " + instruccionesDesbloqueo(ctx);
}
// EL CAMBIO DE PERMISO DEL SISTEMA, donde el navegador lo avisa (`navigator.permissions`).
// Devuelve con qué dejar de escuchar. Sin la API, no pasa nada: queda el botón.
function escucharCambioDePermiso(alCambiar: () => void): () => void {
  let estado: any = null; let vivo = true;
  try {
    const perms: any = typeof navigator !== "undefined" ? (navigator as any).permissions : null;
    if (perms && typeof perms.query === "function") {
      perms.query({name: "notifications"})
        .then((s: any) => { if (!vivo || !s) return; estado = s; s.onchange = () => alCambiar(); })
        .catch(() => {});
    }
  } catch (e) { /* sin la API de permisos */ }
  return () => { vivo = false; if (estado) estado.onchange = null; };
}
const TEXTO_COMPROBAR_DE_NUEVO = "Comprobar de nuevo";
const TEXTOS_AVISOS: Record<EstadoAvisos, {titulo: string; cuerpo: string; boton?: string}> = {
  puede_pedir: {
    titulo: "Avisos en este dispositivo",
    // "Un aviso al día, con el número de personas dentro" se cayó de aquí: describía
    // la cadencia del aviso del checador, y el del accidente no la tiene —sale en
    // cuanto se registra y sin tope—. Dicho de los dos, era falso para uno.
    // La frase de lo que NO se avisa se queda: sigue siendo cierta y es la mitad
    // que distingue un aviso de una notificación por cada cosa que pasa.
    cuerpo: "Solo te avisamos de lo que necesita que hagas algo, nada más: "
      + AVISOS_QUE_HOY_SE_MANDAN + ". "
      + "No te avisamos de cada checada ni de cada movimiento: eso lo ves en la campana cuando tú quieras.",
    boton: "Activar avisos",
  },
  activos: {
    titulo: "Avisos activados",
    cuerpo: "Te llegan a este dispositivo: " + AVISOS_QUE_HOY_SE_MANDAN
      + ". Para dejar de recibirlos, "
      + "bloquéalos desde el candado que está junto a la dirección de la página.",
  },
  bloqueado: {
    titulo: "Los avisos están bloqueados",
    // EL DE LA PÁGINA EN EL NAVEGADOR. Instalada, la aplicación no tiene dirección ni
    // candado: `PuertaDeAvisos` pinta `textoBloqueado` con el contexto de verdad.
    cuerpo: textoBloqueado("navegador"),
  },
  ios_sin_instalar: {
    titulo: "En iPhone, primero instala AXIS",
    cuerpo: "Los avisos en iPhone solo llegan si AXIS está en tu pantalla de inicio. Desde Safari: toca "
      + "el botón Compartir, elige “Añadir a pantalla de inicio” y abre AXIS desde ese icono. "
      + "Luego vuelve aquí y podrás activarlos.",
  },
  no_soportado: {
    titulo: "Este navegador no puede mandar avisos",
    // ⚠️ AQUÍ DECÍA "Puedes activarlos desde Chrome o Edge en la computadora".
    //
    // Eso es una afirmación sobre software ajeno que la plataforma NO puede
    // comprobar en el momento de decirla: no sabe qué versión de qué navegador hay
    // en la computadora de quien lee, ni si mañana seguirá siendo verdad. Y si
    // resulta falsa, manda a alguien a dar un paseo para nada.
    //
    // Lo que sí puede decir es lo que DETECTÓ aquí —este aparato no ofrece los
    // avisos— y dejar la comprobación donde se puede hacer de verdad: en la otra
    // pantalla, donde el botón aparece o no aparece. Por eso "si ahí es posible".
    //
    // NO ES "NO NOMBRAR NAVEGADORES". La frase de iPhone nombra Safari y se queda:
    // da pasos DENTRO del navegador en el que la persona ya está, y no afirma nada
    // sobre lo que ese navegador puede o no puede hacer. La diferencia —nombrar vs.
    // afirmar— la vigila `prueba-instalar`.
    //
    // Y EL CUERPO NO REPITE LO QUE YA DIJO EL TÍTULO CON OTRA PALABRA. Una versión
    // intermedia empezaba con "Este dispositivo no permite activar los avisos"
    // debajo de un título que dice "Este navegador": dos nombres para la misma cosa
    // en dos renglones seguidos, y quien lo lee no sabe si son lo mismo o si le
    // hablan de dos problemas. El título nombra el navegador; el cuerpo, en vez de
    // volver a nombrarlo, dice qué hacer. `prueba-instalar` lo vigila.
    cuerpo: "Abre la plataforma desde una computadora "
      + "y, si ahí es posible, verás el botón para activarlos. "
      + "Mientras tanto, no te pierdes nada: todo sigue estando en la campana de la plataforma.",
  },
};

// EL ESTADO DE LOS AVISOS TIENE UN SOLO DUEÑO, Y VIAJA POR CONTEXTO.
// Lo necesitan dos sitios que no son padre e hijo: la fila permanente del perfil
// —dentro de AppShell— y el bloque "Prepara este dispositivo" —dentro de Inicio,
// que llega como `children`—. Con un estado en cada uno, activar los avisos desde
// Inicio dejaría al perfil diciendo que siguen apagados hasta recargar, que es
// exactamente la clase de contradicción que llevamos toda la serie cerrando.
const CtxPuertaAvisos = React.createContext<{
  estado: EstadoAvisos; activar: () => void; cerrado: boolean; cerrar: () => void; intentado: boolean; comprobar: () => void;
} | null>(null);

// EL DUEÑO DEL ESTADO, POR ENCIMA DE LOS DOS ÁRBOLES DEL PATRÓN.
//
// Vivía dentro de `AppShell`, y por eso el bloque no aparecía en el teléfono: el
// portal móvil del patrón —`PortalPatronMovil`— es OTRO árbol, se devuelve antes
// de que ningún `conShell` llegue a montarse, y el contexto no le alcanzaba.
//
// Se subió aquí en vez de duplicar el estado en el portal móvil. Con dos dueños,
// activar los avisos desde el teléfono dejaría la fila del perfil de escritorio
// diciendo que siguen apagados, y al revés: la misma contradicción que llevamos
// toda la serie cerrando, pero repartida entre dos aparatos, donde ni siquiera se
// puede ver de un vistazo.
//
// ⚠️ ES UN COMPONENTE Y NO UNA LLAMADA SUELTA EN `App` a propósito. Los hooks no
// se pueden montar bajo condición, y `useNotificacionesPush` NO debe correr para
// un trabajador —no existe todavía ningún aviso dirigido a él; ver el razonamiento
// donde se declara el hook—. Como componente, simplemente no se monta en su rama.
function ProveedorPuertaAvisos({currentUser, children}: {currentUser: any; children: React.ReactNode}) {
  const { permiso: permisoNotif, activar: activarNotif, comprobar: comprobarNotif } = useNotificacionesPush(currentUser);
  const [avisoNotifCerrado, setAvisoNotifCerrado] = useState<boolean>(() => {
    try { return localStorage.getItem("axis_aviso_notif") === "1"; } catch (e) { return false; }
  });
  const cerrarAvisoNotif = () => { try { localStorage.setItem("axis_aviso_notif", "1"); } catch (e) {} setAvisoNotifCerrado(true); };
  const estadoAvisos = estadoDeAvisos(permisoNotif);
  // Si el navegador contesta "denied" JUSTO AHORA, la tarjeta se queda y explica
  // cómo desbloquearlo. Sin esto, pulsar "Activar" y no ver nada era el mismo
  // silencio de antes, solo que un paso más adelante.
  const [intentoAvisos, setIntentoAvisos] = useState(false);
  const activarAvisos = () => { setIntentoAvisos(true); activarNotif(); };
  const valor = {
    estado: estadoAvisos, activar: activarAvisos,
    cerrado: avisoNotifCerrado, cerrar: cerrarAvisoNotif, intentado: intentoAvisos, comprobar: comprobarNotif,
  };
  return <CtxPuertaAvisos.Provider value={valor}>{children}</CtxPuertaAvisos.Provider>;
}

// LA PUERTA, una sola pieza para los dos sitios donde se ofrece: la tarjeta que
// aparece sola y la fila permanente del perfil. `c` es la paleta de quien la monta
// —la tarjeta va sobre crema y la fila sobre navy—, porque una pieza que se pinta
// en dos temas no puede llevar los colores dentro.
function PuertaDeAvisos({estado, onActivar, onCerrar, c, fontSans, compacta}: {
  estado: EstadoAvisos;
  onActivar: () => void;
  onCerrar?: () => void;
  c: {fondo: string; borde: string; acento: string; botonTexto: string; texto: string; textoSuave: string};
  fontSans: string;
  compacta?: boolean;
}) {
  const t = TEXTOS_AVISOS[estado];
  // Bloqueado: las instrucciones de ESTE contexto (navegador, Android instalada,
  // iPhone instalada) y "Comprobar de nuevo", que vuelve a leer el permiso.
  const ctxAvisos = useContext(CtxPuertaAvisos);
  const comprobar = estado === "bloqueado" && ctxAvisos ? ctxAvisos.comprobar : undefined;
  const cuerpo = estado === "bloqueado" ? textoBloqueado(contextoDeAvisos()) : t.cuerpo;
  const punto = estado === "activos" ? "#059669"
    : estado === "bloqueado" ? "#DC2626"
    : estado === "puede_pedir" ? c.acento : "#B8932A";
  return (
    <div style={{background: c.fondo, border: "1px solid " + c.borde, borderLeft: "4px solid " + punto,
      borderRadius: 12, padding: compacta ? "11px 13px" : "12px 16px", fontFamily: fontSans}}>
      <div style={{display: "flex", alignItems: "center", gap: 7, marginBottom: 3}}>
        <span style={{width: 8, height: 8, borderRadius: "50%", background: punto, flexShrink: 0}}/>
        <span style={{fontSize: 13, fontWeight: 700, color: c.texto}}>{t.titulo}</span>
      </div>
      <div style={{fontSize: 12, color: c.textoSuave, lineHeight: 1.55}}>{cuerpo}</div>
      {(t.boton || onCerrar || comprobar) && (
        <div style={{display: "flex", gap: 8, marginTop: 10, flexWrap: "wrap" as const}}>
          {comprobar && (
            <button onClick={comprobar} style={{background: c.acento, border: "none", color: c.botonTexto, borderRadius: 8,
              padding: "8px 14px", cursor: "pointer", fontSize: 12, fontWeight: 700, fontFamily: fontSans}}>{TEXTO_COMPROBAR_DE_NUEVO}</button>
          )}
          {t.boton && (
            <button onClick={onActivar} style={{background: c.acento, border: "none", color: c.botonTexto, borderRadius: 8,
              padding: "8px 14px", cursor: "pointer", fontSize: 12, fontWeight: 700, fontFamily: fontSans}}>{t.boton}</button>
          )}
          {onCerrar && (
            <button onClick={onCerrar} style={{background: "transparent", border: "1px solid " + c.borde, color: c.textoSuave,
              borderRadius: 8, padding: "8px 12px", cursor: "pointer", fontSize: 12, fontWeight: 600, fontFamily: fontSans}}>Ahora no</button>
          )}
        </div>
      )}
    </div>
  );
}



// ═══ EL RECORDATORIO DE ENTRADA, DEL LADO DEL TRABAJADOR (13-oct-2026) ═══════
//
// Su propia puerta, no la del patrón (ver el comentario de `useNotificacionesPush`).
// Solo existe si la cuenta de su patrón tiene encendido el interruptor
// (configuracion_empresa/{uid}.recordatorioEntrada.activo); apagado, no se monta
// nada: ni el panel, ni la escucha de sus teléfonos, ni la renovación del token.
//
// EL TOKEN SOLO SE REGISTRA CUANDO PULSA "Activar en este teléfono". Al abrir la
// aplicación con el permiso concedido, se RENUEVA, pero solo si este teléfono ya
// estaba activado: un permiso concedido por otra razón no lo apunta solo.
//
// Sus teléfonos: dispositivos_trabajador/{uid}.dispositivos.{id del aparato}, con
// la hora del SERVIDOR y `dispositivoActual` (las reglas solo dejan cambiar la
// entrada de quien escribe). `silenciado` apaga los suyos, en todos sus teléfonos.
const COL_TELEFONOS_TRABAJADOR = "dispositivos_trabajador";
const TITULO_RECORDATORIO_TRABAJADOR = "Recordatorio de entrada";
const TEXTOS_RECORDATORIO_TRABAJADOR = [
  "La plataforma puede avisarte en este teléfono 5 minutos antes de tu hora de entrada, los días que te toca trabajar.",
  "El aviso depende de tu teléfono: si está apagado, sin internet, en ahorro de batería o con las notificaciones bloqueadas, puede llegar tarde o no llegar.",
  "Checar tu entrada es tu responsabilidad, llegue o no el aviso.",
];
const BOTON_ACTIVAR_EN_ESTE_TELEFONO = "Activar en este teléfono";
const BOTON_SILENCIAR_RECORDATORIOS = "Silenciar mis recordatorios";
const BOTON_REANUDAR_RECORDATORIOS = "Reanudar mis recordatorios";
const TEXTO_RECORDATORIO_ACTIVADO = "Activado en este teléfono.";
const TEXTO_RECORDATORIO_SILENCIADO = "Tus recordatorios están silenciados: no te llega ninguno, en ningún teléfono.";
const TEXTO_NOTIF_BLOQUEADAS = "Las notificaciones están bloqueadas en este teléfono.";
const TEXTO_RECORDATORIO_BLOQUEADO = TEXTO_NOTIF_BLOQUEADAS + " Para desbloquearlas: ";
const TEXTO_RECORDATORIO_IOS_SIN_INSTALAR = "En iPhone, el aviso solo llega si la plataforma está en tu pantalla de inicio. Desde Safari: toca el botón Compartir, elige “Añadir a pantalla de inicio” y ábrela desde ese ícono. Luego vuelve aquí para activarlo.";
const TEXTO_RECORDATORIO_NO_SOPORTADO = "Este navegador no puede recibir el aviso.";
const TEXTO_RECORDATORIO_NO_SE_PUDO = "No se pudo activar en este teléfono. Revisa tu conexión e inténtalo de nuevo.";
function useRecordatorioTrabajador(uid: string, activo: boolean) {
  const leerPermiso = () => (typeof Notification !== "undefined" ? Notification.permission : "unsupported");
  const [permiso, setPermiso] = useState<string>(leerPermiso);
  // undefined = todavía no se sabe; null = no hay documento.
  const [docTel, setDocTel] = useState<any>(undefined);
  const [ocupado, setOcupado] = useState(false);
  const [error, setError] = useState("");
  const idAparato = idDeEsteDispositivo();
  useEffect(() => {
    if (!uid || !activo) { setDocTel(undefined); return; }
    return onSnapshot(doc(db, COL_TELEFONOS_TRABAJADOR, uid),
      (d: any) => setDocTel(d.exists() ? (d.data() || {}) : null),
      (e: any) => { console.warn("recordatorio · mis teléfonos:", e); setDocTel(null); });
  }, [uid, activo]);
  const comprobar = () => setPermiso(leerPermiso());
  useEffect(() => (activo ? escucharCambioDePermiso(comprobar) : undefined),
    // eslint-disable-next-line
    [activo]);
  // Pide el token de ESTE teléfono y lo apunta (o lo renueva) con la hora del servidor.
  const registrar = async (): Promise<boolean> => {
    try {
      if (!uid || !(await fcmIsSupported())) return false;
      if (!VAPID_KEY) return false;
      const token = await getToken(getMessaging(firebaseApp), { vapidKey: VAPID_KEY });
      if (!token) return false;
      await setDoc(doc(db, COL_TELEFONOS_TRABAJADOR, uid), {
        dispositivos: { [idAparato]: {
          token, actualizado: serverTimestamp(), plataforma: plataformaDeEsteAparato(),
          origen: typeof window !== "undefined" ? String(window.location.host || "").slice(0, 200) : "",
        } },
        dispositivoActual: idAparato,
      }, { merge: true });
      return true;
    } catch (e) { console.error("recordatorio · no se pudo apuntar este teléfono:", e); return false; }
  };
  const activar = async () => {
    if (ocupado) return;
    setOcupado(true); setError("");
    try {
      if (typeof Notification === "undefined") { setPermiso("unsupported"); return; }
      let p = Notification.permission;
      if (p === "default") p = await Notification.requestPermission();
      setPermiso(p);
      if (p === "granted" && !(await registrar())) setError(TEXTO_RECORDATORIO_NO_SE_PUDO);
    } catch (e) { console.error("recordatorio · permiso:", e); setError(TEXTO_RECORDATORIO_NO_SE_PUDO); }
    finally { setOcupado(false); }
  };
  const registradoAqui = !!(docTel && docTel.dispositivos && docTel.dispositivos[idAparato]);
  // LA RENOVACIÓN AL ABRIR: una vez por apertura, con el permiso concedido y este
  // teléfono ya activado.
  const renovado = useRef(false);
  useEffect(() => {
    if (!activo || renovado.current || permiso !== "granted" || !registradoAqui) return;
    renovado.current = true;
    registrar();
    // eslint-disable-next-line
  }, [activo, permiso, registradoAqui]);
  // Con la plataforma abierta, el aviso llega a ESTA página: se pinta con el service
  // worker, como en el patrón (`mostrarAvisoEnPrimerPlano`).
  useEffect(() => {
    if (!activo) return;
    let unsub: any;
    (async () => {
      try {
        if (!(await fcmIsSupported())) return;
        unsub = onMessage(getMessaging(firebaseApp), (payload: any) => { mostrarAvisoEnPrimerPlano((payload && payload.data) || {}); });
      } catch (e) { console.error("recordatorio · no se pudo escuchar onMessage:", e); }
    })();
    return () => { if (typeof unsub === "function") unsub(); };
  }, [activo]);
  const silenciar = async (v: boolean) => {
    if (!uid || ocupado) return;
    setOcupado(true); setError("");
    try { await setDoc(doc(db, COL_TELEFONOS_TRABAJADOR, uid), { silenciado: v }, { merge: true }); }
    catch (e) { console.error("recordatorio · silenciar:", e); setError("No se pudo guardar. Revisa tu conexión e inténtalo de nuevo."); }
    finally { setOcupado(false); }
  };
  return {
    activo, permiso, estado: estadoDeAvisos(permiso), contexto: contextoDeAvisos(), contextoAyuda: contextoDeAyuda(),
    cargando: docTel === undefined, registradoAqui,
    hayTelefonos: !!(docTel && docTel.dispositivos && Object.keys(docTel.dispositivos).length),
    silenciado: !!(docTel && docTel.silenciado === true),
    ocupado, error, activar, comprobar, silenciar,
  };
}
function PanelRecordatorioEntrada({r, NV, fontSans}: {r: ReturnType<typeof useRecordatorioTrabajador>; NV: any; fontSans: string}) {
  if (!r.activo) return null;
  const boton = (texto: string, onClick: () => void, principal: boolean) => (
    <button onClick={onClick} disabled={r.ocupado}
      style={{background: principal ? NV.gold : "transparent", color: principal ? "#0B1829" : NV.ink,
        border: principal ? "none" : "1px solid " + NV.line, borderRadius: 10, padding: "9px 14px", fontSize: 12.5, fontWeight: 800,
        cursor: r.ocupado ? "default" : "pointer", opacity: r.ocupado ? 0.6 : 1, fontFamily: fontSans}}>{texto}</button>
  );
  const e = r.estado;
  const ofreceActivar = e === "puede_pedir" || (e === "activos" && !r.registradoAqui);
  return (
    <div data-recordatorio="trabajador" style={{background: NV.panel, border: "1px solid " + NV.line, borderRadius: 14, padding: "14px 14px",
      boxShadow: NV.sombra, marginBottom: 12, fontFamily: fontSans}}>
      <div style={{fontSize: 13.5, fontWeight: 800, color: NV.ink, marginBottom: 6}}>{TITULO_RECORDATORIO_TRABAJADOR}</div>
      {TEXTOS_RECORDATORIO_TRABAJADOR.map((t, i) => (
        <div key={i} style={{fontSize: 12.5, lineHeight: 1.5, marginBottom: 6, color: i === 2 ? NV.ink : NV.inkSoft, fontWeight: i === 2 ? 700 : 400}}>{t}</div>
      ))}
      {!r.cargando && (
        <div style={{marginTop: 8}}>
          {e === "ios_sin_instalar" && <div style={{fontSize: 12.5, color: NV.inkSoft, lineHeight: 1.5}}>{TEXTO_RECORDATORIO_IOS_SIN_INSTALAR}</div>}
          {e === "no_soportado" && <div style={{fontSize: 12.5, color: NV.inkSoft, lineHeight: 1.5}}>{TEXTO_RECORDATORIO_NO_SOPORTADO}</div>}
          {e === "bloqueado" && (
            <div>
              <div style={{fontSize: 12.5, color: NV.inkSoft, lineHeight: 1.5, marginBottom: 8}}>{TEXTO_RECORDATORIO_BLOQUEADO + instruccionesDesbloqueo(r.contexto)}</div>
              {boton(TEXTO_COMPROBAR_DE_NUEVO, r.comprobar, true)}
            </div>
          )}
          {ofreceActivar && boton(BOTON_ACTIVAR_EN_ESTE_TELEFONO, r.activar, true)}
          {e === "activos" && r.registradoAqui && (
            <div style={{display: "flex", alignItems: "center", gap: 7, fontSize: 12.5, fontWeight: 700, color: NV.ink}}>
              <span style={{width: 8, height: 8, borderRadius: "50%", background: "#34D399", flexShrink: 0}}/>{TEXTO_RECORDATORIO_ACTIVADO}
            </div>
          )}
          {r.silenciado ? (
            <div style={{marginTop: 10}}>
              <div style={{fontSize: 12.5, color: NV.inkSoft, lineHeight: 1.5, marginBottom: 8}}>{TEXTO_RECORDATORIO_SILENCIADO}</div>
              {boton(BOTON_REANUDAR_RECORDATORIOS, () => r.silenciar(false), false)}
            </div>
          ) : r.hayTelefonos ? (
            <div style={{marginTop: 10}}>{boton(BOTON_SILENCIAR_RECORDATORIOS, () => r.silenciar(true), false)}</div>
          ) : null}
          {r.error && <div style={{marginTop: 8, fontSize: 12, color: "#FCA5A5", lineHeight: 1.45}}>{r.error}</div>}
        </div>
      )}
    </div>
  );
}

// ═══ EL RECORDATORIO EN EL CHECADOR (feat/recordatorio-en-checador) ═════════
//
// Para que el trabajador lo descubra donde está todos los días: una tarjeta en su
// checador, DEBAJO de los botones de checar y de sus mensajes, en el flujo normal
// de la pantalla (nunca flotante, nunca modal). No toca la checada: es otra pieza,
// con su propio estado, y sus botones no pasan por `pedirChecada`.
//
// LA MISMA LÓGICA Y LOS MISMOS TEXTOS QUE LA PESTAÑA NOTIFICACIONES: recibe la misma
// instancia de `useRecordatorioTrabajador` (su "Activar" es `r.activar`, el de
// "Activar en este teléfono", con la petición de permiso), y la ayuda usa los pasos
// que ya existen (`PASOS_DESBLOQUEO`, `TEXTO_RECORDATORIO_IOS_SIN_INSTALAR`,
// `LINEA_CERRAR_Y_VOLVER_A_ABRIR`, `TEXTO_COMPROBAR_DE_NUEVO`).
//
// Cuándo sale, en este orden:
//   · nada si el interruptor del patrón está apagado, si su cuenta no está
//     vinculada a su ficha, o mientras no se sabe cómo están sus teléfonos;
//   · silenciados → una línea, con "Cambiar" (lleva a Notificaciones);
//   · este teléfono ya activado → una línea, con "Cambiar";
//   · navegador sin avisos → nada (no hay nada que activar ahí);
//   · "Ahora no" en los últimos 7 días, en este teléfono → nada;
//   · bloqueado → la tarjeta con la ayuda desplegada;
//   · si no → la tarjeta, con "Activar" y "Ahora no". En iPhone sin instalar el
//     permiso ni existe: ahí "Activar" despliega la ayuda, que empieza por cómo
//     instalarla.
const TEXTO_TARJETA_RECORDATORIO = "¿Quieres que te avisemos en este teléfono 5 minutos antes de tu hora de entrada?";
const BOTON_ACTIVAR_TARJETA = "Activar";
const BOTON_AHORA_NO = "Ahora no";
const TEXTO_LINEA_RECORDATORIO_ACTIVADO = "Recordatorio activado en este teléfono";
const TEXTO_LINEA_RECORDATORIO_SILENCIADO = "Tus recordatorios están silenciados.";
const ENLACE_CAMBIAR_RECORDATORIO = "Cambiar";
const ENLACE_AYUDA_RECORDATORIO = "¿No puedes activarlos?";
const ROTULO_OTROS_TELEFONOS = "Otros teléfonos";
const TEXTO_AHORRO_BATERIA_RECORDATORIO = "Si tu teléfono es Samsung u otro Android con ahorro de batería, quita Chrome y " + NOMBRE_EN_EL_TELEFONO
  + " de las aplicaciones en suspensión (Ajustes → Batería → Límites de uso en segundo plano); si no, el aviso puede llegar tarde.";
// LOS CUATRO CONTEXTOS DE LA AYUDA: los tres de las instrucciones de desbloqueo y el
// iPhone sin instalar (ahí no hay permiso que desbloquear: hay que instalarla).
type ContextoAyuda = ContextoAvisos | "iphone_sin_instalar";
function contextoDeAyuda(): ContextoAyuda {
  if (_esIOS() && !_esStandalone()) return "iphone_sin_instalar";
  return contextoDeAvisos();
}
const ORDEN_CONTEXTOS_AYUDA: ContextoAyuda[] = ["navegador", "android_instalada", "iphone_instalada", "iphone_sin_instalar"];
const ROTULOS_CONTEXTO_AYUDA: Record<ContextoAyuda, string> = {
  navegador: "En el navegador",
  android_instalada: "Aplicación instalada en Android",
  iphone_instalada: "Aplicación instalada en iPhone",
  iphone_sin_instalar: "iPhone sin instalar",
};
function pasosDeAyuda(ctx: ContextoAyuda): string {
  return ctx === "iphone_sin_instalar" ? TEXTO_RECORDATORIO_IOS_SIN_INSTALAR : PASOS_DESBLOQUEO[ctx];
}
// "AHORA NO": 7 días en ESTE teléfono, en el almacenamiento local del navegador. Si
// no se puede leer o escribir, la tarjeta simplemente vuelve a aparecer.
const CLAVE_AHORA_NO_RECORDATORIO = "axis_recordatorio_ahora_no";
const DIAS_AHORA_NO_RECORDATORIO = 7;
function ahoraNoVigente(ms: number | null, ahora: number): boolean {
  return ms !== null && Number.isFinite(ms) && ahora >= ms && ahora - ms < DIAS_AHORA_NO_RECORDATORIO * 86400000;
}
function leerAhoraNoRecordatorio(): number | null {
  try {
    const v = window.localStorage.getItem(CLAVE_AHORA_NO_RECORDATORIO);
    const n = v === null ? NaN : Number(v);
    return Number.isFinite(n) ? n : null;
  } catch (e) { return null; }
}
function guardarAhoraNoRecordatorio(ms: number): void {
  try { window.localStorage.setItem(CLAVE_AHORA_NO_RECORDATORIO, String(ms)); } catch (e) { /* vuelve a aparecer */ }
}
// LA AYUDA, DESPLEGADA DENTRO DE LA TARJETA: primero el contexto detectado, los
// demás plegados en "Otros teléfonos"; siempre el ahorro de batería; y al final la
// línea de cerrar y volver a abrir, con "Comprobar de nuevo".
function AyudaActivarRecordatorio({contexto, onComprobar, ocupado, NV, fontSans}: {contexto: ContextoAyuda; onComprobar: () => void; ocupado?: boolean; NV: any; fontSans: string}) {
  const [otros, setOtros] = useState(false);
  const bloque = (ctx: ContextoAyuda) => (
    <div key={ctx} data-ayuda-contexto={ctx} style={{marginBottom: 8}}>
      <div style={{fontSize: 11.5, fontWeight: 700, color: NV.ink, marginBottom: 2}}>{ROTULOS_CONTEXTO_AYUDA[ctx]}</div>
      <div style={{fontSize: 12, color: NV.inkSoft, lineHeight: 1.5}}>{pasosDeAyuda(ctx)}</div>
    </div>
  );
  return (
    <div data-ayuda-recordatorio="" style={{marginTop: 10, paddingTop: 10, borderTop: "1px solid " + NV.lineSoft, fontFamily: fontSans}}>
      {bloque(contexto)}
      <button type="button" onClick={() => setOtros(!otros)} aria-expanded={otros}
        style={{background: "transparent", border: "none", padding: 0, marginBottom: 8, color: NV.gold, fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: fontSans}}>
        {ROTULO_OTROS_TELEFONOS} {otros ? "▴" : "▾"}
      </button>
      {otros && <div data-ayuda-otros="">{ORDEN_CONTEXTOS_AYUDA.filter((c) => c !== contexto).map(bloque)}</div>}
      <div data-ayuda-bateria="" style={{fontSize: 12, color: NV.inkSoft, lineHeight: 1.5, marginBottom: 8}}>{TEXTO_AHORRO_BATERIA_RECORDATORIO}</div>
      <div style={{fontSize: 12, color: NV.inkSoft, lineHeight: 1.5, marginBottom: 8}}>{LINEA_CERRAR_Y_VOLVER_A_ABRIR}</div>
      <button type="button" onClick={onComprobar} disabled={ocupado}
        style={{background: NV.gold, color: "#0B1829", border: "none", borderRadius: 10, padding: "8px 14px", fontSize: 12.5, fontWeight: 800, cursor: "pointer", fontFamily: fontSans}}>{TEXTO_COMPROBAR_DE_NUEVO}</button>
    </div>
  );
}
function TarjetaRecordatorioChecador({r, vinculada, onCambiar, NV, fontSans, ahora}: {r: ReturnType<typeof useRecordatorioTrabajador>; vinculada: boolean; onCambiar: () => void; NV: any; fontSans: string; ahora?: number}) {
  const [ahoraNo, setAhoraNo] = useState<boolean>(() => ahoraNoVigente(leerAhoraNoRecordatorio(), ahora ?? Date.now()));
  const [ayuda, setAyuda] = useState(false);
  if (!r.activo || !vinculada || r.cargando) return null;
  const linea = (texto: string, dato: string) => (
    <div data-recordatorio-checador={dato} style={{marginTop: 12, fontSize: 12, color: NV.inkSoft, fontFamily: fontSans}}>
      {texto}{" · "}
      <button type="button" onClick={onCambiar}
        style={{background: "transparent", border: "none", padding: 0, color: NV.gold, fontSize: 12, fontWeight: 700, cursor: "pointer", textDecoration: "underline", fontFamily: fontSans}}>{ENLACE_CAMBIAR_RECORDATORIO}</button>
    </div>
  );
  if (r.silenciado) return linea(TEXTO_LINEA_RECORDATORIO_SILENCIADO, "silenciado");
  if (r.estado === "activos" && r.registradoAqui) return linea(TEXTO_LINEA_RECORDATORIO_ACTIVADO, "activado");
  if (r.estado === "no_soportado" || ahoraNo) return null;
  const bloqueado = r.estado === "bloqueado";
  const sinInstalar = r.estado === "ios_sin_instalar";
  const abierta = bloqueado || ayuda;
  const ahoraNoPulsado = () => { guardarAhoraNoRecordatorio(ahora ?? Date.now()); setAhoraNo(true); };
  const boton = (texto: string, onClick: () => void, principal: boolean) => (
    <button type="button" onClick={onClick} disabled={r.ocupado}
      style={{background: principal ? NV.gold : "transparent", color: principal ? "#0B1829" : NV.ink, border: principal ? "none" : "1px solid " + NV.line,
        borderRadius: 10, padding: "8px 14px", fontSize: 12.5, fontWeight: 800, cursor: r.ocupado ? "default" : "pointer", opacity: r.ocupado ? 0.6 : 1, fontFamily: fontSans}}>{texto}</button>
  );
  return (
    <div data-recordatorio-checador={bloqueado ? "bloqueado" : "tarjeta"}
      style={{marginTop: 12, background: "rgba(255,255,255,0.03)", border: "1px solid " + NV.lineSoft, borderRadius: 12, padding: "12px 13px", fontFamily: fontSans}}>
      <div style={{fontSize: 13, fontWeight: 700, color: NV.ink, lineHeight: 1.45}}>{bloqueado ? TEXTO_NOTIF_BLOQUEADAS : TEXTO_TARJETA_RECORDATORIO}</div>
      <div style={{display: "flex", gap: 8, flexWrap: "wrap" as const, marginTop: 10}}>
        {!bloqueado && boton(BOTON_ACTIVAR_TARJETA, sinInstalar ? () => setAyuda(true) : r.activar, true)}
        {boton(BOTON_AHORA_NO, ahoraNoPulsado, false)}
      </div>
      {!bloqueado && (
        <button type="button" onClick={() => setAyuda(!ayuda)} aria-expanded={ayuda}
          style={{display: "inline-flex", alignItems: "center", gap: 6, marginTop: 10, background: "transparent", border: "none", padding: 0,
            color: NV.gold, fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: fontSans}}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8"/><path d="M9.6 9.3a2.5 2.5 0 014.8 1c0 1.7-2.4 2.1-2.4 3.7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/><circle cx="12" cy="17" r="1.1" fill="currentColor"/></svg>
          {ENLACE_AYUDA_RECORDATORIO}
        </button>
      )}
      {abierta && <AyudaActivarRecordatorio contexto={r.contextoAyuda} onComprobar={r.comprobar} ocupado={r.ocupado} NV={NV} fontSans={fontSans}/>}
      {r.error && <div style={{marginTop: 8, fontSize: 12, color: "#FCA5A5", lineHeight: 1.45}}>{r.error}</div>}
    </div>
  );
}

// ═══ EL INTERRUPTOR DE LA CUENTA (13-oct-2026) ═══════════════════════════════
// En la configuración del checador (la ventana de "Horario y ubicación de trabajo"),
// apagado por omisión. configuracion_empresa/{uid}.recordatorioEntrada =
// {activo, minutosAntes: 5, actualizadoEn}: las reglas de ese documento ya dejan al
// patrón escribirlo, y sus trabajadores lo leen (de ahí sale si ven su panel).
const TEXTO_INTERRUPTOR_RECORDATORIO = "Recordar a los trabajadores 5 minutos antes de su entrada";
const AYUDA_INTERRUPTOR_RECORDATORIO = "Les llega solo a quienes tienen su cuenta vinculada a su ficha y activaron los avisos en su teléfono. No sustituye la obligación de checar. Al encenderlo, los recordatorios empiezan al día siguiente; al apagarlo, se detienen de inmediato. Los cambios de horarios y de cuentas vinculadas se aplican a partir del día siguiente.";
function InterruptorRecordatorioEntrada({uid, tema, fontSans}: {uid: string; tema: "light" | "navy"; fontSans: string}) {
  const [activo, setActivo] = useState<boolean | null>(null);
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    if (!uid) return;
    return escucharConfigEmpresa(uid, (c) => setActivo(!!(c && c.recordatorioEntrada && c.recordatorioEntrada.activo === true)));
  }, [uid]);
  const cambiar = async () => {
    if (activo === null || guardando || !uid) return;
    const nuevo = !activo;
    setGuardando(true); setError("");
    try {
      await setDoc(doc(db, COL_CONFIG_EMPRESA, uid),
        { recordatorioEntrada: { activo: nuevo, minutosAntes: 5, actualizadoEn: serverTimestamp() } }, { merge: true });
    } catch (e) { console.error("recordatorio · interruptor:", e); setError("No se pudo guardar. Revisa tu conexión e inténtalo de nuevo."); }
    finally { setGuardando(false); }
  };
  const P = tema === "navy"
    ? {fondo: "rgba(255,255,255,0.04)", borde: "rgba(212,168,67,0.22)", texto: "#ECE6D8", suave: "rgba(236,230,216,0.66)", acento: "#D4A843", apagado: "rgba(255,255,255,0.18)"}
    : {fondo: "#fff", borde: T_LIGHT.borderCard, texto: T_LIGHT.textInk, suave: T_LIGHT.textInkSoft, acento: "#236478", apagado: "#CBD2DC"};
  const on = activo === true;
  return (
    <div data-interruptor="recordatorio-entrada" style={{marginTop: 16, background: P.fondo, border: "1px solid " + P.borde, borderRadius: 12, padding: "12px 14px", fontFamily: fontSans}}>
      <div style={{display: "flex", alignItems: "center", gap: 12}}>
        <div style={{flex: 1, fontSize: 13, fontWeight: 700, color: P.texto, lineHeight: 1.4}}>{TEXTO_INTERRUPTOR_RECORDATORIO}</div>
        <button role="switch" aria-checked={on} aria-label={TEXTO_INTERRUPTOR_RECORDATORIO} onClick={cambiar} disabled={activo === null || guardando}
          style={{width: 44, height: 26, borderRadius: 13, border: "none", flexShrink: 0, position: "relative" as const, padding: 0,
            background: on ? P.acento : P.apagado, cursor: activo === null || guardando ? "default" : "pointer", opacity: guardando ? 0.6 : 1}}>
          <span style={{position: "absolute" as const, top: 3, left: on ? 21 : 3, width: 20, height: 20, borderRadius: "50%", background: "#fff", transition: "left .15s"}}/>
        </button>
      </div>
      <div style={{marginTop: 6, fontSize: 11.5, color: P.suave, lineHeight: 1.5}}>{AYUDA_INTERRUPTOR_RECORDATORIO}</div>
      {error && <div style={{marginTop: 6, fontSize: 11.5, color: "#DC2626"}}>{error}</div>}
    </div>
  );
}

// ═══ LA PRUEBA DEL RECORDATORIO, DESDE EL PANEL DEL ADMINISTRADOR (13-oct-2026) ═══
// Para probar en producción sin curl y sin CRON_SECRET fuera de Vercel. Va en el
// Panel de Administrador, pestaña Configuración, que solo se abre al administrador
// (`esAdmin`, src/logica/admin.js). Lo que de verdad protege está en el servidor
// (api/recordatorios-entrada.js): comprueba el token de sesión de quien llama, que
// sea el administrador, y que la cuenta esté en CUENTAS_DE_PRUEBA. Si no, 403.
//   · "Ver plan de hoy": por trabajador, si se le enviaría o por qué no, y el
//     estado del documento del día. No escribe ni manda nada.
//   · "Enviar ahora": manda YA el recordatorio real a la ficha elegida.
const RUTA_RECORDATORIOS = "/api/recordatorios-entrada";
const MOTIVOS_RECORDATORIO: Record<string, string> = {
  sin_cuenta_vinculada: "sin cuenta vinculada a su ficha",
  sin_cuenta: "sin cuenta activa",
  fuera_de_periodo: "fuera de su periodo laboral",
  sin_horario: "sin horario",
  no_laborable: "hoy no le toca trabajar",
  vacaciones: "de vacaciones",
  descanso_obligatorio: "descanso obligatorio (art. 74)",
  ya_checo: "ya checó",
  entrada_cambio: "su hora de entrada cambió",
  aun_no_toca: "todavía no es su hora",
  ya_paso: "ya pasó su hora",
  silenciado: "silenció sus recordatorios",
  sin_telefono: "sin teléfono con los avisos activados",
  interruptor_apagado: "el interruptor de la cuenta está apagado",
  sin_ficha: "la ficha ya no existe",
  cuenta_vinculada_cambio: "la ficha está vinculada a otra cuenta",
  lo_planeo_el_dia_anterior: "lo planeó el planificador de ayer",
  mas_de_3_minutos: "llegó más de 3 minutos tarde",
  ningun_telefono_lo_acepto: "ningún teléfono lo aceptó",
};
const textoMotivoRecordatorio = (m: any) => (m ? (MOTIVOS_RECORDATORIO[String(m)] || String(m)) : "");
function textoDocumentoRecordatorio(d: any): string {
  if (!d) return "—";
  if (typeof d === "string") return d.indexOf("no existe") === 0 ? "aún no existe (lo arma el planificador de las 00:05)" : d;
  return String(d.estado || "—") + (d.motivo ? ": " + textoMotivoRecordatorio(d.motivo) : "");
}
// El plan, pintado. Aparte del panel para poder probarlo sin red.
function VistaPlanRecordatorio({plan}: {plan: any}) {
  if (!plan) return null;
  if (plan.sinCuentasDePrueba || !(plan.cuentas || []).length)
    return <div style={{fontSize: 12.5, color: T_LIGHT.textInkSoft}}>No hay cuentas de prueba escritas en el código (CUENTAS_DE_PRUEBA, en src/logica/recordatorios.js).</div>;
  return (
    <div style={{display: "flex", flexDirection: "column" as const, gap: 12}}>
      {(plan.cuentas || []).map((c: any) => (
        <div key={c.uid} data-plan-cuenta={c.uid}>
          <div style={{fontSize: 12, fontWeight: 700, color: T_LIGHT.textInk, marginBottom: 6}}>
            Cuenta {c.uid} · {c.error ? "no se pudo leer" : (c.interruptor ? "interruptor encendido" : "interruptor apagado")} · hoy {c.isoHoy || ""}
          </div>
          {c.error ? <div style={{fontSize: 12, color: "#DC2626"}}>{String(c.error)}</div> : (
            <div style={{overflowX: "auto" as const}}>
              <table style={{width: "100%", borderCollapse: "collapse" as const, fontSize: 12}}>
                <thead><tr style={{textAlign: "left" as const, color: T_LIGHT.textInkSoft}}>
                  <th style={{padding: "4px 6px"}}>Trabajador</th><th style={{padding: "4px 6px"}}>Entrada</th><th style={{padding: "4px 6px"}}>Aviso</th>
                  <th style={{padding: "4px 6px"}}>¿Se enviaría?</th><th style={{padding: "4px 6px"}}>Documento del día</th>
                </tr></thead>
                <tbody>
                  {(c.trabajadores || []).map((t: any, i: number) => (
                    <tr key={t.fichaId + ":" + i} style={{borderTop: "1px solid " + T_LIGHT.borderCard, color: T_LIGHT.textInk}}>
                      <td style={{padding: "5px 6px"}}>{t.nombre || t.fichaId}{t.diaEntrada && t.diaEntrada !== c.isoHoy ? " (entrada del " + t.diaEntrada + ")" : ""}</td>
                      <td style={{padding: "5px 6px"}}>{t.entrada || "—"}</td>
                      <td style={{padding: "5px 6px"}}>{t.envio || "—"}</td>
                      <td style={{padding: "5px 6px", fontWeight: 700, color: t.seEnviaria ? "#059669" : "#B45309"}}>{t.seEnviaria ? "Sí" : "No: " + textoMotivoRecordatorio(t.motivo)}</td>
                      <td style={{padding: "5px 6px"}}>{t.planeado ? textoDocumentoRecordatorio(t.documento) : "—"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
function textoRespuestaRecordatorio(status: number): string {
  if (status === 403) return "El servidor no autorizó la consulta (403).";
  if (status === 401) return "Tu sesión no es válida. Vuelve a iniciar sesión.";
  return "El servidor no pudo contestar (" + status + "). Revisa el registro de Vercel.";
}
function PanelPruebaRecordatorio({user, fontSans}: {user: any; fontSans: string}) {
  const [plan, setPlan] = useState<any>(null);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState("");
  const [elegida, setElegida] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [resultado, setResultado] = useState("");
  // CON EL TOKEN DE SESIÓN del administrador, nunca con un secreto: el servidor lo
  // comprueba y decide.
  const llamar = async (consulta: string, metodo: "GET" | "POST") => {
    const t = await (user?.getIdToken ? user.getIdToken() : Promise.resolve(""));
    const r = await fetch(RUTA_RECORDATORIOS + "?" + consulta, {method: metodo, headers: t ? {Authorization: "Bearer " + t} : {}});
    let cuerpo: any = null;
    try { cuerpo = await r.json(); } catch (e) { cuerpo = null; }
    return {status: r.status, cuerpo};
  };
  const verPlan = async () => {
    setCargando(true); setError(""); setResultado("");
    try {
      const {status, cuerpo} = await llamar("modo=dryRun", "GET");
      if (status !== 200 || !cuerpo) { setPlan(null); setError(textoRespuestaRecordatorio(status)); }
      else setPlan(cuerpo);
    } catch (e) { setError("No se pudo consultar. Revisa tu conexión."); }
    finally { setCargando(false); }
  };
  // Una opción por ficha (el plan puede traer dos renglones de la misma: hoy y mañana).
  const fichas: {valor: string; nombre: string}[] = [];
  for (const c of ((plan && plan.cuentas) || [])) for (const t of (c.trabajadores || [])) {
    const valor = c.uid + "|" + t.fichaId;
    if (!fichas.some((f) => f.valor === valor)) fichas.push({valor, nombre: (t.nombre || t.fichaId) + " · cuenta " + c.uid});
  }
  const enviar = async () => {
    const [cuenta, ficha] = elegida.split("|");
    if (!cuenta || !ficha || enviando) return;
    setEnviando(true); setResultado("");
    try {
      const {status, cuerpo} = await llamar("modo=enviar&cuenta=" + encodeURIComponent(cuenta) + "&ficha=" + encodeURIComponent(ficha), "POST");
      if (status !== 200 || !cuerpo) setResultado(textoRespuestaRecordatorio(status));
      else if (cuerpo.ok) setResultado("Enviado: " + Number(cuerpo.aceptados || 0) + " teléfono(s) lo aceptaron, " + Number(cuerpo.fallidos || 0) + " fallaron. Entrada " + (cuerpo.entrada || "—") + ".");
      else setResultado("No se envió: " + (cuerpo.motivo ? textoMotivoRecordatorio(cuerpo.motivo) : (cuerpo.error || "ningún teléfono lo aceptó")) + ".");
    } catch (e) { setResultado("No se pudo enviar. Revisa tu conexión."); }
    finally { setEnviando(false); }
  };
  const boton = (texto: string, onClick: () => void, deshabilitado: boolean) => (
    <button onClick={onClick} disabled={deshabilitado}
      style={{background: deshabilitado ? "#CBD2DC" : "#0F172A", color: "white", border: "none", borderRadius: 8, padding: "8px 14px",
        fontSize: 12.5, fontWeight: 700, cursor: deshabilitado ? "default" : "pointer", fontFamily: fontSans}}>{texto}</button>
  );
  return (
    <div data-panel="prueba-recordatorio" style={{background: "white", border: "1px solid " + T_LIGHT.borderCard, borderRadius: 12, padding: "14px 16px", fontFamily: fontSans}}>
      <div style={{fontSize: 14, fontWeight: 800, color: T_LIGHT.textInk, marginBottom: 4}}>Recordatorio de entrada · prueba</div>
      <div style={{fontSize: 12, color: T_LIGHT.textInkSoft, lineHeight: 1.5, marginBottom: 10}}>Solo para las cuentas de prueba. «Ver plan de hoy» no escribe ni manda nada; «Enviar ahora» manda el recordatorio real a la ficha elegida.</div>
      <div style={{display: "flex", gap: 8, flexWrap: "wrap" as const, alignItems: "center", marginBottom: 10}}>
        {boton(cargando ? "Consultando…" : "Ver plan de hoy", verPlan, cargando)}
        {fichas.length > 0 && (
          <>
            <select value={elegida} onChange={(e) => setElegida(e.target.value)} aria-label="Ficha a la que enviar"
              style={{padding: "7px 8px", borderRadius: 8, border: "1px solid " + T_LIGHT.borderCard, fontSize: 12.5, fontFamily: fontSans, maxWidth: "100%"}}>
              <option value="">Elige una ficha…</option>
              {fichas.map((f) => <option key={f.valor} value={f.valor}>{f.nombre}</option>)}
            </select>
            {boton(enviando ? "Enviando…" : "Enviar ahora", enviar, !elegida || enviando)}
          </>
        )}
      </div>
      {error && <div style={{fontSize: 12.5, color: "#DC2626", marginBottom: 8}}>{error}</div>}
      {resultado && <div style={{fontSize: 12.5, color: T_LIGHT.textInk, fontWeight: 700, marginBottom: 8}}>{resultado}</div>}
      <VistaPlanRecordatorio plan={plan}/>
    </div>
  );
}

// ═══ ABRIR UNA PANTALLA DESDE UN AVISO (13-oct-2026) ═════════════════════════
// El aviso trae `/?abrir=checador` (recordatorio de entrada) o `/?abrir=inicio`
// ("no ha checado" del patrón). Dos caminos, el mismo final:
//   · la plataforma se ABRE con esa dirección: se lee aquí, al cargar, y la
//     dirección se limpia en el acto (recargar no vuelve a saltar);
//   · ya estaba ABIERTA: el service worker la enfoca y le manda
//     {tipo: "axis:abrir", abrir} (public/firebase-messaging-sw.js).
// Queda pendiente hasta que la pantalla que lo atiende está montada —el trabajador
// puede tener que iniciar sesión antes— y la atiende una sola vez.
const DESTINOS_ABRIR = ["checador", "inicio"];
// Las pantallas del trabajador que una dirección puede abrir (fix/recarga-conserva-pantalla).
const VISTAS_DEL_TRABAJADOR = ["checador", "flotilla", "tareas", "calendario", "misAccidentes", "notificaciones", "perfil"];
// Las pestañas del portal móvil del patrón; la ficha abierta va como "equipo/ficha/<id de la ficha>".
const VISTAS_DEL_PATRON_MOVIL = ["inicio", "actividad", "equipo", "perfil"];
const EVENTO_ABRIR = "axis:abrir";
let _abrirPendiente = "";
(function leerAbrirDeLaDireccion() {
  try {
    if (typeof window === "undefined") return;
    const u = new URL(window.location.href);
    const a = u.searchParams.get("abrir");
    if (a === null) return;
    if (DESTINOS_ABRIR.indexOf(a) >= 0) _abrirPendiente = a;
    u.searchParams.delete("abrir");
    window.history.replaceState(window.history.state, "", u.pathname + u.search + u.hash);
  } catch (e) { /* sin dirección que leer */ }
})();
(function escucharAlServiceWorker() {
  try {
    if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return;
    navigator.serviceWorker.addEventListener("message", (ev: any) => {
      const d = ev && ev.data;
      if (!d || d.tipo !== "axis:abrir" || DESTINOS_ABRIR.indexOf(d.abrir) < 0) return;
      _abrirPendiente = d.abrir;
      window.dispatchEvent(new CustomEvent(EVENTO_ABRIR, {detail: d.abrir}));
    });
    if (typeof (navigator.serviceWorker as any).startMessages === "function") (navigator.serviceWorker as any).startMessages();
  } catch (e) { /* sin service worker: queda la dirección */ }
})();
// ═══ LA PANTALLA EN LA DIRECCIÓN Y EN EL HISTORIAL (fix/recarga-conserva-pantalla) ═══
// La lógica vive en src/logica/navegacion.js (ver ahí el porqué). Aquí solo se
// engancha a una pantalla de React:
//   · `mostrada`: la clave de lo que se ve ahora ("checador", "equipo/ficha/ID"…);
//   · `aplicar`: va a una clave, o contesta "invalida" si ya no existe o no es de
//     este rol (entonces se cae a la principal);
//   · `listo`: cuando ya se puede decidir (el patrón espera a tener sus fichas).
// "Atrás" con algo escrito sin guardar pregunta lo mismo que al cerrar un panel.
//
// MIENTRAS SE DECIDE NO SE ENSEÑA LA PRINCIPAL (ajuste del 14-oct). Si la dirección
// trae algo que restaurar, devuelve `restaurando: true` hasta decidirlo, y la
// pantalla pinta "Cargando…" en vez de su principal: antes el patrón veía Inicio un
// segundo y luego saltaba a la ficha. Se decide EN CUANTO hay datos y ANTES DE
// PINTAR (useLayoutEffect): la ficha que existe sale directa; la que no, Inicio.
// Y nunca se queda cargando: si los datos no llegan en LIMITE_RESTAURAR_MS, se cae
// a la principal.
const LIMITE_RESTAURAR_MS = 8000;
function useVistaEnLaDireccion(o: {principal: string; mostrada: string; aplicar: (v: string) => "ok" | "invalida"; listo: boolean; limiteMs?: number}): {restaurando: boolean} {
  const nav = useRef<any>(null);
  const aplicar = useRef(o.aplicar);
  aplicar.current = o.aplicar;
  const mostrada = useRef(o.mostrada);
  mostrada.current = o.mostrada;
  // ¿Trae la dirección algo que restaurar? Se mira una vez, al montar.
  const [porRestaurar] = useState<boolean>(() => {
    try { const v = vistaDeLaDireccion(window.location.href); return !!v && v !== o.principal; } catch (e) { return false; }
  });
  const [iniciado, setIniciado] = useState(false);
  const [vencido, setVencido] = useState(false);
  useEffect(() => {
    if (!porRestaurar || iniciado || o.listo) return;
    const t = setTimeout(() => setVencido(true), o.limiteMs ?? LIMITE_RESTAURAR_MS);
    return () => clearTimeout(t);
    // eslint-disable-next-line
  }, [porRestaurar, iniciado, o.listo]);
  // Sin datos a tiempo, la dirección no se restaura (a la principal); solo al iniciar.
  const sinDatos = useRef(false);
  useLayoutEffect(() => {
    if ((!o.listo && !vencido) || nav.current || typeof window === "undefined" || !window.history) return;
    const n: any = crearNavegacion({ win: window, principal: o.principal,
      aplicar: (v: string) => (sinDatos.current && v !== o.principal ? "invalida" : aplicar.current(v)),
      hayCaptura: hayCapturaSinGuardar, confirmar: (t: string) => window.confirm(t), textoConfirmar: TEXTO_CERRAR_SIN_GUARDAR });
    n.oyente = () => n.alVolver();
    window.addEventListener("popstate", n.oyente);
    nav.current = n;
    sinDatos.current = !o.listo;
    n.iniciar(mostrada.current);
    sinDatos.current = false;
    setIniciado(true);
    // eslint-disable-next-line
  }, [o.listo, vencido]);
  useEffect(() => () => { if (nav.current) { window.removeEventListener("popstate", nav.current.oyente); nav.current = null; } }, []);
  useEffect(() => { if (nav.current) nav.current.alCambiar(o.mostrada); }, [o.mostrada]);
  return {restaurando: porRestaurar && !iniciado};
}
// EL INDICADOR DE CARGA DE LA PLATAFORMA, el de siempre: fondo navy y "Cargando…".
function PantallaCargando({fontSans}: {fontSans: string}) {
  return <div data-cargando="1" style={{minHeight:"100vh", background:"#0B1829", display:"flex", alignItems:"center", justifyContent:"center", fontFamily:fontSans, color:"rgba(255,255,255,0.6)", fontSize:14}}>Cargando…</div>;
}

function useAbrirDesdeAviso(destino: string, listo: boolean, accion: () => void) {
  const ref = useRef(accion);
  ref.current = accion;
  useEffect(() => {
    if (!listo) return;
    const atender = () => { if (_abrirPendiente === destino) { _abrirPendiente = ""; ref.current(); } };
    atender();
    window.addEventListener(EVENTO_ABRIR, atender);
    return () => window.removeEventListener(EVENTO_ABRIR, atender);
  }, [destino, listo]);
}

// ═══ LAS ACTUALIZACIONES DE LA PLATAFORMA ═══════════════════════════════════
//
// Avisan de los cambios importantes DENTRO de la plataforma, de forma visible
// pero discreta: sin push, sin la campana ni el escudo. El contenido vive en
// src/novedades.js y la decisión de a quién le sale, en src/logica/novedades.js.
//
// LO VISTO SE GUARDA EN LA CUENTA, NO EN EL APARATO: `usuarios/{uid}.novedadesVistas`
// con `arrayUnion`. La regla de `usuarios` ya deja al dueño actualizar su
// documento, así que no hace falta tocar firestore.rules. Una copia en este
// navegador cubre el rato sin red, y se sube en cuanto se puede.
const CAMPO_NOVEDADES_VISTAS = "novedadesVistas";
// El MISMO mecanismo guarda también qué correcciones del patrón ya vio el
// trabajador (`usuarios/{uid}.correccionesVistas`, fase 2b): otro campo, otra copia
// local. La de las novedades conserva su clave de siempre.
const CAMPO_CORRECCIONES_VISTAS = "correccionesVistas";
const _claveNovedadesLocal = (uid: string, campo?: string) => "axis_novedades_vistas_" + uid + (campo && campo !== CAMPO_NOVEDADES_VISTAS ? "_" + campo : "");
function _novedadesLocales(uid: string, campo?: string): string[] {
  try { const v = JSON.parse(localStorage.getItem(_claveNovedadesLocal(uid, campo)) || "[]"); return Array.isArray(v) ? v.map(String) : []; }
  catch (e) { return []; }
}
function useNovedadesVistas(uid?: string, campo: string = CAMPO_NOVEDADES_VISTAS): {vistas: string[]|null; marcarVistas: (ids: string[]) => void} {
  // null = todavía no se sabe qué vio: mientras tanto NO se enseña ningún aviso.
  const [vistas, setVistas] = useState<string[]|null>(null);
  useEffect(() => {
    if (!uid) { setVistas(null); return; }
    let vivo = true;
    (async () => {
      const locales = _novedadesLocales(uid, campo);
      try {
        const snap: any = await getDoc(doc(db, "usuarios", uid));
        if (!vivo) return;
        const g = (snap && snap.data && snap.data() as any)?.[campo];
        const delServidor = Array.isArray(g) ? g.map(String) : [];
        setVistas(Array.from(new Set([...delServidor, ...locales])));
        // Lo que este navegador marcó sin red y no llegó a subir, se sube ahora.
        const faltan = locales.filter((x) => delServidor.indexOf(x) < 0);
        if (faltan.length) updateDoc(doc(db, "usuarios", uid), {[campo]: arrayUnion(...faltan)}).catch(() => {});
      } catch (e) {
        if (vivo) setVistas(locales);
      }
    })();
    return () => { vivo = false; };
  }, [uid, campo]);
  const marcarVistas = (ids: string[]) => {
    const nuevos = (ids || []).map(String).filter(Boolean);
    if (!nuevos.length) return;
    setVistas((prev) => Array.from(new Set([...(prev || []), ...nuevos])));
    if (!uid) return;
    try { localStorage.setItem(_claveNovedadesLocal(uid, campo), JSON.stringify(Array.from(new Set([..._novedadesLocales(uid, campo), ...nuevos])))); } catch (e) {}
    updateDoc(doc(db, "usuarios", uid), {[campo]: arrayUnion(...nuevos)})
      .catch((e: any) => console.error("novedades · no se pudo guardar lo visto (queda en este navegador):", e));
  };
  return {vistas, marcarVistas};
}
// Cuándo se creó la cuenta: la fecha de Authentication, que no se reescribe.
function altaDeLaCuentaMs(user: any): number {
  const t0 = Date.parse(String(user?.metadata?.creationTime || ""));
  return Number.isFinite(t0) ? t0 : 0;
}

const _NV_AVISO = {fondo: "#0B1829", borde: "rgba(212,168,67,0.45)", oro: "#D4A843", texto: "#ECE6D8", suave: "rgba(236,230,216,0.72)", tenue: "rgba(236,230,216,0.48)"};

// EL AVISO AL TRABAJADOR DE UNA CORRECCIÓN DE SU PATRÓN (fase 2b). No hay token de
// avisos para los teléfonos de los trabajadores (los avisos push van en su propia
// rama), así que se le dice al abrir su portal, como las actualizaciones: flotante,
// abajo, hasta que lo cierra o toca "Ver", que lo lleva a su checador.
function AvisoCorreccion({n, visible, onVer, onCerrar, abajo, fontSans}: {n: number; visible: boolean; onVer: () => void; onCerrar: () => void; abajo: string; fontSans: string}) {
  if (!visible || !n) return null;
  const P = _NV_AVISO;
  return (
    <div role="status" data-aviso="correccion"
      style={{position: "fixed" as const, left: 12, right: 12, bottom: abajo, margin: "0 auto", maxWidth: 520, zIndex: 30, background: P.fondo, border: "1px solid " + P.borde,
        borderRadius: 14, boxShadow: "0 12px 34px rgba(0,0,0,0.38)", padding: "12px 14px", fontFamily: fontSans, boxSizing: "border-box" as const}}>
      <div style={{display: "flex", alignItems: "flex-start", gap: 10}}>
        <div style={{flex: 1}}>
          <div style={{fontSize: 13.5, fontWeight: 800, color: P.oro, marginBottom: 2}}>{TEXTO_AVISO_CORRECCION}</div>
          {n > 1 && <div style={{fontSize: 12, color: P.suave}}>{n} correcciones sin revisar.</div>}
        </div>
        <button onClick={onCerrar} aria-label="Cerrar aviso" style={{background: "transparent", border: "none", color: P.suave, fontSize: 19, lineHeight: 1, cursor: "pointer", padding: "0 2px"}}>×</button>
      </div>
      <button onClick={onVer} style={{marginTop: 8, background: P.oro, color: "#0B1829", border: "none", borderRadius: 9, padding: "8px 14px", fontSize: 12.5, fontWeight: 800, cursor: "pointer", fontFamily: fontSans}}>Ver mi checador</button>
    </div>
  );
}
// LAS CORRECCIONES A SUS REGISTROS, EN SU CHECADOR: cada una con su anotación (quién,
// con qué cargo, cuándo y por qué) y "No conforme". Una nota por corrección en la
// pantalla; pide texto (mínimo 10 caracteres) y confirmación.
function CorreccionesDelTrabajador({vista, correoSesion, onCambio, NV, fontSans}: {vista: any; correoSesion: string; onCambio: () => void; NV: any; fontSans: string}) {
  const [abierta, setAbierta] = useState<string|null>(null);
  const [texto, setTexto] = useState(""); const [confirmando, setConfirmando] = useState(false);
  const [guardando, setGuardando] = useState(false); const [error, setError] = useState("");
  const lista = (vista?.correcciones || []).slice().sort((a: any, b: any) => (Number(b.correccion?.en?.toMillis?.()) || Date.now()) - (Number(a.correccion?.en?.toMillis?.()) || Date.now()));
  if (!lista.length) return null;
  const abrir = (id: string) => { setAbierta(id); setTexto(""); setConfirmando(false); setError(""); };
  const revisar = () => { const r = datosDeNoConformidad({correccionId: abierta, comentario: texto, marca: "pendiente"}); if (r.error) { setError(r.error); return; } setError(""); setConfirmando(true); };
  const guardar = async (x: any) => {
    setGuardando(true); setError("");
    try { const r = await guardarNoConformidad({correccion: x.correccion, correoSesion, comentario: texto}); if (r.error) { setError(r.error); setConfirmando(false); } else { setAbierta(null); onCambio(); } }
    catch (e: any) { console.error("no conforme:", e); setError(mensajeDeFallo(e, {accion: "guardar tu inconformidad", denegado: "Tu cuenta no tiene permiso para dejar esta nota. Avísale a tu patrón."})); setConfirmando(false); }
    finally { setGuardando(false); }
  };
  const btn = (txt: string, fn: () => void, primario?: boolean, off?: boolean) => (
    <button type="button" onClick={fn} disabled={off} style={{background: primario ? NV.gold : "transparent", color: primario ? "#0B1829" : NV.gold, border: `1px solid ${NV.gold}`, borderRadius: 9,
      padding: "7px 12px", fontSize: 12, fontWeight: 800, fontFamily: fontSans, cursor: off ? "wait" : "pointer", opacity: off ? 0.6 : 1}}>{txt}</button>
  );
  return (
    <div {...ZONA_DE_CAPTURA} data-seccion="correcciones-trabajador" style={{marginTop: 16, paddingTop: 14, borderTop: `1px solid ${NV.lineSoft}`}}>
      <div style={{fontSize: 11, fontWeight: 700, color: NV.inkMut, textTransform: "uppercase" as const, letterSpacing: "0.4px", marginBottom: 10}}>Correcciones de tu patrón a tus registros</div>
      {lista.map((x: any) => {
        const nota = x.noConformidades[0];
        return (
          <div key={x.correccion.id} style={{background: "rgba(255,255,255,0.03)", border: `1px solid ${NV.lineSoft}`, borderRadius: 10, padding: "10px 12px", marginBottom: 8}}>
            <div style={{fontSize: 11, color: NV.inkMut, marginBottom: 3}}>{registroAfectadoTexto(x.registro)}</div>
            {/* Cada anotación en su renglón: la corrección y, debajo, su reversión. */}
            {renglonesDeCorreccion(x).map((t: string, k: number) => <div key={k} data-anotacion style={{fontSize: 12.5, color: NV.ink, lineHeight: 1.5}}>{t}</div>)}
            {nota ? (
              <div style={{fontSize: 12, color: NV.gold, marginTop: 6, lineHeight: 1.45}}>{noConformidadTexto(nota, false)}</div>
            ) : abierta === x.correccion.id ? (
              <div style={{marginTop: 8}}>
                <textarea value={texto} onChange={(e) => { setTexto(e.target.value); setConfirmando(false); }} rows={3} maxLength={1000}
                  placeholder="¿Qué no te parece de esta corrección? (mínimo 10 caracteres)"
                  style={{width: "100%", boxSizing: "border-box" as const, background: "rgba(255,255,255,0.05)", border: `1px solid ${NV.line}`, borderRadius: 9, color: NV.ink, padding: "8px 10px", fontSize: 13, fontFamily: fontSans, outline: "none"}}/>
                {error && <div style={{fontSize: 11.5, color: "#FCA5A5", marginTop: 4}}>{error}</div>}
                {confirmando ? (
                  <div style={{marginTop: 6}}>
                    <div style={{fontSize: 12, color: NV.inkSoft, lineHeight: 1.5, marginBottom: 6}}>{TEXTO_CONFIRMAR_NO_CONFORME}</div>
                    <div style={{display: "flex", gap: 8, flexWrap: "wrap" as const}}>{btn(guardando ? "Guardando…" : "Sí, dejar mi inconformidad", () => guardar(x), true, guardando)}{btn("Volver", () => setConfirmando(false), false, guardando)}</div>
                  </div>
                ) : (
                  <div style={{display: "flex", gap: 8, marginTop: 6, flexWrap: "wrap" as const}}>{btn("Guardar", revisar, true)}{btn("Cancelar", () => setAbierta(null))}</div>
                )}
              </div>
            ) : (
              <div style={{marginTop: 6}}>{btn("No conforme", () => abrir(x.correccion.id))}</div>
            )}
          </div>
        );
      })}
    </div>
  );
}

// EL AVISO FLOTANTE. Pequeño, abajo —en el celular, por encima de la barra de
// navegación—, sin oscurecer el fondo ni bloquear nada.
//   · NO SE QUITA SOLO: ni temporizador ni cierre al tocar fuera. Se queda hasta
//     que la persona lo cierra o aprieta "Ver".
//   · UNO SOLO aunque haya varias sin ver: la más reciente, "y N más", y en el
//     panel "Ver todas".
//   · "×" o "Entendido" marcan como vistas TODAS las que el aviso representaba:
//     si no, cada visita al inicio sacaría la siguiente. Siguen en "Actualizaciones".
//   · `visible` lo decide quien lo monta: SOLO en la pantalla de inicio y sin
//     ningún formulario ni ventana encima. Fuera de ahí no se pinta, y espera.
function AvisoNovedades({rol, tieneFlotilla, altaMs, vistas, onMarcar, visible, posicion, abajo, fontSans}: {
  rol: "patron"|"trabajador"; tieneFlotilla: boolean; altaMs: number; vistas: string[]|null;
  onMarcar: (ids: string[]) => void; visible: boolean; posicion: "movil"|"escritorio"; abajo: string; fontSans: string;
}) {
  const [panel, setPanel] = useState(false);
  const [todas, setTodas] = useState(false);
  const aviso = avisoDeNovedades(NOVEDADES, {rol, tieneFlotilla}, vistas || [], altaMs);
  if (!visible || vistas === null || !aviso.principal) return null;
  const P = _NV_AVISO;
  const marcar = () => { onMarcar(aviso.pendientes.map((e: any) => e.id)); setPanel(false); setTodas(false); };
  const sitio: any = posicion === "movil"
    ? {left: 12, right: 12, bottom: abajo, margin: "0 auto", maxWidth: 520, zIndex: 29}
    : {right: 20, bottom: abajo, width: 380, zIndex: 1100};
  const cerrarBtn = (etiqueta: string) => (
    <button onClick={marcar} aria-label={etiqueta}
      style={{background: "transparent", border: "none", color: P.suave, fontSize: 19, lineHeight: 1, cursor: "pointer", padding: "0 2px", flexShrink: 0}}>×</button>
  );
  if (panel) {
    const mostradas = todas ? aviso.pendientes : [aviso.principal];
    return (
      <div role="dialog" aria-label="Actualización" data-novedades="panel"
        style={{position: "fixed" as const, ...sitio, background: P.fondo, border: "1px solid " + P.borde, borderRadius: 14,
          boxShadow: "0 12px 34px rgba(0,0,0,0.38)", padding: "14px 16px", fontFamily: fontSans, maxHeight: "70vh", overflowY: "auto" as const, boxSizing: "border-box" as const}}>
        <div style={{display: "flex", alignItems: "flex-start", gap: 10}}>
          <div style={{flex: 1, fontSize: 10.5, fontWeight: 800, color: P.oro, textTransform: "uppercase" as const, letterSpacing: "0.6px"}}>Actualización</div>
          {cerrarBtn("Cerrar actualización")}
        </div>
        {mostradas.map((e: any) => (
          <div key={e.id} style={{marginTop: 6, marginBottom: 10}}>
            <div style={{fontSize: 14.5, fontWeight: 800, color: P.texto, lineHeight: 1.3}}>{e.titulo}</div>
            <div style={{fontSize: 11, color: P.tenue, marginTop: 2}}>{fechaNovedadTexto(e.fecha)}</div>
            <ul style={{margin: "8px 0 0", paddingLeft: 18, color: P.suave, fontSize: 12.5, lineHeight: 1.55}}>
              {e.puntos.map((p: string, i: number) => <li key={i} style={{marginBottom: 4}}>{p}</li>)}
            </ul>
          </div>
        ))}
        <div style={{display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" as const, marginTop: 4}}>
          <button onClick={marcar}
            style={{background: P.oro, color: P.fondo, border: "none", borderRadius: 9, padding: "8px 16px", fontSize: 12.5, fontWeight: 800, cursor: "pointer", fontFamily: fontSans}}>Entendido</button>
          {aviso.mas > 0 && !todas && (
            <button onClick={() => setTodas(true)}
              style={{background: "transparent", color: P.oro, border: "1px solid " + P.borde, borderRadius: 9, padding: "7px 12px", fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: fontSans}}>Ver todas ({aviso.pendientes.length})</button>
          )}
        </div>
      </div>
    );
  }
  return (
    <div role="status" aria-label="Actualización" data-novedades="aviso"
      style={{position: "fixed" as const, ...sitio, background: P.fondo, border: "1px solid " + P.borde, borderRadius: 12,
        boxShadow: "0 10px 28px rgba(0,0,0,0.32)", padding: "10px 12px", fontFamily: fontSans, display: "flex", gap: 10, alignItems: "flex-start", boxSizing: "border-box" as const}}>
      <div style={{flex: 1, minWidth: 0}}>
        <div style={{fontSize: 13, fontWeight: 800, color: P.texto, lineHeight: 1.3}}>{aviso.principal.titulo}</div>
        <div style={{fontSize: 12, color: P.suave, marginTop: 2, lineHeight: 1.4}}>
          {aviso.principal.resumen}{aviso.mas > 0 ? ` · y ${aviso.mas} más` : ""}
        </div>
      </div>
      <button onClick={() => setPanel(true)}
        style={{background: "transparent", color: P.oro, border: "1px solid " + P.borde, borderRadius: 8, padding: "5px 11px", fontSize: 12, fontWeight: 800, cursor: "pointer", fontFamily: fontSans, flexShrink: 0}}>Ver</button>
      {cerrarBtn("Cerrar actualización")}
    </div>
  );
}

// "ACTUALIZACIONES" EN EL PERFIL: todas las que le aplican, también las ya vistas
// y las anteriores a su alta, de la más reciente a la más antigua, con su fecha.
function ListaNovedades({rol, tieneFlotilla, c, fontSans}: {
  rol: "patron"|"trabajador"; tieneFlotilla: boolean; fontSans: string;
  c: {fondo: string; borde: string; texto: string; textoSuave: string; acento: string};
}) {
  const [abierta, setAbierta] = useState<string>("");
  const lista = novedadesDeLaCuenta(NOVEDADES, {rol, tieneFlotilla});
  return (
    <div data-novedades="historial" style={{fontFamily: fontSans}}>
      {lista.length === 0 ? (
        <div style={{fontSize: 12, color: c.textoSuave, padding: "8px 2px"}}>Sin actualizaciones por ahora.</div>
      ) : lista.map((e: any) => {
        const ab = abierta === e.id;
        return (
          <div key={e.id} style={{background: c.fondo, border: "1px solid " + c.borde, borderRadius: 12, padding: "11px 13px", marginBottom: 8}}>
            <button onClick={() => setAbierta(ab ? "" : e.id)}
              style={{display: "block", width: "100%", textAlign: "left" as const, background: "transparent", border: "none", padding: 0, cursor: "pointer", fontFamily: fontSans}}>
              <div style={{fontSize: 11, color: c.textoSuave}}>{fechaNovedadTexto(e.fecha)}</div>
              <div style={{fontSize: 13, fontWeight: 700, color: c.texto, marginTop: 2}}>{e.titulo}</div>
              <div style={{fontSize: 12, color: c.textoSuave, marginTop: 2, lineHeight: 1.45}}>{e.resumen}</div>
              <div style={{fontSize: 11.5, fontWeight: 700, color: c.acento, marginTop: 5}}>{ab ? "Ocultar" : "Ver detalle"}</div>
            </button>
            {ab && (
              <ul style={{margin: "8px 0 0", paddingLeft: 18, color: c.textoSuave, fontSize: 12.5, lineHeight: 1.55}}>
                {e.puntos.map((p: string, i: number) => <li key={i} style={{marginBottom: 4}}>{p}</li>)}
              </ul>
            )}
          </div>
        );
      })}
    </div>
  );
}

// ═══ PREPARAR ESTE DISPOSITIVO ══════════════════════════════════════════════
//
// UN SOLO BLOQUE, Y NO DOS FILAS FIJAS. Instalar la app y activar los avisos son
// la misma clase de cosa —dejar listo ESTE aparato—, las dos desaparecen cuando ya
// están hechas, y en iPhone una depende de la otra. Se eligió una pieza que enseña
// lo que falte, y no un bloque con dos renglones, por tres razones:
//
//   1) CON UNA SOLA COSA PENDIENTE, dos renglones dejarían un hueco donde estaba
//      el otro, y un hueco se lee como algo roto.
//   2) EN iPHONE SIN INSTALAR SE SOLAPAN: el estado de los avisos ya dice "primero
//      instala AXIS", y la fila de instalar dice lo mismo. Aquí, cuando eso pasa,
//      la de avisos se calla y la de instalar añade una línea explicando que al
//      instalar también quedan los avisos. Un mensaje, no dos iguales.
//   3) SIN NADA PENDIENTE NO OCUPA NADA: devuelve null, sin encabezado huérfano.
//
// DÓNDE VIVE: alto en Inicio, justo debajo del saludo. Antes estaba al pie de
// TODAS las pantallas —había que bajar hasta el final para encontrarla, y además
// perseguía al patrón por todo el producto—. Y no va ENCIMA del saludo: quien
// entra por primera vez debe ver su cuenta, no una petición de permisos.
// `tema` existe porque los dos árboles del patrón no comparten paleta: el
// escritorio pinta sobre crema y el portal móvil sobre navy. Es lo mismo que hace
// `PuertaDeAvisos` con su `c`: una pieza que se monta en dos temas no puede llevar
// los colores dentro.
function PrepararDispositivo({isMobile, fontSerif, fontSans, tema}: {isMobile: boolean; fontSerif: string; fontSans: string; tema?: "claro" | "navy"}) {
  const avisos = useContext(CtxPuertaAvisos);
  // La decisión de instalar se replica aquí porque el encabezado del bloque tiene
  // que saber si hay algo debajo ANTES de pintarse. `InstallBanner` sigue siendo
  // quien manda —vuelve a comprobarlo y se esconde solo—, pero avisa al cerrarse
  // con `onCerrar` para que este bloque se entere en el mismo render.
  const [instalarCerrado, setInstalarCerrado] = useState<boolean>(() => {
    try { return localStorage.getItem("axis_install_dismissed") === "1"; } catch (e) { return false; }
  });
  const enIframe = typeof window !== "undefined" && window.self !== window.top;
  const faltaInstalar = !_esStandalone() && !enIframe && !instalarCerrado;

  const estado = avisos ? avisos.estado : "no_soportado";
  const faltaAvisos = !!avisos && !avisos.cerrado && (
    estado === "puede_pedir" ||
    estado === "ios_sin_instalar" ||
    (estado === "bloqueado" && avisos.intentado)
  );
  // EL SOLAPE. Si se está ofreciendo instalar y el estado de avisos es justamente
  // "falta instalar", los dos renglones dirían lo mismo con otras palabras.
  const mostrarAvisos = faltaAvisos && !(faltaInstalar && estado === "ios_sin_instalar");
  // LA NOTA DEL AHORRO DE BATERÍA: al ACTIVAR los avisos desde un Android, debajo,
  // hasta que se cierre. Cerrada, no vuelve a salir en este aparato (en el perfil
  // sigue a la vista).
  const [notaBateriaCerrada, setNotaBateriaCerrada] = useState<boolean>(() => {
    try { return localStorage.getItem(CLAVE_NOTA_BATERIA) === "1"; } catch (e) { return false; }
  });
  const cerrarNotaBateria = () => { try { localStorage.setItem(CLAVE_NOTA_BATERIA, "1"); } catch (e) {} setNotaBateriaCerrada(true); };
  const mostrarNotaBateria = !!avisos && avisos.intentado && estado === "activos" && _esAndroid() && !notaBateriaCerrada;

  // NADA PENDIENTE, NADA EN PANTALLA. Ni encabezado, ni margen, ni un pixel.
  if (!faltaInstalar && !mostrarAvisos && !mostrarNotaBateria) return null;

  const navy = tema === "navy";
  const P = navy
    ? {oro: "#D4A843", titulo: "#ECE6D8", fondo: "rgba(255,255,255,0.04)", borde: "rgba(212,168,67,0.22)",
       acento: "#D4A843", botonTexto: "#0B1829", texto: "#ECE6D8", textoSuave: "rgba(236,230,216,0.66)"}
    : {oro: T_LIGHT.gold, titulo: T_LIGHT.textInk, fondo: "#fff", borde: T_LIGHT.borderCard,
       acento: "#236478", botonTexto: "white", texto: T_LIGHT.textInk, textoSuave: T_LIGHT.textInkSoft};

  return (
    <div style={{marginBottom: isMobile ? 14 : 22}}>
      <div style={{display: "flex", alignItems: "center", gap: 9, margin: isMobile ? "2px 0 8px" : "4px 0 12px"}}>
        <div style={{width: 4, height: isMobile ? 15 : 18, background: P.oro, borderRadius: 2, flexShrink: 0}}/>
        <h3 style={{fontFamily: fontSerif, fontSize: isMobile ? 14 : 18, color: P.titulo, margin: 0, fontWeight: 700}}>
          Prepara este dispositivo
        </h3>
      </div>
      {/* INSTALAR. El componente trae su propio modal con las instrucciones de
          iPhone y de Android, y es el mismo que usan la portada y el portal del
          trabajador: aquí no se copia nada, solo se le dice dónde ponerse. */}
      <InstallBanner fontSerif={fontSerif} gold={P.oro} isMobile={isMobile}
        onCerrar={() => setInstalarCerrado(true)}
        motivo={estado === "ios_sin_instalar"
          ? "En iPhone, instalarla en tu pantalla de inicio es la única forma de recibir avisos, como el de un accidente."
          : undefined}/>
      {mostrarAvisos && avisos && (
        <PuertaDeAvisos estado={estado} onActivar={avisos.activar} onCerrar={avisos.cerrar}
          fontSans={fontSans} compacta={navy}
          c={{fondo: P.fondo, borde: P.borde, acento: P.acento, botonTexto: P.botonTexto,
              texto: P.texto, textoSuave: P.textoSuave}}/>
      )}
      {mostrarNotaBateria && (
        <NotaBateriaAndroid fontSans={fontSans} onCerrar={cerrarNotaBateria}
          c={{fondo: P.fondo, borde: P.borde, texto: P.texto, textoSuave: P.textoSuave}}/>
      )}
    </div>
  );
}

// ⚠ CONSERVADO SIN LLAMAR. Este hook estuvo montado en AppShell y hoy no lo
// llama nadie. Es a propósito, y estas son las tres razones:
//
//   1) SOLO EMITÍA CON LA PESTAÑA A LA VISTA. La última condición del `if` es
//      `document.visibilityState === "visible"`: avisaba de lo que el patrón ya
//      estaba mirando y callaba justo cuando no estaba delante, que es lo único
//      para lo que sirve una notificación.
//
//   2) UNA NOTIFICACIÓN POR PERSONA Y POR HECHO, recortadas a tres por tanda con
//      un `slice(0,3)` sin criterio. Con quince empleados, la mañana de un lunes
//      son quince avisos de los que se ven tres, elegidos por el orden en que
//      llegaron. Eso es ruido, y además ruido incompleto.
//
//   3) NOTIFICABA LO ESPERADO. Cada checada normal era un aviso. Que la gente
//      cheque entrada es que el día empezó bien; lo que merece interrumpir a
//      alguien es que TRES no hayan checado. Ver la regla 1 de arriba.
//
// NO SE BORRA porque la maquinaria de "qué es nuevo" —la línea base de la primera
// pasada y el cotejo contra la marca de visto del servidor— es correcta y hay que
// reutilizarla cuando exista el envío de push. Lo que estaba mal era QUÉ se
// emitía, no CÓMO se decidía qué era nuevo.
//
// Mientras tanto, esos hechos se ven donde les toca: en la campana de actividad y
// en el registro. Ninguno de los dos se ha tocado.
function useAvisoPorCadaHecho(actividad:any, uid?:string) {
  const {marca: marcaVistas} = useMarcaVistas(uid);
  const notifInicializado = useRef(false);
  const notifEnviados = useRef<Set<string>>(new Set());
  useEffect(() => {
    if (!actividad) return;
    const items: Array<{id:string; texto:string; ms:number}> = [
      ...((actividad.tareas||[]).map((t:any)=>({id:t.id, texto:`${t.nombre} marcó "${t.titulo}"`, ms:t.ms||0}))),
      ...((actividad.checadas||[]).map((c:any)=>({id:c.id, texto:`${c.nombre} · ${c.label||labelChecada(c.tipo)}`, ms:c.ms||0}))),
      ...((actividad.flotilla||[]).map((f:any)=>({id:f.id, texto:`${f.nombre} registró ${f.tipo} de ${f.placa}`, ms:f.ms||0}))),
      ...((actividad.accidentes||[]).map((a:any)=>({id:a.id, texto:`${a.nombre} registró un accidente`, ms:a.ms||0}))),
    ];
    // (1) Primera pasada con datos: fija la línea base sin notificar lo preexistente.
    if (!notifInicializado.current) {
      if (items.length === 0) return;                       // espera a que carguen datos
      items.forEach(i => notifEnviados.current.add(i.id));
      notifInicializado.current = true;
      return;
    }
    // (2) Referencia de "visto": LA MISMA MARCA que la campana y el portal del
    //     trabajador. Verlas en el teléfono apaga también la notificación del
    //     navegador en la computadora. Mientras no se sepa la marca —`null`— no
    //     se notifica nada: es la dirección segura.
    const yaVisto = (it:any) => marcaVistas === null || it.ms <= marcaVistas;
    // Solo avisos NO notificados esta sesión Y NO marcados como vistos.
    const nuevos = items.filter(i => !notifEnviados.current.has(i.id) && !yaVisto(i));
    items.forEach(i => notifEnviados.current.add(i.id));
    if (nuevos.length && typeof Notification !== "undefined" && Notification.permission === "granted"
        && (typeof document === "undefined" || document.visibilityState === "visible")) {
      // El icono es el de AXIS, no el de AXIOR: esto es un hecho de la
      // plataforma, no algo que diga el asistente.
      // `badge` es el icono de la barra de estado, y Android lo vuelve silueta:
      // `logo.png` no tiene canal alfa y daba un cuadro blanco. Ver badge.png.
      nuevos.slice(0,3).forEach(n => { try { new Notification("Actividad de trabajadores", { body:n.texto, icon:"/logo.png?v=4", badge:"/badge.png" } as any); } catch (e) {} });
    }
  }, [actividad, marcaVistas]);
}


// ─── MODO BETA ─────────────

// ─── STORAGE HELPERS ──────────────────────────────────────────────────────────

// EL TIPO QUE SE DECLARA AL SUBIR, Y POR QUÉ NO PUEDE SER UNO POR OMISIÓN.
//
// Firebase no huele el contenido: si no se le dice el tipo, usa el `type` del
// File, y muchos Android entregan el archivo de la galería con el `type` VACÍO.
// Entonces el objeto sube como "application/octet-stream", que no pasa ni
// `videoOk()` ni `tipoOk()` en storage.rules, y la subida muere con
// storage/unauthorized sin que nadie entienda por qué.
//
// La suplente es la EXTENSIÓN, y nada más. Poner "video/mp4" por omisión para
// cualquier archivo desharía la protección que las reglas acaban de estrenar:
// bastaría subir un ejecutable con esa etiqueta. Si el `type` viene vacío Y la
// extensión no dice nada, no se declara nada y que falle: se prefiere una
// subida fallida a una etiqueta inventada.
//
// LO QUE ESTO NO ES: una garantía, y conviene tenerlo claro para no confundirse
// sobre qué hace este mapa. Las reglas se fían de lo que declara quien sube,
// aquí y en cualquier cliente: alguien decidido etiqueta lo que quiera con mapa
// o sin él. Esto NO es un control de seguridad —el control es `videoOk()` y
// `tipoOk()` en el servidor—: es una cortesía para el teléfono honesto que no
// sabe qué está mandando. Por eso puede ensancharse sin aflojar nada.
//
// Y por eso la regla de al lado NO se mueve: sigue sin haber tipo por omisión.
// Si la extensión tampoco dice nada, no se declara nada.
const MIME_POR_EXTENSION: Record<string, string> = {
  mp4: "video/mp4", m4v: "video/mp4", mov: "video/quicktime",
  webm: "video/webm", "3gp": "video/3gpp", mkv: "video/x-matroska",
  jpg: "image/jpeg", jpeg: "image/jpeg", png: "image/png",
  webp: "image/webp", heic: "image/heic", heif: "image/heif", gif: "image/gif",
};

// UN TIPO QUE NO DICE NADA, AUNQUE SEA UN VALOR.
//
// El `type` vacío no es el único caso: Android manda muchas veces
// "application/octet-stream", que es literalmente "una ristra de bytes". Como es
// un valor, se declaraba tal cual, y storage.rules lo rechazaba igual que al
// vacío —no pasa `videoOk()` ni `tipoOk()`—: el mismo storage/unauthorized por
// otra puerta. Así que se trata como si no hubiera venido nada y se cae al
// respaldo por extensión.
const TIPO_SIN_INFORMACION = "application/octet-stream";
function tipoDeclarado(archivo: File): string {
  const t = String(archivo?.type || "").trim();
  if (t && t.toLowerCase() !== TIPO_SIN_INFORMACION) return t;
  const ext = String(archivo?.name || "").split(".").pop();
  return MIME_POR_EXTENSION[String(ext || "").toLowerCase()] || "";
}

// LO QUE HACE ÚNICA A UNA RUTA, Y NO ES EL RELOJ.
//
// El nombre del objeto era `${Date.now()}_${nombre}`, y eso no es único: el
// bucle de una tanda llama a esto hasta ocho veces seguidas, y dos archivos con
// el mismo nombre de origen —dos "IMG_0001.jpg" de una galería— caían en la
// MISMA ruta si las dos vueltas compartían milisegundo. El segundo sobrescribía
// al primero en Storage, y en la lista quedaban dos filas con la misma URL: dos
// nombres, un archivo. Comprobado ejecutando el camino real.
//
// Es el mismo defecto que ya costó datos con `Date.now()` como id de documento
// dentro de un lote, en la otra mitad del sistema.
//
// Una marca de tiempo con más dígitos NO lo arregla: solo estrecha la ventana.
// La unicidad tiene que venir de algo que no sea el reloj:
//   · el CONTADOR basta dentro de una pestaña —dos vueltas del bucle nunca
//     comparten valor, pase lo que pase con la hora—, que es el caso real;
//   · el AZAR cubre lo que el contador no puede: la misma persona subiendo desde
//     dos dispositivos a la vez, donde los dos contadores arrancan en 1.
// `Date.now()` se queda delante, pero ya no carga con la unicidad: sirve para
// que los objetos del bucket se lean y se ordenen por fecha.
let _secuenciaSubida = 0;
function _sufijoUnico(): string {
  _secuenciaSubida += 1;
  const c: any = (globalThis as any).crypto;
  const azar = String(c?.randomUUID ? c.randomUUID() : Math.random().toString(36).slice(2))
    .replace(/-/g, "").slice(0, 8);
  return _secuenciaSubida + "-" + azar;
}

// Sube un archivo a Firebase Storage y devuelve la URL de descarga.
//
// ═══ LA CARPETA NO PUEDE LLEVAR BARRAS ══════════════════════════════════════
//
// La ruta se compone `carpeta/userId/…`, con el uid en el SEGUNDO segmento,
// que es exactamente donde storage.rules ata `{userId}` y compara contra
// `uid()`. Si la carpeta trae barras dentro, el uid se va al fondo y el segundo
// segmento pasa a ser otra cosa: la regla deja de encajar y la subida muere con
// storage/unauthorized.
//
// Ya pasó: el vídeo de un movimiento se subía con carpeta
// `flotilla/<empleadorId>/<movimientoId>`, y el uid del trabajador acababa en
// cuarta posición mientras el segundo segmento era el uid del PATRÓN. Las fotos
// del mismo movimiento subían bien porque componen la ruta a mano. El registro
// se guardaba, las fotos se veían, y solo el vídeo fallaba — un cuadro que no
// señala a la ruta por ningún lado.
//
// Por eso esto revienta AQUÍ, en la llamada, con el nombre de la carpeta en el
// mensaje. Un error de programación tiene que salir cuando se escribe, no seis
// meses después en el teléfono de una clienta en carretera.
//
// Si hace falta agrupar en subcarpetas, va en `subcarpeta`, que se concatena
// DESPUÉS del uid y por tanto nunca lo desplaza.
async function subirArchivo(
  userId: string,
  carpeta: string,
  archivo: File,
  onProgress?: (pct: number) => void,
  subcarpeta?: string
): Promise<string> {
  if (String(carpeta || "").indexOf("/") >= 0) {
    const aviso = "subirArchivo: la carpeta \"" + carpeta + "\" lleva barras. El uid tiene que quedar en el "
      + "segundo segmento de la ruta, que es al que storage.rules ata {userId}; una carpeta compuesta lo "
      + "empuja hacia el fondo y la subida falla con storage/unauthorized. Pasa las subcarpetas en el "
      + "parámetro `subcarpeta`, que va DESPUÉS del uid.";
    console.error(aviso);
    throw new Error(aviso);
  }
  // Ver `_sufijoUnico`: sin él, dos archivos del mismo nombre en la misma tanda
  // se pisan. El nombre de origen se conserva al final, que es lo que hace
  // legible el bucket; el que se muestra en pantalla sale del campo `nombre` del
  // documento de Firestore, no de aquí.
  const nombre = `${Date.now()}_${_sufijoUnico()}_${archivo.name.replace(/[^a-zA-Z0-9._-]/g, "_")}`;
  const cola = subcarpeta ? String(subcarpeta).replace(/^\/+|\/+$/g, "") + "/" : "";
  const storageRef = ref(storage, `${carpeta}/${userId}/${cola}${nombre}`);
  const tipo = tipoDeclarado(archivo);
  return new Promise((resolve, reject) => {
    // Sin tipo no se manda metadata: mejor que Firebase decida a mentirle.
    const uploadTask = tipo
      ? uploadBytesResumable(storageRef, archivo, {contentType: tipo})
      : uploadBytesResumable(storageRef, archivo);
    uploadTask.on("state_changed",
      snap => { if (onProgress) onProgress(Math.round(snap.bytesTransferred/snap.totalBytes*100)); },
      err => reject(err),
      async () => { resolve(await getDownloadURL(uploadTask.snapshot.ref)); }
    );
  });
}


// ─── FOTOS DE MOVIMIENTO DE FLOTILLA ───────────────────────────────────────
// Comprime una imagen EN EL CLIENTE antes de subirla. Quien registra el
// movimiento lo hace desde carretera, con datos móviles y a veces con una barra
// de señal: una foto de 4 MB recién salida de la cámara puede tardar minutos o
// no subir. Lado mayor 1600 px y JPEG 0.7 deja el archivo en unos cientos de KB
// y sigue siendo legible una placa o un golpe en la carrocería.
//
// Si algo falla —un formato que el navegador no decodifica, un canvas que no da
// contexto— se devuelve el archivo ORIGINAL en vez de tirar el error: es
// preferible una subida lenta a una foto perdida.
async function comprimirImagen(archivo: File, ladoMax = 1600, calidad = 0.7): Promise<Blob> {
  try {
    if (!archivo.type.startsWith("image/")) return archivo;
    const bitmap = await new Promise<HTMLImageElement>((resolve, reject) => {
      const img = new Image();
      const url = URL.createObjectURL(archivo);
      img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
      img.onerror = () => { URL.revokeObjectURL(url); reject(new Error("no se pudo leer la imagen")); };
      img.src = url;
    });
    const escala = Math.min(1, ladoMax / Math.max(bitmap.width, bitmap.height));
    const w = Math.max(1, Math.round(bitmap.width * escala));
    const h = Math.max(1, Math.round(bitmap.height * escala));
    const canvas = document.createElement("canvas");
    canvas.width = w; canvas.height = h;
    const ctx = canvas.getContext("2d");
    if (!ctx) return archivo;
    ctx.drawImage(bitmap, 0, 0, w, h);
    const blob = await new Promise<Blob|null>((resolve)=> canvas.toBlob(resolve, "image/jpeg", calidad));
    if (!blob) return archivo;
    // Si comprimir no ayudó (una foto ya pequeña puede crecer al recodificar),
    // se queda la original.
    return blob.size < archivo.size ? blob : archivo;
  } catch { return archivo; }
}

// ═══ LO QUE SE SUBE DESDE LA CALLE ══════════════════════════════════════════
//
// Los tres sitios que un TRABAJADOR usa en carretera —fotos de accidente, fotos
// de movimiento y el documento de un vehículo— no pasan por `SubirArchivoBtn`, y
// por eso se quedaron fuera de la rama anterior. Cada uno tiene su razón para no
// pasar: uno necesita previsualizar antes de guardar, otro guarda el archivo junto
// con las fechas en una sola operación, y el tercero acumula y deja quitar.
//
// Lo que NO puede ser distinto en ellos es lo de aquí abajo: cuántas caben, cuánto
// pesan y qué formatos entran. Un chofer con una barra de señal es el caso normal,
// no el excepcional.

// CUÁNTAS FOTOS. Los dos números son distintos porque los dos hechos lo son.
//
//   · UN ACCIDENTE necesita ángulos: los cuatro costados del vehículo propio, el
//     detalle del golpe, el otro vehículo, las dos placas, la posición final en la
//     vía y el parte si lo hay. Diez es lo que cabe en un parte decente sin que se
//     convierta en un álbum. Comprimidas rondan 275 KB cada una: unos 2,7 MB en
//     total, que por datos móviles es una subida larga pero posible.
//   · UNA SALIDA O UN REGRESO es rutina: cuatro costados, el odómetro y la carga.
//     Seis. Tres se quedaba corto —no cabían los cuatro lados— y veinte sería
//     pedirle a alguien que fotografíe un camión entero cada mañana.
const MAX_FOTOS_ACCIDENTE = 10;
const MAX_FOTOS_MOVIMIENTO = 6;

// CUÁNTO PESA UNA FOTO. El mismo tope que el resto de la plataforma, y con la
// compresión delante casi nunca se toca: una foto de 12 MP baja a unos cientos de
// KB. Está para el caso raro —un formato que el navegador no sabe recodificar— y
// para que el mensaje sea claro en vez de un fallo de red a los tres minutos.
const MAX_MB_FOTO = 10;

// ═══ EL VÍDEO: 30 SEGUNDOS ══════════════════════════════════════════════════
//
// UN VÍDEO NO SE PUEDE COMPRIMIR EN EL NAVEGADOR. Con las imágenes se puede: hay
// canvas y `toBlob`, y por eso una foto de 5 MB acaba pesando 274 KB. Con vídeo no
// existe nada equivalente que funcione en un teléfono de gama media sin bloquearlo
// medio minuto. Así que aquí el límite no es una red de seguridad: es el ÚNICO
// control, y por eso es estricto y se comprueba ANTES de empezar.
//
// EL LÍMITE SE PIENSA EN SEGUNDOS Y SE APLICA EN MEGAS, porque un chofer sabe
// cuánto duró su grabación y no sabe cuánto pesa. La medida real de un teléfono
// grabando a 1080p es 1,7 MB por segundo, así que 30 segundos son 51 MB, y el
// límite queda en 50: un número redondo, el mismo que en storage.rules, y a una
// grabación de 30 segundos no le sobra casi nada.
//
// La espera ya no es el argumento que era. Antes el límite lo marcaba el tiempo
// que alguien aguanta mirando una barra, porque el registro no se guardaba hasta
// que el vídeo terminaba. Ya no: el movimiento y el accidente se escriben PRIMERO
// y el vídeo se engancha después. Si la subida tarda o falla, se pierde evidencia
// añadida, nunca el registro. Ver `guardarFlota` y `registrarAccidente`.
//
// Y SOLO EN DOS SITIOS: salida/regreso de flotilla y accidente. En el expediente de
// un empleado o en el banco de documentos no tiene sentido y no se abre — las
// reglas de Storage lo impiden ahí, no solo la aplicación.
//
// Los dos números viajan juntos: SEGUNDOS es lo que se le dice a la persona,
// MB es lo que se comprueba. Si uno cambia, el otro y storage.rules también.
const SEGUNDOS_VIDEO = 30;
const MAX_MB_VIDEO = 50;
const TIPOS_VIDEO = ["video/mp4", "video/quicktime", "video/webm", "video/3gpp", "video/x-matroska"];
// DOS ACCEPT DISTINTOS, Y NO ES UN CAPRICHO.
//
// El primer intento fue UN solo botón con la lista larga de abajo y sin `capture`.
// En un Android de verdad eso abre el EXPLORADOR DE ARCHIVOS, nunca la cámara: sin
// `capture` el navegador no tiene motivo para grabar nada, y una lista que mezcla
// tipos MIME con extensiones —".mp4", ".mov"— hace que Android se decida todavía
// más por el explorador.
//
// No se pueden tener las dos cosas en un mismo campo: `capture` es una orden, no
// una sugerencia. Con el atributo se graba; sin él se elige. Así que son dos
// botones, igual que en las fotos, y por la misma razón: son dos intenciones
// distintas —"voy a grabarlo ahora" y "ya lo tengo"—.
//
//   · Para GRABAR: `video/*` a secas y `capture="environment"`. La cámara trasera,
//     en modo vídeo, sin pasar por ninguna galería. Una lista de tipos concretos
//     aquí rompe el comportamiento en varios Android.
//   · Para ELEGIR: la lista larga, que es la que filtra bien en el explorador y
//     acepta lo que graban los telefonos —mp4 en Android, mov en iPhone—.
const ACEPTA_VIDEO_CAMARA = "video/*";
const ACEPTA_VIDEO = "video/mp4,video/quicktime,video/webm,video/3gpp,.mp4,.mov,.webm,.3gp";

function esVideo(f: File): boolean {
  const t = String(f.type || "").toLowerCase();
  if (t.startsWith("video/")) return true;
  // Algunos Android entregan un `type` vacío al elegir de la galería. La extensión
  // no es una garantía, pero es mejor que dar por hecho que no es un vídeo y
  // colarlo por la puerta de las imágenes.
  return /\.(mp4|mov|m4v|webm|3gp|mkv)$/i.test(String(f.name || ""));
}

// El peso, dicho en un mensaje que sirve: cuánto pesa el que eligió y cuánto se
// admite. "El archivo es muy grande" no le dice a nadie qué hacer.
function _mb(bytes: number): string {
  return (Math.round(bytes / 1024 / 1024 * 10) / 10).toFixed(1);
}
function motivoRechazo(f: File): string {
  if (esVideo(f)) {
    if (!TIPOS_VIDEO.includes(String(f.type || "").toLowerCase()) && String(f.type || "")) {
      return `el formato de video ${f.type} no se admite`;
    }
    // `>=` Y NO `>`: storage.rules pide `size < 50 * 1024 * 1024`, así que un
    // archivo de 52.428.800 bytes clavados pasaba este filtro y moría contra la
    // regla después de gastar los datos. El filtro de aquí tiene que rechazar
    // exactamente lo mismo que rechaza el servidor, ni un byte menos.
    if (f.size >= MAX_MB_VIDEO * 1024 * 1024) {
      // En segundos primero, que es lo que la persona controla; los megas van
      // detrás, entre paréntesis, para quien quiera el dato exacto.
      return `ese video es más largo de lo que se admite. El máximo son unos ${SEGUNDOS_VIDEO} segundos de grabación (${MAX_MB_VIDEO} MB) y ése pesa ${_mb(f.size)} MB. Graba uno más corto.`;
    }
    return "";
  }
  if (!String(f.type || "").startsWith("image/")) return "no es una imagen ni un video";
  // `>=`, por lo mismo que arriba: `pesoOk()` pide `size < 10 * 1024 * 1024`.
  if (f.size >= MAX_MB_FOTO * 1024 * 1024) {
    return `pesa ${_mb(f.size)} MB y el máximo son ${MAX_MB_FOTO} MB`;
  }
  return "";
}

// Sube UNA foto de movimiento y devuelve la URL de descarga y el path de Storage.
//
// RUTA: flotilla/{uid de quien sube}/{empleadorId}/{movimientoId}/{n}.jpg
// El primer segmento después de la carpeta tiene que ser el uid de quien escribe:
// la regla de Storage es `/{carpeta}/{userId}/**` con `uid() == userId`, y las
// reglas de Storage NO pueden consultar Firestore, así que no hay forma de
// comprobar ahí que este trabajador pertenece a ese patrón. El vínculo real vive
// en el documento de Firestore, igual que en accidentes; el empleador y el
// movimiento van dentro de la ruta para poder rastrear y limpiar después.
//
// A diferencia de subirArchivo(), este devuelve TAMBIÉN el path: la URL de
// descarga lleva token y no sirve para ubicar el objeto de forma estable.
async function subirFotoMovimiento(
  uid: string, empleadorId: string, movimientoId: string, indice: number, archivo: File,
  onProgress?: (pct:number)=>void
): Promise<{url:string; path:string}> {
  const blob = await comprimirImagen(archivo);
  const path = `flotilla/${uid}/${empleadorId}/${movimientoId}/${indice}.jpg`;
  const objetivo = ref(storage, path);
  const tarea = uploadBytesResumable(objetivo, blob, {contentType: blob.type || "image/jpeg"});
  await new Promise<void>((resolve, reject) => {
    // El porcentaje real, para que en carretera se vea que avanza.
    tarea.on("state_changed",
      (snap)=>{ if (onProgress) onProgress(Math.round(snap.bytesTransferred/snap.totalBytes*100)); },
      (err)=>reject(err), ()=>resolve());
  });
  const url = await getDownloadURL(tarea.snapshot.ref);
  return {url, path};
}

// EL VÍDEO DEL MOVIMIENTO, EN LA MISMA CARPETA QUE SUS FOTOS.
//
// Va aquí al lado de `subirFotoMovimiento` y compone la ruta igual, a mano, con
// el uid PRIMERO: es lo que storage.rules ata a `{userId}`. Antes pasaba por
// `subirArchivo` con una carpeta compuesta y el uid acababa en cuarta posición
// —ver el comentario de la guardia allí—, así que fallaba mientras las fotos del
// mismo movimiento subían sin problema.
//
// Un solo vídeo por movimiento, y por eso el nombre es fijo: si alguien graba
// otro, reemplaza. El tipo se declara con `tipoDeclarado`, porque un vídeo de
// galería en Android llega muchas veces con el `type` vacío.
async function subirVideoMovimiento(
  uid: string, empleadorId: string, movimientoId: string, archivo: File,
  onProgress?: (pct:number)=>void
): Promise<{url:string; path:string}> {
  const ext = String(archivo.name || "").split(".").pop() || "mp4";
  const path = `flotilla/${uid}/${empleadorId}/${movimientoId}/video.${ext.toLowerCase()}`;
  const objetivo = ref(storage, path);
  const tipo = tipoDeclarado(archivo);
  const tarea = tipo
    ? uploadBytesResumable(objetivo, archivo, {contentType: tipo})
    : uploadBytesResumable(objetivo, archivo);
  await new Promise<void>((resolve, reject) => {
    tarea.on("state_changed",
      (snap)=>{ if (onProgress) onProgress(Math.round(snap.bytesTransferred/snap.totalBytes*100)); },
      (err)=>reject(err), ()=>resolve());
  });
  const url = await getDownloadURL(tarea.snapshot.ref);
  return {url, path};
}

// CUÁNDO SE SUBIÓ ESTE ARCHIVO, AL MINUTO.
//
// Tres subidas del mismo archivo dan tres renglones con el mismo nombre y la
// misma fecha. Desde que la ruta lleva sufijo único son archivos distintos de
// verdad, pero en la lista no había forma de saber cuál era cuál. La hora los
// separa, y no hace falta inventar nombres ni renumerar nada al borrar uno.
//
// EL DATO YA ESTABA GUARDADO, en dos sitios y sin querer: el nombre del objeto
// en Storage empieza por `Date.now()` —siempre lo hizo, también antes de esta
// rama— y el id de la fila del banco también. No se toca ningún documento: se
// lee lo que ya hay.
//
// Y se muestra la fecha DE ESE MISMO INSTANTE, no el campo `fecha` guardado.
// El campo se escribe con `toISOString().slice(0,10)`, que es la fecha en UTC:
// en México, todo lo subido después de las 18:00 se guardó con la fecha del día
// siguiente. Poner la hora local al lado de una fecha UTC habría enseñado la
// contradicción —"10 de septiembre · 19:05" para algo subido el 9—. Cuando el
// instante se puede leer, manda él; cuando no, se cae al campo de siempre.
function selloDeSubida(d: any): string {
  const url = String((d && d.url) || "");
  let ms = NaN;
  const enRuta = url.match(/(?:%2F|\/)(\d{13})_/);
  if (enRuta) ms = Number(enRuta[1]);
  if (!Number.isFinite(ms)) {
    const enId = String((d && d.id) || "").match(/^(\d{13})/);
    if (enId) ms = Number(enId[1]);
  }
  if (!Number.isFinite(ms)) return String((d && d.fecha) || "");
  const f = new Date(ms);
  return f.toLocaleDateString("es-MX") + " · " + f.toLocaleTimeString("es-MX", {hour: "2-digit", minute: "2-digit"});
}

// Normaliza el arreglo `fotos` de un movimiento. Se guarda como {url, path},
// pero se lee tolerando la forma plana (un string suelto) por si algún registro
// llegara así: al mostrar solo hace falta la URL.
function fotosDeMovimiento(registro:any): {url:string; path?:string}[] {
  const arr = registro?.fotos;
  if (!Array.isArray(arr)) return [];
  return arr.map((f:any)=> typeof f === "string" ? {url:f} : f).filter((f:any)=> f && f.url);
}
// ═══ EL VISOR DE IMÁGENES, UNO PARA TODA LA PLATAFORMA ══════════════════════
//
// Hasta ahora una foto subida se veía como una miniatura de 84 px que abría una
// PESTAÑA NUEVA. Con una foto por movimiento se aguantaba; multiplicando los
// archivos, mirar seis fotos eran seis pestañas y seis vueltas atrás.
//
// UNO SOLO, NO UNO POR MÓDULO. La bitácora de flotilla y el detalle de accidentes
// pintaban su propia tira de miniaturas con el mismo código copiado. Dos visores
// habrían divergido igual que divergieron los tres resaltados: aquí hay una sola
// pieza y las dos pantallas la usan.
//
// SE CIERRA CON UN CLIC FUERA, y eso es deliberado: es la regla que ya fijamos
// para los paneles —el que CAPTURA no se cierra solo, el que solo MUESTRA sí—.
// Aquí no hay nada escrito que perder, así que cerrarlo con un clic fuera es
// cómodo y no cuesta nada. Por lo mismo escucha Escape.
function VisorImagenes({ imagenes, indice, onCerrar }: {
  imagenes: {url:string; titulo?:string; tipo?:"imagen"|"video"}[]; indice:number; onCerrar:()=>void;
}) {
  const [i, setI] = useState(indice);
  const n = imagenes.length;
  // El índice se re-sincroniza si se abre otra imagen del mismo conjunto sin
  // cerrar el visor.
  useEffect(() => { setI(indice); }, [indice]);
  const ir = React.useCallback((d:number) => setI((k) => (k + d + n) % n), [n]);
  useEffect(() => {
    const tecla = (e: any) => {
      if (e.key === "Escape") { onCerrar(); return; }
      if (e.key === "ArrowRight") { ir(1); return; }
      if (e.key === "ArrowLeft") { ir(-1); return; }
    };
    window.addEventListener("keydown", tecla);
    // Mientras el visor está abierto, la pantalla de detrás no se desplaza: si no,
    // al cerrar apareces en otro sitio de la lista.
    const previo = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { window.removeEventListener("keydown", tecla); document.body.style.overflow = previo; };
  }, [ir, onCerrar]);
  if (!n) return null;
  const actual = imagenes[Math.min(Math.max(i, 0), n - 1)];
  const btn:any = {
    background:"rgba(255,255,255,0.10)", border:"1px solid rgba(255,255,255,0.22)",
    color:"#fff", width:44, height:44, borderRadius:"50%", cursor:"pointer",
    fontSize:20, lineHeight:1, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0,
  };
  return (
    <div onClick={onCerrar}
      style={{position:"fixed" as const, inset:0, zIndex:5000, background:"rgba(6,12,24,0.92)",
        display:"flex", flexDirection:"column" as const, padding:"14px 14px 20px"}}>
      <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", gap:12, color:"#fff", flexShrink:0}}>
        <span style={{fontSize:12.5, opacity:0.8, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" as const}}>
          {actual.titulo || ""}{n > 1 ? `${actual.titulo ? " · " : ""}${i + 1} de ${n}` : ""}
        </span>
        <button onClick={(ev)=>{ ev.stopPropagation(); onCerrar(); }} aria-label="Cerrar" style={btn}>×</button>
      </div>
      <div onClick={(ev)=>ev.stopPropagation()}
        style={{flex:1, minHeight:0, display:"flex", alignItems:"center", justifyContent:"center", gap:10, marginTop:10}}>
        {n > 1 && <button onClick={()=>ir(-1)} aria-label="Anterior" style={btn}>‹</button>}
        {actual.tipo === "video" ? (
          // SE REPRODUCE AQUI, no en otra pestaña. `controls` da play, barra y
          // pantalla completa; `playsInline` evita que iOS se lo lleve a su
          // reproductor a pantalla completa sin avisar. Si el navegador no sabe
          // decodificar ese formato, enseña su propio aviso y el enlace de abajo
          // sigue estando para abrirlo o descargarlo: no se queda en negro.
          <video src={actual.url} controls playsInline preload="metadata"
            style={{maxWidth:"100%", maxHeight:"100%", borderRadius:10, display:"block", background:"#000"}}/>
        ) : (
          <img src={actual.url} alt={actual.titulo || `Imagen ${i + 1}`}
            style={{maxWidth:"100%", maxHeight:"100%", objectFit:"contain" as const, borderRadius:10, display:"block"}}/>
        )}
        {n > 1 && <button onClick={()=>ir(1)} aria-label="Siguiente" style={btn}>›</button>}
      </div>
      {/* Abrir en pestaña sigue estando, para descargar o imprimir: se quita el
          paso obligatorio, no la posibilidad. */}
      <div style={{textAlign:"center" as const, marginTop:10, flexShrink:0}}>
        <a href={actual.url} target="_blank" rel="noopener noreferrer" onClick={(ev)=>ev.stopPropagation()}
          style={{color:"rgba(255,255,255,0.62)", fontSize:11.5, textDecoration:"underline"}}>
          Abrir en una pestaña
        </a>
      </div>
    </div>
  );
}

// LA TIRA DE MINIATURAS, también una sola vez. Las dos pantallas que enseñaban
// fotos tenían su propia copia de este bloque, con los mismos 84 px escritos dos
// veces. Ahora abren el visor en lugar de una pestaña.
function TiraMiniaturas({ imagenes, titulo }: { imagenes: {url:string; titulo?:string; tipo?:"imagen"|"video"}[]; titulo?:string }) {
  const [abierto, setAbierto] = useState<number|null>(null);
  if (!imagenes.length) return null;
  return (
    <div style={{marginTop:14}}>
      {!!titulo && (
        <div style={{fontSize:11, fontWeight:700, color:"#9A9AAA", textTransform:"uppercase" as const,
          letterSpacing:"0.5px", marginBottom:8}}>{titulo}</div>
      )}
      <div style={{display:"flex", flexWrap:"wrap" as const, gap:8}}>
        {imagenes.map((im, i) => (
          <button key={i} type="button" onClick={()=>setAbierto(i)}
            aria-label={`Ver ${im.tipo === "video" ? "video" : "imagen"} ${i + 1} de ${imagenes.length}`}
            style={{display:"block", width:84, height:84, borderRadius:10, overflow:"hidden", padding:0, position:"relative" as const,
              border:"1px solid rgba(0,0,0,0.12)", cursor:"pointer", background:"transparent"}}>
            {im.tipo === "video" ? (
              // Un video no tiene miniatura sin descargarlo entero, asi que se
              // enseña lo que SI se sabe: que es un video y que se puede tocar.
              <span style={{display:"flex", width:"100%", height:"100%", alignItems:"center", justifyContent:"center",
                background:"#0B1829", color:"#D4A843", fontSize:26}}>▶</span>
            ) : (
              <img src={im.url} alt={im.titulo || `Imagen ${i + 1}`}
                style={{width:"100%", height:"100%", objectFit:"cover" as const, display:"block"}}/>
            )}
          </button>
        ))}
      </div>
      {abierto !== null && (
        <VisorImagenes imagenes={imagenes} indice={abierto} onCerrar={()=>setAbierto(null)}/>
      )}
    </div>
  );
}

// Elimina un archivo de Storage por su URL
async function eliminarArchivo(url: string): Promise<void> {
  try {
    const fileRef = ref(storage, url);
    await deleteObject(fileRef);
  } catch (e) { console.warn("No se pudo eliminar archivo:", e); }
}

// ─── PDF desde HTML — convierte un string HTML a PDF de verdad ──────────────
// Algunos forms de contratos (Servicios Profesionales, Arrendamiento de
// Vivienda, Servicio Doméstico, Contrato de Trabajo) construyen el contenido
// del contrato como un string HTML enriquecido en lugar de usar jsPDF nativo
// con `doc.text()` celda a celda. Históricamente el HTML se descargaba como
// archivo .html — eso impedía subirlo a Storage como PDF y por lo tanto
// rompía el panel "Guardar y vincular".
//
// IMPORTANTE — uso iframe en lugar de innerHTML en un <div>: cuando se hace
// `div.innerHTML = "<!DOCTYPE html>...<head><style>...</style></head><body>..."`,
// el parser HTML descarta los wrappers html/head/body y los estilos del
// <style> que dependían de selectores body { ... } no se aplican al
// contenido. Resultado: el PDF salía con header/banner/firmas (que tienen
// clases con estilos propios) pero el cuerpo del contrato (cláusulas en
// <p>/<div class="clausula"> que dependen del font-family/size del body)
// quedaba "invisible" o vacío. El iframe carga el HTML como documento
// completo y respeta el <style>.
//
// Requiere ambos scripts cargados desde index.html:
//   - jspdf 2.5.1 (window.jspdf.jsPDF)
//   - html2canvas 1.4.1 (window.html2canvas)
// ── Identidad en los documentos generados ────────────────────────────────────
// LA REGLA, UNA SOLA, y sustituye a la lista por tipo que había aquí:
//
//   Un documento que el PATRÓN emite a un tercero lleva el membrete del patrón.
//   Un documento que la PLATAFORMA le entrega a él lleva el de AXIS.
//
// Con esa vara: los diecisiete documentos del patrón —contratos, recibo de
// nómina, finiquito, bitácora, registro mensual, flotilla, acta, constancia,
// calendario— se encabezan con su denominación, su RFC y su domicilio (ver
// `membreteDelPatron`) y llevan a AXIS solo en el pie, en letra chica (ver
// `pieDelPatron`). El informe de diagnóstico RegulaMX es el otro lado de la
// regla y conserva la marca de AXIS: no lo emite el patrón, se lo entregamos.
//
// `_axisLogoImgHTML` YA NO LO USA NINGÚN DOCUMENTO. Se conserva porque el logo
// en base64 sigue haciendo falta si alguna vez se imprime algo de la plataforma
// para el propio usuario; si se usa en un documento del patrón, es que la regla
// de arriba se rompió.
function _axisLogoImgHTML(h:number){
  return `<img src="${AXIS_LOGO_FIRMA_B64}" alt="AXIS Legaltech" style="height:${h}px;width:auto;display:block;flex-shrink:0;" onerror="this.style.display='none'"/>`;
}
// Leyenda de AUTORÍA que va al PIE de los contratos (nunca como membrete arriba).
// Va en CADA hoja, incluso suelta: ése es su propósito.
//
// ⚠️ MÉTODO, Y ESTO VALE PARA CUALQUIER TEXTO DE UN PDF DE jsPDF:
// `doc.text()` NO PARTE LÍNEAS. Escribe la cadena en un solo renglón y lo que no
// cabe se sale de la hoja y se corta a media palabra. El código puede tener la
// frase entera y el papel mostrarla partida, así que comprobar que la cadena
// está NO es comprobar nada: hay que GENERAR la hoja y mirarla.
//
// Pasó exactamente eso aquí: esta leyenda tenía 78 caracteres y cabía; se
// sustituyó por una de 226 —unos 250 mm a 7,5 pt, contra 170 mm de ancho útil en
// A4— y salió cortada en las tres hojas de un contrato ya generado.
//
// Por eso NO se pinta con doc.text a secas: se parte antes con
// `doc.splitTextToSize(texto, ancho)`, que devuelve las líneas ya ajustadas al
// ancho real de la hoja. Ver `pintarLeyendaContrato`.
const _LEYENDA_CONTRATO_AXIS = "Documento generado por el usuario mediante la plataforma AXIS Legaltech, a partir de un formato de uso general. La plataforma no es parte de este contrato y su generación no constituye asesoría jurídica sobre el caso concreto.";

// LA LETRA PEQUEÑA DEL "EXPEDIENTE CAPTURADO", en una sola copia. La dicen los dos
// PDF y la vista previa de uno de ellos; escrita tres veces se separaría a la
// tercera edición. Sin acentos ni eñes: jsPDF la imprime con las fuentes estándar,
// que es la razón por la que el resto del archivo escribe "Desempeno".
const NOTA_EXPEDIENTE_CAPTURADO =
  "El expediente capturado cuenta las casillas marcadas en la plataforma; no acredita la existencia ni la validez de los documentos.";

// Pinta la leyenda partida al ancho que se le dé, hacia ARRIBA desde `yBase`:
// así el bloque crece hacia el texto y nunca invade el pie ni el número de
// página, cuantas líneas ocupe. Devuelve la altura usada, en mm.
function pintarLeyendaContrato(doc:any, x:number, yBase:number, ancho:number, alinear?:"center"): number {
  const lineas: string[] = doc.splitTextToSize(_LEYENDA_CONTRATO_AXIS, ancho);
  // EL INTERLINEADO SE PREGUNTA, NO SE ESCRIBE A MANO.
  //
  // Aquí había un 2.6 fijo, con el comentario "interlineado a 7,5 pt". Y 2,6 es la
  // altura de una línea de 7,5 pt EN MILÍMETROS. Los siete contratos que se dibujan
  // en milímetros salían bien, y por eso nadie lo vio; pero generarPDFDesdeHTML
  // —el que produce el de Servicios Profesionales y otros tres— crea el documento
  // en PUNTOS, y ahí 2,6 no es una línea: es menos de un tercio de línea. Los dos
  // renglones de la leyenda se imprimían casi encima uno del otro, y el papel se
  // leía cortado en "su generación no", que es justo donde parte el primero.
  //
  // Una función que se usa desde dos documentos con unidades distintas no puede
  // llevar la unidad escrita dentro. getTextDimensions devuelve el alto en las
  // unidades del documento que se le pasa, así que la misma cuenta vale para los
  // dos sin que esta función tenga que saber en cuál está.
  const alto = doc.getTextDimensions("Hg").h * 1.15;
  lineas.forEach((ln:string, i:number) => {
    const y = yBase - (lineas.length - 1 - i) * alto;
    if (alinear === "center") doc.text(ln, x, y, {align:"center"});
    else doc.text(ln, x, y);
  });
  return lineas.length * alto;
}
// Logo suelto para membrete de GESTIÓN en jsPDF nativo (dibuja el logo; el caller
// mantiene su propio cursor). Defensivo: si falla, no truena y sigue sin logo.
//
// YA NO LO USA NINGÚN DOCUMENTO, igual que `_axisLogoImgHTML`. Sus dos últimos
// llamadores eran el Resumen general del equipo y el Reporte individual, que se
// habían saltado la regla de arriba y llevaban el logo del despacho en la cabecera
// de un documento del patrón. Se conserva por el mismo motivo que el otro: si algún
// día se imprime algo de la plataforma PARA el usuario, aquí está. Si vuelve a
// aparecer en un documento del patrón, es que la regla se rompió otra vez.
function _axisLogoJsPDF(doc:any, x:number, y:number, size:number){
  try { doc.addImage(AXIS_LOGO_FIRMA_B64, "PNG", x, y, size, size); } catch(e){}
}

// ── WhatsApp de contacto del PATRÓN ──────────────────────────────────────────
// Se guarda en su propio doc (usuarios/{uid}.whatsapp) y se PROPAGA a las cuentas
// de sus trabajadores (cuentas_trabajador.empleadorWhatsapp). La propagación es
// necesaria porque usuarios/{uid} NO es legible por el trabajador, y su propio doc
// de cuentas_trabajador SÍ lo es. El patrón ya es dueño de esos docs
// (empleadorId == uid) → NO requiere cambios en firestore.rules.
async function guardarWhatsappPatron(uid:string, valor:string): Promise<void> {
  await updateDoc(doc(db,"usuarios",uid), { whatsapp: valor });
  // Propagación best-effort: si falla, el número igual quedó guardado en el perfil.
  try {
    const snap = await getDocs(query(collection(db,"cuentas_trabajador"), where("empleadorId","==",uid)));
    await Promise.all(snap.docs.map(d => setDoc(doc(db,"cuentas_trabajador", d.id), { empleadorWhatsapp: valor }, { merge:true })));
  } catch(e){ console.error("propagar whatsapp a cuentas_trabajador:", e); }
}

// ── SISTEMA VISUAL DEL ÁREA DE TRABAJO (solo ESCRITORIO) ────────────────────
// Tokens centralizados: Empleados es la pantalla de referencia y el resto los
// hereda sin duplicar. Todos los tonos de TEXTO se eligieron midiendo contraste
// real (WCAG AA ≥ 4.5:1 sobre blanco) — los anteriores reprobaban:
//   textInkMut #7A8499 → 3.76 · success #059669 → 3.77 · warn #D97706 → 3.19
//
// FONDO — DECIDIDO: neutro FRÍO. Separación blanco/fondo 1.19.
// (La alternativa cálida evaluada era #EFEBE3 con bordes #DCD6CA / divisor #EBE6DC
//  / hover #FAF8F4; se descartó. Queda anotada por si algún día se reconsidera.)
const UI_FONDO   = "#E8ECF2";
const UI_BORDE   = "#D3DAE6";
const UI_DIVISOR = "#E4E9F1";
const UI_HOVER   = "#F5F7FA";

const UI = {
  fondo: UI_FONDO,
  superficie: "#FFFFFF",
  hover: UI_HOVER,
  borde: UI_BORDE,               // 1.41 sobre blanco: por fin se despega
  divisor: UI_DIVISOR,
  navy: "#162447",               // estructural: encabezado de tabla, filtro activo, filetes
  navySuave: "#233459",
  // ORO: se usa como RELLENO con texto oscuro encima (el botón de la acción
  // principal) o como filete de marca. NUNCA como color de TEXTO sobre
  // superficie clara: da 2.90 contra blanco y el texto pide 4.5. Si hace falta
  // una afordancia legible sobre claro, va en navy.
  oro: "#B8932A",                // 2.90 sobre blanco → relleno, no texto.
                                 // Nunca como texto pequeño: 2.90 sobre blanco, reprueba.
  texto: "#162447",              // 15.25 AA
  textoSuave: "#3D4B6B",         //  8.69 AA
  textoTenue: "#5B6784",         //  5.65 AA  (sustituye al #7A8499 ilegible)
  ok: "#0F7A52",                 //  5.35 AA
  okBg: "rgba(15,122,82,0.10)",
  ambar: "#9A5B00",              //  5.43 AA
  ambarBg: "rgba(154,91,0,0.10)",
  rojo: "#B3261E",               //  6.54 AA
  rojoBg: "rgba(179,38,30,0.10)",
  neutro: "#5B6784",
  neutroBg: "rgba(91,103,132,0.10)",
  // ── TONO OSCURO PARA TEXTO, TONO VIVO PARA GRÁFICOS ───────────────────────
  // Los de arriba se oscurecieron para que el TEXTO pasara AA sobre blanco. En
  // un filete de 3px o una barra de progreso eso juega en contra: la exigencia
  // ahí no es de lectura sino de distinguirse de los colores vecinos, y contra
  // el navy del encabezado los oscuros se pierden (ámbar 2.81, rojo 2.33).
  // Estos vivos suben esa distancia (ámbar 4.79, rojo 3.16, verde 4.05) y
  // siguen pasando el 3:1 que WCAG pide a elementos gráficos sobre blanco.
  // Regla: texto y chips → oscuro. Filetes, barras e iconos → vivo.
  okVivo: "#059669",
  ambarVivo: "#D97706",
  rojoVivo: "#DC2626",
  sombra: "0 1px 2px rgba(22,36,71,0.06), 0 8px 24px rgba(22,36,71,0.07)",
  sombraHov: "0 2px 6px rgba(22,36,71,0.10), 0 14px 34px rgba(22,36,71,0.12)",
  rPanel: 12, rTarjeta: 10, rControl: 8, rChip: 999,
  fsNum: 30, fsNombre: 14.5, fsCuerpo: 13, fsEtiqueta: 11.5, fsRotulo: 11,
};
// ── ZONA RESERVADA A LOS FLOTANTES (escritorio) ─────────────────────────────
// El lanzador de AXIOR se pinta fuera del flujo, pegado al borde. Mientras el
// contenido era angosto cabía en el margen muerto; con el contenido a todo lo
// ancho ya no hay margen que le sobre, así que se monta sobre la última fila de
// las tablas y sobre lo que quede pegado al borde derecho.
// La regla general: el flotante vive SIEMPRE dentro de esta franja al pie, y el
// contenedor de contenido reserva esa franja. Así ninguna pantalla —presente o
// futura— tiene que acordarse del búho.
const FLOTANTE_ALTO = 115;      // alto del lanzador en escritorio
const ZOCALO_FLOTANTES = 150;   // franja inferior reservada (lanzador + aire)
// Techo del flotante: por encima de esto ya estaría invadiendo el contenido.
const flotanteBottomMax = (movil:boolean) =>
  movil ? Math.max(8, window.innerHeight - 80) : Math.max(8, ZOCALO_FLOTANTES - FLOTANTE_ALTO);
// Altura de apilamiento del flotante: por ENCIMA de todo el contenido de página
// (que no pasa de 100) y por DEBAJO de cualquier ventana modal (que arranca en
// 200). Así el búho nunca queda encima de los botones de un modal.
const Z_FLOTANTE = 190;
// Filas que se dibujan de golpe en un listado que crece sin techo (los recibos
// se acumulan cada quincena). No limita lo que se lee de Firestore —eso se lee
// completo— sino cuántos nodos se pintan a la vez.
const HISTORIAL_POR_TANDA = 100;
// ── AVATAR DE PERSONA (iniciales + color determinista) ──────────────────────
// Dos letras: primer nombre + primer apellido. Con 4 palabras o más asumimos
// nombre compuesto + dos apellidos ("Miguel Ángel Soto Rivas" → MS) y tomamos la
// penúltima; con 3 el patrón dominante es nombre + paterno + materno, así que
// vale la segunda ("Carlos Ruvalcaba Díaz" → CR). Sin campos separados de nombre
// y apellidos el caso de 3 palabras es genuinamente ambiguo ("María Fernanda
// López" da MF): no se intenta adivinar más, el color del avatar desambigua.
const inicialesDe = (nombre:string):string => {
  const p = String(nombre||"").trim().split(/\s+/).filter(Boolean);
  if (p.length === 0) return "?";
  const a = p[0][0] || "";
  const iApellido = p.length >= 4 ? p.length - 2 : 1;
  const b = p.length > 1 ? (p[iApellido][0] || "") : "";
  return (a + b).toUpperCase();
};
// Color derivado del nombre COMPLETO: dos personas con las mismas iniciales se
// distinguen, y el mismo nombre siempre da el mismo color. Paleta deliberadamente
// NEUTRA (navy/pizarra): usar semánticos haría leer un estado que no existe.
const AVATAR_TONOS = ["#162447","#2C3E5C","#3D4B6B","#4A5568","#5B6784","#33445E","#414F6E","#26354F"];
const colorAvatar = (nombre:string):string => {
  const s = String(nombre||"");
  let h = 0;
  for (let i=0;i<s.length;i++) h = (h*31 + s.charCodeAt(i)) >>> 0;
  return AVATAR_TONOS[h % AVATAR_TONOS.length];
};

// Traduce un color de TEXTO a su equivalente para GRÁFICOS. Las pantallas
// siguen pasando UI.ok / UI.ambar / UI.rojo —el vocabulario no cambia— y las
// piezas del molde convierten al vivo donde el color es un filete o una barra.
// Lo que no es semántico (navy, neutro) se queda igual: ya se distingue.
const tonoGrafico = (color:string):string =>
  color===UI.ok ? UI.okVivo : color===UI.ambar ? UI.ambarVivo : color===UI.rojo ? UI.rojoVivo : color;

// Chip de estado con la paleta semántica (un solo lugar para toda la plataforma).
// Cuatro tonos: ok / pendiente / critico / neutro. `ambar` y `rojo` se conservan
// como sinónimos de los dos de en medio para no romper llamados existentes.
type TonoEstado = "ok"|"pendiente"|"critico"|"neutro"|"ambar"|"rojo";
const chipUI = (texto:string, tono:TonoEstado) => {
  const c = tono==="ok" ? {t:UI.ok,b:UI.okBg}
          : (tono==="pendiente"||tono==="ambar") ? {t:UI.ambar,b:UI.ambarBg}
          : (tono==="critico"||tono==="rojo") ? {t:UI.rojo,b:UI.rojoBg}
          : {t:UI.neutro,b:UI.neutroBg};
  return { texto, style:{ fontSize:10.5, fontWeight:700, color:c.t, background:c.b,
    border:`1px solid ${c.t}33`, padding:"2px 9px", borderRadius:UI.rChip, whiteSpace:"nowrap" as const } };
};
// Misma pieza en versión componente, para no repetir el <span> en cada pantalla.
function ChipEstado({texto, tono, title}:{texto:string; tono:TonoEstado; title?:string}) {
  const c = chipUI(texto, tono);
  return <span title={title} style={c.style}>{c.texto}</span>;
}

// Avatar de persona: si algún día hay foto se muestra la foto; si no, iniciales
// sobre el color determinista. Preparado para `fotoUrl` sin cambiar los llamados.
function AvatarPersona({nombre, fotoUrl, size=34, fontSerif}:{
  nombre:string; fotoUrl?:string|null; size?:number; fontSerif:string;
}) {
  const tono = colorAvatar(nombre);
  if (fotoUrl) return (
    <img src={fotoUrl} alt={nombre}
      style={{width:size, height:size, borderRadius:"50%", objectFit:"cover" as const, flexShrink:0,
        border:`1px solid ${tono}33`, display:"block"}}/>
  );
  return (
    <span style={{width:size, height:size, borderRadius:"50%", flexShrink:0, background:`${tono}14`,
      border:`1px solid ${tono}33`, color:tono, fontFamily:fontSerif, fontWeight:700,
      fontSize:Math.round(size*0.38), letterSpacing:"0.5px",
      display:"flex", alignItems:"center", justifyContent:"center"}}>
      {inicialesDe(nombre)}
    </span>
  );
}

// Estado vacío REUTILIZABLE: una frase que explica y botones que dicen qué hacer.
// Dos variantes de uso: SIN DATOS (la cuenta aún no tiene nada: el texto invita a
// crear) y SIN COINCIDENCIAS (hay datos pero el filtro no devuelve nada: el texto
// invita a quitar filtros). Hoy las dos se dibujan igual; lo único que cambia es
// lo que la pantalla pasa en `titulo`, `texto` y `acciones`.
// SIN DATOS lleva el icono de la entidad; SIN COINCIDENCIAS lleva lupa: no son
// la misma situación —una invita a crear y la otra a limpiar el filtro— y por
// eso no llevan la misma señal. `icono` deja que cada pantalla ponga el suyo.
function EstadoVacio({titulo, texto, acciones, icono, variante="sin-datos", fontSans, fontSerif}:{
  titulo:string; texto:string;
  acciones:{t:string; principal:boolean; fn:()=>void}[];
  icono?:string; variante?:"sin-datos"|"sin-coincidencias";
  fontSans:string; fontSerif:string;
}) {
  const iconoFinal = icono || (variante==="sin-coincidencias" ? "search" : "suite_empleados");
  return (
    <div style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rPanel, boxShadow:UI.sombra,
      padding:"48px 32px", textAlign:"center" as const, fontFamily:fontSans}}>
      <div style={{width:56, height:56, margin:"0 auto 16px", borderRadius:"50%", background:`${UI.navy}0D`,
        border:`1px solid ${UI.navy}1F`, display:"flex", alignItems:"center", justifyContent:"center"}}>
        <AxisIcon name={iconoFinal} size={26} color={UI.navy} withBackdrop={false} strokeWidth={1.9}/>
      </div>
      <div style={{fontFamily:fontSerif, fontSize:19, fontWeight:700, color:UI.texto, marginBottom:8}}>{titulo}</div>
      <div style={{fontSize:UI.fsCuerpo, color:UI.textoSuave, lineHeight:1.65, maxWidth:520, margin:"0 auto 22px"}}>{texto}</div>
      <div style={{display:"flex", gap:10, justifyContent:"center", flexWrap:"wrap" as const}}>
        {acciones.map((a,i)=> a.principal ? (
          <BotonPrimario key={i} texto={a.t} onClick={a.fn} fontSans={fontSans} tamano="grande"/>
        ) : (
          <button key={i} onClick={a.fn}
            style={{background:UI.superficie, color:UI.navy, border:`1px solid ${UI.navy}40`, borderRadius:UI.rControl, padding:"11px 20px", fontSize:UI.fsEtiqueta, fontWeight:700, cursor:"pointer", fontFamily:fontSans}}>
            {a.t}
          </button>
        ))}
      </div>
    </div>
  );
}

// ── MOLDE VISUAL REUTILIZABLE (solo ESCRITORIO) ─────────────────────────────
// Piezas extraídas de Empleados para que el resto de las pantallas las herede.
// Ninguna trae lógica de negocio: reciben datos ya calculados y los dibujan.

// INDICADOR: filete superior de color, icono en cuadro tintado, etiqueta, cifra
// destacada y micro-contexto. `valor` es TEXTO ya formateado, no un número: eso
// es lo que permite el caso "sin dato" ("Sin registrar") sin fingir un cero. El
// cuerpo se achica solo cuando el valor trae letras, para no romper la retícula.
// `pct` dibuja la barra; en null (sin dato) no se dibuja.
// El realce al pasar el cursor vive AQUÍ DENTRO y no en una clase que cada
// pantalla tenga que acordarse de declarar: la pieza se ve bien sola.
// ACCIONABLE (opcional): si recibe `onAccion`, la tarjeta entera se vuelve un
// control —puntero, realce, foco de teclado, Enter/Espacio— y avisa que la
// pulsaron. NO sabe a dónde lleva: quien la usa decide el destino, así que la
// misma pieza sirve en cualquier pantalla. Con la cifra en cero o sin dato se
// apaga y deja de ser pulsable: no se manda a nadie a una tabla vacía.
// `activo` es la marca discreta de que su filtro es el que está aplicado.
// `nota` (opcional): la letra pequeña de un número que podría leerse como más de
// lo que es. Va DEBAJO del micro, en el tono más apagado, y solo aparece si se
// pasa: las tarjetas que no la necesitan no cambian.
function IndicadorTarjeta({etiqueta, valor, icono, tono, micro, nota, pct, isMobile, fontSerif, onAccion, activo}:{
  etiqueta:string; valor:string; icono:string; tono:string;
  micro?:string; nota?:string; pct?:number|null; isMobile:boolean; fontSerif:string;
  onAccion?:()=>void; activo?:boolean;
}) {
  const [hov, setHov] = useState(false);
  const g = tonoGrafico(tono);
  // Cero, vacío o "Sin registrar" → no hay nada que ir a ver.
  const _n = Number(String(valor).replace(/[^0-9.-]/g, ""));
  const hayDato = Number.isFinite(_n) && _n > 0;
  const pulsable = !!onAccion && hayDato;
  const activar = () => { if (pulsable) onAccion!(); };
  return (
    <div
      onMouseEnter={()=>setHov(true)} onMouseLeave={()=>setHov(false)}
      onClick={activar}
      role={pulsable ? "button" : undefined}
      tabIndex={pulsable ? 0 : undefined}
      aria-pressed={pulsable ? !!activo : undefined}
      onKeyDown={pulsable ? (e:any)=>{ if(e.key==="Enter" || e.key===" "){ e.preventDefault(); activar(); } } : undefined}
      style={{background:UI.superficie, border:`1px solid ${activo ? UI.navy+"66" : UI.borde}`, borderRadius:UI.rTarjeta,
      borderTop:`3px solid ${g}`, padding:"14px 16px", boxShadow:UI.sombra,
      transition:"all 0.35s cubic-bezier(0.34, 1.56, 0.64, 1)",
      cursor: pulsable ? "pointer" : "default",
      opacity: (onAccion && !hayDato) ? 0.62 : 1,
      WebkitTapHighlightColor: "transparent",
      ...(activo ? {boxShadow:`${UI.sombra}, inset 0 0 0 1px ${UI.navy}22`} : {}),
      ...(pulsable && hov ? {borderColor:"rgba(184,147,42,0.4)", transform:"translateY(-3px)",
                 boxShadow:"0 6px 18px rgba(184,147,42,0.15)"} : {})}}>
      <div style={{display:"flex", alignItems:"center", gap:9, marginBottom:10}}>
        <span style={{width:30, height:30, borderRadius:UI.rControl, background:`${g}14`, border:`1px solid ${g}33`,
          display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0}}>
          <AxisIcon name={icono} size={15} color={g} withBackdrop={false} strokeWidth={2.4}/>
        </span>
        <div style={{fontSize:UI.fsRotulo, color:UI.textoTenue, textTransform:"uppercase" as const, letterSpacing:"0.5px", fontWeight:700, lineHeight:1.2}}>{etiqueta}</div>
      </div>
      <div style={{fontFamily:fontSerif, fontSize: /[A-Za-zÁÉÍÓÚÑáéíóúñ]/.test(valor) ? (isMobile?16:19) : (isMobile?22:UI.fsNum),
        color:UI.texto, fontWeight:700, lineHeight:1.05}}>{valor}</div>
      {pct!=null && (
        <div style={{height:5, background:UI.divisor, borderRadius:999, overflow:"hidden", marginTop:8}}>
          <div style={{height:"100%", width:`${Math.max(0,Math.min(100,pct))}%`, background:g, borderRadius:999}}/>
        </div>
      )}
      <div style={{fontSize:10.5, color:UI.textoTenue, marginTop:6, lineHeight:1.35, display:"flex", alignItems:"center", gap:6}}>
        <span style={{minWidth:0}}>{micro}</span>
        {pulsable && <span style={{color:UI.navy, fontWeight:700, flexShrink:0}}>{activo ? "· filtrando" : "· ver ›"}</span>}
      </div>
      {nota && (
        <div style={{fontSize:9.5, color:UI.textoTenue, opacity:0.78, marginTop:3, lineHeight:1.35, fontStyle:"italic" as const}}>
          {nota}
        </div>
      )}
    </div>
  );
}

// SEGMENTADO: filtra, no navega. El seleccionado va en navy sólido.
function SegmentadoFiltro<T extends string>({opciones, valor, onCambio, fontSans}:{
  opciones:{v:T; t:string}[]; valor:T; onCambio:(v:T)=>void; fontSans:string;
}) {
  return (
    <div style={{display:"inline-flex", background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rControl, padding:2, gap:2}}>
      {opciones.map(o => {
        const on = valor===o.v;
        return (
          <button key={o.v} onClick={()=>onCambio(o.v)}
            style={{padding:"7px 14px", borderRadius:6, border:"none", cursor:"pointer", fontSize:UI.fsEtiqueta, fontWeight:on?800:600,
              background: on?UI.navy:"transparent", color: on?"#FFFFFF":UI.textoSuave, fontFamily:fontSans, transition:"all .15s"}}>
            {o.t}
          </button>
        );
      })}
    </div>
  );
}

// BOTÓN PRIMARIO (dorado): UNA sola acción principal por pantalla.
// Dos tamaños: "normal" para la barra de acciones y "grande" para el que va
// dentro de un estado vacío, donde es lo único en pantalla y pide más presencia.
function BotonPrimario({texto, onClick, fontSans, className, tamano="normal"}:{
  texto:string; onClick:()=>void; fontSans:string; className?:string; tamano?:"normal"|"grande";
}) {
  return (
    <button className={className} onClick={onClick}
      style={{background:UI.oro, color:"#0B1829", borderRadius:UI.rControl,
        padding: tamano==="grande" ? "11px 20px" : "9px 18px", fontSize:UI.fsEtiqueta,
        fontWeight:800, border:"none", cursor:"pointer", whiteSpace:"nowrap" as const, fontFamily:fontSans,
        boxShadow:"0 2px 10px rgba(184,147,42,0.30)"}}>
      {texto}
    </button>
  );
}

// BOTÓN SECUNDARIO (contorno navy + icono): ejecuta, pero no es LA acción.
function BotonSecundario({texto, onClick, icono, title, fontSans}:{
  texto:string; onClick:()=>void; icono?:string; title?:string; fontSans:string;
}) {
  return (
    <button onClick={onClick} title={title}
      style={{display:"inline-flex", alignItems:"center", gap:7, background:UI.superficie, color:UI.navy, borderRadius:UI.rControl,
        padding:"8px 14px", fontSize:UI.fsEtiqueta, fontWeight:700, border:`1px solid ${UI.navy}40`, cursor:"pointer",
        whiteSpace:"nowrap" as const, fontFamily:fontSans}}>
      {icono && <AxisIcon name={icono} size={14} color={UI.navy} withBackdrop={false} strokeWidth={2.4}/>}{texto}
    </button>
  );
}

// ENCABEZADO DE TABLA: navy, fijo al hacer scroll, con indicador de orden. La
// columna ordenable alterna dirección; al cambiar de columna arranca en "asc".
type ColumnaTabla = {k:string; t:string; orden?:boolean; al?:"left"|"right"|"center"};
function EncabezadoTabla({columnas, ordenCol, ordenDir, onOrdenar}:{
  columnas:ColumnaTabla[]; ordenCol:string; ordenDir:"asc"|"desc";
  onOrdenar:(col:string, dir:"asc"|"desc")=>void;
}) {
  return (
    <thead>
      <tr>
        {columnas.map(c=>{
          const activa = !!c.orden && ordenCol===c.k;
          return (
            <th key={c.k}
              onClick={c.orden ? ()=>onOrdenar(c.k, activa ? (ordenDir==="asc"?"desc":"asc") : "asc") : undefined}
              style={{position:"sticky" as const, top:0, zIndex:2, background:UI.navy, color:"#FFFFFF",
                textAlign:(c.al||"left") as any, padding:"11px 14px", fontSize:UI.fsRotulo, fontWeight:700,
                textTransform:"uppercase" as const, letterSpacing:"0.6px", whiteSpace:"nowrap" as const,
                cursor:c.orden?"pointer":"default", userSelect:"none" as const}}>
              {c.t}
              {c.orden && <span style={{marginLeft:6, opacity:activa?1:0.35, fontSize:9}}>{activa ? (ordenDir==="asc"?"▲":"▼") : "▲"}</span>}
            </th>
          );
        })}
      </tr>
    </thead>
  );
}

// PLEGABLE con preferencia recordada. La decisión explícita del usuario manda;
// mientras no la haya, la pantalla decide con `abiertoSinPreferencia` (p. ej.
// abierto sólo si la cuenta está vacía). La preferencia vive por navegador.
function usarPlegable(clave:string, abiertoSinPreferencia:boolean): [boolean, ()=>void] {
  const [pref, setPref] = useState<string|null>(()=>{
    try { return localStorage.getItem(clave); } catch { return null; }
  });
  const abierto = pref ? pref==="abierta" : abiertoSinPreferencia;
  const alternar = () => {
    const n = abierto ? "cerrada" : "abierta";
    try { localStorage.setItem(clave, n); } catch(e) {}
    setPref(n);
  };
  return [abierto, alternar];
}

// Tira "▾ título" que abre y cierra el bloque explicativo.
function TiraPlegable({abierto, texto, onAlternar, fontSans}:{
  abierto:boolean; texto:string; onAlternar:()=>void; fontSans:string;
}) {
  return (
    <button onClick={onAlternar}
      style={{display:"inline-flex", alignItems:"center", gap:7, background:"transparent", border:"none",
        color:UI.textoTenue, fontSize:UI.fsEtiqueta, fontWeight:700, cursor:"pointer", fontFamily:fontSans, padding:"2px 0"}}>
      {abierto ? "▾" : "▸"} {texto}
    </button>
  );
}

// ── ANCHO DEL CONTENIDO (solo ESCRITORIO) ───────────────────────────────────
// Antes cada pantalla declaraba su propio maxWidth (de 700 a 1200), lo que dejaba
// franjas muertas a los lados y apretaba el contenido en el centro. Ahora el ancho
// se define UNA sola vez aquí y las secciones lo heredan.
//
// ANCHO_CONTENIDO = 1680: el área útil en un monitor de 1920 es 1920 − 232 (sidebar)
// = 1688 px, así que 1680 la llena casi exacta sin margen muerto; en pantallas más
// chicas (1280/1440) el contenedor simplemente ocupa todo el ancho disponible. El
// tope evita que en un ultrawide (2560+) la interfaz se estire de forma absurda.
//
// ANCHO_LECTURA = 820: el texto corrido NO debe heredar el ancho completo — una
// línea de punta a punta es incómoda de leer. Los párrafos largos, avisos y notas
// legales se acotan a esta medida aunque el contenedor sea mucho más ancho.
const ANCHO_CONTENIDO = 1680;
const ANCHO_LECTURA = 820;

// ── SALARIO: conversión centralizada mensual↔diario ────────────────────────────
// Factor = 30 por Art. 89 LFT: "Cuando el salario se fije por semana o por mes, se
// dividirá entre siete o entre treinta, según el caso, para determinar el salario
// diario." (antes se usaba 30.4). TODO cálculo/display de conversión pasa por aquí;
// no debe quedar ningún 30/30.4 mágico disperso.
// OJO: 30.4375 (365.25/12) SIGUE siendo correcto para contar MESES de antigüedad —
// eso no es salario y no debe pasar por estos helpers.
// Viven aquí arriba, antes que cualquier módulo, para que la Calculadora LFT, los
// contratos, Nómina y el expediente consuman EXACTAMENTE el mismo factor.
const DIAS_MES_LFT = 30;
const mensualADiario = (m:number)=> (Number(m)||0) / DIAS_MES_LFT;
const diarioAMensual = (d:number)=> (Number(d)||0) * DIAS_MES_LFT;
const _round2 = (n:number)=> Math.round((Number(n)||0)*100)/100;
// Lectura tolerante con datos LEGADO (empleados guardados solo con el diario viejo):
// diario -> usa salarioDiario (existe en viejo y nuevo).
// mensual -> usa salarioMensual guardado; si no existe, deriva del diario (×30).
const salDiarioDe = (t:any)=> Number(t?.salarioDiario)||0;
const salMensualDe = (t:any)=> (t?.salarioMensual!=null && Number(t.salarioMensual)>0)
  ? Number(t.salarioMensual)
  : diarioAMensual(Number(t?.salarioDiario)||0);
const fmtMXN2 = (n:number)=> "$"+(Number(n)||0).toLocaleString("es-MX",{minimumFractionDigits:2, maximumFractionDigits:2});

// ─── REGLAS DE PAGINACIÓN DEL PDF ───────────────────────────────────────────
// Los números que deciden dónde se parte un documento viven aquí, con nombre y
// con su razón. Una cifra suelta dentro del cálculo no se puede discutir ni
// ajustar: hay que descubrirla leyendo el código y adivinar qué la justificaba.

// Cuánto tiene que llenarse una hoja para aceptar un corte de BLOQUE —el inicio
// de una sección, una cláusula, una fila—. Cortar entre bloques deja el
// documento con sus piezas enteras y es lo preferible, pero solo si aprovecha la
// hoja: media hoja en blanco a mitad de un contrato se lee como si faltara algo,
// y quien lo recibe no tiene forma de saber que no falta. Por debajo de este
// llenado se prefiere cortar entre renglones, que llena la hoja sin partir nada.
const PDF_LLENADO_MIN_BLOQUE = 0.72;

// Lo mismo para un corte de RENGLÓN, que es la red de seguridad: se acepta más
// arriba porque la alternativa es no cortar en ningún sitio seguro y partir una
// línea por la mitad. Una hoja al cuarto es fea; un renglón cortado es un error.
const PDF_LLENADO_MIN_LINEA = 0.25;

// Puntos de contenido que deben viajar CON el bloque de firmas. Una hoja de
// firmas sola se puede desprender de un documento probatorio, o se le puede
// sustituir el cuerpo; con contenido delante, la hoja se reconoce como parte del
// documento que acredita. 90 pt son unas seis líneas de texto.
const PDF_ACOMPANAMIENTO_FIRMAS = 90;

// Alto reservado arriba para el encabezado de continuación, cuando aun así la
// hoja de firmas queda con poco contenido delante: dos renglones en letra chica.
const PDF_ALTO_CONTINUACION = 26;

// Banda inferior reservada para la numeración de página en los documentos que no
// son contrato. Sin ella el contenido se pegaría al "Página X de Y".
const PDF_BANDA_PIE = 26;

// Márgenes del MODO CONTRATO: más generosos arriba y abajo porque ahí el pie
// lleva dos líneas —la leyenda de que AXIS solo redactó el documento, y los
// datos con el número de hoja—.
const PDF_CONTRATO_MARGEN_SUP = 46;
const PDF_CONTRATO_MARGEN_INF = 62;

// Aire que se deja bajo la última línea del documento antes de dar por terminado
// el alto: sin él, el descendente de una "g" o una "p" puede quedar rozando el
// borde del recorte.
const PDF_AIRE_FINAL = 6;

async function generarPDFDesdeHTML(htmlString: string, fname: string, opts?: {save?: boolean; pieContrato?: boolean; pieTexto?: string}): Promise<Blob> {
  const html2canvas = (window as any).html2canvas;
  const jsPDFLib = (window as any).jspdf;
  if (!html2canvas) throw new Error("html2canvas no cargado todavía");
  if (!jsPDFLib?.jsPDF) throw new Error("jsPDF no cargado todavía");

  // 1) Crear iframe oculto fuera de pantalla, ancho ~letter @ 96dpi.
  const iframe = document.createElement("iframe");
  iframe.style.position = "absolute";
  iframe.style.left = "-99999px";
  iframe.style.top = "0";
  iframe.style.width = "816px";
  iframe.style.height = "100px";   // se ajusta tras render
  iframe.style.border = "0";
  iframe.style.background = "#ffffff";
  document.body.appendChild(iframe);

  try {
    const idoc = iframe.contentDocument || iframe.contentWindow?.document;
    if (!idoc) throw new Error("No se pudo acceder al documento del iframe");

    // 2) Escribir el HTML completo dentro del iframe. document.write parsea
    //    correctamente <html>/<head>/<body> y aplica el <style> del template.
    idoc.open();
    idoc.write(htmlString);
    idoc.close();

    // El HTML original incluye `<script>window.onload = () => window.print();</script>`
    // — lo removemos para que NO dispare el diálogo de impresión del navegador.
    idoc.querySelectorAll("script").forEach(s => s.remove());

    // 3) Esperar a que el render del iframe termine. Two tick + fonts.
    await new Promise(r => setTimeout(r, 120));
    if ((idoc as any).fonts?.ready) {
      try { await (idoc as any).fonts.ready; } catch {}
    }

    const body = idoc.body;
    // Forzar background blanco por si el template usa transparencia.
    body.style.background = "#ffffff";
    const fullHeight = Math.max(body.scrollHeight, body.offsetHeight, 1100);
    iframe.style.height = fullHeight + "px";

    // 4) Capturar el body del iframe con html2canvas. Pasar windowWidth/Height
    //    explícito ayuda a que el render aplique los media queries y estilos
    //    correctos al alto real del documento.
    const canvas = await html2canvas(body, {
      scale: 2, useCORS: true, backgroundColor: "#ffffff",
      logging: false,
      width: 816, height: fullHeight,
      windowWidth: 816, windowHeight: fullHeight,
    });

    // 5) Pasar el canvas a un PDF multipágina.
    const imgData = canvas.toDataURL("image/jpeg", 0.92);
    const { jsPDF } = jsPDFLib;
    const doc = new jsPDF({orientation:"portrait", unit:"pt", format:"letter"});
    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();
    const margin = 20;
    const imgW = pageW - margin * 2;
    const imgH = (canvas.height * imgW) / canvas.width;

    // ── MEDICIÓN DEL DOCUMENTO, común a los dos modos ─────────────────────
    // Se mide ANTES de decidir cortes y ANTES de elegir modo: las reglas de
    // paginación son del generador, no de cada documento.
    const ptPorCss = imgW / 816;            // el iframe se renderiza a 816 px de ancho
    const canvasPorPt = canvas.height / imgH;

    // DÓNDE TERMINA DE VERDAD EL DOCUMENTO. El iframe se rellena hasta un mínimo
    // de 1100 px de alto, así que debajo del último elemento suele quedar solo
    // blanco. Paginar sobre ese blanco fabrica hojas vacías.
    let ultimoPx = 0;
    Array.from(idoc.body.querySelectorAll("*")).forEach((el:any) => {
      const r = el.getBoundingClientRect();
      if (r.height > 0 && r.width > 0) ultimoPx = Math.max(ultimoPx, r.bottom);
    });
    const altoDoc = ultimoPx > 0
      ? Math.min(imgH, Math.round(ultimoPx * ptPorCss) + PDF_AIRE_FINAL)
      : imgH;

    // EL BLOQUE DE FIRMAS. Un documento probatorio con la hoja de firmas separada
    // del contenido que acredita es un documento al que se le puede desprender la
    // última hoja, o al que se le puede sustituir el cuerpo. Por eso el bloque se
    // mide aparte: no se corta por dentro, y no se le deja empezar una hoja solo.
    // Incluye lo que va pegado a él —la nota de qué acredita la firma y el pie—,
    // porque separar la nota de las líneas sería el mismo problema más pequeño.
    const _firmasEl:any = idoc.querySelector(".firmas");
    let firmas: {top:number; bot:number; alto:number}|null = null;
    if (_firmasEl) {
      const rf = _firmasEl.getBoundingClientRect();
      const notaEl:any = idoc.querySelector(".nota-firma");
      const rn = notaEl ? notaEl.getBoundingClientRect() : null;
      const top = Math.round(Math.min(rf.top, rn ? rn.top : rf.top) * ptPorCss);
      const bot = Math.round(Math.min(altoDoc, rf.bottom * ptPorCss));
      if (bot > top) firmas = {top, bot, alto: bot - top};
    }

    // FRONTERAS EN DOS NIVELES.
    //
    // 1) DE BLOQUE: el borde superior de una sección, una tabla, una fila, un
    //    párrafo. Cortar ahí deja el documento con sus piezas enteras y es lo
    //    preferible... si no desperdicia media hoja.
    // 2) DE LÍNEA: el borde inferior de CADA renglón realmente dibujado, sacado
    //    de los rectángulos de los nodos de texto. Es la red que impide que un
    //    corte caiga por la mitad de un renglón.
    //
    // Antes solo existía el nivel 1, con una lista de etiquetas escrita a mano.
    // Un contrato no usa ninguna de ellas —su cuerpo son <div class="clausula">—,
    // así que se quedaba prácticamente sin fronteras: unas veces el corte caía a
    // media línea por falta de candidatos, y otras se iba a un candidato lejano y
    // dejaba media hoja en blanco. El nivel 2 no depende de cómo esté marcado el
    // documento, así que sirve para todos por igual.
    const fronteras = Array.from(new Set(
      Array.from(idoc.querySelectorAll("section, table, tr, h1, h2, .head, .meta, .firmas, .nota-firma, .pie, .hint, .criterio, .vacio, .clausula, .seccion-titulo, .declaracion, p, li"))
        .map((el:any) => Math.round(el.getBoundingClientRect().top * ptPorCss))
        .filter((y:number) => y > 0 && y < altoDoc)
    )).sort((a:number, b:number) => a - b);

    // Renglones dibujados. Se recorre el texto y se toma el borde INFERIOR de
    // cada rectángulo de línea: cortar justo debajo de un renglón nunca lo parte.
    const fronterasLinea: number[] = (() => {
      const ys: number[] = [];
      try {
        const paseo = idoc.createTreeWalker(idoc.body, 4 /* NodeFilter.SHOW_TEXT */);
        let nodo:any = paseo.nextNode();
        let vueltas = 0;
        while (nodo && vueltas++ < 20000) {
          if (String(nodo.nodeValue||"").trim()) {
            const rango = idoc.createRange();
            rango.selectNodeContents(nodo);
            const rects = rango.getClientRects();
            for (let i = 0; i < rects.length; i++) {
              const y = Math.round(rects[i].bottom * ptPorCss);
              if (y > 0 && y < altoDoc) ys.push(y);
            }
          }
          nodo = paseo.nextNode();
        }
      } catch { /* sin fronteras de línea se cae al comportamiento anterior */ }
      return Array.from(new Set(ys)).sort((a:number, b:number) => a - b);
    })();

    // Encabezado de continuación: se toma del propio documento (título y la línea
    // de datos), así que ningún documento tiene que pasarlo. Si no tiene `.meta`,
    // simplemente no hay nada que repetir.
    const _h1:any = idoc.querySelector("h1");
    const _meta:any = idoc.querySelector(".meta");
    const tituloDoc = _h1 ? String(_h1.textContent||"").replace(/\s+/g," ").trim() : "";
    const metaDoc = _meta ? String(_meta.innerText||"").replace(/\s+/g," ").trim() : "";

    // CÁLCULO DE CORTES. Una sola función para los dos modos: lo único que cambia
    // entre un contrato y un reporte es el alto útil de la hoja y qué se imprime
    // en el pie, no dónde es legítimo partir el documento.
    const cortesDe = (usable:number): {desde:number; hasta:number; continuacion:boolean}[] => {
      const dentroDeFirmas = (y:number) => !!firmas && y > firmas.top && y < firmas.bot;
      const cortes: [number, number][] = [];
      let inicio = 0, guarda = 0;
      while (inicio < altoDoc - 1 && guarda++ < 400) {
        let fin = inicio + usable;
        if (fin >= altoDoc) fin = altoDoc;
        else {
          // PRIMERO una frontera de bloque, pero solo si llena la hoja: un corte
          // de bloque muy arriba deja media página en blanco, y media hoja vacía a
          // mitad de un contrato se lee como si faltara algo.
          const bloque = fronteras.filter((y:number) => y > inicio + usable * PDF_LLENADO_MIN_BLOQUE && y <= fin && !dentroDeFirmas(y));
          if (bloque.length) fin = bloque[bloque.length - 1];
          else {
            // SI NO, el último renglón dibujado que quepa: la hoja se llena y el
            // corte cae entre líneas, nunca por la mitad de una.
            const linea = fronterasLinea.filter((y:number) => y > inicio + usable * PDF_LLENADO_MIN_LINEA && y <= fin && !dentroDeFirmas(y));
            if (linea.length) fin = linea[linea.length - 1];
            else if (dentroDeFirmas(fin) && firmas) fin = firmas.top;   // jamás por dentro
          }
        }
        if (fin <= inicio) fin = Math.min(altoDoc, inicio + usable);   // red de seguridad
        cortes.push([inicio, fin]);
        inicio = fin;
      }
      if (cortes.length === 0) cortes.push([0, altoDoc]);

      // REGLA DE LA HOJA HUÉRFANA. Si la última hoja empieza justo donde empiezan
      // las firmas —o casi—, la ruptura se hace ANTES, arrastrando contenido
      // suficiente para que la hoja de firmas no viaje sola. Solo se acepta un
      // corte anterior si el resto SIGUE cabiendo en una hoja: mover el corte
      // hacia atrás y provocar tres hojas sería peor.
      if (firmas && cortes.length > 1) {
        const ult = cortes[cortes.length - 1];
        const contenidoAntes = firmas.top - ult[0];
        if (contenidoAntes < PDF_ACOMPANAMIENTO_FIRMAS) {
          const objetivo = firmas.top - PDF_ACOMPANAMIENTO_FIRMAS;
          const previo = cortes[cortes.length - 2][0];
          const cand = fronteras.concat(fronterasLinea).sort((a:number,b:number)=>a-b).filter((y:number) =>
            y <= objetivo && y > previo && (altoDoc - y) <= usable && !dentroDeFirmas(y));
          if (cand.length) {
            const nuevo = cand[cand.length - 1];
            cortes[cortes.length - 2][1] = nuevo;
            ult[0] = nuevo;
          }
        }
      }
      // Una hoja es "de continuación" cuando lleva el bloque de firmas y NO lleva
      // contenido suficiente delante. Diez puntos de una tabla cortada no
      // reconectan nada: para eso está el encabezado que repite de quién y de qué
      // periodo es el papel.
      return cortes.map(([desde, hasta]) => ({
        desde, hasta,
        continuacion: !!firmas && cortes.length > 1 && hasta > (firmas as any).top
          && ((firmas as any).top - desde) < PDF_ACOMPANAMIENTO_FIRMAS,
      }));
    };

    // Dibuja un tramo del canvas como una hoja. Devuelve el alto en puntos.
    const pintarTrozo = (desde:number, hasta:number, y:number) => {
      const y0 = Math.max(0, Math.round(desde * canvasPorPt));
      const y1 = Math.min(canvas.height, Math.round(hasta * canvasPorPt));
      const alto = Math.max(1, y1 - y0);
      const trozo = document.createElement("canvas");
      trozo.width = canvas.width; trozo.height = alto;
      const ctx = trozo.getContext("2d");
      if (ctx) {
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, trozo.width, trozo.height);
        ctx.drawImage(canvas, 0, y0, canvas.width, alto, 0, 0, canvas.width, alto);
      }
      doc.addImage(trozo.toDataURL("image/jpeg", 0.92), "JPEG", margin, y, imgW, alto / canvasPorPt);
      return alto / canvasPorPt;
    };

    // ENCABEZADO DE CONTINUACIÓN. Una hoja de firmas suelta tiene que poder
    // reconectarse con su cuerpo: de quién es, qué periodo cubre, y que viene de
    // la hoja anterior. En letra chica, sin competir con el documento.
    const pintarContinuacion = (y:number) => {
      doc.setFont("helvetica", "normal"); doc.setFontSize(7.5);
      doc.setTextColor(120, 120, 120);
      const linea1 = [tituloDoc, metaDoc].filter(Boolean).join(" · ");
      if (linea1) doc.text(linea1.slice(0, 150), margin + 2, y + 8);
      doc.setFont("helvetica", "italic");
      doc.text("continúa de la página anterior", margin + 2, y + 18);
      doc.setFont("helvetica", "normal");
    };

    // MODO CONTRATO (opt-in): márgenes superior/inferior cómodos y parejos en
    // TODAS las hojas + pie de dos líneas por hoja.
    if (opts?.pieContrato) {
      const topM = PDF_CONTRATO_MARGEN_SUP, botM = PDF_CONTRATO_MARGEN_INF;
      const cortes = cortesDe(pageH - topM - botM - PDF_ALTO_CONTINUACION);
      cortes.forEach((c, k) => {
        if (k > 0) doc.addPage();
        if (c.continuacion) { pintarContinuacion(topM - PDF_ALTO_CONTINUACION + 6); pintarTrozo(c.desde, c.hasta, topM + 6); }
        else pintarTrozo(c.desde, c.hasta, topM);
      });
      // Pie en CADA hoja, 2 líneas discretas:
      //  1) leyenda de PROTECCIÓN: deja claro en toda hoja —incluso suelta— que AXIS
      //     solo REDACTÓ el contrato a petición de parte y NO es parte del mismo;
      //  2) datos + numeración de página.
      const total = doc.internal.pages.length - 1;
      for (let p = 1; p <= total; p++) {
        doc.setPage(p);
        doc.setFont("times","italic"); doc.setFontSize(7.5);
        doc.setTextColor(130, 130, 130);
        const yLeyenda = pageH - 42;
        pintarLeyendaContrato(doc, margin + 8, yLeyenda, pageW - 2*margin - 16);
        // El pie lo redacta quien llama: solo el sabe de que patron es este
        // documento. Sin pie, no se pone ninguno: aqui iba el domicilio y el
        // telefono del despacho en un contrato donde no es parte.
        //
        // VA UN RENGLÓN ENTERO POR DEBAJO DE LA LEYENDA, medido con el tipo que hay
        // puesto, y no en un pageH - 30 suelto. Da el mismo sitio que antes —12 pt
        // a 7,5 pt de cuerpo— pero deja de ser una coincidencia: si mañana alguien
        // sube el cuerpo de letra, la separación sube con él.
        const yPie = yLeyenda + doc.getTextDimensions("Hg").h * 1.6;
        if (opts?.pieTexto) doc.text(opts.pieTexto, margin + 8, yPie);
        doc.text(`Página ${p} de ${total}`, pageW - margin - 8, yPie, {align:"right"});
      }
    } else {
    // MULTIPÁGINA POR BLOQUES. El teselado anterior cortaba el canvas a altura
    // fija, y esa altura caía donde caía: a media línea de texto, a media fila de
    // tabla, o justo antes del bloque de firmas.
    const cortes = cortesDe(pageH - margin - PDF_BANDA_PIE - PDF_ALTO_CONTINUACION);
    cortes.forEach((c, k) => {
      if (k > 0) doc.addPage();
      if (c.continuacion) { pintarContinuacion(margin); pintarTrozo(c.desde, c.hasta, margin + PDF_ALTO_CONTINUACION); }
      else pintarTrozo(c.desde, c.hasta, margin);
    });

    // NUMERACIÓN. Va en todas las hojas, incluida la única cuando el documento
    // cabe en una: "Página 1 de 1" confirma que no falta nada detrás.
    const totalHojas = doc.internal.pages.length - 1;
    for (let pg = 1; pg <= totalHojas; pg++) {
      doc.setPage(pg);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      doc.setTextColor(150, 150, 150);
      doc.text(`Página ${pg} de ${totalHojas}`, pageW - margin, pageH - 14, {align:"right"});
    }
    }

    if (opts?.save !== false) doc.save(fname);
    return doc.output("blob");
  } finally {
    document.body.removeChild(iframe);
  }
}

// Componente reutilizable de subida de archivos
// ═══ EL BOTÓN DE SUBIR ══════════════════════════════════════════════════════
//
// EL DEFECTO QUE ESTE CONTRATO ARREGLA, Y HAY QUE CONTARLO ENTERO PORQUE COSTÓ
// CINCO ARCHIVOS DE UN CLIENTE REAL:
//
// La primera versión de "varios archivos" llamaba a `onSubido(url, nombre)` una
// vez por archivo, para no tocar a los diecisiete consumidores. Parecía elegante.
// Era un destructor de datos: cada consumidor guarda haciendo `[...lista, uno]`
// sobre la lista que capturó su cierre, y seis llamadas seguidas parten TODAS de
// la misma lista vieja y se pisan entre ellas. Gana la última.
//
// Se subieron seis archivos a Storage y quedó registrado UNO. Los otros cinco
// siguen ahí, ocupando y pagándose, sin ninguna pantalla que los muestre ni
// permita borrarlos. Y el usuario vio seis renglones terminados.
//
// ESPERAR A CADA LLAMADA NO LO ARREGLA: el problema no es el orden, es que las
// seis leen el mismo dato viejo.
//
// POR ESO EL CONTRATO CAMBIA, y cambia de una forma que hace el defecto
// IMPOSIBLE en vez de improbable:
//
//   · `onLote(archivos[])` — se llama UNA vez con la tanda entera. El consumidor
//     hace UN solo leer-modificar-escribir con todo dentro. No hay dos llamadas
//     que puedan pisarse porque no hay dos llamadas.
//   · `onSubido(url, nombre)` — el contrato de siempre, para un archivo.
//
// Y VARIOS ARCHIVOS SOLO SE OFRECEN SI HAY `onLote`. No es una preferencia: un
// consumidor que solo sabe recibir de uno en uno NO puede recibir seis sin perder
// cinco, así que ni siquiera se le deja elegir. `varios` sale de si existe
// `onLote`, no de una bandera que alguien pueda poner por optimismo.
const MAX_ARCHIVOS_TANDA = 8;

// EL LADO MAYOR AL QUE SE REDUCE, según para qué es la imagen.
//
//   · Un documento fotografiado —un acta, una identificación, una póliza— tiene
//     que poder LEERSE. 1600 px es lo que ya usaba flotilla para que se distinga
//     una placa o un golpe, y para un oficio escaneado deja el texto legible.
//   · Un avatar se pinta a 72–84 px. Aun contando pantallas de tres veces la
//     densidad, 256 px lo cubren; 512 deja margen por si algún día se enseña más
//     grande y sigue pesando unas decenas de KB. Reducir un avatar a 1600 px es
//     guardar veinte veces los píxeles que se van a ver.
const LADO_DOCUMENTO = 1600;
const LADO_AVATAR = 512;

// El nombre tiene que decir la verdad: si una imagen entra como .png y sale
// recodificada a JPEG, guardarla como .png es mentir sobre el archivo. Solo se
// cambia la extensión cuando el tipo cambió de verdad.
function _nombreSegunTipo(nombre: string, tipo: string): string {
  if (tipo !== "image/jpeg") return nombre;
  if (/\.jpe?g$/i.test(nombre)) return nombre;
  return nombre.replace(/\.[^.]+$/, "") + ".jpg";
}

// PREPARA UN ARCHIVO PARA SUBIRLO: comprime si es imagen, lo deja intacto si no.
//
// UN PDF O UN .docx SE SUBEN INTACTOS. `comprimirImagen` los devolvería tal cual
// —comprueba el tipo antes de nada— pero aquí se dice explícitamente, porque
// pasar un contrato firmado por un canvas y recodificarlo a JPEG lo destruiría.
//
// Y SI COMPRIMIR FALLA, SE SUBE EL ORIGINAL. Un formato que el navegador no sabe
// decodificar, un canvas sin contexto, una imagen corrupta a medias: cualquiera
// de esas cosas devuelve el archivo de entrada. Mejor una subida lenta que una
// foto perdida — el usuario ya la eligió, y perdérsela para ahorrar unos KB sería
// el peor negocio posible.
async function prepararParaSubir(archivo: File, ladoMax: number): Promise<File> {
  if (!archivo.type.startsWith("image/")) return archivo;
  try {
    const blob = await comprimirImagen(archivo, ladoMax);
    // `comprimirImagen` devuelve el propio archivo cuando no pudo o no valió la
    // pena; en ese caso no hay nada que envolver.
    if (blob === (archivo as any)) return archivo;
    const nombre = _nombreSegunTipo(archivo.name, blob.type || "image/jpeg");
    return new File([blob], nombre, {type: blob.type || "image/jpeg", lastModified: Date.now()});
  } catch (e) { return archivo; }
}

function SubirArchivoBtn({
  userId, carpeta, label, accept, onSubido, onLote, maxMB = 10, ladoMax = LADO_DOCUMENTO
}: {
  userId:string; carpeta:string; label:string; accept?:string; maxMB?:number; ladoMax?:number;
  // Uno. El contrato de siempre; los consumidores que guardan un valor único
  // —una foto de perfil, el PDF de un contrato— se quedan con éste.
  onSubido?:(url:string, nombre:string)=>void|Promise<void>;
  // La tanda entera, de una vez. Quien lo implementa puede recibir varios; quien
  // no, no. Ver el aviso de arriba: esto no es una opción de estilo.
  onLote?:(archivos:{url:string; nombre:string}[])=>void|Promise<void>;
}) {
  const varios = !!onLote;
  // El estado de la tanda, archivo por archivo. UN progreso para toda la tanda no
  // sirve: si van seis y falla el cuarto, "45%" no dice cuál se perdió.
  const [cola, setCola] = useState<{nombre:string; estado:"espera"|"subiendo"|"guardando"|"hecho"|"error"; pct:number; detalle?:string}[]>([]);
  const [trabajando, setTrabajando] = useState(false);
  const [aviso, setAviso] = useState("");

  const handleChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const lista = Array.from(e.target.files || []) as File[];
    try { e.target.value = ""; } catch (_e) {}
    // Defensivo: sin archivos (canceló la cámara/el selector) → no truena, no hace nada.
    if (!lista.length) return;
    setAviso("");

    let elegidos = lista;
    if (!varios) elegidos = lista.slice(0, 1);
    else if (lista.length > MAX_ARCHIVOS_TANDA) {
      elegidos = lista.slice(0, MAX_ARCHIVOS_TANDA);
      setAviso(`Se suben los primeros ${MAX_ARCHIVOS_TANDA}; elegiste ${lista.length}.`);
    }

    // EL LÍMITE DE PESO ES DE CADA ARCHIVO, NO DE LA TANDA, y el que se pasa se
    // rechaza POR SU NOMBRE sin tirar a los demás.
    const estados = elegidos.map((f) => f.size > maxMB * 1024 * 1024
      ? {nombre: f.name, estado: "error" as const, pct: 0, detalle: `pesa más de ${maxMB} MB`}
      : {nombre: f.name, estado: "espera" as const, pct: 0});
    setCola(estados);
    setTrabajando(true);
    const marca = (i:number, cambio:any) => setCola((prev) => prev.map((c, j) => j === i ? {...c, ...cambio} : c));

    // ── 1) SUBIR. De uno en uno y no en paralelo: seis subidas simultáneas por
    //    datos móviles se estorban entre ellas.
    const subidos: {url:string; nombre:string; indice:number}[] = [];
    for (let i = 0; i < elegidos.length; i++) {
      if (estados[i].estado === "error") continue;
      try {
        marca(i, {estado: "subiendo", pct: 0});
        const listo = await prepararParaSubir(elegidos[i], ladoMax);
        const url = await subirArchivo(userId, carpeta, listo, (p) => marca(i, {pct: p}));
        subidos.push({url, nombre: listo.name, indice: i});
        marca(i, {estado: "guardando", pct: 100});
      } catch (err) {
        // UNA QUE FALLA NO TIRA A LAS DEMÁS.
        marca(i, {estado: "error", detalle: "no se pudo subir"});
      }
    }

    // ── 2) REGISTRAR, UNA SOLA VEZ para toda la tanda cuando hay `onLote`.
    //
    // Y SI EL REGISTRO FALLA, SE BORRA LO SUBIDO. Un archivo que está en Storage
    // y no figura en ninguna pantalla es basura que se paga y que nadie puede
    // encontrar para borrar. Antes se quedaba ahí; ahora se limpia, y si la
    // limpieza tampoco puede, al menos se dice.
    if (subidos.length) {
      try {
        if (onLote) await onLote(subidos.map((s) => ({url: s.url, nombre: s.nombre})));
        else if (onSubido) await onSubido(subidos[0].url, subidos[0].nombre);
        subidos.forEach((s) => marca(s.indice, {estado: "hecho", pct: 100}));
      } catch (err) {
        let limpios = 0;
        for (const s of subidos) {
          try { await eliminarArchivo(s.url); limpios++; } catch (_e) {}
          marca(s.indice, {estado: "error", detalle: "no se pudo guardar"});
        }
        setAviso(limpios === subidos.length
          ? "No se pudo guardar; lo subido se borró y no quedó nada a medias."
          : "No se pudo guardar, y no todo lo subido se pudo borrar. Avisa a soporte.");
      }
    }
    setTrabajando(false);
  };

  const estiloBtn:any = {
    display:"inline-flex", alignItems:"center", gap:8,
    background:"rgba(184,147,42,0.12)", border:"1px solid rgba(184,147,42,0.3)",
    borderRadius:10, padding:"8px 16px", cursor:trabajando?"not-allowed":"pointer",
    fontSize:13, color:"#D4A843", fontWeight:600, opacity:trabajando?0.7:1, transition:"all 0.2s"
  };
  const fallidos = cola.filter((c) => c.estado === "error").length;
  const hechos = cola.filter((c) => c.estado === "hecho").length;

  return (
    <div style={{position:"relative" as const}}>
      {trabajando ? (
        <span style={{...estiloBtn, cursor:"not-allowed"}}>
          {cola.length === 1 ? "Subiendo…" : `Subiendo ${Math.min(hechos + fallidos + 1, cola.length)} de ${cola.length}…`}
        </span>
      ) : (
        <div style={{display:"inline-flex", gap:8, flexWrap:"wrap" as const, alignItems:"center"}}>
          {/* Tomar foto / escanear: usa la cámara del dispositivo. En móvil, iOS/Android
              ofrecen "Escanear documento" nativo (bordes/enderezado). En escritorio cae
              al selector de archivos sin tronar. La cámara es de una en una por su
              propia naturaleza: nunca lleva `multiple`. */}
          <label style={estiloBtn}>
            <span>📷 Tomar foto / escanear</span>
            <input type="file" accept="image/*" capture="environment" onChange={handleChange}
              style={{display:"none"}}/>
          </label>
          <label style={estiloBtn}>
            <span>📎 {varios ? `${label} (hasta ${MAX_ARCHIVOS_TANDA})` : label}</span>
            <input type="file" accept={accept} multiple={varios} onChange={handleChange}
              style={{display:"none"}}/>
          </label>
        </div>
      )}

      {/* UN RENGLÓN POR ARCHIVO, con su nombre y su estado. Es lo que permite saber
          CUÁL falló cuando van seis. */}
      {cola.length > 0 && (
        <div style={{marginTop:8, display:"flex", flexDirection:"column" as const, gap:5}}>
          {cola.map((c, i) => (
            <div key={i} style={{fontSize:11.5, lineHeight:1.45}}>
              <div style={{display:"flex", alignItems:"center", gap:6, flexWrap:"wrap" as const,
                color: c.estado === "error" ? "#FCA5A5" : c.estado === "hecho" ? "#7FD1C0" : "#D4A843"}}>
                <span style={{flexShrink:0}}>{c.estado === "error" ? "✕" : c.estado === "hecho" ? "✓" : "•"}</span>
                <span style={{overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" as const, maxWidth:200}}>{c.nombre}</span>
                <span style={{opacity:0.85}}>
                  {c.estado === "espera" ? "en cola"
                    : c.estado === "subiendo" ? `${c.pct}%`
                    : c.estado === "guardando" ? "guardando…"
                    : c.estado === "hecho" ? "listo"
                    : c.detalle || "no se pudo subir"}
                </span>
              </div>
              {(c.estado === "subiendo" || c.estado === "guardando") && (
                <div style={{marginTop:3, height:3, background:"rgba(255,255,255,0.12)", borderRadius:2}}>
                  <div style={{height:"100%", width:`${c.pct}%`, borderRadius:2,
                    background:"linear-gradient(90deg,#B8932A,#D4A843)", transition:"width 0.3s"}}/>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
      {!trabajando && fallidos > 0 && (
        <div style={{fontSize:11, color:"#FCA5A5", marginTop:5}}>
          {fallidos === 1 ? "1 archivo no se subió." : `${fallidos} archivos no se subieron.`}
          {hechos > 0 && ` Los otros ${hechos} sí.`} Puedes volver a intentarlo con los que faltan.
        </div>
      )}
      {aviso && <div style={{fontSize:11, color:"#D4A843", marginTop:5}}>{aviso}</div>}
    </div>
  );
}

// ── Avatar de perfil TOCABLE (patrón tipo WhatsApp) ─────────────────────────
// Se toca el avatar → se despliega la opción de cambiar la foto (reutiliza
// SubirArchivoBtn: cámara/escaneo + elegir archivo). Un badge de cámara en la
// esquina indica que es tocable. NO cambia la lógica de subida/guardado: al
// terminar, llama onSubido(url, nombre) igual que antes. `c` da los colores del
// tema (navy) para encajar en cualquiera de los perfiles.
function AvatarEditable({ url, iniciales, size = 72, userId, carpeta, onSubido, fontSans, c }: {
  url:string; iniciales:string; size?:number; userId:string; carpeta:string;
  onSubido:(url:string, nombre:string)=>void|Promise<void>; fontSans:string;
  c:{gold:string; iconBg:string; iconBd:string; panel:string; inkSoft:string};
}) {
  const [abierto, setAbierto] = useState(false);
  const badge = Math.max(20, Math.round(size*0.30));
  return (
    <div style={{width:size, margin:"0 auto"}}>
      <button onClick={()=>setAbierto(o=>!o)} aria-label="Cambiar foto de perfil" title="Cambiar foto"
        style={{position:"relative" as const, width:size, height:size, borderRadius:"50%", padding:0, cursor:"pointer", border:"none", background:"transparent", display:"block"}}>
        {url
          ? <img src={url} alt="Foto de perfil" style={{width:size, height:size, borderRadius:"50%", objectFit:"cover" as const, display:"block", border:`1px solid ${c.iconBd}`}}/>
          : <div style={{width:size, height:size, borderRadius:"50%", display:"flex", alignItems:"center", justifyContent:"center", background:c.iconBg, border:`1px solid ${c.iconBd}`, color:c.gold, fontFamily:fontSans, fontSize:Math.round(size*0.33), fontWeight:800, letterSpacing:"1px"}}>{iniciales}</div>}
        <span style={{position:"absolute" as const, right:0, bottom:0, width:badge, height:badge, borderRadius:"50%", background:c.gold, border:`2px solid ${c.panel}`, display:"flex", alignItems:"center", justifyContent:"center", color:"#0B1829"}}>
          <svg width={Math.round(badge*0.56)} height={Math.round(badge*0.56)} viewBox="0 0 24 24" fill="none"><path d="M4 8h3l1.5-2h7L16 8h4a1 1 0 011 1v9a1 1 0 01-1 1H4a1 1 0 01-1-1V9a1 1 0 011-1z" stroke="currentColor" strokeWidth="1.9" strokeLinejoin="round"/><circle cx="12" cy="13.2" r="3.1" stroke="currentColor" strokeWidth="1.9"/></svg>
        </span>
      </button>
      {abierto && (
        <div style={{marginTop:12, display:"flex", flexDirection:"column" as const, alignItems:"center", gap:8}}>
          {/* UNA foto de perfil, no ocho, y eso ya no hace falta pedirlo: varios
              archivos solo se ofrecen a quien implementa `onLote`, y guardar una
              foto de perfil no es acumular una lista. Lo que sí se dice aquí es el
              tamaño: al lado del avatar es donde más se notaba subir sin comprimir
              —una selfie de 12 MP para pintarse a 72 px—. */}
          <SubirArchivoBtn userId={userId} carpeta={carpeta} label="Elegir archivo" accept="image/*"
            ladoMax={LADO_AVATAR}
            onSubido={async (u,n)=>{ await onSubido(u,n); setAbierto(false); }}/>
          <button onClick={()=>setAbierto(false)} style={{background:"transparent", border:"none", color:c.inkSoft, cursor:"pointer", fontFamily:fontSans, fontSize:12, fontWeight:700}}>Cancelar</button>
        </div>
      )}
    </div>
  );
}

// LA LISTA VIVE EN `src/logica/admin.js`, no aquí. La necesita también el
// servidor —el aviso de leads nuevos va al dueño de la plataforma— y dos copias
// de la misma lista corriendo en dos sitios distintos es exactamente el defecto
// que este proyecto lleva media docena de ramas quitando.
//
// De paso se arregla algo que estaba mal aquí: `includes` comparaba en crudo, y
// Firebase Auth conserva las mayúsculas con las que uno se registró. Bastaba un
// `Ivan.Lopez.15@hotmail.com` para que el propio administrador dejara de serlo.
// La versión compartida normaliza a minúsculas.
import { ADMIN_EMAILS, esAdmin } from "./logica/admin";
// El "¿Qué pasó?" del accidente: una sola lista, compartida con el servidor, que
// escribe el tipo de hecho en el aviso al patrón. Ver src/logica/accidente.js.
import { tiposAccidenteVisibles, tipoAccidente, rotuloTipoAccidente } from "./logica/accidente";
// LAS ACTUALIZACIONES: el contenido versionado y quién lo ve. Ver src/novedades.js.
import { NOVEDADES } from "./novedades";
import { avisoDeNovedades, novedadesDeLaCuenta, fechaNovedadTexto } from "./logica/novedades";
// EL HORARIO DE CADA PERSONA SALE DE AQUÍ Y DE NINGÚN OTRO SITIO: la misma función
// que usa el aviso del servidor (api/avisos-checador.js). Ver sus reglas y sus
// valores por omisión en src/logica/checador.js.
import { vistaEfectiva, anotacionesDeRegistro, renglonesDeCorreccion, noConformidadTexto, correccionesDelPeriodo, correccionesHechasEnElPeriodo, marcaBreveDelDia, registrosDelDia, registroAfectadoTexto,
  diasConRegistrosAgregados, textoDiasConAgregados, datosDeCorreccion, datosDeNoConformidad, sePuedeRevertir, fechaHoraMexico,
  TEXTO_CONFIRMAR_CORRECCION, TEXTO_CONFIRMAR_NO_CONFORME, TEXTO_AVISO_CORRECCION, TIPOS_DE_CHECADA, DIAS_PARA_AGREGAR } from "./logica/correcciones";
import { primerMesDisponible, etiquetaMes, mesesDisponibles, quincenasDelMes, quincenaEnCurso, rangoDeQuincena, periodoPermitido } from "./logica/periodos";
import { horarioVigente, horarioQueRegia, enHoraDeMexico, instanteDeMexico, horarioAplicadoDe, difiereDelTestigo, historialVacio, siguienteClaveDeHistorial, entradaDeHistorial, horarioParaHistorial, instantesDelHistorial, firmaDelHorarioAplicado, ultimoPersonalizadoDelHistorial, periodosLaboralesDe, relacionLaboralEnDia, fechaDeLaRelacion, relacionLaboralHoy,
  // UNA SOLA FUNCIÓN para "debe checar" (13-oct-2026): la base, sus ventanas, los días
  // laborables, quién ya checó (en hora de México), vacaciones y art. 74. Sin copias aquí.
  debiaChecarHoy, correosConCuentaActiva, correosQueChecaronHoy, diasLaborablesDe, diasLaborablesVigentes,
  descansosObligatoriosDe, diasDeVacaciones, isoDiaLocal as _isoDia, debeChecarEnFecha } from "./logica/checador";
// "Suspender cuenta" / "Reactivar cuenta" escriben el valor explícito; sin el
// campo, la cuenta está activa (ver src/logica/acceso.js).
import { activoAlAlternar, cuentaDesactivada, cuentaActiva } from "./logica/acceso";
// Sedes y razones sociales de cada trabajador (11-oct-2026): ver src/logica/sedes.js.
import { SEDE_PRINCIPAL, RAZON_PRINCIPAL, RADIOS_SEDE, ETIQUETA_PRINCIPAL_SIN_NOMBRE, AYUDA_NOMBRE_SEDE, TEXTO_NOMBRA_LA_PRINCIPAL, faltaNombrarLaPrincipal, TEXTO_PRINCIPAL_NECESITA_NOMBRE, hayOtrasSedesRegistradas, etiquetaDeSede, TEXTO_CAMBIO_RFC_PRINCIPAL, rfcCambiaElGuardado, efectoDesdeElInicioDe, sinHistorialDeAsignacion, TEXTO_CAMBIO_DESDE_HOY, TEXTO_ELECCION_IRREVERSIBLE, textoConfirmaDesdeElInicio, textoCuentaEnOtraFicha, TEXTO_CUENTA_YA_VINCULADA, otraFichaConLaCuenta, mismaDenominacion, textoNombreNoCoincide, OPCION_DESDE_EL_INICIO, OPCION_A_PARTIR_DE_HOY, TEXTO_FICHA_SIN_VINCULAR, TEXTO_RFC_FIJO,
  entradasDeAsignacion, siguienteClaveDeAsignacion, valorQueRegia, cambiosEnElPeriodo, catalogoDeSedes, sedeDeId, sedeVigenteDe, sedeQueRegia,
  sedeAplicadaDe, medirContraSede, sedeDifiereDelTestigo, catalogoDeRazones, razonSocialDeId, razonSocialVigenteDe, razonSocialQueRegia, razonSocialDelCatalogo,
  razonSocialAplicadaDe, normalizarRfc, errorDeRfc, fichaSinVincular, fichasConCuentaSinVincular } from "./logica/sedes";
// La versión de la plataforma: la franja "Hay una versión nueva" y la versión
// mínima (ver src/logica/version.js, donde se sube NIVEL_MINIMO).
import { NIVEL_MINIMO, RUTA_VERSION, INTERVALO_REVISION_MS, INTERVALO_PENDIENTE_MS, PAUSA_ANTES_DE_RECARGAR_MS, CLAVE_RECARGAS,
  TEXTO_BOTON_ACTUALIZAR, TEXTO_CONFIRMAR_ACTUALIZAR_CON_CAPTURA, versionCargada, leerVersionServida, decidirActualizacion, textoDeFranja } from "./logica/version";

// ═══ QUIÉN ENTRA A LA PLATAFORMA — UNA SOLA COMPROBACIÓN ═══════════════════
// La puerta y el menú preguntan lo mismo a la misma función. Dos comprobaciones
// distintas para el mismo permiso acaban discrepando, y el día que discrepan
// alguien ve un menú que no puede usar o entra a algo que no debería.
//
// TRES RAMAS, Y SOLO TRES:
//   · administrador, por correo;
//   · patrón cuyo correo está en la lista de autorizados;
//   · trabajador cuyo EMPLEADOR está en la lista de autorizados.
//
// La tercera es una herencia, no una copia: el trabajador no tiene registro
// propio en la lista. Si el patrón deja de estar autorizado, sus trabajadores
// dejan de entrar con él en el mismo instante, sin que nadie tenga que acordarse
// de darlos de baja uno por uno.
//
// POR OMISIÓN SE CIERRA. Si el documento no existe, no se puede leer o viene
// vacío, la respuesta es NO. Un permiso que se concede ante la duda no es un
// permiso, es un agujero con horario.
type ResultadoAcceso = {
  entra: boolean;
  via: "admin" | "lista" | "empleador" | "ninguna";
  motivo?: "sin_sesion" | "sesion_anonima" | "no_autorizado" | "sin_correo";
  empleadorEmail?: string;      // cuando entra heredando
};

const ACCESO_DENEGADO: ResultadoAcceso = {entra:false, via:"ninguna", motivo:"no_autorizado"};

// EVALUANDO NO ES "NO ENTRA", Y CONFUNDIRLOS ES LO ÚNICO QUE PUEDE SALIR MAL AL
// CERRAR. `evaluarAcceso` hace hasta tres lecturas a Firestore; si durante ese
// rato el estado fuese "no entra", un patrón legítimo vería la pantalla de
// rechazo en CADA inicio de sesión. Un cliente que ve eso un segundo cierra la
// aplicación y llama por teléfono.
//
// Un booleano no puede representar tres respuestas, así que aquí no hay booleano:
// o se está evaluando, o hay un resultado. Mientras se evalúa se muestra carga, y
// el rechazo SOLO puede pintarse desde la rama "resuelto".
type FaseAcceso = {fase:"evaluando"} | {fase:"resuelto"; resultado:ResultadoAcceso};
const ACCESO_EVALUANDO: FaseAcceso = {fase:"evaluando"};

// QUÉ PINTA LA PUERTA. Tres respuestas, decididas en un solo sitio y no repartidas
// por el render, para que se puedan probar una por una. La que importa es que
// "evaluando" NUNCA produzca "sin_acceso": ese es el parpadeo que haría que un
// cliente legítimo viera el rechazo en cada inicio de sesión.
type PuertaPinta = "cargando" | "sin_acceso" | "seguir";
function decidirPuerta(acceso: FaseAcceso, user: any): PuertaPinta {
  // 1. Todavía no se sabe. Incluye el arranque en frío, antes de que Firebase
  //    diga siquiera si hay sesión guardada.
  if (acceso.fase === "evaluando") return "cargando";
  // 2. Sesión anónima heredada de antes del cierre: se está cerrando sola.
  //    Tampoco es un rechazo, es un visitante con un resto en el navegador.
  if (user?.isAnonymous) return "cargando";
  // 3. Hay sesión real y la respuesta fue que no.
  if (user && !acceso.resultado.entra) return "sin_acceso";
  // 4. Entra, o no hay sesión: sigue el flujo normal —bienvenida y acceso—.
  return "seguir";
}

// LA DECISIÓN VIVE EN `src/logica/acceso.js`, Y AQUÍ NO QUEDA COPIA. La misma
// función la usa `api/axior.js` para no llamar al modelo de IA por quien no pasa
// la puerta. Si el navegador y el servidor tuvieran cada uno la suya, el día que
// discreparan alguien vería la puerta cerrada y seguiría usando AXIOR por detrás.
// Aquí solo queda CÓMO se lee en el navegador: `getDoc`, con `null` si el
// documento no existe; si la lectura falla, lanza, y la función compartida lo
// cuenta como "no" —se cierra por omisión—.
import { evaluarAccesoCon } from "./logica/acceso";
// La pantalla en la dirección y en el historial (fix/recarga-conserva-pantalla).
import { crearNavegacion, vistaDeLaDireccion } from "./logica/navegacion";
async function _leerDocCliente(coleccion: string, id: string): Promise<any> {
  const d = await getDoc(doc(db, coleccion, id));
  return d.exists() ? (d.data() || {}) : null;
}
async function evaluarAcceso(user: any): Promise<ResultadoAcceso> {
  return (await evaluarAccesoCon(user, _leerDocCliente)) as ResultadoAcceso;
}

// ─── TEMA PREMIUM ─────────────────────────────────────────────────────────────
// T  = paleta del shell oscuro (sidebar, header, modales sobre marino).
// T_LIGHT = paleta del área de contenido crema (cards blancas, texto marino).
// El rediseño híbrido (Stripe/Notion-style) usa ambas: header navy + dorado,
// canvas crema con tarjetas blancas. Ver memoria project-colores-estructura.md.
const T = {
  bg:         "linear-gradient(160deg,#0B1829 0%,#0F2040 50%,#162447 100%)",
  bgCard:     "rgba(255,255,255,0.05)",
  bgCardHov:  "rgba(255,255,255,0.08)",
  bgSide:     "#0D1E3A",
  bgDark:     "#162447",
  navy:       "#0F1E3D",     // navy "limpio" para el header del shell híbrido
  navyDeep:   "#0A1530",     // hover/activo en sidebar premium
  gold:       "#B8932A",
  goldLight:  "#D4A843",
  goldDim:    "rgba(184,147,42,0.12)",
  goldBorder: "rgba(184,147,42,0.30)",
  blue:       "#162447",
  blueAcc:    "#1E3A5F",
  blueMid:    "#3B82F6",
  blueLight:  "#60A5FA",
  textPrim:   "#FFFFFF",
  textSec:    "rgba(255,255,255,0.70)",
  textMut:    "rgba(255,255,255,0.38)",
  border:     "rgba(255,255,255,0.08)",
  borderGold: "rgba(184,147,42,0.28)",
  shadow:     "0 4px 24px rgba(0,0,0,0.30)",
  shadowHov:  "0 8px 32px rgba(0,0,0,0.45)",
};

// Paleta del área de contenido (crema cálido + tarjetas blancas + texto marino).
// Solo se usa en módulos migrados al rediseño híbrido — el resto sigue con T.
const T_LIGHT = {
  canvas:       "#F7F4ED",   // crema cálido — fondo del área de contenido
  canvasSoft:   "#F0EBDE",   // crema un punto más profundo — dividers, hover
  cardLight:    "#FFFFFF",   // tarjetas blancas
  cardLightHov: "#FBF9F2",   // hover de tarjeta
  border:       "#E8E2D5",   // borde sutil sobre crema (divisores internos, líneas de tabla)
  borderCard:   "rgba(28,43,74,0.68)",  // CONTORNO NAVY marcado de tarjetas (mismo que el Inicio / INI.borde) — centralizado
  borderStrong: "#D6CFBE",   // borde con más contraste
  textInk:      "#162447",   // marino — texto principal sobre crema/blanco
  textInkSoft:  "#3D4B6B",   // marino atenuado — texto secundario
  textInkMut:   "#7A8499",   // gris azulado — etiquetas, footer
  gold:         "#B8932A",
  goldLight:    "#D4A843",
  goldSoft:     "rgba(184,147,42,0.10)",   // pill dorado sobre fondo claro
  goldBorder:   "rgba(184,147,42,0.30)",
  success:      "#059669",
  successSoft:  "rgba(5,150,105,0.10)",
  danger:       "#DC2626",
  warn:         "#D97706",
  shadow:       "0 4px 16px rgba(22,36,71,0.08)",
  shadowHov:    "0 12px 32px rgba(22,36,71,0.14)",
};

// Lenguaje visual UNIFICADO de las tarjetas del Inicio (solo estilo, mismo radio,
// borde y sombra en todos los cuadros para que se vean de la misma familia).
// Navy translúcido lleva el peso; el gold se reserva para el hover y acentos.
const INI = {
  borde:     "rgba(28,43,74,0.68)",   // borde NAVY marcado/definido (navy de marca #1C2B4A, opaco) — fondo de tarjeta intacto
  radio:     14,                       // esquinas consistentes
  sombra:    "0 1px 3px rgba(22,36,71,0.07), 0 1px 2px rgba(22,36,71,0.04)",
  sombraHov: "0 6px 18px rgba(22,36,71,0.13)",
  iconoBg:   "rgba(22,36,71,0.06)",    // fondo de ícono navy muy sutil
  iconoBd:   "rgba(22,36,71,0.10)",
};

// ─── TIPOS ────────────────────────────────────────────────────────────────────
interface Regulacion {
  id: string; nivel: string; clave: string; titulo: string;
  descripcion: string; autoridad: string; especialidades: string[];
  obligatorio: boolean; nuevo?: boolean; esMarco?: boolean;
}
interface Sector {
  id: string; nombre: string; descripcion: string; icon: string;
  color: string; acento: string; disponible: boolean; totalRegs: number;
}
type EstadoType = "pendiente" | "cumplido";
type AppPantalla = "bienvenida" | "landing" | "regulamx" | "login" | "suite" | "flotilla" | "admin" | "nomina" | "contratos" | "empleados" | "calendario" | "documentos" | "proveedores" | "clientes" | "creditos" | "planes" | "acerca_de" | "ayuda" | "cuentas_trab" | "tareas" | "recibos" | "obligaciones" | "datos_empresa";
type RegistroFlotilla = {
  id?: string; tipo:"salida"|"regreso"; placa:string;
  kmInicial?:number; kmFinal?:number; destino?:string;
  observaciones?:string; conductor:string; conductorEmail:string;
  fecha:string; hora:string; timestamp:any;
  estado?:"normal"|"revision"|"incidente";
  salidaId?:string;
  kmRecorridos?:number;
};

// ─── CONFIG ───────────────────────────────────────────────────────────────────
const NIVEL_LABELS: Record<string,string> = {
  marco:"Marco Legal de Referencia", federal:"Marco Federal", estatal:"Marco Estatal", municipal:"Trámites Municipales",
  nom_universal:"NOMs Universales", nom_especialidad:"NOMs por Especialidad",
  nom_complementaria:"NOMs Complementarias", laboral:"Obligaciones Laborales", iso:"Normas ISO",
};
const NIVEL_ICONS: Record<string,string> = {
  marco:"📜", federal:"⚖", estatal:"🏛", municipal:"🏙", nom_universal:"📋",
  nom_especialidad:"🔬", nom_complementaria:"🔧", laboral:"👷", iso:"🌐",
};
const NIVEL_ORDEN = ["marco","federal","estatal","municipal","nom_universal","nom_especialidad","nom_complementaria","laboral","iso"];
const ESTADOS: EstadoType[] = ["pendiente","cumplido"];
const ESTADO_CFG: Record<EstadoType,{label:string;color:string;bg:string}> = {
  pendiente: {label:"Pendiente", color:"#DC2626", bg:"rgba(220,38,38,0.06)"},
  cumplido:  {label:"Cumplido",  color:"#059669", bg:"rgba(5,150,105,0.08)"},
};

// #region DATOS: MÉDICO
// ─── DATOS: MÉDICO ────────────────────────────────────────────────────────────
const ESP_MEDICO = ["Todas","Ambulatorio / Consultorio","Hospital","Laboratorio Clínico","Ginecología / Obstetricia","Odontología","Psiquiatría / Salud Mental","Radiología / Imagen","Hemodiálisis / Nefrología","Anestesiología / Cirugía","Medicina Interna / Crónicas","Dispositivos Médicos"];
const REGS_MEDICO: Regulacion[] = [
  {id:"mf1",nivel:"marco",esMarco:true,clave:"Art. 4° CPEUM",titulo:"Derecho a la protección de la salud",descripcion:"Base constitucional de todo el sistema de salud.",autoridad:"Constitución Política",especialidades:["Todas"],obligatorio:true},
  {id:"mf2",nivel:"marco",esMarco:true,clave:"Ley General de Salud",titulo:"Ley General de Salud (LGS)",descripcion:"Arts. 45–48 regulan establecimientos; Art. 47 obliga al cumplimiento de NOMs.",autoridad:"Secretaría de Salud Federal",especialidades:["Todas"],obligatorio:true},
  {id:"mf3",nivel:"marco",esMarco:true,clave:"Rgto. LGS-Atención Médica",titulo:"Reglamento LGS — Prestación de Servicios de Atención Médica",descripcion:"Arts. 19, 21 y 26: personal suficiente e idóneo, recursos físicos, tecnológicos y humanos.",autoridad:"Secretaría de Salud Federal",especialidades:["Todas"],obligatorio:true},
  {id:"mf4",nivel:"marco",esMarco:true,clave:"Ley Infraestructura Calidad",titulo:"Ley de Infraestructura de la Calidad (2020)",descripcion:"Sustituye a la LFMN. Marco legal bajo el cual se expiden todas las NOMs vigentes.",autoridad:"SE / Congreso de la Unión",especialidades:["Todas"],obligatorio:true},
  {id:"mf5",nivel:"federal",clave:"COFEPRIS — Aviso/Licencia",titulo:"Aviso de funcionamiento o Licencia Sanitaria ante COFEPRIS",descripcion:"Obligatorio para todo establecimiento médico según nivel de riesgo sanitario.",autoridad:"COFEPRIS",especialidades:["Todas"],obligatorio:true},
  {id:"me1",nivel:"marco",esMarco:true,clave:"Ley Salud AGS",titulo:"Ley de Salud del Estado de Aguascalientes",descripcion:"Regula el registro de profesionales y establecimientos ante el ISSEA. Última reforma: 16 de junio de 2025.",autoridad:"ISSEA / Gobierno del Estado",especialidades:["Todas"],obligatorio:true},
  {id:"me2",nivel:"estatal",clave:"Registro ISSEA",titulo:"Registro / Refrendo anual ante el ISSEA",descripcion:"Trámite en las oficinas del ISSEA. Incluye verificación de instalaciones.",autoridad:"ISSEA",especialidades:["Todas"],obligatorio:true},
  {id:"me3",nivel:"estatal",clave:"Cédulas profesionales",titulo:"Cédulas profesionales y de especialidad del personal",descripcion:"Título, cédula profesional y de especialidad registradas ante SEP. El ISSEA publica padrón anual.",autoridad:"SEP / ISSEA",especialidades:["Todas"],obligatorio:true},
  {id:"mm1",nivel:"municipal",clave:"Licencia Municipal",titulo:"Licencia municipal de funcionamiento",descripcion:"Trámite ante el H. Ayuntamiento de Aguascalientes para uso de suelo y licencia de funcionamiento.",autoridad:"Ayuntamiento de Aguascalientes",especialidades:["Todas"],obligatorio:true},
  {id:"mn1",nivel:"nom_universal",clave:"NOM-004-SSA3-2012",titulo:"Expediente clínico",descripcion:"Criterios para integración, uso, manejo, archivo y conservación del expediente clínico.",autoridad:"SSA",especialidades:["Todas"],obligatorio:true},
  {id:"mn2",nivel:"nom_universal",clave:"NOM-005-SSA3-2018",titulo:"Infraestructura y equipamiento — pacientes ambulatorios",descripcion:"⚠️ La versión 2010 fue abrogada. Vigente: 2018. Consultorios de medicina general, odontología y psicología.",autoridad:"SSA",especialidades:["Ambulatorio / Consultorio","Odontología"],obligatorio:true},
  {id:"mn3",nivel:"nom_universal",clave:"NOM-016-SSA3-2012",titulo:"Infraestructura y equipamiento — hospitales especializados",descripcion:"Características mínimas para hospitales. Verificación interna anual y externa cada 3 años.",autoridad:"SSA",especialidades:["Hospital","Ambulatorio / Consultorio"],obligatorio:true},
  {id:"mn4",nivel:"nom_universal",clave:"NOM-087-SEMARNAT-SSA1",titulo:"Residuos peligrosos biológico-infecciosos (RPBI)",descripcion:"Clasificación y manejo de RPBI. Obligatoria para cualquier establecimiento con agujas, sangre o material contaminado.",autoridad:"SEMARNAT / SSA",especialidades:["Todas"],obligatorio:true},
  {id:"mn5",nivel:"nom_universal",clave:"NOM-017-SSA2-2012",titulo:"Vigilancia epidemiológica",descripcion:"Notificación de enfermedades de reporte obligatorio al SINAVE.",autoridad:"SSA",especialidades:["Todas"],obligatorio:true},
  {id:"mn6",nivel:"nom_universal",clave:"NOM-030-SSA3-2013",titulo:"Accesibilidad para personas con discapacidad",descripcion:"Características arquitectónicas para facilitar el acceso. Obligatorio en obra nueva y remodelaciones.",autoridad:"SSA",especialidades:["Todas"],obligatorio:true},
  {id:"mne1",nivel:"nom_especialidad",clave:"NOM-007-SSA3-2011",titulo:"Laboratorios clínicos — organización y funcionamiento",descripcion:"Criterios de organización y funcionamiento de laboratorios clínicos.",autoridad:"SSA",especialidades:["Laboratorio Clínico"],obligatorio:true},
  {id:"mne2",nivel:"nom_especialidad",clave:"NOM-006-SSA3-2011",titulo:"Práctica de la anestesiología",descripcion:"Obligatoria para establecimientos con quirófano o procedimientos bajo anestesia.",autoridad:"SSA",especialidades:["Anestesiología / Cirugía","Hospital"],obligatorio:true},
  {id:"mne3",nivel:"nom_especialidad",clave:"NOM-002-SSA3-2017",titulo:"Servicios de radioterapia",descripcion:"Organización y funcionamiento. Versión actualizada 2017.",autoridad:"SSA",especialidades:["Radiología / Imagen"],obligatorio:true},
  {id:"mne4",nivel:"nom_especialidad",clave:"NOM-003-SSA3-2010",titulo:"Práctica de la hemodiálisis",descripcion:"Criterios para organización y funcionamiento de servicios de hemodiálisis.",autoridad:"SSA",especialidades:["Hemodiálisis / Nefrología"],obligatorio:true},
  {id:"mne5",nivel:"nom_especialidad",clave:"NOM-020-SSA-2025",titulo:"Atención integral materna y neonatal",descripcion:"Nueva norma 2025. Establecimientos de salud y reconocimiento de la partería.",autoridad:"SSA",especialidades:["Ginecología / Obstetricia","Hospital"],obligatorio:true,nuevo:true},
  {id:"mne6",nivel:"nom_especialidad",clave:"NOM-013-SSA2-2015",titulo:"Prevención y control de enfermedades bucales",descripcion:"Para consultorios de estomatología y odontología.",autoridad:"SSA",especialidades:["Odontología"],obligatorio:true},
  {id:"mne7",nivel:"nom_especialidad",clave:"NOM-241-SSA1-2025",titulo:"Fabricación de dispositivos médicos — BPF",descripcion:"Buenas Prácticas de Fabricación de Dispositivos Médicos. Publicada 2025.",autoridad:"SSA / COFEPRIS",especialidades:["Dispositivos Médicos"],obligatorio:true,nuevo:true},
  {id:"mnc1",nivel:"nom_complementaria",clave:"NOM-001-SEDE-2012",titulo:"Instalaciones eléctricas",descripcion:"Contactos grado hospital marcados con punto verde o leyenda 'grado médico'.",autoridad:"SEDE",especialidades:["Todas"],obligatorio:true},
  {id:"mnc2",nivel:"nom_complementaria",clave:"NOM-026-STPS-2008",titulo:"Colores y señales de seguridad",descripcion:"Señalización de seguridad e higiene e identificación de riesgos.",autoridad:"STPS",especialidades:["Todas"],obligatorio:true},
  {id:"ml1",nivel:"laboral",clave:"IMSS — Alta patronal",titulo:"Registro patronal y alta de trabajadores ante el IMSS",descripcion:"Todo establecimiento con personal debe registrarse como patrón.",autoridad:"IMSS",especialidades:["Todas"],obligatorio:true},
  {id:"ml2",nivel:"laboral",clave:"INFONAVIT",titulo:"Aportaciones al INFONAVIT",descripcion:"5% del salario base de cotización de cada trabajador, bimestralmente.",autoridad:"INFONAVIT",especialidades:["Todas"],obligatorio:true},
  {id:"ml3",nivel:"laboral",clave:"LFT — Contratos",titulo:"Contratos de trabajo (Ley Federal del Trabajo)",descripcion:"Todo trabajador debe contar con contrato escrito.",autoridad:"STPS",especialidades:["Todas"],obligatorio:true},
  {id:"ml4",nivel:"laboral",clave:"NOM-035-STPS-2018",titulo:"Factores de riesgo psicosocial",descripcion:"Identificación y prevención de riesgos psicosociales. Centros de trabajo con más de 15 trabajadores.",autoridad:"STPS",especialidades:["Todas"],obligatorio:true},
  {id:"ml5",nivel:"laboral",clave:"RIT — Art. 422 LFT",titulo:"Reglamento Interno de Trabajo (Art. 422 LFT)",descripcion:"Documento obligatorio que regula la relación laboral interna: jornada, horarios, lugares de prestación, días y forma de pago, permisos, sanciones y procedimientos disciplinarios. Debe registrarse ante el Centro Federal de Conciliación y Registro Laboral (CFCRL).",autoridad:"STPS / CFCRL",especialidades:["Todas"],obligatorio:true},
  {id:"mi1",nivel:"iso",clave:"ISO 9001:2015",titulo:"Sistema de Gestión de Calidad",descripcion:"Reconocido por aseguradoras (HDI, CHUBB) e instituciones de salud.",autoridad:"ISO / IMNC",especialidades:["Todas"],obligatorio:false},
  {id:"mi2",nivel:"iso",clave:"ISO 15189:2022",titulo:"Laboratorios clínicos — calidad y competencia",descripcion:"Estándar para acreditación ante EMA.",autoridad:"ISO / EMA",especialidades:["Laboratorio Clínico"],obligatorio:false},
];

// #endregion
// #region DATOS: RESTAURANTES
// ─── DATOS: RESTAURANTES ──────────────────────────────────────────────────────
const ESP_RESTAURANTE = ["Todas","Restaurante / Comedor","Bar / Cantina / Antro","Comida para llevar / Delivery","Cafetería / Pastelería","Cocina Central / Dark Kitchen","Expendio de Bebidas Alcohólicas"];
const REGS_RESTAURANTE: Regulacion[] = [
  {id:"rf1",nivel:"marco",esMarco:true,clave:"LGS — Alimentos",titulo:"Ley General de Salud — Control sanitario de alimentos",descripcion:"Arts. 194–216 regulan el control sanitario de la producción, elaboración, envasado, almacenamiento y distribución de alimentos.",autoridad:"Secretaría de Salud Federal",especialidades:["Todas"],obligatorio:true},
  {id:"rf2",nivel:"marco",esMarco:true,clave:"LFPC — Profeco",titulo:"Ley Federal de Protección al Consumidor",descripcion:"Regula información al consumidor: precios, porciones, ingredientes y condiciones de venta.",autoridad:"PROFECO",especialidades:["Todas"],obligatorio:true},
  {id:"rf3",nivel:"federal",clave:"Aviso COFEPRIS",titulo:"Aviso de funcionamiento ante COFEPRIS",descripcion:"Todo establecimiento que procese, prepare o expenda alimentos debe presentar aviso de funcionamiento.",autoridad:"COFEPRIS",especialidades:["Todas"],obligatorio:true},
  {id:"rf4",nivel:"federal",clave:"Ley IEPS — Alcoholes",titulo:"Ley del IEPS — Bebidas alcohólicas",descripcion:"Los establecimientos que venden bebidas alcohólicas deben cumplir con las obligaciones fiscales del IEPS.",autoridad:"SAT",especialidades:["Bar / Cantina / Antro","Expendio de Bebidas Alcohólicas","Restaurante / Comedor"],obligatorio:true},
  {id:"re1",nivel:"marco",esMarco:true,clave:"Ley Salud AGS — Alimentos",titulo:"Ley de Salud AGS — Sanidad alimentaria",descripcion:"Atribuciones del ISSEA para la vigilancia sanitaria de establecimientos de alimentos.",autoridad:"ISSEA / Gobierno del Estado",especialidades:["Todas"],obligatorio:true},
  {id:"re2",nivel:"marco",esMarco:true,clave:"Rgto. Bebidas Alcohólicas AGS",titulo:"Reglamento de Venta y Consumo de Bebidas Alcohólicas del Estado de AGS",descripcion:"Horarios de venta, distancias mínimas a escuelas e iglesias, requisitos del local.",autoridad:"Gobierno del Estado de Aguascalientes",especialidades:["Bar / Cantina / Antro","Expendio de Bebidas Alcohólicas","Restaurante / Comedor"],obligatorio:true},
  {id:"re3",nivel:"marco",esMarco:true,clave:"Ley Protección Civil AGS",titulo:"Ley de Protección Civil del Estado de Aguascalientes",descripcion:"Obligación de contar con programa interno de protección civil y dictamen favorable.",autoridad:"Coordinación Estatal de PC",especialidades:["Todas"],obligatorio:true},
  {id:"rm1",nivel:"municipal",clave:"Licencia de Funcionamiento",titulo:"Licencia municipal de funcionamiento",descripcion:"Trámite ante el H. Ayuntamiento. Requiere uso de suelo compatible, planos del local y pago de derechos.",autoridad:"Ayuntamiento — Desarrollo Económico",especialidades:["Todas"],obligatorio:true},
  {id:"rm2",nivel:"municipal",clave:"Uso de Suelo",titulo:"Constancia de uso de suelo compatible",descripcion:"Verifica que la actividad sea compatible con la zonificación del predio.",autoridad:"Ayuntamiento — Ordenamiento Territorial",especialidades:["Todas"],obligatorio:true},
  {id:"rm3",nivel:"municipal",clave:"Dictamen Protección Civil",titulo:"Dictamen de Protección Civil municipal",descripcion:"Verificación de salidas de emergencia, extintores, señalización y capacidad máxima.",autoridad:"Dirección de Protección Civil Municipal",especialidades:["Todas"],obligatorio:true},
  {id:"rm4",nivel:"municipal",clave:"Licencia de Alcoholes",titulo:"Licencia municipal para venta de bebidas alcohólicas",descripcion:"Requerida adicionalmente a la licencia de funcionamiento para establecimientos que expendan bebidas alcohólicas.",autoridad:"Ayuntamiento — Dirección de Alcoholes",especialidades:["Bar / Cantina / Antro","Expendio de Bebidas Alcohólicas","Restaurante / Comedor"],obligatorio:true},
  {id:"rm5",nivel:"municipal",clave:"Permiso de Anuncio",titulo:"Permiso de anuncio publicitario exterior",descripcion:"Cualquier letrero o anuncio exterior requiere permiso municipal.",autoridad:"Ayuntamiento de Aguascalientes",especialidades:["Todas"],obligatorio:true},
  {id:"rn1",nivel:"nom_universal",clave:"NOM-251-SSA1-2009",titulo:"Prácticas de higiene — proceso de alimentos",descripcion:"La norma más importante del sector. Requisitos mínimos de higiene en instalaciones, personal, materias primas, proceso y almacenamiento.",autoridad:"SSA / COFEPRIS",especialidades:["Todas"],obligatorio:true},
  {id:"rn2",nivel:"nom_universal",clave:"NOM-093-SSA1-1994",titulo:"Higiene y sanidad en establecimientos fijos de alimentos",descripcion:"Complementa la NOM-251. Específica para cocinas, área de servicio y manejo de residuos.",autoridad:"SSA",especialidades:["Restaurante / Comedor","Cafetería / Pastelería","Cocina Central / Dark Kitchen"],obligatorio:true},
  {id:"rn3",nivel:"nom_universal",clave:"NOM-051-SCFI/SSA1-2010",titulo:"Etiquetado de alimentos y bebidas no alcohólicas",descripcion:"Incluye tabla nutrimental y sellos de advertencia (reforma 2020).",autoridad:"SE / SSA",especialidades:["Todas"],obligatorio:true},
  {id:"rn4",nivel:"nom_universal",clave:"NOM-002-STPS-2010",titulo:"Prevención y protección contra incendios",descripcion:"Extintores, detectores de humo, rutas de evacuación y simulacros.",autoridad:"STPS",especialidades:["Todas"],obligatorio:true},
  {id:"rne1",nivel:"nom_especialidad",clave:"NOM-142-SSA1/SCFI-2014",titulo:"Bebidas alcohólicas — especificaciones sanitarias",descripcion:"Etiquetado, calidad y condiciones sanitarias para la venta de bebidas alcohólicas.",autoridad:"SSA / SE",especialidades:["Bar / Cantina / Antro","Expendio de Bebidas Alcohólicas","Restaurante / Comedor"],obligatorio:true},
  {id:"rnc1",nivel:"nom_complementaria",clave:"NOM-026-STPS-2008",titulo:"Colores y señales de seguridad",descripcion:"Señalización de rutas de evacuación, riesgos y extintores dentro del local.",autoridad:"STPS",especialidades:["Todas"],obligatorio:true},
  {id:"rnc2",nivel:"nom_complementaria",clave:"NOM-011-SEMARNAT-2001",titulo:"Niveles máximos permisibles de emisión de ruido",descripcion:"Aplica principalmente a bares, cantinas y antros.",autoridad:"SEMARNAT",especialidades:["Bar / Cantina / Antro"],obligatorio:true},
  {id:"rnc3",nivel:"nom_complementaria",clave:"NOM-001-SEMARNAT-2021",titulo:"Descargas de aguas residuales — trampa de grasas",descripcion:"Los establecimientos con descarga de grasas deben contar con trampa de grasas.",autoridad:"SEMARNAT",especialidades:["Restaurante / Comedor","Cocina Central / Dark Kitchen"],obligatorio:true},
  {id:"rl1",nivel:"laboral",clave:"IMSS — Alta patronal",titulo:"Registro patronal y alta de trabajadores",descripcion:"Todo establecimiento con personal debe registrarse como patrón.",autoridad:"IMSS",especialidades:["Todas"],obligatorio:true},
  {id:"rl2",nivel:"laboral",clave:"INFONAVIT",titulo:"Aportaciones al INFONAVIT",descripcion:"5% del salario base de cotización bimestral.",autoridad:"INFONAVIT",especialidades:["Todas"],obligatorio:true},
  {id:"rl3",nivel:"laboral",clave:"LFT — Contratos",titulo:"Contratos de trabajo individuales (LFT)",descripcion:"Todo trabajador debe contar con contrato escrito.",autoridad:"STPS",especialidades:["Todas"],obligatorio:true},
  {id:"rl4",nivel:"laboral",clave:"NOM-035-STPS-2018",titulo:"Factores de riesgo psicosocial",descripcion:"Aplica a centros de trabajo con más de 15 trabajadores.",autoridad:"STPS",especialidades:["Todas"],obligatorio:true},
  {id:"rl5",nivel:"laboral",clave:"RIT — Art. 422 LFT",titulo:"Reglamento Interno de Trabajo (Art. 422 LFT)",descripcion:"Documento obligatorio que regula la relación laboral interna: jornada, horarios, lugares de prestación, días y forma de pago, permisos, sanciones y procedimientos disciplinarios. Debe registrarse ante el Centro Federal de Conciliación y Registro Laboral (CFCRL).",autoridad:"STPS / CFCRL",especialidades:["Todas"],obligatorio:true},
  {id:"ri1",nivel:"iso",clave:"ISO 22000:2018",titulo:"Gestión de inocuidad alimentaria",descripcion:"Requerido por cadenas y franquicias. Cubre toda la cadena alimentaria.",autoridad:"ISO / IMNC",especialidades:["Todas"],obligatorio:false},
  {id:"ri2",nivel:"iso",clave:"HACCP / NMX-F-CC-22000",titulo:"Sistema HACCP — Análisis de peligros y puntos críticos",descripcion:"Metodología de análisis de riesgos. Requerida por compradores institucionales.",autoridad:"IMNC / Codex Alimentarius",especialidades:["Cocina Central / Dark Kitchen","Comida para llevar / Delivery"],obligatorio:false},
];

// #endregion
// #region DATOS: CONSTRUCCIÓN
// ─── DATOS: CONSTRUCCIÓN ──────────────────────────────────────────────────────
const ESP_CONSTRUCCION = ["Todas","Obra Nueva Habitacional","Obra Nueva Comercial / Industrial","Remodelación / Ampliación","Desarrolladora habitacional","Contratista / Empresa Constructora"];
const REGS_CONSTRUCCION: Regulacion[] = [
  // ── Marco federal ──────────────────────────────────────────────────────────
  {id:"cf1",nivel:"marco",esMarco:true,clave:"LGAH",titulo:"Ley General de Asentamientos Humanos y Desarrollo Urbano",descripcion:"Marco federal que regula el ordenamiento del territorio. Base de todos los planes de desarrollo municipales.",autoridad:"SEDATU",especialidades:["Todas"],obligatorio:true},
  {id:"cf2",nivel:"marco",esMarco:true,clave:"Ley de Vivienda",titulo:"Ley de Vivienda",descripcion:"Regula la producción, financiamiento y calidad de la vivienda. Aplica a desarrolladores con INFONAVIT, FOVISSSTE o FONHAPO.",autoridad:"CONAVI / SEDATU",especialidades:["Obra Nueva Habitacional","Desarrolladora habitacional"],obligatorio:true},
  {id:"cf3",nivel:"marco",esMarco:true,clave:"LGEEPA — MIA",titulo:"LGEEPA — Manifestación de Impacto Ambiental",descripcion:"Las obras con cierta escala o en zonas sensibles requieren MIA ante SEMARNAT antes de iniciar.",autoridad:"SEMARNAT",especialidades:["Obra Nueva Comercial / Industrial","Desarrolladora habitacional"],obligatorio:true},
  {id:"cf4",nivel:"federal",clave:"SAT — Obligaciones fiscales",titulo:"Régimen fiscal del contratista / desarrollador",descripcion:"ISR, IVA, CFDI por cada operación y retenciones de subcontratistas.",autoridad:"SAT",especialidades:["Todas"],obligatorio:true},
  // ── Estatal AGS ────────────────────────────────────────────────────────────
  {id:"ce1",nivel:"marco",esMarco:true,clave:"Código Urbano AGS",titulo:"Código Urbano del Estado de Aguascalientes",descripcion:"Regula el ordenamiento del territorio, usos de suelo y edificación. Base para licencias municipales.",autoridad:"SDUOT",especialidades:["Todas"],obligatorio:true},
  {id:"ce2",nivel:"marco",esMarco:true,clave:"Ley PC AGS — Obra",titulo:"Ley de Protección Civil del Estado de Aguascalientes",descripcion:"Las obras deben cumplir disposiciones de PC, incluyendo el Programa Interno y el dictamen al concluir.",autoridad:"Coordinación Estatal de PC",especialidades:["Obra Nueva Habitacional","Obra Nueva Comercial / Industrial"],obligatorio:true},
  {id:"ce3",nivel:"estatal",clave:"Programa Interno PC de Obra",titulo:"Programa Interno de Protección Civil de la Obra",descripcion:"Documento técnico que detalla los riesgos identificados y las medidas preventivas durante la ejecución de la obra. Complementa la Ley PC AGS.",autoridad:"Coordinación Estatal de PC",especialidades:["Obra Nueva Habitacional","Obra Nueva Comercial / Industrial","Contratista / Empresa Constructora"],obligatorio:true},
  {id:"ce4",nivel:"estatal",clave:"Padrón de Contratistas AGS",titulo:"Padrón de Contratistas del Estado de Aguascalientes",descripcion:"Inscripción para participar en licitaciones de obra pública estatal. Renovación anual. No es obligatorio para construcción privada, sí para licitar con gobierno del estado.",autoridad:"Secretaría de Obras Públicas e Infraestructura AGS",especialidades:["Contratista / Empresa Constructora"],obligatorio:false},
  // ── Municipal ──────────────────────────────────────────────────────────────
  {id:"cm1",nivel:"municipal",clave:"Licencia de Construcción",titulo:"Licencia de construcción",descripcion:"Trámite principal ante el H. Ayuntamiento para autorizar el inicio de cualquier obra. Requiere proyecto ejecutivo firmado por DRO.",autoridad:"Ayuntamiento — Obras Públicas",especialidades:["Todas"],obligatorio:true},
  {id:"cm2",nivel:"municipal",clave:"Uso de Suelo",titulo:"Constancia de uso de suelo y alineamiento",descripcion:"Verifica que el tipo de obra sea compatible con la zonificación.",autoridad:"Ayuntamiento — Ordenamiento Territorial",especialidades:["Todas"],obligatorio:true},
  {id:"cm3",nivel:"municipal",clave:"DRO",titulo:"Director Responsable de Obra (DRO)",descripcion:"Toda obra requiere un DRO registrado ante el Ayuntamiento.",autoridad:"Ayuntamiento / Colegio de Ingenieros",especialidades:["Todas"],obligatorio:true},
  {id:"cm4",nivel:"municipal",clave:"Constancia Terminación Obra",titulo:"Constancia de terminación de obra",descripcion:"Autoriza el uso y ocupación del inmueble una vez concluida la obra. En Aguascalientes el trámite se denomina formalmente 'Constancia de Terminación de Obra'.",autoridad:"Ayuntamiento — Obras Públicas",especialidades:["Obra Nueva Habitacional","Obra Nueva Comercial / Industrial"],obligatorio:true},
  {id:"cm5",nivel:"municipal",clave:"Reglamento de Construcciones AGS",titulo:"Reglamento de Construcciones del Municipio de Aguascalientes",descripcion:"Norma operativa cotidiana de la obra: requisitos técnicos, distancias, alturas, accesibilidad, seguridad estructural y términos de la licencia.",autoridad:"Ayuntamiento — Obras Públicas",especialidades:["Todas"],obligatorio:true},
  {id:"cm6",nivel:"municipal",clave:"Bitácora de Obra",titulo:"Bitácora de obra",descripcion:"Registro continuo de actividades, incidencias, cambios y firmas del DRO durante toda la obra. Documento exigible en revisiones municipales y dictámenes finales.",autoridad:"Ayuntamiento — Obras Públicas / DRO",especialidades:["Todas"],obligatorio:true},
  {id:"cm7",nivel:"municipal",clave:"Mecánica de Suelos",titulo:"Estudio de mecánica de suelos (geotecnia)",descripcion:"Estudio técnico previo a la licencia que define las condiciones del subsuelo y los parámetros para la cimentación. Lo realiza profesional certificado.",autoridad:"Ayuntamiento — Obras Públicas",especialidades:["Obra Nueva Habitacional","Obra Nueva Comercial / Industrial"],obligatorio:true},
  {id:"cm8",nivel:"municipal",clave:"Avisos de Obra",titulo:"Manifiesto de inicio y terminación de obra",descripcion:"Avisos formales al Ayuntamiento al comenzar y al concluir la obra. Disparan inspecciones y cierran administrativamente la licencia.",autoridad:"Ayuntamiento — Obras Públicas",especialidades:["Todas"],obligatorio:true},
  // ── NOMs universales ──────────────────────────────────────────────────────
  {id:"cn1",nivel:"nom_universal",clave:"NOM-001-SEDE-2018",titulo:"Instalaciones eléctricas (utilización)",descripcion:"El proyecto eléctrico del edificio debe cumplir con esta norma. Versión vigente desde 2018 (sustituyó a la NOM-001-SEDE-2012).",autoridad:"SENER / CRE",especialidades:["Todas"],obligatorio:true},
  // ── NOMs de especialidad ──────────────────────────────────────────────────
  {id:"cne1",nivel:"nom_especialidad",clave:"NOM-031-STPS-2011",titulo:"Construcción — Condiciones de seguridad y salud",descripcion:"La norma más importante para empresas constructoras: andamios, excavaciones, maquinaria, EPP y capacitación.",autoridad:"STPS",especialidades:["Contratista / Empresa Constructora","Obra Nueva Habitacional","Obra Nueva Comercial / Industrial"],obligatorio:true},
  {id:"cne2",nivel:"nom_especialidad",clave:"NOM-020-ENER-2011",titulo:"Eficiencia energética — edificaciones habitacionales",descripcion:"Especificaciones de aislamiento térmico para vivienda nueva.",autoridad:"SENER / CONUEE",especialidades:["Obra Nueva Habitacional","Desarrolladora habitacional"],obligatorio:true},
  {id:"cne3",nivel:"nom_especialidad",clave:"NOM-247-SE-2021",titulo:"Contratos de adhesión para vivienda",descripcion:"Regula los contratos de compraventa de vivienda nueva.",autoridad:"PROFECO / SE",especialidades:["Desarrolladora habitacional"],obligatorio:true},
  {id:"cne4",nivel:"nom_especialidad",clave:"NOM-009-STPS-2011",titulo:"Trabajos en altura — Condiciones de seguridad",descripcion:"Riesgo crítico en construcción. Define EPP, sistemas de detención de caídas, anclajes, capacitación y supervisión para trabajo a más de 1.80 m.",autoridad:"STPS",especialidades:["Contratista / Empresa Constructora","Obra Nueva Habitacional","Obra Nueva Comercial / Industrial"],obligatorio:true},
  {id:"cne5",nivel:"nom_especialidad",clave:"NOM-018-STPS-2015",titulo:"Sustancias químicas peligrosas — SGA",descripcion:"Identificación, etiquetado y comunicación de peligros para sustancias químicas usadas en obra (solventes, adhesivos, aditivos, combustibles).",autoridad:"STPS",especialidades:["Contratista / Empresa Constructora"],obligatorio:true},
  // ── NOMs complementarias ──────────────────────────────────────────────────
  {id:"cnc1",nivel:"nom_complementaria",clave:"NOM-026-STPS-2008",titulo:"Colores y señales de seguridad",descripcion:"Señalización dentro de la obra y en el edificio terminado.",autoridad:"STPS",especialidades:["Todas"],obligatorio:true},
  // ── Laboral ───────────────────────────────────────────────────────────────
  {id:"cl1",nivel:"laboral",clave:"IMSS — Alta patronal",titulo:"Registro patronal y alta de trabajadores",descripcion:"La empresa constructora debe registrar a TODOS sus trabajadores, incluyendo jornaleros.",autoridad:"IMSS",especialidades:["Todas"],obligatorio:true},
  {id:"cl2",nivel:"laboral",clave:"INFONAVIT",titulo:"Aportaciones al INFONAVIT",descripcion:"5% del salario base de cotización bimestral.",autoridad:"INFONAVIT",especialidades:["Todas"],obligatorio:true},
  {id:"cl3",nivel:"laboral",clave:"REPSE",titulo:"Registro de Prestadoras de Servicios Especializados (REPSE)",descripcion:"Desde la reforma laboral 2021, las subcontratistas deben registrarse en el REPSE. Implica cumplimiento ante STPS y reportes informativos al SAT (ICSOE/SISUB).",autoridad:"STPS / SAT",especialidades:["Contratista / Empresa Constructora","Desarrolladora habitacional"],obligatorio:true},
  {id:"cl4",nivel:"laboral",clave:"RIT — Art. 422 LFT",titulo:"Reglamento Interno de Trabajo (Art. 422 LFT)",descripcion:"Documento obligatorio que regula la relación laboral interna: jornada, horarios, lugares de prestación, días y forma de pago, permisos, sanciones y procedimientos disciplinarios. Debe registrarse ante el Centro Federal de Conciliación y Registro Laboral (CFCRL).",autoridad:"STPS / CFCRL",especialidades:["Todas"],obligatorio:true},
  // ── ISO ───────────────────────────────────────────────────────────────────
  {id:"ci1",nivel:"iso",clave:"ISO 9001:2015",titulo:"Sistema de Gestión de Calidad",descripcion:"Requerido para licitaciones de obra pública y clientes corporativos.",autoridad:"ISO / IMNC",especialidades:["Contratista / Empresa Constructora","Desarrolladora habitacional"],obligatorio:false},
  {id:"ci2",nivel:"iso",clave:"ISO 45001:2018",titulo:"Seguridad y salud en el trabajo",descripcion:"El sector construcción es el de mayor siniestralidad en México.",autoridad:"ISO / IMNC",especialidades:["Contratista / Empresa Constructora"],obligatorio:false},
];

// #endregion
// #region DATOS: INMOBILIARIO
// ─── DATOS: INMOBILIARIO ──────────────────────────────────────────────────────
const ESP_INMOBILIARIO = ["Todas","Agencia Inmobiliaria","Arrendador Individual","Administración de Propiedades","Valuación Inmobiliaria","Fraccionamiento / Desarrollo","Inmuebles Comerciales / Oficinas"];
const REGS_INMOBILIARIO: Regulacion[] = [
  {id:"if1",nivel:"marco",esMarco:true,clave:"Código Civil Federal",titulo:"Código Civil Federal — Arrendamiento y compraventa",descripcion:"Arts. 2398–2496 regulan el arrendamiento. Arts. 2248–2326 regulan la compraventa. Marco base de toda operación inmobiliaria.",autoridad:"Congreso de la Unión",especialidades:["Todas"],obligatorio:true},
  {id:"if2",nivel:"marco",esMarco:true,clave:"Ley Antilavado (LFPIORPI)",titulo:"Ley Federal para la Prevención e Identificación de Operaciones con Recursos de Procedencia Ilícita",descripcion:"Las compraventas de alto valor están sujetas a obligaciones KYC, avisos al SAT y registros ante la UIF.",autoridad:"SAT / SHCP / UIF",especialidades:["Agencia Inmobiliaria","Fraccionamiento / Desarrollo","Inmuebles Comerciales / Oficinas"],obligatorio:true},
  {id:"if3",nivel:"marco",esMarco:true,clave:"SAT — Arrendamiento",titulo:"Obligaciones fiscales del arrendador (ISR, IVA, CFDI)",descripcion:"El arrendador persona física debe declarar ingresos por rentas. El arrendamiento comercial causa IVA.",autoridad:"SAT",especialidades:["Todas"],obligatorio:true},
  {id:"ie1",nivel:"marco",esMarco:true,clave:"Código Civil AGS",titulo:"Código Civil del Estado de Aguascalientes — Arrendamiento",descripcion:"Regula el contrato de arrendamiento local: plazos mínimos, obligaciones del arrendador y arrendatario.",autoridad:"Congreso del Estado de Aguascalientes",especialidades:["Todas"],obligatorio:true},
  {id:"ie2",nivel:"marco",esMarco:true,clave:"Ley del Notariado AGS",titulo:"Ley del Notariado del Estado de Aguascalientes",descripcion:"Toda compraventa de inmueble debe formalizarse ante Notario Público.",autoridad:"Colegio de Notarios AGS",especialidades:["Agencia Inmobiliaria","Fraccionamiento / Desarrollo","Arrendador Individual"],obligatorio:true},
  {id:"im1",nivel:"municipal",clave:"Catastro Municipal",titulo:"Alta catastral y pago del impuesto predial",descripcion:"Todo inmueble debe estar dado de alta en el Catastro. El predial se paga anualmente.",autoridad:"Dirección de Catastro — Ayuntamiento",especialidades:["Todas"],obligatorio:true},
  {id:"im2",nivel:"municipal",clave:"RPP — Traslado de dominio",titulo:"Inscripción en el Registro Público de la Propiedad (RPP)",descripcion:"Toda compraventa debe inscribirse en el RPP para que el nuevo propietario tenga derechos frente a terceros.",autoridad:"Registro Público de la Propiedad AGS",especialidades:["Agencia Inmobiliaria","Fraccionamiento / Desarrollo","Arrendador Individual"],obligatorio:true},
  {id:"im3",nivel:"municipal",clave:"ISAI",titulo:"Impuesto Sobre Adquisición de Inmuebles (ISAI)",descripcion:"Impuesto local del 2% sobre el valor de la operación en cada traslado de dominio.",autoridad:"Secretaría de Finanzas del Estado AGS",especialidades:["Agencia Inmobiliaria","Fraccionamiento / Desarrollo","Arrendador Individual"],obligatorio:true},
  {id:"in1",nivel:"nom_universal",clave:"NOM-247-SE-2021",titulo:"Contratos de adhesión para vivienda nueva",descripcion:"Condiciones mínimas de los contratos de compraventa de vivienda nueva.",autoridad:"PROFECO / SE",especialidades:["Fraccionamiento / Desarrollo","Agencia Inmobiliaria"],obligatorio:true},
  {id:"ine1",nivel:"nom_especialidad",clave:"NOM-019-SSPF-2011",titulo:"Valuación de inmuebles — Metodología y requisitos",descripcion:"Establece la metodología y requisitos para la valuación de inmuebles.",autoridad:"Sociedad Hipotecaria Federal / SSPF",especialidades:["Valuación Inmobiliaria"],obligatorio:true},
  {id:"inc1",nivel:"nom_complementaria",clave:"LGPDPPP",titulo:"Ley General de Protección de Datos Personales",descripcion:"Las agencias que recopilan datos de clientes deben cumplir con aviso de privacidad y medidas de seguridad.",autoridad:"INAI",especialidades:["Agencia Inmobiliaria","Administración de Propiedades"],obligatorio:true},
  {id:"il1",nivel:"laboral",clave:"IMSS — Alta patronal",titulo:"Registro patronal y alta de agentes ante el IMSS",descripcion:"Las agencias con agentes en nómina deben registrarse ante el IMSS.",autoridad:"IMSS",especialidades:["Agencia Inmobiliaria","Administración de Propiedades"],obligatorio:true},
  {id:"il2",nivel:"laboral",clave:"LFT — Contratos agentes",titulo:"Contratos de trabajo o prestación de servicios",descripcion:"Definir correctamente si los agentes son empleados o independientes.",autoridad:"STPS",especialidades:["Agencia Inmobiliaria"],obligatorio:true},
  {id:"il3",nivel:"laboral",clave:"RIT — Art. 422 LFT",titulo:"Reglamento Interno de Trabajo (Art. 422 LFT)",descripcion:"Documento obligatorio que regula la relación laboral interna: jornada, horarios, lugares de prestación, días y forma de pago, permisos, sanciones y procedimientos disciplinarios. Debe registrarse ante el Centro Federal de Conciliación y Registro Laboral (CFCRL).",autoridad:"STPS / CFCRL",especialidades:["Agencia Inmobiliaria","Administración de Propiedades"],obligatorio:true},
  {id:"ii1",nivel:"iso",clave:"ISO 9001:2015",titulo:"Sistema de Gestión de Calidad",descripcion:"Para agencias que buscan diferenciarse mediante procesos estandarizados.",autoridad:"ISO / IMNC",especialidades:["Agencia Inmobiliaria","Administración de Propiedades"],obligatorio:false},
];

// #endregion
// #region DATOS: COMERCIO
// ─── DATOS: COMERCIO ──────────────────────────────────────────────────────────
const ESP_COMERCIO = ["Todas","Tienda de Ropa / Calzado","Farmacia / Botica","Abarrotes / Minisuper","Ferretería / Tlapalería","Joyería / Relojería","Óptica","Juguetería / Artículos Deportivos"];
const REGS_COMERCIO: Regulacion[] = [
  {id:"comf1",nivel:"marco",esMarco:true,clave:"LFPC",titulo:"Ley Federal de Protección al Consumidor",descripcion:"Regula precios, etiquetado, garantías, devoluciones y prácticas comerciales. PROFECO puede inspeccionar en cualquier momento.",autoridad:"PROFECO",especialidades:["Todas"],obligatorio:true},
  {id:"comf2",nivel:"marco",esMarco:true,clave:"SAT — Régimen fiscal",titulo:"Obligaciones fiscales: RFC, CFDI, régimen fiscal",descripcion:"RFC activo, emitir CFDI por cada venta y estar en el régimen fiscal correcto.",autoridad:"SAT",especialidades:["Todas"],obligatorio:true},
  {id:"comf3",nivel:"federal",clave:"Aviso COFEPRIS",titulo:"Aviso de funcionamiento ante COFEPRIS",descripcion:"Requerido para establecimientos que venden medicamentos, cosméticos o alimentos envasados.",autoridad:"COFEPRIS",especialidades:["Farmacia / Botica","Abarrotes / Minisuper"],obligatorio:true},
  {id:"comf4",nivel:"marco",esMarco:true,clave:"LGPDPPP",titulo:"Ley General de Protección de Datos Personales",descripcion:"Los establecimientos con programas de lealtad o facturación deben tener aviso de privacidad.",autoridad:"INAI",especialidades:["Todas"],obligatorio:true},
  {id:"come1",nivel:"marco",esMarco:true,clave:"Ley del Consumidor AGS",titulo:"Ley de Protección al Consumidor del Estado de Aguascalientes",descripcion:"Complementa la LFPC. La PROCO puede realizar verificaciones e imponer sanciones.",autoridad:"PROCO AGS",especialidades:["Todas"],obligatorio:true},
  {id:"comm1",nivel:"municipal",clave:"Licencia de Funcionamiento",titulo:"Licencia municipal de funcionamiento",descripcion:"Trámite indispensable ante el H. Ayuntamiento. Debe renovarse anualmente.",autoridad:"Ayuntamiento — Desarrollo Económico",especialidades:["Todas"],obligatorio:true},
  {id:"comm2",nivel:"municipal",clave:"Uso de Suelo",titulo:"Constancia de uso de suelo compatible",descripcion:"El giro comercial debe ser compatible con la zonificación del predio.",autoridad:"Ayuntamiento — Ordenamiento Territorial",especialidades:["Todas"],obligatorio:true},
  {id:"comm3",nivel:"municipal",clave:"Dictamen Protección Civil",titulo:"Dictamen de Protección Civil municipal",descripcion:"Verificación de extintores, señalización de emergencia y salidas del local.",autoridad:"Dirección de Protección Civil Municipal",especialidades:["Todas"],obligatorio:true},
  {id:"comn1",nivel:"nom_universal",clave:"NOM-050-SCFI-2004",titulo:"Información comercial — Etiquetado general de productos",descripcion:"Todos los productos deben tener etiqueta en español con denominación, país de origen y contenido neto.",autoridad:"SE / PROFECO",especialidades:["Todas"],obligatorio:true},
  {id:"comn2",nivel:"nom_universal",clave:"NOM-051-SCFI/SSA1-2010",titulo:"Etiquetado de alimentos y bebidas",descripcion:"Incluye sellos de advertencia desde 2020.",autoridad:"SE / SSA",especialidades:["Abarrotes / Minisuper","Farmacia / Botica"],obligatorio:true},
  {id:"comn3",nivel:"nom_universal",clave:"NOM-002-STPS-2010",titulo:"Prevención y protección contra incendios",descripcion:"Extintores, detectores de humo y señalización de rutas de evacuación.",autoridad:"STPS",especialidades:["Todas"],obligatorio:true},
  {id:"comne1",nivel:"nom_especialidad",clave:"NOM-072-SSA1-2012",titulo:"Etiquetado de medicamentos — Farmacias y boticas",descripcion:"Todo medicamento debe tener número de registro sanitario, leyendas de advertencia y fecha de caducidad.",autoridad:"SSA / COFEPRIS",especialidades:["Farmacia / Botica"],obligatorio:true},
  {id:"comne2",nivel:"nom_especialidad",clave:"NOM-059-SSA1-2015",titulo:"Farmacias — Buenas prácticas de almacenamiento",descripcion:"Condiciones de almacenamiento, temperatura y humedad. Incluye manejo de psicotrópicos.",autoridad:"SSA / COFEPRIS",especialidades:["Farmacia / Botica"],obligatorio:true},
  {id:"comne3",nivel:"nom_especialidad",clave:"NOM-004-SE-2021",titulo:"Textiles y ropa — Etiquetado de fibras",descripcion:"Toda prenda debe tener etiqueta con composición de fibras, instrucciones de lavado y país de fabricación.",autoridad:"SE",especialidades:["Tienda de Ropa / Calzado"],obligatorio:true},
  {id:"comne4",nivel:"nom_especialidad",clave:"NOM-016-SCFI-2015",titulo:"Joyería — Metales preciosos, etiquetado y calidad",descripcion:"Las joyas de metales preciosos deben tener marcado de ley y etiqueta con composición.",autoridad:"SE",especialidades:["Joyería / Relojería"],obligatorio:true},
  {id:"comne5",nivel:"nom_especialidad",clave:"NOM-274-SCFI-2017",titulo:"Ópticas — Lentes oftálmicos, requisitos y etiquetado",descripcion:"Los lentes deben cumplir con características ópticas mínimas. Las ópticas deben contar con personal calificado.",autoridad:"SE / SSA",especialidades:["Óptica"],obligatorio:true},
  {id:"comnc1",nivel:"nom_complementaria",clave:"NOM-026-STPS-2008",titulo:"Colores y señales de seguridad",descripcion:"Señalización de rutas de emergencia, extintores y áreas de restricción.",autoridad:"STPS",especialidades:["Todas"],obligatorio:true},
  {id:"coml1",nivel:"laboral",clave:"IMSS — Alta patronal",titulo:"Registro patronal y alta de trabajadores",descripcion:"Todo comercio con trabajadores debe registrarse como patrón.",autoridad:"IMSS",especialidades:["Todas"],obligatorio:true},
  {id:"coml2",nivel:"laboral",clave:"INFONAVIT",titulo:"Aportaciones al INFONAVIT",descripcion:"5% del salario base de cotización bimestral.",autoridad:"INFONAVIT",especialidades:["Todas"],obligatorio:true},
  {id:"coml3",nivel:"laboral",clave:"LFT — Contratos",titulo:"Contratos de trabajo (LFT)",descripcion:"Todo trabajador debe contar con contrato escrito.",autoridad:"STPS",especialidades:["Todas"],obligatorio:true},
  {id:"coml4",nivel:"laboral",clave:"NOM-035-STPS-2018",titulo:"Factores de riesgo psicosocial",descripcion:"Aplica a establecimientos con más de 15 trabajadores.",autoridad:"STPS",especialidades:["Todas"],obligatorio:true},
  {id:"coml5",nivel:"laboral",clave:"RIT — Art. 422 LFT",titulo:"Reglamento Interno de Trabajo (Art. 422 LFT)",descripcion:"Documento obligatorio que regula la relación laboral interna: jornada, horarios, lugares de prestación, días y forma de pago, permisos, sanciones y procedimientos disciplinarios. Debe registrarse ante el Centro Federal de Conciliación y Registro Laboral (CFCRL).",autoridad:"STPS / CFCRL",especialidades:["Todas"],obligatorio:true},
];

// #endregion
// #region DATOS: MANUFACTURA
// ─── DATOS: MANUFACTURA ───────────────────────────────────────────────────────
const ESP_MANUFACTURA = ["Todas","Industria Automotriz / Autopartes","Industria Textil / Confección","Agroindustria / Alimentos Procesados","Metal-mecánica / Maquinado","Industria Química / Plásticos","Electrónica / Electrodomésticos"];
const REGS_MANUFACTURA: Regulacion[] = [
  {id:"manf1",nivel:"marco",esMarco:true,clave:"LGEEPA — Industria",titulo:"Ley General del Equilibrio Ecológico y Protección al Ambiente",descripcion:"Marco ambiental federal. Toda planta industrial con emisiones, residuos peligrosos o descargas debe tramitar autorizaciones ante SEMARNAT. Base de la Licencia Ambiental Única (LAU).",autoridad:"SEMARNAT",especialidades:["Todas"],obligatorio:true},
  {id:"manf2",nivel:"marco",esMarco:true,clave:"Ley Federal del Trabajo",titulo:"Ley Federal del Trabajo — Industria",descripcion:"Regula las condiciones laborales en plantas industriales: jornadas, descansos, salarios, sindicatos y contratos colectivos.",autoridad:"STPS",especialidades:["Todas"],obligatorio:true},
  {id:"manf3",nivel:"federal",clave:"Ley Aduanera — IMMEX",titulo:"Ley Aduanera — Programa IMMEX (Maquiladoras)",descripcion:"Las empresas que importan temporalmente materiales para transformación y exportación deben estar registradas en el Programa IMMEX ante la SE.",autoridad:"SE / SHCP",especialidades:["Industria Automotriz / Autopartes","Electrónica / Electrodomésticos","Industria Textil / Confección"],obligatorio:false},
  {id:"manf4",nivel:"marco",esMarco:true,clave:"SAT — Obligaciones fiscales",titulo:"Obligaciones fiscales: ISR, IVA, CFDI, DIOT",descripcion:"Las plantas industriales deben emitir CFDI por cada operación, presentar declaraciones de IVA y DIOT con sus proveedores.",autoridad:"SAT",especialidades:["Todas"],obligatorio:true},
  {id:"manf5",nivel:"federal",clave:"COFEPRIS — Alimentos procesados",titulo:"Licencia Sanitaria o Aviso ante COFEPRIS",descripcion:"Las plantas que procesan alimentos, bebidas o cosméticos deben contar con licencia sanitaria o aviso según el nivel de riesgo.",autoridad:"COFEPRIS",especialidades:["Agroindustria / Alimentos Procesados"],obligatorio:true},
  {id:"manf6",nivel:"federal",clave:"REPSE — Subcontratación",titulo:"Registro de Prestadoras de Servicios Especializados (REPSE)",descripcion:"Desde la reforma laboral de 2021, las empresas que presten servicios especializados deben estar registradas en el REPSE.",autoridad:"STPS",especialidades:["Todas"],obligatorio:true},
  {id:"mane1",nivel:"marco",esMarco:true,clave:"Ley Ambiental AGS",titulo:"Ley Ambiental del Estado de Aguascalientes",descripcion:"Regula las actividades industriales con potencial impacto ambiental dentro del estado.",autoridad:"IMA — Instituto del Medio Ambiente AGS",especialidades:["Todas"],obligatorio:true},
  {id:"mane2",nivel:"marco",esMarco:true,clave:"Ley Protección Civil AGS",titulo:"Ley de Protección Civil del Estado de Aguascalientes",descripcion:"Las plantas industriales deben contar con Programa Interno de Protección Civil, brigadas capacitadas y simulacros periódicos.",autoridad:"Coordinación Estatal de PC",especialidades:["Todas"],obligatorio:true},
  {id:"mane3",nivel:"marco",esMarco:true,clave:"Código Urbano AGS — Industrial",titulo:"Código Urbano AGS — Uso de suelo industrial",descripcion:"El predio donde se instala la planta debe tener uso de suelo industrial compatible.",autoridad:"SDUOT",especialidades:["Todas"],obligatorio:true},
  {id:"manm1",nivel:"municipal",clave:"Licencia de Funcionamiento",titulo:"Licencia municipal de funcionamiento industrial",descripcion:"Trámite ante el H. Ayuntamiento. Para plantas industriales incluye verificación de uso de suelo e impacto vial.",autoridad:"Ayuntamiento — Desarrollo Económico",especialidades:["Todas"],obligatorio:true},
  {id:"manm2",nivel:"municipal",clave:"Dictamen Protección Civil",titulo:"Dictamen de Protección Civil municipal — Planta industrial",descripcion:"Verificación de sistemas de supresión de incendios, alarmas, EPP disponible y rutas de evacuación.",autoridad:"Dirección de PC Municipal",especialidades:["Todas"],obligatorio:true},
  {id:"mann1",nivel:"nom_universal",clave:"NOM-001-STPS-2008",titulo:"Edificios, locales e instalaciones — Condiciones de seguridad",descripcion:"Condiciones mínimas de seguridad e higiene en edificios e instalaciones: pisos, techos, escaleras, iluminación y ventilación.",autoridad:"STPS",especialidades:["Todas"],obligatorio:true},
  {id:"mann2",nivel:"nom_universal",clave:"NOM-002-STPS-2010",titulo:"Prevención y protección contra incendios",descripcion:"Sistemas de detección y extinción, rutas de evacuación y simulacros. En plantas aplica con mayor rigor por materiales inflamables.",autoridad:"STPS",especialidades:["Todas"],obligatorio:true},
  {id:"mann3",nivel:"nom_universal",clave:"NOM-004-STPS-1999",titulo:"Sistemas de protección y dispositivos de seguridad en maquinaria",descripcion:"Toda maquinaria de producción debe contar con guardas y dispositivos de paro de emergencia.",autoridad:"STPS",especialidades:["Todas"],obligatorio:true},
  {id:"mann4",nivel:"nom_universal",clave:"NOM-017-STPS-2008",titulo:"Equipo de Protección Personal (EPP) — Selección y uso",descripcion:"El patrón debe proporcionar el EPP adecuado al riesgo de cada puesto de manera gratuita.",autoridad:"STPS",especialidades:["Todas"],obligatorio:true},
  {id:"mann5",nivel:"nom_universal",clave:"NOM-026-STPS-2008",titulo:"Colores y señales de seguridad e higiene",descripcion:"Señalización de riesgos, rutas de evacuación y tuberías. Es de las normas más verificadas en inspecciones de la STPS.",autoridad:"STPS",especialidades:["Todas"],obligatorio:true},
  {id:"mann6",nivel:"nom_universal",clave:"NOM-001-SEDE-2012",titulo:"Instalaciones eléctricas industriales",descripcion:"Las instalaciones eléctricas de la planta deben cumplir con esta norma. Aplica con mayor exigencia por las altas cargas eléctricas.",autoridad:"SEDE",especialidades:["Todas"],obligatorio:true},
  {id:"manne1",nivel:"nom_especialidad",clave:"NOM-010-STPS-2014",titulo:"Agentes químicos contaminantes — Exposición laboral",descripcion:"Establece los valores límite de exposición a agentes químicos. Obliga a medir concentraciones periódicamente.",autoridad:"STPS",especialidades:["Industria Química / Plásticos","Metal-mecánica / Maquinado"],obligatorio:true},
  {id:"manne2",nivel:"nom_especialidad",clave:"NOM-011-STPS-2001",titulo:"Ruido — Condiciones de seguridad e higiene",descripcion:"Niveles máximos de ruido permisibles. La exposición a más de 85 dB por 8 horas obliga a implementar controles.",autoridad:"STPS",especialidades:["Metal-mecánica / Maquinado","Industria Automotriz / Autopartes","Industria Textil / Confección"],obligatorio:true},
  {id:"manne3",nivel:"nom_especialidad",clave:"NOM-018-STPS-2015",titulo:"Sistema armonizado para comunicación de peligros — Hojas de datos",descripcion:"Sistema GHS para comunicación de peligros de sustancias químicas. Hojas de datos de seguridad (SDS) en español.",autoridad:"STPS",especialidades:["Industria Química / Plásticos","Metal-mecánica / Maquinado"],obligatorio:true},
  {id:"manne4",nivel:"nom_especialidad",clave:"NOM-020-STPS-2011",titulo:"Recipientes sujetos a presión y generadores de vapor",descripcion:"Aplica a plantas con calderas, compresores o autoclaves. Requiere registro, operadores certificados e inspecciones periódicas.",autoridad:"STPS",especialidades:["Industria Química / Plásticos","Agroindustria / Alimentos Procesados","Metal-mecánica / Maquinado"],obligatorio:true},
  {id:"manne5",nivel:"nom_especialidad",clave:"NOM-022-STPS-2015",titulo:"Electricidad estática — Condiciones de seguridad",descripcion:"Aplica a industrias donde la electricidad estática puede provocar explosión o incendio: plásticos, química, textil.",autoridad:"STPS",especialidades:["Industria Química / Plásticos","Industria Textil / Confección"],obligatorio:true},
  {id:"manne6",nivel:"nom_especialidad",clave:"NOM-027-STPS-2008",titulo:"Actividades de soldadura y corte — Condiciones de seguridad",descripcion:"Condiciones de seguridad en soldadura y corte: ventilación, EPP específico y protección contra radiación UV.",autoridad:"STPS",especialidades:["Metal-mecánica / Maquinado","Industria Automotriz / Autopartes"],obligatorio:true},
  {id:"manne7",nivel:"nom_especialidad",clave:"NOM-036-STPS-2018",titulo:"Factores de riesgo ergonómico — Evaluación y control",descripcion:"Evaluar y controlar riesgos ergonómicos: levantamiento de cargas, posturas forzadas y movimientos repetitivos.",autoridad:"STPS",especialidades:["Industria Automotriz / Autopartes","Electrónica / Electrodomésticos","Industria Textil / Confección"],obligatorio:true},
  {id:"manne8",nivel:"nom_especialidad",clave:"NOM-033-STPS-2015",titulo:"Espacios confinados — Condiciones de seguridad",descripcion:"Regula el trabajo en espacios confinados: fosos, tanques, silos. Requiere permiso de trabajo y prueba de atmósfera.",autoridad:"STPS",especialidades:["Metal-mecánica / Maquinado","Industria Química / Plásticos"],obligatorio:true},
  {id:"manne9",nivel:"nom_especialidad",clave:"NOM-043-SEMARNAT-1993",titulo:"Partículas suspendidas y emisiones a la atmósfera — Fuentes fijas",descripcion:"Regula las emisiones de partículas de fuentes fijas como chimeneas industriales. Obliga a realizar monitoreos periódicos.",autoridad:"SEMARNAT",especialidades:["Metal-mecánica / Maquinado","Industria Química / Plásticos","Agroindustria / Alimentos Procesados"],obligatorio:true},
  {id:"manne10",nivel:"nom_especialidad",clave:"NOM-052-SEMARNAT-2005",titulo:"Residuos peligrosos — Características y listados",descripcion:"Define qué residuos son peligrosos. Obliga a llevar un registro y enviarlos a confinamiento certificado.",autoridad:"SEMARNAT",especialidades:["Metal-mecánica / Maquinado","Industria Química / Plásticos","Industria Automotriz / Autopartes"],obligatorio:true},
  {id:"manne11",nivel:"nom_especialidad",clave:"NOM-251-SSA1-2009",titulo:"Prácticas de higiene — Proceso de alimentos y suplementos",descripcion:"La norma más importante para la agroindustria. Requisitos mínimos de higiene en instalaciones y procesos de producción.",autoridad:"SSA / COFEPRIS",especialidades:["Agroindustria / Alimentos Procesados"],obligatorio:true},
  {id:"mannc1",nivel:"nom_complementaria",clave:"NOM-006-STPS-2014",titulo:"Manejo y almacenamiento de materiales — Condiciones de seguridad",descripcion:"Condiciones para el manejo manual y mecánico de materiales: montacargas, grúas, patines y almacenamiento en estantería.",autoridad:"STPS",especialidades:["Todas"],obligatorio:true},
  {id:"mannc2",nivel:"nom_complementaria",clave:"NOM-009-STPS-2011",titulo:"Trabajos en altura — Condiciones de seguridad",descripcion:"Aplica cuando los trabajadores realizan actividades a más de 1.8 metros de altura.",autoridad:"STPS",especialidades:["Todas"],obligatorio:true},
  {id:"mannc3",nivel:"nom_complementaria",clave:"NOM-029-STPS-2011",titulo:"Mantenimiento de instalaciones eléctricas — Procedimientos LOTO",descripcion:"Regula el bloqueo y etiquetado (LOTO) de energías peligrosas durante el mantenimiento. Una de las normas más violadas.",autoridad:"STPS",especialidades:["Todas"],obligatorio:true},
  {id:"mannc4",nivel:"nom_complementaria",clave:"NOM-001-SEMARNAT-2021",titulo:"Descargas de aguas residuales industriales",descripcion:"Las plantas con descarga de aguas residuales deben cumplir con los límites permisibles y tramitar el permiso ante CONAGUA.",autoridad:"SEMARNAT / CONAGUA",especialidades:["Industria Química / Plásticos","Agroindustria / Alimentos Procesados","Metal-mecánica / Maquinado"],obligatorio:true},
  {id:"manl1",nivel:"laboral",clave:"IMSS — Alta patronal",titulo:"Registro patronal y alta de trabajadores ante el IMSS",descripcion:"Toda planta con trabajadores debe estar registrada como patrón. Las multas por trabajadores no asegurados son elevadas.",autoridad:"IMSS",especialidades:["Todas"],obligatorio:true},
  {id:"manl2",nivel:"laboral",clave:"INFONAVIT",titulo:"Aportaciones al INFONAVIT",descripcion:"5% del salario base de cotización bimestral. En empresas con cientos de empleados el incumplimiento acumula créditos fiscales importantes.",autoridad:"INFONAVIT",especialidades:["Todas"],obligatorio:true},
  {id:"manl3",nivel:"laboral",clave:"LFT — Contrato colectivo",titulo:"Contrato Colectivo de Trabajo (CCT)",descripcion:"En manufactura automotriz y textil es común la existencia de sindicatos. El CCT debe estar registrado ante la STPS y negociarse cada 2 años.",autoridad:"STPS",especialidades:["Industria Automotriz / Autopartes","Industria Textil / Confección"],obligatorio:false},
  {id:"manl4",nivel:"laboral",clave:"NOM-035-STPS-2018",titulo:"Factores de riesgo psicosocial en el trabajo",descripcion:"Aplica a todos los centros de trabajo con más de 15 trabajadores. Incluye la evaluación de turnos nocturnos y ritmo de producción.",autoridad:"STPS",especialidades:["Todas"],obligatorio:true},
  {id:"manl5",nivel:"laboral",clave:"NOM-030-STPS-2009",titulo:"Servicios preventivos de seguridad y salud en el trabajo",descripcion:"Obliga a contar con un servicio preventivo de seguridad e higiene. En plantas con más de 100 trabajadores se requiere médico de empresa.",autoridad:"STPS",especialidades:["Todas"],obligatorio:true},
  {id:"manl6",nivel:"laboral",clave:"RIT — Art. 422 LFT",titulo:"Reglamento Interno de Trabajo (Art. 422 LFT)",descripcion:"Documento obligatorio que regula la relación laboral interna: jornada, horarios, lugares de prestación, días y forma de pago, permisos, sanciones y procedimientos disciplinarios. Debe registrarse ante el Centro Federal de Conciliación y Registro Laboral (CFCRL).",autoridad:"STPS / CFCRL",especialidades:["Todas"],obligatorio:true},
  {id:"mani1",nivel:"iso",clave:"ISO 9001:2015",titulo:"Sistema de Gestión de Calidad",descripcion:"Base de cualquier sistema de calidad manufacturero. Requerido por la mayoría de clientes corporativos y OEMs.",autoridad:"ISO / IMNC",especialidades:["Todas"],obligatorio:false},
  {id:"mani2",nivel:"iso",clave:"IATF 16949:2016",titulo:"Gestión de calidad automotriz — IATF",descripcion:"El estándar específico de la industria automotriz. Requerido para ser proveedor de Nissan AGS, Stellantis u otras OEMs.",autoridad:"IATF / AIAG",especialidades:["Industria Automotriz / Autopartes"],obligatorio:false},
  {id:"mani3",nivel:"iso",clave:"ISO 14001:2015",titulo:"Sistema de Gestión Ambiental",descripcion:"Para plantas con impacto ambiental significativo. Requerido en licitaciones gubernamentales.",autoridad:"ISO / IMNC",especialidades:["Todas"],obligatorio:false},
  {id:"mani4",nivel:"iso",clave:"ISO 45001:2018",titulo:"Seguridad y salud en el trabajo",descripcion:"La manufactura es el sector con mayor siniestralidad laboral en México. Exigida por clientes internacionales.",autoridad:"ISO / IMNC",especialidades:["Todas"],obligatorio:false},
  {id:"mani5",nivel:"iso",clave:"ISO 50001:2018",titulo:"Gestión de la energía",descripcion:"Para plantas con alto consumo energético. Reduce costos de electricidad y gas. Requerido por algunos clientes europeos.",autoridad:"ISO / IMNC",especialidades:["Todas"],obligatorio:false},
  {id:"mani6",nivel:"iso",clave:"ISO 22000:2018 / FSSC 22000",titulo:"Inocuidad alimentaria — Agroindustria",descripcion:"Necesario para exportar a EUA o Europa, o vender a cadenas como Walmart o HEB.",autoridad:"ISO / IMNC",especialidades:["Agroindustria / Alimentos Procesados"],obligatorio:false},
];

// #endregion
// #region DATOS: EDUCACIÓN PRIVADA
// ─── DATOS: EDUCACIÓN PRIVADA ─────────────────────────────────────────────────
const ESP_EDUCACION = [
  "Todas",
  "Preescolar / Guardería / Kinder",
  "Primaria / Secundaria",
  "Preparatoria / Bachillerato",
  "Universidad / Educación Superior",
  "Centro de Capacitación / Instituto",
  "Academia / Idiomas / Extracurricular",
];

const REGS_EDUCACION: Regulacion[] = [
  // FEDERAL
  {id:"edf1", nivel:"marco", esMarco:true, clave:"Art. 3° CPEUM", titulo:"Derecho a la educación — Constitución Política", descripcion:"La educación es un derecho humano garantizado por el Estado. Los particulares que impartan educación deben obtener autorización o reconocimiento de validez oficial de estudios (RVOE) para que sus programas sean válidos legalmente.", autoridad:"Constitución Política / SEP", especialidades:["Todas"], obligatorio:true},
  {id:"edf2", nivel:"marco", esMarco:true, clave:"Ley General de Educación 2019", titulo:"Ley General de Educación", descripcion:"Marco normativo nacional de la educación. Regula las obligaciones de los particulares que imparten educación: contenidos mínimos, evaluación docente, infraestructura, derechos de los alumnos y transparencia en cobros de colegiaturas.", autoridad:"SEP", especialidades:["Todas"], obligatorio:true},
  {id:"edf3", nivel:"federal", clave:"RVOE — SEP", titulo:"Reconocimiento de Validez Oficial de Estudios (RVOE)", descripcion:"Toda institución privada que imparta educación con validez oficial debe contar con RVOE federal (SEP) o estatal (SEG). Sin él, los estudios no tienen validez legal. Requiere plan de estudios, instalaciones y planta docente certificada.", autoridad:"SEP / SEG AGS", especialidades:["Preescolar / Guardería / Kinder","Primaria / Secundaria","Preparatoria / Bachillerato","Universidad / Educación Superior","Centro de Capacitación / Instituto"], obligatorio:true},
  {id:"edf4", nivel:"marco", esMarco:true, clave:"Ley DNNNA", titulo:"Ley General de los Derechos de Niñas, Niños y Adolescentes", descripcion:"Establece las obligaciones de las instituciones educativas privadas en materia de protección a menores: políticas contra el acoso escolar (bullying), protocolos de denuncia de abuso, espacios seguros y no discriminación.", autoridad:"SIPINNA / SEP", especialidades:["Preescolar / Guardería / Kinder","Primaria / Secundaria","Preparatoria / Bachillerato"], obligatorio:true},
  {id:"edf5", nivel:"marco", esMarco:true, clave:"LGPDPPP — Datos educativos", titulo:"Ley General de Protección de Datos Personales en Posesión de Particulares", descripcion:"Los datos de alumnos, padres de familia y expedientes académicos son datos personales sensibles. Las escuelas privadas deben contar con aviso de privacidad, sistemas de protección y políticas de retención de datos.", autoridad:"INAI", especialidades:["Todas"], obligatorio:true},
  {id:"edf6", nivel:"marco", esMarco:true, clave:"SAT — Régimen fiscal", titulo:"Obligaciones fiscales: RFC, CFDI, régimen fiscal", descripcion:"Las instituciones educativas privadas con fines de lucro deben emitir CFDI (facturas) por colegiaturas e inscripciones. Las A.C. educativas tienen tratamiento fiscal especial y pueden estar exentas de ISR si cumplen con los requisitos del SAT.", autoridad:"SAT", especialidades:["Todas"], obligatorio:true},
  {id:"edf7", nivel:"federal", clave:"Ley del Servicio Profesional Docente", titulo:"Ley General del Sistema para la Carrera de las Maestras y los Maestros (USICAMM)", descripcion:"Aplica a las escuelas incorporadas al sistema oficial. Regula la contratación, evaluación y permanencia de los docentes. Las privadas deben garantizar que su planta docente cumpla con los perfiles requeridos por los planes de estudio autorizados.", autoridad:"SEP / USICAMM", especialidades:["Primaria / Secundaria","Preparatoria / Bachillerato","Universidad / Educación Superior"], obligatorio:false},
  {id:"edf8", nivel:"marco", esMarco:true, clave:"Ley Federal de Protección al Consumidor", titulo:"LFPC — Colegiaturas, contratos y transparencia de cobros", descripcion:"Las instituciones educativas están sujetas a la LFPC en materia de transparencia de cobros: colegiaturas, inscripciones y cuotas deben publicarse. Los contratos de prestación de servicios educativos son contratos de adhesión regulados por PROFECO.", autoridad:"PROFECO", especialidades:["Todas"], obligatorio:true},
  // ESTATAL
  {id:"ede1", nivel:"marco", esMarco:true, clave:"Ley de Educación del Estado de AGS", titulo:"Ley de Educación del Estado de Aguascalientes", descripcion:"Complementa la Ley General de Educación en el ámbito local. Regula la incorporación de escuelas privadas al sistema educativo estatal, los requisitos de infraestructura, calendarios escolares y supervisión por parte de la SEG.", autoridad:"SEG — Secretaría de Educación del Gobierno del Estado", especialidades:["Todas"], obligatorio:true},
  {id:"ede2", nivel:"estatal", clave:"Incorporación SEG", titulo:"Incorporación o RVOE Estatal ante la SEG",  descripcion:"Para los niveles de preescolar, primaria, secundaria y bachillerato no federal, el RVOE o incorporación se tramita ante la Secretaría de Educación del Gobierno de AGS. Requiere inspección de instalaciones, planta docente con perfil y plan de estudios.", autoridad:"SEG Aguascalientes", especialidades:["Preescolar / Guardería / Kinder","Primaria / Secundaria","Preparatoria / Bachillerato"], obligatorio:true},
  {id:"ede3", nivel:"marco", esMarco:true, clave:"Ley PC AGS — Escuelas", titulo:"Ley de Protección Civil del Estado de Aguascalientes", descripcion:"Las instituciones educativas deben contar con Programa Interno de Protección Civil, brigadas capacitadas, simulacros mínimo dos veces al año y señalización de emergencia conforme a la norma.", autoridad:"Coordinación Estatal de Protección Civil", especialidades:["Todas"], obligatorio:true},
  {id:"ede4", nivel:"estatal", clave:"CAINTRA / DIF AGS — Guarderías", titulo:"Autorización DIF Estatal para guarderías y estancias infantiles", descripcion:"Las guarderías y estancias infantiles privadas deben obtener autorización del DIF Estatal de Aguascalientes además del RVOE. Incluye verificación de instalaciones, ratios niño-educador, alimentación y protocolos de seguridad.", autoridad:"DIF Aguascalientes", especialidades:["Preescolar / Guardería / Kinder"], obligatorio:true},
  // MUNICIPAL
  {id:"edm1", nivel:"municipal", clave:"Licencia de Funcionamiento", titulo:"Licencia municipal de funcionamiento educativo", descripcion:"Trámite ante el H. Ayuntamiento de Aguascalientes. Para uso educativo, el predio debe tener uso de suelo compatible y cumplir con las especificaciones de la Dirección de Desarrollo Urbano.", autoridad:"Ayuntamiento — Desarrollo Económico", especialidades:["Todas"], obligatorio:true},
  {id:"edm2", nivel:"municipal", clave:"Uso de Suelo Educativo", titulo:"Constancia de uso de suelo compatible — educación", descripcion:"El uso de suelo educativo privado debe ser compatible con el Plan de Desarrollo Urbano de Aguascalientes. En zonas residenciales, las escuelas requieren un dictamen especial de impacto vial.", autoridad:"Ayuntamiento — Dirección de Ordenamiento Territorial", especialidades:["Todas"], obligatorio:true},
  {id:"edm3", nivel:"municipal", clave:"Dictamen Protección Civil", titulo:"Dictamen de Protección Civil municipal", descripcion:"Inspección del plantel educativo para verificar salidas de emergencia, extintores, señalización, rutas de evacuación y capacidad máxima de ocupación por aula.", autoridad:"Dirección de Protección Civil Municipal", especialidades:["Todas"], obligatorio:true},
  {id:"edm4", nivel:"municipal", clave:"Impacto vial — Escuelas", titulo:"Estudio de impacto vial para escuelas privadas", descripcion:"Las escuelas nuevas o con más de cierto número de alumnos deben presentar un estudio de impacto vial ante el Ayuntamiento para mitigar el congestionamiento en las horas de entrada y salida.", autoridad:"Dirección de Tránsito y Vialidad Municipal", especialidades:["Primaria / Secundaria","Preparatoria / Bachillerato","Universidad / Educación Superior"], obligatorio:false},
  // NOMs UNIVERSALES
  {id:"edn1", nivel:"nom_universal", clave:"NOM-009-SSA2-2013", titulo:"Promoción de la salud escolar", descripcion:"Establece los criterios para la promoción de la salud en el entorno escolar: higiene, alimentación correcta, activación física, entornos libres de violencia y detección oportuna de enfermedades.", autoridad:"SSA / SEP", especialidades:["Preescolar / Guardería / Kinder","Primaria / Secundaria","Preparatoria / Bachillerato"], obligatorio:true},
  {id:"edn2", nivel:"nom_universal", clave:"NOM-002-STPS-2010", titulo:"Prevención y protección contra incendios", descripcion:"Extintores con vigencia, detectores de humo, señalización de rutas de evacuación y simulacros periódicos. En escuelas aplica con mayor rigor por la presencia de menores de edad.", autoridad:"STPS", especialidades:["Todas"], obligatorio:true},
  {id:"edn3", nivel:"nom_universal", clave:"NOM-026-STPS-2008", titulo:"Colores y señales de seguridad e higiene", descripcion:"Señalización de riesgos, rutas de evacuación, zonas de reunión y extintores en todas las áreas del plantel educativo.", autoridad:"STPS", especialidades:["Todas"], obligatorio:true},
  {id:"edn4", nivel:"nom_universal", clave:"NOM-001-SEDE-2012", titulo:"Instalaciones eléctricas en planteles educativos", descripcion:"Las instalaciones eléctricas de los edificios escolares deben cumplir con esta norma. Especialmente importante en laboratorios, talleres y zonas con menores de edad.", autoridad:"SEDE", especialidades:["Todas"], obligatorio:true},
  // NOMs POR ESPECIALIDAD
  {id:"edne1", nivel:"nom_especialidad", clave:"NOM-032-SSA2-2014", titulo:"Asistencia social para menores — guarderías y estancias infantiles", descripcion:"Establece las especificaciones mínimas de infraestructura, personal, alimentación y atención médica que deben cumplir las guarderías y estancias infantiles privadas.", autoridad:"SSA / DIF", especialidades:["Preescolar / Guardería / Kinder"], obligatorio:true},
  {id:"edne2", nivel:"nom_especialidad", clave:"NOM-167-SSA1-1997", titulo:"Asistencia social — Prestación de servicios para menores", descripcion:"Regula las condiciones de prestación de servicios de asistencia social para menores: condiciones físicas, personal, alimentación, actividades pedagógicas y mecanismos de supervisión.", autoridad:"SSA", especialidades:["Preescolar / Guardería / Kinder"], obligatorio:true},
  {id:"edne3", nivel:"nom_especialidad", clave:"NOM-051-SCFI/SSA1 — Cafetería", titulo:"NOM-051 — Etiquetado de alimentos en cafeterías escolares", descripcion:"Las cafeterías de los planteles educativos que vendan o distribuyan alimentos envasados deben cumplir con el etiquetado vigente, incluyendo los sellos de advertencia (octágonos negros) desde 2020.", autoridad:"SE / SSA", especialidades:["Primaria / Secundaria","Preescolar / Guardería / Kinder","Preparatoria / Bachillerato"], obligatorio:true},
  {id:"edne4", nivel:"nom_especialidad", clave:"Lineamientos SEP — Cafeterías", titulo:"Lineamientos para la venta y distribución de alimentos en planteles educativos (SEP)", descripcion:"Prohíben la venta de alimentos con exceso de calorías, azúcar, grasas saturadas y sodio en las cafeterías de escuelas públicas y privadas de nivel básico. Las escuelas deben garantizar el cumplimiento.", autoridad:"SEP / SSPF", especialidades:["Preescolar / Guardería / Kinder","Primaria / Secundaria","Preparatoria / Bachillerato"], obligatorio:true},
  {id:"edne5", nivel:"nom_especialidad", clave:"Protocolo SEP — Acoso escolar", titulo:"Protocolo de actuación ante situaciones de acoso escolar (bullying)", descripcion:"Todas las escuelas privadas deben contar con un protocolo formal de detección, atención y seguimiento de casos de acoso escolar, violencia entre pares y violencia digital. Deben nombrarse responsables de protección.", autoridad:"SEP / CNDH", especialidades:["Primaria / Secundaria","Preparatoria / Bachillerato"], obligatorio:true},
  {id:"edne6", nivel:"nom_especialidad", clave:"RVOE — Perfil docente", titulo:"Perfiles docentes requeridos por el RVOE y plan de estudios", descripcion:"El personal docente debe acreditar el perfil académico requerido por el plan de estudios aprobado. Para niveles básicos, los docentes deben tener título en educación o área afín. Para bachillerato y superior, título profesional en el área que imparten.", autoridad:"SEP / SEG AGS", especialidades:["Primaria / Secundaria","Preparatoria / Bachillerato","Universidad / Educación Superior"], obligatorio:true},
  {id:"edne7", nivel:"nom_especialidad", clave:"STPS — Capacitación art. 153", titulo:"Plan y programa de capacitación y adiestramiento (Art. 153 LFT)", descripcion:"Toda empresa con trabajadores, incluyendo instituciones educativas, debe registrar su plan de capacitación ante la STPS. Para el personal docente, esto complementa la formación continua exigida por el RVOE.", autoridad:"STPS", especialidades:["Todas"], obligatorio:true},
  // NOMs COMPLEMENTARIAS
  {id:"ednc1", nivel:"nom_complementaria", clave:"NOM-087-SEMARNAT — Enfermería", titulo:"Residuos peligrosos biológico-infecciosos — Enfermería escolar", descripcion:"Las escuelas que cuentan con servicio de enfermería o primeros auxilios deben manejar correctamente los residuos biológico-infecciosos (jeringas, gasas, etc.) conforme a esta norma.", autoridad:"SEMARNAT / SSA", especialidades:["Primaria / Secundaria","Preparatoria / Bachillerato","Universidad / Educación Superior"], obligatorio:false},
  {id:"ednc2", nivel:"nom_complementaria", clave:"NOM-030-STPS-2009", titulo:"Servicios preventivos de seguridad y salud en el trabajo", descripcion:"Las instituciones educativas con más de 100 trabajadores (docentes y administrativos) deben contar con un servicio preventivo de seguridad e higiene.",autoridad:"STPS", especialidades:["Todas"], obligatorio:true},
  {id:"ednc3", nivel:"nom_complementaria", clave:"LGPDPPP — Expedientes académicos", titulo:"Protección de datos personales de alumnos y padres de familia", descripcion:"Los expedientes académicos, calificaciones, datos de salud y fotografías de alumnos son datos personales sensibles. Las escuelas deben contar con aviso de privacidad específico y sistemas de seguridad para su resguardo.", autoridad:"INAI", especialidades:["Todas"], obligatorio:true},
  // LABORAL
  {id:"edl1", nivel:"laboral", clave:"IMSS — Alta patronal docente", titulo:"Registro patronal y alta de docentes y personal ante el IMSS", descripcion:"Todos los docentes y empleados administrativos deben estar afiliados al IMSS. Es un error común contratar docentes como 'honorarios' cuando en realidad existe una relación laboral, lo que puede derivar en multas importantes.", autoridad:"IMSS", especialidades:["Todas"], obligatorio:true},
  {id:"edl2", nivel:"laboral", clave:"INFONAVIT", titulo:"Aportaciones al INFONAVIT", descripcion:"5% del salario base de cotización bimestral por cada trabajador, incluyendo docentes de planta.", autoridad:"INFONAVIT", especialidades:["Todas"], obligatorio:true},
  {id:"edl3", nivel:"laboral", clave:"LFT — Contrato docente", titulo:"Contratos de trabajo para personal docente y administrativo", descripcion:"Los contratos de los docentes deben especificar: horas frente a grupo, preparación de clases, evaluaciones y actividades extracurriculares. Los contratos por ciclo escolar son válidos como contratos por tiempo determinado con causa justificada.", autoridad:"STPS", especialidades:["Todas"], obligatorio:true},
  {id:"edl4", nivel:"laboral", clave:"NOM-035-STPS-2018", titulo:"Factores de riesgo psicosocial en el trabajo", descripcion:"La docencia es una de las profesiones con mayor incidencia de estrés laboral, burnout y acoso laboral. Las instituciones con más de 15 trabajadores deben identificar, analizar y prevenir estos factores.", autoridad:"STPS", especialidades:["Todas"], obligatorio:true},
  {id:"edl5", nivel:"laboral", clave:"REPSE — Servicios tercerizados", titulo:"Registro de Prestadoras de Servicios Especializados (REPSE)", descripcion:"Las escuelas que contratan servicios de limpieza, seguridad, transporte escolar o mantenimiento con terceros deben verificar que estas empresas estén registradas en el REPSE del STPS.", autoridad:"STPS", especialidades:["Primaria / Secundaria","Preparatoria / Bachillerato","Universidad / Educación Superior"], obligatorio:true},
  {id:"edl6", nivel:"laboral", clave:"RIT — Art. 422 LFT", titulo:"Reglamento Interno de Trabajo (Art. 422 LFT)", descripcion:"Documento obligatorio que regula la relación laboral interna: jornada, horarios, lugares de prestación, días y forma de pago, permisos, sanciones y procedimientos disciplinarios. Debe registrarse ante el Centro Federal de Conciliación y Registro Laboral (CFCRL).", autoridad:"STPS / CFCRL", especialidades:["Todas"], obligatorio:true},
  // ISO
  {id:"edi1", nivel:"iso", clave:"ISO 21001:2018", titulo:"Sistemas de gestión para organizaciones educativas",  descripcion:"El único estándar ISO diseñado específicamente para organizaciones educativas. Establece requisitos para asegurar la calidad del proceso de enseñanza-aprendizaje, la satisfacción de estudiantes y el liderazgo pedagógico. Muy valorado en escuelas privadas de alto nivel.", autoridad:"ISO / IMNC", especialidades:["Todas"], obligatorio:false},
  {id:"edi2", nivel:"iso", clave:"ISO 9001:2015", titulo:"Sistema de Gestión de Calidad — aplicado a educación", descripcion:"Base para certificar los procesos administrativos y académicos de la institución. Requerido por algunas instituciones de acreditación internacional como la Western Association of Schools and Colleges (WASC) o CAMBRIDGE.", autoridad:"ISO / IMNC", especialidades:["Preparatoria / Bachillerato","Universidad / Educación Superior"], obligatorio:false},
  {id:"edi3", nivel:"iso", clave:"ISO 45001:2018", titulo:"Seguridad y salud en el trabajo", descripcion:"Para instituciones con grandes plantillas de docentes y personal administrativo. Cubre riesgos laborales específicos de la enseñanza: ergonomía vocal, estrés, riesgos en laboratorios y talleres.", autoridad:"ISO / IMNC", especialidades:["Universidad / Educación Superior","Centro de Capacitación / Instituto"], obligatorio:false},
];

// #endregion
// #region DATOS: TRANSPORTE Y LOGÍSTICA
// ─── DATOS: TRANSPORTE Y LOGÍSTICA ───────────────────────────────────────────
const ESP_TRANSPORTE = [
  "Todas",
  "Autotransporte de Carga Federal",
  "Transporte de Personal / Turismo",
  "Paquetería y Mensajería",
  "Almacenaje y Logística",
  "Transporte de Materiales Peligrosos",
  "Transporte Urbano / Local",
];

const REGS_TRANSPORTE: Regulacion[] = [
  // FEDERAL
  {id:"trf1", nivel:"marco", esMarco:true, clave:"Ley de Caminos, Puentes y Autotransporte Federal", titulo:"Ley de Caminos, Puentes y Autotransporte Federal", descripcion:"Ley marco que regula el autotransporte federal de pasajeros y carga. Establece los requisitos para obtener concesiones y permisos de operación ante la SCT/SICT. Sin permiso federal vigente, el transportista no puede operar en carreteras federales.", autoridad:"SICT — Secretaría de Infraestructura, Comunicaciones y Transportes", especialidades:["Todas"], obligatorio:true},
  {id:"trf2", nivel:"marco", esMarco:true, clave:"Reglamento de Autotransporte Federal — SCT", titulo:"Reglamento de Autotransporte Federal y Servicios Auxiliares", descripcion:"Detalla los requisitos operativos del autotransporte federal: condiciones de los vehículos, documentación que debe portarse, tiempos de conducción y descanso de operadores, pesos y dimensiones máximas.", autoridad:"SICT", especialidades:["Autotransporte de Carga Federal","Transporte de Personal / Turismo","Paquetería y Mensajería"], obligatorio:true},
  {id:"trf3", nivel:"federal", clave:"Permiso SCT / SICT", titulo:"Permiso federal de autotransporte de carga o pasajeros", descripcion:"Todo vehículo que transporte carga o pasajeros en carreteras federales debe contar con permiso vigente de la SICT. Existen diferentes tipos: carga general, carga especializada, transporte privado, turismo, mensajería.", autoridad:"SICT", especialidades:["Autotransporte de Carga Federal","Transporte de Personal / Turismo","Paquetería y Mensajería"], obligatorio:true},
  {id:"trf4", nivel:"federal", clave:"NOM-012-SCT-2-2017", titulo:"Sobre el peso y dimensiones máximas con los que pueden circular los vehículos de autotransporte", descripcion:"La norma más verificada en operativos de la SCT. Establece los pesos brutos vehiculares máximos según configuración del vehículo. Circular con exceso de peso genera multas elevadas y retención del vehículo.", autoridad:"SICT / SCT", especialidades:["Autotransporte de Carga Federal","Transporte de Materiales Peligrosos"], obligatorio:true},
  {id:"trf5", nivel:"marco", esMarco:true, clave:"Ley de Aviación Civil / Ley de Puertos", titulo:"Regulación de logística multimodal — puertos y aeropuertos", descripcion:"Para operaciones de logística que involucren transporte aéreo o marítimo, aplican regulaciones adicionales de la Ley de Aviación Civil y la Ley de Puertos.", autoridad:"SICT / ASIPONA", especialidades:["Almacenaje y Logística"], obligatorio:false},
  {id:"trf6", nivel:"federal", clave:"SAT — CFDI Carta Porte", titulo:"CFDI con Complemento Carta Porte", descripcion:"Desde 2022, todo traslado de mercancías en territorio nacional debe acompañarse de un CFDI con el Complemento Carta Porte. Incluye datos del transportista, vehículo, mercancía, origen y destino. Es verificado en operativos del SAT y la SCT.", autoridad:"SAT", especialidades:["Autotransporte de Carga Federal","Paquetería y Mensajería","Transporte de Materiales Peligrosos"], obligatorio:true},
  {id:"trf7", nivel:"federal", clave:"Ley del Seguro Social — Operadores", titulo:"Seguridad social obligatoria para operadores y personal", descripcion:"Los operadores de transporte deben estar afiliados al IMSS como trabajadores. Es común que empresas transportistas trabajen con operadores como 'prestadores independientes' lo cual es una práctica de riesgo legal.", autoridad:"IMSS", especialidades:["Todas"], obligatorio:true},
  // ESTATAL
  {id:"tre1", nivel:"marco", esMarco:true, clave:"Ley de Transporte del Estado de AGS", titulo:"Ley de Transporte del Estado de Aguascalientes", descripcion:"Regula el transporte público y privado de pasajeros y carga dentro del estado de Aguascalientes. Establece los requisitos para concesiones y permisos de operación locales ante la Secretaría de Movilidad.", autoridad:"Secretaría de Movilidad del Estado de AGS", especialidades:["Transporte Urbano / Local","Transporte de Personal / Turismo"], obligatorio:true},
  {id:"tre2", nivel:"estatal", clave:"Ley Ambiental AGS — Verificación vehicular", titulo:"Verificación vehicular — Ley Ambiental AGS", descripcion:"Los vehículos de carga y transporte con base en Aguascalientes deben cumplir con la verificación vehicular de emisiones contaminantes conforme a la normativa ambiental estatal.", autoridad:"IMA — Instituto del Medio Ambiente AGS", especialidades:["Todas"], obligatorio:true},
  {id:"tre3", nivel:"marco", esMarco:true, clave:"Ley PC AGS — Bodegas", titulo:"Ley de Protección Civil AGS — Almacenes y bodegas", descripcion:"Las instalaciones de almacenaje y logística deben contar con Programa Interno de Protección Civil, sistemas de supresión de incendios y dictamen favorable de la autoridad.",autoridad:"Coordinación Estatal de PC", especialidades:["Almacenaje y Logística","Transporte de Materiales Peligrosos"], obligatorio:true},
  // MUNICIPAL
  {id:"trm1", nivel:"municipal", clave:"Licencia de Funcionamiento — Base", titulo:"Licencia municipal de funcionamiento para base de operaciones", descripcion:"La empresa transportista debe contar con licencia de funcionamiento para su oficina, taller y base de operaciones en el municipio de Aguascalientes.",autoridad:"Ayuntamiento de Aguascalientes — Desarrollo Económico", especialidades:["Todas"], obligatorio:true},
  {id:"trm2", nivel:"municipal", clave:"Uso de Suelo — Bodega / Taller", titulo:"Constancia de uso de suelo para bodega, taller y patio de maniobras", descripcion:"El predio donde se ubican las instalaciones de la empresa (bodega, taller mecánico, patio de maniobras) debe tener uso de suelo compatible con la actividad industrial o de servicios.", autoridad:"Ayuntamiento — Ordenamiento Territorial", especialidades:["Almacenaje y Logística","Autotransporte de Carga Federal"], obligatorio:true},
  {id:"trm3", nivel:"municipal", clave:"Dictamen PC — Instalaciones", titulo:"Dictamen de Protección Civil para instalaciones logísticas", descripcion:"Las bodegas y centros de distribución requieren dictamen de PC. Incluye verificación de sistemas contra incendios, señalización, salidas de emergencia y manejo de materiales.", autoridad:"Dirección de PC Municipal", especialidades:["Almacenaje y Logística","Transporte de Materiales Peligrosos"], obligatorio:true},
  // NOMs UNIVERSALES
  {id:"trn1", nivel:"nom_universal", clave:"NOM-012-SCT-2-2017", titulo:"Pesos y dimensiones máximas en autotransporte federal", descripcion:"Especificaciones técnicas sobre configuraciones vehiculares, pesos máximos por eje y dimensiones máximas permitidas. El incumplimiento es causa de retención vehicular y multas.",autoridad:"SCT / SICT", especialidades:["Autotransporte de Carga Federal","Transporte de Materiales Peligrosos"], obligatorio:true},
  {id:"trn2", nivel:"nom_universal", clave:"NOM-087-SCT-2-2017", titulo:"Transporte de materiales y residuos peligrosos — Disposiciones generales", descripcion:"Establece las disposiciones generales para el transporte de materiales y residuos peligrosos por autotransporte federal: identificación, documentación, equipo de emergencia y capacitación del operador.", autoridad:"SCT / SICT / SEMARNAT", especialidades:["Transporte de Materiales Peligrosos"], obligatorio:true},
  {id:"trn3", nivel:"nom_universal", clave:"NOM-002-STPS-2010", titulo:"Prevención y protección contra incendios — Bodegas e instalaciones", descripcion:"Aplica a las bodegas, talleres y centros de distribución. Extintores, detectores de humo, rutas de evacuación y señalización de emergencia.", autoridad:"STPS", especialidades:["Almacenaje y Logística","Autotransporte de Carga Federal"], obligatorio:true},
  {id:"trn4", nivel:"nom_universal", clave:"NOM-026-STPS-2008", titulo:"Colores y señales de seguridad en instalaciones", descripcion:"Señalización de riesgos, rutas de evacuación y áreas de maniobras dentro de bodegas, talleres y patios de operaciones.", autoridad:"STPS", especialidades:["Todas"], obligatorio:true},
  // NOMs POR ESPECIALIDAD
  {id:"trne1", nivel:"nom_especialidad", clave:"NOM-004-SCT-2008", titulo:"Sistemas de sujeción de carga en autotransporte", descripcion:"Establece los sistemas y dispositivos para la sujeción, acuñamiento y amarre de la carga en vehículos de autotransporte. Una carga mal asegurada es causa de accidente y de responsabilidad civil y penal.", autoridad:"SCT / SICT", especialidades:["Autotransporte de Carga Federal"], obligatorio:true},
  {id:"trne2", nivel:"nom_especialidad", clave:"NOM-024-SCT-2-1995", titulo:"Especificaciones y características de los operadores de autotransporte", descripcion:"Establece las características y requisitos que deben cumplir los operadores de autotransporte federal: licencia federal, exámenes médicos periódicos, pruebas de alcoholimetría y no consumo de estupefacientes.", autoridad:"SCT / SICT", especialidades:["Autotransporte de Carga Federal","Transporte de Personal / Turismo","Transporte de Materiales Peligrosos"], obligatorio:true},
  {id:"trne3", nivel:"nom_especialidad", clave:"Licencia Federal de Conductor", titulo:"Licencia federal de conducir tipo E o F para autotransporte", descripcion:"Los operadores de vehículos de autotransporte federal deben contar con licencia federal tipo E (carga) o F (pasajeros) expedida por la SICT. Requiere examen médico, psicológico y de manejo.", autoridad:"SICT", especialidades:["Autotransporte de Carga Federal","Transporte de Personal / Turismo","Transporte de Materiales Peligrosos"], obligatorio:true},
  {id:"trne4", nivel:"nom_especialidad", clave:"NOM-032-SCT-2020", titulo:"Transporte de materiales peligrosos — Capacitación de operadores", descripcion:"Los operadores que transporten materiales peligrosos deben recibir capacitación específica en manejo de emergencias, uso de equipo de protección y primeros auxilios.", autoridad:"SCT / SICT", especialidades:["Transporte de Materiales Peligrosos"], obligatorio:true},
  {id:"trne5", nivel:"nom_especialidad", clave:"NOM-070-SCT3-2018", titulo:"Transporte de personal — Condiciones de seguridad", descripcion:"Aplica a empresas que prestan servicio de transporte de personal para otras empresas (plantas, maquiladoras). Incluye requisitos de vehículos, operadores, seguros y bitácoras de viaje.", autoridad:"SCT / SICT", especialidades:["Transporte de Personal / Turismo"], obligatorio:true},
  {id:"trne6", nivel:"nom_especialidad", clave:"NOM-006-STPS-2014 — Montacargas", titulo:"Manejo y almacenamiento de materiales con montacargas", descripcion:"Aplica a bodegas y centros de distribución que utilizan montacargas, grúas horquilla o equipos similares. Incluye requisitos de capacitación del operador, bitácoras y mantenimiento.", autoridad:"STPS", especialidades:["Almacenaje y Logística"], obligatorio:true},
  {id:"trne7", nivel:"nom_especialidad", clave:"Seguro de Responsabilidad Civil — SCT", titulo:"Seguro de responsabilidad civil para vehículos de autotransporte federal", descripcion:"Requisito obligatorio para obtener y mantener el permiso de autotransporte federal. El monto mínimo asegurado varía según el tipo de servicio y la carga. Debe presentarse como condición de operación ante la SCT.", autoridad:"SICT / CNSF", especialidades:["Autotransporte de Carga Federal","Transporte de Personal / Turismo","Transporte de Materiales Peligrosos","Paquetería y Mensajería"], obligatorio:true},
  // NOMs COMPLEMENTARIAS
  {id:"trnc1", nivel:"nom_complementaria", clave:"NOM-001-SEMARNAT-2021", titulo:"Descargas de aguas residuales — Talleres de mantenimiento", descripcion:"Los talleres de mantenimiento de vehículos generan aguas residuales con aceites y lubricantes. Deben cumplir con los límites permisibles de descarga y manejar correctamente los residuos aceitosos.", autoridad:"SEMARNAT", especialidades:["Autotransporte de Carga Federal","Almacenaje y Logística"], obligatorio:true},
  {id:"trnc2", nivel:"nom_complementaria", clave:"NOM-052-SEMARNAT-2005", titulo:"Residuos peligrosos — Aceites y lubricantes usados de taller", descripcion:"Los aceites usados, filtros, solventes y materiales contaminados con hidrocarburos generados en el taller de mantenimiento de flota son residuos peligrosos y deben manejarse conforme a esta norma.", autoridad:"SEMARNAT", especialidades:["Autotransporte de Carga Federal","Almacenaje y Logística"], obligatorio:true},
  {id:"trnc3", nivel:"nom_complementaria", clave:"NOM-044-SEMARNAT-2017", titulo:"Emisiones contaminantes de vehículos diésel", descripcion:"Establece los límites máximos permisibles de emisiones de partículas y óxidos de nitrógeno de vehículos diésel. Los vehículos de carga deben pasar verificación periódica.", autoridad:"SEMARNAT / SICT", especialidades:["Autotransporte de Carga Federal","Transporte de Materiales Peligrosos"], obligatorio:true},
  // LABORAL
  {id:"trl1", nivel:"laboral", clave:"IMSS — Alta patronal operadores", titulo:"Registro patronal y alta de operadores y personal ante el IMSS", descripcion:"Todos los operadores y personal de la empresa deben estar asegurados ante el IMSS. Es frecuente la práctica de contratar operadores como independientes para evadir cuotas, lo cual es un riesgo laboral y fiscal importante.", autoridad:"IMSS", especialidades:["Todas"], obligatorio:true},
  {id:"trl2", nivel:"laboral", clave:"INFONAVIT", titulo:"Aportaciones al INFONAVIT", descripcion:"5% del salario base de cotización bimestral por cada trabajador en nómina.", autoridad:"INFONAVIT", especialidades:["Todas"], obligatorio:true},
  {id:"trl3", nivel:"laboral", clave:"LFT — Contratos operadores", titulo:"Contratos de trabajo para operadores y personal logístico", descripcion:"Los contratos de los operadores deben especificar: rutas asignadas, jornada, salario base más viáticos, condiciones de uso del vehículo y políticas de alcoholimetría. Los operadores no pueden ser considerados independientes si la empresa controla su jornada.", autoridad:"STPS", especialidades:["Todas"], obligatorio:true},
  {id:"trl4", nivel:"laboral", clave:"NOM-035-STPS-2018", titulo:"Factores de riesgo psicosocial — Operadores de larga distancia", descripcion:"Los operadores de larga distancia están expuestos a fatiga, aislamiento y estrés. La empresa debe identificar y prevenir estos factores. Aplica a centros de trabajo con más de 15 trabajadores.", autoridad:"STPS", especialidades:["Todas"], obligatorio:true},
  {id:"trl5", nivel:"laboral", clave:"REPSE", titulo:"Registro de Prestadoras de Servicios Especializados (REPSE)", descripcion:"Las empresas de transporte que prestan servicios a terceros (transporte de personal para plantas, outsourcing logístico) deben estar registradas en el REPSE del STPS.", autoridad:"STPS", especialidades:["Autotransporte de Carga Federal","Transporte de Personal / Turismo","Almacenaje y Logística"], obligatorio:true},
  {id:"trl6", nivel:"laboral", clave:"RIT — Art. 422 LFT", titulo:"Reglamento Interno de Trabajo (Art. 422 LFT)", descripcion:"Documento obligatorio que regula la relación laboral interna: jornada, horarios, lugares de prestación, días y forma de pago, permisos, sanciones y procedimientos disciplinarios. Debe registrarse ante el Centro Federal de Conciliación y Registro Laboral (CFCRL).", autoridad:"STPS / CFCRL", especialidades:["Todas"], obligatorio:true},
  // ISO
  {id:"tri1", nivel:"iso", clave:"ISO 9001:2015", titulo:"Sistema de Gestión de Calidad", descripcion:"Para empresas de transporte y logística que buscan estandarizar procesos operativos. Requerido por clientes corporativos como plantas automotrices y tiendas departamentales.", autoridad:"ISO / IMNC", especialidades:["Todas"], obligatorio:false},
  {id:"tri2", nivel:"iso", clave:"ISO 28000:2022", titulo:"Gestión de la seguridad en la cadena de suministro", descripcion:"Estándar específico para la seguridad en la cadena de suministro. Requerido por clientes de alto valor que necesitan garantías de seguridad en el manejo de su mercancía.", autoridad:"ISO / IMNC", especialidades:["Autotransporte de Carga Federal","Almacenaje y Logística","Paquetería y Mensajería"], obligatorio:false},
  {id:"tri3", nivel:"iso", clave:"ISO 45001:2018", titulo:"Seguridad y salud en el trabajo", descripcion:"Transporte y logística tienen alta siniestralidad. Esta certificación es cada vez más exigida por clientes del sector automotriz y por aseguradoras para reducir primas.", autoridad:"ISO / IMNC", especialidades:["Todas"], obligatorio:false},
];

// #endregion
// #region DATOS: SERVICIOS PROFESIONALES
// ─── DATOS: SERVICIOS PROFESIONALES ──────────────────────────────────────────
const ESP_SERVICIOS = [
  "Todas",
  "Despacho de Abogados / Notaría",
  "Despacho Contable / Fiscal",
  "Consultoría / Asesoría Empresarial",
  "Arquitectura / Ingeniería / Diseño",
  "Agencia de Publicidad / Marketing",
  "Psicología / Coaching / Terapia",
];

const REGS_SERVICIOS: Regulacion[] = [
  // FEDERAL
  {id:"spf1", nivel:"marco", esMarco:true, clave:"Ley de Profesiones — Cédula profesional", titulo:"Ley Reglamentaria del Art. 5° Constitucional — Ejercicio profesional", descripcion:"Todo profesionista que ejerza una profesión que requiere título debe contar con cédula profesional expedida por la SEP. En Aguascalientes el ISSEA lleva el padrón de profesionales de la salud; los demás se registran ante la Dirección General de Profesiones.", autoridad:"SEP — Dirección General de Profesiones", especialidades:["Todas"], obligatorio:true},
  {id:"spf2", nivel:"federal", clave:"SAT — Honorarios / Régimen fiscal", titulo:"Obligaciones fiscales: RFC, CFDI, régimen fiscal de honorarios", descripcion:"Los profesionistas independientes tributan en el régimen de actividades empresariales y profesionales. Deben emitir CFDI por cada servicio prestado y presentar declaraciones mensuales y anuales de ISR. Las personas morales (despachos) tienen obligaciones adicionales de ISR corporativo.", autoridad:"SAT", especialidades:["Todas"], obligatorio:true},
  {id:"spf3", nivel:"marco", esMarco:true, clave:"LGPDPPP — Confidencialidad de clientes", titulo:"Ley General de Protección de Datos Personales en Posesión de Particulares", descripcion:"Los despachos y consultoras manejan datos sensibles de sus clientes: información financiera, legal, médica y estratégica. Deben contar con aviso de privacidad, medidas de seguridad técnica y administrativa, y políticas de retención y destrucción de datos.", autoridad:"INAI", especialidades:["Todas"], obligatorio:true},
  {id:"spf4", nivel:"federal", clave:"Ley Antilavado — LFPIORPI", titulo:"Ley Federal para la Prevención e Identificación de Operaciones con Recursos de Procedencia Ilícita", descripcion:"Los abogados y notarios que intervienen en operaciones de compraventa de inmuebles, constitución de sociedades, fideicomisos o manejo de activos por cuenta de clientes son sujetos obligados. Deben identificar al cliente (KYC), presentar avisos al SAT y llevar un expediente de debida diligencia.", autoridad:"SAT / SHCP / UIF", especialidades:["Despacho de Abogados / Notaría","Consultoría / Asesoría Empresarial"], obligatorio:true},
  {id:"spf5", nivel:"federal", clave:"REPSE — Servicios especializados", titulo:"Registro de Prestadoras de Servicios Especializados (REPSE)", descripcion:"Los despachos y consultoras que prestan servicios especializados a otras empresas (outsourcing jurídico, contable, de RRHH, de TI) deben registrarse en el REPSE del STPS. Sin este registro, los clientes corporativos no pueden deducir los pagos.", autoridad:"STPS", especialidades:["Despacho de Abogados / Notaría","Despacho Contable / Fiscal","Consultoría / Asesoría Empresarial"], obligatorio:true},
  {id:"spf6", nivel:"marco", esMarco:true, clave:"LFPC — Contratos de servicios", titulo:"Ley Federal de Protección al Consumidor — Contratos de prestación de servicios", descripcion:"Los contratos de prestación de servicios profesionales con consumidores finales deben ser claros en: alcance del servicio, honorarios, plazos, causas de terminación y mecanismos de queja. PROFECO puede intervenir en conflictos con consumidores.", autoridad:"PROFECO", especialidades:["Todas"], obligatorio:true},
  {id:"spf7", nivel:"marco", esMarco:true, clave:"Ley de Notariado Federal", titulo:"Ley del Notariado — Obligaciones del Notario Público", descripcion:"Los notarios tienen obligaciones especiales: guardar el protocolo, reportar operaciones sospechosas, verificar identidades, calcular y retener impuestos (ISR e IVA) en operaciones inmobiliarias y emitir CFDI por sus honorarios.", autoridad:"SEP / SFP / UIF", especialidades:["Despacho de Abogados / Notaría"], obligatorio:true},
  // ESTATAL
  {id:"spe1", nivel:"marco", esMarco:true, clave:"Ley del Notariado del Estado de AGS", titulo:"Ley del Notariado del Estado de Aguascalientes", descripcion:"Regula el ejercicio del notariado en el estado. Establece los requisitos para obtener y mantener la patente de notario, las obligaciones de protocolo, el arancel aplicable y las causas de responsabilidad.", autoridad:"Colegio de Notarios AGS / Gobierno del Estado", especialidades:["Despacho de Abogados / Notaría"], obligatorio:true},
  {id:"spe2", nivel:"estatal", clave:"Registro estatal de profesionistas", titulo:"Registro de título y cédula ante la Dirección de Profesiones del Estado de AGS", descripcion:"Además del registro federal, los profesionistas que ejercen en AGS deben registrar su título y cédula ante la Dirección de Profesiones del Estado. Este registro es verificado en inspecciones de colegios profesionales y por clientes institucionales.", autoridad:"Dirección de Profesiones — Gobierno del Estado de AGS", especialidades:["Todas"], obligatorio:true},
  {id:"spe3", nivel:"marco", esMarco:true, clave:"Código Civil AGS — Responsabilidad profesional", titulo:"Código Civil del Estado de Aguascalientes — Responsabilidad civil profesional", descripcion:"Regula la responsabilidad civil de los profesionistas por daños y perjuicios causados a sus clientes por negligencia, impericia o dolo en el ejercicio de su profesión. Es el fundamento legal de las demandas por mala práctica profesional.", autoridad:"Poder Judicial del Estado de AGS", especialidades:["Todas"], obligatorio:true},
  // MUNICIPAL
  {id:"spm1", nivel:"municipal", clave:"Licencia de Funcionamiento", titulo:"Licencia municipal de funcionamiento para despacho u oficina", descripcion:"Todo despacho con instalaciones físicas en Aguascalientes debe contar con licencia municipal de funcionamiento. Incluye verificación de uso de suelo compatible con servicios profesionales.", autoridad:"Ayuntamiento — Desarrollo Económico", especialidades:["Todas"], obligatorio:true},
  {id:"spm2", nivel:"municipal", clave:"Uso de Suelo — Oficinas", titulo:"Constancia de uso de suelo compatible con servicios profesionales", descripcion:"Las oficinas de despachos y consultoras deben estar ubicadas en predios con uso de suelo de servicios o mixto. En zonas residenciales exclusivas el uso profesional puede requerir una autorización especial.", autoridad:"Ayuntamiento — Ordenamiento Territorial", especialidades:["Todas"], obligatorio:true},
  {id:"spm3", nivel:"municipal", clave:"Dictamen Protección Civil", titulo:"Dictamen de Protección Civil municipal para oficinas", descripcion:"Las oficinas deben contar con extintor vigente, señalización de salidas de emergencia y rutas de evacuación. Para espacios con más de cierto número de personas, se requiere dictamen formal de PC.", autoridad:"Dirección de Protección Civil Municipal", especialidades:["Todas"], obligatorio:true},
  // NOMs UNIVERSALES
  {id:"spn1", nivel:"nom_universal", clave:"NOM-002-STPS-2010", titulo:"Prevención y protección contra incendios en oficinas", descripcion:"Extintores con vigencia, señalización de salidas de emergencia y rutas de evacuación. Aplica a cualquier centro de trabajo con personal, incluyendo despachos y consultorios.", autoridad:"STPS", especialidades:["Todas"], obligatorio:true},
  {id:"spn2", nivel:"nom_universal", clave:"NOM-026-STPS-2008", titulo:"Colores y señales de seguridad en el lugar de trabajo", descripcion:"Señalización de riesgos, extintores y rutas de evacuación dentro de las instalaciones. Es de las normas más básicas verificadas en cualquier centro de trabajo.", autoridad:"STPS", especialidades:["Todas"], obligatorio:true},
  {id:"spn3", nivel:"nom_universal", clave:"NOM-001-SEDE-2012", titulo:"Instalaciones eléctricas en oficinas", descripcion:"Las instalaciones eléctricas de las oficinas deben cumplir con los requisitos de seguridad. Especialmente relevante en estudios de arquitectura e ingeniería que operan equipos de alto consumo.", autoridad:"SEDE", especialidades:["Todas"], obligatorio:true},
  // NOMs POR ESPECIALIDAD
  {id:"spne1", nivel:"nom_especialidad", clave:"NIF — Normas de Información Financiera", titulo:"Normas de Información Financiera (NIF) — Despachos contables", descripcion:"Los despachos contables que preparan estados financieros para empresas deben aplicar las NIF emitidas por el CINIF. El incumplimiento de las NIF puede derivar en responsabilidad profesional del contador y del despacho ante el cliente.", autoridad:"CINIF / IMCP", especialidades:["Despacho Contable / Fiscal"], obligatorio:true},
  {id:"spne2", nivel:"nom_especialidad", clave:"IMCP — Código de ética profesional", titulo:"Código de Ética Profesional del IMCP — Contadores públicos", descripcion:"El Código de Ética del Instituto Mexicano de Contadores Públicos es obligatorio para los CPC que firman dictámenes fiscales o estados financieros. Regula la independencia, confidencialidad y objetividad del contador.", autoridad:"IMCP", especialidades:["Despacho Contable / Fiscal"], obligatorio:true},
  {id:"spne3", nivel:"nom_especialidad", clave:"Dictamen fiscal — Art. 32-A CFF", titulo:"Dictamen fiscal ante el SAT — Art. 32-A del Código Fiscal de la Federación", descripcion:"Las empresas obligadas a dictaminarse fiscalmente deben contratar a un Contador Público Registrado (CPR) ante el SAT. El despacho contable que emite el dictamen tiene responsabilidad solidaria ante el SAT por sus conclusiones.", autoridad:"SAT / IMCP", especialidades:["Despacho Contable / Fiscal"], obligatorio:false},
  {id:"spne4", nivel:"nom_especialidad", clave:"Barra Mexicana — Código de ética legal", titulo:"Código de Ética de la Barra Mexicana de Abogados", descripcion:"El código de ética de la BMA establece las obligaciones de lealtad, confidencialidad y probidad de los abogados hacia sus clientes. Su violación puede derivar en queja disciplinaria ante el Colegio de Abogados.", autoridad:"Barra Mexicana de Abogados / CONACAL", especialidades:["Despacho de Abogados / Notaría"], obligatorio:false},
  {id:"spne5", nivel:"nom_especialidad", clave:"NOM-025-SSA3-2013 — Psicología", titulo:"NOM-025 — Criterios para los servicios de salud mental (psicólogos)",descripcion:"Los psicólogos clínicos y terapeutas que prestan servicios de atención a la salud mental deben seguir los criterios establecidos en esta norma: consentimiento informado, confidencialidad, expediente clínico y límites de la práctica.", autoridad:"SSA", especialidades:["Psicología / Coaching / Terapia"], obligatorio:true},
  {id:"spne6", nivel:"nom_especialidad", clave:"DRO — Arquitectos e ingenieros", titulo:"Registro como Director Responsable de Obra (DRO) — Arquitectos e ingenieros", descripcion:"Los arquitectos e ingenieros que dirigen obras en Aguascalientes deben estar registrados como DRO ante el Ayuntamiento. Es un requisito para firmar planos y responsabilizarse legalmente de una construcción.", autoridad:"Ayuntamiento de Aguascalientes / Colegio de Ingenieros y Arquitectos", especialidades:["Arquitectura / Ingeniería / Diseño"], obligatorio:true},
  {id:"spne7", nivel:"nom_especialidad", clave:"Ley Federal del Derecho de Autor", titulo:"Ley Federal del Derecho de Autor — Agencias creativas y de diseño", descripcion:"Las agencias de publicidad, diseño y marketing deben proteger y respetar los derechos de autor. Los contratos con clientes deben especificar la titularidad de los derechos de las obras creadas: si son del cliente o de la agencia.", autoridad:"INDAUTOR / SEP", especialidades:["Agencia de Publicidad / Marketing","Arquitectura / Ingeniería / Diseño"], obligatorio:true},
  {id:"spne8", nivel:"nom_especialidad", clave:"Ley de Propiedad Industrial — Marcas", titulo:"Ley Federal de Protección a la Propiedad Industrial — Registro de marcas", descripcion:"Las agencias de publicidad que desarrollan marcas para clientes deben asesorar sobre el registro ante el IMPI. El no registro de una marca desarrollada puede derivar en conflictos de propiedad intelectual entre la agencia y el cliente.", autoridad:"IMPI — Instituto Mexicano de la Propiedad Industrial", especialidades:["Agencia de Publicidad / Marketing"], obligatorio:false},
  // NOMs COMPLEMENTARIAS
  {id:"spnc1", nivel:"nom_complementaria", clave:"NOM-035-STPS-2018 — Oficinas", titulo:"Factores de riesgo psicosocial en el trabajo de oficina", descripcion:"Los servicios profesionales tienen alta incidencia de estrés, burnout y acoso laboral. Las firmas con más de 15 personas deben identificar y prevenir estos factores mediante encuestas y políticas internas.", autoridad:"STPS", especialidades:["Todas"], obligatorio:true},
  {id:"spnc2", nivel:"nom_complementaria", clave:"NOM-030-STPS-2009", titulo:"Servicios preventivos de seguridad y salud en el trabajo", descripcion:"Obligación de designar un responsable de seguridad e higiene en el despacho. Para firmas con más de 100 personas se requiere un servicio preventivo formal.", autoridad:"STPS", especialidades:["Todas"], obligatorio:true},
  {id:"spnc3", nivel:"nom_complementaria", clave:"LGPDPPP — Expedientes de clientes", titulo:"Protección de datos personales de clientes y expedientes confidenciales", descripcion:"Los expedientes de clientes en despachos de abogados, contadores y psicólogos son datos personales sensibles sujetos a la LGPDPPP. Deben implementarse controles de acceso, cifrado y políticas de retención.", autoridad:"INAI", especialidades:["Todas"], obligatorio:true},
  // LABORAL
  {id:"spl1", nivel:"laboral", clave:"IMSS — Alta patronal", titulo:"Registro patronal y alta de colaboradores ante el IMSS", descripcion:"Todo despacho con personal en nómina debe estar registrado como patrón ante el IMSS. Es común en despachos profesionales contratar asociados o pasantes como 'independientes' cuando en realidad existe subordinación, lo que genera riesgo laboral y fiscal.", autoridad:"IMSS", especialidades:["Todas"], obligatorio:true},
  {id:"spl2", nivel:"laboral", clave:"INFONAVIT", titulo:"Aportaciones al INFONAVIT", descripcion:"5% del salario base de cotización bimestral de cada colaborador en nómina.", autoridad:"INFONAVIT", especialidades:["Todas"], obligatorio:true},
  {id:"spl3", nivel:"laboral", clave:"LFT — Contrato de trabajo vs. honorarios", titulo:"Contratos de trabajo vs. contratos de prestación de servicios profesionales", descripcion:"Es crítico distinguir correctamente si la relación es laboral (contrato LFT, IMSS, prestaciones de ley) o civil (honorarios, factura, sin subordinación). Una mala clasificación puede derivar en demandas laborales por liquidación, prestaciones y IMSS no pagado.", autoridad:"STPS / IMSS", especialidades:["Todas"], obligatorio:true},
  {id:"spl4", nivel:"laboral", clave:"NOM-035-STPS-2018", titulo:"Factores de riesgo psicosocial", descripcion:"Aplica a despachos con más de 15 colaboradores. En servicios profesionales son especialmente relevantes los factores de jornadas extendidas, trabajo bajo presión y conflicto trabajo-familia.", autoridad:"STPS", especialidades:["Todas"], obligatorio:true},
  {id:"spl5", nivel:"laboral", clave:"REPSE", titulo:"Registro de Prestadoras de Servicios Especializados (REPSE)", descripcion:"Los despachos que prestan servicios especializados a empresas (outsourcing jurídico, contable, de consultoría) deben estar inscritos en el REPSE. Sin este registro, sus clientes corporativos no pueden deducir los pagos.", autoridad:"STPS", especialidades:["Despacho de Abogados / Notaría","Despacho Contable / Fiscal","Consultoría / Asesoría Empresarial"], obligatorio:true},
  {id:"spl6", nivel:"laboral", clave:"RIT — Art. 422 LFT", titulo:"Reglamento Interno de Trabajo (Art. 422 LFT)", descripcion:"Documento obligatorio que regula la relación laboral interna: jornada, horarios, lugares de prestación, días y forma de pago, permisos, sanciones y procedimientos disciplinarios. Debe registrarse ante el Centro Federal de Conciliación y Registro Laboral (CFCRL).", autoridad:"STPS / CFCRL", especialidades:["Todas"], obligatorio:true},
  // ISO
  {id:"spi1", nivel:"iso", clave:"ISO 9001:2015", titulo:"Sistema de Gestión de Calidad para servicios profesionales", descripcion:"Permite estandarizar los procesos del despacho: atención al cliente, gestión de expedientes, revisión de calidad de entregables y mejora continua. Es un diferenciador importante para ganar licitaciones corporativas.", autoridad:"ISO / IMNC", especialidades:["Todas"], obligatorio:false},
  {id:"spi2", nivel:"iso", clave:"ISO 27001:2022", titulo:"Seguridad de la información — Despachos y consultoras", descripcion:"El estándar más relevante para despachos profesionales que manejan información confidencial de clientes. Cubre controles de acceso, cifrado, gestión de incidentes y continuidad del negocio ante ataques cibernéticos o pérdida de datos.", autoridad:"ISO / IMNC", especialidades:["Despacho de Abogados / Notaría","Despacho Contable / Fiscal","Consultoría / Asesoría Empresarial"], obligatorio:false},
  {id:"spi3", nivel:"iso", clave:"ISO 45001:2018", titulo:"Seguridad y salud en el trabajo", descripcion:"Para firmas con plantillas medianas o grandes que buscan certificar su gestión de riesgos laborales, incluyendo el estrés y el burnout profesional.", autoridad:"ISO / IMNC", especialidades:["Todas"], obligatorio:false},
];


// #endregion
// #region DATOS: HOTELERÍA Y TURISMO
// ─── DATOS: HOTELERÍA Y TURISMO ───────────────────────────────────────────────
const ESP_HOTELERIA = [
  "Todas",
  "Hotel / Motel / Boutique",
  "Restaurante Turístico / Bar",
  "Agencia de Viajes / Tour Operador",
  "Centro de Entretenimiento / Spa",
  "Guía de Turistas",
  "Servicios de Transporte Turístico",
];

const REGS_HOTELERIA: Regulacion[] = [
  // MARCO LEGAL
  {id:"hotf1", nivel:"marco", esMarco:true, clave:"Ley General de Turismo", titulo:"Ley General de Turismo", descripcion:"Marco federal que regula las actividades turísticas en México. Establece las bases para la planeación, programación, fomento, desarrollo, promoción y regulación del sector turístico.", autoridad:"SECTUR — Secretaría de Turismo Federal", especialidades:["Todas"], obligatorio:true},
  {id:"hotf2", nivel:"marco", esMarco:true, clave:"Ley Federal de Turismo — Reglamento", titulo:"Reglamento de la Ley General de Turismo", descripcion:"Detalla las obligaciones de los prestadores de servicios turísticos: clasificación de establecimientos, calidad, derechos del turista y sanciones por incumplimiento.", autoridad:"SECTUR", especialidades:["Todas"], obligatorio:true},
  {id:"hotf3", nivel:"marco", esMarco:true, clave:"LFPC — Turismo", titulo:"Ley Federal de Protección al Consumidor — Servicios turísticos", descripcion:"Regula los contratos de servicios turísticos, paquetes vacacionales, reservaciones y derechos del turista ante cancelaciones y cambios.", autoridad:"PROFECO", especialidades:["Todas"], obligatorio:true},
  {id:"hotf4", nivel:"marco", esMarco:true, clave:"Ley General de Salud — Establecimientos", titulo:"Ley General de Salud — Establecimientos de hospedaje y alimentos", descripcion:"Regula las condiciones sanitarias de los establecimientos de hospedaje y los que sirven alimentos y bebidas.", autoridad:"Secretaría de Salud Federal", especialidades:["Todas"], obligatorio:true},
  {id:"hote1", nivel:"marco", esMarco:true, clave:"Ley de Turismo AGS", titulo:"Ley de Turismo del Estado de Aguascalientes", descripcion:"Regula el desarrollo turístico local, la clasificación de establecimientos y las obligaciones de los prestadores de servicios turísticos en el estado.", autoridad:"Instituto Aguascalentense de Turismo (IAT)", especialidades:["Todas"], obligatorio:true},
  // FEDERAL ACCIONABLE
  {id:"hotf5", nivel:"federal", clave:"Registro SECTUR — RNT", titulo:"Registro Nacional de Turismo (RNT) ante SECTUR", descripcion:"Todo prestador de servicios turísticos debe inscribirse en el Registro Nacional de Turismo. Es un requisito para operar legalmente y acceder a programas de fomento federal.", autoridad:"SECTUR", especialidades:["Hotel / Motel / Boutique","Agencia de Viajes / Tour Operador","Guía de Turistas","Servicios de Transporte Turístico"], obligatorio:true},
  {id:"hotf6", nivel:"federal", clave:"SAT — Régimen fiscal", titulo:"Obligaciones fiscales: RFC, CFDI, régimen fiscal", descripcion:"Los establecimientos turísticos deben emitir CFDI por cada servicio, declarar IVA mensualmente y cumplir con el régimen fiscal correspondiente.", autoridad:"SAT", especialidades:["Todas"], obligatorio:true},
  {id:"hotf7", nivel:"federal", clave:"COFEPRIS — Hospedaje", titulo:"Aviso de funcionamiento ante COFEPRIS", descripcion:"Los establecimientos de hospedaje con servicios de alimentos y bebidas deben presentar aviso de funcionamiento ante COFEPRIS.", autoridad:"COFEPRIS", especialidades:["Hotel / Motel / Boutique","Restaurante Turístico / Bar"], obligatorio:true},
  {id:"hotf8", nivel:"federal", clave:"Licencia Federal Guías", titulo:"Licencia federal para guías de turistas", descripcion:"Los guías de turistas deben contar con licencia federal expedida por SECTUR. Se requiere acreditar conocimientos específicos del destino y del patrimonio cultural.", autoridad:"SECTUR", especialidades:["Guía de Turistas"], obligatorio:true},
  // ESTATAL
  {id:"hote2", nivel:"estatal", clave:"Registro IAT", titulo:"Registro ante el Instituto Aguascalentense de Turismo (IAT)", descripcion:"Todo prestador de servicios turísticos en AGS debe registrarse ante el IAT. El registro es requisito para operar con validez en el estado y para acceder a promoción en plataformas oficiales.", autoridad:"Instituto Aguascalentense de Turismo", especialidades:["Todas"], obligatorio:true},
  {id:"hote3", nivel:"estatal", clave:"Ley PC AGS — Hoteles", titulo:"Ley de Protección Civil AGS — Establecimientos turísticos", descripcion:"Los hoteles, restaurantes y centros de entretenimiento deben contar con Programa Interno de Protección Civil, brigadas capacitadas y simulacros periódicos.", autoridad:"Coordinación Estatal de PC", especialidades:["Hotel / Motel / Boutique","Centro de Entretenimiento / Spa"], obligatorio:true},
  // MUNICIPAL
  {id:"hotm1", nivel:"municipal", clave:"Licencia de Funcionamiento", titulo:"Licencia municipal de funcionamiento", descripcion:"Todo establecimiento turístico requiere licencia municipal de funcionamiento compatible con uso de suelo turístico o mixto.", autoridad:"Ayuntamiento de Aguascalientes — Desarrollo Económico", especialidades:["Todas"], obligatorio:true},
  {id:"hotm2", nivel:"municipal", clave:"Licencia de Alcoholes", titulo:"Licencia municipal para venta de bebidas alcohólicas", descripcion:"Los hoteles con bar, restaurantes turísticos y bares deben contar con licencia municipal de alcoholes además de la licencia de funcionamiento.", autoridad:"Ayuntamiento — Dirección de Alcoholes", especialidades:["Hotel / Motel / Boutique","Restaurante Turístico / Bar","Centro de Entretenimiento / Spa"], obligatorio:true},
  {id:"hotm3", nivel:"municipal", clave:"Dictamen PC Municipal", titulo:"Dictamen de Protección Civil municipal", descripcion:"Verificación de extintores, señalización, salidas de emergencia y capacidad máxima de ocupación.", autoridad:"Dirección de PC Municipal", especialidades:["Todas"], obligatorio:true},
  {id:"hotm4", nivel:"municipal", clave:"Uso de Suelo Turístico", titulo:"Constancia de uso de suelo compatible con actividad turística", descripcion:"El predio debe tener uso de suelo compatible con la actividad turística o de servicios. En zonas históricas aplican restricciones adicionales.", autoridad:"Ayuntamiento — Ordenamiento Territorial", especialidades:["Todas"], obligatorio:true},
  // NOMs UNIVERSALES
  {id:"hotn1", nivel:"nom_universal", clave:"NOM-010-TUR-2001", titulo:"Prestadores de servicios turísticos — Requisitos mínimos de información al turista", descripcion:"Establece los requisitos mínimos de información que deben proporcionar los prestadores de servicios turísticos: precios, condiciones, cancelaciones y derechos del usuario.", autoridad:"SECTUR", especialidades:["Todas"], obligatorio:true},
  {id:"hotn2", nivel:"nom_universal", clave:"NOM-251-SSA1-2009", titulo:"Prácticas de higiene — alimentos en establecimientos turísticos", descripcion:"La norma más importante para restaurantes turísticos y cocinas de hoteles. Requisitos mínimos de higiene en instalaciones, personal y proceso de alimentos.", autoridad:"SSA / COFEPRIS", especialidades:["Hotel / Motel / Boutique","Restaurante Turístico / Bar"], obligatorio:true},
  {id:"hotn3", nivel:"nom_universal", clave:"NOM-002-STPS-2010", titulo:"Prevención y protección contra incendios", descripcion:"Extintores, detectores de humo, rutas de evacuación y simulacros. Aplica a todos los establecimientos turísticos.", autoridad:"STPS", especialidades:["Todas"], obligatorio:true},
  {id:"hotn4", nivel:"nom_universal", clave:"NOM-026-STPS-2008", titulo:"Colores y señales de seguridad", descripcion:"Señalización de rutas de evacuación, zonas de riesgo y extintores dentro del establecimiento.", autoridad:"STPS", especialidades:["Todas"], obligatorio:true},
  // NOMs POR ESPECIALIDAD
  {id:"hotne1", nivel:"nom_especialidad", clave:"NOM-07-TUR-2002", titulo:"Agencias de viajes — Requisitos para su funcionamiento", descripcion:"Establece los requisitos para la operación de agencias de viajes: información al cliente, contratos, garantías, seguros y condiciones de los paquetes turísticos.", autoridad:"SECTUR", especialidades:["Agencia de Viajes / Tour Operador"], obligatorio:true},
  {id:"hotne2", nivel:"nom_especialidad", clave:"NOM-08-TUR-2002", titulo:"Guías de turistas — Requisitos y clasificación", descripcion:"Requisitos de conocimiento, certificación y conducta de los guías de turistas. Establece las categorías según el tipo de turismo (general, especializado, ecoturismo).", autoridad:"SECTUR", especialidades:["Guía de Turistas"], obligatorio:true},
  {id:"hotne3", nivel:"nom_especialidad", clave:"NOM-09-TUR-2002", titulo:"Turismo de aventura — Requisitos de seguridad", descripcion:"Aplica a operadores de turismo de aventura: ciclismo, senderismo, rappel, tirolesa y actividades similares. Incluye equipamiento, guías certificados y seguros.", autoridad:"SECTUR", especialidades:["Agencia de Viajes / Tour Operador","Guía de Turistas"], obligatorio:false},
  {id:"hotne4", nivel:"nom_especialidad", clave:"NOM-142-SSA1/SCFI-2014", titulo:"Bebidas alcohólicas — Especificaciones sanitarias y etiquetado", descripcion:"Para bares, restaurantes turísticos y hoteles con bar. Regula las condiciones sanitarias y de etiquetado en la venta de bebidas alcohólicas.", autoridad:"SSA / SE", especialidades:["Restaurante Turístico / Bar","Hotel / Motel / Boutique","Centro de Entretenimiento / Spa"], obligatorio:true},
  {id:"hotne5", nivel:"nom_especialidad", clave:"NOM-030-SSA3-2013 — Spa", titulo:"Establecimientos de atención a la salud — Servicios de spa y bienestar", descripcion:"Para establecimientos que ofrezcan masajes, tratamientos corporales o servicios de bienestar. Incluye requisitos de personal certificado, higiene e instalaciones.", autoridad:"SSA", especialidades:["Centro de Entretenimiento / Spa"], obligatorio:true},
  // NOMs COMPLEMENTARIAS
  {id:"hotnc1", nivel:"nom_complementaria", clave:"NOM-001-SEMARNAT-2021", titulo:"Descargas de aguas residuales — albercas y lavandería", descripcion:"Los hoteles con alberca o lavandería industrial deben tratar sus aguas residuales antes de descargarlas. Aplica especialmente a hoteles medianos y grandes.", autoridad:"SEMARNAT", especialidades:["Hotel / Motel / Boutique"], obligatorio:true},
  {id:"hotnc2", nivel:"nom_complementaria", clave:"NOM-011-SEMARNAT-2001", titulo:"Niveles máximos permisibles de ruido", descripcion:"Aplica a bares, discotecas y centros de entretenimiento. El ruido exterior no debe exceder los límites establecidos en función de la zona y el horario.", autoridad:"SEMARNAT", especialidades:["Centro de Entretenimiento / Spa","Restaurante Turístico / Bar"], obligatorio:true},
  {id:"hotnc3", nivel:"nom_complementaria", clave:"NOM-030-STPS-2009", titulo:"Servicios preventivos de seguridad y salud en el trabajo", descripcion:"Para establecimientos con más de 100 trabajadores, como hoteles medianos y grandes, se requiere un servicio preventivo formal de seguridad e higiene.", autoridad:"STPS", especialidades:["Hotel / Motel / Boutique"], obligatorio:true},
  // LABORAL
  {id:"hotl1", nivel:"laboral", clave:"IMSS — Alta patronal", titulo:"Registro patronal y alta de trabajadores ante el IMSS", descripcion:"Todo establecimiento con personal debe registrarse como patrón. En hoteles y restaurantes es frecuente el trabajo por turnos y eventual, todos deben estar asegurados.", autoridad:"IMSS", especialidades:["Todas"], obligatorio:true},
  {id:"hotl2", nivel:"laboral", clave:"INFONAVIT", titulo:"Aportaciones al INFONAVIT", descripcion:"5% del salario base de cotización bimestral por cada trabajador.", autoridad:"INFONAVIT", especialidades:["Todas"], obligatorio:true},
  {id:"hotl3", nivel:"laboral", clave:"LFT — Contratos turismo", titulo:"Contratos de trabajo — personal de turismo", descripcion:"El sector turístico tiene trabajadores por temporada, eventuales y de planta. Cada tipo requiere un contrato específico. Los meseros y personal de contacto con propinas tienen un régimen especial de cotización ante el IMSS.", autoridad:"STPS", especialidades:["Todas"], obligatorio:true},
  {id:"hotl4", nivel:"laboral", clave:"NOM-035-STPS-2018", titulo:"Factores de riesgo psicosocial", descripcion:"El sector turístico tiene alta incidencia de estrés laboral por horarios nocturnos, trato con público y estacionalidad. Aplica a establecimientos con más de 15 trabajadores.", autoridad:"STPS", especialidades:["Todas"], obligatorio:true},
  {id:"hotl5", nivel:"laboral", clave:"RIT — Art. 422 LFT", titulo:"Reglamento Interno de Trabajo (Art. 422 LFT)", descripcion:"Documento obligatorio que regula la relación laboral interna: jornada, horarios, lugares de prestación, días y forma de pago, permisos, sanciones y procedimientos disciplinarios. Debe registrarse ante el Centro Federal de Conciliación y Registro Laboral (CFCRL).", autoridad:"STPS / CFCRL", especialidades:["Todas"], obligatorio:true},
  // ISO
  {id:"hoti1", nivel:"iso", clave:"NMX-TT-009-IMNC-2004", titulo:"Requisitos mínimos de calidad para hoteles — NMX", descripcion:"Norma mexicana de calidad para establecimientos de hospedaje. Aunque no es ISO internacional, es la referencia de calidad reconocida por SECTUR para clasificación de hoteles.", autoridad:"IMNC / SECTUR", especialidades:["Hotel / Motel / Boutique"], obligatorio:false},
  {id:"hoti2", nivel:"iso", clave:"ISO 9001:2015", titulo:"Sistema de Gestión de Calidad", descripcion:"Para hoteles y agencias de viajes que buscan certificar la calidad de sus procesos. Requerido por cadenas hoteleras y clientes corporativos.", autoridad:"ISO / IMNC", especialidades:["Hotel / Motel / Boutique","Agencia de Viajes / Tour Operador"], obligatorio:false},
  {id:"hoti3", nivel:"iso", clave:"ISO 14001:2015", titulo:"Sistema de Gestión Ambiental — Turismo sustentable", descripcion:"Para hoteles con compromiso de sustentabilidad. Cada vez más valorado por turistas nacionales e internacionales y requerido por operadores de turismo responsable.", autoridad:"ISO / IMNC", especialidades:["Hotel / Motel / Boutique","Agencia de Viajes / Tour Operador"], obligatorio:false},
];

// #endregion
// ─── MAPA DE SECTORES ─────────────────────────────────────────────────────────
const SECTOR_DATA: Record<string,{regs:Regulacion[];especialidades:string[]}> = {
  medico:      {regs:REGS_MEDICO,       especialidades:ESP_MEDICO},
  restaurante: {regs:REGS_RESTAURANTE,  especialidades:ESP_RESTAURANTE},
  construccion:{regs:REGS_CONSTRUCCION, especialidades:ESP_CONSTRUCCION},
  inmobiliario:{regs:REGS_INMOBILIARIO, especialidades:ESP_INMOBILIARIO},
  comercio:    {regs:REGS_COMERCIO,     especialidades:ESP_COMERCIO},
  manufactura: {regs:REGS_MANUFACTURA,  especialidades:ESP_MANUFACTURA},
  educacion:   {regs:REGS_EDUCACION,    especialidades:ESP_EDUCACION},
  transporte:  {regs:REGS_TRANSPORTE,   especialidades:ESP_TRANSPORTE},
  servicios:   {regs:REGS_SERVICIOS,    especialidades:ESP_SERVICIOS},
  hoteleria:   {regs:REGS_HOTELERIA,    especialidades:ESP_HOTELERIA},
};

const SECTORES: Sector[] = [
  {id:"medico",       nombre:"Sector Médico",              descripcion:"Consultorios, hospitales, laboratorios y clínicas",                   icon:"🏥", color:"#4A9EFF", acento:"rgba(74,158,255,0.15)",  disponible:true, totalRegs:REGS_MEDICO.length},
  {id:"restaurante",  nombre:"Restaurantes y Alimentos",    descripcion:"Restaurantes, bares, cafeterías y cocinas centrales",                 icon:"🍽️", color:"#F5A623", acento:"rgba(245,166,35,0.15)",  disponible:true, totalRegs:REGS_RESTAURANTE.length},
  {id:"construccion", nombre:"Construcción",  descripcion:"Obras, contratistas, desarrollos habitacionales/comerciales y remodelaciones",              icon:"🏗️", color:"#A855F7", acento:"rgba(168,85,247,0.15)",  disponible:true, totalRegs:REGS_CONSTRUCCION.length},
  {id:"inmobiliario", nombre:"Sector Inmobiliario",          descripcion:"Agencias, arrendadores y administración de propiedades",             icon:"🏠", color:"#EC4899", acento:"rgba(236,72,153,0.15)",  disponible:true, totalRegs:REGS_INMOBILIARIO.length},
  {id:"comercio",     nombre:"Comercio al por Menor",        descripcion:"Tiendas, farmacias, abarrotes y establecimientos de venta",          icon:"🛒", color:"#06B6D4", acento:"rgba(6,182,212,0.15)",   disponible:true, totalRegs:REGS_COMERCIO.length},
  {id:"manufactura",  nombre:"Manufactura e Industria",      descripcion:"Autopartes, textil, agroindustria, metal-mecánica y química",        icon:"🏭", color:"#10B981", acento:"rgba(16,185,129,0.15)",  disponible:true, totalRegs:REGS_MANUFACTURA.length},
  {id:"educacion",    nombre:"Educación Privada",            descripcion:"Escuelas, guarderías, institutos, academias y centros de capacitación", icon:"🎓", color:"#F472B6", acento:"rgba(244,114,182,0.15)", disponible:true, totalRegs:REGS_EDUCACION.length},
  {id:"transporte",   nombre:"Transporte y Logística",       descripcion:"Autotransporte federal, carga, paquetería, logística y almacenaje",  icon:"🚛", color:"#FB923C", acento:"rgba(251,146,60,0.15)",  disponible:true, totalRegs:REGS_TRANSPORTE.length},
  {id:"servicios",    nombre:"Servicios Profesionales",      descripcion:"Despachos de abogados, contadores, consultores, arquitectos y agencias", icon:"💼", color:"#A78BFA", acento:"rgba(167,139,250,0.15)", disponible:true, totalRegs:REGS_SERVICIOS.length},
  {id:"hoteleria",    nombre:"Hotelería y Turismo",           descripcion:"Hoteles, restaurantes turísticos, agencias de viajes y centros de entretenimiento", icon:"🏨", color:"#0EA5E9", acento:"rgba(14,165,233,0.15)", disponible:true, totalRegs:REGS_HOTELERIA.length},
];

const TOTAL_REGS = Object.values(SECTOR_DATA).reduce((s,d) => s + d.regs.length, 0);

// ─── SISTEMA DE ICONOS AXIS ────────────────────────────────────────────────
// Estilo unificado: line-art SVG · stroke 3 · backdrop translúcido (B2)
// Uso: <AxisIcon name="medico" size={42} />
// Si más adelante quieres cambiar el estilo (más grueso, más sutil, otra paleta),
// se hace en UN solo lugar y aplica en toda la app.

const AXIS_ICONS_PATHS: Record<string, JSX.Element> = {
  // Industrias del Diagnóstico
  medico: (<><rect x="8" y="14" width="48" height="42" rx="3"/><path d="M14 14V11a4 4 0 014-4h28a4 4 0 014 4v3"/><path d="M32 26v18M23 35h18"/></>),
  restaurante: (<><path d="M22 6v22a4 4 0 008 0V6M26 6v18"/><path d="M44 6c-3 0-6 4-6 10s3 10 6 10v22"/></>),
  construccion: (<><path d="M6 56h52"/><path d="M14 56V18l38 10"/><path d="M14 36h18"/><rect x="36" y="42" width="14" height="14"/></>),
  inmobiliario: (<><path d="M8 30L32 10l24 20"/><path d="M14 26v30h36V26"/><rect x="26" y="36" width="12" height="20"/></>),
  comercio: (<><path d="M6 10h8l8 30h26l5-22H22"/><circle cx="24" cy="50" r="4"/><circle cx="44" cy="50" r="4"/></>),
  manufactura: (<><path d="M8 56V30l14 10V30l14 10V18l20 22v16z"/><path d="M16 50h2M30 50h2M44 50h2M52 50h2"/></>),
  educacion: (<><path d="M32 12L4 24l28 12 28-12z"/><path d="M16 30v14c0 4 7 8 16 8s16-4 16-8V30"/><path d="M58 24v14"/></>),
  transporte: (<><rect x="4" y="22" width="32" height="22"/><path d="M36 30h12l8 10v4H36z"/><circle cx="18" cy="50" r="4"/><circle cx="48" cy="50" r="4"/></>),
  servicios: (<><rect x="6" y="20" width="52" height="36" rx="3"/><path d="M22 20v-6a4 4 0 014-4h12a4 4 0 014 4v6"/><path d="M6 36h52"/></>),
  hoteleria: (<><rect x="10" y="6" width="44" height="50"/><path d="M20 16h4M30 16h4M40 16h4"/><path d="M20 26h4M30 26h4M40 26h4"/><rect x="26" y="36" width="12" height="20"/></>),

  // ─── Módulos de la Suite ───────────────────────────────────────────────
  // Diagnóstico Regulatorio (balanza romana estilizada)
  suite_diagnostico: (<><path d="M32 10v44"/><path d="M14 22h36"/><path d="M14 22v3M50 22v3"/><path d="M6 30l8 14 8-14"/><path d="M42 30l8 14 8-14"/><rect x="22" y="52" width="20" height="4" rx="1"/></>),
  // Calculadora LFT (calculadora con pantalla y botones)
  suite_calculadora: (<><rect x="14" y="6" width="36" height="52" rx="3"/><rect x="20" y="14" width="24" height="10" rx="1"/><circle cx="22" cy="34" r="2"/><circle cx="32" cy="34" r="2"/><circle cx="42" cy="34" r="2"/><circle cx="22" cy="42" r="2"/><circle cx="32" cy="42" r="2"/><circle cx="42" cy="42" r="2"/><circle cx="22" cy="50" r="2"/><circle cx="32" cy="50" r="2"/><circle cx="42" cy="50" r="2"/></>),
  // Flotilla (auto sedán con ventanas)
  suite_flotilla: (<><path d="M10 38l4-12c1-3 3-4 6-4h24c3 0 5 1 6 4l4 12"/><rect x="6" y="36" width="52" height="14" rx="2"/><circle cx="20" cy="50" r="4"/><circle cx="44" cy="50" r="4"/><path d="M20 26h10v10M34 26h10v10"/></>),
  // Contratos (documento con esquina doblada y firma)
  suite_contratos: (<><path d="M14 6h24l12 12v40H14z"/><path d="M38 6v12h12"/><path d="M22 30h20M22 36h20M22 42h12"/><path d="M22 50c2-2 4-2 6 0s4 2 6 0"/></>),
  // Empleados (dos personas estilizadas)
  suite_empleados: (<><circle cx="22" cy="20" r="7"/><circle cx="42" cy="20" r="7"/><path d="M8 52v-2c0-6 6-10 14-10s14 4 14 10v2"/><path d="M28 52v-2c0-6 6-10 14-10s14 4 14 10v2"/></>),
  // Calendario (calendario con anillas y días)
  suite_calendario: (<><rect x="8" y="14" width="48" height="42" rx="3"/><path d="M8 24h48"/><path d="M20 8v10M44 8v10"/><path d="M16 32h6M28 32h6M40 32h6"/><path d="M16 42h6M28 42h6M40 42h6"/></>),
  // Documentos (carpeta con pestaña)
  suite_documentos: (<><path d="M6 18h22l4 6h28v32H6z"/><path d="M6 26h52"/></>),
  // Suite Empresarial (dashboard con 4 cards)
  suite_dashboard: (<><rect x="8" y="8" width="22" height="22" rx="2"/><rect x="34" y="8" width="22" height="22" rx="2"/><rect x="8" y="34" width="22" height="22" rx="2"/><rect x="34" y="34" width="22" height="22" rx="2"/><path d="M14 16h10M14 22h6"/><path d="M40 16h10M40 22h6"/></>),

  // ─── Iconos UI auxiliares ─────────────────────────────────────────────
  // Candado abierto (Modo prueba / sesión anónima)
  lock_open: (<><rect x="14" y="28" width="36" height="28" rx="3"/><path d="M22 28v-8a10 10 0 0118-4"/><circle cx="32" cy="40" r="2.5"/><path d="M32 42v6"/></>),
  // Candado cerrado (Iniciar sesión / Plan Pro / Salir)
  lock_closed: (<><rect x="14" y="28" width="36" height="28" rx="3"/><path d="M22 28v-8a10 10 0 0120 0v8"/><circle cx="32" cy="40" r="2.5"/><path d="M32 42v6"/></>),
  // Rayo / bolt (Mi Suite, accesos rápidos)
  bolt: (<><path d="M36 6L14 36h14l-4 22 22-30H32z"/></>),
  // Globo terráqueo (sitio web)
  globe: (<><circle cx="32" cy="32" r="22"/><path d="M10 32h44"/><path d="M32 10c-6 6-10 14-10 22s4 16 10 22c6-6 10-14 10-22s-4-16-10-22z"/></>),
  // Pin de ubicación
  pin: (<><path d="M32 6c-9 0-16 7-16 16 0 12 16 32 16 32s16-20 16-32c0-9-7-16-16-16z"/><circle cx="32" cy="22" r="6"/></>),
  // Teléfono (handset)
  phone: (<><path d="M52 44v8a4 4 0 01-4 4C26 56 8 38 8 16a4 4 0 014-4h8l4 14-6 4c2 6 8 12 14 14l4-6z"/></>),
  // Sobre / email
  mail: (<><rect x="6" y="14" width="52" height="36" rx="2"/><path d="M6 18l26 18 26-18"/></>),
  // Balanza simple (AXIS Abogados, contacto legal — variante de la del Diagnóstico)
  scale_simple: (<><path d="M32 10v44"/><path d="M16 22h32"/><path d="M8 28l8 14 8-14"/><path d="M40 28l8 14 8-14"/><rect x="22" y="52" width="20" height="4" rx="1"/></>),
  // Check (cumplido, completado)
  check: (<><path d="M10 32l14 14L54 14"/></>),
  // X (cerrar, eliminar)
  x: (<><path d="M14 14l36 36M50 14L14 50"/></>),
  // Triángulo de alerta
  alert: (<><path d="M32 8L4 56h56z"/><path d="M32 24v16"/><circle cx="32" cy="48" r="2"/></>),
  // Campana / notificación urgente
  bell: (<><path d="M14 44V28a18 18 0 0136 0v16"/><path d="M8 48h48"/><path d="M28 52a4 4 0 008 0"/></>),
  // Clipboard / portapapeles
  clipboard: (<><rect x="14" y="10" width="36" height="48" rx="3"/><rect x="22" y="6" width="20" height="10" rx="2"/><path d="M22 28h20M22 36h20M22 44h12"/></>),
  // Edificio / negocio
  building: (<><rect x="14" y="8" width="36" height="48"/><path d="M22 18h4M30 18h4M38 18h4"/><path d="M22 28h4M30 28h4M38 28h4"/><path d="M22 38h4M30 38h4M38 38h4"/><rect x="28" y="48" width="8" height="8"/></>),
  // Casa
  house: (<><path d="M8 30L32 10l24 20"/><path d="M14 26v30h36V26"/><path d="M26 56V40h12v16"/></>),
  // Lupa / buscar
  search: (<><circle cx="26" cy="26" r="16"/><path d="M38 38l16 16"/></>),
  // Gráfica de barras
  chart: (<><path d="M8 56V32h10v24M27 56V18h10v38M46 56V8h10v48"/><path d="M4 56h56"/></>),
  // Link / enlace
  link: (<><path d="M28 36c-3 3-8 3-11 0s-3-8 0-11l8-8c3-3 8-3 11 0"/><path d="M36 28c3-3 8-3 11 0s3 8 0 11l-8 8c-3 3-8 3-11 0"/></>),
  // Cohete / lanzar
  rocket: (<><path d="M32 4l10 14v22l-10 8-10-8V18z"/><path d="M22 30l-10 6v14l10-6M42 30l10 6v14l-10-6"/><circle cx="32" cy="22" r="3"/></>),
  // Maletín / servicios profesionales
  briefcase: (<><rect x="6" y="20" width="52" height="36" rx="3"/><path d="M22 20v-6a4 4 0 014-4h12a4 4 0 014 4v6"/><path d="M6 36h52"/></>),
  // Avión de papel / enviar (WhatsApp, mensajes)
  send: (<><path d="M56 8L8 28l16 6 4 16 8-12 12 10z"/></>),
  // Filtros
  filter: (<><path d="M8 12h48l-18 22v18l-12-6V34z"/></>),
  // Documento individual (distinto al clipboard)
  document: (<><path d="M14 6h24l12 12v40H14z"/><path d="M38 6v12h12"/><path d="M22 30h20M22 38h20M22 46h12"/></>),
  // Plus / agregar
  plus: (<><path d="M32 12v40M12 32h40"/></>),
  // Dinero / honorarios (símbolo $ en círculo)
  money: (<><circle cx="32" cy="32" r="22"/><path d="M32 14v36"/><path d="M40 22c-2-2-5-3-8-3-4 0-8 2-8 6s4 5 8 5 8 1 8 5-4 6-8 6c-3 0-6-1-8-3"/></>),
  // Persona única (expediente individual)
  user_single: (<><circle cx="32" cy="22" r="10"/><path d="M14 56c0-10 8-18 18-18s18 8 18 18"/></>),
  // Casco de construcción / obra
  construction: (<><path d="M14 40c0-10 8-18 18-18s18 8 18 18v8H14z"/><rect x="10" y="48" width="44" height="6" rx="1"/><path d="M28 22v-4h8v4"/></>),
  // Flecha saliendo (salida vehículo)
  arrow_out: (<><path d="M8 32h44"/><path d="M36 16l16 16-16 16"/></>),
  // Flecha entrando (regreso vehículo)
  arrow_in: (<><path d="M56 32H12"/><path d="M28 16L12 32l16 16"/></>),
  // Info / información (i en círculo)
  info: (<><circle cx="32" cy="32" r="24"/><circle cx="32" cy="20" r="2.5" fill="currentColor"/><path d="M32 30v18"/></>),
  // Refresh / recargar (flecha circular)
  refresh: (<><path d="M48 20a18 18 0 10-2 22"/><path d="M48 8v12h-12"/></>),
  // Estados semáforo de cumplimiento — círculos sólidos rellenos
  status_dot: (<><circle cx="32" cy="32" r="22" fill="currentColor" stroke="currentColor" strokeWidth="0"/></>),
};

function AxisIcon({name, size=42, tone="white", withBackdrop=true, strokeWidth=3, color}:
  {name:string; size?:number; tone?:"white"|"gold"; withBackdrop?:boolean; strokeWidth?:number; color?:string}) {
  const paths = AXIS_ICONS_PATHS[name];
  if (!paths) return null;
  const stroke = color ? color : (tone === "gold" ? "#D4A843" : "white");
  const innerSize = withBackdrop ? Math.round(size * 0.55) : size;
  const svg = (
    <svg width={innerSize} height={innerSize} viewBox="0 0 64 64"
      fill="none" stroke={stroke} strokeWidth={strokeWidth}
      strokeLinecap="round" strokeLinejoin="round">
      {paths}
    </svg>
  );
  if (!withBackdrop) return svg;
  const bg = tone === "gold" ? "rgba(212,168,67,0.12)" : "rgba(0,0,0,0.18)";
  const border = tone === "gold" ? "rgba(212,168,67,0.25)" : "rgba(255,255,255,0.12)";
  return (
    <div style={{
      width:size, height:size, borderRadius:Math.round(size*0.24),
      background:bg, border:`1px solid ${border}`,
      display:"flex", alignItems:"center", justifyContent:"center",
      backdropFilter:"blur(4px)", WebkitBackdropFilter:"blur(4px)",
      flexShrink:0,
    }}>{svg}</div>
  );
}

// ─── BOTÓN DE RECARGA (los dos portales móviles) ────────────────────────────
// Un BOTÓN, no el gesto de tirar hacia abajo: en iOS ese gesto pelea con el
// desplazamiento de la página y acaba disparándose cuando no toca —o no
// disparándose cuando sí—. Un botón se toca a propósito y se sabe qué hizo.
//
// No cambia NADA de cómo se leen los datos: vuelve a correr la misma carga que
// ya existe. Pasar a escucha en vivo es otra conversación.
function BotonRecargar({onRecargar, cargando, error, color, borde}: {
  onRecargar:()=>void; cargando:boolean; error?:boolean; color:string; borde:string;
}) {
  const [tocado, setTocado] = useState(false);
  // "Listo" solo tras una recarga que el usuario pidió: sin esto no habría forma
  // de distinguir "ya cargó" de "no pasó nada".
  useEffect(() => {
    if (!tocado || cargando) return;
    const id = setTimeout(()=>setTocado(false), 1800);
    return ()=>clearTimeout(id);
  }, [tocado, cargando]);
  const estado = cargando ? "cargando" : (tocado && error) ? "error" : tocado ? "listo" : "idle";
  return (<>
    <style>{`@keyframes axisGira{to{transform:rotate(360deg)}}`}</style>
    <button
      onClick={()=>{ if (!cargando) { setTocado(true); onRecargar(); } }}
      disabled={cargando}
      aria-label="Actualizar datos"
      title={estado==="error" ? "No se pudo actualizar" : "Actualizar datos"}
      style={{display:"inline-flex", alignItems:"center", gap:6, padding:"6px 10px", borderRadius:999,
        cursor: cargando ? "wait" : "pointer", fontFamily:"inherit", fontSize:11.5, fontWeight:800,
        background: estado==="error" ? "rgba(220,38,38,0.16)" : "rgba(255,255,255,0.06)",
        border:`1px solid ${estado==="error" ? "rgba(252,165,165,0.5)" : borde}`,
        color: estado==="error" ? "#FCA5A5" : color, flexShrink:0, WebkitTapHighlightColor:"transparent"}}>
      <span style={{display:"inline-flex", animation: cargando ? "axisGira 0.9s linear infinite" : "none"}}>
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
          <path d="M20 11a8 8 0 10-.6 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          <path d="M20 4v7h-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </span>
      <span>{estado==="cargando" ? "Actualizando…" : estado==="error" ? "No se pudo" : estado==="listo" ? "Listo" : "Actualizar"}</span>
    </button>
  </>);
}

// ─── BANNER DE INSTALACIÓN PWA (reutilizable entre pantallas) ──────────────
// `onCerrar` y `nota` son OPCIONALES y solo los usa el bloque de Inicio; los otros
// tres montajes —portada, portal del trabajador y la landing— no pasan ninguno y no
// cambian en nada.
//   · `onCerrar`: el bloque que lo envuelve necesita enterarse en el MISMO render,
//     porque si esto se esconde y él no, queda un encabezado sin nada debajo.
//   · `nota`: una línea extra cuando instalar es además lo que habilita los avisos,
//     que es el caso de iPhone. Así no hacen falta dos mensajes diciendo lo mismo.
// `motivo` (opcional): SUSTITUYE el subtítulo genérico en vez de añadirse debajo.
// Antes era una `nota` al pie, más tenue y en tercera línea, y ese sitio la volvía
// invisible: una pasante abrió la plataforma en su iPhone, vio el banner de
// instalar y no vio nada sobre avisos. El motivo por el que alguien haría el
// esfuerzo de instalar tiene que ser LO QUE SE LEE, no lo que hay que buscar
// debajo. Solo lo pasa `PrepararDispositivo`, y solo en el caso de iPhone sin
// instalar; en los demás montajes el subtítulo genérico sigue igual.
function InstallBanner({fontSerif, gold, isMobile, onCerrar, motivo}: {fontSerif:string; gold:string; isMobile:boolean; onCerrar?:()=>void; motivo?:string}) {
  const [installPrompt, setInstallPrompt] = useState<any>(null);
  const [showModal, setShowModal] = useState(false);
  const [showInstall, setShowInstall] = useState(() => {
    try { return localStorage.getItem("axis_install_dismissed") !== "1"; }
    catch { return true; }
  });

  useEffect(() => {
    const handler = (e: any) => {
      e.preventDefault();
      setInstallPrompt(e);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstallClick = async () => {
    if (installPrompt) {
      // Chrome puede instalar directo
      installPrompt.prompt();
      const { outcome } = await installPrompt.userChoice;
      if (outcome === "accepted") {
        setShowInstall(false);
        try { localStorage.setItem("axis_install_dismissed", "1"); } catch {}
      }
    } else {
      // No hay prompt nativo → abrir modal con instrucciones visuales
      setShowModal(true);
    }
  };

  const dismissInstall = () => {
    setShowInstall(false);
    try { localStorage.setItem("axis_install_dismissed", "1"); } catch {}
    if (onCerrar) onCerrar();
  };

  // Detección de entorno — la pregunta vive en `_esStandalone`, que comparte con la
  // puerta de los avisos. Antes estaba escrita aquí en línea y allí otra vez.
  const isStandalone = _esStandalone();
  const isInIframe = typeof window !== "undefined" && window.self !== window.top;
  // ⚠️ EN iPHONE Y iPAD EL BOTÓN NO PUEDE DECIR "INSTALAR". iOS no tiene el aviso
  // de instalación del navegador: tocarlo abre la ventana de pasos, que empieza
  // explicando que no se instala con un toque. Un botón que promete una cosa y
  // abre otra es un botón que miente. La detección es `_esIOS`, la misma que usa
  // la puerta de los avisos, para que un iPad no sea iPad en una y Mac en otra.
  const esIOS = _esIOS();

  if (isStandalone || isInIframe || !showInstall) return null;

  return (
    <>
      {/* Banner compacto y directo */}
      <div style={{marginBottom:20, background:"linear-gradient(135deg, #1B2B4B, #1F3460)", borderRadius:14, padding:isMobile?"14px 16px":"16px 20px", display:"flex", alignItems:"center", gap:12, border:"1px solid rgba(184,147,42,0.25)", boxShadow:"0 4px 12px rgba(0,0,0,0.2)"}}>
        {/* Icono chevron AXIS */}
        <div style={{width:42, height:42, background:"rgba(184,147,42,0.15)", borderRadius:10, flexShrink:0, display:"flex", alignItems:"center", justifyContent:"center", border:"1px solid rgba(184,147,42,0.3)"}}>
          <svg width="22" height="22" viewBox="0 0 64 64" fill="none" stroke={gold} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 28L32 12l20 16"/>
            <path d="M16 32L32 20l16 12"/>
            <path d="M20 36L32 28l12 8"/>
            <line x1="10" y1="44" x2="54" y2="44"/>
          </svg>
        </div>
        {/* Texto */}
        <div style={{flex:1, minWidth:0}}>
          <div style={{fontFamily:fontSerif, fontSize:isMobile?13:14, fontWeight:700, color:gold, marginBottom:2}}>Instala AXIS Legaltech</div>
          {/* O EL MOTIVO, O EL RECLAMO GENÉRICO — nunca los dos. Si se apilaran,
              el motivo volvería a ser la segunda cosa que se lee, que es el
              defecto que esto viene a corregir. Y "acceso rápido" no se pierde:
              el motivo ya dice "en tu pantalla de inicio".
              Va algo más claro que el subtítulo que sustituye porque carga el
              porqué, y con más interlineado porque en un banner estrecho ocupa
              dos renglones. */}
          {motivo
            ? <div style={{fontSize:11, color:"rgba(255,255,255,0.72)", lineHeight:1.45}}>{motivo}</div>
            : <div style={{fontSize:11, color:"rgba(255,255,255,0.6)"}}>Acceso rápido desde tu pantalla de inicio</div>}
        </div>
        {/* Botones */}
        <div style={{display:"flex", gap:8, flexShrink:0, alignItems:"center"}}>
          <button onClick={handleInstallClick} style={{
            background:`linear-gradient(135deg, ${gold}, #A07C30)`,
            border:"none", borderRadius:10, padding:isMobile?"10px 16px":"10px 20px",
            cursor:"pointer", fontSize:13, fontWeight:700, color:"#0A0A0A",
            whiteSpace:"nowrap" as const, boxShadow:"0 2px 8px rgba(212,168,67,0.4)"
          }}>{esIOS ? "Cómo instalar" : "📲 Instalar"}</button>
          <button onClick={dismissInstall} style={{
            background:"transparent", border:"1px solid rgba(255,255,255,0.15)",
            borderRadius:8, width:32, height:32, padding:0,
            color:"rgba(255,255,255,0.4)", cursor:"pointer", fontSize:14,
            display:"flex", alignItems:"center", justifyContent:"center"
          }}>✕</button>
        </div>
      </div>

      {/* Modal con instrucciones visuales por plataforma */}
      {showModal && <InstallInstructionsModal onClose={() => setShowModal(false)} fontSerif={fontSerif} gold={gold} />}
    </>
  );
}

// Modal con instrucciones visuales paso-a-paso
function InstallInstructionsModal({onClose, fontSerif, gold}: {onClose:()=>void; fontSerif:string; gold:string}) {
  const ua = typeof navigator !== "undefined" ? navigator.userAgent : "";
  // LA MISMA DETECCIÓN QUE LA PUERTA DE LOS AVISOS. Aquí había otra, escrita en
  // línea, que no sabía que el iPad moderno se anuncia como Mac: al iPad le daba
  // las instrucciones de computadora —un icono en la barra de direcciones que en
  // iPad no existe— mientras la puerta de avisos, en el mismo iPad, le hablaba de
  // pantalla de inicio. Dos respuestas distintas del mismo aparato.
  const isIOS = _esIOS();
  const isAndroid = !isIOS && /android/i.test(ua);
  const isDesktop = !isIOS && !isAndroid;
  const esIPad = isIOS && !/iphone|ipod/i.test(ua);
  const dispositivo = isDesktop ? "computadora" : (isIOS ? (esIPad ? "iPad" : "iPhone") : "celular");

  return (
    <div onClick={onClose} style={{
      position:"fixed" as const, inset:0, background:"rgba(0,0,0,0.85)",
      backdropFilter:"blur(8px)", WebkitBackdropFilter:"blur(8px)",
      display:"flex", alignItems:"center", justifyContent:"center",
      zIndex:9999, padding:"20px"
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        background:"linear-gradient(160deg, #1B2B4B 0%, #0B1829 100%)",
        borderRadius:20, padding:"28px 22px", maxWidth:480, width:"100%",
        border:"1px solid rgba(212,168,67,0.3)",
        position:"relative" as const, maxHeight:"90vh", overflowY:"auto" as const,
        boxShadow:"0 20px 60px rgba(0,0,0,0.6)"
      }}>
        {/* Close button */}
        <button onClick={onClose} style={{
          position:"absolute" as const, top:14, right:14,
          background:"rgba(255,255,255,0.08)", border:"none",
          width:32, height:32, borderRadius:"50%",
          color:"rgba(255,255,255,0.6)", fontSize:16, cursor:"pointer",
          display:"flex", alignItems:"center", justifyContent:"center"
        }}>✕</button>

        <h2 style={{fontFamily:fontSerif, fontSize:22, color:gold, margin:"0 0 6px", paddingRight:30}}>
          Cómo instalar AXIS Legaltech
        </h2>
        <p style={{fontSize:13, color:"rgba(255,255,255,0.6)", margin:"0 0 22px", lineHeight:1.5}}>
          Este navegador no la instala con un solo toque. Sigue estos pasos en tu {dispositivo}:
        </p>

        {/* Visual + pasos según plataforma */}
        {isAndroid && <AndroidInstall gold={gold} fontSerif={fontSerif} />}
        {isIOS && <IOSInstall gold={gold} fontSerif={fontSerif} dispositivo={dispositivo} />}
        {isDesktop && <DesktopInstall gold={gold} fontSerif={fontSerif} />}

        <button onClick={onClose} style={{
          marginTop:22, width:"100%", padding:"14px",
          background:`linear-gradient(135deg, ${gold}, #A07C30)`,
          border:"none", borderRadius:12, color:"#0A0A0A",
          fontSize:14, fontWeight:700, cursor:"pointer",
          fontFamily:"inherit"
        }}>Entendido, lo intentaré</button>
      </div>
    </div>
  );
}

// Helper para los pasos numerados
function StepRow({n, gold, children}: {n:string|number; gold:string; children:React.ReactNode}) {
  return (
    <div style={{display:"flex", gap:14, alignItems:"flex-start"}}>
      <div style={{
        width:28, height:28, borderRadius:"50%",
        background:`linear-gradient(135deg, ${gold}, #A07C30)`,
        color:"#0A0A0A", fontSize:13, fontWeight:800,
        display:"flex", alignItems:"center", justifyContent:"center",
        flexShrink:0, boxShadow:`0 2px 6px rgba(212,168,67,0.3)`
      }}>{n}</div>
      <div style={{fontSize:13, color:"rgba(255,255,255,0.85)", lineHeight:1.6, flex:1, paddingTop:4}}>{children}</div>
    </div>
  );
}

// Visualización Android: navegador con 3 puntos resaltados
function AndroidInstall({gold, fontSerif}: {gold:string; fontSerif:string}) {
  return (
    <div>
      {/* Visual del navegador móvil */}
      <div style={{background:"rgba(0,0,0,0.3)", border:"1px solid rgba(255,255,255,0.08)", borderRadius:14, padding:"20px 16px", marginBottom:18, textAlign:"center" as const}}>
        <svg width="100%" viewBox="0 0 320 110" style={{maxWidth:300}}>
          {/* Outline del navegador */}
          <rect x="10" y="10" width="300" height="90" rx="10" fill="#1A1A2E" stroke="rgba(255,255,255,0.15)" strokeWidth="1"/>
          {/* URL bar */}
          <rect x="22" y="22" width="225" height="26" rx="13" fill="#2D3748"/>
          <text x="40" y="38" fill="#9CA3AF" fontSize="10" fontFamily="monospace">axis-legaltech.vercel.app</text>
          {/* Botón ⋮ resaltado */}
          <circle cx="280" cy="35" r="20" fill="rgba(212,168,67,0.25)" stroke={gold} strokeWidth="2.5">
            <animate attributeName="r" values="18;22;18" dur="1.8s" repeatCount="indefinite"/>
          </circle>
          <circle cx="280" cy="27" r="2.5" fill="white"/>
          <circle cx="280" cy="35" r="2.5" fill="white"/>
          <circle cx="280" cy="43" r="2.5" fill="white"/>
          {/* Etiqueta */}
          <text x="160" y="86" fill={gold} fontSize="13" fontWeight="700" textAnchor="middle" fontFamily="serif">↑ Aquí, los 3 puntitos ⋮</text>
        </svg>
      </div>

      {/* Pasos */}
      <div style={{display:"flex", flexDirection:"column" as const, gap:14}}>
        <StepRow n="1" gold={gold}>
          Toca el botón <strong style={{color:gold}}>⋮</strong> (tres puntos verticales) <strong style={{color:gold}}>arriba a la derecha</strong> de tu navegador
        </StepRow>
        <StepRow n="2" gold={gold}>
          En el menú que aparece, busca y selecciona <strong style={{color:gold}}>"Instalar app"</strong> o <strong style={{color:gold}}>"Agregar a pantalla principal"</strong>
        </StepRow>
        <StepRow n="3" gold={gold}>
          Confirma con <strong style={{color:gold}}>"Instalar"</strong> — listo, AXIS Legaltech aparecerá como app en tu pantalla principal 🎉
        </StepRow>
      </div>
    </div>
  );
}

// Visualización iOS: Safari con botón de compartir
// ⚠️ SOLO LOS PASOS DEL NAVEGADOR QUE SE ESTÁ USANDO. NINGUNA AFIRMACIÓN SOBRE
// LOS DEMÁS.
//
// Aquí había un recuadro que decía "en iPhone solo Safari puede agregarla; ni
// Chrome ni el navegador de WhatsApp lo permiten". Eso depende de la versión de
// iOS y de cada navegador, cambia sin avisarnos, y nadie de este lado lo vuelve a
// comprobar: lo que no podemos mantener cierto, no lo afirmamos. Tampoco el
// dibujo de Safari con el botón Compartir junto a la dirección: en el iPhone ese
// botón ha estado abajo, y en las versiones recientes dentro del menú "···". Un
// dibujo que coloca el botón en un sitio es otra afirmación que caduca.
//
// Queda lo que sí se puede sostener:
//   · en Safari, los pasos de Safari, sin decir DÓNDE está el botón —se describe
//     cómo es y qué hacer si no se ve—;
//   · en cualquier otro, que busque esa opción en el menú de ESE navegador, y
//     que si no la encuentra abra la página fuera de la aplicación en la que está
//     —el tropiezo real es el enlace abierto dentro de WhatsApp—, sin nombrar a
//     ningún navegador ni decir qué puede o no puede hacer.
// La detección de Safari es solo para elegir qué pasos enseñar: los nombres de
// abajo no se le dicen a nadie.
function IOSInstall({gold, fontSerif, dispositivo}: {gold:string; fontSerif:string; dispositivo:string}) {
  const ua = typeof navigator !== "undefined" ? navigator.userAgent : "";
  const esSafari = /Safari\//.test(ua)
    && !/CriOS|FxiOS|EdgiOS|OPiOS|GSA\/|DuckDuckGo|FBAN|FBAV|Instagram|Line\//i.test(ua);
  if (!esSafari) {
    return (
      <div style={{display:"flex", flexDirection:"column" as const, gap:14}}>
        <StepRow n="1" gold={gold}>
          Abre el menú de este navegador y busca la opción <strong style={{color:gold}}>"Agregar a pantalla de inicio"</strong>
        </StepRow>
        <StepRow n="2" gold={gold}>
          Si no la encuentras, abre esta página fuera de la aplicación en la que estás —suele estar en el menú, como <strong style={{color:gold}}>"Abrir en el navegador"</strong>— y vuelve a tocar <strong style={{color:gold}}>"Cómo instalar"</strong>
        </StepRow>
      </div>
    );
  }
  return (
    <div>
      {/* Cómo ES el botón, no dónde está. */}
      <div style={{background:"rgba(0,0,0,0.3)", border:"1px solid rgba(255,255,255,0.08)", borderRadius:14, padding:"16px", marginBottom:18, display:"flex", alignItems:"center", gap:14}}>
        <svg width="40" height="40" viewBox="0 0 40 40" style={{flexShrink:0}}>
          <circle cx="20" cy="20" r="18" fill="rgba(212,168,67,0.18)" stroke={gold} strokeWidth="2"/>
          <rect x="13" y="17" width="14" height="13" rx="2" fill="none" stroke="white" strokeWidth="1.8"/>
          <path d="M20 9 L20 23 M15.5 13.5 L20 9 L24.5 13.5" stroke="white" strokeWidth="1.8" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        <div style={{fontSize:12.5, color:"rgba(255,255,255,0.82)", lineHeight:1.5}}>
          Así es el botón <strong style={{color:gold}}>Compartir</strong> de Safari en tu {dispositivo}: un cuadrado con una flecha hacia arriba.
        </div>
      </div>

      {/* Pasos */}
      <div style={{display:"flex", flexDirection:"column" as const, gap:14}}>
        <StepRow n="1" gold={gold}>
          Toca el botón <strong style={{color:gold}}>Compartir</strong>. Si no lo ves, toca primero el botón <strong style={{color:gold}}>···</strong> y ahí aparece
        </StepRow>
        <StepRow n="2" gold={gold}>
          En la lista, busca y toca <strong style={{color:gold}}>"Agregar a pantalla de inicio"</strong>
        </StepRow>
        <StepRow n="3" gold={gold}>
          Toca <strong style={{color:gold}}>"Agregar"</strong> — AXIS Legaltech aparecerá en tu pantalla de inicio 🎉
        </StepRow>
      </div>
    </div>
  );
}

// Visualización Desktop Chrome/Edge: ícono de instalación en URL bar
function DesktopInstall({gold, fontSerif}: {gold:string; fontSerif:string}) {
  return (
    <div>
      {/* Visual del navegador desktop */}
      <div style={{background:"rgba(0,0,0,0.3)", border:"1px solid rgba(255,255,255,0.08)", borderRadius:14, padding:"20px 16px", marginBottom:18, textAlign:"center" as const}}>
        <svg width="100%" viewBox="0 0 360 130" style={{maxWidth:340}}>
          {/* Browser frame */}
          <rect x="10" y="10" width="340" height="110" rx="6" fill="#FFFFFF" stroke="rgba(0,0,0,0.2)" strokeWidth="1"/>
          {/* Top bar */}
          <rect x="10" y="10" width="340" height="20" rx="6" fill="#E5E7EB"/>
          <circle cx="22" cy="20" r="3" fill="#EF4444"/>
          <circle cx="32" cy="20" r="3" fill="#F59E0B"/>
          <circle cx="42" cy="20" r="3" fill="#10B981"/>
          {/* URL bar */}
          <rect x="20" y="40" width="280" height="28" rx="14" fill="#F3F4F6"/>
          <text x="40" y="58" fill="#374151" fontSize="11" fontFamily="monospace">https://axis-legaltech.vercel.app</text>
          {/* Install icon resaltado en la URL bar (lado derecho) */}
          <circle cx="270" cy="54" r="18" fill="rgba(212,168,67,0.25)" stroke={gold} strokeWidth="2.5">
            <animate attributeName="r" values="16;20;16" dur="1.8s" repeatCount="indefinite"/>
          </circle>
          {/* Ícono "monitor con flecha hacia abajo" (Chrome install icon) */}
          <rect x="262" y="49" width="16" height="11" rx="1.5" fill="none" stroke="#374151" strokeWidth="1.6"/>
          <line x1="266" y1="62" x2="274" y2="62" stroke="#374151" strokeWidth="1.6"/>
          <path d="M270 51 L270 56 M267 54 L270 57 L273 54" stroke="#374151" strokeWidth="1.6" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
          {/* Star bookmark icon (decorativo) */}
          <text x="295" y="58" fill="#9CA3AF" fontSize="14">★</text>
          {/* Three dots */}
          <circle cx="320" cy="51" r="1.5" fill="#374151"/>
          <circle cx="320" cy="55" r="1.5" fill="#374151"/>
          <circle cx="320" cy="59" r="1.5" fill="#374151"/>
          {/* Etiqueta */}
          <text x="180" y="105" fill={gold} fontSize="13" fontWeight="700" textAnchor="middle" fontFamily="serif">↑ Ícono "Instalar app" en la barra de dirección</text>
        </svg>
      </div>

      {/* Pasos */}
      <div style={{display:"flex", flexDirection:"column" as const, gap:14}}>
        <StepRow n="1" gold={gold}>
          Mira el <strong style={{color:gold}}>extremo derecho</strong> de la barra de direcciones (donde está la URL)
        </StepRow>
        <StepRow n="2" gold={gold}>
          Click en el <strong style={{color:gold}}>ícono pequeño con forma de monitor con flecha ↓</strong> (es el ícono de "Instalar app")
        </StepRow>
        <StepRow n="3" gold={gold}>
          En el cuadro que aparece, click en <strong style={{color:gold}}>"Instalar"</strong> — AXIS Legaltech se abrirá como ventana propia 🎉
        </StepRow>
        <div style={{marginTop:8, padding:"10px 12px", background:"rgba(212,168,67,0.08)", border:"1px solid rgba(212,168,67,0.2)", borderRadius:8, fontSize:11, color:"rgba(255,255,255,0.65)", lineHeight:1.5}}>
          {/* Sin nombrar navegadores: decía que Firefox y Safari de escritorio no
              instalan, y eso ya no es verdad para todos. Ver `IOSInstall`. */}
          <strong style={{color:gold}}>¿No ves el ícono?</strong> Busca <strong>"Instalar"</strong> en el menú de este navegador. Si no aparece, este navegador no ofrece instalarla; puedes seguir usando AXIS desde esta pestaña, igual que hasta ahora.
        </div>
      </div>
    </div>
  );
}


// ═══ REGLA DE LA COLECCIÓN `usuarios` ═══════════════════════════════════════
// NADA CREA usuarios/{uid} SALVO ESTA FUNCIÓN. Todo lo demás que escriba en esa
// colección usa `updateDoc`, que actualiza si el documento existe y falla si no.
//
// POR QUÉ, y no es una preferencia de estilo: `setDoc(..., {merge:true})` sobre una
// ruta que no existe LA CREA. Once sitios escribían aquí con merge —el contador de
// uso, el historial del chat, la foto, el puesto, el horario— y cualquiera de ellos
// podía dar de alta una cuenta sin correo y sin nombre por accidente. El panel se
// llenó de filas en blanco sobre las que no se puede decidir nada.
//
// La regla es "solo el alta crea" y no "los demás no alcanzan esa pantalla": lo
// segundo hay que reconstruirlo cada vez y deja de ser cierto en silencio el día que
// alguien mueva una pantalla. Lo primero se comprueba de un vistazo buscando
// `setDoc(doc(db,"usuarios"` en el archivo: si aparece fuera de aquí, está mal.
//
// El comentario que decía "no crea documentos" encima de un merge que sí los creaba
// es exactamente cómo esto se reintroduce dentro de tres meses.
// ════════════════════════════════════════════════════════════════════════════
// ─── EL DOCUMENTO DE LA CUENTA, O NO HAY ALTA ────────────────────────────────
// De `usuarios/{uid}` cuelga TODO lo que el panel sabe de una cuenta: si no está,
// esa persona no se puede ver, ni autorizar, ni dejar fuera a sabiendas. Es
// invisible justo para la pantalla con la que se decide eso.
//
// Se escribía en dos de las TRES entradas —Google no lo escribía nunca— y cuando
// fallaba se anotaba en la consola y el alta seguía adelante. El resultado era
// una cuenta fantasma: existe en Auth, entra a la app, y no existe para nadie más.
//
// Una sola función para las tres entradas, y distingue dos cosas que no valen lo
// mismo:
//  · CREAR el documento cuando no existe es obligatorio. Si falla, LANZA, y quien
//    llama tiene que impedir la entrada.
//  · REFRESCAR `ultimoAcceso` cuando ya existe no lo es. Que no se pueda anotar la
//    hora de entrada no es motivo para dejar fuera a un cliente que ya está dado
//    de alta.
//
// Y si NO SE PUEDE LEER si existe, también lanza. Adivinar es peor que parar: dar
// por nuevo un documento que existe le reescribiría la fecha de alta, y darlo por
// existente cuando no está deja la cuenta fantasma que veníamos a evitar.
// Los dos fallos NO significan lo mismo y no se le pueden contar igual a quien
// está delante:
//  · "creacion" — el documento no estaba y no se pudo escribir. La cuenta SÍ
//    quedó a medias, y eso se dice con esas palabras.
//  · "lectura"  — no se pudo ni averiguar si existe. La cuenta puede llevar años
//    completa y lo que falló fue la red de este segundo. Decirle a ese cliente
//    que su cuenta "quedó a medias" es una acusación falsa, y ofrecerle borrarla
//    sobre una duda es lo último que debe ver.
// Lo desconocido se trata como "lectura": es el lado que no propone destruir nada.
type FalloAlta = Error & {causa: "lectura"|"creacion"};
function _falloAlta(causa: "lectura"|"creacion", e:any): FalloAlta {
  const err = new Error(String(e?.code || e?.message || e || "error")) as FalloAlta;
  err.causa = causa;
  return err;
}
const causaDelFallo = (e:any): "lectura"|"creacion" => e?.causa === "creacion" ? "creacion" : "lectura";

async function asegurarDocUsuario(user: any, nombreSugerido?: string): Promise<"creado"|"actualizado"> {
  const uid = user?.uid;
  if (!uid) throw _falloAlta("lectura", "La sesión no trae identificador de usuario.");
  let existe: boolean | null = null;
  try { existe = (await getDoc(doc(db, "usuarios", uid))).exists(); }
  catch(e:any) { throw _falloAlta("lectura", e); }

  if (existe) {
    // El nombre NO se toca aquí: si la persona lo editó en su perfil, volver a
    // escribir el de Google en cada entrada le desharía el cambio cada vez.
    try { await updateDoc(doc(db, "usuarios", uid), {email: user?.email || "", ultimoAcceso: Timestamp.now()}); }
    catch(e){ console.error("ultimoAcceso (no bloquea, el documento ya existe):", e); }
    return "actualizado";
  }
  try {
    await setDoc(doc(db, "usuarios", uid), {
      email: user?.email || "",
      nombre: String(nombreSugerido || user?.displayName || "").trim(),
      fechaAlta: Timestamp.now(),
      ultimoAcceso: Timestamp.now(),
    }, {merge:true});
  } catch(e:any){ throw _falloAlta("creacion", e); }   // que se entere quien llama
  return "creado";
}

// ─── EL CORREO DEL TRABAJADOR YA TIENE CUENTA PROPIA ─────────────────────────
// El alta de un trabajador crea su usuario de Authentication. Si falla con
// "auth/email-already-in-use", ese correo ya tiene cuenta propia: casi siempre
// porque la persona usó "Registrarse" antes de que su patrón la diera de alta,
// pero también puede ser trabajador de otro patrón, así que el texto no afirma
// cuál de las dos. Convertirla en trabajador desde aquí permitiría a cualquier patrón
// quedarse con el correo de otro, con sus datos. Así que no se hace: se dice qué
// pasó y a quién escribir. Lo usan las DOS pantallas de alta (Empleados y
// Cuentas de trabajador).
const WA_SOPORTE_AXIS = "524494251128";
const MSG_CORREO_CON_CUENTA_PROPIA =
  "Ese correo ya tiene una cuenta propia en la plataforma; casi siempre es porque esa persona se registró sola antes de que la dieras de alta. Por seguridad, la plataforma no puede convertirla en cuenta de trabajador desde aquí. Escríbenos a soporte por WhatsApp para liberar el correo y después vuelve a darla de alta.";
function ErrorAltaTrabajador({msg, correo, fontSans, style}: {msg:string; correo:string; fontSans:string; style:any}) {
  const ocupado = msg === MSG_CORREO_CON_CUENTA_PROPIA;
  const escribir = () => {
    const url = `https://wa.me/${WA_SOPORTE_AXIS}?text=${encodeURIComponent("Hola AXIS, quiero dar de alta como trabajador a " + (correo||"").trim().toLowerCase() + ", pero esa persona ya tiene una cuenta propia. ¿Me ayudan a liberar el correo?")}`;
    try { window.open(url, "_blank", "noopener,noreferrer"); } catch(e){ window.location.href = url; }
  };
  return (
    <div style={style}>
      {msg}
      {ocupado && (
        <button onClick={escribir}
          style={{display:"block", marginTop:10, background:"#25D366", color:"white", border:"none", borderRadius:9, padding:"8px 14px", fontSize:12.5, fontWeight:700, cursor:"pointer", fontFamily:fontSans}}>
          Escribir a soporte por WhatsApp
        </button>
      )}
    </div>
  );
}

// ─── COMPONENTE LOGIN/REGISTRO ────────────────────────────────────────────────
// GOOGLE, PRIMERO EN UNA INSTANCIA APARTE. "Continuar con Google" CREA la cuenta
// si ese Google es nuevo, y un trabajador que entraba así quedaba como patrón
// Free sin empresa. Hay que preguntar ANTES de que exista nada más que el
// usuario de Authentication, y en la instancia principal eso es imposible: en
// cuanto hay sesión, la app pasa por su puerta y sus pantallas (la de "sin
// acceso" escribe leads_acceso). Así que el popup se abre en una instancia
// secundaria, en memoria, que la app no escucha. Si la cuenta ya existía, o ya
// tiene cuentas_trabajador, la MISMA credencial abre la sesión principal y todo
// sigue como antes. Si es nueva, se decide aquí; y si es de un trabajador, se
// borra desde esa misma instancia sin haber escrito un solo documento.
const APP_GOOGLE_APARTE = "GoogleAntesDeEntrar";
async function abrirGoogleAparte(): Promise<{app:any; auth:any; cred:any; credencial:any; nueva:boolean; correo:string}> {
  const app = getApps().find(a => a.name === APP_GOOGLE_APARTE) || initializeApp(firebaseConfig, APP_GOOGLE_APARTE);
  const authAparte = getAuth(app);
  await setPersistence(authAparte, inMemoryPersistence);   // nada queda guardado en el navegador
  const cred = await signInWithPopup(authAparte, new GoogleAuthProvider());
  return {
    app, auth: authAparte, cred,
    credencial: GoogleAuthProvider.credentialFromResult(cred),
    nueva: !!getAdditionalUserInfo(cred)?.isNewUser,
    correo: String(cred?.user?.email || "").trim().toLowerCase(),
  };
}
// ¿Ese correo ya es trabajador? Se lee CON LA SESIÓN APARTE (las reglas dejan
// leer cuentas_trabajador/{su correo} a su dueño). Si la lectura falla, se
// contesta "no": lo peor que pasa es que vea la pregunta.
async function _esTrabajadorAparte(aparte:any): Promise<boolean> {
  if (!aparte?.correo) return false;
  try { return (await getDoc(doc(getFirestore(aparte.app), "cuentas_trabajador", aparte.correo))).exists(); }
  catch(e){ return false; }
}
// La cuenta NUEVA que resultó ser de un trabajador: se borra de Authentication
// (la sesión aparte es recién iniciada, así que el borrado no pide reautenticar)
// y se cierra. No se escribió ningún documento, así que no queda nada.
async function _descartarGoogleNuevo(aparte:any): Promise<void> {
  await deleteUser(aparte.cred.user);
  try { await signOut(aparte.auth); } catch(e){ /* ya no hay sesión que cerrar */ }
}
const TEXTO_TRABAJADOR_CUENTA =
  "Tu patrón te crea la cuenta desde su panel. Cuando te avise, entra aquí con tu correo y la contraseña que te dé, o con Google si es el mismo correo.";

function LoginScreen({onBack, onSuccess, fontSans, fontSerif, gold, puerta = "empresa"}: {onBack:()=>void; onSuccess:(u:any)=>void; fontSans:string; fontSerif:string; gold:string; puerta?:"empresa"|"trabajador"}) {
  // LA PUERTA DE TRABAJADOR solo inicia sesión: sin "Registrarse" ni "Crear
  // cuenta". La de empresa queda como estaba.
  const soloTrabajador = puerta === "trabajador";
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [nombre, setNombre] = useState("");
  const [isReg, setIsReg] = useState(false);
  // QUIÉN SE REGISTRA. Registrarse aquí crea una cuenta de EMPRESA; un trabajador
  // que lo hace por error queda como patrón Free sin empresa, y su patrón ya no
  // puede darlo de alta con ese correo. Por eso "Registrarse" pregunta primero y
  // solo "Soy una empresa" deja ver el registro. "Iniciar sesión" no pregunta.
  const [tipoRegistro, setTipoRegistro] = useState<null|"empresa"|"trabajador">(null);
  const registroAbierto = isReg && tipoRegistro === "empresa";
  // Google NUEVO sin cuentas_trabajador, esperando respuesta: la sesión vive solo
  // en la instancia aparte y no se ha escrito nada.
  const [googlePendiente, setGooglePendiente] = useState<any|null>(null);
  // Tras descartar un Google nuevo de trabajador: se le explica qué hacer.
  const [avisoTrabajador, setAvisoTrabajador] = useState(false);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [mantenerSesion, setMantenerSesion] = useState(true);   // persistencia local (default)
  // Cuenta creada en Auth cuyo documento no se pudo escribir. Mientras esto no sea
  // null, NO se entra a la app: el alta no está terminada y la persona lo ve.
  const [altaAMedias, setAltaAMedias] = useState<{detalle:string; user:any; recienCreada:boolean; causa:"lectura"|"creacion"}|null>(null);
  const [reintentando, setReintentando] = useState(false);
  const [borrando, setBorrando] = useState(false);
  const aplicarPersistencia = async () => { try { await setPersistence(auth, mantenerSesion ? browserLocalPersistence : browserSessionPersistence); } catch(e){ /* no fatal: sigue el login normal */ } };
  // Recuperación de contraseña (autoservicio)
  const [showReset, setShowReset] = useState(false);
  const [resetEmail, setResetEmail] = useState("");
  const [resetMsg, setResetMsg] = useState("");
  const [resetErr, setResetErr] = useState("");
  const [resetLoading, setResetLoading] = useState(false);

  const handleAuth = async () => {
    if (isReg && !registroAbierto) return;   // sin "Soy una empresa" no se crea nada
    if (isReg && soloTrabajador) return;     // la puerta de trabajador no registra
    setErr(""); setLoading(true);
    await aplicarPersistencia();
    try {
      if (isReg) {
        const cred = await createUserWithEmailAndPassword(auth, email, pass);
        // Guarda el nombre como displayName para que aparezca en el saludo de Suite
        if (nombre.trim()) {
          try { await updateProfile(cred.user, { displayName: nombre.trim() }); } catch(e){ console.error("displayName:", e); }
        }
        try { await asegurarDocUsuario(cred.user, nombre.trim()); }
        catch(e:any){ setAltaAMedias({detalle: e?.message || "error", user: cred.user, recienCreada: true, causa: causaDelFallo(e)}); return; }
        onSuccess(cred.user);
      } else {
        const cred = await signInWithEmailAndPassword(auth, email, pass);
        try { await asegurarDocUsuario(cred.user); }
        catch(e:any){ setAltaAMedias({detalle: e?.message || "error", user: cred.user, recienCreada: false, causa: causaDelFallo(e)}); return; }
        onSuccess(cred.user);
      }
    } catch(e:any) {
      const msgs: Record<string,string> = {
        "auth/user-not-found":"Usuario no encontrado",
        "auth/wrong-password":"Contraseña incorrecta",
        "auth/email-already-in-use":"Correo ya registrado",
        "auth/weak-password":"Mínimo 6 caracteres",
        "auth/invalid-credential":"Correo o contraseña incorrectos",
        "auth/invalid-email":"Correo inválido",
      };
      setErr(msgs[e.code] || "Error al iniciar sesión");
    } finally { setLoading(false); }
  };

  const handleGoogle = async () => {
    if (isReg && !registroAbierto) return;   // ídem: Google también crea la cuenta
    setErr(""); setLoading(true);
    await aplicarPersistencia();
    try {
      const aparte = await abrirGoogleAparte();
      // Solo se pregunta por una cuenta NUEVA, y no en "Registrarse → Soy una
      // empresa", que ya contestó. Una cuenta que ya existía sigue como siempre.
      if (aparte.nueva && !registroAbierto && !(await _esTrabajadorAparte(aparte))) {
        if (soloTrabajador) {
          // Por la puerta de trabajador no se crea cuenta: se borra y se explica.
          await descartarYAvisar(aparte);
          return;
        }
        setGooglePendiente(aparte);
        return;
      }
      await entrarConGoogle(aparte);
    } catch(e:any) {
      // Si el usuario cierra el popup, no es error que mostremos
      if (e.code === "auth/popup-closed-by-user" || e.code === "auth/cancelled-popup-request") {
        return;
      }
      console.error("[Google Sign-In Error]", e.code, e.message, e);
      const msgs: Record<string,string> = {
        "auth/popup-blocked":"Tu navegador bloqueó la ventana emergente. Permítela e intenta de nuevo.",
        "auth/account-exists-with-different-credential":"Ya existe una cuenta con este correo usando otro método.",
        "auth/operation-not-allowed":"Google Sign-In no está habilitado. Revisa Firebase Console → Authentication → Sign-in method.",
        "auth/unauthorized-domain":"Este dominio no está autorizado. Agrégalo en Firebase Console → Authentication → Settings → Authorized domains.",
        "auth/credential-already-in-use":"Esa cuenta de Google ya está en uso.",
      };
      // Muestra el mensaje amigable si lo conocemos, sino el código + mensaje real
      setErr(msgs[e.code] || `Error: ${e.code || "desconocido"} — ${e.message || "sin detalle"}`);
    } finally { setLoading(false); }
  };

  // La sesión principal se abre con la MISMA credencial de Google, y a partir de
  // aquí todo es como era: el documento del usuario y la entrada.
  const entrarConGoogle = async (aparte:any) => {
    const cred = await signInWithCredential(auth, aparte.credencial);
    try { await signOut(aparte.auth); } catch(e){ /* la aparte vive en memoria */ }
    // ESTO NO ESTABA. Una cuenta creada con Google no escribía nunca su
    // documento, así que era invisible para el panel para siempre.
    try { await asegurarDocUsuario(cred.user); }
    catch(e:any){ setAltaAMedias({detalle: e?.message || "error", user: cred.user, recienCreada: aparte.nueva, causa: causaDelFallo(e)}); return; }
    onSuccess(cred.user);
  };
  const descartarYAvisar = async (aparte:any) => {
    try { await _descartarGoogleNuevo(aparte); }
    catch(e:any){
      // Si no se pudo borrar, se dice. Quedaría un usuario de Authentication sin
      // ningún documento; no entra a nada, pero hay que liberarlo a mano.
      setGooglePendiente(null);
      setErr("No se pudo borrar la cuenta de Google recién creada (" + (e?.code || "error") + "). Escríbenos a contacto@axislegalags.com para liberarla.");
      return;
    }
    setGooglePendiente(null); setAvisoTrabajador(true);
  };
  // La respuesta a la pregunta de un Google nuevo.
  const responderGoogle = async (tipo:"empresa"|"trabajador") => {
    const aparte = googlePendiente; if (!aparte) return;
    setErr(""); setLoading(true);
    try {
      if (tipo === "trabajador") { await descartarYAvisar(aparte); return; }
      await entrarConGoogle(aparte);
      setGooglePendiente(null);
    } catch(e:any){
      setErr("No se pudo completar la entrada con Google (" + (e?.code || "error") + "). Intenta de nuevo.");
    } finally { setLoading(false); }
  };
  // Salir con un Google nuevo sin contestar: esa cuenta no tiene nada todavía,
  // así que se borra en vez de dejarla huérfana.
  const volver = async () => {
    if (googlePendiente) { try { await _descartarGoogleNuevo(googlePendiente); } catch(e){ /* se intentó */ } setGooglePendiente(null); }
    onBack();
  };

  // Envía el correo de restablecimiento. Por seguridad (evitar enumeración de
  // cuentas) se muestra SIEMPRE el mismo mensaje de éxito, exista o no la cuenta.
  const handleReset = async () => {
    setResetErr(""); setResetMsg(""); setResetLoading(true);
    const MSG_OK = "Si existe una cuenta con ese correo, te enviamos un enlace para restablecer tu contraseña. Revisa tu bandeja y tu carpeta de spam.";
    try {
      await sendPasswordResetEmail(auth, resetEmail.trim());
      setResetMsg(MSG_OK);
    } catch(e:any) {
      if (e?.code === "auth/invalid-email") {
        setResetErr("El correo no tiene un formato válido. Revísalo e intenta de nuevo.");
      } else if (e?.code === "auth/user-not-found") {
        setResetMsg(MSG_OK);   // no revelamos si la cuenta existe (anti-enumeración)
      } else {
        setResetErr("No se pudo enviar el enlace en este momento. Intenta de nuevo en unos minutos.");
      }
    } finally { setResetLoading(false); }
  };

  // ── EL ALTA A MEDIAS SE VE, SE REINTENTA O SE DESHACE ────────────────────
  // No se entra a la app hasta que el documento exista. Antes esto era una línea
  // en la consola que nadie iba a leer nunca.
  const reintentarAlta = async () => {
    if (!altaAMedias) return;
    setReintentando(true);
    try {
      await asegurarDocUsuario(altaAMedias.user, nombre.trim());
      const u = altaAMedias.user;
      setAltaAMedias(null);
      onSuccess(u);
    } catch(e:any){ setAltaAMedias({...altaAMedias, detalle: e?.message || "error", causa: causaDelFallo(e)}); }
    finally { setReintentando(false); }
  };
  const deshacerAlta = async () => {
    if (!altaAMedias?.user) return;
    if (!window.confirm("Se va a borrar la cuenta recién creada para que puedas registrarte otra vez con el mismo correo. ¿Continuar?")) return;
    setBorrando(true);
    try { await deleteUser(altaAMedias.user); setAltaAMedias(null); setPass(""); }
    catch(e:any){
      // Si tampoco se puede borrar, se dice. Lo que no se hace es fingir.
      setAltaAMedias({...altaAMedias, detalle: "No se pudo borrar la cuenta (" + (e?.code || e?.message || "error") + "). Escríbenos a contacto@axislegalags.com."});
    }
    finally { setBorrando(false); }
  };
  const salirDelAlta = async () => {
    try { await signOut(auth); } catch(e){ /* la pantalla vuelve igual */ }
    setAltaAMedias(null); setPass("");
  };

  // La pregunta y el aviso, UNA sola vez: los usan "Registrarse" y el Google nuevo.
  const pintarPregunta = (elegir:(t:"empresa"|"trabajador")=>void) => (
    <div>
      <div style={{fontSize:14, fontWeight:700, color:T_LIGHT.textInk, marginBottom:12, textAlign:"center" as const, fontFamily:fontSans}}>¿Cómo vas a usar la plataforma?</div>
      {([
        {tipo:"empresa" as const, titulo:"Soy una empresa", sub:"Doy de alta mi empresa y a mis trabajadores."},
        {tipo:"trabajador" as const, titulo:"Mi empresa me dio acceso", sub:"Trabajo para una empresa que usa AXIS."},
      ]).map(o => (
        <button key={o.tipo} onClick={() => elegir(o.tipo)} disabled={loading}
          style={{width:"100%", textAlign:"left" as const, padding:"13px 15px", marginBottom:10, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:12,
            background:T_LIGHT.cardLight, cursor:loading?"wait":"pointer", fontFamily:fontSans, boxShadow:"0 1px 4px rgba(22,36,71,0.06)"}}>
          <div style={{fontSize:14, fontWeight:700, color:T_LIGHT.textInk}}>{o.titulo}</div>
          <div style={{fontSize:12, color:T_LIGHT.textInkSoft, marginTop:2}}>{o.sub}</div>
        </button>
      ))}
    </div>
  );
  const pintarAvisoTrabajador = (textoBoton:string, alPulsar:()=>void) => (
    <div>
      <div style={{background:T_LIGHT.canvasSoft, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:12, padding:"14px 16px", fontSize:13.5, color:T_LIGHT.textInk, lineHeight:1.6, fontFamily:fontSans}}>
        {TEXTO_TRABAJADOR_CUENTA}
      </div>
      <button onClick={alPulsar}
        style={{width:"100%", marginTop:16, background:"linear-gradient(135deg,#B8932A,#A07C30)", border:"none", borderRadius:12, padding:"13px", cursor:"pointer", fontSize:14, fontWeight:700, color:"white", fontFamily:fontSans, boxShadow:"0 4px 16px rgba(184,147,42,0.35)"}}>
        {textoBoton}
      </button>
    </div>
  );

  if (altaAMedias) return (
    <div style={{minHeight:"100vh", background:T_LIGHT.canvas, display:"flex", alignItems:"center", justifyContent:"center", padding:20, fontFamily:fontSans}}>
      <div style={{background:"white", border:"1.5px solid rgba(220,38,38,0.4)", borderRadius:18, padding:"30px 32px", maxWidth:460, width:"100%", boxShadow:"0 20px 56px rgba(22,36,71,0.14)"}}>
        <h2 style={{fontFamily:fontSerif, fontSize:21, color:"#B3261E", margin:"0 0 10px", lineHeight:1.3}}>
          {altaAMedias.causa === "creacion"
            ? "Tu cuenta quedó a medias"
            : "No pudimos verificar tu cuenta en este momento"}
        </h2>
        <p style={{fontSize:13.5, color:T_LIGHT.textInk, lineHeight:1.6, margin:"0 0 10px"}}>
          {altaAMedias.causa === "creacion" ? (<>
            Tu acceso se creó, pero <b>no se pudo guardar tu registro</b>, así que la cuenta todavía no está completa
            {" "}y no vamos a dejarte entrar a medias.
          </>) : (<>
            Entraste bien, pero <b>no pudimos leer tu registro</b> para confirmar que tu cuenta está completa. No quiere
            {" "}decir que le pase nada: casi siempre es la conexión de este momento.
          </>)}
        </p>
        <div style={{background:"rgba(220,38,38,0.06)", border:"1px solid rgba(220,38,38,0.25)", borderRadius:9, padding:"9px 11px", fontSize:12, color:"#B3261E", margin:"0 0 14px", wordBreak:"break-word" as const}}>
          {altaAMedias.detalle}
        </div>
        <p style={{fontSize:12.5, color:T_LIGHT.textInkSoft, lineHeight:1.55, margin:"0 0 16px"}}>
          {altaAMedias.causa === "creacion" ? "Casi siempre es la conexión. Vuelve a intentarlo" : "Vuelve a intentarlo"}
          {"; si sigue fallando, escríbenos a "}
          <a href="mailto:contacto@axislegalags.com" style={{color:gold, fontWeight:700}}>contacto@axislegalags.com</a>.
        </p>
        <button onClick={reintentarAlta} disabled={reintentando||borrando}
          style={{width:"100%", background:gold, color:"#0B1829", border:"none", borderRadius:11, padding:"13px", fontSize:14.5, fontWeight:800,
            cursor:(reintentando||borrando)?"wait":"pointer", fontFamily:fontSans, marginBottom:9}}>
          {reintentando ? "Reintentando…" : "Reintentar"}
        </button>
        {/* Borrar SOLO cuando sabemos que el documento no se pudo crear. Si lo que
            falló fue la lectura, no sabemos si la cuenta existe, y ofrecer borrarla
            sobre una duda es la peor salida posible. */}
        {altaAMedias.causa === "creacion" && altaAMedias.recienCreada && (
          <button onClick={deshacerAlta} disabled={reintentando||borrando}
            style={{width:"100%", background:"transparent", color:"#B3261E", border:"1px solid rgba(220,38,38,0.4)", borderRadius:11, padding:"11px",
              fontSize:13, fontWeight:700, cursor:(reintentando||borrando)?"wait":"pointer", fontFamily:fontSans, marginBottom:9}}>
            {borrando ? "Borrando…" : "Cancelar el registro y borrar la cuenta"}
          </button>
        )}
        <button onClick={salirDelAlta} disabled={reintentando||borrando}
          style={{width:"100%", background:"transparent", color:T_LIGHT.textInkSoft, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:11, padding:"11px",
            fontSize:13, fontWeight:700, cursor:"pointer", fontFamily:fontSans}}>
          Salir y volver más tarde
        </button>
      </div>
    </div>
  );

  return (
    <div style={{minHeight:"100vh", background:T_LIGHT.canvas, display:"flex", alignItems:"center", justifyContent:"center", padding:20}}>
      <div {...ZONA_DE_CAPTURA} style={{background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:20, padding:"40px 44px", maxWidth:420, width:"100%", boxShadow:"0 12px 40px rgba(22,36,71,0.14)"}}>
        <button onClick={volver} style={{background:"none", border:"none", fontSize:13, color:T_LIGHT.textInkMut, cursor:"pointer", padding:0, marginBottom:24, fontWeight:600}}>← Volver</button>
        <div style={{textAlign:"center" as const, marginBottom:24}}>
          <div style={{width:56, height:56, background:T.navy, borderRadius:14, display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 14px", boxShadow:"0 4px 16px rgba(22,36,71,0.20)"}}>
            <span style={{fontFamily:fontSerif, fontSize:20, fontWeight:700, color:gold}}>AX</span>
          </div>
          <h2 style={{fontFamily:fontSerif, fontSize:22, color:T_LIGHT.textInk, margin:"0 0 4px"}}>AXIS Suite</h2>
          <p style={{fontSize:12, color:T_LIGHT.textInkSoft, margin:0}}>Acceso exclusivo para clientes y colaboradores</p>
          {soloTrabajador && (
            <p style={{fontSize:13, color:T_LIGHT.textInk, margin:"10px 0 0", fontWeight:600, fontFamily:fontSans}}>Tu patrón te crea la cuenta desde su panel.</p>
          )}
        </div>
        {!soloTrabajador && !googlePendiente && !avisoTrabajador && (
        <div style={{display:"flex", background:T_LIGHT.canvasSoft, borderRadius:10, padding:4, marginBottom:18, border:`1px solid ${T_LIGHT.borderCard}`}}>
          {["Iniciar sesión","Registrarse"].map((t,i) => (
            <button key={t} onClick={() => { setIsReg(i===1); setTipoRegistro(null); setErr(""); }}
              style={{flex:1, padding:"9px 0", borderRadius:8, border:"none", cursor:"pointer", fontSize:13, fontWeight:600,
                background:isReg===(i===1)?T_LIGHT.cardLight:"transparent",
                color:isReg===(i===1)?T_LIGHT.textInk:T_LIGHT.textInkSoft,
                boxShadow:isReg===(i===1)?"0 1px 4px rgba(22,36,71,0.08)":"none"}}>
              {t}
            </button>
          ))}
        </div>
        )}

        {/* ── Google NUEVO: la misma pregunta, antes de escribir nada ── */}
        {googlePendiente && (<>
          <div style={{fontSize:12.5, color:T_LIGHT.textInkSoft, textAlign:"center" as const, marginBottom:12, lineHeight:1.5, fontFamily:fontSans}}>
            Es la primera vez que entras con <b style={{color:T_LIGHT.textInk}}>{googlePendiente.correo || "esta cuenta de Google"}</b>.
          </div>
          {pintarPregunta((t) => loading ? undefined : responderGoogle(t))}
        </>)}
        {avisoTrabajador && pintarAvisoTrabajador(soloTrabajador ? "Entendido" : "Ir a Iniciar sesión",
          () => { setAvisoTrabajador(false); setIsReg(false); setTipoRegistro(null); setErr(""); })}
        {(googlePendiente || avisoTrabajador) && err && <div style={{background:"rgba(220,38,38,0.08)", border:"1px solid rgba(220,38,38,0.30)", borderRadius:8, padding:"9px 13px", fontSize:12, color:T_LIGHT.danger, marginTop:12, fontWeight:600}}>{err}</div>}

        {/* ── Registrarse: primero, quién eres ── */}
        {!googlePendiente && !avisoTrabajador && isReg && tipoRegistro === null && pintarPregunta((t) => { setTipoRegistro(t); setErr(""); })}
        {!googlePendiente && !avisoTrabajador && isReg && tipoRegistro === "trabajador" && pintarAvisoTrabajador("Ir a Iniciar sesión",
          () => { setIsReg(false); setTipoRegistro(null); setErr(""); })}
        {isReg && tipoRegistro === "empresa" && (
          <button onClick={() => { setTipoRegistro(null); setErr(""); }}
            style={{display:"block", margin:"-6px 0 12px", background:"none", border:"none", color:T_LIGHT.textInkMut, fontSize:12, fontWeight:600, cursor:"pointer", padding:0, fontFamily:fontSans}}>
            ← Soy una empresa · cambiar
          </button>
        )}

        {(!isReg || registroAbierto) && !googlePendiente && !avisoTrabajador && (<>
        {/* ── Google Sign-In ── */}
        <button onClick={handleGoogle} disabled={loading}
          style={{
            width:"100%", padding:"11px 13px", border:`1px solid ${T_LIGHT.borderCard}`,
            borderRadius:10, fontSize:13, fontWeight:600, cursor:"pointer",
            background:T_LIGHT.cardLight, color:T_LIGHT.textInk, display:"flex", alignItems:"center",
            justifyContent:"center", gap:10, marginBottom:14,
            opacity:loading?0.7:1, fontFamily:fontSans,
            boxShadow:"0 1px 4px rgba(22,36,71,0.06)",
          }}>
          {/* Logo Google oficial — 4 colores */}
          <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 01-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z" fill="#4285F4"/>
            <path d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 009 18z" fill="#34A853"/>
            <path d="M3.964 10.706A5.41 5.41 0 013.682 9c0-.593.102-1.17.282-1.706V4.962H.957A8.996 8.996 0 000 9c0 1.452.348 2.827.957 4.038l3.007-2.332z" fill="#FBBC05"/>
            <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 00.957 4.962L3.964 7.294C4.672 5.167 6.656 3.58 9 3.58z" fill="#EA4335"/>
          </svg>
          {isReg ? "Registrarse con Google" : "Continuar con Google"}
        </button>

        {/* Divider */}
        <div style={{display:"flex", alignItems:"center", gap:10, marginBottom:14}}>
          <div style={{flex:1, height:1, background:T_LIGHT.border}}/>
          <span style={{fontSize:10, color:T_LIGHT.textInkMut, textTransform:"uppercase" as const, letterSpacing:"1px", fontWeight:700}}>o con correo</span>
          <div style={{flex:1, height:1, background:T_LIGHT.border}}/>
        </div>

        {/* ── Form fields ── */}
        <div style={{display:"flex", flexDirection:"column" as const, gap:12}}>
          {isReg && (
            <div>
              <label style={{fontSize:10, color:T_LIGHT.textInkMut, display:"block", marginBottom:4, textTransform:"uppercase" as const, letterSpacing:"0.5px", fontWeight:700}}>Nombre completo</label>
              <input value={nombre} onChange={e=>setNombre(e.target.value)} type="text" placeholder="Lic. Juan Pérez"
                onKeyDown={e=>e.key==="Enter"&&handleAuth()}
                style={{width:"100%", padding:"11px 13px", border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:10, fontSize:13, outline:"none", boxSizing:"border-box" as const, background:T_LIGHT.canvasSoft, color:T_LIGHT.textInk}} />
            </div>
          )}
          {[
            {label:"Correo electrónico", val:email, set:setEmail, type:"email", ph:"correo@empresa.mx"},
            {label:"Contraseña", val:pass, set:setPass, type:"password", ph:"••••••••"},
          ].map(f => (
            <div key={f.label}>
              <label style={{fontSize:10, color:T_LIGHT.textInkMut, display:"block", marginBottom:4, textTransform:"uppercase" as const, letterSpacing:"0.5px", fontWeight:700}}>{f.label}</label>
              <input value={f.val} onChange={e=>f.set(e.target.value)} type={f.type} placeholder={f.ph}
                onKeyDown={e=>e.key==="Enter"&&handleAuth()}
                style={{width:"100%", padding:"11px 13px", border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:10, fontSize:13, outline:"none", boxSizing:"border-box" as const, background:T_LIGHT.canvasSoft, color:T_LIGHT.textInk}} />
            </div>
          ))}
        </div>
        {err && <div style={{background:"rgba(220,38,38,0.08)", border:"1px solid rgba(220,38,38,0.30)", borderRadius:8, padding:"9px 13px", fontSize:12, color:T_LIGHT.danger, marginTop:12, fontWeight:600}}>{err}</div>}
        {/* Mantener sesión (persistencia) — aplica a contraseña y a Google */}
        <label style={{display:"flex", alignItems:"flex-start", gap:9, marginTop:14, cursor:"pointer"}}>
          <input type="checkbox" checked={mantenerSesion} onChange={e=>setMantenerSesion(e.target.checked)} style={{marginTop:2, width:16, height:16, accentColor:"#B8932A", cursor:"pointer", flexShrink:0}}/>
          <span style={{fontSize:12, color:T_LIGHT.textInkSoft, lineHeight:1.5}}>Mantener mi cuenta activa en este dispositivo. <span style={{color:T_LIGHT.textInkMut}}>No cerramos tu sesión al salir. Recomendado: activa el candado de huella/Face ID al entrar para que solo tú accedas.</span></span>
        </label>
        <button onClick={handleAuth} disabled={loading||!email||!pass||(isReg && !nombre.trim())}
          style={{width:"100%", marginTop:18, background:"linear-gradient(135deg,#B8932A,#A07C30)", border:"none", borderRadius:12, padding:"13px", cursor:"pointer", fontSize:14, fontWeight:700, color:"white",
            opacity:(loading||!email||!pass||(isReg && !nombre.trim()))?0.6:1, boxShadow:"0 4px 16px rgba(184,147,42,0.35)"}}>
          {loading?"Cargando...":isReg?"Crear cuenta":"Entrar a AXIS Suite"}
        </button>
        {!isReg && (
          <button onClick={() => { setResetEmail(email); setResetMsg(""); setResetErr(""); setShowReset(true); }}
            style={{display:"block", margin:"14px auto 0", background:"none", border:"none", color:gold, fontSize:12, fontWeight:600, cursor:"pointer", padding:0, textDecoration:"underline", fontFamily:fontSans}}>
            ¿Olvidaste tu contraseña?
          </button>
        )}
        </>)}
        <p style={{fontSize:11, color:T_LIGHT.textInkSoft, textAlign:"center" as const, marginTop:16, lineHeight:1.6}}>
          ¿Problemas para acceder? Contáctanos:<br/><strong style={{color:gold}}>contacto@axislegalags.com</strong>
        </p>
      </div>

      {/* Modal de recuperación de contraseña (autoservicio) */}
      {showReset && (
        <div
          style={{position:"fixed" as const, inset:0, background:"rgba(15,23,42,0.55)", zIndex:1000, display:"flex", alignItems:"center", justifyContent:"center", padding:20}}>
          <div {...PANEL_DE_CAPTURA} onClick={e=>e.stopPropagation()}
            style={{background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:18, padding:"30px 32px", maxWidth:400, width:"100%", boxShadow:"0 16px 50px rgba(22,36,71,0.22)"}}>
            <h3 style={{fontFamily:fontSerif, fontSize:18, color:T_LIGHT.textInk, margin:"0 0 6px"}}>Recuperar contraseña</h3>
            <p style={{fontSize:12, color:T_LIGHT.textInkSoft, margin:"0 0 16px", lineHeight:1.6}}>Escribe tu correo y te enviaremos un enlace para restablecer tu contraseña.</p>
            <label style={{fontSize:10, color:T_LIGHT.textInkMut, display:"block", marginBottom:4, textTransform:"uppercase" as const, letterSpacing:"0.5px", fontWeight:700}}>Correo electrónico</label>
            <input value={resetEmail} onChange={e=>setResetEmail(e.target.value)} type="email" placeholder="correo@empresa.mx"
              onKeyDown={e=> e.key==="Enter" && !resetLoading && resetEmail && handleReset()}
              style={{width:"100%", padding:"11px 13px", border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:10, fontSize:13, outline:"none", boxSizing:"border-box" as const, background:T_LIGHT.canvasSoft, color:T_LIGHT.textInk}} />
            {resetMsg && <div style={{background:"rgba(5,150,105,0.08)", border:"1px solid rgba(5,150,105,0.30)", borderRadius:8, padding:"9px 13px", fontSize:12, color:T_LIGHT.success, marginTop:12, fontWeight:600, lineHeight:1.5}}>{resetMsg}</div>}
            {resetErr && <div style={{background:"rgba(220,38,38,0.08)", border:"1px solid rgba(220,38,38,0.30)", borderRadius:8, padding:"9px 13px", fontSize:12, color:T_LIGHT.danger, marginTop:12, fontWeight:600}}>{resetErr}</div>}
            <button onClick={handleReset} disabled={resetLoading||!resetEmail}
              style={{width:"100%", marginTop:16, background:"linear-gradient(135deg,#B8932A,#A07C30)", border:"none", borderRadius:12, padding:"12px", cursor:(resetLoading||!resetEmail)?"not-allowed":"pointer", fontSize:14, fontWeight:700, color:"white", opacity:(resetLoading||!resetEmail)?0.6:1, boxShadow:"0 4px 16px rgba(184,147,42,0.35)", fontFamily:fontSans}}>
              {resetLoading?"Enviando...":"Enviar enlace de recuperación"}
            </button>
            <button onClick={(ev)=>{ if (sePuedeCerrarElPanel(ev)) setShowReset(false); }} disabled={resetLoading}
              style={{width:"100%", marginTop:8, background:"none", border:"none", color:T_LIGHT.textInkSoft, fontSize:12, fontWeight:600, cursor:resetLoading?"not-allowed":"pointer", padding:"6px", fontFamily:fontSans}}>
              {resetMsg ? "Cerrar" : "Cancelar"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

// #region SUITE HOME
// ─── SUITE HOME ───────────────────────────────────────────────────────────────

function ExpedienteProveedor({proveedor, sitMeta, onBack, onActualizado, onGoContratos, fontSans, fontSerif, gold}: {proveedor:any; sitMeta:any; onGoContratos:()=>void; onBack:()=>void; onActualizado:()=>void; fontSans:string; fontSerif:string; gold:string}) {
  const [editando, setEditando] = useState(false);
  const [tel, setTel] = useState(proveedor.telefono||"");
  const [email, setEmail] = useState(proveedor.email||"");
  const [contacto, setContacto] = useState(proveedor.contacto||"");
  const [direccion, setDireccion] = useState(proveedor.direccion||"");
  const [desde, setDesde] = useState(proveedor.proveedorDesde||"");
  const [folioRepse, setFolioRepse] = useState(proveedor.folioRepse||"");
  const [vencRepse, setVencRepse] = useState(proveedor.vencimientoRepse||"");
  const [esEspecializado, setEsEspecializado] = useState(proveedor.esEspecializado||false);
  const [docs, setDocs] = useState<any[]>(proveedor.documentos||[]);
  const [contratos, setContratos] = useState<any[]>(proveedor.contratos||[]);
  const [guardando, setGuardando] = useState(false);
  const [pedidos, setPedidos] = useState<any[]>([]);
  const [showFormPed, setShowFormPed] = useState(false);
  const [pedFecha, setPedFecha] = useState("");
  const [pedDesc, setPedDesc] = useState("");
  const [pedMonto, setPedMonto] = useState("");
  const [pedFolio, setPedFolio] = useState("");
  const [guardandoPed, setGuardandoPed] = useState(false);
  const isMobile = window.innerWidth < 768;
  const db = getFirestore();

  const cargarPedidos = async () => {
    if (!proveedor.id) return;
    try {
      // Multi-tenant: filtra por el dueño (userId heredado del proveedor), que es el
      // campo con el que la regla de Firestore acota la colección.
      const snap = await getDocs(query(collection(db,"pedidos_proveedor"), where("userId","==",(proveedor as any).userId||""), where("proveedorId","==",proveedor.id)));
      setPedidos(snap.docs.map(d=>({id:d.id,...d.data()} as any)).sort((a,b)=>(b.fecha||"").localeCompare(a.fecha||"")));
    } catch(e){ console.error(e); }
  };
  useEffect(()=>{ cargarPedidos(); /* eslint-disable-next-line */ },[]);

  // LA TANDA ENTERA, en UNA escritura. Recibía un archivo y hacía `[...docs, uno]`;
  // con seis llamadas seguidas las seis partían del mismo `docs` y se pisaban.
  const onDocSubido = async (archivos:{url:string; nombre:string}[]) => {
    const nuevo = [...docs, ...archivos.map((a)=>({nombre:a.nombre, url:a.url, fecha: new Date().toISOString().slice(0,10)}))];
    // La pantalla NO avanza antes de saber que la escritura paso: si se pinta el
    // documento y el guardado falla, el usuario cree que quedo archivado y se
    // entera el dia que lo necesita como prueba.
    try {
      await updateDoc(doc(db,"proveedores",proveedor.id), {documentos: nuevo});
      setDocs(nuevo); onActualizado();
    } catch(e:any){ console.error(e); alert("No se pudo guardar el documento en el expediente del proveedor: " + (e?.code || e?.message || "error desconocido")); }
  };

  const onDocEliminar = async (idx:number) => {
    if (!window.confirm("¿Eliminar este documento?")) return;
    const d = docs[idx];
    // HUERFANOS DE STORAGE: el borrado del PDF va primero y su fallo se traga a
    // proposito, porque la operacion que importa es quitarlo del expediente. Pero
    // si falla en silencio el archivo queda SIN DUENO en Storage, invisible desde
    // la interfaz y imposible de encontrar. Es la fuente de los huerfanos que hay
    // que barrer en su propia rama: no se arregla aqui porque borrar archivos es
    // irreversible y merece su propio diagnostico. Mismo caso en clientes,
    // creditos y deudores.
    try { await eliminarArchivo(d.url); } catch(e){ console.error(e); }
    const nuevo = docs.filter((_:any,i:number)=>i!==idx);
    try {
      await updateDoc(doc(db,"proveedores",proveedor.id), {documentos: nuevo});
      setDocs(nuevo); onActualizado();
    } catch(e:any){ console.error(e); alert("No se pudo quitar el documento del expediente del proveedor: " + (e?.code || e?.message || "error desconocido")); }
  };

  const guardarDatos = async () => {
    if (!proveedor.id) return;
    setGuardando(true);
    try {
      await updateDoc(doc(db,"proveedores",proveedor.id), {telefono:tel||null, email:email||null, contacto:contacto||null, direccion:direccion||null, proveedorDesde:desde||null, folioRepse:folioRepse||null, vencimientoRepse:vencRepse||null, esEspecializado:esEspecializado});
      setEditando(false); onActualizado();
    } catch(e){ console.error(e); alert("Error al guardar los datos"); }
    finally{ setGuardando(false); }
  };

  const guardarPedido = async () => {
    if (!proveedor.id || !pedFecha || !pedDesc.trim()) return;
    setGuardandoPed(true);
    try {
      await addDoc(collection(db,"pedidos_proveedor"), {userId:(proveedor as any).userId||"", proveedorId:proveedor.id, rfc:proveedor.rfc, fecha:pedFecha, descripcion:pedDesc.trim(), monto:pedMonto?parseFloat(pedMonto):null, folio:pedFolio.trim()||null, timestamp:Timestamp.now()});
      setShowFormPed(false); setPedFecha(""); setPedDesc(""); setPedMonto(""); setPedFolio("");
      await cargarPedidos();
    } catch(e){ console.error(e); alert("Error al guardar el pedido"); }
    finally{ setGuardandoPed(false); }
  };

  const eliminarPedido = async (ped:any) => {
    if (!window.confirm("¿Eliminar este registro de pedido/entrega?")) return;
    // La recarga va en `finally`: si el borrado falla, la lista se vuelve a leer y
    // el registro sigue ahi, que es la verdad. Dentro del `try` no se releia y la
    // pantalla quedaba igual, como si la accion no hubiera hecho nada.
    try { await deleteDoc(doc(db,"pedidos_proveedor",ped.id)); }
    catch(e:any){ console.error(e); alert("No se pudo eliminar el registro de pedido/entrega: " + (e?.code || e?.message || "error desconocido")); }
    finally { await cargarPedidos(); }
  };

  const totalMontos = pedidos.reduce((s,p)=>s+(p.monto||0),0);
  const lbl = {fontSize:10, color:"#9A9AAA", display:"block", marginBottom:5, textTransform:"uppercase" as const, letterSpacing:"0.5px"};
  const inp = {width:"100%", padding:"11px 13px", border:"1px solid rgba(0,0,0,0.12)", borderRadius:10, fontSize:14, outline:"none", boxSizing:"border-box" as const, fontFamily:fontSans};
  const dato = (etq:string, val:string) => (<div><div style={{fontSize:10, color:T_LIGHT.textInkMut, textTransform:"uppercase" as const, letterSpacing:"0.5px", marginBottom:3, fontWeight:700}}>{etq}</div><div style={{fontSize:14, color:T_LIGHT.textInk}}>{val||"—"}</div></div>);

  return (
    <div {...ZONA_DE_CAPTURA} style={{minHeight:"100vh", background:T_LIGHT.canvas, fontFamily:fontSans}}>
      <div style={{background:T.navy, borderBottom:"1px solid rgba(184,147,42,0.24)", padding:isMobile?"14px 16px":"16px 32px", display:"flex", alignItems:"center", gap:14, position:"sticky" as const, top:0, zIndex:10, boxShadow:"0 2px 16px rgba(22,36,71,0.12)"}}>
        <button onClick={onBack} style={{background:"rgba(255,255,255,0.08)", border:"none", color:"white", borderRadius:8, padding:"8px 14px", cursor:"pointer", fontSize:13, fontFamily:fontSans}}>← Proveedores</button>
        <span style={{color:"white", fontWeight:700, fontSize:isMobile?15:17}}>{proveedor.nombre}</span>
      </div>

      <div style={{maxWidth:860, margin:"0 auto", padding:isMobile?"20px 16px":"28px 32px"}}>
        <div style={{background:T_LIGHT.cardLight, border:`1px solid ${sitMeta?.alerta?sitMeta.color:T_LIGHT.borderCard}`, borderRadius:16, padding:"22px 24px", marginBottom:20, boxShadow:T_LIGHT.shadow, borderLeft:`3px solid ${sitMeta?.alerta?sitMeta.color:"#3D3A6B"}`}}>
          <div style={{display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:14, flexWrap:"wrap" as const}}>
            <div>
              <div style={{fontFamily:fontSerif, fontSize:22, color:T_LIGHT.textInk, fontWeight:600}}>{proveedor.nombre}</div>
              <div style={{fontSize:13, color:T_LIGHT.textInkSoft, letterSpacing:"1px", fontFamily:"monospace", marginTop:4}}>{proveedor.rfc}</div>
            </div>
            <span style={{background:sitMeta?.bg, color:sitMeta?.color, fontSize:12, padding:"6px 13px", borderRadius:8, fontWeight:700, border:`1px solid ${sitMeta?.color}40`}}>{sitMeta?.label}</span>
          </div>
          {sitMeta?.alerta && <div style={{fontSize:12, color:sitMeta.color, marginTop:12, paddingTop:12, borderTop:`1px solid ${sitMeta.color}33`, lineHeight:1.5}}>{sitMeta.desc}</div>}
        </div>

        <div style={{background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:14, padding:"20px 22px", marginBottom:20, boxShadow:T_LIGHT.shadow}}>
          <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16}}>
            <h3 style={{color:T_LIGHT.textInk, fontFamily:fontSerif, fontSize:16, fontWeight:600, margin:0}}>Datos de contacto</h3>
            {!editando && <button onClick={()=>setEditando(true)} style={{background:T_LIGHT.goldSoft, border:`1px solid ${T_LIGHT.goldBorder}`, color:gold, borderRadius:8, padding:"6px 14px", cursor:"pointer", fontSize:12, fontFamily:fontSans, fontWeight:700}}>Editar</button>}
          </div>
          {(() => {
                  const hoy = new Date();
                  let est:any = null;
                  if (vencRepse) {
                    const v = new Date(vencRepse + "T12:00:00");
                    const dias = Math.ceil((v.getTime() - hoy.getTime()) / 86400000);
                    if (dias < 0) est = {txt:"REPSE VENCIDO — no puedes deducir sus facturas", color:"#DC2626", bg:"rgba(220,38,38,0.12)"};
                    else if (dias <= 90) est = {txt:"REPSE por vencer en "+dias+" días", color:"#D97706", bg:"rgba(245,158,11,0.12)"};
                  } else if (esEspecializado) {
                    est = {txt:"Servicios especializados SIN folio REPSE registrado", color:"#DC2626", bg:"rgba(220,38,38,0.12)"};
                  }
                  return est ? (<div style={{background:est.bg, color:est.color, border:`1px solid ${est.color}55`, borderRadius:10, padding:"10px 14px", fontSize:12, fontWeight:700, marginBottom:14}}>{est.txt}</div>) : null;
                })()}
                {editando ? (
            <div>
              <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr":"1fr 1fr", gap:14, marginBottom:14}}>
                <div><label style={lbl}>Teléfono</label><input value={tel} onChange={e=>setTel(e.target.value)} style={inp} placeholder="449..."/></div>
                <div><label style={lbl}>Email</label><input value={email} onChange={e=>setEmail(e.target.value)} style={inp} placeholder="correo@..."/></div>
                <div><label style={lbl}>Persona de contacto</label><input value={contacto} onChange={e=>setContacto(e.target.value)} style={inp} placeholder="Nombre"/></div>
                <div><label style={lbl}>Proveedor desde</label><input type="date" value={desde} onChange={e=>setDesde(e.target.value)} style={inp}/></div>
                  <div><label style={lbl}>Folio REPSE</label><input value={folioRepse} onChange={e=>setFolioRepse(e.target.value)} style={inp} placeholder="Folio STPS"/></div>
                  <div><label style={lbl}>Vence REPSE</label><input type="date" value={vencRepse} onChange={e=>setVencRepse(e.target.value)} style={inp}/></div>
                  <div style={{gridColumn:isMobile?"auto":"1 / -1", display:"flex", alignItems:"center", gap:8}}><input type="checkbox" checked={esEspecializado} onChange={e=>setEsEspecializado(e.target.checked)} id="esEsp"/><label htmlFor="esEsp" style={{fontSize:12, color:T_LIGHT.textInkSoft, cursor:"pointer"}}>Presta servicios especializados (requiere REPSE)</label></div>
                <div style={{gridColumn:isMobile?"auto":"1 / -1"}}><label style={lbl}>Dirección</label><input value={direccion} onChange={e=>setDireccion(e.target.value)} style={inp} placeholder="Domicilio del proveedor"/></div>
              </div>
              <div style={{display:"flex", gap:8}}>
                <button onClick={()=>setEditando(false)} style={{flex:1, background:"transparent", border:`1px solid ${T_LIGHT.borderCard}`, color:T_LIGHT.textInkSoft, borderRadius:8, padding:"10px", cursor:"pointer", fontSize:13, fontFamily:fontSans}}>Cancelar</button>
                <button onClick={guardarDatos} disabled={guardando} style={{flex:2, background:gold, border:"none", color:"#0B1829", borderRadius:8, padding:"10px", cursor:"pointer", fontSize:13, fontWeight:700, fontFamily:fontSans}}>{guardando?"Guardando...":"Guardar datos"}</button>
              </div>
            </div>
          ) : (
            <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr 1fr":"repeat(3,1fr)", gap:16}}>
              {dato("Teléfono", tel)}{dato("Email", email)}{dato("Contacto", contacto)}{dato("Proveedor desde", desde)}{dato("Folio REPSE", folioRepse)}{dato("Vence REPSE", vencRepse)}{dato("Dirección", direccion)}
            </div>
          )}
        </div>

        <div style={{background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:14, padding:"20px 22px", marginBottom:20, boxShadow:T_LIGHT.shadow}}>
                  <h3 style={{color:T_LIGHT.textInk, fontFamily:fontSerif, fontSize:16, fontWeight:600, margin:"0 0 8px"}}>Documentos</h3>
                  <p style={{fontSize:11, color:T_LIGHT.textInkSoft, margin:"0 0 14px", lineHeight:1.6}}>Contrato, constancia REPSE, opinión de cumplimiento, etc.</p>
                  <SubirArchivoBtn userId={proveedor.userId} carpeta="proveedores_docs" label="Subir documento" accept=".pdf,.jpg,.jpeg,.png,.doc,.docx" maxMB={10} onLote={onDocSubido} />
                  <div style={{display:"flex", flexDirection:"column" as const, gap:8, marginTop:14}}>
                    {docs.length === 0 && <div style={{fontSize:12, color:T_LIGHT.textInkMut}}>Aún no hay documentos.</div>}
                    {docs.map((dc:any, idx:number) => (
                      <div key={idx} style={{display:"flex", alignItems:"center", justifyContent:"space-between", gap:10, background:T_LIGHT.canvasSoft, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:8, padding:"8px 12px"}}>
                        <a href={dc.url} target="_blank" rel="noopener noreferrer" style={{color:gold, fontSize:13, textDecoration:"none", flex:1, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" as const, fontWeight:600}}>{dc.nombre}</a>
                        <span style={{fontSize:11, color:T_LIGHT.textInkMut}}>{dc.fecha}</span>
                        <button onClick={()=>onDocEliminar(idx)} style={{background:"transparent", border:"none", color:T_LIGHT.danger, cursor:"pointer", fontSize:12, fontWeight:700}}>Eliminar</button>
                      </div>
                    ))}
                  </div>
                </div>

                <div style={{background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:14, padding:"20px 22px", boxShadow:T_LIGHT.shadow}}>
          <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:8, flexWrap:"wrap" as const, gap:10}}>
            <h3 style={{color:T_LIGHT.textInk, fontFamily:fontSerif, fontSize:16, fontWeight:600, margin:0}}>Pedidos y entregas</h3>
            {!showFormPed && <button onClick={()=>setShowFormPed(true)} style={{background:gold, border:"none", color:"#0B1829", borderRadius:8, padding:"8px 15px", cursor:"pointer", fontSize:12, fontWeight:700, fontFamily:fontSans}}>+ Registrar</button>}
          </div>
          <p style={{fontSize:11, color:T_LIGHT.textInkSoft, margin:"0 0 16px", lineHeight:1.6}}>Documenta tus operaciones con este proveedor. Sirve como evidencia de materialidad si el SAT cuestiona las operaciones.</p>

          {showFormPed && (
            <div style={{background:T_LIGHT.canvasSoft, border:`1px solid ${T_LIGHT.goldBorder}`, borderRadius:12, padding:"16px 18px", marginBottom:16}}>
              <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr 1fr":"1fr 2fr 1fr 1fr", gap:12, marginBottom:14}}>
                <div><label style={lbl}>Fecha *</label><input type="date" value={pedFecha} onChange={e=>setPedFecha(e.target.value)} style={inp}/></div>
                <div style={{gridColumn:isMobile?"1 / -1":"auto"}}><label style={lbl}>Descripción *</label><input value={pedDesc} onChange={e=>setPedDesc(e.target.value)} style={inp} placeholder="Qué compraste / recibiste"/></div>
                <div><label style={lbl}>Monto</label><input type="number" value={pedMonto} onChange={e=>setPedMonto(e.target.value)} style={inp} placeholder="$"/></div>
                <div><label style={lbl}>Folio factura</label><input value={pedFolio} onChange={e=>setPedFolio(e.target.value)} style={inp} placeholder="Opcional"/></div>
              </div>
              <div style={{display:"flex", gap:8}}>
                <button onClick={()=>setShowFormPed(false)} style={{flex:1, background:"transparent", border:`1px solid ${T_LIGHT.borderCard}`, color:T_LIGHT.textInkSoft, borderRadius:8, padding:"10px", cursor:"pointer", fontSize:13, fontFamily:fontSans}}>Cancelar</button>
                <button onClick={guardarPedido} disabled={!pedFecha||!pedDesc.trim()||guardandoPed} style={{flex:2, background:(pedFecha&&pedDesc.trim())?gold:T_LIGHT.canvasSoft, border:"none", color:(pedFecha&&pedDesc.trim())?"#0B1829":T_LIGHT.textInkMut, borderRadius:8, padding:"10px", cursor:(pedFecha&&pedDesc.trim())?"pointer":"not-allowed", fontSize:13, fontWeight:700, fontFamily:fontSans}}>{guardandoPed?"Guardando...":"Guardar"}</button>
              </div>
            </div>
          )}

          {pedidos.length===0 ? (
            <div style={{textAlign:"center" as const, padding:"30px 20px", color:T_LIGHT.textInkMut, fontSize:13}}>Sin pedidos registrados todavía.</div>
          ) : (
            <>
              {totalMontos>0 && <div style={{fontSize:12, color:T_LIGHT.textInkSoft, marginBottom:12}}>Total documentado: <strong style={{color:gold, fontFamily:fontSerif}}>${totalMontos.toLocaleString("es-MX")}</strong> en {pedidos.length} {pedidos.length===1?"operación":"operaciones"}</div>}
              <div style={{display:"flex", flexDirection:"column" as const, gap:8}}>
                {pedidos.map(p=>(
                  <div key={p.id} style={{display:"flex", alignItems:"center", gap:12, padding:"11px 14px", background:T_LIGHT.canvasSoft, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:9, fontSize:13, flexWrap:"wrap" as const}}>
                    <span style={{color:T_LIGHT.textInkMut, fontSize:11, minWidth:72}}>{p.fecha}</span>
                    <span style={{color:T_LIGHT.textInk, flex:1, minWidth:0}}>{p.descripcion}{p.folio?` · folio ${p.folio}`:""}</span>
                    {p.monto!=null && <span style={{color:gold, fontWeight:600, fontFamily:fontSerif}}>${p.monto.toLocaleString("es-MX")}</span>}
                    <button onClick={()=>eliminarPedido(p)} style={{background:"none", border:"none", color:T_LIGHT.textInkMut, cursor:"pointer", fontSize:15}}>×</button>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>

        {/* Contratos vinculados — reusable, sube PDF a Storage */}
        <div style={{marginTop:20}}>
          <SeccionContratosVinculados
            user={{uid: proveedor.userId}}
            entidadId={proveedor.id}
            entidadTipo="proveedor"
            coleccion="proveedores"
            contratos={contratos}
            onContratosChange={(nuevos)=>{ setContratos(nuevos); onActualizado(); }}
            onGoContratos={onGoContratos}
            accentColor="#3D3A6B"
            fontSans={fontSans} fontSerif={fontSerif} gold={gold}
          />
        </div>
      </div>
    </div>
  );
}

// ═══ LA VALIDACIÓN 69-B, RETIRADA HASTA QUE SE SOSTENGA ═══════════════════
//
// Proveedores y Clientes se apoyaban en `public/efos_sat.json`, una copia de las
// listas del Art. 69-B del CFF con su fecha de corte. El dato es bueno; lo que
// no se sostiene es lo que la plataforma HACE con él:
//
//   · `situacionEfos` se escribe UNA VEZ, en el alta, y no se vuelve a evaluar.
//     Un proveedor guardado como presunto sigue diciéndolo aunque haya
//     desvirtuado ante el SAT, y uno guardado como limpio sigue limpio aunque
//     haya entrado a la lista después. La lista se actualiza; lo guardado, no.
//   · Un RFC mal tecleado no encuentra la clave y devuelve "limpio" — la MISMA
//     respuesta que un proveedor genuinamente limpio. No se distingue "no está
//     en la lista" de "no se pudo comprobar".
//
// Señalar a una empresa como EFOS es una acusación fiscal seria. Con un dato que
// puede estar caducado y un fallo que se lee como absolución, no se sostiene, y
// se retira hasta que la plataforma revalide sola lo ya guardado.
//
// NO SE BORRA NADA: ni `efos_sat.json`, ni `situacionEfos`, ni `fechaValidacion`,
// ni un solo proveedor o cliente. Todo queda donde está, esperando.
function ProximamenteValidacion69B({que, onBack, fontSans, fontSerif, gold}: {
  que:"Proveedores"; onBack:()=>void; fontSans:string; fontSerif:string; gold:string;
}) {
  const isMobile = window.innerWidth < 768;
  return (
    <div style={{minHeight:"100vh", background:T_LIGHT.canvas, fontFamily:fontSans, padding:isMobile?"20px 16px 40px":"40px 24px 56px"}}>
      <div style={{maxWidth:640, margin:"0 auto"}}>
        <button onClick={onBack}
          style={{background:"transparent", border:"none", color:T_LIGHT.textInkSoft, cursor:"pointer",
            fontFamily:fontSans, fontSize:13, fontWeight:700, padding:"0 0 18px", display:"inline-flex", alignItems:"center", gap:6}}>
          <span style={{fontSize:16, lineHeight:1}}>‹</span> Volver
        </button>
        <div style={{background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:16,
          padding:isMobile?"26px 20px":"34px 36px", boxShadow:T_LIGHT.shadow}}>
          <div style={{fontSize:10.5, fontWeight:800, letterSpacing:"0.8px", textTransform:"uppercase" as const,
            color:gold, marginBottom:10}}>Próximamente</div>
          <h1 style={{fontFamily:fontSerif, fontSize:isMobile?21:26, color:T_LIGHT.textInk, margin:"0 0 14px", lineHeight:1.25}}>
            {que} con validación 69-B
          </h1>
          <p style={{fontSize:14, color:T_LIGHT.textInkSoft, lineHeight:1.7, margin:"0 0 16px"}}>
            Estamos preparando esta sección y todavía no está disponible.
          </p>
          {/* La línea honesta: por qué se retiró. Sin fecha, porque no la hay. */}
          <div style={{background:T_LIGHT.canvasSoft, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:12,
            padding:"14px 16px", fontSize:13, color:T_LIGHT.textInkSoft, lineHeight:1.7}}>
            <strong style={{color:T_LIGHT.textInk}}>Por qué.</strong> La lista del Artículo 69-B del SAT se
            actualiza cada pocas semanas: una empresa entra, otra desvirtúa la presunción y sale. La
            plataforma comprobaba el RFC al darlo de alta, pero todavía no vuelve a comprobar sola lo
            que ya está guardado, así que con el tiempo podría estar mostrándote una situación que el
            SAT ya cambió. Señalar a una empresa como EFOS es serio, y preferimos no decirlo antes que
            decirlo con un dato viejo.
          </div>
          <p style={{fontSize:12.5, color:T_LIGHT.textInkMut, lineHeight:1.7, margin:"16px 0 0"}}>
            <strong style={{color:T_LIGHT.textInkSoft}}>Tus datos siguen ahí.</strong> No se borró ningún
            registro: los proveedores que capturaste, sus documentos y la validación que se hizo en su
            momento se conservan íntegros y volverán a verse cuando la sección se active.
          </p>
          <p style={{fontSize:12.5, color:T_LIGHT.textInkMut, lineHeight:1.7, margin:"12px 0 0"}}>
            Mientras tanto, puedes consultar las listas directamente en el portal del SAT.
          </p>
        </div>
      </div>
    </div>
  );
}

function ProveedoresModulo({user, tipoContrato, onBack, onGoContratos, fontSans, fontSerif, gold}: {onGoContratos:()=>void; user:any; tipoContrato:string; onBack:()=>void; fontSans:string; fontSerif:string; gold:string}) {
  const [proveedores, setProveedores] = useState<any[]>([]);
  const [efosData, setEfosData] = useState<any>(null);
  const [efosMeta, setEfosMeta] = useState<any>(null);
  const [cargandoEfos, setCargandoEfos] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [rfc, setRfc] = useState("");
  const [nombre, setNombre] = useState("");
  const [notas, setNotas] = useState("");
  const [guardando, setGuardando] = useState(false);
  const [cargando, setCargando] = useState(true);
const [previewVal, setPreviewVal] = useState<any>(null);
  const [proveedorExpediente, setProveedorExpediente] = useState<any>(null);
  const [showComoFunciona, setShowComoFunciona] = useState(false);
  const isMobile = window.innerWidth < 768;
  const db = getFirestore();

  const SIT_META: Record<string,{label:string; color:string; bg:string; desc:string; alerta:boolean}> = {
    limpio: {label:"Sin coincidencias", color:"#1D9E75", bg:"rgba(29,158,117,0.12)", desc:"No aparece en las listas 69-B / 69-B Bis del SAT.", alerta:false},
    D: {label:"EFOS Definitivo", color:"#E24B4A", bg:"rgba(226,75,74,0.14)", desc:"Confirmado por el SAT. Sus facturas NO tienen efectos fiscales — no las deduzcas.", alerta:true},
    P: {label:"Presunto", color:"#EF9F27", bg:"rgba(239,159,39,0.14)", desc:"El SAT presume operaciones inexistentes. Aún puede desvirtuar. Precaución.", alerta:true},
    V: {label:"Desvirtuado", color:"#5DA0E8", bg:"rgba(93,160,232,0.12)", desc:"Fue señalado pero aclaró la presunción ante el SAT. Sin efectos negativos.", alerta:false},
    S: {label:"Sentencia Favorable", color:"#5DA0E8", bg:"rgba(93,160,232,0.12)", desc:"Fue señalado pero un tribunal falló a su favor. Removido de la lista.", alerta:false},
  };

  useEffect(() => {
    fetch("/efos_sat.json").then(r => r.json())
      .then(d => { setEfosData(d.rfcs||{}); setEfosMeta(d.meta||null); setCargandoEfos(false); })
      .catch(e => { console.error("Error cargando lista EFOS", e); setCargandoEfos(false); });
  }, []);

  const cargarProveedores = async () => {
    if (!user?.uid) { setCargando(false); return; }
    try {
      const snap = await getDocs(query(collection(db,"proveedores"), where("userId","==",user.uid)));
      const lista = snap.docs.map(d => ({id:d.id, ...d.data()} as any)).sort((a,b)=>(a.nombre||"").localeCompare(b.nombre||""));
      setProveedores(lista);
    } catch(e) { console.error(e); }
    finally { setCargando(false); }
  };
  useEffect(() => { cargarProveedores(); /* eslint-disable-next-line */ }, [user]);

  const validarRFC = (rfcVal:string) => {
    if (!efosData) return null;
    const hit = efosData[(rfcVal||"").trim().toUpperCase()];
    if (!hit) return {situacion:"limpio", nombreSat:null};
    return {situacion:hit[0], nombreSat:hit[1]};
  };

  const guardar = async () => {
    if (!rfc.trim() || !nombre.trim() || !user?.uid) return;
    setGuardando(true);
    try {
      const val = validarRFC(rfc);
      await addDoc(collection(db,"proveedores"), {
        userId: user.uid, rfc: rfc.trim().toUpperCase(), nombre: nombre.trim(),
        notas: notas.trim()||null, situacionEfos: val?.situacion||"limpio",
        nombreSat: val?.nombreSat||null, fechaValidacion: Timestamp.now(), timestamp: Timestamp.now(),
      });
      setShowForm(false); setRfc(""); setNombre(""); setNotas(""); setPreviewVal(null);
      await cargarProveedores();
    } catch(e){ console.error(e); alert("Error al guardar el proveedor"); }
    finally{ setGuardando(false); }
  };

  const eliminar = async (p:any) => {
    if (!window.confirm(`¿Eliminar a ${p.nombre} de tu lista de proveedores?`)) return;
    try { await deleteDoc(doc(db,"proveedores",p.id)); }
    catch(e:any){ console.error(e); alert("No se pudo eliminar al proveedor " + (p.nombre||"") + ": " + (e?.code || e?.message || "error desconocido")); }
    finally { await cargarProveedores(); }
  };

  const proveedoresVal = proveedores.map(p => {
    const v = validarRFC(p.rfc||"");
    return {...p, _sit: v?.situacion||"limpio", _nombreSat: v?.nombreSat};
  });
  const enAlerta = proveedoresVal.filter(p => SIT_META[p._sit]?.alerta).length;

  const lbl = {fontSize:10, color:UI.textoTenue, display:"block", marginBottom:5, textTransform:"uppercase" as const, letterSpacing:"0.5px"};
  const inp = {width:"100%", padding:"12px 14px", border:"1px solid rgba(0,0,0,0.12)", borderRadius:UI.rTarjeta, fontSize:14, outline:"none", boxSizing:"border-box" as const, fontFamily:fontSans};

  if (proveedorExpediente) {
    const _v = validarRFC(proveedorExpediente.rfc||"");
    const _meta = SIT_META[_v?.situacion||"limpio"] || SIT_META.limpio;
    return <ExpedienteProveedor onGoContratos={onGoContratos} proveedor={proveedorExpediente} sitMeta={_meta} onBack={()=>setProveedorExpediente(null)} onActualizado={cargarProveedores} fontSans={fontSans} fontSerif={fontSerif} gold={gold} />;
  }

  return (
    <div {...ZONA_DE_CAPTURA} style={{minHeight:"100vh", background:UI.fondo, fontFamily:fontSans}}>
      {/* Header navy interno removido — la identidad ("Proveedores") la da el sidebar. */}
      <div style={{maxWidth:ANCHO_CONTENIDO, margin:"0 auto", padding:isMobile?"20px 16px":"28px 32px"}}>
        <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr 1fr":"repeat(3,1fr)", gap:12, marginBottom:24}}>
          <div style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rPanel, padding:"18px 20px", boxShadow:UI.sombra, borderLeft:"3px solid #3D3A6B"}}>
            <div style={{fontFamily:fontSerif, fontSize:30, color:UI.texto, fontWeight:600}}>{proveedores.length}</div>
            <div style={{fontSize:11, color:UI.textoSuave, marginTop:2}}>Proveedores registrados</div>
          </div>
          <div style={{background:UI.superficie, border:`1px solid ${enAlerta>0?"rgba(226,75,74,0.40)":UI.borde}`, borderRadius:UI.rPanel, padding:"18px 20px", boxShadow:UI.sombra, borderLeft:`3px solid ${enAlerta>0?"#E24B4A":"#3D3A6B"}`}}>
            <div style={{fontFamily:fontSerif, fontSize:30, color:enAlerta>0?"#E24B4A":UI.texto, fontWeight:600}}>{enAlerta}</div>
            <div style={{fontSize:11, color:UI.textoSuave, marginTop:2}}>En lista negra del SAT</div>
          </div>
          <div style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rPanel, padding:"18px 20px", boxShadow:UI.sombra, borderLeft:"3px solid #3D3A6B", gridColumn:isMobile?"1 / -1":"auto"}}>
            <div style={{fontSize:12, color:UI.textoSuave, fontWeight:600}}>{cargandoEfos?"Cargando lista...":`${efosMeta?.total?.toLocaleString()||"—"} RFCs`}</div>
            <div style={{fontSize:10, color:UI.textoTenue, marginTop:4, lineHeight:1.5}}>Lista 69-B SAT{efosMeta?` · al ${efosMeta.actualizado_69b}`:""}</div>
          </div>
        </div>

        <div style={{background:T_LIGHT.goldSoft, border:`1px solid ${T_LIGHT.goldBorder}`, borderRadius:UI.rPanel, padding:"14px 16px", marginBottom:24, fontSize:12, color:UI.textoSuave, lineHeight:1.7}}>
          Verifica a tus proveedores contra las listas del Artículo 69-B del CFF (EFOS). Si deduces facturas de un proveedor en lista definitiva, el SAT puede rechazarlas y considerarte EDOS. Valida antes de pagar.
        </div>

        <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16, flexWrap:"wrap" as const, gap:10}}>
          <h2 style={{color:UI.texto, fontFamily:fontSerif, fontSize:18, fontWeight:600, margin:0}}>Mis proveedores</h2>
          {!showForm && <BotonPrimario texto="+ Agregar proveedor" onClick={()=>setShowForm(true)} fontSans={fontSans}/>}
        </div>

        {showForm && (
          <div style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rPanel, padding:isMobile?"20px":"24px", marginBottom:20, boxShadow:UI.sombra}}>
            <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr":"1fr 1fr", gap:14, marginBottom:14}}>
              <div>
                <label style={lbl}>RFC del proveedor *</label>
                <input value={rfc} onChange={e=>{const v=e.target.value.toUpperCase(); setRfc(v); setPreviewVal(v.trim().length>=10?validarRFC(v):null);}} placeholder="Ej. ABC123456XY0" style={{...inp, letterSpacing:"1px", fontWeight:600, textTransform:"uppercase" as const}}/>
              </div>
              <div>
                <label style={lbl}>Nombre / Razón social *</label>
                <input value={nombre} onChange={e=>setNombre(e.target.value)} placeholder="Nombre del proveedor" style={inp}/>
              </div>
            </div>
            {previewVal && (
              <div style={{background:SIT_META[previewVal.situacion]?.bg, border:`1px solid ${SIT_META[previewVal.situacion]?.color}`, borderRadius:UI.rTarjeta, padding:"12px 14px", marginBottom:14}}>
                <div style={{fontSize:13, fontWeight:700, color:SIT_META[previewVal.situacion]?.color, marginBottom:3}}>{SIT_META[previewVal.situacion]?.label}</div>
                <div style={{fontSize:12, color:UI.textoSuave, lineHeight:1.5}}>{SIT_META[previewVal.situacion]?.desc}{previewVal.nombreSat?` — SAT: ${previewVal.nombreSat}`:""}</div>
              </div>
            )}
            <div style={{marginBottom:16}}>
              <label style={lbl}>Notas (opcional)</label>
              <input value={notas} onChange={e=>setNotas(e.target.value)} placeholder="Ej. proveedor de papelería" style={inp}/>
            </div>
            <div style={{display:"flex", gap:8}}>
              <button onClick={()=>{setShowForm(false); setPreviewVal(null);}} style={{flex:1, background:"transparent", border:"1px solid rgba(0,0,0,0.15)", color:UI.textoSuave, borderRadius:UI.rTarjeta, padding:"11px", cursor:"pointer", fontSize:13, fontFamily:fontSans}}>Cancelar</button>
              <button onClick={guardar} disabled={!rfc.trim()||!nombre.trim()||guardando} style={{flex:2, background:(rfc.trim()&&nombre.trim())?gold:"#ddd", border:"none", color:(rfc.trim()&&nombre.trim())?"#0B1829":"#999", borderRadius:UI.rTarjeta, padding:"11px", cursor:(rfc.trim()&&nombre.trim())?"pointer":"not-allowed", fontSize:13, fontWeight:700, fontFamily:fontSans}}>{guardando?"Guardando...":"Guardar y validar"}</button>
            </div>
          </div>
        )}

        {cargando ? (
          <div style={{textAlign:"center" as const, padding:"40px", color:UI.textoTenue}}>Cargando...</div>
        ) : proveedoresVal.length === 0 ? (
          <div style={{textAlign:"center" as const, padding:"50px 20px", background:UI.superficie, borderRadius:UI.rPanel, border:`1px dashed ${T_LIGHT.goldBorder}`, color:UI.textoSuave, fontSize:14}}>
            Aún no tienes proveedores registrados. Agrega uno para validar su situación ante el SAT.
          </div>
        ) : (
          <div style={{display:"flex", flexDirection:"column" as const, gap:10}}>
            {proveedoresVal.map(p => {
              const meta = SIT_META[p._sit] || SIT_META.limpio;
              return (
                <div key={p.id} onClick={()=>setProveedorExpediente(p)} style={{background:UI.superficie, border:`1px solid ${meta.alerta?meta.color:UI.borde}`, borderRadius:UI.rPanel, padding:"16px 18px", cursor:"pointer", boxShadow:UI.sombra, borderLeft:`3px solid ${meta.alerta?meta.color:"#3D3A6B"}`}}>
                  <div style={{display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:12, flexWrap:"wrap" as const}}>
                    <div style={{flex:1, minWidth:0}}>
                      <div style={{fontSize:15, fontWeight:600, color:UI.texto, marginBottom:3}}>{p.nombre}</div>
                      <div style={{fontSize:12, color:UI.textoSuave, letterSpacing:"1px", fontFamily:"monospace"}}>{p.rfc}</div>
                      {p.notas && <div style={{fontSize:11, color:UI.textoTenue, marginTop:4}}>{p.notas}</div>}
                    </div>
                    <div style={{display:"flex", alignItems:"center", gap:10}}>
                      <span style={{background:meta.bg, color:meta.color, fontSize:11, padding:"5px 11px", borderRadius:7, fontWeight:700, whiteSpace:"nowrap" as const, border:`1px solid ${meta.color}40`}}>{meta.label}</span>
                      <button onClick={(e)=>{e.stopPropagation(); eliminar(p);}} style={{background:"none", border:"none", color:UI.textoTenue, cursor:"pointer", fontSize:16, padding:4}}>×</button>
                    </div>
                  </div>
                  {meta.alerta && <div style={{fontSize:11, color:meta.color, marginTop:10, paddingTop:10, borderTop:`1px solid ${meta.color}33`, lineHeight:1.5}}>{meta.desc}{p._nombreSat?` (SAT: ${p._nombreSat})`:""}</div>}
                </div>
              );
            })}
          </div>
        )}
        {/* ── ¿Cómo funciona? ── */}
          <div style={{maxWidth:760, margin:"26px auto 0", background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rPanel, overflow:"hidden", boxShadow:UI.sombra}}>
            <button onClick={()=>setShowComoFunciona(v=>!v)} style={{width:"100%", display:"flex", justifyContent:"space-between", alignItems:"center", padding:"16px 22px", background:"none", border:"none", cursor:"pointer", color:UI.texto, fontSize:15, fontFamily:fontSerif, fontWeight:600, textAlign:"left"}}>
              <span>¿Cómo funciona la validación 69-B?</span>
              <span style={{color:gold, fontSize:20, lineHeight:1}}>{showComoFunciona?"−":"+"}</span>
            </button>
            {showComoFunciona && (
              <div style={{padding:"0 22px 22px", color:UI.textoSuave, fontSize:13.5, lineHeight:1.7, maxWidth:ANCHO_LECTURA}}>
                <p style={{margin:"0 0 14px"}}><strong style={{color:gold}}>Qué es la lista 69-B.</strong> El SAT publica, conforme al Artículo 69-B del Código Fiscal de la Federación, a los contribuyentes que detectó emitiendo comprobantes de operaciones inexistentes (los llamados EFOS). Esta herramienta compara el RFC de tus proveedores contra esa lista.</p>
                <p style={{margin:"0 0 14px"}}><strong style={{color:gold}}>Cómo usarla.</strong> Registra a tus proveedores con su RFC y la app valida su situación al instante, marcándola por color: verde si no aparece, azul si desvirtuó o un tribunal falló a su favor, naranja si es presunto y rojo si está como definitivo.</p>
                <p style={{margin:"0 0 14px"}}><strong style={{color:"#E24B4A"}}>El riesgo que evitas.</strong> Si das efectos fiscales a facturas de un proveedor en lista definitiva, el SAT puede rechazar esas deducciones o acreditamientos y considerarte EDOS (quien da efectos a operaciones simuladas), con consecuencias económicas e incluso penales. Por eso conviene validar antes de contratar, pagar o deducir.</p>
                <p style={{margin:"0 0 14px"}}><strong style={{color:gold}}>La app te avisa.</strong> Cualquier proveedor en lista negra aparece marcado automáticamente y el indicador "En lista negra del SAT" del panel superior te lo señala.</p>
                <p style={{margin:0}}><strong style={{color:gold}}>Sobre la lista.</strong> Es información pública del SAT y se actualiza periódicamente. La versión cargada en tu app está actualizada {efosMeta?.actualizado_69b ? `al ${efosMeta.actualizado_69b}` : "a la fecha que aparece en el panel superior"}.</p>
              </div>
            )}
          </div>
      </div>
    </div>
  );
}

// ─── MÓDULO CLIENTES v1.5 ────────────────────────────────────────────────────
// Cartera plantilla-aware: el registro elige entre "general" (cliente de
// negocio, con RFC + validación 69-B SAT) o "medico" (paciente, con datos
// personales + consentimiento informado, sin expediente clínico). Capa legal
// común a ambas: Aviso de Privacidad LFPDPPP con consentimiento fechado,
// campos personalizados libres, documentos y vínculo a contratos.
//
// Patrones reutilizados:
//   - Estructura visual idéntica a ProveedoresModulo (KPI cards + form + lista).
//   - Validación RFC contra /efos_sat.json (misma lógica que Proveedores).
//   - Subida de documentos vía <SubirArchivoBtn> (carpeta "clientes_docs").
//   - Owner-scoped: filtra por userId, ORDENA EN JS (sin orderBy → sin índices).
//
// Sobre plantillas: el campo `plantilla` ("general"|"medico") en el doc del
// cliente decide qué campos se muestran. Los docs antiguos sin `plantilla` se
// tratan como "general" por compatibilidad. Las reglas Firestore son las
// mismas para ambas plantillas — owner-scoped duro, sin excepciones (ya que en
// la plantilla médica los datos son sensibles).
//
// IMPORTANTE: la plantilla médica es un registro + capa legal. NO contiene
// historial clínico, diagnósticos ni recetas (NOM-004 fuera de alcance v1.5).
//
// Vínculo con Contratos: el campo `contratos` en el doc del cliente es un array
// embebido [{tipo, fecha, descripcion, url|null, id}]. Esto equivale a "el
// contrato guarda clienteId" pero sin crear una colección nueva.
const CLIENTES_COLOR = "#8E3B6E";  // borgoña rosado — accent del módulo
type PlantillaCliente = "general" | "medico";
const PLANTILLAS_CLIENTE: Record<PlantillaCliente, {
  label:string; icono:string; desc:string;
  entidad:string; entidadPlural:string;
  rfcObligatorio:boolean;
}> = {
  general: {
    label: "Cliente de negocio",
    icono: "🧾",
    // Sin la mención al 69-B: el módulo volvió, la validación no.
    desc: "Empresas o personas que contratan tus servicios.",
    entidad: "cliente",
    entidadPlural: "clientes",
    rfcObligatorio: true,
  },
  medico: {
    label: "Paciente",
    icono: "🩺",
    desc: "Personas que reciben tu atención. Es un registro + capa legal, NO es expediente clínico ni NOM-004.",
    entidad: "paciente",
    entidadPlural: "pacientes",
    rfcObligatorio: false,
  },
};
const SEXO_OPCIONES = [
  {id:"femenino",  label:"Femenino"},
  {id:"masculino", label:"Masculino"},
  {id:"otro",      label:"Otro / Prefiero no decir"},
];
const TIPOS_CONTRATO_CLIENTE: Array<{id:string; nombre:string}> = [
  {id:"servicios_profesionales", nombre:"Prestación de Servicios Profesionales"},
  {id:"contratacion_personal",   nombre:"Contrato de Trabajo (individual o colectivo)"},
  {id:"arrendamiento_vivienda",  nombre:"Arrendamiento de Vivienda"},
  {id:"arrendamiento_bodega_industrial", nombre:"Arrendamiento de Bodega Industrial"},
  {id:"compraventa_inmueble",    nombre:"Compraventa de Inmueble"},
  {id:"compraventa_vehiculo",    nombre:"Compraventa de Vehículo"},
  {id:"confidencialidad",        nombre:"Convenio de Confidencialidad (NDA)"},
  {id:"obra",                    nombre:"Contrato de Obra"},
  {id:"asociacion_participacion",nombre:"Asociación en Participación"},
  {id:"servicio_domestico",      nombre:"Servicio Doméstico"},
  {id:"aviso_privacidad",        nombre:"Aviso de Privacidad (LFPDPPP)"},
  {id:"consentimiento_informado",nombre:"Consentimiento Informado (médico)"},
  {id:"pagare",                  nombre:"Pagaré"},
  {id:"otro",                    nombre:"Otro contrato"},
];

// ─── HELPERS REUTILIZABLES: contratos vinculados ─────────────────────────────
// Los PDFs de contratos vinculados se suben a Storage en
// `contratos_vinculados/{userId}/{archivo}` — mismo patrón wildcard ya cubierto
// por storage.rules. El registro embebido en el doc de la entidad lleva:
//   {id, tipo, fecha, descripcion, url, nombrePdf, creado}
//
// SeccionContratosVinculados — componente DRY que usan ExpedienteCliente,
// ExpedienteProveedor y ExpedienteInner (empleados). Maneja el form de alta
// con subida de PDF y la lista de contratos vinculados de la entidad.
//
// BotonGuardarYVincular — componente para los forms del generador de Contratos.
// Recibe una función que retorna el Blob del PDF generado, abre un modal con
// picker de entidad (cliente | empleado | proveedor), sube el PDF y crea el
// registro en el array `contratos` de la entidad elegida.

function SeccionContratosVinculados({
  user, entidadId, entidadTipo, coleccion,
  contratos, onContratosChange,
  onGoContratos, accentColor,
  fontSans, fontSerif, gold,
}: {
  user: any;
  entidadId: string;
  entidadTipo: "cliente"|"paciente"|"empleado"|"proveedor"|"deudor";
  coleccion: "clientes"|"trabajadores"|"proveedores"|"deudores";
  contratos: any[];
  onContratosChange: (nuevos:any[]) => void;
  onGoContratos: () => void;
  accentColor: string;
  fontSans: string; fontSerif: string; gold: string;
}) {
  const [showForm, setShowForm] = useState(false);
  const [cTipo, setCTipo] = useState("servicios_profesionales");
  const [cFecha, setCFecha] = useState("");
  const [cDescripcion, setCDescripcion] = useState("");
  const [pdfUrl, setPdfUrl] = useState("");
  const [pdfNombre, setPdfNombre] = useState("");
  const [guardando, setGuardando] = useState(false);
  const isMobile = window.innerWidth < 768;
  const db = getFirestore();

  const lbl = {fontSize:10, color:"#9A9AAA", display:"block", marginBottom:5, textTransform:"uppercase" as const, letterSpacing:"0.5px"};
  const inp = {width:"100%", padding:"11px 13px", border:"1px solid rgba(0,0,0,0.12)", borderRadius:10, fontSize:14, outline:"none", boxSizing:"border-box" as const, fontFamily:fontSans};

  const labelEntidad = entidadTipo === "cliente" ? "este cliente"
                    : entidadTipo === "paciente" ? "este paciente"
                    : entidadTipo === "empleado" ? "este empleado"
                    : entidadTipo === "deudor" ? "este deudor"
                    : "este proveedor";

  const onPdfSubido = (url:string, nombre:string) => {
    setPdfUrl(url);
    setPdfNombre(nombre);
  };

  const limpiarForm = () => {
    setShowForm(false);
    setCTipo("servicios_profesionales"); setCFecha("");
    setCDescripcion(""); setPdfUrl(""); setPdfNombre("");
  };

  const addContrato = async () => {
    if (!cFecha || !cTipo || !entidadId) return;
    setGuardando(true);
    try {
      const nuevo = [
        ...contratos,
        {
          id: `c_${Date.now()}`,
          tipo: cTipo,
          fecha: cFecha,
          descripcion: cDescripcion.trim() || null,
          url: pdfUrl || null,
          nombrePdf: pdfNombre || null,
          creado: Timestamp.now(),
        },
      ];
      await updateDoc(doc(db, coleccion, entidadId), {contratos: nuevo});
      onContratosChange(nuevo);
      limpiarForm();
    } catch(e){ console.error(e); alert("Error al vincular el documento"); }
    finally{ setGuardando(false); }
  };

  const removeContrato = async (idx:number) => {
    if (!window.confirm("¿Quitar este documento vinculado? Se eliminará también el PDF de Storage.")) return;
    const c = contratos[idx];
    if (c?.url) {
      try { await eliminarArchivo(c.url); } catch(e){ console.error("No se pudo eliminar PDF:", e); }
    }
    const nuevo = contratos.filter((_:any,i:number)=>i!==idx);
    try {
      await updateDoc(doc(db, coleccion, entidadId), {contratos: nuevo});
      onContratosChange(nuevo);
    } catch(e:any){ console.error(e); alert("No se pudo quitar el documento vinculado del expediente: " + (e?.code || e?.message || "error desconocido")); }
  };

  // Cancelar limpia también el PDF subido (evita huérfanos en Storage).
  const cancelar = async () => {
    if (pdfUrl) {
      try { await eliminarArchivo(pdfUrl); } catch(e){ console.error(e); }
    }
    limpiarForm();
  };

  return (
    <div {...ZONA_DE_CAPTURA} style={{background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:14, padding:"20px 22px", boxShadow:T_LIGHT.shadow}}>
      <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:8, flexWrap:"wrap" as const, gap:10}}>
        <h3 style={{color:T_LIGHT.textInk, fontFamily:fontSerif, fontSize:16, fontWeight:600, margin:0}}>Documentos legales vinculados</h3>
        {!showForm && <button onClick={()=>setShowForm(true)} style={{background:gold, border:"none", color:"#0B1829", borderRadius:8, padding:"8px 15px", cursor:"pointer", fontSize:12, fontWeight:700, fontFamily:fontSans}}>+ Vincular</button>}
      </div>
      <p style={{fontSize:11, color:T_LIGHT.textInkSoft, margin:"0 0 16px", lineHeight:1.6}}>Sube el PDF de un documento firmado (contrato, aviso, consentimiento, pagaré…) y queda asociado a {labelEntidad}. Son distintos a los archivos sueltos del expediente. ¿Necesitas generar uno nuevo? <button onClick={onGoContratos} style={{background:"none", border:"none", color:gold, fontWeight:700, cursor:"pointer", padding:0, fontSize:11, textDecoration:"underline"}}>Ir al Generador legal</button>.</p>

      {showForm && (
        <div style={{background:T_LIGHT.canvasSoft, border:`1px solid ${T_LIGHT.goldBorder}`, borderRadius:12, padding:"16px 18px", marginBottom:16}}>
          <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr":"2fr 1fr", gap:12, marginBottom:12}}>
            <div>
              <label style={lbl}>Tipo de documento *</label>
              <select value={cTipo} onChange={e=>setCTipo(e.target.value)} style={{...inp, cursor:"pointer"}}>
                {TIPOS_CONTRATO_CLIENTE.map(t => <option key={t.id} value={t.id}>{t.nombre}</option>)}
              </select>
            </div>
            <div>
              <label style={lbl}>Fecha *</label>
              <input type="date" value={cFecha} onChange={e=>setCFecha(e.target.value)} style={inp}/>
            </div>
          </div>
          <div style={{marginBottom:12}}>
            <label style={lbl}>Descripción / nota</label>
            <input value={cDescripcion} onChange={e=>setCDescripcion(e.target.value)} style={inp} placeholder="Ej. servicios mensuales 2025"/>
          </div>
          {/* Subir PDF (Storage) — reusa el patrón de Documentos */}
          <div style={{marginBottom:14, padding:"12px 14px", background:T_LIGHT.cardLight, border:`1px dashed ${T_LIGHT.border}`, borderRadius:10}}>
            <label style={{...lbl, marginBottom:8}}>PDF del contrato firmado (opcional)</label>
            {pdfUrl ? (
              <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", gap:10, padding:"8px 12px", background:T_LIGHT.successSoft, border:`1px solid rgba(5,150,105,0.30)`, borderRadius:8}}>
                <a href={pdfUrl} target="_blank" rel="noopener noreferrer" style={{color:T_LIGHT.success, fontSize:12, textDecoration:"none", flex:1, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" as const, fontWeight:700}}>✓ {pdfNombre}</a>
                <button onClick={async ()=>{ try{await eliminarArchivo(pdfUrl);}catch{} setPdfUrl(""); setPdfNombre(""); }} style={{background:"none", border:"none", color:T_LIGHT.danger, cursor:"pointer", fontSize:11, fontWeight:700}}>Quitar</button>
              </div>
            ) : (
              <SubirArchivoBtn userId={user?.uid||""} carpeta="contratos_vinculados" label="Subir PDF" accept=".pdf,.doc,.docx" maxMB={10} onSubido={onPdfSubido} />
            )}
            <div style={{fontSize:10, color:T_LIGHT.textInkMut, marginTop:6, lineHeight:1.5}}>Puedes guardar el vínculo sin PDF y subirlo después.</div>
          </div>
          <div style={{display:"flex", gap:8}}>
            <button onClick={cancelar} style={{flex:1, background:"transparent", border:`1px solid ${T_LIGHT.borderCard}`, color:T_LIGHT.textInkSoft, borderRadius:8, padding:"10px", cursor:"pointer", fontSize:13, fontFamily:fontSans}}>Cancelar</button>
            <button onClick={addContrato} disabled={!cFecha||guardando} style={{flex:2, background:cFecha?gold:T_LIGHT.canvasSoft, border:"none", color:cFecha?"#0B1829":T_LIGHT.textInkMut, borderRadius:8, padding:"10px", cursor:cFecha?"pointer":"not-allowed", fontSize:13, fontWeight:700, fontFamily:fontSans}}>{guardando?"Guardando...":"Vincular documento"}</button>
          </div>
        </div>
      )}

      {contratos.length === 0 ? (
        <div style={{textAlign:"center" as const, padding:"30px 20px", color:T_LIGHT.textInkMut, fontSize:13}}>Aún no hay documentos legales vinculados a {labelEntidad}.</div>
      ) : (
        <div style={{display:"flex", flexDirection:"column" as const, gap:8}}>
          {contratos.map((k:any, idx:number) => {
            const tipoNombre = TIPOS_CONTRATO_CLIENTE.find(t=>t.id===k.tipo)?.nombre || k.tipo;
            return (
              <div key={k.id||idx} style={{display:"flex", alignItems:"center", gap:12, padding:"11px 14px", background:T_LIGHT.canvasSoft, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:9, fontSize:13, flexWrap:"wrap" as const, borderLeft:`3px solid ${accentColor}`}}>
                <span style={{color:T_LIGHT.textInkMut, fontSize:11, minWidth:72}}>{k.fecha}</span>
                <div style={{flex:1, minWidth:0}}>
                  <div style={{color:T_LIGHT.textInk, fontWeight:600}}>{tipoNombre}</div>
                  {k.descripcion && <div style={{fontSize:11, color:T_LIGHT.textInkSoft, marginTop:2}}>{k.descripcion}</div>}
                </div>
                {k.url && <a href={k.url} target="_blank" rel="noopener noreferrer" style={{color:gold, fontSize:11, fontWeight:700, textDecoration:"none"}}>Ver PDF ↗</a>}
                <button onClick={()=>removeContrato(idx)} style={{background:"none", border:"none", color:T_LIGHT.textInkMut, cursor:"pointer", fontSize:15}}>×</button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

// Nombre de archivo para STORAGE. El saneo a A-Z es obligatorio, pero aplicado
// en crudo destrozaba casi cualquier apellido mexicano: "María Gómez" quedaba
// como MAR_A_G_MEZ. Transliterar primero conserva la palabra: MARIA_GOMEZ.
//
// NO HAY TABLA DE CARACTERES que mantener, y no debe añadirse una. `_sinAcentos`
// normaliza a NFD —que separa cada letra de su diacrítico— y descarta los
// diacríticos sueltos. Eso cubre TODO el latín acentuado de una vez: el español
// (ñ, tildes, ü), el alemán (ä ö ü), el italiano (à è ì ò ù), el portugués (ç,
// ã), el francés, el turco… sin enumerar ninguno.
// Único límite real: las letras cuyo trazo va DENTRO del glifo (ø, ł, đ) no se
// descomponen y siguen cayendo en guion bajo. No aparecen en el padrón mexicano.
//
// La DESCARGA no pasa por aquí: ahí los acentos se quedan, porque funcionan.
const _nombreArchivoSeguro = (s:string) =>
  _sinAcentos(String(s??"")).replace(/[^a-zA-Z0-9._-]/g, "_");

// Baja = la MISMA convención que usa el resto de la app para trabajadores:
// `status` ausente significa activo, y la única marca de salida es "baja".
// Clientes, proveedores y deudores no escriben ese valor, así que para ellos
// esto siempre es false y la lista se comporta como antes.
const _esBajaEntidad = (en:any) => ((en?.status || "activo") === "baja");

function BotonGuardarYVincular({
  user, tipoContrato, fechaContratoDefault, descripcionDefault,
  getPDFBlob, nombrePDFBase, entidadFija, etiquetaBoton,
  fontSans, fontSerif, gold,
}: {
  user: any;
  tipoContrato: string;
  fechaContratoDefault?: string;
  descripcionDefault?: string;
  getPDFBlob: () => Promise<Blob>;
  nombrePDFBase: string;
  // Si viene, el documento se vincula SIEMPRE a esta entidad (se oculta el
  // selector). Lo usa el flujo "Generar desde el expediente del paciente".
  entidadFija?: {tipo:"cliente"|"paciente"|"empleado"|"proveedor"|"deudor"; id:string; nombre:string};
  etiquetaBoton?: string;
  fontSans: string; fontSerif: string; gold: string;
}) {
  const [open, setOpen] = useState(false);
  const [entidadTipo, setEntidadTipo] = useState<"cliente"|"paciente"|"empleado"|"proveedor"|"deudor">(entidadFija?.tipo || "cliente");
  const [entidades, setEntidades] = useState<any[]>([]);
  const [cargando, setCargando] = useState(false);
  const [entidadIdSel, setEntidadIdSel] = useState(entidadFija?.id || "");
  const [fecha, setFecha] = useState(fechaContratoDefault || new Date().toISOString().slice(0,10));
  const [descripcion, setDescripcion] = useState(descripcionDefault || "");
  const [guardando, setGuardando] = useState(false);
  const [guardandoSin, setGuardandoSin] = useState(false);
  const isMobile = window.innerWidth < 768;
  const db = getFirestore();

  const COLECCION: Record<typeof entidadTipo, "clientes"|"trabajadores"|"proveedores"|"deudores"> = {
    cliente: "clientes",
    paciente: "clientes",   // los pacientes son clientes con plantilla "medico"
    empleado: "trabajadores",
    proveedor: "proveedores",
    deudor: "deudores",
  };

  // Carga las entidades del tipo seleccionado, owner-scoped y ORDENADAS EN JS
  // (sin orderBy de Firestore — evitamos índices compuestos).
  useEffect(() => {
    if (!open || !user?.uid) return;
    // Entidad fija: no hace falta cargar lista, ya sabemos a quién vincular.
    if (entidadFija) { setEntidadTipo(entidadFija.tipo); setEntidadIdSel(entidadFija.id); return; }
    setCargando(true); setEntidadIdSel("");
    const col = COLECCION[entidadTipo];
    getDocs(query(collection(db, col), where("userId","==",user.uid)))
      .then(snap => {
        let lista = snap.docs.map(d => ({id:d.id, ...d.data()} as any));
        // Clientes y Pacientes viven en la misma colección "clientes": se
        // separan por el campo `plantilla` ("medico" = paciente).
        if (entidadTipo === "cliente")  lista = lista.filter(c => c.plantilla !== "medico");
        if (entidadTipo === "paciente") lista = lista.filter(c => c.plantilla === "medico");
        // Los dados de baja SIGUEN en la lista —archivar un documento en el
        // expediente de quien ya salió es legítimo— pero van después de los
        // activos. Misma convención que el resto de la app: sin `status` se
        // asume activo.
        lista.sort((a,b)=>{
          const ba = _esBajaEntidad(a) ? 1 : 0, bb = _esBajaEntidad(b) ? 1 : 0;
          if (ba !== bb) return ba - bb;
          return (a.nombre||"").localeCompare(b.nombre||"");
        });
        setEntidades(lista);
      })
      .catch(e => { console.error(e); setEntidades([]); })
      .finally(() => setCargando(false));
  }, [open, entidadTipo, user]);

  const handleGuardar = async () => {
    if (!entidadIdSel || !user?.uid) return;
    setGuardando(true);
    try {
      // 1) PDF blob → File para reusar subirArchivo
      const blob = await getPDFBlob();
      const safeName = _nombreArchivoSeguro(nombrePDFBase);
      const fileName = `${safeName}_${Date.now()}.pdf`;
      const file = new File([blob], fileName, {type:"application/pdf"});
      const url = await subirArchivo(user.uid, "contratos_vinculados", file);
      // 2) Lee el doc actual para no pisar otros contratos en concurrencia.
      const docRef = doc(db, COLECCION[entidadTipo], entidadIdSel);
      const snap = await getDoc(docRef);
      const actuales: any[] = (snap.exists() && (snap.data() as any).contratos) || [];
      const nuevo = [
        ...actuales,
        {
          id: `c_${Date.now()}`,
          tipo: tipoContrato,
          fecha: fecha || new Date().toISOString().slice(0,10),
          descripcion: descripcion.trim() || null,
          url, nombrePdf: fileName,
          creado: Timestamp.now(),
        },
      ];
      await updateDoc(docRef, {contratos: nuevo});
      const entidad = entidades.find(e=>e.id===entidadIdSel);
      alert(`Documento guardado y vinculado a ${entidad?.nombre || entidadFija?.nombre || "la entidad"}.`);
      setOpen(false); if (!entidadFija) setEntidadIdSel("");
    } catch(e:any){
      console.error(e);
      alert("Error al guardar y vincular: " + (e?.message || "intenta de nuevo"));
    }
    finally { setGuardando(false); }
  };

  // "Guardar (sin vincular)" — guarda el PDF en el banco (colección
  // documentos_generados, ref:null) SIN asociarlo a ninguna persona. Solo se
  // ofrece cuando NO hay entidadFija (no aplica al generar desde un expediente).
  // Requiere que las reglas de Firestore para 'documentos_generados' estén
  // publicadas (sección 8E); si no, Firestore responde permission-denied.
  const handleGuardarSinVincular = async () => {
    if (!user?.uid) return;
    setGuardandoSin(true);
    try {
      const blob = await getPDFBlob();
      const safeName = _nombreArchivoSeguro(nombrePDFBase);
      const fileName = `${safeName}_${Date.now()}.pdf`;
      const file = new File([blob], fileName, {type:"application/pdf"});
      const url = await subirArchivo(user.uid, "contratos_vinculados", file);
      await addDoc(collection(db, "documentos_generados"), {
        userId: user.uid,
        tipo: tipoContrato,
        fecha: fechaContratoDefault || new Date().toISOString().slice(0,10),
        descripcion: (descripcionDefault || "").trim() || null,
        url, nombrePdf: fileName,
        ref: null,                 // sin vincular
        creado: Timestamp.now(),
      });
      alert("Documento guardado en tu banco (sin vincular). Lo verás en “Documentos generados”, dentro del Generador legal.");
    } catch(e:any){
      console.error(e);
      alert("Error al guardar: " + (e?.message || "intenta de nuevo"));
    }
    finally { setGuardandoSin(false); }
  };

  const lbl = {fontSize:10, color:"#9A9AAA", display:"block", marginBottom:5, textTransform:"uppercase" as const, letterSpacing:"0.5px"};
  const inp = {width:"100%", padding:"11px 13px", border:"1px solid rgba(0,0,0,0.12)", borderRadius:10, fontSize:14, outline:"none", boxSizing:"border-box" as const, fontFamily:fontSans};

  if (!user || user.isAnonymous) return null;

  return (
    <>
      <div style={{display:"inline-flex", gap:10, flexWrap:"wrap" as const, alignItems:"center"}}>
        <button onClick={()=>setOpen(true)} style={{
          background:"transparent", border:`1.5px solid ${gold}`, color:gold,
          borderRadius:10, padding:"11px 18px", cursor:"pointer",
          fontSize:13, fontWeight:700, fontFamily:fontSans,
          display:"inline-flex", alignItems:"center", gap:8,
        }}>🔗 {etiquetaBoton || (entidadFija ? "Guardar en este expediente" : "Guardar y vincular a…")}</button>
        {/* Guardar sin vincular: solo cuando NO se generó desde un expediente. */}
        {!entidadFija && (
          <button onClick={handleGuardarSinVincular} disabled={guardandoSin} style={{
            background:"transparent", border:`1.5px solid ${T_LIGHT.border}`, color:T_LIGHT.textInkSoft,
            borderRadius:10, padding:"11px 18px", cursor:guardandoSin?"wait":"pointer",
            fontSize:13, fontWeight:700, fontFamily:fontSans,
            display:"inline-flex", alignItems:"center", gap:8, opacity:guardandoSin?0.7:1,
          }}>💾 {guardandoSin ? "Guardando…" : "Guardar (sin vincular)"}</button>
        )}
      </div>

      {open && (
        <div style={{
          position:"fixed" as const, inset:0, background:"rgba(15,23,42,0.65)",
          zIndex:1000, display:"flex", alignItems:"center", justifyContent:"center",
          padding:16, fontFamily:fontSans,
        }}>
          <div {...PANEL_DE_CAPTURA} onClick={e=>e.stopPropagation()} style={{
            background:T_LIGHT.cardLight, borderRadius:16, padding:isMobile?"22px 20px":"26px 28px",
            maxWidth:480, width:"100%", maxHeight:"86vh", overflowY:"auto" as const,
            boxShadow:"0 20px 50px rgba(22,36,71,0.4)", color:T_LIGHT.textInk,
          }}>
            <h3 style={{fontFamily:fontSerif, fontSize:18, fontWeight:700, margin:"0 0 6px", color:T_LIGHT.textInk}}>Guardar y vincular documento</h3>
            <p style={{fontSize:12, color:T_LIGHT.textInkSoft, margin:"0 0 18px", lineHeight:1.6}}>El PDF se subirá a Storage y quedará vinculado al expediente {entidadFija ? "indicado" : "que elijas"}.</p>

            {entidadFija ? (
              /* Entidad fija: se generó desde un expediente. No hay selector. */
              <div style={{marginBottom:14, padding:"12px 14px", background:T_LIGHT.successSoft, border:`1px solid rgba(5,150,105,0.30)`, borderRadius:10}}>
                <div style={{fontSize:10, color:T_LIGHT.textInkMut, textTransform:"uppercase" as const, letterSpacing:"0.5px", marginBottom:3}}>Se vinculará a</div>
                <div style={{fontSize:14, color:T_LIGHT.textInk, fontWeight:700}}>{entidadFija.nombre}</div>
              </div>
            ) : (
              <>
                {/* Toggle de tipo de entidad */}
                <div style={{marginBottom:14}}>
                  <label style={lbl}>¿A quién quieres vincularlo?</label>
                  <div style={{display:"grid", gridTemplateColumns: isMobile?"repeat(2,1fr)":"repeat(3,1fr)", gap:6, background:T_LIGHT.canvasSoft, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:10, padding:6}}>
                    {([
                      {id:"cliente"   as const, label:"🧾 Cliente"},
                      {id:"paciente"  as const, label:"🩺 Paciente"},
                      {id:"empleado"  as const, label:"👥 Empleado"},
                      {id:"proveedor" as const, label:"💼 Proveedor"},
                      {id:"deudor"    as const, label:"💵 Deudor"},
                    ]).map(opt => (
                      <button key={opt.id} onClick={()=>setEntidadTipo(opt.id)}
                        style={{
                          background: entidadTipo===opt.id ? gold : "transparent",
                          color: entidadTipo===opt.id ? "#0B1829" : T_LIGHT.textInkSoft,
                          border: entidadTipo===opt.id ? "none" : `1px solid ${T_LIGHT.border}`,
                          borderRadius:7, padding:"8px 6px",
                          cursor:"pointer", fontSize:12, fontWeight:700, fontFamily:fontSans,
                          whiteSpace:"nowrap" as const,
                        }}>{opt.label}</button>
                    ))}
                  </div>
                </div>

                {/* Selector de entidad */}
                <div style={{marginBottom:14}}>
                  <label style={lbl}>Selecciona el registro</label>
                  {cargando ? (
                    <div style={{padding:"12px 14px", background:T_LIGHT.canvasSoft, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:10, fontSize:13, color:T_LIGHT.textInkMut}}>Cargando...</div>
                  ) : entidades.length === 0 ? (
                    <div style={{padding:"12px 14px", background:T_LIGHT.canvasSoft, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:10, fontSize:13, color:T_LIGHT.textInkMut}}>
                      Aún no tienes {entidadTipo === "empleado" ? "empleados" : entidadTipo + "s"} registrados.
                    </div>
                  ) : (
                    // El estado se escribe en el renglón: sin él, el usuario tiene
                    // que salir a averiguarlo, y al salir pierde el PDF recién
                    // generado y este panel. Solo se agrupa cuando de verdad hay
                    // bajas; si no, un único grupo sería ruido.
                    <select value={entidadIdSel} onChange={e=>setEntidadIdSel(e.target.value)} style={{...inp, cursor:"pointer"}}>
                      <option value="">— Elige uno —</option>
                      {(()=>{
                        const rotulo = (en:any) => `${en.nombre}${en.rfc?` · ${en.rfc}`:""}`;
                        const bajas = entidades.filter(_esBajaEntidad);
                        if (bajas.length === 0) {
                          return entidades.map(en => (
                            <option key={en.id} value={en.id}>{rotulo(en)}</option>
                          ));
                        }
                        const activos = entidades.filter(en => !_esBajaEntidad(en));
                        return (<>
                          {activos.length > 0 && (
                            <optgroup label="Activos">
                              {activos.map(en => (
                                <option key={en.id} value={en.id}>{rotulo(en)} · activo</option>
                              ))}
                            </optgroup>
                          )}
                          <optgroup label="Dados de baja">
                            {bajas.map(en => (
                              <option key={en.id} value={en.id}>{rotulo(en)} · dado de baja</option>
                            ))}
                          </optgroup>
                        </>);
                      })()}
                    </select>
                  )}
                </div>
              </>
            )}

            <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr":"1fr 1fr", gap:12, marginBottom:14}}>
              <div>
                <label style={lbl}>Fecha del contrato</label>
                <input type="date" value={fecha} onChange={e=>setFecha(e.target.value)} style={inp}/>
              </div>
              <div>
                <label style={lbl}>Descripción</label>
                <input value={descripcion} onChange={e=>setDescripcion(e.target.value)} style={inp} placeholder="Ej. abril 2025"/>
              </div>
            </div>

            <div style={{display:"flex", gap:8}}>
              <button onClick={(ev)=>{ if (!guardando && sePuedeCerrarElPanel(ev)) setOpen(false); }} disabled={guardando} style={{flex:1, background:"transparent", border:`1px solid ${T_LIGHT.borderCard}`, color:T_LIGHT.textInkSoft, borderRadius:10, padding:"11px", cursor:"pointer", fontSize:13, fontFamily:fontSans}}>Cancelar</button>
              <button onClick={handleGuardar} disabled={!entidadIdSel||guardando} style={{flex:2, background:(entidadIdSel&&!guardando)?gold:T_LIGHT.canvasSoft, border:"none", color:(entidadIdSel&&!guardando)?"#0B1829":T_LIGHT.textInkMut, borderRadius:10, padding:"11px", cursor:(entidadIdSel&&!guardando)?"pointer":"not-allowed", fontSize:13, fontWeight:700, fontFamily:fontSans}}>{guardando?"Subiendo y guardando...":"Guardar y vincular"}</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

function ClientesModulo({user, onBack, onGoContratos, fontSans, fontSerif, gold}: {
  user:any; onBack:()=>void; onGoContratos:()=>void;
  fontSans:string; fontSerif:string; gold:string;
}) {
  const [clientes, setClientes] = useState<any[]>([]);
  const [showForm, setShowForm] = useState(false);
  // Selector de plantilla: null hasta que el usuario elige. Una vez elegida,
  // el form muestra los campos correspondientes.
  const [plantilla, setPlantilla] = useState<PlantillaCliente|null>(null);
  // Campos GENERAL
  const [rfc, setRfc] = useState("");
  const [nombre, setNombre] = useState("");
  const [tipo, setTipo] = useState<"fisica"|"moral">("moral");
  const [correo, setCorreo] = useState("");
  const [telefono, setTelefono] = useState("");
  const [domicilio, setDomicilio] = useState("");
  const [notas, setNotas] = useState("");
  // Campos MÉDICO (extras)
  const [fechaNacimiento, setFechaNacimiento] = useState("");
  const [sexo, setSexo] = useState("femenino");
  const [emergNombre, setEmergNombre] = useState("");
  const [emergTel, setEmergTel] = useState("");
  const [emergRel, setEmergRel] = useState("");
  const [observaciones, setObservaciones] = useState("");
  // Comunes
  const [guardando, setGuardando] = useState(false);
  const [cargando, setCargando] = useState(true);
  const [previewVal, setPreviewVal] = useState<any>(null);
  const [clienteExpediente, setClienteExpediente] = useState<any>(null);
  const [showComoFunciona, setShowComoFunciona] = useState(false);
  // Filtro de lista por plantilla — null = todas
  const [filtroPlantilla, setFiltroPlantilla] = useState<PlantillaCliente|null>(null);
  const isMobile = window.innerWidth < 768;
  const db = getFirestore();

  // ── SIN VALIDACIÓN 69-B ────────────────────────────────────────────────
  // Este módulo la usaba de forma ACCESORIA —da de alta clientes, sus datos y
  // sus contratos, y de paso comprobaba el RFC—, así que vuelve entero menos esa
  // parte. La validación está en "Próximamente" (ver `ProximamenteValidacion69B`):
  // mientras la plataforma no revalide sola lo ya guardado, no puede afirmar la
  // situación fiscal de nadie.
  //
  // Lo guardado NO se toca: `situacionEfos` y `nombreSat` siguen en cada ficha de
  // cliente, intactos. Simplemente ya no se leen ni se pintan. El diccionario se
  // conserva —sin usar— para que reactivarlo sea volver a enchufarlo, no
  // reescribirlo.
  // eslint-disable-next-line
  const _SIT_META_RETIRADO: Record<string,{label:string; color:string; bg:string; desc:string; alerta:boolean}> = {
    limpio: {label:"Sin coincidencias", color:"#1D9E75", bg:"rgba(29,158,117,0.12)", desc:"No aparece en las listas 69-B / 69-B Bis del SAT.", alerta:false},
    D: {label:"EFOS Definitivo", color:"#E24B4A", bg:"rgba(226,75,74,0.14)", desc:"Confirmado por el SAT. Sus facturas NO tienen efectos fiscales — no las deduzcas.", alerta:true},
    P: {label:"Presunto", color:"#EF9F27", bg:"rgba(239,159,39,0.14)", desc:"El SAT presume operaciones inexistentes. Aún puede desvirtuar. Precaución.", alerta:true},
    V: {label:"Desvirtuado", color:"#5DA0E8", bg:"rgba(93,160,232,0.12)", desc:"Fue señalado pero aclaró la presunción ante el SAT. Sin efectos negativos.", alerta:false},
    S: {label:"Sentencia Favorable", color:"#5DA0E8", bg:"rgba(93,160,232,0.12)", desc:"Fue señalado pero un tribunal falló a su favor. Removido de la lista.", alerta:false},
  };

  const cargarClientes = async () => {
    if (!user?.uid) { setCargando(false); return; }
    try {
      const snap = await getDocs(query(collection(db,"clientes"), where("userId","==",user.uid)));
      const lista = snap.docs.map(d => ({id:d.id, ...d.data()} as any))
        .sort((a,b)=>(a.nombre||"").localeCompare(b.nombre||""));   // orden en JS — sin orderBy
      setClientes(lista);
    } catch(e) { console.error(e); }
    finally { setCargando(false); }
  };
  useEffect(() => { cargarClientes(); /* eslint-disable-next-line */ }, [user]);

  // Devuelve SIEMPRE null: no se consulta la lista y, sobre todo, NO se afirma
  // "limpio". Decir que un cliente no aparece en el 69-B sin haberlo comprobado
  // es la misma mentira que decir que aparece, solo que en la otra dirección.
  const validarRFC = (_rfcVal:string): {situacion:string; nombreSat:string|null}|null => null;

  const resetForm = () => {
    setPlantilla(null);
    setRfc(""); setNombre(""); setTipo("moral"); setCorreo("");
    setTelefono(""); setDomicilio(""); setNotas(""); setPreviewVal(null);
    setFechaNacimiento(""); setSexo("femenino");
    setEmergNombre(""); setEmergTel(""); setEmergRel("");
    setObservaciones("");
  };

  // Validación del form según plantilla. Reglas:
  // - GENERAL: RFC y nombre obligatorios.
  // - MÉDICO: solo nombre del paciente obligatorio. El RFC es opcional; si lo
  //   captura, se guarda como un dato más (ya no se valida contra el 69-B).
  const puedeGuardar = (() => {
    if (!plantilla || !nombre.trim()) return false;
    if (plantilla === "general") return !!rfc.trim();
    return true;
  })();

  const guardar = async () => {
    if (!puedeGuardar || !user?.uid || !plantilla) return;
    setGuardando(true);
    try {
      // Sin validación 69-B: `validarRFC` devuelve siempre null (ver arriba).
      const rfcLimpio = rfc.trim().toUpperCase();
      const val = rfcLimpio ? validarRFC(rfcLimpio) : null;
      const baseDoc: any = {
        userId: user.uid,
        plantilla,
        nombre: nombre.trim(),
        telefono: telefono.trim() || null,
        notas: notas.trim() || null,
        // Capa legal común a ambas plantillas
        consentimientoAviso: { entregado: false, fecha: null, version: "1.0" },
        documentos: [],
        contratos: [],
        camposExtra: [],
        timestamp: Timestamp.now(),
      };
      // Campos específicos por plantilla
      if (plantilla === "general") {
        Object.assign(baseDoc, {
          rfc: rfcLimpio,
          tipo,                                    // "fisica" | "moral"
          correo: correo.trim() || null,
          domicilio: domicilio.trim() || null,
          // Sin validación: se guarda `null`, NO "limpio". Afirmar que no
          // aparece en el 69-B sin haberlo comprobado es la misma mentira que
          // afirmar que aparece. Los clientes ya guardados conservan lo suyo.
          situacionEfos: null,
          nombreSat: null,
          fechaValidacion: null,
        });
      } else {
        // MÉDICO: RFC opcional, datos sensibles del paciente.
        Object.assign(baseDoc, {
          rfc: rfcLimpio || null,
          correo: correo.trim() || null,
          fechaNacimiento: fechaNacimiento || null,
          sexo: sexo || null,
          contactoEmergencia: (emergNombre.trim() || emergTel.trim()) ? {
            nombre: emergNombre.trim() || null,
            telefono: emergTel.trim() || null,
            relacion: emergRel.trim() || null,
          } : null,
          observaciones: observaciones.trim() || null,
          // Consentimiento informado (paciente acepta atención) — separado de
          // Aviso de Privacidad. Se marca después desde el expediente.
          consentimientoInformado: { entregado: false, fecha: null, version: "1.0" },
          // Sin validación 69-B: ver la nota de arriba.
          situacionEfos: null,
          nombreSat: null,
          fechaValidacion: null,
        });
      }
      await addDoc(collection(db,"clientes"), baseDoc);
      setShowForm(false); resetForm();
      await cargarClientes();
    } catch(e){ console.error(e); alert("Error al guardar el registro"); }
    finally{ setGuardando(false); }
  };

  const eliminar = async (c:any) => {
    const ent = PLANTILLAS_CLIENTE[(c.plantilla||"general") as PlantillaCliente].entidad;
    if (!window.confirm(`¿Eliminar a ${c.nombre} de tu cartera de ${ent}s?`)) return;
    try { await deleteDoc(doc(db,"clientes",c.id)); }
    catch(e:any){ console.error(e); alert("No se pudo eliminar a " + (c.nombre||"") + ": " + (e?.code || e?.message || "error desconocido")); }
    finally { await cargarClientes(); }
  };

  // La situación 69-B ya no se deriva ni se pinta. En docs sin plantilla se
  // asume "general", que es lo único que esta lista necesita saber.
  const clientesVal = clientes.map(c => ({
    ...c,
    _plantilla: ((c.plantilla as PlantillaCliente) || "general") as PlantillaCliente,
  }));
  const conAviso = clientesVal.filter(c => c.consentimientoAviso?.entregado).length;
  const conteoGeneral = clientesVal.filter(c => c._plantilla === "general").length;
  const conteoMedico  = clientesVal.filter(c => c._plantilla === "medico").length;

  // Aplico filtro de plantilla a la lista mostrada (no a los KPIs — los KPIs
  // muestran el total real para no confundir al usuario).
  const clientesMostrados = filtroPlantilla
    ? clientesVal.filter(c => c._plantilla === filtroPlantilla)
    : clientesVal;

  const lbl = {fontSize:10, color:UI.textoTenue, display:"block", marginBottom:5, textTransform:"uppercase" as const, letterSpacing:"0.5px"};
  const inp = {width:"100%", padding:"12px 14px", border:"1px solid rgba(0,0,0,0.12)", borderRadius:UI.rTarjeta, fontSize:14, outline:"none", boxSizing:"border-box" as const, fontFamily:fontSans};

  if (clienteExpediente) {
    return <ExpedienteCliente
      cliente={clienteExpediente}
      sitMeta={null}
      onBack={()=>setClienteExpediente(null)}
      onActualizado={cargarClientes}
      onGoContratos={onGoContratos}
      fontSans={fontSans} fontSerif={fontSerif} gold={gold}
    />;
  }

  // Helper para renderizar la card de selector de plantilla en el form.
  const PlantillaCard = ({pl}:{pl:PlantillaCliente}) => {
    const meta = PLANTILLAS_CLIENTE[pl];
    const activo = plantilla === pl;
    return (
      <button onClick={()=>setPlantilla(pl)} style={{
        textAlign:"left" as const, cursor:"pointer",
        background: activo ? `${CLIENTES_COLOR}10` : UI.hover,
        border:`1.5px solid ${activo ? CLIENTES_COLOR : UI.divisor}`,
        borderRadius:UI.rPanel, padding:"16px 18px",
        boxShadow: activo ? `0 4px 16px ${CLIENTES_COLOR}22` : "none",
        fontFamily:fontSans, transition:"all 0.18s ease",
      }}>
        <div style={{display:"flex", alignItems:"center", gap:10, marginBottom:6}}>
          <span style={{fontSize:22, lineHeight:1}}>{meta.icono}</span>
          <span style={{fontFamily:fontSerif, fontSize:15, fontWeight:700, color:UI.texto}}>{meta.label}</span>
          {activo && <span style={{marginLeft:"auto", fontSize:11, color:CLIENTES_COLOR, fontWeight:700}}>✓ Elegido</span>}
        </div>
        <div style={{fontSize:12, color:UI.textoSuave, lineHeight:1.5}}>{meta.desc}</div>
      </button>
    );
  };

  return (
    <div {...ZONA_DE_CAPTURA} style={{minHeight:"100vh", background:UI.fondo, fontFamily:fontSans}}>
      {/* Header interno se omite — la identidad ("Clientes") la da el sidebar. */}
      <div style={{maxWidth:ANCHO_CONTENIDO, margin:"0 auto", padding:isMobile?"20px 16px":"28px 32px"}}>
        {/* KPI cards */}
        <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr 1fr":"repeat(4,1fr)", gap:12, marginBottom:24}}>
          <div style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rPanel, padding:"18px 20px", boxShadow:UI.sombra, borderLeft:`3px solid ${CLIENTES_COLOR}`}}>
            <div style={{fontFamily:fontSerif, fontSize:30, color:UI.texto, fontWeight:600}}>{clientes.length}</div>
            <div style={{fontSize:11, color:UI.textoSuave, marginTop:2}}>En cartera</div>
          </div>
          <div style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rPanel, padding:"18px 20px", boxShadow:UI.sombra, borderLeft:`3px solid ${CLIENTES_COLOR}`}}>
            <div style={{fontFamily:fontSerif, fontSize:22, color:UI.texto, fontWeight:600}}>{conteoGeneral}<span style={{fontSize:12, color:UI.textoTenue, marginLeft:6}}>{PLANTILLAS_CLIENTE.general.icono}</span></div>
            <div style={{fontSize:11, color:UI.textoSuave, marginTop:2}}>Clientes · {conteoMedico} pacientes {PLANTILLAS_CLIENTE.medico.icono}</div>
          </div>
          {/* El contador "En lista negra SAT (69-B)" salió de aquí con la
             validación: un número sacado de un dato que no se revalida es peor
             que no tenerlo, y en rojo, mucho peor. Vuelve con ella. */}
          <div style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rPanel, padding:"18px 20px", boxShadow:UI.sombra, borderLeft:`3px solid ${CLIENTES_COLOR}`, gridColumn:isMobile?"1 / -1":"auto"}}>
            <div style={{fontFamily:fontSerif, fontSize:30, color:UI.texto, fontWeight:600}}>{conAviso}<span style={{fontSize:16, color:UI.textoTenue, fontWeight:500}}> / {clientes.length||0}</span></div>
            <div style={{fontSize:11, color:UI.textoSuave, marginTop:2}}>Aviso de Privacidad entregado</div>
          </div>
        </div>

        {/* Banner contextual */}
        <div style={{background:T_LIGHT.goldSoft, border:`1px solid ${T_LIGHT.goldBorder}`, borderRadius:UI.rPanel, padding:"14px 16px", marginBottom:24, fontSize:12, color:UI.textoSuave, lineHeight:1.7}}>
          Lleva tu cartera de clientes y pacientes en un solo lugar. Para clientes de negocio se capturan RFC y domicilio; para pacientes, campos básicos y consentimiento informado. En ambos casos se registra el Aviso de Privacidad (LFPDPPP) y puedes vincular contratos.
        </div>

        {/* Header de lista + botón agregar + filtro */}
        <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16, flexWrap:"wrap" as const, gap:10}}>
          <h2 style={{color:UI.texto, fontFamily:fontSerif, fontSize:18, fontWeight:600, margin:0}}>Mi cartera</h2>
          <div style={{display:"flex", alignItems:"center", gap:8, flexWrap:"wrap" as const}}>
            {(conteoGeneral>0 && conteoMedico>0) && (
              <div style={{display:"inline-flex", background:UI.hover, border:`1px solid ${UI.borde}`, borderRadius:UI.rTarjeta, padding:3}}>
                {([
                  {id:null, label:"Todos"},
                  {id:"general" as PlantillaCliente, label:`${PLANTILLAS_CLIENTE.general.icono} Clientes`},
                  {id:"medico" as PlantillaCliente, label:`${PLANTILLAS_CLIENTE.medico.icono} Pacientes`},
                ]).map(opt => (
                  <button key={opt.id||"todos"} onClick={()=>setFiltroPlantilla(opt.id as any)}
                    style={{
                      background: filtroPlantilla === opt.id ? CLIENTES_COLOR : "transparent",
                      color: filtroPlantilla === opt.id ? "white" : UI.textoSuave,
                      border:"none", borderRadius:7, padding:"6px 12px",
                      cursor:"pointer", fontSize:12, fontWeight:600, fontFamily:fontSans,
                    }}>{opt.label}</button>
                ))}
              </div>
            )}
            {!showForm && <BotonPrimario texto="+ Agregar" onClick={()=>setShowForm(true)} fontSans={fontSans}/>}
          </div>
        </div>

        {/* Form de alta — paso 1: elegir plantilla. Paso 2: campos. */}
        {showForm && (
          <div style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rPanel, padding:isMobile?"20px":"24px", marginBottom:20, boxShadow:UI.sombra}}>
            <div style={{marginBottom:18}}>
              <div style={{fontSize:11, color:CLIENTES_COLOR, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"0.6px", marginBottom:8}}>Paso 1 · ¿Qué tipo de registro vas a crear?</div>
              <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr":"1fr 1fr", gap:10}}>
                <PlantillaCard pl="general"/>
                <PlantillaCard pl="medico"/>
              </div>
            </div>

            {/* Una vez elegida la plantilla, mostramos los campos correspondientes. */}
            {plantilla && (
              <>
                <div style={{fontSize:11, color:CLIENTES_COLOR, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"0.6px", marginBottom:8, paddingTop:8, borderTop:`1px dashed ${UI.divisor}`}}>Paso 2 · Datos del {PLANTILLAS_CLIENTE[plantilla].entidad}</div>

                {plantilla === "general" ? (
                  <>
                    <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr":"1fr 1fr", gap:14, marginBottom:14}}>
                      <div>
                        <label style={lbl}>RFC *</label>
                        <input value={rfc} onChange={e=>{const v=e.target.value.toUpperCase(); setRfc(v); setPreviewVal(v.trim().length>=10?validarRFC(v):null);}} placeholder="Ej. ABC123456XY0" style={{...inp, letterSpacing:"1px", fontWeight:600, textTransform:"uppercase" as const}}/>
                      </div>
                      <div>
                        <label style={lbl}>Nombre / Razón social *</label>
                        <input value={nombre} onChange={e=>setNombre(e.target.value)} placeholder="Nombre del cliente" style={inp}/>
                      </div>
                      <div>
                        <label style={lbl}>Tipo *</label>
                        <select value={tipo} onChange={e=>setTipo(e.target.value as any)} style={{...inp, cursor:"pointer"}}>
                          <option value="moral">Persona moral</option>
                          <option value="fisica">Persona física</option>
                        </select>
                      </div>
                      <div>
                        <label style={lbl}>Correo</label>
                        <input value={correo} onChange={e=>setCorreo(e.target.value)} placeholder="correo@cliente.com" style={inp}/>
                      </div>
                      <div>
                        <label style={lbl}>Teléfono</label>
                        <input value={telefono} onChange={e=>setTelefono(e.target.value)} placeholder="449..." style={inp}/>
                      </div>
                      <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
                        <label style={lbl}>Domicilio</label>
                        <input value={domicilio} onChange={e=>setDomicilio(e.target.value)} placeholder="Calle, número, colonia, ciudad" style={inp}/>
                      </div>
                    </div>
                    {/* Vista previa de la situación 69-B: retirada con la validación. */}
                  </>
                ) : (
                  <>
                    <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr":"1fr 1fr", gap:14, marginBottom:14}}>
                      <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
                        <label style={lbl}>Nombre del paciente *</label>
                        <input value={nombre} onChange={e=>setNombre(e.target.value)} placeholder="Nombre completo" style={inp}/>
                      </div>
                      <div>
                        <label style={lbl}>Fecha de nacimiento</label>
                        <input type="date" value={fechaNacimiento} onChange={e=>setFechaNacimiento(e.target.value)} style={inp}/>
                      </div>
                      <div>
                        <label style={lbl}>Sexo</label>
                        <select value={sexo} onChange={e=>setSexo(e.target.value)} style={{...inp, cursor:"pointer"}}>
                          {SEXO_OPCIONES.map(s => <option key={s.id} value={s.id}>{s.label}</option>)}
                        </select>
                      </div>
                      <div>
                        <label style={lbl}>Teléfono</label>
                        <input value={telefono} onChange={e=>setTelefono(e.target.value)} placeholder="449..." style={inp}/>
                      </div>
                      <div>
                        <label style={lbl}>Correo</label>
                        <input value={correo} onChange={e=>setCorreo(e.target.value)} placeholder="opcional" style={inp}/>
                      </div>
                      <div>
                        <label style={lbl}>RFC (opcional)</label>
                        <input value={rfc} onChange={e=>{const v=e.target.value.toUpperCase(); setRfc(v); setPreviewVal(v.trim().length>=10?validarRFC(v):null);}} placeholder="Solo si lo necesitas" style={{...inp, letterSpacing:"1px", textTransform:"uppercase" as const}}/>
                      </div>
                      <div style={{gridColumn:isMobile?"auto":"1 / -1", borderTop:`1px dashed ${UI.divisor}`, paddingTop:12, marginTop:2}}>
                        <div style={{fontSize:11, color:UI.textoTenue, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"0.5px", marginBottom:8}}>Contacto de emergencia</div>
                      </div>
                      <div>
                        <label style={lbl}>Nombre</label>
                        <input value={emergNombre} onChange={e=>setEmergNombre(e.target.value)} placeholder="Persona a contactar" style={inp}/>
                      </div>
                      <div>
                        <label style={lbl}>Teléfono</label>
                        <input value={emergTel} onChange={e=>setEmergTel(e.target.value)} placeholder="449..." style={inp}/>
                      </div>
                      <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
                        <label style={lbl}>Relación</label>
                        <input value={emergRel} onChange={e=>setEmergRel(e.target.value)} placeholder="Madre, hermano, esposa..." style={inp}/>
                      </div>
                      <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
                        <label style={lbl}>Observaciones generales</label>
                        <input value={observaciones} onChange={e=>setObservaciones(e.target.value)} placeholder="Notas administrativas (NO datos clínicos)" style={inp}/>
                      </div>
                    </div>
                    {/* Vista previa de la situación 69-B: retirada con la validación. */}
                    <div style={{background:UI.hover, border:`1px solid ${UI.borde}`, borderLeft:`3px solid ${CLIENTES_COLOR}`, borderRadius:UI.rTarjeta, padding:"11px 14px", marginBottom:14, fontSize:11.5, color:UI.textoSuave, lineHeight:1.65}}>
                      Este registro guarda los datos administrativos y de contacto del paciente. AXIS no es un expediente clínico — para el historial usa tu formato (NOM-004) y, si quieres, súbelo aquí como documento.
                    </div>
                  </>
                )}

                <div style={{marginBottom:16}}>
                  <label style={lbl}>Notas (opcional)</label>
                  <input value={notas} onChange={e=>setNotas(e.target.value)} placeholder={plantilla==="medico"?"Notas internas":"Ej. cliente recurrente desde 2023"} style={inp}/>
                </div>
              </>
            )}

            <div style={{display:"flex", gap:8}}>
              <button onClick={()=>{setShowForm(false); resetForm();}} style={{flex:1, background:"transparent", border:"1px solid rgba(0,0,0,0.15)", color:UI.textoSuave, borderRadius:UI.rTarjeta, padding:"11px", cursor:"pointer", fontSize:13, fontFamily:fontSans}}>Cancelar</button>
              <button onClick={guardar} disabled={!puedeGuardar||guardando} style={{flex:2, background:puedeGuardar?gold:"#ddd", border:"none", color:puedeGuardar?"#0B1829":"#999", borderRadius:UI.rTarjeta, padding:"11px", cursor:puedeGuardar?"pointer":"not-allowed", fontSize:13, fontWeight:700, fontFamily:fontSans}}>{guardando?"Guardando...":(plantilla==="general"?"Guardar y validar":"Guardar registro")}</button>
            </div>
          </div>
        )}

        {/* Lista */}
        {cargando ? (
          <div style={{textAlign:"center" as const, padding:"40px", color:UI.textoTenue}}>Cargando...</div>
        ) : clientesMostrados.length === 0 ? (
          <div style={{textAlign:"center" as const, padding:"50px 20px", background:UI.superficie, borderRadius:UI.rPanel, border:`1px dashed ${T_LIGHT.goldBorder}`, color:UI.textoSuave, fontSize:14}}>
            {filtroPlantilla
              ? `Aún no tienes ${PLANTILLAS_CLIENTE[filtroPlantilla].entidadPlural} registrados.`
              : "Aún no tienes registros en tu cartera. Agrega uno para empezar."}
          </div>
        ) : (
          <div style={{display:"flex", flexDirection:"column" as const, gap:10}}>
            {clientesMostrados.map(c => {
              const plMeta = PLANTILLAS_CLIENTE[c._plantilla as PlantillaCliente];
              const aviso = !!c.consentimientoAviso?.entregado;
              const numContratos = Array.isArray(c.contratos) ? c.contratos.length : 0;
              return (
                <div key={c.id} onClick={()=>setClienteExpediente(c)} style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rPanel, padding:"16px 18px", cursor:"pointer", boxShadow:UI.sombra, borderLeft:`3px solid ${CLIENTES_COLOR}`}}>
                  <div style={{display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:12, flexWrap:"wrap" as const}}>
                    <div style={{flex:1, minWidth:0}}>
                      <div style={{fontSize:15, fontWeight:600, color:UI.texto, marginBottom:3, display:"flex", alignItems:"center", gap:8, flexWrap:"wrap" as const}}>
                        <span>{plMeta.icono} {c.nombre}</span>
                        <span style={{fontSize:10, fontWeight:700, color:CLIENTES_COLOR, background:`${CLIENTES_COLOR}14`, padding:"2px 8px", borderRadius:6, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>{plMeta.entidad}</span>
                        {c._plantilla === "general" && c.tipo && <span style={{fontSize:10, fontWeight:600, color:UI.textoTenue, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>{c.tipo==="fisica"?"P. física":"P. moral"}</span>}
                      </div>
                      {c.rfc && <div style={{fontSize:12, color:UI.textoSuave, letterSpacing:"1px", fontFamily:"monospace"}}>{c.rfc}</div>}
                      {c._plantilla === "medico" && c.fechaNacimiento && <div style={{fontSize:11, color:UI.textoTenue, marginTop:3}}>Nac. {c.fechaNacimiento}</div>}
                      <div style={{display:"flex", gap:14, marginTop:6, flexWrap:"wrap" as const}}>
                        <span style={{fontSize:11, color:aviso?UI.ok:UI.textoTenue, fontWeight:600}}>{aviso?"✓ Aviso entregado":"○ Sin Aviso de Privacidad"}</span>
                        {c._plantilla === "medico" && (
                          <span style={{fontSize:11, color:c.consentimientoInformado?.entregado?UI.ok:UI.textoTenue, fontWeight:600}}>{c.consentimientoInformado?.entregado?"✓ Consent. informado":"○ Sin consent. informado"}</span>
                        )}
                        {numContratos>0 && <span style={{fontSize:11, color:CLIENTES_COLOR, fontWeight:600}}>{numContratos} contrato{numContratos===1?"":"s"} vinculado{numContratos===1?"":"s"}</span>}
                      </div>
                      {c.notas && <div style={{fontSize:11, color:UI.textoTenue, marginTop:4}}>{c.notas}</div>}
                    </div>
                    <div style={{display:"flex", alignItems:"center", gap:10}}>
                      {/* Aquí iba la etiqueta de situación 69-B. Sin revalidación no se afirma. */}
                      <button onClick={(e)=>{e.stopPropagation(); eliminar(c);}} style={{background:"none", border:"none", color:UI.textoTenue, cursor:"pointer", fontSize:16, padding:4}}>×</button>
                    </div>
                  </div>
                  {/* La etiqueta de situación 69-B ya no se pinta: sin revalidación no se afirma. */}
                </div>
              );
            })}
          </div>
        )}

        {/* ¿Cómo funciona? */}
        <div style={{maxWidth:760, margin:"26px auto 0", background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rPanel, overflow:"hidden", boxShadow:UI.sombra}}>
          <button onClick={()=>setShowComoFunciona(v=>!v)} style={{width:"100%", display:"flex", justifyContent:"space-between", alignItems:"center", padding:"16px 22px", background:"none", border:"none", cursor:"pointer", color:UI.texto, fontSize:15, fontFamily:fontSerif, fontWeight:600, textAlign:"left"}}>
            <span>¿Cómo funciona el módulo de Clientes?</span>
            <span style={{color:gold, fontSize:20, lineHeight:1}}>{showComoFunciona?"−":"+"}</span>
          </button>
          {showComoFunciona && (
            <div style={{padding:"0 22px 22px", color:UI.textoSuave, fontSize:13.5, lineHeight:1.7, maxWidth:ANCHO_LECTURA}}>
              <p style={{margin:"0 0 14px"}}><strong style={{color:gold}}>Dos plantillas, mismo expediente.</strong> Al crear un registro eliges si es un cliente de negocio o un paciente. La app muestra los campos correctos para cada caso. Los docs antiguos se tratan como clientes de negocio por defecto.</p>
              <p style={{margin:"0 0 14px"}}><strong style={{color:gold}}>El RFC.</strong> En clientes de negocio es obligatorio y en pacientes es opcional. La validación contra las listas del Artículo 69-B del SAT está en preparación y hoy no se realiza; el RFC se guarda como un dato más de la ficha.</p>
              <p style={{margin:"0 0 14px"}}><strong style={{color:gold}}>Capa legal LFPDPPP.</strong> En todos los registros puedes marcar la entrega del Aviso de Privacidad y el sistema graba la fecha del consentimiento. En pacientes hay además un "Consentimiento informado" separado.</p>
              <p style={{margin:"0 0 14px"}}><strong style={{color:gold}}>Campos personalizados y vínculo a contratos.</strong> Cada registro puede tener campos extra (etiqueta + valor) y los contratos que tienes con esa persona/empresa quedan asociados por id.</p>
              <p style={{margin:0, fontSize:12, color:UI.textoTenue}}>v1.5. NO es expediente clínico (NOM-004) — no metas diagnósticos, recetas ni historial médico. Próximamente: ARCO, más plantillas, CFDI.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function ExpedienteCliente({cliente, sitMeta, onBack, onActualizado, onGoContratos, fontSans, fontSerif, gold}: {
  cliente:any;
  sitMeta:any;                       // null si el registro no tiene RFC (paciente sin RFC)
  onBack:()=>void; onActualizado:()=>void; onGoContratos:()=>void;
  fontSans:string; fontSerif:string; gold:string;
}) {
  // Plantilla del registro (default "general" para docs antiguos sin campo).
  const plantilla: PlantillaCliente = (cliente.plantilla as PlantillaCliente) || "general";
  const plMeta = PLANTILLAS_CLIENTE[plantilla];
  const esMedico = plantilla === "medico";

  const [editando, setEditando] = useState(false);
  // Campos comunes
  const [tel, setTel] = useState(cliente.telefono||"");
  const [email, setEmail] = useState(cliente.correo||"");
  const [notas, setNotas] = useState(cliente.notas||"");
  // GENERAL
  const [tipo, setTipo] = useState<"fisica"|"moral">(cliente.tipo||"moral");
  const [domicilio, setDomicilio] = useState(cliente.domicilio||"");
  // MÉDICO
  const [fechaNacimiento, setFechaNacimiento] = useState(cliente.fechaNacimiento||"");
  const [sexo, setSexo] = useState(cliente.sexo||"femenino");
  const [emergNombre, setEmergNombre] = useState(cliente.contactoEmergencia?.nombre||"");
  const [emergTel, setEmergTel] = useState(cliente.contactoEmergencia?.telefono||"");
  const [emergRel, setEmergRel] = useState(cliente.contactoEmergencia?.relacion||"");
  const [observaciones, setObservaciones] = useState(cliente.observaciones||"");

  const [guardando, setGuardando] = useState(false);
  const [docs, setDocs] = useState<any[]>(cliente.documentos||[]);
  const [aviso, setAviso] = useState(!!cliente.consentimientoAviso?.entregado);
  const [avisoFecha, setAvisoFecha] = useState<any>(cliente.consentimientoAviso?.fecha || null);

  // Consentimiento informado (solo médico). Se persiste igual que el Aviso.
  const [consInf, setConsInf] = useState(!!cliente.consentimientoInformado?.entregado);
  const [consInfFecha, setConsInfFecha] = useState<any>(cliente.consentimientoInformado?.fecha || null);

  // Campos personalizados libres (etiqueta + valor). Array embebido en el doc.
  const [camposExtra, setCamposExtra] = useState<any[]>(cliente.camposExtra||[]);
  const [showFormCampo, setShowFormCampo] = useState(false);
  const [ceEtiqueta, setCeEtiqueta] = useState("");
  const [ceValor, setCeValor] = useState("");

  const [contratos, setContratos] = useState<any[]>(cliente.contratos||[]);
  // Generador de documentos legales DESDE el expediente (Aviso / Consentimiento).
  // Precargado con los datos del registro y vinculado a este expediente.
  const [docGen, setDocGen] = useState<null|"aviso_privacidad"|"consentimiento_informado">(null);
  const isMobile = window.innerWidth < 768;
  const db = getFirestore();

  const lbl = {fontSize:10, color:UI.textoTenue, display:"block", marginBottom:5, textTransform:"uppercase" as const, letterSpacing:"0.5px"};
  const inp = {width:"100%", padding:"11px 13px", border:"1px solid rgba(0,0,0,0.12)", borderRadius:UI.rTarjeta, fontSize:14, outline:"none", boxSizing:"border-box" as const, fontFamily:fontSans};
  const dato = (etq:string, val:string) => (<div><div style={{fontSize:10, color:UI.textoTenue, textTransform:"uppercase" as const, letterSpacing:"0.5px", marginBottom:3, fontWeight:700}}>{etq}</div><div style={{fontSize:14, color:UI.texto}}>{val||"—"}</div></div>);

  const guardarDatos = async () => {
    if (!cliente.id) return;
    setGuardando(true);
    try {
      const payload: any = {
        telefono: tel||null, correo: email||null, notas: notas||null,
      };
      if (esMedico) {
        Object.assign(payload, {
          fechaNacimiento: fechaNacimiento||null,
          sexo: sexo||null,
          contactoEmergencia: (emergNombre.trim() || emergTel.trim()) ? {
            nombre: emergNombre.trim() || null,
            telefono: emergTel.trim() || null,
            relacion: emergRel.trim() || null,
          } : null,
          observaciones: observaciones||null,
        });
      } else {
        Object.assign(payload, { tipo, domicilio: domicilio||null });
      }
      await updateDoc(doc(db,"clientes",cliente.id), payload);
      setEditando(false); onActualizado();
    } catch(e){ console.error(e); alert("Error al guardar los datos"); }
    finally{ setGuardando(false); }
  };

  // Documentos: mismo patrón que Proveedores (array embebido en el doc).
  // La tanda entera, en UNA escritura. Ver la nota del expediente de proveedor.
  const onDocSubido = async (archivos:{url:string; nombre:string}[]) => {
    const nuevo = [...docs, ...archivos.map((a)=>({nombre:a.nombre, url:a.url, fecha: new Date().toISOString().slice(0,10)}))];
    try {
      await updateDoc(doc(db,"clientes",cliente.id), {documentos: nuevo});
      setDocs(nuevo); onActualizado();
    } catch(e:any){ console.error(e); alert("No se pudo guardar el documento en el expediente: " + (e?.code || e?.message || "error desconocido")); }
  };
  const onDocEliminar = async (idx:number) => {
    if (!window.confirm("¿Eliminar este documento?")) return;
    const d = docs[idx];
    try { await eliminarArchivo(d.url); } catch(e){ console.error(e); }   // ver nota de huerfanos en ProveedorExpediente
    const nuevo = docs.filter((_:any,i:number)=>i!==idx);
    try {
      await updateDoc(doc(db,"clientes",cliente.id), {documentos: nuevo});
      setDocs(nuevo); onActualizado();
    } catch(e:any){ console.error(e); alert("No se pudo quitar el documento del expediente: " + (e?.code || e?.message || "error desconocido")); }
  };

  // Aviso de Privacidad (LFPDPPP) — toggle con fecha automática del consentimiento.
  // Al marcar: graba Timestamp.now(). Al desmarcar: conserva la fecha previa.
  const toggleAviso = async () => {
    if (!cliente.id) return;
    const nuevoEstado = !aviso;
    const nuevaFecha = nuevoEstado ? Timestamp.now() : avisoFecha;
    setAviso(nuevoEstado);
    setAvisoFecha(nuevaFecha);
    try {
      await updateDoc(doc(db,"clientes",cliente.id), {
        consentimientoAviso: {
          entregado: nuevoEstado,
          fecha: nuevaFecha,
          version: cliente.consentimientoAviso?.version || "1.0",
        },
      });
      onActualizado();
    } catch(e){ console.error(e); alert("Error al actualizar el consentimiento"); }
  };

  // Consentimiento informado (paciente acepta atención). Solo en plantilla médica.
  // Estructura idéntica al Aviso de Privacidad (entregado + fecha + version).
  const toggleConsInf = async () => {
    if (!cliente.id) return;
    const nuevoEstado = !consInf;
    const nuevaFecha = nuevoEstado ? Timestamp.now() : consInfFecha;
    setConsInf(nuevoEstado);
    setConsInfFecha(nuevaFecha);
    try {
      await updateDoc(doc(db,"clientes",cliente.id), {
        consentimientoInformado: {
          entregado: nuevoEstado,
          fecha: nuevaFecha,
          version: cliente.consentimientoInformado?.version || "1.0",
        },
      });
      onActualizado();
    } catch(e){ console.error(e); alert("Error al actualizar el consentimiento informado"); }
  };

  // Campos personalizados (etiqueta + valor). Array libre, sin tipos ni validación.
  const addCampoExtra = async () => {
    if (!ceEtiqueta.trim()) return;
    const nuevo = [...camposExtra, {
      id: `ce_${Date.now()}`,
      etiqueta: ceEtiqueta.trim(),
      valor: ceValor.trim() || null,
    }];
    setCamposExtra(nuevo);
    try {
      await updateDoc(doc(db,"clientes",cliente.id), {camposExtra: nuevo});
      setShowFormCampo(false); setCeEtiqueta(""); setCeValor("");
      onActualizado();
    } catch(e){ console.error(e); alert("Error al guardar el campo"); }
  };
  const removeCampoExtra = async (idx:number) => {
    if (!window.confirm("¿Eliminar este campo?")) return;
    const nuevo = camposExtra.filter((_:any,i:number)=>i!==idx);
    try {
      await updateDoc(doc(db,"clientes",cliente.id), {camposExtra: nuevo});
      setCamposExtra(nuevo); onActualizado();
    } catch(e:any){ console.error(e); alert("No se pudo eliminar el campo: " + (e?.code || e?.message || "error desconocido")); }
  };

  // Nota: el alta/baja de contratos vinculados vive en <SeccionContratosVinculados>.

  const formatFecha = (ts:any): string => {
    if (!ts) return "—";
    try {
      const d: Date = typeof ts?.toDate === "function" ? ts.toDate()
                    : ts?.seconds ? new Date(ts.seconds*1000)
                    : new Date(ts);
      return d.toLocaleDateString("es-MX", {year:"numeric", month:"long", day:"numeric"});
    } catch { return "—"; }
  };

  // ── Generador de documentos desde el expediente ─────────────────────────
  // Al volver re-leemos los contratos del cliente por si se vinculó un PDF.
  if (docGen) {
    const volver = async () => {
      setDocGen(null);
      try {
        const snap = await getDoc(doc(db,"clientes",cliente.id));
        if (snap.exists()) setContratos(((snap.data() as any).contratos) || []);
      } catch(e){ console.error(e); }
    };
    const entFija = {tipo: (esMedico ? "paciente" : "cliente") as "cliente"|"paciente", id:cliente.id, nombre:cliente.nombre};
    if (docGen === "aviso_privacidad") {
      return <FormAvisoPrivacidad
        user={{uid: cliente.userId}}
        tipoContrato="aviso_privacidad"
        onBack={volver}
        prefill={{
          titularNombre: cliente.nombre || "",
          ...(esMedico ? {datosSensibles:true} : {}),
        }}
        entidadFija={entFija}
        fontSans={fontSans} fontSerif={fontSerif} gold={gold}
      />;
    }
    // consentimiento_informado — calcula edad y sexo legibles desde el registro.
    const edadCalc = (():string => {
      if (!fechaNacimiento) return "";
      try {
        const n = new Date(fechaNacimiento), h = new Date();
        let e = h.getFullYear() - n.getFullYear();
        const m = h.getMonth() - n.getMonth();
        if (m < 0 || (m === 0 && h.getDate() < n.getDate())) e--;
        return (e >= 0 && e < 150) ? String(e) : "";
      } catch { return ""; }
    })();
    const sexoTxt = sexo === "femenino" ? "femenino" : sexo === "masculino" ? "masculino" : "";
    return <FormConsentimientoInformado
      user={{uid: cliente.userId}}
      tipoContrato="consentimiento_informado"
      onBack={volver}
      prefill={{
        pacienteNombre: cliente.nombre || "",
        pacienteEdad: edadCalc,
        pacienteSexo: sexoTxt,
      }}
      entidadFija={entFija}
      fontSans={fontSans} fontSerif={fontSerif} gold={gold}
    />;
  }

  return (
    <div {...ZONA_DE_CAPTURA} style={{minHeight:"100vh", background:UI.fondo, fontFamily:fontSans}}>
      <div style={{background:T.navy, borderBottom:"1px solid rgba(184,147,42,0.24)", padding:isMobile?"14px 16px":"16px 32px", display:"flex", alignItems:"center", gap:14, position:"sticky" as const, top:0, zIndex:10, boxShadow:"0 2px 16px rgba(22,36,71,0.12)"}}>
        <button onClick={onBack} style={{background:"rgba(255,255,255,0.08)", border:"none", color:"white", borderRadius:UI.rControl, padding:"8px 14px", cursor:"pointer", fontSize:13, fontFamily:fontSans}}>← Clientes</button>
        <span style={{color:"white", fontWeight:700, fontSize:isMobile?15:17}}>{plMeta.icono} {cliente.nombre}</span>
      </div>

      <div style={{maxWidth:860, margin:"0 auto", padding:isMobile?"20px 16px":"28px 32px"}}>
        {/* Identificación + situación 69-B (si aplica) */}
        <div style={{background:UI.superficie, border:`1px solid ${sitMeta?.alerta?sitMeta.color:UI.borde}`, borderRadius:UI.rPanel, padding:"22px 24px", marginBottom:20, boxShadow:UI.sombra, borderLeft:`3px solid ${sitMeta?.alerta?sitMeta.color:CLIENTES_COLOR}`}}>
          <div style={{display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:14, flexWrap:"wrap" as const}}>
            <div>
              <div style={{fontFamily:fontSerif, fontSize:22, color:UI.texto, fontWeight:600}}>{cliente.nombre}</div>
              {cliente.rfc && <div style={{fontSize:13, color:UI.textoSuave, letterSpacing:"1px", fontFamily:"monospace", marginTop:4}}>{cliente.rfc}</div>}
              <div style={{fontSize:11, color:CLIENTES_COLOR, marginTop:6, textTransform:"uppercase" as const, letterSpacing:"0.6px", fontWeight:700}}>
                {plMeta.icono} {plMeta.label}
                {!esMedico && cliente.tipo && ` · ${cliente.tipo==="fisica"?"Persona Física":"Persona Moral"}`}
              </div>
            </div>
            {sitMeta && <span style={{background:sitMeta.bg, color:sitMeta.color, fontSize:12, padding:"6px 13px", borderRadius:UI.rControl, fontWeight:700, border:`1px solid ${sitMeta.color}40`}}>{sitMeta.label}</span>}
          </div>
          {sitMeta?.alerta && <div style={{fontSize:12, color:sitMeta.color, marginTop:12, paddingTop:12, borderTop:`1px solid ${sitMeta.color}33`, lineHeight:1.5}}>{sitMeta.desc}</div>}
        </div>

        {/* Nota honesta (médico) — NO banner rojo: aclara el alcance del registro. */}
        {esMedico && (
          <div style={{background:UI.hover, border:`1px solid ${UI.borde}`, borderLeft:`3px solid ${CLIENTES_COLOR}`, borderRadius:UI.rPanel, padding:"14px 16px", marginBottom:20, display:"flex", gap:11, alignItems:"flex-start", boxShadow:UI.sombra}}>
            <span style={{flexShrink:0, marginTop:1}}><AxisIcon name="info" size={17} color={CLIENTES_COLOR} withBackdrop={false} strokeWidth={2.5}/></span>
            <div style={{fontSize:12.5, color:UI.textoSuave, lineHeight:1.65}}>
              Este registro guarda los datos administrativos y de contacto del paciente. AXIS no es un expediente clínico — para el historial usa tu formato (NOM-004) y, si quieres, súbelo aquí como documento.
            </div>
          </div>
        )}

        {/* Datos del registro */}
        <div style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rPanel, padding:"20px 22px", marginBottom:20, boxShadow:UI.sombra}}>
          <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16}}>
            <h3 style={{color:UI.texto, fontFamily:fontSerif, fontSize:16, fontWeight:600, margin:0}}>Datos del {plMeta.entidad}</h3>
            {!editando && <button onClick={()=>setEditando(true)} style={{background:T_LIGHT.goldSoft, border:`1px solid ${T_LIGHT.goldBorder}`, color:gold, borderRadius:UI.rControl, padding:"6px 14px", cursor:"pointer", fontSize:12, fontFamily:fontSans, fontWeight:700}}>Editar</button>}
          </div>
          {editando ? (
            <div>
              <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr":"1fr 1fr", gap:14, marginBottom:14}}>
                {esMedico ? (
                  <>
                    <div><label style={lbl}>Fecha de nacimiento</label><input type="date" value={fechaNacimiento} onChange={e=>setFechaNacimiento(e.target.value)} style={inp}/></div>
                    <div><label style={lbl}>Sexo</label><select value={sexo} onChange={e=>setSexo(e.target.value)} style={{...inp, cursor:"pointer"}}>{SEXO_OPCIONES.map(s => <option key={s.id} value={s.id}>{s.label}</option>)}</select></div>
                    <div><label style={lbl}>Teléfono</label><input value={tel} onChange={e=>setTel(e.target.value)} style={inp} placeholder="449..."/></div>
                    <div><label style={lbl}>Correo</label><input value={email} onChange={e=>setEmail(e.target.value)} style={inp} placeholder="correo@..."/></div>
                    <div style={{gridColumn:isMobile?"auto":"1 / -1", borderTop:`1px dashed ${UI.divisor}`, paddingTop:12, marginTop:2}}>
                      <div style={{fontSize:11, color:UI.textoTenue, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"0.5px", marginBottom:8}}>Contacto de emergencia</div>
                    </div>
                    <div><label style={lbl}>Nombre</label><input value={emergNombre} onChange={e=>setEmergNombre(e.target.value)} style={inp} placeholder="Persona a contactar"/></div>
                    <div><label style={lbl}>Teléfono</label><input value={emergTel} onChange={e=>setEmergTel(e.target.value)} style={inp} placeholder="449..."/></div>
                    <div style={{gridColumn:isMobile?"auto":"1 / -1"}}><label style={lbl}>Relación</label><input value={emergRel} onChange={e=>setEmergRel(e.target.value)} style={inp} placeholder="Madre, hermano, esposa..."/></div>
                    <div style={{gridColumn:isMobile?"auto":"1 / -1"}}><label style={lbl}>Observaciones generales</label><input value={observaciones} onChange={e=>setObservaciones(e.target.value)} style={inp} placeholder="Notas administrativas (NO datos clínicos)"/></div>
                    <div style={{gridColumn:isMobile?"auto":"1 / -1"}}><label style={lbl}>Notas internas</label><input value={notas} onChange={e=>setNotas(e.target.value)} style={inp} placeholder="Notas adicionales"/></div>
                  </>
                ) : (
                  <>
                    <div><label style={lbl}>Tipo</label><select value={tipo} onChange={e=>setTipo(e.target.value as any)} style={{...inp, cursor:"pointer"}}><option value="moral">Persona moral</option><option value="fisica">Persona física</option></select></div>
                    <div><label style={lbl}>Teléfono</label><input value={tel} onChange={e=>setTel(e.target.value)} style={inp} placeholder="449..."/></div>
                    <div><label style={lbl}>Correo</label><input value={email} onChange={e=>setEmail(e.target.value)} style={inp} placeholder="correo@..."/></div>
                    <div style={{gridColumn:isMobile?"auto":"1 / -1"}}><label style={lbl}>Domicilio</label><input value={domicilio} onChange={e=>setDomicilio(e.target.value)} style={inp} placeholder="Calle, número, colonia, ciudad"/></div>
                    <div style={{gridColumn:isMobile?"auto":"1 / -1"}}><label style={lbl}>Notas</label><input value={notas} onChange={e=>setNotas(e.target.value)} style={inp} placeholder="Información interna del cliente"/></div>
                  </>
                )}
              </div>
              <div style={{display:"flex", gap:8}}>
                <button onClick={()=>setEditando(false)} style={{flex:1, background:"transparent", border:`1px solid ${UI.borde}`, color:UI.textoSuave, borderRadius:UI.rControl, padding:"10px", cursor:"pointer", fontSize:13, fontFamily:fontSans}}>Cancelar</button>
                <button onClick={guardarDatos} disabled={guardando} style={{flex:2, background:gold, border:"none", color:"#0B1829", borderRadius:UI.rControl, padding:"10px", cursor:"pointer", fontSize:13, fontWeight:700, fontFamily:fontSans}}>{guardando?"Guardando...":"Guardar datos"}</button>
              </div>
            </div>
          ) : (
            <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr 1fr":"repeat(3,1fr)", gap:16}}>
              {esMedico ? (
                <>
                  {dato("Fecha de nacimiento", fechaNacimiento)}
                  {dato("Sexo", SEXO_OPCIONES.find(s=>s.id===sexo)?.label || "—")}
                  {dato("Teléfono", tel)}
                  {dato("Correo", email)}
                  {(emergNombre||emergTel||emergRel) && dato("Contacto de emergencia", [emergNombre, emergTel, emergRel].filter(Boolean).join(" · "))}
                  {observaciones && dato("Observaciones", observaciones)}
                  {notas && dato("Notas", notas)}
                </>
              ) : (
                <>
                  {dato("Tipo", tipo==="fisica"?"Persona física":"Persona moral")}
                  {dato("Teléfono", tel)}
                  {dato("Correo", email)}
                  {dato("Domicilio", domicilio)}
                  {notas && dato("Notas", notas)}
                </>
              )}
            </div>
          )}
        </div>

        {/* Aviso de Privacidad + consentimiento (LFPDPPP) — común a ambas plantillas */}
        <div style={{background:UI.superficie, border:`1px solid ${aviso?"rgba(5,150,105,0.32)":UI.borde}`, borderRadius:UI.rPanel, padding:"20px 22px", marginBottom:20, boxShadow:UI.sombra, borderLeft:`3px solid ${aviso?UI.ok:CLIENTES_COLOR}`}}>
          <div style={{display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:14, flexWrap:"wrap" as const, marginBottom:12}}>
            <div style={{flex:1, minWidth:0}}>
              <h3 style={{color:UI.texto, fontFamily:fontSerif, fontSize:16, fontWeight:600, margin:"0 0 6px"}}>Aviso de Privacidad y consentimiento</h3>
              <p style={{fontSize:12, color:UI.textoSuave, margin:0, lineHeight:1.6}}>Conforme a la LFPDPPP, debes entregar tu Aviso de Privacidad antes de tratar los datos de {esMedico?"este paciente":"este cliente"} y conservar evidencia del consentimiento.</p>
            </div>
            {aviso && <span style={{background:UI.okBg, color:UI.ok, fontSize:11, padding:"5px 11px", borderRadius:7, fontWeight:700, border:`1px solid rgba(5,150,105,0.30)`, whiteSpace:"nowrap" as const}}>✓ Entregado</span>}
          </div>
          <label style={{display:"flex", alignItems:"center", gap:10, cursor:"pointer", padding:"10px 12px", background:aviso?"rgba(5,150,105,0.06)":UI.hover, border:`1px solid ${aviso?"rgba(5,150,105,0.25)":UI.borde}`, borderRadius:UI.rTarjeta}}>
            <input type="checkbox" checked={aviso} onChange={toggleAviso} style={{width:18, height:18, accentColor:UI.ok, cursor:"pointer"}}/>
            <div style={{flex:1, minWidth:0}}>
              <div style={{fontSize:13, color:UI.texto, fontWeight:600}}>{esMedico?"El paciente":"El cliente"} recibió el Aviso de Privacidad</div>
              <div style={{fontSize:11, color:UI.textoSuave, marginTop:2}}>
                {aviso && avisoFecha
                  ? <>Consentimiento registrado el <strong style={{color:UI.texto}}>{formatFecha(avisoFecha)}</strong></>
                  : "Marca esta casilla cuando le hayas hecho llegar el Aviso."}
              </div>
            </div>
          </label>

          {/* Generar el Aviso de Privacidad con los datos del registro y vincularlo aquí. */}
          <div style={{marginTop:12, paddingTop:14, borderTop:`1px dashed ${UI.divisor}`}}>
            <p style={{fontSize:12, color:UI.textoSuave, margin:"0 0 10px", lineHeight:1.6}}>
              ¿Aún no tienes tu Aviso de Privacidad? Genera uno con los datos de tu empresa y guárdalo en este expediente.
            </p>
            <button onClick={()=>setDocGen("aviso_privacidad")} style={{
              width:"100%", background:"linear-gradient(135deg,#4C5BAA,#4C5BAACC)", border:"none",
              borderRadius:UI.rTarjeta, padding:"12px", cursor:"pointer", fontSize:13.5, fontWeight:700,
              color:"white", fontFamily:fontSans, boxShadow:"0 4px 14px rgba(76,91,170,0.32)"}}>
              Generar Aviso de Privacidad →
            </button>
          </div>
        </div>

        {/* Consentimiento informado — solo en plantilla MÉDICO */}
        {esMedico && (
          <div style={{background:UI.superficie, border:`1px solid ${consInf?"rgba(5,150,105,0.32)":UI.borde}`, borderRadius:UI.rPanel, padding:"20px 22px", marginBottom:20, boxShadow:UI.sombra, borderLeft:`3px solid ${consInf?UI.ok:CLIENTES_COLOR}`}}>
            <div style={{display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:14, flexWrap:"wrap" as const, marginBottom:12}}>
              <div style={{flex:1, minWidth:0}}>
                <h3 style={{color:UI.texto, fontFamily:fontSerif, fontSize:16, fontWeight:600, margin:"0 0 6px"}}>Consentimiento informado</h3>
                <p style={{fontSize:12, color:UI.textoSuave, margin:0, lineHeight:1.6}}>El paciente (o su tutor) declara haber recibido información sobre el procedimiento y otorga su consentimiento. Este registro NO sustituye los formatos clínicos requeridos por la NOM-004 cuando aplique.</p>
              </div>
              {consInf && <span style={{background:UI.okBg, color:UI.ok, fontSize:11, padding:"5px 11px", borderRadius:7, fontWeight:700, border:`1px solid rgba(5,150,105,0.30)`, whiteSpace:"nowrap" as const}}>✓ Firmado</span>}
            </div>
            <label style={{display:"flex", alignItems:"center", gap:10, cursor:"pointer", padding:"10px 12px", background:consInf?"rgba(5,150,105,0.06)":UI.hover, border:`1px solid ${consInf?"rgba(5,150,105,0.25)":UI.borde}`, borderRadius:UI.rTarjeta}}>
              <input type="checkbox" checked={consInf} onChange={toggleConsInf} style={{width:18, height:18, accentColor:UI.ok, cursor:"pointer"}}/>
              <div style={{flex:1, minWidth:0}}>
                <div style={{fontSize:13, color:UI.texto, fontWeight:600}}>El paciente firmó el consentimiento informado</div>
                <div style={{fontSize:11, color:UI.textoSuave, marginTop:2}}>
                  {consInf && consInfFecha
                    ? <>Firmado el <strong style={{color:UI.texto}}>{formatFecha(consInfFecha)}</strong></>
                    : "Marca esta casilla cuando el paciente (o su tutor) firme el documento."}
                </div>
              </div>
            </label>

            {/* Generar el consentimiento informado precargado con los datos del paciente. */}
            <div style={{marginTop:12, paddingTop:14, borderTop:`1px dashed ${UI.divisor}`}}>
              <p style={{fontSize:12, color:UI.textoSuave, margin:"0 0 10px", lineHeight:1.6}}>
                Todo procedimiento debería contar con el consentimiento informado firmado del paciente: lo protege a él y a ti.
              </p>
              <button onClick={()=>setDocGen("consentimiento_informado")} style={{
                width:"100%", background:"linear-gradient(135deg,#0D9488,#0D9488CC)", border:"none",
                borderRadius:UI.rTarjeta, padding:"12px", cursor:"pointer", fontSize:13.5, fontWeight:700,
                color:"white", fontFamily:fontSans, boxShadow:"0 4px 14px rgba(13,148,136,0.32)"}}>
                Generar consentimiento informado →
              </button>
            </div>
          </div>
        )}

        {/* Campos personalizados — común a ambas plantillas */}
        <div style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rPanel, padding:"20px 22px", marginBottom:20, boxShadow:UI.sombra}}>
          <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:8, flexWrap:"wrap" as const, gap:10}}>
            <h3 style={{color:UI.texto, fontFamily:fontSerif, fontSize:16, fontWeight:600, margin:0}}>Campos personalizados</h3>
            {!showFormCampo && <button onClick={()=>setShowFormCampo(true)} style={{background:gold, border:"none", color:"#0B1829", borderRadius:UI.rControl, padding:"8px 15px", cursor:"pointer", fontSize:12, fontWeight:700, fontFamily:fontSans}}>+ Agregar</button>}
          </div>
          <p style={{fontSize:11, color:UI.textoSuave, margin:"0 0 14px", lineHeight:1.6}}>Información extra que no encaja en los campos estándar. Ej. número de póliza, código interno, alergias declaradas, etc.</p>

          {showFormCampo && (
            <div style={{background:UI.hover, border:`1px solid ${T_LIGHT.goldBorder}`, borderRadius:UI.rPanel, padding:"14px 16px", marginBottom:14}}>
              <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr":"1fr 2fr", gap:10, marginBottom:12}}>
                <div>
                  <label style={lbl}>Etiqueta *</label>
                  <input value={ceEtiqueta} onChange={e=>setCeEtiqueta(e.target.value)} style={inp} placeholder="Ej. Núm. póliza"/>
                </div>
                <div>
                  <label style={lbl}>Valor</label>
                  <input value={ceValor} onChange={e=>setCeValor(e.target.value)} style={inp} placeholder="Ej. POL-78429"/>
                </div>
              </div>
              <div style={{display:"flex", gap:8}}>
                <button onClick={()=>{setShowFormCampo(false); setCeEtiqueta(""); setCeValor("");}} style={{flex:1, background:"transparent", border:`1px solid ${UI.borde}`, color:UI.textoSuave, borderRadius:UI.rControl, padding:"9px", cursor:"pointer", fontSize:13, fontFamily:fontSans}}>Cancelar</button>
                <button onClick={addCampoExtra} disabled={!ceEtiqueta.trim()} style={{flex:2, background:ceEtiqueta.trim()?gold:UI.hover, border:"none", color:ceEtiqueta.trim()?"#0B1829":UI.textoTenue, borderRadius:UI.rControl, padding:"9px", cursor:ceEtiqueta.trim()?"pointer":"not-allowed", fontSize:13, fontWeight:700, fontFamily:fontSans}}>Agregar campo</button>
              </div>
            </div>
          )}

          {camposExtra.length === 0 ? (
            <div style={{fontSize:12, color:UI.textoTenue}}>Aún no hay campos personalizados.</div>
          ) : (
            <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr":"repeat(2, 1fr)", gap:8}}>
              {camposExtra.map((ce:any, idx:number) => (
                <div key={ce.id||idx} style={{display:"flex", alignItems:"flex-start", gap:8, background:UI.hover, border:`1px solid ${UI.borde}`, borderRadius:UI.rControl, padding:"10px 12px"}}>
                  <div style={{flex:1, minWidth:0}}>
                    <div style={{fontSize:10, color:UI.textoTenue, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"0.5px", marginBottom:2}}>{ce.etiqueta}</div>
                    <div style={{fontSize:13, color:UI.texto, wordBreak:"break-word" as const}}>{ce.valor || "—"}</div>
                  </div>
                  <button onClick={()=>removeCampoExtra(idx)} style={{background:"none", border:"none", color:UI.textoTenue, cursor:"pointer", fontSize:14, padding:2, lineHeight:1}}>×</button>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Documentos */}
        <div style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rPanel, padding:"20px 22px", marginBottom:20, boxShadow:UI.sombra}}>
          <h3 style={{color:UI.texto, fontFamily:fontSerif, fontSize:16, fontWeight:600, margin:"0 0 8px"}}>Documentos del {plMeta.entidad}</h3>
          <p style={{fontSize:11, color:UI.textoSuave, margin:"0 0 14px", lineHeight:1.6}}>
            {esMedico
              ? "Identificación, formato de consentimiento firmado, etc. NO subas notas clínicas ni recetas aquí."
              : "Constancias, identificación, comprobante de domicilio, contratos firmados, etc."}
          </p>
          <SubirArchivoBtn userId={cliente.userId} carpeta="clientes_docs" label="Subir documento" accept=".pdf,.jpg,.jpeg,.png,.doc,.docx" maxMB={10} onLote={onDocSubido} />
          <div style={{display:"flex", flexDirection:"column" as const, gap:8, marginTop:14}}>
            {docs.length === 0 && <div style={{fontSize:12, color:UI.textoTenue}}>Aún no hay documentos.</div>}
            {docs.map((dc:any, idx:number) => (
              <div key={idx} style={{display:"flex", alignItems:"center", justifyContent:"space-between", gap:10, background:UI.hover, border:`1px solid ${UI.borde}`, borderRadius:UI.rControl, padding:"8px 12px"}}>
                <a href={dc.url} target="_blank" rel="noopener noreferrer" style={{color:gold, fontSize:13, textDecoration:"none", flex:1, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" as const, fontWeight:600}}>{dc.nombre}</a>
                <span style={{fontSize:11, color:UI.textoTenue}}>{dc.fecha}</span>
                <button onClick={()=>onDocEliminar(idx)} style={{background:"transparent", border:"none", color:UI.rojo, cursor:"pointer", fontSize:12, fontWeight:700}}>Eliminar</button>
              </div>
            ))}
          </div>
        </div>

        {/* Contratos vinculados — helper reusable, sube PDF a Storage */}
        <SeccionContratosVinculados
          user={{uid: cliente.userId}}
          entidadId={cliente.id}
          entidadTipo={cliente.plantilla === "medico" ? "paciente" : "cliente"}
          coleccion="clientes"
          contratos={contratos}
          onContratosChange={(nuevos)=>{ setContratos(nuevos); onActualizado(); }}
          onGoContratos={onGoContratos}
          accentColor={CLIENTES_COLOR}
          fontSans={fontSans} fontSerif={fontSerif} gold={gold}
        />
      </div>
    </div>
  );
}

// ─── FASE 3A: DASHBOARD SUITE ────────────────────────────────────────────────
// Hook + componente que agrega 5 medidores arriba del menú de módulos cuando
// el usuario tiene sesión real (no anónimo). Reutiliza los helpers existentes
// de cada módulo (calcularComplianceGlobal, calcularKPIsFlotilla,
// calcularComplianceVehiculo) y NO duplica lógica de negocio.
//
// Queries: filtran por userId (seguridad) y NUNCA usan orderBy (evitamos
// índices compuestos en Firestore — ordenamos en JS si hace falta).

// Helper local: cuenta vencimientos de contrato del empleado.
// La lógica es idéntica a la `calcularAlertas` interna de ExpedienteInner
// (línea 16044) pero devuelve datos estructurados (números) en lugar de
// strings con emojis, para que el dashboard los consuma sin parsear.
// ESTADO DEL CRÉDITO, DERIVADO AL LEER. El campo `estado` guardado en el
// documento SOLO se recalcula al registrar un pago (ver recalcularEstadoCredito),
// así que un crédito que vence sin que nadie lo toque conserva su estado viejo
// indefinidamente: la pantalla decía "Al corriente" mientras la lista de
// pendientes mostraba sus cuotas vencidas. Aquí se calcula igual que esa lista,
// leyendo la tabla de amortización —que ya trae los pagos aplicados en
// `montoPagado`—, así que no hace falta cargar la colección `pagos`.
//
// Misma regla que recalcularEstadoCredito, para que las dos coincidan siempre:
// se preserva la marca manual "incobrable", saldar todo es "liquidado", y el
// atraso de la cuota vencida más antigua decide entre "atrasado" (1-30 días) y
// "en_mora" (más de 30).
const estadoCreditoDerivado = (c: any, hoyStr: string): EstadoCredito => {
  if (c?.estado === "incobrable") return "incobrable";
  const tabla: any[] = c?.tablaAmortizacion || [];
  const pendientes = tabla.filter(cu => (cu.montoPagado||0) < (cu.cuota||0) - 0.005);
  if (tabla.length > 0 && pendientes.length === 0) return "liquidado";
  if (tabla.length === 0) return (c?.estado as EstadoCredito) || "al_corriente";
  const vencidas = pendientes
    .filter(cu => cu.fechaVencimiento && cu.fechaVencimiento < hoyStr)
    .sort((a, b) => String(a.fechaVencimiento).localeCompare(String(b.fechaVencimiento)));
  if (vencidas.length === 0) return "al_corriente";
  let diasAtraso = 0;
  try {
    const [y, m, d] = String(vencidas[0].fechaVencimiento).split("-").map(Number);
    const [hy, hm, hd] = hoyStr.split("-").map(Number);
    diasAtraso = Math.floor((new Date(hy, hm-1, hd).getTime() - new Date(y, m-1, d).getTime()) / 86400000);
  } catch {}
  return diasAtraso > 30 ? "en_mora" : "atrasado";
};

// ═══ CONFIGURACIÓN DE LA EMPRESA — UNA FUENTE, LOS DOS LADOS ════════════════
// El horario general vivía en `usuarios/{uid}.horarioLaboral`, un documento que
// NADIE más que su dueño puede leer. Por eso se COPIABA a cada ficha de
// trabajador: era la única forma de que el dato le llegara. Y una copia se separa
// de su fuente en cuanto alguien se da de alta después de la última propagación.
//
// `configuracion_empresa/{uid del patrón}` existe para que no haga falta copiar:
// el patrón la escribe, el patrón y SUS trabajadores la leen. Misma fuente, misma
// resolución en los dos lados, y el bucle de propagación desaparece.
//
// Aquí van a vivir también la denominación social, el domicilio y el correo del
// responsable: el aviso de privacidad obliga a nombrárselos al trabajador, y hoy
// no tendrían dónde estar sin inventar otra copia.
const COL_CONFIG_EMPRESA = "configuracion_empresa";

// LEE LA FUENTE, Y SI TODAVÍA NO ESTÁ, LA COPIA. El respaldo es TEMPORAL y existe
// solo para la ventana entre este cambio y la migración: mientras dure, nadie se
// queda sin horario. Cuando la migración esté hecha, el respaldo se retira.
async function leerConfigEmpresa(uidPatron: string): Promise<any> {
  if (!uidPatron) return null;
  try {
    const d = await getDoc(doc(db, COL_CONFIG_EMPRESA, uidPatron));
    if (d.exists()) return d.data() as any;
  } catch(e){ /* sin permiso o sin red: se intenta el respaldo */ }
  // RESPALDO — solo lo alcanza el propio patrón. Un trabajador NO puede leer
  // usuarios/{su patrón}, así que para él este camino no existe: si la
  // configuración no está migrada, sigue viendo la copia de su ficha.
  try {
    const us = await getDoc(doc(db, "usuarios", uidPatron));
    if (us.exists()) {
      const d0 = us.data() as any;
      return {horarioLaboral: d0.horarioLaboral || null, ubicacionTrabajo: d0.ubicacionTrabajo || null, _deRespaldo: true};
    }
  } catch(e){ /* nada que hacer: quien llama trata el null */ }
  return null;
}
// ═══ EL HORARIO DEL TRABAJADOR, EN VIVO Y AL CHECAR ══════════════════════════
// La pantalla del checador leía su ficha y la configuración de su empresa UNA vez,
// al abrirse. Con la pantalla abierta, si el patrón cambiaba o apagaba su horario
// personalizado, el trabajador seguía viendo el de antes —y el teléfono lo
// escribía como testigo de su checada— hasta tocar "Actualizar". Pasó el 9 de
// octubre de 2026: a las 08:14 se le apagó el personalizado a una persona y a las
// 08:15 su pantalla seguía diciendo 08:00 · tolerancia 0.
// Ahora se ESCUCHAN los dos documentos de los que sale su horario: su ficha y la
// configuración de su empresa. Son dos documentos, no colecciones enteras: la
// escucha cuesta una lectura cuando cambian, nada más.
function escucharFichaPropia(uid:string, alCambiar:(ficha:any|null, estado:"ok"|"vacia"|"error")=>void): ()=>void {
  return onSnapshot(query(collection(db,"trabajadores"), where("cuentaUid","==",uid)),
    (snap:any)=> { if (snap.empty) alCambiar(null, "vacia"); else alCambiar({id:snap.docs[0].id, ...(snap.docs[0].data() as any)}, "ok"); },
    (e:any)=> { console.warn("ficha propia (en vivo):", e); alCambiar(null, "error"); });
}
function escucharConfigEmpresa(empleadorId:string, alCambiar:(cfg:any|null)=>void): ()=>void {
  return onSnapshot(doc(db, COL_CONFIG_EMPRESA, empleadorId),
    (d:any)=> alCambiar(d.exists() ? d.data() : null),
    (e:any)=> { console.warn("configuración de la empresa (en vivo):", e); });
}
// Y AL CHECAR, SE RELEE. La escucha puede ir atrasada (sin red un momento, el
// teléfono recién despertado): justo antes de escribir la checada se vuelven a
// leer los dos documentos y se resuelve con la MISMA función que la pantalla y
// que la clasificación (horarioVigente). Si la lectura falla o tarda más del
// límite, se usa el de la pantalla: la checada nunca se queda sin registrar.
async function horarioDelTrabajadorAhora(o:{uid:string; empleadorId:string; respaldo:any; limiteMs?:number}): Promise<any> {
  const SIN_RESPUESTA = {};
  const leer = (async ()=>{
    const [fs, cs]:any[] = await Promise.all([
      getDocs(query(collection(db,"trabajadores"), where("cuentaUid","==",o.uid))),
      o.empleadorId ? getDoc(doc(db, COL_CONFIG_EMPRESA, o.empleadorId)) : Promise.resolve(null),
    ]);
    const ficha = fs.empty ? null : fs.docs[0].data();
    const cfg:any = cs && cs.exists() ? cs.data() : null;
    return horarioVigente(ficha, cfg?.horarioLaboral || null);
  })();
  leer.catch(()=>{});
  const limite = new Promise((res)=> setTimeout(()=> res(SIN_RESPUESTA), o.limiteMs ?? 4000));
  try { const r = await Promise.race([leer, limite]); return r === SIN_RESPUESTA ? o.respaldo : r; }
  catch(e){ return o.respaldo; }
}
// LA SEDE Y LA RAZÓN SOCIAL, TAMBIÉN RELEÍDAS AL CHECAR (11-oct-2026), igual que el
// horario: la ficha (su `sedeId` y su `razonSocialId`), la configuración de la
// empresa (la principal) y, si no es la principal, su documento del catálogo. La
// checada mide dentro/fuera contra ESA sede y la escribe como testigo
// (`sedeAplicada`, `razonSocialAplicada`). Si la lectura falla o tarda, lo de la
// pantalla: la checada nunca se queda sin registrar, ni se bloquea por estar fuera.
async function sedeYRazonDelTrabajadorAhora(o:{uid:string; empleadorId:string; respaldo:{sede:any; razon:any}; limiteMs?:number}): Promise<{sede:any; razon:any}> {
  const SIN_RESPUESTA = {};
  const leer = (async ()=>{
    const [fs, cs]:any[] = await Promise.all([
      getDocs(query(collection(db,"trabajadores"), where("cuentaUid","==",o.uid))),
      o.empleadorId ? getDoc(doc(db, COL_CONFIG_EMPRESA, o.empleadorId)) : Promise.resolve(null),
    ]);
    const ficha:any = fs.empty ? null : fs.docs[0].data();
    const cfg:any = cs && cs.exists() ? cs.data() : null;
    const sedeId = String(ficha?.sedeId || SEDE_PRINCIPAL), razonId = String(ficha?.razonSocialId || RAZON_PRINCIPAL);
    const [ds, dr]:any[] = await Promise.all([
      sedeId !== SEDE_PRINCIPAL && o.empleadorId ? getDoc(doc(db, COL_CONFIG_EMPRESA, o.empleadorId, "sedes", sedeId)) : Promise.resolve(null),
      razonId !== RAZON_PRINCIPAL && o.empleadorId ? getDoc(doc(db, COL_CONFIG_EMPRESA, o.empleadorId, "razones_sociales", razonId)) : Promise.resolve(null),
    ]);
    const sedes = catalogoDeSedes(cfg, ds && ds.exists() ? [{id: ds.id, ...ds.data()}] : []);
    const razones = catalogoDeRazones(cfg, dr && dr.exists() ? [{id: dr.id, ...dr.data()}] : []);
    return { sede: sedeDeId(sedeId, sedes), razon: razonSocialDeId(razonId, razones) };
  })();
  leer.catch(()=>{});
  const limite = new Promise((res)=> setTimeout(()=> res(SIN_RESPUESTA), o.limiteMs ?? 4000));
  try { const r:any = await Promise.race([leer, limite]); return r === SIN_RESPUESTA ? o.respaldo : r; }
  catch(e){ return o.respaldo; }
}
// El horario general, que es lo que piden las seis lecturas del patrón.
async function leerHorarioGeneral(uidPatron: string): Promise<any> {
  const cfg = await leerConfigEmpresa(uidPatron);
  return cfg?.horarioLaboral || null;
}
// ═══ EL HORARIO Y SU HISTORIA, EN EL MISMO GUARDADO ═════════════════════════
// Cada guardado del horario —el general en configuracion_empresa, el propio en la
// ficha— añade, EN LA MISMA ESCRITURA, la siguiente entrada de su historial con el
// horario tal como queda guardado. Así un día viejo se sigue calificando con el
// horario que regía entonces (horarioQueRegia). Las reglas solo dejan añadir UNA
// entrada por escritura, y solo al final (historialSoloCrece); por eso:
//   1) si el historial todavía no existe, primero va h0 "desde siempre" con el
//      horario de ANTES: es el que rigió todo lo anterior;
//   2) después, el horario nuevo y su entrada, juntos.
// Cada paso es una transacción: se lee el documento y se escribe sobre lo leído,
// así la clave de la entrada es la que esperan las reglas aunque otra pestaña haya
// guardado entre medias. Si el paso 2 fallara, h0 queda escrita y no estorba: dice
// cuál era el horario, que sigue siendo el mismo.
// EL HORARIO SE GUARDA TAL COMO SE VE: se REEMPLAZA entero, el general y el
// propio. El general se escribía con merge, que FUSIONA mapas: un campo que el
// formulario ya no enseñaba —los días de antes, por ejemplo— se quedaba guardado
// y seguía rigiendo. Si el documento existe, `update` (reemplaza el campo); si
// no, se crea. La entrada del historial lleva exactamente ese horario.
// Devuelve el historial ya escrito (leído de nuevo), o null si no se pudo leer.
// ═══ CAMBIAR LA SEDE O LA RAZÓN SOCIAL DE UN TRABAJADOR, A PARTIR DE HOY ═══════
// (11-oct-2026) El valor vigente y su entrada de historial, en el MISMO guardado,
// como lo exigen las reglas (asignacionConSuHistorial): la siguiente clave contada
// como la cuentan ellas, la hora del SERVIDOR y quién lo cambió. Una transacción:
// se lee la ficha y se escribe sobre lo leído, así la clave es la que esperan las
// reglas aunque otra pestaña haya guardado entre medias. Si ya tiene ese valor, no
// se escribe nada (una entrada sin cambio la rechazarían).
// UNA CUENTA, UNA FICHA (13-oct-2026): antes de escribir `cuentaUid` en una ficha, se
// comprueba LEYENDO que ninguna otra ficha del patrón la tenga. Si la tiene, no se
// guarda y se dice; si no se puede leer, tampoco se guarda.
async function comprobarCuentaSinOtraFicha(uidPatron:string, cuentaUid:string, fichaId:string|null): Promise<void> {
  const s = await getDocs(query(collection(db,"trabajadores"), where("userId","==",uidPatron), where("cuentaUid","==",cuentaUid)));
  if (s.docs.some((d:any)=> d.id !== fichaId)) throw errorParaMostrar(TEXTO_CUENTA_YA_VINCULADA);
}
async function cambiarAsignacionDeFicha(o:{fichaId:string; campo:"sedeId"|"razonSocialId"; campoHistorial:"historialSede"|"historialRazonSocial"; valor:string; correo:string; efectoDesdeElInicio?:boolean}): Promise<boolean> {
  const ref = doc(db, "trabajadores", o.fichaId);
  let cambio = false;
  await runTransaction(db, async (tx:any) => {
    const s = await tx.get(ref);
    if (!s.exists()) throw new Error("No se encontró la ficha de este trabajador.");
    const d:any = s.data() || {};
    if (String(d[o.campo] || SEDE_PRINCIPAL) === o.valor) return;
    const clave = siguienteClaveDeAsignacion(d[o.campoHistorial]);
    // EFECTO DESDE EL INICIO (12-oct-2026): solo la PRIMERA razón social (h0). Si
    // mientras tanto ya se le asignó una, no se escribe: las reglas lo rechazarían.
    if (o.efectoDesdeElInicio && (o.campo !== "razonSocialId" || clave !== "h0"))
      throw errorParaMostrar("Este trabajador ya tiene una razón social registrada: el cambio solo puede aplicar a partir de hoy.");
    const entrada:any = { vigenteDesde: serverTimestamp(), [o.campo]: o.valor, por: o.correo };
    if (o.efectoDesdeElInicio) entrada.efectoDesdeElInicio = true;
    tx.update(ref, { [o.campo]: o.valor, [o.campoHistorial + "." + clave]: entrada });
    cambio = true;
  });
  return cambio;
}
async function guardarHorarioConHistorial(o:{ref:any; campoHorario:string; campoHistorial:string; horario:any; correo:string; extra?:any; anteriorSiNoHay?:any}): Promise<any> {
  await runTransaction(db, async (tx:any) => {
    const s = await tx.get(o.ref);
    const d:any = s.exists() ? s.data() : null;
    if (!historialVacio(d?.[o.campoHistorial])) return;
    const anterior = d ? (d[o.campoHorario] ?? null) : (o.anteriorSiNoHay ?? null);
    const h0 = entradaDeHistorial(anterior, o.correo, serverTimestamp(), true);
    if (d) tx.update(o.ref, {[`${o.campoHistorial}.h0`]: h0});
    else tx.set(o.ref, {[o.campoHistorial]: {h0}});
  });
  await runTransaction(db, async (tx:any) => {
    const s = await tx.get(o.ref);
    const d:any = s.exists() ? s.data() : null;
    const clave = siguienteClaveDeHistorial(d?.[o.campoHistorial]);
    const entrada = entradaDeHistorial(o.horario, o.correo, serverTimestamp(), false);
    if (d) tx.update(o.ref, {[o.campoHorario]: o.horario, [`${o.campoHistorial}.${clave}`]: entrada, ...(o.extra||{})});
    else tx.set(o.ref, {[o.campoHorario]: o.horario, [o.campoHistorial]: {[clave]: entrada}, ...(o.extra||{})});
  });
  try { const s = await getDoc(o.ref); return s.exists() ? ((s.data() as any)?.[o.campoHistorial] || null) : null; }
  catch(e){ return null; }
}
// Y CON SU HISTORIAL, para quien clasifica días que ya pasaron: cada uno con el
// horario que regía entonces (horarioQueRegia). Una sola lectura para los dos.
async function leerHorarioGeneralConHistorial(uidPatron: string): Promise<{horario:any; historial:any}> {
  const cfg = await leerConfigEmpresa(uidPatron);
  return {horario: cfg?.horarioLaboral || null, historial: cfg?.historialHorario || null};
}

// ═══ QUIÉN ES EL PATRÓN, DICHO UNA VEZ ══════════════════════════════════════
// Siete documentos nombran al patrón y ninguno lo sabía. Cinco leían un nombre
// corto de texto libre del perfil; el recibo de nómina se lo INVENTABA partiendo
// el correo por la arroba —`ivan.lopez.15@…` se imprimía como IVAN.LOPEZ.15,
// encima de la línea de firma de un comprobante de pago—; y el aviso de
// privacidad lo pedía a mano cada vez. Ninguno tenía domicilio ni RFC.
//
// Aquí vive el hecho, una sola vez, en la misma casa que el horario general:
// `configuracion_empresa/{uid}`, que leen el patrón y sus trabajadores. Que lo
// lean sus trabajadores es deliberado: la denominación, el domicilio y el RFC ya
// aparecen en el contrato individual de cada uno y en su aviso de privacidad.
//
// EL DOMICILIO VA DESGLOSADO, no en un cuadro de texto. Se imprime completo en
// documentos que se firman, y capturado a granel sale con las abreviaturas y el
// orden que se le ocurran a quien lo teclee.
// `tipoPersona` NO es un adorno fiscal: decide qué declara el contrato. Media
// docena de plantillas dicen "Ser persona física mayor de edad, identificándose
// con credencial de elector", y el prellenado metía ahí una razón social. La
// plataforma no lo sabía porque nunca se lo preguntamos, así que se pregunta una
// vez, junto a la denominación y el RFC, y no se adivina: vacío significa que no
// se sabe, y con eso NO se prellena a ciegas.
type DatosPatron = {
  denominacion: string; rfc: string; tipoPersona: ""|"fisica"|"moral";
  domCalle: string; domColonia: string; domMunicipio: string; domEstado: string; domCP: string;
  correoContacto: string;
};
const CAMPOS_PATRON: {k: keyof DatosPatron; etiqueta: string; obligatorio: boolean}[] = [
  {k:"denominacion",   etiqueta:"Nombre o razón social de la empresa", obligatorio:true},
  {k:"rfc",            etiqueta:"RFC de la empresa",                   obligatorio:true},
  {k:"tipoPersona",    etiqueta:"¿Tu empresa es persona física o persona moral?", obligatorio:true},
  {k:"domCalle",       etiqueta:"Calle y número",                      obligatorio:true},
  {k:"domColonia",     etiqueta:"Colonia",                             obligatorio:true},
  {k:"domMunicipio",   etiqueta:"Municipio o alcaldía",                obligatorio:true},
  {k:"domEstado",      etiqueta:"Estado",                              obligatorio:true},
  {k:"domCP",          etiqueta:"Código postal",                       obligatorio:false},
  {k:"correoContacto", etiqueta:"Correo de contacto para tus trabajadores", obligatorio:true},
];
const DATOS_PATRON_VACIOS: DatosPatron = {
  denominacion:"", rfc:"", tipoPersona:"", domCalle:"", domColonia:"", domMunicipio:"", domEstado:"", domCP:"", correoContacto:"",
};
function datosPatronDe(cfg: any): DatosPatron {
  const t = (v:any)=> String(v==null ? "" : v).trim();
  // Cualquier valor que no sea uno de los dos se lee como "no se sabe": una
  // cadena rara no puede convertirse en una declaración sobre la empresa.
  const tp = t(cfg?.tipoPersona).toLowerCase();
  return {
    denominacion:   t(cfg?.denominacion),
    rfc:            t(cfg?.rfc).toUpperCase(),
    tipoPersona:    (tp === "fisica" || tp === "moral") ? tp : "",
    domCalle:       t(cfg?.domCalle),
    domColonia:     t(cfg?.domColonia),
    domMunicipio:   t(cfg?.domMunicipio),
    domEstado:      t(cfg?.domEstado),
    domCP:          t(cfg?.domCP),
    correoContacto: t(cfg?.correoContacto).toLowerCase(),
  };
}
// QUÉ FALTA, con las etiquetas que ve el usuario. El candado no dice "datos
// incompletos": dice qué falta, porque quien lo lee tiene que poder arreglarlo.
function faltanDatosPatron(cfg: any): string[] {
  const d = datosPatronDe(cfg);
  return CAMPOS_PATRON.filter(c => c.obligatorio && !d[c.k]).map(c => c.etiqueta);
}
function datosPatronCompletos(cfg: any): boolean {
  return faltanDatosPatron(cfg).length === 0;
}
// El domicilio para imprimir. Se arma SIEMPRE igual, en los siete documentos.
function domicilioPatronTexto(d: DatosPatron): string {
  // MUNICIPIO Y ESTADO IGUALES SE DICEN UNA VEZ. Pasa en buena parte de las
  // capitales del país —Aguascalientes, Querétaro, Campeche, Chihuahua,
  // Durango, Colima, Zacatecas, Puebla…— y "Aguascalientes, Aguascalientes"
  // impreso en un documento que se firma se lee como un error de captura.
  const mun = d.domMunicipio, est = d.domEstado;
  const lugar = (mun && est && mun.toLowerCase().trim() === est.toLowerCase().trim()) ? [est] : [mun, est];
  const partes = [d.domCalle, d.domColonia, ...lugar].filter(Boolean);
  const base = partes.join(", ");
  return d.domCP ? (base ? `${base}, C.P. ${d.domCP}` : `C.P. ${d.domCP}`) : base;
}
// UNA PUERTA AL FORMULARIO, sin cablear una prop por cuatro componentes. Mismo
// mecanismo que ya usa el aviso de la campana (`avisos:abrir`): quien bloquea
// dispara el evento y el armazón navega.
// ═══ UNA SOLA PUERTA PARA NAVEGAR DESDE CUALQUIER SITIO ════════════════════
//
// Este evento existía solo para "Datos de mi empresa", porque ahí el botón vivía a
// cuatro componentes de distancia de quien sabe navegar. El mismo problema lo
// tienen los tres pasos de "Por dónde empezar", y dos de ellos lo resolvían con
// props OPCIONALES —`onGoEmpleados?`, `onGoFlotilla?`— enhebradas por dos
// componentes. Una prop opcional que no llega no rompe nada: el renglón se sigue
// pintando con el cursor de mano y no hace absolutamente nada al pulsarlo, que es
// el peor fallo posible porque no deja rastro.
//
// Ahora los tres usan ESTA puerta. No hay prop que se pueda quedar sin pasar, y el
// oyente vive en `App`, montado siempre. Y sigue habiendo UN solo punto de
// navegación por evento —el mismo `setNavToken` de antes—, así que el conteo de
// saltos de `prueba-navegacion` no cambia.
const EVT_IR_A_MODULO = "app:ir_a_modulo";
function irAModuloGlobal(modulo: AppPantalla){
  try { window.dispatchEvent(new CustomEvent(EVT_IR_A_MODULO, {detail:{modulo}})); } catch(e){}
}
// Se conserva el nombre viejo: lo llaman siete sitios y todos quieren decir lo
// mismo. Ahora es un atajo del general.
function abrirDatosDelPatron(){ irAModuloGlobal("datos_empresa"); }

// ═══ LOS PANELES NO SE CIERRAN SOLOS ═══════════════════════════════════════
//
// UN PANEL QUE CAPTURA DATOS NO SE CIERRA AL PULSAR FUERA. NUNCA.
//
// La primera clienta perdió el alta de un vehículo entera —diez campos— con un
// clic al lado del panel: sin aviso, sin nada que recuperar y sin llegar a saber
// qué había pasado. El fondo de un panel no es un botón: es el sitio donde el
// ratón acaba por accidente. Se cierra con Cancelar o con la equis, que son actos
// deliberados, y con ningún otro gesto.
//
// Un panel que solo MUESTRA sí puede cerrarse pulsando fuera: ahí no hay nada que
// perder y cerrarlo así es cómodo. La tecla Escape sigue el mismo criterio.
//
// Las dos piezas viven aquí, juntas y una sola vez. El fondo de cada panel estaba
// escrito a mano treinta y cinco veces, y bastaba copiar el del panel de al lado
// —que era de los que solo muestran— para heredar el defecto sin verlo.

// LA FIRMA DE LO QUE HAY ESCRITO EN UN PANEL, AHORA MISMO.
//
// Recorre los campos que el panel tiene montados —incluidos los que pone un
// componente de dentro, como el editor de horario— y devuelve una cadena con sus
// valores. No guarda nada: se calcula cada vez que se pregunta, así que no puede
// quedarse vieja.
//
// Se saltan los que no contienen texto de nadie: botones, ocultos y `file`, cuyo
// valor el navegador no deja leer ni escribir.
// DÓNDE ESTÁ EL FORMULARIO, cuando el panel tiene algo más que un formulario.
//
// Se pega en el <div> que envuelve los campos de captura. Solo hace falta en los
// paneles que además llevan una LISTA con controles dentro; el resto no se toca.
//
// POR QUÉ EXISTE: la firma miraba todos los campos del panel, y los paneles de
// vacaciones y de aguinaldo llevan debajo "Historial de este periodo" y "Pagos
// registrados", con un checkbox de "Marcar como firmada" en CADA renglón. Al
// registrar aparece un renglón nuevo —o sea un campo nuevo—, la firma dejaba de
// coincidir y la guardia avisaba de que había trabajo sin guardar justo después
// de guardar. Y hay un segundo motivo que obliga a lo mismo: ese checkbox GUARDA
// AL INSTANTE, así que marcarlo tampoco puede avisar de nada.
//
// La prueba `prueba-guardia-paneles` DERIVA del propio archivo qué paneles
// necesitan este marcador —recorre el árbol buscando campos dentro de una
// repetición sobre datos— y falla si a alguno le falta. No hay una lista escrita
// a mano que se quede vieja.
const CAMPOS_DE_CAPTURA: any = { "data-campos": "1" };
// UN CAMPO QUE NO ES TEXTO DE NADIE: el periodo de un reporte que solo se genera
// o se descarga. Cambiarlo no es trabajo que perder, y un modal que solo genera
// no debe advertir al cerrarse. La guardia lo salta (ver _camposDelPanel).
const CAMPO_DE_PARAMETRO: any = { "data-parametro": "1" };

// LOS CAMPOS QUE CUENTAN. Si el panel dice dónde está su formulario, SOLO los de
// dentro. Si no lo dice, el panel entero: los paneles que son solo un formulario
// no necesitan marcar nada, y así no hay veinte marcadores que mantener.
//
// Se saltan los que no contienen texto de nadie: botones, ocultos, y `file`, cuyo
// valor el navegador no deja leer ni escribir.
function _camposDelPanel(panel: any): any[] {
  const salida: any[] = [];
  try {
    let raices: any[] = [];
    const marcados = panel.querySelectorAll("[data-campos]");
    for (let i = 0; i < marcados.length; i++) raices.push(marcados[i]);
    if (!raices.length) raices = [panel];
    for (const raiz of raices) {
      const campos = raiz.querySelectorAll("input, textarea, select");
      for (let i = 0; i < campos.length; i++) {
        const t = String(campos[i].type || "").toLowerCase();
        if (t === "file" || t === "hidden" || t === "button" || t === "submit" || t === "reset") continue;
        if (campos[i].getAttribute && campos[i].getAttribute("data-parametro") === "1") continue;
        salida.push(campos[i]);
      }
    }
  } catch (_e) { /* sin DOM utilizable no se estorba a nadie */ }
  return salida;
}

// EL VALOR DE UN CAMPO, para poder compararlo con el que tenía al abrirse.
function _valorDelCampo(c: any): string {
  const t = String(c.type || "").toLowerCase();
  if (t === "checkbox" || t === "radio") return c.checked ? "1" : "0";
  return String(c.value == null ? "" : c.value);
}

// ¿ESTE CAMPO TIENE CONTENIDO? Definido aquí y no al criterio de quien pase,
// porque dentro de las regiones marcadas hay casillas y selectores y, sin esto
// escrito, alguien lo decidiría por accidente:
//
//   · una casilla MARCADA tiene contenido; sin marcar, está vacía;
//   · un SELECTOR en su primera opción está vacío —no se ha elegido nada—; en
//     cualquier otra, tiene contenido;
//   · lo demás tiene contenido si su valor no es la cadena vacía.
function _tieneContenido(c: any): boolean {
  const t = String(c.type || "").toLowerCase();
  if (t === "checkbox" || t === "radio") return !!c.checked;
  if (String(c.tagName || "").toLowerCase() === "select") return Number(c.selectedIndex) > 0;
  return String(c.value == null ? "" : c.value) !== "";
}

// Se conserva el nombre viejo: es lo que la prueba extrae para comprobar que la
// foto de apertura se toma con los valores ya puestos.
function _firmaDelPanel(panel: any): string {
  return _camposDelPanel(panel).map(_valorDelCampo).join("\u0001");
}

// ¿HAY ALGO QUE PERDER SI SE CIERRA AHORA?
//
// LA LECCIÓN DE LA SEMANA, escrita aquí para que no se repita: NO MONTÉ EL PANEL
// QUE SE ABRE, MONTÉ EL PANEL QUE SUPONÍA. Dos veces seguidas los casos pasaron
// en verde y la pantalla falló en el mismo sitio, porque el panel de la prueba
// hacía lo que yo esperaba y no lo que hace el de verdad.
//
// La primera vez fue el historial: mi panel no tenía. La segunda fue el reset: mi
// panel devolvía los campos a como estaban al abrirse, y el de aguinaldo NO —se
// abre con el monto proyectado ya escrito y al guardar lo vacía—. La regla de
// entonces era "avisa si algo cambió", y vaciar es cambiar.
//
// La regla ahora dice lo que de verdad se quiere saber: VACIAR UN CAMPO NO ES
// TRABAJO QUE PERDER. Solo cuenta un campo que TIENE contenido AHORA y que ese
// contenido sea distinto del que traía al abrirse. Con eso, "el guardado vacía un
// campo que abrió lleno" deja de poder mentir en ningún panel, ni en éste ni en
// el que venga.
function _hayAlgoQuePerder(panel: any, inicial: string[]): boolean {
  const campos = _camposDelPanel(panel);
  for (let i = 0; i < campos.length; i++) {
    if (!_tieneContenido(campos[i])) continue;                 // vacío: nada que perder
    const antes = i < inicial.length ? inicial[i] : "";
    if (_valorDelCampo(campos[i]) !== antes) return true;
  }
  return false;
}

// Se pega tal cual en el <div> del panel de captura. Hace dos cosas: lo marca como
// panel de captura, y GUARDA CÓMO ESTABA EL PANEL AL ABRIRSE.
//
// ANTES ERA UNA BANDERA, Y LA BANDERA MENTÍA. Se encendía con el primer `input` y
// no la apagaba nadie, en ninguna parte. Así que después de registrar unas
// vacaciones —formulario guardado, campos ya vacíos, acta generada— cerrar el
// panel seguía avisando de que "lo que escribiste se va a perder", con los campos
// vacíos y el registro hecho. Un aviso que miente enseña a decir que sí sin leer,
// y el día que el aviso sea verdad nadie lo va a leer tampoco.
//
// Ahora no hay bandera que reiniciar: se compara lo que hay AHORA con lo que había
// al abrir. Después de guardar, el formulario vuelve a su estado inicial y las dos
// firmas coinciden solas. Es cierto por construcción, no porque alguien se acuerde.
//
// Y por eso la referencia es lo que había AL ABRIR y no la cadena vacía: un campo
// prellenado con la fecha de hoy que nadie tocó no es contenido que perder.
//
// Se apunta en el nodo del DOM y no en un estado de React a propósito: un estado
// obliga a declarar una variable por panel y a mantenerla al día, y veinte
// variables escritas a mano son veinte oportunidades de que una se quede vieja.
const PANEL_DE_CAPTURA: any = {
  "data-captura": "1",
  ref: (nodo: any) => {
    // React llama a esto al montar el panel, con sus campos ya puestos, y con
    // `null` al desmontarlo. La foto se toma una sola vez, al abrir.
    if (nodo) { try { nodo.__axisValoresIniciales = _camposDelPanel(nodo).map(_valorDelCampo); } catch (_e) {} }
  },
};

// VOLVER A TOMAR LA FOTO. La de PANEL_DE_CAPTURA se toma al montar el panel, y
// basta cuando el formulario nace con sus valores. No basta cuando los CARGA
// DESPUÉS (el horario se lee de la base al abrir) ni cuando se QUEDA LLENO al
// guardar (el horario sigue a la vista con lo guardado): la foto era la de antes
// de cargar, no coincidía con lo ya guardado, y cerrar avisaba de una pérdida que
// no existía. Quien carga o guarda llama a esto con un nodo de DENTRO del panel,
// cuando la pantalla ya enseña los valores (desde un efecto).
function retomarFotoDelPanel(nodo: any): void {
  try {
    const panel = nodo && nodo.closest ? nodo.closest("[data-captura]") : null;
    if (panel) panel.__axisValoresIniciales = _camposDelPanel(panel).map(_valorDelCampo);
    // Y si está en una ZONA de captura: lo que hay ahora es lo guardado.
    const zona = nodo && nodo.closest ? nodo.closest("[data-captura-zona]") : null;
    if (zona) _camposDeLaZona(zona).forEach((c: any) => { c.__axisEditado = false; c.__axisRef = _valorDelCampo(c); });
  } catch (_e) { /* sin DOM, nada que retomar */ }
}

// ═══ ZONAS DE CAPTURA: LO QUE SE ESCRIBE FUERA DE UN PANEL (11-oct-2026) ════════
// Una recarga (la actualización forzada de la plataforma) se lleva lo escrito en
// CUALQUIER pantalla, no solo en un panel: el registro de un accidente, la
// salida de un vehículo, un contrato a medio llenar, un mensaje a AXIOR. Esas
// pantallas se marcan con ZONA_DE_CAPTURA y la actualización forzada las respeta
// igual que a los paneles (hayCapturaSinGuardar). Cerrar un panel no cambia:
// esto no es PANEL_DE_CAPTURA.
//
// EL CRITERIO ES EL MISMO —algo escrito que no estaba—, PERO POR CAMPO, no por
// una foto de toda la zona: una zona es una pantalla entera, donde los
// formularios aparecen y desaparecen, y una foto por posiciones se desordenaba.
// Cada campo guarda lo que tenía cuando la persona ENTRÓ a escribir (al tomar el
// foco, mientras no haya escrito), y cuenta solo si:
//   · la persona escribió en él (input/change de verdad, no un valor que puso la
//     pantalla al cargar),
//   · tiene contenido ahora (vaciar no es trabajo que perder; al guardar, la
//     mayoría de los formularios se vacían solos),
//   · y es distinto de lo que tenía al entrar.
// Quien GUARDA y deja el formulario lleno llama a retomarFotoDelPanel (arriba).
// Un buscador, un filtro o un selector de periodo dentro de una zona no es
// trabajo que perder: se marca con CAMPO_DE_PARAMETRO y no cuenta.
const _ES_CAMPO_DE_TEXTO = (c: any) => {
  if (!c || !/^(INPUT|TEXTAREA|SELECT)$/.test(String(c.tagName || "").toUpperCase())) return false;
  const t = String(c.type || "").toLowerCase();
  if (t === "file" || t === "hidden" || t === "button" || t === "submit" || t === "reset") return false;
  return !(c.getAttribute && c.getAttribute("data-parametro") === "1");
};
function _camposDeLaZona(zona: any): any[] {
  const salida: any[] = [];
  try { const cs = zona.querySelectorAll("input, textarea, select"); for (let i = 0; i < cs.length; i++) if (_ES_CAMPO_DE_TEXTO(cs[i])) salida.push(cs[i]); }
  catch (_e) {}
  return salida;
}
function _vigilarZona(nodo: any): void {
  if (!nodo || nodo.__axisZona) return;
  nodo.__axisZona = true;
  // Al entrar a un campo, mientras no se haya escrito en él: su valor de partida.
  nodo.addEventListener("focusin", (ev: any) => {
    const c = ev && ev.target;
    if (_ES_CAMPO_DE_TEXTO(c) && !c.__axisEditado) c.__axisRef = _valorDelCampo(c);
  }, true);
  const escrito = (ev: any) => {
    const c = ev && ev.target;
    if (!_ES_CAMPO_DE_TEXTO(c)) return;
    if (c.__axisRef === undefined) c.__axisRef = "";
    c.__axisEditado = true;
  };
  nodo.addEventListener("input", escrito, true);
  nodo.addEventListener("change", escrito, true);
}
// LO QUE ACABA DE GUARDARSE YA NO ES TRABAJO QUE PERDER: los campos de `nodo`
// (un bloque, un formulario) dejan de contar hasta que se vuelva a escribir en
// ellos. Para los formularios que se quedan llenos al guardar; sin tocar lo que
// haya escrito en otros bloques de la misma zona.
function marcarCamposComoGuardados(nodo: any): void {
  try { _camposDeLaZona(nodo).forEach((c: any) => { c.__axisEditado = false; c.__axisRef = _valorDelCampo(c); }); } catch (_e) {}
}
function _zonaConAlgoQuePerder(zona: any): boolean {
  const campos = _camposDeLaZona(zona);
  for (let i = 0; i < campos.length; i++) {
    const c = campos[i];
    if (!c.__axisEditado || !_tieneContenido(c)) continue;
    if (_valorDelCampo(c) !== c.__axisRef) return true;
  }
  return false;
}
const ZONA_DE_CAPTURA: any = {
  "data-captura-zona": "1",
  ref: (nodo: any) => { if (nodo) _vigilarZona(nodo); },
};

// LA PREGUNTA ANTES DE DESCARTAR, una sola para toda la plataforma.
//
// Si el panel está como se abrió, no pregunta: interrumpir a quien no cambió nada
// es ruido, y el ruido enseña a decir que sí sin leer. Solo habla cuando de verdad
// hay algo que perder.
const TEXTO_CERRAR_SIN_GUARDAR = "Lo que escribiste aquí todavía no se ha guardado y se va a perder. ¿Cerrar de todos modos?";
function sePuedeCerrarElPanel(ev: any): boolean {
  let panel: any = null;
  try { panel = ev && ev.currentTarget && ev.currentTarget.closest ? ev.currentTarget.closest("[data-captura]") : null; } catch (_e) { panel = null; }
  // Sin panel a la vista no se estorba: cerrar es lo que el usuario pidió.
  if (!panel) return true;
  // Sin foto de referencia tampoco se estorba. Pasa si el panel se montó antes de
  // que existiera este marcador; preguntar entonces sería adivinar.
  const inicial = panel.__axisValoresIniciales;
  if (!inicial || typeof inicial.length !== "number") return true;
  if (!_hayAlgoQuePerder(panel, inicial)) return true;
  return window.confirm(TEXTO_CERRAR_SIN_GUARDAR);
}
// ¿HAY ALGO SIN GUARDAR EN ALGÚN PANEL ABIERTO? La misma pregunta que se hace
// antes de cerrar un panel (_hayAlgoQuePerder contra la foto de apertura), en
// todos los paneles de captura a la vista. La usa la actualización forzada de la
// plataforma: nunca recarga encima de algo que se está capturando.
function hayCapturaSinGuardar(): boolean {
  try {
    const paneles: any = document.querySelectorAll("[data-captura]");
    for (let i = 0; i < paneles.length; i++) {
      const inicial = paneles[i].__axisValoresIniciales;
      if (!inicial || typeof inicial.length !== "number") continue;
      if (_hayAlgoQuePerder(paneles[i], inicial)) return true;
    }
    // Y las pantallas que no son panel (ZONA_DE_CAPTURA).
    const zonas: any = document.querySelectorAll("[data-captura-zona]");
    for (let i = 0; i < zonas.length; i++) if (_zonaConAlgoQuePerder(zonas[i])) return true;
  } catch (_e) { /* sin DOM, nada que perder */ }
  return false;
}
// ═══ RESALTAR AL LLEGAR ═════════════════════════════════════════════════════
//
// Cuando un enlace lleva a UN elemento concreto, al llegar hay que decir cuál.
// "Aldred no ha checado hoy" abría Empleados y dejaba al patrón buscando a Aldred
// a ojo en una lista de cuarenta: el enlace prometía ahorrarle justo eso.
//
// Esto ya existía escrito a mano en tres sitios —el viaje señalado del historial
// de flotilla, la actividad señalada de Tareas y la unidad señalada del móvil—,
// cada uno con su ref, su efecto y su scroll. Aquí se recoge el MECANISMO una sola
// vez. Tres copias de lo mismo terminan divergiendo, y de hecho ya divergían: dos
// se apagaban al salir del módulo y ninguna se apagaba sola.
//
// SE APAGA SOLO, y eso es parte del mecanismo, no un adorno. Un resaltado que se
// queda pegado deja de señalar: al minuto siguiente el usuario ya no sabe si el
// dorado significa "esto venías a ver" o "esto tiene algo raro". Se apaga a los
// seis segundos, o en cuanto la persona toca cualquier cosa —lo que ocurra
// antes—, porque en cuanto interactúa ya encontró lo que buscaba.
const RESALTADO_MS = 6000;
function useResaltado(id: any, cuandoCargue?: any) {
  const ref = useRef<any>(null);
  const [vivo, setVivo] = useState(false);
  // ENCENDER Y APAGAR DEPENDE SOLO DEL ID, y esto es lo que hace que el apagado
  // funcione de verdad. Si dependiera también de la lista, el temporizador se
  // reiniciaría en cada repintado —y varias de estas listas se recalculan enteras
  // en cada pintada, así que nunca son la misma—: el resaltado no se apagaría
  // jamás, que es exactamente lo que no debe pasar.
  useEffect(() => {
    if (!id) { setVivo(false); return; }
    setVivo(true);
    const t = setTimeout(() => setVivo(false), RESALTADO_MS);
    const apagar = () => setVivo(false);
    // Se registran DESPUÉS del clic que trajo hasta aquí —el efecto corre tras
    // pintar—, así que ese clic no apaga el resaltado que acaba de encender.
    window.addEventListener("pointerdown", apagar);
    window.addEventListener("keydown", apagar);
    return () => {
      clearTimeout(t);
      window.removeEventListener("pointerdown", apagar);
      window.removeEventListener("keydown", apagar);
    };
  }, [id]);
  // DESPLAZARSE ES OTRA COSA, y esa sí tiene que esperar a los datos: el elemento
  // no existe en la pantalla hasta que la lista llega. Por eso este efecto mira
  // también `cuandoCargue`, y se desplaza UNA sola vez por id: si no, cada
  // repintado devolvería la pantalla al mismo sitio y no se podría ni bajar.
  const yaLlevado = useRef<any>(null);
  useEffect(() => {
    if (!id || yaLlevado.current === id) return;
    const n = ref.current;
    if (!n || typeof n.scrollIntoView !== "function") return;
    yaLlevado.current = id;
    try { n.scrollIntoView({block:"center", behavior:"smooth"}); } catch(e){}
  }, [id, cuandoCargue]);
  return {ref, vivo};
}
// EL ASPECTO, también una sola vez. Dos parámetros y ninguna copia:
//   · `forma`: una tarjeta lleva anillo; una fila de tabla no, porque el anillo
//     en un <tr> no se pinta igual en todos los navegadores —ahí es una barra
//     dorada a la izquierda, que es lo que ya usaba Tareas—.
//   · `tema`: el mismo dorado no sirve sobre crema y sobre navy. Es el mismo
//     resaltado, no otro; solo el tono que cada superficie necesita para que se
//     vea, igual que el resto de la plataforma.
function estiloResaltado(vivo: boolean, forma: "tarjeta"|"fila" = "tarjeta", tema: "claro"|"navy" = "claro"): any {
  const oro = tema === "navy" ? "226,184,74" : "184,147,42";
  const base = {transition: "background .5s ease, box-shadow .5s ease, border-color .5s ease"};
  if (!vivo) return base;
  return {
    ...base,
    background: `rgba(${oro},0.10)`,
    borderColor: `rgba(${oro},0.55)`,
    boxShadow: forma === "fila" ? `inset 3px 0 0 rgb(${oro})` : `0 0 0 3px rgba(${oro},0.16)`,
  };
}

// EL CANDADO, DICHO EN UN SITIO. Los seis documentos que se firman lo usan igual,
// así que no pueden explicarse de seis maneras distintas. Dice QUÉ falta y lleva
// de un clic a donde se captura: "datos incompletos" a secas deja al usuario
// buscando por su cuenta en qué pantalla estaba eso.
function AvisoFaltanDatosPatron({faltan, que, fontSans, fontSerif, oscuro}:{
  faltan:string[]; que:string; fontSans:string; fontSerif:string; oscuro?:boolean;
}) {
  // Los mismos colores del molde en los dos temas: estos avisos salen tanto en
  // pantallas claras (Nómina, Obligaciones) como en la ficha en navy.
  const c = oscuro
    ? {fondo:"rgba(184,147,42,0.12)", borde:"rgba(184,147,42,0.38)", titulo:"#D4A843", cuerpo:"rgba(236,230,216,0.86)", fuerte:"#ECE6D8", pie:"rgba(236,230,216,0.55)"}
    : {fondo:"rgba(184,147,42,0.10)", borde:"rgba(184,147,42,0.34)", titulo:"#7A5F12", cuerpo:"#5A4A18", fuerte:"#3F340F", pie:"#8A7434"};
  return (
    <div style={{background:c.fondo, border:`1px solid ${c.borde}`, borderRadius:12, padding:"14px 16px", marginTop:12}}>
      <div style={{fontFamily:fontSerif, fontSize:14.5, fontWeight:700, color:c.titulo, marginBottom:5}}>
        Faltan los datos de tu empresa
      </div>
      <div style={{fontSize:12.5, color:c.cuerpo, lineHeight:1.6, marginBottom:9}}>
        {que} se firma, y tiene que decir con qué empresa se firma. Falta{faltan.length===1?"":"n"}:
      </div>
      <ul style={{margin:"0 0 11px", paddingLeft:18, fontSize:12.5, color:c.fuerte, lineHeight:1.7}}>
        {faltan.map((f:string)=>(<li key={f}><b>{f}</b></li>))}
      </ul>
      <button onClick={abrirDatosDelPatron}
        style={{background:"#B8932A", border:"none", borderRadius:10, padding:"9px 16px", cursor:"pointer",
          fontSize:12.5, fontWeight:800, color:"#0B1829", fontFamily:fontSans}}>
        Capturar los datos de mi empresa
      </button>
      <div style={{fontSize:11, color:c.pie, marginTop:8, lineHeight:1.5}}>
        Se capturan una sola vez y sirven para todos tus documentos. El resto de la plataforma funciona igual.
      </div>
    </div>
  );
}

// EL DATO Y SU CANDADO, EN UNA LÍNEA, para los cinco documentos que lo piden.
// Devuelve la config leída y qué falta; null en `cfg` significa "aún no se sabe",
// y con eso NO se bloquea nada: la ausencia de dato no es un hecho.
function useDatosPatron(uidPatron: string|undefined) {
  const [cfg, setCfg] = React.useState<any|null>(null);
  React.useEffect(()=>{ let cancel=false; (async()=>{
    if (!uidPatron) return;
    try { const c = await leerConfigEmpresa(uidPatron); if (!cancel) setCfg(c || {}); }
    catch(e){ if (!cancel) setCfg({}); }
  })(); return ()=>{cancel=true;}; }, [uidPatron]);
  return {cfg, datos: datosPatronDe(cfg), faltan: cfg === null ? [] : faltanDatosPatron(cfg), listo: cfg !== null};
}

// LA PANTALLA DONDE SE CAPTURAN. Una sola, y es a la que lleva el candado.
function PantallaDatosEmpresa({currentUser, fontSans, fontSerif, onGuardado}:{
  currentUser:any; fontSans:string; fontSerif:string; onGuardado?:()=>void;
}) {
  const isMobile = window.innerWidth < 768;
  const [d, setD] = React.useState<DatosPatron>(DATOS_PATRON_VACIOS);
  const [cargando, setCargando] = React.useState(true);
  const [guardando, setGuardando] = React.useState(false);
  const [msg, setMsg] = React.useState<{ok:boolean; t:string}|null>(null);
  const [tocado, setTocado] = React.useState(false);
  // El RFC tal como está guardado: cambiarlo pide confirmación (TEXTO_CAMBIO_RFC_PRINCIPAL).
  const [rfcGuardado, setRfcGuardado] = React.useState("");

  React.useEffect(()=>{ let cancel=false; (async()=>{
    if (!currentUser?.uid) { setCargando(false); return; }
    try { const cfg = await leerConfigEmpresa(currentUser.uid); if (!cancel) { const dg = datosPatronDe(cfg); setD(dg); setRfcGuardado(dg.rfc || ""); } }
    catch(e){ console.warn("datos de empresa:", e); }
    finally { if (!cancel) setCargando(false); }
  })(); return ()=>{ cancel=true; }; }, [currentUser?.uid]);

  const set = (k: keyof DatosPatron, v:string) => { setTocado(true); setMsg(null); setD(prev=>({...prev, [k]: v})); };
  const faltan = CAMPOS_PATRON.filter(c => c.obligatorio && !String((d as any)[c.k]||"").trim());

  const guardar = async () => {
    if (!currentUser?.uid) return;
    if (faltan.length) { setMsg({ok:false, t:`Falta ${faltan.map(f=>f.etiqueta.toLowerCase()).join(", ")}.`}); return; }
    const nuevos = datosPatronDe(d);
    // EL RFC (13-oct-2026): sin espacios y en mayúsculas, y la MISMA validación (función
    // y texto) que el catálogo de razones sociales: forma, y longitud según el tipo.
    nuevos.rfc = normalizarRfc(d.rfc);
    const errRfc = errorDeRfc(nuevos.rfc, nuevos.tipoPersona);
    if (errRfc) { setMsg({ok:false, t: errRfc}); return; }
    if (rfcCambiaElGuardado(rfcGuardado, nuevos.rfc) && !window.confirm(TEXTO_CAMBIO_RFC_PRINCIPAL)) return;
    setGuardando(true); setMsg(null);
    try {
      // merge: aquí vive también el horario general, y guardar los datos de la
      // empresa no puede borrarlo.
      await setDoc(doc(db, COL_CONFIG_EMPRESA, currentUser.uid), {
        ...nuevos, actualizadoEn: serverTimestamp(),
      }, {merge:true});
      setTocado(false); setRfcGuardado(nuevos.rfc || "");
      // Se queda lleno con lo guardado: ya no es trabajo que perder.
      try { marcarCamposComoGuardados(document.querySelector("[data-datos-empresa]")); } catch (_e) {}
      setMsg({ok:true, t:"Guardado. Tus documentos ya pueden emitirse."});
      if (onGuardado) { try { onGuardado(); } catch(e){} }
    } catch(e:any){
      console.error("guardar datos de empresa:", e);
      setMsg({ok:false, t: mensajeDeFallo(e, {accion:"guardar los datos de la empresa", denegado: denegadoPatron("guardar los datos de la empresa")})});
    } finally { setGuardando(false); }
  };

  const lbl = {display:"block", fontSize:11, fontWeight:700, color:T_LIGHT.textInkSoft, marginBottom:5} as const;
  const inp = {width:"100%", boxSizing:"border-box" as const, padding:"10px 12px", borderRadius:9,
    border:`1px solid ${T_LIGHT.borderCard}`, fontSize:13.5, outline:"none", fontFamily:fontSans, background:"white", color:T_LIGHT.textInk};
  const ayuda = {fontSize:11, color:T_LIGHT.textInkMut, marginTop:4, lineHeight:1.5} as const;
  const campo = (k: keyof DatosPatron, etiqueta:string, ph:string, help?:string, ancho?:string) => (
    <div style={{gridColumn: ancho || "auto"}}>
      <label style={lbl}>{etiqueta}{CAMPOS_PATRON.find(c=>c.k===k)?.obligatorio ? <span style={{color:"#C2410C"}}> *</span> : null}</label>
      <input value={(d as any)[k]} onChange={e=>set(k, e.target.value)} placeholder={ph} style={inp}/>
      {help && <div style={ayuda}>{help}</div>}
    </div>
  );

  return (
    <div {...ZONA_DE_CAPTURA} data-datos-empresa="1" style={{maxWidth:ANCHO_CONTENIDO, margin:"0 auto", padding:isMobile?"4px 0 40px":"8px 0 60px"}}>
      <div style={{marginBottom:16}}>
        <h1 style={{fontFamily:fontSerif, fontSize:isMobile?22:26, fontWeight:700, color:"#0B1829", margin:"0 0 4px"}}>Datos de tu empresa</h1>
        <p style={{fontSize:13, color:"#4A4A60", margin:0, maxWidth:680, lineHeight:1.55}}>
          Es con lo que la plataforma te nombra en todo lo que firmas con tus trabajadores: recibos de nómina, bitácoras de asistencia,
          {" "}actas, constancias y tu aviso de privacidad. Se capturan una vez.
        </p>
      </div>

      {cargando ? (
        <div style={{fontSize:13, color:T_LIGHT.textInkMut, padding:"18px 0"}}>Cargando…</div>
      ) : (
        <div style={{background:"white", border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:14, padding:isMobile?"16px 16px":"20px 24px", boxShadow:T_LIGHT.shadow, maxWidth:820}}>
          <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr":"1fr 1fr", gap:14}}>
            {campo("denominacion", "Nombre o razón social de la empresa", "Ej. Transportes del Centro, S.A. de C.V.",
              "Como aparece en tu acta constitutiva o en tu constancia de situación fiscal. Si eres persona física, tu nombre completo.",
              isMobile?"auto":"1 / -1")}
            {campo("rfc", "RFC de la empresa", "Ej. TCE0101019A8",
              "El RFC con el que facturas y con el que apareces ante el IMSS.")}
            {/* NO es un campo de texto: son dos opciones, y ninguna marcada de
                salida. Media docena de contratos declaran que una parte es
                persona física; sin este dato el prellenado metía una razón
                social en esa declaración. */}
            <div>
              <label style={lbl}>¿Tu empresa es persona física o persona moral?<span style={{color:"#C2410C"}}> *</span></label>
              <div style={{display:"flex", gap:16, flexWrap:"wrap" as const, padding:"9px 0 2px"}}>
                {([["fisica","Persona física"],["moral","Persona moral"]] as const).map(([v,txt])=>(
                  <label key={v} style={{display:"flex", alignItems:"center", gap:7, cursor:"pointer", fontSize:13.5, color:T_LIGHT.textInk, fontFamily:fontSans}}>
                    <input type="radio" checked={d.tipoPersona===v} onChange={()=>set("tipoPersona", v)}
                      style={{width:16, height:16, accentColor:"#B8932A", cursor:"pointer"}}/>
                    {txt}
                  </label>
                ))}
              </div>
              <div style={ayuda}>
                Persona moral es una sociedad —S.A. de C.V., S. de R.L.—; persona física eres tú con tu nombre y tu RFC.
                {" "}Los contratos que generes declaran una cosa o la otra, y de esto depende cuál.
              </div>
            </div>
            {campo("correoContacto", "Correo de contacto para tus trabajadores", "correo@tuempresa.com",
              "Aquí te van a escribir si quieren acceder, corregir o cancelar sus datos personales. Puede ser el mismo con el que entras a la plataforma.")}
          </div>

          <div style={{borderTop:`1px solid ${T_LIGHT.borderCard}`, marginTop:20, paddingTop:16}}>
            <div style={{fontFamily:fontSerif, fontSize:15, fontWeight:700, color:"#0B1829", marginBottom:3}}>Domicilio</div>
            <div style={{fontSize:11.5, color:T_LIGHT.textInkMut, marginBottom:13, lineHeight:1.5, maxWidth:640}}>
              El domicilio fiscal o el de tu centro de trabajo. Se imprime completo en los documentos que firmas con tus trabajadores.
            </div>
            <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr":"2fr 1fr", gap:14}}>
              {campo("domCalle", "Calle y número", "Ej. Av. Aguascalientes Sur 1250")}
              {campo("domColonia", "Colonia", "Ej. Jardines de Aguascalientes")}
              {campo("domMunicipio", "Municipio o alcaldía", "Ej. Aguascalientes")}
              {campo("domEstado", "Estado", "Ej. Aguascalientes")}
              {campo("domCP", "Código postal", "Ej. 20270")}
            </div>
          </div>

          <div style={{display:"flex", alignItems:"center", gap:12, flexWrap:"wrap" as const, marginTop:20}}>
            <button onClick={guardar} disabled={guardando}
              style={{background:guardando?"rgba(0,0,0,0.08)":"#B8932A", border:"none", borderRadius:10, padding:"11px 22px",
                cursor:guardando?"wait":"pointer", fontSize:13, fontWeight:800, color:guardando?"#9A9AAA":"#0B1829", fontFamily:fontSans}}>
              {guardando ? "Guardando…" : "Guardar"}
            </button>
            {/* QUÉ FALTA, mientras se captura. No se esconde el botón: se dice. */}
            {faltan.length > 0 && (
              <span style={{fontSize:12, color:T_LIGHT.textInkMut}}>
                Falta{faltan.length===1?"":"n"} {faltan.length} campo{faltan.length===1?"":"s"} obligatorio{faltan.length===1?"":"s"}
              </span>
            )}
            {faltan.length === 0 && !tocado && !msg && (
              <span style={{fontSize:12, fontWeight:700, color:"#059669"}}>Completo</span>
            )}
            {msg && (
              <span style={{fontSize:12.5, fontWeight:700, color: msg.ok ? "#059669" : "#DC2626"}}>{msg.t}</span>
            )}
          </div>
          <div style={{fontSize:11, color:T_LIGHT.textInkMut, marginTop:10, lineHeight:1.5, maxWidth:680}}>
            Tus trabajadores pueden ver estos datos: ya aparecen en su contrato y en su aviso de privacidad. El resto de la plataforma
            {" "}funciona sin ellos; solo los documentos que se firman los necesitan.
          </div>
          {/* LAS DEMÁS RAZONES SOCIALES DE ESTA CUENTA (11-oct-2026). */}
          <RazonesSocialesEmpresa currentUser={currentUser} fontSans={fontSans}/>
        </div>
      )}
    </div>
  );
}

// ═══ LA REGLA DEL HORARIO ════════════════════════════════════════════════════
// EL HORARIO GENERAL RIGE PARA TODOS —los ya registrados y los que entren—
// SALVO QUE LA PERSONA TENGA UNO PROPIO, QUE LO SUSTITUYE. Una sola frase, y
// esta es la única función que la aplica.
//
// SE RESUELVE AL LEER, NO SE COPIA. Antes el general se COPIABA a cada ficha
// —campo `horarioEfectivo`— en el momento de guardarlo, así que quien se diera de
// alta después nunca recibía la copia: para el checador no tenía horario, no
// aparecía en "no han checado hoy" aunque faltara, y su propia ficha le pedía
// configurar un horario que el interruptor de al lado decía que ya heredaba. Un
// valor derivado se deriva; copiarlo es exactamente cómo se separa de su fuente.
//
// `horarioPropio.activo` es lo que distingue "esto es suyo" de "esto es el
// general": ya existía, y por eso NO hay que migrar ninguna ficha.
//
// `horarioVigente` YA NO VIVE AQUÍ: se importa de src/logica/checador.js, que es
// la que usa también el aviso del servidor. La bitácora llegó a imprimir 15 min
// de tolerancia y umbral 30 mientras la pantalla del trabajador decía 0: cada
// sitio partía de una ficha distinta. Ahora la función es una, propio si está
// activo y COMPLETO, general si no, con los mismos valores por omisión.
// ¿Se puede saber a qué hora entra esta persona? Es la pregunta que hacían las
// seis lecturas, cada una a su manera y todas sobre la copia.
function tieneHorarioVigente(empleado: any, horarioGeneral: any): boolean {
  const h = horarioVigente(empleado, horarioGeneral);
  return !!(h && h.entrada);
}
// FICHAS AMBIGUAS. Una ficha guardada antes de que existiera `horarioPropio`
// pudo dejar su horario personalizado SOLO en la copia. Al resolver al leer,
// esa persona pasaría en silencio a heredar el general. No se adivina: se
// listan para que alguien las mire. Si la lista sale vacía, no había ninguna.
function fichasConHorarioAmbiguo(empleados: any[], horarioGeneral: any): any[] {
  const mismo = (a:any, b:any) => !!a && !!b && a.entrada === b.entrada && a.salida === b.salida;
  return (empleados||[]).filter((e:any) => {
    if (e?.horarioPropio) return false;              // ya está declarado, no hay duda
    const copia = e?.horarioEfectivo;
    if (!copia || !copia.entrada) return false;      // sin copia no hay nada que perder
    return !mismo(copia, horarioGeneral);            // difiere del general: era suyo
  });
}

// ═══ ¿ESTA PERSONA DEBÍA CHECAR HOY Y NO LO HA HECHO? ════════════════════════
// UNA función, y las TRES vistas que responden esa pregunta la llaman: el aviso
// de Inicio, la fila de la lista de Empleados y la ficha individual.
//
// Antes eran tres criterios distintos sobre el mismo hecho. El aviso miraba
// cuenta y horario pero NO el día ni la hora —habría nombrado a medio equipo un
// sábado—. La ficha no miraba nada: decía "sin checada hoy" de cualquiera, sin
// cuenta y en domingo. Y la fila no calculaba: pintaba una lista que el aviso le
// pasaba al navegar, así que solo marcaba si habías llegado por ahí. Si las tres
// señalan a personas distintas, ninguna de las tres es confiable.
//
// LAS CUATRO CONDICIONES SE COMPRUEBAN AQUÍ DENTRO, no repartidas. Si falla
// cualquiera, no se marca. Y la ausencia de dato NO es una falta: sin horario que
// resolver no se marca nada, igual que no se marca a las siete de la mañana ni en
// el día de descanso de esa persona.
// La función vive en src/logica/checador.js (debiaChecarHoy, sobre la base
// debeChecarEnFecha), y también correosConCuentaActiva y correosQueChecaronHoy: la
// MISMA que usa el servidor. "Hoy" se decide en hora de México.

// ── LOS TRES HECHOS DEL EQUIPO ───────────────────────────────────────────────
// UNA sola función para escritorio y app. Antes cada pantalla calculaba y
// redactaba lo suyo, y por eso llegaron a contradecirse en el mismo dato: el
// escritorio decía "1 de 11 expedientes con datos capturados" mientras la app
// decía "Documental 100% · Expedientes al día". Si las dos leen de aquí, no
// pueden discrepar.
//
// Devuelve el HECHO y su redacción, no un porcentaje: con pocos datos un
// promedio miente en las dos direcciones. Y ningún renglón se pinta en rojo por
// ausencia de dato — no capturar un expediente no es un incumplimiento.
type HechoEquipo = {
  k: "exp"|"act"|"che";
  color: string;          // punto: vivo para gráficos
  texto: string;
  detalle: string;
  tono: string;           // color del detalle: oscuro para texto
  destino: "empleados"|"tareas"|"sin_checar"|"horario"|null;   // null = no lleva a ninguna parte
  // Correos de quienes no han checado hoy. El destino "sin_checar" lleva a la
  // lista de Equipo FILTRADA a estas personas: un número que te manda a buscar
  // entre once fichas no sirve de nada.
  emails?: string[];
};
// LOS ARGUMENTOS SON OBLIGATORIOS, Y ES A PROPÓSITO. Cuando `horarioGeneral` y
// `cuentasTrab` eran opcionales, una pantalla que se olvidaba de pasarlos no
// fallaba: recibía `undefined`, lo trataba como "vacío" y AFIRMABA que nadie del
// equipo tenía cuenta para checar, con el feed de la misma pantalla diciendo lo
// contrario dos centímetros más abajo. Un cable suelto no puede ser un fallo
// mudo en ejecución: siendo obligatorios, el compilador lo caza antes.
//
// `cuentasTrab` en NULL significa "todavía no se han podido leer", que NO es lo
// mismo que "no hay ninguna". La lista vacía sí afirma; el null se calla.
function hechosDelEquipo(
  empleados: any[], tareasPatron: any[], checadasPatron: any[],
  totalEmpleados: number, empleadosEvaluados: number, horarioGeneral: any, cuentasTrab: any[]|null,
  historialGeneral: any, registrosVacaciones: any[]|null,
): HechoEquipo[] {
  const d0 = new Date();
  const iso = (d:Date)=> `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`;
  const hoyISO = iso(d0);
  const en7 = new Date(d0); en7.setDate(en7.getDate()+7);
  const en7ISO = iso(en7);

  // EXPEDIENTES — proporción, no promedio. Ámbar solo si de verdad falta
  // capturar; nunca rojo: no subir un archivo no pone a nadie en falta.
  const faltanExp = Math.max(0, totalEmpleados - empleadosEvaluados);

  // ACTIVIDADES — pendientes REALES contra su fecha límite, no un promedio del
  // mes. Solo las de empleados activos.
  const act = tareasDeActivos(tareasPatron, empleados)
    .filter((x:any)=> x.estado === "pendiente" && x.fechaLimite);
  const actVencidas = act.filter((x:any)=> x.fechaLimite < hoyISO).length;
  const actProximas = act.filter((x:any)=> x.fechaLimite >= hoyISO && x.fechaLimite <= en7ISO).length;

  // CHECADOR — la respuesta sale de `debiaChecarHoy`, la MISMA función que usan
  // la fila de la lista y la ficha. Aquí no se comprueba nada por separado: si
  // este bloque volviera a tener su propio criterio, las tres pantallas podrían
  // volver a señalar a personas distintas, que es de donde venimos.
  //
  // La cuenta se DERIVA de `cuentas_trabajador`. Antes se leía la bandera
  // `tieneAcceso` de la ficha, que solo escriben las rutas que crean la cuenta
  // desde la app: faltaba en las cuentas anteriores a esa bandera y en las que se
  // crearon aparte de su ficha, así que había gente con cuenta real a la que el
  // checador no veía.
  //
  // Escalera de tres peldaños, porque las tres situaciones son distintas y
  // ninguna de las dos primeras es un incumplimiento:
  //   1) Nadie tiene cuenta  → no hay quien pueda checar.
  //   2) Hay cuentas, ningún horario → no hay contra qué comparar la hora.
  //   3) Hoy no es día laborable para nadie → tampoco hay nada que exigir.
  const activos = (empleados||[]).filter((e:any)=> (e.status||"activo")!=="baja" && (e.email||"").trim());
  // LA RED POR DEBAJO. Sin la colección leída no se puede afirmar nada sobre
  // quién tiene cuenta, y la ausencia de un dato no es un hecho.
  const cuentasCargadas = Array.isArray(cuentasTrab);
  const conCuentaSet = correosConCuentaActiva(cuentasTrab||[]);
  // "Hoy" en hora de México, no en la del navegador (13-oct-2026).
  const checaronHoy = correosQueChecaronHoy(checadasPatron||[], d0, enHoraDeMexico);
  const evaluados = activos.map((e:any)=> ({e, r: debiaChecarHoy({
    empleado:e, horarioGeneral, historialGeneral, correosConCuenta:conCuentaSet, checadasHoy:checaronHoy,
    registrosVacaciones: registrosVacaciones || [], instante:d0})}));
  // Quien hoy está fuera de su relación laboral (ingreso futuro, baja pasada) no
  // es del equipo de hoy: ni cuenta ni entra en "N de M".
  const conCuenta = evaluados.filter((x:any)=> x.r.motivo !== "sin_cuenta" && x.r.motivo !== "fuera_de_periodo");
  // De vacaciones o en día de descanso obligatorio (art. 74) hoy no le toca: no
  // entra en "N de M han checado" (13-oct-2026).
  const noLeToca = (x:any)=> x.r.motivo === "vacaciones" || x.r.motivo === "descanso_obligatorio";
  const conHorario = conCuenta.filter((x:any)=> x.r.motivo !== "sin_horario" && !noLeToca(x));
  const descansoObligatorioHoy = conCuenta.some((x:any)=> x.r.motivo === "descanso_obligatorio");
  const sinChecarLista = evaluados.filter((x:any)=> x.r.marca).map((x:any)=> x.e);
  const sinChecar = sinChecarLista.length;
  const sinCuentas = conCuenta.length === 0;
  const hoyNadieTieneQueChecar = conHorario.length === 0 && conCuenta.some(noLeToca);
  const sinHorarios = conHorario.length === 0 && !hoyNadieTieneQueChecar;
  // HOY NO ES DÍA LABORABLE PARA NADIE. No es que nadie falte: es que a nadie le
  // tocaba. Sin decirlo, el aviso desaparecería en sábado y parecería roto.
  const nadieLaboraHoy = conHorario.length > 0 && conHorario.every((x:any)=> x.r.motivo === "no_laborable");
  // Y TODAVÍA NO LES TOCA: a las siete de la mañana nadie ha faltado a nada.
  const aunNoTocaANadie = conHorario.length > 0 && !nadieLaboraHoy
    && conHorario.filter((x:any)=> x.r.motivo !== "no_laborable").every((x:any)=> x.r.motivo === "aun_no_toca");
  // Con tres o menos se nombran: "Ana, Luis y Marta no han checado hoy" dice más
  // que un número y evita el viaje a buscar quiénes son.
  const nombresSinChecar = sinChecarLista.map((e:any)=> String(e.nombre||e.email||"").split(" ")[0]).filter(Boolean);
  const listaNombres = nombresSinChecar.length <= 1 ? (nombresSinChecar[0]||"")
    : nombresSinChecar.slice(0,-1).join(", ") + " y " + nombresSinChecar[nombresSinChecar.length-1];

  return [
    {
      k: "exp",
      color: totalEmpleados === 0 ? UI.textoTenue : faltanExp > 0 ? UI.ambarVivo : UI.okVivo,
      texto: totalEmpleados === 0
        ? "Aún no das de alta empleados"
        : `${empleadosEvaluados} de ${totalEmpleados} expediente${totalEmpleados===1?"":"s"} con datos capturados`,
      detalle: totalEmpleados === 0 ? "" : faltanExp > 0 ? `faltan ${faltanExp} por capturar` : "completo",
      tono: faltanExp > 0 ? UI.ambar : UI.textoSuave,
      destino: totalEmpleados > 0 ? "empleados" : null,
    },
    {
      k: "act",
      color: actVencidas > 0 ? UI.rojoVivo : actProximas > 0 ? UI.ambarVivo : UI.textoTenue,
      texto: act.length === 0
        ? "Sin actividades pendientes"
        : actVencidas > 0
          ? `${actVencidas} actividad${actVencidas===1?"":"es"} vencida${actVencidas===1?"":"s"}`
          : `${actProximas} vence${actProximas===1?"":"n"} esta semana`,
      detalle: act.length === 0 ? ""
        : actVencidas > 0 && actProximas > 0
          ? `${actProximas} vence${actProximas===1?"":"n"} esta semana` : "",
      tono: actVencidas > 0 ? UI.rojo : UI.ambar,
      destino: act.length > 0 ? "tareas" : null,
    },
    {
      k: "che",
      // NINGUNO de los peldaños de ausencia va en ámbar: no poder checar, no
      // tocarle hoy o no haber llegado la hora no son faltas.
      color: (!cuentasCargadas || sinCuentas || sinHorarios || nadieLaboraHoy || hoyNadieTieneQueChecar || aunNoTocaANadie) ? UI.textoTenue
        : sinChecar > 0 ? UI.ambarVivo : UI.okVivo,
      // CADA AUSENCIA DICE POR QUÉ. Sin esto el aviso desaparecía en sábado y a
      // primera hora, y una pantalla que se queda en blanco sin explicarse se lee
      // como rota: el patrón no sabe si nadie faltó o si el checador no funciona.
      texto: !cuentasCargadas
        ? "Todavía no se puede saber quién ha checado hoy"
        : sinCuentas
        ? "Ningún trabajador tiene cuenta para checar"
        : sinHorarios
          ? "Configura los días laborables de tu equipo para ver quién ha checado"
          : nadieLaboraHoy
            ? "Hoy no es día laborable según el horario de tu equipo"
            : hoyNadieTieneQueChecar
              ? (descansoObligatorioHoy ? "Hoy es día de descanso obligatorio" : "Hoy nadie tiene que checar: están de vacaciones")
            : aunNoTocaANadie
              ? "Todavía no es la hora de entrada de nadie"
              : sinChecar === 0
                ? `${conHorario.length} de ${conHorario.length} han checado hoy`
                : nombresSinChecar.length <= 3
                  ? `${listaNombres} ${nombresSinChecar.length===1?"no ha":"no han"} checado hoy`
                  : `${sinChecar} de ${conHorario.length} no han checado hoy`,
      detalle: !cuentasCargadas ? "no se han podido leer las cuentas del equipo"
        : sinCuentas ? "no hay quien pueda checar"
        : sinHorarios ? "se hace una vez y aplica a todos"
        : nadieLaboraHoy ? "cámbialo si tu equipo trabaja hoy"
        : hoyNadieTieneQueChecar ? (descansoObligatorioHoy ? "art. 74 LFT" : "")
        : aunNoTocaANadie ? "nadie ha faltado a nada todavía" : "",
      tono: UI.textoSuave,
      // Cada peldaño lleva a donde se resuelve: sin horario o en día no laborable,
      // al horario general; con gente sin checar, a la lista.
      // Sin saber, no lleva a ninguna parte: no hay a quién ir a ver.
      destino: !cuentasCargadas ? null
        : (sinHorarios || nadieLaboraHoy) ? "horario"
        : sinChecar > 0 ? "sin_checar" : "empleados",
      emails: sinChecarLista.map((e:any)=> String(e.email||"").toLowerCase().trim()).filter(Boolean),
    },
  ];
}

// `referencia` existe para poder preguntar "¿cómo se veía esto a tal hora?" en la
// prueba. En la pantalla siempre es ahora.
function _alertasEmpleadoDashboard(t: any, referencia?: Date): {vencidos: number; porVencer: number} {
  let vencidos = 0, porVencer = 0;
  // Día contra día: el contrato vence un DÍA, no a una hora. Antes se comparaba
  // `new Date(cadena)` —medianoche UTC— contra el instante actual, y a partir de
  // las 18:00 hora de México un contrato que vencía mañana ya se contaba como
  // vencido en la tarjeta de Inicio.
  const dias = diasHastaFecha(t?.fechaVencimiento, referencia);
  if (dias !== null) {
    // VENCIDO EMPIEZA AL DÍA SIGUIENTE. Un contrato que termina hoy ampara hoy;
    // contarlo entre los vencidos era afirmar un incumplimiento el último día de
    // vigencia. Mismo criterio que los documentos del vehículo.
    if (dias < 0) vencidos++;
    else if (dias <= 30) porVencer++;
  }
  return {vencidos, porVencer};
}

// Helper: cuenta eventos del calendario en los próximos N días (pasados no
// cuentan — asumimos que ya se atendieron). Incluye eventos del usuario y
// las OBLIGACIONES_FIJAS si están dentro del rango.
function _eventosEnProximosDias(eventos: any[], dias: number): number {
  const hoy = new Date(); hoy.setHours(0,0,0,0);
  const hasta = new Date(hoy); hasta.setDate(hasta.getDate() + dias);
  let count = 0;
  eventos.forEach(e => {
    if (!e?.fecha || typeof e.fecha !== "string") return;
    try {
      const [y,m,d] = e.fecha.split("-").map(Number);
      const f = new Date(y, m-1, d);
      if (f >= hoy && f <= hasta) count++;
    } catch {}
  });
  return count;
}

type DashboardKpis = {
  cumplimientoEmpleados: number;   // 0-100
  // Sobre CUÁNTOS expedientes se sacó ese promedio. `calcularComplianceGlobal` ya
  // lo devolvía y el tablero lo tiraba: sin este dato la cifra no se puede
  // presentar honestamente, porque no dice de qué es promedio.
  empleadosEvaluados: number;
  // Flotilla en HECHOS, no en porcentaje: el promedio contaba una unidad sin
  // fechas capturadas como 0% de cumplimiento, que es afirmar un incumplimiento
  // a partir de un dato ausente. Estas dos cifras sí exigen una acción concreta.
  // Los CUATRO estados de `estadoFlota`, excluyentes y con su misma prioridad.
  vehiculosVencidos: number;
  vehiculosPorVencer: number;
  vehiculosSinRegistro: number;
  vehiculosEnRegla: number;
  cumplimientoVehiculos: number;   // 0-100
  alertasCriticas: number;         // total docs vencidos / contratos vencidos / proveedores 69-B
  porVencer30d: number;            // total próximos vencer en 30 días
  registrosActivos: {total:number; empleados:number; vehiculos:number; proveedores:number};
  hayEmpleados: boolean;           // para mostrar "—" en lugar de 0% cuando no hay datos
  hayVehiculos: boolean;
};

// Item de la lista "Requieren tu atención" (Fase 3B).
// Cruza vencimientos de todos los módulos en una sola lista priorizada.
// ═══ CUÁNDO FUE, ESCRITO IGUAL EN TODAS LAS SUPERFICIES ══════════════════════
//
// Este formato —"22-sep, 05:22 p. m."— ya existía: lo usa la campana de
// "Actividad de trabajadores". Estaba escrito a mano, con sus opciones repetidas,
// en dos sitios de `useDashboardData`. NO se escribe otro: se le pone nombre a ése
// y lo usan también el escudo, la tarjeta de Inicio y "Qué atender hoy" del móvil.
//
// Dos formas del MISMO formateador, no dos formateadores: las mismas opciones, con
// hora o sin ella. Un accidente ocurrió a una hora concreta y la hora importa; un
// documento vence un DÍA —en el papel no hay hora—, y pintarle "12:00 a. m." sería
// inventar una precisión que el dato no tiene.
//
// La zona horaria es la del aparato, que es la misma que ya usa la campana.
const _OPCIONES_CUANDO = {day:"2-digit", month:"short"} as const;
// Acepta lo que hay en los documentos: Timestamp de Firestore, Date, milisegundos
// o "AAAA-MM-DD". La cadena de solo fecha se arma con sus tres números —NO con
// `new Date("2026-09-22")`, que se lee como UTC y en México retrocede un día—.
function fechaDeCualquiera(v:any): Date|null {
  try {
    if (v === null || v === undefined || v === "") return null;
    if (typeof v?.toDate === "function") { const d = v.toDate(); return isNaN(d?.getTime?.()) ? null : d; }
    if (v instanceof Date) return isNaN(v.getTime()) ? null : v;
    if (typeof v === "number") { const d = new Date(v); return isNaN(d.getTime()) ? null : d; }
    if (typeof v === "string") {
      const m = v.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (m) return new Date(Number(m[1]), Number(m[2])-1, Number(m[3]));
      const d = new Date(v); return isNaN(d.getTime()) ? null : d;
    }
  } catch (e) { /* un dato ilegible no es una fecha */ }
  return null;
}
// Devuelve "" cuando no hay fecha legible. Quien pinta decide qué hacer con eso,
// pero NO puede inventarla: un renglón sin fecha se queda sin fecha, y hay una
// prueba que se pone roja si un renglón del escudo sale así.
function cuandoTexto(v:any, conHora:boolean = true): string {
  const d = fechaDeCualquiera(v);
  if (!d) return "";
  return d.toLocaleString("es-MX", conHora
    ? {..._OPCIONES_CUANDO, hour:"2-digit", minute:"2-digit"}
    : _OPCIONES_CUANDO);
}

type ItemAtencion = {
  id: string;
  modulo: AppPantalla;        // destino al hacer click
  moduloLabel: string;        // "Flotilla", "Empleados", etc.
  moduloIconName: string;     // nombre del SidebarIcon
  titulo: string;
  detalle: string;            // "vencido hace 5 días" / "vence hoy" / "vence en 3 días"
  dias: number;               // <0 vencido, 0 vence hoy (todavía vigente), >0 por vencer
  severidad: "vencido" | "porVencer";
  // A QUÉ apunta el renglón. Sin esto, pulsar un aviso solo podía abrir el
  // módulo: el usuario pulsaba una lista y obtenía otra lista de lo mismo.
  // `refId` es la entidad concreta; `refPadreId` el contenedor cuando hace falta
  // atravesar dos niveles (un crédito vive dentro del expediente de su deudor).
  refId?: string;
  refPadreId?: string;
  // CUÁNDO. El renglón decía "vence en 3 días" y nada más, y dos renglones del
  // mismo vehículo o del mismo trabajador salían idénticos sin forma de saber cuál
  // era cuál. Aquí va la fecha RELEVANTE de ese pendiente —la de vencimiento del
  // documento, del contrato o de la cuota—, tal como está guardada; el formato lo
  // pone `cuandoTexto` al pintar. Es opcional en el tipo porque los registros
  // viejos pueden no traerla, no porque un renglón nuevo pueda salir sin ella:
  // `prueba-atencion` se pone roja si alguno se queda sin fecha.
  fechaRef?: any;
};

// Correos de los empleados ACTIVOS (status !== "baja"; undefined = activo). Se usa para
// que los cumplimientos/contadores por ACTIVIDAD cuenten solo a empleados vigentes: las
// tareas se ligan al empleado por trabajadorEmail, así que hay que cruzar por correo.
const emailsActivos = (empleados:any[]) => new Set(
  (empleados||[]).filter((e:any)=> (e?.status||"activo")!=="baja")
    .map((e:any)=> (e?.email||"").toLowerCase().trim()).filter(Boolean)
);
// Actividades que pertenecen a empleados ACTIVOS (excluye las de dados de baja / sin dueño vigente).
const tareasDeActivos = (tareas:any[], empleados:any[]) => {
  const set = emailsActivos(empleados);
  return (tareas||[]).filter((t:any)=> set.has((t?.trabajadorEmail||"").toLowerCase().trim()));
};

// ═══ CUANDO CAMBIA ALGO QUE "REQUIEREN TU ATENCIÓN" LEE ══════════════════
//
// `atencionUrgente` se calculaba UNA vez, al cargar Inicio, y nadie lo volvía a
// calcular: se renovaba una verificación, el escudo seguía diciendo 5, y solo
// con F5 bajaba a 4. El dato se guardaba bien —eso está medido—; lo que faltaba
// era volver a preguntarlo.
//
// SE RESUELVE CON UN AVISO EXPLÍCITO, NO CON UNA ESCUCHA EN VIVO. Poner
// `onSnapshot` sobre las colecciones de `useDashboardData` sería catastrófico en
// costo: hoy lee tareas, checadas, flotilla y accidentes ENTERAS y sin `limit()`
// —ver la nota de esas consultas—, y en vivo eso se cobraría cada día en cada
// pestaña abierta. Un aviso solo cuesta cuando alguien escribe.
//
// MISMO IDIOMA que `avisos:abrir` y `axior:abrir`, pero EVENTO PROPIO: aquellos
// son ÓRDENES de abrir un panel y éste es un HECHO —"cambió algo que esa lista
// lee"—. Reutilizar el nombre mezclaría dos significados en un solo canal, y el
// día que alguien escuche uno recibiría el otro.
//
// SOLO DESDE LO QUE ESA LISTA MIRA: documentos de vehículo, contratos de
// empleado, cuotas de crédito, y las altas/bajas/reactivaciones que cambian
// quién está en esas listas. NO desde checadas, movimientos de flotilla ni
// actividades: no entran en `atencionUrgente` y solo provocarían lecturas de más.
// EL HORARIO GENERAL CAMBIÓ. La ficha (y el tablero, que alimenta a AXIOR) lo
// leían UNA vez al abrirse: si se guardaba desde el panel "Horario y ubicación de
// trabajo", seguían clasificando con el de antes hasta recargar la página. Ahora
// el editor lo avisa al guardar, y quien lo lee lo vuelve a leer.
const EVT_HORARIO_GENERAL_CAMBIO = "horario:general_cambio";
function avisarCambioDeHorarioGeneral() {
  try { window.dispatchEvent(new CustomEvent(EVT_HORARIO_GENERAL_CAMBIO)); } catch(e) {}
}
const EVT_ATENCION_CAMBIO = "atencion:datos_cambiaron";
function avisarCambioDeAtencion() {
  try { window.dispatchEvent(new CustomEvent(EVT_ATENCION_CAMBIO)); } catch(e) {}
}

function useDashboardData(currentUser: any) {
  const [loading, setLoading]       = useState(true);
  // RECARGA MANUAL. No cambia NADA de cómo se lee: `tick` entra en las
  // dependencias del efecto, así que subirlo vuelve a correr exactamente la misma
  // carga. Convertir esto a escucha en vivo es otra conversación.
  const [tick, setTick] = useState(0);
  // Y el aviso de arriba entra por la misma puerta: sube `tick`, se repite la
  // MISMA carga. Ni una consulta nueva, ni una suscripción.
  useEffect(() => {
    const alCambiar = () => setTick(x => x + 1);
    window.addEventListener(EVT_ATENCION_CAMBIO, alCambiar as any);
    window.addEventListener(EVT_HORARIO_GENERAL_CAMBIO, alCambiar as any);
    return () => { window.removeEventListener(EVT_ATENCION_CAMBIO, alCambiar as any); window.removeEventListener(EVT_HORARIO_GENERAL_CAMBIO, alCambiar as any); };
  }, []);
  // Bandera aparte de `loading`: si reusáramos esa, la pantalla se vaciaría a un
  // esqueleto en cada recarga. Aquí los datos viejos se quedan a la vista hasta
  // que llegan los nuevos.
  const [refrescando, setRefrescando] = useState(false);
  const [errorRefresco, setErrorRefresco] = useState(false);
  const [empleados, setEmpleados]   = useState<any[]>([]);
  // El horario general de la empresa viaja con el resto de la carga: las
  // pantallas que resuelven "qué horario rige para esta persona" lo necesitan, y
  // pedirlo por separado en cada una serían cuatro lecturas en vez de una.
  const [horarioGeneral, setHorarioGeneral] = useState<any>(null);
  // Su historial: con él se clasifican los días que ya pasaron (horarioQueRegia).
  const [historialGeneral, setHistorialGeneral] = useState<any>(null);
  // Las vacaciones registradas (cumplimiento_obligaciones, tipo "vacaciones"): quien
  // está de vacaciones hoy no "no ha checado" (13-oct-2026). null = no se pudieron leer.
  const [registrosVacaciones, setRegistrosVacaciones] = useState<any[]|null>(null);
  const [vehiculos, setVehiculos]   = useState<Vehiculo[]>([]);
  const [proveedores, setProveedores] = useState<any[]>([]);
  const [eventos, setEventos]       = useState<any[]>([]);
  // ── Créditos (módulo independiente — NO se mezcla con cumplimientos) ──
  const [creditos, setCreditos]     = useState<any[]>([]);
  const [deudores, setDeudores]     = useState<any[]>([]);
  const [clientes, setClientes]     = useState<any[]>([]);  // solo para el contador de la tira de registros
  // Actividades del patrón (para avisos de "por confirmar" en la campana).
  const [tareasPatron, setTareasPatron] = useState<any[]>([]);
  // Checadas del patrón (para "Actividad de trabajadores" en la campana).
  const [checadasPatron, setChecadasPatron] = useState<any[]>([]);
  // Registros de flotilla del patrón (para "Actividad de trabajadores").
  const [flotillaPatron, setFlotillaPatron] = useState<any[]>([]);
  // Accidentes registrados por trabajadores (para "Actividad de trabajadores").
  const [accidentesPatron, setAccidentesPatron] = useState<any[]>([]);
  // Las notas "no conforme" de su equipo sobre sus correcciones (fase 2b): un hecho
  // para la campana. Sin push al patrón.
  const [noConformesPatron, setNoConformesPatron] = useState<any[]>([]);
  // Y SUS CORRECCIONES (fase 2b): con ellas, lo que se CALIFICA es la vista
  // efectiva (`checadasEfectivas`, abajo). Lo que se cuenta como EVENTO —la campana,
  // la actividad— sigue siendo la checada tal como llegó.
  const [correccionesPatron, setCorreccionesPatron] = useState<any[]>([]);
  // CUENTAS DEL PORTAL DEL EQUIPO. Es la fuente de "quién puede checar", y hasta
  // ahora solo la cargaba el módulo Empleados: Inicio evaluaba sin ella y por eso
  // afirmaba que nadie tenía cuenta. Arranca en NULL —"aún no se sabe"—, y solo
  // pasa a ser una lista cuando la lectura sale bien. Vacío y desconocido no
  // pueden ser el mismo valor: uno se puede afirmar y el otro no.
  const [cuentasTrab, setCuentasTrab] = useState<any[]|null>(null);

  useEffect(() => {
    // Solo cargamos cuando hay sesión REAL (no anónima).
    if (!currentUser?.uid || currentUser.isAnonymous) {
      setEmpleados([]); setVehiculos([]); setProveedores([]); setEventos([]);
      setCreditos([]); setDeudores([]); setClientes([]); setTareasPatron([]); setChecadasPatron([]); setFlotillaPatron([]); setAccidentesPatron([]); setCuentasTrab(null);
      setLoading(false);
      return;
    }
    let cancelled = false;
    (async () => {
      // En la PRIMERA carga se muestra el esqueleto; en una recarga manual no, para
      // no borrar de la pantalla lo que el usuario ya estaba leyendo.
      if (tick === 0) setLoading(true); else { setRefrescando(true); setErrorRefresco(false); }
      try {
        const uid = currentUser.uid;
        const [snapE, snapV, snapP, snapEv, snapC, snapD, snapCl] = await Promise.all([
          getDocs(query(collection(db, "trabajadores"),       where("userId","==",uid))),
          getDocs(query(collection(db, "vehiculos"),          where("userId","==",uid))),
          getDocs(query(collection(db, "proveedores"),        where("userId","==",uid))),
          getDocs(query(collection(db, "eventos_calendario"), where("userId","==",uid))),
          getDocs(query(collection(db, "creditos"),           where("userId","==",uid))),
          getDocs(query(collection(db, "deudores"),           where("userId","==",uid))),
          getDocs(query(collection(db, "clientes"),           where("userId","==",uid))),
        ]);
        if (cancelled) return;
        setEmpleados(snapE.docs.map(d => ({id:d.id, ...d.data()})));
        setVehiculos(snapV.docs.map(d => ({id:d.id, ...d.data()} as Vehiculo)));
        setProveedores(snapP.docs.map(d => ({id:d.id, ...d.data()})));
        setEventos(snapEv.docs.map(d => ({id:d.id, ...d.data()})));
        setCreditos(snapC.docs.map(d => ({id:d.id, ...d.data()})));
        setDeudores(snapD.docs.map(d => ({id:d.id, ...d.data()})));
        setClientes(snapCl.docs.map(d => ({id:d.id, ...d.data()})));
        // Aparte del Promise.all de arriba: es un documento, no una colección, y
        // que falte no debe impedir que el tablero cargue.
        try { const cfg = await leerConfigEmpresa(uid); if (!cancelled) { setHorarioGeneral(cfg?.horarioLaboral || null); setHistorialGeneral(cfg?.historialHorario || null); } }
        catch(eC){ console.warn("configuracion_empresa:", eC); }
        // Aislado como el anterior: sin vacaciones leídas se sigue como antes de que
        // contaran (nadie aparece de vacaciones), y no se rompe el tablero.
        try {
          const snapVac = await getDocs(query(collection(db,"cumplimiento_obligaciones"), where("empleadorId","==",uid)));
          if (!cancelled) setRegistrosVacaciones(snapVac.docs.map((d:any)=> ({id:d.id, ...(d.data() as any)})).filter((x:any)=> x.tipo === "vacaciones"));
        } catch(eV){ console.warn("cumplimiento_obligaciones (vacaciones):", eV); }
        // Actividades + checadas del patrón — aislado: un fallo de permisos NO debe
        // romper el resto del dashboard/campana. Un where (empleadorId), filtra en JS.
        //
        // ⚠️ ESTAS CUATRO LECTURAS NO TIENEN `limit()` NI FILTRO DE FECHA, y se
        // hacen CADA VEZ que se abre Inicio. Se traen las colecciones ENTERAS
        // desde el primer día de la cuenta para calcular con ellas en memoria.
        //
        // Hoy, con doce empleados, no se nota. La cuenta de referencia genera del
        // orden de SESENTA registros diarios solo de checador —quince personas ×
        // entrada, comida, regreso y salida— más los movimientos de flotilla. A un
        // año de uso eso son miles de documentos leídos en cada visita a Inicio, y
        // en el plan Blaze cada lectura se cobra.
        //
        // Es la misma familia que la consulta pendiente de Nómina. Cuando se
        // atienda: acotar por fecha (el feed y la campana solo miran lo reciente),
        // o paginar, o precalcular los contadores. NO se arregla subiendo el tope
        // de lo que se pinta: lo que cuesta es lo que se lee, no lo que se enseña.
        try {
          const [snapT, snapCh, snapFl, snapAcc, snapCu] = await Promise.all([
            getDocs(query(collection(db, "tareas"),     where("empleadorId","==",uid))),
            getDocs(query(collection(db, "checadas"),   where("empleadorId","==",uid))),
            getDocs(query(collection(db, "flotilla"),   where("userId","==",uid))),
            getDocs(query(collection(db, "accidentes"), where("empleadorId","==",uid))),
            getDocs(query(collection(db, "cuentas_trabajador"), where("empleadorId","==",uid))),
          ]);
          if (!cancelled) {
            setTareasPatron(snapT.docs.map(d => ({id:d.id, ...d.data()})));
            setChecadasPatron(snapCh.docs.map(d => ({id:d.id, ...d.data()})));
            setFlotillaPatron(snapFl.docs.map(d => ({id:d.id, ...d.data()})));
            setAccidentesPatron(snapAcc.docs.map(d => ({id:d.id, ...d.data()})));
            setCuentasTrab(snapCu.docs.map(d => ({id:d.id, ...d.data()})));
          }
        } catch (eT) { console.warn("actividad trabajadores (campana):", eT); }
        try {
          const [snapNc, snapCo] = await Promise.all([
            getDocs(query(collection(db, "no_conformidades"), where("empleadorId","==",uid))),
            getDocs(query(collection(db, "correcciones_checadas"), where("empleadorId","==",uid))),
          ]);
          if (!cancelled) {
            setNoConformesPatron(snapNc.docs.map(d => ({id:d.id, ...d.data()})));
            setCorreccionesPatron(snapCo.docs.map(d => ({id:d.id, ...d.data()})));
          }
        } catch (eNc) { console.warn("correcciones y no conformidades (tablero):", eNc); }
      } catch (e) {
        console.error("useDashboardData:", e);
        if (!cancelled) setErrorRefresco(true);
      } finally {
        if (!cancelled) { setLoading(false); setRefrescando(false); }
      }
    })();
    return () => { cancelled = true; };
  }, [currentUser?.uid, currentUser?.isAnonymous, tick]);

  const kpis: DashboardKpis = useMemo(() => {
    const empAct = empleados.filter((t:any) => t.status === "activo");
    const vehAct = vehiculos.filter(v => (v.status || "activo") === "activo");

    // % cumplimiento — reutiliza helpers existentes
    const compEmp  = calcularComplianceGlobal(empAct);
    const kpisFlot = calcularKPIsFlotilla(vehAct);
    // Unidades (no documentos) que exigen acción documental. Se LEE
    // `calcularComplianceVehiculo`, no se modifica: lo consumen cuatro pantallas.
    // MISMA prioridad EXACTA que `estadoFlota` dentro de Flotilla: vencida gana a
    // por vencer, y por vencer gana a sin registro. Sin el escalón intermedio, una
    // unidad con un documento por vencer Y otro sin capturar se contaba aquí como
    // "sin registrar" y allá como "por vencer": las dos pantallas darían cifras
    // distintas del mismo parque vehicular.
    let vehiculosVencidos = 0, vehiculosPorVencer = 0, vehiculosSinRegistro = 0, vehiculosEnRegla = 0;
    vehAct.forEach(v => {
      const docs = calcularComplianceVehiculo(v).documentos;
      if (docs.some(d => d.estado === "vencido")) vehiculosVencidos++;
      else if (docs.some(d => d.estado === "por_vencer")) vehiculosPorVencer++;
      else if (docs.some(d => d.estado === "sin_registro")) vehiculosSinRegistro++;
      else vehiculosEnRegla++;
    });

    // Alertas críticas: vencidos en cada módulo.
    //
    // FUERA LOS PROVEEDORES 69-B: la validación se retiró a "Próximamente" —ver
    // `ProximamenteValidacion69B`— y ningún renglón rojo puede apuntar a una
    // pantalla que ya no está. `situacionEfos` sigue guardado en cada proveedor,
    // intacto; simplemente ya no se cuenta hasta que la revalidación exista.
    let alertasCriticas = 0;
    vehAct.forEach(v => {
      const docs = calcularComplianceVehiculo(v).documentos;
      alertasCriticas += docs.filter(d => d.estado === "vencido").length;
    });
    empAct.forEach((t:any) => {
      alertasCriticas += _alertasEmpleadoDashboard(t).vencidos;
    });

    // Por vencer en 30 días: por_vencer en cada módulo + eventos próximos
    let porVencer30d = 0;
    vehAct.forEach(v => {
      const docs = calcularComplianceVehiculo(v).documentos;
      porVencer30d += docs.filter(d => d.estado === "por_vencer").length;
    });
    empAct.forEach((t:any) => {
      porVencer30d += _alertasEmpleadoDashboard(t).porVencer;
    });
    porVencer30d += _eventosEnProximosDias(eventos, 30);

    return {
      cumplimientoEmpleados: compEmp.porcentaje,
      empleadosEvaluados: compEmp.evaluados,
      vehiculosVencidos,
      vehiculosPorVencer,
      vehiculosSinRegistro,
      vehiculosEnRegla,
      cumplimientoVehiculos: kpisFlot.cumplimientoPromedio,
      alertasCriticas,
      porVencer30d,
      registrosActivos: {
        total:       empAct.length + vehAct.length + proveedores.length,
        empleados:   empAct.length,
        vehiculos:   vehAct.length,
        proveedores: proveedores.length,
      },
      hayEmpleados: empAct.length > 0,
      hayVehiculos: vehAct.length > 0,
    };
  }, [empleados, vehiculos, proveedores, eventos]);

  // ── Lista "Requieren tu atención" (cross-módulos, priorizada) ────────
  const atencionUrgente: ItemAtencion[] = useMemo(() => {
    const items: ItemAtencion[] = [];
    const hoy = new Date(); hoy.setHours(0,0,0,0);

    // (1) Vehículos: cada doc vencido o por vencer (verificación, seguro, tarjeta)
    vehiculos.filter(v => (v.status||"activo")==="activo").forEach(v => {
      calcularComplianceVehiculo(v).documentos.forEach(d => {
        if (d.estado === "vencido" || d.estado === "por_vencer") {
          const detalle = textoDePlazo(d.dias);
          items.push({
            id: `veh:${v.id}:${d.key}`,
            modulo: "flotilla",
            moduloLabel: "Flotilla",
            moduloIconName: "flotilla",
            titulo: `${d.label} · ${v.placa}`,
            detalle,
            refId: v.id,
            // La fecha del propio documento: es la que vence o venció.
            fechaRef: d.fecha,
            dias: d.dias,
            severidad: d.estado === "vencido" ? "vencido" : "porVencer",
          });
        }
      });
    });

    // (2) Empleados: contratos vencidos o por vencer en ≤30 días
    empleados.filter((t:any)=>t.status==="activo").forEach((t:any) => {
      if (!t.fechaVencimiento) return;
      try {
        // Día contra día, con la misma función que Inicio y la ficha.
        const dias = diasHastaFecha(t.fechaVencimiento, hoy);
        if (dias === null) return;   // fecha ilegible: no es un plazo
        if (dias > 30) return;       // todavía no en rango de atención
        items.push({
          id: `emp:${t.id}:contrato`,
          modulo: "empleados",
          moduloLabel: "Empleados",
          moduloIconName: "empleados",
          titulo: `Contrato · ${t.nombre}`,
          detalle: textoDePlazo(dias),
          refId: t.id,
          fechaRef: t.fechaVencimiento,
          dias,
          // El contrato que termina HOY todavía ampara hoy: vencido empieza
          // mañana. Mismo criterio que los documentos del vehículo.
          severidad: dias < 0 ? "vencido" : "porVencer",
        });
      } catch {}
    });

    // (3) PROVEEDORES 69-B — RETIRADO. La validación pasó a "Próximamente" (ver
    //     `ProximamenteValidacion69B`): mientras la plataforma no revalide sola
    //     lo ya guardado, no puede señalar a nadie como EFOS, y menos llevar a un
    //     módulo que ya no se monta. Los datos siguen en cada proveedor.
    //
    // (4) CALENDARIO — RETIRADO. Metía TODOS los eventos de los próximos 30 días,
    //     y un evento dentro de 29 días es AGENDA, no urgencia: mantenía el
    //     contador inflado de forma permanente sin que hubiera nada que atender.
    //     Se comprobó antes de quitarlo que esa información tiene su propia casa:
    //     `CalendarioModulo` se monta desde el sidebar ("Calendario"), así que no
    //     se queda sin puerta. Los eventos no se pierden: cambian de sitio.

    // (5) Créditos: cuotas vencidas o próximas en ≤7 días.
    //     Iván: NO mezclar con cumplimientos de empleados/flotilla; pero SÍ
    //     aparecer en la lista global de atención, etiquetadas claramente
    //     como "Créditos · [nombre del deudor]" para que se distingan.
    //     Solo cuentan créditos activos (no liquidados ni incobrables).
    const deudorNombrePorId: Record<string,string> = {};
    deudores.forEach((d:any) => { if (d.id) deudorNombrePorId[d.id] = d.nombre || "Deudor"; });
    const hoyStr = `${hoy.getFullYear()}-${String(hoy.getMonth()+1).padStart(2,"0")}-${String(hoy.getDate()).padStart(2,"0")}`;
    creditos.filter((c:any) => c.estado !== "liquidado" && c.estado !== "incobrable").forEach((c:any) => {
      const nombreD = deudorNombrePorId[c.deudorId] || "Deudor";
      (c.tablaAmortizacion || []).forEach((cu:any) => {
        const pagada = (cu.montoPagado||0) >= (cu.cuota||0) - 0.005;
        if (pagada) return;
        const venc = cu.fechaVencimiento;
        if (!venc) return;
        // Diferencia en días: positivo = aún por vencer, negativo o cero = vencido
        let dias = 0;
        try {
          const [y,m,d] = venc.split("-").map(Number);
          const f = new Date(y, m-1, d);
          dias = Math.ceil((f.getTime() - hoy.getTime())/(1000*60*60*24));
        } catch { return; }
        const esVencida = venc < hoyStr;
        if (!esVencida && dias > 7) return;   // sólo próximas a ≤7d o vencidas
        const detalle = esVencida
          ? `vencido hace ${Math.abs(dias)} día${Math.abs(dias)!==1?"s":""}`
          : (dias === 0 ? "vence hoy" : `vence en ${dias} día${dias!==1?"s":""}`);
        items.push({
          id: `cred:${c.id}:${cu.numero}`,
          modulo: "creditos",
          moduloLabel: "Créditos",
          moduloIconName: "creditos",
          // El monto distingue dos créditos del MISMO deudor. Sin él, dos cuotas
          // "cuota 2" de créditos distintos se leen como un registro repetido, y
          // el modelo no tiene folio ni nombre de crédito que sirva de etiqueta.
          titulo: `Créditos · ${nombreD} · ${moneyMXN(Number(c.monto)||0)}`,
          detalle: `cuota ${cu.numero} ${detalle}`,
          refId: c.id,
          refPadreId: c.deudorId,
          // La fecha de vencimiento de ESA cuota, no la del crédito.
          fechaRef: venc,
          dias,
          severidad: esVencida ? "vencido" : "porVencer",
        });
      });
    });

    // NOTA: las actividades marcadas por confirmar y las checadas/flotilla NO van aquí
    // (Alertas) — viven en "Actividad de trabajadores" (ver memo `actividad`).

    // Ordenamiento: vencidos primero y, dentro de cada grupo, por `dias`
    // ascendente. Como `dias` es negativo en lo vencido, eso pone LO MÁS GRAVE
    // arriba; en lo por vencer, lo más próximo.
    //
    // Antes los vencidos iban al revés —"los recién vencidos antes de los muy
    // vencidos, más actionable"—, y eso escondía justo la cuota que determina el
    // estado jurídico del crédito: la más antigua sin pagar. La consecuencia era
    // que el resumen decía "2 en mora" mientras los renglones visibles marcaban 25
    // y 28 días, sin forma de reconciliarlo mirando la pantalla. La severidad manda
    // sobre la facilidad de cobro; ese otro criterio es un filtro del módulo de
    // Créditos, no el orden por defecto de la bandeja del patrón.
    items.sort((a, b) => {
      if (a.severidad !== b.severidad) return a.severidad === "vencido" ? -1 : 1;
      return a.dias - b.dias;
    });

    return items;
  }, [empleados, vehiculos, proveedores, eventos, creditos, deudores]);

  // ── KPIs de Créditos (INDEPENDIENTES — no se mezclan con cumplimientos) ──
  // Iván: empleados/vehículos tienen sus medidores de cumplimiento; créditos
  // tiene SU PROPIO medidor financiero. Tarjeta aparte en el dashboard.
  const kpisCreditos = useMemo(() => {
    // Se DERIVA el estado de cada crédito al leer. Antes se filtraba por el campo
    // guardado y bastaba con que nadie registrara un pago para que la pantalla
    // se quedara congelada en el estado del día en que se creó el crédito.
    const _hoyD = new Date();
    const _hoyStrD = `${_hoyD.getFullYear()}-${String(_hoyD.getMonth()+1).padStart(2,"0")}-${String(_hoyD.getDate()).padStart(2,"0")}`;
    const conEstado = creditos.map((c:any) => ({c, est: estadoCreditoDerivado(c, _hoyStrD)}));
    const activos = conEstado.filter(x => x.est !== "liquidado" && x.est !== "incobrable").map(x => x.c);
    // "En mora" y "atrasado" son AMBOS dinero vencido: los dos entran al saldo que
    // el patrón tiene que perseguir. La diferencia entre ellos es de gravedad, no
    // de si hay o no un incumplimiento.
    const creditosVencidos = conEstado.filter(x => x.est === "en_mora" || x.est === "atrasado");
    const creditosEnMora = conEstado.filter(x => x.est === "en_mora");
    const saldoEnMora = round2(creditosVencidos
      .reduce((s:number,x:any) => s + (Number(x.c.saldoTotal)||0), 0));
    const totalPrestadoVigente = round2(activos
      .reduce((s:number,c:any) => s + (Number(c.monto)||0), 0));

    // Cuotas vencidas (count) y próxima cuota más urgente
    const hoy = new Date(); hoy.setHours(0,0,0,0);
    const hoyStr = `${hoy.getFullYear()}-${String(hoy.getMonth()+1).padStart(2,"0")}-${String(hoy.getDate()).padStart(2,"0")}`;
    let cuotasVencidas = 0;
    let proximaCuota: {deudor: string; fecha: string; monto: number; dias: number} | null = null;
    const deudorNombrePorId: Record<string,string> = {};
    deudores.forEach((d:any) => { if (d.id) deudorNombrePorId[d.id] = d.nombre || "Deudor"; });
    activos.forEach((c:any) => {
      const nombreD = deudorNombrePorId[c.deudorId] || "Deudor";
      // Primera cuota no pagada (la más urgente del crédito)
      const primeraPendiente = (c.tablaAmortizacion || []).find((cu:any) =>
        (cu.montoPagado||0) < (cu.cuota||0) - 0.005);
      if (!primeraPendiente) return;
      let dias = 0;
      try {
        const [y,m,d] = primeraPendiente.fechaVencimiento.split("-").map(Number);
        const f = new Date(y, m-1, d);
        dias = Math.ceil((f.getTime() - hoy.getTime())/(1000*60*60*24));
      } catch {}
      // Contar todas las cuotas vencidas de este crédito (no solo la primera)
      (c.tablaAmortizacion || []).forEach((cu:any) => {
        const pagada = (cu.montoPagado||0) >= (cu.cuota||0) - 0.005;
        if (!pagada && cu.fechaVencimiento < hoyStr) cuotasVencidas++;
      });
      // Próxima cuota más urgente cross-créditos (fecha más antigua de pendientes)
      if (!proximaCuota || primeraPendiente.fechaVencimiento < proximaCuota.fecha) {
        proximaCuota = {
          deudor: nombreD,
          fecha: primeraPendiente.fechaVencimiento,
          monto: Number(primeraPendiente.cuota)||0,
          dias,
        };
      }
    });
    return {
      saldoEnMora,
      cuotasVencidas,
      totalPrestadoVigente,
      proximaCuota,
      hayCreditos: creditos.length > 0,
      totalCreditos: creditos.length,
      creditosActivos: activos.length,
      // Para la tira: cuántos están vencidos y cuántos ya pasaron de 30 días.
      creditosVencidos: creditosVencidos.length,
      creditosEnMora: creditosEnMora.length,
    };
  }, [creditos, deudores]);

  // Actividad de trabajadores (campana A): actividades marcadas por confirmar +
  // checadas recientes + registros de flotilla recientes. Todo filtrado/ordenado
  // EN JS sobre lo ya cargado (sin queries nuevas ni índices).
  const actividad = useMemo(() => {
    // El formato vive en `cuandoTexto`, que es el que reusan el escudo, la tarjeta
    // de Inicio y el móvil. Aquí se conserva el guion cuando no hay fecha, que es
    // lo que esta campana pintaba desde siempre.
    const fmt = (ts:any) => cuandoTexto(ts) || "—";
    const tareas = tareasPatron
      .filter((t:any)=>t.marcadaPorTrabajador===true && !t.confirmadaPorPatron)
      .map((t:any)=>({ id:`tarea:${t.id}`, nombre:t.trabajadorNombre||t.trabajadorEmail||"Trabajador", titulo:t.titulo||"Actividad", ms:t.fechaMarcada?.toMillis?.()||0 }))
      .sort((a:any,b:any)=>b.ms-a.ms);
    const checadas = checadasPatron
      .map((c:any)=>({ id:`chk:${c.id}`, nombre:c.trabajadorNombre||c.trabajadorEmail||"Trabajador", tipo:c.tipo, label:labelChecada(c.tipo), esLlegada:esLlegadaChecada(c.tipo), ms:c.timestamp?.toMillis?.()||0, cuando:fmt(c.timestamp) }))
      .sort((a:any,b:any)=>b.ms-a.ms).slice(0,6);
    // Solo los registros hechos por TRABAJADORES son avisos. Se identifican por el
    // campo de identidad registradoPorRol (antes por la bandera anonima).
    const flotilla = flotillaPatron
      .filter((f:any)=> f.registradoPorRol==="trabajador" || f.registradoPorConductor===true)
      .map((f:any)=>({ id:`flo:${f.id}`, nombre:f.conductorNombre||f.conductor||"Trabajador", placa:f.placa||"vehículo", tipo:f.tipo==="regreso"?"regreso":"salida", ms:f.timestamp?.toMillis?.()||0, cuando:f.timestamp?.toDate?.()?fmt(f.timestamp):(f.fecha?`${f.fecha}${f.hora?` ${f.hora}`:""}`:"—") }))
      .sort((a:any,b:any)=>b.ms-a.ms).slice(0,8);
    // Accidentes registrados por trabajadores — son avisos IMPORTANTES (alerta).
    // NOTAS "NO CONFORME" de su equipo (fase 2b), con el nombre de la ficha.
    const nombreDeCorreo = (correo:any) => {
      const c = String(correo||"").toLowerCase().trim();
      const e = (empleados||[]).find((x:any)=> String(x.email||"").toLowerCase().trim() === c);
      return (e && e.nombre) || c || "Trabajador";
    };
    const noConformes = noConformesPatron
      .map((n:any)=>({ id:`nc:${n.id}`, nombre:nombreDeCorreo(n.trabajadorEmail), texto:String(n.comentario||"").trim().slice(0,90), ms:n.en?.toMillis?.()||0, cuando:fmt(n.en) }))
      .sort((a:any,b:any)=>b.ms-a.ms).slice(0,12);
    const accidentes = accidentesPatron
      .map((a:any)=>({ id:`acc:${a.id}`, nombre:a.trabajadorNombre||a.trabajadorEmail||"Trabajador", resumen:resumenDeAccidente(a).slice(0,70), ms:a.timestamp?.toMillis?.()||0, cuando:(a.fechaHechos||a.horaHechos)?`${a.fechaHechos||""}${a.horaHechos?` ${a.horaHechos}`:""}`.trim():(a.timestamp?.toDate?.()?fmt(a.timestamp):(a.fecha?`${a.fecha}${a.hora?` ${a.hora}`:""}`:"—")) }))
      .sort((a:any,b:any)=>b.ms-a.ms).slice(0,12);
    // Historial: últimos 30 eventos (actividades confirmadas + checadas + flotilla de
    // trabajadores), ordenados por fecha desc. Calculado en vivo (sin Firestore).
    const historial = [
      ...tareasPatron.filter((t:any)=>t.confirmadaPorPatron).map((t:any)=>({
        id:`htar:${t.id}`, tipo:"Actividad confirmada", nombre:t.trabajadorNombre||t.trabajadorEmail||"Trabajador",
        desc:t.titulo||"Actividad", ms:(t.fechaConfirmada?.toMillis?.()||t.creadoEn?.toMillis?.()||0),
      })),
      ...checadasPatron.map((c:any)=>({
        id:`hchk:${c.id}`, tipo:labelChecada(c.tipo), nombre:c.trabajadorNombre||c.trabajadorEmail||"Trabajador",
        desc:`Registró ${labelChecada(c.tipo).toLowerCase()}`, ms:(c.timestamp?.toMillis?.()||0),
      })),
      ...flotillaPatron.filter((f:any)=> f.registradoPorRol==="trabajador" || f.registradoPorConductor===true).map((f:any)=>({
        id:`hflo:${f.id}`, tipo:f.tipo==="regreso"?"Flotilla · Regreso":"Flotilla · Salida", nombre:f.conductorNombre||f.conductor||"Trabajador",
        desc:`${f.tipo==="regreso"?"Regreso":"Salida"} de ${f.placa||"vehículo"}`, ms:(f.timestamp?.toMillis?.()||0),
      })),
      ...accidentesPatron.map((a:any)=>({
        id:`hacc:${a.id}`, tipo:"Accidente", nombre:a.trabajadorNombre||a.trabajadorEmail||"Trabajador",
        desc:resumenDeAccidente(a).slice(0,80), ms:(a.timestamp?.toMillis?.()||0),
      })),
      ...noConformes.map((n:any)=>({ id:`h${n.id}`, tipo:"No conforme", nombre:n.nombre, desc:n.texto, ms:n.ms })),
    ].sort((a:any,b:any)=>b.ms-a.ms).slice(0,30)
     .map((e:any)=>({ ...e, cuando: cuandoTexto(e.ms) || "—" }));
    // ⚠️ AQUÍ SE DEVOLVÍA UN `count`, Y SE QUITÓ AUNQUE NO LO PINTABA NADIE.
    //
    // Era "actividades por confirmar + los últimos 8 movimientos + los últimos 12
    // accidentes". Dos de esos tres sumandos NUNCA BAJAN: las actividades esperan
    // un clic y los otros dos son recortes de una lista que siempre trae algo. Un
    // contador así no puede llegar a cero jamás.
    //
    // La campana no lo usaba —calcula el suyo contra la marca de `useMarcaVistas`,
    // y ahí está escrito por qué—, así que esto era un valor muerto. Pero un valor
    // muerto CON FORMA DE CONTADOR es peor que uno a secas: el día que alguien
    // quiera poner un número en una pestaña, éste estaba ahí, con el nombre
    // correcto y la trampa dentro. Se quita para que no exista la tentación.
    //
    // `total` se queda: lo usa el estado vacío del historial en `ActividadBell`.
    return { tareas, checadas, flotilla, accidentes, noConformes, historial, total: tareas.length+checadas.length+flotilla.length+accidentes.length+noConformes.length };
  }, [tareasPatron, checadasPatron, flotillaPatron, accidentesPatron, noConformesPatron, empleados]);

  // % de cumplimiento de ACTIVIDADES agregado (confirmadas / total) — aditivo, para el
  // medidor del portal del patrón. No altera lo demás que ya devuelve el hook.
  const cumplimientoTareas = useMemo(() => {
    // Solo actividades de empleados ACTIVOS (las de dados de baja NO cuentan en el %).
    const tareasAct = tareasDeActivos(tareasPatron, empleados);
    const total = tareasAct.length;
    if (!total) return 0;
    const confirmadas = tareasAct.filter((t:any)=>t.confirmadaPorPatron).length;
    return Math.round((confirmadas/total)*100);
  }, [tareasPatron, empleados]);

  // `refrescar` re-ejecuta la MISMA carga; no hay lectura nueva ni escucha viva.
  // ═══ LOS ACCIDENTES QUE REQUIEREN ATENCIÓN, CALCULADOS EN UN SOLO SITIO ════
  // La misma lista para el escudo del escritorio y "Qué atender hoy" del móvil: si
  // cada superficie filtrara por su cuenta, podrían no coincidir.
  //
  // NO VAN DENTRO DE `atencionUrgente`, y a propósito: esa lista es de PLAZOS —cada
  // renglón tiene días y severidad "vencido/por vencer", se pinta en el calendario
  // del móvil y alimenta el titular de AXIOR—. Un accidente no es un plazo: metido
  // ahí saldría con una insignia "hace 0d", contaría como "vencido" y aparecería
  // como fecha en el calendario. Va aparte, y el escudo lo pinta en su sección.
  //
  // Sin `useMemo` a propósito: es un filtro sobre una lista corta, y así no añade
  // un hook que dependa del orden de los de arriba. La ventana se evalúa al cargar
  // y al refrescar; la carga ya es así (`getDocs`, sin escucha viva).
  const accidentesPendientes = accidentesQueRequierenAtencion(accidentesPatron, Date.now());
  // LO QUE SE CALIFICA, después de las correcciones: la misma vista efectiva que la
  // ficha y los documentos (cada corrección lleva su checada o su persona, así que
  // sirve para todo el equipo a la vez).
  const checadasEfectivas = useMemo(
    () => vistaEfectiva({checadas: checadasPatron, correcciones: correccionesPatron}).checadasQueCuentan,
    [checadasPatron, correccionesPatron]);
  return { refrescar: ()=>setTick(x=>x+1), refrescando, errorRefresco, loading, empleados, vehiculos, proveedores, eventos, creditos, deudores, clientes, kpis, kpisCreditos, atencionUrgente, actividad, checadasEfectivas, correccionesPatron, noConformesPatron, cumplimientoTareas,
    // Colecciones crudas (ya cargadas arriba) para la bitácora del portal del patrón
    // móvil: traen TODOS los campos (comentario, destino/km, lugar) y sin truncar.
    checadasPatron, flotillaPatron, accidentesPatron, tareasPatron, horarioGeneral, historialGeneral, cuentasTrab,
    accidentesPendientes, registrosVacaciones };
}

// ── A DÓNDE LLEVA UNA FILA DEL FEED ───────────────────────────────────────
//
// DOS REGLAS QUE NO SE NEGOCIAN:
//
// 1) EL DESTINO SE DIRECCIONA POR ID. Viaja el id y nada más; la pantalla de
//    destino vuelve a leer el dato de su propia colección. Transportar el objeto
//    en la navegación haría que el feed enseñara una copia congelada de algo que
//    puede haber cambiado —o desaparecido— mientras la lista estaba en pantalla.
//
// 2) SI EL DESTINO YA NO EXISTE, LA FILA NO ES CLICABLE. No se lleva al módulo
//    "por si acaso": pulsar un hecho y aterrizar en una lista genérica es la
//    misma frustración que ya se corrigió en los avisos. Sin destino, la fila
//    sigue siendo lo que es —un hecho que ocurrió— y no finge ser un botón.
type DestinoFeed =
  | {modulo:"flotilla";  foco:"viaje"|"movimiento"|"accidente"; id:string}
  | {modulo:"empleados"; id:string; pestana:"datos"|"checador"|"documentos"|"contratos"}
  // La actividad se direcciona por SU id, no por la persona: la fila habla de
  // una actividad que ya existe, y llevar a "asignarle algo a fulano" era abrir
  // el formulario de crear otra.
  | {modulo:"tareas";    id:string};

// ── LAS CUATRO FAMILIAS DEL FEED ──────────────────────────────────────────
//
// No son los seis tipos de fila: son las cuatro cosas que una empresa distingue
// al mirar su día. Un accidente va con Flotilla —aparece dos veces al año y no
// justifica un control permanente, aunque su renglón sí se distinga a simple
// vista—, y un contrato y un documento son los dos "papeles del expediente":
// separarlos es una distinción nuestra, no de quien mira.
type FamiliaFeed = "flotilla"|"checador"|"actividades"|"expedientes";
const FAMILIAS_FEED: {k:FamiliaFeed; label:string}[] = [
  {k:"flotilla",    label:"Flotilla"},
  {k:"checador",    label:"Checador"},
  {k:"actividades", label:"Actividades"},
  {k:"expedientes", label:"Expedientes"},
];

// ── Microinteracción: cuenta animada de 0 al target con ease-out cúbico ──
function useCountUp(target: number, durationMs: number = 700, enabled: boolean = true): number {
  const [value, setValue] = useState(0);
  useEffect(() => {
    if (!enabled || target === 0) { setValue(target); return; }
    let raf = 0;
    const start = performance.now();
    const step = (now: number) => {
      const t = Math.min((now - start) / durationMs, 1);
      const eased = 1 - Math.pow(1 - t, 3);   // ease-out cubic
      setValue(Math.round(target * eased));
      if (t < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [target, durationMs, enabled]);
  return value;
}

// ── LOS CUATRO TIPOS DE CHECADA, Y QUÉ PUEDE VENIR DESPUÉS DE CADA UNO ─────
//
// La regla NO es "una entrada y una salida por día": quien sale a comer y vuelve
// tiene legítimamente varias marcas. Lo que no puede haber son DOS MOVIMIENTOS
// IGUALES SEGUIDOS sin el opuesto en medio. Alternancia, no cuota diaria.
//
// Vive aquí, fuera de la pantalla, porque de esto dependen dos cosas a la vez:
// lo que el checador ofrece al trabajador y lo que la bitácora imprime.
type TipoChecada = "entrada"|"salida_comer"|"regreso_comer"|"salida";
const TIPOS_CHECADA: TipoChecada[] = ["entrada","salida_comer","regreso_comer","salida"];
// EL ORDEN DE CADA LISTA IMPORTA: el primero es el que se SUGIERE. Los dos son
// transiciones válidas y ninguna advierte, pero la sugerencia tiene que apuntar a
// lo probable. Después de volver de comer lo que ocurre casi siempre es el fin de
// jornada; comer dos veces es rarísimo y no merece llevar el sello de "Te toca".
const SIGUIENTES_CHECADA: Record<TipoChecada, TipoChecada[]> = {
  entrada:       ["salida_comer","salida"],
  salida_comer:  ["regreso_comer"],
  regreso_comer: ["salida","salida_comer"],
  salida:        ["entrada"],          // reingreso el mismo día: legítimo
};
// El tipo que TOCA según la última marca del día. Sin marcas, empieza la jornada.
// El primero de la lista es el principal; los demás siguen disponibles.
function siguienteChecadaSugerida(ultimoTipo: TipoChecada | null): TipoChecada {
  if (!ultimoTipo) return "entrada";
  const opciones = SIGUIENTES_CHECADA[ultimoTipo];
  return (opciones && opciones[0]) || "entrada";
}
// LA CONSECUENCIA DE REGISTRAR `tipo` AHORA, dicha en palabras. Devuelve "" si
// es un movimiento que encaja: entonces no hay nada que advertir.
//
// No es un "¿estás seguro?": es lo que va a pasar si sigue adelante, para que el
// que se equivocó lo vea ANTES de guardar y el que de verdad necesita registrar
// algo raro pueda hacerlo. Nada se bloquea.
function _horaCortaChecada(d: Date): string {
  return d.toLocaleTimeString("es-MX",{hour:"2-digit",minute:"2-digit"}).replace(/\.\s*$/, "");
}
function consecuenciaDeChecar(tipo: TipoChecada, ultimoTipo: TipoChecada | null, ultimaHora: Date | null): string {
  if (!ultimoTipo) {
    if (tipo === "entrada") return "";
    return `Todavía no registras tu entrada de hoy. Si registras ${labelChecada(tipo).toLowerCase()}, el día quedará sin hora de entrada y la bitácora no podrá clasificarlo.`;
  }
  if ((SIGUIENTES_CHECADA[ultimoTipo] || []).indexOf(tipo) >= 0) return "";
  // `es-MX` escribe la hora como "07:00 p. m.", con punto final. Pegado a la
  // frase quedaba "…p. m.. Si registras otra": se le quita el punto propio para
  // que el de la oración sea el único.
  const hora = ultimaHora ? ` a las ${_horaCortaChecada(ultimaHora)}` : "";
  const laUltima = `Tu última marca de hoy fue ${_ARTICULO_CHECADA[ultimoTipo]} ${labelChecada(ultimoTipo).toLowerCase()}${hora}.`;
  if (tipo === ultimoTipo) {
    const plural = _PLURAL_CHECADA[tipo];
    return `${laUltima} Si registras otra, quedarán dos ${plural} seguidas y la bitácora lo va a señalar.`;
  }
  return `${laUltima} Registrar ${_ARTICULO_CHECADA[tipo]} ${labelChecada(tipo).toLowerCase()} ahora deja el día con marcas fuera de orden, y la bitácora lo va a señalar.`;
}
const _ARTICULO_CHECADA: Record<TipoChecada,string> = {
  entrada:"una", salida_comer:"una", regreso_comer:"un", salida:"una",
};
const _PLURAL_CHECADA: Record<TipoChecada,string> = {
  entrada:"entradas", salida_comer:"salidas a comer", regreso_comer:"regresos de comer", salida:"salidas",
};
// EL DOBLE TOQUE: la MISMA marca dos veces en menos de 2 minutos. Es lo único
// que el checador frena. Antes se negaba cualquier segunda marca del mismo tipo
// en el día, y eso dejaba sin registrar al que vuelve a entrar después de salir:
// un reingreso que SIGUIENTES_CHECADA declara legítimo.
//
// Se compara con la hora del TELÉFONO de cada marca (`horaDispositivo`), la del
// mismo reloj que da el "ahora". Una marca sin ella (las antiguas) cae a la hora
// oficial.
const DOBLE_TOQUE_MS = 2 * 60 * 1000;
// MIENTRAS SE REGISTRA UNA MARCA (la espera del GPS puede llegar a 10 s), otra no
// puede entrar. Antes se descartaba EN SILENCIO: "Registrar de todos modos" no
// hacía nada y nadie decía nada. Ahora se dice.
const TEXTO_CHECADA_EN_CURSO = "Todavía se está registrando tu marca anterior. Espera a que termine y vuelve a intentarlo.";
// CUENTA SUSPENDIDA (`activo: false` en cuentas_trabajador): no entra a la
// plataforma ni puede checar. Si la suspenden A MEDIA SESIÓN, el checador lo dice
// desde que se abre o al rechazarse una checada, y apaga los botones. Nunca un código.
const TEXTO_ACCESO_DESACTIVADO = "Tu cuenta está suspendida. Habla con tu patrón.";
// EL ESTADO, CON LAS MISMAS PALABRAS en la ficha, en "Cuentas de trabajador", en
// la lista de empleados y en el panel de administración. Y los dos botones.
const TEXTO_CUENTA_SUSPENDIDA = "Cuenta suspendida";
const BOTON_SUSPENDER_CUENTA = "Suspender cuenta";
const BOTON_REACTIVAR_CUENTA = "Reactivar cuenta";
// SUSPENDER PREGUNTA ANTES; REACTIVAR, NO. La misma pregunta en los dos sitios.
function textoConfirmarSuspension(nombre: string): string {
  return `${nombre} no podrá entrar a la plataforma ni checar mientras su cuenta esté suspendida. Sus registros se conservan y nadie puede borrarlos. Puedes reactivarla cuando quieras.`;
}
function ConfirmarSuspension({nombre, ocupado, onSuspender, onCancelar, fontSans}: {nombre:string; ocupado:boolean; onSuspender:()=>void; onCancelar:()=>void; fontSans:string}) {
  return (
    <div onClick={()=>{ if (!ocupado) onCancelar(); }} style={{position:"fixed" as const, inset:0, background:"rgba(15,23,42,0.55)", zIndex:3000, display:"flex", alignItems:"center", justifyContent:"center", padding:16, fontFamily:fontSans}}>
      <div role="dialog" aria-modal="true" onClick={e=>e.stopPropagation()} style={{background:"white", borderRadius:14, maxWidth:420, width:"100%", padding:"20px 22px", boxShadow:"0 20px 50px rgba(0,0,0,0.3)"}}>
        <div style={{fontSize:15, fontWeight:800, color:"#0B1829", marginBottom:8}}>{BOTON_SUSPENDER_CUENTA}</div>
        <p style={{fontSize:13, color:"#4A4A60", lineHeight:1.6, margin:"0 0 16px"}}>{textoConfirmarSuspension(nombre)}</p>
        <div style={{display:"flex", gap:8, justifyContent:"flex-end"}}>
          <button onClick={onCancelar} disabled={ocupado}
            style={{padding:"9px 16px", borderRadius:9, border:"1px solid rgba(15,23,42,0.18)", background:"white", color:"#0B1829", cursor:ocupado?"wait":"pointer", fontFamily:fontSans, fontSize:13, fontWeight:700}}>Cancelar</button>
          <button onClick={onSuspender} disabled={ocupado}
            style={{padding:"9px 16px", borderRadius:9, border:"none", background:"#B91C1C", color:"white", cursor:ocupado?"wait":"pointer", fontFamily:fontSans, fontSize:13, fontWeight:800}}>{ocupado ? "Suspendiendo…" : "Suspender"}</button>
        </div>
      </div>
    </div>
  );
}
function _msDelTelefonoDeChecada(c: any): number {
  const ms = Date.parse(String(c?.horaDispositivo || ""));
  return isFinite(ms) ? ms : msDeChecada(c);
}
function esDobleToque(tipo: TipoChecada, checadas: any[], ahoraMs: number): boolean {
  return (checadas || []).some((c: any) => c?.tipo === tipo && Math.abs(ahoraMs - _msDelTelefonoDeChecada(c)) < DOBLE_TOQUE_MS);
}
// UNA SEGUNDA MARCA DEL MISMO TIPO EN EL DÍA (volver a entrar, comer otra vez).
// Se registra, pero antes se dice qué hará la bitácora con ella: es el mismo
// aviso, con "Registrar de todos modos", que ya tienen las marcas fuera de orden.
// "" si es la primera de su tipo hoy.
function avisoDeSegundaMarca(tipo: TipoChecada, checadasDelDia: any[]): string {
  const previas = (checadasDelDia || []).filter((c: any) => c?.tipo === tipo)
    .sort((a: any, b: any) => msDeChecada(a) - msDeChecada(b));
  if (!previas.length) return "";
  const d = horaDeChecada(previas[0]);
  const hora = d ? ` a las ${_horaCortaChecada(d)}` : "";
  const queHara = tipo === "entrada" ? "la bitácora mostrará la primera y señalará que hubo dos"
    : tipo === "salida" ? "la bitácora mostrará la última y señalará que hubo dos"
    : "quedarán las dos en tu registro";
  return `Ya registraste ${_ARTICULO_CHECADA[tipo]} ${labelChecada(tipo).toLowerCase()} hoy${hora}. Si registras otra, ${queHara}.`;
}
// La HORA OFICIAL de una checada es la del servidor. `timestamp` es el respaldo
// de los registros antiguos; la del dispositivo nunca decide nada.
function horaDeChecada(c: any): Date | null {
  return c?.horaServidor?.toDate?.() || c?.timestamp?.toDate?.() || null;
}
function msDeChecada(c: any): number {
  return c?.horaServidor?.toMillis?.() || c?.timestamp?.toMillis?.() || 0;
}
// La ÚLTIMA marca de una lista de checadas ya acotada a una persona y un día.
// De aquí sale el estado en el que está esa persona ahora mismo.
function ultimaChecadaDe(checadasDelDia: any[]): {tipo: TipoChecada; cuando: Date|null} | null {
  const orden = (checadasDelDia||[])
    .filter((c:any)=> TIPOS_CHECADA.indexOf(c?.tipo) >= 0)
    .sort((a:any,b:any)=> msDeChecada(a) - msDeChecada(b));
  const u = orden[orden.length-1];
  return u ? {tipo: u.tipo as TipoChecada, cuando: horaDeChecada(u)} : null;
}
// CUÁNTAS ENTRADAS Y CUÁNTAS SALIDAS TIENE UN DÍA. El reporte se queda con una
// de cada —la entrada más temprana y la salida más tardía— y hasta ahora no
// decía que había descartado otras. Con las salidas eso desplazaba un dato; con
// las ENTRADAS borra un hecho, porque la entrada es la que clasifica el día: un
// doble toque a las 08:50 y 09:40 convertía un retardo en un día a tiempo, y ese
// conteo va impreso en el resumen.
//
// Sin umbral: no hay forma sostenible de decidir que dos marcas cercanas "son la
// misma". Si hubo dos, se dice.
function repeticionesDelDia(checadasDelDia: any[]): {entradas:number; salidas:number} {
  let entradas = 0, salidas = 0;
  (checadasDelDia||[]).forEach((c:any)=>{
    if (c?.tipo === "entrada") entradas++;
    else if (c?.tipo === "salida") salidas++;
  });
  return {entradas, salidas};
}
// La marca que se imprime en el renglón del día. "" cuando no hay nada que decir.
// Dice QUÉ HIZO el reporte, no solo que hubo repetición.
function notaRepeticionDia(rep: {entradas:number; salidas:number}): string {
  const partes: string[] = [];
  if (rep.entradas > 1) partes.push(`${rep.entradas} entradas registradas; se muestra la primera`);
  if (rep.salidas  > 1) partes.push(`${rep.salidas} salidas registradas; se muestra la última`);
  return partes.join(" · ");
}

// ── Etiqueta legible del tipo de checada ──────────────────────────────────
// Compartida por el portal del trabajador y las vistas del patrón (campana,
// expediente). Compatible con datos antiguos (tipo "entrada"/"salida").
function labelChecada(t: string): string {
  return t === "entrada"        ? "Entrada"
       : t === "salida_comer"   ? "Salida a comer"
       : t === "regreso_comer"  ? "Regreso de comer"
       : "Salida";
}
// ¿El tipo es una "llegada" (entrada / regreso de comer)? Para color semántico.
// Reduce los cuatro tipos a dos A PROPÓSITO, y solo para elegir un color: nunca
// para NOMBRAR la marca. El nombre lo da siempre `labelChecada`.
function esLlegadaChecada(t: string): boolean {
  return t === "entrada" || t === "regreso_comer";
}
// LO QUE HIZO LA PERSONA, en una frase, para las listas de actividad.
//
// Existe porque el feed de Inicio escribía su propia versión con un ternario
// —`tipo === "entrada" ? "checó entrada" : "checó salida"`— que aplastaba los
// cuatro tipos en dos y le ponía a uno el nombre de otro: un REGRESO DE COMER
// aparecía como "checó salida". Con eso en pantalla, tres marcas correctas
// —entrada, salida a comer, regreso de comer— se leían como dos salidas
// seguidas, y llegamos a diagnosticar un duplicado que nunca existió.
//
// Los cuatro tipos, cuatro frases, en un solo sitio. Si algún día se añade un
// quinto, esta tabla obliga a nombrarlo aquí en vez de dejar que caiga en el
// "si no es entrada, es salida" de turno.
function accionChecada(t: string): string {
  return t === "entrada"        ? "checó entrada"
       : t === "salida_comer"   ? "salió a comer"
       : t === "regreso_comer"  ? "regresó de comer"
       : "checó salida";
}

// ── Mapeo tone → color semántico ──────────────────────────────────────────
const TONE_COLORS: Record<string, string> = {
  ok:      "#059669",  // verde — saludable / sin pendientes
  warn:    "#D97706",  // ámbar — atención / por vencer
  alerta:  "#DC2626",  // rojo  — vencido / crítico
  neutral: "#B8932A",  // dorado — informativo
  muted:   "#9CA3AF",  // gris — sin datos
  // AVANCE, no salud: una barra que se está llenando. Se usa donde la cifra mide
  // cuánto llevas hecho y NO si estás en falta, así que nunca se pone en rojo.
  progreso:"#2F5FA8",
  // Ámbar quemado — lo MÁS urgente de lo que todavía está vigente: vence hoy o
  // en los próximos dos días. Se distingue del ámbar normal y NO es rojo,
  // porque nada de esto es todavía un incumplimiento.
  warnFuerte:"#B45309",
};
// EL TONO DE UN PLAZO, DECIDIDO EN UN SOLO SITIO.
//
// Cuatro pantallas lo resolvían por su cuenta con la misma expresión copiada
// —`severidad === "vencido" || dias <= 2`— y las cuatro pintaban de ROJO lo que
// vence hoy. Un documento que vence el 30 de septiembre ampara hasta el 30
// inclusive: el incumplimiento empieza el 1 de octubre. Vale igual para una
// póliza, una verificación y un contrato por tiempo determinado, y hasta hoy la
// plataforma afirmaba lo contrario justo el último día de vigencia.
//
// Tres estados, no dos: vencido (rojo), inminente —vence hoy o en dos días—
// (ámbar fuerte) y próximo (ámbar).
function tonoDePlazo(it: {severidad?: string; dias: number}): {clave:"vencido"|"inminente"|"proximo"; color:string; bgSuave:string; bgTinte:string; borde:string} {
  if (it.severidad === "vencido") {
    return {clave:"vencido", color:TONE_COLORS.alerta, bgSuave:"rgba(220,38,38,0.10)", bgTinte:"rgba(220,38,38,0.07)", borde:"rgba(220,38,38,0.30)"};
  }
  if (it.dias <= 2) {
    return {clave:"inminente", color:TONE_COLORS.warnFuerte, bgSuave:"rgba(180,83,9,0.12)", bgTinte:"rgba(180,83,9,0.08)", borde:"rgba(180,83,9,0.35)"};
  }
  return {clave:"proximo", color:TONE_COLORS.warn, bgSuave:"rgba(217,119,6,0.10)", bgTinte:"rgba(217,119,6,0.07)", borde:"rgba(217,119,6,0.30)"};
}
// Cómo se DICE un plazo. "vence en 0 días" no es una frase: es "vence hoy".
function textoDePlazo(dias: number): string {
  if (dias < 0) return `vencido hace ${Math.abs(dias)} día${Math.abs(dias)!==1?"s":""}`;
  if (dias === 0) return "vence hoy";
  return `vence en ${dias} día${dias!==1?"s":""}`;
}
function toneFromPct(pct: number, hasData: boolean): "ok"|"warn"|"alerta"|"muted" {
  if (!hasData)   return "muted";
  if (pct >= 90)  return "ok";
  if (pct >= 60)  return "warn";
  return "alerta";
}

// ── Íconos inline (14px, color hereda del padre vía currentColor) ─────────
const ICON_EMP = (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" style={{display:"block"}}><circle cx="9" cy="8" r="3.5" stroke="currentColor" strokeWidth="1.7"/><path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/><circle cx="18" cy="9" r="2.6" stroke="currentColor" strokeWidth="1.7"/><path d="M21 20c0-2.6-1.2-4.5-3-5.3" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/></svg>);
const ICON_VEH = (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" style={{display:"block"}}><rect x="2.5" y="10" width="19" height="8" rx="2.4" stroke="currentColor" strokeWidth="1.7"/><path d="M6 10V8a2 2 0 012-2h8a2 2 0 012 2v2" stroke="currentColor" strokeWidth="1.7"/><circle cx="7" cy="18.5" r="2" stroke="currentColor" strokeWidth="1.7"/><circle cx="17" cy="18.5" r="2" stroke="currentColor" strokeWidth="1.7"/></svg>);
const ICON_ALR = (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" style={{display:"block"}}><path d="M12 3L22 20H2L12 3z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round"/><path d="M12 10v4M12 17h.01" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round"/></svg>);
const ICON_RJ  = (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" style={{display:"block"}}><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.7"/><path d="M12 7v5l3 2" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/></svg>);

// ── Tooltip de ayuda (?) reutilizable ──────────────────────────────────────
// (?) pequeño y discreto junto a un título. Muestra una explicación breve al
// pasar el cursor (hover) y también al hacer click/tocar (por si acaso). Solo
// presentación; no toca datos. Navy sobre crema, borde dorado sutil.
function AyudaTip({texto}:{texto:string}) {
  const [ab, setAb] = useState(false);
  return (
    <span style={{position:"relative" as const, display:"inline-flex", alignItems:"center", verticalAlign:"middle"}}
      onMouseLeave={()=>setAb(false)}>
      <button type="button"
        onMouseEnter={()=>setAb(true)}
        onClick={(e)=>{ e.stopPropagation(); setAb(v=>!v); }}
        aria-label="Ayuda"
        style={{
          width:14, height:14, borderRadius:"50%", flexShrink:0, cursor:"help",
          border:`1px solid ${T_LIGHT.gold}66`, background:`${T_LIGHT.gold}18`,
          color:T_LIGHT.gold, fontSize:9.5, fontWeight:800, lineHeight:1,
          display:"inline-flex", alignItems:"center", justifyContent:"center",
          padding:0, fontFamily:"inherit",
        }}>?</button>
      {ab && (
        <span role="tooltip" style={{
          position:"absolute" as const, top:"calc(100% + 7px)", left:"50%", transform:"translateX(-50%)",
          width:210, maxWidth:"70vw", background:"#0F1E3D", color:"#ECE6D8",
          border:`1px solid ${T_LIGHT.gold}66`, borderRadius:8, padding:"8px 10px",
          fontSize:11, fontWeight:500, lineHeight:1.45, textAlign:"left" as const,
          boxShadow:"0 8px 24px rgba(0,0,0,0.28)", zIndex:60,
          whiteSpace:"normal" as const, textTransform:"none" as const, letterSpacing:"normal",
        }}>{texto}</span>
      )}
    </span>
  );
}

// ── Dona de métrica individual (sección "Cumplimiento de empleados") ────────
// Círculo de progreso con % al centro + label/sublabel debajo. Color por valor
// (verde/ámbar/rojo) o neutro "—" sin datos. `onClick` opcional deja la métrica
// LISTA para el Paso B (detalle navegable al tocar); por ahora solo hover.
function DonaMetrica({pct, hasData, label, sublabel, ayuda, icon, isMobile, fontSerif, onClick, tonoFijo}: {
  pct:number; hasData:boolean; label:string; sublabel?:string; ayuda?:string; icon?:React.ReactNode;
  isMobile:boolean; fontSerif:string; onClick?:()=>void;
  // `tonoFijo` saca al anillo del semáforo por porcentaje. Lo pide la métrica que
  // mide AVANCE y no salud: un 30% de captura no es una alarma, y pintarlo de rojo
  // le dice a un cliente que incumple cuando solo le falta subir archivos.
  tonoFijo?:string;
}) {
  const tone = tonoFijo && hasData ? tonoFijo : toneFromPct(pct, hasData);
  const color = TONE_COLORS[tone] || TONE_COLORS.muted;
  const animated = useCountUp(hasData ? pct : 0, 1000, hasData);
  const size   = isMobile ? 84 : 104;
  const stroke = isMobile ? 8  : 10;
  const r  = (size - stroke) / 2;
  const cx = size / 2, cy = size / 2;
  const C  = 2 * Math.PI * r;
  const filled = hasData ? C * (animated / 100) : 0;
  return (
    <div onClick={onClick}
      onMouseEnter={onClick ? (e)=>{ const t=e.currentTarget; t.style.transform="translateY(-2px)"; t.style.boxShadow=INI.sombraHov; t.style.borderColor=T_LIGHT.goldBorder; } : undefined}
      onMouseLeave={onClick ? (e)=>{ const t=e.currentTarget; t.style.transform="translateY(0)"; t.style.boxShadow=INI.sombra; t.style.borderColor=INI.borde; } : undefined}
      style={{
        background: T_LIGHT.cardLight, border: `2px solid ${INI.borde}`, borderRadius: INI.radio,
        padding: isMobile ? "12px 8px" : "16px 12px", boxShadow: INI.sombra,
        cursor: onClick ? "pointer" : "default",
        display: "flex", flexDirection: "column" as const, alignItems: "center", gap: isMobile?7:9,
        transition: "transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease", minWidth: 0,
      }}>
      <div style={{position:"relative" as const, width:size, height:size}}>
        <svg width={size} height={size} style={{transform:"rotate(-90deg)"}}>
          <circle cx={cx} cy={cy} r={r} fill="none" stroke={T_LIGHT.canvasSoft} strokeWidth={stroke}/>
          <circle cx={cx} cy={cy} r={r} fill="none" stroke={color} strokeWidth={stroke} strokeLinecap="round"
            strokeDasharray={`${filled} ${C}`} style={{transition:"stroke-dasharray 1s cubic-bezier(0.4,0,0.2,1)"}}/>
        </svg>
        <div style={{position:"absolute" as const, top:"50%", left:"50%", transform:"translate(-50%,-50%)", textAlign:"center" as const, width:"100%"}}>
          <div style={{fontFamily:fontSerif, fontSize:isMobile?18:24, fontWeight:800, color, lineHeight:1}}>
            {hasData ? `${animated}` : "—"}
            {hasData && <span style={{fontSize:isMobile?10:13, fontWeight:700, marginLeft:1, color}}>%</span>}
          </div>
        </div>
      </div>
      <div style={{textAlign:"center" as const, minWidth:0, width:"100%"}}>
        <div style={{display:"flex", alignItems:"center", justifyContent:"center", gap:5}}>
          {icon && <span style={{color, display:"inline-flex", transform:"scale(0.82)"}}>{icon}</span>}
          <span style={{fontSize:isMobile?11:12.5, fontWeight:700, color:T_LIGHT.textInk}}>{label}</span>
          {ayuda && <AyudaTip texto={ayuda}/>}
        </div>
        {sublabel && <div style={{fontSize:isMobile?9:10, color:T_LIGHT.textInkMut, marginTop:3, lineHeight:1.35, maxWidth:isMobile?116:160, marginLeft:"auto", marginRight:"auto"}}>{sublabel}</div>}
      </div>
    </div>
  );
}

// KPIMedidor se retiró: sus tres usos migraron a IndicadorTarjeta para heredar
// la afordancia y el sistema visual del molde. Era el último componente propio
// de Inicio fuera del molde, aparte de DonaMetrica, que sí se queda a propósito.

// ── Componente dashboard completo ─────────────────────────────────────────
// ── Lista "Requieren tu atención" (Fase 3B) ──────────────────────────────
// Ancla: id="axis-atencion" para que el medidor "Alertas críticas" pueda
// hacer scrollIntoView al ser clickeado.
//
// UX: por defecto muestra los 3 más urgentes en filas compactas (una línea).
// Botón acordeón "Ver todas (N) ▾" expande el resto sin paginar.
//
// ⚠️ NO ESTÁ MONTADO EN NINGUNA PANTALLA. Nada lo renderiza y nadie lo importa:
// es la única aparición de su nombre en todo el archivo. LA LISTA VIVA está
// escrita EN LÍNEA dentro de `DashboardSuite`, en la tarjeta ancha "Requieren tu
// atención", y la otra copia vive en `NotificationBell` (la campana del top bar).
// Editar esto no cambia nada de lo que el usuario ve.
//
// Se deja porque su acordeón "Ver todas" no existe en las otras dos, pero antes
// de montarlo hay que saber que ha quedado atrás en dos cosas:
//   1) Lleva `onIrModulo`, no `onIrItem`: sus renglones irían al MÓDULO y no al
//      asunto concreto, que es justo el defecto que se corrigió en la lista viva.
//   2) No pasa por `tonoDePlazo`, así que volvería a pintar de rojo lo que vence
//      hoy —todavía vigente— en vez del ámbar fuerte.
function AtencionUrgente({items, isMobile, fontSerif, onIrModulo}: {
  items: ItemAtencion[]; isMobile: boolean; fontSerif: string;
  onIrModulo: (m: AppPantalla) => void;
}) {
  const COLLAPSED = 3;
  const [expandido, setExpandido] = useState(false);
  const visibles = expandido ? items : items.slice(0, COLLAPSED);
  const restantes = items.length - COLLAPSED;

  // Estado vacío — "todo al día"
  if (items.length === 0) {
    return (
      <div id="axis-atencion" style={{
        background: T_LIGHT.cardLight,
        border: `1px solid ${T_LIGHT.borderCard}`,
        borderLeft: `3px solid ${TONE_COLORS.ok}`,
        borderRadius: 12,
        padding: isMobile?"20px 16px":"26px 24px",
        textAlign: "center" as const,
        boxShadow: T_LIGHT.shadow,
        marginBottom: isMobile?14:24,
      }}>
        <div style={{
          width:44, height:44, borderRadius:"50%",
          background:"rgba(5,150,105,0.10)", color: TONE_COLORS.ok,
          display:"flex", alignItems:"center", justifyContent:"center",
          margin:"0 auto 10px",
        }}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <path d="M5 12l4 4 10-10" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <div style={{
          fontFamily: fontSerif, fontSize: isMobile?15:17, fontWeight: 700,
          color: T_LIGHT.textInk, marginBottom: 3,
        }}>Todo al día. Buen trabajo.</div>
        <div style={{fontSize: isMobile?11:12, color: T_LIGHT.textInkSoft}}>
          No hay vencimientos próximos en empleados, vehículos, proveedores ni calendario.
        </div>
      </div>
    );
  }

  // Helper: badge corto de días. El tono lo decide `tonoDePlazo`, en un solo
  // sitio: rojo solo para lo ya vencido, ámbar fuerte para lo inminente.
  const badgeDias = (it: ItemAtencion) => {
    const tono = tonoDePlazo(it);
    const color = tono.color, bg = tono.bgSuave, borde = tono.borde;
    const texto = it.severidad === "vencido"
      ? (it.dias === 0 ? "hoy" : `hace ${Math.abs(it.dias)}d`)
      : (it.dias === 0 ? "hoy" : `en ${it.dias}d`);
    return (
      <span style={{
        fontSize: isMobile?10:10.5, fontWeight:700, color,
        background: bg, border: `1px solid ${borde}`,
        padding: isMobile?"2px 7px":"2px 8px", borderRadius:6,
        whiteSpace:"nowrap" as const, flexShrink:0,
      }}>{texto}</span>
    );
  };

  return (
    <div id="axis-atencion" style={{marginBottom: isMobile?14:24}}>
      {/* Encabezado */}
      <div style={{
        display:"flex", alignItems:"center", gap:8,
        marginBottom: isMobile?8:10, padding: "0 2px",
      }}>
        <span style={{color: TONE_COLORS.alerta, display:"inline-flex", alignItems:"center"}}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M12 3L22 20H2L12 3z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round"/>
            <path d="M12 10v4M12 17h.01" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round"/>
          </svg>
        </span>
        <span style={{
          fontFamily: fontSerif, fontSize: isMobile?14:16, fontWeight: 700,
          color: T_LIGHT.textInk,
        }}>Requieren tu atención</span>
        <span style={{
          fontSize: 10, fontWeight: 700, color: TONE_COLORS.alerta,
          background: "rgba(220,38,38,0.10)", border: "1px solid rgba(220,38,38,0.25)",
          padding: "2px 7px", borderRadius: 8,
        }}>{items.length}</span>
      </div>

      {/* Lista (filas compactas, una línea por item) */}
      <div style={{display:"flex", flexDirection:"column" as const, gap:6}}>
        {visibles.map((it, idx) => {
          const tono      = tonoDePlazo(it);
          const tintColor = tono.color;
          const tintBg    = tono.bgTinte;
          return (
            <div key={it.id} onClick={() => onIrModulo(it.modulo)}
              onMouseEnter={(e)=>{
                e.currentTarget.style.transform = "translateY(-1px)";
                e.currentTarget.style.boxShadow = `0 4px 12px ${tintColor}22`;
                e.currentTarget.style.borderColor = `${tintColor}66`;
              }}
              onMouseLeave={(e)=>{
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = T_LIGHT.shadow;
                e.currentTarget.style.borderColor = T_LIGHT.border;
              }}
              style={{
                background: T_LIGHT.cardLight,
                border: `1px solid ${T_LIGHT.borderCard}`,
                borderLeft: `3px solid ${tintColor}`,
                borderRadius: 9,
                padding: isMobile?"7px 10px":"7px 12px",
                cursor: "pointer",
                display: "flex", alignItems: "center", gap: isMobile?9:10,
                boxShadow: T_LIGHT.shadow,
                transition: "transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease",
                opacity: 0,
                animation: `axisFadeIn 0.32s ease ${idx*0.025}s forwards`,
              }}>
              {/* Ícono del módulo (más pequeño que antes) */}
              <div style={{
                display:"inline-flex", alignItems:"center", justifyContent:"center",
                width: isMobile?24:26, height: isMobile?24:26, borderRadius:6,
                background: tintBg, color: tintColor, flexShrink: 0,
              }}>
                <SidebarIcon name={it.moduloIconName}/>
              </div>
              {/* Título · módulo — todo en una sola línea con elipsis */}
              <div style={{
                flex:1, minWidth:0,
                display:"flex", alignItems:"baseline", gap:6,
                whiteSpace:"nowrap" as const, overflow:"hidden",
              }}>
                <span style={{
                  fontSize: isMobile?12.5:13.5, fontWeight: 600,
                  color: T_LIGHT.textInk,
                  overflow:"hidden", textOverflow:"ellipsis", minWidth:0,
                }}>{it.titulo}</span>
                {!isMobile && (
                  <span style={{
                    fontSize: 11, color: T_LIGHT.textInkMut, flexShrink:0,
                  }}>· {it.moduloLabel}</span>
                )}
              </div>
              {/* Badge días + chevron */}
              {badgeDias(it)}
              <span style={{
                color: T_LIGHT.textInkMut, fontSize:16, fontWeight:300, flexShrink: 0,
                marginLeft: 2,
              }}>›</span>
            </div>
          );
        })}
      </div>

      {/* Botón acordeón "Ver todas (N) ▾" / "Ver menos ▴" */}
      {restantes > 0 && (
        <button
          onClick={() => setExpandido(v => !v)}
          onMouseEnter={(e)=>{
            e.currentTarget.style.background = "rgba(184,147,42,0.06)";
            e.currentTarget.style.borderColor = T_LIGHT.goldBorder;
          }}
          onMouseLeave={(e)=>{
            e.currentTarget.style.background = "transparent";
            e.currentTarget.style.borderColor = T_LIGHT.border;
          }}
          style={{
            marginTop: 8, width: "100%",
            background: "transparent",
            border: `1px dashed ${T_LIGHT.border}`,
            borderRadius: 9,
            padding: "8px 12px",
            cursor: "pointer",
            fontSize: isMobile?11.5:12, fontWeight: 700,
            color: T_LIGHT.gold,
            fontFamily: "inherit",
            display: "flex", alignItems: "center", justifyContent: "center", gap: 6,
            transition: "background 0.18s ease, border-color 0.18s ease",
          }}>
          {expandido ? `Ver menos ▴` : `Ver todas (${items.length}) ▾`}
        </button>
      )}

      <style>{`@keyframes axisFadeIn { from {opacity:0; transform:translateY(4px)} to {opacity:1; transform:translateY(0)} }`}</style>
    </div>
  );
}

// ── Modal de detalle (Paso B) — panel claro centrado, contorno navy, cierre con
// overlay / X / Escape. Solo presentación; no toca datos. ──────────────────────
function ModalDetalle({titulo, subtitulo, onClose, children, fontSerif}:{
  titulo:string; subtitulo?:string; onClose:()=>void; children:React.ReactNode; fontSerif:string;
}) {
  useEffect(()=>{
    const h=(e:KeyboardEvent)=>{ if(e.key==="Escape") onClose(); };
    window.addEventListener("keydown", h);
    const prev = document.body.style.overflow; document.body.style.overflow="hidden";
    return ()=>{ window.removeEventListener("keydown", h); document.body.style.overflow=prev; };
  }, [onClose]);
  return (
    <div onClick={onClose} style={{position:"fixed" as const, inset:0, background:"rgba(11,24,41,0.55)", zIndex:4000, display:"flex", alignItems:"center", justifyContent:"center", padding:16}}>
      <div onClick={(e)=>e.stopPropagation()} style={{background:"#FFFFFF", borderRadius:16, border:`2px solid ${INI.borde}`, width:"min(580px, 100%)", maxHeight:"84vh", display:"flex", flexDirection:"column" as const, boxShadow:"0 24px 64px rgba(0,0,0,0.38)", overflow:"hidden"}}>
        <div style={{padding:"15px 18px", borderBottom:`1px solid ${INI.borde}`, display:"flex", alignItems:"flex-start", justifyContent:"space-between", gap:12, flexShrink:0}}>
          <div style={{display:"flex", alignItems:"flex-start", gap:9, minWidth:0}}>
            <div style={{width:3, height:20, background:T_LIGHT.gold, borderRadius:2, flexShrink:0, marginTop:2}}/>
            <div style={{minWidth:0}}>
              <div style={{fontFamily:fontSerif, fontSize:16, fontWeight:700, color:T_LIGHT.textInk, lineHeight:1.2}}>{titulo}</div>
              {subtitulo && <div style={{fontSize:12, color:T_LIGHT.textInkSoft, marginTop:2}}>{subtitulo}</div>}
            </div>
          </div>
          <button onClick={onClose} aria-label="Cerrar" style={{border:"none", background:"transparent", cursor:"pointer", color:T_LIGHT.textInkMut, fontSize:20, lineHeight:1, padding:"2px 4px", flexShrink:0, fontFamily:"inherit"}}>✕</button>
        </div>
        <div style={{padding:"14px 18px 18px", overflowY:"auto" as const}}>{children}</div>
      </div>
    </div>
  );
}

// Lista con "Ver todos" — evita scroll infinito: muestra los primeros N y expande.
function ListaConVerTodos({items, render, colapsado=6, fontSans}:{
  items:any[]; render:(it:any,i:number)=>React.ReactNode; colapsado?:number; fontSans?:string;
}) {
  const [exp, setExp] = useState(false);
  const vis = exp ? items : items.slice(0, colapsado);
  return (
    <div style={{display:"flex", flexDirection:"column" as const, gap:8}}>
      {vis.map((it,i)=>render(it,i))}
      {items.length>colapsado && (
        <button onClick={()=>setExp(v=>!v)}
          style={{alignSelf:"center", marginTop:4, border:`1px solid ${INI.borde}`, background:T_LIGHT.canvasSoft, borderRadius:9, padding:"7px 14px", cursor:"pointer", fontSize:12, fontWeight:700, color:T_LIGHT.gold, fontFamily:fontSans||"inherit"}}>
          {exp ? "Ver menos ▴" : `Ver todos (${items.length}) ▾`}
        </button>
      )}
    </div>
  );
}

// Detalle de un medidor de "Cumplimiento de empleados". Deriva TODO en JS de datos
// ya cargados (empleados, checadas clasificadas 2B, tareas). Defensivo.
// ⚠️ NO ESTÁ MONTADO EN NINGUNA PANTALLA. Se quedó aquí cuando se retiraron las
// donas de Inicio: nada lo renderiza y nadie lo importa. Se deja porque su
// desglose de incidencias puede servir, pero NO SE VUELVE A PINTAR TAL CUAL.
//
// Antes de montarlo hay que arreglarle dos cosas, y las dos afirman falsedades:
//   1) Los días laborables están escritos a mano —`dow===0||dow===6`— en vez de
//      salir de `diasLaborablesVigentes`. A una empresa que opera los sábados le
//      diría que el sábado no se trabaja, contradiciendo el horario que ella
//      misma configuró.
//   2) No pregunta por cuentas: cuenta como incumplimiento la ausencia de quien
//      no tiene forma de checar. Eso ya lo resuelve `debiaChecarHoy`.
//
// La prueba `prueba-cables` falla si alguien lo monta sin arreglar lo anterior.
function DetalleCumplimiento({tipo, empleados, checadasPatron, tareasPatron, horarioGeneral, registrosObligaciones, fontSerif, fontSans, onClose}:{
  tipo:"checador"|"documentos"|"tareas"; empleados:any[]; checadasPatron:any[]; tareasPatron:any[];
  horarioGeneral?:any; registrosObligaciones?:any[];
  fontSerif:string; fontSans?:string; onClose:()=>void;
}) {
  const activos = (empleados||[]).filter((e:any)=> e.status!=="baja");
  const filaVacia = (texto:string) => (
    <div style={{textAlign:"center" as const, padding:"26px 12px"}}>
      <div style={{width:46, height:46, borderRadius:"50%", margin:"0 auto 10px", display:"flex", alignItems:"center", justifyContent:"center", background:"rgba(5,150,105,0.10)", color:TONE_COLORS.ok, fontSize:22}}>✓</div>
      <div style={{fontFamily:fontSerif, fontSize:15, fontWeight:700, color:T_LIGHT.textInk}}>{texto}</div>
    </div>
  );
  const badge = (txt:string, color:string) => (
    <span style={{fontSize:10.5, fontWeight:800, padding:"2px 9px", borderRadius:999, border:`1px solid ${color}`, color, background:`${color}14`, whiteSpace:"nowrap" as const, flexShrink:0}}>{txt}</span>
  );
  // Tarjeta POR EMPLEADO: nombre (encabezado) + conteo (dorado) + sus incidencias debajo.
  // Separación visual marcada (contorno navy) para distinguir de un vistazo a quién pertenece cada cosa.
  const cardEmpleado = (nombre:string, conteo:string, hijos:React.ReactNode) => (
    <div style={{border:`1.5px solid ${INI.borde}`, borderRadius:12, background:T_LIGHT.cardLight, padding:"10px 12px", boxShadow:INI.sombra}}>
      <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", gap:10, marginBottom:8, paddingBottom:7, borderBottom:`1px solid ${INI.borde}`}}>
        <span style={{fontSize:13.5, fontWeight:800, color:T_LIGHT.textInk, minWidth:0, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" as const}}>{nombre}</span>
        <span style={{fontSize:11, fontWeight:800, color:T_LIGHT.gold, flexShrink:0, whiteSpace:"nowrap" as const}}>{conteo}</span>
      </div>
      <div style={{display:"flex", flexDirection:"column" as const, gap:6}}>{hijos}</div>
    </div>
  );
  // Agrupa una lista por su campo `empleado`. Devuelve grupos ordenados por # desc.
  const agrupar = (items:any[]) => {
    const map:Record<string, any[]> = {};
    items.forEach((x:any)=>{ (map[x.empleado] = map[x.empleado] || []).push(x); });
    return Object.keys(map).map(nombre=>({nombre, items:map[nombre], total:map[nombre].length}))
      .sort((a,b)=> b.total-a.total || a.nombre.localeCompare(b.nombre));
  };

  if (tipo==="checador") {
    const mesLabel = (()=>{ const s=new Date().toLocaleDateString("es-MX",{month:"long",year:"numeric"}); return s.charAt(0).toUpperCase()+s.slice(1); })();
    const conHorario = activos.filter((e:any)=> tieneHorarioVigente(e, horarioGeneral) && (e.email||"").trim());
    const sinHorario = activos.filter((e:any)=> (e.email||"").trim() && !tieneHorarioVigente(e, horarioGeneral));
    // El mismo recorrido que la bitácora (ver incidenciasDelMes): ni L–V a mano ni "Falta".
    const inc = incidenciasDelMes({empleados: conHorario, checadas: checadasPatron||[], horarioGeneral, hoy: new Date(), registrosObligaciones});
    const nS = inc.filter((x:any)=>x.tipo==="sin_registro").length, nR = inc.filter((x:any)=>x.tipo==="retardo").length, nT = inc.filter((x:any)=>x.tipo==="tardia").length;
    const grupos = agrupar(inc);  // ya ordenados por # incidencias; dentro, por fecha desc
    return (
      <ModalDetalle titulo={`Incidencias de asistencia · ${mesLabel}`} subtitulo={inc.length? `${nS} sin registro · ${nR} retardo${nR===1?"":"s"}${nT ? ` · ${nT} entrada${nT===1?"":"s"} tardía${nT===1?"":"s"}` : ""} · ${grupos.length} empleado${grupos.length===1?"":"s"}` : undefined} onClose={onClose} fontSerif={fontSerif}>
        {sinHorario.length>0 && (
          <div style={{marginBottom:12, fontSize:12, color:"#8a6d1a", background:"rgba(226,184,74,0.12)", border:"1px solid rgba(226,184,74,0.35)", borderRadius:9, padding:"8px 11px"}}>
            {sinHorario.length} empleado{sinHorario.length===1?"":"s"} sin horario configurado — no se evalúan (su % de asistencia sale neutro).
          </div>
        )}
        {inc.length===0 ? filaVacia("Sin incidencias este mes") : (
          <ListaConVerTodos items={grupos} colapsado={4} fontSans={fontSans} render={(g:any,i:number)=>{
            const gs=g.items.filter((x:any)=>x.tipo==="sin_registro").length, gr=g.items.filter((x:any)=>x.tipo==="retardo").length, gt=g.items.filter((x:any)=>x.tipo==="tardia").length;
            const conteo=[gs?`${gs} sin registro`:"", gr?`${gr} retardo${gr===1?"":"s"}`:"", gt?`${gt} entrada${gt===1?"":"s"} tardía${gt===1?"":"s"}`:""].filter(Boolean).join(", ");
            return <div key={i}>{cardEmpleado(g.nombre, conteo, g.items.map((x:any,j:number)=>(
              <div key={j} style={{display:"flex", alignItems:"center", gap:8}}>
                {badge(x.tipo==="sin_registro"?"Sin registro":x.tipo==="tardia"?clasifAsistenciaMeta("tardia").patron:"Retardo", x.tipo==="sin_registro"?"#5B6784":x.tipo==="tardia"?"#B45309":"#B8860B")}
                <span style={{fontSize:12, color:T_LIGHT.textInk, fontWeight:600, textTransform:"capitalize" as const, flexShrink:0}}>{x.fecha.toLocaleDateString("es-MX",{weekday:"short",day:"2-digit",month:"short"})}</span>
                <span style={{fontSize:11.5, color:T_LIGHT.textInkSoft, minWidth:0, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" as const}}>{x.detalle}</span>
              </div>
            )))}</div>;
          }}/>
        )}
      </ModalDetalle>
    );
  }

  if (tipo==="documentos") {
    const incompletos = activos.map((e:any)=>{
      const comp = e.compliance||{};
      const faltantes = COMPLIANCE_ITEMS.filter((it:any)=> comp[it.key]!=="ok" && comp[it.key]!=="na");
      const aplicables = COMPLIANCE_ITEMS.filter((it:any)=> comp[it.key]!=="na").length;
      return {empleado:e.nombre||e.email||"Empleado", faltan:faltantes.length, aplicables, labels:faltantes.map((f:any)=>f.label)};
    }).filter((x:any)=> x.faltan>0).sort((a:any,b:any)=> b.faltan-a.faltan || a.empleado.localeCompare(b.empleado));
    return (
      <ModalDetalle titulo="Documentos por completar" subtitulo={incompletos.length? `${incompletos.length} empleado${incompletos.length===1?"":"s"} con expediente incompleto` : undefined} onClose={onClose} fontSerif={fontSerif}>
        {incompletos.length===0 ? filaVacia("Expedientes completos") : (
          <ListaConVerTodos items={incompletos} colapsado={4} fontSans={fontSans} render={(x:any,i:number)=>{
            const vis = x.labels.slice(0,8); const resto = x.labels.length-vis.length;
            return <div key={i}>{cardEmpleado(x.empleado, `faltan ${x.faltan} de ${x.aplicables}`, <>
              {vis.map((l:string,j:number)=>(
                <div key={j} style={{display:"flex", alignItems:"flex-start", gap:7, fontSize:12, color:T_LIGHT.textInkSoft}}>
                  <span style={{color:"#B8860B", flexShrink:0, lineHeight:1.3}}>•</span>
                  <span style={{minWidth:0}}>{l}</span>
                </div>
              ))}
              {resto>0 && <div style={{fontSize:11.5, color:T_LIGHT.textInkMut, paddingLeft:14}}>… y {resto} más</div>}
            </>)}</div>;
          }}/>
        )}
      </ModalDetalle>
    );
  }

  // tareas — solo de empleados ACTIVOS (excluye actividades de dados de baja)
  const pend = tareasDeActivos(tareasPatron, empleados).filter((t:any)=> !t.confirmadaPorPatron).map((t:any)=>({
    titulo:t.titulo||"Actividad", empleado:t.trabajadorNombre||t.trabajadorEmail||"—",
    porConfirmar: !!t.marcadaPorTrabajador, fechaLimite:t.fechaLimite||"",
  }));
  const gruposT = agrupar(pend).map(g=>({ ...g, items: g.items.slice().sort((a:any,b:any)=> (a.fechaLimite||"9999").localeCompare(b.fechaLimite||"9999")) }));
  return (
    <ModalDetalle titulo="Actividades pendientes" subtitulo={pend.length? `${pend.length} actividad${pend.length===1?"":"es"} sin confirmar · ${gruposT.length} empleado${gruposT.length===1?"":"s"}` : undefined} onClose={onClose} fontSerif={fontSerif}>
      {pend.length===0 ? filaVacia("Sin actividades pendientes") : (
        <ListaConVerTodos items={gruposT} colapsado={4} fontSans={fontSans} render={(g:any,i:number)=>(
          <div key={i}>{cardEmpleado(g.nombre, `${g.total} actividad${g.total===1?"":"es"} sin confirmar`, g.items.map((x:any,j:number)=>(
            <div key={j} style={{display:"flex", alignItems:"center", gap:8}}>
              {badge(x.porConfirmar?"Por confirmar":"Pendiente", x.porConfirmar?"#B8860B":"#6B7280")}
              <span style={{fontSize:12.5, color:T_LIGHT.textInk, fontWeight:600, minWidth:0, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" as const}}>{x.titulo}</span>
              {x.fechaLimite && <span style={{fontSize:11, color:T_LIGHT.textInkSoft, flexShrink:0, marginLeft:"auto"}}>vence {x.fechaLimite}</span>}
            </div>
          )))}</div>
        )}/>
      )}
    </ModalDetalle>
  );
}

function DashboardSuite({currentUser, isMobile, isTablet, fontSerif, onGoEmpleadosFoco, onGoFlotillaFiltrada, onIrItem, onGoViaje, onIrDestino}: {
  currentUser: any; isMobile: boolean; isTablet: boolean; fontSerif: string;
  // LAS QUE QUEDAN LLEVAN CARGA, y por eso no pueden pasar por `irAModuloGlobal`:
  // la puerta solo sabe a qué módulo ir, no con qué. Los saltos a secas ya no
  // están aquí; si alguna vez vuelve a aparecer una prop de las de `() => void`,
  // es que alguien se saltó la puerta.
  //
  // Abre Empleados acotado a estos correos (renglón del checador).
  onGoEmpleadosFoco?: (emails:string[]) => void;
  // Salto CONTEXTUAL: abre Flotilla con un filtro ya aplicado.
  onGoFlotillaFiltrada?: (filtro:"vencida"|"por_vencer"|"sin_registro"|"en_regla") => void;
  // Abre el asunto CONCRETO de un renglón de "Requieren tu atención".
  onIrItem?: (it: ItemAtencion) => void;
  // Abre ESE viaje en Flotilla. No el módulo: el viaje.
  onGoViaje?: (viajeId:string) => void;
  // Abre el hecho concreto de una fila del feed, por su id. Si no viene, las
  // filas dejan de ser clicables: nunca caen al módulo "por si acaso".
  onIrDestino?: (d: DestinoFeed) => void;
}) {
  const {loading, kpis, kpisCreditos, checadasPatron, checadasEfectivas, empleados, tareasPatron, cumplimientoTareas, creditos, clientes, atencionUrgente, accidentesPendientes, flotillaPatron, accidentesPatron, horarioGeneral, historialGeneral, registrosVacaciones, cuentasTrab, vehiculos} = useDashboardData(currentUser);

  // UNIDADES FUERA AHORA. Va aparte de "Requieren tu atención" a propósito: que
  // una unidad esté en la calle no es un incumplimiento, y meterla en el cubo de
  // urgentes convertiría el trabajo normal de la empresa en una alarma.
  const fuera = useMemo(() => unidadesFueraAhora(flotillaPatron||[], vehiculos||[]),
    [flotillaPatron, vehiculos]);

  // ── LO QUE SE VE DEL FEED ─────────────────────────────────────────────────
  // El corte es de la VISTA, no del dato: la lista completa vive en
  // `actividadReciente` y aquí se decide cuánta se enseña y de qué familia.
  const FEED_COLAPSADO = 8, FEED_ABIERTO = 50;
  const [feedFamilia, setFeedFamilia] = useState<"todo"|FamiliaFeed>("todo");
  const [feedAbierto, setFeedAbierto] = useState(false);

  // Tone semántico de cada medidor depende del VALOR, no del módulo.
  // Documentos: se calcula sobre los expedientes CON ALGO CAPTURADO. Si no hay
  // ninguno, no hay cifra que dar —igual que Checador sin horarios y Actividades
  // sin actividades—. Es avance de captura, no cumplimiento legal: su tono es de
  // progreso y nunca rojo. El rojo se reserva para lo vencido de verdad.
  const hayExpedientes = kpis.empleadosEvaluados > 0;
  // Flotilla en hechos: unidades que exigen que hagas algo con su documentación.
  // El filete resume los renglones: rojo si hay algo vencido de verdad, ámbar
  // si solo hay documentos por vencer o fechas sin capturar, neutro si no hay
  // nada que hacer. Ausencia de dato nunca llega a rojo.
  const flotaAccion = kpis.vehiculosVencidos + kpis.vehiculosPorVencer + kpis.vehiculosSinRegistro;
  // El filete solo encarna urgencia de un hecho REAL: rojo si hay documento
  // vencido, ámbar si solo faltan capturas, neutro si no hay nada que hacer.
  const toneFlota = kpis.vehiculosVencidos > 0 ? UI.rojo
    : flotaAccion > 0 ? UI.ambar : UI.neutro;
  // Una sola tarjeta para lo que vence: el desglose ya existe en la campana.
  // ⚠️ ESTA TARJETA CONTABA SOLO LOS PLAZOS, y por eso llegó a decir "Todo al día"
  // mientras el escudo de la misma pantalla enseñaba tres accidentes con personas
  // lesionadas. Ahora las dos leen `resumenDeAtencion`, que es la única suma.
  const atencion = resumenDeAtencion(atencionUrgente, accidentesPendientes);
  const totalAtencion = atencion.total;
  // LOS ACCIDENTES CUENTAN, PERO NO CAMBIAN EL TONO DE LA TARJETA (4-oct): no se
  // clasifica su gravedad. El tono sigue siendo el de los plazos: rojo si hay
  // alertas críticas, ámbar si hay algo pendiente, neutro si nada.
  const toneAtencion = kpis.alertasCriticas > 0 ? UI.rojo
    : totalAtencion > 0 ? UI.ambar : UI.neutro;
  const abrirAvisos = () => { try { window.dispatchEvent(new CustomEvent("avisos:abrir")); } catch(e){} };

  const hayTareas = tareasDeActivos(tareasPatron, empleados).length > 0;   // solo actividades de activos

  // ── HECHOS DEL EQUIPO, en vez de porcentajes ──────────────────────────────
  // Las tres donas se retiraron: con pocos datos mentían en las dos direcciones
  // —un "100%" sacado de 1 de 11 expedientes y un "0%" en rojo del checador—, y
  // un porcentaje sin base suficiente no ayuda a decidir. En su lugar van tres
  // hechos contables, con el mismo tratamiento que los renglones de al lado.
  // El cálculo y la redacción viven en `hechosDelEquipo`, compartida con la app:
  // si las dos pantallas leen de ahí, no pueden contradecirse.
  const hechosEquipo = useMemo(
    () => hechosDelEquipo(empleados, tareasPatron, checadasEfectivas,
      kpis.registrosActivos.empleados, kpis.empleadosEvaluados, horarioGeneral, cuentasTrab, historialGeneral, registrosVacaciones),
    [empleados, tareasPatron, checadasEfectivas, kpis.registrosActivos.empleados, kpis.empleadosEvaluados, horarioGeneral, cuentasTrab, historialGeneral, registrosVacaciones]);
  // ── ACTIVIDAD RECIENTE ────────────────────────────────────────────────────
  // CERO lecturas nuevas: las once colecciones que alimentan esto ya vienen de
  // `useDashboardData`. Los documentos y contratos viven DENTRO de la ficha del
  // trabajador, así que tampoco cuestan una consulta aparte. Un bloque informativo
  // no debe costar lecturas en cada entrada a Inicio.
  //
  // Queda fuera a propósito `documentos_generados` —el banco de documentos sin
  // vincular—: es la única fuente que exigiría una consulta más.
  const _hace = (ms:number):string => {
    if (!ms) return "";
    const min = Math.floor((Date.now() - ms) / 60000);
    if (min < 1) return "hace un momento";
    if (min < 60) return `hace ${min} min`;
    const h = Math.floor(min / 60);
    if (h < 24) return `hace ${h} h`;
    const d = Math.floor(h / 24);
    if (d === 1) return "ayer";
    if (d < 7) return `hace ${d} días`;
    return new Date(ms).toLocaleDateString("es-MX", {day:"numeric", month:"short"});
  };
  const _ms = (v:any):number => {
    try { if (v?.toMillis) return v.toMillis(); } catch(e) {}
    if (typeof v === "string" && /^\d{4}-\d{2}-\d{2}/.test(v)) {
      const [y,m,d] = v.slice(0,10).split("-").map(Number);
      return new Date(y, m-1, d, 12, 0, 0).getTime();   // mediodía: evita el corrimiento de zona
    }
    return 0;
  };
  // Cuenta vacía: sin empleados NI unidades. Con uno solo de los dos ya se ve el
  // tablero normal, que sabe decir qué falta.
  const cuentaVacia = kpis.registrosActivos.empleados === 0 && kpis.registrosActivos.vehiculos === 0;
  // La TIRA tiene su propia condición, y no es la de arriba: cuenta además
  // proveedores y clientes. Se muestra si AL MENOS UNO de sus cuatro contadores
  // trae algo. Así el bloque de arranque y la tira pueden convivir cuando alguien
  // cargó clientes pero todavía no empleados ni unidades —un caso real, y donde
  // la tira sí informa—.
  //
  // Y los CRÉDITOS cuentan también, aunque no tengan contador propio: el resumen
  // de lo que le deben vive DENTRO de esta tira, a la derecha. Los cuatro
  // contadores son empleados, vehículos, proveedores y clientes —los DEUDORES no
  // están ahí—, así que quien use la plataforma solo para prestar tendría los
  // cuatro en cero y perdería su resumen. Es un uso legítimo del producto, no un
  // caso borde.
  //
  // Se lee `kpisCreditos` y no el alias `_kc`, que se declara más abajo: usarlo
  // aquí sería leerlo antes de su declaración.
  const hayContadores = kpis.registrosActivos.empleados > 0
    || kpis.registrosActivos.vehiculos > 0
    || kpis.registrosActivos.proveedores > 0
    || (clientes||[]).length > 0
    || kpisCreditos.hayCreditos;
  const actividadReciente = useMemo(() => {
    const ev: {id:string; texto:string; ms:number; color:string; familia:FamiliaFeed; esAccidente?:boolean; destino?:DestinoFeed}[] = [];
    const quien = (x:any) => x?.registradoPorNombre || x?.conductorNombre || x?.conductor
      || x?.trabajadorNombre || x?.trabajadorEmail || x?.registradoPorEmail || "Alguien";
    // LA FICHA DE UN CORREO. Una checada guarda el correo del trabajador, no el
    // id de su expediente: para llevar a la ficha hay que resolverlo, y si no
    // resuelve —expediente borrado, o una checada de alguien que nunca lo tuvo—
    // no hay destino y la fila no es clicable.
    const fichaPorCorreo: Record<string, string> = {};
    (empleados||[]).forEach((e:any)=>{
      const c = String(e?.email||"").toLowerCase().trim();
      if (c && e?.id) fichaPorCorreo[c] = e.id;
    });
    const fichaDe = (x:any):string => {
      const c = String(x?.trabajadorEmail||x?.conductorEmail||"").toLowerCase().trim();
      return c ? (fichaPorCorreo[c] || "") : "";
    };
    (flotillaPatron||[]).forEach((x:any)=>{
      const acc = x.tipo==="salida" ? "registró la salida de" : x.tipo==="llegada" ? "registró la llegada de" : "registró el regreso de";
      ev.push({id:`f:${x.id}`, texto:`${quien(x)} ${acc} ${x.placa||"una unidad"}`,
        ms:_ms(x.timestamp), color:UI.navy, familia:"flotilla",
        // El movimiento ES la fila: su id existe por construcción.
        destino: x.id ? {modulo:"flotilla", foco:"movimiento", id:x.id} : undefined});
    });
    (checadasPatron||[]).forEach((x:any)=>{
      // Cada tipo por su nombre. Este ternario decía "checó salida" de un regreso
      // de comer, y el día de una persona se leía al revés de como ocurrió.
      const acc = accionChecada(x.tipo);
      const ficha = fichaDe(x);
      ev.push({id:`c:${x.id}`, texto:`${quien(x)} ${acc}`,
        ms:_ms(x.horaServidor||x.timestamp), color:UI.okVivo, familia:"checador",
        destino: ficha ? {modulo:"empleados", id:ficha, pestana:"checador"} : undefined});
    });
    (tareasPatron||[]).forEach((x:any)=>{
      // La actividad ES la fila: su id existe por construcción, y ya no depende
      // de que el trabajador conserve ficha —una actividad de alguien dado de
      // baja sigue siendo un hecho al que se puede llegar.
      const dest: DestinoFeed|undefined = x.id ? {modulo:"tareas", id:x.id} : undefined;
      if (x.confirmadaPorPatron && x.fechaConfirmada) {
        ev.push({id:`tc:${x.id}`, texto:`Se confirmó “${x.titulo||"una actividad"}” · ${quien(x)}`,
          ms:_ms(x.fechaConfirmada), color:UI.okVivo, familia:"actividades", destino:dest});
      } else if (x.marcadaPorTrabajador && x.fechaMarcada) {
        ev.push({id:`tm:${x.id}`, texto:`${quien(x)} marcó “${x.titulo||"una actividad"}” como cumplida`,
          ms:_ms(x.fechaMarcada), color:UI.ambarVivo, familia:"actividades", destino:dest});
      }
    });
    (accidentesPatron||[]).forEach((x:any)=>{
      ev.push({id:`a:${x.id}`, texto:`${quien(x)} reportó un accidente${x.placa?` · ${x.placa}`:""}`,
        ms:_ms(x.timestamp), color:UI.rojoVivo, familia:"flotilla", esAccidente:true,
        destino: x.id ? {modulo:"flotilla", foco:"accidente", id:x.id} : undefined});
    });
    (empleados||[]).forEach((e:any)=>{
      // El contrato y el documento viven DENTRO de la ficha: el id que se manda
      // es el de la ficha, y la pestaña dice en cuál de sus apartados está.
      (Array.isArray(e.contratos)?e.contratos:[]).forEach((c:any, i:number)=>{
        const nom = String(c.tipo||"documento").replace(/_/g," ");
        ev.push({id:`k:${e.id}:${c.id||i}`, texto:`Se generó ${nom} · ${e.nombre||"un trabajador"}`,
          ms:_ms(c.creado||c.fecha), color:UI.oro, familia:"expedientes",
          destino: e.id ? {modulo:"empleados", id:e.id, pestana:"contratos"} : undefined});
      });
      (Array.isArray(e.documentos)?e.documentos:[]).forEach((d:any, i:number)=>{
        ev.push({id:`d:${e.id}:${d.id||i}`, texto:`Se subió ${d.nombre||"un documento"} al expediente de ${e.nombre||"un trabajador"}`,
          ms:_ms(d.fecha), color:UI.textoTenue, familia:"expedientes",
          destino: e.id ? {modulo:"empleados", id:e.id, pestana:"documentos"} : undefined});
      });
    });
    // Sin fecha no se puede ordenar ni fechar el hecho: se descarta antes de pintar.
    // NO SE CORTA AQUÍ. El corte es de la vista, no del dato: la tarjeta enseña
    // ocho y "Ver todo" enseña el resto, y el filtro por familia necesita mirar
    // la lista entera para poder sacar a la superficie lo que el tope hundía.
    return ev.filter(x=>x.ms>0).sort((a,b)=>b.ms-a.ms);
  }, [flotillaPatron, checadasPatron, tareasPatron, accidentesPatron, empleados]);

  // LA LISTA COMPLETA SE ARMA UNA VEZ POR CARGA DE DATOS, no en cada render.
  // Sus dependencias son solo las cinco colecciones; el filtro y el "Ver todo"
  // NO están ahí, así que pulsarlos no reconstruye nada. Importa desde que el
  // corte pasó de dato a vista: con un año de uso son miles de objetos, y
  // armarlos en cada render de Inicio se notaría.
  //
  // Lo que sí corre en cada render es el `slice` de lo visible y el agrupado por
  // día, y los dos trabajan sobre cincuenta filas como mucho.

  // Solo se ofrecen los botones de las familias que TIENEN filas, con su cuenta.
  const familiasConFilas = useMemo(() => FAMILIAS_FEED
    .map(f => ({...f, n: actividadReciente.filter((e:any)=> e.familia === f.k).length}))
    .filter(f => f.n > 0), [actividadReciente]);
  // Y si la familia elegida se queda sin filas —cambiaron los datos al refrescar—
  // se vuelve a "Todo" en vez de dejar una lista vacía sin explicación.
  const familiaVigente: "todo"|FamiliaFeed =
    (feedFamilia !== "todo" && !familiasConFilas.some(f => f.k === feedFamilia)) ? "todo" : feedFamilia;
  const feedFiltrado = useMemo(() => familiaVigente === "todo"
    ? actividadReciente
    : actividadReciente.filter((e:any)=> e.familia === familiaVigente),
    [actividadReciente, familiaVigente]);
  // El día se agrupa DESPUÉS de filtrar: los encabezados describen lo que se ve.
  const feedVisible = feedFiltrado.slice(0, feedAbierto ? FEED_ABIERTO : FEED_COLAPSADO);

  // Paso B: detalle al tocar cada medidor de "Cumplimiento de empleados".

  if (loading) {
    // Skeleton: respeta el layout asimétrico del dashboard real.
    return (
      <div style={{display:"grid",
        gridTemplateColumns: isMobile?"1fr":"minmax(215px, 235px) 1fr",
        gridTemplateAreas: isMobile ? `"anillo" "der"` : `"anillo der"`,
        gap: isMobile?12:16, marginBottom: isMobile?14:20}}>
        <div style={{
          gridArea:"anillo",
          background:T_LIGHT.canvasSoft, border:`1px solid ${T_LIGHT.borderCard}`,
          borderRadius: 17, height: isMobile?184:250, opacity:0.6,
          animation:`axisPulse 1.4s ease-in-out infinite`,
        }}/>
        <div style={{gridArea:"der", display:"flex", flexDirection:"column" as const, gap: isMobile?8:10}}>
          <div style={{
            background:T_LIGHT.canvasSoft, border:`1px solid ${T_LIGHT.borderCard}`,
            borderRadius:11, height: 44, opacity:0.6,
            animation:`axisPulse 1.4s ease-in-out infinite`,
          }}/>
          <div style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap: isMobile?8:10}}>
            {[0,1,2,3].map(i => (
              <div key={i} style={{
                background:T_LIGHT.canvasSoft, border:`1px solid ${T_LIGHT.borderCard}`,
                borderRadius:12, height: isMobile?68:76, opacity:0.6,
                animation:`axisPulse 1.4s ease-in-out infinite`, animationDelay:`${i*0.08}s`,
              }}/>
            ))}
          </div>
        </div>
        <style>{`@keyframes axisPulse { 0%,100%{opacity:0.55} 50%{opacity:0.85} }`}</style>
      </div>
    );
  }

  // TIRA DELGADA de contadores — resumen rápido de lo activo en el sistema.
  // Reemplaza la tarjeta gruesa de "Registros activos". Reutiliza datos ya
  // cargados por el hook (emp/veh/prov de kpis.registrosActivos, más clientes y
  // créditos). Informativa (sin navegación): es un resumen discreto, no protagonista.
  const _icoProv = (<svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M4 21V5a1 1 0 011-1h9a1 1 0 011 1v16M15 21V9h4a1 1 0 011 1v11M4 21h16M8 8h3M8 12h3M8 16h3" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/></svg>);
  const _icoCli  = (<svg width="14" height="14" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="1.7"/><path d="M4 21c0-4 4-6 8-6s8 2 8 6" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/></svg>);
  const _icoCred = (<svg width="14" height="14" viewBox="0 0 24 24" fill="none"><rect x="3" y="6" width="18" height="12" rx="2" stroke="currentColor" strokeWidth="1.7"/><path d="M3 10h18M7 15h4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/></svg>);
  // A la IZQUIERDA: contadores (Créditos ya no va aquí; su resumen vive a la derecha).
  // Cada contador lleva a su módulo. Con cero registros deja de ser pulsable: no
  // se manda a nadie a una tabla vacía (misma regla que los indicadores).
  // CUÁNTOS TIENE DADOS DE ALTA Y A CUÁNTOS ALCANZA LA PLATAFORMA no son el mismo
  // hecho, y se estaba contando uno y enseñando como si fuera el otro. Un patrón
  // con doce fichas y dos cuentas tiene doce empleados y llega a dos: el checador,
  // las actividades y la bitácora de flotilla solo funcionan con cuenta.
  //
  // Si la colección no se ha podido leer no se dice nada: no se sabe.
  const _conCuentaSet = correosConCuentaActiva(cuentasTrab||[]);
  const _nConCuenta = (empleados||[]).filter((e:any)=> (e.status||"activo")!=="baja"
    && _conCuentaSet.has(String(e.email||"").toLowerCase().trim())).length;
  // CADA RENGLÓN DICE SU DESTINO, no trae un manejador que le pasaron. Colgaban de
  // props opcionales —`onGoEmpleados?`, `onGoFlotilla?`, `onGoProveedores?`,
  // `onGoClientes?`— enhebradas desde App por SuiteHome: si una no llega, el
  // renglón se queda mudo y no hay error, ni rastro, ni forma de notarlo leyendo.
  // Ahora ninguno depende de que le pasen nada.
  const contadores = [
    {icon: ICON_EMP, n: kpis.registrosActivos.empleados,   label: "Empleados",   modulo:"empleados" as AppPantalla,
      sub: cuentasTrab === null ? "" : `${_nConCuenta} con cuenta`,
      ayuda: cuentasTrab === null ? "" : `${kpis.registrosActivos.empleados} dados de alta · ${_nConCuenta} con cuenta del portal, que son a los que llega el checador, las actividades y la bitácora de flotilla`},
    {icon: ICON_VEH, n: kpis.registrosActivos.vehiculos,   label: "Vehículos",   modulo:"flotilla" as AppPantalla},
    {icon: _icoProv, n: kpis.registrosActivos.proveedores, label: "Proveedores", modulo:"proveedores" as AppPantalla},
    {icon: _icoCli,  n: (clientes||[]).length,             label: "Clientes",    modulo:"clientes" as AppPantalla},
  ];
  // A la DERECHA (aprovechando el espacio libre): resumen de créditos con estado
  // + "Ver detalle →". Mismo estilo CLARO de la tira, con acento navy/dorado fino.
  const _kc = kpisCreditos;
  const _cEnMora = _kc.creditosEnMora;
  const _cVencidos = _kc.creditosVencidos;
  const _cActivos = _kc.creditosActivos;
  const _cHayMora = _cVencidos > 0;
  const _cProxTxt = _kc.proximaCuota
    ? (_kc.proximaCuota.dias < 0 ? `vencida hace ${Math.abs(_kc.proximaCuota.dias)}d`
       : (_kc.proximaCuota.dias === 0 ? "vence hoy" : `vence en ${_kc.proximaCuota.dias}d`))
    : "—";
  const _cAyuda = `Créditos activos y su estado (verde al corriente, rojo en mora).${_kc.proximaCuota ? ` Próxima cuota ${moneyMXN(_kc.proximaCuota.monto)} · ${_cProxTxt}.` : ""}${_cHayMora ? ` Vencido: ${moneyMXN(_kc.saldoEnMora)}.` : ""} 'Ver detalle' abre el módulo de Créditos.`;
  const registrosInline = (
    <div style={{
      background: T_LIGHT.cardLight, border: `1px solid ${INI.borde}`,
      borderRadius: INI.radio, padding: isMobile?"6px 12px":"7px 16px",
      boxShadow: INI.sombra, width:"100%",
      display:"flex", alignItems:"center", flexWrap:"wrap" as const, rowGap:8, columnGap:0,
      minWidth: 0,
    }}>
      {/* Contadores (izquierda) */}
      {contadores.map((c, i) => (
        <React.Fragment key={c.label}>
          {i>0 && <span aria-hidden style={{width:1, height:15, background:T_LIGHT.border, margin: isMobile?"0 9px":"0 13px", flexShrink:0}}/>}
          {(()=>{ const pulsable = c.n > 0; return (
          <div
            onClick={pulsable ? ()=>irAModuloGlobal(c.modulo) : undefined}
            role={pulsable ? "button" : undefined}
            tabIndex={pulsable ? 0 : undefined}
            title={(c as any).ayuda || (pulsable ? `Ver ${c.label}` : undefined)}
            onKeyDown={pulsable ? (ev:any)=>{ if(ev.key==="Enter"||ev.key===" "){ ev.preventDefault(); irAModuloGlobal(c.modulo); } } : undefined}
            style={{display:"flex", alignItems:"center", gap:6, minWidth:0,
              cursor: pulsable ? "pointer" : "default",
              borderRadius:UI.rControl, padding:"3px 5px", margin:"-3px -5px",
              transition:"background 0.18s", WebkitTapHighlightColor:"transparent"}}
            onMouseEnter={(ev:any)=>{ if(pulsable) ev.currentTarget.style.background = UI.hover; }}
            onMouseLeave={(ev:any)=>{ ev.currentTarget.style.background = "transparent"; }}>
            <span style={{color:T_LIGHT.gold, display:"inline-flex", flexShrink:0, transform:"scale(0.9)"}}>{c.icon}</span>
            <span style={{fontFamily:fontSerif, fontSize:isMobile?14:15, fontWeight:800, color:T_LIGHT.textInk, lineHeight:1}}>{c.n}</span>
            <span style={{fontSize:isMobile?10.5:11.5, color:T_LIGHT.textInkSoft, fontWeight:600, whiteSpace:"nowrap" as const}}>{c.label}</span>
            {!!(c as any).sub && (
              <span style={{fontSize:isMobile?10:11, color:T_LIGHT.textInkMut, fontWeight:600, whiteSpace:"nowrap" as const}}>· {(c as any).sub}</span>
            )}
          </div>); })()}
        </React.Fragment>
      ))}

      {/* Resumen de Créditos (derecha, empujado por marginLeft:auto) */}
      {_kc.hayCreditos && (
        <div style={{display:"flex", alignItems:"center", gap: isMobile?9:12, marginLeft:"auto", flexShrink:0, paddingLeft: isMobile?9:13}}>
          {/* Divisor central que separa contadores de créditos */}
          <span aria-hidden style={{width:1, height:18, background:T_LIGHT.border, flexShrink:0}}/>
          <div style={{display:"flex", alignItems:"center", gap:7, minWidth:0, flexWrap:"wrap" as const, rowGap:2}}>
            <span style={{color:"#1E3A8A", display:"inline-flex", flexShrink:0, transform:"scale(0.9)"}}>{_icoCred}</span>
            <span style={{fontFamily:fontSerif, fontSize:isMobile?14:15, fontWeight:800, color:T_LIGHT.textInk, lineHeight:1}}>{_cActivos}</span>
            <span style={{fontSize:isMobile?10.5:11.5, color:T_LIGHT.textInkSoft, fontWeight:600}}>Créditos</span>
            <span aria-hidden style={{color:T_LIGHT.textInkMut}}>·</span>
            {_cActivos===0 ? (
              <span style={{fontSize:isMobile?11:12, fontWeight:700, color:T_LIGHT.textInkMut}}>sin activos</span>
            ) : _cEnMora > 0 ? (
              <span style={{fontSize:isMobile?11:12, fontWeight:800, color:T_LIGHT.danger}}>{_cEnMora} en mora</span>
            ) : _cVencidos > 0 ? (
              // Escalón que faltaba: vencido pero aún dentro de los 30 días. Antes
              // caía en el "else" y se anunciaba como "Al corriente ✓", justo en la
              // ventana en la que todavía se puede cobrar sin ir a lo legal.
              <span style={{fontSize:isMobile?11:12, fontWeight:800, color:T_LIGHT.warn}}>{_cVencidos} con pago vencido</span>
            ) : (
              <span style={{fontSize:isMobile?11:12, fontWeight:800, color:TONE_COLORS.ok}}>Al corriente ✓</span>
            )}
            <AyudaTip texto={_cAyuda} />
            {/* Éste no estaba señalado y es exactamente lo mismo: un salto de
                módulo colgado de una prop opcional. Se pasa también, porque dejar
                uno con la forma vieja es lo que hace que nadie recuerde por qué. */}
            <button onClick={()=>irAModuloGlobal("creditos")}
              style={{border:"none", background:"transparent", padding:0, cursor:"pointer", color:"#1E3A8A", fontWeight:700, fontSize:isMobile?11:12, fontFamily:"inherit", whiteSpace:"nowrap" as const}}>
              Ver detalle →
            </button>
          </div>
        </div>
      )}
    </div>
  );

  return (
    <div style={{marginBottom: isMobile?14:20}}>

      {/* ── Registros activos + KPIs operativos (Vehículos aparte, vencimientos) ──
         El cumplimiento de VEHÍCULOS/flotilla queda en su propia tarjeta, fuera
         de la sección de empleados (es de flotilla, no de empleados). */}
      <div style={{display:"flex", flexDirection:"column" as const, gap: isMobile?8:10}}>
        {/* TRES COLUMNAS IGUALES. Los tres bloques tienen la misma forma —renglones
           de hecho con su detalle—, así que reparten el ancho por igual. Antes uno
           ocupaba un tercio, otro dos tercios y el tercero la fila entera: el hecho
           y su detalle acababan separados por más de mil píxeles, y sobraba vacío.
           `alignItems:"stretch"` (por defecto en grid) les da la misma altura; las
           tarjetas usan height:100% para llenarla. */}
        {/* ── POR DÓNDE EMPEZAR ─────────────────────────────────────────────────
           SUSTITUYE a la fila de tres columnas mientras la cuenta está vacía, no se
           añade encima: tres tarjetas diciendo "sin vehículos", "todo al día" y "aún
           no das de alta empleados" no aportan nada y ocupan lo mejor de la pantalla.
           Desaparece en cuanto haya UN empleado o UNA unidad; a partir de ahí el
           tablero normal ya sabe decir qué falta.
           Sin barra de progreso ni "0 de 2 pasos": acabamos de retirar los
           porcentajes sin base de esta misma pantalla, y un contador de arranque
           sería lo mismo con otro nombre. */}
        {cuentaVacia && (
        <div style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rTarjeta,
          borderTop:`3px solid ${UI.oro}`, padding: isMobile?"16px 16px":"18px 20px", boxShadow:UI.sombra}}>
          <div style={{fontFamily:fontSerif, fontSize:isMobile?16:19, fontWeight:700, color:UI.texto, marginBottom:4}}>
            Por dónde empezar
          </div>
          <div style={{fontSize:UI.fsCuerpo, color:UI.textoSuave, marginBottom:14, lineHeight:1.5}}>
            Tu cuenta está lista. Carga tu información y la plataforma empieza a trabajar.
          </div>
          <div style={{display:"flex", flexDirection:"column" as const, gap:0}}>
            {([
              // VA PRIMERO, y no por orden alfabético: sin estos datos no se puede
              // emitir un solo documento firmado. Todo lo demás de la plataforma
              // funciona sin ellos; los recibos, las bitácoras, las actas y el
              // aviso de privacidad, no —tendrían que nombrar a una empresa que la
              // plataforma no sabe cómo se llama—.
              // LOS TRES VAN POR LA MISMA PUERTA, `irAModuloGlobal`. Dos de ellos
              // usaban props opcionales enhebradas por dos componentes: si alguna no
              // llegaba, el renglón seguía pintándose con cursor de mano y no hacía
              // nada. Ahora ninguno depende de que le pasen algo.
              {n:"1", t:"Captura los datos de tu empresa", d:"Nombre o razón social, RFC, domicilio y correo de contacto. Es con lo que se firman tus documentos.", modulo:"datos_empresa" as AppPantalla},
              {n:"2", t:"Carga a tus empleados", d:"Impórtalos desde Excel o desde un documento con IA, o captúralos uno a uno.", modulo:"empleados" as AppPantalla},
              // El paso 3 se declara SALTABLE: un despacho sin flotilla no debe
              // sentir que le falta algo por no tener vehículos.
              {n:"3", t:"Carga tus unidades", d:"Si tienes flotilla. Si no, sáltalo.", modulo:"flotilla" as AppPantalla},
            ]).map((s:any, i:number)=>(
              // UN <button> DE VERDAD, no un div con `role="button"`. Un div sigue
              // pareciendo pulsable aunque su manejador falte; un botón sin
              // `onClick` no existe. Y trae gratis el teclado, el foco y el lector
              // de pantalla, que antes había que escribir a mano.
              <button key={s.n} type="button"
                onClick={()=>irAModuloGlobal(s.modulo)}
                style={{display:"flex", alignItems:"flex-start", gap:12, cursor:"pointer",
                  width:"100%", textAlign:"left" as const, font:"inherit", background:"transparent",
                  border:"none", borderTop: i===0 ? "none" : `1px solid ${UI.divisor}`,
                  padding:"11px 8px", margin:"0 -8px", borderRadius:UI.rControl,
                  transition:"background 0.18s", WebkitTapHighlightColor:"transparent"}}
                onMouseEnter={(ev:any)=>{ ev.currentTarget.style.background = UI.hover; }}
                onMouseLeave={(ev:any)=>{ ev.currentTarget.style.background = "transparent"; }}>
                <span style={{width:22, height:22, borderRadius:"50%", flexShrink:0,
                  background:UI.oro, color:"#0B1829", display:"flex", alignItems:"center", justifyContent:"center",
                  fontSize:12, fontWeight:800, fontFamily:fontSerif, marginTop:1}}>{s.n}</span>
                <div style={{minWidth:0, flex:1}}>
                  <div style={{fontSize:UI.fsNombre, color:UI.texto, fontWeight:700, lineHeight:1.3}}>{s.t}</div>
                  <div style={{fontSize:UI.fsEtiqueta, color:UI.textoSuave, marginTop:2, lineHeight:1.45}}>{s.d}</div>
                </div>
                <span aria-hidden style={{color:UI.navy, fontWeight:700, fontSize:UI.fsEtiqueta, flexShrink:0, marginTop:3}}>›</span>
              </button>
            ))}
          </div>
          {/* CIERRE, no un paso: no tiene destino ni acción, así que numerarlo junto
              a dos que sí se pueden ejecutar lo haría leer como un pendiente
              imposible de cumplir. Va con menos peso, debajo de los dos pasos. */}
          <div style={{fontSize:UI.fsEtiqueta, color:UI.textoTenue, marginTop:12, paddingTop:11,
            borderTop:`1px solid ${UI.divisor}`, lineHeight:1.5}}>
            Cuando tengas gente cargada, aquí verás lo que vence, quién checó y qué firmaste.
          </div>
        </div>
        )}

        {/* DOS FILAS DE DOS, SIN HUECO. Con "En la calle" dentro son cuatro
           tarjetas, y en tres columnas la cuarta se quedaba sola con un vacío a
           su derecha. El número de columnas se saca del número de tarjetas: con
           cuatro, dos columnas; con tres —cuando no hay ninguna unidad fuera—,
           tres. Ninguna tarjeta se queda sola en su fila.

           Y EL ORDEN AGRUPA POR NATURALEZA, no por urgencia. Arriba, lo que está
           pasando AHORA MISMO: qué unidades andan en la calle y cómo está el
           equipo. Abajo, lo PENDIENTE: lo que vence y lo que le falta a la
           flotilla. Cada fila contesta una pregunta entera en vez de dejar dos
           parejas arbitrarias.

           Baja "Requieren tu atención" de la primera fila, y se acepta a
           conciencia: no es la única vía a lo urgente —el mismo contenido vive
           en la campana del top bar, con su contador siempre visible—, así que
           no se pierde nada por leerlo un renglón más abajo. */}
        {!cuentaVacia && (
        <div style={{display:"grid",
          gridTemplateColumns: isMobile ? "1fr" : isTablet ? "1fr 1fr" : (fuera.length > 0 ? "1fr 1fr" : "repeat(3, 1fr)"),
          gap: isMobile?8:10, alignItems:"stretch"}}>
          {/* Flotilla en HECHOS. El porcentaje anterior contaba una unidad sin
              fechas capturadas como 0% de cumplimiento —afirmar incumplimiento a
              partir de un dato ausente— y por eso se retiró también de Flotilla.
              La cifra suma las unidades que exigen que hagas algo, y el pie dice
              de qué está hecha: no es un agregado opaco. */}
          {/* RESUMEN DEL MÓDULO, no una bandeja de pendientes. Antes contaba
              pendientes igual que su vecina y por eso se solapaban: las unidades
              vencidas salían en las dos y el patrón podía sumarlas. Un resumen de
              estado y una bandeja de pendientes pueden nombrar el mismo seguro
              vencido sin contradecirse, así que la aclaración sobra.
              La cifra grande es el parque; el pie, su estado documental. Las tres
              son las MISMAS que muestra Flotilla por dentro. */}
          {/* MISMA ESTRUCTURA DE RENGLONES que la tarjeta de al lado: un módulo se
              lee como una lista de estados, no como una estadística. Con un número
              grande y una línea de texto la tarjeta quedaba hueca dos tercios de su
              altura y la fila no se leía como un solo sistema.
              El total va al PIE, como cierre. Los puntos usan los mismos colores
              que Flotilla por dentro, y "sin registrar" NUNCA en rojo: es ausencia
              de dato, no incumplimiento. */}
          <div style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rTarjeta,
            borderTop:`3px solid ${tonoGrafico(toneFlota)}`, padding:"14px 16px", boxShadow:UI.sombra,
            height:"100%", boxSizing:"border-box" as const, order:4,
            display:"flex", flexDirection:"column" as const}}>
            <div style={{display:"flex", alignItems:"center", gap:10, marginBottom:8}}>
              <AxisIcon name="flotilla" size={15} color={tonoGrafico(toneFlota)} withBackdrop={false} strokeWidth={2.4}/>
              <span style={{fontSize:UI.fsRotulo, color:UI.textoTenue, fontWeight:700, letterSpacing:"0.8px", textTransform:"uppercase" as const}}>
                Flotilla
              </span>
            </div>
            {!kpis.hayVehiculos ? (
              <div style={{fontSize:UI.fsCuerpo, color:UI.textoSuave, padding:"6px 0 2px"}}>
                Aún no das de alta unidades.
              </div>
            ) : (<>
              <div style={{display:"flex", flexDirection:"column" as const, gap:0}}>
                {([
                  {k:"vencida"     as const, n:kpis.vehiculosVencidos,    txt:"con documentación vencida", color:UI.rojoVivo},
                  {k:"por_vencer"  as const, n:kpis.vehiculosPorVencer,   txt:"por vencer en 30 días",     color:UI.ambarVivo},
                  {k:"sin_registro"as const, n:kpis.vehiculosSinRegistro, txt:"sin registrar",             color:UI.textoTenue},
                ]).map((r, i) => {
                  // Un renglón en cero no lleva a ninguna parte: se apaga y deja de
                  // ser pulsable, para no mandar a nadie a una tabla vacía.
                  const pulsable = r.n > 0 && !!onGoFlotillaFiltrada;
                  return (
                    <div key={r.k}
                      onClick={pulsable ? ()=>onGoFlotillaFiltrada!(r.k) : undefined}
                      role={pulsable ? "button" : undefined} tabIndex={pulsable ? 0 : undefined}
                      onKeyDown={pulsable ? (ev:any)=>{ if(ev.key==="Enter"||ev.key===" "){ ev.preventDefault(); onGoFlotillaFiltrada!(r.k); } } : undefined}
                      style={{display:"flex", alignItems:"baseline", gap:"2px 8px",
                        flexWrap:"wrap" as const,
                        cursor: pulsable ? "pointer" : "default", opacity: r.n > 0 ? 1 : 0.45,
                        padding:"7px 6px", margin:"0 -6px", borderRadius:UI.rControl,
                        borderTop: i===0 ? "none" : `1px solid ${UI.divisor}`,
                        transition:"background 0.18s", WebkitTapHighlightColor:"transparent"}}
                      onMouseEnter={(ev:any)=>{ if(pulsable) ev.currentTarget.style.background = UI.hover; }}
                      onMouseLeave={(ev:any)=>{ ev.currentTarget.style.background = "transparent"; }}>
                      <span aria-hidden style={{width:6, height:6, borderRadius:"50%", flexShrink:0,
                        background:r.color, transform:"translateY(-2px)"}}/>
                      <span style={{fontFamily:fontSerif, fontSize:isMobile?14:15, fontWeight:800, color:UI.texto,
                        minWidth:18, flexShrink:0}}>{r.n}</span>
                      <span style={{fontSize:UI.fsCuerpo, color:UI.texto, fontWeight:600, minWidth:0}}>{r.txt}</span>
                    </div>
                  );
                })}
              </div>
              <div style={{display:"flex", alignItems:"baseline", gap:6, flexWrap:"wrap" as const,
                marginTop:"auto", paddingTop:8, borderTop:`1px solid ${UI.divisor}`}}>
                <span style={{fontSize:UI.fsEtiqueta, color:UI.textoSuave}}>
                  {kpis.registrosActivos.vehiculos} {kpis.registrosActivos.vehiculos===1 ? "unidad activa" : "unidades activas"}
                  {" · "}{kpis.vehiculosEnRegla} en regla
                </span>
                <button onClick={()=>irAModuloGlobal("flotilla")}
                  style={{marginLeft:"auto", background:"transparent", border:"none", color:UI.navy,
                    fontWeight:700, fontSize:UI.fsEtiqueta, cursor:"pointer", fontFamily:"inherit", padding:"2px 0"}}>
                  Ver ›
                </button>
              </div>
            </>)}
          </div>

          {/* LA TARJETA ANCHA. Es el TOTAL de vencimientos de la cuenta y la unica
              de la fila que muestra hechos concretos. No calcula nada: lee los
              mismos `atencionUrgente` que alimentan la campana, ya ordenados
              (vencidos primero, luego lo mas proximo) y toma los tres primeros. */}
          <div style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rTarjeta,
            borderTop:`3px solid ${tonoGrafico(toneAtencion)}`, padding:"14px 16px", boxShadow:UI.sombra,
            height:"100%", boxSizing:"border-box" as const, order:3,
            display:"flex", flexDirection:"column" as const}}>
            <div style={{display:"flex", alignItems:"center", gap:10, marginBottom:8}}>
              <AxisIcon name="alert" size={15} color={tonoGrafico(toneAtencion)} withBackdrop={false} strokeWidth={2.4}/>
              <span style={{fontSize:UI.fsRotulo, color:UI.textoTenue, fontWeight:700, letterSpacing:"0.8px", textTransform:"uppercase" as const}}>
                Requieren tu atención
              </span>
              <span style={{fontFamily:fontSerif, fontSize:isMobile?20:24, fontWeight:700, color:UI.texto, lineHeight:1, marginLeft:"auto"}}>
                {totalAtencion === 0 ? "Todo al día" : totalAtencion}
              </span>
            </div>
            {totalAtencion === 0 ? (
              <div style={{fontSize:UI.fsCuerpo, color:UI.textoSuave, padding:"6px 0 2px"}}>
                {atencion.frase}
              </div>
            ) : (<>
              {/* EL CONTADOR DE ACCIDENTES, encima de los renglones: aquí solo caben
                  tres, y un accidente con lesionados que quede fuera no puede pasar
                  desapercibido. Cuenta todos los de la ventana. */}
              {!!atencion.conteoAccidentes && (
                <div style={{fontSize:UI.fsEtiqueta, fontWeight:700, color:UI.rojoVivo, margin:"0 0 4px"}}>{atencion.conteoAccidentes}</div>
              )}
              <div style={{display:"flex", flexDirection:"column" as const, gap:0}}>
                {atencion.filas.slice(0,3).map((fa:FilaAtencion, i:number)=>{
                  const it:any = fa.item;
                  return (
                  // El renglón va a SU asunto —el expediente de esa unidad, ese
                  // crédito, ese trabajador—. Antes abría el panel de avisos: el
                  // usuario pulsaba una lista y obtenía otra lista de lo mismo.
                  // "Ver todo ›" sí sigue abriendo la lista completa.
                  // UN ACCIDENTE NO TIENE `item`: va a su propio destino en Flotilla,
                  // el mismo al que lleva el escudo. Sin esto, pulsarlo no hacía nada.
                  <div key={fa.clave}
                    onClick={()=> onIrItem ? onIrItem(fa.esAccidente
                      ? ({modulo:"flotilla", refId:fa.accidente?.id, refTipo:"accidente"} as any) : it) : abrirAvisos()}
                    role="button" tabIndex={0} title="Abrir este asunto"
                    onKeyDown={(ev:any)=>{ if(ev.key==="Enter"||ev.key===" "){ ev.preventDefault(); onIrItem ? onIrItem(fa.esAccidente
                      ? ({modulo:"flotilla", refId:fa.accidente?.id, refTipo:"accidente"} as any) : it) : abrirAvisos(); } }}
                    style={{display:"flex", alignItems:"baseline", gap:"2px 8px", cursor:"pointer",
                      flexWrap:"wrap" as const,
                      padding:"7px 6px", margin:"0 -6px", borderRadius:UI.rControl,
                      borderTop: i===0 ? "none" : `1px solid ${UI.divisor}`,
                      transition:"background 0.18s", WebkitTapHighlightColor:"transparent"}}
                    onMouseEnter={(ev:any)=>{ ev.currentTarget.style.background = UI.hover; }}
                    onMouseLeave={(ev:any)=>{ ev.currentTarget.style.background = "transparent"; }}>
                    {/* El tono lo decide `tonoDePlazo`, el mismo que la campana:
                        rojo solo lo vencido, ámbar fuerte lo que vence hoy o en
                        dos días, ámbar lo demás. Esta lista lo decidía por su
                        cuenta con un ternario propio y no distinguía lo inminente. */}
                    <span aria-hidden style={{width:6, height:6, borderRadius:"50%", flexShrink:0,
                      background: fa.esAccidente ? UI.rojoVivo : tonoDePlazo(it).color, transform:"translateY(-2px)"}}/>
                    <span style={{fontSize:UI.fsCuerpo, color:UI.texto, fontWeight:600, minWidth:0}}>{fa.titulo}</span>
                    {fa.esAccidente && <EtiquetaLesionadosChip accidente={fa.accidente} tema="claro"/>}
                    {/* Sin `marginLeft:auto`: el detalle se queda junto a su hecho y,
                        si no cabe, baja a la línea siguiente en vez de irse al borde. */}
                    <span style={{fontSize:UI.fsEtiqueta, color: fa.esAccidente ? UI.rojoVivo : tonoDePlazo(it).color,
                      fontWeight:600}}>{fa.detalle}</span>
                    {/* CUÁNDO FUE. Dos renglones iguales —mismo trabajador, misma
                        unidad— solo se distinguen por aquí. Mismo formato que la
                        campana de actividad; ver `cuandoTexto`. */}
                    {!!fa.cuando && <span style={{fontSize:UI.fsEtiqueta, color:UI.textoTenue}}>{fa.cuando}</span>}
                  </div>
                  );
                })}
              </div>
              <button onClick={abrirAvisos}
                style={{alignSelf:"flex-start", marginTop:"auto", paddingTop:8, background:"transparent", border:"none",
                  color:UI.navy, fontWeight:700, fontSize:UI.fsEtiqueta, cursor:"pointer",
                  fontFamily:"inherit", padding:"2px 0"}}>
                {totalAtencion > 3 ? `Ver los ${totalAtencion} ›` : "Ver todo ›"}
              </button>
            </>)}
          </div>

      {/* ── UNIDADES FUERA AHORA ──────────────────────────────────────────────
         Aviso propio, en tono informativo. NO entra en "Requieren tu atención":
         que una unidad esté en la calle es el trabajo normal de la empresa, no
         un incumplimiento, y meterla en el cubo de urgentes convertiría la
         operación de cada día en una alarma.
         Y NO HAY UMBRAL de "lleva demasiado tiempo fuera": eso sería una regla
         inventada. Se enseña el hecho —qué unidad, desde cuándo, quién la sacó—
         y quien conoce su operación decide si le parece mucho.
         La tarjeta solo existe si hay alguna: un "0 unidades fuera" ocupa sitio
         para no decir nada. */}
      {fuera.length > 0 && (
        <div style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rTarjeta,
          borderTop:`3px solid ${UI.neutro}`, padding:"14px 16px", boxShadow:UI.sombra,
          height:"100%", boxSizing:"border-box" as const, order:1,
          display:"flex", flexDirection:"column" as const}}>
          <div style={{display:"flex", alignItems:"center", gap:10, marginBottom:8}}>
            <AxisIcon name="flotilla" size={15} color={UI.textoTenue} withBackdrop={false} strokeWidth={2.4}/>
            <span style={{fontSize:UI.fsRotulo, color:UI.textoTenue, fontWeight:700, letterSpacing:"0.8px", textTransform:"uppercase" as const}}>
              En la calle
            </span>
            <span style={{fontFamily:fontSerif, fontSize:isMobile?20:24, fontWeight:700, color:UI.texto, lineHeight:1, marginLeft:"auto"}}>
              {fuera.length}
            </span>
          </div>
          <div style={{fontSize:UI.fsCuerpo, color:UI.textoSuave, marginBottom:6}}>
            Ahora mismo {fuera.length===1 ? "hay 1 unidad fuera" : `hay ${fuera.length} unidades fuera`}.
          </div>
          <div style={{display:"flex", flexDirection:"column" as const, gap:0}}>
            {fuera.slice(0,3).map((v:any, i:number)=>{
              // Lleva AL VIAJE, no al módulo, y por su id. Si no hay a dónde ir,
              // el renglón no finge ser un botón.
              const irAlViaje = onGoViaje ? ()=>onGoViaje(v.id) : undefined;
              const quien = v.conductor || "Sin conductor registrado";
              return (
                <div key={v.id}
                  onClick={irAlViaje}
                  role={irAlViaje ? "button" : undefined} tabIndex={irAlViaje ? 0 : undefined}
                  title={irAlViaje ? "Abrir este viaje" : undefined}
                  onKeyDown={(ev:any)=>{ if(irAlViaje && (ev.key==="Enter"||ev.key===" ")){ ev.preventDefault(); irAlViaje(); } }}
                  style={{display:"flex", alignItems:"baseline", gap:"2px 8px", cursor:irAlViaje?"pointer":"default",
                    flexWrap:"wrap" as const, padding:"7px 6px", margin:"0 -6px", borderRadius:UI.rControl,
                    borderTop: i===0 ? "none" : `1px solid ${UI.divisor}`,
                    transition:"background 0.18s", WebkitTapHighlightColor:"transparent"}}
                  onMouseEnter={(ev:any)=>{ if(irAlViaje) ev.currentTarget.style.background = UI.hover; }}
                  onMouseLeave={(ev:any)=>{ ev.currentTarget.style.background = "transparent"; }}>
                  <span style={{fontSize:UI.fsCuerpo, color:UI.texto, fontWeight:600, minWidth:0}}>
                    {v.placa || "Unidad sin placa"}
                  </span>
                  <span style={{fontSize:UI.fsEtiqueta, color:UI.textoSuave}}>
                    salió {cuandoRelativoAxis(v.salida?.d || null)} · {quien}
                  </span>
                </div>
              );
            })}
          </div>
          {fuera.length > 3 && (
            <button onClick={()=>irAModuloGlobal("flotilla")}
              style={{alignSelf:"flex-start", marginTop:"auto", paddingTop:8, background:"transparent", border:"none",
                color:UI.navy, fontWeight:700, fontSize:UI.fsEtiqueta, cursor:"pointer", fontFamily:"inherit", padding:"2px 0"}}>
              {`Ver las ${fuera.length} ›`}
            </button>
          )}
        </div>
      )}
      {/* ── EQUIPO, EN HECHOS ─────────────────────────────────────────────────
         Aquí vivían tres medidores circulares con porcentaje. Se retiraron: con
         la base actual mentían en las dos direcciones —un "100%" sacado de un
         solo expediente, un "0%" en rojo del checador—, y un porcentaje sin base
         suficiente no ayuda a decidir. En la primera pantalla, además, cuesta
         credibilidad. Mismo tratamiento visual que los renglones de "Requieren tu
         atención": punto, hecho, detalle a la derecha. Ningún renglón en rojo por
         ausencia de dato. */}
      <div style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rTarjeta,
        borderTop:`3px solid ${UI.neutro}`, padding:"14px 16px", boxShadow:UI.sombra,
        height:"100%", boxSizing:"border-box" as const, order:2,
        display:"flex", flexDirection:"column" as const}}>
        <div style={{display:"flex", alignItems:"center", gap:10, marginBottom:8}}>
          <AxisIcon name="user_single" size={15} color={UI.textoTenue} withBackdrop={false} strokeWidth={2.4}/>
          <span style={{fontSize:UI.fsRotulo, color:UI.textoTenue, fontWeight:700, letterSpacing:"0.8px", textTransform:"uppercase" as const}}>
            Tu equipo
          </span>
        </div>
        <div style={{display:"flex", flexDirection:"column" as const, gap:0}}>
          {(()=>{
            // Los tres hechos y su redacción vienen de `hechosDelEquipo`, la misma
            // que lee la app. Aquí solo se traduce el destino a la navegación de
            // esta pantalla.
            // CADA RENGLÓN DICE SU DESTINO. Dos de los tres son saltos de módulo a
            // secas y van por la puerta única: ya no cuelgan de una prop opcional
            // que pueda no llegar.
            //
            // EL TERCERO NO PUEDE IR POR AHÍ, y conviene que quede escrito para que
            // dentro de tres meses no parezca un olvido: abre Empleados ACOTADO a
            // unos correos, y la puerta solo sabe de módulos, no lleva carga.
            // Lo que sí se arregla es que mentía. El manejador se construía siempre
            // —una flecha nunca es falsa—, así que el renglón se pintaba pulsable
            // aunque la prop no hubiera llegado, y al pulsarlo no pasaba nada.
            // Ahora se pregunta por la prop, no por la flecha.
            const filas = hechosEquipo.map((h:any)=>({
              ...h,
              ir: h.destino === "sin_checar" ? (onGoEmpleadosFoco ? ()=> onGoEmpleadosFoco(h.emails||[]) : undefined)
                : h.destino === "empleados" ? ()=>irAModuloGlobal("empleados")
                : h.destino === "tareas" ? ()=>irAModuloGlobal("tareas") : undefined,
            }));
            return filas.map((r:any, i:number) => {
              const pulsable = !!r.ir;
              return (
                <div key={r.k}
                  onClick={pulsable ? r.ir : undefined}
                  role={pulsable ? "button" : undefined} tabIndex={pulsable ? 0 : undefined}
                  onKeyDown={pulsable ? (ev:any)=>{ if(ev.key==="Enter"||ev.key===" "){ ev.preventDefault(); r.ir(); } } : undefined}
                  style={{display:"flex", alignItems:"baseline", gap:"2px 8px",
                    flexWrap:"wrap" as const,
                    cursor: pulsable ? "pointer" : "default",
                    padding:"7px 6px", margin:"0 -6px", borderRadius:UI.rControl,
                    borderTop: i===0 ? "none" : `1px solid ${UI.divisor}`,
                    transition:"background 0.18s", WebkitTapHighlightColor:"transparent"}}
                  onMouseEnter={(ev:any)=>{ if(pulsable) ev.currentTarget.style.background = UI.hover; }}
                  onMouseLeave={(ev:any)=>{ ev.currentTarget.style.background = "transparent"; }}>
                  <span aria-hidden style={{width:6, height:6, borderRadius:"50%", flexShrink:0,
                    background:r.color, transform:"translateY(-2px)"}}/>
                  <span style={{fontSize:UI.fsCuerpo, color:UI.texto, fontWeight:600, minWidth:0}}>{r.texto}</span>
                  {r.detalle && (
                    <span style={{fontSize:UI.fsEtiqueta, color:r.tono, fontWeight:600}}>{r.detalle}</span>
                  )}
                </div>
              );
            });
          })()}
        </div>
      </div>
        </div>
        )}
      </div>


      {/* ── ACTIVIDAD RECIENTE ────────────────────────────────────────────────
         Ancho completo, debajo de la fila de tres. Mismo tratamiento de renglones
         que los tres bloques de arriba: punto de color, hecho, y el cuándo junto
         a él. Todo sale de memoria: no cuesta una sola lectura extra.

         ESTA TARJETA CORTABA A OCHO Y NO TENÍA RUTA AL NOVENO. Sus dos hermanas
         de la fila de arriba sí tienen su "Ver todo"; ésta no, y el corte no era
         sobre una lista corta: era sobre TODO el historial de la cuenta. Con
         quince empleados marcando entrada, comida, regreso y salida, un día
         normal genera del orden de sesenta filas para ocho huecos: el feed no
         enseñaba "lo reciente", enseñaba la última hora, y una salida de unidad
         de la mañana ya no estaba en ninguna parte.

         Y ES BARATO: los datos ya están en memoria. "Ver todo" no añade una sola
         lectura, solo deja de tirar lo que ya se tiene. */}
      {actividadReciente.length > 0 && (
        <div style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rTarjeta,
          borderTop:`3px solid ${UI.neutro}`, padding:"14px 16px", boxShadow:UI.sombra,
          marginBottom: isMobile?8:10}}>
          <div style={{display:"flex", alignItems:"center", gap:10, marginBottom:8}}>
            <AxisIcon name="clipboard" size={15} color={UI.textoTenue} withBackdrop={false} strokeWidth={2.4}/>
            <span style={{fontSize:UI.fsRotulo, color:UI.textoTenue, fontWeight:700, letterSpacing:"0.8px", textTransform:"uppercase" as const}}>
              Actividad reciente
            </span>
            <span style={{fontFamily:fontSerif, fontSize:isMobile?20:24, fontWeight:700, color:UI.texto, lineHeight:1, marginLeft:"auto"}}>
              {actividadReciente.length}
            </span>
          </div>

          {/* LOS FILTROS SOLO SE OFRECEN SI HAY ALGO DETRÁS. Un botón que lleva a
             una lista vacía hace perder el tiempo, y con el tope quitado la
             cuenta de cada familia ya es un dato real. */}
          {familiasConFilas.length > 1 && (
            <div style={{display:"flex", gap:6, flexWrap:"wrap" as const, marginBottom:10}}>
              {([{k:"todo" as const, label:"Todo", n:actividadReciente.length}]
                .concat(familiasConFilas as any)).map((f:any)=>{
                const on = feedFamilia === f.k;
                return (
                  <button key={f.k} onClick={()=>setFeedFamilia(f.k)}
                    style={{background: on ? UI.navy : "transparent",
                      border:`1px solid ${on ? UI.navy : UI.borde}`, color: on ? "#fff" : UI.textoSuave,
                      borderRadius:999, padding:"5px 12px", cursor:"pointer", fontFamily:"inherit",
                      fontSize:UI.fsEtiqueta, fontWeight:700, whiteSpace:"nowrap" as const,
                      transition:"background 0.18s, border-color 0.18s"}}>
                    {f.label} <span style={{opacity:0.7, fontWeight:600}}>{f.n}</span>
                  </button>
                );
              })}
            </div>
          )}
          {/* SEPARADO POR DÍA, CON EL MISMO ENCABEZADO QUE EL MÓVIL. "Hoy · 7 sep",
             "Ayer · 6 sep", y de ahí la fecha. No es un rótulo nuevo: es
             `etiquetaDiaAxis`, la que ya usaba la bitácora del portal, subida a
             nivel de módulo para que las dos pantallas lo hagan igual.
             Un rótulo y no un filtro: un filtro añade un control que hay que
             aprender y que hay que acordarse de quitar.
             Dentro de HOY se queda el tiempo relativo que ya usaba —"hace 3 h"
             se lee de un vistazo—; en los días anteriores va la hora, porque
             "hace 2 días" obliga a hacer la cuenta para saber cuándo fue. */}
          <div style={{display:"flex", flexDirection:"column" as const, gap:0,
            // Abierto, la lista puede ser larga: se desplaza dentro de su tarjeta
            // en vez de empujar el resto de Inicio hacia abajo.
            ...(feedAbierto ? {maxHeight: isMobile?420:520, overflowY:"auto" as const, paddingRight:4} : {})}}>
            {agruparPorDiaAxis(feedVisible, (ev:any)=> ev.ms ? new Date(ev.ms) : null).map((g, gi)=>{
              const esHoy = !!g.d && diaRelativoAxis(g.d) === "Hoy";
              return (
                <React.Fragment key={g.key}>
                  <div style={{fontSize:UI.fsRotulo, fontWeight:700, letterSpacing:"0.8px",
                    textTransform:"uppercase" as const, color:UI.textoTenue,
                    padding: gi===0 ? "2px 0 6px" : "12px 0 6px",
                    borderTop: gi===0 ? "none" : `1px solid ${UI.divisor}`,
                    marginTop: gi===0 ? 0 : 4}}>
                    {etiquetaDiaAxis(g.d)}
                  </div>
                  {g.items.map((ev:any, i:number) => {
                    const ir = ev.destino && onIrDestino ? ()=>onIrDestino(ev.destino) : undefined;
                    const pulsable = !!ir;
                    const d = ev.ms ? new Date(ev.ms) : null;
                    return (
                      <div key={ev.id}
                        onClick={ir}
                        role={pulsable ? "button" : undefined} tabIndex={pulsable ? 0 : undefined}
                        title={pulsable ? "Ir a donde ocurrió" : undefined}
                        onKeyDown={pulsable ? (evt:any)=>{ if(evt.key==="Enter"||evt.key===" "){ evt.preventDefault(); ir!(); } } : undefined}
                        style={{display:"flex", alignItems:"baseline", gap:"2px 8px", flexWrap:"wrap" as const,
                          cursor: pulsable ? "pointer" : "default",
                          padding:"7px 6px", margin:"0 -6px", borderRadius:UI.rControl,
                          // UN ACCIDENTE NO SE PIERDE ENTRE MOVIMIENTOS. Va con
                          // Flotilla —aparece dos veces al año y no merece un
                          // control propio—, pero su renglón se distingue a
                          // simple vista dentro de la lista.
                          ...(ev.esAccidente ? {borderLeft:`3px solid ${UI.rojoVivo}`, background:"rgba(220,38,38,0.05)", paddingLeft:9} : {}),
                          // El separador de arriba lo pone el encabezado del día:
                          // una línea más dejaría un doble filo.
                          borderTop: i===0 ? "none" : `1px solid ${UI.divisor}`,
                          transition:"background 0.18s", WebkitTapHighlightColor:"transparent"}}
                        onMouseEnter={(evt:any)=>{ if(pulsable) evt.currentTarget.style.background = UI.hover; }}
                        // Al salir el ratón se vuelve a SU fondo, no a transparente:
                        // si no, pasar por encima de un accidente le borraba el tinte.
                        onMouseLeave={(evt:any)=>{ evt.currentTarget.style.background = ev.esAccidente ? "rgba(220,38,38,0.05)" : "transparent"; }}>
                        <span aria-hidden style={{width:6, height:6, borderRadius:"50%", flexShrink:0,
                          background:ev.color, transform:"translateY(-2px)"}}/>
                        <span style={{fontSize:UI.fsCuerpo, color:UI.texto, fontWeight:600, minWidth:0}}>{ev.texto}</span>
                        <span style={{fontSize:UI.fsEtiqueta, color:UI.textoTenue, fontWeight:600}}>
                          · {esHoy ? _hace(ev.ms) : (d ? d.toLocaleTimeString("es-MX",{hour:"2-digit",minute:"2-digit"}) : "—")}
                        </span>
                      </div>
                    );
                  })}
                </React.Fragment>
              );
            })}
          </div>

          {/* LA RUTA AL RENGLÓN NUEVE, que no existía. Mismo control que las dos
             tarjetas hermanas de la fila de arriba. */}
          {feedFiltrado.length > FEED_COLAPSADO && (
            <button onClick={()=>setFeedAbierto(v=>!v)}
              style={{alignSelf:"flex-start", marginTop:8, background:"transparent", border:"none",
                color:UI.navy, fontWeight:700, fontSize:UI.fsEtiqueta, cursor:"pointer",
                fontFamily:"inherit", padding:"2px 0"}}>
              {feedAbierto
                ? "Ver menos ‹"
                : `Ver ${Math.min(feedFiltrado.length, FEED_ABIERTO)} ›`}
            </button>
          )}
          {/* Se dice cuántos quedan fuera incluso abierto: cincuenta es un tope de
             lectura, y callar que hay más sería el mismo defecto en pequeño. */}
          {feedAbierto && feedFiltrado.length > FEED_ABIERTO && (
            <div style={{fontSize:UI.fsEtiqueta, color:UI.textoTenue, marginTop:6}}>
              Se muestran los {FEED_ABIERTO} más recientes de {feedFiltrado.length}.
            </div>
          )}
        </div>
      )}

      {hayContadores && registrosInline}

      {/* Créditos ya no vive aquí: su resumen se integró en la fila de la tira de
         contadores (registrosInline), a la derecha, con divisor. */}

      {/* La lista detallada "Requieren tu atención" vive en la campana 🔔
         del top bar global, no en el cuerpo del dashboard. */}

      {/* (Retirado) El detalle al tocar una dona ya no se monta: las donas se
          fueron y nada podía volver a abrirlo. `DonaMetrica` y `DetalleCumplimiento`
          quedan DEFINIDOS pero sin uso, por si vuelven a hacer falta cuando la base
          de datos dé para un porcentaje honesto. */}
    </div>
  );
}

// ── Franja AXIOR con resumen en lenguaje natural (Fase 3C) ───────────────
// Construye un mensaje desde los KPIs + el ítem más urgente. Sin click,
// puramente informativa. La expresión del avatar se ajusta al estado.
// Insight de AXIOR — NO repite el conteo de pendientes (ya vive en los
// medidores y la campana). En su lugar, identifica el punto MÁS DÉBIL del
// estado de la empresa y propone una acción concreta.
//
// Prioridad de elección del insight:
//   1) Si hay un vencimiento crítico (rojo) → señala el más urgente con CTA
//      a ese módulo.
//   2) Si el cumplimiento más bajo está < 90% → invita a revisarlo.
//   3) Si hay próximos a vencer (ámbar) → señala el primero con CTA.
//   4) Si todo está bien → un mensaje de felicitación, sin CTA.
//   5) Si no hay datos suficientes (sin empleados ni vehículos y sin items)
//      → null → no se renderiza la franja.
// CONSERVADA SIN USAR, junto con `DashboardAxiorStrip`, que es su única lectora.
// La razón está escrita entera ahí abajo, en la cabecera del componente.
function _resumenAxior(kpis: DashboardKpis, items: ItemAtencion[], nombre: string): {
  greeting: string;
  headline: string;
  insight?: string;
  cta?: string;
  ctaModulo?: AppPantalla;
  estado: "ok" | "warn" | "alerta";
} | null {
  const saludo = nombre ? `Hola, ${nombre}.` : "Hola.";

  // No hay datos suficientes → no mostramos franja.
  const sinDatos = !kpis.hayEmpleados && !kpis.hayVehiculos && items.length === 0;
  if (sinDatos) return null;

  // (1) Lo más urgente: un vencimiento crítico rojo
  const vencidoTop = items.find(it => it.severidad === "vencido");
  if (vencidoTop) {
    // Ya no hay vencimientos con `dias === 0`: lo que vence hoy sigue vigente y
    // cae en el bloque ámbar. Aquí un `0` solo puede venir de un asunto que no
    // es una fecha —un proveedor en la lista 69-B—, y de ése no se dice "venció".
    const insight = vencidoTop.dias < 0
      ? `${vencidoTop.titulo} venció hace ${Math.abs(vencidoTop.dias)} día${Math.abs(vencidoTop.dias)!==1?"s":""}. Resolverlo primero evita problemas legales.`
      : `${vencidoTop.titulo} requiere atención inmediata. Resolverlo primero evita problemas legales.`;
    return {
      greeting: saludo,
      headline: "Atiende lo más urgente.",
      insight,
      cta: `Ir a ${vencidoTop.moduloLabel} →`,
      ctaModulo: vencidoTop.modulo,
      estado: "alerta",
    };
  }

  // (2) Cumplimiento más débil < 90%
  type C = { modulo: AppPantalla; label: string; valor: number };
  const cumplimientos: C[] = [];
  if (kpis.hayEmpleados)  cumplimientos.push({modulo: "empleados", label: "empleados",  valor: kpis.cumplimientoEmpleados});
  if (kpis.hayVehiculos)  cumplimientos.push({modulo: "flotilla",  label: "vehículos",  valor: kpis.cumplimientoVehiculos});
  cumplimientos.sort((a,b) => a.valor - b.valor);
  const masDebil = cumplimientos[0];
  if (masDebil && masDebil.valor < 90) {
    const muyBajo = masDebil.valor < 60;
    return {
      greeting: saludo,
      headline: `Tienes el expediente de ${masDebil.label} capturado al ${masDebil.valor}%.`,
      insight: muyBajo
        ? "Es el punto más flojo de tu operación. Completar los expedientes pendientes lo sube al verde."
        : "Un par de documentos al día te llevan al verde.",
      cta: `Revisar ${masDebil.label} →`,
      ctaModulo: masDebil.modulo,
      estado: muyBajo ? "alerta" : "warn",
    };
  }

  // (3) Por vencer próximos (ámbar)
  const porVencerTop = items.find(it => it.severidad === "porVencer");
  if (porVencerTop) {
    const cuando = porVencerTop.dias === 0
      ? "vence hoy"
      : `vence en ${porVencerTop.dias} día${porVencerTop.dias!==1?"s":""}`;
    return {
      greeting: saludo,
      headline: "Tienes algo cerca de vencerse.",
      insight: `${porVencerTop.titulo} ${cuando}. Adelantarte ahora te ahorra una alerta crítica.`,
      cta: `Ir a ${porVencerTop.moduloLabel} →`,
      ctaModulo: porVencerTop.modulo,
      estado: "warn",
    };
  }

  // (4) Todo al día — felicitación, sin CTA
  return {
    greeting: saludo,
    headline: "Tu operación está saludable.",
    insight: "Expedientes capturados y sin vencimientos próximos. Buen trabajo.",
    estado: "ok",
  };
}

// ⚠ CONSERVADO SIN MONTAR. Hoy no se pinta en ninguna pantalla, y es a propósito.
//
// Estuvo en la home y luego dentro del panel del escudo. En los dos sitios decía
// lo mismo que ya estaba a la vista: su titular era el primer renglón de la lista
// que tenía debajo, y su número el que la tarjeta de al lado ya enseñaba. Su
// botón, encima, navegaba peor que el propio renglón —llevaba al módulo, no al
// asunto—. Un copiloto que repite lo que ya se ve deja de leerse, y entonces
// tampoco se lee cuando por fin tiene algo que decir.
//
// VUELVE CUANDO TENGA ALGO QUE LA LISTA NO PUEDA DECIR: cruces entre módulos,
// tendencias, consecuencias. Nada de eso se calcula todavía, así que no se borra
// el componente ni `_resumenAxior`: el día que haya ese material, esto es lo que
// se enchufa.
//
// NO ES LO MISMO QUE EL CHAT DEL BÚHO, que sigue vivo y montado: ahí AXIOR
// responde preguntas, que es una cosa que la lista efectivamente no puede hacer.
function DashboardAxiorStrip({kpis, atencionUrgente, currentUser, isMobile, fontSerif, onIrModulo}: {
  kpis: DashboardKpis;
  atencionUrgente: ItemAtencion[];
  currentUser: any;
  isMobile: boolean;
  fontSerif: string;
  onIrModulo?: (m: AppPantalla) => void;
}) {
  const nombre = (currentUser?.displayName?.split(" ")[0]) || (currentUser?.email?.split("@")[0]) || "";
  const resumen = _resumenAxior(kpis, atencionUrgente, nombre);

  // Si no hay insight útil que entregar, NO renderizamos la franja.
  if (!resumen) return null;
  const {greeting, headline, insight, cta, ctaModulo, estado} = resumen;

  // Expresión del avatar según el estado del insight.
  const expr: "atento"|"explicando"|"confirmado" =
    estado === "ok" ? "confirmado"
    : estado === "alerta" ? "explicando"
    : "atento";

  // Color del CTA según el estado (suave para warn/ok, dorado por defecto).
  const ctaBg     = "linear-gradient(135deg,#D4A843 0%,#B8932A 100%)";
  const ctaShadow = "0 4px 14px rgba(184,147,42,0.40)";

  // ── AXIOR como TILE COMPACTO ───────────────────────────────────────────
  // Tile de mitad de ancho. Avatar circular dorado arriba a la izquierda +
  // etiqueta "AXIOR · TU COPILOTO", headline, insight, CTA dorado.
  const avatarSize = isMobile ? 38 : 42;

  return (
    <div style={{
      background: `
        radial-gradient(120% 90% at 0% 0%, rgba(184,147,42,0.16) 0%, transparent 55%),
        linear-gradient(135deg, #0F1E3D 0%, #142340 100%)
      `,
      border: "1px solid rgba(184,147,42,0.28)",
      borderRadius: 14,
      padding: isMobile ? "11px 13px" : "12px 16px",
      boxShadow: "0 8px 22px rgba(11,24,41,0.18)",
      position: "relative" as const,
      overflow: "hidden",
      display: "flex", flexDirection: "column" as const,
      gap: isMobile ? 8 : 9,
      minWidth: 0,
    }}>
      {/* Línea decorativa dorada superior sutil */}
      <div style={{
        position: "absolute" as const, top: 0, left: 14, right: 14, height: 1,
        background: "linear-gradient(90deg, transparent 0%, rgba(184,147,42,0.45) 50%, transparent 100%)",
        pointerEvents: "none" as const,
      }}/>

      {/* Header: avatar + etiqueta */}
      <div style={{display:"flex", alignItems:"center", gap: isMobile?8:10, minWidth:0}}>
        <div style={{
          width: avatarSize, height: avatarSize, borderRadius: "50%",
          background: "linear-gradient(135deg, #1F3460 0%, #0B1829 100%)",
          border: "2px solid rgba(184,147,42,0.55)",
          boxShadow: "0 3px 10px rgba(0,0,0,0.30), 0 0 0 3px rgba(184,147,42,0.08)",
          display:"flex", alignItems:"center", justifyContent:"center",
          flexShrink: 0,
        }}>
          <AxiorSVG size={Math.round(avatarSize * 0.7)} expr={expr}/>
        </div>
        <div style={{minWidth:0, flex:1}}>
          <div style={{
            fontSize: isMobile?8.5:9, color: "rgba(212,168,67,0.9)",
            fontWeight: 700, letterSpacing: "1.4px",
            textTransform: "uppercase" as const,
          }}>AXIOR · TU COPILOTO</div>
          <div style={{
            fontSize: isMobile?9:9.5, color: "rgba(255,255,255,0.45)",
            fontWeight: 600, marginTop: 1,
          }}>{greeting}</div>
        </div>
      </div>

      {/* Headline + insight */}
      <div style={{minWidth: 0}}>
        <div style={{
          fontFamily: fontSerif, fontSize: isMobile?13:14.5, fontWeight: 700,
          color: "white", lineHeight: 1.3, marginBottom: insight ? 3 : 0,
        }}>{headline}</div>
        {insight && (
          <div style={{
            fontSize: isMobile?11:12, color: "rgba(255,255,255,0.68)",
            lineHeight: 1.4,
          }}>{insight}</div>
        )}
      </div>

      {/* CTA dorado al pie */}
      {cta && ctaModulo && onIrModulo && (
        <div>
          <button onClick={() => onIrModulo(ctaModulo)}
            onMouseEnter={(e) => {e.currentTarget.style.transform = "translateY(-1px)";}}
            onMouseLeave={(e) => {e.currentTarget.style.transform = "translateY(0)";}}
            style={{
              background: ctaBg, border: "none",
              color: "#0B1829", fontWeight: 800,
              padding: isMobile ? "7px 13px" : "8px 15px",
              borderRadius: 8, cursor: "pointer",
              fontSize: isMobile ? 11 : 12, fontFamily: "inherit",
              boxShadow: ctaShadow,
              transition: "transform 0.18s ease",
              whiteSpace: "nowrap" as const,
            }}>{cta}</button>
        </div>
      )}
    </div>
  );
}

function SuiteHome({user, isProUser, onLogout, onLogin, onGoFlotilla, onGoRegula, onGoAdmin, onGoNomina, onGoContratos, onGoEmpleados, onGoCalendario, onGoDocumentos, onGoProveedores, onGoClientes, onGoCreditos, onGoTareas, onGoEmpleadosFoco, onGoFlotillaFiltrada, onIrItem, onGoViaje, onIrDestino, fontSans, fontSerif, gold}: {
  user:any; isProUser:boolean; onLogout:()=>void; onLogin:()=>void; onGoFlotilla:()=>void; onGoRegula:()=>void; onGoAdmin:()=>void; onGoNomina:()=>void; onGoContratos:()=>void; onGoEmpleados:()=>void; onGoCalendario:()=>void; onGoDocumentos:()=>void; onGoProveedores:()=>void; onGoClientes:()=>void; onGoCreditos:()=>void; onGoTareas:()=>void; onGoEmpleadosFoco:(emails:string[])=>void; onGoFlotillaFiltrada:(f:"vencida"|"por_vencer"|"sin_registro"|"en_regla")=>void; onIrItem:(it:ItemAtencion)=>void; onGoViaje?:(viajeId:string)=>void; onIrDestino?:(d:DestinoFeed)=>void; fontSans:string; fontSerif:string; gold:string;}) {
  const isMobile = window.innerWidth < 768;
  const isTablet = !isMobile && window.innerWidth < 1024;
  const isUserAdmin = esAdmin(user?.email);

  return (
    // Contenedor principal en flex column con min-height para anclar el
    // remate dorado y el copyright al fondo de la pantalla aunque la
    // cuenta tenga poco contenido (sin admin, sin créditos, etc.).
    <div style={{minHeight:"100vh", background:T_LIGHT.canvas, display:"flex", flexDirection:"column" as const}}>
      <style>{`
        @keyframes cardFadeUp{from{opacity:0;transform:translateY(18px)}to{opacity:1;transform:translateY(0)}}
        @keyframes goldShimmer{0%{background-position:200% 0}100%{background-position:-200% 0}}
        @keyframes pulseDot{0%,100%{opacity:1;transform:scale(1)}50%{opacity:0.6;transform:scale(0.9)}}
        .mod-card{animation:cardFadeUp 0.45s ease forwards;opacity:0;cursor:pointer;transition:transform 0.28s cubic-bezier(0.34,1.56,0.64,1),box-shadow 0.25s ease,border-color 0.2s!important}
        .mod-card:hover{transform:translateY(-6px)!important;box-shadow:var(--mod-shadow-hov, ${T_LIGHT.shadowHov})!important;border-color:var(--mod-border-hov, ${T_LIGHT.goldBorder})!important}
        .mod-card:nth-child(1){animation-delay:0.04s}.mod-card:nth-child(2){animation-delay:0.08s}
        .mod-card:nth-child(3){animation-delay:0.12s}.mod-card:nth-child(4){animation-delay:0.16s}
        .mod-card:nth-child(5){animation-delay:0.20s}.mod-card:nth-child(6){animation-delay:0.24s}
        .gold-name{background:linear-gradient(90deg,#B8932A 0%,#D4A843 40%,#F0C85A 50%,#D4A843 60%,#B8932A 100%);background-size:200% auto;-webkit-background-clip:text;-webkit-text-fill-color:transparent;animation:goldShimmer 3s linear infinite}
        .pulse{animation:pulseDot 2s ease-in-out infinite}
        .admin-card:hover{transform:translateY(-3px)!important;box-shadow:0 6px 18px rgba(22,36,71,0.13)!important;border-color:rgba(184,147,42,0.30)!important}
        .admin-card{transition:transform 0.2s ease,box-shadow 0.2s ease,border-color 0.2s ease!important}
      `}</style>

      {/* Header slim de SuiteHome removido — email/Salir/Iniciar sesión y la
         campana de notificaciones viven ahora en el top bar global del
         AppShell, disponible en TODAS las pantallas internas. */}

      <div style={{padding:isMobile?"10px 12px 14px":"36px 40px", maxWidth:ANCHO_CONTENIDO, margin:"0 auto", width:"100%", boxSizing:"border-box" as const, flex:1, display:"flex", flexDirection:"column" as const}}>
        {/* Saludo */}
        <div style={{marginBottom:isMobile?10:24}}>
          <div style={{fontSize:isMobile?9:11, color:T_LIGHT.gold, fontWeight:700,
            textTransform:"uppercase" as const, letterSpacing:isMobile?"1.5px":"2.5px", marginBottom:isMobile?2:10}}>
            Panel de control
          </div>
          <h2 style={{fontFamily:fontSerif, fontSize:isMobile?18:40, color:T_LIGHT.textInk, margin:"0 0 4px",
            fontWeight:700, lineHeight:1.1}}>
            Bienvenido, <span className="gold-name">{user?.isAnonymous ? "Invitado" : (user?.displayName || user?.email?.split("@")[0] || "Invitado")}</span>
          </h2>
          {/* La fecha ancla la pantalla: da peso al encabezado sin meter un gráfico,
              y en un producto de cumplimiento —donde casi todo son plazos— saber en
              qué día se está leyendo el tablero no es decoración. */}
          <p style={{fontSize:isMobile?11.5:13, color:T_LIGHT.textInkSoft, margin:"2px 0 0", textTransform:"capitalize" as const}}>
            {new Date().toLocaleDateString("es-MX", {weekday:"long", day:"numeric", month:"long", year:"numeric"})}
          </p>
          {!isMobile && <p style={{fontSize:13, color:T_LIGHT.textInkSoft, margin:"4px 0 0"}}>
            Selecciona el módulo que deseas usar hoy.
          </p>}
        </div>


        {/* PREPARA ESTE DISPOSITIVO — instalar la app y activar los avisos, juntos
           y solo si falta alguno. Va aquí, justo debajo del saludo: se ve al entrar
           sin desplazarse, y no por encima de la cuenta. Desaparece del todo cuando
           las dos cosas están hechas. */}
        {user && !user.isAnonymous && (
          <PrepararDispositivo isMobile={isMobile} fontSerif={fontSerif} fontSans={fontSans}/>
        )}

        {/* DASHBOARD — medidores de cumplimiento + línea compacta de créditos.
           Solo si hay sesión REAL. El saludo/resumen de AXIOR y la lista
           "Requieren tu atención" viven en la campana 🔔 del top bar global. */}
        {user && !user.isAnonymous && (
          <DashboardSuite
            currentUser={user}
            isMobile={isMobile}
            isTablet={isTablet}
            fontSerif={fontSerif}
            onGoEmpleadosFoco={onGoEmpleadosFoco}
            onGoFlotillaFiltrada={onGoFlotillaFiltrada}
            onIrItem={onIrItem}
            onGoViaje={onGoViaje}
            onIrDestino={onIrDestino}
          />
        )}

        {/* EL BANNER DE INSTALAR SE MUDÓ ARRIBA, a "Prepara este dispositivo", junto
           a los avisos: son la misma clase de cosa —dejar listo este aparato— y aquí,
           debajo del tablero entero, había que bajar a buscarlo. */}

        {/* ── Accesos rápidos — atajos compactos (íconos) a las acciones más
           comunes. Sustituyen las tarjetas grandes que duplicaban el sidebar;
           la navegación completa vive en el menú lateral. ── */}
        <div style={{marginBottom: isMobile?14:22}}>
          <div style={{display:"flex", alignItems:"center", gap:9, margin:isMobile?"2px 0 8px":"4px 0 12px"}}>
            <div style={{width:4, height:isMobile?15:18, background:gold, borderRadius:2, flexShrink:0}}/>
            <h3 style={{fontFamily:fontSerif, fontSize:isMobile?14:18, color:T_LIGHT.textInk, margin:0, fontWeight:700}}>Accesos rápidos</h3>
          </div>
          {/* 7 accesos de ANCHO IGUAL: una fila de 7 columnas (1fr) en desktop,
             que wrapea ordenado (4 / 2 cols) sin perder el ancho uniforme. */}
          {/* CUATRO ACCIONES, no enlaces. Diagnóstico, Calculadora LFT y Calendario
             se retiraron: solo repetían la barra lateral, que ya lleva a todos los
             módulos. Un atajo que duplica el menú no ahorra un clic, solo ocupa el
             lugar donde debería estar algo que SE HACE. */}
          <div style={{display:"grid", gridTemplateColumns: isMobile?"repeat(2,1fr)":"repeat(4,1fr)", gap: isMobile?8:10}}>
            {[
              {label:"Generar contrato",   icon:"suite_contratos",   onClick:onGoContratos,  disp:isProUser},
              {label:"Subir documento",    icon:"suite_documentos",  onClick:onGoDocumentos, disp:isProUser},
              {label:"Agregar empleado",   icon:"suite_empleados",   onClick:onGoEmpleados,  disp:isProUser},
              {label:"Pregúntale a AXIOR", icon:"axior", onClick:()=>{ try{ window.dispatchEvent(new CustomEvent("axior:abrir")); }catch(e){} }, disp:true, axior:true},
            ].map((a:any) => (
              // Sin PRO NO se apaga a gris muerto: se marca como PRO y sigue viva al
              // tacto. Es lo que se vende; presentarlo como avería lo esconde.
              <button key={a.label} onClick={a.onClick}
                title={a.disp?undefined:"Incluido en el plan PRO"}
                onMouseEnter={(e)=>{ if(a.disp){ const t=e.currentTarget; t.style.transform="translateY(-3px)"; t.style.borderColor="rgba(181,154,80,0.85)"; t.style.boxShadow="0 10px 26px rgba(0,0,0,0.30)"; } }}
                onMouseLeave={(e)=>{ const t=e.currentTarget; t.style.transform="translateY(0)"; t.style.borderColor="rgba(181,154,80,0.50)"; t.style.boxShadow="0 3px 10px rgba(10,20,40,0.22)"; }}
                style={{display:"flex", flexDirection:"column" as const, alignItems:"center", justifyContent:"flex-start", gap:8,
                  background:"linear-gradient(140deg,#1C2B4A 0%,#12203A 100%)", border:`1px solid rgba(181,154,80,0.50)`, borderRadius:INI.radio,
                  padding:isMobile?"13px 6px":"15px 8px", cursor:"pointer", opacity:1,
                  position:"relative" as const,
                  boxShadow:"0 3px 10px rgba(10,20,40,0.22)", fontFamily:"inherit", transition:"transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease"}}>
                <div style={{width:isMobile?36:42, height:isMobile?36:42, borderRadius:11, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0,
                  background:"rgba(181,154,80,0.14)",
                  border: `1px solid rgba(181,154,80,0.34)`}}>
                  {a.axior
                    ? <img src="/axior.png" alt="AXIOR" style={{width:isMobile?26:30, height:isMobile?26:30, objectFit:"contain" as const, display:"block"}}/>
                    : <AxisIcon name={a.icon} size={isMobile?20:23} color="#B59A50" withBackdrop={false} strokeWidth={2.5}/>}
                </div>
                <span style={{fontSize:isMobile?10.5:11.5, fontWeight:600, color:"#ECE6D8", textAlign:"center" as const, lineHeight:1.25}}>{a.label}</span>
                {!a.disp && (
                  <span style={{position:"absolute" as const, top:7, right:7, fontSize:8.5, fontWeight:800,
                    letterSpacing:"0.6px", padding:"2px 6px", borderRadius:999,
                    background:"#B59A50", color:"#12203A"}}>PRO</span>
                )}
              </button>
            ))}
          </div>
        </div>

        {/* Panel Admin */}
        {isUserAdmin && (
          <div onClick={onGoAdmin} className="admin-card"
            style={{background:"linear-gradient(135deg,rgba(184,147,42,0.14),rgba(184,147,42,0.06))",
              borderRadius:INI.radio, padding:isMobile?"14px 16px":"22px 28px", cursor:"pointer",
              border:`1px solid ${INI.borde}`,
              display:"flex", alignItems:"center", gap:16,
              position:"relative" as const, overflow:"hidden",
              boxShadow:INI.sombra}}>
            <div style={{position:"absolute" as const, top:-30, right:-30, width:130, height:130,
              borderRadius:"50%", background:"radial-gradient(circle,rgba(184,147,42,0.18) 0%,transparent 70%)"}} />
            <div style={{position:"absolute" as const, top:0, left:0, right:0, height:2,
              background:"linear-gradient(90deg,transparent,rgba(184,147,42,0.8),#F0C85A,rgba(184,147,42,0.8),transparent)"}} />
            <div style={{width:52, height:52, background:"rgba(184,147,42,0.2)", borderRadius:15,
              display:"flex", alignItems:"center", justifyContent:"center", fontSize:24,
              border:"1px solid rgba(184,147,42,0.4)", flexShrink:0,
              boxShadow:"0 4px 16px rgba(184,147,42,0.3)"}}>🛡️</div>
            <div style={{flex:1}}>
              <div style={{fontFamily:fontSerif, fontSize:17, fontWeight:700, color:gold, marginBottom:4}}>
                Panel de Administrador
              </div>
              <div style={{fontSize:12, color:T_LIGHT.textInkSoft}}>
                Leads · Flotilla · Diagnósticos · Contratos · Empleados · Recibos
              </div>
            </div>
            <span style={{color:gold, fontSize:22, fontWeight:300}}>→</span>
          </div>
        )}

        {/* Spacer flex que empuja el remate y el copyright al fondo
           cuando la cuenta tiene poco contenido (sin créditos, sin admin,
           etc.). En cuentas con todo el contenido, este spacer colapsa a
           0 y el remate queda justo debajo del último elemento. */}
        <div style={{flex:1}}/>

        {/* Remate de cierre — línea dorada fina con diamante centrado.
           Sustituye el separador plano por un detalle premium discreto. */}
        <div style={{
          display: "flex", alignItems: "center", justifyContent: "center",
          gap: 14,
          margin: isMobile ? "32px auto 14px" : "44px auto 18px",
          maxWidth: 380,
          padding: "0 16px",
        }}>
          <div style={{
            flex: 1, height: 1,
            background: "linear-gradient(90deg, transparent 0%, rgba(184,147,42,0.50) 100%)",
          }}/>
          <div style={{
            width: 9, height: 9,
            background: "linear-gradient(135deg, #F0C85A 0%, #D4A843 50%, #B8932A 100%)",
            transform: "rotate(45deg)",
            boxShadow: "0 0 10px rgba(184,147,42,0.45), inset 0 1px 0 rgba(255,255,255,0.5)",
            border: "0.5px solid rgba(184,147,42,0.6)",
          }}/>
          <div style={{
            flex: 1, height: 1,
            background: "linear-gradient(90deg, rgba(184,147,42,0.50) 0%, transparent 100%)",
          }}/>
        </div>

        <div style={{textAlign:"center" as const, paddingBottom: isMobile?8:0}}>
          <p style={{fontSize:11, color:T_LIGHT.textInkMut, margin:0}}>
            © 2026 AXIS Asesoría Legal Corporativa · Torre Plaza Bosques, Int. 909 · Aguascalientes · 449 425 11 28
          </p>
        </div>
      </div>
    </div>
  );
}


// ─── FLOTILLA: TIPOS Y HELPERS ─────────────────────────────────────────────
type Vehiculo = {
  id?: string;
  placa: string;
  marca?: string;
  modelo?: string;
  anio?: number;
  color?: string;
  numeroEconomico?: string;
  numeroSerie?: string;
  kilometraje?: number;
  conductorAsignadoId?: string;
  conductorAsignadoNombre?: string;
  status?: "activo" | "inactivo";
  // CADA DOCUMENTO ES UNA RANURA: desde cuándo vale, hasta cuándo, y el archivo.
  // Antes solo se guardaba `venceX`, o sea la fecha que alguien tecleó y no el
  // documento. En una inspección lo que sirve es la póliza, no la fecha.
  //
  // `venceX` se queda como está y sigue siendo la ÚNICA fuente del vencimiento:
  // trece pantallas cuelgan de ella. Lo nuevo se añade al lado, sin migrar nada.
  venceVerificacion?: string;
  venceSeguro?: string;
  venceTenencia?: string;
  venceTarjeta?: string;
  desdeVerificacion?: string;
  desdeSeguro?: string;
  desdeTarjeta?: string;
  archivoVerificacion?: ArchivoDoc;
  archivoSeguro?: ArchivoDoc;
  archivoTarjeta?: ArchivoDoc;
  // A QUIÉN LLAMAR SI HAY UN ACCIDENTE. La póliza guardaba fechas y archivo, pero
  // no el teléfono de siniestros, y quien está junto a la unidad no puede abrir el
  // archivo del patrón. Con esto la pantalla del accidente ofrece "Llamar a la
  // aseguradora". Opcionales: las unidades de antes no los tienen.
  aseguradora?: string;
  telefonoSiniestros?: string;
  numeroPoliza?: string;
  fechaBaja?: string;
  razonBaja?: string;
  notasBaja?: string;
  userId?: string;
};

// El género va con la etiqueta porque la frase lo necesita: "Verificación
// vencida", "Seguro vencido". Un "vencido(a)" en una pantalla que se enseña en un
// operativo se lee como un formulario, no como un hecho.
type ArchivoDoc = {url: string; nombre: string; subidoEn?: any};

const DOCS_VEHICULO = [
  { key: "venceVerificacion", keyDesde: "desdeVerificacion", keyArchivo: "archivoVerificacion", label: "Verificación", labelCorto: "Verif.", gen: "f" },
  { key: "venceSeguro", keyDesde: "desdeSeguro", keyArchivo: "archivoSeguro", label: "Seguro", labelCorto: "Seguro", gen: "m" },
  { key: "venceTarjeta", keyDesde: "desdeTarjeta", keyArchivo: "archivoTarjeta", label: "Tarjeta de circulación", labelCorto: "T. circ.", gen: "f" },
];

type EstadoDocVehiculo = "ok" | "vencido" | "por_vencer" | "sin_registro";

// UNA FECHA "AAAA-MM-DD" ES UN DÍA, NO UN INSTANTE. `new Date("2026-10-14")` la
// interpreta como medianoche UTC, que en México es a las 18:00 del día 13. Aquí se
// arma el día en hora LOCAL, con las mismas piezas que ya usa `_partesFecha` para
// los reportes, sin que UTC entre en la conversación.
//
// Rechaza los días imposibles en vez de dejarlos rodar: `new Date(2026, 12, 45)`
// devolvería una fecha válida de febrero de 2027, y una fecha inventada es peor
// que ninguna.
// ⚠️ LA REGLA DE LAS FECHAS DE CALENDARIO, la misma que está junto a
// `fechaLargaAxis`, repetida aquí a propósito porque ésta es la otra función
// correcta y quien llega a una no llega a la otra:
//
//   `new Date("AAAA-MM-DD")` es medianoche UTC, NO medianoche local. En México
//   (UTC-6) eso cae en el día ANTERIOR. Para fechas de calendario se usa
//   `_diaLocalDeFecha` —para comparar, restar o contar días— o `fechaLargaAxis`
//   —para imprimir—, nunca el constructor con una cadena.
function _diaLocalDeFecha(f: any): Date | null {
  const p = _partesFecha(f);
  if (!p) return null;
  const d = new Date(p.a, p.m - 1, p.d);
  return (d.getFullYear() === p.a && d.getMonth() === p.m - 1 && d.getDate() === p.d) ? d : null;
}

// `referencia` permite evaluar el documento A UNA FECHA DADA (p. ej. el día en que
// se registró un movimiento de flotilla) en vez de "hoy". Por defecto es hoy.
//
// SE COMPARA DÍA CONTRA DÍA, no instante contra instante, y por eso el resultado
// no depende de la hora a la que se mire. Antes sí dependía: a partir de las 18:00
// hora de México un documento VIGENTE se leía como vencido, porque ahí es cuando
// UTC cruza a la medianoche siguiente. El error tenía una sola dirección —acusaba y
// nunca absolvía— y en la bitácora escribía "circuló con documento vencido" sobre
// viajes de tarde-noche del mismo día en que el documento todavía valía. En un
// producto cuyo valor es la prueba, ese es el peor sentido posible.
//
// Una vigencia "hasta el 14 de octubre" INCLUYE el 14: ese día `dias` vale 0 y el
// documento se lee como vigente, no como vencido.
//
// `Math.round` y no `ceil`: los dos extremos son medianoches locales, así que la
// diferencia ya es un número entero de días salvo por la hora que movería un
// cambio de horario de verano, y redondear la absorbe.
// CUÁNTOS DÍAS FALTAN PARA UNA FECHA GUARDADA, contando DÍA contra DÍA. Devuelve
// null si no hay fecha o no se puede leer: la ausencia de dato no es un plazo.
//
// Vive aparte porque la misma pregunta se hacía en cuatro sitios —el documento
// del vehículo, el vencimiento del contrato en Inicio, en la campana y en la
// ficha— y tres de ellos la respondían con `new Date(cadena)`, que es medianoche
// UTC: a partir de las 18:00 hora de México contaban un día de menos, así que un
// contrato que vence mañana se leía como que vence hoy. Ver la regla junto a
// `_diaLocalDeFecha`.
function diasHastaFecha(fecha: any, referencia?: Date): number | null {
  const venc = _diaLocalDeFecha(fecha);
  if (!venc) return null;
  const ref = referencia || new Date();
  const hoy = new Date(ref.getFullYear(), ref.getMonth(), ref.getDate());   // su DÍA, sin la hora
  // `Math.round` y no `ceil`: los dos extremos son medianoches locales, así que
  // la diferencia ya es entera salvo por el cambio de horario de verano, que el
  // redondeo absorbe.
  return Math.round((venc.getTime() - hoy.getTime()) / (1000*60*60*24));
}
function estadoDocVehiculo(fechaVence: string | undefined, referencia?: Date): {estado: EstadoDocVehiculo; dias: number} {
  const dias = diasHastaFecha(fechaVence, referencia);
  if (dias === null) return {estado: "sin_registro", dias: 0};
  if (dias < 0) return {estado: "vencido", dias};
  if (dias <= 30) return {estado: "por_vencer", dias};
  return {estado: "ok", dias};
}

function calcularComplianceVehiculo(v: Vehiculo, referencia?: Date): {
  porcentaje: number;
  cumplidos: number;
  total: number;
  documentos: {key: string; label: string; labelCorto: string; gen: string; fecha: string; estado: EstadoDocVehiculo; dias: number}[];
} {
  let cumplidos = 0;
  const documentos = DOCS_VEHICULO.map(d => {
    const fecha = String((v as any)[d.key] || "");
    const {estado, dias} = estadoDocVehiculo(fecha, referencia);
    if (estado === "ok" || estado === "por_vencer") cumplidos++;
    return {...d, fecha, estado, dias};
  });
  const porcentaje = Math.round((cumplidos / DOCS_VEHICULO.length) * 100);
  return {porcentaje, cumplidos, total: DOCS_VEHICULO.length, documentos};
}

// ── EL HECHO MÁS URGENTE, EN UNA LÍNEA ──────────────────────────────────────
// Sustituye a la barra de progreso, al "2/3 docs en regla" y a la etiqueta
// "Crítico". Una fracción y una calificación obligan a traducir: 2/3 no dice CUÁL
// falta ni desde cuándo, y "Crítico" es una nota escolar, no un hecho que se
// pueda enseñar en un operativo. Aquí se dice qué documento, en qué estado y con
// qué fecha.
//
// UN SOLO SITIO, tres pantallas: el expediente, la lista de flotilla y la
// flotilla en móvil. Antes cada una tenía su propia forma de resumir lo mismo.
//
// SIN REGISTRAR NO ES INCUMPLIR. Un documento que nadie capturó es un pendiente
// de captura: no se puede afirmar que la unidad circule sin él, y decirlo en rojo
// sería inventar una falta. Tampoco se cuenta como vigente, que era el otro
// error: en la flotilla móvil un documento sin fecha salía en verde como
// "Vigente".
const _listaEs = (xs: string[]): string =>
  xs.length <= 1 ? (xs[0] || "") : xs.slice(0, -1).join(", ") + " y " + xs[xs.length - 1];

// LA VIGENCIA, DICHA COMO SE DICE EN UN PAPEL. Con las dos fechas se lee "del X
// al Y"; con una sola, "hasta el Y". La de inicio NO se inventa restando un año:
// una vigencia que nadie capturó no se deduce, se deja en blanco.
function textoVigencia(desde: string, hasta: string, estado: EstadoDocVehiculo, dias: number): string {
  if (estado === "sin_registro") return "Sin registrar";
  const rango = desde
    ? `del ${fechaLargaAxis(desde)} al ${fechaLargaAxis(hasta)}`
    : `hasta el ${fechaLargaAxis(hasta)}`;
  // PRIMERO EL HECHO. Decía "Vencido hace 67 días · vigencia hasta el 30 de junio",
  // que afirma a la vez que está vencido y que su vigencia llega hasta una fecha.
  // Un documento vencido no tiene vigencia: tuvo una, y terminó ese día.
  if (estado === "vencido") {
    const d = Math.abs(dias);
    return `Venció el ${fechaLargaAxis(hasta)} — hace ${d} ${d === 1 ? "día" : "días"}`
      + (desde ? ` · vigencia desde el ${fechaLargaAxis(desde)}` : "");
  }
  if (estado === "por_vencer") {
    const cuando = dias === 0 ? "Vence hoy" : dias === 1 ? "Vence mañana" : `Vence en ${dias} días`;
    return `${cuando} · vigente ${rango}`;
  }
  return `Vigente ${rango}`;
}

// QUÉ IMPIDE GUARDAR. Solo dos cosas, y las dos se explican: sin fecha de
// vencimiento no hay nada que decidir sobre el documento, y un inicio posterior al
// vencimiento es una vigencia imposible. La fecha de inicio NO se deduce restando
// un año: una vigencia que nadie capturó se deja en blanco.
function validarVigencia(desde: string, hasta: string): string {
  if (!hasta) return "La fecha de vencimiento es obligatoria: es la que decide si el documento está vigente.";
  if (desde && desde > hasta) return "La fecha de inicio es posterior a la de vencimiento. Revísalas: así no se puede guardar.";
  return "";
}

// QUÉ PASÓ AL GUARDAR, DICHO CON ESAS PALABRAS. Subir el archivo y escribir la
// vigencia son dos operaciones y cualquiera puede fallar sola. El caso que más
// importa es el de en medio: si la fecha se guardó y el archivo no, el mensaje lo
// dice, porque el documento sigue sin archivo y la persona tiene que volver.
function mensajeGuardadoDoc(o: {intentoArchivo: boolean; falloArchivo: string; falloDoc: string}):
  {tipo: "ok"|"parcial"|"err"; texto: string; cerrar: boolean} {
  if (o.falloDoc && o.falloArchivo) return {tipo:"err", cerrar:false,
    texto:`No se guardó nada: ni el archivo (${o.falloArchivo}) ni la vigencia (${o.falloDoc}).`};
  if (o.falloDoc) return {tipo:"err", cerrar:false,
    texto:`No se pudo guardar la vigencia (${o.falloDoc}).` + (o.intentoArchivo ? " El archivo sí se subió, pero quedó sin vincular: vuelve a guardar." : "")};
  if (o.falloArchivo) return {tipo:"parcial", cerrar:false,
    texto:`La vigencia se guardó, pero el archivo NO se subió (${o.falloArchivo}). El documento sigue sin archivo: vuelve a intentarlo.`};
  return {tipo:"ok", cerrar:true, texto: o.intentoArchivo ? "Vigencia y archivo guardados." : "Vigencia guardada."};
}

type ResumenDocVehiculo = {texto: string; corto: string; tono: "ok"|"pendiente"|"critico"};
function resumenDocumentalVehiculo(v: Vehiculo, referencia?: Date): ResumenDocVehiculo {
  const docs = calcularComplianceVehiculo(v, referencia).documentos;
  const vencidos = docs.filter(d => d.estado === "vencido").sort((a, b) => a.dias - b.dias);
  const sinReg   = docs.filter(d => d.estado === "sin_registro");
  const conFecha = docs.filter(d => d.estado === "ok" || d.estado === "por_vencer").sort((a, b) => a.dias - b.dias);

  // 1. Lo vencido manda: es lo único que ya tiene consecuencia hoy.
  if (vencidos.length) {
    const peor = vencidos[0];
    const d = Math.abs(peor.dias);
    const uno = `${peor.label} ${peor.gen === "f" ? "vencida" : "vencido"} hace ${d} ${d === 1 ? "día" : "días"}`;
    const otros = vencidos.length - 1;
    return {
      texto: otros ? `${uno}, y ${otros === 1 ? "otro documento vencido" : `${otros} documentos más vencidos`}.` : `${uno}.`,
      corto: vencidos.length === 1 ? "1 vencido" : `${vencidos.length} vencidos`,
      tono: "critico",
    };
  }
  // 2. Nada capturado todavía: es un expediente vacío, no una unidad en falta.
  if (sinReg.length === docs.length) {
    return {texto: `Sin registrar: ${_listaEs(sinReg.map(d => d.label.toLowerCase()))}.`,
            corto: "sin registrar", tono: "pendiente"};
  }
  // 3. Nada vencido. Se dice, y después qué falta o qué sigue.
  const partes: string[] = [sinReg.length === 0 ? "Los tres documentos vigentes." : "Ningún documento vencido."];
  if (sinReg.length) partes.push(`Sin registrar: ${_listaEs(sinReg.map(d => d.label.toLowerCase()))}.`);
  const prox = conFecha[0];
  if (prox) partes.push(`El próximo vence el ${fechaLargaAxis(prox.fecha)} (${prox.label.toLowerCase()}).`);
  return {
    texto: partes.join(" "),
    corto: sinReg.length ? (sinReg.length === 1 ? "1 sin registrar" : `${sinReg.length} sin registrar`)
         : (prox && prox.estado === "por_vencer") ? (prox.dias === 0 ? "vence hoy" : `vence en ${prox.dias} d`)
         : "vigentes",
    tono: (sinReg.length || (prox && prox.estado === "por_vencer")) ? "pendiente" : "ok",
  };
}

// ── Estado documental de un REGISTRO de flotilla, DERIVADO al mostrar ────────
// Cruza el `vehiculoId` del registro con el vehículo del patrón y evalúa sus
// documentos A LA FECHA DEL REGISTRO (no a hoy). Es un valor calculado: NUNCA se
// escribe de vuelta, así que si el patrón corrige una fecha de vencimiento la
// bitácora refleja la verdad corregida de inmediato.
// Tres estados posibles, sin inventar ninguno:
//   · "no_verificable"  → el registro no trae vehiculoId (modo libre o anterior a
//                         este cambio). NUNCA se marca como vencido.
//   · "sin_datos"       → hay vehículo pero no tiene ninguna fecha capturada.
//                         Es "sin registro documental", NO "vencido".
//   · "vencido"/"vigente" → se pudo evaluar de verdad.
type EstadoDocRegistro =
  | {tipo:"no_verificable"}
  | {tipo:"sin_datos"}
  | {tipo:"vigente"}
  | {tipo:"vencido"; documentos:string[]};
function estadoDocumentalRegistro(registro:any, vehiculo:any, fechaRegistro:Date|null): EstadoDocRegistro {
  // Antes esto exigía además `registro.vehiculoId`, y por eso TODA la bitácora
  // histórica salía como "no verificable" aunque quien llama ya hubiera resuelto
  // la unidad por placa: se buscaba bien y aquí se descartaba. Si llega un
  // vehículo resuelto, no importa por qué vía llegó.
  //
  // La AMBIGÜEDAD se resuelve antes de llegar aquí: quien construye el índice de
  // placas no indexa ninguna cuando dos unidades comparten la misma, así que este
  // parámetro llega vacío y el registro queda como no verificable. Atribuir un
  // movimiento a la unidad equivocada es peor que no atribuirlo. Con `vehiculoId`
  // presente eso no aplica: el id es inequívoco.
  if (!vehiculo || !fechaRegistro) return {tipo:"no_verificable"};
  const docs = calcularComplianceVehiculo(vehiculo, fechaRegistro).documentos;
  // Sin NINGUNA fecha capturada → no se puede afirmar nada (jamás "vencido").
  if (docs.every(d => d.estado === "sin_registro")) return {tipo:"sin_datos"};
  const vencidos = docs.filter(d => d.estado === "vencido").map(d => d.label);
  return vencidos.length > 0 ? {tipo:"vencido", documentos:vencidos} : {tipo:"vigente"};
}

// ── EL TABLERO: UNA UNIDAD CUENTA EN UN SOLO CUBO ──────────────────────────
// Un vehículo puede tener un documento vencido Y otro sin capturar a la vez. Si
// apareciera en dos contadores, la suma dejaría de dar el total de la flota, y un
// tablero cuyos números no suman es peor que no tener tablero.
//
// Por eso cada unidad pasa por UN solo `switch` y sale con UNA etiqueta, en este
// orden de urgencia: vencido gana a por vencer, y por vencer gana a sin capturar.
// Que la suma cuadre no es una comprobación que haya que recordar hacer: es
// consecuencia de clasificar una vez.
type CuboFlotilla = "vencido" | "por_vencer" | "sin_capturar" | "sin_pendientes";
function cuboDeVehiculo(v: Vehiculo, referencia?: Date): CuboFlotilla {
  const docs = calcularComplianceVehiculo(v, referencia).documentos;
  if (docs.some(d => d.estado === "vencido")) return "vencido";
  if (docs.some(d => d.estado === "por_vencer")) return "por_vencer";
  if (docs.some(d => d.estado === "sin_registro")) return "sin_capturar";
  return "sin_pendientes";
}
function cubosFlotilla(vehiculos: Vehiculo[], referencia?: Date): {
  vencido: number; por_vencer: number; sin_capturar: number; sin_pendientes: number;
  activos: number; baja: number;
} {
  const r = {vencido: 0, por_vencer: 0, sin_capturar: 0, sin_pendientes: 0, activos: 0, baja: 0};
  vehiculos.forEach(v => {
    if ((v.status || "activo") === "inactivo") { r.baja++; return; }
    r.activos++;
    r[cuboDeVehiculo(v, referencia)]++;
  });
  return r;
}

function nivelVehiculo(v: Vehiculo): "ok" | "atencion" | "riesgo" {
  const c = calcularComplianceVehiculo(v);
  const hayVencidos = c.documentos.some(d => d.estado === "vencido");
  const hayPorVencer = c.documentos.some(d => d.estado === "por_vencer");
  if (hayVencidos) return "riesgo";
  if (hayPorVencer || c.porcentaje < 100) return "atencion";
  return "ok";
}

// SOLO COLOR. Antes traía también un `nombre` —"En regla", "Atención",
// "Crítico"— que se pintaba como etiqueta del vehículo. Una calificación no dice
// qué pasa ni qué hacer: de eso se encarga resumenDocumentalVehiculo. El color se
// queda porque orienta la vista de un vistazo; la palabra se fue.
function colorVehiculo(nivel: "ok"|"atencion"|"riesgo"): {color: string; bg: string; border: string} {
  if (nivel === "ok") return {color: "#1D9E75", bg: "rgba(29,158,117,0.15)", border: "rgba(29,158,117,0.35)"};
  if (nivel === "atencion") return {color: "#EF9F27", bg: "rgba(239,159,39,0.15)", border: "rgba(239,159,39,0.35)"};
  return {color: "#E24B4A", bg: "rgba(226,75,74,0.15)", border: "rgba(226,75,74,0.35)"};
}

function calcularKPIsFlotilla(vehiculos: Vehiculo[]): {
  activos: number;
  cumplimientoPromedio: number;
  conDocsVencidos: number;
  proximosVencer: number;
} {
  const activos = vehiculos.filter(v => (v.status || "activo") === "activo");
  if (activos.length === 0) return {activos: 0, cumplimientoPromedio: 0, conDocsVencidos: 0, proximosVencer: 0};
  let sumaCompliance = 0;
  let conVencidos = 0;
  let conProximos = 0;
  activos.forEach(v => {
    const c = calcularComplianceVehiculo(v);
    sumaCompliance += c.porcentaje;
    const hayVenc = c.documentos.some(d => d.estado === "vencido");
    const hayProx = c.documentos.some(d => d.estado === "por_vencer");
    if (hayVenc) conVencidos++;
    if (hayProx) conProximos++;
  });
  return {
    activos: activos.length,
    cumplimientoPromedio: Math.round(sumaCompliance / activos.length),
    conDocsVencidos: conVencidos,
    proximosVencer: conProximos,
  };
}

const RAZONES_BAJA_VEHICULO = [
  { value: "vendido", label: "Vendido" },
  { value: "siniestro_total", label: "Siniestro total / pérdida total" },
  { value: "transferido", label: "Transferido a otra empresa" },
  { value: "obsoleto", label: "Obsoleto / dado de baja por edad" },
  { value: "otro", label: "Otro motivo" },
];

// ─── FLOTILLA: SUB-COMPONENTES ─────────────────────────────────────────────

// Sección de CONSULTA plegable. Una sola vestidura para las cuatro: superficie
// del sistema, filete hairline arriba y etiqueta en versalitas navy. Sin relleno
// de acento a propósito: rojo, ámbar y verde quedan reservados al estado
// documental. La regla: rojo, ámbar y verde solo codifican la urgencia de un
// HECHO REAL sobre una unidad —un documento vencido, un accidente reportado—;
// nunca decoran un contenedor ni distinguen categorías de material de consulta.
// "accidente" y arriba "por vencer": el mismo canal no puede decir dos cosas.
// `variant` se conserva en la firma —hay llamados que lo pasan— pero ya sólo
// elige el ICONO, nunca el color.
function SeccionColapsableFlotilla({titulo, abierta, onToggle, gold, fontSans, variant = "default", icono, children}: {
  titulo: string; abierta: boolean; onToggle: ()=>void; gold: string; fontSans: string;
  variant?: "info" | "warning" | "default"; icono?: string; children: React.ReactNode;
}) {
  const iconName = icono || (variant === "warning" ? "alert" : variant === "info" ? "info" : "clipboard");
  return (
    <div style={{background: UI.superficie, border: `1px solid ${UI.borde}`, borderRadius: UI.rTarjeta,
      marginBottom: 10, fontFamily: fontSans, overflow: "hidden", boxShadow: UI.sombra}}>
      <div style={{height:2, background:`linear-gradient(90deg, ${UI.oro}, ${UI.oro}00)`}}/>
      <div onClick={onToggle} style={{
        padding: "12px 16px", cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"space-between", gap:12,
      }}>
        <span style={{color: UI.navy, fontWeight:700, fontSize:UI.fsRotulo, letterSpacing:"0.8px", textTransform:"uppercase" as const, display:"flex", alignItems:"center", gap:8, minWidth:0}}>
          <AxisIcon name={iconName} size={14} color={UI.navy} withBackdrop={false} strokeWidth={2.5}/> {titulo}
        </span>
        <span style={{color: UI.navy, fontSize:UI.fsEtiqueta, fontWeight:700, flexShrink:0}}>{abierta ? "Cerrar" : "Abrir"}</span>
      </div>
      {abierta && (
        <div style={{padding:"0 16px 14px 16px"}}>
          <div style={{borderTop: `1px solid ${UI.divisor}`, paddingTop: 12}}>
            {children}
          </div>
        </div>
      )}
    </div>
  );
}

function VehiculoCard({vehiculo, onAbrir, onDarDeBaja, onReactivar, fontSans, fontSerif, gold, isMobile}: {
  vehiculo: Vehiculo; onAbrir: ()=>void; onDarDeBaja: ()=>void; onReactivar: ()=>void;
  fontSans: string; fontSerif: string; gold: string; isMobile: boolean;
}) {
  // VehiculoCard ahora es una FILA compacta: icono + placa/modelo + conductor +
  // indicador docs (X/Y) + badge estado + chevron. El detalle completo (3 docs,
  // barra de cumplimiento, Dar de baja / Reactivar) vive en ExpedienteVehiculo,
  // que se abre al hacer click en cualquier parte de la fila (onAbrir).
  // Los props onDarDeBaja / onReactivar siguen recibiéndose para no romper el
  // contrato, pero ya no se renderizan aquí (el expediente los expone).
  const nivel = nivelVehiculo(vehiculo);
  const colorNivel = colorVehiculo(nivel);
  const esInactivo = (vehiculo.status || "activo") === "inactivo";

  // MISMO resumen que el expediente y que la flotilla móvil: aquí solo cabe la
  // forma corta, pero sale de la misma función, así que las tres pantallas no
  // pueden empezar a decir cosas distintas del mismo vehículo.
  const resumen = resumenDocumentalVehiculo(vehiculo);
  const badgeTexto = esInactivo ? "Inactivo" : resumen.corto;

  const badgeStyle = esInactivo ? {color: "#9A9AAA", bg: "rgba(154,154,170,0.15)", border: "rgba(154,154,170,0.3)"}
    : resumen.tono === "critico" ? {color: "#E24B4A", bg: "rgba(226,75,74,0.12)", border: "rgba(226,75,74,0.3)"}
    : resumen.tono === "pendiente" ? {color: "#EF9F27", bg: "rgba(239,159,39,0.12)", border: "rgba(239,159,39,0.3)"}
    : {color: "#1D9E75", bg: "rgba(29,158,117,0.12)", border: "rgba(29,158,117,0.3)"};

  const subInfo = [vehiculo.marca, vehiculo.modelo, vehiculo.anio].filter(Boolean).join(" ") || "Sin datos";

  return (
    <div onClick={onAbrir}
      onMouseEnter={(e)=>{e.currentTarget.style.borderColor = esInactivo ? "rgba(154,154,170,0.35)" : `${colorNivel.color}66`; e.currentTarget.style.boxShadow = `0 8px 20px ${colorNivel.color}22`; e.currentTarget.style.transform = "translateY(-1px)";}}
      onMouseLeave={(e)=>{e.currentTarget.style.borderColor = esInactivo ? "rgba(154,154,170,0.3)" : T_LIGHT.border; e.currentTarget.style.boxShadow = T_LIGHT.shadow; e.currentTarget.style.transform = "translateY(0)";}}
      style={{
        background: T_LIGHT.cardLight,
        border: `1px solid ${esInactivo ? "rgba(154,154,170,0.3)" : T_LIGHT.border}`,
        borderRadius: 10,
        padding: isMobile ? "9px 11px" : "10px 14px",
        opacity: esInactivo ? 0.65 : 1,
        transition: "all 0.2s ease",
        cursor: "pointer",
        boxShadow: T_LIGHT.shadow,
        borderLeft: `3px solid ${esInactivo ? "#9A9AAA" : colorNivel.color}`,
        display: "flex", alignItems: "center", gap: isMobile ? 10 : 12,
      }}>
      {/* Icono circular pequeño */}
      <div style={{
        width: isMobile?32:36, height: isMobile?32:36, borderRadius: "50%",
        background: colorNivel.bg, border: `1px solid ${colorNivel.border}`,
        display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
      }}>
        <AxisIcon name="suite_flotilla" size={isMobile?16:18} color={esInactivo ? "#9A9AAA" : colorNivel.color} withBackdrop={false} strokeWidth={2.5}/>
      </div>

      {/* Bloque texto */}
      <div style={{flex: 1, minWidth: 0}}>
        <div style={{display:"flex", alignItems:"baseline", gap:8, minWidth:0}}>
          <span style={{fontFamily:fontSerif, fontSize:isMobile?13.5:15, fontWeight:700, color:T_LIGHT.textInk, letterSpacing:"0.3px", flexShrink:0}}>
            {vehiculo.placa}
          </span>
          <span style={{fontSize:isMobile?10.5:12, color:T_LIGHT.textInkSoft, whiteSpace:"nowrap" as const, overflow:"hidden" as const, textOverflow:"ellipsis" as const, minWidth:0}}>
            {subInfo}
          </span>
        </div>
        {!esInactivo && !isMobile && (vehiculo.conductorAsignadoNombre || vehiculo.numeroEconomico) && (
          <div style={{fontSize:10.5, color:T_LIGHT.textInkMut, marginTop:1, whiteSpace:"nowrap" as const, overflow:"hidden" as const, textOverflow:"ellipsis" as const}}>
            {vehiculo.conductorAsignadoNombre || "Sin conductor"}
            {vehiculo.numeroEconomico ? ` · #${vehiculo.numeroEconomico}` : ""}
          </div>
        )}
        {esInactivo && vehiculo.fechaBaja && (
          <div style={{fontSize:10.5, color:T_LIGHT.textInkMut, marginTop:1}}>
            Baja: {vehiculo.fechaBaja}{vehiculo.razonBaja ? ` · ${RAZONES_BAJA_VEHICULO.find(r=>r.value===vehiculo.razonBaja)?.label || vehiculo.razonBaja}` : ""}
          </div>
        )}
      </div>

      {/* Cluster derecho: docs + badge + chevron */}
      <div style={{display:"flex", alignItems:"center", gap: isMobile?6:8, flexShrink:0}}>
        {/* Aquí iba "2/3". Una fracción no dice cuál falta ni desde cuándo, y el
            badge de al lado ya dice el hecho. */}
        <span style={{
          background: badgeStyle.bg, color: badgeStyle.color, border:`1px solid ${badgeStyle.border}`,
          fontSize: isMobile?9.5:10.5, padding: isMobile?"2px 7px":"3px 9px", borderRadius:6, fontWeight:700,
          whiteSpace:"nowrap" as const,
        }}>
          {badgeTexto}
        </span>
        <span style={{color: T_LIGHT.textInkMut, fontSize:18, fontWeight:300, marginLeft:2}}>›</span>
      </div>
    </div>
  );
}

function ModalBajaVehiculo({vehiculo, onClose, onConfirmar, gold, fontSans, fontSerif}: {
  vehiculo: Vehiculo; onClose: ()=>void; onConfirmar: (razon: string, notas: string)=>void;
  gold: string; fontSans: string; fontSerif: string;
}) {
  const [razon, setRazon] = useState("vendido");
  const [notas, setNotas] = useState("");
  
  return (
    <div style={{
      position:"fixed" as const, inset:0, background:"rgba(0,0,0,0.6)", backdropFilter:"blur(4px)",
      display:"flex", alignItems:"center", justifyContent:"center", zIndex:1000, padding:16
    }}>
      <div {...PANEL_DE_CAPTURA} onClick={(e)=>e.stopPropagation()} style={{
        background:"linear-gradient(160deg,#162447,#1E3A5F)", border:"1px solid rgba(184,147,42,0.3)", borderRadius:16,
        padding:"28px 24px", maxWidth:480, width:"100%", fontFamily:fontSans,
        boxShadow:"0 20px 60px rgba(0,0,0,0.5)"
      }}>
        <h3 style={{fontFamily:fontSerif, fontSize:20, color:"white", margin:"0 0 6px", fontWeight:600}}>
          Dar de baja vehículo
        </h3>
        <p style={{fontSize:13, color:"rgba(232,226,213,0.65)", margin:"0 0 20px"}}>
          {vehiculo.placa}{[vehiculo.marca, vehiculo.modelo].filter(Boolean).length ? ` · ${[vehiculo.marca, vehiculo.modelo].filter(Boolean).join(" ")}` : ""}
        </p>
        
        <label style={{display:"block", fontSize:11, color:gold, marginBottom:6, fontWeight:600, letterSpacing:"0.5px", textTransform:"uppercase" as const}}>
          Motivo de la baja
        </label>
        <select value={razon} onChange={(e)=>setRazon(e.target.value)} style={{
          width:"100%", background:"rgba(255,255,255,0.05)", border:"1px solid rgba(184,147,42,0.25)",
          color:"white", borderRadius:8, padding:"10px 14px", fontSize:13, fontFamily:fontSans, marginBottom:16, outline:"none", boxSizing:"border-box" as const
        }}>
          {RAZONES_BAJA_VEHICULO.map(r => (
            <option key={r.value} value={r.value} style={{background:"#0B1829"}}>{r.label}</option>
          ))}
        </select>

        <label style={{display:"block", fontSize:11, color:gold, marginBottom:6, fontWeight:600, letterSpacing:"0.5px", textTransform:"uppercase" as const}}>
          Notas (opcional)
        </label>
        <textarea value={notas} onChange={(e)=>setNotas(e.target.value)} rows={3} placeholder="Información adicional sobre la baja..."
          style={{
            width:"100%", background:"rgba(255,255,255,0.05)", border:"1px solid rgba(184,147,42,0.25)",
            color:"white", borderRadius:8, padding:"10px 14px", fontSize:13, fontFamily:fontSans, marginBottom:18, outline:"none", resize:"vertical" as const, boxSizing:"border-box" as const, fontFamily:fontSans
          }}/>
        
        <div style={{background:"rgba(239,159,39,0.08)", border:"1px solid rgba(239,159,39,0.25)", borderRadius:8, padding:"10px 12px", marginBottom:18}}>
          <p style={{fontSize:12, color:"rgba(232,226,213,0.8)", margin:0, lineHeight:1.5}}>
            ⓘ El vehículo dejará de aparecer en el listado de activos y no afectará tu % de expediente capturado. Su historial se conserva y puedes reactivarlo después.
          </p>
        </div>

        <div style={{display:"flex", gap:10}}>
          <button onClick={(ev)=>{ if (sePuedeCerrarElPanel(ev)) onClose(); }} style={{
            flex:1, background:"transparent", border:"1px solid rgba(255,255,255,0.2)",
            color:"white", borderRadius:10, padding:"10px 16px", cursor:"pointer", fontSize:13, fontFamily:fontSans
          }}>
            Cancelar
          </button>
          <button onClick={()=>onConfirmar(razon, notas)} style={{
            flex:1, background:"#E24B4A", border:"none",
            color:"white", borderRadius:10, padding:"10px 16px", cursor:"pointer", fontSize:13, fontFamily:fontSans, fontWeight:600
          }}>
            Confirmar baja
          </button>
        </div>
      </div>
    </div>
  );
}

function ResumenFlotilla({vehiculos, registros, gold, fontSans, fontSerif, isMobile}: {
  vehiculos: Vehiculo[]; registros: RegistroFlotilla[];
  gold: string; fontSans: string; fontSerif: string; isMobile: boolean;
}) {
  const cubos = cubosFlotilla(vehiculos);
  
  const hoy = new Date();
  const inicioMes = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
  const registrosMes = registros.filter(r => {
    if (!r.timestamp) return false;
    const ts: any = r.timestamp;
    const fecha = ts.toDate ? ts.toDate() : new Date(ts);
    return fecha >= inicioMes;
  });
  
  return (
    <div>
      <h3 style={{color:T_LIGHT.textInk, fontFamily:fontSerif, fontSize:18, fontWeight:600, margin:"0 0 16px"}}>
        Estado actual de la flota
      </h3>

      {/* CINCO CUBOS QUE SUMAN. Decían "En regla / Atención / Crítico", que son
          calificaciones y no hechos, y además "Atención" mezclaba lo que vence la
          semana que viene con lo que nadie ha capturado nunca —dos cosas que se
          arreglan de forma distinta—. Cada unidad activa cae en UNO solo, el más
          urgente, así que los cuatro primeros suman el total de unidades activas. */}
      <div style={{display:"grid", gridTemplateColumns:isMobile?"repeat(2,1fr)":"repeat(5,1fr)", gap:12, marginBottom:8}}>
        {([
          {n: cubos.vencido,        t: "Con documento vencido",   c: "#E24B4A"},
          {n: cubos.por_vencer,     t: "Con algo por vencer",     c: "#EF9F27"},
          {n: cubos.sin_capturar,   t: "Con documentos sin capturar", c: "#8A93A6"},
          {n: cubos.sin_pendientes, t: "Sin pendientes",          c: "#1D9E75"},
          {n: cubos.baja,           t: "Dadas de baja",           c: T_LIGHT.textInkMut},
        ] as const).map((k, i) => (
          <div key={i} style={{background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:12, padding:"14px 16px", boxShadow:T_LIGHT.shadow, borderLeft:`3px solid ${k.c}`}}>
            <div style={{fontFamily:fontSerif, fontSize:28, color:k.c, fontWeight:700, lineHeight:1}}>{k.n}</div>
            <div style={{fontSize:10.5, color:T_LIGHT.textInkSoft, fontWeight:600, marginTop:5, lineHeight:1.35}}>{k.t}</div>
          </div>
        ))}
      </div>
      <div style={{fontSize:11, color:T_LIGHT.textInkMut, marginBottom:24, lineHeight:1.5}}>
        Cada unidad cuenta una sola vez, en lo más urgente que tenga: los cuatro primeros suman las
        {" "}{cubos.activos} {cubos.activos === 1 ? "unidad activa" : "unidades activas"}.
      </div>

      <h3 style={{color:T_LIGHT.textInk, fontFamily:fontSerif, fontSize:18, fontWeight:600, margin:"0 0 16px"}}>
        Actividad del mes
      </h3>

      <div style={{background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:12, padding:"18px 20px", marginBottom:16, boxShadow:T_LIGHT.shadow}}>
        <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14, paddingBottom:14, borderBottom:`1px solid ${T_LIGHT.border}`}}>
          <div>
            <div style={{color:T_LIGHT.textInk, fontSize:13, fontWeight:600}}>Movimientos registrados</div>
            <div style={{fontSize:11, color:T_LIGHT.textInkSoft, marginTop:2}}>Desde el 1 de {hoy.toLocaleDateString("es-MX", {month:"long"})} hasta hoy</div>
          </div>
          <span style={{fontFamily:fontSerif, fontSize:28, color:gold, fontWeight:700}}>{registrosMes.length}</span>
        </div>
        <div style={{display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:10}}>
          {[
            {n: registrosMes.filter((r:any)=>r.tipo==="salida").length, l:"Salidas", c:"#5DA0E8"},
            {n: registrosMes.filter((r:any)=>r.tipo==="llegada").length, l:"Llegadas", c:"#D97706"},
            {n: registrosMes.filter((r:any)=>r.tipo==="regreso").length, l:"Regresos", c:"#1D9E75"},
            {n: registrosMes.filter((r:any)=>r.estado==="incidente").length, l:"Incidentes", c: registrosMes.filter((r:any)=>r.estado==="incidente").length>0?"#E24B4A":T_LIGHT.textInkMut},
          ].map(s => (
            <div key={s.l} style={{textAlign:"center" as const}}>
              <div style={{fontFamily:fontSerif, fontSize:22, color:s.c, fontWeight:700, lineHeight:1}}>{s.n}</div>
              <div style={{fontSize:10, color:T_LIGHT.textInkMut, textTransform:"uppercase" as const, letterSpacing:"0.5px", marginTop:4, fontWeight:700}}>{s.l}</div>
            </div>
          ))}
        </div>
      </div>

      {registrosMes.length > 0 && (
        <div>
          <div style={{fontSize:11, color:T_LIGHT.textInkMut, marginBottom:10, textTransform:"uppercase" as const, letterSpacing:"0.5px", fontWeight:700}}>Últimos movimientos</div>
          <div style={{display:"flex", flexDirection:"column" as const, gap:6}}>
            {registrosMes.slice(0,5).map((r:any) => {
              const ts:any = r.timestamp;
              const f = ts?.toDate ? ts.toDate() : null;
              const fechaStr = f ? f.toLocaleString("es-MX",{day:"2-digit",month:"short",hour:"2-digit",minute:"2-digit"}) : "";
              const tc = r.tipo==="salida"?"#5DA0E8":r.tipo==="llegada"?"#D97706":"#1D9E75";
              const tt = r.tipo==="salida"?"Salida":r.tipo==="llegada"?"Llegada":"Regreso";
              return (
                <div key={r.id} style={{display:"flex", alignItems:"center", gap:10, padding:"9px 12px", background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:8, fontSize:12, flexWrap:"wrap" as const}}>
                  <span style={{color:tc, fontWeight:700, fontSize:11, minWidth:52}}>{tt}</span>
                  <span style={{color:T_LIGHT.textInk, fontFamily:fontSerif, fontWeight:600}}>{r.placa}</span>
                  <span style={{color:T_LIGHT.textInkSoft, flex:1, minWidth:0, overflow:"hidden", textOverflow:"ellipsis" as const, whiteSpace:"nowrap" as const}}>{r.conductor||"Sin conductor"}{r.destino?` · ${r.destino}`:""}</span>
                  <span style={{color:T_LIGHT.textInkMut, fontSize:11, flexShrink:0}}>{fechaStr}</span>
                </div>
              );
            })}
          </div>
          {registrosMes.length > 5 && <div style={{fontSize:11, color:T_LIGHT.textInkMut, marginTop:8, textAlign:"center" as const}}>Ver todos en la pestaña Historial o en el reporte PDF.</div>}
        </div>
      )}
    </div>
  );
}

// ── DETALLE DE UN MOVIMIENTO DE FLOTILLA ─────────────────────────────────────
// Componente compartido por el escritorio y la app. Antes vivía inline dentro de
// `HistorialFlotilla`, así que la app no podía mostrarlo: el celular enseñaba la
// placa y el kilometraje, y se quedaba sin el veredicto documental, que es lo que
// hace valiosa la bitácora. Extraerlo evita mantener dos copias que se
// desincronizan; el único ajuste por pantalla es el alto de la tarjeta y del mapa.
//
// Misma cáscara de modal que usa Flotilla para "Agregar vehículo": fondo
// translúcido con desenfoque, tarjeta blanca centrada, cierre al pulsar fuera.

// ─── VIAJES DE FLOTILLA — ARMADO ÚNICO ──────────────────────────────────────
// TODA pantalla que muestre viajes pasa por aquí. No debe existir una segunda
// forma de agruparlos: dos criterios sobre la misma colección producen dos
// verdades, y esta es la colección que se presenta como prueba.
//
// CÓMO SE ARMA UN VIAJE, en este orden:
//   1) Por `salidaId`. La salida es la cabeza del viaje y su propio id de
//      documento es el id del viaje. Toda llegada y todo regreso que lo traigan
//      se cuelgan de ahí sin adivinar nada. Esto es LECTURA, no inferencia.
//   2) Por inferencia, solo para lo registrado antes de que se escribiera
//      `salidaId`. Y la inferencia particiona PRIMERO por UNIDAD y PERSONA, y
//      solo después camina en el tiempo.
//
// Nunca se juntan movimientos de dos personas ni de dos unidades. Cuando la
// unidad o la persona no se pueden determinar, el movimiento queda SUELTO: un
// renglón huérfano honesto vale más que un viaje inventado, y en un registro
// probatorio la diferencia tiene nombre y apellido.
type MomentoViaje = {m:any; ms:number; d:Date|null};
type ViajeFlotilla = {
  id: string;
  salida: MomentoViaje|null;
  paradas: MomentoViaje[];
  regreso: MomentoViaje|null;
  momentos: MomentoViaje[];
  estado: "abierto"|"cerrado"|"sin_regreso"|"suelto";
  cierre: {ms:number; d:Date|null; motivo:string}|null;
  veh: any;
  placa: string;
  conductor: string;
  unidadClave: string;
  personaClave: string;
  msIni: number;
  msFin: number;
  d: Date|null;
};

// Nombre comparable: sin acentos, sin dobles espacios, en mayúsculas. NO
// intenta emparejar "Juan" con "Juan Pérez": para el código son dos personas
// distintas, y eso es deliberado. Adivinar que son la misma es exactamente la
// clase de atribución que no queremos.
function _nombreClave(s:any): string {
  return String(s||"").normalize("NFD").replace(/[̀-ͯ]/g,"").toUpperCase().replace(/[^A-Z0-9 ]/g," ").replace(/\s+/g," ").trim();
}
function _placaClave(s:any): string {
  return String(s||"").toUpperCase().replace(/[^A-Z0-9]/g,"");
}

// QUIÉN CONDUJO. En la app del trabajador el correo es suyo y es de fiar. En el
// escritorio no siempre: durante mucho tiempo `conductorEmail` se guardó como el
// correo del PATRÓN, así que ahí solo se acepta si difiere del de quien capturó
// —y solo si ese dato existe para poder compararlo—. Cuando no hay correo
// creíble se cae al nombre; cuando no hay ni nombre, no hay persona y el
// movimiento no se encadena con nada.
function _personaDeMovimiento(m:any): string {
  let correo = "";
  const ce = String(m?.conductorEmail||"").toLowerCase().trim();
  const te = String(m?.trabajadorEmail||"").toLowerCase().trim();
  const re = String(m?.registradoPorEmail||"").toLowerCase().trim();
  if (m?.registradoPorRol === "trabajador") correo = ce || te || re;
  else if (ce && re && ce !== re) correo = ce;
  if (correo) return "e:" + correo;
  const n = _nombreClave(m?.conductorNombre || m?.conductor);
  return n ? "n:" + n : "";
}

// Índice de unidades con GUARDIÁN DE AMBIGÜEDAD: si dos unidades comparten placa
// normalizada, esa placa deja de identificar a una sola y se marca ambigua.
function _indiceUnidades(vehiculos:any[]) {
  const porId: Record<string, any> = {};
  const porPlaca: Record<string, any> = {};
  (vehiculos||[]).forEach((v:any)=>{
    if (v?.id) porId[v.id] = v;
    const pl = _placaClave(v?.placa);
    if (pl) porPlaca[pl] = (pl in porPlaca) ? null : v;
  });
  return {porId, porPlaca};
}

// UNIDAD del movimiento, NORMALIZADA ANTES DE AGRUPAR. Si la placa se puede
// resolver a una unidad del catálogo, la clave es SIEMPRE el id: si no, la misma
// unidad generaría dos grupos —los registros viejos no traen vehiculoId— y un
// viaje que cruce esa frontera se partiría en dos sin que nada lo avisara.
// Clave vacía = unidad indeterminable: ese movimiento no encadena con ninguno.
function _unidadDeMovimiento(m:any, idx:{porId:Record<string,any>; porPlaca:Record<string,any>}): {clave:string; veh:any} {
  const id = m?.vehiculoId;
  if (id && idx.porId[id]) return {clave:"v:"+id, veh:idx.porId[id]};
  const pl = _placaClave(m?.placa);
  if (pl) {
    const porPlaca = idx.porPlaca[pl];
    // `null` significa "más de una unidad con esta placa": ambiguo, no se usa.
    if (porPlaca) return {clave:"v:"+porPlaca.id, veh:porPlaca};
    if (pl in idx.porPlaca) return {clave:"", veh:undefined};
    // Placa que no está en el catálogo (modo libre): identifica de forma
    // consistente aunque no haya ficha detrás.
    if (!id) return {clave:"p:"+pl, veh:undefined};
  }
  // Unidad dada de baja o borrada: el id sigue siendo un identificador estable.
  if (id) return {clave:"v:"+id, veh:undefined};
  return {clave:"", veh:undefined};
}

function armarViajesFlotilla(registros:any[], vehiculos:any[]): ViajeFlotilla[] {
  const idx = _indiceUnidades(vehiculos);
  const movs = (registros||[]).map((m:any)=>({
    m,
    ms: m?.timestamp?.toMillis?.() || 0,
    d:  m?.timestamp?.toDate?.() || null,
    tipo: String(m?.tipo||"").toLowerCase(),
    unidad: _unidadDeMovimiento(m, idx),
    persona: _personaDeMovimiento(m),
  }));

  // CIERRES SIN REGRESO. Una salida nueva puede declarar que la anterior se
  // quedó sin cerrar (`cierraViajeId`). El asiento original NO se toca: el hecho
  // se deriva de un acto nuevo, fechado y atribuible.
  const cierres: Record<string, {ms:number; d:Date|null; motivo:string}> = {};
  movs.forEach((x:any)=>{
    const ref = x.m?.cierraViajeId;
    if (ref) cierres[ref] = {ms:x.ms, d:x.d, motivo:String(x.m?.cierraViajeMotivo||"")};
  });

  const grupos: Record<string, any> = {};
  let nSueltos = 0;
  const grupo = (id:string) => (grupos[id] = grupos[id] || {id, salida:null, paradas:[], regreso:null});

  // 1) Cabezas: cada salida ES un viaje, identificado por su propio id.
  movs.filter((x:any)=>x.tipo==="salida").forEach((x:any)=>{
    const g = grupo("s:" + (x.m.id || `sin-id-${x.ms}`));
    g.salida = {m:x.m, ms:x.ms, d:x.d};
    g.unidad = x.unidad; g.persona = x.persona;
  });

  // 2) Enlace EXPLÍCITO. Gana sobre todo lo demás: no hay nada que inferir, y
  //    vale aunque la unidad o la persona del movimiento no se puedan
  //    determinar. Si la cabeza no está cargada, el grupo queda sin salida.
  const pendientes: any[] = [];
  movs.filter((x:any)=>x.tipo!=="salida").forEach((x:any)=>{
    const ref = x.m?.salidaId;
    if (ref) {
      const g = grupo("s:" + ref);
      if (x.tipo==="regreso") g.regreso = {m:x.m, ms:x.ms, d:x.d};
      else g.paradas.push({m:x.m, ms:x.ms, d:x.d});
    } else pendientes.push(x);
  });

  // 3) INFERENCIA, solo para lo que no trae enlace. Se parte por UNIDAD +
  //    PERSONA y se camina en el tiempo dentro de cada partición. Un movimiento
  //    sin unidad o sin persona identificable no entra a ninguna partición: sale
  //    suelto. Encadenarlos entre sí sería inventar viajes.
  const particiones: Record<string, any[]> = {};
  const suelto = (x:any) => {
    const g = grupo(`x:${x.m.id || "sin-id"}:${++nSueltos}`);
    if (x.tipo==="regreso") g.regreso = {m:x.m, ms:x.ms, d:x.d};
    else g.paradas.push({m:x.m, ms:x.ms, d:x.d});
    g.unidad = x.unidad; g.persona = x.persona;
  };
  pendientes.forEach((x:any)=>{
    if (!x.unidad.clave || !x.persona) { suelto(x); return; }
    const k = x.unidad.clave + "|" + x.persona;
    (particiones[k] = particiones[k] || []).push(x);
  });
  // Las salidas entran a la partición como referencia temporal: son las que
  // abren y cierran el tramo al que se puede colgar un movimiento.
  movs.filter((x:any)=>x.tipo==="salida" && x.unidad.clave && x.persona).forEach((x:any)=>{
    const k = x.unidad.clave + "|" + x.persona;
    if (particiones[k]) particiones[k].push(x);
  });
  Object.keys(particiones).forEach((k)=>{
    const lista = particiones[k].sort((a:any,b:any)=> a.ms - b.ms);
    let abierta: string|null = null;
    lista.forEach((x:any)=>{
      if (x.tipo === "salida") { abierta = "s:" + (x.m.id || `sin-id-${x.ms}`); return; }
      if (!abierta) { suelto(x); return; }          // llegada o regreso sin salida previa
      const g = grupo(abierta);
      if (x.tipo === "regreso") { g.regreso = {m:x.m, ms:x.ms, d:x.d}; abierta = null; }
      else g.paradas.push({m:x.m, ms:x.ms, d:x.d});
    });
  });

  // 4) Consolidación: estado, unidad, persona y orden interno.
  return Object.keys(grupos).map((gid)=>{
    const g = grupos[gid];
    g.paradas.sort((a:any,b:any)=> a.ms - b.ms);
    const momentos: MomentoViaje[] = [g.salida, ...g.paradas, g.regreso].filter(Boolean) as MomentoViaje[];
    const ref = g.salida || momentos[0];
    const refM = ref ? ref.m : {};
    const unidad = g.unidad || _unidadDeMovimiento(refM, idx);
    const cierre = (g.salida && cierres[g.salida.m.id]) ? cierres[g.salida.m.id] : null;
    const estado: ViajeFlotilla["estado"] =
      !g.salida       ? "suelto"
      : g.regreso     ? "cerrado"
      : cierre        ? "sin_regreso"
      :                 "abierto";
    return {
      id: gid,
      salida: g.salida, paradas: g.paradas, regreso: g.regreso, momentos,
      estado,
      cierre: (estado === "sin_regreso") ? cierre : null,
      veh: unidad.veh,
      placa: refM.placa || "",
      conductor: refM.conductorNombre || refM.conductor || "Trabajador",
      unidadClave: unidad.clave,
      personaClave: g.persona || _personaDeMovimiento(refM),
      msIni: momentos[0]?.ms || 0,
      msFin: momentos[momentos.length-1]?.ms || 0,
      d: momentos[0]?.d || null,
    } as ViajeFlotilla;
  })
  // ORDEN: los abiertos primero —son unidades en la calle AHORA— y después todo
  // lo demás por fecha de salida descendente. "Sin regreso registrado" NO va con
  // los abiertos: es un estado propio, y confundirlos haría creer que hay más
  // unidades fuera de las que hay.
  .sort((a,b)=>{
    const pa = a.estado==="abierto" ? 0 : 1, pb = b.estado==="abierto" ? 0 : 1;
    return pa !== pb ? pa - pb : b.msIni - a.msIni;
  });
}

// UNIDADES FUERA AHORA MISMO. No es un incumplimiento y no lleva umbral: que una
// unidad esté en la calle es lo normal en una transportista, y "lleva demasiado
// tiempo fuera" sería una regla inventada que nadie puede sostener. Lo que hay es
// un HECHO: qué unidad, desde cuándo y quién la sacó.
//
// Sale de `armarViajesFlotilla`, la misma función que usan Flotilla y la app del
// patrón, y conserva su orden. Un viaje "abierto" es exactamente eso: salió y no
// ha registrado regreso. "Sin regreso registrado" es OTRO estado y NO entra aquí:
// mezclarlos haría creer que hay más unidades fuera de las que hay.
function unidadesFueraAhora(registros:any[], vehiculos:any[]): ViajeFlotilla[] {
  return armarViajesFlotilla(registros||[], vehiculos||[]).filter(v => v.estado === "abierto");
}

// Filtro A NIVEL VIAJE. Filtrar por conductor devuelve viajes completos de esa
// persona, no los renglones sueltos que coincidan: un viaje es la unidad de
// lectura, y partirlo al filtrar volvería a la lista cronológica que estorbaba.
function filtrarViajesFlotilla(viajes: ViajeFlotilla[], f: {
  texto?: string; unidad?: string; persona?: string; desde?: string; hasta?: string;
}): ViajeFlotilla[] {
  const q = String(f.texto||"").trim().toLowerCase();
  const msDesde = f.desde ? new Date(`${f.desde}T00:00:00`).getTime() : null;
  const msHasta = f.hasta ? new Date(`${f.hasta}T23:59:59`).getTime() : null;
  return viajes.filter((v)=>{
    if (f.unidad && v.unidadClave !== f.unidad) return false;
    if (f.persona && v.personaClave !== f.persona) return false;
    // El rango se mide contra el viaje COMPLETO: uno que salió antes y sigue
    // dentro del rango es justamente el que hay que ver.
    if (msDesde !== null && v.msFin < msDesde) return false;
    if (msHasta !== null && v.msIni > msHasta) return false;
    if (q) {
      const heno = v.momentos.map((mv)=>[
        mv.m.placa, mv.m.destino, mv.m.conductorNombre, mv.m.conductor,
      ].filter(Boolean).join(" ")).join(" ").toLowerCase();
      if (heno.indexOf(q) < 0) return false;
    }
    return true;
  });
}

// Unidades y personas presentes en un conjunto de viajes, para poblar los
// selectores. Salen de los viajes y no del catálogo: un filtro que ofrece
// opciones sin resultados hace perder el tiempo.
function opcionesDeViajes(viajes: ViajeFlotilla[]) {
  const unidades: Record<string,string> = {};
  const personas: Record<string,string> = {};
  viajes.forEach((v)=>{
    if (v.unidadClave) unidades[v.unidadClave] = v.veh
      ? [v.veh.placa, [v.veh.marca, v.veh.modelo].filter(Boolean).join(" ")].filter(Boolean).join(" · ")
      : (v.placa || "Unidad sin placa");
    if (v.personaClave) personas[v.personaClave] = v.conductor;
  });
  const orden = (o:Record<string,string>) => Object.keys(o)
    .map(k=>({clave:k, etiqueta:o[k]}))
    .sort((a,b)=> a.etiqueta.localeCompare(b.etiqueta));
  return {unidades: orden(unidades), personas: orden(personas)};
}

// "hace 6 horas". Para viajes sin regreso: dice desde cuándo está abierto.
function desdeHaceTexto(ms:number): string {
  const min = Math.floor((Date.now() - ms) / 60000);
  if (min < 1) return "hace un momento";
  if (min < 60) return `hace ${min} min`;
  const h = Math.floor(min / 60);
  if (h < 24) return `hace ${h} ${h===1?"hora":"horas"}`;
  const dd = Math.floor(h / 24);
  return `hace ${dd} ${dd===1?"día":"días"}`;
}
function duracionViajeTexto(ms:number): string {
  const min = Math.max(0, Math.round(ms / 60000));
  if (min < 60) return `${min} min`;
  const h = Math.floor(min / 60), r = min % 60;
  if (h < 24) return r ? `${h} h ${r} min` : `${h} h`;
  const dd = Math.floor(h / 24), rh = h % 24;
  return rh ? `${dd} d ${rh} h` : `${dd} d`;
}
// Kilometraje: "" y null NO son cero. Number("") daría 0 y eso inventaría una
// distancia que nadie capturó.
function kmDeCampo(x:any): number|null {
  if (x===null || x===undefined || x==="") return null;
  const n = Number(x); return Number.isFinite(n) ? n : null;
}

// VELOCIDAD MEDIA MÁXIMA CREÍBLE, en km/h, para juzgar si una distancia se
// sostiene. No es un límite legal ni una regla del cliente: es el techo a partir
// del cual la lectura del odómetro dejó de ser un dato y pasó a ser un error de
// captura. 120 km/h de PROMEDIO durante todo el viaje —paradas incluidas— ya es
// más de lo que sostiene un vehículo de trabajo en carretera mexicana.
//
// Se mide contra la DURACIÓN del viaje y no contra un tope fijo de kilómetros,
// porque un viaje de tres días recorre legítimamente lo que uno de dos horas no.
// La ventana mínima de una hora evita juzgar un viaje de diez minutos por su
// duración: ahí el margen sería tan estrecho que marcaría como error cualquier
// salida corta a carretera.
const KM_VELOCIDAD_MAX = 120;
const KM_VENTANA_MIN_H = 1;

// Los kilómetros de un viaje, CON EL MOTIVO cuando no se pueden afirmar. Esta es
// la única función que calcula la distancia de un viaje: la usan las dos
// tarjetas y el reporte, así que el guardián vive aquí y no en cada lector.
//
// Un odómetro que retrocede o que salta millones de kilómetros no es una
// distancia pequeña ni grande: es una lectura que no se sostiene. Imprimirla
// como un hecho en un documento que sale de la empresa es peor que no imprimir
// nada, así que se devuelve el motivo y las dos lecturas crudas para que quien
// lea sepa QUÉ corregir.
type KmDeViaje =
  | {estado:"ok"; km:number; ini:number; fin:number}
  | {estado:"sin_lecturas"}
  | {estado:"sin_avance"; ini:number; fin:number}
  | {estado:"inconsistente"; motivo:"retrocede"|"excesivo"; ini:number; fin:number; km:number};
// EL TECHO, Y LA REGLA QUE LO APLICA. Estaba dentro de kmDeViajeDetalle, que solo
// corre al LEER un viaje ya guardado. El formulario que captura la lectura tiene
// que poder preguntar lo mismo ANTES de guardar —es más barato corregir un dedazo
// en el momento que descubrirlo impreso en un reporte—, y para eso la regla vive
// aquí y no dentro de un lector.
function techoKmEnHoras(horas: number): number {
  return Math.max(KM_VENTANA_MIN_H, horas) * KM_VELOCIDAD_MAX;
}
// null = la lectura se sostiene. Si no, dice POR QUÉ y contra qué techo, para que
// quien avise pueda explicarlo en vez de limitarse a decir que algo está mal.
function saltoKmSospechoso(ini: number, fin: number, horas: number):
  {motivo: "retrocede"|"excesivo"; km: number; techo: number} | null {
  const km = Math.round(fin - ini);
  const techo = Math.round(techoKmEnHoras(horas));
  if (km < 0) return {motivo:"retrocede", km, techo};
  if (km > techo) return {motivo:"excesivo", km, techo};
  return null;
}

function kmDeViajeDetalle(v: ViajeFlotilla): KmDeViaje {
  const ini = kmDeCampo(v.salida?.m?.kmInicial);
  const fin = v.regreso ? (kmDeCampo(v.regreso.m.kmFinal) ?? kmDeCampo(v.regreso.m.kmLlegada)) : null;
  if (ini === null || fin === null) return {estado:"sin_lecturas"};
  const km = Math.round(fin - ini);
  if (km === 0) return {estado:"sin_avance", ini, fin};
  const horas = (v.salida && v.regreso) ? (v.regreso.ms - v.salida.ms) / 3600000 : 0;
  const malo = saltoKmSospechoso(ini, fin, horas);
  if (malo) return {estado:"inconsistente", motivo:malo.motivo, ini, fin, km};
  return {estado:"ok", km, ini, fin};
}
// Solo el número, y solo cuando se puede afirmar. Es lo que necesitan las
// tarjetas: ahí no hay espacio para explicar una lectura rota.
function kmDeViaje(v: ViajeFlotilla): number|null {
  const r = kmDeViajeDetalle(v);
  return r.estado === "ok" ? r.km : null;
}
// Cuántas fotos trae el viaje entero.
function fotosDeViaje(v: ViajeFlotilla): number {
  return v.momentos.reduce((s:number, mv:any)=> s + fotosDeMovimiento(mv.m).length, 0);
}
// Etiqueta de cada momento dentro del viaje, con las mismas palabras y los
// mismos colores en las dos pantallas.
function momentosDeViaje(v: ViajeFlotilla) {
  return v.momentos.map((mv:any, i:number)=>({
    mv,
    etiqueta: mv===v.salida ? "Salida" : mv===v.regreso ? "Regreso" : `Parada ${v.paradas.indexOf(mv)+1}`,
    color: mv===v.salida ? "#D97706" : mv===v.regreso ? "#059669" : "#2F5FA8",
    ultimo: i === v.momentos.length - 1,
  }));
}

// Etiqueta del estado del viaje, con las MISMAS palabras en todas las pantallas.
function estadoViajeMeta(estado: ViajeFlotilla["estado"]): {texto:string; color:string} {
  if (estado === "abierto")     return {texto:"ABIERTO", color:"#D97706"};
  if (estado === "sin_regreso") return {texto:"SIN REGRESO REGISTRADO", color:"#DC2626"};
  if (estado === "suelto")      return {texto:"MOVIMIENTO SUELTO", color:"#5B6784"};
  return {texto:"CERRADO", color:"#059669"};
}
function DetalleMovimientoFlotilla({registro, vehiculo, fecha, onClose, isMobile, fontSans, fontSerif}: {
  registro:any; vehiculo:any; fecha:Date|null; onClose:()=>void;
  isMobile:boolean; fontSans:string; fontSerif:string;
}) {
  const r:any = registro; const veh:any = vehiculo;
    const est = estadoDocumentalRegistro(r, veh, fecha);
    const tt = r.tipo==="salida"?"Salida":r.tipo==="llegada"?"Llegada":"Regreso";
    const nf = (n:any)=> (n===0||n) ? Number(n).toLocaleString("es-MX") : null;
    // Un dato vacío NO se pinta: una ficha llena de guiones no dice nada.
    const filas: {k:string; v:any}[] = [
      {k:"Movimiento", v: tt},
      {k:"Fecha y hora", v: fecha ? fecha.toLocaleString("es-MX",{dateStyle:"full", timeStyle:"short"}) : (r.fecha||"")},
      {k:"Placa", v: r.placa},
      {k:"Unidad", v: veh ? [veh.marca, veh.modelo, veh.anio].filter(Boolean).join(" ") : null},
      {k:"Conductor", v: r.conductor || r.conductorNombre},
      {k:"Destino", v: r.destino},
      {k:"Kilometraje inicial", v: nf(r.kmInicial)},
      {k:"Kilometraje de llegada", v: nf(r.kmLlegada)},
      {k:"Kilometraje final", v: nf(r.kmFinal)},
      {k:"Kilómetros recorridos", v: nf(r.kmRecorridos)},
      {k:"Estado del viaje", v: r.estado==="incidente" ? "Incidente reportado" : r.estado==="revision" ? "Requiere revisión" : r.estado==="normal" ? "Normal" : null},
      {k:"Observaciones", v: (r.observaciones||"").trim() || null},
      {k:"Registrado por", v: r.registradoPorNombre || r.registradoPorEmail},
      {k:"Rol de quien registró", v: r.registradoPorRol==="trabajador" ? "Trabajador" : r.registradoPorRol==="patron" ? "Patrón" : null},
      {k:"Correo de quien registró", v: r.registradoPorEmail},
    ].filter(x => x.v !== null && x.v !== undefined && String(x.v).trim() !== "");
    return (
      <div onClick={()=>onClose()}
        style={{position:"fixed" as const, inset:0, background:"rgba(0,0,0,0.55)", backdropFilter:"blur(4px)",
          zIndex:300, display:"flex", alignItems:"center", justifyContent:"center", padding:16}}>
        <div onClick={e=>e.stopPropagation()}
          style={{background:"white", borderRadius:16, padding: isMobile?"18px 18px":"24px 26px", maxWidth:560, width:"100%",
            maxHeight:"90vh", overflowY:"auto" as const, fontFamily:fontSans, boxShadow:"0 24px 64px rgba(0,0,0,0.28)"}}>
          <div style={{display:"flex", alignItems:"center", gap:10, marginBottom:4}}>
            <AxisIcon name="suite_flotilla" size={22} tone="gold" withBackdrop={false} strokeWidth={2.5}/>
            <h3 style={{fontFamily:fontSerif, fontSize:isMobile?17:20, color:"#0F172A", margin:0, fontWeight:600, flex:1, minWidth:0}}>
              {tt} · {r.placa||"Sin placa"}
            </h3>
            <button onClick={()=>onClose()} aria-label="Cerrar"
              style={{background:"transparent", border:"none", cursor:"pointer", fontSize:20, color:"#6B7280", lineHeight:1, padding:"0 4px"}}>×</button>
          </div>
          <p style={{fontSize:12, color:"#6B7280", margin:"0 0 18px"}}>Todo lo que se capturó en este movimiento.</p>

          {/* ESTADO DOCUMENTAL a la fecha del movimiento, no a hoy. */}
          {est.tipo === "vencido" ? (
            <div style={{marginBottom:16, fontSize:12.5, fontWeight:700, color:"#B3261E", background:"rgba(226,75,74,0.10)",
              border:"1px solid rgba(226,75,74,0.30)", borderRadius:10, padding:"10px 12px", lineHeight:1.5}}>
              ⚠ Circuló con documento vencido: {est.documentos.join(", ")}
            </div>
          ) : est.tipo === "vigente" ? (
            <div style={{marginBottom:16, fontSize:12.5, color:"#117A56", background:"rgba(29,158,117,0.10)",
              border:"1px solid rgba(29,158,117,0.30)", borderRadius:10, padding:"10px 12px", lineHeight:1.5}}>
              Documentación vigente a la fecha del registro
            </div>
          ) : (
            <div style={{marginBottom:16, fontSize:12.5, color:"#6B7280", background:"rgba(0,0,0,0.03)",
              border:"1px solid rgba(0,0,0,0.10)", borderRadius:10, padding:"10px 12px", lineHeight:1.5}}>
              {est.tipo === "sin_datos"
                ? "Sin registro documental de la unidad: no hay fechas capturadas, así que no se puede afirmar nada sobre su vigencia."
                : "Documentación no verificable: el movimiento no quedó referido a una unidad del catálogo."}
            </div>
          )}

          <div style={{display:"flex", flexDirection:"column" as const, gap:0}}>
            {filas.map((x, i)=>(
              <div key={x.k} style={{display:"flex", gap:12, alignItems:"baseline", padding:"9px 0",
                borderTop: i===0 ? "none" : "1px solid rgba(0,0,0,0.07)"}}>
                <span style={{fontSize:11, color:"#9A9AAA", textTransform:"uppercase" as const, letterSpacing:"0.5px",
                  fontWeight:700, minWidth:isMobile?110:150, flexShrink:0}}>{x.k}</span>
                <span style={{fontSize:13, color:"#0F172A", fontWeight:600, minWidth:0, wordBreak:"break-word" as const}}>{x.v}</span>
              </div>
            ))}
          </div>

          {/* UBICACIÓN: mapa embebido y enlace, solo si el registro la trae. */}
          {(r.lat && r.lng) ? (
            <div style={{marginTop:16}}>
              <div style={{fontSize:11, color:"#9A9AAA", textTransform:"uppercase" as const, letterSpacing:"0.5px", fontWeight:700, marginBottom:8}}>
                Ubicación del registro
              </div>
              <iframe title="Ubicación del movimiento" loading="lazy"
                src={`https://www.openstreetmap.org/export/embed.html?bbox=${r.lng-0.006},${r.lat-0.006},${r.lng+0.006},${r.lat+0.006}&layer=mapnik&marker=${r.lat},${r.lng}`}
                style={{width:"100%", height:isMobile?180:220, border:"1px solid rgba(0,0,0,0.12)", borderRadius:10, display:"block"}}/>
              <a href={`https://www.google.com/maps?q=${r.lat},${r.lng}`} target="_blank" rel="noopener noreferrer"
                style={{display:"inline-block", marginTop:8, fontSize:12, fontWeight:700, color:"#2563EB", textDecoration:"none"}}>
                Abrir en Google Maps ›
              </a>
            </div>
          ) : (
            <div style={{marginTop:16, fontSize:11.5, color:"#9A9AAA", lineHeight:1.5}}>
              Sin ubicación: el registro se guardó sin coordenadas (el dispositivo no las dio o no se autorizó).
            </div>
          )}

          {/* FOTOS DEL MOVIMIENTO. Se abren en pestaña nueva a tamaño completo:
              una miniatura de 84 px no sirve para leer una placa ni ver un golpe.
              No hay borrar: un asiento de bitácora del que se pueden quitar las
              pruebas deja de servir como prueba. */}
          {(()=>{
            const fotos = fotosDeMovimiento(r);
            if (fotos.length === 0) return null;
            // Por la tira común: pulsar una la abre grande y se pasa a la siguiente
            // sin salir de aquí. Antes cada foto abría una pestaña nueva, y mirar
            // seis eran seis pestañas y seis vueltas atrás.
            return (
              <TiraMiniaturas
                titulo={fotos.length===1 && !r.video ? "Foto del movimiento" : "Del movimiento"}
                imagenes={[
                  ...fotos.map((f:any, i:number)=>({url:f.url, titulo:`Foto ${i+1} del movimiento`, tipo:"imagen" as const})),
                  // El video va en la MISMA tira: subirlo y no enseñarlo seria
                  // repetir el defecto que esta rama viene arreglando.
                  ...(r.video ? [{url:r.video, titulo:"Video del movimiento", tipo:"video" as const}] : []),
                ]}/>
            );
          })()}
          <button onClick={()=>onClose()}
            style={{marginTop:20, width:"100%", background:"rgba(0,0,0,0.05)", border:"none", borderRadius:10,
              padding:"12px", cursor:"pointer", fontSize:13, fontWeight:600, color:"#4A4A60", fontFamily:fontSans}}>
            Cerrar
          </button>
        </div>
      </div>
    );
}

function HistorialFlotilla({registros, vehiculos, filtro, setFiltro, gold, fontSans, fontSerif, isMobile, viajeSenalado, movimientoSenalado}: {
  registros: RegistroFlotilla[]; vehiculos?: Vehiculo[]; filtro: string; setFiltro: (v: string)=>void;
  gold: string; fontSans: string; fontSerif: string; isMobile: boolean;
  // Viaje al que se llegó desde otra pantalla, POR SU ID. Se SEÑALA, no se
  // filtra: un filtro que el usuario no puso y no ve fue exactamente el defecto
  // del aviso del checador. Si el id ya no corresponde a ningún viaje, no se
  // señala nada y la lista se ve como siempre.
  viajeSenalado?: string|null;
  // Un MOVIMIENTO concreto, por su id: la fila del feed es un movimiento, no un
  // viaje. Se abre su detalle, que es lo que esa fila prometía.
  movimientoSenalado?: string|null;
}) {
  // Para acercar el viaje señalado a la vista. Si no está en la lista —porque ya
  // no existe, o quedó fuera de los 60 más recientes— no pasa nada: el ref queda
  // sin nodo y el efecto no hace nada.
  // Por la pieza común: el mismo scroll de siempre y, ahora, el apagado.
  const _resViaje = useResaltado(viajeSenalado, registros);
  // Índice de vehículos del patrón para cruzar el registro con su unidad (dato
  // derivado, nunca se escribe de vuelta).
  //
  // DOS VÍAS, EN ESTE ORDEN, y el orden importa:
  //   1) `vehiculoId` — el vínculo duradero. Sobrevive a que la placa se corrija
  //      o a que la unidad se dé de baja.
  //   2) `placa` — el RESCATE de lo ya registrado. Ningún movimiento anterior a
  //      este cambio trae vehiculoId, así que TODA la bitácora histórica salía
  //      como "no verificable" y el cruce contra vigencias —que es el valor
  //      jurídico del módulo— no ocurría nunca.
  // Nunca al revés: si la placa de una unidad cambia, resolver por texto ataría
  // el movimiento a la unidad equivocada.
  const vehPorId: Record<string, any> = {};
  const vehPorPlaca: Record<string, any> = {};
  (vehiculos||[]).forEach((v:any)=>{
    if (v?.id) vehPorId[v.id] = v;
    const pl = String(v?.placa||"").toUpperCase().replace(/[^A-Z0-9]/g,"");
    // GUARDIÁN DE AMBIGÜEDAD: si dos o más unidades comparten placa normalizada,
    // la placa deja de identificar a una sola y se marca como ambigua (null). No
    // se escoge la primera: atribuir un movimiento a la unidad equivocada es peor
    // que no atribuirlo, y en un documento probatorio esa diferencia importa.
    if (pl) vehPorPlaca[pl] = (pl in vehPorPlaca) ? null : v;
  });
  // Registro abierto en el detalle. La bitácora mostraba placa, persona y hora, y
  // el trabajador captura además kilometraje, destino, observaciones y ubicación:
  // nada de eso se veía, aunque es justo lo que da valor probatorio al movimiento.
  const [detalleReg, setDetalleReg] = useState<any|null>(null);
  const _movSenaladoUsado = useRef(false);
  // POR VIAJE es la vista por defecto también aquí. Con varios choferes, la
  // lista cronológica parte un viaje de tres días entre decenas de renglones
  // ajenos. "Por movimiento" queda como vista de AUDITORÍA, para revisar
  // captura por captura, no como una lectura equivalente.
  const [vistaHist, setVistaHist] = useState<"viaje"|"movimiento">("viaje");
  const [fUnidad, setFUnidad] = useState("");
  const [fPersona, setFPersona] = useState("");
  const [fDesde, setFDesde] = useState("");
  const [fHasta, setFHasta] = useState("");
  // Los viajes NO se arman aquí: los arma `armarViajesFlotilla`, la misma
  // función que usa la app del patrón. Dos formas de agrupar la misma colección
  // producirían dos verdades sobre un registro que se presenta como prueba.
  const viajesTodos = armarViajesFlotilla(registros as any[], (vehiculos||[]) as any[]);
  const viajesVista = filtrarViajesFlotilla(viajesTodos, {
    texto: filtro, unidad: fUnidad, persona: fPersona, desde: fDesde, hasta: fHasta,
  });
  const opcHist = opcionesDeViajes(viajesTodos);
  const hayFiltroHist = !!(filtro || fUnidad || fPersona || fDesde || fHasta);
  // El buscador de texto también aplica a la vista de auditoría, y ahí busca lo
  // mismo: placa, conductor y destino.
  const movsVista: RegistroFlotilla[] = filtro
    ? registros.filter((r)=>{
        const q = filtro.toLowerCase();
        return [r.placa, r.conductor, (r as any).conductorNombre, r.destino].filter(Boolean)
          .join(" ").toLowerCase().indexOf(q) >= 0;
      })
    : registros;
  const vehiculoDelRegistro = (r:any) => {
    // 1) El id es inequívoco: si está y resuelve, gana. La ambigüedad no aplica.
    if (r?.vehiculoId && vehPorId[r.vehiculoId]) return vehPorId[r.vehiculoId];
    // 2) Rescate por placa, SOLO si no es ambigua. En el índice, `null` significa
    //    "más de una unidad con esta placa"; tanto null como la ausencia salen
    //    como no verificable.
    const pl = String(r?.placa||"").toUpperCase().replace(/[^A-Z0-9]/g,"");
    if (!pl) return undefined;
    return vehPorPlaca[pl] || undefined;
  };

  // SE LLEGÓ A UN MOVIMIENTO CONCRETO desde el feed: se abre su detalle, que es
  // lo que la fila prometía. Se busca POR ID en los registros que este módulo ya
  // leyó; si no está —lo borraron entre que se pintó la fila y se pulsó— no se
  // abre nada y la pantalla se ve como siempre. Una sola vez: si el usuario
  // cierra el detalle, no se le vuelve a abrir en la cara.
  //
  // EL DETALLE ESPERA UN SOBRE `{r, fecha, veh}`, NO EL REGISTRO PELADO. El
  // render lee `detalleReg.r`, y aquí se le pasaba el registro tal cual: `.r`
  // llegaba `undefined` y `r.tipo` reventaba la pantalla entera. Los otros tres
  // sitios que abren este detalle arman el mismo sobre; ahora éste también.
  // "En la calle" no lo destapó porque un viaje solo se señala: no abre esto.
  //
  // Va DESPUÉS de `vehiculoDelRegistro` a propósito: el sobre necesita la unidad
  // resuelta, y leerlo aquí es leerlo donde está definido.
  useEffect(() => {
    if (!movimientoSenalado || _movSenaladoUsado.current) return;
    const r = (registros||[]).find((x:any)=> x.id === movimientoSenalado);
    if (!r) return;                       // aún no cargan, o ya no existe
    _movSenaladoUsado.current = true;
    const ts:any = (r as any).timestamp;
    const fecha = ts?.toDate ? ts.toDate() : (ts ? new Date(ts) : null);
    setDetalleReg({r, fecha, veh: vehiculoDelRegistro(r)});
  }, [movimientoSenalado, registros]);

  return (
    <div>
      {/* SELECTOR DE VISTA. "Por viaje" es la principal; "Por movimiento" queda
          como auditoría, para revisar captura por captura. Son dos lecturas del
          mismo dato, no dos agrupaciones alternativas: no existe una tercera. */}
      <div style={{display:"flex", gap:8, marginBottom:12}}>
        {([["viaje","Por viaje"],["movimiento","Por movimiento"]] as const).map(([v,l])=>{
          const on = vistaHist===v;
          return <button key={v} type="button" onClick={()=>setVistaHist(v)}
            style={{padding:"9px 16px", borderRadius:9, cursor:"pointer", fontSize:13, fontWeight:700, fontFamily:fontSans,
              border:`1px solid ${on?gold:T_LIGHT.borderCard}`, background:on?gold:T_LIGHT.cardLight, color:on?"#0B1829":T_LIGHT.textInkSoft}}>{l}</button>;
        })}
      </div>

      {/* FILTROS A NIVEL VIAJE. Filtrar por conductor devuelve sus viajes
          COMPLETOS, no los renglones que coincidan: el viaje es la unidad de
          lectura, y partirlo al filtrar devolvería la lista cronológica. */}
      <div style={{display:"flex", gap:10, marginBottom:16, flexWrap:"wrap" as const, alignItems:"center"}}>
        <input {...CAMPO_DE_PARAMETRO} value={filtro} onChange={(e)=>setFiltro(e.target.value)} placeholder="Buscar placa, conductor o destino..."
          style={{flex:1, minWidth:200, background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, color:T_LIGHT.textInk, borderRadius:10, padding:"10px 14px", fontSize:13, outline:"none", fontFamily:fontSans}} />
        {vistaHist==="viaje" && (<>
          <select {...CAMPO_DE_PARAMETRO} value={fUnidad} onChange={e=>setFUnidad(e.target.value)}
            style={{background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, color:T_LIGHT.textInk, borderRadius:10, padding:"10px 12px", fontSize:13, outline:"none", fontFamily:fontSans, minWidth:150}}>
            <option value="">Todas las unidades</option>
            {opcHist.unidades.map((o:any)=>(<option key={o.clave} value={o.clave}>{o.etiqueta}</option>))}
          </select>
          <select {...CAMPO_DE_PARAMETRO} value={fPersona} onChange={e=>setFPersona(e.target.value)}
            style={{background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, color:T_LIGHT.textInk, borderRadius:10, padding:"10px 12px", fontSize:13, outline:"none", fontFamily:fontSans, minWidth:150}}>
            <option value="">Todos los conductores</option>
            {opcHist.personas.map((o:any)=>(<option key={o.clave} value={o.clave}>{o.etiqueta}</option>))}
          </select>
          <input {...CAMPO_DE_PARAMETRO} type="date" value={fDesde} onChange={e=>setFDesde(e.target.value)} title="Desde"
            style={{background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, color:T_LIGHT.textInk, borderRadius:10, padding:"9px 12px", fontSize:13, outline:"none", fontFamily:fontSans}} />
          <input {...CAMPO_DE_PARAMETRO} type="date" value={fHasta} onChange={e=>setFHasta(e.target.value)} title="Hasta"
            style={{background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, color:T_LIGHT.textInk, borderRadius:10, padding:"9px 12px", fontSize:13, outline:"none", fontFamily:fontSans}} />
          {/* ATAJOS. Rellenan los MISMOS campos Desde/Hasta que están arriba —el
              usuario ve aparecer las fechas y puede ajustarlas—. No filtran por su
              cuenta: un atajo con su propio criterio y unos campos con el suyo
              serían dos formas distintas de acotar el mismo dato. */}
          {([["semana","Esta semana"],["mes","Este mes"],["mes_pasado","Mes pasado"]] as const).map(([k,l2])=>(
            <button key={k} type="button" onClick={()=>{ const r = rangoDeAtajo(k); setFDesde(r.desde); setFHasta(r.hasta); }}
              style={{background:T_LIGHT.canvasSoft, border:`1px solid ${T_LIGHT.borderCard}`, color:T_LIGHT.textInkSoft, borderRadius:999,
                padding:"7px 13px", cursor:"pointer", fontSize:12, fontWeight:700, fontFamily:fontSans}}>{l2}</button>
          ))}
          {hayFiltroHist && (
            <button onClick={()=>{ setFiltro(""); setFUnidad(""); setFPersona(""); setFDesde(""); setFHasta(""); }}
              style={{background:"none", border:"none", color:"#2563EB", cursor:"pointer", fontSize:12.5, fontWeight:700, fontFamily:fontSans}}>
              Quitar filtros
            </button>
          )}
        </>)}
      </div>

      {vistaHist === "viaje" ? (
        viajesVista.length === 0 ? (
          <div style={{textAlign:"center" as const, padding:"40px 20px", color:T_LIGHT.textInkSoft, fontSize:13, background:T_LIGHT.cardLight, borderRadius:12, border:`1px solid ${T_LIGHT.borderCard}`}}>
            {hayFiltroHist ? "Ningún viaje coincide con los filtros." : "Aún no hay viajes registrados."}
          </div>
        ) : (
          // Lista PLANA en el orden que decide el armado: los abiertos arriba
          // —unidades en la calle ahora— y después el resto por fecha de salida
          // descendente.
          <div style={{display:"grid", gridTemplateColumns:"1fr", gap:10}}>
            {viajesVista.slice(0, 60).map((v:any)=>{
              const meta = estadoViajeMeta(v.estado);
              const ref = v.salida || v.momentos[0];
              // El veredicto es UNO por viaje, al momento de la salida: la unidad
              // sale con los documentos que trae, no se revalida en cada parada.
              const est = estadoDocumentalRegistro(ref.m, v.veh, ref.d);
              const km = kmDeViaje(v);
              const dur = (v.salida && v.regreso) ? duracionViajeTexto(v.regreso.ms - v.salida.ms) : null;
              const nFotos = fotosDeViaje(v);
              const unidad = [v.placa, v.veh ? [v.veh.marca, v.veh.modelo].filter(Boolean).join(" ") : ""].filter(Boolean).join(" · ") || "Unidad sin placa";
              const dato = (txt:string) => (
                <span style={{fontSize:11, fontWeight:700, color:T_LIGHT.textInkSoft, background:T_LIGHT.canvasSoft,
                  border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:999, padding:"3px 10px"}}>{txt}</span>
              );
              // Se llegó a ESTE viaje desde otra pantalla: se señala en su sitio,
              // dentro de la lista completa. No se oculta lo demás.
              const senalado = !!viajeSenalado && v.id === viajeSenalado;
              return (
                <div key={v.id} ref={senalado ? _resViaje.ref : undefined}
                  style={{background:T_LIGHT.cardLight,
                  border:`1px solid ${T_LIGHT.borderCard}`,
                  borderLeft:`3px solid ${meta.color}`, borderRadius:12, padding:"14px 16px",
                  ...estiloResaltado(senalado && _resViaje.vivo)}}>
                  {senalado && _resViaje.vivo && (
                    <div style={{fontSize:10.5, fontWeight:800, letterSpacing:"0.6px", textTransform:"uppercase" as const,
                      color:"#8a6d1a", marginBottom:8}}>Vienes de Inicio · este viaje</div>
                  )}
                  <div style={{display:"flex", alignItems:"flex-start", gap:12, marginBottom:10, flexWrap:"wrap" as const}}>
                    <div style={{flex:1, minWidth:180}}>
                      <div style={{fontSize:14, fontWeight:700, color:T_LIGHT.textInk, fontFamily:fontSerif}}>{unidad}</div>
                      <div style={{fontSize:12, color:T_LIGHT.textInkSoft, marginTop:2}}>
                        {v.conductor}{v.d ? ` · ${v.d.toLocaleDateString("es-MX",{weekday:"short", day:"numeric", month:"short"})}` : ""}
                      </div>
                    </div>
                    {/* Estado del viaje con LAS MISMAS PALABRAS que en la app. */}
                    <span style={{fontSize:10, fontWeight:800, letterSpacing:"0.5px", padding:"3px 10px", borderRadius:999, flexShrink:0,
                      border:`1px solid ${meta.color}`, color:meta.color, background:`${meta.color}14`}}>{meta.texto}</span>
                  </div>

                  {/* LA SECUENCIA. Cada momento abre el mismo detalle de siempre:
                      aquí cambia la lectura, no la ficha. */}
                  <div style={{display:"flex", flexDirection:"column" as const}}>
                    {momentosDeViaje(v).map((fl:any, i:number)=>(
                      <button key={i} type="button"
                        onClick={()=>setDetalleReg({r: fl.mv.m, fecha: fl.mv.d, veh: v.veh})}
                        style={{display:"flex", alignItems:"stretch", gap:10, width:"100%", textAlign:"left" as const, fontFamily:fontSans,
                          background:"transparent", border:"none", padding:0, cursor:"pointer"}}>
                        <div style={{width:11, display:"flex", flexDirection:"column" as const, alignItems:"center", flexShrink:0}}>
                          <span style={{width:9, height:9, borderRadius:999, background:fl.color, marginTop:4, flexShrink:0}}/>
                          {!fl.ultimo && <span style={{flex:1, width:1.5, background:T_LIGHT.borderCard, marginTop:2}}/>}
                        </div>
                        <div style={{flex:1, minWidth:0, paddingBottom: fl.ultimo ? 0 : 9}}>
                          <div style={{display:"flex", alignItems:"baseline", gap:8, flexWrap:"wrap" as const}}>
                            <span style={{fontSize:12.5, fontWeight:700, color:fl.color}}>{fl.etiqueta}</span>
                            <span style={{fontSize:11.5, color:T_LIGHT.textInkMut}}>
                              {fl.mv.d ? fl.mv.d.toLocaleTimeString("es-MX",{hour:"2-digit",minute:"2-digit"}) : "—"}
                            </span>
                          </div>
                          {fl.mv.m.destino && <div style={{fontSize:12, color:T_LIGHT.textInkSoft, marginTop:1}}>{fl.mv.m.destino}</div>}
                        </div>
                      </button>
                    ))}
                  </div>

                  {/* Lo que se puede afirmar del recorrido. Lo que no, no aparece. */}
                  <div style={{display:"flex", flexWrap:"wrap" as const, gap:6, marginTop:10}}>
                    {dato(v.paradas.length===0 ? "Sin paradas" : v.paradas.length===1 ? "1 parada" : `${v.paradas.length} paradas`)}
                    {dur && dato(dur)}
                    {km !== null && dato(`${km.toLocaleString("es-MX")} km`)}
                    {nFotos > 0 && dato(nFotos===1 ? "1 foto" : `${nFotos} fotos`)}
                  </div>

                  {v.estado === "abierto" && (
                    <div style={{fontSize:11.5, fontWeight:700, color:"#A85A04", marginTop:8}}>
                      {v.salida ? `Salió ${desdeHaceTexto(v.salida.ms)}` : `Último movimiento ${desdeHaceTexto(v.msFin)}`} · sin regreso
                    </div>
                  )}
                  {/* SIN REGRESO REGISTRADO no es lo mismo que abierto: esa unidad
                      ya no está afuera. No se inventó una hora de regreso, y por
                      eso el viaje tampoco se cuenta como cerrado. */}
                  {v.estado === "sin_regreso" && (
                    <div style={{fontSize:11.5, color:"#B3261E", marginTop:8, lineHeight:1.5}}>
                      El regreso nunca se registró.{v.cierre?.d ? ` Se dio por terminado el ${v.cierre.d.toLocaleDateString("es-MX",{day:"numeric",month:"short"})}` : ""}
                      {v.cierre?.motivo === "salida_en_otra_unidad" ? " porque el conductor salió en otra unidad." : "."}
                    </div>
                  )}
                  {v.estado === "suelto" && (
                    <div style={{fontSize:11, color:T_LIGHT.textInkMut, marginTop:8, lineHeight:1.45}}>
                      Movimiento suelto: no se pudo atribuir a ningún viaje con certeza, así que se muestra por su cuenta en vez de colgarlo del viaje de alguien.
                    </div>
                  )}

                  {est.tipo === "vencido" ? (
                    <div style={{marginTop:8, fontSize:10.5, fontWeight:700, color:"#B3261E", background:"rgba(226,75,74,0.10)", border:"1px solid rgba(226,75,74,0.28)", borderRadius:7, padding:"5px 9px", display:"inline-block"}}>
                      ⚠ Salió con documento vencido: {est.documentos.join(", ")}
                    </div>
                  ) : est.tipo === "vigente" ? (
                    <div style={{marginTop:8, fontSize:10.5, color:"#117A56"}}>Documentación vigente a la fecha de la salida</div>
                  ) : est.tipo === "sin_datos" ? (
                    <div style={{marginTop:8, fontSize:10.5, color:T_LIGHT.textInkMut}}>Sin registro documental del vehículo</div>
                  ) : (
                    <div style={{marginTop:8, fontSize:10.5, color:T_LIGHT.textInkMut}}>Documentación no verificable (registro sin vehículo vinculado)</div>
                  )}
                </div>
              );
            })}
            {viajesVista.length > 60 && (
              <div style={{textAlign:"center" as const, padding:"12px", color:T_LIGHT.textInkMut, fontSize:11}}>
                Mostrando 60 viajes más recientes de {viajesVista.length} total.
              </div>
            )}
          </div>
        )
      ) : (
        <>
        {movsVista.length === 0 ? (
          <div style={{textAlign:"center" as const, padding:"40px 20px", color:T_LIGHT.textInkSoft, fontSize:13, background:T_LIGHT.cardLight, borderRadius:12, border:`1px dashed ${T_LIGHT.border}`}}>
            {filtro ? "No se encontraron movimientos con ese filtro." : "Aún no hay movimientos registrados."}
          </div>
        ) : (
          <div style={{display:"grid", gridTemplateColumns:"1fr", gap:8}}>
            {movsVista.slice(0, 50).map(r => {
              const ts: any = r.timestamp;
              const fecha = ts?.toDate ? ts.toDate() : (ts ? new Date(ts) : null);
              const fechaStr = fecha ? fecha.toLocaleString("es-MX", {dateStyle:"short", timeStyle:"short"}) : "";
              // Toda la tarjeta abre el detalle: el trabajador captura kilometraje,
              // destino, observaciones y ubicación, y hasta ahora nada de eso se veía.
              const abrirDetalle = () => setDetalleReg({r, fecha, veh: vehiculoDelRegistro(r)});
              return (
                <div key={r.id}
                  onClick={abrirDetalle} role="button" tabIndex={0} title="Ver el detalle del movimiento"
                  onKeyDown={(ev:any)=>{ if(ev.key==="Enter"||ev.key===" "){ ev.preventDefault(); abrirDetalle(); } }}
                  style={{
                  cursor:"pointer", WebkitTapHighlightColor:"transparent",
                  background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`,
                  borderRadius:10, padding:"12px 14px", display:"flex", justifyContent:"space-between", alignItems:"center", gap:12, flexWrap:"wrap" as const, transition:"all 0.2s ease", boxShadow:T_LIGHT.shadow
                }}>
                  <div style={{display:"flex", alignItems:"center", gap:12, flex:1, minWidth:0}}>
                    <span style={{
                      background: r.tipo === "salida" ? "rgba(93,160,232,0.12)" : r.tipo === "llegada" ? "rgba(217,119,6,0.12)" : "rgba(29,158,117,0.12)",
                      color: r.tipo === "salida" ? "#3578B8" : r.tipo === "llegada" ? "#A85A04" : "#117A56",
                      border: `1px solid ${r.tipo === "salida" ? "rgba(93,160,232,0.30)" : r.tipo === "llegada" ? "rgba(217,119,6,0.30)" : "rgba(29,158,117,0.30)"}`,
                      fontSize:11, padding:"3px 9px", borderRadius:6, fontWeight:700, flexShrink:0
                    }}>
                      {r.tipo === "salida" ? "→ Salida" : r.tipo === "llegada" ? "◎ Llegada" : "← Regreso"}
                    </span>
                    <div style={{minWidth:0, flex:1}}>
                      <div style={{fontSize:13, color:T_LIGHT.textInk, fontFamily:fontSerif, fontWeight:600}}>{r.placa}</div>
                      <div style={{fontSize:11, color:T_LIGHT.textInkSoft, marginTop:2}}>{r.conductor || "Sin conductor"} · {fechaStr}</div>
                      {/* IDENTIDAD del capturista: hace la bitácora atribuible. Los
                          registros anteriores al cambio no la traen (eran anónimos). */}
                      {(()=>{ const q:any = r as any;
                        const quien = q.registradoPorNombre || q.registradoPorEmail;
                        if (!quien) return <div style={{fontSize:10.5, color:T_LIGHT.textInkMut, marginTop:2}}>Registrado por: sin identificar (registro anterior)</div>;
                        return (
                          <div style={{fontSize:10.5, color:T_LIGHT.textInkMut, marginTop:2}}>
                            Registrado por: <strong style={{color:T_LIGHT.textInkSoft}}>{quien}</strong>
                            {q.registradoPorRol === "trabajador" ? " (trabajador)" : q.registradoPorRol === "patron" ? " (patrón)" : ""}
                            {q.registradoPorEmail && q.registradoPorNombre && q.registradoPorEmail !== q.registradoPorNombre ? ` · ${q.registradoPorEmail}` : ""}
                          </div>
                        );
                      })()}
                      {/* Estado documental DERIVADO: se evalúa a la FECHA DEL REGISTRO. */}
                      {(()=>{ const est = estadoDocumentalRegistro(r as any, vehiculoDelRegistro(r), fecha);
                        if (est.tipo === "vencido") return (
                          <div style={{marginTop:4, fontSize:10.5, fontWeight:700, color:"#B3261E", background:"rgba(226,75,74,0.10)", border:"1px solid rgba(226,75,74,0.30)", borderRadius:6, padding:"2px 7px", display:"inline-block"}}>
                            ⚠ Circuló con documento vencido: {est.documentos.join(", ")}
                          </div>
                        );
                        if (est.tipo === "sin_datos") return (
                          <div style={{marginTop:4, fontSize:10.5, color:T_LIGHT.textInkMut}}>Sin registro documental del vehículo</div>
                        );
                        if (est.tipo === "no_verificable") return (
                          <div style={{marginTop:4, fontSize:10.5, color:T_LIGHT.textInkMut}}>Documentación no verificable (registro sin vehículo vinculado)</div>
                        );
                        return (
                          <div style={{marginTop:4, fontSize:10.5, color:"#117A56"}}>Documentación vigente a la fecha del registro</div>
                        );
                      })()}
                    </div>
                  </div>
                  {(r as any).km && <span style={{fontSize:11, color:T_LIGHT.textInkMut, flexShrink:0}}>{(r as any).km.toLocaleString()} km</span>}
                </div>
              );
            })}
            {movsVista.length > 50 && (
              <div style={{textAlign:"center" as const, padding:"12px", color:T_LIGHT.textInkMut, fontSize:11}}>
                Mostrando 50 más recientes de {movsVista.length} total.
              </div>
            )}
          </div>
        )}
        </>
      )}

      {/* Detalle del movimiento: componente compartido con la app (ver
          DetalleMovimientoFlotilla). */}
      {detalleReg && (
        <DetalleMovimientoFlotilla
          registro={detalleReg.r} vehiculo={detalleReg.veh} fecha={detalleReg.fecha}
          onClose={()=>setDetalleReg(null)}
          isMobile={isMobile} fontSans={fontSans} fontSerif={fontSerif}/>
      )}
    </div>
  );
}

// ─── FLOTILLA: MÓDULO PRINCIPAL ────────────────────────────────────────────
function ExpedienteVehiculo({vehiculo, registros, onBack, onActualizado, onDarDeBaja, onReactivar, tabInicial, fontSans, fontSerif, gold}: {
  vehiculo: Vehiculo; registros: RegistroFlotilla[]; onBack: ()=>void; onActualizado: ()=>void; onDarDeBaja: ()=>void; onReactivar: ()=>void;
  // EL RENGLÓN LLEVA AL LUGAR DONDE SE RESUELVE. "Verificación · PQR-654-E" abría
  // el expediente en "Datos" y había que buscar dónde se arregla lo que la
  // plataforma acababa de señalar. Ahora llega a Documentos, que es donde se
  // renueva la vigencia. Mismo patrón que `trabajadorInicialTab` en la ficha del
  // empleado: la pestaña es parte del foco, no una lista aparte.
  tabInicial?: "datos"|"documentos"|"historial"|"mantenimientos"|null;
  fontSans: string; fontSerif: string; gold: string;
}) {
  const isMobile = window.innerWidth < 768;
  const [tabExp, setTabExp] = useState<"datos"|"documentos"|"historial"|"mantenimientos">(tabInicial || "datos");
  const [editando, setEditando] = useState(false);
  const [guardando, setGuardando] = useState(false);
  const [viajeMapa, setViajeMapa] = useState<any|null>(null);
  const [mantenimientos, setMantenimientos] = useState<any[]>([]);
  const [showFormMant, setShowFormMant] = useState(false);
  const [mantTipo, setMantTipo] = useState("Servicio / afinación");
  const [mantFecha, setMantFecha] = useState("");
  const [mantKm, setMantKm] = useState("");
  const [mantTaller, setMantTaller] = useState("");
  const [mantCosto, setMantCosto] = useState("");
  const [mantObs, setMantObs] = useState("");
  const [guardandoMant, setGuardandoMant] = useState(false);

  const [marca, setMarca] = useState(vehiculo.marca || "");
  const [modelo, setModelo] = useState(vehiculo.modelo || "");
  const [anio, setAnio] = useState(vehiculo.anio ? String(vehiculo.anio) : "");
  const [color, setColor] = useState(vehiculo.color || "");
  const [numeroEconomico, setNumeroEconomico] = useState(vehiculo.numeroEconomico || "");
  const [numeroSerie, setNumeroSerie] = useState(vehiculo.numeroSerie || "");
  const [kilometraje, setKilometraje] = useState(vehiculo.kilometraje ? String(vehiculo.kilometraje) : "");
  const [conductorAsignadoNombre, setConductorAsignadoNombre] = useState(vehiculo.conductorAsignadoNombre || "");
  // EL SEGURO, PARA EL MOMENTO DEL ACCIDENTE. El expediente guardaba las fechas y
  // el archivo de la póliza, pero no a quién llamar: el trabajador, de pie junto a
  // la unidad, no tenía el teléfono. Con estos tres datos la pantalla del accidente
  // le ofrece "Llamar a la aseguradora". Los captura el patrón; el trabajador solo
  // los lee, con la misma regla con la que ya lee la lista de unidades.
  const [aseguradora, setAseguradora] = useState(vehiculo.aseguradora || "");
  const [telefonoSiniestros, setTelefonoSiniestros] = useState(vehiculo.telefonoSiniestros || "");
  const [numeroPoliza, setNumeroPoliza] = useState(vehiculo.numeroPoliza || "");
  // ── UNA RANURA ABIERTA A LA VEZ ─────────────────────────────────────────
  // "Actualizar" abre el formulario de ESE documento con las dos fechas y el
  // archivo juntos. No hay una pantalla de "editar fechas" aparte: la fecha y el
  // papel son el mismo hecho y se capturan de una sola vez.
  const [docAbierto, setDocAbierto] = useState<string>("");
  const [fDesde, setFDesde] = useState("");
  const [fHasta, setFHasta] = useState("");
  const [fArchivo, setFArchivo] = useState<File|null>(null);
  const [guardandoDoc, setGuardandoDoc] = useState(false);
  const [msgDoc, setMsgDoc] = useState<{tipo:"ok"|"err"|"parcial"; texto:string}|null>(null);
  const abrirDoc = (d:any) => {
    setDocAbierto(d.key);
    setFDesde(String((vehiculo as any)[d.keyDesde] || ""));
    setFHasta(String((vehiculo as any)[d.key] || ""));
    setFArchivo(null); setMsgDoc(null);
  };

  // GUARDA UNA RANURA. El archivo sube PRIMERO, pero si falla las fechas se
  // guardan igual y se dice exactamente qué quedó y qué no: perder de paso la
  // vigencia que la persona acaba de teclear sería castigarla por un fallo de red.
  // Nada de try/catch con console.error: si algo no se guardó, se ve en pantalla.
  const guardarDocumento = async (d:any) => {
    if (!vehiculo.id) return;
    const problema = validarVigencia(fDesde, fHasta);
    if (problema) { setMsgDoc({tipo:"err", texto:problema}); return; }
    setGuardandoDoc(true); setMsgDoc(null);
    const dueno = String((vehiculo as any).userId || "");
    let archivoNuevo: ArchivoDoc | null = null;
    let falloArchivo = "", falloDoc = "";
    if (fArchivo) {
      // SE COMPRIME COMO EN TODAS PARTES. Una poliza fotografiada con el telefono
      // pesaba 5 MB y se subia tal cual; ahora pasa por la MISMA pieza que el resto
      // -`prepararParaSubir`-, que deja intacto un PDF y solo toca las imagenes.
      // Y el peso se comprueba antes de empezar: mejor un mensaje que dice cuanto
      // pesa que tres minutos de subida que acaban en nada.
      const malo = motivoRechazo(fArchivo);
      if (malo && !fArchivo.type.startsWith("image/") && !esVideo(fArchivo)) {
        // Un PDF o un Word son validos aqui aunque `motivoRechazo` no los conozca:
        // esa funcion habla de fotos y videos. Solo se comprueba su peso.
        if (fArchivo.size >= MAX_MB_FOTO * 1024 * 1024) falloArchivo = `el archivo pesa ${_mb(fArchivo.size)} MB y el maximo son ${MAX_MB_FOTO} MB`;
      } else if (malo) {
        falloArchivo = malo;
      }
      if (!falloArchivo) {
        try {
          const listo = await prepararParaSubir(fArchivo, LADO_DOCUMENTO);
          const url = await subirArchivo(dueno, "vehiculos", listo);
          archivoNuevo = {url, nombre: listo.name, subidoEn: Timestamp.now()};
        } catch(e:any){ falloArchivo = e?.code || e?.message || "error"; }
      }
    }
    // La vigencia se escribe AUNQUE el archivo haya fallado: perder de paso la
    // fecha que la persona acaba de teclear sería castigarla por un fallo de red.
    try {
      await updateDoc(doc(db, "vehiculos", vehiculo.id), {
        [d.key]: fHasta,
        [d.keyDesde]: fDesde || null,
        ...(archivoNuevo ? {[d.keyArchivo]: archivoNuevo} : {}),
      });
      onActualizado();
      avisarCambioDeAtencion();   // cambió la vigencia de un documento del vehículo
    } catch(e:any){ falloDoc = e?.code || e?.message || "error"; }
    const m = mensajeGuardadoDoc({intentoArchivo: !!fArchivo, falloArchivo, falloDoc});
    setMsgDoc({tipo:m.tipo, texto:m.texto});
    if (m.cerrar) setDocAbierto("");
    setGuardandoDoc(false);
  };

  const compliance = calcularComplianceVehiculo(vehiculo);
  const resumenDoc = resumenDocumentalVehiculo(vehiculo);   // el mismo que la lista y el móvil
  const nivel = nivelVehiculo(vehiculo);
  const colorNivel = colorVehiculo(nivel);
  const esInactivo = (vehiculo.status || "activo") === "inactivo";

  const viajes = registros
    .filter(r => (r.placa||"").toUpperCase() === vehiculo.placa.toUpperCase())
    .sort((a:any, b:any) => {
      const ta = a.timestamp?.toDate ? a.timestamp.toDate().getTime() : 0;
      const tb = b.timestamp?.toDate ? b.timestamp.toDate().getTime() : 0;
      return tb - ta;
    });

  const guardarCambios = async () => {
    if (!vehiculo.id) return;
    setGuardando(true);
    try {
      await updateDoc(doc(db, "vehiculos", vehiculo.id), {
        marca: marca || null,
        modelo: modelo || null,
        anio: anio ? parseInt(anio) : null,
        color: color || null,
        numeroEconomico: numeroEconomico || null,
        numeroSerie: numeroSerie || null,
        kilometraje: kilometraje ? parseInt(kilometraje) : null,
        conductorAsignadoNombre: conductorAsignadoNombre || null,
        aseguradora: aseguradora.trim() || null,
        telefonoSiniestros: telefonoSiniestros.trim() || null,
        numeroPoliza: numeroPoliza.trim() || null,
        // Las fechas de los documentos YA NO se escriben aquí: cada una se guarda
        // desde su ranura, con su archivo. Si siguieran, editar la marca del coche
        // reescribiría de vuelta el estado que tuvieran al abrir la pantalla y
        // desharía en silencio una vigencia recién actualizada.
      });
      setEditando(false);
      onActualizado();
      avisarCambioDeAtencion();   // pudo cambiar alguna vigencia de la unidad
    } catch(e) { console.error(e); alert("Error al guardar los cambios"); }
    finally { setGuardando(false); }
  };

  const cargarMantenimientos = async () => {
    if (!vehiculo.id) return;
    try {
      // Multi-tenant: se filtra también por el dueño (userId heredado del vehículo),
      // que es el campo con el que la regla de Firestore acota la colección.
      const snap = await getDocs(query(collection(db, "mantenimientos"), where("userId","==",(vehiculo as any).userId||""), where("vehiculoId","==",vehiculo.id)));
      const lista = snap.docs.map(d => ({id:d.id, ...d.data()} as any)).sort((a,b) => (b.fecha||"").localeCompare(a.fecha||""));
      setMantenimientos(lista);
    } catch(e) { console.error(e); }
  };

  useEffect(() => { cargarMantenimientos(); /* eslint-disable-next-line */ }, []);

  const guardarMantenimiento = async () => {
    if (!vehiculo.id || !mantFecha) return;
    setGuardandoMant(true);
    try {
      await addDoc(collection(db, "mantenimientos"), {
        userId: (vehiculo as any).userId || "",   // dueño (patrón): acota la colección por cuenta
        vehiculoId: vehiculo.id,
        placa: vehiculo.placa,
        tipo: mantTipo,
        fecha: mantFecha,
        kilometraje: mantKm ? parseInt(mantKm) : null,
        taller: mantTaller || null,
        costo: mantCosto ? parseFloat(mantCosto) : null,
        observaciones: mantObs || null,
        timestamp: Timestamp.now(),
      });
      setShowFormMant(false);
      setMantTipo("Servicio / afinación"); setMantFecha(""); setMantKm(""); setMantTaller(""); setMantCosto(""); setMantObs("");
      await cargarMantenimientos();
    } catch(e) { console.error(e); alert("Error al guardar el mantenimiento"); }
    finally { setGuardandoMant(false); }
  };

  const labelStyle = {fontSize:10, color:"rgba(232,226,213,0.62)", display:"block" as const, marginBottom:5, textTransform:"uppercase" as const, letterSpacing:"0.5px", fontWeight:600 as const};
  const inputStyle = {width:"100%", padding:"10px 12px", border:"1px solid rgba(184,147,42,0.25)", borderRadius:8, fontSize:13, outline:"none", boxSizing:"border-box" as const, fontFamily:fontSans, color:"white", background:"rgba(255,255,255,0.05)"};
  const valorStyle = {fontSize:14, color:"#E8E2D5", fontWeight:500 as const};
  const tabExpStyle = (activa:boolean) => ({background: activa?"rgba(184,147,42,0.1)":"transparent", border:"none", borderBottom: activa?`2px solid ${gold}`:"2px solid transparent", color: activa?gold:"rgba(232,226,213,0.55)", padding:"10px 16px", fontSize:13, fontWeight:activa?600:500, fontFamily:fontSans, cursor:"pointer", transition:"all 0.2s ease", marginBottom:-1, whiteSpace:"nowrap" as const});

  return (
    <div {...ZONA_DE_CAPTURA} style={{minHeight:"100vh", background:"linear-gradient(160deg,#0B1829 0%,#0F2040 50%,#162447 100%)", fontFamily:fontSans}}>
      {/* Header */}
      <div style={{background:"linear-gradient(135deg,#162447,#1E3A5F)", padding:"0 20px", height:58, display:"flex", alignItems:"center", gap:12, borderBottom:"1px solid rgba(184,147,42,0.2)", boxShadow:"0 2px 16px rgba(0,0,0,0.3)"}}>
        <button onClick={onBack} style={{background:"rgba(255,255,255,0.08)", border:"1px solid rgba(255,255,255,0.12)", color:"white", borderRadius:8, padding:"5px 12px", cursor:"pointer", fontSize:12, fontFamily:fontSans}}>← Flotilla</button>
        <span style={{color:"white", fontWeight:600, fontSize:14}}>Expediente del vehículo</span>
      </div>

      <div style={{maxWidth:ANCHO_CONTENIDO, margin:"0 auto", padding:isMobile?"20px 14px 60px":"28px 24px 80px"}}>

        {/* Tarjeta de identidad */}
        <div style={{background:"rgba(255,255,255,0.04)", border:"1px solid rgba(184,147,42,0.2)", borderRadius:16, padding:isMobile?"18px":"24px", marginBottom:20}}>
          <div style={{display:"flex", alignItems:"center", gap:16, flexWrap:"wrap" as const}}>
            <div style={{width:64, height:64, borderRadius:"50%", background:colorNivel.bg, border:`1px solid ${colorNivel.border}`, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0}}>
              <AxisIcon name="suite_flotilla" size={32} color={colorNivel.color} withBackdrop={false} strokeWidth={2.5}/>
            </div>
            <div style={{flex:1, minWidth:0}}>
              <div style={{fontFamily:fontSerif, fontSize:26, fontWeight:600, color:gold, letterSpacing:"0.5px"}}>{vehiculo.placa}</div>
              <div style={{fontSize:13, color:"rgba(232,226,213,0.7)", marginTop:2}}>
                {[vehiculo.marca, vehiculo.modelo, vehiculo.anio].filter(Boolean).join(" ") || "Sin datos del vehículo"}
                {vehiculo.color ? ` · ${vehiculo.color}` : ""}
              </div>
              <div style={{fontSize:12, color:"rgba(232,226,213,0.62)", marginTop:2}}>
                {vehiculo.conductorAsignadoNombre || "Sin conductor asignado"}
                {vehiculo.kilometraje ? ` · ${vehiculo.kilometraje.toLocaleString()} km` : ""}
              </div>
            </div>
            {esInactivo && (
              <span style={{background:"rgba(154,154,170,0.15)", color:"#9A9AAA", border:"1px solid rgba(154,154,170,0.3)", fontSize:11, padding:"5px 12px", borderRadius:8, fontWeight:600, flexShrink:0}}>
                Inactivo
              </span>
            )}
          </div>
          {/* EL HECHO, NO LA NOTA. Aquí había una etiqueta ("Crítico"), una
              fracción ("2/3 docs en regla") y una barra de progreso. Las tres
              obligaban a traducir: ninguna decía QUÉ documento ni desde cuándo, y
              una barra al 66% no se puede enseñar en un operativo. */}
          {!esInactivo && (
            <div style={{marginTop:14, display:"flex", alignItems:"flex-start", gap:9}}>
              <span style={{width:9, height:9, borderRadius:"50%", flexShrink:0, marginTop:5,
                background: resumenDoc.tono==="critico" ? "#E24B4A" : resumenDoc.tono==="pendiente" ? "#EF9F27" : "#1D9E75"}}/>
              <div style={{fontSize:13.5, lineHeight:1.55, fontWeight: resumenDoc.tono==="critico" ? 700 : 500,
                color: resumenDoc.tono==="critico" ? "#F19E9D" : "#E8E2D5"}}>
                {resumenDoc.texto}
              </div>
            </div>
          )}
          <div style={{marginTop:16, display:"flex", gap:8, flexWrap:"wrap" as const}}>
            {!esInactivo ? (
              <button onClick={onDarDeBaja} style={{background:"rgba(226,75,74,0.08)", border:"1px solid rgba(226,75,74,0.25)", color:"#E24B4A", borderRadius:8, padding:"7px 16px", cursor:"pointer", fontSize:12, fontFamily:fontSans, fontWeight:500}}>⊘ Dar de baja</button>
            ) : (
              <button onClick={onReactivar} style={{background:"rgba(29,158,117,0.1)", border:"1px solid rgba(29,158,117,0.3)", color:"#1D9E75", borderRadius:8, padding:"7px 16px", cursor:"pointer", fontSize:12, fontFamily:fontSans, fontWeight:500}}>↻ Reactivar</button>
            )}
            {esInactivo && vehiculo.fechaBaja && (
              <span style={{fontSize:12, color:"rgba(232,226,213,0.62)", padding:"7px 8px"}}>Baja: {vehiculo.fechaBaja}{vehiculo.razonBaja ? ` · ${RAZONES_BAJA_VEHICULO.find(r=>r.value===vehiculo.razonBaja)?.label || vehiculo.razonBaja}` : ""}</span>
            )}
          </div>
        </div>

        {/* Tabs */}
        <div style={{display:"flex", gap:2, borderBottom:"1px solid rgba(184,147,42,0.2)", marginBottom:20, overflowX:"auto" as const}}>
          <button onClick={()=>setTabExp("datos")} style={tabExpStyle(tabExp==="datos")}>Datos</button>
          <button onClick={()=>setTabExp("documentos")} style={tabExpStyle(tabExp==="documentos")}>Documentos</button>
          <button onClick={()=>setTabExp("historial")} style={tabExpStyle(tabExp==="historial")}>Historial de viajes</button>
          <button onClick={()=>setTabExp("mantenimientos")} style={tabExpStyle(tabExp==="mantenimientos")}>Mantenimientos</button>
        </div>

        {/* TAB DATOS */}
        {tabExp === "datos" && (
          <div>
            <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16}}>
              <h3 style={{color:"white", fontFamily:fontSerif, fontSize:17, fontWeight:600, margin:0}}>Datos del vehículo</h3>
              {!editando ? (
                <button onClick={()=>setEditando(true)} style={{background:"rgba(184,147,42,0.12)", border:"1px solid rgba(184,147,42,0.35)", color:gold, borderRadius:8, padding:"7px 16px", cursor:"pointer", fontSize:12, fontFamily:fontSans, fontWeight:500}}>✎ Editar</button>
              ) : (
                <div style={{display:"flex", gap:8}}>
                  <button onClick={()=>setEditando(false)} style={{background:"transparent", border:"1px solid rgba(255,255,255,0.2)", color:"white", borderRadius:8, padding:"7px 16px", cursor:"pointer", fontSize:12, fontFamily:fontSans}}>Cancelar</button>
                  <button onClick={guardarCambios} disabled={guardando} style={{background:gold, border:"none", color:"#0B1829", borderRadius:8, padding:"7px 16px", cursor:"pointer", fontSize:12, fontFamily:fontSans, fontWeight:700}}>{guardando?"Guardando...":"Guardar"}</button>
                </div>
              )}
            </div>
            {editando ? (
              <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr 1fr":"1fr 1fr 1fr", gap:14}}>
                <div><label style={labelStyle}>Marca</label><input value={marca} onChange={e=>setMarca(e.target.value)} style={inputStyle}/></div>
                <div><label style={labelStyle}>Modelo</label><input value={modelo} onChange={e=>setModelo(e.target.value)} style={inputStyle}/></div>
                <div><label style={labelStyle}>Año</label><input type="number" value={anio} onChange={e=>setAnio(e.target.value)} style={inputStyle}/></div>
                <div><label style={labelStyle}>Color</label><input value={color} onChange={e=>setColor(e.target.value)} style={inputStyle}/></div>
                <div><label style={labelStyle}># Económico</label><input value={numeroEconomico} onChange={e=>setNumeroEconomico(e.target.value)} style={inputStyle}/></div>
                <div><label style={labelStyle}>Kilometraje</label><input type="number" value={kilometraje} onChange={e=>setKilometraje(e.target.value)} style={inputStyle}/></div>
                <div style={{gridColumn: isMobile?"span 2":"span 2"}}><label style={labelStyle}># Serie (VIN)</label><input value={numeroSerie} onChange={e=>setNumeroSerie(e.target.value)} style={{...inputStyle, fontFamily:"monospace"}} maxLength={17}/></div>
                <div><label style={labelStyle}>Conductor habitual</label><input value={conductorAsignadoNombre} onChange={e=>setConductorAsignadoNombre(e.target.value)} style={inputStyle}/></div>
                <div><label style={labelStyle}>Aseguradora</label><input value={aseguradora} onChange={e=>setAseguradora(e.target.value)} placeholder="Ej. Qualitas" style={inputStyle}/></div>
                <div><label style={labelStyle}>Teléfono de siniestros</label><input type="tel" value={telefonoSiniestros} onChange={e=>setTelefonoSiniestros(e.target.value)} placeholder="El que viene en la póliza" style={inputStyle}/></div>
                <div><label style={labelStyle}>Número de póliza</label><input value={numeroPoliza} onChange={e=>setNumeroPoliza(e.target.value)} style={inputStyle}/></div>
              </div>
            ) : (
              <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr 1fr":"1fr 1fr 1fr", gap:16, background:"rgba(255,255,255,0.03)", borderRadius:12, padding:"18px 20px", border:"1px solid rgba(184,147,42,0.12)"}}>
                <div><div style={labelStyle}>Marca</div><div style={valorStyle}>{vehiculo.marca || "—"}</div></div>
                <div><div style={labelStyle}>Modelo</div><div style={valorStyle}>{vehiculo.modelo || "—"}</div></div>
                <div><div style={labelStyle}>Año</div><div style={valorStyle}>{vehiculo.anio || "—"}</div></div>
                <div><div style={labelStyle}>Color</div><div style={valorStyle}>{vehiculo.color || "—"}</div></div>
                <div><div style={labelStyle}># Económico</div><div style={valorStyle}>{vehiculo.numeroEconomico || "—"}</div></div>
                <div><div style={labelStyle}>Kilometraje</div><div style={valorStyle}>{vehiculo.kilometraje ? `${vehiculo.kilometraje.toLocaleString()} km` : "—"}</div></div>
                <div style={{gridColumn:"span 2"}}><div style={labelStyle}># Serie (VIN)</div><div style={{...valorStyle, fontFamily:"monospace", fontSize:13}}>{vehiculo.numeroSerie || "—"}</div></div>
                <div><div style={labelStyle}>Conductor habitual</div><div style={valorStyle}>{vehiculo.conductorAsignadoNombre || "—"}</div></div>
                <div><div style={labelStyle}>Aseguradora</div><div style={valorStyle}>{vehiculo.aseguradora || "—"}</div></div>
                <div><div style={labelStyle}>Teléfono de siniestros</div><div style={valorStyle}>{vehiculo.telefonoSiniestros || "—"}</div></div>
                <div><div style={labelStyle}>Número de póliza</div><div style={valorStyle}>{vehiculo.numeroPoliza || "—"}</div></div>
              </div>
            )}
          </div>
        )}

        {/* TAB DOCUMENTOS */}
        {tabExp === "documentos" && (
          <div>
            <h3 style={{color:"white", fontFamily:fontSerif, fontSize:17, fontWeight:600, margin:"0 0 4px"}}>Documentos</h3>
            <p style={{fontSize:12, color:"rgba(232,226,213,0.62)", margin:"0 0 16px", lineHeight:1.55}}>
              Cada documento guarda su vigencia <b>y el archivo</b>. En un operativo lo que sirve es la póliza, no la fecha.
            </p>
            {/* TRES RANURAS. Antes esto era una lista de fechas con un "Editar
                fechas" que abría los tres campos a la vez: se guardaba el número
                que alguien tecleó y el documento no estaba en ninguna parte. */}
            <div style={{display:"flex", flexDirection:"column" as const, gap:10}}>
              {compliance.documentos.map((d:any) => {
                const dc = d.estado === "ok" ? {color:"#1D9E75", bg:"rgba(29,158,117,0.08)", bd:"rgba(29,158,117,0.25)"}
                  : d.estado === "por_vencer" ? {color:"#EF9F27", bg:"rgba(239,159,39,0.08)", bd:"rgba(239,159,39,0.25)"}
                  : d.estado === "vencido" ? {color:"#E24B4A", bg:"rgba(226,75,74,0.08)", bd:"rgba(226,75,74,0.25)"}
                  : {color:"#9A9AAA", bg:"rgba(154,154,170,0.06)", bd:"rgba(154,154,170,0.2)"};
                const archivo = (vehiculo as any)[d.keyArchivo] as ArchivoDoc | undefined;
                const desde = String((vehiculo as any)[d.keyDesde] || "");
                const abierto = docAbierto === d.key;
                return (
                  <div key={d.key} style={{background:dc.bg, border:`1px solid ${dc.bd}`, borderRadius:10, padding:"14px 16px"}}>
                    <div style={{display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:12, flexWrap:"wrap" as const}}>
                      <div style={{flex:1, minWidth:180}}>
                        <div style={{fontSize:13.5, color:"#E8E2D5", fontWeight:600, marginBottom:3}}>{d.label}</div>
                        <div style={{fontSize:12.5, color:dc.color, fontWeight:600, lineHeight:1.5}}>
                          {textoVigencia(desde, d.fecha, d.estado, d.dias)}
                        </div>
                        {/* EL ARCHIVO, O SU AUSENCIA DICHA CON TODAS SUS LETRAS. */}
                        <div style={{marginTop:7, display:"flex", alignItems:"center", gap:10, flexWrap:"wrap" as const}}>
                          {archivo?.url ? (<>
                            <a href={archivo.url} target="_blank" rel="noreferrer"
                              style={{fontSize:12, fontWeight:700, color:gold, textDecoration:"none", borderBottom:`1px solid ${gold}55`}}>
                              Ver archivo
                            </a>
                            <span style={{fontSize:11, color:"rgba(232,226,213,0.5)", maxWidth:220, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" as const}}>
                              {archivo.nombre}
                            </span>
                            <button onClick={()=>abrirDoc(d)}
                              style={{background:"transparent", border:"1px solid rgba(255,255,255,0.22)", color:"#E8E2D5", borderRadius:7, padding:"4px 11px", cursor:"pointer", fontSize:11.5, fontFamily:fontSans, fontWeight:600}}>
                              Reemplazar
                            </button>
                          </>) : d.estado !== "sin_registro" ? (
                            /* GRIS, NO ÁMBAR. El ámbar es color de advertencia y que
                               falte subir un papel no es un incumplimiento: es una
                               captura pendiente. Pintarlo de ámbar era aplicar al revés
                               nuestra propia regla, y dejaba la pantalla con tres
                               avisos cuando el resumen real era "dos vigentes, uno
                               vencido, faltan los papeles". */
                            <span style={{fontSize:11.5, color:"rgba(232,226,213,0.55)"}}>Sin archivo — solo fecha capturada</span>
                          ) : (
                            <span style={{fontSize:11.5, color:"rgba(232,226,213,0.5)"}}>Sin archivo y sin fecha</span>
                          )}
                        </div>
                      </div>
                      {!abierto && (
                        <button onClick={()=>abrirDoc(d)}
                          style={{background:"rgba(184,147,42,0.14)", border:`1px solid ${gold}59`, color:gold, borderRadius:8, padding:"7px 16px", cursor:"pointer", fontSize:12, fontFamily:fontSans, fontWeight:700, flexShrink:0}}>
                          Actualizar
                        </button>
                      )}
                    </div>

                    {/* EL FORMULARIO: LAS DOS FECHAS Y EL ARCHIVO, JUNTOS. */}
                    {abierto && (
                      <div style={{marginTop:14, paddingTop:14, borderTop:"1px solid rgba(255,255,255,0.10)"}}>
                        <div style={{display:"grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap:12}}>
                          <div>
                            <label style={labelStyle}>Vigente desde <span style={{textTransform:"none" as const, letterSpacing:0}}>(opcional)</span></label>
                            <input type="date" value={fDesde} onChange={e=>setFDesde(e.target.value)} style={inputStyle}/>
                          </div>
                          <div>
                            <label style={labelStyle}>Vigente hasta <span style={{color:"#F19E9D", textTransform:"none" as const, letterSpacing:0}}>(obligatoria)</span></label>
                            <input type="date" value={fHasta} onChange={e=>setFHasta(e.target.value)} style={inputStyle}/>
                          </div>
                        </div>
                        <div style={{marginTop:12}}>
                          <label style={labelStyle}>Archivo del documento {archivo?.url ? "(reemplaza el actual)" : "(opcional)"}</label>
                          {/* El control crudo del navegador —"Seleccionar archivo ·
                              Ningún archivo seleccionado"— era lo único sin terminar de
                              esta pantalla, y es lo que ve un cliente subiendo su
                              primera póliza. El input real se oculta y el <label> hace
                              de botón: mismo comportamiento, sin JavaScript de por
                              medio y sin perder el teclado ni el lector de pantalla. */}
                          <label htmlFor={`arch-${d.key}`}
                            style={{display:"flex", alignItems:"center", gap:10, cursor:"pointer",
                              background:"rgba(255,255,255,0.05)", border:`1px dashed ${gold}66`, borderRadius:9,
                              padding:"11px 13px", transition:"all 0.2s ease"}}>
                            <span style={{display:"inline-flex", alignItems:"center", justifyContent:"center",
                              width:30, height:30, borderRadius:8, background:"rgba(184,147,42,0.16)", flexShrink:0}}>
                              <AxisIcon name="documentos" size={15} tone="gold" withBackdrop={false} strokeWidth={2.4}/>
                            </span>
                            <span style={{minWidth:0}}>
                              <span style={{display:"block", fontSize:12.5, fontWeight:700, color:gold}}>
                                {fArchivo ? "Elegir otro archivo" : archivo?.url ? "Elegir el archivo que lo reemplaza" : "Elegir archivo"}
                              </span>
                              <span style={{display:"block", fontSize:11, color:"rgba(232,226,213,0.55)", marginTop:1,
                                overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" as const}}>
                                {fArchivo
                                  ? `${fArchivo.name} · ${(fArchivo.size/1024/1024).toFixed(2)} MB`
                                  : "PDF o foto de la póliza, la verificación o la tarjeta"}
                              </span>
                            </span>
                          </label>
                          <input id={`arch-${d.key}`} type="file" accept=".pdf,.jpg,.jpeg,.png"
                            onChange={e=>setFArchivo(e.target.files?.[0] || null)}
                            style={{display:"none"}}/>
                          {/* SEGUNDA PUERTA: LA CÁMARA. La de arriba sigue siendo la misma
                              y sigue aceptando PDF —una póliza llega casi siempre en PDF—.
                              Esta se añade al lado, no la sustituye: `capture="environment"`
                              abre la cámara trasera directamente, y en iOS/Android ofrece
                              además "Escanear documento" con enderezado de bordes. En
                              escritorio, donde no hay cámara que abrir, el navegador cae al
                              selector de archivos: no truena, solo se comporta como la otra.
                              Las dos escriben en el MISMO `fArchivo`, así que el botón
                              Guardar de abajo no distingue de dónde vino el archivo. */}
                          <label htmlFor={`foto-${d.key}`}
                            style={{display:"inline-flex", alignItems:"center", gap:7, cursor:"pointer", marginTop:8,
                              background:"rgba(184,147,42,0.12)", border:`1px solid ${gold}4D`, borderRadius:9,
                              padding:"8px 13px", fontSize:12.5, fontWeight:700, color:gold}}>
                            📷 Tomar foto ahora
                          </label>
                          <input id={`foto-${d.key}`} type="file" accept="image/*" capture="environment"
                            onChange={e=>setFArchivo(e.target.files?.[0] || null)}
                            style={{display:"none"}}/>
                        </div>
                        {msgDoc && (
                          <div style={{marginTop:12, fontSize:12, lineHeight:1.55, borderRadius:9, padding:"9px 12px", fontWeight:600,
                            background: msgDoc.tipo==="ok" ? "rgba(29,158,117,0.12)" : msgDoc.tipo==="parcial" ? "rgba(239,159,39,0.14)" : "rgba(226,75,74,0.12)",
                            border: `1px solid ${msgDoc.tipo==="ok" ? "rgba(29,158,117,0.35)" : msgDoc.tipo==="parcial" ? "rgba(239,159,39,0.45)" : "rgba(226,75,74,0.35)"}`,
                            color: msgDoc.tipo==="ok" ? "#7FD1C0" : msgDoc.tipo==="parcial" ? "#F0B45E" : "#F19E9D"}}>
                            {msgDoc.texto}
                          </div>
                        )}
                        <div style={{marginTop:14, display:"flex", gap:8, justifyContent:"flex-end", flexWrap:"wrap" as const}}>
                          <button onClick={()=>{setDocAbierto(""); setMsgDoc(null);}} disabled={guardandoDoc}
                            style={{background:"transparent", border:"1px solid rgba(255,255,255,0.2)", color:"white", borderRadius:8, padding:"8px 16px", cursor:"pointer", fontSize:12, fontFamily:fontSans}}>
                            Cancelar
                          </button>
                          <button onClick={()=>guardarDocumento(d)} disabled={guardandoDoc}
                            style={{background:gold, border:"none", color:"#0B1829", borderRadius:8, padding:"8px 18px", cursor:guardandoDoc?"wait":"pointer", fontSize:12, fontFamily:fontSans, fontWeight:800}}>
                            {guardandoDoc ? "Guardando…" : "Guardar"}
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
            {/* Esta pantalla es navy por decisión: el arreglo de contraste es el
                mismo criterio que en Marco legal (el texto se queda, sube el
                color), pero con la crema de ESTA superficie, no con los tokens
                claros. Al 0.5 daba 4.12:1 sobre el navy; al 0.62 da 5.41:1 en el
                punto más claro del degradado, por encima del 4.5 que pide un
                texto, y sigue leyéndose como secundario frente al 12.5:1 del
                valor principal. */}
            <p style={{fontSize:UI.fsEtiqueta, color:"rgba(232,226,213,0.62)", marginTop:14, lineHeight:1.6}}>El impuesto federal sobre tenencia se abrogó a partir de 2012, y desde entonces cada estado decide si establece el suyo. Aguascalientes eliminó la tenencia estatal desde el 1 de enero de 2016; por eso AXIS no la monitorea. Lo que sí subsiste en el estado es el control vehicular —el refrendo—, de pago anual y obligatorio, que AXIS todavía no monitorea. Si necesitas seguimiento de algún documento extra, escríbenos.</p>
          </div>
        )}

        {/* TAB HISTORIAL */}
        {tabExp === "historial" && (
          <div>
            <h3 style={{color:"white", fontFamily:fontSerif, fontSize:17, fontWeight:600, margin:"0 0 16px"}}>Historial de viajes ({viajes.length})</h3>
            {viajes.length === 0 ? (
              <div style={{textAlign:"center" as const, padding:"40px 20px", color:"rgba(232,226,213,0.62)", fontSize:13, background:"rgba(255,255,255,0.02)", borderRadius:12, border:"1px dashed rgba(184,147,42,0.2)"}}>Este vehículo aún no tiene movimientos registrados.</div>
            ) : (
              <div style={{display:"flex", flexDirection:"column" as const, gap:8}}>
                {viajes.slice(0, 50).map((r:any) => {
                  const ts = r.timestamp?.toDate ? r.timestamp.toDate() : null;
                  const fechaStr = ts ? ts.toLocaleString("es-MX", {dateStyle:"short", timeStyle:"short"}) : (r.fecha||"");
                  const tieneGps = r.lat && r.lng;
                  return (
                    <div key={r.id} style={{background:"rgba(255,255,255,0.03)", border:"1px solid rgba(184,147,42,0.15)", borderRadius:10, padding:"12px 14px"}}>
                      <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", gap:12, flexWrap:"wrap" as const}}>
                        <div style={{display:"flex", alignItems:"center", gap:10, flex:1, minWidth:0}}>
                          <span style={{background: r.tipo==="salida"?"rgba(93,160,232,0.15)":r.tipo==="llegada"?"rgba(217,119,6,0.15)":"rgba(29,158,117,0.15)", color: r.tipo==="salida"?"#5DA0E8":r.tipo==="llegada"?"#D97706":"#1D9E75", fontSize:11, padding:"3px 9px", borderRadius:6, fontWeight:600, flexShrink:0}}>{r.tipo==="salida"?"→ Salida":r.tipo==="llegada"?"◎ Llegada":"← Regreso"}</span>
                          <div style={{minWidth:0}}>
                            <div style={{fontSize:12, color:"#E8E2D5"}}>{r.conductor||"Sin conductor"} · {fechaStr}</div>
                            <div style={{fontSize:11, color:"rgba(232,226,213,0.62)"}}>
                              {r.kmInicial ? `${r.kmInicial.toLocaleString()} km` : r.kmFinal ? `${r.kmFinal.toLocaleString()} km` : ""}
                              {r.destino ? ` · ${r.destino}` : ""}
                            </div>
                          </div>
                        </div>
                        {tieneGps && (
                          <button onClick={()=>setViajeMapa(viajeMapa?.id===r.id ? null : r)} style={{background:"rgba(184,147,42,0.1)", border:"1px solid rgba(184,147,42,0.3)", color:gold, borderRadius:7, padding:"5px 12px", cursor:"pointer", fontSize:11, fontFamily:fontSans, fontWeight:500, flexShrink:0, display:"flex", alignItems:"center", gap:5}}>
                            <AxisIcon name="pin" size={11} tone="gold" withBackdrop={false} strokeWidth={3}/>
                            {viajeMapa?.id===r.id ? "Ocultar mapa" : "Ver ubicación"}
                          </button>
                        )}
                      </div>
                      {viajeMapa?.id===r.id && tieneGps && (
                        <div style={{marginTop:12}}>
                          <div style={{fontSize:11, color:"rgba(232,226,213,0.7)", marginBottom:6, display:"flex", alignItems:"center", gap:6, lineHeight:1.4}}>
                            <AxisIcon name="pin" size={12} tone="gold" withBackdrop={false} strokeWidth={3}/>
                            <span>Ubicación donde el conductor marcó {r.tipo==="salida"?"la SALIDA":r.tipo==="llegada"?"la LLEGADA al destino":"el REGRESO"} — es el punto del registro, no la ruta ni el destino escrito.</span>
                          </div>
                          <iframe title={`mapa-${r.id}`} style={{width:"100%", height:220, border:0, borderRadius:8}} src={`https://www.openstreetmap.org/export/embed.html?bbox=${r.lng-0.006},${r.lat-0.006},${r.lng+0.006},${r.lat+0.006}&layer=mapnik&marker=${r.lat},${r.lng}`}/>
                          <a href={`https://www.google.com/maps?q=${r.lat},${r.lng}`} target="_blank" rel="noopener noreferrer" style={{fontSize:11, color:gold, marginTop:6, display:"inline-block", textDecoration:"none"}}>Abrir en Google Maps →</a>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}

        {/* TAB MANTENIMIENTOS */}
        {tabExp === "mantenimientos" && (
          <div>
            <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:8, flexWrap:"wrap" as const, gap:10}}>
              <h3 style={{color:"white", fontFamily:fontSerif, fontSize:17, fontWeight:600, margin:0}}>Bitácora de servicios</h3>
              {!showFormMant && (
                <button onClick={()=>setShowFormMant(true)} style={{background:gold, border:"none", color:"#0B1829", borderRadius:8, padding:"8px 16px", cursor:"pointer", fontSize:12, fontFamily:fontSans, fontWeight:700}}>+ Registrar servicio</button>
              )}
            </div>
            <p style={{fontSize:11, color:"rgba(232,226,213,0.62)", margin:"0 0 16px", lineHeight:1.6}}>Documenta los servicios realizados a esta unidad. AXIS no programa ni recomienda servicios.</p>

            {showFormMant && (
              <div style={{background:"rgba(255,255,255,0.04)", border:"1px solid rgba(184,147,42,0.25)", borderRadius:12, padding:"18px 20px", marginBottom:18}}>
                <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr 1fr":"1fr 1fr 1fr", gap:14, marginBottom:14}}>
                  <div>
                    <label style={labelStyle}>Tipo de servicio</label>
                    <select value={mantTipo} onChange={e=>setMantTipo(e.target.value)} style={inputStyle}>
                      {["Servicio / afinación","Cambio de aceite","Llantas","Frenos","Verificación","Reparación","Otro"].map(t => <option key={t} value={t} style={{background:"#0B1829"}}>{t}</option>)}
                    </select>
                  </div>
                  <div>
                    <label style={labelStyle}>Fecha del servicio *</label>
                    <input type="date" value={mantFecha} onChange={e=>setMantFecha(e.target.value)} style={inputStyle}/>
                  </div>
                  <div>
                    <label style={labelStyle}>Kilometraje</label>
                    <input type="number" value={mantKm} onChange={e=>setMantKm(e.target.value)} placeholder="Ej. 45000" style={inputStyle}/>
                  </div>
                  <div>
                    <label style={labelStyle}>Taller</label>
                    <input value={mantTaller} onChange={e=>setMantTaller(e.target.value)} placeholder="Nombre del taller" style={inputStyle}/>
                  </div>
                  <div>
                    <label style={labelStyle}>Costo (MXN)</label>
                    <input type="number" value={mantCosto} onChange={e=>setMantCosto(e.target.value)} placeholder="Ej. 2500" style={inputStyle}/>
                  </div>
                </div>
                <div style={{marginBottom:14}}>
                  <label style={labelStyle}>Observaciones</label>
                  <textarea value={mantObs} onChange={e=>setMantObs(e.target.value)} rows={2} placeholder="Detalles del servicio realizado..." style={{...inputStyle, resize:"vertical" as const}}/>
                </div>
                <div style={{display:"flex", gap:8}}>
                  <button onClick={()=>setShowFormMant(false)} style={{flex:1, background:"transparent", border:"1px solid rgba(255,255,255,0.2)", color:"white", borderRadius:8, padding:"10px", cursor:"pointer", fontSize:13, fontFamily:fontSans}}>Cancelar</button>
                  <button onClick={guardarMantenimiento} disabled={!mantFecha||guardandoMant} style={{flex:2, background:mantFecha?gold:"rgba(255,255,255,0.1)", border:"none", color:mantFecha?"#0B1829":"rgba(255,255,255,0.4)", borderRadius:8, padding:"10px", cursor:mantFecha?"pointer":"not-allowed", fontSize:13, fontFamily:fontSans, fontWeight:700}}>{guardandoMant?"Guardando...":"Guardar en bitácora"}</button>
                </div>
              </div>
            )}

            {mantenimientos.length === 0 ? (
              <div style={{textAlign:"center" as const, padding:"40px 20px", color:"rgba(232,226,213,0.62)", fontSize:13, background:"rgba(255,255,255,0.02)", borderRadius:12, border:"1px dashed rgba(184,147,42,0.2)"}}>
                Aún no hay servicios registrados para esta unidad.
              </div>
            ) : (
              <div style={{display:"flex", flexDirection:"column" as const, gap:10}}>
                {mantenimientos.map(m => (
                  <div key={m.id} style={{background:"rgba(255,255,255,0.03)", border:"1px solid rgba(184,147,42,0.15)", borderRadius:10, padding:"14px 16px"}}>
                    <div style={{display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:12, flexWrap:"wrap" as const, marginBottom:6}}>
                      <div style={{display:"flex", alignItems:"center", gap:10, flexWrap:"wrap" as const}}>
                        <span style={{background:"rgba(184,147,42,0.12)", color:gold, fontSize:11, padding:"3px 10px", borderRadius:6, fontWeight:600}}>{m.tipo}</span>
                        <span style={{fontSize:13, color:"#E8E2D5", fontWeight:500}}>{m.fecha}</span>
                      </div>
                      {m.costo != null && <span style={{fontSize:13, color:gold, fontWeight:600, fontFamily:fontSerif}}>${m.costo.toLocaleString("es-MX")}</span>}
                    </div>
                    <div style={{fontSize:12, color:"rgba(232,226,213,0.6)", lineHeight:1.6}}>
                      {m.kilometraje != null && `${m.kilometraje.toLocaleString()} km`}
                      {m.kilometraje != null && m.taller ? " · " : ""}
                      {m.taller || ""}
                    </div>
                    {m.observaciones && <div style={{fontSize:12, color:"rgba(232,226,213,0.7)", marginTop:6, fontStyle:"italic" as const}}>{m.observaciones}</div>}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

      </div>
    </div>
  );
}

// `filtroInicial` es el MISMO patrón con el que Recibos abre Nómina en un
// trabajador concreto: estado en App, prop de valor inicial aquí, y `irAModulo`
// lo limpia al navegar por el sidebar para que no se arrastre.
function FlotillaModulo({user, tipoContrato, onBack, fontSans, fontSerif, gold, filtroInicial, vehiculoInicialId, vehiculoInicialTab, foco}: {user:any; tipoContrato:string; onBack:()=>void; fontSans:string; fontSerif:string; gold:string; filtroInicial?:"vencida"|"por_vencer"|"sin_registro"|"en_regla"|null; vehiculoInicialId?:string|null;
  // La pestaña del expediente en la que aterriza el salto.
  vehiculoInicialTab?:"datos"|"documentos"|"historial"|"mantenimientos"|null;
  // El hecho concreto al que se llegó desde otra pantalla, POR SU ID: un viaje
  // abierto desde Inicio, o un movimiento o un accidente desde el feed. Se
  // SEÑALA en su sitio; nunca se filtra la lista para dejarlo solo.
  foco?: {foco:"viaje"|"movimiento"|"accidente"; id:string}|null}) {
  const isMobile = window.innerWidth < 768;

  // Guard: requiere cuenta porque guarda flotilla por empresa en Firestore
  if (!user) {
    return (
      <div style={{minHeight:"100vh", background:T_LIGHT.canvas, fontFamily:fontSans, display:"flex", flexDirection:"column" as const}}>
        <div style={{background:T.navy, padding:"0 20px",
          height:58, display:"flex", alignItems:"center", gap:12,
          borderBottom:"1px solid rgba(184,147,42,0.24)", boxShadow:"0 2px 16px rgba(22,36,71,0.12)"}}>
          <button onClick={onBack}
            style={{background:"rgba(255,255,255,0.08)", border:"1px solid rgba(255,255,255,0.12)",
              color:"white", borderRadius:8, padding:"5px 12px", cursor:"pointer", fontSize:12}}>
            ← Suite
          </button>
          <span style={{color:"white", fontWeight:600, fontSize:14, display:"flex", alignItems:"center", gap:8}}>
            <AxisIcon name="suite_flotilla" size={18} tone="white" withBackdrop={false} strokeWidth={2.5}/>
            Control de Flotilla
          </span>
        </div>
        <div style={{flex:1, display:"flex", alignItems:"center", justifyContent:"center", padding:"32px 20px"}}>
          <div style={{maxWidth:440, width:"100%", textAlign:"center" as const,
            background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.goldBorder}`,
            borderRadius:18, padding:isMobile?"32px 22px":"44px 36px",
            boxShadow:T_LIGHT.shadow}}>
            <div style={{marginBottom:14, display:"flex", justifyContent:"center"}}>
              <AxisIcon name="suite_flotilla" size={48} tone="gold" withBackdrop={false} strokeWidth={2.5}/>
            </div>
            <h2 style={{fontFamily:fontSerif, fontSize:isMobile?20:24, color:T_LIGHT.textInk,
              margin:"0 0 12px", fontWeight:700}}>Necesitas una cuenta</h2>
            <p style={{fontSize:14, lineHeight:1.6, color:T_LIGHT.textInkSoft, margin:"0 0 24px"}}>
              Control de Flotilla guarda los registros de tus vehículos por empresa. Crea una cuenta gratuita para empezar.
            </p>
            <button onClick={onBack}
              style={{background:gold, border:"none", color:"#0B1829", borderRadius:10,
                padding:"12px 28px", cursor:"pointer", fontSize:14, fontWeight:700,
                fontFamily:fontSans, width:"100%", boxShadow:"0 4px 16px rgba(184,147,42,0.35)"}}>
              ← Volver a la Suite
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Estado
  // Si se entró señalando un hecho, se abre la pestaña donde ese hecho vive.
  // Solo el valor INICIAL: a partir de ahí las pestañas son del usuario.
  const [tab, setTab] = useState<"vehiculos"|"resumen"|"historial"|"movimiento"|"accidentes">(
    foco ? (foco.foco === "accidente" ? "accidentes" : "historial") : "vehiculos");
  const [tipoMovimiento, setTipoMovimiento] = useState<"salida"|"regreso">("salida");
  const setTabMovimiento = (tipo:"salida"|"regreso") => { setTipoMovimiento(tipo); setTab("movimiento"); };
  const [vehiculos, setVehiculos] = useState<Vehiculo[]>([]);
  const [registros, setRegistros] = useState<RegistroFlotilla[]>([]);
  const [accidentes, setAccidentes] = useState<any[]>([]);          // accidentes registrados por trabajadores
  // EL ACCIDENTE QUE SEÑALÓ EL FEED, dicho una sola vez: lo leen el desplegado
  // inicial y el resaltado, y si se escribiera dos veces podrían acabar señalando
  // a accidentes distintos.
  const _resAccId = foco && foco.foco === "accidente" ? foco.id : null;
  // Id del accidente con detalle abierto. Si se llegó desde el feed señalando
  // uno, arranca abierto: la fila prometía ESE accidente, no la lista.
  const [accExpandido, setAccExpandido] = useState<string|null>(_resAccId);
  // VIGENTES Y CANCELADOS NO SE MEZCLAN: un cancelado (registro por error o de
  // prueba) se ve aparte, y nunca se borra.
  const [accVista, setAccVista] = useState<"vigentes"|"cancelados">("vigentes");
  // Llegar desplegado es la mitad del trabajo: en una lista larga, el accidente
  // desplegado puede quedar fuera de la pantalla y hay que buscarlo igual.
  const _resAcc = useResaltado(_resAccId, accidentes);
  const [loading, setLoading] = useState(true);
  const [showFormVehiculo, setShowFormVehiculo] = useState(false);
  const [verImportarVeh, setVerImportarVeh] = useState(false);
  const [verImportarVehIA, setVerImportarVehIA] = useState(false);
  const [filtroStatus, setFiltroStatus] = useState<"activo"|"inactivo"|"todos">("activo");
  const [busqueda, setBusqueda] = useState("");
  const [showModalBaja, setShowModalBaja] = useState<Vehiculo|null>(null);
  const [showComoFunciona, setShowComoFunciona] = useState(false);
  const [showProtocoloAccidente, setShowProtocoloAccidente] = useState(false);
  const [showMultas, setShowMultas] = useState(false);
  const [filtroHistorial, setFiltroHistorial] = useState("");
  // Filtro y orden de la tabla de unidades. Arranca por acción requerida.
  const [filtroDoc, setFiltroDoc] = useState<"todas"|"vencida"|"por_vencer"|"sin_registro"|"en_regla">(filtroInicial || "todas");
  const [ordenFlota, setOrdenFlota] = useState<"accion"|"placa"|"estado">("accion");
  // Ancla de la tabla: al filtrar desde un indicador, la respuesta tiene que
  // quedar a la vista; si no, parece que no pasó nada.
  const refTabla = useRef<HTMLDivElement|null>(null);
  const filtrarDesdeIndicador = (v:"todas"|"vencida"|"por_vencer"|"sin_registro"|"en_regla") => {
    setFiltroDoc(v);
    setTimeout(()=>{ try { refTabla.current?.scrollIntoView({behavior:"smooth", block:"start"}); } catch(e) {} }, 60);
  };
  const [dirFlota, setDirFlota] = useState<"asc"|"desc">("asc");
  const [vehiculoExpediente, setVehiculoExpediente] = useState<Vehiculo|null>(null);
  const _vehInicialUsado = useRef(false);

  useEffect(() => { cargarTodo(); /* eslint-disable-next-line */ }, [user?.uid]);

  const cargarTodo = async () => {
    // SEGURIDAD: filtramos por userId para no exponer flotas de otros usuarios.
    // Si no hay sesión, dejamos vacío en lugar de pedirle a Firestore "todo".
    if (!user?.uid) { setVehiculos([]); setRegistros([]); setLoading(false); return; }
    setLoading(true);
    try {
      // NOTA: NO usamos orderBy en estas queries. Combinar where("userId",...)
      // con orderBy en otro campo (placa, timestamp) requiere un índice
      // compuesto en Firestore. Para evitar tener que crear/mantener índices,
      // traemos los docs filtrados y ordenamos en memoria abajo.
      const [snapV, snapR] = await Promise.all([
        getDocs(query(collection(db, "vehiculos"), where("userId","==",user.uid))),
        getDocs(query(collection(db, "flotilla"),  where("userId","==",user.uid))),
      ]);
      const veh: Vehiculo[] = snapV.docs.map(d => ({id:d.id, ...d.data()} as Vehiculo))
        .sort((a,b) => (a.placa || "").localeCompare(b.placa || ""));
      const reg: RegistroFlotilla[] = snapR.docs.map(d => ({id:d.id, ...d.data()} as RegistroFlotilla))
        .sort((a,b) => ((b.timestamp as any)?.seconds || 0) - ((a.timestamp as any)?.seconds || 0));
      setVehiculos(veh);
      // Salto desde un aviso: se abre el expediente de ESA unidad. Va aquí y no en
      // un efecto aparte porque la lista llega asíncrona: antes de esto no hay a
      // quién abrir. Solo la primera vez, para no reabrirlo en cada recarga.
      if (vehiculoInicialId && !_vehInicialUsado.current) {
        _vehInicialUsado.current = true;
        const v = veh.find((x:any)=> x.id === vehiculoInicialId);
        if (v) setVehiculoExpediente(v);
      }
      setRegistros(reg);
      // Accidentes registrados por trabajadores (empleadorId == uid del patrón).
      // Aislado: un fallo de permisos NO debe romper la carga de la flotilla.
      // Un solo where; se ordena en JS (sin índice compuesto).
      try {
        const snapAcc = await getDocs(query(collection(db, "accidentes"), where("empleadorId","==",user.uid)));
        const acc = snapAcc.docs.map(d => ({id:d.id, ...(d.data() as any)}))
          .sort((a:any,b:any)=>((b.timestamp as any)?.seconds||0)-((a.timestamp as any)?.seconds||0));
        setAccidentes(acc);
      } catch(eAcc) { console.warn("accidentes (Flotilla):", eAcc); }
    } catch(e) { console.error(e); }
    finally { setLoading(false); }
  };

  const confirmarBaja = async (razon: string, notas: string) => {
    if (!showModalBaja?.id) return;
    try {
      await updateDoc(doc(db, "vehiculos", showModalBaja.id), {
        status: "inactivo",
        fechaBaja: new Date().toISOString().slice(0,10),
        razonBaja: razon,
        notasBaja: notas,
      });
      setShowModalBaja(null);
      await cargarTodo();
      avisarCambioDeAtencion();   // una unidad de baja sale de la lista
    } catch(e) { console.error(e); alert("Error al dar de baja el vehículo"); }
  };

  // ── IMPORTACIÓN DE UNIDADES (archivo o documento con IA) ───────────────────
  // Mismo par de componentes que usa Empleados; lo único propio es el ESQUEMA y
  // el guardado. Los campos son los que ya existen en el modelo Vehiculo: no se
  // inventa ninguno. Quedan fuera a propósito el conductor asignado (se asigna a
  // mano contra la lista real de trabajadores) y la tenencia (campo informativo
  // que no entra al estado documental).
  const camposImportVehiculo: CampoImport[] = [
    {key:"placa", label:"Placa", tipo:"text", requerido:true, alias:["placa","placas","matrícula","matricula","unidad"], ejemplo:"ABC-123-D"},
    {key:"numeroEconomico", label:"Número económico", tipo:"text", alias:["no. econ.","economico","económico","no. económico","numero economico","número económico","económico de la unidad"], ejemplo:"U-14"},
    {key:"marca", label:"Marca", tipo:"text", alias:["marca"], ejemplo:"Nissan"},
    {key:"modelo", label:"Modelo", tipo:"text", alias:["modelo","submarca"], ejemplo:"NP300"},
    {key:"anio", label:"Año", tipo:"number", alias:["año","anio","ano","modelo año"], ejemplo:"2021"},
    {key:"color", label:"Color", tipo:"text", alias:["color"], ejemplo:"Blanco"},
    {key:"numeroSerie", label:"Número de serie", tipo:"text", alias:["no. de serie","numero de serie","número de serie","serie","vin","niv"], ejemplo:"3N6AD33A9MK800000"},
    {key:"kilometraje", label:"Kilometraje", tipo:"number", alias:["kilometraje","km","kms","odómetro","odometro"], ejemplo:"48500"},
    {key:"venceVerificacion", label:"La verificación vence el", tipo:"date", alias:["verificación","verificacion","vence verificación","vencimiento verificación"], ejemplo:"2026-12-31"},
    {key:"venceSeguro", label:"El seguro vence el", tipo:"date", alias:["seguro","póliza","poliza","vence seguro","vencimiento seguro"], ejemplo:"2026-10-15"},
    {key:"venceTarjeta", label:"La tarjeta de circulación vence el", tipo:"date", alias:["tarjeta","tarjeta de circulación","tarjeta de circulacion","circulación","vence tarjeta"], ejemplo:"2027-03-01"},
  ];
  // DUPLICADO POR PLACA, y nada más: es el identificador que trae cualquier lista
  // y el que el patrón tiene en la cabeza. El número de serie casi nunca viene en
  // un documento operativo, y exigirlo dejaría duplicados sin detectar.
  const firmaVehiculo = (o:any):string[] => {
    const placa = String(o?.placa||"").toUpperCase().replace(/[^A-Z0-9]/g,"");
    return placa ? ["placa:"+placa] : [];
  };
  const guardarVehiculoImportado = async (valores:Record<string,string>) => {
    if (!user?.uid) throw new Error("Necesitas estar autenticado para guardar un vehículo.");
    const num = (v:string) => { const n = parseInt(String(v||"").replace(/[^0-9-]/g,""), 10); return Number.isFinite(n) ? n : null; };
    const txt = (v:string) => { const s = String(v||"").trim(); return s || null; };
    // MISMA forma que el alta manual (colección `vehiculos`, el CATÁLOGO; la
    // colección `flotilla` es la bitácora de salidas y regresos, no va aquí).
    await addDoc(collection(db, "vehiculos"), {
      userId: user.uid,
      placa: String(valores.placa||"").toUpperCase().trim(),
      marca: txt(valores.marca),
      modelo: txt(valores.modelo),
      anio: num(valores.anio),
      color: txt(valores.color),
      numeroEconomico: txt(valores.numeroEconomico),
      numeroSerie: txt(valores.numeroSerie),
      kilometraje: num(valores.kilometraje),
      conductorAsignadoNombre: null,
      status: "activo",
      venceVerificacion: txt(valores.venceVerificacion) || "",
      venceSeguro: txt(valores.venceSeguro) || "",
      venceTarjeta: txt(valores.venceTarjeta) || "",
      timestamp: Timestamp.now(),
    });
    avisarCambioDeAtencion();   // unidad importada: sus vigencias entran en la lista
  };

  const reactivarVehiculo = async (v: Vehiculo) => {
    if (!v.id) return;
    if (!window.confirm(`¿Reactivar el vehículo ${v.placa}? Volverá al listado de activos.`)) return;
    try {
      await updateDoc(doc(db, "vehiculos", v.id), {
        status: "activo",
        fechaBaja: null,
        razonBaja: null,
        notasBaja: null,
      });
      await cargarTodo();
      avisarCambioDeAtencion();   // una unidad reactivada vuelve a la lista
    } catch(e) { console.error(e); alert("Error al reactivar el vehículo"); }
  };

  // ── REPORTE MENSUAL DE FLOTILLA ───────────────────────────────────────────
  // Sustituye al anterior, que abría una pestaña con HTML y llamaba a
  // window.print(): eso no dejaba un PDF, salía con la URL impresa en el pie y
  // era un segundo mecanismo de documento conviviendo con el de la plataforma.
  // Ahora usa EL MISMO generador y EL MISMO formato que el reporte mensual de
  // empleados (generarPDFDesdeHTML + _estiloDocumentoAxis).
  //
  // Este reporte es del PATRÓN y no se envía al trabajador.
  const [mesReporteFlota, setMesReporteFlota] = useState<"actual"|"anterior">("actual");
  const [generandoReporteFlota, setGenerandoReporteFlota] = useState(false);
  const [msgReporteFlota, setMsgReporteFlota] = useState("");
  // El mes se escribe con su nombre en el propio control. Ver la nota del
  // encabezado: si no se lee sin abrir nada, se confunde con el filtro de la
  // bitácora.
  const etiquetaMesReporte = (desplaz:number) => {
    const h = new Date();
    const d = new Date(h.getFullYear(), h.getMonth() + desplaz, 1);
    return `${d.toLocaleDateString("es-MX",{month:"long"})} ${d.getFullYear()}`;
  };
  const generarReporteFlotilla = async () => {
    if (generandoReporteFlota) return;
    setGenerandoReporteFlota(true); setMsgReporteFlota("");
    try {
      const hoy = new Date();
      const objetivo = mesReporteFlota === "actual"
        ? new Date(hoy.getFullYear(), hoy.getMonth(), 1)
        : new Date(hoy.getFullYear(), hoy.getMonth()-1, 1);
      const anio = objetivo.getFullYear(), mes = objetivo.getMonth();
      // EL CANDADO Y LA FUENTE. El reporte de flotilla se firma y nombra a la
      // empresa en su encabezado: sin denominacion no se emite.
      let cfgP:any = null;
      try { cfgP = await leerConfigEmpresa(user.uid); } catch(e){}
      if (!datosPatronCompletos(cfgP)) {
        setMsgReporteFlota("Faltan los datos de tu empresa: " + faltanDatosPatron(cfgP).join(", ").toLowerCase() + ". Captúralos en Datos de mi empresa.");
        setGenerandoReporteFlota(false); return;
      }
      const empresa = datosPatronDe(cfgP).denominacion;
      const d = datosReporteFlotilla({registros: registros as any[], vehiculos: vehiculos as any[], anio, mes});
      const html = construirReporteFlotillaHTML({
        empresa, rfc: datosPatronDe(cfgP).rfc, domicilio: domicilioPatronTexto(datosPatronDe(cfgP)),
        mes: mesLargoAxis(anio, mes),
        generadoPor: user?.displayName || user?.email || "—",
        generadoEn: fechaHoraLargaAxis(),
        d,
      });
      const fname = `reporte-flotilla-${anio}-${String(mes+1).padStart(2,"0")}.pdf`;
      await generarPDFDesdeHTML(html, fname);
      setMsgReporteFlota("PDF generado (revisa tus descargas).");
    } catch(e:any) {
      console.error("reporte-flotilla:", e);
      setMsgReporteFlota("No se pudo generar: " + (e?.message || "error"));
    } finally { setGenerandoReporteFlota(false); }
  };

  // Cálculos derivados
  const kpis = calcularKPIsFlotilla(vehiculos);
  // ── ESTADO DOCUMENTAL EN CUATRO NIVELES (solo PRESENTACIÓN) ────────────────
  // El cálculo no se toca: se LEE calcularComplianceVehiculo y se traduce a lo que
  // la tabla debe mostrar. La diferencia con `nivelVehiculo` es que aquí SIN
  // REGISTRAR es un estado propio y no se mezcla con "por vencer": una unidad sin
  // fechas capturadas no está incumpliendo, simplemente no se ha capturado.
  const estadoFlota = (v:any):{clave:"vencida"|"por_vencer"|"sin_registro"|"en_regla"; docs:any[]} => {
    const docs = calcularComplianceVehiculo(v).documentos;
    const vencidos = docs.filter((d:any)=>d.estado==="vencido");
    if (vencidos.length) return {clave:"vencida", docs:vencidos};
    const porVencer = docs.filter((d:any)=>d.estado==="por_vencer");
    if (porVencer.length) return {clave:"por_vencer", docs:porVencer};
    const faltantes = docs.filter((d:any)=>d.estado==="sin_registro");
    if (faltantes.length) return {clave:"sin_registro", docs:faltantes};
    return {clave:"en_regla", docs:[]};
  };
  // Orden por ACCIÓN REQUERIDA, no alfabético: lo vencido primero, luego lo que está
  // por vencer —donde el patrón todavía puede actuar a tiempo—, luego lo que falta
  // capturar y al final lo que está en regla.
  const RANGO_FLOTA:Record<string,number> = {vencida:0, por_vencer:1, sin_registro:2, en_regla:3};
  const nDocVencidas = vehiculos.filter(v=>(v.status||"activo")==="activo" && estadoFlota(v).clave==="vencida").length;
  const nDocPorVencer = vehiculos.filter(v=>(v.status||"activo")==="activo" && estadoFlota(v).clave==="por_vencer").length;
  const nSinRegistro = vehiculos.filter(v=>(v.status||"activo")==="activo" && estadoFlota(v).clave==="sin_registro").length;
  const _mesFlota = new Date().toISOString().slice(0,7);
  const nMovsMes = registros.filter((r:any)=>{ const d=(r as any).timestamp?.toDate?.(); return !!d && d.toISOString().slice(0,7)===_mesFlota; }).length;

  const vehiculosFiltrados = vehiculos.filter(v => {
    const matchStatus = filtroStatus === "todos" || (v.status || "activo") === filtroStatus;
    const q = busqueda.toLowerCase();
    const matchBusqueda = !busqueda || v.placa.toLowerCase().includes(q) || (v.marca||"").toLowerCase().includes(q) || (v.modelo||"").toLowerCase().includes(q) || (v.conductorAsignadoNombre||"").toLowerCase().includes(q);
    const matchDoc = filtroDoc==="todas" || estadoFlota(v).clave===filtroDoc;
    return matchStatus && matchBusqueda && matchDoc;
  });
  // Orden por acción requerida; el manual por columna lo pisa cuando se pide.
  const vehiculosVista = vehiculosFiltrados.slice().sort((a:any,b:any)=>{
    const dir = dirFlota==="asc" ? 1 : -1;
    if (ordenFlota==="placa") return (a.placa||"").localeCompare((b.placa||""), "es") * dir;
    if (ordenFlota==="estado") {
      const r = RANGO_FLOTA[estadoFlota(a).clave] - RANGO_FLOTA[estadoFlota(b).clave];
      if (r!==0) return r*dir;
      return (a.placa||"").localeCompare((b.placa||""), "es");
    }
    const r = RANGO_FLOTA[estadoFlota(a).clave] - RANGO_FLOTA[estadoFlota(b).clave];
    if (r!==0) return r;
    return (a.placa||"").localeCompare((b.placa||""), "es");
  });

  if (tab === "movimiento") return <FlotillaForm tipo={tipoMovimiento} user={user} onBack={() => { setTab("historial"); cargarTodo(); }} fontSans={fontSans} fontSerif={fontSerif} gold={gold} vehiculos={vehiculos} />;

  if (vehiculoExpediente) return (
    <ExpedienteVehiculo
      vehiculo={vehiculoExpediente}
      tabInicial={vehiculoInicialTab || null}
      registros={registros}
      onBack={() => { setVehiculoExpediente(null); cargarTodo(); }}
      onActualizado={async () => {
        if (vehiculoExpediente.id) {
          try {
            const snap = await getDoc(doc(db, "vehiculos", vehiculoExpediente.id));
            if (snap.exists()) setVehiculoExpediente({id: snap.id, ...snap.data()} as Vehiculo);
          } catch(e) { console.error(e); }
        }
        cargarTodo();
      }}
      onDarDeBaja={() => { const v = vehiculoExpediente; setVehiculoExpediente(null); setShowModalBaja(v); }}
      onReactivar={() => { const v = vehiculoExpediente; setVehiculoExpediente(null); reactivarVehiculo(v); }}
      fontSans={fontSans} fontSerif={fontSerif} gold={gold}
    />
  );

  const totalAlertas = kpis.conDocsVencidos + kpis.proximosVencer;

  return (
    <div style={{minHeight:"100vh", background:T_LIGHT.canvas, fontFamily:fontSans}}>
      <div style={{maxWidth:ANCHO_CONTENIDO, margin:"0 auto", padding:isMobile?"20px 14px 60px":"28px 24px 80px"}}>

        {/* PUNTO DE ENTRADA DEL REPORTE. Va en el ENCABEZADO y no dentro de una
            pestaña: se genera igual desde Unidades, Bitácora o Accidentes, y hay
            UNO solo —dos botones para la misma acción son dos rutas—.

            El mes va ESCRITO en el control a propósito. Este botón queda cerca de
            los filtros Desde/Hasta de la bitácora, y cualquiera supondría que el
            reporte respeta ese filtro. NO lo respeta: cubre un mes completo. Si el
            mes no se lee sin abrir nada, esa confusión se descubre cuando el
            documento ya salió de la empresa. */}
        <div style={{display:"flex", alignItems:"center", gap:10, marginBottom:16, flexWrap:"wrap" as const, justifyContent:"flex-end"}}>
          {msgReporteFlota && <span style={{fontSize:12, color:T_LIGHT.textInkSoft, marginRight:"auto"}}>{msgReporteFlota}</span>}
          <select {...CAMPO_DE_PARAMETRO} value={mesReporteFlota} onChange={e=>setMesReporteFlota(e.target.value as any)}
            aria-label="Mes que cubre el reporte"
            style={{background:T_LIGHT.cardLight, border:`1px solid ${gold}`, color:T_LIGHT.textInk, borderRadius:10,
              padding:"10px 12px", fontSize:13, fontWeight:700, fontFamily:fontSans, outline:"none", cursor:"pointer", textTransform:"capitalize" as const}}>
            <option value="actual">{`Reporte mensual · ${etiquetaMesReporte(0)}`}</option>
            <option value="anterior">{`Reporte mensual · ${etiquetaMesReporte(-1)}`}</option>
          </select>
          <button onClick={generarReporteFlotilla} disabled={generandoReporteFlota}
            style={{background:gold, border:"none", color:"#0B1829", borderRadius:10, padding:"10px 18px",
              cursor:generandoReporteFlota?"wait":"pointer", fontSize:13, fontFamily:fontSans, fontWeight:700,
              display:"flex", alignItems:"center", gap:8, opacity:generandoReporteFlota?0.7:1}}>
            <AxisIcon name="document" size={16} color="#0B1829" withBackdrop={false} strokeWidth={2.5}/>
            {generandoReporteFlota ? "Generando…" : "Descargar PDF"}
          </button>
        </div>
        {/* NAVEGA dentro del módulo (no explica ni acciona) → siempre visible.
            De cinco pestañas a tres: "Resumen" son los indicadores de arriba y
            "Movimiento" es un formulario, así que pasa a botón de acción. */}
        <div style={{display:"flex", alignItems:"center", gap:10, marginBottom:18, flexWrap:"wrap" as const}}>
          <SegmentadoFiltro fontSans={fontSans} valor={tab==="historial"?"historial":tab==="accidentes"?"accidentes":"vehiculos"}
            onCambio={(v)=>setTab(v as any)}
            opciones={[
              {v:"vehiculos" as const, t:"Unidades"},
              {v:"historial" as const, t:"Bitácora"},
              {v:"accidentes" as const, t:"Accidentes"},
            ]}/>
          {totalAlertas > 0 && <ChipEstado texto={`${totalAlertas} por atender`} tono="critico"/>}
          {/* Los cancelados por el patrón no son accidentes: tienen su pestaña. */}
          {(()=>{ const n = accidentes.filter((a:any)=> estadoAtencionAccidente(a) !== "cancelado").length;
            return n > 0 ? <ChipEstado texto={`${n} accidente${n===1?"":"s"}`} tono="pendiente"/> : null; })()}
        </div>

        {/* TAB: VEHÍCULOS */}
        {tab === "vehiculos" && (
          <>
            {/* ── INDICADORES ── el filete dice ESTADO: rojo si hay unidades con
                 documentos vencidos, ámbar si hay plazos por vencer, verde si no. */}
            <div style={{display:"grid", gridTemplateColumns:isMobile?"repeat(2,1fr)":"repeat(5,1fr)", gap:12, marginBottom:18}}>
              <IndicadorTarjeta isMobile={isMobile} fontSerif={fontSerif}
                onAccion={()=>filtrarDesdeIndicador("todas")} activo={filtroDoc==="todas"}
                etiqueta="Unidades activas" valor={vehiculos.length===0 ? "Sin registrar" : String(kpis.activos)}
                icono="suite_flotilla" tono={UI.navy}
                micro={vehiculos.length===0 ? "aún no das de alta unidades"
                     : (vehiculos.length - kpis.activos) > 0
                       ? `${vehiculos.length - kpis.activos} dada${vehiculos.length-kpis.activos===1?"":"s"} de baja, fuera de este conteo`
                       : `de ${vehiculos.length} registrada${vehiculos.length===1?"":"s"}`}/>
              <IndicadorTarjeta isMobile={isMobile} fontSerif={fontSerif}
                onAccion={()=>filtrarDesdeIndicador("vencida")} activo={filtroDoc==="vencida"}
                etiqueta="Con documentos vencidos" valor={vehiculos.length===0 ? "Sin registrar" : String(nDocVencidas)}
                icono="alert" tono={nDocVencidas>0 ? UI.rojo : UI.ok}
                micro={nDocVencidas>0 ? "documentación vencida" : "toda la documentación vigente"}/>
              {/* El que da el valor del módulo: avisa cuando todavía se puede actuar. */}
              <IndicadorTarjeta isMobile={isMobile} fontSerif={fontSerif}
                onAccion={()=>filtrarDesdeIndicador("por_vencer")} activo={filtroDoc==="por_vencer"}
                etiqueta="Por vencer (30 días)" valor={vehiculos.length===0 ? "Sin registrar" : String(nDocPorVencer)}
                icono="suite_calendario" tono={nDocPorVencer>0 ? UI.ambar : UI.ok}
                micro={nDocPorVencer>0 ? "aún hay tiempo de renovar" : "sin vencimientos próximos"}/>
              {/* Falta de dato, NO incumplimiento: tono neutro siempre. */}
              <IndicadorTarjeta isMobile={isMobile} fontSerif={fontSerif}
                onAccion={()=>filtrarDesdeIndicador("sin_registro")} activo={filtroDoc==="sin_registro"}
                etiqueta="Sin registrar" valor={vehiculos.length===0 ? "Sin registrar" : String(nSinRegistro)}
                icono="document" tono={UI.neutro}
                micro={nSinRegistro>0 ? "les falta capturar alguna fecha" : "todas con sus tres fechas"}/>
              <IndicadorTarjeta isMobile={isMobile} fontSerif={fontSerif}
                onAccion={()=>setTab("historial")}
                etiqueta="Movimientos del mes" valor={registros.length===0 ? "Sin registrar" : String(nMovsMes)}
                icono="clipboard" tono={UI.navy}
                micro={registros.length===0 ? "aún no hay bitácora"
                     : nMovsMes>0 ? "salidas y regresos registrados" : "ninguno este mes"}/>
            </div>

            {/* FILTRA (no navega) + la acción principal */}
            <div style={{display:"flex", gap:10, marginBottom:14, flexWrap:"wrap" as const, alignItems:"center"}}>
              <input {...CAMPO_DE_PARAMETRO} value={busqueda} onChange={(e)=>setBusqueda(e.target.value)} placeholder="Buscar por placa, marca, modelo o conductor…"
                style={{flex:1, minWidth:220, background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rControl,
                  padding:"9px 13px", color:UI.texto, fontSize:UI.fsCuerpo, outline:"none", fontFamily:fontSans, boxSizing:"border-box" as const}} />
              <SegmentadoFiltro fontSans={fontSans} valor={filtroDoc} onCambio={(v)=>setFiltroDoc(v)}
                opciones={[
                  {v:"todas" as const, t:"Todas"},
                  {v:"vencida" as const, t:"Vencidas"},
                  {v:"por_vencer" as const, t:"Por vencer"},
                  {v:"sin_registro" as const, t:"Sin registrar"},
                  {v:"en_regla" as const, t:"En regla"},
                ]}/>
              <select {...CAMPO_DE_PARAMETRO} value={filtroStatus} onChange={(e)=>setFiltroStatus(e.target.value as any)} title="Altas y bajas"
                style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rControl, padding:"8px 12px",
                  fontSize:UI.fsEtiqueta, color:UI.texto, fontWeight:700, fontFamily:fontSans, cursor:"pointer", outline:"none"}}>
                <option value="activo">Solo activos</option>
                <option value="inactivo">Solo dados de baja</option>
                <option value="todos">Todos</option>
              </select>
              <BotonSecundario texto="Registrar movimiento" icono="clipboard" fontSans={fontSans}
                onClick={()=>{ setTipoMovimiento("salida"); setTab("movimiento"); }}/>
              <BotonSecundario texto="Importar Excel" icono="clipboard" fontSans={fontSans}
                title="Importar tu catálogo de unidades desde Excel o CSV"
                onClick={()=>setVerImportarVeh(true)}/>
              <BotonSecundario texto="Importar con IA" icono="document" fontSans={fontSans}
                title="La IA lee un PDF o Word con tu lista de unidades y las propone para que las revises antes de guardar"
                onClick={()=>setVerImportarVehIA(true)}/>
              <BotonPrimario texto="+ Agregar vehículo" fontSans={fontSans} onClick={()=>setShowFormVehiculo(true)}/>
            </div>

            {/* ── TABLA DE UNIDADES ── */}
            {loading ? (
              <div style={{textAlign:"center" as const, padding:60, color:UI.textoSuave, background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rPanel}}>Cargando unidades…</div>
            ) : vehiculosVista.length === 0 ? (
              <EstadoVacio
                titulo={vehiculos.length===0 ? "Aún no hay unidades registradas" : "Ninguna unidad coincide"}
                texto={vehiculos.length===0
                  ? "Da de alta tus vehículos con sus fechas de verificación, seguro y tarjeta de circulación. AXIS te avisa 30 días antes de cada vencimiento, lleva la bitácora de quién sacó cada unidad y guarda el expediente documental de la flota en un solo lugar."
                  : "Prueba con otro texto de búsqueda o cambia los filtros."}
                acciones={vehiculos.length===0
                  ? [{t:"+ Agregar el primer vehículo", principal:true, fn:()=>setShowFormVehiculo(true)}]
                  : [{t:"Quitar filtros", principal:false, fn:()=>{ setBusqueda(""); setFiltroDoc("todas"); setFiltroStatus("activo"); }}]}
                icono="suite_flotilla"
                variante={vehiculos.length===0 ? "sin-datos" : "sin-coincidencias"}
                fontSans={fontSans} fontSerif={fontSerif}
              />
            ) : (
              <div ref={refTabla} style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rPanel, boxShadow:UI.sombra, overflow:"hidden"}}>
                <div style={{height:2, background:`linear-gradient(90deg, ${UI.oro}, ${UI.oro}00)`}}/>
                <div style={{maxHeight:`calc(100vh - 460px - ${ZOCALO_FLOTANTES}px)`, minHeight:220, overflowY:"auto" as const}}>
                  <table style={{width:"100%", borderCollapse:"separate" as const, borderSpacing:0}}>
                    <EncabezadoTabla ordenCol={ordenFlota} ordenDir={dirFlota}
                      onOrdenar={(col,dir)=>{ setOrdenFlota(col as any); setDirFlota(dir); }}
                      columnas={[
                        {k:"placa", t:"Unidad", orden:true, al:"left"},
                        {k:"conductor", t:"Conductor asignado", orden:false, al:"left"},
                        {k:"estado", t:"Estado documental", orden:true, al:"left"},
                        {k:"movimiento", t:"Último movimiento", orden:false, al:"left"},
                        {k:"acc", t:"Acción", orden:false, al:"right"},
                      ]}/>
                    <tbody>
                      {vehiculosVista.map((v:any)=>{
                        const est = estadoFlota(v);
                        const tdV:any = {padding:"11px 14px", borderTop:`1px solid ${UI.divisor}`, fontSize:UI.fsCuerpo, color:UI.textoSuave, verticalAlign:"top"};
                        const movs = registros.filter((r:any)=> (r.placa||"").toUpperCase()===(v.placa||"").toUpperCase());
                        const ultimo = movs.slice().sort((a:any,b:any)=>((b.timestamp?.toDate?.()?.getTime())||0)-((a.timestamp?.toDate?.()?.getTime())||0))[0];
                        const fUlt = ultimo?.timestamp?.toDate?.();
                        const dado = (v.status||"activo")!=="activo";
                        return (
                          <tr key={v.id}
                            onClick={()=>setVehiculoExpediente(v)}
                            onMouseEnter={(e)=>{ e.currentTarget.style.background = UI.hover; }}
                            onMouseLeave={(e)=>{ e.currentTarget.style.background = "transparent"; }}
                            style={{cursor:"pointer", transition:"background .12s"}}>
                            {/* Unidad: la placa manda, y el económico va debajo porque
                                muchas flotas identifican así sus unidades. */}
                            <td style={{...tdV, verticalAlign:"middle"}}>
                              <div style={{display:"flex", alignItems:"center", gap:8, minWidth:0, flexWrap:"wrap" as const}}>
                                <span style={{fontFamily:fontSerif, fontSize:UI.fsNombre, fontWeight:700, color:UI.texto, letterSpacing:"0.5px"}}>{v.placa}</span>
                                {v.numeroEconomico && <span style={{fontSize:UI.fsRotulo, color:UI.textoTenue, fontWeight:700}}>· Econ. {v.numeroEconomico}</span>}
                                {dado && <ChipEstado texto="Baja" tono="neutro"/>}
                              </div>
                              <div style={{fontSize:UI.fsEtiqueta, color:UI.textoTenue, marginTop:2}}>
                                {[v.marca, v.modelo, v.anio].filter(Boolean).join(" · ") || "Sin datos de la unidad"}
                              </div>
                            </td>
                            {/* Conductor asignado */}
                            <td style={{...tdV, verticalAlign:"middle"}}>
                              {v.conductorAsignadoNombre
                                ? <div style={{display:"flex", alignItems:"center", gap:10, minWidth:0}}>
                                    <AvatarPersona nombre={v.conductorAsignadoNombre} size={30} fontSerif={fontSerif}/>
                                    <span style={{fontSize:UI.fsCuerpo, color:UI.texto, whiteSpace:"nowrap" as const, overflow:"hidden", textOverflow:"ellipsis"}}>{v.conductorAsignadoNombre}</span>
                                  </div>
                                : <span style={{fontSize:UI.fsEtiqueta, color:UI.textoTenue}}>Sin asignar</span>}
                            </td>
                            {/* Estado documental: cuatro niveles. Sin fechas capturadas
                                NO es incumplimiento, es "Sin registrar". */}
                            <td style={{...tdV, minWidth:230}}>
                              {est.clave==="vencida" ? (
                                <>
                                  <ChipEstado texto="⚠ Vencida" tono="critico"/>
                                  <div style={{fontSize:UI.fsCuerpo, color:UI.texto, marginTop:4, lineHeight:1.4}}>
                                    {est.docs.map((d:any)=>`${d.label} (${Math.abs(d.dias)} día${Math.abs(d.dias)===1?"":"s"})`).join(" · ")}
                                  </div>
                                </>
                              ) : est.clave==="por_vencer" ? (
                                <>
                                  <ChipEstado texto="Por vencer" tono="pendiente"/>
                                  <div style={{fontSize:UI.fsCuerpo, color:UI.texto, marginTop:4, lineHeight:1.4}}>
                                    {est.docs.map((d:any)=>`${d.label} en ${d.dias} día${d.dias===1?"":"s"}`).join(" · ")}
                                  </div>
                                </>
                              ) : est.clave==="sin_registro" ? (
                                <>
                                  <ChipEstado texto="Sin registrar" tono="neutro"/>
                                  <div style={{fontSize:UI.fsEtiqueta, color:UI.textoTenue, marginTop:4, lineHeight:1.4}}>Captura sus fechas para que AXIS avise antes de que venzan.</div>
                                </>
                              ) : (
                                <>
                                  <ChipEstado texto="✓ En regla" tono="ok"/>
                                  <div style={{fontSize:UI.fsEtiqueta, color:UI.textoTenue, marginTop:4}}>Verificación, seguro y tarjeta vigentes</div>
                                </>
                              )}
                            </td>
                            {/* Último movimiento */}
                            <td style={{...tdV, whiteSpace:"nowrap" as const}}>
                              {ultimo ? (
                                <>
                                  <div style={{fontSize:UI.fsCuerpo, color:UI.textoSuave, textTransform:"capitalize" as const}}>{ultimo.tipo || "Movimiento"}</div>
                                  <div style={{fontSize:UI.fsEtiqueta, color:UI.textoTenue, marginTop:2}}>
                                    {fUlt ? fUlt.toLocaleDateString("es-MX",{day:"2-digit",month:"short",year:"numeric"}) : ""}
                                    {ultimo.conductor ? ` · ${ultimo.conductor}` : ""}
                                  </div>
                                </>
                              ) : <span style={{fontSize:UI.fsEtiqueta, color:UI.textoTenue}}>Sin movimientos</span>}
                            </td>
                            {/* Acción única de la fila */}
                            <td style={{...tdV, textAlign:"right" as const, whiteSpace:"nowrap" as const, verticalAlign:"middle"}}>
                              <span style={{fontSize:UI.fsEtiqueta, fontWeight:700, color:UI.navy}}>Ver expediente ›</span>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                <div style={{padding:"9px 14px", borderTop:`1px solid ${UI.divisor}`, fontSize:10.5, color:UI.textoTenue, background:UI.superficie}}>
                  {/* Explica QUÉ se está viendo y por qué faltan las demás: un
                      "10 de 15" se lee como paginación truncada. */}
                  {vehiculosVista.length===1
                    ? `1 unidad${filtroStatus==="activo" ? " activa" : filtroStatus==="inactivo" ? " dada de baja" : ""}`
                    : `${vehiculosVista.length} unidades${filtroStatus==="activo" ? " activas" : filtroStatus==="inactivo" ? " dadas de baja" : ""}`}
                  {vehiculos.length>vehiculosVista.length
                    ? ` · ${vehiculos.length - vehiculosVista.length} ocultada${vehiculos.length-vehiculosVista.length===1?"":"s"} por los filtros`
                    : ""}
                  {ordenFlota==="accion" ? " · ordenadas por lo que requiere atención primero" : ""}
                </div>
              </div>
            )}
          </>
        )}

        {/* TAB: RESUMEN */}
        {tab === "resumen" && (
          <>
            <ResumenFlotilla
              vehiculos={vehiculos}
              registros={registros}
              gold={gold}
              fontSans={fontSans}
              fontSerif={fontSerif}
              isMobile={isMobile}
            />
          </>
        )}

        {/* TAB: HISTORIAL */}
        {tab === "historial" && (
          <HistorialFlotilla
            registros={registros}
            vehiculos={vehiculos}
            filtro={filtroHistorial}
            setFiltro={setFiltroHistorial}
            gold={gold}
            fontSans={fontSans}
            fontSerif={fontSerif}
            isMobile={isMobile}
            viajeSenalado={foco && foco.foco === "viaje" ? foco.id : null}
            movimientoSenalado={foco && foco.foco === "movimiento" ? foco.id : null}
          />
        )}

        {/* TAB: ACCIDENTES REGISTRADOS (por trabajadores, vía portal del trabajador) */}
        {tab === "accidentes" && (
          <div>
            <div style={{marginBottom:14}}>
              <h3 style={{fontFamily:fontSerif, fontSize:isMobile?17:19, color:T_LIGHT.textInk, margin:"0 0 4px", fontWeight:700}}>Accidentes registrados</h3>
              <p style={{fontSize:12.5, color:T_LIGHT.textInkSoft, margin:0, lineHeight:1.5}}>Constancias de accidentes que tus trabajadores registraron desde su portal. Toca una para ver todo el detalle y las fotos.</p>
            </div>
            {(()=>{
              const nCanc = accidentes.filter((a:any)=> estadoAtencionAccidente(a) === "cancelado").length;
              if (!nCanc && accVista === "vigentes") return null;
              return (
                <div style={{display:"inline-flex", gap:6, marginBottom:12}}>
                  {([["vigentes", "Vigentes (" + (accidentes.length - nCanc) + ")"], ["cancelados", "Cancelados (" + nCanc + ")"]] as const).map(([v, l])=>(
                    <button key={v} onClick={()=>setAccVista(v)}
                      style={{padding:"6px 12px", borderRadius:999, fontSize:12, fontWeight:700, cursor:"pointer", fontFamily:fontSans,
                        border:`1px solid ${accVista===v ? "#236478" : T_LIGHT.borderCard}`, background: accVista===v ? "rgba(35,100,120,0.10)" : "transparent", color: accVista===v ? "#236478" : T_LIGHT.textInkSoft}}>{l}</button>
                  ))}
                </div>
              );
            })()}
            {accidentes.filter((a:any)=> (estadoAtencionAccidente(a) === "cancelado") === (accVista === "cancelados")).length === 0 && accidentes.length > 0 ? (
              <div style={{background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:14, padding:"20px 22px", textAlign:"center" as const, fontSize:13, color:T_LIGHT.textInkSoft}}>
                {accVista === "cancelados" ? "No hay accidentes cancelados." : "Todos los accidentes registrados están cancelados."}
              </div>
            ) : accidentes.length === 0 ? (
              <div style={{background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:14, padding:"28px 22px", textAlign:"center" as const, fontSize:13, color:T_LIGHT.textInkSoft, boxShadow:T_LIGHT.shadow}}>
                Aún no hay accidentes registrados por tus trabajadores.
              </div>
            ) : (
              <div style={{display:"flex", flexDirection:"column" as const, gap:10}}>
                {accidentes.filter((a:any)=> (estadoAtencionAccidente(a) === "cancelado") === (accVista === "cancelados")).map((a:any) => {
                  const abierto = accExpandido === a.id;
                  const cuandoHechos = (a.fechaHechos||a.horaHechos) ? `${a.fechaHechos||""}${a.horaHechos?` · ${a.horaHechos}`:""}`.trim() : null;
                  return (
                    <div key={a.id} ref={a.id === _resAccId ? _resAcc.ref : undefined}
                      style={{...estiloResaltado(a.id === _resAccId && _resAcc.vivo), background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderLeft:"4px solid #E24B4A", borderRadius:14, boxShadow:T_LIGHT.shadow, overflow:"hidden"}}>
                      {/* Encabezado tocable */}
                      <button onClick={()=>setAccExpandido(abierto?null:a.id)}
                        style={{display:"flex", alignItems:"flex-start", gap:12, width:"100%", textAlign:"left" as const, cursor:"pointer", fontFamily:fontSans, background:"transparent", border:"none", padding:isMobile?"13px 14px":"15px 18px"}}>
                        <span style={{color:"#E24B4A", flexShrink:0, marginTop:2, display:"inline-flex"}}>{ICON_ALR}</span>
                        <div style={{flex:1, minWidth:0}}>
                          <div style={{fontSize:13.5, fontWeight:700, color:T_LIGHT.textInk, lineHeight:1.3}}>{a.trabajadorNombre || a.trabajadorEmail || "Trabajador"}</div>
                          {/* "Atendido el … por …" o "Cancelado …": la etiqueta del estado. */}
                          {!!textoEstadoAtencion(a) && (
                            <div style={{fontSize:11.5, fontWeight:700, marginTop:3, color: estadoAtencionAccidente(a) === "cancelado" ? "#B3261E" : "#047857"}}>{textoEstadoAtencion(a)}</div>
                          )}
                          <div style={{fontSize:11.5, color:T_LIGHT.textInkMut, marginTop:2}}>
                            {cuandoHechos ? `Hechos: ${cuandoHechos}` : (a.fecha ? `Registrado: ${a.fecha}${a.hora?` ${a.hora}`:""}` : "")}
                            {a.lugarHechos ? ` · ${a.lugarHechos}` : ""}
                          </div>
                          <div style={{fontSize:12.5, color:T_LIGHT.textInkSoft, marginTop:4, lineHeight:1.45, ...(abierto?{}:{display:"-webkit-box", WebkitLineClamp:2, WebkitBoxOrient:"vertical" as any, overflow:"hidden"})}}>{resumenDeAccidente(a)}</div>
                        </div>
                        <span style={{fontSize:12, fontWeight:700, color:"#E24B4A", flexShrink:0, whiteSpace:"nowrap" as const}}>{abierto?"Cerrar ▲":"Ver detalle ▼"}</span>
                      </button>

                      {/* Detalle expandible */}
                      {abierto && (
                        <div style={{padding:isMobile?"0 14px 14px":"0 18px 18px", borderTop:`1px solid ${T_LIGHT.border}`}}>
                          {/* EL MISMO DETALLE QUE EL MÓVIL, con las mismas etiquetas y sin
                              campos vacíos: ver `detalleDeAccidente`. */}
                          {detalleDeAccidente(a).map((s) => (
                            <div key={s.titulo} style={{marginTop:14}}>
                              <div style={{fontSize:11, fontWeight:700, color:T_LIGHT.textInkMut, textTransform:"uppercase" as const, letterSpacing:"0.5px", marginBottom:6}}>{s.titulo}</div>
                              <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr":"1fr 1fr", gap:"6px 18px"}}>
                                {s.filas.map(([l,v]) => (
                                  <div key={l} style={{fontSize:12.5, lineHeight:1.45, ...(l === "Relato del trabajador" ? {gridColumn:"1 / -1", whiteSpace:"pre-wrap" as const} : {})}}>
                                    <span style={{color:T_LIGHT.textInkMut}}>{l}: </span>
                                    <span style={{color:T_LIGHT.textInk, fontWeight:600}}>{v}</span>
                                  </div>
                                ))}
                              </div>
                            </div>
                          ))}

                          {/* LA ATENCIÓN DEL PATRÓN: atender, reabrir o cancelar, con su historial. */}
                          <AtencionDeAccidente accidente={a} tema="claro" fontSans={fontSans}
                            usuario={{email: String(user?.email || ""), nombre: String(user?.displayName || "")}}
                            onCambio={(nuevo:any)=> setAccidentes((prev:any[])=> prev.map((x:any)=> x.id === nuevo.id ? nuevo : x))}/>

                          {/* Ubicación GPS → Google Maps */}
                          {(typeof a.lat === "number" && typeof a.lng === "number") && (
                            <div style={{marginTop:12}}>
                              <a href={`https://www.google.com/maps?q=${a.lat},${a.lng}`} target="_blank" rel="noreferrer"
                                style={{display:"inline-flex", alignItems:"center", gap:6, fontSize:12, fontWeight:700, color:"#236478", textDecoration:"none", background:"rgba(35,100,120,0.08)", border:"1px solid rgba(35,100,120,0.25)", borderRadius:8, padding:"7px 12px"}}>
                                📍 Ver ubicación en Google Maps
                              </a>
                            </div>
                          )}

                          {/* Fotos */}
                          {/* MISMA tira y MISMO visor que la bitácora: las fotos de un
                              accidente no son otra clase de foto. Se tolera la forma
                              plana —un string suelto— por si algún registro viejo
                              llegara así, igual que hace `fotosDeMovimiento`. */}
                          {((Array.isArray(a.fotos) && a.fotos.length>0) || !!a.video) && (
                            <TiraMiniaturas
                              titulo={(a.fotos||[]).length===1 && !a.video ? "Foto del accidente" : "Del accidente"}
                              imagenes={[
                                ...(Array.isArray(a.fotos) ? a.fotos : []).map((u:any, i:number)=>({url: typeof u === "string" ? u : (u && u.url), titulo:`Foto ${i+1} del accidente`, tipo:"imagen" as const})).filter((x:any)=>!!x.url),
                                ...(a.video ? [{url:a.video, titulo:"Video del accidente", tipo:"video" as const}] : []),
                              ]}/>
                          )}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}

        {/* ── MATERIAL DE CONSULTA ── un estante SUBORDINADO a la tabla, no
             cuatro alertas. Misma vestidura para las cuatro: se distinguen por
             icono y texto, nunca por color de fondo. Rojo, ámbar y verde quedan
             reservados al estado documental. */}
        <div style={{marginTop:26, marginBottom:10}}>
          <div style={{fontSize:UI.fsRotulo, color:UI.textoTenue, textTransform:"uppercase" as const, letterSpacing:"1px", fontWeight:700}}>Material de consulta</div>
          <div style={{fontSize:UI.fsEtiqueta, color:UI.textoTenue, marginTop:2}}>Guías y fundamento legal. Nada de esto cambia el estado de tus unidades.</div>
        </div>
          {/* ¿Cómo funciona? */}
          <SeccionColapsableFlotilla
            titulo="¿Cómo funciona Control de Flotilla?"
            abierta={showComoFunciona}
            onToggle={() => setShowComoFunciona(!showComoFunciona)}
            gold={gold}
            fontSans={fontSans}
            variant="info"
          >
            <ol style={{margin:0, paddingLeft:18, fontSize:13, lineHeight:1.8, color:T_LIGHT.textInk}}>
              <li><strong style={{color:UI.texto}}>Registra tus vehículos</strong> con placas, marca, modelo y las tres fechas que se monitorean: verificación, seguro y tarjeta de circulación.</li>
              <li><strong style={{color:UI.texto}}>Tu equipo registra desde su celular.</strong> Cada trabajador entra con su cuenta de AXIS —sin instalar nada— y registra salidas y regresos. Cada registro queda con fecha, hora y quién lo capturó, para que puedas consultarlo y presentarlo si lo necesitas.</li>
              <li><strong style={{color:UI.texto}}>Monitorea los documentos</strong> de cada unidad. Desde 30 días antes del vencimiento, el documento se marca como “por vencer” en esta tabla y aparece en tu campana de avisos, para que tengas tiempo de renovar.</li>
              <li><strong style={{color:UI.texto}}>Da de baja vehículos</strong> que ya no operan (vendidos, siniestros, etc.). Quedan en el historial y dejan de contar en los indicadores de unidades activas.</li>
            </ol>
          </SeccionColapsableFlotilla>

        {/* Protocolo en caso de accidente */}
        <div style={{marginTop:24}}>
          <SeccionColapsableFlotilla
            titulo="Protocolo legal en caso de accidente"
            abierta={showProtocoloAccidente}
            onToggle={() => setShowProtocoloAccidente(!showProtocoloAccidente)}
            gold={gold}
            fontSans={fontSans}
            variant="warning"
          >
            <p style={{fontSize:12, color:T_LIGHT.textInkSoft, margin:"0 0 14px", fontStyle:"italic" as const}}>
              Si uno de tus vehículos tiene un accidente, sigue estos pasos en orden. Como cliente AXIS tienes asesoría sin costo inmediata.
            </p>
            <ol style={{margin:0, paddingLeft:18, fontSize:13, lineHeight:1.8, color:T_LIGHT.textInk}}>
              <li><strong style={{color:UI.texto}}>Activa tu seguro inmediatamente.</strong> No esperes a la mañana siguiente — la oportunidad probatoria se pierde rápido.</li>
              <li><strong style={{color:UI.texto}}>NO admitas responsabilidad.</strong> Aunque parezca evidente. Tu seguro y tu abogado son quienes evalúan la situación.</li>
              <li><strong style={{color:UI.texto}}>Documenta todo con fotos y video.</strong> Vehículos, placas, daños, vialidad, semáforos, testigos. Desde el primer minuto.</li>
              <li><strong style={{color:UI.texto}}>Si hay lesionados, llama al 911 y al ajustador en ese orden.</strong></li>
              <li><strong style={{color:UI.texto}}>Identifica a TODOS los involucrados y testigos.</strong> Nombre, teléfono, placas, aseguradora, número de póliza.</li>
              <li><strong style={{color:UI.texto}}>Reporta al IMSS y STPS en 72 horas</strong> si el conductor estaba en horario laboral (Art. 504 LFT).</li>
              <li><strong style={{color:UI.texto}}>Conserva las copias de la patrulla.</strong> NO firmes nada hasta consultarnos. Pide copia de cualquier documento.</li>
              <li><strong style={{color:UI.texto}}>Si el conductor estaba alcoholizado o bajo efectos de sustancias,</strong> contacta a AXIS ANTES de declarar — hay implicaciones penales y de seguro distintas.</li>
            </ol>
            <button onClick={() => window.open("https://wa.me/524494251128?text=Hola%20AXIS%2C%20tuve%20un%20accidente%20vehicular%20y%20necesito%20asesor%C3%ADa%20urgente","_blank")}
              style={{background:gold, border:"none", color:"#0B1829", borderRadius:10,
                padding:"10px 18px", cursor:"pointer", fontSize:13, fontWeight:700,
                fontFamily:fontSans, marginTop:16, display:"flex", alignItems:"center", gap:6}}>
              🚨 Asesoría inmediata por WhatsApp →
            </button>
          </SeccionColapsableFlotilla>
        </div>

        {/* Multas: cuándo impugnar */}
        <div style={{marginTop:8}}>
          <SeccionColapsableFlotilla
            titulo="Multas de tránsito: cuándo conviene impugnar"
            abierta={showMultas}
            onToggle={() => setShowMultas(!showMultas)}
            gold={gold}
            fontSans={fontSans}
            variant="info"
          >
            <p style={{fontSize:12, color:T_LIGHT.textInkSoft, margin:"0 0 14px", fontStyle:"italic" as const}}>
              No todas las multas proceden. Muchas tienen errores o vicios que permiten impugnarlas con éxito — pero los plazos son cortos. Antes de pagar, evalúa si conviene.
            </p>

            <div style={{fontSize:UI.fsCuerpo, color:UI.textoSuave, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"0.5px", marginBottom:8}}>Cuándo SÍ conviene impugnar</div>
            <ul style={{margin:"0 0 16px", paddingLeft:18, fontSize:13, lineHeight:1.8, color:T_LIGHT.textInk}}>
              <li><strong style={{color:UI.texto}}>Datos incorrectos</strong> en la boleta: placa, marca, color o fecha que no corresponden a tu vehículo.</li>
              <li><strong style={{color:UI.texto}}>Falta de fundamentación y motivación</strong>: no cita el artículo infringido o no describe con claridad la conducta.</li>
              <li><strong style={{color:UI.texto}}>El agente no se identificó</strong> o actuó sin facultades para sancionar.</li>
              <li><strong style={{color:UI.texto}}>Señalización inexistente, oculta o contradictoria</strong> en el lugar de la supuesta infracción.</li>
              <li><strong style={{color:UI.texto}}>Doble sanción</strong> por el mismo hecho.</li>
              <li><strong style={{color:UI.texto}}>Vicios en el procedimiento</strong>: no te entregaron copia, sanción "a distancia" sin sustento, etc.</li>
            </ul>

            <div style={{fontSize:UI.fsCuerpo, color:UI.textoSuave, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"0.5px", marginBottom:8}}>Cuándo normalmente NO conviene</div>
            <ul style={{margin:"0 0 16px", paddingLeft:18, fontSize:13, lineHeight:1.8, color:T_LIGHT.textInk}}>
              <li>La infracción es clara y está correctamente fundada.</li>
              <li>El monto es bajo y el tiempo/costo de impugnar supera el beneficio.</li>
              <li>Hay descuento por pronto pago que conviene aprovechar.</li>
            </ul>

            <div style={{fontSize:UI.fsCuerpo, color:UI.textoSuave, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"0.5px", marginBottom:8}}>Si decides impugnar</div>
            <ol style={{margin:0, paddingLeft:18, fontSize:13, lineHeight:1.8, color:T_LIGHT.textInk}}>
              <li><strong style={{color:UI.texto}}>Actúa rápido.</strong> Los plazos son cortos (con frecuencia 15 días hábiles). Revisa la fecha en tu boleta.</li>
              <li><strong style={{color:UI.texto}}>Documenta todo:</strong> fotos del lugar y la señalización, la boleta completa, testigos.</li>
              <li><strong style={{color:UI.texto}}>No pagues antes de impugnar.</strong> El pago suele tomarse como aceptación de la infracción.</li>
              <li><strong style={{color:UI.texto}}>Vía administrativa primero</strong> (recurso de revisión); si se niega, juicio de nulidad ante el Tribunal de lo Contencioso Administrativo del Estado.</li>
            </ol>

            <p style={{fontSize:11, color:T_LIGHT.textInkSoft, margin:"16px 0 0", lineHeight:1.6}}>
              Esta es información general orientativa. Cada multa es un caso particular y los plazos varían según el ordenamiento aplicable. Como cliente AXIS, revisamos tu boleta sin costo y te decimos si conviene impugnar.
            </p>

            <button onClick={() => window.open("https://wa.me/524494251128?text=Hola%20AXIS%2C%20tengo%20una%20multa%20de%20tr%C3%A1nsito%20y%20quiero%20saber%20si%20conviene%20impugnarla","_blank")}
              style={{background:gold, border:"none", color:"#0B1829", borderRadius:10, padding:"10px 18px", cursor:"pointer", fontSize:13, fontWeight:700, fontFamily:fontSans, marginTop:16, display:"flex", alignItems:"center", gap:6}}>
              Consultar una multa con AXIS →
            </button>
          </SeccionColapsableFlotilla>
        </div>

        {/* Marco Legal del Patrón (existente) */}
        <div style={{marginTop:8}}>
          <MarcoLegalFlotilla gold={gold} fontSerif={fontSerif} fontSans={fontSans} />
        </div>

      </div>

      {/* MODALES */}
      {/* Los DOS importadores son los mismos componentes que usa Empleados: aquí
          solo cambian el esquema, la firma de duplicado y el guardado. */}
      {verImportarVeh && (
        <ImportadorLote
          titulo="Importar unidades"
          campos={camposImportVehiculo}
          existentes={vehiculos}
          firmaFila={firmaVehiculo}
          entidad={{singular:"unidad", plural:"unidades"}}
          notaSuperior="Se detectan duplicados por PLACA. Las fechas de verificación, seguro y tarjeta de circulación son las que disparan los avisos de vencimiento; puedes dejarlas vacías y capturarlas después."
          onGuardarFila={guardarVehiculoImportado}
          onTerminar={()=>{ setVerImportarVeh(false); cargarTodo(); }}
          onCerrar={()=>setVerImportarVeh(false)}
          fontSans={fontSans} fontSerif={fontSerif} gold={gold}
        />
      )}
      {verImportarVehIA && (
        <ImportadorIADocumento
          titulo="Importar unidades"
          campos={camposImportVehiculo}
          existentes={vehiculos}
          firmaFila={firmaVehiculo}
          entidad={{singular:"unidad", plural:"unidades"}}
          onGuardarFila={guardarVehiculoImportado}
          onTerminar={()=>{ setVerImportarVehIA(false); cargarTodo(); }}
          onCerrar={()=>setVerImportarVehIA(false)}
          fontSans={fontSans} fontSerif={fontSerif} gold={gold}
        />
      )}
      {showFormVehiculo && (
        <FormVehiculo
          onClose={() => { setShowFormVehiculo(false); cargarTodo(); }}
          fontSans={fontSans} fontSerif={fontSerif} gold={gold}
          userId={user?.uid || ""}
        />
      )}
      

      {showModalBaja && (
        <ModalBajaVehiculo
          vehiculo={showModalBaja}
          onClose={() => setShowModalBaja(null)}
          onConfirmar={confirmarBaja}
          gold={gold}
          fontSans={fontSans}
          fontSerif={fontSerif}
        />
      )}
    </div>
  );
}

// #endregion
// ─── FORM AGREGAR VEHÍCULO ────────────────────────────────────────────────────
function FormVehiculo({onClose, fontSans, fontSerif, gold, userId}: {onClose:()=>void; fontSans:string; fontSerif:string; gold:string; userId:string}) {
  const [placa, setPlaca] = useState("");
  const [marca, setMarca] = useState("");
  const [modelo, setModelo] = useState("");
  const [anio, setAnio] = useState("");
  const [color, setColor] = useState("");
  const [numeroEconomico, setNumeroEconomico] = useState("");
  const [numeroSerie, setNumeroSerie] = useState("");
  const [kilometraje, setKilometraje] = useState("");
  const [conductorAsignadoNombre, setConductorAsignadoNombre] = useState("");
  // Los mismos tres datos del seguro que la edición del expediente: sin ellos, la
  // pantalla del accidente no puede ofrecer "Llamar a la aseguradora".
  const [aseguradora, setAseguradora] = useState("");
  const [telefonoSiniestros, setTelefonoSiniestros] = useState("");
  const [numeroPoliza, setNumeroPoliza] = useState("");
  const [docs, setDocs] = useState<any>({});
  const [guardando, setGuardando] = useState(false);

  const guardar = async () => {
    if (!placa) return;
    if (!userId) { alert("Necesitas estar autenticado para guardar un vehículo."); return; }
    setGuardando(true);
    try {
      await addDoc(collection(db, "vehiculos"), {
        userId,                              // SEGURIDAD: ata el vehículo al usuario que lo crea.
        placa: placa.toUpperCase(),
        marca: marca || null,
        modelo: modelo || null,
        anio: anio ? parseInt(anio) : null,
        color: color || null,
        numeroEconomico: numeroEconomico || null,
        numeroSerie: numeroSerie || null,
        kilometraje: kilometraje ? parseInt(kilometraje) : null,
        conductorAsignadoNombre: conductorAsignadoNombre || null,
        aseguradora: aseguradora.trim() || null,
        telefonoSiniestros: telefonoSiniestros.trim() || null,
        numeroPoliza: numeroPoliza.trim() || null,
        status: "activo",
        ...docs,
        timestamp: Timestamp.now(),
      });
      onClose();
      avisarCambioDeAtencion();   // unidad nueva: sus vigencias entran en la lista
    } catch(e) { console.error(e); alert("Error al guardar el vehículo"); }
    finally { setGuardando(false); }
  };

  const labelStyle = {fontSize:10, color:"#6B7280", display:"block" as const, marginBottom:5, textTransform:"uppercase" as const, letterSpacing:"0.5px", fontWeight:600 as const};
  const inputStyle = {width:"100%", padding:"10px 12px", border:"1px solid rgba(0,0,0,0.12)", borderRadius:8, fontSize:13, outline:"none", boxSizing:"border-box" as const, fontFamily:fontSans, color:"#0F172A", background:"white"};
  const seccionStyle = {background:"rgba(184,147,42,0.04)", border:"1px solid rgba(184,147,42,0.18)", borderRadius:12, padding:"14px 16px"};
  const seccionTituloStyle = {fontSize:11, fontWeight:700 as const, color:gold, marginBottom:12, textTransform:"uppercase" as const, letterSpacing:"0.5px", display:"flex" as const, alignItems:"center" as const, gap:8};

  return (
    <div style={{position:"fixed" as const, inset:0, background:"rgba(0,0,0,0.55)", backdropFilter:"blur(4px)", zIndex:300, display:"flex", alignItems:"center", justifyContent:"center", padding:16}}>
      <div {...PANEL_DE_CAPTURA} onClick={e=>e.stopPropagation()} style={{background:"white", borderRadius:16, padding:"24px 26px", maxWidth:560, width:"100%", maxHeight:"90vh", overflowY:"auto" as const, fontFamily:fontSans}}>
        <h3 style={{fontFamily:fontSerif, fontSize:20, color:"#0F172A", margin:"0 0 4px", display:"flex", alignItems:"center", gap:10, fontWeight:600}}>
          <AxisIcon name="suite_flotilla" size={22} tone="gold" withBackdrop={false} strokeWidth={2.5}/>
          Agregar vehículo
        </h3>
        <p style={{fontSize:12, color:"#6B7280", margin:"0 0 22px"}}>Solo la placa es obligatoria. Mientras más datos llenes, mejor seguimiento podrás hacer.</p>

        <div style={{display:"flex", flexDirection:"column" as const, gap:16}}>

          {/* Identificación */}
          <div>
            <label style={labelStyle}>Placa *</label>
            <input value={placa} onChange={e=>setPlaca(e.target.value.toUpperCase())} placeholder="Ej. ABC-123-A"
              style={{...inputStyle, fontSize:16, fontWeight:700, letterSpacing:"2px", padding:"12px 14px"}} />
          </div>

          {/* Datos del vehículo */}
          <div style={seccionStyle}>
            <div style={seccionTituloStyle}>
              <AxisIcon name="suite_flotilla" size={12} tone="gold" withBackdrop={false} strokeWidth={3}/>
              Datos del vehículo
            </div>
            <div style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap:10}}>
              <div>
                <label style={labelStyle}>Marca</label>
                <input value={marca} onChange={e=>setMarca(e.target.value)} placeholder="Ej. Nissan"
                  style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Modelo</label>
                <input value={modelo} onChange={e=>setModelo(e.target.value)} placeholder="Ej. NP300"
                  style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Año</label>
                <input type="number" value={anio} onChange={e=>setAnio(e.target.value)} placeholder="2023" min="1990" max="2030"
                  style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Color</label>
                <input value={color} onChange={e=>setColor(e.target.value)} placeholder="Ej. Blanco"
                  style={inputStyle} />
              </div>
            </div>
          </div>

          {/* Identificadores internos */}
          <div style={seccionStyle}>
            <div style={seccionTituloStyle}>
              <AxisIcon name="clipboard" size={12} tone="gold" withBackdrop={false} strokeWidth={3}/>
              Identificadores internos
            </div>
            <div style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:10}}>
              <div>
                <label style={labelStyle}>Número económico</label>
                <input value={numeroEconomico} onChange={e=>setNumeroEconomico(e.target.value)} placeholder="Ej. 45"
                  style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Kilometraje actual</label>
                <input type="number" value={kilometraje} onChange={e=>setKilometraje(e.target.value)} placeholder="Ej. 45000"
                  style={inputStyle} />
              </div>
            </div>
            <div>
              <label style={labelStyle}>Número de serie (VIN)</label>
              <input value={numeroSerie} onChange={e=>setNumeroSerie(e.target.value)} placeholder="17 caracteres"
                style={{...inputStyle, fontFamily:"monospace", letterSpacing:"1px", fontSize:12}} maxLength={17} />
            </div>
          </div>

          {/* Asignación */}
          <div style={seccionStyle}>
            <div style={seccionTituloStyle}>
              <AxisIcon name="user_single" size={12} tone="gold" withBackdrop={false} strokeWidth={3}/>
              Asignación
            </div>
            <div>
              <label style={labelStyle}>Conductor habitual</label>
              <input value={conductorAsignadoNombre} onChange={e=>setConductorAsignadoNombre(e.target.value)} placeholder="Ej. Juan Pérez"
                style={inputStyle} />
              <p style={{fontSize:10, color:"#9A9AAA", margin:"5px 0 0", lineHeight:1.5, fontStyle:"italic" as const}}>
                Puedes dejarlo vacío si el vehículo no tiene un conductor fijo.
              </p>
            </div>
          </div>

          {/* Seguro: a quién llamar si hay un accidente */}
          <div style={seccionStyle}>
            <div style={seccionTituloStyle}>
              <AxisIcon name="document" size={12} tone="gold" withBackdrop={false} strokeWidth={3}/>
              Seguro
            </div>
            <div style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap:12}}>
              <div>
                <label style={labelStyle}>Aseguradora</label>
                <input value={aseguradora} onChange={e=>setAseguradora(e.target.value)} placeholder="Ej. Qualitas" style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Teléfono de siniestros</label>
                <input type="tel" value={telefonoSiniestros} onChange={e=>setTelefonoSiniestros(e.target.value)} placeholder="El que viene en la póliza" style={inputStyle} />
              </div>
              <div style={{gridColumn:"span 2"}}>
                <label style={labelStyle}>Número de póliza</label>
                <input value={numeroPoliza} onChange={e=>setNumeroPoliza(e.target.value)} style={inputStyle} />
              </div>
            </div>
            <p style={{fontSize:10, color:"#9A9AAA", margin:"5px 0 0", lineHeight:1.5, fontStyle:"italic" as const}}>
              Si hay un accidente, tu trabajador verá un botón para llamar a este número desde la pantalla del accidente.
            </p>
          </div>

          {/* Documentación */}
          <div style={seccionStyle}>
            <div style={seccionTituloStyle}>
              <AxisIcon name="document" size={12} tone="gold" withBackdrop={false} strokeWidth={3}/>
              ¿Hasta cuándo vale cada documento?
            </div>
            {/* CADA ETIQUETA DICE QUÉ FECHA SE PIDE, y no el nombre del documento a
                secas. "Verificación vehicular" encima de un calendario no dice si es
                la de expedición, la del trámite o la del vencimiento; la primera
                clienta puso fechas al azar y la plataforma se puso a decirle cuándo
                vencía su seguro. Eso es afirmar algo que nadie le dijo.
                Lo que se guarda es el VENCIMIENTO, así que la etiqueta lo dice. */}
            <p style={{fontSize:11.5, color:"#4A4A60", margin:"0 0 10px", lineHeight:1.6}}>
              Escribe el <strong>último día en que cada documento sigue siendo válido</strong> —la
              fecha que viene impresa en él—. <strong>Si no la tienes a la mano, déjala vacía:</strong>{" "}
              es mejor que una fecha inventada. Un vehículo sin fecha capturada no cuenta como
              vehículo en falta; simplemente no decimos nada de ese documento hasta que la captures.
            </p>
            <div style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap:10}}>
              {[
                {label:"La verificación vence el", key:"venceVerificacion"},
                {label:"El seguro vence el", key:"venceSeguro"},
                {label:"La tarjeta de circulación vence el", key:"venceTarjeta"},
              ].map(d => (
                <div key={d.key}>
                  <label style={labelStyle}>{d.label} <span style={{fontWeight:500, opacity:0.7}}>(opcional)</span></label>
                  <input type="date" onChange={e=>setDocs((p: any)=>({...p,[d.key]:e.target.value}))}
                    style={inputStyle} />
                </div>
              ))}
            </div>
            <p style={{fontSize:11, color:"#6B7280", margin:"10px 0 0", lineHeight:1.6}}>
              Estos tres documentos son los que AXIS monitorea: son los que se te piden en un
              operativo. La tenencia NO entra al estado documental, porque la federal se abolió
              en 2012 y cada estado decide si la cobra, la subsidia o la exenta: avisarte de algo
              que quizá no aplique en tu estado sería una alerta falsa.
              Recibirás alertas cuando tus documentos estén próximos a vencer. Como cliente AXIS, asesoría sin costo en multas por documentación.
            </p>
          </div>

        </div>

        <div style={{display:"flex", gap:10, marginTop:22}}>
          <button onClick={(ev)=>{ if (sePuedeCerrarElPanel(ev)) onClose(); }} style={{flex:1, background:"rgba(0,0,0,0.05)", border:"none", borderRadius:10, padding:"12px", cursor:"pointer", fontSize:13, fontWeight:600, color:"#4A4A60", fontFamily:fontSans}}>Cancelar</button>
          <button onClick={guardar} disabled={!placa||guardando}
            style={{flex:2, background:placa?`linear-gradient(135deg,${gold},#A07C30)`:"rgba(0,0,0,0.08)", border:"none", borderRadius:10, padding:"12px", cursor:placa?"pointer":"not-allowed", fontSize:13, fontWeight:700, color:placa?"#0A0A0A":"#9A9AAA", fontFamily:fontSans, display:"flex", alignItems:"center", justifyContent:"center", gap:6}}>
            {guardando?"Guardando...":(<><AxisIcon name="check" size={14} color={placa?"#0A0A0A":"#9A9AAA"} withBackdrop={false} strokeWidth={3}/> Guardar vehículo</>)}
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── FORMULARIO FLOTILLA ──────────────────────────────────────────────────────
function FlotillaForm({tipo, user, onBack, fontSans, fontSerif, gold, vehiculos}: {tipo:"salida"|"regreso"; user:any; onBack:()=>void; fontSans:string; fontSerif:string; gold:string; vehiculos?:any[]}) {
  const [placa, setPlaca] = useState("");
  const [km, setKm] = useState("");
  const [destino, setDestino] = useState("");
  const [conductor, setConductor] = useState(user?.email?.split("@")[0]||"");
  const [obs, setObs] = useState("");
  const [estado, setEstado] = useState<"normal"|"revision"|"incidente">("normal");
  const [docsVencimiento, setDocsVencimiento] = useState<any>({});
  const [salidaRef, setSalidaRef] = useState<RegistroFlotilla|null>(null);
  const [buscandoSalida, setBuscandoSalida] = useState(false);
  const [guardando, setGuardando] = useState(false);
  const [exito, setExito] = useState(false);
  const [err, setErr] = useState("");
  const [ubicacion, setUbicacion] = useState<{lat:number; lng:number}|null>(null);
  const [gpsEstado, setGpsEstado] = useState<"idle"|"capturando"|"ok"|"error">("idle");
  const [vehiculoSel, setVehiculoSel] = useState<any|null>(null);
  const [modoLibre, setModoLibre] = useState(false);
  // QUIÉN CONDUJO. Durante mucho tiempo este formulario guardó
  // `conductorEmail: user.email`, o sea: cada movimiento que capturaba el patrón
  // afirmaba que el conductor había sido el patrón. En una bitácora que se puede
  // presentar en una investigación, eso dice que el dueño iba manejando.
  // Ahora el conductor se ELIGE de las cuentas de la empresa —y entonces se
  // guarda SU correo— o se escribe a mano, y entonces el correo va vacío. Vacío
  // es honesto; el correo del patrón es falso.
  // NULL mientras no se hayan leído: ver la nota de useDashboardData.
  const [cuentasTrab, setCuentasTrab] = useState<any[]|null>(null);
  const [conductorCuenta, setConductorCuenta] = useState("");   // correo elegido, "" = nombre libre
  useEffect(() => {
    if (!user?.uid) return;
    let cancel = false;
    (async () => {
      try {
        const snap = await getDocs(query(collection(db,"cuentas_trabajador"), where("empleadorId","==",user.uid)));
        if (!cancel) setCuentasTrab(snap.docs.map(d=>({correo:d.id, ...(d.data() as any)}))
          .sort((a:any,b:any)=>(a.nombre||"").localeCompare(b.nombre||"")));
      } catch(e){ if (!cancel) console.error("cuentas_trabajador (flotilla):", e); }
    })();
    return () => { cancel = true; };
  }, [user?.uid]);
  const isMobile = window.innerWidth < 768;
  const color = tipo==="salida"?"#2563EB":"#059669";
  const vehiculosActivos = (vehiculos||[]).filter((v:any) => (v.status||"activo")==="activo");

  // Capturar ubicación GPS al cargar (el navegador pide permiso)
  useEffect(() => {
    if (!navigator.geolocation) { setGpsEstado("error"); return; }
    setGpsEstado("capturando");
    navigator.geolocation.getCurrentPosition(
      (pos) => { setUbicacion({lat: pos.coords.latitude, lng: pos.coords.longitude}); setGpsEstado("ok"); },
      () => setGpsEstado("error"),
      {enableHighAccuracy: true, timeout: 10000, maximumAge: 60000}
    );
  // eslint-disable-next-line
  }, []);

  // Alerta de docs al escribir placa
  const getAlertasPlaca = (placaBuscar: string) => {
    if (!vehiculos || !placaBuscar) return [];
    const veh = vehiculos.find((v:any) => v.placa === placaBuscar.toUpperCase());
    if (!veh) return [];
    return [
      {key:"venceVerificacion", label:"Verificación"},
      {key:"venceSeguro", label:"Seguro"},
      {key:"venceTarjeta", label:"Tarjeta circ."},
    ].map(d => {
      // Día contra día. Antes se restaba la medianoche UTC del documento del
      // instante actual, y a partir de las 18:00 esta alerta avisaba de un
      // documento vencido que todavía valía ese día.
      const diff = diasHastaFecha(veh[d.key]);
      if (diff === null) return null;
      // Mismo criterio que `estadoDocVehiculo`, que es quien manda sobre estos
      // mismos documentos en el resto de Flotilla: vigente hasta el día impreso
      // inclusive, vencido al día siguiente. Aquí decía lo contrario.
      return diff <= 30 ? {label:d.label, diff, vencido:diff<0} : null;
    }).filter(Boolean) as any[];
  };

  // Al escribir la placa en regreso, buscar salida previa
  // Busca la salida abierta a la que pertenece este regreso, para poder guardar
  // `salidaId` y que el viaje quede identificado al ESCRIBIR, no al leer.
  //
  // Corre por los dos caminos por los que puede quedar determinada la unidad:
  // al elegirla de la lista y al teclear la placa a mano.
  //
  // Dos cuidados que antes no tenía:
  //   · Busca por `vehiculoId` cuando la unidad viene del catálogo. Buscar por
  //     texto de placa fallaba en silencio si la salida se guardó con la placa
  //     escrita de otra forma, y el regreso salía sin enlace.
  //   · Si hay salidas de VARIAS personas para esa unidad —un camión por turnos—
  //     y ninguna es de este conductor, NO enlaza. Colgar el regreso de la salida
  //     de otra persona escribiría una atribución falsa en el registro, que es
  //     justo lo que este campo viene a evitar.
  const _nombreIgual = (a:any, b:any) =>
    String(a||"").normalize("NFD").replace(/[\u0300-\u036f]/g,"").toUpperCase().replace(/\s+/g," ").trim() ===
    String(b||"").normalize("NFD").replace(/[\u0300-\u036f]/g,"").toUpperCase().replace(/\s+/g," ").trim();
  const buscarSalidaPrevia = async (placaBuscar: string, vehId?: string, conductorNombre?: string) => {
    if (tipo !== "regreso") return;
    if (!vehId && String(placaBuscar||"").length < 3) return;
    if (!user?.uid) return;  // SEGURIDAD: no buscar salidas si no hay sesión
    setBuscandoSalida(true);
    try {
      // NO usamos orderBy aquí: multiples where("==") + orderBy en otro campo
      // requiere índice compuesto. Traemos los matches y elegimos en JS.
      const base = [
        where("userId", "==", user.uid),        // SEGURIDAD: solo dentro de mis registros
        where("tipo", "==", "salida"),
      ];
      const q = vehId
        ? query(collection(db, "flotilla"), ...base, where("vehiculoId", "==", vehId))
        : query(collection(db, "flotilla"), ...base, where("placa", "==", String(placaBuscar||"").toUpperCase()));
      const snap = await getDocs(q);
      const docs = snap.docs.map(d => ({id:d.id, ...d.data()} as RegistroFlotilla))
        .sort((a,b) => ((b.timestamp as any)?.seconds || 0) - ((a.timestamp as any)?.seconds || 0));
      if (docs.length === 0) { setSalidaRef(null); return; }
      const quien = conductorNombre !== undefined ? conductorNombre : conductor;
      if (quien && quien.trim()) {
        const suya = docs.find(d => _nombreIgual(d.conductor, quien));
        // Hay salidas de esa unidad, pero ninguna de esta persona: sin enlace.
        setSalidaRef(suya || null);
        return;
      }
      const ultima = docs[0];
      setSalidaRef(ultima);
      if (ultima.conductor) setConductor(ultima.conductor);
    } catch(e) { setSalidaRef(null); }
    finally { setBuscandoSalida(false); }
  };

  const guardar = async () => {
    // El KILOMETRAJE ya no se exige. La app del trabajador lo dejó de pedir y
    // tener el mismo dato gobernado por dos criterios en dos pantallas es
    // exactamente el defecto que se viene corrigiendo: el mismo cliente vería su
    // celular aceptando un registro que su escritorio rechaza.
    if (!placa||!conductor) { setErr("Placa y conductor son obligatorios."); return; }
    setGuardando(true); setErr("");
    try {
      const now = new Date();
      // Un campo vacío se OMITE al escribir. parseInt("") da NaN, y un NaN —o un
      // cero de relleno— sería una lectura de odómetro que nadie tomó.
      const kmNumero = km.trim()==="" ? null : Number(km);
      const kmValido = kmNumero !== null && Number.isFinite(kmNumero);
      const kmRecorridos = tipo==="regreso" && salidaRef?.kmInicial && kmValido
        ? (kmNumero as number) - salidaRef.kmInicial
        : undefined;

      await addDoc(collection(db, "flotilla"), {
        userId: user?.uid || "",                  // SEGURIDAD: estandariza filtro por usuario
        // VÍNCULO CON LA UNIDAD. El selector ya existía y `vehiculoSel` ya tenía la
        // unidad elegida: solo no se guardaba, así que el registro salía como
        // "documentación no verificable" y no se podía cruzar contra las vigencias.
        // Va condicional a propósito: en MODO LIBRE —placa que no está en el
        // catálogo— no hay unidad que referir, y ahí el rescate por placa hace lo
        // que puede. No se cierra esa puerta.
        ...(vehiculoSel?.id ? {vehiculoId: vehiculoSel.id} : {}),
        tipo, placa:placa.toUpperCase(), conductor,
        // Vacío cuando el conductor se escribió a mano: no hay cuenta que citar,
        // y el nombre en texto ya queda en `conductor`.
        conductorEmail: conductorCuenta || "",
        fecha:now.toLocaleDateString("es-MX"),
        hora:now.toLocaleTimeString("es-MX",{hour:"2-digit",minute:"2-digit"}),
        timestamp:Timestamp.now(),
        empresaId:user?.uid||"",                  // legacy — se mantiene por compat con docs anteriores
        // IDENTIDAD del capturista (aquí, el propio patrón): la bitácora es atribuible.
        registradoPorEmail: user?.email || "",
        registradoPorUid: user?.uid || "",
        registradoPorNombre: user?.displayName || user?.email || "Patrón",
        registradoPorRol: "patron",
        observaciones:obs||"",
        ...(ubicacion ? {lat: ubicacion.lat, lng: ubicacion.lng} : {}),
        ...(tipo==="salida"
          ? {...(kmValido ? {kmInicial: kmNumero as number} : {}), destino, ...docsVencimiento}
          : {
              ...(kmValido ? {kmFinal: kmNumero as number} : {}),
              estado,
              ...(salidaRef?.id ? {salidaId:salidaRef.id} : {}),
              ...(kmRecorridos && kmRecorridos > 0 ? {kmRecorridos} : {}),
            }
        ),
      });
      setExito(true);
      setTimeout(onBack, 1800);
    } catch(e) { setErr("Error al guardar. Verifica tu conexión."); }
    finally { setGuardando(false); }
  };

  if (exito) return (
    <div style={{minHeight:"100vh", background:T_LIGHT.canvas, display:"flex", alignItems:"center", justifyContent:"center"}}>
      <div style={{textAlign:"center" as const, padding:40, background:T_LIGHT.cardLight, borderRadius:18, border:`1px solid ${T_LIGHT.borderCard}`, boxShadow:"0 8px 32px rgba(22,36,71,0.12)"}}>
        <div style={{fontSize:56, marginBottom:14}}>✅</div>
        <div style={{fontFamily:fontSerif, fontSize:22, color:T_LIGHT.textInk, marginBottom:6}}>Registro guardado</div>
        <div style={{fontSize:13, color:T_LIGHT.textInkSoft}}>Regresando al historial...</div>
      </div>
    </div>
  );

  return (
    <div {...ZONA_DE_CAPTURA} style={{minHeight:"100vh", background:T_LIGHT.canvas}}>
      <div style={{background:T.navy, padding:"0 20px", height:58, display:"flex", alignItems:"center", gap:12, boxShadow:"0 2px 16px rgba(22,36,71,0.12)", borderBottom:"1px solid rgba(184,147,42,0.24)"}}>
        <button onClick={onBack} style={{background:"rgba(255,255,255,0.08)", border:"1px solid rgba(255,255,255,0.15)", color:"white", borderRadius:8, padding:"5px 10px", cursor:"pointer", fontSize:12}}>← Historial</button>
        <span style={{color:"white", fontWeight:600, fontSize:14, display:"flex", alignItems:"center", gap:6}}>
          <AxisIcon name={tipo==="salida"?"arrow_out":"arrow_in"} size={14} tone="white" withBackdrop={false} strokeWidth={3}/>
          {tipo==="salida"?"Registrar Salida":"Registrar Regreso"}
        </span>
      </div>
      <div style={{padding:isMobile?16:24, maxWidth:520, margin:"0 auto"}}>
        <div style={{background:"white", borderRadius:16, padding:isMobile?"20px":"28px 32px", boxShadow:"0 2px 16px rgba(0,0,0,0.06)", border:`1px solid ${T_LIGHT.borderCard}`, borderTop:`4px solid ${color}`}}>
          <div style={{display:"flex", flexDirection:"column" as const, gap:16}}>
            {/* Indicador de ubicación GPS */}
            <div style={{display:"flex", alignItems:"center", gap:8, padding:"10px 12px", borderRadius:10, fontSize:12,
              background: gpsEstado==="ok" ? "rgba(29,158,117,0.08)" : gpsEstado==="error" ? "rgba(226,75,74,0.06)" : "rgba(0,0,0,0.03)",
              border: gpsEstado==="ok" ? "1px solid rgba(29,158,117,0.25)" : gpsEstado==="error" ? "1px solid rgba(226,75,74,0.2)" : "1px solid rgba(0,0,0,0.08)",
              color: gpsEstado==="ok" ? "#0F6E56" : gpsEstado==="error" ? "#A32D2D" : "#6B7280"}}>
              <AxisIcon name="pin" size={14} color={gpsEstado==="ok" ? "#0F6E56" : gpsEstado==="error" ? "#A32D2D" : "#6B7280"} withBackdrop={false} strokeWidth={2.5}/>
              <span>
                {gpsEstado==="capturando" && "Capturando tu ubicación..."}
                {gpsEstado==="ok" && "Ubicación capturada — quedará registrada con este movimiento"}
                {gpsEstado==="error" && "Sin ubicación (el registro se guardará de todos modos)"}
                {gpsEstado==="idle" && "Preparando ubicación..."}
              </span>
            </div>
            <div>
              <label style={{fontSize:10, color:"#9A9AAA", display:"block", marginBottom:5, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>Vehículo *</label>
              {vehiculosActivos.length === 0 || modoLibre ? (
                <>
                  <input value={placa} onChange={e=>{ setPlaca(e.target.value.toUpperCase()); buscarSalidaPrevia(e.target.value, undefined, conductor); }} placeholder="Ej. ABC-123-A" type="text"
                    style={{width:"100%", padding:"12px 14px", border:"1px solid rgba(0,0,0,0.12)", borderRadius:10, fontSize:14, outline:"none", boxSizing:"border-box" as const, letterSpacing:"2px", fontWeight:700, textTransform:"uppercase" as const}} />
                  {vehiculosActivos.length > 0 && (
                    <button onClick={()=>{setModoLibre(false); setPlaca(""); setVehiculoSel(null);}} style={{marginTop:8, background:"none", border:"none", color:"#2563EB", fontSize:12, cursor:"pointer", textDecoration:"underline", padding:0, fontFamily:fontSans}}>← Elegir de la lista de vehículos</button>
                  )}
                </>
              ) : (
                <div style={{display:"flex", flexDirection:"column" as const, gap:8}}>
                  {vehiculosActivos.map((v:any) => {
                    const sel = vehiculoSel?.id === v.id;
                    return (
                      <div key={v.id} onClick={()=>{ setVehiculoSel(v); setPlaca(v.placa); const quien = conductor || v.conductorAsignadoNombre || ""; if(!conductor && v.conductorAsignadoNombre) setConductor(v.conductorAsignadoNombre); buscarSalidaPrevia(v.placa, v.id, quien); }} style={{
                        display:"flex", alignItems:"center", gap:12, padding:"12px 14px", borderRadius:10, cursor:"pointer",
                        border: sel ? `2px solid ${color}` : "1px solid rgba(0,0,0,0.12)",
                        background: sel ? `${color}0D` : "white", transition:"all 0.15s ease",
                      }}>
                        <div style={{width:38, height:38, borderRadius:"50%", background:"rgba(184,147,42,0.1)", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0}}>
                          <AxisIcon name="suite_flotilla" size={18} tone="gold" withBackdrop={false} strokeWidth={2.5}/>
                        </div>
                        <div style={{flex:1, minWidth:0}}>
                          <div style={{fontSize:15, fontWeight:700, color:"#0F172A", letterSpacing:"1px"}}>{v.placa}</div>
                          <div style={{fontSize:12, color:"#6B7280"}}>{[v.marca,v.modelo,v.anio].filter(Boolean).join(" ")||"Sin datos del vehículo"}</div>
                        </div>
                        {sel && <div style={{color, fontSize:18, fontWeight:700}}>✓</div>}
                      </div>
                    );
                  })}
                  <button onClick={()=>{setModoLibre(true); setVehiculoSel(null); setPlaca("");}} style={{marginTop:4, background:"none", border:"1px dashed rgba(0,0,0,0.18)", borderRadius:10, padding:"10px", color:"#6B7280", fontSize:12, cursor:"pointer", fontFamily:fontSans}}>Mi vehículo no está en la lista</button>
                </div>
              )}
            </div>
            {/* CONDUCTOR. Se elige de las cuentas de la empresa siempre que se
                pueda: solo así se puede guardar SU correo en vez de inventar uno.
                El nombre a mano sigue disponible —hay choferes sin cuenta— y en
                ese caso el correo queda vacío, que es la verdad. */}
            <div>
            <label style={{fontSize:10, color:"#9A9AAA", display:"block", marginBottom:5, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>Conductor *</label>
              {(cuentasTrab||[]).length > 0 && (
                <select value={conductorCuenta ? conductorCuenta : (conductor ? "__libre__" : "")}
                  onChange={e=>{
                    const v = e.target.value;
                    if (v === "__libre__") { setConductorCuenta(""); }
                    else if (v === "") { setConductorCuenta(""); setConductor(""); }
                    else {
                      const c = (cuentasTrab||[]).find((x:any)=>x.correo===v);
                      setConductorCuenta(v);
                      const nom = c?.nombre || v;
                      setConductor(nom);
                      // Cambiar de conductor cambia a qué salida pertenece este
                      // regreso: se vuelve a buscar con la persona ya decidida.
                      buscarSalidaPrevia(placa, vehiculoSel?.id, nom);
                    }
                  }}
                  style={{width:"100%", padding:"12px 14px", border:"1px solid rgba(0,0,0,0.12)", borderRadius:10, fontSize:14, outline:"none", boxSizing:"border-box" as const, background:"white", color:"#0F172A", fontFamily:fontSans, marginBottom: conductorCuenta ? 0 : 8}}>
                  <option value="">Selecciona al conductor…</option>
                  {(cuentasTrab||[]).map((c:any)=>(<option key={c.correo} value={c.correo}>{c.nombre || c.correo}</option>))}
                  <option value="__libre__">Otro — escribir el nombre</option>
                </select>
              )}
              {/* SIN NINGUNA CUENTA no hay desplegable, y hasta ahora tampoco
                  explicación: el patrón escribía el nombre a mano sin saber que por
                  eso el movimiento no queda atribuido a nadie. */}
              {cuentasTrab !== null && cuentasTrab.length === 0 && (
                <div style={{fontSize:11.5, color:"#7A5F12", background:"rgba(184,147,42,0.10)", border:"1px solid rgba(184,147,42,0.28)", borderRadius:9, padding:"9px 11px", marginBottom:8, lineHeight:1.55}}>
                  Nadie de tu equipo tiene cuenta todavía, así que el conductor se escribe a mano y el movimiento queda <b>sin correo al que atribuirlo</b>.
                  {" "}El enlace con el trabajador funciona solo mediante su cuenta: con ella, además, es él quien registra sus salidas y regresos desde su teléfono.
                </div>
              )}
              {!conductorCuenta && (
                <input value={conductor} onChange={e=>{ setConductor(e.target.value); }}
                  onBlur={e=>buscarSalidaPrevia(placa, vehiculoSel?.id, e.target.value)}
                  placeholder="Nombre completo" type="text"
                style={{width:"100%", padding:"12px 14px", border:"1px solid rgba(0,0,0,0.12)", borderRadius:10, fontSize:14, outline:"none", boxSizing:"border-box" as const, background:"white", color:"#0F172A", fontFamily:fontSans}} />
              )}
              {conductorCuenta && (
                <div style={{fontSize:11, color:"#6B7280", marginTop:5}}>Se guardará con su correo: {conductorCuenta}</div>
              )}
              {!conductorCuenta && conductor.trim() !== "" && (cuentasTrab||[]).length > 0 && (
                <div style={{fontSize:11, color:"#6B7280", marginTop:5}}>Sin cuenta seleccionada: se guarda el nombre, sin correo.</div>
              )}
            </div>
            {[
              {label:`Kilometraje ${tipo==="salida"?"inicial":"final"} (opcional)`, val:km, set:setKm, ph:"Ej. 45230", type:"number", style:{}},
            ].map(f => (
              <div key={f.label}>
                <label style={{fontSize:10, color:"#9A9AAA", display:"block", marginBottom:5, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>{f.label}</label>
                <input value={f.val} onChange={e=>f.set(e.target.value)} placeholder={f.ph} type={f.type}
                  style={{width:"100%", padding:"12px 14px", border:"1px solid rgba(0,0,0,0.12)", borderRadius:10, fontSize:14, outline:"none", boxSizing:"border-box" as const, ...f.style}} />
              </div>
            ))}
            {tipo==="salida" && (
              <div>
                <label style={{fontSize:10, color:"#9A9AAA", display:"block", marginBottom:5, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>Destino</label>
                <input value={destino} onChange={e=>setDestino(e.target.value)} placeholder="Ej. Cliente Zona Industrial"
                  style={{width:"100%", padding:"12px 14px", border:"1px solid rgba(0,0,0,0.12)", borderRadius:10, fontSize:14, outline:"none", boxSizing:"border-box" as const}} />
              </div>
            )}
            {/* Salida previa detectada */}
            {tipo === "regreso" && salidaRef && (
              <div style={{background:"rgba(37,99,235,0.06)", border:"1px solid rgba(37,99,235,0.2)", borderRadius:10, padding:"12px 14px"}}>
                <div style={{fontSize:10, color:"#2563EB", fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"0.5px", marginBottom:6}}>✓ Salida previa encontrada</div>
                <div style={{fontSize:12, color:"#4A4A60"}}>
                  Salió el <strong>{salidaRef.fecha}</strong> a las <strong>{salidaRef.hora}</strong>
                  {salidaRef.destino && <> · Destino: <strong>{salidaRef.destino}</strong></>}
                  {salidaRef.kmInicial !== undefined && <> · Km inicial: <strong>{salidaRef.kmInicial?.toLocaleString()}</strong></>}
                </div>
              </div>
            )}
            {tipo === "regreso" && buscandoSalida && (
              <div style={{fontSize:12, color:"#9A9AAA", padding:"8px 0"}}>🔍 Buscando salida previa...</div>
            )}

            {/* Estado del vehículo — solo en regreso */}
            {/* Aviso de documentos próximos a vencer al registrar salida */}
            {tipo === "salida" && getAlertasPlaca(placa).length > 0 && (
              <div style={{background:"rgba(220,38,38,0.06)", border:"1px solid rgba(220,38,38,0.2)", borderRadius:10, padding:"12px 14px"}}>
                <div style={{fontSize:11, fontWeight:700, color:"#DC2626", marginBottom:8, display:"flex", alignItems:"center", gap:5}}>
                  <AxisIcon name="alert" size={12} tone="white" withBackdrop={false} strokeWidth={3}/>
                  Este vehículo tiene documentos por atender
                </div>
                {getAlertasPlaca(placa).map((a:any, i:number) => (
                  <div key={i} style={{fontSize:12, color:"#4A4A60", marginBottom:4, display:"flex", alignItems:"center", gap:6}}>
                    {/* Rojo solo lo vencido; el que vence hoy es lo más urgente
                        de lo vigente, en el ámbar más fuerte. */}
                    <span style={{width:7, height:7, borderRadius:"50%", background:a.vencido?"#DC2626":(a.diff<=2?TONE_COLORS.warnFuerte:"#F59E0B"), flexShrink:0}}/>
                    <span><strong>{a.label}:</strong> {a.vencido ? `VENCIDO hace ${Math.abs(a.diff)} día${Math.abs(a.diff)!==1?"s":""}` : textoDePlazo(a.diff)}</span>
                  </div>
                ))}
              </div>
            )}

            {/* Documentos del vehículo — solo en salida */}
            {tipo === "salida" && (
              <div style={{background:"rgba(37,99,235,0.04)", border:"1px solid rgba(37,99,235,0.15)", borderRadius:12, padding:"14px"}}>
                <div style={{fontSize:11, fontWeight:700, color:"#2563EB", marginBottom:6, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>📋 Documentos del vehículo (opcional)</div>
                {/* Mismas etiquetas que el alta: es la misma pregunta y no puede
                    hacerse de dos maneras. Ver el alta para el porqué. */}
                <div style={{fontSize:11, color:"#4A4A60", marginBottom:11, lineHeight:1.55}}>
                  El último día en que cada documento sigue valiendo. Si no la sabes, déjala vacía.
                </div>
                <div style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap:12}}>
                  {[
                    {label:"La verificación vence el", key:"venceVerificacion"},
                    {label:"El seguro vence el", key:"venceSeguro"},
                    {label:"La tarjeta de circulación vence el", key:"venceTarjeta"},
                  ].map(doc => (
                    <div key={doc.key}>
                      <label style={{fontSize:10, color:"#9A9AAA", display:"block", marginBottom:4}}>{doc.label}</label>
                      <input type="date"
                        onChange={e => setDocsVencimiento((prev: any) => ({...prev, [doc.key]: e.target.value}))}
                        style={{width:"100%", padding:"8px 10px", border:"1px solid rgba(0,0,0,0.12)", borderRadius:8, fontSize:12, outline:"none", boxSizing:"border-box" as const}} />
                    </div>
                  ))}
                </div>
              </div>
            )}

            {tipo === "regreso" && (
              <div>
                <label style={{fontSize:10, color:"#9A9AAA", display:"block", marginBottom:8, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>Estado del vehículo al regresar *</label>
                <div style={{display:"flex", gap:8}}>
                  {([
                    {val:"normal", label:"✅ Normal", color:"#059669", bg:"rgba(5,150,105,0.08)", border:"rgba(5,150,105,0.25)"},
                    {val:"revision", label:"⚠️ Requiere revisión", color:"#D97706", bg:"rgba(217,119,6,0.08)", border:"rgba(217,119,6,0.25)"},
                    {val:"incidente", label:"🚨 Incidente", color:"#DC2626", bg:"rgba(220,38,38,0.08)", border:"rgba(220,38,38,0.25)"},
                  ] as const).map(op => (
                    <button key={op.val} type="button" onClick={() => setEstado(op.val)}
                      style={{flex:1, padding:"10px 6px", borderRadius:10, border:`2px solid ${estado===op.val?op.color:op.border}`, background:estado===op.val?op.bg:"white", cursor:"pointer", fontSize:11, fontWeight:600, color:estado===op.val?op.color:"#9A9AAA", transition:"all 0.15s"}}>
                      {op.label}
                    </button>
                  ))}
                </div>
              </div>
            )}

            <div>
              <label style={{fontSize:10, color:"#9A9AAA", display:"block", marginBottom:5, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>Observaciones {estado==="incidente"?"(describe el incidente) *":""}</label>
              <textarea value={obs} onChange={e=>setObs(e.target.value)} rows={3}
                placeholder={estado==="incidente"?"Describe el incidente detalladamente: qué pasó, dónde, cómo...":tipo==="regreso"?"Observaciones, daños menores, situaciones a reportar...":"Observaciones adicionales..."}
                style={{width:"100%", padding:"12px 14px", border:`1px solid ${estado==="incidente"?"rgba(220,38,38,0.3)":"rgba(0,0,0,0.12)"}`, borderRadius:10, fontSize:13, outline:"none", boxSizing:"border-box" as const, resize:"vertical" as const, fontFamily:fontSans}} />
            </div>
            <div style={{background:"#F7F5F0", borderRadius:10, padding:"10px 14px", fontSize:11, color:"#9A9AAA"}}>
              📅 Fecha y hora automáticas: {new Date().toLocaleDateString("es-MX")} · {new Date().toLocaleTimeString("es-MX",{hour:"2-digit",minute:"2-digit"})}
            </div>
            {err && <div style={{background:"rgba(220,38,38,0.08)", border:"1px solid rgba(220,38,38,0.2)", borderRadius:8, padding:"9px 13px", fontSize:12, color:"#DC2626"}}>{err}</div>}
            <button onClick={guardar} disabled={guardando}
              style={{background:`linear-gradient(135deg,${color},${tipo==="salida"?"#1D4ED8":"#047857"})`, border:"none", borderRadius:12, padding:"14px", cursor:guardando?"not-allowed":"pointer", fontSize:14, fontWeight:700, color:"white", opacity:guardando?0.7:1}}>
              {guardando?"Guardando...":tipo==="salida"?"🚀 Confirmar Salida":"🏁 Confirmar Regreso"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}


// #region PANEL ADMIN
// ─── PANEL DE ADMINISTRADOR ───────────────────────────────────────────────────
// ═══ "NO SE PUDO LEER" NO ES "NO HAY" ════════════════════════════════════════
//
// El mismo criterio que la tarjeta del checador, donde ya está escrito: una lista
// en `null` significa "todavía no se ha podido leer", y eso NO se puede pintar
// como "no hay nadie". Ver `hechosDelEquipo`, que se calla en vez de acusar.
//
// Aquí pasaba lo contrario y en las cinco listas de leads: el `catch` escribía en
// la consola —donde no mira nadie— y la pantalla decía "Nadie está esperando
// acceso ahora mismo", idéntico a cuando de verdad no hay nadie. Con eso, un fallo
// de permisos o de red se lee como una buena noticia.
//
// UNA sola pieza para las cinco, y dice tres cosas: qué no se pudo leer, el motivo
// tal como lo devolvió Firestore —sirve para distinguir un permiso de una caída— y
// un botón para volver a intentarlo, porque estas listas se cargan una sola vez al
// abrir el panel.
function CajaNoSePudoLeer({que, detalle, onReintentar}: {que:string; detalle?:string; onReintentar?:()=>void}) {
  return (
    <div style={{textAlign:"center" as const, padding:"30px 24px", background:"rgba(220,38,38,0.04)",
      borderRadius:14, border:"1px solid rgba(220,38,38,0.35)"}}>
      <div style={{marginBottom:10, display:"flex", justifyContent:"center"}}>
        <AxisIcon name="alert" size={28} color="#DC2626" withBackdrop={false} strokeWidth={2.5}/>
      </div>
      <div style={{fontSize:14, color:"#0B1829", fontWeight:700, marginBottom:4}}>
        No se pudo leer {que}
      </div>
      <div style={{fontSize:12.5, color:"#4A4A60", lineHeight:1.6, maxWidth:440, margin:"0 auto"}}>
        Esto NO quiere decir que no haya ninguno: quiere decir que esta pantalla no pudo consultarlos.
        {detalle ? <> El motivo que devolvió la base de datos: <strong style={{color:"#0B1829"}}>{detalle}</strong>.</> : null}
      </div>
      {onReintentar && (
        <button onClick={onReintentar}
          style={{marginTop:14, padding:"8px 16px", background:"#0B1829", border:"none", borderRadius:9,
            color:"white", fontSize:12.5, fontWeight:700, cursor:"pointer", fontFamily:"inherit"}}>
          Reintentar
        </button>
      )}
    </div>
  );
}

// ═══ LA MUDANZA DEL HORARIO GENERAL, CON SU HISTORIAL ════════════════════════
// «Mudar la configuración de las empresas» (panel del admin) copia el horario y el
// centro de trabajo de usuarios/{uid} a configuracion_empresa/{uid}. Con el MODO
// ESTRICTO, el horario no puede entrar sin su entrada de historial en la MISMA
// escritura. Esta función decide qué se escribe, sobre lo que hay en el documento:
//   · ya tiene horario → nada (lo migrado después manda);
//   · no existe → se CREA con el horario y su historial: h0 "desde siempre", con
//     la hora del servidor y firmada por quien migra (el admin);
//   · existe sin horario → se le AÑADEN horario y la siguiente entrada juntos (h0
//     "desde siempre" si no tenía historial);
//   · sin horario que mover → solo el centro de trabajo, como antes.
// El horario se copia con los campos que admite el historial (horarioParaHistorial)
// y su `actualizadoEn`: así lo guardado y su entrada son el mismo horario.
function escrituraMudanzaConfig(o:{existente:any|null; horario:any; ubi:any; correo:string; marca:any; migradoEn:any}): {tipo:"nada"|"set"|"update"; datos?:any} {
  const {existente, horario, ubi} = o;
  if (existente && existente.horarioLaboral) return {tipo:"nada"};
  const comun:any = {...(ubi ? {ubicacionTrabajo: ubi} : {}), migradoDe: "usuarios", migradoEn: o.migradoEn};
  if (!horario) return {tipo: existente ? "update" : "set", datos: comun};
  const limpio:any = Object.assign({}, horarioParaHistorial(horario) || {}, horario.actualizadoEn ? {actualizadoEn: horario.actualizadoEn} : {});
  const clave = siguienteClaveDeHistorial(existente?.historialHorario);
  const entrada = entradaDeHistorial(limpio, o.correo, o.marca, clave === "h0");
  if (!existente) return {tipo: "set", datos: {...comun, horarioLaboral: limpio, historialHorario: {[clave]: entrada}}};
  return {tipo: "update", datos: {...comun, horarioLaboral: limpio, [`historialHorario.${clave}`]: entrada}};
}
function AdminPanel({user, tipoContrato, onBack, fontSans, fontSerif, gold}: {user:any; tipoContrato:string; onBack:()=>void; fontSans:string; fontSerif:string; gold:string}) {
  // SEGURIDAD: guardia hard en el cliente para no exponer el panel ni siquiera
  // a renderizar si el usuario no es admin. La autorización REAL vive en las
  // reglas de Firestore (firestore.rules) — un atacante puede saltar este guard
  // pero NO puede leer las colecciones sin permiso del servidor.
  useEffect(() => {
    if (!esAdmin(user?.email)) { onBack(); }
  }, [user?.email]);

  const isMobile = window.innerWidth < 768;

  // MAESTRO-DETALLE. La lista de cuentas es LIGERA (sale de `usuarios`, ya cargada):
  // no dispara ninguna consulta por fila. El detalle de UNA cuenta se calcula
  // ON-DEMAND al seleccionarla, todo por AGREGACIÓN en servidor (getCountFromServer)
  // scopeada a ese patrón — no se descarga ninguna colección completa.
  const [cuentaSel, setCuentaSel] = useState<any|null>(null);
  const [detalle, setDetalle] = useState<Record<string, number|null>>({});
  const [cargandoDetalle, setCargandoDetalle] = useState(false);
  // Única lista con documentos del detalle: las cuentas de trabajador del patrón
  // seleccionado, y SOLO nombre + correo (mínimo necesario, dato de terceros).
  const [trabsCuenta, setTrabsCuenta] = useState<{nombre:string; email:string; activo:boolean}[]|null>(null);

  const [diagnosticos, setDiagnosticos] = useState<any[]>([]);
  const [contratosLeads, setContratosLeads] = useState<any[]>([]);
  const [nominaLeads, setNominaLeads] = useState<any[]>([]);
  // LOS DOS QUE SE ESCRIBÍAN Y NO LEÍA NADIE. `leads_pdf` guarda a quien descargó
  // el reporte del Diagnóstico y `leads_acceso` a quien se creó una cuenta y se
  // topó con que todavía no tiene acceso. Las dos llevaban meses llenándose sin
  // una sola pantalla que las mostrara: para verlas había que entrar a la consola
  // de Firebase. Un cliente potencial que ya levantó la mano y no se entera nadie.
  const [leadsPdf, setLeadsPdf] = useState<any[]>([]);
  const [leadsAcceso, setLeadsAcceso] = useState<any[]>([]);
  // QUÉ LISTA NO SE PUDO LEER, por su colección. Vacío = todas se leyeron. Una lista
  // vacía y una lista que no se pudo consultar dejan de verse igual; ver
  // `CajaNoSePudoLeer`. El valor es el motivo que devolvió Firestore.
  const [leadsFallo, setLeadsFallo] = useState<Record<string,string>>({});
  const marcarFallo = (col:string, e:any) => {
    console.error(col + ":", e);
    setLeadsFallo((f) => ({...f, [col]: String(e?.code || e?.message || "error desconocido")}));
  };
  const marcarLeido = (col:string) => setLeadsFallo((f) => {
    if (!(col in f)) return f;
    const resto = {...f}; delete resto[col]; return resto;
  });
  const [usuariosReg, setUsuariosReg] = useState<any[]>([]);
  // Restablecimiento de contraseña iniciado por el admin
  const [resetAdminFeedback, setResetAdminFeedback] = useState<{tipo:"ok"|"err"; texto:string}|null>(null);
  const [enviandoResetEmail, setEnviandoResetEmail] = useState("");
  // 4 áreas: Resumen (agregados) · Registros (cuentas de patrón) · Leads · Configuración.
  const [tabActual, setTabActual] = useState<"resumen"|"registros"|"leads"|"config">("resumen");
  const [leadSub, setLeadSub] = useState<"diagnosticos"|"contratos"|"nomina"|"pdf"|"acceso">("diagnosticos");
  const [betaProActivo, setBetaProActivo] = useState<boolean|null>(null);
  const [toggleandoPro, setToggleandoPro] = useState(false);

  // ── CHECADAS INALTERABLES: LA FECHA DE CORTE ──────────────────────────────
  // Se fija UNA vez, con la hora del SERVIDOR, y las reglas no dejan cambiarla ni
  // borrarla. Desde ahí la bitácora y el registro mensual dicen que los registros
  // del checador no se modifican desde la plataforma (notaDeCorteChecadas). Si ya
  // existe, no hay botón: se enseña la fecha. Si no se pudo leer, tampoco hay
  // botón —no se sabe si existe— y se dice.
  const [corteChecadas, setCorteChecadas] = useState<{estado:"cargando"|"sin"|"con"|"error"; desde?:Date|null}>({estado:"cargando"});
  const [fijandoCorte, setFijandoCorte] = useState(false);
  const [corteMsg, setCorteMsg] = useState("");
  const leerCorteChecadas = async () => {
    try {
      const d = await getDoc(doc(db, RUTA_CORTE_CHECADAS.coleccion, RUTA_CORTE_CHECADAS.id));
      setCorteChecadas(d.exists() ? {estado:"con", desde:(d.data() as any)?.desde?.toDate?.() || null} : {estado:"sin"});
    } catch(e:any){ setCorteChecadas({estado:"error"}); setCorteMsg(mensajeDeFallo(e, {accion:"leer la fecha de corte de las checadas", denegado:"Tu sesión no tiene permiso para leer la fecha de corte."})); }
  };
  useEffect(()=>{ leerCorteChecadas(); /* eslint-disable-next-line */ }, []);
  const fijarCorteChecadas = async () => {
    if (!esAdmin(user?.email) || corteChecadas.estado !== "sin") return;
    if (!window.confirm("¿Fijar AHORA la fecha de corte de las checadas?\n\nSe guarda con la hora del servidor y NO se puede cambiar ni borrar. Desde esa fecha, la bitácora y el registro mensual dirán que los registros del checador no se pueden modificar ni borrar desde la plataforma.")) return;
    setFijandoCorte(true); setCorteMsg("");
    try {
      await setDoc(doc(db, RUTA_CORTE_CHECADAS.coleccion, RUTA_CORTE_CHECADAS.id), {desde: serverTimestamp(), por: user.email});
    } catch(e:any){ setCorteMsg(mensajeDeFallo(e, {accion:"fijar la fecha de corte de las checadas", denegado:"No se pudo fijar: solo el administrador puede hacerlo, y solo una vez."})); }
    finally { await leerCorteChecadas(); setFijandoCorte(false); }
  };
  const horaMexicoCorta = (d:Date|null|undefined) => {
    const m = d ? enHoraDeMexico(d) : null;
    return m ? `${String(m.getHours()).padStart(2,"0")}:${String(m.getMinutes()).padStart(2,"0")}` : "";
  };

  useEffect(() => {
    const loadBeta = async () => {
      try {
        const cfgDoc = await getDoc(doc(db,"configuracion","beta_pro"));
        setBetaProActivo(cfgDoc.exists() ? (cfgDoc.data()?.activo ?? true) : true);
      } catch { setBetaProActivo(true); }
    };
    loadBeta();
  }, []);

  const toggleBetaPro = async () => {
    setToggleandoPro(true);
    try {
      const nuevo = !betaProActivo;
      await setDoc(doc(db,"configuracion","beta_pro"), {activo:nuevo, updatedAt:Timestamp.now()});
      setBetaProActivo(nuevo);   // solo despues de confirmar: un interruptor que se
                                 // mueve sin haber guardado miente sobre el estado real
    } catch(e:any){ console.error(e); alert("No se pudo cambiar el modo PRO de la beta: " + (e?.code || e?.message || "error desconocido")); }
    setToggleandoPro(false);
  };



  const [usuariosPro, setUsuariosPro] = useState<any[]>([]);

  // ── VISTA PREVIA DEL CIERRE ───────────────────────────────────────────────
  // Quién entraría y quién no con la lista TAL COMO ESTÁ, antes de cerrar la
  // puerta. Va agrupada por patrón y con sus trabajadores colgando porque la
  // autorización se HEREDA: olvidar un correo de patrón deja fuera a todos sus
  // choferes de golpe, y una lista plana esconde justo ese radio.
  const [cuentasTrabTodas, setCuentasTrabTodas] = useState<any[]>([]);
  const [cargandoPrevia, setCargandoPrevia] = useState(false);
  // El porqué de cada bloque vive detrás de un desplegable. Esta pantalla se
  // abre para decidir a quién autorizar, no para entender Firestore.
  const [porQue, setPorQue] = useState("");
  const [previaCargada, setPreviaCargada] = useState(false);
  const cargarPrevia = async () => {
    setCargandoPrevia(true);
    try {
      const snap = await getDocs(collection(db,"cuentas_trabajador"));
      setCuentasTrabTodas(snap.docs.map(d=>({id:d.id, ...(d.data() as any)})));
      setPreviaCargada(true);
    } catch(e:any){ console.error("cuentas_trabajador (vista previa):", e); alert("No se pudieron leer las cuentas de trabajador: " + (e?.code||e?.message||"error")); }
    finally { setCargandoPrevia(false); }
  };

  // Se calcula DOS VECES: como están las cosas hoy, y como quedarían después de
  // pulsar Arreglar. El marcador enseña la segunda, porque un "0 entran" causado
  // por dos registros que se arreglan con un botón no es información, es un susto.
  const _calcularPrevia = (suponerArreglado:boolean) => {
    // ── SE NORMALIZA IGUAL QUE LA REGLA, NI UNA PIZCA MÁS ──────────────────
    // La regla compara con .lower() y nada más: NO recorta espacios, y busca los
    // documentos por su id tal como está escrito. Si este cálculo limpiara más
    // que la regla, esta pantalla diría que un chofer entra y la puerta lo
    // dejaría fuera. Por eso aquí solo vale como correo el que YA está en
    // minúsculas y sin espacios; cualquier otro se manda a reparar, no se da por
    // bueno. Esta pantalla puede quedarse corta, nunca larga.
    const norm = (s:any)=>String(s||"").toLowerCase().trim();
    const crudo = (s:any)=>String(s||"");
    const esClave = (v:string)=> !!v && v.indexOf("@")>0 && v === v.toLowerCase() && v === v.trim();

    // LA LISTA, CON EL ESTADO DE CADA CORREO. Antes esto era un sí/no y todo lo
    // que no fuera "sí" acababa en el bloque de cuentas sueltas, que se construía
    // RESTANDO —lo que no es admin, ni trabajador, ni autorizado— en vez de
    // comprobando. Restar mete en el mismo saco cosas que no se parecen: un correo
    // que nunca estuvo en la lista y otro que sí está pero suspendido salían con la
    // misma etiqueta ("nunca estuvo en la lista") y el mismo botón ("Autorizar"),
    // y las dos cosas eran falsas para el segundo.
    //
    // Cuatro estados, y cada bloque de la pantalla pregunta por el suyo:
    //   · autorizado   — está y entra.
    //   · suspendido   — está y NO entra. Hace falta reactivar, no autorizar.
    //   · porArreglar  — está, pero su documento no se encuentra por su correo.
    //                    Lo resuelve el botón Arreglar, no una decisión tuya.
    //   · no           — no está. Solo esto es una cuenta "suelta".
    type EstadoLista = "autorizado" | "suspendido" | "porArreglar" | "no";
    const enLista: Record<string, {estado:EstadoLista; doc:any}> = {};
    const autorizados: Record<string, boolean> = {};
    const listaInalcanzable: any[] = [];
    const _apunta = (mail:string, estado:EstadoLista, doc:any) => {
      if (!mail) return;
      // Un correo alcanzable manda sobre uno que no lo es: si hay dos registros
      // para el mismo correo, el que la puerta encuentra es el que decide.
      if (enLista[mail] && enLista[mail].estado !== "porArreglar") return;
      enLista[mail] = {estado, doc};
    };
    usuariosPro.forEach((u:any)=>{
      const id = crudo(u.id);
      const destino = norm(u.correo);
      const activo = u.activo !== false;
      if (!esClave(id) || id !== destino) {
        const reparable = esClave(destino);
        listaInalcanzable.push({...u, _destino:destino, _reparable:reparable});
        if (reparable) {
          if (suponerArreglado && activo) { _apunta(destino, "autorizado", u); autorizados[destino] = true; }
          else _apunta(destino, "porArreglar", u);
        }
        return;
      }
      if (activo) { _apunta(id, "autorizado", u); autorizados[id] = true; }
      else _apunta(id, "suspendido", u);
    });
    const estadoDe = (mail:string): EstadoLista => enLista[mail]?.estado || "no";

    const porUid: Record<string, any> = {};
    (usuariosReg||[]).forEach((u:any)=>{ if (u.id) porUid[u.id] = u; });

    type Grupo = {correo:string; nombre:string; autorizado:boolean; esElAdmin:boolean;
                  estadoLista:EstadoLista; docPro:any; trabajadores:any[]};
    const grupos: Record<string, Grupo> = {};
    const nuevoGrupo = (mail:string): Grupo => {
      const u = (usuariosReg||[]).find((x:any)=>norm(x.email)===mail);
      return {correo:mail, nombre:(u?.nombre||u?.empresa||""), autorizado:!!autorizados[mail],
              esElAdmin:esAdmin(mail), estadoLista:estadoDe(mail), docPro:enLista[mail]?.doc||null, trabajadores:[]};
    };
    const sinResolver: any[] = [];
    const porRellenar: any[] = [];
    const cuentasInalcanzables: any[] = [];
    const correosTrabajador = new Set<string>();

    (cuentasTrabTodas||[]).forEach((c:any)=>{
      const idCuenta = crudo(c.id);
      const mailTrab = norm(c.email || c.id);
      correosTrabajador.add(mailTrab);
      // EL ID DE SU CUENTA ES LA RUTA por la que la puerta la busca, siempre en
      // minúsculas. Con mayúsculas o espacios no la encuentra nadie y ninguna
      // regla puede rescatarla: es un renombre, y va a revisión aparte.
      if (!esClave(idCuenta)) { cuentasInalcanzables.push({...c, _correo:mailTrab}); return; }

      // DOS PREGUNTAS DISTINTAS SOBRE EL MISMO CAMPO, y confundirlas era mentir
      // en una dirección o en la otra:
      //  · reglaAcepta — ¿la regla lo va a dar por bueno? Compara con .lower() en
      //    ambos lados, así que las MAYÚSCULAS le dan igual; lo que no perdona son
      //    los ESPACIOS, porque .lower() no recorta. Esto decide el marcador.
      //  · esClave — ¿está guardado ya como se va a leer? Esto decide la lista de
      //    pendientes: normalizarlo quita la dependencia de que la regla sea
      //    indulgente, que es una garantía más frágil que un dato limpio.
      const guardado = crudo(c.empleadorEmail);
      const sirve = esClave(guardado);
      const mailPatron = norm(guardado) || norm(porUid[c.empleadorId]?.email);
      if (!mailPatron) { sinResolver.push({...c, _correo:mailTrab}); return; }
      const reglaAcepta = suponerArreglado ? true : (guardado !== "" && guardado === guardado.trim());
      if (!grupos[mailPatron]) grupos[mailPatron] = nuevoGrupo(mailPatron);
      const tr = {...c, _correo:mailTrab, _patronCorreo:mailPatron, _guardadoSirve:reglaAcepta, _limpio:sirve};
      grupos[mailPatron].trabajadores.push(tr);
      if (!sirve) porRellenar.push(tr);   // la lista de pendientes es la de higiene
    });
    // Patrones autorizados que todavía no tienen ningún trabajador: también son
    // parte del cuadro, y su ausencia haría creer que la lista tiene menos gente.
    // TODO correo que esté en la lista tiene fila, tenga trabajadores o no: si no,
    // un suspendido sin equipo desaparecería de la pantalla o, peor, caería en el
    // bloque de sueltas diciendo que nunca estuvo en la lista.
    Object.keys(enLista).forEach((mail)=>{ if (!grupos[mail]) grupos[mail] = nuevoGrupo(mail); });
    // EL ADMINISTRADOR TIENE FILA PROPIA, esté o no en la lista: entra por
    // isAdmin() y no depende de ella. Lo que sí depende es su EQUIPO, que hereda
    // de la lista y no de isAdmin(); por eso su fila se muestra siempre, aunque
    // no tenga trabajadores todavía.
    const correoAdmin = ((usuariosReg||[]).map((u:any)=>norm(u.email)).find((m:string)=>!!m && esAdmin(m))
                        || Object.keys(grupos).find((m)=>esAdmin(m)) || "");
    if (correoAdmin && !grupos[correoAdmin]) grupos[correoAdmin] = nuevoGrupo(correoAdmin);
    porRellenar.forEach((x:any)=>{ x._patronAutorizado = !!autorizados[x._patronCorreo]; });

    const _rango = (g:Grupo)=> g.esElAdmin ? 0 : (g.autorizado ? 1 : (g.estadoLista==="suspendido" ? 2 : 3));
    const lista = Object.keys(grupos).map(k=>grupos[k])
      .sort((a,b)=> (_rango(a)===_rango(b) ? a.correo.localeCompare(b.correo) : _rango(a)-_rango(b)));
    // Cada bloque PREGUNTA por su estado. Ninguno se define como "lo que sobra".
    // El admin entra siempre, esté o no autorizado: va con los que entran.
    const conAcceso   = lista.filter(g=>g.autorizado || g.esElAdmin);
    const suspendidos = lista.filter(g=>!g.autorizado && !g.esElAdmin && g.estadoLista==="suspendido");
    const sinAcceso   = lista.filter(g=>!g.autorizado && !g.esElAdmin && g.estadoLista==="no");
    // Los "porArreglar" no salen en ningún bloque de decisión: no hay nada que
    // decidir sobre ellos, ya están en la lista y los resuelve el botón Arreglar.
    const porArreglarGrupos = lista.filter(g=>!g.autorizado && !g.esElAdmin && g.estadoLista==="porArreglar");

    // SUELTA significa una sola cosa: NUNCA estuvo en la lista. Se comprueba, no se
    // resta: `estadoDe(mail) === "no"` es la pregunta, y un suspendido responde
    // "suspendido" y se va a su bloque en vez de colarse aquí con una etiqueta que
    // dice lo contrario de la verdad.
    const sueltas = (usuariosReg||[]).filter((u:any)=>{
      const mail = norm(u.email);
      if (!mail) return false;
      if (estadoDe(mail) !== "no") return false;   // está en la lista, en algún estado
      if (esAdmin(mail)) return false;
      if (correosTrabajador.has(mail)) return false;
      // Un patrón que ya sale arriba con su equipo colgando no se repite aquí: se
      // contaría dos veces entre los que se quedan fuera.
      if (grupos[mail]) return false;
      return true;
    });

    // ENTRAN los patrones autorizados, el administrador, y SOLO los trabajadores
    // cuyo correo de patrón ya está guardado como la regla lo va a leer. Los
    // demás NO entran, y contarlos aquí sería la mentira más cara de esta
    // pantalla: la puerta intenta resolverlos leyendo usuarios/{patrón}, lectura
    // que al trabajador le está prohibida, así que se queda sin heredar y sin
    // aviso. Y OJO con el equipo del administrador: hereda de la LISTA, no de
    // isAdmin(), así que si su correo no está en la lista, su gente no entra.
    const _entranDe = (g:Grupo)=> g.autorizado ? g.trabajadores.filter((t:any)=>t._guardadoSirve).length : 0;
    const heredan   = conAcceso.reduce((s,g)=>s+_entranDe(g),0);
    const noHeredan = conAcceso.reduce((s,g)=>s+(g.trabajadores.length-_entranDe(g)),0);
    const entran = conAcceso.length + heredan;
    const _conEquipo = (arr:Grupo[])=> arr.length + arr.reduce((s,g)=>s+g.trabajadores.length,0);
    const fuera = _conEquipo(sinAcceso) + _conEquipo(suspendidos) + _conEquipo(porArreglarGrupos)
                  + sueltas.length + sinResolver.length + cuentasInalcanzables.length + noHeredan;

    // LO QUE HAY QUE ARREGLAR, en dos montones: lo que hace el botón y lo que no.
    const reparables = listaInalcanzable.filter((x:any)=>x._reparable);
    const autoArreglables = reparables.length + porRellenar.length;
    const manuales = listaInalcanzable.filter((x:any)=>!x._reparable).length + sinResolver.length + cuentasInalcanzables.length;
    return {conAcceso, sinAcceso, suspendidos, porArreglarGrupos, sueltas, sinResolver, entran, fuera, porRellenar,
            cuentasInalcanzables, listaInalcanzable, reparables, autoArreglables, manuales,
            pendientes: autoArreglables + manuales, estadoDe, adminEnLista: !!correoAdmin && !!autorizados[correoAdmin]};
  };
  const previa = _calcularPrevia(false);
  const previaArreglada = _calcularPrevia(true);
  // El marcador y las listas enseñan el DESPUÉS mientras haya algo que arreglar:
  // un "0 entran" que se resuelve con un botón asusta sin informar de nada.
  const vistaPrevia = previa.pendientes > 0 ? previaArreglada : previa;
  const botonPorQue = (clave:string) => (
    <button onClick={()=>setPorQue(porQue===clave?"":clave)}
      style={{marginLeft:8,background:"transparent",border:"none",padding:0,cursor:"pointer",
        fontSize:11,fontWeight:700,color:"#6B7280",textDecoration:"underline",fontFamily:fontSans,
        textTransform:"none" as const,letterSpacing:"normal"}}>
      {porQue===clave ? "ocultar" : "¿por qué?"}
    </button>
  );
  const [migrando, setMigrando] = useState(false);
  // MIGRACIÓN DE LA CONFIGURACIÓN DE EMPRESA, de un solo uso. El horario general
  // vivía en `usuarios/{uid}`, que solo lee su dueño, y por eso se copiaba a cada
  // ficha de trabajador. Ahora vive en `configuracion_empresa/{uid}`, que leen el
  // patrón y sus trabajadores. Esto mueve lo que ya existe.
  //
  // Va como acción PEDIDA y no automática: es una escritura sobre la configuración
  // de cuentas ajenas, y esas no ocurren porque alguien abra una pantalla.
  const [migrandoCfg, setMigrandoCfg] = useState(false);
  // MIGRACIÓN DE LA DENOMINACIÓN, de un solo uso y aparte de la del horario.
  // El nombre de la empresa vivía en `usuarios/{uid}` bajo CUATRO nombres de
  // campo posibles —empresa, razonSocial, nombreEmpresa, negocio— según en qué
  // época se guardara. La cascada se resuelve AQUÍ, en ese orden, y no en cada
  // pantalla que lo lea: una cuenta que tuviera el dato bajo el cuarto nombre
  // llegaría vacía al documento nuevo y el candado le cerraría la puerta por un
  // dato que sí tenía.
  //
  // Solo mueve el NOMBRE. El RFC, el domicilio y el correo de contacto no
  // existían en ningún sitio, así que no hay nada que mover: los captura cada
  // patrón en su pantalla, y hasta entonces el candado hace su trabajo.
  const [migrandoDen, setMigrandoDen] = useState(false);
  const migrarDenominaciones = async () => {
    setMigrandoDen(true);
    let movidas = 0, yaEstaban = 0, vacias = 0; const fallos: string[] = [];
    for (const u of (usuariosReg||[])) {
      const uid = String((u as any).id || "");
      if (!uid) { vacias++; continue; }
      const nombre = String((u as any).empresa || (u as any).razonSocial
        || (u as any).nombreEmpresa || (u as any).negocio || "").trim();
      if (!nombre) { vacias++; continue; }
      try {
        // Lo ya capturado en la pantalla nueva MANDA: volver a copiar el nombre
        // corto encima sería deshacer una razón social escrita a conciencia.
        const yaHay = await getDoc(doc(db, COL_CONFIG_EMPRESA, uid));
        if (yaHay.exists() && String((yaHay.data() as any)?.denominacion || "").trim()) { yaEstaban++; continue; }
        await setDoc(doc(db, COL_CONFIG_EMPRESA, uid), {
          denominacion: nombre, denominacionMigradaDe: "usuarios", denominacionMigradaEn: Timestamp.now(),
        }, {merge:true});
        movidas++;
      } catch(e:any){ console.error("migrar denominación:", uid, e); fallos.push(`${(u as any).email || uid}: ${e?.code || e?.message || "error"}`); }
    }
    setMigrandoDen(false);
    alert(`${movidas} ${movidas===1?"cuenta movida":"cuentas movidas"}.`
      + `\n${vacias} ${vacias===1?"llegó vacía":"llegaron vacías"} (sin nombre en ninguno de los cuatro campos).`
      + (yaEstaban ? `\n${yaEstaban} ya tenían denominación capturada y no se tocaron.` : "")
      + `\n\nEl RFC, el domicilio y el correo de contacto no existían antes: los captura cada patrón en su pantalla.`
      + (fallos.length ? `\n\nNo se pudo con:\n${fallos.join("\n")}` : ""));
  };

  const migrarConfigEmpresa = async () => {
    setMigrandoCfg(true);
    let movidas = 0, yaEstaban = 0, sinNada = 0; const fallos: string[] = [];
    for (const u of (usuariosReg||[])) {
      const uid = String((u as any).id || "");
      const horario = (u as any).horarioLaboral || null;
      const ubi = (u as any).ubicacionTrabajo || null;
      if (!uid || (!horario && !ubi)) { sinNada++; continue; }
      try {
        // No se pisa lo que ya esté migrado: si el documento nuevo ya tiene
        // horario, manda él. Volver a copiar el viejo encima sería deshacer un
        // cambio hecho después de migrar.
        // EL HORARIO VA CON SU ENTRADA DE HISTORIAL, EN LA MISMA ESCRITURA (modo
        // estricto): la decide escrituraMudanzaConfig sobre lo que hay AHORA en el
        // documento, dentro de una transacción.
        const ref = doc(db, COL_CONFIG_EMPRESA, uid);
        const tipo = await runTransaction(db, async (tx:any) => {
          const s = await tx.get(ref);
          const w = escrituraMudanzaConfig({existente: s.exists() ? s.data() : null, horario, ubi,
            correo: user?.email || "", marca: serverTimestamp(), migradoEn: Timestamp.now()});
          if (w.tipo === "set") tx.set(ref, w.datos);
          else if (w.tipo === "update") tx.update(ref, w.datos);
          return w.tipo;
        });
        if (tipo === "nada") { yaEstaban++; continue; }
        movidas++;
      } catch(e:any){ console.error("migrar config empresa:", uid, e); fallos.push(`${(u as any).email || uid}: ${e?.code || e?.message || "error"}`); }
    }
    setMigrandoCfg(false);
    alert(`${movidas} ${movidas===1?"cuenta movida":"cuentas movidas"}.` +
      (yaEstaban ? `\n${yaEstaban} ya estaban migradas y no se tocaron.` : "") +
      (sinNada ? `\n${sinNada} sin horario ni centro de trabajo que mover.` : "") +
      (fallos.length ? `\n\nNo se pudo con:\n${fallos.join("\n")}` : ""));
  };
  const [nuevoCorreo, setNuevoCorreo] = useState("");
  const [agregandoPro, setAgregandoPro] = useState(false);

  // Solo se leen con DOCUMENTOS: usuarios (Registros + métricas), usuarios_pro y
  // configuracion (Configuración) y las tres de leads. Todo lo demás va por agregación.
  useEffect(() => { cargarDiag(); cargarContratos(); cargarNomina(); cargarLeadsPdf(); cargarLeadsAcceso(); cargarUsuariosPro(); cargarConfig(); cargarUsuarios(); cargarPrevia(); }, []);   // eslint-disable-line

  // Conteo en SERVIDOR (no descarga documentos). En su propio try/catch: si falla
  // (p. ej. faltara un índice), ese contador muestra "—" y el resto sigue. NUNCA se
  // cae de vuelta a traer la colección completa.
  const _count = async (ref:any):Promise<number|null> => {
    try { const s = await getCountFromServer(ref); return s.data().count; }
    catch(e){ console.warn("conteo admin:", e); return null; }
  };

  // DETALLE de UNA cuenta, calculado al seleccionarla. Todo scopeado al patrón.
  // Campo de vínculo por colección: `userId` en trabajadores/vehiculos/flotilla/
  // proveedores/clientes/recibos_nomina/creditos, y `empleadorId` en cuentas_trabajador.
  // "Contratos generados" = colección documentos_generados (vinculada por userId).
  // Requiere que su regla esté PUBLICADA en firestore.rules; si aún no lo está, el
  // servidor deniega el conteo, ese contador muestra "—" y el resto del detalle sigue.
  const abrirDetalle = async (u:any) => {
    setCuentaSel(u);
    setDetalle({}); setTrabsCuenta(null); setCargandoDetalle(true);
    const uid = u?.id;
    if (!uid) { setCargandoDetalle(false); return; }
    const porUsuario = (col:string)=> query(collection(db,col), where("userId","==",uid));
    try {
      const [empActivos, empTotal, vehiculos, movFlotilla, proveedores, clientes, recibos, creditos, contratos] = await Promise.all([
        _count(query(collection(db,"trabajadores"), where("userId","==",uid), where("status","==","activo"))),
        _count(porUsuario("trabajadores")),
        _count(porUsuario("vehiculos")),
        _count(porUsuario("flotilla")),
        _count(porUsuario("proveedores")),
        _count(porUsuario("clientes")),
        _count(porUsuario("recibos_nomina")),
        _count(porUsuario("creditos")),
        _count(porUsuario("documentos_generados")),   // "—" mientras su regla no esté publicada
      ]);
      setDetalle({empActivos, empTotal, vehiculos, movFlotilla, proveedores, clientes, recibos, creditos, contratos});
      // Cuentas de trabajador del patrón: única lista con documentos, SOLO nombre+correo.
      try {
        const snap = await getDocs(query(collection(db,"cuentas_trabajador"), where("empleadorId","==",uid)));
        setTrabsCuenta(snap.docs.map(d=>{ const x:any=d.data(); return {nombre:(x.nombre||"").toString(), email:(x.email||d.id||"").toString(), activo:x.activo!==false}; })
          .sort((a,b)=> (a.nombre||a.email).localeCompare(b.nombre||b.email)));
      } catch(e){ console.warn("cuentas_trabajador de la cuenta:", e); setTrabsCuenta([]); }
    } catch(e){ console.error("detalle de cuenta:", e); }
    finally { setCargandoDetalle(false); }
  };

  const cargarUsuariosPro = async () => {
    try {
      const snap = await getDocs(collection(db,"usuarios_pro"));
      const lista = snap.docs.map(d=>({id:d.id, ...(d.data() as any)}));
      setUsuariosPro(lista);   // quién no autoriza a nadie lo decide la vista previa, en un solo sitio
    } catch(e){ console.error(e); }
  };

  // UN SOLO ARREGLO. Eran dos botones para dos avisos que, mirados de cerca,
  // señalaban los mismos documentos y se resolvían igual. Aquí van juntos: se
  // reescribe la lista con el correo como id y se guarda el correo del patrón en
  // las cuentas que no lo tienen. Sigue siendo una acción PEDIDA: una escritura
  // silenciosa sobre la lista que decide quién entra no debe ocurrir sola.
  const arreglarPendientes = async (reparables:any[], porRellenar:any[]) => {
    if (!reparables.length && !porRellenar.length) return;
    setMigrando(true);
    let hechos = 0, fallos = 0;
    for (const viejo of reparables) {
      const mail = String(viejo.correo||"").toLowerCase().trim();
      if (!mail.includes("@")) { fallos++; continue; }
      try {
        await setDoc(doc(db,"usuarios_pro",mail), {
          correo: mail,
          activo: viejo.activo !== false,
          fechaAlta: viejo.fechaAlta || new Date().toLocaleDateString("es-MX"),
          timestamp: viejo.timestamp || Timestamp.now(),
          migradoDe: viejo.id,
        });
        await deleteDoc(doc(db,"usuarios_pro", viejo.id));
        hechos++;
      } catch(e){ console.error("migrar autorizado:", viejo.id, e); fallos++; }
    }
    for (const c of porRellenar) {
      if (!c?.id || !c._patronCorreo) { fallos++; continue; }
      try { await updateDoc(doc(db,"cuentas_trabajador", c.id), {empleadorEmail: c._patronCorreo}); hechos++; }
      catch(e){ console.error("rellenar empleadorEmail:", c.id, e); fallos++; }
    }
    await cargarUsuariosPro();
    await cargarPrevia();
    setMigrando(false);
    alert(hechos + " de " + (hechos+fallos) + " arreglados." + (fallos ? " Quedaron " + fallos + " sin arreglar; revisa la lista de la pantalla." : ""));
  };

  // Admin: envía el correo de restablecimiento de contraseña a un usuario (Firebase Auth).
  const enviarResetPassword = async (email:string) => {
    if (!email) return;
    setEnviandoResetEmail(email); setResetAdminFeedback(null);
    try {
      await sendPasswordResetEmail(auth, email);
      setResetAdminFeedback({tipo:"ok", texto:`Correo de restablecimiento enviado a ${email}.`});
    } catch(e:any) {
      const t = e?.code === "auth/invalid-email" ? `El correo ${email} no tiene un formato válido.`
        : e?.code === "auth/user-not-found" ? `No hay una cuenta registrada con ${email}.`
        : `No se pudo enviar el correo a ${email} (${e?.code || "error"}).`;
      setResetAdminFeedback({tipo:"err", texto:t});
    } finally { setEnviandoResetEmail(""); }
  };

  const cargarConfig = async () => {
    try {
      const cfgDoc = await getDoc(doc(db,"configuracion","app"));
      const fc = cfgDoc.exists() ? String(cfgDoc.data()?.fechaCorteMetricas || "") : "";
      setFechaCorte(fc); setNuevaFechaCorte(fc);
    } catch(e){ console.error(e); }
  };


  const cargarUsuarios = async () => {
    try {
      const snap = await getDocs(collection(db,"usuarios"));
      setUsuariosReg(snap.docs.map(d=>({id:d.id,...d.data()})));
    } catch(e){ console.error(e); }
  };

  // EL CORREO ES EL ID DEL DOCUMENTO, igual que en cuentas_trabajador. Así la
  // puerta lee una ruta conocida —usuarios_pro/{correo}— en vez de correr una
  // consulta que funcionaba porque su `where` coincidía con la regla de
  // seguridad: el día que alguien cambiara la consulta, dejaría de funcionar sin
  // que nada avisara. Además hace imposible el duplicado por construcción.
  const agregarUsuarioPro = async () => {
    const mail = nuevoCorreo.toLowerCase().trim();
    if (!mail.includes("@")) return;
    setAgregandoPro(true);
    try {
      const existe = await getDoc(doc(db,"usuarios_pro",mail));
      if (existe.exists()) { alert("Este correo ya está autorizado"); setAgregandoPro(false); return; }
      await setDoc(doc(db,"usuarios_pro",mail),{correo:mail,activo:true,fechaAlta:new Date().toLocaleDateString("es-MX"),timestamp:Timestamp.now()});
      setNuevoCorreo("");
      await cargarUsuariosPro();
    } catch(e:any){ console.error(e); alert("No se pudo dar acceso PRO a ese correo: " + (e?.code || e?.message || "error desconocido")); }
    setAgregandoPro(false);
  };

  const toggleUsuarioPro = async (id:string, activo:boolean) => {
    // Sin try/catch esto era una promesa rechazada sin dueno: ni aviso ni rastro.
    // La recarga va en `finally` para que la lista muestre el estado REAL.
    try { await updateDoc(doc(db,"usuarios_pro",id),{activo:!activo}); }
    catch(e:any){ console.error(e); alert("No se pudo cambiar el estado del acceso PRO: " + (e?.code || e?.message || "error desconocido")); }
    finally { await cargarUsuariosPro(); }
  };

  // Toggle PRO desde el detalle de una cuenta. REUTILIZA la misma colección y lógica
  // que la pestaña Configuración: si ya existe su registro PRO lo activa/suspende;
  // si no existe, lo crea con el mismo shape que `agregarUsuarioPro`.
  const [proCambiando, setProCambiando] = useState("");
  // Vista del listado. La marca de prueba NO borra ni oculta la cuenta: solo la
  // saca de las métricas. Sigue existiendo y entrando a la app con normalidad.
  const [vistaCuentas, setVistaCuentas] = useState<"reales"|"prueba"|"todas">("reales");
  const [pruebaCambiando, setPruebaCambiando] = useState("");
  // Fecha de corte (AAAA-MM-DD) para las métricas HISTÓRICAS. Vive en
  // configuracion/app, que el panel ya lee al arrancar y cuya regla ya permite
  // escritura al admin: no hay reglas nuevas que publicar.
  const [fechaCorte, setFechaCorte] = useState("");
  const [nuevaFechaCorte, setNuevaFechaCorte] = useState("");
  const [guardandoCorte, setGuardandoCorte] = useState(false);
  const toggleProDeCuenta = async (correo:string, proDoc:any) => {
    const mail = (correo||"").toLowerCase().trim();
    if (!mail) return;
    setProCambiando(mail);
    try {
      if (proDoc) await toggleUsuarioPro(proDoc.id, proDoc.activo);
      else {
        await setDoc(doc(db,"usuarios_pro",mail),{correo:mail, activo:true, fechaAlta:new Date().toLocaleDateString("es-MX"), timestamp:Timestamp.now()});
        await cargarUsuariosPro();
      }
    } catch(e:any){ console.error("toggle PRO cuenta:", e); alert("No se pudo cambiar el acceso PRO de " + mail + ": " + (e?.code || e?.message || "error desconocido")); }
    finally { setProCambiando(""); }
  };

  // Marca de cuenta de prueba. Un solo campo en el doc que el panel ya lee.
  const marcarPrueba = async (u:any, esPrueba:boolean) => {
    if (!u?.id) return;
    setPruebaCambiando(u.id);
    try { await updateDoc(doc(db,"usuarios",u.id), {esPrueba}); }
    catch(e:any){ console.error(e); alert("No se pudo marcar la cuenta como de prueba: " + (e?.code || e?.message || "error desconocido")); }
    finally { setPruebaCambiando(""); await cargarUsuarios(); }
  };

  const guardarFechaCorte = async () => {
    setGuardandoCorte(true);
    const v = nuevaFechaCorte.trim();
    try {
      await setDoc(doc(db,"configuracion","app"), {fechaCorteMetricas: v, updatedAt: Timestamp.now()}, {merge:true});
      setFechaCorte(v);   // solo tras confirmar
    } catch(e:any){ console.error(e); alert("No se pudo guardar la fecha de corte: " + (e?.code || e?.message || "error desconocido")); }
    finally { setGuardandoCorte(false); }
  };

  const eliminarUsuarioPro = async (id:string, correo:string) => {
    if (!window.confirm("¿Revocar acceso PRO a "+correo+"?")) return;
    try { await deleteDoc(doc(db,"usuarios_pro",id)); }
    catch(e:any){ console.error(e); alert("No se pudo revocar el acceso PRO de " + correo + ": " + (e?.code || e?.message || "error desconocido")); }
    finally { await cargarUsuariosPro(); }
  };

  const cargarNomina = async () => {
    try {
      const q = query(collection(db,"nomina_leads"), orderBy("timestamp","desc"));
      const snap = await getDocs(q);
      setNominaLeads(snap.docs.map(d=>({id:d.id,...d.data()})));
      marcarLeido("nomina_leads");
    } catch(e){ marcarFallo("nomina_leads", e); }
  };

  const cargarContratos = async () => {
    try {
      const q = query(collection(db, "contratos_leads"), orderBy("timestamp", "desc"));
      const snap = await getDocs(q);
      setContratosLeads(snap.docs.map(d => ({id:d.id, ...d.data()})));
      marcarLeido("contratos_leads");
    } catch(e) { marcarFallo("contratos_leads", e); }
  };

  const cargarDiag = async () => {
    try {
      const q = query(collection(db, "diagnosticos"), orderBy("timestamp", "desc"));
      const snap = await getDocs(q);
      setDiagnosticos(snap.docs.map(d => ({id:d.id, ...d.data()})));
      marcarLeido("diagnosticos");
    } catch(e) { marcarFallo("diagnosticos", e); }
  };

  // Quien descargó el reporte del Diagnóstico. Trae el sector y el porcentaje con
  // el que salió, que es con lo que se abre la conversación.
  const cargarLeadsPdf = async () => {
    try {
      const q = query(collection(db, "leads_pdf"), orderBy("timestamp", "desc"));
      const snap = await getDocs(q);
      setLeadsPdf(snap.docs.map(d => ({id:d.id, ...d.data()})));
      marcarLeido("leads_pdf");
    } catch(e) { marcarFallo("leads_pdf", e); }
  };

  // Quien se creó una cuenta y se encontró con que todavía no tiene acceso.
  // Se ordena por `ultimoIntento` y no por `timestamp`: el documento se reescribe
  // en cada intento y lo que interesa es cuándo fue el último, no cuándo el
  // primero. Si algún registro viejo no lo trae, se cae a `timestamp`.
  const cargarLeadsAcceso = async () => {
    try {
      const q = query(collection(db, "leads_acceso"), orderBy("ultimoIntento", "desc"));
      const snap = await getDocs(q);
      setLeadsAcceso(snap.docs.map(d => ({id:d.id, ...d.data()})));
      marcarLeido("leads_acceso");
    } catch(e) {
      // El índice de `ultimoIntento` puede no existir todavía, o haber registros
      // sin ese campo. Antes que no mostrar a nadie, se lee sin orden y se ordena
      // aquí: la lista importa más que el índice.
      try {
        const snap = await getDocs(collection(db, "leads_acceso"));
        const ms = (x:any) => { try { return x?.toMillis?.() || 0; } catch(_) { return 0; } };
        setLeadsAcceso(snap.docs.map(d => ({id:d.id, ...d.data()}))
          .sort((a:any,b:any)=> (ms(b.ultimoIntento)||ms(b.timestamp)) - (ms(a.ultimoIntento)||ms(a.timestamp))));
        marcarLeido("leads_acceso");
        // Si los DOS intentos fallan, ya no hay nada que leer: se dice en pantalla,
        // no solo en la consola.
      } catch(e2) { marcarFallo("leads_acceso", e2); }
    }
  };

  // Métricas de CUENTAS a partir de `usuarios` (única colección con documentos que se
  // lee para métricas; no son datos de terceros). Activa = ultimoAcceso ≤ 30 días.
  const _fechaDe = (v:any):Date|null => { try { return v?.toDate?.() || null; } catch(_){ return null; } };
  const _ymActual = (()=>{ const d=new Date(); return `${d.getFullYear()}${String(d.getMonth()+1).padStart(2,"0")}`; })();
  const usoDelMesDe = (u:any):number => Number(u?.usoPorMes?.[_ymActual]) || 0;
  // El corte solo aplica a lo HISTÓRICO. El uso del mes se guarda en cubetas
  // "AAAAMM", así que basta comparar la cubeta del mes en curso con la del corte:
  // si el corte es posterior, ese mes aún no cuenta.
  const _ymCorte = (fechaCorte||"").slice(0,7).replace("-","");
  const mesCuentaTrasCorte = (ym:string)=> !_ymCorte || ym >= _ymCorte;
  const proDe = (u:any) => usuariosPro.find((p:any)=> (p.correo||"").toLowerCase() === (u?.email||"").toLowerCase()) || null;
  // `usuarios` recibe un doc en CUALQUIER inicio de sesión, así que también hay
  // ahí cuentas de TRABAJADOR. Antes se decidía por un indicio —tener fechaAlta o
  // empresa— y todo lo que no lo cumplía DESAPARECÍA del listado. Eso escondía a
  // las cuentas cuyo documento se creó al entrar y no al registrarse, que son
  // justamente las que hay que arreglar. Una cuenta que no se ve no se puede
  // arreglar, así que ahora se clasifica con el HECHO que la distingue —tener o no
  // cuenta de trabajador— y las que no encajan se marcan, no se ocultan.
  const _correosTrab = new Set((cuentasTrabTodas||[]).map((c:any)=>String(c.email||c.id||"").toLowerCase().trim()));
  const esAccesoTrabajador = (u:any):boolean => _correosTrab.has(String(u?.email||"").toLowerCase().trim());
  // SIN IDENTIFICAR: ni correo, ni nombre, ni empresa. No es una cuenta a medio
  // hacer, es un documento que nació de una escritura con merge sobre una ruta que
  // no existía —el contador de uso y el historial de AXIOR lo hacían— muy
  // probablemente desde una sesión anónima. Una fila que no dice de quién es es una
  // fila sobre la que no se puede decidir nada, así que ni entra en las métricas ni
  // se esconde: sale con su identificador y con lo único que se sabe de ella.
  const sinIdentificar = (u:any):boolean => !esAccesoTrabajador(u)
    && !String(u?.email||"").trim() && !String(u?.nombre||"").trim() && !(u?.empresa||u?.nombreEmpresa);
  // Lo que el documento SÍ tiene dentro. Es lo que permite distinguir de dónde salió,
  // ya que el correo no está: un documento con solo el contador vino de navegar.
  const pistasDe = (u:any):string[] => {
    const campos: [string,string][] = [["usoPorMes","contador de uso"],["axiorHistorial","historial de chat"],
      ["fcmDispositivos","permiso de notificaciones"],["horarioLaboral","horario configurado"],["ubicacionTrabajo","centro de trabajo"],
      ["diasAguinaldo","días de aguinaldo"],["whatsapp","whatsapp"],["fotoPerfilUrl","foto de perfil"],["ultimoAcceso","último acceso"]];
    return campos.filter(([k])=> (u as any)?.[k] != null).map(([,txt])=>txt);
  };
  // QUÉ LE FALTA A ESTA FICHA. Devuelve hechos, no una categoría: "ficha
  // incompleta" nombraba un cajón y no daba nada que hacer, y además exigía que
  // faltaran las DOS cosas para decir algo, así que una cuenta con empresa pero sin
  // fecha de alta no salía marcada y aun así desaparecía de la gráfica de altas.
  // Aquí se dice qué falta, y con eso se sabe qué corregir.
  //
  // Solo aplica a cuentas de las que SÍ se sabe de quién son: un acceso de
  // trabajador no necesita empresa, y una cuenta sin identificar tiene su propio
  // bloque, con un problema mayor.
  const faltaEnFicha = (u:any):string[] => {
    if (!previaCargada || esAccesoTrabajador(u) || sinIdentificar(u)) return [];
    const falta: string[] = [];
    if (!(u?.empresa || u?.nombreEmpresa)) falta.push("sin nombre de empresa");
    if (!u?.fechaAlta) falta.push("sin fecha de alta");
    return falta;
  };
  const fichaIncompleta = (u:any):boolean => faltaEnFicha(u).length > 0;
  // FILTRO ÚNICO. Todas las métricas del panel —total, activas, uso del mes, top 5
  // y altas por mes— cuelgan de esta lista, así que excluir aquí las cuentas de
  // prueba las excluye de todo a la vez. No hay seis lugares que recordar.
  const esPrueba = (u:any)=> u?.esPrueba === true;
  const cuentasSinIdentificar = usuariosReg.filter((u:any)=>!esAccesoTrabajador(u)).filter(sinIdentificar);
  const cuentasPatron = usuariosReg.filter((u:any)=>!esAccesoTrabajador(u)).filter((u:any)=>!esPrueba(u)).filter((u:any)=>!sinIdentificar(u))
    .sort((a:any,b:any)=> (_fechaDe(b.ultimoAcceso)?.getTime()||0) - (_fechaDe(a.ultimoAcceso)?.getTime()||0));
  // Lista VISIBLE del listado, independiente de las métricas: las de prueba se
  // pueden ver detrás del selector, nunca desaparecen.
  const cuentasPrueba = usuariosReg.filter((u:any)=>!esAccesoTrabajador(u)).filter(esPrueba).filter((u:any)=>!sinIdentificar(u))
    .sort((a:any,b:any)=> (_fechaDe(b.ultimoAcceso)?.getTime()||0) - (_fechaDe(a.ultimoAcceso)?.getTime()||0));
  const cuentasListadas = vistaCuentas==="prueba" ? cuentasPrueba
    : vistaCuentas==="todas" ? [...cuentasPatron, ...cuentasPrueba]
    : cuentasPatron;
  const cuentasTrabEnUsuarios = usuariosReg.filter(esAccesoTrabajador).length;
  // La gráfica de altas solo se pierde a las que no tienen FECHA. Contar aquí las
  // que solo no tienen empresa sería culpar a un dato de lo que hace otro.
  const cuentasSinFechaAlta = cuentasPatron.filter((u:any)=> faltaEnFicha(u).indexOf("sin fecha de alta") >= 0).length;
  const usoSinIdentificar = cuentasSinIdentificar.reduce((s:number,u:any)=> s + (Number(u?.usoPorMes?.[_ymActual])||0), 0);
  const cuentasTotal = cuentasPatron.length;
  const cuentasActivas = cuentasPatron.filter((u:any)=>{
    const d = _fechaDe(u.ultimoAcceso); if (!d) return false;
    return (Date.now() - d.getTime()) <= 30*86400000;
  }).length;
  const _usoCortado = (u:any)=> mesCuentaTrasCorte(_ymActual) ? usoDelMesDe(u) : 0;
  const usoTotalMes = cuentasPatron.reduce((s:number,u:any)=> s + _usoCortado(u), 0);
  const topUso = cuentasPatron.map((u:any)=>({u, uso:_usoCortado(u)})).filter(x=>x.uso>0).sort((a,b)=>b.uso-a.uso).slice(0,5);
  const maxUso = Math.max(1, ...topUso.map(x=>x.uso));
  // Altas por mes (últimos 12 meses) para el gráfico de barras (divs, sin librería).
  const altasPorMes = (()=>{
    const hoy = new Date(); const out:{k:string; label:string; n:number}[] = [];
    for (let i=11;i>=0;i--){
      const d = new Date(hoy.getFullYear(), hoy.getMonth()-i, 1);
      out.push({k:`${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}`, label:d.toLocaleDateString("es-MX",{month:"short"}), n:0});
    }
    const idx:Record<string,number> = {}; out.forEach((o,i)=>{ idx[o.k]=i; });
    cuentasPatron.forEach((u:any)=>{
      const d = _fechaDe(u.fechaAlta); if (!d) return;
      // Altas ANTERIORES al corte no cuentan: es una métrica histórica.
      if (fechaCorte && d.toISOString().slice(0,10) < fechaCorte) return;
      const k = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}`;
      if (idx[k]!=null) out[idx[k]].n++;
    });
    return out;
  })();
  const maxAltas = Math.max(1, ...altasPorMes.map(a=>a.n));
  const nf = (v:number|null)=> v==null ? "—" : v.toLocaleString("es-MX");
  const nfMoney = (v:number|null)=> v==null ? "—" : "$"+v.toLocaleString("es-MX",{minimumFractionDigits:2, maximumFractionDigits:2});

  return (
    <div {...ZONA_DE_CAPTURA} style={{minHeight:"100vh", background:"linear-gradient(160deg,#0B1829 0%,#0F2040 50%,#162447 100%)"}}>
      {/* Header */}
      <div style={{background:"linear-gradient(135deg,#162447,#1E3A5F)", padding:"0 20px", height:58, display:"flex", alignItems:"center", gap:12}}>
        <button onClick={onBack} style={{background:"rgba(255,255,255,0.08)", border:"1px solid rgba(255,255,255,0.15)", color:"white", borderRadius:8, padding:"5px 10px", cursor:"pointer", fontSize:12}}>← Suite</button>
        <span style={{color:gold, fontWeight:700, fontSize:14}}>🛡️ Panel de Administrador</span>
        <span style={{fontSize:11, color:"rgba(255,255,255,0.4)", marginLeft:4}}>· {user?.email}</span>
        {/* Un corte invisible es tan malo como un porcentaje sin periodo: si las
            métricas históricas están recortadas, tiene que decirlo la pantalla. */}
        {fechaCorte && (
          <span style={{fontSize:11, fontWeight:700, color:gold, marginLeft:8, padding:"3px 9px",
            borderRadius:999, background:"rgba(184,147,42,0.12)", border:"1px solid rgba(184,147,42,0.35)"}}>
            Registro desde {_fechaCortaMX(fechaCorte)}
          </span>
        )}
        <div style={{marginLeft:"auto", display:"flex", alignItems:"center", gap:10}}>
          {/* EL INTERRUPTOR DICE LO QUE HACE. Se llamaba "PRO beta" y lo que
              gobierna es la puerta entera: encendido, cualquier cuenta entra;
              apagado, solo las de la lista. Un rótulo que no describe el efecto es
              exactamente cómo se acciona el interruptor equivocado. */}
          <span style={{fontSize:11, color:"rgba(255,255,255,0.35)", marginLeft:8}}>Puerta:</span>
          <button onClick={toggleBetaPro} disabled={toggleandoPro || betaProActivo === null}
            title={betaProActivo
              ? "Cualquier cuenta con sesión entra. Tócalo para exigir estar en la lista de autorizados."
              : "Solo entran el administrador, los correos de la lista y los trabajadores de esos patrones."}
            style={{display:"flex", alignItems:"center", gap:7, padding:"6px 14px", borderRadius:20, border:"none",
              cursor:"pointer", fontSize:12, fontWeight:700, transition:"all 0.3s", maxWidth:300,
              background:betaProActivo?"rgba(239,68,68,0.20)":"linear-gradient(135deg,#059669,#047857)",
              color:betaProActivo?"#FCA5A5":"white",
              boxShadow:betaProActivo?"none":"0 2px 12px rgba(5,150,105,0.4)"}}>
            <span style={{width:8,height:8,borderRadius:"50%",
              background:betaProActivo?"#EF4444":"#6EE7B7",display:"inline-block",flexShrink:0}}/>
            {toggleandoPro ? "Guardando…"
              : betaProActivo === null ? "Leyendo…"
              : betaProActivo ? "Abierta a cualquier cuenta"
              : "Solo cuentas autorizadas"}
          </button>
          {/* `cargarConteos` existió y se eliminó al pasar de agregados globales a
              métricas por cuenta: hoy TODO lo que pinta esta pantalla se deriva de
              `usuarios`, que es justo lo que trae `cargarUsuarios`. La llamada
              huérfana tumbaba el panel al pulsar el botón. */}
          <button onClick={()=>{ cargarUsuarios(); }} title="Actualizar métricas" style={{background:"rgba(255,255,255,0.08)", border:"1px solid rgba(255,255,255,0.15)", color:"rgba(255,255,255,0.7)", borderRadius:8, padding:"5px 10px", cursor:"pointer", fontSize:11}}>↻</button>
        </div>
      </div>

      <div style={{padding:isMobile?14:24, maxWidth:ANCHO_CONTENIDO, margin:"0 auto"}}>
        {/* Tabs */}
        <div style={{display:"flex", background:"white", borderRadius:10, padding:4, marginBottom:16, border:`1px solid ${T_LIGHT.borderCard}`}}>
          <div style={{display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:4, width:"100%"}}>
          {(["resumen","registros","leads","config"] as const).map(tab => {
            const META: Record<string,{icon:string; label:string}> = {
              resumen:  {icon:"scale_simple",    label:"Resumen"},
              registros:{icon:"suite_empleados", label:"Cuentas"},
              leads:    {icon:"document",        label:"Leads"},
              config:   {icon:"rocket",          label:"Configuración"},
            };
            const m = META[tab];
            const isActive = tabActual===tab;
            return (
              <button key={tab} onClick={() => setTabActual(tab)}
                style={{padding:"8px 4px", borderRadius:8, border:"none", cursor:"pointer", fontSize:10, fontWeight:600,
                  background:isActive?(tab==="config"?"linear-gradient(135deg,#B8932A,#A07C30)":"#0F172A"):"transparent",
                  color:isActive?"white":"#9A9AAA",
                  display:"flex", alignItems:"center", justifyContent:"center", gap:5}}>
                <AxisIcon name={m.icon} size={12} tone={isActive?"white":"gold"} withBackdrop={false} strokeWidth={3}/>
                {m.label}
              </button>
            );
          })}
          </div>
        </div>

        {tabActual === "resumen" && (
          <div style={{display:"flex", flexDirection:"column" as const, gap:14, marginBottom:20}}>
            {/* Cuentas: totales, activas y altas por mes (desde `usuarios`) */}
            <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr 1fr":"repeat(3,1fr)", gap:12}}>
              {[
                {label:"Cuentas de patrón", val:nf(cuentasTotal), color:"#7C3AED"},
                {label:"Activas (últimos 30 días)", val:nf(cuentasActivas), color:"#059669"},
                {label:"Aperturas de módulo este mes", val:nf(usoTotalMes), color:"#B8932A"},
              ].map((s,i)=>(
                <div key={i} style={{background:"white", borderRadius:12, padding:"16px", border:`1px solid ${T_LIGHT.borderCard}`, boxShadow:"0 1px 6px rgba(0,0,0,0.05)"}}>
                  <div style={{fontFamily:fontSerif, fontSize:26, fontWeight:800, color:s.color}}>{s.val}</div>
                  <div style={{fontSize:11, color:"#9A9AAA", textTransform:"uppercase" as const, letterSpacing:"0.5px", marginTop:2}}>{s.label}</div>
                </div>
              ))}
            </div>

            {/* Altas por mes — barras simples con divs (sin librería de charts) */}
            <div style={{background:"white", borderRadius:12, padding:"16px 18px", border:`1px solid ${T_LIGHT.borderCard}`}}>
              <div style={{fontFamily:fontSerif, fontSize:14, fontWeight:700, color:"#0F1D35", marginBottom:4}}>Altas de cuentas · últimos 12 meses</div>
              {/* Estas cuentas SI se listan y SI cuentan en el total; lo que no
                  tienen es fecha con la que ponerlas en un mes. Se dice. */}
              <div style={{fontSize:11, color:cuentasSinFechaAlta>0?"#B45309":"#9A9AAA", marginBottom:10, lineHeight:1.45}}>
                {cuentasSinFechaAlta>0
                  ? `${cuentasSinFechaAlta} ${cuentasSinFechaAlta===1?"cuenta no aparece":"cuentas no aparecen"} en esta gráfica: no tienen fecha de alta. Están en el listado, marcadas.`
                  : "Todas las cuentas del listado tienen fecha de alta."}
              </div>
              <div style={{display:"flex", alignItems:"flex-end", gap:6, height:120}}>
                {altasPorMes.map((a,i)=>(
                  <div key={i} style={{flex:1, display:"flex", flexDirection:"column" as const, alignItems:"center", gap:4}}>
                    <div style={{fontSize:10, fontWeight:800, color:a.n>0?"#B8932A":"#C9CDD8"}}>{a.n}</div>
                    <div title={`${a.label}: ${a.n}`} style={{width:"100%", height:`${Math.round((a.n/maxAltas)*80)+2}px`, background:a.n>0?"linear-gradient(180deg,#B8932A,#A07C30)":"#EDEFF3", borderRadius:"5px 5px 0 0", transition:"height .2s"}}/>
                    <div style={{fontSize:9.5, color:"#9A9AAA", textTransform:"capitalize" as const}}>{a.label.replace(".","")}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* Uso del mes: cuentas más activas (barras simples, sin librería) */}
            <div style={{background:"white", borderRadius:12, padding:"16px 18px", border:`1px solid ${T_LIGHT.borderCard}`}}>
              <div style={{fontFamily:fontSerif, fontSize:14, fontWeight:700, color:"#0F1D35", marginBottom:4}}>Cuentas más activas · este mes</div>
              <div style={{fontSize:11, color:"#9A9AAA", marginBottom:12}}>Aperturas de módulo registradas en el mes en curso.</div>
              {topUso.length===0 ? (
                <div style={{fontSize:12.5, color:"#9A9AAA"}}>Aún no hay uso registrado este mes. Aparecerá conforme los patrones naveguen la plataforma.</div>
              ) : (
                <div style={{display:"flex", flexDirection:"column" as const, gap:8}}>
                  {topUso.map((x:any,i:number)=>(
                    <div key={i} style={{display:"flex", alignItems:"center", gap:10}}>
                      <div style={{width:isMobile?100:190, fontSize:12, color:"#4A4A60", whiteSpace:"nowrap" as const, overflow:"hidden", textOverflow:"ellipsis"}}>{x.u.empresa || x.u.nombre || x.u.email}</div>
                      <div style={{flex:1, background:"rgba(184,147,42,0.10)", borderRadius:6, height:18}}>
                        <div style={{width:`${(x.uso/maxUso)*100}%`, background:"linear-gradient(90deg,#B8932A,#A07C30)", borderRadius:6, height:18}}/>
                      </div>
                      <div style={{width:40, textAlign:"right" as const, fontSize:12, fontWeight:800, color:"#B8932A"}}>{x.uso}</div>
                    </div>
                  ))}
                </div>
              )}
              {/* Una barra sin etiqueta no se pinta. Estas cuentas no tienen correo
                  ni nombre con el que rotularla, así que van agrupadas en una línea:
                  su uso se ve, pero no finge ser el de alguien. */}
              {cuentasSinIdentificar.length > 0 && (
                <div style={{fontSize:11, color:"#9A9AAA", marginTop:10, lineHeight:1.5, borderTop:`1px solid ${T_LIGHT.borderCard}`, paddingTop:8}}>
                  Cuentas sin identificar · {cuentasSinIdentificar.length}
                  {usoSinIdentificar>0 ? ` · suman ${usoSinIdentificar} aperturas este mes` : " · sin uso este mes"}.
                  {" "}No se pintan porque no hay nombre que poner en la barra; están listadas en la pestaña Cuentas.
                </div>
              )}
            </div>

            <div style={{fontSize:10.5, color:"rgba(255,255,255,0.45)", lineHeight:1.5}}>
              El detalle de cada cuenta (trabajadores y contadores) está en la pestaña <strong style={{color:"rgba(255,255,255,0.7)"}}>Cuentas</strong>.
            </div>
          </div>
        )}






              {tabActual === "registros" && (
                <div style={{display:"flex", flexDirection:"column" as const, gap:12, marginBottom:20}}>
                  {resetAdminFeedback && (
                    <div style={{background: resetAdminFeedback.tipo==="ok" ? "rgba(5,150,105,0.08)" : "rgba(220,38,38,0.08)", border:`1px solid ${resetAdminFeedback.tipo==="ok" ? "rgba(5,150,105,0.30)" : "rgba(220,38,38,0.30)"}`, borderRadius:10, padding:"10px 14px", fontSize:13, fontWeight:600, color: resetAdminFeedback.tipo==="ok" ? "#059669" : "#DC2626"}}>{resetAdminFeedback.texto}</div>
                  )}

                  {/* ── DETALLE de la cuenta seleccionada (on-demand) ── */}
                  {cuentaSel && (()=>{ const u=cuentaSel; const pro=proDe(u); const mail=(u.email||"").toLowerCase();
                    const conts = [
                      {l:"Empleados activos", v:detalle.empActivos, s:`de ${detalle.empTotal==null?"—":detalle.empTotal} en total`, c:"#162447"},
                      {l:"Vehículos", v:detalle.vehiculos, s:`${detalle.movFlotilla==null?"—":detalle.movFlotilla} movimientos`, c:"#2563EB"},
                      {l:"Proveedores", v:detalle.proveedores, s:"registrados", c:"#4F46E5"},
                      {l:"Clientes", v:detalle.clientes, s:"registrados", c:"#B8932A"},
                      {l:"Recibos de nómina", v:detalle.recibos, s:"generados", c:"#0EA5E9"},
                      {l:"Créditos", v:detalle.creditos, s:"registrados", c:"#059669"},
                      {l:"Contratos generados", v:detalle.contratos, s:"en su banco de documentos", c:"#DC2626"},
                      {l:"Uso del mes", v:usoDelMesDe(u), s:"aperturas de módulo", c:"#7C3AED"},
                    ];
                    return (
                    <div style={{background:"white", border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:14, overflow:"hidden", boxShadow:"0 4px 18px rgba(0,0,0,0.10)"}}>
                      <div style={{background:"linear-gradient(135deg,#162447,#1E3A5F)", padding:"14px 18px", display:"flex", alignItems:"center", justifyContent:"space-between", gap:12, flexWrap:"wrap" as const}}>
                        <div style={{minWidth:0}}>
                          <div style={{fontFamily:fontSerif, fontSize:16, fontWeight:700, color:"white"}}>{u.empresa || u.nombre || "(sin nombre)"}</div>
                          <div style={{fontSize:11.5, color:"rgba(255,255,255,0.6)", marginTop:2}}>
                            {u.email || "—"} · Alta: {u.fechaAlta?.toDate?.().toLocaleDateString("es-MX") || "—"} · Último acceso: {u.ultimoAcceso?.toDate?.().toLocaleDateString("es-MX") || "—"}
                          </div>
                        </div>
                        <div style={{display:"flex", gap:8, alignItems:"center", flexWrap:"wrap" as const}}>
                          <button onClick={()=>toggleProDeCuenta(u.email, pro)} disabled={!u.email || proCambiando===mail}
                            title={pro?.activo ? "Suspender PRO" : "Activar PRO"}
                            style={{padding:"6px 14px", borderRadius:999, border:`1px solid ${pro?.activo?"rgba(184,147,42,0.6)":"rgba(255,255,255,0.2)"}`, background:pro?.activo?"rgba(184,147,42,0.22)":"rgba(255,255,255,0.06)", color:pro?.activo?gold:"rgba(255,255,255,0.6)", cursor:u.email?"pointer":"not-allowed", fontSize:11.5, fontWeight:800, fontFamily:fontSans}}>
                            {proCambiando===mail ? "…" : pro?.activo ? "★ PRO activo" : "PRO inactivo"}
                          </button>
                          {u.email && (
                            <button onClick={()=>enviarResetPassword(u.email)} disabled={enviandoResetEmail===u.email}
                              style={{background:"rgba(124,58,237,0.20)", border:"1px solid rgba(124,58,237,0.40)", color:"#C4B5FD", borderRadius:8, padding:"6px 12px", cursor:enviandoResetEmail===u.email?"not-allowed":"pointer", fontSize:11.5, fontWeight:700, fontFamily:fontSans}}>
                              {enviandoResetEmail===u.email ? "Enviando…" : "🔑 Restablecer"}
                            </button>
                          )}
                          <button onClick={()=>{setCuentaSel(null); setDetalle({}); setTrabsCuenta(null);}} aria-label="Cerrar detalle"
                            style={{background:"rgba(255,255,255,0.10)", border:"none", color:"white", width:28, height:28, borderRadius:8, cursor:"pointer", fontSize:14}}>✕</button>
                        </div>
                      </div>

                      <div style={{padding:"16px 18px"}}>
                        {/* Contadores (agregación en servidor, scopeada a esta cuenta) */}
                        <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr 1fr":"repeat(4,1fr)", gap:10, marginBottom:16}}>
                          {conts.map((s,i)=>(
                            <div key={i} style={{background:T_LIGHT.canvasSoft, borderRadius:10, padding:"12px 14px", border:`1px solid ${T_LIGHT.borderCard}`}}>
                              <div style={{fontFamily:fontSerif, fontSize:20, fontWeight:800, color:s.c}}>{cargandoDetalle && s.v==null ? "·" : (s.v==null ? "—" : s.v)}</div>
                              <div style={{fontSize:11.5, color:"#4A4A60", fontWeight:700, marginTop:2}}>{s.l}</div>
                              <div style={{fontSize:10.5, color:"#9A9AAA", marginTop:1}}>{s.s}</div>
                            </div>
                          ))}
                        </div>

                        {/* Cuentas de trabajador de ESTE patrón (solo nombre + correo) */}
                        <div style={{fontFamily:fontSerif, fontSize:14, fontWeight:700, color:"#0F1D35", marginBottom:8}}>
                          Cuentas de trabajador {trabsCuenta && <span style={{fontFamily:fontSans, fontSize:12, color:"#9A9AAA", fontWeight:600}}>· {trabsCuenta.length}</span>}
                        </div>
                        {cargandoDetalle && !trabsCuenta ? (
                          <div style={{fontSize:12.5, color:"#9A9AAA"}}>Cargando…</div>
                        ) : !trabsCuenta || trabsCuenta.length===0 ? (
                          <div style={{fontSize:12.5, color:"#9A9AAA"}}>Esta cuenta aún no ha creado accesos para sus trabajadores.</div>
                        ) : (
                          <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr":"1fr 1fr", gap:8}}>
                            {trabsCuenta.map((t,i)=>(
                              <div key={i} style={{display:"flex", alignItems:"center", gap:8, background:T_LIGHT.canvasSoft, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:9, padding:"8px 11px"}}>
                                <span style={{width:7, height:7, borderRadius:"50%", background:t.activo?"#059669":"#9A9AAA", flexShrink:0}}/>
                                <div style={{minWidth:0}}>
                                  <div style={{fontSize:12.5, fontWeight:700, color:"#0B1829", whiteSpace:"nowrap" as const, overflow:"hidden", textOverflow:"ellipsis"}}>
                                    {t.nombre || "(sin nombre)"}
                                    {!t.activo && <span style={{marginLeft:6, fontSize:9.5, fontWeight:800, color:"#B91C1C", background:"rgba(220,38,38,0.10)", border:"1px solid rgba(220,38,38,0.30)", borderRadius:6, padding:"1px 6px", textTransform:"uppercase" as const}}>{TEXTO_CUENTA_SUSPENDIDA}</span>}
                                  </div>
                                  <div style={{fontSize:11, color:"#9A9AAA", whiteSpace:"nowrap" as const, overflow:"hidden", textOverflow:"ellipsis"}}>{t.email}</div>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                        <div style={{fontSize:10.5, color:"#9A9AAA", marginTop:12, lineHeight:1.5}}>
                          Contadores calculados en el servidor para esta cuenta; no se descargan las colecciones. Un “—” significa que ese conteo fue rechazado (p. ej. “Contratos generados” mientras la regla de <code>documentos_generados</code> no esté publicada).
                        </div>
                      </div>
                    </div>); })()}

                  {/* ── MAESTRO: lista simple de cuentas de patrón (sin consultas por fila) ── */}
                  <div style={{fontSize:11, color:"rgba(255,255,255,0.55)", textTransform:"uppercase" as const, letterSpacing:"0.5px", fontWeight:700, marginTop:4}}>
                    Cuentas de patrón · {cuentasTotal}
                  </div>
                  {/* Las de prueba NO desaparecen: se ven detrás del selector. Lo
                      único que cambia es que no entran en las métricas. */}
                  <div style={{display:"flex", alignItems:"center", gap:8, marginBottom:10, flexWrap:"wrap" as const}}>
                    {([["reales","Reales"],["prueba","De prueba"],["todas","Todas"]] as const).map(([v,txt])=>(
                      <button key={v} onClick={()=>setVistaCuentas(v as any)}
                        style={{padding:"5px 12px", borderRadius:999, cursor:"pointer", fontSize:11.5, fontWeight:700,
                          border:`1px solid ${vistaCuentas===v?"rgba(184,147,42,0.5)":T_LIGHT.borderCard}`,
                          background:vistaCuentas===v?"rgba(184,147,42,0.14)":"white",
                          color:vistaCuentas===v?"#B8932A":"#4A4A60"}}>
                        {txt}{v==="prueba" && cuentasPrueba.length>0 ? ` (${cuentasPrueba.length})` : ""}
                      </button>
                    ))}
                    {cuentasPrueba.length>0 && (
                      <span style={{fontSize:10.5, color:"#4A4A60"}}>
                        {cuentasPrueba.length} cuenta{cuentasPrueba.length===1?"":"s"} de prueba fuera de las métricas
                      </span>
                    )}
                  </div>
                  {cuentasListadas.map((u:any) => { const pro=proDe(u); const sel=cuentaSel?.id===u.id; return (
                    <div key={u.id} onClick={()=>abrirDetalle(u)} title="Ver detalle de la cuenta"
                      style={{background:"white", border:`1px solid ${sel?"rgba(184,147,42,0.55)":T_LIGHT.borderCard}`, borderRadius:12, padding:"12px 16px", borderLeft:`4px solid ${sel?"#B8932A":"#7C3AED"}`, cursor:"pointer", boxShadow:sel?"0 2px 12px rgba(184,147,42,0.18)":"none"}}>
                      <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap" as const, gap:6}}>
                        <div style={{display:"flex", alignItems:"center", gap:8, minWidth:0}}>
                          <AxisIcon name="suite_empleados" size={14} tone="gold" withBackdrop={false} strokeWidth={3}/>
                          <span style={{fontWeight:700, fontSize:14, color:"#0B1829"}}>{u.empresa || u.nombre || u.email}</span>
                          <span style={{fontSize:10, fontWeight:800, padding:"2px 9px", borderRadius:999, border:`1px solid ${pro?.activo?"rgba(184,147,42,0.4)":"rgba(154,154,170,0.3)"}`, background:pro?.activo?"rgba(184,147,42,0.12)":"transparent", color:pro?.activo?"#B8932A":"#9A9AAA"}}>{pro?.activo?"PRO":"Free"}</span>
                          {pro && !pro.activo && <span style={{fontSize:10, fontWeight:800, color:"#DC2626"}}>suspendido</span>}
                          {/* El HECHO, no el rótulo: qué falta exactamente. */}
                          {faltaEnFicha(u).map((falta:string)=>(
                            <span key={falta}
                              title={falta==="sin fecha de alta"
                                ? "Su documento nació de un inicio de sesión y no de un registro. Entra sin problema, pero no cuenta en la gráfica de altas por mes."
                                : "Nadie ha escrito el nombre de la empresa en esta cuenta, así que el listado la muestra por su correo. Se completa desde el perfil del patrón."}
                              style={{fontSize:10, fontWeight:800, padding:"2px 9px", borderRadius:999, border:"1px solid rgba(217,119,6,0.45)", background:"rgba(217,119,6,0.12)", color:"#B45309"}}>
                              {falta}
                            </span>
                          ))}
                        </div>
                        <span style={{fontSize:11, color:"#9A9AAA"}}>Último acceso: {u.ultimoAcceso?.toDate?.().toLocaleDateString("es-MX") || "—"}</span>
                      </div>
                      <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", gap:10, marginTop:4, flexWrap:"wrap" as const}}>
                        <span style={{fontSize:11, color:"#4A4A60"}}>{u.email}</span>
                        <button onClick={(ev)=>{ ev.stopPropagation(); marcarPrueba(u, !esPrueba(u)); }}
                          disabled={pruebaCambiando===u.id}
                          title={esPrueba(u) ? "Volver a contarla en las métricas" : "Excluirla de las métricas, sin borrarla"}
                          style={{padding:"4px 10px", borderRadius:999, cursor:"pointer", fontSize:10.5, fontWeight:800,
                            border:`1px solid ${esPrueba(u)?"rgba(217,119,6,0.45)":T_LIGHT.borderCard}`,
                            background:esPrueba(u)?"rgba(217,119,6,0.12)":"white",
                            color:esPrueba(u)?"#B45309":"#9A9AAA"}}>
                          {pruebaCambiando===u.id ? "…" : esPrueba(u) ? "DE PRUEBA · fuera de métricas" : "Marcar como prueba"}
                        </button>
                      </div>
                    </div>
                  ); })}
                  {cuentasTrabEnUsuarios>0 && (
                    <div style={{fontSize:10.5, color:"rgba(255,255,255,0.45)", lineHeight:1.5}}>
                      {cuentasTrabEnUsuarios} cuenta{cuentasTrabEnUsuarios===1?"":"s"} de la colección no se listan aquí: son accesos de trabajador,
                      {" "}comprobado contra cuentas_trabajador, y se ven en el detalle de su patrón.
                    </div>
                  )}
                  {cuentasListadas.length === 0 && (
                    <div style={{fontSize:13, color:"#4A4A60"}}>
                      {vistaCuentas==="prueba" ? "No has marcado ninguna cuenta como de prueba." : "Aún no hay cuentas de patrón registradas."}
                    </div>
                  )}

                  {/* ── CUENTAS SIN IDENTIFICAR ──────────────────────────────
                      Salían como filas en blanco. Una fila que no dice de quién es
                      es una fila sobre la que no se puede decidir nada, así que se
                      muestra su identificador y lo único que el documento contiene:
                      con eso se ve de dónde salió. No se borra ninguna. */}
                  {cuentasSinIdentificar.length > 0 && (
                    <div style={{marginTop:14, background:"rgba(255,255,255,0.04)", border:"1px solid rgba(255,255,255,0.12)", borderRadius:12, padding:"13px 15px"}}>
                      <div style={{fontSize:12.5, fontWeight:800, color:"rgba(255,255,255,0.85)"}}>
                        Cuentas sin identificar · {cuentasSinIdentificar.length}
                      </div>
                      <div style={{fontSize:11, color:"rgba(255,255,255,0.5)", marginTop:3, lineHeight:1.55}}>
                        No tienen correo ni nombre. Su documento nació de una escritura automática —el contador de uso o el
                        {" "}historial del chat— sobre una cuenta que no estaba dada de alta, casi siempre una <b>sesión anónima</b>.
                        {" "}Ya no se crean más. <b>Para confirmar cuál es cuál:</b> busca el identificador en Firebase → Authentication;
                        {" "}si el proveedor dice Anónimo, es una de esas. No entran a la plataforma en ningún caso, y quedan fuera de
                        {" "}las métricas.
                      </div>
                      <div style={{marginTop:9}}>
                        {cuentasSinIdentificar.map((u:any)=>{
                          const pistas = pistasDe(u);
                          return (
                          <div key={u.id} style={{borderTop:"1px solid rgba(255,255,255,0.08)", padding:"7px 0"}}>
                            <div style={{display:"flex", alignItems:"center", gap:8, flexWrap:"wrap" as const}}>
                              <code style={{fontSize:11, color:"rgba(255,255,255,0.75)", wordBreak:"break-all" as const}}>{u.id}</code>
                              <span style={{fontSize:9.5, fontWeight:800, padding:"2px 8px", borderRadius:999, border:"1px solid rgba(217,119,6,0.5)", background:"rgba(217,119,6,0.16)", color:"#F0B45E", textTransform:"uppercase" as const}}>
                                sin correo
                              </span>
                            </div>
                            <div style={{fontSize:10.5, color:"rgba(255,255,255,0.45)", marginTop:2}}>
                              {pistas.length ? "solo tiene: " + pistas.join(" · ") : "el documento está vacío"}
                            </div>
                          </div>
                        ); })}
                      </div>
                    </div>
                  )}
                </div>
              )}

              {tabActual === "leads" && (
                <div style={{display:"flex", gap:6, marginBottom:14, flexWrap:"wrap" as const}}>
                  {([["diagnosticos","Diagnósticos"],["pdf","Reporte PDF"],["acceso","Sin acceso"],["nomina","Nómina"],["contratos","Contratos"]] as const).map(([k,l])=>(
                    <button key={k} onClick={()=>setLeadSub(k)}
                      style={{padding:"7px 14px", borderRadius:999, border:`1px solid ${leadSub===k?"rgba(184,147,42,0.5)":"rgba(255,255,255,0.15)"}`, background:leadSub===k?"rgba(184,147,42,0.18)":"rgba(255,255,255,0.05)", color:leadSub===k?gold:"rgba(255,255,255,0.6)", cursor:"pointer", fontSize:12, fontWeight:700, fontFamily:fontSans}}>{l}</button>
                  ))}
                </div>
              )}

              {tabActual === "leads" && leadSub === "diagnosticos" && (
          <div style={{display:"flex", flexDirection:"column" as const, gap:8, marginBottom:20}}>
            {/* El contador NO puede decir "0 diagnósticos registrados" cuando lo que
                pasó es que no se pudieron leer: eso es afirmar un cero que nadie
                contó. Con fallo, en su lugar va la caja que lo dice. */}
            {leadsFallo["diagnosticos"] ? (
              <CajaNoSePudoLeer que="los diagnósticos" detalle={leadsFallo["diagnosticos"]} onReintentar={cargarDiag}/>
            ) : (
              <div style={{fontSize:12, color:"#9A9AAA", marginBottom:4}}>{diagnosticos.length} diagnósticos registrados</div>
            )}
            {!leadsFallo["diagnosticos"] && diagnosticos.map((d:any) => (
              <div key={d.id} style={{background:"white", border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:12, padding:"12px 16px", borderLeft:"4px solid #B8932A"}}>
                <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:6, flexWrap:"wrap" as const, gap:4}}>
                  <div style={{display:"flex", alignItems:"center", gap:8}}>
                    <AxisIcon name="scale_simple" size={14} tone="gold" withBackdrop={false} strokeWidth={3}/>
                    <span style={{fontWeight:700, fontSize:14, color:"#0B1829"}}>{d.sector}</span>
                    {d.pct !== undefined && (
                      <span style={{fontSize:11, fontWeight:700, color:d.pct>=80?"#059669":d.pct>=40?"#D97706":"#DC2626", background:d.pct>=80?"rgba(5,150,105,0.08)":d.pct>=40?"rgba(217,119,6,0.08)":"rgba(220,38,38,0.08)", padding:"2px 8px", borderRadius:10, display:"inline-flex", alignItems:"center", gap:5}}>
                        <span style={{width:7, height:7, borderRadius:"50%", background:d.pct>=80?"#10B981":d.pct>=40?"#F59E0B":"#DC2626", flexShrink:0}}/>
                        {d.pct}%
                      </span>
                    )}
                  </div>
                  <span style={{fontSize:11, color:"#9A9AAA"}}>{d.fecha} · {d.hora}</span>
                </div>
                <div style={{display:"flex", gap:16, flexWrap:"wrap" as const}}>
                  <span style={{fontSize:11, color:"#4A4A60", display:"inline-flex", alignItems:"center", gap:5}}>
                    <AxisIcon name="suite_empleados" size={11} tone="gold" withBackdrop={false} strokeWidth={3}/>
                    {d.usuarioEmail}
                  </span>
                  {d.cumplidas !== undefined && <span style={{fontSize:11, color:"#059669", display:"inline-flex", alignItems:"center", gap:5}}>
                    <AxisIcon name="check" size={11} tone="white" withBackdrop={false} strokeWidth={3}/>
                    {d.cumplidas} cumplidas
                  </span>}
                  {d.pendientes !== undefined && <span style={{fontSize:11, color:"#DC2626", display:"inline-flex", alignItems:"center", gap:5}}>
                    <AxisIcon name="alert" size={11} tone="white" withBackdrop={false} strokeWidth={3}/>
                    {d.pendientes} pendientes
                  </span>}
                  {d.especialidad && d.especialidad !== "Todas" && <span style={{fontSize:11, color:"#B8932A"}}>{d.especialidad}</span>}
                </div>
              </div>
            ))}
          </div>
        )}

        {tabActual === "leads" && leadSub === "nomina" && (
          <div style={{display:"flex", flexDirection:"column" as const, gap:8}}>
            <div style={{fontSize:12, color:"#9A9AAA", marginBottom:4}}>
              {leadsFallo["nomina_leads"] ? "No se pudo consultar esta lista" : `${nominaLeads.length} cálculos realizados`}
            </div>
            {/* Stats por tipo */}
            {(() => {
              const tipos:Record<string,number> = {};
              nominaLeads.forEach((l:any) => { tipos[l.tipoCalculo]=(tipos[l.tipoCalculo]||0)+1; });
              const iconNames:Record<string,string> = {liquidacion:"scale_simple",finiquito:"clipboard",aguinaldo:"money",vacaciones:"suite_calendario"};
              return (
                <div style={{display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:8, marginBottom:12}}>
                  {Object.entries(tipos).map(([tipo,count]) => (
                    <div key={tipo} style={{background:"white", borderRadius:10, padding:"10px 12px", border:`1px solid ${T_LIGHT.borderCard}`, textAlign:"center" as const}}>
                      <div style={{marginBottom:4, display:"flex", justifyContent:"center"}}>
                        <AxisIcon name={iconNames[tipo]||"briefcase"} size={20} tone="gold" withBackdrop={false} strokeWidth={3}/>
                      </div>
                      <div style={{fontFamily:fontSerif, fontSize:20, fontWeight:700, color:"#7C3AED"}}>{count}</div>
                      <div style={{fontSize:10, color:"#9A9AAA", textTransform:"capitalize" as const}}>{tipo}</div>
                    </div>
                  ))}
                </div>
              );
            })()}
            {leadsFallo["nomina_leads"] ? (
              <CajaNoSePudoLeer que="los cálculos de nómina" detalle={leadsFallo["nomina_leads"]} onReintentar={cargarNomina}/>
            ) : nominaLeads.length === 0 ? (
              <div style={{textAlign:"center" as const, padding:40, background:"white", borderRadius:14, border:`1px solid ${T_LIGHT.borderCard}`}}>
                <div style={{marginBottom:10, display:"flex", justifyContent:"center"}}>
                  <AxisIcon name="briefcase" size={32} tone="gold" withBackdrop={false} strokeWidth={2.5}/>
                </div>
                <div style={{fontSize:14, color:"#0F172A"}}>Sin cálculos registrados aún</div>
              </div>
            ) : nominaLeads.map((l:any) => (
              <div key={l.id} style={{background:"white", border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:12, padding:"12px 16px", borderLeft:"4px solid #7C3AED"}}>
                <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:4, flexWrap:"wrap" as const, gap:4}}>
                  <div style={{display:"flex", alignItems:"center", gap:8}}>
                    <span style={{fontSize:13, fontWeight:700, color:"#0B1829", textTransform:"capitalize" as const}}>{l.tipoCalculo}</span>
                    {l.usuarioRegistrado && <span style={{fontSize:10, color:"#7C3AED", background:"rgba(124,58,237,0.08)", padding:"2px 8px", borderRadius:10}}>Registrado</span>}
                  </div>
                  <span style={{fontSize:11, color:"#9A9AAA"}}>{l.fecha}</span>
                </div>
                <span style={{fontSize:12, color:"#4A4A60"}}>📧 {l.correo}</span>
              </div>
            ))}
          </div>
        )}

        {/* ── REPORTE PDF DEL DIAGNÓSTICO ────────────────────────────────────
            Quien llegó al final del Diagnóstico y dejó su correo para llevarse el
            PDF. Es el lead más caliente que produce la plataforma: ya vio su
            porcentaje y ya sabe qué le falta. Se muestra con qué salió, porque es
            con lo que se abre la conversación. */}
        {tabActual === "leads" && leadSub === "pdf" && (
          <div style={{display:"flex", flexDirection:"column" as const, gap:8}}>
            <div style={{fontSize:12, color:"#9A9AAA", marginBottom:4}}>
              {leadsFallo["leads_pdf"] ? "No se pudo consultar esta lista"
                : leadsPdf.length === 1 ? "1 persona descargó su reporte" : `${leadsPdf.length} personas descargaron su reporte`}
            </div>
            {leadsFallo["leads_pdf"] ? (
              <CajaNoSePudoLeer que="quién descargó el reporte" detalle={leadsFallo["leads_pdf"]} onReintentar={cargarLeadsPdf}/>
            ) : leadsPdf.length === 0 ? (
              <div style={{textAlign:"center" as const, padding:"34px 24px", background:"white", borderRadius:14, border:`1px solid ${T_LIGHT.borderCard}`}}>
                <div style={{marginBottom:10, display:"flex", justifyContent:"center"}}>
                  <AxisIcon name="document" size={30} tone="gold" withBackdrop={false} strokeWidth={2.5}/>
                </div>
                <div style={{fontSize:14, color:"#0B1829", fontWeight:600, marginBottom:4}}>Todavía nadie ha descargado el reporte</div>
                <div style={{fontSize:12.5, color:"#4A4A60", lineHeight:1.6, maxWidth:420, margin:"0 auto"}}>
                  Cuando alguien termine el Diagnóstico y deje su correo para llevarse el PDF, aparecerá aquí con el sector y el porcentaje con el que salió.
                </div>
              </div>
            ) : leadsPdf.map((l:any) => (
              <div key={l.id} style={{background:"white", border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:12, padding:"12px 16px", borderLeft:"4px solid #B8932A"}}>
                <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:6, flexWrap:"wrap" as const, gap:4}}>
                  <div style={{display:"flex", alignItems:"center", gap:8, minWidth:0}}>
                    <AxisIcon name="mail" size={13} tone="gold" withBackdrop={false} strokeWidth={3}/>
                    <span style={{fontWeight:700, fontSize:13.5, color:"#0B1829", wordBreak:"break-all" as const}}>{l.correo}</span>
                  </div>
                  <span style={{fontSize:11, color:"#9A9AAA"}}>{l.fecha}</span>
                </div>
                <div style={{display:"flex", alignItems:"center", gap:8, flexWrap:"wrap" as const, fontSize:12, color:"#4A4A60"}}>
                  {l.sector && <span>{l.sector}</span>}
                  {l.especialidad && <span style={{color:"#9A9AAA"}}>· {l.especialidad}</span>}
                  {typeof l.pct === "number" && (
                    <span style={{fontSize:11, fontWeight:800, padding:"2px 9px", borderRadius:999,
                      color: l.pct >= 80 ? "#047857" : l.pct >= 50 ? "#B45309" : "#B91C1C",
                      background: l.pct >= 80 ? "rgba(4,120,87,0.10)" : l.pct >= 50 ? "rgba(180,83,9,0.10)" : "rgba(185,28,28,0.10)",
                      border:`1px solid ${l.pct >= 80 ? "rgba(4,120,87,0.28)" : l.pct >= 50 ? "rgba(180,83,9,0.28)" : "rgba(185,28,28,0.28)"}`}}>
                      {l.pct}% de cumplimiento
                    </span>
                  )}
                  {typeof l.pendientes === "number" && l.pendientes > 0 && (
                    <span style={{color:"#9A9AAA"}}>· {l.pendientes} pendientes</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}

        {/* ── SE CREÓ CUENTA Y NO TIENE ACCESO ───────────────────────────────
            Esta persona hizo lo más difícil: darse de alta. Lo único que la separa
            de ser cliente es que alguien la autorice.
            LOS INTENTOS SON EL DATO. Quien volvió cuatro veces está esperando una
            respuesta; quien entró una vez puede que se equivocara de sitio. Por eso
            no es un renglón más de la lista: se dice, y se ordena por el último
            intento y no por el primero. */}
        {tabActual === "leads" && leadSub === "acceso" && (
          <div style={{display:"flex", flexDirection:"column" as const, gap:8}}>
            <div style={{fontSize:12, color:"#9A9AAA", marginBottom:4}}>
              {/* Sin dato leído no hay recuento: decir "0 personas" sería contar lo
                  que no se pudo consultar. */}
              {leadsFallo["leads_acceso"] ? "No se pudo consultar esta lista"
                : leadsAcceso.length === 1 ? "1 persona se creó cuenta y está esperando acceso"
                : `${leadsAcceso.length} personas se crearon cuenta y están esperando acceso`}
            </div>
            {leadsFallo["leads_acceso"] ? (
              <CajaNoSePudoLeer que="quién está esperando acceso" detalle={leadsFallo["leads_acceso"]} onReintentar={cargarLeadsAcceso}/>
            ) : leadsAcceso.length === 0 ? (
              <div style={{textAlign:"center" as const, padding:"34px 24px", background:"white", borderRadius:14, border:`1px solid ${T_LIGHT.borderCard}`}}>
                <div style={{marginBottom:10, display:"flex", justifyContent:"center"}}>
                  <AxisIcon name="user_single" size={30} tone="gold" withBackdrop={false} strokeWidth={2.5}/>
                </div>
                <div style={{fontSize:14, color:"#0B1829", fontWeight:600, marginBottom:4}}>Nadie está esperando acceso ahora mismo</div>
                <div style={{fontSize:12.5, color:"#4A4A60", lineHeight:1.6, maxWidth:440, margin:"0 auto"}}>
                  Aquí aparece quien se crea una cuenta y todavía no está en la lista de autorizados. Si alguien te dice que no puede entrar, es el primer sitio donde mirar.
                </div>
              </div>
            ) : leadsAcceso.map((l:any) => {
              const n = Number(l.intentos) || 1;
              // Tres o más vueltas ya no es curiosidad: es alguien esperando.
              const insiste = n >= 3;
              const cuando = (() => {
                try { const d = l.ultimoIntento?.toDate?.() || l.timestamp?.toDate?.(); return d ? d.toLocaleDateString("es-MX") : ""; }
                catch(_) { return ""; }
              })();
              return (
                <div key={l.id} style={{background:"white", border:`1px solid ${insiste ? "rgba(184,147,42,0.55)" : T_LIGHT.borderCard}`,
                  borderRadius:12, padding:"12px 16px", borderLeft:`4px solid ${insiste ? "#B8932A" : "#9A9AAA"}`,
                  boxShadow: insiste ? "0 0 0 3px rgba(184,147,42,0.10)" : undefined}}>
                  <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:6, flexWrap:"wrap" as const, gap:4}}>
                    <div style={{display:"flex", alignItems:"center", gap:8, minWidth:0}}>
                      <AxisIcon name="mail" size={13} tone="gold" withBackdrop={false} strokeWidth={3}/>
                      <span style={{fontWeight:700, fontSize:13.5, color:"#0B1829", wordBreak:"break-all" as const}}>{l.correo}</span>
                    </div>
                    {!!cuando && <span style={{fontSize:11, color:"#9A9AAA"}}>{cuando}</span>}
                  </div>
                  <div style={{display:"flex", alignItems:"center", gap:8, flexWrap:"wrap" as const, fontSize:12, color:"#4A4A60"}}>
                    {!!l.nombre && <span>{l.nombre}</span>}
                    <span style={{fontSize:11, fontWeight:800, padding:"2px 9px", borderRadius:999,
                      color: insiste ? "#8a6d1a" : "#4A4A60",
                      background: insiste ? "rgba(184,147,42,0.14)" : "rgba(0,0,0,0.05)",
                      border:`1px solid ${insiste ? "rgba(184,147,42,0.35)" : "rgba(0,0,0,0.10)"}`}}>
                      {n === 1 ? "1 intento" : `${n} intentos`}
                    </span>
                    {insiste && <span style={{fontSize:11.5, color:"#8a6d1a", fontWeight:700}}>Lleva rato esperando</span>}
                  </div>
                </div>
              );
            })}
          </div>
        )}
        {tabActual === "leads" && leadSub === "contratos" && (
          <div style={{display:"flex", flexDirection:"column" as const, gap:8}}>
            {/* ESTE FLUJO ESTÁ CERRADO, y la pestaña lo dice en vez de fingir que
                sigue vivo. El único sitio que escribía en `contratos_leads` era un
                panel que pedía el correo antes de descargar el contrato, y ese
                panel llevaba tiempo sin montarse en ninguna pantalla. Lo que hay
                aquí es historia: gente real que dejó su correo cuando funcionaba,
                y por eso no se borra ni se esconde. Pero no van a entrar más. */}
            <div style={{background:"rgba(184,147,42,0.08)", border:"1px solid rgba(184,147,42,0.30)",
              borderRadius:10, padding:"10px 13px", marginBottom:10, fontSize:12, color:"#5A4A18", lineHeight:1.6}}>
              <strong style={{color:"#3F340F"}}>Esta lista ya no crece.</strong> El Generador legal es un módulo de pago,
              así que a nadie se le pide el correo para descargar un contrato: quien genera uno ya es cliente.
              Lo de abajo es lo que se recogió cuando el generador estaba abierto al público.
            </div>
            <div style={{fontSize:12, color:"#9A9AAA", marginBottom:4}}>
              {contratosLeads.length === 1 ? "1 contrato generado en su momento" : `${contratosLeads.length} contratos generados en su momento`}
            </div>
            {/* Stats por tipo */}
            {(() => {
              const tipos: Record<string,number> = {};
              contratosLeads.forEach((c:any) => { tipos[c.tipoContrato] = (tipos[c.tipoContrato]||0)+1; });
              return (
                <div style={{display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:10, marginBottom:12}}>
                  {Object.entries(tipos).map(([tipo,count]) => (
                    <div key={tipo} style={{background:"white", borderRadius:10, padding:"12px 14px", border:`1px solid ${T_LIGHT.borderCard}`}}>
                      <div style={{fontFamily:fontSerif, fontSize:22, fontWeight:700, color:"#059669"}}>{count}</div>
                      <div style={{fontSize:11, color:"#9A9AAA", marginTop:2}}>{tipo}</div>
                    </div>
                  ))}
                </div>
              );
            })()}
            {leadsFallo["contratos_leads"] ? (
              <CajaNoSePudoLeer que="los registros de contratos" detalle={leadsFallo["contratos_leads"]} onReintentar={cargarContratos}/>
            ) : contratosLeads.length === 0 ? (
              <div style={{textAlign:"center" as const, padding:40, background:"white", borderRadius:14, border:`1px solid ${T_LIGHT.borderCard}`}}>
                <div style={{marginBottom:10, display:"flex", justifyContent:"center"}}>
                  <AxisIcon name="document" size={30} tone="gold" withBackdrop={false} strokeWidth={2.5}/>
                </div>
                <div style={{fontSize:14, color:"#0B1829", fontWeight:600, marginBottom:4}}>Aquí no quedó ningún registro</div>
                <div style={{fontSize:12.5, color:"#4A4A60", lineHeight:1.6, maxWidth:420, margin:"0 auto"}}>
                  Nadie dejó su correo mientras el generador estuvo abierto al público, y ya no se pide.
                </div>
              </div>
            ) : contratosLeads.map((c:any) => (
              <div key={c.id} style={{background:"white", border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:12, padding:"12px 16px", borderLeft:"4px solid #059669"}}>
                <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:6, flexWrap:"wrap" as const, gap:4}}>
                  <div style={{display:"flex", alignItems:"center", gap:8}}>
                    <AxisIcon name="document" size={14} tone="gold" withBackdrop={false} strokeWidth={3}/>
                    <span style={{fontWeight:700, fontSize:14, color:"#0B1829"}}>{c.tipoContrato}</span>
                    {c.usuarioRegistrado && <span style={{fontSize:10, color:"#059669", background:"rgba(5,150,105,0.08)", padding:"2px 8px", borderRadius:10}}>Usuario registrado</span>}
                  </div>
                  <span style={{fontSize:11, color:"#9A9AAA"}}>{c.fecha}</span>
                </div>
                <span style={{fontSize:12, color:"#4A4A60", display:"inline-flex", alignItems:"center", gap:5}}>
                  <AxisIcon name="mail" size={11} tone="gold" withBackdrop={false} strokeWidth={3}/>
                  {c.correo}
                </span>
              </div>
            ))}
          </div>
        )}

        {tabActual === "config" && (
          <div style={{display:"flex", flexDirection:"column" as const, gap:12}}>
            {/* La prueba del recordatorio de entrada (13-oct-2026): solo aquí, en el panel del administrador. */}
            <PanelPruebaRecordatorio user={user} fontSans={fontSans}/>
            <div style={{display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:10}}>
              {[
                {label:"PRO activos", val:usuariosPro.filter((u:any)=>u.activo).length, color:"#B8932A"},
                {label:"Inactivos", val:usuariosPro.filter((u:any)=>!u.activo).length, color:"#DC2626"},
                {label:"Total", val:usuariosPro.length, color:"#162447"},
              ].map((s,i)=>(
                <div key={i} style={{background:"white",borderRadius:10,padding:"12px",border:`1px solid ${T_LIGHT.borderCard}`,textAlign:"center" as const}}>
                  <div style={{fontFamily:fontSerif,fontSize:22,fontWeight:800,color:s.color}}>{s.val}</div>
                  <div style={{fontSize:11,color:"#9A9AAA",marginTop:2}}>{s.label}</div>
                </div>
              ))}
            </div>
            <div style={{background:"rgba(184,147,42,0.06)",border:"1px solid rgba(184,147,42,0.2)",borderRadius:14,padding:"16px 18px"}}>
              <div style={{fontFamily:fontSerif,fontSize:14,fontWeight:700,color:"#B8932A",marginBottom:10}}>⭐ Agregar usuario PRO</div>
              <div style={{display:"flex",gap:10}}>
                <input value={nuevoCorreo} onChange={e=>setNuevoCorreo(e.target.value)}
                  onKeyDown={e=>e.key==="Enter"&&agregarUsuarioPro()}
                  type="email" placeholder="correo@empresa.mx"
                  style={{flex:1,padding:"10px 13px",border:"1px solid rgba(184,147,42,0.3)",borderRadius:10,fontSize:13,outline:"none",boxSizing:"border-box" as const}} />
                <button onClick={agregarUsuarioPro} disabled={agregandoPro||!nuevoCorreo.includes("@")}
                  style={{background:nuevoCorreo.includes("@")?"linear-gradient(135deg,#B8932A,#A07C30)":"rgba(0,0,0,0.08)",border:"none",borderRadius:10,padding:"10px 18px",cursor:"pointer",fontSize:13,fontWeight:700,color:nuevoCorreo.includes("@")?"white":"#9A9AAA"}}>
                  {agregandoPro?"...":"+ Agregar"}
                </button>
              </div>
              <div style={{fontSize:11,color:"rgba(184,147,42,0.7)",marginTop:8}}>El acceso se activa en el próximo inicio de sesión del usuario.</div>
            </div>
            {/* FECHA DE CORTE — solo afecta a las métricas HISTÓRICAS (altas por mes
                y uso del mes). El listado de cuentas y los conteos por cuenta son
                estado presente: no se recortan, porque "cuántos empleados tiene hoy"
                no depende de cuándo empezamos a medir. Recortar el detalle por
                cuenta exigiría índices compuestos y queda fuera a propósito. */}
            <div style={{background:"rgba(184,147,42,0.06)",border:"1px solid rgba(184,147,42,0.2)",borderRadius:14,padding:"16px 18px"}}>
                <div style={{fontFamily:fontSerif,fontSize:14,fontWeight:700,color:"#B8932A",marginBottom:6}}>Fecha de corte de métricas</div>
                <div style={{fontSize:11,color:"rgba(184,147,42,0.7)",marginBottom:10}}>
                  {fechaCorte ? `Registro desde ${_fechaCortaMX(fechaCorte)}` : "Sin corte: se cuenta todo el histórico."}
                </div>
                <div style={{display:"flex",gap:10,flexWrap:"wrap" as const}}>
                  <input type="date" value={nuevaFechaCorte} onChange={(e:any)=>setNuevaFechaCorte(e.target.value)}
                    style={{flex:1,minWidth:170,padding:"10px 13px",border:"1px solid rgba(184,147,42,0.3)",borderRadius:10,fontSize:13,outline:"none",boxSizing:"border-box" as const}} />
                  <button onClick={guardarFechaCorte} disabled={guardandoCorte}
                    style={{background:"linear-gradient(135deg,#B8932A,#A07C30)",border:"none",borderRadius:10,padding:"10px 18px",cursor:"pointer",color:"white",fontWeight:700,fontSize:13}}>
                    {guardandoCorte?"...":"Guardar"}
                  </button>
                  {fechaCorte && (
                    <button onClick={()=>{ setNuevaFechaCorte(""); }} disabled={guardandoCorte}
                      style={{background:"transparent",border:`1px solid ${T_LIGHT.borderCard}`,borderRadius:10,padding:"10px 14px",cursor:"pointer",color:"#4A4A60",fontWeight:600,fontSize:12.5}}>
                      Quitar corte
                    </button>
                  )}
                </div>
                <div style={{fontSize:11,color:"rgba(184,147,42,0.7)",marginTop:8}}>
                  Afecta a altas por mes y uso del mes. El total de cuentas, las activas y el detalle por cuenta son estado presente y no se recortan.
                </div>
              </div>

              {/* CHECADAS INALTERABLES · FECHA DE CORTE. Una sola vez, con
                  confirmación; si ya existe, el botón no aparece y se ve la fecha. */}
              <div style={{background:"rgba(15,29,53,0.04)",border:"1px solid rgba(15,29,53,0.15)",borderRadius:14,padding:"16px 18px"}}>
                <div style={{fontFamily:fontSerif,fontSize:14,fontWeight:700,color:"#0F1D35",marginBottom:6}}>Checadas inalterables · fecha de corte</div>
                {corteChecadas.estado==="con" ? (
                  <div style={{fontSize:12.5,color:"#4A4A60",lineHeight:1.55}}>
                    Fijada el <b>{corteChecadas.desde ? fechaLargaAxis(enHoraDeMexico(corteChecadas.desde)) : "—"}</b>{corteChecadas.desde ? ` a las ${horaMexicoCorta(corteChecadas.desde)} (hora de México)` : ""}. No se puede cambiar ni borrar. La bitácora y el registro mensual ya lo dicen.
                  </div>
                ) : corteChecadas.estado==="sin" ? (<>
                  <div style={{fontSize:12,color:"#4A4A60",lineHeight:1.55,marginBottom:10}}>
                    Todavía no está fijada. Se fija una sola vez, con la hora del servidor, y no se puede cambiar ni borrar. Desde esa fecha, la bitácora y el registro mensual dirán que los registros del checador no se pueden modificar ni borrar desde la plataforma.
                  </div>
                  <button onClick={fijarCorteChecadas} disabled={fijandoCorte}
                    style={{background:"#0F1D35",border:"none",borderRadius:10,padding:"10px 18px",cursor:fijandoCorte?"wait":"pointer",color:"white",fontWeight:700,fontSize:13}}>
                    {fijandoCorte ? "Fijando…" : "Fijar la fecha de corte"}
                  </button>
                </>) : corteChecadas.estado==="cargando" ? (
                  <div style={{fontSize:12,color:"#9A9AAA"}}>Leyendo…</div>
                ) : null}
                {corteMsg && <div style={{fontSize:12,color:"#B3261E",marginTop:8}}>{corteMsg}</div>}
              </div>

              {usuariosPro.map((u:any) => (
              <div key={u.id} style={{background:"white",border:`1px solid ${u.activo?"rgba(184,147,42,0.2)":"rgba(220,38,38,0.15)"}`,borderRadius:12,padding:"14px 18px",borderLeft:`4px solid ${u.activo?"#B8932A":"#DC2626"}`}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap" as const,gap:8}}>
                  <div>
                    <div style={{fontWeight:700,fontSize:13,color:"#0F1D35"}}>📧 {u.correo}</div>
                    <div style={{fontSize:11,color:"#9A9AAA"}}>Alta: {u.fechaAlta} · {u.activo?"✓ Activo":"✗ Inactivo"}</div>
                  </div>
                  <div style={{display:"flex",gap:8}}>
                    <button onClick={()=>toggleUsuarioPro(u.id,u.activo)}
                      style={{background:u.activo?"rgba(220,38,38,0.08)":"rgba(5,150,105,0.08)",border:`1px solid ${u.activo?"rgba(220,38,38,0.2)":"rgba(5,150,105,0.2)"}`,borderRadius:8,padding:"5px 12px",cursor:"pointer",fontSize:11,fontWeight:700,color:u.activo?"#DC2626":"#059669"}}>
                      {u.activo?"Suspender":"Activar"}
                    </button>
                    <button onClick={()=>eliminarUsuarioPro(u.id,u.correo)}
                      style={{background:"rgba(220,38,38,0.06)",border:"1px solid rgba(220,38,38,0.15)",borderRadius:8,padding:"5px 10px",cursor:"pointer",fontSize:11,color:"#DC2626"}}>🗑️</button>
                  </div>
                </div>
              </div>
            ))}
            {/* ── MUDANZA DE LA CONFIGURACIÓN DE EMPRESA ───────────────────
                De un solo uso. Mueve el horario general y el centro de trabajo de
                usuarios/{uid} —que solo lee su dueño— a configuracion_empresa/{uid},
                que leen el patrón y sus trabajadores. Es lo que hace innecesaria la
                copia del horario en cada ficha. */}
            <div style={{background:"white",border:`1px solid ${T_LIGHT.borderCard}`,borderRadius:14,padding:"16px 18px",marginTop:16}}>
              <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:12,flexWrap:"wrap" as const}}>
                <div>
                  <div style={{fontFamily:fontSerif,fontSize:15,fontWeight:700,color:"#0F172A"}}>Mudar la configuración de las empresas</div>
                  <div style={{fontSize:11.5,color:"#6B7280",marginTop:2,lineHeight:1.5,maxWidth:600}}>
                    El horario general y el centro de trabajo pasan a un documento que <b>los trabajadores también pueden leer</b>.
                    {" "}Es lo que hace que ya no haga falta copiarles el horario a cada ficha, que era la causa de que quien se daba
                    {" "}de alta después se quedara sin horario. Se pulsa una vez; lo ya migrado no se toca.
                  </div>
                </div>
                <button onClick={migrarConfigEmpresa} disabled={migrandoCfg}
                  style={{background:"#B8932A",color:"#0B1829",border:"none",borderRadius:10,padding:"10px 18px",
                    cursor:migrandoCfg?"wait":"pointer",fontSize:12.5,fontWeight:800,fontFamily:fontSans,flexShrink:0}}>
                  {migrandoCfg ? "Mudando…" : "Mudar ahora"}
                </button>
              </div>
              <div style={{fontSize:11,color:"#9A9AAA",marginTop:9,lineHeight:1.5}}>
                Requiere que las reglas de <code>configuracion_empresa</code> estén publicadas. Si no lo están, ninguna cuenta se moverá
                {" "}y el aviso lo dirá con el código del error.
              </div>
              {/* SEGUNDA MUDANZA, la del NOMBRE. Va aquí y no en la misma tarjeta
                  porque mueve otra cosa y tiene su propio conteo. */}
              <div style={{borderTop:`1px solid ${T_LIGHT.borderCard}`,marginTop:14,paddingTop:14,display:"flex",alignItems:"center",justifyContent:"space-between",gap:12,flexWrap:"wrap" as const}}>
                <div style={{fontSize:11.5,color:"#6B7280",lineHeight:1.5,maxWidth:600}}>
                  <b style={{color:"#0F172A"}}>Mudar el nombre de cada empresa.</b> El nombre vivía en cuatro campos distintos según la época
                  {" "}(<code>empresa</code>, <code>razonSocial</code>, <code>nombreEmpresa</code>, <code>negocio</code>); esto los resuelve en ese orden y lo deja
                  {" "}en un solo sitio. El RFC, el domicilio y el correo de contacto no existían antes: los captura cada patrón.
                </div>
                <button onClick={migrarDenominaciones} disabled={migrandoDen}
                  style={{background:"#236478",color:"white",border:"none",borderRadius:10,padding:"10px 18px",
                    cursor:migrandoDen?"wait":"pointer",fontSize:12.5,fontWeight:800,fontFamily:fontSans,flexShrink:0}}>
                  {migrandoDen ? "Mudando…" : "Mudar los nombres"}
                </button>
              </div>
            </div>

            {/* ── QUIÉN ENTRA CUANDO SE CIERRE LA PUERTA ────────────────────
                Una línea por bloque y el porqué detrás de "¿por qué?". Estaba
                explicada a fondo en la superficie —rutas, ids, renombres— y eso
                obliga a leer un manual para tomar una decisión de tres opciones. */}
            <div style={{background:"white",border:`1px solid ${T_LIGHT.borderCard}`,borderRadius:14,padding:"16px 18px",marginTop:16}}>
              <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:12,flexWrap:"wrap" as const}}>
                <div>
                  <div style={{fontFamily:fontSerif,fontSize:15,fontWeight:700,color:"#0F172A"}}>Quién entra cuando se cierre la puerta</div>
                  <div style={{fontSize:11.5,color:"#6B7280",marginTop:2,lineHeight:1.5,maxWidth:560}}>
                    Los trabajadores entran <b>por su patrón</b>: quitar un correo de la lista deja fuera a todo su equipo.
                  </div>
                </div>
                <button onClick={cargarPrevia} disabled={cargandoPrevia}
                  style={{background:"#0F172A",color:"white",border:"none",borderRadius:10,padding:"10px 16px",
                    cursor:cargandoPrevia?"wait":"pointer",fontSize:12.5,fontWeight:700,fontFamily:fontSans,flexShrink:0}}>
                  {cargandoPrevia ? "Calculando…" : previaCargada ? "Recalcular" : "Calcular"}
                </button>
              </div>

              {previaCargada && (<>
                {/* ── 1. LO QUE HAY QUE ARREGLAR — un recuadro, un botón ─────
                    Eran dos avisos amarillos que señalaban los mismos documentos
                    y se resolvían con el mismo botón. */}
                {previa.pendientes > 0 ? (
                  <div style={{marginTop:14,background:"rgba(184,147,42,0.10)",border:"1.5px solid rgba(184,147,42,0.45)",borderRadius:12,padding:"13px 15px"}}>
                    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:12,flexWrap:"wrap" as const}}>
                      <div style={{fontSize:13.5,fontWeight:700,color:"#8a6d1a"}}>
                        {previa.pendientes} {previa.pendientes===1?"registro todavía no autoriza":"registros todavía no autorizan"} a nadie
                        {botonPorQue("arreglar")}
                      </div>
                      {previa.autoArreglables > 0 && (
                        <button onClick={()=>arreglarPendientes(previa.reparables, previa.porRellenar)} disabled={migrando}
                          style={{background:"#B8932A",color:"#0B1829",border:"none",borderRadius:9,padding:"9px 18px",
                            cursor:migrando?"wait":"pointer",fontSize:13,fontWeight:800,fontFamily:fontSans,flexShrink:0}}>
                          {migrando ? "Arreglando…" : "Arreglar"}
                        </button>
                      )}
                    </div>
                    {porQue==="arreglar" && (
                      <div style={{marginTop:9,fontSize:11.5,color:"#6B7280",lineHeight:1.55}}>
                        La puerta busca a cada cuenta por su correo exacto. Estos documentos están guardados con otro
                        {" "}nombre —un identificador antiguo, o con mayúsculas— así que la puerta no da con ellos y es como
                        {" "}si no estuvieran en la lista. <b>Arreglar</b> los vuelve a guardar con el correo correcto y
                        {" "}anota en cada cuenta de trabajador el correo de su patrón, que es de donde hereda el acceso.
                      </div>
                    )}
                    {previa.manuales > 0 && (
                      <div style={{marginTop:11,background:"white",border:"1px solid rgba(220,38,38,0.3)",borderRadius:10,padding:"10px 12px"}}>
                        <div style={{fontSize:12.5,fontWeight:700,color:"#B3261E"}}>
                          {previa.manuales} {previa.manuales===1?"no se arregla":"no se arreglan"} con el botón
                        </div>
                        <div style={{fontSize:11.5,color:"#6B7280",marginTop:2,lineHeight:1.5}}>
                          No hay forma de saber a qué patrón pertenecen, o cambiarlas tocaría también su acceso. Revísalas una por una.
                        </div>
                        <div style={{marginTop:7,maxHeight:170,overflowY:"auto" as const,paddingRight:4}}>
                          {previa.listaInalcanzable.filter((x:any)=>!x._reparable).map((u:any)=>(
                            <div key={u.id} style={{fontSize:11.5,color:"#4A4A60",lineHeight:1.7,borderBottom:`1px solid ${T_LIGHT.borderCard}`,padding:"3px 0"}}>
                              Registro de la lista sin correo válido · <code style={{fontSize:11,color:"#B3261E"}}>{u.id}</code>
                            </div>
                          ))}
                          {previa.sinResolver.map((c:any)=>(
                            <div key={c.id} style={{fontSize:11.5,color:"#4A4A60",lineHeight:1.7,borderBottom:`1px solid ${T_LIGHT.borderCard}`,padding:"3px 0"}}>
                              {c._correo || c.id}{c.nombre?` · ${c.nombre}`:""} <span style={{color:"#9A9AAA"}}>· no se sabe de qué patrón es</span>
                            </div>
                          ))}
                          {previa.cuentasInalcanzables.map((c:any)=>(
                            <div key={c.id} style={{fontSize:11.5,color:"#4A4A60",lineHeight:1.7,borderBottom:`1px solid ${T_LIGHT.borderCard}`,padding:"3px 0"}}>
                              {c.nombre || c._correo} <span style={{color:"#9A9AAA"}}>· su correo está guardado como</span> <code style={{fontSize:11,color:"#B3261E"}}>{c.id}</code>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <div style={{marginTop:14,background:"rgba(5,150,105,0.08)",border:"1px solid rgba(5,150,105,0.3)",borderRadius:12,padding:"11px 13px",fontSize:12.5,color:"#047857",fontWeight:700}}>
                    No hay nada pendiente de arreglar.
                  </div>
                )}

                {/* ── 2. EL MARCADOR ─────────────────────────────────────────
                    Cuenta lo que habrá DESPUÉS de pulsar Arreglar. Un "0 entran"
                    provocado por dos registros que se arreglan con un botón no es
                    información, es un susto. */}
                <div style={{display:"flex",gap:10,marginTop:14,flexWrap:"wrap" as const}}>
                  <div style={{flex:"1 1 150px",background:"rgba(5,150,105,0.08)",border:"1px solid rgba(5,150,105,0.3)",borderRadius:10,padding:"12px 14px"}}>
                    <div style={{fontFamily:fontSerif,fontSize:24,fontWeight:800,color:"#047857"}}>{vistaPrevia.entran}</div>
                    <div style={{fontSize:11,color:"#6B7280",marginTop:2}}>cuentas entran</div>
                  </div>
                  <div style={{flex:"1 1 150px",background:"rgba(220,38,38,0.07)",border:"1px solid rgba(220,38,38,0.3)",borderRadius:10,padding:"12px 14px"}}>
                    <div style={{fontFamily:fontSerif,fontSize:24,fontWeight:800,color:"#B3261E"}}>{vistaPrevia.fuera}</div>
                    <div style={{fontSize:11,color:"#6B7280",marginTop:2}}>cuentas quedan fuera</div>
                  </div>
                </div>
                {previa.pendientes > 0 && (
                  <div style={{fontSize:11,color:"#8a6d1a",marginTop:6,lineHeight:1.5}}>Contando lo que arregla el botón de arriba.</div>
                )}

                {/* ── 3. QUIÉN ENTRA ─────────────────────────────────────────*/}
                <div style={{fontSize:11,fontWeight:700,color:"#047857",textTransform:"uppercase" as const,letterSpacing:"0.6px",margin:"18px 0 8px"}}>
                  Entran · {vistaPrevia.conAcceso.length}
                </div>
                {vistaPrevia.conAcceso.length===0 && <div style={{fontSize:12,color:"#9A9AAA",fontStyle:"italic" as const}}>Nadie todavía.</div>}
                {vistaPrevia.conAcceso.map((g:any)=>(
                  <div key={g.correo} style={{border:`1px solid ${T_LIGHT.borderCard}`,borderLeft:`3px solid ${g.esElAdmin?"#B8932A":"#059669"}`,borderRadius:10,padding:"10px 12px",marginBottom:8}}>
                    <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap" as const}}>
                      <span style={{fontSize:13,fontWeight:700,color:"#0F172A"}}>{g.correo}{g.nombre?` · ${g.nombre}`:""}</span>
                      {g.esElAdmin && (
                        <span style={{fontSize:10,fontWeight:800,padding:"2px 9px",borderRadius:999,border:"1px solid rgba(184,147,42,0.5)",background:"rgba(184,147,42,0.14)",color:"#8a6d1a"}}>
                          Administrador · siempre entra
                        </span>
                      )}
                    </div>
                    {/* EL EQUIPO DEL ADMINISTRADOR NO HEREDA DE isAdmin(). La puerta
                        deja entrar al admin por su correo, pero sus trabajadores
                        miran la LISTA, igual que los de cualquier otro patrón. */}
                    {g.esElAdmin && !g.autorizado ? (
                      <div style={{marginTop:5}}>
                        <div style={{fontSize:11.5,color:"#B3261E",lineHeight:1.5}}>
                          Tus trabajadores <b>no heredan tu acceso de administrador</b>: heredan de la lista. Si quieres que tu
                          {" "}equipo entre, tu correo tiene que estar en la lista aunque tú no lo necesites.
                        </div>
                        {/* NO dice "Autorizar": no se está autorizando a sí mismo, que ya
                            entra por isAdmin(). Lo que hace es habilitar a su equipo. */}
                        <button onClick={()=>toggleProDeCuenta(g.correo, null)} disabled={proCambiando===g.correo}
                          style={{marginTop:7,background:"rgba(184,147,42,0.14)",color:"#8a6d1a",border:"1px solid rgba(184,147,42,0.5)",
                            borderRadius:8,padding:"7px 13px",cursor:"pointer",fontSize:11.5,fontWeight:700,fontFamily:fontSans}}>
                          {proCambiando===g.correo ? "…" : "Agregar mi correo a la lista"}
                        </button>
                      </div>
                    ) : (
                      <div style={{fontSize:11.5,color:"#6B7280",marginTop:2}}>
                        {g.trabajadores.length===0 ? "sin trabajadores con cuenta" :
                          `${g.trabajadores.length} ${g.trabajadores.length===1?"trabajador entra con él":"trabajadores entran con él"}`}
                      </div>
                    )}
                    {g.trabajadores.length>0 && (
                      <div style={{marginTop:6,paddingLeft:12,borderLeft:`2px solid ${T_LIGHT.borderCard}`}}>
                        {g.trabajadores.map((tr:any)=>(
                          <div key={tr.id} style={{fontSize:11.5,color:"#4A4A60",lineHeight:1.7}}>
                            {tr._correo}{tr.nombre?` · ${tr.nombre}`:""}
                            {!g.autorizado && <span style={{color:"#B3261E"}}> · no entra</span>}
                            {tr.activo===false && <span style={{color:"#B3261E"}}> · {TEXTO_CUENTA_SUSPENDIDA}</span>}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}

                {/* ── 3B. EN LA LISTA, PERO SUSPENDIDOS ──────────────────────
                    Caían en "Cuentas sueltas" con la etiqueta "nunca estuvo en la
                    lista", que en su caso era falsa, y con un botón que decía
                    Autorizar cuando lo que hace falta es reactivar. */}
                {vistaPrevia.suspendidos.length > 0 && (<>
                  <div style={{fontSize:11,fontWeight:700,color:"#B45309",textTransform:"uppercase" as const,letterSpacing:"0.6px",margin:"18px 0 8px"}}>
                    En la lista, suspendidos · {vistaPrevia.suspendidos.length}
                    {botonPorQue("suspendidos")}
                  </div>
                  {porQue==="suspendidos" && (
                    <div style={{fontSize:11.5,color:"#6B7280",marginBottom:8,lineHeight:1.55}}>
                      Su correo sí está en la lista, pero el registro está desactivado, así que no entran —ni ellos ni su
                      {" "}equipo—. No hay que autorizarlos otra vez: basta con reactivarlos.
                    </div>
                  )}
                  {vistaPrevia.suspendidos.map((g:any)=>(
                    <div key={g.correo} style={{border:`1px solid ${T_LIGHT.borderCard}`,borderLeft:"3px solid #D97706",borderRadius:10,padding:"10px 12px",marginBottom:8}}>
                      <div style={{display:"flex",justifyContent:"space-between",gap:10,alignItems:"center",flexWrap:"wrap" as const}}>
                        <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap" as const}}>
                          <span style={{fontSize:13,fontWeight:700,color:"#0F172A"}}>{g.correo}{g.nombre?` · ${g.nombre}`:""}</span>
                          <span style={{fontSize:10,fontWeight:800,padding:"2px 9px",borderRadius:999,border:"1px solid rgba(217,119,6,0.45)",background:"rgba(217,119,6,0.12)",color:"#B45309"}}>
                            En la lista, suspendido · no entra
                          </span>
                        </div>
                        <button onClick={()=>toggleProDeCuenta(g.correo, g.docPro)} disabled={proCambiando===g.correo}
                          style={{background:"rgba(217,119,6,0.14)",color:"#B45309",border:"1px solid rgba(217,119,6,0.45)",borderRadius:8,
                            padding:"6px 11px",cursor:"pointer",fontSize:11.5,fontWeight:700,fontFamily:fontSans}}>
                          {proCambiando===g.correo ? "…" : "Reactivar"}
                        </button>
                      </div>
                      <div style={{fontSize:11.5,color:"#B45309",marginTop:2}}>
                        {g.trabajadores.length===0 ? "sin trabajadores con cuenta" :
                          `arrastra a ${g.trabajadores.length} ${g.trabajadores.length===1?"trabajador":"trabajadores"}`}
                      </div>
                      {g.trabajadores.length>0 && (
                        <div style={{marginTop:6,paddingLeft:12,borderLeft:`2px solid ${T_LIGHT.borderCard}`}}>
                          {g.trabajadores.map((tr:any)=>(
                            <div key={tr.id} style={{fontSize:11.5,color:"#4A4A60",lineHeight:1.7}}>{tr._correo}{tr.nombre?` · ${tr.nombre}`:""}</div>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </>)}

                {/* ── 4. QUIÉN QUEDA FUERA ───────────────────────────────────*/}
                <div style={{fontSize:11,fontWeight:700,color:"#B3261E",textTransform:"uppercase" as const,letterSpacing:"0.6px",margin:"18px 0 8px"}}>
                  Quedan fuera · {vistaPrevia.sinAcceso.length}
                  {botonPorQue("fuera")}
                </div>
                {porQue==="fuera" && (
                  <div style={{fontSize:11.5,color:"#6B7280",marginBottom:8,lineHeight:1.55}}>
                    Su correo no está en la lista —ni suspendido ni de ninguna otra forma—. Autorizar a uno hace entrar también a todo su equipo.
                  </div>
                )}
                {vistaPrevia.sinAcceso.length===0 && <div style={{fontSize:12,color:"#9A9AAA",fontStyle:"italic" as const}}>Ninguno.</div>}
                {vistaPrevia.sinAcceso.map((g:any)=>(
                  <div key={g.correo} style={{border:`1px solid ${T_LIGHT.borderCard}`,borderLeft:"3px solid #DC2626",borderRadius:10,padding:"10px 12px",marginBottom:8}}>
                    <div style={{display:"flex",justifyContent:"space-between",gap:10,alignItems:"center",flexWrap:"wrap" as const}}>
                      <div style={{fontSize:13,fontWeight:700,color:"#0F172A"}}>{g.correo}{g.nombre?` · ${g.nombre}`:""}</div>
                      <button onClick={()=>toggleProDeCuenta(g.correo, null)} disabled={proCambiando===g.correo}
                        style={{background:"rgba(5,150,105,0.12)",color:"#047857",border:"1px solid rgba(5,150,105,0.35)",borderRadius:8,
                          padding:"6px 11px",cursor:"pointer",fontSize:11.5,fontWeight:700,fontFamily:fontSans}}>
                        {proCambiando===g.correo ? "…" : "Autorizar"}
                      </button>
                    </div>
                    <div style={{fontSize:11.5,color:"#B3261E",marginTop:2}}>
                      {g.trabajadores.length===0 ? "sin trabajadores con cuenta" :
                        `arrastra a ${g.trabajadores.length} ${g.trabajadores.length===1?"trabajador":"trabajadores"}`}
                    </div>
                    {g.trabajadores.length>0 && (
                      <div style={{marginTop:6,paddingLeft:12,borderLeft:`2px solid ${T_LIGHT.borderCard}`}}>
                        {g.trabajadores.map((tr:any)=>(
                          <div key={tr.id} style={{fontSize:11.5,color:"#4A4A60",lineHeight:1.7}}>{tr._correo}{tr.nombre?` · ${tr.nombre}`:""}</div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}

                {/* ── 5. CUENTAS SUELTAS ─────────────────────────────────────*/}
                <div style={{fontSize:11,fontWeight:700,color:"#6B7280",textTransform:"uppercase" as const,letterSpacing:"0.6px",margin:"18px 0 8px"}}>
                  Cuentas sueltas · {vistaPrevia.sueltas.length}
                  {botonPorQue("sueltas")}
                </div>
                {porQue==="sueltas" && (
                  <div style={{fontSize:11.5,color:"#6B7280",marginBottom:8,lineHeight:1.55}}>
                    <b>Nunca han estado en la lista.</b> Se registraron por su cuenta y no son trabajador de nadie. No entran.
                  </div>
                )}
                {vistaPrevia.sueltas.length===0 && <div style={{fontSize:12,color:"#9A9AAA",fontStyle:"italic" as const}}>Ninguna.</div>}
                {vistaPrevia.sueltas.slice(0,60).map((u:any)=>(
                  <div key={u.id} style={{display:"flex",justifyContent:"space-between",gap:10,alignItems:"center",
                    borderBottom:`1px solid ${T_LIGHT.borderCard}`,padding:"6px 2px",fontSize:12,color:"#4A4A60",flexWrap:"wrap" as const}}>
                    <span>{u.email}{u.nombre?` · ${u.nombre}`:""}{u.esPrueba?" · prueba":""}</span>
                    <button onClick={()=>toggleProDeCuenta(u.email, null)} disabled={proCambiando===String(u.email||"").toLowerCase().trim()}
                      style={{background:"transparent",color:"#047857",border:"1px solid rgba(5,150,105,0.35)",borderRadius:8,
                        padding:"4px 10px",cursor:"pointer",fontSize:11,fontWeight:700,fontFamily:fontSans}}>Autorizar</button>
                  </div>
                ))}
                {vistaPrevia.sueltas.length>60 && (
                  <div style={{fontSize:11,color:"#9A9AAA",marginTop:6}}>Mostrando 60 de {vistaPrevia.sueltas.length}.</div>
                )}
              </>)}
            </div>
          </div>
        )}



      </div>
    </div>
  );
}


// #endregion
// ─── LANDING HOME — FREEMIUM ──────────────────────────────────────────────────
// ─── BOTÓN LEGAL REUTILIZABLE ─────────────────────────────────────────────────
function LegalBtn({label, tipo, gold, fontSans, fontSerif}: {
  label:string; tipo:"disclaimer"|"privacidad"; gold:string; fontSans:string; fontSerif:string;
}) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button onClick={()=>setOpen(true)}
        style={{background:"none", border:"none", fontSize:11, color:"rgba(184,147,42,0.45)", cursor:"pointer",
          padding:0, textDecoration:"underline", textUnderlineOffset:"2px", fontFamily:fontSans}}>
        {label}
      </button>
      {open && <ModalLegal tipo={tipo} onClose={()=>setOpen(false)} />}
    </>
  );
}


// ─── Pantalla de Créditos / Autoría ──────────────────────────────────
function AcercaDeScreen({onBack, fontSans, fontSerif, gold}: {
  onBack: ()=>void; fontSans: string; fontSerif: string; gold: string;
}) {
  const isMobile = window.innerWidth < 768;
  return (
    <div style={{minHeight:"100vh", background:"#0B1829", color:"#E8E2D5", fontFamily:fontSans, padding: isMobile?"24px 16px 60px":"56px 32px 80px"}}>
      <div style={{maxWidth: 720, margin:"0 auto"}}>
        {/* Botón volver */}
        <button onClick={onBack} style={{
          background:"transparent", border:`1px solid ${gold}40`, color:gold,
          padding:"8px 16px", borderRadius:8, cursor:"pointer", fontFamily:fontSans,
          fontSize:13, marginBottom:32, transition:"all 0.2s ease"
        }}
        onMouseEnter={(e)=>{e.currentTarget.style.background=`${gold}15`}}
        onMouseLeave={(e)=>{e.currentTarget.style.background="transparent"}}>
          ← Volver
        </button>

        {/* Header */}
        <div style={{textAlign:"center", marginBottom:48}}>
          <div style={{fontSize:11, letterSpacing:"3px", color:gold, textTransform:"uppercase" as const, marginBottom:8}}>Créditos · Autoría · Producción</div>
          <h1 style={{fontFamily:fontSerif, fontSize: isMobile?28:36, fontWeight:600, margin:"0 0 12px", color:"#FEFAF0", letterSpacing:"-0.5px"}}>
            AXIS Legaltech
          </h1>
          <p style={{fontSize:14, color:"rgba(232,226,213,0.6)", margin:0, fontStyle:"italic"}}>
            Plataforma de cumplimiento regulatorio para PyMEs · México
          </p>
        </div>

        {/* Sección: Sobre la plataforma */}
        <Seccion titulo="Sobre la plataforma" gold={gold} fontSerif={fontSerif}>
          <p>AXIS Legaltech es una suite jurídica para el cumplimiento regulatorio de pequeñas y medianas empresas en México, con enfoque especial en el estado de Aguascalientes y la región Bajío. Integra diagnóstico regulatorio en 10 sectores económicos, calculadora laboral conforme a la LFT, generación de contratos, calendario de obligaciones y un asistente legal IA (AXIOR).</p>
        </Seccion>

        {/* Sección: Autoría intelectual */}
        <Seccion titulo="Autoría intelectual" gold={gold} fontSerif={fontSerif}>
          <p>La idea original, concepción del producto, arquitectura jurídica, diseño funcional y dirección integral del desarrollo de AXIS Legaltech son obra de:</p>
          <div style={{padding:"16px 20px", background:"rgba(212,168,67,0.08)", border:`1px solid ${gold}30`, borderRadius:10, margin:"16px 0"}}>
            <div style={{fontSize:18, fontFamily:fontSerif, fontWeight:600, color:gold, marginBottom:4}}>Los socios de AXIS Asesoría Legal Corporativa</div>
            <div style={{fontSize:13, color:"rgba(232,226,213,0.75)"}}>Javier Iván Acuña López · Marco Aurelio Hernández Parada · Lixandro Fabián Gutiérrez Ortiz</div>
          </div>
          <p>El proyecto fue concebido, dirigido y validado jurídicamente por los socios del despacho, quienes lideraron de forma conjunta las decisiones de diseño, modelado regulatorio y producto durante todo el ciclo de desarrollo.</p>
        </Seccion>

        {/* Sección: Producto institucional */}
        <Seccion titulo="Respaldo institucional" gold={gold} fontSerif={fontSerif}>
          <p>AXIS Legaltech es un producto de <strong style={{color:gold}}>AXIS Asesoría Legal Corporativa</strong>, despacho jurídico con sede en Aguascalientes, México, especializado en derecho corporativo, civil, mercantil, laboral, inmobiliario y de seguros para PyMEs.</p>
          <div style={{fontSize:13, color:"rgba(232,226,213,0.65)", marginTop:12}}>
            Socios fundadores del despacho:<br/>
            · Javier Iván Acuña López<br/>
            · Marco Aurelio Hernández Parada<br/>
            · Lixandro Fabián Gutiérrez Ortiz
          </div>
        </Seccion>

        {/* Sección: Implementación técnica */}
        <Seccion titulo="Implementación técnica" gold={gold} fontSerif={fontSerif}>
          <p>El desarrollo técnico de la plataforma se realizó bajo dirección de los socios de AXIS, con apoyo de herramientas de inteligencia artificial generativa para asistir en la implementación. La concepción del producto, las decisiones de diseño jurídico, la validación legal de cada módulo y la dirección del proyecto fueron íntegramente humanas y se mantuvieron bajo responsabilidad profesional directa de AXIS Asesoría Legal Corporativa.</p>
        </Seccion>

        {/* Sección: Protección legal */}
        <Seccion titulo="Protección legal" gold={gold} fontSerif={fontSerif}>
          <p>Esta obra se encuentra protegida por la <strong>Ley Federal del Derecho de Autor</strong> (LFDA), su Reglamento y los tratados internacionales aplicables en materia de derecho de autor y propiedad intelectual.</p>
          <p style={{margin:"12px 0 0"}}>El registro ante el <strong>Instituto Nacional del Derecho de Autor (INDAUTOR)</strong> se encuentra en trámite.</p>
          <p style={{margin:"12px 0 0", fontSize:12, color:"rgba(232,226,213,0.55)"}}>Cualquier reproducción, distribución, modificación o uso comercial no autorizado de esta plataforma o sus componentes está expresamente prohibido y será perseguido conforme a la legislación aplicable.</p>
        </Seccion>

        {/* Sección: Contacto */}
        <Seccion titulo="Contacto" gold={gold} fontSerif={fontSerif}>
          <p style={{margin:0}}>
            <strong style={{color:"#FEFAF0"}}>AXIS Asesoría Legal Corporativa</strong><br/>
            Torre Plaza Bosques, Int. 909<br/>
            Aguascalientes, Aguascalientes, México<br/>
            <a href="tel:4494251128" style={{color:gold, textDecoration:"none"}}>449 425 11 28</a><br/>
            <a href="https://axislegalags.com" target="_blank" rel="noreferrer" style={{color:gold, textDecoration:"none"}}>axislegalags.com</a>
          </p>
        </Seccion>

        {/* Footer del Créditos */}
        <div style={{marginTop:48, paddingTop:24, borderTop:`1px solid ${gold}20`, textAlign:"center"}}>
          <p style={{fontSize:11, color:"rgba(232,226,213,0.4)", margin:0, lineHeight:1.7}}>
            © 2026 AXIS Asesoría Legal Corporativa<br/>
            Concebido, diseñado y desarrollado por AXIS Asesoría Legal Corporativa<br/>
            Todos los derechos reservados
          </p>
        </div>
      </div>
    </div>
  );
}

// Helper de sección para AcercaDeScreen
function Seccion({titulo, gold, fontSerif, children}: {titulo:string; gold:string; fontSerif:string; children: React.ReactNode}) {
  return (
    <section style={{marginBottom: 36}}>
      <h2 style={{fontFamily:fontSerif, fontSize:18, fontWeight:600, color:gold, margin:"0 0 14px", letterSpacing:"-0.2px"}}>
        {titulo}
      </h2>
      <div style={{fontSize:14, lineHeight:1.7, color:"rgba(232,226,213,0.85)"}}>
        {children}
      </div>
    </section>
  );
}


// ─── CRÉDITOS (Préstamos) — TIPOS Y MÓDULO ───────────────────────────────────
// Módulo de gestión de préstamos. Etapa 1: sólo deudores + expediente.
// Próximas etapas: créditos+amortización, pagos, score conductual, integración
// con dashboard/campana. Reutiliza el patrón de Proveedores/Expediente.
type DocumentoExpediente = {
  key?: string;           // si pertenece al checklist (ej. "ine")
  nombre: string;
  url: string;
  fecha: string;          // YYYY-MM-DD
};

type ScoreEvento = {
  fecha: string;          // ISO
  delta: number;
  motivo: string;
};

type DomicilioDeudor = {
  calle?: string;
  numero?: string;
  colonia?: string;
  municipio?: string;
  estado?: string;
  cp?: string;
};

type Aval = {
  nombre: string;
  relacion?: string;       // parentesco o relación con el deudor
  telefono?: string;
  direccion?: string;
  rfc?: string;
  notas?: string;
};

type Deudor = {
  id?: string;
  userId: string;
  nombre: string;
  rfc?: string;
  curp?: string;
  telefono?: string;
  email?: string;
  domicilio?: DomicilioDeudor;
  ocupacion?: string;
  ingresoAproximado?: number;          // declarado por el deudor — puede ser inexacto
  avales?: Aval[];                     // uno o varios
  score: number;                       // 0-100, default 70
  scoreHistorial: ScoreEvento[];       // [] inicial — se llena en Etapa 4
  documentos: DocumentoExpediente[];
  notas?: string;
  creadoEn: any;
};

// Checklist de documentos del expediente del deudor (hardcoded, como DOCS_VEHICULO).
// Los `opcional:true` NO cuentan para el "expediente completo" y se muestran
// con UI más suave (badge gris "Opcional", sin marcar rojo si faltan).
const DOCS_DEUDOR: Array<{key:string; label:string; opcional?:boolean}> = [
  {key:"ine",                label:"INE / Identificación oficial"},
  {key:"domicilio",          label:"Comprobante de domicilio"},
  {key:"ingresos",           label:"Comprobante de ingresos"},
  {key:"referencias",        label:"Referencias personales"},
  {key:"pagare",             label:"Pagaré firmado"},
  {key:"contrato",           label:"Contrato firmado"},
  {key:"garantia_predial",   label:"Documento de garantía (predial, propiedad del aval o deudor)", opcional:true},
  {key:"garantia_prendaria", label:"Garantía prendaria",                                           opcional:true},
];
const DOCS_DEUDOR_OBLIG = DOCS_DEUDOR.filter(d => !d.opcional);
const DOCS_DEUDOR_OPC   = DOCS_DEUDOR.filter(d =>  d.opcional);

// ─── CRÉDITOS — TIPOS + MATEMÁTICA DE AMORTIZACIÓN ────────────────────────
// Etapa 2: interés simple + pagos fijos. Toda la matemática es PURA y
// testeable a mano con calculadora. Última cuota absorbe el redondeo para
// que la suma de cuotas dé exactamente el total a pagar (regla estándar
// en préstamos personales — Iván validó este enfoque).
type FrecuenciaCredito = "semanal" | "quincenal" | "mensual";
type EstadoCredito = "al_corriente" | "atrasado" | "en_mora" | "liquidado" | "incobrable";
type EstadoCuota = "pendiente" | "pagada" | "vencida" | "parcial";

type CuotaAmortizacion = {
  numero: number;
  fechaVencimiento: string;          // YYYY-MM-DD
  cuota: number;
  interes: number;
  capital: number;
  saldoCapitalDespues: number;
  estadoCuota: EstadoCuota;
  montoPagado: number;
};

type Credito = {
  id?: string;
  userId: string;
  deudorId: string;
  // Términos pactados
  monto: number;                     // capital prestado (MXN)
  tasaAnual: number;                 // % anual (ej. 24 = 24%)
  frecuencia: FrecuenciaCredito;
  numeroPagos: number;
  fechaEmision: string;              // YYYY-MM-DD
  // Calculados al crear (se denormalizan para no recalcular en cada vista)
  pagoFijo: number;
  interesTotal: number;
  totalAPagar: number;
  tablaAmortizacion: CuotaAmortizacion[];
  // Estado vivo (se recalcula al registrar pagos — Etapa 3)
  saldoCapital: number;
  saldoTotal: number;
  proximoVencimiento: string;        // YYYY-MM-DD de la primera cuota pendiente
  // ⚠ CACHÉ, NO FUENTE DE VERDAD. Se recalcula SOLO al registrar un pago
  // (recalcularEstadoCredito), así que un crédito que vence sin que nadie lo toque
  // conserva este valor indefinidamente: decía "al corriente" con cuotas vencidas
  // de 25 días, y "en mora" en créditos ya saldados. Miente en las dos direcciones.
  //
  // NO LO USES PARA MOSTRAR NADA. Para pintar el estado en pantalla, deriva
  // siempre con `estadoCreditoDerivado(credito, hoyISO())`, que lo calcula desde
  // la tabla de amortización. Este campo solo es válido para filtrar por
  // `liquidado` e `incobrable`, que no envejecen con el calendario: el primero se
  // fija al registrar el pago que salda, el segundo es una marca manual.
  estado: EstadoCredito;
  // Otros
  documentos: DocumentoExpediente[];
  notas?: string;
  creadoEn: any;
};

const PERIODOS_POR_ANIO: Record<FrecuenciaCredito, number> = {
  semanal: 52, quincenal: 26, mensual: 12,
};
const FRECUENCIA_LABEL: Record<FrecuenciaCredito, string> = {
  semanal: "Semanal", quincenal: "Quincenal", mensual: "Mensual",
};
const FRECUENCIA_SINGULAR: Record<FrecuenciaCredito, string> = {
  semanal: "semana", quincenal: "quincena", mensual: "mes",
};
const ESTADO_CREDITO_META: Record<EstadoCredito, {label:string; color:string; bg:string}> = {
  al_corriente: {label:"Al corriente", color:"#059669", bg:"rgba(5,150,105,0.10)"},
  atrasado:     {label:"Atrasado",     color:"#D97706", bg:"rgba(217,119,6,0.10)"},
  en_mora:      {label:"En mora",      color:"#DC2626", bg:"rgba(220,38,38,0.10)"},
  liquidado:    {label:"Liquidado",    color:"#1E3A8A", bg:"rgba(30,58,138,0.10)"},
  incobrable:   {label:"Incobrable",   color:"#7C2D12", bg:"rgba(124,45,18,0.10)"},
};

const round2 = (n: number) => Math.round(n * 100) / 100;
const moneyMXN = (n: number) =>
  "$" + n.toLocaleString("es-MX", {minimumFractionDigits: 2, maximumFractionDigits: 2});

// Suma n periodos a una fecha YYYY-MM-DD.
// semanal: +7 días por periodo; quincenal: +14 días; mensual: +1 mes (mismo día).
function agregarPeriodos(fechaISO: string, n: number, freq: FrecuenciaCredito): string {
  const [y, m, d] = fechaISO.split("-").map(Number);
  const base = new Date(y, m - 1, d);
  if (freq === "semanal")        base.setDate(base.getDate() + 7 * n);
  else if (freq === "quincenal") base.setDate(base.getDate() + 14 * n);
  else                           base.setMonth(base.getMonth() + n);
  const yy = base.getFullYear();
  const mm = String(base.getMonth() + 1).padStart(2, "0");
  const dd = String(base.getDate()).padStart(2, "0");
  return `${yy}-${mm}-${dd}`;
}

// Calcula la amortización completa.
// Fórmula:
//   tasaPeriodo  = tasaAnual / 100 / periodosPorAño
//   interesTotal = monto × tasaPeriodo × numeroPagos      (interés simple)
//   totalAPagar  = monto + interesTotal
//   pagoFijo     = totalAPagar / numeroPagos
// Cada cuota carga la misma porción de interés y capital. La última cuota
// absorbe el redondeo para que sum(cuotas) === totalAPagar exacto.
function calcularAmortizacion(
  monto: number,
  tasaAnual: number,
  frecuencia: FrecuenciaCredito,
  numeroPagos: number,
  fechaEmision: string,
): {
  pagoFijo: number;
  interesTotal: number;
  totalAPagar: number;
  tablaAmortizacion: CuotaAmortizacion[];
} {
  const tasaPeriodo  = (tasaAnual / 100) / PERIODOS_POR_ANIO[frecuencia];
  const interesTotal = round2(monto * tasaPeriodo * numeroPagos);
  const totalAPagar  = round2(monto + interesTotal);
  const pagoFijo     = round2(totalAPagar / numeroPagos);
  const interesPorCuota = round2(interesTotal / numeroPagos);
  const capitalPorCuota = round2(monto / numeroPagos);

  const tabla: CuotaAmortizacion[] = [];
  let saldoCapital = monto;
  let sumCuotas = 0, sumInteres = 0, sumCapital = 0;
  for (let i = 1; i <= numeroPagos; i++) {
    const esUltima = i === numeroPagos;
    let interes = interesPorCuota;
    let capital = capitalPorCuota;
    let cuota   = pagoFijo;
    if (esUltima) {
      interes = round2(interesTotal - sumInteres);
      capital = round2(monto       - sumCapital);
      cuota   = round2(totalAPagar - sumCuotas);
    }
    saldoCapital = round2(saldoCapital - capital);
    tabla.push({
      numero: i,
      fechaVencimiento: agregarPeriodos(fechaEmision, i, frecuencia),
      cuota, interes, capital,
      saldoCapitalDespues: esUltima ? 0 : saldoCapital,
      estadoCuota: "pendiente",
      montoPagado: 0,
    });
    sumCuotas  += cuota;
    sumInteres += interes;
    sumCapital += capital;
  }
  return { pagoFijo, interesTotal, totalAPagar, tablaAmortizacion: tabla };
}

// Checklist mínimo de documentos del crédito (pagaré + contrato del crédito,
// distintos del pagaré/contrato genérico del expediente del deudor).
const DOCS_CREDITO: Array<{key:string; label:string}> = [
  {key:"pagare_credito",   label:"Pagaré del crédito"},
  {key:"contrato_credito", label:"Contrato del crédito"},
];

// ─── PAGOS — TIPOS + RECÁLCULO ────────────────────────────────────────────
// Etapa 3: registrar abonos y recalcular saldo + estado del crédito.
//
// Diseño:
// 1) Los pagos viven en colección "pagos" con userId, creditoId, deudorId.
// 2) Cada pago + la actualización del crédito asociado se persisten en una
//    transacción atómica (writeBatch). Si una falla, ninguna se aplica —
//    NUNCA queda un pago huérfano sin actualizar el saldo del crédito.
// 3) El recálculo es PURO y determinístico: tomar la tabla de amortización
//    original (cuota/interes/capital/fechaVenc) + todos los pagos ordenados
//    cronológicamente, y aplicar pagos FIFO a las cuotas pendientes. Mismo
//    input → mismo resultado siempre. Esto permite recomputar la tabla
//    desde cero en cada cambio sin riesgo de drift.

type MedioPago = "efectivo" | "transferencia" | "deposito" | "cheque";
const MEDIO_LABEL: Record<MedioPago, string> = {
  efectivo: "Efectivo", transferencia: "Transferencia", deposito: "Depósito", cheque: "Cheque",
};
const ESTADO_CUOTA_META: Record<EstadoCuota, {label:string; color:string; bg:string}> = {
  pendiente: {label:"Pendiente", color:"#6B7280", bg:"rgba(107,114,128,0.10)"},
  pagada:    {label:"Pagada",    color:"#059669", bg:"rgba(5,150,105,0.10)"},
  vencida:   {label:"Vencida",   color:"#DC2626", bg:"rgba(220,38,38,0.10)"},
  parcial:   {label:"Parcial",   color:"#D97706", bg:"rgba(217,119,6,0.10)"},
};

type Pago = {
  id?: string;
  userId: string;
  creditoId: string;
  deudorId: string;             // denormalizado para queries cross-deudor
  fecha: string;                // YYYY-MM-DD del abono
  monto: number;
  medio?: MedioPago;
  referencia?: string;
  notas?: string;
  creadoEn: any;
};

// Aplica una lista de pagos (ordenados por fecha) a la tabla de amortización.
// Devuelve la tabla nueva con estadoCuota y montoPagado actualizados según
// hoy (que solo se usa para distinguir "vencida" de "pendiente").
// FIFO: cada peso del pago va a la cuota más antigua aún no totalmente pagada.
function aplicarPagosATabla(
  tablaOriginal: CuotaAmortizacion[],
  pagos: Pago[],
  hoyISO: string,
): CuotaAmortizacion[] {
  // Copia profunda — no mutamos la tabla original
  const tabla = tablaOriginal.map(c => ({...c, estadoCuota: "pendiente" as EstadoCuota, montoPagado: 0}));
  // Ordenar pagos por fecha ASC y aplicar acumulando
  const pagosOrdenados = [...pagos].sort((a,b) => (a.fecha||"").localeCompare(b.fecha||""));
  let bolsa = round2(pagosOrdenados.reduce((s,p) => s + (Number(p.monto)||0), 0));
  for (const c of tabla) {
    if (bolsa <= 0) break;
    const aplicar = Math.min(bolsa, c.cuota);
    c.montoPagado = round2(aplicar);
    bolsa = round2(bolsa - aplicar);
  }
  // Etiquetar estadoCuota
  for (const c of tabla) {
    if (c.montoPagado >= c.cuota - 0.005) {
      c.estadoCuota = "pagada";
    } else if (c.montoPagado > 0) {
      c.estadoCuota = "parcial";
    } else if (c.fechaVencimiento < hoyISO) {
      c.estadoCuota = "vencida";
    } else {
      c.estadoCuota = "pendiente";
    }
  }
  return tabla;
}

// Recalcula los campos vivos del crédito a partir de la tabla nueva y los pagos.
// NO toca: estado "incobrable" (es manual del dueño, se preserva tal cual).
// El cálculo de "atrasado / en_mora" usa los días de atraso de la cuota
// vencida más antigua sin pagar completa.
function recalcularEstadoCredito(
  credito: any,
  pagos: Pago[],
  hoyISO: string,
): {
  estado: EstadoCredito;
  saldoCapital: number;
  saldoTotal: number;
  proximoVencimiento: string;
  tablaAmortizacion: CuotaAmortizacion[];
} {
  const tabla = aplicarPagosATabla(credito.tablaAmortizacion || [], pagos, hoyISO);
  const totalPagado = round2(pagos.reduce((s,p) => s + (Number(p.monto)||0), 0));
  const saldoTotal  = round2((credito.totalAPagar||0) - totalPagado);
  // Capital aún no abonado: sumamos cuota.capital de cuotas no pagadas y la
  // parte proporcional de cuotas parciales.
  let saldoCapital = 0;
  for (const c of tabla) {
    if (c.estadoCuota === "pagada") continue;
    if (c.estadoCuota === "parcial") {
      // Lo pagado primero cubre interés (criterio conservador del prestamista)
      const aCapital = Math.max(0, c.montoPagado - c.interes);
      saldoCapital += round2(c.capital - aCapital);
    } else {
      saldoCapital += c.capital;
    }
  }
  saldoCapital = round2(saldoCapital);

  // Próxima cuota pendiente (cualquiera no totalmente pagada)
  const proximaPendiente = tabla.find(c => c.estadoCuota !== "pagada");
  const proximoVencimiento = proximaPendiente?.fechaVencimiento || credito.fechaEmision;

  // Estado final
  let estado: EstadoCredito;
  if (credito.estado === "incobrable") {
    estado = "incobrable";                   // preservar marca manual
  } else if (saldoTotal <= 0.01) {
    estado = "liquidado";
  } else {
    // Días de atraso de la cuota vencida más antigua sin completar
    const vencidaMasAntigua = tabla.find(c => c.estadoCuota === "vencida" || (c.estadoCuota === "parcial" && c.fechaVencimiento < hoyISO));
    if (!vencidaMasAntigua) {
      estado = "al_corriente";
    } else {
      const venc = new Date(vencidaMasAntigua.fechaVencimiento + "T12:00:00");
      const hoy  = new Date(hoyISO + "T12:00:00");
      const diasAtraso = Math.floor((hoy.getTime() - venc.getTime()) / 86400000);
      estado = diasAtraso > 30 ? "en_mora" : "atrasado";
    }
  }
  return { estado, saldoCapital, saldoTotal, proximoVencimiento, tablaAmortizacion: tabla };
}

// Helper para hoy en YYYY-MM-DD (zona local del navegador).
const hoyISO = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`;
};

// ─── SCORE CONDUCTUAL ─────────────────────────────────────────────────────
// El score del deudor se RECALCULA DESDE CERO en cada cambio (es
// determinístico). Eso garantiza que eliminar un pago revierta el efecto sin
// necesidad de "deshacer" eventos guardados. Mismo input → mismo output.
//
// Reglas (acordadas con Iván):
//   • Score base: 70 / 100
//   • Cuota puntual o anticipada (atraso ≤ 0d): +2
//   • Cuota con 1–7 días de atraso:               0
//   • Cuota con 8–30 días de atraso:             −3
//   • Cuota con >30 días de atraso:              −8
//   • Crédito liquidado completo:                +10
//   • Crédito marcado incobrable:                −20
//   • Clamp final a [0, 100]
//
// "Días de atraso de una cuota" = (fecha del pago que la COMPLETÓ al 100%)
//   − (fecha de vencimiento de la cuota). Una cuota sólo se evalúa cuando
//   queda 100% pagada — los pagos parciales no producen evento todavía.

const SCORE_BASE = 70;
const SCORE_MIN  = 0;
const SCORE_MAX  = 100;

function deltaPorAtraso(diasAtraso: number): number {
  if (diasAtraso <= 0)  return  +2;
  if (diasAtraso <= 7)  return   0;
  if (diasAtraso <= 30) return  -3;
  return -8;
}

function _diffDiasISO(desdeISO: string, hastaISO: string): number {
  // hasta − desde, en días. Usa noon para evitar DST/zona.
  const a = new Date(desdeISO + "T12:00:00").getTime();
  const b = new Date(hastaISO + "T12:00:00").getTime();
  return Math.floor((b - a) / 86400000);
}

// Genera la línea de tiempo de eventos del deudor a partir de todos sus
// créditos y todos sus pagos. Devuelve {score, historial}.
function calcularScoreDeudor(creditos: any[], pagos: Pago[]): {
  score: number;
  historial: ScoreEvento[];
} {
  const eventos: ScoreEvento[] = [];

  for (const c of creditos) {
    const tabla: CuotaAmortizacion[] = c.tablaAmortizacion || [];
    if (tabla.length === 0) continue;
    const pagosCredito = pagos
      .filter(p => p.creditoId === c.id)
      .sort((a,b) => (a.fecha||"").localeCompare(b.fecha||""));

    // Simulamos acumulación de pagos en orden cronológico y detectamos en
    // qué momento se completa cada cuota.
    let acumulado = 0;
    let cuotaIdx = 0;
    let sumHastaCuota = 0;
    if (tabla[0]) sumHastaCuota = round2(tabla[0].cuota);

    for (const p of pagosCredito) {
      acumulado = round2(acumulado + (Number(p.monto) || 0));
      while (cuotaIdx < tabla.length && acumulado >= sumHastaCuota - 0.005) {
        const cuota = tabla[cuotaIdx];
        const dias  = _diffDiasISO(cuota.fechaVencimiento, p.fecha);
        const delta = deltaPorAtraso(dias);
        const motivo = dias <= 0
          ? `Cuota ${cuota.numero}: pago puntual`
          : `Cuota ${cuota.numero}: ${dias} día${dias!==1?"s":""} de atraso`;
        eventos.push({fecha: p.fecha, delta, motivo});
        cuotaIdx++;
        if (cuotaIdx < tabla.length) {
          sumHastaCuota = round2(sumHastaCuota + tabla[cuotaIdx].cuota);
        }
      }
    }

    // Bonus por liquidación completa (todas las cuotas pagadas)
    if (cuotaIdx === tabla.length && pagosCredito.length > 0) {
      const fechaCierre = pagosCredito[pagosCredito.length - 1].fecha;
      eventos.push({fecha: fechaCierre, delta: +10, motivo: `Crédito liquidado por ${moneyMXN(c.monto||0)}`});
    }

    // Penalización por incobrable (manual). Se usa fechaIncobrable si existe,
    // sino la fecha del último pago o la fecha de emisión.
    if (c.estado === "incobrable") {
      const fecha = c.fechaIncobrable
        || pagosCredito[pagosCredito.length - 1]?.fecha
        || c.fechaEmision
        || hoyISO();
      eventos.push({fecha, delta: -20, motivo: `Crédito marcado incobrable (${moneyMXN(c.monto||0)})`});
    }
  }

  // Aplicar cronológicamente con clamp
  eventos.sort((a,b) => (a.fecha||"").localeCompare(b.fecha||""));
  let score = SCORE_BASE;
  for (const e of eventos) {
    score = Math.max(SCORE_MIN, Math.min(SCORE_MAX, score + e.delta));
  }
  return { score, historial: eventos };
}

// Recalcula y persiste el score del deudor. Carga todos sus créditos y
// pagos, calcula, y hace un updateDoc(deudores). Se invoca DESPUÉS del
// commit atómico del pago/crédito — no es parte del mismo batch para
// mantener la lógica de saldo simple y aislada.
async function recalcularYGuardarScoreDeudor(
  db: ReturnType<typeof getFirestore>,
  userId: string,
  deudorId: string,
): Promise<void> {
  if (!userId || !deudorId) return;
  try {
    const [snapC, snapP] = await Promise.all([
      getDocs(query(collection(db,"creditos"), where("userId","==",userId), where("deudorId","==",deudorId))),
      getDocs(query(collection(db,"pagos"),    where("userId","==",userId), where("deudorId","==",deudorId))),
    ]);
    const creditos = snapC.docs.map(d => ({id:d.id, ...d.data()} as any));
    const pagos    = snapP.docs.map(d => ({id:d.id, ...d.data()} as Pago));
    const {score, historial} = calcularScoreDeudor(creditos, pagos);
    await updateDoc(doc(db,"deudores",deudorId), {
      score,
      scoreHistorial: historial,
    });
  } catch(e) {
    console.error("recalcularYGuardarScoreDeudor:", e);
    // Silencioso: el saldo del crédito ya quedó bien. El próximo cambio
    // recalcula. No vale la pena alertar al usuario.
  }
}

// ── FormCredito: sub-form para crear un nuevo crédito ────────────────────
// Muestra preview en vivo de pagoFijo / interesTotal / totalAPagar mientras
// el dueño llena los campos. Persiste en colección "creditos" al guardar.
function FormCredito({deudorId, userId, onCreado, onCancelar, fontSans, fontSerif, gold}: {
  deudorId: string; userId: string;
  onCreado: () => void; onCancelar: () => void;
  fontSans: string; fontSerif: string; gold: string;
}) {
  const [monto, setMonto] = useState("");
  const [tasa, setTasa] = useState("");                       // % anual
  const [frecuencia, setFrecuencia] = useState<FrecuenciaCredito>("mensual");
  const [numPagos, setNumPagos] = useState("");
  const [fechaEmision, setFechaEmision] = useState(() => new Date().toISOString().slice(0,10));
  const [guardando, setGuardando] = useState(false);
  const isMobile = window.innerWidth < 768;
  const db = getFirestore();

  const montoN = parseFloat(monto);
  const tasaN  = parseFloat(tasa);
  const npN    = parseInt(numPagos, 10);
  const datosValidos = montoN > 0 && tasaN >= 0 && npN > 0 && !!fechaEmision;

  const preview = datosValidos
    ? calcularAmortizacion(montoN, tasaN, frecuencia, npN, fechaEmision)
    : null;

  const guardar = async () => {
    if (!datosValidos) return;
    setGuardando(true);
    try {
      const calc = calcularAmortizacion(montoN, tasaN, frecuencia, npN, fechaEmision);
      const nuevo = {
        userId, deudorId,
        monto: montoN,
        tasaAnual: tasaN,
        frecuencia,
        numeroPagos: npN,
        fechaEmision,
        pagoFijo:           calc.pagoFijo,
        interesTotal:       calc.interesTotal,
        totalAPagar:        calc.totalAPagar,
        tablaAmortizacion:  calc.tablaAmortizacion,
        saldoCapital:       montoN,
        saldoTotal:         calc.totalAPagar,
        proximoVencimiento: calc.tablaAmortizacion[0]?.fechaVencimiento || fechaEmision,
        estado:             "al_corriente" as EstadoCredito,
        documentos:         [],
        creadoEn:           Timestamp.now(),
      };
      await addDoc(collection(db,"creditos"), nuevo);
      avisarCambioDeAtencion();   // crédito nuevo: su primera cuota entra en la lista
      onCreado();
    } catch(e){ console.error(e); alert("Error al guardar el crédito"); }
    finally{ setGuardando(false); }
  };

  const lbl = {fontSize:10, color:UI.textoTenue, display:"block", marginBottom:5, textTransform:"uppercase" as const, letterSpacing:"0.5px"};
  const inp = {width:"100%", padding:"11px 13px", border:"1px solid rgba(0,0,0,0.12)", borderRadius:UI.rTarjeta, fontSize:14, outline:"none", boxSizing:"border-box" as const, fontFamily:fontSans};

  return (
    <div {...ZONA_DE_CAPTURA} style={{background:UI.hover, border:`1px solid ${T_LIGHT.goldBorder}`, borderRadius:UI.rPanel, padding:"18px 20px", marginBottom:16}}>
      <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr 1fr":"repeat(4,1fr)", gap:12, marginBottom:14}}>
        <div style={{gridColumn:isMobile?"1 / -1":"auto"}}>
          <label style={lbl}>Monto prestado (MXN) *</label>
          <input type="number" value={monto} onChange={e=>setMonto(e.target.value)} style={inp} placeholder="Ej. 10000"/>
        </div>
        <div>
          <label style={lbl}>Tasa anual (%) *</label>
          <input type="number" value={tasa} onChange={e=>setTasa(e.target.value)} style={inp} placeholder="Ej. 24"/>
        </div>
        <div>
          <label style={lbl}>Frecuencia *</label>
          <select value={frecuencia} onChange={e=>setFrecuencia(e.target.value as FrecuenciaCredito)} style={{...inp, cursor:"pointer"}}>
            <option value="semanal">Semanal</option>
            <option value="quincenal">Quincenal</option>
            <option value="mensual">Mensual</option>
          </select>
        </div>
        <div>
          <label style={lbl}>Núm. de pagos *</label>
          <input type="number" value={numPagos} onChange={e=>setNumPagos(e.target.value)} style={inp} placeholder="Ej. 10"/>
        </div>
        <div style={{gridColumn:isMobile?"1 / -1":"1 / 3"}}>
          <label style={lbl}>Fecha de emisión *</label>
          <input type="date" value={fechaEmision} onChange={e=>setFechaEmision(e.target.value)} style={inp}/>
        </div>
      </div>

      {/* Preview en vivo */}
      {preview ? (
        <div style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rTarjeta, padding:"14px 16px", marginBottom:14, display:"grid", gridTemplateColumns:isMobile?"1fr 1fr":"repeat(4,1fr)", gap:14}}>
          <div>
            <div style={{fontSize:10, color:UI.textoTenue, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"0.6px"}}>Pago fijo cada {FRECUENCIA_SINGULAR[frecuencia]}</div>
            <div style={{fontFamily:fontSerif, fontSize:20, color:"#1E3A8A", fontWeight:700, marginTop:3}}>{moneyMXN(preview.pagoFijo)}</div>
          </div>
          <div>
            <div style={{fontSize:10, color:UI.textoTenue, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"0.6px"}}>Interés total</div>
            <div style={{fontFamily:fontSerif, fontSize:20, color:UI.texto, fontWeight:700, marginTop:3}}>{moneyMXN(preview.interesTotal)}</div>
          </div>
          <div>
            <div style={{fontSize:10, color:UI.textoTenue, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"0.6px"}}>Total a pagar</div>
            <div style={{fontFamily:fontSerif, fontSize:20, color:UI.texto, fontWeight:700, marginTop:3}}>{moneyMXN(preview.totalAPagar)}</div>
          </div>
          <div>
            <div style={{fontSize:10, color:UI.textoTenue, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"0.6px"}}>Última cuota vence</div>
            <div style={{fontFamily:fontSerif, fontSize:14, color:UI.texto, fontWeight:700, marginTop:6}}>{preview.tablaAmortizacion[preview.tablaAmortizacion.length-1]?.fechaVencimiento || "—"}</div>
          </div>
        </div>
      ) : (
        <div style={{background:UI.hover, border:`1px dashed ${UI.divisor}`, borderRadius:UI.rTarjeta, padding:"12px 14px", marginBottom:14, fontSize:12, color:UI.textoTenue, textAlign:"center" as const}}>
          Llena monto, tasa y número de pagos para ver el cálculo en vivo.
        </div>
      )}

      <div style={{display:"flex", gap:8}}>
        <button onClick={onCancelar} style={{flex:1, background:"transparent", border:`1px solid ${UI.borde}`, color:UI.textoSuave, borderRadius:UI.rControl, padding:"10px", cursor:"pointer", fontSize:13, fontFamily:fontSans}}>Cancelar</button>
        <button onClick={guardar} disabled={!datosValidos||guardando} style={{flex:2, background:datosValidos?gold:"#ddd", border:"none", color:datosValidos?"#0B1829":"#999", borderRadius:UI.rControl, padding:"10px", cursor:datosValidos?"pointer":"not-allowed", fontSize:13, fontWeight:700, fontFamily:fontSans}}>{guardando?"Guardando...":"Guardar crédito"}</button>
      </div>
    </div>
  );
}

// ── DetalleCredito: vista de un crédito con su tabla de amortización ─────
// Etapa 2: solo lectura de la tabla + subida de documentos (pagaré, contrato).
// Etapa 3 agregará registro de pagos y recálculo de estado/saldo.
function DetalleCredito({credito, deudor, deudorNombre, onBack, onActualizado, fontSans, fontSerif, gold}: {
  credito: any; deudor?: any; deudorNombre: string;
  onBack: () => void; onActualizado: () => void;
  fontSans: string; fontSerif: string; gold: string;
}) {
  const [docs, setDocs] = useState<DocumentoExpediente[]>(credito.documentos || []);
  const [eliminando, setEliminando] = useState(false);
  // El membrete de los pagares de la serie: el patron, no la plataforma.
  const dpPagare = useDatosPatron(auth.currentUser?.uid).datos;
  // ── Pagos ──
  const [pagos, setPagos] = useState<Pago[]>([]);
  const [cargandoPagos, setCargandoPagos] = useState(true);
  const [showFormPago, setShowFormPago] = useState(false);
  const [pagoFecha, setPagoFecha] = useState(hoyISO());
  const [pagoMonto, setPagoMonto] = useState("");
  const [pagoMedio, setPagoMedio] = useState<MedioPago | "">("");
  const [pagoRef, setPagoRef] = useState("");
  const [pagoNotas, setPagoNotas] = useState("");
  const [guardandoPago, setGuardandoPago] = useState(false);
  const [eliminandoPagoId, setEliminandoPagoId] = useState<string|null>(null);
  const isMobile = window.innerWidth < 768;
  const db = getFirestore();

  // Estado DERIVADO, no el guardado: ese solo se recalcula al registrar un pago,
  // así que un crédito vencido hoy seguía mostrando su insignia verde en su propio
  // expediente —la pantalla que más se parece a un estado de cuenta—.
  const _estadoVivo = estadoCreditoDerivado(credito, hoyISO());
  const meta = ESTADO_CREDITO_META[_estadoVivo] || ESTADO_CREDITO_META.al_corriente;
  const tabla: CuotaAmortizacion[] = credito.tablaAmortizacion || [];

  // ── Pagarés (REUSA el generador de pagaré; este módulo SOLO lee datos del crédito) ──
  const [genPagare, setGenPagare] = useState(false);
  const [nombreCuenta, setNombreCuenta] = useState("");
  const [serieEstado, setSerieEstado] = useState<{activo:boolean; hechos:number; total:number}>({activo:false, hechos:0, total:0});
  // Nombre del negocio de la cuenta → beneficiario por defecto (editable). Lectura
  // owner-scoped del propio doc de usuarios; si falla, el beneficiario se captura a mano.
  useEffect(() => {
    let cancel = false;
    (async () => {
      try { const us = await getDoc(doc(db,"usuarios",credito.userId)); if (!cancel && us.exists()) setNombreCuenta(((us.data() as any).nombre)||""); }
      catch(e){ /* opcional */ }
    })();
    return () => { cancel = true; };
  }, [credito.userId]);

  // Carga los pagos de este crédito. Filtra por userId (seguridad) Y creditoId.
  // Ordenamos en JS por fecha ASC (orden de aplicación FIFO).
  const cargarPagos = async () => {
    if (!credito.id || !credito.userId) { setCargandoPagos(false); return; }
    setCargandoPagos(true);
    try {
      const snap = await getDocs(query(collection(db,"pagos"),
        where("userId","==",credito.userId), where("creditoId","==",credito.id)));
      const lista = snap.docs.map(d => ({id:d.id, ...d.data()} as Pago))
        .sort((a,b) => (a.fecha||"").localeCompare(b.fecha||""));
      setPagos(lista);
    } catch(e){ console.error(e); }
    finally{ setCargandoPagos(false); }
  };
  useEffect(() => { cargarPagos(); /* eslint-disable-next-line */ }, [credito?.id]);

  // KPIs de pagos
  const totalPagado = round2(pagos.reduce((s,p) => s + (Number(p.monto)||0), 0));
  const saldoActual = round2((credito.totalAPagar||0) - totalPagado);
  const liquidadoOIncobrable = credito.estado === "liquidado" || credito.estado === "incobrable";

  const limpiarFormPago = () => {
    setPagoFecha(hoyISO()); setPagoMonto(""); setPagoMedio(""); setPagoRef(""); setPagoNotas("");
  };

  // Registra un pago Y actualiza el crédito en UNA SOLA TRANSACCIÓN ATÓMICA.
  // Si una falla, la otra tampoco se aplica.
  const registrarPago = async () => {
    if (!credito.id) return;
    if (liquidadoOIncobrable) { alert("No se pueden registrar pagos a un crédito liquidado o incobrable."); return; }
    const monto = parseFloat(pagoMonto);
    if (!(monto > 0)) { alert("El monto debe ser mayor a cero."); return; }
    if (monto > saldoActual + 0.005) { alert(`El monto excede el saldo pendiente (${moneyMXN(saldoActual)}).`); return; }
    if (!pagoFecha) { alert("La fecha del pago es obligatoria."); return; }
    setGuardandoPago(true);
    try {
      // 1) Construir el nuevo pago (con ref pre-asignada para batch)
      const pagoRef_ = doc(collection(db, "pagos"));
      const nuevoPago: Pago = {
        userId:    credito.userId,
        creditoId: credito.id,
        deudorId:  credito.deudorId,
        fecha:     pagoFecha,
        monto:     round2(monto),
        medio:     (pagoMedio || undefined) as MedioPago|undefined,
        referencia: pagoRef.trim() || undefined,
        notas:      pagoNotas.trim() || undefined,
        creadoEn:   Timestamp.now(),
      };
      // 2) Recalcular el crédito con el nuevo pago incluido
      const pagosConNuevo = [...pagos, {...nuevoPago, id: pagoRef_.id}];
      const recalc = recalcularEstadoCredito(credito, pagosConNuevo, hoyISO());
      // 3) Batch: pago + actualización del crédito juntos
      const batch = writeBatch(db);
      // Limpiar undefined antes de set (Firestore no acepta undefined)
      const pagoLimpio: any = {...nuevoPago};
      Object.keys(pagoLimpio).forEach(k => pagoLimpio[k] === undefined && delete pagoLimpio[k]);
      batch.set(pagoRef_, pagoLimpio);
      batch.update(doc(db,"creditos",credito.id), {
        estado:             recalc.estado,
        saldoCapital:       recalc.saldoCapital,
        saldoTotal:         recalc.saldoTotal,
        proximoVencimiento: recalc.proximoVencimiento,
        tablaAmortizacion:  recalc.tablaAmortizacion,
      });
      await batch.commit();
      // 4) Refrescar local
      setPagos(pagosConNuevo);
      setShowFormPago(false); limpiarFormPago();
      // 5) Recalcular score del deudor (operación posterior; si falla no
      //    revierte el pago — el siguiente cambio lo arregla)
      recalcularYGuardarScoreDeudor(db, credito.userId, credito.deudorId);
      onActualizado();
      avisarCambioDeAtencion();   // pago registrado: la cuota puede quedar cubierta
    } catch(e){ console.error(e); alert("Error al registrar el pago. No se aplicaron cambios."); }
    finally{ setGuardandoPago(false); }
  };

  // Eliminar un pago Y recalcular el crédito atómicamente.
  const eliminarPago = async (p: Pago) => {
    if (!p.id || !credito.id) return;
    const txt = `¿Eliminar el pago de ${moneyMXN(p.monto)} del ${p.fecha}? El saldo del crédito se recalculará automáticamente. NO se puede deshacer.`;
    if (!window.confirm(txt)) return;
    setEliminandoPagoId(p.id);
    try {
      const pagosRestantes = pagos.filter(x => x.id !== p.id);
      const recalc = recalcularEstadoCredito(credito, pagosRestantes, hoyISO());
      const batch = writeBatch(db);
      batch.delete(doc(db,"pagos",p.id));
      batch.update(doc(db,"creditos",credito.id), {
        estado:             recalc.estado,
        saldoCapital:       recalc.saldoCapital,
        saldoTotal:         recalc.saldoTotal,
        proximoVencimiento: recalc.proximoVencimiento,
        tablaAmortizacion:  recalc.tablaAmortizacion,
      });
      await batch.commit();
      setPagos(pagosRestantes);
      // Recalcular score (mismo principio que registrarPago)
      recalcularYGuardarScoreDeudor(db, credito.userId, credito.deudorId);
      onActualizado();
      avisarCambioDeAtencion();   // pago borrado: la cuota vuelve a deber
    } catch(e){ console.error(e); alert("Error al eliminar el pago. No se aplicaron cambios."); }
    finally{ setEliminandoPagoId(null); }
  };

  // ── Marcar / desmarcar incobrable ─────────────────────────────────────
  // Marcar: setea estado=incobrable y fechaIncobrable. El score del deudor
  // se penaliza en -20 vía recalcularYGuardarScoreDeudor.
  // Desmarcar: recalcula el estado real (liquidado / atrasado / en_mora /
  // al_corriente) a partir de los pagos actuales.
  const [cambiandoIncobrable, setCambiandoIncobrable] = useState(false);

  const marcarIncobrable = async () => {
    if (!credito.id) return;
    if (credito.estado === "liquidado") { alert("No tiene sentido marcar como incobrable un crédito ya liquidado."); return; }
    const txt = `¿Marcar este crédito de ${moneyMXN(credito.monto)} como INCOBRABLE? Esto bloquea nuevos pagos y penaliza el score del deudor en −20 puntos. Puedes desmarcarlo después si fue un error.`;
    if (!window.confirm(txt)) return;
    setCambiandoIncobrable(true);
    try {
      await updateDoc(doc(db,"creditos",credito.id), {
        estado: "incobrable" as EstadoCredito,
        fechaIncobrable: hoyISO(),
      });
      recalcularYGuardarScoreDeudor(db, credito.userId, credito.deudorId);
      onActualizado();
      avisarCambioDeAtencion();   // incobrable: deja de contar como cuota por cobrar
      onBack();   // salimos al expediente del deudor para ver el score actualizado
    } catch(e){ console.error(e); alert("Error al marcar como incobrable."); }
    finally{ setCambiandoIncobrable(false); }
  };

  const desmarcarIncobrable = async () => {
    if (!credito.id) return;
    const txt = `¿Desmarcar este crédito como incobrable? Su estado volverá a calcularse según los pagos registrados y el deudor recuperará los 20 puntos en su score.`;
    if (!window.confirm(txt)) return;
    setCambiandoIncobrable(true);
    try {
      // Para recalcular el estado real: pasarle a recalcularEstadoCredito una
      // copia del crédito con estado NO-incobrable (para que no preserve la marca)
      const creditoSinMarca = {...credito, estado: "al_corriente"};
      const recalc = recalcularEstadoCredito(creditoSinMarca, pagos, hoyISO());
      await updateDoc(doc(db,"creditos",credito.id), {
        estado:             recalc.estado,
        saldoCapital:       recalc.saldoCapital,
        saldoTotal:         recalc.saldoTotal,
        proximoVencimiento: recalc.proximoVencimiento,
        tablaAmortizacion:  recalc.tablaAmortizacion,
        fechaIncobrable:    null,
      });
      recalcularYGuardarScoreDeudor(db, credito.userId, credito.deudorId);
      onActualizado();
      avisarCambioDeAtencion();   // el crédito volvió a estar activo: sus cuotas vuelven
      onBack();
    } catch(e){ console.error(e); alert("Error al desmarcar incobrable."); }
    finally{ setCambiandoIncobrable(false); }
  };

  // Atraso del próximo vencimiento en días (>0 vencido, <=0 días para vencer)
  const proxVenc = credito.proximoVencimiento || "";
  let diasAlVenc: number | null = null;
  if (proxVenc && !liquidadoOIncobrable) {
    try {
      const v = new Date(proxVenc + "T12:00:00");
      const h = new Date(hoyISO() + "T12:00:00");
      diasAlVenc = Math.floor((v.getTime() - h.getTime()) / 86400000);
    } catch {}
  }

  // La tanda entera, en UNA escritura. Cuando la ranura es de UNA `key` concreta
  // —"la póliza", "el pagaré"— solo puede quedar un archivo: se queda el último de
  // la tanda, igual que antes se quedaba el último de las llamadas seguidas.
  const onDocSubido = async (key: string|undefined, archivos:{url:string; nombre:string}[]) => {
    const filtrados = key ? docs.filter(d => d.key !== key) : docs;
    const entran = key ? archivos.slice(-1) : archivos;
    const nuevo: DocumentoExpediente[] = [
      ...filtrados,
      ...entran.map((a)=>({key, nombre: a.nombre, url: a.url, fecha: new Date().toISOString().slice(0,10)})),
    ];
    try {
      await updateDoc(doc(db,"creditos",credito.id), {documentos: nuevo});
      setDocs(nuevo); onActualizado();
    } catch(e:any){ console.error(e); alert("No se pudo guardar el documento del credito: " + (e?.code || e?.message || "error desconocido")); }
  };
  const onDocEliminar = async (idx: number) => {
    if (!window.confirm("¿Eliminar este documento?")) return;
    const d = docs[idx];
    try { await eliminarArchivo(d.url); } catch(e){ console.error(e); }   // ver nota de huerfanos en ProveedorExpediente
    const nuevo = docs.filter((_,i)=>i!==idx);
    try {
      await updateDoc(doc(db,"creditos",credito.id), {documentos: nuevo});
      setDocs(nuevo); onActualizado();
    } catch(e:any){ console.error(e); alert("No se pudo quitar el documento del credito: " + (e?.code || e?.message || "error desconocido")); }
  };
  const docPorKey = (k: string) => docs.find(d => d.key === k);

  const eliminarCredito = async () => {
    const numPagos = pagos.length;
    const txt = `¿Eliminar este crédito de ${moneyMXN(credito.monto)}? Esta acción NO se puede deshacer y borra también la tabla de amortización${numPagos>0?` y los ${numPagos} pago${numPagos!==1?"s":""} asociado${numPagos!==1?"s":""}`:""}.`;
    if (!window.confirm(txt)) return;
    setEliminando(true);
    try {
      // Batch atómico: borrar crédito + todos sus pagos
      const batch = writeBatch(db);
      batch.delete(doc(db,"creditos",credito.id));
      for (const p of pagos) {
        if (p.id) batch.delete(doc(db,"pagos",p.id));
      }
      await batch.commit();
      // Recalcular score del deudor (ya sin este crédito ni sus pagos)
      recalcularYGuardarScoreDeudor(db, credito.userId, credito.deudorId);
      onActualizado();
      avisarCambioDeAtencion();   // crédito eliminado: sus cuotas salen de la lista
      onBack();
    } catch(e){ console.error(e); alert("Error al eliminar"); }
    finally{ setEliminando(false); }
  };

  // ── Datos del crédito → pagaré (SOLO LECTURA; no recalcula nada del crédito) ──
  const _ddom: any = (deudor && deudor.domicilio) || {};
  const deudorDomStr = [_ddom.calle, _ddom.numero].filter(Boolean).join(" ") +
    ([_ddom.colonia, _ddom.municipio, _ddom.estado, _ddom.cp].filter(Boolean).length
      ? ", " + [_ddom.colonia, _ddom.municipio, _ddom.estado, _ddom.cp].filter(Boolean).join(", ") : "");
  const tasaMensual = round2((credito.tasaAnual||0) / 12);   // % mensual ≈ anual / 12
  const ultimaCuota = tabla.length ? tabla[tabla.length-1] : null;
  const nombreDeudor = (deudor && deudor.nombre) || deudorNombre;

  // "GENERAR PAGARÉ" (uno solo): precarga FormPagare con el monto total del crédito.
  const prefillPagareUnico = {
    beneficiario: nombreCuenta,
    montoNumero: (credito.monto||0).toLocaleString("es-MX",{minimumFractionDigits:2, maximumFractionDigits: 2}),
    montoLetra: _pesosEnLetra(credito.monto||0),
    suscriptorNombre: nombreDeudor,
    suscriptorDomicilio: deudorDomStr,
    fechaSuscripcion: hoyISO(),
    fechaVencimiento: (ultimaCuota && ultimaCuota.fechaVencimiento) || credito.proximoVencimiento || "",
    interesOrdinario: String(tasaMensual),
  };

  // "GENERAR SERIE": un pagaré por parcialidad usando la tabla YA calculada.
  // Genera el PDF (plantilla compartida), lo sube, y SOLO si todos suben bien
  // hace UNA escritura con los N registros. Si algo falla: borra los PDFs ya
  // subidos (sin huérfanos) y NO escribe nada en Firestore.
  const generarSerie = async () => {
    if (!credito.id || !credito.deudorId) return;
    if (!tabla.length) { alert("Este crédito no tiene tabla de amortización."); return; }
    const N = tabla.length;
    const benef = window.prompt(`Beneficiario de los ${N} pagarés (tu negocio o razón social):`, nombreCuenta || "");
    if (benef === null) return;
    if (!window.confirm(`Se generarán ${N} pagarés (1/${N} … ${N}/${N}), uno por parcialidad, todos vinculados a ${nombreDeudor} y guardados en el Banco de documentos. ¿Continuar?`)) return;
    setSerieEstado({activo:true, hechos:0, total:N});
    const subidas: string[] = [];
    const registros: any[] = [];
    const baseFolio = (credito.id||"").slice(-5).toUpperCase();
    try {
      for (let i = 0; i < N; i++) {
        const cu = tabla[i];
        const datos = {
          folio: `PG-${baseFolio}`, serieX: String(cu.numero), serieN: String(N),
          montoNumero: (cu.cuota||0).toLocaleString("es-MX",{minimumFractionDigits:2, maximumFractionDigits: 2}),
          montoLetra: _pesosEnLetra(cu.cuota||0),
          beneficiario: benef,
          lugarSuscripcion: "Aguascalientes, Ags.", fechaSuscripcion: hoyISO(),
          lugarPago: "Aguascalientes, Ags.", fechaVencimiento: cu.fechaVencimiento,
          enParcialidades: false, numParcialidades:"", montoParcialidad:"", vencimientosParcialidades:"",
          interesOrdinario: String(tasaMensual), interesMoratorio: "",
          suscriptorNombre: nombreDeudor, suscriptorDomicilio: deudorDomStr, suscriptorIdentificacion: "",
          aval1Nombre:"", aval1Domicilio:"", aval2Nombre:"", aval2Domicilio:"",
        };
        const html = _construirPagareHTML(datos, dpPagare);
        const blob = await generarPDFDesdeHTML(html, `Pagare_${cu.numero}_de_${N}.pdf`);
        const fileName = `Pagare_${baseFolio}_${cu.numero}de${N}_${Date.now()}.pdf`;
        const url = await subirArchivo(credito.userId, "contratos_vinculados", new File([blob], fileName, {type:"application/pdf"}));
        subidas.push(url);
        registros.push({
          id: `c_${Date.now()}_${cu.numero}`, tipo: "pagare", fecha: hoyISO(),
          descripcion: `Pagaré ${cu.numero}/${N} · crédito ${moneyMXN(credito.monto)} · vence ${cu.fechaVencimiento}`,
          url, nombrePdf: fileName, creado: Timestamp.now(),
        });
        setSerieEstado({activo:true, hechos:i+1, total:N});
      }
      // Una sola escritura: relee el deudor y agrega los N registros (no pisa cambios concurrentes).
      const dref = doc(db,"deudores",credito.deudorId);
      const snap = await getDoc(dref);
      const actuales: any[] = (snap.exists() && (snap.data() as any).contratos) || [];
      await updateDoc(dref, {contratos: [...actuales, ...registros]});
      setSerieEstado({activo:false, hechos:N, total:N});
      onActualizado();
      alert(`Listo: ${N} pagarés (1/${N} … ${N}/${N}) quedaron vinculados a ${nombreDeudor} y en el Banco de documentos.`);
    } catch(e:any){
      console.error(e);
      for (const u of subidas) { try { await eliminarArchivo(u); } catch { /* ignora */ } }   // rollback: sin huérfanos
      setSerieEstado({activo:false, hechos:0, total:0});
      alert("No se pudo completar la serie. No se guardó nada y se limpiaron los archivos subidos. Intenta de nuevo.");
    }
  };

  // Vista "Generar pagaré" (uno solo): REUSA FormPagare con datos precargados y
  // lo vincula SIEMPRE al deudor del crédito (entidadFija oculta el selector).
  if (genPagare) {
    return <FormPagare
      user={{uid: credito.userId}} tipoContrato="pagare"
      prefill={prefillPagareUnico}
      entidadFija={{tipo:"deudor", id:credito.deudorId, nombre:nombreDeudor}}
      onBack={()=>setGenPagare(false)}
      fontSans={fontSans} fontSerif={fontSerif} gold={gold}
    />;
  }

  return (
    <div {...ZONA_DE_CAPTURA} style={{minHeight:"100vh", background:UI.fondo, fontFamily:fontSans}}>
      <div style={{background:T.navy, borderBottom:"1px solid rgba(184,147,42,0.24)", padding:isMobile?"14px 16px":"16px 32px", display:"flex", alignItems:"center", gap:14, position:"sticky" as const, top:0, zIndex:10, boxShadow:"0 2px 16px rgba(22,36,71,0.12)"}}>
        <button onClick={onBack} style={{background:"rgba(255,255,255,0.08)", border:"none", color:"white", borderRadius:UI.rControl, padding:"8px 14px", cursor:"pointer", fontSize:13, fontFamily:fontSans}}>← {deudorNombre}</button>
        <span style={{color:"white", fontWeight:700, fontSize:isMobile?15:17}}>Crédito · {moneyMXN(credito.monto)}</span>
      </div>

      <div style={{maxWidth:ANCHO_CONTENIDO, margin:"0 auto", padding:isMobile?"20px 16px":"28px 32px"}}>

        {/* Términos pactados */}
        <div style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rPanel, padding:"22px 24px", marginBottom:20, boxShadow:UI.sombra, borderLeft:`3px solid ${meta.color}`}}>
          <div style={{display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:14, flexWrap:"wrap" as const, marginBottom:14}}>
            <div>
              <div style={{fontFamily:fontSerif, fontSize:22, color:UI.texto, fontWeight:700}}>{moneyMXN(credito.monto)} a {credito.tasaAnual}% anual</div>
              <div style={{fontSize:12, color:UI.textoSuave, marginTop:4}}>
                {credito.numeroPagos} pagos {FRECUENCIA_LABEL[credito.frecuencia as FrecuenciaCredito].toLowerCase()}es · emitido {credito.fechaEmision}
              </div>
            </div>
            <span style={{background:meta.bg, color:meta.color, fontSize:12, padding:"6px 13px", borderRadius:UI.rControl, fontWeight:700, border:`1px solid ${meta.color}40`}}>{meta.label}</span>
          </div>
          <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr 1fr":"repeat(4,1fr)", gap:14, paddingTop:14, borderTop:`1px solid ${UI.divisor}`}}>
            <div>
              <div style={{fontSize:10, color:UI.textoTenue, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"0.6px"}}>Pago fijo</div>
              <div style={{fontFamily:fontSerif, fontSize:18, color:"#1E3A8A", fontWeight:700, marginTop:3}}>{moneyMXN(credito.pagoFijo)}</div>
            </div>
            <div>
              <div style={{fontSize:10, color:UI.textoTenue, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"0.6px"}}>Interés total</div>
              <div style={{fontFamily:fontSerif, fontSize:18, color:UI.texto, fontWeight:700, marginTop:3}}>{moneyMXN(credito.interesTotal)}</div>
            </div>
            <div>
              <div style={{fontSize:10, color:UI.textoTenue, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"0.6px"}}>Total a pagar</div>
              <div style={{fontFamily:fontSerif, fontSize:18, color:UI.texto, fontWeight:700, marginTop:3}}>{moneyMXN(credito.totalAPagar)}</div>
            </div>
            <div>
              <div style={{fontSize:10, color:UI.textoTenue, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"0.6px"}}>Saldo pendiente</div>
              <div style={{fontFamily:fontSerif, fontSize:18, color:credito.saldoTotal>0?UI.rojo:UI.ok, fontWeight:700, marginTop:3}}>{moneyMXN(credito.saldoTotal||0)}</div>
            </div>
          </div>
        </div>

        {/* Tabla de amortización con semáforo por cuota */}
        <div style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rPanel, padding:isMobile?"16px 14px":"20px 22px", marginBottom:20, boxShadow:UI.sombra}}>
          <h3 style={{color:UI.texto, fontFamily:fontSerif, fontSize:16, fontWeight:600, margin:"0 0 6px"}}>Tabla de amortización</h3>
          <p style={{fontSize:11, color:UI.textoSuave, margin:"0 0 14px", lineHeight:1.6}}>
            {credito.numeroPagos} cuotas. El semáforo muestra el estado de cada una según los pagos registrados.
          </p>
          <div style={{overflowX:"auto" as const, marginLeft:isMobile?-4:0, marginRight:isMobile?-4:0}}>
            <table style={{width:"100%", borderCollapse:"collapse" as const, fontSize:12, minWidth:isMobile?620:720}}>
              <thead>
                <tr style={{background:UI.hover}}>
                  <th style={{padding:"10px 8px", textAlign:"left" as const, fontWeight:700, color:UI.textoSuave, fontSize:11, textTransform:"uppercase" as const, letterSpacing:"0.5px", borderBottom:`1px solid ${UI.divisor}`}}>#</th>
                  <th style={{padding:"10px 8px", textAlign:"left" as const, fontWeight:700, color:UI.textoSuave, fontSize:11, textTransform:"uppercase" as const, letterSpacing:"0.5px", borderBottom:`1px solid ${UI.divisor}`}}>Vence</th>
                  <th style={{padding:"10px 8px", textAlign:"right" as const, fontWeight:700, color:UI.textoSuave, fontSize:11, textTransform:"uppercase" as const, letterSpacing:"0.5px", borderBottom:`1px solid ${UI.divisor}`}}>Cuota</th>
                  <th style={{padding:"10px 8px", textAlign:"right" as const, fontWeight:700, color:UI.textoSuave, fontSize:11, textTransform:"uppercase" as const, letterSpacing:"0.5px", borderBottom:`1px solid ${UI.divisor}`}}>Interés</th>
                  <th style={{padding:"10px 8px", textAlign:"right" as const, fontWeight:700, color:UI.textoSuave, fontSize:11, textTransform:"uppercase" as const, letterSpacing:"0.5px", borderBottom:`1px solid ${UI.divisor}`}}>Capital</th>
                  <th style={{padding:"10px 8px", textAlign:"right" as const, fontWeight:700, color:UI.textoSuave, fontSize:11, textTransform:"uppercase" as const, letterSpacing:"0.5px", borderBottom:`1px solid ${UI.divisor}`}}>Pagado</th>
                  <th style={{padding:"10px 8px", textAlign:"left"  as const, fontWeight:700, color:UI.textoSuave, fontSize:11, textTransform:"uppercase" as const, letterSpacing:"0.5px", borderBottom:`1px solid ${UI.divisor}`}}>Estado</th>
                </tr>
              </thead>
              <tbody>
                {tabla.map((c) => {
                  const em = ESTADO_CUOTA_META[c.estadoCuota as EstadoCuota] || ESTADO_CUOTA_META.pendiente;
                  return (
                    <tr key={c.numero} style={{borderBottom:`1px solid ${UI.divisor}`, borderLeft:`3px solid ${em.color}`}}>
                      <td style={{padding:"9px 8px", fontWeight:700, color:UI.texto}}>{c.numero}</td>
                      <td style={{padding:"9px 8px", color:UI.textoSuave, whiteSpace:"nowrap" as const}}>{c.fechaVencimiento}</td>
                      <td style={{padding:"9px 8px", textAlign:"right" as const, fontWeight:700, color:UI.texto, fontFamily:fontSerif}}>{moneyMXN(c.cuota)}</td>
                      <td style={{padding:"9px 8px", textAlign:"right" as const, color:UI.textoSuave}}>{moneyMXN(c.interes)}</td>
                      <td style={{padding:"9px 8px", textAlign:"right" as const, color:UI.textoSuave}}>{moneyMXN(c.capital)}</td>
                      <td style={{padding:"9px 8px", textAlign:"right" as const, color:c.montoPagado>0?em.color:UI.textoTenue, fontWeight:c.montoPagado>0?700:400}}>{c.montoPagado>0?moneyMXN(c.montoPagado):"—"}</td>
                      <td style={{padding:"9px 8px"}}>
                        <span style={{background:em.bg, color:em.color, fontSize:10, padding:"3px 8px", borderRadius:5, fontWeight:700, border:`1px solid ${em.color}40`, whiteSpace:"nowrap" as const}}>{em.label}</span>
                      </td>
                    </tr>
                  );
                })}
                <tr style={{background:UI.hover, fontWeight:700}}>
                  <td colSpan={2} style={{padding:"11px 8px", color:UI.texto}}>Total</td>
                  <td style={{padding:"11px 8px", textAlign:"right" as const, color:UI.texto, fontFamily:fontSerif}}>{moneyMXN(credito.totalAPagar)}</td>
                  <td style={{padding:"11px 8px", textAlign:"right" as const, color:UI.texto}}>{moneyMXN(credito.interesTotal)}</td>
                  <td style={{padding:"11px 8px", textAlign:"right" as const, color:UI.texto}}>{moneyMXN(credito.monto)}</td>
                  <td style={{padding:"11px 8px", textAlign:"right" as const, color:UI.ok}}>{moneyMXN(totalPagado)}</td>
                  <td/>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Pagarés del crédito — REUSA el generador de pagaré (no recalcula nada) */}
        <div style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rPanel, padding:isMobile?"16px 14px":"20px 22px", marginBottom:20, boxShadow:UI.sombra, borderLeft:"3px solid #92400E"}}>
          <h3 style={{color:UI.texto, fontFamily:fontSerif, fontSize:16, fontWeight:600, margin:"0 0 6px"}}>Pagarés</h3>
          <p style={{fontSize:11.5, color:UI.textoSuave, margin:"0 0 14px", lineHeight:1.6}}>
            Genera el pagaré con los datos de este crédito. Queda vinculado a <strong>{nombreDeudor}</strong> y en el Banco de documentos. Revisa siempre el borrador antes de firmar.
          </p>
          <div style={{display:"flex", gap:10, flexWrap:"wrap" as const}}>
            <button onClick={()=>setGenPagare(true)} disabled={serieEstado.activo}
              style={{background:"#92400E", border:"none", color:"white", borderRadius:UI.rTarjeta, padding:"11px 18px", cursor:serieEstado.activo?"not-allowed":"pointer", fontSize:13, fontWeight:700, fontFamily:fontSans, opacity:serieEstado.activo?0.6:1, display:"inline-flex", alignItems:"center", gap:8}}>
              📄 Generar pagaré
            </button>
            <button onClick={generarSerie} disabled={serieEstado.activo || !tabla.length}
              style={{background:"transparent", border:"1.5px solid #92400E", color:"#92400E", borderRadius:UI.rTarjeta, padding:"11px 18px", cursor:(serieEstado.activo||!tabla.length)?"not-allowed":"pointer", fontSize:13, fontWeight:700, fontFamily:fontSans, opacity:(serieEstado.activo||!tabla.length)?0.6:1, display:"inline-flex", alignItems:"center", gap:8}}>
              {serieEstado.activo ? `Generando ${serieEstado.hechos} de ${serieEstado.total}…` : `🧾 Generar serie (${tabla.length} pagaré${tabla.length===1?"":"s"})`}
            </button>
          </div>
          <p style={{fontSize:10.5, color:UI.textoTenue, margin:"10px 2px 0", lineHeight:1.5}}>
            <strong>Generar pagaré</strong>: uno solo por {moneyMXN(credito.monto)} (el monto del crédito). <strong>Generar serie</strong>: un pagaré por cada parcialidad (1/{tabla.length} … {tabla.length}/{tabla.length}), cada uno con su monto y vencimiento.
          </p>
        </div>

        {/* Pagos */}
        <div style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rPanel, padding:"20px 22px", marginBottom:20, boxShadow:UI.sombra}}>
          <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:8, flexWrap:"wrap" as const, gap:10}}>
            <h3 style={{color:UI.texto, fontFamily:fontSerif, fontSize:16, fontWeight:600, margin:0}}>
              Pagos registrados <span style={{fontSize:11, color:UI.textoSuave, fontWeight:600}}>({pagos.length})</span>
            </h3>
            {!showFormPago && !liquidadoOIncobrable && (
              <button onClick={()=>{ limpiarFormPago(); setShowFormPago(true); }} style={{background:gold, border:"none", color:"#0B1829", borderRadius:UI.rControl, padding:"8px 16px", cursor:"pointer", fontSize:12, fontWeight:700, fontFamily:fontSans}}>+ Registrar pago</button>
            )}
          </div>

          {/* KPI mini de pagos */}
          <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr 1fr":"repeat(3,1fr)", gap:10, marginBottom:14}}>
            <div style={{background:UI.hover, border:`1px solid ${UI.borde}`, borderRadius:UI.rTarjeta, padding:"10px 12px"}}>
              <div style={{fontSize:9, color:UI.textoTenue, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>Total pagado</div>
              <div style={{fontFamily:fontSerif, fontSize:18, color:UI.ok, fontWeight:700, marginTop:2}}>{moneyMXN(totalPagado)}</div>
            </div>
            <div style={{background:UI.hover, border:`1px solid ${UI.borde}`, borderRadius:UI.rTarjeta, padding:"10px 12px"}}>
              <div style={{fontSize:9, color:UI.textoTenue, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>Saldo pendiente</div>
              <div style={{fontFamily:fontSerif, fontSize:18, color:saldoActual>0.01?UI.rojo:UI.ok, fontWeight:700, marginTop:2}}>{moneyMXN(saldoActual)}</div>
            </div>
            <div style={{background:UI.hover, border:`1px solid ${UI.borde}`, borderRadius:UI.rTarjeta, padding:"10px 12px", gridColumn:isMobile?"1 / -1":"auto"}}>
              <div style={{fontSize:9, color:UI.textoTenue, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>Próximo vencimiento</div>
              <div style={{fontFamily:fontSerif, fontSize:15, color:UI.texto, fontWeight:700, marginTop:2}}>
                {liquidadoOIncobrable
                  ? "—"
                  : (<span>{proxVenc}{diasAlVenc!=null && (
                      <span style={{fontSize:11, fontWeight:600, marginLeft:6,
                        color: diasAlVenc<0 ? UI.rojo : (diasAlVenc<=7 ? "#D97706" : UI.textoSuave)}}>
                        {diasAlVenc<0 ? `(vencido ${Math.abs(diasAlVenc)}d)` : diasAlVenc===0 ? "(hoy)" : `(en ${diasAlVenc}d)`}
                      </span>
                    )}</span>)
                }
              </div>
            </div>
          </div>

          {/* Aviso si está liquidado/incobrable */}
          {liquidadoOIncobrable && (
            <div style={{background:meta.bg, border:`1px solid ${meta.color}55`, color:meta.color, borderRadius:UI.rTarjeta, padding:"10px 14px", marginBottom:14, fontSize:12, fontWeight:700}}>
              Crédito {meta.label.toLowerCase()}. No se pueden registrar nuevos pagos.
            </div>
          )}

          {/* Form de pago */}
          {showFormPago && !liquidadoOIncobrable && (
            <div style={{background:UI.hover, border:`1px solid ${T_LIGHT.goldBorder}`, borderRadius:UI.rPanel, padding:"16px 18px", marginBottom:14}}>
              <div style={{fontSize:11, color:UI.textoSuave, marginBottom:12, lineHeight:1.5}}>
                Saldo pendiente actual: <strong style={{color:UI.texto, fontFamily:fontSerif}}>{moneyMXN(saldoActual)}</strong> · El monto no puede exceder este saldo.
              </div>
              <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr 1fr":"repeat(4,1fr)", gap:12, marginBottom:12}}>
                <div>
                  <label style={{fontSize:10, color:UI.textoTenue, display:"block", marginBottom:5, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>Fecha *</label>
                  <input type="date" value={pagoFecha} onChange={e=>setPagoFecha(e.target.value)} style={{width:"100%", padding:"11px 13px", border:"1px solid rgba(0,0,0,0.12)", borderRadius:UI.rTarjeta, fontSize:14, outline:"none", boxSizing:"border-box" as const, fontFamily:fontSans}}/>
                </div>
                <div>
                  <label style={{fontSize:10, color:UI.textoTenue, display:"block", marginBottom:5, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>Monto (MXN) *</label>
                  <input type="number" value={pagoMonto} onChange={e=>setPagoMonto(e.target.value)} placeholder="0.00" style={{width:"100%", padding:"11px 13px", border:"1px solid rgba(0,0,0,0.12)", borderRadius:UI.rTarjeta, fontSize:14, outline:"none", boxSizing:"border-box" as const, fontFamily:fontSans}}/>
                </div>
                <div>
                  <label style={{fontSize:10, color:UI.textoTenue, display:"block", marginBottom:5, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>Medio</label>
                  <select value={pagoMedio} onChange={e=>setPagoMedio(e.target.value as MedioPago | "")} style={{width:"100%", padding:"11px 13px", border:"1px solid rgba(0,0,0,0.12)", borderRadius:UI.rTarjeta, fontSize:14, outline:"none", boxSizing:"border-box" as const, fontFamily:fontSans, cursor:"pointer", background:"white"}}>
                    <option value="">— Sin especificar —</option>
                    <option value="efectivo">Efectivo</option>
                    <option value="transferencia">Transferencia</option>
                    <option value="deposito">Depósito</option>
                    <option value="cheque">Cheque</option>
                  </select>
                </div>
                <div>
                  <label style={{fontSize:10, color:UI.textoTenue, display:"block", marginBottom:5, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>Referencia / Folio</label>
                  <input value={pagoRef} onChange={e=>setPagoRef(e.target.value)} placeholder="Opcional" style={{width:"100%", padding:"11px 13px", border:"1px solid rgba(0,0,0,0.12)", borderRadius:UI.rTarjeta, fontSize:14, outline:"none", boxSizing:"border-box" as const, fontFamily:fontSans}}/>
                </div>
                <div style={{gridColumn:isMobile?"1 / -1":"1 / -1"}}>
                  <label style={{fontSize:10, color:UI.textoTenue, display:"block", marginBottom:5, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>Notas</label>
                  <input value={pagoNotas} onChange={e=>setPagoNotas(e.target.value)} placeholder="Opcional" style={{width:"100%", padding:"11px 13px", border:"1px solid rgba(0,0,0,0.12)", borderRadius:UI.rTarjeta, fontSize:14, outline:"none", boxSizing:"border-box" as const, fontFamily:fontSans}}/>
                </div>
              </div>
              <div style={{display:"flex", gap:8}}>
                <button onClick={()=>{ setShowFormPago(false); limpiarFormPago(); }} style={{flex:1, background:"transparent", border:`1px solid ${UI.borde}`, color:UI.textoSuave, borderRadius:UI.rControl, padding:"10px", cursor:"pointer", fontSize:13, fontFamily:fontSans}}>Cancelar</button>
                <button onClick={registrarPago} disabled={guardandoPago || !pagoMonto || !pagoFecha} style={{flex:2, background:(pagoMonto&&pagoFecha)?gold:"#ddd", border:"none", color:(pagoMonto&&pagoFecha)?"#0B1829":"#999", borderRadius:UI.rControl, padding:"10px", cursor:(pagoMonto&&pagoFecha)?"pointer":"not-allowed", fontSize:13, fontWeight:700, fontFamily:fontSans}}>{guardandoPago?"Guardando...":"Registrar pago"}</button>
              </div>
            </div>
          )}

          {/* Lista de pagos */}
          {cargandoPagos ? (
            <div style={{textAlign:"center" as const, padding:"24px", color:UI.textoTenue, fontSize:13}}>Cargando pagos...</div>
          ) : pagos.length === 0 && !showFormPago ? (
            <div style={{textAlign:"center" as const, padding:"24px 20px", background:UI.hover, borderRadius:UI.rTarjeta, border:`1px dashed ${UI.divisor}`, color:UI.textoTenue, fontSize:13}}>
              Sin pagos registrados todavía.
            </div>
          ) : (
            <div style={{display:"flex", flexDirection:"column" as const, gap:8}}>
              {[...pagos].sort((a,b) => (b.fecha||"").localeCompare(a.fecha||"")).map((p) => (
                <div key={p.id} style={{display:"flex", alignItems:"center", gap:12, padding:"11px 14px", background:UI.hover, border:`1px solid ${UI.borde}`, borderLeft:`3px solid ${UI.ok}`, borderRadius:UI.rControl, fontSize:13, flexWrap:"wrap" as const}}>
                  <span style={{color:UI.textoSuave, fontSize:12, minWidth:90}}>{p.fecha}</span>
                  <span style={{fontFamily:fontSerif, color:UI.ok, fontWeight:700, fontSize:15, minWidth:100}}>{moneyMXN(p.monto)}</span>
                  <span style={{flex:1, minWidth:0, color:UI.textoSuave, fontSize:11}}>
                    {p.medio && <span style={{display:"inline-block", background:UI.hover, color:UI.textoSuave, padding:"2px 7px", borderRadius:5, border:`1px solid ${UI.borde}`, marginRight:6, fontWeight:600}}>{MEDIO_LABEL[p.medio]}</span>}
                    {p.referencia && <span style={{marginRight:8}}>folio {p.referencia}</span>}
                    {p.notas && <span style={{fontStyle:"italic" as const, color:UI.textoTenue}}>{p.notas}</span>}
                  </span>
                  <button onClick={()=>eliminarPago(p)} disabled={eliminandoPagoId===p.id} style={{background:"transparent", border:"none", color:UI.rojo, cursor:eliminandoPagoId===p.id?"not-allowed":"pointer", fontSize:14, padding:4, fontWeight:700}}>
                    {eliminandoPagoId===p.id ? "..." : "×"}
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Documentos del crédito */}
        <div style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rPanel, padding:"20px 22px", marginBottom:20, boxShadow:UI.sombra}}>
          <h3 style={{color:UI.texto, fontFamily:fontSerif, fontSize:16, fontWeight:600, margin:"0 0 14px"}}>Documentos del crédito</h3>
          <div style={{display:"flex", flexDirection:"column" as const, gap:8}}>
            {DOCS_CREDITO.map((c) => {
              const sub = docPorKey(c.key);
              const idxEnDocs = sub ? docs.findIndex(d => d.key === c.key) : -1;
              return (
                <div key={c.key} style={{display:"flex", alignItems:"center", justifyContent:"space-between", gap:10, background:UI.hover, border:`1px solid ${sub?UI.okBg:UI.borde}`, borderLeft:`3px solid ${sub?UI.ok:"#9A9AAA"}`, borderRadius:UI.rControl, padding:"10px 14px", flexWrap:"wrap" as const}}>
                  <div style={{flex:1, minWidth:160}}>
                    <div style={{fontSize:13, fontWeight:600, color:UI.texto}}>{c.label}</div>
                    {sub ? (
                      <a href={sub.url} target="_blank" rel="noopener noreferrer" style={{fontSize:11, color:gold, textDecoration:"none", display:"inline-block", marginTop:2}}>{sub.nombre} · {sub.fecha}</a>
                    ) : (
                      <div style={{fontSize:11, color:UI.textoTenue, marginTop:2}}>Pendiente</div>
                    )}
                  </div>
                  <div style={{display:"flex", gap:8, alignItems:"center"}}>
                    <SubirArchivoBtn
                      userId={credito.userId}
                      carpeta="creditos_docs"
                      label={sub?"Reemplazar":"Subir"}
                      accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                      maxMB={10}
                      onLote={(archivos)=>onDocSubido(c.key, archivos)}
                    />
                    {sub && idxEnDocs>=0 && (
                      <button onClick={()=>onDocEliminar(idxEnDocs)} style={{background:"transparent", border:"none", color:UI.rojo, cursor:"pointer", fontSize:12, fontWeight:700}}>Eliminar</button>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Zona peligrosa */}
        <div style={{background:"rgba(220,38,38,0.04)", border:`1px solid rgba(220,38,38,0.2)`, borderRadius:UI.rPanel, padding:"14px 18px", display:"flex", flexDirection:"column" as const, gap:12}}>
          {/* Marcar / desmarcar incobrable */}
          {credito.estado === "incobrable" ? (
            <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", gap:12, flexWrap:"wrap" as const}}>
              <div style={{fontSize:12, color:UI.textoSuave, lineHeight:1.5}}>
                Este crédito está marcado como <strong style={{color:UI.rojo}}>incobrable</strong>{credito.fechaIncobrable?` desde el ${credito.fechaIncobrable}`:""}. Restará −20 puntos del score del deudor hasta que lo desmarques.
              </div>
              <button onClick={desmarcarIncobrable} disabled={cambiandoIncobrable} style={{background:"transparent", border:`1px solid ${UI.textoSuave}`, color:UI.textoSuave, borderRadius:UI.rControl, padding:"8px 14px", cursor:cambiandoIncobrable?"not-allowed":"pointer", fontSize:12, fontWeight:700, fontFamily:fontSans, whiteSpace:"nowrap" as const}}>
                {cambiandoIncobrable?"Cambiando...":"Desmarcar incobrable"}
              </button>
            </div>
          ) : credito.estado !== "liquidado" && (
            <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", gap:12, flexWrap:"wrap" as const, paddingBottom:12, borderBottom:`1px solid rgba(220,38,38,0.15)`}}>
              <div style={{fontSize:12, color:UI.textoSuave, lineHeight:1.5}}>
                Marca el crédito como <strong>incobrable</strong> si el deudor ya no va a pagar. Bloquea nuevos pagos y penaliza el score en −20.
              </div>
              <button onClick={marcarIncobrable} disabled={cambiandoIncobrable} style={{background:"transparent", border:`1px solid #7C2D12`, color:"#7C2D12", borderRadius:UI.rControl, padding:"8px 14px", cursor:cambiandoIncobrable?"not-allowed":"pointer", fontSize:12, fontWeight:700, fontFamily:fontSans, whiteSpace:"nowrap" as const}}>
                {cambiandoIncobrable?"Marcando...":"Marcar incobrable"}
              </button>
            </div>
          )}
          {/* Eliminar crédito */}
          <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", gap:12, flexWrap:"wrap" as const}}>
            <div style={{fontSize:12, color:UI.textoSuave, lineHeight:1.5}}>
              Eliminar este crédito borra también su tabla de amortización y todos los pagos asociados. <strong>No se puede deshacer.</strong>
            </div>
            <button onClick={eliminarCredito} disabled={eliminando} style={{background:"transparent", border:`1px solid ${UI.rojo}`, color:UI.rojo, borderRadius:UI.rControl, padding:"8px 14px", cursor:eliminando?"not-allowed":"pointer", fontSize:12, fontWeight:700, fontFamily:fontSans, whiteSpace:"nowrap" as const}}>
              {eliminando?"Eliminando...":"Eliminar crédito"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function ExpedienteDeudor({deudor, onBack, onActualizado, onGoContratos, fontSans, fontSerif, gold, user, creditoInicialId}: {
  deudor: any; onBack: ()=>void; onActualizado: ()=>void;
  fontSans: string; fontSerif: string; gold: string; user: any;
  creditoInicialId?: string|null;
  onGoContratos: ()=>void;
}) {
  const [editando, setEditando] = useState(false);
  const [nombre, setNombre] = useState(deudor.nombre||"");
  const [rfc, setRfc] = useState(deudor.rfc||"");
  const [curp, setCurp] = useState(deudor.curp||"");
  const [telefono, setTelefono] = useState(deudor.telefono||"");
  const [email, setEmail] = useState(deudor.email||"");
  const [ocupacion, setOcupacion] = useState(deudor.ocupacion||"");
  const [ingreso, setIngreso] = useState(deudor.ingresoAproximado!=null?String(deudor.ingresoAproximado):"");
  const [dom, setDom] = useState<DomicilioDeudor>(deudor.domicilio||{});
  const [notas, setNotas] = useState(deudor.notas||"");
  const [docs, setDocs] = useState<DocumentoExpediente[]>(deudor.documentos||[]);
  const [contratos, setContratos] = useState<any[]>(deudor.contratos||[]);
  const [guardando, setGuardando] = useState(false);
  // ── Avales ──
  const [avales, setAvales] = useState<Aval[]>(deudor.avales||[]);
  const [showAvalForm, setShowAvalForm] = useState(false);
  const [avalEditIdx, setAvalEditIdx] = useState<number|null>(null);
  const [avNombre, setAvNombre] = useState("");
  const [avRelacion, setAvRelacion] = useState("");
  const [avTelefono, setAvTelefono] = useState("");
  const [avDireccion, setAvDireccion] = useState("");
  const [avRfc, setAvRfc] = useState("");
  const [avNotas, setAvNotas] = useState("");
  const [guardandoAval, setGuardandoAval] = useState(false);
  // ── Créditos del deudor ──
  const [creditos, setCreditos] = useState<any[]>([]);
  const [cargandoCreditos, setCargandoCreditos] = useState(true);
  const [showFormCredito, setShowFormCredito] = useState(false);
  const [creditoDetalle, setCreditoDetalle] = useState<any|null>(null);
  const _credInicialUsado = useRef(false);
  const [showScoreHistorial, setShowScoreHistorial] = useState(false);
  const isMobile = window.innerWidth < 768;
  const db = getFirestore();

  // Carga (o recarga) la lista de créditos de este deudor.
  // Filtra por userId (seguridad) Y deudorId (relación). Ordena en JS por
  // fecha de emisión DESC para evitar índices compuestos en Firestore.
  const cargarCreditos = async () => {
    if (!user?.uid || !deudor.id) { setCargandoCreditos(false); return; }
    setCargandoCreditos(true);
    try {
      const snap = await getDocs(query(collection(db,"creditos"),
        where("userId","==",user.uid), where("deudorId","==",deudor.id)));
      const lista = snap.docs.map(d => ({id:d.id, ...d.data()} as any))
        .sort((a,b) => (b.fechaEmision||"").localeCompare(a.fechaEmision||""));
      setCreditos(lista);
      // Último tramo del salto desde un aviso de cuota: el crédito concreto.
      if (creditoInicialId && !_credInicialUsado.current) {
        _credInicialUsado.current = true;
        const c0 = lista.find((x:any)=> x.id === creditoInicialId);
        if (c0) setCreditoDetalle(c0);
      }
      // Si hay un crédito abierto en detalle, refrescarlo
      if (creditoDetalle) {
        const r = lista.find(c => c.id === creditoDetalle.id);
        if (r) setCreditoDetalle(r);
      }
    } catch(e){ console.error(e); }
    finally{ setCargandoCreditos(false); }
  };
  useEffect(() => { cargarCreditos(); /* eslint-disable-next-line */ }, [deudor?.id, user?.uid]);

  const abrirNuevoAval = () => {
    setAvalEditIdx(null);
    setAvNombre(""); setAvRelacion(""); setAvTelefono(""); setAvDireccion(""); setAvRfc(""); setAvNotas("");
    setShowAvalForm(true);
  };
  const abrirEditarAval = (idx: number) => {
    const a = avales[idx]; if (!a) return;
    setAvalEditIdx(idx);
    setAvNombre(a.nombre||""); setAvRelacion(a.relacion||""); setAvTelefono(a.telefono||"");
    setAvDireccion(a.direccion||""); setAvRfc(a.rfc||""); setAvNotas(a.notas||"");
    setShowAvalForm(true);
  };
  const cerrarAvalForm = () => { setShowAvalForm(false); setAvalEditIdx(null); };
  const guardarAval = async () => {
    if (!avNombre.trim() || !deudor.id) return;
    setGuardandoAval(true);
    const nuevoAval: Aval = {
      nombre: avNombre.trim(),
      relacion: avRelacion.trim()||undefined,
      telefono: avTelefono.trim()||undefined,
      direccion: avDireccion.trim()||undefined,
      rfc: avRfc.trim().toUpperCase()||undefined,
      notas: avNotas.trim()||undefined,
    };
    const nuevo = avalEditIdx==null
      ? [...avales, nuevoAval]
      : avales.map((a,i) => i===avalEditIdx ? nuevoAval : a);
    try {
      await updateDoc(doc(db,"deudores",deudor.id), {avales: nuevo});
      setAvales(nuevo); cerrarAvalForm(); onActualizado();
    } catch(e){ console.error(e); alert("Error al guardar el aval"); }
    finally{ setGuardandoAval(false); }
  };
  const eliminarAval = async (idx: number) => {
    const a = avales[idx]; if (!a || !deudor.id) return;
    if (!window.confirm(`¿Eliminar al aval ${a.nombre}?`)) return;
    const nuevo = avales.filter((_,i) => i!==idx);
    try {
      await updateDoc(doc(db,"deudores",deudor.id), {avales: nuevo});
      setAvales(nuevo); onActualizado();
    } catch(e){ console.error(e); }
  };

  const guardarDatos = async () => {
    if (!deudor.id) return;
    if (!nombre.trim()) { alert("El nombre es obligatorio"); return; }
    setGuardando(true);
    try {
      await updateDoc(doc(db,"deudores",deudor.id), {
        nombre: nombre.trim(),
        rfc: rfc.trim().toUpperCase()||null,
        curp: curp.trim().toUpperCase()||null,
        telefono: telefono.trim()||null,
        email: email.trim()||null,
        ocupacion: ocupacion.trim()||null,
        ingresoAproximado: ingreso?parseFloat(ingreso):null,
        domicilio: {
          calle: dom.calle?.trim()||null,
          numero: dom.numero?.trim()||null,
          colonia: dom.colonia?.trim()||null,
          municipio: dom.municipio?.trim()||null,
          estado: dom.estado?.trim()||null,
          cp: dom.cp?.trim()||null,
        },
        notas: notas.trim()||null,
      });
      setEditando(false); onActualizado();
    } catch(e){ console.error(e); alert("Error al guardar"); }
    finally{ setGuardando(false); }
  };

  // Subir documento del checklist (con key) o uno suelto (sin key)
  // La tanda entera, en UNA escritura. Ver la nota del expediente de crédito.
  const onDocSubido = async (key: string|undefined, archivos:{url:string; nombre:string}[]) => {
    // Si ya había un doc para esa key, lo reemplazamos
    const filtrados = key ? docs.filter(d => d.key !== key) : docs;
    const entran = key ? archivos.slice(-1) : archivos;
    const nuevo: DocumentoExpediente[] = [
      ...filtrados,
      ...entran.map((a)=>({key, nombre: a.nombre, url: a.url, fecha: new Date().toISOString().slice(0,10)})),
    ];
    try {
      await updateDoc(doc(db,"deudores",deudor.id), {documentos: nuevo});
      setDocs(nuevo); onActualizado();
    } catch(e:any){ console.error(e); alert("No se pudo guardar el documento del deudor: " + (e?.code || e?.message || "error desconocido")); }
  };

  const onDocEliminar = async (idx: number) => {
    if (!window.confirm("¿Eliminar este documento?")) return;
    const d = docs[idx];
    try { await eliminarArchivo(d.url); } catch(e){ console.error(e); }   // ver nota de huerfanos en ProveedorExpediente
    const nuevo = docs.filter((_,i)=>i!==idx);
    try {
      await updateDoc(doc(db,"deudores",deudor.id), {documentos: nuevo});
      setDocs(nuevo); onActualizado();
    } catch(e:any){ console.error(e); alert("No se pudo quitar el documento del deudor: " + (e?.code || e?.message || "error desconocido")); }
  };

  // Por cada checklist key, el documento subido (si existe)
  const docPorKey = (k: string) => docs.find(d => d.key === k);
  const docsSueltos = docs.filter(d => !d.key);
  const docsObligCompletos = DOCS_DEUDOR_OBLIG.filter(c => docPorKey(c.key)).length;
  const docsOpcSubidos    = DOCS_DEUDOR_OPC.filter(c => docPorKey(c.key)).length;

  const lbl = {fontSize:10, color:UI.textoTenue, display:"block", marginBottom:5, textTransform:"uppercase" as const, letterSpacing:"0.5px"};
  const inp = {width:"100%", padding:"11px 13px", border:"1px solid rgba(0,0,0,0.12)", borderRadius:UI.rTarjeta, fontSize:14, outline:"none", boxSizing:"border-box" as const, fontFamily:fontSans};
  const dato = (etq:string, val:string) => (<div><div style={{fontSize:10, color:UI.textoTenue, textTransform:"uppercase" as const, letterSpacing:"0.5px", marginBottom:3, fontWeight:700}}>{etq}</div><div style={{fontSize:14, color:UI.texto}}>{val||"—"}</div></div>);

  const score = typeof deudor.score === "number" ? deudor.score : 70;
  const scoreColor = score >= 80 ? UI.ok : score >= 60 ? "#D97706" : UI.rojo;
  const scoreEtq   = score >= 80 ? "Bueno"        : score >= 60 ? "Aceptable" : "Bajo";

  const domStr = [dom.calle, dom.numero].filter(Boolean).join(" ") +
    ([dom.colonia, dom.municipio, dom.estado, dom.cp].filter(Boolean).length
      ? ", " + [dom.colonia, dom.municipio, dom.estado, dom.cp].filter(Boolean).join(", ")
      : "");

  // KPIs de créditos del deudor (Etapa 2: vigentes = no liquidados/incobrables)
  const creditosVigentes = creditos.filter(c => c.estado !== "liquidado" && c.estado !== "incobrable");
  const montoPrestadoVigente = creditosVigentes.reduce((s,c) => s + (Number(c.monto)||0), 0);
  const saldoVigente         = creditosVigentes.reduce((s,c) => s + (Number(c.saldoTotal)||0), 0);

  // Si hay un crédito abierto en detalle, renderizar DetalleCredito (early return).
  if (creditoDetalle) {
    return <DetalleCredito
      credito={creditoDetalle}
      deudor={deudor}
      deudorNombre={deudor.nombre}
      onBack={() => setCreditoDetalle(null)}
      onActualizado={cargarCreditos}
      fontSans={fontSans} fontSerif={fontSerif} gold={gold}
    />;
  }

  return (
    <div {...ZONA_DE_CAPTURA} style={{minHeight:"100vh", background:UI.fondo, fontFamily:fontSans}}>
      <div style={{background:T.navy, borderBottom:"1px solid rgba(184,147,42,0.24)", padding:isMobile?"14px 16px":"16px 32px", display:"flex", alignItems:"center", gap:14, position:"sticky" as const, top:0, zIndex:10, boxShadow:"0 2px 16px rgba(22,36,71,0.12)"}}>
        <button onClick={onBack} style={{background:"rgba(255,255,255,0.08)", border:"none", color:"white", borderRadius:UI.rControl, padding:"8px 14px", cursor:"pointer", fontSize:13, fontFamily:fontSans}}>← Deudores</button>
        <span style={{color:"white", fontWeight:700, fontSize:isMobile?15:17}}>{deudor.nombre}</span>
      </div>

      <div style={{maxWidth:860, margin:"0 auto", padding:isMobile?"20px 16px":"28px 32px"}}>

        {/* Tarjeta resumen + score */}
        <div style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rPanel, padding:"22px 24px", marginBottom:20, boxShadow:UI.sombra, borderLeft:`3px solid ${scoreColor}`}}>
          <div style={{display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:14, flexWrap:"wrap" as const}}>
            <div style={{flex:1, minWidth:0}}>
              <div style={{fontFamily:fontSerif, fontSize:22, color:UI.texto, fontWeight:600}}>{deudor.nombre}</div>
              <div style={{fontSize:12, color:UI.textoSuave, marginTop:4}}>
                {[deudor.rfc, deudor.curp].filter(Boolean).join(" · ") || "Sin RFC/CURP"}
              </div>
            </div>
            <div style={{textAlign:"right" as const, minWidth:120}}>
              <div style={{fontSize:10, color:UI.textoTenue, fontWeight:700, letterSpacing:"0.8px", textTransform:"uppercase" as const}}>Calificación interna</div>
              <div style={{fontFamily:fontSerif, fontSize:34, fontWeight:700, color:scoreColor, lineHeight:1}}>{score}<span style={{fontSize:14, color:UI.textoTenue}}>/100</span></div>
              <div style={{fontSize:11, color:scoreColor, fontWeight:700, marginTop:2}}>{scoreEtq}</div>
            </div>
          </div>
          <div style={{fontSize:11, color:UI.textoTenue, marginTop:12, paddingTop:12, borderTop:`1px solid ${UI.divisor}`, lineHeight:1.5}}>
            La calificación es <strong>interna y conductual</strong> (sube con pagos puntuales, baja con atrasos). NO es Buró de Crédito. Empieza en 70/100 · puntual +2 · 8–30d atraso −3 · &gt;30d −8 · liquidado +10 · incobrable −20.
          </div>

          {/* Historial del score */}
          {(deudor.scoreHistorial||[]).length > 0 && (
            <div style={{marginTop:10, borderTop:`1px solid ${UI.divisor}`, paddingTop:10}}>
              <button onClick={()=>setShowScoreHistorial(v=>!v)} style={{background:"none", border:"none", color:gold, cursor:"pointer", fontSize:12, fontWeight:700, fontFamily:fontSans, padding:0, display:"flex", alignItems:"center", gap:6}}>
                {showScoreHistorial?"▾":"▸"} Historial del score ({(deudor.scoreHistorial||[]).length} {(deudor.scoreHistorial||[]).length===1?"evento":"eventos"})
              </button>
              {showScoreHistorial && (
                <div style={{marginTop:10, display:"flex", flexDirection:"column" as const, gap:6, maxHeight:280, overflowY:"auto" as const}}>
                  {[...(deudor.scoreHistorial||[])].sort((a:any,b:any)=>(b.fecha||"").localeCompare(a.fecha||"")).map((e:any, i:number) => {
                    const positivo = (e.delta||0) > 0;
                    const cero = (e.delta||0) === 0;
                    const color = cero ? UI.textoTenue : (positivo ? UI.ok : UI.rojo);
                    const signo = positivo ? "+" : "";
                    return (
                      <div key={i} style={{display:"flex", alignItems:"center", gap:10, padding:"7px 10px", background:UI.hover, border:`1px solid ${UI.borde}`, borderLeft:`3px solid ${color}`, borderRadius:UI.rControl, fontSize:12}}>
                        <span style={{color:UI.textoTenue, minWidth:80, fontFamily:"monospace"}}>{e.fecha}</span>
                        <span style={{color, fontWeight:700, fontFamily:fontSerif, minWidth:36, textAlign:"right" as const}}>{signo}{e.delta}</span>
                        <span style={{flex:1, color:UI.textoSuave, minWidth:0}}>{e.motivo}</span>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}
        </div>

        {/* Datos personales */}
        <div style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rPanel, padding:"20px 22px", marginBottom:20, boxShadow:UI.sombra}}>
          <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16}}>
            <h3 style={{color:UI.texto, fontFamily:fontSerif, fontSize:16, fontWeight:600, margin:0}}>Datos del deudor</h3>
            {!editando && <button onClick={()=>setEditando(true)} style={{background:T_LIGHT.goldSoft, border:`1px solid ${T_LIGHT.goldBorder}`, color:gold, borderRadius:UI.rControl, padding:"6px 14px", cursor:"pointer", fontSize:12, fontFamily:fontSans, fontWeight:700}}>Editar</button>}
          </div>

          {editando ? (
            <div>
              <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr":"1fr 1fr", gap:14, marginBottom:14}}>
                <div style={{gridColumn:isMobile?"auto":"1 / -1"}}><label style={lbl}>Nombre completo *</label><input value={nombre} onChange={e=>setNombre(e.target.value)} style={inp}/></div>
                <div><label style={lbl}>RFC</label><input value={rfc} onChange={e=>setRfc(e.target.value.toUpperCase())} style={{...inp, letterSpacing:"1px", textTransform:"uppercase" as const}}/></div>
                <div><label style={lbl}>CURP</label><input value={curp} onChange={e=>setCurp(e.target.value.toUpperCase())} style={{...inp, letterSpacing:"1px", textTransform:"uppercase" as const}}/></div>
                <div><label style={lbl}>Teléfono</label><input value={telefono} onChange={e=>setTelefono(e.target.value)} style={inp} placeholder="449..."/></div>
                <div><label style={lbl}>Email</label><input value={email} onChange={e=>setEmail(e.target.value)} style={inp} placeholder="correo@..."/></div>
                <div><label style={lbl}>Ocupación</label><input value={ocupacion} onChange={e=>setOcupacion(e.target.value)} style={inp} placeholder="A qué se dedica"/></div>
                <div><label style={lbl}>Ingreso aproximado (opcional, MXN)</label><input type="number" value={ingreso} onChange={e=>setIngreso(e.target.value)} style={inp} placeholder="Lo que el deudor declare"/></div>
              </div>
              <div style={{borderTop:`1px solid ${UI.divisor}`, paddingTop:14, marginBottom:14}}>
                <div style={{fontSize:11, color:UI.textoSuave, fontWeight:700, marginBottom:10, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>Domicilio</div>
                <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr 1fr":"3fr 1fr 2fr", gap:10, marginBottom:10}}>
                  <div><label style={lbl}>Calle</label><input value={dom.calle||""} onChange={e=>setDom({...dom, calle:e.target.value})} style={inp}/></div>
                  <div><label style={lbl}>Número</label><input value={dom.numero||""} onChange={e=>setDom({...dom, numero:e.target.value})} style={inp}/></div>
                  <div><label style={lbl}>Colonia</label><input value={dom.colonia||""} onChange={e=>setDom({...dom, colonia:e.target.value})} style={inp}/></div>
                </div>
                <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr 1fr":"2fr 2fr 1fr", gap:10}}>
                  <div><label style={lbl}>Municipio</label><input value={dom.municipio||""} onChange={e=>setDom({...dom, municipio:e.target.value})} style={inp}/></div>
                  <div><label style={lbl}>Estado</label><input value={dom.estado||""} onChange={e=>setDom({...dom, estado:e.target.value})} style={inp}/></div>
                  <div><label style={lbl}>C.P.</label><input value={dom.cp||""} onChange={e=>setDom({...dom, cp:e.target.value})} style={inp}/></div>
                </div>
              </div>
              <div style={{marginBottom:14}}>
                <label style={lbl}>Notas</label>
                <input value={notas} onChange={e=>setNotas(e.target.value)} style={inp} placeholder="Cualquier observación interna"/>
              </div>
              <div style={{display:"flex", gap:8}}>
                <button onClick={()=>{setEditando(false); setNombre(deudor.nombre||""); setRfc(deudor.rfc||""); setCurp(deudor.curp||""); setTelefono(deudor.telefono||""); setEmail(deudor.email||""); setOcupacion(deudor.ocupacion||""); setIngreso(deudor.ingresoAproximado!=null?String(deudor.ingresoAproximado):""); setDom(deudor.domicilio||{}); setNotas(deudor.notas||"");}} style={{flex:1, background:"transparent", border:`1px solid ${UI.borde}`, color:UI.textoSuave, borderRadius:UI.rControl, padding:"10px", cursor:"pointer", fontSize:13, fontFamily:fontSans}}>Cancelar</button>
                <button onClick={guardarDatos} disabled={guardando||!nombre.trim()} style={{flex:2, background:nombre.trim()?gold:"#ddd", border:"none", color:nombre.trim()?"#0B1829":"#999", borderRadius:UI.rControl, padding:"10px", cursor:nombre.trim()?"pointer":"not-allowed", fontSize:13, fontWeight:700, fontFamily:fontSans}}>{guardando?"Guardando...":"Guardar datos"}</button>
              </div>
            </div>
          ) : (
            <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr 1fr":"repeat(3,1fr)", gap:16}}>
              {dato("RFC", deudor.rfc)}
              {dato("CURP", deudor.curp)}
              {dato("Teléfono", deudor.telefono)}
              {dato("Email", deudor.email)}
              {dato("Ocupación", deudor.ocupacion)}
              {dato("Ingreso aproximado", deudor.ingresoAproximado!=null?`$${Number(deudor.ingresoAproximado).toLocaleString("es-MX")}`:"")}
              <div style={{gridColumn:isMobile?"1 / -1":"1 / -1"}}>{dato("Domicilio", domStr.trim())}</div>
              {deudor.notas && <div style={{gridColumn:isMobile?"1 / -1":"1 / -1"}}>{dato("Notas", deudor.notas)}</div>}
            </div>
          )}
        </div>

        {/* Avales */}
        <div style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rPanel, padding:"20px 22px", marginBottom:20, boxShadow:UI.sombra}}>
          <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:8, flexWrap:"wrap" as const, gap:10}}>
            <h3 style={{color:UI.texto, fontFamily:fontSerif, fontSize:16, fontWeight:600, margin:0}}>
              Avales <span style={{fontSize:11, color:UI.textoSuave, fontWeight:600}}>({avales.length})</span>
            </h3>
            {!showAvalForm && (
              <button onClick={abrirNuevoAval} style={{background:T_LIGHT.goldSoft, border:`1px solid ${T_LIGHT.goldBorder}`, color:gold, borderRadius:UI.rControl, padding:"6px 14px", cursor:"pointer", fontSize:12, fontFamily:fontSans, fontWeight:700}}>+ Agregar aval</button>
            )}
          </div>
          <p style={{fontSize:11, color:UI.textoSuave, margin:"0 0 14px", lineHeight:1.6}}>Personas que respaldan el préstamo en caso de incumplimiento del deudor.</p>

          {showAvalForm && (
            <div style={{background:UI.hover, border:`1px solid ${T_LIGHT.goldBorder}`, borderRadius:UI.rPanel, padding:"16px 18px", marginBottom:16}}>
              <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr":"1fr 1fr", gap:14, marginBottom:14}}>
                <div style={{gridColumn:isMobile?"auto":"1 / -1"}}><label style={lbl}>Nombre completo *</label><input value={avNombre} onChange={e=>setAvNombre(e.target.value)} style={inp} placeholder="Nombre del aval"/></div>
                <div><label style={lbl}>Relación con el deudor</label><input value={avRelacion} onChange={e=>setAvRelacion(e.target.value)} style={inp} placeholder="Hermano, vecino, padre..."/></div>
                <div><label style={lbl}>Teléfono</label><input value={avTelefono} onChange={e=>setAvTelefono(e.target.value)} style={inp} placeholder="449..."/></div>
                <div><label style={lbl}>RFC</label><input value={avRfc} onChange={e=>setAvRfc(e.target.value.toUpperCase())} style={{...inp, letterSpacing:"1px", textTransform:"uppercase" as const}} placeholder="Opcional"/></div>
                <div><label style={lbl}>Dirección</label><input value={avDireccion} onChange={e=>setAvDireccion(e.target.value)} style={inp} placeholder="Calle, número, colonia..."/></div>
                <div style={{gridColumn:isMobile?"auto":"1 / -1"}}><label style={lbl}>Notas</label><input value={avNotas} onChange={e=>setAvNotas(e.target.value)} style={inp} placeholder="Cualquier dato relevante"/></div>
              </div>
              <div style={{display:"flex", gap:8}}>
                <button onClick={cerrarAvalForm} style={{flex:1, background:"transparent", border:`1px solid ${UI.borde}`, color:UI.textoSuave, borderRadius:UI.rControl, padding:"10px", cursor:"pointer", fontSize:13, fontFamily:fontSans}}>Cancelar</button>
                <button onClick={guardarAval} disabled={!avNombre.trim()||guardandoAval} style={{flex:2, background:avNombre.trim()?gold:"#ddd", border:"none", color:avNombre.trim()?"#0B1829":"#999", borderRadius:UI.rControl, padding:"10px", cursor:avNombre.trim()?"pointer":"not-allowed", fontSize:13, fontWeight:700, fontFamily:fontSans}}>{guardandoAval?"Guardando...":(avalEditIdx==null?"Agregar aval":"Guardar cambios")}</button>
              </div>
            </div>
          )}

          {avales.length === 0 && !showAvalForm ? (
            <div style={{textAlign:"center" as const, padding:"24px 20px", background:UI.hover, borderRadius:UI.rTarjeta, border:`1px dashed ${UI.divisor}`, color:UI.textoTenue, fontSize:13}}>
              Sin avales registrados todavía.
            </div>
          ) : (
            <div style={{display:"flex", flexDirection:"column" as const, gap:10}}>
              {avales.map((a, idx) => (
                <div key={idx} style={{background:UI.hover, border:`1px solid ${UI.borde}`, borderRadius:UI.rTarjeta, padding:"12px 14px"}}>
                  <div style={{display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:10, flexWrap:"wrap" as const}}>
                    <div style={{flex:1, minWidth:0}}>
                      <div style={{fontSize:14, fontWeight:700, color:UI.texto}}>{a.nombre}</div>
                      <div style={{fontSize:11, color:UI.textoSuave, marginTop:3}}>
                        {[a.relacion, a.telefono, a.rfc].filter(Boolean).join(" · ") || "Sin datos de contacto"}
                      </div>
                      {a.direccion && <div style={{fontSize:11, color:UI.textoTenue, marginTop:2}}>{a.direccion}</div>}
                      {a.notas && <div style={{fontSize:11, color:UI.textoTenue, marginTop:4, fontStyle:"italic" as const}}>{a.notas}</div>}
                    </div>
                    <div style={{display:"flex", gap:6, alignItems:"center"}}>
                      <button onClick={()=>abrirEditarAval(idx)} style={{background:"transparent", border:`1px solid ${UI.borde}`, color:UI.textoSuave, borderRadius:6, padding:"5px 10px", cursor:"pointer", fontSize:11, fontFamily:fontSans, fontWeight:600}}>Editar</button>
                      <button onClick={()=>eliminarAval(idx)} style={{background:"transparent", border:"none", color:UI.rojo, cursor:"pointer", fontSize:14, padding:4}}>×</button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Expediente: checklist obligatorio + opcional + sueltos */}
        <div style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rPanel, padding:"20px 22px", marginBottom:20, boxShadow:UI.sombra}}>
          <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:8, flexWrap:"wrap" as const, gap:10}}>
            <h3 style={{color:UI.texto, fontFamily:fontSerif, fontSize:16, fontWeight:600, margin:0}}>Expediente</h3>
            <span style={{fontSize:11, color:UI.textoSuave, fontWeight:700}}>
              {docsObligCompletos}/{DOCS_DEUDOR_OBLIG.length} obligatorios
              {DOCS_DEUDOR_OPC.length>0 && <> · {docsOpcSubidos}/{DOCS_DEUDOR_OPC.length} opcionales</>}
            </span>
          </div>
          <p style={{fontSize:11, color:UI.textoSuave, margin:"0 0 14px", lineHeight:1.6}}>Sube cada documento del checklist. Sin un expediente completo el riesgo del préstamo es mayor.</p>

          {/* Obligatorios */}
          <div style={{display:"flex", flexDirection:"column" as const, gap:8}}>
            {DOCS_DEUDOR_OBLIG.map((c) => {
              const sub = docPorKey(c.key);
              const idxEnDocs = sub ? docs.findIndex(d => d.key === c.key) : -1;
              return (
                <div key={c.key} style={{display:"flex", alignItems:"center", justifyContent:"space-between", gap:10, background:UI.hover, border:`1px solid ${sub?UI.okBg:UI.borde}`, borderLeft:`3px solid ${sub?UI.ok:"#9A9AAA"}`, borderRadius:UI.rControl, padding:"10px 14px", flexWrap:"wrap" as const}}>
                  <div style={{flex:1, minWidth:160}}>
                    <div style={{fontSize:13, fontWeight:600, color:UI.texto}}>{c.label}</div>
                    {sub ? (
                      <a href={sub.url} target="_blank" rel="noopener noreferrer" style={{fontSize:11, color:gold, textDecoration:"none", display:"inline-block", marginTop:2}}>{sub.nombre} · {sub.fecha}</a>
                    ) : (
                      <div style={{fontSize:11, color:UI.textoTenue, marginTop:2}}>Pendiente</div>
                    )}
                  </div>
                  <div style={{display:"flex", gap:8, alignItems:"center"}}>
                    <SubirArchivoBtn
                      userId={deudor.userId}
                      carpeta="expedientes_deudor"
                      label={sub?"Reemplazar":"Subir"}
                      accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                      maxMB={10}
                      onLote={(archivos)=>onDocSubido(c.key, archivos)}
                    />
                    {sub && idxEnDocs>=0 && (
                      <button onClick={()=>onDocEliminar(idxEnDocs)} style={{background:"transparent", border:"none", color:UI.rojo, cursor:"pointer", fontSize:12, fontWeight:700}}>Eliminar</button>
                    )}
                  </div>
                </div>
              );
            })}
          </div>

          {/* Opcionales (garantías) */}
          {DOCS_DEUDOR_OPC.length > 0 && (
            <div style={{marginTop:18, paddingTop:14, borderTop:`1px solid ${UI.divisor}`}}>
              <div style={{display:"flex", alignItems:"center", gap:8, marginBottom:10, flexWrap:"wrap" as const}}>
                <span style={{fontSize:12, fontWeight:700, color:UI.textoSuave, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>Garantías (opcionales)</span>
                <span style={{fontSize:10, color:UI.textoTenue}}>· no afectan el conteo de expediente completo</span>
              </div>
              <div style={{display:"flex", flexDirection:"column" as const, gap:8}}>
                {DOCS_DEUDOR_OPC.map((c) => {
                  const sub = docPorKey(c.key);
                  const idxEnDocs = sub ? docs.findIndex(d => d.key === c.key) : -1;
                  return (
                    <div key={c.key} style={{display:"flex", alignItems:"center", justifyContent:"space-between", gap:10, background:UI.hover, border:`1px dashed ${sub?UI.okBg:UI.borde}`, borderLeft:`3px solid ${sub?UI.ok:"#C8C2B0"}`, borderRadius:UI.rControl, padding:"10px 14px", flexWrap:"wrap" as const}}>
                      <div style={{flex:1, minWidth:160}}>
                        <div style={{display:"flex", alignItems:"center", gap:8, flexWrap:"wrap" as const}}>
                          <span style={{fontSize:13, fontWeight:600, color:UI.texto}}>{c.label}</span>
                          <span style={{fontSize:9, fontWeight:700, padding:"2px 7px", borderRadius:6, background:UI.hover, color:UI.textoTenue, border:`1px solid ${UI.borde}`, letterSpacing:"0.4px", textTransform:"uppercase" as const}}>Opcional</span>
                        </div>
                        {sub ? (
                          <a href={sub.url} target="_blank" rel="noopener noreferrer" style={{fontSize:11, color:gold, textDecoration:"none", display:"inline-block", marginTop:4}}>{sub.nombre} · {sub.fecha}</a>
                        ) : (
                          <div style={{fontSize:11, color:UI.textoTenue, marginTop:4}}>Sin documento</div>
                        )}
                      </div>
                      <div style={{display:"flex", gap:8, alignItems:"center"}}>
                        <SubirArchivoBtn
                          userId={deudor.userId}
                          carpeta="expedientes_deudor"
                          label={sub?"Reemplazar":"Subir"}
                          accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                          maxMB={10}
                          onLote={(archivos)=>onDocSubido(c.key, archivos)}
                        />
                        {sub && idxEnDocs>=0 && (
                          <button onClick={()=>onDocEliminar(idxEnDocs)} style={{background:"transparent", border:"none", color:UI.rojo, cursor:"pointer", fontSize:12, fontWeight:700}}>Eliminar</button>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* Documentos sueltos (sin checklist key) */}
          <div style={{marginTop:18, paddingTop:14, borderTop:`1px solid ${UI.divisor}`}}>
            <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:10, flexWrap:"wrap" as const, gap:8}}>
              <span style={{fontSize:12, fontWeight:700, color:UI.textoSuave, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>Otros documentos</span>
              <SubirArchivoBtn
                userId={deudor.userId}
                carpeta="expedientes_deudor"
                label="Subir otro"
                accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                maxMB={10}
                onLote={(archivos)=>onDocSubido(undefined, archivos)}
              />
            </div>
            {docsSueltos.length === 0 ? (
              <div style={{fontSize:12, color:UI.textoTenue}}>Sin documentos adicionales.</div>
            ) : (
              <div style={{display:"flex", flexDirection:"column" as const, gap:6}}>
                {docsSueltos.map((d,i) => {
                  const idxReal = docs.findIndex(x => x.url === d.url);
                  return (
                    <div key={i} style={{display:"flex", alignItems:"center", justifyContent:"space-between", gap:10, background:UI.hover, border:`1px solid ${UI.borde}`, borderRadius:UI.rControl, padding:"8px 12px"}}>
                      <a href={d.url} target="_blank" rel="noopener noreferrer" style={{color:gold, fontSize:13, textDecoration:"none", flex:1, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" as const, fontWeight:600}}>{d.nombre}</a>
                      <span style={{fontSize:11, color:UI.textoTenue}}>{d.fecha}</span>
                      <button onClick={()=>onDocEliminar(idxReal)} style={{background:"transparent", border:"none", color:UI.rojo, cursor:"pointer", fontSize:12, fontWeight:700}}>Eliminar</button>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>

        {/* Créditos del deudor */}
        <div style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rPanel, padding:"20px 22px", marginBottom:20, boxShadow:UI.sombra}}>
          <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:8, flexWrap:"wrap" as const, gap:10}}>
            <h3 style={{color:UI.texto, fontFamily:fontSerif, fontSize:16, fontWeight:600, margin:0}}>
              Créditos <span style={{fontSize:11, color:UI.textoSuave, fontWeight:600}}>({creditos.length})</span>
            </h3>
            {!showFormCredito && (
              <button onClick={()=>setShowFormCredito(true)} style={{background:gold, border:"none", color:"#0B1829", borderRadius:UI.rControl, padding:"8px 16px", cursor:"pointer", fontSize:12, fontWeight:700, fontFamily:fontSans}}>+ Nuevo crédito</button>
            )}
          </div>

          {creditos.length > 0 && (
            <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr 1fr":"repeat(3,1fr)", gap:10, marginBottom:14}}>
              <div style={{background:UI.hover, border:`1px solid ${UI.borde}`, borderRadius:UI.rTarjeta, padding:"10px 12px"}}>
                <div style={{fontSize:9, color:UI.textoTenue, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>Vigentes</div>
                <div style={{fontFamily:fontSerif, fontSize:18, color:UI.texto, fontWeight:700, marginTop:2}}>{creditosVigentes.length}<span style={{fontSize:11, color:UI.textoTenue}}> / {creditos.length}</span></div>
              </div>
              <div style={{background:UI.hover, border:`1px solid ${UI.borde}`, borderRadius:UI.rTarjeta, padding:"10px 12px"}}>
                <div style={{fontSize:9, color:UI.textoTenue, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>Prestado (vigente)</div>
                <div style={{fontFamily:fontSerif, fontSize:18, color:"#1E3A8A", fontWeight:700, marginTop:2}}>{moneyMXN(montoPrestadoVigente)}</div>
              </div>
              <div style={{background:UI.hover, border:`1px solid ${UI.borde}`, borderRadius:UI.rTarjeta, padding:"10px 12px", gridColumn:isMobile?"1 / -1":"auto"}}>
                <div style={{fontSize:9, color:UI.textoTenue, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>Saldo pendiente</div>
                <div style={{fontFamily:fontSerif, fontSize:18, color:saldoVigente>0?UI.rojo:UI.ok, fontWeight:700, marginTop:2}}>{moneyMXN(saldoVigente)}</div>
              </div>
            </div>
          )}

          {showFormCredito && (
            <FormCredito
              deudorId={deudor.id}
              userId={user?.uid || deudor.userId}
              onCreado={()=>{ setShowFormCredito(false); cargarCreditos(); onActualizado(); }}
              onCancelar={()=>setShowFormCredito(false)}
              fontSans={fontSans} fontSerif={fontSerif} gold={gold}
            />
          )}

          {cargandoCreditos ? (
            <div style={{textAlign:"center" as const, padding:"24px", color:UI.textoTenue, fontSize:13}}>Cargando créditos...</div>
          ) : creditos.length === 0 && !showFormCredito ? (
            <div style={{textAlign:"center" as const, padding:"24px 20px", background:UI.hover, borderRadius:UI.rTarjeta, border:`1px dashed ${T_LIGHT.goldBorder}`, color:UI.textoSuave, fontSize:13}}>
              Este deudor aún no tiene créditos. Crea el primero con el botón de arriba.
            </div>
          ) : (
            <div style={{display:"flex", flexDirection:"column" as const, gap:10}}>
              {creditos.map((c) => {
                // Derivado al leer (ver nota en el campo `estado` del tipo Credito).
                const m = ESTADO_CREDITO_META[estadoCreditoDerivado(c, hoyISO())] || ESTADO_CREDITO_META.al_corriente;
                return (
                  <div key={c.id} onClick={()=>setCreditoDetalle(c)} style={{background:UI.hover, border:`1px solid ${UI.borde}`, borderLeft:`3px solid ${m.color}`, borderRadius:UI.rTarjeta, padding:"12px 14px", cursor:"pointer", transition:"background 0.15s"}}
                    onMouseEnter={(e)=>(e.currentTarget as HTMLDivElement).style.background=UI.hover}
                    onMouseLeave={(e)=>(e.currentTarget as HTMLDivElement).style.background=UI.hover}>
                    <div style={{display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:10, flexWrap:"wrap" as const}}>
                      <div style={{flex:1, minWidth:0}}>
                        <div style={{fontSize:14, fontWeight:700, color:UI.texto}}>
                          {moneyMXN(c.monto)} <span style={{fontSize:11, fontWeight:500, color:UI.textoSuave}}>a {c.tasaAnual}% anual</span>
                        </div>
                        <div style={{fontSize:11, color:UI.textoSuave, marginTop:3}}>
                          {c.numeroPagos} pagos {FRECUENCIA_LABEL[c.frecuencia as FrecuenciaCredito]?.toLowerCase()}es · emitido {c.fechaEmision}
                        </div>
                        <div style={{fontSize:11, color:UI.textoTenue, marginTop:4}}>
                          Pago fijo {moneyMXN(c.pagoFijo)} · saldo {moneyMXN(c.saldoTotal||0)}
                        </div>
                      </div>
                      <span style={{background:m.bg, color:m.color, fontSize:10, padding:"4px 9px", borderRadius:6, fontWeight:700, whiteSpace:"nowrap" as const, border:`1px solid ${m.color}40`}}>{m.label}</span>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {/* Documentos legales vinculados — helper reusable (contratos, avisos,
            consentimientos, pagarés…). Distinto de los archivos del expediente. */}
        <SeccionContratosVinculados
          user={{uid: deudor.userId}}
          entidadId={deudor.id}
          entidadTipo="deudor"
          coleccion="deudores"
          contratos={contratos}
          onContratosChange={(nuevos)=>{ setContratos(nuevos); onActualizado(); }}
          onGoContratos={onGoContratos}
          accentColor="#1E3A8A"
          fontSans={fontSans} fontSerif={fontSerif} gold={gold}
        />

      </div>
    </div>
  );
}

function CreditosModulo({user, onBack, onGoContratos, fontSans, fontSerif, gold, deudorInicialId, creditoInicialId}: {
  user: any; onBack: ()=>void; onGoContratos: ()=>void; fontSans: string; fontSerif: string; gold: string;
  deudorInicialId?: string|null; creditoInicialId?: string|null;
}) {
  const [deudores, setDeudores] = useState<any[]>([]);
  const [cargando, setCargando] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [nombre, setNombre] = useState("");
  const [rfc, setRfc] = useState("");
  const [curp, setCurp] = useState("");
  const [telefono, setTelefono] = useState("");
  const [email, setEmail] = useState("");
  const [ocupacion, setOcupacion] = useState("");
  const [ingreso, setIngreso] = useState("");
  const [notas, setNotas] = useState("");
  const [guardando, setGuardando] = useState(false);
  const [deudorExpediente, setDeudorExpediente] = useState<any>(null);
  const _deuInicialUsado = useRef(false);
  const [showComoFunciona, setShowComoFunciona] = useState(false);
  const isMobile = window.innerWidth < 768;
  const db = getFirestore();

  const cargarDeudores = async () => {
    if (!user?.uid) { setCargando(false); return; }
    try {
      const snap = await getDocs(query(collection(db,"deudores"), where("userId","==",user.uid)));
      const lista = snap.docs.map(d => ({id:d.id, ...d.data()} as any))
        .sort((a,b) => (a.nombre||"").localeCompare(b.nombre||""));
      setDeudores(lista);
      // Salto desde un aviso de cuota: abre el expediente del deudor dueño del
      // crédito. El crédito concreto lo abre ExpedienteDeudor con `creditoInicialId`.
      if (deudorInicialId && !_deuInicialUsado.current) {
        _deuInicialUsado.current = true;
        const d0 = lista.find((x:any)=> x.id === deudorInicialId);
        if (d0) setDeudorExpediente(d0);
      }
      // Si el deudor abierto en expediente cambió, refrescarlo
      if (deudorExpediente) {
        const refrescado = lista.find(d => d.id === deudorExpediente.id);
        if (refrescado) setDeudorExpediente(refrescado);
      }
    } catch(e){ console.error(e); }
    finally{ setCargando(false); }
  };
  useEffect(()=>{ cargarDeudores(); /* eslint-disable-next-line */ }, [user]);

  const limpiarForm = () => {
    setNombre(""); setRfc(""); setCurp(""); setTelefono(""); setEmail("");
    setOcupacion(""); setIngreso(""); setNotas("");
  };

  const guardar = async () => {
    if (!nombre.trim() || !user?.uid) return;
    setGuardando(true);
    try {
      await addDoc(collection(db,"deudores"), {
        userId: user.uid,
        nombre: nombre.trim(),
        rfc: rfc.trim().toUpperCase()||null,
        curp: curp.trim().toUpperCase()||null,
        telefono: telefono.trim()||null,
        email: email.trim()||null,
        ocupacion: ocupacion.trim()||null,
        ingresoAproximado: ingreso?parseFloat(ingreso):null,
        domicilio: {},
        avales: [],
        score: 70,
        scoreHistorial: [],
        documentos: [],
        notas: notas.trim()||null,
        creadoEn: Timestamp.now(),
      });
      setShowForm(false); limpiarForm();
      await cargarDeudores();
    } catch(e){ console.error(e); alert("Error al guardar el deudor"); }
    finally{ setGuardando(false); }
  };

  const eliminar = async (d: any) => {
    if (!window.confirm(`¿Eliminar a ${d.nombre} de tus deudores? Esto NO elimina documentos ya subidos.`)) return;
    try { await deleteDoc(doc(db,"deudores",d.id)); }
    catch(e:any){ console.error(e); alert("No se pudo eliminar a " + (d.nombre||"") + ": " + (e?.code || e?.message || "error desconocido")); }
    finally { await cargarDeudores(); }
  };

  // KPIs simples (Etapa 1: sólo deudores)
  const totalDeudores = deudores.length;
  const scoreProm = totalDeudores > 0
    ? Math.round(deudores.reduce((s,d)=>s+(typeof d.score==="number"?d.score:70),0)/totalDeudores)
    : 0;
  const expedientesCompletos = deudores.filter(d => {
    const docs: DocumentoExpediente[] = d.documentos||[];
    return DOCS_DEUDOR_OBLIG.every(c => docs.some(x => x.key === c.key));
  }).length;

  const lbl = {fontSize:10, color:UI.textoTenue, display:"block", marginBottom:5, textTransform:"uppercase" as const, letterSpacing:"0.5px"};
  const inp = {width:"100%", padding:"12px 14px", border:"1px solid rgba(0,0,0,0.12)", borderRadius:UI.rTarjeta, fontSize:14, outline:"none", boxSizing:"border-box" as const, fontFamily:fontSans};

  if (deudorExpediente) {
    return <ExpedienteDeudor onGoContratos={onGoContratos} creditoInicialId={creditoInicialId} deudor={deudorExpediente} onBack={()=>setDeudorExpediente(null)} onActualizado={cargarDeudores} fontSans={fontSans} fontSerif={fontSerif} gold={gold} user={user} />;
  }

  return (
    <div {...ZONA_DE_CAPTURA} style={{minHeight:"100vh", background:UI.fondo, fontFamily:fontSans}}>
      {/* Header navy interno removido — la identidad ("Créditos") la da el sidebar. */}
      <div style={{maxWidth:ANCHO_CONTENIDO, margin:"0 auto", padding:isMobile?"20px 16px":"28px 32px"}}>
        {/* KPIs */}
        <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr 1fr":"repeat(3,1fr)", gap:12, marginBottom:24}}>
          <div style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rPanel, padding:"18px 20px", boxShadow:UI.sombra, borderLeft:"3px solid #1E3A8A"}}>
            <div style={{fontFamily:fontSerif, fontSize:30, color:UI.texto, fontWeight:600}}>{totalDeudores}</div>
            <div style={{fontSize:11, color:UI.textoSuave, marginTop:2}}>Deudores registrados</div>
          </div>
          <div style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rPanel, padding:"18px 20px", boxShadow:UI.sombra, borderLeft:"3px solid #B8932A"}}>
            <div style={{fontFamily:fontSerif, fontSize:30, color:UI.texto, fontWeight:600}}>{totalDeudores>0?scoreProm:"—"}<span style={{fontSize:14, color:UI.textoTenue}}>{totalDeudores>0?" /100":""}</span></div>
            <div style={{fontSize:11, color:UI.textoSuave, marginTop:2}}>Score promedio (interno)</div>
          </div>
          <div style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rPanel, padding:"18px 20px", boxShadow:UI.sombra, borderLeft:"3px solid #3D3A6B", gridColumn:isMobile?"1 / -1":"auto"}}>
            <div style={{fontFamily:fontSerif, fontSize:30, color:UI.texto, fontWeight:600}}>{expedientesCompletos}<span style={{fontSize:14, color:UI.textoTenue}}> / {totalDeudores||0}</span></div>
            <div style={{fontSize:11, color:UI.textoSuave, marginTop:2}}>Expedientes completos</div>
          </div>
        </div>

        {/* Tip */}
        <div style={{background:T_LIGHT.goldSoft, border:`1px solid ${T_LIGHT.goldBorder}`, borderRadius:UI.rPanel, padding:"14px 16px", marginBottom:24, fontSize:12, color:UI.textoSuave, lineHeight:1.7}}>
          Da de alta a cada persona a la que prestes dinero. En cada ficha guarda su <strong>expediente</strong> (INE, comprobante de domicilio, ingresos, pagaré, contrato...). En la siguiente etapa podrás crear créditos con su tabla de amortización y registrar pagos.
        </div>

        {/* Acción primaria */}
        <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16, flexWrap:"wrap" as const, gap:10}}>
          <h2 style={{color:UI.texto, fontFamily:fontSerif, fontSize:18, fontWeight:600, margin:0}}>Mis deudores</h2>
          {!showForm && <BotonPrimario texto="+ Agregar deudor" onClick={()=>setShowForm(true)} fontSans={fontSans}/>}
        </div>

        {/* Form de alta */}
        {showForm && (
          <div style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rPanel, padding:isMobile?"20px":"24px", marginBottom:20, boxShadow:UI.sombra}}>
            <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr":"1fr 1fr", gap:14, marginBottom:14}}>
              <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
                <label style={lbl}>Nombre completo *</label>
                <input value={nombre} onChange={e=>setNombre(e.target.value)} placeholder="Nombre del deudor" style={inp}/>
              </div>
              <div>
                <label style={lbl}>RFC</label>
                <input value={rfc} onChange={e=>setRfc(e.target.value.toUpperCase())} placeholder="Opcional" style={{...inp, letterSpacing:"1px", textTransform:"uppercase" as const}}/>
              </div>
              <div>
                <label style={lbl}>CURP</label>
                <input value={curp} onChange={e=>setCurp(e.target.value.toUpperCase())} placeholder="Opcional" style={{...inp, letterSpacing:"1px", textTransform:"uppercase" as const}}/>
              </div>
              <div>
                <label style={lbl}>Teléfono</label>
                <input value={telefono} onChange={e=>setTelefono(e.target.value)} placeholder="449..." style={inp}/>
              </div>
              <div>
                <label style={lbl}>Email</label>
                <input value={email} onChange={e=>setEmail(e.target.value)} placeholder="correo@..." style={inp}/>
              </div>
              <div>
                <label style={lbl}>Ocupación</label>
                <input value={ocupacion} onChange={e=>setOcupacion(e.target.value)} placeholder="A qué se dedica" style={inp}/>
              </div>
              <div>
                <label style={lbl}>Ingreso aproximado (opcional, MXN)</label>
                <input type="number" value={ingreso} onChange={e=>setIngreso(e.target.value)} placeholder="Lo que el deudor declare" style={inp}/>
              </div>
              <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
                <label style={lbl}>Notas (opcional)</label>
                <input value={notas} onChange={e=>setNotas(e.target.value)} placeholder="Cualquier observación interna" style={inp}/>
              </div>
            </div>
            <p style={{fontSize:11, color:UI.textoSuave, margin:"0 0 14px"}}>
              El domicilio y los documentos del expediente se completan después, en la ficha del deudor.
            </p>
            <div style={{display:"flex", gap:8}}>
              <button onClick={()=>{setShowForm(false); limpiarForm();}} style={{flex:1, background:"transparent", border:"1px solid rgba(0,0,0,0.15)", color:UI.textoSuave, borderRadius:UI.rTarjeta, padding:"11px", cursor:"pointer", fontSize:13, fontFamily:fontSans}}>Cancelar</button>
              <button onClick={guardar} disabled={!nombre.trim()||guardando} style={{flex:2, background:nombre.trim()?gold:"#ddd", border:"none", color:nombre.trim()?"#0B1829":"#999", borderRadius:UI.rTarjeta, padding:"11px", cursor:nombre.trim()?"pointer":"not-allowed", fontSize:13, fontWeight:700, fontFamily:fontSans}}>{guardando?"Guardando...":"Guardar deudor"}</button>
            </div>
          </div>
        )}

        {/* Lista de deudores */}
        {cargando ? (
          <div style={{textAlign:"center" as const, padding:"40px", color:UI.textoTenue}}>Cargando...</div>
        ) : deudores.length === 0 ? (
          <div style={{textAlign:"center" as const, padding:"50px 20px", background:UI.superficie, borderRadius:UI.rPanel, border:`1px dashed ${T_LIGHT.goldBorder}`, color:UI.textoSuave, fontSize:14}}>
            Aún no tienes deudores registrados. Agrega uno para empezar.
          </div>
        ) : (
          <div style={{display:"flex", flexDirection:"column" as const, gap:10}}>
            {deudores.map((d:any) => {
              const score = typeof d.score === "number" ? d.score : 70;
              const scoreColor = score >= 80 ? UI.ok : score >= 60 ? "#D97706" : UI.rojo;
              const docs: DocumentoExpediente[] = d.documentos||[];
              const completos = DOCS_DEUDOR_OBLIG.filter(c => docs.some(x => x.key === c.key)).length;
              const numAvales = (d.avales||[]).length;
              return (
                <div key={d.id} onClick={()=>setDeudorExpediente(d)} style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rPanel, padding:"16px 18px", cursor:"pointer", boxShadow:UI.sombra, borderLeft:`3px solid ${scoreColor}`}}>
                  <div style={{display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:12, flexWrap:"wrap" as const}}>
                    <div style={{flex:1, minWidth:0}}>
                      <div style={{fontSize:15, fontWeight:600, color:UI.texto, marginBottom:3}}>{d.nombre}</div>
                      <div style={{fontSize:11, color:UI.textoSuave}}>
                        {[d.rfc, d.curp, d.telefono].filter(Boolean).join(" · ") || "Sin datos de contacto"}
                      </div>
                      <div style={{fontSize:11, color:UI.textoTenue, marginTop:4}}>
                        Expediente: {completos}/{DOCS_DEUDOR_OBLIG.length} obligatorios · {numAvales} {numAvales===1?"aval":"avales"}{d.ocupacion?` · ${d.ocupacion}`:""}
                      </div>
                    </div>
                    <div style={{display:"flex", alignItems:"center", gap:10}}>
                      <div style={{textAlign:"right" as const, minWidth:60}}>
                        <div style={{fontFamily:fontSerif, fontSize:20, fontWeight:700, color:scoreColor, lineHeight:1}}>{score}</div>
                        <div style={{fontSize:9, color:UI.textoTenue, fontWeight:700, letterSpacing:"0.5px", textTransform:"uppercase" as const}}>Score</div>
                      </div>
                      <button onClick={(e)=>{e.stopPropagation(); eliminar(d);}} style={{background:"none", border:"none", color:UI.textoTenue, cursor:"pointer", fontSize:16, padding:4}}>×</button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* ¿Cómo funciona? */}
        <div style={{maxWidth:760, margin:"26px auto 0", background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rPanel, overflow:"hidden", boxShadow:UI.sombra}}>
          <button onClick={()=>setShowComoFunciona(v=>!v)} style={{width:"100%", display:"flex", justifyContent:"space-between", alignItems:"center", padding:"16px 22px", background:"none", border:"none", cursor:"pointer", color:UI.texto, fontSize:15, fontFamily:fontSerif, fontWeight:600, textAlign:"left"}}>
            <span>¿Cómo funciona el módulo de Créditos?</span>
            <span style={{color:gold, fontSize:20, lineHeight:1}}>{showComoFunciona?"−":"+"}</span>
          </button>
          {showComoFunciona && (
            <div style={{padding:"0 22px 22px", color:UI.textoSuave, fontSize:13.5, lineHeight:1.7}}>
              <p style={{margin:"0 0 12px"}}><strong style={{color:gold}}>Etapa 1 — Deudores y expedientes (hoy).</strong> Da de alta a cada persona a la que le prestes dinero y arma su expediente con INE, comprobantes y referencias.</p>
              <p style={{margin:"0 0 12px"}}><strong style={{color:gold}}>Etapa 2 — Créditos.</strong> A cada deudor le crearás préstamos con monto, tasa, frecuencia y número de pagos. La app generará automáticamente la tabla de amortización con pagos fijos.</p>
              <p style={{margin:"0 0 12px"}}><strong style={{color:gold}}>Etapa 3 — Pagos.</strong> Registrarás cada abono y la app recalculará saldo, estado del crédito (al corriente / atrasado / en mora / liquidado) y semáforo por cuota.</p>
              <p style={{margin:"0 0 12px"}}><strong style={{color:gold}}>Etapa 4 — Calificación interna.</strong> El score de cada deudor subirá con pagos puntuales y bajará con atrasos. Es interna y conductual — NO Buró de Crédito.</p>
              <p style={{margin:0}}><strong style={{color:gold}}>Etapa 5 — Avisos.</strong> Los pagos vencidos y próximos a vencer aparecerán en la campana del top bar y en el dashboard, junto con el resto de tus pendientes.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// ─── PÁGINA DE PLANES ────────────────────────────────────────────────────────
// Página completa con los 4 planes (Emprendedor / PyME / Crecimiento / Corporativo).
// Lift escalonado al hover, progresión cromática (blanco → dorado → black luxury).
// Sin banner promocional público — promociones se manejan vía contacto directo.
function PaginaPlanes({onBack, onContratar, onCotizar, fontSans, fontSerif, gold}: {
  onBack:()=>void;
  onContratar:(planId:string)=>void;
  onCotizar:()=>void;
  fontSans:string;
  fontSerif:string;
  gold:string;
}) {
  const isMobile = window.innerWidth < 768;
  const [periodo, setPeriodo] = useState<"mensual"|"anual">("mensual");

  type Plan = {
    id:string; tier:string; nombre:string; subtitulo:string;
    precio:number; precioAnual:number;
    precioPrefix?:string; etiquetaPrecio:string;
    ctaLabel:string;
    badge?:string;
    hereda?:string;
    features:{modulo:string; detalle:string}[];
    excluye?:string;
  };

  const planes: Plan[] = [
    {id:"emprendedor", tier:"plan-emp",
     nombre:"Emprendedor", subtitulo:"Comienza a conocer tus obligaciones legales",
     precio:0, precioAnual:0, etiquetaPrecio:"para siempre", ctaLabel:"Empezar gratis",
     features:[
       {modulo:"Diagnóstico Regulatorio",  detalle:"10 sectores · Aguascalientes"},
       {modulo:"Calculadora LFT",          detalle:"Liquidación, finiquito, aguinaldo, vacaciones"},
       {modulo:"AXIOR · copiloto legal IA", detalle:"20 consultas al mes"},
     ],
     excluye:"Sin Empleados, Documentos ni Flotilla",
    },
    {id:"pyme", tier:"plan-pyme",
     nombre:"PyME", subtitulo:"Toda tu operación legal en un solo lugar",
     precio:599, precioAnual:499, etiquetaPrecio:"o $499/mes anual",
     ctaLabel:"Contratar", badge:"RECOMENDADO", hereda:"TODO LO DEL EMPRENDEDOR +",
     features:[
       {modulo:"Empleados y Nómina",        detalle:"7 cuentas · recibos ISR e IMSS"},
       {modulo:"Cuentas de trabajador",     detalle:"Acceso propio para cada trabajador"},
       {modulo:"Actividades con doble validación", detalle:"Asignas y el trabajador confirma · medidor por empleado"},
       {modulo:"Checador con GPS",          detalle:"Entrada/salida con ubicación"},
       {modulo:"Control de Flotilla",       detalle:"4 vehículos · bitácoras de salida y regreso"},
       {modulo:"Proveedores",               detalle:"Validación SAT 69-B · próximamente"},
       {modulo:"Generador Legal",           detalle:"Contratos, avisos, pagarés y cartas poder"},
       {modulo:"Banco de Documentos",       detalle:"20 GB cifrados"},
       {modulo:"Clientes / Pacientes",      detalle:"Expedientes con Aviso de Privacidad (LFPDPPP)"},
       {modulo:"Créditos",                  detalle:"Pagarés con folio y avales"},
       {modulo:"Calendario y Contratos",    detalle:"Ilimitados · 14 tipos AGS · alertas de vencimientos"},
       {modulo:"AXIOR · tu copiloto legal", detalle:"100 consultas al mes"},
     ],
    },
    {id:"crecimiento", tier:"plan-crec",
     nombre:"Empresa en Crecimiento", subtitulo:"Para escalar sin perder el control",
     precio:1499, precioAnual:1299, etiquetaPrecio:"o $1,299/mes anual",
     ctaLabel:"Contratar", badge:"PRO+", hereda:"TODO LO DEL PYME +",
     features:[
       {modulo:"Empleados y Nómina",      detalle:"20 cuentas"},
       {modulo:"Control de Flotilla",     detalle:"10 vehículos"},
       {modulo:"Banco de Documentos",     detalle:"100 GB"},
       {modulo:"Consulta legal con AXIS", detalle:"1 sesión 30 min/mes"},
       {modulo:"Contrato certificado",    detalle:"1 con valor legal pleno/mes"},
       {modulo:"AXIOR · copiloto legal",  detalle:"250 consultas al mes"},
     ],
    },
    {id:"corporativo", tier:"plan-corp",
     nombre:"Corporativo", subtitulo:"Operaciones complejas, múltiples sedes",
     precio:4000, precioAnual:4000, precioPrefix:"Desde",
     etiquetaPrecio:"cotizado a la medida",
     ctaLabel:"Cotizar", badge:"ÉLITE", hereda:"TODO LO DE CRECIMIENTO +",
     features:[
       {modulo:"Empleados y Flotilla",     detalle:"30 a 50 cuentas y vehículos (ampliable)"},
       {modulo:"Banco de Documentos",      detalle:"Almacenamiento ilimitado"},
       {modulo:"Asesoría legal ampliada",  detalle:"Consultas mensuales múltiples"},
       {modulo:"Soporte y onboarding",     detalle:"SLA 1h · presencial inicial"},
       {modulo:"White-label opcional",     detalle:"Tu marca en lugar de AXIS"},
       {modulo:"AXIOR · copiloto legal",   detalle:"uso ampliado (1,000 al mes)"},
     ],
    },
  ];

  const fmtPrecio = (p:Plan) => {
    if (p.precio === 0) return "$0";
    const v = periodo === "mensual" ? p.precio : p.precioAnual;
    return `$${v.toLocaleString("es-MX")}`;
  };

  const handleCta = (p:Plan) => {
    if (p.id === "corporativo") return onCotizar();
    if (p.id === "emprendedor") return onContratar("emprendedor");
    return onContratar(p.id);
  };

  return (
    <div style={{minHeight:"100vh", background:"linear-gradient(160deg,#0B1829 0%,#0F2040 50%,#162447 100%)", fontFamily:fontSans, color:"white"}}>
      <style>{`
        .plan-card { transition: transform 0.45s cubic-bezier(0.34,1.56,0.64,1), box-shadow 0.3s ease; cursor:pointer; }
        @media (min-width: 768px) {
          .plan-emp { transform: translateY(0); }
          .plan-emp:hover { transform: translateY(-3px); }
          .plan-pyme { transform: translateY(-3px); }
          .plan-pyme:hover { transform: translateY(-7px); }
          .plan-crec { transform: translateY(-6px); }
          .plan-crec:hover { transform: translateY(-11px); }
          .plan-corp { transform: translateY(-9px); }
          .plan-corp:hover { transform: translateY(-15px); box-shadow: inset 0 1px 0 rgba(212,168,67,0.35), 0 10px 36px rgba(0,0,0,0.6), 0 0 0 1px rgba(212,168,67,0.45) !important; }
        }
        .planes-scroll { -webkit-overflow-scrolling: touch; scrollbar-width: none; }
        .planes-scroll::-webkit-scrollbar { display: none; height:0; width:0; }
        @keyframes shimmer-gold { 0%{background-position:200% 0} 100%{background-position:-200% 0} }
        .gold-shine { background:linear-gradient(90deg,#B8932A,#D4A843,#F0C85A,#D4A843,#B8932A); background-size:200% auto; -webkit-background-clip:text; -webkit-text-fill-color:transparent; animation:shimmer-gold 3s linear infinite; }
        @keyframes hint-slide { 0%,100% { transform: translateX(0); } 50% { transform: translateX(-6px); } }
        .swipe-hint { animation: hint-slide 1.6s ease-in-out infinite; }
      `}</style>

      {/* Header */}
      <div style={{padding:isMobile?"0 14px":"0 28px", height:isMobile?52:66, display:"flex",
        alignItems:"center", gap:isMobile?9:14,
        background:"rgba(11,24,41,0.85)", backdropFilter:"blur(16px)",
        borderBottom:"1px solid rgba(184,147,42,0.18)",
        position:"sticky" as const, top:0, zIndex:100,
        boxShadow:"0 4px 24px rgba(0,0,0,0.3)"}}>
        <button onClick={onBack}
          style={{background:"rgba(255,255,255,0.06)", border:"1px solid rgba(255,255,255,0.12)",
            color:"white", borderRadius:8, padding:isMobile?"5px 10px":"6px 14px",
            cursor:"pointer", fontSize:isMobile?11:12, fontWeight:600}}>
          ← Volver
        </button>
        <div style={{width:isMobile?32:36, height:isMobile?32:36,
          background:"linear-gradient(135deg,#B8932A,#D4A843)", borderRadius:isMobile?9:10,
          display:"flex", alignItems:"center", justifyContent:"center",
          boxShadow:"0 4px 16px rgba(184,147,42,0.45)"}}>
          <span style={{fontFamily:fontSerif, fontSize:isMobile?13:14, fontWeight:900, color:"#0B1829"}}>AX</span>
        </div>
        {!isMobile && <div>
          <div style={{fontFamily:fontSerif, fontSize:14, fontWeight:700, color:"white", letterSpacing:"0.3px"}}>Planes y Precios</div>
          <div style={{fontSize:9, color:"rgba(184,147,42,0.6)", textTransform:"uppercase" as const, letterSpacing:"1.5px"}}>AXIS Legaltech</div>
        </div>}
      </div>

      {/* Contenido */}
      <div style={{maxWidth:1200, margin:"0 auto", padding:isMobile?"22px 14px 36px":"36px 32px 56px"}}>

        {/* Banner Precios Especiales 2026 */}
        <div style={{
          background:"linear-gradient(135deg, rgba(184,147,42,0.18), rgba(184,147,42,0.08))",
          border:"1.5px solid rgba(184,147,42,0.45)",
          borderRadius:14,
          padding:isMobile?"14px 16px":"16px 22px",
          marginBottom:isMobile?20:24,
          display:"flex",
          alignItems:isMobile?"flex-start":"center",
          gap:14,
          flexDirection:isMobile?"column" as const:"row" as const,
          boxShadow:"0 4px 20px rgba(184,147,42,0.12)"
        }}>
          <div style={{
            display:"flex", alignItems:"center", justifyContent:"center",
            width:42, height:42, borderRadius:10,
            background:"linear-gradient(135deg,#D4A843,#B8932A)",
            flexShrink:0,
            boxShadow:"0 4px 12px rgba(184,147,42,0.30)"
          }}>
            <AxisIcon name="bolt" size={20} tone="white" withBackdrop={false} strokeWidth={3}/>
          </div>
          <div style={{flex:1}}>
            <div style={{
              fontFamily:fontSerif, fontSize:isMobile?14:16, fontWeight:700,
              color:"#D4A843", marginBottom:4, letterSpacing:"0.3px"
            }}>
              Precios especiales 2026
            </div>
            <div style={{
              fontSize:isMobile?12:13, color:"rgba(255,255,255,0.85)", lineHeight:1.5
            }}>
              Si te suscribes durante <strong style={{color:"white"}}>2026</strong>, conservas este precio mientras mantengas tu plan activo. A partir de <strong style={{color:"white"}}>enero 2027</strong> los precios se ajustarán por inflación y nuevas funcionalidades.
            </div>
          </div>
        </div>

        {/* Hero */}
        <div style={{textAlign:"center" as const, marginBottom:isMobile?22:28}}>
          <div style={{display:"inline-flex", alignItems:"center", gap:6,
            background:"rgba(184,147,42,0.10)", border:"1px solid rgba(184,147,42,0.3)",
            borderRadius:14, padding:"3px 12px", marginBottom:12}}>
            <AxisIcon name="bolt" size={11} tone="gold" withBackdrop={false} strokeWidth={3}/>
            <span style={{fontSize:10, color:gold, fontWeight:600, letterSpacing:"0.5px"}}>PLANES Y PRECIOS</span>
          </div>
          <h1 style={{fontFamily:fontSerif, fontSize:isMobile?24:36, fontWeight:700,
            color:"white", margin:"0 0 8px", lineHeight:1.15}}>
            Un plan para cada etapa.<br/><span className="gold-shine">Crece a tu ritmo.</span>
          </h1>
          <p style={{fontSize:isMobile?12:14, color:"rgba(255,255,255,0.55)", margin:"0 0 18px",
            maxWidth:560, marginLeft:"auto", marginRight:"auto"}}>
            Sin contratos, sin permanencia, sin sorpresas. Cancela cuando quieras.
          </p>

          {/* Toggle Mensual/Anual */}
          <div style={{display:"inline-flex", background:"rgba(255,255,255,0.06)",
            border:"1px solid rgba(255,255,255,0.10)", borderRadius:18, padding:3}}>
            {(["mensual","anual"] as const).map(p => (
              <button key={p} onClick={() => setPeriodo(p)}
                style={{background:periodo===p?"rgba(184,147,42,0.22)":"transparent",
                  color:periodo===p?"white":"rgba(255,255,255,0.55)",
                  border:0, borderRadius:14, padding:isMobile?"5px 14px":"6px 18px",
                  fontSize:isMobile?10:11, fontWeight:600, cursor:"pointer",
                  display:"inline-flex", alignItems:"center", gap:5}}>
                {p === "mensual" ? "Mensual" : <>Anual <span style={{color:gold, fontWeight:700}}>−17%</span></>}
              </button>
            ))}
          </div>
        </div>

        {/* Grid 4 planes — carrusel horizontal con snap en móvil, grid 4 columnas en desktop */}
        <div className={isMobile ? "planes-scroll" : ""} style={{
          display: isMobile ? "flex" : "grid",
          gridTemplateColumns: isMobile ? undefined : "repeat(4,1fr)",
          gap: isMobile ? 12 : 10,
          alignItems: "start" as const,
          paddingTop: 14,
          marginBottom: 12,
          ...(isMobile ? {
            overflowX: "auto" as const,
            scrollSnapType: "x mandatory" as const,
            paddingLeft: 14, paddingRight: 14,
            paddingBottom: 4,
            marginLeft: -14, marginRight: -14,
          } : {})
        }}>

          {planes.map(plan => {
            const tierStyles: Record<string,React.CSSProperties> = {
              "plan-emp": {
                background:"rgba(255,255,255,0.04)",
                border:"0.5px solid rgba(255,255,255,0.18)",
                boxShadow:"0 2px 10px rgba(0,0,0,0.18)",
              },
              "plan-pyme": {
                background:"linear-gradient(180deg,rgba(184,147,42,0.18),rgba(184,147,42,0.06))",
                border:"1px solid rgba(184,147,42,0.55)",
                boxShadow:"0 8px 26px rgba(184,147,42,0.22), inset 0 1px 0 rgba(255,255,255,0.08)",
              },
              "plan-crec": {
                background:"linear-gradient(180deg,rgba(140,111,31,0.32) 0%,rgba(94,73,21,0.18) 100%)",
                border:"1.5px solid rgba(212,168,67,0.65)",
                boxShadow:"0 10px 32px rgba(140,111,31,0.35), 0 0 0 0.5px rgba(212,168,67,0.25), inset 0 1px 0 rgba(212,168,67,0.30)",
              },
              "plan-corp": {
                background:"linear-gradient(180deg,#0A0A0F 0%,#15151F 100%)",
                border:"0.5px solid rgba(212,168,67,0.55)",
                boxShadow:"inset 0 1px 0 rgba(212,168,67,0.25), 0 8px 32px rgba(0,0,0,0.5), 0 0 0 0.5px rgba(212,168,67,0.20)",
              },
            };
            const titleColor = plan.tier === "plan-crec" ? "#F0C85A" : plan.tier === "plan-corp" ? "#D4A843" : "white";
            const badgeStyle: React.CSSProperties =
              plan.tier === "plan-pyme" ? {background:"linear-gradient(135deg,#B8932A,#D4A843)", color:"#0B1829", boxShadow:"0 2px 8px rgba(184,147,42,0.5)", border:"none"} :
              plan.tier === "plan-crec" ? {background:"linear-gradient(135deg,#8C6F1F,#A07C30)", color:"white", border:"0.5px solid rgba(212,168,67,0.4)", boxShadow:"0 2px 8px rgba(140,111,31,0.6)"} :
              plan.tier === "plan-corp" ? {background:"#0A0A0F", color:"#D4A843", border:"0.5px solid rgba(212,168,67,0.6)", boxShadow:"0 2px 12px rgba(0,0,0,0.6)"} :
              {background:"transparent", color:"white"};
            const ctaStyle: React.CSSProperties =
              plan.tier === "plan-emp" ? {background:"rgba(212,168,67,0.10)", border:"0.5px solid rgba(212,168,67,0.45)", color:gold} :
              plan.tier === "plan-pyme" ? {background:"linear-gradient(135deg,#B8932A,#A07C30)", border:"none", color:"#0B1829", boxShadow:"0 3px 10px rgba(184,147,42,0.4)"} :
              plan.tier === "plan-crec" ? {background:"linear-gradient(135deg,#A07C30,#8C6F1F)", border:"0.5px solid rgba(212,168,67,0.5)", color:"white", boxShadow:"0 3px 10px rgba(140,111,31,0.5)"} :
              {background:"#000", border:"0.5px solid rgba(212,168,67,0.55)", color:gold, letterSpacing:"0.5px"};

            return (
              <div key={plan.id} className={`plan-card ${plan.tier}`}
                style={{...tierStyles[plan.tier], borderRadius:12, padding:isMobile?"14px 13px":"14px 13px",
                  position:"relative" as const,
                  ...(isMobile ? {
                    flex: "0 0 78%",
                    minWidth: "78%",
                    scrollSnapAlign: "start" as const,
                  } : {})}}>

                {/* Línea metálica decorativa (solo Crec y Corp) */}
                {(plan.tier === "plan-crec" || plan.tier === "plan-corp") && (
                  <div style={{position:"absolute" as const, top:0, left:"6%", right:"6%", height:plan.tier==="plan-corp"?1.5:1,
                    background:"linear-gradient(90deg, transparent, rgba(212,168,67,0.9), transparent)"}}/>
                )}

                {/* Badge */}
                {plan.badge && (
                  <div style={{position:"absolute" as const, top:-10, left:"50%",
                    transform:"translateX(-50%)",
                    height:20, padding:"0 14px",
                    display:"flex", alignItems:"center" as const, justifyContent:"center" as const,
                    borderRadius:10, fontSize:9.5, fontWeight:700, letterSpacing:"0.6px",
                    lineHeight:1, whiteSpace:"nowrap" as const, ...badgeStyle}}>
                    {plan.badge}
                  </div>
                )}

                {/* Encabezado */}
                <div style={{fontSize:9, color:plan.tier==="plan-crec"||plan.tier==="plan-corp"?"#D4A843":(plan.tier==="plan-pyme"?gold:"rgba(255,255,255,0.45)"),
                  letterSpacing:"0.5px", textTransform:"uppercase" as const, marginBottom:4, fontWeight:600}}>Plan</div>
                <div style={{fontFamily:fontSerif, fontSize:14, fontWeight:600,
                  color:titleColor, marginBottom:1, lineHeight:1.2}}>{plan.nombre}</div>
                <div style={{fontSize:10, color:plan.tier==="plan-crec"?"rgba(240,200,90,0.65)":(plan.tier==="plan-corp"?"rgba(212,168,67,0.55)":"rgba(255,255,255,0.55)"),
                  marginBottom:10, lineHeight:1.4}}>{plan.subtitulo}</div>

                {/* Precio */}
                {plan.precioPrefix && (
                  <div style={{fontSize:11, color:"rgba(255,255,255,0.55)", lineHeight:1, marginBottom:2}}>{plan.precioPrefix}</div>
                )}
                <div style={{display:"flex", alignItems:"baseline" as const, gap:4, lineHeight:1, marginBottom:2}}>
                  <span style={{fontFamily:fontSerif, fontSize:26, fontWeight:600, color:"white"}}>{fmtPrecio(plan)}</span>
                  {plan.precio > 0 && <span style={{fontSize:10, color:"rgba(255,255,255,0.45)"}}>MXN/mes</span>}
                </div>
                <div style={{fontSize:10, color:plan.tier==="plan-corp"?"rgba(212,168,67,0.5)":"rgba(255,255,255,0.40)", marginBottom:plan.precio > 0 && !plan.precioPrefix ? 6 : 12}}>
                  {plan.precio === 0 ? plan.etiquetaPrecio : (periodo === "mensual" ? plan.etiquetaPrecio : plan.etiquetaPrecio.replace("o ", "").replace("/mes anual", "/mes"))}
                </div>

                {/* Mini-badge Precio 2026 — solo planes con precio fijo (PyME y Crecimiento) */}
                {plan.precio > 0 && !plan.precioPrefix && (
                  <div style={{display:"inline-flex", alignItems:"center", gap:4,
                    background:"rgba(184,147,42,0.18)",
                    border:"1px solid rgba(184,147,42,0.4)",
                    borderRadius:8, padding:"2px 7px", marginBottom:12}}>
                    <AxisIcon name="bolt" size={9} tone="gold" withBackdrop={false} strokeWidth={3}/>
                    <span style={{fontSize:9, color:"#D4A843", fontWeight:700, letterSpacing:"0.3px"}}>
                      Precio 2026 · garantizado
                    </span>
                  </div>
                )}

                {/* Lista hereda */}
                {plan.hereda && (
                  <div style={{fontSize:9, color:plan.tier==="plan-corp"?"rgba(212,168,67,0.85)":"rgba(212,168,67,0.75)",
                    fontWeight:600, letterSpacing:"0.4px", marginBottom:6, textTransform:"uppercase" as const}}>
                    {plan.hereda}
                  </div>
                )}

                {/* Features */}
                <div style={{display:"flex", flexDirection:"column" as const, gap:6}}>
                  {plan.features.map((f, i) => (
                    <div key={i} style={{display:"flex", gap:6, alignItems:"flex-start" as const}}>
                      <AxisIcon name="check" size={11} tone="gold" withBackdrop={false} strokeWidth={3}/>
                      <div style={{flex:1, minWidth:0, lineHeight:1.35}}>
                        <div style={{fontSize:10.5, color:"white", fontWeight:600}}>{f.modulo}</div>
                        <div style={{fontSize:9.5, color:"rgba(255,255,255,0.50)", marginTop:1}}>{f.detalle}</div>
                      </div>
                    </div>
                  ))}
                  {plan.excluye && (
                    <div style={{display:"flex", gap:6, alignItems:"flex-start" as const, marginTop:2, opacity:0.45}}>
                      <AxisIcon name="x" size={11} tone="white" withBackdrop={false} strokeWidth={3}/>
                      <span style={{fontSize:9.5, color:"rgba(255,255,255,0.5)"}}>{plan.excluye}</span>
                    </div>
                  )}
                </div>

                {/* Botón */}
                <button onClick={() => handleCta(plan)}
                  style={{width:"100%", marginTop:14, borderRadius:8,
                    padding:"9px", fontSize:11, fontWeight:700, cursor:"pointer",
                    fontFamily:fontSans, ...ctaStyle}}>
                  {plan.ctaLabel} →
                </button>
              </div>
            );
          })}
        </div>

        {/* Hint "Desliza" — solo móvil */}
        {isMobile && (
          <div style={{display:"flex", alignItems:"center" as const, justifyContent:"center" as const,
            gap:8, marginTop:6, marginBottom:18, color:"rgba(212,168,67,0.65)", fontSize:11, fontWeight:600,
            letterSpacing:"0.5px"}}>
            <span className="swipe-hint">←</span>
            <span>Desliza para comparar planes</span>
            <span className="swipe-hint">→</span>
          </div>
        )}

        {/* Add-ons */}
        <div style={{paddingTop:18, borderTop:"1px solid rgba(184,147,42,0.12)", marginBottom:18}}>
          <div style={{fontSize:10, color:"rgba(184,147,42,0.6)", letterSpacing:"0.5px",
            textTransform:"uppercase" as const, marginBottom:10, fontWeight:600}}>
            Complementos · paga solo lo que uses
          </div>
          <div style={{display:"grid",
            gridTemplateColumns:isMobile?"1fr":"repeat(3,1fr)", gap:8}}>
            {[
              {iconName:"suite_empleados", titulo:"Empleado adicional", precio:"$49 MXN/mes"},
              {iconName:"suite_flotilla",  titulo:"Vehículo adicional",  precio:"$69 MXN/mes"},
              {iconName:"scale_simple",    titulo:"Consulta con AXIS",   precio:"$800 MXN c/u"},
            ].map(a => (
              <div key={a.titulo} style={{background:"rgba(255,255,255,0.03)",
                border:"1px solid rgba(255,255,255,0.07)", borderRadius:10,
                padding:"11px 14px", display:"flex", alignItems:"center" as const, gap:10}}>
                <AxisIcon name={a.iconName} size={18} tone="gold" withBackdrop={false} strokeWidth={2.5}/>
                <div>
                  <div style={{fontSize:11.5, color:"white", fontWeight:600}}>{a.titulo}</div>
                  <div style={{fontSize:10, color:"rgba(255,255,255,0.5)"}}>{a.precio}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* FAQ rápido */}
        <div style={{paddingTop:18, borderTop:"1px solid rgba(184,147,42,0.12)", marginBottom:18}}>
          <div style={{fontSize:10, color:"rgba(184,147,42,0.6)", letterSpacing:"0.5px",
            textTransform:"uppercase" as const, marginBottom:10, fontWeight:600}}>
            Preguntas frecuentes
          </div>
          <div style={{display:"grid",
            gridTemplateColumns:isMobile?"1fr":"repeat(2,1fr)", gap:10}}>
            {[
              {q:"¿Puedo cambiar de plan cuando quiera?", a:"Sí. Puedes mover hacia arriba o hacia abajo en cualquier momento. Las suscripciones se prorratean automáticamente."},
              {q:"¿Qué pasa si supero mis empleados o vehículos?", a:"El número incluido no es un tope: se amplía con complementos. Cada extra se cobra a tu plan: $49/mes por empleado adicional y $69/mes por vehículo adicional."},
              {q:"¿Aceptan factura?", a:"Sí. Emitimos CFDI 4.0 al RFC de tu empresa al momento del pago. Pago seguro con Stripe (tarjeta, transferencia, OXXO Pay)."},
              {q:"¿Qué pasa si cancelo?", a:"Conservas acceso hasta el final del período pagado. Tus datos quedan disponibles 30 días para descarga; después se eliminan según el Aviso de Privacidad."},
            ].map(f => (
              <div key={f.q} style={{background:"rgba(255,255,255,0.03)",
                border:"1px solid rgba(255,255,255,0.06)", borderRadius:10,
                padding:"12px 14px"}}>
                <div style={{fontSize:11.5, color:"white", fontWeight:600, marginBottom:5, lineHeight:1.35}}>{f.q}</div>
                <div style={{fontSize:10.5, color:"rgba(255,255,255,0.55)", lineHeight:1.6}}>{f.a}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Footer */}
        <div style={{paddingTop:14, borderTop:"1px solid rgba(255,255,255,0.05)",
          textAlign:"center" as const, fontSize:10, color:"rgba(255,255,255,0.30)", lineHeight:1.7}}>
          Operado por <span style={{color:gold}}>AXIS Asesoría Legal Corporativa</span> · Aguascalientes, México<br/>
          <span style={{fontSize:9.5, color:"rgba(255,255,255,0.22)"}}>
            Aviso de Privacidad · Términos · Facturación CFDI 4.0 · Pago seguro con Stripe
          </span>
        </div>
      </div>
    </div>
  );
}


// Se abre desde el botón del header en el landing.
// Contiene toda la info detallada: qué hace AXIS, despacho, equipo, casos de uso.
function ModalAboutAxis({onClose, fontSans, fontSerif, gold, isMobile}: {
  onClose:()=>void; fontSans:string; fontSerif:string; gold:string; isMobile:boolean;
}) {
  return (
    <div onClick={onClose}
      style={{position:"fixed" as const, inset:0, background:"rgba(0,0,0,0.65)", zIndex:600,
        display:"flex", alignItems:"center", justifyContent:"center", padding:isMobile?12:24,
        backdropFilter:"blur(6px)", WebkitBackdropFilter:"blur(6px)"}}>
      <div onClick={e => e.stopPropagation()}
        style={{background:"linear-gradient(160deg,#0F2040 0%,#162447 60%,#1B3358 100%)",
          border:"1px solid rgba(184,147,42,0.3)", borderRadius:isMobile?16:20,
          width:"100%", maxWidth:760, maxHeight:"90vh", overflowY:"auto" as const,
          boxShadow:"0 30px 80px rgba(0,0,0,0.5)", fontFamily:fontSans}}>

        {/* Header del modal */}
        <div style={{padding:isMobile?"20px 20px 16px":"28px 32px 20px",
          borderBottom:"1px solid rgba(184,147,42,0.15)",
          position:"sticky" as const, top:0,
          background:"linear-gradient(160deg,#0F2040 0%,#162447 100%)", zIndex:1,
          display:"flex", alignItems:"center", justifyContent:"space-between"}}>
          <div style={{display:"flex", alignItems:"center", gap:12}}>
            <div style={{width:38, height:38, background:"linear-gradient(135deg,#B8932A,#D4A843)",
              borderRadius:9, display:"flex", alignItems:"center", justifyContent:"center",
              boxShadow:"0 3px 12px rgba(184,147,42,0.4)"}}>
              <span style={{fontFamily:fontSerif, fontSize:14, fontWeight:900, color:"#0B1829"}}>AX</span>
            </div>
            <div>
              <div style={{fontFamily:fontSerif, fontSize:isMobile?15:17, fontWeight:700, color:"white"}}>Acerca de AXIS</div>
              <div style={{fontSize:10, color:"rgba(184,147,42,0.6)", letterSpacing:"1px", textTransform:"uppercase" as const}}>El despacho detrás de la suite</div>
            </div>
          </div>
          <button onClick={onClose}
            style={{background:"transparent", border:"1px solid rgba(255,255,255,0.15)",
              color:"rgba(255,255,255,0.6)", cursor:"pointer", borderRadius:8,
              width:32, height:32, display:"flex", alignItems:"center", justifyContent:"center",
              fontSize:18, lineHeight:1}}>×</button>
        </div>

        {/* Contenido scrollable */}
        <div style={{padding:isMobile?"20px":"28px 32px"}}>

          {/* Bloque 1: Qué hace AXIS */}
          <div style={{marginBottom:28}}>
            <div style={{display:"inline-flex", alignItems:"center", gap:6,
              background:"rgba(184,147,42,0.12)", border:"1px solid rgba(184,147,42,0.3)",
              borderRadius:14, padding:"3px 11px", marginBottom:12}}>
              <AxisIcon name="bolt" size={11} tone="gold" withBackdrop={false} strokeWidth={3}/>
              <span style={{fontSize:10, color:gold, fontWeight:600, letterSpacing:"0.4px"}}>Tu empresa, blindada legalmente</span>
            </div>
            <h3 style={{fontFamily:fontSerif, fontSize:isMobile?20:24, fontWeight:700, color:"white",
              margin:"0 0 12px", lineHeight:1.25}}>
              ¿Qué hace AXIS Legaltech?
            </h3>
            <p style={{fontSize:13, color:"rgba(255,255,255,0.65)", margin:"0 0 16px", lineHeight:1.8}}>
              La primera herramienta legal preventiva diseñada para las empresas de Aguascalientes. No esperes una multa, una inspección o un conflicto laboral para actuar. <span style={{color:"rgba(184,147,42,0.9)", fontWeight:600}}>Actúa antes.</span>
            </p>
            <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr":"repeat(2,1fr)", gap:10}}>
              {[
                {iconName:"search", titulo:"Diagnóstico por industria", desc:"Verifica en minutos qué licencias, permisos y normas aplican a tu empresa según su sector. Datos del INEGI, COPARMEX y normatividad vigente en AGS."},
                {iconName:"suite_calendario", titulo:"Alertas de vencimientos", desc:"Calendario de obligaciones IMSS, SAT, INFONAVIT, PTU con recordatorios para no perder fechas críticas."},
                {iconName:"document", titulo:"Contratos en minutos", desc:"Genera contratos conforme a la LFT vigente y al Código Civil de Aguascalientes — sin esperar a un abogado."},
                {iconName:"suite_empleados", titulo:"Control de personal con respaldo legal", desc:"Expediente digital, recibos con ISR e IMSS, avisos legales automáticos. Respaldo de despacho físico."},
              ].map((item,i) => (
                <div key={i} style={{background:"rgba(255,255,255,0.04)", border:"1px solid rgba(255,255,255,0.08)",
                  borderRadius:11, padding:"12px 14px", display:"flex", gap:11, alignItems:"flex-start"}}>
                  <div style={{width:32, height:32, borderRadius:8, flexShrink:0,
                    background:"rgba(184,147,42,0.10)", border:"1px solid rgba(184,147,42,0.2)",
                    display:"flex", alignItems:"center", justifyContent:"center"}}>
                    <AxisIcon name={item.iconName} size={16} tone="gold" withBackdrop={false} strokeWidth={2.5}/>
                  </div>
                  <div>
                    <div style={{fontWeight:700, fontSize:12.5, color:"white", marginBottom:3}}>{item.titulo}</div>
                    <div style={{fontSize:11, color:"rgba(255,255,255,0.55)", lineHeight:1.6}}>{item.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Bloque 2: Documentos */}
          <div style={{marginBottom:28, background:"linear-gradient(135deg,rgba(184,147,42,0.10),rgba(184,147,42,0.03))",
            border:"1px solid rgba(184,147,42,0.25)", borderRadius:14,
            padding:isMobile?"16px":"20px 22px", display:"flex", gap:14,
            flexDirection:isMobile?"column" as const:"row" as const, alignItems:isMobile?"flex-start" as const:"center" as const}}>
            <div style={{flexShrink:0, width:isMobile?52:60, height:isMobile?52:60,
              background:"linear-gradient(135deg,#F5EFE0,#ECE3CF)",
              border:"1px solid rgba(184,147,42,0.45)", borderRadius:13,
              display:"flex", alignItems:"center", justifyContent:"center"}}>
              <AxisIcon name="suite_documentos" size={isMobile?28:32} tone="gold" withBackdrop={false} strokeWidth={2.5}/>
            </div>
            <div style={{flex:1}}>
              <h4 style={{fontFamily:fontSerif, fontSize:isMobile?15:17, fontWeight:700,
                color:"white", margin:"0 0 6px", lineHeight:1.3}}>
                Todos tus documentos legales en un solo lugar
              </h4>
              <p style={{margin:0, fontSize:12, color:"rgba(255,255,255,0.6)", lineHeight:1.7}}>
                Sube contratos firmados, expedientes de empleados, permisos y licencias. Almacenamiento cifrado, acceso desde celular o computadora en segundos.
              </p>
            </div>
          </div>

          {/* Bloque 3: El despacho */}
          <div style={{marginBottom:28, paddingTop:24,
            borderTop:"1px solid rgba(184,147,42,0.15)"}}>
            <div style={{display:"inline-flex", alignItems:"center", gap:6,
              background:"rgba(184,147,42,0.12)", border:"1px solid rgba(184,147,42,0.3)",
              borderRadius:14, padding:"3px 11px", marginBottom:12}}>
              <AxisIcon name="building" size={11} tone="gold" withBackdrop={false} strokeWidth={3}/>
              <span style={{fontSize:10, color:gold, fontWeight:600, letterSpacing:"0.4px"}}>Abogados de Aguascalientes</span>
            </div>
            <h3 style={{fontFamily:fontSerif, fontSize:isMobile?18:22, fontWeight:700, color:"white",
              margin:"0 0 12px", lineHeight:1.3}}>
              Un despacho que entiende cómo funciona Aguascalientes
            </h3>
            <p style={{fontSize:13, color:"rgba(255,255,255,0.65)", lineHeight:1.85,
              margin:"0 0 12px", textAlign:"justify" as const}}>
              <strong style={{color:gold}}>AXIS Asesoría Legal Corporativa</strong> es un despacho orgullosamente aguascalentense que decidió no quedarse en lo tradicional. Aguascalientes está por encima de la media nacional en actividad industrial y comercial — y las empresas de la región merecen herramientas legales a la altura.
            </p>
            <p style={{fontSize:13, color:"rgba(255,255,255,0.65)", lineHeight:1.85,
              margin:"0 0 16px", textAlign:"justify" as const}}>
              AXIS Legaltech no es una app genérica. Es desarrollada por abogados de Aguascalientes, calibrada para las industrias y exigencias reales de las PYMES de la región. Si necesitas algo más que la app, el despacho físico está aquí.
            </p>
            <p style={{fontSize:12, color:"rgba(255,255,255,0.5)", lineHeight:1.8,
              margin:"0 0 16px"}}>
              Fundado por <strong style={{color:gold}}>Javier Iván Acuña López</strong>, <strong style={{color:gold}}>Marco Aurelio Hernández Parada</strong> y <strong style={{color:gold}}>Lixandro Fabián Gutiérrez Ortiz</strong>.
            </p>

            {/* Datos de contacto */}
            <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr":"repeat(2,1fr)",
              gap:8, marginBottom:16}}>
              {[
                {iconName:"pin", titulo:"Aguascalientes, AGS", desc:"Torre Plaza Bosques, Int. 909"},
                {iconName:"chart", titulo:"Datos reales", desc:"INEGI, COPARMEX, cámaras de AGS"},
                {iconName:"bolt", titulo:"Rapidez y confianza", desc:"App + despacho físico cuando lo necesites"},
                {iconName:"refresh", titulo:"Siempre actualizada", desc:"Evoluciona con la normatividad"},
              ].map((item,i) => (
                <div key={i} style={{background:"rgba(255,255,255,0.03)",
                  border:"1px solid rgba(255,255,255,0.06)", borderRadius:10,
                  padding:"10px 12px", display:"flex", gap:10, alignItems:"flex-start"}}>
                  <AxisIcon name={item.iconName} size={14} tone="gold" withBackdrop={false} strokeWidth={2.5}/>
                  <div>
                    <div style={{fontWeight:700, fontSize:12, color:"white", marginBottom:2}}>{item.titulo}</div>
                    <div style={{fontSize:10.5, color:"rgba(255,255,255,0.5)", lineHeight:1.5}}>{item.desc}</div>
                  </div>
                </div>
              ))}
            </div>

            <a href="https://axislegalags.com" target="_blank" rel="noreferrer"
              style={{display:"inline-flex", alignItems:"center", gap:8,
                background:"linear-gradient(135deg,#B8932A,#A07C30)",
                border:"none", borderRadius:10, padding:"11px 22px",
                fontSize:13, fontWeight:700, color:"#0B1829",
                textDecoration:"none",
                boxShadow:"0 4px 16px rgba(184,147,42,0.35)"}}>
              <AxisIcon name="globe" size={14} tone="white" withBackdrop={false} strokeWidth={3}/>
              Conoce el despacho →
            </a>
          </div>

          {/* Footer del modal */}
          <div style={{paddingTop:16, borderTop:"1px solid rgba(184,147,42,0.15)",
            display:"flex", flexWrap:"wrap" as const, gap:14, alignItems:"center", justifyContent:"center",
            fontSize:11, color:"rgba(255,255,255,0.4)"}}>
            <span style={{display:"inline-flex", alignItems:"center", gap:5}}>
              <AxisIcon name="phone" size={11} tone="gold" withBackdrop={false} strokeWidth={3}/>
              449 425 11 28
            </span>
            <span style={{display:"inline-flex", alignItems:"center", gap:5}}>
              <AxisIcon name="mail" size={11} tone="gold" withBackdrop={false} strokeWidth={3}/>
              contacto@axislegalags.com
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── MODAL "HAZTE PRO" ───────────────────────────────────────────────────────
// Se muestra al click en card PRO si el usuario aún no es Pro.
// Permite contratar por WhatsApp o activar período de prueba sin tarjeta.
function ModalHazteProBeta({onClose, onActivarPrueba, onVerPlanes, fontSans, fontSerif, gold, isMobile}: {
  onClose:()=>void; onActivarPrueba:()=>void; onVerPlanes:()=>void;
  fontSans:string; fontSerif:string; gold:string; isMobile:boolean;
}) {
  const beneficios = [
    {iconName:"suite_documentos", titulo:"Documentos centralizados", desc:"Todos los archivos legales de tu empresa en un solo lugar — accesible desde cualquier dispositivo"},
    {iconName:"suite_empleados",  titulo:"Empleados y nómina",       desc:"Expediente digital, recibos con ISR e IMSS automáticos, avisos legales"},
    {iconName:"suite_calendario", titulo:"Calendario inteligente",   desc:"Obligaciones fiscales y laborales precargadas, comparte con tu equipo por link"},
    {iconName:"document",         titulo:"Contratos según AGS",      desc:"14 tipos de contratos conforme a la legislación vigente en Aguascalientes"},
    {iconName:"suite_flotilla",   titulo:"Control de flotilla",      desc:"Salidas, regresos e historial de vehículos con alertas de vencimiento"},
    {iconName:"scale_simple",     titulo:"Respaldo del despacho",    desc:"Cuando la app no basta, AXIS Asesoría Legal Corporativa interviene en persona"},
  ];

  const wa = "https://wa.me/524494251128?text=" + encodeURIComponent(
    "Hola AXIS, me interesa contratar el Plan Pro de AXIS Legaltech. Mi empresa es ___ y necesito saber más sobre precios y activación."
  );

  return (
    <div onClick={onClose}
      style={{position:"fixed" as const, inset:0, background:"rgba(0,0,0,0.65)", zIndex:600,
        display:"flex", alignItems:"center", justifyContent:"center", padding:isMobile?12:24,
        backdropFilter:"blur(6px)", WebkitBackdropFilter:"blur(6px)"}}>
      <div onClick={e => e.stopPropagation()}
        style={{background:"linear-gradient(160deg,#0F2040 0%,#162447 60%,#1B3358 100%)",
          border:"1px solid rgba(184,147,42,0.4)", borderRadius:isMobile?16:20,
          width:"100%", maxWidth:560, maxHeight:"90vh", overflowY:"auto" as const,
          boxShadow:"0 30px 80px rgba(0,0,0,0.5)", fontFamily:fontSans}}>

        {/* Header */}
        <div style={{padding:isMobile?"22px 20px 18px":"28px 32px 22px",
          borderBottom:"1px solid rgba(184,147,42,0.15)", textAlign:"center" as const}}>
          <div style={{width:54, height:54, background:"linear-gradient(135deg,#B8932A,#D4A843)",
            borderRadius:14, display:"flex", alignItems:"center", justifyContent:"center",
            margin:"0 auto 14px", boxShadow:"0 6px 20px rgba(184,147,42,0.4)"}}>
            <AxisIcon name="bolt" size={28} tone="white" withBackdrop={false} strokeWidth={2.5}/>
          </div>
          <h3 style={{fontFamily:fontSerif, fontSize:isMobile?22:26, fontWeight:700,
            color:"white", margin:"0 0 6px"}}>
            Hazte Pro
          </h3>
          <p style={{fontSize:12, color:"rgba(255,255,255,0.55)", margin:0, lineHeight:1.6}}>
            Desbloquea toda la suite jurídica para tu PyME en Aguascalientes
          </p>
          <button onClick={onClose}
            style={{position:"absolute" as const, top:14, right:14,
              background:"transparent", border:"1px solid rgba(255,255,255,0.15)",
              color:"rgba(255,255,255,0.6)", cursor:"pointer", borderRadius:8,
              width:30, height:30, display:"flex", alignItems:"center", justifyContent:"center",
              fontSize:18, lineHeight:1}}>×</button>
        </div>

        {/* Beneficios */}
        <div style={{padding:isMobile?"20px":"24px 32px"}}>
          <div style={{display:"grid", gridTemplateColumns:"1fr", gap:9, marginBottom:20}}>
            {beneficios.map((b,i) => (
              <div key={i} style={{display:"flex", gap:11, alignItems:"flex-start",
                background:"rgba(255,255,255,0.04)", border:"1px solid rgba(255,255,255,0.07)",
                borderRadius:10, padding:"10px 12px"}}>
                <div style={{width:28, height:28, borderRadius:7, flexShrink:0,
                  background:"rgba(184,147,42,0.10)", border:"1px solid rgba(184,147,42,0.2)",
                  display:"flex", alignItems:"center", justifyContent:"center"}}>
                  <AxisIcon name={b.iconName} size={14} tone="gold" withBackdrop={false} strokeWidth={2.5}/>
                </div>
                <div style={{flex:1}}>
                  <div style={{fontWeight:700, fontSize:12.5, color:"white", marginBottom:2}}>{b.titulo}</div>
                  <div style={{fontSize:11, color:"rgba(255,255,255,0.55)", lineHeight:1.55}}>{b.desc}</div>
                </div>
              </div>
            ))}
          </div>

          {/* CTAs */}
          <button onClick={onVerPlanes}
            style={{width:"100%", display:"flex", alignItems:"center", justifyContent:"center", gap:7,
              background:"linear-gradient(135deg,#B8932A,#A07C30)", border:"none",
              borderRadius:12, padding:"13px", fontSize:14, fontWeight:700, color:"#0B1829",
              cursor:"pointer", fontFamily:fontSans,
              boxShadow:"0 4px 16px rgba(184,147,42,0.35)", marginBottom:10}}>
            <AxisIcon name="bolt" size={14} tone="white" withBackdrop={false} strokeWidth={3}/>
            Ver detalle de planes
          </button>
          <a href={wa} target="_blank" rel="noreferrer"
            style={{display:"flex", alignItems:"center", justifyContent:"center", gap:9,
              background:"linear-gradient(135deg,#25D366,#128C7E)", border:"none",
              borderRadius:12, padding:"13px", fontSize:14, fontWeight:700, color:"white",
              textDecoration:"none", boxShadow:"0 6px 20px rgba(37,211,102,0.3)",
              marginBottom:10}}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="white"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884"/></svg>
            Contratar por WhatsApp
          </a>
          <button onClick={onActivarPrueba}
            style={{width:"100%", display:"flex", alignItems:"center", justifyContent:"center", gap:9,
              background:"transparent", border:"1px solid rgba(184,147,42,0.4)",
              borderRadius:12, padding:"12px", fontSize:13, fontWeight:600, color:gold,
              cursor:"pointer", fontFamily:fontSans}}>
            <AxisIcon name="bolt" size={13} tone="gold" withBackdrop={false} strokeWidth={3}/>
            Probar 14 días sin costo
          </button>
          <p style={{fontSize:10, color:"rgba(255,255,255,0.35)", textAlign:"center" as const,
            margin:"12px 0 0", lineHeight:1.6}}>
            Activación inmediata. Sin tarjeta requerida durante el período de prueba.
          </p>
        </div>
      </div>
    </div>
  );
}

function LandingHome({onEntrarDiagnostico, onLogin, onGoSuite, onGoFiniquito, onGoAcercaDe, onGoPlanes, onVolver, currentUser, isProUser, fontSans, fontSerif, gold}: {
  onEntrarDiagnostico:()=>void; onLogin:()=>void; onGoSuite:()=>void; onGoFiniquito:()=>void; onGoAcercaDe:()=>void; onGoPlanes:()=>void; onVolver?:()=>void;
  currentUser:any; isProUser:boolean; fontSans:string; fontSerif:string; gold:string;
}) {
  const isMobile = window.innerWidth < 768;
  const [modalAbout, setModalAbout] = useState(false);
  const [modalPro, setModalPro] = useState(false);

  // Módulos del landing — paleta despacho premium (mismos colores que SuiteHome)
  // gradiente claro→oscuro, badge GRATIS/PRO, icono blanco encima
  const modulos = [
    {id:"diagnostico", nombre:"Diagnóstico Regulatorio", desc:"Cumplimiento normativo en 10 sectores", iconName:"scale_simple", libre:true,  color:"#B8932A", colorDark:"#8C6F1F"},
    {id:"finiquito",   nombre:"Calculadora LFT",         desc:"Liquidación, finiquito, aguinaldo y vacaciones", iconName:"money", libre:true, color:"#722F37", colorDark:"#4F1F25"},
    {id:"empleados",   nombre:"Empleados y Nómina",       desc:"Expediente, recibos ISR e IMSS", iconName:"suite_empleados", libre:false, color:"#236478", colorDark:"#164C5D"},
    {id:"calendario",  nombre:"Calendario Empresarial",   desc:"Obligaciones fiscales y laborales", iconName:"suite_calendario", libre:false, color:"#A0522D", colorDark:"#7B3D1F"},
    {id:"contratos",   nombre:"Generador legal",          desc:"Contratos, avisos, consentimientos y títulos de crédito", iconName:"document", libre:false, color:"#1F4E3D", colorDark:"#143528"},
    {id:"flotilla",    nombre:"Control de Flotilla",      desc:"Salidas, regresos e historial de vehículos", iconName:"suite_flotilla", libre:false, color:"#5D4037", colorDark:"#3E2723"},
    {id:"proveedores", nombre:"Proveedores",             desc:"Validación 69-B del SAT · próximamente", iconName:"briefcase", libre:false, color:"#3D3A6B", colorDark:"#2A2849"},
    {id:"clientes",    nombre:"Clientes / Pacientes",     desc:"Cartera, expedientes y contratos",   iconName:"user_single", libre:false, color:"#8E3B6E", colorDark:"#5E2748"},
    {id:"creditos",    nombre:"Créditos",                 desc:"Préstamos a deudores, amortización y pagos",              iconName:"chart",     libre:false, color:"#1E3A8A", colorDark:"#152C66"},
  ];

  // Click en módulo:
  // - GRATIS: si no logueado o anónimo → login. Sino → entrar al módulo.
  // - PRO: si es Pro → entrar a Suite. Sino → modal Hazte Pro.
  const handleClick = (m: typeof modulos[0]) => {
    if (m.libre) {
      if (!currentUser || currentUser.isAnonymous) return onLogin();
      if (m.id === "finiquito") return onGoFiniquito();
      return onEntrarDiagnostico();
    }
    if (isProUser) return onGoSuite();
    return setModalPro(true);
  };

  // Click en card joya Documentos (siempre PRO)
  const handleClickDocumentos = () => {
    if (isProUser) return onGoSuite();
    return setModalPro(true);
  };
  return (
    <div style={{minHeight:"100vh", background:T_LIGHT.canvas, fontFamily:fontSans}}>
      <style>{`
        @keyframes goldShimmer2{0%{background-position:200% 0}100%{background-position:-200% 0}}
        .gold-text{background:linear-gradient(90deg,#B8932A,#D4A843,#F0C85A,#D4A843,#B8932A);background-size:200% auto;-webkit-background-clip:text;-webkit-text-fill-color:transparent;animation:goldShimmer2 3s linear infinite}
        @keyframes fadeUp2{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:translateY(0)}}
        .land-card{animation:fadeUp2 0.4s ease both;cursor:pointer;transition:transform 0.28s cubic-bezier(0.34,1.56,0.64,1),box-shadow 0.25s ease,border-color 0.2s!important}
        .land-card:hover{transform:translateY(-6px)!important;box-shadow:var(--mod-shadow-hov, ${T_LIGHT.shadowHov})!important;border-color:var(--mod-border-hov, ${T_LIGHT.goldBorder})!important}
        .land-card:nth-child(1){animation-delay:0.05s}.land-card:nth-child(2){animation-delay:0.10s}
        .land-card:nth-child(3){animation-delay:0.15s}.land-card:nth-child(4){animation-delay:0.20s}
        .land-card:nth-child(5){animation-delay:0.25s}.land-card:nth-child(6){animation-delay:0.30s}.land-card:nth-child(7){animation-delay:0.35s}
      `}</style>

      {/* ── HEADER navy — identidad de marca sobre canvas crema ── */}
      <div style={{padding:isMobile?"0 16px":"0 28px", height:58, display:"flex", alignItems:"center", gap:12,
        background:T.navy,
        borderBottom:"1px solid rgba(184,147,42,0.24)", position:"sticky" as const, top:0, zIndex:100,
        boxShadow:"0 2px 16px rgba(22,36,71,0.12)"}}>
        {onVolver && (!currentUser || currentUser.isAnonymous) && (
          <button onClick={onVolver} aria-label="Volver al inicio" title="Volver"
            style={{display:"inline-flex", alignItems:"center", gap:5, background:"rgba(255,255,255,0.06)", border:"1px solid rgba(255,255,255,0.16)",
              color:"rgba(255,255,255,0.85)", borderRadius:8, padding:isMobile?"6px 9px":"6px 12px", cursor:"pointer", fontFamily:fontSans, fontSize:isMobile?11:12, fontWeight:700, flexShrink:0}}>
            <span style={{fontSize:15, lineHeight:1, color:gold}}>‹</span>{!isMobile && <span>Volver</span>}
          </button>
        )}
        <div style={{width:34, height:34, background:"linear-gradient(135deg,#B8932A,#D4A843)", borderRadius:10,
          display:"flex", alignItems:"center", justifyContent:"center", boxShadow:"0 3px 12px rgba(184,147,42,0.4)"}}>
          <span style={{fontFamily:fontSerif, fontSize:14, fontWeight:900, color:"#0B1829"}}>AX</span>
        </div>
        {!isMobile && <div>
          <div style={{fontFamily:fontSerif, fontSize:15, fontWeight:700, color:"white"}}>AXIS Gestión Empresarial</div>
          <div style={{fontSize:9, color:"rgba(184,147,42,0.55)", textTransform:"uppercase" as const, letterSpacing:"1.5px"}}>by AXIS Legaltech · AGS</div>
        </div>}
        <div style={{flex:1}}/>
        {/* Botón "Acerca de AXIS" — abre modal con info detallada */}
        <button onClick={() => setModalAbout(true)}
          style={{background:"transparent", border:"1px solid rgba(255,255,255,0.14)",
            color:"rgba(255,255,255,0.7)", borderRadius:8,
            padding:isMobile?"6px 10px":"6px 14px", cursor:"pointer",
            fontSize:isMobile?11:12, fontWeight:600,
            display:"flex", alignItems:"center", gap:6}}
          title="Conoce AXIS">
          <AxisIcon name="info" size={13} tone="white" withBackdrop={false} strokeWidth={3}/>
          {!isMobile && <span>Acerca de AXIS</span>}
        </button>
        {/* Botón "Planes" — abre página de Planes y Precios */}
        <button onClick={onGoPlanes}
          style={{background:"linear-gradient(135deg,rgba(184,147,42,0.18),rgba(184,147,42,0.10))",
            border:"1px solid rgba(184,147,42,0.45)",
            color:gold, borderRadius:8,
            padding:isMobile?"6px 11px":"6px 14px", cursor:"pointer",
            fontSize:isMobile?11:12, fontWeight:700,
            display:"flex", alignItems:"center", gap:6,
            boxShadow:"0 2px 10px rgba(184,147,42,0.18)"}}
          title="Planes y precios">
          <AxisIcon name="bolt" size={13} tone="gold" withBackdrop={false} strokeWidth={3}/>
          <span>Planes</span>
        </button>
        <button onClick={onEntrarDiagnostico}
          style={{background:"transparent", border:"1px solid rgba(184,147,42,0.3)", color:gold,
            borderRadius:8, padding:isMobile?"6px 10px":"6px 14px", cursor:"pointer",
            fontSize:isMobile?11:12, fontWeight:600,
            display:"flex", alignItems:"center", gap:6}}>
          <AxisIcon name="scale_simple" size={13} tone="gold" withBackdrop={false} strokeWidth={3}/>
          <span>{isMobile?"Gratis":"Diagnóstico gratis"}</span>
        </button>
        {/* Botón "Iniciar sesión" — visible solo si no hay cuenta real (anónimo o nada) */}
        {(!currentUser || currentUser.isAnonymous) && (
          <button onClick={onLogin}
            style={{background:"transparent", border:"1px solid rgba(255,255,255,0.18)",
              color:"rgba(255,255,255,0.75)", borderRadius:8,
              padding:isMobile?"6px 10px":"6px 14px", cursor:"pointer",
              fontSize:isMobile?11:12, fontWeight:600,
              display:"flex", alignItems:"center", gap:6}}
            title="Iniciar sesión con cuenta">
            <AxisIcon name="lock_closed" size={13} tone="white" withBackdrop={false} strokeWidth={3}/>
            {!isMobile && <span>Iniciar sesión</span>}
          </button>
        )}
        <button onClick={currentUser && !currentUser.isAnonymous ? onGoSuite : (isProUser ? onGoSuite : onLogin)}
          style={{background:"linear-gradient(135deg,#B8932A,#A07C30)", border:"none",
            borderRadius:8, padding:isMobile?"6px 12px":"6px 16px", cursor:"pointer",
            fontSize:isMobile?11:12, fontWeight:700, color:"#0B1829",
            boxShadow:"0 2px 10px rgba(184,147,42,0.35)",
            display:"flex", alignItems:"center", gap:6}}>
          <AxisIcon name={(currentUser && !currentUser.isAnonymous) || isProUser ? "bolt" : "lock_closed"} size={13} tone="white" withBackdrop={false} strokeWidth={3}/>
          <span>{(currentUser && !currentUser.isAnonymous) || isProUser ? "Mi Suite" : "Plan Pro"}</span>
        </button>
      </div>

      {/* Banner de instalación PWA */}
      <div style={{maxWidth:1200, margin:"0 auto", padding:isMobile?"12px 16px 0":"16px 32px 0"}}>
        <InstallBanner fontSerif={fontSerif} gold={gold} isMobile={isMobile} />
      </div>

      {/* ═══════════════════════════════════════════════════════════════════
          HERO COMPACTO + SUITE EN UNA SOLA VISTA (sin scroll en desktop)
          ═══════════════════════════════════════════════════════════════════ */}
      <div style={{maxWidth:1100, margin:"0 auto", padding:isMobile?"16px 14px 24px":"24px 32px 40px"}}>

        {/* ── Hero compacto ── */}
        <div style={{textAlign:"center" as const, marginBottom:isMobile?16:24, position:"relative" as const}}>
          <div style={{position:"absolute" as const, top:-20, left:"15%", width:isMobile?180:280, height:isMobile?180:280, borderRadius:"50%",
            background:"radial-gradient(circle,rgba(184,147,42,0.10) 0%,transparent 70%)", pointerEvents:"none" as const, zIndex:0}}/>
          <div style={{position:"relative" as const, zIndex:1}}>
            <div style={{display:"inline-flex", alignItems:"center", gap:6,
              background:T_LIGHT.goldSoft, border:`1px solid ${T_LIGHT.goldBorder}`,
              borderRadius:18, padding:isMobile?"3px 12px":"4px 14px", marginBottom:isMobile?10:14}}>
              <AxisIcon name="scale_simple" size={isMobile?11:12} tone="gold" withBackdrop={false} strokeWidth={3}/>
              <span style={{fontSize:isMobile?10:11, color:gold, fontWeight:600, letterSpacing:"0.3px"}}>
                Suite jurídica premium · Pensada para PyMEs en Aguascalientes
              </span>
            </div>
            <h1 style={{fontFamily:fontSerif, fontSize:isMobile?26:42, fontWeight:700,
              color:T_LIGHT.textInk, margin:"0 0 8px", lineHeight:1.1}}>
              Gestiona tu empresa<br/><span className="gold-text">con respaldo legal.</span>
            </h1>
            <p style={{fontSize:isMobile?12:14, color:T_LIGHT.textInkSoft,
              margin:"0 auto", maxWidth:520, lineHeight:1.65}}>
              Diagnóstico y calculadora <strong style={{color:gold, fontWeight:700}}>gratis</strong>. El plan <strong style={{color:gold, fontWeight:700}}>PRO</strong> desbloquea contratos, empleados, calendario, flotilla y documentos.
            </p>
          </div>
        </div>

        {/* ── Documentos joya banner (full width) ── */}
        <div onClick={handleClickDocumentos} className="land-card"
          style={{
            background:"linear-gradient(135deg,#FFFFFF 0%,#FBF6E7 100%)",
            border:`1px solid ${T_LIGHT.goldBorder}`,
            borderRadius:isMobile?14:16, padding:isMobile?"14px 16px":"18px 22px",
            marginBottom:isMobile?10:12,
            position:"relative" as const, overflow:"hidden",
            boxShadow:"0 8px 28px rgba(184,147,42,0.16), 0 0 0 1px rgba(184,147,42,0.22)",
            display:"flex", alignItems:"center", gap:isMobile?12:18,
            ["--mod-shadow-hov" as any]: `0 14px 32px rgba(184,147,42,0.30)`,
            ["--mod-border-hov" as any]: `rgba(184,147,42,0.60)`,
          }}>
          {/* Barra acento superior dorada */}
          <div style={{position:"absolute" as const, top:0, left:0, right:0,
            height:3, background:"#B8932A", zIndex:1, pointerEvents:"none" as const}}/>
          <div style={{position:"absolute" as const, top:-30, right:-30, width:160, height:160,
            borderRadius:"50%", background:"radial-gradient(circle,rgba(184,147,42,0.14),transparent 70%)",
            pointerEvents:"none" as const}}/>
          <div style={{position:"absolute" as const, top:isMobile?9:11, right:isMobile?11:13,
            fontSize:9, fontWeight:800, padding:"3px 9px", borderRadius:11, letterSpacing:"0.5px",
            background:"rgba(184,147,42,0.18)", color:gold, border:`1px solid ${T_LIGHT.goldBorder}`}}>PRO</div>
          <div style={{flexShrink:0, width:isMobile?48:60, height:isMobile?48:60,
            background:"rgba(184,147,42,0.16)", border:"1px solid rgba(184,147,42,0.40)",
            borderRadius:isMobile?11:13,
            display:"flex", alignItems:"center", justifyContent:"center",
            boxShadow:"inset 0 1px 0 rgba(255,255,255,0.6), 0 2px 8px rgba(184,147,42,0.18)"}}>
            <AxisIcon name="suite_documentos" size={isMobile?28:36} tone="gold" color="#B8932A" withBackdrop={false} strokeWidth={2.5}/>
          </div>
          <div style={{flex:1, position:"relative" as const, zIndex:1}}>
            <div style={{fontFamily:fontSerif, fontSize:isMobile?15:19, fontWeight:700,
              color:T_LIGHT.textInk, marginBottom:isMobile?2:4, lineHeight:1.2}}>
              Documentos
            </div>
            <div style={{fontSize:isMobile?11:13, color:T_LIGHT.textInkSoft, lineHeight:1.55,
              maxWidth:520}}>
              Expedientes de empleados, contratos firmados, vehículos y más. Todo en un lugar.
            </div>
            {!isMobile && <div style={{fontSize:11, color:"#8C6F1F", marginTop:8, fontWeight:600,
              display:"flex", alignItems:"center", gap:5}}>
              <span style={{width:5, height:5, borderRadius:"50%", background:"#8C6F1F", display:"inline-block"}}/>
              Abrir módulo →
            </div>}
          </div>
        </div>

        {/* ── Grid 2x3 módulos con paleta despacho premium ── */}
        <div style={{display:"grid", gridTemplateColumns:"repeat(2,1fr)",
          gap:isMobile?9:12}}>
          {modulos.map((m, i) => {
            const accent = m.color;
            return (
              <div key={m.id} onClick={() => handleClick(m)} className="land-card"
                style={{
                  background:T_LIGHT.cardLight,
                  border:`1px solid ${T_LIGHT.borderCard}`,
                  borderRadius:isMobile?12:14,
                  padding:isMobile?"12px 13px":"16px 18px",
                  position:"relative" as const, overflow:"hidden",
                  animationDelay:`${i*0.06}s`, animationFillMode:"both",
                  boxShadow:T_LIGHT.shadow,
                  ["--mod-shadow-hov" as any]: `0 14px 32px ${accent}33`,
                  ["--mod-border-hov" as any]: `${accent}66`,
                }}>
                {/* Barra acento superior — color pleno del módulo */}
                <div style={{position:"absolute" as const, top:0, left:0, right:0,
                  height:3, background:accent, zIndex:1, pointerEvents:"none" as const}}/>
                {/* Blob decorativo (tinte del accent) */}
                <div style={{position:"absolute" as const, top:-25, right:-25,
                  width:110, height:110, borderRadius:"50%",
                  background:`${accent}14`,
                  pointerEvents:"none" as const}}/>
                {/* Badge GRATIS/PRO */}
                <div style={{position:"absolute" as const, top:isMobile?8:10, right:isMobile?8:10,
                  fontSize:8, fontWeight:800, padding:"2px 7px", borderRadius:10, letterSpacing:"0.4px",
                  background: m.libre ? T_LIGHT.successSoft : T_LIGHT.goldSoft,
                  color:      m.libre ? T_LIGHT.success     : T_LIGHT.gold,
                  border: `1px solid ${m.libre ? "rgba(5,150,105,0.25)" : T_LIGHT.goldBorder}`}}>
                  {m.libre ? "GRATIS" : "PRO"}
                </div>
                {/* Pill del ícono — accent al 10% con ícono en color pleno */}
                <div style={{
                  display:"inline-flex", alignItems:"center", justifyContent:"center",
                  width:isMobile?32:38, height:isMobile?32:38,
                  borderRadius:isMobile?9:10,
                  background:`${accent}1A`,
                  border:`1px solid ${accent}40`,
                  marginBottom:isMobile?8:10,
                  boxShadow:"inset 0 1px 0 rgba(255,255,255,0.5), 0 2px 6px rgba(22,36,71,0.06)",
                }}>
                  <AxisIcon name={m.iconName} size={isMobile?18:22} tone="gold" color={accent} withBackdrop={false} strokeWidth={2.5}/>
                </div>
                <div style={{fontFamily:fontSerif, fontWeight:700,
                  fontSize:isMobile?12:15, color:T_LIGHT.textInk, marginBottom:isMobile?2:4,
                  lineHeight:1.2}}>
                  {m.nombre}
                </div>
                <div style={{fontSize:isMobile?10:11, color:T_LIGHT.textInkSoft,
                  lineHeight:1.45}}>
                  {m.desc}
                </div>
                {/* "Abrir módulo →" en color del módulo — solo desktop */}
                {!isMobile && (
                  <div style={{marginTop:10, fontSize:10, color:accent, fontWeight:600,
                    display:"flex", alignItems:"center", gap:4}}>
                    <span style={{width:5, height:5, borderRadius:"50%", background:accent, display:"inline-block"}}/>
                    Abrir módulo →
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {/* Modal "Acerca de AXIS" */}
      {modalAbout && (
        <ModalAboutAxis onClose={() => setModalAbout(false)}
          fontSans={fontSans} fontSerif={fontSerif} gold={gold} isMobile={isMobile}/>
      )}

      {/* Modal "Hazte Pro" */}
      {modalPro && (
        <ModalHazteProBeta onClose={() => setModalPro(false)}
          onActivarPrueba={() => { setModalPro(false); onLogin(); }}
          onVerPlanes={() => { setModalPro(false); onGoPlanes(); }}
          fontSans={fontSans} fontSerif={fontSerif} gold={gold} isMobile={isMobile}/>
      )}

      {/* Footer */}
      <div style={{borderTop:`1px solid ${T_LIGHT.border}`, padding:isMobile?"16px":"20px 32px"}}>
        <div style={{maxWidth:960, margin:"0 auto", display:"flex",
          justifyContent:isMobile?"center":"space-between",
          flexDirection:isMobile?"column" as const:"row" as const,
          alignItems:"center", gap:10}}>
          <p style={{fontSize:11, color:T_LIGHT.textInkMut, margin:0, textAlign:"center" as const}}>
            © 2026 AXIS Asesoría Legal Corporativa · Torre Plaza Bosques, Int. 909 · Aguascalientes · 449 425 11 28
          </p>
          <p style={{fontSize:10, color:T_LIGHT.textInkMut, margin:"6px 0 0", textAlign:"center" as const, letterSpacing:"0.3px"}}>
            Concebido, diseñado y desarrollado por <span style={{color:T_LIGHT.gold, fontWeight:500}}>AXIS Asesoría Legal Corporativa</span> · Todos los derechos reservados
          </p>
          <div style={{display:"flex", gap:16, alignItems:"center"}}>
            <a href="https://axislegalags.com" target="_blank" rel="noreferrer"
              style={{fontSize:11, color:T_LIGHT.gold, textDecoration:"none"}}>axislegalags.com</a>
            <LegalBtn label="Aviso Legal" tipo="disclaimer" gold={gold} fontSans={fontSans} fontSerif={fontSerif} />
            <LegalBtn label="Privacidad" tipo="privacidad" gold={gold} fontSans={fontSans} fontSerif={fontSerif} />
            <button onClick={onGoAcercaDe}
              style={{background:"none", border:"none", fontSize:11, color:"rgba(184,147,42,0.45)", cursor:"pointer",
                padding:0, textDecoration:"underline", textUnderlineOffset:"2px", fontFamily:fontSans}}>
              Acerca de AXIS
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}


// ── Constantes oficiales 2026 (LFT, IMSS, INEGI/DOF) ──
// Salario mínimo zona general (CONASAMI, vigente 1-ene-2026)
const SMG_2026 = 315.04;
// Salario mínimo Zona Libre Frontera Norte (no aplica en AGS)
const SMG_ZLFN_2026 = 440.87;
// UMA diaria (INEGI/DOF, vigente 1-feb-2026) — referencia para obligaciones, no para tope laboral
const UMA_DIARIA_2026 = 117.31;
// Tope salarial para Prima de Antigüedad: 2 × SMG (Art. 162 fracc. II + Art. 486 LFT)
// El Art. 486 conservó textualmente "salario mínimo" tras la reforma de desindexación 2016.
// Criterio respaldado por PROFEDET, CCL estatales y software de nómina (CONTPAQi).
const TOPE_PRIMA_ANTIGUEDAD_2026 = SMG_2026 * 2; // = $630.08/día

// ── Lógica LFT reutilizable (misma que la Calculadora / NominaModulo) ────────
// Extraída a nivel de módulo para que el Centro de Obligaciones use EXACTAMENTE el
// mismo conteo que la calculadora (NominaModulo delega en estas funciones).
// Parsea "YYYY-MM-DD" en hora LOCAL (no UTC) para no correr un día en husos negativos.
function parseLocalLFT(s: string) { const [y,m,d] = s.split("-").map(Number); return new Date(y, (m||1)-1, d||1); }
// Días de vacaciones por antigüedad — Art. 76 LFT (reforma "Vacaciones Dignas" 2023).
function diasVacacionesLFT(anios: number) {
  if (anios < 1) return 0;
  if (anios < 2) return 12;   // Año 1
  if (anios < 3) return 14;   // Año 2
  if (anios < 4) return 16;   // Año 3
  if (anios < 5) return 18;   // Año 4
  if (anios < 6) return 20;   // Año 5
  // A partir del 6° año: 22 días base, +2 por cada quinquenio (6-10=22, 11-15=24, …)
  return 22 + Math.floor((anios - 6) / 5) * 2;
}
// Años COMPLETOS de servicio entre dos fechas (método calendario, floor). Negativo → -1.
function aniosCompletosLFT(ingreso: Date, hasta: Date): number {
  let anios = hasta.getFullYear() - ingreso.getFullYear();
  const mDiff = hasta.getMonth() - ingreso.getMonth();
  const dDiff = hasta.getDate() - ingreso.getDate();
  if (mDiff < 0 || (mDiff === 0 && dDiff < 0)) anios--;
  return anios;
}
// PATRÓN REUTILIZABLE — estado de una OBLIGACIÓN CON VENCIMIENTO por empleado.
// input: fecha de referencia (nace el derecho) + plazo (meses) + hoy.
// output: fin del plazo, días restantes, si venció, y meses transcurridos.
// Aguinaldo (límite 20 dic), PTU y otras obligaciones reusarán esta misma función.
function estadoObligacionVencimiento(referencia: Date, hoy: Date, plazoMeses: number) {
  const DAY = 86400000;
  const finPlazo = new Date(referencia); finPlazo.setMonth(finPlazo.getMonth() + plazoMeses);
  const diasRestantes = Math.ceil((finPlazo.getTime() - hoy.getTime()) / DAY);
  const vencido = hoy.getTime() > finPlazo.getTime();
  const mesesDesde = Math.max(0, Math.floor((hoy.getTime() - referencia.getTime()) / (DAY * 30.4375)));
  return { finPlazo, diasRestantes, vencido, mesesDesde };
}
// Estatus de VACACIONES de un empleado cruzando su fecha de ingreso con hoy.
// SOLO hechos + señal de RIESGO; NUNCA declara prescripción consumada.
function calcularVacacionesEmpleado(fechaIngreso: string, hoy: Date) {
  if (!fechaIngreso || typeof fechaIngreso !== "string" || !/^\d{4}-\d{2}-\d{2}/.test(fechaIngreso)) return { valida:false } as any;
  const ingreso = parseLocalLFT(fechaIngreso);
  if (isNaN(ingreso.getTime())) return { valida:false } as any;
  const DAY = 86400000;
  const addYears = (d:Date, y:number) => { const r = new Date(d); r.setFullYear(r.getFullYear() + y); return r; };
  const anios = aniosCompletosLFT(ingreso, hoy);
  if (anios < 0) return { valida:true, futuro:true, ingreso } as any;   // fecha de ingreso futura
  if (anios < 1) {
    const proximo = addYears(ingreso, 1);
    const diasParaAniversario = Math.max(0, Math.ceil((proximo.getTime() - hoy.getTime()) / DAY));
    return { valida:true, yaAplica:false, anios, dias:0, proximoAniversario:proximo, diasParaAniversario, ingreso } as any;
  }
  const desde = addYears(ingreso, anios);                 // último aniversario cumplido = nace el derecho
  const dias = diasVacacionesLFT(anios);
  const est = estadoObligacionVencimiento(desde, hoy, 6); // art. 81: otorgar dentro de 6 meses
  return {
    valida:true, yaAplica:true, anios, dias, desde,
    finPlazo: est.finPlazo, diasRestantesPlazo: est.diasRestantes, plazoVencido: est.vencido, mesesDesde: est.mesesDesde,
    // RIESGO (nunca hecho): pasado el plazo de otorgamiento, los días podrían quedar
    // sujetos a prescripción (art. 516, 1 año) — a revisar por el abogado.
    riesgoPrescripcion: est.vencido, ingreso,
  } as any;
}
// Estatus de AGUINALDO de un empleado (art. 87 LFT) — MISMA fórmula que la
// Calculadora LFT: se cuenta por AÑO CALENDARIO (desde el 1-ene, o desde su ingreso
// si entró ese mismo año) y los días se prorratean sobre 365. El salario diario se
// toma TAL CUAL del expediente (`salarioDiario`), igual que la calculadora (sin divisor).
// Reutiliza estadoObligacionVencimiento con plazoMeses=0 para el límite fijo del 20-dic.
function calcularAguinaldoEmpleado(fechaIngreso: string, salarioDiario: any, diasAguinaldo: number, hoy: Date) {
  const DAY = 86400000;
  const anio = hoy.getFullYear();
  const inicioAnio = new Date(anio, 0, 1);
  const finAnio = new Date(anio, 11, 31);
  const limite = new Date(anio, 11, 20);                       // art. 87: antes del 20 de diciembre
  const est = estadoObligacionVencimiento(limite, hoy, 0);     // patrón modular reutilizado
  const base:any = { limite, diasParaLimite: est.diasRestantes, limiteVencido: est.vencido, valida:false };
  if (!fechaIngreso || typeof fechaIngreso !== "string" || !/^\d{4}-\d{2}-\d{2}/.test(fechaIngreso)) return base;
  const ingreso = parseLocalLFT(fechaIngreso);
  if (isNaN(ingreso.getTime())) return base;
  if (ingreso.getTime() > finAnio.getTime()) return { ...base, valida:true, futuro:true, ingreso };
  const inicioComputo = ingreso.getTime() > inicioAnio.getTime() ? ingreso : inicioAnio;
  const proporcional = ingreso.getTime() > inicioAnio.getTime();   // ingresó este año → parte proporcional
  const hastaHoy = hoy.getTime() < finAnio.getTime() ? hoy : finAnio;
  const diasEntre = (hasta:Date) => Math.max(0, Math.floor((hasta.getTime() - inicioComputo.getTime()) / DAY) + 1);
  // Se acota a 1 para que un año completo dé exactamente los días pactados (evita 366/365).
  const ratio = (hasta:Date) => Math.min(1, diasEntre(hasta) / 365);
  const aunNoIngresa = inicioComputo.getTime() > hastaHoy.getTime();
  const diasProyectados = ratio(finAnio) * diasAguinaldo;
  const diasDevengados = aunNoIngresa ? 0 : ratio(hastaHoy) * diasAguinaldo;
  const sd = Number(salarioDiario);
  const tieneSalario = Number.isFinite(sd) && sd > 0;
  return {
    ...base, valida:true, ingreso, proporcional, tieneSalario, salarioDiario: tieneSalario ? sd : 0,
    diasTrabajadosAnio: aunNoIngresa ? 0 : diasEntre(hastaHoy),
    diasProyectados, diasDevengados,
    montoProyectado: tieneSalario ? diasProyectados * sd : null,
    montoDevengado:  tieneSalario ? diasDevengados  * sd : null,
  };
}

// ── CONTEXTO DE LA CUENTA PARA AXIOR ────────────────────────────────────────
// Los shells del patrón (escritorio y móvil) publican aquí el resumen YA CALCULADO
// con los datos que ELLOS ya cargaron (useDashboardData). AxiorChat lo lee al enviar.
// MULTI-TENANT: se guarda junto al uid y solo se entrega si coincide con el uid
// autenticado, para que jamás se mezclen datos de dos cuentas distintas.
const _axiorCtx: {uid:string; texto:string} = {uid:"", texto:""};
function publicarContextoAxior(uid:string, texto:string){ _axiorCtx.uid = uid || ""; _axiorCtx.texto = texto || ""; }
function leerContextoAxior(uid:string){ return (uid && _axiorCtx.uid === uid) ? _axiorCtx.texto : ""; }
// Tope de fichas individuales que viajan en el contexto (control de tamaño/costo).
const AXIOR_MAX_FICHAS = 30;

// Arma el bloque de contexto. NO recalcula reglas: reutiliza los mismos helpers que
// usan los módulos (vacaciones, aguinaldo, compliance, tareas y clasificarEntrada).
// NO incluye datos personales sensibles (CURP/RFC/NSS/correo/teléfono) ni SALARIOS
// ni montos de aguinaldo por empleado: los montos van solo como TOTAL agregado.
function construirContextoAxior(o:{
  empresa?:string; empleados:any[]; kpis:any; atencionUrgente:any[]; actividad:any;
  tareasPatron:any[]; checadasPatron:any[]; cumplimientoTareas:number; diasAg:number; hoy:Date;
  horarioGeneral?:any; historialGeneral?:any;
  // Las vacaciones registradas (13-oct-2026): con ellas el checador del mes no
  // llama "sin registro" a un día de vacaciones.
  registrosVacaciones?:any[]|null;
}): string {
  const empleados = o.empleados||[], atencion = o.atencionUrgente||[], tareasPatron = o.tareasPatron||[];
  const checadas = o.checadasPatron||[], diasAg = o.diasAg||15, hoy = o.hoy||new Date();
  const activos = empleados.filter((e:any)=> (e.status||"activo")==="activo");
  const ym = mesActualYM();
  const p2 = (n:number)=> String(n).padStart(2,"0");
  const hoyISO = `${hoy.getFullYear()}-${p2(hoy.getMonth()+1)}-${p2(hoy.getDate())}`;
  const tareasMes = tareasDelMes(tareasPatron, ym, ym);
  const horaDe = (c:any)=> { try { return c?.horaServidor?.toDate?.() || c?.timestamp?.toDate?.() || null; } catch(_){ return null; } };
  const money = (n:number)=> (Number(n)||0).toLocaleString("es-MX",{style:"currency",currency:"MXN",maximumFractionDigits:0});
  const fFecha = (d:any)=> (d && typeof d.toLocaleDateString==="function" && !isNaN(d.getTime?.())) ? d.toLocaleDateString("es-MX",{day:"2-digit",month:"short",year:"numeric"}) : "fecha no disponible";
  const nDias = (n:any)=> Number.isFinite(Number(n)) ? Number(n) : 0;

  // Checador del mes por empleado. Ya no tiene bucle propio: llama al MISMO
  // clasificador que los dos documentos firmados y el expediente. Cuatro
  // pantallas clasificando el mismo día con escaleras distintas era lo que
  // permitía que un documento dijera "faltó" donde otro decía "sin registro".
  // Cada día, con el horario que REGÍA ese día (horarioQueRegia), como los papeles.
  const checMes = (email:string, he:any, e:any) => checadorDelMes(email, he, o.horarioGeneral, checadas, hoy,
    (t:Date)=> horarioQueRegia(e, o.horarioGeneral, o.historialGeneral, t), periodosLaboralesDe(e),
    debeChecarEnDiaDe(e, o.horarioGeneral, o.historialGeneral, o.registrosVacaciones || null));

  // Cada ficha va en su propio try/catch: un empleado con datos incompletos o
  // corruptos (sin fecha de ingreso, sin salario, sin actividades, sin checadas, compliance
  // ausente) NUNCA rompe la construcción del contexto de los demás.
  const fichas = activos.map((e:any)=>{
    try {
      const email = (e?.email||"").toString().toLowerCase().trim();
      const vac = calcularVacacionesEmpleado(e?.fechaIngreso, hoy) || {valida:false};
      const agu = calcularAguinaldoEmpleado(e?.fechaIngreso, e?.salarioDiario, diasAg, hoy) || {valida:false};
      let docs = 0; try { const c = calcularCompliance(e?.compliance); docs = Number(c?.porcentaje)||0; } catch(_){ docs = 0; }
      const abiertas = email ? tareasPatron.filter((t:any)=> t && (t.trabajadorEmail||"").toString().toLowerCase()===email && !t.confirmadaPorPatron) : [];
      const vencidas = abiertas.filter((t:any)=> t.fechaLimite && t.fechaLimite < hoyISO).length;
      let ct:any = {porcentaje:0, total:0, confirmadas:0};
      try { if (email) ct = calcularCumplimientoTareas(tareasMes, email) || ct; } catch(_){}
      const he = horarioVigente(e, o.horarioGeneral);
      let chk:any = null; try { chk = checMes(email, he, e); } catch(_){ chk = null; }
      const incidencia = !vac.valida || !!(vac as any).riesgoPrescripcion || abiertas.length>0 || docs<100 || (!!chk && (chk.sinRegistro>0 || chk.retardos>0));
      return {e, he, vac, agu, docs, ct, abiertas:abiertas.length, vencidas, chk, incidencia};
    } catch(err){
      console.error("contexto AXIOR: ficha de empleado con datos incompletos:", err);
      return {e, he:null, vac:{valida:false}, agu:{valida:false}, docs:0, ct:{porcentaje:0,total:0,confirmadas:0}, abiertas:0, vencidas:0, chk:null, incidencia:true};
    }
  });

  const conDerecho  = fichas.filter(f=> f.vac.valida && f.vac.yaAplica).length;
  const porCumplir  = fichas.filter(f=> f.vac.valida && !f.vac.yaAplica && !f.vac.futuro).length;
  const enRiesgoVac = fichas.filter(f=> f.vac.valida && f.vac.yaAplica && f.vac.plazoVencido).length;
  const totalProy = fichas.reduce((s,f)=> s + (f.agu.montoProyectado||0), 0);
  const totalDev  = fichas.reduce((s,f)=> s + (f.agu.montoDevengado||0), 0);
  const nProp     = fichas.filter(f=> f.agu.valida && !f.agu.futuro && f.agu.proporcional).length;
  const diasLim   = (()=>{ try { return estadoObligacionVencimiento(new Date(hoy.getFullYear(),11,20), hoy, 0).diasRestantes; } catch(_){ return null; } })();
  const chkTot = fichas.reduce((a:any,f:any)=> f.chk ? {a:a.a+f.chk.aTiempo, r:a.r+f.chk.retardos, t:a.t+(f.chk.tardias||0), fl:a.fl+f.chk.sinRegistro, n:a.n+1} : a, {a:0,r:0,t:0,fl:0,n:0});

  const L:string[] = [];
  L.push("=== INSTRUCCIÓN PRIORITARIA (tiene precedencia sobre cualquier otra) ===");
  L.push("Los datos de ESTA cuenta que aparecen abajo YA fueron calculados por los módulos de la plataforma (Centro de obligaciones, cumplimiento, checador).");
  L.push("• Responde sobre esta empresa ÚNICAMENTE con los datos de este bloque. Cítalos tal cual.");
  L.push("• NO hagas aritmética de fechas, NO recalcules días de vacaciones, aguinaldo, antigüedad, porcentajes ni montos. Si el número está aquí, úsalo; si no está, NO lo deduzcas ni lo estimes.");
  L.push("• Si te preguntan por un empleado o un dato que NO aparece en este bloque, di claramente que no tienes ese dato a la vista y remite al módulo correspondiente (Obligaciones, Empleados, Checador o Nómina). NUNCA inventes nombres ni cifras.");
  L.push("• No menciones salarios, CURP, RFC, NSS, correos ni teléfonos: no están aquí a propósito.");
  L.push("• ASISTENCIA: la plataforma registra CHECADAS (entradas y salidas). NO registra ausencias ni faltas. Un día laborable sin checada es \"sin registro\": nunca lo llames falta ni ausencia, ni afirmes que alguien faltó.");
  L.push("• No describas funciones que la plataforma no tiene. Si un dato no está en este bloque, di que no lo tienes a la vista; no inventes la causa.");
  L.push("Esto aplica solo a los datos de la cuenta; tus conocimientos legales generales siguen igual.");
  L.push("");
  L.push("=== DATOS REALES DE LA CUENTA ===");
  if (o.empresa) L.push(`Empresa: ${o.empresa}`);
  L.push(`Fecha de hoy: ${fFecha(hoy)}`);
  L.push("");
  L.push("RESUMEN");
  L.push(`- Empleados activos: ${activos.length}`);
  // AXIOR habla con el mismo nombre: si el tablero dice "expediente capturado"
  // y el asistente dice "cumplimiento", la contradicción la resuelve el usuario
  // creyendo lo peor.
  L.push(`- Expediente capturado (promedio): ${o.kpis?.hayEmpleados ? `${o.kpis.cumplimientoEmpleados}%` : "sin datos"}`);
  L.push(`- Cumplimiento de actividades (global): ${Number.isFinite(o.cumplimientoTareas) ? `${o.cumplimientoTareas}%` : "sin datos"}`);
  L.push(`- Horario general de la empresa: ${o.horarioGeneral ? textoHorarioParaAxior(horarioVigente(null, o.horarioGeneral)) : "no configurado"}`);
  const nPropios = fichas.filter((f:any)=> f.he && f.he.origen==="propio").length;
  L.push(`- Empleados con horario propio: ${nPropios}; con el general: ${fichas.filter((f:any)=> f.he && f.he.origen==="general").length}; sin horario: ${fichas.filter((f:any)=> !f.he || !f.he.entrada).length}`);
  L.push(chkTot.n>0
    ? `- Checador del mes (${chkTot.n} empleado${chkTot.n===1?"":"s"} evaluado${chkTot.n===1?"":"s"}): ${chkTot.a} a tiempo, ${chkTot.r} retardo${chkTot.r===1?"":"s"}, ${chkTot.t} entrada${chkTot.t===1?"":"s"} tardía${chkTot.t===1?"":"s"}, ${chkTot.fl} día${chkTot.fl===1?"":"s"} laborable${chkTot.fl===1?"":"s"} sin registro`
    : (o.horarioGeneral || nPropios ? "- Checador del mes: no hay empleados que se puedan evaluar (sin correo o sin cuenta con horario resoluble)" : "- Checador: no hay horario general ni horarios propios configurados"));
  L.push(`- Alertas críticas: ${o.kpis?.alertasCriticas ?? 0} · Por vencer en 30 días: ${o.kpis?.porVencer30d ?? 0}`);
  L.push(`- Actividades por confirmar: ${o.actividad?.tareas?.length ?? 0}`);
  L.push(`- Vacaciones: ${conDerecho} ya con derecho, ${porCumplir} por cumplir el año, ${enRiesgoVac} con plazo de otorgamiento vencido (riesgo a revisar, no es prescripción declarada)`);
  L.push(`- Aguinaldo (${diasAg} días por empleado): total proyectado a fin de año ${money(totalProy)}; devengado a la fecha ${money(totalDev)}; ${nProp} proporcionales${diasLim!=null ? `; faltan ${diasLim} días para el 20 de diciembre` : ""}`);

  if (atencion.length) {
    L.push("");
    L.push("ALERTAS PRIORITARIAS");
    atencion.slice(0,8).forEach((a:any)=> L.push(`- [${a.moduloLabel}] ${a.titulo} — ${a.detalle}`));
    if (atencion.length>8) L.push(`- (y ${atencion.length-8} alertas más)`);
  }

  // RECORTE: con pocos empleados van todos; con muchos, solo los que tienen
  // pendientes o alertas + una línea con cuántos quedaron fuera (sin incidencias).
  const todas = fichas.length <= AXIOR_MAX_FICHAS;
  const listado = todas ? fichas : fichas.filter(f=>f.incidencia).slice(0, AXIOR_MAX_FICHAS);
  const omitidos = fichas.length - listado.length;

  L.push("");
  L.push(todas ? "EMPLEADOS (todos)" : "EMPLEADOS (solo los que tienen pendientes o alertas)");
  listado.forEach((f:any, i:number)=>{
    try {
      const e = f?.e || {}, v = f?.vac || {valida:false}, a = f?.agu || {valida:false};
      const mesesIng = (v.ingreso && typeof v.ingreso.getTime==="function") ? Math.max(0, Math.floor((hoy.getTime()-v.ingreso.getTime())/(86400000*30.4375))) : 0;
      const antig = !v.valida ? "sin fecha de ingreso"
        : v.futuro ? "ingreso futuro"
        : v.anios>=1 ? `${v.anios} año${v.anios===1?"":"s"}`
        : `${mesesIng} meses`;
      L.push(`${i+1}) ${e.nombre||"(sin nombre)"}${e.puesto?` — ${e.puesto}`:""} | Ingreso: ${e.fechaIngreso||"no capturado"} | Antigüedad: ${antig}`);
      if (!v.valida) L.push("   Vacaciones: no se puede determinar (falta su fecha de ingreso).");
      else if (v.futuro) L.push("   Vacaciones: su fecha de ingreso es futura.");
      else if (!v.yaAplica) L.push(`   Vacaciones: aún no le aplican; cumple 1 año el ${fFecha(v.proximoAniversario)} (faltan ${nDias(v.diasParaAniversario)} días).`);
      else L.push(`   Vacaciones: le corresponden ${nDias(v.dias)} días; con derecho desde ${fFecha(v.desde)} (hace ${nDias(v.mesesDesde)} meses); plazo para otorgarlas hasta ${fFecha(v.finPlazo)}${v.plazoVencido ? " — PLAZO VENCIDO, riesgo a revisar" : ` (quedan ${Math.max(0,nDias(v.diasRestantesPlazo))} días)`}.`);
      if (a.valida && !a.futuro) L.push(`   Aguinaldo: ${nDias(a.diasProyectados).toFixed(1)} días proyectados de ${diasAg}${a.proporcional ? " (proporcional, ingresó este año)" : " (año completo)"}${a.tieneSalario ? "" : " — sin salario capturado, no se puede calcular el monto"}.`);
      L.push(`   Documentos: ${nDias(f.docs)}% | Actividades abiertas: ${nDias(f.abiertas)}${f.vencidas>0?` (${f.vencidas} vencidas)`:""} | Cumplimiento de actividades del mes: ${f.ct?.total>0?`${nDias(f.ct.porcentaje)}%`:"sin actividades"}`);
      L.push(`   Horario (${f.he?.origen === "propio" ? "propio" : "general"}): ${textoHorarioParaAxior(f.he)}`);
      L.push(lineaChecadorDelMes(f.chk));
    } catch(err){ L.push(`${i+1}) ${f?.e?.nombre||"(empleado)"} — datos incompletos, no se pudo resumir.`); }
  });
  if (omitidos>0) L.push(`y ${omitidos} empleado${omitidos===1?"":"s"} más sin incidencias (documentos completos, sin actividades abiertas y sin días sin registro ni retardos este mes).`);
  L.push("=== FIN DEL CONTEXTO ===");
  return L.join("\n");
}

// La marca de "esto no lo escribiste tú, lo trajimos de su ficha". Discreta a
// propósito: informa de dónde salió el dato, no pide nada.
const MARCA_FICHA: React.CSSProperties = {fontSize:10, color:"#B8932A", marginTop:4, fontWeight:700, letterSpacing:"0.3px"};

type PrellenadoFiniquito = {
  id: string; nombre: string; salarioDiario: string; fechaIngreso: string; fechaSalida: string;
  periodos: number; primeraContratacion: string;
};
// QUÉ SE COPIA DE LA FICHA A LA CALCULADORA. Vive fuera del componente para que
// se pueda probar sin pintar nada, porque de aquí sale un número que se le paga
// a una persona.
//
// Lo que no está en la ficha sale VACÍO, nunca en cero ni en la fecha de hoy: un
// salario en blanco no es un salario de cero, y una baja sin fecha no es "hoy".
function prellenadoDeFicha(t: any): PrellenadoFiniquito | null {
  if (!t) return null;
  // El ÚLTIMO periodo, no la primera contratación: `fechaIngreso` de la ficha es
  // la primera vez que entró, y si la relación se interrumpió esas dos fechas no
  // son la misma. Cuál aplica es una decisión jurídica sobre la continuidad de
  // la relación; cuando hay más de un periodo la pantalla enseña las dos y deja
  // elegir, no la toma por su cuenta.
  const per = periodosDe(t);
  const ultimo = per.length ? per[per.length - 1] : null;
  const sd = Number(t.salarioDiario);
  return {
    id: String(t.id || ""),
    nombre: String(t.nombre || ""),
    salarioDiario: (isFinite(sd) && sd > 0) ? String(sd) : "",
    fechaIngreso: String(ultimo?.ingreso || t.fechaIngreso || ""),
    fechaSalida: String(ultimo?.baja || ""),
    periodos: per.length,
    primeraContratacion: String(t.fechaIngreso || ""),
  };
}

function NominaModulo({onBack, onGoLanding, fontSans, fontSerif, gold, currentUser, isProUser, variant}: {onBack:()=>void; onGoLanding:()=>void; fontSans:string; fontSerif:string; gold:string; currentUser:any; isProUser:boolean; variant?:"portal"}) {
  const isMobile = window.innerWidth < 768;
  // El membrete del finiquito y de la liquidacion: el patron, no la plataforma.
  const dpNomina = useDatosPatron(currentUser?.uid);
  // UNA SOLA FUENTE PARA EL NOMBRE DE LA EMPRESA. El recibo imprimía DOS: el
  // encabezado leía `denominacion` del expediente de la empresa y el bloque de
  // datos leía este campo, que se tecleaba a mano cada vez y arrancaba vacío. El
  // mismo documento salía con "AXIS LEGAL" arriba y "AXIS" abajo.
  //
  // Se prellena desde el expediente y SIGUE SIENDO EDITABLE: si el patrón quiere
  // otro nombre en un recibo concreto, lo cambia. Solo se rellena mientras esté
  // vacío, para no pisar lo que él haya escrito.
  const [tab, setTab] = useState<"liquidacion"|"finiquito"|"despido_justificado"|"aguinaldo"|"vacaciones">("liquidacion");

  // Campos comunes
  const [salarioDiario, setSalarioDiario] = useState("");
  const [fechaIngreso, setFechaIngreso] = useState("");
  const [fechaSalida, setFechaSalida] = useState("");
  const [tieneVariables, setTieneVariables] = useState(false);
  const [promedioVariables, setPromedioVariables] = useState("");
  // Vacaciones de periodos ANTERIORES no disfrutadas/pagadas (default 0). Solo aplica
  // a liquidación/finiquito/despido (comparten el modelo de vacaciones proporcionales).
  const [tieneVacPendientes, setTieneVacPendientes] = useState(false);
  const [vacPendientes, setVacPendientes] = useState("0");
  const [nombreTrabajador, setNombreTrabajador] = useState("");
  const [nombreEmpresa, setNombreEmpresa] = useState("");
  const [empresaTocada, setEmpresaTocada] = useState(false);
  const [resultado, setResultado] = useState<any>(null);
  const [calculado, setCalculado] = useState(false);
  const [mostrarComparativa, setMostrarComparativa] = useState(false);
  const [showModalNomina, setShowModalNomina] = useState(false);
  const [nominaCorreoConfirmado, setNominaCorreoConfirmado] = useState(false);

  // ── TRAER LOS DATOS DE LA FICHA EN VEZ DE TECLEARLOS ──
  // El finiquito se calcula con cuatro datos que la plataforma YA tiene: el
  // nombre, el salario diario, la fecha de ingreso y la de baja. Tecleado a
  // mano, cada uno es una ocasión de equivocarse EN DINERO: un dígito de más en
  // el salario o una fecha de ingreso de otro año cambian lo que se le paga a
  // una persona, y el recibo sale firmado con ese número.
  //
  // `null` es "todavía no se ha leído", que NO es lo mismo que "no hay
  // empleados": con una lista vacía la pantalla afirmaría que no hay nadie
  // mientras todavía está cargando.
  const hayCuenta = !!currentUser?.uid && !currentUser?.isAnonymous;
  const [equipoNomina, setEquipoNomina] = useState<any[]|null>(null);
  const [equipoFallo, setEquipoFallo] = useState(false);
  // SE VUELVE A LEER AL ABRIR EL MENÚ, no una sola vez al montar. La calculadora
  // se usa justo después de dar de baja a alguien, y con una sola carga la lista
  // se quedaba con el estado que tenía cuando se entró a la pantalla: el recién
  // dado de baja seguía apareciendo como activo.
  const [tickEquipo, setTickEquipo] = useState(0);
  const [trabajadorElegido, setTrabajadorElegido] = useState("");
  // Lo que se copió, para poder decir qué campo sigue viniendo de la ficha y
  // cuál ya cambió el usuario. Se DERIVA comparando, no se marca a mano.
  const [prellenadoDe, setPrellenadoDe] = useState<PrellenadoFiniquito|null>(null);
  // Mientras no se edite a mano, el nombre de la empresa es el de la razón social que
  // firmaría el documento: la del trabajador elegido en la fecha de salida (sin ficha o
  // sin historial, la principal, como siempre). 12-oct-2026.
  // Y la denominación que rige se guarda SIEMPRE (13-oct-2026): con ella se avisa, antes de
  // generar, si el nombre escrito a mano no coincide.
  const [denominacionQueRige, setDenominacionQueRige] = useState("");
  useEffect(() => {
    let vivo = true;
    const ficha = trabajadorElegido ? ((equipoNomina||[]).find((x:any)=> x.id === trabajadorElegido) || null) : null;
    (async () => {
      try {
        const d = await datosPatronParaDocumento(currentUser?.uid || "", dpNomina.datos, ficha, fechaSalida);
        const den = String(d.denominacion || "").trim();
        if (vivo) setDenominacionQueRige(den);
        if (vivo && den && !empresaTocada) setNombreEmpresa(den);
      } catch(e) { if (vivo) setDenominacionQueRige(""); /* al generar, el documento lo vuelve a intentar y avisa */ }
    })();
    return () => { vivo = false; };
    // eslint-disable-next-line
  }, [dpNomina?.datos?.denominacion, trabajadorElegido, fechaSalida, equipoNomina, empresaTocada]);
  useEffect(() => {
    if (!hayCuenta) return;                 // un visitante no tiene equipo que traer
    let vivo = true;
    (async () => {
      try {
        const snap = await getDocs(query(collection(db,"trabajadores"), where("userId","==",currentUser.uid)));
        if (!vivo) return;
        setEquipoFallo(false);
        setEquipoNomina(snap.docs.map(d=>({id:d.id, ...(d.data() as any)})));
      } catch(e) {
        // No se pudo leer. Se dice, y se sigue pudiendo teclear a mano: nadie se
        // queda sin calcular porque falló la red.
        if (vivo) { setEquipoFallo(true); setEquipoNomina([]); }
      }
    })();
    return () => { vivo = false; };
  }, [hayCuenta, currentUser?.uid, tickEquipo]);

  const elegirTrabajador = (id:string) => {
    setTrabajadorElegido(id);
    setCalculado(false);
    const copia = prellenadoDeFicha((equipoNomina||[]).find((x:any)=>x.id===id));
    if (!copia) {
      // Volvió a "Capturar a mano". Se limpian los cuatro campos: quedarse con
      // los números de la persona anterior y ya sin la marca de dónde salieron
      // es exactamente como se calcula un finiquito de alguien más.
      setPrellenadoDe(null);
      setNombreTrabajador(""); setSalarioDiario(""); setFechaIngreso(""); setFechaSalida("");
      return;
    }
    setNombreTrabajador(copia.nombre);
    setSalarioDiario(copia.salarioDiario);
    setFechaIngreso(copia.fechaIngreso);
    setFechaSalida(copia.fechaSalida);
    setPrellenadoDe(copia);
  };
  // "Esto sigue siendo lo que dice su ficha". Es una comparación, no una
  // etiqueta: en cuanto el usuario corrige el campo, la marca desaparece sola.
  const deLaFicha = (campo:"nombre"|"salarioDiario"|"fechaIngreso"|"fechaSalida", valor:string) =>
    !!prellenadoDe && prellenadoDe[campo] !== "" && prellenadoDe[campo] === valor;

  // Parsea "YYYY-MM-DD" en hora LOCAL (no UTC). new Date("YYYY-MM-DD") interpreta
  // UTC y, en husos negativos (Aguascalientes UTC-6), corre la fecha un día atrás,
  // haciendo que un aniversario exacto se calcule como "1 día antes". Esto lo evita.
  const parseLocal = parseLocalLFT;

  const calcularAnios = () => {
    if (!fechaIngreso || !fechaSalida) return 0;
    const ingreso = parseLocal(fechaIngreso);
    const salida = parseLocal(fechaSalida);
    if (salida <= ingreso) return 0;
    // Cálculo calendarizado preciso (no usa 365.25 que falla en bisiestos)
    let anios = salida.getFullYear() - ingreso.getFullYear();
    const mDiff = salida.getMonth() - ingreso.getMonth();
    const dDiff = salida.getDate() - ingreso.getDate();
    if (mDiff < 0 || (mDiff === 0 && dDiff < 0)) anios--;
    // Calcular fracción del año en curso para proporcionales
    const ultimoAniversario = new Date(ingreso);
    ultimoAniversario.setFullYear(ingreso.getFullYear() + anios);
    const diasFraccion = Math.floor((salida.getTime() - ultimoAniversario.getTime()) / (1000*60*60*24));
    return anios + (diasFraccion / 365);
  };

  const calcularDiasVacaciones = diasVacacionesLFT;   // misma tabla, ahora a nivel de módulo

  const calcular = () => {
    const sdBase = parseFloat(salarioDiario);
    if (!sdBase || sdBase <= 0 || !fechaIngreso || !fechaSalida) return;

    // ── 1. Salario Diario Simple (sdSimple) — base para finiquito ──
    // Para aguinaldo, vacaciones y prima vacacional se usa el salario diario ordinario (Arts. 87, 76, 80)
    const variablesDiarias = tieneVariables && promedioVariables ? parseFloat(promedioVariables) / 30 : 0;
    const sdSimple = sdBase + variablesDiarias;

    // ── 2. Antigüedad (calendarizada) ──
    const anios = calcularAnios();
    const aniosCompletos = Math.floor(anios);
    const fraccionAnio = anios - aniosCompletos;
    const diasAnio = Math.floor(fraccionAnio * 365);

    // ── 3. Días de vacaciones del año en curso (para SDI factor + prop) ──
    // Si ya cumplió años, las vacaciones que está generando ahora son las del año siguiente
    const diasVacAnioCurso = calcularDiasVacaciones(aniosCompletos + 1);

    // ── 4. Factor de Integración y SDI (Art. 84 + 89 LFT) ──
    // SDI mínimo año 1: 1 + 15/365 + (12 × 0.25)/365 = 1.0493
    const diasAguinaldo = 15;
    const factorIntegracion = 1 + (diasAguinaldo / 365) + (diasVacAnioCurso * 0.25 / 365);
    const sdi = sdSimple * factorIntegracion;

    // ── 5. Aguinaldo proporcional (Art. 87 LFT) — POR AÑO CALENDARIO ──
    // No por año laboral. Se cuentan días trabajados en el año en que sale,
    // desde el 1-ene (o desde la fecha de ingreso si entró ese mismo año) hasta la fecha de salida.
    const fechaSal = parseLocal(fechaSalida);
    const fechaIng = parseLocal(fechaIngreso);
    const inicioAnioSalida = new Date(fechaSal.getFullYear(), 0, 1);
    const inicioAguinaldo = fechaIng > inicioAnioSalida ? fechaIng : inicioAnioSalida;
    const diasTrabAnioCalendario = Math.max(0, Math.floor((fechaSal.getTime() - inicioAguinaldo.getTime()) / (1000*60*60*24)) + 1);
    const diasAguinaldoProp = (diasTrabAnioCalendario / 365) * diasAguinaldo;
    const aguinaldoProp = diasAguinaldoProp * sdSimple;

    // ── 6. Vacaciones (Art. 76 LFT) — por año LABORAL ──
    // Modelo: el derecho se GENERA al cumplir cada aniversario; NO se acumula de años
    // anteriores (se asumen tomados/liquidados en su momento). En la separación se debe:
    //  • el PROPORCIONAL de los días transcurridos del periodo EN CURSO (el que se está
    //    generando), sobre los días del SIGUIENTE aniversario según tabla; y
    //  • SI la separación cae EXACTAMENTE en un aniversario (diasAnio===0), el periodo
    //    recién cumplido se generó ese día y se debe COMPLETO (no es un proporcional
    //    sumado: es el mismo periodo recién completado).
    const diasVacAnioCumplido = calcularDiasVacaciones(aniosCompletos);      // periodo recién cumplido
    const vacProporcionalEnCurso = (diasAnio / 365) * diasVacAnioCurso;       // periodo en curso
    const vacAnioReciencumplido = (diasAnio === 0 && aniosCompletos >= 1) ? diasVacAnioCumplido : 0;
    // Días pendientes de periodos ANTERIORES (captura manual; default 0 = se asumen
    // tomados/pagados). Son una deuda del patrón sólo si no se disfrutaron ni pagaron.
    const diasVacPendientes = tieneVacPendientes ? (parseFloat(vacPendientes) || 0) : 0;
    const vacProp = vacProporcionalEnCurso + vacAnioReciencumplido + diasVacPendientes;
    const importeVac = vacProp * sdSimple;
    // Texto del desglose de vacaciones (muestra de dónde sale el total).
    const _partesVac: string[] = [];
    if (vacAnioReciencumplido > 0) _partesVac.push(`${vacAnioReciencumplido} recién cumplido`);
    if (vacProporcionalEnCurso > 0) _partesVac.push(`${vacProporcionalEnCurso.toFixed(2)} proporcional`);
    if (diasVacPendientes > 0) _partesVac.push(`${diasVacPendientes} pendientes anteriores`);
    const vacDiasTexto = `${vacProp.toFixed(2)} días${_partesVac.length > 1 ? ` (${_partesVac.join(" + ")})` : ""}`;

    // ── 7. Prima Vacacional 25% (Art. 80 LFT) ──
    const primaVac = importeVac * 0.25;

    // ── 8. Finiquito base (lo que aplica a TODOS los casos de separación) ──
    const finiquitoBase = aguinaldoProp + importeVac + primaVac;

    // ── 9. Indemnizaciones del Art. 50 LFT (solo despido injustificado) ──
    // CRÍTICO: estas indemnizaciones se calculan al SDI, no al SD simple (Art. 89 LFT)
    const tresMeses = 90 * sdi;
    const veinteDiasPorAnio = 20 * aniosCompletos * sdi;

    // ── 10. Prima de Antigüedad (Art. 162 LFT) — OBLIGATORIA en despido ──
    // 12 días por año (incluye fracción), salario topado a 2 × UMA diaria
    // Aplica en: despido (justificado o no), renuncia con 15+ años, separación justificada, muerte
    const sdParaPrimaAnt = Math.min(sdSimple, TOPE_PRIMA_ANTIGUEDAD_2026);
    const primaAntiguedad = 12 * anios * sdParaPrimaAnt;
    const primaAntTopeAplicado = sdSimple > TOPE_PRIMA_ANTIGUEDAD_2026;

    // ── 11. Liquidación total (Art. 50 + finiquito + prima antigüedad) ──
    const liquidacionTotal = finiquitoBase + tresMeses + veinteDiasPorAnio + primaAntiguedad;

    // ── 12. Aguinaldo completo del año (tab independiente) ──
    // Mismo criterio que el proporcional: días trabajados en el año calendario
    const aguinaldoCompleto = (diasTrabAnioCalendario / 365) * diasAguinaldo * sdSimple;

    setResultado({
      sd: sdSimple, sdSimple, sdi, sdBase, factorIntegracion, tieneVariables, variablesDiarias,
      sdEtiqueta: tieneVariables ? `$${sdSimple.toFixed(2)}/día (con variables)` : `$${sdSimple.toFixed(2)}/día`,
      anios, aniosCompletos, diasAnio,
      diasTrabAnioCalendario,
      aguinaldoProp, importeVac, primaVac, finiquitoBase,
      diasAguinaldoProp: diasAguinaldoProp.toFixed(2),
      vacProp: vacProp.toFixed(2), vacDiasTexto, diasVacPendientes,
      diasVac: diasVacAnioCurso,
      tresMeses, veinteDiasPorAnio, liquidacionTotal,
      primaAntiguedad, sdParaPrimaAnt, primaAntTopeAplicado,
      aguinaldoCompleto, diasAguinaldo,
      diasVacCorresponden: diasVacAnioCurso,
      importeVacaciones: diasVacAnioCurso * sdSimple,
      primaVacacional: diasVacAnioCurso * sdSimple * 0.25,
      nombreTrabajador, nombreEmpresa,
      fechaIngreso, fechaSalida,
    });
    setCalculado(true);
    setMostrarComparativa(false);
  };

  const fmt = (n: number) => n.toLocaleString("es-MX", {style:"currency", currency:"MXN", minimumFractionDigits:2, maximumFractionDigits: 2});

  // ── Tooltips de ayuda por concepto (textos exactos solicitados) ──
  const TIP_AGUINALDO = "El aguinaldo es un derecho irrenunciable (Art. 87 LFT): se paga siempre, sin importar la causa de la separación.";
  const TIP_VACACIONES = "Las vacaciones proporcionales son irrenunciables (Art. 76-79 LFT): se pagan siempre, sin importar la causa de la separación.";
  const TIP_PRIMA_VAC = "La prima vacacional (25% sobre vacaciones) es irrenunciable (Art. 80 LFT): se paga siempre, sin importar la causa de la separación.";
  const TIP_TRES_MESES = "Solo aplica en despido INJUSTIFICADO o rescisión por causa imputable al patrón (Art. 49 LFT). No aplica si el trabajador renuncia o si el despido es justificado.";
  const TIP_VEINTE_DIAS = "Solo aplica en despido INJUSTIFICADO, cuando el trabajador opta por la indemnización constitucional en vez de la reinstalación (Art. 50 LFT). No aplica en renuncia ni en despido justificado.";
  const TIP_ANTIGUEDAD = "El cálculo de antigüedad sigue reglas distintas según la causa: en RENUNCIA se calcula hasta la fecha de separación para fines de vacaciones/aguinaldo proporcional únicamente; en DESPIDO (justificado o injustificado) se calcula igual para los proporcionales, pero además determina los años completos de servicio para la indemnización de 20 días por año cuando aplica (solo en injustificado).";
  const TIP_PRIMA_ANT = "Prima de antigüedad: aplica con 15 años o más de servicio (Art. 162 LFT), independientemente de la causa de separación. Se calcula con 12 días de salario por año de servicio, con el salario topado a 2 veces el salario mínimo general.";
  const TIP_VAC_PENDIENTES = "Si el trabajador no disfrutó ni se le pagaron vacaciones de años anteriores, captura aquí esos días pendientes. Por default se asume que las vacaciones de periodos ya cumplidos fueron tomadas o pagadas en su momento (Art. 76-79 LFT); si no fue así, ese saldo sigue siendo una deuda del patrón y debe sumarse aquí.";
  // Ícono ⓘ con tooltip nativo (mismo patrón title= que ya usa la app).
  const Info = ({texto}:{texto:string}) => (
    <span title={texto} role="img" aria-label="Ayuda"
      style={{display:"inline-flex", alignItems:"center", justifyContent:"center", width:15, height:15, borderRadius:"50%", border:`1px solid ${T_LIGHT.gold}`, color:T_LIGHT.gold, fontSize:10, fontWeight:800, fontStyle:"italic" as const, cursor:"help", marginLeft:6, flexShrink:0, lineHeight:1, verticalAlign:"middle"}}>i</span>
  );

  const generarReciboPDF = async (res: any, tipo: string, fmtFn: (n:number)=>string) => {
    // Si salió de una ficha, a nombre de la razón social del trabajador en la
    // fecha de salida; capturado a mano no hay ficha y queda la principal (12-oct-2026).
    const fichaFin = trabajadorElegido ? ((equipoNomina||[]).find((x:any)=> x.id === trabajadorElegido) || null) : null;
    let dpFin: DatosPatron;
    try { dpFin = await datosPatronParaDocumento(currentUser?.uid || "", dpNomina.datos, fichaFin, fechaSalida); }
    catch(e:any){ alert((e && e.message) || "No se pudo generar el recibo."); return; }
    // En el cuerpo y en la firma: la razón social del documento, salvo que el nombre se
    // haya escrito a mano en «Empresa / Razón social».
    const empresaFirma = (empresaTocada && String(res.nombreEmpresa || "").trim()) ? res.nombreEmpresa : (dpFin.denominacion || res.nombreEmpresa);
    // EL NOMBRE ESCRITO A MANO (13-oct-2026). Si coincide con la denominación de la razón
    // social que rige al trabajador en la fecha del finiquito, el documento va con ella.
    // Si no, NINGÚN dato de esa razón social: membrete y pie con el nombre escrito, la
    // firma sin RFC ("RFC del patrón: ____") y "Por el patrón", y sin su nota.
    const coincideNombre = mismaDenominacion(empresaFirma, dpFin.denominacion);
    const dpDocFin: DatosPatron = coincideNombre ? dpFin : {...DATOS_PATRON_VACIOS, denominacion: String(empresaFirma || "").trim()};
    // La nota de la primera razón social con efecto desde el inicio (12-oct-2026).
    const notaFin = (fichaFin && coincideNombre) ? notaRazonDesdeElInicio(fichaFin, _msDeFechaDocumento(fechaSalida), ()=> dpFin.denominacion) : null;
    const hoy = new Date().toLocaleDateString("es-MX", {day:"2-digit", month:"long", year:"numeric"});
    const titulo = tipo === "liquidacion" ? "RECIBO DE LIQUIDACIÓN" : tipo === "despido_justificado" ? "FINIQUITO POR DESPIDO JUSTIFICADO" : "RECIBO DE FINIQUITO";
    const conceptos = tipo === "liquidacion" ? [
      {label:"Aguinaldo proporcional", base:`${res.diasAguinaldoProp} días × ${fmtFn(res.sdSimple)}/día`, importe:res.aguinaldoProp},
      {label:"Vacaciones proporcionales", base:`${res.vacProp} días × ${fmtFn(res.sdSimple)}/día`, importe:res.importeVac},
      {label:"Prima vacacional (25%)", base:`25% de ${fmtFn(res.importeVac)}`, importe:res.primaVac},
      {label:"Indemnización — 3 meses (al SDI)", base:`90 días × ${fmtFn(res.sdi)}/día`, importe:res.tresMeses},
      {label:`20 días por año (${res.aniosCompletos} años, al SDI)`, base:`${res.aniosCompletos * 20} días × ${fmtFn(res.sdi)}/día`, importe:res.veinteDiasPorAnio},
      {label:`Prima de antigüedad`, base:`12 días × ${res.anios.toFixed(2)} años × ${fmtFn(res.sdParaPrimaAnt)}/día${res.primaAntTopeAplicado?" (tope 2×SMG)":""}`, importe:res.primaAntiguedad},
    ] : [
      {label:"Aguinaldo proporcional", base:`${res.diasAguinaldoProp} días × ${fmtFn(res.sdSimple)}/día`, importe:res.aguinaldoProp},
      {label:"Vacaciones proporcionales", base:`${res.vacProp} días × ${fmtFn(res.sdSimple)}/día`, importe:res.importeVac},
      {label:"Prima vacacional (25%)", base:`25% de ${fmtFn(res.importeVac)}`, importe:res.primaVac},
    ];
    // Despido justificado: agrega prima de antigüedad al recibo SOLO si aplica (15+ años, Art. 162).
    const primaAntDespido = tipo === "despido_justificado" && res.aniosCompletos >= 15;
    if (primaAntDespido) {
      conceptos.push({label:"Prima de antigüedad", base:`12 días × ${res.anios.toFixed(2)} años × ${fmtFn(res.sdParaPrimaAnt)}/día${res.primaAntTopeAplicado?" (tope 2×SMG)":""}`, importe:res.primaAntiguedad});
    }
    const total = tipo === "liquidacion" ? res.liquidacionTotal : (res.finiquitoBase + (primaAntDespido ? res.primaAntiguedad : 0));

    const filas = conceptos.map(c => `
      <tr style="border-bottom:1px solid #eee;">
        <td style="padding:10px 12px;font-size:13px;color:#1A1A2E;">${c.label}</td>
        <td style="padding:10px 12px;font-size:12px;color:#6B7280;">${c.base}</td>
        <td style="padding:10px 12px;font-size:13px;font-weight:700;color:#1A1A2E;text-align:right;">${fmtFn(c.importe)}</td>
      </tr>`).join("");

    const html = `<!DOCTYPE html>
<html lang="es">
<head><meta charset="UTF-8"><title>${titulo}</title>
<style>
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { font-family: -apple-system, Arial, sans-serif; color: #1A1A2E; padding: 40px; background: white; text-align: justify; }
  .header { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 32px; padding-bottom: 20px; border-bottom: 3px solid #B8932A; }
  .logo { font-size: 28px; font-weight: 800; font-family: Georgia, serif; color: #0F172A; }
  .logo span { color: #B8932A; }
  .titulo { font-size: 22px; font-weight: 700; color: #0F172A; margin-bottom: 4px; }
  .datos { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin-bottom: 28px; background: #F7F5F0; padding: 20px; border-radius: 12px; }
  .dato label { font-size: 10px; color: #9A9AAA; text-transform: uppercase; letter-spacing: 0.5px; display: block; margin-bottom: 4px; }
  .dato span { font-size: 14px; font-weight: 600; color: #1A1A2E; }
  table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
  thead { background: #0F172A; }
  thead th { padding: 10px 12px; font-size: 11px; color: rgba(255,255,255,0.7); text-transform: uppercase; letter-spacing: 0.5px; text-align: left; }
  thead th:last-child { text-align: right; }
  .total-row { background: #0F172A; }
  .total-row td { padding: 14px 12px; font-size: 15px; font-weight: 800; color: white; }
  .total-row td:last-child { text-align: right; color: #B8932A; font-size: 18px; }
  .nota { background: rgba(184,147,42,0.08); border: 1px solid rgba(184,147,42,0.25); border-radius: 10px; padding: 14px 16px; margin-bottom: 28px; font-size: 12px; color: #4A4A60; line-height: 1.7; }
  .firmas { display: grid; grid-template-columns: 1fr 1fr; gap: 40px; margin-top: 40px; }
  .firma { border-top: 2px solid #1A1A2E; padding-top: 10px; text-align: center; }
  .firma span { font-size: 12px; color: #4A4A60; }
  .footer { text-align: center; margin-top: 32px; padding-top: 16px; border-top: 1px solid #eee; font-size: 11px; color: #9A9AAA; }
  @media print { body { padding: 20px; } }
</style>
</head>
<body>
  <div class="header">
    <div style="display:flex;align-items:center;gap:10px;">
      ${!dpDocFin.denominacion ? "" : `
      <div>
        <div class="logo">${_escHtml(dpDocFin.denominacion)}</div>
        ${dpDocFin.rfc ? `<div style="font-size:11px;color:#162447;margin-top:3px;">RFC ${_escHtml(dpDocFin.rfc)}</div>` : ""}
        ${domicilioPatronTexto(dpDocFin) ? `<div style="font-size:10px;color:#6B7CB8;margin-top:2px;max-width:330px;line-height:1.45;">${_escHtml(domicilioPatronTexto(dpDocFin))}</div>` : ""}
      </div>`}
    </div>
    <div style="text-align:right;">
      <div class="titulo">${titulo}</div>
      <div style="font-size:13px;color:#9A9AAA;">Fecha: ${hoy}</div>
    </div>
  </div>

  <div class="datos">
    <div class="dato"><label>Trabajador</label><span>${res.nombreTrabajador || "___________________________"}</span></div>
    <div class="dato"><label>Empresa</label><span>${empresaFirma || "___________________________"}</span></div>
    <div class="dato"><label>Fecha de ingreso</label><span>${fechaLargaAxis(res.fechaIngreso) || "—"}</span></div>
    <div class="dato"><label>Fecha de baja</label><span>${fechaLargaAxis(res.fechaSalida) || "—"}</span></div>
    <div class="dato"><label>Antigüedad</label><span>${res.aniosCompletos} año${res.aniosCompletos!==1?"s":""} y ${res.diasAnio} días</span></div>
    <div class="dato"><label>Salario diario ${res.tieneVariables?"(con variables)":"base"}</label><span>${fmtFn(res.sdSimple)}/día</span></div>
    ${tipo === "liquidacion" ? `<div class="dato"><label>SDI</label><span>${fmtFn(res.sdi)}/día <span style="color:#9A9AAA;font-size:11px;">(factor ${res.factorIntegracion.toFixed(4)})</span></span></div>` : ""}
  </div>

  <table>
    <thead>
      <tr>
        <th>Concepto</th>
        <th>Base de cálculo</th>
        <th style="text-align:right;">Importe</th>
      </tr>
    </thead>
    <tbody>${filas}</tbody>
    <tr class="total-row">
      <td colspan="2">TOTAL ${titulo}</td>
      <td>${fmtFn(total)}</td>
    </tr>
  </table>

  <div class="nota">
    <strong style="color:#B8932A;">Nota legal:</strong> El presente recibo ampara el pago de los importes que en él se detallan. Para efectos de validez legal plena, se recomienda la revisión de un abogado laboral certificado.
  </div>
  ${bloqueDeNotasHTML([notaFin])}

  <div class="firmas">
    <div class="firma">
      <div style="height:60px;"></div>
      <span>Firma del Trabajador<br/><strong>${res.nombreTrabajador || "___________________________"}</strong></span>
    </div>
    <div class="firma">
      <div style="height:60px;"></div>
      <!-- La firma común de todo documento que firma el patrón (firmaDelPatronHTML,
           13-oct-2026): denominación, RFC y, según el tipo de persona de la razón
           social que rige, "Representante legal" (moral), "Patrón" (física) o "Por
           el patrón" (sin dato). Nunca el nombre de quien usa la cuenta. -->
      <span>Firma del patrón<br/>${firmaDelPatronHTML(coincideNombre ? dpFin.denominacion : empresaFirma, dpDocFin.rfc, dpDocFin.tipoPersona)}</span>
    </div>
  </div>

  <div class="footer">
    ${_escHtml(pieDelPatronTexto(dpDocFin, fechaHoraLargaAxis()))}
  </div>

  <script>window.onload = () => window.print();</script>
</body>
</html>`;

    const blob = new Blob([html], {type:"text/html"});
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = titulo.replace(/ /g,"_") + "_" + (res.nombreTrabajador||"trabajador") + ".html";
    a.click();
    URL.revokeObjectURL(url);
  };

  const TABS = [
    {id:"liquidacion", label:"Liquidación", desc:"Despido injustificado",
     svg:<svg width="28" height="28" viewBox="0 0 28 28" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><path d="M14 5v18"/><path d="M7 9h14"/><path d="M10 23h8"/><path d="M3 13a4 4 0 008 0L7 9z" strokeLinejoin="round"/><path d="M17 13a4 4 0 008 0l-4-4z" strokeLinejoin="round"/></svg>},
    {id:"finiquito", label:"Finiquito", desc:"Renuncia voluntaria",
     svg:<svg width="28" height="28" viewBox="0 0 28 28" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M7 4h10l4 4v16H7z" strokeLinejoin="round"/><path d="M17 4v4h4"/><path d="M11 13l2 2 4-4" strokeLinecap="round" strokeLinejoin="round"/><path d="M11 19h6" strokeLinecap="round"/></svg>},
    {id:"despido_justificado", label:"Despido justificado", desc:"Causa imputable (Art. 47)",
     svg:<svg width="28" height="28" viewBox="0 0 28 28" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M7 4h10l4 4v16H7z" strokeLinejoin="round"/><path d="M17 4v4h4"/><path d="M11 13l5 5M16 13l-5 5" strokeLinecap="round" strokeLinejoin="round"/></svg>},
    {id:"aguinaldo", label:"Aguinaldo", desc:"Proporcional anual",
     svg:<svg width="28" height="28" viewBox="0 0 28 28" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"><rect x="4" y="11" width="20" height="12" rx="1"/><path d="M14 11v12"/><path d="M3 16h22"/><path d="M14 11c-2-2-5-2-5 1s3 1 5-1z"/><path d="M14 11c2-2 5-2 5 1s-3 1-5-1z"/></svg>},
    {id:"vacaciones", label:"Vacaciones", desc:"Días y prima vacacional",
     svg:<svg width="28" height="28" viewBox="0 0 28 28" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><circle cx="14" cy="13" r="4"/><path d="M14 4v3M14 19v3M4 13h3M21 13h3M7 6l2 2M19 6l-2 2"/><path d="M3 23h22" strokeWidth="1.7"/></svg>},
  ] as const;

  return (
    <div {...ZONA_DE_CAPTURA} style={{minHeight:"100vh", background:variant==="portal"?"transparent":T_LIGHT.canvas, fontFamily:fontSans}}>
      {/* Header navy interno removido — la marca y la navegación a Suite las da el sidebar.
          variant="portal": fondo transparente para que el navy del portal del patrón
          se vea detrás (la suite de escritorio queda idéntica con el default). */}
      <div style={{maxWidth:ANCHO_CONTENIDO, margin:"0 auto", padding:variant==="portal"?(isMobile?"4px 0 14px":"4px 0 14px"):(isMobile?"12px 14px":"28px 24px")}}>

        {/* ── Pasos visuales calculadora ── */}
        <div style={{marginBottom:isMobile?12:16, padding:isMobile?"8px 10px":"12px 16px",
          background:T_LIGHT.cardLight,
          borderRadius:12, border:`1px solid ${T_LIGHT.goldBorder}`, boxShadow:T_LIGHT.shadow}}>
          <div style={{display:"flex", alignItems:"center", gap:isMobile?6:10, flexWrap:"nowrap" as const}}>
            {[
              {num:1, txt:isMobile?"Tipo":"Elige tipo de cálculo", active:true},
              {num:2, txt:isMobile?"Datos":"Ingresa los datos", active:false},
              {num:3, txt:isMobile?"PDF":"Descarga tu resultado", active:false},
            ].map((p,i) => (
              <div key={p.num} style={{display:"flex", alignItems:"center", gap:isMobile?4:8, flex:1}}>
                <div style={{width:isMobile?20:22, height:isMobile?20:22, borderRadius:"50%", flexShrink:0,
                  background:p.active?"linear-gradient(135deg,#B8932A,#8B6914)":T_LIGHT.canvasSoft,
                  border:p.active?"none":`1px solid ${T_LIGHT.border}`,
                  display:"flex", alignItems:"center", justifyContent:"center",
                  boxShadow:p.active?"0 2px 8px rgba(184,147,42,0.3)":"none"}}>
                  <span style={{fontSize:10, fontWeight:800, color:p.active?"#0B1829":T_LIGHT.textInkMut}}>{p.num}</span>
                </div>
                <span style={{fontSize:isMobile?10:11, fontWeight:p.active?700:600,
                  color:p.active?T_LIGHT.gold:T_LIGHT.textInkSoft, whiteSpace:"nowrap" as const}}>{p.txt}</span>
                {i<2 && <div style={{flex:1, height:1, background:T_LIGHT.border}}/>}
              </div>
            ))}
          </div>
        </div>

        {/* Tabs */}
        <div style={{fontSize:isMobile?10:11, color:T_LIGHT.gold, fontWeight:700, marginBottom:isMobile?6:8, textTransform:"uppercase" as const, letterSpacing:"1px"}}>
          Paso 1 — ¿Qué deseas calcular?
        </div>
        <div style={{display:"grid", gridTemplateColumns:"repeat(5,1fr)", gap:isMobile?5:6, marginBottom:isMobile?14:20}}>
          {TABS.map((t,ti) => {
              const GRAD_TABS = [
                "linear-gradient(135deg,#D4A843,#A07C30)",
                "linear-gradient(135deg,#B8932A,#7B5E15)",
                "linear-gradient(135deg,#9A7B2E,#5C4109)",
                "linear-gradient(135deg,#C9A55B,#8B6914)",
                "linear-gradient(135deg,#A77F2A,#5C4109)",
              ];
              return (
            <button key={t.id} onClick={() => { setTab(t.id); setCalculado(false); }}
              style={{padding:isMobile?"9px 4px":"12px 6px", borderRadius:isMobile?12:14, cursor:"pointer", textAlign:"center" as const,
                background:tab===t.id?GRAD_TABS[ti]:T_LIGHT.cardLight,
                boxShadow:tab===t.id?"0 4px 20px rgba(184,147,42,0.30), inset 0 1px 0 rgba(255,255,255,0.15)":T_LIGHT.shadow,
                border:tab===t.id?"none":`1px solid ${T_LIGHT.border}`}}>
              <div style={{
                color:tab===t.id?"white":T_LIGHT.gold,
                display:"flex", justifyContent:"center", marginBottom:isMobile?4:6,
                transition:"color 0.2s"
              }}>
                {t.svg}
              </div>
              <div style={{fontSize:isMobile?10.5:11, fontWeight:700, color:tab===t.id?"white":T_LIGHT.textInk}}>{t.label}</div>
              <div style={{fontSize:isMobile?9:10, color:tab===t.id?"rgba(255,255,255,0.85)":T_LIGHT.textInkSoft, lineHeight:1.25}}>{t.desc}</div>
            </button>
              );
            })}
        </div>

        {/* Formulario */}
        <div style={{background:T_LIGHT.cardLight, borderRadius:16, padding:isMobile?"14px 14px":"28px", boxShadow:T_LIGHT.shadow, border:`1px solid ${T_LIGHT.borderCard}`, marginBottom:isMobile?14:20}}>
          <h3 style={{fontFamily:fontSerif, fontSize:isMobile?16:18, color:T_LIGHT.textInk, margin:isMobile?"0 0 4px":"0 0 6px", display:"flex", alignItems:"center", gap:isMobile?8:10}}>
            <span style={{color:["#D4A843","#B8932A","#9A7B2E","#C9A55B","#A77F2A"][["liquidacion","finiquito","despido_justificado","aguinaldo","vacaciones"].indexOf(tab)], display:"flex"}}>
              {TABS.find(t=>t.id===tab)?.svg}
            </span>
            Calculadora de {TABS.find(t=>t.id===tab)?.label}
          </h3>
          <p style={{fontSize:isMobile?11.5:12, color:T_LIGHT.textInkSoft, margin:isMobile?"0 0 14px":"0 0 20px", lineHeight:1.4}}>
            {tab==="liquidacion" && "Art. 50 LFT — Rescisión sin causa justificada por parte del patrón"}
            {tab==="finiquito" && "Arts. 76, 80 y 87 LFT — Partes proporcionales al separarse"}
            {tab==="despido_justificado" && "Art. 47 LFT — Rescisión sin responsabilidad para el patrón (causa imputable al trabajador). No procede indemnización; solo las prestaciones irrenunciables."}
            {tab==="aguinaldo" && "Art. 87 LFT — Mínimo 15 días de salario antes del 20 de diciembre"}
            {tab==="vacaciones" && "Arts. 76 y 80 LFT — Días según antigüedad + prima del 25%"}
          </p>

          {/* EL SELECTOR DE TRABAJADOR. Solo dentro de la cuenta: quien no ha
             entrado no tiene ficha de nadie, y para él la pantalla es la misma
             de siempre. */}
          {hayCuenta && (
            <div style={{background:"rgba(184,147,42,0.07)", border:"1px solid rgba(184,147,42,0.22)", borderRadius:12, padding:isMobile?"12px 13px":"14px 16px", marginBottom:isMobile?14:18}}>
              <label style={{fontSize:10, color:T_LIGHT.textInkMut, display:"block", marginBottom:6, textTransform:"uppercase" as const, letterSpacing:"0.5px", fontWeight:700}}>
                Traer los datos de un trabajador
              </label>
              {equipoNomina === null ? (
                <div style={{fontSize:12.5, color:T_LIGHT.textInkSoft}}>Cargando tu equipo…</div>
              ) : equipoFallo ? (
                <div style={{fontSize:12.5, color:T_LIGHT.textInkSoft, lineHeight:1.6}}>
                  No se pudo leer tu equipo ahora mismo. Puedes capturar los datos a mano aquí abajo, o volver a entrar más tarde.
                </div>
              ) : equipoNomina.length === 0 ? (
                <div style={{fontSize:12.5, color:T_LIGHT.textInkSoft, lineHeight:1.6}}>
                  Todavía no tienes empleados dados de alta. Captura los datos a mano aquí abajo.
                </div>
              ) : (
                <>
                  <select value={trabajadorElegido} onChange={e=>elegirTrabajador(e.target.value)}
                    onFocus={()=>setTickEquipo(t=>t+1)}
                    style={{width:"100%", padding:"11px 13px", background:T_LIGHT.canvasSoft, border:"1px solid rgba(184,147,42,0.30)", borderRadius:10, fontSize:14, color:T_LIGHT.textInk, outline:"none", boxSizing:"border-box" as const, cursor:"pointer"}}>
                    <option value="">Capturar a mano…</option>
                    {/* LOS DE BAJA SE QUEDAN, y no es un descuido: un finiquito se
                        calcula justo después de la baja, así que quitarlos de aquí
                        sería quitarlos del único sitio donde hacen falta.
                        Pero van DESPUÉS de los activos y con la baja por delante,
                        no como un sufijo al final del renglón que se pierde
                        cuando el nombre y el puesto ya llenaron la línea. */}
                    {[...equipoNomina]
                      .sort((a:any,b:any)=> (a.status==="baja"?1:0) - (b.status==="baja"?1:0)
                        || String(a.nombre||"").localeCompare(String(b.nombre||""), "es"))
                      .map((t:any) => (
                        <option key={t.id} value={t.id}>
                          {t.status==="baja" ? "⚠ DADO DE BAJA · " : ""}{String(t.nombre||"(sin nombre)")}{t.puesto?` — ${t.puesto}`:""}
                        </option>
                      ))}
                  </select>
                  <div style={{fontSize:11, color:T_LIGHT.textInkMut, marginTop:7, lineHeight:1.6}}>
                    Se copian aquí su nombre, su salario diario y sus fechas. Puedes corregir cualquiera antes de calcular:
                    <strong> nada de lo que cambies aquí se guarda en su ficha.</strong>
                  </div>
                </>
              )}

              {/* LO QUE FALTABA EN LA FICHA SE DICE, no se rellena con un cero.
                 Un salario en blanco no es un salario de cero. */}
              {prellenadoDe && (prellenadoDe.salarioDiario === "" || prellenadoDe.fechaIngreso === "" || prellenadoDe.fechaSalida === "") && (
                <div style={{marginTop:10, fontSize:11.5, color:T_LIGHT.textInkSoft, background:T_LIGHT.canvasSoft, border:"1px solid rgba(0,0,0,0.06)", borderRadius:8, padding:"9px 11px", lineHeight:1.6}}>
                  Su ficha no tiene {[
                    prellenadoDe.salarioDiario === "" ? "salario diario" : "",
                    prellenadoDe.fechaIngreso === "" ? "fecha de ingreso" : "",
                    prellenadoDe.fechaSalida === "" ? "fecha de baja" : "",
                  ].filter(Boolean).join(", ").replace(/, ([^,]*)$/, " ni $1")}. {prellenadoDe.fechaSalida === "" ? "Si todavía está activo, escribe la fecha de separación que vas a usar." : "Captúralo abajo."}
                </div>
              )}

              {/* DOS FECHAS DE INGRESO POSIBLES: no se elige por el usuario. */}
              {prellenadoDe && prellenadoDe.periodos > 1 && (
                <div style={{marginTop:10, fontSize:11.5, color:T_LIGHT.textInkSoft, background:T_LIGHT.canvasSoft, border:"1px solid rgba(184,147,42,0.25)", borderRadius:8, padding:"9px 11px", lineHeight:1.6}}>
                  Esta persona tuvo <strong>{prellenadoDe.periodos} periodos con interrupción</strong>. Se trajo el inicio del último ({fechaLargaAxis(prellenadoDe.fechaIngreso)}). Su primera contratación fue el {fechaLargaAxis(prellenadoDe.primeraContratacion)}; si la relación se considera continua, esa es la fecha que va en el cálculo de la antigüedad.
                  {" "}
                  <button onClick={()=>{setFechaIngreso(prellenadoDe.primeraContratacion);setCalculado(false);}}
                    style={{background:"transparent", border:"none", padding:0, color:T_LIGHT.gold, fontWeight:700, cursor:"pointer", fontSize:11.5, textDecoration:"underline"}}>
                    Usar la primera contratación
                  </button>
                </div>
              )}
            </div>
          )}

          <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr":"1fr 1fr", gap:isMobile?12:16}}>
            <div>
              <label style={{fontSize:10, color:T_LIGHT.textInkMut, display:"block", marginBottom:5, textTransform:"uppercase" as const, letterSpacing:"0.5px", fontWeight:700}}>Nombre del trabajador</label>
              <input value={nombreTrabajador} onChange={e=>setNombreTrabajador(e.target.value)} placeholder="Para el recibo PDF"
                style={{width:"100%", padding:"11px 13px", background:T_LIGHT.canvasSoft, border:"1px solid rgba(184,147,42,0.22)", borderRadius:10, fontSize:14, color:T_LIGHT.textInk, outline:"none", boxSizing:"border-box" as const}} />
              {deLaFicha("nombre", nombreTrabajador) && <div style={MARCA_FICHA}>Viene de su ficha</div>}
            </div>
            <div>
              <label style={{fontSize:10, color:T_LIGHT.textInkMut, display:"block", marginBottom:5, textTransform:"uppercase" as const, letterSpacing:"0.5px", fontWeight:700}}>Empresa / Razón social</label>
              <input data-campo-nombre-empresa value={nombreEmpresa} onChange={e=>{ setEmpresaTocada(true); setNombreEmpresa(e.target.value); }} placeholder="Para el recibo PDF"
                style={{width:"100%", padding:"11px 13px", background:T_LIGHT.canvasSoft, border:"1px solid rgba(184,147,42,0.22)", borderRadius:10, fontSize:14, color:T_LIGHT.textInk, outline:"none", boxSizing:"border-box" as const}} />
              {/* EL NOMBRE ESCRITO NO ES LA RAZÓN SOCIAL QUE RIGE (13-oct-2026): se avisa antes de
                  generar; no bloquea. El finiquito saldrá con el nombre escrito y sin su RFC. */}
              {String(nombreEmpresa||"").trim() && denominacionQueRige && !mismaDenominacion(nombreEmpresa, denominacionQueRige) && (
                <div data-aviso-nombre-empresa style={{marginTop:6, background:"rgba(184,147,42,0.10)", border:"1px solid rgba(184,147,42,0.35)", borderRadius:9, padding:"8px 10px", fontSize:12, color:"#7A5F12", lineHeight:1.5}}>
                  {textoNombreNoCoincide((()=>{ const f = trabajadorElegido ? (equipoNomina||[]).find((x:any)=> x.id === trabajadorElegido) : null;
                    return f ? (String(f.nombre||"").trim() || "este trabajador") : (String(nombreTrabajador||"").trim() || "este trabajador"); })(), denominacionQueRige)}
                </div>
              )}
            </div>
            <div>
              <label style={{fontSize:10, color:T_LIGHT.textInkMut, display:"block", marginBottom:5, textTransform:"uppercase" as const, letterSpacing:"0.5px", fontWeight:700}}>Salario diario base (pesos) *</label>
              <input value={salarioDiario} onChange={e=>{setSalarioDiario(e.target.value);setCalculado(false);}} type="number" placeholder="Ej. 450.00"
                style={{width:"100%", padding:"11px 13px", background:T_LIGHT.canvasSoft, border:"1px solid rgba(184,147,42,0.22)", borderRadius:10, fontSize:14, color:T_LIGHT.textInk, outline:"none", boxSizing:"border-box" as const}} />
              {/* MISMO factor que el expediente y Nómina (÷30, Art. 89 LFT). Antes decía
                  ÷30.4, lo que hacía que esta pantalla y la ficha del empleado arrojaran
                  prestaciones distintas para el mismo sueldo. */}
              <div style={{fontSize:10, color:T_LIGHT.textInkMut, marginTop:4}}>
                Salario diario = salario mensual ÷ 30 <span style={{opacity:0.75}}>(Art. 89 LFT)</span>
                {parseFloat(salarioDiario) > 0 && (
                  <> · equivale a <strong style={{color:T_LIGHT.textInkSoft}}>{fmtMXN2(Math.round(diarioAMensual(parseFloat(salarioDiario))))}</strong> al mes</>
                )}
              </div>
              {deLaFicha("salarioDiario", salarioDiario) && <div style={MARCA_FICHA}>Viene de su ficha</div>}
            </div>
            <div>
              <label style={{fontSize:10, color:T_LIGHT.textInkMut, display:"block", marginBottom:5, textTransform:"uppercase" as const, letterSpacing:"0.5px", fontWeight:700}}>Fecha de ingreso *</label>
              <input value={fechaIngreso} onChange={e=>{setFechaIngreso(e.target.value);setCalculado(false);}} type="date"
                style={{width:"100%", padding:"11px 13px", background:T_LIGHT.canvasSoft, border:"1px solid rgba(184,147,42,0.22)", borderRadius:10, fontSize:14, color:T_LIGHT.textInk, outline:"none", boxSizing:"border-box" as const}} />
              {deLaFicha("fechaIngreso", fechaIngreso) && <div style={MARCA_FICHA}>Viene de su ficha</div>}
            </div>
            <div>
              <label style={{fontSize:10, color:T_LIGHT.textInkMut, display:"block", marginBottom:5, textTransform:"uppercase" as const, letterSpacing:"0.5px", fontWeight:700}}>
                {tab==="aguinaldo"?"Fecha de corte *":"Fecha de baja *"}
              </label>
              <input value={fechaSalida} onChange={e=>{setFechaSalida(e.target.value);setCalculado(false);}} type="date"
                style={{width:"100%", padding:"11px 13px", background:T_LIGHT.canvasSoft, border:"1px solid rgba(184,147,42,0.22)", borderRadius:10, fontSize:14, color:T_LIGHT.textInk, outline:"none", boxSizing:"border-box" as const}} />
              {deLaFicha("fechaSalida", fechaSalida) && <div style={MARCA_FICHA}>Viene de su ficha</div>}
            </div>
            {/* Percepciones variables */}
            <div style={{gridColumn:isMobile?"1":"1 / -1"}}>
              <div style={{display:"flex", alignItems:"center", gap:10, marginBottom:tieneVariables?12:0}}>
                <input type="checkbox" id="chkVariables" checked={tieneVariables} onChange={e=>setTieneVariables(e.target.checked)}
                  style={{width:16, height:16, cursor:"pointer", accentColor:"#B8932A"}} />
                <label htmlFor="chkVariables" style={{fontSize:13, color:T_LIGHT.textInkSoft, cursor:"pointer"}}>
                  El trabajador tiene <strong style={{color:T_LIGHT.gold}}>percepciones variables</strong> (comisiones, bonos, horas extra)
                </label>
              </div>
              {tieneVariables && (
                <div style={{background:"rgba(184,147,42,0.08)", border:"1px solid rgba(184,147,42,0.25)", borderRadius:10, padding:"12px 14px"}}>
                  <label style={{fontSize:10, color:"#D4A843", display:"block", marginBottom:6, textTransform:"uppercase" as const, letterSpacing:"0.5px", fontWeight:700}}>
                    Promedio mensual de percepciones variables (Art. 84 LFT)
                  </label>
                  <input value={promedioVariables} onChange={e=>{setPromedioVariables(e.target.value);setCalculado(false);}} type="number" placeholder="Ej. 2500.00"
                    style={{width:"100%", padding:"11px 13px", background:T_LIGHT.canvasSoft, border:"1px solid rgba(184,147,42,0.3)", borderRadius:10, fontSize:14, color:T_LIGHT.textInk, outline:"none", boxSizing:"border-box" as const}} />
                  <div style={{fontSize:11, color:"rgba(212,168,67,0.8)", marginTop:6}}>
                    Este monto se integra al salario diario para el cálculo conforme al Art. 84 LFT
                  </div>
                </div>
              )}
            </div>

            {/* Vacaciones de periodos ANTERIORES pendientes — solo liquidación/finiquito/despido */}
            {(tab === "liquidacion" || tab === "finiquito" || tab === "despido_justificado") && (
            <div style={{gridColumn:isMobile?"1":"1 / -1"}}>
              <div style={{display:"flex", alignItems:"flex-start", gap:10, marginBottom:tieneVacPendientes?12:0}}>
                <input type="checkbox" id="chkVacPend" checked={tieneVacPendientes} onChange={e=>{setTieneVacPendientes(e.target.checked);setCalculado(false);}}
                  style={{width:16, height:16, cursor:"pointer", accentColor:"#B8932A", marginTop:2, flexShrink:0}} />
                <label htmlFor="chkVacPend" style={{fontSize:13, color:T_LIGHT.textInkSoft, cursor:"pointer"}}>
                  ¿El trabajador tiene <strong style={{color:T_LIGHT.gold}}>periodos de vacaciones anteriores pendientes</strong> de pago o disfrute?
                  <Info texto={TIP_VAC_PENDIENTES}/>
                </label>
              </div>
              {tieneVacPendientes && (
                <div style={{background:"rgba(184,147,42,0.08)", border:"1px solid rgba(184,147,42,0.25)", borderRadius:10, padding:"12px 14px"}}>
                  <label style={{fontSize:10, color:"#D4A843", display:"block", marginBottom:6, textTransform:"uppercase" as const, letterSpacing:"0.5px", fontWeight:700}}>
                    Días de vacaciones pendientes de periodos anteriores
                  </label>
                  <input value={vacPendientes} onChange={e=>{setVacPendientes(e.target.value);setCalculado(false);}} type="number" min="0" placeholder="0"
                    style={{width:"100%", padding:"11px 13px", background:T_LIGHT.canvasSoft, border:"1px solid rgba(184,147,42,0.3)", borderRadius:10, fontSize:14, color:T_LIGHT.textInk, outline:"none", boxSizing:"border-box" as const}} />
                  <div style={{fontSize:11, color:"rgba(212,168,67,0.8)", marginTop:6}}>
                    Se suman a las vacaciones proporcionales del periodo en curso (Art. 76-79 LFT). Default: 0 (se asumen ya pagadas/tomadas).
                  </div>
                </div>
              )}
            </div>
            )}
          </div>

          {/* A QUIEN YA ENTRÓ NO SE LE PIDE EL CORREO. La calculadora nació como
              puerta de entrada para visitantes, y el correo era lo que se pedía a
              cambio del resultado. Dentro de la cuenta ese trato ya no existe: la
              plataforma conoce el correo, y volver a pedirlo hace dudar de si el
              cálculo se está mandando a alguien. Con sesión se calcula y ya, sin
              modal y sin escribir el lead. Sin sesión, todo sigue igual.

              La decisión se toma AQUÍ y no en el estado inicial, porque la sesión
              puede llegar después de que se pinta la pantalla. */}
          <button onClick={() => { if(currentUser || nominaCorreoConfirmado){calcular();}else{setShowModalNomina(true);} }}
            style={{marginTop:20, width:"100%", background:"linear-gradient(135deg,#B8932A,#8B6914)", border:"none", borderRadius:12, padding:"14px", cursor:"pointer", fontSize:14, fontWeight:700, color:"#0B1829", boxShadow:"0 4px 20px rgba(184,147,42,0.35)", letterSpacing:"0.3px"}}>
            Calcular {TABS.find(t=>t.id===tab)?.label}
          </button>
          {showModalNomina && (
            <ModalCorreoNomina
              tab={tab}
              currentUser={currentUser}
              onConfirmar={async (correo:string) => {
                try {
                  await addDoc(collection(db,"nomina_leads"),{
                    correo, tipoCalculo:tab,
                    fecha:new Date().toLocaleDateString("es-MX"),
                    timestamp:Timestamp.now(),
                    usuarioRegistrado:!!currentUser,
                  });
                } catch(e){}
                setNominaCorreoConfirmado(true);
                setShowModalNomina(false);
                calcular();
              }}
              onClose={() => setShowModalNomina(false)}
              gold={gold} fontSans={fontSans} fontSerif={fontSerif}
            />
          )}
        </div>

        {/* Resultado */}
        {calculado && resultado && (
          <div style={{background:T_LIGHT.cardLight, borderRadius:16, padding:isMobile?"20px":"28px", boxShadow:T_LIGHT.shadow, border:`1px solid ${T_LIGHT.borderCard}`}}>
            <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:20, flexWrap:"wrap" as const, gap:8}}>
              <h3 style={{fontFamily:fontSerif, fontSize:18, color:T_LIGHT.textInk, margin:0}}>Resultado del cálculo</h3>
              <div style={{fontSize:11, color:"#D4A843", background:"rgba(184,147,42,0.12)", border:"1px solid rgba(184,147,42,0.25)", padding:"4px 12px", borderRadius:20, display:"inline-flex", alignItems:"center"}}>
                Antigüedad: {resultado.aniosCompletos} año{resultado.aniosCompletos!==1?"s":""} y {resultado.diasAnio} días
                <Info texto={TIP_ANTIGUEDAD}/>
              </div>
            </div>

            {tab === "liquidacion" && (
              <div style={{display:"flex", flexDirection:"column" as const, gap:10}}>
                {[
                  {label:"Aguinaldo proporcional", dias:`${resultado.diasAguinaldoProp} días`, monto:resultado.aguinaldoProp, base:"Art. 87 LFT", tip:TIP_AGUINALDO},
                  {label:"Vacaciones proporcionales", dias:resultado.vacDiasTexto, monto:resultado.importeVac, base:"Art. 76 LFT", tip:TIP_VACACIONES},
                  {label:"Prima vacacional (25%)", dias:"25% de vacaciones", monto:resultado.primaVac, base:"Art. 80 LFT", tip:TIP_PRIMA_VAC},
                  {label:"3 meses de salario (al SDI)", dias:"90 días × SDI", monto:resultado.tresMeses, base:"Arts. 50 y 89 LFT", tip:TIP_TRES_MESES},
                  {label:`20 días por año (${resultado.aniosCompletos} años, al SDI)`, dias:`${resultado.aniosCompletos*20} días × SDI`, monto:resultado.veinteDiasPorAnio, base:"Arts. 50 y 89 LFT", tip:TIP_VEINTE_DIAS},
                  {label:`Prima de antigüedad (12 días × ${resultado.anios.toFixed(2)} años)`, dias:resultado.primaAntTopeAplicado?`Tope 2×SMG: $${resultado.sdParaPrimaAnt.toFixed(2)}/día`:`$${resultado.sdParaPrimaAnt.toFixed(2)}/día`, monto:resultado.primaAntiguedad, base:"Art. 162 LFT"},
                ].map(c => (
                  <div key={c.label} style={{display:"flex", alignItems:"center", justifyContent:"space-between", padding:"13px 16px", background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:10, boxShadow:T_LIGHT.shadow, borderLeft:`3px solid ${T_LIGHT.gold}`}}>
                    <div>
                      <div style={{fontSize:13, color:T_LIGHT.textInk, fontWeight:600, display:"flex", alignItems:"center"}}>{c.label}{(c as any).tip && <Info texto={(c as any).tip}/>}</div>
                      <div style={{fontSize:11, color:T_LIGHT.textInkSoft, marginTop:2}}>{c.dias} · {c.base}</div>
                    </div>
                    <div style={{fontSize:15, fontWeight:700, color:T_LIGHT.textInk}}>{fmt(c.monto)}</div>
                  </div>
                ))}
                <div style={{background:"linear-gradient(135deg,#B8932A,#8B6914)", borderRadius:12, padding:"18px 20px", display:"flex", justifyContent:"space-between", alignItems:"center", marginTop:4}}>
                  <div>
                    <div style={{fontSize:12, color:"rgba(255,255,255,0.7)"}}>TOTAL LIQUIDACIÓN</div>
                    <div style={{fontSize:10, color:"rgba(255,255,255,0.5)", marginTop:2}}>Monto mínimo conforme a LFT</div>
                  </div>
                  <div style={{fontFamily:fontSerif, fontSize:28, fontWeight:700, color:"white"}}>{fmt(resultado.liquidacionTotal)}</div>
                </div>
              </div>
            )}

            {tab === "finiquito" && (
              <div style={{display:"flex", flexDirection:"column" as const, gap:10}}>
                {[
                  {label:"Aguinaldo proporcional", dias:`${resultado.diasAguinaldoProp} días`, monto:resultado.aguinaldoProp, base:"Art. 87 LFT", tip:TIP_AGUINALDO},
                  {label:"Vacaciones proporcionales", dias:resultado.vacDiasTexto, monto:resultado.importeVac, base:"Art. 76 LFT", tip:TIP_VACACIONES},
                  {label:"Prima vacacional (25%)", dias:"25% de vacaciones", monto:resultado.primaVac, base:"Art. 80 LFT", tip:TIP_PRIMA_VAC},
                ].map(c => (
                  <div key={c.label} style={{display:"flex", alignItems:"center", justifyContent:"space-between", padding:"13px 16px", background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:10, boxShadow:T_LIGHT.shadow, borderLeft:`3px solid ${T_LIGHT.gold}`}}>
                    <div>
                      <div style={{fontSize:13, color:T_LIGHT.textInk, fontWeight:600, display:"flex", alignItems:"center"}}>{c.label}{(c as any).tip && <Info texto={(c as any).tip}/>}</div>
                      <div style={{fontSize:11, color:T_LIGHT.textInkSoft, marginTop:2}}>{c.dias} · {c.base}</div>
                    </div>
                    <div style={{fontSize:15, fontWeight:700, color:T_LIGHT.textInk}}>{fmt(c.monto)}</div>
                  </div>
                ))}
                <div style={{background:"linear-gradient(135deg,#B8932A,#8B6914)", borderRadius:12, padding:"18px 20px", display:"flex", justifyContent:"space-between", alignItems:"center", marginTop:4}}>
                  <div>
                    <div style={{fontSize:12, color:"rgba(255,255,255,0.7)"}}>TOTAL FINIQUITO</div>
                    <div style={{fontSize:10, color:"rgba(255,255,255,0.5)", marginTop:2}}>Monto mínimo conforme a LFT</div>
                  </div>
                  <div style={{fontFamily:fontSerif, fontSize:28, fontWeight:700, color:"white"}}>{fmt(resultado.finiquitoBase)}</div>
                </div>
              </div>
            )}

            {tab === "despido_justificado" && (
              <div style={{display:"flex", flexDirection:"column" as const, gap:10}}>
                {/* Prestaciones irrenunciables (se pagan SIEMPRE) */}
                {[
                  {label:"Aguinaldo proporcional", dias:`${resultado.diasAguinaldoProp} días`, monto:resultado.aguinaldoProp, base:"Art. 87 LFT", tip:TIP_AGUINALDO, noAplica:false},
                  {label:"Vacaciones proporcionales", dias:resultado.vacDiasTexto, monto:resultado.importeVac, base:"Art. 76 LFT", tip:TIP_VACACIONES, noAplica:false},
                  {label:"Prima vacacional (25%)", dias:"25% de vacaciones", monto:resultado.primaVac, base:"Art. 80 LFT", tip:TIP_PRIMA_VAC, noAplica:false},
                  {label:"Prima de antigüedad", dias: resultado.aniosCompletos>=15 ? `12 días × ${resultado.anios.toFixed(2)} años × $${resultado.sdParaPrimaAnt.toFixed(2)}/día${resultado.primaAntTopeAplicado?" (tope 2×SMG)":""}` : "No aplica — requiere 15 años de antigüedad mínima, Art. 162", monto: resultado.aniosCompletos>=15 ? resultado.primaAntiguedad : 0, base:"Art. 162 LFT", tip:TIP_PRIMA_ANT, noAplica: resultado.aniosCompletos < 15},
                  {label:"Indemnización de 3 meses", dias:"No aplica en despido justificado", monto:0, base:"Arts. 49 y 50 LFT", tip:TIP_TRES_MESES, noAplica:true},
                  {label:"20 días por año de servicio", dias:"No aplica en despido justificado", monto:0, base:"Art. 50 LFT", tip:TIP_VEINTE_DIAS, noAplica:true},
                ].map(c => (
                  <div key={c.label} style={{display:"flex", alignItems:"center", justifyContent:"space-between", padding:"13px 16px", background:c.noAplica?T_LIGHT.canvasSoft:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:10, boxShadow:c.noAplica?"none":T_LIGHT.shadow, borderLeft:`3px solid ${c.noAplica?T_LIGHT.textInkMut:T_LIGHT.gold}`, opacity:c.noAplica?0.75:1}}>
                    <div>
                      <div style={{fontSize:13, color:c.noAplica?T_LIGHT.textInkSoft:T_LIGHT.textInk, fontWeight:600, display:"flex", alignItems:"center"}}>{c.label}{c.tip && <Info texto={c.tip}/>}</div>
                      <div style={{fontSize:11, color:T_LIGHT.textInkSoft, marginTop:2}}>{c.dias} · {c.base}</div>
                    </div>
                    <div style={{fontSize:15, fontWeight:700, color:c.noAplica?T_LIGHT.textInkMut:T_LIGHT.textInk}}>{fmt(c.monto)}</div>
                  </div>
                ))}
                <div style={{background:T_LIGHT.goldSoft, border:`1px solid ${T_LIGHT.goldBorder}`, borderRadius:10, padding:"11px 14px", fontSize:11.5, color:T_LIGHT.textInkSoft, lineHeight:1.6}}>
                  Además de lo anterior, deben cubrirse los <strong style={{color:T_LIGHT.textInk}}>salarios devengados pendientes</strong> (días efectivamente trabajados y no pagados a la fecha de separación), que se suman aparte según los días que correspondan.
                </div>
                <div style={{background:"linear-gradient(135deg,#9A7B2E,#5C4109)", borderRadius:12, padding:"18px 20px", display:"flex", justifyContent:"space-between", alignItems:"center", marginTop:4}}>
                  <div>
                    <div style={{fontSize:12, color:"rgba(255,255,255,0.7)"}}>TOTAL DESPIDO JUSTIFICADO</div>
                    <div style={{fontSize:10, color:"rgba(255,255,255,0.55)", marginTop:2}}>Prestaciones irrenunciables (Art. 47){resultado.aniosCompletos>=15?" + prima de antigüedad (Art. 162)":""} · sin indemnización</div>
                  </div>
                  <div style={{fontFamily:fontSerif, fontSize:28, fontWeight:700, color:"white"}}>{fmt(resultado.finiquitoBase + (resultado.aniosCompletos>=15 ? resultado.primaAntiguedad : 0))}</div>
                </div>
              </div>
            )}

            {tab === "aguinaldo" && (
              <div style={{display:"flex", flexDirection:"column" as const, gap:10}}>
                {[
                  {label:`Días de aguinaldo (${resultado.diasAnio} días trabajados en el año)`, monto:resultado.aguinaldoCompleto, base:"Art. 87 LFT — 15 días mínimo", tip:TIP_AGUINALDO},
                ].map(c => (
                  <div key={c.label} style={{padding:"13px 16px", background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:10, boxShadow:T_LIGHT.shadow, borderLeft:`3px solid ${T_LIGHT.gold}`}}>
                    <div style={{fontSize:13, color:T_LIGHT.textInk, fontWeight:600, marginBottom:4, display:"flex", alignItems:"center"}}>{c.label}{(c as any).tip && <Info texto={(c as any).tip}/>}</div>
                    <div style={{fontSize:11, color:T_LIGHT.textInkSoft, marginTop:2}}>{c.base}</div>
                  </div>
                ))}
                <div style={{background:"linear-gradient(135deg,#B8932A,#8B6914)", borderRadius:12, padding:"18px 20px", display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                  <div>
                    <div style={{fontSize:12, color:"rgba(255,255,255,0.7)"}}>AGUINALDO PROPORCIONAL</div>
                    <div style={{fontSize:10, color:"rgba(255,255,255,0.5)"}}>Pagar antes del 20 de diciembre</div>
                  </div>
                  <div style={{fontFamily:fontSerif, fontSize:28, fontWeight:700, color:"white"}}>{fmt(resultado.aguinaldoCompleto)}</div>
                </div>
              </div>
            )}

            {tab === "vacaciones" && (
              <div style={{display:"flex", flexDirection:"column" as const, gap:10}}>
                {[
                  {label:`Días de vacaciones — ${resultado.aniosCompletos} año${resultado.aniosCompletos!==1?"s":""}`, dias:`${resultado.diasVacCorresponden} días`, monto:resultado.importeVacaciones, base:"Art. 76 LFT", tip:TIP_VACACIONES},
                  {label:"Prima vacacional (25%)", dias:"25% del importe de vacaciones", monto:resultado.primaVacacional, base:"Art. 80 LFT", tip:TIP_PRIMA_VAC},
                ].map(c => (
                  <div key={c.label} style={{display:"flex", alignItems:"center", justifyContent:"space-between", padding:"13px 16px", background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:10, boxShadow:T_LIGHT.shadow, borderLeft:`3px solid ${T_LIGHT.gold}`}}>
                    <div>
                      <div style={{fontSize:13, color:T_LIGHT.textInk, fontWeight:600, display:"flex", alignItems:"center"}}>{c.label}{(c as any).tip && <Info texto={(c as any).tip}/>}</div>
                      <div style={{fontSize:11, color:T_LIGHT.textInkSoft, marginTop:2}}>{c.dias} · {c.base}</div>
                    </div>
                    <div style={{fontSize:15, fontWeight:700, color:T_LIGHT.textInk}}>{fmt(c.monto)}</div>
                  </div>
                ))}
                <div style={{background:"linear-gradient(135deg,#B8932A,#8B6914)", borderRadius:12, padding:"18px 20px", display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                  <div>
                    <div style={{fontSize:12, color:"rgba(255,255,255,0.7)"}}>TOTAL VACACIONES + PRIMA</div>
                    <div style={{fontSize:10, color:"rgba(255,255,255,0.5)"}}>Incluye importe + prima del 25%</div>
                  </div>
                  <div style={{fontFamily:fontSerif, fontSize:28, fontWeight:700, color:"white"}}>{fmt(resultado.importeVacaciones + resultado.primaVacacional)}</div>
                </div>
              </div>
            )}

            {/* Salario integrado — aviso (siempre se muestra en liquidación porque el SDI sí se usa) */}
            {(tab === "liquidacion" || resultado.tieneVariables) && (
              <div style={{background:T_LIGHT.goldSoft, border:`1px solid ${T_LIGHT.goldBorder}`, borderRadius:10, padding:"12px 14px", marginTop:8}}>
                <div style={{fontSize:11, color:T_LIGHT.gold, fontWeight:700, marginBottom:6, letterSpacing:"0.5px"}}>BASES SALARIALES UTILIZADAS (Arts. 84, 89 LFT)</div>
                <div style={{fontSize:12, color:T_LIGHT.textInkSoft, lineHeight:1.8}}>
                  Salario diario base: <strong style={{color:T_LIGHT.textInk}}>${resultado.sdBase.toFixed(2)}</strong>/día<br/>
                  {resultado.tieneVariables && <>Percepciones variables: <strong style={{color:T_LIGHT.textInk}}>+${resultado.variablesDiarias.toFixed(2)}</strong>/día<br/></>}
                  <strong style={{color:T_LIGHT.gold}}>SD simple: ${resultado.sdSimple.toFixed(2)}/día</strong> <span style={{color:T_LIGHT.textInkMut}}>(para aguinaldo, vacaciones y prima vacacional)</span><br/>
                  Factor de integración: <strong style={{color:T_LIGHT.textInk}}>{resultado.factorIntegracion.toFixed(4)}</strong> <span style={{color:T_LIGHT.textInkMut}}>(15 días aguinaldo + {resultado.diasVac} días vac × 25%)</span><br/>
                  <strong style={{color:T_LIGHT.gold}}>SDI: ${resultado.sdi.toFixed(2)}/día</strong> <span style={{color:T_LIGHT.textInkMut}}>(para indemnización de 90 días + 20 días/año, Art. 89 LFT)</span>
                  {resultado.primaAntTopeAplicado && (<><br/><span style={{color:T_LIGHT.danger}}>⚠ Prima antigüedad topada a 2×SMG: ${resultado.sdParaPrimaAnt.toFixed(2)}/día</span></>)}
                </div>
              </div>
            )}

            {/* Tabla comparativa liquidación vs finiquito */}
            {(tab === "liquidacion" || tab === "finiquito") && (
              <div style={{marginTop:12}}>
                <button onClick={() => setMostrarComparativa(!mostrarComparativa)}
                  style={{width:"100%", background:T_LIGHT.goldSoft, border:`1px solid ${T_LIGHT.goldBorder}`, borderRadius:10, padding:"11px", cursor:"pointer", fontSize:13, fontWeight:600, color:T_LIGHT.gold, display:"flex", alignItems:"center", justifyContent:"center", gap:8}}>
                  {mostrarComparativa?"Ocultar":"Ver"} comparativa: Liquidación vs Finiquito
                </button>
                {mostrarComparativa && (
                  <div style={{marginTop:8, background:T_LIGHT.cardLight, borderRadius:12, border:`1px solid ${T_LIGHT.borderCard}`, overflow:"hidden", boxShadow:T_LIGHT.shadow}}>
                    <div style={{display:"grid", gridTemplateColumns:"1fr 1fr 1fr", background:T_LIGHT.goldSoft, padding:"11px 14px", borderBottom:`1px solid ${T_LIGHT.goldBorder}`}}>
                      <div style={{fontSize:11, color:T_LIGHT.textInkSoft, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>Concepto</div>
                      <div style={{fontSize:11, color:T_LIGHT.danger, fontWeight:700, textAlign:"center" as const, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>Liquidación</div>
                      <div style={{fontSize:11, color:T_LIGHT.success, fontWeight:700, textAlign:"center" as const, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>Finiquito</div>
                    </div>
                    {[
                      {label:"Aguinaldo prop.", liq:resultado.aguinaldoProp, fin:resultado.aguinaldoProp},
                      {label:"Vacaciones prop.", liq:resultado.importeVac, fin:resultado.importeVac},
                      {label:"Prima vacacional", liq:resultado.primaVac, fin:resultado.primaVac},
                      {label:"3 meses (al SDI)", liq:resultado.tresMeses, fin:0},
                      {label:`20 días × ${resultado.aniosCompletos} años (al SDI)`, liq:resultado.veinteDiasPorAnio, fin:0},
                      {label:"Prima de antigüedad", liq:resultado.primaAntiguedad, fin:0},
                    ].map((r,i) => (
                      <div key={i} style={{display:"grid", gridTemplateColumns:"1fr 1fr 1fr", padding:"10px 14px", borderBottom:`1px solid ${T_LIGHT.border}`, background:i%2===0?"transparent":T_LIGHT.canvasSoft}}>
                        <div style={{fontSize:12, color:T_LIGHT.textInk}}>{r.label}</div>
                        <div style={{fontSize:12, fontWeight:600, color:T_LIGHT.danger, textAlign:"center" as const}}>{fmt(r.liq)}</div>
                        <div style={{fontSize:12, fontWeight:600, color:r.fin>0?T_LIGHT.success:T_LIGHT.textInkMut, textAlign:"center" as const}}>{r.fin>0?fmt(r.fin):"—"}</div>
                      </div>
                    ))}
                    <div style={{display:"grid", gridTemplateColumns:"1fr 1fr 1fr", padding:"13px 14px", background:T_LIGHT.goldSoft, borderTop:`1px solid ${T_LIGHT.goldBorder}`}}>
                      <div style={{fontSize:13, fontWeight:700, color:T_LIGHT.gold, letterSpacing:"0.5px"}}>TOTAL</div>
                      <div style={{fontSize:14, fontWeight:800, color:T_LIGHT.danger, textAlign:"center" as const}}>{fmt(resultado.liquidacionTotal)}</div>
                      <div style={{fontSize:14, fontWeight:800, color:T_LIGHT.success, textAlign:"center" as const}}>{fmt(resultado.finiquitoBase)}</div>
                    </div>
                    <div style={{padding:"10px 14px", background:T_LIGHT.canvasSoft, borderTop:`1px solid ${T_LIGHT.border}`}}>
                      <div style={{fontSize:11, color:T_LIGHT.textInkSoft, lineHeight:1.6}}>Diferencia: <strong style={{color:T_LIGHT.gold}}>{fmt(resultado.liquidacionTotal - resultado.finiquitoBase)}</strong> a favor del trabajador en caso de despido injustificado</div>
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* Botones PDF recibo */}
            {(tab === "liquidacion" || tab === "finiquito" || tab === "despido_justificado") && (
              <div style={{marginTop:12}}>
                <button onClick={() => generarReciboPDF(resultado, tab, fmt)}
                  style={{width:"100%", background:"linear-gradient(135deg,#1E3A5F,#2D5A8E)", border:"none", borderRadius:12, padding:"13px", cursor:"pointer", fontSize:13, fontWeight:700, color:"white", display:"flex", alignItems:"center", justifyContent:"center", gap:8}}>
                  📄 Descargar Recibo de {tab === "liquidacion" ? "Liquidación" : tab === "despido_justificado" ? "Despido Justificado" : "Finiquito"} PDF
                </button>
                <div style={{fontSize:10, color:"rgba(255,255,255,0.5)", textAlign:"center" as const, marginTop:6}}>
                  Incluye desglose, artículos de la LFT y espacio para firma del trabajador
                </div>
              </div>
            )}

            {/* Advertencia legal */}
            <div style={{marginTop:12, background:T_LIGHT.goldSoft, border:`1px solid ${T_LIGHT.goldBorder}`, borderRadius:10, padding:"14px 16px"}}>
              <div style={{fontSize:11, color:T_LIGHT.gold, fontWeight:700, marginBottom:6, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>Nota importante</div>
              <div style={{fontSize:12, color:T_LIGHT.textInkSoft, lineHeight:1.7}}>
                Este cálculo considera los mínimos establecidos por la LFT. Para una liquidación definitiva con valor legal pleno, se recomienda verificar con un abogado laboral — especialmente si existen cláusulas en contrato colectivo o individual.
              </div>
              <a href="https://wa.me/524494251128?text=Hola%20AXIS%2C%20necesito%20asesoría%20para%20calcular%20una%20liquidación"
                target="_blank" rel="noreferrer"
                style={{display:"inline-flex", alignItems:"center", gap:6, marginTop:12, background:"linear-gradient(135deg,#B8932A,#8B6914)", color:"#0B1829", padding:"9px 18px", borderRadius:8, textDecoration:"none", fontSize:12, fontWeight:700, boxShadow:"0 2px 12px rgba(184,147,42,0.3)"}}>
                Asesoría con AXIS Abogados →
              </a>
            </div>
          </div>
        )}
      </div>
      {/* Footer */}
      <div style={{borderTop:"1px solid rgba(22,36,71,0.08)", padding:"16px 28px", marginTop:8}}>
        <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap" as const, gap:10, maxWidth:ANCHO_CONTENIDO, margin:"0 auto"}}>
          <p style={{fontSize:11, color:"#9A9AAA", margin:0}}>© 2026 AXIS Asesoría Legal Corporativa · Aguascalientes</p>
          <div style={{display:"flex", gap:14, alignItems:"center"}}>
            <LegalBtn label="Aviso Legal" tipo="disclaimer" gold={gold} fontSans={fontSans} fontSerif={fontSerif} />
            <LegalBtn label="Privacidad" tipo="privacidad" gold={gold} fontSans={fontSans} fontSerif={fontSerif} />
          </div>
        </div>
      </div>
    </div>
  );
}


// ─── MARCO LEGAL FLOTILLA ─────────────────────────────────────────────────────
function MarcoLegalFlotilla({gold, fontSerif, fontSans}: {gold:string; fontSerif:string; fontSans:string}) {
  const [openItem, setOpenItem] = useState<number|null>(null);
  const items = [
    {
      titulo:"Responsabilidad patronal en accidentes vehiculares en comisión de servicio",
      icono:"scale_simple",
      contenido:"Conforme al Art. 123, fracción XIV de la Constitución y los Arts. 473 y 474 de la LFT, los patrones son responsables de los accidentes de trabajo sufridos por sus trabajadores en ejercicio o con motivo del trabajo, incluyendo los que ocurren cuando el trabajador se traslada en vehículo de la empresa por encargo del patrón. Si el trabajador está asegurado ante el IMSS (Art. 53 LSS), el Instituto asume las prestaciones en especie y en dinero; si no está asegurado, el patrón responde directamente con indemnizaciones que pueden alcanzar 5,000 días de salario en caso de muerte (Art. 500 LFT). El Art. 475 Bis de la LFT establece que el patrón es responsable de la seguridad e higiene y de la prevención de riesgos en el trabajo.",
      ley:"Art. 123 CPEUM Fracc. XIV · Arts. 473, 474, 475 Bis, 487, 500 LFT · Art. 53 LSS",
    },
    {
      titulo:"Obligación de reportar accidentes — plazo de 72 horas",
      icono:"alert",
      contenido:"Cuando ocurre un accidente de trabajo, el patrón está obligado a reportarlo por escrito o por medios electrónicos a la STPS y al IMSS dentro de las 72 horas siguientes al evento, a través del Sistema de Avisos de Accidentes de Trabajo (SIAAT). No reportar un accidente puede derivar en multas de 50 a 5,000 veces la UMA (aproximadamente $4,300 a $434,000 pesos). El patrón también debe prestar primeros auxilios y garantizar el traslado del trabajador a un centro médico.",
      ley:"Art. 504 LFT · Art. 1002 LFT · Sistema SIAAT-STPS",
    },
    {
      titulo:"Documentos obligatorios del vehículo — responsabilidad del patrón",
      icono:"clipboard",
      contenido:"Todo vehículo que circule en Aguascalientes debe contar con: licencia de conducir vigente, tarjeta de circulación, verificación vehicular vigente y seguro de responsabilidad civil obligatorio. La Ley de Movilidad y Seguridad Vial del Estado de Aguascalientes (última reforma diciembre 2025) y el Reglamento de Movilidad y Seguridad Vial del Municipio de Aguascalientes (2023) establecen las infracciones correspondientes. Cuando el vehículo es propiedad de la empresa, el patrón es corresponsable de mantener la documentación al corriente. Un vehículo sin documentos en accidente puede invalidar la cobertura del seguro.",
      ley:"Ley de Movilidad y Seguridad Vial AGS (reforma 15/12/2025) · Reglamento de Movilidad y Seguridad Vial Municipio de AGS (2023)",
    },
    {
      titulo:"Alcoholemia: cuándo el patrón queda eximido y cuándo no",
      icono:"info",
      contenido:"El Art. 488 de la LFT establece que el patrón queda exceptuado de responsabilidad si el accidente ocurre cuando el trabajador se encuentra en estado de embriaguez o bajo narcóticos, SALVO que exista prescripción médica notificada al patrón. Sin embargo, si la empresa no implementó controles preventivos razonables (como verificar el estado del conductor antes de la salida), puede existir corresponsabilidad civil frente a terceros afectados. Cada registro queda con fecha, hora y quién lo capturó, para que puedas consultarlo y presentarlo si lo necesitas.",
      ley:"Art. 488 Fracc. I LFT · Art. 489 LFT · Código Civil Federal (responsabilidad civil extracontractual)",
    },
    {
      titulo:"La bitácora de flotilla: qué queda registrado",
      icono:"document",
      contenido:"El Art. 784 de la LFT establece que en juicio laboral, la carga de la prueba corresponde al patrón cuando se trata de hechos que sólo él puede conocer. La bitácora registra salidas y regresos con datos del conductor, kilómetros, destino, hora y estado del vehículo. Cada registro queda con fecha, hora y quién lo capturó, para que puedas consultarlo y presentarlo si lo necesitas. AXIS Asesoría Legal Corporativa puede orientarte sobre cómo llevar tu bitácora y representarte en caso de siniestro relacionado con tu flotilla.",
      ley:"Art. 784 LFT · Ley del Seguro Social",
    },
  ];

  return (
    <div style={{marginBottom:10}}>
      <button onClick={() => setOpenItem(openItem !== null ? null : -1)}
        style={{width:"100%", display:"flex", alignItems:"center", gap:10, padding:"12px 16px",
          background:UI.superficie, border:`1px solid ${UI.borde}`, borderTop:`2px solid ${UI.oro}`,
          borderRadius:openItem !== null ? `${UI.rTarjeta}px ${UI.rTarjeta}px 0 0` : UI.rTarjeta, cursor:"pointer", marginBottom:0, boxShadow:UI.sombra}}>
        <AxisIcon name="scale_simple" size={14} color={UI.navy} withBackdrop={false} strokeWidth={2.5}/>
        <div style={{flex:1, textAlign:"left" as const}}>
          <div style={{fontSize:UI.fsRotulo, fontWeight:700, color:UI.navy, textTransform:"uppercase" as const, letterSpacing:"0.8px"}}>Marco legal del patrón</div>
          <div style={{fontSize:UI.fsEtiqueta, color:UI.textoTenue, marginTop:1}}>LFT · Responsabilidad patronal · Ley del Seguro Social</div>
        </div>
        <span style={{fontSize:UI.fsEtiqueta, fontWeight:700, color:UI.navy}}>{openItem !== null ? "Cerrar" : "Abrir"}</span>
      </button>

      {openItem !== null && (
        <div style={{border:`1px solid ${UI.borde}`, borderTop:"none", borderRadius:`0 0 ${UI.rTarjeta}px ${UI.rTarjeta}px`, background:UI.superficie, padding:"8px 12px 12px"}}>
          <p style={{fontSize:UI.fsEtiqueta, color:UI.textoTenue, margin:"8px 0 10px 4px", fontStyle:"italic"}}>
            Información legal relevante para empresas con flotilla vehicular en Aguascalientes.
          </p>
          {items.map((item, i) => (
            <div key={i} style={{marginBottom:6}}>
              <button onClick={() => setOpenItem(openItem === i ? -1 : i)}
                style={{width:"100%", display:"flex", alignItems:"center", gap:10, padding:"11px 14px",
                  background:openItem===i?UI.hover:UI.superficie,
                  border:`1px solid ${openItem===i?UI.navy+"40":UI.divisor}`,
                  borderRadius:10, cursor:"pointer"}}>
                <AxisIcon name={item.icono} size={15} color={openItem===i?UI.navy:UI.textoTenue} withBackdrop={false} strokeWidth={2.4}/>
                <span style={{flex:1, textAlign:"left" as const, fontSize:UI.fsCuerpo, fontWeight:600, color:openItem===i?UI.navy:UI.texto}}>
                  {item.titulo}
                </span>
                <span style={{fontSize:12, color:UI.textoTenue}}>{openItem===i?"▲":"▼"}</span>
              </button>
              {openItem === i && (
                <div style={{background:UI.hover, border:`1px solid ${UI.divisor}`, borderTop:"none", borderRadius:"0 0 10px 10px", padding:"12px 14px"}}>
                  <p style={{fontSize:UI.fsCuerpo, color:UI.textoSuave, lineHeight:1.8, margin:"0 0 10px"}}>{item.contenido}</p>
                  <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", flexWrap:"wrap" as const, gap:8}}>
                    <span style={{fontSize:UI.fsRotulo, color:UI.textoTenue, fontStyle:"italic"}}>{item.ley}</span>
                    <a href="https://wa.me/524494251128?text=Hola%20AXIS%2C%20tengo%20una%20duda%20sobre%20flotilla%20vehicular"
                      target="_blank" rel="noreferrer"
                      style={{fontSize:UI.fsEtiqueta, fontWeight:700, color:UI.navy, textDecoration:"none", background:UI.hover, border:`1px solid ${UI.borde}`, padding:"4px 12px", borderRadius:8, border:`1px solid rgba(184,147,42,0.3)`}}>
                      Consulta gratuita con AXIS →
                    </a>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ─── INFO LEGAL PARA CONDUCTORES ─────────────────────────────────────────────
function InfoLegalConductor({gold, fontSerif, fontSans}: {gold:string; fontSerif:string; fontSans:string}) {
  const [open, setOpen] = useState(false);
  const [openItem, setOpenItem] = useState<number|null>(null);

  const items = [
    {
      icono:"🪪",
      titulo:"Documentos que debes portar al conducir",
      contenido:"Como conductor estás obligado a portar en original y vigentes: licencia de conducir y tarjeta de circulación del vehículo. El Reglamento de Movilidad y Seguridad Vial del Municipio de Aguascalientes (2023) establece que debes mostrarlos al agente de tránsito o autoridad competente cuando te los soliciten. En caso de accidente o infracción, la falta de cualquiera de estos documentos agrava tu situación legal y puede invalidar la cobertura del seguro. Conducir sin licencia vigente es una infracción grave.",
      ley:"Reglamento de Movilidad y Seguridad Vial del Municipio de AGS (2023) · Ley de Movilidad y Seguridad Vial del Estado de AGS (15/12/2025)",
    },
    {
      icono:"🚦",
      titulo:"Velocidades máximas en Aguascalientes",
      contenido:"La Ley de Movilidad y Seguridad Vial del Estado de Aguascalientes (publicada el 15 de diciembre de 2025) y el Reglamento de Movilidad y Seguridad Vial del Municipio de Aguascalientes (2023) establecen las Zonas 30 como áreas al interior de colonias y fraccionamientos donde la velocidad máxima es de 30 km/h. El Reglamento Municipal homologa los límites de velocidad conforme a la Ley General de Movilidad y Seguridad Vial. El exceso de velocidad puede ser infracción grave con multa de 10 a 15 UMA ($1,173 a $1,759 pesos con UMA 2026 de $117.31). Velocidades excesivas en zonas escolares o habitacionales se sancionan con mayor severidad.",
      ley:"Ley de Movilidad y Seguridad Vial del Estado de AGS (15/12/2025) · Reglamento de Movilidad y Seguridad Vial Municipio AGS (2023) · UMA 2025: $113.14",
    },
    {
      icono:"📱",
      titulo:"Uso del celular y distracciones al conducir",
      contenido:"El Reglamento de Movilidad y Seguridad Vial del Municipio de Aguascalientes (2023) prohíbe a los conductores realizar acciones que distraigan su atención de la conducción, incluyendo el uso del teléfono celular con las manos. Las infracciones se clasifican por gravedad: leves ($117-$587), medias ($703-$1,173), graves ($1,173-$1,759) y muy graves ($1,876-$2,346) según UMA 2026 ($117.31). Si ocurre un accidente mientras usas el celular, tu responsabilidad civil y penal se agrava significativamente. Solo se permite el uso de dispositivos de manos libres.",
      ley:"Reglamento de Movilidad y Seguridad Vial del Municipio de AGS (2023) · Ley de Movilidad y Seguridad Vial del Estado de AGS (15/12/2025) · UMA 2025: $113.14",
    },
    {
      icono:"🍺",
      titulo:"Alcoholemia — consecuencias para el conductor",
      contenido:"Conducir bajo el influjo del alcohol está prohibido y es una infracción muy grave conforme al Reglamento de Movilidad y Seguridad Vial del Municipio de Aguascalientes (2023). Si causas un accidente en estado de ebriedad, el seguro del vehículo puede negarse a cubrir los daños a terceros. Adicionalmente puedes enfrentar arresto, suspensión de licencia y responsabilidad penal por lesiones culposas o, en casos graves, homicidio culposo conforme al Código Penal del Estado de Aguascalientes. El empleador NO responde por los daños que causes en estado de ebriedad — la responsabilidad recae directamente sobre ti (Art. 488 LFT).",
      ley:"Reglamento de Movilidad y Seguridad Vial del Municipio de AGS (2023) · Código Penal del Estado de AGS · Art. 488 LFT",
    },
    {
      icono:"🚨",
      titulo:"Qué hacer en caso de accidente",
      contenido:"Conforme al Reglamento de Movilidad y Seguridad Vial del Municipio de Aguascalientes (2023): 1) No abandones el lugar — darte a la fuga es delito. 2) Llama al 911 de inmediato. 3) No muevas los vehículos hasta que llegue la autoridad, salvo que obstruyan completamente el tráfico. 4) Intercambia con el otro conductor: nombre completo, placa, aseguradora y número de póliza. 5) Avisa a tu empleador inmediatamente — tiene 72 horas para reportarlo ante el IMSS y la STPS a través del Sistema SIAAT. 6) Si te lesionas en comisión de servicio, tienes derecho a atención médica como riesgo de trabajo conforme al Art. 474 de la LFT.",
      ley:"Reglamento de Movilidad y Seguridad Vial del Municipio de AGS (2023) · Art. 474 LFT · Sistema SIAAT-STPS",
    },
  ];

  return (
    <div style={{marginTop:24}}>
      <button onClick={() => setOpen(!open)}
        style={{width:"100%", display:"flex", alignItems:"center", gap:10, padding:"13px 16px",
          background:open?"#1E293B":"#0F172A",
          border:`1px solid rgba(184,147,42,0.25)`,
          borderRadius:open?"12px 12px 0 0":12, cursor:"pointer"}}>
        <AxisIcon name="clipboard" size={16} tone="gold" withBackdrop={false} strokeWidth={3}/>
        <div style={{flex:1, textAlign:"left" as const}}>
          <div style={{fontSize:12, fontWeight:700, color:gold, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>
            Lo que debes saber como conductor
          </div>
          <div style={{fontSize:11, color:"rgba(255,255,255,0.4)", marginTop:1}}>
            Ley de Movilidad AGS · Tus derechos y obligaciones
          </div>
        </div>
        <span style={{fontSize:12, color:gold}}>{open?"▲ Cerrar":"▼ Ver información"}</span>
      </button>

      {open && (
        <div style={{border:"1px solid rgba(184,147,42,0.2)", borderTop:"none", borderRadius:"0 0 12px 12px", background:"#1B2B4B", padding:"8px 12px 12px"}}>
          <p style={{fontSize:11, color:"rgba(255,255,255,0.4)", margin:"8px 0 10px 4px", fontStyle:"italic"}}>
            Información relevante para conductores de vehículos de empresa en Aguascalientes.
          </p>
          {items.map((item, i) => (
            <div key={i} style={{marginBottom:6}}>
              <button onClick={() => setOpenItem(openItem===i?null:i)}
                style={{width:"100%", display:"flex", alignItems:"center", gap:10, padding:"11px 14px",
                  background:openItem===i?"rgba(184,147,42,0.1)":"rgba(255,255,255,0.04)",
                  border:`1px solid ${openItem===i?"rgba(184,147,42,0.3)":"rgba(255,255,255,0.08)"}`,
                  borderRadius:10, cursor:"pointer"}}>
                <span style={{fontSize:18, flexShrink:0}}>{item.icono}</span>
                <span style={{flex:1, textAlign:"left" as const, fontSize:12, fontWeight:600, color:openItem===i?gold:"rgba(255,255,255,0.8)"}}>
                  {item.titulo}
                </span>
                <span style={{fontSize:12, color:gold}}>{openItem===i?"▲":"▼"}</span>
              </button>
              {openItem===i && (
                <div style={{background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.07)", borderTop:"none", borderRadius:"0 0 10px 10px", padding:"12px 14px"}}>
                  <p style={{fontSize:12, color:"rgba(255,255,255,0.7)", lineHeight:1.8, margin:"0 0 10px"}}>{item.contenido}</p>
                  <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", flexWrap:"wrap" as const, gap:8}}>
                    <span style={{fontSize:10, color:"rgba(184,147,42,0.6)", fontStyle:"italic"}}>{item.ley}</span>
                    <a href="https://wa.me/524494251128?text=Hola%20AXIS%2C%20tengo%20una%20duda%20como%20conductor%20de%20empresa"
                      target="_blank" rel="noreferrer"
                      style={{fontSize:11, fontWeight:700, color:gold, textDecoration:"none", background:"rgba(184,147,42,0.1)", padding:"4px 12px", borderRadius:8, border:`1px solid rgba(184,147,42,0.3)`}}>
                      Asesoría gratuita con AXIS →
                    </a>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}



// ─── MODAL CORREO NÓMINA ─────────────────────────────────────────────────────
function ModalCorreoNomina({tab, onConfirmar, onClose, gold, fontSans, fontSerif, currentUser}: {
  tab:string; onConfirmar:(correo:string)=>void; onClose:()=>void;
  gold:string; fontSans:string; fontSerif:string; currentUser:any;
}) {
  const [correo, setCorreo] = useState(currentUser?.email || "");
  const [guardando, setGuardando] = useState(false);
  const labels:Record<string,string> = {liquidacion:"Liquidación",finiquito:"Finiquito",aguinaldo:"Aguinaldo",vacaciones:"Vacaciones"};
  const iconNames:Record<string,string> = {liquidacion:"scale_simple",finiquito:"clipboard",aguinaldo:"money",vacaciones:"suite_calendario"};

  const confirmar = async () => {
    if (!correo.includes("@")) return;
    setGuardando(true);
    await onConfirmar(correo);
    setGuardando(false);
  };

  return (
    <div style={{position:"fixed" as const, inset:0, background:"rgba(0,0,0,0.55)", zIndex:500, display:"flex", alignItems:"center", justifyContent:"center", padding:20, backdropFilter:"blur(4px)"}}>
      <div {...PANEL_DE_CAPTURA} onClick={e=>e.stopPropagation()} style={{background:"white", borderRadius:20, padding:"36px 40px", maxWidth:400, width:"100%", boxShadow:"0 20px 60px rgba(0,0,0,0.15)"}}>
        <div style={{textAlign:"center" as const, marginBottom:24}}>
          <div style={{marginBottom:12, display:"flex", justifyContent:"center"}}>
            <div style={{width:56, height:56, borderRadius:14, background:"rgba(184,147,42,0.10)", border:"1px solid rgba(184,147,42,0.25)", display:"flex", alignItems:"center", justifyContent:"center"}}>
              <AxisIcon name={iconNames[tab]||"briefcase"} size={28} tone="gold" withBackdrop={false} strokeWidth={2.5}/>
            </div>
          </div>
          <h3 style={{fontFamily:fontSerif, fontSize:20, color:"#0B1829", margin:"0 0 8px"}}>Calculadora de {labels[tab]||tab}</h3>
          <p style={{fontSize:13, color:"#4A4A60", margin:0, lineHeight:1.6}}>Ingresa tu correo para ver el resultado.<br/><strong style={{color:"#7C3AED"}}>Cálculo inmediato y gratuito.</strong></p>
        </div>
        <div style={{marginBottom:16}}>
          <label style={{fontSize:10, color:"#9A9AAA", display:"block", marginBottom:6, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>Correo electrónico</label>
          <input value={correo} onChange={e=>setCorreo(e.target.value)} type="email" placeholder="correo@empresa.mx"
            autoFocus onKeyDown={e=>e.key==="Enter"&&confirmar()}
            style={{width:"100%", padding:"12px 14px", border:"1px solid rgba(0,0,0,0.15)", borderRadius:10, fontSize:14, outline:"none", boxSizing:"border-box" as const, background:"#F7F5F0"}} />
        </div>
        <div style={{fontSize:11, color:"#9A9AAA", marginBottom:20, lineHeight:1.6}}>
          🔒 Confidencial. No recibirás spam.
        </div>
        <button onClick={confirmar} disabled={!correo.includes("@")||guardando}
          style={{width:"100%", background:correo.includes("@")?"linear-gradient(135deg,#7C3AED,#6D28D9)":"rgba(0,0,0,0.08)", border:"none", borderRadius:12, padding:"14px", cursor:correo.includes("@")?"pointer":"not-allowed", fontSize:14, fontWeight:700, color:correo.includes("@")?"white":"#9A9AAA", boxShadow:correo.includes("@")?"0 4px 16px rgba(124,58,237,0.3)":"none"}}>
          {guardando?"Calculando...":"📊 Ver resultado"}
        </button>
        <button onClick={(ev)=>{ if (sePuedeCerrarElPanel(ev)) onClose(); }} style={{width:"100%", marginTop:8, background:"transparent", border:"none", color:"#9A9AAA", cursor:"pointer", fontSize:12, padding:"8px"}}>Cancelar</button>
      </div>
    </div>
  );
}

// #region MÓDULO CONTRATOS
// ─── MÓDULO CONTRATOS ─────────────────────────────────────────────────────────
// #region INDIVIDUAL TRABAJO
// ─── CONTRATO INDIVIDUAL DE TRABAJO ─────────────────────────────────────────
// `user` y `tipoContrato` SIEMPRE llegaron desde el selector; lo que faltaba era
// desempacarlos aquí. Sin ellos, el panel "Guardar y vincular a…" tumbaba la
// pantalla al pintarse, justo después de que el PDF se descargaba bien.
function FormContratoTrabajo({user, tipoContrato, onBack, fontSans, fontSerif, gold}:{user:any;tipoContrato:string;onBack:()=>void;fontSans:string;fontSerif:string;gold:string}) {
  // El pie de este documento lo firma el patrón, no la plataforma.
  const datosPatron = useDatosPatron(user?.uid).datos;
  const isMobile = window.innerWidth < 768;
  const [modalidad, setModalidad] = useState<"indeterminado"|"determinado"|"obra">("indeterminado");
  // Una sola fuente para el nombre del archivo: la descarga y lo que se archiva
  // en el expediente tienen que llamarse igual, o el patrón cree que son dos
  // documentos distintos. Sin acentos a propósito: al subir a Storage cada
  // acento se convertiría en guion bajo.
  const vModalidadArchivo = modalidad === "indeterminado" ? "por tiempo indeterminado"
    : modalidad === "determinado" ? "por tiempo determinado"
    : "por obra o tiempo determinado";
  const [generando, setGenerando] = useState(false);
  const [ultimoBlob, setUltimoBlob] = useState<Blob|null>(null);
  const [seccion, setSeccion] = useState("trabajador");
  const [form, setForm] = useState({
    nombreTrabajador:"", rfcTrabajador:"", domicilioTrabajador:"", nacionalidad:"Mexicana",
    razonSocial:"", rfcPatron:"", domicilioPatron:"", repLegal:"",
    puesto:"", descripcionActividades:"", departamento:"",
    lugarTrabajo:"Aguascalientes, Aguascalientes",
    fechaInicio:"", fechaTermino:"", obraDescripcion:"",
    tipoJornada:"diurna", horaEntrada:"08:00", horaSalida:"17:00", diasTrabajo:"Lunes a Viernes",
    salarioDiario:"", formaPago:"semanal",
    diasVacaciones:"12", primaVacacional:"25", aguinaldo:"15",
    beneficios:"", clausulaConfidencialidad:true, fechaContrato:"",
    testigo1:"", testigo2:"",
  });

  // PRELLENADO desde configuracion_empresa, y EDITABLE. Contrato individual de trabajo.
  // Un contrato lo puede celebrar otra razon social del grupo o firmarlo un
  // representante con otro domicilio, y eso no es un error del usuario: se
  // propone, no se impone. Solo rellena lo que este VACIO, asi que nunca pisa
  // lo que ya escribio quien lo esta redactando.
  useEffect(()=>{ let cancel=false; (async()=>{
    if (!user?.uid) return;
    try {
      const dpc = datosPatronDe(await leerConfigEmpresa(user.uid));
      if (cancel) return;
      const dom = domicilioPatronTexto(dpc);
      setForm((f:any)=>({...f,
        razonSocial:     f.razonSocial     || dpc.denominacion,
        rfcPatron:       f.rfcPatron       || dpc.rfc,
        domicilioPatron: f.domicilioPatron || dom,
      }));
    } catch(e){ /* sin datos capturados: el formulario se queda igual */ }
  })(); return ()=>{cancel=true;}; /* eslint-disable-next-line */ }, [user?.uid]);
  const f = (k:string, v:string|boolean) => setForm(p => ({...p,[k]:v}));
  // La fecha va en ISO para que la carpeta ordene cronológicamente sola. Si el
  // contrato aún no tiene fecha de inicio se OMITE: más vale un nombre sin
  // fecha que un nombre con una fecha que nadie firmó.
  // VA DESPUÉS DE `form`: leerlo antes de su declaración es un ReferenceError en
  // cada render, y el build con Babel no lo ve porque no comprueba tipos.
  const vFechaArchivo = /^\d{4}-\d{2}-\d{2}$/.test(form.fechaInicio||"") ? form.fechaInicio : "";
  const vNombreArchivo = `Contrato individual de trabajo ${vModalidadArchivo}`
    + ` - ${form.nombreTrabajador || "borrador"}`
    + (vFechaArchivo ? ` - ${vFechaArchivo}` : "");
  const INPUT: React.CSSProperties = {
    width:"100%", padding:"9px 11px", fontSize:13, fontFamily:fontSans,
    background:"white", border:"1px solid #D1D5DB", borderRadius:8, color:"#0F172A",
    boxSizing:"border-box" as const, outline:"none",
  };
  const LABEL: React.CSSProperties = {
    display:"block", fontSize:11, fontWeight:600, color:"#374151", marginBottom:4,
    letterSpacing:"0.2px",
  };
  const secciones = [
    {key:"trabajador",titulo:"Trabajador",iconName:"user_single"},
    {key:"patron",titulo:"Patrón",iconName:"building"},
    {key:"relacion",titulo:"Relación",iconName:"clipboard"},
    {key:"jornada",titulo:"Jornada",iconName:"refresh"},
    {key:"salario",titulo:"Salario",iconName:"money"},
    {key:"extras",titulo:"Firma",iconName:"document"},
  ];
  const idx = secciones.findIndex(s=>s.key===seccion);
  const next = () => idx < secciones.length-1 && setSeccion(secciones[idx+1].key);
  const prev = () => idx > 0 && setSeccion(secciones[idx-1].key);
  const generarPDF = async () => {
    setGenerando(true);
    // `new Date("2026-09-01")` es medianoche UTC y en México eso es el 31 de
    // agosto: el contrato imprimía el día ANTERIOR al que se capturó, y eso
    // mueve antigüedad, aguinaldo proporcional y periodo de prueba. Mismo
    // defecto que corregimos en el expediente de vehículos. `fechaLargaAxis`
    // parte la cadena en vez de construir un Date.
    const hoy = fechaLargaAxis(form.fechaContrato) || fechaLargaAxis(new Date());

    const vTrabajador = form.nombreTrabajador || "___________________________";
    const vRfcTrab = form.rfcTrabajador || "___________________________";
    const vDomTrab = form.domicilioTrabajador || "___________________________";
    const vNacionalidad = form.nacionalidad || "Mexicana";
    const vPatron = form.razonSocial || "___________________________";
    const vRfcPatron = form.rfcPatron || "___________________________";
    const vDomPatron = form.domicilioPatron || "___________________________";
    const vRepLegal = form.repLegal || "___________________________";
    const vPuesto = form.puesto || "___________________________";
    const vActividades = form.descripcionActividades || "Las inherentes al puesto y aquellas que le indique su superior jerárquico";
    const vDepto = form.departamento || "";
    const vLugar = form.lugarTrabajo || "Aguascalientes, Aguascalientes";
    const vFechaInicio = fechaLargaAxis(form.fechaInicio) || "___________________________";
    const vFechaTermino = fechaLargaAxis(form.fechaTermino);
    const vObra = form.obraDescripcion || "";
    const vJornadaTipo = form.tipoJornada === "nocturna" ? "nocturna" : form.tipoJornada === "mixta" ? "mixta" : "diurna";
    const vHoraEnt = form.horaEntrada || "08:00";
    const vHoraSal = form.horaSalida || "17:00";
    const vDias = form.diasTrabajo || "Lunes a Viernes";
    const vSalDiario = form.salarioDiario || "___________________________";
    const vFormaPago = form.formaPago === "quincenal" ? "quincenal" : form.formaPago === "mensual" ? "mensual" : "semanal";
    const vDiasVac = form.diasVacaciones || "12";
    const vPrimaVac = form.primaVacacional || "25";
    const vAguinaldo = form.aguinaldo || "15";
    const vBeneficios = form.beneficios || "";
    const vTestigo1 = form.testigo1 || "___________________________";
    const vTestigo2 = form.testigo2 || "___________________________";
    const vFechaGen = new Date().toLocaleDateString("es-MX");

    const vModalidadTitulo = modalidad === "indeterminado" ? "POR TIEMPO INDETERMINADO" :
                              modalidad === "determinado" ? "POR TIEMPO DETERMINADO" :
                              "POR OBRA O TIEMPO DETERMINADO";

    const vClausulaModalidad = modalidad === "indeterminado"
      ? `La presente relación laboral es por <strong>tiempo indeterminado</strong>, conforme al artículo 35 de la Ley Federal del Trabajo. EL TRABAJADOR prestará sus servicios a partir del día <strong>${vFechaInicio}</strong>.`
      : modalidad === "determinado"
      ? `La presente relación laboral es por <strong>tiempo determinado</strong>, del <strong>${vFechaInicio}</strong> al <strong>${vFechaTermino}</strong>, conforme a los artículos 37 y 39 de la Ley Federal del Trabajo, en virtud de la naturaleza temporal de los servicios requeridos.`
      : `La presente relación laboral es por <strong>obra o tiempo determinado</strong>, conforme al artículo 36 de la Ley Federal del Trabajo, para la realización de la siguiente obra: <strong>${vObra}</strong>. La relación concluirá al término de dicha obra.`;

    const vClausulaConf = form.clausulaConfidencialidad ? `
      <div class="clausula">
        <span class="clausula-titulo">SEXTA.- CONFIDENCIALIDAD:</span> EL TRABAJADOR se obliga a guardar absoluta confidencialidad respecto de toda información, datos, procesos, metodologías, listas de clientes, planes comerciales y demás secretos industriales o comerciales de EL PATRÓN a los que tenga acceso con motivo de su empleo. Esta obligación subsistirá durante la vigencia del contrato y por un período de DOS (2) años posteriores a su terminación, bajo apercibimiento de la responsabilidad civil correspondiente.
      </div>` : "";

    const vBeneficiosClausula = vBeneficios ? `
      <div class="clausula">
        <span class="clausula-titulo">PRESTACIONES ADICIONALES:</span> Además de las prestaciones de Ley, EL PATRÓN otorgará al TRABAJADOR las siguientes prestaciones: <strong>${vBeneficios}</strong>.
      </div>` : "";

    const html = `<!DOCTYPE html>
<html lang="es">
<head><meta charset="UTF-8"><title>Contrato Individual de Trabajo</title>
<style>
  * { box-sizing:border-box; margin:0; padding:0; }
  body { font-family:'Times New Roman', serif; color:#1A1A2E; padding:55px 65px; font-size:12.5px; line-height:1.85; background:white; text-align:justify; }
  .encabezado { font-size:13px; font-weight:bold; text-align:center; text-transform:uppercase; margin-bottom:28px; line-height:1.6; }
  .seccion-titulo { font-weight:bold; text-transform:uppercase; text-align:center; font-size:13px; margin:24px 0 12px; letter-spacing:0.5px; }
  .declaracion-titulo { font-weight:bold; text-transform:uppercase; font-size:12.5px; margin:16px 0 8px; }
  .clausula { margin-bottom:18px; }
  .clausula-titulo { font-weight:bold; text-transform:uppercase; font-size:12.5px; display:inline; }
  .firmas { margin-top:60px; display:grid; grid-template-columns:1fr 1fr; gap:60px; }
  .firma-bloque { text-align:center; }
  .firma-linea { border-top:1px solid #1A1A2E; margin-bottom:8px; }
  .testigos { margin-top:40px; display:grid; grid-template-columns:1fr 1fr; gap:60px; }
  .header-axis { display:flex; justify-content:space-between; align-items:center; margin-bottom:36px; padding-bottom:14px; border-bottom:2px solid #B8932A; }
  .footer { text-align:center; margin-top:36px; padding-top:14px; border-top:1px solid #ddd; font-size:10px; color:#9A9AAA; font-family:Arial,sans-serif; }
  @media print { body { padding:40px 50px; } }
</style>
</head>
<body>
  <div class="encabezado">
    CONTRATO INDIVIDUAL DE TRABAJO ${vModalidadTitulo} QUE CELEBRAN, POR UNA PARTE,
    ${vPatron.toUpperCase()}, A QUIEN EN LO SUCESIVO SE DENOMINARÁ COMO "EL PATRÓN", Y POR OTRA PARTE,
    ${vTrabajador.toUpperCase()}, A QUIEN EN LO SUCESIVO SE DENOMINARÁ COMO "EL TRABAJADOR",
    AL TENOR DE LAS SIGUIENTES DECLARACIONES Y CLÁUSULAS:
  </div>

  <div class="seccion-titulo">DECLARACIONES</div>

  <div class="declaracion-titulo">DECLARA EL PATRÓN:</div>
  <p><strong>1.-</strong> Llamarse como ha quedado escrito, con RFC <strong>${vRfcPatron}</strong>, con domicilio fiscal en <strong>${vDomPatron}</strong>, representado en este acto por <strong>${vRepLegal}</strong>, quien acredita su personalidad con instrumento notarial.</p>
  <br/>
  <p><strong>2.-</strong> Que requiere contratar los servicios personales subordinados de EL TRABAJADOR para el desempeño del puesto de <strong>${vPuesto}</strong>${vDepto ? ", adscrito al área de <strong>" + vDepto + "</strong>" : ""}, y contar con la capacidad económica para cumplir con todas las obligaciones laborales derivadas del presente contrato.</p>

  <div class="declaracion-titulo" style="margin-top:16px;">DECLARA EL TRABAJADOR:</div>
  <p><strong>3.-</strong> Llamarse como ha quedado escrito, ser de nacionalidad <strong>${vNacionalidad}</strong>, con RFC <strong>${vRfcTrab}</strong>, con domicilio en <strong>${vDomTrab}</strong>, mayor de edad y con plena capacidad legal para celebrar el presente contrato.</p>
  <br/>
  <p><strong>4.-</strong> Contar con los conocimientos, experiencia, aptitudes y disponibilidad necesarios para desempeñar el puesto ofrecido, comprometiéndose a prestar sus servicios con diligencia, lealtad y subordinación conforme al artículo 134 de la Ley Federal del Trabajo.</p>

  <div class="declaracion-titulo" style="margin-top:16px;">AMBAS PARTES DECLARAN:</div>
  <p><strong>5.-</strong> Reconocer la personalidad con la que se ostentan, manifestar que en la celebración del presente contrato no existe error, dolo, violencia, mala fe o cualquier otro vicio del consentimiento, y haberlo celebrado en la ciudad de <strong>${vLugar}</strong>, el día <strong>${hoy}</strong>.</p>

  <div class="seccion-titulo" style="margin-top:24px;">CLÁUSULAS</div>

  <div class="clausula">
    <span class="clausula-titulo">PRIMERA.- OBJETO Y MODALIDAD:</span> EL PATRÓN contrata a EL TRABAJADOR para que preste sus servicios personales subordinados en el puesto de <strong>${vPuesto}</strong>, realizando las siguientes actividades: <strong>${vActividades}</strong>. ${vClausulaModalidad}
  </div>

  <div class="clausula">
    <span class="clausula-titulo">SEGUNDA.- LUGAR Y JORNADA DE TRABAJO:</span> EL TRABAJADOR prestará sus servicios en <strong>${vLugar}</strong>. La jornada de trabajo será <strong>${vJornadaTipo}</strong>, de <strong>${vHoraEnt}</strong> a <strong>${vHoraSal}</strong> horas, de <strong>${vDias}</strong>, con una hora de descanso intermedio para tomar alimentos, conforme a los artículos 58 a 68 de la Ley Federal del Trabajo. EL TRABAJADOR disfrutará de un día de descanso a la semana con goce de salario íntegro (Art. 69 LFT).
  </div>

  <div class="clausula">
    <span class="clausula-titulo">TERCERA.- SALARIO:</span> EL PATRÓN pagará a EL TRABAJADOR un salario diario integrado de <strong>$${vSalDiario} pesos M.N.</strong>, mismo que se cubrirá de forma <strong>${vFormaPago}</strong>, en el lugar de trabajo y en horario laboral, mediante depósito o transferencia bancaria. El salario incluye las partes proporcionales correspondientes y se realizarán únicamente las retenciones de Ley (ISR e IMSS), conforme a los artículos 82 a 89 y 110 de la Ley Federal del Trabajo.
  </div>

  <div class="clausula">
    <span class="clausula-titulo">CUARTA.- PRESTACIONES DE LEY:</span> EL TRABAJADOR tendrá derecho a las siguientes prestaciones mínimas de Ley: <strong>I)</strong> Vacaciones anuales de <strong>${vDiasVac} días</strong> laborables (Art. 76 LFT). <strong>II)</strong> Prima vacacional del <strong>${vPrimaVac}%</strong> sobre el salario correspondiente a las vacaciones (Art. 80 LFT). <strong>III)</strong> Aguinaldo anual equivalente a <strong>${vAguinaldo} días</strong> de salario, pagadero antes del 20 de diciembre de cada año (Art. 87 LFT). <strong>IV)</strong> Inscripción al IMSS, INFONAVIT, SAR y demás obligaciones de seguridad social. <strong>V)</strong> Participación en las utilidades de la empresa (PTU) conforme a la Ley.
  </div>

  <div class="clausula">
    <span class="clausula-titulo">QUINTA.- CAPACITACIÓN Y ADIESTRAMIENTO:</span> EL PATRÓN proporcionará a EL TRABAJADOR la capacitación y adiestramiento necesarios conforme al Capítulo III Bis del Título Cuarto de la Ley Federal del Trabajo. EL TRABAJADOR se obliga a recibirla, prestar atención durante su impartición y aprobar las evaluaciones correspondientes.
  </div>

  ${vBeneficiosClausula}
  ${vClausulaConf}

  <div class="clausula">
    <span class="clausula-titulo">${form.clausulaConfidencialidad ? "SÉPTIMA" : "SEXTA"}.- CAUSAS DE RESCISIÓN Y TERMINACIÓN:</span> Serán causas de rescisión sin responsabilidad para EL PATRÓN las previstas en el artículo 47 de la Ley Federal del Trabajo, y de terminación las del artículo 53. Cualquier rescisión deberá notificarse por escrito al TRABAJADOR explicando las causas, de conformidad con el procedimiento previsto en la Ley.
  </div>

  <div class="clausula">
    <span class="clausula-titulo">${form.clausulaConfidencialidad ? "OCTAVA" : "SÉPTIMA"}.- JURISDICCIÓN Y COMPETENCIA:</span> Para todo lo relacionado con la interpretación y cumplimiento del presente contrato, las partes se someten expresamente a la jurisdicción de los Tribunales Laborales Federales con sede en el Estado de Aguascalientes, en términos de la reforma constitucional al artículo 123 de febrero de 2017 y la reforma a la Ley Federal del Trabajo de mayo de 2019, renunciando al fuero que pudiera corresponderles por razón de sus domicilios presentes o futuros.
  </div>

  <div style="margin-top:20px;padding:14px 16px;background:#FFF8F0;border:1px solid #F0D080;border-radius:8px;font-size:11px;font-family:Arial,sans-serif;color:#6B5A3A;">
    <strong>Fundamento legal:</strong> Arts. 20, 21, 24 a 28, 35 a 39, 47, 53, 58 a 68, 69, 76, 80, 82 a 89, 110, 132, 134 y 153-A a 153-X de la Ley Federal del Trabajo · Constitución Política de los Estados Unidos Mexicanos, Art. 123
  </div>

  <div class="firmas">
    <div class="firma-bloque">
      <div style="height:70px;"></div>
      <div class="firma-linea"></div>
      <strong>EL PATRÓN</strong><br/>
      ${vPatron}<br/>
      <span style="font-size:11px;color:#555;">Representado por: ${vRepLegal}</span><br/>
      <span style="font-size:11px;color:#555;">RFC: ${vRfcPatron}</span>
    </div>
    <div class="firma-bloque">
      <div style="height:70px;"></div>
      <div class="firma-linea"></div>
      <strong>EL TRABAJADOR</strong><br/>
      ${vTrabajador}<br/>
      <span style="font-size:11px;color:#555;">RFC: ${vRfcTrab}</span>
    </div>
  </div>

  <div class="testigos" style="margin-top:50px;">
    <div class="firma-bloque">
      <div style="height:60px;"></div>
      <div class="firma-linea"></div>
      <span style="font-size:11px;color:#555;">TESTIGO 1<br/>${vTestigo1}</span>
    </div>
    <div class="firma-bloque">
      <div style="height:60px;"></div>
      <div class="firma-linea"></div>
      <span style="font-size:11px;color:#555;">TESTIGO 2<br/>${vTestigo2}</span>
    </div>
  </div>

</body>
</html>`;

    // El helper renderiza el HTML a un PDF real (jsPDF + html2canvas),
    // descarga el archivo y devuelve el blob. setUltimoBlob activa el panel
    // "Guardar y vincular a…" debajo del botón.
    try {
      // El nombre de la DESCARGA se alinea con el que se archiva en el
      // expediente: el mismo título legal, con la modalidad, más de quién es.
      // Antes decía "Contrato_Trabajo_<nombre>", que no distinguía dos
      // contratos distintos de la misma persona.
      const fname = `${vNombreArchivo}.pdf`;
      const pdfBlob = await generarPDFDesdeHTML(html, fname, {pieContrato:true, pieTexto: pieDelPatron(datosPatron, fechaHoraLargaAxis())});
      setUltimoBlob(pdfBlob);
    } catch(e){ console.error(e); alert("No se pudo generar el PDF. Intenta de nuevo."); }
    finally { setGenerando(false); }
  };

  return (
    <div {...ZONA_DE_CAPTURA} style={{minHeight:"100vh", background:T_LIGHT.canvas, fontFamily:fontSans}}>
      {/* Header */}
      <div style={{background:"linear-gradient(135deg,#2563EB,#1E40AF)", padding:"0 20px", height:58,
        display:"flex", alignItems:"center", gap:12, position:"sticky" as const, top:0, zIndex:100,
        boxShadow:"0 4px 20px rgba(37,99,235,0.30)"}}>
        <button onClick={onBack}
          style={{background:"rgba(255,255,255,0.18)", border:"1px solid rgba(255,255,255,0.30)",
            color:"white", borderRadius:8, padding:"5px 11px", cursor:"pointer",
            fontSize:12, fontWeight:600}}>← Modalidad</button>
        <span style={{color:"white", fontWeight:700, fontSize:isMobile?12:14, display:"flex",
          alignItems:"center", gap:8}}>
          <AxisIcon name="user_single" size={18} tone="white" withBackdrop={false} strokeWidth={2.5}/>
          Contrato Individual de Trabajo
        </span>
      </div>

      <div style={{maxWidth:760, margin:"0 auto", padding:isMobile?"16px":"20px 24px"}}>
        {/* Modalidad selector (Indeterminado / Determinado / Obra) */}
        <div style={{marginBottom:16}}>
          <div style={{fontSize:11, fontWeight:600, color:"#64748B", marginBottom:8, letterSpacing:"0.5px",
            textTransform:"uppercase" as const}}>Modalidad del contrato</div>
          <div style={{display:"flex", gap:8, flexWrap:"wrap" as const}}>
            {([["indeterminado","Tiempo Indeterminado","Art. 35 LFT"],["determinado","Tiempo Determinado","Art. 37 LFT"],["obra","Por Obra Determinada","Art. 36 LFT"]] as const).map(([val,label,art])=>(
              <button key={val} onClick={()=>setModalidad(val)}
                style={{flex:1, minWidth:isMobile?"45%":"auto", padding:"10px 12px", borderRadius:9,
                  border: modalidad===val ? "1px solid #2563EB" : "1px solid #D1D5DB",
                  background: modalidad===val ? "#2563EB" : "white",
                  color: modalidad===val ? "white" : "#374151",
                  cursor:"pointer", fontSize:12, fontWeight:modalidad===val?700:500,
                  fontFamily:fontSans, transition:"all 0.2s"}}>
                {label}
                <span style={{display:"block", fontSize:9.5, marginTop:2, opacity:0.85, fontWeight:400}}>{art}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Tabs horizontales */}
        <div style={{borderBottom:"1px solid #E5E7EB", marginBottom:18, overflowX:"auto" as const}}>
          <div style={{display:"flex", minWidth:"max-content"}}>
            {secciones.map((s,i)=>(
              <button key={s.key} onClick={()=>setSeccion(s.key)}
                style={{padding:"10px 14px", border:"none", background:"transparent", cursor:"pointer",
                  borderBottom:`2px solid ${seccion===s.key?"#2563EB":"transparent"}`,
                  color:seccion===s.key?"#2563EB":"#6B7280",
                  fontSize:isMobile?11:12, fontWeight:seccion===s.key?700:500,
                  whiteSpace:"nowrap" as const, transition:"all 0.2s",
                  display:"flex", alignItems:"center", gap:6, fontFamily:fontSans}}>
                <AxisIcon name={s.iconName} size={13} color={seccion===s.key?"#2563EB":"#9CA3AF"} withBackdrop={false} strokeWidth={3}/>
                {s.titulo}
              </button>
            ))}
          </div>
        </div>

        {/* Contenido del tab */}
        {seccion==="trabajador" && (
          <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr":"1fr 1fr", gap:12}}>
            <div style={{gridColumn:"1/-1"}}><label style={LABEL}>Nombre completo <span style={{color:"#DC2626"}}>*</span></label><input autoComplete="off" style={INPUT} value={form.nombreTrabajador} onChange={e=>f("nombreTrabajador",e.target.value)} placeholder="Como aparece en INE"/></div>
            <div><label style={LABEL}>RFC</label><input autoComplete="off" style={INPUT} value={form.rfcTrabajador} onChange={e=>f("rfcTrabajador",e.target.value.toUpperCase())} placeholder="XXXX000000XXX" maxLength={13}/></div>
            <div><label style={LABEL}>Nacionalidad</label><input autoComplete="off" style={INPUT} value={form.nacionalidad} onChange={e=>f("nacionalidad",e.target.value)} placeholder="Mexicana"/></div>
            <div style={{gridColumn:"1/-1"}}><label style={LABEL}>Domicilio <span style={{color:"#DC2626"}}>*</span></label><input autoComplete="off" style={INPUT} value={form.domicilioTrabajador} onChange={e=>f("domicilioTrabajador",e.target.value)} placeholder="Calle, Núm., Colonia, Ciudad, C.P."/></div>
          </div>
        )}
        {seccion==="patron" && (
          <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr":"1fr 1fr", gap:12}}>
            <div style={{gridColumn:"1/-1"}}><label style={LABEL}>Razón social / Nombre del patrón <span style={{color:"#DC2626"}}>*</span></label><input autoComplete="off" style={INPUT} value={form.razonSocial} onChange={e=>f("razonSocial",e.target.value)} placeholder="Empresa S.A. de C.V."/></div>
            <div><label style={LABEL}>RFC del patrón</label><input autoComplete="off" style={INPUT} value={form.rfcPatron} onChange={e=>f("rfcPatron",e.target.value.toUpperCase())} placeholder="RFC" maxLength={13}/></div>
            <div><label style={LABEL}>Representante legal</label><input autoComplete="off" style={INPUT} value={form.repLegal} onChange={e=>f("repLegal",e.target.value)} placeholder="Nombre del Rep. Legal"/></div>
            <div style={{gridColumn:"1/-1"}}><label style={LABEL}>Domicilio del patrón <span style={{color:"#DC2626"}}>*</span></label><input autoComplete="off" style={INPUT} value={form.domicilioPatron} onChange={e=>f("domicilioPatron",e.target.value)} placeholder="Domicilio fiscal o del centro de trabajo"/></div>
          </div>
        )}
        {seccion==="relacion" && (
          <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr":"1fr 1fr", gap:12}}>
            <div><label style={LABEL}>Puesto <span style={{color:"#DC2626"}}>*</span></label><input autoComplete="off" style={INPUT} value={form.puesto} onChange={e=>f("puesto",e.target.value)} placeholder="Auxiliar Contable"/></div>
            <div><label style={LABEL}>Departamento</label><input autoComplete="off" style={INPUT} value={form.departamento} onChange={e=>f("departamento",e.target.value)} placeholder="Administración, Ventas..."/></div>
            <div style={{gridColumn:"1/-1"}}><label style={LABEL}>Descripción de actividades <span style={{color:"#DC2626"}}>*</span></label><textarea autoComplete="off" style={{...INPUT,minHeight:75,resize:"vertical" as const}} value={form.descripcionActividades} onChange={e=>f("descripcionActividades",e.target.value)} placeholder="Principales funciones y responsabilidades"/></div>
            <div style={{gridColumn:"1/-1"}}><label style={LABEL}>Lugar de trabajo <span style={{color:"#DC2626"}}>*</span></label><input autoComplete="off" style={INPUT} value={form.lugarTrabajo} onChange={e=>f("lugarTrabajo",e.target.value)}/></div>
            <div><label style={LABEL}>Fecha de inicio <span style={{color:"#DC2626"}}>*</span></label><input autoComplete="off" type="date" style={INPUT} value={form.fechaInicio} onChange={e=>f("fechaInicio",e.target.value)}/></div>
            {modalidad==="determinado" && <div><label style={LABEL}>Fecha de término <span style={{color:"#DC2626"}}>*</span></label><input autoComplete="off" type="date" style={INPUT} value={form.fechaTermino} onChange={e=>f("fechaTermino",e.target.value)}/></div>}
            {modalidad==="obra" && <div style={{gridColumn:"1/-1"}}><label style={LABEL}>Descripción de la obra <span style={{color:"#DC2626"}}>*</span></label><textarea autoComplete="off" style={{...INPUT,minHeight:70,resize:"vertical" as const}} value={form.obraDescripcion} onChange={e=>f("obraDescripcion",e.target.value)} placeholder="Describe la obra o proyecto"/></div>}
          </div>
        )}
        {seccion==="jornada" && (
          <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr":"1fr 1fr", gap:12}}>
            <div style={{gridColumn:"1/-1"}}>
              <label style={LABEL}>Tipo de jornada</label>
              <div style={{display:"flex", gap:8, flexWrap:"wrap" as const}}>
                {([["diurna","Diurna","6–20h"],["nocturna","Nocturna","20–6h"],["mixta","Mixta",""],["reducida","Reducida","Convenida"]] as const).map(([v,l,d])=>(
                  <button key={v} onClick={()=>f("tipoJornada",v)}
                    style={{flex:1, minWidth:isMobile?"45%":"22%", padding:"9px 10px", borderRadius:8,
                      border: form.tipoJornada===v ? "1px solid #2563EB" : "1px solid #D1D5DB",
                      background: form.tipoJornada===v ? "#2563EB" : "white",
                      color: form.tipoJornada===v ? "white" : "#374151",
                      cursor:"pointer", fontSize:12, fontWeight:form.tipoJornada===v?700:500,
                      fontFamily:fontSans, transition:"all 0.2s"}}>
                    {l}{d ? <span style={{display:"block", fontSize:9.5, marginTop:2, opacity:0.85, fontWeight:400}}>{d}</span> : null}
                  </button>
                ))}
              </div>
            </div>
            <div><label style={LABEL}>Hora de entrada</label><input autoComplete="off" type="time" style={INPUT} value={form.horaEntrada} onChange={e=>f("horaEntrada",e.target.value)}/></div>
            <div><label style={LABEL}>Hora de salida</label><input autoComplete="off" type="time" style={INPUT} value={form.horaSalida} onChange={e=>f("horaSalida",e.target.value)}/></div>
            <div style={{gridColumn:"1/-1"}}><label style={LABEL}>Días de trabajo</label><input autoComplete="off" style={INPUT} value={form.diasTrabajo} onChange={e=>f("diasTrabajo",e.target.value)} placeholder="Lunes a Viernes"/></div>
          </div>
        )}
        {seccion==="salario" && (
          <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr":"1fr 1fr", gap:12}}>
            <div style={{gridColumn:"1/-1", background:"rgba(184,147,42,0.10)", border:"1px solid rgba(184,147,42,0.30)", borderRadius:9, padding:"10px 14px", display:"flex", gap:10}}>
              <AxisIcon name="money" size={16} tone="gold" withBackdrop={false} strokeWidth={3}/>
              <p style={{margin:0, fontSize:11.5, color:"#374151", lineHeight:1.5}}><strong>Salario mínimo 2026:</strong> $315.04/día · ZLFN: $440.87/día (no aplica en AGS)</p>
            </div>
            <div>
              <label style={LABEL}>Salario diario MXN <span style={{color:"#DC2626"}}>*</span></label>
              <input autoComplete="off" type="number" style={INPUT} value={form.salarioDiario} onChange={e=>f("salarioDiario",e.target.value)} placeholder="Mín. 315.04"/>
              {/* Mismo factor que el expediente (×30, Art. 89 LFT): el contrato no puede
                  declarar una cifra distinta a la que la plataforma registra. */}
              {form.salarioDiario && <span style={{fontSize:10.5, color:"#64748B", marginTop:4, display:"block"}}>Mensual: {fmtMXN2(Math.round(diarioAMensual(parseFloat(form.salarioDiario))))} <span style={{opacity:0.8}}>(÷30, Art. 89 LFT)</span></span>}
            </div>
            <div>
              <label style={LABEL}>Forma de pago</label>
              <select style={INPUT} value={form.formaPago} onChange={e=>f("formaPago",e.target.value)}>
                <option value="semanal">Semanal</option>
                <option value="quincenal">Quincenal</option>
                <option value="mensual">Mensual</option>
              </select>
            </div>
            <div><label style={LABEL}>Días de vacaciones (año 1)</label><input autoComplete="off" type="number" style={INPUT} value={form.diasVacaciones} onChange={e=>f("diasVacaciones",e.target.value)} min="12"/><span style={{fontSize:10, color:"#64748B", marginTop:3, display:"block"}}>Mín. legal: 12 días</span></div>
            <div><label style={LABEL}>Prima vacacional (%)</label><input autoComplete="off" type="number" style={INPUT} value={form.primaVacacional} onChange={e=>f("primaVacacional",e.target.value)} min="25"/><span style={{fontSize:10, color:"#64748B", marginTop:3, display:"block"}}>Mín. legal: 25%</span></div>
            <div><label style={LABEL}>Días de aguinaldo</label><input autoComplete="off" type="number" style={INPUT} value={form.aguinaldo} onChange={e=>f("aguinaldo",e.target.value)} min="15"/><span style={{fontSize:10, color:"#64748B", marginTop:3, display:"block"}}>Mín. legal: 15 días</span></div>
            <div style={{gridColumn:"1/-1"}}><label style={LABEL}>Prestaciones adicionales (opcional)</label><textarea autoComplete="off" style={{...INPUT,minHeight:60,resize:"vertical" as const}} value={form.beneficios} onChange={e=>f("beneficios",e.target.value)} placeholder="Seguro médico, vales de despensa, fondo de ahorro..."/></div>
          </div>
        )}
        {seccion==="extras" && (
          <div>
            <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr":"1fr 1fr", gap:12}}>
              <div><label style={LABEL}>Fecha del contrato</label><input autoComplete="off" type="date" style={INPUT} value={form.fechaContrato} onChange={e=>f("fechaContrato",e.target.value)}/></div>
              <div style={{display:"flex", alignItems:"center", gap:10, paddingTop:isMobile?0:18}}>
                <input autoComplete="off" type="checkbox" id="conf" checked={form.clausulaConfidencialidad} onChange={e=>f("clausulaConfidencialidad",e.target.checked)} style={{width:16,height:16,cursor:"pointer", flexShrink:0}}/>
                <label htmlFor="conf" style={{cursor:"pointer", fontSize:12, color:"#374151"}}>Incluir cláusula de confidencialidad</label>
              </div>
              <div><label style={LABEL}>Testigo 1</label><input autoComplete="off" style={INPUT} value={form.testigo1} onChange={e=>f("testigo1",e.target.value)} placeholder="Opcional"/></div>
              <div><label style={LABEL}>Testigo 2</label><input autoComplete="off" style={INPUT} value={form.testigo2} onChange={e=>f("testigo2",e.target.value)} placeholder="Opcional"/></div>
            </div>

            {/* Resumen */}
            <div style={{background:"rgba(37,99,235,0.05)", border:"1px solid rgba(37,99,235,0.20)", borderRadius:10, padding:14, marginTop:18}}>
              <div style={{fontFamily:fontSerif, fontWeight:700, color:"#0F172A", marginBottom:8, fontSize:13, display:"flex", alignItems:"center", gap:6}}>
                <AxisIcon name="check" size={14} color="#2563EB" withBackdrop={false} strokeWidth={3}/>
                Resumen del contrato
              </div>
              {[["Trabajador",form.nombreTrabajador||"—"],["Patrón",form.razonSocial||"—"],["Puesto",form.puesto||"—"],["Modalidad",modalidad==="indeterminado"?"Tiempo Indeterminado":modalidad==="determinado"?"Tiempo Determinado":"Por Obra"],["Salario/día",form.salarioDiario?`$${form.salarioDiario}`:"—"],["Jornada",`${form.tipoJornada} · ${form.horaEntrada}–${form.horaSalida}`]].map(([k,v])=>(
                <div key={k} style={{display:"flex", justifyContent:"space-between", fontSize:12, borderBottom:"1px solid rgba(37,99,235,0.10)", padding:"5px 0"}}>
                  <span style={{color:"#64748B"}}>{k}</span>
                  <span style={{color:"#0F172A", fontWeight:600}}>{v}</span>
                </div>
              ))}
            </div>

            {/* Aviso legal */}
            <div style={{background:"rgba(184,147,42,0.10)", border:"1px solid rgba(184,147,42,0.3)",
              borderRadius:10, padding:"12px 14px", marginTop:14, display:"flex", gap:10}}>
              <AxisIcon name="scale_simple" size={16} tone="gold" withBackdrop={false} strokeWidth={3}/>
              <div style={{fontSize:11.5, color:"#374151", lineHeight:1.5}}>
                <strong>Aviso legal:</strong> Modelo general conforme a LFT vigente. Cada relación laboral puede tener particularidades. Recomendamos revisión por AXIS Asesoría Legal antes de firmar.
              </div>
            </div>

            {/* Botón generar */}
            <button onClick={generarPDF} disabled={generando||!form.nombreTrabajador||!form.razonSocial||!form.puesto}
              style={{width:"100%", marginTop:14, padding:"14px", borderRadius:10,
                background: (!form.nombreTrabajador||!form.razonSocial||!form.puesto) ? "#9CA3AF" : "linear-gradient(135deg,#2563EB,#1E40AF)",
                border:"none", color:"white", fontSize:15, fontWeight:700,
                cursor: (!form.nombreTrabajador||!form.razonSocial||!form.puesto) ? "not-allowed" : "pointer",
                boxShadow: (!form.nombreTrabajador||!form.razonSocial||!form.puesto) ? "none" : "0 4px 16px rgba(37,99,235,0.40)",
                display:"flex", alignItems:"center", justifyContent:"center", gap:10,
                fontFamily:fontSans}}>
              <AxisIcon name="document" size={16} tone="white" withBackdrop={false} strokeWidth={3}/>
              {generando?"Generando contrato...":"Generar contrato en PDF"}
            </button>
            {(!form.nombreTrabajador||!form.razonSocial||!form.puesto) && <p style={{textAlign:"center" as const, fontSize:11, color:"#DC2626", marginTop:8}}>Completa: nombre del trabajador, patrón y puesto</p>}
            {ultimoBlob && (
              <div style={{marginTop:14, padding:"14px 16px", background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:12, display:"flex", justifyContent:"space-between", alignItems:"center", gap:12, flexWrap:"wrap"}}>
                <div style={{fontSize:12, color:T_LIGHT.textInkSoft, flex:1, minWidth:160}}>¿Quieres guardar este contrato en un expediente?</div>
                {/* El archivo se guarda con el nombre del documento, no con la
                    clave interna: quien lo abra en el expediente tiene que saber
                    qué firmó sin abrirlo. La modalidad forma parte del título
                    legal del contrato, así que va en el nombre. */}
                <BotonGuardarYVincular
                  user={user}
                  tipoContrato={tipoContrato}
                  getPDFBlob={async () => ultimoBlob!}
                  nombrePDFBase={vNombreArchivo}
                  fontSans={fontSans} fontSerif={fontSerif} gold={gold}
                />
              </div>
            )}
          </div>
        )}

        {/* Paginación */}
        <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginTop:22, paddingTop:14, borderTop:"1px solid #E5E7EB"}}>
          <button onClick={prev} disabled={idx===0}
            style={{padding:"9px 16px", borderRadius:8,
              border: idx===0 ? "1px solid #E5E7EB" : "1px solid #D1D5DB",
              background:"white",
              color: idx===0 ? "#D1D5DB" : "#374151",
              cursor: idx===0 ? "not-allowed" : "pointer",
              fontSize:12.5, fontWeight:600, fontFamily:fontSans}}>← Anterior</button>
          <span style={{fontSize:11, color:"#64748B", fontWeight:500}}>{idx+1} / {secciones.length}</span>
          <button onClick={next} disabled={idx===secciones.length-1}
            style={{padding:"9px 16px", borderRadius:8, border:"none",
              background: idx===secciones.length-1 ? "#E5E7EB" : "linear-gradient(135deg,#2563EB,#1E40AF)",
              color: idx===secciones.length-1 ? "#9CA3AF" : "white",
              cursor: idx===secciones.length-1 ? "not-allowed" : "pointer",
              fontSize:12.5, fontWeight:600, fontFamily:fontSans}}>Siguiente →</button>
        </div>
      </div>
    </div>
  );
}


// ─── BANCO DE DOCUMENTOS GENERADOS ───────────────────────────────────────────
// Vista dentro del Generador legal que lista TODOS los documentos guardados de
// la cuenta. Modelo HÍBRIDO (sin migración de datos existentes):
//   • VINCULADOS: viven embebidos en su entidad (clientes/trabajadores/
//     proveedores/deudores) dentro del array `contratos`. Se leen y aplanan aquí.
//   • SIN VINCULAR: viven en la colección owner-scoped `documentos_generados`
//     con ref:null. (Requiere publicar las reglas de Firestore — sección 8E.)
// La lista junta ambas fuentes y ORDENA EN JS por fecha (sin orderBy → sin índices).
// Es resiliente: si aún no se publican las reglas, los vinculados se muestran igual.
function BancoDocumentos({user, onBack, fontSans, fontSerif, gold}: {user:any; onBack:()=>void; fontSans:string; fontSerif:string; gold:string}) {
  const isMobile = window.innerWidth < 768;
  const db = getFirestore();
  const [cargando, setCargando] = useState(true);
  const [docs, setDocs] = useState<any[]>([]);
  const [filtro, setFiltro] = useState<"todos"|"vinculados"|"sin">("todos");

  const LABEL_ENT: Record<string,string> = {cliente:"Cliente", paciente:"Paciente", empleado:"Empleado", proveedor:"Proveedor", deudor:"Deudor"};
  const COLOR_ENT: Record<string,string> = {cliente:"#8E3B6E", paciente:"#0D9488", empleado:"#2563EB", proveedor:"#7C3AED", deudor:"#1E3A8A"};
  const nombreTipo = (id:string) => TIPOS_CONTRATO_CLIENTE.find(t=>t.id===id)?.nombre || id;

  const cargar = async () => {
    if (!user?.uid) return;
    setCargando(true);
    const out:any[] = [];
    // 1) VINCULADOS — arrays embebidos en cada entidad (lectura siempre permitida).
    try {
      const [snapCli, snapTra, snapPro, snapDeu] = await Promise.all([
        getDocs(query(collection(db,"clientes"),     where("userId","==",user.uid))),
        getDocs(query(collection(db,"trabajadores"), where("userId","==",user.uid))),
        getDocs(query(collection(db,"proveedores"),  where("userId","==",user.uid))),
        getDocs(query(collection(db,"deudores"),     where("userId","==",user.uid))),
      ]);
      const aplanar = (snap:any, tipoBase:string) => {
        snap.docs.forEach((d:any) => {
          const data:any = d.data();
          const arr:any[] = data.contratos || [];
          // Pacientes = clientes con plantilla "medico".
          const tipoEnt = (tipoBase==="cliente" && data.plantilla==="medico") ? "paciente" : tipoBase;
          arr.forEach((c:any) => out.push({
            key:`${tipoBase}_${d.id}_${c.id||c.url}`,
            tipo:c.tipo, fecha:c.fecha||"", descripcion:c.descripcion||null,
            url:c.url, nombrePdf:c.nombrePdf,
            vinc:{tipo:tipoEnt, nombre:data.nombre||"(sin nombre)"},
          }));
        });
      };
      aplanar(snapCli,"cliente"); aplanar(snapTra,"empleado"); aplanar(snapPro,"proveedor"); aplanar(snapDeu,"deudor");
    } catch(e){ console.error("Banco — vinculados:", e); }

    // 2) SIN VINCULAR — colección nueva. Si las reglas aún no están publicadas,
    //    esto lanza permission-denied: lo atrapamos y seguimos (no rompe el banco).
    try {
      const snapU = await getDocs(query(collection(db,"documentos_generados"), where("userId","==",user.uid)));
      snapU.docs.forEach((d:any) => {
        const c:any = d.data();
        out.push({
          key:`dg_${d.id}`, docId:d.id,
          tipo:c.tipo, fecha:c.fecha||"", descripcion:c.descripcion||null,
          url:c.url, nombrePdf:c.nombrePdf,
          vinc:null,
        });
      });
    } catch(e){ console.warn("Banco — 'documentos_generados' sin permisos todavía (publica las reglas de Firestore, sección 8E):", e); }

    out.sort((a,b)=> (b.fecha||"").localeCompare(a.fecha||""));
    setDocs(out);
    setCargando(false);
  };

  useEffect(()=>{ cargar(); }, [user]);

  const eliminarSinVincular = async (d:any) => {
    if (!window.confirm("¿Eliminar este documento del banco? Se borrará también su PDF. (Solo aplica a documentos sin vincular.)")) return;
    try {
      if (d.url) { try { await eliminarArchivo(d.url); } catch(e){ console.error("No se pudo borrar PDF:", e); } }
      await deleteDoc(doc(db,"documentos_generados",d.docId));
      setDocs(prev => prev.filter(x => x.key !== d.key));
    } catch(e){ console.error(e); alert("No se pudo eliminar el documento."); }
  };

  const visibles = docs.filter(d => filtro==="todos" ? true : filtro==="vinculados" ? !!d.vinc : !d.vinc);
  const totalVinc = docs.filter(d=>d.vinc).length;
  const totalSin  = docs.filter(d=>!d.vinc).length;

  return (
    <div style={{minHeight:"100vh", background:T_LIGHT.canvas, fontFamily:fontSans}}>
      <div style={{maxWidth:ANCHO_CONTENIDO, margin:"0 auto", padding:isMobile?"16px":"28px 24px"}}>
        <button onClick={onBack} style={{background:"transparent", border:`1px solid ${T_LIGHT.borderCard}`, color:T_LIGHT.textInkSoft, borderRadius:8, padding:"6px 12px", cursor:"pointer", fontSize:12, fontWeight:600, marginBottom:18, fontFamily:fontSans}}>← Generador legal</button>

        <div style={{marginBottom:18}}>
          <h2 style={{fontFamily:fontSerif, fontSize:isMobile?20:26, color:T_LIGHT.textInk, margin:"0 0 6px"}}>Documentos generados</h2>
          <p style={{fontSize:13, color:T_LIGHT.textInkSoft, margin:0, lineHeight:1.6}}>
            Todos los documentos que has guardado desde el Generador legal: vinculados a una persona (cliente, paciente, empleado, proveedor o deudor) o sin vincular. Cada uno con su PDF.
          </p>
        </div>

        {/* Filtros */}
        <div style={{display:"flex", gap:8, marginBottom:16, flexWrap:"wrap" as const}}>
          {([
            {id:"todos" as const,      label:`Todos (${docs.length})`},
            {id:"vinculados" as const, label:`Vinculados (${totalVinc})`},
            {id:"sin" as const,        label:`Sin vincular (${totalSin})`},
          ]).map(f => (
            <button key={f.id} onClick={()=>setFiltro(f.id)} style={{
              background: filtro===f.id ? gold : "transparent",
              color: filtro===f.id ? "#0B1829" : T_LIGHT.textInkSoft,
              border: filtro===f.id ? "none" : `1px solid ${T_LIGHT.border}`,
              borderRadius:20, padding:"6px 14px", cursor:"pointer", fontSize:12, fontWeight:700, fontFamily:fontSans,
            }}>{f.label}</button>
          ))}
        </div>

        {cargando ? (
          <div style={{textAlign:"center" as const, padding:"50px 20px", color:T_LIGHT.textInkMut, fontSize:14}}>Cargando documentos…</div>
        ) : visibles.length === 0 ? (
          <div style={{textAlign:"center" as const, padding:"50px 24px", color:T_LIGHT.textInkMut, fontSize:14, background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:14, lineHeight:1.6}}>
            {docs.length===0
              ? "Aún no has guardado documentos. Genera uno en el Generador legal y usa “Guardar y vincular…” o “Guardar (sin vincular)”."
              : "No hay documentos con este filtro."}
          </div>
        ) : (
          <div style={{display:"flex", flexDirection:"column" as const, gap:10}}>
            {visibles.map(d => (
              <div key={d.key} style={{background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:12, padding:isMobile?"13px 14px":"15px 18px", boxShadow:T_LIGHT.shadow, display:"flex", alignItems:isMobile?"flex-start":"center", gap:12, flexDirection:isMobile?"column" as const:"row" as const}}>
                <div style={{flex:1, minWidth:0, width:isMobile?"100%":"auto"}}>
                  <div style={{fontWeight:700, fontSize:14, color:T_LIGHT.textInk, marginBottom:5, lineHeight:1.3}}>{nombreTipo(d.tipo)}</div>
                  <div style={{display:"flex", alignItems:"center", gap:8, flexWrap:"wrap" as const}}>
                    <span style={{fontSize:11.5, color:T_LIGHT.textInkMut}}>{d.fecha || "—"}</span>
                    <span style={{fontSize:11.5, color:T_LIGHT.textInkMut}}>·</span>
                    {d.vinc ? (
                      <span style={{fontSize:11, fontWeight:700, padding:"2px 9px", borderRadius:10, background:(COLOR_ENT[d.vinc.tipo]||gold)+"18", color:COLOR_ENT[d.vinc.tipo]||T_LIGHT.textInk, border:`1px solid ${(COLOR_ENT[d.vinc.tipo]||gold)}40`}}>
                        {LABEL_ENT[d.vinc.tipo]||d.vinc.tipo}: {d.vinc.nombre}
                      </span>
                    ) : (
                      <span style={{fontSize:11, fontWeight:700, padding:"2px 9px", borderRadius:10, background:"rgba(100,116,139,0.12)", color:T_LIGHT.textInkMut, border:"1px solid rgba(100,116,139,0.25)"}}>Sin vincular</span>
                    )}
                  </div>
                  {d.descripcion && <div style={{fontSize:11.5, color:T_LIGHT.textInkSoft, marginTop:5, lineHeight:1.5}}>{d.descripcion}</div>}
                </div>
                <div style={{display:"flex", gap:8, flexShrink:0, alignItems:"center"}}>
                  <a href={d.url} target="_blank" rel="noreferrer" style={{background:gold, color:"#0B1829", borderRadius:8, padding:"8px 14px", cursor:"pointer", fontSize:12, fontWeight:700, textDecoration:"none", whiteSpace:"nowrap" as const}}>Ver PDF</a>
                  {!d.vinc && (
                    <button onClick={()=>eliminarSinVincular(d)} title="Eliminar del banco" style={{background:"transparent", border:`1px solid ${T_LIGHT.borderCard}`, color:T_LIGHT.danger, borderRadius:8, padding:"8px 11px", cursor:"pointer", fontSize:12, fontWeight:700, fontFamily:fontSans}}>Eliminar</button>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Nota del modelo híbrido */}
        <p style={{fontSize:11, color:T_LIGHT.textInkMut, margin:"18px 2px 0", lineHeight:1.6}}>
          Los documentos <strong>vinculados</strong> también aparecen y se gestionan en el expediente de cada persona. Los <strong>“sin vincular”</strong> se guardan solo aquí, en tu banco.
        </p>
      </div>
    </div>
  );
}

function ContratosModulo({user, onBack, fontSans, fontSerif, gold}: {user:any; onBack:()=>void; fontSans:string; fontSerif:string; gold:string}) {
  const isMobile = window.innerWidth < 768;
  const [contratoSeleccionado, setContratoSeleccionado] = useState<string|null>(null);
  const [expandido, setExpandido] = useState<string|null>(null);
  const toggleExpandir = (id:string) => setExpandido(prev => prev === id ? null : id);

  const contratos = [
    {
      id:"servicios_profesionales",
      icon:"💼", iconName:"briefcase",
      nombre:"Prestación de Servicios Profesionales",
      desc:"Para contratar o formalizar servicios de cualquier profesional independiente: abogados, contadores, consultores, diseñadores, ingenieros y similares.",
      sectores:"Todos los sectores · Especialmente servicios, manufactura, comercio y salud",
      color:"#059669",
      acento:"rgba(5,150,105,0.08)",
    },
    {
      id:"contratacion_personal",
      icon:"👥", iconName:"suite_empleados",
      nombre:"Contrato de Trabajo · Individual o Colectivo",
      desc:"Para formalizar la relación laboral. Modalidad Individual (con sub-modalidades: tiempo indeterminado, determinado o por obra) o Modalidad Colectiva (entre empresa y sindicato, conforme a la LFT).",
      sectores:"Todos los sectores · Cualquier empresa con trabajadores o sindicato",
      color:"#2563EB",
      acento:"rgba(37,99,235,0.08)",
    },
    {
      id:"compraventa_inmueble",
      icon:"🏠", iconName:"house",
      nombre:"Compraventa de Inmueble",
      desc:"Contrato privado de compraventa de casas, locales, terrenos o bodegas, conforme al Código Civil de Aguascalientes. Surte efectos entre las partes desde la firma y se obligan a formalizarlo ante Notario Público.",
      sectores:"Inmobiliario · Cualquier empresa o persona que compra o vende un inmueble",
      color:"#B8932A",
      acento:"rgba(184,147,42,0.08)",
    },
    {
      id:"arrendamiento_bodega_industrial",
      icon:"🏭", iconName:"building",
      nombre:"Arrendamiento de Bodega Industrial",
      desc:"Para rentar bodegas, naves o inmuebles en parques industriales destinados a almacenamiento, distribución o producción. Incluye obligado solidario, depósito en garantía y cláusula penal.",
      sectores:"Manufactura · Logística · Distribución · Empresas en parques industriales",
      color:"#7C3AED",
      acento:"rgba(124,58,237,0.08)",
    },
    {
      id:"arrendamiento_vivienda",
      icon:"🏡", iconName:"house",
      nombre:"Arrendamiento de Vivienda",
      desc:"Para rentar una casa o departamento con fines habitacionales, conforme al Código Civil del Estado de Aguascalientes.",
      sectores:"Particulares · Empresas que proporcionan vivienda a trabajadores",
      color:"#DC2626",
      acento:"rgba(220,38,38,0.08)",
    },
    {
      id:"servicio_domestico",
      icon:"🏠", iconName:"house",
      nombre:"Contrato de Servicio Doméstico — Hogar y Empresa",
      desc:"Para contratar personal de limpieza, intendencia, cuidados o asistencia en hogares particulares o empresas. Conforme al Capítulo XIII-BIS de la LFT.",
      sectores:"Hogares · Empresas con personal de limpieza o intendencia · Cualquier empleador",
      color:"#059669",
      acento:"rgba(5,150,105,0.08)",
    },
    {
      id:"confidencialidad",
      icon:"🔒", iconName:"lock_closed",
      nombre:"Convenio de Confidencialidad (NDA)",
      desc:"Para proteger información sensible, secretos comerciales, procesos y datos cuando se comparten con empleados, socios, proveedores o terceros. Incluye daños precuantificados y responsabilidad civil y penal.",
      sectores:"Todos los sectores · Especialmente tecnología, manufactura y servicios profesionales",
      color:"#0F172A",
      acento:"rgba(15,23,42,0.06)",
    },
    {
      id:"compraventa_vehiculo",
      icon:"🚗", iconName:"suite_flotilla",
      nombre:"Compraventa de Vehículo",
      desc:"Para formalizar la compra-venta de vehículos automotores entre particulares o empresas, conforme al Código Civil de Aguascalientes (arts. 2119 y siguientes). Incluye saneamiento por evicción y vicios ocultos.",
      sectores:"Transporte · Flotillas · Cualquier persona o empresa",
      color:"#2563EB",
      acento:"rgba(37,99,235,0.06)",
    },
    {
      id:"obra",
      icon:"🏗️", iconName:"construction",
      nombre:"Contrato de Obra · Precio Alzado o Administración",
      desc:"Para contratar construcción, ampliación o remodelación entre el contratante y el contratista (arquitecto, ingeniero o constructor). Dos modalidades: precio alzado (fijo) o por administración (costo + honorarios). Conforme al Código Civil de Aguascalientes (arts. 2489-2518 para precio alzado).",
      sectores:"Construcción · Inmobiliario · Cualquier empresa o particular que contrata obra",
      color:"#D97706",
      acento:"rgba(217,119,6,0.08)",
    },
    {
      id:"asociacion_participacion",
      icon:"🤝", iconName:"suite_empleados",
      nombre:"Asociación en Participación",
      desc:"Para que dos o más personas se asocien comercialmente en un negocio sin crear una sociedad mercantil. EL ASOCIANTE opera frente a terceros y EL ASOCIADO aporta bienes/capital. Reparto de utilidades pactado. Sin relación laboral.",
      sectores:"Comercio · Servicios profesionales · Cualquier negocio entre dos o más personas",
      color:"#0D9488",
      acento:"rgba(13,148,136,0.08)",
    },
  ];

  // ── Documentos legales (no son contratos: cumplimiento + médico) ────────
  const documentos = [
    {
      id:"aviso_privacidad",
      iconName:"lock_closed",
      nombre:"Aviso de Privacidad (LFPDPPP)",
      desc:"Aviso de privacidad integral conforme a la Ley Federal de Protección de Datos Personales en Posesión de los Particulares. Se llena con los datos de tu empresa (responsable del tratamiento) e informa al titular sobre finalidades, transferencias y medios para ejercer sus derechos ARCO.",
      sectores:"Todos los sectores · Obligatorio para quien recaba datos personales",
      color:"#4C5BAA",
      acento:"rgba(76,91,170,0.08)",
    },
    {
      id:"consentimiento_informado",
      iconName:"medico",
      nombre:"Consentimiento Informado (médico)",
      desc:"Documento donde el paciente autoriza un procedimiento tras ser informado del procedimiento, riesgos, beneficios y alternativas. Tú redactas esos campos según el caso concreto. Protege tanto al paciente como al profesional de la salud.",
      sectores:"Salud · Clínicas, consultorios y profesionales médicos",
      color:"#0D9488",
      acento:"rgba(13,148,136,0.08)",
    },
  ];

  if (contratoSeleccionado === "contratacion_personal") {
    return <FormContratoTrabajoSelector user={user} tipoContrato="contratacion_personal" onBack={() => setContratoSeleccionado(null)} fontSans={fontSans} fontSerif={fontSerif} gold={gold} />;
  }

  if (contratoSeleccionado === "servicios_profesionales") {
    return <FormServiciosProfesionales user={user} tipoContrato="servicios_profesionales" onBack={() => setContratoSeleccionado(null)} fontSans={fontSans} fontSerif={fontSerif} gold={gold} />;
  }

  if (contratoSeleccionado === "arrendamiento_vivienda") {
    return <FormArrendamientoVivienda user={user} tipoContrato="arrendamiento_vivienda" onBack={() => setContratoSeleccionado(null)} fontSans={fontSans} fontSerif={fontSerif} gold={gold} />;
  }

  if (contratoSeleccionado === "servicio_domestico") {
    return <FormServicioDomestico user={user} tipoContrato="servicio_domestico" onBack={() => setContratoSeleccionado(null)} fontSans={fontSans} fontSerif={fontSerif} gold={gold} />;
  }

  if (contratoSeleccionado === "arrendamiento_bodega_industrial") {
    return <FormArrendamientoBodegaIndustrial user={user} tipoContrato="arrendamiento_bodega_industrial" onBack={() => setContratoSeleccionado(null)} fontSans={fontSans} fontSerif={fontSerif} gold={gold} />;
  }

  if (contratoSeleccionado === "compraventa_vehiculo") {
    return <FormCompraventaVehiculo user={user} tipoContrato="compraventa_vehiculo" onBack={() => setContratoSeleccionado(null)} fontSans={fontSans} fontSerif={fontSerif} gold={gold} />;
  }

  if (contratoSeleccionado === "compraventa_inmueble") {
    return <FormCompraventaInmueble user={user} tipoContrato="compraventa_inmueble" onBack={() => setContratoSeleccionado(null)} fontSans={fontSans} fontSerif={fontSerif} gold={gold} />;
  }

  if (contratoSeleccionado === "confidencialidad") {
    return <FormConfidencialidad user={user} tipoContrato="confidencialidad" onBack={() => setContratoSeleccionado(null)} fontSans={fontSans} fontSerif={fontSerif} gold={gold} />;
  }

  if (contratoSeleccionado === "obra") {
    return <FormObra user={user} tipoContrato="obra" onBack={() => setContratoSeleccionado(null)} fontSans={fontSans} fontSerif={fontSerif} gold={gold} />;
  }

  if (contratoSeleccionado === "asociacion_participacion") {
    return <FormAsociacionParticipacion user={user} tipoContrato="asociacion_participacion" onBack={() => setContratoSeleccionado(null)} fontSans={fontSans} fontSerif={fontSerif} gold={gold} />;
  }

  // ── Documentos legales (no son contratos) ──────────────────────────────
  if (contratoSeleccionado === "aviso_privacidad") {
    return <FormAvisoPrivacidad user={user} tipoContrato="aviso_privacidad" onBack={() => setContratoSeleccionado(null)} fontSans={fontSans} fontSerif={fontSerif} gold={gold} />;
  }

  if (contratoSeleccionado === "consentimiento_informado") {
    return <FormConsentimientoInformado user={user} tipoContrato="consentimiento_informado" onBack={() => setContratoSeleccionado(null)} fontSans={fontSans} fontSerif={fontSerif} gold={gold} />;
  }

  // ── Título de crédito: Pagaré ──────────────────────────────────────────
  if (contratoSeleccionado === "pagare") {
    return <FormPagare user={user} tipoContrato="pagare" onBack={() => setContratoSeleccionado(null)} fontSans={fontSans} fontSerif={fontSerif} gold={gold} />;
  }

  // ── Banco de documentos generados ──────────────────────────────────────
  if (contratoSeleccionado === "__banco__") {
    return <BancoDocumentos user={user} onBack={() => setContratoSeleccionado(null)} fontSans={fontSans} fontSerif={fontSerif} gold={gold} />;
  }

  return (
    <div style={{minHeight:"100vh", background:T_LIGHT.canvas, fontFamily:fontSans}}>
      {/* Header navy interno removido — "Generador legal" lo da el sidebar. */}

      <div style={{maxWidth:ANCHO_CONTENIDO, margin:"0 auto", padding:isMobile?"16px":"28px 24px"}}>
        <div style={{marginBottom:24}}>
          <h2 style={{fontFamily:fontSerif, fontSize:isMobile?20:26, color:T_LIGHT.textInk, margin:"0 0 6px"}}>Generador legal</h2>
          <div style={{fontSize:isMobile?12:13, color:T_LIGHT.gold, fontWeight:700, letterSpacing:"0.2px", margin:"0 0 10px"}}>
            Contratos · Avisos y consentimientos · Títulos de crédito
          </div>
          <p style={{fontSize:13, color:T_LIGHT.textInkSoft, margin:0, lineHeight:1.6}}>
            Selecciona el documento que necesitas. Llena los datos y descarga un borrador en PDF conforme a la legislación vigente en Aguascalientes.
          </p>
        </div>

        {/* Banner aviso legal */}
        <div style={{background:T_LIGHT.goldSoft, border:`1px solid ${T_LIGHT.goldBorder}`, borderRadius:12, padding:"12px 16px", marginBottom:20, display:"flex", alignItems:"center", gap:12}}>
          <AxisIcon name="scale_simple" size={20} tone="gold" withBackdrop={false} strokeWidth={2.5}/>
          <div style={{fontSize:12, color:T_LIGHT.textInkSoft, lineHeight:1.6}}>
            <strong style={{color:T_LIGHT.gold}}>Nota legal:</strong> Los contratos generados son borradores de referencia basados en la legislación vigente. Para contratos con valor legal pleno, AXIS los revisa, personaliza y certifica. <a href="https://wa.me/524494251128?text=Hola%20AXIS%2C%20necesito%20revisar%20un%20contrato" target="_blank" rel="noreferrer" style={{color:T_LIGHT.gold, fontWeight:700}}>Consultar con AXIS →</a>
          </div>
        </div>

        {/* Acceso al Banco de documentos generados */}
        <button onClick={()=>setContratoSeleccionado("__banco__")} style={{
          width:"100%", display:"flex", alignItems:"center", gap:12, textAlign:"left" as const,
          background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:12,
          padding:"13px 16px", marginBottom:20, cursor:"pointer", fontFamily:fontSans, boxShadow:T_LIGHT.shadow,
        }}>
          <div style={{width:38, height:38, borderRadius:10, background:T_LIGHT.goldSoft, border:`1px solid ${T_LIGHT.goldBorder}`, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0, fontSize:18}}>📁</div>
          <div style={{flex:1, minWidth:0}}>
            <div style={{fontWeight:700, fontSize:14, color:T_LIGHT.textInk}}>Documentos generados</div>
            <div style={{fontSize:12, color:T_LIGHT.textInkSoft, lineHeight:1.5}}>Todos los documentos que has guardado: vinculados a una persona o sin vincular.</div>
          </div>
          <span style={{color:T_LIGHT.gold, fontWeight:700, fontSize:13, flexShrink:0}}>Ver →</span>
        </button>

        {/* ── Categoría: Contratos ── */}
        <div style={{display:"flex", alignItems:"center", gap:10, margin:"0 0 14px"}}>
          <div style={{width:4, height:22, background:"#1F4E3D", borderRadius:2, flexShrink:0}}/>
          <h3 style={{fontFamily:fontSerif, fontSize:isMobile?16:19, color:T_LIGHT.textInk, margin:0, flex:1}}>Contratos</h3>
          <span style={{fontSize:10.5, fontWeight:700, padding:"3px 9px", borderRadius:12,
            background:T_LIGHT.goldSoft, border:`1px solid ${T_LIGHT.goldBorder}`,
            color:T_LIGHT.gold, whiteSpace:"nowrap" as const}}>14 disponibles</span>
        </div>

        {/* Grid de contratos — solo se muestran los implementados (consolidado) */}
        <div style={{display:"flex", flexDirection:"column" as const, gap:10}}>
          {contratos.filter(c => ["servicios_profesionales","contratacion_personal","arrendamiento_vivienda","servicio_domestico","arrendamiento_bodega_industrial","compraventa_vehiculo","compraventa_inmueble","confidencialidad","obra","asociacion_participacion"].includes(c.id)).map((c,i) => {
            const isOpen = expandido === c.id;
            const esGenerable = ["servicios_profesionales","contratacion_personal","arrendamiento_vivienda","servicio_domestico","arrendamiento_bodega_industrial","compraventa_vehiculo","compraventa_inmueble","confidencialidad","obra","asociacion_participacion"].includes(c.id);
            return (
              <div key={c.id}
                style={{
                  background:"white", borderRadius:14, overflow:"hidden",
                  border:`1px solid ${isOpen ? c.color+"88" : "rgba(22,36,71,0.25)"}`,
                  boxShadow:isOpen ? `0 8px 32px ${c.color}18` : "0 2px 8px rgba(22,36,71,0.06)",
                  transition:"all 0.25s ease",
                  animation:`fadeUp 0.35s ${i*0.05}s ease both`,
                }}>
                {/* ── Cabecera siempre visible ── */}
                <div onClick={() => toggleExpandir(c.id)}
                  style={{display:"flex", alignItems:"center", gap:12, padding:"14px 16px",
                    cursor:"pointer", position:"relative" as const}}>
                  {/* Línea izquierda de color */}
                  <div style={{position:"absolute" as const, left:0, top:0, bottom:0, width:3,
                    background:c.color, borderRadius:"0 2px 2px 0"}}/>
                  {/* Icono */}
                  <div style={{width:40, height:40, background:c.acento, borderRadius:10,
                    display:"flex", alignItems:"center", justifyContent:"center",
                    flexShrink:0, border:`1px solid ${c.color}30`}}>
                    <AxisIcon name={c.iconName} size={20} color={c.color} withBackdrop={false} strokeWidth={2.5}/>
                  </div>
                  {/* Nombre */}
                  <div style={{flex:1, minWidth:0}}>
                    <div style={{fontWeight:700, fontSize:isMobile?13:14, color:"#0F172A",
                      lineHeight:1.3, marginBottom:2}}>{c.nombre}</div>
                    {!isOpen && <div style={{fontSize:11, color:"#9CA3AF", whiteSpace:"nowrap" as const,
                      overflow:"hidden", textOverflow:"ellipsis"}}>{c.sectores}</div>}
                  </div>
                  {/* Badges + flecha */}
                  <div style={{display:"flex", alignItems:"center", gap:8, flexShrink:0}}>
                    {esGenerable && (
                      <span style={{fontSize:9, fontWeight:700, padding:"3px 8px", borderRadius:10,
                        background:"rgba(5,150,105,0.1)", color:"#059669",
                        border:"1px solid rgba(5,150,105,0.25)", whiteSpace:"nowrap" as const}}>
                        ✓ Disponible
                      </span>
                    )}
                    <div style={{width:24, height:24, borderRadius:6,
                      background:isOpen ? c.color : "rgba(22,36,71,0.06)",
                      display:"flex", alignItems:"center", justifyContent:"center",
                      transition:"all 0.2s", flexShrink:0}}>
                      <span style={{fontSize:10, color:isOpen?"white":"#6B7280",
                        transform:isOpen?"rotate(180deg)":"rotate(0deg)",
                        transition:"transform 0.25s", display:"block"}}>▼</span>
                    </div>
                  </div>
                </div>

                {/* ── Panel expandido ── */}
                {isOpen && (
                  <div style={{padding:"0 16px 16px 16px", borderTop:`1px solid ${c.color}20`}}>
                    {/* Descripción */}
                    <p style={{fontSize:13, color:T_LIGHT.textInkSoft, lineHeight:1.7, margin:"12px 0 10px"}}>
                      {c.desc}
                    </p>
                    {/* Quién lo usa */}
                    <div style={{display:"flex", alignItems:"flex-start", gap:8, padding:"10px 12px",
                      background:c.acento, borderRadius:10, marginBottom:14,
                      border:`1px solid ${c.color}25`}}>
                      <span style={{fontSize:13, flexShrink:0}}>👤</span>
                      <div>
                        <div style={{fontSize:10, fontWeight:700, color:c.color,
                          textTransform:"uppercase" as const, letterSpacing:"0.5px", marginBottom:3}}>
                          Quién lo usa
                        </div>
                        <div style={{fontSize:12, color:"#4B5563", lineHeight:1.5}}>{c.sectores}</div>
                      </div>
                    </div>
                    {/* Botón */}
                    {esGenerable ? (
                      <button onClick={() => setContratoSeleccionado(c.id)}
                        style={{width:"100%", background:`linear-gradient(135deg,${c.color},${c.color}CC)`,
                          border:"none", borderRadius:10, padding:"13px",
                          cursor:"pointer", fontSize:14, fontWeight:700, color:"white",
                          boxShadow:`0 4px 16px ${c.color}40`}}>
                        ✍️ Generar contrato →
                      </button>
                    ) : (
                      <div style={{textAlign:"center" as const, padding:"10px",
                        background:"rgba(22,36,71,0.04)", borderRadius:10,
                        border:"1px dashed rgba(22,36,71,0.15)"}}>
                        <div style={{fontSize:12, color:"#9CA3AF", marginBottom:4}}>🔜 Próximamente</div>
                        <div style={{fontSize:11, color:"#D1D5DB"}}>Este contrato estará disponible pronto</div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* ── Categoría: Avisos y consentimientos ── */}
        <div style={{marginTop:34}}>
          <div style={{display:"flex", alignItems:"center", gap:10, margin:"0 0 6px"}}>
            <div style={{width:4, height:22, background:"#4C5BAA", borderRadius:2, flexShrink:0}}/>
            <h3 style={{fontFamily:fontSerif, fontSize:isMobile?16:19, color:T_LIGHT.textInk, margin:0}}>Avisos y consentimientos</h3>
          </div>
          <p style={{fontSize:13, color:T_LIGHT.textInkSoft, margin:"0 0 14px", lineHeight:1.6, paddingLeft:14}}>
            No son contratos: son documentos de cumplimiento que tu empresa necesita. Mismo flujo — llena los datos, descarga el PDF y guárdalo en el expediente.
          </p>

          <div style={{display:"flex", flexDirection:"column" as const, gap:10}}>
            {documentos.map((d,i) => (
              <div key={d.id}
                style={{
                  background:"white", borderRadius:14, overflow:"hidden",
                  border:"1px solid rgba(22,36,71,0.25)",
                  boxShadow:"0 2px 8px rgba(22,36,71,0.06)",
                  position:"relative" as const,
                  animation:`fadeUp 0.35s ${i*0.05}s ease both`,
                }}>
                <div style={{position:"absolute" as const, left:0, top:0, bottom:0, width:3,
                  background:d.color, borderRadius:"0 2px 2px 0"}}/>
                <div style={{padding:"16px 16px 16px 18px"}}>
                  <div style={{display:"flex", alignItems:"center", gap:12, marginBottom:10}}>
                    <div style={{width:40, height:40, background:d.acento, borderRadius:10,
                      display:"flex", alignItems:"center", justifyContent:"center",
                      flexShrink:0, border:`1px solid ${d.color}30`}}>
                      <AxisIcon name={d.iconName} size={20} color={d.color} withBackdrop={false} strokeWidth={2.5}/>
                    </div>
                    <div style={{flex:1, minWidth:0}}>
                      <div style={{fontWeight:700, fontSize:isMobile?13:14, color:"#0F172A",
                        lineHeight:1.3, marginBottom:2}}>{d.nombre}</div>
                      <div style={{fontSize:11, color:"#9CA3AF"}}>{d.sectores}</div>
                    </div>
                  </div>
                  <p style={{fontSize:13, color:T_LIGHT.textInkSoft, lineHeight:1.7, margin:"0 0 12px"}}>{d.desc}</p>
                  <button onClick={() => setContratoSeleccionado(d.id)}
                    style={{width:"100%", background:`linear-gradient(135deg,${d.color},${d.color}CC)`,
                      border:"none", borderRadius:10, padding:"13px",
                      cursor:"pointer", fontSize:14, fontWeight:700, color:"white",
                      boxShadow:`0 4px 16px ${d.color}40`}}>
                    ✍️ Generar documento →
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ── Categoría: Títulos de crédito ── */}
        <div style={{marginTop:34}}>
          <div style={{display:"flex", alignItems:"center", gap:10, margin:"0 0 6px"}}>
            <div style={{width:4, height:22, background:"#92400E", borderRadius:2, flexShrink:0}}/>
            <h3 style={{fontFamily:fontSerif, fontSize:isMobile?16:19, color:T_LIGHT.textInk, margin:0}}>Títulos de crédito</h3>
          </div>
          <p style={{fontSize:13, color:T_LIGHT.textInkSoft, margin:"0 0 14px", lineHeight:1.6, paddingLeft:14}}>
            Documentos para respaldar deudas y pagos conforme a la Ley General de Títulos y Operaciones de Crédito.
          </p>
          <div style={{background:"white", borderRadius:14, overflow:"hidden",
            border:"1px solid rgba(146,64,14,0.30)", position:"relative" as const,
            boxShadow:"0 2px 8px rgba(22,36,71,0.06)"}}>
            <div style={{position:"absolute" as const, left:0, top:0, bottom:0, width:3,
              background:"#92400E", borderRadius:"0 2px 2px 0"}}/>
            <div style={{padding:"16px 16px 16px 18px", display:"flex", alignItems:"center", gap:12}}>
              <div style={{width:40, height:40, background:"rgba(146,64,14,0.08)", borderRadius:10,
                display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0,
                border:"1px solid rgba(146,64,14,0.20)"}}>
                <AxisIcon name="document" size={20} color="#92400E" withBackdrop={false} strokeWidth={2.5}/>
              </div>
              <div style={{flex:1, minWidth:0}}>
                <div style={{fontWeight:700, fontSize:isMobile?13:14, color:"#0F172A", lineHeight:1.3, marginBottom:2}}>Pagaré</div>
                <div style={{fontSize:12, color:T_LIGHT.textInkSoft, lineHeight:1.5}}>Título de crédito para documentar una deuda con fecha y monto de pago.</div>
              </div>
              <span style={{fontSize:9, fontWeight:700, padding:"3px 8px", borderRadius:10,
                background:"rgba(5,150,105,0.1)", color:"#059669",
                border:"1px solid rgba(5,150,105,0.25)", whiteSpace:"nowrap" as const, flexShrink:0}}>
                ✓ Disponible
              </span>
            </div>
            <div style={{padding:"0 16px 16px 18px"}}>
              <button onClick={() => setContratoSeleccionado("pagare")}
                style={{width:"100%", background:"linear-gradient(135deg,#92400E,#92400ECC)",
                  border:"none", borderRadius:10, padding:"13px", cursor:"pointer",
                  fontSize:14, fontWeight:700, color:"white", fontFamily:fontSans,
                  boxShadow:"0 4px 16px rgba(146,64,14,0.25)"}}>
                ✍️ Generar pagaré →
              </button>
            </div>
          </div>
        </div>

        {/* Aviso legal */}
        <div style={{marginTop:24, padding:"16px 20px",
          background:"rgba(239,68,68,0.06)",
          border:"1px solid rgba(239,68,68,0.30)",
          borderRadius:12,
          boxShadow:T_LIGHT.shadow}}>
          <div style={{display:"flex", alignItems:"flex-start", gap:12}}>
            <span style={{fontSize:22, flexShrink:0, marginTop:2}}>⚠️</span>
            <div>
              <div style={{fontSize:14, fontWeight:700, color:T_LIGHT.danger, marginBottom:4}}>
                Aviso importante
              </div>
              <p style={{margin:0, fontSize:13, color:T_LIGHT.textInkSoft, lineHeight:1.75, fontWeight:400}}>
                Este contrato es un modelo general conforme a la LFT vigente. Cada relación laboral puede tener particularidades. Se recomienda revisión por parte de AXIS Asesoría Legal antes de firmar.
              </p>
              <div style={{marginTop:8, fontSize:13, fontWeight:700, color:T_LIGHT.danger}}>
                📞 449 425 11 28 · axislegalags.com
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}


function SectionServicios({title, children, fontSerif, isMobile}: {title:string; children:React.ReactNode; fontSerif:string; isMobile:boolean}) {
  return (
    <div style={{marginBottom:18}}>
      <div style={{fontFamily:fontSerif, fontSize:14, fontWeight:700, color:"#0F172A",
        marginBottom:10, paddingBottom:6, borderBottom:"1px solid rgba(184,147,42,0.3)",
        display:"flex", alignItems:"center", gap:8}}>
        <AxisIcon name="briefcase" size={14} color="#B8932A" withBackdrop={false} strokeWidth={3}/>
        {title}
      </div>
      <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr":"1fr 1fr", gap:10}}>
        {children}
      </div>
    </div>
  );
}

// #region DOCUMENTOS LEGALES (Aviso de Privacidad + Consentimiento Informado)
// ─────────────────────────────────────────────────────────────────────────────
// Dos tipos NUEVOS del generador, con el mismo flujo que los contratos:
// generar PDF (modo HTML → generarPDFDesdeHTML) → descargar → "Guardar y vincular".
// Props opcionales:
//   • prefill     → valores iniciales del formulario (lanzado desde un expediente)
//   • entidadFija → vincula el PDF SIEMPRE a ese registro (oculta el selector)
// El texto es un BORRADOR de referencia (requiere revisión legal). En el
// Consentimiento Informado, PROCEDIMIENTO/RIESGOS/BENEFICIOS/ALTERNATIVAS son
// campos LIBRES que llena el profesional (deben ser específicos del caso).
// ─────────────────────────────────────────────────────────────────────────────

// Encabezado y pie comunes a ambos documentos (igual a los contratos, para que
// todos los PDF generados se vean uniformes).
//
// EL BANNER DE BORRADOR SE RETIRÓ. Sus estilos seguían aquí sin que nada los
// usara, y con ellos la tentación de volver a pintarlo: un contrato que dos
// partes firman no puede llevar impreso que es un borrador. Eso no es una
// advertencia, es una declaración en contra del propio instrumento, y le sirve
// a la contraparte el argumento de que no era el acuerdo definitivo. La
// protección la da la leyenda del pie —"a partir de un formato de uso general…
// no constituye asesoría jurídica sobre el caso concreto"—, que dice lo mismo
// sin llamar borrador a un documento firmado. Las advertencias van en la
// PANTALLA donde se genera; ahí siguen las once.
// ═══ EL MEMBRETE ES DEL PATRÓN, NO DE LA PLATAFORMA ═════════════════════════
// Estos documentos los emite el patrón: los firma él y responden de su
// operación. Llevaban en la cabecera el logo, la razón social y la ciudad de
// AXIS Asesoría Legal Corporativa, y en el pie su dominio, su teléfono y su
// domicilio. En un recibo de nómina AXIS al menos es el proveedor del patrón;
// en un arrendamiento entre el patrón y su casero, AXIS no es parte de nada y
// aparecía en la cabecera de un documento que nunca redactó.
//
// La ÚNICA mención permitida es a la plataforma, en el pie y en letra chica: el
// documento lo genera el patrón, con una herramienta.
// QUÉ DICE EL MEMBRETE, separado de CÓMO se pinta. Las mismas tres líneas y en el
// mismo orden las necesitan dos motores distintos: el HTML de los contratos y las
// constancias, y el jsPDF de los dos documentos de Empleados. Escritas dos veces
// se separarían a la primera edición —es exactamente el defecto que arregla esta
// rama en el cálculo—, así que se definen UNA vez aquí y cada motor las dibuja.
//
// SIN DATOS NO SE INVENTA UNA IDENTIDAD: devuelve null y el llamador no imprime
// nada. Ese hueco lo llenaba el membrete de AXIS; vacío es la verdad, y el
// documento se identifica por su propio título.
function lineasMembretePatron(d: DatosPatron | null | undefined): {denominacion:string; rfc:string; domicilio:string} | null {
  const dp = d || DATOS_PATRON_VACIOS;
  if (!dp.denominacion) return null;
  return {
    denominacion: dp.denominacion,
    rfc: dp.rfc ? `RFC ${dp.rfc}` : "",
    domicilio: domicilioPatronTexto(dp) || "",
  };
}
function membreteDelPatron(d: DatosPatron | null | undefined): string {
  const m = lineasMembretePatron(d);
  if (!m) return "";
  return `
    <div style="font-family:Arial,sans-serif;">
      <div style="font-size:16px;font-weight:800;color:#0F172A;">${_escHtml(m.denominacion)}</div>
      ${m.rfc ? `<div style="font-size:10.5px;color:#162447;margin-top:3px;">${_escHtml(m.rfc)}</div>` : ""}
      ${m.domicilio ? `<div style="font-size:10px;color:#6B7CB8;margin-top:2px;max-width:340px;line-height:1.45;">${_escHtml(m.domicilio)}</div>` : ""}
    </div>`;
}
// Parte un texto al ancho dado evitando que el ÚLTIMO renglón quede en muñón.
// Devuelve las líneas ya listas para pintar. Si el texto cabe entero, devuelve una.
function _partirSinHuerfanos(doc:any, texto:string, ancho:number): string[] {
  const normal: string[] = doc.splitTextToSize(texto, ancho);
  if (normal.length <= 1) return normal;
  const esMunon = (ls:string[]) => doc.getTextWidth(ls[ls.length - 1]) < ancho * 0.35;
  if (!esMunon(normal)) return normal;
  // Se estrecha en pasos: al repartir en menos ancho, la última línea se llena.
  for (const factor of [0.92, 0.85, 0.78, 0.7, 0.62]) {
    const cand: string[] = doc.splitTextToSize(texto, ancho * factor);
    if (cand.length === normal.length && !esMunon(cand)) return cand;
  }
  return normal;
}

// El MISMO membrete, dibujado con jsPDF. No es una cabecera nueva: son las líneas
// de `lineasMembretePatron`, en su orden, con la jerarquía de tamaños del HTML.
// Devuelve la Y por debajo de la última línea para que el llamador siga su cursor.
function membreteDelPatronJsPDF(doc:any, x:number, y:number, d: DatosPatron|null|undefined, anchoDom:number): number {
  const m = lineasMembretePatron(d);
  if (!m) return y;
  doc.setFont("helvetica","bold"); doc.setFontSize(12); doc.setTextColor(15, 23, 42);
  doc.text(m.denominacion, x, y);
  let cur = y + 4.6;
  doc.setFont("helvetica","normal");
  if (m.rfc) {
    doc.setFontSize(8.5); doc.setTextColor(22, 36, 71);
    doc.text(m.rfc, x, cur); cur += 3.7;
  }
  if (m.domicilio) {
    doc.setFontSize(8); doc.setTextColor(107, 124, 184);
    // `doc.text` no parte líneas: un domicilio largo se saldría de la hoja. Misma
    // regla que la leyenda de los contratos, y por el mismo susto.
    //
    // Y SIN HUÉRFANOS. Partido a lo ancho a secas, un domicilio de Aguascalientes
    // dejaba "C.P. 20120" solo en la segunda línea: técnicamente cabía, pero se
    // lee como un dato suelto pegado al margen, no como el final de la dirección.
    // Se prueban anchos cada vez más estrechos y se elige el primero cuyo último
    // renglón no sea un muñón; si ninguno lo consigue, se queda el reparto normal,
    // que al menos no se sale de la hoja. Todas las líneas arrancan en la misma x.
    const lineas: string[] = _partirSinHuerfanos(doc, m.domicilio, anchoDom);
    lineas.forEach((ln:string, i:number) => doc.text(ln, x, cur + i * 3.2));
    cur += lineas.length * 3.2;
  }
  return cur;
}
// ═══ EN UN CONTRATO DE DOS PARTES, ¿CUÁL SOY YO? ════════════════════════════
// La plataforma no lo sabe y NO lo adivina. En el contrato individual de trabajo
// el patrón siempre es el patrón, así que ahí se prellena directo; pero en un
// contrato de servicios el usuario puede ser el prestador o el cliente, y en una
// compraventa el vendedor o el comprador. Meter sus datos de un lado sin
// preguntar es firmar en el lado equivocado.
//
// Por eso el control arranca SIN NINGUNA OPCIÓN MARCADA. Al elegir, se rellenan
// los campos de esa parte —los que existan en ese contrato— y siguen editables,
// como todo lo demás: un contrato lo puede celebrar otra razón social del grupo.
// `declaraPersonaFisica` marca las partes cuyo texto dice "Ser persona física
// mayor de edad, identificándose con credencial de elector" SIN que el formulario
// ofrezca cambiarlo. Meter ahí una razón social hace que el contrato afirme lo
// contrario de lo que firma quien lo firma.
type ParteDeContrato = {clave: string; etiqueta: string; nombre?: string; rfc?: string; domicilio?: string; declaraPersonaFisica?: boolean};
function SelectorDeMiParte({partes, elegida, onElegir, tipoPersona, fontSans, fontSerif}:{
  partes: ParteDeContrato[]; elegida: string; onElegir:(clave:string)=>void;
  tipoPersona: ""|"fisica"|"moral"; fontSans:string; fontSerif:string;
}) {
  const opciones = [...partes, {clave:"", etiqueta:"No usarlos"} as ParteDeContrato];
  const parteElegida = partes.find(p => p.clave === elegida);
  // Se avisa cuando el formato declara persona física y la empresa NO lo es, y
  // TAMBIÉN cuando no se sabe qué es: la ausencia del dato no se lee como
  // "física". Sin esto, el aviso solo protegería a quien ya capturó el campo.
  const avisar = !!parteElegida?.declaraPersonaFisica && tipoPersona !== "fisica";
  return (
    <div style={{background:"rgba(35,100,120,0.06)", border:"1px solid rgba(35,100,120,0.24)",
      borderRadius:12, padding:"13px 15px", marginBottom:16}}>
      <div style={{fontFamily:fontSerif, fontSize:13.5, fontWeight:700, color:"#1B4F5F", marginBottom:3}}>
        Usar los datos de mi empresa como:
      </div>
      <div style={{fontSize:11.5, color:"#2A5C6B", marginBottom:10, lineHeight:1.5}}>
        Este contrato tiene dos partes y la plataforma no sabe de qué lado estás. Elige tú, y luego edita lo que haga falta.
      </div>
      <div style={{display:"flex", gap:16, flexWrap:"wrap" as const}}>
        {opciones.map(o => (
          <label key={o.clave || "ninguna"} style={{display:"flex", alignItems:"center", gap:7, cursor:"pointer", fontSize:13, color:"#0B1829", fontFamily:fontSans}}>
            <input type="radio" checked={elegida === o.clave} onChange={()=>onElegir(o.clave)}
              style={{width:16, height:16, accentColor:"#236478", cursor:"pointer"}}/>
            {o.etiqueta}
          </label>
        ))}
      </div>
      {avisar && (
        <div style={{marginTop:11, background:"rgba(184,147,42,0.12)", border:"1px solid rgba(184,147,42,0.36)",
          borderRadius:9, padding:"10px 12px", fontSize:12, color:"#5A4A18", lineHeight:1.6}}>
          <b style={{color:"#7A5F12"}}>Revisa las declaraciones antes de firmar.</b>{" "}
          Este formato declara que {parteElegida?.etiqueta?.toLowerCase()} es <b>persona física mayor de edad</b> y se identifica con credencial de elector.
          {tipoPersona === "moral"
            ? " Tu empresa es persona moral, así que esa declaración no le corresponde: edítala para que diga que es una sociedad y quién la representa."
            : " No has capturado si tu empresa es persona física o moral, así que no se puede saber si esa declaración le corresponde. Captúralo en Datos de mi empresa, o edita las declaraciones a mano."}
        </div>
      )}
    </div>
  );
}
// Rellena los campos de la parte elegida y VACÍA los de la otra si los había
// puesto este mismo control: cambiar de lado no puede dejar tus datos en las dos
// partes del contrato.
function aplicarMiParte(form: any, partes: ParteDeContrato[], clave: string, d: DatosPatron): any {
  const out = {...form};
  const dom = domicilioPatronTexto(d);
  for (const p of partes) {
    const mia = p.clave === clave;
    if (p.nombre)    out[p.nombre]    = mia ? d.denominacion : (form[p.nombre]    === d.denominacion ? "" : form[p.nombre]);
    if (p.rfc)       out[p.rfc]       = mia ? d.rfc          : (form[p.rfc]       === d.rfc          ? "" : form[p.rfc]);
    if (p.domicilio) out[p.domicilio] = mia ? dom            : (form[p.domicilio] === dom            ? "" : form[p.domicilio]);
  }
  return out;
}

// EL PIE, IDÉNTICO EN LOS DIECISIETE DOCUMENTOS. Si alguna vez vuelven a
// divergir, será porque alguien escribió el suyo en vez de llamar aquí.
// SIN DENOMINACIÓN, LA FRASE NO SE ESCRIBE A MEDIAS. Misma regla que la
// cabecera vacía. Importa sobre todo en la Calculadora LFT, que es PÚBLICA: un
// visitante sin sesión genera su finiquito y no tiene denominación que poner.
// La cláusula "por {x}" desaparece entera; no queda un hueco entre "por" y
// "mediante".
// LA FRASE EN CRUDO. La necesitan tres consumidores: el HTML (que la escapa), el
// jsPDF de Empleados (que NO debe escaparla: en un PDF "&amp;" se lee "&amp;") y
// cualquiera que la quiera medir. Se define aquí una vez y `pieDelPatron` es solo
// su versión escapada.
function pieDelPatronTexto(d: DatosPatron | null | undefined, generadoEn: string, marca?: string): string {
  const quien = (d && d.denominacion) ? d.denominacion : "";
  const cabeza = quien
    ? `Generado por ${quien} mediante la plataforma AXIS Legaltech`
    : "Generado con la plataforma AXIS Legaltech";
  return `${cabeza} · ${generadoEn}${marca ? " · " + marca : ""}`;
}
function pieDelPatron(d: DatosPatron | null | undefined, generadoEn: string, marca?: string): string {
  return _escHtml(pieDelPatronTexto(d, generadoEn, marca));
}
// REPARTE VARIOS TEXTOS A LO ANCHO, MIDIÉNDOLOS. Sustituye a las columnas fijas:
// una x escrita a mano vale mientras nadie alargue el texto de la izquierda, y en
// cuanto alguien lo alarga la línea se pisa sin avisar —no hay error, no hay
// hueco: la segunda frase empieza encima de la primera y el papel sale así—.
//
// Si no caben en un renglón con un hueco mínimo digno, los APILA en vez de
// encogerlos: un renglón con tres cosas ilegibles es peor que tres renglones.
// Devuelve la Y de la última línea escrita, para que el llamador siga su cursor.
const _HUECO_MIN_MM = 6;
function repartirEnRenglonJsPDF(doc:any, textos:string[], x:number, y:number, ancho:number, alto:number): number {
  const usables = textos.filter(t => !!t);
  if (usables.length === 0) return y;
  const anchos = usables.map(t => doc.getTextWidth(t));
  const suma = anchos.reduce((a:number, b:number) => a + b, 0);
  if (usables.length > 1 && suma + _HUECO_MIN_MM * (usables.length - 1) <= ancho) {
    const hueco = (ancho - suma) / (usables.length - 1);
    let cur = x;
    usables.forEach((t, i) => { doc.text(t, cur, y); cur += anchos[i] + hueco; });
    return y;
  }
  usables.forEach((t, i) => doc.text(t, x, y + i * alto));
  return y + (usables.length - 1) * alto;
}

// El pie del patrón en jsPDF, CRECIENDO HACIA ARRIBA desde `yBase`: así, por
// larga que sea la denominación, el bloque nunca se sale por abajo de la hoja.
// Mismo mecanismo que `pintarLeyendaContrato`, y por la misma razón.
function pintarPieDelPatronJsPDF(doc:any, x:number, yBase:number, ancho:number, d: DatosPatron|null|undefined, generadoEn:string): void {
  const lineas: string[] = doc.splitTextToSize(pieDelPatronTexto(d, generadoEn), ancho);
  const alto = 3.1;
  lineas.forEach((ln:string, i:number) => doc.text(ln, x, yBase - (lineas.length - 1 - i) * alto));
}

// `opts` se conserva por las tres llamadas existentes; el logo de AXIS ya no
// entra por ninguna vía.
function _docLegalHead(vFechaGen:string, opts?:{logo?:boolean}, datosPatron?: DatosPatron|null) {
  // SIN DENOMINACIÓN, EL BLOQUE ENTERO NO SE IMPRIME y el documento arranca en
  // su contenido. Una cabecera vacía con sus líneas se lee como un error;
  // ausente, no: muchos contratos legítimos no llevan membrete. La fecha de
  // generación viaja en el pie, así que aquí no se pierde nada.
  const membrete = membreteDelPatron(datosPatron);
  if (!membrete) return "";
  return `
  <div class="header-axis">
    ${membrete}
    <div style="text-align:right;font-family:Arial,sans-serif;font-size:10px;color:#9A9AAA;">
      Generado el ${vFechaGen}
    </div>
  </div>`;
}
function _docLegalFooter(datosPatron?: DatosPatron|null, generadoEn?: string) {
  // SIN <script>window.print()</script>: el Aviso de Privacidad y el
  // Consentimiento Informado se generan como PDF descargable vía
  // generarPDFDesdeHTML (html2canvas + jsPDF), igual que los contratos.
  // Así NO se abre el diálogo de impresión del navegador ni se añaden
  // URL/fecha/número de página al documento.
  //
  // Aquí iba el dominio, el teléfono y el domicilio del despacho. Y "Se
  // recomienda revisión jurídica antes de su uso", que también se fue: mismo
  // caso que "borrador de referencia". Un pagaré es un título EJECUTIVO; que
  // lleve impreso que le falta revisión lo debilita solo, y se lo dice justo a
  // quien podría querer atacarlo. La advertencia vive en la PANTALLA donde se
  // genera, que ya la da y con más detalle.
  return `
  <div class="footer">
    ${pieDelPatron(datosPatron, generadoEn || fechaHoraLargaAxis())}
  </div>`;
}
const _DOC_LEGAL_CSS = `
  * { box-sizing:border-box; margin:0; padding:0; }
  body { font-family:'Times New Roman', serif; color:#1A1A2E; padding:55px 65px; font-size:12.5px; line-height:1.85; background:white; text-align:justify; }
  .encabezado { font-size:15px; font-weight:bold; text-align:center; text-transform:uppercase; margin-bottom:22px; line-height:1.5; }
  .seccion-titulo { font-weight:bold; text-transform:uppercase; text-align:center; font-size:13px; margin:24px 0 12px; letter-spacing:0.5px; }
  .clausula { margin-bottom:15px; }
  .clausula-titulo { font-weight:bold; text-transform:uppercase; font-size:12.5px; display:inline; }
  .firmas { margin-top:55px; display:grid; grid-template-columns:1fr 1fr; gap:60px; }
  .firma-bloque { text-align:center; }
  .firma-linea { border-top:1px solid #1A1A2E; margin-bottom:8px; }
  .header-axis { display:flex; justify-content:space-between; align-items:center; margin-bottom:30px; padding-bottom:14px; border-bottom:2px solid #B8932A; }
  .nota-legal { margin-top:20px; padding:14px 16px; background:#FFF8F0; border:1px solid #F0D080; border-radius:8px; font-size:11px; font-family:Arial,sans-serif; color:#6B5A3A; line-height:1.6; }
  .footer { text-align:center; margin-top:36px; padding-top:14px; border-top:1px solid #ddd; font-size:10px; color:#9A9AAA; font-family:Arial,sans-serif; }
  @media print { body { padding:40px 50px; } }`;

// ─── DOCUMENTO: AVISO DE PRIVACIDAD (LFPDPPP) ────────────────────────────────
function FormAvisoPrivacidad({user, tipoContrato, onBack, fontSans, fontSerif, gold, prefill, entidadFija}: {
  user:any; tipoContrato:string; onBack:()=>void; fontSans:string; fontSerif:string; gold:string;
  prefill?: Record<string,any>;
  entidadFija?: {tipo:"cliente"|"paciente"|"empleado"|"proveedor"|"deudor"; id:string; nombre:string};
}) {
  // El membrete de la cabecera y la firma del pie: el patron, no la plataforma.
  const datosPatron = useDatosPatron(user?.uid).datos;
  const isMobile = window.innerWidth < 768;
  const COLOR = "#4C5BAA";
  const [form, setForm] = useState({
    ciudad:"Aguascalientes, Ags.",
    fecha:"",
    responsableNombre:"",
    responsableRFC:"",
    responsableDomicilio:"",
    responsableCorreo:"",
    responsableTelefono:"",
    datosIdentificacion:"Nombre completo, domicilio, teléfono, correo electrónico y RFC.",
    datosSensibles:false,
    datosSensiblesDetalle:"Datos sobre el estado de salud físico y/o mental.",
    finalidadesPrimarias:"",
    finalidadesSecundarias:"",
    transferencias:"",
    mediosARCO:"",
    titularNombre:"",
    ...(prefill||{}),
  });

  // PRELLENADO desde configuracion_empresa, y EDITABLE. Aviso de privacidad. NO se bloquea: no lee configuracion para afirmar nada, y ya tiene su propio minimo de campos.
  // Se propone, no se impone; solo rellena lo que este vacio.
  useEffect(()=>{ let cancel=false; (async()=>{
    if (!user?.uid) return;
    try {
      const dpc = datosPatronDe(await leerConfigEmpresa(user.uid));
      if (cancel) return;
      const dom = domicilioPatronTexto(dpc);
      setForm((f:any)=>({...f,
        responsableNombre:    f.responsableNombre    || dpc.denominacion,
        responsableRFC:       f.responsableRFC       || dpc.rfc,
        responsableDomicilio: f.responsableDomicilio || dom,
        responsableCorreo:    f.responsableCorreo    || dpc.correoContacto,
      }));
    } catch(e){ /* sin datos capturados: el formulario se queda igual */ }
  })(); return ()=>{cancel=true;}; /* eslint-disable-next-line */ }, [user?.uid]);
  const [generando, setGenerando] = useState(false);
  const [ultimoBlob, setUltimoBlob] = useState<Blob|null>(null);
  const set = (k:string,v:any)=> setForm(p=>({...p,[k]:v}));

  const inputStyle: React.CSSProperties = {width:"100%", padding:"9px 11px", fontSize:13, fontFamily:fontSans, background:"white", border:"1px solid #D1D5DB", borderRadius:8, color:"#0F172A", boxSizing:"border-box" as const, outline:"none"};
  const labelStyle: React.CSSProperties = {display:"block", fontSize:11, fontWeight:600, color:"#374151", marginBottom:4, letterSpacing:"0.2px"};
  const camposMin = !!(form.responsableNombre && form.responsableDomicilio && form.responsableCorreo && form.finalidadesPrimarias);

  const generarPDF = async () => {
    setGenerando(true);
    const F = (v:string)=> v || "___________________________";
    // Ver la nota del contrato de trabajo: construir un Date con "AAAA-MM-DD"
    // imprime el día anterior en México.
    const hoy = fechaLargaAxis(form.fecha) || fechaLargaAxis(new Date());
    const vFechaGen = new Date().toLocaleDateString("es-MX");
    const vResp = F(form.responsableNombre);
    const vRFC = form.responsableRFC ? `, con RFC <strong>${form.responsableRFC}</strong>` : "";
    const vDom = F(form.responsableDomicilio);
    const vCorreo = F(form.responsableCorreo);
    const vTel = form.responsableTelefono ? `, teléfono ${form.responsableTelefono}` : "";
    const vArco = form.mediosARCO || form.responsableCorreo || "___________________________";
    const vDatos = F(form.datosIdentificacion);
    const vCiudad = form.ciudad || "Aguascalientes, Ags.";
    const vPrim = F(form.finalidadesPrimarias);
    const vSensiblesBlock = form.datosSensibles ? `
  <div class="clausula">
    <span class="clausula-titulo">DATOS PERSONALES SENSIBLES:</span> Para cumplir con las finalidades descritas, el Responsable también podrá tratar datos personales sensibles, en específico: ${F(form.datosSensiblesDetalle)} El Responsable se compromete a tratarlos con estricta seguridad y confidencialidad. El tratamiento de estos datos requiere su consentimiento expreso, mismo que se entiende otorgado mediante la firma del presente Aviso.
  </div>` : "";
    const vSecundariasBlock = form.finalidadesSecundarias ? `<br/><p style="margin-top:6px;"><strong>Finalidades secundarias (no necesarias para la relación):</strong> ${form.finalidadesSecundarias} Si usted no desea que sus datos personales se traten para estas finalidades adicionales, puede manifestar su negativa enviando un correo a <strong>${vCorreo}</strong> dentro de los cinco días hábiles siguientes.</p>` : "";
    const vTransfer = form.transferencias ? form.transferencias : "El Responsable no realizará transferencias de sus datos personales que requieran de su consentimiento, salvo aquellas que sean necesarias para atender requerimientos de autoridad competente o las expresamente previstas en el artículo 37 de la LFPDPPP.";
    const vTitular = form.titularNombre ? `<div style="margin-top:8px;font-size:11px;color:#555;">Aviso entregado a: <strong>${form.titularNombre}</strong></div>` : "";

    const html = `<!DOCTYPE html>
<html lang="es">
<head><meta charset="UTF-8"><title>Aviso de Privacidad</title>
<style>${_DOC_LEGAL_CSS}</style>
</head>
<body>
  ${_docLegalHead(vFechaGen, undefined, datosPatron)}

  <div class="encabezado">
    Aviso de Privacidad Integral<br/>
    <span style="font-size:11px;font-weight:normal;text-transform:none;">Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP)</span>
  </div>

  <p>En cumplimiento de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (en lo sucesivo "la Ley"), su Reglamento y los Lineamientos del Aviso de Privacidad, <strong>${vResp}</strong>${vRFC}, con domicilio en <strong>${vDom}</strong> (en lo sucesivo, "el Responsable"), hace de su conocimiento el presente Aviso de Privacidad.</p>
  <br/>

  <div class="clausula">
    <span class="clausula-titulo">1. Identidad y domicilio del Responsable:</span> El Responsable de recabar y dar tratamiento a sus datos personales es <strong>${vResp}</strong>, con domicilio en ${vDom}, correo electrónico de contacto <strong>${vCorreo}</strong>${vTel}.
  </div>

  <div class="clausula">
    <span class="clausula-titulo">2. Datos personales que se recaban:</span> Para las finalidades señaladas en el presente Aviso, el Responsable podrá recabar y tratar los siguientes datos personales: ${vDatos}
  </div>
  ${vSensiblesBlock}

  <div class="clausula">
    <span class="clausula-titulo">3. Finalidades del tratamiento:</span> Sus datos personales serán utilizados para las siguientes <strong>finalidades primarias</strong>, necesarias para la relación con el Responsable: ${vPrim}${vSecundariasBlock}
  </div>

  <div class="clausula">
    <span class="clausula-titulo">4. Transferencias de datos:</span> ${vTransfer}
  </div>

  <div class="clausula">
    <span class="clausula-titulo">5. Medios para ejercer los derechos ARCO y revocar el consentimiento:</span> Usted tiene derecho a conocer qué datos personales tenemos de usted, para qué los utilizamos y las condiciones del uso que les damos (Acceso); a solicitar la corrección de su información (Rectificación); a que la eliminemos de nuestros registros cuando considere que no se está utilizando conforme a la Ley (Cancelación); así como a oponerse al uso de sus datos para fines específicos (Oposición). Para ejercer estos derechos o revocar su consentimiento, envíe su solicitud al correo <strong>${vArco}</strong>, indicando su nombre, el derecho que desea ejercer y acompañando copia de su identificación. El Responsable dará respuesta en los plazos que marca la Ley.
  </div>

  <div class="clausula">
    <span class="clausula-titulo">6. Limitación del uso o divulgación:</span> Usted puede solicitar al Responsable, en el correo antes señalado, que limite el uso o divulgación de sus datos personales conforme a la Ley.
  </div>

  <div class="clausula">
    <span class="clausula-titulo">7. Cambios al Aviso de Privacidad:</span> El presente Aviso podrá sufrir modificaciones o actualizaciones. Cualquier cambio será comunicado a través de los medios que el Responsable tenga disponibles.
  </div>

  <div class="clausula">
    <span class="clausula-titulo">8. Consentimiento del titular:</span> Manifiesto que he leído y comprendido el presente Aviso de Privacidad y otorgo mi consentimiento para el tratamiento de mis datos personales${form.datosSensibles ? ", incluyendo los datos personales sensibles antes señalados," : ""} en los términos aquí expresados.
  </div>

  <div class="nota-legal">
    <strong>Fundamento legal:</strong> Arts. 8, 15, 16, 17, 22, 28 y 36 de la LFPDPPP · Lineamientos del Aviso de Privacidad (INAI).
  </div>

  <div class="firmas">
    <div class="firma-bloque">
      <div style="height:60px;"></div>
      <div class="firma-linea"></div>
      <strong>EL TITULAR</strong><br/>
      <span style="font-size:11px;color:#555;">Nombre y firma</span>
      ${vTitular}
    </div>
    <div class="firma-bloque">
      <div style="height:60px;"></div>
      <div class="firma-linea"></div>
      <strong>EL RESPONSABLE</strong><br/>
      ${vResp}<br/>
      <span style="font-size:11px;color:#555;">Fecha: ${hoy} · ${vCiudad}</span>
    </div>
  </div>

  ${_docLegalFooter(datosPatron)}
</body>
</html>`;

    try {
      const fname = "Aviso_Privacidad_" + (form.responsableNombre||"borrador").replace(/[^A-Za-z0-9]/g,"_") + ".pdf";
      const pdfBlob = await generarPDFDesdeHTML(html, fname);
      setUltimoBlob(pdfBlob);
    } catch(e){ console.error(e); alert("No se pudo generar el PDF. Intenta de nuevo."); }
    finally { setGenerando(false); }
  };

  return (
    <div {...ZONA_DE_CAPTURA} style={{minHeight:"100vh", background:T_LIGHT.canvas, fontFamily:fontSans}}>
      <div style={{background:`linear-gradient(135deg,${COLOR},${COLOR}CC)`, padding:"0 20px", height:58, display:"flex", alignItems:"center", gap:12, position:"sticky" as const, top:0, zIndex:100, boxShadow:`0 4px 20px ${COLOR}4D`}}>
        <button onClick={onBack} style={{background:"rgba(255,255,255,0.18)", border:"1px solid rgba(255,255,255,0.30)", color:"white", borderRadius:8, padding:"5px 11px", cursor:"pointer", fontSize:12, fontWeight:600}}>← {entidadFija ? "Volver" : "Generador legal"}</button>
        <span style={{color:"white", fontWeight:700, fontSize:isMobile?12:14, display:"flex", alignItems:"center", gap:8}}>
          <AxisIcon name="document" size={18} tone="white" withBackdrop={false} strokeWidth={2.5}/>
          Aviso de Privacidad (LFPDPPP)
        </span>
      </div>

      <div style={{maxWidth:760, margin:"0 auto", padding:isMobile?"16px":"24px"}}>
        <p style={{fontSize:12, color:"#64748B", margin:"0 0 18px", lineHeight:1.6}}>
          Genera el Aviso de Privacidad que tu negocio entrega a sus clientes o pacientes. Se llena con los datos de tu empresa (el responsable). Los campos con <span style={{color:"#DC2626"}}>*</span> son indispensables.
        </p>

        <SectionServicios title="Datos del responsable (tu empresa)" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Nombre o razón social <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" style={inputStyle} value={form.responsableNombre} onChange={e=>set("responsableNombre",e.target.value)} placeholder="Mi Empresa S.A. de C.V. / Dr. Juan Pérez"/>
          </div>
          <div>
            <label style={labelStyle}>RFC (opcional)</label>
            <input autoComplete="off" style={inputStyle} value={form.responsableRFC} onChange={e=>set("responsableRFC",e.target.value)} placeholder="RFC con homoclave"/>
          </div>
          <div>
            <label style={labelStyle}>Teléfono (opcional)</label>
            <input autoComplete="off" style={inputStyle} value={form.responsableTelefono} onChange={e=>set("responsableTelefono",e.target.value)} placeholder="449 123 4567"/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Domicilio <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" style={inputStyle} value={form.responsableDomicilio} onChange={e=>set("responsableDomicilio",e.target.value)} placeholder="Calle, número, colonia, ciudad"/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Correo de contacto (para derechos ARCO) <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" style={inputStyle} value={form.responsableCorreo} onChange={e=>set("responsableCorreo",e.target.value)} placeholder="datos@tuempresa.com"/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Correo para ejercer ARCO (si es distinto al de contacto)</label>
            <input autoComplete="off" style={inputStyle} value={form.mediosARCO} onChange={e=>set("mediosARCO",e.target.value)} placeholder="Déjalo vacío para usar el correo de contacto"/>
          </div>
        </SectionServicios>

        <SectionServicios title="Datos y finalidades" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Datos personales que recabas</label>
            <textarea autoComplete="off" style={{...inputStyle, minHeight:55, resize:"vertical" as const}} value={form.datosIdentificacion} onChange={e=>set("datosIdentificacion",e.target.value)} placeholder="Nombre, domicilio, teléfono, correo, RFC..."/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1", padding:"10px 12px", background:`${COLOR}0D`, borderRadius:8, border:`1px solid ${COLOR}33`}}>
            <label style={{display:"flex", alignItems:"flex-start", gap:8, cursor:"pointer", fontSize:12, color:"#374151"}}>
              <input autoComplete="off" type="checkbox" checked={form.datosSensibles} onChange={e=>set("datosSensibles",e.target.checked)} style={{marginTop:2}}/>
              <div>
                <strong>Trato datos personales sensibles</strong>
                <div style={{fontSize:10.5, color:"#64748B", marginTop:2, lineHeight:1.4}}>Marca esta casilla si recabas datos de salud, origen étnico, creencias, etc. (común en consultorios médicos). Requiere consentimiento expreso.</div>
              </div>
            </label>
          </div>
          {form.datosSensibles && (
            <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
              <label style={labelStyle}>¿Qué datos sensibles tratas?</label>
              <input autoComplete="off" style={inputStyle} value={form.datosSensiblesDetalle} onChange={e=>set("datosSensiblesDetalle",e.target.value)} placeholder="Datos sobre el estado de salud físico y/o mental"/>
            </div>
          )}
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Finalidades primarias (para qué usas los datos) <span style={{color:"#DC2626"}}>*</span></label>
            <textarea autoComplete="off" style={{...inputStyle, minHeight:60, resize:"vertical" as const}} value={form.finalidadesPrimarias} onChange={e=>set("finalidadesPrimarias",e.target.value)} placeholder="Brindar el servicio contratado, facturación, contacto, seguimiento, cumplir obligaciones legales..."/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Finalidades secundarias (opcional)</label>
            <textarea autoComplete="off" style={{...inputStyle, minHeight:50, resize:"vertical" as const}} value={form.finalidadesSecundarias} onChange={e=>set("finalidadesSecundarias",e.target.value)} placeholder="Envío de promociones, encuestas de satisfacción..."/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Transferencias de datos (opcional)</label>
            <textarea autoComplete="off" style={{...inputStyle, minHeight:50, resize:"vertical" as const}} value={form.transferencias} onChange={e=>set("transferencias",e.target.value)} placeholder="Déjalo vacío si no transfieres datos a terceros."/>
          </div>
        </SectionServicios>

        <SectionServicios title="Documento" fontSerif={fontSerif} isMobile={isMobile}>
          <div>
            <label style={labelStyle}>Ciudad</label>
            <input autoComplete="off" style={inputStyle} value={form.ciudad} onChange={e=>set("ciudad",e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Fecha</label>
            <input autoComplete="off" type="date" style={inputStyle} value={form.fecha} onChange={e=>set("fecha",e.target.value)}/>
          </div>
          {!entidadFija && (
            <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
              <label style={labelStyle}>Nombre del titular (a quién se lo entregas, opcional)</label>
              <input autoComplete="off" style={inputStyle} value={form.titularNombre} onChange={e=>set("titularNombre",e.target.value)} placeholder="Cliente o paciente"/>
            </div>
          )}
        </SectionServicios>

        <div style={{background:`${COLOR}1A`, border:`1px solid ${COLOR}4D`, borderRadius:10, padding:"12px 14px", marginBottom:18, display:"flex", gap:10}}>
          <AxisIcon name="scale_simple" size={16} tone="gold" withBackdrop={false} strokeWidth={3}/>
          <div style={{fontSize:11.5, color:"#374151", lineHeight:1.5}}>
            <strong>Borrador de referencia.</strong> Plantilla conforme a la LFPDPPP. Ajústala a tu operación real; para mayor certeza jurídica, valídala con AXIS Asesoría Legal Corporativa.
          </div>
        </div>

        <button onClick={generarPDF} disabled={generando || !camposMin}
          style={{width:"100%", padding:"14px", borderRadius:10,
            background: camposMin ? `linear-gradient(135deg,${COLOR},${COLOR}CC)` : "#9CA3AF",
            border:"none", color:"white", fontSize:15, fontWeight:700,
            cursor: camposMin ? "pointer" : "not-allowed",
            boxShadow: camposMin ? `0 4px 16px ${COLOR}59` : "none",
            display:"flex", alignItems:"center", justifyContent:"center", gap:10, fontFamily:fontSans}}>
          <AxisIcon name="document" size={16} tone="white" withBackdrop={false} strokeWidth={3}/>
          {generando ? "Generando documento..." : "Generar Aviso de Privacidad en PDF"}
        </button>

        {!camposMin && (
          <p style={{fontSize:11, color:"#DC2626", margin:"8px 0 0", textAlign:"center" as const}}>
            Completa los campos marcados con <strong>*</strong> para generar el documento.
          </p>
        )}
        {ultimoBlob && (
          <div style={{marginTop:14, padding:"14px 16px", background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:12, display:"flex", justifyContent:"space-between", alignItems:"center", gap:12, flexWrap:"wrap" as const}}>
            <div style={{fontSize:12, color:T_LIGHT.textInkSoft, flex:1, minWidth:160}}>{entidadFija ? `¿Guardar este Aviso en el expediente de ${entidadFija.nombre}?` : "¿Quieres guardar este documento en un expediente?"}</div>
            <BotonGuardarYVincular
              user={user}
              tipoContrato={tipoContrato}
              getPDFBlob={async () => ultimoBlob!}
              nombrePDFBase="Aviso_Privacidad"
              entidadFija={entidadFija}
              fontSans={fontSans} fontSerif={fontSerif} gold={gold}
            />
          </div>
        )}
      </div>
    </div>
  );
}

// ─── PAGARÉ: helpers compartidos (monto en letra + plantilla HTML) ───────────
// _construirPagareHTML recibe un objeto con la MISMA forma que el estado del
// formulario de pagaré y devuelve el HTML del documento. Lo usan FormPagare (un
// pagaré) y la generación de SERIE desde Créditos, para NO duplicar la plantilla
// ni la lógica del PDF. _numeroALetras/_pesosEnLetra reusan la misma conversión
// a letras que el resto de los documentos del generador.
function _numeroALetras(n: number): string {
  const unidades = ["","UN","DOS","TRES","CUATRO","CINCO","SEIS","SIETE","OCHO","NUEVE","DIEZ","ONCE","DOCE","TRECE","CATORCE","QUINCE","DIECISEIS","DIECISIETE","DIECIOCHO","DIECINUEVE"];
  const decenas = ["","DIEZ","VEINTE","TREINTA","CUARENTA","CINCUENTA","SESENTA","SETENTA","OCHENTA","NOVENTA"];
  const centenas = ["","CIEN","DOSCIENTOS","TRESCIENTOS","CUATROCIENTOS","QUINIENTOS","SEISCIENTOS","SETECIENTOS","OCHOCIENTOS","NOVECIENTOS"];
  n = Math.floor(n);
  if (n === 0) return "CERO";
  if (n < 20) return unidades[n];
  if (n < 100) return decenas[Math.floor(n/10)] + (n%10 ? " Y " + unidades[n%10] : "");
  if (n < 1000) return centenas[Math.floor(n/100)] + (n%100 ? " " + _numeroALetras(n%100) : "");
  if (n < 10000) return unidades[Math.floor(n/1000)] + " MIL" + (n%1000 ? " " + _numeroALetras(n%1000) : "");
  if (n < 1000000) return _numeroALetras(Math.floor(n/1000)) + " MIL" + (n%1000 ? " " + _numeroALetras(n%1000) : "");
  return _numeroALetras(Math.floor(n/1000000)) + " MILLONES" + (n%1000000 ? " " + _numeroALetras(n%1000000) : "");
}
function _pesosEnLetra(n: number): string {
  const entero = Math.floor(n);
  const cent = String(Math.round((n - entero) * 100)).padStart(2, "0");
  return _numeroALetras(entero) + " PESOS " + cent + "/100";
}
function _construirPagareHTML(form: any, datosPatron?: DatosPatron|null): string {
  const F = (v:string)=> v || "___________________________";
  // La MISMA función que el resto de los documentos: aquí se imprimía "01 de
  // septiembre" y en la compraventa "1 de septiembre", dos formatos para lo
  // mismo.
  const fmtFecha = (f:string)=> fechaLargaAxis(f) || "___________________________";
  const vFechaGen = new Date().toLocaleDateString("es-MX");
  const vFolio = form.folio ? form.folio : "____________";
  const vSerie = (form.serieX && form.serieN) ? `${form.serieX} de ${form.serieN}` : "";
  // EL MONTO, CON SEPARADOR DE MILES Y CENTAVOS. Salía "$10000". En un pagaré lo
  // que se discute es justamente que el número y la letra coincidan, así que un
  // número sin formatear es munición gratis para quien lo ataque. Se usa
  // `moneyMXN`, la misma de nómina y créditos. Si lo capturado no es un número
  // se imprime tal cual: inventar una cifra sería peor.
  const _montoCrudo = String(form.montoNumero||"").replace(/[$\s,]/g, "");
  const _montoVal = parseFloat(_montoCrudo);
  const vMontoNum = Number.isFinite(_montoVal) ? moneyMXN(_montoVal).replace(/^\$/, "") : F(form.montoNumero);
  // "M.N." LO PONE LA PLANTILLA, UNA VEZ. El campo pide la cantidad en letra sin
  // él; si alguien lo escribe de todas formas —salía "DIEZ MIL PESOS M.N. M.N."—
  // se recorta antes de añadirlo. Un solo sitio decide.
  const vMontoLetra = F(String(form.montoLetra||"").trim().replace(/\s*M\.?\s*N\.?\s*$/i, "").trim() || form.montoLetra);
  // La parcialidad es dinero igual que el monto: mismo formato.
  const _parcialVal = parseFloat(String(form.montoParcialidad||"").replace(/[$\s,]/g, ""));
  const vMontoParcial = Number.isFinite(_parcialVal) ? moneyMXN(_parcialVal).replace(/^\$/, "") : F(form.montoParcialidad);
  const vBenef = F(form.beneficiario);
  const vLugarSus = F(form.lugarSuscripcion);
  const vFechaSus = fmtFecha(form.fechaSuscripcion);
  const vLugarPago = F(form.lugarPago);
  const vFechaVenc = fmtFecha(form.fechaVencimiento);
  const vIntOrd = form.interesOrdinario || "0";
  const vIntMor = form.interesMoratorio || "0";
  const vSuscNom = F(form.suscriptorNombre);
  const vSuscDom = F(form.suscriptorDomicilio);
  const vSuscId = F(form.suscriptorIdentificacion);

  const vParc = form.enParcialidades ? `
  <div class="clausula" style="margin-top:8px;">
    El pago se realizará en <strong>${F(form.numParcialidades)}</strong> parcialidades de <strong>$${vMontoParcial}</strong> cada una, con vencimientos los días <strong>${F(form.vencimientosParcialidades)}</strong>. La falta de pago de una parcialidad dará por vencido anticipadamente el total adeudado.
  </div>` : "";

  const avalBloque = (n:number, nombre:string, dom:string) => (nombre || dom) ? `
  <div style="margin-bottom:34px;">
    <div style="font-weight:bold; text-transform:uppercase; font-size:12px; margin-bottom:5px;">Aval ${n}</div>
    <div style="font-size:11.5px; margin-bottom:5px;">Por aval, garantizo solidariamente el pago de este pagaré.</div>
    <div style="font-size:12px;">Nombre: <strong>${F(nombre)}</strong> &nbsp;·&nbsp; Domicilio: ${F(dom)}</div>
    <div style="margin-top:36px; width:62%;"><div class="firma-linea"></div><span style="font-size:11px;">Firma del aval ${n}</span></div>
  </div>` : "";
  const vAval1 = avalBloque(1, form.aval1Nombre, form.aval1Domicilio);
  const vAval2 = avalBloque(2, form.aval2Nombre, form.aval2Domicilio);

  return `<!DOCTYPE html>
<html lang="es">
<head><meta charset="UTF-8"><title>Pagaré</title>
<style>${_DOC_LEGAL_CSS}</style>
</head>
<body>
  <!-- EL PAGARÉ NO LLEVA CABECERA. Ni de AXIS ni del beneficiario.
       El comentario viejo de este archivo decía "Pagaré: NADA de AXIS" y tenía
       razón; lo que faltaba era el porqué, y ahora lo sabemos: sus requisitos
       son taxativos (art. 170 LGTOC) y lo que obliga es su literalidad. Un
       membrete no forma parte del texto cambiario, no aporta nada —el
       beneficiario ya aparece en el cuerpo— y sí le da a un demandado algo de
       lo que hablar. El documento arranca en su título. -->
  <div class="encabezado">Pagaré</div>

  <div style="display:flex; justify-content:space-between; align-items:center; font-family:Arial,sans-serif; font-size:11px; margin-bottom:14px; border-bottom:1px solid #ddd; padding-bottom:8px;">
    <span><strong>Folio / Pagaré No.:</strong> ${vFolio}</span>
    ${vSerie ? `<span><strong>${vSerie}</strong></span>` : ""}
  </div>

  <div style="text-align:right; font-size:15px; font-weight:bold; margin:8px 0 18px;">Bueno por $${vMontoNum} (${vMontoLetra} M.N.)</div>

  <p>En <strong>${vLugarSus}</strong>, a <strong>${vFechaSus}</strong>.</p>
  <br/>

  <p>Por este <strong>PAGARÉ</strong> prometo incondicionalmente pagar a la orden de <strong>${vBenef}</strong> la cantidad de <strong>$${vMontoNum} (${vMontoLetra} M.N.)</strong>, en <strong>${vLugarPago}</strong>, el día <strong>${vFechaVenc}</strong>.</p>
  ${vParc}

  <div class="clausula" style="margin-top:14px;">
    <span class="clausula-titulo">Intereses:</span> esta cantidad causará intereses <strong>ordinarios</strong> a razón del <strong>${vIntOrd}% mensual</strong> desde la fecha de suscripción hasta su total liquidación. En caso de mora, causará intereses <strong>moratorios</strong> a razón del <strong>${vIntMor}% mensual</strong>.
  </div>

  <!-- AQUÍ IBA EL RECUADRO DE FUNDAMENTO, Y EN UN PAGARÉ NO VA.
       Sus requisitos son taxativos y lo que obliga es su literalidad: lo que no
       es requisito ni pacto es ruido en el documento. En un contrato el recuadro
       sí sirve —citar la ley que lo rige ayuda a quien lo lee—; en un título de
       crédito, no.
       Y su contenido era peor que ruido: "cuide que las tasas de interés no sean
       excesivas" impreso le señala al deudor por dónde atacar, y lo usurario es
       de los pocos frentes donde un juez puede entrar de oficio en un ejecutivo
       mercantil. "Conserve el original" es una instrucción para quien cobra, no
       parte de la obligación de quien paga. Las dos viven ahora en la PANTALLA
       donde se genera. -->

  <div style="margin-top:46px;">
    <div style="margin-bottom:38px;">
      <div style="font-weight:bold; text-transform:uppercase; font-size:12px; margin-bottom:6px;">Suscriptor (deudor)</div>
      <div style="font-size:12px;">Nombre: <strong>${vSuscNom}</strong></div>
      <div style="font-size:12px;">Domicilio: ${vSuscDom}</div>
      <div style="font-size:12px;">Identificación: ${vSuscId}</div>
      <div style="margin-top:40px; width:62%;"><div class="firma-linea"></div><span style="font-size:11px;">Firma del suscriptor</span></div>
    </div>
    ${vAval1}
    ${vAval2}
  </div>

  ${_docLegalFooter(datosPatron)}
</body>
</html>`;
}

// ─── TÍTULO DE CRÉDITO: PAGARÉ (LGTOC arts. 170-174) ─────────────────────────
// Mismo flujo que los contratos / documentos legales: generar PDF descargable
// (modo HTML → generarPDFDesdeHTML, SIN window.print, para que NO salga la URL
// del navegador) → "Guardar y vincular" o "Guardar (sin vincular)" → queda en el
// Banco de documentos. El texto sigue el machote: mención PAGARÉ, promesa
// incondicional de pago, beneficiario, lugar/fecha de pago y de suscripción,
// intereses, y firmas del suscriptor + dos avales. Conserva la nota de BORRADOR.
function FormPagare({user, tipoContrato, onBack, fontSans, fontSerif, gold, prefill, entidadFija}: {
  user:any; tipoContrato:string; onBack:()=>void; fontSans:string; fontSerif:string; gold:string;
  prefill?: Record<string,any>;
  entidadFija?: {tipo:"cliente"|"paciente"|"empleado"|"proveedor"|"deudor"; id:string; nombre:string};
}) {
  // El membrete de la cabecera y la firma del pie: el patron, no la plataforma.
  const datosPatron = useDatosPatron(user?.uid).datos;
  const isMobile = window.innerWidth < 768;
  const COLOR = "#92400E";
  const [form, setForm] = useState({
    folio:"",
    serieX:"", serieN:"",
    montoNumero:"", montoLetra:"",
    beneficiario:"",
    lugarSuscripcion:"Aguascalientes, Ags.",
    fechaSuscripcion:"",
    lugarPago:"Aguascalientes, Ags.",
    fechaVencimiento:"",
    enParcialidades:false,
    numParcialidades:"", montoParcialidad:"", vencimientosParcialidades:"",
    interesOrdinario:"", interesMoratorio:"",
    suscriptorNombre:"", suscriptorDomicilio:"", suscriptorIdentificacion:"",
    aval1Nombre:"", aval1Domicilio:"",
    aval2Nombre:"", aval2Domicilio:"",
    ...(prefill||{}),
  });
  const [generando, setGenerando] = useState(false);
  const [ultimoBlob, setUltimoBlob] = useState<Blob|null>(null);
  const set = (k:string,v:any)=> setForm(p=>({...p,[k]:v}));

  const inputStyle: React.CSSProperties = {width:"100%", padding:"9px 11px", fontSize:13, fontFamily:fontSans, background:"white", border:"1px solid #D1D5DB", borderRadius:8, color:"#0F172A", boxSizing:"border-box" as const, outline:"none"};
  const labelStyle: React.CSSProperties = {display:"block", fontSize:11, fontWeight:600, color:"#374151", marginBottom:4, letterSpacing:"0.2px"};
  const camposMin = !!(form.beneficiario && form.montoNumero && form.montoLetra && form.fechaVencimiento && form.suscriptorNombre);

  const generarPDF = async () => {
    setGenerando(true);
    try {
      const html = _construirPagareHTML(form, datosPatron);   // plantilla compartida (misma que la serie)
      const fname = "Pagare_" + (form.beneficiario||"borrador").replace(/[^A-Za-z0-9]/g,"_") + ".pdf";
      const pdfBlob = await generarPDFDesdeHTML(html, fname);
      setUltimoBlob(pdfBlob);
    } catch(e){ console.error(e); alert("No se pudo generar el PDF. Intenta de nuevo."); }
    finally { setGenerando(false); }
  };

  return (
    <div {...ZONA_DE_CAPTURA} style={{minHeight:"100vh", background:T_LIGHT.canvas, fontFamily:fontSans}}>
      <div style={{background:`linear-gradient(135deg,${COLOR},${COLOR}CC)`, padding:"0 20px", height:58, display:"flex", alignItems:"center", gap:12, position:"sticky" as const, top:0, zIndex:100, boxShadow:`0 4px 20px ${COLOR}4D`}}>
        <button onClick={onBack} style={{background:"rgba(255,255,255,0.18)", border:"1px solid rgba(255,255,255,0.30)", color:"white", borderRadius:8, padding:"5px 11px", cursor:"pointer", fontSize:12, fontWeight:600}}>← {entidadFija ? "Volver" : "Generador legal"}</button>
        <span style={{color:"white", fontWeight:700, fontSize:isMobile?12:14, display:"flex", alignItems:"center", gap:8}}>
          <AxisIcon name="document" size={18} tone="white" withBackdrop={false} strokeWidth={2.5}/>
          Pagaré
        </span>
      </div>

      <div style={{maxWidth:760, margin:"0 auto", padding:isMobile?"16px":"24px"}}>
        <p style={{fontSize:12, color:"#64748B", margin:"0 0 18px", lineHeight:1.6}}>
          Genera un pagaré (título de crédito) para documentar una deuda. Los campos con <span style={{color:"#DC2626"}}>*</span> son indispensables. El monto en número y en letra deben coincidir exactamente.
        </p>

        <SectionServicios title="Datos del pagaré" fontSerif={fontSerif} isMobile={isMobile}>
          <div>
            <label style={labelStyle}>Folio / número de serie</label>
            <input autoComplete="off" style={inputStyle} value={form.folio} onChange={e=>set("folio",e.target.value)} placeholder="Ej. A-001"/>
          </div>
          <div style={{display:"grid", gridTemplateColumns:"1fr auto 1fr", gap:6, alignItems:"end"}}>
            <div>
              <label style={labelStyle}>Pagaré (X)</label>
              <input autoComplete="off" style={inputStyle} value={form.serieX} onChange={e=>set("serieX",e.target.value)} placeholder="1"/>
            </div>
            <div style={{paddingBottom:9, color:"#9CA3AF", fontSize:12}}>de</div>
            <div>
              <label style={labelStyle}>Total (N)</label>
              <input autoComplete="off" style={inputStyle} value={form.serieN} onChange={e=>set("serieN",e.target.value)} placeholder="12"/>
            </div>
          </div>
          <div>
            <label style={labelStyle}>Monto en número <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" style={inputStyle} value={form.montoNumero} onChange={e=>set("montoNumero",e.target.value)} placeholder="10,000.00"/>
          </div>
          <div>
            <label style={labelStyle}>Monto con letra <span style={{color:"#DC2626"}}>*</span></label>
            {/* SIN "M.N.": lo añade la plantilla. Si se escribe igual, se recorta. */}
            <input autoComplete="off" style={inputStyle} value={form.montoLetra} onChange={e=>set("montoLetra",e.target.value)} placeholder="Diez mil pesos 00/100 (sin M.N.)"/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Beneficiario (a quién se paga) <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" style={inputStyle} value={form.beneficiario} onChange={e=>set("beneficiario",e.target.value)} placeholder="Nombre de quien recibe el pago"/>
          </div>
        </SectionServicios>

        <SectionServicios title="Suscripción y pago" fontSerif={fontSerif} isMobile={isMobile}>
          <div>
            <label style={labelStyle}>Lugar de suscripción</label>
            <input autoComplete="off" style={inputStyle} value={form.lugarSuscripcion} onChange={e=>set("lugarSuscripcion",e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Fecha de suscripción</label>
            <input autoComplete="off" type="date" style={inputStyle} value={form.fechaSuscripcion} onChange={e=>set("fechaSuscripcion",e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Lugar de pago</label>
            <input autoComplete="off" style={inputStyle} value={form.lugarPago} onChange={e=>set("lugarPago",e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Fecha de pago / vencimiento <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" type="date" style={inputStyle} value={form.fechaVencimiento} onChange={e=>set("fechaVencimiento",e.target.value)}/>
          </div>
        </SectionServicios>

        <SectionServicios title="Parcialidades e intereses (opcional)" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1", padding:"10px 12px", background:`${COLOR}0D`, borderRadius:8, border:`1px solid ${COLOR}33`}}>
            <label style={{display:"flex", alignItems:"flex-start", gap:8, cursor:"pointer", fontSize:12, color:"#374151"}}>
              <input autoComplete="off" type="checkbox" checked={form.enParcialidades} onChange={e=>set("enParcialidades",e.target.checked)} style={{marginTop:2}}/>
              <div>
                <strong>El pago es en parcialidades</strong>
                <div style={{fontSize:10.5, color:"#64748B", marginTop:2, lineHeight:1.4}}>Marca esta casilla si la deuda se paga en abonos. La falta de pago de una parcialidad da por vencido el total.</div>
              </div>
            </label>
          </div>
          {form.enParcialidades && (<>
            <div>
              <label style={labelStyle}>Número de parcialidades</label>
              <input autoComplete="off" style={inputStyle} value={form.numParcialidades} onChange={e=>set("numParcialidades",e.target.value)} placeholder="12"/>
            </div>
            <div>
              <label style={labelStyle}>Monto de cada parcialidad</label>
              <input autoComplete="off" style={inputStyle} value={form.montoParcialidad} onChange={e=>set("montoParcialidad",e.target.value)} placeholder="833.33"/>
            </div>
            <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
              <label style={labelStyle}>Vencimientos (días)</label>
              <input autoComplete="off" style={inputStyle} value={form.vencimientosParcialidades} onChange={e=>set("vencimientosParcialidades",e.target.value)} placeholder="Los días 1 de cada mes, de 01/2026 a 12/2026"/>
            </div>
          </>)}
          <div>
            <label style={labelStyle}>Interés ordinario (% mensual)</label>
            <input autoComplete="off" style={inputStyle} value={form.interesOrdinario} onChange={e=>set("interesOrdinario",e.target.value)} placeholder="0"/>
          </div>
          <div>
            <label style={labelStyle}>Interés moratorio (% mensual)</label>
            <input autoComplete="off" style={inputStyle} value={form.interesMoratorio} onChange={e=>set("interesMoratorio",e.target.value)} placeholder="0"/>
          </div>
        </SectionServicios>

        <SectionServicios title="Suscriptor (deudor)" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Nombre completo <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" style={inputStyle} value={form.suscriptorNombre} onChange={e=>set("suscriptorNombre",e.target.value)} placeholder="Nombre de quien firma y debe"/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Domicilio</label>
            <input autoComplete="off" style={inputStyle} value={form.suscriptorDomicilio} onChange={e=>set("suscriptorDomicilio",e.target.value)} placeholder="Calle, número, colonia, ciudad"/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Identificación</label>
            <input autoComplete="off" style={inputStyle} value={form.suscriptorIdentificacion} onChange={e=>set("suscriptorIdentificacion",e.target.value)} placeholder="INE, pasaporte, etc."/>
          </div>
        </SectionServicios>

        <SectionServicios title="Avales (opcional, recomendado)" fontSerif={fontSerif} isMobile={isMobile}>
          <div>
            <label style={labelStyle}>Aval 1 — Nombre</label>
            <input autoComplete="off" style={inputStyle} value={form.aval1Nombre} onChange={e=>set("aval1Nombre",e.target.value)} placeholder="Nombre del aval 1"/>
          </div>
          <div>
            <label style={labelStyle}>Aval 1 — Domicilio</label>
            <input autoComplete="off" style={inputStyle} value={form.aval1Domicilio} onChange={e=>set("aval1Domicilio",e.target.value)} placeholder="Domicilio del aval 1"/>
          </div>
          <div>
            <label style={labelStyle}>Aval 2 — Nombre</label>
            <input autoComplete="off" style={inputStyle} value={form.aval2Nombre} onChange={e=>set("aval2Nombre",e.target.value)} placeholder="Nombre del aval 2"/>
          </div>
          <div>
            <label style={labelStyle}>Aval 2 — Domicilio</label>
            <input autoComplete="off" style={inputStyle} value={form.aval2Domicilio} onChange={e=>set("aval2Domicilio",e.target.value)} placeholder="Domicilio del aval 2"/>
          </div>
        </SectionServicios>

        <div style={{background:`${COLOR}1A`, border:`1px solid ${COLOR}4D`, borderRadius:10, padding:"12px 14px", marginBottom:18, display:"flex", gap:10}}>
          <AxisIcon name="scale_simple" size={16} tone="gold" withBackdrop={false} strokeWidth={3}/>
          <div style={{fontSize:11.5, color:"#374151", lineHeight:1.5}}>
            <strong>Borrador de referencia.</strong> Un pagaré es un título de crédito (LGTOC arts. 170–174); si le falta un requisito esencial puede perder fuerza ejecutiva.
            {" "}El monto en número y en letra deben coincidir. <strong>Conserva el original firmado</strong>: es título ejecutivo y se cobra con el original, no con una copia.
            {" "}Cuida que las tasas de interés no sean excesivas — lo usurario lo puede revisar un juez de oficio.
            {" "}Para mayor certeza jurídica, valídalo con AXIS Asesoría Legal Corporativa.
          </div>
        </div>

        <button onClick={generarPDF} disabled={generando || !camposMin}
          style={{width:"100%", padding:"14px", borderRadius:10,
            background: camposMin ? `linear-gradient(135deg,${COLOR},${COLOR}CC)` : "#9CA3AF",
            border:"none", color:"white", fontSize:15, fontWeight:700,
            cursor: camposMin ? "pointer" : "not-allowed",
            boxShadow: camposMin ? `0 4px 16px ${COLOR}59` : "none",
            display:"flex", alignItems:"center", justifyContent:"center", gap:10, fontFamily:fontSans}}>
          <AxisIcon name="document" size={16} tone="white" withBackdrop={false} strokeWidth={3}/>
          {generando ? "Generando documento..." : "Generar Pagaré en PDF"}
        </button>

        {!camposMin && (
          <p style={{fontSize:11, color:"#DC2626", margin:"8px 0 0", textAlign:"center" as const}}>
            Completa los campos marcados con <strong>*</strong> para generar el pagaré.
          </p>
        )}
        {ultimoBlob && (
          <div style={{marginTop:14, padding:"14px 16px", background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:12, display:"flex", justifyContent:"space-between", alignItems:"center", gap:12, flexWrap:"wrap" as const}}>
            <div style={{fontSize:12, color:T_LIGHT.textInkSoft, flex:1, minWidth:160}}>{entidadFija ? `¿Guardar este pagaré en el expediente de ${entidadFija.nombre}?` : "¿Quieres guardar este pagaré en un expediente o en tu banco?"}</div>
            <BotonGuardarYVincular
              user={user}
              tipoContrato={tipoContrato}
              getPDFBlob={async () => ultimoBlob!}
              nombrePDFBase="Pagare"
              entidadFija={entidadFija}
              fontSans={fontSans} fontSerif={fontSerif} gold={gold}
            />
          </div>
        )}
      </div>
    </div>
  );
}

// ─── DOCUMENTO: CONSENTIMIENTO INFORMADO (MÉDICO) ────────────────────────────
function FormConsentimientoInformado({user, tipoContrato, onBack, fontSans, fontSerif, gold, prefill, entidadFija}: {
  user:any; tipoContrato:string; onBack:()=>void; fontSans:string; fontSerif:string; gold:string;
  prefill?: Record<string,any>;
  entidadFija?: {tipo:"cliente"|"paciente"|"empleado"|"proveedor"|"deudor"; id:string; nombre:string};
}) {
  // El membrete de la cabecera y la firma del pie: el patron, no la plataforma.
  const datosPatron = useDatosPatron(user?.uid).datos;
  const isMobile = window.innerWidth < 768;
  const COLOR = "#0D9488";
  const [form, setForm] = useState({
    ciudad:"Aguascalientes, Ags.",
    fecha:"",
    profesionalNombre:"",
    profesionalCedula:"",
    profesionalEspecialidad:"",
    establecimiento:"",
    establecimientoDomicilio:"",
    pacienteNombre:"",
    pacienteEdad:"",
    pacienteSexo:"",
    representanteNombre:"",
    representanteParentesco:"",
    procedimiento:"",
    riesgos:"",
    beneficios:"",
    alternativas:"",
    notas:"",
    ...(prefill||{}),
  });
  const [generando, setGenerando] = useState(false);
  const [ultimoBlob, setUltimoBlob] = useState<Blob|null>(null);
  const set = (k:string,v:any)=> setForm(p=>({...p,[k]:v}));

  const inputStyle: React.CSSProperties = {width:"100%", padding:"9px 11px", fontSize:13, fontFamily:fontSans, background:"white", border:"1px solid #D1D5DB", borderRadius:8, color:"#0F172A", boxSizing:"border-box" as const, outline:"none"};
  const labelStyle: React.CSSProperties = {display:"block", fontSize:11, fontWeight:600, color:"#374151", marginBottom:4, letterSpacing:"0.2px"};
  const camposMin = !!(form.profesionalNombre && form.pacienteNombre && form.procedimiento && form.riesgos && form.beneficios);

  const generarPDF = async () => {
    setGenerando(true);
    const F = (v:string)=> v || "___________________________";
    // Ver la nota del contrato de trabajo: construir un Date con "AAAA-MM-DD"
    // imprime el día anterior en México.
    const hoy = fechaLargaAxis(form.fecha) || fechaLargaAxis(new Date());
    const vFechaGen = new Date().toLocaleDateString("es-MX");
    const vCiudad = form.ciudad || "Aguascalientes, Ags.";
    const vProf = F(form.profesionalNombre);
    const vCedula = form.profesionalCedula ? `, con cédula profesional <strong>${form.profesionalCedula}</strong>` : "";
    const vEsp = form.profesionalEspecialidad ? `, especialidad en ${form.profesionalEspecialidad}` : "";
    const vEstab = form.establecimiento ? `, adscrito(a) a <strong>${form.establecimiento}</strong>${form.establecimientoDomicilio ? ` (${form.establecimientoDomicilio})` : ""}` : "";
    const vPac = F(form.pacienteNombre);
    const vEdad = form.pacienteEdad ? `, de ${form.pacienteEdad} años de edad` : "";
    const vSexo = form.pacienteSexo ? `, sexo ${form.pacienteSexo}` : "";
    const vRepre = form.representanteNombre ? `<br/><br/>En virtud de que el/la paciente no se encuentra en posibilidad de otorgar su consentimiento por sí mismo(a), comparece en su representación <strong>${form.representanteNombre}</strong>${form.representanteParentesco ? ` en su carácter de ${form.representanteParentesco}` : ""}, quien manifiesta su conformidad en los términos del presente documento.` : "";
    const vProc = F(form.procedimiento);
    const vRiesgos = F(form.riesgos);
    const vBenef = F(form.beneficios);
    const vAlt = form.alternativas ? form.alternativas : "Se me ha informado sobre las alternativas existentes, incluida la opción de no someterme a ningún procedimiento, así como las consecuencias previsibles de dicha decisión.";
    const vNotas = form.notas ? `
  <div class="clausula">
    <span class="clausula-titulo">OBSERVACIONES:</span> ${form.notas}
  </div>` : "";

    const html = `<!DOCTYPE html>
<html lang="es">
<head><meta charset="UTF-8"><title>Consentimiento Informado</title>
<style>${_DOC_LEGAL_CSS}</style>
</head>
<body>
  ${_docLegalHead(vFechaGen, undefined, datosPatron)}

  <div class="encabezado">Carta de Consentimiento Informado</div>

  <p style="text-align:right;">En ${vCiudad}, a ${hoy}.</p>
  <br/>

  <div class="clausula">
    <span class="clausula-titulo">Profesional de la salud:</span> ${vProf}${vCedula}${vEsp}${vEstab}.
  </div>

  <div class="clausula">
    <span class="clausula-titulo">Paciente:</span> ${vPac}${vEdad}${vSexo}.${vRepre}
  </div>

  <p>Por medio del presente documento, el/la paciente (o su representante legal) declara que ha sido informado(a) de forma clara, suficiente y en lenguaje comprensible sobre lo siguiente:</p>
  <br/>

  <div class="clausula">
    <span class="clausula-titulo">Primera. Naturaleza y descripción del procedimiento:</span> ${vProc}
  </div>

  <div class="clausula">
    <span class="clausula-titulo">Segunda. Riesgos y posibles complicaciones:</span> ${vRiesgos}
  </div>

  <div class="clausula">
    <span class="clausula-titulo">Tercera. Beneficios esperados:</span> ${vBenef}
  </div>

  <div class="clausula">
    <span class="clausula-titulo">Cuarta. Alternativas:</span> ${vAlt}
  </div>

  <div class="clausula">
    <span class="clausula-titulo">Quinta. Declaración del paciente:</span> Manifiesto que se me ha explicado la información anterior, que he tenido la oportunidad de formular todas las preguntas que consideré necesarias y que éstas han sido respondidas a mi entera satisfacción. Entiendo que la práctica de la medicina y la odontología no es una ciencia exacta y que no se me ha garantizado un resultado determinado. Sé que puedo revocar este consentimiento en cualquier momento antes de la realización del procedimiento, sin que ello afecte la atención que en derecho me corresponde.
  </div>

  <div class="clausula">
    <span class="clausula-titulo">Sexta. Autorización:</span> En pleno uso de mis facultades, de manera libre, voluntaria y consciente, OTORGO MI CONSENTIMIENTO para que se lleve a cabo el procedimiento descrito en el presente documento.
  </div>
  ${vNotas}

  <div class="nota-legal">
    <strong>Fundamento legal:</strong> Art. 4º Constitucional · Ley General de Salud (arts. 51 Bis 1 y 2, 80-83) · Reglamento de la LGS en materia de prestación de servicios de atención médica · NOM-004-SSA3-2012 (Expediente Clínico). Este consentimiento no sustituye el expediente clínico ni el criterio del profesional: el procedimiento, riesgos, beneficios y alternativas deben describirse de forma específica para cada caso.
  </div>

  <div class="firmas">
    <div class="firma-bloque">
      <div style="height:60px;"></div>
      <div class="firma-linea"></div>
      <strong>${form.representanteNombre ? "EL REPRESENTANTE / TUTOR" : "EL PACIENTE"}</strong><br/>
      ${form.representanteNombre ? F(form.representanteNombre) : vPac}<br/>
      <span style="font-size:11px;color:#555;">Nombre y firma</span>
    </div>
    <div class="firma-bloque">
      <div style="height:60px;"></div>
      <div class="firma-linea"></div>
      <strong>EL PROFESIONAL DE LA SALUD</strong><br/>
      ${vProf}<br/>
      <span style="font-size:11px;color:#555;">${form.profesionalCedula ? "Cédula: " + form.profesionalCedula : "Nombre y firma"}</span>
    </div>
  </div>

  <div class="firmas" style="margin-top:40px;">
    <div class="firma-bloque">
      <div style="height:50px;"></div>
      <div class="firma-linea"></div>
      <span style="font-size:11px;color:#555;">TESTIGO 1<br/>Nombre y firma</span>
    </div>
    <div class="firma-bloque">
      <div style="height:50px;"></div>
      <div class="firma-linea"></div>
      <span style="font-size:11px;color:#555;">TESTIGO 2<br/>Nombre y firma</span>
    </div>
  </div>

  ${_docLegalFooter(datosPatron)}
</body>
</html>`;

    try {
      const fname = "Consentimiento_Informado_" + (form.pacienteNombre||"borrador").replace(/[^A-Za-z0-9]/g,"_") + ".pdf";
      const pdfBlob = await generarPDFDesdeHTML(html, fname);
      setUltimoBlob(pdfBlob);
    } catch(e){ console.error(e); alert("No se pudo generar el PDF. Intenta de nuevo."); }
    finally { setGenerando(false); }
  };

  return (
    <div {...ZONA_DE_CAPTURA} style={{minHeight:"100vh", background:T_LIGHT.canvas, fontFamily:fontSans}}>
      <div style={{background:`linear-gradient(135deg,${COLOR},${COLOR}CC)`, padding:"0 20px", height:58, display:"flex", alignItems:"center", gap:12, position:"sticky" as const, top:0, zIndex:100, boxShadow:`0 4px 20px ${COLOR}4D`}}>
        <button onClick={onBack} style={{background:"rgba(255,255,255,0.18)", border:"1px solid rgba(255,255,255,0.30)", color:"white", borderRadius:8, padding:"5px 11px", cursor:"pointer", fontSize:12, fontWeight:600}}>← {entidadFija ? "Volver" : "Generador legal"}</button>
        <span style={{color:"white", fontWeight:700, fontSize:isMobile?12:14, display:"flex", alignItems:"center", gap:8}}>
          <AxisIcon name="document" size={18} tone="white" withBackdrop={false} strokeWidth={2.5}/>
          Consentimiento Informado
        </span>
      </div>

      <div style={{maxWidth:760, margin:"0 auto", padding:isMobile?"16px":"24px"}}>
        <p style={{fontSize:12, color:"#64748B", margin:"0 0 18px", lineHeight:1.6}}>
          Genera el consentimiento informado del paciente. El <strong>procedimiento, riesgos, beneficios y alternativas</strong> son campos libres: descríbelos de forma específica para cada caso. Los campos con <span style={{color:"#DC2626"}}>*</span> son indispensables.
        </p>

        <SectionServicios title="Profesional y establecimiento" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Nombre del profesional <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" style={inputStyle} value={form.profesionalNombre} onChange={e=>set("profesionalNombre",e.target.value)} placeholder="Dr(a). Nombre completo"/>
          </div>
          <div>
            <label style={labelStyle}>Cédula profesional</label>
            <input autoComplete="off" style={inputStyle} value={form.profesionalCedula} onChange={e=>set("profesionalCedula",e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Especialidad</label>
            <input autoComplete="off" style={inputStyle} value={form.profesionalEspecialidad} onChange={e=>set("profesionalEspecialidad",e.target.value)} placeholder="Odontología, dermatología..."/>
          </div>
          <div>
            <label style={labelStyle}>Consultorio / clínica</label>
            <input autoComplete="off" style={inputStyle} value={form.establecimiento} onChange={e=>set("establecimiento",e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Domicilio del establecimiento</label>
            <input autoComplete="off" style={inputStyle} value={form.establecimientoDomicilio} onChange={e=>set("establecimientoDomicilio",e.target.value)}/>
          </div>
        </SectionServicios>

        <SectionServicios title="Datos del paciente" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Nombre del paciente <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" style={inputStyle} value={form.pacienteNombre} onChange={e=>set("pacienteNombre",e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Edad</label>
            <input autoComplete="off" style={inputStyle} value={form.pacienteEdad} onChange={e=>set("pacienteEdad",e.target.value)} placeholder="Ej. 34"/>
          </div>
          <div>
            <label style={labelStyle}>Sexo</label>
            <input autoComplete="off" style={inputStyle} value={form.pacienteSexo} onChange={e=>set("pacienteSexo",e.target.value)} placeholder="Femenino / Masculino"/>
          </div>
          <div>
            <label style={labelStyle}>Representante / tutor (si aplica)</label>
            <input autoComplete="off" style={inputStyle} value={form.representanteNombre} onChange={e=>set("representanteNombre",e.target.value)} placeholder="Solo menores o incapaces"/>
          </div>
          <div>
            <label style={labelStyle}>Parentesco del representante</label>
            <input autoComplete="off" style={inputStyle} value={form.representanteParentesco} onChange={e=>set("representanteParentesco",e.target.value)} placeholder="Madre, padre, tutor..."/>
          </div>
        </SectionServicios>

        <SectionServicios title="Información del procedimiento (campos libres)" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Procedimiento propuesto <span style={{color:"#DC2626"}}>*</span></label>
            <textarea autoComplete="off" style={{...inputStyle, minHeight:65, resize:"vertical" as const}} value={form.procedimiento} onChange={e=>set("procedimiento",e.target.value)} placeholder="Describe en qué consiste el procedimiento, en qué parte del cuerpo, con qué técnica..."/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Riesgos y complicaciones <span style={{color:"#DC2626"}}>*</span></label>
            <textarea autoComplete="off" style={{...inputStyle, minHeight:65, resize:"vertical" as const}} value={form.riesgos} onChange={e=>set("riesgos",e.target.value)} placeholder="Riesgos específicos del procedimiento, frecuencia, gravedad..."/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Beneficios esperados <span style={{color:"#DC2626"}}>*</span></label>
            <textarea autoComplete="off" style={{...inputStyle, minHeight:55, resize:"vertical" as const}} value={form.beneficios} onChange={e=>set("beneficios",e.target.value)} placeholder="Qué se espera lograr con el procedimiento..."/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Alternativas (opcional)</label>
            <textarea autoComplete="off" style={{...inputStyle, minHeight:50, resize:"vertical" as const}} value={form.alternativas} onChange={e=>set("alternativas",e.target.value)} placeholder="Otros tratamientos posibles y la opción de no tratarse..."/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Observaciones (opcional)</label>
            <input autoComplete="off" style={inputStyle} value={form.notas} onChange={e=>set("notas",e.target.value)}/>
          </div>
        </SectionServicios>

        <SectionServicios title="Documento" fontSerif={fontSerif} isMobile={isMobile}>
          <div>
            <label style={labelStyle}>Ciudad</label>
            <input autoComplete="off" style={inputStyle} value={form.ciudad} onChange={e=>set("ciudad",e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Fecha</label>
            <input autoComplete="off" type="date" style={inputStyle} value={form.fecha} onChange={e=>set("fecha",e.target.value)}/>
          </div>
        </SectionServicios>

        <div style={{background:`${COLOR}1A`, border:`1px solid ${COLOR}4D`, borderRadius:10, padding:"12px 14px", marginBottom:18, display:"flex", gap:10}}>
          <AxisIcon name="scale_simple" size={16} tone="gold" withBackdrop={false} strokeWidth={3}/>
          <div style={{fontSize:11.5, color:"#374151", lineHeight:1.5}}>
            <strong>Borrador de referencia.</strong> No sustituye el expediente clínico (NOM-004) ni el criterio del profesional. Describe el procedimiento, riesgos, beneficios y alternativas de forma específica para cada paciente.
          </div>
        </div>

        <button onClick={generarPDF} disabled={generando || !camposMin}
          style={{width:"100%", padding:"14px", borderRadius:10,
            background: camposMin ? `linear-gradient(135deg,${COLOR},${COLOR}CC)` : "#9CA3AF",
            border:"none", color:"white", fontSize:15, fontWeight:700,
            cursor: camposMin ? "pointer" : "not-allowed",
            boxShadow: camposMin ? `0 4px 16px ${COLOR}59` : "none",
            display:"flex", alignItems:"center", justifyContent:"center", gap:10, fontFamily:fontSans}}>
          <AxisIcon name="document" size={16} tone="white" withBackdrop={false} strokeWidth={3}/>
          {generando ? "Generando documento..." : "Generar Consentimiento en PDF"}
        </button>

        {!camposMin && (
          <p style={{fontSize:11, color:"#DC2626", margin:"8px 0 0", textAlign:"center" as const}}>
            Completa los campos marcados con <strong>*</strong> para generar el documento.
          </p>
        )}
        {ultimoBlob && (
          <div style={{marginTop:14, padding:"14px 16px", background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:12, display:"flex", justifyContent:"space-between", alignItems:"center", gap:12, flexWrap:"wrap" as const}}>
            <div style={{fontSize:12, color:T_LIGHT.textInkSoft, flex:1, minWidth:160}}>{entidadFija ? `¿Guardar este consentimiento en el expediente de ${entidadFija.nombre}?` : "¿Quieres guardar este documento en un expediente?"}</div>
            <BotonGuardarYVincular
              user={user}
              tipoContrato={tipoContrato}
              getPDFBlob={async () => ultimoBlob!}
              nombrePDFBase="Consentimiento_Informado"
              entidadFija={entidadFija}
              fontSans={fontSans} fontSerif={fontSerif} gold={gold}
            />
          </div>
        )}
      </div>
    </div>
  );
}
// #endregion

function FormServiciosProfesionales({user, tipoContrato, onBack, fontSans, fontSerif, gold}: {user:any; tipoContrato:string; onBack:()=>void; fontSans:string; fontSerif:string; gold:string}) {
  // El pie de este documento lo firma el patrón, no la plataforma.
  const datosPatron = useDatosPatron(user?.uid).datos;
  // Las dos partes de ESTE contrato, para el control de "cuál soy yo".
  const PARTES_SP: ParteDeContrato[] = [
    {clave:"prestador", etiqueta:"Prestador", nombre:"nombrePrestador", rfc:"rfcPrestador", domicilio:"domicilioPrestador"},
    {clave:"cliente",   etiqueta:"Cliente",   nombre:"nombreCliente",   rfc:"rfcCliente",   domicilio:"domicilioCliente"},
  ];
  const [miParte, setMiParte] = useState("");   // por defecto, ninguna
  const isMobile = window.innerWidth < 768;
  const [form, setForm] = useState({
    ciudad:"Aguascalientes, Ags.",
    fechaContrato:"",
    tipoPrestador:"persona_fisica",
    nombrePrestador:"",
    rfcPrestador:"",
    domicilioPrestador:"",
    telefonoPrestador:"",
    cedulaPrestador:"",
    especialidadPrestador:"",
    certificacionesPrestador:"",
    tipoCliente:"persona_fisica",
    nombreCliente:"",
    rfcCliente:"",
    domicilioCliente:"",
    descripcionServicios:"",
    entregables:"",
    honorarios:"",
    formaPago:"dos_exhibiciones",
    plazoInicio:"",
    plazoFin:"",
    confidencialidad:true,
    nonCompete:false,
  });
  const [generando, setGenerando] = useState(false);
  const [ultimoBlob, setUltimoBlob] = useState<Blob|null>(null);

  const set = (k: string, v: any) => setForm(p => ({...p, [k]:v}));
  const fmt = (v: string) => v || "___________________________";

  const generarPDF = async () => {
    setGenerando(true);
    // `new Date("2026-09-01")` es medianoche UTC y en México eso es el 31 de
    // agosto: el contrato imprimía el día ANTERIOR al que se capturó, y eso
    // mueve antigüedad, aguinaldo proporcional y periodo de prueba. Mismo
    // defecto que corregimos en el expediente de vehículos. `fechaLargaAxis`
    // parte la cadena en vez de construir un Date.
    const hoy = fechaLargaAxis(form.fechaContrato) || fechaLargaAxis(new Date());
    const F = (v:string) => v || "___________________________";

    const clausulaConf = form.confidencialidad ? `
      <div class="clausula">
        <div class="clausula-titulo">SÉPTIMA.- CONFIDENCIALIDAD</div>
        EL PROFESIONISTA se obliga a guardar estricta confidencialidad respecto de toda información, datos, documentos y procesos a los que tenga acceso en virtud del presente contrato, tanto durante su vigencia como por un período de DOS (2) años posteriores a su terminación. El incumplimiento de esta obligación dará lugar al pago de daños y perjuicios conforme al Código Civil del Estado de Aguascalientes.
      </div>` : "";

    const numClausulaNonCompete = form.confidencialidad ? "OCTAVA" : "SÉPTIMA";
    const clausulaNonCompete = form.nonCompete ? `
      <div class="clausula">
        <div class="clausula-titulo">${numClausulaNonCompete}.- NO COMPETENCIA</div>
        Durante la vigencia del presente contrato y por un período de DOCE (12) meses posteriores a su terminación, EL PROFESIONISTA se obliga a no prestar servicios iguales o similares, directa o indirectamente, a personas físicas o morales que sean competidores directos de EL CLIENTE en el Estado de Aguascalientes.
      </div>` : "";

        // Pre-calcular todos los valores
    const vPrestador = form.nombrePrestador || "___________________________";
    const vCliente = form.nombreCliente || "___________________________";
    const vRfcPrestador = form.rfcPrestador || "___________________________";
    const vRfcCliente = form.rfcCliente || "___________________________";
    const vDomPrestador = form.domicilioPrestador || "___________________________";
    const vDomCliente = form.domicilioCliente || "___________________________";
    const vCiudad = form.ciudad || "Aguascalientes, Ags.";
    const vTelPrestador = form.telefonoPrestador || "";
    const vCedula = form.cedulaPrestador || "";
    const vEspecialidad = form.especialidadPrestador || "";
    const vCertificaciones = form.certificacionesPrestador || "";
    const vDatosProfesionales = [
      vEspecialidad ? "Especialidad: " + vEspecialidad : "",
      vCedula ? "Cédula Profesional: " + vCedula : "",
      vCertificaciones ? "Certificaciones: " + vCertificaciones : "",
      vTelPrestador ? "Teléfono: " + vTelPrestador : "",
    ].filter(Boolean).join(" · ");
    const vServicios = form.descripcionServicios || "___________________________";
    const vHonorarios = form.honorarios || "___________________________";
    const vTipoPrestador = form.tipoPrestador === "persona_fisica" ? "persona física" : "persona moral";
    const vTipoCliente = form.tipoCliente === "persona_fisica" ? "persona física" : "persona moral";
    const vEntregables = form.entregables ? " Los entregables acordados son: <strong>" + form.entregables + "</strong>." : "";
    const vPlazoInicio = fechaLargaAxis(form.plazoInicio);
    const vPlazoFin = fechaLargaAxis(form.plazoFin);
    const vVigencia = (form.plazoInicio && form.plazoFin)
      ? "del <strong>" + vPlazoInicio + "</strong> al <strong>" + vPlazoFin + "</strong>"
      : "a partir de la fecha de su firma y hasta la conclusión de los servicios acordados";
    const vFormaPago = form.formaPago === "dos_exhibiciones"
      ? "dos exhibiciones: el 50% al momento de la firma del presente contrato y el 50% restante al concluir el servicio"
      : form.formaPago === "mensual" ? "mensual"
      : form.formaPago === "quincenal" ? "quincenal"
      : form.formaPago === "por entregable" ? "por entregable acordado"
      : "única al momento de la firma";
    const vFechaGen = new Date().toLocaleDateString("es-MX");

    const vClausulaConf = form.confidencialidad ? `
      <div class="clausula">
        <div class="clausula-titulo">SÉPTIMA.- CONFIDENCIALIDAD</div>
        EL PROFESIONISTA se obliga a guardar estricta confidencialidad respecto de toda información, datos, documentos y procesos a los que tenga acceso en virtud del presente contrato, tanto durante su vigencia como por un período de DOS (2) años posteriores a su terminación. El incumplimiento de esta obligación dará lugar al pago de daños y perjuicios conforme al Código Civil del Estado de Aguascalientes.
      </div>` : "";
    const numNC = form.confidencialidad ? "OCTAVA" : "SÉPTIMA";
    const vClausulaNonCompete = form.nonCompete ? `
      <div class="clausula">
        <div class="clausula-titulo">${numNC}.- NO COMPETENCIA</div>
        Durante la vigencia del presente contrato y por un período de DOCE (12) meses posteriores a su terminación, EL PROFESIONISTA se obliga a no prestar servicios iguales o similares a competidores directos de EL CLIENTE en el Estado de Aguascalientes.
      </div>` : "";

    const html = `<!DOCTYPE html>
<html lang="es">
<head><meta charset="UTF-8"><title>Contrato de Prestación de Servicios Profesionales</title>
<style>
  * { box-sizing:border-box; margin:0; padding:0; }
  body { font-family:'Times New Roman', serif; color:#1A1A2E; padding:55px 65px; font-size:12.5px; line-height:1.85; background:white; text-align:justify; }
  .encabezado { font-size:13px; font-weight:bold; text-align:center; text-transform:uppercase; margin-bottom:28px; line-height:1.6; }
  .seccion-titulo { font-weight:bold; text-transform:uppercase; text-align:center; font-size:13px; margin:24px 0 12px; letter-spacing:0.5px; }
  .declaracion-titulo { font-weight:bold; text-transform:uppercase; font-size:12.5px; margin:16px 0 8px; }
  .clausula { margin-bottom:18px; }
  .clausula-titulo { font-weight:bold; text-transform:uppercase; font-size:12.5px; display:inline; }
  .firmas { margin-top:60px; display:grid; grid-template-columns:1fr 1fr; gap:60px; }
  .firma-bloque { text-align:center; }
  .firma-linea { border-top:1px solid #1A1A2E; margin-bottom:8px; }
  .testigos { margin-top:40px; display:grid; grid-template-columns:1fr 1fr; gap:60px; }
  .header-axis { display:flex; justify-content:space-between; align-items:center; margin-bottom:36px; padding-bottom:14px; border-bottom:2px solid #B8932A; }
  .footer { text-align:center; margin-top:36px; padding-top:14px; border-top:1px solid #ddd; font-size:10px; color:#9A9AAA; font-family:Arial,sans-serif; }
  @media print { body { padding:40px 50px; } }
</style>
</head>
<body>
  <div class="encabezado">
    CONTRATO DE PRESTACIÓN DE SERVICIOS PROFESIONALES QUE CELEBRAN, POR UNA PARTE,
    ${vPrestador.toUpperCase()}, A QUIEN EN LO SUCESIVO SE DENOMINARÁ COMO
    "EL PROFESIONISTA", Y POR OTRA PARTE, ${vCliente.toUpperCase()},
    A QUIEN EN LO SUCESIVO SE DENOMINARÁ COMO "EL CLIENTE", DE CONFORMIDAD CON LAS
    SIGUIENTES DECLARACIONES Y CLÁUSULAS:
  </div>

  <div class="seccion-titulo">DECLARACIONES</div>

  <div class="declaracion-titulo">DECLARA EL PROFESIONISTA:</div>
  <p><strong>1.-</strong> Ser ${vTipoPrestador}${vEspecialidad ? ", " + vEspecialidad : ""}, con RFC <strong>${vRfcPrestador}</strong>${vCedula ? ", Cédula Profesional <strong>" + vCedula + "</strong>" : ""}, con domicilio en <strong>${vDomPrestador}</strong>${vTelPrestador ? ", teléfono " + vTelPrestador : ""}${vCertificaciones ? ", con las siguientes certificaciones: <strong>" + vCertificaciones + "</strong>" : ""}, con plena capacidad legal para celebrar el presente contrato y prestar los servicios profesionales que en él se describen.</p>
  <br/>
  <p><strong>2.-</strong> Contar con los conocimientos, experiencia y habilidades necesarias para comprometerse a cumplir con todas las obligaciones derivadas del presente contrato, actuando siempre con profesionalismo y dentro de los límites que establece la legislación vigente aplicable en el Estado de Aguascalientes.</p>

  <div class="declaracion-titulo" style="margin-top:16px;">DECLARA EL CLIENTE:</div>
  <p><strong>3.-</strong> Ser ${vTipoCliente}, con RFC <strong>${vRfcCliente}</strong>, con domicilio en <strong>${vDomCliente}</strong>, con plena capacidad legal y económica para celebrar el presente contrato.</p>
  <br/>
  <p><strong>4.-</strong> Que desea contratar los servicios profesionales de EL PROFESIONISTA, contando con los recursos necesarios para cubrir el pago total de la prestación solicitada. Así mismo declara estar al corriente en sus obligaciones fiscales.</p>

  <div class="declaracion-titulo" style="margin-top:16px;">AMBAS PARTES DECLARAN:</div>
  <p><strong>5.-</strong> Reconocer la personalidad con la que se ostentan, libres de toda coacción y vicio en su consentimiento, que es su voluntad comprometerse en los términos del presente contrato, celebrado en la ciudad de <strong>${vCiudad}</strong>, el día <strong>${hoy}</strong>.</p>

  <div class="seccion-titulo" style="margin-top:24px;">CLÁUSULAS</div>

  <div class="clausula">
    <span class="clausula-titulo">PRIMERA.- OBJETO DEL CONTRATO:</span> EL PROFESIONISTA se compromete a prestar a EL CLIENTE los siguientes servicios profesionales: <strong>${vServicios}</strong>.${vEntregables}
  </div>

  <div class="clausula">
    <span class="clausula-titulo">SEGUNDA.- NATURALEZA DE LA RELACIÓN:</span> Las partes reconocen expresamente que el presente contrato no crea relación laboral alguna entre EL PROFESIONISTA y EL CLIENTE. EL PROFESIONISTA actuará como profesional independiente, siendo responsable de sus impuestos y obligaciones fiscales, conforme a los artículos 2479 y 2488 del Código Civil del Estado de Aguascalientes y el artículo 14 de la Ley Federal del Trabajo. Su responsabilidad se limita a casos de negligencia, impericia o dolo (Art. 2488 CCAGS).
  </div>

  <div class="clausula">
    <span class="clausula-titulo">TERCERA.- OBLIGACIONES DEL PROFESIONISTA:</span> EL PROFESIONISTA se compromete a: I) Actuar con profesionalismo y respeto. II) Cumplir con los plazos y entregables acordados. III) En caso de imposibilidad, dar aviso con al menos <strong>3 días naturales</strong> de anticipación. IV) El incumplimiento sin justificación generará una penalización del <strong>20% del costo total</strong> en favor de EL CLIENTE (Art. 2487 CCAGS).
  </div>

  <div class="clausula">
    <span class="clausula-titulo">CUARTA.- OBLIGACIONES DEL CLIENTE:</span> EL CLIENTE se obliga a: I) Pagar puntualmente los honorarios pactados. II) Proporcionar información, accesos e instalaciones necesarias. III) No obstaculizar el ejercicio profesional de EL PROFESIONISTA. IV) En caso de imposibilidad, dar aviso con al menos <strong>3 días naturales</strong> de anticipación. El incumplimiento generará una penalización del <strong>20% del costo total</strong> en favor de EL PROFESIONISTA (Art. 2487 CCAGS).
  </div>

  <div class="clausula">
    <span class="clausula-titulo">QUINTA.- HONORARIOS Y FORMA DE PAGO:</span> EL CLIENTE pagará a EL PROFESIONISTA la cantidad de <strong>$${vHonorarios} pesos M.N. (más IVA conforme a la ley)</strong> de forma <strong>${vFormaPago}</strong>. EL PROFESIONISTA emitirá el CFDI correspondiente. Lo anterior conforme a los Arts. 2479, 2483 y 2486 del Código Civil del Estado de Aguascalientes.
  </div>

  <div class="clausula">
    <span class="clausula-titulo">SEXTA.- VIGENCIA:</span> El presente contrato tendrá vigencia ${vVigencia}. Cualquiera de las partes podrá darlo por terminado anticipadamente mediante aviso escrito con <strong>15 días naturales</strong> de anticipación, siendo exigibles únicamente los servicios y honorarios devengados hasta esa fecha.
  </div>

  ${vClausulaConf}
  ${vClausulaNonCompete}

  <div class="clausula">
    <span class="clausula-titulo">PROPIEDAD INTELECTUAL:</span> Todos los trabajos y entregables generados por EL PROFESIONISTA serán propiedad de EL CLIENTE desde su entrega, salvo pacto expreso en contrario, conforme a la Ley Federal del Derecho de Autor.
  </div>

  <div class="clausula">
    <span class="clausula-titulo">JURISDICCIÓN Y COMPETENCIA:</span> En caso de controversia, ambas partes se someten expresamente a la jurisdicción del Poder Judicial del Estado de Aguascalientes, renunciando al fuero que pudiera corresponderles por razón de sus domicilios.
  </div>

  <div style="margin-top:20px;padding:14px 16px;background:#FFF8F0;border:1px solid #F0D080;border-radius:8px;font-size:11px;font-family:Arial,sans-serif;color:#6B5A3A;">
    <strong>Fundamento legal:</strong> Arts. 2479, 2480, 2483, 2486, 2487 y 2488 del Código Civil del Estado de Aguascalientes · Art. 14 LFT · Ley Federal del Derecho de Autor
  </div>

  <div class="firmas">
    <div class="firma-bloque">
      <div style="height:70px;"></div>
      <div class="firma-linea"></div>
      <strong>EL PROFESIONISTA</strong><br/>
      ${vPrestador}<br/>
      <span style="font-size:11px;color:#555;">RFC: ${vRfcPrestador}</span><br/>
      ${vDatosProfesionales ? '<span style="font-size:10px;color:#777;">' + vDatosProfesionales + '</span>' : ""}
    </div>
    <div class="firma-bloque">
      <div style="height:70px;"></div>
      <div class="firma-linea"></div>
      <strong>EL CLIENTE</strong><br/>
      ${vCliente}<br/>
      <span style="font-size:11px;color:#555;">RFC: ${vRfcCliente}</span>
    </div>
  </div>

  <div class="testigos" style="margin-top:50px;">
    <div class="firma-bloque">
      <div style="height:60px;"></div>
      <div class="firma-linea"></div>
      <span style="font-size:11px;color:#555;">TESTIGO 1<br/>Nombre: ___________________________<br/>Domicilio: ___________________________</span>
    </div>
    <div class="firma-bloque">
      <div style="height:60px;"></div>
      <div class="firma-linea"></div>
      <span style="font-size:11px;color:#555;">TESTIGO 2<br/>Nombre: ___________________________<br/>Domicilio: ___________________________</span>
    </div>
  </div>

</body>
</html>`;

    // PDF real (jsPDF + html2canvas) — descarga y activa setUltimoBlob.
    try {
      const fname = "Contrato_Servicios_Profesionales_" + (form.nombrePrestador||"borrador") + ".pdf";
      const pdfBlob = await generarPDFDesdeHTML(html, fname, {pieContrato:true, pieTexto: pieDelPatron(datosPatron, fechaHoraLargaAxis())});
      setUltimoBlob(pdfBlob);
    } catch(e){ console.error(e); alert("No se pudo generar el PDF. Intenta de nuevo."); }
    finally { setGenerando(false); }
  };

  // ===== UI homologada al estilo claro (PASO 2) =====
  const inputStyleSP: React.CSSProperties = {
    width:"100%", padding:"9px 11px", fontSize:13, fontFamily:fontSans,
    background:"white", border:"1px solid #D1D5DB", borderRadius:8, color:"#0F172A",
    boxSizing:"border-box" as const, outline:"none",
  };
  const labelStyleSP: React.CSSProperties = {
    display:"block", fontSize:11, fontWeight:600, color:"#374151", marginBottom:4,
    letterSpacing:"0.2px",
  };
  
  const camposMin = !!(form.nombrePrestador && form.nombreCliente && form.descripcionServicios && form.honorarios);

  return (
    <div {...ZONA_DE_CAPTURA} style={{minHeight:"100vh", background:T_LIGHT.canvas, fontFamily:fontSans}}>
      <div style={{background:"linear-gradient(135deg,#B8932A,#A07C30)", padding:"0 20px", height:58,
        display:"flex", alignItems:"center", gap:12, position:"sticky" as const, top:0, zIndex:100,
        boxShadow:"0 4px 20px rgba(184,147,42,0.30)"}}>
        <button onClick={onBack}
          style={{background:"rgba(255,255,255,0.18)", border:"1px solid rgba(255,255,255,0.30)",
            color:"white", borderRadius:8, padding:"5px 11px", cursor:"pointer",
            fontSize:12, fontWeight:600}}>← Generador legal</button>
        <span style={{color:"white", fontWeight:700, fontSize:isMobile?12:14, display:"flex",
          alignItems:"center", gap:8}}>
          <AxisIcon name="briefcase" size={18} tone="white" withBackdrop={false} strokeWidth={2.5}/>
          Prestación de Servicios Profesionales
        </span>
      </div>

      <div style={{maxWidth:760, margin:"0 auto", padding:isMobile?"16px":"24px"}}>
        <p style={{fontSize:12, color:"#64748B", margin:"0 0 18px", lineHeight:1.6}}>
          Completa los datos. Los campos marcados con <span style={{color:"#DC2626"}}>*</span> son indispensables.
        </p>

        <SectionServicios title="Datos generales" fontSerif={fontSerif} isMobile={isMobile}>
          <div>
            <label style={labelStyleSP}>Ciudad y estado</label>
            <input autoComplete="off" style={inputStyleSP} value={form.ciudad} onChange={e => set("ciudad", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyleSP}>Fecha del contrato</label>
            <input autoComplete="off" type="date" style={inputStyleSP} value={form.fechaContrato} onChange={e => set("fechaContrato", e.target.value)}/>
          </div>
        </SectionServicios>

        <SelectorDeMiParte partes={PARTES_SP} elegida={miParte} tipoPersona={datosPatron.tipoPersona} fontSans={fontSans} fontSerif={fontSerif}
          onElegir={(c)=>{ setMiParte(c); setForm((f:any)=>aplicarMiParte(f, PARTES_SP, c, datosPatron)); }}/>

        <SectionServicios title="Datos del Prestador de Servicios" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyleSP}>Nombre completo o razón social <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" style={inputStyleSP} value={form.nombrePrestador} onChange={e => set("nombrePrestador", e.target.value)}
              placeholder="Nombre del profesional o empresa"/>
          </div>
          <div>
            <label style={labelStyleSP}>RFC <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" style={inputStyleSP} value={form.rfcPrestador} onChange={e => set("rfcPrestador", e.target.value)}
              placeholder="RFC con homoclave"/>
          </div>
          <div>
            <label style={labelStyleSP}>Teléfono</label>
            <input autoComplete="off" style={inputStyleSP} value={form.telefonoPrestador} onChange={e => set("telefonoPrestador", e.target.value)}
              placeholder="Ej. 449 123 4567"/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyleSP}>Domicilio</label>
            <input autoComplete="off" style={inputStyleSP} value={form.domicilioPrestador} onChange={e => set("domicilioPrestador", e.target.value)}
              placeholder="Calle, número, colonia, ciudad"/>
          </div>
          <div>
            <label style={labelStyleSP}>Cédula profesional</label>
            <input autoComplete="off" style={inputStyleSP} value={form.cedulaPrestador} onChange={e => set("cedulaPrestador", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyleSP}>Especialidad / Profesión</label>
            <input autoComplete="off" style={inputStyleSP} value={form.especialidadPrestador} onChange={e => set("especialidadPrestador", e.target.value)}
              placeholder="Abogado, Contador, etc."/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyleSP}>Certificaciones (opcional)</label>
            <input autoComplete="off" style={inputStyleSP} value={form.certificacionesPrestador} onChange={e => set("certificacionesPrestador", e.target.value)}/>
          </div>
        </SectionServicios>

        <SectionServicios title="Datos del Cliente" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyleSP}>Nombre completo o razón social <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" style={inputStyleSP} value={form.nombreCliente} onChange={e => set("nombreCliente", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyleSP}>RFC <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" style={inputStyleSP} value={form.rfcCliente} onChange={e => set("rfcCliente", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyleSP}>Domicilio</label>
            <input autoComplete="off" style={inputStyleSP} value={form.domicilioCliente} onChange={e => set("domicilioCliente", e.target.value)}/>
          </div>
        </SectionServicios>

        <SectionServicios title="Objeto del contrato" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyleSP}>Descripción de los servicios <span style={{color:"#DC2626"}}>*</span></label>
            <textarea autoComplete="off" style={{...inputStyleSP, minHeight:65, resize:"vertical" as const}} value={form.descripcionServicios}
              onChange={e => set("descripcionServicios", e.target.value)}
              placeholder="Servicios de consultoría contable y fiscal..."/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyleSP}>Entregables (opcional)</label>
            <input autoComplete="off" style={inputStyleSP} value={form.entregables} onChange={e => set("entregables", e.target.value)}
              placeholder="Reporte mensual en PDF, declaraciones fiscales..."/>
          </div>
        </SectionServicios>

        <SectionServicios title="Honorarios y vigencia" fontSerif={fontSerif} isMobile={isMobile}>
          <div>
            <label style={labelStyleSP}>Honorarios MXN (sin IVA) <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" type="number" style={inputStyleSP} value={form.honorarios} onChange={e => set("honorarios", e.target.value)}
              placeholder="5000"/>
          </div>
          <div>
            <label style={labelStyleSP}>Forma de pago</label>
            <select style={inputStyleSP} value={form.formaPago} onChange={e => set("formaPago", e.target.value)}>
              <option value="dos_exhibiciones">Dos exhibiciones (50% / 50%)</option>
              <option value="mensual">Mensual</option>
              <option value="quincenal">Quincenal</option>
              <option value="por entregable">Por entregable</option>
              <option value="unica">Pago único</option>
            </select>
          </div>
          <div>
            <label style={labelStyleSP}>Fecha de inicio</label>
            <input autoComplete="off" type="date" style={inputStyleSP} value={form.plazoInicio} onChange={e => set("plazoInicio", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyleSP}>Fecha de término</label>
            <input autoComplete="off" type="date" style={inputStyleSP} value={form.plazoFin} onChange={e => set("plazoFin", e.target.value)}/>
          </div>
        </SectionServicios>

        <SectionServicios title="Cláusulas opcionales" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1", padding:"10px 12px",
            background:"rgba(184,147,42,0.05)", borderRadius:8,
            border:"1px solid rgba(184,147,42,0.2)"}}>
            <label style={{display:"flex", alignItems:"flex-start", gap:8, cursor:"pointer", fontSize:12, color:"#374151"}}>
              <input autoComplete="off" type="checkbox" checked={form.confidencialidad} onChange={e => set("confidencialidad", e.target.checked)} style={{marginTop:2}}/>
              <div>
                <strong>Cláusula de confidencialidad</strong>
                <div style={{fontSize:10.5, color:"#64748B", marginTop:2, lineHeight:1.4}}>El prestador se obliga a no divulgar información del cliente por 2 años</div>
              </div>
            </label>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1", padding:"10px 12px",
            background:"rgba(184,147,42,0.05)", borderRadius:8,
            border:"1px solid rgba(184,147,42,0.2)"}}>
            <label style={{display:"flex", alignItems:"flex-start", gap:8, cursor:"pointer", fontSize:12, color:"#374151"}}>
              <input autoComplete="off" type="checkbox" checked={form.nonCompete} onChange={e => set("nonCompete", e.target.checked)} style={{marginTop:2}}/>
              <div>
                <strong>Cláusula de no competencia</strong>
                <div style={{fontSize:10.5, color:"#64748B", marginTop:2, lineHeight:1.4}}>El prestador no prestará servicios a competidores directos durante 12 meses</div>
              </div>
            </label>
          </div>
        </SectionServicios>

        <div style={{background:"rgba(184,147,42,0.10)", border:"1px solid rgba(184,147,42,0.3)",
          borderRadius:10, padding:"12px 14px", marginBottom:18, display:"flex", gap:10}}>
          <AxisIcon name="scale_simple" size={16} tone="gold" withBackdrop={false} strokeWidth={3}/>
          <div style={{fontSize:11.5, color:"#374151", lineHeight:1.5}}>
            <strong>Aviso legal:</strong> Plantilla genérica conforme al Código Civil del Estado de Aguascalientes. Para servicios especializados o de alto valor, te recomendamos validación con AXIS Asesoría Legal Corporativa.
          </div>
        </div>

        <button onClick={generarPDF} disabled={generando || !camposMin}
          style={{width:"100%", padding:"14px", borderRadius:10,
            background: camposMin ? "linear-gradient(135deg,#B8932A,#A07C30)" : "#9CA3AF",
            border:"none", color:"white", fontSize:15, fontWeight:700,
            cursor: camposMin ? "pointer" : "not-allowed",
            boxShadow: camposMin ? "0 4px 16px rgba(184,147,42,0.35)" : "none",
            display:"flex", alignItems:"center", justifyContent:"center", gap:10,
            fontFamily:fontSans}}>
          <AxisIcon name="document" size={16} tone="white" withBackdrop={false} strokeWidth={3}/>
          {generando ? "Generando contrato..." : "Generar contrato en PDF"}
        </button>

        {!camposMin && (
          <p style={{fontSize:11, color:"#DC2626", margin:"8px 0 0", textAlign:"center" as const}}>
            Completa los campos marcados con <strong>*</strong> para generar el contrato.
          </p>
        )}
        {ultimoBlob && (
          <div style={{marginTop:14, padding:"14px 16px", background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:12, display:"flex", justifyContent:"space-between", alignItems:"center", gap:12, flexWrap:"wrap"}}>
            <div style={{fontSize:12, color:T_LIGHT.textInkSoft, flex:1, minWidth:160}}>¿Quieres guardar este contrato en un expediente?</div>
            <BotonGuardarYVincular
              user={user}
              tipoContrato={tipoContrato}
              getPDFBlob={async () => ultimoBlob!}
              nombrePDFBase={`Contrato_${tipoContrato}`}
              fontSans={fontSans} fontSerif={fontSerif} gold={gold}
            />
          </div>
        )}

      </div>
    </div>
  );
}


// #endregion
// #region ARRENDAMIENTO VIVIENDA
// ─── CONTRATO: ARRENDAMIENTO DE VIVIENDA ─────────────────────────────────────
function FormArrendamientoVivienda({user, tipoContrato, onBack, fontSans, fontSerif, gold}: {user:any; tipoContrato:string; onBack:()=>void; fontSans:string; fontSerif:string; gold:string}) {
  // El pie de este documento lo firma el patrón, no la plataforma.
  const datosPatron = useDatosPatron(user?.uid).datos;
  // Las dos partes de este contrato. Aquí NINGUNA tiene campo de RFC, así que
  // el control rellena nombre y domicilio: lo que hay.
  const PARTES_AV: ParteDeContrato[] = [
    {clave:"arrendador",   etiqueta:"Arrendador",   nombre:"nombreArrendador",   domicilio:"domicilioArrendador"},
    {clave:"arrendatario", etiqueta:"Arrendatario", nombre:"nombreArrendatario"},
  ];
  const [miParte, setMiParte] = useState("");   // por defecto, ninguna
  const isMobile = window.innerWidth < 768;
  const [form, setForm] = useState({
    ciudad: "Aguascalientes, Ags.",
    fechaContrato: "",
    // Arrendador
    nombreArrendador: "",
    telefonoArrendador: "",
    domicilioArrendador: "",
    // Inmueble
    domicilioInmueble: "",
    serviciosInmueble: "luz, teléfono, agua, drenaje y gas estacionario",
    inventario: "",
    // Arrendatario
    nombreArrendatario: "",
    telefonoArrendatario: "",
    domicilioConvencional: "",
    // Condiciones
    plazoAnios: "1",
    fechaInicio: "",
    fechaFin: "",
    rentaMensual: "",
    deposito: "",
    interesesMoratorios: "5",
    rentaOcupacionIlicita: "",
    // Pago
    diasPago: "1 y 4",
    domicilioPago: "",
    formaPago: "efectivo",
    // Testigo 1
    nombreTestigo1: "",
    telefonoTestigo1: "",
    // Testigo 2
    nombreTestigo2: "",
    telefonoTestigo2: "",
  });
  const [generando, setGenerando] = useState(false);
  const [ultimoBlob, setUltimoBlob] = useState<Blob|null>(null);
  const set = (k: string, v: any) => setForm(p => ({...p, [k]:v}));
  const F = (v: string) => v || "___________________________";
  const fmt$ = (v: string) => {
    if (!v) return "___________________________";
    const n = parseFloat(v);
    if (isNaN(n)) return v;
    return n.toLocaleString("es-MX", {minimumFractionDigits:2, maximumFractionDigits: 2}) + " (" + numeroALetras(n) + ")";
  };

  // Número a letras simplificado
  const numeroALetras = (n: number): string => {
    const unidades = ["","UN","DOS","TRES","CUATRO","CINCO","SEIS","SIETE","OCHO","NUEVE","DIEZ","ONCE","DOCE","TRECE","CATORCE","QUINCE","DIECISEIS","DIECISIETE","DIECIOCHO","DIECINUEVE"];
    const decenas = ["","DIEZ","VEINTE","TREINTA","CUARENTA","CINCUENTA","SESENTA","SETENTA","OCHENTA","NOVENTA"];
    const centenas = ["","CIEN","DOSCIENTOS","TRESCIENTOS","CUATROCIENTOS","QUINIENTOS","SEISCIENTOS","SETECIENTOS","OCHOCIENTOS","NOVECIENTOS"];
    if (n === 0) return "CERO";
    if (n < 20) return unidades[n];
    if (n < 100) return decenas[Math.floor(n/10)] + (n%10 ? " Y " + unidades[n%10] : "");
    if (n < 1000) return centenas[Math.floor(n/100)] + (n%100 ? " " + numeroALetras(n%100) : "");
    if (n < 10000) return unidades[Math.floor(n/1000)] + " MIL" + (n%1000 ? " " + numeroALetras(n%1000) : "");
    if (n < 100000) return numeroALetras(Math.floor(n/1000)) + " MIL" + (n%1000 ? " " + numeroALetras(n%1000) : "");
    return n.toLocaleString("es-MX");
  };

  const generarPDF = async () => {
    setGenerando(true);
    // Ver la nota del contrato de trabajo: "AAAA-MM-DD" a través de Date imprime
    // el día anterior en México. Este documento va en mayúsculas.
    const hoy = (fechaLargaAxis(form.fechaContrato) || fechaLargaAxis(new Date())).toUpperCase();
    const vCiudad = form.ciudad || "AGUASCALIENTES, AGS.";
    const vArrendador = (form.nombreArrendador || "___________________________").toUpperCase();
    const vArrendatario = (form.nombreArrendatario || "___________________________").toUpperCase();
    const vInmueble = (form.domicilioInmueble || "___________________________").toUpperCase();
    const vFechaInicio = fechaLargaAxis(form.fechaInicio).toUpperCase() || "___________________________";
    const vFechaFin = fechaLargaAxis(form.fechaFin).toUpperCase() || "___________________________";
    const vRenta = form.rentaMensual ? "$" + parseFloat(form.rentaMensual).toLocaleString("es-MX", {minimumFractionDigits:2, maximumFractionDigits: 2}) + " M.N. (" + numeroALetras(parseFloat(form.rentaMensual)) + " PESOS 00/100 M.N.)" : "___________________________";
    const vDeposito = form.deposito ? "$" + parseFloat(form.deposito).toLocaleString("es-MX", {minimumFractionDigits:2, maximumFractionDigits: 2}) + " M.N. (" + numeroALetras(parseFloat(form.deposito)) + " PESOS 00/100 M.N.)" : "UN MES DE RENTA";
    const vRentaIlicita = form.rentaOcupacionIlicita ? "$" + parseFloat(form.rentaOcupacionIlicita).toLocaleString("es-MX", {minimumFractionDigits:2, maximumFractionDigits: 2}) + " M.N. (" + numeroALetras(parseFloat(form.rentaOcupacionIlicita)) + " PESOS 00/100 M.N.)" : "EL DOBLE DE LA RENTA MENSUAL PACTADA";
    const vInventario = form.inventario || "EL INMUEBLE SE ENTREGA EN LAS CONDICIONES EN QUE SE ENCUENTRA, SEGÚN CONSTA EN FOTOGRAFÍAS TOMADAS AL MOMENTO DE LA ENTREGA.";
    const vDomPago = form.domicilioPago || form.domicilioArrendador || vInmueble;

    const html = `<!DOCTYPE html>
<html lang="es">
<head><meta charset="UTF-8"><title>Contrato de Arrendamiento de Casa Habitación</title>
<style>
  * { box-sizing:border-box; margin:0; padding:0; }
  body { font-family:'Times New Roman', serif; color:#1A1A2E; padding:55px 65px; font-size:12.5px; line-height:1.85; background:white; text-align:justify; }
  .header-axis { display:flex; justify-content:space-between; align-items:center; margin-bottom:32px; padding-bottom:14px; border-bottom:2px solid #B8932A; }
  .encabezado { font-size:12.5px; font-weight:bold; text-align:center; text-transform:uppercase; margin-bottom:24px; line-height:1.7; }
  .seccion { font-weight:bold; text-transform:uppercase; text-align:center; font-size:12.5px; margin:20px 0 10px; letter-spacing:1px; }
  .decl { margin-bottom:12px; text-transform:uppercase; }
  .clausula { margin-bottom:16px; }
  .num-clausula { font-weight:bold; text-transform:uppercase; }
  .inventario { margin:8px 0 8px 20px; }
  .firmas { margin-top:50px; }
  .fila-firmas { display:grid; grid-template-columns:1fr 1fr; gap:50px; margin-bottom:36px; }
  .firma-bloque { text-align:center; }
  .linea-firma { border-top:1px solid #1A1A2E; margin-bottom:6px; }
  .footer { text-align:center; margin-top:32px; padding-top:14px; border-top:1px solid #ddd; font-size:10px; color:#9A9AAA; font-family:Arial,sans-serif; }
  .fund-legal { margin-top:20px; padding:12px 16px; background:#FFF8F0; border:1px solid #F0D080; border-radius:8px; font-size:11px; font-family:Arial,sans-serif; color:#6B5A3A; }
  @media print { body { padding:40px 50px; } }
</style>
</head>
<body>
  <div class="encabezado">
    ${vCiudad.toUpperCase()}, A ${hoy}<br/><br/>
    CONTRATO DE ARRENDAMIENTO CIVIL DE BIEN INMUEBLE DESTINADO A CASA HABITACIÓN QUE CELEBRAN POR UNA PARTE ${vArrendador}${form.telefonoArrendador ? ", TEL. " + form.telefonoArrendador : ""}, A QUIEN EN LO SUCESIVO SE LE DENOMINARÁ "LA ARRENDADORA" Y POR LA OTRA PARTE ${vArrendatario}${form.telefonoArrendatario ? ", TEL. " + form.telefonoArrendatario : ""}, A QUIEN SE LE DENOMINARÁ "EL ARRENDATARIO", RESPECTO DEL INMUEBLE UBICADO EN ${vInmueble}. SE SUJETAN AL TENOR DE LAS SIGUIENTES DECLARACIONES Y CLÁUSULAS:
  </div>

  <div class="seccion">D E C L A R A C I O N E S:</div>

  <div class="decl">I.- DECLARAN AMBAS PARTES CONTAR CON LA CAPACIDAD LEGAL PARA CONTRATAR Y OBLIGARSE EN TÉRMINOS DEL PRESENTE CONTRATO.</div>
  <div class="decl">II.- DECLARA LA ARRENDADORA SER PROPIETARIA DEL BIEN INMUEBLE UBICADO EN ${vInmueble}${form.domicilioArrendador ? ", CON DOMICILIO EN " + form.domicilioArrendador.toUpperCase() : ""}.</div>
  <div class="decl">III.- DECLARA EL ARRENDATARIO TENER COMO DOMICILIO CONVENCIONAL EL UBICADO EN ${(form.domicilioConvencional || "___________________________").toUpperCase()}.</div>
  <div class="decl">IV.- DECLARA LA ARRENDADORA QUE EL BIEN INMUEBLE SE ENCUENTRA AL CORRIENTE EN EL PAGO DE LOS SERVICIOS DE LUZ Y AGUA.</div>
  <div class="decl">V.- DECLARAN LAS PARTES QUE SE RECONOCEN MUTUAMENTE LA PERSONALIDAD Y CAPACIDAD LEGAL CON LA QUE SE OSTENTAN.</div>
  <div class="decl">VI.- DECLARA LA ARRENDADORA QUE ES SU DESEO OTORGAR EN ARRENDAMIENTO EL BIEN INMUEBLE A QUE SE REFIERE LA DECLARACIÓN II DE ESTE CONTRATO.</div>
  <div class="decl">VII.- DECLARA EL ARRENDATARIO QUE CONOCE EL BIEN INMUEBLE MATERIA DE ESTE CONTRATO Y QUE ES SU DESEO TOMARLO EN ARRENDAMIENTO.</div>

  <p style="text-transform:uppercase; margin:16px 0; font-weight:bold;">LAS PARTES MANIFIESTAN SU LIBRE VOLUNTAD PARA LA CELEBRACIÓN DE ESTE CONTRATO, BAJO EL TENOR DE LAS SIGUIENTES:</p>

  <div class="seccion">CLÁUSULAS</div>

  <div class="clausula"><span class="num-clausula">PRIMERA.-</span> LA ARRENDADORA DA EN ARRENDAMIENTO EL BIEN INMUEBLE UBICADO EN ${vInmueble}, EL CUAL CUENTA CON LAS INSTALACIONES NECESARIAS PARA LOS SERVICIOS DE ${(form.serviciosInmueble || "LUZ, AGUA Y DRENAJE").toUpperCase()}. EL ARRENDATARIO SE ENCUENTRA CONSCIENTE Y CONFORME CON LAS CONDICIONES DEL INMUEBLE AL MOMENTO DE SU ENTREGA, CONSTANDO MEDIANTE FOTOGRAFÍAS EL ESTADO DEL MISMO. (Art. 2283 CCAGS)</div>

  <div class="clausula"><span class="num-clausula">SEGUNDA.-</span> CONVIENEN AMBAS PARTES QUE EL BIEN INMUEBLE OBJETO DEL PRESENTE CONTRATO SERÁ UTILIZADO ÚNICA Y EXCLUSIVAMENTE COMO CASA HABITACIÓN, QUEDANDO RESCINDIDO EL CONTRATO DE DARSE OTRO USO O DE REALIZARSE ACTIVIDADES ILÍCITAS. EN CASO DE REALIZACIÓN DE ACTIVIDADES ILÍCITAS O LA MERA PRESUNCIÓN DE LAS MISMAS POR MEDIO DE UNA DENUNCIA, SERÁ RAZÓN SUFICIENTE PARA LA INMEDIATA RESCISIÓN DEL PRESENTE CONTRATO, QUEDANDO LA ARRENDADORA TOTALMENTE EXCLUIDA DE CUALQUIER RESPONSABILIDAD. (Arts. 2269, 2296 CCAGS)</div>

  <div class="clausula"><span class="num-clausula">TERCERA.-</span> EL ARRENDATARIO ES CONSCIENTE DE QUE SE LE ENTREGA EL BIEN INMUEBLE EN LAS CONDICIONES ACORDADAS, CON TODOS LOS SERVICIOS PÚBLICOS DISPONIBLES, Y EN ESAS MISMAS CONDICIONES LO DEVOLVERÁ AL TÉRMINO DEL CONTRATO. EL ARRENDATARIO SE OBLIGA A CONSERVAR EL INMUEBLE Y SUS ACCESORIOS EN LAS CONDICIONES EN QUE LE FUE ENTREGADO, CONFORME AL SIGUIENTE INVENTARIO: (Art. 2313 CCAGS)
    <div class="inventario">${vInventario}</div>
  </div>

  <div class="clausula"><span class="num-clausula">CUARTA.-</span> CONVIENEN AMBAS PARTES QUE LA DURACIÓN DE ESTE CONTRATO SEA DE ${form.plazoAnios || "___"} AÑO(S), COMENZANDO A CORRER A PARTIR DEL ${vFechaInicio} Y CONCLUYENDO EL ${vFechaFin}. SI EL ARRENDATARIO DEJA EL INMUEBLE CON ANTICIPACIÓN, SE OBLIGA A PAGAR LOS MESES CORRESPONDIENTES QUE RESTEN AL LAPSO CONTRATADO. EN CASO DE RENOVACIÓN SE APLICARÁ UN INCREMENTO EQUIVALENTE A LA INFLACIÓN DEL AÑO EN QUE SE RENUEVE. (Art. 2269 CCAGS — máximo 10 años para vivienda)</div>

  <div class="clausula"><span class="num-clausula">QUINTA.-</span> LA RENTA MENSUAL PACTADA ES DE ${vRenta}. EL ARRENDATARIO OTORGA EN DEPÓSITO DE GARANTÍA LA CANTIDAD DE ${vDeposito}. ASIMISMO, AMBAS PARTES CONVIENEN QUE EN CASO DE QUE EL ARRENDATARIO INCURRA EN MORA EN EL PAGO DE LA RENTA, DEBERÁ CUBRIR UN INTERÉS MORATORIO MENSUAL DEL ${form.interesesMoratorios || "5"}% SOBRE LAS PENSIONES RENTÍSTICAS ADEUDADAS. (Arts. 2270, 2297 CCAGS)</div>

  <div class="clausula"><span class="num-clausula">SEXTA.-</span> VENCIDO EL PLAZO DEL PRESENTE CONTRATO, ÉSTE NO SE ENTENDERÁ PRORROGADO AUTOMÁTICAMENTE. EL ARRENDATARIO RENUNCIA AL DERECHO DE PRÓRROGA A QUE SE REFIERE EL CÓDIGO CIVIL VIGENTE PARA EL ESTADO DE AGUASCALIENTES. PODRÁ RENOVARSE ÚNICAMENTE POR ESCRITO Y POR VOLUNTAD DE AMBAS PARTES. (Art. 2269 CCAGS)</div>

  <div class="clausula"><span class="num-clausula">SÉPTIMA.-</span> EL PAGO DE LA RENTA MENSUAL DEBERÁ HACERSE ENTRE LOS DÍAS ${form.diasPago || "1 Y 4"} DE CADA MES, EN ${(form.formaPago || "EFECTIVO").toUpperCase()}, EN EL DOMICILIO UBICADO EN ${vDomPago.toUpperCase()}. EL ARRENDATARIO SE OBLIGA A ENTREGAR LOS RECIBOS DE PAGO DE SERVICIOS CORRESPONDIENTES AL MOMENTO DEL PAGO DE LA RENTA. LA OMISIÓN O NEGATIVA DE ENTREGA DARÁ LUGAR A LA RESCISIÓN DEL CONTRATO. (Art. 2298, 2296 CCAGS)</div>

  <div class="clausula"><span class="num-clausula">OCTAVA.-</span> EL ARRENDATARIO DEBERÁ ABSTENERSE DE HACER NUEVAS CONSTRUCCIONES, MODIFICACIONES O VARIAR DE ALGUNA MANERA EL BIEN ARRENDADO, A MENOS QUE LO SOLICITE A LA ARRENDADORA POR ESCRITO Y ÉSTA ACEPTE. EN CASO DE HACERLO, LAS OBRAS QUEDARÁN A FAVOR DEL INMUEBLE SIN OBLIGACIÓN DE PAGO POR PARTE DE LA ARRENDADORA. (Art. 2312 CCAGS)</div>

  <div class="clausula"><span class="num-clausula">NOVENA.-</span> EL ARRENDATARIO SE OBLIGA A PAGAR POR SU CUENTA LOS SERVICIOS DE ENERGÍA ELÉCTRICA, AGUA, GAS Y CUALQUIER OTRO SERVICIO QUE CONTRATE O USE DURANTE LA VIGENCIA DEL ARRENDAMIENTO Y HASTA LA DESOCUPACIÓN. (Art. 2296 Fracc. V CCAGS)</div>

  <div class="clausula"><span class="num-clausula">DÉCIMA.-</span> LA ARRENDADORA PODRÁ RESCINDIR EL PRESENTE CONTRATO O EXIGIR SU CUMPLIMIENTO FORZOSO EN CASO DE QUE EL ARRENDATARIO SE RETRASE EN EL PAGO DE DOS MENSUALIDADES, O POR LA VIOLACIÓN O INCUMPLIMIENTO DE CUALQUIERA DE LAS OBLIGACIONES ESTABLECIDAS EN ESTE CONTRATO O EN EL CÓDIGO CIVIL DEL ESTADO DE AGUASCALIENTES. EL ARRENDATARIO SE OBLIGA AL PAGO DE DAÑOS, PERJUICIOS Y GASTOS DE TRAMITACIÓN DEL JUICIO. (Art. 2287 CCAGS, Arts. 561 a 570 CPC AGS)</div>

  <div class="clausula"><span class="num-clausula">DÉCIMA PRIMERA.-</span> SE PROHÍBE EXPRESAMENTE AL ARRENDATARIO TRASPASAR O SUBARRENDAR TODO O PARTE DEL INMUEBLE ARRENDADO, SIENDO CAUSA DE RESCISIÓN CUALQUIER ACTO EN CONTRAVENCIÓN DE ESTA CLÁUSULA. (Art. 2312 CCAGS)</div>

  <div class="clausula"><span class="num-clausula">DÉCIMA SEGUNDA.-</span> SI UNA VEZ VENCIDO EL TÉRMINO DEL CONTRATO EL ARRENDATARIO SIGUE OCUPANDO EL INMUEBLE DE MANERA ILÍCITA, PAGARÁ A LA ARRENDADORA UNA RENTA MENSUAL DE ${vRentaIlicita}, HASTA EL DÍA QUE LO DESOCUPE Y HAGA ENTREGA MATERIAL A ENTERA SATISFACCIÓN DE LA ARRENDADORA. AUN CUANDO LA ENTREGA SEA A MEDIADOS DEL MES, DEBERÁ PAGAR LA MENSUALIDAD COMPLETA.</div>

  <div class="clausula"><span class="num-clausula">DÉCIMA TERCERA.-</span> EN CASO DE CUALQUIER CONFLICTO, LAS PARTES SE SOMETEN A LA JURISDICCIÓN DE LOS TRIBUNALES DEL ESTADO DE AGUASCALIENTES, RENUNCIANDO AL FUERO QUE LES PUDIERE CORRESPONDER POR DOMICILIO FUTURO. SERÁ A CARGO DE LA PARTE RESPONSABLE EL PAGO DE GASTOS, COSTAS Y HONORARIOS DE ABOGADOS QUE SE ORIGINEN. (Art. 2280 CCAGS)</div>

  <div class="clausula"><span class="num-clausula">DÉCIMA CUARTA.-</span> LOS CONTRATANTES SE OBLIGAN A CUMPLIR CON LAS DEMÁS DISPOSICIONES QUE LES IMPONE EL CÓDIGO CIVIL VIGENTE EN EL ESTADO Y EL CÓDIGO DE PROCEDIMIENTOS CIVILES VIGENTE EN EL ESTADO, QUE NO ESTÉN PREVISTAS EN ESTE CONTRATO.</div>

  <div class="fund-legal">
    <strong>Fundamento legal:</strong> Arts. 2269, 2270, 2277, 2279, 2280, 2283, 2287, 2293, 2296, 2297, 2298, 2312 y 2313 del Código Civil del Estado de Aguascalientes · Arts. 561 a 570 del Código de Procedimientos Civiles del Estado de Aguascalientes
  </div>

  <div class="firmas">
    <p style="text-transform:uppercase;font-weight:bold;margin-bottom:24px;">FIRMAN DE CONFORMIDAD EL PRESENTE CONTRATO, EL ${hoy}, EN LA CIUDAD DE ${vCiudad.toUpperCase()}.</p>
    <div class="fila-firmas">
      <div class="firma-bloque">
        <div style="height:65px;"></div>
        <div class="linea-firma"></div>
        <strong>${vArrendador}</strong><br/>
        <span style="font-size:11px;">ARRENDADORA${form.telefonoArrendador ? " · " + form.telefonoArrendador : ""}</span>
      </div>
      <div class="firma-bloque">
        <div style="height:65px;"></div>
        <div class="linea-firma"></div>
        <strong>${vArrendatario}</strong><br/>
        <span style="font-size:11px;">ARRENDATARIO${form.telefonoArrendatario ? " · " + form.telefonoArrendatario : ""}</span>
      </div>
    </div>
    <p style="text-transform:uppercase;font-weight:bold;text-align:center;margin:8px 0 20px;">TESTIGOS</p>
    <div class="fila-firmas">
      <div class="firma-bloque">
        <div style="height:60px;"></div>
        <div class="linea-firma"></div>
        <strong>${(form.nombreTestigo1 || "TESTIGO 1").toUpperCase()}</strong><br/>
        <span style="font-size:11px;">${form.telefonoTestigo1 || "___________________________"}</span>
      </div>
      <div class="firma-bloque">
        <div style="height:60px;"></div>
        <div class="linea-firma"></div>
        <strong>${(form.nombreTestigo2 || "TESTIGO 2").toUpperCase()}</strong><br/>
        <span style="font-size:11px;">${form.telefonoTestigo2 || "___________________________"}</span>
      </div>
    </div>
  </div>

</body>
</html>`;

    // PDF real (jsPDF + html2canvas) — descarga y activa setUltimoBlob.
    try {
      const fname = "Contrato_Arrendamiento_" + (form.nombreArrendatario||"borrador") + ".pdf";
      const pdfBlob = await generarPDFDesdeHTML(html, fname, {pieContrato:true, pieTexto: pieDelPatron(datosPatron, fechaHoraLargaAxis())});
      setUltimoBlob(pdfBlob);
    } catch(e){ console.error(e); alert("No se pudo generar el PDF. Intenta de nuevo."); }
    finally { setGenerando(false); }
  };

  const secciones = [
    { titulo:"📅 Datos generales", campos:[
      {label:"Ciudad y estado", key:"ciudad", ph:"Aguascalientes, Ags.", tipo:"text", span:2},
      {label:"Fecha del contrato", key:"fechaContrato", ph:"", tipo:"date", span:1},
    ]},
    { titulo:"👤 La Arrendadora", campos:[
      {label:"Nombre completo *", key:"nombreArrendador", ph:"Nombre de quien arrienda", tipo:"text", span:2},
      {label:"Teléfono", key:"telefonoArrendador", ph:"Ej. 449 123 4567", tipo:"text", span:1},
      {label:"Domicilio de la arrendadora", key:"domicilioArrendador", ph:"Calle, número, colonia, ciudad", tipo:"text", span:2},
    ]},
    { titulo:"🏡 El Inmueble arrendado", campos:[
      {label:"Domicilio completo del inmueble *", key:"domicilioInmueble", ph:"Calle #, Fraccionamiento, CP, Aguascalientes, Ags.", tipo:"text", span:2},
      {label:"Servicios con que cuenta", key:"serviciosInmueble", ph:"luz, agua, drenaje, gas...", tipo:"text", span:2},
    ]},
    { titulo:"🧾 Inventario del inmueble", campos:[
      {label:"Inventario (describe los elementos incluidos)", key:"inventario", ph:"1.- Cocina integral / 2.- Calentador / 3.- Baños completos...", tipo:"textarea", span:2},
    ]},
    { titulo:"🧑 El Arrendatario", campos:[
      {label:"Nombre completo *", key:"nombreArrendatario", ph:"Nombre de quien renta", tipo:"text", span:2},
      {label:"Teléfono", key:"telefonoArrendatario", ph:"Ej. 449 123 4567", tipo:"text", span:1},
      {label:"Domicilio convencional del arrendatario", key:"domicilioConvencional", ph:"Domicilio actual del arrendatario", tipo:"text", span:2},
    ]},
    { titulo:"📋 Condiciones del arrendamiento", campos:[
      {label:"Plazo en años *", key:"plazoAnios", ph:"Ej. 1", tipo:"number", span:1},
      {label:"Fecha de inicio *", key:"fechaInicio", ph:"", tipo:"date", span:1},
      {label:"Fecha de término *", key:"fechaFin", ph:"", tipo:"date", span:1},
      {label:"Renta mensual (pesos) *", key:"rentaMensual", ph:"Ej. 8000", tipo:"number", span:1},
      {label:"Depósito en garantía (pesos)", key:"deposito", ph:"Ej. 8000", tipo:"number", span:1},
      {label:"Interés moratorio mensual (%)", key:"interesesMoratorios", ph:"5", tipo:"number", span:1},
      {label:"Renta por ocupación ilícita (pesos/mes)", key:"rentaOcupacionIlicita", ph:"Ej. 16000 (doble de la renta)", tipo:"number", span:1},
    ]},
    { titulo:"💵 Forma de pago", campos:[
      {label:"Días de pago del mes", key:"diasPago", ph:"Ej. 1 y 4", tipo:"text", span:1},
      {label:"Forma de pago", key:"formaPago", ph:"efectivo / transferencia", tipo:"text", span:1},
      {label:"Domicilio de pago (si es diferente al de la arrendadora)", key:"domicilioPago", ph:"Dejar vacío si es igual al domicilio de la arrendadora", tipo:"text", span:2},
    ]},
    { titulo:"👥 Testigos", campos:[
      {label:"Nombre Testigo 1", key:"nombreTestigo1", ph:"Nombre completo", tipo:"text", span:1},
      {label:"Teléfono Testigo 1", key:"telefonoTestigo1", ph:"Ej. 449 123 4567", tipo:"text", span:1},
      {label:"Nombre Testigo 2", key:"nombreTestigo2", ph:"Nombre completo", tipo:"text", span:1},
      {label:"Teléfono Testigo 2", key:"telefonoTestigo2", ph:"", tipo:"text", span:1},
    ]},
  ];

  // ===== UI homologada al estilo claro (PASO 2) =====
  const inputStyleAV: React.CSSProperties = {
    width:"100%", padding:"9px 11px", fontSize:13, fontFamily:fontSans,
    background:"white", border:"1px solid #D1D5DB", borderRadius:8, color:"#0F172A",
    boxSizing:"border-box" as const, outline:"none",
  };
  const labelStyleAV: React.CSSProperties = {
    display:"block", fontSize:11, fontWeight:600, color:"#374151", marginBottom:4,
    letterSpacing:"0.2px",
  };
  const camposMinAV = !!(form.nombreArrendador && form.nombreArrendatario && form.domicilioInmueble);

  return (
    <div {...ZONA_DE_CAPTURA} style={{minHeight:"100vh", background:T_LIGHT.canvas, fontFamily:fontSans}}>
      <div style={{background:"linear-gradient(135deg,#DC2626,#B91C1C)", padding:"0 20px", height:58,
        display:"flex", alignItems:"center", gap:12, position:"sticky" as const, top:0, zIndex:100,
        boxShadow:"0 4px 20px rgba(220,38,38,0.30)"}}>
        <button onClick={onBack}
          style={{background:"rgba(255,255,255,0.18)", border:"1px solid rgba(255,255,255,0.30)",
            color:"white", borderRadius:8, padding:"5px 11px", cursor:"pointer",
            fontSize:12, fontWeight:600}}>← Generador legal</button>
        <span style={{color:"white", fontWeight:700, fontSize:isMobile?12:14, display:"flex",
          alignItems:"center", gap:8}}>
          <AxisIcon name="house" size={18} tone="white" withBackdrop={false} strokeWidth={2.5}/>
          Arrendamiento de Vivienda
        </span>
      </div>

      <div style={{maxWidth:760, margin:"0 auto", padding:isMobile?"16px":"24px"}}>
        <p style={{fontSize:12, color:"#64748B", margin:"0 0 18px", lineHeight:1.6}}>
          Completa los datos. Los campos marcados con <span style={{color:"#DC2626"}}>*</span> son indispensables.
        </p>

        <SelectorDeMiParte partes={PARTES_AV} elegida={miParte} tipoPersona={datosPatron.tipoPersona} fontSans={fontSans} fontSerif={fontSerif}
          onElegir={(c)=>{ setMiParte(c); setForm((f:any)=>aplicarMiParte(f, PARTES_AV, c, datosPatron)); }}/>

        {secciones.map(sec => (
          <div key={sec.titulo} style={{marginBottom:18}}>
            <div style={{fontFamily:fontSerif, fontSize:14, fontWeight:700, color:"#0F172A",
              marginBottom:10, paddingBottom:6, borderBottom:"1px solid rgba(220,38,38,0.3)",
              display:"flex", alignItems:"center", gap:8}}>
              <AxisIcon name="house" size={14} color="#DC2626" withBackdrop={false} strokeWidth={3}/>
              {sec.titulo.replace(/^[^a-zA-Z]+/, "")}
            </div>
            <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr":"1fr 1fr", gap:10}}>
              {sec.campos.map(c => (
                <div key={c.key} style={{gridColumn: c.span === 2 ? "1 / -1" : "auto"}}>
                  <label style={labelStyleAV}>{c.label}</label>
                  {c.tipo === "textarea" ? (
                    <textarea autoComplete="off" value={(form as any)[c.key]} onChange={e=>set(c.key, e.target.value)} placeholder={c.ph} rows={3}
                      style={{...inputStyleAV, minHeight:60, resize:"vertical" as const}}/>
                  ) : (
                    <input autoComplete="off" value={(form as any)[c.key]} onChange={e=>set(c.key, e.target.value)} placeholder={c.ph} type={c.tipo}
                      style={inputStyleAV}/>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}

        <div style={{background:"rgba(184,147,42,0.10)", border:"1px solid rgba(184,147,42,0.3)",
          borderRadius:10, padding:"12px 14px", marginBottom:18, display:"flex", gap:10}}>
          <AxisIcon name="scale_simple" size={16} tone="gold" withBackdrop={false} strokeWidth={3}/>
          <div style={{fontSize:11.5, color:"#374151", lineHeight:1.5}}>
            <strong>Aviso legal:</strong> Plantilla genérica conforme al Código Civil del Estado de Aguascalientes en materia de arrendamiento de vivienda. Para casos con régimen de propiedad en condominio o reglas específicas, valida con AXIS Asesoría Legal Corporativa.
          </div>
        </div>

        <button onClick={generarPDF} disabled={generando || !camposMinAV}
          style={{width:"100%", padding:"14px", borderRadius:10,
            background: camposMinAV ? "linear-gradient(135deg,#DC2626,#B91C1C)" : "#9CA3AF",
            border:"none", color:"white", fontSize:15, fontWeight:700,
            cursor: camposMinAV ? "pointer" : "not-allowed",
            boxShadow: camposMinAV ? "0 4px 16px rgba(220,38,38,0.35)" : "none",
            display:"flex", alignItems:"center", justifyContent:"center", gap:10,
            fontFamily:fontSans}}>
          <AxisIcon name="document" size={16} tone="white" withBackdrop={false} strokeWidth={3}/>
          {generando ? "Generando contrato..." : "Generar contrato en PDF"}
        </button>

        {!camposMinAV && (
          <p style={{fontSize:11, color:"#DC2626", margin:"8px 0 0", textAlign:"center" as const}}>
            Completa los campos marcados con <strong>*</strong> para generar el contrato.
          </p>
        )}
        {ultimoBlob && (
          <div style={{marginTop:14, padding:"14px 16px", background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:12, display:"flex", justifyContent:"space-between", alignItems:"center", gap:12, flexWrap:"wrap"}}>
            <div style={{fontSize:12, color:T_LIGHT.textInkSoft, flex:1, minWidth:160}}>¿Quieres guardar este contrato en un expediente?</div>
            <BotonGuardarYVincular
              user={user}
              tipoContrato={tipoContrato}
              getPDFBlob={async () => ultimoBlob!}
              nombrePDFBase={`Contrato_${tipoContrato}`}
              fontSans={fontSans} fontSerif={fontSerif} gold={gold}
            />
          </div>
        )}

      </div>
    </div>
  );
}


// #endregion
// #region ARRENDAMIENTO BODEGA
// ─── CONTRATO: ARRENDAMIENTO DE BODEGA INDUSTRIAL ────────────────────────────
// Basado en cláusulas estándar para parques industriales en Aguascalientes.
// Incluye obligado solidario, cláusula penal resumida y depósito en garantía.
function SectionBodega({title, children, fontSerif, isMobile}: {title:string; children:React.ReactNode; fontSerif:string; isMobile:boolean}) {
  return (
    <div style={{marginBottom:18}}>
      <div style={{fontFamily:fontSerif, fontSize:14, fontWeight:700, color:"#0F172A",
        marginBottom:10, paddingBottom:6, borderBottom:"1px solid rgba(184,147,42,0.3)",
        display:"flex", alignItems:"center", gap:8}}>
        <AxisIcon name="scale_simple" size={14} color="#7C3AED" withBackdrop={false} strokeWidth={3}/>
        {title}
      </div>
      <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr":"1fr 1fr", gap:10}}>
        {children}
      </div>
    </div>
  );
}

function FormArrendamientoBodegaIndustrial({user, tipoContrato, onBack, fontSans, fontSerif, gold}: {user:any; tipoContrato:string; onBack:()=>void; fontSans:string; fontSerif:string; gold:string}) {
  // El pie de este documento lo firma el patrón, no la plataforma.
  const datosPatron = useDatosPatron(user?.uid).datos;
  // Las dos partes. El arrendatario aquí es persona MORAL —tiene razón social y
  // RFC—; el arrendador se captura como persona con nombre y domicilio.
  const PARTES_ABI: ParteDeContrato[] = [
    {clave:"arrendador",   etiqueta:"Arrendador",   nombre:"nombreArrendador",       domicilio:"domicilioArrendador"},
    {clave:"arrendatario", etiqueta:"Arrendatario", nombre:"razonSocialArrendatario", rfc:"rfcArrendatario", domicilio:"domicilioFiscalArrendatario"},
  ];
  const [miParte, setMiParte] = useState("");   // por defecto, ninguna
  const isMobile = window.innerWidth < 768;
  const [tipoArrendatario, setTipoArrendatario] = useState<"fisica"|"moral">("moral");
  const [incluyeObligadoSolidario, setIncluyeObligadoSolidario] = useState<boolean>(true);
  const [incluyeIVA, setIncluyeIVA] = useState<boolean>(true);

  const [form, setForm] = useState({
    ciudad: "Aguascalientes, Ags.",
    fechaContrato: "",
    // Arrendador (puede ser una o varias personas)
    nombreArrendador: "",
    domicilioArrendador: "",
    telefonoArrendador: "",
    correoArrendador: "",
    // Arrendatario (persona moral por default)
    razonSocialArrendatario: "",
    rfcArrendatario: "",
    domicilioFiscalArrendatario: "",
    telefonoArrendatario: "",
    correoArrendatario: "",
    // Si es persona moral
    representanteLegal: "",
    escrituraConstitutiva: "",
    notarioConstitutiva: "",
    fechaConstitutiva: "",
    // Si es persona física
    nombreArrendatarioFisico: "",
    domicilioArrendatarioFisico: "",
    // Obligado solidario (opcional)
    nombreObligado: "",
    domicilioObligado: "",
    telefonoObligado: "",
    correoObligado: "",
    inmuebleGarantia: "",
    // El inmueble
    descripcionInmueble: "",
    superficieTotal: "",
    superficieArrendada: "",
    usoPermitido: "",
    // Términos
    plazoMeses: "12",
    fechaInicio: "",
    fechaFin: "",
    rentaMensual: "",
    diasPago: "5",
    bancoPago: "",
    cuentaPago: "",
    clabePago: "",
    deposito: "",
    visitasAnuales: "3",
    aumentoAnualPuntos: "2",
    interesMoratorio: "2",
    // Testigos
    nombreTestigo1: "",
    nombreTestigo2: "",
  });

  const [generando, setGenerando] = useState(false);
  const [ultimoBlob, setUltimoBlob] = useState<Blob|null>(null);
  const set = (k: string, v: any) => setForm(p => ({...p, [k]:v}));
  const F = (v: string) => v || "_______________________________";
  // FECHAS EN CASTELLANO, NO EN ISO. El campo guarda "2026-09-07" y eso salía
  // impreso tal cual en un contrato que se firma. `fechaLargaAxis` PARTE la
  // cadena en vez de construir un Date: `new Date("2026-09-01")` es medianoche
  // UTC, y en México eso es el 31 de agosto —el contrato imprimiría el día
  // anterior al pactado—. Si el valor no es una fecha ISO (hay campos de fecha
  // que son texto libre), se imprime tal como se escribió.
  const FF = (v: string) => fechaLargaAxis(v) || F(v);
  const fmt$ = (v: string) => {
    if (!v) return "_______________________________";
    const n = parseFloat(v);
    if (isNaN(n)) return v;
    return "$" + n.toLocaleString("es-MX", {minimumFractionDigits:2, maximumFractionDigits: 2}) + " M.N.";
  };

  // Calcular fecha fin automáticamente cuando cambia inicio o plazo
  useEffect(() => {
    if (form.fechaInicio && form.plazoMeses) {
      // NO `new Date("2026-09-01")`: eso es medianoche UTC y en México cae en el
      // día anterior, así que un arrendamiento de doce meses desde el 1 de
      // septiembre terminaba el 30 de agosto en vez del 31. Y aquí no es un
      // problema de formato: este valor SE GUARDA en el formulario y se imprime.
      const _p = _partesFecha(form.fechaInicio);
      const fi = _p ? new Date(_p.a, _p.m - 1, _p.d) : new Date(NaN);
      const meses = parseInt(form.plazoMeses);
      if (!isNaN(meses) && !isNaN(fi.getTime())) {
        const ff = new Date(fi);
        ff.setMonth(ff.getMonth() + meses);
        ff.setDate(ff.getDate() - 1);
        const yyyy = ff.getFullYear();
        const mm = String(ff.getMonth()+1).padStart(2,"0");
        const dd = String(ff.getDate()).padStart(2,"0");
        const newFin = `${yyyy}-${mm}-${dd}`;
        if (form.fechaFin !== newFin) set("fechaFin", newFin);
      }
    }
  }, [form.fechaInicio, form.plazoMeses]);

  // Auto-completar depósito = renta cuando cambia renta
  useEffect(() => {
    if (form.rentaMensual && !form.deposito) {
      set("deposito", form.rentaMensual);
    }
  }, [form.rentaMensual]);

  const generarPDF = () => {
    setGenerando(true);
    setTimeout(() => {
      const { jsPDF } = (window as any).jspdf;
      const doc = new jsPDF({orientation:"portrait", unit:"mm", format:"letter"});
      const W = doc.internal.pageSize.getWidth();
      const H = doc.internal.pageSize.getHeight();
      const ML = 22, MR = 22;
      const usable = W - ML - MR;
      let y = 28;   // margen superior cómodo; el contrato inicia DIRECTO con su título (AXIS va al pie)

      const checkPage = (need = 8) => {
        if (y + need > H - 34) { doc.addPage(); y = 28; }
      };

      const titulo = (txt: string) => {
        checkPage(12);
        doc.setFont("times", "bold");
        doc.setFontSize(11);
        doc.setTextColor(11,24,41);
        doc.text(txt, W/2, y, {align:"center"});
        y += 6;
      };

      const subtitulo = (txt: string) => {
        checkPage(30);   // mantiene el encabezado junto a su primer texto (evita viudas)
        doc.setFont("times", "bold");
        doc.setFontSize(10);
        doc.setTextColor(11,24,41);
        doc.text(txt, ML, y);
        y += 5;
      };

      const parrafo = (txt: string, opts?:{align?:"justify"|"left"|"center"; bold?:boolean; size?:number}) => {
        const fs = opts?.size || 9;
        doc.setFont("times", opts?.bold ? "bold" : "normal");
        doc.setFontSize(fs);
        doc.setTextColor(45,45,45);
        const lines = doc.splitTextToSize(txt, usable);
        for (const ln of lines) {
          checkPage(5);
          doc.text(ln, ML, y, {align: opts?.align==="center" ? "center" : "left", maxWidth: usable});
          y += fs*0.42 + 1.2;
        }
        y += 1;
      };

      // ───── ENCABEZADO ─────
      titulo("CONTRATO DE ARRENDAMIENTO DE BODEGA INDUSTRIAL");

      const arrendatarioNombre = tipoArrendatario === "moral"
        ? `${F(form.razonSocialArrendatario)}, representada por ${F(form.representanteLegal)}`
        : F(form.nombreArrendatarioFisico);

      const obligadoFrase = incluyeObligadoSolidario
        ? `, Y COMO OBLIGADO SOLIDARIO ${F(form.nombreObligado).toUpperCase()}`
        : "";

      parrafo(
        `Contrato de arrendamiento que celebran por una parte ${F(form.nombreArrendador).toUpperCase()}, en lo sucesivo "EL ARRENDADOR", y por la otra ${arrendatarioNombre.toUpperCase()}, en lo sucesivo "EL ARRENDATARIO"${obligadoFrase}, al tenor de las siguientes declaraciones y cláusulas:`,
        {align:"justify"}
      );

      // ───── DECLARACIONES ─────
      subtitulo("DECLARACIONES");

      // Arrendador
      parrafo("I. DECLARA EL ARRENDADOR:", {bold:true});
      parrafo(
        `a) Tener facultades para celebrar el presente contrato respecto del inmueble descrito a continuación: ${F(form.descripcionInmueble)}.`,
        {align:"justify"}
      );
      if (form.superficieTotal) {
        parrafo(`b) El inmueble cuenta con una superficie total de ${form.superficieTotal} m².`);
      }
      if (form.superficieArrendada) {
        parrafo(`c) El objeto del arrendamiento recae sobre una fracción del inmueble correspondiente a ${form.superficieArrendada} m². Se anexa plano del inmueble total donde se indica el perímetro arrendado.`);
      }
      parrafo(`d) Tener domicilio en ${F(form.domicilioArrendador)}, contar con teléfono ${F(form.telefonoArrendador)} y correo electrónico ${F(form.correoArrendador)}.`);

      // Arrendatario
      parrafo("II. DECLARA EL ARRENDATARIO:", {bold:true});
      if (tipoArrendatario === "moral") {
        parrafo(
          `a) Que es una sociedad constituida conforme a las leyes mexicanas según consta en la escritura ${F(form.escrituraConstitutiva)} de fecha ${F(form.fechaConstitutiva)}, otorgada ante la fe del Notario ${F(form.notarioConstitutiva)}.`,
          {align:"justify"}
        );
        parrafo(`b) Está representada por ${F(form.representanteLegal)}, quien cuenta con facultades suficientes para celebrar el presente contrato.`);
        parrafo(`c) Cuenta con Registro Federal de Contribuyentes ${F(form.rfcArrendatario)} y domicilio fiscal en ${F(form.domicilioFiscalArrendatario)}.`);
      } else {
        parrafo(`a) Es persona física con domicilio en ${F(form.domicilioArrendatarioFisico)} y RFC ${F(form.rfcArrendatario)}.`);
      }
      parrafo(`b) Cuenta con teléfono ${F(form.telefonoArrendatario)} y correo electrónico ${F(form.correoArrendatario)}.`);
      parrafo("c) Manifiesta su interés y voluntad de celebrar el presente contrato y contar con las facultades suficientes para suscribirlo.");

      // Obligado solidario
      if (incluyeObligadoSolidario) {
        parrafo("III. DECLARA EL OBLIGADO SOLIDARIO:", {bold:true});
        parrafo(`a) Nombre: ${F(form.nombreObligado).toUpperCase()}.`);
        parrafo(`b) Domicilio: ${F(form.domicilioObligado)}.`);
        parrafo(`c) Teléfono: ${F(form.telefonoObligado)} y correo electrónico ${F(form.correoObligado)}.`);
        parrafo(
          `d) Señala el siguiente inmueble como garantía del cumplimiento de las obligaciones del presente acto jurídico: ${F(form.inmuebleGarantia)}. Bajo protesta de decir verdad, manifiesta que dicha propiedad le pertenece de manera exclusiva, se encuentra libre de gravamen y se compromete a mantenerla en esa condición durante la vigencia del contrato.`,
          {align:"justify"}
        );
        parrafo("e) Comprende los efectos y alcances de participar como obligado solidario, asumiendo las mismas obligaciones que el arrendatario y al mismo grado.");
      }

      // ───── CLÁUSULAS ─────
      checkPage(12);
      y += 2;
      subtitulo("CLÁUSULAS");

      parrafo("PRIMERA. OBJETO DEL CONTRATO.", {bold:true});
      parrafo(
        `El ARRENDADOR concede el uso y goce del inmueble descrito en las declaraciones, en calidad de arrendamiento al ARRENDATARIO, con destino exclusivo al uso pactado en este contrato.`,
        {align:"justify"}
      );

      parrafo("SEGUNDA. VIGENCIA.", {bold:true});
      parrafo(
        `La vigencia del arrendamiento será de ${F(form.plazoMeses)} meses, contados a partir del ${FF(form.fechaInicio)} y concluyendo el ${FF(form.fechaFin)}. El contrato no se entenderá renovado por el simple hecho de continuar ocupando el inmueble o pagando/recibiendo la renta; exclusivamente se renovará mediante un nuevo acuerdo firmado por escrito.`,
        {align:"justify"}
      );
      parrafo(
        `Si el ARRENDATARIO continuara ocupando el inmueble después de vencido el plazo o tras una causal de rescisión, sin acuerdo escrito en contrario, se actualizará la cláusula penal correspondiente. El inmueble se entenderá entregado satisfactoriamente únicamente con la firma del acta de entrega y recepción, acompañada de los comprobantes de pago de todos los servicios.`,
        {align:"justify"}
      );

      parrafo("TERCERA. RENTA.", {bold:true});
      const rentaMasIVA = incluyeIVA ? " más IVA, menos retenciones que apliquen conforme a la ley" : "";
      parrafo(
        `El precio del arrendamiento mensual será por la cantidad de ${fmt$(form.rentaMensual)}${rentaMasIVA}, que deberá pagarse dentro de los primeros ${F(form.diasPago)} días hábiles del mes correspondiente.`,
        {align:"justify"}
      );
      if (form.bancoPago || form.cuentaPago || form.clabePago) {
        parrafo(`El pago se realizará mediante transferencia electrónica a la cuenta No. ${F(form.cuentaPago)} de la institución bancaria ${F(form.bancoPago)}, con CLABE interbancaria ${F(form.clabePago)}.`);
      }
      parrafo(`En caso de demora, el ARRENDATARIO pagará un interés moratorio del ${F(form.interesMoratorio)}% mensual o por fracción de mes de retraso. La omisión de pago de dos mensualidades de manera continua dará lugar a la rescisión del contrato.`);

      parrafo("CUARTA. ACTUALIZACIÓN DE RENTA.", {bold:true});
      parrafo(
        `Si las partes acuerdan firmar un nuevo contrato al término del presente, el monto de la renta se incrementará cada doce meses en el mismo porcentaje en que se hubiera incrementado el Índice Nacional de Precios al Consumidor (INPC) publicado por el Banco de México, adicionándole ${F(form.aumentoAnualPuntos)} puntos porcentuales en cada periodo. Esta cláusula es informativa.`,
        {align:"justify"}
      );

      parrafo("QUINTA. DEPÓSITO EN GARANTÍA.", {bold:true});
      parrafo(
        `El ARRENDATARIO exhibe en calidad de depósito en garantía la cantidad de ${fmt$(form.deposito)} para responder por los daños y perjuicios que se llegasen a ocasionar. De no ocurrir éstos, el ARRENDADOR se compromete a reintegrar el depósito al término del contrato, en un plazo máximo de 60 días naturales después de la entrega física del inmueble. El depósito no causará interés alguno y solo será devuelto una vez verificado el buen estado del inmueble y el pago total de servicios y multas.`,
        {align:"justify"}
      );

      parrafo("SEXTA. USO Y RESTRICCIONES.", {bold:true});
      parrafo(`El ARRENDATARIO se obliga a destinar el inmueble exclusivamente a: ${F(form.usoPermitido)}.`);
      parrafo("El ARRENDATARIO NO podrá: a) subarrendar el inmueble parcial o totalmente; b) utilizar el inmueble para un fin distinto al pactado; c) realizar mejoras al inmueble sin autorización por escrito del ARRENDADOR. Las mejoras autorizadas quedarán en beneficio del inmueble sin que proceda descuento alguno en la renta. En caso de incumplimiento se actualizará la cláusula penal.");

      parrafo("SÉPTIMA. CONSERVACIÓN, SEGUROS Y MATERIALES.", {bold:true});
      parrafo(
        "El ARRENDATARIO es el único responsable de la seguridad, conservación y reparación del inmueble. Deberá entregarlo en el mismo estado en que lo recibió, según conste en el legajo fotográfico anexo. Tiene prohibido el uso de sustancias peligrosas o corrosivas no autorizadas. Si maneja materiales de manejo especial, deberá contar con todos los permisos federales, estatales y municipales correspondientes.",
        {align:"justify"}
      );
      parrafo(
        "El ARRENDATARIO queda obligado a contratar, dentro de los 30 días naturales siguientes a la firma, un seguro que cubra cualquier daño al inmueble y a terceros derivado de cualquier accidente generado por el ARRENDATARIO, sus socios, subordinados o personas con las que guarde relación. La póliza debe cubrir el giro del negocio con la cobertura más amplia. Esta obligación es irrenunciable y el ARRENDATARIO debe notificar al ARRENDADOR la contratación dentro del mismo plazo, anexando copia de la póliza.",
        {align:"justify"}
      );
      parrafo("Si el seguro no cubre la totalidad de los daños, el ARRENDATARIO será responsable de cubrir la reparación restante o total.");

      parrafo("OCTAVA. SERVICIOS DEL INMUEBLE.", {bold:true});
      parrafo(
        "Cualquier servicio contratado o no por el ARRENDATARIO durante la vigencia del contrato u ocupación del inmueble (agua, luz, gas, teléfono, mantenimiento, etc.) correrá a su cargo. Ante cualquier incumplimiento se actualizará la cláusula penal.",
        {align:"justify"}
      );

      parrafo("NOVENA. VISITAS DE SUPERVISIÓN.", {bold:true});
      parrafo(
        `El ARRENDADOR tendrá derecho —y el ARRENDATARIO la obligación de permitir— a realizar ${F(form.visitasAnuales)} visitas de supervisión al año para verificar el estado del inmueble. Las fechas se acordarán por escrito y podrán realizarse bajo la fe pública de un notario. En caso de no permitir el acceso, se actualizará la facultad de rescisión del contrato y la cláusula penal correspondiente.`,
        {align:"justify"}
      );

      if (incluyeObligadoSolidario) {
        parrafo("DÉCIMA. OBLIGADO SOLIDARIO.", {bold:true});
        parrafo(
          "El OBLIGADO SOLIDARIO se sujeta a las mismas obligaciones que el ARRENDATARIO en cada una de las cláusulas del presente contrato. En caso de incumplimiento, responderá en el mismo grado, sin necesidad de que el ARRENDADOR agote primero el procedimiento contra el ARRENDATARIO. Si el inmueble señalado como garantía se encontrara gravado o se gravara durante la vigencia del contrato, y no se reponga la garantía en 30 días naturales, se actualizará la cláusula penal.",
          {align:"justify"}
        );
      }

      parrafo("DÉCIMA PRIMERA. RESCISIÓN.", {bold:true});
      parrafo(
        "En caso de actualizarse alguna causal de rescisión, el ARRENDADOR notificará al ARRENDATARIO vía correo electrónico, contando éste con 30 días naturales para desalojar y entregar el inmueble, así como pagar adeudos pendientes. La omisión actualizará la cláusula penal.",
        {align:"justify"}
      );

      parrafo("DÉCIMA SEGUNDA. CLÁUSULA PENAL.", {bold:true});
      parrafo(
        "Las partes convienen las siguientes sanciones por incumplimiento de las obligaciones pactadas:",
        {align:"justify"}
      );
      parrafo("1. Si el ARRENDATARIO no entrega el inmueble al término del contrato o tras la rescisión, pagará la renta al doble por mes o fracción.");
      parrafo("2. Si no paga los servicios al desocupar, pena convencional del 50% del valor total del negocio jurídico, parcialmente cubierta con el depósito.");
      parrafo("3. Si subarrenda el inmueble, total o parcialmente, se faculta la rescisión más una pena del 50% del valor total del contrato.");
      parrafo("4. Si realiza modificaciones sin autorización escrita, se faculta la rescisión más una pena del 50% del valor total del contrato.");
      parrafo("5. Si da uso distinto al pactado, se faculta la rescisión más una pena del 50% del valor total del contrato.");
      parrafo(`6. Por mora en el pago: interés del ${F(form.interesMoratorio)}% mensual sobre el adeudo. Mora de dos meses consecutivos: rescisión automática.`);
      parrafo("7. Por daños al inmueble por negligencia o malas prácticas: rescisión más pena del 50% del valor del contrato, sin perjuicio del seguro.");
      parrafo("8. Por incumplimiento de la obligación de contratar seguro: rescisión más pena del 50% del valor del contrato.");
      parrafo("9. Por almacenar materiales peligrosos sin permisos: rescisión más pena del 50% del valor del contrato.");
      parrafo("10. Por sanciones de autoridades por acción u omisión del ARRENDATARIO: éste cubrirá multas y daños, sin derecho a finalizar anticipadamente hasta subsanar.");

      parrafo("DÉCIMA TERCERA. JURISDICCIÓN.", {bold:true});
      parrafo(
        "Para la interpretación y cumplimiento del presente contrato, las partes se someten a las leyes y tribunales competentes en el Estado de Aguascalientes y renuncian a cualquier otro fuero que pudiera corresponderles.",
        {align:"justify"}
      );

      // ───── FIRMAS ─────
      checkPage(60);
      y += 6;
      doc.setFont("times","bold");
      doc.setFontSize(9);
      doc.setTextColor(11,24,41);
      doc.text(`Firmado en ${F(form.ciudad)} el día ${FF(form.fechaContrato)}.`, W/2, y, {align:"center"});
      y += 14;

      // Líneas de firma
      const colW = (usable - 8) / 2;
      const x1 = ML;
      const x2 = ML + colW + 8;
      doc.setDrawColor(11,24,41);
      doc.setLineWidth(0.3);
      doc.line(x1+8, y, x1+colW-8, y);
      doc.line(x2+8, y, x2+colW-8, y);
      y += 4;
      doc.setFont("times","bold"); doc.setFontSize(8);
      doc.text("EL ARRENDADOR", x1+colW/2, y, {align:"center"});
      doc.text("EL ARRENDATARIO", x2+colW/2, y, {align:"center"});
      y += 4;
      doc.setFont("times","normal");
      doc.text(F(form.nombreArrendador), x1+colW/2, y, {align:"center"});
      doc.text(tipoArrendatario==="moral" ? F(form.razonSocialArrendatario) : F(form.nombreArrendatarioFisico), x2+colW/2, y, {align:"center"});
      y += 4;
      if (tipoArrendatario==="moral") {
        doc.setFontSize(7);
        doc.text(`Por: ${F(form.representanteLegal)}`, x2+colW/2, y, {align:"center"});
      }

      // Obligado solidario
      if (incluyeObligadoSolidario) {
        y += 14;
        checkPage(20);
        doc.line(W/2-30, y, W/2+30, y);
        y += 4;
        doc.setFont("times","bold"); doc.setFontSize(8);
        doc.text("OBLIGADO SOLIDARIO", W/2, y, {align:"center"});
        y += 4;
        doc.setFont("times","normal");
        doc.text(F(form.nombreObligado), W/2, y, {align:"center"});
      }

      // Testigos
      if (form.nombreTestigo1 || form.nombreTestigo2) {
        y += 14;
        checkPage(20);
        doc.line(x1+8, y, x1+colW-8, y);
        doc.line(x2+8, y, x2+colW-8, y);
        y += 4;
        doc.setFont("times","bold"); doc.setFontSize(8);
        doc.text("TESTIGO 1", x1+colW/2, y, {align:"center"});
        doc.text("TESTIGO 2", x2+colW/2, y, {align:"center"});
        y += 4;
        doc.setFont("times","normal");
        doc.text(F(form.nombreTestigo1), x1+colW/2, y, {align:"center"});
        doc.text(F(form.nombreTestigo2), x2+colW/2, y, {align:"center"});
      }

      // Pie en CADA hoja, 2 líneas discretas:
      //  1) leyenda de PROTECCIÓN: deja claro en toda hoja —incluso suelta— que AXIS
      //     solo REDACTÓ el contrato a petición de parte y NO es parte del mismo;
      //  2) datos + numeración de página.
      const totalPages = doc.internal.pages.length - 1;
      for (let p = 1; p <= totalPages; p++) {
        doc.setPage(p);
        doc.setFont("times","italic"); doc.setFontSize(7);
        doc.setTextColor(130,130,130);
        pintarLeyendaContrato(doc, ML, H-17, W-ML-MR);
        doc.text(pieDelPatron(datosPatron, fechaHoraLargaAxis()), ML, H-13);
        doc.text(`Página ${p} de ${totalPages}`, W-MR, H-13, {align:"right"});
      }

      const fname = `Arrendamiento_Bodega_${(form.razonSocialArrendatario || form.nombreArrendatarioFisico || "Industrial").replace(/[^A-Za-z0-9]/g,"_")}.pdf`;
      doc.save(fname);
      try { setUltimoBlob(doc.output("blob")); } catch {}
      setGenerando(false);
    }, 200);
  };

  const inputStyle: React.CSSProperties = {
    width:"100%", padding:"9px 11px", fontSize:13, fontFamily:fontSans,
    background:"white", border:"1px solid #D1D5DB", borderRadius:8, color:"#0F172A",
    boxSizing:"border-box" as const,
  };
  const labelStyle: React.CSSProperties = {
    display:"block", fontSize:11, fontWeight:600, color:"#374151", marginBottom:4,
    letterSpacing:"0.2px",
  };

  const camposObligatoriosLlenos = !!(
    form.nombreArrendador && form.fechaContrato && form.descripcionInmueble &&
    form.rentaMensual && form.fechaInicio && form.usoPermitido &&
    (tipoArrendatario === "moral" ? form.razonSocialArrendatario && form.representanteLegal : form.nombreArrendatarioFisico)
  );

  return (
    <div {...ZONA_DE_CAPTURA} style={{minHeight:"100vh", background:T_LIGHT.canvas, fontFamily:fontSans}}>
      {/* Header */}
      <div style={{background:"linear-gradient(135deg,#7C3AED,#6D28D9)", padding:"0 20px", height:58,
        display:"flex", alignItems:"center", gap:12, position:"sticky" as const, top:0, zIndex:100,
        boxShadow:"0 4px 20px rgba(124,58,237,0.25)"}}>
        <button onClick={onBack}
          style={{background:"rgba(255,255,255,0.15)", border:"1px solid rgba(255,255,255,0.25)",
            color:"white", borderRadius:8, padding:"5px 11px", cursor:"pointer",
            fontSize:12, fontWeight:600}}>← Generador legal</button>
        <span style={{color:"white", fontWeight:700, fontSize:14, display:"flex",
          alignItems:"center", gap:8}}>
          <AxisIcon name="building" size={18} tone="white" withBackdrop={false} strokeWidth={2.5}/>
          Arrendamiento de Bodega Industrial
        </span>
      </div>

      <div style={{maxWidth:760, margin:"0 auto", padding:isMobile?"16px":"24px"}}>
        <p style={{fontSize:12, color:"#64748B", margin:"0 0 18px", lineHeight:1.6}}>
          Completa los datos. Los campos marcados con <span style={{color:"#DC2626"}}>*</span> son indispensables para generar el contrato.
        </p>

        <SelectorDeMiParte partes={PARTES_ABI} elegida={miParte} tipoPersona={datosPatron.tipoPersona} fontSans={fontSans} fontSerif={fontSerif}
          onElegir={(c)=>{ setMiParte(c); setForm((f:any)=>aplicarMiParte(f, PARTES_ABI, c, datosPatron));
            // El arrendatario tiene variante de sociedad; se pone del lado correcto.
            if (c === "arrendatario" && datosPatron.tipoPersona) setTipoArrendatario(datosPatron.tipoPersona);
          }}/>

        {/* Datos generales */}
        <SectionBodega title="Datos generales" fontSerif={fontSerif} isMobile={isMobile}>
          <div>
            <label style={labelStyle}>Ciudad y estado de firma <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" style={inputStyle} value={form.ciudad} onChange={e => set("ciudad", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Fecha de firma <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" type="date" style={inputStyle} value={form.fechaContrato} onChange={e => set("fechaContrato", e.target.value)}/>
          </div>
        </SectionBodega>

        {/* Arrendador */}
        <SectionBodega title="El Arrendador (propietario)" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Nombre completo del arrendador <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" style={inputStyle} value={form.nombreArrendador} onChange={e => set("nombreArrendador", e.target.value)}
              placeholder="Si son varios, sepáralos con 'y' (ej. JUANA PÉREZ Y MARÍA PÉREZ)"/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Domicilio del arrendador</label>
            <input autoComplete="off" style={inputStyle} value={form.domicilioArrendador} onChange={e => set("domicilioArrendador", e.target.value)}
              placeholder="Av. Universidad #1302, Local 25, Plaza Albera..."/>
          </div>
          <div>
            <label style={labelStyle}>Teléfono</label>
            <input autoComplete="off" style={inputStyle} value={form.telefonoArrendador} onChange={e => set("telefonoArrendador", e.target.value)}
              placeholder="449 123 4567"/>
          </div>
          <div>
            <label style={labelStyle}>Correo electrónico</label>
            <input autoComplete="off" style={inputStyle} value={form.correoArrendador} onChange={e => set("correoArrendador", e.target.value)}
              placeholder="contacto@correo.com"/>
          </div>
        </SectionBodega>

        {/* Arrendatario - selector tipo */}
        <SectionBodega title="El Arrendatario (quien renta)" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Tipo de persona <span style={{color:"#DC2626"}}>*</span></label>
            <div style={{display:"flex", gap:8}}>
              {(["moral","fisica"] as const).map(t => (
                <button key={t} onClick={() => setTipoArrendatario(t)}
                  style={{flex:1, padding:"9px 12px", borderRadius:8, fontSize:12, fontWeight:600,
                    fontFamily:fontSans, cursor:"pointer",
                    background: tipoArrendatario===t ? "#7C3AED" : "white",
                    color: tipoArrendatario===t ? "white" : "#374151",
                    border: tipoArrendatario===t ? "1px solid #7C3AED" : "1px solid #D1D5DB"}}>
                  {t === "moral" ? "Persona moral (empresa)" : "Persona física"}
                </button>
              ))}
            </div>
          </div>

          {tipoArrendatario === "moral" ? (
            <>
              <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
                <label style={labelStyle}>Razón social <span style={{color:"#DC2626"}}>*</span></label>
                <input autoComplete="off" style={inputStyle} value={form.razonSocialArrendatario} onChange={e => set("razonSocialArrendatario", e.target.value)}
                  placeholder="EMPRESA EJEMPLO S.A. DE C.V."/>
              </div>
              <div>
                <label style={labelStyle}>RFC</label>
                <input autoComplete="off" style={inputStyle} value={form.rfcArrendatario} onChange={e => set("rfcArrendatario", e.target.value)}
                  placeholder="EJE930126TZ7"/>
              </div>
              <div>
                <label style={labelStyle}>Representante legal <span style={{color:"#DC2626"}}>*</span></label>
                <input autoComplete="off" style={inputStyle} value={form.representanteLegal} onChange={e => set("representanteLegal", e.target.value)}
                  placeholder="Nombre del apoderado"/>
              </div>
              <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
                <label style={labelStyle}>Domicilio fiscal</label>
                <input autoComplete="off" style={inputStyle} value={form.domicilioFiscalArrendatario} onChange={e => set("domicilioFiscalArrendatario", e.target.value)}/>
              </div>
              <div>
                <label style={labelStyle}>Escritura constitutiva</label>
                <input autoComplete="off" style={inputStyle} value={form.escrituraConstitutiva} onChange={e => set("escrituraConstitutiva", e.target.value)}
                  placeholder="No. 19537 Tomo 125 Libro 4"/>
              </div>
              <div>
                <label style={labelStyle}>Fecha de constitución</label>
                <input autoComplete="off" style={inputStyle} value={form.fechaConstitutiva} onChange={e => set("fechaConstitutiva", e.target.value)}
                  placeholder="22 de enero de 1993"/>
              </div>
              <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
                <label style={labelStyle}>Notario y ciudad</label>
                <input autoComplete="off" style={inputStyle} value={form.notarioConstitutiva} onChange={e => set("notarioConstitutiva", e.target.value)}
                  placeholder="Lic. ___, Notario No. __ en Aguascalientes, Ags."/>
              </div>
            </>
          ) : (
            <>
              <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
                <label style={labelStyle}>Nombre completo <span style={{color:"#DC2626"}}>*</span></label>
                <input autoComplete="off" style={inputStyle} value={form.nombreArrendatarioFisico} onChange={e => set("nombreArrendatarioFisico", e.target.value)}/>
              </div>
              <div>
                <label style={labelStyle}>RFC</label>
                <input autoComplete="off" style={inputStyle} value={form.rfcArrendatario} onChange={e => set("rfcArrendatario", e.target.value)}/>
              </div>
              <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
                <label style={labelStyle}>Domicilio</label>
                <input autoComplete="off" style={inputStyle} value={form.domicilioArrendatarioFisico} onChange={e => set("domicilioArrendatarioFisico", e.target.value)}/>
              </div>
            </>
          )}

          <div>
            <label style={labelStyle}>Teléfono</label>
            <input autoComplete="off" style={inputStyle} value={form.telefonoArrendatario} onChange={e => set("telefonoArrendatario", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Correo electrónico</label>
            <input autoComplete="off" style={inputStyle} value={form.correoArrendatario} onChange={e => set("correoArrendatario", e.target.value)}/>
          </div>
        </SectionBodega>

        {/* Obligado solidario */}
        <SectionBodega title="Obligado solidario (recomendado)" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1", padding:"10px 12px",
            background:"rgba(124,58,237,0.05)", borderRadius:8,
            border:"1px solid rgba(124,58,237,0.2)"}}>
            <label style={{display:"flex", alignItems:"center", gap:8, cursor:"pointer", fontSize:12, color:"#374151"}}>
              <input autoComplete="off" type="checkbox" checked={incluyeObligadoSolidario}
                onChange={e => setIncluyeObligadoSolidario(e.target.checked)}/>
              <strong>Incluir obligado solidario</strong> — recomendado para arrendamientos industriales: garantiza pago en caso de incumplimiento del arrendatario.
            </label>
          </div>

          {incluyeObligadoSolidario && (
            <>
              <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
                <label style={labelStyle}>Nombre completo</label>
                <input autoComplete="off" style={inputStyle} value={form.nombreObligado} onChange={e => set("nombreObligado", e.target.value)}/>
              </div>
              <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
                <label style={labelStyle}>Domicilio</label>
                <input autoComplete="off" style={inputStyle} value={form.domicilioObligado} onChange={e => set("domicilioObligado", e.target.value)}/>
              </div>
              <div>
                <label style={labelStyle}>Teléfono</label>
                <input autoComplete="off" style={inputStyle} value={form.telefonoObligado} onChange={e => set("telefonoObligado", e.target.value)}/>
              </div>
              <div>
                <label style={labelStyle}>Correo electrónico</label>
                <input autoComplete="off" style={inputStyle} value={form.correoObligado} onChange={e => set("correoObligado", e.target.value)}/>
              </div>
              <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
                <label style={labelStyle}>Inmueble que ofrece como garantía</label>
                <textarea autoComplete="off" style={{...inputStyle, minHeight:60, resize:"vertical" as const}} value={form.inmuebleGarantia}
                  onChange={e => set("inmuebleGarantia", e.target.value)}
                  placeholder="Casa habitación ubicada en Calle ___, No. ___, Colonia ___, Aguascalientes, Ags. (libre de gravamen)"/>
              </div>
            </>
          )}
        </SectionBodega>

        {/* El inmueble */}
        <SectionBodega title="El inmueble (objeto del contrato)" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Descripción y ubicación del inmueble <span style={{color:"#DC2626"}}>*</span></label>
            <textarea autoComplete="off" style={{...inputStyle, minHeight:70, resize:"vertical" as const}} value={form.descripcionInmueble}
              onChange={e => set("descripcionInmueble", e.target.value)}
              placeholder="Lote No. ___, Manzana ___, Parque Industrial del Valle de Aguascalientes, Circuito Aguascalientes Norte #151, Fraccionamiento Parque Industrial, San Francisco de los Romo, Aguascalientes."/>
          </div>
          <div>
            <label style={labelStyle}>Superficie total del inmueble (m²)</label>
            <input autoComplete="off" style={inputStyle} value={form.superficieTotal} onChange={e => set("superficieTotal", e.target.value)}
              placeholder="11,400.28"/>
          </div>
          <div>
            <label style={labelStyle}>Superficie arrendada (m²) — solo si renta una fracción</label>
            <input autoComplete="off" style={inputStyle} value={form.superficieArrendada} onChange={e => set("superficieArrendada", e.target.value)}
              placeholder="2,500"/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Uso permitido del inmueble <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" style={inputStyle} value={form.usoPermitido} onChange={e => set("usoPermitido", e.target.value)}
              placeholder="Almacenamiento y distribución de alambres y aceros"/>
          </div>
        </SectionBodega>

        {/* Términos económicos */}
        <SectionBodega title="Términos económicos" fontSerif={fontSerif} isMobile={isMobile}>
          <div>
            <label style={labelStyle}>Plazo (meses) <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" type="number" style={inputStyle} value={form.plazoMeses} onChange={e => set("plazoMeses", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Fecha de inicio <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" type="date" style={inputStyle} value={form.fechaInicio} onChange={e => set("fechaInicio", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Fecha de término (auto-calculada)</label>
            <input autoComplete="off" type="date" style={inputStyle} value={form.fechaFin} onChange={e => set("fechaFin", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Renta mensual (MXN) <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" type="number" style={inputStyle} value={form.rentaMensual} onChange={e => set("rentaMensual", e.target.value)}
              placeholder="155375"/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1", padding:"8px 12px",
            background:"rgba(124,58,237,0.05)", borderRadius:8,
            border:"1px solid rgba(124,58,237,0.15)"}}>
            <label style={{display:"flex", alignItems:"center", gap:8, cursor:"pointer", fontSize:12, color:"#374151"}}>
              <input autoComplete="off" type="checkbox" checked={incluyeIVA} onChange={e => setIncluyeIVA(e.target.checked)}/>
              <strong>Renta + IVA</strong> (la cantidad indicada es antes del 16% de IVA, menos retenciones aplicables)
            </label>
          </div>
          <div>
            <label style={labelStyle}>Día límite de pago (primeros __ días hábiles)</label>
            <input autoComplete="off" type="number" style={inputStyle} value={form.diasPago} onChange={e => set("diasPago", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Depósito en garantía (MXN)</label>
            <input autoComplete="off" type="number" style={inputStyle} value={form.deposito} onChange={e => set("deposito", e.target.value)}
              placeholder="Por defecto: igual a la renta"/>
          </div>
          <div>
            <label style={labelStyle}>Banco para pago</label>
            <input autoComplete="off" style={inputStyle} value={form.bancoPago} onChange={e => set("bancoPago", e.target.value)}
              placeholder="BBVA, Santander, etc."/>
          </div>
          <div>
            <label style={labelStyle}>Cuenta bancaria</label>
            <input autoComplete="off" style={inputStyle} value={form.cuentaPago} onChange={e => set("cuentaPago", e.target.value)}/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>CLABE interbancaria</label>
            <input autoComplete="off" style={inputStyle} value={form.clabePago} onChange={e => set("clabePago", e.target.value)}
              placeholder="18 dígitos"/>
          </div>
        </SectionBodega>

        {/* Condiciones especiales */}
        <SectionBodega title="Condiciones especiales" fontSerif={fontSerif} isMobile={isMobile}>
          <div>
            <label style={labelStyle}>Visitas anuales del arrendador</label>
            <input autoComplete="off" type="number" style={inputStyle} value={form.visitasAnuales} onChange={e => set("visitasAnuales", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Aumento anual: INPC + ___ puntos %</label>
            <input autoComplete="off" type="number" step="0.5" style={inputStyle} value={form.aumentoAnualPuntos} onChange={e => set("aumentoAnualPuntos", e.target.value)}/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Interés moratorio mensual (%)</label>
            <input autoComplete="off" type="number" step="0.1" style={inputStyle} value={form.interesMoratorio} onChange={e => set("interesMoratorio", e.target.value)}/>
          </div>
        </SectionBodega>

        {/* Testigos */}
        <SectionBodega title="Testigos (opcionales)" fontSerif={fontSerif} isMobile={isMobile}>
          <div>
            <label style={labelStyle}>Nombre Testigo 1</label>
            <input autoComplete="off" style={inputStyle} value={form.nombreTestigo1} onChange={e => set("nombreTestigo1", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Nombre Testigo 2</label>
            <input autoComplete="off" style={inputStyle} value={form.nombreTestigo2} onChange={e => set("nombreTestigo2", e.target.value)}/>
          </div>
        </SectionBodega>

        {/* Aviso legal */}
        <div style={{background:"rgba(184,147,42,0.10)", border:"1px solid rgba(184,147,42,0.3)",
          borderRadius:10, padding:"12px 14px", marginBottom:18, display:"flex", gap:10}}>
          <AxisIcon name="scale_simple" size={16} tone="gold" withBackdrop={false} strokeWidth={3}/>
          <div style={{fontSize:11.5, color:"#374151", lineHeight:1.5}}>
            <strong>Aviso legal:</strong> Este contrato es una plantilla genérica conforme a la legislación de Aguascalientes y la legislación federal aplicable. Para arrendamientos industriales con cláusulas específicas (REPSE, manejo de residuos peligrosos, condiciones técnicas particulares), te recomendamos validarlo con un abogado del despacho AXIS antes de firmarlo.
          </div>
        </div>

        {/* Botón generar */}
        <button onClick={generarPDF} disabled={generando || !camposObligatoriosLlenos}
          style={{width:"100%", padding:"14px", borderRadius:10,
            background: camposObligatoriosLlenos
              ? "linear-gradient(135deg,#7C3AED,#6D28D9)"
              : "#9CA3AF",
            border:"none", color:"white", fontSize:15, fontWeight:700,
            cursor: camposObligatoriosLlenos ? "pointer" : "not-allowed",
            boxShadow: camposObligatoriosLlenos ? "0 4px 16px rgba(124,58,237,0.35)" : "none",
            display:"flex", alignItems:"center", justifyContent:"center", gap:10,
            fontFamily:fontSans}}>
          <AxisIcon name="document" size={16} tone="white" withBackdrop={false} strokeWidth={3}/>
          {generando ? "Generando contrato..." : "Generar contrato en PDF"}
        </button>

        {!camposObligatoriosLlenos && (
          <p style={{fontSize:11, color:"#DC2626", margin:"8px 0 0", textAlign:"center" as const}}>
            Completa los campos marcados con <strong>*</strong> para generar el contrato.
          </p>
        )}
        {ultimoBlob && (
          <div style={{marginTop:14, padding:"14px 16px", background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:12, display:"flex", justifyContent:"space-between", alignItems:"center", gap:12, flexWrap:"wrap"}}>
            <div style={{fontSize:12, color:T_LIGHT.textInkSoft, flex:1, minWidth:160}}>¿Quieres guardar este contrato en un expediente?</div>
            <BotonGuardarYVincular
              user={user}
              tipoContrato={tipoContrato}
              getPDFBlob={async () => ultimoBlob!}
              nombrePDFBase={`Contrato_${tipoContrato}`}
              fontSans={fontSans} fontSerif={fontSerif} gold={gold}
            />
          </div>
        )}
      </div>
    </div>
  );
}


// #endregion
// #region COMPRAVENTA VEHÍCULO
// ─── CONTRATO: COMPRAVENTA DE VEHÍCULO ────────────────────────────────────────
// Fundamento: Código Civil del Estado de Aguascalientes, arts. 2119 y siguientes
// (compraventa, elementos esenciales, saneamiento por evicción y vicios ocultos).
// Es contrato privado válido entre partes — NO requiere notario para vehículos.
function SectionVehiculo({title, iconColor, children, fontSerif, isMobile}: {title:string; iconColor?:string; children:React.ReactNode; fontSerif:string; isMobile:boolean}) {
  return (
    <div style={{marginBottom:18}}>
      <div style={{fontFamily:fontSerif, fontSize:14, fontWeight:700, color:"#0F172A",
        marginBottom:10, paddingBottom:6, borderBottom:"1px solid rgba(37,99,235,0.3)",
        display:"flex", alignItems:"center", gap:8}}>
        <AxisIcon name="suite_flotilla" size={14} color={iconColor || "#2563EB"} withBackdrop={false} strokeWidth={3}/>
        {title}
      </div>
      <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr":"1fr 1fr", gap:10}}>
        {children}
      </div>
    </div>
  );
}

function FormCompraventaVehiculo({user, tipoContrato, onBack, fontSans, fontSerif, gold}: {user:any; tipoContrato:string; onBack:()=>void; fontSans:string; fontSerif:string; gold:string}) {
  // El pie de este documento lo firma el patrón, no la plataforma.
  const datosPatron = useDatosPatron(user?.uid).datos;
  // Las dos partes de este contrato, para el control de "cuál soy yo".
  // LAS DOS declaran "Ser persona física mayor de edad" y este formulario NO
  // ofrece cambiarlo, así que si la empresa es moral hay que avisarlo.
  const PARTES_CVV: ParteDeContrato[] = [
    {clave:"vendedor",  etiqueta:"Vendedor",  nombre:"nombreVendedor",  rfc:"rfcVendedor",  domicilio:"domicilioVendedor", declaraPersonaFisica:true},
    {clave:"comprador", etiqueta:"Comprador", nombre:"nombreComprador", rfc:"rfcComprador", domicilio:"domicilioComprador", declaraPersonaFisica:true},
  ];
  const [miParte, setMiParte] = useState("");   // por defecto, ninguna
  const isMobile = window.innerWidth < 768;
  const [formaPago, setFormaPago] = useState<"contado"|"parcialidades">("contado");

  const [form, setForm] = useState({
    ciudad: "Aguascalientes, Ags.",
    fechaContrato: "",
    // Vendedor
    nombreVendedor: "",
    ineVendedor: "",
    rfcVendedor: "",
    domicilioVendedor: "",
    telefonoVendedor: "",
    // Comprador
    nombreComprador: "",
    ineComprador: "",
    rfcComprador: "",
    domicilioComprador: "",
    telefonoComprador: "",
    // Vehículo
    marca: "",
    modelo: "",
    anio: "",
    color: "",
    nivSerie: "",
    numMotor: "",
    placas: "",
    facturaFolio: "",
    facturaFecha: "",
    facturaEmisor: "",
    estadoVehiculo: "Buen estado de funcionamiento mecánico y carrocería",
    // Términos
    precio: "",
    anticipo: "",
    saldo: "",
    plazoMeses: "12",
    diaPagoMensual: "5",
    fechaEntrega: "",
    lugarEntrega: "",
    // Reserva de dominio (sólo aplica si parcialidades)
    reservaDominio: true,
    // Testigos
    nombreTestigo1: "",
    nombreTestigo2: "",
  });

  const [generando, setGenerando] = useState(false);
  const [ultimoBlob, setUltimoBlob] = useState<Blob|null>(null);
  const set = (k: string, v: any) => setForm(p => ({...p, [k]:v}));
  const F = (v: string) => v || "_______________________________";
  // FECHAS EN CASTELLANO, NO EN ISO. El campo guarda "2026-09-07" y eso salía
  // impreso tal cual en un contrato que se firma. `fechaLargaAxis` PARTE la
  // cadena en vez de construir un Date: `new Date("2026-09-01")` es medianoche
  // UTC, y en México eso es el 31 de agosto —el contrato imprimiría el día
  // anterior al pactado—. Si el valor no es una fecha ISO (hay campos de fecha
  // que son texto libre), se imprime tal como se escribió.
  const FF = (v: string) => fechaLargaAxis(v) || F(v);

  // Auto-cálculo de saldo cuando cambia precio o anticipo
  useEffect(() => {
    if (formaPago === "parcialidades" && form.precio && form.anticipo) {
      const p = parseFloat(form.precio);
      const a = parseFloat(form.anticipo);
      if (!isNaN(p) && !isNaN(a)) {
        const s = (p - a).toString();
        if (form.saldo !== s) set("saldo", s);
      }
    }
  }, [form.precio, form.anticipo, formaPago, form.saldo]);

  // Número a letras simple
  const numeroALetras = (n: number): string => {
    const unidades = ["","UN","DOS","TRES","CUATRO","CINCO","SEIS","SIETE","OCHO","NUEVE","DIEZ","ONCE","DOCE","TRECE","CATORCE","QUINCE","DIECISEIS","DIECISIETE","DIECIOCHO","DIECINUEVE"];
    const decenas = ["","DIEZ","VEINTE","TREINTA","CUARENTA","CINCUENTA","SESENTA","SETENTA","OCHENTA","NOVENTA"];
    const centenas = ["","CIEN","DOSCIENTOS","TRESCIENTOS","CUATROCIENTOS","QUINIENTOS","SEISCIENTOS","SETECIENTOS","OCHOCIENTOS","NOVECIENTOS"];
    if (n === 0) return "CERO";
    if (n < 20) return unidades[n];
    if (n < 100) return decenas[Math.floor(n/10)] + (n%10 ? " Y " + unidades[n%10] : "");
    if (n < 1000) return centenas[Math.floor(n/100)] + (n%100 ? " " + numeroALetras(n%100) : "");
    if (n < 10000) return unidades[Math.floor(n/1000)] + " MIL" + (n%1000 ? " " + numeroALetras(n%1000) : "");
    if (n < 1000000) return numeroALetras(Math.floor(n/1000)) + " MIL" + (n%1000 ? " " + numeroALetras(n%1000) : "");
    return numeroALetras(Math.floor(n/1000000)) + " MILLONES" + (n%1000000 ? " " + numeroALetras(n%1000000) : "");
  };

  const fmt$ = (v: string) => {
    if (!v) return "_______________________________";
    const n = parseFloat(v);
    if (isNaN(n)) return v;
    return "$" + n.toLocaleString("es-MX", {minimumFractionDigits:2, maximumFractionDigits: 2}) + " M.N. (" + numeroALetras(Math.floor(n)) + " PESOS " + String(Math.round((n%1)*100)).padStart(2,"0") + "/100 M.N.)";
  };

  const generarPDF = () => {
    setGenerando(true);
    setTimeout(() => {
      const { jsPDF } = (window as any).jspdf;
      const doc = new jsPDF({orientation:"portrait", unit:"mm", format:"letter"});
      const W = doc.internal.pageSize.getWidth();
      const H = doc.internal.pageSize.getHeight();
      const ML = 22, MR = 22;
      const usable = W - ML - MR;
      let y = 28;   // margen superior cómodo; el contrato inicia DIRECTO con su título (AXIS va al pie)

      const checkPage = (need = 8) => {
        if (y + need > H - 34) { doc.addPage(); y = 28; }
      };

      const titulo = (txt: string) => {
        checkPage(12);
        doc.setFont("times", "bold");
        doc.setFontSize(11);
        doc.setTextColor(11,24,41);
        doc.text(txt, W/2, y, {align:"center"});
        y += 7;
      };

      const subtitulo = (txt: string) => {
        checkPage(30);   // mantiene el encabezado junto a su primer texto (evita viudas)
        doc.setFont("times", "bold");
        doc.setFontSize(10);
        doc.setTextColor(11,24,41);
        doc.text(txt, ML, y);
        y += 5;
      };

      const parrafo = (txt: string, opts?:{align?:"justify"|"left"|"center"; bold?:boolean; size?:number}) => {
        const fs = opts?.size || 9;
        doc.setFont("times", opts?.bold ? "bold" : "normal");
        doc.setFontSize(fs);
        doc.setTextColor(45,45,45);
        const lines = doc.splitTextToSize(txt, usable);
        for (const ln of lines) {
          checkPage(5);
          doc.text(ln, ML, y, {align: opts?.align==="center" ? "center" : "left", maxWidth: usable});
          y += fs*0.42 + 1.2;
        }
        y += 1;
      };

      // ───── ENCABEZADO ─────
      titulo("CONTRATO DE COMPRAVENTA DE VEHÍCULO");

      parrafo(
        `Contrato de compraventa que celebran por una parte ${F(form.nombreVendedor).toUpperCase()}, en lo sucesivo "EL VENDEDOR", y por la otra ${F(form.nombreComprador).toUpperCase()}, en lo sucesivo "EL COMPRADOR", al tenor de las siguientes declaraciones y cláusulas:`,
        {align:"justify"}
      );

      // ───── DECLARACIONES ─────
      subtitulo("DECLARACIONES");

      parrafo("I. DECLARA EL VENDEDOR:", {bold:true});
      parrafo(`a) Ser persona física mayor de edad, con plena capacidad jurídica para celebrar el presente contrato.`);
      parrafo(`b) Identificarse con credencial de elector con clave ${F(form.ineVendedor)}, contar con RFC ${F(form.rfcVendedor)} y tener su domicilio en ${F(form.domicilioVendedor)}.`);
      parrafo(`c) Ser legítimo propietario del vehículo descrito en la cláusula PRIMERA del presente contrato, libre de gravámenes, embargos, adeudos por tenencias, refrendos o multas de tránsito al momento de la firma.`);

      parrafo("II. DECLARA EL COMPRADOR:", {bold:true});
      parrafo(`a) Ser persona física mayor de edad, con plena capacidad jurídica para celebrar el presente contrato.`);
      parrafo(`b) Identificarse con credencial de elector con clave ${F(form.ineComprador)}, contar con RFC ${F(form.rfcComprador)} y tener su domicilio en ${F(form.domicilioComprador)}.`);
      parrafo(`c) Estar interesado en adquirir el vehículo descrito en la cláusula PRIMERA, conocer su estado físico y mecánico actual, y aceptarlo en las condiciones en que se encuentra.`);

      // ───── CLÁUSULAS ─────
      checkPage(12);
      y += 2;
      subtitulo("CLÁUSULAS");

      parrafo("PRIMERA. OBJETO DEL CONTRATO.", {bold:true});
      parrafo(
        `EL VENDEDOR transmite la propiedad y EL COMPRADOR adquiere el siguiente vehículo automotor, con las características que a continuación se detallan:`,
        {align:"justify"}
      );
      parrafo(`Marca: ${F(form.marca)}`);
      parrafo(`Modelo (línea): ${F(form.modelo)}`);
      parrafo(`Año: ${F(form.anio)}`);
      parrafo(`Color: ${F(form.color)}`);
      parrafo(`Número de Identificación Vehicular (NIV/serie): ${F(form.nivSerie)}`);
      parrafo(`Número de motor: ${F(form.numMotor)}`);
      parrafo(`Placas de circulación: ${F(form.placas)}`);
      if (form.facturaFolio || form.facturaFecha) {
        parrafo(`Factura original No. ${F(form.facturaFolio)} de fecha ${F(form.facturaFecha)} expedida por ${F(form.facturaEmisor)}.`);
      }
      parrafo(`Estado del vehículo al momento de la entrega: ${F(form.estadoVehiculo)}.`);

      parrafo("SEGUNDA. PRECIO Y FORMA DE PAGO.", {bold:true});
      parrafo(`El precio total convenido por la compraventa del vehículo es la cantidad de ${fmt$(form.precio)}, que EL COMPRADOR pagará a EL VENDEDOR de la siguiente manera:`, {align:"justify"});

      if (formaPago === "contado") {
        parrafo(`PAGO DE CONTADO: la cantidad total se entrega a EL VENDEDOR a la firma del presente contrato, sirviendo el mismo como recibo legal en la cantidad mencionada. EL VENDEDOR otorga a EL COMPRADOR el más amplio finiquito que en derecho proceda respecto del precio.`, {align:"justify"});
      } else {
        parrafo(`PAGO EN PARCIALIDADES:`, {bold:true});
        parrafo(`a) ANTICIPO: ${fmt$(form.anticipo)} entregados a la firma del presente contrato, sirviendo el mismo como recibo legal por dicha cantidad.`, {align:"justify"});
        parrafo(`b) SALDO: ${fmt$(form.saldo)} pagaderos en ${F(form.plazoMeses)} mensualidades iguales y consecutivas, dentro de los primeros ${F(form.diaPagoMensual)} días de cada mes.`, {align:"justify"});
        if (form.reservaDominio) {
          parrafo(`c) RESERVA DE DOMINIO: EL VENDEDOR conserva la propiedad del vehículo hasta el pago total del precio. La transmisión definitiva de propiedad se perfeccionará al momento del pago de la última mensualidad.`, {align:"justify"});
        }
        parrafo(`d) En caso de mora en el pago de dos mensualidades consecutivas, EL VENDEDOR podrá rescindir el contrato sin necesidad de declaración judicial, con derecho a recuperar el vehículo y conservar las cantidades pagadas en concepto de pena convencional.`, {align:"justify"});
      }

      parrafo("TERCERA. ENTREGA Y POSESIÓN.", {bold:true});
      parrafo(
        `EL VENDEDOR entrega el vehículo objeto de este contrato a EL COMPRADOR el día ${FF(form.fechaEntrega)} en ${F(form.lugarEntrega || form.ciudad)}, junto con la siguiente documentación: factura original endosada, tarjeta de circulación vigente, comprobante de pago de tenencia/refrendo del ejercicio fiscal vigente y juego completo de llaves. La firma del presente contrato hace prueba plena de la entrega satisfactoria del vehículo.`,
        {align:"justify"}
      );

      parrafo("CUARTA. SANEAMIENTO POR EVICCIÓN.", {bold:true});
      parrafo(
        `Conforme a los artículos aplicables del Código Civil del Estado de Aguascalientes, EL VENDEDOR responderá por los daños y perjuicios que se ocasionen a EL COMPRADOR si fuere privado del vehículo, total o parcialmente, por sentencia ejecutoriada que tenga su origen en causa anterior a la venta. EL VENDEDOR garantiza que el vehículo es de su exclusiva propiedad y se encuentra libre de gravámenes, embargos o cualquier limitación al dominio.`,
        {align:"justify"}
      );

      parrafo("QUINTA. SANEAMIENTO POR VICIOS OCULTOS.", {bold:true});
      parrafo(
        `EL VENDEDOR manifiesta que el vehículo no tiene vicios ocultos a la fecha de su entrega. EL COMPRADOR ha tenido oportunidad de revisarlo física y mecánicamente, aceptándolo en el estado en que se encuentra. Cualquier defecto manifiestamente apreciable a simple vista se considera conocido y aceptado por EL COMPRADOR. Para los vicios ocultos no apreciables al momento de la entrega, EL VENDEDOR responderá conforme a las disposiciones del Código Civil del Estado de Aguascalientes en la materia.`,
        {align:"justify"}
      );

      parrafo("SEXTA. CAMBIO DE PROPIETARIO Y OBLIGACIONES FISCALES.", {bold:true});
      parrafo(
        `EL COMPRADOR se obliga a realizar el trámite de cambio de propietario ante las autoridades correspondientes dentro de los 30 días naturales siguientes a la firma del presente contrato. A partir de la fecha de entrega, todas las tenencias, refrendos, multas, infracciones y obligaciones fiscales o administrativas relacionadas con el vehículo serán de la exclusiva responsabilidad de EL COMPRADOR.`,
        {align:"justify"}
      );

      parrafo("SÉPTIMA. GASTOS.", {bold:true});
      parrafo(
        `Los gastos derivados del cambio de propietario, expedición de nuevas placas o cualquier trámite administrativo posterior a la firma del contrato serán por cuenta exclusiva de EL COMPRADOR.`,
        {align:"justify"}
      );

      parrafo("OCTAVA. JURISDICCIÓN.", {bold:true});
      parrafo(
        `Para la interpretación y cumplimiento del presente contrato, las partes se someten expresamente a las leyes y tribunales competentes en el Estado de Aguascalientes, renunciando a cualquier otro fuero que pudiera corresponderles por razón de su domicilio presente o futuro.`,
        {align:"justify"}
      );

      parrafo("NOVENA. ACEPTACIÓN.", {bold:true});
      parrafo(
        `Las partes manifiestan que en la celebración del presente contrato no existe error, dolo, mala fe ni vicio alguno del consentimiento, firmándolo de conformidad por duplicado.`,
        {align:"justify"}
      );

      // ───── FIRMAS ─────
      checkPage(45);
      y += 6;
      doc.setFont("times","bold");
      doc.setFontSize(9);
      doc.setTextColor(11,24,41);
      doc.text(`Firmado en ${F(form.ciudad)} el día ${FF(form.fechaContrato)}.`, W/2, y, {align:"center"});
      y += 14;

      const colW = (usable - 8) / 2;
      const x1 = ML;
      const x2 = ML + colW + 8;
      doc.setDrawColor(11,24,41);
      doc.setLineWidth(0.3);
      doc.line(x1+8, y, x1+colW-8, y);
      doc.line(x2+8, y, x2+colW-8, y);
      y += 4;
      doc.setFont("times","bold"); doc.setFontSize(8);
      doc.text("EL VENDEDOR", x1+colW/2, y, {align:"center"});
      doc.text("EL COMPRADOR", x2+colW/2, y, {align:"center"});
      y += 4;
      doc.setFont("times","normal");
      doc.text(F(form.nombreVendedor), x1+colW/2, y, {align:"center"});
      doc.text(F(form.nombreComprador), x2+colW/2, y, {align:"center"});

      // Testigos
      if (form.nombreTestigo1 || form.nombreTestigo2) {
        y += 14;
        checkPage(20);
        doc.line(x1+8, y, x1+colW-8, y);
        doc.line(x2+8, y, x2+colW-8, y);
        y += 4;
        doc.setFont("times","bold"); doc.setFontSize(8);
        doc.text("TESTIGO 1", x1+colW/2, y, {align:"center"});
        doc.text("TESTIGO 2", x2+colW/2, y, {align:"center"});
        y += 4;
        doc.setFont("times","normal");
        doc.text(F(form.nombreTestigo1), x1+colW/2, y, {align:"center"});
        doc.text(F(form.nombreTestigo2), x2+colW/2, y, {align:"center"});
      }

      // Pie en CADA hoja, 2 líneas discretas:
      //  1) leyenda de PROTECCIÓN: deja claro en toda hoja —incluso suelta— que AXIS
      //     solo REDACTÓ el contrato a petición de parte y NO es parte del mismo;
      //  2) datos + numeración de página.
      const totalPages = doc.internal.pages.length - 1;
      for (let p = 1; p <= totalPages; p++) {
        doc.setPage(p);
        doc.setFont("times","italic"); doc.setFontSize(7);
        doc.setTextColor(130,130,130);
        pintarLeyendaContrato(doc, ML, H-17, W-ML-MR);
        doc.text(pieDelPatron(datosPatron, fechaHoraLargaAxis()), ML, H-13);
        doc.text(`Página ${p} de ${totalPages}`, W-MR, H-13, {align:"right"});
      }

      const fname = `Compraventa_Vehiculo_${(form.marca + "_" + form.modelo || "vehiculo").replace(/[^A-Za-z0-9]/g,"_")}.pdf`;
      doc.save(fname);
      try { setUltimoBlob(doc.output("blob")); } catch {}
      setGenerando(false);
    }, 200);
  };

  const inputStyle: React.CSSProperties = {
    width:"100%", padding:"9px 11px", fontSize:13, fontFamily:fontSans,
    background:"white", border:"1px solid #D1D5DB", borderRadius:8, color:"#0F172A",
    boxSizing:"border-box" as const,
  };
  const labelStyle: React.CSSProperties = {
    display:"block", fontSize:11, fontWeight:600, color:"#374151", marginBottom:4,
    letterSpacing:"0.2px",
  };

  const camposObligatoriosLlenos = !!(
    form.nombreVendedor && form.nombreComprador && form.fechaContrato &&
    form.marca && form.modelo && form.anio && form.nivSerie &&
    form.precio && form.fechaEntrega &&
    (formaPago === "contado" || (form.anticipo && form.saldo))
  );

  return (
    <div {...ZONA_DE_CAPTURA} style={{minHeight:"100vh", background:T_LIGHT.canvas, fontFamily:fontSans}}>
      {/* Header */}
      <div style={{background:"linear-gradient(135deg,#2563EB,#1E40AF)", padding:"0 20px", height:58,
        display:"flex", alignItems:"center", gap:12, position:"sticky" as const, top:0, zIndex:100,
        boxShadow:"0 4px 20px rgba(37,99,235,0.25)"}}>
        <button onClick={onBack}
          style={{background:"rgba(255,255,255,0.15)", border:"1px solid rgba(255,255,255,0.25)",
            color:"white", borderRadius:8, padding:"5px 11px", cursor:"pointer",
            fontSize:12, fontWeight:600}}>← Generador legal</button>
        <span style={{color:"white", fontWeight:700, fontSize:14, display:"flex",
          alignItems:"center", gap:8}}>
          <AxisIcon name="suite_flotilla" size={18} tone="white" withBackdrop={false} strokeWidth={2.5}/>
          Compraventa de Vehículo
        </span>
      </div>

      <div style={{maxWidth:760, margin:"0 auto", padding:isMobile?"16px":"24px"}}>
        <p style={{fontSize:12, color:"#64748B", margin:"0 0 6px", lineHeight:1.6}}>
          Conforme al Código Civil del Estado de Aguascalientes, arts. 2119 y siguientes.
        </p>
        <p style={{fontSize:12, color:"#64748B", margin:"0 0 18px", lineHeight:1.6}}>
          Completa los datos. Los campos marcados con <span style={{color:"#DC2626"}}>*</span> son indispensables para generar el contrato.
        </p>

        <SelectorDeMiParte partes={PARTES_CVV} elegida={miParte} tipoPersona={datosPatron.tipoPersona} fontSans={fontSans} fontSerif={fontSerif}
          onElegir={(c)=>{ setMiParte(c); setForm((f:any)=>aplicarMiParte(f, PARTES_CVV, c, datosPatron)); }}/>

        {/* Datos generales */}
        <SectionVehiculo title="Datos generales" fontSerif={fontSerif} isMobile={isMobile}>
          <div>
            <label style={labelStyle}>Ciudad y estado de firma <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" style={inputStyle} value={form.ciudad} onChange={e => set("ciudad", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Fecha de firma <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" type="date" style={inputStyle} value={form.fechaContrato} onChange={e => set("fechaContrato", e.target.value)}/>
          </div>
        </SectionVehiculo>

        {/* Vendedor */}
        <SectionVehiculo title="El Vendedor" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Nombre completo <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" style={inputStyle} value={form.nombreVendedor} onChange={e => set("nombreVendedor", e.target.value)}
              placeholder="Nombre tal como aparece en su INE"/>
          </div>
          <div>
            <label style={labelStyle}>Clave de elector (INE)</label>
            <input autoComplete="off" style={inputStyle} value={form.ineVendedor} onChange={e => set("ineVendedor", e.target.value)}
              placeholder="ABCDEF12345678901234"/>
          </div>
          <div>
            <label style={labelStyle}>RFC</label>
            <input autoComplete="off" style={inputStyle} value={form.rfcVendedor} onChange={e => set("rfcVendedor", e.target.value)}/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Domicilio</label>
            <input autoComplete="off" style={inputStyle} value={form.domicilioVendedor} onChange={e => set("domicilioVendedor", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Teléfono</label>
            <input autoComplete="off" style={inputStyle} value={form.telefonoVendedor} onChange={e => set("telefonoVendedor", e.target.value)}/>
          </div>
        </SectionVehiculo>

        {/* Comprador */}
        <SectionVehiculo title="El Comprador" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Nombre completo <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" style={inputStyle} value={form.nombreComprador} onChange={e => set("nombreComprador", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Clave de elector (INE)</label>
            <input autoComplete="off" style={inputStyle} value={form.ineComprador} onChange={e => set("ineComprador", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>RFC</label>
            <input autoComplete="off" style={inputStyle} value={form.rfcComprador} onChange={e => set("rfcComprador", e.target.value)}/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Domicilio</label>
            <input autoComplete="off" style={inputStyle} value={form.domicilioComprador} onChange={e => set("domicilioComprador", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Teléfono</label>
            <input autoComplete="off" style={inputStyle} value={form.telefonoComprador} onChange={e => set("telefonoComprador", e.target.value)}/>
          </div>
        </SectionVehiculo>

        {/* Vehículo */}
        <SectionVehiculo title="Datos del vehículo" fontSerif={fontSerif} isMobile={isMobile}>
          <div>
            <label style={labelStyle}>Marca <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" style={inputStyle} value={form.marca} onChange={e => set("marca", e.target.value)}
              placeholder="Nissan, Toyota, Ford..."/>
          </div>
          <div>
            <label style={labelStyle}>Modelo / línea <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" style={inputStyle} value={form.modelo} onChange={e => set("modelo", e.target.value)}
              placeholder="Sentra, Ranger, Hilux..."/>
          </div>
          <div>
            <label style={labelStyle}>Año <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" type="number" style={inputStyle} value={form.anio} onChange={e => set("anio", e.target.value)}
              placeholder="2020"/>
          </div>
          <div>
            <label style={labelStyle}>Color</label>
            <input autoComplete="off" style={inputStyle} value={form.color} onChange={e => set("color", e.target.value)}
              placeholder="Blanco, gris..."/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>NIV / Número de serie (17 caracteres) <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" style={inputStyle} value={form.nivSerie} onChange={e => set("nivSerie", e.target.value)}
              placeholder="3N1AB7AP4LL206XXX" maxLength={17}/>
          </div>
          <div>
            <label style={labelStyle}>Número de motor</label>
            <input autoComplete="off" style={inputStyle} value={form.numMotor} onChange={e => set("numMotor", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Placas de circulación</label>
            <input autoComplete="off" style={inputStyle} value={form.placas} onChange={e => set("placas", e.target.value)}
              placeholder="ABC-12-34"/>
          </div>
          <div>
            <label style={labelStyle}>Folio de factura original</label>
            <input autoComplete="off" style={inputStyle} value={form.facturaFolio} onChange={e => set("facturaFolio", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Fecha de factura</label>
            <input autoComplete="off" style={inputStyle} value={form.facturaFecha} onChange={e => set("facturaFecha", e.target.value)}
              placeholder="15 de enero de 2020"/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Emisor de la factura (agencia / vendedor original)</label>
            <input autoComplete="off" style={inputStyle} value={form.facturaEmisor} onChange={e => set("facturaEmisor", e.target.value)}
              placeholder="Nissan Aguascalientes S.A. de C.V."/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Estado del vehículo al momento de la entrega</label>
            <textarea autoComplete="off" style={{...inputStyle, minHeight:55, resize:"vertical" as const}} value={form.estadoVehiculo}
              onChange={e => set("estadoVehiculo", e.target.value)}
              placeholder="Buen estado de funcionamiento mecánico y carrocería, con desgaste normal por uso..."/>
          </div>
        </SectionVehiculo>

        {/* Términos económicos */}
        <SectionVehiculo title="Precio y forma de pago" fontSerif={fontSerif} isMobile={isMobile}>
          <div>
            <label style={labelStyle}>Precio total (MXN) <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" type="number" style={inputStyle} value={form.precio} onChange={e => set("precio", e.target.value)}
              placeholder="180000"/>
          </div>
          <div>
            <label style={labelStyle}>Forma de pago <span style={{color:"#DC2626"}}>*</span></label>
            <div style={{display:"flex", gap:8}}>
              {(["contado","parcialidades"] as const).map(t => (
                <button key={t} onClick={() => setFormaPago(t)}
                  style={{flex:1, padding:"9px 12px", borderRadius:8, fontSize:12, fontWeight:600,
                    fontFamily:fontSans, cursor:"pointer",
                    background: formaPago===t ? "#2563EB" : "white",
                    color: formaPago===t ? "white" : "#374151",
                    border: formaPago===t ? "1px solid #2563EB" : "1px solid #D1D5DB"}}>
                  {t === "contado" ? "Contado" : "Parcialidades"}
                </button>
              ))}
            </div>
          </div>

          {formaPago === "parcialidades" && (
            <>
              <div>
                <label style={labelStyle}>Anticipo (MXN)</label>
                <input autoComplete="off" type="number" style={inputStyle} value={form.anticipo} onChange={e => set("anticipo", e.target.value)}/>
              </div>
              <div>
                <label style={labelStyle}>Saldo (auto-calculado)</label>
                <input autoComplete="off" type="number" style={inputStyle} value={form.saldo} onChange={e => set("saldo", e.target.value)} readOnly={true}/>
              </div>
              <div>
                <label style={labelStyle}>Plazo (meses)</label>
                <input autoComplete="off" type="number" style={inputStyle} value={form.plazoMeses} onChange={e => set("plazoMeses", e.target.value)}/>
              </div>
              <div>
                <label style={labelStyle}>Día de pago mensual (primeros __ días)</label>
                <input autoComplete="off" type="number" style={inputStyle} value={form.diaPagoMensual} onChange={e => set("diaPagoMensual", e.target.value)}/>
              </div>
              <div style={{gridColumn:isMobile?"auto":"1 / -1", padding:"10px 12px",
                background:"rgba(37,99,235,0.05)", borderRadius:8,
                border:"1px solid rgba(37,99,235,0.2)"}}>
                <label style={{display:"flex", alignItems:"center", gap:8, cursor:"pointer", fontSize:12, color:"#374151"}}>
                  <input autoComplete="off" type="checkbox" checked={form.reservaDominio}
                    onChange={e => set("reservaDominio", e.target.checked)}/>
                  <span><strong>Incluir reserva de dominio</strong> — el vendedor conserva la propiedad hasta el pago total. <em>Recomendado en pagos a plazos.</em></span>
                </label>
              </div>
            </>
          )}

          <div>
            <label style={labelStyle}>Fecha de entrega <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" type="date" style={inputStyle} value={form.fechaEntrega} onChange={e => set("fechaEntrega", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Lugar de entrega</label>
            <input autoComplete="off" style={inputStyle} value={form.lugarEntrega} onChange={e => set("lugarEntrega", e.target.value)}
              placeholder="Si no llenas este campo, se usa la ciudad de firma"/>
          </div>
        </SectionVehiculo>

        {/* Testigos */}
        <SectionVehiculo title="Testigos (recomendado)" fontSerif={fontSerif} isMobile={isMobile}>
          <div>
            <label style={labelStyle}>Nombre Testigo 1</label>
            <input autoComplete="off" style={inputStyle} value={form.nombreTestigo1} onChange={e => set("nombreTestigo1", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Nombre Testigo 2</label>
            <input autoComplete="off" style={inputStyle} value={form.nombreTestigo2} onChange={e => set("nombreTestigo2", e.target.value)}/>
          </div>
        </SectionVehiculo>

        {/* Aviso legal */}
        <div style={{background:"rgba(184,147,42,0.10)", border:"1px solid rgba(184,147,42,0.3)",
          borderRadius:10, padding:"12px 14px", marginBottom:18, display:"flex", gap:10}}>
          <AxisIcon name="scale_simple" size={16} tone="gold" withBackdrop={false} strokeWidth={3}/>
          <div style={{fontSize:11.5, color:"#374151", lineHeight:1.5}}>
            <strong>Aviso legal:</strong> Este contrato es válido entre las partes conforme al Código Civil del Estado de Aguascalientes (arts. 2119 y siguientes). Para que la transmisión surta efectos frente a las autoridades de tránsito, EL COMPRADOR debe realizar el cambio de propietario en SEFI/Recaudación dentro de los 30 días siguientes. Si tienes dudas o necesitas validación legal, consulta con AXIS Asesoría Legal Corporativa.
          </div>
        </div>

        {/* Botón generar */}
        <button onClick={generarPDF} disabled={generando || !camposObligatoriosLlenos}
          style={{width:"100%", padding:"14px", borderRadius:10,
            background: camposObligatoriosLlenos
              ? "linear-gradient(135deg,#2563EB,#1E40AF)"
              : "#9CA3AF",
            border:"none", color:"white", fontSize:15, fontWeight:700,
            cursor: camposObligatoriosLlenos ? "pointer" : "not-allowed",
            boxShadow: camposObligatoriosLlenos ? "0 4px 16px rgba(37,99,235,0.35)" : "none",
            display:"flex", alignItems:"center", justifyContent:"center", gap:10,
            fontFamily:fontSans}}>
          <AxisIcon name="document" size={16} tone="white" withBackdrop={false} strokeWidth={3}/>
          {generando ? "Generando contrato..." : "Generar contrato en PDF"}
        </button>

        {!camposObligatoriosLlenos && (
          <p style={{fontSize:11, color:"#DC2626", margin:"8px 0 0", textAlign:"center" as const}}>
            Completa los campos marcados con <strong>*</strong> para generar el contrato.
          </p>
        )}
        {ultimoBlob && (
          <div style={{marginTop:14, padding:"14px 16px", background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:12, display:"flex", justifyContent:"space-between", alignItems:"center", gap:12, flexWrap:"wrap"}}>
            <div style={{fontSize:12, color:T_LIGHT.textInkSoft, flex:1, minWidth:160}}>¿Quieres guardar este contrato en un expediente?</div>
            <BotonGuardarYVincular
              user={user}
              tipoContrato={tipoContrato}
              getPDFBlob={async () => ultimoBlob!}
              nombrePDFBase={`Contrato_${tipoContrato}`}
              fontSans={fontSans} fontSerif={fontSerif} gold={gold}
            />
          </div>
        )}
      </div>
    </div>
  );
}


// #endregion
// #region COMPRAVENTA INMUEBLE
// ─── CONTRATO: COMPRAVENTA DE INMUEBLE ────────────────────────────────────────
// Fundamento: Código Civil del Estado de Aguascalientes, arts. 2119 y siguientes.
// Es contrato privado VÁLIDO entre las partes desde la firma. Para oposición a
// terceros e inscripción en RPP debe formalizarse mediante escritura pública.
function SectionInmueble({title, children, fontSerif, isMobile}: {title:string; children:React.ReactNode; fontSerif:string; isMobile:boolean}) {
  return (
    <div style={{marginBottom:18}}>
      <div style={{fontFamily:fontSerif, fontSize:14, fontWeight:700, color:"#0F172A",
        marginBottom:10, paddingBottom:6, borderBottom:"1px solid rgba(184,147,42,0.3)",
        display:"flex", alignItems:"center", gap:8}}>
        <AxisIcon name="house" size={14} color="#B8932A" withBackdrop={false} strokeWidth={3}/>
        {title}
      </div>
      <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr":"1fr 1fr", gap:10}}>
        {children}
      </div>
    </div>
  );
}

function FormCompraventaInmueble({user, tipoContrato, onBack, fontSans, fontSerif, gold}: {user:any; tipoContrato:string; onBack:()=>void; fontSans:string; fontSerif:string; gold:string}) {
  // El pie de este documento lo firma el patrón, no la plataforma.
  const datosPatron = useDatosPatron(user?.uid).datos;
  // Las dos partes de este contrato, para el control de "cuál soy yo".
  // Igual que la compraventa de vehículo: las dos partes se declaran persona
  // física y el formulario no ofrece la variante de sociedad.
  const PARTES_CVI: ParteDeContrato[] = [
    {clave:"vendedor",  etiqueta:"Vendedor",  nombre:"nombreVendedor",  rfc:"rfcVendedor",  domicilio:"domicilioVendedor", declaraPersonaFisica:true},
    {clave:"comprador", etiqueta:"Comprador", nombre:"nombreComprador", rfc:"rfcComprador", domicilio:"domicilioComprador", declaraPersonaFisica:true},
  ];
  const [miParte, setMiParte] = useState("");   // por defecto, ninguna
  const isMobile = window.innerWidth < 768;
  const [tipoInmueble, setTipoInmueble] = useState<"casa"|"terreno"|"local"|"departamento"|"bodega">("casa");
  const [formaPago, setFormaPago] = useState<"contado"|"parcialidades">("contado");
  const [vendedorCasado, setVendedorCasado] = useState<boolean>(false);

  const [form, setForm] = useState({
    ciudad: "Aguascalientes, Ags.",
    fechaContrato: "",
    // Vendedor
    nombreVendedor: "",
    ineVendedor: "",
    rfcVendedor: "",
    domicilioVendedor: "",
    telefonoVendedor: "",
    estadoCivilVendedor: "soltero(a)",
    nombreConyugeVendedor: "",
    // Comprador
    nombreComprador: "",
    ineComprador: "",
    rfcComprador: "",
    domicilioComprador: "",
    telefonoComprador: "",
    // Inmueble - descripción
    direccionInmueble: "",
    superficieTerreno: "",
    superficieConstruccion: "",
    linderos: "",
    serviciosInmueble: "agua, luz, drenaje, gas y alumbrado público",
    // Antecedentes registrales
    escrituraNumero: "",
    escrituraFecha: "",
    notarioOriginal: "",
    inscripcionRPP: "",
    cuentaPredial: "",
    // Términos
    precio: "",
    anticipo: "",
    saldo: "",
    plazoMesesParcialidades: "12",
    fechaEntregaFisica: "",
    plazoEscrituracion: "60",
    notarioParaEscriturar: "",
    // Condiciones
    librGravamen: true,
    predialAlCorriente: true,
    posesionInmediata: true,
    // Testigos
    nombreTestigo1: "",
    nombreTestigo2: "",
  });

  const [generando, setGenerando] = useState(false);
  const [ultimoBlob, setUltimoBlob] = useState<Blob|null>(null);
  const set = (k: string, v: any) => setForm(p => ({...p, [k]:v}));
  const F = (v: string) => v || "_______________________________";
  // FECHAS EN CASTELLANO, NO EN ISO. El campo guarda "2026-09-07" y eso salía
  // impreso tal cual en un contrato que se firma. `fechaLargaAxis` PARTE la
  // cadena en vez de construir un Date: `new Date("2026-09-01")` es medianoche
  // UTC, y en México eso es el 31 de agosto —el contrato imprimiría el día
  // anterior al pactado—. Si el valor no es una fecha ISO (hay campos de fecha
  // que son texto libre), se imprime tal como se escribió.
  const FF = (v: string) => fechaLargaAxis(v) || F(v);

  // Auto-cálculo de saldo
  useEffect(() => {
    if (formaPago === "parcialidades" && form.precio && form.anticipo) {
      const p = parseFloat(form.precio);
      const a = parseFloat(form.anticipo);
      if (!isNaN(p) && !isNaN(a)) {
        const s = (p - a).toString();
        if (form.saldo !== s) set("saldo", s);
      }
    }
  }, [form.precio, form.anticipo, formaPago, form.saldo]);

  const numeroALetras = (n: number): string => {
    const unidades = ["","UN","DOS","TRES","CUATRO","CINCO","SEIS","SIETE","OCHO","NUEVE","DIEZ","ONCE","DOCE","TRECE","CATORCE","QUINCE","DIECISEIS","DIECISIETE","DIECIOCHO","DIECINUEVE"];
    const decenas = ["","DIEZ","VEINTE","TREINTA","CUARENTA","CINCUENTA","SESENTA","SETENTA","OCHENTA","NOVENTA"];
    const centenas = ["","CIEN","DOSCIENTOS","TRESCIENTOS","CUATROCIENTOS","QUINIENTOS","SEISCIENTOS","SETECIENTOS","OCHOCIENTOS","NOVECIENTOS"];
    if (n === 0) return "CERO";
    if (n < 20) return unidades[n];
    if (n < 100) return decenas[Math.floor(n/10)] + (n%10 ? " Y " + unidades[n%10] : "");
    if (n < 1000) return centenas[Math.floor(n/100)] + (n%100 ? " " + numeroALetras(n%100) : "");
    if (n < 10000) return unidades[Math.floor(n/1000)] + " MIL" + (n%1000 ? " " + numeroALetras(n%1000) : "");
    if (n < 1000000) return numeroALetras(Math.floor(n/1000)) + " MIL" + (n%1000 ? " " + numeroALetras(n%1000) : "");
    return numeroALetras(Math.floor(n/1000000)) + " MILLONES" + (n%1000000 ? " " + numeroALetras(n%1000000) : "");
  };

  const fmt$ = (v: string) => {
    if (!v) return "_______________________________";
    const n = parseFloat(v);
    if (isNaN(n)) return v;
    return "$" + n.toLocaleString("es-MX", {minimumFractionDigits:2, maximumFractionDigits: 2}) + " M.N. (" + numeroALetras(Math.floor(n)) + " PESOS " + String(Math.round((n%1)*100)).padStart(2,"0") + "/100 M.N.)";
  };

  const tipoInmuebleTexto: Record<string,string> = {
    casa:"casa habitación",
    terreno:"terreno",
    local:"local comercial",
    departamento:"departamento",
    bodega:"bodega",
  };

  const generarPDF = () => {
    setGenerando(true);
    setTimeout(() => {
      const { jsPDF } = (window as any).jspdf;
      const doc = new jsPDF({orientation:"portrait", unit:"mm", format:"letter"});
      const W = doc.internal.pageSize.getWidth();
      const H = doc.internal.pageSize.getHeight();
      const ML = 22, MR = 22;
      const usable = W - ML - MR;
      let y = 28;   // margen superior cómodo; el contrato inicia DIRECTO con su título (AXIS va al pie)

      const checkPage = (need = 8) => { if (y + need > H - 34) { doc.addPage(); y = 28; } };
      const titulo = (txt: string) => {
        checkPage(12);
        doc.setFont("times","bold"); doc.setFontSize(11); doc.setTextColor(11,24,41);
        doc.text(txt, W/2, y, {align:"center"}); y += 7;
      };
      const subtitulo = (txt: string) => {
        checkPage(30);   // mantiene el encabezado junto a su primer texto (evita viudas)
        doc.setFont("times","bold"); doc.setFontSize(10); doc.setTextColor(11,24,41);
        doc.text(txt, ML, y); y += 5;
      };
      const parrafo = (txt: string, opts?:{align?:"justify"|"left"|"center"; bold?:boolean; size?:number}) => {
        const fs = opts?.size || 9;
        doc.setFont("times", opts?.bold ? "bold" : "normal");
        doc.setFontSize(fs); doc.setTextColor(45,45,45);
        const lines = doc.splitTextToSize(txt, usable);
        for (const ln of lines) {
          checkPage(5);
          doc.text(ln, ML, y, {align: opts?.align==="center" ? "center" : "left", maxWidth: usable});
          y += fs*0.42 + 1.2;
        }
        y += 1;
      };

      // ───── ENCABEZADO ─────
      titulo("CONTRATO PRIVADO DE COMPRAVENTA DE INMUEBLE");

      const conyugeFrase = vendedorCasado && form.nombreConyugeVendedor
        ? `, con consentimiento expreso de su cónyuge ${F(form.nombreConyugeVendedor).toUpperCase()}`
        : "";

      parrafo(
        `Contrato privado de compraventa que celebran por una parte ${F(form.nombreVendedor).toUpperCase()}${conyugeFrase}, en lo sucesivo "EL VENDEDOR", y por la otra ${F(form.nombreComprador).toUpperCase()}, en lo sucesivo "EL COMPRADOR", al tenor de las siguientes declaraciones y cláusulas, conforme a los artículos 2119 y siguientes del Código Civil del Estado de Aguascalientes:`,
        {align:"justify"}
      );

      // ───── DECLARACIONES ─────
      subtitulo("DECLARACIONES");

      parrafo("I. DECLARA EL VENDEDOR:", {bold:true});
      parrafo(`a) Ser persona física mayor de edad, con plena capacidad jurídica para contratar y obligarse, identificándose con credencial de elector clave ${F(form.ineVendedor)}.`);
      parrafo(`b) Tener su domicilio en ${F(form.domicilioVendedor)}, contar con RFC ${F(form.rfcVendedor)} y con teléfono ${F(form.telefonoVendedor)}.`);
      parrafo(`c) Su estado civil es: ${F(form.estadoCivilVendedor)}${vendedorCasado ? `, siendo su cónyuge ${F(form.nombreConyugeVendedor)}, quien comparece a este acto otorgando su consentimiento expreso para la presente compraventa` : ""}.`);
      parrafo(`d) Ser legítimo propietario del inmueble objeto de este contrato, según consta en la escritura pública número ${F(form.escrituraNumero)} de fecha ${F(form.escrituraFecha)}, otorgada ante la fe del ${F(form.notarioOriginal)}, debidamente inscrita en el Registro Público de la Propiedad bajo ${F(form.inscripcionRPP)}.`);
      parrafo(`e) El inmueble se encuentra ${form.librGravamen ? "libre de todo gravamen, hipoteca o limitación al dominio" : "con los gravámenes que se manifestarán a EL COMPRADOR"}, y al corriente en el pago del impuesto predial${form.predialAlCorriente ? " y demás contribuciones y servicios" : ""}.`);

      parrafo("II. DECLARA EL COMPRADOR:", {bold:true});
      parrafo(`a) Ser persona física mayor de edad, con plena capacidad jurídica para contratar, identificándose con credencial de elector clave ${F(form.ineComprador)}.`);
      parrafo(`b) Tener su domicilio en ${F(form.domicilioComprador)}, contar con RFC ${F(form.rfcComprador)} y con teléfono ${F(form.telefonoComprador)}.`);
      parrafo(`c) Conocer el inmueble objeto del presente contrato, haberlo inspeccionado físicamente y aceptarlo en las condiciones en que se encuentra, así como contar con los recursos suficientes para cubrir el precio pactado.`);

      // ───── CLÁUSULAS ─────
      checkPage(12);
      y += 2;
      subtitulo("CLÁUSULAS");

      parrafo("PRIMERA. OBJETO DEL CONTRATO.", {bold:true});
      parrafo(
        `EL VENDEDOR vende y EL COMPRADOR adquiere para sí, con todos los usos, costumbres, derechos, accesiones y servidumbres, el siguiente inmueble:`,
        {align:"justify"}
      );
      parrafo(`Tipo: ${tipoInmuebleTexto[tipoInmueble] || "inmueble"}.`);
      parrafo(`Ubicación: ${F(form.direccionInmueble)}.`);
      if (form.superficieTerreno) parrafo(`Superficie de terreno: ${form.superficieTerreno} m².`);
      if (form.superficieConstruccion) parrafo(`Superficie de construcción: ${form.superficieConstruccion} m².`);
      if (form.linderos) parrafo(`Colindancias y linderos: ${form.linderos}.`);
      if (form.serviciosInmueble) parrafo(`Servicios con que cuenta: ${form.serviciosInmueble}.`);
      if (form.cuentaPredial) parrafo(`Cuenta predial / clave catastral: ${form.cuentaPredial}.`);

      parrafo("SEGUNDA. ANTECEDENTES DE PROPIEDAD.", {bold:true});
      parrafo(
        `EL VENDEDOR acredita la propiedad del inmueble mediante escritura pública número ${F(form.escrituraNumero)} de fecha ${F(form.escrituraFecha)}, otorgada ante el ${F(form.notarioOriginal)}, inscrita en el Registro Público de la Propiedad de Aguascalientes bajo ${F(form.inscripcionRPP)}.`,
        {align:"justify"}
      );

      parrafo("TERCERA. PRECIO Y FORMA DE PAGO.", {bold:true});
      parrafo(`El precio total convenido por la presente compraventa es la cantidad de ${fmt$(form.precio)}, que EL COMPRADOR pagará a EL VENDEDOR de la siguiente manera:`, {align:"justify"});

      if (formaPago === "contado") {
        parrafo(`PAGO DE CONTADO: la cantidad total se entrega a EL VENDEDOR a la firma del presente contrato, sirviendo el mismo como recibo legal por dicha cantidad. EL VENDEDOR otorga a EL COMPRADOR el más amplio finiquito que en derecho proceda respecto del precio del inmueble.`, {align:"justify"});
      } else {
        parrafo(`PAGO EN PARCIALIDADES:`, {bold:true});
        parrafo(`a) ANTICIPO: ${fmt$(form.anticipo)} entregados a la firma del presente contrato, sirviendo el mismo como recibo legal por dicha cantidad.`, {align:"justify"});
        parrafo(`b) SALDO: ${fmt$(form.saldo)} pagaderos en ${F(form.plazoMesesParcialidades)} mensualidades iguales y consecutivas, mismas que deberán cubrirse antes del otorgamiento de la escritura pública correspondiente.`, {align:"justify"});
        parrafo(`c) RESERVA DE DOMINIO: EL VENDEDOR conserva la propiedad del inmueble hasta el pago total del precio. La transmisión definitiva se perfeccionará al momento del pago de la última parcialidad, lo cual será requisito previo para el otorgamiento de la escritura pública.`, {align:"justify"});
        parrafo(`d) En caso de mora superior a dos mensualidades consecutivas, EL VENDEDOR podrá rescindir el presente contrato con derecho a recuperar el inmueble y conservar las cantidades recibidas en concepto de pena convencional, sin perjuicio del derecho a reclamar daños y perjuicios.`, {align:"justify"});
      }

      parrafo("CUARTA. ENTREGA Y POSESIÓN.", {bold:true});
      if (form.posesionInmediata) {
        parrafo(
          `EL VENDEDOR entrega la posesión física, real y material del inmueble a EL COMPRADOR el día ${FF(form.fechaEntregaFisica)}, libre de personas y de cosas no incluidas en este contrato. La firma del presente contrato hace prueba plena de la entrega satisfactoria del inmueble.`,
          {align:"justify"}
        );
      } else {
        parrafo(
          `La posesión física del inmueble será entregada por EL VENDEDOR a EL COMPRADOR el día ${FF(form.fechaEntregaFisica)}, fecha en la cual se firmará un acta de entrega-recepción haciendo constar el estado del inmueble y la entrega de llaves.`,
          {align:"justify"}
        );
      }

      parrafo("QUINTA. OBLIGACIÓN DE FORMALIZAR ANTE NOTARIO.", {bold:true});
      parrafo(
        `Las partes se obligan a comparecer ante Notario Público a otorgar la escritura pública correspondiente al presente contrato dentro de los ${F(form.plazoEscrituracion)} días naturales siguientes a la firma del mismo${form.notarioParaEscriturar ? `, ante ${form.notarioParaEscriturar}` : ""}. La escrituración es necesaria para que la transmisión de propiedad surta plenos efectos frente a terceros y pueda inscribirse en el Registro Público de la Propiedad. EL COMPRADOR cubrirá los gastos notariales, impuestos sobre adquisición de inmuebles, derechos de inscripción y demás erogaciones derivadas de la escrituración, salvo el Impuesto Sobre la Renta por enajenación que corresponde a EL VENDEDOR.`,
        {align:"justify"}
      );

      parrafo("SEXTA. SANEAMIENTO POR EVICCIÓN.", {bold:true});
      parrafo(
        `Conforme al Código Civil del Estado de Aguascalientes, EL VENDEDOR responderá por los daños y perjuicios que se ocasionen a EL COMPRADOR si éste fuere privado del inmueble, total o parcialmente, por sentencia ejecutoriada que tenga su origen en causa anterior a la venta. EL VENDEDOR garantiza que es legítimo propietario del inmueble y que éste se encuentra libre de gravámenes ocultos, embargos o cualquier limitación al dominio que pudiera afectar la transmisión.`,
        {align:"justify"}
      );

      parrafo("SÉPTIMA. SANEAMIENTO POR VICIOS OCULTOS.", {bold:true});
      parrafo(
        `EL VENDEDOR manifiesta no tener conocimiento de vicios ocultos que afecten el inmueble. EL COMPRADOR ha tenido la oportunidad de inspeccionar el inmueble física y técnicamente, aceptándolo en el estado en que se encuentra. Para los vicios ocultos no apreciables al momento de la entrega, EL VENDEDOR responderá conforme a las disposiciones del Código Civil aplicables.`,
        {align:"justify"}
      );

      parrafo("OCTAVA. ADEUDOS Y CONTRIBUCIONES.", {bold:true});
      parrafo(
        `EL VENDEDOR garantiza que el inmueble se encuentra al corriente en el pago de impuesto predial, agua potable, mantenimiento (si aplica) y cualquier otro adeudo de carácter público o privado a la fecha de firma del presente contrato. Cualquier adeudo posterior a la entrega física del inmueble será de la exclusiva responsabilidad de EL COMPRADOR.`,
        {align:"justify"}
      );

      parrafo("NOVENA. GASTOS.", {bold:true});
      parrafo(
        `Los gastos derivados de la escritura pública, incluyendo honorarios notariales, impuesto sobre adquisición de inmuebles, derechos de inscripción ante el Registro Público de la Propiedad y avalúo, serán por cuenta exclusiva de EL COMPRADOR. El Impuesto Sobre la Renta por enajenación de bienes inmuebles, en su caso, será cubierto por EL VENDEDOR conforme a las disposiciones fiscales aplicables.`,
        {align:"justify"}
      );

      parrafo("DÉCIMA. PERFECCIONAMIENTO Y EFECTOS.", {bold:true});
      parrafo(
        `Las partes reconocen que la presente compraventa se perfecciona desde este momento entre ellas, conforme a los artículos 2119 y siguientes del Código Civil del Estado de Aguascalientes, al haber convenido sobre la cosa y el precio. Sin embargo, las partes son sabedoras de que para que la transmisión de propiedad surta efectos frente a terceros y pueda inscribirse en el Registro Público de la Propiedad, debe formalizarse mediante escritura pública conforme a la cláusula QUINTA.`,
        {align:"justify"}
      );

      parrafo("DÉCIMA PRIMERA. JURISDICCIÓN.", {bold:true});
      parrafo(
        `Para la interpretación y cumplimiento del presente contrato, las partes se someten expresamente a las leyes y tribunales competentes en el Estado de Aguascalientes, renunciando a cualquier otro fuero que pudiera corresponderles por razón de su domicilio presente o futuro.`,
        {align:"justify"}
      );

      parrafo("DÉCIMA SEGUNDA. ACEPTACIÓN.", {bold:true});
      parrafo(
        `Las partes manifiestan que en la celebración del presente contrato no existe error, dolo, violencia, mala fe ni vicio alguno del consentimiento, firmándolo de conformidad por duplicado en la fecha indicada al final.`,
        {align:"justify"}
      );

      // ───── FIRMAS ─────
      checkPage(60);
      y += 6;
      doc.setFont("times","bold"); doc.setFontSize(9); doc.setTextColor(11,24,41);
      doc.text(`Firmado en ${F(form.ciudad)} el día ${FF(form.fechaContrato)}.`, W/2, y, {align:"center"});
      y += 14;

      const colW = (usable - 8) / 2;
      const x1 = ML;
      const x2 = ML + colW + 8;
      doc.setDrawColor(11,24,41);
      doc.setLineWidth(0.3);
      doc.line(x1+8, y, x1+colW-8, y);
      doc.line(x2+8, y, x2+colW-8, y);
      y += 4;
      doc.setFont("times","bold"); doc.setFontSize(8);
      doc.text("EL VENDEDOR", x1+colW/2, y, {align:"center"});
      doc.text("EL COMPRADOR", x2+colW/2, y, {align:"center"});
      y += 4;
      doc.setFont("times","normal");
      doc.text(F(form.nombreVendedor), x1+colW/2, y, {align:"center"});
      doc.text(F(form.nombreComprador), x2+colW/2, y, {align:"center"});

      // Cónyuge
      if (vendedorCasado && form.nombreConyugeVendedor) {
        y += 14;
        checkPage(20);
        doc.line(W/2-30, y, W/2+30, y);
        y += 4;
        doc.setFont("times","bold"); doc.setFontSize(8);
        doc.text("CÓNYUGE DEL VENDEDOR", W/2, y, {align:"center"});
        y += 3.5;
        doc.setFontSize(7);
        doc.text("(Otorga consentimiento expreso)", W/2, y, {align:"center"});
        y += 4;
        doc.setFont("times","normal"); doc.setFontSize(8);
        doc.text(F(form.nombreConyugeVendedor), W/2, y, {align:"center"});
      }

      // Testigos
      if (form.nombreTestigo1 || form.nombreTestigo2) {
        y += 14;
        checkPage(20);
        doc.line(x1+8, y, x1+colW-8, y);
        doc.line(x2+8, y, x2+colW-8, y);
        y += 4;
        doc.setFont("times","bold"); doc.setFontSize(8);
        doc.text("TESTIGO 1", x1+colW/2, y, {align:"center"});
        doc.text("TESTIGO 2", x2+colW/2, y, {align:"center"});
        y += 4;
        doc.setFont("times","normal");
        doc.text(F(form.nombreTestigo1), x1+colW/2, y, {align:"center"});
        doc.text(F(form.nombreTestigo2), x2+colW/2, y, {align:"center"});
      }

      // Footer
      const totalPages = doc.internal.pages.length - 1;
      for (let p = 1; p <= totalPages; p++) {
        doc.setPage(p);
        doc.setFont("times","italic"); doc.setFontSize(7);
        doc.setTextColor(120,120,120);
        pintarLeyendaContrato(doc, W/2, H-13.5, W-ML-MR, "center");
        doc.text(pieDelPatron(datosPatron, fechaHoraLargaAxis()), W/2, H-10, {align:"center"});
        doc.text(`Página ${p} de ${totalPages}`, W-MR, H-10, {align:"right"});
      }

      const fname = `Compraventa_Inmueble_${(form.nombreComprador || "comprador").replace(/[^A-Za-z0-9]/g,"_")}.pdf`;
      doc.save(fname);
      try { setUltimoBlob(doc.output("blob")); } catch {}
      setGenerando(false);
    }, 200);
  };

  const inputStyle: React.CSSProperties = {
    width:"100%", padding:"9px 11px", fontSize:13, fontFamily:fontSans,
    background:"white", border:"1px solid #D1D5DB", borderRadius:8, color:"#0F172A",
    boxSizing:"border-box" as const,
  };
  const labelStyle: React.CSSProperties = {
    display:"block", fontSize:11, fontWeight:600, color:"#374151", marginBottom:4,
    letterSpacing:"0.2px",
  };

  const camposObligatoriosLlenos = !!(
    form.nombreVendedor && form.nombreComprador && form.fechaContrato &&
    form.direccionInmueble && form.precio && form.fechaEntregaFisica &&
    (formaPago === "contado" || (form.anticipo && form.saldo))
  );

  return (
    <div {...ZONA_DE_CAPTURA} style={{minHeight:"100vh", background:T_LIGHT.canvas, fontFamily:fontSans}}>
      {/* Header */}
      <div style={{background:"linear-gradient(135deg,#B8932A,#A07C30)", padding:"0 20px", height:58,
        display:"flex", alignItems:"center", gap:12, position:"sticky" as const, top:0, zIndex:100,
        boxShadow:"0 4px 20px rgba(184,147,42,0.25)"}}>
        <button onClick={onBack}
          style={{background:"rgba(255,255,255,0.18)", border:"1px solid rgba(255,255,255,0.30)",
            color:"white", borderRadius:8, padding:"5px 11px", cursor:"pointer",
            fontSize:12, fontWeight:600}}>← Generador legal</button>
        <span style={{color:"white", fontWeight:700, fontSize:14, display:"flex",
          alignItems:"center", gap:8}}>
          <AxisIcon name="house" size={18} tone="white" withBackdrop={false} strokeWidth={2.5}/>
          Compraventa de Inmueble
        </span>
      </div>

      <div style={{maxWidth:760, margin:"0 auto", padding:isMobile?"16px":"24px"}}>
        <p style={{fontSize:12, color:"#64748B", margin:"0 0 6px", lineHeight:1.6}}>
          Conforme al Código Civil del Estado de Aguascalientes, arts. 2119 y siguientes.
        </p>

        {/* Aviso legal destacado al inicio */}
        <div style={{background:"rgba(184,147,42,0.10)", border:"1px solid rgba(184,147,42,0.4)",
          borderRadius:10, padding:"12px 14px", marginBottom:18, display:"flex", gap:10}}>
          <AxisIcon name="scale_simple" size={18} tone="gold" withBackdrop={false} strokeWidth={3}/>
          <div style={{fontSize:11.5, color:"#374151", lineHeight:1.6}}>
            <strong>Importante sobre la formalización:</strong> Este contrato privado es <strong>válido entre las partes desde su firma</strong> (perfecciona el acuerdo: cosa + precio + consentimiento). Sin embargo, para que la transmisión de propiedad surta <strong>efectos frente a terceros</strong> y pueda inscribirse en el Registro Público de la Propiedad, las partes deben formalizarlo mediante <strong>escritura pública ante Notario Público</strong> dentro del plazo pactado.
          </div>
        </div>

        <p style={{fontSize:12, color:"#64748B", margin:"0 0 18px", lineHeight:1.6}}>
          Completa los datos. Los campos marcados con <span style={{color:"#DC2626"}}>*</span> son indispensables.
        </p>

        <SelectorDeMiParte partes={PARTES_CVI} elegida={miParte} tipoPersona={datosPatron.tipoPersona} fontSans={fontSans} fontSerif={fontSerif}
          onElegir={(c)=>{ setMiParte(c); setForm((f:any)=>aplicarMiParte(f, PARTES_CVI, c, datosPatron)); }}/>

        {/* Datos generales */}
        <SectionInmueble title="Datos generales" fontSerif={fontSerif} isMobile={isMobile}>
          <div>
            <label style={labelStyle}>Ciudad y estado de firma <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" style={inputStyle} value={form.ciudad} onChange={e => set("ciudad", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Fecha de firma <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" type="date" style={inputStyle} value={form.fechaContrato} onChange={e => set("fechaContrato", e.target.value)}/>
          </div>
        </SectionInmueble>

        {/* Vendedor */}
        <SectionInmueble title="El Vendedor" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Nombre completo <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" style={inputStyle} value={form.nombreVendedor} onChange={e => set("nombreVendedor", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Clave de elector (INE)</label>
            <input autoComplete="off" style={inputStyle} value={form.ineVendedor} onChange={e => set("ineVendedor", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>RFC</label>
            <input autoComplete="off" style={inputStyle} value={form.rfcVendedor} onChange={e => set("rfcVendedor", e.target.value)}/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Domicilio</label>
            <input autoComplete="off" style={inputStyle} value={form.domicilioVendedor} onChange={e => set("domicilioVendedor", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Teléfono</label>
            <input autoComplete="off" style={inputStyle} value={form.telefonoVendedor} onChange={e => set("telefonoVendedor", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Estado civil</label>
            <select style={inputStyle} value={form.estadoCivilVendedor}
              onChange={e => { set("estadoCivilVendedor", e.target.value); setVendedorCasado(e.target.value.includes("casado")); }}>
              <option value="soltero(a)">Soltero(a)</option>
              <option value="casado(a) por separación de bienes">Casado(a) por separación de bienes</option>
              <option value="casado(a) por sociedad conyugal">Casado(a) por sociedad conyugal</option>
              <option value="divorciado(a)">Divorciado(a)</option>
              <option value="viudo(a)">Viudo(a)</option>
              <option value="unión libre">Unión libre</option>
            </select>
          </div>
          {vendedorCasado && (
            <div style={{gridColumn:isMobile?"auto":"1 / -1", padding:"10px 12px",
              background:"rgba(184,147,42,0.05)", borderRadius:8,
              border:"1px solid rgba(184,147,42,0.2)"}}>
              <label style={labelStyle}>Nombre completo del cónyuge (debe firmar el contrato)</label>
              <input autoComplete="off" style={inputStyle} value={form.nombreConyugeVendedor} onChange={e => set("nombreConyugeVendedor", e.target.value)}
                placeholder="Si vendedor está casado por sociedad conyugal, el cónyuge debe firmar"/>
              <p style={{fontSize:10.5, color:"#92660E", margin:"6px 0 0", lineHeight:1.5}}>
                <strong>Nota legal:</strong> en sociedad conyugal el inmueble es de ambos. Si solo firma uno, la compraventa puede ser anulable.
              </p>
            </div>
          )}
        </SectionInmueble>

        {/* Comprador */}
        <SectionInmueble title="El Comprador" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Nombre completo <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" style={inputStyle} value={form.nombreComprador} onChange={e => set("nombreComprador", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Clave de elector (INE)</label>
            <input autoComplete="off" style={inputStyle} value={form.ineComprador} onChange={e => set("ineComprador", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>RFC</label>
            <input autoComplete="off" style={inputStyle} value={form.rfcComprador} onChange={e => set("rfcComprador", e.target.value)}/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Domicilio</label>
            <input autoComplete="off" style={inputStyle} value={form.domicilioComprador} onChange={e => set("domicilioComprador", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Teléfono</label>
            <input autoComplete="off" style={inputStyle} value={form.telefonoComprador} onChange={e => set("telefonoComprador", e.target.value)}/>
          </div>
        </SectionInmueble>

        {/* Inmueble */}
        <SectionInmueble title="Datos del inmueble" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Tipo de inmueble <span style={{color:"#DC2626"}}>*</span></label>
            <div style={{display:"grid", gridTemplateColumns:isMobile?"repeat(3,1fr)":"repeat(5,1fr)", gap:6}}>
              {(["casa","departamento","local","terreno","bodega"] as const).map(t => (
                <button key={t} onClick={() => setTipoInmueble(t)}
                  style={{padding:"8px 6px", borderRadius:8, fontSize:11, fontWeight:600,
                    fontFamily:fontSans, cursor:"pointer",
                    background: tipoInmueble===t ? "#B8932A" : "white",
                    color: tipoInmueble===t ? "white" : "#374151",
                    border: tipoInmueble===t ? "1px solid #B8932A" : "1px solid #D1D5DB",
                    textTransform:"capitalize" as const}}>
                  {t}
                </button>
              ))}
            </div>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Dirección y ubicación completa <span style={{color:"#DC2626"}}>*</span></label>
            <textarea autoComplete="off" style={{...inputStyle, minHeight:55, resize:"vertical" as const}} value={form.direccionInmueble}
              onChange={e => set("direccionInmueble", e.target.value)}
              placeholder="Calle ___ No. ___, Colonia ___, Aguascalientes, Ags., C.P. ___"/>
          </div>
          <div>
            <label style={labelStyle}>Superficie del terreno (m²)</label>
            <input autoComplete="off" style={inputStyle} value={form.superficieTerreno} onChange={e => set("superficieTerreno", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Superficie de construcción (m²)</label>
            <input autoComplete="off" style={inputStyle} value={form.superficieConstruccion} onChange={e => set("superficieConstruccion", e.target.value)}/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Linderos y colindancias</label>
            <textarea autoComplete="off" style={{...inputStyle, minHeight:55, resize:"vertical" as const}} value={form.linderos}
              onChange={e => set("linderos", e.target.value)}
              placeholder="Norte: ___, Sur: ___, Este: ___, Oeste: ___"/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Servicios con que cuenta</label>
            <input autoComplete="off" style={inputStyle} value={form.serviciosInmueble} onChange={e => set("serviciosInmueble", e.target.value)}/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Cuenta predial / clave catastral</label>
            <input autoComplete="off" style={inputStyle} value={form.cuentaPredial} onChange={e => set("cuentaPredial", e.target.value)}
              placeholder="Aparece en el recibo de predial"/>
          </div>
        </SectionInmueble>

        {/* Antecedentes registrales */}
        <SectionInmueble title="Antecedentes registrales (origen de propiedad)" fontSerif={fontSerif} isMobile={isMobile}>
          <div>
            <label style={labelStyle}>No. de escritura pública</label>
            <input autoComplete="off" style={inputStyle} value={form.escrituraNumero} onChange={e => set("escrituraNumero", e.target.value)}
              placeholder="12345"/>
          </div>
          <div>
            <label style={labelStyle}>Fecha de escritura</label>
            <input autoComplete="off" style={inputStyle} value={form.escrituraFecha} onChange={e => set("escrituraFecha", e.target.value)}
              placeholder="15 de marzo de 2018"/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Notario que autorizó</label>
            <input autoComplete="off" style={inputStyle} value={form.notarioOriginal} onChange={e => set("notarioOriginal", e.target.value)}
              placeholder="Lic. ___, Notario No. ___ en Aguascalientes, Ags."/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Inscripción en el RPP</label>
            <input autoComplete="off" style={inputStyle} value={form.inscripcionRPP} onChange={e => set("inscripcionRPP", e.target.value)}
              placeholder="Folio Real ___, sección ___ de fecha ___"/>
          </div>
        </SectionInmueble>

        {/* Precio y forma de pago */}
        <SectionInmueble title="Precio y forma de pago" fontSerif={fontSerif} isMobile={isMobile}>
          <div>
            <label style={labelStyle}>Precio total (MXN) <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" type="number" style={inputStyle} value={form.precio} onChange={e => set("precio", e.target.value)}
              placeholder="1500000"/>
          </div>
          <div>
            <label style={labelStyle}>Forma de pago <span style={{color:"#DC2626"}}>*</span></label>
            <div style={{display:"flex", gap:8}}>
              {(["contado","parcialidades"] as const).map(t => (
                <button key={t} onClick={() => setFormaPago(t)}
                  style={{flex:1, padding:"9px 12px", borderRadius:8, fontSize:12, fontWeight:600,
                    fontFamily:fontSans, cursor:"pointer",
                    background: formaPago===t ? "#B8932A" : "white",
                    color: formaPago===t ? "white" : "#374151",
                    border: formaPago===t ? "1px solid #B8932A" : "1px solid #D1D5DB"}}>
                  {t === "contado" ? "Contado" : "Parcialidades"}
                </button>
              ))}
            </div>
          </div>

          {formaPago === "parcialidades" && (
            <>
              <div>
                <label style={labelStyle}>Anticipo (MXN)</label>
                <input autoComplete="off" type="number" style={inputStyle} value={form.anticipo} onChange={e => set("anticipo", e.target.value)}/>
              </div>
              <div>
                <label style={labelStyle}>Saldo (auto-calculado)</label>
                <input autoComplete="off" type="number" style={inputStyle} value={form.saldo} onChange={e => set("saldo", e.target.value)} readOnly/>
              </div>
              <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
                <label style={labelStyle}>Plazo de pago del saldo (meses)</label>
                <input autoComplete="off" type="number" style={inputStyle} value={form.plazoMesesParcialidades} onChange={e => set("plazoMesesParcialidades", e.target.value)}/>
              </div>
            </>
          )}
        </SectionInmueble>

        {/* Términos y condiciones */}
        <SectionInmueble title="Términos de entrega y escrituración" fontSerif={fontSerif} isMobile={isMobile}>
          <div>
            <label style={labelStyle}>Fecha de entrega física <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" type="date" style={inputStyle} value={form.fechaEntregaFisica} onChange={e => set("fechaEntregaFisica", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Plazo para escriturar (días)</label>
            <input autoComplete="off" type="number" style={inputStyle} value={form.plazoEscrituracion} onChange={e => set("plazoEscrituracion", e.target.value)}
              placeholder="60"/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Notario propuesto para la escrituración (opcional)</label>
            <input autoComplete="off" style={inputStyle} value={form.notarioParaEscriturar} onChange={e => set("notarioParaEscriturar", e.target.value)}
              placeholder="Si las partes ya lo acordaron, anotar aquí"/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1", padding:"8px 12px",
            background:"rgba(184,147,42,0.05)", borderRadius:8,
            border:"1px solid rgba(184,147,42,0.15)"}}>
            <label style={{display:"flex", alignItems:"center", gap:8, cursor:"pointer", fontSize:12, color:"#374151"}}>
              <input autoComplete="off" type="checkbox" checked={form.librGravamen} onChange={e => set("librGravamen", e.target.checked)}/>
              <strong>Inmueble libre de gravamen</strong> (sin hipotecas, embargos ni limitaciones)
            </label>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1", padding:"8px 12px",
            background:"rgba(184,147,42,0.05)", borderRadius:8,
            border:"1px solid rgba(184,147,42,0.15)"}}>
            <label style={{display:"flex", alignItems:"center", gap:8, cursor:"pointer", fontSize:12, color:"#374151"}}>
              <input autoComplete="off" type="checkbox" checked={form.predialAlCorriente} onChange={e => set("predialAlCorriente", e.target.checked)}/>
              <strong>Predial y servicios al corriente</strong> a la fecha de firma
            </label>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1", padding:"8px 12px",
            background:"rgba(184,147,42,0.05)", borderRadius:8,
            border:"1px solid rgba(184,147,42,0.15)"}}>
            <label style={{display:"flex", alignItems:"center", gap:8, cursor:"pointer", fontSize:12, color:"#374151"}}>
              <input autoComplete="off" type="checkbox" checked={form.posesionInmediata} onChange={e => set("posesionInmediata", e.target.checked)}/>
              <strong>Posesión inmediata a la firma</strong> (si está marcada, la firma del contrato hace prueba de la entrega)
            </label>
          </div>
        </SectionInmueble>

        {/* Testigos */}
        <SectionInmueble title="Testigos (recomendado)" fontSerif={fontSerif} isMobile={isMobile}>
          <div>
            <label style={labelStyle}>Nombre Testigo 1</label>
            <input autoComplete="off" style={inputStyle} value={form.nombreTestigo1} onChange={e => set("nombreTestigo1", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Nombre Testigo 2</label>
            <input autoComplete="off" style={inputStyle} value={form.nombreTestigo2} onChange={e => set("nombreTestigo2", e.target.value)}/>
          </div>
        </SectionInmueble>

        {/* Aviso final */}
        <div style={{background:"rgba(220,38,38,0.06)", border:"1px solid rgba(220,38,38,0.25)",
          borderRadius:10, padding:"12px 14px", marginBottom:18, display:"flex", gap:10}}>
          <AxisIcon name="alert" size={16} color="#DC2626" withBackdrop={false} strokeWidth={3}/>
          <div style={{fontSize:11.5, color:"#374151", lineHeight:1.5}}>
            <strong>Recordatorio:</strong> Las partes <strong>se obligan a comparecer ante Notario Público</strong> dentro del plazo pactado para otorgar la escritura pública correspondiente. Sin escrituración no podrás inscribir el inmueble a tu nombre en el Registro Público de la Propiedad. Para tramitar la escritura te recomendamos contactar a AXIS Asesoría Legal Corporativa o a un notario público de tu confianza.
          </div>
        </div>

        {/* Botón generar */}
        <button onClick={generarPDF} disabled={generando || !camposObligatoriosLlenos}
          style={{width:"100%", padding:"14px", borderRadius:10,
            background: camposObligatoriosLlenos
              ? "linear-gradient(135deg,#B8932A,#A07C30)"
              : "#9CA3AF",
            border:"none", color:"white", fontSize:15, fontWeight:700,
            cursor: camposObligatoriosLlenos ? "pointer" : "not-allowed",
            boxShadow: camposObligatoriosLlenos ? "0 4px 16px rgba(184,147,42,0.35)" : "none",
            display:"flex", alignItems:"center", justifyContent:"center", gap:10,
            fontFamily:fontSans}}>
          <AxisIcon name="document" size={16} tone="white" withBackdrop={false} strokeWidth={3}/>
          {generando ? "Generando contrato..." : "Generar contrato en PDF"}
        </button>

        {!camposObligatoriosLlenos && (
          <p style={{fontSize:11, color:"#DC2626", margin:"8px 0 0", textAlign:"center" as const}}>
            Completa los campos marcados con <strong>*</strong> para generar el contrato.
          </p>
        )}
        {ultimoBlob && (
          <div style={{marginTop:14, padding:"14px 16px", background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:12, display:"flex", justifyContent:"space-between", alignItems:"center", gap:12, flexWrap:"wrap"}}>
            <div style={{fontSize:12, color:T_LIGHT.textInkSoft, flex:1, minWidth:160}}>¿Quieres guardar este contrato en un expediente?</div>
            <BotonGuardarYVincular
              user={user}
              tipoContrato={tipoContrato}
              getPDFBlob={async () => ultimoBlob!}
              nombrePDFBase={`Contrato_${tipoContrato}`}
              fontSans={fontSans} fontSerif={fontSerif} gold={gold}
            />
          </div>
        )}
      </div>
    </div>
  );
}


// #endregion
// #region NDA
// ─── CONTRATO: CONFIDENCIALIDAD (NDA) ─────────────────────────────────────────
// Convenio de no revelación de información, adaptado para Aguascalientes.
// Funciona entre empresas, empresa-persona, persona-persona, en cualquier giro.
function SectionNDA({title, children, fontSerif, isMobile}: {title:string; children:React.ReactNode; fontSerif:string; isMobile:boolean}) {
  return (
    <div style={{marginBottom:18}}>
      <div style={{fontFamily:fontSerif, fontSize:14, fontWeight:700, color:"#0F172A",
        marginBottom:10, paddingBottom:6, borderBottom:"1px solid rgba(15,23,42,0.3)",
        display:"flex", alignItems:"center", gap:8}}>
        <AxisIcon name="lock_closed" size={14} color="#0F172A" withBackdrop={false} strokeWidth={3}/>
        {title}
      </div>
      <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr":"1fr 1fr", gap:10}}>
        {children}
      </div>
    </div>
  );
}

function FormConfidencialidad({user, tipoContrato, onBack, fontSans, fontSerif, gold}: {user:any; tipoContrato:string; onBack:()=>void; fontSans:string; fontSerif:string; gold:string}) {
  // El pie de este documento lo firma el patrón, no la plataforma.
  const datosPatron = useDatosPatron(user?.uid).datos;
  // Las dos partes de este convenio, para el control de "cuál soy yo".
  // El INFORMADO sí tiene selector física/moral en este formulario —lo pone el
  // control al elegir—; el INFORMANTE no lo tiene, así que ahí se avisa.
  const PARTES_NDA: ParteDeContrato[] = [
    {clave:"informante", etiqueta:"Informante", nombre:"razonSocialInformante", rfc:"rfcInformante", domicilio:"domicilioInformante", declaraPersonaFisica:true},
    {clave:"informado",  etiqueta:"Informado",  nombre:"razonSocialInformado",  rfc:"rfcInformado",  domicilio:"domicilioInformado"},
  ];
  const [miParte, setMiParte] = useState("");   // por defecto, ninguna
  const isMobile = window.innerWidth < 768;
  const [tipoInformante, setTipoInformante] = useState<"moral"|"fisica">("moral");
  const [tipoInformado, setTipoInformado] = useState<"fisica"|"moral">("fisica");
  const [monedaDanios, setMonedaDanios] = useState<"USD"|"MXN">("MXN");
  const [incluyeNoCompetencia, setIncluyeNoCompetencia] = useState<boolean>(false);

  const [form, setForm] = useState({
    ciudad: "Aguascalientes, Ags.",
    fechaContrato: "",
    // Informante
    razonSocialInformante: "",
    repLegalInformante: "",
    escrituraInformante: "",
    rfcInformante: "",
    domicilioInformante: "",
    nombreInformanteFisico: "",
    ineInformanteFisico: "",
    // Informado
    razonSocialInformado: "",
    repLegalInformado: "",
    rfcInformado: "",
    domicilioInformado: "",
    nombreInformadoFisico: "",
    ineInformadoFisico: "",
    estadoCivilInformado: "soltero(a)",
    // Contexto
    propositoRelacion: "",
    descripcionServicios: "",
    // Términos
    vigenciaMeses: "36",
    montoDanios: "100000",
    // Testigos
    nombreTestigo1: "",
    nombreTestigo2: "",
  });

  const [generando, setGenerando] = useState(false);
  const [ultimoBlob, setUltimoBlob] = useState<Blob|null>(null);
  const set = (k: string, v: any) => setForm(p => ({...p, [k]:v}));
  const F = (v: string) => v || "_______________________________";
  // FECHAS EN CASTELLANO, NO EN ISO. El campo guarda "2026-09-07" y eso salía
  // impreso tal cual en un contrato que se firma. `fechaLargaAxis` PARTE la
  // cadena en vez de construir un Date: `new Date("2026-09-01")` es medianoche
  // UTC, y en México eso es el 31 de agosto —el contrato imprimiría el día
  // anterior al pactado—. Si el valor no es una fecha ISO (hay campos de fecha
  // que son texto libre), se imprime tal como se escribió.
  const FF = (v: string) => fechaLargaAxis(v) || F(v);

  const numeroALetras = (n: number): string => {
    const unidades = ["","UN","DOS","TRES","CUATRO","CINCO","SEIS","SIETE","OCHO","NUEVE","DIEZ","ONCE","DOCE","TRECE","CATORCE","QUINCE","DIECISEIS","DIECISIETE","DIECIOCHO","DIECINUEVE"];
    const decenas = ["","DIEZ","VEINTE","TREINTA","CUARENTA","CINCUENTA","SESENTA","SETENTA","OCHENTA","NOVENTA"];
    const centenas = ["","CIEN","DOSCIENTOS","TRESCIENTOS","CUATROCIENTOS","QUINIENTOS","SEISCIENTOS","SETECIENTOS","OCHOCIENTOS","NOVECIENTOS"];
    if (n === 0) return "CERO";
    if (n < 20) return unidades[n];
    if (n < 100) return decenas[Math.floor(n/10)] + (n%10 ? " Y " + unidades[n%10] : "");
    if (n < 1000) return centenas[Math.floor(n/100)] + (n%100 ? " " + numeroALetras(n%100) : "");
    if (n < 10000) return unidades[Math.floor(n/1000)] + " MIL" + (n%1000 ? " " + numeroALetras(n%1000) : "");
    if (n < 1000000) return numeroALetras(Math.floor(n/1000)) + " MIL" + (n%1000 ? " " + numeroALetras(n%1000) : "");
    return numeroALetras(Math.floor(n/1000000)) + " MILLONES" + (n%1000000 ? " " + numeroALetras(n%1000000) : "");
  };

  const fmtMoneda = (v: string, moneda: string) => {
    if (!v) return "_______________________________";
    const n = parseFloat(v);
    if (isNaN(n)) return v;
    const simbolo = moneda === "USD" ? "USD$" : "$";
    const sufijo = moneda === "USD" ? " (DÓLARES AMERICANOS)" : " M.N. (PESOS MEXICANOS)";
    return simbolo + n.toLocaleString("es-MX", {minimumFractionDigits:2, maximumFractionDigits: 2}) + " (" + numeroALetras(Math.floor(n)) + sufijo + ")";
  };

  const generarPDF = () => {
    setGenerando(true);
    setTimeout(() => {
      const { jsPDF } = (window as any).jspdf;
      const doc = new jsPDF({orientation:"portrait", unit:"mm", format:"letter"});
      const W = doc.internal.pageSize.getWidth();
      const H = doc.internal.pageSize.getHeight();
      const ML = 22, MR = 22;
      const usable = W - ML - MR;
      let y = 28;   // margen superior cómodo; el contrato inicia DIRECTO con su título (AXIS va al pie)

      const checkPage = (need = 8) => { if (y + need > H - 34) { doc.addPage(); y = 28; } };
      const titulo = (txt: string) => {
        checkPage(12);
        doc.setFont("times","bold"); doc.setFontSize(11); doc.setTextColor(11,24,41);
        doc.text(txt, W/2, y, {align:"center"}); y += 7;
      };
      const subtitulo = (txt: string) => {
        checkPage(30);   // mantiene el encabezado junto a su primer texto (evita viudas)
        doc.setFont("times","bold"); doc.setFontSize(10); doc.setTextColor(11,24,41);
        doc.text(txt, ML, y); y += 5;
      };
      const parrafo = (txt: string, opts?:{align?:"justify"|"left"|"center"; bold?:boolean; size?:number}) => {
        const fs = opts?.size || 9;
        doc.setFont("times", opts?.bold ? "bold" : "normal");
        doc.setFontSize(fs); doc.setTextColor(45,45,45);
        const lines = doc.splitTextToSize(txt, usable);
        for (const ln of lines) {
          checkPage(5);
          doc.text(ln, ML, y, {align: opts?.align==="center" ? "center" : "left", maxWidth: usable});
          y += fs*0.42 + 1.2;
        }
        y += 1;
      };

      // ───── ENCABEZADO ─────
      titulo("CONVENIO DE CONFIDENCIALIDAD Y NO REVELACIÓN DE INFORMACIÓN");

      const infoNombre = tipoInformante === "moral"
        ? `LA SOCIEDAD DENOMINADA ${F(form.razonSocialInformante).toUpperCase()}, REPRESENTADA POR ${F(form.repLegalInformante).toUpperCase()}`
        : F(form.nombreInformanteFisico).toUpperCase();
      const infdoNombre = tipoInformado === "moral"
        ? `LA SOCIEDAD DENOMINADA ${F(form.razonSocialInformado).toUpperCase()}, REPRESENTADA POR ${F(form.repLegalInformado).toUpperCase()}`
        : F(form.nombreInformadoFisico).toUpperCase();

      parrafo(
        `Convenio de confidencialidad y no revelación de información que celebran por una parte ${infoNombre}, a quien en lo sucesivo se denominará "EL INFORMANTE", y por la otra parte ${infdoNombre}, en adelante "EL INFORMADO", ambas partes con capacidad legal para contratar y obligarse, sujetando este acto a las siguientes declaraciones y cláusulas:`,
        {align:"justify"}
      );

      // ───── DECLARACIONES ─────
      subtitulo("DECLARACIONES");

      parrafo("I. DECLARA EL INFORMANTE:", {bold:true});
      if (tipoInformante === "moral") {
        parrafo(`a) Ser una sociedad mercantil legalmente constituida conforme a las leyes mexicanas, según consta en la escritura pública ${F(form.escrituraInformante)}.`);
        parrafo(`b) Estar representada por ${F(form.repLegalInformante)}, quien cuenta con las facultades suficientes para celebrar el presente convenio y comprometer a su mandante en los términos aquí estipulados.`);
        parrafo(`c) Tener su domicilio en ${F(form.domicilioInformante)} y contar con RFC ${F(form.rfcInformante)}.`);
      } else {
        parrafo(`a) Ser persona física mayor de edad, con plena capacidad jurídica, identificándose con credencial de elector clave ${F(form.ineInformanteFisico)}.`);
        parrafo(`b) Tener su domicilio en ${F(form.domicilioInformante)} y contar con RFC ${F(form.rfcInformante)}.`);
      }

      parrafo("II. DECLARA EL INFORMADO:", {bold:true});
      if (tipoInformado === "moral") {
        parrafo(`a) Ser una sociedad legalmente constituida, representada por ${F(form.repLegalInformado)}, quien cuenta con facultades suficientes para celebrar este convenio.`);
        parrafo(`b) Tener su domicilio en ${F(form.domicilioInformado)} y RFC ${F(form.rfcInformado)}.`);
      } else {
        parrafo(`a) Ser persona física mayor de edad, mexicano(a), de estado civil ${F(form.estadoCivilInformado)}, identificándose con credencial de elector clave ${F(form.ineInformadoFisico)}.`);
        parrafo(`b) Tener su domicilio en ${F(form.domicilioInformado)}${form.rfcInformado ? ` y RFC ${form.rfcInformado}` : ""}.`);
      }
      parrafo(
        `c) Que en virtud de la relación que sostiene con EL INFORMANTE, ${F(form.propositoRelacion)}, ha obtenido y seguirá obteniendo directamente de EL INFORMANTE documentos, datos e información necesaria para el cumplimiento de dicha relación.`,
        {align:"justify"}
      );
      if (form.descripcionServicios) {
        parrafo(`d) Sus servicios o actividades específicas consistirán en: ${form.descripcionServicios}.`);
      }
      parrafo(
        `e) Reconoce que la información y documentación recibida es propiedad exclusiva de EL INFORMANTE, no es del conocimiento público, y representa una ventaja económica y de desarrollo para EL INFORMANTE respecto de sus competidores.`,
        {align:"justify"}
      );

      parrafo("III. DECLARAN AMBAS PARTES:", {bold:true});
      parrafo("Que se reconocen mutuamente la personalidad y facultades con que comparecen, celebrando este convenio con buena fe, sin error, dolo, violencia ni vicio alguno del consentimiento.");

      // ───── CLÁUSULAS ─────
      checkPage(12);
      y += 2;
      subtitulo("CLÁUSULAS");

      parrafo("PRIMERA. INFORMACIÓN CONFIDENCIAL.", {bold:true});
      parrafo(
        `Para efectos de este convenio, "Información Confidencial" significa: todo documento, dato, plan, proyecto, programa de cómputo, software, mercadotecnia, administración, ventas, publicidad, estrategias, métodos, técnicas, conocimientos técnicos, procesos, diseños, marcas, patentes, secretos, especificaciones, información de mercado, financiera, comercial, listados de clientes, proveedores, distribuidores, deudores, acreedores, asesores, datos personales, números de cuenta, contratos, estados de cuenta, direcciones y cualquier información que EL INFORMADO reciba u obtenga directa o indirectamente como resultado de su relación con EL INFORMANTE, así como toda información proveniente de las sociedades en las que EL INFORMANTE participe. Esta información será considerada confidencial aunque no sea proporcionada directamente por EL INFORMANTE.`,
        {align:"justify"}
      );

      parrafo("SEGUNDA. OBLIGACIONES DEL INFORMADO.", {bold:true});
      parrafo("Durante la vigencia del presente convenio, EL INFORMADO se obliga a:", {align:"justify"});
      parrafo("a) Mantener en estricta secrecía y no difundir por ningún medio toda o parte de la Información Confidencial que EL INFORMANTE, sus representantes, empleados, asesores, proveedores, distribuidores o las sociedades en las que EL INFORMANTE participa le hayan suministrado o le suministren en el futuro.");
      parrafo("b) Abstenerse de utilizar, directa o indirectamente, la Información Confidencial para su exclusivo beneficio o de terceros, sin autorización previa por escrito de EL INFORMANTE.");
      parrafo("c) No proporcionar dicha información a terceros bajo ninguna circunstancia, sin autorización expresa.");
      parrafo("d) Emplear el cuidado necesario para impedir la utilización no autorizada, copia, reproducción, imitación o cualquier otro acto contrario a los fines aquí señalados.");
      parrafo("e) Conservar la Información Confidencial a disposición de EL INFORMANTE y restituirla en un término máximo de 15 días naturales cuando le sea solicitada. La omisión de su entrega oportuna o su retención serán consideradas ilegales para todos los efectos legales.");
      if (incluyeNoCompetencia) {
        parrafo("f) Abstenerse de prestar servicios de la misma o similar naturaleza que los que presta a EL INFORMANTE en la misma rama o industria, utilizando las técnicas, información, listados, sistemas o procedimientos que le hayan sido proporcionados.");
      }

      parrafo("TERCERA. EXCEPCIONES.", {bold:true});
      parrafo(
        `EL INFORMADO quedará liberado de las obligaciones de confidencialidad cuando: a) la Información Confidencial haya sido divulgada general y públicamente por EL INFORMANTE; b) EL INFORMANTE consienta expresamente y por escrito la revelación de información específica.`,
        {align:"justify"}
      );

      parrafo("CUARTA. EXTENSIÓN DE LA SECRECÍA.", {bold:true});
      parrafo(
        `EL INFORMADO se obliga a hacer del conocimiento de todas las personas que bajo cualquier acto jurídico tengan relación con él y se vean involucradas o tengan acceso a la Información Confidencial (familiares, socios, trabajadores, asesores, etc.) las obligaciones consignadas en este convenio, así como a obligarlas a respetar la secrecía y confidencialidad bajo la pena de responder en los términos del presente instrumento.`,
        {align:"justify"}
      );

      parrafo("QUINTA. RESPONSABILIDAD CIVIL Y PENAL.", {bold:true});
      parrafo(
        `EL INFORMADO tiene la obligación de guardar escrupulosamente los secretos técnicos, comerciales, métodos, procedimientos e Información Confidencial, conforme a la Ley Federal de Protección a la Propiedad Industrial (artículos 82, 83 y siguientes), el Código Penal Federal (artículos 210 y 211), el Código Penal del Estado de Aguascalientes y el Código Civil del Estado de Aguascalientes. La divulgación o uso indebido podrá derivar en responsabilidad civil y penal, además de la prevista en este convenio.`,
        {align:"justify"}
      );

      parrafo("SEXTA. DAÑOS Y PERJUICIOS PRECUANTIFICADOS.", {bold:true});
      parrafo(
        `EL INFORMADO reconoce que el daño que sufriría EL INFORMANTE por el incumplimiento del presente convenio sería irreparable, y que la cuantificación pecuniaria de los daños y perjuicios sería difícil o imposible de determinar. En consecuencia, las partes convienen, bajo el concepto de daños precuantificados y sin necesidad de probarlos, en la cantidad de ${fmtMoneda(form.montoDanios, monedaDanios)}, sin perjuicio del derecho de EL INFORMANTE para intentar todos los remedios legales que en derecho procedan, incluyendo las denuncias penales que correspondan.`,
        {align:"justify"}
      );

      parrafo("SÉPTIMA. VIGENCIA.", {bold:true});
      parrafo(
        `Este convenio tendrá una vigencia forzosa para ambas partes a partir de la fecha de su firma y se mantendrá en vigor durante ${F(form.vigenciaMeses)} meses posteriores a la conclusión de la relación o proyecto entre las partes. Una vez transcurrido el término, las obligaciones aquí contraídas se tendrán por finalizadas.`,
        {align:"justify"}
      );

      parrafo("OCTAVA. NO COMPROMISO LABORAL NI REPRESENTACIÓN.", {bold:true});
      parrafo(
        `Las partes reconocen que la celebración de este convenio no constituye relación laboral ni compromiso de celebrar contrato alguno. EL INFORMADO no es ni adquiere carácter alguno de representante o apoderado de EL INFORMANTE, por lo que no tiene facultad para actuar en nombre de éste ni asumir derechos u obligaciones a su cargo.`,
        {align:"justify"}
      );

      parrafo("NOVENA. DEPOSITARIO Y MODIFICACIONES.", {bold:true});
      parrafo(
        `EL INFORMADO será considerado depositario para todos los efectos legales de la Información Confidencial recibida. Cualquier modificación al presente convenio deberá realizarse mediante acuerdo por escrito firmado por ambas partes.`,
        {align:"justify"}
      );

      parrafo("DÉCIMA. JURISDICCIÓN.", {bold:true});
      parrafo(
        `Para la interpretación, cumplimiento y ejecución del presente convenio, las partes se someten expresamente a las leyes y tribunales competentes en el Estado de Aguascalientes, México, renunciando a cualquier otro fuero que pudiera corresponderles por razón de su domicilio presente o futuro.`,
        {align:"justify"}
      );

      // ───── FIRMAS ─────
      checkPage(45);
      y += 6;
      doc.setFont("times","bold"); doc.setFontSize(9); doc.setTextColor(11,24,41);
      doc.text(`Leído el presente convenio y enterados de su alcance, las partes lo firman de conformidad en ${F(form.ciudad)} el día ${FF(form.fechaContrato)}.`, W/2, y, {align:"center", maxWidth: usable});
      y += 14;

      const colW = (usable - 8) / 2;
      const x1 = ML;
      const x2 = ML + colW + 8;
      doc.setDrawColor(11,24,41);
      doc.setLineWidth(0.3);
      doc.line(x1+8, y, x1+colW-8, y);
      doc.line(x2+8, y, x2+colW-8, y);
      y += 4;
      doc.setFont("times","bold"); doc.setFontSize(8);
      doc.text("EL INFORMANTE", x1+colW/2, y, {align:"center"});
      doc.text("EL INFORMADO", x2+colW/2, y, {align:"center"});
      y += 4;
      doc.setFont("times","normal");
      const nomInf = tipoInformante === "moral" ? F(form.razonSocialInformante) : F(form.nombreInformanteFisico);
      const nomIfo = tipoInformado === "moral" ? F(form.razonSocialInformado) : F(form.nombreInformadoFisico);
      doc.text(nomInf, x1+colW/2, y, {align:"center"});
      doc.text(nomIfo, x2+colW/2, y, {align:"center"});
      if (tipoInformante === "moral") {
        y += 4;
        doc.setFontSize(7);
        doc.text(`Por: ${F(form.repLegalInformante)}`, x1+colW/2, y, {align:"center"});
      }
      if (tipoInformado === "moral") {
        if (tipoInformante !== "moral") y += 4;
        doc.setFontSize(7);
        doc.text(`Por: ${F(form.repLegalInformado)}`, x2+colW/2, y, {align:"center"});
      }

      // Testigos
      if (form.nombreTestigo1 || form.nombreTestigo2) {
        y += 14;
        checkPage(20);
        doc.line(x1+8, y, x1+colW-8, y);
        doc.line(x2+8, y, x2+colW-8, y);
        y += 4;
        doc.setFont("times","bold"); doc.setFontSize(8);
        doc.text("TESTIGO 1", x1+colW/2, y, {align:"center"});
        doc.text("TESTIGO 2", x2+colW/2, y, {align:"center"});
        y += 4;
        doc.setFont("times","normal");
        doc.text(F(form.nombreTestigo1), x1+colW/2, y, {align:"center"});
        doc.text(F(form.nombreTestigo2), x2+colW/2, y, {align:"center"});
      }

      // Footer
      const totalPages = doc.internal.pages.length - 1;
      for (let p = 1; p <= totalPages; p++) {
        doc.setPage(p);
        doc.setFont("times","italic"); doc.setFontSize(7);
        doc.setTextColor(120,120,120);
        pintarLeyendaContrato(doc, W/2, H-13.5, W-ML-MR, "center");
        doc.text(pieDelPatron(datosPatron, fechaHoraLargaAxis()), W/2, H-10, {align:"center"});
        doc.text(`Página ${p} de ${totalPages}`, W-MR, H-10, {align:"right"});
      }

      const fname = `NDA_Confidencialidad_${(nomIfo || "informado").replace(/[^A-Za-z0-9]/g,"_")}.pdf`;
      doc.save(fname);
      try { setUltimoBlob(doc.output("blob")); } catch {}
      setGenerando(false);
    }, 200);
  };

  const inputStyle: React.CSSProperties = {
    width:"100%", padding:"9px 11px", fontSize:13, fontFamily:fontSans,
    background:"white", border:"1px solid #D1D5DB", borderRadius:8, color:"#0F172A",
    boxSizing:"border-box" as const,
  };
  const labelStyle: React.CSSProperties = {
    display:"block", fontSize:11, fontWeight:600, color:"#374151", marginBottom:4,
    letterSpacing:"0.2px",
  };

  const camposObligatoriosLlenos = !!(
    form.fechaContrato && form.propositoRelacion &&
    form.montoDanios && form.vigenciaMeses &&
    (tipoInformante === "moral" ? form.razonSocialInformante && form.repLegalInformante : form.nombreInformanteFisico) &&
    (tipoInformado === "moral" ? form.razonSocialInformado && form.repLegalInformado : form.nombreInformadoFisico)
  );

  return (
    <div {...ZONA_DE_CAPTURA} style={{minHeight:"100vh", background:T_LIGHT.canvas, fontFamily:fontSans}}>
      {/* Header */}
      <div style={{background:"linear-gradient(135deg,#0F172A,#1E293B)", padding:"0 20px", height:58,
        display:"flex", alignItems:"center", gap:12, position:"sticky" as const, top:0, zIndex:100,
        boxShadow:"0 4px 20px rgba(15,23,42,0.4)"}}>
        <button onClick={onBack}
          style={{background:"rgba(255,255,255,0.15)", border:"1px solid rgba(255,255,255,0.25)",
            color:"white", borderRadius:8, padding:"5px 11px", cursor:"pointer",
            fontSize:12, fontWeight:600}}>← Generador legal</button>
        <span style={{color:"white", fontWeight:700, fontSize:14, display:"flex",
          alignItems:"center", gap:8}}>
          <AxisIcon name="lock_closed" size={18} tone="white" withBackdrop={false} strokeWidth={2.5}/>
          Convenio de Confidencialidad (NDA)
        </span>
      </div>

      <div style={{maxWidth:760, margin:"0 auto", padding:isMobile?"16px":"24px"}}>
        <p style={{fontSize:12, color:"#64748B", margin:"0 0 18px", lineHeight:1.6}}>
          Convenio de no revelación de información sensible. Aplicable entre empresas, empresa-persona o entre particulares. Adaptado a la legislación de Aguascalientes.
        </p>

        <SelectorDeMiParte partes={PARTES_NDA} elegida={miParte} tipoPersona={datosPatron.tipoPersona} fontSans={fontSans} fontSerif={fontSerif}
          onElegir={(c)=>{ setMiParte(c); setForm((f:any)=>aplicarMiParte(f, PARTES_NDA, c, datosPatron));
            // Este formulario SÍ tiene la variante de sociedad para el informado:
            // se pone del lado que corresponde en vez de dejarla en "física" por
            // omisión, que era lo que hacía falsa la declaración.
            if (c === "informado" && datosPatron.tipoPersona) setTipoInformado(datosPatron.tipoPersona);
          }}/>

        {/* Datos generales */}
        <SectionNDA title="Datos generales" fontSerif={fontSerif} isMobile={isMobile}>
          <div>
            <label style={labelStyle}>Ciudad y estado de firma <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" style={inputStyle} value={form.ciudad} onChange={e => set("ciudad", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Fecha de firma <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" type="date" style={inputStyle} value={form.fechaContrato} onChange={e => set("fechaContrato", e.target.value)}/>
          </div>
        </SectionNDA>

        {/* INFORMANTE */}
        <SectionNDA title="EL INFORMANTE (quien comparte la información)" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Tipo de persona <span style={{color:"#DC2626"}}>*</span></label>
            <div style={{display:"flex", gap:8}}>
              {(["moral","fisica"] as const).map(t => (
                <button key={t} onClick={() => setTipoInformante(t)}
                  style={{flex:1, padding:"9px 12px", borderRadius:8, fontSize:12, fontWeight:600,
                    fontFamily:fontSans, cursor:"pointer",
                    background: tipoInformante===t ? "#0F172A" : "white",
                    color: tipoInformante===t ? "white" : "#374151",
                    border: tipoInformante===t ? "1px solid #0F172A" : "1px solid #D1D5DB"}}>
                  {t === "moral" ? "Persona moral (empresa)" : "Persona física"}
                </button>
              ))}
            </div>
          </div>
          {tipoInformante === "moral" ? (
            <>
              <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
                <label style={labelStyle}>Razón social <span style={{color:"#DC2626"}}>*</span></label>
                <input autoComplete="off" style={inputStyle} value={form.razonSocialInformante} onChange={e => set("razonSocialInformante", e.target.value)}
                  placeholder="EMPRESA EJEMPLO S.A. DE C.V."/>
              </div>
              <div>
                <label style={labelStyle}>Representante legal <span style={{color:"#DC2626"}}>*</span></label>
                <input autoComplete="off" style={inputStyle} value={form.repLegalInformante} onChange={e => set("repLegalInformante", e.target.value)}/>
              </div>
              <div>
                <label style={labelStyle}>RFC</label>
                <input autoComplete="off" style={inputStyle} value={form.rfcInformante} onChange={e => set("rfcInformante", e.target.value)}/>
              </div>
              <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
                <label style={labelStyle}>Datos escritura constitutiva</label>
                <input autoComplete="off" style={inputStyle} value={form.escrituraInformante} onChange={e => set("escrituraInformante", e.target.value)}
                  placeholder="No. ___ de fecha ___, ante Notario ___"/>
              </div>
            </>
          ) : (
            <>
              <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
                <label style={labelStyle}>Nombre completo <span style={{color:"#DC2626"}}>*</span></label>
                <input autoComplete="off" style={inputStyle} value={form.nombreInformanteFisico} onChange={e => set("nombreInformanteFisico", e.target.value)}/>
              </div>
              <div>
                <label style={labelStyle}>Clave de elector (INE)</label>
                <input autoComplete="off" style={inputStyle} value={form.ineInformanteFisico} onChange={e => set("ineInformanteFisico", e.target.value)}/>
              </div>
              <div>
                <label style={labelStyle}>RFC</label>
                <input autoComplete="off" style={inputStyle} value={form.rfcInformante} onChange={e => set("rfcInformante", e.target.value)}/>
              </div>
            </>
          )}
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Domicilio</label>
            <input autoComplete="off" style={inputStyle} value={form.domicilioInformante} onChange={e => set("domicilioInformante", e.target.value)}/>
          </div>
        </SectionNDA>

        {/* INFORMADO */}
        <SectionNDA title="EL INFORMADO (quien recibe la información)" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Tipo de persona <span style={{color:"#DC2626"}}>*</span></label>
            <div style={{display:"flex", gap:8}}>
              {(["fisica","moral"] as const).map(t => (
                <button key={t} onClick={() => setTipoInformado(t)}
                  style={{flex:1, padding:"9px 12px", borderRadius:8, fontSize:12, fontWeight:600,
                    fontFamily:fontSans, cursor:"pointer",
                    background: tipoInformado===t ? "#0F172A" : "white",
                    color: tipoInformado===t ? "white" : "#374151",
                    border: tipoInformado===t ? "1px solid #0F172A" : "1px solid #D1D5DB"}}>
                  {t === "moral" ? "Persona moral (empresa)" : "Persona física"}
                </button>
              ))}
            </div>
          </div>
          {tipoInformado === "moral" ? (
            <>
              <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
                <label style={labelStyle}>Razón social <span style={{color:"#DC2626"}}>*</span></label>
                <input autoComplete="off" style={inputStyle} value={form.razonSocialInformado} onChange={e => set("razonSocialInformado", e.target.value)}/>
              </div>
              <div>
                <label style={labelStyle}>Representante legal <span style={{color:"#DC2626"}}>*</span></label>
                <input autoComplete="off" style={inputStyle} value={form.repLegalInformado} onChange={e => set("repLegalInformado", e.target.value)}/>
              </div>
              <div>
                <label style={labelStyle}>RFC</label>
                <input autoComplete="off" style={inputStyle} value={form.rfcInformado} onChange={e => set("rfcInformado", e.target.value)}/>
              </div>
            </>
          ) : (
            <>
              <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
                <label style={labelStyle}>Nombre completo <span style={{color:"#DC2626"}}>*</span></label>
                <input autoComplete="off" style={inputStyle} value={form.nombreInformadoFisico} onChange={e => set("nombreInformadoFisico", e.target.value)}/>
              </div>
              <div>
                <label style={labelStyle}>Clave de elector (INE)</label>
                <input autoComplete="off" style={inputStyle} value={form.ineInformadoFisico} onChange={e => set("ineInformadoFisico", e.target.value)}/>
              </div>
              <div>
                <label style={labelStyle}>RFC</label>
                <input autoComplete="off" style={inputStyle} value={form.rfcInformado} onChange={e => set("rfcInformado", e.target.value)}/>
              </div>
              <div>
                <label style={labelStyle}>Estado civil</label>
                <select style={inputStyle} value={form.estadoCivilInformado} onChange={e => set("estadoCivilInformado", e.target.value)}>
                  <option value="soltero(a)">Soltero(a)</option>
                  <option value="casado(a)">Casado(a)</option>
                  <option value="divorciado(a)">Divorciado(a)</option>
                  <option value="viudo(a)">Viudo(a)</option>
                  <option value="unión libre">Unión libre</option>
                </select>
              </div>
            </>
          )}
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Domicilio</label>
            <input autoComplete="off" style={inputStyle} value={form.domicilioInformado} onChange={e => set("domicilioInformado", e.target.value)}/>
          </div>
        </SectionNDA>

        {/* Contexto / Propósito */}
        <SectionNDA title="Contexto del convenio" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Propósito de la relación entre las partes <span style={{color:"#DC2626"}}>*</span></label>
            <textarea autoComplete="off" style={{...inputStyle, minHeight:65, resize:"vertical" as const}} value={form.propositoRelacion}
              onChange={e => set("propositoRelacion", e.target.value)}
              placeholder="Ejemplos: 'la prestación de servicios profesionales como contador externo', 'la negociación de una posible alianza comercial', 'el desarrollo de software a la medida'..."/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Descripción específica de servicios o actividades (opcional)</label>
            <textarea autoComplete="off" style={{...inputStyle, minHeight:55, resize:"vertical" as const}} value={form.descripcionServicios}
              onChange={e => set("descripcionServicios", e.target.value)}
              placeholder="Detalle específico de las funciones, productos o servicios involucrados"/>
          </div>
        </SectionNDA>

        {/* Términos */}
        <SectionNDA title="Términos del convenio" fontSerif={fontSerif} isMobile={isMobile}>
          <div>
            <label style={labelStyle}>Vigencia post-relación (meses) <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" type="number" style={inputStyle} value={form.vigenciaMeses} onChange={e => set("vigenciaMeses", e.target.value)}
              placeholder="36"/>
            <p style={{fontSize:10, color:"#64748B", margin:"4px 0 0", lineHeight:1.4}}>
              Tiempo después de terminar la relación durante el cual sigue vigente la confidencialidad. Recomendado: 24-36 meses.
            </p>
          </div>
          <div>
            <label style={labelStyle}>Moneda de daños <span style={{color:"#DC2626"}}>*</span></label>
            <div style={{display:"flex", gap:8}}>
              {(["MXN","USD"] as const).map(t => (
                <button key={t} onClick={() => setMonedaDanios(t)}
                  style={{flex:1, padding:"9px 12px", borderRadius:8, fontSize:12, fontWeight:600,
                    fontFamily:fontSans, cursor:"pointer",
                    background: monedaDanios===t ? "#0F172A" : "white",
                    color: monedaDanios===t ? "white" : "#374151",
                    border: monedaDanios===t ? "1px solid #0F172A" : "1px solid #D1D5DB"}}>
                  {t === "USD" ? "USD (Dólares)" : "MXN (Pesos)"}
                </button>
              ))}
            </div>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Monto de daños y perjuicios precuantificados ({monedaDanios}) <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" type="number" style={inputStyle} value={form.montoDanios} onChange={e => set("montoDanios", e.target.value)}
              placeholder={monedaDanios === "USD" ? "10000" : "100000"}/>
            <p style={{fontSize:10, color:"#64748B", margin:"4px 0 0", lineHeight:1.4}}>
              Cantidad fija que pagará EL INFORMADO si incumple, sin necesidad de probar daños. Recomendado: $50,000-$500,000 MXN o USD$10,000-50,000.
            </p>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1", padding:"10px 12px",
            background:"rgba(15,23,42,0.04)", borderRadius:8,
            border:"1px solid rgba(15,23,42,0.15)"}}>
            <label style={{display:"flex", alignItems:"center", gap:8, cursor:"pointer", fontSize:12, color:"#374151"}}>
              <input autoComplete="off" type="checkbox" checked={incluyeNoCompetencia}
                onChange={e => setIncluyeNoCompetencia(e.target.checked)}/>
              <span><strong>Incluir cláusula de no competencia</strong> — EL INFORMADO se obliga a no prestar servicios similares a competidores en la misma rama, usando información confidencial recibida.</span>
            </label>
          </div>
        </SectionNDA>

        {/* Testigos */}
        <SectionNDA title="Testigos (recomendado)" fontSerif={fontSerif} isMobile={isMobile}>
          <div>
            <label style={labelStyle}>Nombre Testigo 1</label>
            <input autoComplete="off" style={inputStyle} value={form.nombreTestigo1} onChange={e => set("nombreTestigo1", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Nombre Testigo 2</label>
            <input autoComplete="off" style={inputStyle} value={form.nombreTestigo2} onChange={e => set("nombreTestigo2", e.target.value)}/>
          </div>
        </SectionNDA>

        {/* Aviso legal */}
        <div style={{background:"rgba(184,147,42,0.10)", border:"1px solid rgba(184,147,42,0.3)",
          borderRadius:10, padding:"12px 14px", marginBottom:18, display:"flex", gap:10}}>
          <AxisIcon name="scale_simple" size={16} tone="gold" withBackdrop={false} strokeWidth={3}/>
          <div style={{fontSize:11.5, color:"#374151", lineHeight:1.5}}>
            <strong>Aviso legal:</strong> Convenio adaptado a la Ley Federal de Protección a la Propiedad Industrial, Código Penal Federal (arts. 210-211), Código Penal del Estado de Aguascalientes y Código Civil del Estado de Aguascalientes. Para casos con propiedad intelectual específica (patentes, marcas, software propietario) o información clasificada, te recomendamos validarlo con AXIS Asesoría Legal Corporativa.
          </div>
        </div>

        {/* Botón generar */}
        <button onClick={generarPDF} disabled={generando || !camposObligatoriosLlenos}
          style={{width:"100%", padding:"14px", borderRadius:10,
            background: camposObligatoriosLlenos
              ? "linear-gradient(135deg,#0F172A,#1E293B)"
              : "#9CA3AF",
            border:"none", color:"white", fontSize:15, fontWeight:700,
            cursor: camposObligatoriosLlenos ? "pointer" : "not-allowed",
            boxShadow: camposObligatoriosLlenos ? "0 4px 16px rgba(15,23,42,0.4)" : "none",
            display:"flex", alignItems:"center", justifyContent:"center", gap:10,
            fontFamily:fontSans}}>
          <AxisIcon name="document" size={16} tone="white" withBackdrop={false} strokeWidth={3}/>
          {generando ? "Generando convenio..." : "Generar convenio en PDF"}
        </button>

        {!camposObligatoriosLlenos && (
          <p style={{fontSize:11, color:"#DC2626", margin:"8px 0 0", textAlign:"center" as const}}>
            Completa los campos marcados con <strong>*</strong> para generar el convenio.
          </p>
        )}
        {ultimoBlob && (
          <div style={{marginTop:14, padding:"14px 16px", background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:12, display:"flex", justifyContent:"space-between", alignItems:"center", gap:12, flexWrap:"wrap"}}>
            <div style={{fontSize:12, color:T_LIGHT.textInkSoft, flex:1, minWidth:160}}>¿Quieres guardar este convenio en un expediente?</div>
            <BotonGuardarYVincular
              user={user}
              tipoContrato={tipoContrato}
              getPDFBlob={async () => ultimoBlob!}
              nombrePDFBase={`Contrato_${tipoContrato}`}
              fontSans={fontSans} fontSerif={fontSerif} gold={gold}
            />
          </div>
        )}
      </div>
    </div>
  );
}


// #endregion
// #region CONTRATO OBRA
// ─── CONTRATO: OBRA (PRECIO ALZADO O ADMINISTRACIÓN) ─────────────────────────
// Fundamento: Código Civil del Estado de Aguascalientes, arts. 2489 a 2518
// (contrato de obras a precio alzado), y disposiciones generales para contratos
// de prestación de servicios profesionales (arquitecto/ingeniero como contratista).
function SectionObra({title, children, fontSerif, isMobile}: {title:string; children:React.ReactNode; fontSerif:string; isMobile:boolean}) {
  return (
    <div style={{marginBottom:18}}>
      <div style={{fontFamily:fontSerif, fontSize:14, fontWeight:700, color:"#0F172A",
        marginBottom:10, paddingBottom:6, borderBottom:"1px solid rgba(217,119,6,0.3)",
        display:"flex", alignItems:"center", gap:8}}>
        <AxisIcon name="construction" size={14} color="#D97706" withBackdrop={false} strokeWidth={3}/>
        {title}
      </div>
      <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr":"1fr 1fr", gap:10}}>
        {children}
      </div>
    </div>
  );
}

function FormObra({user, tipoContrato, onBack, fontSans, fontSerif, gold}: {user:any; tipoContrato:string; onBack:()=>void; fontSans:string; fontSerif:string; gold:string}) {
  // El pie de este documento lo firma el patrón, no la plataforma.
  const datosPatron = useDatosPatron(user?.uid).datos;
  // Las dos partes de este contrato, para el control de "cuál soy yo".
  const PARTES_OBRA: ParteDeContrato[] = [
    {clave:"contratante", etiqueta:"Contratante", nombre:"razonSocialContratante", rfc:"rfcContratante", domicilio:"domicilioContratante"},
    {clave:"contratista", etiqueta:"Contratista", nombre:"nombreContratista",      rfc:"rfcContratista", domicilio:"domicilioContratista"},
  ];
  const [miParte, setMiParte] = useState("");   // por defecto, ninguna
  const isMobile = window.innerWidth < 768;
  const [modalidad, setModalidad] = useState<"precio_alzado"|"administracion">("precio_alzado");
  const [tipoContratante, setTipoContratante] = useState<"fisica"|"moral">("fisica");
  const [contratistaIncluyeMateriales, setContratistaIncluyeMateriales] = useState<boolean>(true);
  const [contratistaIncluyeManoObra, setContratistaIncluyeManoObra] = useState<boolean>(true);

  const [form, setForm] = useState({
    ciudad: "Aguascalientes, Ags.",
    fechaContrato: "",
    // Contratante
    nombreContratante: "",
    razonSocialContratante: "",
    repLegalContratante: "",
    ineContratante: "",
    rfcContratante: "",
    domicilioContratante: "",
    telefonoContratante: "",
    // Contratista
    nombreContratista: "",
    especialidadContratista: "Arquitecto",
    cedulaProfesional: "",
    rfcContratista: "",
    domicilioContratista: "",
    telefonoContratista: "",
    // Inmueble (terreno donde se construye)
    direccionTerreno: "",
    superficieTerreno: "",
    medidasColindancias: "",
    escrituraTerreno: "",
    cuentaPredial: "",
    // Descripción de la obra
    tipoObra: "construcción nueva",
    descripcionObra: "",
    superficieConstruccion: "",
    nivelesObra: "1",
    // Plazos
    fechaInicio: "",
    fechaTerminacion: "",
    diasNaturales: "",
    // Precio alzado
    precioAlzado: "",
    anticipoPorcentaje: "30",
    pagoPorAvances: true,
    // Administración
    honorariosCantidad: "",
    honorariosPorcentaje: "10",
    honorariosTipo: "porcentaje" as "porcentaje"|"fijo",
    presentacionGastos: "quincenal",
    // Garantías y penalizaciones
    garantiaBuenaEjecucionPct: "10",
    garantiaViciosOcultosMeses: "12",
    penalizacionDiariaPct: "0.5",
    // Anexos
    incluyeMemoria: true,
    incluyePlanos: true,
    incluyePresupuesto: true,
    incluyePrograma: true,
    // Testigos
    nombreTestigo1: "",
    nombreTestigo2: "",
  });

  const [generando, setGenerando] = useState(false);
  const [ultimoBlob, setUltimoBlob] = useState<Blob|null>(null);
  const set = (k: string, v: any) => setForm(p => ({...p, [k]:v}));
  const F = (v: string) => v || "_______________________________";
  // FECHAS EN CASTELLANO, NO EN ISO. El campo guarda "2026-09-07" y eso salía
  // impreso tal cual en un contrato que se firma. `fechaLargaAxis` PARTE la
  // cadena en vez de construir un Date: `new Date("2026-09-01")` es medianoche
  // UTC, y en México eso es el 31 de agosto —el contrato imprimiría el día
  // anterior al pactado—. Si el valor no es una fecha ISO (hay campos de fecha
  // que son texto libre), se imprime tal como se escribió.
  const FF = (v: string) => fechaLargaAxis(v) || F(v);

  const numeroALetras = (n: number): string => {
    const unidades = ["","UN","DOS","TRES","CUATRO","CINCO","SEIS","SIETE","OCHO","NUEVE","DIEZ","ONCE","DOCE","TRECE","CATORCE","QUINCE","DIECISEIS","DIECISIETE","DIECIOCHO","DIECINUEVE"];
    const decenas = ["","DIEZ","VEINTE","TREINTA","CUARENTA","CINCUENTA","SESENTA","SETENTA","OCHENTA","NOVENTA"];
    const centenas = ["","CIEN","DOSCIENTOS","TRESCIENTOS","CUATROCIENTOS","QUINIENTOS","SEISCIENTOS","SETECIENTOS","OCHOCIENTOS","NOVECIENTOS"];
    if (n === 0) return "CERO";
    if (n < 20) return unidades[n];
    if (n < 100) return decenas[Math.floor(n/10)] + (n%10 ? " Y " + unidades[n%10] : "");
    if (n < 1000) return centenas[Math.floor(n/100)] + (n%100 ? " " + numeroALetras(n%100) : "");
    if (n < 10000) return unidades[Math.floor(n/1000)] + " MIL" + (n%1000 ? " " + numeroALetras(n%1000) : "");
    if (n < 1000000) return numeroALetras(Math.floor(n/1000)) + " MIL" + (n%1000 ? " " + numeroALetras(n%1000) : "");
    return numeroALetras(Math.floor(n/1000000)) + " MILLONES" + (n%1000000 ? " " + numeroALetras(n%1000000) : "");
  };

  const fmt$ = (v: string) => {
    if (!v) return "_______________________________";
    const n = parseFloat(v);
    if (isNaN(n)) return v;
    return "$" + n.toLocaleString("es-MX", {minimumFractionDigits:2, maximumFractionDigits: 2}) + " M.N. (" + numeroALetras(Math.floor(n)) + " PESOS " + String(Math.round((n%1)*100)).padStart(2,"0") + "/100 M.N.)";
  };

  const generarPDF = () => {
    setGenerando(true);
    setTimeout(() => {
      const { jsPDF } = (window as any).jspdf;
      const doc = new jsPDF({orientation:"portrait", unit:"mm", format:"letter"});
      const W = doc.internal.pageSize.getWidth();
      const H = doc.internal.pageSize.getHeight();
      const ML = 22, MR = 22;
      const usable = W - ML - MR;
      let y = 28;   // margen superior cómodo; el contrato inicia DIRECTO con su título (AXIS va al pie)

      const checkPage = (need = 8) => { if (y + need > H - 34) { doc.addPage(); y = 28; } };
      const titulo = (txt: string) => {
        checkPage(12);
        doc.setFont("times","bold"); doc.setFontSize(11); doc.setTextColor(11,24,41);
        doc.text(txt, W/2, y, {align:"center", maxWidth: usable}); y += 7;
      };
      const subtitulo = (txt: string) => {
        checkPage(30);   // mantiene el encabezado junto a su primer texto (evita viudas)
        doc.setFont("times","bold"); doc.setFontSize(10); doc.setTextColor(11,24,41);
        doc.text(txt, ML, y); y += 5;
      };
      const parrafo = (txt: string, opts?:{align?:"justify"|"left"|"center"; bold?:boolean; size?:number}) => {
        const fs = opts?.size || 9;
        doc.setFont("times", opts?.bold ? "bold" : "normal");
        doc.setFontSize(fs); doc.setTextColor(45,45,45);
        const lines = doc.splitTextToSize(txt, usable);
        for (const ln of lines) {
          checkPage(5);
          doc.text(ln, ML, y, {align: opts?.align==="center" ? "center" : "left", maxWidth: usable});
          y += fs*0.42 + 1.2;
        }
        y += 1;
      };

      // ───── ENCABEZADO ─────
      const tituloModalidad = modalidad === "precio_alzado"
        ? "CONTRATO DE OBRA A PRECIO ALZADO"
        : "CONTRATO DE OBRA POR ADMINISTRACIÓN";
      titulo(tituloModalidad);

      const contratanteNombre = tipoContratante === "moral"
        ? `${F(form.razonSocialContratante).toUpperCase()}, REPRESENTADA POR ${F(form.repLegalContratante).toUpperCase()}`
        : F(form.nombreContratante).toUpperCase();

      parrafo(
        `Contrato de obra que celebran por una parte ${contratanteNombre}, en lo sucesivo "EL CONTRATANTE", y por la otra ${F(form.nombreContratista).toUpperCase()}, ${F(form.especialidadContratista)} con cédula profesional ${F(form.cedulaProfesional)}, en lo sucesivo "EL CONTRATISTA", al tenor de las siguientes declaraciones y cláusulas:`,
        {align:"justify"}
      );

      // ───── DECLARACIONES ─────
      subtitulo("DECLARACIONES");

      parrafo("I. DECLARA EL CONTRATANTE:", {bold:true});
      if (tipoContratante === "moral") {
        parrafo(`a) Ser una sociedad legalmente constituida, representada por ${F(form.repLegalContratante)}.`);
      } else {
        parrafo(`a) Ser persona física mayor de edad con plena capacidad jurídica, identificándose con credencial de elector clave ${F(form.ineContratante)}.`);
      }
      parrafo(`b) Tener su domicilio en ${F(form.domicilioContratante)}, RFC ${F(form.rfcContratante)} y teléfono ${F(form.telefonoContratante)}.`);
      parrafo(`c) Ser legítimo propietario o tener derechos sobre el inmueble descrito en la cláusula PRIMERA, donde se llevará a cabo la obra objeto del presente contrato.`);
      parrafo(`d) Ser su voluntad encomendar a EL CONTRATISTA la ejecución de la obra descrita más adelante.`);

      parrafo("II. DECLARA EL CONTRATISTA:", {bold:true});
      parrafo(`a) Ser ${F(form.especialidadContratista)} con cédula profesional ${F(form.cedulaProfesional)}, con conocimientos técnicos, experiencia y los recursos humanos y materiales necesarios para ejecutar la obra objeto del presente contrato.`);
      parrafo(`b) Tener su domicilio en ${F(form.domicilioContratista)}, contar con RFC ${F(form.rfcContratista)} y teléfono ${F(form.telefonoContratista)}.`);
      parrafo(`c) Conocer físicamente el sitio donde se ejecutará la obra y aceptar las condiciones del terreno.`);

      // ───── CLÁUSULAS ─────
      checkPage(12);
      y += 2;
      subtitulo("CLÁUSULAS");

      parrafo("PRIMERA. UBICACIÓN DE LA OBRA.", {bold:true});
      parrafo(
        `La obra objeto del presente contrato se ejecutará en el inmueble ubicado en: ${F(form.direccionTerreno)}.`,
        {align:"justify"}
      );
      if (form.superficieTerreno) parrafo(`Superficie del terreno: ${form.superficieTerreno} m².`);
      if (form.medidasColindancias) parrafo(`Medidas y colindancias: ${form.medidasColindancias}.`);
      if (form.escrituraTerreno) parrafo(`Antecedentes de propiedad: ${form.escrituraTerreno}.`);
      if (form.cuentaPredial) parrafo(`Cuenta predial / clave catastral: ${form.cuentaPredial}.`);

      parrafo("SEGUNDA. OBJETO Y DESCRIPCIÓN DE LA OBRA.", {bold:true});
      parrafo(
        `EL CONTRATISTA se obliga a ejecutar para EL CONTRATANTE la siguiente obra: ${F(form.tipoObra)}, consistente en ${F(form.descripcionObra)}.`,
        {align:"justify"}
      );
      if (form.superficieConstruccion) parrafo(`Superficie de construcción: ${form.superficieConstruccion} m².`);
      if (form.nivelesObra) parrafo(`Niveles: ${form.nivelesObra}.`);
      parrafo(
        `La obra deberá ejecutarse conforme a los anexos que forman parte integrante de este contrato y se mencionan en la cláusula CUARTA.`,
        {align:"justify"}
      );

      parrafo("TERCERA. PLAZO DE EJECUCIÓN.", {bold:true});
      parrafo(
        `EL CONTRATISTA se obliga a iniciar la obra el día ${FF(form.fechaInicio)} y entregarla terminada a más tardar el día ${FF(form.fechaTerminacion)}${form.diasNaturales ? `, en un plazo total de ${form.diasNaturales} días naturales` : ""}. Cualquier prórroga deberá pactarse por escrito entre las partes y registrarse en la bitácora de obra.`,
        {align:"justify"}
      );

      parrafo("CUARTA. ANEXOS INTEGRANTES.", {bold:true});
      const anexos = [];
      if (form.incluyeMemoria) anexos.push("Memoria descriptiva y de cálculo");
      if (form.incluyePlanos) anexos.push("Planos arquitectónicos y estructurales");
      if (form.incluyePresupuesto) anexos.push("Presupuesto detallado por partidas");
      if (form.incluyePrograma) anexos.push("Programa de obra (cronograma)");
      if (anexos.length > 0) {
        parrafo(`Forman parte integrante de este contrato los siguientes anexos: ${anexos.join("; ")}.`);
      }
      parrafo(
        `EL CONTRATISTA se obliga a llevar una BITÁCORA DE OBRA permanente, debidamente foliada, donde se asentarán las incidencias diarias, instrucciones, modificaciones y observaciones, la cual será firmada periódicamente por ambas partes o sus representantes técnicos.`,
        {align:"justify"}
      );

      // CLÁUSULA QUINTA — varía según modalidad
      if (modalidad === "precio_alzado") {
        parrafo("QUINTA. PRECIO ALZADO Y FORMA DE PAGO.", {bold:true});
        parrafo(
          `Conforme a los artículos 2489 y siguientes del Código Civil del Estado de Aguascalientes, el precio total de la obra es A PRECIO ALZADO en la cantidad de ${fmt$(form.precioAlzado)}, cantidad fija que NO sufrirá variación alguna por incremento en costos de materiales, mano de obra o cualquier otra causa imputable a EL CONTRATISTA. El precio incluye ${contratistaIncluyeMateriales ? "los materiales necesarios" : "ÚNICAMENTE la mano de obra (los materiales corren por cuenta de EL CONTRATANTE)"}, ${contratistaIncluyeManoObra ? "la mano de obra" : "y NO incluye mano de obra"}, herramientas, equipos, supervisión técnica y todas las prestaciones que correspondan al personal del contratista.`,
          {align:"justify"}
        );
        parrafo(
          `FORMA DE PAGO: a) ANTICIPO del ${F(form.anticipoPorcentaje)}% del precio total a la firma del presente contrato, sirviendo el mismo como recibo legal por dicha cantidad. b) PAGOS POR AVANCES de obra, conforme al programa de obra anexo y previa verificación documentada en bitácora del avance correspondiente. c) FINIQUITO al término total de la obra, contra entrega y aceptación firmada por EL CONTRATANTE.`,
          {align:"justify"}
        );
        parrafo(
          `Si por causas imputables a EL CONTRATANTE se ordenan obras adicionales o modificaciones al proyecto original, éstas se cotizarán y pactarán por escrito como adendum, sin afectar el precio alzado de la obra original.`,
          {align:"justify"}
        );
      } else {
        parrafo("QUINTA. OBRA POR ADMINISTRACIÓN Y HONORARIOS.", {bold:true});
        const honorariosTexto = form.honorariosTipo === "porcentaje"
          ? `del ${F(form.honorariosPorcentaje)}% sobre el costo total de los gastos comprobados de la obra`
          : `por la cantidad fija de ${fmt$(form.honorariosCantidad)}`;
        parrafo(
          `Bajo la modalidad de OBRA POR ADMINISTRACIÓN, EL CONTRATANTE pagará a EL CONTRATISTA los costos reales de materiales, mano de obra, equipos y demás insumos necesarios para la ejecución de la obra, contra comprobantes y facturas que EL CONTRATISTA presentará de manera ${F(form.presentacionGastos)}. Adicionalmente, EL CONTRATISTA recibirá honorarios profesionales ${honorariosTexto}.`,
          {align:"justify"}
        );
        parrafo(
          `EL CONTRATISTA se obliga a presentar de manera ${F(form.presentacionGastos)} un reporte detallado con los comprobantes y facturas correspondientes. EL CONTRATANTE deberá cubrir los gastos comprobados dentro de los 5 días hábiles siguientes a la presentación, así como reponer los anticipos para materiales que se requieran para continuar con la obra.`,
          {align:"justify"}
        );
        parrafo(
          `EL CONTRATISTA actuará con la diligencia profesional propia de su especialidad, buscando la economía y eficiencia en la administración de los recursos.`,
          {align:"justify"}
        );
      }

      parrafo("SEXTA. RESPONSABILIDAD TÉCNICA Y SUPERVISIÓN.", {bold:true});
      parrafo(
        `EL CONTRATISTA será el responsable técnico de la obra y deberá ejecutarla conforme a las normas técnicas de construcción aplicables, los reglamentos municipales de Aguascalientes en materia de construcción y las disposiciones de seguridad e higiene en el trabajo. EL CONTRATISTA responderá por la calidad de los materiales que utilice y por el desempeño del personal a su cargo.`,
        {align:"justify"}
      );
      parrafo(
        `EL CONTRATANTE o su representante técnico podrá supervisar la obra en cualquier momento, asentando observaciones en la bitácora correspondiente.`,
        {align:"justify"}
      );

      parrafo("SÉPTIMA. MODIFICACIONES Y OBRAS EXTRAORDINARIAS.", {bold:true});
      parrafo(
        `Cualquier modificación al proyecto original deberá pactarse por escrito como anexo al presente contrato, especificando los cambios técnicos, su costo y, en su caso, la prórroga al plazo de entrega. Las obras extraordinarias no autorizadas por escrito no generarán obligación de pago a cargo de EL CONTRATANTE.`,
        {align:"justify"}
      );

      parrafo("OCTAVA. GARANTÍA DE BUENA EJECUCIÓN.", {bold:true});
      parrafo(
        `EL CONTRATISTA garantiza la calidad y correcta ejecución de la obra. Para tal efecto, otorga una garantía equivalente al ${F(form.garantiaBuenaEjecucionPct)}% del valor total del contrato, la cual podrá retenerse de los pagos finales hasta la entrega satisfactoria de la obra.`,
        {align:"justify"}
      );

      parrafo("NOVENA. SANEAMIENTO POR VICIOS OCULTOS.", {bold:true});
      parrafo(
        `EL CONTRATISTA responderá por los vicios ocultos en la construcción durante un plazo de ${F(form.garantiaViciosOcultosMeses)} meses contados a partir de la entrega formal de la obra, conforme a las disposiciones del Código Civil del Estado de Aguascalientes en materia de responsabilidad por defectos de construcción.`,
        {align:"justify"}
      );

      parrafo("DÉCIMA. PENALIZACIÓN POR RETRASO.", {bold:true});
      parrafo(
        `Si EL CONTRATISTA no entrega la obra en el plazo pactado, por causas imputables a su persona, pagará a EL CONTRATANTE una pena convencional equivalente al ${F(form.penalizacionDiariaPct)}% del valor total del contrato por cada día natural de retraso, hasta la entrega definitiva.`,
        {align:"justify"}
      );

      parrafo("DÉCIMA PRIMERA. CAUSALES DE RESCISIÓN.", {bold:true});
      parrafo(
        `Son causales de rescisión del presente contrato, sin perjuicio del derecho a daños y perjuicios: a) abandono de la obra por más de 15 días sin causa justificada; b) ejecución de la obra con materiales o calidad notoriamente inferiores a los pactados; c) incumplimiento sustancial de los plazos pactados; d) falta de pago por parte de EL CONTRATANTE de tres avances consecutivos.`,
        {align:"justify"}
      );

      parrafo("DÉCIMA SEGUNDA. ENTREGA DE LA OBRA.", {bold:true});
      parrafo(
        `Al concluir la obra, las partes firmarán un acta de entrega-recepción haciendo constar el cumplimiento del contrato, los anexos integrantes, las observaciones que en su caso existan y los plazos para subsanarlas. La firma del acta de entrega-recepción libera a EL CONTRATISTA de las obligaciones derivadas de la ejecución, sin perjuicio del saneamiento por vicios ocultos.`,
        {align:"justify"}
      );

      parrafo("DÉCIMA TERCERA. JURISDICCIÓN.", {bold:true});
      parrafo(
        `Para la interpretación, cumplimiento y ejecución del presente contrato, las partes se someten expresamente a las leyes y tribunales competentes en el Estado de Aguascalientes, renunciando a cualquier otro fuero que pudiera corresponderles.`,
        {align:"justify"}
      );

      // ───── FIRMAS ─────
      checkPage(45);
      y += 6;
      doc.setFont("times","bold"); doc.setFontSize(9); doc.setTextColor(11,24,41);
      doc.text(`Firmado en ${F(form.ciudad)} el día ${FF(form.fechaContrato)}.`, W/2, y, {align:"center"});
      y += 14;

      const colW = (usable - 8) / 2;
      const x1 = ML;
      const x2 = ML + colW + 8;
      doc.setDrawColor(11,24,41);
      doc.setLineWidth(0.3);
      doc.line(x1+8, y, x1+colW-8, y);
      doc.line(x2+8, y, x2+colW-8, y);
      y += 4;
      doc.setFont("times","bold"); doc.setFontSize(8);
      doc.text("EL CONTRATANTE", x1+colW/2, y, {align:"center"});
      doc.text("EL CONTRATISTA", x2+colW/2, y, {align:"center"});
      y += 4;
      doc.setFont("times","normal");
      const nombContrante = tipoContratante === "moral" ? F(form.razonSocialContratante) : F(form.nombreContratante);
      doc.text(nombContrante, x1+colW/2, y, {align:"center"});
      doc.text(F(form.nombreContratista), x2+colW/2, y, {align:"center"});
      if (tipoContratante === "moral") {
        y += 4;
        doc.setFontSize(7);
        doc.text(`Por: ${F(form.repLegalContratante)}`, x1+colW/2, y, {align:"center"});
      } else {
        y += 4;
      }
      doc.setFontSize(7);
      doc.text(`${F(form.especialidadContratista)} · Céd. Prof. ${F(form.cedulaProfesional)}`, x2+colW/2, y, {align:"center"});

      // Testigos
      if (form.nombreTestigo1 || form.nombreTestigo2) {
        y += 14;
        checkPage(20);
        doc.line(x1+8, y, x1+colW-8, y);
        doc.line(x2+8, y, x2+colW-8, y);
        y += 4;
        doc.setFont("times","bold"); doc.setFontSize(8);
        doc.text("TESTIGO 1", x1+colW/2, y, {align:"center"});
        doc.text("TESTIGO 2", x2+colW/2, y, {align:"center"});
        y += 4;
        doc.setFont("times","normal");
        doc.text(F(form.nombreTestigo1), x1+colW/2, y, {align:"center"});
        doc.text(F(form.nombreTestigo2), x2+colW/2, y, {align:"center"});
      }

      // Footer
      const totalPages = doc.internal.pages.length - 1;
      for (let p = 1; p <= totalPages; p++) {
        doc.setPage(p);
        doc.setFont("times","italic"); doc.setFontSize(7);
        doc.setTextColor(120,120,120);
        pintarLeyendaContrato(doc, W/2, H-13.5, W-ML-MR, "center");
        doc.text(pieDelPatron(datosPatron, fechaHoraLargaAxis()), W/2, H-10, {align:"center"});
        doc.text(`Página ${p} de ${totalPages}`, W-MR, H-10, {align:"right"});
      }

      const sufijo = modalidad === "precio_alzado" ? "Precio_Alzado" : "Administracion";
      const fname = `Contrato_Obra_${sufijo}_${(form.nombreContratista || "obra").replace(/[^A-Za-z0-9]/g,"_")}.pdf`;
      doc.save(fname);
      try { setUltimoBlob(doc.output("blob")); } catch {}
      setGenerando(false);
    }, 200);
  };

  const inputStyle: React.CSSProperties = {
    width:"100%", padding:"9px 11px", fontSize:13, fontFamily:fontSans,
    background:"white", border:"1px solid #D1D5DB", borderRadius:8, color:"#0F172A",
    boxSizing:"border-box" as const,
  };
  const labelStyle: React.CSSProperties = {
    display:"block", fontSize:11, fontWeight:600, color:"#374151", marginBottom:4,
    letterSpacing:"0.2px",
  };

  const camposObligatoriosLlenos = !!(
    form.fechaContrato && form.nombreContratista && form.especialidadContratista &&
    form.direccionTerreno && form.descripcionObra &&
    form.fechaInicio && form.fechaTerminacion &&
    (tipoContratante === "moral" ? form.razonSocialContratante && form.repLegalContratante : form.nombreContratante) &&
    (modalidad === "precio_alzado"
      ? form.precioAlzado
      : (form.honorariosTipo === "porcentaje" ? form.honorariosPorcentaje : form.honorariosCantidad))
  );

  return (
    <div {...ZONA_DE_CAPTURA} style={{minHeight:"100vh", background:T_LIGHT.canvas, fontFamily:fontSans}}>
      {/* Header */}
      <div style={{background:"linear-gradient(135deg,#D97706,#B45309)", padding:"0 20px", height:58,
        display:"flex", alignItems:"center", gap:12, position:"sticky" as const, top:0, zIndex:100,
        boxShadow:"0 4px 20px rgba(217,119,6,0.30)"}}>
        <button onClick={onBack}
          style={{background:"rgba(255,255,255,0.18)", border:"1px solid rgba(255,255,255,0.30)",
            color:"white", borderRadius:8, padding:"5px 11px", cursor:"pointer",
            fontSize:12, fontWeight:600}}>← Generador legal</button>
        <span style={{color:"white", fontWeight:700, fontSize:isMobile?12:14, display:"flex",
          alignItems:"center", gap:8}}>
          <AxisIcon name="construction" size={18} tone="white" withBackdrop={false} strokeWidth={2.5}/>
          Contrato de Obra
        </span>
      </div>

      <div style={{maxWidth:760, margin:"0 auto", padding:isMobile?"16px":"24px"}}>
        <p style={{fontSize:12, color:"#64748B", margin:"0 0 6px", lineHeight:1.6}}>
          Para construcción, ampliación o remodelación. Conforme al Código Civil de Aguascalientes (arts. 2489 y siguientes para precio alzado).
        </p>
        <p style={{fontSize:12, color:"#64748B", margin:"0 0 18px", lineHeight:1.6}}>
          Completa los datos. Los campos marcados con <span style={{color:"#DC2626"}}>*</span> son indispensables.
        </p>

        <SelectorDeMiParte partes={PARTES_OBRA} elegida={miParte} tipoPersona={datosPatron.tipoPersona} fontSans={fontSans} fontSerif={fontSerif}
          onElegir={(c)=>{ setMiParte(c); setForm((f:any)=>aplicarMiParte(f, PARTES_OBRA, c, datosPatron));
            // El contratante tiene variante de sociedad; se pone del lado correcto.
            if (c === "contratante" && datosPatron.tipoPersona) setTipoContratante(datosPatron.tipoPersona);
          }}/>

        {/* Selector de modalidad — DESTACADO */}
        <div style={{background:"white", border:"2px solid rgba(217,119,6,0.35)", borderRadius:12,
          padding:"14px 16px", marginBottom:18, boxShadow:"0 2px 12px rgba(217,119,6,0.10)"}}>
          <div style={{fontSize:11, color:"#D97706", fontWeight:700, textTransform:"uppercase" as const,
            letterSpacing:"0.5px", marginBottom:8}}>
            Modalidad del contrato
          </div>
          <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr":"1fr 1fr", gap:10}}>
            <button onClick={() => setModalidad("precio_alzado")}
              style={{padding:"14px 14px", borderRadius:10, fontFamily:fontSans, cursor:"pointer",
                textAlign:"left" as const,
                background: modalidad==="precio_alzado" ? "linear-gradient(135deg,#D97706,#B45309)" : "white",
                color: modalidad==="precio_alzado" ? "white" : "#374151",
                border: modalidad==="precio_alzado" ? "1px solid #D97706" : "1px solid #D1D5DB",
                boxShadow: modalidad==="precio_alzado" ? "0 4px 14px rgba(217,119,6,0.35)" : "none"}}>
              <div style={{fontSize:13, fontWeight:700, marginBottom:4}}>A Precio Alzado</div>
              <div style={{fontSize:10.5, lineHeight:1.5, opacity:modalidad==="precio_alzado"?0.95:0.7}}>
                Precio FIJO desde el inicio. El contratista absorbe variaciones. Da certeza al contratante.
              </div>
              <div style={{fontSize:9, marginTop:6, opacity:0.7}}>CC AGS arts. 2489-2518</div>
            </button>
            <button onClick={() => setModalidad("administracion")}
              style={{padding:"14px 14px", borderRadius:10, fontFamily:fontSans, cursor:"pointer",
                textAlign:"left" as const,
                background: modalidad==="administracion" ? "linear-gradient(135deg,#D97706,#B45309)" : "white",
                color: modalidad==="administracion" ? "white" : "#374151",
                border: modalidad==="administracion" ? "1px solid #D97706" : "1px solid #D1D5DB",
                boxShadow: modalidad==="administracion" ? "0 4px 14px rgba(217,119,6,0.35)" : "none"}}>
              <div style={{fontSize:13, fontWeight:700, marginBottom:4}}>Por Administración</div>
              <div style={{fontSize:10.5, lineHeight:1.5, opacity:modalidad==="administracion"?0.95:0.7}}>
                El contratante paga costos reales + honorarios al contratista. El cliente asume el riesgo de variaciones.
              </div>
              <div style={{fontSize:9, marginTop:6, opacity:0.7}}>Costos comprobables + honorarios</div>
            </button>
          </div>
        </div>

        {/* Datos generales */}
        <SectionObra title="Datos generales" fontSerif={fontSerif} isMobile={isMobile}>
          <div>
            <label style={labelStyle}>Ciudad y estado de firma <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" style={inputStyle} value={form.ciudad} onChange={e => set("ciudad", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Fecha de firma <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" type="date" style={inputStyle} value={form.fechaContrato} onChange={e => set("fechaContrato", e.target.value)}/>
          </div>
        </SectionObra>

        {/* Contratante */}
        <SectionObra title="EL CONTRATANTE (quien encarga la obra)" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Tipo de persona <span style={{color:"#DC2626"}}>*</span></label>
            <div style={{display:"flex", gap:8}}>
              {(["fisica","moral"] as const).map(t => (
                <button key={t} onClick={() => setTipoContratante(t)}
                  style={{flex:1, padding:"9px 12px", borderRadius:8, fontSize:12, fontWeight:600,
                    fontFamily:fontSans, cursor:"pointer",
                    background: tipoContratante===t ? "#D97706" : "white",
                    color: tipoContratante===t ? "white" : "#374151",
                    border: tipoContratante===t ? "1px solid #D97706" : "1px solid #D1D5DB"}}>
                  {t === "moral" ? "Persona moral (empresa)" : "Persona física"}
                </button>
              ))}
            </div>
          </div>
          {tipoContratante === "moral" ? (
            <>
              <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
                <label style={labelStyle}>Razón social <span style={{color:"#DC2626"}}>*</span></label>
                <input autoComplete="off" style={inputStyle} value={form.razonSocialContratante} onChange={e => set("razonSocialContratante", e.target.value)}/>
              </div>
              <div>
                <label style={labelStyle}>Representante legal <span style={{color:"#DC2626"}}>*</span></label>
                <input autoComplete="off" style={inputStyle} value={form.repLegalContratante} onChange={e => set("repLegalContratante", e.target.value)}/>
              </div>
            </>
          ) : (
            <>
              <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
                <label style={labelStyle}>Nombre completo <span style={{color:"#DC2626"}}>*</span></label>
                <input autoComplete="off" style={inputStyle} value={form.nombreContratante} onChange={e => set("nombreContratante", e.target.value)}/>
              </div>
              <div>
                <label style={labelStyle}>Clave de elector (INE)</label>
                <input autoComplete="off" style={inputStyle} value={form.ineContratante} onChange={e => set("ineContratante", e.target.value)}/>
              </div>
            </>
          )}
          <div>
            <label style={labelStyle}>RFC</label>
            <input autoComplete="off" style={inputStyle} value={form.rfcContratante} onChange={e => set("rfcContratante", e.target.value)}/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Domicilio</label>
            <input autoComplete="off" style={inputStyle} value={form.domicilioContratante} onChange={e => set("domicilioContratante", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Teléfono</label>
            <input autoComplete="off" style={inputStyle} value={form.telefonoContratante} onChange={e => set("telefonoContratante", e.target.value)}/>
          </div>
        </SectionObra>

        {/* Contratista */}
        <SectionObra title="EL CONTRATISTA (arquitecto / ingeniero / constructor)" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Nombre completo <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" style={inputStyle} value={form.nombreContratista} onChange={e => set("nombreContratista", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Especialidad <span style={{color:"#DC2626"}}>*</span></label>
            <select style={inputStyle} value={form.especialidadContratista} onChange={e => set("especialidadContratista", e.target.value)}>
              <option value="Arquitecto">Arquitecto</option>
              <option value="Ingeniero Civil">Ingeniero Civil</option>
              <option value="Ingeniero Arquitecto">Ingeniero Arquitecto</option>
              <option value="Constructor">Constructor (sin título)</option>
              <option value="Maestro de Obra">Maestro de Obra</option>
            </select>
          </div>
          <div>
            <label style={labelStyle}>Cédula profesional</label>
            <input autoComplete="off" style={inputStyle} value={form.cedulaProfesional} onChange={e => set("cedulaProfesional", e.target.value)}
              placeholder="Sólo si tiene título profesional"/>
          </div>
          <div>
            <label style={labelStyle}>RFC</label>
            <input autoComplete="off" style={inputStyle} value={form.rfcContratista} onChange={e => set("rfcContratista", e.target.value)}/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Domicilio</label>
            <input autoComplete="off" style={inputStyle} value={form.domicilioContratista} onChange={e => set("domicilioContratista", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Teléfono</label>
            <input autoComplete="off" style={inputStyle} value={form.telefonoContratista} onChange={e => set("telefonoContratista", e.target.value)}/>
          </div>
        </SectionObra>

        {/* Inmueble - terreno */}
        <SectionObra title="Datos del terreno donde se construye" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Dirección y ubicación del terreno <span style={{color:"#DC2626"}}>*</span></label>
            <textarea autoComplete="off" style={{...inputStyle, minHeight:55, resize:"vertical" as const}} value={form.direccionTerreno}
              onChange={e => set("direccionTerreno", e.target.value)}
              placeholder="Calle ___ No. ___, Colonia ___, Aguascalientes, Ags."/>
          </div>
          <div>
            <label style={labelStyle}>Superficie del terreno (m²)</label>
            <input autoComplete="off" style={inputStyle} value={form.superficieTerreno} onChange={e => set("superficieTerreno", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Cuenta predial</label>
            <input autoComplete="off" style={inputStyle} value={form.cuentaPredial} onChange={e => set("cuentaPredial", e.target.value)}/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Medidas y colindancias</label>
            <textarea autoComplete="off" style={{...inputStyle, minHeight:55, resize:"vertical" as const}} value={form.medidasColindancias}
              onChange={e => set("medidasColindancias", e.target.value)}
              placeholder="Norte: ___ m con ___; Sur: ___ m con ___; Este: ___ m con ___; Oeste: ___ m con ___"/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Antecedentes de propiedad (escritura)</label>
            <input autoComplete="off" style={inputStyle} value={form.escrituraTerreno} onChange={e => set("escrituraTerreno", e.target.value)}
              placeholder="Escritura No. ___ de fecha ___, Notario ___, inscrita en RPP folio ___"/>
          </div>
        </SectionObra>

        {/* Descripción de la obra */}
        <SectionObra title="Descripción de la obra" fontSerif={fontSerif} isMobile={isMobile}>
          <div>
            <label style={labelStyle}>Tipo de obra <span style={{color:"#DC2626"}}>*</span></label>
            <select style={inputStyle} value={form.tipoObra} onChange={e => set("tipoObra", e.target.value)}>
              <option value="construcción nueva">Construcción nueva</option>
              <option value="ampliación">Ampliación</option>
              <option value="remodelación">Remodelación</option>
              <option value="acabados">Acabados</option>
              <option value="demolición">Demolición</option>
              <option value="restauración">Restauración</option>
            </select>
          </div>
          <div>
            <label style={labelStyle}>Niveles / pisos</label>
            <input autoComplete="off" type="number" style={inputStyle} value={form.nivelesObra} onChange={e => set("nivelesObra", e.target.value)}/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Descripción detallada de la obra <span style={{color:"#DC2626"}}>*</span></label>
            <textarea autoComplete="off" style={{...inputStyle, minHeight:75, resize:"vertical" as const}} value={form.descripcionObra}
              onChange={e => set("descripcionObra", e.target.value)}
              placeholder="Casa habitación de dos plantas con 3 recámaras, 2 baños, sala-comedor, cocina y patio trasero. Acabados de mediana calidad..."/>
          </div>
          <div>
            <label style={labelStyle}>Superficie de construcción (m²)</label>
            <input autoComplete="off" style={inputStyle} value={form.superficieConstruccion} onChange={e => set("superficieConstruccion", e.target.value)}/>
          </div>
        </SectionObra>

        {/* Plazos */}
        <SectionObra title="Plazos de ejecución" fontSerif={fontSerif} isMobile={isMobile}>
          <div>
            <label style={labelStyle}>Fecha de inicio <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" type="date" style={inputStyle} value={form.fechaInicio} onChange={e => set("fechaInicio", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Fecha de terminación <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" type="date" style={inputStyle} value={form.fechaTerminacion} onChange={e => set("fechaTerminacion", e.target.value)}/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Plazo total en días naturales (opcional)</label>
            <input autoComplete="off" type="number" style={inputStyle} value={form.diasNaturales} onChange={e => set("diasNaturales", e.target.value)}
              placeholder="Si lo dejas vacío, se calcula con las fechas"/>
          </div>
        </SectionObra>

        {/* Precio - varía según modalidad */}
        {modalidad === "precio_alzado" ? (
          <SectionObra title="Precio alzado y forma de pago" fontSerif={fontSerif} isMobile={isMobile}>
            <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
              <label style={labelStyle}>Precio total fijo (MXN) <span style={{color:"#DC2626"}}>*</span></label>
              <input autoComplete="off" type="number" style={inputStyle} value={form.precioAlzado} onChange={e => set("precioAlzado", e.target.value)}
                placeholder="500000"/>
              <p style={{fontSize:10, color:"#64748B", margin:"4px 0 0", lineHeight:1.4}}>
                Esta cantidad NO sufrirá variaciones por incrementos en costos de materiales o mano de obra (CC AGS art. 2489 y ss.)
              </p>
            </div>
            <div>
              <label style={labelStyle}>Anticipo (% del total)</label>
              <input autoComplete="off" type="number" style={inputStyle} value={form.anticipoPorcentaje} onChange={e => set("anticipoPorcentaje", e.target.value)}/>
              <p style={{fontSize:10, color:"#64748B", margin:"4px 0 0"}}>Recomendado: 30-50%</p>
            </div>
            <div style={{gridColumn:isMobile?"auto":"1 / -1", padding:"10px 12px",
              background:"rgba(217,119,6,0.05)", borderRadius:8,
              border:"1px solid rgba(217,119,6,0.2)"}}>
              <label style={{display:"flex", alignItems:"center", gap:8, cursor:"pointer", fontSize:12, color:"#374151", marginBottom:6}}>
                <input autoComplete="off" type="checkbox" checked={contratistaIncluyeMateriales}
                  onChange={e => setContratistaIncluyeMateriales(e.target.checked)}/>
                <strong>El precio incluye materiales</strong>
              </label>
              <label style={{display:"flex", alignItems:"center", gap:8, cursor:"pointer", fontSize:12, color:"#374151"}}>
                <input autoComplete="off" type="checkbox" checked={contratistaIncluyeManoObra}
                  onChange={e => setContratistaIncluyeManoObra(e.target.checked)}/>
                <strong>El precio incluye mano de obra</strong>
              </label>
            </div>
          </SectionObra>
        ) : (
          <SectionObra title="Honorarios y administración" fontSerif={fontSerif} isMobile={isMobile}>
            <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
              <label style={labelStyle}>Tipo de honorarios <span style={{color:"#DC2626"}}>*</span></label>
              <div style={{display:"flex", gap:8}}>
                {(["porcentaje","fijo"] as const).map(t => (
                  <button key={t} onClick={() => set("honorariosTipo", t)}
                    style={{flex:1, padding:"9px 12px", borderRadius:8, fontSize:12, fontWeight:600,
                      fontFamily:fontSans, cursor:"pointer",
                      background: form.honorariosTipo===t ? "#D97706" : "white",
                      color: form.honorariosTipo===t ? "white" : "#374151",
                      border: form.honorariosTipo===t ? "1px solid #D97706" : "1px solid #D1D5DB"}}>
                    {t === "porcentaje" ? "% sobre costo de obra" : "Cantidad fija"}
                  </button>
                ))}
              </div>
            </div>
            {form.honorariosTipo === "porcentaje" ? (
              <div>
                <label style={labelStyle}>Honorarios (%) <span style={{color:"#DC2626"}}>*</span></label>
                <input autoComplete="off" type="number" step="0.5" style={inputStyle} value={form.honorariosPorcentaje} onChange={e => set("honorariosPorcentaje", e.target.value)}
                  placeholder="10"/>
                <p style={{fontSize:10, color:"#64748B", margin:"4px 0 0"}}>Típico: 8-15% del costo total</p>
              </div>
            ) : (
              <div>
                <label style={labelStyle}>Cantidad fija (MXN) <span style={{color:"#DC2626"}}>*</span></label>
                <input autoComplete="off" type="number" style={inputStyle} value={form.honorariosCantidad} onChange={e => set("honorariosCantidad", e.target.value)}/>
              </div>
            )}
            <div>
              <label style={labelStyle}>Presentación de gastos</label>
              <select style={inputStyle} value={form.presentacionGastos} onChange={e => set("presentacionGastos", e.target.value)}>
                <option value="semanal">Semanal</option>
                <option value="quincenal">Quincenal</option>
                <option value="mensual">Mensual</option>
              </select>
            </div>
          </SectionObra>
        )}

        {/* Anexos */}
        <SectionObra title="Anexos integrantes (recomendados)" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <p style={{fontSize:11.5, color:"#64748B", margin:"0 0 8px", lineHeight:1.5}}>
              Marca los anexos que formarán parte integrante del contrato. EL CONTRATISTA debe entregarlos por separado y se mencionarán en la cláusula CUARTA del contrato.
            </p>
          </div>
          {[
            {k:"incluyeMemoria", label:"Memoria descriptiva y de cálculo"},
            {k:"incluyePlanos", label:"Planos arquitectónicos y estructurales"},
            {k:"incluyePresupuesto", label:"Presupuesto detallado por partidas"},
            {k:"incluyePrograma", label:"Programa de obra (cronograma)"},
          ].map(a => (
            <div key={a.k} style={{padding:"8px 12px", background:"rgba(217,119,6,0.05)",
              borderRadius:8, border:"1px solid rgba(217,119,6,0.15)"}}>
              <label style={{display:"flex", alignItems:"center", gap:8, cursor:"pointer", fontSize:12, color:"#374151"}}>
                <input autoComplete="off" type="checkbox" checked={(form as any)[a.k]}
                  onChange={e => set(a.k, e.target.checked)}/>
                <strong>{a.label}</strong>
              </label>
            </div>
          ))}
        </SectionObra>

        {/* Garantías y penalizaciones */}
        <SectionObra title="Garantías y penalizaciones" fontSerif={fontSerif} isMobile={isMobile}>
          <div>
            <label style={labelStyle}>Garantía de buena ejecución (%)</label>
            <input autoComplete="off" type="number" step="0.5" style={inputStyle} value={form.garantiaBuenaEjecucionPct} onChange={e => set("garantiaBuenaEjecucionPct", e.target.value)}/>
            <p style={{fontSize:10, color:"#64748B", margin:"4px 0 0"}}>% del valor que se retiene hasta entrega final</p>
          </div>
          <div>
            <label style={labelStyle}>Vigencia vicios ocultos (meses)</label>
            <input autoComplete="off" type="number" style={inputStyle} value={form.garantiaViciosOcultosMeses} onChange={e => set("garantiaViciosOcultosMeses", e.target.value)}/>
            <p style={{fontSize:10, color:"#64748B", margin:"4px 0 0"}}>Recomendado: 12 meses</p>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Penalización diaria por retraso (%)</label>
            <input autoComplete="off" type="number" step="0.05" style={inputStyle} value={form.penalizacionDiariaPct} onChange={e => set("penalizacionDiariaPct", e.target.value)}/>
            <p style={{fontSize:10, color:"#64748B", margin:"4px 0 0"}}>% del valor total por cada día natural de retraso. Típico: 0.5%</p>
          </div>
        </SectionObra>

        {/* Testigos */}
        <SectionObra title="Testigos (recomendado)" fontSerif={fontSerif} isMobile={isMobile}>
          <div>
            <label style={labelStyle}>Nombre Testigo 1</label>
            <input autoComplete="off" style={inputStyle} value={form.nombreTestigo1} onChange={e => set("nombreTestigo1", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Nombre Testigo 2</label>
            <input autoComplete="off" style={inputStyle} value={form.nombreTestigo2} onChange={e => set("nombreTestigo2", e.target.value)}/>
          </div>
        </SectionObra>

        {/* Aviso legal */}
        <div style={{background:"rgba(184,147,42,0.10)", border:"1px solid rgba(184,147,42,0.3)",
          borderRadius:10, padding:"12px 14px", marginBottom:18, display:"flex", gap:10}}>
          <AxisIcon name="scale_simple" size={16} tone="gold" withBackdrop={false} strokeWidth={3}/>
          <div style={{fontSize:11.5, color:"#374151", lineHeight:1.5}}>
            <strong>Aviso legal:</strong> Plantilla genérica conforme al Código Civil del Estado de Aguascalientes (arts. 2489-2518 para precio alzado). Los anexos (memoria, planos, presupuesto, programa) son responsabilidad técnica del contratista y forman parte integrante del contrato. Para obras de gran cuantía o con permisos especiales (uso de suelo, INAH, manifestación de impacto ambiental), recomendamos validación adicional con AXIS Asesoría Legal Corporativa.
          </div>
        </div>

        {/* Botón generar */}
        <button onClick={generarPDF} disabled={generando || !camposObligatoriosLlenos}
          style={{width:"100%", padding:"14px", borderRadius:10,
            background: camposObligatoriosLlenos
              ? "linear-gradient(135deg,#D97706,#B45309)"
              : "#9CA3AF",
            border:"none", color:"white", fontSize:15, fontWeight:700,
            cursor: camposObligatoriosLlenos ? "pointer" : "not-allowed",
            boxShadow: camposObligatoriosLlenos ? "0 4px 16px rgba(217,119,6,0.40)" : "none",
            display:"flex", alignItems:"center", justifyContent:"center", gap:10,
            fontFamily:fontSans}}>
          <AxisIcon name="document" size={16} tone="white" withBackdrop={false} strokeWidth={3}/>
          {generando ? "Generando contrato..." : `Generar contrato ${modalidad === "precio_alzado" ? "a precio alzado" : "por administración"} en PDF`}
        </button>

        {!camposObligatoriosLlenos && (
          <p style={{fontSize:11, color:"#DC2626", margin:"8px 0 0", textAlign:"center" as const}}>
            Completa los campos marcados con <strong>*</strong> para generar el contrato.
          </p>
        )}
        {ultimoBlob && (
          <div style={{marginTop:14, padding:"14px 16px", background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:12, display:"flex", justifyContent:"space-between", alignItems:"center", gap:12, flexWrap:"wrap"}}>
            <div style={{fontSize:12, color:T_LIGHT.textInkSoft, flex:1, minWidth:160}}>¿Quieres guardar este contrato en un expediente?</div>
            <BotonGuardarYVincular
              user={user}
              tipoContrato={tipoContrato}
              getPDFBlob={async () => ultimoBlob!}
              nombrePDFBase={`Contrato_${tipoContrato}`}
              fontSans={fontSans} fontSerif={fontSerif} gold={gold}
            />
          </div>
        )}
      </div>
    </div>
  );
}


// #endregion
// #region ASOCIACIÓN PARTICIPACIÓN
// ─── CONTRATO: ASOCIACIÓN EN PARTICIPACIÓN ────────────────────────────────────
// Contrato mercantil donde EL ASOCIANTE opera el negocio frente a terceros y
// EL ASOCIADO aporta bienes/capital. NO genera relación laboral ni constituye
// sociedad mercantil. Las utilidades se reparten conforme al porcentaje pactado.
function SectionAsociacion({title, children, fontSerif, isMobile}: {title:string; children:React.ReactNode; fontSerif:string; isMobile:boolean}) {
  return (
    <div style={{marginBottom:18}}>
      <div style={{fontFamily:fontSerif, fontSize:14, fontWeight:700, color:"#0F172A",
        marginBottom:10, paddingBottom:6, borderBottom:"1px solid rgba(13,148,136,0.3)",
        display:"flex", alignItems:"center", gap:8}}>
        <AxisIcon name="suite_empleados" size={14} color="#0D9488" withBackdrop={false} strokeWidth={3}/>
        {title}
      </div>
      <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr":"1fr 1fr", gap:10}}>
        {children}
      </div>
    </div>
  );
}

function FormAsociacionParticipacion({user, tipoContrato, onBack, fontSans, fontSerif, gold}: {user:any; tipoContrato:string; onBack:()=>void; fontSans:string; fontSerif:string; gold:string}) {
  // El pie de este documento lo firma el patrón, no la plataforma.
  const datosPatron = useDatosPatron(user?.uid).datos;
  // Las dos partes de este contrato, para el control de "cuál soy yo".
  const PARTES_AP: ParteDeContrato[] = [
    {clave:"asociante", etiqueta:"Asociante", nombre:"razonSocialAsociante", rfc:"rfcAsociante", domicilio:"domicilioAsociante"},
    {clave:"asociado",  etiqueta:"Asociado",  nombre:"razonSocialAsociado",  rfc:"rfcAsociado",  domicilio:"domicilioAsociado"},
  ];
  const [miParte, setMiParte] = useState("");   // por defecto, ninguna
  const isMobile = window.innerWidth < 768;
  const [tipoAsociante, setTipoAsociante] = useState<"fisica"|"moral">("fisica");
  const [tipoAsociado, setTipoAsociado] = useState<"fisica"|"moral">("fisica");
  const [incluyeNoCompetencia, setIncluyeNoCompetencia] = useState<boolean>(true);

  const [form, setForm] = useState({
    ciudad: "Aguascalientes, Ags.",
    fechaContrato: "",
    // Asociante
    nombreAsociante: "",
    razonSocialAsociante: "",
    repLegalAsociante: "",
    nacionalidadAsociante: "Mexicana",
    estadoCivilAsociante: "soltero(a)",
    ocupacionAsociante: "",
    curpAsociante: "",
    rfcAsociante: "",
    cedulaAsociante: "",
    domicilioAsociante: "",
    telefonoAsociante: "",
    correoAsociante: "",
    // Asociado
    nombreAsociado: "",
    razonSocialAsociado: "",
    repLegalAsociado: "",
    nacionalidadAsociado: "Mexicana",
    estadoCivilAsociado: "soltero(a)",
    ocupacionAsociado: "",
    curpAsociado: "",
    rfcAsociado: "",
    domicilioAsociado: "",
    telefonoAsociado: "",
    correoAsociado: "",
    // El negocio
    nombreNegocio: "",
    giroNegocio: "",
    direccionNegocio: "",
    descripcionNegocio: "",
    // Aportaciones
    aportacionesAsociante: "",
    aportacionesAsociado: "",
    // Términos económicos
    porcentajeAsociado: "70",
    porcentajeAsociante: "30",
    vigenciaMeses: "12",
    fondoCajaChica: "2000",
    limiteGastoSinAutorizacion: "2000",
    // Penalizaciones
    penaRetrasoCuentas: "2000",
    penaEntregaTardia: "1000",
    penaNoCompetencia: "50000",
    radioNoCompetenciaKm: "10",
    aniosNoCompetenciaPost: "2",
    // Testigos
    nombreTestigo1: "",
    nombreTestigo2: "",
  });

  const [generando, setGenerando] = useState(false);
  const [ultimoBlob, setUltimoBlob] = useState<Blob|null>(null);
  const set = (k: string, v: any) => setForm(p => ({...p, [k]:v}));
  const F = (v: string) => v || "_______________________________";
  // FECHAS EN CASTELLANO, NO EN ISO. El campo guarda "2026-09-07" y eso salía
  // impreso tal cual en un contrato que se firma. `fechaLargaAxis` PARTE la
  // cadena en vez de construir un Date: `new Date("2026-09-01")` es medianoche
  // UTC, y en México eso es el 31 de agosto —el contrato imprimiría el día
  // anterior al pactado—. Si el valor no es una fecha ISO (hay campos de fecha
  // que son texto libre), se imprime tal como se escribió.
  const FF = (v: string) => fechaLargaAxis(v) || F(v);

  const numeroALetras = (n: number): string => {
    const unidades = ["","UN","DOS","TRES","CUATRO","CINCO","SEIS","SIETE","OCHO","NUEVE","DIEZ","ONCE","DOCE","TRECE","CATORCE","QUINCE","DIECISEIS","DIECISIETE","DIECIOCHO","DIECINUEVE"];
    const decenas = ["","DIEZ","VEINTE","TREINTA","CUARENTA","CINCUENTA","SESENTA","SETENTA","OCHENTA","NOVENTA"];
    const centenas = ["","CIEN","DOSCIENTOS","TRESCIENTOS","CUATROCIENTOS","QUINIENTOS","SEISCIENTOS","SETECIENTOS","OCHOCIENTOS","NOVECIENTOS"];
    if (n === 0) return "CERO";
    if (n < 20) return unidades[n];
    if (n < 100) return decenas[Math.floor(n/10)] + (n%10 ? " Y " + unidades[n%10] : "");
    if (n < 1000) return centenas[Math.floor(n/100)] + (n%100 ? " " + numeroALetras(n%100) : "");
    if (n < 10000) return unidades[Math.floor(n/1000)] + " MIL" + (n%1000 ? " " + numeroALetras(n%1000) : "");
    if (n < 1000000) return numeroALetras(Math.floor(n/1000)) + " MIL" + (n%1000 ? " " + numeroALetras(n%1000) : "");
    return numeroALetras(Math.floor(n/1000000)) + " MILLONES" + (n%1000000 ? " " + numeroALetras(n%1000000) : "");
  };

  const fmt$ = (v: string) => {
    if (!v) return "_______________________________";
    const n = parseFloat(v);
    if (isNaN(n)) return v;
    return "$" + n.toLocaleString("es-MX", {minimumFractionDigits:2, maximumFractionDigits: 2}) + " M.N. (" + numeroALetras(Math.floor(n)) + " PESOS " + String(Math.round((n%1)*100)).padStart(2,"0") + "/100 M.N.)";
  };

  const generarPDF = () => {
    setGenerando(true);
    setTimeout(() => {
      const { jsPDF } = (window as any).jspdf;
      const doc = new jsPDF({orientation:"portrait", unit:"mm", format:"letter"});
      const W = doc.internal.pageSize.getWidth();
      const H = doc.internal.pageSize.getHeight();
      const ML = 22, MR = 22;
      const usable = W - ML - MR;
      let y = 28;   // margen superior cómodo; el contrato inicia DIRECTO con su título (AXIS va al pie)

      const checkPage = (need = 8) => { if (y + need > H - 34) { doc.addPage(); y = 28; } };
      const titulo = (txt: string) => {
        checkPage(12);
        doc.setFont("times","bold"); doc.setFontSize(11); doc.setTextColor(11,24,41);
        doc.text(txt, W/2, y, {align:"center", maxWidth: usable}); y += 7;
      };
      const subtitulo = (txt: string) => {
        checkPage(30);   // mantiene el encabezado junto a su primer texto (evita viudas)
        doc.setFont("times","bold"); doc.setFontSize(10); doc.setTextColor(11,24,41);
        doc.text(txt, ML, y); y += 5;
      };
      const parrafo = (txt: string, opts?:{align?:"justify"|"left"|"center"; bold?:boolean; size?:number}) => {
        const fs = opts?.size || 9;
        doc.setFont("times", opts?.bold ? "bold" : "normal");
        doc.setFontSize(fs); doc.setTextColor(45,45,45);
        const lines = doc.splitTextToSize(txt, usable);
        for (const ln of lines) {
          checkPage(5);
          doc.text(ln, ML, y, {align: opts?.align==="center" ? "center" : "left", maxWidth: usable});
          y += fs*0.42 + 1.2;
        }
        y += 1;
      };

      // ───── ENCABEZADO ─────
      titulo("CONTRATO DE ASOCIACIÓN EN PARTICIPACIÓN");

      const asocianteNombre = tipoAsociante === "moral"
        ? `${F(form.razonSocialAsociante).toUpperCase()}, REPRESENTADA POR ${F(form.repLegalAsociante).toUpperCase()}`
        : F(form.nombreAsociante).toUpperCase();
      const asociadoNombre = tipoAsociado === "moral"
        ? `${F(form.razonSocialAsociado).toUpperCase()}, REPRESENTADA POR ${F(form.repLegalAsociado).toUpperCase()}`
        : F(form.nombreAsociado).toUpperCase();

      parrafo(
        `Contrato de asociación en participación que celebran por una parte ${asocianteNombre}, a quien en lo sucesivo se denominará "EL ASOCIANTE", y por la otra parte ${asociadoNombre}, en adelante "EL ASOCIADO", quienes en conjunto serán designados como "LAS PARTES" o "LOS ASOCIADOS", al tenor de las siguientes declaraciones y cláusulas:`,
        {align:"justify"}
      );

      // ───── DECLARACIONES ─────
      subtitulo("DECLARACIONES");

      parrafo("I. DECLARA EL ASOCIANTE:", {bold:true});
      if (tipoAsociante === "moral") {
        parrafo(`a) Ser una sociedad legalmente constituida, representada por ${F(form.repLegalAsociante)}, quien cuenta con facultades suficientes para celebrar el presente contrato.`);
        parrafo(`b) Tener su domicilio en ${F(form.domicilioAsociante)}, RFC ${F(form.rfcAsociante)}, teléfono ${F(form.telefonoAsociante)} y correo ${F(form.correoAsociante)}.`);
      } else {
        parrafo(`a) Ser persona física de nacionalidad ${F(form.nacionalidadAsociante)}, en pleno ejercicio y goce de sus derechos, mayor de edad, de estado civil ${F(form.estadoCivilAsociante)}, de ocupación ${F(form.ocupacionAsociante)}.`);
        parrafo(`b) Identificarse con CURP ${F(form.curpAsociante)} y RFC ${F(form.rfcAsociante)}${form.cedulaAsociante ? `, contando con cédula profesional vigente número ${form.cedulaAsociante}` : ""}.`);
        parrafo(`c) Contar con los conocimientos teóricos y prácticos, experiencia y capacidades para ejercer su actividad de manera diligente.`);
        parrafo(`d) Manifestar bajo protesta de decir verdad que no cuenta con impedimento legal, ético, sanitario o de cualquier naturaleza para ejercer su actividad.`);
        parrafo(`e) Tener su domicilio en ${F(form.domicilioAsociante)} y como medios de notificación: teléfono ${F(form.telefonoAsociante)} y correo ${F(form.correoAsociante)}.`);
      }

      parrafo("II. DECLARA EL ASOCIADO:", {bold:true});
      if (tipoAsociado === "moral") {
        parrafo(`a) Ser una sociedad legalmente constituida, representada por ${F(form.repLegalAsociado)}, quien cuenta con facultades suficientes para celebrar el presente contrato.`);
        parrafo(`b) Tener su domicilio en ${F(form.domicilioAsociado)}, RFC ${F(form.rfcAsociado)}, teléfono ${F(form.telefonoAsociado)} y correo ${F(form.correoAsociado)}.`);
      } else {
        parrafo(`a) Ser persona física de nacionalidad ${F(form.nacionalidadAsociado)}, en pleno ejercicio y goce de sus derechos, mayor de edad, de estado civil ${F(form.estadoCivilAsociado)}, de ocupación ${F(form.ocupacionAsociado)}.`);
        parrafo(`b) Identificarse con CURP ${F(form.curpAsociado)} y RFC ${F(form.rfcAsociado)}.`);
        parrafo(`c) Tener su domicilio en ${F(form.domicilioAsociado)} y como medios de notificación: teléfono ${F(form.telefonoAsociado)} y correo ${F(form.correoAsociado)}.`);
      }

      parrafo("III. DECLARAN LAS PARTES:", {bold:true});
      parrafo("a) Que se reconocen mutuamente la personalidad y facultades con que comparecen, celebrando este contrato con buena fe y lealtad negocial, sin error, dolo, violencia ni vicio alguno del consentimiento.");
      parrafo("b) Que cuentan con las capacidades económicas, profesionales, técnicas y demás necesarias para el buen desarrollo del objeto del presente contrato.");
      parrafo("c) Que la intención de este contrato es realizar una explotación comercial conjunta del negocio que se describe a continuación, y que de ninguna forma la relación jurídica que los une es de carácter laboral, no existiendo subordinación entre ellos.");

      // ───── CLÁUSULAS ─────
      checkPage(12);
      y += 2;
      subtitulo("CLÁUSULAS");

      parrafo("PRIMERA. OBJETO Y NOMBRE DEL NEGOCIO.", {bold:true});
      parrafo(
        `LAS PARTES convienen en constituir mediante el presente contrato una asociación en participación para la creación y explotación del negocio comercial denominado "${F(form.nombreNegocio).toUpperCase()}", el cual se dedicará de manera enunciativa más no limitativa a: ${F(form.giroNegocio)}.${form.descripcionNegocio ? ` ${form.descripcionNegocio}` : ""} El negocio operará en el domicilio ubicado en: ${F(form.direccionNegocio)}.`,
        {align:"justify"}
      );

      parrafo("SEGUNDA. REPRESENTACIÓN FRENTE A TERCEROS.", {bold:true});
      parrafo(
        `Dada la naturaleza de la asociación en participación, EL ASOCIANTE actuará en nombre propio y será el único responsable jurídico, civil, fiscal, administrativo y de cualquier naturaleza ante clientes, proveedores y autoridades de cualquier nivel de gobierno, respecto a la operación del negocio. EL ASOCIADO no tendrá relación alguna con dichos terceros. EL ASOCIANTE se obliga a indemnizar y sacar en paz a EL ASOCIADO por cualquier reclamación derivada de la operación del negocio.`,
        {align:"justify"}
      );

      parrafo("TERCERA. VIGENCIA.", {bold:true});
      parrafo(
        `El presente contrato tendrá una vigencia de ${F(form.vigenciaMeses)} meses contados a partir de su firma, condicionada a la rentabilidad y viabilidad del negocio. Podrá terminar anticipadamente cuando los estados financieros reflejen pérdidas netas (diferencia del 40% entre ingreso y gasto) en dos meses consecutivos, o cuando alguna de LAS PARTES manifieste su deseo de no continuar mediante aviso por escrito con 30 días naturales de anticipación.`,
        {align:"justify"}
      );

      parrafo("CUARTA. APORTACIONES INICIALES.", {bold:true});
      parrafo(`a) APORTACIONES DE EL ASOCIADO:`, {bold:true});
      parrafo(`${F(form.aportacionesAsociado)}`, {align:"justify"});
      parrafo(`b) APORTACIONES DE EL ASOCIANTE:`, {bold:true});
      parrafo(`${F(form.aportacionesAsociante)}`, {align:"justify"});
      parrafo(
        `Para constancia legal, las características y estado de los bienes aportados se documentarán en inventarios firmados por LAS PARTES y se adjuntarán como anexos al presente contrato.`,
        {align:"justify"}
      );

      parrafo("QUINTA. PROPIEDAD DE LOS BIENES.", {bold:true});
      parrafo(
        `LAS PARTES reconocen que los bienes aportados individualmente permanecen bajo su propiedad exclusiva. La celebración de este contrato no implica transmisión de dominio ni creación de derechos reales sobre dichos activos a favor de la otra parte. Los bienes adquiridos durante la vigencia con capital del negocio se considerarán propiedad común al 50% de cada parte y se liquidarán conforme a la cláusula DÉCIMA PRIMERA.`,
        {align:"justify"}
      );

      parrafo("SEXTA. OBLIGACIONES DE LAS PARTES.", {bold:true});
      parrafo("LAS PARTES se obligan conjunta y solidariamente al correcto funcionamiento del negocio mediante:", {align:"justify"});
      parrafo("a) Pago puntual de servicios (energía eléctrica, agua, internet, telefonía, recolección de residuos).");
      parrafo("b) Mantenimiento al corriente de registros contables, declaraciones fiscales y pago de impuestos.");
      parrafo("c) Obtención y renovación de permisos, licencias de funcionamiento y avisos ante autoridades.");
      parrafo("d) Conservación y mantenimiento de los activos e inmuebles del negocio.");
      parrafo("e) Documentación mensual de la entrada y salida de insumos.");
      parrafo("f) Resguardo de la base de datos de clientes y estrategias comerciales como secreto industrial.");
      parrafo("g) Abstenerse de desviar clientes hacia consultorios o establecimientos externos.");
      parrafo("h) No vender, empeñar, arrendar o transmitir los activos aportados sin autorización previa por escrito.");

      parrafo("SÉPTIMA. ADMINISTRACIÓN Y CONTROL ECONÓMICO.", {bold:true});
      parrafo(
        `EL ASOCIANTE tendrá autonomía operativa para las decisiones técnicas y administrativas diarias del negocio. Sin embargo, deberá obtener el acuerdo previo y por escrito de EL ASOCIADO para: (i) erogaciones extraordinarias que excedan ${fmt$(form.limiteGastoSinAutorizacion)}; (ii) contratación de personal permanente; (iii) compromisos contractuales con proveedores que excedan la vigencia del contrato.`,
        {align:"justify"}
      );
      parrafo(
        `Toda compra o gasto deberá estar respaldado con evidencia física y/o fiscal (facturas electrónicas, comprobantes de pago o notas de remisión). Se autoriza a EL ASOCIANTE el manejo de un fondo fijo mensual de ${fmt$(form.fondoCajaChica)} para gastos operativos menores, el cual deberá reponerse y comprobarse en cada periodo de rendición de cuentas.`,
        {align:"justify"}
      );

      parrafo("OCTAVA. RENDICIÓN DE CUENTAS.", {bold:true});
      parrafo(
        `EL ASOCIANTE se obliga a rendir cuentas detalladas a EL ASOCIADO el último día de cada mes calendario, presencialmente en las instalaciones del negocio, cerrándose el reporte a las 18:00 horas. Esta obligación subsiste aun cuando el último día sea domingo o festivo. Los gastos no autorizados o sin soporte fiscal serán absorbidos íntegramente por EL ASOCIANTE y descontados de su participación en utilidades. La revisión concluirá con la firma de un acta denominada "RENDICIÓN DE MES CORRIENTE".`,
        {align:"justify"}
      );

      parrafo("NOVENA. REPARTO DE UTILIDADES.", {bold:true});
      parrafo(
        `Se entenderá por utilidad distribuible el remanente líquido que resulte de los ingresos totales del mes, tras descontar gastos operativos, administrativos, fiscales, salarios, prestaciones, servicios, suministros y demás gastos necesarios para el funcionamiento del negocio.`,
        {align:"justify"}
      );
      parrafo(
        `REPARTO: ${F(form.porcentajeAsociado)}% para EL ASOCIADO y ${F(form.porcentajeAsociante)}% para EL ASOCIANTE. Esta proporción tendrá vigencia de 12 meses, periodo considerado de recuperación de inversión inicial; vencido el plazo, LAS PARTES se obligan a revisarla y ajustarla de común acuerdo.`,
        {align:"justify"}
      );
      parrafo(
        `EL ASOCIANTE acepta y autoriza expresamente que, antes de recibir su utilidad, se apliquen automáticamente los descuentos por: (i) penas convencionales o multas previstas en este contrato; (ii) resarcimiento por daños a activos por uso negligente; (iii) gastos no autorizados. El reparto se realizará dentro de los 3 días naturales posteriores a la firma del acta de rendición de cuentas, formalizándose con un comprobante denominado "PAGO DE UTILIDADES DEL MES".`,
        {align:"justify"}
      );

      parrafo("DÉCIMA. EXCLUSIÓN DE RELACIÓN LABORAL.", {bold:true});
      parrafo(
        `LAS PARTES declaran expresamente que el presente contrato es de naturaleza mercantil y NO genera relación laboral, de subordinación o de dependencia entre ellas. Para la operación del negocio, EL ASOCIANTE asumirá la figura de patrón respecto del personal contratado, obligándose a sacar en paz a EL ASOCIADO de cualquier reclamación laboral, civil o de seguridad social.`,
        {align:"justify"}
      );

      parrafo("DÉCIMA PRIMERA. LIQUIDACIÓN DE LA ASOCIACIÓN.", {bold:true});
      parrafo(
        `Al término de la vigencia, rescisión o terminación anticipada, se procederá a la liquidación bajo las siguientes reglas: a) Restitución de aportaciones iniciales en plazo máximo de 5 días naturales; b) Los bienes adquiridos individualmente con recursos propios pertenecen a quien los compró; c) Los bienes adquiridos con capital del negocio se consideran propiedad común al 50% — EL ASOCIADO tendrá derecho preferente para adquirir la titularidad total pagando 50% del valor factura a EL ASOCIANTE; d) La base de datos y expedientes son propiedad de quien los aportó originalmente; e) El proceso concluirá con un acta denominada "DE LIQUIDACIÓN Y FINIQUITO".`,
        {align:"justify"}
      );

      if (incluyeNoCompetencia) {
        parrafo("DÉCIMA SEGUNDA. NO COMPETENCIA.", {bold:true});
        parrafo(
          `EL ASOCIANTE se obliga a no realizar, por cuenta propia o de terceros, actividades comerciales que entren en competencia directa o indirecta con el objeto del negocio, en un radio de ${F(form.radioNoCompetenciaKm)} kilómetros a la redonda del domicilio del negocio. Esta prohibición surtirá efectos durante la vigencia del contrato y se extenderá por ${F(form.aniosNoCompetenciaPost)} años posteriores a su terminación. El incumplimiento generará la obligación de pagar a EL ASOCIADO una pena convencional de ${fmt$(form.penaNoCompetencia)}, sin perjuicio de las acciones legales por daños y perjuicios.`,
          {align:"justify"}
        );
      }

      parrafo(`DÉCIMA ${incluyeNoCompetencia ? "TERCERA" : "SEGUNDA"}. SANCIONES.`, {bold:true});
      parrafo(
        `LAS PARTES acuerdan las siguientes penas convencionales, descontables directamente de las utilidades de EL ASOCIANTE: a) Por retraso en rendición de cuentas: ${fmt$(form.penaRetrasoCuentas)} por cada día de retraso; b) Por exceso en autonomía financiera (gastos no autorizados): 100% del monto excedido; c) Por incumplimiento de disponibilidad o falta de respuesta a notificaciones en plazo mayor a 24 horas: ${fmt$(form.penaEntregaTardia)} por evento; d) Por retraso en entrega de bienes al término del contrato: ${fmt$(form.penaEntregaTardia)} por día natural; e) Por omisión de ingresos o falta de probidad: ${fmt$(form.penaRetrasoCuentas)} por evento, además del derecho de rescisión inmediata.`,
        {align:"justify"}
      );

      parrafo(`DÉCIMA ${incluyeNoCompetencia ? "CUARTA" : "TERCERA"}. CAUSAS DE TERMINACIÓN.`, {bold:true});
      parrafo(
        `El contrato podrá darse por terminado por: a) Cumplimiento del plazo, salvo renovación por escrito; b) Mutuo acuerdo de LAS PARTES; c) Aviso de terminación anticipada con 30 días naturales de anticipación; d) Rescisión inmediata por incumplimiento de EL ASOCIANTE (omisión de ingresos, alteración de registros, retraso en pagos, abandono de la gestión por más de 3 días, negligencia comprobada); e) Pérdida de rentabilidad o caso fortuito que impida la operación.`,
        {align:"justify"}
      );

      parrafo(`DÉCIMA ${incluyeNoCompetencia ? "QUINTA" : "CUARTA"}. JURISDICCIÓN.`, {bold:true});
      parrafo(
        `Para la interpretación, cumplimiento y ejecución del presente contrato, LAS PARTES se someten expresamente a la jurisdicción y competencia de los Juzgados y Tribunales del Estado de Aguascalientes, renunciando al fuero que pudiera corresponderles por razón de su domicilio presente o futuro.`,
        {align:"justify"}
      );

      // ───── FIRMAS ─────
      checkPage(45);
      y += 6;
      doc.setFont("times","bold"); doc.setFontSize(9); doc.setTextColor(11,24,41);
      doc.text(`Leído el presente contrato y enterados de su alcance, LAS PARTES lo firman de conformidad en ${F(form.ciudad)} el día ${FF(form.fechaContrato)}.`, W/2, y, {align:"center", maxWidth: usable});
      y += 14;

      const colW = (usable - 8) / 2;
      const x1 = ML;
      const x2 = ML + colW + 8;
      doc.setDrawColor(11,24,41);
      doc.setLineWidth(0.3);
      doc.line(x1+8, y, x1+colW-8, y);
      doc.line(x2+8, y, x2+colW-8, y);
      y += 4;
      doc.setFont("times","bold"); doc.setFontSize(8);
      doc.text("EL ASOCIANTE", x1+colW/2, y, {align:"center"});
      doc.text("EL ASOCIADO", x2+colW/2, y, {align:"center"});
      y += 4;
      doc.setFont("times","normal");
      const nomAsoc = tipoAsociante === "moral" ? F(form.razonSocialAsociante) : F(form.nombreAsociante);
      const nomAsdo = tipoAsociado === "moral" ? F(form.razonSocialAsociado) : F(form.nombreAsociado);
      doc.text(nomAsoc, x1+colW/2, y, {align:"center"});
      doc.text(nomAsdo, x2+colW/2, y, {align:"center"});

      // Testigos
      if (form.nombreTestigo1 || form.nombreTestigo2) {
        y += 14;
        checkPage(20);
        doc.line(x1+8, y, x1+colW-8, y);
        doc.line(x2+8, y, x2+colW-8, y);
        y += 4;
        doc.setFont("times","bold"); doc.setFontSize(8);
        doc.text("TESTIGO 1", x1+colW/2, y, {align:"center"});
        doc.text("TESTIGO 2", x2+colW/2, y, {align:"center"});
        y += 4;
        doc.setFont("times","normal");
        doc.text(F(form.nombreTestigo1), x1+colW/2, y, {align:"center"});
        doc.text(F(form.nombreTestigo2), x2+colW/2, y, {align:"center"});
      }

      // Footer
      const totalPages = doc.internal.pages.length - 1;
      for (let p = 1; p <= totalPages; p++) {
        doc.setPage(p);
        doc.setFont("times","italic"); doc.setFontSize(7);
        doc.setTextColor(120,120,120);
        pintarLeyendaContrato(doc, W/2, H-13.5, W-ML-MR, "center");
        doc.text(pieDelPatron(datosPatron, fechaHoraLargaAxis()), W/2, H-10, {align:"center"});
        doc.text(`Página ${p} de ${totalPages}`, W-MR, H-10, {align:"right"});
      }

      const fname = `Asociacion_Participacion_${(form.nombreNegocio || "negocio").replace(/[^A-Za-z0-9]/g,"_")}.pdf`;
      doc.save(fname);
      try { setUltimoBlob(doc.output("blob")); } catch {}
      setGenerando(false);
    }, 200);
  };

  const inputStyle: React.CSSProperties = {
    width:"100%", padding:"9px 11px", fontSize:13, fontFamily:fontSans,
    background:"white", border:"1px solid #D1D5DB", borderRadius:8, color:"#0F172A",
    boxSizing:"border-box" as const,
  };
  const labelStyle: React.CSSProperties = {
    display:"block", fontSize:11, fontWeight:600, color:"#374151", marginBottom:4,
    letterSpacing:"0.2px",
  };

  const camposObligatoriosLlenos = !!(
    form.fechaContrato && form.nombreNegocio && form.giroNegocio && form.direccionNegocio &&
    form.aportacionesAsociante && form.aportacionesAsociado &&
    form.porcentajeAsociado && form.porcentajeAsociante &&
    (tipoAsociante === "moral" ? form.razonSocialAsociante && form.repLegalAsociante : form.nombreAsociante) &&
    (tipoAsociado === "moral" ? form.razonSocialAsociado && form.repLegalAsociado : form.nombreAsociado)
  );

  return (
    <div {...ZONA_DE_CAPTURA} style={{minHeight:"100vh", background:T_LIGHT.canvas, fontFamily:fontSans}}>
      {/* Header */}
      <div style={{background:"linear-gradient(135deg,#0D9488,#0F766E)", padding:"0 20px", height:58,
        display:"flex", alignItems:"center", gap:12, position:"sticky" as const, top:0, zIndex:100,
        boxShadow:"0 4px 20px rgba(13,148,136,0.30)"}}>
        <button onClick={onBack}
          style={{background:"rgba(255,255,255,0.18)", border:"1px solid rgba(255,255,255,0.30)",
            color:"white", borderRadius:8, padding:"5px 11px", cursor:"pointer",
            fontSize:12, fontWeight:600}}>← Generador legal</button>
        <span style={{color:"white", fontWeight:700, fontSize:isMobile?12:14, display:"flex",
          alignItems:"center", gap:8}}>
          <AxisIcon name="suite_empleados" size={18} tone="white" withBackdrop={false} strokeWidth={2.5}/>
          Asociación en Participación
        </span>
      </div>

      <div style={{maxWidth:760, margin:"0 auto", padding:isMobile?"16px":"24px"}}>
        <p style={{fontSize:12, color:"#64748B", margin:"0 0 6px", lineHeight:1.6}}>
          Contrato mercantil donde dos partes se asocian para explotar un negocio en conjunto. EL ASOCIANTE opera frente a terceros y EL ASOCIADO aporta bienes/capital.
        </p>
        <p style={{fontSize:12, color:"#64748B", margin:"0 0 18px", lineHeight:1.6}}>
          Completa los datos. Los campos marcados con <span style={{color:"#DC2626"}}>*</span> son indispensables.
        </p>

        <SelectorDeMiParte partes={PARTES_AP} elegida={miParte} tipoPersona={datosPatron.tipoPersona} fontSans={fontSans} fontSerif={fontSerif}
          onElegir={(c)=>{ setMiParte(c); setForm((f:any)=>aplicarMiParte(f, PARTES_AP, c, datosPatron));
            // Aquí las DOS partes tienen variante de sociedad.
            if (datosPatron.tipoPersona) {
              if (c === "asociante") setTipoAsociante(datosPatron.tipoPersona);
              if (c === "asociado")  setTipoAsociado(datosPatron.tipoPersona);
            }
          }}/>

        {/* Aviso explicativo destacado */}
        <div style={{background:"rgba(13,148,136,0.08)", border:"1px solid rgba(13,148,136,0.30)",
          borderRadius:10, padding:"12px 14px", marginBottom:18, display:"flex", gap:10}}>
          <AxisIcon name="info" size={18} color="#0D9488" withBackdrop={false} strokeWidth={3}/>
          <div style={{fontSize:11.5, color:"#374151", lineHeight:1.55}}>
            <strong>¿Cómo funciona?</strong> EL ASOCIADO típicamente aporta el capital, inmuebles, marca o software. EL ASOCIANTE típicamente aporta el conocimiento profesional, la operación diaria y representa al negocio frente a clientes y autoridades. Las utilidades se reparten conforme al porcentaje pactado (ej. 70/30) y el contrato NO crea relación laboral.
          </div>
        </div>

        {/* Datos generales */}
        <SectionAsociacion title="Datos generales" fontSerif={fontSerif} isMobile={isMobile}>
          <div>
            <label style={labelStyle}>Ciudad y estado de firma <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" style={inputStyle} value={form.ciudad} onChange={e => set("ciudad", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Fecha de firma <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" type="date" style={inputStyle} value={form.fechaContrato} onChange={e => set("fechaContrato", e.target.value)}/>
          </div>
        </SectionAsociacion>

        {/* EL ASOCIANTE */}
        <SectionAsociacion title="EL ASOCIANTE (quien opera el negocio)" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Tipo de persona <span style={{color:"#DC2626"}}>*</span></label>
            <div style={{display:"flex", gap:8}}>
              {(["fisica","moral"] as const).map(t => (
                <button key={t} onClick={() => setTipoAsociante(t)}
                  style={{flex:1, padding:"9px 12px", borderRadius:8, fontSize:12, fontWeight:600,
                    fontFamily:fontSans, cursor:"pointer",
                    background: tipoAsociante===t ? "#0D9488" : "white",
                    color: tipoAsociante===t ? "white" : "#374151",
                    border: tipoAsociante===t ? "1px solid #0D9488" : "1px solid #D1D5DB"}}>
                  {t === "moral" ? "Persona moral (empresa)" : "Persona física"}
                </button>
              ))}
            </div>
          </div>
          {tipoAsociante === "moral" ? (
            <>
              <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
                <label style={labelStyle}>Razón social <span style={{color:"#DC2626"}}>*</span></label>
                <input autoComplete="off" style={inputStyle} value={form.razonSocialAsociante} onChange={e => set("razonSocialAsociante", e.target.value)}/>
              </div>
              <div>
                <label style={labelStyle}>Representante legal <span style={{color:"#DC2626"}}>*</span></label>
                <input autoComplete="off" style={inputStyle} value={form.repLegalAsociante} onChange={e => set("repLegalAsociante", e.target.value)}/>
              </div>
            </>
          ) : (
            <>
              <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
                <label style={labelStyle}>Nombre completo <span style={{color:"#DC2626"}}>*</span></label>
                <input autoComplete="off" style={inputStyle} value={form.nombreAsociante} onChange={e => set("nombreAsociante", e.target.value)}/>
              </div>
              <div>
                <label style={labelStyle}>Ocupación / profesión</label>
                <input autoComplete="off" style={inputStyle} value={form.ocupacionAsociante} onChange={e => set("ocupacionAsociante", e.target.value)}
                  placeholder="Médico veterinario, Contador, etc."/>
              </div>
              <div>
                <label style={labelStyle}>Estado civil</label>
                <select style={inputStyle} value={form.estadoCivilAsociante} onChange={e => set("estadoCivilAsociante", e.target.value)}>
                  <option value="soltero(a)">Soltero(a)</option>
                  <option value="casado(a)">Casado(a)</option>
                  <option value="divorciado(a)">Divorciado(a)</option>
                  <option value="viudo(a)">Viudo(a)</option>
                  <option value="unión libre">Unión libre</option>
                </select>
              </div>
              <div>
                <label style={labelStyle}>CURP</label>
                <input autoComplete="off" style={inputStyle} value={form.curpAsociante} onChange={e => set("curpAsociante", e.target.value)}/>
              </div>
              <div>
                <label style={labelStyle}>Cédula profesional (opcional)</label>
                <input autoComplete="off" style={inputStyle} value={form.cedulaAsociante} onChange={e => set("cedulaAsociante", e.target.value)}/>
              </div>
            </>
          )}
          <div>
            <label style={labelStyle}>RFC</label>
            <input autoComplete="off" style={inputStyle} value={form.rfcAsociante} onChange={e => set("rfcAsociante", e.target.value)}/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Domicilio</label>
            <input autoComplete="off" style={inputStyle} value={form.domicilioAsociante} onChange={e => set("domicilioAsociante", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Teléfono</label>
            <input autoComplete="off" style={inputStyle} value={form.telefonoAsociante} onChange={e => set("telefonoAsociante", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Correo electrónico</label>
            <input autoComplete="off" style={inputStyle} value={form.correoAsociante} onChange={e => set("correoAsociante", e.target.value)}/>
          </div>
        </SectionAsociacion>

        {/* EL ASOCIADO */}
        <SectionAsociacion title="EL ASOCIADO (quien aporta bienes/capital)" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Tipo de persona <span style={{color:"#DC2626"}}>*</span></label>
            <div style={{display:"flex", gap:8}}>
              {(["fisica","moral"] as const).map(t => (
                <button key={t} onClick={() => setTipoAsociado(t)}
                  style={{flex:1, padding:"9px 12px", borderRadius:8, fontSize:12, fontWeight:600,
                    fontFamily:fontSans, cursor:"pointer",
                    background: tipoAsociado===t ? "#0D9488" : "white",
                    color: tipoAsociado===t ? "white" : "#374151",
                    border: tipoAsociado===t ? "1px solid #0D9488" : "1px solid #D1D5DB"}}>
                  {t === "moral" ? "Persona moral (empresa)" : "Persona física"}
                </button>
              ))}
            </div>
          </div>
          {tipoAsociado === "moral" ? (
            <>
              <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
                <label style={labelStyle}>Razón social <span style={{color:"#DC2626"}}>*</span></label>
                <input autoComplete="off" style={inputStyle} value={form.razonSocialAsociado} onChange={e => set("razonSocialAsociado", e.target.value)}/>
              </div>
              <div>
                <label style={labelStyle}>Representante legal <span style={{color:"#DC2626"}}>*</span></label>
                <input autoComplete="off" style={inputStyle} value={form.repLegalAsociado} onChange={e => set("repLegalAsociado", e.target.value)}/>
              </div>
            </>
          ) : (
            <>
              <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
                <label style={labelStyle}>Nombre completo <span style={{color:"#DC2626"}}>*</span></label>
                <input autoComplete="off" style={inputStyle} value={form.nombreAsociado} onChange={e => set("nombreAsociado", e.target.value)}/>
              </div>
              <div>
                <label style={labelStyle}>Ocupación</label>
                <input autoComplete="off" style={inputStyle} value={form.ocupacionAsociado} onChange={e => set("ocupacionAsociado", e.target.value)}/>
              </div>
              <div>
                <label style={labelStyle}>Estado civil</label>
                <select style={inputStyle} value={form.estadoCivilAsociado} onChange={e => set("estadoCivilAsociado", e.target.value)}>
                  <option value="soltero(a)">Soltero(a)</option>
                  <option value="casado(a)">Casado(a)</option>
                  <option value="divorciado(a)">Divorciado(a)</option>
                  <option value="viudo(a)">Viudo(a)</option>
                  <option value="unión libre">Unión libre</option>
                </select>
              </div>
              <div>
                <label style={labelStyle}>CURP</label>
                <input autoComplete="off" style={inputStyle} value={form.curpAsociado} onChange={e => set("curpAsociado", e.target.value)}/>
              </div>
            </>
          )}
          <div>
            <label style={labelStyle}>RFC</label>
            <input autoComplete="off" style={inputStyle} value={form.rfcAsociado} onChange={e => set("rfcAsociado", e.target.value)}/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Domicilio</label>
            <input autoComplete="off" style={inputStyle} value={form.domicilioAsociado} onChange={e => set("domicilioAsociado", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Teléfono</label>
            <input autoComplete="off" style={inputStyle} value={form.telefonoAsociado} onChange={e => set("telefonoAsociado", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Correo electrónico</label>
            <input autoComplete="off" style={inputStyle} value={form.correoAsociado} onChange={e => set("correoAsociado", e.target.value)}/>
          </div>
        </SectionAsociacion>

        {/* El Negocio */}
        <SectionAsociacion title="El negocio" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Nombre comercial del negocio <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" style={inputStyle} value={form.nombreNegocio} onChange={e => set("nombreNegocio", e.target.value)}
              placeholder="Veterinaria Quetzalcóatl, Café El Roble..."/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Giro / actividad principal <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" style={inputStyle} value={form.giroNegocio} onChange={e => set("giroNegocio", e.target.value)}
              placeholder="Atención médico veterinaria y venta de insumos"/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Dirección donde operará el negocio <span style={{color:"#DC2626"}}>*</span></label>
            <textarea autoComplete="off" style={{...inputStyle, minHeight:55, resize:"vertical" as const}} value={form.direccionNegocio}
              onChange={e => set("direccionNegocio", e.target.value)}
              placeholder="Calle ___ No. ___, Local ___, Colonia ___, Aguascalientes, Ags."/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Descripción adicional (opcional)</label>
            <textarea autoComplete="off" style={{...inputStyle, minHeight:55, resize:"vertical" as const}} value={form.descripcionNegocio}
              onChange={e => set("descripcionNegocio", e.target.value)}
              placeholder="Detalle de servicios, productos o información complementaria"/>
          </div>
        </SectionAsociacion>

        {/* Aportaciones */}
        <SectionAsociacion title="Aportaciones de cada parte" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Aportaciones de EL ASOCIADO <span style={{color:"#DC2626"}}>*</span></label>
            <textarea autoComplete="off" style={{...inputStyle, minHeight:80, resize:"vertical" as const}} value={form.aportacionesAsociado}
              onChange={e => set("aportacionesAsociado", e.target.value)}
              placeholder="Lista lo que aporta EL ASOCIADO. Ejemplo:&#10;1. Inmueble ubicado en ___&#10;2. Software de administración&#10;3. Marca y nombre comercial&#10;4. Capital inicial de $___"/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Aportaciones de EL ASOCIANTE <span style={{color:"#DC2626"}}>*</span></label>
            <textarea autoComplete="off" style={{...inputStyle, minHeight:80, resize:"vertical" as const}} value={form.aportacionesAsociante}
              onChange={e => set("aportacionesAsociante", e.target.value)}
              placeholder="Lista lo que aporta EL ASOCIANTE. Ejemplo:&#10;1. Conocimientos profesionales en ___&#10;2. Mobiliario consistente en: ___&#10;3. Equipo profesional ___"/>
          </div>
        </SectionAsociacion>

        {/* Términos económicos */}
        <SectionAsociacion title="Reparto de utilidades y términos económicos" fontSerif={fontSerif} isMobile={isMobile}>
          <div>
            <label style={labelStyle}>% para EL ASOCIADO <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" type="number" style={inputStyle} value={form.porcentajeAsociado}
              onChange={e => {
                const v = e.target.value;
                set("porcentajeAsociado", v);
                const n = parseFloat(v);
                if (!isNaN(n) && n >= 0 && n <= 100) set("porcentajeAsociante", String(100 - n));
              }}/>
            <p style={{fontSize:10, color:"#64748B", margin:"4px 0 0"}}>Quien aporta capital — típico: 60-70%</p>
          </div>
          <div>
            <label style={labelStyle}>% para EL ASOCIANTE <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" type="number" style={inputStyle} value={form.porcentajeAsociante}
              onChange={e => {
                const v = e.target.value;
                set("porcentajeAsociante", v);
                const n = parseFloat(v);
                if (!isNaN(n) && n >= 0 && n <= 100) set("porcentajeAsociado", String(100 - n));
              }}/>
            <p style={{fontSize:10, color:"#64748B", margin:"4px 0 0"}}>Quien opera — típico: 30-40%</p>
          </div>
          <div>
            <label style={labelStyle}>Vigencia inicial (meses)</label>
            <input autoComplete="off" type="number" style={inputStyle} value={form.vigenciaMeses} onChange={e => set("vigenciaMeses", e.target.value)}/>
            <p style={{fontSize:10, color:"#64748B", margin:"4px 0 0"}}>Periodo de recuperación de inversión</p>
          </div>
          <div>
            <label style={labelStyle}>Fondo de caja chica mensual (MXN)</label>
            <input autoComplete="off" type="number" style={inputStyle} value={form.fondoCajaChica} onChange={e => set("fondoCajaChica", e.target.value)}/>
            <p style={{fontSize:10, color:"#64748B", margin:"4px 0 0"}}>Para gastos menores y urgentes</p>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Límite de gastos sin autorización (MXN)</label>
            <input autoComplete="off" type="number" style={inputStyle} value={form.limiteGastoSinAutorizacion} onChange={e => set("limiteGastoSinAutorizacion", e.target.value)}/>
            <p style={{fontSize:10, color:"#64748B", margin:"4px 0 0"}}>Gastos arriba de este monto requieren acuerdo escrito de EL ASOCIADO</p>
          </div>
        </SectionAsociacion>

        {/* No competencia y penalizaciones */}
        <SectionAsociacion title="No competencia y penalizaciones" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1", padding:"10px 12px",
            background:"rgba(13,148,136,0.05)", borderRadius:8,
            border:"1px solid rgba(13,148,136,0.2)"}}>
            <label style={{display:"flex", alignItems:"center", gap:8, cursor:"pointer", fontSize:12, color:"#374151"}}>
              <input autoComplete="off" type="checkbox" checked={incluyeNoCompetencia}
                onChange={e => setIncluyeNoCompetencia(e.target.checked)}/>
              <strong>Incluir cláusula de no competencia</strong> — recomendado para proteger el negocio
            </label>
          </div>
          {incluyeNoCompetencia && (
            <>
              <div>
                <label style={labelStyle}>Radio de no competencia (km)</label>
                <input autoComplete="off" type="number" style={inputStyle} value={form.radioNoCompetenciaKm} onChange={e => set("radioNoCompetenciaKm", e.target.value)}/>
              </div>
              <div>
                <label style={labelStyle}>Vigencia post-contrato (años)</label>
                <input autoComplete="off" type="number" style={inputStyle} value={form.aniosNoCompetenciaPost} onChange={e => set("aniosNoCompetenciaPost", e.target.value)}/>
              </div>
              <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
                <label style={labelStyle}>Pena por violación de no competencia (MXN)</label>
                <input autoComplete="off" type="number" style={inputStyle} value={form.penaNoCompetencia} onChange={e => set("penaNoCompetencia", e.target.value)}/>
              </div>
            </>
          )}
          <div>
            <label style={labelStyle}>Pena por retraso en rendición de cuentas (MXN/día)</label>
            <input autoComplete="off" type="number" style={inputStyle} value={form.penaRetrasoCuentas} onChange={e => set("penaRetrasoCuentas", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Pena por entrega tardía o no respuesta (MXN/día)</label>
            <input autoComplete="off" type="number" style={inputStyle} value={form.penaEntregaTardia} onChange={e => set("penaEntregaTardia", e.target.value)}/>
          </div>
        </SectionAsociacion>

        {/* Testigos */}
        <SectionAsociacion title="Testigos (recomendado)" fontSerif={fontSerif} isMobile={isMobile}>
          <div>
            <label style={labelStyle}>Nombre Testigo 1</label>
            <input autoComplete="off" style={inputStyle} value={form.nombreTestigo1} onChange={e => set("nombreTestigo1", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Nombre Testigo 2</label>
            <input autoComplete="off" style={inputStyle} value={form.nombreTestigo2} onChange={e => set("nombreTestigo2", e.target.value)}/>
          </div>
        </SectionAsociacion>

        {/* Aviso legal */}
        <div style={{background:"rgba(184,147,42,0.10)", border:"1px solid rgba(184,147,42,0.3)",
          borderRadius:10, padding:"12px 14px", marginBottom:18, display:"flex", gap:10}}>
          <AxisIcon name="scale_simple" size={16} tone="gold" withBackdrop={false} strokeWidth={3}/>
          <div style={{fontSize:11.5, color:"#374151", lineHeight:1.5}}>
            <strong>Aviso legal:</strong> Plantilla genérica conforme al Código Civil del Estado de Aguascalientes y al Código de Comercio. Para asociaciones con activos de alto valor, propiedad intelectual registrada (marcas, patentes), licencias especiales (sanitarias, COFEPRIS) o aportaciones complejas, recomendamos validación con AXIS Asesoría Legal Corporativa antes de firmar. Recuerda formalizar los anexos: inventario de bienes aportados, aviso de privacidad, y registros operativos del negocio.
          </div>
        </div>

        {/* Botón generar */}
        <button onClick={generarPDF} disabled={generando || !camposObligatoriosLlenos}
          style={{width:"100%", padding:"14px", borderRadius:10,
            background: camposObligatoriosLlenos
              ? "linear-gradient(135deg,#0D9488,#0F766E)"
              : "#9CA3AF",
            border:"none", color:"white", fontSize:15, fontWeight:700,
            cursor: camposObligatoriosLlenos ? "pointer" : "not-allowed",
            boxShadow: camposObligatoriosLlenos ? "0 4px 16px rgba(13,148,136,0.40)" : "none",
            display:"flex", alignItems:"center", justifyContent:"center", gap:10,
            fontFamily:fontSans}}>
          <AxisIcon name="document" size={16} tone="white" withBackdrop={false} strokeWidth={3}/>
          {generando ? "Generando contrato..." : "Generar contrato en PDF"}
        </button>

        {!camposObligatoriosLlenos && (
          <p style={{fontSize:11, color:"#DC2626", margin:"8px 0 0", textAlign:"center" as const}}>
            Completa los campos marcados con <strong>*</strong> para generar el contrato.
          </p>
        )}
        {ultimoBlob && (
          <div style={{marginTop:14, padding:"14px 16px", background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:12, display:"flex", justifyContent:"space-between", alignItems:"center", gap:12, flexWrap:"wrap"}}>
            <div style={{fontSize:12, color:T_LIGHT.textInkSoft, flex:1, minWidth:160}}>¿Quieres guardar este contrato en un expediente?</div>
            <BotonGuardarYVincular
              user={user}
              tipoContrato={tipoContrato}
              getPDFBlob={async () => ultimoBlob!}
              nombrePDFBase={`Contrato_${tipoContrato}`}
              fontSans={fontSans} fontSerif={fontSerif} gold={gold}
            />
          </div>
        )}
      </div>
    </div>
  );
}


// #endregion
// #region WRAPPER SELECTOR
// ─── WRAPPER: SELECTOR INDIVIDUAL / COLECTIVO ────────────────────────────────
// Muestra dos cards al inicio: Individual o Colectivo. Permite navegar a uno u
// otro componente, manteniendo el back consistente.
function FormContratoTrabajoSelector({user, tipoContrato, onBack, fontSans, fontSerif, gold}: {user:any; tipoContrato:string; onBack:()=>void; fontSans:string; fontSerif:string; gold:string}) {
  const isMobile = window.innerWidth < 768;
  const [modalidad, setModalidad] = useState<"selector"|"individual"|"colectivo">("selector");

  if (modalidad === "individual") {
    return <FormContratoTrabajo user={user} tipoContrato={tipoContrato} onBack={() => setModalidad("selector")} fontSans={fontSans} fontSerif={fontSerif} gold={gold} />;
  }
  if (modalidad === "colectivo") {
    return <FormContratoColectivo user={user} tipoContrato={tipoContrato} onBack={() => setModalidad("selector")} fontSans={fontSans} fontSerif={fontSerif} gold={gold} />;
  }

  return (
    <div style={{minHeight:"100vh", background:T_LIGHT.canvas, fontFamily:fontSans}}>
      {/* Header */}
      <div style={{background:"linear-gradient(135deg,#2563EB,#1E40AF)", padding:"0 20px", height:58,
        display:"flex", alignItems:"center", gap:12, position:"sticky" as const, top:0, zIndex:100,
        boxShadow:"0 4px 20px rgba(37,99,235,0.30)"}}>
        <button onClick={onBack}
          style={{background:"rgba(255,255,255,0.18)", border:"1px solid rgba(255,255,255,0.30)",
            color:"white", borderRadius:8, padding:"5px 11px", cursor:"pointer",
            fontSize:12, fontWeight:600}}>← Generador legal</button>
        <span style={{color:"white", fontWeight:700, fontSize:isMobile?12:14, display:"flex",
          alignItems:"center", gap:8}}>
          <AxisIcon name="suite_empleados" size={18} tone="white" withBackdrop={false} strokeWidth={2.5}/>
          Contrato de Trabajo
        </span>
      </div>

      <div style={{maxWidth:760, margin:"0 auto", padding:isMobile?"24px 16px":"32px 24px"}}>
        <h2 style={{fontFamily:fontSerif, fontSize:isMobile?20:24, fontWeight:700, color:"#0F172A",
          margin:"0 0 8px", textAlign:"center" as const}}>
          ¿Qué tipo de contrato necesitas?
        </h2>
        <p style={{fontSize:13, color:"#64748B", margin:"0 0 28px", textAlign:"center" as const, lineHeight:1.5}}>
          Selecciona la modalidad que corresponda a tu caso.
        </p>

        {/* Cards de selección */}
        <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr":"1fr 1fr", gap:14}}>

          {/* Individual */}
          <button onClick={() => setModalidad("individual")}
            style={{background:"white", border:"2px solid rgba(37,99,235,0.25)", borderRadius:14,
              padding:"22px 18px", cursor:"pointer", textAlign:"left" as const,
              fontFamily:fontSans, transition:"all 0.2s ease",
              boxShadow:"0 2px 8px rgba(15,23,42,0.06)"}}
            onMouseOver={e => {
              e.currentTarget.style.borderColor = "rgba(37,99,235,0.6)";
              e.currentTarget.style.boxShadow = "0 8px 24px rgba(37,99,235,0.18)";
              e.currentTarget.style.transform = "translateY(-3px)";
            }}
            onMouseOut={e => {
              e.currentTarget.style.borderColor = "rgba(37,99,235,0.25)";
              e.currentTarget.style.boxShadow = "0 2px 8px rgba(15,23,42,0.06)";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
            <div style={{display:"flex", alignItems:"center", gap:10, marginBottom:12}}>
              <div style={{width:42, height:42, borderRadius:10,
                background:"linear-gradient(135deg,#2563EB,#1E40AF)",
                display:"flex", alignItems:"center", justifyContent:"center",
                boxShadow:"0 3px 10px rgba(37,99,235,0.30)"}}>
                <AxisIcon name="user_single" size={22} tone="white" withBackdrop={false} strokeWidth={2.5}/>
              </div>
              <div style={{fontSize:15, fontWeight:700, color:"#0F172A"}}>
                Individual
              </div>
            </div>
            <p style={{fontSize:12, color:"#475569", lineHeight:1.55, margin:"0 0 10px"}}>
              Entre la empresa (o patrón) y un solo trabajador. Conforme a la Ley Federal del Trabajo.
            </p>
            <div style={{fontSize:10.5, color:"#64748B", lineHeight:1.5, padding:"8px 10px",
              background:"rgba(37,99,235,0.05)", borderRadius:7,
              border:"1px solid rgba(37,99,235,0.15)"}}>
              <strong>Sub-modalidades:</strong><br/>
              • Tiempo indeterminado (Art. 35 LFT)<br/>
              • Tiempo determinado (Art. 37 LFT)<br/>
              • Por obra determinada (Art. 36 LFT)
            </div>
          </button>

          {/* Colectivo */}
          <button onClick={() => setModalidad("colectivo")}
            style={{background:"white", border:"2px solid rgba(67,56,202,0.25)", borderRadius:14,
              padding:"22px 18px", cursor:"pointer", textAlign:"left" as const,
              fontFamily:fontSans, transition:"all 0.2s ease",
              boxShadow:"0 2px 8px rgba(15,23,42,0.06)"}}
            onMouseOver={e => {
              e.currentTarget.style.borderColor = "rgba(67,56,202,0.6)";
              e.currentTarget.style.boxShadow = "0 8px 24px rgba(67,56,202,0.18)";
              e.currentTarget.style.transform = "translateY(-3px)";
            }}
            onMouseOut={e => {
              e.currentTarget.style.borderColor = "rgba(67,56,202,0.25)";
              e.currentTarget.style.boxShadow = "0 2px 8px rgba(15,23,42,0.06)";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
            <div style={{display:"flex", alignItems:"center", gap:10, marginBottom:12}}>
              <div style={{width:42, height:42, borderRadius:10,
                background:"linear-gradient(135deg,#4338CA,#3730A3)",
                display:"flex", alignItems:"center", justifyContent:"center",
                boxShadow:"0 3px 10px rgba(67,56,202,0.30)"}}>
                <AxisIcon name="suite_empleados" size={22} tone="white" withBackdrop={false} strokeWidth={2.5}/>
              </div>
              <div style={{fontSize:15, fontWeight:700, color:"#0F172A"}}>
                Colectivo
              </div>
            </div>
            <p style={{fontSize:12, color:"#475569", lineHeight:1.55, margin:"0 0 10px"}}>
              Entre la empresa y un sindicato legalmente constituido. Establece condiciones generales de trabajo para todos los trabajadores sindicalizados.
            </p>
            <div style={{fontSize:10.5, color:"#64748B", lineHeight:1.5, padding:"8px 10px",
              background:"rgba(67,56,202,0.05)", borderRadius:7,
              border:"1px solid rgba(67,56,202,0.15)"}}>
              <strong>Conforme a:</strong><br/>
              • Art. 386 y siguientes de la LFT<br/>
              • Arts. 399 y 399 BIS LFT (revisión)<br/>
              • Requiere depósito ante Tribunal Laboral
            </div>
          </button>
        </div>

        {/* Aviso */}
        <div style={{marginTop:20, padding:"12px 14px", background:"rgba(184,147,42,0.10)",
          border:"1px solid rgba(184,147,42,0.3)", borderRadius:10, display:"flex", gap:10}}>
          <AxisIcon name="info" size={16} tone="gold" withBackdrop={false} strokeWidth={3}/>
          <p style={{fontSize:11.5, color:"#374151", margin:0, lineHeight:1.5}}>
            Si tienes dudas sobre cuál aplicar, consulta con AXIS Asesoría Legal Corporativa. Los contratos colectivos requieren depósito ante el Tribunal Laboral del Estado para tener validez plena.
          </p>
        </div>
      </div>
    </div>
  );
}


// #region COLECTIVO TRABAJO
// ─── CONTRATO COLECTIVO DE TRABAJO ────────────────────────────────────────────
// Conforme a los artículos 386 y siguientes de la Ley Federal del Trabajo.
// Establece condiciones generales de trabajo entre EL PATRÓN (empresa) y EL
// SINDICATO. Las prestaciones son configurables vía toggles para reflejar lo
// que cada empresa puede ofrecer.
function SectionColectivo({title, children, fontSerif, isMobile}: {title:string; children:React.ReactNode; fontSerif:string; isMobile:boolean}) {
  return (
    <div style={{marginBottom:18}}>
      <div style={{fontFamily:fontSerif, fontSize:14, fontWeight:700, color:"#0F172A",
        marginBottom:10, paddingBottom:6, borderBottom:"1px solid rgba(67,56,202,0.3)",
        display:"flex", alignItems:"center", gap:8}}>
        <AxisIcon name="suite_empleados" size={14} color="#4338CA" withBackdrop={false} strokeWidth={3}/>
        {title}
      </div>
      <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr":"1fr 1fr", gap:10}}>
        {children}
      </div>
    </div>
  );
}

function ToggleColectivo({checked, onChange, label, hint}: {checked:boolean; onChange:(v:boolean)=>void; label:string; hint?:string}) {
  return (
    <div style={{padding:"8px 12px", background:"rgba(67,56,202,0.04)", borderRadius:8,
      border:"1px solid rgba(67,56,202,0.15)"}}>
      <label style={{display:"flex", alignItems:"flex-start", gap:8, cursor:"pointer", fontSize:12, color:"#374151"}}>
        <input type="checkbox" checked={checked} onChange={e => onChange(e.target.checked)} style={{marginTop:2}}/>
        <div>
          <strong>{label}</strong>
          {hint && <div style={{fontSize:10.5, color:"#64748B", marginTop:2, lineHeight:1.4}}>{hint}</div>}
        </div>
      </label>
    </div>
  );
}

function FormContratoColectivo({user, tipoContrato, onBack, fontSans, fontSerif, gold}: {user:any; tipoContrato:string; onBack:()=>void; fontSans:string; fontSerif:string; gold:string}) {
  // El pie de este documento lo firma el patrón, no la plataforma.
  const datosPatron = useDatosPatron(user?.uid).datos;
  const isMobile = window.innerWidth < 768;

  const [form, setForm] = useState({
    ciudad: "Aguascalientes, Ags.",
    fechaContrato: "",
    // EL PATRÓN
    razonSocial: "",
    repLegal: "",
    cargoRepLegal: "",
    rfcEmpresa: "",
    domicilioEmpresa: "",
    objetoSocial: "",
    // EL SINDICATO
    nombreSindicato: "",
    registroSindicato: "",
    seccionSindicato: "",
    secretarioGeneral: "",
    domicilioSindicato: "",
    // Ámbito
    centroTrabajo: "",
    categoriasTrabajadores: "",
    // Vigencia
    vigenciaTipo: "indefinido" as "indefinido"|"determinado",
    vigenciaMeses: "12",
    fechaRevisionMes: "abril",
    // Jornada
    jornadaHoras: "40",
    jornadaTipo: "diurna" as "diurna"|"nocturna"|"mixta",
    diasLaborables: "Lunes a viernes",
    horarioLaboral: "9:00 a 17:00 horas",
    // Salarios
    periodoPago: "quincenal" as "semanal"|"quincenal"|"mensual",
    cuotaSindical: "2",
    diaDescanso: "domingo",
    // Prestaciones (toggles)
    aguinaldoDias: "30",
    vacacionesDias: "20",
    primaVacacionalPct: "35",
    incluyePermisoNacimiento: true,
    diasNacimiento: "3",
    incluyePermisoDefuncion: true,
    diasDefuncion: "3",
    incluyeAsuntosPersonales: true,
    diasAsuntosPersonales: "2",
    incluyeValesDespensa: false,
    montoValesDespensa: "600",
    incluyeApoyoComida: false,
    montoApoyoComidaDiario: "60",
    incluyeFondoAhorro: false,
    pctFondoAhorro: "10",
    incluyeSeguroVida: false,
    factorSeguroVida: "40",
    incluyeGastosMedicos: false,
    incluyePremioPuntualidad: false,
    diasPremioPuntualidad: "30",
    incluyeCompensacionFinAno: false,
    diasCompensacionFinAno: "30",
    incluyeBonoNavideno: false,
    montoBonoNavideno: "1500",
    // Seguridad
    incluyeComisionSeguridad: true,
    incluyeCapacitacion: true,
    // Riesgos
    pctIncapacidadInicial: "100",
    diasIncapacidadInicial: "3",
    pctIncapacidadPosterior: "40",
    // Testigos
    nombreTestigo1: "",
    nombreTestigo2: "",
  });

  // PRELLENADO desde configuracion_empresa, y EDITABLE. Contrato de sociedad.
  // Se propone, no se impone; solo rellena lo que este vacio.
  useEffect(()=>{ let cancel=false; (async()=>{
    if (!user?.uid) return;
    try {
      const dpc = datosPatronDe(await leerConfigEmpresa(user.uid));
      if (cancel) return;
      const dom = domicilioPatronTexto(dpc);
      setForm((f:any)=>({...f,
        rfcEmpresa:      f.rfcEmpresa      || dpc.rfc,
        domicilioEmpresa:f.domicilioEmpresa|| dom,
      }));
    } catch(e){ /* sin datos capturados: el formulario se queda igual */ }
  })(); return ()=>{cancel=true;}; /* eslint-disable-next-line */ }, [user?.uid]);

  const [generando, setGenerando] = useState(false);
  const [ultimoBlob, setUltimoBlob] = useState<Blob|null>(null);
  const set = (k: string, v: any) => setForm(p => ({...p, [k]:v}));
  const F = (v: string) => v || "_______________________________";
  // FECHAS EN CASTELLANO, NO EN ISO. El campo guarda "2026-09-07" y eso salía
  // impreso tal cual en un contrato que se firma. `fechaLargaAxis` PARTE la
  // cadena en vez de construir un Date: `new Date("2026-09-01")` es medianoche
  // UTC, y en México eso es el 31 de agosto —el contrato imprimiría el día
  // anterior al pactado—. Si el valor no es una fecha ISO (hay campos de fecha
  // que son texto libre), se imprime tal como se escribió.
  const FF = (v: string) => fechaLargaAxis(v) || F(v);

  const fmt$ = (v: string) => {
    if (!v) return "_______________________________";
    const n = parseFloat(v);
    if (isNaN(n)) return v;
    return "$" + n.toLocaleString("es-MX", {minimumFractionDigits:2, maximumFractionDigits: 2}) + " M.N.";
  };

  const generarPDF = () => {
    setGenerando(true);
    setTimeout(() => {
      const { jsPDF } = (window as any).jspdf;
      const doc = new jsPDF({orientation:"portrait", unit:"mm", format:"letter"});
      const W = doc.internal.pageSize.getWidth();
      const H = doc.internal.pageSize.getHeight();
      const ML = 22, MR = 22;
      const usable = W - ML - MR;
      let y = 28;   // margen superior cómodo; el contrato inicia DIRECTO con su título (AXIS va al pie)

      const checkPage = (need = 8) => { if (y + need > H - 34) { doc.addPage(); y = 28; } };
      const titulo = (txt: string) => {
        checkPage(12);
        doc.setFont("times","bold"); doc.setFontSize(11); doc.setTextColor(11,24,41);
        doc.text(txt, W/2, y, {align:"center", maxWidth: usable}); y += 7;
      };
      const subtitulo = (txt: string) => {
        checkPage(30);   // mantiene el encabezado junto a su primer texto (evita viudas)
        doc.setFont("times","bold"); doc.setFontSize(10); doc.setTextColor(11,24,41);
        doc.text(txt, ML, y); y += 5;
      };
      const parrafo = (txt: string, opts?:{align?:"justify"|"left"|"center"; bold?:boolean; size?:number}) => {
        const fs = opts?.size || 9;
        doc.setFont("times", opts?.bold ? "bold" : "normal");
        doc.setFontSize(fs); doc.setTextColor(45,45,45);
        const lines = doc.splitTextToSize(txt, usable);
        for (const ln of lines) {
          checkPage(5);
          doc.text(ln, ML, y, {align: opts?.align==="center" ? "center" : "left", maxWidth: usable});
          y += fs*0.42 + 1.2;
        }
        y += 1;
      };
      const capitulo = (num: string, txt: string) => {
        checkPage(14);
        y += 3;
        doc.setFont("times","bold"); doc.setFontSize(10); doc.setTextColor(11,24,41);
        doc.text(`CAPÍTULO ${num} — ${txt}`, W/2, y, {align:"center", maxWidth: usable});
        y += 6;
      };

      // ───── ENCABEZADO ─────
      titulo("CONTRATO COLECTIVO DE TRABAJO");

      parrafo(
        `Contrato colectivo de trabajo que celebran por una parte la sociedad denominada ${F(form.razonSocial).toUpperCase()}, a quien en lo sucesivo se le denominará "EL PATRÓN", representada en este acto por ${F(form.repLegal)}, en su carácter de ${F(form.cargoRepLegal)}, y por la otra parte ${F(form.nombreSindicato).toUpperCase()}, al que en lo sucesivo se le denominará "EL SINDICATO", representado por su Secretario General ${F(form.secretarioGeneral)}${form.seccionSindicato ? `, respecto de la sección ${form.seccionSindicato}` : ""}, de conformidad con las siguientes declaraciones y cláusulas:`,
        {align:"justify"}
      );

      // ───── DECLARACIONES ─────
      subtitulo("DECLARACIONES");

      parrafo("PRIMERA. EL PATRÓN DECLARA:", {bold:true});
      parrafo(`a) Ser una sociedad legalmente constituida conforme a las leyes mexicanas, con Registro Federal de Contribuyentes ${F(form.rfcEmpresa)}.`);
      if (form.objetoSocial) parrafo(`b) Que su objeto social comprende: ${form.objetoSocial}.`);
      parrafo(`${form.objetoSocial ? "c" : "b"}) Que opera en el centro de trabajo ubicado en ${F(form.centroTrabajo)}, motivo por el cual celebra el presente contrato colectivo de trabajo, con el fin de buscar el equilibrio entre los factores de la producción y regular las relaciones laborales que se establezcan en este centro de trabajo.`);
      parrafo(`${form.objetoSocial ? "d" : "c"}) Tener su domicilio para efectos legales en ${F(form.domicilioEmpresa)}.`);

      parrafo("SEGUNDA. EL SINDICATO DECLARA:", {bold:true});
      parrafo(`a) Ser un sindicato legalmente constituido y reconocido por la Secretaría del Trabajo y Previsión Social, registrado con el número ${F(form.registroSindicato)}.`);
      parrafo(`b) Conocer el centro de trabajo señalado por EL PATRÓN y, en atención a que representa el interés colectivo de los trabajadores${form.seccionSindicato ? ` de la sección ${form.seccionSindicato}` : ""}, celebra el presente contrato colectivo para regular las relaciones laborales en el centro de trabajo mencionado.`);
      parrafo(`c) Tener su domicilio para notificaciones en ${F(form.domicilioSindicato)}.`);

      parrafo("Expuesto lo anterior, ambas partes se sujetan a las siguientes:", {align:"justify"});

      // ───── CLÁUSULAS ─────
      checkPage(12);
      y += 2;
      doc.setFont("times","bold"); doc.setFontSize(11); doc.setTextColor(11,24,41);
      doc.text("CLÁUSULAS", W/2, y, {align:"center"}); y += 7;

      // CAPÍTULO I — DISPOSICIONES GENERALES
      capitulo("I", "DISPOSICIONES GENERALES");

      parrafo("PRIMERA. RECONOCIMIENTO MUTUO.", {bold:true});
      parrafo("Los representantes de las partes convienen en reconocerse mutuamente la personalidad jurídica con la que se ostentan, con todas sus consecuencias legales inherentes.", {align:"justify"});

      parrafo("SEGUNDA. OBJETO.", {bold:true});
      parrafo(`El presente contrato colectivo de trabajo tiene por objeto establecer las condiciones generales de trabajo conforme a las cuales deberán prestar sus servicios a EL PATRÓN los trabajadores sindicalizados${form.categoriasTrabajadores ? ` que desempeñen las siguientes categorías: ${form.categoriasTrabajadores}` : ""}.`, {align:"justify"});

      parrafo("TERCERA. ÁMBITO DE APLICACIÓN.", {bold:true});
      parrafo("El presente contrato colectivo afectará exclusivamente a los trabajadores cuya categoría esté amparada en este documento y sus anexos. Las partes convienen expresamente en que el personal de confianza queda excluido de la aplicación del presente contrato.", {align:"justify"});

      parrafo("CUARTA. PUESTOS DE CONFIANZA.", {bold:true});
      parrafo("Las partes convienen en considerar como puestos de confianza, de manera enunciativa pero no limitativa: gerente, subgerentes, jefes de departamento, supervisores, coordinadores, secretarias y, en general, aquellos puestos que comprenden labores de vigilancia, fiscalización, supervisión o dirección.", {align:"justify"});

      parrafo("QUINTA. VIGENCIA.", {bold:true});
      const vigenciaTexto = form.vigenciaTipo === "indefinido"
        ? `La duración del presente contrato colectivo será por tiempo indefinido. Las normas que contiene serán revisables en su renglón contractual y/o salarial, según sea el caso, el día primero de ${form.fechaRevisionMes} de cada año, observándose lo establecido en los artículos 399 y 399 BIS de la Ley Federal del Trabajo.`
        : `La duración del presente contrato colectivo será de ${F(form.vigenciaMeses)} meses contados a partir de su firma, prorrogable por mutuo acuerdo expreso por escrito.`;
      parrafo(vigenciaTexto, {align:"justify"});

      parrafo("SEXTA. DERECHO DE LIBRE CONTRATACIÓN.", {bold:true});
      parrafo("EL SINDICATO reconoce de manera expresa que EL PATRÓN tiene el pleno derecho para celebrar libremente toda clase de contratos civiles, mercantiles y, en general, los necesarios para el eficiente desempeño de sus actividades.", {align:"justify"});

      // CAPÍTULO II — DEL SINDICATO
      capitulo("II", "DEL SINDICATO");

      parrafo("SÉPTIMA. RECONOCIMIENTO DEL SINDICATO.", {bold:true});
      parrafo("EL PATRÓN reconoce a EL SINDICATO como el único representante genuino del interés profesional de los trabajadores sindicalizados a que se refiere la cláusula SEGUNDA del presente contrato.", {align:"justify"});

      parrafo("OCTAVA. CUOTAS SINDICALES.", {bold:true});
      parrafo(`EL PATRÓN se obliga a descontar de los salarios de los trabajadores, por concepto de cuotas sindicales ordinarias, el ${F(form.cuotaSindical)}% del salario base ordinario, quedando entendido que por este servicio EL PATRÓN no cobrará cantidad alguna. Dichas cantidades serán entregadas a EL SINDICATO.`, {align:"justify"});

      // CAPÍTULO III — JORNADA Y SALARIOS
      capitulo("III", "JORNADA DE TRABAJO Y SALARIOS");

      parrafo("NOVENA. JORNADA DE TRABAJO.", {bold:true});
      parrafo(`La jornada de trabajo será ${F(form.jornadaTipo)} y su duración será de ${F(form.jornadaHoras)} horas a la semana, distribuidas de ${F(form.diasLaborables)}, en horario de ${F(form.horarioLaboral)}.`, {align:"justify"});

      parrafo("DÉCIMA. PRÓRROGAS DE JORNADA.", {bold:true});
      parrafo("La jornada de trabajo podrá prorrogarse por circunstancias extraordinarias, sin exceder de tres horas en un día, ni de tres veces a la semana, conforme al artículo 66 de la Ley Federal del Trabajo. El tiempo extraordinario se pagará en términos del artículo 67 de la misma ley.", {align:"justify"});

      parrafo("DÉCIMA PRIMERA. PAGO DE SALARIOS.", {bold:true});
      parrafo(`El pago de los salarios de los trabajadores se hará de manera ${F(form.periodoPago)}, conforme a los tabuladores aprobados por las partes. EL PATRÓN queda facultado para efectuar los descuentos de ley por impuestos federales, cuotas del IMSS, INFONAVIT y demás obligaciones a cargo de los trabajadores.`, {align:"justify"});

      // CAPÍTULO IV — DESCANSOS, VACACIONES Y PERMISOS
      capitulo("IV", "DESCANSOS, VACACIONES Y PERMISOS");

      parrafo("DÉCIMA SEGUNDA. DÍAS DE DESCANSO.", {bold:true});
      parrafo(`EL PATRÓN concederá a sus trabajadores con goce de salario íntegro los días de descanso obligatorios señalados en el artículo 74 de la Ley Federal del Trabajo, así como un día de descanso semanal con goce de salario íntegro, procurando que sea el ${F(form.diaDescanso)}.`, {align:"justify"});

      parrafo("DÉCIMA TERCERA. VACACIONES.", {bold:true});
      parrafo(`Los trabajadores amparados por este contrato disfrutarán anualmente de ${F(form.vacacionesDias)} días de vacaciones, aumentándose en términos del artículo 76 de la Ley Federal del Trabajo conforme a la antigüedad del trabajador.`, {align:"justify"});

      parrafo("DÉCIMA CUARTA. PRIMA VACACIONAL.", {bold:true});
      parrafo(`Conforme al artículo 80 de la Ley Federal del Trabajo, EL PATRÓN se obliga a pagar por concepto de prima vacacional la cantidad que resulte sobre la base de un ${F(form.primaVacacionalPct)}% del salario, multiplicado por el número de días que corresponda gozar al trabajador.`, {align:"justify"});

      const permisosArr: string[] = [];
      if (form.incluyePermisoNacimiento) permisosArr.push(`${F(form.diasNacimiento)} días por nacimiento de hijo`);
      if (form.incluyePermisoDefuncion) permisosArr.push(`${F(form.diasDefuncion)} días por defunción de padres, cónyuge o hijos`);
      if (form.incluyeAsuntosPersonales) permisosArr.push(`${F(form.diasAsuntosPersonales)} días al año para atender asuntos personales`);

      if (permisosArr.length > 0) {
        parrafo("DÉCIMA QUINTA. PERMISOS CON GOCE DE SALARIO.", {bold:true});
        parrafo(`EL PATRÓN concederá los siguientes permisos con goce de salario: ${permisosArr.join("; ")}.`, {align:"justify"});
      }

      // CAPÍTULO V — SEGURIDAD E HIGIENE
      if (form.incluyeComisionSeguridad || form.incluyeCapacitacion) {
        capitulo("V", "SEGURIDAD, HIGIENE Y CAPACITACIÓN");

        if (form.incluyeComisionSeguridad) {
          parrafo("DÉCIMA SEXTA. COMISIÓN DE SEGURIDAD E HIGIENE.", {bold:true});
          parrafo("Las partes, a fin de evitar actos y condiciones inseguros en el centro de trabajo, se comprometen a integrar la Comisión Mixta de Seguridad e Higiene, con un representante de cada una, conforme al artículo 509 de la Ley Federal del Trabajo.", {align:"justify"});
        }

        if (form.incluyeCapacitacion) {
          parrafo("DÉCIMA SÉPTIMA. CAPACITACIÓN Y ADIESTRAMIENTO.", {bold:true});
          parrafo("Las partes formularán e implementarán un plan y programa de capacitación y adiestramiento conforme a los artículos 153-A a 153-X de la Ley Federal del Trabajo. Se integrará una Comisión Mixta de Capacitación y Adiestramiento.", {align:"justify"});
        }
      }

      // CAPÍTULO VI — RIESGOS Y PRESTACIONES
      capitulo("VI", "RIESGOS DE TRABAJO Y PRESTACIONES");

      parrafo("DÉCIMA OCTAVA. INCAPACIDADES.", {bold:true});
      parrafo(`EL PATRÓN se obliga a pagar a los trabajadores el ${F(form.pctIncapacidadInicial)}% de su salario dentro de los ${F(form.diasIncapacidadInicial)} primeros días de incapacidad por enfermedad general, y el ${F(form.pctIncapacidadPosterior)}% a partir del cuarto día, sin perjuicio de las prestaciones del IMSS.`, {align:"justify"});

      const prestaciones: string[] = [];
      if (form.incluyeSeguroVida) prestaciones.push(`SEGURO DE VIDA: EL PATRÓN proporcionará a los trabajadores un seguro de vida por la cantidad que resulte de ${F(form.factorSeguroVida)} veces el salario mensual, ya sea por muerte natural o accidental`);
      if (form.incluyeGastosMedicos) prestaciones.push(`GASTOS MÉDICOS MAYORES: EL PATRÓN otorgará a los trabajadores una póliza de gastos médicos mayores en los términos y políticas establecidas por EL PATRÓN`);
      if (form.incluyeApoyoComida) prestaciones.push(`APOYO PARA ALIMENTACIÓN: EL PATRÓN proporcionará a cada trabajador un apoyo para alimentación de ${fmt$(form.montoApoyoComidaDiario)} netos por día laborado, en vales de comida canjeables en restaurantes`);
      if (form.incluyeValesDespensa) prestaciones.push(`VALES DE DESPENSA: EL PATRÓN entregará mensualmente a los trabajadores vales de despensa por la cantidad de ${fmt$(form.montoValesDespensa)}, canjeables en establecimientos autorizados`);
      if (form.incluyeFondoAhorro) prestaciones.push(`FONDO DE AHORRO: Las partes convienen en establecer un fondo de ahorro que se constituirá con el ${F(form.pctFondoAhorro)}% del salario del trabajador, aportando EL PATRÓN una cantidad igual. El ahorro y los intereses se entregarán anualmente`);
      if (form.incluyeBonoNavideno) prestaciones.push(`CONVIVIO DE FIN DE AÑO: EL PATRÓN otorgará en el mes de diciembre de cada año la cantidad de ${fmt$(form.montoBonoNavideno)} a cada trabajador para realizar un convivio de fin de año`);

      if (prestaciones.length > 0) {
        let claveCl = 19;
        prestaciones.forEach(p => {
          const num = claveCl === 19 ? "DÉCIMA NOVENA" : claveCl === 20 ? "VIGÉSIMA" : claveCl === 21 ? "VIGÉSIMA PRIMERA" : claveCl === 22 ? "VIGÉSIMA SEGUNDA" : claveCl === 23 ? "VIGÉSIMA TERCERA" : claveCl === 24 ? "VIGÉSIMA CUARTA" : "VIGÉSIMA " + claveCl;
          const titulo = p.split(":")[0];
          const cuerpo = p.split(":").slice(1).join(":").trim();
          parrafo(`${num}. ${titulo}.`, {bold:true});
          parrafo(cuerpo, {align:"justify"});
          claveCl++;
        });
      }

      // CAPÍTULO VII — AGUINALDO Y PREMIOS
      capitulo("VII", "AGUINALDO Y PREMIOS");

      parrafo("AGUINALDO.", {bold:true});
      parrafo(`Conforme al artículo 87 de la Ley Federal del Trabajo, EL PATRÓN se obliga a entregar antes del día 20 de diciembre de cada año, el equivalente a ${F(form.aguinaldoDias)} días de salario por concepto de aguinaldo. Para los trabajadores con menos de un año de servicio, esta prestación se otorgará en forma proporcional al tiempo laborado.`, {align:"justify"});

      if (form.incluyeCompensacionFinAno) {
        parrafo("COMPENSACIÓN EXTRAORDINARIA.", {bold:true});
        parrafo(`EL PATRÓN otorgará en el mes de diciembre de cada año el equivalente a ${F(form.diasCompensacionFinAno)} días de salario por concepto de compensación extraordinaria, siempre y cuando el trabajador tenga un año completo de servicio.`, {align:"justify"});
      }

      if (form.incluyePremioPuntualidad) {
        parrafo("PREMIO DE PUNTUALIDAD Y ASISTENCIA.", {bold:true});
        parrafo(`EL PATRÓN otorgará anualmente a los trabajadores que cumplan con los lineamientos establecidos, el equivalente a ${F(form.diasPremioPuntualidad)} días de salario por concepto de premio de puntualidad y asistencia.`, {align:"justify"});
      }

      // CLÁUSULA FINAL
      checkPage(12);
      y += 3;
      parrafo("JURISDICCIÓN.", {bold:true});
      parrafo("Para la interpretación, cumplimiento y ejecución del presente contrato colectivo, las partes se someten expresamente a las leyes laborales aplicables y a la jurisdicción de los Tribunales Laborales del Estado de Aguascalientes.", {align:"justify"});

      parrafo("Enteradas las partes del alcance, contenido y fuerza legal de este contrato colectivo de trabajo, lo otorgan y firman de conformidad para su debido depósito ante el Tribunal Laboral correspondiente.", {align:"justify"});

      // ───── FIRMAS ─────
      checkPage(45);
      y += 6;
      doc.setFont("times","bold"); doc.setFontSize(9); doc.setTextColor(11,24,41);
      doc.text(`Firmado en ${F(form.ciudad)} el día ${FF(form.fechaContrato)}.`, W/2, y, {align:"center"});
      y += 14;

      const colW = (usable - 8) / 2;
      const x1 = ML;
      const x2 = ML + colW + 8;
      doc.setDrawColor(11,24,41);
      doc.setLineWidth(0.3);
      doc.line(x1+8, y, x1+colW-8, y);
      doc.line(x2+8, y, x2+colW-8, y);
      y += 4;
      doc.setFont("times","bold"); doc.setFontSize(8);
      doc.text("POR EL PATRÓN", x1+colW/2, y, {align:"center"});
      doc.text("POR EL SINDICATO", x2+colW/2, y, {align:"center"});
      y += 4;
      doc.setFont("times","normal");
      doc.text(F(form.razonSocial), x1+colW/2, y, {align:"center"});
      doc.text(F(form.nombreSindicato), x2+colW/2, y, {align:"center"});
      y += 3.5;
      doc.setFontSize(7);
      doc.text(`Rep: ${F(form.repLegal)}`, x1+colW/2, y, {align:"center"});
      doc.text(`Sec. Gral: ${F(form.secretarioGeneral)}`, x2+colW/2, y, {align:"center"});

      // Testigos
      if (form.nombreTestigo1 || form.nombreTestigo2) {
        y += 14;
        checkPage(20);
        doc.line(x1+8, y, x1+colW-8, y);
        doc.line(x2+8, y, x2+colW-8, y);
        y += 4;
        doc.setFont("times","bold"); doc.setFontSize(8);
        doc.text("TESTIGO 1", x1+colW/2, y, {align:"center"});
        doc.text("TESTIGO 2", x2+colW/2, y, {align:"center"});
        y += 4;
        doc.setFont("times","normal");
        doc.text(F(form.nombreTestigo1), x1+colW/2, y, {align:"center"});
        doc.text(F(form.nombreTestigo2), x2+colW/2, y, {align:"center"});
      }

      // Footer
      const totalPages = doc.internal.pages.length - 1;
      for (let p = 1; p <= totalPages; p++) {
        doc.setPage(p);
        doc.setFont("times","italic"); doc.setFontSize(7);
        doc.setTextColor(120,120,120);
        pintarLeyendaContrato(doc, W/2, H-13.5, W-ML-MR, "center");
        doc.text(pieDelPatron(datosPatron, fechaHoraLargaAxis()), W/2, H-10, {align:"center"});
        doc.text(`Página ${p} de ${totalPages}`, W-MR, H-10, {align:"right"});
      }

      const fname = `Contrato_Colectivo_${(form.razonSocial || "empresa").replace(/[^A-Za-z0-9]/g,"_")}.pdf`;
      doc.save(fname);
      try { setUltimoBlob(doc.output("blob")); } catch {}
      setGenerando(false);
    }, 200);
  };

  const inputStyle: React.CSSProperties = {
    width:"100%", padding:"9px 11px", fontSize:13, fontFamily:fontSans,
    background:"white", border:"1px solid #D1D5DB", borderRadius:8, color:"#0F172A",
    boxSizing:"border-box" as const,
  };
  const labelStyle: React.CSSProperties = {
    display:"block", fontSize:11, fontWeight:600, color:"#374151", marginBottom:4,
    letterSpacing:"0.2px",
  };

  const camposObligatoriosLlenos = !!(
    form.fechaContrato && form.razonSocial && form.repLegal &&
    form.nombreSindicato && form.secretarioGeneral && form.centroTrabajo
  );

  return (
    <div {...ZONA_DE_CAPTURA} style={{minHeight:"100vh", background:T_LIGHT.canvas, fontFamily:fontSans}}>
      {/* Header */}
      <div style={{background:"linear-gradient(135deg,#4338CA,#3730A3)", padding:"0 20px", height:58,
        display:"flex", alignItems:"center", gap:12, position:"sticky" as const, top:0, zIndex:100,
        boxShadow:"0 4px 20px rgba(67,56,202,0.30)"}}>
        <button onClick={onBack}
          style={{background:"rgba(255,255,255,0.18)", border:"1px solid rgba(255,255,255,0.30)",
            color:"white", borderRadius:8, padding:"5px 11px", cursor:"pointer",
            fontSize:12, fontWeight:600}}>← Modalidad</button>
        <span style={{color:"white", fontWeight:700, fontSize:isMobile?12:14, display:"flex",
          alignItems:"center", gap:8}}>
          <AxisIcon name="suite_empleados" size={18} tone="white" withBackdrop={false} strokeWidth={2.5}/>
          Contrato Colectivo de Trabajo
        </span>
      </div>

      <div style={{maxWidth:760, margin:"0 auto", padding:isMobile?"16px":"24px"}}>
        <p style={{fontSize:12, color:"#64748B", margin:"0 0 6px", lineHeight:1.6}}>
          Conforme a los artículos 386 y siguientes de la Ley Federal del Trabajo. Establece condiciones generales entre EL PATRÓN y EL SINDICATO.
        </p>

        {/* Aviso destacado al inicio */}
        <div style={{background:"rgba(67,56,202,0.08)", border:"1px solid rgba(67,56,202,0.30)",
          borderRadius:10, padding:"12px 14px", marginBottom:18, display:"flex", gap:10}}>
          <AxisIcon name="info" size={18} color="#4338CA" withBackdrop={false} strokeWidth={3}/>
          <div style={{fontSize:11.5, color:"#374151", lineHeight:1.55}}>
            <strong>Importante:</strong> el contrato colectivo debe depositarse ante el <strong>Tribunal Laboral del Estado</strong> para tener validez plena (Art. 390 LFT). El presente formulario genera la plantilla; el depósito y trámite los realiza un abogado laboral o el propio sindicato.
          </div>
        </div>

        <p style={{fontSize:12, color:"#64748B", margin:"0 0 18px", lineHeight:1.6}}>
          Completa los datos. Los campos marcados con <span style={{color:"#DC2626"}}>*</span> son indispensables.
        </p>

        {/* Datos generales */}
        <SectionColectivo title="Datos generales" fontSerif={fontSerif} isMobile={isMobile}>
          <div>
            <label style={labelStyle}>Ciudad y estado de firma <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" style={inputStyle} value={form.ciudad} onChange={e => set("ciudad", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Fecha de firma <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" type="date" style={inputStyle} value={form.fechaContrato} onChange={e => set("fechaContrato", e.target.value)}/>
          </div>
        </SectionColectivo>

        {/* EL PATRÓN */}
        <SectionColectivo title="EL PATRÓN (la empresa)" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Razón social <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" style={inputStyle} value={form.razonSocial} onChange={e => set("razonSocial", e.target.value)}
              placeholder="EMPRESA EJEMPLO S.A. DE C.V."/>
          </div>
          <div>
            <label style={labelStyle}>Representante legal <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" style={inputStyle} value={form.repLegal} onChange={e => set("repLegal", e.target.value)}
              placeholder="Lic. Juan Pérez García"/>
          </div>
          <div>
            <label style={labelStyle}>Cargo del representante</label>
            <input autoComplete="off" style={inputStyle} value={form.cargoRepLegal} onChange={e => set("cargoRepLegal", e.target.value)}
              placeholder="Director General, Director de Administración..."/>
          </div>
          <div>
            <label style={labelStyle}>RFC</label>
            <input autoComplete="off" style={inputStyle} value={form.rfcEmpresa} onChange={e => set("rfcEmpresa", e.target.value)}/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Domicilio fiscal de la empresa</label>
            <input autoComplete="off" style={inputStyle} value={form.domicilioEmpresa} onChange={e => set("domicilioEmpresa", e.target.value)}/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Objeto social (opcional)</label>
            <textarea autoComplete="off" style={{...inputStyle, minHeight:55, resize:"vertical" as const}} value={form.objetoSocial}
              onChange={e => set("objetoSocial", e.target.value)}
              placeholder="Producción y comercialización de..."/>
          </div>
        </SectionColectivo>

        {/* EL SINDICATO */}
        <SectionColectivo title="EL SINDICATO" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Nombre completo del sindicato <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" style={inputStyle} value={form.nombreSindicato} onChange={e => set("nombreSindicato", e.target.value)}
              placeholder="Sindicato Nacional de Trabajadores de la Industria..."/>
          </div>
          <div>
            <label style={labelStyle}>Registro ante STPS</label>
            <input autoComplete="off" style={inputStyle} value={form.registroSindicato} onChange={e => set("registroSindicato", e.target.value)}
              placeholder="Número de registro federal"/>
          </div>
          <div>
            <label style={labelStyle}>Sección o seccional (si aplica)</label>
            <input autoComplete="off" style={inputStyle} value={form.seccionSindicato} onChange={e => set("seccionSindicato", e.target.value)}
              placeholder="Sección Aguascalientes"/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Secretario General <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" style={inputStyle} value={form.secretarioGeneral} onChange={e => set("secretarioGeneral", e.target.value)}/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Domicilio para notificaciones</label>
            <input autoComplete="off" style={inputStyle} value={form.domicilioSindicato} onChange={e => set("domicilioSindicato", e.target.value)}/>
          </div>
        </SectionColectivo>

        {/* Ámbito */}
        <SectionColectivo title="Ámbito de aplicación" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Centro de trabajo (dirección) <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" style={inputStyle} value={form.centroTrabajo} onChange={e => set("centroTrabajo", e.target.value)}
              placeholder="Calle ___, No. ___, Colonia ___, Aguascalientes, Ags."/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Categorías de trabajadores cubiertos</label>
            <textarea autoComplete="off" style={{...inputStyle, minHeight:55, resize:"vertical" as const}} value={form.categoriasTrabajadores}
              onChange={e => set("categoriasTrabajadores", e.target.value)}
              placeholder="Operadores de máquina, supervisores de línea, almacenistas, choferes..."/>
          </div>
        </SectionColectivo>

        {/* Vigencia */}
        <SectionColectivo title="Vigencia" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>Tipo de vigencia</label>
            <div style={{display:"flex", gap:8}}>
              {(["indefinido","determinado"] as const).map(t => (
                <button key={t} onClick={() => set("vigenciaTipo", t)}
                  style={{flex:1, padding:"9px 12px", borderRadius:8, fontSize:12, fontWeight:600,
                    fontFamily:fontSans, cursor:"pointer",
                    background: form.vigenciaTipo===t ? "#4338CA" : "white",
                    color: form.vigenciaTipo===t ? "white" : "#374151",
                    border: form.vigenciaTipo===t ? "1px solid #4338CA" : "1px solid #D1D5DB"}}>
                  {t === "indefinido" ? "Tiempo indefinido (estándar)" : "Tiempo determinado"}
                </button>
              ))}
            </div>
          </div>
          {form.vigenciaTipo === "determinado" && (
            <div>
              <label style={labelStyle}>Duración (meses)</label>
              <input autoComplete="off" type="number" style={inputStyle} value={form.vigenciaMeses} onChange={e => set("vigenciaMeses", e.target.value)}/>
            </div>
          )}
          {form.vigenciaTipo === "indefinido" && (
            <div>
              <label style={labelStyle}>Mes de revisión anual</label>
              <select style={inputStyle} value={form.fechaRevisionMes} onChange={e => set("fechaRevisionMes", e.target.value)}>
                <option value="enero">Enero</option>
                <option value="febrero">Febrero</option>
                <option value="marzo">Marzo</option>
                <option value="abril">Abril</option>
                <option value="mayo">Mayo</option>
                <option value="junio">Junio</option>
                <option value="julio">Julio</option>
              </select>
            </div>
          )}
        </SectionColectivo>

        {/* Jornada */}
        <SectionColectivo title="Jornada de trabajo" fontSerif={fontSerif} isMobile={isMobile}>
          <div>
            <label style={labelStyle}>Horas semanales</label>
            <input autoComplete="off" type="number" style={inputStyle} value={form.jornadaHoras} onChange={e => set("jornadaHoras", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Tipo de jornada</label>
            <select style={inputStyle} value={form.jornadaTipo} onChange={e => set("jornadaTipo", e.target.value)}>
              <option value="diurna">Diurna</option>
              <option value="nocturna">Nocturna</option>
              <option value="mixta">Mixta</option>
            </select>
          </div>
          <div>
            <label style={labelStyle}>Días laborables</label>
            <input autoComplete="off" style={inputStyle} value={form.diasLaborables} onChange={e => set("diasLaborables", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Horario laboral</label>
            <input autoComplete="off" style={inputStyle} value={form.horarioLaboral} onChange={e => set("horarioLaboral", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Día de descanso semanal</label>
            <input autoComplete="off" style={inputStyle} value={form.diaDescanso} onChange={e => set("diaDescanso", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Periodo de pago</label>
            <select style={inputStyle} value={form.periodoPago} onChange={e => set("periodoPago", e.target.value)}>
              <option value="semanal">Semanal</option>
              <option value="quincenal">Quincenal</option>
              <option value="mensual">Mensual</option>
            </select>
          </div>
        </SectionColectivo>

        {/* Cuotas sindicales */}
        <SectionColectivo title="Cuotas sindicales" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyle}>% del salario base como cuota sindical</label>
            <input autoComplete="off" type="number" step="0.5" style={inputStyle} value={form.cuotaSindical} onChange={e => set("cuotaSindical", e.target.value)}/>
            <p style={{fontSize:10, color:"#64748B", margin:"4px 0 0"}}>Típico: 1-2% del salario base ordinario</p>
          </div>
        </SectionColectivo>

        {/* Prestaciones obligatorias */}
        <SectionColectivo title="Prestaciones obligatorias (LFT)" fontSerif={fontSerif} isMobile={isMobile}>
          <div>
            <label style={labelStyle}>Días de aguinaldo</label>
            <input autoComplete="off" type="number" style={inputStyle} value={form.aguinaldoDias} onChange={e => set("aguinaldoDias", e.target.value)}/>
            <p style={{fontSize:10, color:"#64748B", margin:"4px 0 0"}}>Mínimo legal: 15 días. Estándar: 30</p>
          </div>
          <div>
            <label style={labelStyle}>Vacaciones iniciales (días)</label>
            <input autoComplete="off" type="number" style={inputStyle} value={form.vacacionesDias} onChange={e => set("vacacionesDias", e.target.value)}/>
            <p style={{fontSize:10, color:"#64748B", margin:"4px 0 0"}}>Mínimo legal: 12 días</p>
          </div>
          <div>
            <label style={labelStyle}>Prima vacacional (%)</label>
            <input autoComplete="off" type="number" style={inputStyle} value={form.primaVacacionalPct} onChange={e => set("primaVacacionalPct", e.target.value)}/>
            <p style={{fontSize:10, color:"#64748B", margin:"4px 0 0"}}>Mínimo legal: 25%</p>
          </div>
          <div>
            <label style={labelStyle}>% incapacidad inicial (primeros días)</label>
            <input autoComplete="off" type="number" style={inputStyle} value={form.pctIncapacidadInicial} onChange={e => set("pctIncapacidadInicial", e.target.value)}/>
          </div>
        </SectionColectivo>

        {/* Permisos con goce de salario */}
        <SectionColectivo title="Permisos con goce de salario" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <ToggleColectivo checked={form.incluyePermisoNacimiento}
              onChange={v => set("incluyePermisoNacimiento", v)}
              label="Permiso por nacimiento de hijo"
              hint="Días con goce de salario para el padre"/>
          </div>
          {form.incluyePermisoNacimiento && (
            <div>
              <label style={labelStyle}>Días por nacimiento</label>
              <input autoComplete="off" type="number" style={inputStyle} value={form.diasNacimiento} onChange={e => set("diasNacimiento", e.target.value)}/>
            </div>
          )}
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <ToggleColectivo checked={form.incluyePermisoDefuncion}
              onChange={v => set("incluyePermisoDefuncion", v)}
              label="Permiso por defunción de familiar directo"
              hint="Padres, cónyuge o hijos"/>
          </div>
          {form.incluyePermisoDefuncion && (
            <div>
              <label style={labelStyle}>Días por defunción</label>
              <input autoComplete="off" type="number" style={inputStyle} value={form.diasDefuncion} onChange={e => set("diasDefuncion", e.target.value)}/>
            </div>
          )}
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <ToggleColectivo checked={form.incluyeAsuntosPersonales}
              onChange={v => set("incluyeAsuntosPersonales", v)}
              label="Días anuales para asuntos personales"/>
          </div>
          {form.incluyeAsuntosPersonales && (
            <div>
              <label style={labelStyle}>Días al año</label>
              <input autoComplete="off" type="number" style={inputStyle} value={form.diasAsuntosPersonales} onChange={e => set("diasAsuntosPersonales", e.target.value)}/>
            </div>
          )}
        </SectionColectivo>

        {/* Prestaciones adicionales */}
        <SectionColectivo title="Prestaciones adicionales (opcionales)" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <ToggleColectivo checked={form.incluyeValesDespensa}
              onChange={v => set("incluyeValesDespensa", v)}
              label="Vales de despensa mensuales"/>
          </div>
          {form.incluyeValesDespensa && (
            <div>
              <label style={labelStyle}>Monto mensual (MXN)</label>
              <input autoComplete="off" type="number" style={inputStyle} value={form.montoValesDespensa} onChange={e => set("montoValesDespensa", e.target.value)}/>
            </div>
          )}
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <ToggleColectivo checked={form.incluyeApoyoComida}
              onChange={v => set("incluyeApoyoComida", v)}
              label="Apoyo para alimentación (vales de comida)"/>
          </div>
          {form.incluyeApoyoComida && (
            <div>
              <label style={labelStyle}>Monto diario (MXN)</label>
              <input autoComplete="off" type="number" style={inputStyle} value={form.montoApoyoComidaDiario} onChange={e => set("montoApoyoComidaDiario", e.target.value)}/>
            </div>
          )}
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <ToggleColectivo checked={form.incluyeFondoAhorro}
              onChange={v => set("incluyeFondoAhorro", v)}
              label="Fondo de ahorro (con aportación del patrón)"/>
          </div>
          {form.incluyeFondoAhorro && (
            <div>
              <label style={labelStyle}>% del salario</label>
              <input autoComplete="off" type="number" style={inputStyle} value={form.pctFondoAhorro} onChange={e => set("pctFondoAhorro", e.target.value)}/>
            </div>
          )}
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <ToggleColectivo checked={form.incluyeSeguroVida}
              onChange={v => set("incluyeSeguroVida", v)}
              label="Seguro de vida"
              hint="Por muerte natural o accidental"/>
          </div>
          {form.incluyeSeguroVida && (
            <div>
              <label style={labelStyle}>Factor (veces el salario mensual)</label>
              <input autoComplete="off" type="number" style={inputStyle} value={form.factorSeguroVida} onChange={e => set("factorSeguroVida", e.target.value)}/>
            </div>
          )}
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <ToggleColectivo checked={form.incluyeGastosMedicos}
              onChange={v => set("incluyeGastosMedicos", v)}
              label="Póliza de gastos médicos mayores"/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <ToggleColectivo checked={form.incluyeBonoNavideno}
              onChange={v => set("incluyeBonoNavideno", v)}
              label="Convivio o bono de fin de año"/>
          </div>
          {form.incluyeBonoNavideno && (
            <div>
              <label style={labelStyle}>Monto por trabajador (MXN)</label>
              <input autoComplete="off" type="number" style={inputStyle} value={form.montoBonoNavideno} onChange={e => set("montoBonoNavideno", e.target.value)}/>
            </div>
          )}
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <ToggleColectivo checked={form.incluyePremioPuntualidad}
              onChange={v => set("incluyePremioPuntualidad", v)}
              label="Premio anual de puntualidad y asistencia"/>
          </div>
          {form.incluyePremioPuntualidad && (
            <div>
              <label style={labelStyle}>Días de salario</label>
              <input autoComplete="off" type="number" style={inputStyle} value={form.diasPremioPuntualidad} onChange={e => set("diasPremioPuntualidad", e.target.value)}/>
            </div>
          )}
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <ToggleColectivo checked={form.incluyeCompensacionFinAno}
              onChange={v => set("incluyeCompensacionFinAno", v)}
              label="Compensación extraordinaria de fin de año"/>
          </div>
          {form.incluyeCompensacionFinAno && (
            <div>
              <label style={labelStyle}>Días de salario</label>
              <input autoComplete="off" type="number" style={inputStyle} value={form.diasCompensacionFinAno} onChange={e => set("diasCompensacionFinAno", e.target.value)}/>
            </div>
          )}
        </SectionColectivo>

        {/* Comisiones mixtas */}
        <SectionColectivo title="Seguridad e higiene y capacitación" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <ToggleColectivo checked={form.incluyeComisionSeguridad}
              onChange={v => set("incluyeComisionSeguridad", v)}
              label="Comisión Mixta de Seguridad e Higiene (Art. 509 LFT)"/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <ToggleColectivo checked={form.incluyeCapacitacion}
              onChange={v => set("incluyeCapacitacion", v)}
              label="Plan de capacitación y adiestramiento (Arts. 153-A a 153-X LFT)"/>
          </div>
        </SectionColectivo>

        {/* Testigos */}
        <SectionColectivo title="Testigos (recomendado)" fontSerif={fontSerif} isMobile={isMobile}>
          <div>
            <label style={labelStyle}>Nombre Testigo 1</label>
            <input autoComplete="off" style={inputStyle} value={form.nombreTestigo1} onChange={e => set("nombreTestigo1", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyle}>Nombre Testigo 2</label>
            <input autoComplete="off" style={inputStyle} value={form.nombreTestigo2} onChange={e => set("nombreTestigo2", e.target.value)}/>
          </div>
        </SectionColectivo>

        {/* Aviso legal */}
        <div style={{background:"rgba(184,147,42,0.10)", border:"1px solid rgba(184,147,42,0.3)",
          borderRadius:10, padding:"12px 14px", marginBottom:18, display:"flex", gap:10}}>
          <AxisIcon name="scale_simple" size={16} tone="gold" withBackdrop={false} strokeWidth={3}/>
          <div style={{fontSize:11.5, color:"#374151", lineHeight:1.5}}>
            <strong>Aviso legal:</strong> Plantilla genérica conforme a la Ley Federal del Trabajo (Arts. 386-403). El contrato debe depositarse ante el Tribunal Laboral del Estado y debe acompañarse de un tabulador de salarios anexo. Para casos con cláusulas específicas (admisión exclusiva, exclusión, condiciones especiales por industria), recomendamos validación con AXIS Asesoría Legal Corporativa antes de firmar.
          </div>
        </div>

        {/* Botón generar */}
        <button onClick={generarPDF} disabled={generando || !camposObligatoriosLlenos}
          style={{width:"100%", padding:"14px", borderRadius:10,
            background: camposObligatoriosLlenos
              ? "linear-gradient(135deg,#4338CA,#3730A3)"
              : "#9CA3AF",
            border:"none", color:"white", fontSize:15, fontWeight:700,
            cursor: camposObligatoriosLlenos ? "pointer" : "not-allowed",
            boxShadow: camposObligatoriosLlenos ? "0 4px 16px rgba(67,56,202,0.40)" : "none",
            display:"flex", alignItems:"center", justifyContent:"center", gap:10,
            fontFamily:fontSans}}>
          <AxisIcon name="document" size={16} tone="white" withBackdrop={false} strokeWidth={3}/>
          {generando ? "Generando contrato..." : "Generar contrato colectivo en PDF"}
        </button>

        {!camposObligatoriosLlenos && (
          <p style={{fontSize:11, color:"#DC2626", margin:"8px 0 0", textAlign:"center" as const}}>
            Completa los campos marcados con <strong>*</strong> para generar el contrato.
          </p>
        )}
        {ultimoBlob && (
          <div style={{marginTop:14, padding:"14px 16px", background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:12, display:"flex", justifyContent:"space-between", alignItems:"center", gap:12, flexWrap:"wrap"}}>
            <div style={{fontSize:12, color:T_LIGHT.textInkSoft, flex:1, minWidth:160}}>¿Quieres guardar este contrato en un expediente?</div>
            <BotonGuardarYVincular
              user={user}
              tipoContrato={tipoContrato}
              getPDFBlob={async () => ultimoBlob!}
              nombrePDFBase={`Contrato_${tipoContrato}`}
              fontSans={fontSans} fontSerif={fontSerif} gold={gold}
            />
          </div>
        )}
      </div>
    </div>
  );
}


function SectionDomestico({title, children, fontSerif, isMobile}: {title:string; children:React.ReactNode; fontSerif:string; isMobile:boolean}) {
  return (
    <div style={{marginBottom:18}}>
      <div style={{fontFamily:fontSerif, fontSize:14, fontWeight:700, color:"#0F172A",
        marginBottom:10, paddingBottom:6, borderBottom:"1px solid rgba(5,150,105,0.3)",
        display:"flex", alignItems:"center", gap:8}}>
        <AxisIcon name="house" size={14} color="#059669" withBackdrop={false} strokeWidth={3}/>
        {title}
      </div>
      <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr":"1fr 1fr", gap:10}}>
        {children}
      </div>
    </div>
  );
}

function FormServicioDomestico({user, tipoContrato, onBack, fontSans, fontSerif, gold}: {user:any; tipoContrato:string; onBack:()=>void; fontSans:string; fontSerif:string; gold:string}) {
  // El pie de este documento lo firma el patrón, no la plataforma.
  const datosPatron = useDatosPatron(user?.uid).datos;
  const isMobile = window.innerWidth < 768;
  const [tipoEmpleador, setTipoEmpleador] = useState<"hogar"|"empresa">("hogar");
  const [form, setForm] = useState({
    ciudad:"Aguascalientes, Ags.",
    fechaContrato:"",
    // Empleador
    nombreEmpleador:"",
    domicilioEmpleador:"",
    // Trabajador
    nombreTrabajador:"",
    domicilioTrabajador:"",
    // Trabajo
    labores:"labores domésticas de limpieza, aseo, asistencia general y mantenimiento del inmueble",
    domicilioTrabajo:"",
    modalidad:"sin_internado",
    // Horario
    horarioEntrada:"07:30",
    horarioSalida:"13:30",
    diasSemana:"lunes a viernes",
    // Pago
    salarioDiario:"",
    formaPago:"semanal",
    diaPago:"sábado",
    cuentaPago:"",
    // Fechas
    fechaInicio:"",
    fechaFin:"",
    duracion:"un año (365 días)",
    // Testigos
    nombreTestigo1:"",
    nombreTestigo2:"",
  });
  const [generando, setGenerando] = useState(false);
  const [ultimoBlob, setUltimoBlob] = useState<Blob|null>(null);
  const set = (k:string, v:any) => setForm(p=>({...p,[k]:v}));
  const F = (v:string) => v || "___________________________";

  const numeroALetras = (n:number):string => {
    const u=["","UN","DOS","TRES","CUATRO","CINCO","SEIS","SIETE","OCHO","NUEVE","DIEZ","ONCE","DOCE","TRECE","CATORCE","QUINCE","DIECISEIS","DIECISIETE","DIECIOCHO","DIECINUEVE"];
    const d=["","DIEZ","VEINTE","TREINTA","CUARENTA","CINCUENTA","SESENTA","SETENTA","OCHENTA","NOVENTA"];
    const c=["","CIEN","DOSCIENTOS","TRESCIENTOS","CUATROCIENTOS","QUINIENTOS","SEISCIENTOS","SETECIENTOS","OCHOCIENTOS","NOVECIENTOS"];
    if(n===0)return"CERO";if(n<20)return u[n];if(n<100)return d[Math.floor(n/10)]+(n%10?" Y "+u[n%10]:"");
    if(n<1000)return c[Math.floor(n/100)]+(n%100?" "+numeroALetras(n%100):"");
    if(n<10000)return u[Math.floor(n/1000)]+" MIL"+(n%1000?" "+numeroALetras(n%1000):"");
    return n.toLocaleString("es-MX");
  };

  const generarPDF = async () => {
    setGenerando(true);
    // Ver la nota del contrato de trabajo: "AAAA-MM-DD" a través de Date imprime
    // el día anterior en México.
    const hoy = fechaLargaAxis(form.fechaContrato) || fechaLargaAxis(new Date());
    const vEmpleador = form.nombreEmpleador || "___________________________";
    const vTrabajador = form.nombreTrabajador || "___________________________";
    const vSalario = form.salarioDiario
      ? "$"+parseFloat(form.salarioDiario).toLocaleString("es-MX",{minimumFractionDigits:2, maximumFractionDigits: 2})+" ("+numeroALetras(Math.floor(parseFloat(form.salarioDiario)))+" PESOS "+((parseFloat(form.salarioDiario)%1)*100).toFixed(0)+"/100 M.N.)"
      : "___________________________";
    const vFechaInicio = fechaLargaAxis(form.fechaInicio) || "___________________________";
    const vFechaFin = fechaLargaAxis(form.fechaFin) || "___________________________";
    const esEmpresa = tipoEmpleador === "empresa";
    const vTipoEmpleador = esEmpresa ? "persona moral / empresa" : "persona física";
    const vLugar = form.domicilioTrabajo || form.domicilioEmpleador || "___________________________";

    const html = `<!DOCTYPE html>
<html lang="es">
<head><meta charset="UTF-8"><title>Contrato de Trabajo del Hogar</title>
<style>
  * { box-sizing:border-box; margin:0; padding:0; }
  body { font-family:'Times New Roman', serif; color:#1A1A2E; padding:50px 65px; font-size:12.5px; line-height:1.85; background:white; text-align:justify; }
  .header-axis { display:flex; justify-content:space-between; align-items:center; margin-bottom:28px; padding-bottom:12px; border-bottom:2px solid #B8932A; }
  .titulo { font-size:13px; font-weight:bold; text-align:center; text-transform:uppercase; margin-bottom:20px; line-height:1.7; }
  .seccion { font-weight:bold; text-transform:uppercase; text-align:center; font-size:12.5px; margin:18px 0 10px; letter-spacing:1px; }
  .decl { margin-bottom:10px; }
  .clausula { margin-bottom:16px; }
  .cl-titulo { font-weight:bold; text-transform:uppercase; }
  .firmas { margin-top:50px; }
  .fila-firmas { display:grid; grid-template-columns:1fr 1fr; gap:48px; margin-bottom:32px; }
  .firma-bloque { text-align:center; }
  .linea-firma { border-top:1px solid #1A1A2E; margin-bottom:6px; }
  .fund-legal { margin-top:18px; padding:12px 16px; background:#FFF8F0; border:1px solid #F0D080; border-radius:8px; font-size:11px; font-family:Arial,sans-serif; color:#6B5A3A; }
  .footer { text-align:center; margin-top:28px; padding-top:12px; border-top:1px solid #ddd; font-size:10px; color:#9A9AAA; font-family:Arial,sans-serif; }
  @media print { body { padding:36px 48px; } }
</style>
</head>
<body>
  <div class="titulo">
    CONTRATO DE TRABAJO ${esEmpresa ? "DE PERSONAL DE LIMPIEZA E INTENDENCIA" : "DEL HOGAR"}<br/>
    QUE CELEBRAN, POR UNA PARTE, ${vEmpleador.toUpperCase()}, A QUIEN SE DENOMINARÁ "LA PERSONA EMPLEADORA",<br/>
    Y POR LA OTRA PARTE, ${vTrabajador.toUpperCase()}, A QUIEN SE DENOMINARÁ "LA PERSONA TRABAJADORA",<br/>
    QUIENES SE SUJETAN AL TENOR DE LAS SIGUIENTES DECLARACIONES Y CLÁUSULAS:
  </div>

  <div class="seccion">DECLARACIONES</div>

  <div class="decl"><strong>I.</strong> La persona empleadora es ${vTipoEmpleador}, con domicilio en ${(form.domicilioEmpleador||"___________________________").toUpperCase()}, y manifiesta tener plena capacidad legal para celebrar el presente contrato. Se anexan copias de identificación oficial y comprobante de domicilio.</div>
  <div class="decl"><strong>II.</strong> La persona trabajadora declara tener por domicilio el ubicado en ${(form.domicilioTrabajador||"___________________________").toUpperCase()}. Se anexan copias de identificación oficial y comprobante de domicilio.</div>

  <div class="seccion">CONTRATO DE TRABAJO ${esEmpresa ? "DE PERSONAL DE LIMPIEZA E INTENDENCIA" : "DEL HOGAR"}</div>
  <div class="seccion" style="margin-top:4px;">CLÁUSULAS</div>

  <div class="clausula">
    <span class="cl-titulo">PRIMERA.- Naturaleza y objeto del trabajo.</span><br/>
    Conforme a la Ley Federal del Trabajo ${esEmpresa ? "(Arts. 331 a 343 LFT — Capítulo XIII BIS)" : "(Arts. 331 a 343 LFT)"}, la persona trabajadora realizará de manera remunerada las siguientes actividades: <strong>${form.labores || "___________________________"}</strong>. La modalidad de prestación del servicio será: <strong>${form.modalidad === "con_internado" ? "con internado (la persona trabajadora reside en el domicilio donde presta sus servicios)" : "sin internado (la persona trabajadora no reside en el domicilio y tiene una sola persona empleadora)"}</strong>.
  </div>

  <div class="clausula">
    <span class="cl-titulo">SEGUNDA.- Lugar de prestación del trabajo.</span><br/>
    Las partes acuerdan que los servicios deberán prestarse de manera exclusiva en el domicilio ubicado en ${vLugar.toUpperCase()}.
  </div>

  <div class="clausula">
    <span class="cl-titulo">TERCERA.- Monto, forma y período de pago.</span><br/>
    La persona trabajadora percibirá la cantidad de <strong>${vSalario}</strong> por concepto de salario diario, mismo que será pagado de forma <strong>${form.formaPago || "semanal"}</strong>, los días <strong>${form.diaPago || "sábado"}</strong> de cada semana${form.cuentaPago ? ", mediante depósito a la cuenta: " + form.cuentaPago : ", en efectivo al finalizar la jornada"}. El salario diario pactado es superior al mínimo general vigente, conforme al Art. 336 LFT.
  </div>

  <div class="clausula">
    <span class="cl-titulo">CUARTA.- Prestaciones de ley.</span><br/>
    La persona trabajadora contará con las siguientes prestaciones conforme a la LFT y estará comprendida en el régimen obligatorio del Seguro Social (Art. 333 LFT):<br/>
    <strong>a) Vacaciones:</strong> Después de un año de trabajo, un período continuo mínimo de 12 días laborales, que aumentará en 2 días por cada año subsecuente hasta llegar a 20, y 2 días por cada 5 años adicionales (Art. 76 LFT).<br/>
    <strong>b) Prima vacacional:</strong> Mínimo 25% del salario del período vacacional (Art. 80 LFT).<br/>
    <strong>c) Aguinaldo:</strong> Equivalente a 15 días de salario mínimo, pagado antes del 20 de diciembre de cada año (Art. 87 LFT).<br/>
    <strong>d) Seguridad Social:</strong> La persona empleadora afiliará a la persona trabajadora al IMSS (Art. 333 LFT).
  </div>

  <div class="clausula">
    <span class="cl-titulo">QUINTA.- Jornada de trabajo.</span><br/>
    La persona trabajadora estará sujeta a una jornada de trabajo de <strong>${form.horarioEntrada || "07:30"} a ${form.horarioSalida || "13:30"} horas</strong>, los días <strong>${form.diasSemana || "lunes a viernes"}</strong>. Los períodos en que permanezca a disposición de la persona empleadora fuera de la jornada pactada se considerarán horas extras y deberán ser remuneradas conforme a la LFT.
  </div>

  <div class="clausula">
    <span class="cl-titulo">SEXTA.- Días de descanso obligatorio.</span><br/>
    Son días de descanso obligatorio con pago de salario íntegro los establecidos en el Art. 74 de la LFT: 1° de enero, primer lunes de febrero, tercer lunes de marzo, 1° de mayo, 16 de septiembre, tercer lunes de noviembre, 25 de diciembre, y los días electorales que determine la autoridad competente. Los domingos serán día de descanso semanal obligatorio (Art. 69 LFT).
  </div>

  <div class="clausula">
    <span class="cl-titulo">SÉPTIMA.- Instrumentos y materiales de trabajo.</span><br/>
    La persona empleadora tiene la obligación de proporcionar todos los instrumentos, materiales y utensilios que la persona trabajadora requiera para el desempeño de sus labores, sin que se descuente costo alguno de su salario (Art. 132 Fracc. III LFT).
  </div>

  <div class="clausula">
    <span class="cl-titulo">OCTAVA.- Rescisión del contrato.</span><br/>
    Son causas de rescisión sin responsabilidad para la persona empleadora las establecidas en el Art. 47 de la LFT, incluyendo: engaño con documentos falsos, faltas de probidad u honradez, actos de violencia, más de tres faltas injustificadas en 30 días, estado de embriaguez durante la jornada, y las demás análogas. La persona empleadora deberá dar aviso por escrito de la causa y fecha de rescisión, personalmente o mediante el Tribunal Laboral dentro de los 5 días hábiles siguientes (Art. 47 LFT).
  </div>

  <div class="clausula">
    <span class="cl-titulo">NOVENA.- Terminación del contrato.</span><br/>
    La persona trabajadora podrá dar por terminada la relación laboral en cualquier momento, dando aviso a la persona empleadora con <strong>8 días de anticipación</strong>. La persona empleadora podrá terminar el contrato dando aviso a la persona trabajadora con <strong>8 días de anticipación</strong> y pagando la indemnización que corresponda conforme a la LFT.
  </div>

  <div class="clausula">
    <span class="cl-titulo">DÉCIMA.- Fecha de inicio y duración.</span><br/>
    La persona trabajadora comenzó a prestar servicios a partir del <strong>${vFechaInicio}</strong>. El presente contrato tendrá una duración de <strong>${form.duracion || "un año (365 días)"}</strong>, con fecha de terminación el <strong>${vFechaFin}</strong>, sin que se renueve automáticamente, sino únicamente por renovación escrita y expresa signada por ambas partes en presencia de testigos.
  </div>

  <div class="clausula">
    <span class="cl-titulo">DÉCIMA PRIMERA.- Autoridades laborales.</span><br/>
    Las autoridades laborales competentes para conocer sobre cualquier problemática derivada de la presente relación laboral son las del Estado de Aguascalientes. En todo momento prevalecerá la conciliación entre las partes para la resolución de conflictos, salvo en casos de hostigamiento o acoso sexual (Art. 343 LFT).
  </div>

  <div class="fund-legal">
    <strong>Fundamento legal:</strong> Arts. 331 a 343 de la Ley Federal del Trabajo (Capítulo XIII BIS — Trabajo del Hogar) · Arts. 47, 69, 74, 76, 80, 87, 132 LFT · Ley del Seguro Social (Art. 13 Fracc. II) · Art. 2477 del Código Civil del Estado de Aguascalientes
  </div>

  <div class="firmas">
    <p style="margin-bottom:20px;">Tras leerse en voz alta y estar ambas partes enteradas de su contenido, el presente contrato se firma en dos ejemplares del mismo contenido y fecha, quedando un ejemplar en poder de cada parte.</p>
    <p style="font-weight:bold;margin-bottom:24px;">${form.ciudad.toUpperCase()}, A ${hoy.toUpperCase()}</p>
    <div class="fila-firmas">
      <div class="firma-bloque">
        <div style="height:65px;"></div>
        <div class="linea-firma"></div>
        <strong>${vEmpleador.toUpperCase()}</strong><br/>
        <span style="font-size:11px;text-transform:uppercase;">PERSONA EMPLEADORA</span>
      </div>
      <div class="firma-bloque">
        <div style="height:65px;"></div>
        <div class="linea-firma"></div>
        <strong>${vTrabajador.toUpperCase()}</strong><br/>
        <span style="font-size:11px;text-transform:uppercase;">PERSONA TRABAJADORA</span>
      </div>
    </div>
    <div class="fila-firmas">
      <div class="firma-bloque">
        <div style="height:60px;"></div>
        <div class="linea-firma"></div>
        <strong>${(form.nombreTestigo1||"TESTIGO 1").toUpperCase()}</strong><br/>
        <span style="font-size:11px;">TESTIGO</span>
      </div>
      <div class="firma-bloque">
        <div style="height:60px;"></div>
        <div class="linea-firma"></div>
        <strong>${(form.nombreTestigo2||"TESTIGO 2").toUpperCase()}</strong><br/>
        <span style="font-size:11px;">TESTIGO</span>
      </div>
    </div>
  </div>

</body>
</html>`;

    // PDF real (jsPDF + html2canvas) — descarga y activa setUltimoBlob.
    try {
      const fname = "Contrato_Trabajo_Hogar_" + (form.nombreTrabajador||"borrador") + ".pdf";
      const pdfBlob = await generarPDFDesdeHTML(html, fname, {pieContrato:true, pieTexto: pieDelPatron(datosPatron, fechaHoraLargaAxis())});
      setUltimoBlob(pdfBlob);
    } catch(e){ console.error(e); alert("No se pudo generar el PDF. Intenta de nuevo."); }
    finally { setGenerando(false); }
  };

  // ===== UI homologada al estilo claro (PASO 2) =====
  const inputStyleSD: React.CSSProperties = {
    width:"100%", padding:"9px 11px", fontSize:13, fontFamily:fontSans,
    background:"white", border:"1px solid #D1D5DB", borderRadius:8, color:"#0F172A",
    boxSizing:"border-box" as const, outline:"none",
  };
  const labelStyleSD: React.CSSProperties = {
    display:"block", fontSize:11, fontWeight:600, color:"#374151", marginBottom:4,
    letterSpacing:"0.2px",
  };
  
  const camposMinSD = !!(form.nombreEmpleador && form.nombreTrabajador && form.salarioDiario);

  return (
    <div {...ZONA_DE_CAPTURA} style={{minHeight:"100vh", background:T_LIGHT.canvas, fontFamily:fontSans}}>
      <div style={{background:"linear-gradient(135deg,#059669,#047857)", padding:"0 20px", height:58,
        display:"flex", alignItems:"center", gap:12, position:"sticky" as const, top:0, zIndex:100,
        boxShadow:"0 4px 20px rgba(5,150,105,0.30)"}}>
        <button onClick={onBack}
          style={{background:"rgba(255,255,255,0.18)", border:"1px solid rgba(255,255,255,0.30)",
            color:"white", borderRadius:8, padding:"5px 11px", cursor:"pointer",
            fontSize:12, fontWeight:600}}>← Generador legal</button>
        <span style={{color:"white", fontWeight:700, fontSize:isMobile?12:14, display:"flex",
          alignItems:"center", gap:8}}>
          <AxisIcon name="house" size={18} tone="white" withBackdrop={false} strokeWidth={2.5}/>
          Contrato de Servicio Doméstico
        </span>
      </div>

      <div style={{maxWidth:760, margin:"0 auto", padding:isMobile?"16px":"24px"}}>
        <p style={{fontSize:12, color:"#64748B", margin:"0 0 18px", lineHeight:1.6}}>
          Completa los datos. Los campos marcados con <span style={{color:"#DC2626"}}>*</span> son indispensables.
        </p>

        {/* Toggle Hogar / Empresa */}
        <SectionDomestico title="Tipo de empleador" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <div style={{display:"flex", gap:8}}>
              {(["hogar","empresa"] as const).map(val => (
                <button key={val} onClick={() => setTipoEmpleador(val)}
                  style={{flex:1, padding:"10px 12px", borderRadius:8, fontSize:12, fontWeight:600,
                    fontFamily:fontSans, cursor:"pointer", textAlign:"left" as const,
                    background: tipoEmpleador===val ? "#059669" : "white",
                    color: tipoEmpleador===val ? "white" : "#374151",
                    border: tipoEmpleador===val ? "1px solid #059669" : "1px solid #D1D5DB"}}>
                  <div style={{fontSize:13, fontWeight:700, marginBottom:2}}>
                    {val==="hogar" ? "Hogar particular" : "Empresa / Negocio"}
                  </div>
                  <div style={{fontSize:10, opacity:0.85, fontWeight:400}}>
                    {val==="hogar" ? "Personas físicas que contratan en su hogar" : "Empresas con personal de limpieza/intendencia"}
                  </div>
                </button>
              ))}
            </div>
          </div>
        </SectionDomestico>

        <SectionDomestico title="Datos generales" fontSerif={fontSerif} isMobile={isMobile}>
          <div>
            <label style={labelStyleSD}>Ciudad y estado</label>
            <input autoComplete="off" style={inputStyleSD} value={form.ciudad} onChange={e => set("ciudad", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyleSD}>Fecha del contrato</label>
            <input autoComplete="off" type="date" style={inputStyleSD} value={form.fechaContrato} onChange={e => set("fechaContrato", e.target.value)}/>
          </div>
        </SectionDomestico>

        <SectionDomestico title={tipoEmpleador==="hogar" ? "La Persona Empleadora" : "La Empresa Empleadora"} fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyleSD}>{tipoEmpleador==="hogar" ? "Nombre completo" : "Razón social / Nombre"} <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" style={inputStyleSD} value={form.nombreEmpleador} onChange={e => set("nombreEmpleador", e.target.value)}
              placeholder={tipoEmpleador==="hogar" ? "Nombre del empleador" : "Empresa S.A. de C.V."}/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyleSD}>Domicilio <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" style={inputStyleSD} value={form.domicilioEmpleador} onChange={e => set("domicilioEmpleador", e.target.value)}
              placeholder="Calle, número, colonia, ciudad"/>
          </div>
        </SectionDomestico>

        <SectionDomestico title="La Persona Trabajadora" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyleSD}>Nombre completo <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" style={inputStyleSD} value={form.nombreTrabajador} onChange={e => set("nombreTrabajador", e.target.value)}
              placeholder="Nombre completo del trabajador"/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyleSD}>Domicilio</label>
            <input autoComplete="off" style={inputStyleSD} value={form.domicilioTrabajador} onChange={e => set("domicilioTrabajador", e.target.value)}
              placeholder="Domicilio de la persona trabajadora"/>
          </div>
        </SectionDomestico>

        <SectionDomestico title="Objeto del trabajo" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyleSD}>Labores a realizar</label>
            <input autoComplete="off" style={inputStyleSD} value={form.labores} onChange={e => set("labores", e.target.value)}
              placeholder="Limpieza general, aseo, asistencia..."/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyleSD}>Domicilio donde se prestará el servicio</label>
            <input autoComplete="off" style={inputStyleSD} value={form.domicilioTrabajo} onChange={e => set("domicilioTrabajo", e.target.value)}
              placeholder="Dejar vacío si es igual al de la empleadora"/>
          </div>
        </SectionDomestico>

        <SectionDomestico title="Modalidad del trabajo" fontSerif={fontSerif} isMobile={isMobile}>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <div style={{display:"flex", gap:8}}>
              {(["sin_internado","con_internado"] as const).map(val => (
                <button key={val} onClick={() => set("modalidad", val)}
                  style={{flex:1, padding:"10px 12px", borderRadius:8, fontSize:12, fontWeight:600,
                    fontFamily:fontSans, cursor:"pointer", textAlign:"left" as const,
                    background: form.modalidad===val ? "#059669" : "white",
                    color: form.modalidad===val ? "white" : "#374151",
                    border: form.modalidad===val ? "1px solid #059669" : "1px solid #D1D5DB"}}>
                  <div style={{fontSize:13, fontWeight:700, marginBottom:2}}>
                    {val==="sin_internado" ? "Sin internado" : "Con internado"}
                  </div>
                  <div style={{fontSize:10, opacity:0.85, fontWeight:400}}>
                    {val==="sin_internado" ? "No vive donde trabaja" : "Vive en el domicilio donde trabaja"}
                  </div>
                </button>
              ))}
            </div>
          </div>
        </SectionDomestico>

        <SectionDomestico title="Horario y remuneración" fontSerif={fontSerif} isMobile={isMobile}>
          <div>
            <label style={labelStyleSD}>Hora de entrada</label>
            <input autoComplete="off" type="time" style={inputStyleSD} value={form.horarioEntrada} onChange={e => set("horarioEntrada", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyleSD}>Hora de salida</label>
            <input autoComplete="off" type="time" style={inputStyleSD} value={form.horarioSalida} onChange={e => set("horarioSalida", e.target.value)}/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyleSD}>Días de la semana</label>
            <input autoComplete="off" style={inputStyleSD} value={form.diasSemana} onChange={e => set("diasSemana", e.target.value)}
              placeholder="Lunes a viernes"/>
          </div>
          <div>
            <label style={labelStyleSD}>Salario diario MXN <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" type="number" style={inputStyleSD} value={form.salarioDiario} onChange={e => set("salarioDiario", e.target.value)}
              placeholder="248.93"/>
          </div>
          <div>
            <label style={labelStyleSD}>Frecuencia de pago</label>
            <input autoComplete="off" style={inputStyleSD} value={form.formaPago} onChange={e => set("formaPago", e.target.value)}
              placeholder="Semanal / Quincenal / Mensual"/>
          </div>
          <div>
            <label style={labelStyleSD}>Día de pago</label>
            <input autoComplete="off" style={inputStyleSD} value={form.diaPago} onChange={e => set("diaPago", e.target.value)}
              placeholder="Sábado / quincena"/>
          </div>
          <div>
            <label style={labelStyleSD}>Cuenta para depósito (opcional)</label>
            <input autoComplete="off" style={inputStyleSD} value={form.cuentaPago} onChange={e => set("cuentaPago", e.target.value)}
              placeholder="Tarjeta o CLABE"/>
          </div>
        </SectionDomestico>

        <SectionDomestico title="Vigencia" fontSerif={fontSerif} isMobile={isMobile}>
          <div>
            <label style={labelStyleSD}>Fecha de inicio <span style={{color:"#DC2626"}}>*</span></label>
            <input autoComplete="off" type="date" style={inputStyleSD} value={form.fechaInicio} onChange={e => set("fechaInicio", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyleSD}>Fecha de término</label>
            <input autoComplete="off" type="date" style={inputStyleSD} value={form.fechaFin} onChange={e => set("fechaFin", e.target.value)}/>
          </div>
          <div style={{gridColumn:isMobile?"auto":"1 / -1"}}>
            <label style={labelStyleSD}>Duración (texto)</label>
            <input autoComplete="off" style={inputStyleSD} value={form.duracion} onChange={e => set("duracion", e.target.value)}
              placeholder="Ej. un año (365 días)"/>
          </div>
        </SectionDomestico>

        <SectionDomestico title="Testigos" fontSerif={fontSerif} isMobile={isMobile}>
          <div>
            <label style={labelStyleSD}>Nombre Testigo 1</label>
            <input autoComplete="off" style={inputStyleSD} value={form.nombreTestigo1} onChange={e => set("nombreTestigo1", e.target.value)}/>
          </div>
          <div>
            <label style={labelStyleSD}>Nombre Testigo 2</label>
            <input autoComplete="off" style={inputStyleSD} value={form.nombreTestigo2} onChange={e => set("nombreTestigo2", e.target.value)}/>
          </div>
        </SectionDomestico>

        <div style={{background:"rgba(184,147,42,0.10)", border:"1px solid rgba(184,147,42,0.3)",
          borderRadius:10, padding:"12px 14px", marginBottom:18, display:"flex", gap:10}}>
          <AxisIcon name="scale_simple" size={16} tone="gold" withBackdrop={false} strokeWidth={3}/>
          <div style={{fontSize:11.5, color:"#374151", lineHeight:1.5}}>
            <strong>Aviso legal:</strong> Plantilla conforme a la LFT y al Convenio 189 OIT sobre trabajo decente del hogar. Recuerda registrar al trabajador en IMSS (obligatorio desde 2019). Para casos particulares, valida con AXIS Asesoría Legal Corporativa.
          </div>
        </div>

        <button onClick={generarPDF} disabled={generando || !camposMinSD}
          style={{width:"100%", padding:"14px", borderRadius:10,
            background: camposMinSD ? "linear-gradient(135deg,#059669,#047857)" : "#9CA3AF",
            border:"none", color:"white", fontSize:15, fontWeight:700,
            cursor: camposMinSD ? "pointer" : "not-allowed",
            boxShadow: camposMinSD ? "0 4px 16px rgba(5,150,105,0.35)" : "none",
            display:"flex", alignItems:"center", justifyContent:"center", gap:10,
            fontFamily:fontSans}}>
          <AxisIcon name="document" size={16} tone="white" withBackdrop={false} strokeWidth={3}/>
          {generando ? "Generando contrato..." : "Generar contrato en PDF"}
        </button>

        {!camposMinSD && (
          <p style={{fontSize:11, color:"#DC2626", margin:"8px 0 0", textAlign:"center" as const}}>
            Completa los campos marcados con <strong>*</strong> para generar el contrato.
          </p>
        )}
        {ultimoBlob && (
          <div style={{marginTop:14, padding:"14px 16px", background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:12, display:"flex", justifyContent:"space-between", alignItems:"center", gap:12, flexWrap:"wrap"}}>
            <div style={{fontSize:12, color:T_LIGHT.textInkSoft, flex:1, minWidth:160}}>¿Quieres guardar este contrato en un expediente?</div>
            <BotonGuardarYVincular
              user={user}
              tipoContrato={tipoContrato}
              getPDFBlob={async () => ultimoBlob!}
              nombrePDFBase={`Contrato_${tipoContrato}`}
              fontSans={fontSans} fontSerif={fontSerif} gold={gold}
            />
          </div>
        )}

      </div>
    </div>
  );
}



//

// #endregion
// #endregion
// ─── WIDGET PRÓXIMAS OBLIGACIONES ────────────────────────────────────────────
function ProximasObligaciones({todosEventos, fontSans, fontSerif}: {todosEventos:EventoCal[]; fontSans:string; fontSerif:string}) {
  const hoy = new Date();
  const en60dias = new Date(hoy.getTime() + 60*24*60*60*1000);

  const proximas = todosEventos
    .filter(e => {
      const fecha = new Date(e.fecha+"T12:00:00");
      return fecha >= hoy && fecha <= en60dias;
    })
    .sort((a,b) => a.fecha.localeCompare(b.fecha))
    .slice(0, 8);

  if (proximas.length === 0) return null;

  const diasRestantes = (fecha:string) => {
    const d = Math.ceil((new Date(fecha+"T12:00:00").getTime()-hoy.getTime())/(1000*60*60*24));
    if (d === 0) return "Hoy";
    if (d === 1) return "Mañana";
    if (d <= 7) return `${d} días`;
    if (d <= 14) return "Esta semana";
    if (d <= 30) return `${d} días`;
    return `${d} días`;
  };

  const urgencia = (fecha:string) => {
    const d = Math.ceil((new Date(fecha+"T12:00:00").getTime()-hoy.getTime())/(1000*60*60*24));
    if (d <= 3) return {bg:"rgba(220,38,38,0.08)", border:"rgba(220,38,38,0.25)", badge:"rgba(220,38,38,0.95)", text:"#991B1B"};
    if (d <= 7) return {bg:"rgba(234,179,8,0.08)", border:"rgba(234,179,8,0.25)", badge:"rgba(234,179,8,0.95)", text:"#92400E"};
    return {bg:T_LIGHT.cardLight, border:T_LIGHT.border, badge:"rgba(22,36,71,0.85)", text:T_LIGHT.textInk};
  };

  return (
    <div style={{marginTop:20}}>
      <h3 style={{fontFamily:fontSerif, fontSize:16, color:T_LIGHT.textInk, margin:"0 0 12px", display:"flex", alignItems:"center", gap:8}}>
        ⚡ Próximas obligaciones
        <span style={{fontSize:11, color:T_LIGHT.textInkSoft, fontFamily:fontSans, fontWeight:400}}>— siguientes 60 días</span>
      </h3>
      <div style={{display:"flex", flexDirection:"column" as const, gap:6}}>
        {proximas.map((e,i) => {
          const u = urgencia(e.fecha);
          const c = TIPO_COLORS[e.tipo];
          const dias = diasRestantes(e.fecha);
          const fechaFmt = new Date(e.fecha+"T12:00:00").toLocaleDateString("es-MX",{day:"numeric",month:"short"});
          return (
            <div key={i} style={{display:"flex", alignItems:"center", gap:12, padding:"10px 14px", background:u.bg, border:`1px solid ${u.border}`, borderRadius:10, borderLeft:`3px solid ${c.dot}`}}>
              <div style={{flexShrink:0, width:54, textAlign:"center" as const}}>
                <div style={{fontSize:12, fontWeight:800, color:u.text}}>{fechaFmt}</div>
              </div>
              <div style={{flex:1, minWidth:0}}>
                <div style={{fontSize:12, fontWeight:600, color:u.text, whiteSpace:"nowrap" as const, overflow:"hidden", textOverflow:"ellipsis"}}>{e.titulo}</div>
                <div style={{fontSize:10, color:T_LIGHT.textInkSoft, marginTop:1}}>{e.descripcion?.slice(0,60)}{e.descripcion && e.descripcion.length>60?"...":""}</div>
              </div>
              <div style={{flexShrink:0}}>
                <span style={{fontSize:10, fontWeight:700, color:"white", background:u.badge, padding:"3px 8px", borderRadius:12}}>{dias}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

//
// #region NÓMINA
// ─── NÓMINA DE TRABAJADORES ───────────────────────────────────────────────────
type ReciboPago = {
  id?: string;
  userId: string;
  trabajadorId: string;
  trabajadorNombre: string;
  trabajadorPuesto: string;
  periodo: "semanal"|"quincenal"|"mensual";
  fechaInicio: string;
  fechaFin: string;
  fechaPago: string;
  diasTrabajados: number;
  salarioDiario: number;
  salarioBruto: number;
  imssObrero: number;
  isrRetenido: number;
  otrosDescuentos: number;
  otrosDescuentosConcepto: string;
  percepciones: number;
  totalDeducciones: number;
  netoAPagar: number;
  folio: string;
  status: "pendiente"|"pagado";
  timestamp?: any;
};

// ── Tablas IMSS 2025 (cuota obrera simplificada ~2.54% del SBC) ──
const calcularIMSS = (salarioDiario: number, dias: number): number => {
  // Cuota obrero IMSS 2026:
  // Enfermedades y Maternidad: 2.00% SBC | Invalidez y Vida: 0.625% | CEAV obrero: 1.125% | Total obrero ≈ 2.54%
  // Tope: 25 UMA 2026 = 25 × $117.31 = $2,932.75 diarios
  const UMA_2026_DIARIA = 117.31;
  const sbc = Math.min(salarioDiario, 25 * UMA_2026_DIARIA);
  // Cuota obrero total aproximada: 2.54% (sin INFONAVIT que es solo patronal)
  return Math.round(sbc * dias * 0.0254 * 100) / 100;
};

// ── ISR mensual estimado — Tabla Art. 96 LISR · Anexo 8 RMF 2026 (DOF 28/12/2025) ──
const calcularISRMensual = (salarioMensualGravable: number): number => {
  // Fuente: Tarifa B.V — Pagos provisionales mensuales Art. 96 LISR 2026
  const tablas = [
    {li:0.01,       ls:844.59,     ci:0,          pct:0.0192},
    {li:844.60,     ls:7168.51,    ci:16.22,      pct:0.0640},
    {li:7168.52,    ls:12598.02,   ci:420.95,     pct:0.1088},
    {li:12598.03,   ls:14644.64,   ci:1011.68,    pct:0.1600},
    {li:14644.65,   ls:17533.64,   ci:1339.14,    pct:0.1792},
    {li:17533.65,   ls:35362.83,   ci:1856.84,    pct:0.2136},
    {li:35362.84,   ls:55736.68,   ci:5665.16,    pct:0.2352},
    {li:55736.69,   ls:106410.50,  ci:10457.09,   pct:0.3000},
    {li:106410.51,  ls:141880.66,  ci:25659.23,   pct:0.3200},
    {li:141880.67,  ls:425641.99,  ci:37009.69,   pct:0.3400},
    {li:425642.00,  ls:Infinity,   ci:133488.54,  pct:0.3500},
  ];
  const t = tablas.find(r => salarioMensualGravable >= r.li && salarioMensualGravable <= r.ls);
  if (!t) return 0;
  const isr = (salarioMensualGravable - t.li) * t.pct + t.ci;
  // Subsidio al empleo 2026 (estimado — se actualiza con tabla oficial del SAT)
  const subsidio = salarioMensualGravable <= 7768.00 ? Math.max(0, 407.02 - isr * 0.1) : 0;
  return Math.max(0, Math.round((isr - subsidio) * 100) / 100);
};

// ═══ LA ETIQUETA DEL PERIODO NO ES DECORATIVA: CAMBIA LA RETENCIÓN ══════════
// `calcularISR` anualiza el bruto según la etiqueta —mensual ×1, quincenal ×2,
// semanal ×4.33— y luego divide igual. La tarifa del Art. 96 es PROGRESIVA, así
// que un bruto inflado cae en un escalón más alto: 36 días marcados como
// "mensual" retienen de más, y dos meses marcados como "semanal" retienen de
// menos. Las dos cosas salían impresas en un comprobante de pago sin un aviso.
//
// SE AVISA, NO SE BLOQUEA, y tampoco se deriva la etiqueta del rango. Un rango
// irregular es legítimo y frecuente —alta a mitad de mes, finiquito, quincena
// partida—: bloquearlo rompería el caso normal. Quien firma tiene que poder
// hacerlo sabiendo qué implica.
const DIAS_ESPERADOS_PERIODO: Record<string, {min:number; max:number; nombre:string}> = {
  semanal:   {min:7,  max:8,  nombre:"semanal"},
  quincenal: {min:14, max:16, nombre:"quincenal"},
  mensual:   {min:28, max:31, nombre:"mensual"},
};
function periodoCuadraConRango(periodo: string, dias: number): boolean {
  const r = DIAS_ESPERADOS_PERIODO[periodo];
  if (!r || !Number.isFinite(dias) || dias <= 0) return true;   // sin datos no se afirma nada
  return dias >= r.min && dias <= r.max;
}
// El aviso DICE LA CONSECUENCIA, no solo que no cuadra: "no coincide" no le
// dice a nadie que la retención de su trabajador puede salir mal.
function avisoPeriodoRecibo(periodo: string, dias: number): string {
  const r = DIAS_ESPERADOS_PERIODO[periodo];
  if (!r || periodoCuadraConRango(periodo, dias)) return "";
  const masOMenos = dias > r.max ? "por encima" : "por debajo";
  return `Marcaste el periodo como ${r.nombre} (${r.min} a ${r.max} días) pero el rango que capturaste cubre ${dias} día${dias===1?"":"s"}. `
    + `El ISR se calcula tratando este bruto como si correspondiera a un periodo ${r.nombre} completo, así que la retención puede quedar `
    + `${masOMenos} de la que corresponde. Puedes emitirlo igual —un alta a mitad de mes o un finiquito son rangos legítimos—, `
    + `pero revisa la retención antes de firmarlo.`;
}

const calcularISR = (salarioBruto: number, periodo: string): number => {
  const mensual = periodo === "mensual" ? salarioBruto : periodo === "quincenal" ? salarioBruto * 2 : salarioBruto * 4.33;
  const isrMensual = calcularISRMensual(mensual);
  if (periodo === "mensual") return Math.round(isrMensual * 100) / 100;
  if (periodo === "quincenal") return Math.round(isrMensual / 2 * 100) / 100;
  return Math.round(isrMensual / 4.33 * 100) / 100;
};

const generarFolio = () => `NOM-${Date.now().toString(36).toUpperCase()}`;

function NominaInner({fontSans, fontSerif, gold, currentUser, trabajadorInicial, onIrExpediente}: {
  fontSans:string; fontSerif:string; gold:string; currentUser:any; trabajadorInicial:any; onIrExpediente:()=>void;
}) {
  const isMobile = window.innerWidth < 768;
  const [trabajadores, setTrabajadores] = useState<any[]>([]);
  const [recibos, setRecibos] = useState<ReciboPago[]>([]);
  const [cargando, setCargando] = useState(true);
  // QUIÉN FIRMA ESTE RECIBO. Hasta ahora se imprimía el correo del patrón partido
  // por la arroba —`ivan.lopez.15@…` salía como IVAN.LOPEZ.15— en el encabezado y
  // encima de la línea de firma. No era un dato que faltara: era una identidad
  // inventada en un comprobante de pago. Null = todavía no se ha leído.
  const [cfgPatron, setCfgPatron] = useState<any|null>(null);
  useEffect(()=>{ let cancel=false; (async()=>{
    if (!currentUser?.uid) return;
    try { const c = await leerConfigEmpresa(currentUser.uid); if (!cancel) setCfgPatron(c || {}); }
    catch(e){ if (!cancel) setCfgPatron({}); }
  })(); return ()=>{cancel=true;}; }, [currentUser?.uid]);
  const faltanDelPatron = cfgPatron === null ? [] : faltanDatosPatron(cfgPatron);
  // Si el salto vino de la ficha de un trabajador, se abre directo en su recibo;
  // entrando por el sidebar `trabajadorInicial` llega en null y se ve la lista.
  const [vista, setVista] = useState<"lista"|"generar"|"historial">(trabajadorInicial ? "generar" : "lista");
  const [trabajadorSel, setTrabajadorSel] = useState<any>(trabajadorInicial||null);
  const [guardando, setGuardando] = useState(false);
  // Búsqueda y orden del listado. Van aquí arriba, con el resto de los hooks:
  // más abajo quedarían después de los `return` de las vistas.
  const [busqueda, setBusqueda] = useState("");
  const [ordenCol, setOrdenCol] = useState<"nombre"|"pendientes">("nombre");
  const [ordenDir, setOrdenDir] = useState<"asc"|"desc">("asc");
  // Historial: búsqueda, filtro por estado, orden y tope de filas dibujadas.
  // Arranca por período descendente porque lo último emitido es lo que se busca.
  const [busqHist, setBusqHist] = useState("");
  const [filtroEstado, setFiltroEstado] = useState<"todos"|"pagado"|"pendiente">("todos");
  const [ordenHist, setOrdenHist] = useState<"periodo"|"trabajador">("periodo");
  const [dirHist, setDirHist] = useState<"asc"|"desc">("desc");
  const [topeHist, setTopeHist] = useState(HISTORIAL_POR_TANDA);

  const hoy = new Date().toISOString().slice(0,10);
  const [form, setForm] = useState({
    periodo:"quincenal" as "semanal"|"quincenal"|"mensual",
    fechaInicio:"", fechaFin:"", fechaPago:hoy,
    otrosDescuentos:"0", otrosDescuentosConcepto:"",
  });
  const setF = (k:string, v:any) => setForm(p=>({...p,[k]:v}));

  useEffect(() => { cargar(); }, []);

  const cargar = async () => {
    setCargando(true);
    try {
      const qt = query(collection(db,"trabajadores"), where("userId","==",currentUser.uid));
      const qr = query(collection(db,"recibos_nomina"), where("userId","==",currentUser.uid));
      const [st, sr] = await Promise.all([getDocs(qt), getDocs(qr)]);
      const tArr = st.docs.map(d=>({id:d.id,...d.data()})).filter((t:any)=>t.status==="activo");
      tArr.sort((a:any,b:any)=>a.nombre.localeCompare(b.nombre));
      const rArr = sr.docs.map(d=>({id:d.id,...d.data()} as ReciboPago));
      rArr.sort((a,b)=>b.folio.localeCompare(a.folio));
      setTrabajadores(tArr);
      setRecibos(rArr);
    } catch(e){ console.error(e); }
    setCargando(false);
  };

  // Calcular nómina
  const calcular = () => {
    if (!trabajadorSel || !form.fechaInicio || !form.fechaFin) return null;
    const inicio = new Date(form.fechaInicio+"T12:00:00");
    const fin = new Date(form.fechaFin+"T12:00:00");
    const dias = Math.ceil((fin.getTime()-inicio.getTime())/(1000*60*60*24))+1;
    const sd = trabajadorSel.salarioDiario;
    const bruto = Math.round(sd * dias * 100) / 100;
    const imss = calcularIMSS(sd, dias);
    const isr = calcularISR(bruto, form.periodo);
    const otros = parseFloat(form.otrosDescuentos)||0;
    const deducciones = Math.round((imss + isr + otros)*100)/100;
    const neto = Math.round((bruto - deducciones)*100)/100;
    return {dias, bruto, imss, isr, otros, deducciones, neto};
  };

  const calc = calcular();

  const guardarRecibo = async () => {
    if (!calc || !trabajadorSel) return;
    setGuardando(true);
    try {
      const recibo: Omit<ReciboPago,"id"> = {
        userId: currentUser.uid,
        trabajadorId: trabajadorSel.id,
        trabajadorNombre: trabajadorSel.nombre,
        trabajadorPuesto: trabajadorSel.puesto,
        periodo: form.periodo,
        fechaInicio: form.fechaInicio,
        fechaFin: form.fechaFin,
        fechaPago: form.fechaPago,
        diasTrabajados: calc.dias,
        salarioDiario: trabajadorSel.salarioDiario,
        salarioBruto: calc.bruto,
        imssObrero: calc.imss,
        isrRetenido: calc.isr,
        otrosDescuentos: calc.otros,
        otrosDescuentosConcepto: form.otrosDescuentosConcepto,
        percepciones: calc.bruto,
        totalDeducciones: calc.deducciones,
        netoAPagar: calc.neto,
        folio: generarFolio(),
        status: "pendiente",
        timestamp: Timestamp.now(),
      };
      await addDoc(collection(db,"recibos_nomina"), recibo);
      await cargar();
      setVista("historial");   // SOLO si el recibo quedo guardado. Antes se saltaba al
                               // historial pasara lo que pasara, y el patron se quedaba
                               // creyendo que existia un recibo que nunca se escribio.
    } catch(e:any){ console.error(e); alert("No se pudo guardar el recibo de nomina. NO se genero: " + (e?.code || e?.message || "error desconocido")); }
    setGuardando(false);
  };

  const marcarPagado = async (id:string) => {
    await updateDoc(doc(db,"recibos_nomina",id),{status:"pagado"});
    await cargar();
  };

  const fmt = (n:number) => n.toLocaleString("es-MX",{style:"currency",currency:"MXN",minimumFractionDigits:2, maximumFractionDigits: 2});

  const generarPDFRecibo = async (r:ReciboPago) => {
    // El candado: sin denominación no se emite. La UI ya lo impide antes de
    // llegar aquí; esto es el cierre, para que ninguna ruta futura se lo salte.
    if (!datosPatronCompletos(cfgPatron)) { abrirDatosDelPatron(); return; }
    // A NOMBRE DE LA RAZÓN SOCIAL DEL TRABAJADOR al fin del periodo pagado (12-oct-2026).
    let dp: DatosPatron;
    try { dp = await datosPatronParaDocumento(currentUser?.uid || "", datosPatronDe(cfgPatron), (trabajadores||[]).find((x:any)=> x.id === r.trabajadorId) || null, r.fechaFin); }
    catch(e:any){ alert((e && e.message) || "No se pudo generar el recibo."); return; }
    const empresa = dp.denominacion;
    const rfcPatron = dp.rfc;
    const domPatron = domicilioPatronTexto(dp);
    // LAS NOTAS DE LA RAZÓN SOCIAL (12-oct-2026): si cambió dentro del periodo pagado,
    // o si su primera razón social se asignó con efecto desde el inicio.
    const fichaRec = (trabajadores||[]).find((x:any)=> x.id === r.trabajadorId) || null;
    let notasRec: string[] = [];
    if (fichaRec && !sinHistorialDeAsignacion(fichaRec.historialRazonSocial)) {
      const cat = await leerCatalogosDeEmpresa(currentUser?.uid || "");
      notasRec = avisosDeRazonSocial(fichaRec, cat.razones, _msInicioDeFechaDocumento(r.fechaInicio), _msDeFechaDocumento(r.fechaFin));
    }
    const html = `<!DOCTYPE html><html lang="es"><head><meta charset="UTF-8">
    <title>Recibo de Nómina — ${r.trabajadorNombre}</title>
    <style>
      *{box-sizing:border-box;margin:0;padding:0}
      body{font-family:'Arial',sans-serif;color:#1A1A2E;padding:40px 50px;font-size:12px;background:white;text-align:justify}
      .header{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:28px;padding-bottom:16px;border-bottom:3px solid #162447}
      .logo{font-size:22px;font-weight:900;color:#162447}
      .logo span{color:#B8932A}
      .folio-box{background:#162447;color:white;padding:10px 16px;border-radius:8px;text-align:right}
      .seccion{background:#F4F6FB;border-radius:8px;padding:14px 18px;margin-bottom:14px}
      .seccion-titulo{font-size:10px;font-weight:700;color:#6B7CB8;text-transform:uppercase;letter-spacing:1px;margin-bottom:10px}
      .grid2{display:grid;grid-template-columns:1fr 1fr;gap:10px}
      .grid3{display:grid;grid-template-columns:1fr 1fr 1fr;gap:10px}
      .dato label{font-size:9px;color:#9A9AAA;display:block;text-transform:uppercase;letter-spacing:0.5px;margin-bottom:3px}
      .dato span{font-size:13px;font-weight:600;color:#0F1D35}
      table{width:100%;border-collapse:collapse;margin-bottom:14px}
      thead{background:#162447}
      thead th{padding:8px 12px;font-size:10px;color:rgba(255,255,255,0.8);text-align:left;font-weight:700}
      td{padding:8px 12px;font-size:12px;border-bottom:1px solid #eee}
      .total-row{background:#F4F6FB;font-weight:700}
      .neto-row{background:#162447;color:white}
      .neto-row td{color:white;font-size:14px;font-weight:800;border-bottom:none}
      .neto-monto{color:#B8932A!important;font-size:16px!important}
      .firmas{display:grid;grid-template-columns:1fr 1fr;gap:50px;margin-top:40px}
      .firma{text-align:center}
      .firma-linea{border-top:1px solid #162447;margin-bottom:8px}
      .footer{text-align:center;margin-top:24px;padding-top:14px;border-top:1px solid #eee;font-size:9px;color:#9A9AAA}
      @media print{body{padding:24px 32px}}
    </style></head><body>
    <!-- LA CABECERA ES DEL PATRÓN. Aquí iba el logo de AXIS, "AXIS Legal" y
         "Asesoría Legal Corporativa · Aguascalientes", con el nombre de la
         empresa debajo y más chico: el recibo de una clienta salía con el
         membrete del despacho que le vende la plataforma. En un recibo de
         nómina el patrón es quien paga y quien firma; nadie más tiene por qué
         aparecer arriba. -->
    <div class="header">
      <div>
        <div class="logo">${empresa}</div>
        <div style="font-size:10.5px;color:#162447;margin-top:5px">RFC ${rfcPatron}</div>
        <div style="font-size:10px;color:#6B7CB8;margin-top:3px;max-width:330px;line-height:1.45">${domPatron}</div>
      </div>
      <div class="folio-box">
        <div style="font-size:9px;color:rgba(255,255,255,0.6);margin-bottom:4px">RECIBO DE NÓMINA</div>
        <div style="font-size:14px;font-weight:800;color:#B8932A">${r.folio}</div>
        <div style="font-size:10px;color:rgba(255,255,255,0.7);margin-top:4px">Período: ${r.periodo.toUpperCase()}</div>
      </div>
    </div>

    <div class="seccion">
      <div class="seccion-titulo">Datos del trabajador</div>
      <div class="grid3">
        <div class="dato"><label>Nombre completo</label><span>${r.trabajadorNombre}</span></div>
        <div class="dato"><label>Puesto</label><span>${r.trabajadorPuesto||"—"}</span></div>
        <div class="dato"><label>Salario diario</label><span>${fmt(r.salarioDiario)}</span></div>
      </div>
    </div>

    <div class="seccion">
      <div class="seccion-titulo">Período de pago</div>
      <div class="grid3">
        <div class="dato"><label>Fecha inicio</label><span>${new Date(r.fechaInicio+"T12:00:00").toLocaleDateString("es-MX",{day:"2-digit",month:"short",year:"numeric"})}</span></div>
        <div class="dato"><label>Fecha fin</label><span>${new Date(r.fechaFin+"T12:00:00").toLocaleDateString("es-MX",{day:"2-digit",month:"short",year:"numeric"})}</span></div>
        <div class="dato"><label>Días trabajados</label><span>${r.diasTrabajados} días</span></div>
      </div>
    </div>

    <table>
      <thead><tr><th>Concepto</th><th>Tipo</th><th style="text-align:right">Importe</th></tr></thead>
      <tbody>
        <tr><td>Salario por ${r.diasTrabajados} días × ${fmt(r.salarioDiario)}/día</td><td><span style="color:#059669;font-weight:700">PERCEPCIÓN</span></td><td style="text-align:right;font-weight:700">${fmt(r.salarioBruto)}</td></tr>
        <tr class="total-row"><td colspan="2"><strong>Total Percepciones</strong></td><td style="text-align:right;color:#059669"><strong>${fmt(r.percepciones)}</strong></td></tr>
        <tr><td>Cuota IMSS obrera (Art. 25 LSS)</td><td><span style="color:#EF4444;font-weight:700">DEDUCCIÓN</span></td><td style="text-align:right">-${fmt(r.imssObrero)}</td></tr>
        <tr><td>ISR retenido (Art. 96 LISR 2026)</td><td><span style="color:#EF4444;font-weight:700">DEDUCCIÓN</span></td><td style="text-align:right">-${fmt(r.isrRetenido)}</td></tr>
        ${r.otrosDescuentos>0?`<tr><td>${r.otrosDescuentosConcepto||"Otros descuentos"}</td><td><span style="color:#EF4444;font-weight:700">DEDUCCIÓN</span></td><td style="text-align:right">-${fmt(r.otrosDescuentos)}</td></tr>`:""}
        <tr class="total-row"><td colspan="2"><strong>Total Deducciones</strong></td><td style="text-align:right;color:#EF4444"><strong>-${fmt(r.totalDeducciones)}</strong></td></tr>
        <tr class="neto-row"><td colspan="2"><strong>NETO A PAGAR</strong></td><td style="text-align:right" class="neto-monto"><strong>${fmt(r.netoAPagar)}</strong></td></tr>
      </tbody>
    </table>

    <div style="background:rgba(184,147,42,0.06);border:1px solid rgba(184,147,42,0.2);border-radius:8px;padding:12px 16px;font-size:11px;color:#6B5A3A">
      <strong>Nota:</strong> Los cálculos de IMSS e ISR son estimados conforme a las tablas vigentes 2026 (ISR: Anexo 8 RMF · DOF 28/12/2025; IMSS: cuota CEAV patronal 6.361%–7.513% según SBC). Para efectos fiscales definitivos se recomienda verificar con contador certificado.
    </div>

    ${bloqueDeNotasHTML(notasRec)}
    <div class="firmas">
      <div class="firma">
        <div style="height:55px"></div>
        <div class="firma-linea"></div>
        <strong>${r.trabajadorNombre}</strong><br/>
        <span style="font-size:10px;color:#6B7CB8">Trabajador</span><br/><span style="font-size:10px;color:#6B7CB8">Firma de recibido</span>
      </div>
      <div class="firma">
        <div style="height:55px"></div>
        <div class="firma-linea"></div>
        ${firmaDelPatronHTML(empresa, rfcPatron, dp.tipoPersona)}
      </div>
    </div>

    <div class="footer">Generado por ${empresa} mediante la plataforma AXIS Legaltech · ${fechaHoraLargaAxis()} · ${MARCA_EDICION_DOCS}</div>
    <script>window.onload=()=>window.print()</script>
    </body></html>`;

    const blob = new Blob([html],{type:"text/html"});
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href=url; a.download=`Recibo_${r.folio}_${r.trabajadorNombre.replace(/ /g,"_")}.html`;
    a.click(); URL.revokeObjectURL(url);
  };

  // ── VISTA GENERAR ──
  if (vista==="generar" && trabajadorSel) return (
    <div {...ZONA_DE_CAPTURA} style={{fontFamily:fontSans}}>
      <div style={{background:"rgba(22,36,71,0.04)",padding:"10px 20px",borderBottom:"1px solid rgba(22,36,71,0.08)",display:"flex",alignItems:"center",gap:8}}>
        <button onClick={()=>setVista("lista")} style={{background:"rgba(22,36,71,0.08)",border:"1px solid rgba(22,36,71,0.12)",color:"#162447",borderRadius:8,padding:"5px 12px",cursor:"pointer",fontSize:12}}>← Lista</button>
        <span style={{color:UI.texto,fontWeight:600,fontSize:13}}>💼 Recibo — {trabajadorSel.nombre}</span>
      </div>
      <div style={{maxWidth:640,margin:"0 auto",padding:isMobile?"16px":"28px 24px"}}>

        {/* Datos del trabajador */}
        <div style={{background:"white",borderRadius:14,padding:"18px 22px",marginBottom:14,boxShadow:"0 2px 12px rgba(22,36,71,0.07)",border:"1px solid rgba(22,36,71,0.07)"}}>
          <div style={{display:"flex",alignItems:"center",gap:14}}>
            <div style={{width:50,height:50,background:"linear-gradient(135deg,#059669,#047857)",borderRadius:14,display:"flex",alignItems:"center",justifyContent:"center",color:"white",fontWeight:800,fontSize:18,fontFamily:fontSerif}}>
              {trabajadorSel.nombre.charAt(0)}
            </div>
            <div>
              <div style={{fontFamily:fontSerif,fontSize:17,fontWeight:700,color:UI.texto}}>{trabajadorSel.nombre}</div>
              <div style={{fontSize:13,color:UI.textoSuave}}>{trabajadorSel.puesto} · ${(trabajadorSel.salarioDiario).toFixed(2)}/día</div>
            </div>
          </div>
        </div>

        {/* Período */}
        <div style={{background:"white",borderRadius:14,padding:"20px 22px",marginBottom:14,boxShadow:"0 2px 12px rgba(22,36,71,0.07)",border:"1px solid rgba(22,36,71,0.07)"}}>
          <h3 style={{fontFamily:fontSerif,fontSize:15,color:UI.texto,margin:"0 0 14px", display:"flex", alignItems:"center", gap:8}}>
            <AxisIcon name="suite_calendario" size={16} tone="gold" withBackdrop={false} strokeWidth={2.5}/>
            Período de pago
          </h3>
          <div style={{display:"flex",gap:8,marginBottom:14}}>
            {(["semanal","quincenal","mensual"] as const).map(p => (
              <button key={p} onClick={()=>setF("periodo",p)}
                style={{flex:1,padding:"10px 6px",borderRadius:10,border:`2px solid ${form.periodo===p?"#059669":"rgba(22,36,71,0.12)"}`,background:form.periodo===p?"rgba(5,150,105,0.06)":"white",cursor:"pointer",fontSize:12,fontWeight:700,color:form.periodo===p?"#059669":"#4A4A60",textTransform:"capitalize" as const}}>
                {p}
              </button>
            ))}
          </div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:12}}>
            {[
              {label:"Fecha inicio *",key:"fechaInicio"},
              {label:"Fecha fin *",key:"fechaFin"},
              {label:"Fecha de pago *",key:"fechaPago"},
            ].map(c=>(
              <div key={c.key}>
                <label style={{fontSize:10,color:UI.textoTenue,display:"block",marginBottom:4,textTransform:"uppercase" as const,letterSpacing:"0.5px"}}>{c.label}</label>
                <input value={(form as any)[c.key]} onChange={e=>setF(c.key,e.target.value)} type="date"
                  style={{width:"100%",padding:"10px 12px",border:"1px solid rgba(22,36,71,0.12)",borderRadius:10,fontSize:12,outline:"none",boxSizing:"border-box" as const}} />
              </div>
            ))}
          </div>
          {/* EL AVISO DEL PERIODO. Va aqui, pegado a las fechas, y no en el PDF:
              se tiene que ver ANTES de emitir, no despues de firmar. */}
          {(()=>{ const av = calc ? avisoPeriodoRecibo(form.periodo, calc.dias) : ""; if (!av) return null; return (
            <div style={{marginTop:12, background:"rgba(184,147,42,0.10)", border:"1px solid rgba(184,147,42,0.34)",
              borderRadius:10, padding:"11px 13px", fontSize:12, color:"#5A4A18", lineHeight:1.6}}>
              <b style={{color:"#7A5F12"}}>Revisa el periodo.</b>{" "}{av}
            </div>
          ); })()}
        </div>

        {/* Descuentos adicionales */}
        <div style={{background:"white",borderRadius:14,padding:"20px 22px",marginBottom:14,boxShadow:"0 2px 12px rgba(22,36,71,0.07)",border:"1px solid rgba(22,36,71,0.07)"}}>
          <h3 style={{fontFamily:fontSerif,fontSize:15,color:UI.texto,margin:"0 0 14px"}}>➖ Descuentos adicionales (opcional)</h3>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
            <div>
              <label style={{fontSize:10,color:UI.textoTenue,display:"block",marginBottom:4,textTransform:"uppercase" as const,letterSpacing:"0.5px"}}>Monto a descontar</label>
              <input value={form.otrosDescuentos} onChange={e=>setF("otrosDescuentos",e.target.value)} type="number" placeholder="0.00"
                style={{width:"100%",padding:"10px 12px",border:"1px solid rgba(22,36,71,0.12)",borderRadius:10,fontSize:13,outline:"none",boxSizing:"border-box" as const}} />
            </div>
            <div>
              <label style={{fontSize:10,color:UI.textoTenue,display:"block",marginBottom:4,textTransform:"uppercase" as const,letterSpacing:"0.5px"}}>Concepto</label>
              <input value={form.otrosDescuentosConcepto} onChange={e=>setF("otrosDescuentosConcepto",e.target.value)} placeholder="Ej. Préstamo, falta..."
                style={{width:"100%",padding:"10px 12px",border:"1px solid rgba(22,36,71,0.12)",borderRadius:10,fontSize:13,outline:"none",boxSizing:"border-box" as const}} />
            </div>
          </div>
        </div>

        {/* Vista previa del cálculo */}
        {calc && (
          <div style={{background:"linear-gradient(135deg,#0F1D35,#162447)",borderRadius:16,padding:"22px",marginBottom:16,boxShadow:"0 8px 32px rgba(22,36,71,0.25)"}}>
            <div style={{fontSize:12,color:"rgba(184,147,42,0.7)",fontWeight:700,textTransform:"uppercase" as const,letterSpacing:"1px",marginBottom:14}}>Vista previa del recibo</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:16}}>
              {[
                {label:"Días trabajados",val:`${calc.dias} días`,color:"white"},
                {label:"Salario bruto",val:fmt(calc.bruto),color:"#6EE7B7"},
                {label:"IMSS obrero",val:`-${fmt(calc.imss)}`,color:"#FCA5A5"},
                {label:"ISR retenido",val:`-${fmt(calc.isr)}`,color:"#FCA5A5"},
                ...(calc.otros>0?[{label:form.otrosDescuentosConcepto||"Otros",val:`-${fmt(calc.otros)}`,color:"#FCA5A5"}]:[]),
                {label:"Total deducciones",val:`-${fmt(calc.deducciones)}`,color:"#FCA5A5"},
              ].map((d,i)=>(
                <div key={i} style={{background:"rgba(255,255,255,0.05)",borderRadius:10,padding:"10px 12px",border:"1px solid rgba(255,255,255,0.08)"}}>
                  <div style={{fontSize:10,color:"rgba(255,255,255,0.4)",marginBottom:3,textTransform:"uppercase" as const,letterSpacing:"0.5px"}}>{d.label}</div>
                  <div style={{fontSize:14,fontWeight:700,color:d.color}}>{d.val}</div>
                </div>
              ))}
            </div>
            <div style={{background:"rgba(184,147,42,0.15)",borderRadius:12,padding:"16px 18px",border:"1px solid rgba(184,147,42,0.3)",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <span style={{fontSize:14,fontWeight:700,color:"white"}}>NETO A PAGAR</span>
              <span style={{fontFamily:fontSerif,fontSize:28,fontWeight:900,color:"#D4A843"}}>{fmt(calc.neto)}</span>
            </div>
          </div>
        )}

        <button onClick={guardarRecibo} disabled={guardando||!calc||!form.fechaInicio||!form.fechaFin}
          style={{width:"100%",background:calc&&form.fechaInicio&&form.fechaFin?"linear-gradient(135deg,#059669,#047857)":"rgba(0,0,0,0.08)",border:"none",borderRadius:14,padding:"16px",cursor:"pointer",fontSize:15,fontWeight:700,color:calc&&form.fechaInicio&&form.fechaFin?"white":"#9A9AAA",boxShadow:calc&&form.fechaInicio&&form.fechaFin?"0 4px 16px rgba(5,150,105,0.3)":"none"}}>
          {guardando?"Guardando...":<><AxisIcon name="document" size={14} tone="gold" withBackdrop={false} strokeWidth={2}/>Guardar recibo en historial</>}
        </button>
        <div style={{fontSize:11,color:UI.textoTenue,textAlign:"center" as const,marginTop:8}}>
          Podrás descargar el PDF desde el historial
        </div>
      </div>
    </div>
  );

  // ── LISTA PRINCIPAL ──
  const nominasPendientes = recibos.filter(r=>r.status==="pendiente").length;
  const totalPendiente = recibos.filter(r=>r.status==="pendiente").reduce((s,r)=>s+r.netoAPagar,0);
  const sinRecibos = recibos.length===0;
  // Nómina emitida en el mes en curso, por FECHA DE PAGO del recibo. Es un corte
  // distinto de "Total por pagar" (que es acumulado y solo lo no pagado), así que
  // el micro-contexto de cada uno dice explícitamente qué mide: sumarlos no da
  // nada. No se recalcula nada: se suma el neto que ya quedó guardado.
  const _hoyMes = new Date();
  const _claveMes = `${_hoyMes.getFullYear()}-${String(_hoyMes.getMonth()+1).padStart(2,"0")}`;
  const _nombreMes = _hoyMes.toLocaleDateString("es-MX",{month:"long"});
  const recibosDelMes = recibos.filter(r=>(r.fechaPago||"").slice(0,7)===_claveMes);
  const emitidoMes = recibosDelMes.reduce((s,r)=>s+r.netoAPagar,0);
  const pendientesDelMes = recibosDelMes.filter(r=>r.status==="pendiente").length;
  const sinSalario = trabajadores.filter(t=>!(salDiarioDe(t)>0)).length;

  // Una fila por trabajador con lo que ya está cargado: sus recibos, cuántos
  // quedan pendientes y cuál fue el último. `recibos` ya viene ordenado por
  // folio descendente, así que el primero de cada quien es el más reciente.
  const filasNomina = trabajadores.map((t:any)=>{
    const recibosT = recibos.filter(r=>r.trabajadorId===t.id);
    return {t, pendientes: recibosT.filter(r=>r.status==="pendiente").length, ultimo: recibosT[0]};
  });
  const bq = busqueda.trim().toLowerCase();
  const filasFiltradas = bq
    ? filasNomina.filter(f => (f.t.nombre||"").toLowerCase().includes(bq) || (f.t.puesto||"").toLowerCase().includes(bq))
    : filasNomina;
  const filas = filasFiltradas.slice().sort((a,b)=>{
    const dir = ordenDir==="asc" ? 1 : -1;
    if (ordenCol==="pendientes") return (a.pendientes - b.pendientes) * dir;
    return (a.t.nombre||"").localeCompare((b.t.nombre||""), "es") * dir;
  });
  // Historial ya filtrado y ordenado. El orden por período usa la fecha de
  // INICIO, que es la que se ve en la columna, para que lo que ordena sea lo
  // mismo que se lee. Nada de esto recalcula el recibo: solo lo acomoda.
  const _bqH = busqHist.trim().toLowerCase();
  const recibosVisibles = recibos
    .filter(r => filtroEstado==="todos" ? true : r.status===filtroEstado)
    .filter(r => !_bqH || (r.trabajadorNombre||"").toLowerCase().includes(_bqH) || (r.folio||"").toLowerCase().includes(_bqH))
    .slice()
    .sort((a,b)=>{
      const dir = dirHist==="asc" ? 1 : -1;
      if (ordenHist==="trabajador") return (a.trabajadorNombre||"").localeCompare((b.trabajadorNombre||""), "es") * dir;
      return (a.fechaInicio||"").localeCompare(b.fechaInicio||"") * dir;
    });

  const fechaCorta = (s?:string) => s
    ? new Date(s+"T12:00:00").toLocaleDateString("es-MX",{day:"2-digit",month:"short",year:"numeric"})
    : "";
  const abrirGenerar = (t:any) => {
    setTrabajadorSel(t);
    setForm(p=>({...p,fechaInicio:"",fechaFin:"",fechaPago:hoy,otrosDescuentos:"0",otrosDescuentosConcepto:""}));
    setVista("generar");
  };

  return (
    <div {...ZONA_DE_CAPTURA} style={{background:UI.fondo, minHeight:`calc(100vh - 100px - ${ZOCALO_FLOTANTES}px)`, fontFamily:fontSans}}>
      {/* NAVEGA (no explica ni acciona) → siempre visible. El sidebar devuelve
          siempre a "Generar" porque al entrar se vuelve a montar el módulo. */}
      <div style={{background:UI.superficie, borderBottom:`1px solid ${UI.borde}`, position:"sticky" as const, top:0, zIndex:50}}>
        <div style={{maxWidth:ANCHO_CONTENIDO, margin:"0 auto", padding:isMobile?"0 16px":"0 24px", height:46, display:"flex", alignItems:"center"}}>
          <SegmentadoFiltro fontSans={fontSans}
            valor={vista==="historial" ? "historial" : "generar"}
            onCambio={(v)=>setVista(v==="historial" ? "historial" : "lista")}
            opciones={[{v:"generar" as const, t:"Generar"}, {v:"historial" as const, t:"Historial"}]}/>
        </div>
      </div>

      <div style={{maxWidth:ANCHO_CONTENIDO, margin:"0 auto", padding:isMobile?"16px":"18px 24px"}}>
        {/* ── INDICADORES ── el filete dice ESTADO, no módulo: navy es neutro,
             ámbar avisa que hay algo por pagar y verde que no queda nada. */}
        <div style={{display:"grid", gridTemplateColumns:isMobile?"repeat(2,1fr)":"repeat(4,1fr)", gap:12, marginBottom:18}}>
          <IndicadorTarjeta isMobile={isMobile} fontSerif={fontSerif}
            etiqueta="Trabajadores activos" valor={String(trabajadores.length)} icono="user_single" tono={UI.navy}
            micro={trabajadores.length===0 ? "sin plantilla activa"
                 : sinSalario>0 ? `${sinSalario} sin salario registrado`
                 : "todos con salario registrado"}/>
          {/* Nunca haber generado un recibo no es "cero pendientes": se dice. */}
          <IndicadorTarjeta isMobile={isMobile} fontSerif={fontSerif}
            etiqueta="Recibos pendientes"
            valor={sinRecibos ? "Sin registrar" : String(nominasPendientes)}
            icono="clipboard"
            tono={sinRecibos ? UI.neutro : nominasPendientes>0 ? UI.ambar : UI.ok}
            micro={sinRecibos ? "aún no generas recibos"
                 : nominasPendientes>0 ? `de ${recibos.length} generado${recibos.length===1?"":"s"}`
                 : "todos los recibos pagados"}/>
          {/* Emitido en el mes: incluye pagados y no pagados. Se dice con esas
              palabras para que no se lea como parte del "Total por pagar". */}
          <IndicadorTarjeta isMobile={isMobile} fontSerif={fontSerif}
            etiqueta={`Nómina emitida en ${_nombreMes}`}
            valor={recibosDelMes.length===0 ? "Sin registrar" : fmt(emitidoMes)}
            icono="clipboard" tono={UI.navy}
            micro={recibosDelMes.length===0 ? `sin recibos con fecha de pago en ${_nombreMes}`
                 : pendientesDelMes>0 ? `${recibosDelMes.length} recibo${recibosDelMes.length===1?"":"s"} del mes, pagados y no pagados`
                 : `${recibosDelMes.length} recibo${recibosDelMes.length===1?"":"s"} del mes, todos pagados`}/>
          {/* Acumulado histórico de lo NO pagado: otro corte, no el del mes. */}
          <IndicadorTarjeta isMobile={isMobile} fontSerif={fontSerif}
            etiqueta="Total por pagar"
            valor={sinRecibos ? "Sin registrar" : fmt(totalPendiente)}
            icono="money" tono={UI.navy}
            micro={sinRecibos ? "sin recibos que liquidar"
                 : nominasPendientes>0 ? `${nominasPendientes} recibo${nominasPendientes===1?"":"s"} sin pagar, de cualquier mes`
                 : "sin saldo pendiente"}/>
        </div>

        {/* EL CANDADO, UNA VEZ Y ARRIBA. El recibo se sigue calculando y guardando
            —eso no afirma nada sobre la empresa—; lo que no se emite es el PDF
            firmado, que sí tiene que decir con qué empresa se firma. */}
        {faltanDelPatron.length > 0 && (
          <AvisoFaltanDatosPatron faltan={faltanDelPatron} que="El recibo de nómina" fontSans={fontSans} fontSerif={fontSerif}/>
        )}
        {vista==="historial" ? (
          // ── HISTORIAL ──
          <>
            {recibos.length===0 ? (
              <EstadoVacio
                titulo="Sin recibos generados"
                texto="Aquí se van guardando los recibos que emitas, con su folio, su período y su estado de pago. Genera el primero desde la lista de trabajadores."
                acciones={[{t:"Ir a generar un recibo", principal:true, fn:()=>setVista("lista")}]}
                icono="clipboard"
                fontSans={fontSans} fontSerif={fontSerif}
              />
            ) : (
              <>
                <div style={{display:"flex", gap:10, marginBottom:14, flexWrap:"wrap" as const, alignItems:"center"}}>
                  <input value={busqHist} onChange={e=>{setBusqHist(e.target.value); setTopeHist(HISTORIAL_POR_TANDA);}}
                    placeholder="Buscar por trabajador o folio…"
                    style={{flex:1, minWidth:220, background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rControl,
                      padding:"9px 13px", color:UI.texto, fontSize:UI.fsCuerpo, outline:"none", fontFamily:fontSans, boxSizing:"border-box" as const}} />
                  <SegmentadoFiltro fontSans={fontSans} valor={filtroEstado}
                    onCambio={(v)=>{ setFiltroEstado(v); setTopeHist(HISTORIAL_POR_TANDA); }}
                    opciones={[{v:"todos" as const, t:"Todos"}, {v:"pagado" as const, t:"Pagados"}, {v:"pendiente" as const, t:"Pendientes"}]}/>
                </div>

                {recibosVisibles.length===0 ? (
                  <EstadoVacio
                    titulo="Ningún recibo coincide"
                    texto="Prueba con otro texto de búsqueda o cambia el filtro de estado."
                    acciones={[{t:"Quitar filtros", principal:false, fn:()=>{ setBusqHist(""); setFiltroEstado("todos"); }}]}
                    variante="sin-coincidencias"
                    fontSans={fontSans} fontSerif={fontSerif}
                  />
                ) : (
                  <div style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rPanel, boxShadow:UI.sombra, overflow:"hidden"}}>
                    <div style={{height:2, background:`linear-gradient(90deg, ${UI.oro}, ${UI.oro}00)`}}/>
                    <div style={{maxHeight:`calc(100vh - 380px - ${ZOCALO_FLOTANTES}px)`, minHeight:220, overflowY:"auto" as const, overflowX:"auto" as const}}>
                      <table style={{width:"100%", borderCollapse:"separate" as const, borderSpacing:0, minWidth:900}}>
                        <EncabezadoTabla ordenCol={ordenHist} ordenDir={dirHist}
                          onOrdenar={(col,dir)=>{ setOrdenHist(col as any); setDirHist(dir); }}
                          columnas={[
                            {k:"folio", t:"Folio", orden:false, al:"left"},
                            {k:"trabajador", t:"Trabajador", orden:true, al:"left"},
                            {k:"periodo", t:"Período", orden:true, al:"left"},
                            {k:"neto", t:"Neto", orden:false, al:"right"},
                            {k:"estado", t:"Estado", orden:false, al:"center"},
                            {k:"acc", t:"Acción", orden:false, al:"right"},
                          ]}/>
                        <tbody>
                          {recibosVisibles.slice(0, topeHist).map(r=>(
                            <tr key={r.id}
                              onMouseEnter={(e)=>{ e.currentTarget.style.background = UI.hover; }}
                              onMouseLeave={(e)=>{ e.currentTarget.style.background = "transparent"; }}
                              style={{transition:"background .12s"}}>
                              {/* Folio — es el identificador legal del recibo */}
                              <td style={{padding:"11px 14px", borderTop:`1px solid ${UI.divisor}`, fontSize:UI.fsEtiqueta, color:UI.textoTenue, whiteSpace:"nowrap" as const}}>{r.folio}</td>
                              {/* Trabajador */}
                              <td style={{padding:"11px 14px", borderTop:`1px solid ${UI.divisor}`}}>
                                <div style={{display:"flex", alignItems:"center", gap:11, minWidth:0}}>
                                  <AvatarPersona nombre={r.trabajadorNombre||""} size={30} fontSerif={fontSerif}/>
                                  <div style={{minWidth:0}}>
                                    <div style={{fontFamily:fontSerif, fontSize:UI.fsNombre, fontWeight:700, color:UI.texto,
                                      whiteSpace:"nowrap" as const, overflow:"hidden", textOverflow:"ellipsis"}}>{r.trabajadorNombre}</div>
                                    <div style={{fontSize:UI.fsEtiqueta, color:UI.textoTenue, marginTop:2,
                                      whiteSpace:"nowrap" as const, overflow:"hidden", textOverflow:"ellipsis"}}>{r.trabajadorPuesto || "Sin puesto"}</div>
                                  </div>
                                </div>
                              </td>
                              {/* Período: el rango y, debajo, con qué periodicidad se emitió */}
                              <td style={{padding:"11px 14px", borderTop:`1px solid ${UI.divisor}`, whiteSpace:"nowrap" as const}}>
                                <div style={{fontSize:UI.fsCuerpo, color:UI.textoSuave}}>{fechaCorta(r.fechaInicio)} — {fechaCorta(r.fechaFin)}</div>
                                <div style={{fontSize:UI.fsEtiqueta, color:UI.textoTenue, marginTop:2, textTransform:"capitalize" as const}}>{r.periodo}</div>
                              </td>
                              {/* Neto, con el bruto de contexto debajo */}
                              <td style={{padding:"11px 14px", borderTop:`1px solid ${UI.divisor}`, textAlign:"right" as const, whiteSpace:"nowrap" as const}}>
                                <div style={{fontSize:UI.fsCuerpo, fontWeight:700, color:UI.texto}}>{fmt(r.netoAPagar)}</div>
                                <div style={{fontSize:UI.fsRotulo, color:UI.textoTenue, marginTop:2}}>Bruto {fmt(r.salarioBruto)}</div>
                              </td>
                              {/* Estado */}
                              <td style={{padding:"11px 14px", borderTop:`1px solid ${UI.divisor}`, textAlign:"center" as const}}>
                                <ChipEstado texto={r.status==="pagado"?"Pagado":"Pendiente"} tono={r.status==="pagado"?"ok":"pendiente"}/>
                              </td>
                              {/* Acciones — en texto: repetir iconos en cada fila sería ruido */}
                              <td style={{padding:"11px 14px", borderTop:`1px solid ${UI.divisor}`, textAlign:"right" as const, whiteSpace:"nowrap" as const}}>
                                <button onClick={()=>generarPDFRecibo(r)}
                                  title={faltanDelPatron.length ? "Faltan los datos de tu empresa" : undefined}
                                  style={{background:"transparent", border:"none", cursor:"pointer", fontFamily:fontSans,
                                    fontSize:UI.fsEtiqueta, fontWeight:700, color:faltanDelPatron.length?UI.ambar:UI.navy, padding:"2px 0"}}>
                                  {faltanDelPatron.length ? "Faltan datos de tu empresa" : "Descargar PDF"}
                                </button>
                                {r.status==="pendiente" && r.id && (
                                  <button onClick={()=>marcarPagado(r.id!)}
                                    style={{background:"transparent", border:"none", cursor:"pointer", fontFamily:fontSans,
                                      fontSize:UI.fsEtiqueta, fontWeight:700, color:UI.ok, padding:"2px 0", marginLeft:14}}>Marcar pagado</button>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <div style={{padding:"9px 14px", borderTop:`1px solid ${UI.divisor}`, fontSize:10.5, color:UI.textoTenue,
                      background:UI.superficie, display:"flex", alignItems:"center", justifyContent:"space-between", gap:10}}>
                      <span>Mostrando {Math.min(topeHist, recibosVisibles.length)} de {recibosVisibles.length} recibo{recibosVisibles.length===1?"":"s"}
                        {recibosVisibles.length!==recibos.length ? ` · ${recibos.length} en total` : ""}</span>
                      {recibosVisibles.length > topeHist && (
                        <button onClick={()=>setTopeHist(n=>n+HISTORIAL_POR_TANDA)}
                          style={{background:"transparent", border:"none", cursor:"pointer", fontFamily:fontSans,
                            fontSize:UI.fsEtiqueta, fontWeight:700, color:UI.navy, padding:"2px 0"}}>
                          Mostrar {Math.min(HISTORIAL_POR_TANDA, recibosVisibles.length - topeHist)} más ›
                        </button>
                      )}
                    </div>
                  </div>
                )}
              </>
            )}
          </>
        ) : (
          // ── LISTA DE TRABAJADORES ──
          <>
            {trabajadores.length>0 && (
              <div style={{display:"flex", gap:10, marginBottom:14, flexWrap:"wrap" as const, alignItems:"center"}}>
                <input value={busqueda} onChange={e=>setBusqueda(e.target.value)} placeholder="Buscar por nombre o puesto…"
                  style={{flex:1, minWidth:220, background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rControl,
                    padding:"9px 13px", color:UI.texto, fontSize:UI.fsCuerpo, outline:"none", fontFamily:fontSans, boxSizing:"border-box" as const}} />
              </div>
            )}
            {cargando ? (
              <div style={{textAlign:"center" as const, padding:60, color:UI.textoSuave, background:UI.superficie,
                border:`1px solid ${UI.borde}`, borderRadius:UI.rPanel}}>Cargando trabajadores…</div>
            ) : filas.length===0 ? (
              <EstadoVacio
                titulo={trabajadores.length===0 ? "Sin trabajadores registrados" : "Ningún trabajador coincide"}
                texto={trabajadores.length===0
                  ? "Los recibos se generan sobre tu plantilla activa. Da de alta a tus trabajadores en Empleados y vuelve aquí para emitir su recibo con el cálculo de ISR y cuota IMSS."
                  : "Prueba con otro texto de búsqueda."}
                acciones={trabajadores.length===0
                  ? [{t:"Ir a Empleados", principal:true, fn:onIrExpediente}]
                  : [{t:"Quitar la búsqueda", principal:false, fn:()=>setBusqueda("")}]}
                variante={trabajadores.length===0 ? "sin-datos" : "sin-coincidencias"}
                fontSans={fontSans} fontSerif={fontSerif}
              />
            ) : (
              <div style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rPanel, boxShadow:UI.sombra, overflow:"hidden"}}>
                {/* Filete dorado de marca (ornamento, no dato) */}
                <div style={{height:2, background:`linear-gradient(90deg, ${UI.oro}, ${UI.oro}00)`}}/>
                <div style={{maxHeight:`calc(100vh - 380px - ${ZOCALO_FLOTANTES}px)`, minHeight:220, overflowY:"auto" as const, overflowX:"auto" as const}}>
                  <table style={{width:"100%", borderCollapse:"separate" as const, borderSpacing:0, minWidth:900}}>
                    <EncabezadoTabla ordenCol={ordenCol} ordenDir={ordenDir}
                      onOrdenar={(col,dir)=>{ setOrdenCol(col as any); setOrdenDir(dir); }}
                      columnas={[
                        {k:"nombre", t:"Trabajador", orden:true, al:"left"},
                        {k:"sdiario", t:"Salario diario", orden:false, al:"right"},
                        {k:"smensual", t:"Salario mensual", orden:false, al:"right"},
                        {k:"pendientes", t:"Recibos pendientes", orden:true, al:"center"},
                        {k:"ultimo", t:"Último recibo", orden:false, al:"left"},
                        {k:"acc", t:"", orden:false, al:"right"},
                      ]}/>
                    <tbody>
                      {filas.map(({t, pendientes, ultimo}) => (
                        <tr key={t.id}
                          onClick={()=>abrirGenerar(t)}
                          onMouseEnter={(e)=>{ e.currentTarget.style.background = UI.hover; }}
                          onMouseLeave={(e)=>{ e.currentTarget.style.background = "transparent"; }}
                          style={{cursor:"pointer", transition:"background .12s"}}>
                          {/* Trabajador */}
                          <td style={{padding:"11px 14px", borderTop:`1px solid ${UI.divisor}`}}>
                            <div style={{display:"flex", alignItems:"center", gap:11, minWidth:0}}>
                              <AvatarPersona nombre={t.nombre||""} fotoUrl={(t as any).fotoPerfilUrl} size={34} fontSerif={fontSerif}/>
                              <div style={{minWidth:0}}>
                                <div style={{fontFamily:fontSerif, fontSize:UI.fsNombre, fontWeight:700, color:UI.texto,
                                  whiteSpace:"nowrap" as const, overflow:"hidden", textOverflow:"ellipsis"}}>{t.nombre}</div>
                                <div style={{fontSize:UI.fsEtiqueta, color:UI.textoTenue, marginTop:2,
                                  whiteSpace:"nowrap" as const, overflow:"hidden", textOverflow:"ellipsis"}}>{t.puesto || "Sin puesto"}</div>
                              </div>
                            </div>
                          </td>
                          {/* Salario diario — es la base legal del cálculo, por eso va primero */}
                          <td style={{padding:"11px 14px", borderTop:`1px solid ${UI.divisor}`, fontSize:UI.fsCuerpo, color:UI.texto, fontWeight:600, textAlign:"right" as const, whiteSpace:"nowrap" as const}}>
                            {salDiarioDe(t)>0 ? fmtMXN2(salDiarioDe(t)) : <span style={{color:UI.textoTenue, fontWeight:400}}>Sin salario</span>}
                          </td>
                          {/* Salario mensual */}
                          <td style={{padding:"11px 14px", borderTop:`1px solid ${UI.divisor}`, fontSize:UI.fsCuerpo, color:UI.textoSuave, textAlign:"right" as const, whiteSpace:"nowrap" as const}}>
                            {salDiarioDe(t)>0 ? fmtMXN2(salMensualDe(t)) : "—"}
                          </td>
                          {/* Recibos pendientes */}
                          <td style={{padding:"11px 14px", borderTop:`1px solid ${UI.divisor}`, textAlign:"center" as const}}>
                            {pendientes>0
                              ? <ChipEstado texto={String(pendientes)} tono="pendiente" title={`${pendientes} recibo${pendientes===1?"":"s"} por pagar`}/>
                              : <span style={{fontSize:UI.fsEtiqueta, color:UI.textoTenue}}>—</span>}
                          </td>
                          {/* Último recibo */}
                          <td style={{padding:"11px 14px", borderTop:`1px solid ${UI.divisor}`, fontSize:UI.fsCuerpo, color:UI.textoSuave, whiteSpace:"nowrap" as const}}>
                            {ultimo ? fechaCorta(ultimo.fechaPago) : <span style={{color:UI.textoTenue}}>Sin recibos</span>}
                          </td>
                          {/* Acción única */}
                          <td style={{padding:"11px 14px", borderTop:`1px solid ${UI.divisor}`, textAlign:"right" as const, whiteSpace:"nowrap" as const}}>
                            <span style={{fontSize:UI.fsEtiqueta, fontWeight:700, color:UI.navy}}>Generar recibo ›</span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div style={{padding:"9px 14px", borderTop:`1px solid ${UI.divisor}`, fontSize:10.5, color:UI.textoTenue, background:UI.superficie}}>
                  Mostrando {filas.length} de {trabajadores.length} trabajador{trabajadores.length===1?"":"es"} activo{trabajadores.length===1?"":"s"}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

// #endregion
// ─── CALENDARIO EMPRESARIAL ───────────────────────────────────────────────────
type EventoCal = {
  id?: string;
  titulo: string;
  fecha: string; // YYYY-MM-DD
  tipo: "fiscal"|"laboral"|"personal"|"contrato"|"vacaciones";
  descripcion?: string;
  userId?: string;
  repeticion?: "ninguna"|"mensual"|"anual";
  color?: string;
};

// Obligaciones fiscales y laborales 2025-2026 precargadas
const OBLIGACIONES_FIJAS: EventoCal[] = [
  // IMSS bimestral 2025
  {id:"imss-1",titulo:"IMSS — Pago cuotas bimestrales",fecha:"2025-01-17",tipo:"fiscal",descripcion:"Pago de cuotas obrero-patronales bimestre Nov-Dic 2024",repeticion:"ninguna"},
  {id:"imss-2",titulo:"IMSS — Pago cuotas bimestrales",fecha:"2025-03-17",tipo:"fiscal",descripcion:"Pago de cuotas obrero-patronales bimestre Ene-Feb 2025",repeticion:"ninguna"},
  {id:"imss-3",titulo:"IMSS — Pago cuotas bimestrales",fecha:"2025-05-17",tipo:"fiscal",descripcion:"Pago de cuotas obrero-patronales bimestre Mar-Abr 2025",repeticion:"ninguna"},
  {id:"imss-4",titulo:"IMSS — Pago cuotas bimestrales",fecha:"2025-07-17",tipo:"fiscal",descripcion:"Pago de cuotas obrero-patronales bimestre May-Jun 2025",repeticion:"ninguna"},
  {id:"imss-5",titulo:"IMSS — Pago cuotas bimestrales",fecha:"2025-09-17",tipo:"fiscal",descripcion:"Pago de cuotas obrero-patronales bimestre Jul-Ago 2025",repeticion:"ninguna"},
  {id:"imss-6",titulo:"IMSS — Pago cuotas bimestrales",fecha:"2025-11-17",tipo:"fiscal",descripcion:"Pago de cuotas obrero-patronales bimestre Sep-Oct 2025",repeticion:"ninguna"},
  {id:"imss-7",titulo:"IMSS — Pago cuotas bimestrales",fecha:"2026-01-17",tipo:"fiscal",descripcion:"Pago de cuotas obrero-patronales bimestre Nov-Dic 2025",repeticion:"ninguna"},
  {id:"imss-8",titulo:"IMSS — Pago cuotas bimestrales",fecha:"2026-03-17",tipo:"fiscal",descripcion:"Pago de cuotas obrero-patronales bimestre Ene-Feb 2026",repeticion:"ninguna"},
  {id:"imss-9",titulo:"IMSS — Pago cuotas bimestrales",fecha:"2026-05-17",tipo:"fiscal",descripcion:"Pago de cuotas obrero-patronales bimestre Mar-Abr 2026",repeticion:"ninguna"},
  // ISR retenciones mensuales
  {id:"isr-may25",titulo:"SAT — Declaración ISR mensual (Abril)",fecha:"2025-05-17",tipo:"fiscal",descripcion:"Declaración y pago de ISR retenciones del mes de Abril 2025",repeticion:"ninguna"},
  {id:"isr-jun25",titulo:"SAT — Declaración ISR mensual (Mayo)",fecha:"2025-06-17",tipo:"fiscal",descripcion:"Declaración y pago de ISR retenciones del mes de Mayo 2025",repeticion:"ninguna"},
  {id:"isr-jul25",titulo:"SAT — Declaración ISR mensual (Junio)",fecha:"2025-07-17",tipo:"fiscal",descripcion:"Declaración y pago de ISR retenciones del mes de Junio 2025",repeticion:"ninguna"},
  {id:"isr-ago25",titulo:"SAT — Declaración ISR mensual (Julio)",fecha:"2025-08-17",tipo:"fiscal",descripcion:"Declaración y pago de ISR retenciones del mes de Julio 2025",repeticion:"ninguna"},
  {id:"isr-sep25",titulo:"SAT — Declaración ISR mensual (Agosto)",fecha:"2025-09-17",tipo:"fiscal",descripcion:"Declaración y pago de ISR retenciones del mes de Agosto 2025",repeticion:"ninguna"},
  {id:"isr-oct25",titulo:"SAT — Declaración ISR mensual (Septiembre)",fecha:"2025-10-17",tipo:"fiscal",descripcion:"Declaración y pago de ISR retenciones del mes de Septiembre 2025",repeticion:"ninguna"},
  {id:"isr-nov25",titulo:"SAT — Declaración ISR mensual (Octubre)",fecha:"2025-11-17",tipo:"fiscal",descripcion:"Declaración y pago de ISR retenciones del mes de Octubre 2025",repeticion:"ninguna"},
  {id:"isr-dic25",titulo:"SAT — Declaración ISR mensual (Noviembre)",fecha:"2025-12-17",tipo:"fiscal",descripcion:"Declaración y pago de ISR retenciones del mes de Noviembre 2025",repeticion:"ninguna"},
  {id:"isr-ene26",titulo:"SAT — Declaración ISR mensual (Diciembre)",fecha:"2026-01-17",tipo:"fiscal",descripcion:"Declaración y pago de ISR retenciones del mes de Diciembre 2025",repeticion:"ninguna"},
  {id:"isr-feb26",titulo:"SAT — Declaración ISR mensual (Enero)",fecha:"2026-02-17",tipo:"fiscal",descripcion:"Declaración y pago de ISR retenciones del mes de Enero 2026",repeticion:"ninguna"},
  {id:"isr-mar26",titulo:"SAT — Declaración ISR mensual (Febrero)",fecha:"2026-03-17",tipo:"fiscal",descripcion:"Declaración y pago de ISR retenciones del mes de Febrero 2026",repeticion:"ninguna"},
  {id:"isr-abr26",titulo:"SAT — Declaración ISR mensual (Marzo)",fecha:"2026-04-17",tipo:"fiscal",descripcion:"Declaración y pago de ISR retenciones del mes de Marzo 2026",repeticion:"ninguna"},
  {id:"isr-may26",titulo:"SAT — Declaración ISR mensual (Abril)",fecha:"2026-05-17",tipo:"fiscal",descripcion:"Declaración y pago de ISR retenciones del mes de Abril 2026",repeticion:"ninguna"},
  // INFONAVIT
  {id:"info-1",titulo:"INFONAVIT — Pago bimestral",fecha:"2025-02-17",tipo:"fiscal",descripcion:"Entero de aportaciones INFONAVIT bimestre Nov-Dic 2024",repeticion:"ninguna"},
  {id:"info-2",titulo:"INFONAVIT — Pago bimestral",fecha:"2025-04-17",tipo:"fiscal",descripcion:"Entero de aportaciones INFONAVIT bimestre Ene-Feb 2025",repeticion:"ninguna"},
  {id:"info-3",titulo:"INFONAVIT — Pago bimestral",fecha:"2025-06-17",tipo:"fiscal",descripcion:"Entero de aportaciones INFONAVIT bimestre Mar-Abr 2025",repeticion:"ninguna"},
  {id:"info-4",titulo:"INFONAVIT — Pago bimestral",fecha:"2025-08-17",tipo:"fiscal",descripcion:"Entero de aportaciones INFONAVIT bimestre May-Jun 2025",repeticion:"ninguna"},
  {id:"info-5",titulo:"INFONAVIT — Pago bimestral",fecha:"2025-10-17",tipo:"fiscal",descripcion:"Entero de aportaciones INFONAVIT bimestre Jul-Ago 2025",repeticion:"ninguna"},
  {id:"info-6",titulo:"INFONAVIT — Pago bimestral",fecha:"2025-12-17",tipo:"fiscal",descripcion:"Entero de aportaciones INFONAVIT bimestre Sep-Oct 2025",repeticion:"ninguna"},
  {id:"info-7",titulo:"INFONAVIT — Pago bimestral",fecha:"2026-02-17",tipo:"fiscal",descripcion:"Entero de aportaciones INFONAVIT bimestre Nov-Dic 2025",repeticion:"ninguna"},
  {id:"info-8",titulo:"INFONAVIT — Pago bimestral",fecha:"2026-04-17",tipo:"fiscal",descripcion:"Entero de aportaciones INFONAVIT bimestre Ene-Feb 2026",repeticion:"ninguna"},
  // Obligaciones laborales anuales
  {id:"agui-25",titulo:"Aguinaldo — Pago obligatorio",fecha:"2025-12-20",tipo:"laboral",descripcion:"Fecha límite de pago de aguinaldo (Art. 87 LFT) — mínimo 15 días de salario",repeticion:"anual"},
  {id:"agui-26",titulo:"Aguinaldo — Pago obligatorio",fecha:"2026-12-20",tipo:"laboral",descripcion:"Fecha límite de pago de aguinaldo (Art. 87 LFT) — mínimo 15 días de salario",repeticion:"anual"},
  {id:"ptutil-25",titulo:"PTU — Declaración anual y reparto",fecha:"2025-05-31",tipo:"fiscal",descripcion:"Fecha límite para reparto de PTU a trabajadores (Art. 122 LFT)",repeticion:"anual"},
  {id:"ptutil-26",titulo:"PTU — Declaración anual y reparto",fecha:"2026-05-31",tipo:"fiscal",descripcion:"Fecha límite para reparto de PTU a trabajadores (Art. 122 LFT)",repeticion:"anual"},
  {id:"decanu-25",titulo:"SAT — Declaración anual personas morales",fecha:"2025-03-31",tipo:"fiscal",descripcion:"Declaración anual ISR personas morales correspondiente a 2024",repeticion:"anual"},
  {id:"decanu-26",titulo:"SAT — Declaración anual personas morales",fecha:"2026-03-31",tipo:"fiscal",descripcion:"Declaración anual ISR personas morales correspondiente a 2025",repeticion:"anual"},
  {id:"decpf-25",titulo:"SAT — Declaración anual personas físicas",fecha:"2025-04-30",tipo:"fiscal",descripcion:"Declaración anual ISR personas físicas correspondiente a 2024",repeticion:"anual"},
  {id:"decpf-26",titulo:"SAT — Declaración anual personas físicas",fecha:"2026-04-30",tipo:"fiscal",descripcion:"Declaración anual ISR personas físicas correspondiente a 2025",repeticion:"anual"},
  // Días festivos oficiales LFT 2025-2026
  {id:"dia1-25",titulo:"🔴 Día de descanso obligatorio — Año Nuevo",fecha:"2025-01-01",tipo:"laboral",descripcion:"Art. 74 LFT — Día de descanso obligatorio con goce de sueldo",repeticion:"anual"},
  {id:"dia2-25",titulo:"🔴 Día de descanso obligatorio — Constitución",fecha:"2025-02-03",tipo:"laboral",descripcion:"Art. 74 LFT — Primer lunes de febrero",repeticion:"ninguna"},
  {id:"dia3-25",titulo:"🔴 Día de descanso obligatorio — Natalicio de Juárez",fecha:"2025-03-17",tipo:"laboral",descripcion:"Art. 74 LFT — Tercer lunes de marzo",repeticion:"ninguna"},
  {id:"dia4-25",titulo:"🔴 Día de descanso obligatorio — 1° de Mayo",fecha:"2025-05-01",tipo:"laboral",descripcion:"Art. 74 LFT — Día del Trabajo. Día de descanso obligatorio",repeticion:"anual"},
  {id:"dia5-25",titulo:"🔴 Día de descanso obligatorio — Independencia",fecha:"2025-09-16",tipo:"laboral",descripcion:"Art. 74 LFT — Día de descanso obligatorio",repeticion:"anual"},
  {id:"dia6-25",titulo:"🔴 Día de descanso obligatorio — Revolución",fecha:"2025-11-17",tipo:"laboral",descripcion:"Art. 74 LFT — Tercer lunes de noviembre",repeticion:"ninguna"},
  {id:"dia7-25",titulo:"🔴 Día de descanso obligatorio — Navidad",fecha:"2025-12-25",tipo:"laboral",descripcion:"Art. 74 LFT — Día de descanso obligatorio",repeticion:"anual"},
  // 2026 — Art. 74 LFT
  {id:"dia1-26",titulo:"🔴 Día de descanso obligatorio — Año Nuevo",fecha:"2026-01-01",tipo:"laboral",descripcion:"Art. 74 LFT — Día de descanso obligatorio con goce de sueldo",repeticion:"anual"},
  {id:"dia2-26",titulo:"🔴 Día de descanso obligatorio — Constitución",fecha:"2026-02-02",tipo:"laboral",descripcion:"Art. 74 LFT — Primer lunes de febrero 2026",repeticion:"ninguna"},
  {id:"dia3-26",titulo:"🔴 Día de descanso obligatorio — Natalicio de Juárez",fecha:"2026-03-16",tipo:"laboral",descripcion:"Art. 74 LFT — Tercer lunes de marzo 2026",repeticion:"ninguna"},
  {id:"dia4-26",titulo:"🔴 Día de descanso obligatorio — 1° de Mayo",fecha:"2026-05-01",tipo:"laboral",descripcion:"Art. 74 LFT — Día del Trabajo",repeticion:"anual"},
  {id:"dia5-26",titulo:"🔴 Día de descanso obligatorio — Independencia",fecha:"2026-09-16",tipo:"laboral",descripcion:"Art. 74 LFT — Día de descanso obligatorio",repeticion:"anual"},
  {id:"dia6-26",titulo:"🔴 Día de descanso obligatorio — Revolución",fecha:"2026-11-16",tipo:"laboral",descripcion:"Art. 74 LFT — Tercer lunes de noviembre 2026",repeticion:"ninguna"},
  {id:"dia7-26",titulo:"🔴 Día de descanso obligatorio — Navidad",fecha:"2026-12-25",tipo:"laboral",descripcion:"Art. 74 LFT — Día de descanso obligatorio",repeticion:"anual"},
  // Semana Santa 2026 — Inhábiles SAT (Art. 12 CFF)
  {id:"ss1-26",titulo:"⛪ Jueves Santo — Día inhábil SAT",fecha:"2026-04-02",tipo:"fiscal",descripcion:"Día inhábil conforme al Art. 12 del Código Fiscal de la Federación. Los plazos fiscales que venzan este día se prorrogan al siguiente día hábil. No es descanso obligatorio LFT pero muchas empresas lo otorgan.",repeticion:"ninguna"},
  {id:"ss2-26",titulo:"⛪ Viernes Santo — Día inhábil SAT",fecha:"2026-04-03",tipo:"fiscal",descripcion:"Día inhábil conforme al Art. 12 del Código Fiscal de la Federación. Los plazos fiscales que venzan este día se prorrogan al siguiente día hábil. No es descanso obligatorio LFT pero muchas empresas lo otorgan.",repeticion:"ninguna"},
  // Fechas importantes de observancia general
  {id:"dm-26",titulo:"💐 Día de las Madres",fecha:"2026-05-10",tipo:"laboral",descripcion:"No es descanso obligatorio Art. 74 LFT, pero muchos negocios reducen horario o cierran. Considéralo en tu planeación de personal.",repeticion:"anual"},
  {id:"dm2-26",titulo:"🕯️ Día de Muertos",fecha:"2026-11-02",tipo:"laboral",descripcion:"No es descanso obligatorio LFT, pero es de alta ausentismo en empresas mexicanas. Algunos contratos colectivos lo incluyen como descanso adicional.",repeticion:"anual"},
  {id:"dpm-26",titulo:"💀 Día de Muertos",fecha:"2026-11-01",tipo:"laboral",descripcion:"Día de Todos los Santos — No es descanso obligatorio LFT pero de alta ausentismo. Verificar contratos colectivos si aplica.",repeticion:"anual"},
  // Fechas fiscales adicionales importantes 2026
  {id:"dsa-26",titulo:"📋 SAT — Declaración anual personas morales",fecha:"2026-03-31",tipo:"fiscal",descripcion:"Fecha límite para presentar declaración anual de personas morales ejercicio 2025 (Art. 86 LISR). Aplica a S.A., S. de R.L., A.C. y demás personas morales.",repeticion:"ninguna"},
  {id:"dsa2-26",titulo:"📋 SAT — Declaración anual personas físicas",fecha:"2026-04-30",tipo:"fiscal",descripcion:"Fecha límite para presentar declaración anual de personas físicas ejercicio 2025 (Art. 150 LISR). Incluye honorarios, arrendamiento, actividad empresarial y sueldos.",repeticion:"ninguna"},
  {id:"ptu2-26",titulo:"💰 PTU — Personas morales",fecha:"2026-05-31",tipo:"laboral",descripcion:"Fecha límite para el reparto de Participación de los Trabajadores en las Utilidades (PTU) correspondiente al ejercicio 2025 para personas morales (Art. 122 LFT). 60 días después de la declaración anual.",repeticion:"ninguna"},
  {id:"ptu3-26",titulo:"💰 PTU — Personas físicas",fecha:"2026-06-29",tipo:"laboral",descripcion:"Fecha límite para el reparto de PTU correspondiente al ejercicio 2025 para personas físicas con actividad empresarial (Art. 122 LFT). 60 días después del 30 de abril.",repeticion:"ninguna"},
  {id:"infonavit-an",titulo:"🏠 INFONAVIT — Aportaciones bimestrales Jan-Feb",fecha:"2026-01-17",tipo:"fiscal",descripcion:"Pago de aportaciones patronales INFONAVIT bimestre Enero-Febrero 2026 (5% salario base de cotización). Mismo vencimiento que cuotas IMSS bimestrales.",repeticion:"ninguna"},
  {id:"riesgo-26",titulo:"⚠️ IMSS — Prima riesgo de trabajo",fecha:"2026-02-28",tipo:"fiscal",descripcion:"Fecha límite para presentar la declaración anual de prima de riesgo de trabajo ante el IMSS (Art. 74 LSS). Las empresas deben calcular y declarar su siniestralidad del año anterior.",repeticion:"ninguna"},
];

// ═══ CLASIFICADOR DE DÍA DEL CHECADOR — FUENTE ÚNICA ════════════════════════
// Todo lo que en esta plataforma diga algo sobre la asistencia de una persona
// pasa por aquí: el reporte mensual, la bitácora quincenal, el panel de equipo y
// el expediente. Antes eran cuatro bucles distintos clasificando el mismo hecho
// con escaleras distintas, y dos de ellos salían impresos con firma.
//
// LA REGLA QUE LO ORDENA TODO: el sistema NO sabe si alguien faltó. Sabe si hay
// o no hay registro de checador. "Sin registro" es un hecho; "falta" es una
// acusación, y una acusación en un documento firmado es una base documental
// fabricada para una rescisión. Por eso aquí no existe el estado "falta": el
// único caso en que esa palabra podría usarse es un registro POSITIVO de
// inasistencia, y esta plataforma no captura ninguno.
//
// Lo que sí se afirma, y solo cuando se puede:
//   · con_registro       → hay checada de entrada. Es el único hecho positivo.
//   · vacaciones         → día cubierto por vacaciones registradas por el patrón.
//   · descanso_obligatorio → día del Art. 74 LFT.
//   · no_laborable       → ese día de la semana no se trabaja, según su horario.
//   · sin_registro       → era día laborable y no hay checada. Ni más ni menos.
//   · futuro             → todavía no ocurre. NUNCA se cuenta.
//   · indeterminable     → no hay días laborables configurados: no se puede
//                          saber si ese día debía trabajarse, así que no se
//                          afirma nada de él.
//   · antes_ingreso      → antes de la fecha de ingreso que consta en la ficha.
//   · despues_baja       → después de una baja que consta en la ficha (y antes
//                          de un reingreso, si lo hubo). Ninguno de los dos se
//                          cuenta: no era su trabajo todavía, o ya no lo era.
type EstadoDiaChecador = {
  estado: "con_registro"|"vacaciones"|"descanso_obligatorio"|"no_laborable"|"sin_registro"|"futuro"|"indeterminable"|"antes_ingreso"|"despues_baja";
  clasif?: "a_tiempo"|"retardo"|"tardia"|"sin_horario";   // solo con registro
  hora?: Date|null;
  descanso?: string;                                       // nombre del día 74, si lo es
  // Con registro, en un día FUERA de su relación laboral según la ficha. El
  // registro se muestra (la plataforma no esconde lo que consta) y se anota.
  fueraDeRelacion?: "antes_ingreso"|"despues_baja";
};

// Los días laborables (diasLaborablesDe, diasLaborablesVigentes), los de descanso
// obligatorio del art. 74 (descansosObligatoriosDe, CALCULADOS con el texto vigente)
// y los de vacaciones (diasDeVacaciones) viven en src/logica/checador.js: los usa
// también el servidor, y la base de "debe checar" (debeChecarEnFecha) los consulta.

// EL CLASIFICADOR. Un día, un estado, y el mismo estado en las cuatro pantallas.
// El orden de las preguntas importa y está pensado para no afirmar de más:
//   1) ¿ya ocurrió?  2) ¿hay registro?  3) ¿sabemos si era laborable?
//   4) ¿es su día de descanso semanal?  5) ¿es del 74?  6) ¿está de vacaciones?
// Solo cuando todas responden que sí se llega a "sin registro".
function clasificarDiaChecador(o:{
  dia: Date;
  hoy: Date;
  horario: any;
  entrada: Date|null;
  clasifGuardada?: string;   // YA NO SE USA: se clasifica siempre con el horario vigente
  laborables: number[]|null;
  descansos: Record<string,string>|null;
  vacaciones: Record<string,boolean>;
  // En qué parte de su relación laboral cae el día (relacionLaboralEnDia). Sin
  // él, "dentro": todo como siempre.
  relacion?: "dentro"|"antes_ingreso"|"despues_baja";
}): EstadoDiaChecador {
  const {dia, hoy, horario, entrada, laborables, descansos, vacaciones} = o;
  const relacion = o.relacion || "dentro";
  const iso = _isoDia(dia);
  const nombre74 = descansos ? descansos[iso] : undefined;

  // 1) Un día que no ha ocurrido no dice nada de nadie.
  const finDeHoy = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate(), 23, 59, 59, 999);
  if (dia.getTime() > finDeHoy.getTime()) return {estado:"futuro"};

  // 2) El registro manda sobre todo lo demás. Un día del 74 SE PUEDE trabajar, y
  //    si hay checada se muestra: la etiqueta del día acompaña, no tapa el hecho.
  if (entrada) {
    // `clasificarEntrada` llama "falta" a la entrada muy tardía. Aquí NO: hay
    // registro de que la persona llegó. Tarde, pero llegó (clasifDeEntradaRegistrada).
    // SIEMPRE CON EL HORARIO VIGENTE, nunca con una clasificación guardada en la
    // checada: esa se calculó con el horario de quien checó en ese momento (un
    // horario propio que luego se apagó, por ejemplo) y se quedaba ganándole al
    // horario de hoy. Ver clasificacionDeChecada.
    const clasif = clasifDeEntradaRegistrada(clasificarEntrada(horario, entrada));
    // UN REGISTRO FUERA DE LA RELACIÓN LABORAL (antes del ingreso o después de la
    // baja que constan en la ficha) se muestra igual, con su nota: la plataforma
    // no esconde lo que consta.
    const est: EstadoDiaChecador = {estado:"con_registro", clasif: clasif as any, hora: entrada, descanso: nombre74};
    if (relacion !== "dentro") est.fueraDeRelacion = relacion;
    return est;
  }

  // 2b) Antes de su ingreso o después de su baja, según la ficha: ese día no era
  //     su trabajo, así que ni es laborable ni es "sin registro".
  if (relacion !== "dentro") return {estado: relacion, descanso: nombre74};

  // 3) Sin días laborables configurados no se puede afirmar que debía trabajar.
  if (!laborables) return {estado:"indeterminable", descanso: nombre74};

  // 4) Su descanso semanal, según SU horario. No lunes a viernes por defecto.
  if (laborables.indexOf(dia.getDay()) < 0) return {estado:"no_laborable", descanso: nombre74};

  // 5) Art. 74: día de descanso obligatorio con goce de sueldo.
  if (nombre74) return {estado:"descanso_obligatorio", descanso: nombre74};

  // 6) Vacaciones registradas por el patrón: es el dato que él mismo tiene y que
  //    desmentiría al documento si aquí saliera como día sin registro.
  if (vacaciones[iso]) return {estado:"vacaciones"};

  // 7) Era laborable, ocurrió, y no hay checada. Eso es todo lo que se sabe.
  return {estado:"sin_registro"};
}

// UN DÍA SIN CHECADA, SEGÚN LA BASE (debeChecarEnFecha). Los motivos que hablan de
// ESE día mandan; los que hablan de la cuenta de hoy (sin_cuenta: correo, baja,
// cuenta suspendida) no dicen nada de un día pasado, y ahí se queda lo de siempre.
function estadoSegunLaBase(b:any, antes:EstadoDiaChecador): EstadoDiaChecador {
  if (!b) return antes;
  if (b.debe) return {estado:"sin_registro"};
  if (b.motivo === "vacaciones") return {estado:"vacaciones"};
  if (b.motivo === "descanso_obligatorio") return {estado:"descanso_obligatorio", descanso: b.descanso};
  if (b.motivo === "no_laborable") return {estado:"no_laborable", descanso: antes.descanso};
  if (b.motivo === "sin_horario") return {estado:"indeterminable", descanso: antes.descanso};
  return antes;
}
// LA PREGUNTA DE LA BASE PARA UNA FICHA, DÍA POR DÍA: al cerrar ese día en México,
// con el horario que regía entonces, sus vacaciones registradas y el art. 74. La
// cuenta se da por existente —es un día pasado, no "ahora"— y sin checadas: se
// pregunta solo por los días sin entrada.
function debeChecarEnDiaDe(ficha:any, horarioGeneral:any, historialGeneral:any, registrosVacaciones:any[]|null) {
  const correo = String(ficha?.email||"").toLowerCase().trim();
  return (dia:Date)=> debeChecarEnFecha({
    empleado: ficha, horarioGeneral, historialGeneral: historialGeneral || null,
    registrosVacaciones: registrosVacaciones || [],
    correosConCuenta: new Set([correo]), checadasHoy: new Set(),
    instante: instanteDeMexico(dia.getFullYear(), dia.getMonth(), dia.getDate(), 23, 59, 59, 999),
  });
}

// Recorre un rango y devuelve el estado de cada día con el MISMO clasificador,
// más los conteos. Todo lo que cuenta asistencia en la plataforma sale de aquí.
function recorrerDiasChecador(o:{
  desde: Date; hasta: Date; hoy?: Date;
  horario: any;
  checadas: any[];            // ya filtradas por trabajador, o se filtran con `email`
  email?: string;
  registrosObligaciones?: any[];
  trabajadorId?: string;
  horarioGeneral?: any;          // el de la empresa, para heredar los días
  // EL HORARIO QUE REGÍA EN UN INSTANTE, de su historial (horarioQueRegia). Con
  // él, cada día se lee con el suyo y cambiar el horario hoy ya no reclasifica
  // los días de antes. Sin él, `horario` vale para todo el rango, como antes.
  horarioEn?: (instante: Date) => any;
  // LOS INSTANTES DEL HISTORIAL en que pudo cambiar su horario dentro del periodo
  // (instantesDelHistorial). Con ellos y `horarioEn`, el aviso de cambios sale
  // del historial: TODOS los cambios, aunque no hayan calificado ninguna entrada.
  instantesDeCambio?: Date[];
  // LOS PERIODOS DE SU RELACIÓN LABORAL, de la ficha (periodosLaboralesDe: los de
  // `periodosLaborales`, o uno de `fechaIngreso` a `fechaBaja`). Los días antes del
  // ingreso y después de la baja no se cuentan. Sin ellos, todo como siempre.
  periodosLaborales?: any[];
  // LA BASE DEL MÓDULO, POR DÍA (13-oct-2026): `debeChecarEnFecha` (ver
  // debeChecarEnDiaDe). Con ella, un día sin checada dentro de su relación laboral
  // se lee como lo lee "no ha checado": vacaciones, descanso obligatorio del art. 74,
  // no laborable o sin horario, y "sin registro" solo si DEBÍA checar. Sin ella,
  // todo como siempre.
  debeChecarEnDia?: (dia: Date) => any;
}) {
  const hoy = o.hoy || new Date();
  // La precedencia vive en diasLaborablesVigentes, no aquí: los cuatro lectores
  // pasan por esta misma función. Quien pueda dar el horario general lo da; quien
  // no, obtiene exactamente lo que el horario efectivo traiga.
  const vig = diasLaborablesVigentes(o.horario, o.horarioGeneral);
  const laborables = vig.dias;
  const anioIni = o.desde.getFullYear(), anioFin = o.hasta.getFullYear();
  // Un rango puede cruzar el año: se juntan los catálogos, y si FALTA el de
  // alguno de los años el rango entero queda sin descansos determinados.
  let descansos: Record<string,string>|null = {};
  let anioSinCatalogo: number|null = null;
  for (let a = anioIni; a <= anioFin; a++) {
    const d = descansosObligatoriosDe(a);
    if (!d) { anioSinCatalogo = a; descansos = null; break; }
    descansos = {...(descansos as any), ...d};
  }
  const vacaciones = diasDeVacaciones(o.registrosObligaciones||[], o.trabajadorId||"", laborables, descansos);

  const correo = String(o.email||"").toLowerCase().trim();
  const horaDe = horaDeChecada;
  const msDe   = msDeChecada;
  const suyas  = (o.checadas||[]).filter((c:any)=>
    !correo || String(c.trabajadorEmail||"").toLowerCase() === correo);
  const entradas = suyas.filter((c:any)=> c.tipo === "entrada");
  // EL DÍA DE UNA CHECADA ES EL DÍA EN MÉXICO, el de la hora del servidor leída
  // allí (enHoraDeMexico): no el de la zona del navegador. Se calcula UNA vez por
  // checada: el recorrido pregunta por cada día del rango, y AXIOR recorre el mes
  // de todo el equipo.
  const claveDia = (d:Date)=> `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
  const _diaMexico = new Map<any, string|null>();
  const diaMexicoDe = (c:any)=>{
    if (!_diaMexico.has(c)) { const cd = enHoraDeMexico(horaDe(c) as any); _diaMexico.set(c, cd ? claveDia(cd) : null); }
    return _diaMexico.get(c);
  };
  const esDelDia = (c:any, dia:Date)=>{ const k = diaMexicoDe(c); return !!k && k === claveDia(dia); };
  // El horario de cada instante: el de su historial si se da `horarioEn`; si no,
  // el del rango. La ENTRADA se califica con el que regía a la hora de la marca;
  // si el día era laborable, con el que regía al TERMINAR ese día (en México).
  const horarioDe = (instante:Date)=> o.horarioEn ? o.horarioEn(instante) : o.horario;
  const firmaHorario = (h:any)=> JSON.stringify(horarioAplicadoDe(h));

  const dias: {fecha:Date; iso:string; est:EstadoDiaChecador; salida:Date|null; rep:{entradas:number; salidas:number}; nota:string; notaRelacion:string; fechaRelacion:string; entradaChecada:any; horario:any}[] = [];
  const periodos = o.periodosLaborales || [];
  const cursor = new Date(o.desde.getFullYear(), o.desde.getMonth(), o.desde.getDate());
  let vueltas = 0;
  while (cursor <= o.hasta && vueltas++ < 800) {
    const dia = new Date(cursor);
    const delDia = entradas
      .filter((c:any)=> esDelDia(c, dia))
      .sort((a:any,b:any)=> msDe(a) - msDe(b));
    const c0 = delDia[0];
    const esDeEsteDia = (c:any)=> esDelDia(c, dia);
    const hDia = horarioDe(instanteDeMexico(dia.getFullYear(), dia.getMonth(), dia.getDate(), 23, 59, 59, 999));
    const hEntrada = c0 && horaDe(c0) ? horarioDe(horaDe(c0) as Date) : hDia;
    const labDia = o.horarioEn ? diasLaborablesVigentes(hDia, null).dias : laborables;

    const salidasDia = suyas.filter((c:any)=> c.tipo === "salida" && esDeEsteDia(c))
      .sort((a:any,b:any)=> msDe(b) - msDe(a));
    // Se conserva lo que ya hacía —la entrada más temprana y la salida más
    // tardía— y se AÑADE la cuenta de lo que se descartó, para poder decirlo.
    const rep = repeticionesDelDia(suyas.filter(esDeEsteDia));
    const iso = _isoDia(dia);
    const relacion = relacionLaboralEnDia(periodos, iso) as "dentro"|"antes_ingreso"|"despues_baja";
    let est = clasificarDiaChecador({
      dia, hoy, horario: hEntrada, entrada: c0 ? horaDe(c0) : null,
      laborables: labDia, descansos, vacaciones, relacion,
    });
    if (!c0 && relacion === "dentro" && o.debeChecarEnDia && est.estado !== "futuro") est = estadoSegunLaBase(o.debeChecarEnDia(dia), est);
    dias.push({
      fecha: dia, iso, est,
      salida: salidasDia[0] ? horaDe(salidasDia[0]) : null,
      rep, nota: notaRepeticionDia(rep),
      // La nota del renglón de un registro fuera de su relación laboral (aparte de
      // `nota`, que es la de las marcas repetidas y se cuenta en diasConRepeticion).
      notaRelacion: notaRelacionLaboral(est.fueraDeRelacion),
      // La fecha de la ficha que explica por qué el día no cuenta.
      fechaRelacion: est.estado === "futuro" ? "" : fechaDeLaRelacion(periodos, iso, relacion),
      // La checada de entrada misma: de ella sale lo que la bitácora imprime de
      // ubicación y de verificación en el aparato.
      entradaChecada: c0 || null,
      // El horario con que se leyó el día (el de la entrada, si la hubo).
      horario: hEntrada,
    });
    cursor.setDate(cursor.getDate()+1);
  }

  // LOS TRAMOS DE HORARIO DEL RANGO: días seguidos que se CALIFICARON con el mismo
  // horario —el que devolvió `horarioEn` para cada día (`d.horario`: el de su
  // entrada si la hubo; si no, el que regía al cerrar el día)— y con la misma
  // constancia de su vigencia. ES LA ÚNICA FUENTE de "Cómo se clasifica cada
  // entrada" (criterioDelPeriodo): el papel imprime lo que se aplicó, no una
  // lectura aparte del historial. Sin `horarioEn`, un solo tramo.
  const tramosDeHorario: {desde:Date; hasta:Date; horario:any; firma:string; consta:boolean}[] = [];
  for (const d of dias) {
    const consta = !(d.horario && d.horario.vigenciaConsta === false);
    const f = firmaHorario(d.horario) + (consta ? "" : "|sin vigencia");
    const u = tramosDeHorario[tramosDeHorario.length-1];
    if (u && u.firma === f) u.hasta = d.fecha;
    else tramosDeHorario.push({desde: d.fecha, hasta: d.fecha, horario: d.horario, firma: f, consta});
  }
  // LOS CAMBIOS DE HORARIO DEL RANGO, CON SU MOMENTO REAL. Cada tramo con OTRO
  // horario que el anterior viene de un cambio; su fecha y hora son las de la
  // entrada del historial que lo trajo (`ultimoCambioEn`, hora del servidor), no el
  // primer día que se calificó con él: una entrada de la mañana del día del cambio
  // se calificó con el anterior, y ese día se queda en el tramo anterior. Si el
  // momento no consta, solo el día. Un tramo que solo se separa porque su vigencia
  // no consta no es un cambio de horario.
  //
  // CON LOS INSTANTES DEL HISTORIAL (instantesDeCambio), los cambios salen de él:
  // en cada instante se compara el horario que regía un milisegundo antes con el
  // que rige desde ese instante, con la MISMA función que califica (horarioEn).
  // Así consta TODO cambio del periodo —también uno que se deshizo minutos
  // después sin calificar ninguna entrada—; entradas seguidas con el mismo horario
  // siguen contando como una. La leyenda por rangos (tramos) no cambia.
  const horarioEn = o.horarioEn;
  const cambiosDeHorario: {en: Date; conHora: boolean}[] = (o.instantesDeCambio && horarioEn)
    ? o.instantesDeCambio
      .filter((t)=> firmaDelHorarioAplicado(horarioEn(new Date(t.getTime() - 1))) !== firmaDelHorarioAplicado(horarioEn(t)))
      .map((t)=> ({en: new Date(t.getTime()), conHora: true}))
    : tramosDeHorario.slice(1)
    .filter((t, i)=> firmaHorario(t.horario) !== firmaHorario(tramosDeHorario[i].horario))
    .map((t)=> {
      const real = t.horario?.ultimoCambioEn;
      return real && !isNaN(real.getTime()) ? {en: new Date(real.getTime()), conHora: true} : {en: new Date(t.desde), conHora: false};
    });

  const cuenta = (f:(e:EstadoDiaChecador)=>boolean) => dias.filter(d=>f(d.est)).length;
  return {
    dias,
    cambiosDeHorario,
    tramosDeHorario,
    laborables,
    origenLaborables: vig.origen,
    hayLaborables: !!laborables,
    anioSinCatalogo,                 // año cuyo Art. 74 no se pudo determinar
    conRegistro: cuenta(e=>e.estado==="con_registro"),
    aTiempo:     cuenta(e=>e.estado==="con_registro" && e.clasif==="a_tiempo"),
    retardos:    cuenta(e=>e.estado==="con_registro" && e.clasif==="retardo"),
    tardias:     cuenta(e=>e.estado==="con_registro" && e.clasif==="tardia"),
    sinRegistro: cuenta(e=>e.estado==="sin_registro"),
    vacaciones:  cuenta(e=>e.estado==="vacaciones"),
    descansos74: cuenta(e=>e.estado==="descanso_obligatorio"),
    // Días en los que hubo más de una entrada o más de una salida. El reporte se
    // quedó con una de cada; esto es lo que permite decirlo en el papel.
    diasConRepeticion: dias.filter(d=>!!d.nota).length,
    // Días del periodo que ya ocurrieron y que su horario marca como laborables.
    // Un registro antes del ingreso o después de la baja cuenta como día con
    // registro (consta), pero no como día laborable suyo.
    laborablesTranscurridos: cuenta(e=>(e.estado==="con_registro" && !e.fueraDeRelacion) || e.estado==="sin_registro" || e.estado==="vacaciones" || e.estado==="descanso_obligatorio"),
    // Fuera de su relación laboral según la ficha: los días que no se cuentan, y
    // los registros que constan en ellos.
    antesDeIngreso: cuenta(e=>e.estado==="antes_ingreso"),
    despuesDeBaja:  cuenta(e=>e.estado==="despues_baja"),
    registrosFueraDeRelacion: dias.filter(d=> !!d.est.fueraDeRelacion).map(d=> ({iso: d.iso, relacion: d.est.fueraDeRelacion as string})),
    // Las frases de la leyenda: "Los días anteriores al ingreso (…) no se cuentan."
    avisosRelacion: avisosRelacionLaboral(dias),
  };
}

// ── LA RELACIÓN LABORAL, EN PALABRAS (10-oct-2026) ──────────────────────────
// El renglón de un registro fuera de la relación laboral lleva su nota; el
// periodo que tenga días antes del ingreso o después de la baja lo dice una vez,
// con la fecha de la ficha.
const NOTA_REGISTRO_ANTES_INGRESO = "Registro anterior a la fecha de ingreso que consta en la ficha";
const NOTA_REGISTRO_DESPUES_BAJA = "Registro posterior a la baja que consta en la ficha";
function notaRelacionLaboral(fuera:any): string {
  return fuera === "antes_ingreso" ? NOTA_REGISTRO_ANTES_INGRESO : fuera === "despues_baja" ? NOTA_REGISTRO_DESPUES_BAJA : "";
}
function avisosRelacionLaboral(dias:{est:EstadoDiaChecador; fechaRelacion:string}[]): string[] {
  const antes: string[] = [], despues: string[] = [];
  for (const d of dias) {
    const r = d.est.estado === "antes_ingreso" || d.est.fueraDeRelacion === "antes_ingreso" ? "antes"
      : d.est.estado === "despues_baja" || d.est.fueraDeRelacion === "despues_baja" ? "despues" : "";
    if (!r || !d.fechaRelacion) continue;
    const l = r === "antes" ? antes : despues;
    if (l.indexOf(d.fechaRelacion) < 0) l.push(d.fechaRelacion);
  }
  return [
    ...antes.map((f)=> `Los días anteriores al ingreso (${fechaLargaAxis(f)}) no se cuentan.`),
    ...despues.map((f)=> `Los días posteriores a la baja (${fechaLargaAxis(f)}) no se cuentan.`),
  ];
}

// LAS INCIDENCIAS DEL MES, CON EL MISMO RECORRIDO QUE LA BITÁCORA. Tenían su
// propio bucle de lunes a viernes y llamaban "Falta" a todo día sin checada: a
// quien trabaja sábados no se le contaban, a quien descansa martes cada martes le
// salía falta, y un día sin registro no prueba ninguna inasistencia. Ahora pasan
// por recorrerDiasChecador: días laborables del horario (el propio o el general
// que hereda), descansos del Art. 74 y vacaciones si se dan. Un día sin checada
// es "Sin registro", y solo si era laborable; sin días configurados es
// indeterminable y no cuenta.
function incidenciasDelMes(o:{empleados:any[]; checadas:any[]; horarioGeneral:any; historialGeneral?:any; hoy:Date; registrosObligaciones?:any[]}): {empleado:string; fecha:Date; tipo:"sin_registro"|"retardo"|"tardia"; detalle:string}[] {
  const hoy = o.hoy;
  const ini = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
  const fmtHora = (d:Date)=> d.toLocaleTimeString("es-MX",{hour:"2-digit",minute:"2-digit"});
  const inc:any[] = [];
  for (const e of (o.empleados||[])) {
    const email = String(e?.email||"").toLowerCase().trim();
    const he = horarioVigente(e, o.horarioGeneral);
    if (!email || !he || !he.entrada) continue;
    const rec = recorrerDiasChecador({desde:ini, hasta:hoy, hoy, horario:he, horarioGeneral:o.horarioGeneral,
      checadas:o.checadas||[], email, trabajadorId:e?.id, registrosObligaciones:o.registrosObligaciones||[],
      horarioEn:(t:Date)=> horarioQueRegia(e, o.horarioGeneral, o.historialGeneral, t),
      periodosLaborales: periodosLaboralesDe(e)});
    const quien = e?.nombre || email;
    for (const d of rec.dias) {
      if (d.est.estado === "sin_registro") inc.push({empleado:quien, fecha:d.fecha, tipo:"sin_registro", detalle:"No registró entrada"});
      else if (d.est.estado === "con_registro" && (d.est.clasif === "retardo" || d.est.clasif === "tardia"))
        inc.push({empleado:quien, fecha:d.fecha, tipo:d.est.clasif, detalle:`Entró ${d.est.hora ? fmtHora(d.est.hora) : "—"} · horario ${d.horario?.entrada || he.entrada}`});
    }
  }
  return inc.sort((a:any,b:any)=> b.fecha - a.fecha);
}
// EL CHECADOR DEL MES PARA EL CONTEXTO DE AXIOR. Le decía "N faltas" por los días
// sin registro, y AXIOR lo repetía con esas palabras. Ahora dice lo que hay: días
// laborables sin registro, o que sin días configurados no se cuentan. Y el
// recorrido recibe el horario general, para que un horario propio sin días los
// herede como en el resto de la plataforma.
// (13-oct-2026) Con la BASE del módulo por día (debeChecarEnDia): un día de
// vacaciones o de descanso obligatorio ya no es "sin registro", y la línea los
// cuenta aparte para que los días laborables transcurridos cuadren sin que nadie
// tenga que suponer que faltó.
function checadorDelMes(email:string, he:any, horarioGeneral:any, checadas:any[], hoy:Date, horarioEn?:(instante:Date)=>any, periodosLaborales?:any[], debeChecarEnDia?:(dia:Date)=>any): any {
  if (!he?.entrada || !email) return null;
  const ini = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
  const r = recorrerDiasChecador({desde:ini, hasta:hoy, hoy, horario:he, horarioGeneral, checadas, email, horarioEn, periodosLaborales, debeChecarEnDia});
  return {laborales:r.laborablesTranscurridos, aTiempo:r.aTiempo, retardos:r.retardos,
    tardias:r.tardias, sinRegistro:r.sinRegistro, hayLaborables:r.hayLaborables,
    vacaciones:r.vacaciones, descansos74:r.descansos74};
}
// EL HORARIO, EN PALABRAS, PARA AXIOR: el mismo objeto que usa todo lo demás
// (horarioVigente), con sus valores por omisión ya puestos.
const _DIAS_CORTOS = ["Dom","Lun","Mar","Mié","Jue","Vie","Sáb"];
function textoHorarioParaAxior(he:any): string {
  if (!he || !he.entrada) return "sin horario configurado";
  const dias = Array.isArray(he.diasLaborables) && he.diasLaborables.length
    ? he.diasLaborables.slice().sort((a:number,b:number)=>a-b).map((d:number)=>_DIAS_CORTOS[d]).join(", ")
    : "sin días laborables configurados";
  return `entrada ${he.entrada}${he.salida ? `, salida ${he.salida}` : ""}, tolerancia ${he.toleranciaMin} min, entrada tardía a partir de ${he.umbralFaltaMin} min después de la tolerancia, días: ${dias}`;
}
function lineaChecadorDelMes(chk:any): string {
  if (!chk) return "   Checador: sin horario configurado, no se evalúa.";
  const n = (x:any)=> Number.isFinite(Number(x)) ? Number(x) : 0;
  const base = `   Checador del mes: ${n(chk.aTiempo)} a tiempo, ${n(chk.retardos)} retardo${n(chk.retardos)===1?"":"s"}, ${n(chk.tardias)} entrada${n(chk.tardias)===1?"":"s"} tardía${n(chk.tardias)===1?"":"s"}`;
  return chk.hayLaborables
    ? `${base}, ${n(chk.sinRegistro)} día${n(chk.sinRegistro)===1?"":"s"} laborable${n(chk.sinRegistro)===1?"":"s"} sin registro`
      + (n(chk.vacaciones) ? `, ${n(chk.vacaciones)} día${n(chk.vacaciones)===1?"":"s"} de vacaciones` : "")
      + (n(chk.descansos74) ? `, ${n(chk.descansos74)} día${n(chk.descansos74)===1?"":"s"} de descanso obligatorio (art. 74 LFT)` : "")
      + ` (${n(chk.laborales)} días laborables transcurridos)`
    : `${base}; sin días laborables configurados, los días sin registro no se cuentan.`;
}

// EL CRITERIO, ESCRITO EN EL DOCUMENTO. "0 retardos" junto a "2 entrada tardía"
// no se puede leer si el papel no dice en qué se diferencian: los dos son
// llegadas tarde, y solo el umbral configurado los separa. Se escriben con las
// horas reales de ESE empleado, no en abstracto.
//
// Se mantienen los tres estados y no se colapsan a dos porque el umbral lo
// configuró el patrón: fundirlos borraría una distinción que él mismo fijó, y en
// un documento firmado la diferencia entre llegar diez minutos tarde y llegar dos
// horas tarde no es cosmética.
function criterioEntradaTexto(horario:any): string[]|null {
  const q = String(horario?.entrada||"").split(":");
  const hh = parseInt(q[0],10), mm = parseInt(q[1],10);
  if (isNaN(hh) || isNaN(mm)) return null;
  const tol = Math.max(0, Number(horario?.toleranciaMin)||0);
  const umb = umbralFaltaDe(horario);
  const hora = (min:number) => {
    const total = ((hh*60+mm+min) % 1440 + 1440) % 1440;
    return `${String(Math.floor(total/60)).padStart(2,"0")}:${String(total%60).padStart(2,"0")}`;
  };
  // CON UMBRAL 0 NO HAY RETARDO: pasada la tolerancia, toda entrada es tardía
  // (así clasifica clasificarEntrada). Escribir "después de las 09:10 y antes de
  // las 09:10" sería un renglón sin sentido en un papel que se firma.
  if (umb === 0) return [
    `A tiempo: entrada registrada hasta las ${hora(tol)} (hora de entrada ${hora(0)} más ${tol} min de tolerancia).`,
    `Retardo: no aplica; el umbral de entrada tardía configurado es de 0 min.`,
    `Entrada tardía: entrada después de las ${hora(tol)}. Es una llegada registrada, no una inasistencia.`,
  ];
  return [
    `A tiempo: entrada registrada hasta las ${hora(tol)} (hora de entrada ${hora(0)} más ${tol} min de tolerancia).`,
    `Retardo: entrada después de las ${hora(tol)} y antes de las ${hora(tol+umb)}.`,
    `Entrada tardía: entrada a partir de las ${hora(tol+umb)}. Es una llegada registrada, no una inasistencia.`,
  ];
}

// Etiqueta de un día, con LAS MISMAS PALABRAS en todas las pantallas.
function etiquetaDiaChecador(e: EstadoDiaChecador): string {
  if (e.estado === "con_registro") return ETIQUETA_CLASIF_ENTRADA[clasifDeEntradaRegistrada(e.clasif)];
  if (e.estado === "vacaciones") return "Vacaciones";
  if (e.estado === "descanso_obligatorio") return e.descanso ? `Descanso obligatorio · ${e.descanso}` : "Descanso obligatorio";
  if (e.estado === "no_laborable") return "No laborable";
  if (e.estado === "sin_registro") return "Sin registro";
  if (e.estado === "futuro") return "Aún no ocurre";
  if (e.estado === "antes_ingreso") return "Antes de su ingreso";
  if (e.estado === "despues_baja") return "Después de su baja";
  return "No determinable";
}

const TIPO_COLORS:Record<string,{bg:string;border:string;text:string;dot:string}> = {
  fiscal:    {bg:"rgba(239,68,68,0.08)",  border:"rgba(239,68,68,0.25)",  text:"#B91C1C", dot:"#EF4444"},
  laboral:   {bg:"rgba(245,158,11,0.08)", border:"rgba(245,158,11,0.25)", text:"#92400E", dot:"#F59E0B"},
  personal:  {bg:"rgba(124,58,237,0.08)", border:"rgba(124,58,237,0.25)", text:"#5B21B6", dot:"#7C3AED"},
  contrato:  {bg:"rgba(14,165,233,0.08)", border:"rgba(14,165,233,0.25)", text:"#075985", dot:"#0EA5E9"},
  vacaciones:{bg:"rgba(5,150,105,0.08)",  border:"rgba(5,150,105,0.25)",  text:"#065F46", dot:"#059669"},
};

const MESES = ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];
const DIAS_SEMANA = ["Dom","Lun","Mar","Mié","Jue","Vie","Sáb"];

// #region MÓDULO
// ─── MÓDULO: DOCUMENTOS ───────────────────────────────────────────────────────
function DocumentosModulo({onBack, currentUser, fontSans, fontSerif, gold}:{
  onBack:()=>void; currentUser:any; fontSans:string; fontSerif:string; gold:string;
}) {
  const isMobile = window.innerWidth < 768;

  // Guard de seguridad: si por alguna razón no hay currentUser (anonymous auth falló),
  // mostramos mensaje en vez de crashear con currentUser.uid.
  if (!currentUser) {
    return (
      <div style={{minHeight:"100vh", background:T_LIGHT.canvas, fontFamily:fontSans, display:"flex", flexDirection:"column" as const}}>
        <div style={{background:T.navy, padding:"0 20px",
          height:58, display:"flex", alignItems:"center", gap:12,
          borderBottom:"1px solid rgba(184,147,42,0.24)", boxShadow:"0 2px 16px rgba(22,36,71,0.12)"}}>
          <button onClick={onBack}
            style={{background:"rgba(255,255,255,0.08)", border:"1px solid rgba(255,255,255,0.12)",
              color:"white", borderRadius:8, padding:"5px 12px", cursor:"pointer", fontSize:12}}>
            ← Suite
          </button>
          <AxisIcon name="suite_documentos" size={20} tone="gold" withBackdrop={false} strokeWidth={2.5}/>
          <div style={{flex:1}}>
            <div style={{fontFamily:fontSerif, fontSize:15, fontWeight:700, color:gold}}>Documentos</div>
          </div>
        </div>
        <div style={{flex:1, display:"flex", alignItems:"center", justifyContent:"center", padding:"32px 20px"}}>
          <div style={{maxWidth:440, width:"100%", textAlign:"center" as const,
            background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.goldBorder}`,
            borderRadius:18, padding:isMobile?"32px 22px":"44px 36px", boxShadow:T_LIGHT.shadow}}>
            <div style={{fontSize:48, marginBottom:14}}>⚠️</div>
            <h2 style={{fontFamily:fontSerif, fontSize:isMobile?20:24, color:T_LIGHT.textInk,
              margin:"0 0 12px", fontWeight:700}}>
              Inicializando sesión…
            </h2>
            <p style={{fontSize:14, lineHeight:1.6, color:T_LIGHT.textInkSoft,
              margin:"0 0 24px"}}>
              Si este mensaje persiste, recarga la página. Si el problema continúa, es posible que la
              autenticación anónima no esté habilitada en Firebase.
            </p>
            <button onClick={onBack}
              style={{background:gold, border:"none", color:"#0B1829",
                borderRadius:10, padding:"12px 28px", cursor:"pointer", fontSize:14,
                fontWeight:700, fontFamily:fontSans, width:"100%"}}>
              ← Volver a la Suite
            </button>
          </div>
        </div>
      </div>
    );
  }

  type Carpeta = "empresa"|"empleados"|"actas"|"contratos"|"vehiculos"|"otros";
  const [carpeta, setCarpeta] = useState<Carpeta>("empresa");
  const [empleados, setEmpleados] = useState<any[]>([]);
  const [empleadoSel, setEmpleadoSel] = useState<any|null>(null);
  // Arranca en activos —el trabajo del día a día— pero las bajas se pueden incluir:
  // el expediente de quien ya salió sigue siendo prueba y debe poder consultarse.
  const [filtroDocsEmpleado, setFiltroDocsEmpleado] = useState<"activo"|"todos">("activo");
  const [docs, setDocs] = useState<Record<string,any[]>>({});
  const [cargando, setCargando] = useState(false);
  const [buscando, setBuscando] = useState("");

  const CARPETAS: {id:Carpeta; label:string; icon:string; iconName:string; desc:string; color:string}[] = [
    {id:"empresa",    label:"Empresa",           icon:"🏢", iconName:"building",        desc:"Acta constitutiva, RFC, licencias, permisos", color:"#B8932A"},
    {id:"empleados",  label:"Empleados",          icon:"👥", iconName:"suite_empleados", desc:"INE, contratos firmados, IMSS, CURP",         color:"#0EA5E9"},
    // Actas y constancias: NO es un almacén nuevo. Lee los mismos documentos del
    // expediente (trabajadores/{id}.documentos) y filtra los que el módulo de
    // Obligaciones marcó con `tipo`. Un tercer lugar sería donde se pierden.
    {id:"actas",      label:"Actas y constancias", icon:"⚖️", iconName:"scale_simple",   desc:"Actas de vacaciones y constancias de aguinaldo", color:"#B45309"},
    {id:"contratos",  label:"Contratos firmados", icon:"📄", iconName:"document",        desc:"Versiones firmadas de contratos generados",   color:"#059669"},
    {id:"vehiculos",  label:"Vehículos",          icon:"🚗", iconName:"suite_flotilla",  desc:"Circulación, pólizas, verificaciones",        color:"#7C3AED"},
    {id:"otros",      label:"Otros",              icon:"📋", iconName:"clipboard",       desc:"Documentos varios",                           color:"#6B7280"},
  ];

  // Cargar empleados: lo necesitan la carpeta de Empleados y la de Actas, que
  // lee los mismos documentos del expediente y los filtra por tipo.
  useEffect(() => {
    if ((carpeta !== "empleados" && carpeta !== "actas") || !currentUser) return;
    setCargando(true);
    // NO usamos orderBy("nombre"): where+orderBy en distinto campo requiere
    // índice compuesto. Ordenamos en JS después.
    getDocs(query(collection(db,"trabajadores"),
      where("userId","==",currentUser.uid)))
      .then(snap => {
        const items = snap.docs.map(d => ({id:d.id,...d.data()} as any))
          .sort((a,b) => (a.nombre || "").localeCompare(b.nombre || ""));
        setEmpleados(items);
        setCargando(false);
      }).catch(() => setCargando(false));
  }, [carpeta, currentUser]);

  const empleadosDocsVisibles = filtroDocsEmpleado === "todos"
    ? empleados
    : empleados.filter((e:any)=> (e.status||"activo") !== "baja");

  // Cargar documentos de la carpeta activa (excepto empleados que usa sub-selección)
  useEffect(() => {
    if (carpeta === "empleados" || carpeta === "actas" || !currentUser) return;
    setCargando(true);
    getDoc(doc(db,"documentos_empresa",currentUser.uid))
      .then(snap => {
        const data = snap.exists() ? snap.data() : {};
        setDocs(data);
        setCargando(false);
      }).catch(() => setCargando(false));
  }, [carpeta, currentUser]);

  // ÉSTE ES EL QUE PERDIÓ CINCO ARCHIVOS DE UN CLIENTE REAL. Recibía un archivo y
  // escribía `[...docs[carpeta], uno]`; con seis llamadas seguidas las seis leían
  // el mismo `docs` del cierre y `merge:true` reemplaza el arreglo, así que ganó
  // la última y las otras cinco quedaron en Storage sin figurar en ninguna parte.
  // Ahora entra la tanda entera y se escribe UNA vez.
  const subirDoc = async (archivos:{url:string; nombre:string}[]) => {
    const key = carpeta;
    const actual = docs[key] || [];
    const hoy = new Date().toISOString().slice(0,10);
    const nuevos = [...actual, ...archivos.map((a, k)=>({
      nombre:a.nombre, url:a.url, fecha:hoy,
      // El id sale de la posición además del reloj: seis archivos en la misma
      // tanda comparten milisegundo y acababan con el mismo id.
      id: String(Date.now()) + "-" + k,
    }))];
    const nuevoDocs = {...docs, [key]: nuevos};
    setDocs(nuevoDocs);
    await setDoc(doc(db,"documentos_empresa",currentUser.uid), nuevoDocs, {merge:true});
  };

  // La tanda entera, en UNA escritura.
  const subirDocEmpleado = async (archivos:{url:string; nombre:string}[], empId:string) => {
    const empActual = empleados.find(e=>e.id===empId);
    if (!empActual) return;
    const docsAct = empActual.documentos || [];
    const hoy = new Date().toISOString().slice(0,10);
    const nuevos = [...docsAct, ...archivos.map((a)=>({nombre:a.nombre, url:a.url, fecha:hoy}))];
    await updateDoc(doc(db,"trabajadores",empId), {documentos:nuevos});
    setEmpleados(prev => prev.map(e => e.id===empId ? {...e, documentos:nuevos} : e));
    if (empleadoSel?.id === empId) setEmpleadoSel((e:any) => ({...e, documentos:nuevos}));
  };

  const eliminarDoc = async (idx:number) => {
    const key = carpeta;
    const actual = docs[key] || [];
    await eliminarArchivo(actual[idx].url);
    const nuevos = actual.filter((_:any,i:number)=>i!==idx);
    const nuevoDocs = {...docs, [key]: nuevos};
    setDocs(nuevoDocs);
    await setDoc(doc(db,"documentos_empresa",currentUser.uid), nuevoDocs, {merge:true});
  };

  const eliminarDocEmpleado = async (empId:string, idx:number) => {
    const emp = empleados.find(e=>e.id===empId);
    if (!emp) return;
    const docsAct = emp.documentos || [];
    await eliminarArchivo(docsAct[idx].url);
    const nuevos = docsAct.filter((_:any,i:number)=>i!==idx);
    await updateDoc(doc(db,"trabajadores",empId), {documentos:nuevos});
    setEmpleados(prev => prev.map(e => e.id===empId ? {...e, documentos:nuevos} : e));
    if (empleadoSel?.id === empId) setEmpleadoSel((e:any) => ({...e, documentos:nuevos}));
  };

  const docIcon = (nombre:string) => {
    if (!nombre) return "📋";
    if (nombre.match(/\.pdf$/i)) return "📄";
    if (nombre.match(/\.(jpg|jpeg|png|gif|webp)$/i)) return "🖼️";
    if (nombre.match(/\.(doc|docx)$/i)) return "📝";
    if (nombre.match(/\.(xls|xlsx)$/i)) return "📊";
    return "📋";
  };

  const carpetaActual = CARPETAS.find(c=>c.id===carpeta)!;
  const docsActuales = docs[carpeta] || [];
  const docsFiltrados = buscando
    ? docsActuales.filter(d=>d.nombre?.toLowerCase().includes(buscando.toLowerCase()))
    : docsActuales;

  return (
    <div style={{minHeight:"100vh", background:T_LIGHT.canvas, fontFamily:fontSans}}>
      {/* Header navy interno removido — "Documentos" lo da el sidebar. */}

      {/* Banner de cifrado y confidencialidad sobre canvas crema */}
      <div style={{background:T_LIGHT.goldSoft, borderBottom:`1px solid ${T_LIGHT.goldBorder}`,
        padding:isMobile?"8px 14px":"9px 24px", display:"flex", alignItems:"center", gap:10}}>
        <AxisIcon name="lock_closed" size={14} tone="gold" withBackdrop={false} strokeWidth={3}/>
        <div style={{fontSize:11.5, color:T_LIGHT.textInkSoft, lineHeight:1.4}}>
          <strong style={{color:T_LIGHT.gold}}>Cifrado y confidencialidad:</strong> tus archivos se almacenan cifrados en servidores seguros y se mantienen bajo estricta confidencialidad. Solo tú y los usuarios autorizados de tu cuenta tienen acceso.
        </div>
      </div>

      {/* Altura anclada al viewport: se le descuenta el zócalo de los flotantes
          para que el último archivo de la lista no quede bajo el búho. */}
      <div style={{display:"flex", height: isMobile ? "calc(100vh - 95px)" : `calc(100vh - 95px - ${ZOCALO_FLOTANTES}px)`, overflow:"hidden"}}>

        {/* Sidebar de carpetas */}
        <div style={{width:isMobile?"0":"220px", flexShrink:0, overflow:"hidden",
          background:T_LIGHT.canvasSoft, borderRight:`1px solid ${T_LIGHT.border}`,
          display:isMobile?"none":"flex", flexDirection:"column" as const, gap:4, padding:"16px 10px"}}>
          <div style={{fontSize:10, color:T_LIGHT.textInkMut, fontWeight:700,
            letterSpacing:"1px", textTransform:"uppercase" as const, padding:"0 6px", marginBottom:8}}>
            Carpetas
          </div>
          {CARPETAS.map(c => (
            <button key={c.id} onClick={()=>{setCarpeta(c.id);setEmpleadoSel(null);setBuscando("");}}
              style={{display:"flex", alignItems:"center", gap:10, padding:"10px 12px",
                borderRadius:10, border:`1px solid ${carpeta===c.id?`${c.color}40`:"transparent"}`, cursor:"pointer", textAlign:"left" as const,
                background:carpeta===c.id?`${c.color}1A`:"transparent",
                transition:"all 0.2s"}}>
              <AxisIcon name={c.iconName} size={18} color={carpeta===c.id?c.color:T_LIGHT.textInkMut} withBackdrop={false} strokeWidth={3}/>
              <div style={{flex:1}}>
                <div style={{fontSize:13, fontWeight:carpeta===c.id?700:500,
                  color:carpeta===c.id?T_LIGHT.textInk:T_LIGHT.textInkSoft}}>{c.label}</div>
                <div style={{fontSize:10, color:T_LIGHT.textInkMut}}>{c.desc}</div>
              </div>
            </button>
          ))}
        </div>

        {/* Selector de carpetas en móvil */}
        {isMobile && (
          <div style={{display:"none"}}/>
        )}

        {/* Panel principal */}
        <div style={{flex:1, overflowY:"auto" as const, padding:isMobile?"16px":"24px"}}>

          {/* Header de carpeta + botón subir */}
          <div style={{display:"flex", alignItems:"center", gap:12, marginBottom:20,
            flexWrap:"wrap" as const}}>
            <div style={{flex:1}}>
              <h2 style={{fontFamily:fontSerif, fontSize:isMobile?18:22, color:T_LIGHT.textInk,
                margin:"0 0 4px", display:"flex", alignItems:"center", gap:10}}>
                <AxisIcon name={carpetaActual.iconName} size={isMobile?20:24} color={carpetaActual.color} withBackdrop={false} strokeWidth={2.5}/>
                {carpetaActual.label}
              </h2>
              <p style={{margin:0, fontSize:12, color:T_LIGHT.textInkSoft}}>
                {carpetaActual.desc}
              </p>
            </div>
            {carpeta !== "empleados" && (
              <SubirArchivoBtn
                userId={currentUser.uid}
                carpeta={carpeta}
                label="Subir archivo"
                accept={carpeta==="vehiculos" ? ".pdf,.jpg,.jpeg,.png" : carpeta==="contratos" ? ".pdf,.doc,.docx,.jpg,.jpeg,.png" : ".pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx"}
                onLote={subirDoc}
              />
            )}
          </div>

          {/* Tabs de carpetas en móvil */}
          {isMobile && (
            <div style={{display:"flex", gap:6, overflowX:"auto" as const,
              marginBottom:16, paddingBottom:4}}>
              {CARPETAS.map(c => (
                <button key={c.id} onClick={()=>{setCarpeta(c.id);setEmpleadoSel(null);}}
                  style={{padding:"6px 12px", borderRadius:20,
                    border:`1px solid ${carpeta===c.id?`${c.color}40`:T_LIGHT.border}`,
                    cursor:"pointer", fontSize:11, fontWeight:carpeta===c.id?700:500,
                    whiteSpace:"nowrap" as const,
                    background:carpeta===c.id?`${c.color}1A`:T_LIGHT.cardLight,
                    color:carpeta===c.id?T_LIGHT.textInk:T_LIGHT.textInkSoft,
                    display:"inline-flex", alignItems:"center", gap:6}}>
                  <AxisIcon name={c.iconName} size={12} color={carpeta===c.id?c.color:T_LIGHT.textInkMut} withBackdrop={false} strokeWidth={3}/>
                  {c.label}
                </button>
              ))}
            </div>
          )}

          {/* ── CARPETA: ACTAS Y CONSTANCIAS ──
               Vista transversal del MISMO expediente: recorre a los trabajadores
               ya cargados y saca los documentos que Obligaciones marcó con `tipo`.
               No es un almacén nuevo. El respaldo por nombre de archivo cubre lo
               generado antes de que existieran los metadatos. */}
          {carpeta === "actas" && (()=>{
            const ES_ACTA = (d:any)=>{
              const tipo = String(d?.tipo||"");
              if (tipo.startsWith("acta_vacaciones") || tipo.startsWith("constancia_aguinaldo")) return true;
              const n = String(d?.nombre||"").toLowerCase();
              return n.startsWith("acta-vacaciones") || n.startsWith("constancia-aguinaldo");
            };
            const ETIQUETA:Record<string,string> = {
              acta_vacaciones:"Acta de vacaciones",
              acta_vacaciones_firmada:"Acta de vacaciones · firmada",
              constancia_aguinaldo:"Constancia de aguinaldo",
              constancia_aguinaldo_firmada:"Constancia de aguinaldo · firmada",
            };
            const bq = buscando.trim().toLowerCase();
            const items = empleados.flatMap((e:any)=> ((e.documentos)||[])
                .filter(ES_ACTA)
                .map((d:any)=> ({...d, _emp:e.nombre||"—"})))
              .filter((d:any)=> !bq || (d._emp||"").toLowerCase().includes(bq) || (d.nombre||"").toLowerCase().includes(bq))
              .sort((a:any,b:any)=> String(b.fecha||"").localeCompare(String(a.fecha||"")));
            return (
              <div>
                {cargando ? (
                  <div style={{textAlign:"center" as const, padding:60, color:T_LIGHT.textInkSoft}}>Cargando documentos…</div>
                ) : items.length===0 ? (
                  <EstadoVacio
                    titulo={empleados.length===0 ? "Sin empleados registrados" : "Aún no hay actas ni constancias"}
                    texto={empleados.length===0
                      ? "Estas actas se generan desde Obligaciones sobre tu plantilla. Da de alta a tus trabajadores en Empleados para empezar."
                      : "Cuando generes un acta de vacaciones o una constancia de aguinaldo desde Obligaciones, aparecerá aquí y en el expediente del trabajador."}
                    acciones={[]}
                    icono="scale_simple"
                    variante={bq ? "sin-coincidencias" : "sin-datos"}
                    fontSans={fontSans} fontSerif={fontSerif}
                  />
                ) : (
                  <div style={{display:"flex", flexDirection:"column" as const, gap:10}}>
                    {items.map((d:any,i:number)=>(
                      <div key={i} style={{background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:12, padding:"12px 14px", boxShadow:T_LIGHT.shadow, display:"flex", alignItems:"center", gap:12, flexWrap:"wrap" as const}}>
                        <div style={{flex:1, minWidth:200}}>
                          <div style={{fontSize:13, fontWeight:700, color:T_LIGHT.textInk}}>{d._emp}</div>
                          <div style={{fontSize:11.5, color:T_LIGHT.textInkSoft, marginTop:2}}>
                            {ETIQUETA[String(d.tipo||"")] || "Acta o constancia"}
                            {d.periodo ? ` · ${d.periodo}` : ""}
                          </div>
                          <div style={{fontSize:11, color:T_LIGHT.textInkMut, marginTop:2}}>{d.nombre}{selloDeSubida(d) ? ` · ${selloDeSubida(d)}` : ""}</div>
                        </div>
                        {d.url && <a href={d.url} target="_blank" rel="noreferrer" style={{fontSize:12, fontWeight:700, color:T_LIGHT.gold, textDecoration:"none"}}>Abrir ›</a>}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })()}

          {/* ── CARPETA: EMPLEADOS ── */}
          {carpeta === "empleados" && (
            <div>
              {!empleadoSel ? (
                // Lista de empleados
                <div>
                  {/* Los dados de baja NO se esconden: su expediente es prueba y
                      tiene que seguir siendo accesible después de que salieron.
                      Pero el filtro arranca en activos, que es el trabajo del día
                      a día, y cuando se incluyen van etiquetados —igual que en el
                      selector de vinculación— para que nadie tenga que adivinar. */}
                  <div style={{display:"flex", alignItems:"center", justifyContent:"space-between",
                    gap:12, marginBottom:16, flexWrap:"wrap" as const}}>
                    <div style={{fontSize:13, color:T_LIGHT.textInkSoft}}>
                      Selecciona un empleado para ver o subir sus documentos
                    </div>
                    <SegmentadoFiltro<"activo"|"todos">
                      opciones={[{v:"activo", t:"Activos"}, {v:"todos", t:"Incluir bajas"}]}
                      valor={filtroDocsEmpleado} onCambio={setFiltroDocsEmpleado} fontSans={fontSans}/>
                  </div>
                  {cargando ? (
                    <div style={{color:T_LIGHT.textInkMut, textAlign:"center" as const, padding:40}}>
                      Cargando empleados...
                    </div>
                  ) : empleadosDocsVisibles.length === 0 ? (
                    <div style={{textAlign:"center" as const, padding:"40px 20px",
                      color:T_LIGHT.textInkMut, fontSize:13}}>
                      {empleados.length === 0
                        ? "No hay empleados registrados. Agrégalos en el módulo de Empleados y Nómina."
                        : "Todos tus trabajadores están dados de baja. Cambia el filtro a “Incluir bajas” para ver sus expedientes."}
                    </div>
                  ) : (
                    <div style={{display:"flex", flexDirection:"column" as const, gap:8}}>
                      {empleadosDocsVisibles.map(emp => (
                        <div key={emp.id} onClick={()=>setEmpleadoSel(emp)}
                          style={{display:"flex", alignItems:"center", gap:12,
                            background:T_LIGHT.cardLight,
                            border:`1px solid ${T_LIGHT.borderCard}`,
                            borderRadius:12, padding:"14px 16px", cursor:"pointer",
                            boxShadow:T_LIGHT.shadow,
                            transition:"all 0.2s"}}>
                          <div style={{width:40, height:40, borderRadius:"50%",
                            background:"linear-gradient(135deg,#0EA5E9,#0284C7)",
                            display:"flex", alignItems:"center", justifyContent:"center",
                            fontSize:16, fontWeight:700, color:"white", flexShrink:0}}>
                            {emp.nombre?.charAt(0).toUpperCase()}
                          </div>
                          <div style={{flex:1}}>
                            <div style={{display:"flex", alignItems:"center", gap:7, flexWrap:"wrap" as const}}>
                              <span style={{fontWeight:600, fontSize:13, color:T_LIGHT.textInk}}>{emp.nombre}</span>
                              {(emp.status||"activo")==="baja" && <ChipEstado
                                texto={emp.fechaBaja ? `Baja · ${_fechaCortaMX(emp.fechaBaja)}` : "Baja"}
                                tono="neutro"/>}
                            </div>
                            <div style={{fontSize:11, color:T_LIGHT.textInkSoft}}>
                              {emp.puesto}{emp.departamento?` · ${emp.departamento}`:""}
                            </div>
                          </div>
                          <div style={{display:"flex", alignItems:"center", gap:8}}>
                            <span style={{fontSize:11, color:T_LIGHT.textInkMut}}>
                              {(emp.documentos||[]).length} docs
                            </span>
                            <span style={{color:T_LIGHT.textInkMut, fontSize:16}}>→</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ) : (
                // Documentos del empleado seleccionado
                <div>
                  <div style={{display:"flex", alignItems:"center", gap:10, marginBottom:20}}>
                    <button onClick={()=>setEmpleadoSel(null)}
                      style={{background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`,
                        color:T_LIGHT.textInkSoft, borderRadius:8, padding:"5px 10px", cursor:"pointer", fontSize:11}}>
                      ← Empleados
                    </button>
                    <div style={{width:32, height:32, borderRadius:"50%",
                      background:"linear-gradient(135deg,#0EA5E9,#0284C7)",
                      display:"flex", alignItems:"center", justifyContent:"center",
                      fontSize:14, fontWeight:700, color:"white"}}>
                      {empleadoSel.nombre?.charAt(0).toUpperCase()}
                    </div>
                    <div>
                      <div style={{fontWeight:700, fontSize:14, color:T_LIGHT.textInk}}>{empleadoSel.nombre}</div>
                      <div style={{fontSize:11, color:T_LIGHT.textInkSoft}}>{empleadoSel.puesto}</div>
                    </div>
                    <div style={{marginLeft:"auto"}}>
                      <SubirArchivoBtn
                        userId={currentUser.uid}
                        carpeta="empleados"
                        label="Subir documento"
                        accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                        onLote={(archivos)=>subirDocEmpleado(archivos, empleadoSel.id)}
                      />
                    </div>
                  </div>
                  <ListaDocumentos
                    documentos={empleadoSel.documentos||[]}
                    docIcon={docIcon}
                    onEliminar={(i)=>eliminarDocEmpleado(empleadoSel.id,i)}
                  />
                </div>
              )}
            </div>
          )}

          {/* ── OTRAS CARPETAS ── */}
          {carpeta !== "empleados" && (
            <div>
              {/* Buscador */}
              {docsActuales.length > 3 && (
                <div style={{position:"relative" as const, marginBottom:16}}>
                  <input {...CAMPO_DE_PARAMETRO}
                    value={buscando}
                    onChange={e=>setBuscando(e.target.value)}
                    placeholder="🔍 Buscar documento..."
                    style={{width:"100%", padding:"10px 14px", borderRadius:10,
                      background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`,
                      color:T_LIGHT.textInk, fontSize:13, outline:"none", boxSizing:"border-box" as const,
                      fontFamily:fontSans}}
                  />
                </div>
              )}
              <ListaDocumentos
                documentos={docsFiltrados}
                docIcon={docIcon}
                onEliminar={eliminarDoc}
              />
              {docsActuales.length === 0 && (
                <div style={{textAlign:"center" as const, padding:"60px 20px"}}>
                  <div style={{fontSize:48, marginBottom:16}}>📭</div>
                  <div style={{fontSize:14, color:T_LIGHT.textInkSoft, marginBottom:8}}>
                    Esta carpeta está vacía
                  </div>
                  <div style={{fontSize:12, color:T_LIGHT.textInkMut}}>
                    Sube archivos con el botón "Subir archivo" de arriba
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// Componente lista de documentos reutilizable
function ListaDocumentos({documentos, docIcon, onEliminar}: {
  documentos:any[]; docIcon:(n:string)=>string; onEliminar:(i:number)=>void;
}) {
  if (documentos.length === 0) return null;
  return (
    <div style={{display:"flex", flexDirection:"column" as const, gap:8}}>
      {documentos.map((d:any, i:number) => (
        <div key={i} style={{display:"flex", alignItems:"center", gap:10,
          background:T_LIGHT.cardLight, borderRadius:12, padding:"12px 16px",
          border:`1px solid ${T_LIGHT.borderCard}`, boxShadow:T_LIGHT.shadow}}>
          <span style={{fontSize:22, flexShrink:0}}>{docIcon(d.nombre)}</span>
          <div style={{flex:1, minWidth:0}}>
            <div style={{fontSize:13, color:T_LIGHT.textInk, fontWeight:500,
              whiteSpace:"nowrap" as const, overflow:"hidden", textOverflow:"ellipsis"}}>
              {d.nombre}
            </div>
            {/* Si Obligaciones marcó el documento, se dice QUÉ es y de qué periodo:
                dos actas del mismo trabajador ya no se distinguen sólo por el archivo. */}
            {d.tipo && (
              <div style={{fontSize:11.5, color:T_LIGHT.textInkSoft, marginTop:2, fontWeight:600}}>
                {String(d.tipo).startsWith("acta_vacaciones") ? "Acta de vacaciones" : String(d.tipo).startsWith("constancia_aguinaldo") ? "Constancia de aguinaldo" : "Documento"}
                {String(d.tipo).endsWith("_firmada") ? " · firmada" : ""}
                {d.periodo ? ` · ${d.periodo}` : ""}
              </div>
            )}
            <div style={{fontSize:11, color:T_LIGHT.textInkMut, marginTop:2}}>{selloDeSubida(d)}</div>
          </div>
          <a href={(d.nombre?.match(/\.(doc|docx)$/i)) ? `https://docs.google.com/viewer?embedded=true&url=${encodeURIComponent(d.url)}` : d.url} target="_blank" rel="noreferrer"
            style={{fontSize:12, color:T_LIGHT.gold, fontWeight:600,
              textDecoration:"none", flexShrink:0, padding:"4px 10px",
              background:T_LIGHT.goldSoft, borderRadius:6,
              border:`1px solid ${T_LIGHT.goldBorder}`}}>
            Ver →
          </a>
          <button onClick={()=>onEliminar(i)}
            style={{background:"rgba(220,38,38,0.08)", border:"1px solid rgba(220,38,38,0.22)",
              color:T_LIGHT.danger, cursor:"pointer", fontSize:12, padding:"4px 8px",
              borderRadius:6, flexShrink:0}}>
            ✕
          </button>
        </div>
      ))}
    </div>
  );
}


function CalendarioModulo({onBack, fontSans, fontSerif, gold, currentUser}: {
  onBack:()=>void; fontSans:string; fontSerif:string; gold:string; currentUser:any;
}) {
  // El membrete del calendario impreso: el patron, no la plataforma.
  const dpCal = useDatosPatron(currentUser?.uid).datos;
  const isMobile = window.innerWidth < 768;

  // (Retirado) Existía un modo "vista pública compartida" por el enlace
  // "?calendario=<uid>", que permitía leer el calendario sin sesión. Se eliminó:
  // todo acceso exige cuenta. Siempre se lee el calendario del usuario en sesión.
  // `esVistaPublica` se conserva en false para no alterar los condicionales de la
  // vista del dueño (que ya se comportaban así cuando no había enlace compartido).
  const uidParaLeer = currentUser?.uid || null;
  const esVistaPublica = false;

  // Guard: solo bloquea si NO hay uid del que leer (ni compartido ni sesión)
  if (!uidParaLeer) {
    return (
      <div style={{minHeight:"100vh", background:T_LIGHT.canvas, fontFamily:fontSans, display:"flex", flexDirection:"column" as const}}>
        <div style={{background:T.navy, padding:"0 20px",
          height:58, display:"flex", alignItems:"center", gap:12,
          borderBottom:"1px solid rgba(184,147,42,0.24)", boxShadow:"0 2px 16px rgba(22,36,71,0.12)"}}>
          <button onClick={onBack}
            style={{background:"rgba(255,255,255,0.08)", border:"1px solid rgba(255,255,255,0.12)",
              color:"white", borderRadius:8, padding:"5px 12px", cursor:"pointer", fontSize:12}}>
            ← Suite
          </button>
          <span style={{fontSize:18}}>📅</span>
          <div style={{flex:1}}>
            <div style={{fontFamily:fontSerif, fontSize:15, fontWeight:700, color:gold}}>Calendario Empresarial</div>
          </div>
        </div>
        <div style={{flex:1, display:"flex", alignItems:"center", justifyContent:"center", padding:"32px 20px"}}>
          <div style={{maxWidth:440, width:"100%", textAlign:"center" as const,
            background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.goldBorder}`,
            borderRadius:18, padding:isMobile?"32px 22px":"44px 36px",
            boxShadow:T_LIGHT.shadow}}>
            <div style={{fontSize:48, marginBottom:14}}>📅</div>
            <h2 style={{fontFamily:fontSerif, fontSize:isMobile?20:24, color:T_LIGHT.textInk,
              margin:"0 0 12px", fontWeight:700}}>Necesitas una cuenta</h2>
            <p style={{fontSize:14, lineHeight:1.6, color:T_LIGHT.textInkSoft, margin:"0 0 24px"}}>
              El Calendario guarda tus obligaciones fiscales y laborales por usuario. Crea una cuenta gratuita para usarlo.
            </p>
            <button onClick={onBack}
              style={{background:gold, border:"none", color:"#0B1829", borderRadius:10,
                padding:"12px 28px", cursor:"pointer", fontSize:14, fontWeight:700,
                fontFamily:fontSans, width:"100%", boxShadow:"0 4px 16px rgba(184,147,42,0.35)"}}>
              ← Volver a la Suite
            </button>
          </div>
        </div>
      </div>
    );
  }

  const hoy = new Date();
  const [anio, setAnio] = useState(hoy.getFullYear());
  const [mes, setMes] = useState(hoy.getMonth());
  const [eventosUser, setEventosUser] = useState<EventoCal[]>([]);
  const [trabajadoresInfo, setTrabajadoresInfo] = useState<any[]>([]);
  const [diaSeleccionado, setDiaSeleccionado] = useState<string|null>(null);
  const [showFormEvento, setShowFormEvento] = useState(false);
  const [showCompartir, setShowCompartir] = useState(false);
  const [formEvento, setFormEvento] = useState<Partial<EventoCal>>({tipo:"personal", repeticion:"ninguna"});
  const [guardando, setGuardando] = useState(false);
  const [filtroTipo, setFiltroTipo] = useState<string>("todos");
  const isPublico = !currentUser;

  // Loaders memoizados — referencia estable mientras no cambien uidParaLeer
  // o esVistaPublica, lo que permite usarlos como deps del useEffect de abajo
  // sin ciclos infinitos ni silenciar el lint.
  const cargarEventos = useCallback(async () => {
    if (!uidParaLeer) return;
    try {
      const q = query(collection(db,"eventos_calendario"), where("userId","==",uidParaLeer));
      const snap = await getDocs(q);
      setEventosUser(snap.docs.map(d=>({id:d.id,...d.data()} as EventoCal)));
    } catch(e){ console.error(e); }
  }, [uidParaLeer]);

  const cargarTrabajadores = useCallback(async () => {
    if (!uidParaLeer) return;
    // En modo vista pública NO leemos trabajadores: son datos sensibles y la
    // regla de Firestore solo permite al dueño leer su lista. Como
    // consecuencia, en modo compartido NO se muestran aniversarios/vencimientos
    // de empleados — sólo obligaciones fiscales y eventos personales del
    // calendario. Es un trade-off intencional.
    if (esVistaPublica) { setTrabajadoresInfo([]); return; }
    try {
      const q = query(collection(db,"trabajadores"), where("userId","==",uidParaLeer));
      const snap = await getDocs(q);
      setTrabajadoresInfo(snap.docs.map(d=>({id:d.id,...d.data()})).filter((t:any)=>t.status==="activo"));
    } catch(e){ console.error(e); }
  }, [uidParaLeer, esVistaPublica]);

  useEffect(() => {
    if (uidParaLeer) {
      cargarEventos();
      cargarTrabajadores();
    }
  }, [uidParaLeer, cargarEventos, cargarTrabajadores]);

  // Generar eventos automáticos del expediente (vienen de trabajadores del
  // dueño del calendario que estamos viendo — propio o compartido).
  const eventosExpediente: EventoCal[] = (uidParaLeer ? trabajadoresInfo : []).flatMap((t:any) => {
    const evs: EventoCal[] = [];
    // Vencimiento de contrato
    if (t.fechaVencimiento) {
      evs.push({id:`venc-${t.id}`, titulo:`📋 Vence contrato: ${t.nombre}`, fecha:t.fechaVencimiento, tipo:"contrato", descripcion:`Vencimiento del contrato de ${t.puesto}`});
    }
    // Aniversario laboral
    const anivFecha = `${anio}-${t.fechaIngreso.slice(5)}`;
    // Los años se restan de las CADENAS, sin pasar por Date: `new Date("2026-09-01")`
    // es medianoche UTC y en México cae en el 31 de diciembre del año anterior
    // cuando el ingreso es 1 de enero, con lo que el aniversario contaría un año
    // de más. Y de este aniversario sale el periodo de vacaciones que acaba
    // impreso en el acta que se firma.
    const _aAniv = Number(String(anivFecha).slice(0,4)) || 0;
    const _aIngreso = Number(String(t.fechaIngreso).slice(0,4)) || 0;
    evs.push({id:`aniv-${t.id}`, titulo:`🎂 Aniversario: ${t.nombre}`, fecha:anivFecha, tipo:"vacaciones", descripcion:`${_aAniv - _aIngreso} años en la empresa`});
    return evs;
  });

  const todosEventos = [...OBLIGACIONES_FIJAS, ...eventosUser, ...eventosExpediente];

  const eventosMes = todosEventos.filter(e => {
    const [y,m] = e.fecha.split("-").map(Number);
    const matchMes = y === anio && m-1 === mes;
    const matchTipo = filtroTipo === "todos" || e.tipo === filtroTipo;
    return matchMes && matchTipo;
  });

  // Generar días del mes
  const primerDia = new Date(anio, mes, 1).getDay();
  const diasMes = new Date(anio, mes+1, 0).getDate();
  const celdas: (number|null)[] = [...Array(primerDia).fill(null), ...Array.from({length:diasMes},(_,i)=>i+1)];
  while (celdas.length % 7 !== 0) celdas.push(null);

  const eventosDelDia = (dia:number) => {
    const fecha = `${anio}-${String(mes+1).padStart(2,"0")}-${String(dia).padStart(2,"0")}`;
    return eventosMes.filter(e => e.fecha === fecha);
  };

  const guardarEvento = async () => {
    if (!formEvento.titulo || !formEvento.fecha) return;
    setGuardando(true);
    try {
      await addDoc(collection(db,"eventos_calendario"), {...formEvento, userId:currentUser.uid, timestamp:Timestamp.now()});
      await cargarEventos();
      setShowFormEvento(false);   // el formulario solo se cierra si el evento existe
      setFormEvento({tipo:"personal", repeticion:"ninguna"});
    } catch(e:any){ console.error(e); alert("No se pudo guardar el evento: " + (e?.code || e?.message || "error desconocido")); }
    setGuardando(false);
  };

  const eliminarEvento = async (id:string) => {
    if (!window.confirm("¿Eliminar este evento?")) return;
    // Sin try/catch era una promesa rechazada sin dueno. La recarga va en `finally`
    // para que el dia muestre lo que de verdad quedo.
    try {
      await deleteDoc(doc(db,"eventos_calendario",id));
      setDiaSeleccionado(null);
    } catch(e:any){ console.error(e); alert("No se pudo eliminar el evento: " + (e?.code || e?.message || "error desconocido")); }
    finally { await cargarEventos(); }
  };


  const generarPDF = () => {
    const evsMes = eventosMes.sort((a,b)=>a.fecha.localeCompare(b.fecha));
    const filas = evsMes.map(e => {
      const d = new Date(e.fecha+"T12:00:00").toLocaleDateString("es-MX",{day:"numeric",month:"long"});
      const c = TIPO_COLORS[e.tipo];
      return `<tr style="border-bottom:1px solid #eee">
        <td style="padding:10px 12px;font-size:13px;color:#1A1A2E">${d}</td>
        <td style="padding:10px 12px"><span style="background:${c.bg};color:${c.text};border:1px solid ${c.border};padding:3px 10px;border-radius:12px;font-size:11px;font-weight:700">${e.tipo.toUpperCase()}</span></td>
        <td style="padding:10px 12px;font-size:13px;color:#1A1A2E;font-weight:600">${e.titulo}</td>
        <td style="padding:10px 12px;font-size:12px;color:#6B7280">${e.descripcion||""}</td>
      </tr>`;
    }).join("");

    const html = `<!DOCTYPE html><html lang="es"><head><meta charset="UTF-8">
    <title>Calendario ${MESES[mes]} ${anio}</title>
    <style>body{font-family:'Times New Roman',serif;padding:50px 60px;color:#1A1A2E}
    .header{display:flex;justify-content:space-between;align-items:center;margin-bottom:32px;padding-bottom:16px;border-bottom:2px solid #B8932A}
    table{width:100%;border-collapse:collapse}thead{background:#162447}
    thead th{padding:10px 12px;font-size:11px;color:rgba(255,255,255,0.7);text-align:left;font-family:Arial,sans-serif;text-transform:uppercase;letter-spacing:0.5px}
    .footer{text-align:center;margin-top:32px;font-size:10px;color:#9A9AAA;font-family:Arial,sans-serif}
    @media print{body{padding:30px 40px}}</style></head><body>
    <div class="header">
      ${!dpCal.denominacion ? "" : `<div style="font-family:Arial,sans-serif;"><div style="font-size:16px;font-weight:800;color:#0F172A">${_escHtml(dpCal.denominacion)}</div>
      ${dpCal.rfc ? `<div style="font-size:10px;color:#162447;margin-top:2px">RFC ${_escHtml(dpCal.rfc)}</div>` : ""}</div>`}
      <div style="font-family:Arial,sans-serif;text-align:right">
        <div style="font-size:18px;font-weight:700;color:#162447">${MESES[mes]} ${anio}</div>
        <div style="font-size:11px;color:#9A9AAA">Calendario de obligaciones empresariales</div>
      </div>
    </div>
    <table><thead><tr><th>Fecha</th><th>Tipo</th><th>Obligación / Evento</th><th>Descripción</th></tr></thead>
    <tbody>${filas}</tbody></table>
    <div class="footer">${_escHtml(pieDelPatronTexto(dpCal, fechaHoraLargaAxis()))}</div>
    <script>window.onload=()=>window.print()</script></body></html>`;

    const blob = new Blob([html], {type:"text/html"});
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a"); a.href=url;
    a.download = `Calendario_${MESES[mes]}_${anio}.html`;
    a.click(); URL.revokeObjectURL(url);
  };

  const diaSelec = diaSeleccionado ? eventosDelDia(parseInt(diaSeleccionado.split("-")[2])) : [];

  return (
    <div style={{minHeight:"100vh", background:T_LIGHT.canvas, fontFamily:fontSans}}>
      {/* Header slim — sólo se muestra al dueño autenticado (esVistaPublica oculta
         las acciones de edición/compartir/PDF del visitante público). */}
      {currentUser && !esVistaPublica && (
        <div style={{background:T.navy, padding:"0 20px", height:46, display:"flex", alignItems:"center", justifyContent:"flex-end", gap:8, position:"sticky" as const, top:0, zIndex:50, borderBottom:"1px solid rgba(184,147,42,0.20)", boxShadow:"0 2px 12px rgba(22,36,71,0.10)"}}>
          <button onClick={()=>setShowCompartir(true)} style={{background:"rgba(184,147,42,0.15)", border:"1px solid rgba(184,147,42,0.3)", color:gold, borderRadius:8, padding:"5px 12px", cursor:"pointer", fontSize:11, fontWeight:700}}>Descargar</button>
          <button onClick={generarPDF} style={{background:"rgba(255,255,255,0.08)", border:"1px solid rgba(255,255,255,0.15)", color:"white", borderRadius:8, padding:"5px 12px", cursor:"pointer", fontSize:11}}>📄 PDF</button>
          <button onClick={()=>{setFormEvento({tipo:"personal",repeticion:"ninguna",fecha:diaSeleccionado||""});setShowFormEvento(true);}} style={{background:"linear-gradient(135deg,#B8932A,#8B6914)", border:"none", color:"white", borderRadius:8, padding:"5px 14px", cursor:"pointer", fontSize:11, fontWeight:700}}>+ Evento</button>
        </div>
      )}
      {/* Banner "Solo lectura" — visible cuando se abre el calendario via link compartido */}
      {esVistaPublica && (
        <div style={{background:"rgba(184,147,42,0.10)", borderBottom:`1px solid ${T_LIGHT.goldBorder}`, padding:isMobile?"8px 14px":"9px 24px", display:"flex", alignItems:"center", gap:10}}>
          <span style={{fontSize:14}}>🔒</span>
          <div style={{fontSize:11.5, color:T_LIGHT.textInkSoft, lineHeight:1.4}}>
            Vista compartida (solo lectura). Las obligaciones y eventos los gestiona el titular del calendario.
          </div>
        </div>
      )}

      <div style={{maxWidth:ANCHO_CONTENIDO, margin:"0 auto", padding:isMobile?"12px":"24px 28px", display:"grid", gridTemplateColumns:isMobile||diaSeleccionado===null?"1fr":"1fr 300px", gap:16}}>
        <div>
          {/* Navegación mes */}
          <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:16}}>
            <button onClick={()=>{if(mes===0){setMes(11);setAnio(a=>a-1);}else setMes(m=>m-1);setDiaSeleccionado(null);}}
              style={{background:"white", border:"1px solid rgba(22,36,71,0.12)", borderRadius:10, padding:"8px 16px", cursor:"pointer", fontSize:14, fontWeight:600, color:"#162447"}}>‹</button>
            <h2 style={{fontFamily:fontSerif, fontSize:isMobile?18:24, color:T_LIGHT.textInk, fontWeight:700, margin:0}}>{MESES[mes]} <span style={{color:T_LIGHT.gold}}>{anio}</span></h2>
            <button onClick={()=>{if(mes===11){setMes(0);setAnio(a=>a+1);}else setMes(m=>m+1);setDiaSeleccionado(null);}}
              style={{background:"white", border:"1px solid rgba(22,36,71,0.12)", borderRadius:10, padding:"8px 16px", cursor:"pointer", fontSize:14, fontWeight:600, color:"#162447"}}>›</button>
          </div>

          {/* Filtro tipo */}
          <div style={{display:"flex", gap:6, marginBottom:14, flexWrap:"wrap" as const}}>
            {["todos","fiscal","laboral","personal","contrato","vacaciones"].map(t => (
              <button key={t} onClick={()=>setFiltroTipo(t)}
                style={{padding:"5px 12px", borderRadius:20, border:"1px solid rgba(22,36,71,0.12)", fontSize:11, fontWeight:600, cursor:"pointer",
                  background:filtroTipo===t?(TIPO_COLORS[t]?.bg||"#162447"):"white",
                  color:filtroTipo===t?(TIPO_COLORS[t]?.text||"white"):"#4A4A60",
                  borderColor:filtroTipo===t?(TIPO_COLORS[t]?.border||"#162447"):"rgba(22,36,71,0.12)"}}>
                {t==="todos"?"Todos":t.charAt(0).toUpperCase()+t.slice(1)}
              </button>
            ))}
          </div>

          {/* Grid del calendario */}
          <div style={{background:T_LIGHT.cardLight, borderRadius:16, padding:isMobile?12:20, boxShadow:T_LIGHT.shadow, border:`1px solid ${T_LIGHT.borderCard}`}}>
            {/* Cabecera días */}
            <div style={{display:"grid", gridTemplateColumns:"repeat(7,1fr)", marginBottom:8}}>
              {DIAS_SEMANA.map(d => (
                <div key={d} style={{textAlign:"center" as const, fontSize:11, fontWeight:700, color:T_LIGHT.textInkSoft, padding:"6px 0", textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>{d}</div>
              ))}
            </div>
            {/* Semanas */}
            {Array.from({length:celdas.length/7},(_,si) => (
              <div key={si} style={{display:"grid", gridTemplateColumns:"repeat(7,1fr)", gap:2, marginBottom:2}}>
                {celdas.slice(si*7,(si+1)*7).map((dia,di) => {
                  if (!dia) return <div key={di} />;
                  const fechaStr = `${anio}-${String(mes+1).padStart(2,"0")}-${String(dia).padStart(2,"0")}`;
                  const evs = eventosDelDia(dia);
                  const esHoy = fechaStr === hoy.toISOString().slice(0,10);
                  const selec = diaSeleccionado === fechaStr;
                  return (
                    <div key={di} onClick={()=>setDiaSeleccionado(selec?null:fechaStr)}
                      style={{minHeight:isMobile?48:64, padding:isMobile?"4px":"6px 8px", borderRadius:10, cursor:"pointer",
                        background:selec?"rgba(124,58,237,0.18)":esHoy?"rgba(124,58,237,0.08)":T_LIGHT.canvasSoft,
                        border:selec?"2px solid #7C3AED":esHoy?"2px solid rgba(124,58,237,0.55)":`1px solid rgba(28,43,74,0.30)`,
                        transition:"all 0.15s"}}>
                      <div style={{fontSize:isMobile?11:13, fontWeight:esHoy||selec?700:500, color:selec?"#5B21B6":esHoy?"#6D28D9":T_LIGHT.textInk, marginBottom:3}}>
                        {dia}{esHoy && <span style={{fontSize:8, marginLeft:2}}>●</span>}
                      </div>
                      {evs.slice(0,isMobile?1:3).map((e,ei) => (
                        <div key={ei} style={{
                          width:"100%", borderRadius:4, marginBottom:2,
                          background:TIPO_COLORS[e.tipo]?.dot||"#7C3AED",
                          padding:isMobile?"1px 3px":"2px 4px",
                          display:"flex", alignItems:"center", gap:2,
                          minHeight:isMobile?5:14,
                        }}>
                          {!isMobile && <span style={{
                            fontSize:9, color:"white", whiteSpace:"nowrap" as const,
                            overflow:"hidden", textOverflow:"ellipsis", lineHeight:1,
                            fontFamily:"sans-serif", maxWidth:"100%",
                          }}>{e.titulo.split("—")[0].split("–")[0].trim().substring(0,22)}</span>}
                        </div>
                      ))}
                      {evs.length>3 && <div style={{fontSize:9, color:T_LIGHT.textInkMut}}>+{evs.length-3}</div>}
                    </div>
                  );
                })}
              </div>
            ))}
          </div>

          {/* Leyenda */}
          <div style={{display:"flex", gap:12, marginTop:12, flexWrap:"wrap" as const}}>
            {Object.entries(TIPO_COLORS).map(([tipo,c]) => (
              <div key={tipo} style={{display:"flex", alignItems:"center", gap:5, fontSize:11, color:T_LIGHT.textInkSoft}}>
                <div style={{width:10, height:10, borderRadius:"50%", background:c.dot}} />
                {tipo.charAt(0).toUpperCase()+tipo.slice(1)}
              </div>
            ))}
          </div>

          {/* Próximas obligaciones */}
          <ProximasObligaciones todosEventos={todosEventos} fontSans={fontSans} fontSerif={fontSerif} />
        </div>

        {/* Panel lateral — eventos del día */}
        {diaSeleccionado && (
          <div style={{background:T_LIGHT.cardLight, borderRadius:16, padding:"20px", boxShadow:T_LIGHT.shadow, border:`1px solid ${T_LIGHT.borderCard}`, alignSelf:"start"}}>
            <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16}}>
              <h3 style={{fontFamily:fontSerif, fontSize:15, color:T_LIGHT.textInk, margin:0}}>
                {new Date(diaSeleccionado+"T12:00:00").toLocaleDateString("es-MX",{weekday:"long",day:"numeric",month:"long"})}
              </h3>
              <button onClick={()=>setDiaSeleccionado(null)} style={{background:"transparent",border:"none",cursor:"pointer",color:T_LIGHT.textInkMut,fontSize:16}}>✕</button>
            </div>
            {diaSelec.length === 0 ? (
              <div style={{textAlign:"center" as const, padding:"24px 0", color:"#9A9AAA"}}>
                <div style={{fontSize:28, marginBottom:8}}>📅</div>
                <div style={{fontSize:12}}>Sin eventos este día</div>
                {currentUser && !esVistaPublica && <button onClick={()=>{setFormEvento({tipo:"personal",repeticion:"ninguna",fecha:diaSeleccionado});setShowFormEvento(true);}} style={{marginTop:12, background:"rgba(124,58,237,0.08)", border:"1px solid rgba(124,58,237,0.2)", color:"#7C3AED", borderRadius:8, padding:"6px 14px", cursor:"pointer", fontSize:11, fontWeight:700}}>+ Agregar evento</button>}
              </div>
            ) : (
              <div style={{display:"flex", flexDirection:"column" as const, gap:8}}>
                {diaSelec.map((e,i) => {
                  const c = TIPO_COLORS[e.tipo];
                  return (
                    <div key={i} style={{background:c.bg, border:`1px solid ${c.border}`, borderRadius:10, padding:"10px 12px"}}>
                      <div style={{display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:8}}>
                        <div style={{flex:1}}>
                          <div style={{fontSize:12, fontWeight:700, color:c.text, marginBottom:4}}>{e.titulo}</div>
                          {e.descripcion && <div style={{fontSize:11, color:"#4A4A60", lineHeight:1.5}}>{e.descripcion}</div>}
                          <span style={{fontSize:10, color:c.text, fontWeight:700, marginTop:4, display:"inline-block"}}>{e.tipo.toUpperCase()}</span>
                        </div>
                        {currentUser && e.userId && !esVistaPublica && (
                          <button onClick={()=>eliminarEvento(e.id!)} style={{background:"rgba(220,38,38,0.08)",border:"none",color:"#DC2626",borderRadius:6,padding:"3px 8px",cursor:"pointer",fontSize:10}}>✕</button>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}
      </div>

      {/* Modal nuevo evento */}
      {showFormEvento && (
        <div style={{position:"fixed" as const, inset:0, background:"rgba(0,0,0,0.5)", zIndex:500, display:"flex", alignItems:"center", justifyContent:"center", padding:20}}>
          <div {...PANEL_DE_CAPTURA} onClick={e=>e.stopPropagation()} style={{background:T_LIGHT.cardLight, borderRadius:20, padding:"28px 32px", maxWidth:400, width:"100%", boxShadow:"0 20px 60px rgba(22,36,71,0.18)"}}>
            <h3 style={{fontFamily:fontSerif, fontSize:18, color:T_LIGHT.textInk, margin:"0 0 20px"}}>➕ Nuevo evento</h3>
            <div style={{display:"flex", flexDirection:"column" as const, gap:12}}>
              {[
                {label:"Título del evento *", key:"titulo", tipo:"text", ph:"Ej. Revisión de contratos"},
                {label:"Fecha *", key:"fecha", tipo:"date", ph:""},
                {label:"Descripción", key:"descripcion", tipo:"text", ph:"Notas adicionales (opcional)"},
              ].map(c => (
                <div key={c.key}>
                  <label style={{fontSize:10, color:T_LIGHT.textInkMut, display:"block", marginBottom:4, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>{c.label}</label>
                  <input value={(formEvento as any)[c.key]||""} onChange={e=>setFormEvento(p=>({...p,[c.key]:e.target.value}))} type={c.tipo} placeholder={c.ph}
                    style={{width:"100%", padding:"10px 13px", background:T_LIGHT.canvasSoft, color:T_LIGHT.textInk, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:10, fontSize:13, outline:"none", boxSizing:"border-box" as const}} />
                </div>
              ))}
              <div>
                <label style={{fontSize:10, color:T_LIGHT.textInkMut, display:"block", marginBottom:6, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>Tipo</label>
                <div style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap:6}}>
                  {(["personal","fiscal","laboral","contrato","vacaciones"] as const).map(t => (
                    <button key={t} onClick={()=>setFormEvento(p=>({...p,tipo:t}))}
                      style={{padding:"8px", borderRadius:8, border:`1px solid ${formEvento.tipo===t?TIPO_COLORS[t].border:"rgba(22,36,71,0.12)"}`, background:formEvento.tipo===t?TIPO_COLORS[t].bg:"white", cursor:"pointer", fontSize:12, fontWeight:600, color:formEvento.tipo===t?TIPO_COLORS[t].text:"#4A4A60"}}>
                      {t.charAt(0).toUpperCase()+t.slice(1)}
                    </button>
                  ))}
                </div>
              </div>
            </div>
            <div style={{display:"flex", gap:8, marginTop:20}}>
              <button onClick={(ev)=>{ if (sePuedeCerrarElPanel(ev)) setShowFormEvento(false); }} style={{flex:1, background:"rgba(22,36,71,0.06)", border:"none", borderRadius:10, padding:"12px", cursor:"pointer", fontSize:13, color:"#4A4A60"}}>Cancelar</button>
              <button onClick={guardarEvento} disabled={guardando||!formEvento.titulo||!formEvento.fecha}
                style={{flex:2, background:formEvento.titulo&&formEvento.fecha?"linear-gradient(135deg,#7C3AED,#6D28D9)":"rgba(0,0,0,0.08)", border:"none", borderRadius:10, padding:"12px", cursor:"pointer", fontSize:13, fontWeight:700, color:formEvento.titulo&&formEvento.fecha?"white":"#9A9AAA"}}>
                {guardando?"Guardando...":"💾 Guardar evento"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal compartir */}
      {showCompartir && currentUser && (
        <div onClick={()=>setShowCompartir(false)} style={{position:"fixed" as const, inset:0, background:"rgba(0,0,0,0.5)", zIndex:500, display:"flex", alignItems:"center", justifyContent:"center", padding:20}}>
          <div onClick={e=>e.stopPropagation()} style={{background:T_LIGHT.cardLight, borderRadius:20, padding:"28px 32px", maxWidth:440, width:"100%", boxShadow:"0 20px 60px rgba(22,36,71,0.18)"}}>
            <h3 style={{fontFamily:fontSerif, fontSize:18, color:T_LIGHT.textInk, margin:"0 0 8px"}}>Calendario</h3>
            <p style={{fontSize:13, color:T_LIGHT.textInkSoft, margin:"0 0 20px", lineHeight:1.6}}>Descarga tu calendario en PDF. El enlace público se retiró: ahora tu equipo lo consulta desde su cuenta de trabajador.</p>
            <div style={{display:"flex", gap:8}}>
              <button onClick={generarPDF} style={{flex:1, background:"linear-gradient(135deg,#162447,#1E3A5F)", border:"none", borderRadius:10, padding:"12px", cursor:"pointer", fontSize:13, fontWeight:700, color:"white", display:"flex", alignItems:"center", justifyContent:"center", gap:8}}>
                <AxisIcon name="document" size={14} tone="white" withBackdrop={false} strokeWidth={3}/>
                Descargar PDF
              </button>
            </div>
            <button onClick={()=>setShowCompartir(false)} style={{width:"100%", marginTop:8, background:"transparent", border:"none", color:T_LIGHT.textInkMut, cursor:"pointer", fontSize:12, padding:"8px"}}>Cerrar</button>
          </div>
        </div>
      )}
    </div>
  );
}


// #endregion
// #region MÓDULO EMPLEADOS
// ─── MÓDULO EMPLEADOS (EXPEDIENTE + NÓMINA UNIFICADOS) ───────────────────────
// ─── HORARIO LABORAL (config/almacenamiento; la clasificación de retardos es otro bloque) ───
// Fuente única: general en usuarios/{uid}.horarioLaboral (merge); por-empleado en
// trabajadores/{id}.horarioPropio. Mismo componente para móvil (tema navy) y escritorio
// (tema light). NO calcula retardos/faltas — solo guarda la configuración.
function HorarioLaboralEditor({modo, currentUser, trabajador, tema, fontSans, fontSerif, onGuardado}: {
  modo:"general"|"empleado"; currentUser:any; trabajador?:any; tema:"navy"|"light"; fontSans:string; fontSerif:string;
  // Avisa a la pantalla que lo monta con el horario efectivo ya guardado. Sin
  // esto, la ficha seguía leyendo su copia vieja del trabajador y mostraba
  // "configura el horario" justo debajo de "horario guardado".
  // El tercer dato es el historial ya escrito, para que la ficha clasifique los
  // días de antes con el horario de antes sin esperar a recargar.
  onGuardado?: (horarioResuelto:any, horarioPropioGuardado?:any, historialPropio?:any)=>void;
}) {
  const T = tema==="navy"
    ? {panel:"#0F2138", line:"rgba(184,147,42,0.30)", ink:"#ECE6D8", inkSoft:"rgba(236,230,216,0.62)", inkMut:"rgba(236,230,216,0.42)", gold:"#D4A843", inputBg:"rgba(255,255,255,0.05)", sombra:"0 6px 20px rgba(0,0,0,0.35)", dark:true}
    : {panel:T_LIGHT.cardLight, line:T_LIGHT.border, ink:T_LIGHT.textInk, inkSoft:T_LIGHT.textInkSoft, inkMut:T_LIGHT.textInkMut, gold:T_LIGHT.gold, inputBg:T_LIGHT.canvasSoft, sombra:T_LIGHT.shadow, dark:false};
  const [entrada,setEntrada]=useState(""); const [salida,setSalida]=useState("");
  const [usaComida,setUsaComida]=useState(false); const [comidaIni,setComidaIni]=useState(""); const [comidaFin,setComidaFin]=useState("");
  const [tolerancia,setTolerancia]=useState("0");
  const [toleranciaSinConfigurar,setToleranciaSinConfigurar]=useState(false);
  const [umbralFalta,setUmbralFalta]=useState("30");
  // DÍAS LABORABLES. Sin este dato la plataforma no puede decir qué días debía
  // trabajar una persona, y por eso no puede afirmar que faltó a ninguno. Antes
  // se asumía lunes a viernes para todo el mundo: a quien trabaja sábados no se
  // le contaban, y a quien descansa martes cada martes le salía como falta.
  // `null` = todavía sin configurar, que NO es lo mismo que "ningún día".
  const [diasLab,setDiasLab]=useState<number[]|null>(null);
  // Días del horario GENERAL de la empresa: para que un horario personalizado
  // pueda heredarlos y para poder decir en pantalla cuál de los dos rige.
  const [diasGenerales,setDiasGenerales]=useState<number[]|null>(null);
  const [personalizado,setPersonalizado]=useState(false);   // solo modo empleado
  // VOLVER A ENCENDERLO: el formulario se prellena con el último personalizado que
  // tuvo valores, del historial (ultimoPersonalizadoDelHistorial), y lo dice.
  // Solo prellena: no se guarda nada hasta que el patrón toque Guardar.
  const [avisoPrellenado,setAvisoPrellenado]=useState("");
  const vueltaInterruptorRef = useRef(0);
  const [guardando,setGuardando]=useState(false);
  const [msg,setMsg]=useState<{tipo:"ok"|"err"; t:string}|null>(null);
  // Ubicación del centro de trabajo (solo modo general): lat/lng/radio.
  const [ubiLat,setUbiLat]=useState<number|null>(null);
  const [ubiLng,setUbiLng]=useState<number|null>(null);
  const [ubiRadio,setUbiRadio]=useState("200");
  const [ubiCargandoGps,setUbiCargandoGps]=useState(false);
  const [ubiMsg,setUbiMsg]=useState("");
  // La foto del panel que lo contiene (ver retomarFotoDelPanel): se vuelve a
  // tomar cuando el horario termina de cargar y después de cada guardado bueno.
  const raizRef = useRef<any>(null);
  const [fotoPendiente, setFotoPendiente] = useState(0);
  useEffect(()=>{ if (fotoPendiente) retomarFotoDelPanel(raizRef.current); }, [fotoPendiente]);

  const aplicar = (h:any)=>{ setEntrada(h?.entrada||""); setSalida(h?.salida||""); setUsaComida(!!h?.usaComida); setComidaIni(h?.comidaInicio||""); setComidaFin(h?.comidaFin||""); { const tf = toleranciaDelFormulario(h); setTolerancia(tf.valor); setToleranciaSinConfigurar(tf.sinConfigurar); } setUmbralFalta(String(h?.umbralFaltaMin ?? 30)); setDiasLab(diasLaborablesDe(h)); };
  useEffect(()=>{ let cancel=false; (async()=>{
    try {
      if (modo==="general") {
        if (!currentUser?.uid) return;
        // DE LA FUENTE, no de usuarios/{uid}. Este formulario leía el sitio viejo
        // directamente: en cuanto la fuente y el respaldo dejaran de coincidir,
        // enseñaría un horario que ya no rige y lo volvería a guardar como si
        // fuera el vigente.
        const data:any = (await leerConfigEmpresa(currentUser.uid)) || {};
        if (cancel) return;
        aplicar(data?.horarioLaboral || null);
        const ut = data?.ubicacionTrabajo;
        if (ut && typeof ut.lat==="number" && typeof ut.lng==="number") { setUbiLat(ut.lat); setUbiLng(ut.lng); setUbiRadio(String(ut.radioMetros ?? 200)); }
      } else {
        // En modo empleado también se lee el general: es de donde el horario
        // personalizado hereda los días laborables cuando no trae los suyos, y es
        // lo que permite decir en pantalla cuál de los dos está rigiendo.
        let gen:any = null;
        try { if (currentUser?.uid) gen = await leerHorarioGeneral(currentUser.uid); } catch {}
        if (cancel) return;
        setDiasGenerales(diasLaborablesDe(gen));
        const hp = trabajador?.horarioPropio;
        setPersonalizado(!!hp?.activo);
        aplicar(hp?.activo ? hp : null);
      }
      if (!cancel) setFotoPendiente(n=>n+1);
    } catch(e){ console.error("horario load:", e); }
  })(); return ()=>{cancel=true;}; /* eslint-disable-next-line */ }, [modo, currentUser?.uid, trabajador?.id]);

  const alternarPersonalizado = async ()=>{
    const encender = !personalizado;
    const vuelta = ++vueltaInterruptorRef.current;
    setPersonalizado(encender);
    setAvisoPrellenado("");
    // Solo si se enciende con el formulario vacío: lo que ya se escribió no se pisa.
    if (!encender || entrada || salida) return;
    // El historial de la ficha, leído ahora (el de la pantalla puede ir atrasado).
    let hist:any = trabajador?.historialHorarioPropio || null;
    try { if (trabajador?.id) { const s = await getDoc(doc(db,"trabajadores",trabajador.id)); if (s.exists()) hist = (s.data() as any)?.historialHorarioPropio || hist; } } catch {}
    if (vuelta !== vueltaInterruptorRef.current) return;   // se volvió a tocar mientras tanto
    const u = ultimoPersonalizadoDelHistorial(hist);
    if (!u) return;
    aplicar(u.horario);
    setAvisoPrellenado(textoPrellenadoPersonalizado(u.vigenteHasta));
  };

  const usarMiUbicacion = ()=>{
    setUbiMsg("");
    if (!navigator.geolocation) { setUbiMsg("Tu dispositivo no permite ubicación."); return; }
    setUbiCargandoGps(true);
    navigator.geolocation.getCurrentPosition(
      (p)=>{ setUbiLat(p.coords.latitude); setUbiLng(p.coords.longitude); setUbiCargandoGps(false); setUbiMsg("Ubicación actual tomada. Recuerda Guardar."); },
      ()=>{ setUbiCargandoGps(false); setUbiMsg("No se pudo obtener el GPS. Intenta de nuevo."); },
      {enableHighAccuracy:true, timeout:10000, maximumAge:60000}
    );
  };

  const guardar = async ()=>{
    setMsg(null);
    if ((modo==="general" || personalizado) && (!entrada || !salida)) { setMsg({tipo:"err", t:"Define hora de entrada y salida."}); return; }
    if ((modo==="general" || personalizado) && usaComida && (!comidaIni || !comidaFin)) { setMsg({tipo:"err", t:"Define la hora de salida y regreso de comida, o desactívala."}); return; }
    // AL MENOS UN DÍA, en el general y en el propio. Sin días no se puede decir qué
    // días eran laborables; y lo que enseña el formulario es lo que se guarda.
    if ((modo==="general" || personalizado) && !(diasLab && diasLab.length)) { setMsg({tipo:"err", t:"Selecciona al menos un día laborable."}); return; }
    setGuardando(true);
    const h:any = { entrada, salida, usaComida, comidaInicio: usaComida?comidaIni:"", comidaFin: usaComida?comidaFin:"", toleranciaMin: Math.max(0, parseInt(tolerancia,10)||0), umbralFaltaMin: umbralFaltaDe({umbralFaltaMin: parseInt(umbralFalta,10)}), actualizadoEn: serverTimestamp() };
    // LOS DÍAS QUE SE VEN SON LOS QUE SE GUARDAN. Arriba se exige al menos uno.
    // Antes un horario personalizado sin días se guardaba con los del general sin
    // enseñarlos; ahora, si se quieren esos, se copian ("Copiarlos aquí").
    let genEfectivoAlHeredar:any = null;
    let historialPropioNuevo:any = null;
    if (diasLab && diasLab.length) h.diasLaborables = diasLab.slice().sort();
    // Ubicación de la empresa (una para todos). null si el patrón no la fijó.
    const ubi:any = (ubiLat!=null && ubiLng!=null) ? { lat: ubiLat, lng: ubiLng, radioMetros: Math.max(10, parseInt(ubiRadio,10)||200) } : null;
    try {
      if (modo==="general") {
        // LA FUENTE. `configuracion_empresa/{uid}` la leen el patrón Y sus
        // trabajadores, que es lo que hace innecesaria la copia. El horario se
        // REEMPLAZA entero (lo que se ve es lo que queda) y va CON SU ENTRADA DE
        // HISTORIAL en el mismo guardado (guardarHorarioConHistorial). Si el
        // documento aún no existe, el horario de antes es el del respaldo: el que
        // este formulario enseñaba.
        let anteriorGeneral:any = null;
        try { const c0:any = await leerConfigEmpresa(currentUser.uid); if (c0?._deRespaldo) anteriorGeneral = c0.horarioLaboral || null; } catch {}
        await guardarHorarioConHistorial({
          ref: doc(db,COL_CONFIG_EMPRESA,currentUser.uid), campoHorario:"horarioLaboral", campoHistorial:"historialHorario",
          horario: h, correo: currentUser.email, anteriorSiNoHay: anteriorGeneral,
          extra: { ...(ubi ? { ubicacionTrabajo: ubi } : {}), actualizadoEn: serverTimestamp() },
        });
        avisarCambioDeHorarioGeneral();
        // Y de momento TAMBIÉN en el sitio viejo, para que nada se quede atrás
        // mientras la migración no haya corrido. Se retira después de migrar.
        try { await updateDoc(doc(db,"usuarios",currentUser.uid), { horarioLaboral: h, ...(ubi ? { ubicacionTrabajo: ubi } : {}) }); }
        catch(eV){ console.warn("horario en el sitio viejo:", eV); }
        // AQUÍ VIVÍA LA PROPAGACIÓN, y ya no. Copiaba el horario general a la ficha
        // de cada trabajador —campo `horarioEfectivo`— en el momento de guardarlo.
        // Por eso quien se daba de alta DESPUÉS nunca lo recibía: para el checador
        // no tenía horario, no salía en "no han checado hoy" aunque faltara, y su
        // propia ficha le pedía configurar el horario que el interruptor de al lado
        // decía que heredaba. Un valor derivado se deriva; no se copia.
        //
        // El centro de trabajo se guarda en configuracion_empresa, arriba, que es de
        // donde lo lee el portal del trabajador.
      } else {
        if (!trabajador?.id) { setMsg({tipo:"err", t:"No se pudo identificar al empleado."}); setGuardando(false); return; }
        // CON SU ENTRADA DE HISTORIAL, en el mismo guardado (guardarHorarioConHistorial).
        const fichaRef = doc(db,"trabajadores",trabajador.id);
        const propioConHistorial = (horarioPropio:any) => guardarHorarioConHistorial({
          ref: fichaRef, campoHorario:"horarioPropio", campoHistorial:"historialHorarioPropio",
          horario: horarioPropio, correo: currentUser.email,
        });
        if (personalizado) {
          // Su propio horario ES el efectivo.
          historialPropioNuevo = await propioConHistorial({...h, activo:true});
        } else {
          // Hereda el general: efectivo = general (si existe). No pisa con vacío.
          let gen:any = null;
          try { gen = await leerHorarioGeneral(currentUser.uid); } catch {}
          const upd:any = { horarioPropio: {activo:false, actualizadoEn:serverTimestamp()} };
          // Se recuerda cuál es el general SOLO para poder decirlo en pantalla al
          // terminar. No se escribe en la ficha: ahí estaba la copia.
          if (gen) { genEfectivoAlHeredar = gen; }
          historialPropioNuevo = await propioConHistorial(upd.horarioPropio);
        }
      }
      if (onGuardado) { try { onGuardado(modo==="general" ? h : (personalizado ? h : (genEfectivoAlHeredar || h)),
        modo==="empleado" ? (personalizado ? {...h, activo:true} : {activo:false}) : undefined,
        modo==="empleado" ? historialPropioNuevo : undefined); } catch {} }
      setMsg({tipo:"ok", t: modo==="general" ? "Horario general guardado y aplicado al equipo." : (personalizado ? "Horario personalizado guardado." : "Este empleado hereda el horario general.")});
      setAvisoPrellenado("");
      setFotoPendiente(n=>n+1);
    } catch(e:any){ console.error("horario save:", e); setMsg({tipo:"err", t: mensajeDeFallo(e, {accion:"guardar el horario", denegado: denegadoPatron("guardar este horario")})}); }
    finally { setGuardando(false); }
  };

  const lbl = {display:"block", fontSize:11, fontWeight:700, color:T.inkSoft, marginBottom:4} as const;
  const inp:any = {width:"100%", boxSizing:"border-box" as const, padding:"9px 11px", borderRadius:9, border:`1px solid ${T.line}`, background:T.inputBg, color:T.ink, fontSize:14, fontFamily:fontSans, outline:"none", ...(T.dark?{colorScheme:"dark"}:{})};
  const toggle = (on:boolean, onClick:()=>void, label:string) => (
    <button type="button" onClick={onClick} style={{display:"flex", alignItems:"center", gap:10, width:"100%", background:"transparent", border:"none", cursor:"pointer", padding:"2px 0", fontFamily:fontSans, marginBottom:10}}>
      <span style={{width:38, height:22, borderRadius:999, background:on?T.gold:"rgba(128,128,128,0.35)", position:"relative" as const, flexShrink:0, transition:"background 0.2s"}}>
        <span style={{position:"absolute" as const, top:2, left:on?18:2, width:18, height:18, borderRadius:"50%", background:"#fff", transition:"left 0.2s"}}/>
      </span>
      <span style={{fontSize:13, fontWeight:700, color:T.ink}}>{label}</span>
    </button>
  );
  const avisoJornada:any = {fontSize:11.5, lineHeight:1.55, color:"#8a6d1a", background:"rgba(184,147,42,0.12)",
    border:"1px solid rgba(184,147,42,0.38)", borderRadius:9, padding:"9px 11px", marginBottom:12};
  const mostrarCampos = modo==="general" || personalizado;

  return (
    <div {...ZONA_DE_CAPTURA} ref={raizRef} style={{background:T.panel, border:`1px solid ${T.line}`, borderRadius:14, padding:"14px 14px", boxShadow:T.sombra}}>
      <div style={{fontFamily:fontSerif, fontSize:16, fontWeight:700, color:T.gold, marginBottom:2}}>{modo==="general"?"Horario y ubicación de trabajo":"Horario personalizado"}</div>
      <div style={{fontSize:11.5, color:T.inkSoft, marginBottom:12, lineHeight:1.4}}>{modo==="general"?"Aplica a todo el equipo por defecto. Cada empleado puede tener excepción.":"Si lo activas, este empleado usa su propio horario; si no, hereda el general."}</div>
      {modo==="empleado" && toggle(personalizado, alternarPersonalizado, "Usar horario personalizado")}
      {modo==="empleado" && personalizado && avisoPrellenado && (
        <div style={{fontSize:11.5, color:T.gold, lineHeight:1.5, marginTop:-4, marginBottom:10}}>{avisoPrellenado}</div>
      )}
      {mostrarCampos && (<>
        <div style={{display:"flex", gap:10, marginBottom:12}}>
          <div style={{flex:1, minWidth:0}}><label style={lbl}>Entrada</label><input type="time" value={entrada} onChange={e=>setEntrada(e.target.value)} style={inp}/></div>
          <div style={{flex:1, minWidth:0}}><label style={lbl}>Salida</label><input type="time" value={salida} onChange={e=>setSalida(e.target.value)} style={inp}/></div>
        </div>
        {toggle(usaComida, ()=>setUsaComida(v=>!v), "Registrar horario de comida")}
        {usaComida && (
          <div style={{display:"flex", gap:10, marginBottom:12}}>
            <div style={{flex:1, minWidth:0}}><label style={lbl}>Sale a comer</label><input type="time" value={comidaIni} onChange={e=>setComidaIni(e.target.value)} style={inp}/></div>
            <div style={{flex:1, minWidth:0}}><label style={lbl}>Regresa</label><input type="time" value={comidaFin} onChange={e=>setComidaFin(e.target.value)} style={inp}/></div>
          </div>
        )}
        <div style={{display:"flex", gap:10, marginBottom:6}}>
          <div style={{flex:1, minWidth:0}}><label style={lbl}>Tolerancia (min)</label><input type="number" min={0} value={tolerancia} onChange={e=>{ setTolerancia(e.target.value); setToleranciaSinConfigurar(false); }} style={inp}/>{toleranciaSinConfigurar && <div style={{fontSize:10.5, color:T.inkMut, marginTop:3}}>Sin tolerancia configurada</div>}</div>
          <div style={{flex:1, minWidth:0}}><label style={lbl}>Umbral de entrada tardía (min)</label><input type="number" min={0} value={umbralFalta} onChange={e=>setUmbralFalta(e.target.value)} style={inp}/></div>
        </div>
        {/* DÍAS LABORABLES. Es el dato del que dependen todas las afirmaciones
            sobre asistencia: sin él, la plataforma no puede decir que alguien
            faltó a un día, porque no sabe si ese día se trabajaba.
            Se PROPONE lunes a viernes, marcado a la vista, pero no se guarda
            hasta que el patrón toque Guardar: una jornada que nadie confirmó no
            debe convertirse en la base de un documento firmado. */}
        <div style={{marginBottom:12}}>
          <label style={lbl}>Días laborables</label>
          <div style={{display:"flex", gap:6, flexWrap:"wrap" as const, marginTop:2}}>
            {["D","L","M","M","J","V","S"].map((ini, idx)=>{
              const nombres = ["domingo","lunes","martes","miércoles","jueves","viernes","sábado"];
              const on = !!diasLab && diasLab.indexOf(idx) >= 0;
              return (
                <button key={idx} type="button" title={nombres[idx]}
                  onClick={()=>setDiasLab(prev=>{
                    const base = prev || [];
                    return base.indexOf(idx)>=0 ? base.filter(x=>x!==idx) : base.concat([idx]).sort();
                  })}
                  style={{width:38, height:38, borderRadius:10, cursor:"pointer", fontFamily:fontSans, fontSize:13, fontWeight:800,
                    border:`1px solid ${on?T.gold:T.line}`, background:on?T.gold:"transparent", color:on?"#0B1829":T.inkSoft}}>{ini}</button>
              );
            })}
          </div>
          {(()=>{
            // A quién afecta lo que se está editando: el modal general rige a TODO
            // el equipo; el personalizado, solo a esta persona.
            const aQuien = modo==="general" ? "del equipo" : "de este empleado";
            const losReportes = modo==="general" ? "los reportes del equipo" : "los reportes de este empleado";
            // Un horario personalizado sin días propios usa los del general: se
            // dice cuál rige, para que nadie crea que hay un hueco donde no lo hay.
            const hereda = modo!=="general" && personalizado && (!diasLab || !diasLab.length) && !!diasGenerales;
            if (hereda) return (
              <div style={{fontSize:11, color:"#E2B84A", lineHeight:1.5, marginTop:6}}>
                Selecciona al menos un día laborable. Si son los mismos del horario general
                {" "}({(diasGenerales||[]).length} a la semana), cópialos:
                {" "}<button type="button" onClick={()=>setDiasLab((diasGenerales||[]).slice())}
                  style={{background:"none", border:"none", padding:0, color:T.gold, cursor:"pointer", fontFamily:fontSans, fontSize:11, fontWeight:700, textDecoration:"underline"}}>
                  Copiarlos aquí para editarlos
                </button>
              </div>
            );
            if (diasLab===null) return (
              <div style={{fontSize:11, color:T.inkMut, lineHeight:1.5, marginTop:6}}>
                Todavía sin configurar. Mientras no se guarde, {losReportes} no pueden decir qué días eran
                {" "}laborables y no cuentan días sin registro.
                {" "}<button type="button" onClick={()=>setDiasLab([1,2,3,4,5])}
                  style={{background:"none", border:"none", padding:0, color:T.gold, cursor:"pointer", fontFamily:fontSans, fontSize:11, fontWeight:700, textDecoration:"underline"}}>
                  Proponer lunes a viernes
                </button>
              </div>
            );
            if (diasLab.length===0) return (
              <div style={{fontSize:11, color:"#E2B84A", lineHeight:1.5, marginTop:6}}>
                Selecciona al menos un día laborable.
              </div>
            );
            return (
              <div style={{fontSize:11, color:T.inkMut, lineHeight:1.5, marginTop:6}}>
                {diasLab.length===1 ? "1 día laborable" : `${diasLab.length} días laborables`} a la semana {aQuien}.
                {" "}Los demás no cuentan como días sin registro.
                {modo!=="general" && personalizado ? " Estos días sustituyen a los del horario general." : ""}
              </div>
            );
          })()}
        </div>
        {/* AVISO DE JORNADA. No bloquea: hay negocios con turnos largos y no
            somos quién para impedir que se capture lo que de verdad pasa. Pero una
            salida anterior a la entrada casi siempre es un a.m./p.m. mal elegido, y
            contra ese horario se clasifica cada checada del equipo. Que se vea
            antes de guardar, no después de un mes de retardos mal contados. */}
        {(()=>{
          const min = (s:string) => { const q = String(s||"").split(":"); const h = parseInt(q[0],10), m2 = parseInt(q[1],10);
            return (isNaN(h)||isNaN(m2)) ? null : h*60+m2; };
          const e = min(entrada), s = min(salida);
          if (e===null || s===null) return null;
          if (s === e) return (
            <div style={avisoJornada}>La entrada y la salida son la misma hora. Revisa que sea lo que quieres guardar.</div>
          );
          if (s < e) return (
            <div style={avisoJornada}>
              La salida ({salida}) es <b>anterior</b> a la entrada ({entrada}). Si es un turno que cruza la medianoche,
              {" "}ten en cuenta que la plataforma todavía no lo contempla: la hora de salida no interviene en el cálculo
              {" "}y cada checada se clasifica contra la hora de entrada del mismo día. Si te equivocaste de a.m./p.m.,
              {" "}corrígelo antes de guardar.
            </div>
          );
          const horas = (s - e) / 60;
          if (horas > 12) return (
            <div style={avisoJornada}>
              La jornada capturada es de <b>{horas.toFixed(1).replace(".0","")} horas</b> ({entrada} a {salida}).
              {" "}Revisa que sea correcto: contra este horario se clasifica cada checada del equipo.
            </div>
          );
          return null;
        })()}
        <div style={{fontSize:11, color:T.inkMut, lineHeight:1.5, marginBottom:12}}>Hasta la tolerancia = a tiempo · después = retardo · pasados otros {umbralFalta||"30"} min = entrada tardía.</div>
      </>)}

      {/* Ubicación del centro de trabajo (empresa) — solo se registra, no bloquea */}
      {modo==="general" && (
        <div style={{marginTop:6, paddingTop:14, borderTop:`1px solid ${T.line}`}}>
          <div style={{fontFamily:fontSerif, fontSize:14, fontWeight:700, color:T.gold, marginBottom:2}}>Ubicación del centro de trabajo</div>
          <div style={{fontSize:11.5, color:T.inkSoft, marginBottom:10, lineHeight:1.4}}>Al checar se registra si el trabajador está dentro del radio. Nunca bloquea el registro (el GPS falla en interiores).</div>
          <button type="button" onClick={usarMiUbicacion} disabled={ubiCargandoGps}
            style={{display:"inline-flex", alignItems:"center", gap:8, padding:"9px 13px", borderRadius:10, border:`1px solid ${T.line}`, background:T.inputBg, color:T.gold, cursor:ubiCargandoGps?"wait":"pointer", fontFamily:fontSans, fontSize:13, fontWeight:700}}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><path d="M12 21s7-6.3 7-11a7 7 0 10-14 0c0 4.7 7 11 7 11z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round"/><circle cx="12" cy="10" r="2.4" stroke="currentColor" strokeWidth="1.7"/></svg>
            {ubiCargandoGps ? "Obteniendo…" : "Usar mi ubicación actual"}
          </button>
          <div style={{fontSize:12, color:(ubiLat!=null&&ubiLng!=null)?T.inkSoft:T.inkMut, marginTop:8}}>
            {(ubiLat!=null && ubiLng!=null) ? `Fijada: ${ubiLat.toFixed(5)}, ${ubiLng.toFixed(5)}` : "Sin ubicación fijada (el checador funciona igual)."}
          </div>
          <div style={{marginTop:10}}>
            <label style={lbl}>Radio permitido (metros)</label>
            <div style={{display:"flex", gap:8, alignItems:"center", flexWrap:"wrap" as const}}>
              <input type="number" min={10} value={ubiRadio} onChange={e=>setUbiRadio(e.target.value)} style={{...inp, maxWidth:120}}/>
              {[100,200,500].map(r=>(
                <button key={r} type="button" onClick={()=>setUbiRadio(String(r))}
                  style={{padding:"7px 12px", borderRadius:999, border:`1px solid ${ubiRadio===String(r)?T.gold:T.line}`, background:ubiRadio===String(r)?`rgba(184,147,42,0.14)`:"transparent", color:ubiRadio===String(r)?T.gold:T.inkSoft, cursor:"pointer", fontFamily:fontSans, fontSize:12, fontWeight:700}}>{r} m</button>
              ))}
            </div>
          </div>
          {ubiMsg && <div style={{fontSize:12, color:T.inkSoft, marginTop:8}}>{ubiMsg}</div>}
        </div>
      )}
      {modo==="empleado" && !personalizado && (
        <div style={{fontSize:12, color:T.inkMut, marginBottom:12}}>Este empleado hereda el horario general.</div>
      )}
      <button onClick={guardar} disabled={guardando}
        style={{width:"100%", padding:"11px 14px", borderRadius:10, border:"none", cursor:guardando?"wait":"pointer", fontFamily:fontSans, fontSize:13.5, fontWeight:800, background:T.gold, color:"#0B1829"}}>
        {guardando ? "Guardando…" : (modo==="general" ? "Guardar configuración" : "Guardar horario")}
      </button>
      {msg && <div style={{marginTop:10, fontSize:12.5, fontWeight:700, color:msg.tipo==="ok"?"#34D399":"#DC2626"}}>{msg.t}</div>}
    </div>
  );
}

// ── DOCUMENTOS DEL EXPEDIENTE (móvil patrón) — misma subida/registro que escritorio ──
// Reutiliza SubirArchivoBtn (con Tomar foto/escanear + Elegir archivo) y registra igual
// que el escritorio: updateDoc trabajadores/{id}.documentos (array). Sin reglas nuevas
// (el patrón ya es dueño de la ficha). Storage: empleados/{patrónUid}/… como siempre.
function DocumentosEmpleadoBox({empleado, currentUser, tema, fontSans}:{empleado:any; currentUser:any; tema:"navy"|"light"; fontSans:string}) {
  const [docs, setDocs] = useState<any[]>(empleado?.documentos||[]);
  const [borrando, setBorrando] = useState<number|null>(null);
  const [err, setErr] = useState("");
  useEffect(()=>{ setDocs(empleado?.documentos||[]); /* eslint-disable-next-line */ }, [empleado?.id]);
  const T = tema==="navy"
    ? {gold:"#D4A843", line:"rgba(184,147,42,0.30)", ink:"#ECE6D8", inkSoft:"rgba(236,230,216,0.62)", panel:"rgba(255,255,255,0.04)", danger:"#FCA5A5"}
    : {gold:T_LIGHT.gold, line:T_LIGHT.border, ink:T_LIGHT.textInk, inkSoft:T_LIGHT.textInkSoft, panel:T_LIGHT.canvasSoft, danger:"#DC2626"};
  // La tanda entera, en UNA escritura. Ver la nota del botón: recibir de uno en
  // uno y acumular sobre el `docs` del cierre pierde todos menos el último.
  const onSubido = async (archivos:{url:string; nombre:string}[]) => {
    setErr("");
    const hoy = new Date().toISOString().slice(0,10);
    const nuevos = [...docs, ...archivos.map((a)=>({nombre:a.nombre, url:a.url, fecha:hoy}))];
    try { await updateDoc(doc(db,"trabajadores",empleado.id), {documentos:nuevos}); setDocs(nuevos); }
    catch(e:any){ console.error("doc empleado móvil:", e); setErr("No se pudo registrar el documento."); throw e; }
  };
  const eliminar = async (idx:number) => {
    setBorrando(idx); setErr("");
    try {
      await eliminarArchivo(docs[idx].url);
      const nuevos = docs.filter((_:any,i:number)=>i!==idx);
      await updateDoc(doc(db,"trabajadores",empleado.id), {documentos:nuevos});
      setDocs(nuevos);
    } catch(e:any){ console.error("elim doc empleado móvil:", e); setErr("No se pudo eliminar."); }
    finally { setBorrando(null); }
  };
  return (
    <div>
      <SubirArchivoBtn userId={currentUser.uid} carpeta="empleados" label="Subir documento" accept=".pdf,.jpg,.jpeg,.png,.doc,.docx" onLote={onSubido} />
      <div style={{marginTop:10, display:"flex", flexDirection:"column" as const, gap:7}}>
        {docs.length===0 && <div style={{fontSize:12, color:T.inkSoft, fontStyle:"italic" as const}}>Aún no hay documentos.</div>}
        {docs.map((d:any,i:number)=>(
          <div key={i} style={{display:"flex", alignItems:"center", gap:10, background:T.panel, border:`1px solid ${T.line}`, borderRadius:9, padding:"8px 12px"}}>
            <a href={d.url} target="_blank" rel="noopener noreferrer" style={{flex:1, minWidth:0, color:T.gold, fontSize:13, fontWeight:600, textDecoration:"none", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" as const}}>{d.nombre}</a>
            <button onClick={()=>eliminar(i)} disabled={borrando===i}
              style={{background:"transparent", border:"none", color:T.danger, cursor:borrando===i?"wait":"pointer", fontSize:12, fontWeight:700, fontFamily:fontSans, flexShrink:0}}>
              {borrando===i ? "…" : "Eliminar"}
            </button>
          </div>
        ))}
      </div>
      {err && <div style={{fontSize:11.5, color:T.danger, marginTop:6}}>{err}</div>}
    </div>
  );
}

// ── LO QUE "MIS REPORTES" LE DICE AL TRABAJADOR ─────────────────────────────
// Decía que el reporte "deberá ser firmado" en 3 días hábiles y que las
// incidencias "pueden ser consideradas para efectos de actas administrativas":
// consecuencias que fija la política interna de cada empresa, no la plataforma.
const TEXTO_REVISION_REPORTE = "Revisa este registro. Si no estás de acuerdo con alguna marca, házselo saber por escrito a tu patrón.";
function mensajeReporteAsistencia(tipo:string, periodo:string): string {
  return `Reporte de asistencia ${tipo === "quincenal" ? "de la quincena" : "del mes"} ${periodo}. ${TEXTO_REVISION_REPORTE}`;
}
// LOS YA ENVIADOS SE ENSEÑAN TAL COMO SE ENVIARON: es lo que el trabajador
// recibió, y la plataforma no lo reescribe. Si traen la leyenda vieja (firma
// obligatoria / actas administrativas), "Mis reportes" añade debajo una nota
// aparte diciendo que la plataforma ya no la usa. Solo los de asistencia: un acta
// o una constancia no llevan esa leyenda.
const NOTA_LEYENDA_VIEJA = "Este reporte se envió con una leyenda que la plataforma ya no usa.";
function reporteConLeyendaVieja(r:any): boolean {
  return (r?.tipo === "quincenal" || r?.tipo === "mensual") && /actas administrativas|Deberá ser firmado/.test(String(r?.mensaje || ""));
}

// ── ENVÍO DE REPORTE AL TRABAJADOR — sube el PDF a Storage + registra en 'reportes' ──
// Reutiliza subirArchivo (mismo bucket que fotos de accidentes). Ruta:
// reportes/{empleadorId}/{trabajadorId}/{archivo}. El trabajador lo verá en "Mis
// reportes" (query where trabajadorEmail==su correo) y le encenderá el puntito.
// El mensaje que acompaña al reporte: ver mensajeReporteAsistencia.
async function enviarReporteAlTrabajador(opts:{empleado:any; currentUser:any; tipo:"quincenal"|"mensual"; periodo:string; html:string; fname:string}): Promise<void> {
  const {empleado, currentUser, tipo, periodo, html, fname} = opts;
  const trabajadorId = empleado?.id || "";
  const trabajadorEmail = (empleado?.email||"").toLowerCase().trim();
  if (!trabajadorId || !trabajadorEmail) throw errorParaMostrar("Este empleado no tiene correo vinculado; agrégalo en su ficha para poder enviarle el reporte.");
  const blob = await generarPDFDesdeHTML(html, fname, {save:false});
  const file = new File([blob], fname, {type:"application/pdf"});
  // `subcarpeta` (5.º argumento) en vez de una carpeta compuesta: la ruta que
  // sale es la MISMA de siempre —reportes/{uidPatron}/{trabajadorId}/…—, así que
  // las URLs ya guardadas en Firestore siguen casando. Lo que cambia es que el
  // uid que se pasa es de verdad el de quien sube. Ver la guardia en `subirArchivo`.
  const url = await subirArchivo(currentUser.uid, "reportes", file, undefined, trabajadorId);
  const mensaje = mensajeReporteAsistencia(tipo, periodo);
  await addDoc(collection(db,"reportes"), {
    empleadorId: currentUser.uid,
    trabajadorId,
    trabajadorEmail,
    trabajadorCuentaUid: empleado?.cuentaUid || "",
    trabajadorNombre: empleado?.nombre || trabajadorEmail,
    tipo, periodo,
    urlPDF: url,
    mensaje,
    estado: "enviado",
    fechaEnvio: serverTimestamp(),
    creadoPor: currentUser.uid,
  });
}

// LO QUE SE IMPRIME SE LEE AL IMPRIMIR. La bitácora y el registro mensual
// recibían la ficha y las checadas de cuando se abrió la pantalla: si el horario
// propio cambió después, el papel imprimía el viejo; y una checada registrada
// después (el reingreso de las 09:3x) no salía, ni su renglón de "2 entradas".
// Si alguna lectura falla, se usa lo que llegó, como antes.
// LO QUE CALIFICAN LOS DOS DOCUMENTOS ES LA VISTA EFECTIVA (fase 2b): las checadas
// de esta persona después de las correcciones del patrón (src/logica/correcciones.js),
// la MISMA que enseñan la ficha y la pantalla del trabajador. `checadas` son las
// que cuentan —con su tipo corregido y los registros agregados—; `vista` trae
// además las anuladas, las correcciones y las notas "no conforme".
// SIN CORRECCIONES NO HAY DOCUMENTO: si no se pueden leer, el papel contaría
// registros anulados o callaría los agregados, y se firma. Se dice y no se emite.
async function fichaYChecadasAlDia(empleado:any, checadas:any[], uidPatron:string): Promise<{ficha:any; checadas:any[]; vista:any}> {
  let ficha = empleado; let lista = checadas || [];
  try {
    if (empleado?.id) { const s = await getDoc(doc(db,"trabajadores",empleado.id)); if (s.exists()) ficha = {id:s.id, ...(s.data() as any)}; }
  } catch(e){ console.warn("documento: ficha al día:", e); }
  try {
    const sc = await getDocs(query(collection(db,"checadas"), where("empleadorId","==",uidPatron)));
    lista = sc.docs.map((d:any)=>({id:d.id, ...d.data()}));
  } catch(e){ console.warn("documento: checadas al día:", e); }
  const email = String(empleado?.email||"").toLowerCase().trim();
  const deEsaPersona = (x:any)=> String(x?.trabajadorEmail||"").toLowerCase().trim() === email;
  let correcciones:any[] = [], notas:any[] = [];
  try {
    const [sco, sno] = await Promise.all([
      getDocs(query(collection(db,"correcciones_checadas"), where("empleadorId","==",uidPatron))),
      getDocs(query(collection(db,"no_conformidades"), where("empleadorId","==",uidPatron))),
    ]);
    correcciones = sco.docs.map((d:any)=>({id:d.id, ...d.data()})).filter(deEsaPersona);
    notas = sno.docs.map((d:any)=>({id:d.id, ...d.data()})).filter(deEsaPersona);
  } catch(e){
    console.error("documento: correcciones:", e);
    throw errorParaMostrar("No se pudieron leer las correcciones del checador de este empleado, y sin ellas el documento no se puede emitir. Intenta de nuevo.");
  }
  const vista = vistaEfectiva({checadas: lista.filter(deEsaPersona), correcciones, noConformidades: notas});
  return {ficha, checadas: vista.checadasQueCuentan, vista};
}
// "CORRECCIONES DEL PERIODO", la misma sección en la bitácora y en el registro
// mensual: cada corrección con su fecha y hora, tipo, registro afectado, autor
// (nombre y cargo), motivo, su estado y, si la hay, la nota "no conforme" del
// trabajador. Las filas las arma `correccionesDelPeriodo`; sin correcciones, la
// sección no aparece.
function _tablaCorreccionesHTML(filas:any[], titulo:string, subtitulo:string, clase:string): string {
  if (!filas || !filas.length) return "";
  const td = "padding:5px 6px;border-bottom:1px solid #ddd;vertical-align:top;color:#222;";
  const enc = ["Fecha y hora", "Tipo", "Registro afectado", "Autor", "Motivo", "Estado"];
  return `<div class="${clase}" style="margin-top:16px;font-family:Arial,sans-serif;">`
    + `<div style="font-size:13px;font-weight:700;color:#0F1D35;margin-bottom:4px;">${_escHtml(titulo)}</div>`
    + `<div style="font-size:10.5px;color:#555;margin-bottom:6px;line-height:1.5;">${_escHtml(subtitulo)}</div>`
    + `<table style="width:100%;border-collapse:collapse;font-size:10px;"><thead><tr>${enc.map((h)=>`<th style="background:#0F1D35;color:#fff;text-align:left;padding:6px;font-weight:700;">${h}</th>`).join("")}</tr></thead><tbody>`
    + filas.map((f:any)=> `<tr>${[f.cuando, f.tipo, f.registro, f.autor, f.motivo, f.estado].map((v:any)=>`<td style="${td}">${_escHtml(v)}</td>`).join("")}</tr>`
      + (f.despuesDelCierre ? `<tr><td colspan="6" style="${td}color:#7A5F12;font-weight:700;">${_escHtml(f.despuesDelCierre)}</td></tr>` : "")
      + (f.noConformidad ? `<tr><td colspan="6" style="${td}color:#8a6d1a;background:rgba(184,147,42,0.07);">${_escHtml(f.noConformidad)}</td></tr>` : "")).join("")
    + `</tbody></table></div>`;
}
function seccionCorreccionesHTML(filas:any[]): string {
  return _tablaCorreccionesHTML(filas, "Correcciones del periodo", "Anotadas por el patrón en la plataforma, cada una con su autor y su motivo.", "correcciones");
}
// Las hechas en este periodo a registros de periodos anteriores: SOLO SE LISTAN.
// Los conteos y la calificación de este periodo no las tocan.
function seccionCorreccionesAnterioresHTML(filas:any[]): string {
  return _tablaCorreccionesHTML(filas, "Correcciones hechas en este periodo a registros de periodos anteriores",
    "Constan en el documento del periodo de cada registro. Aquí solo se listan: no cambian los conteos ni la calificación de este periodo.", "correcciones-anteriores");
}

// LA UBICACIÓN DE UNA CHECADA, EN PALABRAS. UNA SOLA FUNCIÓN para la bitácora, la
// ficha y la Actividad del móvil. Una checada desde una computadora con ubicación
// por red salía "Fuera (~174371 m)": a 174 km no hay checador; lo que hay es una
// posición que no sirve. Por eso:
//   · si trae precisionMetros y es mayor a 100 m, un "Fuera" pasa a "Ubicación
//     imprecisa (±N m)" (un "Dentro" se queda: el radio lo contiene igual);
//   · si la distancia pasa de 50 km, es "Ubicación imprecisa", traiga o no
//     precisión (las checadas viejas no la traen).
// Todavía no se avisa a nadie de nada: eso va en su rama.
// "±100000 m" no se lee. Menos de 1000 m, en metros; desde 1000, en kilómetros
// sin decimales: "±350 m", "±100 km", "Fuera (~10 km)".
function distanciaLegible(m:number): string {
  const v = Math.abs(Number(m) || 0);
  return v < 1000 ? `${Math.round(v)} m` : `${Math.round(v / 1000)} km`;
}
const PRECISION_MAXIMA_M = 100;
const DISTANCIA_ABSURDA_M = 50000;
function lecturaUbicacionChecada(c:any, larga?:boolean): {estado:"dentro"|"fuera"|"imprecisa"|"sin_ubicacion"|"sin_zona"|"sin_dato"; texto:string} {
  if (!c) return {estado:"sin_dato", texto:"—"};
  const prec = (typeof c.precisionMetros === "number" && isFinite(c.precisionMetros)) ? c.precisionMetros : null;
  const dist = (typeof c.distanciaMetros === "number" && isFinite(c.distanciaMetros)) ? c.distanciaMetros : null;
  if (c.dentroDeUbicacion === true || c.dentroDeUbicacion === false) {
    const imprecisa = (c.dentroDeUbicacion === false && prec != null && prec > PRECISION_MAXIMA_M) || (dist != null && dist > DISTANCIA_ABSURDA_M);
    if (imprecisa) return {estado:"imprecisa", texto: prec != null ? `Ubicación imprecisa (±${distanciaLegible(prec)})` : "Ubicación imprecisa"};
    // CON SU SEDE (11-oct-2026): la checada trae la sede contra la que se midió
    // (`sedeAplicada`, testigo escrito al checar) y se nombra. Una checada vieja sin
    // testigo se muestra como consta, sin reinterpretarla con la sede de hoy.
    const sede = c.sedeAplicada && String(c.sedeAplicada.nombre || "").trim();
    if (sede) {
      if (c.dentroDeUbicacion === true) return {estado:"dentro", texto: `Dentro de ${sede}`};
      return {estado:"fuera", texto: `Fuera de ${sede}` + (dist != null ? ` (~${distanciaLegible(dist)})` : "")};
    }
    if (c.dentroDeUbicacion === true) return {estado:"dentro", texto: larga ? "Dentro de la zona" : "Dentro"};
    return {estado:"fuera", texto: (larga ? "Fuera de la zona" : "Fuera") + (dist != null ? ` (~${distanciaLegible(dist)})` : "")};
  }
  if (c.ubicacionDisponible === false) return {estado:"sin_ubicacion", texto:"Sin ubicación"};
  if (c.lat != null && c.lng != null) return {estado:"sin_zona", texto:"Registrada, sin zona de trabajo"};
  return {estado:"sin_dato", texto:"—"};
}

// ── LO QUE LA ENTRADA DICE DE SÍ MISMA, EN EL PAPEL ─────────────────────────
// Desde el 3-sep la fila se armaba con "—" fijo en Ubicación y en Biometría, y la
// bitácora que se firma callaba lo que sí constaba en la checada. Ahora la
// checada de entrada del día llega a la fila (`entradaChecada`, de
// recorrerDiasChecador) y se imprime lo que dice.
function ubicacionEnBitacora(c:any): string {
  return lecturaUbicacionChecada(c).texto;
}
// "Sí", "No: <motivo>", o "—" si la checada es de antes de que existiera el dato.
function verificacionEnBitacora(c:any): string {
  if (!c || c.verificacionBiometrica === undefined || c.verificacionBiometrica === null) return "—";
  if (c.verificacionBiometrica === true) return "Sí";
  return "No: " + motivoSinVerificacion(c);
}
function filaDeBitacora(d:any, vista?:any): any {
  const fmtT = (x:Date|null) => x ? x.toLocaleTimeString("es-MX",{hour:"2-digit",minute:"2-digit"}) : "—";
  // LAS CORRECCIONES DEL DÍA, EN BREVE (la sección "Correcciones del periodo" las
  // detalla). Una entrada agregada por el patrón no tiene ubicación ni verificación
  // en el aparato: se dice que es agregada, nunca un "—" que parezca dato.
  const agregada = !!d.entradaChecada?.agregadoPorPatron;
  // Solo con una vista de verdad: `dias.map(filaDeBitacora)` le pasa el índice.
  const marca = vista && vista.registros ? marcaBreveDelDia(registrosDelDia(vista, d.iso)) : "";
  return {
    fecha: d.fecha.toLocaleDateString("es-MX",{weekday:"short",day:"2-digit",month:"short"}),
    // Antes del ingreso y después de la baja, en gris como el día no laboral, con
    // su propio texto.
    laboral: d.est.estado !== "no_laborable" && d.est.estado !== "antes_ingreso" && d.est.estado !== "despues_baja",
    textoNoLaboral: d.est.estado === "no_laborable" ? "Día no laboral" : etiquetaDiaChecador(d.est),
    entrada: fmtT(d.est.hora || null),
    salida: fmtT(d.salida),
    estatus: etiquetaDiaChecador(d.est),
    estKey: d.est.estado === "con_registro" ? (d.est.clasif || "sin_horario") : d.est.estado,
    // LA MARCA VA EN EL PAPEL. La bitácora es la que imprime la columna Salida
    // y es donde alguien firma; decir en pantalla que se descartó una marca y
    // callarlo en el documento sería peor que no decirlo en ninguna parte.
    nota: [d.nota || "", d.notaRelacion || "", marca].filter(Boolean).join(" · "),
    ubi: agregada ? "Agregada por el patrón" : ubicacionEnBitacora(d.entradaChecada),
    bio: agregada ? "No aplica" : verificacionEnBitacora(d.entradaChecada),
  };
}
// El aviso de los días con marcas repetidas. Ya no dice que "ningún registro se
// borra": hoy el patrón sí puede borrar una checada, y el papel no puede afirmar
// lo contrario. Volverá cuando las checadas sean inalterables.
function avisoRepeticionesBitacora(n:number): string {
  return `En ${n} día${n!==1?"s":""} de este periodo quedó registrada más de una entrada o más de una salida. La bitácora muestra la entrada más temprana y la salida más tardía de cada día, y señala en el renglón correspondiente cuántas marcas hubo.`;
}

// ── BITÁCORA QUINCENAL DE CHECADOR (PDF) — reutiliza generarPDFDesdeHTML existente ──
// Quincenas: [1..15] y [16..fin de mes]. Días laborales = L–V (mismo criterio que 2B).
function quincenaDe(ref:Date){ const y=ref.getFullYear(), m=ref.getMonth(), day=ref.getDate();
  if (day<=15) return {ini:new Date(y,m,1), fin:new Date(y,m,15)};
  const finMes=new Date(y,m+1,0).getDate();
  return {ini:new Date(y,m,16), fin:new Date(y,m,finMes)};
}
function quincenaAnterior(ref:Date){ const q=quincenaDe(ref); const antes=new Date(q.ini); antes.setDate(antes.getDate()-1); return quincenaDe(antes); }
function _escHtml(s:any){ return String(s==null?"":s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;"); }
// ═══ ¿HAY ASISTENCIA QUE REPORTAR EN ESTE PERIODO? ═══════════════════════════
// UNA función, y los DOS documentos que se firman la usan: la bitácora quincenal
// y el registro mensual. Antes cada uno decidía por su cuenta —el mensual
// preguntaba por la bandera `tieneAcceso` de la ficha, el quincenal solo por si
// había correo—. Dos documentos que se firman no pueden decidir el mismo hecho
// con dos criterios distintos.
//
// Y NINGUNO DE LOS DOS PREGUNTA POR LA CUENTA. Un documento firmado describe un
// PASADO. Si la cuenta se suspendió o se borró la semana pasada, eso no cambia
// que en junio esta persona checó todos los días: preguntarle al presente por lo
// que era verdad entonces borraría del documento asistencia que sí ocurrió, y un
// documento firmado que omite asistencia real es peor que uno que no la calcula.
// Ningún campo de hoy sabe qué era verdad en junio. El hecho, sí: ¿quedaron
// checadas suyas dentro del periodo?
function hayAsistenciaEnPeriodo(o:{checadas:any[]; email:string; desde:Date; hasta:Date}): boolean {
  const correo = String(o.email||"").toLowerCase().trim();
  if (!correo) return false;
  // El periodo se toma por DÍAS COMPLETOS: una checada de las 07:15 del primer
  // día cuenta, y una de las 23:40 del último también.
  const d0 = new Date(o.desde.getFullYear(), o.desde.getMonth(), o.desde.getDate(), 0,0,0,0).getTime();
  const d1 = new Date(o.hasta.getFullYear(), o.hasta.getMonth(), o.hasta.getDate(), 23,59,59,999).getTime();
  // Mismo orden de campos que recorrerDiasChecador: la hora del servidor manda
  // sobre la del teléfono.
  return (o.checadas||[]).some((c:any)=>{
    if (String(c?.trabajadorEmail||"").toLowerCase().trim() !== correo) return false;
    const d = c?.horaServidor?.toDate?.() || c?.timestamp?.toDate?.() || null;
    if (!d) return false;
    const ms = d.getTime();
    return ms >= d0 && ms <= d1;
  });
}

// ═══ CHECADAS INALTERABLES: LA FECHA DE CORTE ════════════════════════════════
// `plataforma/checadas_inalterables` lo crea UNA vez el admin (ver AdminPanel),
// con la hora del servidor, y nadie lo cambia ni lo borra (firestore.rules).
// Desde esa fecha, la bitácora y el registro mensual lo dicen. Si no se puede
// leer, el papel no lo afirma: no se imprime nada.
const RUTA_CORTE_CHECADAS = {coleccion:"plataforma", id:"checadas_inalterables"};
async function leerFechaDeCorteChecadas(): Promise<Date|null> {
  try {
    const d = await getDoc(doc(db, RUTA_CORTE_CHECADAS.coleccion, RUTA_CORTE_CHECADAS.id));
    return d.exists() ? ((d.data() as any)?.desde?.toDate?.() || null) : null;
  } catch(e){ console.warn("fecha de corte de checadas:", e); return null; }
}
// ═══ LA SEDE Y LA RAZÓN SOCIAL EN LOS DOCUMENTOS (11-oct-2026) ═══════════════
// LOS CATÁLOGOS DE LA EMPRESA: la configuración (la sede y la razón social
// principales) y las subcolecciones `sedes` y `razones_sociales`. Si una lectura
// falla (por ejemplo, antes de publicar las reglas), queda solo la principal: el
// documento sale como siempre.
async function leerCatalogosDeEmpresa(uidPatron:string): Promise<{cfg:any; docsSedes:any[]; docsRazones:any[]; sedes:any[]; razones:any[]}> {
  let cfg:any = null, ds:any[] = [], dr:any[] = [];
  try { cfg = await leerConfigEmpresa(uidPatron); } catch(e){ console.warn("catálogos · configuración:", e); }
  try { const s = await getDocs(collection(db, COL_CONFIG_EMPRESA, uidPatron, "sedes")); ds = s.docs.map((d:any)=>({id:d.id, ...d.data()})); }
  catch(e){ console.warn("catálogos · sedes:", e); }
  try { const s = await getDocs(collection(db, COL_CONFIG_EMPRESA, uidPatron, "razones_sociales")); dr = s.docs.map((d:any)=>({id:d.id, ...d.data()})); }
  catch(e){ console.warn("catálogos · razones sociales:", e); }
  return {cfg, docsSedes: ds, docsRazones: dr, sedes: catalogoDeSedes(cfg, ds), razones: catalogoDeRazones(cfg, dr)};
}
// LA RAZÓN SOCIAL QUE SE IMPRIME, en la forma de los Datos de mi empresa. La
// principal son esos mismos datos (no cambia nada). Otra: la del CATÁLOGO, con lo
// que el catálogo dice HOY de ella —si la denominación se editó después del
// periodo, sale la vigente: no se inventa historial—. Su RFC no cambia nunca
// (las reglas lo dejan fijo al crearla).
function datosPatronDeRazon(rs:any, base:DatosPatron): DatosPatron {
  if (!rs || rs.id === RAZON_PRINCIPAL) return base;
  return {...base, denominacion: rs.denominacion, rfc: rs.rfc, tipoPersona: (rs.tipoPersona === "fisica" || rs.tipoPersona === "moral") ? rs.tipoPersona : "",
    domCalle: rs.domCalle, domColonia: rs.domColonia, domMunicipio: rs.domMunicipio, domEstado: rs.domEstado, domCP: rs.domCP};
}
// ═══ LA RAZÓN SOCIAL DE UN DOCUMENTO LIGADO A UN TRABAJADOR (12-oct-2026) ═════
// Recibo de nómina, finiquito, acta de vacaciones, constancia de aguinaldo: salen
// a nombre de la razón social del trabajador VIGENTE EN LA FECHA DEL DOCUMENTO
// (la del hecho: el fin del periodo pagado, la separación, la toma, el pago),
// según el historial de su ficha. Sin historial, la principal (como hoy). La
// razón social se LEE AL GENERAR, no de una lista cargada antes; y si no se puede
// leer, el documento no se emite: nunca a nombre de otra persona.
function _msDeFechaDocumento(fecha:any): number {
  if (typeof fecha === "number" && isFinite(fecha)) return fecha;
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(fecha || ""));
  if (m) return instanteDeMexico(Number(m[1]), Number(m[2]) - 1, Number(m[3]), 23, 59, 59, 999).getTime();
  return Date.now();
}
async function datosPatronParaDocumento(uidPatron:string, base:DatosPatron, ficha:any, fecha:any): Promise<DatosPatron> {
  const id = valorQueRegia(ficha, "razonSocialId", "historialRazonSocial", _msDeFechaDocumento(fecha));
  if (!ficha || !uidPatron || id === RAZON_PRINCIPAL) return base;
  let d:any = null;
  try { d = await getDoc(doc(db, COL_CONFIG_EMPRESA, uidPatron, "razones_sociales", id)); }
  catch(e){ console.warn("razón social del documento:", e); }
  if (!d || !d.exists()) throw errorParaMostrar("No se pudo leer la razón social de este trabajador, así que el documento no se generó. Intenta de nuevo en un momento.");
  return datosPatronDeRazon(razonSocialDelCatalogo(id, d.data()), base);
}
// La razón social del trabajador EN EL PERIODO: la que regía al cerrarlo, según el
// historial de su ficha (historialRazonSocial). Si cambió dentro del periodo, el
// aviso lo dice (avisosDeSedeYRazon).
function razonSocialDelPeriodo(ficha:any, finMs:number, razones:any[]): any {
  return razonSocialDeId(valorQueRegia(ficha, "razonSocialId", "historialRazonSocial", finMs), razones);
}
function _nombreDeSede(id:string, sedes:any[]): string {
  const s = (sedes||[]).find((x:any)=> x.sedeId === id);
  if (s && String(s.nombre||"").trim()) return s.nombre;
  return id === SEDE_PRINCIPAL ? "la sede principal" : "una sede que ya no está en el catálogo";
}
function _denominacionDeRazon(id:string, razones:any[]): string {
  const r = (razones||[]).find((x:any)=> x.id === id);
  return r && r.denominacion ? r.denominacion : id === RAZON_PRINCIPAL ? "la razón social principal" : "una razón social que ya no está en el catálogo";
}
function _cuandoEnMexico(ms:number): string {
  const mx = enHoraDeMexico(new Date(ms));
  return mx ? `${fechaLargaAxis(mx)} a las ${String(mx.getHours()).padStart(2,"0")}:${String(mx.getMinutes()).padStart(2,"0")}` : "";
}
// SI LA SEDE O LA RAZÓN SOCIAL CAMBIARON DENTRO DEL PERIODO, con fecha y hora (de
// México), igual que el aviso del horario. Las checadas no se reinterpretan: cada
// una se midió contra la sede vigente cuando se registró (su testigo).
function avisosDeSedeYRazon(ficha:any, sedes:any[], razones:any[], iniMs:number, finMs:number): string[] {
  return avisosDeSede(ficha, sedes, iniMs, finMs).concat(avisosDeRazonSocial(ficha, razones, iniMs, finMs));
}
// Solo la SEDE: explica cómo se midieron las checadas, así que va con ellas. Las de la
// RAZÓN SOCIAL explican el encabezado y salen aunque no haya registros (13-oct-2026).
function avisosDeSede(ficha:any, sedes:any[], iniMs:number, finMs:number): string[] {
  const out: string[] = [];
  cambiosEnElPeriodo(ficha, "sedeId", "historialSede", iniMs, finMs).forEach((c:any)=> out.push(
    `La sede de trabajo de este empleado cambió el ${_cuandoEnMexico(c.desdeMs)} (hora de México): de ${_nombreDeSede(c.de, sedes)} a ${_nombreDeSede(c.a, sedes)}. Cada checada se midió contra la sede vigente cuando se registró.`));
  return out;
}
// LAS NOTAS DE LA RAZÓN SOCIAL de un periodo (12-oct-2026): la de la primera razón
// social con efecto desde el inicio, si el periodo empieza antes de que se registrara,
// y la de cada cambio dentro del periodo. Las usan la bitácora y el registro mensual
// (con las de la sede), el reporte individual y el recibo de nómina.
function avisosDeRazonSocial(ficha:any, razones:any[], iniMs:number, finMs:number): string[] {
  const out: string[] = [];
  const n = notaRazonDesdeElInicio(ficha, iniMs, (id)=> _denominacionDeRazon(id, razones));
  if (n) out.push(n);
  cambiosEnElPeriodo(ficha, "razonSocialId", "historialRazonSocial", iniMs, finMs).forEach((c:any)=> out.push(
    `La razón social de este empleado cambió el ${_cuandoEnMexico(c.desdeMs)} (hora de México): de ${_denominacionDeRazon(c.de, razones)} a ${_denominacionDeRazon(c.a, razones)}. El encabezado muestra la vigente al cierre del periodo.`));
  return out;
}
// La nota de la primera razón social con EFECTO DESDE EL INICIO de la relación: va en
// los documentos cuyo periodo (o fecha) empieza antes de que se registrara, que son los
// que esa asignación decide hacia atrás. null si no aplica.
// Nombra la razón social (13-oct-2026): `denominacionDe` da la denominación de su id.
function notaRazonDesdeElInicio(ficha:any, desdeMs:number, denominacionDe:(id:string)=>string): string|null {
  const e = efectoDesdeElInicioDe(ficha, "razonSocialId", "historialRazonSocial");
  if (!e || !(desdeMs < e.desdeMs)) return null;
  return `Razón social ${denominacionDe(e.valor)} asignada el ${_cuandoEnMexico(e.desdeMs)} (hora de México) por ${e.por || "—"}, con efecto desde el inicio de la relación laboral.`;
}
// El inicio del día de un documento ("AAAA-MM-DD"), en México.
function _msInicioDeFechaDocumento(fecha:any): number {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(fecha || ""));
  return m ? instanteDeMexico(Number(m[1]), Number(m[2]) - 1, Number(m[3]), 0, 0, 0, 0).getTime() : _msDeFechaDocumento(fecha);
}
// Las notas, en un documento HTML (recibo, finiquito, acta, constancia). Nada si no hay.
function bloqueDeNotasHTML(notas:any): string {
  const ns = (Array.isArray(notas) ? notas : []).filter((n:any)=> String(n || "").trim());
  if (!ns.length) return "";
  return `<div class="notas-razon" style="margin:14px 0;padding:10px 14px;border:1px solid #E5D9B6;background:#FBF7EC;border-radius:8px;font-size:11px;color:#5A4A1A;line-height:1.5;text-align:left">${ns.map((n:any)=> `<div>${_escHtml(n)}</div>`).join("")}</div>`;
}
// LA FIRMA DEL PATRÓN, UNA SOLA para todo documento que firma el patrón (recibo,
// bitácora, registro mensual, finiquito, acta de vacaciones, constancia de aguinaldo):
//   1. la denominación de la razón social que rige, en negritas;
//   2. "RFC …";
//   3. según su tipo de persona: moral → "Representante legal"; física → "Patrón";
//      sin dato → "Por el patrón".
// Nunca el nombre de quien usa la cuenta. Si falta un dato, una etiqueta dice qué va ahí.
function firmaDelPatronHTML(denominacion:any, rfc:any, tipoPersona?:any): string {
  const den = String(denominacion || "").trim(), rf = String(rfc || "").trim();
  const tp = String(tipoPersona || "").trim().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  const calidad = tp === "moral" ? "Representante legal" : tp === "fisica" ? "Patrón" : "Por el patrón";
  return `<strong>${_escHtml(den || "Nombre o razón social del patrón")}</strong><br/><span style="font-size:10px;color:#6B7CB8">${rf ? "RFC " + _escHtml(rf) : "RFC del patrón: ____________"}</span><br/><span style="font-size:10px;color:#6B7CB8">${calidad}</span>`;
}
// LA FRASE, con la fecha Y LA HORA en México, las del documento
// plataforma/checadas_inalterables (nada fijo aquí). Si el periodo empieza antes
// de ese momento, lo dice: lo anterior se muestra como consta.
function notaDeCorteChecadas(corte:Date|null, inicioPeriodo:Date): string|null {
  const mx = corte ? enHoraDeMexico(corte) : null;
  if (!mx) return null;
  const hora = `${String(mx.getHours()).padStart(2,"0")}:${String(mx.getMinutes()).padStart(2,"0")}`;
  let t = `Desde el ${fechaLargaAxis(mx)} a las ${hora} (hora de México), los registros del checador no se pueden modificar ni borrar desde la plataforma; las correcciones quedan anotadas con autor, fecha y motivo.`;
  // El periodo empieza a las 00:00 de su primer día, en México.
  const inicio = instanteDeMexico(inicioPeriodo.getFullYear(), inicioPeriodo.getMonth(), inicioPeriodo.getDate(), 0, 0, 0, 0);
  if (inicio.getTime() < (corte as Date).getTime()) t += " Los registros anteriores a ese momento se muestran como constan en la plataforma.";
  return t;
}
// EL HORARIO CAMBIÓ DENTRO DEL PERIODO: cuándo, de verdad. La fecha y la hora de
// CADA cambio que consta en el historial (leída en México), no el primer día que
// se calificó con el horario nuevo. Si son más de CAMBIOS_EN_EL_AVISO, los más
// recientes, y en una oración aparte cuántos hubo antes: el papel no se vuelve
// una lista, y el historial completo sigue en la plataforma. Los cambios del
// MISMO MINUTO se dicen juntos ("dos cambios el … a las 08:10"), sin segundos.
// El criterio impreso enseña los rangos de días según el horario con que se
// calificó cada entrada.
const CAMBIOS_EN_EL_AVISO = 5;
const _CUANTOS_EN_LETRA = ["", "un", "dos", "tres", "cuatro", "cinco"];
function avisoCambioDeHorario(cambios:{en:Date; conHora:boolean}[]|undefined): string|null {
  if (!cambios || !cambios.length) return null;
  const enOrden = cambios.slice().sort((a, b)=> a.en.getTime() - b.en.getTime());
  const mostrados = enOrden.slice(-CAMBIOS_EN_EL_AVISO);
  const mas = enOrden.length - mostrados.length;
  // Seguidos y en el mismo minuto (en México), un solo renglón con cuántos fueron.
  const grupos: {fecha:string; hora:string; n:number}[] = [];
  for (const c of mostrados) {
    const mx = c.conHora ? enHoraDeMexico(c.en) : null;
    const fecha = fechaLargaAxis(mx || c.en);
    const hora = mx ? `${String(mx.getHours()).padStart(2,"0")}:${String(mx.getMinutes()).padStart(2,"0")}` : "";
    const u = grupos[grupos.length-1];
    if (u && hora && u.hora === hora && u.fecha === fecha) u.n++;
    else grupos.push({fecha, hora, n: 1});
  }
  const uno = (g:{fecha:string; hora:string; n:number}) =>
    `${g.n > 1 ? `${_CUANTOS_EN_LETRA[g.n] || g.n} cambios ` : ""}el ${g.fecha}${g.hora ? ` a las ${g.hora}` : ""}`;
  const partes = grupos.map(uno);
  const lista = partes.length === 1 ? partes[0] : `${partes.slice(0, -1).join(", ")} y ${partes[partes.length-1]}`;
  const zona = mostrados.some((c)=> c.conHora) ? ", hora de México" : "";
  const antes = mas ? ` Además hubo ${mas} ${mas === 1 ? "cambio anterior" : "cambios anteriores"} en el periodo; el historial completo consta en la plataforma.` : "";
  return `El horario de este empleado cambió durante el periodo (${lista}${zona}).${antes} Cada entrada se calificó con el horario vigente en el momento en que se registró.`;
}
// VOLVER A ENCENDER EL PERSONALIZADO: lo que dice el formulario prellenado.
function textoPrellenadoPersonalizado(vigenteHasta:Date|null): string {
  const mx = vigenteHasta ? enHoraDeMexico(vigenteHasta) : null;
  const cuando = mx ? ` (vigente hasta el ${fechaLargaAxis(mx)} a las ${String(mx.getHours()).padStart(2,"0")}:${String(mx.getMinutes()).padStart(2,"0")})` : "";
  return `Se cargó el último horario personalizado${cuando}. Revísalo y guarda.`;
}
// UN HORARIO EN UNA LÍNEA, para el criterio por tramos. Las mismas cuentas que
// criterioEntradaTexto (tolerancia y umbral), dichas de corrido.
function criterioEnUnaLinea(horario:any): string {
  const q = String(horario?.entrada||"").split(":");
  const hh = parseInt(q[0],10), mm = parseInt(q[1],10);
  if (isNaN(hh) || isNaN(mm)) return "sin horario configurado; las entradas se muestran sin clasificar.";
  const tol = Math.max(0, Number(horario?.toleranciaMin)||0);
  const umb = umbralFaltaDe(horario);
  const hora = (min:number) => {
    const total = ((hh*60+mm+min) % 1440 + 1440) % 1440;
    return `${String(Math.floor(total/60)).padStart(2,"0")}:${String(total%60).padStart(2,"0")}`;
  };
  const base = `entrada ${hora(0)}, tolerancia ${tol} min. A tiempo hasta las ${hora(tol)}; `;
  return umb === 0
    ? base + `sin retardo (umbral de entrada tardía de 0 min); entrada tardía después de las ${hora(tol)}.`
    : base + `retardo después de las ${hora(tol)} y antes de las ${hora(tol+umb)}; entrada tardía a partir de las ${hora(tol+umb)}.`;
}
// LA VIGENCIA DE UN TRAMO, dentro del periodo: "Del 1 al 5 de octubre de 2026",
// "El 6 de octubre de 2026" y, el último, "Desde el 6 de octubre de 2026".
function vigenciaDelTramo(desde:Date, hasta:Date, esUltimo:boolean): string {
  if (esUltimo) return `Desde el ${fechaLargaAxis(desde)}`;
  if (desde.getTime() === hasta.getTime() || _isoDia(desde) === _isoDia(hasta)) return `El ${fechaLargaAxis(desde)}`;
  const mismoAnio = desde.getFullYear() === hasta.getFullYear();
  if (mismoAnio && desde.getMonth() === hasta.getMonth()) return `Del ${desde.getDate()} al ${fechaLargaAxis(hasta)}`;
  if (mismoAnio) return `Del ${desde.getDate()} de ${_MESES_AXIS[desde.getMonth()]} al ${fechaLargaAxis(hasta)}`;
  return `Del ${fechaLargaAxis(desde)} al ${fechaLargaAxis(hasta)}`;
}
// EL RESUMEN DE ASISTENCIA DE LA FICHA: cuántos días cubre (el título, los
// contadores y la lista dicen lo mismo) y cuántos renglones enseña antes de "Ver todos".
const DIAS_RESUMEN_FICHA = 14;
const RENGLONES_RESUMEN_FICHA = 8;
const TEXTO_SOLO_INCIDENCIAS = "Se muestran solo los días con incidencia (retardo, entrada tardía o sin registro).";
// "CÓMO SE CLASIFICA CADA ENTRADA", DE LOS HORARIOS QUE SE APLICARON. Se arma
// SOLO con los tramos del recorrido (los horarios con los que de verdad se
// calificó cada día), nunca con una lectura aparte del historial: así cada
// renglón cuadra con el criterio impreso de su rango.
//   · un solo horario en el periodo: el texto de siempre, con ESE horario;
//   · más de uno: cada uno con su rango y su origen (general o personalizado);
//   · un rango cuya vigencia no consta (anterior a toda entrada del historial):
//     se dice en ese rango, imprimiendo el horario: nunca una frase que remita a
//     un horario sin decir cuál.
function origenDelHorario(h:any): string {
  return h?.origen === "propio" ? " (horario personalizado)" : h?.origen === "general" ? " (horario general)" : "";
}
function criterioDelPeriodo(tramos:any[]|undefined): string[]|null {
  const ts = tramos || [];
  if (!ts.length) return null;
  if (ts.length === 1) return criterioEntradaTexto(ts[0].horario);
  return ts.map((t:any, i:number)=> {
    const sinVigencia = !t.consta && !!t.horario?.entrada;
    return `${vigenciaDelTramo(t.desde, t.hasta, i === ts.length-1)}${origenDelHorario(t.horario)}: `
      + `${sinVigencia ? "se aplicó el horario más antiguo registrado, que es: " : ""}${criterioEnUnaLinea(t.horario)}`;
  });
}

function construirBitacoraHTML(o:any){
  // SIN UNA SOLA CHECADA EN EL PERIODO NO SE IMPRIME EL APARTADO. Una tabla de
  // quince renglones que dicen "Falta" no es un registro de asistencia: es una
  // acusación construida con la ausencia de datos, en un documento que se firma.
  const sinAsistencia = o.hayAsistencia === false;
  const resumenHTML = sinAsistencia ? "" : `<div class="resumen"><h2>Resumen de la quincena</h2><div class="hint2">Lo que consta en el checador. La plataforma registra entradas: no registra inasistencias, así que no las afirma.</div>${o.resumen.textoAgregados ? `<div class="hint2">${_escHtml(o.resumen.textoAgregados)}</div>` : ""}${(o.resumen.avisosRelacion||[]).map((a:string)=>`<div class="hint2">${_escHtml(a)}</div>`).join("")}<div class="rgrid"><div><b>${o.resumen.conRegistro}</b>Días con registro</div><div><b>${o.resumen.aTiempo}</b>A tiempo</div><div><b>${o.resumen.retardos}</b>Retardo</div>${o.resumen.tardias ? `<div><b>${o.resumen.tardias}</b>Entrada tardía</div>` : ""}${o.resumen.hayLaborables ? `<div><b>${o.resumen.sinRegistro}</b>Días laborables sin registro</div>` : ""}${o.resumen.hayLaborables && o.resumen.vacaciones ? `<div><b>${o.resumen.vacaciones}</b>Vacaciones</div>` : ""}${o.resumen.hayLaborables && o.resumen.descansos74 ? `<div><b>${o.resumen.descansos74}</b>Descanso obligatorio</div>` : ""}</div></div>`;
  // La marca de repetición va como un renglón propio pegado al del día: dentro de
  // una celda se pierde, y este documento se firma.
  const notaFila = (f:any)=> f.nota ? `
      <tr class="repet"><td colspan="6">${_escHtml(f.nota)}</td></tr>` : "";
  const filas = o.filas.map((f:any)=> f.laboral ? `
      <tr><td>${_escHtml(f.fecha)}</td><td>${_escHtml(f.entrada)}</td><td>${_escHtml(f.salida)}</td><td><span class="est est-${f.estKey}">${_escHtml(f.estatus)}</span></td><td>${_escHtml(f.ubi)}</td><td>${_escHtml(f.bio)}</td></tr>${notaFila(f)}`
    : `<tr class="nolab"><td>${_escHtml(f.fecha)}</td><td colspan="5">${_escHtml(f.textoNoLaboral || "Día no laboral")}</td></tr>${notaFila(f)}`).join("");
  return `<!doctype html><html><head><meta charset="utf-8"><style>
    *{box-sizing:border-box;} body{margin:0;font-family:Georgia,'Times New Roman',serif;color:#1a1a2e;background:#fff;}
    .doc{padding:34px 40px;}
    .head{border-bottom:2px solid #B8932A;padding-bottom:12px;margin-bottom:16px;display:flex;justify-content:space-between;align-items:flex-end;}
    .wm{font-size:20px;font-weight:800;color:#0F1D35;letter-spacing:.3px;} .wm span{color:#B8932A;}
    .wm-sub{font-size:9.5px;color:#666;font-family:Arial,sans-serif;margin-top:2px;letter-spacing:1.2px;text-transform:uppercase;}
    .htag{font-size:10px;color:#666;font-family:Arial,sans-serif;text-align:right;line-height:1.5;}
    h1{font-size:18px;color:#0F1D35;margin:0 0 10px;}
    .meta{font-size:12px;color:#333;font-family:Arial,sans-serif;line-height:1.7;margin-bottom:14px;} .meta b{color:#0F1D35;}
    table{width:100%;border-collapse:collapse;font-family:Arial,sans-serif;font-size:11px;}
    th{background:#0F1D35;color:#fff;text-align:left;padding:7px 8px;font-weight:700;}
    td{padding:6px 8px;border-bottom:1px solid #ddd;color:#222;}
    tr.nolab td{color:#999;font-style:italic;background:#fafafa;}
    tr.repet td{font-size:10px;color:#8a6d1a;background:rgba(184,147,42,0.07);border-bottom:1px solid #ddd;padding:4px 8px 5px;font-family:Arial,sans-serif;}
    .est{font-weight:700;padding:1px 8px;border-radius:9px;border:1px solid #999;white-space:nowrap;}
    .est-tardia{color:#b3261e;border-color:#b3261e;} .est-sin_registro{color:#5B6784;border-color:#5B6784;}
    .est-vacaciones{color:#2F5FA8;border-color:#2F5FA8;} .est-descanso_obligatorio{color:#0a7a4a;border-color:#0a7a4a;}
    .est-futuro{color:#999;border-color:#ccc;} .est-indeterminable{color:#8a6d1a;border-color:#8a6d1a;}
    .est-a_tiempo{color:#0a7a4a;border-color:#0a7a4a;} .est-retardo{color:#8a6d1a;border-color:#8a6d1a;} .est-falta{color:#b3261e;border-color:#b3261e;} .est-sin_horario{color:#666;border-color:#bbb;}
    .resumen{margin-top:18px;border:1px solid #ccc;border-radius:8px;padding:12px 16px;font-family:Arial,sans-serif;}
    .resumen h2{font-family:Georgia,serif;font-size:14px;color:#0F1D35;margin:0 0 10px;}
    .rgrid{display:flex;gap:26px;flex-wrap:wrap;} .rgrid div{font-size:11px;color:#555;} .rgrid b{font-size:19px;color:#0F1D35;display:block;}
    .firmas{display:flex;gap:44px;margin-top:52px;} .firma{flex:1;text-align:center;}
    .firma .sp{height:46px;} .firma .linea{border-top:1px solid #333;} .firma .rol{font-size:11px;color:#333;font-family:Arial,sans-serif;margin-top:6px;} .firma .nom{font-size:10px;color:#777;font-family:Arial,sans-serif;margin-top:2px;}
    .pie{margin-top:26px;text-align:center;font-size:9.5px;color:#999;font-family:Arial,sans-serif;}
    .aviso{margin-top:9px;font-family:Arial,sans-serif;font-size:11px;color:#8a6d1a;background:rgba(184,147,42,0.10);border:1px solid rgba(184,147,42,0.30);border-radius:8px;padding:8px 10px;line-height:1.55;}
    .hint2{font-size:10.5px;color:#666;font-family:Arial,sans-serif;margin:-4px 0 9px;}
    .criterio{margin-top:12px;font-family:Arial,sans-serif;font-size:11px;color:#555;border:1px solid #e0e0e0;border-radius:8px;padding:8px 12px;line-height:1.65;}
    .criterio b{color:#0F1D35;} .criterio ul{margin:4px 0 0;padding-left:16px;}
    .nota-firma{margin-top:40px;font-family:Arial,sans-serif;font-size:11px;color:#444;line-height:1.6;}
    .corte{margin-top:16px;font-family:Arial,sans-serif;font-size:10.5px;color:#444;border-top:1px solid #e0e0e0;padding-top:8px;line-height:1.55;}
    .firma .ack{font-family:Arial,sans-serif;font-size:10px;color:#666;margin-top:3px;} .firma .fch{font-family:Arial,sans-serif;font-size:10px;color:#888;margin-top:10px;}
    .edic{font-family:Arial,sans-serif;font-size:9.5px;color:#8a6d1a;}
    .vacio{font-family:Arial,sans-serif;font-size:11.5px;color:#555;background:#fafafa;border:1px solid #e0e0e0;border-radius:8px;padding:11px 13px;line-height:1.6;}
  </style></head><body><div class="doc">
    <div class="head"><div style="font-family:Arial,sans-serif;"><div style="font-size:15px;font-weight:800;color:#0F1D35;">${_escHtml(o.empresa||"")}</div>${o.rfc ? `<div style="font-size:10px;color:#333;margin-top:2px;">RFC ${_escHtml(o.rfc)}</div>` : ""}${o.domicilio ? `<div style="font-size:9.5px;color:#666;margin-top:2px;max-width:330px;line-height:1.45;">${_escHtml(o.domicilio)}</div>` : ""}</div><div class="htag">Bitácora de asistencia<br/>Reporte quincenal</div></div>
    <h1>Bitácora quincenal de asistencia</h1>
    <div class="meta"><div><b>Empresa:</b> ${_escHtml(o.empresa||"—")}</div><div><b>Empleado:</b> ${_escHtml(o.empleado||"—")}</div><div><b>Periodo:</b> ${_escHtml(o.periodo)}</div></div>
    ${sinAsistencia ? "" : `<table><thead><tr><th>Fecha</th><th>Entrada</th><th>Salida</th><th>Estatus</th><th>Ubicación</th><th>Verificación en el aparato</th></tr></thead><tbody>${filas}</tbody></table>`}
    ${!sinAsistencia && o.avisos && o.avisos.length ? o.avisos.map((a:string)=>`<div class="aviso">${_escHtml(a)}</div>`).join("") : ""}
    ${(o.notasRazon || []).map((a:string)=>`<div class="aviso">${_escHtml(a)}</div>`).join("")}
    ${!sinAsistencia && o.criterio && o.criterio.length ? `<div class="criterio"><b>Cómo se clasifica cada entrada</b><ul>${o.criterio.map((c:string)=>`<li>${_escHtml(c)}</li>`).join("")}</ul></div>` : ""}
    ${sinAsistencia ? `<div class="vacio">No existen registros de asistencia de este empleado en el periodo.</div>` : ""}
    ${seccionCorreccionesHTML(o.correcciones)}
    ${seccionCorreccionesAnterioresHTML(o.correccionesAnteriores)}
    ${resumenHTML}
    ${o.notaCorte ? `<div class="corte">${_escHtml(o.notaCorte)}</div>` : ""}
    <div class="nota-firma">La firma acredita la recepción del documento, no conformidad con su contenido.</div>
    <div class="firmas">
      <div class="firma"><div class="sp"></div><div class="linea"></div><div class="rol">Firma del trabajador</div><div class="nom">${_escHtml(o.empleado||"")}</div><div class="ack">Recibí copia de este registro</div><div class="fch">Fecha: _______________</div></div>
      <div class="firma"><div class="sp"></div><div class="linea"></div><div class="rol">Firma del patrón</div><div class="nom">${firmaDelPatronHTML(o.empresa, o.rfc, o.tipoPersona)}</div><div class="ack">Entregué copia</div><div class="fch">Fecha: _______________</div></div>
    </div>
    <div class="pie">${_escHtml(pieDelPatronTexto({denominacion:o.empresa||""} as any, o.generadoEn, MARCA_EDICION_DOCS))}</div>
  </div></body></html>`;
}

// ═══ CORREGIR CHECADAS, CON ANOTACIÓN (FASE 2b) ══════════════════════════════
// Ninguna checada se edita ni se borra: el patrón ANOTA una corrección (anular,
// cambiar el tipo, agregar un registro faltante o revertir una corrección), con
// motivo, nombre y cargo de quien la hace. Las reglas lo exigen igual (8F-2).
//
// LA FIRMA SE RECUERDA EN LA CUENTA, no en este navegador: `usuarios/{uid}.
// firmaCorrecciones` = {nombre, cargo}, lo último que usó esa cuenta. Una cuenta de
// empresa la puede usar el patrón o un adjunto: se prellena, y se cambia si toca.
async function leerFirmaCorrecciones(uid:string): Promise<{nombre:string; cargo:string}> {
  try {
    const s = await getDoc(doc(db, "usuarios", uid));
    const f = (s.exists() ? (s.data() as any)?.firmaCorrecciones : null) || {};
    return {nombre: String(f.nombre||""), cargo: String(f.cargo||"")};
  } catch(e){ return {nombre: "", cargo: ""}; }
}
// Guarda una corrección. Los datos los arma y comprueba `datosDeCorreccion` (con
// los mismos límites que las reglas). Devuelve {id} o {error}.
async function guardarCorreccion(o:any): Promise<{id?:string; error?:string}> {
  const r = datosDeCorreccion({...o, marca: serverTimestamp(), ahoraMs: Date.now(), aTimestamp: (d:Date)=> Timestamp.fromDate(d)});
  if (r.error) return {error: r.error};
  const ref = await addDoc(collection(db, "correcciones_checadas"), r.datos);
  try { await updateDoc(doc(db, "usuarios", o.uid), {firmaCorrecciones: {nombre: r.datos.porNombre, cargo: r.datos.porCargo}}); }
  catch(e){ console.warn("firma de correcciones (no se recordará):", e); }
  return {id: ref.id};
}
// Guarda la nota "no conforme" del trabajador sobre una corrección suya.
async function guardarNoConformidad(o:{correccion:any; correoSesion:string; comentario:string}): Promise<{id?:string; error?:string}> {
  const r = datosDeNoConformidad({correccionId: o.correccion?.id, empleadorId: o.correccion?.empleadorId,
    trabajadorEmail: o.correccion?.trabajadorEmail, correo: o.correoSesion, comentario: o.comentario, marca: serverTimestamp()});
  if (r.error) return {error: r.error};
  const ref = await addDoc(collection(db, "no_conformidades"), r.datos);
  return {id: ref.id};
}
const _TXT_CORR = {anular: "Anular este registro", cambiar_tipo: "Cambiar tipo", agregar: "Agregar registro faltante", revertir: "Revertir corrección"} as any;

// EL FORMULARIO DE UNA CORRECCIÓN: lo que pide cada tipo, más motivo, nombre y
// cargo (obligatorios), y la confirmación antes de guardar.
function PanelCorreccion({modo, registro, correccion, currentUser, trabajadorEmail, onCerrar, onGuardado, fontSans}: {
  modo:"anular"|"cambiar_tipo"|"agregar"|"revertir"; registro?:any; correccion?:any; currentUser:any; trabajadorEmail:string;
  onCerrar:()=>void; onGuardado:()=>void; fontSans:string;
}) {
  const [motivo, setMotivo] = useState(""); const [nombre, setNombre] = useState(""); const [cargo, setCargo] = useState("");
  const [nuevoTipo, setNuevoTipo] = useState(""); const [tipoChecada, setTipoChecada] = useState("entrada");
  const [fecha, setFecha] = useState(""); const [hora, setHora] = useState("");
  const [error, setError] = useState(""); const [confirmando, setConfirmando] = useState(false); const [guardando, setGuardando] = useState(false);
  useEffect(()=>{ let vivo = true; (async()=>{ if (!currentUser?.uid) return; const f = await leerFirmaCorrecciones(currentUser.uid);
    if (vivo) { setNombre((n)=> n || f.nombre); setCargo((c)=> c || f.cargo); } })(); return ()=>{ vivo = false; }; }, [currentUser?.uid]);
  const hoy = new Date(); const minFecha = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate() - (DIAS_PARA_AGREGAR - 1));
  // La hora que escribe el patrón es la de México (la del checador).
  const horaDeclarada = ()=> { const f = fecha.split("-").map(Number), h = hora.split(":").map(Number);
    return (f.length === 3 && h.length >= 2 && f.every((x)=>x>0) && h.every((x)=>!isNaN(x))) ? instanteDeMexico(f[0], f[1]-1, f[2], h[0], h[1], 0, 0) : null; };
  const entrada = ()=> ({tipo: modo, uid: currentUser?.uid, empleadorId: currentUser?.uid, trabajadorEmail, correo: currentUser?.email,
    nombre, cargo, motivo, checadaId: registro?.checada?.id, tipoRegistrado: registro?.tipoRegistrado, nuevoTipo,
    tipoChecada, horaDeclarada: horaDeclarada(), correccionId: correccion?.id});
  const revisar = ()=> {
    const r = datosDeCorreccion({...entrada(), marca: "pendiente", ahoraMs: Date.now()});
    if (r.error) { setError(r.error); return; }
    setError(""); setConfirmando(true);
  };
  const guardar = async ()=> {
    setGuardando(true); setError("");
    try { const r = await guardarCorreccion(entrada()); if (r.error) { setError(r.error); setConfirmando(false); } else onGuardado(); }
    catch(e:any){ console.error("corrección:", e); setError(mensajeDeFallo(e, {accion:"guardar la corrección", denegado: denegadoPatron("corregir los registros de este empleado")})); setConfirmando(false); }
    finally { setGuardando(false); }
  };
  const lbl:any = {display:"block", fontSize:11, fontWeight:700, color:T_LIGHT.textInkSoft, margin:"8px 0 3px"};
  const inp:any = {width:"100%", boxSizing:"border-box" as const, padding:"8px 10px", borderRadius:8, border:`1px solid ${T_LIGHT.border}`, background:T_LIGHT.canvasSoft, color:T_LIGHT.textInk, fontSize:13, fontFamily:fontSans, outline:"none"};
  const btn = (txt:string, fn:()=>void, primario?:boolean, deshabilitado?:boolean)=> (
    <button type="button" onClick={fn} disabled={deshabilitado}
      style={{padding:"8px 14px", borderRadius:9, border:`1px solid ${T_LIGHT.gold}`, background:primario?T_LIGHT.gold:"transparent", color:primario?"#fff":"#7A5F12",
        fontSize:12.5, fontWeight:700, fontFamily:fontSans, cursor:deshabilitado?"wait":"pointer", opacity:deshabilitado?0.6:1}}>{txt}</button>
  );
  return (
    <div {...ZONA_DE_CAPTURA} data-correccion={modo} style={{marginTop:8, background:T_LIGHT.canvas, border:`1px solid ${T_LIGHT.goldBorder}`, borderRadius:10, padding:"10px 12px"}}>
      <div style={{fontSize:12.5, fontWeight:800, color:T_LIGHT.textInk}}>{_TXT_CORR[modo]}</div>
      {modo === "cambiar_tipo" && (<>
        <label style={lbl}>Registrado como {labelChecada(registro?.tipoRegistrado)}. Corregir a:</label>
        <select value={nuevoTipo} onChange={(e)=>{ setNuevoTipo(e.target.value); setConfirmando(false); }} style={inp}>
          <option value="">Elige el tipo correcto</option>
          {TIPOS_DE_CHECADA.filter((t:string)=> t !== registro?.tipoRegistrado).map((t:string)=> <option key={t} value={t}>{labelChecada(t)}</option>)}
        </select>
      </>)}
      {modo === "agregar" && (<>
        <label style={lbl}>Tipo de registro</label>
        <select value={tipoChecada} onChange={(e)=>{ setTipoChecada(e.target.value); setConfirmando(false); }} style={inp}>
          {TIPOS_DE_CHECADA.map((t:string)=> <option key={t} value={t}>{labelChecada(t)}</option>)}
        </select>
        <div style={{display:"flex", gap:8}}>
          <div style={{flex:1}}><label style={lbl}>Fecha</label><input type="date" value={fecha} min={_isoLocal(minFecha)} max={_isoLocal(hoy)} onChange={(e)=>{ setFecha(e.target.value); setConfirmando(false); }} style={inp}/></div>
          <div style={{flex:1}}><label style={lbl}>Hora (de México)</label><input type="time" value={hora} onChange={(e)=>{ setHora(e.target.value); setConfirmando(false); }} style={inp}/></div>
        </div>
        <div style={{fontSize:11, color:T_LIGHT.textInkMut, marginTop:4}}>Solo hacia atrás, hasta {DIAS_PARA_AGREGAR} días; nunca en el futuro.</div>
      </>)}
      {modo === "revertir" && correccion && (
        <div style={{fontSize:11.5, color:T_LIGHT.textInkSoft, marginTop:6, lineHeight:1.5}}>Se revierte: {correccion.motivo ? `«${String(correccion.motivo).trim()}»` : "esta corrección"}.</div>
      )}
      <label style={lbl}>Motivo (mínimo 10 caracteres)</label>
      <textarea value={motivo} onChange={(e)=>{ setMotivo(e.target.value); setConfirmando(false); }} rows={2} maxLength={500} style={{...inp, resize:"vertical" as const}}/>
      <div style={{display:"flex", gap:8}}>
        <div style={{flex:1}}><label style={lbl}>Nombre de quien corrige</label><input value={nombre} onChange={(e)=>{ setNombre(e.target.value); setConfirmando(false); }} maxLength={120} style={inp}/></div>
        <div style={{flex:1}}><label style={lbl}>Cargo</label><input value={cargo} onChange={(e)=>{ setCargo(e.target.value); setConfirmando(false); }} maxLength={120} style={inp}/></div>
      </div>
      {error && <div style={{fontSize:11.5, color:"#B91C1C", marginTop:6}}>{error}</div>}
      {confirmando ? (
        <div style={{marginTop:8, background:"rgba(184,147,42,0.10)", border:`1px solid ${T_LIGHT.goldBorder}`, borderRadius:8, padding:"8px 10px"}}>
          <div style={{fontSize:12, color:T_LIGHT.textInk, lineHeight:1.5, marginBottom:8}}>{TEXTO_CONFIRMAR_CORRECCION}</div>
          <div style={{display:"flex", gap:8, flexWrap:"wrap" as const}}>
            {btn(guardando ? "Guardando…" : "Sí, guardar la corrección", guardar, true, guardando)}
            {btn("Volver", ()=> setConfirmando(false), false, guardando)}
          </div>
        </div>
      ) : (
        <div style={{display:"flex", gap:8, marginTop:10, flexWrap:"wrap" as const}}>
          {btn("Guardar corrección", revisar, true)}
          {btn("Cancelar", onCerrar)}
        </div>
      )}
    </div>
  );
}
// LAS CHECADAS DE UN TRABAJADOR EN SU FICHA, COMO SE VEN DESPUÉS DE LAS
// CORRECCIONES (la vista efectiva): un registro anulado sigue visible, atenuado y
// anotado; uno agregado lleva su marca, sin ubicación ni verificación en el
// aparato (no las tiene); un cambio de tipo dice cómo se registró y a qué se
// corrigió. Cada corrección, con su anotación, su nota "no conforme" si la hay, y
// "Revertir corrección" mientras esté vigente.
// En el portal móvil del patrón no se corrige (decisión de Iván, 9-oct-2026): se ve.
const TEXTO_CORREGIR_DESDE_COMPUTADORA = "Para corregir un registro, entra a la plataforma desde una computadora.";
function ChecadasConCorrecciones({vista, horarioEn, currentUser, trabajadorEmail, onCambio, fontSans, soloLectura, tema, ficha}: {
  vista:any; horarioEn:(t:Date|null)=>any; currentUser:any; trabajadorEmail:string; onCambio:()=>void; fontSans:string;
  // La ficha, para el historial de su sede: si el testigo de la checada dice otra
  // sede que la que regía, se marca en gris (como el del horario).
  ficha?:any;
  // EN EL PORTAL MÓVIL DEL PATRÓN se ve igual, sin corregir (y en navy): ni
  // "Corregir", ni "Agregar registro faltante", ni "Revertir corrección".
  soloLectura?:boolean; tema?:"light"|"navy";
}) {
  const TT = tema === "navy"
    ? {cardLight:"rgba(255,255,255,0.03)", borderCard:"rgba(184,147,42,0.30)", textInk:"#ECE6D8", textInkSoft:"rgba(236,230,216,0.66)", textInkMut:"rgba(236,230,216,0.42)", shadow:"none",
       enlace:"#D4A843", nota:"#E2B84A", mapa:"#4FA3C0"}
    : {...T_LIGHT, enlace:"#7A5F12", nota:"#8a6d1a", mapa:"#236478"};
  const [abierto, setAbierto] = useState<{modo:any; registroId?:string; correccion?:any}|null>(null);
  const [menu, setMenu] = useState<string|null>(null);
  const registros = (vista?.registros || []).slice().sort((a:any,b:any)=> (b.ms||0) - (a.ms||0));
  const deRegistro = (id:string)=> (vista?.correcciones || []).filter((x:any)=> x.registro && x.registro.id === id);
  const efectivaDe = (r:any)=> (vista?.checadasQueCuentan || []).find((c:any)=> c.id === r.id) || null;
  const listo = ()=> { setAbierto(null); setMenu(null); onCambio(); };
  const panel = (modo:any, registro?:any, correccion?:any)=> (
    <PanelCorreccion modo={modo} registro={registro} correccion={correccion} currentUser={currentUser} trabajadorEmail={trabajadorEmail}
      onCerrar={()=> setAbierto(null)} onGuardado={listo} fontSans={fontSans}/>
  );
  const enlace = (txt:string, fn:()=>void)=> (
    <button type="button" onClick={fn} style={{background:"none", border:"none", padding:0, color:TT.enlace, fontFamily:fontSans, fontSize:12, fontWeight:700, cursor:"pointer", textDecoration:"underline"}}>{txt}</button>
  );
  const chip = (txt:string, color:string, fondo:string)=> <span style={{fontSize:11, fontWeight:700, padding:"3px 10px", borderRadius:999, background:fondo, color}}>{txt}</span>;
  return (
    <div>
      <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", gap:10, flexWrap:"wrap" as const, marginBottom:10}}>
        <div style={{fontSize:12, color:TT.textInkSoft}}>{registros.length} registro{registros.length===1?"":"s"} de entrada/salida</div>
        {soloLectura
          ? <div style={{fontSize:11.5, color:TT.textInkMut, fontStyle:"italic" as const}}>{TEXTO_CORREGIR_DESDE_COMPUTADORA}</div>
          : enlace("Agregar registro faltante", ()=> { setMenu(null); setAbierto({modo:"agregar"}); })}
      </div>
      {abierto?.modo === "agregar" && <div style={{marginBottom:10}}>{panel("agregar")}</div>}
      {registros.length === 0 ? (
        <div style={{background:TT.cardLight, border:`1px solid ${TT.borderCard}`, borderRadius:12, padding:"28px 24px", textAlign:"center" as const, fontSize:13, color:TT.textInkSoft, boxShadow:TT.shadow}}>
          Este trabajador aún no tiene registros de checador.
        </div>
      ) : (
        <div style={{display:"flex", flexDirection:"column" as const, gap:8}}>
          {registros.map((r:any)=> {
            const c = r.checada; const ef = efectivaDe(r);
            const d = Number.isFinite(r.ms) ? new Date(r.ms) : null;
            const fechaHora = d ? d.toLocaleString("es-MX",{weekday:"short", day:"2-digit", month:"short", hour:"2-digit", minute:"2-digit"}) : "—";
            const llegada = esLlegadaChecada(r.tipo);
            const cl = ef && r.tipo === "entrada" ? clasificacionDeChecada(ef, horarioEn(d)) : "sin_horario";
            const cm = cl !== "sin_horario" ? clasifAsistenciaMeta(cl) : null;
            const suyas = deRegistro(r.id);
            return (
              <div key={r.id} data-registro={r.origen} style={{background:TT.cardLight, border:`1px solid ${TT.borderCard}`, borderLeft:`4px solid ${llegada?"#059669":"#B8932A"}`, borderRadius:10, padding:"10px 14px", opacity: r.cuenta ? 1 : 0.6}}>
                <div style={{display:"flex", alignItems:"center", gap:10, flexWrap:"wrap" as const}}>
                  {chip(labelChecada(r.tipo), llegada?"#059669":"#B8932A", llegada?"rgba(5,150,105,0.10)":"rgba(184,147,42,0.12)")}
                  {r.origen === "agregado" && chip("Agregado por el patrón", "#5B4B8A", "rgba(91,75,138,0.12)")}
                  {r.origen === "original" && !r.cuenta && chip("Anulado", "#6B7280", "rgba(107,114,128,0.14)")}
                  {r.origen === "original" && r.cuenta && r.cambio && chip("Tipo corregido", "#5B4B8A", "rgba(91,75,138,0.12)")}
                  {r.origen === "agregado" && !r.cuenta && chip("Revertido", "#6B7280", "rgba(107,114,128,0.14)")}
                  {c && difiereDelTestigo(c, horarioEn(d)) && (
                    <span title={detalleDelTestigo(c)} style={{fontSize:10.5, fontStyle:"italic" as const, color:TT.textInkMut}}>El teléfono registró otro horario</span>
                  )}
                  {c && ficha && sedeDifiereDelTestigo(c, ficha, d) && (
                    <span data-sede-difiere title={`Checó con ${c.sedeAplicada?.nombre ? `la sede «${c.sedeAplicada.nombre}»` : c.sedeAplicada?.sedeId === SEDE_PRINCIPAL ? "la sede principal" : "otra sede"}; según el historial de su ficha regía otra.`} style={{fontSize:10.5, fontStyle:"italic" as const, color:TT.textInkMut}}>El teléfono registró otra sede</span>
                  )}
                  {cm && r.cuenta && <span style={{fontSize:11, fontWeight:700, padding:"3px 10px", borderRadius:999, border:`1px solid ${cm.color}`, color:cm.color, background:`rgba(${cm.rgb},0.12)`}}>{cm.patron}</span>}
                  {c && (()=>{ const lu = lecturaUbicacionChecada(c); if (lu.estado!=="dentro" && lu.estado!=="fuera" && lu.estado!=="imprecisa") return null;
                    const col = lu.estado==="dentro" ? "#059669" : lu.estado==="fuera" ? "#B8860B" : "#6B7280";
                    const fondo = lu.estado==="dentro" ? "rgba(5,150,105,0.10)" : lu.estado==="fuera" ? "rgba(184,147,42,0.12)" : "rgba(107,114,128,0.12)";
                    return chip(lu.texto, col, fondo); })()}
                  {c && (()=>{ const eb = etiquetaBiometria(c); if (!eb) return null;
                    return chip(eb.texto, eb.con?"#059669":"#6B7280", eb.con?"rgba(5,150,105,0.10)":"rgba(107,114,128,0.12)"); })()}
                  <span style={{fontSize:13, color:TT.textInk, fontWeight:600}}>{fechaHora}</span>
                </div>
                {c ? (c.ubicacionDisponible && c.lat!=null && c.lng!=null ? (
                  <a href={`https://www.google.com/maps?q=${c.lat},${c.lng}`} target="_blank" rel="noopener noreferrer" style={{fontSize:12, fontWeight:700, color:TT.mapa, textDecoration:"none"}}>Ver ubicación →</a>
                ) : (<span style={{fontSize:11, color:TT.textInkMut}}>sin ubicación</span>)) : null}
                {suyas.map((x:any)=> {
                  // Una reversión que SÍ deshizo algo ya se lee en la corrección que
                  // revirtió ("Revertida por…"); aquí solo se dice su nota, si la hay.
                  const mostrarAnotacion = x.correccion.tipo !== "revertir" || x.estado === "reversion_sin_efecto";
                  return (
                    <div key={x.correccion.id} style={{marginTop:6, fontSize:11.5, color:TT.textInkSoft, lineHeight:1.5}}>
                      {/* Cada anotación en su renglón: la corrección y, debajo, su reversión. */}
                      {mostrarAnotacion && renglonesDeCorreccion(x).map((t:string, k:number)=> <div key={k} data-anotacion>{t}</div>)}
                      {x.noConformidades[0] && <div style={{color:TT.nota, fontWeight:600}}>{noConformidadTexto(x.noConformidades[0])}</div>}
                      {!soloLectura && sePuedeRevertir(x.correccion, vista.estados) && (abierto?.modo === "revertir" && abierto.correccion?.id === x.correccion.id
                        ? panel("revertir", r, x.correccion)
                        : <div style={{marginTop:2}}>{enlace("Revertir corrección", ()=> { setMenu(null); setAbierto({modo:"revertir", correccion:x.correccion}); })}</div>)}
                    </div>
                  );
                })}
                {!soloLectura && r.origen === "original" && r.cuenta && (
                  <div style={{marginTop:6}}>
                    {menu === r.id ? (
                      <div style={{display:"flex", gap:12, flexWrap:"wrap" as const}}>
                        {enlace("Anular este registro", ()=> { setAbierto({modo:"anular", registroId:r.id}); setMenu(null); })}
                        {enlace("Cambiar tipo", ()=> { setAbierto({modo:"cambiar_tipo", registroId:r.id}); setMenu(null); })}
                        {enlace("Cancelar", ()=> setMenu(null))}
                      </div>
                    ) : enlace("Corregir", ()=> { setAbierto(null); setMenu(r.id); })}
                  </div>
                )}
                {(abierto?.modo === "anular" || abierto?.modo === "cambiar_tipo") && abierto.registroId === r.id && panel(abierto.modo, r)}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

// CUALQUIER PERIODO PASADO, NO SOLO EL ANTERIOR (decisión de Iván, 9-oct-2026): una
// corrección puede tocar registros de hasta 60 días atrás y en un juicio se pide el
// periodo que sea. Se ofrece desde el mes de su primer registro —checada o
// registro agregado por el patrón— o de su ingreso, lo que sea anterior, hasta el
// en curso; nunca uno futuro (src/logica/periodos.js).
function primerMesDelEmpleado(empleado:any, checadas:any[], correcciones:any[]|undefined): {anio:number; mes0:number} {
  const email = String(empleado?.email||"").toLowerCase().trim();
  const deEl = (x:any)=> String(x?.trabajadorEmail||"").toLowerCase().trim() === email;
  return primerMesDisponible({hoy: new Date(), fechaIngreso: empleado?.fechaIngreso,
    instantesDeRegistros: [...(checadas||[]).filter(deEl).map((c:any)=> c.horaServidor || c.timestamp),
      ...(correcciones||[]).filter((c:any)=> c?.tipo === "agregar" && deEl(c)).map((c:any)=> c.horaDeclarada)]});
}
const _mayuscula = (s:string)=> s.charAt(0).toUpperCase() + s.slice(1);
const TEXTO_PERIODO_NO_PERMITIDO = "Ese periodo no se puede emitir: elige uno entre el primer registro de este empleado y el periodo en curso.";
function BitacoraBoton({empleado, checadas, correcciones, currentUser, tema, fontSans}:{empleado:any; checadas:any[]; correcciones?:any[]; currentUser:any; tema:"navy"|"light"; fontSans:string}) {
  // La quincena: por omisión, la en curso; cualquier otra desde el primer registro.
  const [quincenaSel,setQuincenaSel]=useState<{anio:number; mes0:number; mitad:number}>(()=> quincenaEnCurso(new Date()));
  const primeroDisponible = primerMesDelEmpleado(empleado, checadas, correcciones);
  const [gen,setGen]=useState(false); const [env,setEnv]=useState(false); const [msg,setMsg]=useState("");
  const [ultimoEnvio,setUltimoEnvio]=useState<Date|null>(null);
  // Quién firma esta bitácora. Sin denominación no se emite: el documento la
  // nombra en su encabezado y sobre la línea de firma del patrón.
  const dp = useDatosPatron(currentUser?.uid);
  const T = tema==="navy"
    ? {gold:"#D4A843", line:"rgba(184,147,42,0.30)", ink:"#ECE6D8", inkSoft:"rgba(236,230,216,0.62)", inputBg:"rgba(255,255,255,0.05)", dark:true}
    : {gold:T_LIGHT.gold, line:T_LIGHT.border, ink:T_LIGHT.textInk, inkSoft:T_LIGHT.textInkSoft, inputBg:T_LIGHT.canvasSoft, dark:false};
  const email = (empleado?.email||"").toLowerCase().trim();
  // Último envío quincenal de este empleado (un solo where por empleadorId; filtra en JS).
  useEffect(()=>{ let cancel=false; (async()=>{
    try { const snap=await getDocs(query(collection(db,"reportes"), where("empleadorId","==",currentUser.uid)));
      if (cancel) return;
      const mios=snap.docs.map((d:any)=>d.data()).filter((r:any)=>(r.trabajadorEmail||"").toLowerCase()===email && r.tipo==="quincenal");
      const ult=mios.map((r:any)=>r.fechaEnvio?.toDate?.()).filter(Boolean).sort((a:any,b:any)=>b-a)[0]||null;
      setUltimoEnvio(ult);
    } catch(e){ /* silencioso */ }
  })(); return ()=>{cancel=true;}; /* eslint-disable-next-line */ }, [email]);
  const construir = async ()=>{
    // EL CANDADO. La UI ya lo impide antes de llegar aquí; esto cierra la puerta
    // para cualquier ruta futura que llame a construir() por su cuenta.
    if (!datosPatronCompletos(dp.cfg)) { abrirDatosDelPatron(); throw errorParaMostrar("Faltan los datos de tu empresa."); }
    const hoy = new Date();
    // LA QUINCENA ELEGIDA, comprobada otra vez aquí: ni antes del primer registro
    // ni futura (el selector ya no las ofrece).
    if (!periodoPermitido({periodo: quincenaSel, primero: primeroDisponible, hoy})) throw errorParaMostrar(TEXTO_PERIODO_NO_PERMITIDO);
    const {ini,fin} = rangoDeQuincena(quincenaSel);
    // La quincena en curso TERMINA HOY. Imprimir "Falta" en los días que aún no
    // ocurren fue el mismo defecto del reporte mensual, en un documento que
    // también se firma.
    const enCurso = fin.getTime() > hoy.getTime();
    const finReal = enCurso ? new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate()) : new Date(fin);
    // La misma lectura trae el horario general: es de donde hereda los días
    // laborables un horario personalizado que no los traiga. Ver diasLaborablesVigentes.
    // La denominación que se imprime ya no es siempre la de la empresa: es la de la
    // razón social del trabajador en el periodo (dpDoc, más abajo).
    let horarioGeneral:any=null, historialGeneral:any=null;
    try { const g = await leerHorarioGeneralConHistorial(currentUser.uid); horarioGeneral = g.horario; historialGeneral = g.historial; } catch {}
    // EL HORARIO QUE REGÍA, DÍA POR DÍA (horarioQueRegia): el suyo si lo tenía y
    // si no el general, cada uno de su historial. Cambiar el horario hoy ya no
    // reclasifica los días de antes en un papel que se firma. Se resuelve DESPUÉS
    // de leer la ficha al día, que trae su historial propio.
    const alDia = await fichaYChecadasAlDia(empleado, checadas||[], currentUser.uid);
    const horarioEn = (t:Date)=> horarioQueRegia(alDia.ficha, horarioGeneral, historialGeneral, t);
    // El criterio que se imprime es el del CIERRE del periodo; si el horario cambió
    // dentro del periodo, el papel lo dice (avisoCambioDeHorario).
    const he = horarioEn(instanteDeMexico(finReal.getFullYear(), finReal.getMonth(), finReal.getDate(), 23, 59, 59, 999));
    const corte = await leerFechaDeCorteChecadas();
    let regObl:any[] = [];
    try {
      const snapO = await getDocs(query(collection(db,"cumplimiento_obligaciones"), where("empleadorId","==",currentUser.uid)));
      regObl = snapO.docs.map((d:any)=>({id:d.id, ...d.data()}));
    } catch(e){ console.warn("cumplimiento_obligaciones (bitácora):", e); }

    // MISMO clasificador que el registro mensual, el panel de equipo y el
    // expediente. Cuatro pantallas, una sola forma de leer un día.
    const rec = recorrerDiasChecador({
      desde: ini, hasta: finReal, hoy, horario: he, checadas: alDia.checadas, email,
      registrosObligaciones: regObl, trabajadorId: empleado?.id, horarioGeneral, horarioEn,
      instantesDeCambio: instantesDelHistorial(alDia.ficha?.historialHorarioPropio, historialGeneral,
        instanteDeMexico(ini.getFullYear(), ini.getMonth(), ini.getDate(), 0, 0, 0, 0),
        instanteDeMexico(finReal.getFullYear(), finReal.getMonth(), finReal.getDate(), 23, 59, 59, 999)),
      // Su ingreso y su baja, de la ficha al día: antes y después no se cuenta.
      periodosLaborales: periodosLaboralesDe(alDia.ficha),
    });
    const filas = rec.dias.map((d:any)=> filaDeBitacora(d, alDia.vista));
    // El periodo en instantes de México, para las correcciones y los agregados.
    const iniMs = instanteDeMexico(ini.getFullYear(), ini.getMonth(), ini.getDate(), 0, 0, 0, 0).getTime();
    const finMs = instanteDeMexico(finReal.getFullYear(), finReal.getMonth(), finReal.getDate(), 23, 59, 59, 999).getTime();
    // LA RAZÓN SOCIAL DEL TRABAJADOR EN EL PERIODO (11-oct-2026): la que regía al
    // cerrarlo según su ficha, con los datos del catálogo; la principal son los
    // Datos de mi empresa de siempre. Y los catálogos, para nombrar sedes y razones.
    const cat = await leerCatalogosDeEmpresa(currentUser.uid);
    const dpDoc = datosPatronDeRazon(razonSocialDelPeriodo(alDia.ficha, finMs, cat.razones), dp.datos);

    // Los avisos sustituyen a la nota al pie que se disculpaba DESPUÉS de haber
    // impreso un conteo. Aquí el conteo que no se puede sostener no existe.
    // EL MISMO CRITERIO QUE EL REGISTRO MENSUAL, palabra por palabra: el hecho de
    // que haya checadas suyas en el periodo. Antes esto preguntaba solo si tenía
    // correo, y el mensual preguntaba por la bandera de la ficha.
    const hayAsistencia = hayAsistenciaEnPeriodo({checadas: alDia.checadas, email, desde: ini, hasta: finReal});
    const avisos: string[] = [];
    if (!rec.hayLaborables) avisos.push("No hay días laborables configurados para este empleado, así que no es posible determinar qué días eran laborables. Configura los días laborables de este empleado en su horario para que este apartado pueda calcularse.");
    if (rec.anioSinCatalogo) avisos.push(`No se pudieron determinar los días de descanso obligatorio de ${rec.anioSinCatalogo}: el catálogo del Art. 74 LFT de la plataforma no cubre ese año.`);
    if (!he || !he.entrada) avisos.push("Este empleado no tiene horario configurado, así que no se puede clasificar la hora de entrada; se muestran las horas registradas.");
    // Se explica UNA vez lo que las marcas de los renglones ya dicen día por día.
    // Sin esto, la marca sola se lee como un señalamiento a la persona; con
    // esto, se lee como lo que es: el reporte diciendo qué descartó y por qué.
    if (rec.diasConRepeticion > 0) avisos.push(avisoRepeticionesBitacora(rec.diasConRepeticion));
    { const ac = avisoCambioDeHorario(rec.cambiosDeHorario); if (ac) avisos.push(ac); }
    // Si la sede o la razón social cambiaron dentro de la quincena, con fecha y hora.
    avisosDeSede(alDia.ficha, cat.sedes, iniMs, finMs).forEach((a)=> avisos.push(a));
    // Las de la razón social, aparte: salen aunque no haya registros (13-oct-2026).
    const notasRazon = avisosDeRazonSocial(alDia.ficha, cat.razones, iniMs, finMs);

    const fmtF=(d:Date)=>`${d.getFullYear()}${String(d.getMonth()+1).padStart(2,"0")}${String(d.getDate()).padStart(2,"0")}`;
    const periodo = enCurso
      ? `${fechaLargaAxis(ini)} al ${fechaLargaAxis(finReal)} (quincena en curso)`
      : `${fechaLargaAxis(ini)} al ${fechaLargaAxis(fin)}`;
    const html = construirBitacoraHTML({
      // El encabezado: la razón social del trabajador en el periodo (dpDoc).
      empresa: dpDoc.denominacion, rfc: dpDoc.rfc, tipoPersona: dpDoc.tipoPersona, domicilio: domicilioPatronTexto(dpDoc),
      empleado: empleado?.nombre||email||"Empleado",
      periodo, filas, avisos, notasRazon, hayAsistencia,
      criterio: criterioDelPeriodo(rec.tramosDeHorario),
      notaCorte: notaDeCorteChecadas(corte, ini),
      correcciones: correccionesDelPeriodo(alDia.vista, iniMs, finMs),
      correccionesAnteriores: correccionesHechasEnElPeriodo(alDia.vista, iniMs, finMs),
      resumen:{
        conRegistro: rec.conRegistro, aTiempo: rec.aTiempo, retardos: rec.retardos, tardias: rec.tardias,
        sinRegistro: rec.sinRegistro, vacaciones: rec.vacaciones, descansos74: rec.descansos74,
        hayLaborables: rec.hayLaborables,
        textoAgregados: textoDiasConAgregados(diasConRegistrosAgregados(alDia.vista, iniMs, finMs)),
        avisosRelacion: rec.avisosRelacion,
      },
      generadoEn: fechaHoraLargaAxis(),
    });
    const fname = `bitacora-${String(empleado?.nombre||email||"empleado").replace(/[^a-zA-Z0-9]/g,"_")}-${fmtF(ini)}_${fmtF(finReal)}.pdf`;
    return { html, fname, periodo };
  };
  const generar = async ()=>{
    setGen(true); setMsg("");
    try { const {html,fname}=await construir(); await generarPDFDesdeHTML(html, fname); setMsg("PDF generado (revisa tus descargas)."); }
    catch(e:any){ console.error("bitacora:", e); setMsg(mensajeDeFallo(e, {accion:"generar la bitácora", denegado: denegadoPatron("leer las checadas de este empleado")})); }
    finally { setGen(false); }
  };
  const enviar = async ()=>{
    setEnv(true); setMsg("");
    try {
      const {html,fname,periodo}=await construir();
      await enviarReporteAlTrabajador({empleado, currentUser, tipo:"quincenal", periodo, html, fname});
      setUltimoEnvio(new Date());
      setMsg("Enviado al trabajador. Lo verá en “Mis reportes” con notificación.");
    } catch(e:any){ console.error("bitacora envio:", e); setMsg(mensajeDeFallo(e, {accion:"enviar la bitácora", denegado: denegadoPatron("enviarle reportes a este empleado")})); }
    finally { setEnv(false); }
  };
  const inp:any = {padding:"8px 10px", borderRadius:9, border:`1px solid ${T.line}`, background:T.inputBg, color:T.ink, fontSize:13, fontFamily:fontSans, outline:"none", ...(T.dark?{colorScheme:"dark"}:{})};
  const btnGhost:any = {display:"inline-flex", alignItems:"center", gap:7, padding:"9px 14px", borderRadius:10, border:`1px solid ${T.gold}`, background:"transparent", color:T.gold, cursor:(gen||env)?"wait":"pointer", fontFamily:fontSans, fontSize:13, fontWeight:800};
  return (
    <div>
      <div style={{display:"flex", gap:8, alignItems:"center", flexWrap:"wrap" as const}}>
        <select {...CAMPO_DE_PARAMETRO} value={`${quincenaSel.anio}-${quincenaSel.mes0}`} aria-label="Mes de la bitácora" style={inp}
          onChange={e=>{ const [a, m] = e.target.value.split("-").map(Number); const qs = quincenasDelMes({anio:a, mes0:m}, new Date());
            setQuincenaSel({anio:a, mes0:m, mitad: qs.some((x:any)=> x.mitad === quincenaSel.mitad) ? quincenaSel.mitad : qs[qs.length-1].mitad}); }}>
          {mesesDisponibles(primeroDisponible, new Date()).map((p:any)=> <option key={`${p.anio}-${p.mes0}`} value={`${p.anio}-${p.mes0}`}>{_mayuscula(etiquetaMes(p))}{p.enCurso ? " (en curso)" : ""}</option>)}
        </select>
        <select {...CAMPO_DE_PARAMETRO} value={quincenaSel.mitad} aria-label="Quincena" style={inp} onChange={e=>setQuincenaSel({...quincenaSel, mitad: Number(e.target.value)})}>
          {quincenasDelMes(quincenaSel, new Date()).map((x:any)=> <option key={x.mitad} value={x.mitad}>{x.enCurso ? "Quincena en curso: " : ""}{x.etiqueta}</option>)}
        </select>
        <button onClick={generar} disabled={gen||env}
          style={{display:"inline-flex", alignItems:"center", gap:7, padding:"9px 14px", borderRadius:10, border:"none", background:T.gold, color:"#0B1829", cursor:(gen||env)?"wait":"pointer", fontFamily:fontSans, fontSize:13, fontWeight:800}}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><path d="M6 3h8l4 4v13a1 1 0 01-1 1H6a1 1 0 01-1-1V4a1 1 0 011-1z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round"/><path d="M13 3v5h5M9 14h6M9 17h4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/></svg>
          {gen ? "Generando…" : "Generar bitácora (PDF)"}
        </button>
        <button onClick={enviar} disabled={gen||env} style={btnGhost}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><path d="M4 12l16-8-6 16-3-6-7-2z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round"/></svg>
          {env ? "Enviando…" : "Enviar al trabajador"}
        </button>
      </div>
      {ultimoEnvio && <div style={{fontSize:11.5, color:T.inkSoft, marginTop:8}}>✓ Enviado el {ultimoEnvio.toLocaleDateString("es-MX",{day:"numeric",month:"long",year:"numeric"})} · {ultimoEnvio.toLocaleTimeString("es-MX",{hour:"2-digit",minute:"2-digit"})}</div>}
      {/* EL CANDADO, A LA VISTA Y ANTES DE PULSAR. Dice que falta y lleva a
          capturarlo; el propio construir() lo vuelve a comprobar. */}
      {dp.faltan.length > 0 && (
        <AvisoFaltanDatosPatron faltan={dp.faltan} que="La bitácora quincenal" oscuro={T.dark}
          fontSans={fontSans} fontSerif={fontSans}/>
      )}
      {msg && <div style={{fontSize:12, color:T.inkSoft, marginTop:7}}>{msg}</div>}
    </div>
  );
}



// ─── FECHAS EN LOS DOCUMENTOS DE AXIS ───────────────────────────────────────
// LA REGLA, escrita una sola vez y no decidida documento por documento:
//   · FORMA LARGA ("3 de septiembre de 2026") en el encabezado y dentro de
//     cualquier frase. Un documento que se lee como texto se lee mejor así, y no
//     hay ambigüedad posible entre día y mes.
//   · dd/mm/aaaa en las COLUMNAS DE TABLA. Ahí la forma larga rompe la
//     alineación y obliga a leer palabra por palabra para comparar dos renglones.
// Nada de mezclar las dos formas en el mismo tipo de sitio.
//
// Las tres aceptan Date o el texto "AAAA-MM-DD" que guarda la plataforma, y ese
// texto NO se convierte a Date en el camino: `new Date("2026-10-15")` se
// interpreta como medianoche UTC y en México imprime el día anterior.
const _MESES_AXIS = ["enero","febrero","marzo","abril","mayo","junio","julio",
  "agosto","septiembre","octubre","noviembre","diciembre"];
function _partesFecha(f:any): {a:number; m:number; d:number}|null {
  if (f instanceof Date && !isNaN(f.getTime())) return {a:f.getFullYear(), m:f.getMonth()+1, d:f.getDate()};
  const p = String(f||"").slice(0,10).split("-");
  if (p.length !== 3) return null;
  const a = Number(p[0]), m = Number(p[1]), d = Number(p[2]);
  return (a && m && d) ? {a, m, d} : null;
}
// ⚠️ LA REGLA DE LAS FECHAS DE CALENDARIO, y está aquí porque ésta es una de las
// dos funciones correctas y nadie sabía que existían hasta que algo se rompía:
//
//   `new Date("AAAA-MM-DD")` es medianoche UTC, NO medianoche local. En México
//   (UTC-6) eso cae en el día ANTERIOR. Para fechas de calendario se usa
//   `fechaLargaAxis` —para imprimir— o `_diaLocalDeFecha` —para comparar y
//   restar—, nunca el constructor con una cadena.
//
// No es teoría: los contratos imprimían el día anterior al capturado, y un
// contrato de trabajo que dice que la relación inició el 31 de agosto en vez del
// 1 de septiembre mueve antigüedad, aguinaldo proporcional, prima de antigüedad
// y periodo de prueba. El arrendamiento de bodega, además, GUARDABA una fecha
// fin un día corta. Y el aniversario laboral, del que sale el periodo de
// vacaciones que se imprime en el acta, se corría un año.
//
// Estas dos funciones parten la cadena en trozos y arman el día en hora local;
// por eso no dependen de la zona horaria ni de la hora a la que se mire.
function fechaLargaAxis(f:any): string {
  const p = _partesFecha(f);
  return p ? `${p.d} de ${_MESES_AXIS[p.m-1]} de ${p.a}` : "";
}
// EL DÍA DE UNA MARCA DE TIEMPO, DICHO COMO LO DIRÍA UNA PERSONA. "Hoy",
// "Ayer", y a partir de ahí la fecha completa. Un rótulo contesta solo; un
// filtro añade un control que hay que aprender.
//
// Compara DÍA contra DÍA, con la misma regla de siempre: nada de restar
// milisegundos y dividir.
function diaRelativoAxis(d: Date | null, referencia?: Date): string {
  if (!d || isNaN(d.getTime())) return "";
  const ref = referencia || new Date();
  const hoy = new Date(ref.getFullYear(), ref.getMonth(), ref.getDate());
  const suyo = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const dias = Math.round((suyo.getTime() - hoy.getTime()) / (1000*60*60*24));
  if (dias === 0) return "Hoy";
  if (dias === -1) return "Ayer";
  if (dias === 1) return "Mañana";
  return `${suyo.getDate()} de ${_MESES_AXIS[suyo.getMonth()]} de ${suyo.getFullYear()}`;
}
// EL ENCABEZADO DE UN BLOQUE DE DÍA: "Hoy · 7 sep", "Ayer · 6 sep", "5 sep".
//
// Esta forma ya existía —la usa la bitácora del portal del patrón en el móvil—
// pero vivía DENTRO de aquel componente, así que el escritorio no podía usarla.
// Sube aquí tal cual para que las dos pantallas separen los días de la misma
// manera: dos listas que hacen lo mismo de dos maneras distintas es justo lo que
// llevamos la semana quitando.
//
// Se apoya en `diaRelativoAxis` para decidir qué día es, así que hay UN solo
// sitio que sabe qué es "hoy" y qué es "ayer".
function etiquetaDiaAxis(d: Date | null, referencia?: Date): string {
  if (!d || isNaN(d.getTime())) return "Sin fecha";
  const corto = d.toLocaleDateString("es-MX",{day:"numeric",month:"short"});
  const rel = diaRelativoAxis(d, referencia);
  return (rel === "Hoy" || rel === "Ayer") ? `${rel} · ${corto}` : corto;
}
// Agrupa una lista YA ORDENADA en bloques por día, conservando su orden. No
// ordena ni filtra: solo marca dónde cambia el día.
//
// `fechaDe` existe porque cada lista guarda su fecha a su manera —el móvil trae
// un `Date` en `d`, el feed de Inicio trae milisegundos en `ms`—, y convertir una
// para que se parezca a la otra sería copiar el dato en vez de leerlo.
function agruparPorDiaAxis<T>(items: T[], fechaDe: (it:T)=>Date|null): {key:string; d:Date|null; items:T[]}[] {
  const grupos: {key:string; d:Date|null; items:T[]}[] = [];
  const idx: Record<string, number> = {};
  (items||[]).forEach((it)=>{
    const d = fechaDe(it);
    const key = (d && !isNaN(d.getTime())) ? `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}` : "sin";
    if (!(key in idx)) { idx[key] = grupos.length; grupos.push({key, d: (d && !isNaN(d.getTime())) ? d : null, items: []}); }
    grupos[idx[key]].items.push(it);
  });
  return grupos;
}
// "ayer 16:40" / "hoy 09:12" / "3 de septiembre de 2026 16:40". En minúscula
// porque va dentro de una frase, no como rótulo.
function cuandoRelativoAxis(d: Date | null, referencia?: Date): string {
  if (!d || isNaN(d.getTime())) return "";
  const dia = diaRelativoAxis(d, referencia);
  // La hora va TAL CUAL, con su punto: "04:40 p. m." es la hora completa. El
  // punto solo se quita cuando detrás viene el de una oración (ver
  // `_horaCortaChecada`); aquí no viene nada detrás, y quitarlo dejaba "p.m".
  const hora = d.toLocaleTimeString("es-MX",{hour:"2-digit",minute:"2-digit"});
  return `${dia.charAt(0).toLowerCase()}${dia.slice(1)} ${hora}`;
}
function fechaTablaAxis(f:any): string {
  const p = _partesFecha(f);
  return p ? `${String(p.d).padStart(2,"0")}/${String(p.m).padStart(2,"0")}/${p.a}` : "";
}
// Mes con año, para encabezados y frases: "Septiembre de 2026".
function mesLargoAxis(anio:number, mes:number): string {
  const n = _MESES_AXIS[mes];
  return `${n.charAt(0).toUpperCase()}${n.slice(1)} de ${anio}`;
}
// Fecha y hora de generación, en forma larga: va en una frase, no en una columna.
function fechaHoraLargaAxis(d?: Date): string {
  const f = d || new Date();
  return `${fechaLargaAxis(f)}, ${f.toLocaleTimeString("es-MX",{hour:"2-digit",minute:"2-digit"})}`;
}
// ─── ATAJOS DE RANGO DE FECHAS ──────────────────────────────────────────────
// Son ATAJOS, no un filtro paralelo: devuelven las dos fechas y quien los llama
// las escribe en los mismos campos Desde/Hasta que el usuario ve y puede
// ajustar después. Si el atajo filtrara por su cuenta habría dos criterios
// distintos sobre el mismo dato, que es el defecto que venimos corrigiendo.
function _isoLocal(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`;
}
function rangoDeAtajo(clave: "semana"|"mes"|"mes_pasado", hoy?: Date): {desde:string; hasta:string} {
  const h = hoy || new Date();
  if (clave === "semana") {
    // La semana arranca en lunes: es como se lee una semana de trabajo aquí.
    const dow = (h.getDay() + 6) % 7;              // 0 = lunes
    const ini = new Date(h.getFullYear(), h.getMonth(), h.getDate() - dow);
    const fin = new Date(ini.getFullYear(), ini.getMonth(), ini.getDate() + 6);
    return {desde:_isoLocal(ini), hasta:_isoLocal(fin)};
  }
  const desplaz = clave === "mes_pasado" ? -1 : 0;
  const ini = new Date(h.getFullYear(), h.getMonth() + desplaz, 1);
  const fin = new Date(h.getFullYear(), h.getMonth() + desplaz + 1, 0);
  return {desde:_isoLocal(ini), hasta:_isoLocal(fin)};
}

// ─── REPORTE MENSUAL DE FLOTILLA — DATOS ────────────────────────────────────
// Se alimenta de armarViajesFlotilla: no arma viajes por su cuenta. Y el
// periodo se recorta con filtrarViajesFlotilla, el mismo filtro que usan las dos
// pantallas, para que "los viajes de septiembre" quieran decir lo mismo en el
// reporte y en la bitácora.
//
// Este documento sale de la empresa y puede acabar en una investigación: son
// HECHOS con unidad, fecha y nombre. Sin porcentajes, sin calificaciones y sin
// semáforos —una unidad a la que nadie le ha capturado el seguro no está
// incumpliendo, simplemente no se ha capturado, y decir lo contrario en un
// documento firmado es afirmar algo que no se verificó.
function datosReporteFlotilla(o:{registros:any[]; vehiculos:any[]; anio:number; mes:number}) {
  const {registros, vehiculos, anio, mes} = o;
  const ini = new Date(anio, mes, 1);
  const fin = new Date(anio, mes + 1, 0);
  const viajes = filtrarViajesFlotilla(
    armarViajesFlotilla(registros||[], vehiculos||[]),
    {desde:_isoLocal(ini), hasta:_isoLocal(fin)}
  );
  // Todo lo que va en COLUMNA usa la misma forma; ver la regla en fechaTablaAxis.
  const fmtFecha = (d:Date|null) => d ? fechaTablaAxis(d) : "—";
  const fmtISO   = (s:any) => fechaTablaAxis(s) || String(s||"");
  const fmtHora  = (d:Date|null) => d ? d.toLocaleTimeString("es-MX",{hour:"2-digit",minute:"2-digit"}) : "—";
  const nombreUnidad = (v:any) => v.veh
    ? [v.veh.placa, [v.veh.marca, v.veh.modelo].filter(Boolean).join(" ")].filter(Boolean).join(" · ")
    : (v.placa || "Unidad sin placa");

  // (b) SALIDAS CON DOCUMENTO VENCIDO. El veredicto lo da la MISMA función que
  // usan las dos pantallas; aquí solo se le añade desde cuándo estaba vencido,
  // leyendo la fecha de la ficha de la unidad. No hay un segundo criterio.
  const vencidas:any[] = [];
  viajes.forEach((v)=>{
    if (!v.salida) return;
    const est = estadoDocumentalRegistro(v.salida.m, v.veh, v.salida.d);
    if (est.tipo !== "vencido") return;
    const docs = calcularComplianceVehiculo(v.veh, v.salida.d).documentos
      .filter((d:any)=> d.estado === "vencido")
      .map((d:any)=>({
        label: d.label,
        vencioEl: fmtISO((v.veh as any)?.[d.key]),
        dias: Math.abs(d.dias),
      }));
    vencidas.push({
      unidad: nombreUnidad(v), fecha: fmtFecha(v.salida.d), hora: fmtHora(v.salida.d),
      conductor: v.conductor, destino: v.salida.m.destino || "", docs,
    });
  });
  vencidas.sort((a,b)=> a.fecha.localeCompare(b.fecha));

  // (c) VIAJES SIN REGRESO REGISTRADO Y VIAJES ABIERTOS. Son dos hechos
  // distintos y se cuentan aparte: uno dice que la unidad puede seguir afuera,
  // el otro que el viaje se dio por terminado sin que nadie registrara el
  // regreso. Ninguno de los dos es un incumplimiento.
  const dias = (ms:number) => Math.max(0, Math.floor((Date.now() - ms) / 86400000));
  const abiertos = viajes.filter(v=>v.estado==="abierto").map(v=>({
    unidad: nombreUnidad(v), conductor: v.conductor,
    salida: `${fmtFecha(v.salida?.d||null)} ${fmtHora(v.salida?.d||null)}`,
    destino: v.salida?.m?.destino || "", dias: dias(v.msIni),
  }));
  const sinRegreso = viajes.filter(v=>v.estado==="sin_regreso").map(v=>({
    unidad: nombreUnidad(v), conductor: v.conductor,
    salida: `${fmtFecha(v.salida?.d||null)} ${fmtHora(v.salida?.d||null)}`,
    destino: v.salida?.m?.destino || "", dias: dias(v.msIni),
    cerradoEl: v.cierre?.d ? fmtFecha(v.cierre.d) : "",
  }));

  // (d) y (e) RESÚMENES. Los kilómetros solo salen de viajes con las DOS
  // lecturas; si en una unidad no hubo ninguno, la celda dice "sin dato". Nunca
  // 0 ni un guion: un cero afirma que no se movió.
  const acumular = (clave:(v:ViajeFlotilla)=>string, etiqueta:(v:ViajeFlotilla)=>string) => {
    const map: Record<string, any> = {};
    viajes.forEach((v)=>{
      const k = clave(v) || "—";
      if (!map[k]) map[k] = {etiqueta: etiqueta(v), viajes:0, paradas:0, km:0, conKm:0, rotos:[] as any[]};
      const a = map[k];
      a.viajes++; a.paradas += v.paradas.length;
      // Un viaje con lecturas rotas NO entra en la suma y además se guarda para
      // poder nombrarlo: el patrón necesita saber cuál corregir, no solo que la
      // cifra falta.
      const r = kmDeViajeDetalle(v);
      if (r.estado === "ok") { a.km += r.km; a.conKm++; }
      else if (r.estado === "inconsistente") a.rotos.push({motivo:r.motivo, ini:r.ini, fin:r.fin});
    });
    return Object.keys(map).map(k=>map[k]).sort((a,b)=> b.viajes - a.viajes || a.etiqueta.localeCompare(b.etiqueta));
  };
  const porUnidad = acumular(v=>v.unidadClave, v=>nombreUnidad(v));
  const porConductor = acumular(v=>v.personaClave, v=>v.conductor);

  // (f) VIGENCIAS QUE VENCEN EL MES SIGUIENTE. Sirve para actuar antes, no para
  // calificar: por eso va la fecha y no un estado.
  const iniSig = new Date(anio, mes + 1, 1);
  const finSig = new Date(anio, mes + 2, 0);
  const activos = (vehiculos||[]).filter((v:any)=>(v.status||"activo")==="activo");
  const vigencias:any[] = [];
  activos.forEach((v:any)=>{
    DOCS_VEHICULO.forEach((d:any)=>{
      const val = v[d.key];
      if (!val) return;
      // La fecha se arma LOCAL. new Date("2026-10-15") se interpreta como
      // medianoche UTC y en México se imprime el 14: un documento que sale de la
      // empresa diciendo que un seguro vence un día antes de lo que vence.
      const [yy, mm, dd] = String(val).slice(0,10).split("-").map(Number);
      if (!yy || !mm || !dd) return;
      const f = new Date(yy, mm-1, dd);
      if (isNaN(f.getTime())) return;
      if (f >= iniSig && f <= finSig) vigencias.push({
        unidad: [v.placa, [v.marca, v.modelo].filter(Boolean).join(" ")].filter(Boolean).join(" · "),
        documento: d.label, fecha: fechaTablaAxis(f),
        orden: val,
      });
    });
  });
  vigencias.sort((a,b)=> String(a.orden).localeCompare(String(b.orden)));

  // (g) UNIDADES SIN REGISTRO DOCUMENTAL. Pendiente de captura, no falta.
  const sinCaptura = activos.map((v:any)=>{
    const faltan = calcularComplianceVehiculo(v).documentos
      .filter((d:any)=>d.estado==="sin_registro").map((d:any)=>d.label);
    return faltan.length ? {
      unidad: [v.placa, [v.marca, v.modelo].filter(Boolean).join(" ")].filter(Boolean).join(" · "),
      faltan: faltan.join(", "),
    } : null;
  }).filter(Boolean);

  return {vencidas, abiertos, sinRegreso, porUnidad, porConductor, vigencias, sinCaptura, totalViajes: viajes.length};
}

// ─── REPORTE MENSUAL DE FLOTILLA — DOCUMENTO ────────────────────────────────
// Mismo formato y mismo generador que el reporte mensual de empleados
// (_estiloDocumentoAxis + generarPDFDesdeHTML). No hay un segundo formato.
function construirReporteFlotillaHTML(o:any){
  const vacio = (txt:string) => `<div class="vacio">${_escHtml(txt)}</div>`;
  const tabla = (cabeceras:string[], filas:string[]) =>
    `<table class="t"><thead><tr>${cabeceras.map(h=>`<th>${_escHtml(h)}</th>`).join("")}</tr></thead><tbody>${filas.join("")}</tbody></table>`;

  const secVencidas = o.d.vencidas.length
    ? tabla(["Unidad","Fecha","Hora","Conductor","Documento vencido"],
        o.d.vencidas.map((x:any)=>`<tr><td>${_escHtml(x.unidad)}</td><td>${_escHtml(x.fecha)}</td><td>${_escHtml(x.hora)}</td><td>${_escHtml(x.conductor)}</td><td class="mal">${
          x.docs.map((dd:any)=>`${_escHtml(dd.label)}${dd.vencioEl?` — vencido desde el ${_escHtml(dd.vencioEl)} (${dd.dias} días antes de la salida)`:""}`).join("<br/>")
        }</td></tr>`))
    : vacio("Ninguna salida con documento vencido en el periodo.");

  const secAbiertos = o.d.abiertos.length
    ? tabla(["Unidad","Conductor","Salida","Destino","Días transcurridos"],
        o.d.abiertos.map((x:any)=>`<tr><td>${_escHtml(x.unidad)}</td><td>${_escHtml(x.conductor)}</td><td>${_escHtml(x.salida)}</td><td>${_escHtml(x.destino||"—")}</td><td>${x.dias}</td></tr>`))
    : vacio("Ningún viaje sigue abierto.");

  const secSinRegreso = o.d.sinRegreso.length
    ? tabla(["Unidad","Conductor","Salida","Destino","Se dio por terminado"],
        o.d.sinRegreso.map((x:any)=>`<tr><td>${_escHtml(x.unidad)}</td><td>${_escHtml(x.conductor)}</td><td>${_escHtml(x.salida)}</td><td>${_escHtml(x.destino||"—")}</td><td>${x.cerradoEl ? _escHtml(x.cerradoEl) : `<span class="nd">sin fecha</span>`}</td></tr>`))
    : vacio("Ningún viaje quedó sin regreso registrado en el periodo.");

  // NUNCA se imprime una distancia que el documento no pueda sostener. Cuando
  // el odómetro retrocede o salta lo imposible, la celda dice qué pasó y enseña
  // las dos lecturas crudas: eso es lo que hay que corregir en el registro.
  const nfKm = (n:number) => Number(n).toLocaleString("es-MX");
  const celdaKm = (a:any) => {
    const roto = (a.rotos||[]).length
      ? `<div class="nd" style="margin-top:3px;">lecturas inconsistentes en ${a.rotos.length===1?"un viaje":`${a.rotos.length} viajes`}: ${
          a.rotos.slice(0,3).map((r:any)=>`${nfKm(r.ini)} → ${nfKm(r.fin)}${r.motivo==="retrocede"?" (el odómetro retrocede)":" (salto imposible)"}`).join("; ")
        }</div>`
      : "";
    if (a.conKm === 0) return `<span class="nd">sin dato${(a.rotos||[]).length ? " · lecturas inconsistentes" : ""}</span>${roto}`;
    return `${nfKm(a.km)} km${a.conKm < a.viajes ? ` <span class="nd">(de ${a.conKm} de ${a.viajes} viajes)</span>` : ""}${roto}`;
  };

  const secUnidad = o.d.porUnidad.length
    ? tabla(["Unidad","Viajes","Paradas","Kilómetros recorridos"],
        o.d.porUnidad.map((x:any)=>`<tr><td>${_escHtml(x.etiqueta)}</td><td>${x.viajes}</td><td>${x.paradas}</td><td>${celdaKm(x)}</td></tr>`))
    : vacio("Sin viajes registrados en el periodo.");

  const secConductor = o.d.porConductor.length
    ? tabla(["Conductor","Viajes","Paradas"],
        o.d.porConductor.map((x:any)=>`<tr><td>${_escHtml(x.etiqueta)}</td><td>${x.viajes}</td><td>${x.paradas}</td></tr>`))
    : vacio("Sin viajes registrados en el periodo.");

  const secVigencias = o.d.vigencias.length
    ? tabla(["Unidad","Documento","Vence el"],
        o.d.vigencias.map((x:any)=>`<tr><td>${_escHtml(x.unidad)}</td><td>${_escHtml(x.documento)}</td><td>${_escHtml(x.fecha)}</td></tr>`))
    : vacio("Ninguna vigencia vence el mes siguiente.");

  const secSinCaptura = o.d.sinCaptura.length
    ? tabla(["Unidad","Documentos pendientes de capturar"],
        o.d.sinCaptura.map((x:any)=>`<tr><td>${_escHtml(x.unidad)}</td><td>${_escHtml(x.faltan)}</td></tr>`))
    : vacio("Todas las unidades activas tienen sus fechas capturadas.");

  return `<!doctype html><html><head><meta charset="utf-8"><style>
${_estiloDocumentoAxis()}
    table.t{width:100%;border-collapse:collapse;font-family:Arial,sans-serif;font-size:11px;margin-top:4px;}
    table.t th{text-align:left;background:#0F1D35;color:#fff;padding:6px 8px;font-size:9.5px;text-transform:uppercase;letter-spacing:.4px;font-weight:700;}
    table.t td{padding:6px 8px;border-bottom:1px solid #e6e6e6;color:#222;vertical-align:top;line-height:1.5;}
    table.t td.mal{color:#b3261e;font-weight:700;}
    .nd{color:#888;font-style:italic;font-weight:400;}
  </style></head><body><div class="doc">
    <div class="head"><div style="font-family:Arial,sans-serif;"><div style="font-size:15px;font-weight:800;color:#0F1D35;">${_escHtml(o.empresa||"")}</div>${o.rfc ? `<div style="font-size:10px;color:#333;margin-top:2px;">RFC ${_escHtml(o.rfc)}</div>` : ""}${o.domicilio ? `<div style="font-size:9.5px;color:#666;margin-top:2px;max-width:330px;line-height:1.45;">${_escHtml(o.domicilio)}</div>` : ""}</div><div class="htag">Documento interno<br/>Generado el ${_escHtml(o.generadoEn)}</div></div>
    <h1>Reporte mensual de flotilla</h1>
    <div class="meta"><div><b>Empresa:</b> ${_escHtml(o.empresa||"—")}</div><div><b>Periodo:</b> ${_escHtml(o.mes)}</div><div><b>Generado por:</b> ${_escHtml(o.generadoPor||"—")}</div><div><b>Viajes en el periodo:</b> ${o.d.totalViajes}</div></div>

    <section><h2>Salidas con documento vencido</h2>
      <div class="hint">Unidades que salieron a circular con una vigencia vencida A LA FECHA DE LA SALIDA. Es el hecho que este reporte existe para dejar constancia.</div>
      ${secVencidas}</section>

    <section><h2>Viajes que siguen abiertos</h2>
      <div class="hint">Salieron y todavía no registran regreso. Puede ser que la unidad siga fuera o que falte cerrar el viaje; no se ha dado por terminado ninguno automáticamente.</div>
      ${secAbiertos}</section>

    <section><h2>Viajes sin regreso registrado</h2>
      <div class="hint">El conductor salió después en otra unidad, así que el viaje se dio por terminado sin registrar el regreso. No se inventó una hora de regreso.</div>
      ${secSinRegreso}</section>

    <section><h2>Resumen por unidad</h2>
      <div class="hint">Los kilómetros solo se suman cuando existen las dos lecturas del odómetro, la de salida y la de regreso.</div>
      ${secUnidad}</section>

    <section><h2>Resumen por conductor</h2>${secConductor}</section>

    <section><h2>Vigencias que vencen el mes siguiente</h2>
      <div class="hint">Para actuar antes de que ocurra.</div>
      ${secVigencias}</section>

    <section><h2>Unidades pendientes de capturar</h2>
      <div class="hint">Estas unidades no tienen todas sus fechas capturadas en la plataforma. Es información que falta registrar, no un incumplimiento: sin la fecha no se puede afirmar nada sobre esos documentos.</div>
      ${secSinCaptura}</section>

    <div class="pie">${_escHtml(pieDelPatronTexto({denominacion:o.empresa||""} as any, o.generadoEn, MARCA_EDICION_FLOTILLA))}</div>
  </div></body></html>`;
}
// ─── ESTILO DE LOS DOCUMENTOS DE AXIS ───────────────────
// UN solo formato para los documentos que salen de la plataforma. Este bloque
// vivía dentro del reporte mensual de empleados; se extrae TAL CUAL para que el
// reporte de flotilla use EL MISMO y no una copia que se vaya separando sola.
// MARCA DE EDICIÓN. Los documentos generados antes de este cambio y los de
// ahora dicen cosas distintas del MISMO periodo: los viejos afirmaban faltas que
// nadie registró y un porcentaje documental que no variaba por mes. Que se
// puedan distinguir en la cara del papel, no solo por la hora de generación.
const MARCA_EDICION_DOCS = "Edición 2 · criterio de asistencia por registro";
// El de flotilla lleva la SUYA, no la de asistencia: cada familia de documentos
// declara qué cambió en ella. Antes las vigencias se comparaban contra la
// medianoche UTC y un documento vigente podía salir listado como vencido; dos PDF
// del mismo mes dicen ahora cosas distintas y tienen que distinguirse en la cara
// del papel, sin que el documento tenga que disculparse de sí mismo.
const MARCA_EDICION_FLOTILLA = "Edición 2 — vigencias por día local";

function _estiloDocumentoAxis(): string {
  return `
    *{box-sizing:border-box;} body{margin:0;font-family:Georgia,'Times New Roman',serif;color:#1a1a2e;background:#fff;}
    .doc{padding:34px 40px;}
    .head{border-bottom:2px solid #B8932A;padding-bottom:12px;margin-bottom:16px;display:flex;justify-content:space-between;align-items:flex-end;}
    .wm{font-size:20px;font-weight:800;color:#0F1D35;letter-spacing:.3px;} .wm span{color:#B8932A;}
    .wm-sub{font-size:9.5px;color:#666;font-family:Arial,sans-serif;margin-top:2px;letter-spacing:1.2px;text-transform:uppercase;}
    .htag{font-size:10px;color:#666;font-family:Arial,sans-serif;text-align:right;line-height:1.5;}
    h1{font-size:18px;color:#0F1D35;margin:0 0 10px;}
    .meta{font-size:12px;color:#333;font-family:Arial,sans-serif;line-height:1.7;margin-bottom:6px;} .meta b{color:#0F1D35;}
    section{margin-top:18px;} h2{font-family:Georgia,serif;font-size:15px;color:#0F1D35;border-bottom:1px solid #B8932A;padding-bottom:5px;margin:0 0 10px;}
    h2 .sub{font-family:Arial,sans-serif;font-size:11px;color:#888;font-weight:400;}
    .big{font-size:30px;font-weight:800;color:#0F1D35;font-family:Georgia,serif;line-height:1;}
    .desg{font-size:12px;color:#333;font-family:Arial,sans-serif;margin-top:4px;}
    .vacio{font-size:12px;color:#777;font-style:italic;font-family:Arial,sans-serif;}
    .hint{font-size:10.5px;color:#666;font-family:Arial,sans-serif;margin-bottom:9px;}
    .bar{height:9px;border:1px solid #999;border-radius:6px;overflow:hidden;background:#fff;margin-top:6px;max-width:300px;} .bar .fill{height:100%;background:#0F1D35;}
    .rgrid{display:flex;gap:26px;flex-wrap:wrap;font-family:Arial,sans-serif;} .rgrid div{font-size:11px;color:#555;} .rgrid b{font-size:22px;color:#0F1D35;display:block;font-family:Georgia,serif;}
    .acc{margin:2px 0 0;padding-left:18px;font-family:Arial,sans-serif;font-size:11.5px;color:#222;line-height:1.75;}
    .acc-total{font-family:Arial,sans-serif;font-size:11.5px;color:#333;margin:0 0 4px;}
    .acc-sub{font-family:Arial,sans-serif;font-size:11.5px;color:#555;margin:10px 0 2px;font-weight:700;}
    .firmas{display:flex;gap:44px;margin-top:52px;} .firma{flex:1;text-align:center;} .firma .sp{height:46px;} .firma .linea{border-top:1px solid #333;} .firma .rol{font-size:11px;color:#333;font-family:Arial,sans-serif;margin-top:6px;} .firma .nom{font-size:10px;color:#777;font-family:Arial,sans-serif;margin-top:2px;}
    .pie{margin-top:26px;text-align:center;font-size:9.5px;color:#999;font-family:Arial,sans-serif;}
`;
}

// ── REGISTRO MENSUAL DE ASISTENCIA Y ACTIVIDADES (PDF) ─────────────────────
// Se llamaba "Reporte mensual de desempeño" y evaluaba a la persona. Ahora
// describe lo que contiene: registros. El cambio no es de estilo — un documento
// firmado que califica el desempeño con datos que el sistema no puede sostener
// es una base documental fabricada.
//
// Lo que salió de aquí, y por qué:
//   · "Faltas". El sistema no sabe si alguien faltó, sabe si hay registro. Ver
//     clasificarDiaChecador: esa palabra ya no existe en la plataforma salvo que
//     hubiera un registro POSITIVO de inasistencia, y no lo hay.
//   · Los PORCENTAJES y las BARRAS. Se quitaron de todo el producto y habían
//     sobrevivido justo en el único documento que se firma.
//   · "Cumplimiento documental". Integrar el expediente es obligación del
//     patrón: ese renglón le atribuía al trabajador un incumplimiento ajeno, y
//     además era el MISMO dato bajo encabezados de meses distintos, porque se
//     calculaba sobre el expediente de hoy y no sobre el mes del reporte.
// ═══ UN ACCIDENTE EN EL REGISTRO MENSUAL ══════════════════════════════════════
// Lo que consta en la plataforma, y nada más:
//   · el REGISTRO: quién (si consta: hoy solo lo registra el trabajador) y cuándo,
//     con la hora del servidor leída en México; y la fecha DECLARADA de los hechos
//     si la hay y es otro día (es la que decide en qué mes cae);
//   · el TIPO, "según el registro" (nada de lesiones: ver la plantilla);
//   · el ESTADO DE LA ATENCIÓN, de la misma fuente que la pantalla
//     (estadoAtencionAccidente y el historial `atencion`): pendiente, marcado como
//     atendido por el patrón —nunca "atendido" a secas: no es atención médica—,
//     reabierto, o cancelado con su motivo.
// Sin relato, sin gravedad, sin número ni nombres de lesionados.
function _fechaLargaMexico(v:any): string {
  const d = fechaDeCualquiera(v);
  const mx = d ? enHoraDeMexico(d) : null;
  return mx ? fechaLargaAxis(mx) : "";
}
function estadoAccidenteRegistroMensual(a:any): string {
  const e = entradasDeAtencion(a);
  const u = e[e.length - 1];
  const estado = estadoAtencionAccidente(a);
  const f = u ? _fechaLargaMexico(u.en) : "";
  const el = f ? " el " + f : "";
  if (estado === "cancelado") return `Cancelado por el patrón${el}. Motivo: ${String(u?.motivo || "").trim() || "no consta"}`;
  if (estado === "atendido") return `Marcado como atendido por el patrón${el}`;
  if (u && u.accion === "reabierto") return `Reabierto${el}; pendiente de atención`;
  return "Pendiente de atención";
}
function renglonAccidenteRegistroMensual(a:any): {cancelado:boolean; texto:string} {
  const partes: string[] = [];
  const reg = fechaDeCualquiera(a?.timestamp);
  const mx = reg ? enHoraDeMexico(reg) : null;
  const quien = a?.registradoPorTrabajador === true ? " por el trabajador" : "";
  partes.push(mx
    ? `Registrado${quien} el ${fechaLargaAxis(mx)} a las ${String(mx.getHours()).padStart(2,"0")}:${String(mx.getMinutes()).padStart(2,"0")}`
    : `Registrado${quien} (sin fecha de registro)`);
  const fh = String(a?.fechaHechos || "").slice(0, 10);
  if (/^\d{4}-\d{2}-\d{2}$/.test(fh) && (!mx || fh !== _isoDia(mx))) partes.push(`Hechos declarados para el ${fechaLargaAxis(fh)}`);
  // EL TIPO, según el registro. ⚠️ NADA DE LESIONES NI DE SALUD (decisión del
  // 30-sep, confirmada el 7-oct): ni con/sin lesionados, ni "sin confirmar", ni
  // cuándo se corrigió esa respuesta. Es dato sensible en un papel que se firma y
  // circula, y este registro no lo necesita. `prueba-reporte-sin-salud` lo vigila.
  const tipo = rotuloTipoAccidente(a?.tipoEvento);
  if (tipo) partes.push(`${tipo}, según el registro`);
  partes.push(estadoAccidenteRegistroMensual(a));
  return { cancelado: estadoAtencionAccidente(a) === "cancelado", texto: partes.join(". ") + "." };
}
// EL TOTAL: solo los no cancelados son accidentes del periodo.
function totalAccidentesRegistroMensual(n:number, cancelados:number): string {
  const acc = `${n} accidente${n === 1 ? "" : "s"} registrado${n === 1 ? "" : "s"}`;
  return cancelados ? `${acc}; ${cancelados} registro${cancelados === 1 ? "" : "s"} cancelado${cancelados === 1 ? "" : "s"}` : acc;
}
function construirReporteMensualHTML(o:any){
  // LOS ACCIDENTES, CON LO QUE CONSTA (decisión de Iván, 6-oct-2026). El
  // trabajador FIRMA de recibido este papel: no puede listar como accidente uno
  // que el patrón canceló, ni callar en qué estado está. Cada renglón lo arma
  // `renglonAccidenteRegistroMensual`: quién y cuándo lo registró, la fecha
  // declarada si es otro día, el tipo y el estado de la atención.
  //
  // ⚠️ NADA DE SALUD (decisión del 30-sep, confirmada el 7-oct): ni gravedad, ni
  // con/sin lesionados, ni su número, ni nombres, ni el relato. Es dato sensible
  // en un documento que se firma y circula, y no hace falta para su propósito.
  //
  // LOS CANCELADOS VAN APARTE, bajo "Registros cancelados por el patrón", y no
  // cuentan en el total de accidentes del periodo.
  const accs = (o.accidentes||[]) as {cancelado:boolean; texto:string}[];
  const vigentes = accs.filter((a)=> !a.cancelado), cancelados = accs.filter((a)=> a.cancelado);
  const lista = (xs:{texto:string}[]) => `<ul class="acc">${xs.map((a)=>`<li>${_escHtml(a.texto)}</li>`).join("")}</ul>`;
  const accHTML = accs.length
    ? `<div class="acc-total">${_escHtml(totalAccidentesRegistroMensual(vigentes.length, cancelados.length))}</div>`
      + (vigentes.length ? lista(vigentes) : `<div class="vacio">Sin accidentes registrados en el periodo.</div>`)
      + (cancelados.length ? `<h3 class="acc-sub">Registros cancelados por el patrón</h3>${lista(cancelados)}` : "")
    : `<div class="vacio">Sin accidentes registrados en el periodo.</div>`;

  // ASISTENCIA. Hechos, y solo los que se pueden sostener.
  const a = o.asis || {};
  const filaHecho = (n:number, txt:string) => `<li><b>${n}</b> ${_escHtml(txt)}</li>`;
  let asisHTML = "";
  if (a.hayAsistencia === false) {
    // Ni una sola checada suya en el periodo. No se imprime ningún conteo ni se
    // calculan faltas: veintiún ceros se leen como veintiuna faltas, y este
    // documento se firma. Se dice lo que consta, que es que no consta nada.
    asisHTML = `<div class="vacio">No existen registros de asistencia de este empleado en el periodo.</div>`;
  } else {
    const detalle = [
      a.aTiempo ? `${a.aTiempo} a tiempo` : "",
      a.retardos ? `${a.retardos} con retardo` : "",
      a.tardias ? `${a.tardias} con entrada tardía` : "",
    ].filter(Boolean).join(" · ");
    const partes = [
      filaHecho(a.conRegistro||0, (a.conRegistro===1?"día con registro de entrada":"días con registro de entrada") + (detalle?` (${detalle})`:"")),
    ];
    if (a.diasConAgregados) partes.push(filaHecho(a.diasConAgregados, a.diasConAgregados===1?"día incluye registros agregados por el patrón":"días incluyen registros agregados por el patrón"));
    if (a.hayLaborables) {
      partes.push(filaHecho(a.sinRegistro||0, a.sinRegistro===1?"día laborable sin registro":"días laborables sin registro"));
      if (a.vacaciones) partes.push(filaHecho(a.vacaciones, a.vacaciones===1?"día de vacaciones registradas":"días de vacaciones registradas"));
      if (a.descansos74) partes.push(filaHecho(a.descansos74, a.descansos74===1?"día de descanso obligatorio":"días de descanso obligatorio"));
    }
    asisHTML = `<ul class="hechos">${partes.join("")}</ul>`;
    // ANTES DEL INGRESO Y DESPUÉS DE LA BAJA (de la ficha): esos días no se
    // cuentan, y se dice; y los registros que constan en ellos, con su fecha.
    (a.avisosRelacion||[]).forEach((t:string)=>{ asisHTML += `<div class="hint">${_escHtml(t)}</div>`; });
    const fuera = (a.registrosFueraDeRelacion||[]) as {iso:string; relacion:string}[];
    (["antes_ingreso","despues_baja"] as const).forEach((r)=>{
      const fs = fuera.filter((x)=> x.relacion === r).map((x)=> fechaLargaAxis(x.iso));
      if (fs.length) asisHTML += `<div class="hint">${_escHtml(`${notaRelacionLaboral(r)}: ${fs.join(", ")}.`)}</div>`;
    });
    if (o.avisoHorario) asisHTML += `<div class="aviso">${_escHtml(o.avisoHorario)}</div>`;
    (o.avisosLugar||[]).forEach((a:string)=>{ asisHTML += `<div class="aviso">${_escHtml(a)}</div>`; });
    if (o.criterio && o.criterio.length) {
      asisHTML += `<div class="criterio"><b>Cómo se clasifica cada entrada</b><ul>${o.criterio.map((c:string)=>`<li>${_escHtml(c)}</li>`).join("")}</ul></div>`;
    } else {
      asisHTML += `<div class="aviso">Este empleado no tiene hora de entrada configurada, así que las entradas registradas no se pudieron clasificar.</div>`;
    }
    if (!a.hayLaborables) {
      // Un hecho con destino, no un hueco mudo.
      asisHTML += `<div class="aviso">No hay días laborables configurados para este empleado, así que no es posible determinar qué días eran laborables.
        Configura los días laborables de este empleado en su horario para que este apartado pueda calcularse.</div>`;
    }
    if (a.anioSinCatalogo) {
      asisHTML += `<div class="aviso">No se pudieron determinar los días de descanso obligatorio de ${a.anioSinCatalogo}: el catálogo del Art. 74 LFT de la plataforma no cubre ese año.</div>`;
    }
  }
  // Las notas de la razón social explican el encabezado: salen haya o no registros (13-oct-2026).
  (o.notasRazon||[]).forEach((n:string)=>{ asisHTML += `<div class="aviso">${_escHtml(n)}</div>`; });
  // Las correcciones del periodo, haya o no asistencia que contar: si se anularon
  // todas sus checadas, el papel dice que no constan registros Y por qué.
  asisHTML += seccionCorreccionesHTML(o.correcciones);
  asisHTML += seccionCorreccionesAnterioresHTML(o.correccionesAnteriores);

  // ACTIVIDADES. Dos hechos separados, nunca un cociente: la demora del patrón
  // en confirmar no puede contar contra el trabajador.
  const ta = o.tareas || {};
  const tareasHTML = ta.total > 0
    ? `<ul class="hechos">
        <li><b>${ta.terminadas}</b> de ${ta.total} ${ta.total===1?"actividad marcada":"actividades marcadas"} como ${ta.terminadas===1?"terminada":"terminadas"} por el trabajador</li>
        <li><b>${ta.confirmadas}</b> ${ta.confirmadas===1?"confirmada":"confirmadas"} por el patrón</li>
      </ul>`
    : `<div class="vacio">Sin actividades con plazo dentro del periodo.</div>`;

  return `<!doctype html><html><head><meta charset="utf-8"><style>
${_estiloDocumentoAxis()}
    ul.hechos{margin:2px 0 0;padding-left:18px;font-family:Arial,sans-serif;font-size:12.5px;color:#222;line-height:1.9;}
    ul.hechos b{font-size:15px;color:#0F1D35;}
    .criterio{margin-top:10px;font-family:Arial,sans-serif;font-size:11px;color:#555;border:1px solid #e0e0e0;border-radius:8px;padding:8px 12px;line-height:1.65;}
    .criterio b{color:#0F1D35;} .criterio ul{margin:4px 0 0;padding-left:16px;}
    .aviso{margin-top:9px;font-family:Arial,sans-serif;font-size:11.5px;color:#8a6d1a;background:rgba(184,147,42,0.10);border:1px solid rgba(184,147,42,0.30);border-radius:8px;padding:8px 10px;line-height:1.55;}
    .nota-firma{margin-top:40px;font-family:Arial,sans-serif;font-size:11px;color:#444;line-height:1.6;}
    .corte{margin-top:16px;font-family:Arial,sans-serif;font-size:10.5px;color:#444;border-top:1px solid #e0e0e0;padding-top:8px;line-height:1.55;}
    .firma .ack{font-family:Arial,sans-serif;font-size:10px;color:#666;margin-top:3px;}
    .firma .fch{font-family:Arial,sans-serif;font-size:10px;color:#888;margin-top:10px;}
    .edic{font-family:Arial,sans-serif;font-size:9.5px;color:#8a6d1a;}
  </style></head><body><div class="doc">
    <div class="head"><div style="font-family:Arial,sans-serif;"><div style="font-size:15px;font-weight:800;color:#0F1D35;">${_escHtml(o.empresa||"")}</div>${o.rfc ? `<div style="font-size:10px;color:#333;margin-top:2px;">RFC ${_escHtml(o.rfc)}</div>` : ""}${o.domicilio ? `<div style="font-size:9.5px;color:#666;margin-top:2px;max-width:330px;line-height:1.45;">${_escHtml(o.domicilio)}</div>` : ""}</div><div class="htag">Registro mensual<br/>de asistencia y actividades</div></div>
    <h1>Registro mensual de asistencia y actividades</h1>
    <div class="meta"><div><b>Empresa:</b> ${_escHtml(o.empresa||"—")}</div><div><b>Empleado:</b> ${_escHtml(o.empleado||"—")}</div><div><b>Periodo:</b> ${_escHtml(o.periodo)}</div></div>

    <section><h2>Asistencia · checador</h2>
      <div class="hint">Lo que consta en el checador. La plataforma registra entradas: no registra inasistencias, así que no las afirma.</div>
      ${asisHTML}</section>

    <section><h2>Actividades <span class="sub">· con plazo dentro del periodo</span></h2>${tareasHTML}</section>

    <section><h2>Accidentes del periodo</h2>${accHTML}</section>

    ${o.notaCorte ? `<div class="corte">${_escHtml(o.notaCorte)}</div>` : ""}
    <div class="nota-firma">La firma acredita la recepción del documento, no conformidad con su contenido.</div>
    <div class="firmas">
      <div class="firma"><div class="sp"></div><div class="linea"></div><div class="rol">Firma del trabajador</div><div class="nom">${_escHtml(o.empleado||"")}</div><div class="ack">Recibí copia de este registro</div><div class="fch">Fecha: _______________</div></div>
      <div class="firma"><div class="sp"></div><div class="linea"></div><div class="rol">Firma del patrón</div><div class="nom">${firmaDelPatronHTML(o.empresa, o.rfc, o.tipoPersona)}</div><div class="ack">Entregué copia</div><div class="fch">Fecha: _______________</div></div>
    </div>
    <div class="pie">${_escHtml(pieDelPatronTexto({denominacion:o.empresa||""} as any, o.generadoEn, MARCA_EDICION_DOCS))}</div>
  </div></body></html>`;
}

// ── ACTA / CONSTANCIA DE VACACIONES (PDF) — documento emitido por AXIS (membrete
//   arriba, mismo estilo que la bitácora/reporte mensual). Se genera por CADA toma
//   registrada: muestra el detalle de esta toma + la foto del periodo (días que le
//   tocan, gozados acumulados incluyendo esta toma, y pendientes) + líneas de firma
//   FÍSICA (nada de firma digital). Reutiliza _axisLogoImgHTML/_escHtml existentes.
function construirActaVacacionesHTML(o:any){
  const dias = Number(o.diasEstaToma)||0;
  const ctxLinea = o.completo
    ? `Con esta toma <b>completa la totalidad</b> de los ${o.diasPeriodo} días que le corresponden en este periodo.`
    : `Le quedan <b>${o.pend}</b> día${o.pend===1?"":"s"} pendiente${o.pend===1?"":"s"} por disfrutar de este periodo.`;
  return `<!doctype html><html><head><meta charset="utf-8"><style>
    *{box-sizing:border-box;} body{margin:0;font-family:Georgia,'Times New Roman',serif;color:#1a1a2e;background:#fff;}
    .doc{padding:34px 40px;}
    .head{border-bottom:2px solid #B8932A;padding-bottom:12px;margin-bottom:16px;display:flex;justify-content:space-between;align-items:flex-end;}
    .wm{font-size:20px;font-weight:800;color:#0F1D35;letter-spacing:.3px;} .wm span{color:#B8932A;}
    .wm-sub{font-size:9.5px;color:#666;font-family:Arial,sans-serif;margin-top:2px;letter-spacing:1.2px;text-transform:uppercase;}
    .htag{font-size:10px;color:#666;font-family:Arial,sans-serif;text-align:right;line-height:1.5;}
    h1{font-size:18px;color:#0F1D35;margin:0 0 10px;}
    .meta{font-size:12px;color:#333;font-family:Arial,sans-serif;line-height:1.7;margin-bottom:14px;} .meta b{color:#0F1D35;}
    .intro{font-size:12px;color:#333;font-family:Arial,sans-serif;line-height:1.7;margin-bottom:4px;}
    section{margin-top:16px;border:1px solid #ccc;border-radius:8px;padding:12px 16px;font-family:Arial,sans-serif;}
    section h2{font-family:Georgia,serif;font-size:14px;color:#0F1D35;margin:0 0 8px;}
    .row{font-size:12px;color:#333;line-height:1.85;} .row b{color:#0F1D35;}
    .rgrid{display:flex;gap:26px;flex-wrap:wrap;margin-top:6px;} .rgrid div{font-size:11px;color:#555;} .rgrid b{font-size:19px;color:#0F1D35;display:block;}
    .fund{margin-top:14px;font-size:10px;color:#777;font-family:Arial,sans-serif;line-height:1.6;font-style:italic;}
    .firmas{display:flex;gap:44px;margin-top:52px;} .firma{flex:1;text-align:center;} .firma .sp{height:46px;} .firma .linea{border-top:1px solid #333;} .firma .rol{font-size:11px;color:#333;font-family:Arial,sans-serif;margin-top:6px;} .firma .nom{font-size:10px;color:#777;font-family:Arial,sans-serif;margin-top:2px;}
    .pie{margin-top:26px;text-align:center;font-size:9.5px;color:#999;font-family:Arial,sans-serif;}
  </style></head><body><div class="doc">
    <div class="head"><div style="font-family:Arial,sans-serif;"><div style="font-size:15px;font-weight:800;color:#0F1D35;">${_escHtml(o.empresa||"")}</div>${o.rfc ? `<div style="font-size:10px;color:#333;margin-top:2px;">RFC ${_escHtml(o.rfc)}</div>` : ""}${o.domicilio ? `<div style="font-size:9.5px;color:#666;margin-top:2px;max-width:330px;line-height:1.45;">${_escHtml(o.domicilio)}</div>` : ""}</div><div class="htag">Constancia de disfrute<br/>de vacaciones</div></div>
    <h1>Constancia de disfrute de vacaciones</h1>
    <div class="meta"><div><b>Empresa:</b> ${_escHtml(o.empresa||"—")}</div><div><b>Empleado:</b> ${_escHtml(o.empleado||"—")}</div><div><b>Puesto:</b> ${_escHtml(o.puesto||"—")}</div><div><b>Fecha de ingreso:</b> ${_escHtml(o.fechaIngreso||"—")}</div></div>
    <div class="intro">Por medio de la presente se hace constar que el trabajador disfrutó de los días de vacaciones que se detallan a continuación, correspondientes a su periodo vacacional.</div>
    <section><h2>Detalle de esta toma</h2>
      <div class="row"><b>Días gozados en esta toma:</b> ${dias} día${dias===1?"":"s"}</div>
      <div class="row"><b>Fecha registrada:</b> ${_escHtml(o.fechaToma||"—")}</div>
      ${o.nota?`<div class="row"><b>Nota:</b> ${_escHtml(o.nota)}</div>`:""}
    </section>
    <section><h2>Situación del periodo</h2>
      <div class="row"><b>Periodo:</b> aniversario N.° ${_escHtml(String(o.anios??"—"))} · derecho generado el ${_escHtml(o.periodoDesde||"—")}</div>
      <div class="rgrid"><div><b>${o.diasPeriodo}</b>Días del periodo</div><div><b>${o.gozado}</b>Gozados (incluye esta toma)</div><div><b>${o.completo?0:o.pend}</b>Pendientes</div></div>
      <div class="row" style="margin-top:8px;">${ctxLinea}</div>
    </section>
    <div class="fund">Documento de control interno; la firma de ambas partes se realiza de forma física.</div>
    ${bloqueDeNotasHTML(o.notas)}
    <div class="firmas"><div class="firma"><div class="sp"></div><div class="linea"></div><div class="rol">Firma del trabajador</div><div class="nom">${_escHtml(o.empleado||"")}</div></div><div class="firma"><div class="sp"></div><div class="linea"></div><div class="rol">Firma del patrón</div><div class="nom">${firmaDelPatronHTML(o.patron, o.rfc, o.tipoPersona)}</div></div></div>
    <div class="pie">${_escHtml(pieDelPatronTexto({denominacion:o.empresa||""} as any, o.generadoEn))}</div>
  </div></body></html>`;
}

// ── CONSTANCIA DE PAGO DE AGUINALDO (PDF) — documento emitido por AXIS, mismo estilo
//   que el acta de vacaciones. SECUNDARIO/opcional: el aguinaldo se comprueba fiscalmente
//   con el recibo de nómina (CFDI); esta constancia es un comprobante complementario.
function construirConstanciaAguinaldoHTML(o:any){
  const dEmp = Number(o.diasEmpresa)||0;
  const diasTxt = (o.diasQueCorresponden!=null)
    ? `${(Math.round(o.diasQueCorresponden*10)/10)} de ${dEmp}${o.proporcional?" (proporcional, ingresó este año)":""}`
    : `${dEmp}`;
  const money = (n:number)=> (Number(n)||0).toLocaleString("es-MX",{style:"currency",currency:"MXN",maximumFractionDigits:2});
  return `<!doctype html><html><head><meta charset="utf-8"><style>
    *{box-sizing:border-box;} body{margin:0;font-family:Georgia,'Times New Roman',serif;color:#1a1a2e;background:#fff;}
    .doc{padding:34px 40px;}
    .head{border-bottom:2px solid #B8932A;padding-bottom:12px;margin-bottom:16px;display:flex;justify-content:space-between;align-items:flex-end;}
    .wm{font-size:20px;font-weight:800;color:#0F1D35;letter-spacing:.3px;} .wm span{color:#B8932A;}
    .wm-sub{font-size:9.5px;color:#666;font-family:Arial,sans-serif;margin-top:2px;letter-spacing:1.2px;text-transform:uppercase;}
    .htag{font-size:10px;color:#666;font-family:Arial,sans-serif;text-align:right;line-height:1.5;}
    h1{font-size:18px;color:#0F1D35;margin:0 0 10px;}
    .meta{font-size:12px;color:#333;font-family:Arial,sans-serif;line-height:1.7;margin-bottom:14px;} .meta b{color:#0F1D35;}
    .intro{font-size:12px;color:#333;font-family:Arial,sans-serif;line-height:1.7;margin-bottom:4px;}
    section{margin-top:16px;border:1px solid #ccc;border-radius:8px;padding:12px 16px;font-family:Arial,sans-serif;}
    section h2{font-family:Georgia,serif;font-size:14px;color:#0F1D35;margin:0 0 8px;}
    .row{font-size:12px;color:#333;line-height:1.85;} .row b{color:#0F1D35;}
    .big{font-size:24px;font-weight:800;color:#0F1D35;font-family:Georgia,serif;margin-top:4px;}
    .fund{margin-top:14px;font-size:10px;color:#777;font-family:Arial,sans-serif;line-height:1.6;font-style:italic;}
    .cfdi{margin-top:8px;font-size:10.5px;color:#555;font-family:Arial,sans-serif;line-height:1.6;background:#f6f4ee;border:1px solid #e6e0cf;border-radius:7px;padding:9px 12px;}
    .firmas{display:flex;gap:44px;margin-top:52px;} .firma{flex:1;text-align:center;} .firma .sp{height:46px;} .firma .linea{border-top:1px solid #333;} .firma .rol{font-size:11px;color:#333;font-family:Arial,sans-serif;margin-top:6px;} .firma .nom{font-size:10px;color:#777;font-family:Arial,sans-serif;margin-top:2px;}
    .pie{margin-top:26px;text-align:center;font-size:9.5px;color:#999;font-family:Arial,sans-serif;}
  </style></head><body><div class="doc">
    <div class="head"><div style="font-family:Arial,sans-serif;"><div style="font-size:15px;font-weight:800;color:#0F1D35;">${_escHtml(o.empresa||"")}</div>${o.rfc ? `<div style="font-size:10px;color:#333;margin-top:2px;">RFC ${_escHtml(o.rfc)}</div>` : ""}${o.domicilio ? `<div style="font-size:9.5px;color:#666;margin-top:2px;max-width:330px;line-height:1.45;">${_escHtml(o.domicilio)}</div>` : ""}</div><div class="htag">Constancia de pago<br/>de aguinaldo</div></div>
    <h1>Constancia de pago de aguinaldo</h1>
    <div class="meta"><div><b>Empresa:</b> ${_escHtml(o.empresa||"—")}</div><div><b>Empleado:</b> ${_escHtml(o.empleado||"—")}</div><div><b>Puesto:</b> ${_escHtml(o.puesto||"—")}</div><div><b>Año:</b> ${_escHtml(String(o.anio??"—"))}</div></div>
    <div class="intro">Por medio de la presente se hace constar que el trabajador recibió el pago de su aguinaldo correspondiente al año que se indica.</div>
    <section><h2>Detalle del pago</h2>
      <div class="row"><b>Días de aguinaldo:</b> ${diasTxt}</div>
      <div class="row"><b>Fecha de pago:</b> ${_escHtml(o.fechaPago||"—")}</div>
      <div class="row"><b>Monto pagado:</b></div>
      <div class="big">${money(o.monto)}</div>
    </section>
    <div class="fund">Documento de control interno; la firma de ambas partes se realiza de forma física.</div>
    <div class="cfdi"><b>Nota:</b> el aguinaldo se comprueba fiscalmente con el recibo de nómina (CFDI). Esta constancia es un comprobante complementario de pago; no sustituye el recibo.</div>
    ${bloqueDeNotasHTML(o.notas)}
    <div class="firmas"><div class="firma"><div class="sp"></div><div class="linea"></div><div class="rol">Firma del trabajador</div><div class="nom">${_escHtml(o.empleado||"")}</div></div><div class="firma"><div class="sp"></div><div class="linea"></div><div class="rol">Firma del patrón</div><div class="nom">${firmaDelPatronHTML(o.patron, o.rfc, o.tipoPersona)}</div></div></div>
    <div class="pie">${_escHtml(pieDelPatronTexto({denominacion:o.empresa||""} as any, o.generadoEn))}</div>
  </div></body></html>`;
}

function ReporteMensualBoton({empleado, checadas, correcciones, tareas, accidentes, currentUser, tema, fontSans}:{empleado:any; checadas:any[]; correcciones?:any[]; tareas:any[]; accidentes?:any[]|null; currentUser:any; tema:"navy"|"light"; fontSans:string}) {
  // El mes: por omisión, el en curso; cualquier otro desde el primer registro.
  const [mesSel,setMesSel]=useState<{anio:number; mes0:number}>(()=> ({anio: new Date().getFullYear(), mes0: new Date().getMonth()}));
  const primeroDisponible = primerMesDelEmpleado(empleado, checadas, correcciones);
  const [gen,setGen]=useState(false); const [env,setEnv]=useState(false); const [msg,setMsg]=useState("");
  const [ultimoEnvio,setUltimoEnvio]=useState<Date|null>(null);
  // Quien firma este registro. Sin denominacion no se emite.
  const dp = useDatosPatron(currentUser?.uid);
  const T = tema==="navy"
    ? {gold:"#D4A843", line:"rgba(184,147,42,0.30)", ink:"#ECE6D8", inkSoft:"rgba(236,230,216,0.62)", inputBg:"rgba(255,255,255,0.05)", dark:true}
    : {gold:T_LIGHT.gold, line:T_LIGHT.border, ink:T_LIGHT.textInk, inkSoft:T_LIGHT.textInkSoft, inputBg:T_LIGHT.canvasSoft, dark:false};
  const email = (empleado?.email||"").toLowerCase().trim();
  // Último envío mensual de este empleado (un solo where por empleadorId; filtra en JS).
  useEffect(()=>{ let cancel=false; (async()=>{
    try { const snap=await getDocs(query(collection(db,"reportes"), where("empleadorId","==",currentUser.uid)));
      if (cancel) return;
      const mios=snap.docs.map((d:any)=>d.data()).filter((r:any)=>(r.trabajadorEmail||"").toLowerCase()===email && r.tipo==="mensual");
      const ult=mios.map((r:any)=>r.fechaEnvio?.toDate?.()).filter(Boolean).sort((a:any,b:any)=>b-a)[0]||null;
      setUltimoEnvio(ult);
    } catch(e){ /* silencioso */ }
  })(); return ()=>{cancel=true;}; /* eslint-disable-next-line */ }, [email]);
  const construir = async ()=>{
    // EL CANDADO, igual que en la bitacora quincenal: la UI lo impide antes,
    // y esto cierra la puerta a cualquier ruta futura.
    if (!datosPatronCompletos(dp.cfg)) { abrirDatosDelPatron(); throw errorParaMostrar("Faltan los datos de tu empresa."); }
    const hoy = new Date();
    // EL MES ELEGIDO, comprobado otra vez aquí: ni antes del primer registro ni futuro.
    if (!periodoPermitido({periodo: mesSel, primero: primeroDisponible, hoy})) throw errorParaMostrar(TEXTO_PERIODO_NO_PERMITIDO);
    const target = new Date(mesSel.anio, mesSel.mes0, 1);
    const y=target.getFullYear(), m=target.getMonth();
    const ym=`${y}-${String(m+1).padStart(2,"0")}`;
    const ini=new Date(y,m,1);
    // EL PERIODO TERMINA HOY cuando el mes está en curso. Contar días que no han
    // ocurrido fue exactamente el defecto que hacía decir "22 faltas" el día 3.
    const ultimoDelMes=new Date(y,m+1,0);
    const enCurso = (y===hoy.getFullYear() && m===hoy.getMonth());
    const fin = enCurso ? new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate()) : ultimoDelMes;
    // La misma lectura trae el horario general: es de donde hereda los días
    // laborables un horario personalizado que no los traiga. Ver diasLaborablesVigentes.
    // La denominación que se imprime ya no es siempre la de la empresa: es la de la
    // razón social del trabajador en el periodo (dpDoc, más abajo).
    let horarioGeneral:any=null, historialGeneral:any=null;
    try { const g = await leerHorarioGeneralConHistorial(currentUser.uid); horarioGeneral = g.horario; historialGeneral = g.historial; } catch {}
    // EL HORARIO QUE REGÍA, DÍA POR DÍA (horarioQueRegia), igual que la bitácora.
    // Se resuelve DESPUES de leer la ficha al día, que trae su historial propio.
    const alDia = await fichaYChecadasAlDia(empleado, checadas||[], currentUser.uid);
    const horarioEn = (t:Date)=> horarioQueRegia(alDia.ficha, horarioGeneral, historialGeneral, t);
    // El criterio impreso, el del CIERRE del periodo (ver la bitácora).
    const he = horarioEn(instanteDeMexico(fin.getFullYear(), fin.getMonth(), fin.getDate(), 23, 59, 59, 999));
    const corte = await leerFechaDeCorteChecadas();

    // 1) ASISTENCIA — un solo clasificador, el mismo de las otras tres pantallas.
    // Y UN SOLO CRITERIO CON LA BITÁCORA QUINCENAL para decidir si hay algo que
    // reportar: el hecho de que existan checadas suyas dentro del periodo. Antes
    // esto leía la bandera `tieneAcceso` de la ficha, un dato del presente para
    // decidir el contenido de un documento del pasado.
    const hayAsistencia = hayAsistenciaEnPeriodo({checadas: alDia.checadas, email, desde: ini, hasta: fin});
    let regObl:any[] = [];
    try {
      const snapO = await getDocs(query(collection(db,"cumplimiento_obligaciones"), where("empleadorId","==",currentUser.uid)));
      regObl = snapO.docs.map((d:any)=>({id:d.id, ...d.data()}));
    } catch(e){ console.warn("cumplimiento_obligaciones (reporte):", e); }
    const iniMsMes = instanteDeMexico(ini.getFullYear(), ini.getMonth(), ini.getDate(), 0, 0, 0, 0).getTime();
    const finMsMes = instanteDeMexico(fin.getFullYear(), fin.getMonth(), fin.getDate(), 23, 59, 59, 999).getTime();
    // LA RAZÓN SOCIAL DEL TRABAJADOR EN EL MES (11-oct-2026), igual que la bitácora.
    const cat = await leerCatalogosDeEmpresa(currentUser.uid);
    const dpDoc = datosPatronDeRazon(razonSocialDelPeriodo(alDia.ficha, finMsMes, cat.razones), dp.datos);
    const rec = recorrerDiasChecador({
      desde: ini, hasta: fin, hoy, horario: he, checadas: alDia.checadas, email,
      registrosObligaciones: regObl, trabajadorId: empleado?.id, horarioGeneral, horarioEn,
      instantesDeCambio: instantesDelHistorial(alDia.ficha?.historialHorarioPropio, historialGeneral,
        instanteDeMexico(ini.getFullYear(), ini.getMonth(), ini.getDate(), 0, 0, 0, 0),
        instanteDeMexico(fin.getFullYear(), fin.getMonth(), fin.getDate(), 23, 59, 59, 999)),
      // Su ingreso y su baja, de la ficha al día: antes y después no se cuenta.
      periodosLaborales: periodosLaboralesDe(alDia.ficha),
    });

    // 2) ACTIVIDADES — dos hechos separados. Al denominador solo entran las que
    // ya vencieron dentro del periodo: una actividad con plazo futuro no está
    // pendiente todavía, y contarla como no terminada culpa de un plazo vivo.
    const finISO = _isoDia(fin);
    const suyas = tareasDelMes(tareas||[], ym, mesActualYM())
      .filter((t:any)=> (t.trabajadorEmail||"").toLowerCase()===email)
      .filter((t:any)=> String(t.fechaLimite||"").slice(0,10) <= finISO);
    const tareasHechos = {
      total: suyas.length,
      terminadas: suyas.filter((t:any)=> !!t.completada || !!t.terminada || !!t.confirmadaPorPatron).length,
      confirmadas: suyas.filter((t:any)=> !!t.confirmadaPorPatron).length,
    };

    // 3) Accidentes del periodo (reusa el arreglo cargado o lee por empleadorId).
    let accs:any[]|null = accidentes ?? null;
    if (!accs){ try { const snap=await getDocs(query(collection(db,"accidentes"), where("empleadorId","==",currentUser.uid))); accs=snap.docs.map((d:any)=>({id:d.id, ...d.data()})); } catch(e){ accs=[]; } }
    const mesAcc = (accs||[]).filter((a:any)=>{
      if ((a.trabajadorEmail||"").toLowerCase()!==email) return false;
      const fh=(a.fechaHechos||"").slice(0,7);
      if (/^\d{4}-\d{2}$/.test(fh)) return fh===ym;
      const td=a.timestamp?.toDate?.(); return td ? `${td.getFullYear()}-${String(td.getMonth()+1).padStart(2,"0")}`===ym : false;
    }).sort((a:any,b:any)=>fechaDelAccidente(a).localeCompare(fechaDelAccidente(b)))
      // CADA UNO CON SU RENGLÓN, y si está cancelado (ver
      // renglonAccidenteRegistroMensual). El documento no recibe el accidente
      // entero: ni la gravedad, ni el relato, ni nada que no vaya a imprimir.
      .map((a:any)=> renglonAccidenteRegistroMensual(a));

    // 4) EL PERIODO, ESCRITO. Un mes en curso lo dice: si no, el lector supone
    // que el documento cubre el mes completo y lee los días que faltan como
    // ausencias.
    const periodo = enCurso
      ? `Del 1 al ${fechaLargaAxis(fin)} (mes en curso)`
      : `${mesLargoAxis(y, m)} · del ${fechaTablaAxis(ini)} al ${fechaTablaAxis(ultimoDelMes)}`;

    const html = construirReporteMensualHTML({
      // El encabezado: la razón social del trabajador en el mes (dpDoc).
      empresa: dpDoc.denominacion, rfc: dpDoc.rfc, tipoPersona: dpDoc.tipoPersona, domicilio: domicilioPatronTexto(dpDoc),
      empleado: empleado?.nombre||email||"Empleado",
      periodo,
      asis: {
        hayAsistencia,
        hayLaborables: rec.hayLaborables,
        anioSinCatalogo: rec.anioSinCatalogo,
        conRegistro: rec.conRegistro, aTiempo: rec.aTiempo, retardos: rec.retardos, tardias: rec.tardias,
        sinRegistro: rec.sinRegistro, vacaciones: rec.vacaciones, descansos74: rec.descansos74,
        diasConAgregados: diasConRegistrosAgregados(alDia.vista, iniMsMes, finMsMes),
        avisosRelacion: rec.avisosRelacion,
        registrosFueraDeRelacion: rec.registrosFueraDeRelacion,
      },
      correcciones: correccionesDelPeriodo(alDia.vista, iniMsMes, finMsMes),
      correccionesAnteriores: correccionesHechasEnElPeriodo(alDia.vista, iniMsMes, finMsMes),
      tareas: tareasHechos, accidentes: mesAcc,
      criterio: criterioDelPeriodo(rec.tramosDeHorario),
      avisoHorario: avisoCambioDeHorario(rec.cambiosDeHorario),
      // Si la sede o la razón social cambiaron dentro del mes, con fecha y hora.
      avisosLugar: avisosDeSede(alDia.ficha, cat.sedes, iniMsMes, finMsMes),
      notasRazon: avisosDeRazonSocial(alDia.ficha, cat.razones, iniMsMes, finMsMes),
      notaCorte: notaDeCorteChecadas(corte, ini),
      generadoEn: fechaHoraLargaAxis(),
    });
    const fname = `registro-mensual-${String(empleado?.nombre||email||"empleado").replace(/[^a-zA-Z0-9]/g,"_")}-${ym}.pdf`;
    return { html, fname, periodo };
  };
  const generar = async ()=>{
    setGen(true); setMsg("");
    try { const {html,fname}=await construir(); await generarPDFDesdeHTML(html, fname); setMsg("PDF generado (revisa tus descargas)."); }
    catch(e:any){ console.error("reporte-mensual:", e); setMsg(mensajeDeFallo(e, {accion:"generar el registro mensual", denegado: denegadoPatron("leer las checadas de este empleado")})); }
    finally { setGen(false); }
  };
  const enviar = async ()=>{
    setEnv(true); setMsg("");
    try {
      const {html,fname,periodo}=await construir();
      await enviarReporteAlTrabajador({empleado, currentUser, tipo:"mensual", periodo, html, fname});
      setUltimoEnvio(new Date());
      setMsg("Enviado al trabajador. Lo verá en “Mis reportes” con notificación.");
    } catch(e:any){ console.error("reporte-mensual envio:", e); setMsg(mensajeDeFallo(e, {accion:"enviar el registro mensual", denegado: denegadoPatron("enviarle reportes a este empleado")})); }
    finally { setEnv(false); }
  };
  const inp:any = {padding:"8px 10px", borderRadius:9, border:`1px solid ${T.line}`, background:T.inputBg, color:T.ink, fontSize:13, fontFamily:fontSans, outline:"none", ...(T.dark?{colorScheme:"dark"}:{})};
  const btnGhost:any = {display:"inline-flex", alignItems:"center", gap:7, padding:"9px 14px", borderRadius:10, border:`1px solid ${T.gold}`, background:"transparent", color:T.gold, cursor:(gen||env)?"wait":"pointer", fontFamily:fontSans, fontSize:13, fontWeight:800};
  return (
    <div>
      <div style={{display:"flex", gap:8, alignItems:"center", flexWrap:"wrap" as const}}>
        <select {...CAMPO_DE_PARAMETRO} value={`${mesSel.anio}-${mesSel.mes0}`} aria-label="Mes del registro" style={inp}
          onChange={e=>{ const [a, m] = e.target.value.split("-").map(Number); setMesSel({anio:a, mes0:m}); }}>
          {mesesDisponibles(primeroDisponible, new Date()).map((p:any)=> <option key={`${p.anio}-${p.mes0}`} value={`${p.anio}-${p.mes0}`}>{_mayuscula(etiquetaMes(p))}{p.enCurso ? " (mes en curso)" : ""}</option>)}
        </select>
        <button onClick={generar} disabled={gen||env}
          style={{display:"inline-flex", alignItems:"center", gap:7, padding:"9px 14px", borderRadius:10, border:"none", background:T.gold, color:"#0B1829", cursor:(gen||env)?"wait":"pointer", fontFamily:fontSans, fontSize:13, fontWeight:800}}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><path d="M6 3h8l4 4v13a1 1 0 01-1 1H6a1 1 0 01-1-1V4a1 1 0 011-1z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round"/><path d="M13 3v5h5M9 13h6M9 16h4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/></svg>
          {gen ? "Generando…" : "Generar registro mensual (PDF)"}
        </button>
        <button onClick={enviar} disabled={gen||env} style={btnGhost}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><path d="M4 12l16-8-6 16-3-6-7-2z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round"/></svg>
          {env ? "Enviando…" : "Enviar al trabajador"}
        </button>
      </div>
      {ultimoEnvio && <div style={{fontSize:11.5, color:T.inkSoft, marginTop:8}}>✓ Enviado el {ultimoEnvio.toLocaleDateString("es-MX",{day:"numeric",month:"long",year:"numeric"})} · {ultimoEnvio.toLocaleTimeString("es-MX",{hour:"2-digit",minute:"2-digit"})}</div>}
      {dp.faltan.length > 0 && (
        <AvisoFaltanDatosPatron faltan={dp.faltan} que="El registro mensual" oscuro={T.dark}
          fontSans={fontSans} fontSerif={fontSans}/>
      )}
      {msg && <div style={{fontSize:12, color:T.inkSoft, marginTop:7}}>{msg}</div>}
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════
// CENTRO DE OBLIGACIONES PATRONALES (escritorio) — arranca con VACACIONES.
// Solo LECTURA/cálculo sobre `trabajadores` (fecha de ingreso). Sin colecciones ni
// reglas nuevas. Estructura modular: Aguinaldo/PTU reusan el mismo patrón + helpers
// (calcularVacacionesEmpleado / estadoObligacionVencimiento).
// ═══════════════════════════════════════════════════════════════════════════
function ObligacionesModulo({onBack, currentUser, fontSans, fontSerif, gold}: {onBack:()=>void; currentUser:any; fontSans:string; fontSerif:string; gold:string}) {
  const isMobile = window.innerWidth < 768;
  // Se eliminó el hub: era un clic intermedio que no aportaba dato. Vacaciones
  // es la vista por defecto por ser la que trae el riesgo de plazo del art. 81.
  const [vista, setVista] = useState<"vacaciones"|"aguinaldo">("vacaciones");
  const [busqObl, setBusqObl] = useState("");
  const [ordenObl, setOrdenObl] = useState<"nombre"|"pendientes">("nombre");
  const [dirObl, setDirObl] = useState<"asc"|"desc">("asc");
  // Aguinaldo arranca por monto proyectado descendente, que es el orden útil por
  // omisión; "monto" es un estado propio para poder volver a él.
  const [ordenAg, setOrdenAg] = useState<"monto"|"nombre"|"pago">("monto");
  const [dirAg, setDirAg] = useState<"asc"|"desc">("asc");
  const [infoVac, setInfoVac] = useState(false);   // panel "Lo que debes saber" (vacaciones)
  const [infoAg, setInfoAg] = useState(false);     // panel "Lo que debes saber" (aguinaldo)
  const [empleados, setEmpleados] = useState<any[]>([]);
  const [cargando, setCargando] = useState(true);
  const [errorCarga, setErrorCarga] = useState("");
  // Registros de cumplimiento (vacaciones tomadas) — colección cumplimiento_obligaciones.
  const [registros, setRegistros] = useState<any[]>([]);
  // Modal de registro/historial de vacaciones tomadas: {t, v, periodoISO}.
  const [regModal, setRegModal] = useState<any|null>(null);
  const [regFecha, setRegFecha] = useState("");
  const [regDias, setRegDias] = useState("");
  const [regNota, setRegNota] = useState("");
  const [regEditId, setRegEditId] = useState<string|null>(null);
  const [regGuardando, setRegGuardando] = useState(false);
  const [regError, setRegError] = useState("");
  // Días de aguinaldo de la EMPRESA (art. 87 LFT: mínimo 15; muchas dan 20 o 30).
  // Único dato nuevo: usuarios/{uid}.diasAguinaldo (el patrón es dueño → sin reglas nuevas).
  const [diasAg, setDiasAg] = useState<number>(15);
  const [diasAgConfigurado, setDiasAgConfigurado] = useState(false);
  const [agEdit, setAgEdit] = useState(false);
  const [agInput, setAgInput] = useState("15");
  const [agGuardando, setAgGuardando] = useState(false);
  // Acta de vacaciones: razón social (usuarios/{uid}.empresa), id de la toma en
  // generación y mensaje de resultado por registro. Sin reglas nuevas (add a 'reportes'
  // + campos a la toma existente en cumplimiento_obligaciones + documentos del expediente).
  // QUIEN FIRMA EL ACTA Y LA CONSTANCIA. Antes salia del nombre corto del
  // perfil, con cuatro nombres de campo posibles; ahora de configuracion_empresa,
  // que es la fuente y trae ademas el RFC y el domicilio.
  // La denominación de cada acta o constancia sale de la razón social del
  // trabajador en la fecha del documento (datosPatronParaDocumento).
  const dp = useDatosPatron(currentUser?.uid);
  const [actaGenId, setActaGenId] = useState<string|null>(null);
  const [actaEnvId, setActaEnvId] = useState<string|null>(null);      // envío digital (opcional)
  const [actaMsg, setActaMsg] = useState<{id:string; ok:boolean; txt:string}|null>(null);
  // Aguinaldo — registro de PAGO por año (colección cumplimiento_obligaciones, tipo:'aguinaldo').
  // Mismo patrón que vacaciones; el filtro por tipo mantiene Vacaciones intacta.
  const [agRegModal, setAgRegModal] = useState<any|null>(null);   // {t, a, anio}
  const [agRegFecha, setAgRegFecha] = useState("");
  const [agRegMonto, setAgRegMonto] = useState("");
  const [agRegNota, setAgRegNota] = useState("");
  const [agRegEditId, setAgRegEditId] = useState<string|null>(null);
  const [agRegGuardando, setAgRegGuardando] = useState(false);
  const [agRegError, setAgRegError] = useState("");
  const [agConstGenId, setAgConstGenId] = useState<string|null>(null);
  const [agConstEnvId, setAgConstEnvId] = useState<string|null>(null);   // envío digital (opcional)
  const [agConstMsg, setAgConstMsg] = useState<{id:string; ok:boolean; txt:string}|null>(null);

  useEffect(() => {
    if (!currentUser?.uid) { setCargando(false); return; }
    let cancel = false;
    (async () => {
      setCargando(true); setErrorCarga("");
      try {
        // MISMA fuente/consulta que el expediente (un solo where, sin índice compuesto).
        const snap = await getDocs(query(collection(db,"trabajadores"), where("userId","==",currentUser.uid)));
        if (cancel) return;
        // UNA SOLA REGLA PARA TODO EL MÓDULO: aquí se excluyen los dados de baja,
        // y de aquí para abajo `empleados` significa SIEMPRE "trabajadores activos".
        // Antes unas vistas filtraban y otras no, así que las obligaciones del
        // patrón salían infladas con gente que ya no trabaja ahí — vacaciones que
        // nadie va a tomar y aguinaldos que nadie va a cobrar.
        setEmpleados(snap.docs.map(d=>({id:d.id, ...(d.data() as any)}))
          .filter((t:any)=> (t.status||"activo") !== "baja"));
      } catch(e){ if(!cancel){ console.error("obligaciones empleados:", e); setErrorCarga("No se pudieron cargar los empleados."); } }
      finally { if(!cancel) setCargando(false); }
      // Registros de cumplimiento (un solo where por empleadorId; filtra en JS por tipo/periodo).
      // Aislado: si la regla aún no está publicada, no rompe el panel (solo no muestra tomadas).
      try {
        const snapR = await getDocs(query(collection(db,"cumplimiento_obligaciones"), where("empleadorId","==",currentUser.uid)));
        if (!cancel) setRegistros(snapR.docs.map(d=>({id:d.id, ...(d.data() as any)})));
      } catch(e){ if(!cancel) console.warn("cumplimiento_obligaciones read (¿regla publicada?):", e); }
      try {
        const u = await getDoc(doc(db,"usuarios",currentUser.uid));
        if (cancel || !u.exists()) return;
        const ud:any = u.data() || {};
        const n = Number(ud?.diasAguinaldo);
        if (Number.isFinite(n) && n > 0) { setDiasAg(n); setDiasAgConfigurado(true); setAgInput(String(n)); }
      } catch(e){ /* sin config → queda el mínimo legal de 15 */ }
    })();
    return ()=>{ cancel = true; };
  }, [currentUser?.uid]);

  const guardarDiasAguinaldo = async () => {
    if (!currentUser?.uid) return;
    const n = Math.round(Number(agInput));
    if (!Number.isFinite(n) || n < 15) { alert("El mínimo legal es 15 días (art. 87 LFT)."); return; }
    setAgGuardando(true);
    try {
      await updateDoc(doc(db,"usuarios",currentUser.uid), { diasAguinaldo: n });
      setDiasAg(n); setDiasAgConfigurado(true); setAgEdit(false);
    } catch(e){ console.error("diasAguinaldo write:", e); alert("No se pudo guardar. Intenta de nuevo."); }
    finally { setAgGuardando(false); }
  };

  // ── Registro de vacaciones TOMADAS por PERIODO ────────────────────────────
  // El "periodo" es el ANIVERSARIO al que corresponde el derecho (fecha ISO de
  // v.desde). Como v.desde avanza cada aniversario, el ciclo se REINICIA solo: al
  // siguiente aniversario el panel mira otro periodo y los registros del anterior
  // ya NO cuentan para el nuevo (quedan como historial).
  const _p2 = (n:number)=> String(n).padStart(2,"0");
  const periodoISO = (v:any):string => (v?.valida && v?.yaAplica && v?.desde) ? `${v.desde.getFullYear()}-${_p2(v.desde.getMonth()+1)}-${_p2(v.desde.getDate())}` : "";
  // Empareja un registro con el PERIODO vigente de un empleado. Clave PRIMARIA = número
  // de aniversario (periodoAnios, un ENTERO estable), no el string de fecha (frágil a
  // formato/zona horaria). Fallback a la fecha del aniversario para registros antiguos.
  const mismoPeriodo = (r:any, v:any):boolean => {
    if (r?.periodoAnios!=null && v?.anios!=null && Number(r.periodoAnios)===Number(v.anios)) return true;
    return !!r?.periodo && r.periodo===periodoISO(v);
  };
  // Registros de vacaciones de un empleado para SU periodo vigente (v) o todos (v=null).
  const registrosDe = (trabajadorId:string, v:any) => registros
    .filter((r:any)=> r.tipo==="vacaciones" && r.trabajadorId===trabajadorId && (v==null || mismoPeriodo(r,v)))
    .sort((a:any,b:any)=> (b.fecha||"").localeCompare(a.fecha||""));
  const diasTomadosDe = (trabajadorId:string, v:any) => registrosDe(trabajadorId, v).reduce((s:number,r:any)=> s + (Number(r.diasTomados)||0), 0);

  const recargarRegistros = async () => {
    if (!currentUser?.uid) return;
    try {
      const snapR = await getDocs(query(collection(db,"cumplimiento_obligaciones"), where("empleadorId","==",currentUser.uid)));
      setRegistros(snapR.docs.map(d=>({id:d.id, ...(d.data() as any)})));
    } catch(e){ console.warn("recargar registros:", e); throw e; }
  };

  const abrirRegistro = (t:any, v:any) => {
    setRegModal({t, v, periodoISO: periodoISO(v)});
    setRegEditId(null); setRegFecha(""); setRegDias(""); setRegNota(""); setRegError("");
  };
  const editarRegistro = (r:any) => {
    setRegEditId(r.id); setRegFecha(r.fecha||""); setRegDias(String(r.diasTomados||"")); setRegNota(r.nota||""); setRegError("");
  };
  const guardarRegistro = async () => {
    if (!regModal || !currentUser?.uid) return;
    const {t, v, periodoISO:per} = regModal;
    const dias = Number(regDias);
    if (!regFecha) { setRegError("Indica la fecha en que tomó las vacaciones."); return; }
    if (!Number.isFinite(dias) || dias<=0) { setRegError("Indica cuántos días tomó (mayor a 0)."); return; }
    // No exceder el total del PERIODO (descontando lo ya registrado, sin la edición actual).
    const yaTomados = registrosDe(t.id, v).filter((r:any)=> r.id!==regEditId).reduce((s:number,r:any)=> s+(Number(r.diasTomados)||0),0);
    if (yaTomados + dias > (v.dias||0)) { setRegError(`Excede su total del periodo: le corresponden ${v.dias} días y ya hay ${yaTomados} registrados (máximo ${Math.max(0,(v.dias||0)-yaTomados)} más).`); return; }
    // AVISO SUAVE, no bloqueo: dos tomas con la misma fecha y los mismos días en
    // el mismo periodo casi siempre son un error de dedo, y los días gozados son
    // un dato con consecuencias. Puede haber casos raros, así que decide el patrón.
    const gemelo = registrosDe(t.id, v).find((r:any)=> r.id!==regEditId
      && String(r.fecha||"")===regFecha && (Number(r.diasTomados)||0)===dias);
    if (gemelo) {
      const ok = window.confirm(
        `Ya hay un registro de ${dias} día${dias===1?"":"s"} con fecha ${regFecha} en este periodo` +
        (gemelo.nota ? ` (nota: "${gemelo.nota}")` : "") + "." +
        "\n\nSi es un error de captura, cancela y revisa el historial. Si de verdad son dos tomas distintas, continúa." +
        "\n\n¿Guardar de todos modos?");
      if (!ok) return;
    }
    setRegGuardando(true); setRegError("");
    try {
      if (regEditId) {
        await updateDoc(doc(db,"cumplimiento_obligaciones",regEditId), { fecha:regFecha, diasTomados:dias, nota:regNota.trim(), editadoEn: serverTimestamp() });
      } else {
        await addDoc(collection(db,"cumplimiento_obligaciones"), {
          empleadorId: currentUser.uid, trabajadorId: t.id, tipo:"vacaciones",
          periodo: per, periodoAnios: v.anios||null, fecha: regFecha, diasTomados: dias,
          nota: regNota.trim(), creadoPor: currentUser.uid, createdAt: serverTimestamp(),
        });
      }
      await recargarRegistros();
      setRegEditId(null); setRegFecha(""); setRegDias(""); setRegNota("");
    } catch(e:any){ console.error("guardar registro vacaciones:", e); setRegError("No se pudo guardar. Si acabas de publicar la regla, intenta de nuevo."); }
    finally { setRegGuardando(false); }
  };
  const eliminarRegistro = async (r:any) => {
    if (!window.confirm(`¿Eliminar el registro de ${r.diasTomados} día(s) del ${r.fecha}? No se puede deshacer.`)) return;
    try { await deleteDoc(doc(db,"cumplimiento_obligaciones",r.id)); await recargarRegistros(); }
    catch(e){ console.error("eliminar registro:", e); alert("No se pudo eliminar. Intenta de nuevo."); }
  };

  // Días gozados ACUMULADOS del periodo hasta esta toma inclusive (ordena por fecha y
  // luego createdAt). Así el acta muestra la foto correcta aunque haya varias tomas.
  const _fLarga = (iso:string) => iso ? new Date(iso+"T00:00:00").toLocaleDateString("es-MX",{day:"2-digit",month:"long",year:"numeric"}) : "—";

  // Vincula un documento al expediente del trabajador SIN duplicar: si ya hay una
  // entrada con esa misma URL, no se agrega otra. Es lo que evita que reintentar
  // tras un fallo parcial deje dos veces el mismo PDF en el expediente.
  // Guarda además `tipo` y `periodo`, que es lo que permite reconocerlo después
  // en la carpeta "Actas y constancias" sin adivinar por el nombre del archivo.
  const vincularAlExpediente = async (t:any, entrada:{nombre:string; url:string; tipo:string; periodo:string}) => {
    const docsActuales:any[] = (t.documentos)||[];
    if (docsActuales.some((d:any)=> d && d.url===entrada.url)) return docsActuales;
    const nuevos = [...docsActuales, {...entrada, fecha: new Date().toISOString().slice(0,10)}];
    await updateDoc(doc(db,"trabajadores",t.id), {documentos: nuevos});
    return nuevos;
  };
  const acumuladoHastaToma = (trabajadorId:string, v:any, r:any):number => {
    const orden = registrosDe(trabajadorId, v).slice().sort((a:any,b:any)=>{
      const fa=(a.fecha||""), fb=(b.fecha||"");
      if (fa!==fb) return fa.localeCompare(fb);
      return ((a.createdAt?.toMillis?.()||0)-(b.createdAt?.toMillis?.()||0));
    });
    let acc=0;
    for (const x of orden){ acc += Number(x.diasTomados)||0; if (x.id===r.id) break; }
    return acc;
  };
  const fmtActaFirmada = (r:any):string => {
    const d = r?.documentoFirmadoEn?.toDate?.();
    return d ? d.toLocaleDateString("es-MX",{day:"2-digit",month:"short",year:"numeric"}) : "";
  };

  // GENERA el acta (PDF con membrete AXIS), la DESCARGA al patrón, la sube a Storage y la
  // vincula al expediente (trabajadores/{id}.documentos), marcando documentoUrl/documentoGeneradoEn.
  // NO depende del correo: un trabajador sin cuenta se imprime y firma en FÍSICO. El envío
  // digital es una acción aparte (enviarActaVacaciones), la única que sí requiere correo.
  const generarActaVacaciones = async (r:any) => {
    if (!regModal || !currentUser?.uid) return;
    // EL CANDADO. El acta de vacaciones nombra a la empresa y lleva su firma.
    if (!datosPatronCompletos(dp.cfg)) { abrirDatosDelPatron(); return; }
    const {t, v} = regModal;
    const email = (t?.email||"").toLowerCase().trim();
    if (!t?.id) { setActaMsg({id:r.id, ok:false, txt:"No se pudo identificar al empleado."}); return; }
    setActaGenId(r.id); setActaMsg(null);
    try {
      const diasPeriodo = Number(v.dias)||0;
      const gozado = acumuladoHastaToma(t.id, v, r);
      const completo = diasPeriodo>0 && gozado + 1e-6 >= diasPeriodo;
      const pend = completo ? 0 : Math.max(0, Math.round((diasPeriodo - gozado)*100)/100);
      const dias = Number(r.diasTomados)||0;
      const ahora = new Date();
      const fechaTomaLarga = _fLarga(r.fecha||"");
      // A nombre de la razón social del trabajador el día de la toma (12-oct-2026).
      const dpActa = await datosPatronParaDocumento(currentUser.uid, dp.datos, t, r.fecha);
      const html = construirActaVacacionesHTML({
        empresa: dpActa.denominacion, rfc: dpActa.rfc, tipoPersona: dpActa.tipoPersona, domicilio: domicilioPatronTexto(dpActa),
        empleado: t.nombre||email,
        puesto: t.puesto||"—",
        fechaIngreso: _fLarga(t.fechaIngreso||""),
        diasEstaToma: dias,
        fechaToma: fechaTomaLarga,
        nota: r.nota||"",
        anios: v.anios,
        periodoDesde: fmtFecha(v.desde),
        diasPeriodo, gozado, pend, completo,
        patron: dpActa.denominacion||"",
        notas: [notaRazonDesdeElInicio(t, _msDeFechaDocumento(r.fecha), ()=> dpActa.denominacion)],
        generadoEn: ahora.toLocaleDateString("es-MX",{day:"2-digit",month:"long",year:"numeric"})+" · "+ahora.toLocaleTimeString("es-MX",{hour:"2-digit",minute:"2-digit"}),
      });
      // Nombre limpio: quita acentos correctamente (é→e, í→i, ñ→n…) descomponiendo con
      // NFD y borrando los signos combinantes; luego guiones simples (sin guiones bajos).
      const base = (t.nombre||email)
        .normalize("NFD").replace(new RegExp("[\\u0300-\\u036f]","g"),"")
        .replace(/[^a-zA-Z0-9]+/g,"-").replace(/^-+|-+$/g,"");
      // Dos tomas distintas pueden coincidir en fecha y en días; sin el id del
      // registro quedaban dos archivos con nombre idéntico y contenido distinto
      // en el mismo expediente. El id es estable: regenerar no cambia el nombre.
      const idCorto = String(r.id||"").slice(-6) || "sin-id";
      const fname = `acta-vacaciones-${base||"empleado"}-${r.fecha||"s-f"}-${dias}d-${idCorto}.pdf`;
      // save:true → devuelve el Blob (para subir/vincular/enviar como ya hace) Y ADEMÁS
      // descarga el PDF directo en el navegador del patrón, con este MISMO nombre limpio.
      const blob = await generarPDFDesdeHTML(html, fname, {save:true});
      const file = new File([blob], fname, {type:"application/pdf"});
      // Misma ruta de siempre, con el uid de quien sube en su sitio. Ver la
      // guardia en `subirArchivo` y el caso permanente en prueba-campo.
      const url = await subirArchivo(currentUser.uid, "reportes", file, undefined, t.id);

      // A partir de aquí el PDF YA existe y YA se descargó. Los dos pasos que
      // faltan se manejan por separado: si uno falla, el mensaje dice qué se
      // logró y qué no, en vez de un "no se pudo generar" que sería falso.
      let okExp = true, okReg = true;
      let nuevosDocs:any[] = (t.documentos)||[];
      try {
        nuevosDocs = await vincularAlExpediente(t, {
          nombre: fname, url,
          tipo: "acta_vacaciones",
          periodo: `${dias} día${dias===1?"":"s"} · ${fechaTomaLarga}`,
        });
        setEmpleados(prev=> prev.map(e=> e.id===t.id ? {...e, documentos:nuevosDocs} : e));
        setRegModal((rm:any)=> rm ? {...rm, t:{...rm.t, documentos:nuevosDocs}} : rm);
      } catch(e){ okExp = false; console.error("vincular acta al expediente:", e); }
      try {
        await updateDoc(doc(db,"cumplimiento_obligaciones",r.id), {documentoUrl:url, documentoGeneradoEn: serverTimestamp()});
        await recargarRegistros();
      } catch(e){ okReg = false; console.error("marcar toma con el acta:", e); }

      const donde = `el expediente de ${t.nombre||email||"el trabajador"}`;
      if (okExp && okReg) {
        setActaMsg({id:r.id, ok:true, txt: email
          ? `Acta generada y guardada en ${donde} ✓ — se descargó en tu equipo; puedes enviarla al trabajador o imprimirla para firma física.`
          : `Acta generada y guardada en ${donde} ✓ — se descargó en tu equipo; imprímela para recabar la firma física.`});
      } else if (okExp && !okReg) {
        // El caso delicado: el documento SÍ quedó. Lo que no avanzó es el registro.
        setActaMsg({id:r.id, ok:false, txt:`El acta se generó, se descargó y quedó guardada en ${donde}, pero no se pudo actualizar el registro de la toma. Vuelve a presionar "Generar acta": no se duplicará el documento.`});
      } else if (!okExp && okReg) {
        setActaMsg({id:r.id, ok:false, txt:"El acta se generó y se descargó, y el registro quedó marcado, pero no se pudo guardar en el expediente del trabajador. Reintenta para vincularla."});
      } else {
        setActaMsg({id:r.id, ok:false, txt:"El acta se generó y se descargó en tu equipo, pero NO se pudo guardar ni en el expediente ni en el registro. Reintenta antes de darla por buena."});
      }
    } catch(e){ console.error("generar acta vacaciones:", e); setActaMsg({id:r.id, ok:false, txt:(e && (e as any).paraMostrar && (e as any).message) || "No se pudo generar el acta. No se guardó nada; intenta de nuevo."}); }
    finally { setActaGenId(null); }
  };

  // ENVÍO DIGITAL (acción SEPARADA y opcional): manda el acta ya generada al trabajador
  // reutilizando EXACTAMENTE el flujo de reportes (colección 'reportes' → "Mis reportes",
  // con su acuse). Es lo ÚNICO que requiere correo; no condiciona generar/descargar.
  const enviarActaVacaciones = async (r:any) => {
    if (!regModal || !currentUser?.uid) return;
    const {t} = regModal;
    const email = (t?.email||"").toLowerCase().trim();
    if (!t?.id || !email || !r?.documentoUrl) return;
    setActaEnvId(r.id); setActaMsg(null);
    try {
      const dias = Number(r.diasTomados)||0;
      const fechaTomaLarga = _fLarga(r.fecha||"");
      await addDoc(collection(db,"reportes"), {
        empleadorId: currentUser.uid,
        trabajadorId: t.id,
        trabajadorEmail: email,
        trabajadorCuentaUid: t.cuentaUid||"",
        trabajadorNombre: t.nombre||email,
        tipo:"acta_vacaciones",
        periodo: `${dias} día${dias===1?"":"s"} · ${fechaTomaLarga}`,
        urlPDF: r.documentoUrl,
        mensaje: `Constancia de disfrute de vacaciones: ${dias} día${dias===1?"":"s"} registrados el ${fechaTomaLarga}. Este documento debe firmarse de forma física por el trabajador y el patrón; consérvalo para tu control.`,
        estado:"enviado",
        fechaEnvio: serverTimestamp(),
        creadoPor: currentUser.uid,
      });
      await updateDoc(doc(db,"cumplimiento_obligaciones",r.id), {documentoEnviadoEn: serverTimestamp()});
      await recargarRegistros();
      setActaMsg({id:r.id, ok:true, txt:`Acta enviada a ${t.nombre||email} ✓ — la verá en "Mis reportes", dentro de su portal.`});
    } catch(e){ console.error("enviar acta vacaciones:", e); setActaMsg({id:r.id, ok:false, txt:"No se pudo enviar el acta. Intenta de nuevo."}); }
    finally { setActaEnvId(null); }
  };

  // SUBIR EL ACTA YA FIRMADA (escaneo/foto): reutiliza SubirArchivoBtn → la vincula al
  // expediente (trabajadores/{id}.documentos, mismo patrón) y respalda la marca "firmada".
  const registrarActaFirmadaSubida = async (r:any, url:string, nombre:string) => {
    if (!regModal || !currentUser?.uid) return;
    const {t} = regModal;
    if (!t?.id) return;
    try {
      const nuevosDocs = await vincularAlExpediente(t, {
        nombre: nombre||`acta-vacaciones-firmada-${r.fecha||""}`, url,
        tipo: "acta_vacaciones_firmada", periodo: `${Number(r.diasTomados)||0} día(s) · ${_fLarga(r.fecha||"")}`,
      });
      await updateDoc(doc(db,"cumplimiento_obligaciones",r.id), {documentoFirmadoUrl:url, documentoFirmado:true, documentoFirmadoEn: serverTimestamp()});
      setEmpleados(prev=> prev.map(e=> e.id===t.id ? {...e, documentos:nuevosDocs} : e));
      setRegModal((rm:any)=> rm ? {...rm, t:{...rm.t, documentos:nuevosDocs}} : rm);
      await recargarRegistros();
      setActaMsg({id:r.id, ok:true, txt:"Acta firmada subida y vinculada al expediente ✓"});
    } catch(e){ console.error("subir acta firmada:", e); setActaMsg({id:r.id, ok:false, txt:"No se pudo guardar el acta firmada. Intenta de nuevo."}); }
  };

  // Checklist de control: marca/desmarca que el acta se firmó FÍSICAMENTE (con fecha).
  const toggleActaFirmada = async (r:any) => {
    const nuevo = !r.documentoFirmado;
    try {
      await updateDoc(doc(db,"cumplimiento_obligaciones",r.id), { documentoFirmado:nuevo, documentoFirmadoEn: nuevo?serverTimestamp():null });
      await recargarRegistros();
    } catch(e){ console.error("acta firmada toggle:", e); alert("No se pudo actualizar. Intenta de nuevo."); }
  };

  // ════════ AGUINALDO — registro de PAGO por AÑO calendario (tipo:'aguinaldo') ════════
  // Filtra por tipo, así que NO interfiere con vacaciones (tipo:'vacaciones').
  const pagosAguinaldoDe = (trabajadorId:string, anio:number) => registros
    .filter((r:any)=> r.tipo==="aguinaldo" && r.trabajadorId===trabajadorId && String(r.periodo)===String(anio))
    .sort((a:any,b:any)=> (b.fecha||"").localeCompare(a.fecha||""));
  const tienePagoAg = (trabajadorId:string, anio:number) => pagosAguinaldoDe(trabajadorId, anio).length>0;
  const totalPagadoAg = (trabajadorId:string, anio:number) => pagosAguinaldoDe(trabajadorId, anio).reduce((s:number,r:any)=> s+(Number(r.monto)||0),0);
  const ultimoPagoAg = (trabajadorId:string, anio:number) => pagosAguinaldoDe(trabajadorId, anio)[0] || null;

  const abrirAgReg = (t:any, a:any, anio:number) => {
    setAgRegModal({t, a, anio});
    setAgRegEditId(null);
    setAgRegFecha(new Date().toISOString().slice(0,10));
    setAgRegMonto(a?.montoProyectado!=null ? String(Math.round(a.montoProyectado*100)/100) : "");
    setAgRegNota(""); setAgRegError(""); setAgConstMsg(null);
  };
  const editarPagoAg = (r:any) => {
    setAgRegEditId(r.id); setAgRegFecha(r.fecha||""); setAgRegMonto(String(r.monto??"")); setAgRegNota(r.nota||""); setAgRegError("");
  };
  const guardarPagoAg = async () => {
    if (!agRegModal || !currentUser?.uid) return;
    const {t, anio} = agRegModal;
    const monto = Number(agRegMonto);
    if (!agRegFecha) { setAgRegError("Indica la fecha en que se pagó el aguinaldo."); return; }
    if (!Number.isFinite(monto) || monto<=0) { setAgRegError("Indica el monto pagado (mayor a 0)."); return; }
    setAgRegGuardando(true); setAgRegError("");
    try {
      if (agRegEditId) {
        await updateDoc(doc(db,"cumplimiento_obligaciones",agRegEditId), { fecha:agRegFecha, monto, nota:agRegNota.trim(), editadoEn: serverTimestamp() });
      } else {
        await addDoc(collection(db,"cumplimiento_obligaciones"), {
          empleadorId: currentUser.uid, trabajadorId: t.id, tipo:"aguinaldo",
          periodo: String(anio), anio, fecha: agRegFecha, monto,
          nota: agRegNota.trim(), creadoPor: currentUser.uid, createdAt: serverTimestamp(),
        });
      }
      await recargarRegistros();
      setAgRegEditId(null); setAgRegFecha(new Date().toISOString().slice(0,10)); setAgRegMonto(""); setAgRegNota("");
    } catch(e:any){ console.error("guardar pago aguinaldo:", e); setAgRegError("No se pudo guardar. Intenta de nuevo."); }
    finally { setAgRegGuardando(false); }
  };
  const eliminarPagoAg = async (r:any) => {
    if (!window.confirm(`¿Eliminar el registro de pago de aguinaldo del ${r.fecha}? No se puede deshacer.`)) return;
    try { await deleteDoc(doc(db,"cumplimiento_obligaciones",r.id)); await recargarRegistros(); }
    catch(e){ console.error("eliminar pago aguinaldo:", e); alert("No se pudo eliminar. Intenta de nuevo."); }
  };

  // Constancia de pago de aguinaldo (SECUNDARIA/opcional): clon EXACTO del flujo del acta
  // de vacaciones — PDF con membrete + descarga directa al patrón (nombre limpio) + vínculo
  // al expediente + checklist 'constancia firmada'. NO depende del correo: el envío digital
  // es una acción aparte (enviarConstanciaAguinaldo), la única que sí lo requiere.
  const generarConstanciaAguinaldo = async (r:any) => {
    if (!agRegModal || !currentUser?.uid) return;
    // EL CANDADO. La constancia de aguinaldo nombra a la empresa y lleva su firma.
    if (!datosPatronCompletos(dp.cfg)) { abrirDatosDelPatron(); return; }
    const {t, a, anio} = agRegModal;
    const email = (t?.email||"").toLowerCase().trim();
    if (!t?.id) { setAgConstMsg({id:r.id, ok:false, txt:"No se pudo identificar al empleado."}); return; }
    setAgConstGenId(r.id); setAgConstMsg(null);
    try {
      const monto = Number(r.monto)||0;
      const fechaPagoLarga = _fLarga(r.fecha||"");
      const ahora = new Date();
      // A nombre de la razón social del trabajador el día del pago (12-oct-2026).
      const dpConst = await datosPatronParaDocumento(currentUser.uid, dp.datos, t, r.fecha);
      const html = construirConstanciaAguinaldoHTML({
        empresa: dpConst.denominacion, rfc: dpConst.rfc, tipoPersona: dpConst.tipoPersona, domicilio: domicilioPatronTexto(dpConst),
        empleado: t.nombre||email,
        puesto: t.puesto||"—",
        anio,
        diasEmpresa: diasAg,
        diasQueCorresponden: (a?.diasProyectados!=null ? Number(a.diasProyectados) : null),
        proporcional: !!a?.proporcional,
        monto,
        fechaPago: fechaPagoLarga,
        patron: dpConst.denominacion||"",
        notas: [notaRazonDesdeElInicio(t, _msDeFechaDocumento(r.fecha), ()=> dpConst.denominacion)],
        generadoEn: ahora.toLocaleDateString("es-MX",{day:"2-digit",month:"long",year:"numeric"})+" · "+ahora.toLocaleTimeString("es-MX",{hour:"2-digit",minute:"2-digit"}),
      });
      const base = (t.nombre||email)
        .normalize("NFD").replace(new RegExp("[\\u0300-\\u036f]","g"),"")
        .replace(/[^a-zA-Z0-9]+/g,"-").replace(/^-+|-+$/g,"");
      const idCortoAg = String(r.id||"").slice(-6) || "sin-id";
      const fname = `constancia-aguinaldo-${base||"empleado"}-${anio}-${idCortoAg}.pdf`;
      const blob = await generarPDFDesdeHTML(html, fname, {save:true});
      const file = new File([blob], fname, {type:"application/pdf"});
      // Misma ruta de siempre, con el uid de quien sube en su sitio. Ver la
      // guardia en `subirArchivo` y el caso permanente en prueba-campo.
      const url = await subirArchivo(currentUser.uid, "reportes", file, undefined, t.id);
      // Igual que el acta: el PDF ya existe y ya se descargó. Expediente y
      // registro se manejan por separado para no mentir en el mensaje.
      let okExp = true, okReg = true;
      let nuevosDocs:any[] = (t.documentos)||[];
      try {
        nuevosDocs = await vincularAlExpediente(t, {
          nombre: fname, url,
          tipo: "constancia_aguinaldo",
          periodo: String(anio),
        });
        setEmpleados(prev=> prev.map(e=> e.id===t.id ? {...e, documentos:nuevosDocs} : e));
        setAgRegModal((rm:any)=> rm ? {...rm, t:{...rm.t, documentos:nuevosDocs}} : rm);
      } catch(e){ okExp = false; console.error("vincular constancia al expediente:", e); }
      try {
        await updateDoc(doc(db,"cumplimiento_obligaciones",r.id), {documentoUrl:url, documentoGeneradoEn: serverTimestamp()});
        await recargarRegistros();
      } catch(e){ okReg = false; console.error("marcar pago con la constancia:", e); }

      const dondeAg = `el expediente de ${t.nombre||email||"el trabajador"}`;
      if (okExp && okReg) {
        setAgConstMsg({id:r.id, ok:true, txt: email
          ? `Constancia generada y guardada en ${dondeAg} ✓ — se descargó en tu equipo; puedes enviarla al trabajador o imprimirla para firma física.`
          : `Constancia generada y guardada en ${dondeAg} ✓ — se descargó en tu equipo; imprímela para recabar la firma física.`});
      } else if (okExp && !okReg) {
        setAgConstMsg({id:r.id, ok:false, txt:`La constancia se generó, se descargó y quedó guardada en ${dondeAg}, pero no se pudo actualizar el registro del pago. Vuelve a presionar "Generar constancia": no se duplicará el documento.`});
      } else if (!okExp && okReg) {
        setAgConstMsg({id:r.id, ok:false, txt:"La constancia se generó y se descargó, y el registro quedó marcado, pero no se pudo guardar en el expediente del trabajador. Reintenta para vincularla."});
      } else {
        setAgConstMsg({id:r.id, ok:false, txt:"La constancia se generó y se descargó en tu equipo, pero NO se pudo guardar ni en el expediente ni en el registro. Reintenta antes de darla por buena."});
      }
    } catch(e){ console.error("generar constancia aguinaldo:", e); setAgConstMsg({id:r.id, ok:false, txt:(e && (e as any).paraMostrar && (e as any).message) || "No se pudo generar la constancia. Intenta de nuevo."}); }
    finally { setAgConstGenId(null); }
  };

  // ENVÍO DIGITAL de la constancia (acción SEPARADA y opcional; única que requiere correo).
  const enviarConstanciaAguinaldo = async (r:any) => {
    if (!agRegModal || !currentUser?.uid) return;
    const {t, anio} = agRegModal;
    const email = (t?.email||"").toLowerCase().trim();
    if (!t?.id || !email || !r?.documentoUrl) return;
    setAgConstEnvId(r.id); setAgConstMsg(null);
    try {
      const monto = Number(r.monto)||0;
      const fechaPagoLarga = _fLarga(r.fecha||"");
      await addDoc(collection(db,"reportes"), {
        empleadorId: currentUser.uid,
        trabajadorId: t.id,
        trabajadorEmail: email,
        trabajadorCuentaUid: t.cuentaUid||"",
        trabajadorNombre: t.nombre||email,
        tipo:"constancia_aguinaldo",
        periodo: `Aguinaldo ${anio}`,
        urlPDF: r.documentoUrl,
        mensaje: `Constancia de pago de aguinaldo ${anio}: ${monto.toLocaleString("es-MX",{style:"currency",currency:"MXN",maximumFractionDigits:2})} pagados el ${fechaPagoLarga}. Comprobante complementario; el aguinaldo se comprueba fiscalmente con tu recibo de nómina (CFDI). Puede firmarse de forma física por ambas partes.`,
        estado:"enviado",
        fechaEnvio: serverTimestamp(),
        creadoPor: currentUser.uid,
      });
      await updateDoc(doc(db,"cumplimiento_obligaciones",r.id), {documentoEnviadoEn: serverTimestamp()});
      await recargarRegistros();
      setAgConstMsg({id:r.id, ok:true, txt:`Constancia enviada a ${t.nombre||email} ✓ — la verá en "Mis reportes", dentro de su portal.`});
    } catch(e){ console.error("enviar constancia aguinaldo:", e); setAgConstMsg({id:r.id, ok:false, txt:"No se pudo enviar la constancia. Intenta de nuevo."}); }
    finally { setAgConstEnvId(null); }
  };

  // SUBIR la constancia YA FIRMADA (escaneo/foto) — mismo patrón que en vacaciones.
  const registrarConstanciaFirmadaSubida = async (r:any, url:string, nombre:string) => {
    if (!agRegModal || !currentUser?.uid) return;
    const {t, anio} = agRegModal;
    if (!t?.id) return;
    try {
      const nuevosDocs = await vincularAlExpediente(t, {
        nombre: nombre||`constancia-aguinaldo-firmada-${anio}`, url,
        tipo: "constancia_aguinaldo_firmada", periodo: String(anio),
      });
      await updateDoc(doc(db,"cumplimiento_obligaciones",r.id), {documentoFirmadoUrl:url, documentoFirmado:true, documentoFirmadoEn: serverTimestamp()});
      setEmpleados(prev=> prev.map(e=> e.id===t.id ? {...e, documentos:nuevosDocs} : e));
      setAgRegModal((rm:any)=> rm ? {...rm, t:{...rm.t, documentos:nuevosDocs}} : rm);
      await recargarRegistros();
      setAgConstMsg({id:r.id, ok:true, txt:"Constancia firmada subida y vinculada al expediente ✓"});
    } catch(e){ console.error("subir constancia firmada:", e); setAgConstMsg({id:r.id, ok:false, txt:"No se pudo guardar la constancia firmada. Intenta de nuevo."}); }
  };

  const toggleConstanciaFirmada = async (r:any) => {
    const nuevo = !r.documentoFirmado;
    try {
      await updateDoc(doc(db,"cumplimiento_obligaciones",r.id), { documentoFirmado:nuevo, documentoFirmadoEn: nuevo?serverTimestamp():null });
      await recargarRegistros();
    } catch(e){ console.error("constancia firmada toggle:", e); alert("No se pudo actualizar. Intenta de nuevo."); }
  };

  const TL = T_LIGHT;
  // NAVEGA (no explica ni acciona) → siempre visible. Sustituye al hub y al
  // botón de "volver": el sidebar ya dice dónde estás y, al entrar desde ahí,
  // el módulo se vuelve a montar en Vacaciones.
  const barra = (_titulo?:string, _subvista?:boolean) => (
    <div style={{background:UI.superficie, borderBottom:`1px solid ${UI.borde}`, position:"sticky" as const, top:0, zIndex:50}}>
      <div style={{maxWidth:ANCHO_CONTENIDO, margin:"0 auto", padding:isMobile?"0 16px":"0 24px", height:46, display:"flex", alignItems:"center"}}>
        <SegmentadoFiltro fontSans={fontSans} valor={vista}
          onCambio={(v)=>{ setVista(v); setBusqObl(""); }}
          opciones={[{v:"vacaciones" as const, t:"Vacaciones"}, {v:"aguinaldo" as const, t:"Aguinaldo"}]}/>
      </div>
    </div>
  );

  // Guard: sin cuenta real todavía.
  if (!currentUser?.uid) {
    return (<div style={{minHeight:"100vh", background:UI.fondo, fontFamily:fontSans}}>
      {barra("Obligaciones", false)}
      <div style={{maxWidth:640, margin:"40px auto", padding:"0 20px", color:UI.textoSuave, fontSize:14}}>Inicia sesión con tu cuenta para ver las obligaciones de tus empleados.</div>
    </div>);
  }

  const chip = (texto:string, col:string, bg:string, bd:string) => (
    <span style={{display:"inline-block", fontSize:11, fontWeight:800, padding:"3px 9px", borderRadius:999, color:col, background:bg, border:`1px solid ${bd}`, whiteSpace:"nowrap" as const}}>{texto}</span>
  );

  // Panel colapsable "Lo que debes saber" — lenguaje empresarial, sin citar artículos
  // en el cuerpo (van al pie). No estorba la tabla: arranca cerrado.
  const panelInfo = (abierto:boolean, onToggle:()=>void, puntos:string[], fundamento:string) => (
    <div style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:INI.radio, boxShadow:UI.sombra, marginBottom:18, overflow:"hidden"}}>
      <button onClick={onToggle} style={{width:"100%", display:"flex", alignItems:"center", justifyContent:"space-between", gap:10, padding:"13px 16px", background:"transparent", border:"none", cursor:"pointer", fontFamily:fontSans, textAlign:"left" as const}}>
        <span style={{display:"inline-flex", alignItems:"center", gap:9, fontSize:13.5, fontWeight:800, color:UI.texto}}>
          <span style={{fontSize:16}}>💡</span> Lo que debes saber
        </span>
        <span style={{fontSize:12, fontWeight:700, color:UI.oro}}>{abierto?"▲ Ocultar":"▼ Ver"}</span>
      </button>
      {abierto && (
        <div style={{padding:"0 18px 16px"}}>
          <ul style={{margin:"4px 0 0", padding:"0 0 0 4px", listStyle:"none"}}>
            {puntos.map((p,i)=>(
              <li key={i} style={{display:"flex", gap:9, alignItems:"flex-start", fontSize:13, color:UI.textoSuave, lineHeight:1.55, marginBottom:8}}>
                <span style={{color:UI.oro, fontWeight:800, flexShrink:0, marginTop:1}}>•</span>
                <span dangerouslySetInnerHTML={{__html: p.replace(/\*\*(.*?)\*\*/g,"<strong style='color:"+UI.texto+"'>$1</strong>")}}/>
              </li>
            ))}
          </ul>
          <div style={{marginTop:12, paddingTop:11, borderTop:`1px solid ${UI.divisor}`, fontSize:11, color:UI.textoTenue, lineHeight:1.55}}>
            Información general de apoyo. Para casos particulares, consulta a tu asesor.
            <div style={{marginTop:3, opacity:0.85}}>{fundamento}</div>
          </div>
        </div>
      )}
    </div>
  );
  const PUNTOS_VAC = [
    "El derecho a vacaciones **nace cuando el trabajador cumple 1 año** contigo.",
    "Los días **suben con la antigüedad**: 12 el primer año y van aumentando cada año (tabla de la reforma 2023).",
    "Se pagan con **prima vacacional**: al menos **25% extra** sobre esos días.",
    "Lo recomendable es que **las tome dentro de los 6 meses** siguientes a su aniversario.",
    "Conviene **dejar por escrito** cuándo se otorgan o se toman: te protege ante una reclamación.",
  ];
  const PUNTOS_AG = [
    "Es **mínimo 15 días de salario al año** (puedes dar más si quieres).",
    "Se **paga antes del 20 de diciembre**.",
    "Si el trabajador **no cumplió el año**, le corresponde la **parte proporcional** al tiempo trabajado.",
    "Una parte del aguinaldo **está exenta de ISR**; el excedente sí paga impuesto (eso se calcula en **Nómina**).",
  ];

  // El hub desapareció (era un clic sin dato). De sus tarjetas se conserva lo
  // único que informaba algo que no está en otro lado: que PTU viene después.
  const NOTA_PTU = "PTU (reparto de utilidades, art. 122 LFT): próximamente.";

  // ── AGUINALDO ──
  if (vista === "aguinaldo") {
    const hoyAg = new Date();
    const anioAg = hoyAg.getFullYear();
    const estLim = estadoObligacionVencimiento(new Date(anioAg, 11, 20), hoyAg, 0);
    const activosAg = empleados;   // ya vienen filtrados desde la carga (regla única)
    const filasAg = activosAg
      .map((t:any)=> ({ t, a: calcularAguinaldoEmpleado(t.fechaIngreso, t.salarioDiario, diasAg, hoyAg) }))
      .sort((x:any,y:any)=>{
        const rank = (r:any)=> !r.a.valida ? 3 : r.a.futuro ? 2 : (!r.a.tieneSalario ? 1 : 0);
        const d = rank(x)-rank(y); if (d!==0) return d;
        return (y.a.montoProyectado||0)-(x.a.montoProyectado||0);
      });
    // Búsqueda y orden de la TABLA. Los contadores de arriba se calculan sobre
    // `filasAg` completo, así que filtrar aquí no altera los indicadores.
    const _bqA = busqObl.trim().toLowerCase();
    const filasAgVista = (_bqA
        ? filasAg.filter((f:any)=> (f.t.nombre||"").toLowerCase().includes(_bqA) || (f.t.puesto||"").toLowerCase().includes(_bqA))
        : filasAg
      ).slice().sort((x:any,y:any)=>{
        if (ordenAg==="monto") return 0;   // conserva el orden por monto proyectado
        const dir = dirAg==="asc" ? 1 : -1;
        if (ordenAg==="pago") {
          const pg = (f:any)=> tienePagoAg(f.t.id, anioAg) ? 1 : 0;   // sin pago primero en asc
          const d = pg(x)-pg(y); if (d!==0) return d*dir;
          return (x.t.nombre||"").localeCompare((y.t.nombre||""), "es");
        }
        return (x.t.nombre||"").localeCompare((y.t.nombre||""), "es") * dir;
      });
    // Contadores enfocados al PAGO (lo que hace útil el panel para formal e informal).
    const elegiblesAg = filasAg.filter((f:any)=> f.a.valida && !f.a.futuro);
    const nPagados  = elegiblesAg.filter((f:any)=> tienePagoAg(f.t.id, anioAg)).length;
    const nPendPago = elegiblesAg.length - nPagados;
    const totalPagado = elegiblesAg.reduce((s:number,f:any)=> s + totalPagadoAg(f.t.id, anioAg), 0);
    const nSinSal   = filasAg.filter((f:any)=> f.a.valida && !f.a.futuro && !f.a.tieneSalario).length;
    const fmtMXN = (n:number)=> n.toLocaleString("es-MX",{style:"currency",currency:"MXN",maximumFractionDigits:2});
    const fmtF = (d:Date)=> d.toLocaleDateString("es-MX",{day:"2-digit",month:"short",year:"numeric"});
    const thA:any = {textAlign:"left", fontSize:11, fontWeight:800, color:UI.textoTenue, textTransform:"uppercase", letterSpacing:"0.4px", padding:"10px 12px", borderBottom:`1px solid ${UI.divisor}`, whiteSpace:"nowrap"};
    const tdA:any = {fontSize:13, color:UI.texto, padding:"12px 12px", borderBottom:`1px solid ${UI.divisor}`, verticalAlign:"top"};
    const resumenAg = [
      {n: cargando?"·":String(nPagados),   l:"Pagados", col:"#047857"},
      {n: cargando?"·":String(nPendPago),  l:"Pendientes de pago", col: nPendPago>0 ? "#B45309" : UI.texto},
      {n: cargando?"·":fmtMXN(totalPagado),l:"Total pagado", col:UI.texto},
      {n: cargando?"·":(estLim.vencido ? "Vencido" : `${Math.max(0,estLim.diasRestantes)} d`), l:`Para el 20 de diciembre`, col: estLim.vencido ? "#B91C1C" : UI.texto},
    ];

    return (<div style={{minHeight:"100vh", background:UI.fondo, fontFamily:fontSans}}>
      {barra("Aguinaldo", true)}
      <div style={{maxWidth:ANCHO_CONTENIDO, margin:"0 auto", padding:isMobile?"18px 12px 40px":"26px 24px 60px"}}>
        <h1 style={{fontFamily:fontSerif, fontSize:isMobile?20:26, fontWeight:700, color:UI.texto, margin:"0 0 4px"}}>Aguinaldo {anioAg}</h1>
        <p style={{fontSize:13, color:UI.textoSuave, margin:"0 0 18px", lineHeight:1.5}}>Días y montos por empleado (art. 87 LFT), contados por año calendario con su fecha de ingreso y su salario diario del expediente. Debe pagarse antes del <strong>20 de diciembre</strong>.</p>

        {panelInfo(infoAg, ()=>setInfoAg(o=>!o), PUNTOS_AG, "Fundamento: art. 87 de la Ley Federal del Trabajo (aguinaldo).")}

        {/* Configuración: días de aguinaldo de la empresa */}
        <div style={{display:"flex", alignItems:"center", gap:12, flexWrap:"wrap" as const, background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:INI.radio, padding:"14px 16px", boxShadow:UI.sombra, marginBottom:16}}>
          <div style={{minWidth:0, flex:1}}>
            <div style={{fontSize:12.5, fontWeight:800, color:UI.texto}}>Días de aguinaldo de la empresa</div>
            <div style={{fontSize:11.5, color:UI.textoTenue, marginTop:2}}>Mínimo legal 15 días (art. 87 LFT). Si tu empresa otorga más (20, 30), configúralo aquí.</div>
          </div>
          {!agEdit ? (
            <div style={{display:"flex", alignItems:"center", gap:9}}>
              <span style={{fontFamily:fontSerif, fontSize:22, fontWeight:800, color:UI.texto}}>{diasAg} días</span>
              {!diasAgConfigurado && chip("mínimo legal", "#7A8499", "rgba(122,132,153,0.12)", "rgba(122,132,153,0.30)")}
              <button onClick={()=>{ setAgInput(String(diasAg)); setAgEdit(true); }}
                style={{padding:"7px 12px", borderRadius:9, border:`1px solid ${TL.goldBorder}`, background:"transparent", color:UI.oro, cursor:"pointer", fontFamily:fontSans, fontSize:12.5, fontWeight:800}}>Cambiar</button>
            </div>
          ) : (
            <div {...ZONA_DE_CAPTURA} style={{display:"flex", alignItems:"center", gap:8, flexWrap:"wrap" as const}}>
              <input type="number" min={15} value={agInput} onChange={e=>setAgInput(e.target.value)} autoFocus
                style={{width:100, boxSizing:"border-box" as const, padding:"8px 11px", borderRadius:9, border:`1px solid ${UI.oro}`, background:"#fff", color:UI.texto, fontSize:14, fontFamily:fontSans, outline:"none"}}/>
              <button onClick={()=>setAgEdit(false)} style={{padding:"8px 12px", borderRadius:9, border:`1px solid ${TL.goldBorder}`, background:"transparent", color:UI.textoSuave, cursor:"pointer", fontFamily:fontSans, fontSize:12.5, fontWeight:700}}>Cancelar</button>
              <button onClick={guardarDiasAguinaldo} disabled={agGuardando} style={{padding:"8px 14px", borderRadius:9, border:"none", background:UI.oro, color:"#fff", cursor:agGuardando?"wait":"pointer", fontFamily:fontSans, fontSize:12.5, fontWeight:800}}>{agGuardando?"Guardando…":"Guardar"}</button>
            </div>
          )}
        </div>

        {/* El alcance del cálculo se declara: una cifra sin decir sobre quién se
            calculó es tan opaca como un porcentaje sin periodo. */}
        <p style={{fontSize:UI.fsEtiqueta, color:UI.textoTenue, margin:"0 0 14px"}}>
          El cálculo considera únicamente a los trabajadores activos. Los dados de baja quedan fuera.
        </p>
        {/* ── INDICADORES ── filete por ESTADO: ámbar mientras queda gente por
             pagar, rojo si ya pasó el 20 de diciembre, verde cuando está saldado. */}
        <div style={{display:"grid", gridTemplateColumns:isMobile?"repeat(2,1fr)":"repeat(4,1fr)", gap:12, marginBottom:18}}>
          <IndicadorTarjeta isMobile={isMobile} fontSerif={fontSerif}
            etiqueta="Pagados" valor={elegiblesAg.length===0 ? "Sin registrar" : String(nPagados)}
            icono="check" tono={elegiblesAg.length>0 && nPagados===elegiblesAg.length ? UI.ok : UI.navy}
            micro={elegiblesAg.length===0 ? "sin empleados con aguinaldo por calcular" : `de ${elegiblesAg.length} con derecho este año`}/>
          <IndicadorTarjeta isMobile={isMobile} fontSerif={fontSerif}
            etiqueta="Pendientes de pago" valor={elegiblesAg.length===0 ? "Sin registrar" : String(nPendPago)}
            icono="clipboard" tono={nPendPago>0 ? UI.ambar : UI.ok}
            micro={nPendPago>0 ? "sin pago registrado todavía" : "todos con su pago registrado"}/>
          <IndicadorTarjeta isMobile={isMobile} fontSerif={fontSerif}
            etiqueta="Total pagado" valor={totalPagado>0 ? fmtMXN(totalPagado) : "Sin registrar"}
            icono="money" tono={UI.navy}
            micro={totalPagado>0 ? `registrado en ${anioAg}` : `aún no registras pagos de ${anioAg}`}/>
          {/* El plazo del 20-dic es un HECHO de calendario, no una conclusión. */}
          <IndicadorTarjeta isMobile={isMobile} fontSerif={fontSerif}
            etiqueta="Para el 20 de diciembre"
            valor={estLim.vencido ? "Vencido" : `${Math.max(0,estLim.diasRestantes)} días`}
            icono="suite_calendario" tono={estLim.vencido ? (nPendPago>0 ? UI.rojo : UI.ok) : UI.navy}
            micro={estLim.vencido ? (nPendPago>0 ? `${nPendPago} sin pago registrado — revisar` : "todo pagado dentro del año") : "plazo del art. 87 LFT"}/>
        </div>

        {errorCarga && <div style={{fontSize:13, color:"#B91C1C", background:"rgba(220,38,38,0.08)", border:"1px solid rgba(220,38,38,0.25)", borderRadius:10, padding:"11px 14px", marginBottom:16}}>{errorCarga}</div>}
        {nSinSal>0 && !cargando && <div style={{fontSize:12.5, color:"#B45309", background:"rgba(217,119,6,0.10)", border:"1px solid rgba(217,119,6,0.30)", borderRadius:10, padding:"10px 14px", marginBottom:16}}>{nSinSal} empleado{nSinSal===1?"":"s"} sin salario capturado: su monto no se puede calcular. Complétalo en <strong>Empleados</strong>.</div>}
        {!cargando && activosAg.length>0 && (
          <div style={{display:"flex", gap:10, marginBottom:14, flexWrap:"wrap" as const, alignItems:"center"}}>
            <input {...CAMPO_DE_PARAMETRO} value={busqObl} onChange={e=>setBusqObl(e.target.value)} placeholder="Buscar por nombre o puesto…"
              style={{flex:1, minWidth:220, background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rControl,
                padding:"9px 13px", color:UI.texto, fontSize:UI.fsCuerpo, outline:"none", fontFamily:fontSans, boxSizing:"border-box" as const}} />
          </div>
        )}

        {cargando ? (
          <div style={{fontSize:13, color:UI.textoSuave, padding:"24px 4px"}}>Cargando empleados…</div>
        ) : activosAg.length===0 ? (
          <div style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:INI.radio, padding:"28px 20px", textAlign:"center" as const, boxShadow:UI.sombra}}>
            <div style={{fontSize:14, fontWeight:700, color:UI.texto, marginBottom:4}}>Sin empleados activos</div>
            <div style={{fontSize:12.5, color:UI.textoSuave}}>Registra empleados con su fecha de ingreso y salario en la sección Empleados.</div>
          </div>
        ) : (
          <div style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rPanel, boxShadow:UI.sombra, overflow:"hidden"}}>
            <div style={{height:2, background:`linear-gradient(90deg, ${UI.oro}, ${UI.oro}00)`}}/>
            {/* Sin minWidth: seis columnas más la acción caben en una laptop. */}
            <div style={{maxHeight:`calc(100vh - 460px - ${ZOCALO_FLOTANTES}px)`, minHeight:220, overflowY:"auto" as const}}>
              <table style={{width:"100%", borderCollapse:"separate" as const, borderSpacing:0}}>
                <EncabezadoTabla ordenCol={ordenAg} ordenDir={dirAg}
                  onOrdenar={(col,dir)=>{ setOrdenAg(col as any); setDirAg(dir); }}
                  columnas={[
                    {k:"nombre", t:"Trabajador", orden:true, al:"left"},
                    {k:"sd", t:"Salario diario", orden:false, al:"right"},
                    {k:"dias", t:"Días", orden:false, al:"center"},
                    {k:"proy", t:"Proyectado al 31-dic", orden:false, al:"right"},
                    {k:"dev", t:"Devengado a hoy", orden:false, al:"right"},
                    {k:"pago", t:"Estatus de pago", orden:true, al:"left"},
                    {k:"acc", t:"", orden:false, al:"right"},
                  ]}/>
                <tbody>
                  {filasAgVista.map(({t, a}:any)=>{
                    const tdA2:any = {padding:"11px 14px", borderTop:`1px solid ${UI.divisor}`, fontSize:UI.fsCuerpo, color:UI.textoSuave, verticalAlign:"top"};
                    const pagado = tienePagoAg(t.id, anioAg);
                    const up = pagado ? ultimoPagoAg(t.id, anioAg) : null;
                    return (
                    <tr key={t.id}
                      onMouseEnter={(e)=>{ e.currentTarget.style.background = UI.hover; }}
                      onMouseLeave={(e)=>{ e.currentTarget.style.background = "transparent"; }}
                      style={{transition:"background .12s"}}>
                      <td style={{...tdA2, verticalAlign:"middle"}}>
                        <div style={{display:"flex", alignItems:"center", gap:11, minWidth:0}}>
                          <AvatarPersona nombre={t.nombre||""} fotoUrl={(t as any).fotoPerfilUrl} size={34} fontSerif={fontSerif}/>
                          <div style={{minWidth:0}}>
                            <div style={{fontFamily:fontSerif, fontSize:UI.fsNombre, fontWeight:700, color:UI.texto,
                              whiteSpace:"nowrap" as const, overflow:"hidden", textOverflow:"ellipsis"}}>{t.nombre||"—"}</div>
                            <div style={{fontSize:UI.fsEtiqueta, color:UI.textoTenue, marginTop:2,
                              whiteSpace:"nowrap" as const, overflow:"hidden", textOverflow:"ellipsis"}}>{t.puesto || "Sin puesto"}</div>
                          </div>
                        </div>
                      </td>
                      {!a.valida ? (
                        <td style={{...tdA2, color:UI.textoTenue}} colSpan={6}>Falta su fecha de ingreso — complétala en <strong>Empleados</strong> para calcular su aguinaldo.</td>
                      ) : a.futuro ? (
                        <td style={{...tdA2, color:UI.textoTenue}} colSpan={6}>Su fecha de ingreso es posterior a este año.</td>
                      ) : (
                        <>
                          <td style={{...tdA2, textAlign:"right" as const, whiteSpace:"nowrap" as const, color: a.tieneSalario?UI.textoSuave:UI.textoTenue}}>{a.tieneSalario ? fmtMXN(a.salarioDiario) : "Sin salario"}</td>
                          <td style={{...tdA2, textAlign:"center" as const, color:UI.texto, fontWeight:600, whiteSpace:"nowrap" as const}}>{a.diasProyectados.toFixed(1)}</td>
                          {/* Proyectado: debajo, por qué la cifra es la que es. Si es
                              proporcional se dice DESDE CUÁNDO, que es el dato que
                              permite verificarla sin abrir la ficha. */}
                          <td style={{...tdA2, textAlign:"right" as const, whiteSpace:"nowrap" as const}}>
                            <div style={{color:UI.texto, fontWeight:700}}>{a.montoProyectado!=null ? fmtMXN(a.montoProyectado) : "—"}</div>
                            <div style={{fontSize:UI.fsEtiqueta, color:UI.textoTenue, marginTop:2}}>
                              {a.proporcional ? `Proporcional desde ${fmtF(a.ingreso)}` : "Completo"}
                            </div>
                          </td>
                          <td style={{...tdA2, textAlign:"right" as const, whiteSpace:"nowrap" as const}}>
                            <div style={{color:UI.texto, fontWeight:600}}>{a.montoDevengado!=null ? fmtMXN(a.montoDevengado) : "—"}</div>
                            <div style={{fontSize:UI.fsEtiqueta, color:UI.textoTenue, marginTop:2}}>{a.diasTrabajadosAnio} día{a.diasTrabajadosAnio===1?"":"s"} del año</div>
                          </td>
                          <td style={tdA2}>
                            {pagado ? (
                              <>
                                <ChipEstado texto={`✓ Pagado el ${up?.fecha ? fmtF(new Date(up.fecha+"T00:00:00")) : "—"}`} tono="ok"/>
                                <div style={{fontSize:UI.fsEtiqueta, color:UI.textoTenue, marginTop:4}}>{fmtMXN(totalPagadoAg(t.id, anioAg))} registrado</div>
                              </>
                            ) : <ChipEstado texto="Sin pago registrado" tono="pendiente"/>}
                          </td>
                          <td style={{...tdA2, textAlign:"right" as const, whiteSpace:"nowrap" as const, verticalAlign:"middle"}}>
                            <button onClick={()=>abrirAgReg(t, a, anioAg)}
                              style={{background:"transparent", border:"none", cursor:"pointer", fontFamily:fontSans,
                                fontSize:UI.fsEtiqueta, fontWeight:700, color:UI.navy, padding:"2px 0"}}>
                              {pagado ? "Ver / editar pago ›" : "Registrar pago ›"}
                            </button>
                          </td>
                        </>
                      )}
                    </tr>
                  );})}
                </tbody>
              </table>
            </div>
            <div style={{padding:"9px 14px", borderTop:`1px solid ${UI.divisor}`, fontSize:10.5, color:UI.textoTenue, background:UI.superficie}}>
              Mostrando {filasAgVista.length} de {filasAg.length} trabajador{filasAg.length===1?"":"es"} activo{filasAg.length===1?"":"s"}
              {nSinSal>0 ? ` · ${nSinSal} sin salario registrado` : ""}
            </div>
          </div>
        )}

        <div style={{marginTop:16, fontSize:11.5, color:UI.textoTenue, lineHeight:1.6, background:"rgba(184,147,42,0.06)", border:`1px solid ${TL.goldBorder}`, borderRadius:12, padding:"12px 15px"}}>
          <strong style={{color:UI.textoSuave}}>Nota:</strong> montos <strong>brutos</strong>. La retención de ISR aplicable (el aguinaldo tiene exención de 30 UMA y el excedente es gravable) se calcula en <strong>Nómina</strong>. Información de apoyo y proyección; no constituye determinación legal ni fiscal. El proyectado/devengado son estimaciones sobre el salario del expediente; el pago real es el que registres en la columna de estatus.
        </div>
      </div>

      {agRegModal && (()=>{ const {t, a, anio} = agRegModal; const pagos = pagosAguinaldoDe(t.id, anio); const totPag = pagos.reduce((s:number,r:any)=> s+(Number(r.monto)||0),0);
        return (
        <div style={{position:"fixed" as const, inset:0, zIndex:3000, background:"rgba(11,24,41,0.55)", display:"flex", alignItems:"flex-start", justifyContent:"center", padding:"18px", overflowY:"auto" as const, backdropFilter:"blur(3px)"}}>
          <div {...PANEL_DE_CAPTURA} onClick={e=>e.stopPropagation()} style={{width:"100%", maxWidth:580, background:UI.fondo, borderRadius:16, boxShadow:"0 24px 70px rgba(0,0,0,0.5)", overflow:"hidden"}}>
            <div style={{background:T.navy, padding:"14px 20px", display:"flex", alignItems:"center", justifyContent:"space-between", gap:12}}>
              <div style={{minWidth:0}}>
                <div style={{fontFamily:fontSerif, fontSize:16, fontWeight:700, color:"white"}}>Aguinaldo {anio} · {t.nombre||"—"}</div>
                <div style={{fontSize:11.5, color:"rgba(255,255,255,0.6)", marginTop:1}}>{a?.montoProyectado!=null ? `Proyectado ${fmtMXN(a.montoProyectado)} · ${a.diasProyectados.toFixed(1)} de ${diasAg} días` : "Sin salario capturado en el expediente"} · pagado {fmtMXN(totPag)}</div>
              </div>
              <button onClick={(ev)=>{ if (sePuedeCerrarElPanel(ev)) setAgRegModal(null); }} aria-label="Cerrar" style={{background:"rgba(255,255,255,0.10)", border:"none", color:"white", width:30, height:30, borderRadius:8, cursor:"pointer", fontSize:15}}>✕</button>
            </div>
            <div style={{padding:"18px 20px", maxHeight:"calc(100vh - 150px)", overflowY:"auto" as const}}>
              {/* Formulario de pago (o edición) — ACCIÓN PRINCIPAL. Marcado por
                  lo mismo que el de vacaciones: debajo van los pagos registrados. */}
              <div {...CAMPOS_DE_CAPTURA} style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:INI.radio, padding:"14px 16px", boxShadow:UI.sombra, marginBottom:16}}>
                <div style={{fontSize:12.5, fontWeight:800, color:UI.texto, marginBottom:10}}>{agRegEditId ? "Editar pago" : "Registrar pago de aguinaldo"}</div>
                <div style={{display:"flex", gap:10, flexWrap:"wrap" as const}}>
                  <div style={{flex:"1 1 150px"}}>
                    <label style={{display:"block", fontSize:11, fontWeight:700, color:UI.textoSuave, marginBottom:4}}>Fecha de pago</label>
                    <input type="date" value={agRegFecha} onChange={e=>setAgRegFecha(e.target.value)}
                      style={{width:"100%", boxSizing:"border-box" as const, padding:"9px 11px", borderRadius:9, border:`1px solid ${UI.divisor}`, fontSize:13.5, fontFamily:fontSans, background:"#fff", color:UI.texto}}/>
                  </div>
                  <div style={{flex:"1 1 150px"}}>
                    <label style={{display:"block", fontSize:11, fontWeight:700, color:UI.textoSuave, marginBottom:4}}>Monto pagado (MXN)</label>
                    <input type="number" min={1} step="0.01" value={agRegMonto} onChange={e=>setAgRegMonto(e.target.value)} placeholder={a?.montoProyectado!=null?`sugerido ${Math.round(a.montoProyectado*100)/100}`:"monto"}
                      style={{width:"100%", boxSizing:"border-box" as const, padding:"9px 11px", borderRadius:9, border:`1px solid ${UI.divisor}`, fontSize:13.5, fontFamily:fontSans, background:"#fff", color:UI.texto}}/>
                  </div>
                </div>
                <label style={{display:"block", fontSize:11, fontWeight:700, color:UI.textoSuave, margin:"10px 0 4px"}}>Nota (opcional)</label>
                <input value={agRegNota} onChange={e=>setAgRegNota(e.target.value)} placeholder="Ej. pagado en efectivo, transferencia…"
                  style={{width:"100%", boxSizing:"border-box" as const, padding:"9px 11px", borderRadius:9, border:`1px solid ${UI.divisor}`, fontSize:13.5, fontFamily:fontSans, background:"#fff", color:UI.texto}}/>
                {agRegError && <div style={{marginTop:10, fontSize:12.5, color:"#B91C1C", background:"rgba(220,38,38,0.08)", border:"1px solid rgba(220,38,38,0.25)", borderRadius:9, padding:"9px 12px"}}>{agRegError}</div>}
                <div style={{display:"flex", gap:8, marginTop:12}}>
                  {agRegEditId && <button onClick={()=>{ setAgRegEditId(null); setAgRegFecha(new Date().toISOString().slice(0,10)); setAgRegMonto(""); setAgRegNota(""); setAgRegError(""); }} style={{padding:"9px 14px", borderRadius:9, border:`1px solid ${UI.divisor}`, background:"transparent", color:UI.textoSuave, cursor:"pointer", fontFamily:fontSans, fontSize:12.5, fontWeight:700}}>Cancelar edición</button>}
                  <button onClick={guardarPagoAg} disabled={agRegGuardando}
                    style={{padding:"9px 16px", borderRadius:9, border:"none", background:gold, color:"#0B1829", cursor:agRegGuardando?"wait":"pointer", fontFamily:fontSans, fontSize:12.5, fontWeight:800}}>{agRegGuardando?"Guardando…":agRegEditId?"Guardar cambios":"Registrar pago"}</button>
                </div>
              </div>
              {/* Historial de pagos del año */}
              <div style={{fontSize:11.5, fontWeight:700, color:UI.textoTenue, textTransform:"uppercase" as const, letterSpacing:"0.5px", margin:"0 2px 8px"}}>Pagos registrados de {anio}</div>
              {pagos.length===0 ? (
                <div style={{fontSize:12.5, color:UI.textoSuave, padding:"6px 2px"}}>Aún no hay pagos registrados este año.</div>
              ) : (
                <div style={{display:"flex", flexDirection:"column" as const, gap:8}}>
                  {pagos.map((r:any)=>{ const firmadaEl = fmtActaFirmada(r); return (
                    <div key={r.id} style={{display:"flex", flexDirection:"column" as const, gap:8, background:UI.superficie, border:`1px solid ${UI.divisor}`, borderRadius:10, padding:"9px 12px"}}>
                      <div style={{display:"flex", alignItems:"center", gap:10}}>
                        <div style={{flex:1, minWidth:0}}>
                          <div style={{fontSize:13, fontWeight:700, color:UI.texto}}>{fmtMXN(Number(r.monto)||0)} · {r.fecha ? new Date(r.fecha+"T00:00:00").toLocaleDateString("es-MX",{day:"2-digit",month:"short",year:"numeric"}) : "—"}</div>
                          {r.nota && <div style={{fontSize:11.5, color:UI.textoTenue, marginTop:1}}>{r.nota}</div>}
                        </div>
                        <button onClick={()=>editarPagoAg(r)} style={{padding:"6px 10px", borderRadius:8, border:`1px solid ${TL.goldBorder}`, background:"transparent", color:UI.oro, cursor:"pointer", fontFamily:fontSans, fontSize:11.5, fontWeight:700}}>Editar</button>
                        <button onClick={()=>eliminarPagoAg(r)} style={{padding:"6px 10px", borderRadius:8, border:"1px solid rgba(220,38,38,0.35)", background:"rgba(220,38,38,0.06)", color:"#B91C1C", cursor:"pointer", fontFamily:fontSans, fontSize:11.5, fontWeight:700}}>Eliminar</button>
                      </div>
                      {/* Constancia — SECUNDARIA/opcional. Mismo desacople que el acta de
                          vacaciones: generar/descargar SIEMPRE; enviar solo con correo. */}
                      {(()=>{ const sinCorreoAg = !((t?.email||"").trim()); return (<>
                      <div style={{display:"flex", alignItems:"center", gap:10, flexWrap:"wrap" as const, borderTop:`1px dashed ${UI.divisor}`, paddingTop:8}}>
                        <button onClick={()=>generarConstanciaAguinaldo(r)} disabled={agConstGenId===r.id}
                          style={{padding:"6px 11px", borderRadius:8, border:`1px solid ${UI.divisor}`, background:"transparent", color:UI.textoSuave, cursor:agConstGenId===r.id?"wait":"pointer", opacity:agConstGenId===r.id?0.6:1, fontFamily:fontSans, fontSize:11.5, fontWeight:700}}>{agConstGenId===r.id ? "Generando…" : r.documentoUrl ? "Regenerar constancia" : "Generar constancia (opcional)"}</button>
                        {r.documentoUrl && <a href={r.documentoUrl} target="_blank" rel="noreferrer" style={{fontSize:11.5, color:UI.oro, fontWeight:700, textDecoration:"none", padding:"5px 9px", background:TL.goldSoft, borderRadius:7, border:`1px solid ${TL.goldBorder}`}}>Descargar / ver constancia →</a>}
                        {r.documentoUrl && (
                          <button onClick={()=>enviarConstanciaAguinaldo(r)} disabled={sinCorreoAg || agConstEnvId===r.id}
                            title={sinCorreoAg ? "Para enviarla al trabajador, agrega su correo en la ficha" : "Enviar la constancia al trabajador (la verá en Mis reportes)"}
                            style={{padding:"6px 11px", borderRadius:8, border:`1px solid ${UI.divisor}`, background:"transparent", color:sinCorreoAg?UI.textoTenue:UI.textoSuave, cursor:sinCorreoAg?"not-allowed":(agConstEnvId===r.id?"wait":"pointer"), opacity:sinCorreoAg?0.6:1, fontFamily:fontSans, fontSize:11.5, fontWeight:700}}>{agConstEnvId===r.id ? "Enviando…" : r.documentoEnviadoEn ? "Reenviar al trabajador" : "Enviar al trabajador"}</button>
                        )}
                        {r.documentoUrl && <label style={{display:"inline-flex", alignItems:"center", gap:6, fontSize:11.5, color:UI.textoSuave, cursor:"pointer", fontWeight:700, marginLeft:"auto"}}>
                          <input type="checkbox" checked={!!r.documentoFirmado} onChange={()=>toggleConstanciaFirmada(r)} style={{width:15, height:15, accentColor:gold, cursor:"pointer"}}/>
                          Constancia firmada{firmadaEl ? ` · ${firmadaEl}` : ""}
                        </label>}
                      </div>
                      {r.documentoUrl && sinCorreoAg && (
                        <div style={{fontSize:11, color:UI.textoTenue, lineHeight:1.4}}>Para enviarla al trabajador, agrega su correo en la ficha. Mientras tanto puedes descargarla e imprimirla para firma física.</div>
                      )}
                      {r.documentoUrl && (
                        <div style={{display:"flex", alignItems:"center", gap:10, flexWrap:"wrap" as const}}>
                          <SubirArchivoBtn userId={currentUser.uid} carpeta="empleados"
                            label={r.documentoFirmadoUrl ? "Reemplazar constancia firmada" : "Subir constancia firmada (escaneo/foto)"}
                            accept=".pdf,.jpg,.jpeg,.png" maxMB={10}
                            onSubido={(u,n)=> registrarConstanciaFirmadaSubida(r, u, n)} />
                          {r.documentoFirmadoUrl && <a href={r.documentoFirmadoUrl} target="_blank" rel="noreferrer" style={{fontSize:11.5, color:"#047857", fontWeight:700, textDecoration:"none"}}>Ver constancia firmada →</a>}
                        </div>
                      )}
                      </>); })()}
                      {agConstMsg && agConstMsg.id===r.id && <div style={{fontSize:11.5, fontWeight:700, color: agConstMsg.ok ? "#047857" : "#B91C1C"}}>{agConstMsg.txt}</div>}
                    </div>); })}
                </div>
              )}
              <div style={{marginTop:14, fontSize:11, color:UI.textoTenue, lineHeight:1.55}}>La constancia es un comprobante <strong>complementario</strong> y opcional: el aguinaldo se comprueba fiscalmente con el recibo de nómina (CFDI). Información de apoyo; no constituye determinación legal ni fiscal.</div>
            </div>
          </div>
        </div>); })()}
    </div>);
  }

  // ── VACACIONES ──
  const hoy = new Date();
  const activos = empleados;   // ya vienen filtrados desde la carga (regla única)
  const DAY = 86400000;
  const filas = activos
    .map((t:any)=> {
      const v = calcularVacacionesEmpleado(t.fechaIngreso, hoy);
      const yaAplica = !!(v.valida && v.yaAplica);
      const diasTotal = yaAplica ? (Number(v.dias)||0) : 0;
      const tomados = yaAplica ? diasTomadosDe(t.id, v) : 0;
      // Cumplido cuando lo tomado ALCANZA O SUPERA el total (>= numérico, con épsilon
      // para tolerar cualquier decimal). Al cumplir: pendientes 0 y sin riesgo.
      const cumplido = yaAplica && diasTotal>0 && (tomados + 1e-6) >= diasTotal;
      const pendientes = cumplido ? 0 : (yaAplica ? Math.max(0, Math.round((diasTotal - tomados)*100)/100) : 0);
      // El riesgo solo aplica si NO está cumplido, quedan pendientes y venció el plazo.
      const riesgo = !!v.plazoVencido && !cumplido && pendientes>0;
      return { t, v, per: periodoISO(v), tomados, pendientes, cumplido, riesgo };
    })
    .sort((a:any,b:any)=>{
      // orden: en riesgo → con derecho pendiente → por cumplir → cumplido → sin fecha/futuro
      const rank = (x:any)=> !x.v.valida || x.v.futuro ? 5 : x.v.yaAplica ? (x.riesgo?0 : x.cumplido?3 : 1) : 2;
      const r = rank(a)-rank(b);
      if (r!==0) return r;
      return (a.t.nombre||"").localeCompare(b.t.nombre||"");
    });

  const conDerecho = filas.filter((f:any)=> f.v.valida && f.v.yaAplica).length;
  const porCumplir = filas.filter((f:any)=> f.v.valida && !f.v.yaAplica && !f.v.futuro).length;
  const enRiesgo   = filas.filter((f:any)=> f.riesgo).length;
  const cumplidos  = filas.filter((f:any)=> f.cumplido).length;
  const sinFecha   = filas.filter((f:any)=> !f.v.valida || f.v.futuro).length;

  const fmtFecha = (d:Date)=> d.toLocaleDateString("es-MX",{day:"2-digit",month:"short",year:"numeric"});
  const antigTxt = (v:any)=>{
    if (!v.valida) return "—";
    if (v.futuro) return "Ingreso futuro";
    if (v.anios>=1) return `${v.anios} año${v.anios===1?"":"s"}`;
    const meses = Math.max(0, Math.floor((hoy.getTime()-v.ingreso.getTime())/(DAY*30.4375)));
    return `${meses} mes${meses===1?"":"es"}`;
  };

  // Filtro y orden del listado. El orden por defecto (riesgo primero) ya viene
  // de `filas`; al pedir un orden explícito manda el de la columna.
  const _bqV = busqObl.trim().toLowerCase();
  const filasVac = (_bqV
      ? filas.filter((f:any)=> (f.t.nombre||"").toLowerCase().includes(_bqV) || (f.t.puesto||"").toLowerCase().includes(_bqV))
      : filas
    ).slice().sort((a:any,b:any)=>{
      const dir = dirObl==="asc" ? 1 : -1;
      if (ordenObl==="pendientes") return ((a.pendientes||0) - (b.pendientes||0)) * dir;
      return (a.t.nombre||"").localeCompare((b.t.nombre||""), "es") * dir;
    });

  return (<div style={{background:UI.fondo, minHeight:`calc(100vh - 100px - ${ZOCALO_FLOTANTES}px)`, fontFamily:fontSans}}>
    {barra()}
    <div style={{maxWidth:ANCHO_CONTENIDO, margin:"0 auto", padding:isMobile?"18px 12px 40px":"18px 24px 40px"}}>
      <h1 style={{fontFamily:fontSerif, fontSize:isMobile?20:26, fontWeight:700, color:UI.texto, margin:"0 0 4px"}}>Vacaciones</h1>
      <p style={{fontSize:UI.fsCuerpo, color:UI.textoSuave, margin:"0 0 4px", lineHeight:1.5}}>Días por antigüedad (art. 76 LFT, reforma 2023) y plazo de otorgamiento de 6 meses (art. 81 LFT).</p>
      <p style={{fontSize:UI.fsEtiqueta, color:UI.textoTenue, margin:"0 0 4px"}}>{NOTA_PTU}</p>
      <p style={{fontSize:UI.fsEtiqueta, color:UI.textoTenue, margin:"0 0 18px"}}>El cálculo considera únicamente a los trabajadores activos. Los dados de baja quedan fuera.</p>

      {/* EL CANDADO DE LOS DOS DOCUMENTOS DE ESTE MODULO. Los calculos, las
          tablas y el registro de la toma siguen funcionando: nada de eso afirma
          quien es la empresa. Lo que no se emite es el acta y la constancia. */}
      {dp.faltan.length > 0 && (
        <AvisoFaltanDatosPatron faltan={dp.faltan} que="El acta de vacaciones y la constancia de aguinaldo"
          fontSans={fontSans} fontSerif={fontSerif}/>
      )}

      {panelInfo(infoVac, ()=>setInfoVac(o=>!o), PUNTOS_VAC, "Fundamento: arts. 76, 78, 80 y 81 de la Ley Federal del Trabajo (reforma 'Vacaciones Dignas' 2023).")}

      {/* ── INDICADORES ── el filete dice ESTADO: navy es magnitud neutra, rojo
           avisa que hay plazos vencidos por revisar y verde que no queda ninguno. */}
      <div style={{display:"grid", gridTemplateColumns:isMobile?"repeat(2,1fr)":"repeat(4,1fr)", gap:12, marginBottom:18}}>
        <IndicadorTarjeta isMobile={isMobile} fontSerif={fontSerif}
          etiqueta="Ya tienen derecho" valor={activos.length===0 ? "Sin registrar" : String(conDerecho)}
          icono="user_single" tono={UI.navy}
          micro={activos.length===0 ? "sin empleados activos"
               : sinFecha>0 ? `${sinFecha} sin fecha de ingreso`
               : `de ${activos.length} activo${activos.length===1?"":"s"}`}/>
        <IndicadorTarjeta isMobile={isMobile} fontSerif={fontSerif}
          etiqueta="Por cumplir el año" valor={activos.length===0 ? "Sin registrar" : String(porCumplir)}
          icono="suite_calendario" tono={UI.navy}
          micro={porCumplir>0 ? "aún sin derecho a vacaciones" : "ninguno en espera"}/>
        <IndicadorTarjeta isMobile={isMobile} fontSerif={fontSerif}
          etiqueta="Cumplidos este periodo" valor={activos.length===0 ? "Sin registrar" : String(cumplidos)}
          icono="check" tono={conDerecho>0 && cumplidos===conDerecho ? UI.ok : UI.navy}
          micro={conDerecho===0 ? "nadie con derecho todavía"
               : cumplidos===conDerecho ? "todos los que tienen derecho" : `de ${conDerecho} con derecho`}/>
        {/* Riesgo: se enuncia como algo POR REVISAR, nunca como prescripción. */}
        <IndicadorTarjeta isMobile={isMobile} fontSerif={fontSerif}
          etiqueta="Plazo vencido (revisar)" valor={activos.length===0 ? "Sin registrar" : String(enRiesgo)}
          icono="alert" tono={enRiesgo>0 ? UI.rojo : UI.ok}
          micro={enRiesgo>0 ? "pasaron los 6 meses del art. 81" : "ninguno fuera de plazo"}/>
      </div>

      {errorCarga && <div style={{fontSize:UI.fsCuerpo, color:UI.rojo, background:UI.rojoBg, border:`1px solid ${UI.rojo}40`, borderRadius:UI.rControl, padding:"10px 12px", marginBottom:14}}>{errorCarga}</div>}

      {!cargando && activos.length>0 && (
        <div style={{display:"flex", gap:10, marginBottom:14, flexWrap:"wrap" as const, alignItems:"center"}}>
          <input {...CAMPO_DE_PARAMETRO} value={busqObl} onChange={e=>setBusqObl(e.target.value)} placeholder="Buscar por nombre o puesto…"
            style={{flex:1, minWidth:220, background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rControl,
              padding:"9px 13px", color:UI.texto, fontSize:UI.fsCuerpo, outline:"none", fontFamily:fontSans, boxSizing:"border-box" as const}} />
        </div>
      )}

      {cargando ? (
        <div style={{textAlign:"center" as const, padding:60, color:UI.textoSuave, background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rPanel}}>Cargando empleados…</div>
      ) : filasVac.length===0 ? (
        <EstadoVacio
          titulo={activos.length===0 ? "Sin empleados activos" : "Ningún trabajador coincide"}
          texto={activos.length===0
            ? "Las vacaciones se calculan con la fecha de ingreso de cada trabajador. Da de alta a tu plantilla en Empleados y aquí verás sus días, su plazo de otorgamiento y qué falta por otorgar."
            : "Prueba con otro texto de búsqueda."}
          acciones={activos.length===0 ? [] : [{t:"Quitar la búsqueda", principal:false, fn:()=>setBusqObl("")}]}
          variante={activos.length===0 ? "sin-datos" : "sin-coincidencias"}
          fontSans={fontSans} fontSerif={fontSerif}
        />
      ) : (
        <div style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rPanel, boxShadow:UI.sombra, overflow:"hidden"}}>
          <div style={{height:2, background:`linear-gradient(90deg, ${UI.oro}, ${UI.oro}00)`}}/>
          {/* Sin minWidth: las seis columnas más la acción caben en una laptop,
              así que no se fuerza desplazamiento lateral. El texto largo del
              estado envuelve en su celda en vez de empujar la tabla a lo ancho. */}
          <div style={{maxHeight:`calc(100vh - 420px - ${ZOCALO_FLOTANTES}px)`, minHeight:220, overflowY:"auto" as const}}>
            <table style={{width:"100%", borderCollapse:"separate" as const, borderSpacing:0}}>
              <EncabezadoTabla ordenCol={ordenObl} ordenDir={dirObl}
                onOrdenar={(col,dir)=>{ setOrdenObl(col as any); setDirObl(dir); }}
                columnas={[
                  {k:"nombre", t:"Trabajador", orden:true, al:"left"},
                  {k:"antig", t:"Antigüedad", orden:false, al:"left"},
                  {k:"corresponden", t:"Le corresponden", orden:false, al:"center"},
                  {k:"tomados", t:"Tomados", orden:false, al:"center"},
                  {k:"pendientes", t:"Pendientes", orden:true, al:"center"},
                  {k:"estado", t:"Estado del periodo", orden:false, al:"left"},
                  {k:"acc", t:"", orden:false, al:"right"},
                ]}/>
              <tbody>
                {filasVac.map(({t, v, tomados, pendientes, cumplido, riesgo}:any)=>{
                  const tdBase:any = {padding:"11px 14px", borderTop:`1px solid ${UI.divisor}`, fontSize:UI.fsCuerpo, color:UI.textoSuave, verticalAlign:"top"};
                  const num:any = {...tdBase, textAlign:"center", color:UI.texto, fontWeight:600, whiteSpace:"nowrap"};
                  const aplica = v.valida && !v.futuro && v.yaAplica;
                  return (
                    <tr key={t.id}
                      onMouseEnter={(e)=>{ e.currentTarget.style.background = UI.hover; }}
                      onMouseLeave={(e)=>{ e.currentTarget.style.background = "transparent"; }}
                      style={{transition:"background .12s"}}>
                      {/* Trabajador */}
                      <td style={{...tdBase, verticalAlign:"middle"}}>
                        <div style={{display:"flex", alignItems:"center", gap:11, minWidth:0}}>
                          <AvatarPersona nombre={t.nombre||""} fotoUrl={(t as any).fotoPerfilUrl} size={34} fontSerif={fontSerif}/>
                          <div style={{minWidth:0}}>
                            <div style={{fontFamily:fontSerif, fontSize:UI.fsNombre, fontWeight:700, color:UI.texto,
                              whiteSpace:"nowrap" as const, overflow:"hidden", textOverflow:"ellipsis"}}>{t.nombre||"—"}</div>
                            <div style={{fontSize:UI.fsEtiqueta, color:UI.textoTenue, marginTop:2,
                              whiteSpace:"nowrap" as const, overflow:"hidden", textOverflow:"ellipsis"}}>{t.puesto || "Sin puesto"}</div>
                          </div>
                        </div>
                      </td>
                      {/* Antigüedad */}
                      <td style={{...tdBase, whiteSpace:"nowrap" as const}}>{antigTxt(v)}</td>
                      {/* Le corresponden · Tomados · Pendientes — sin derecho aún, un
                          guion en vez de un 0: no haber cumplido el año no es una falta. */}
                      <td style={num}>{aplica ? `${v.dias}` : "—"}</td>
                      <td style={num}>{aplica ? `${tomados}` : "—"}</td>
                      <td style={{...num, color: aplica && pendientes>0 ? UI.ambar : UI.texto}}>{aplica ? `${pendientes}` : "—"}</td>
                      {/* Estado del periodo */}
                      <td style={{...tdBase, minWidth:230}}>
                        {!v.valida ? (
                          <>
                            <ChipEstado texto="Falta fecha de ingreso" tono="neutro"/>
                            <div style={{fontSize:UI.fsEtiqueta, color:UI.textoTenue, marginTop:4, lineHeight:1.4}}>Complétala en Empleados para calcular sus vacaciones.</div>
                          </>
                        ) : v.futuro ? (
                          <ChipEstado texto="Ingreso futuro" tono="neutro"/>
                        ) : !v.yaAplica ? (
                          <>
                            <ChipEstado texto={`Aún sin derecho · cumple el ${fmtFecha(v.proximoAniversario)}`} tono="neutro"/>
                            <div style={{fontSize:UI.fsEtiqueta, color:UI.textoTenue, marginTop:4, lineHeight:1.4}}>Le faltan {v.diasParaAniversario} día{v.diasParaAniversario===1?"":"s"} para tener derecho.</div>
                          </>
                        ) : cumplido ? (
                          <>
                            <ChipEstado texto="✓ Cumplido este periodo" tono="ok"/>
                            <div style={{fontSize:UI.fsEtiqueta, color:UI.textoTenue, marginTop:4}}>Con derecho desde {fmtFecha(v.desde)}</div>
                          </>
                        ) : riesgo ? (
                          <>
                            <ChipEstado texto="⚠ Atención" tono="critico"/>
                            {/* Fecha límite en peso normal: es el único dato accionable. */}
                            <div style={{fontSize:UI.fsCuerpo, color:UI.texto, marginTop:4, lineHeight:1.4}}>Fecha límite: {fmtFecha(v.finPlazo)} — vencida</div>
                            <div style={{fontSize:UI.fsEtiqueta, color:UI.textoTenue, marginTop:3}}>Con derecho desde {fmtFecha(v.desde)}</div>
                          </>
                        ) : (
                          <>
                            <ChipEstado texto="✓ En orden" tono="ok"/>
                            <div style={{fontSize:UI.fsCuerpo, color:UI.texto, marginTop:4, lineHeight:1.4}}>Fecha límite: {fmtFecha(v.finPlazo)}
                              <span style={{color:UI.textoTenue}}> · quedan {Math.max(0,v.diasRestantesPlazo)} día{v.diasRestantesPlazo===1?"":"s"}</span></div>
                            <div style={{fontSize:UI.fsEtiqueta, color:UI.textoTenue, marginTop:3}}>Con derecho desde {fmtFecha(v.desde)}</div>
                          </>
                        )}
                      </td>
                      {/* Acción única de la fila */}
                      <td style={{...tdBase, textAlign:"right" as const, whiteSpace:"nowrap" as const, verticalAlign:"middle"}}>
                        {aplica ? (
                          <button onClick={()=>abrirRegistro(t, v)}
                            style={{background:"transparent", border:"none", cursor:"pointer", fontFamily:fontSans,
                              fontSize:UI.fsEtiqueta, fontWeight:700, color:UI.navy, padding:"2px 0"}}>
                            {tomados>0 ? "Registrar / ver ›" : "Registrar tomadas ›"}
                          </button>
                        ) : <span style={{fontSize:UI.fsEtiqueta, color:UI.textoTenue}}>—</span>}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div style={{padding:"9px 14px", borderTop:`1px solid ${UI.divisor}`, fontSize:10.5, color:UI.textoTenue, background:UI.superficie}}>
            Mostrando {filasVac.length} de {activos.length} trabajador{activos.length===1?"":"es"} activo{activos.length===1?"":"s"}
            {enRiesgo>0 && <span> · Los periodos con plazo vencido conviene acordarlos con el trabajador y dejarlos por escrito.</span>}
          </div>
        </div>
      )}

      {/* Descargo legal — la prescripción se señala como RIESGO, nunca como hecho. */}
      <div style={{marginTop:16, fontSize:11.5, color:UI.textoTenue, lineHeight:1.6, maxWidth:ANCHO_LECTURA, background:"rgba(184,147,42,0.06)", border:`1px solid ${TL.goldBorder}`, borderRadius:12, padding:"12px 15px"}}>
        <strong style={{color:UI.textoSuave}}>Nota:</strong> información de apoyo; no constituye determinación legal. Consulte a su asesor. El cálculo de días se basa en la fecha de ingreso; los días tomados son los que tú registres en esta pantalla. La prescripción (art. 516 LFT) se muestra como <em>riesgo a revisar</em>: los criterios no son unánimes y existen precedentes de que el plazo no corre mientras subsiste la relación laboral.
      </div>
    </div>
    {regModal && (()=>{ const {t, v} = regModal; const hist = registrosDe(t.id, v); const yaT = hist.reduce((s:number,r:any)=> s+(Number(r.diasTomados)||0),0); const rest = Math.max(0, (Number(v.dias)||0)-yaT);
      return (
      <div style={{position:"fixed" as const, inset:0, zIndex:3000, background:"rgba(11,24,41,0.55)", display:"flex", alignItems:"flex-start", justifyContent:"center", padding:"18px", overflowY:"auto" as const, backdropFilter:"blur(3px)"}}>
        <div {...PANEL_DE_CAPTURA} onClick={e=>e.stopPropagation()} style={{width:"100%", maxWidth:560, background:UI.fondo, borderRadius:16, boxShadow:"0 24px 70px rgba(0,0,0,0.5)", overflow:"hidden"}}>
          <div style={{background:T.navy, padding:"14px 20px", display:"flex", alignItems:"center", justifyContent:"space-between", gap:12}}>
            <div style={{minWidth:0}}>
              <div style={{fontFamily:fontSerif, fontSize:16, fontWeight:700, color:"white"}}>Vacaciones tomadas · {t.nombre||"—"}</div>
              <div style={{fontSize:11.5, color:"rgba(255,255,255,0.6)", marginTop:1}}>Periodo desde {fmtFecha(v.desde)} · {v.dias} días · ya registrados {yaT} · quedan {rest}</div>
            </div>
            <button onClick={(ev)=>{ if (sePuedeCerrarElPanel(ev)) setRegModal(null); }} aria-label="Cerrar" style={{background:"rgba(255,255,255,0.10)", border:"none", color:"white", width:30, height:30, borderRadius:8, cursor:"pointer", fontSize:15}}>✕</button>
          </div>
          <div style={{padding:"18px 20px", maxHeight:"calc(100vh - 150px)", overflowY:"auto" as const}}>
            {/* Formulario de registro (o edición). Marcado: debajo hay historial
                con un checkbox por renglón, y eso no es trabajo sin guardar. */}
            <div {...CAMPOS_DE_CAPTURA} style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:INI.radio, padding:"14px 16px", boxShadow:UI.sombra, marginBottom:16}}>
              <div style={{fontSize:12.5, fontWeight:800, color:UI.texto, marginBottom:10}}>{regEditId ? "Editar registro" : "Registrar vacaciones tomadas"}</div>
              <div style={{display:"flex", gap:10, flexWrap:"wrap" as const}}>
                <div style={{flex:"1 1 150px"}}>
                  <label style={{display:"block", fontSize:11, fontWeight:700, color:UI.textoSuave, marginBottom:4}}>Fecha en que las tomó</label>
                  <input type="date" value={regFecha} onChange={e=>setRegFecha(e.target.value)}
                    style={{width:"100%", boxSizing:"border-box" as const, padding:"9px 11px", borderRadius:9, border:`1px solid ${UI.divisor}`, fontSize:13.5, fontFamily:fontSans, background:"#fff", color:UI.texto}}/>
                </div>
                <div style={{flex:"0 1 130px"}}>
                  <label style={{display:"block", fontSize:11, fontWeight:700, color:UI.textoSuave, marginBottom:4}}>Días tomados</label>
                  <input type="number" min={1} max={rest+(regEditId?Number(regDias)||0:0)} value={regDias} onChange={e=>setRegDias(e.target.value)} placeholder={`máx. ${rest}`}
                    style={{width:"100%", boxSizing:"border-box" as const, padding:"9px 11px", borderRadius:9, border:`1px solid ${UI.divisor}`, fontSize:13.5, fontFamily:fontSans, background:"#fff", color:UI.texto}}/>
                </div>
              </div>
              <label style={{display:"block", fontSize:11, fontWeight:700, color:UI.textoSuave, margin:"10px 0 4px"}}>Nota (opcional)</label>
              <input value={regNota} onChange={e=>setRegNota(e.target.value)} placeholder="Ej. Semana Santa, acuerdo verbal…"
                style={{width:"100%", boxSizing:"border-box" as const, padding:"9px 11px", borderRadius:9, border:`1px solid ${UI.divisor}`, fontSize:13.5, fontFamily:fontSans, background:"#fff", color:UI.texto}}/>
              {regError && <div style={{marginTop:10, fontSize:12.5, color:"#B91C1C", background:"rgba(220,38,38,0.08)", border:"1px solid rgba(220,38,38,0.25)", borderRadius:9, padding:"9px 12px"}}>{regError}</div>}
              <div style={{display:"flex", gap:8, marginTop:12}}>
                {regEditId && <button onClick={()=>{ setRegEditId(null); setRegFecha(""); setRegDias(""); setRegNota(""); setRegError(""); }} style={{padding:"9px 14px", borderRadius:9, border:`1px solid ${UI.divisor}`, background:"transparent", color:UI.textoSuave, cursor:"pointer", fontFamily:fontSans, fontSize:12.5, fontWeight:700}}>Cancelar edición</button>}
                <button onClick={guardarRegistro} disabled={regGuardando || rest<=0 && !regEditId}
                  style={{padding:"9px 16px", borderRadius:9, border:"none", background:gold, color:"#0B1829", cursor:(regGuardando||(rest<=0&&!regEditId))?"not-allowed":"pointer", opacity:(rest<=0&&!regEditId)?0.5:1, fontFamily:fontSans, fontSize:12.5, fontWeight:800}}>{regGuardando?"Guardando…":regEditId?"Guardar cambios":"Agregar registro"}</button>
                {rest<=0 && !regEditId && <span style={{alignSelf:"center", fontSize:11.5, color:"#047857", fontWeight:700}}>Ya registró todos sus días de este periodo ✓</span>}
              </div>
            </div>
            {/* Historial del periodo */}
            <div style={{fontSize:11.5, fontWeight:700, color:UI.textoTenue, textTransform:"uppercase" as const, letterSpacing:"0.5px", margin:"0 2px 8px"}}>Historial de este periodo</div>
            {hist.length===0 ? (
              <div style={{fontSize:12.5, color:UI.textoSuave, padding:"6px 2px"}}>Aún no hay vacaciones registradas en este periodo.</div>
            ) : (
              <div style={{display:"flex", flexDirection:"column" as const, gap:8}}>
                {hist.map((r:any)=>{ const firmadaEl = fmtActaFirmada(r);
                  // Tres etapas visibles del acta. Editar y eliminar bajan a un
                  // renglón discreto: el acta es lo que protege ante una junta.
                  const etapa = r.documentoFirmado ? "firmada" : (r.documentoUrl ? "generada" : "sin");
                  return (
                  <div key={r.id} style={{display:"flex", flexDirection:"column" as const, gap:10, background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rTarjeta, padding:"12px 14px", boxShadow:UI.sombra}}>
                    <div style={{display:"flex", alignItems:"center", gap:10}}>
                      <div style={{flex:1, minWidth:0}}>
                        <div style={{fontSize:UI.fsCuerpo, fontWeight:700, color:UI.texto}}>{r.diasTomados} día{r.diasTomados===1?"":"s"} · {r.fecha ? new Date(r.fecha+"T00:00:00").toLocaleDateString("es-MX",{day:"2-digit",month:"short",year:"numeric"}) : "—"}</div>
                        {r.nota && <div style={{fontSize:UI.fsEtiqueta, color:UI.textoTenue, marginTop:2}}>{r.nota}</div>}
                      </div>
                      {etapa==="firmada"
                        ? <ChipEstado texto={`✓ Firmada${firmadaEl ? ` · ${firmadaEl}` : ""}`} tono="ok"/>
                        : etapa==="generada"
                          ? <ChipEstado texto="Generada · pendiente de firma" tono="pendiente"/>
                          : <ChipEstado texto="Acta sin generar" tono="neutro"/>}
                    </div>

                    {(()=>{ const sinCorreo = !((t?.email||"").trim()); return (<>
                    <div style={{display:"flex", alignItems:"center", gap:10, flexWrap:"wrap" as const, borderTop:`1px solid ${UI.divisor}`, paddingTop:10}}>
                      {etapa==="sin" ? (
                        // ETAPA 1 — generar es LA acción, así que va en primario.
                        <BotonPrimario fontSans={fontSans} texto={actaGenId===r.id ? "Generando…" : "Generar acta"}
                          onClick={()=>{ if(actaGenId!==r.id) generarActaVacaciones(r); }}/>
                      ) : (
                        <>
                          {/* ETAPAS 2 y 3 — el documento siempre accesible. */}
                          {r.documentoUrl && <a href={r.documentoUrl} target="_blank" rel="noreferrer"
                            style={{fontSize:UI.fsEtiqueta, color:UI.navy, fontWeight:700, textDecoration:"none"}}>Ver / descargar acta ›</a>}
                          {r.documentoUrl && (
                            <button onClick={()=>enviarActaVacaciones(r)} disabled={sinCorreo || actaEnvId===r.id}
                              title={sinCorreo ? "Para enviarla al trabajador, agrega su correo en la ficha" : "Enviar el acta al trabajador (la verá en Mis reportes)"}
                              style={{background:"transparent", border:"none", cursor:sinCorreo?"not-allowed":"pointer", fontFamily:fontSans,
                                fontSize:UI.fsEtiqueta, fontWeight:700, color:sinCorreo?UI.textoTenue:UI.navy, padding:"2px 0"}}>
                              {actaEnvId===r.id ? "Enviando…" : "Enviar al trabajador"}
                            </button>
                          )}
                          <label style={{display:"inline-flex", alignItems:"center", gap:6, fontSize:UI.fsEtiqueta, color:UI.textoSuave, cursor:"pointer", fontWeight:700}}>
                            <input type="checkbox" checked={!!r.documentoFirmado} onChange={()=>toggleActaFirmada(r)} style={{width:15, height:15, accentColor:UI.ok, cursor:"pointer"}}/>
                            Marcar como firmada
                          </label>
                          <button onClick={()=>generarActaVacaciones(r)} disabled={actaGenId===r.id}
                            style={{background:"transparent", border:"none", cursor:"pointer", fontFamily:fontSans,
                              fontSize:UI.fsEtiqueta, fontWeight:700, color:UI.textoTenue, padding:"2px 0"}}>
                            {actaGenId===r.id ? "Generando…" : "Regenerar"}
                          </button>
                        </>
                      )}
                    </div>
                    {r.documentoUrl && sinCorreo && (
                      <div style={{fontSize:UI.fsRotulo, color:UI.textoTenue, lineHeight:1.4}}>Para enviarla al trabajador, agrega su correo en la ficha. Mientras tanto puedes descargarla e imprimirla para firma física.</div>
                    )}
                    {r.documentoUrl && (
                      <div style={{display:"flex", alignItems:"center", gap:10, flexWrap:"wrap" as const}}>
                        <SubirArchivoBtn userId={currentUser.uid} carpeta="empleados"
                          label={r.documentoFirmadoUrl ? "Reemplazar acta firmada" : "Subir acta firmada (escaneo/foto)"}
                          accept=".pdf,.jpg,.jpeg,.png" maxMB={10}
                          onSubido={(u,n)=> registrarActaFirmadaSubida(r, u, n)} />
                        {r.documentoFirmadoUrl && <a href={r.documentoFirmadoUrl} target="_blank" rel="noreferrer" style={{fontSize:UI.fsEtiqueta, color:UI.ok, fontWeight:700, textDecoration:"none"}}>Ver escaneo firmado ›</a>}
                      </div>
                    )}
                    </>); })()}
                    {actaMsg && actaMsg.id===r.id && <div style={{fontSize:UI.fsEtiqueta, fontWeight:700, color: actaMsg.ok ? UI.ok : UI.rojo}}>{actaMsg.txt}</div>}

                    {/* Secundarias: discretas, sin competir con el acta. */}
                    <div style={{display:"flex", gap:14, borderTop:`1px solid ${UI.divisor}`, paddingTop:8}}>
                      <button onClick={()=>editarRegistro(r)}
                        style={{background:"transparent", border:"none", cursor:"pointer", fontFamily:fontSans,
                          fontSize:UI.fsRotulo, fontWeight:700, color:UI.textoTenue, padding:0}}>Editar</button>
                      <button onClick={()=>eliminarRegistro(r)}
                        style={{background:"transparent", border:"none", cursor:"pointer", fontFamily:fontSans,
                          fontSize:UI.fsRotulo, fontWeight:700, color:UI.textoTenue, padding:0}}>Eliminar</button>
                    </div>
                  </div>); })}
              </div>
            )}
          </div>
        </div>
      </div>);
    })()}
  </div>);
}

// ═══════════════════════════════════════════════════════════════════════════
// IMPORTADOR EN LOTE (Excel/CSV) — COMPONENTE REUTILIZABLE
// Flujo: subir → mapear columnas → previsualizar/validar → confirmar → guardar.
// Genérico: recibe la definición de campos + la función de guardado, así se puede
// reusar luego en Actividades/Nómina. En este bloque solo lo usa Empleados.
// - CSV: parser propio (sin dependencia).
// - XLSX: carga SheetJS bajo demanda desde CDN (mismo patrón que jsPDF/html2canvas;
//   NO agrega dependencia al package.json ni toca index.html).
// ═══════════════════════════════════════════════════════════════════════════
type CampoImport = {
  key:string; label:string; tipo:"text"|"number"|"date"|"select";
  requerido?:boolean; opciones?:{value:string; label:string}[]; alias?:string[];
  ejemplo?:string;                            // valor de muestra para la plantilla
  validarFormato?:(v:string)=>string|null;   // devuelve un AVISO (no bloquea) si el formato es raro
};

// Carga SheetJS (xlsx) una sola vez desde CDN. Resuelve window.XLSX.
let _sheetJSPromise:Promise<any>|null = null;
function cargarSheetJS():Promise<any> {
  if ((window as any).XLSX) return Promise.resolve((window as any).XLSX);
  if (_sheetJSPromise) return _sheetJSPromise;
  _sheetJSPromise = new Promise((resolve, reject) => {
    try {
      const s = document.createElement("script");
      s.src = "https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js";
      s.onload = () => (window as any).XLSX ? resolve((window as any).XLSX) : reject(new Error("XLSX no disponible"));
      s.onerror = () => reject(new Error("No se pudo cargar el lector de Excel"));
      document.head.appendChild(s);
    } catch(e){ reject(e); }
  });
  return _sheetJSPromise;
}

// ── EXTRACCIÓN CON IA (reutilizable): documento → JSON estructurado → cae en la MISMA
//   tabla de confirmación del importador. La IA EXTRAE, el HUMANO CONFIRMA (nunca auto-
//   guardado). Reutiliza la integración de AXIOR (/api/axior, mismo modelo/credencial):
//   los `messages` se reenvían tal cual a Anthropic, así que un PDF viaja como bloque
//   `document` (base64) y un Word como texto. Genérico por `campos` → reusable en
//   Actividades/Nómina cambiando solo la definición de campos y la entidad.
let _mammothPromise:Promise<any>|null = null;
function cargarMammoth():Promise<any> {
  if ((window as any).mammoth) return Promise.resolve((window as any).mammoth);
  if (_mammothPromise) return _mammothPromise;
  _mammothPromise = new Promise((resolve, reject) => {
    try {
      const s = document.createElement("script");
      s.src = "https://unpkg.com/mammoth@1.8.0/mammoth.browser.min.js";
      s.onload = () => (window as any).mammoth ? resolve((window as any).mammoth) : reject(new Error("Lector de Word no disponible"));
      s.onerror = () => reject(new Error("No se pudo cargar el lector de Word (.docx)"));
      document.head.appendChild(s);
    } catch(e){ reject(e); }
  });
  return _mammothPromise;
}
// Lee un File como base64 puro (sin el prefijo data:...;base64,).
function _fileABase64(file:File):Promise<string> {
  return new Promise((resolve, reject) => {
    const rd = new FileReader();
    rd.onload = () => { const s = String(rd.result||""); const i = s.indexOf(","); resolve(i>=0 ? s.slice(i+1) : s); };
    rd.onerror = () => reject(new Error("No se pudo leer el archivo."));
    rd.readAsDataURL(file);
  });
}
// Prompt de extracción construido desde los MISMOS campos del importador (claves exactas).
function _promptExtraccionIA(campos:CampoImport[], entidad:{singular:string; plural:string}):string {
  const lineas = campos.map(c=>{
    const hint = c.tipo==="date" ? "fecha en formato AAAA-MM-DD"
      : c.tipo==="number" ? "solo el número, sin símbolos ni comas"
      : c.tipo==="select" ? ("uno de estos valores exactos: "+(c.opciones||[]).map(o=>o.value).join(", "))
      : "texto";
    return `- "${c.key}": ${c.label} (${hint})`;
  }).join("\n");
  return `Actúa como un extractor de datos estructurados. Del documento que te comparto, extrae la lista de ${entidad.plural} y devuelve EXCLUSIVAMENTE un arreglo JSON válido: sin texto antes ni después, sin explicaciones, sin markdown, sin backticks.
Cada elemento del arreglo es un objeto con EXACTAMENTE estas claves:
${lineas}
Reglas estrictas:
- Extrae SOLO lo que esté EXPLÍCITO en el documento. Si un dato no aparece, deja la cadena vacía "". NUNCA inventes, deduzcas ni completes datos faltantes.
- Una celda con guion (-, –, —), "N/A", "S/D", "pendiente" o similar significa AUSENTE: devuelve la cadena vacía "", nunca ese texto.
${campos.some(c=>c.key==="salario") ? "- Si hay un salario, usa el importe MENSUAL bruto cuando el documento lo indique.\n" : ""}- Si el documento NO contiene ${entidad.plural}, devuelve exactamente [].
Responde ÚNICAMENTE con el arreglo JSON.`;
}
// Parseo DEFENSIVO del JSON de la IA: quita cercos ```json, recorta al arreglo [...] si
// viene con prosa alrededor, y valida. Si no se puede leer, lanza error claro (no truena).
function parsearJSONArrayIA(texto:string):any[] {
  if (!texto || typeof texto!=="string") throw new Error("La IA no devolvió datos legibles. Intenta de nuevo.");
  let t = texto.trim();
  const fence = t.match(/```(?:json)?\s*([\s\S]*?)```/i);
  if (fence) t = fence[1].trim();
  const i = t.indexOf("["), j = t.lastIndexOf("]");
  if (i>=0 && j>i) t = t.slice(i, j+1);
  let data:any;
  try { data = JSON.parse(t); }
  catch(_){ throw new Error("La IA devolvió un formato que no se pudo leer. Vuelve a intentar o usa el importador de Excel/CSV."); }
  if (!Array.isArray(data)) {
    if (data && Array.isArray(data.empleados)) data = data.empleados;
    else if (data && Array.isArray(data.registros)) data = data.registros;
    else throw new Error("La IA no devolvió una lista de registros. Intenta de nuevo.");
  }
  return data.filter((o:any)=> o && typeof o==="object" && !Array.isArray(o));
}
// Orquesta: documento (PDF→bloque document base64; Word .docx→texto vía mammoth) → una
// SOLA llamada a /api/axior → JSON estructurado. Solo manda el documento subido (privacidad).
async function extraerRegistrosDeDocumentoIA(file:File, campos:CampoImport[], entidad:{singular:string; plural:string}):Promise<{registros:any[]; aviso?:string}> {
  const nombre = (file.name||"").toLowerCase();
  const prompt = _promptExtraccionIA(campos, entidad);
  let content:any[]; let aviso:string|undefined;
  const esPDF = file.type==="application/pdf" || nombre.endsWith(".pdf");
  const esDocx = nombre.endsWith(".docx");
  if (esPDF) {
    if (file.size > 4.5*1024*1024) throw new Error("El PDF es muy grande (más de 4.5 MB). Divídelo o comprímelo y vuelve a intentar.");
    const b64 = await _fileABase64(file);
    content = [
      {type:"document", source:{type:"base64", media_type:"application/pdf", data:b64}},
      {type:"text", text:prompt},
    ];
  } else if (esDocx) {
    const mammoth = await cargarMammoth();
    const {value:texto} = await mammoth.extractRawText({arrayBuffer: await file.arrayBuffer()});
    const limpio = (texto||"").trim();
    if (!limpio) throw new Error("No se pudo extraer texto del documento Word. ¿Está vacío o es una imagen escaneada? Prueba con un PDF.");
    if (limpio.length > 100000) aviso = "El documento es muy largo; la IA pudo procesar solo una parte. Revisa que estén todos los registros.";
    content = [{type:"text", text: prompt + "\n\n===== DOCUMENTO =====\n" + limpio.slice(0,120000)}];
  } else if (nombre.endsWith(".doc")) {
    throw new Error("El formato .doc (Word antiguo) no se puede leer. Guárdalo como .docx o PDF e inténtalo de nuevo.");
  } else {
    throw new Error("Formato no soportado. Sube un PDF o un Word (.docx).");
  }
  let resp:Response;
  try {
    resp = await fetch("/api/axior", {method:"POST", headers: await cabecerasAxior(), body:JSON.stringify({messages:[{role:"user", content}]})});
  } catch(_){ throw new Error("No se pudo conectar con el servicio de IA. Revisa tu conexión e intenta de nuevo."); }
  const rechazoIA = mensajeRechazoAxior(resp.status);
  if (rechazoIA) throw new Error(rechazoIA);
  const data = await resp.json().catch(()=>({}));
  if (!resp.ok) throw new Error((data && data.error) || "El servicio de IA devolvió un error. Intenta de nuevo.");
  const registros = parsearJSONArrayIA((data && data.text) || "");
  return {registros, aviso};
}

// Parser CSV propio: respeta comillas, comas y saltos internos; \r\n o \n.
function parseCSV(texto:string):string[][] {
  const filas:string[][] = []; let campo=""; let fila:string[]=[]; let enComillas=false;
  const t = texto.replace(/\r\n/g,"\n").replace(/\r/g,"\n");
  for (let i=0;i<t.length;i++){
    const c=t[i];
    if (enComillas){
      if (c==='"'){ if (t[i+1]==='"'){ campo+='"'; i++; } else enComillas=false; }
      else campo+=c;
    } else {
      if (c==='"') enComillas=true;
      else if (c===","){ fila.push(campo); campo=""; }
      else if (c==="\n"){ fila.push(campo); filas.push(fila); fila=[]; campo=""; }
      else campo+=c;
    }
  }
  if (campo!=="" || fila.length){ fila.push(campo); filas.push(fila); }
  // Descarta filas totalmente vacías.
  return filas.filter(f=> f.some(x=> String(x).trim()!==""));
}

const _sinAcentos = (s:string)=> s.normalize("NFD").replace(/[̀-ͯ]/g,"");
const _norm = (s:any)=> _sinAcentos(String(s??"")).toLowerCase().replace(/[^a-z0-9]/g,"").trim();
const _p2 = (n:number)=> String(n).padStart(2,"0");
// Normaliza celdas de fecha (Date de SheetJS, serial de Excel, o texto) a "YYYY-MM-DD".
// Marcadores de AUSENCIA de dato. Un guion en una celda de fecha no es una
// fecha inválida ni la cadena "-": es que NO HAY dato, y tiene que quedar
// vacío para que la validación diga "Obligatorio" (o avise en ámbar si el
// campo es opcional) en vez de guardar basura o inventar una fecha.
//
// La comparación es EXACTA contra esta lista cerrada, NUNCA por contención:
// buscar "sd" dentro del texto vaciaría "SD-2024", y "na" vaciaría cualquier
// cosa que la contenga. Como `_norm` quita acentos, mayúsculas y signos, aquí
// van ya normalizados: eso hace que "-", "–", "—", "--", "N/A", "n.a." y "S/D"
// caigan solos, sin listar cada variante de puntuación.
const _AUSENCIA_FECHA = new Set([
  "", "na", "nd", "sd", "sinfecha", "sindato", "sindatos",
  "pendiente", "porconfirmar", "pordefinir", "noaplica", "nodisponible",
  "ninguna", "ninguno", "null", "none",
]);

function normalizarFechaISO(v:any):string {
  if (v==null || v==="") return "";
  if (v instanceof Date && !isNaN(v.getTime())) return `${v.getFullYear()}-${_p2(v.getMonth()+1)}-${_p2(v.getDate())}`;
  if (typeof v==="number" && v>0 && v<80000){ // serial de Excel (días desde 1899-12-30)
    const d = new Date(Math.round((v-25569)*86400000)); if (!isNaN(d.getTime())) return `${d.getUTCFullYear()}-${_p2(d.getUTCMonth()+1)}-${_p2(d.getUTCDate())}`;
  }
  const s = String(v).trim();
  // Ausencia declarada → vacío. Va ANTES de intentar interpretar el texto, y
  // cubre por igual la ruta de Excel y la de la IA: las dos pasan por aquí.
  if (_AUSENCIA_FECHA.has(_norm(s))) return "";
  let m = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/); if (m) return `${m[1]}-${_p2(+m[2])}-${_p2(+m[3])}`;
  m = s.match(/^(\d{1,2})[\/\-.](\d{1,2})[\/\-.](\d{4})$/); if (m) return `${m[3]}-${_p2(+m[2])}-${_p2(+m[1])}`;   // DD/MM/AAAA
  return s;
}
const _esFechaISOValida = (s:string)=>{ const m=s.match(/^(\d{4})-(\d{2})-(\d{2})$/); if(!m) return false; const d=new Date(+m[1],+m[2]-1,+m[3]); return d.getFullYear()===+m[1]&&d.getMonth()===+m[2]-1&&d.getDate()===+m[3]; };
// Traduce la firma que coincidió a lenguaje del usuario. El prefijo dice con
// qué dato se topó, y eso decide el consejo: CURP, RFC y placa identifican de
// forma única, así que es EL MISMO registro; el nombre solo no identifica a
// nadie, así que puede ser un homónimo legítimo y hay que verificar a mano.
const _porQueCoincide = (firma:string, donde:string):string => {
  const p = firma.split(":")[0];
  if (p==="curp")  return `${donde} con este CURP: es la misma persona`;
  if (p==="rfc")   return `${donde} con este RFC: es la misma persona`;
  if (p==="placa") return `${donde} con esta placa: es la misma unidad`;
  if (p==="mail")  return `${donde} con este correo`;
  return `${donde} con este nombre: podría ser homónimo, verifica`;
};

// CAUSAS DE TERMINACIÓN — lista cerrada, no texto libre: un catálogo permite
// contar, filtrar y auditar; un campo abierto no. Las cuatro primeras son las
// del art. 53 LFT; el resto son las otras vías por las que termina de hecho una
// relación laboral. Verificado contra la LFT sin reformas posteriores al
// 27/12/2022. El valor se guarda tal cual dentro del periodo que se cierra.
const RAZONES_BAJA_TRABAJADOR: {grupo:string; opciones:{value:string; label:string}[]}[] = [
  {grupo:"Terminación (art. 53 LFT)", opciones:[
    {value:"mutuo_consentimiento", label:"Mutuo consentimiento"},
    {value:"muerte_trabajador",    label:"Muerte del trabajador"},
    {value:"conclusion_obra",      label:"Conclusión de la obra o vencimiento del término"},
    {value:"incapacidad",          label:"Incapacidad física o mental que impide la prestación"},
  ]},
  {grupo:"Otras causas", opciones:[
    {value:"renuncia",             label:"Renuncia del trabajador"},
    {value:"rescision_art47",      label:"Rescisión sin responsabilidad para el patrón (art. 47)"},
    {value:"rescision_art51",      label:"Rescisión sin responsabilidad para el trabajador (art. 51)"},
    {value:"despido_injustificado",label:"Despido sin causa justificada"},
    {value:"jubilacion",           label:"Jubilación"},
  ]},
];
const _etiquetaRazonBaja = (v?:string):string =>
  RAZONES_BAJA_TRABAJADOR.flatMap(g=>g.opciones).find(o=>o.value===v)?.label || v || "";

// Fecha AAAA-MM-DD a texto corto. Se parte la cadena en vez de usar
// `new Date("2026-08-13")`, porque eso se interpreta como medianoche UTC y en
// México (UTC-6) se pinta el día ANTERIOR. En una fecha de baja eso no es un
// detalle cosmético: es el día que determina el corte de la relación laboral.
const _MESES_MX = ["ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic"];
const _fechaCortaMX = (iso?:string):string => {
  const m = String(iso||"").match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return String(iso||"");
  return `${+m[3]} ${_MESES_MX[+m[2]-1]} ${m[1]}`;
};

// Periodos de la relación laboral, DERIVADOS al leer. Las fichas anteriores a
// `periodosLaborales` no se migran en la base: se reconstruyen aquí desde
// `fechaIngreso` y `fechaBaja`, que es todo lo que esas fichas guardaron. Así
// una cuenta vieja ve su historial sin tocarle un solo documento.
// ES LA MISMA FUNCIÓN QUE USAN LOS CONTEOS Y EL AVISO DE "NO HA CHECADO"
// (periodosLaboralesDe, src/logica/checador.js), no una copia: el historial que
// enseña la ficha y los días que se cuentan no pueden leer fechas distintas.
const periodosDe = (t:any):{ingreso:string; baja?:string; razonBaja?:string; notasBaja?:string}[] => periodosLaboralesDe(t);

const _reRFC  = /^([A-ZÑ&]{3,4})\d{6}[A-Z0-9]{3}$/i;
const _reCURP = /^[A-Z]{4}\d{6}[HM][A-Z]{5}[A-Z0-9]\d$/i;
const _reMail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function ImportadorLote({titulo, campos, existentes, firmaFila, validarFilaExtra, notaSuperior, opcionesGlobales, columnaCalculada, entidad={singular:"empleado", plural:"empleados"}, onGuardarFila, onTerminar, onCerrar, registrosIA, fuenteIA, fontSans, fontSerif, gold}: {
  titulo:string; campos:CampoImport[]; existentes:any[];
  // Cómo se llama lo que se importa, para los textos de la pantalla. Por omisión
  // "empleado/empleados": así la importación que ya estaba en producción no cambia.
  entidad?:{singular:string; plural:string};
  // Fuente alterna: registros YA estructurados (p.ej. extraídos por IA de un documento).
  // Caen en la MISMA previsualización/validación, saltando 'subir' y 'mapear'.
  registrosIA?:any[]|null; fuenteIA?:boolean;
  // Firma(s) de identidad de una fila/registro (RFC, correo, nombre+ingreso…) para
  // detectar duplicados contra los existentes Y entre filas del propio archivo.
  firmaFila?:(o:any)=>string[];
  // Validación cruzada opcional; recibe también las opciones globales.
  validarFilaExtra?:(valores:Record<string,string>, opciones:Record<string,string>)=>{errores?:Record<string,string>; avisos?:Record<string,string>};
  notaSuperior?:string;
  // Opciones a nivel de TODA la importación (radios en el mapeo). P.ej. si el salario
  // del archivo es mensual o diario. Evita ambigüedad de columnas.
  opcionesGlobales?:{key:string; label:string; opciones:{value:string; label:string}[]; default:string}[];
  // Columna DERIVADA de solo lectura para la previsualización (p.ej. "Salario diario a guardar").
  columnaCalculada?:{label:string; calc:(valores:Record<string,string>, opciones:Record<string,string>)=>string};
  onGuardarFila:(valores:Record<string,string>, opciones:Record<string,string>)=>Promise<void>;
  onTerminar:()=>void; onCerrar:()=>void;
  fontSans:string; fontSerif:string; gold:string;
}) {
  const TL = T_LIGHT;
  const [paso, setPaso] = useState<"subir"|"mapear"|"revisar"|"importando"|"resumen">(fuenteIA ? "revisar" : "subir");
  const [headers, setHeaders] = useState<string[]>([]);
  const [crudas, setCrudas] = useState<any[][]>([]);           // filas de datos (sin encabezado)
  const [mapa, setMapa] = useState<Record<string,number>>({}); // key de campo → índice de columna (-1 = ninguna)
  const [opcVals, setOpcVals] = useState<Record<string,string>>(()=> { const o:Record<string,string>={}; (opcionesGlobales||[]).forEach(g=> o[g.key]=g.default); return o; });
  const [filas, setFilas] = useState<Record<string,string>[]>([]);
  const [incluir, setIncluir] = useState<boolean[]>([]);
  const [cargandoArch, setCargandoArch] = useState(false);
  const [errArch, setErrArch] = useState("");
  const [progreso, setProgreso] = useState({hechas:0, total:0});
  const [resumen, setResumen] = useState({ok:0, fallo:0, omitidas:0});

  // Ingesta de registros extraídos por IA: normaliza (fecha/número/select) y detecta
  // duplicados IGUAL que el flujo de Excel, y cae directo en la previsualización.
  useEffect(()=>{
    if (!registrosIA || !registrosIA.length) return;
    const out = registrosIA.map((raw:any)=>{
      const v:Record<string,string> = {};
      campos.forEach(c=>{
        let r0 = raw?.[c.key]; if (r0==null) r0 = "";
        if (c.tipo==="date") v[c.key] = normalizarFechaISO(r0);
        else if (c.tipo==="select"){ const n=_norm(r0); const op=(c.opciones||[]).find(o=> _norm(o.value)===n || _norm(o.label)===n); v[c.key] = op ? op.value : String(r0??"").trim(); }
        else v[c.key] = String(r0??"").trim();
      });
      return v;
    });
    // INCLUIR por defecto = true en TODAS las filas (los duplicados se siguen detectando
    // y avisando en la validación; el usuario puede desmarcar el que no quiera).
    const inc = out.map(()=> true);
    setFilas(out); setIncluir(inc); setPaso("revisar");
  }, [registrosIA]);   // eslint-disable-line

  const overlay:any = {position:"fixed", inset:0, zIndex:3000, background:"rgba(11,24,41,0.55)", display:"flex", alignItems:"flex-start", justifyContent:"center", padding:"18px", overflowY:"auto", backdropFilter:"blur(3px)"};
  const panel:any = {width:"100%", maxWidth:980, background:TL.canvas, borderRadius:16, boxShadow:"0 24px 70px rgba(0,0,0,0.5)", fontFamily:fontSans, overflow:"hidden"};
  const btnPrim:any = {background:gold, color:"#0B1829", border:"none", borderRadius:10, padding:"9px 16px", fontSize:13, fontWeight:700, cursor:"pointer", fontFamily:fontSans};
  const btnSec:any = {background:TL.cardLight, color:TL.textInk, border:`1px solid ${TL.borderCard}`, borderRadius:10, padding:"9px 16px", fontSize:13, fontWeight:700, cursor:"pointer", fontFamily:fontSans};

  const descargarPlantilla = () => {
    const encab = campos.map(c=> c.label);
    const ejemplo = campos.map(c=> c.ejemplo ?? "");
    const esc = (v:string)=> /[",\n]/.test(v) ? `"${v.replace(/"/g,'""')}"` : v;
    const csv = "﻿" + [encab, ejemplo].map(f=> f.map(esc).join(",")).join("\n");
    const blob = new Blob([csv], {type:"text/csv;charset=utf-8;"});
    const a = document.createElement("a"); a.href = URL.createObjectURL(blob);
    a.download = `plantilla_${_norm(titulo)||"import"}.csv`; a.click();
    setTimeout(()=> URL.revokeObjectURL(a.href), 1500);
  };

  const autoMapa = (hs:string[]) => {
    const m:Record<string,number> = {};
    const usadas = new Set<number>();   // una columna NO se asigna a dos campos
    // 1ª pasada: coincidencias EXACTAS (más confiables).
    campos.forEach(c=>{
      const cands = [c.label, c.key, ...(c.alias||[])].map(_norm);
      const idx = hs.findIndex((h,i)=> !usadas.has(i) && cands.includes(_norm(h)));
      m[c.key] = idx; if (idx>=0) usadas.add(idx);
    });
    // 2ª pasada: coincidencias DIFUSAS solo para los que quedaron sin columna.
    campos.forEach(c=>{
      if (m[c.key]>=0) return;
      const cands = [c.label, c.key, ...(c.alias||[])].map(_norm);
      const idx = hs.findIndex((h,i)=> { if (usadas.has(i)) return false; const nh=_norm(h); return cands.some(a=> a && (nh.includes(a)||a.includes(nh))); });
      m[c.key] = idx; if (idx>=0) usadas.add(idx);
    });
    return m;
  };

  const procesarArchivo = async (file:File) => {
    setErrArch(""); setCargandoArch(true);
    try {
      const nombre = (file.name||"").toLowerCase();
      let aoa:any[][] = [];
      if (nombre.endsWith(".csv") || file.type==="text/csv") {
        aoa = parseCSV(await file.text());
      } else if (nombre.endsWith(".xlsx") || nombre.endsWith(".xls")) {
        const XLSX = await cargarSheetJS();
        const wb = XLSX.read(await file.arrayBuffer(), {type:"array", cellDates:true});
        const ws = wb.Sheets[wb.SheetNames[0]];
        aoa = XLSX.utils.sheet_to_json(ws, {header:1, raw:true, defval:""});
        aoa = aoa.filter((f:any[])=> Array.isArray(f) && f.some(x=> String(x??"").trim()!==""));
      } else {
        throw new Error("Formato no soportado. Usa un archivo .xlsx o .csv.");
      }
      if (!aoa.length){ setErrArch("El archivo está vacío o no tiene datos."); setCargandoArch(false); return; }
      const hs = (aoa[0]||[]).map((h:any)=> String(h??"").trim());
      const rows = aoa.slice(1);
      if (!rows.length){ setErrArch(`El archivo solo tiene encabezados, sin filas de ${entidad.plural}.`); setCargandoArch(false); return; }
      setHeaders(hs); setCrudas(rows); setMapa(autoMapa(hs)); setPaso("mapear");
    } catch(e:any){
      setErrArch(e?.message || "No se pudo leer el archivo. Revisa que sea .xlsx o .csv válido.");
    }
    setCargandoArch(false);
  };

  // Firmas de identidad de los empleados YA EXISTENTES (para detectar duplicados).
  const firmasExistentes = new Set<string>((existentes||[]).flatMap((r:any)=> firmaFila ? (firmaFila(r)||[]) : []));

  const construirFilas = () => {
    const out = crudas.map(r=>{
      const v:Record<string,string> = {};
      campos.forEach(c=>{
        const idx = mapa[c.key];
        let raw = (idx!=null && idx>=0) ? r[idx] : "";
        if (c.tipo==="date") v[c.key] = normalizarFechaISO(raw);
        else if (c.tipo==="number") v[c.key] = String(raw??"").trim();
        else if (c.tipo==="select"){
          const n=_norm(raw); const op=(c.opciones||[]).find(o=> _norm(o.value)===n || _norm(o.label)===n);
          v[c.key] = op ? op.value : String(raw??"").trim();
        } else v[c.key] = String(raw??"").trim();
      });
      return v;
    });
    // INCLUIR por defecto = true en TODAS las filas. Los duplicados se siguen detectando
    // y avisando en la validación (aviso ámbar "_dup"); el usuario desmarca el que no quiera.
    const inc = out.map(()=> true);
    setFilas(out); setIncluir(inc); setPaso("revisar");
  };

  // Primera aparición de cada firma dentro del archivo (para marcar el duplicado interno).
  const _firmaPrimera:Record<string,number> = {};
  filas.forEach((f,i)=>{ (firmaFila?firmaFila(f)||[]:[]).forEach(s=>{ if(!(s in _firmaPrimera)) _firmaPrimera[s]=i; }); });

  // Validación por fila. Distingue OBLIGATORIO vacío (error rojo, bloquea) de OPCIONAL
  // vacío (aviso ámbar en faltanOpc, NO bloquea: se puede completar después).
  const validarFila = (f:Record<string,string>, i:number) => {
    const errores:Record<string,string>={}, avisos:Record<string,string>={};
    const faltanOpc:string[]=[];   // claves de campos OPCIONALES vacíos (ámbar, no bloquean)
    campos.forEach(c=>{
      const val=(f[c.key]||"").trim();
      if (!val){
        if (c.requerido) errores[c.key]="Obligatorio";   // falta un obligatorio → bloquea
        else faltanOpc.push(c.key);                        // falta un opcional → aviso suave
      } else {
        if (c.tipo==="number"){ const n=Number(val); if(!Number.isFinite(n)||n<=0) errores[c.key]="Número inválido"; }
        else if (c.tipo==="date"){ if(!_esFechaISOValida(val)) errores[c.key]="Fecha inválida (usa AAAA-MM-DD)"; }
        else if (c.validarFormato){ const w=c.validarFormato(val); if(w) avisos[c.key]=w; }
      }
    });
    // Validación cruzada del caller (recibe las opciones globales).
    if (validarFilaExtra){ const x=validarFilaExtra(f, opcVals)||{}; Object.assign(errores, x.errores||{}); Object.assign(avisos, x.avisos||{}); }
    // Duplicados: contra existentes de la cuenta y entre filas del archivo (por firma).
    // POR QUÉ coincidió cambia lo que el usuario debe hacer: un CURP repetido es
    // la misma persona y hay que unificar; un nombre repetido puede ser un
    // homónimo legítimo y hay que verificar. Decirlo "con estos datos" dejaba al
    // usuario adivinando cuál de los dos casos tenía enfrente.
    const firmas = firmaFila ? (firmaFila(f)||[]) : [];
    const golpeExistente = firmas.find(s=> firmasExistentes.has(s));
    const golpeArchivo = golpeExistente ? undefined
      : firmas.find(s=> _firmaPrimera[s]!=null && _firmaPrimera[s] < i);
    const golpe = golpeExistente || golpeArchivo;
    if (golpe) {
      const donde = golpeExistente ? `Ya existe un ${entidad.singular}` : "Repetido dentro del archivo";
      avisos._dup = _porQueCoincide(golpe, donde);
    }
    return {errores, avisos, faltanOpc, tieneError:Object.keys(errores).length>0, tieneAviso:(Object.keys(avisos).length>0 || faltanOpc.length>0)};
  };

  const valids = filas.map((f,i)=> validarFila(f,i));
  const setCelda = (i:number, key:string, val:string) => setFilas(prev=> prev.map((f,idx)=> idx===i ? {...f, [key]:val} : f));
  const incluidasConError = filas.filter((_,i)=> incluir[i] && valids[i].tieneError).length;
  const nOk = filas.filter((_,i)=> incluir[i] && !valids[i].tieneError).length;
  // El aviso de la IA nombra lo que hay que revisar en ESTA entidad y por qué
  // importa: en empleados alimenta prestaciones; en vehículos, las alertas.
  const camposCriticos = campos.some(c=>c.key==="salario")
    ? "fechas, salarios, RFC y CURP"
    : campos.filter(c=>c.tipo==="date"||c.requerido).map(c=>c.label).slice(0,4).join(", ") || "los datos";
  const consecuenciaIA = campos.some(c=>c.key==="salario")
    ? "estos datos alimentan vacaciones, aguinaldo y nómina."
    : "de estos datos dependen los avisos de vencimiento.";
  // PASO 3: no se puede importar mientras alguna fila incluida tenga error.
  // Importa las filas VÁLIDAS marcadas; una incompleta NO frena a las demás (se excluye
  // en confirmarImport). Solo se deshabilita si NO hay ninguna fila marcada y válida.
  const puedeImportar = nOk>0;

  const confirmarImport = async () => {
    if (!puedeImportar) return;
    const aImportar = filas.map((f,i)=>({f,i})).filter(({i})=> incluir[i] && !valids[i].tieneError);
    setResumen({ok:0, fallo:0, omitidas: filas.length - aImportar.length});
    setProgreso({hechas:0, total:aImportar.length}); setPaso("importando");
    let ok=0, fallo=0;
    for (let k=0;k<aImportar.length;k++){
      try { await onGuardarFila(aImportar[k].f, opcVals); ok++; }
      catch(e){ console.error("importar fila:", e); fallo++; }
      setProgreso({hechas:k+1, total:aImportar.length});
    }
    setResumen({ok, fallo, omitidas: filas.length - aImportar.length});
    setPaso("resumen");
  };

  const chipErr=(t:string)=> <span style={{fontSize:10.5, fontWeight:800, color:"#B91C1C", background:"rgba(220,38,38,0.10)", border:"1px solid rgba(220,38,38,0.30)", borderRadius:6, padding:"1px 6px"}}>{t}</span>;
  const chipAvi=(t:string)=> <span style={{fontSize:10.5, fontWeight:800, color:"#B45309", background:"rgba(217,119,6,0.10)", border:"1px solid rgba(217,119,6,0.30)", borderRadius:6, padding:"1px 6px"}}>{t}</span>;

  return (
    <div style={overlay}>
      <div {...PANEL_DE_CAPTURA} style={panel} onClick={e=>e.stopPropagation()}>
        {/* Cabecera */}
        <div style={{background:T.navy, padding:"14px 20px", display:"flex", alignItems:"center", justifyContent:"space-between", gap:12}}>
          <div style={{fontFamily:fontSerif, fontSize:17, fontWeight:700, color:"white"}}>{titulo}</div>
          <button onClick={(ev)=>{ if (sePuedeCerrarElPanel(ev)) onCerrar(); }} aria-label="Cerrar" style={{background:"rgba(255,255,255,0.10)", border:"none", color:"white", width:30, height:30, borderRadius:8, cursor:"pointer", fontSize:15}}>✕</button>
        </div>

        <div style={{padding:"20px", maxHeight:"calc(100vh - 140px)", overflowY:"auto" as const}}>
          {/* Pasos: indicador */}
          <div style={{display:"flex", gap:6, marginBottom:18, flexWrap:"wrap" as const}}>
            {(fuenteIA ? [["revisar","1 · Revisar"],["resumen","2 · Guardar"]] : [["subir","1 · Subir"],["mapear","2 · Mapear"],["revisar","3 · Revisar"],["resumen","4 · Importar"]]).map(([k,l])=>{
              const activo = paso===k || (paso==="importando"&&k==="resumen");
              return <span key={k} style={{fontSize:11.5, fontWeight:700, padding:"5px 11px", borderRadius:999, color:activo?"#0B1829":TL.textInkMut, background:activo?gold:"transparent", border:`1px solid ${activo?gold:TL.border}`}}>{l}</span>;
            })}
          </div>

          {notaSuperior && (
            <div style={{fontSize:12, color:TL.textInkSoft, lineHeight:1.6, background:"rgba(184,147,42,0.08)", border:`1px solid ${TL.goldBorder}`, borderRadius:10, padding:"10px 14px", marginBottom:16}}>{notaSuperior}</div>
          )}

          {paso==="subir" && (
            <div>
              <p style={{fontSize:13.5, color:TL.textInkSoft, lineHeight:1.6, margin:"0 0 14px"}}>Sube un archivo <strong>.xlsx</strong> o <strong>.csv</strong> con tus empleados. ¿No sabes el formato? Descarga la plantilla, llénala y súbela.</p>
              <div style={{display:"flex", gap:10, flexWrap:"wrap" as const, alignItems:"center"}}>
                <button onClick={descargarPlantilla} style={btnSec}>⬇ Descargar plantilla (CSV)</button>
                <label style={{...btnPrim, display:"inline-flex", alignItems:"center", gap:8}}>
                  {cargandoArch ? "Leyendo…" : "📄 Seleccionar archivo"}
                  <input type="file" accept=".xlsx,.xls,.csv" style={{display:"none"}} disabled={cargandoArch}
                    onChange={e=>{ const f=e.target.files?.[0]; if(f) procesarArchivo(f); e.currentTarget.value=""; }}/>
                </label>
              </div>
              {errArch && <div style={{marginTop:14, fontSize:13, color:"#B91C1C", background:"rgba(220,38,38,0.08)", border:"1px solid rgba(220,38,38,0.25)", borderRadius:10, padding:"11px 14px"}}>{errArch}</div>}
              <div style={{marginTop:16, fontSize:12, color:TL.textInkMut, lineHeight:1.6}}>Columnas de la plantilla: {campos.map(c=> c.label + (c.requerido?" *":"")).join(" · ")}. Los campos con <strong>*</strong> son obligatorios.</div>
            </div>
          )}

          {paso==="mapear" && (
            <div {...CAMPOS_DE_CAPTURA}>
              <p style={{fontSize:13.5, color:TL.textInkSoft, lineHeight:1.6, margin:"0 0 14px"}}>Confirma qué columna de tu archivo corresponde a cada campo. Detecté las que coinciden por nombre; corrige si hace falta. Las columnas de más se ignoran.</p>
              <div style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap:10}}>
                {campos.map(c=>(
                  <div key={c.key} style={{display:"flex", alignItems:"center", gap:8, background:TL.cardLight, border:`1px solid ${TL.border}`, borderRadius:10, padding:"9px 12px"}}>
                    <span style={{fontSize:12.5, fontWeight:700, color:TL.textInk, minWidth:130}}>{c.label}{c.requerido?" *":""}</span>
                    <select value={mapa[c.key]??-1} onChange={e=> setMapa(m=>({...m, [c.key]:Number(e.target.value)}))}
                      style={{flex:1, padding:"7px 9px", borderRadius:8, border:`1px solid ${TL.border}`, fontSize:12.5, fontFamily:fontSans, background:"#fff", color:TL.textInk}}>
                      <option value={-1}>— ninguna —</option>
                      {headers.map((h,i)=>(<option key={i} value={i}>{h||`(columna ${i+1})`}</option>))}
                    </select>
                  </div>
                ))}
              </div>
              {(opcionesGlobales||[]).map(g=>(
                <div key={g.key} style={{marginTop:16, background:"rgba(184,147,42,0.07)", border:`1px solid ${TL.goldBorder}`, borderRadius:10, padding:"12px 14px"}}>
                  <div style={{fontSize:12.5, fontWeight:800, color:TL.textInk, marginBottom:8}}>{g.label}</div>
                  <div style={{display:"flex", gap:16, flexWrap:"wrap" as const}}>
                    {g.opciones.map(o=>(
                      <label key={o.value} style={{display:"inline-flex", alignItems:"center", gap:7, cursor:"pointer", fontSize:13, color:TL.textInkSoft}}>
                        <input type="radio" name={g.key} checked={opcVals[g.key]===o.value} onChange={()=> setOpcVals(v=>({...v, [g.key]:o.value}))}/>
                        {o.label}
                      </label>
                    ))}
                  </div>
                </div>
              ))}
              <div style={{display:"flex", justifyContent:"space-between", marginTop:18, gap:10}}>
                <button onClick={()=>setPaso("subir")} style={btnSec}>‹ Atrás</button>
                <button onClick={construirFilas} style={btnPrim}>Previsualizar {crudas.length} fila{crudas.length===1?"":"s"} ›</button>
              </div>
            </div>
          )}

          {paso==="revisar" && (
            <div>
              {fuenteIA && (
                <div style={{fontSize:12.5, color:"#8a5a00", lineHeight:1.55, background:"rgba(217,119,6,0.10)", border:"1px solid rgba(217,119,6,0.35)", borderRadius:10, padding:"10px 14px", marginBottom:14}}>
                  <strong>Datos extraídos por IA.</strong> La IA propone; <strong>tú confirmas</strong>. Revisa con cuidado <strong>{camposCriticos}</strong> antes de guardar — la IA puede equivocarse y {consecuenciaIA} Nada se guarda hasta que pulses el botón final.
                </div>
              )}
              {fuenteIA && (opcionesGlobales||[]).map(g=>(
                <div key={g.key} style={{marginBottom:14, background:"rgba(184,147,42,0.07)", border:`1px solid ${TL.goldBorder}`, borderRadius:10, padding:"10px 14px"}}>
                  <div style={{fontSize:12.5, fontWeight:800, color:TL.textInk, marginBottom:8}}>{g.label}</div>
                  <div style={{display:"flex", gap:16, flexWrap:"wrap" as const}}>
                    {g.opciones.map(o=>(
                      <label key={o.value} style={{display:"inline-flex", alignItems:"center", gap:7, cursor:"pointer", fontSize:13, color:TL.textInkSoft}}>
                        <input type="radio" name={"ia_"+g.key} checked={opcVals[g.key]===o.value} onChange={()=> setOpcVals(v=>({...v, [g.key]:o.value}))}/>
                        {o.label}
                      </label>
                    ))}
                  </div>
                </div>
              ))}
              <p style={{fontSize:13.5, color:TL.textInkSoft, lineHeight:1.6, margin:"0 0 6px"}}>✎ <strong>Edición directa:</strong> toca <strong>cualquier celda</strong> —incluidas las vacías— y escribe el dato ahí mismo. No hay botón de editar; todo se corrige en la tabla. Los campos en <span style={{color:"#B91C1C", fontWeight:700}}>rojo</span> son <strong>obligatorios</strong> (bloquean hasta llenarlos); los de <span style={{color:"#B45309", fontWeight:700}}>ámbar</span> son <strong>opcionales</strong> y puedes completarlos después. <strong>Desmarca</strong> una fila para omitirla.</p>
              <div style={{fontSize:12.5, color:TL.textInkSoft, margin:"0 0 12px"}}>
                <strong style={{color:TL.textInk}}>{nOk}</strong> lista{nOk===1?"":"s"} · <span style={{color:"#B91C1C"}}>{incluidasConError} con datos obligatorios por corregir</span> · <span style={{color:"#B45309"}}>{valids.filter((v,i)=>incluir[i]&&!v.tieneError&&v.tieneAviso).length} con opcionales por completar (puedes hacerlo después)</span>
              </div>
              <div style={{overflowX:"auto" as const, border:`1px solid ${TL.border}`, borderRadius:10}}>
                <table style={{borderCollapse:"collapse" as const, width:"100%", minWidth:820}}>
                  <thead><tr style={{background:TL.canvasSoft}}>
                    <th style={{padding:"8px 8px", fontSize:10.5, color:TL.textInkMut, fontWeight:800, textTransform:"uppercase" as const}}>Incluir</th>
                    {campos.map(c=>(<th key={c.key} style={{padding:"8px 8px", fontSize:10.5, color:TL.textInkMut, fontWeight:800, textTransform:"uppercase" as const, textAlign:"left" as const, whiteSpace:"nowrap" as const}}>{c.label}{c.requerido?" *":""}</th>))}
                    {columnaCalculada && <th style={{padding:"8px 8px", fontSize:10.5, color:"#047857", fontWeight:800, textTransform:"uppercase" as const, textAlign:"left" as const, whiteSpace:"nowrap" as const}}>{columnaCalculada.label}</th>}
                    <th style={{padding:"8px 8px", fontSize:10.5, color:TL.textInkMut, fontWeight:800, textTransform:"uppercase" as const, textAlign:"left" as const}}>Estado</th>
                  </tr></thead>
                  <tbody>
                    {filas.map((f,i)=>{
                      const val=valids[i];
                      const bg = val.tieneError ? "rgba(220,38,38,0.05)" : val.tieneAviso ? "rgba(217,119,6,0.05)" : "#fff";
                      return (
                        <tr key={i} style={{background:bg, borderTop:`1px solid ${TL.border}`, opacity:incluir[i]?1:0.5}}>
                          <td style={{padding:"6px 8px", textAlign:"center" as const}}>
                            <input type="checkbox" checked={incluir[i]} onChange={e=> setIncluir(prev=> prev.map((x,idx)=> idx===i?e.target.checked:x))}/>
                          </td>
                          {campos.map(c=>{
                            const faltaOpc = val.faltanOpc.includes(c.key);
                            const bordeCelda = val.errores[c.key] ? "#DC2626" : (val.avisos[c.key] || faltaOpc) ? "#D97706" : TL.border;
                            // Toda celda es SIEMPRE un campo editable; si está vacía, un placeholder
                            // deja claro que se puede escribir el dato ahí mismo.
                            const ph = c.requerido ? "Obligatorio" : "Agregar…";
                            return (
                            <td key={c.key} style={{padding:"4px 6px"}}>
                              <input value={f[c.key]||""} onChange={e=> setCelda(i, c.key, e.target.value)} placeholder={ph}
                                title={val.errores[c.key] || val.avisos[c.key] || (faltaOpc ? "Falta este dato · puedes agregarlo después" : "")}
                                style={{width:c.tipo==="text"&&(c.key==="nombre")?150:c.key==="curp"?150:100, boxSizing:"border-box" as const, padding:"5px 7px", fontSize:12, fontFamily:fontSans,
                                  border:`1px solid ${bordeCelda}`, borderRadius:6, background:"#fff", color:TL.textInk}}/>
                            </td>);
                          })}
                          {columnaCalculada && <td style={{padding:"6px 8px", fontSize:12.5, fontWeight:700, color:"#047857", whiteSpace:"nowrap" as const}}>{columnaCalculada.calc(f, opcVals)}</td>}
                          <td style={{padding:"6px 8px", whiteSpace:"nowrap" as const}}>
                            <div style={{display:"flex", gap:4, flexWrap:"wrap" as const}}>
                              {Object.values(val.errores).map((m,k)=>(<span key={"e"+k}>{chipErr(m)}</span>))}
                              {Object.values(val.avisos).map((m,k)=>(<span key={"a"+k}>{chipAvi(m)}</span>))}
                              {val.faltanOpc.length>0 && chipAvi(`${val.faltanOpc.length} opcional${val.faltanOpc.length===1?"":"es"} por completar`)}
                              {!val.tieneError && !val.tieneAviso && <span style={{fontSize:11, color:"#047857", fontWeight:700}}>✓ Ok</span>}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              {incluidasConError>0 && (
                <div style={{marginTop:12, fontSize:13, fontWeight:700, color:"#B91C1C", background:"rgba(220,38,38,0.08)", border:"1px solid rgba(220,38,38,0.25)", borderRadius:10, padding:"10px 14px"}}>
                  {incluidasConError} fila{incluidasConError===1?"":"s"} con datos obligatorios faltantes NO se importará{incluidasConError===1?"":"n"} hasta completarla{incluidasConError===1?"":"s"}. Las demás válidas sí se importan; corrige aquí mismo o desmarca la fila.
                </div>
              )}
              <div style={{display:"flex", justifyContent:"space-between", marginTop:14, gap:10, flexWrap:"wrap" as const}}>
                <button onClick={(ev)=>{ if (!fuenteIA) { setPaso("mapear"); return; } if (sePuedeCerrarElPanel(ev)) onCerrar(); }} style={btnSec}>{fuenteIA ? "Cancelar" : "‹ Atrás"}</button>
                <button onClick={confirmarImport} disabled={!puedeImportar} title={!puedeImportar?"Marca al menos una fila con nombre, fecha de ingreso y salario":""}
                  style={{...btnPrim, opacity:puedeImportar?1:0.5, cursor:puedeImportar?"pointer":"not-allowed"}}>Importar {nOk} {nOk===1?entidad.singular:entidad.plural}{incluidasConError>0?` · ${incluidasConError} con obligatorios por corregir`:""} ✓</button>
              </div>
            </div>
          )}

          {paso==="importando" && (
            <div style={{textAlign:"center" as const, padding:"30px 10px"}}>
              <div style={{fontSize:15, fontWeight:700, color:TL.textInk, marginBottom:12}}>Importando… {progreso.hechas} de {progreso.total}</div>
              <div style={{height:8, background:TL.canvasSoft, borderRadius:999, overflow:"hidden"}}>
                <div style={{height:"100%", width:`${progreso.total?Math.round(progreso.hechas/progreso.total*100):0}%`, background:gold, transition:"width 0.2s"}}/>
              </div>
            </div>
          )}

          {paso==="resumen" && (
            <div style={{textAlign:"center" as const, padding:"24px 10px"}}>
              <div style={{fontSize:34, marginBottom:8}}>{resumen.fallo?"⚠️":"✅"}</div>
              <div style={{fontFamily:fontSerif, fontSize:20, fontWeight:700, color:TL.textInk, marginBottom:6}}>Importación terminada</div>
              <div style={{fontSize:14, color:TL.textInkSoft, lineHeight:1.7}}>
                <strong style={{color:"#047857"}}>{resumen.ok}</strong> importado{resumen.ok===1?"":"s"} correctamente.
                {resumen.fallo>0 && <><br/><strong style={{color:"#B91C1C"}}>{resumen.fallo}</strong> con error al guardar.</>}
                {resumen.omitidas>0 && <><br/><strong style={{color:"#B45309"}}>{resumen.omitidas}</strong> omitido{resumen.omitidas===1?"":"s"} (con error o desmarcado{resumen.omitidas===1?"":"s"}).</>}
              </div>
              <button onClick={onTerminar} style={{...btnPrim, marginTop:20}}>Listo</button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════
// ImportadorIADocumento — envuelve al importador: sube un documento (PDF/Word),
// la IA EXTRAE los registros y los deja caer en la MISMA tabla de confirmación
// de ImportadorLote (validación, duplicados, edición, guardado idénticos). La IA
// propone, el HUMANO confirma. Reutilizable: cambia `campos` + `entidad`.
// ═══════════════════════════════════════════════════════════════════════════
function ImportadorIADocumento({titulo, campos, existentes, firmaFila, validarFilaExtra, opcionesGlobales, columnaCalculada, onGuardarFila, onTerminar, onCerrar, entidad, fontSans, fontSerif, gold}: {
  titulo:string; campos:CampoImport[]; existentes:any[];
  firmaFila?:(o:any)=>string[];
  validarFilaExtra?:(valores:Record<string,string>, opciones:Record<string,string>)=>{errores?:Record<string,string>; avisos?:Record<string,string>};
  opcionesGlobales?:{key:string; label:string; opciones:{value:string; label:string}[]; default:string}[];
  columnaCalculada?:{label:string; calc:(valores:Record<string,string>, opciones:Record<string,string>)=>string};
  onGuardarFila:(valores:Record<string,string>, opciones:Record<string,string>)=>Promise<void>;
  onTerminar:()=>void; onCerrar:()=>void;
  entidad:{singular:string; plural:string};
  fontSans:string; fontSerif:string; gold:string;
}) {
  const TL = T_LIGHT;
  const [registros, setRegistros] = useState<any[]|null>(null);
  const [cargando, setCargando] = useState(false);
  const [err, setErr] = useState("");
  const [aviso, setAviso] = useState("");
  const [nombreArch, setNombreArch] = useState("");

  const procesar = async (file:File) => {
    setErr(""); setAviso(""); setCargando(true); setNombreArch(file.name||"");
    try {
      const {registros:regs, aviso:av} = await extraerRegistrosDeDocumentoIA(file, campos, entidad);
      if (!regs.length){ setErr(`La IA no encontró ${entidad.plural} en el documento. Revisa que el archivo tenga una lista de ${entidad.plural}, o usa el importador de Excel/CSV.`); setCargando(false); return; }
      setAviso(av||""); setRegistros(regs);
    } catch(e:any){ setErr(e?.message || "No se pudo procesar el documento."); }
    setCargando(false);
  };

  // Ya extraídos → cae en la MISMA tabla de confirmación (ImportadorLote).
  if (registros) {
    return <ImportadorLote
      titulo={titulo} campos={campos} existentes={existentes}
      firmaFila={firmaFila} validarFilaExtra={validarFilaExtra}
      opcionesGlobales={opcionesGlobales} columnaCalculada={columnaCalculada} entidad={entidad}
      onGuardarFila={onGuardarFila} onTerminar={onTerminar} onCerrar={onCerrar}
      registrosIA={registros} fuenteIA
      notaSuperior={`Datos extraídos por IA de “${nombreArch}”. Revisa y corrige antes de guardar.${aviso? " "+aviso : ""}`}
      fontSans={fontSans} fontSerif={fontSerif} gold={gold}
    />;
  }

  const overlay:any = {position:"fixed", inset:0, zIndex:3000, background:"rgba(11,24,41,0.55)", display:"flex", alignItems:"flex-start", justifyContent:"center", padding:"18px", overflowY:"auto", backdropFilter:"blur(3px)"};
  const panel:any = {width:"100%", maxWidth:620, background:TL.canvas, borderRadius:16, boxShadow:"0 24px 70px rgba(0,0,0,0.5)", fontFamily:fontSans, overflow:"hidden"};
  const btnPrim:any = {background:gold, color:"#0B1829", border:"none", borderRadius:10, padding:"9px 16px", fontSize:13, fontWeight:700, cursor:cargando?"wait":"pointer", fontFamily:fontSans};

  return (
    <div style={overlay}>
      <div {...PANEL_DE_CAPTURA} style={panel} onClick={e=>e.stopPropagation()}>
        <div style={{background:T.navy, padding:"14px 20px", display:"flex", alignItems:"center", justifyContent:"space-between", gap:12}}>
          <div style={{fontFamily:fontSerif, fontSize:17, fontWeight:700, color:"white"}}>{titulo} · desde documento (IA)</div>
          <button onClick={(ev)=>{ if (sePuedeCerrarElPanel(ev)) onCerrar(); }} aria-label="Cerrar" style={{background:"rgba(255,255,255,0.10)", border:"none", color:"white", width:30, height:30, borderRadius:8, cursor:"pointer", fontSize:15}}>✕</button>
        </div>
        <div style={{padding:"20px", maxHeight:"calc(100vh - 140px)", overflowY:"auto" as const}}>
          <p style={{fontSize:13.5, color:TL.textInkSoft, lineHeight:1.6, margin:"0 0 6px"}}>Sube un <strong>PDF</strong> o <strong>Word (.docx)</strong> con tu lista de {entidad.plural} (una plantilla, un oficio, la lista que ya tengas). La IA <strong>lee el documento y propone los datos</strong>; luego los revisas y corriges en una tabla <strong>antes de guardar</strong>.</p>
          <div style={{fontSize:12, color:TL.textInkMut, lineHeight:1.55, margin:"0 0 16px"}}>La IA extrae solo lo que está escrito; lo que no encuentre lo deja vacío para que tú lo completes. <strong>Nada se guarda automáticamente.</strong> Se envía únicamente este documento para la extracción.</div>
          <label style={{...btnPrim, display:"inline-flex", alignItems:"center", gap:8}}>
            {cargando ? "Leyendo el documento con IA…" : "📄 Seleccionar PDF o Word"}
            <input type="file" accept=".pdf,.docx" style={{display:"none"}} disabled={cargando}
              onChange={e=>{ const f=e.target.files?.[0]; if(f) procesar(f); e.currentTarget.value=""; }}/>
          </label>
          {cargando && <div style={{marginTop:14, fontSize:12.5, color:TL.textInkSoft}}>Analizando “{nombreArch}”… esto puede tardar unos segundos.</div>}
          {err && <div style={{marginTop:14, fontSize:13, color:"#B91C1C", background:"rgba(220,38,38,0.08)", border:"1px solid rgba(220,38,38,0.25)", borderRadius:10, padding:"11px 14px"}}>{err}</div>}
          <div style={{marginTop:16, fontSize:11.5, color:TL.textInkMut, lineHeight:1.55}}>Campos que intentará extraer: {campos.map(c=> c.label).join(" · ")}. La revisión humana es obligatoria: un RFC, fecha o salario mal leído se propaga a vacaciones, aguinaldo y nómina.</div>
        </div>
      </div>
    </div>
  );
}

// Módulo de EXPEDIENTE. Ya no tiene pestaña de Nómina: Nómina es su propio
// módulo del sidebar y desde aquí se llega por la acción contextual de la ficha
// (`onGenerarRecibo`), que abre Nómina con ese trabajador puesto. Dos caminos
// para la misma pantalla era lo que dejaba al usuario atrapado en la pestaña.
function EmpleadosModulo({onBack, fontSans, fontSerif, gold, currentUser, onVerTareas, onGenerarRecibo, trabajadorInicialId, trabajadorInicialTab, focoEmails, onGoContratos}: {
  onBack:()=>void; fontSans:string; fontSerif:string; gold:string; currentUser:any;
  onVerTareas?: (email:string)=>void; onGenerarRecibo:(t:any)=>void;
  // Salto desde un aviso de contrato por vencer: abre SU expediente.
  trabajadorInicialId?: string|null;
  // Y en qué apartado de la ficha. Una checada del feed lleva a su asistencia,
  // un documento a Documentos, un contrato a Contratos. Sin esto, todos los
  // saltos caían en "Datos" y había que buscar a mano el hecho que se pulsó.
  trabajadorInicialTab?: "datos"|"checador"|"documentos"|"contratos"|null;
  // Correos a los que se acota la lista al llegar desde el renglon del checador.
  focoEmails?: string[];
  onGoContratos: ()=>void;
}) {
  const [verHorarioConfig, setVerHorarioConfig] = useState(false);   // ventana de horario+ubicación
  // El banner EXPLICA (no navega ni acciona): se pliega. Viene REPLEGADO en
  // cuanto hay plantilla y sólo se abre solo con la cuenta vacía; mientras no
  // sabemos (aún cargando) se queda replegado, para no interponer orientación
  // antes de los datos.
  const [hayPlantilla, setHayPlantilla] = useState<boolean|null>(null);
  const [orientacionAbierta, alternarOrientacion] = usarPlegable("axis_orientacion_empleados", hayPlantilla===false);
  const isMobile = window.innerWidth < 768;

  // Guard: requiere cuenta porque guarda expedientes por usuario en Firestore
  if (!currentUser) {
    return (
      <div style={{minHeight:"100vh", background:T_LIGHT.canvas, fontFamily:fontSans, display:"flex", flexDirection:"column" as const}}>
        <div style={{background:T.navy, padding:"0 20px",
          height:58, display:"flex", alignItems:"center", gap:12,
          borderBottom:"1px solid rgba(184,147,42,0.24)", boxShadow:"0 2px 16px rgba(22,36,71,0.12)"}}>
          <button onClick={onBack}
            style={{background:"rgba(255,255,255,0.08)", border:"1px solid rgba(255,255,255,0.12)",
              color:"white", borderRadius:8, padding:"5px 12px", cursor:"pointer", fontSize:12}}>
            ← Suite
          </button>
          <span style={{color:"white", fontWeight:600, fontSize:14, display:"flex", alignItems:"center", gap:8}}>
            <AxisIcon name="suite_empleados" size={18} tone="white" withBackdrop={false} strokeWidth={2.5}/>
            Empleados
          </span>
        </div>
        <div style={{flex:1, display:"flex", alignItems:"center", justifyContent:"center", padding:"32px 20px"}}>
          <div style={{maxWidth:440, width:"100%", textAlign:"center" as const,
            background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.goldBorder}`,
            borderRadius:18, padding:isMobile?"32px 22px":"44px 36px",
            boxShadow:T_LIGHT.shadow}}>
            <div style={{marginBottom:14, display:"flex", justifyContent:"center"}}>
              <AxisIcon name="suite_empleados" size={48} tone="gold" withBackdrop={false} strokeWidth={2.5}/>
            </div>
            <h2 style={{fontFamily:fontSerif, fontSize:isMobile?20:24, color:T_LIGHT.textInk,
              margin:"0 0 12px", fontWeight:700}}>Necesitas una cuenta</h2>
            <p style={{fontSize:14, lineHeight:1.6, color:T_LIGHT.textInkSoft, margin:"0 0 24px"}}>
              Empleados guarda los expedientes de tus trabajadores de forma segura. Crea una cuenta gratuita para usar este módulo.
            </p>
            <button onClick={onBack}
              style={{background:gold, border:"none", color:"#0B1829", borderRadius:10,
                padding:"12px 28px", cursor:"pointer", fontSize:14, fontWeight:700,
                fontFamily:fontSans, width:"100%", boxShadow:"0 4px 16px rgba(184,147,42,0.35)"}}>
              ← Volver a la Suite
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Fondo del sistema en la raíz del módulo: es la capa que pinta la franja
  // reservada al pie, y con el crema quedaba una banda de otro color.
  return (
    <div style={{minHeight:"100vh", background:UI.fondo}}>

      {/* ORIENTACIÓN (explica, no navega ni acciona) → se pliega y se recuerda.
          Los accesos reales viven en el sidebar y en la ficha del trabajador. */}
      <div style={{padding:isMobile?"8px 14px 0":"10px 18px 0", background:UI.fondo}}>
        <TiraPlegable abierto={orientacionAbierta} onAlternar={alternarOrientacion} fontSans={fontSans} texto="Qué hace esta pantalla"/>
      </div>
      {orientacionAbierta && (
      <div style={{background:"linear-gradient(135deg,rgba(14,165,233,0.10),rgba(124,58,237,0.06))",borderBottom:`1px solid ${T_LIGHT.border}`,padding:"12px 24px",display:"flex",gap:20,flexWrap:"wrap" as const}}>
        <div style={{display:"flex",alignItems:"center",gap:10,flex:1,minWidth:200}}>
          <div style={{flexShrink:0}}><AxisIcon name="user_single" size={26} tone="gold" color="#0EA5E9" withBackdrop={false} strokeWidth={2.5}/></div>
          <div>
            <div style={{fontSize:12,fontWeight:700,color:"#0EA5E9",marginBottom:2}}>Expediente</div>
            <div style={{fontSize:11,color:T_LIGHT.textInkSoft,lineHeight:1.5}}>Da de alta a tus trabajadores con sus datos, contrato y salario. La app calcula automáticamente vacaciones, aguinaldo y prima vacacional conforme a la LFT.</div>
          </div>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:10,flex:1,minWidth:200}}>
          <div style={{flexShrink:0}}><AxisIcon name="briefcase" size={26} tone="gold" color="#059669" withBackdrop={false} strokeWidth={2.5}/></div>
          <div>
            <div style={{fontSize:12,fontWeight:700,color:"#059669",marginBottom:2}}>Nómina</div>
            <div style={{fontSize:11,color:T_LIGHT.textInkSoft,lineHeight:1.5}}>Los recibos de pago (ISR y cuota IMSS) viven en <strong>Nómina</strong>, en el menú lateral. Desde la ficha de un trabajador puedes saltar directo a generar el suyo.</div>
          </div>
        </div>
      </div>
      )}

      {/* Acceso al horario general: ventana, no otra pantalla. */}
      {/* Entrada compacta al horario+ubicación (abre ventana; deja la lista limpia) */}
      <div style={{maxWidth:ANCHO_CONTENIDO, margin:"0 auto", padding:isMobile?"16px 16px 0":"24px 24px 0"}}>
        <button onClick={()=>setVerHorarioConfig(true)}
          style={{display:"inline-flex", alignItems:"center", gap:10, textAlign:"left" as const, fontFamily:fontSans, background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rControl, padding:"8px 14px", cursor:"pointer", boxShadow:UI.sombra}}>
          <span style={{flexShrink:0, display:"flex", alignItems:"center", color:UI.navy}}>
            <svg width="17" height="17" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.6"/><path d="M12 7.5V12l3 1.7" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/></svg>
          </span>
          <span style={{fontSize:UI.fsCuerpo, fontWeight:700, color:UI.texto, whiteSpace:"nowrap" as const}}>Horario y ubicación de trabajo</span>
          <span style={{fontSize:UI.fsEtiqueta, color:UI.textoTenue, whiteSpace:"nowrap" as const}}>Entrada/salida, tolerancia y geocerca</span>
          <span style={{fontSize:15, color:UI.textoTenue, marginLeft:2}}>›</span>
        </button>
      </div>
      {verHorarioConfig && (
        <div style={{position:"fixed" as const, inset:0, background:"rgba(0,0,0,0.55)", zIndex:500, display:"flex", alignItems:"center", justifyContent:"center", padding:20, backdropFilter:"blur(4px)"}}>
          <div {...PANEL_DE_CAPTURA} onClick={e=>e.stopPropagation()} style={{background:"white", borderRadius:18, padding:"18px 20px 24px", maxWidth:520, width:"100%", maxHeight:"88vh", overflowY:"auto" as const, boxShadow:"0 20px 60px rgba(0,0,0,0.2)"}}>
            <div style={{display:"flex", justifyContent:"flex-end", marginBottom:4}}>
              <button onClick={(ev)=>{ if (sePuedeCerrarElPanel(ev)) setVerHorarioConfig(false); }} aria-label="Cerrar" style={{width:32, height:32, borderRadius:"50%", border:`1px solid ${T_LIGHT.borderCard}`, background:"transparent", color:T_LIGHT.textInkSoft, cursor:"pointer", fontSize:17, lineHeight:1}}>×</button>
            </div>
            <HorarioLaboralEditor modo="general" currentUser={currentUser} tema="light" fontSans={fontSans} fontSerif={fontSerif} />
            <InterruptorRecordatorioEntrada uid={currentUser?.uid || ""} tema="light" fontSans={fontSans}/>
          </div>
        </div>
      )}
      <ExpedienteInner
        fontSans={fontSans} fontSerif={fontSerif} gold={gold} currentUser={currentUser}
        trabajadorInicialId={trabajadorInicialId}
        trabajadorInicialTab={trabajadorInicialTab}
        focoEmails={focoEmails}
        onGoContratos={onGoContratos}
        onIrNomina={onGenerarRecibo}
        onVerTareas={onVerTareas}
        onPlantilla={(n)=>setHayPlantilla(n>0)}
      />
    </div>
  );
}

// ─── COMPLIANCE Y ACTIVIDADES — TIPOS, CONSTANTES Y CÁLCULOS ──────────────────────
type ComplianceEstado = "ok" | "pendiente" | "na";
type ComplianceData = { [itemKey: string]: ComplianceEstado };

type ComplianceItem = {
  key: string;
  label: string;
  tipo: "obligatorio" | "recomendado" | "condicional";
  baseLegal: string;
  seccion: "identidad" | "seguridad_social" | "contractual" | "capacitacion" | "puesto";
};

type Tarea = {
  id: string;
  titulo: string;
  descripcion: string;
  fechaAsignada: string;
  fechaLimite: string;
  estado: "pendiente" | "cumplida" | "no_cumplida" | "fuera_plazo";
  fechaCompletada?: string;
  notasPatron?: string;
};

const COMPLIANCE_SECCIONES: {key: ComplianceItem["seccion"]; label: string; iconName: string}[] = [
  { key: "identidad", label: "Identidad", iconName: "user_single" },
  { key: "seguridad_social", label: "Seguridad social", iconName: "scale_simple" },
  { key: "contractual", label: "Contractual", iconName: "document" },
  { key: "capacitacion", label: "Capacitación y seguridad", iconName: "briefcase" },
  { key: "puesto", label: "Documentación del puesto", iconName: "clipboard" },
];

const COMPLIANCE_ITEMS: ComplianceItem[] = [
  { key: "ine", label: "INE / Identificación oficial vigente", tipo: "obligatorio", baseLegal: "Verificación de identidad", seccion: "identidad" },
  { key: "curp", label: "CURP", tipo: "obligatorio", baseLegal: "Registro Nacional de Población", seccion: "identidad" },
  { key: "rfc", label: "RFC", tipo: "obligatorio", baseLegal: "CFF Art. 27", seccion: "identidad" },
  { key: "acta_nacimiento", label: "Acta de nacimiento", tipo: "obligatorio", baseLegal: "Verificación de edad", seccion: "identidad" },
  { key: "comprobante_domicilio", label: "Comprobante de domicilio (≤ 3 meses)", tipo: "obligatorio", baseLegal: "Notificaciones legales", seccion: "identidad" },
  { key: "nss", label: "Número de Seguro Social (NSS)", tipo: "obligatorio", baseLegal: "LSS Art. 15", seccion: "seguridad_social" },
  { key: "alta_imss", label: "Aviso de alta al IMSS", tipo: "obligatorio", baseLegal: "LSS Art. 15 — 5 días", seccion: "seguridad_social" },
  { key: "infonavit", label: "Aviso de retención INFONAVIT", tipo: "condicional", baseLegal: "Ley INFONAVIT", seccion: "seguridad_social" },
  { key: "fonacot", label: "Aviso FONACOT", tipo: "condicional", baseLegal: "Ley FONACOT", seccion: "seguridad_social" },
  { key: "contrato_firmado", label: "Contrato individual de trabajo firmado", tipo: "obligatorio", baseLegal: "LFT Art. 24-28", seccion: "contractual" },
  { key: "reglamento_interior", label: "Reglamento interior — acuse de recibo", tipo: "obligatorio", baseLegal: "LFT Art. 422-425", seccion: "contractual" },
  { key: "aviso_privacidad", label: "Aviso de privacidad firmado", tipo: "obligatorio", baseLegal: "LFPDPPP", seccion: "contractual" },
  { key: "confidencialidad", label: "Convenio de confidencialidad", tipo: "recomendado", baseLegal: "LFPI", seccion: "contractual" },
  { key: "dc3", label: "DC-3 inicial (constancia de habilidades)", tipo: "obligatorio", baseLegal: "LFT Art. 153-V", seccion: "capacitacion" },
  { key: "dc4", label: "DC-4 lista anual", tipo: "obligatorio", baseLegal: "LFT Art. 153-Q", seccion: "capacitacion" },
  { key: "examen_medico", label: "Examen médico de ingreso", tipo: "recomendado", baseLegal: "NOM-030-STPS", seccion: "capacitacion" },
  { key: "capacitacion_seguridad", label: "Capacitación en seguridad (si NOM aplica)", tipo: "condicional", baseLegal: "NOMs sectoriales STPS", seccion: "capacitacion" },
  { key: "cedula_profesional", label: "Cédula profesional", tipo: "condicional", baseLegal: "Ley de Profesiones", seccion: "puesto" },
  { key: "antecedentes_penales", label: "Carta de no antecedentes penales", tipo: "recomendado", baseLegal: "Según puesto", seccion: "puesto" },
  { key: "certificados_academicos", label: "Certificados académicos", tipo: "recomendado", baseLegal: "Según puesto", seccion: "puesto" },
];

function calcularCompliance(compliance: ComplianceData | undefined): {porcentaje: number; cumplidos: number; aplicables: number; totalObligatorios: number; obligatoriosCumplidos: number} {
  if (!compliance) return {porcentaje: 0, cumplidos: 0, aplicables: 0, totalObligatorios: 0, obligatoriosCumplidos: 0};
  let puntosCumplidos = 0;
  let puntosAplicables = 0;
  let totalObligatorios = 0;
  let obligatoriosCumplidos = 0;
  COMPLIANCE_ITEMS.forEach(item => {
    const estado = compliance[item.key] || "pendiente";
    const peso = item.tipo === "obligatorio" ? 2 : 1;
    if (estado === "na") return;
    puntosAplicables += peso;
    if (estado === "ok") puntosCumplidos += peso;
    if (item.tipo === "obligatorio") {
      totalObligatorios++;
      if (estado === "ok") obligatoriosCumplidos++;
    }
  });
  const porcentaje = puntosAplicables === 0 ? 0 : Math.round((puntosCumplidos / puntosAplicables) * 100);
  return {porcentaje, cumplidos: puntosCumplidos, aplicables: puntosAplicables, totalObligatorios, obligatoriosCumplidos};
}

// ═══ LO QUE HUELE MAL EN LA LISTA, DICHO Y NO ARREGLADO ══════════════════════
// SEÑALA, NO FUSIONA. Una herramienta que junte dos fichas toca checadas,
// actividades, documentos y nómina, y esa no se escribe con prisa. Aquí solo se
// dice lo que se ve, con nombres, para que una persona decida.
//
// Las dos cosas que se buscan salieron de casos reales de esta semana:
//   · DOS FICHAS ACTIVAS CON EL MISMO NOMBRE. Pasa cuando se crea la cuenta con
//     el correo mal escrito: nace una ficha nueva, y a partir de ahí el aviso del
//     checador nombra al duplicado —porque la cuenta cuelga del correo— mientras
//     la persona real queda a un lado. El contador de plantilla también la cuenta
//     dos veces.
//   · UNA FICHA CON CUENTA Y SIN PUESTO NI SALARIO. Es la forma que tiene una
//     ficha creada automáticamente al dar de alta la cuenta. Puede ser legítima
//     —falta capturarla— o ser la mitad huérfana de un duplicado.
function nombreCotejable(v:any): string {
  return String(v||"").toLowerCase()
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "")   // sin acentos: ANA KAREN = Ana Karén
    .replace(/[^a-z0-9 ]/g, " ").replace(/\s+/g, " ").trim();
}
type SospechaLista = {clase:"duplicada"|"a_medias"; nombre:string; detalle:string};
function sospechasDeLaLista(fichas:any[], cuentasTrab:any[]|null): SospechaLista[] {
  const activas = (fichas||[]).filter((e:any)=> (e?.status||"activo") !== "baja");
  const out: SospechaLista[] = [];

  // 1. Mismo nombre, dos veces o más.
  const porNombre = new Map<string, any[]>();
  for (const e of activas) {
    const k = nombreCotejable(e?.nombre);
    if (!k) continue;
    porNombre.set(k, (porNombre.get(k) || []).concat([e]));
  }
  porNombre.forEach((grupo:any[]) => {
    if (grupo.length < 2) return;
    // Los correos distinguen a las dos fichas, y son el dato que hay que mirar
    // para saber cuál es la que el checador está viendo.
    const correos = grupo.map((e:any)=> String(e.email||"").toLowerCase().trim() || "sin correo");
    out.push({clase:"duplicada", nombre: grupo[0]?.nombre || "(sin nombre)",
      detalle: `${grupo.length} fichas activas con este nombre · ${correos.join(" · ")}`});
  });

  // 2. Con cuenta, pero sin lo que hace falta para pagarle.
  // Si la colección no se ha podido leer, esta parte NO se afirma: sin saber quién
  // tiene cuenta, "tiene cuenta y le faltan datos" no se puede sostener.
  if (Array.isArray(cuentasTrab)) {
    const conCuenta = correosConCuentaActiva(cuentasTrab);
    for (const e of activas) {
      const correo = String(e?.email||"").toLowerCase().trim();
      if (!correo || !conCuenta.has(correo)) continue;
      const falta: string[] = [];
      if (!String(e?.puesto||"").trim()) falta.push("puesto");
      if (!Number(e?.salarioDiario) && !Number(e?.salarioMensual)) falta.push("salario");
      if (!String(e?.fechaIngreso||"").trim()) falta.push("fecha de ingreso");
      if (!falta.length) continue;
      out.push({clase:"a_medias", nombre: e?.nombre || correo,
        detalle: `tiene cuenta activa y le falta ${falta.join(", ")}`});
    }
  }
  return out;
}

// ═══ EL CORREO DE UNA CUENTA NUEVA SEÑALA A UNA FICHA, O A NINGUNA ═══════════
// Al crear una cuenta de acceso, si el correo coincide con la ficha de alguien,
// esa persona recibe su acceso. Si no coincide con NINGUNA, la app creaba en
// silencio una ficha nueva con ese correo, y no lo decía en ninguna parte.
//
// Una letra de más en el correo bastaba para que apareciera un segundo empleado
// activo, sin puesto y sin salario. Cuenta en la plantilla, sale en Nómina, y el
// aviso del checador nombra a ESE —porque la cuenta cuelga del correo, y el
// correo lo tiene el duplicado— mientras la persona real se queda sin acceso.
// Una semana entera de avisos apuntando a alguien que no existe.
//
// AHORA SE PREGUNTA ANTES DE CREAR NADA. No después: la cuenta de Firebase Auth
// no se puede borrar desde la app, así que preguntar después de crearla dejaría
// basura irreversible cada vez que alguien se arrepiente.
function normalizaCorreo(v:any): string { return String(v||"").toLowerCase().trim(); }
function soloAlfanum(v:any): string { return String(v||"").toLowerCase().replace(/[^a-z0-9]/g, ""); }

// La ficha a la que este correo apunta, si es que apunta a alguna.
function fichaDelCorreo(fichas:any[], email:string): any|null {
  const correo = normalizaCorreo(email);
  if (!correo) return null;
  return (fichas||[]).find((t:any)=> normalizaCorreo(t?.email) === correo) || null;
}

// Distancia de edición acotada. Sirve para "una letra de más o de menos", que es
// el error real; no pretende comparar frases. Se corta en cuanto se pasa del
// margen, para no recorrer una matriz entera por gusto.
function distanciaCorta(a:string, b:string, max:number): number {
  if (a === b) return 0;
  if (Math.abs(a.length - b.length) > max) return max + 1;
  let prev = new Array(b.length + 1);
  for (let j = 0; j <= b.length; j++) prev[j] = j;
  for (let i = 1; i <= a.length; i++) {
    const fila = new Array(b.length + 1);
    fila[0] = i;
    let mejor = i;
    for (let j = 1; j <= b.length; j++) {
      const costo = a.charAt(i-1) === b.charAt(j-1) ? 0 : 1;
      fila[j] = Math.min(fila[j-1] + 1, prev[j] + 1, prev[j-1] + costo);
      if (fila[j] < mejor) mejor = fila[j];
    }
    if (mejor > max) return max + 1;
    prev = fila;
  }
  return prev[b.length];
}

// LAS FICHAS A LAS QUE ESTE CORREO PODRÍA ESTAR QUERIENDO APUNTAR. El nombre va
// PRIMERO y no exige correo: el caso más común es una ficha real a la que nunca
// se le capturó el correo, y esa es justo la que hay que enseñar.
function fichasParecidas(o:{fichas:any[]; email:string; nombre:string}): {ficha:any; porque:string}[] {
  const correo = normalizaCorreo(o.email);
  const nom = soloAlfanum(o.nombre);
  const partes = correo.split("@");
  const loc = partes[0] || "", dom = partes[1] || "";
  const out: {ficha:any; porque:string}[] = [];
  for (const t of (o.fichas||[])) {
    if ((t?.status || "activo") === "baja") continue;
    const suCorreo = normalizaCorreo(t?.email);
    if (suCorreo && suCorreo === correo) continue;   // eso es coincidencia, no parecido
    const suNom = soloAlfanum(t?.nombre);
    let porque = "";
    if (nom && suNom && (suNom === nom || suNom.indexOf(nom) >= 0 || nom.indexOf(suNom) >= 0)) {
      porque = "se llama igual";
    } else if (suCorreo) {
      const suPartes = suCorreo.split("@");
      const suLoc = suPartes[0] || "", suDom = suPartes[1] || "";
      if (loc && suLoc && soloAlfanum(loc) === soloAlfanum(suLoc)) porque = suDom !== dom ? "mismo nombre de correo, otro dominio" : "el correo es casi igual";
      else if (distanciaCorta(correo, suCorreo, 2) <= 2) porque = "el correo es casi igual";
    }
    if (porque) out.push({ficha:t, porque});
  }
  return out.slice(0, 6);
}

// EL AVISO. Dice a quién se va a dar de alta, qué consecuencia tiene, y ofrece
// las dos salidas: seguir, o volver a corregir el correo. Lo usan las DOS
// pantallas que crean cuentas, para que no vuelvan a divergir.
function ConfirmarCuentaSinFicha({correo, nombre, parecidas, creando, onCrearNueva, onCorregir, onUsarCorreo, fontSans, fontSerif}:{
  correo:string; nombre:string; parecidas:{ficha:any; porque:string}[]; creando:boolean;
  onCrearNueva:()=>void; onCorregir:()=>void; onUsarCorreo:(c:string)=>void;
  fontSans:string; fontSerif:string;
}) {
  return (
    <div style={{position:"fixed" as const, inset:0, background:"rgba(0,0,0,0.60)", zIndex:700, display:"flex", alignItems:"center", justifyContent:"center", padding:20, backdropFilter:"blur(4px)"}}>
      <div onClick={(e)=>e.stopPropagation()} style={{background:"white", borderRadius:16, padding:"22px 24px", width:"100%", maxWidth:560, maxHeight:"88vh", overflowY:"auto" as const, boxShadow:"0 24px 60px rgba(0,0,0,0.30)"}}>
        <div style={{fontFamily:fontSerif, fontSize:18, fontWeight:700, color:"#0B1829", marginBottom:8}}>Ningún empleado tuyo tiene ese correo</div>
        <div style={{fontSize:13, color:"#4A4A60", lineHeight:1.6, marginBottom:14}}>
          Si continúas se dará de alta <b>un empleado nuevo</b>, <b>{nombre}</b>, con el correo <b>{correo}</b>.
          {" "}Contará en tu plantilla, aparecerá en Nómina y el checador empezará a nombrarlo.
        </div>
        <div style={{background:"rgba(184,147,42,0.10)", border:"1px solid rgba(184,147,42,0.30)", borderRadius:10, padding:"11px 13px", fontSize:12.5, color:"#7A5F12", lineHeight:1.6, marginBottom:parecidas.length?14:18}}>
          Si el correo tiene una errata, esto crea una <b>ficha duplicada</b>: la persona real se queda sin acceso, y los avisos del checador pasan a nombrar al duplicado en vez de a ella.
        </div>
        {parecidas.length > 0 && (
          <div style={{marginBottom:18}}>
            <div style={{fontSize:12.5, fontWeight:700, color:"#0B1829", marginBottom:8}}>¿Querías darle acceso a alguno de estos?</div>
            <div style={{display:"flex", flexDirection:"column" as const, gap:7}}>
              {parecidas.map((x:any, i:number) => {
                const suCorreo = String(x.ficha?.email||"").toLowerCase().trim();
                return (
                  <div key={x.ficha?.id || i}
                    onClick={()=>{ if (suCorreo && !creando) onUsarCorreo(suCorreo); }}
                    style={{border:"1px solid rgba(0,0,0,0.12)", borderRadius:10, padding:"9px 12px", cursor:(suCorreo && !creando)?"pointer":"default", background:suCorreo?"white":"rgba(0,0,0,0.02)"}}>
                    <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", gap:10, flexWrap:"wrap" as const}}>
                      <div style={{minWidth:0}}>
                        <div style={{fontSize:13, fontWeight:700, color:"#0B1829"}}>{x.ficha?.nombre || "Sin nombre"}</div>
                        <div style={{fontSize:11.5, color:suCorreo?"#4A4A60":"#9A9AAA", marginTop:1}}>
                          {suCorreo || "sin correo capturado — captúraselo en su ficha y vuelve aquí"}
                        </div>
                      </div>
                      <div style={{display:"flex", alignItems:"center", gap:8, flexShrink:0}}>
                        <span style={{fontSize:10.5, fontWeight:700, color:"#6B7280", background:"rgba(0,0,0,0.05)", borderRadius:20, padding:"3px 9px", whiteSpace:"nowrap" as const}}>{x.porque}</span>
                        {/* LA ACCIÓN QUE QUEREMOS QUE SE ELIJA, con forma de botón.
                            Era un enlace gris al extremo derecho: quien no sabía que
                            estaba ahí no lo veía, y lo único visible del modal era el
                            botón que crea la ficha nueva. */}
                        {suCorreo && (
                          <button type="button" disabled={creando}
                            onClick={(ev)=>{ ev.stopPropagation(); if (!creando) onUsarCorreo(suCorreo); }}
                            style={{background:creando?"rgba(0,0,0,0.08)":"#236478", border:"none", borderRadius:9,
                              padding:"7px 14px", cursor:creando?"not-allowed":"pointer", fontSize:12, fontWeight:700,
                              color:creando?"#9A9AAA":"white", fontFamily:fontSans, whiteSpace:"nowrap" as const, flexShrink:0}}>
                            Usar este
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
        <div style={{display:"flex", gap:10, flexWrap:"wrap" as const}}>
          <button onClick={onCorregir} disabled={creando}
            style={{flex:"1 1 200px", background:"rgba(22,36,71,0.06)", border:"none", borderRadius:12, padding:"12px", cursor:creando?"not-allowed":"pointer", fontSize:13, fontWeight:700, color:"#4A4A60", fontFamily:fontSans}}>
            Cancelar y corregir el correo
          </button>
          {/* SALIDA LEGÍTIMA, PERO NO LA SUGERIDA. Iba en teal sólido, así que el
              botón visualmente dominante del modal era el que crea la ficha nueva
              —el que produce el duplicado— y la salida buena era un enlace gris.
              Pasa a contorno: sigue a la vista y se puede pulsar igual, pero deja
              de proponerse. Ni se esconde ni se deshabilita. */}
          <button onClick={onCrearNueva} disabled={creando}
            style={{flex:"1 1 200px", background:"transparent", border:`1px solid ${creando?"rgba(0,0,0,0.15)":"rgba(35,100,120,0.45)"}`, borderRadius:12, padding:"12px", cursor:creando?"wait":"pointer", fontSize:13, fontWeight:700, color:creando?"#9A9AAA":"#236478", fontFamily:fontSans}}>
            {creando ? "Creando cuenta…" : "Sí, es un empleado nuevo"}
          </button>
        </div>
        <div style={{fontSize:11, color:"#9A9AAA", marginTop:10, lineHeight:1.5}}>
          Todavía no se ha creado ninguna cuenta. Si cancelas, no queda nada a medias.
        </div>
      </div>
    </div>
  );
}

function calcularRendimiento(tareas: Tarea[] | undefined, diasAtras: number = 90, referencia?: Date): {porcentaje: number; cumplidasATiempo: number; total: number; pendientes: number; evaluadas: number} {
  if (!tareas || tareas.length === 0) return {porcentaje: 0, cumplidasATiempo: 0, total: 0, pendientes: 0, evaluadas: 0};
  // La ventana se mide en DÍAS, así que sus dos extremos son días. Antes el
  // límite llevaba la hora actual y la fecha de la tarea era medianoche UTC, y
  // la resta de esos dos desalineados dejaba fuera el día más antiguo de la
  // ventana: por la mañana entraban 90 días y por la tarde 89.
  //
  // `>= -diasAtras` incluye ese día. No se pone tope por arriba porque antes no
  // lo había: una tarea asignada a futuro sigue contando, como hasta ahora.
  const tareasPeriodo = tareas.filter(t => {
    const dias = diasHastaFecha((t as any).fechaAsignada, referencia);
    return dias !== null && dias >= -diasAtras;
  });
  if (tareasPeriodo.length === 0) return {porcentaje: 0, cumplidasATiempo: 0, total: 0, pendientes: 0, evaluadas: 0};
  let cumplidasATiempo = 0;
  let pendientes = 0;
  let evaluadas = 0;
  tareasPeriodo.forEach(t => {
    if (t.estado === "pendiente") pendientes++;
    else if (t.estado === "cumplida") { evaluadas++; cumplidasATiempo++; }
    else if (t.estado === "no_cumplida" || t.estado === "fuera_plazo") evaluadas++;
  });
  const porcentaje = evaluadas === 0 ? 0 : Math.round((cumplidasATiempo / evaluadas) * 100);
  return {porcentaje, cumplidasATiempo, total: tareasPeriodo.length, pendientes, evaluadas};
}

// Sin registro ≠ incumplido. El promedio se saca SOLO sobre los evaluables (los
// que ya tienen algo capturado); quien no tiene nada no arrastra el indicador a
// cero ni cuenta como "por debajo del 70%". `evaluados` permite decir arriba lo
// mismo que dicen las filas de la tabla.
function calcularComplianceGlobal(trabajadores: any[]): {porcentaje: number; enRiesgo: number; total: number; evaluados: number} {
  const activos = trabajadores.filter(t => t.status === "activo");
  if (activos.length === 0) return {porcentaje: 0, enRiesgo: 0, total: 0, evaluados: 0};
  const evaluables = activos.filter(tieneExpedienteCapturado);
  if (evaluables.length === 0) return {porcentaje: 0, enRiesgo: 0, total: activos.length, evaluados: 0};
  let suma = 0;
  let enRiesgo = 0;
  evaluables.forEach(t => {
    const calc = calcularCompliance(t.compliance);
    suma += calc.porcentaje;
    if (calc.porcentaje < 70) enRiesgo++;
  });
  return {porcentaje: Math.round(suma / evaluables.length), enRiesgo, total: activos.length, evaluados: evaluables.length};
}

function nivelCompliance(porcentaje: number): "ok" | "atencion" | "riesgo" {
  if (porcentaje >= 80) return "ok";
  if (porcentaje >= 50) return "atencion";
  return "riesgo";
}

function colorCompliance(nivel: "ok"|"atencion"|"riesgo"): {color: string; bg: string; border: string} {
  if (nivel === "ok") return {color: "#1D9E75", bg: "rgba(29,158,117,0.15)", border: "rgba(29,158,117,0.3)"};
  if (nivel === "atencion") return {color: "#EF9F27", bg: "rgba(239,159,39,0.15)", border: "rgba(239,159,39,0.3)"};
  return {color: "#E24B4A", bg: "rgba(226,75,74,0.15)", border: "rgba(226,75,74,0.3)"};
}

// ── FUENTE DE VERDAD del % de cumplimiento de ACTIVIDADES por empleado ──────────────
// confirmadas / total de la colección `tareas`, por trabajadorEmail (el filtro
// empleadorId == patrón ya viene aplicado por quien carga la colección). Es el
// MISMO dato que muestra la sección Actividades. Filtra en JS (sin índices compuestos).
function calcularCumplimientoTareas(tareasColeccion: any[], trabajadorEmail: string): {porcentaje: number; confirmadas: number; total: number} {
  const correo = (trabajadorEmail || "").toLowerCase().trim();
  const suyas = (tareasColeccion || []).filter((t: any) => (t.trabajadorEmail || "").toLowerCase() === correo);
  const total = suyas.length;
  const confirmadas = suyas.filter((t: any) => t.confirmadaPorPatron).length;
  return { porcentaje: total ? Math.round((confirmadas / total) * 100) : 0, confirmadas, total };
}

// ── Historial mensual de actividades (solo PRESENTACIÓN: filtra por mes al mostrar) ──
// Año-mes "YYYY-MM" de una actividad, derivado de fechaLimite ("YYYY-MM-DD") en JS.
// El cumplimiento mensual se mide por MES DE VENCIMIENTO: una actividad con límite el
// 2026-07-16 pertenece a julio, sin importar cuándo se creó. La fecha límite es
// obligatoria en TODAS las vías de alta (expediente y módulo central), así que esto
// resuelve siempre. Si aun así llegara una sin fecha, NO se cuenta para el
// cumplimiento: una instrucción sin término no puede computarse como incumplida.
// Antes caían al mes actual y arrastraban el porcentaje de todos los meses sucesivos.
function mesDeTarea(tar: any): string {
  const fl = (tar?.fechaLimite || "").slice(0, 7); // "YYYY-MM"
  return /^\d{4}-\d{2}$/.test(fl) ? fl : "";
}
// "YYYY-MM" del mes en curso (hoy).
function mesActualYM(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}`;
}
// Filtra una colección de actividades al año-mes "ym" (por fechaLimite). Las que no
// tengan fecha quedan FUERA de todo mes: no se miden. No borra ni mueve nada: filtra.
function tareasDelMes(tareas: any[], ym: string, _ymActual?: string): any[] {
  return (tareas || []).filter((t: any) => mesDeTarea(t) === ym);
}

// ¿ESTE EMPLEADO TIENE ALGO CAPTURADO? Una sola definición para los dos promedios.
// Estaban escritas por separado y por eso el equipo salía al 1% en un sitio y al
// 15% en otro: uno dividía entre todos los activos y el otro solo entre estos.
function tieneExpedienteCapturado(t: any): boolean {
  return !!(t && t.compliance && Object.keys(t.compliance).length > 0);
}

// UNA SOLA FÓRMULA PARA EL EXPEDIENTE, Y ES LA PONDERADA.
// Aquí había una segunda: contaba ítems planos —cada casilla vale uno— mientras la
// ficha contaba puntos, con los obligatorios pesando dos. El mismo empleado salía
// al 12% en su PDF y al 15% en su pantalla, y las dos cifras eran correctas dentro
// de su propia aritmética, que es lo que las hacía imposibles de conciliar a ojo.
//
// Sobrevive la ponderada, `calcularCompliance`, por dos razones: es la que ve el
// patrón cuando marca las casillas —la que puede comprobar— y es la única que
// distingue un acta de nacimiento de un certificado académico. Un promedio que las
// trata igual dice menos, no más.
function calcularMetricasEmpleado(t: any, mes: string, tareasColeccion?: any[]): {pctDocs: number; docs: ReturnType<typeof calcularCompliance>; pctTareas: number; pendientes: number; vencidas: number; tieneTareasEnMes: boolean} {
  const docs = calcularCompliance(t.compliance);
  const pctDocs = docs.porcentaje;

  // % de ACTIVIDADES: fuente única = colección `tareas` (igual que la sección Actividades).
  // Fallback al arreglo embebido sólo si no se pasa la colección.
  let pctTareas: number;
  let tieneTareasEnMes: boolean;
  if (tareasColeccion) {
    const ct = calcularCumplimientoTareas(tareasColeccion, t.email);
    pctTareas = ct.porcentaje;
    tieneTareasEnMes = ct.total > 0;
  } else {
    const todasTareasEmb = t.tareas || [];
    const tareasDelMesEmb = todasTareasEmb.filter((tar: any) => tar.fechaAsignada && tar.fechaAsignada.startsWith(mes));
    const cumplidasDelMesEmb = tareasDelMesEmb.filter((tar: any) => tar.estado === "cumplida").length;
    pctTareas = tareasDelMesEmb.length > 0 ? Math.round((cumplidasDelMesEmb / tareasDelMesEmb.length) * 100) : 0;
    tieneTareasEnMes = tareasDelMesEmb.length > 0;
  }

  const todasTareas = t.tareas || [];
  const hoy = new Date().toISOString().slice(0, 10);
  const pendientes = todasTareas.filter((tar: any) => tar.estado === "pendiente" && tar.fechaLimite >= hoy).length;
  const vencidas = todasTareas.filter((tar: any) => tar.estado === "pendiente" && tar.fechaLimite < hoy).length;

  return { pctDocs, docs, pctTareas, pendientes, vencidas, tieneTareasEnMes };
}

// EL PROMEDIO SE SACA SOBRE QUIEN TIENE ALGO CAPTURADO, y no sobre todos los
// activos. Es el criterio que ya usaba `calcularComplianceGlobal` para la tarjeta,
// y se extiende aquí; el que se va es el de dividir entre todos.
//
// La razón es la misma que hizo cambiar el nombre del indicador: meter un 0% por
// cada empleado que nadie ha empezado a capturar no mide nada, afirma algo. Doce
// empleados, uno con el expediente al 15% y once sin tocar, daban 1% —un número
// que suena a catástrofe y solo dice que hay trabajo sin empezar—.
//
// Y COMO NINGÚN PROMEDIO SE EXPLICA SOLO, se devuelve además sobre cuántos se
// calculó, para que el documento pueda decirlo en palabras al lado de la cifra.
function calcularKPIsGlobales(trabajadoresActivos: any[], mes: string, tareasColeccion?: any[]): {totalEmpleados: number; promDocs: number; promDocsSobre: number; promTareas: number; totalVencidas: number} {
  const totalEmpleados = trabajadoresActivos.length;
  if (totalEmpleados === 0) return {totalEmpleados: 0, promDocs: 0, promDocsSobre: 0, promTareas: 0, totalVencidas: 0};

  let sumDocs = 0;
  let conDocs = 0;
  let sumTareas = 0;
  let conTareas = 0;
  let totalVencidas = 0;

  for (const t of trabajadoresActivos) {
    const m = calcularMetricasEmpleado(t, mes, tareasColeccion);
    if (tieneExpedienteCapturado(t)) {
      sumDocs += m.pctDocs;
      conDocs++;
    }
    if (m.tieneTareasEnMes) {
      sumTareas += m.pctTareas;
      conTareas++;
    }
    totalVencidas += m.vencidas;
  }

  const promDocs = conDocs > 0 ? Math.round(sumDocs / conDocs) : 0;
  const promTareas = conTareas > 0 ? Math.round(sumTareas / conTareas) : 0;

  return {totalEmpleados, promDocs, promDocsSobre: conDocs, promTareas, totalVencidas};
}

// ─── MÓDULO EXPEDIENTE DE TRABAJADORES ───────────────────────────────────────
type Trabajador = {
  id?: string;
  nombre: string;
  puesto: string;
  departamento: string;
  tipoContrato: "indefinido"|"determinado"|"obra";
  salarioDiario: number;                 // base legal de prestaciones/IMSS (Art. 89 LFT)
  salarioMensual?: number;               // monto mensual capturado/derivado (nuevo modelo)
  salarioBase?: "mensual"|"diario";      // qué confirmó el humano = fuente de verdad
  fechaIngreso: string;
  fechaVencimiento?: string;
  telefono?: string;
  email?: string;
  imss?: string;
  curp?: string;
  rfc?: string;
  direccion?: string;
  status: "activo"|"baja";
  // Fecha de la ÚLTIMA salida (AAAA-MM-DD). Se escribía desde siempre, pero no
  // estaba declarada aquí ni se mostraba en ningún lado: el dato existía y era
  // invisible. Queda vacía al reingresar; el registro completo vive en
  // `periodosLaborales`, que sí conserva todas las salidas.
  fechaBaja?: string;
  // HISTORIAL DE LA RELACIÓN LABORAL. Un reingreso NO puede borrar la salida
  // anterior: si la relación fue continua o interrumpida determina la antigüedad,
  // y la antigüedad determina la prima de antigüedad y el cálculo de una
  // indemnización. Antes se sobrescribía `fechaBaja` con "" y el dato se perdía.
  // `fechaIngreso` NO se toca: sigue siendo la PRIMERA contratación, y todo lo
  // que hoy la lee se comporta igual. Las fichas anteriores a este campo se
  // derivan al vuelo (ver `periodosDe`), sin migración en la base.
  periodosLaborales?: { ingreso: string; baja?: string; razonBaja?: string; notasBaja?: string }[];
  notas?: string;
  contactoEmergenciaNombre?: string;
  contactoEmergenciaTel?: string;
  userId: string;
  // Vínculo con cuenta de trabajador (login propio) — ver CuentasTrabajadorPatron.
  // NO ES FUENTE DE VERDAD. `tieneAcceso` es una COPIA de un hecho que vive en la
  // colección `cuentas_trabajador`: solo la escriben las dos rutas que crean la
  // cuenta desde la app, así que falta en las cuentas creadas antes de que
  // existiera y en aquellas cuya escritura de la ficha falló sin decirlo. Nunca se
  // pone en false, ni siquiera al suspender el acceso, así que tampoco sirve para
  // saber si la cuenta sigue viva.
  //
  // Ninguna pantalla decide nada con ella. Para saber si alguien tiene cuenta se
  // busca su correo en `cuentas_trabajador` —eso hace la columna Acceso de la
  // lista, la pestaña Acceso de la ficha y `debiaChecarHoy`—. Sigue escribiéndose
  // para no romper las fichas que ya la traen; se retira en su propia rama.
  tieneAcceso?: boolean;
  cuentaUid?: string;
  datosCompletos?: boolean;
};

// ═══ EL MAPA DE UNA SEDE (11-oct-2026) ═══════════════════════════════════════
// Leaflet + OpenStreetMap. Leaflet se carga SOLO al abrir la pantalla de sedes
// (de cdnjs, como jsPDF), no en el paquete de la plataforma.
// POLÍTICA DE USO DE OPENSTREETMAP: la atribución "© OpenStreetMap contributors"
// SIEMPRE visible en el mapa; las teselas del servidor estándar, sin descargar por
// adelantado; la búsqueda de direcciones (Nominatim) SOLO al pulsar "Buscar" —nada
// de autocompletar al teclear—, con una petición por segundo como máximo, y su
// atribución. Si el mapa no carga (sin red), la ubicación se fija con "Usar mi
// ubicación actual" o con la búsqueda.
const LEAFLET_VERSION = "1.9.4";
const LEAFLET_BASE = `https://cdnjs.cloudflare.com/ajax/libs/leaflet/${LEAFLET_VERSION}/`;
const OSM_TESELAS = "https://tile.openstreetmap.org/{z}/{x}/{y}.png";
const OSM_ATRIBUCION = '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer">OpenStreetMap</a> contributors';
const NOMINATIM_BUSCAR = "https://nominatim.openstreetmap.org/search";
let _leafletPromesa: Promise<any>|null = null;
function cargarLeaflet(): Promise<any> {
  if ((window as any).L) return Promise.resolve((window as any).L);
  if (_leafletPromesa) return _leafletPromesa;
  _leafletPromesa = new Promise((listo, falla) => {
    try {
      const css = document.createElement("link"); css.rel = "stylesheet"; css.href = LEAFLET_BASE + "leaflet.min.css"; document.head.appendChild(css);
      const js = document.createElement("script"); js.src = LEAFLET_BASE + "leaflet.min.js"; js.async = true;
      js.onload = () => { const L = (window as any).L; if (L) { try { L.Icon.Default.imagePath = LEAFLET_BASE + "images/"; } catch (_e) {} listo(L); } else falla(new Error("Leaflet no cargó")); };
      js.onerror = () => { _leafletPromesa = null; falla(new Error("Leaflet no cargó")); };
      document.head.appendChild(js);
    } catch (e) { _leafletPromesa = null; falla(e); }
  });
  return _leafletPromesa;
}
// La búsqueda de una dirección, SOLO cuando se pide, y no más de una por segundo.
let _ultimaBusquedaNominatim = 0;
async function buscarDireccionOSM(q: string): Promise<{lat:number; lng:number; nombre:string}[]> {
  const espera = 1000 - (Date.now() - _ultimaBusquedaNominatim);
  if (espera > 0) await new Promise((r) => setTimeout(r, espera));
  _ultimaBusquedaNominatim = Date.now();
  const url = `${NOMINATIM_BUSCAR}?format=jsonv2&limit=5&countrycodes=mx&q=${encodeURIComponent(q)}`;
  const r = await fetch(url, { headers: { "Accept-Language": "es" } } as any);
  if (!r.ok) throw new Error("La búsqueda de direcciones no respondió.");
  const lista: any[] = await r.json();
  return (lista || []).map((x:any) => ({ lat: Number(x.lat), lng: Number(x.lon), nombre: String(x.display_name || "") }))
    .filter((x) => isFinite(x.lat) && isFinite(x.lng));
}
function MapaDeSede({lat, lng, radio, onMover}: {lat:number|null; lng:number|null; radio:number; onMover:(lat:number, lng:number)=>void}) {
  const caja = useRef<any>(null), mapaRef = useRef<any>(null), pinRef = useRef<any>(null), circuloRef = useRef<any>(null);
  const [estado, setEstado] = useState<"cargando"|"listo"|"sin_mapa">("cargando");
  const centro: [number, number] = lat != null && lng != null ? [lat, lng] : [21.8818, -102.2916];   // Aguascalientes, mientras no haya punto
  useEffect(() => {
    let vivo = true;
    cargarLeaflet().then((L:any) => {
      if (!vivo || !caja.current || mapaRef.current) return;
      const mapa = L.map(caja.current).setView(centro, lat != null ? 16 : 12);
      L.tileLayer(OSM_TESELAS, { maxZoom: 19, attribution: OSM_ATRIBUCION }).addTo(mapa);
      const pin = L.marker(centro, { draggable: true }).addTo(mapa);
      pin.on("dragend", () => { const p = pin.getLatLng(); onMover(p.lat, p.lng); });
      mapa.on("click", (ev:any) => { pin.setLatLng(ev.latlng); onMover(ev.latlng.lat, ev.latlng.lng); });
      circuloRef.current = L.circle(centro, { radius: radio, color: "#B8932A", weight: 1.5, fillOpacity: 0.12 }).addTo(mapa);
      mapaRef.current = mapa; pinRef.current = pin;
      setEstado("listo");
    }).catch(() => { if (vivo) setEstado("sin_mapa"); });
    return () => { vivo = false; try { if (mapaRef.current) mapaRef.current.remove(); } catch (_e) {} mapaRef.current = null; };
    /* eslint-disable-next-line */
  }, []);
  // Cuando la ubicación o el radio cambian por fuera (búsqueda, "mi ubicación", radio).
  useEffect(() => {
    if (!mapaRef.current || lat == null || lng == null) return;
    try { pinRef.current.setLatLng([lat, lng]); circuloRef.current.setLatLng([lat, lng]); mapaRef.current.panTo([lat, lng]); } catch (_e) {}
  }, [lat, lng]);
  useEffect(() => { try { if (circuloRef.current) circuloRef.current.setRadius(radio); } catch (_e) {} }, [radio]);
  return (
    <div>
      <div ref={caja} data-mapa-sede style={{height:260, borderRadius:10, border:`1px solid ${T_LIGHT.borderCard}`, background:"#EEF1F5", overflow:"hidden"}}/>
      {estado === "cargando" && <div style={{fontSize:11.5, color:T_LIGHT.textInkMut, marginTop:4}}>Cargando el mapa…</div>}
      {estado === "sin_mapa" && <div style={{fontSize:11.5, color:"#7A5F12", marginTop:4}}>No se pudo cargar el mapa. Fija la ubicación con «Usar mi ubicación actual» o buscando la dirección.</div>}
      {estado === "listo" && <div style={{fontSize:11, color:T_LIGHT.textInkMut, marginTop:4}}>Arrastra el pin o toca el mapa para mover la sede. El círculo es el radio.</div>}
    </div>
  );
}

// ═══ LAS SEDES DE LA EMPRESA (patrón, escritorio) ═════════════════════════════
// La principal es la ubicación de la empresa de siempre (con el nombre que el patrón
// le ponga; sin nombre no se le inventa uno): se edita aquí y es la de todo trabajador sin sede asignada. Las demás,
// del catálogo. Ninguna se borra: se desactiva, y no mientras alguien la tenga
// asignada (la pantalla lo impide). Radio: 100, 200, 300 o 500 m (la principal
// conserva el suyo mientras no se cambie).
function SedesEmpresa({currentUser, catalogos, trabajadores, fontSans, fontSerif, onCambio, onCerrar}: {
  currentUser:any; catalogos:any; trabajadores:any[]; fontSans:string; fontSerif:string; onCambio:()=>void; onCerrar:()=>void;
}) {
  const sedes:any[] = catalogos?.sedes || [];
  const [form, setForm] = useState<any|null>(null);   // {sedeId|null(nueva), principal, nombre, lat, lng, radioMetros, direccion}
  const [buscar, setBuscar] = useState(""); const [resultados, setResultados] = useState<any[]>([]); const [buscando, setBuscando] = useState(false);
  const [guardando, setGuardando] = useState(false); const [msg, setMsg] = useState<{ok:boolean; t:string}|null>(null);
  // Al abrir el formulario (con los datos de la sede ya puestos), la foto del panel es ESA:
  // abrir para ver y cerrar sin tocar nada no es trabajo que perder (retomarFotoDelPanel).
  const formRef = useRef<any>(null);
  const formAbierto = form ? (form.sedeId || "nueva") : "";
  useEffect(()=>{ if (formAbierto && formRef.current) retomarFotoDelPanel(formRef.current); }, [formAbierto]);
  const asignados = (id:string) => (trabajadores||[]).filter((t:any)=> (t.status||"activo") !== "baja" && String(t.sedeId || SEDE_PRINCIPAL) === id).length;
  const abrir = (s:any|null) => { setMsg(null); setResultados([]); setBuscar("");
    // La primera sede del catálogo pide antes nombrar la principal.
    if (!s && faltaNombrarLaPrincipal(sedes)) { setMsg({ok:false, t: TEXTO_NOMBRA_LA_PRINCIPAL}); return; }
    setForm(s ? {sedeId: s.sedeId, principal: !!s.principal, nombre: s.nombre, lat: s.lat, lng: s.lng, radioMetros: s.radioMetros, direccion: s.direccion || ""}
      : {sedeId: null, principal: false, nombre: "", lat: null, lng: null, radioMetros: 200, direccion: ""}); };
  const miUbicacion = () => {
    if (!navigator.geolocation) { setMsg({ok:false, t:"Este navegador no da la ubicación."}); return; }
    navigator.geolocation.getCurrentPosition((p)=> setForm((f:any)=> ({...f, lat: p.coords.latitude, lng: p.coords.longitude})),
      ()=> setMsg({ok:false, t:"No se pudo leer tu ubicación (¿diste permiso?)."}), {enableHighAccuracy:true, timeout:10000});
  };
  const hacerBusqueda = async () => {
    if (!buscar.trim() || buscando) return;
    setBuscando(true); setMsg(null);
    try { const r = await buscarDireccionOSM(buscar.trim()); setResultados(r); if (!r.length) setMsg({ok:false, t:"No se encontró esa dirección. Prueba con calle, número y municipio."}); }
    catch(e:any){ setMsg({ok:false, t:"La búsqueda de direcciones no respondió. Intenta otra vez o usa el mapa."}); }
    finally { setBuscando(false); }
  };
  const guardar = async () => {
    const f = form; if (!f || !currentUser?.uid) return;
    // La principal puede seguir sin nombre (sus checadas dicen "Dentro de la zona", como
    // siempre); una sede del catálogo, no: es la forma de distinguirla.
    if (!f.principal && String(f.nombre||"").trim().length < 2) { setMsg({ok:false, t:"Ponle un nombre a la sede."}); return; }
    if (!f.principal && !f.sedeId && faltaNombrarLaPrincipal(sedes)) { setMsg({ok:false, t: TEXTO_NOMBRA_LA_PRINCIPAL}); return; }
    // Con otras sedes registradas (activas o no), la principal no puede quedarse sin nombre.
    if (f.principal && !String(f.nombre||"").trim() && hayOtrasSedesRegistradas(sedes, catalogos?.docsSedes)) { setMsg({ok:false, t: TEXTO_PRINCIPAL_NECESITA_NOMBRE}); return; }
    if (f.lat == null || f.lng == null) { setMsg({ok:false, t:"Fija la ubicación en el mapa, con la búsqueda o con «Usar mi ubicación actual»."}); return; }
    setGuardando(true); setMsg(null);
    try {
      const nombre = String(f.nombre||"").trim(), radioMetros = Number(f.radioMetros);
      if (f.principal) {
        // La principal vive en la configuración de la empresa (lo de siempre).
        await setDoc(doc(db, COL_CONFIG_EMPRESA, currentUser.uid), { ubicacionTrabajo: { lat: f.lat, lng: f.lng, radioMetros }, nombreSedePrincipal: nombre, actualizadoEn: serverTimestamp() }, {merge:true});
      } else if (f.sedeId) {
        await updateDoc(doc(db, COL_CONFIG_EMPRESA, currentUser.uid, "sedes", f.sedeId), { nombre, lat: f.lat, lng: f.lng, radioMetros,
          ...(String(f.direccion||"").trim() ? {direccion: String(f.direccion).trim().slice(0, 300)} : {}), actualizadaEn: serverTimestamp(), actualizadaPor: currentUser.email });
      } else {
        await setDoc(doc(collection(db, COL_CONFIG_EMPRESA, currentUser.uid, "sedes")), { nombre, lat: f.lat, lng: f.lng, radioMetros, activa: true,
          ...(String(f.direccion||"").trim() ? {direccion: String(f.direccion).trim().slice(0, 300)} : {}), creadaEn: serverTimestamp(), creadaPor: currentUser.email });
      }
      setForm(null); setMsg({ok:true, t:"Sede guardada."}); onCambio();
    } catch(e:any){ console.error("guardar sede:", e); setMsg({ok:false, t: mensajeDeFallo(e, {accion:"guardar la sede", denegado: denegadoPatron("guardar sedes")})}); }
    finally { setGuardando(false); }
  };
  const alternarActiva = async (s:any) => {
    if (s.activa && asignados(s.sedeId) > 0) return;
    try { await updateDoc(doc(db, COL_CONFIG_EMPRESA, currentUser.uid, "sedes", s.sedeId), { activa: !s.activa, actualizadaEn: serverTimestamp(), actualizadaPor: currentUser.email }); onCambio(); }
    catch(e:any){ console.error("activar/desactivar sede:", e); setMsg({ok:false, t: mensajeDeFallo(e, {accion:"cambiar la sede", denegado: denegadoPatron("cambiar sedes")})}); }
  };
  const radios = form ? (RADIOS_SEDE.indexOf(Number(form.radioMetros)) >= 0 ? RADIOS_SEDE : [Number(form.radioMetros)].concat(RADIOS_SEDE)) : RADIOS_SEDE;
  const boton = (txt:string, fn:()=>void, primario?:boolean, off?:boolean) => (
    <button type="button" onClick={fn} disabled={off} style={{fontSize:12.5, fontWeight:primario?800:700, padding:"7px 13px", borderRadius:8, border: primario ? "none" : `1px solid ${T_LIGHT.borderCard}`,
      background: primario ? T_LIGHT.gold : "transparent", color: primario ? "#0B1829" : T_LIGHT.textInkSoft, cursor: off ? "wait" : "pointer", fontFamily:fontSans}}>{txt}</button>
  );
  return (
    <div style={{position:"fixed" as const, inset:0, background:"rgba(0,0,0,0.55)", zIndex:500, display:"flex", alignItems:"flex-start", justifyContent:"center", padding:"24px 16px", overflowY:"auto" as const}}>
      <div {...PANEL_DE_CAPTURA} data-pantalla-sedes onClick={e=>e.stopPropagation()} style={{background:"white", borderRadius:18, padding:"18px 20px 22px", maxWidth:640, width:"100%", boxShadow:"0 20px 60px rgba(0,0,0,0.3)", fontFamily:fontSans}}>
        <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:6}}>
          <div style={{fontFamily:fontSerif, fontSize:19, fontWeight:700, color:T_LIGHT.textInk}}>Sedes de tu empresa</div>
          <button onClick={(ev)=>{ if (sePuedeCerrarElPanel(ev)) onCerrar(); }} aria-label="Cerrar" style={{width:32, height:32, borderRadius:"50%", border:`1px solid ${T_LIGHT.borderCard}`, background:"transparent", color:T_LIGHT.textInkSoft, cursor:"pointer", fontSize:17, lineHeight:1}}>×</button>
        </div>
        <div style={{fontSize:12.5, color:T_LIGHT.textInkSoft, lineHeight:1.55, marginBottom:12}}>
          Cada trabajador checa contra SU sede. Quien no tiene una asignada usa la principal. Checar nunca se bloquea por estar fuera: solo se marca.
        </div>
        {!form && (<>
          {sedes.length === 0 && <div style={{fontSize:12.5, color:T_LIGHT.textInkMut, marginBottom:10}}>Todavía no hay ninguna ubicación de la empresa. Agrega la primera.</div>}
          {sedes.map((s:any)=> (
            <div key={s.sedeId} data-sede={s.sedeId} style={{border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:12, padding:"10px 12px", marginBottom:8, opacity: s.activa ? 1 : 0.6}}>
              <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", gap:10, flexWrap:"wrap" as const}}>
                <div>
                  <div style={{fontSize:14, fontWeight:700, color:T_LIGHT.textInk}}>{s.nombre || (s.principal ? ETIQUETA_PRINCIPAL_SIN_NOMBRE : "Sede sin nombre")}{s.principal && s.nombre ? " · principal" : ""}{!s.activa ? " · desactivada" : ""}</div>
                  <div style={{fontSize:11.5, color:T_LIGHT.textInkMut}}>Radio {s.radioMetros} m · {asignados(s.sedeId)} trabajador{asignados(s.sedeId)===1?"":"es"}{s.principal ? " (más quienes no tienen sede asignada)" : ""}</div>
                </div>
                <div style={{display:"flex", gap:6}}>
                  {boton("Editar", ()=>abrir(s))}
                  {!s.principal && boton(s.activa ? "Desactivar" : "Activar", ()=>alternarActiva(s), false, s.activa && asignados(s.sedeId) > 0)}
                </div>
              </div>
              {!s.principal && s.activa && asignados(s.sedeId) > 0 && (
                <div style={{fontSize:11, color:T_LIGHT.textInkMut, marginTop:4}}>No se puede desactivar mientras {asignados(s.sedeId) === 1 ? "un trabajador la tenga" : `${asignados(s.sedeId)} trabajadores la tengan`} asignada: cámbialos primero.</div>
              )}
            </div>
          ))}
          <div style={{marginTop:10}}>{boton("+ Agregar sede", ()=>abrir(null), true)}</div>
        </>)}
        {form && (
          <div {...ZONA_DE_CAPTURA}>
            <div ref={formRef}/>
            <label style={{fontSize:11.5, fontWeight:700, color:T_LIGHT.textInkSoft}}>Nombre de la sede</label>
            <input value={form.nombre} onChange={(e)=>setForm({...form, nombre: e.target.value})} maxLength={80} placeholder={AYUDA_NOMBRE_SEDE}
              style={{width:"100%", boxSizing:"border-box" as const, padding:"8px 10px", borderRadius:8, border:`1px solid ${T_LIGHT.borderCard}`, fontSize:13, fontFamily:fontSans, margin:"4px 0 10px"}}/>
            <label style={{fontSize:11.5, fontWeight:700, color:T_LIGHT.textInkSoft}}>Buscar por dirección</label>
            <div style={{display:"flex", gap:6, margin:"4px 0 6px"}}>
              <input {...CAMPO_DE_PARAMETRO} value={buscar} onChange={(e)=>setBuscar(e.target.value)} onKeyDown={(e)=>{ if (e.key === "Enter") hacerBusqueda(); }} placeholder="Calle, número, colonia, municipio"
                style={{flex:1, padding:"8px 10px", borderRadius:8, border:`1px solid ${T_LIGHT.borderCard}`, fontSize:13, fontFamily:fontSans}}/>
              {boton(buscando ? "Buscando…" : "Buscar", hacerBusqueda, false, buscando)}
            </div>
            {resultados.length > 0 && (
              <div style={{border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:8, marginBottom:6, maxHeight:140, overflowY:"auto" as const}}>
                {resultados.map((r:any, i:number)=> (
                  <button key={i} type="button" onClick={()=>{ setForm({...form, lat: r.lat, lng: r.lng, direccion: r.nombre.slice(0, 300)}); setResultados([]); }}
                    style={{display:"block", width:"100%", textAlign:"left" as const, padding:"7px 10px", border:"none", borderBottom:`1px solid ${T_LIGHT.border}`, background:"white", fontSize:12, color:T_LIGHT.textInk, cursor:"pointer", fontFamily:fontSans}}>{r.nombre}</button>
                ))}
              </div>
            )}
            <div style={{fontSize:10.5, color:T_LIGHT.textInkMut, marginBottom:8}}>Búsqueda: © OpenStreetMap (Nominatim)</div>
            <MapaDeSede lat={form.lat} lng={form.lng} radio={Number(form.radioMetros)} onMover={(la, ln)=> setForm((f:any)=> ({...f, lat: la, lng: ln}))}/>
            <div style={{display:"flex", alignItems:"center", gap:10, flexWrap:"wrap" as const, margin:"8px 0 10px"}}>
              {boton("Usar mi ubicación actual", miUbicacion)}
              <span style={{fontSize:11.5, color:T_LIGHT.textInkMut}}>{form.lat != null ? `${Number(form.lat).toFixed(5)}, ${Number(form.lng).toFixed(5)}` : "Sin ubicación todavía"}</span>
            </div>
            <label style={{fontSize:11.5, fontWeight:700, color:T_LIGHT.textInkSoft}}>Radio</label>
            <div style={{display:"flex", gap:6, flexWrap:"wrap" as const, margin:"4px 0 12px"}}>
              {radios.map((r:number)=> (
                <button key={r} type="button" onClick={()=>setForm({...form, radioMetros: r})}
                  style={{padding:"6px 12px", borderRadius:999, border:`1px solid ${Number(form.radioMetros)===r?T_LIGHT.gold:T_LIGHT.borderCard}`, background:Number(form.radioMetros)===r?"rgba(184,147,42,0.14)":"transparent",
                    color:Number(form.radioMetros)===r?T_LIGHT.gold:T_LIGHT.textInkSoft, cursor:"pointer", fontFamily:fontSans, fontSize:12, fontWeight:700}}>{r} m{RADIOS_SEDE.indexOf(r) < 0 ? " (actual)" : ""}</button>
              ))}
            </div>
            <div style={{display:"flex", gap:8}}>
              {boton(guardando ? "Guardando…" : "Guardar sede", guardar, true, guardando)}
              {boton("Cancelar", ()=>setForm(null))}
            </div>
          </div>
        )}
        {msg && <div style={{fontSize:12, color: msg.ok ? "#059669" : "#B91C1C", marginTop:8}}>{msg.t}</div>}
      </div>
    </div>
  );
}

// ═══ ASIGNAR UNA SEDE A VARIOS (Empleados) ═══════════════════════════════════
// Se eligen los trabajadores y la sede; a cada uno se le cambia a partir de hoy,
// con su entrada de historial (cambiarAsignacionDeFicha). Quien ya la tenía no
// cambia. Se avisa de las fichas sin vincular.
function AsignarSedeVarios({currentUser, catalogos, trabajadores, fontSans, fontSerif, onTerminar, onCerrar}: {
  currentUser:any; catalogos:any; trabajadores:any[]; fontSans:string; fontSerif:string; onTerminar:()=>void; onCerrar:()=>void;
}) {
  const sedes:any[] = (catalogos?.sedes || []).filter((s:any)=> s.activa);
  const activos = (trabajadores||[]).filter((t:any)=> (t.status||"activo") !== "baja");
  const [elegidos, setElegidos] = useState<Record<string, boolean>>({});
  const [sedeId, setSedeId] = useState(""); const [confirmando, setConfirmando] = useState(false);
  const [guardando, setGuardando] = useState(false); const [msg, setMsg] = useState<{ok:boolean; t:string}|null>(null);
  const ids = Object.keys(elegidos).filter((k)=> elegidos[k]);
  const sinVincularElegidos = activos.filter((t:any)=> elegidos[t.id] && fichaSinVincular(t));
  const nombreSede = (id:string)=> { const s = sedes.find((x:any)=> x.sedeId === id); return s ? etiquetaDeSede(s) : ""; };
  const asignar = async () => {
    setGuardando(true); setMsg(null);
    let cambiados = 0, iguales = 0; const fallos: string[] = [];
    for (const id of ids) {
      const t = activos.find((x:any)=> x.id === id);
      try { const c = await cambiarAsignacionDeFicha({fichaId: id, campo: "sedeId", campoHistorial: "historialSede", valor: sedeId, correo: currentUser?.email || ""}); if (c) cambiados++; else iguales++; }
      catch(e:any){ console.error("asignar sede:", e); fallos.push(t?.nombre || id); }
    }
    setGuardando(false); setConfirmando(false);
    setMsg({ok: fallos.length === 0, t: `${cambiados} cambiado${cambiados===1?"":"s"} a ${nombreSede(sedeId)} a partir de hoy`
      + (iguales ? ` · ${iguales} ya la tenía${iguales===1?"":"n"}` : "") + (fallos.length ? ` · no se pudo con: ${fallos.join(", ")}` : "") + "."});
    if (!fallos.length) setElegidos({});
  };
  return (
    <div style={{position:"fixed" as const, inset:0, background:"rgba(0,0,0,0.55)", zIndex:500, display:"flex", alignItems:"flex-start", justifyContent:"center", padding:"24px 16px", overflowY:"auto" as const}}>
      <div {...PANEL_DE_CAPTURA} data-asignar-sede onClick={e=>e.stopPropagation()} style={{background:"white", borderRadius:18, padding:"18px 20px 22px", maxWidth:560, width:"100%", boxShadow:"0 20px 60px rgba(0,0,0,0.3)", fontFamily:fontSans}}>
        <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:8}}>
          <div style={{fontFamily:fontSerif, fontSize:19, fontWeight:700, color:T_LIGHT.textInk}}>Asignar sede a varios</div>
          <button onClick={(ev)=>{ if (sePuedeCerrarElPanel(ev)) { if (msg && msg.ok) onTerminar(); else onCerrar(); } }} aria-label="Cerrar" style={{width:32, height:32, borderRadius:"50%", border:`1px solid ${T_LIGHT.borderCard}`, background:"transparent", color:T_LIGHT.textInkSoft, cursor:"pointer", fontSize:17, lineHeight:1}}>×</button>
        </div>
        {sedes.length < 2 ? (
          <div style={{fontSize:12.5, color:T_LIGHT.textInkSoft, lineHeight:1.55}}>Primero da de alta las sedes de tu empresa (botón «Sedes»). Mientras solo haya la principal, todos checan contra ella.</div>
        ) : (<>
          <select value={sedeId} onChange={(e)=>{ setSedeId(e.target.value); setConfirmando(false); }}
            style={{width:"100%", padding:"8px 10px", borderRadius:8, border:`1px solid ${T_LIGHT.borderCard}`, fontSize:13, fontFamily:fontSans, marginBottom:10}}>
            <option value="">Elige la sede…</option>
            {sedes.map((s:any)=> <option key={s.sedeId} value={s.sedeId}>{etiquetaDeSede(s)}{s.principal && s.nombre ? " (principal)" : ""}</option>)}
          </select>
          <div {...CAMPOS_DE_CAPTURA} style={{maxHeight:300, overflowY:"auto" as const, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:10, padding:"4px 0"}}>
            {activos.map((t:any)=> {
              const actual = sedeVigenteDe(t, catalogos?.sedes || []);
              return (
                <label key={t.id} style={{display:"flex", alignItems:"center", gap:10, padding:"6px 12px", fontSize:13, color:T_LIGHT.textInk, cursor:"pointer"}}>
                  <input type="checkbox" checked={!!elegidos[t.id]} onChange={(e)=>{ setElegidos({...elegidos, [t.id]: e.target.checked}); setConfirmando(false); }}/>
                  <span style={{flex:1}}>{t.nombre || t.email}</span>
                  <span style={{fontSize:11.5, color:T_LIGHT.textInkMut}}>{actual ? etiquetaDeSede(actual) : "—"}{fichaSinVincular(t) ? " · sin vincular" : ""}</span>
                </label>
              );
            })}
          </div>
          {sinVincularElegidos.length > 0 && (
            <div data-aviso-sin-vincular style={{marginTop:8, background:"rgba(184,147,42,0.10)", border:"1px solid rgba(184,147,42,0.35)", borderRadius:9, padding:"8px 10px", fontSize:12, color:"#7A5F12", lineHeight:1.5}}>
              {sinVincularElegidos.length === 1 ? TEXTO_FICHA_SIN_VINCULAR : `${sinVincularElegidos.length} de los elegidos no tienen su cuenta vinculada a su ficha. Su teléfono no podrá leer su sede ni su horario propio y medirá contra la sede principal.`}
              {" Vincúlalas desde la ficha de cada uno."}
            </div>
          )}
          {ids.length > 0 && sedeId && !confirmando && (
            <button type="button" onClick={()=>setConfirmando(true)} style={{marginTop:10, fontSize:12.5, fontWeight:800, padding:"8px 14px", borderRadius:8, border:"none", background:T_LIGHT.gold, color:"#0B1829", cursor:"pointer", fontFamily:fontSans}}>
              Asignar {nombreSede(sedeId)} a {ids.length} trabajador{ids.length===1?"":"es"}
            </button>
          )}
          {confirmando && (
            <div style={{marginTop:10, fontSize:12.5, color:T_LIGHT.textInkSoft, lineHeight:1.55}}>
              A partir de hoy, {ids.length === 1 ? "este trabajador checará" : `estos ${ids.length} trabajadores checarán`} contra <b>{nombreSede(sedeId)}</b>. Las checadas anteriores conservan la sede contra la que se midieron.
              <div style={{display:"flex", gap:8, marginTop:8}}>
                <button type="button" onClick={asignar} disabled={guardando} style={{fontSize:12.5, fontWeight:800, padding:"7px 14px", borderRadius:8, border:"none", background:T_LIGHT.gold, color:"#0B1829", cursor:guardando?"wait":"pointer", fontFamily:fontSans}}>{guardando ? "Asignando…" : "Sí, asignar a partir de hoy"}</button>
                <button type="button" onClick={()=>setConfirmando(false)} disabled={guardando} style={{fontSize:12.5, padding:"7px 14px", borderRadius:8, border:`1px solid ${T_LIGHT.borderCard}`, background:"transparent", color:T_LIGHT.textInkSoft, cursor:"pointer", fontFamily:fontSans}}>Volver</button>
              </div>
            </div>
          )}
        </>)}
        {msg && <div style={{fontSize:12, color: msg.ok ? "#059669" : "#B91C1C", marginTop:8}}>{msg.t}</div>}
      </div>
    </div>
  );
}

// ═══ LAS RAZONES SOCIALES DE LA EMPRESA (Datos de mi empresa) ═════════════════
// (11-oct-2026) Una cuenta, varias razones sociales (ISITECH tiene dos). La
// principal es la de este mismo formulario (Datos de mi empresa). Las demás, del
// catálogo: denominación, RFC, tipo de persona y domicilio fiscal. EL RFC Y EL TIPO
// DE PERSONA QUEDAN FIJOS al guardarla (las reglas lo exigen: un RFC distinto es
// otra empresa); si se capturó mal, se da de alta otra y se desactiva la
// equivocada. Ninguna se borra; no se desactiva mientras alguien la tenga.
const _RS_VACIA = {denominacion:"", rfc:"", tipoPersona:"", domCalle:"", domColonia:"", domMunicipio:"", domEstado:"", domCP:""};
function RazonesSocialesEmpresa({currentUser, fontSans}: {currentUser:any; fontSans:string}) {
  const [lista, setLista] = useState<any[]>([]);
  const [asignadas, setAsignadas] = useState<Record<string, number>>({});
  const [tick, setTick] = useState(0);
  const [form, setForm] = useState<any|null>(null);   // {id|null, ...campos}
  const [guardando, setGuardando] = useState(false); const [msg, setMsg] = useState<{ok:boolean; t:string}|null>(null);
  useEffect(()=>{ let vivo = true; if (!currentUser?.uid) return; (async ()=>{
    const c = await leerCatalogosDeEmpresa(currentUser.uid);
    if (!vivo) return;
    setLista(c.razones.filter((r:any)=> !r.principal));
    const cuenta: Record<string, number> = {};
    try { const s = await getDocs(query(collection(db, "trabajadores"), where("userId", "==", currentUser.uid)));
      s.docs.forEach((d:any)=>{ const x:any = d.data(); if ((x.status||"activo") !== "baja" && x.razonSocialId) cuenta[x.razonSocialId] = (cuenta[x.razonSocialId] || 0) + 1; }); }
    catch(e){ console.warn("razones sociales · asignadas:", e); }
    if (vivo) setAsignadas(cuenta);
  })(); return ()=>{ vivo = false; }; }, [currentUser?.uid, tick]);
  const inp:any = {width:"100%", boxSizing:"border-box" as const, padding:"8px 10px", borderRadius:8, border:`1px solid ${T_LIGHT.borderCard}`, fontSize:13, fontFamily:fontSans, marginTop:3};
  const guardar = async ()=>{
    const f = form; if (!f || !currentUser?.uid) return;
    const rfc = normalizarRfc(f.rfc);   // sin espacios y en mayúsculas (13-oct-2026)
    if (String(f.denominacion||"").trim().length < 2) { setMsg({ok:false, t:"Falta la denominación o razón social."}); return; }
    // La validación del RFC, la misma que Datos de mi empresa (errorDeRfc).
    if (!f.id) { const errRfc = errorDeRfc(rfc, f.tipoPersona); if (errRfc) { setMsg({ok:false, t: errRfc}); return; } }
    if (!f.id && f.tipoPersona !== "fisica" && f.tipoPersona !== "moral") { setMsg({ok:false, t:"Elige si es persona física o moral."}); return; }
    if (!["domCalle","domColonia","domMunicipio","domEstado"].every((k)=> String(f[k]||"").trim())) { setMsg({ok:false, t:"Completa el domicilio fiscal (calle, colonia, municipio y estado)."}); return; }
    setGuardando(true); setMsg(null);
    const comunes:any = {denominacion: String(f.denominacion).trim(), domCalle: String(f.domCalle).trim(), domColonia: String(f.domColonia).trim(),
      domMunicipio: String(f.domMunicipio).trim(), domEstado: String(f.domEstado).trim(), ...(String(f.domCP||"").trim() ? {domCP: String(f.domCP).trim().slice(0, 10)} : {})};
    try {
      if (f.id) await updateDoc(doc(db, COL_CONFIG_EMPRESA, currentUser.uid, "razones_sociales", f.id), {...comunes, actualizadaEn: serverTimestamp(), actualizadaPor: currentUser.email});
      else await setDoc(doc(collection(db, COL_CONFIG_EMPRESA, currentUser.uid, "razones_sociales")), {...comunes, rfc, tipoPersona: f.tipoPersona, activa: true, creadaEn: serverTimestamp(), creadaPor: currentUser.email});
      setForm(null); setMsg({ok:true, t:"Razón social guardada."}); setTick((n)=> n + 1);
    } catch(e:any){ console.error("guardar razón social:", e); setMsg({ok:false, t: mensajeDeFallo(e, {accion:"guardar la razón social", denegado: denegadoPatron("guardar razones sociales")})}); }
    finally { setGuardando(false); }
  };
  const alternar = async (r:any)=>{
    if (r.activa && (asignadas[r.id] || 0) > 0) return;
    try { await updateDoc(doc(db, COL_CONFIG_EMPRESA, currentUser.uid, "razones_sociales", r.id), {activa: !r.activa, actualizadaEn: serverTimestamp(), actualizadaPor: currentUser.email}); setTick((n)=> n + 1); }
    catch(e:any){ console.error("activar/desactivar razón social:", e); setMsg({ok:false, t: mensajeDeFallo(e, {accion:"cambiar la razón social", denegado: denegadoPatron("cambiar razones sociales")})}); }
  };
  const campo = (k:string, etiqueta:string, extra?:any) => (
    <div style={{marginBottom:8}}>
      <label style={{fontSize:11.5, fontWeight:700, color:T_LIGHT.textInkSoft}}>{etiqueta}</label>
      <input value={form[k] || ""} onChange={(e)=> setForm({...form, [k]: k === "rfc" ? e.target.value.toUpperCase() : e.target.value})} style={inp} {...(extra || {})}/>
    </div>
  );
  return (
    <div data-razones-sociales style={{marginTop:22, borderTop:`1px solid ${T_LIGHT.borderCard}`, paddingTop:16}}>
      <div style={{fontSize:15, fontWeight:700, color:T_LIGHT.textInk, marginBottom:4}}>Otras razones sociales de esta cuenta</div>
      <div style={{fontSize:12.5, color:T_LIGHT.textInkSoft, lineHeight:1.55, marginBottom:10}}>
        Si tu cuenta maneja más de una razón social, da de alta aquí las demás y asigna a cada trabajador la suya desde su ficha. La de arriba es la principal y la de quien no tenga otra asignada.
      </div>
      {lista.map((r:any)=> (
        <div key={r.id} data-razon={r.id} style={{border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:12, padding:"10px 12px", marginBottom:8, opacity: r.activa ? 1 : 0.6}}>
          <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", gap:10, flexWrap:"wrap" as const}}>
            <div>
              <div style={{fontSize:13.5, fontWeight:700, color:T_LIGHT.textInk}}>{r.denominacion}{!r.activa ? " · desactivada" : ""}</div>
              <div style={{fontSize:11.5, color:T_LIGHT.textInkMut}}>RFC {r.rfc} · {r.domicilio}</div>
            </div>
            <div style={{display:"flex", gap:6}}>
              <button type="button" onClick={()=>{ setMsg(null); setForm({id: r.id, ...r}); }} style={{fontSize:12, fontWeight:700, padding:"6px 12px", borderRadius:8, border:`1px solid ${T_LIGHT.borderCard}`, background:"transparent", color:T_LIGHT.textInkSoft, cursor:"pointer", fontFamily:fontSans}}>Editar</button>
              <button type="button" onClick={()=>alternar(r)} disabled={r.activa && (asignadas[r.id]||0) > 0} style={{fontSize:12, fontWeight:700, padding:"6px 12px", borderRadius:8, border:`1px solid ${T_LIGHT.borderCard}`, background:"transparent", color:T_LIGHT.textInkSoft, cursor:"pointer", fontFamily:fontSans}}>{r.activa ? "Desactivar" : "Activar"}</button>
            </div>
          </div>
          {r.activa && (asignadas[r.id]||0) > 0 && <div style={{fontSize:11, color:T_LIGHT.textInkMut, marginTop:4}}>No se puede desactivar mientras {asignadas[r.id] === 1 ? "un trabajador la tenga" : `${asignadas[r.id]} trabajadores la tengan`} asignada: cámbialos primero.</div>}
        </div>
      ))}
      {!form && <button type="button" onClick={()=>{ setMsg(null); setForm({id: null, ..._RS_VACIA}); }} style={{fontSize:12.5, fontWeight:800, padding:"7px 13px", borderRadius:8, border:"none", background:T_LIGHT.gold, color:"#0B1829", cursor:"pointer", fontFamily:fontSans}}>+ Agregar razón social</button>}
      {form && (
        <div {...ZONA_DE_CAPTURA} style={{border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:12, padding:"12px 14px", marginTop:6}}>
          {campo("denominacion", "Denominación o razón social")}
          {form.id ? (
            <div data-rfc-fijo style={{marginBottom:8, fontSize:12.5, color:T_LIGHT.textInk}}>
              <b>RFC:</b> {form.rfc} · <b>Persona:</b> {form.tipoPersona === "fisica" ? "física" : "moral"}
              <div style={{fontSize:11.5, color:T_LIGHT.textInkMut, marginTop:3, lineHeight:1.5}}>{TEXTO_RFC_FIJO}</div>
            </div>
          ) : (<>
            {campo("rfc", "RFC", {maxLength: 13})}
            <div data-rfc-fijo style={{fontSize:11.5, color:T_LIGHT.textInkMut, margin:"-4px 0 8px", lineHeight:1.5}}>{TEXTO_RFC_FIJO}</div>
            <div style={{marginBottom:8}}>
              <label style={{fontSize:11.5, fontWeight:700, color:T_LIGHT.textInkSoft}}>¿Persona física o moral?</label>
              <select value={form.tipoPersona} onChange={(e)=> setForm({...form, tipoPersona: e.target.value})} style={inp}>
                <option value="">Elige…</option><option value="moral">Persona moral</option><option value="fisica">Persona física</option>
              </select>
            </div>
          </>)}
          {campo("domCalle", "Calle y número")}{campo("domColonia", "Colonia")}{campo("domMunicipio", "Municipio o alcaldía")}{campo("domEstado", "Estado")}{campo("domCP", "Código postal", {maxLength: 10})}
          <div style={{display:"flex", gap:8, marginTop:4}}>
            <button type="button" onClick={guardar} disabled={guardando} style={{fontSize:12.5, fontWeight:800, padding:"7px 14px", borderRadius:8, border:"none", background:T_LIGHT.gold, color:"#0B1829", cursor:guardando?"wait":"pointer", fontFamily:fontSans}}>{guardando ? "Guardando…" : "Guardar razón social"}</button>
            <button type="button" onClick={()=>setForm(null)} style={{fontSize:12.5, padding:"7px 14px", borderRadius:8, border:`1px solid ${T_LIGHT.borderCard}`, background:"transparent", color:T_LIGHT.textInkSoft, cursor:"pointer", fontFamily:fontSans}}>Cancelar</button>
          </div>
        </div>
      )}
      {msg && <div style={{fontSize:12, color: msg.ok ? "#059669" : "#B91C1C", marginTop:8}}>{msg.t}</div>}
    </div>
  );
}

// ═══ LAS SEDES, SOLO PARA VER (portal móvil del patrón) ═══════════════════════
function SedesSoloLectura({uidPatron, C, fontSans}: {uidPatron:string; C:any; fontSans:string}) {
  const [sedes, setSedes] = useState<any[]|null>(null);
  useEffect(()=>{ let vivo = true; if (!uidPatron) return; leerCatalogosDeEmpresa(uidPatron).then((c)=>{ if (vivo) setSedes(c.sedes); }); return ()=>{ vivo = false; }; }, [uidPatron]);
  if (!sedes || !sedes.length) return null;
  return (
    <div data-sedes-solo-lectura style={{background:C.panel, border:`1px solid ${C.line}`, borderRadius:16, padding:"14px 16px", marginTop:12, fontFamily:fontSans}}>
      <div style={{fontSize:11, fontWeight:700, color:C.gold, textTransform:"uppercase" as const, letterSpacing:"0.5px", marginBottom:6}}>Sedes de tu empresa</div>
      {sedes.map((s:any)=> (
        <div key={s.sedeId} style={{fontSize:13, color:C.ink, padding:"4px 0", opacity: s.activa ? 1 : 0.6}}>
          {etiquetaDeSede(s)}{s.principal && s.nombre ? " · principal" : ""}{!s.activa ? " · desactivada" : ""} <span style={{color:C.inkMut, fontSize:11.5}}>· radio {s.radioMetros} m</span>
        </div>
      ))}
      <div style={{fontSize:11.5, color:C.inkMut, marginTop:6}}>Para dar de alta o editar sedes, entra a la plataforma desde una computadora.</div>
    </div>
  );
}

// ═══ LA SEDE DE TRABAJO Y LA RAZÓN SOCIAL DE UN TRABAJADOR, EN SU FICHA ═══════
// (11-oct-2026) Cada una con lo vigente, "Cambiar a partir de hoy" (con
// confirmación) y su historial, que solo crece. Sin sedes ni razones sociales en
// el catálogo, solo se ve la principal y no hay nada que cambiar: todo como hoy.
// Si la ficha no está vinculada a su cuenta, el teléfono no podrá leer nada de
// esto: se dice, con el acceso para vincularla.
function SedeYRazonDeLaFicha({ficha, catalogos, currentUser, cuentaParaVincular, cuentaEnOtraFicha, errorVincular, onVincular, vinculando, onCambio, fontSans}: {
  ficha:any; catalogos:any; currentUser:any; cuentaParaVincular:any; cuentaEnOtraFicha?:any; errorVincular?:string; onVincular:()=>void; vinculando:boolean; onCambio:()=>void; fontSans:string;
}) {
  const [abierto, setAbierto] = useState<""|"sede"|"razon">("");
  const [eleccion, setEleccion] = useState("");
  const [confirmando, setConfirmando] = useState(false);
  // La PRIMERA razón social: ¿desde cuándo aplica? Sin opción preseleccionada.
  const [desde, setDesde] = useState<""|"inicio"|"hoy">("");
  const [guardando, setGuardando] = useState(false);
  const [msg, setMsg] = useState<{ok:boolean; t:string}|null>(null);
  if (!ficha) return null;
  const primeraRazon = sinHistorialDeAsignacion(ficha.historialRazonSocial);
  const sedes:any[] = catalogos?.sedes || [], razones:any[] = catalogos?.razones || [];
  const sinVincular = fichaSinVincular(ficha);
  const sedeActual = sedeVigenteDe(ficha, sedes), razonActual = razonSocialVigenteDe(ficha, razones);
  const nombreSede = (id:string)=> { const s = sedes.find((x:any)=> x.sedeId === id); return s ? etiquetaDeSede(s) : id === SEDE_PRINCIPAL ? "Sede principal" : "Sede que ya no está en el catálogo"; };
  const nombreRazon = (id:string)=> { const r = razones.find((x:any)=> x.id === id); return r && r.denominacion ? r.denominacion : id === RAZON_PRINCIPAL ? "Razón social principal" : "Razón social que ya no está en el catálogo"; };
  const opciones = abierto === "sede"
    ? sedes.filter((s:any)=> s.activa).map((s:any)=> ({id: s.sedeId, txt: etiquetaDeSede(s) + (s.principal && s.nombre ? " (principal)" : "")}))
    : razones.filter((r:any)=> r.activa).map((r:any)=> ({id: r.id, txt: (r.denominacion || "Razón social principal") + (r.rfc ? " · " + r.rfc : "") + (r.principal ? " (principal)" : "")}));
  const abrir = (q:"sede"|"razon")=>{ setAbierto(q); setEleccion(""); setDesde(""); setConfirmando(false); setMsg(null); };
  const guardar = async ()=>{
    if (!ficha.id || !eleccion) return;
    const desdeElInicio = abierto === "razon" && primeraRazon && desde === "inicio";
    if (abierto === "razon" && primeraRazon && !desde) return;   // tiene que elegir desde cuándo
    setGuardando(true); setMsg(null);
    try {
      await cambiarAsignacionDeFicha({fichaId: ficha.id, campo: abierto === "sede" ? "sedeId" : "razonSocialId",
        campoHistorial: abierto === "sede" ? "historialSede" : "historialRazonSocial", valor: eleccion, correo: currentUser?.email || "",
        ...(desdeElInicio ? {efectoDesdeElInicio: true} : {})});
      setMsg({ok:true, t: abierto === "sede" ? "Sede cambiada a partir de hoy." : desdeElInicio ? "Razón social asignada desde el inicio de la relación laboral." : "Razón social cambiada a partir de hoy."});
      setAbierto(""); setConfirmando(false);
      onCambio();
    } catch(e:any){ console.error("cambiar sede / razón social:", e); setMsg({ok:false, t: mensajeDeFallo(e, {accion: abierto === "sede" ? "cambiar la sede" : "cambiar la razón social", denegado: denegadoPatron("cambiar la sede o la razón social de este trabajador")})}); }
    finally { setGuardando(false); }
  };
  const bloque = (q:"sede"|"razon", titulo:string, actual:string, campo:string, campoHistorial:string, nombre:(id:string)=>string, hayCatalogo:boolean) => {
    const es = entradasDeAsignacion(ficha[campoHistorial], campo);
    return (
      <div data-asignacion={q} style={{background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:12, padding:"12px 14px", marginBottom:10}}>
        <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", gap:10, flexWrap:"wrap" as const}}>
          <div>
            <div style={{fontSize:11, fontWeight:700, color:T_LIGHT.textInkMut, textTransform:"uppercase" as const, letterSpacing:"0.4px"}}>{titulo}</div>
            <div style={{fontSize:14, fontWeight:700, color:T_LIGHT.textInk, marginTop:2}}>{actual}</div>
          </div>
          {hayCatalogo && abierto !== q && (
            <button type="button" onClick={()=>abrir(q)} style={{fontSize:12, fontWeight:700, padding:"6px 12px", borderRadius:8, border:`1px solid ${T_LIGHT.gold}`, background:"transparent", color:T_LIGHT.gold, cursor:"pointer", fontFamily:fontSans}}>{q === "razon" && primeraRazon ? "Asignar razón social" : "Cambiar a partir de hoy"}</button>
          )}
        </div>
        {abierto === q && (
          <div {...ZONA_DE_CAPTURA} style={{marginTop:10}}>
            <select value={eleccion} onChange={(e)=>{ setEleccion(e.target.value); setConfirmando(false); }}
              style={{width:"100%", padding:"8px 10px", borderRadius:8, border:`1px solid ${T_LIGHT.borderCard}`, fontSize:13, fontFamily:fontSans}}>
              <option value="">Elige…</option>
              {opciones.filter((o:any)=> o.id !== String(ficha[campo] || SEDE_PRINCIPAL)).map((o:any)=> <option key={o.id} value={o.id}>{o.txt}</option>)}
            </select>
            {sinVincular && eleccion && (
              <div data-aviso-sin-vincular style={{marginTop:8, background:"rgba(184,147,42,0.10)", border:"1px solid rgba(184,147,42,0.35)", borderRadius:9, padding:"8px 10px", fontSize:12, color:"#7A5F12", lineHeight:1.5}}>
                {TEXTO_FICHA_SIN_VINCULAR}
                {cuentaEnOtraFicha && <> {textoCuentaEnOtraFicha(cuentaEnOtraFicha)}</>}
                {cuentaParaVincular && !cuentaEnOtraFicha && <button type="button" onClick={onVincular} disabled={vinculando} style={{marginLeft:6, fontSize:12, fontWeight:700, padding:"3px 9px", borderRadius:7, border:"1px solid rgba(184,147,42,0.5)", background:"white", color:"#7A5F12", cursor:"pointer"}}>{vinculando ? "Vinculando…" : "Vincular ficha y cuenta"}</button>}
              </div>
            )}
            {q === "razon" && primeraRazon && eleccion && (
              <div data-desde-cuando style={{marginTop:10, fontSize:12.5, color:T_LIGHT.textInk}}>
                <div style={{fontWeight:700, marginBottom:4}}>¿Desde cuándo aplica?</div>
                {([["inicio", OPCION_DESDE_EL_INICIO], ["hoy", OPCION_A_PARTIR_DE_HOY]] as [("inicio"|"hoy"), string][]).map(([v, txt])=> (
                  <label key={v} style={{display:"flex", alignItems:"flex-start", gap:6, margin:"4px 0", cursor:"pointer", lineHeight:1.45}}>
                    <input type="radio" name={"desde-" + (ficha.id || "")} value={v} checked={desde === v} onChange={()=>{ setDesde(v); setConfirmando(false); }} style={{marginTop:3}}/>
                    <span>{txt}</span>
                  </label>
                ))}
                <div data-eleccion-irreversible style={{marginTop:4, fontSize:11.5, color:T_LIGHT.textInkSoft}}>{TEXTO_ELECCION_IRREVERSIBLE}</div>
              </div>
            )}
            {eleccion && !confirmando && (q !== "razon" || !primeraRazon || desde) && (
              <div style={{display:"flex", gap:8, marginTop:8}}>
                <button type="button" onClick={()=>setConfirmando(true)} style={{fontSize:12.5, fontWeight:800, padding:"7px 14px", borderRadius:8, border:"none", background:T_LIGHT.gold, color:"#0B1829", cursor:"pointer", fontFamily:fontSans}}>Cambiar</button>
                <button type="button" onClick={()=>setAbierto("")} style={{fontSize:12.5, padding:"7px 14px", borderRadius:8, border:`1px solid ${T_LIGHT.borderCard}`, background:"transparent", color:T_LIGHT.textInkSoft, cursor:"pointer", fontFamily:fontSans}}>Cancelar</button>
              </div>
            )}
            {eleccion && confirmando && (
              <div style={{marginTop:8, fontSize:12.5, color:T_LIGHT.textInkSoft, lineHeight:1.55}}>
                {q === "sede"
                  ? <>A partir de hoy, {ficha.nombre || "este trabajador"} checará contra <b>{nombre(eleccion)}</b>. Las checadas anteriores conservan la sede contra la que se midieron.</>
                  : (primeraRazon && desde === "inicio")
                    ? <span data-confirma-desde-el-inicio>{textoConfirmaDesdeElInicio(ficha.nombre || "este trabajador", nombre(eleccion))}</span>
                    : <>A partir de hoy, los documentos de {ficha.nombre || "este trabajador"} saldrán a nombre de <b>{nombre(eleccion)}</b>.
                        <div data-texto-cambio-desde-hoy style={{marginTop:6, background:"rgba(184,147,42,0.10)", border:"1px solid rgba(184,147,42,0.35)", borderRadius:9, padding:"8px 10px", color:"#7A5F12"}}>{TEXTO_CAMBIO_DESDE_HOY}</div></>}
                <div style={{display:"flex", gap:8, marginTop:8}}>
                  <button type="button" onClick={guardar} disabled={guardando} style={{fontSize:12.5, fontWeight:800, padding:"7px 14px", borderRadius:8, border:"none", background:T_LIGHT.gold, color:"#0B1829", cursor:guardando?"wait":"pointer", fontFamily:fontSans}}>{guardando ? "Guardando…" : (q === "razon" && primeraRazon && desde === "inicio") ? "Sí, asignar desde el inicio" : "Sí, cambiar a partir de hoy"}</button>
                  <button type="button" onClick={()=>setConfirmando(false)} disabled={guardando} style={{fontSize:12.5, padding:"7px 14px", borderRadius:8, border:`1px solid ${T_LIGHT.borderCard}`, background:"transparent", color:T_LIGHT.textInkSoft, cursor:"pointer", fontFamily:fontSans}}>Volver</button>
                </div>
              </div>
            )}
          </div>
        )}
        {es.length > 0 && (
          <div data-historial-asignacion={q} style={{marginTop:10, borderTop:`1px solid ${T_LIGHT.border}`, paddingTop:8, fontSize:11.5, color:T_LIGHT.textInkSoft, lineHeight:1.6}}>
            <div style={{fontWeight:700, color:T_LIGHT.textInkMut, marginBottom:2}}>Historial</div>
            {!es[0].efectoDesdeElInicio && <div>Antes de {_cuandoEnMexico(es[0].desdeMs)}: {nombre(q === "sede" ? SEDE_PRINCIPAL : RAZON_PRINCIPAL)}</div>}
            {es.map((e:any)=> e.efectoDesdeElInicio
              ? <div key={e.clave} data-efecto-desde-el-inicio>{nombre(e.valor)} · Desde el inicio de la relación laboral · registrada el {e.pendiente ? "momento de guardar" : _cuandoEnMexico(e.desdeMs)} por {e.por || "—"}</div>
              : <div key={e.clave}>Desde el {e.pendiente ? "momento de guardar" : _cuandoEnMexico(e.desdeMs)}: {nombre(e.valor)}{e.por ? ` · por ${e.por}` : ""}</div>)}
          </div>
        )}
      </div>
    );
  };
  return (
    <div data-sede-y-razon style={{marginBottom:12}}>
      {sinVincular && (String(ficha.sedeId || SEDE_PRINCIPAL) !== SEDE_PRINCIPAL || String(ficha.razonSocialId || RAZON_PRINCIPAL) !== RAZON_PRINCIPAL) && (
        <div data-aviso-sin-vincular style={{marginBottom:10, background:"rgba(184,147,42,0.10)", border:"1px solid rgba(184,147,42,0.35)", borderRadius:10, padding:"10px 12px", fontSize:12, color:"#7A5F12", lineHeight:1.5}}>
          {TEXTO_FICHA_SIN_VINCULAR}
          {cuentaEnOtraFicha && <> {textoCuentaEnOtraFicha(cuentaEnOtraFicha)}</>}
          {cuentaParaVincular && !cuentaEnOtraFicha && <button type="button" onClick={onVincular} disabled={vinculando} style={{marginLeft:6, fontSize:12, fontWeight:700, padding:"4px 10px", borderRadius:7, border:"1px solid rgba(184,147,42,0.5)", background:"white", color:"#7A5F12", cursor:"pointer"}}>{vinculando ? "Vinculando…" : "Vincular ficha y cuenta"}</button>}
        </div>
      )}
      {bloque("sede", "Sede de trabajo", (sedeActual ? etiquetaDeSede(sedeActual) : "Sin ubicación de la empresa") + (sedeActual && !sedeActual.activa ? " (desactivada)" : ""), "sedeId", "historialSede", nombreSede, sedes.length > 1)}
      {bloque("razon", "Razón social", (razonActual && razonActual.denominacion ? razonActual.denominacion : "La de Datos de mi empresa") + (razonActual && razonActual.rfc ? " · " + razonActual.rfc : ""), "razonSocialId", "historialRazonSocial", nombreRazon, razones.length > 1)}
      {msg && <div style={{fontSize:12, color: msg.ok ? "#059669" : "#B91C1C", marginTop:4}}>{msg.t}</div>}
      {errorVincular && <div data-error-vincular style={{fontSize:12, color:"#B91C1C", marginTop:4}}>{errorVincular}</div>}
    </div>
  );
}

function ExpedienteInner({fontSans, fontSerif, gold, currentUser, onIrNomina, onVerTareas, onPlantilla, trabajadorInicialId, trabajadorInicialTab, focoEmails, onGoContratos}: {
  fontSans:string; fontSerif:string; gold:string; currentUser:any; onIrNomina:(t:any)=>void;
  onVerTareas?: (email:string)=>void;
  onPlantilla?: (n:number)=>void;   // avisa al módulo cuántos trabajadores hay ya cargados
  // Salto desde un aviso de contrato por vencer: abre SU expediente. Baja hasta
  // aquí porque la lista de trabajadores se carga en este componente, no en el
  // módulo: antes no hay a quién abrir.
  trabajadorInicialId?: string|null;
  // El apartado de la ficha en el que aterriza el salto.
  trabajadorInicialTab?: "datos"|"checador"|"documentos"|"contratos"|null;
  // Correos a los que se acota la lista al llegar desde el renglon del checador.
  focoEmails?: string[];
  onGoContratos: ()=>void;
}) {
  const isMobile = window.innerWidth < 768;
  // EL MEMBRETE DE LOS DOS PDF DE ESTE MÓDULO. La regla del archivo es que un
  // documento que el patrón emite lleva SU membrete y a AXIS solo en el pie; los
  // dos de aquí se habían quedado con el logo y la dirección del despacho.
  const dpEmp = useDatosPatron(currentUser?.uid).datos;
  // LOS CATÁLOGOS DE SEDES Y RAZONES SOCIALES (11-oct-2026): para la sede y la razón
  // social de la ficha, la asignación masiva y el membrete del reporte individual.
  const [catalogos, setCatalogos] = useState<{cfg:any; docsSedes:any[]; docsRazones:any[]; sedes:any[]; razones:any[]}>({cfg:null, docsSedes:[], docsRazones:[], sedes:[], razones:[]});
  const [tickCatalogos, setTickCatalogos] = useState(0);
  const [verSedes, setVerSedes] = useState(false);              // la pantalla de sedes (con mapa)
  const [verAsignarSede, setVerAsignarSede] = useState(false);  // asignar una sede a varios
  useEffect(()=>{ let vivo = true; if (!currentUser?.uid) return;
    leerCatalogosDeEmpresa(currentUser.uid).then((c)=>{ if (vivo) setCatalogos(c); });
    return ()=>{ vivo = false; }; }, [currentUser?.uid, tickCatalogos]);
  const [trabajadores, setTrabajadores] = useState<Trabajador[]>([]);
  const [cargando, setCargando] = useState(true);
  // Vínculo con la sección Actividades: cuentas del patrón + tareas (para % y "Ver actividades").
  // NULL mientras no se hayan leído. El aviso de "nadie tiene cuenta" y el
  // detector de la lista se callan hasta entonces.
  const [cuentasTrab, setCuentasTrab] = useState<any[]|null>(null);
  const [tareasTrab, setTareasTrab] = useState<any[]>([]);
  const [checadasTrab, setChecadasTrab] = useState<any[]>([]); // Checador (por trabajador)
  // Las correcciones del patrón y las notas "no conforme" (fase 2b), de todo su
  // equipo; la ficha arma con ellas la vista efectiva de cada persona.
  const [correccionesTrab, setCorreccionesTrab] = useState<any[]>([]);
  const [noConformesTrab, setNoConformesTrab] = useState<any[]>([]);
  const [vista, setVista] = useState<"lista"|"form"|"detalle"|"resumen">("lista");
  const [seleccionado, setSeleccionado] = useState<Trabajador|null>(null);
  // El horario recién guardado desde la ficha. `seleccionado` es una copia del
  // trabajador tomada al abrirlo, y no se entera de lo que guarda el editor: sin
  // esto, el aviso de "configura el horario" seguía apareciendo justo debajo del
  // mensaje de "horario guardado". Se limpia al cambiar de empleado.
  const [horarioFichaLocal, setHorarioFichaLocal] = useState<any>(null);
  // Y su historial recién escrito: sin él, los días de antes se leerían con el
  // horario nuevo hasta recargar.
  const [historialFichaLocal, setHistorialFichaLocal] = useState<any>(null);
  const [horarioGeneralEmpresa, setHorarioGeneralEmpresa] = useState<any>(null);
  const [historialGeneralEmpresa, setHistorialGeneralEmpresa] = useState<any>(null);
  // Las vacaciones registradas de la empresa (13-oct-2026), para el resumen de 14
  // días: un día de vacaciones no es "sin registro". null = no se pudieron leer.
  const [vacacionesEmpresa, setVacacionesEmpresa] = useState<any[]|null>(null);
  useEffect(()=>{ let cancel=false; (async()=>{
    if (!currentUser?.uid) return;
    try {
      const s = await getDocs(query(collection(db,"cumplimiento_obligaciones"), where("empleadorId","==",currentUser.uid)));
      if (!cancel) setVacacionesEmpresa(s.docs.map((d:any)=> ({id:d.id, ...(d.data() as any)})).filter((x:any)=> x.tipo === "vacaciones"));
    } catch(e){ console.warn("cumplimiento_obligaciones (resumen de la ficha):", e); }
  })(); return ()=>{cancel=true;}; }, [currentUser?.uid]);
  // "Ver todos" del resumen de asistencia de la ficha (se cierra al cambiar de empleado).
  const [verTodoResumen, setVerTodoResumen] = useState(false);
  useEffect(()=>{ setHorarioFichaLocal(null); setHistorialFichaLocal(null); setVerTodoResumen(false); }, [seleccionado?.id]);
  const [tickGeneral, setTickGeneral] = useState(0);
  useEffect(()=>{
    const alCambiar = () => setTickGeneral(x=>x+1);
    window.addEventListener(EVT_HORARIO_GENERAL_CAMBIO, alCambiar as any);
    return () => window.removeEventListener(EVT_HORARIO_GENERAL_CAMBIO, alCambiar as any);
  }, []);
  useEffect(()=>{ let cancel=false; (async()=>{
    if (!currentUser?.uid) return;
    try { const g = await leerHorarioGeneralConHistorial(currentUser.uid);
      if (!cancel) { setHorarioGeneralEmpresa(g.horario); setHistorialGeneralEmpresa(g.historial); }
    } catch(e){ /* el resumen degrada solo: sin general, no hereda días */ }
  })(); return ()=>{cancel=true;}; }, [currentUser?.uid, tickGeneral]);
  // Precedencia: lo recién guardado manda; si no, se RESUELVE —su horario propio
  // o el general— en vez de leer la copia. Aquí es donde la ficha decía "configura
  // el horario" justo debajo de un interruptor que decía "hereda el general".
  // La ficha con el horario propio que se acaba de guardar (si se guardó en esta
  // pantalla): la misma función, sobre la ficha al día. Lo que se ve aquí es lo
  // que imprimen la bitácora y el registro mensual.
  const fichaHorario:any = horarioFichaLocal !== null
    ? {...(seleccionado||{}), horarioPropio: horarioFichaLocal, ...(historialFichaLocal ? {historialHorarioPropio: historialFichaLocal} : {})}
    : seleccionado;
  const horarioVigenteFicha = horarioVigente(fichaHorario, horarioGeneralEmpresa);
  // EL HORARIO QUE REGÍA en un instante para esta persona, de los dos historiales:
  // con él se clasifican sus checadas y su resumen, como en los papeles.
  const horarioFichaEn = (t:Date|null)=> horarioQueRegia(fichaHorario, horarioGeneralEmpresa, historialGeneralEmpresa, t);
  const [vinculandoFicha, setVinculandoFicha] = useState(false);
  const [vincularError, setVincularError] = useState("");
  useEffect(()=>{ setVincularError(""); }, [seleccionado?.id]);
  const vincularFichaConCuenta = async (cta:any) => {
    if (!seleccionado?.id || !cta?.uid) return;
    setVinculandoFicha(true); setVincularError("");
    try {
      // UNA CUENTA, UNA FICHA: antes de escribir, se comprueba LEYENDO que ninguna otra
      // ficha del patrón la tenga (no basta la lista en pantalla).
      await comprobarCuentaSinOtraFicha(currentUser.uid, cta.uid, seleccionado.id);
      await updateDoc(doc(db,"trabajadores",seleccionado.id), { cuentaUid: cta.uid, tieneAcceso: true });
      setSeleccionado((prev:any)=> prev && prev.id===seleccionado.id ? {...prev, cuentaUid: cta.uid, tieneAcceso: true} : prev);
      await cargar();
    } catch(e:any){ console.error("vincular ficha y cuenta:", e); setVincularError(mensajeDeFallo(e, {accion:"vincular la ficha con su cuenta", denegado: denegadoPatron("modificar esta ficha")})); }
    finally { setVinculandoFicha(false); }
  };
  const _trabInicialUsado = useRef(false);
  const [busqueda, setBusqueda] = useState("");
  const [filtroStatus, setFiltroStatus] = useState<"todos"|"activo"|"baja">("activo");
  // CURP cuyo aviso de duplicado el usuario decidió ignorar. Guardamos el valor y
  // no un booleano: si corrige el dato, el aviso vuelve solo. Va aquí arriba,
  // con el resto de los hooks, para que su orden nunca dependa de una rama.
  const [dupPerdonado, setDupPerdonado] = useState("");
  const [filtroArea, setFiltroArea] = useState("");                               // "" = todas
  const [ordenCol, setOrdenCol] = useState<"nombre"|"antiguedad">("nombre");
  const [ordenDir, setOrdenDir] = useState<"asc"|"desc">("asc");
  // El material explicativo guía el día uno y estorba después: viene REPLEGADO en
  // cuanto hay plantilla y sólo se abre solo con la cuenta vacía. Una preferencia
  // explícita del usuario manda sobre las dos reglas y se recuerda por navegador.
  const [guiaAbierta, alternarGuia] = usarPlegable("axis_guia_empleados", !cargando && trabajadores.length===0);
  // Mismo criterio para el bloque de orientación que vive un nivel arriba.
  useEffect(()=>{ if(!cargando) onPlantilla?.(trabajadores.length); }, [cargando, trabajadores.length]); // eslint-disable-line
  const [tabActiva, setTabActiva] = useState<"datos"|"tareas"|"checador"|"acceso"|"cumplimiento"|"documentos"|"contratos"|"nomina">("datos");
  const [mesResumen, setMesResumen] = useState(()=>new Date().toISOString().slice(0,7));
  const [ordenamientoResumen, setOrdenamientoResumen] = useState<"docs"|"tareas"|"vencidas">("docs");
  const [generandoPDFResumen, setGenerandoPDFResumen] = useState(false);
  const [recibosEmpleado, setRecibosEmpleado] = useState<any[]>([]);
  const [mostrarModalReporte, setMostrarModalReporte] = useState(false);
  const [mesReporte, setMesReporte] = useState(()=>new Date().toISOString().slice(0,7));
  const [generandoPDF, setGenerandoPDF] = useState(false);
  // ── Pestaña "Actividades" del empleado (colección `tareas`, doble validación) ──
  const [tarTitulo, setTarTitulo] = useState("");
  const [tarDesc, setTarDesc] = useState("");
  const [tarFecha, setTarFecha] = useState("");
  const [tarHorario, setTarHorario] = useState("");
  const [guardandoTar, setGuardandoTar] = useState(false);
  const [feedbackTar, setFeedbackTar] = useState<any|null>(null);
  const [confirmandoTarId, setConfirmandoTarId] = useState<string|null>(null);
  // Historial mensual: mes seleccionado en la pestaña Actividades ("" = mes actual).
  const [mesTareasSel, setMesTareasSel] = useState("");
  // ── Edición de actividad (solo patrón): titulo/descripcion/fechaLimite/horario ──
  const [editTarea, setEditTarea] = useState<any|null>(null);
  const [editTarTitulo, setEditTarTitulo] = useState("");
  const [editTarDesc, setEditTarDesc] = useState("");
  const [editTarFecha, setEditTarFecha] = useState("");
  const [editTarHorario, setEditTarHorario] = useState("");
  const [editTarGuardando, setEditTarGuardando] = useState(false);
  const [editTarError, setEditTarError] = useState<string|null>(null);
  const [toglAcceso, setToglAcceso] = useState(false);
  // La cuenta que se va a suspender, mientras se pregunta (ConfirmarSuspension).
  const [porSuspender, setPorSuspender] = useState<any>(null);
  // ── Modal "Registrar trabajador" (alta con cuenta de acceso) ──
  const [mostrarRegistro, setMostrarRegistro] = useState(false);
  const [regNombre, setRegNombre] = useState("");
  const [regCorreo, setRegCorreo] = useState("");
  const [regGenerando, setRegGenerando] = useState(false);
  const [regFeedback, setRegFeedback] = useState<any|null>(null);
  // El alta que espera confirmación porque su correo no señala a ninguna ficha.
  const [altaSinFicha, setAltaSinFicha] = useState<{correo:string; nombre:string; parecidas:{ficha:any; porque:string}[]}|null>(null);
  // ── Alta unificada: casilla "crear cuenta de acceso" dentro del formulario ──
  const [crearAcceso, setCrearAcceso] = useState(false);
  const [altaAccesoResult, setAltaAccesoResult] = useState<{correo:string; tempPass:string}|null>(null);
  const [altaAccesoError, setAltaAccesoError] = useState<string|null>(null);
  const [mostrarComoFuncionaAcceso, setMostrarComoFuncionaAcceso] = useState(false);

  const formVacio: Omit<Trabajador,"id"|"userId"> = {
    nombre:"", puesto:"", departamento:"", tipoContrato:"indefinido",
    salarioDiario:0, salarioMensual:0, salarioBase:"mensual", fechaIngreso:"", fechaVencimiento:"",
    telefono:"", email:"", imss:"", curp:"", rfc:"", direccion:"", status:"activo", notas:"",
  };
  const [form, setForm] = useState<Omit<Trabajador,"id"|"userId">>(formVacio);
  const [guardando, setGuardando] = useState(false);
  const set = (k:string, v:any) => setForm(p=>({...p,[k]:v}));
  const [verImportar, setVerImportar] = useState(false);
  const [verImportarIA, setVerImportarIA] = useState(false);   // extracción con IA desde documento

  // Campos del importador = MISMOS que el alta manual. El importador es reutilizable
  // (mismo componente servirá luego a Actividades/Nómina cambiando esta definición + el guardado).
  // La plataforma guarda AMBOS: salarioMensual y salarioDiario + salarioBase (lo que el
  // humano confirmó). El otro se deriva UNA vez con el factor centralizado /30 (Art. 89
  // LFT, ver mensualADiario/diarioAMensual). El importador reutilizable servirá luego a
  // Actividades/Nómina cambiando esta definición + el guardado.
  const salarioDiarioDeFila = (v:Record<string,string>, opc:Record<string,string>):number => {
    const n = Number(v.salario);
    if (!Number.isFinite(n) || n<=0) return 0;
    return (opc?.periodoSalario === "diario") ? _round2(n) : _round2(mensualADiario(n));
  };
  const salarioMensualDeFila = (v:Record<string,string>, opc:Record<string,string>):number => {
    const n = Number(v.salario);
    if (!Number.isFinite(n) || n<=0) return 0;
    return (opc?.periodoSalario === "diario") ? _round2(diarioAMensual(n)) : _round2(n);
  };
  // Sugerencia por magnitud SIN auto-aplicar: si el monto no cuadra con la periodicidad
  // elegida, avisa en la celda; respeta lo que el humano deje (no bloquea).
  const validarSalarioLote = (v:Record<string,string>, opc:Record<string,string>) => {
    const n = Number(v.salario); const avisos:Record<string,string> = {};
    if (Number.isFinite(n) && n>0){
      if (opc?.periodoSalario==="diario" && n>5000) avisos.salario="¿Es mensual? El monto parece alto para un salario diario.";
      else if (opc?.periodoSalario==="mensual" && n<3000) avisos.salario="¿Es diario? El monto parece bajo para un salario mensual.";
    }
    return {avisos};
  };
  const camposImportEmpleado: CampoImport[] = [
    {key:"nombre", label:"Nombre completo", tipo:"text", requerido:true, alias:["nombre","trabajador","empleado"], ejemplo:"Juan Pérez López"},
    {key:"puesto", label:"Puesto / Cargo", tipo:"text", alias:["puesto","cargo"], ejemplo:"Auxiliar contable"},
    {key:"departamento", label:"Departamento", tipo:"text", alias:["departamento","area","área"], ejemplo:"Administración"},
    {key:"fechaIngreso", label:"Fecha de ingreso", tipo:"date", requerido:true, alias:["fecha de ingreso","ingreso","alta","fecha ingreso"], ejemplo:"2024-03-15"},
    {key:"salario", label:"Salario", tipo:"number", requerido:true, alias:["salario","sueldo","salario mensual","sueldo mensual","salario diario","mensual","salario al mes"], ejemplo:"18500"},
    {key:"tipoContrato", label:"Tipo de contrato", tipo:"select", opciones:[{value:"indefinido",label:"Indefinido"},{value:"determinado",label:"Determinado"},{value:"obra",label:"Obra"}], alias:["tipo de contrato","contrato","tipocontrato"], ejemplo:"indefinido"},
    {key:"telefono", label:"Teléfono", tipo:"text", alias:["telefono","teléfono","tel","celular"], ejemplo:"4491234567"},
    {key:"email", label:"Correo", tipo:"text", alias:["correo","email","correo electronico","e-mail"], validarFormato:(v)=> _reMail.test(v)?null:"Correo con formato dudoso", ejemplo:"juan@correo.com"},
    {key:"rfc", label:"RFC", tipo:"text", alias:["rfc"], validarFormato:(v)=> _reRFC.test(v)?null:"RFC con formato inválido", ejemplo:"PELJ900101AB1"},
    {key:"curp", label:"CURP", tipo:"text", alias:["curp"], validarFormato:(v)=> _reCURP.test(v)?null:"CURP con formato inválido", ejemplo:"PELJ900101HDFRZN01"},
    {key:"imss", label:"NSS (IMSS)", tipo:"text", alias:["nss","imss","numero imss","número imss","seguro social"], ejemplo:"12345678901"},
  ];
  // Opción global: ¿el salario del archivo es mensual o diario? (default mensual).
  const opcSalario = [{key:"periodoSalario", label:"El salario del archivo es:", opciones:[{value:"mensual",label:"Mensual (se divide ÷ 30 · Art. 89 LFT)"},{value:"diario",label:"Diario (× 30 para el mensual)"}], default:"mensual"}];
  // Columna calculada: muestra AMBOS derivados (mensual · diario) para que el humano vea
  // los dos antes de guardar. El resaltado en negrita es el que capturó (según la opción).
  const colSalarioDiario = {label:"Se guardará (mensual · diario)", calc:(v:Record<string,string>, opc:Record<string,string>)=>{
    const d = salarioDiarioDeFila(v, opc), m = salarioMensualDeFila(v, opc);
    return d>0 ? `${fmtMXN2(m)} mes · ${fmtMXN2(d)} día` : "—";
  }};
  // Guarda una fila IGUAL que el alta manual (misma colección, campos, empleadorId).
  // Persiste AMBOS montos + salarioBase (lo que confirmó el humano); el otro derivado /30.
  const guardarEmpleadoImportado = async (v:Record<string,string>, opc:Record<string,string>) => {
    const data:any = {
      nombre:(v.nombre||"").trim(), puesto:(v.puesto||"").trim(), departamento:(v.departamento||"").trim(),
      tipoContrato: v.tipoContrato||"indefinido",
      salarioDiario: salarioDiarioDeFila(v, opc),
      salarioMensual: salarioMensualDeFila(v, opc),
      salarioBase: (opc?.periodoSalario==="diario") ? "diario" : "mensual",
      fechaIngreso: v.fechaIngreso||"", fechaVencimiento:"",
      telefono:(v.telefono||"").trim(), email:(v.email||"").toLowerCase().trim(),
      imss:(v.imss||"").trim(), curp:(v.curp||"").toUpperCase().trim(), rfc:(v.rfc||"").toUpperCase().trim(),
      status:"activo", notas:"", userId: currentUser.uid, datosCompletos:true, timestamp: Timestamp.now(),
    };
    await addDoc(collection(db,"trabajadores"), data);
  };
  // Firma de identidad para duplicados: RFC, correo y (nombre + fecha de ingreso).
  // Funciona tanto para filas del archivo como para los empleados ya existentes,
  // así detecta aunque el archivo NO traiga RFC/correo. _norm ignora acentos/mayúsculas.
  const firmaEmpleado = (o:any):string[] => {
    const s:string[] = [];
    // El CURP es el identificador más fuerte que existe aquí: único por persona
    // e inmutable. Es aditivo —una oportunidad más de coincidir— y no puede
    // producir un falso positivo: dos CURP iguales son la misma persona.
    const curp=_norm(o.curp); if(curp) s.push("curp:"+curp);
    const rfc=_norm(o.rfc); if(rfc) s.push("rfc:"+rfc);
    const mail=_norm(o.email); if(mail) s.push("mail:"+mail);
    const nom=_norm(o.nombre), fi=_norm(o.fechaIngreso);
    // `nom:` SIEMPRE, además de `nomfi:`. Si no, la misma persona genera firmas
    // distintas según su archivo traiga o no la fecha de ingreso, y no coinciden
    // nunca. El precio aceptado es que dos homónimos se avisen entre sí: el
    // aviso no bloquea y ahora dice explícitamente que verifiques.
    if(nom) s.push("nom:"+nom);
    if(nom && fi) s.push("nomfi:"+nom+"|"+fi);
    return s;
  };

  useEffect(() => { cargar(); }, []);

  const cargar = async () => {
    setCargando(true);
    try {
      const q = query(
        collection(db,"trabajadores"),
        where("userId","==",currentUser.uid)
      );
      const snap = await getDocs(q);
      const docs = snap.docs.map(d=>({id:d.id,...d.data()} as Trabajador));
      docs.sort((a,b)=>new Date(b.fechaIngreso).getTime()-new Date(a.fechaIngreso).getTime());
      setTrabajadores(docs);
      // Salto desde un aviso o desde una fila del feed: abre SU expediente, en el
      // apartado donde está el hecho que se pulsó. Si el id ya no corresponde a
      // ningún expediente —lo borraron entre que se pintó la fila y se pulsó— no
      // se abre nada y la lista se ve como siempre: no se inventa un destino.
      if (trabajadorInicialId && !_trabInicialUsado.current) {
        _trabInicialUsado.current = true;
        const t0 = docs.find((x:any)=> x.id === trabajadorInicialId);
        if (t0) { setSeleccionado(t0); setVista("detalle"); setTabActiva(trabajadorInicialTab || "datos"); }
      }
      const qr = query(collection(db,"recibos_nomina"), where("userId","==",currentUser.uid));
      const sr = await getDocs(qr);
      const recibos = sr.docs.map(d=>({id:d.id, ...d.data()}));
      setRecibosEmpleado(recibos);
      await recargarVinculo();
    } catch(e){ console.error(e); }
    setCargando(false);
  };

  // Recarga cuentas_trabajador + tareas + checadas del patrón (un where c/u, filtra en
  // JS). Reusado tras asignar/confirmar actividad, alta o cambio de acceso.
  const recargarVinculo = async () => {
    if (!currentUser?.uid) return;
    try {
      const [sc, st, sch] = await Promise.all([
        getDocs(query(collection(db,"cuentas_trabajador"), where("empleadorId","==",currentUser.uid))),
        getDocs(query(collection(db,"tareas"), where("empleadorId","==",currentUser.uid))),
        getDocs(query(collection(db,"checadas"), where("empleadorId","==",currentUser.uid))),
      ]);
      setCuentasTrab(sc.docs.map(d=>({id:d.id,...d.data()})));
      setTareasTrab(st.docs.map(d=>({id:d.id,...d.data()})));
      setChecadasTrab(sch.docs.map(d=>({id:d.id,...d.data()})));
    } catch(eVt){ console.warn("Vínculo Empleados↔Actividades/Checador:", eVt); }
    await recargarCorrecciones();
  };
  const recargarCorrecciones = async () => {
    if (!currentUser?.uid) return;
    try {
      const [sco, sno] = await Promise.all([
        getDocs(query(collection(db,"correcciones_checadas"), where("empleadorId","==",currentUser.uid))),
        getDocs(query(collection(db,"no_conformidades"), where("empleadorId","==",currentUser.uid))),
      ]);
      setCorreccionesTrab(sco.docs.map(d=>({id:d.id,...d.data()})));
      setNoConformesTrab(sno.docs.map(d=>({id:d.id,...d.data()})));
    } catch(eCo){ console.warn("correcciones del checador:", eCo); }
  };

  // Asignar actividad a UN empleado (misma colección/campos que la sección Actividades).
  const asignarTareaEmpleado = async (emailEmp:string, nombreEmp:string) => {
    const tit = tarTitulo.trim();
    const correo = (emailEmp||"").toLowerCase().trim();
    if (!tit || !correo || !currentUser?.uid) { setFeedbackTar({tipo:"err", msg:"Falta el título."}); return; }
    if (!tarFecha) { setFeedbackTar({tipo:"err", msg:"La fecha límite es obligatoria (define el mes de cumplimiento)."}); return; }
    setGuardandoTar(true); setFeedbackTar(null);
    try {
      await addDoc(collection(db,"tareas"), {
        empleadorId: currentUser.uid,
        trabajadorEmail: correo,
        trabajadorNombre: nombreEmp || correo,
        titulo: tit,
        descripcion: tarDesc.trim(),
        fechaLimite: tarFecha || "",
        horario: tarHorario.trim() || "",
        marcadaPorTrabajador: false,
        confirmadaPorPatron: false,
        creadoEn: serverTimestamp(),
      });
      setTarTitulo(""); setTarDesc(""); setTarFecha(""); setTarHorario("");
      setFeedbackTar({tipo:"ok", msg:"Actividad asignada."});
      await recargarVinculo();
    } catch(e:any){ console.error("asignar actividad:", e); setFeedbackTar({tipo:"err", msg: mensajeDeFallo(e, {accion:"guardar la actividad", denegado: denegadoPatron("asignarle actividades a este empleado")})}); }
    finally { setGuardandoTar(false); }
  };

  // Editar una actividad ya creada (solo patrón). Actualiza texto/fecha/horario y fija
  // fechaModificacion. NO toca marcadaPorTrabajador ni confirmadaPorPatron (esos
  // siguen su flujo de doble validación, independiente de esta edición).
  const editarTareaEmpleado = async () => {
    if (!editTarea?.id || !editTarTitulo.trim()) return;
    if (!editTarFecha) { setEditTarError("La fecha límite es obligatoria (define el mes de cumplimiento)."); return; }
    setEditTarGuardando(true); setEditTarError(null);
    try {
      await updateDoc(doc(db,"tareas",editTarea.id), {
        titulo: editTarTitulo.trim(),
        descripcion: editTarDesc.trim(),
        fechaLimite: editTarFecha || "",
        horario: editTarHorario.trim() || "",
        fechaModificacion: serverTimestamp(),
      });
      setEditTarea(null);
      await recargarVinculo();
    } catch(e:any){ console.error("editar actividad:", e); setEditTarError(mensajeDeFallo(e, {accion:"guardar los cambios de la actividad", denegado: denegadoPatron("modificar esta actividad")})); }
    finally { setEditTarGuardando(false); }
  };

  const confirmarTareaEmpleado = async (tareaId:string) => {
    setConfirmandoTarId(tareaId);
    try {
      await updateDoc(doc(db,"tareas",tareaId), { confirmadaPorPatron:true, fechaConfirmada:serverTimestamp() });
      await recargarVinculo();
    } catch(e){ console.error(e); alert("No se pudo confirmar la actividad."); }
    finally { setConfirmandoTarId(null); }
  };

  // RESTABLECER BIOMETRÍA. Escribe en la cuenta del trabajador cuándo y quién; su
  // teléfono compara esa fecha con la de su llave y, si la llave es más vieja, la
  // olvida y registra otra en la siguiente checada (con el bloqueo del propio
  // teléfono). Aquí no se borra nada del teléfono ni se toca ninguna checada.
  // `empleadorEmail` va en la escritura porque la regla exige que la cuenta siga
  // diciendo que el patrón es él; en las cuentas antiguas ese campo no existía.
  const [restableciendoBio, setRestableciendoBio] = useState(false);
  const restablecerBiometria = async (cuenta:any) => {
    if (!cuenta?.id || !currentUser?.uid) return;
    if (!window.confirm("¿Restablecer la verificación en el aparato de " + (cuenta.nombre || cuenta.email) + "?\n\n"
      + "En su siguiente checada, el teléfono le pedirá activarla de nuevo. Úsalo si el trabajador cambió de teléfono o su teléfono ya no lo reconoce.")) return;
    setRestableciendoBio(true);
    try {
      await updateDoc(doc(db,"cuentas_trabajador",cuenta.id), {
        bioRestablecidaEn: serverTimestamp(),
        bioRestablecidaPor: (currentUser.email || "").toLowerCase(),
        empleadorEmail: (currentUser.email || "").toLowerCase(),
      });
      await recargarVinculo();
    } catch(e){ console.error(e); alert("No se pudo restablecer la verificación. Intenta de nuevo."); }
    finally { setRestableciendoBio(false); }
  };

  const toggleAccesoEmpleado = async (cuenta:any) => {
    if (!cuenta?.id) return;
    setToglAcceso(true);
    try {
      // EL VALOR EXPLÍCITO: `!cuenta.activo` en una cuenta sin el campo era true y
      // el primer clic no desactivaba (ver activoAlAlternar).
      await updateDoc(doc(db,"cuentas_trabajador",cuenta.id), { activo: activoAlAlternar(cuenta) });
      await recargarVinculo();
    } catch(e){ console.error(e); alert("No se pudo actualizar el acceso."); }
    finally { setToglAcceso(false); }
  };

  // Alta de trabajador CON cuenta de acceso (instancia secundaria + cuenta + ficha).
  // Mismo flujo que vivía en "Cuentas de trabajador".
  // ── Fuente única de creación de cuenta de acceso ──────────────────────────────
  // Crea la cuenta en una instancia SECUNDARIA de Firebase (no cierra la sesión del
  // patrón), escribe el documento en cuentas_trabajador y devuelve la contraseña
  // temporal + el uid del trabajador. Reusada por el modal "Crear acceso" y por la
  // casilla de acceso del formulario de alta. Propaga el error de Auth tal cual.
  // EL CORREO SE NORMALIZA AQUI, donde se escribe, y no solo en cada pantalla
  // que llama. El id de este documento es la ruta por la que la puerta y las
  // reglas buscan la cuenta: con una mayuscula, ese trabajador es invisible para
  // ambas y se queda sin vehiculos, sin bitacora y sin avisos, sin un solo error
  // a la vista. Los dos llamadores de hoy ya lo hacen; esto impide que un tercero
  // futuro se olvide.
  const crearCuentaAccesoCore = async (mailCrudo: string, nom: string): Promise<{tempPass:string; workerUid:string}> => {
    const mail = String(mailCrudo||"").toLowerCase().trim();
    const chars = "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789";
    const len = 10 + Math.floor(Math.random()*3);
    let tempPass = "";
    for (let i=0;i<len;i++) tempPass += chars[Math.floor(Math.random()*chars.length)];
    const secondaryApp = getApps().find(a => a.name === "Secondary") || initializeApp(firebaseConfig, "Secondary");
    const secondaryAuth = getAuth(secondaryApp);
    const cred = await createUserWithEmailAndPassword(secondaryAuth, mail, tempPass);
    const workerUid = cred.user.uid;
    await signOut(secondaryAuth);
    // Hereda el WhatsApp del patrón (si ya lo configuró) para que el trabajador nuevo
    // pueda contactarlo desde Flotilla. Best-effort: si falla la lectura, no bloquea el alta.
    let waHeredado = "";
    try { const uSnap = await getDoc(doc(db,"usuarios",currentUser.uid)); waHeredado = ((uSnap.exists() ? (uSnap.data() as any)?.whatsapp : "") || "").trim(); } catch(e){}
    await setDoc(doc(db, "cuentas_trabajador", mail), {
      email: mail, nombre: nom, empleadorId: currentUser.uid,
      empleadorEmail: (currentUser.email||"").toLowerCase(),
      ...(waHeredado ? { empleadorWhatsapp: waHeredado } : {}),
      uid: workerUid, activo: true, creadoPor: currentUser.uid, creadoEn: serverTimestamp(),
    });
    return { tempPass, workerUid };
  };

  // Traduce el código de error de Auth a un mensaje en español.
  const mensajeErrorAcceso = (e:any): string =>
    e?.code === "auth/email-already-in-use" ? MSG_CORREO_CON_CUENTA_PROPIA
    : e?.code === "auth/invalid-email" ? "El correo no tiene un formato válido."
    : e?.code === "auth/weak-password" ? "La contraseña generada no fue aceptada; intenta de nuevo."
    : ("No se pudo crear la cuenta: " + (e?.code || e?.message || "error"));

  // PRIMERO SE MIRA A QUIÉN PERTENECE EL CORREO, y solo después se crea la cuenta.
  // Si no pertenece a nadie, esto NO crea nada: levanta el aviso y espera. La
  // cuenta de Auth no se puede borrar desde la app, así que crear primero y
  // preguntar después dejaría una cuenta huérfana cada vez que alguien se
  // arrepiente al ver el aviso.
  const registrarTrabajador = async () => {
    const mail = regCorreo.trim().toLowerCase();
    const nom = regNombre.trim();
    if (!mail || !nom || !currentUser?.uid) return;
    setRegGenerando(true); setRegFeedback(null);
    let fichas: any[] = [];
    try {
      const snapT = await getDocs(query(collection(db,"trabajadores"), where("userId","==",currentUser.uid)));
      fichas = snapT.docs.map(d=>({id:d.id, ...(d.data() as any)}));
    } catch(eT){
      // SIN PODER LEER LAS FICHAS NO SE CREA LA CUENTA. Seguir a ciegas es
      // exactamente lo que dejaba cuentas sueltas de nadie.
      console.warn("fichas para el cotejo del correo:", eT);
      setRegGenerando(false);
      setRegFeedback({tipo:"err", msg:"No se pudieron leer tus fichas de empleados, así que no se puede saber de quién es este correo. No se creó ninguna cuenta; intenta de nuevo."});
      return;
    }
    const existente = fichaDelCorreo(fichas, mail);
    if (!existente) {
      setRegGenerando(false);
      setAltaSinFicha({correo:mail, nombre:nom, parecidas: fichasParecidas({fichas, email:mail, nombre:nom})});
      return;
    }
    await crearCuentaYVincular(mail, nom, existente);
  };

  // La creación, ya sabiendo a quién pertenece el correo. `existente` en null
  // significa que el patrón CONFIRMÓ que es alguien nuevo.
  const crearCuentaYVincular = async (mail:string, nom:string, existente:any|null) => {
    setRegGenerando(true); setRegFeedback(null);
    try {
      const { tempPass, workerUid } = await crearCuentaAccesoCore(mail, nom);
      try {
        await comprobarCuentaSinOtraFicha(currentUser.uid, workerUid, existente?.id || null);
        if (existente?.id) {
          await updateDoc(doc(db,"trabajadores",existente.id), { tieneAcceso:true, cuentaUid:workerUid });
        } else {
          await addDoc(collection(db,"trabajadores"), {
            userId: currentUser.uid, nombre: nom, email: mail,
            puesto:"", departamento:"", tipoContrato:"indefinido",
            salarioDiario:0, fechaIngreso:"", status:"activo", notas:"",
            tieneAcceso:true, cuentaUid:workerUid, datosCompletos:false, timestamp: Timestamp.now(),
          });
        }
      } catch(eT){ console.warn("ficha Empleados:", eT); }
      setAltaSinFicha(null);
      setRegFeedback({tipo:"ok", correo: mail, tempPass});
      setRegNombre(""); setRegCorreo("");
      await cargar();
    } catch(e:any) {
      setAltaSinFicha(null);
      setRegFeedback({tipo:"err", msg: mensajeErrorAcceso(e)});
    } finally { setRegGenerando(false); }
  };

  const guardar = async () => {
    if (!form.nombre || !form.fechaIngreso || !form.salarioDiario) return;
    // Casilla "crear cuenta de acceso": sólo aplica en alta nueva (en edición el
    // acceso se gestiona desde la pestaña Acceso de la ficha).
    const quiereAcceso = crearAcceso && !seleccionado;
    const mail = (form.email||"").toLowerCase().trim();
    setAltaAccesoError(null);
    if (quiereAcceso) {
      if (!mail) { setAltaAccesoError("Captura el correo del trabajador para crear su cuenta de acceso."); return; }
      // Evita duplicados por correo (cuentas_trabajador tiene id = correo).
      if ((cuentasTrab||[]).some((c:any)=>(c.email||"").toLowerCase()===mail)) {
        setAltaAccesoError("Ya existe una cuenta de acceso con ese correo."); return;
      }
    }
    setGuardando(true);
    try {
      if (quiereAcceso) {
        // 1) Cuenta de acceso primero: si falla, no creamos la ficha.
        const { tempPass, workerUid } = await crearCuentaAccesoCore(mail, form.nombre.trim());
        // 2) Ficha vinculada con acceso (mismo patrón que el flujo de "Crear acceso").
        await comprobarCuentaSinOtraFicha(currentUser.uid, workerUid, null);
        await addDoc(collection(db,"trabajadores"), {
          ...form, email:mail, userId:currentUser.uid, datosCompletos:true,
          tieneAcceso:true, cuentaUid:workerUid, timestamp:Timestamp.now(),
        });
        setAltaAccesoResult({correo:mail, tempPass});
      } else {
        // datosCompletos:true al guardar — limpia el badge "Completar datos" de las
        // fichas auto-creadas desde una cuenta de trabajador (updateDoc preserva
        // tieneAcceso/cuentaUid, que no vienen en el formulario).
        const data = {...form, userId:currentUser.uid, datosCompletos:true, timestamp:Timestamp.now()};
        if (seleccionado?.id) {
          await updateDoc(doc(db,"trabajadores",seleccionado.id), data);
        } else {
          await addDoc(collection(db,"trabajadores"), data);
        }
      }
      await cargar();
      avisarCambioDeAtencion();   // alta o edición: pudo cambiar la fecha de vencimiento del contrato
      setVista("lista");
      setSeleccionado(null);
      setForm(formVacio);
      setCrearAcceso(false);
    } catch(e:any){
      console.error(e);
      // Si falló la creación de cuenta, mostramos el motivo y NO salimos del formulario.
      setAltaAccesoError(quiereAcceso ? mensajeErrorAcceso(e) : "No se pudo guardar el expediente. Intenta de nuevo.");
    }
    setGuardando(false);
  };

  const [showModalBaja, setShowModalBaja] = useState<Trabajador|null>(null);
  // Causa de la baja (catálogo cerrado) y notas libres, capturadas en el modal.
  const [razonBaja, setRazonBaja] = useState("");
  const [notasBaja, setNotasBaja] = useState("");

  // Suspende/reactiva la CUENTA DEL PORTAL del trabajador (cuentas_trabajador/{correo},
  // id = correo en minúsculas) reutilizando el campo de estado que ya existe: `activo`.
  // NO borra la cuenta ni toca Firebase Auth: es reversible y sin backend. Si el
  // trabajador no tiene cuenta ("Sin acceso"), no hace nada y no truena.
  // Las reglas ya permiten al patrón dueño (empleadorId == su uid) actualizarla.
  const sincronizarCuentaTrabajador = async (email:string|undefined, activo:boolean) => {
    const mail = (email||"").toLowerCase().trim();
    if (!mail) return;
    try {
      const ref = doc(db,"cuentas_trabajador",mail);
      const snap = await getDoc(ref);
      if (!snap.exists()) return;                 // sin cuenta del portal → nada que hacer
      if (snap.data()?.activo === activo) return; // ya está en ese estado
      await updateDoc(ref, { activo });
    } catch(e){ console.warn("sincronizar cuenta del trabajador:", e); }
  };

  const confirmarBaja = async () => {
    const t = showModalBaja;
    if (!t?.id) return;
    const hoy = new Date().toISOString().slice(0,10);
    // Se CIERRA el periodo abierto en vez de solo marcar la ficha. `periodosDe`
    // reconstruye el primer periodo si la ficha es anterior a este campo, así que
    // una baja también deja migrada la ficha vieja, sin script aparte.
    const periodos = periodosDe(t).map(p=>({...p}));
    const abierto = [...periodos].reverse().find(p=>!p.baja);
    if (abierto) {
      abierto.baja = hoy;
      if (razonBaja) abierto.razonBaja = razonBaja;
      if (notasBaja.trim()) abierto.notasBaja = notasBaja.trim();
    } else {
      // Sin periodo abierto (ficha sin fecha de ingreso): se registra igual, para
      // no perder la salida por un dato que falta más arriba.
      periodos.push({ingreso: t.fechaIngreso || "", baja: hoy,
        ...(razonBaja ? {razonBaja} : {}), ...(notasBaja.trim() ? {notasBaja: notasBaja.trim()} : {})});
    }
    await updateDoc(doc(db,"trabajadores",t.id),{
      status:"baja", fechaBaja:hoy, periodosLaborales: periodos,
      ...(razonBaja ? {razonBaja} : {}),
    });
    // Cierra el hueco de seguridad: su cuenta del portal queda SUSPENDIDA.
    await sincronizarCuentaTrabajador(t.email, false);
    setShowModalBaja(null);
    setRazonBaja(""); setNotasBaja("");
    setVista("lista");
    setSeleccionado(null);
    await cargar();
    avisarCambioDeAtencion();   // baja: su contrato sale de la lista
  };

  const darDeBaja = (t:Trabajador) => {
    setShowModalBaja(t);
  };

  // Reingreso: revierte la baja y REACTIVA su cuenta del portal (simétrico a la baja).
  const reactivarTrabajador = async (t:Trabajador) => {
    if (!t?.id) return;
    if (!window.confirm(`¿Reactivar a ${t.nombre}? Volverá a contar como activo y, si tiene cuenta del portal, podrá entrar de nuevo.`)) return;
    try {
      // ABRE un periodo nuevo. Antes esto hacía `fechaBaja:""`, que destruía la
      // fecha de salida: el expediente quedaba afirmando una relación continua
      // que quizá no lo fue. La salida anterior se queda registrada en su
      // periodo; lo único que se limpia es el marcador de la ficha.
      const hoy = new Date().toISOString().slice(0,10);
      const periodos = periodosDe(t).map(p=>({...p}));
      const abierto = periodos.some(p=>!p.baja);
      if (!abierto) periodos.push({ingreso: hoy});
      await updateDoc(doc(db,"trabajadores",t.id),{status:"activo", fechaBaja:"", periodosLaborales: periodos});
      await sincronizarCuentaTrabajador(t.email, true);
      await cargar();
      avisarCambioDeAtencion();   // reingreso: su contrato vuelve a la lista
      setSeleccionado((prev:any)=> prev && prev.id===t.id ? {...prev, status:"activo", fechaBaja:"", periodosLaborales: periodos} : prev);
    } catch(e){ console.error("reactivar trabajador:", e); alert("No se pudo reactivar. Intenta de nuevo."); }
  };

  // RECONTRATACIÓN Y DUPLICADOS EN EL ALTA MANUAL.
  // Al teclear un CURP que ya está en la cuenta, se avisa; NUNCA se bloquea.
  // Se busca en la lista COMPLETA —`cargar()` no filtra por status, así que
  // incluye a los dados de baja—. Eso es lo importante: si la persona vuelve,
  // su antigüedad y su historial viven en el expediente que ya existe, y abrir
  // uno nuevo se los borra. Es un `find` en memoria: cero lecturas y cero
  // índices. Se exige CURP completa para no cruzar capturas a medias.
  const curpDuplicado:any = (() => {
    const bruto = String(form.curp||"").trim();
    if (!_reCURP.test(bruto)) return null;
    const c = _norm(bruto);
    return (trabajadores||[]).find((t:any)=> _norm(t.curp)===c && t.id!==seleccionado?.id) || null;
  })();
  const mostrarAvisoDup = !!curpDuplicado && _norm(dupPerdonado) !== _norm(form.curp||"");

  // LA ANTIGÜEDAD SE CUENTA POR CALENDARIO, NO DIVIDIENDO MILISEGUNDOS. Dividir
  // entre 365.25 no cuenta años: cuenta una media. Los años reales miden 365 o
  // 366 días, y la diferencia se acumula hasta que el contador cambia ANTES del
  // aniversario — medido: un día antes, y con la hora corriéndose seis horas más
  // cada año. Lo mismo con los 30.44 de los meses.
  //
  // `aniosCompletosLFT` compara año, mes y día, que es como se cumple un año.
  const calcularAntiguedad = (fechaIngreso:string) => {
    const ingreso = _diaLocalDeFecha(fechaIngreso);
    if (!ingreso) return "";
    const hoy = new Date();
    const anios = aniosCompletosLFT(ingreso, hoy);
    if (anios < 0) return "";                       // fecha de ingreso futura
    // Meses del año en curso, también por calendario.
    let meses = (hoy.getFullYear()-ingreso.getFullYear())*12 + (hoy.getMonth()-ingreso.getMonth());
    if (hoy.getDate() < ingreso.getDate()) meses--;
    meses = Math.max(0, meses) % 12;
    return anios > 0 ? `${anios} año${anios>1?"s":""} ${meses > 0 ? `y ${meses} mes${meses>1?"es":""}` : ""}` : `${meses} mes${meses>1?"es":""}`;
  };

  const calcularAlertas = (t:Trabajador) => {
    const alertas:string[] = [];
    const hoy = new Date();
    // Vencimiento contrato — día contra día, con la misma función que Inicio.
    const dias = diasHastaFecha(t.fechaVencimiento, hoy);
    if (dias !== null) {
      // El contrato que termina hoy ampara hoy. Vencido empieza mañana.
      if (dias === 0) alertas.push("⚠️ El contrato vence HOY");
      else if (dias <= 30 && dias > 0) alertas.push(`⚠️ Contrato vence en ${dias} día${dias!==1?"s":""}`);
      else if (dias < 0) alertas.push(`🔴 Contrato VENCIDO hace ${Math.abs(dias)} día${Math.abs(dias)!==1?"s":""}`);
    }
    // Aguinaldo — diciembre
    if (hoy.getMonth() === 10) alertas.push("🎄 Aguinaldo vence el 20 de diciembre");
    return alertas;
  };

  // EL AVISO MARCA, NO FILTRA. Antes acotaba la lista a quienes no habían
  // checado, y ese filtro era INVISIBLE y no se podía quitar: cambiar el estado a
  // "Todos" no lo tocaba y "Quitar filtros" tampoco. Quien llegaba desde el aviso
  // veía dos personas de quince y no había nada en pantalla que dijera por qué ni
  // cómo salir — desde fuera, la plataforma había perdido a su personal.
  //
  // Ahora el aviso lleva a la lista COMPLETA y señala en su propia fila a quien
  // falta. Una sola forma de ver a la gente, y ningún filtro que no se vea.
  const marcadosSinChecar = new Set((focoEmails||[]).map((m:string)=>String(m||"").toLowerCase().trim()).filter(Boolean));
  // AL LLEGAR DESDE EL AVISO, SE VA A LA PERSONA. El chip "Sin checar hoy" ya
  // estaba en su fila, pero en una lista de cuarenta hay que encontrarlo — y eso
  // es justo lo que el aviso prometía ahorrar. Se señala al primero de los
  // marcados; si son varios, los demás llevan su chip y quedan a la vista al
  // desplazarse desde ahí.
  const _primerSinChecar = ((trabajadores||[]).find((t:any)=> t.status!=="baja"
    && marcadosSinChecar.has(String(t.email||"").toLowerCase().trim())) || {}).id || null;
  const _resSinChecar = useResaltado(_primerSinChecar, trabajadores);
  const filtradosSinOrden = trabajadores.filter(t => {
    const matchStatus = filtroStatus === "todos" || t.status === filtroStatus;
    const matchBusq = !busqueda || t.nombre.toLowerCase().includes(busqueda.toLowerCase()) || t.puesto.toLowerCase().includes(busqueda.toLowerCase());
    const matchArea = !filtroArea || (t.departamento||"").trim() === filtroArea;
    return matchStatus && matchBusq && matchArea;
  });
  // Orden por columna. La antigüedad se ordena por fechaIngreso (más antiguo = más
  // arriba en "desc"); sin fecha va al final para no fingir un dato que no existe.
  const filtrados = filtradosSinOrden.slice().sort((a:any,b:any)=>{
    const dir = ordenDir==="asc" ? 1 : -1;
    if (ordenCol==="antiguedad") {
      const fa=a.fechaIngreso||"", fb=b.fechaIngreso||"";
      if (!fa && !fb) return 0; if (!fa) return 1; if (!fb) return -1;
      return fa.localeCompare(fb) * dir;
    }
    return (a.nombre||"").localeCompare((b.nombre||""), "es") * dir;
  });
  // Áreas presentes, para el filtro por departamento (sin consultas nuevas).
  const areasDisponibles = Array.from(new Set(trabajadores.map((t:any)=>(t.departamento||"").trim()).filter(Boolean))).sort((a,b)=>a.localeCompare(b,"es"));

  const activos = trabajadores.filter(t=>t.status==="activo");
  const conAlerta = activos.filter(t=>calcularAlertas(t).length>0);

  // ── FORMULARIO ──
  if (vista === "form") return (
    <div {...ZONA_DE_CAPTURA} style={{minHeight:"100vh", background:T_LIGHT.canvas, fontFamily:fontSans}}>
      <div style={{background:T.navy, padding:"0 20px", height:50, display:"flex", alignItems:"center", gap:12, borderBottom:"1px solid rgba(184,147,42,0.18)", boxShadow:"0 2px 16px rgba(22,36,71,0.10)"}}>
        <button onClick={()=>{setVista("lista");setSeleccionado(null);setForm(formVacio);setCrearAcceso(false);setAltaAccesoError(null);}} style={{background:"rgba(255,255,255,0.08)", border:"1px solid rgba(255,255,255,0.15)", color:"white", borderRadius:8, padding:"5px 12px", cursor:"pointer", fontSize:12}}>← Lista</button>
        <span style={{color:"white", fontWeight:600, fontSize:13}}>{seleccionado?"✏️ Editar":"➕ Nuevo trabajador"}</span>
      </div>
      <div style={{maxWidth:640, margin:"0 auto", padding:isMobile?"16px":"28px 24px"}}>
        {[
          {titulo:"Datos personales", icon:"user_single", campos:[
            {label:"Nombre completo *", key:"nombre", tipo:"text", ph:"Nombre del trabajador"},
            {label:"Teléfono", key:"telefono", tipo:"tel", ph:"449 123 4567"},
            {label:"Correo electrónico", key:"email", tipo:"email", ph:"trabajador@email.com"},
            {label:"CURP", key:"curp", tipo:"text", ph:"XXXX000000XXXXXX00"},
            {label:"RFC", key:"rfc", tipo:"text", ph:"RFC con homoclave"},
            {label:"Número IMSS (NSS)", key:"imss", tipo:"text", ph:"11 dígitos"},
            {label:"Dirección", key:"direccion", tipo:"text", ph:"Calle, número, colonia, ciudad"},
          ]},
          {titulo:"Datos laborales", icon:"briefcase", campos:[
            {label:"Puesto / Cargo *", key:"puesto", tipo:"text", ph:"Ej. Auxiliar contable"},
            {label:"Departamento", key:"departamento", tipo:"text", ph:"Ej. Administración"},
            {label:"Fecha de ingreso *", key:"fechaIngreso", tipo:"date", ph:""},
          ]},
        ].map(sec => (
          <React.Fragment key={sec.titulo}>
          <div className="emp-card" style={{background:T_LIGHT.cardLight, borderRadius:14, padding:"20px 24px", marginBottom:14, border:`1px solid ${T_LIGHT.borderCard}`, boxShadow:T_LIGHT.shadow}}>
            <h3 style={{fontFamily:fontSerif, fontSize:15, color:T_LIGHT.textInk, margin:"0 0 16px", display:"flex", alignItems:"center", gap:8}}><AxisIcon name={sec.icon} size={16} tone="gold" withBackdrop={false} strokeWidth={2.5}/>{sec.titulo}</h3>
            <div style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap:12}}>
              {sec.campos.map(c => (
                <div key={c.key} style={{gridColumn:["nombre","puesto","departamento","direccion"].includes(c.key)?"1 / -1":"auto"}}>
                  <label style={{fontSize:10, color:"#9A9AAA", display:"block", marginBottom:4, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>{c.label}</label>
                  <input value={(form as any)[c.key]} onChange={e=>set(c.key, c.tipo==="number"?parseFloat(e.target.value)||0:e.target.value)} type={c.tipo} placeholder={c.ph}
                    style={{width:"100%", padding:"11px 13px", background:T_LIGHT.canvasSoft, color:T_LIGHT.textInk, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:10, fontSize:13, outline:"none", boxSizing:"border-box" as const}} />
                  {/* Aviso informativo (no bloqueante) si el salario diario queda bajo el mínimo legal */}
                  {c.key==="salarioDiario" && (form.salarioDiario||0) > 0 && (form.salarioDiario||0) < SMG_2026 && (
                    <div style={{marginTop:5, fontSize:11, color:"#B45309", lineHeight:1.4, display:"flex", alignItems:"flex-start", gap:5}}>
                      <span style={{flexShrink:0}}>⚠</span>
                      <span>Por debajo del salario mínimo general vigente (${SMG_2026.toFixed(2)} MXN/día).</span>
                    </div>
                  )}
                  {/* Validación de FORMATO por campo (solo si hay valor; vacío es válido — es opcional).
                      No bloquea el guardado ni afecta a los demás campos. */}
                  {(()=>{ const v=String((form as any)[c.key]||"").trim(); if(!v) return null;
                    let msg="";
                    if (c.key==="rfc"  && !_reRFC.test(v))  msg="RFC inválido (12 o 13 caracteres alfanuméricos).";
                    else if (c.key==="curp" && !_reCURP.test(v)) msg="CURP inválida (deben ser 18 caracteres).";
                    else if (c.key==="email" && !_reMail.test(v)) msg="Correo con formato inválido.";
                    else if (c.key==="imss" && !/^\d{11}$/.test(v)) msg="El NSS (IMSS) debe tener 11 dígitos.";
                    return msg ? <div style={{marginTop:5, fontSize:11, color:"#B45309", lineHeight:1.4, display:"flex", alignItems:"flex-start", gap:5}}><span style={{flexShrink:0}}>⚠</span><span>{msg}</span></div> : null;
                  })()}
                  {/* Aviso de CURP repetida. NO bloquea: el botón de guardar sigue
                      funcionando igual. Solo pone enfrente a quién ya tienes, para
                      que el patrón decida con el dato a la vista en vez de crear un
                      expediente paralelo sin saberlo. */}
                  {c.key==="curp" && mostrarAvisoDup && (()=>{
                    const dup = curpDuplicado;
                    const esBaja = (dup.status||"activo")==="baja";
                    return (
                      <div style={{marginTop:8, padding:"10px 12px", background:"rgba(217,119,6,0.07)",
                        border:"1px solid rgba(217,119,6,0.35)", borderRadius:10, lineHeight:1.45}}>
                        <div style={{fontSize:11.5, fontWeight:700, color:"#B45309"}}>
                          Ya tienes a alguien con este CURP
                        </div>
                        <div style={{fontSize:12.5, color:T_LIGHT.textInk, marginTop:4, fontWeight:600}}>
                          {dup.nombre || "Sin nombre"}
                          <span style={{fontWeight:400, color:T_LIGHT.textInkSoft}}>
                            {dup.puesto ? ` · ${dup.puesto}` : ""}
                            {` · ${esBaja ? "dado de baja" : "activo"}`}
                          </span>
                        </div>
                        <div style={{fontSize:11, color:T_LIGHT.textInkSoft, marginTop:5}}>
                          {esBaja
                            ? "Si vuelve a la empresa, reactiva su expediente en vez de abrir uno nuevo: su antigüedad y su historial están ahí, y un registro nuevo los deja atrás."
                            : "Un CURP es único por persona, así que sería el mismo trabajador dos veces."}
                        </div>
                        <div style={{display:"flex", gap:8, marginTop:9, flexWrap:"wrap" as const}}>
                          {esBaja && (
                            <button type="button" onClick={async()=>{
                                await reactivarTrabajador(dup);
                                setSeleccionado(dup); setVista("detalle"); setTabActiva("datos");
                              }}
                              style={{background:T.navy, border:"none", color:"white", borderRadius:8,
                                padding:"7px 12px", fontSize:11.5, fontWeight:700, cursor:"pointer", fontFamily:fontSans}}>
                              Reactivar su expediente
                            </button>
                          )}
                          <button type="button" onClick={()=>{ setSeleccionado(dup); setVista("detalle"); setTabActiva("datos"); }}
                            style={{background:"transparent", border:`1px solid ${T_LIGHT.borderCard}`, color:T_LIGHT.textInk,
                              borderRadius:8, padding:"7px 12px", fontSize:11.5, fontWeight:600, cursor:"pointer", fontFamily:fontSans}}>
                            Abrir su expediente
                          </button>
                          <button type="button" onClick={()=>setDupPerdonado(String(form.curp||""))}
                            style={{background:"transparent", border:"none", color:T_LIGHT.textInkSoft,
                              padding:"7px 4px", fontSize:11.5, fontWeight:600, cursor:"pointer", fontFamily:fontSans, textDecoration:"underline"}}>
                            Crear de todos modos
                          </button>
                        </div>
                      </div>
                    );
                  })()}
                </div>
              ))}
            </div>
          </div>

          {/* Tarjeta "Acceso a la app" — tras los datos de identificación, antes de Datos laborales (sólo en alta nueva) */}
          {sec.titulo==="Datos personales" && !seleccionado && (
            <div className="emp-card" style={{background:T_LIGHT.cardLight, borderRadius:14, padding:"20px 24px", marginBottom:14, border:`1px solid ${crearAcceso?"rgba(35,100,120,0.45)":T_LIGHT.borderCard}`, boxShadow:T_LIGHT.shadow}}>
              <h3 style={{fontFamily:fontSerif, fontSize:15, color:T_LIGHT.textInk, margin:"0 0 14px", display:"flex", alignItems:"center", gap:8}}><AxisIcon name="lock_open" size={16} tone="gold" withBackdrop={false} strokeWidth={2.5}/>Acceso a la app</h3>
              <label style={{display:"flex", alignItems:"flex-start", gap:12, cursor:"pointer"}}>
                <input type="checkbox" checked={crearAcceso} onChange={e=>{setCrearAcceso(e.target.checked); setAltaAccesoError(null);}}
                  style={{marginTop:2, width:18, height:18, accentColor:"#236478", cursor:"pointer", flexShrink:0}} />
                <div>
                  <div style={{fontSize:13, fontWeight:700, color:T_LIGHT.textInk, marginBottom:3}}>
                    Crear cuenta de acceso para que el trabajador entre a la app (tareas, checador, flotilla){" "}
                    <button type="button" onClick={(e)=>{e.preventDefault(); e.stopPropagation(); setMostrarComoFuncionaAcceso(true);}}
                      style={{background:"none", border:"none", padding:0, color:"#236478", fontSize:12, fontWeight:600, textDecoration:"underline", cursor:"pointer", fontFamily:fontSans, whiteSpace:"nowrap" as const}}>
                      ¿Cómo funciona?
                    </button>
                  </div>
                  <div style={{fontSize:11.5, color:T_LIGHT.textInkSoft, lineHeight:1.5}}>
                    Se generará una contraseña temporal para compartir, sin cerrar tu sesión.{" "}
                    {crearAcceso
                      ? ((form.email||"").trim()
                          ? <>Se usará el correo <strong style={{color:T_LIGHT.textInk}}>{(form.email||"").toLowerCase().trim()}</strong>.</>
                          : <strong style={{color:"#C2410C"}}>Captura el correo del trabajador arriba para habilitar el acceso.</strong>)
                      : "Si la dejas sin marcar sólo se crea su expediente. Sin cuenta no podrá checar entrada y salida, ni registrar movimientos de flotilla, ni marcar sus actividades: el enlace con el trabajador funciona solo mediante su cuenta. Se puede crear después desde su ficha, en la pestaña Acceso."}
                  </div>
                </div>
              </label>
            </div>
          )}
          </React.Fragment>
        ))}

        {/* Salario — periodicidad (Mensual/Diario) + equivalente en vivo. Guarda AMBOS
            montos + salarioBase; el otro se deriva con el factor /30 (Art. 89 LFT). */}
        <div className="emp-card" style={{background:T_LIGHT.cardLight, borderRadius:14, padding:"20px 24px", marginBottom:14, border:`1px solid ${T_LIGHT.borderCard}`, boxShadow:T_LIGHT.shadow}}>
          <h3 style={{fontFamily:fontSerif, fontSize:15, color:T_LIGHT.textInk, margin:"0 0 14px", display:"flex", alignItems:"center", gap:8}}><AxisIcon name="money" size={16} tone="gold" withBackdrop={false} strokeWidth={2.5}/>Salario *</h3>
          <div style={{display:"flex", gap:8, marginBottom:12, flexWrap:"wrap" as const}}>
            {(["mensual","diario"] as const).map(b=>{ const activo=(form.salarioBase||"mensual")===b; return (
              <button key={b} type="button" onClick={()=>set("salarioBase",b)}
                style={{flex:1, minWidth:150, padding:"10px 10px", borderRadius:10, border:`2px solid ${activo?"#0EA5E9":"rgba(22,36,71,0.12)"}`, background:activo?"rgba(14,165,233,0.06)":"white", cursor:"pointer", textAlign:"left" as const}}>
                <div style={{fontSize:12, fontWeight:700, color:activo?"#0EA5E9":"#0F1D35", marginBottom:2}}>{b==="mensual"?"Mensual":"Diario"}</div>
                <div style={{fontSize:10, color:"#9A9AAA"}}>{b==="mensual"?"Capturas el monto al mes":"Capturas el monto por día"}</div>
              </button>); })}
          </div>
          <label style={{fontSize:10, color:"#9A9AAA", display:"block", marginBottom:4, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>Salario {(form.salarioBase||"mensual")==="mensual"?"mensual":"diario"} (pesos) *</label>
          <input type="number" min={0}
            value={(((form.salarioBase||"mensual")==="diario" ? form.salarioDiario : form.salarioMensual) || "") as any}
            onChange={e=>{ const n=parseFloat(e.target.value)||0;
              if ((form.salarioBase||"mensual")==="diario") setForm(p=>({...p, salarioDiario:n, salarioMensual:_round2(diarioAMensual(n))}));
              else setForm(p=>({...p, salarioMensual:n, salarioDiario:_round2(mensualADiario(n))}));
            }}
            placeholder={(form.salarioBase||"mensual")==="mensual"?"Ej. 16000":"Ej. 533.33"}
            style={{width:"100%", padding:"11px 13px", background:T_LIGHT.canvasSoft, color:T_LIGHT.textInk, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:10, fontSize:13, outline:"none", boxSizing:"border-box" as const}} />
          {((form.salarioMensual||0)>0 || (form.salarioDiario||0)>0) && (
            <div style={{marginTop:7, fontSize:12.5, color:T_LIGHT.textInkSoft}}>Mensual <strong style={{color:T_LIGHT.textInk}}>{fmtMXN2(form.salarioMensual||0)}</strong> · Diario <strong style={{color:T_LIGHT.textInk}}>{fmtMXN2(form.salarioDiario||0)}</strong> <span style={{color:T_LIGHT.textInkMut}}>(÷ 30, Art. 89 LFT)</span></div>
          )}
          {(form.salarioDiario||0) > 0 && (form.salarioDiario||0) < SMG_2026 && (
            <div style={{marginTop:6, fontSize:11, color:"#B45309", lineHeight:1.4, display:"flex", alignItems:"flex-start", gap:5}}><span style={{flexShrink:0}}>⚠</span><span>Por debajo del salario mínimo general vigente (${SMG_2026.toFixed(2)} MXN/día).</span></div>
          )}
        </div>

        {/* Tipo contrato */}
        <div className="emp-card" style={{background:T_LIGHT.cardLight, borderRadius:14, padding:"20px 24px", marginBottom:14, border:`1px solid ${T_LIGHT.borderCard}`, boxShadow:T_LIGHT.shadow}}>
          <h3 style={{fontFamily:fontSerif, fontSize:15, color:T_LIGHT.textInk, margin:"0 0 14px", display:"flex", alignItems:"center", gap:8}}>
            <AxisIcon name="clipboard" size={16} tone="gold" withBackdrop={false} strokeWidth={2.5}/>
            Tipo de contrato
          </h3>
          <div style={{display:"flex", gap:8, marginBottom:12}}>
            {([["indefinido","Tiempo indefinido","Sin fecha de vencimiento"],["determinado","Tiempo determinado","Con fecha de término"],["obra","Por obra/servicio","Termina al concluir el proyecto"]] as const).map(([val,label,desc]) => (
              <button key={val} onClick={()=>set("tipoContrato",val)}
                style={{flex:1, padding:"10px 8px", borderRadius:10, border:`2px solid ${form.tipoContrato===val?"#0EA5E9":"rgba(22,36,71,0.12)"}`, background:form.tipoContrato===val?"rgba(14,165,233,0.06)":"white", cursor:"pointer", textAlign:"left" as const}}>
                <div style={{fontSize:12, fontWeight:700, color:form.tipoContrato===val?"#0EA5E9":"#0F1D35", marginBottom:2}}>{label}</div>
                <div style={{fontSize:10, color:"#9A9AAA"}}>{desc}</div>
              </button>
            ))}
          </div>
          {form.tipoContrato !== "indefinido" && (
            <div>
              <label style={{fontSize:10, color:"#9A9AAA", display:"block", marginBottom:4, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>Fecha de vencimiento del contrato</label>
              <input value={form.fechaVencimiento||""} onChange={e=>set("fechaVencimiento",e.target.value)} type="date"
                style={{width:"100%", padding:"11px 13px", background:T_LIGHT.canvasSoft, color:T_LIGHT.textInk, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:10, fontSize:13, outline:"none", boxSizing:"border-box" as const}} />
            </div>
          )}
        </div>

        {/* Contacto de emergencia */}
        <div className="emp-card" style={{background:T_LIGHT.cardLight, borderRadius:14, padding:"20px 24px", marginBottom:14, border:`1px solid ${T_LIGHT.borderCard}`, boxShadow:T_LIGHT.shadow}}>
          <h3 style={{fontFamily:fontSerif, fontSize:15, color:T_LIGHT.textInk, margin:"0 0 14px", display:"flex", alignItems:"center", gap:8}}><AxisIcon name="alert" size={16} tone="gold" withBackdrop={false} strokeWidth={2.5}/>Contacto de emergencia</h3>
          <div style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap:12}}>
            <div>
              <label style={{fontSize:10, color:"#9A9AAA", display:"block", marginBottom:4, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>Nombre del contacto</label>
              <input value={form.contactoEmergenciaNombre||""} onChange={e=>set("contactoEmergenciaNombre",e.target.value)} placeholder="Nombre completo"
                style={{width:"100%", padding:"11px 13px", background:T_LIGHT.canvasSoft, color:T_LIGHT.textInk, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:10, fontSize:13, outline:"none", boxSizing:"border-box" as const}} />
            </div>
            <div>
              <label style={{fontSize:10, color:"#9A9AAA", display:"block", marginBottom:4, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>Teléfono de emergencia</label>
              <input value={form.contactoEmergenciaTel||""} onChange={e=>set("contactoEmergenciaTel",e.target.value)} placeholder="449 123 4567" type="tel"
                style={{width:"100%", padding:"11px 13px", background:T_LIGHT.canvasSoft, color:T_LIGHT.textInk, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:10, fontSize:13, outline:"none", boxSizing:"border-box" as const}} />
            </div>
          </div>
        </div>

        {/* Notas */}
        <div className="emp-card" style={{background:T_LIGHT.cardLight, borderRadius:14, padding:"20px 24px", marginBottom:20, border:`1px solid ${T_LIGHT.borderCard}`, boxShadow:T_LIGHT.shadow}}>
          <h3 style={{fontFamily:fontSerif, fontSize:15, color:T_LIGHT.textInk, margin:"0 0 12px", display:"flex", alignItems:"center", gap:8}}><AxisIcon name="document" size={16} tone="gold" withBackdrop={false} strokeWidth={2.5}/>Notas</h3>
          <textarea value={form.notas||""} onChange={e=>set("notas",e.target.value)} rows={3} placeholder="Observaciones, habilidades especiales, acuerdos particulares..."
            style={{width:"100%", padding:"11px 13px", background:T_LIGHT.canvasSoft, color:T_LIGHT.textInk, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:10, fontSize:13, outline:"none", boxSizing:"border-box" as const, resize:"vertical" as const, fontFamily:fontSans}} />
        </div>

        {altaAccesoError && (
          <ErrorAltaTrabajador msg={altaAccesoError} correo={form.email||""} fontSans={fontSans}
            style={{background:"rgba(220,38,38,0.08)", border:"1px solid rgba(220,38,38,0.30)", borderRadius:10, padding:"10px 14px", marginBottom:12, fontSize:12.5, color:"#DC2626", fontWeight:600}}/>
        )}

        {(() => {
          const faltaCorreoAcceso = crearAcceso && !seleccionado && !(form.email||"").trim();
          const puedeGuardar = !!form.nombre && !!form.fechaIngreso && !!form.salarioDiario && !faltaCorreoAcceso;
          return (
            <button onClick={guardar} disabled={guardando||!puedeGuardar}
              style={{width:"100%", background:puedeGuardar?"linear-gradient(135deg,#0EA5E9,#0284C7)":"rgba(0,0,0,0.08)", border:"none", borderRadius:14, padding:"16px", cursor:guardando||!puedeGuardar?"not-allowed":"pointer", fontSize:15, fontWeight:700, color:puedeGuardar?"white":"#9A9AAA", boxShadow:puedeGuardar?"0 4px 16px rgba(14,165,233,0.3)":"none"}}>
              {guardando
                ? (crearAcceso && !seleccionado ? "Creando cuenta..." : "Guardando...")
                : (crearAcceso && !seleccionado ? "💾 Guardar y crear acceso" : "💾 Guardar expediente")}
            </button>
          );
        })()}
      </div>

      {/* Modal informativo: cómo funciona la cuenta del trabajador */}
      {mostrarComoFuncionaAcceso && (
        <div onClick={()=>setMostrarComoFuncionaAcceso(false)} style={{position:"fixed" as const, inset:0, background:"rgba(0,0,0,0.55)", zIndex:500, display:"flex", alignItems:"center", justifyContent:"center", padding:20, backdropFilter:"blur(4px)"}}>
          <div onClick={e=>e.stopPropagation()} style={{background:"white", borderRadius:18, padding:"24px 28px", maxWidth:480, width:"100%", boxShadow:"0 20px 60px rgba(0,0,0,0.18)", fontFamily:fontSans, maxHeight:"85vh", overflowY:"auto" as const}}>
            <h3 style={{fontFamily:fontSerif, fontSize:18, color:"#0F1D35", margin:"0 0 6px", display:"flex", alignItems:"center", gap:8}}><AxisIcon name="lock_open" size={18} tone="gold" withBackdrop={false} strokeWidth={2.5}/>¿Cómo funciona la cuenta del trabajador?</h3>
            <div style={{fontSize:13, color:"#4A4A60", lineHeight:1.6, marginBottom:14}}>
              Al activar esta opción, el sistema genera una <strong style={{color:"#0F1D35"}}>contraseña temporal</strong> que tú (el patrón) compartes con el trabajador. Con ella, el trabajador puede entrar desde su <strong style={{color:"#0F1D35"}}>celular (app)</strong> o desde una <strong style={{color:"#0F1D35"}}>computadora (la misma plataforma web)</strong> para:
            </div>
            <div style={{display:"flex", flexDirection:"column" as const, gap:10, marginBottom:16}}>
              {[
                {icon:"refresh", t:"Checador", d:"Registrar su entrada y salida."},
                {icon:"suite_flotilla", t:"Flotilla", d:"Registrar la salida y el regreso de los vehículos asignados."},
                {icon:"check", t:"Actividades", d:"Confirmar que ya realizó las actividades que se le asignaron."},
                {icon:"plus", t:"Y más", d:"Otras funciones que se irán agregando."},
              ].map(item => (
                <div key={item.t} style={{display:"flex", alignItems:"flex-start", gap:10, background:T_LIGHT.canvasSoft, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:10, padding:"10px 12px"}}>
                  <div style={{flexShrink:0, marginTop:1}}><AxisIcon name={item.icon} size={16} tone="gold" withBackdrop={false} strokeWidth={2.5}/></div>
                  <div>
                    <div style={{fontSize:13, fontWeight:700, color:"#0F1D35"}}>{item.t}</div>
                    <div style={{fontSize:12, color:"#4A4A60", lineHeight:1.5}}>{item.d}</div>
                  </div>
                </div>
              ))}
            </div>
            <button onClick={()=>setMostrarComoFuncionaAcceso(false)} style={{width:"100%", background:"#236478", border:"none", borderRadius:12, padding:"12px", cursor:"pointer", fontSize:13, fontWeight:700, color:"white", fontFamily:fontSans}}>Entendido</button>
          </div>
        </div>
      )}
    </div>
  );

const generarPDFResumen = async () => {
    setGenerandoPDFResumen(true);
    try {
      const jsPDFClass = (window as any).jspdf?.jsPDF || (window as any).jsPDF;
      if (!jsPDFClass) {
        alert("jsPDF no está disponible. Recarga la página.");
        setGenerandoPDFResumen(false);
        return;
      }
      const pdf = new jsPDFClass({orientation:"landscape", unit:"mm", format:"a4"});

      const activos = trabajadores.filter(t => t.status === "activo");
      const kpis = calcularKPIsGlobales(activos, mesResumen, tareasTrab);
      const empleadosConMetricas = activos.map(t => ({trabajador: t, metricas: calcularMetricasEmpleado(t, mesResumen, tareasTrab)}));
      empleadosConMetricas.sort((a, b) => {
        if (ordenamientoResumen === "docs") return a.metricas.pctDocs - b.metricas.pctDocs;
        if (ordenamientoResumen === "tareas") return a.metricas.pctTareas - b.metricas.pctTareas;
        return b.metricas.vencidas - a.metricas.vencidas;
      });

      const [yearStr, monthStr] = mesResumen.split("-");
      const nombreMesRaw = new Date(parseInt(yearStr), parseInt(monthStr)-1, 1).toLocaleString("es-MX", {month:"long", year:"numeric"});
      const nombreMes = nombreMesRaw.charAt(0).toUpperCase() + nombreMesRaw.slice(1);
      const fechaGen = new Date().toLocaleDateString("es-MX", {day:"numeric", month:"short", year:"numeric"});

      pdf.setFillColor(15, 29, 53); pdf.rect(0, 0, 297, 6, "F");
      // EL MEMBRETE ES DEL PATRÓN. Aquí iban el logo y "AXIS LEGALTECH": este
      // documento lo emite él, con sus datos y sobre su plantilla, y AXIS no es
      // parte de nada. Mismo criterio que la bitácora quincenal, y las mismas
      // líneas —`lineasMembretePatron`—, solo que dibujadas con jsPDF.
      // Sin denominación capturada no se imprime nada y el documento se
      // identifica por su título, que sigue arriba a la derecha.
      membreteDelPatronJsPDF(pdf, 15, 13, dpEmp, 215);
      pdf.setFont("helvetica","bold"); pdf.setFontSize(10); pdf.setTextColor(60, 60, 60);
      pdf.text("Resumen general del equipo", 282, 13, {align:"right"});
      pdf.setFont("helvetica","normal"); pdf.setFontSize(9); pdf.setTextColor(90, 90, 90);
      pdf.text(`Periodo: ${nombreMes}`, 282, 18, {align:"right"});
      pdf.text(`Generado: ${fechaGen}`, 282, 23, {align:"right"});
      pdf.setDrawColor(184, 147, 42); pdf.setLineWidth(0.5);
      pdf.line(15, 27, 282, 27);

      pdf.setFont("helvetica","bold"); pdf.setFontSize(11); pdf.setTextColor(20, 20, 20);
      pdf.text(`${kpis.totalEmpleados} empleado${kpis.totalEmpleados===1?"":"s"} activo${kpis.totalEmpleados===1?"":"s"}`, 15, 35);
      pdf.setFontSize(10); pdf.setFont("helvetica","normal"); pdf.setTextColor(80, 80, 80);
      // LOS TRES KPIs SE REPARTEN MIDIENDO, no en columnas escritas a mano. Iban en
      // 15, 110 y 220; al alargarse el primero, el papel salía con "con algo
      // caDesempeno en actividades prom." —una frase encima de otra, sin error ni
      // hueco que lo delatara—.
      const kpisResumen = [
        kpis.promDocsSobre === 0
          ? "Expediente capturado prom.: sin datos"
          : `Expediente capturado prom.: ${kpis.promDocs}%`,
        `Desempeno en actividades prom.: ${kpis.promTareas}%`,
        `Total actividades vencidas: ${kpis.totalVencidas}`,
      ];
      const yKpis = repartirEnRenglonJsPDF(pdf, kpisResumen, 15, 41, 267, 5);

      // EN PAPEL LA ACLARACION PESA MAS, NO MENOS: el PDF se manda y se archiva,
      // y quien lo abre no tiene ni la pantalla ni a quien preguntarle.
      //
      // Y AQUI ES DONDE VA EL DENOMINADOR DEL PROMEDIO. Iba pegado a la cifra, en el
      // renglon de KPIs, y era la mitad de la frase que se comio a su vecina: en la
      // letra pequena cabe entera y se lee mejor, porque explica en vez de medir.
      const notaResumen = (kpis.promDocsSobre === 0
        ? "Todavia nadie tiene casillas marcadas, asi que no hay promedio de expediente que dar. "
        : `El promedio de expediente capturado se saca sobre ${kpis.promDocsSobre} de ${kpis.totalEmpleados} empleado${kpis.totalEmpleados===1?"":"s"} activo${kpis.totalEmpleados===1?"":"s"}: los que ya tienen algo capturado. `)
        + NOTA_EXPEDIENTE_CAPTURADO;
      pdf.setFontSize(7); pdf.setTextColor(130, 130, 130);
      const lineasNota: string[] = pdf.splitTextToSize(notaResumen, 267);
      lineasNota.forEach((ln:string, i:number) => pdf.text(ln, 15, yKpis + 4.5 + i * 3.1));
      pdf.setFontSize(10); pdf.setTextColor(80, 80, 80);

      // LA TABLA EMPIEZA DEBAJO DEL TEXTO, no en un 52 escrito a mano. Ese 52 era
      // el mismo tipo de dato que las tres columnas fijas: cierto hasta que algo de
      // arriba creciera. Si la nota ocupa dos renglones, la cabecera se corre sola.
      let yPos = Math.max(52, yKpis + 4.5 + lineasNota.length * 3.1 + 3);
      pdf.setFillColor(248, 244, 230);
      pdf.rect(15, yPos-5, 267, 7, "F");
      pdf.setFont("helvetica","bold"); pdf.setFontSize(9); pdf.setTextColor(107, 85, 16);
      pdf.text("EMPLEADO", 17, yPos);
      pdf.text("PUESTO", 100, yPos);
      pdf.text("DOCS", 175, yPos);
      pdf.text("ACTIVIDADES", 195, yPos);
      pdf.text("PEND.", 220, yPos);
      pdf.text("VENC.", 240, yPos);
      yPos += 6;

      pdf.setFont("helvetica","normal");
      empleadosConMetricas.forEach(({trabajador: t, metricas: m}, idx) => {
        if (yPos > 195) { pdf.addPage(); yPos = 25; }
        if (idx % 2 === 1) {
          pdf.setFillColor(245, 245, 245);
          pdf.rect(15, yPos-4, 267, 6, "F");
        }
        pdf.setTextColor(20, 20, 20); pdf.setFontSize(9);
        pdf.text((t.nombre || "—").slice(0, 35), 17, yPos);
        pdf.setTextColor(110, 110, 110);
        pdf.text((t.puesto || "—").slice(0, 30), 100, yPos);
        pdf.setTextColor(20, 20, 20); pdf.setFont("helvetica","bold");
        pdf.text(`${m.pctDocs}%`, 175, yPos);
        pdf.text(m.tieneTareasEnMes ? `${m.pctTareas}%` : "-", 195, yPos);
        pdf.setFont("helvetica","normal");
        pdf.text(`${m.pendientes}`, 220, yPos);
        if (m.vencidas > 0) { pdf.setTextColor(200, 40, 40); } else { pdf.setTextColor(110, 110, 110); }
        pdf.text(`${m.vencidas}`, 240, yPos);
        yPos += 6;
      });

      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        pdf.setDrawColor(220, 220, 220); pdf.setLineWidth(0.3);
        pdf.line(15, 200, 282, 200);
        pdf.setFont("helvetica","normal"); pdf.setFontSize(7); pdf.setTextColor(130, 130, 130);
        // El pie que llevan los otros diecisiete documentos, palabra por palabra:
        // la única mención a AXIS permitida es a la PLATAFORMA, en letra chica.
        pintarPieDelPatronJsPDF(pdf, 15, 205, 230, dpEmp, fechaHoraLargaAxis());
        pdf.text(`${i} / ${totalPages}`, 282, 205, {align:"right"});
      }

      pdf.save(`Resumen_general_${mesResumen}.pdf`);
    } catch (e) {
      console.error(e);
      alert("Error al generar el PDF resumen. Revisa la consola (F12).");
    }
    setGenerandoPDFResumen(false);
  };
  
  
  if (vista === "resumen") {
    const activos = trabajadores.filter(t => t.status === "activo");
    const kpis = calcularKPIsGlobales(activos, mesResumen, tareasTrab);
    const filtrados = activos.filter(t => {
      if (!busqueda) return true;
      const q = busqueda.toLowerCase();
      return t.nombre.toLowerCase().includes(q) || (t.puesto||"").toLowerCase().includes(q);
    });
    const empleadosConMetricas = filtrados.map(t => ({trabajador: t, metricas: calcularMetricasEmpleado(t, mesResumen, tareasTrab)}));
    empleadosConMetricas.sort((a, b) => {
      if (ordenamientoResumen === "docs") return a.metricas.pctDocs - b.metricas.pctDocs;
      if (ordenamientoResumen === "tareas") return a.metricas.pctTareas - b.metricas.pctTareas;
      return b.metricas.vencidas - a.metricas.vencidas;
    });
    const [yearStr, monthStr] = mesResumen.split("-");
    const nombreMesRaw = new Date(parseInt(yearStr), parseInt(monthStr)-1, 1).toLocaleString("es-MX", {month:"long", year:"numeric"});
    const nombreMes = nombreMesRaw.charAt(0).toUpperCase() + nombreMesRaw.slice(1);
    const colorPct = (pct: number) => pct >= 80 ? "#7BB97B" : pct >= 50 ? "#F4C075" : "#FCA5A5";
    const colorBg = (pct: number) => pct >= 80 ? "rgba(74,124,74,0.18)" : pct >= 50 ? "rgba(184,147,42,0.18)" : "rgba(220,38,38,0.18)";
    const colorBar = (pct: number) => pct >= 80 ? "#4A7C4A" : pct >= 50 ? "#B8932A" : "#DC2626";

    return (
      <div style={{minHeight:"100vh", background:T_LIGHT.canvas, fontFamily:fontSans}}>

        <div style={{background:T.navy, padding:"0 20px", height:58, display:"flex", alignItems:"center", gap:12, position:"sticky" as const, top:0, zIndex:50, borderBottom:"1px solid rgba(184,147,42,0.24)", boxShadow:"0 2px 16px rgba(22,36,71,0.12)"}}>
          <button onClick={()=>{setVista("lista"); setBusqueda("");}} style={{background:"rgba(255,255,255,0.08)", border:"1px solid rgba(255,255,255,0.15)", color:"white", borderRadius:8, padding:"5px 12px", cursor:"pointer", fontSize:12}}>← Volver</button>
          <span style={{color:"white", fontWeight:600, fontSize:14}}>Resumen general</span>
        </div>

        <div style={{maxWidth:ANCHO_CONTENIDO, margin:"0 auto", padding:isMobile?"16px":"24px"}}>

          <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", gap:12, flexWrap:"wrap" as const, marginBottom:16}}>
            <div>
              <h2 style={{fontFamily:fontSerif, fontSize:20, color:T_LIGHT.textInk, margin:"0 0 4px"}}>Resumen general del equipo</h2>
              <div style={{fontSize:12, color:T_LIGHT.textInkSoft}}>{activos.length} empleado{activos.length===1?"":"s"} activo{activos.length===1?"":"s"} · Periodo: {nombreMes}</div>
            </div>
            <div style={{display:"flex", gap:8, alignItems:"center", flexWrap:"wrap" as const}}>
              <input {...CAMPO_DE_PARAMETRO} type="month" value={mesResumen} onChange={(e)=>setMesResumen(e.target.value)} style={{background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.goldBorder}`, borderRadius:8, padding:"7px 10px", fontSize:12, color:T_LIGHT.gold, fontFamily:fontSans}}/>
              <button onClick={generarPDFResumen} disabled={generandoPDFResumen||activos.length===0} style={{padding:"8px 14px", borderRadius:10, background: generandoPDFResumen ? "rgba(184,147,42,0.5)" : "linear-gradient(135deg,#B8932A,#F4C075)", color:"#0F1D35", fontSize:12, fontWeight:700, cursor:generandoPDFResumen||activos.length===0?"not-allowed":"pointer", border:"none", fontFamily:fontSans}}>
                {generandoPDFResumen ? "Generando..." : "Generar PDF resumen"}
              </button>
            </div>
          </div>

          <div style={{display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(180px, 1fr))", gap:10, marginBottom:16}}>
            <div style={{padding:"12px 14px", background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, boxShadow:T_LIGHT.shadow, borderRadius:10, borderLeft:"3px solid #B8932A"}}>
              <p style={{margin:"0 0 4px", fontSize:10, textTransform:"uppercase" as const, letterSpacing:"0.5px", color:T_LIGHT.textInkMut, fontWeight:600}}>Empleados</p>
              <p style={{margin:0, fontSize:22, fontWeight:600, color:T_LIGHT.textInk, fontFamily:fontSerif}}>{kpis.totalEmpleados}</p>
            </div>
            <div style={{padding:"12px 14px", background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, boxShadow:T_LIGHT.shadow, borderRadius:10, borderLeft:"3px solid #B8932A"}}>
              <p style={{margin:"0 0 4px", fontSize:10, textTransform:"uppercase" as const, letterSpacing:"0.5px", color:T_LIGHT.textInkMut, fontWeight:600}}>Expediente capturado prom.</p>
              <p style={{margin:0, fontSize:22, fontWeight:600, color:colorPct(kpis.promDocs), fontFamily:fontSerif}}>{kpis.promDocsSobre===0 ? "—" : kpis.promDocs+"%"}</p>
              <p style={{margin:"4px 0 0", fontSize:9.5, color:T_LIGHT.textInkMut, opacity:0.85, lineHeight:1.35, fontStyle:"italic" as const}}>
                {kpis.promDocsSobre===0
                  ? "nadie tiene casillas marcadas todavía"
                  : `sobre ${kpis.promDocsSobre} de ${kpis.totalEmpleados} con algo capturado, según las casillas marcadas`}
              </p>
            </div>
            <div style={{padding:"12px 14px", background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, boxShadow:T_LIGHT.shadow, borderRadius:10, borderLeft:"3px solid #4A7C4A"}}>
              <p style={{margin:"0 0 4px", fontSize:10, textTransform:"uppercase" as const, letterSpacing:"0.5px", color:T_LIGHT.textInkMut, fontWeight:600}}>Desempeño actividades prom.</p>
              <p style={{margin:0, fontSize:22, fontWeight:600, color:colorPct(kpis.promTareas), fontFamily:fontSerif}}>{kpis.promTareas}%</p>
            </div>
            <div style={{padding:"12px 14px", background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, boxShadow:T_LIGHT.shadow, borderRadius:10, borderLeft:"3px solid #DC2626"}}>
              <p style={{margin:"0 0 4px", fontSize:10, textTransform:"uppercase" as const, letterSpacing:"0.5px", color:T_LIGHT.textInkMut, fontWeight:600}}>Actividades vencidas</p>
              <p style={{margin:0, fontSize:22, fontWeight:600, color:T_LIGHT.danger, fontFamily:fontSerif}}>{kpis.totalVencidas}</p>
            </div>
          </div>

          <div style={{display:"flex", gap:10, marginBottom:14, flexWrap:"wrap" as const}}>
            <input {...CAMPO_DE_PARAMETRO} type="text" placeholder="Buscar empleado por nombre o puesto..." value={busqueda} onChange={(e)=>setBusqueda(e.target.value)} style={{flex:1, minWidth:200, background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:8, padding:"8px 12px", fontSize:12, color:T_LIGHT.textInk, fontFamily:fontSans}}/>
            <select {...CAMPO_DE_PARAMETRO} value={ordenamientoResumen} onChange={(e)=>setOrdenamientoResumen(e.target.value as any)} style={{background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:8, padding:"8px 12px", fontSize:12, color:T_LIGHT.textInkSoft, fontFamily:fontSans, cursor:"pointer"}}>
              <option value="docs">Ordenar: Expediente capturado</option>
              <option value="tareas">Ordenar: Actividades del mes</option>
              <option value="vencidas">Ordenar: Más vencidas</option>
            </select>
          </div>

          {empleadosConMetricas.length === 0 ? (
            <div style={{background:T_LIGHT.cardLight, borderRadius:14, padding:"40px 24px", border:`1px solid ${T_LIGHT.borderCard}`, boxShadow:T_LIGHT.shadow, textAlign:"center" as const}}>
              <div style={{fontSize:14, color:T_LIGHT.textInkSoft, fontFamily:fontSerif, marginBottom:6}}>No hay empleados que coincidan</div>
              <div style={{fontSize:12, color:T_LIGHT.textInkMut}}>Ajusta la búsqueda.</div>
            </div>
          ) : (
            <div style={{background:T_LIGHT.cardLight, borderRadius:14, border:`1px solid ${T_LIGHT.borderCard}`, boxShadow:T_LIGHT.shadow, overflow:"hidden" as const}}>
              <div style={{display:"grid", gridTemplateColumns:"2.2fr 1fr 1fr 0.8fr 0.8fr 0.3fr", gap:12, padding:"10px 18px", background:T_LIGHT.goldSoft, borderBottom:`1px solid ${T_LIGHT.goldBorder}`, fontSize:10, textTransform:"uppercase" as const, letterSpacing:"0.5px", color:T_LIGHT.gold, fontWeight:700}}>
                <div>Empleado</div>
                <div>Docs</div>
                <div>Actividades (mes)</div>
                <div style={{textAlign:"center" as const}}>Pend.</div>
                <div style={{textAlign:"center" as const}}>Venc.</div>
                <div></div>
              </div>
              {empleadosConMetricas.map(({trabajador: t, metricas: m}) => (
                <div key={t.id} onClick={()=>{setSeleccionado(t); setVista("detalle"); setTabActiva("datos");}} style={{display:"grid", gridTemplateColumns:"2.2fr 1fr 1fr 0.8fr 0.8fr 0.3fr", gap:12, padding:"12px 18px", borderBottom:`1px solid ${T_LIGHT.border}`, alignItems:"center", cursor:"pointer"}}>
                  <div>
                    <p style={{margin:0, fontSize:13, fontWeight:500, color:T_LIGHT.textInk}}>{t.nombre}</p>
                    <p style={{margin:"2px 0 0", fontSize:11, color:T_LIGHT.textInkSoft}}>{t.puesto || "Sin puesto"}</p>
                  </div>
                  <div>
                    <div style={{display:"flex", alignItems:"center", gap:6}}>
                      <span style={{fontSize:12, fontWeight:600, color:colorPct(m.pctDocs), minWidth:34}}>{m.pctDocs}%</span>
                      <div style={{flex:1, height:4, background:colorBg(m.pctDocs), borderRadius:2, overflow:"hidden" as const}}>
                        <div style={{height:"100%", width:`${m.pctDocs}%`, background:colorBar(m.pctDocs)}}></div>
                      </div>
                    </div>
                  </div>
                  <div>
                    {m.tieneTareasEnMes ? (
                      <div style={{display:"flex", alignItems:"center", gap:6}}>
                        <span style={{fontSize:12, fontWeight:600, color:colorPct(m.pctTareas), minWidth:34}}>{m.pctTareas}%</span>
                        <div style={{flex:1, height:4, background:colorBg(m.pctTareas), borderRadius:2, overflow:"hidden" as const}}>
                          <div style={{height:"100%", width:`${m.pctTareas}%`, background:colorBar(m.pctTareas)}}></div>
                        </div>
                      </div>
                    ) : (
                      <div style={{display:"flex", alignItems:"center", gap:6}}>
                        <span style={{fontSize:12, color:T_LIGHT.textInkMut, minWidth:34}}>—</span>
                        <div style={{flex:1, height:4, background:T_LIGHT.canvasSoft, borderRadius:2}}></div>
                      </div>
                    )}
                  </div>
                  <div style={{textAlign:"center" as const, fontSize:12, color: m.pendientes > 0 ? T_LIGHT.textInkSoft : T_LIGHT.textInkMut}}>{m.pendientes}</div>
                  <div style={{textAlign:"center" as const}}>
                    {m.vencidas > 0 ? (
                      <span style={{background:"rgba(220,38,38,0.10)", color:T_LIGHT.danger, padding:"2px 6px", borderRadius:4, fontSize:11, fontWeight:700, border:"1px solid rgba(220,38,38,0.25)"}}>{m.vencidas}</span>
                    ) : (
                      <span style={{fontSize:12, color:T_LIGHT.textInkMut}}>0</span>
                    )}
                  </div>
                  <div style={{textAlign:"right" as const, color:T_LIGHT.textInkMut, fontSize:14}}>›</div>
                </div>
              ))}
            </div>
          )}

        </div>
      </div>
    );
  }
  
  // ── DETALLE ──
  if (vista === "detalle" && seleccionado) {
    const t = seleccionado;
    const antig = calcularAntiguedad(t.fechaIngreso);
    // LOS DÍAS DE VACACIONES SALEN DE LA MISMA FUNCIÓN QUE EL ACTA. Esta pantalla
    // tenía su propia escalera, y estaba un peldaño POR ENCIMA de la del módulo:
    // a los tres años cumplidos la ficha decía 18 días y el acta que se firma
    // decía 16, y a quien no llevaba ni un año la ficha le daba 12. Dos números
    // para el mismo derecho, a una pantalla de distancia.
    //
    // `calcularVacacionesEmpleado` es la que usan Obligaciones y el acta: cuenta
    // los años por calendario y aplica la tabla del módulo. Aquí se lee, no se
    // vuelve a calcular.
    const _vacFicha = calcularVacacionesEmpleado(t.fechaIngreso, new Date());
    const diasVac = Number(_vacFicha?.dias) || 0;
    const aniosCumpl = Math.max(0, Number(_vacFicha?.anios) || 0);
    const salMensual = salMensualDe(t);   // valor guardado exacto (o derivado del diario si es legado)
    const aguinaldo = t.salarioDiario * 15;
    const primaVac = t.salarioDiario * diasVac * 0.25;
    const alertas = calcularAlertas(t);
    const cambiarComplianceItem = async (itemKey: string, nuevoEstado: "ok"|"pendiente"|"na") => {
      const complianceActual = (t as any).compliance || {};
      const nuevoCompliance = {...complianceActual, [itemKey]: nuevoEstado};
      await updateDoc(doc(db,"trabajadores",t.id!), {compliance: nuevoCompliance});
      const actualizado = {...t, compliance: nuevoCompliance} as any;
      setSeleccionado(actualizado);
      setTrabajadores(prev => prev.map(x => x.id === t.id ? actualizado : x));
    };

    const generarReportePDF = async () => {
    setGenerandoPDF(true);
    try {
      const jsPDFClass = (window as any).jspdf?.jsPDF || (window as any).jsPDF;
      if (!jsPDFClass) {
        alert("jsPDF no está disponible. Recarga la página e intenta de nuevo.");
        setGenerandoPDF(false);
        return;
      }
      const pdf = new jsPDFClass({orientation:"portrait", unit:"mm", format:"a4"});

      const [yearStr, monthStr] = mesReporte.split("-");
      const year = parseInt(yearStr);
      const month = parseInt(monthStr);
      // EL MEMBRETE: la razón social del trabajador en el mes del reporte (11-oct-2026).
      const dpRep = datosPatronDeRazon(razonSocialDelPeriodo(t, instanteDeMexico(year, month - 1, new Date(year, month, 0).getDate(), 23, 59, 59, 999).getTime(), catalogos.razones), dpEmp);
      const nombreMesRaw = new Date(year, month-1, 1).toLocaleString("es-MX",{month:"long",year:"numeric"});
      const nombreMes = nombreMesRaw.charAt(0).toUpperCase() + nombreMesRaw.slice(1);

      // EL PDF NO CALCULA: PREGUNTA. Aquí vivía una tercera copia de la fórmula
      // plana, y por eso el papel decía 12% donde la pantalla decía 15%.
      const docsEmp = calcularCompliance((t as any).compliance);
      const pctDocs = docsEmp.porcentaje;
      // El mapa crudo sigue haciendo falta para PINTAR la lista de casillas una por
      // una más abajo. Eso no es calcular: es enseñar lo que hay marcado.
      const compliance = (t as any).compliance || {};

      // Actividades: MISMA fuente que la sección Actividades (colección `tareas`), pero
      // acotadas al MES DEL REPORTE (mesReporte) — reporte mensual, no histórico.
      const correoEmp = ((t as any).email || "").toLowerCase().trim();
      const hoy = new Date().toISOString().slice(0,10);
      const tareasReporte = tareasDelMes(tareasTrab, mesReporte, mesActualYM());
      const susTareas = tareasReporte
        .filter((tar:any) => (tar.trabajadorEmail || "").toLowerCase() === correoEmp)
        .sort((a:any,b:any) => (a.fechaLimite||"9999-99-99").localeCompare(b.fechaLimite||"9999-99-99") || ((a.creadoEn?.toMillis?.()||0) - (b.creadoEn?.toMillis?.()||0)));
      const ctRep = calcularCumplimientoTareas(tareasReporte, correoEmp);
      const pctTareas = ctRep.porcentaje;
      const fechaGen = new Date().toLocaleDateString("es-MX",{day:"numeric",month:"short",year:"numeric"});

      pdf.setFillColor(15, 29, 53);
      pdf.rect(0, 0, 210, 6, "F");
      // MEMBRETE DEL PATRÓN, no del despacho. Este reporte se le entrega al
      // empleado o se archiva en su expediente: lo emite el patrón.
      // 130 mm, no 105: el bloque de la derecha —titulo, periodo, generado— ocupa
      // unos 40 mm alineado a la derecha, asi que el domicilio tiene mas sitio del
      // que se le estaba dando, y por eso partia dejando "C.P. 20120" suelto.
      membreteDelPatronJsPDF(pdf, 20, 13, dpRep, 130);
      pdf.setFont("helvetica","bold"); pdf.setFontSize(9.5); pdf.setTextColor(60, 60, 60);
      pdf.text("Reporte individual del empleado", 190, 13, {align:"right"});
      pdf.setFont("helvetica","normal"); pdf.setFontSize(9); pdf.setTextColor(90, 90, 90);
      pdf.text(`Periodo: ${nombreMes}`, 190, 18, {align:"right"});
      pdf.text(`Generado: ${fechaGen}`, 190, 23, {align:"right"});
      pdf.setDrawColor(184, 147, 42); pdf.setLineWidth(0.5);
      pdf.line(20, 27, 190, 27);

      pdf.setFont("helvetica","bold"); pdf.setFontSize(13); pdf.setTextColor(20, 20, 20);
      pdf.text(t.nombre || "Sin nombre", 20, 36);
      pdf.setFont("helvetica","normal"); pdf.setFontSize(10); pdf.setTextColor(110, 110, 110);
      pdf.text(`${t.puesto || "Sin puesto"}${t.fechaIngreso ? " - Ingreso " + t.fechaIngreso : ""}`, 20, 42);

      pdf.setFillColor(248, 244, 230); pdf.setDrawColor(184, 147, 42); pdf.setLineWidth(0.3);
      pdf.roundedRect(20, 50, 80, 28, 1.5, 1.5, "FD");
      pdf.setFont("helvetica","normal"); pdf.setFontSize(7); pdf.setTextColor(107, 85, 16);
      pdf.text("EXPEDIENTE CAPTURADO", 25, 56);
      pdf.setFont("helvetica","bold"); pdf.setFontSize(20); pdf.setTextColor(20, 20, 20);
      pdf.text(`${pctDocs}%`, 25, 67);
      pdf.setFillColor(220, 213, 195); pdf.rect(25, 70, 70, 1.5, "F");
      pdf.setFillColor(184, 147, 42); pdf.rect(25, 70, 70 * (pctDocs/100), 1.5, "F");
      pdf.setFont("helvetica","normal"); pdf.setFontSize(8); pdf.setTextColor(90, 90, 90);
      // El MISMO pie de cifra que la ficha en pantalla: obligatorios marcados sobre
      // obligatorios que aplican. "N de M documentos" contaba casillas planas y ya
      // no corresponde a un porcentaje ponderado.
      pdf.text(`${docsEmp.obligatoriosCumplidos} de ${docsEmp.totalObligatorios} obligatorios marcados`, 25, 75);
      // La misma aclaracion que en el resumen, y por la misma razon: este reporte
      // se le entrega al empleado o se archiva. Va bajo las DOS cajas porque es la
      // de la izquierda la que lleva el porcentaje que se puede malinterpretar.
      // En vertical no cabe de un renglon: `splitTextToSize` lo parte con la
      // fuente real en vez de fiarse de un calculo a ojo, y la seccion siguiente
      // no empieza hasta y=90.
      pdf.setFontSize(7); pdf.setTextColor(130, 130, 130);
      pdf.text(pdf.splitTextToSize(NOTA_EXPEDIENTE_CAPTURADO, 170), 20, 82);

      pdf.setFillColor(244, 248, 244); pdf.setDrawColor(74, 124, 74);
      pdf.roundedRect(110, 50, 80, 28, 1.5, 1.5, "FD");
      pdf.setFont("helvetica","normal"); pdf.setFontSize(7); pdf.setTextColor(44, 74, 44);
      pdf.text("DESEMPENO EN ACTIVIDADES", 115, 56);
      pdf.setFont("helvetica","bold"); pdf.setFontSize(20); pdf.setTextColor(20, 20, 20);
      pdf.text(`${pctTareas}%`, 115, 67);
      pdf.setFillColor(216, 230, 216); pdf.rect(115, 70, 70, 1.5, "F");
      pdf.setFillColor(74, 124, 74); pdf.rect(115, 70, 70 * (pctTareas/100), 1.5, "F");
      pdf.setFont("helvetica","normal"); pdf.setFontSize(8); pdf.setTextColor(90, 90, 90);
      pdf.text(`${ctRep.confirmadas} de ${ctRep.total} actividades confirmadas`, 115, 75);

      let yPos = 90;
      pdf.setFont("helvetica","bold"); pdf.setFontSize(11); pdf.setTextColor(184, 147, 42);
      pdf.text("DOCUMENTOS LEGALES", 20, yPos);
      pdf.setDrawColor(220, 220, 220); pdf.setLineWidth(0.3);
      pdf.line(20, yPos+1.5, 190, yPos+1.5);
      yPos += 6;
      pdf.setFont("helvetica","normal"); pdf.setFontSize(9);

      COMPLIANCE_ITEMS.forEach((item:any) => {
        if (yPos > 270) { pdf.addPage(); yPos = 25; }
        const estado = compliance[item.key] || "pendiente";
        if (estado === "ok") {
          pdf.setFillColor(5, 150, 105);
          pdf.circle(22, yPos-1, 1.3, "F");
        } else if (estado === "na") {
          pdf.setDrawColor(150, 150, 150); pdf.setLineWidth(0.6);
          pdf.line(20.5, yPos-1, 23.5, yPos-1);
        } else {
          pdf.setDrawColor(184, 147, 42); pdf.setLineWidth(0.4);
          pdf.circle(22, yPos-1, 1.3, "S");
        }
        pdf.setTextColor(20, 20, 20); pdf.setFontSize(9);
        pdf.text((item.label || "").replace(/≤/g, "<="), 27, yPos);
        pdf.setTextColor(140, 140, 140); pdf.setFontSize(8);
        pdf.text(item.baseLegal || "", 190, yPos, {align:"right"});
        yPos += 5;
      });

      yPos += 4;
      if (yPos > 250) { pdf.addPage(); yPos = 25; }
      pdf.setFont("helvetica","bold"); pdf.setFontSize(11); pdf.setTextColor(184, 147, 42);
      pdf.text("ACTIVIDADES ASIGNADAS", 20, yPos);
      pdf.setDrawColor(220, 220, 220); pdf.setLineWidth(0.3);
      pdf.line(20, yPos+1.5, 190, yPos+1.5);
      yPos += 6;

      if (susTareas.length === 0) {
        pdf.setFont("helvetica","italic"); pdf.setFontSize(10); pdf.setTextColor(136, 136, 136);
        pdf.text("Sin actividades asignadas.", 20, yPos);
      } else {
        susTareas.forEach((tar:any) => {
          if (yPos > 265) { pdf.addPage(); yPos = 25; }
          const conf = !!tar.confirmadaPorPatron;
          const marc = !!tar.marcadaPorTrabajador;
          const vencida = !conf && tar.fechaLimite && tar.fechaLimite < hoy;
          const estadoLabel = conf ? "CONFIRMADA" : (marc ? "POR CONFIRMAR" : (vencida ? "VENCIDA" : "PENDIENTE"));
          let bgR=245, bgG=245, bgB=245, txR=110, txG=110, txB=110;
          if (conf) { bgR=230; bgG=244; bgB=234; txR=27; txG=94; txB=32; }
          else if (marc) { bgR=251; bgG=241; bgB=218; txR=107; txG=85; txB=16; }
          else if (vencida) { bgR=252; bgG=232; bgB=232; txR=139; txG=20; txB=20; }
          pdf.setTextColor(20, 20, 20); pdf.setFont("helvetica","normal"); pdf.setFontSize(9.5);
          pdf.text(tar.titulo || tar.descripcion || "Sin titulo", 20, yPos);
          const badgeW = 28, badgeX = 190 - badgeW;
          pdf.setFillColor(bgR, bgG, bgB);
          pdf.roundedRect(badgeX, yPos-3.5, badgeW, 5, 0.8, 0.8, "F");
          pdf.setFont("helvetica","bold"); pdf.setFontSize(7); pdf.setTextColor(txR, txG, txB);
          pdf.text(estadoLabel, badgeX + badgeW/2, yPos, {align:"center"});
          pdf.setFont("helvetica","normal"); pdf.setFontSize(7.5); pdf.setTextColor(130, 130, 130);
          let fechas = tar.fechaLimite ? `Limite ${tar.fechaLimite}` : "Sin fecha limite";
          const dConf = tar.fechaConfirmada?.toDate?.();
          if (dConf) fechas += ` - Confirmada ${dConf.toLocaleDateString("es-MX")}`;
          pdf.text(fechas, 20, yPos+4);
          yPos += 9;
        });
      }

      // LAS NOTAS DE LA RAZÓN SOCIAL DEL MES (12-oct-2026), como en la bitácora y el
      // registro mensual: el cambio dentro del mes y la de efecto desde el inicio.
      const notasRep = avisosDeRazonSocial(t, catalogos.razones, instanteDeMexico(year, month - 1, 1, 0, 0, 0, 0).getTime(),
        instanteDeMexico(year, month - 1, new Date(year, month, 0).getDate(), 23, 59, 59, 999).getTime());
      if (notasRep.length) {
        yPos += 4;
        if (yPos > 250) { pdf.addPage(); yPos = 25; }
        pdf.setFont("helvetica","bold"); pdf.setFontSize(11); pdf.setTextColor(184, 147, 42);
        pdf.text("NOTAS", 20, yPos);
        pdf.setDrawColor(220, 220, 220); pdf.setLineWidth(0.3);
        pdf.line(20, yPos+1.5, 190, yPos+1.5);
        yPos += 6;
        pdf.setFont("helvetica","normal"); pdf.setFontSize(8.5); pdf.setTextColor(70, 70, 70);
        notasRep.forEach((n:string) => {
          const lineas = pdf.splitTextToSize(n, 170);
          if (yPos + lineas.length * 4 > 280) { pdf.addPage(); yPos = 25; }
          pdf.text(lineas, 20, yPos);
          yPos += lineas.length * 4 + 2;
        });
      }

      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        pdf.setDrawColor(220, 220, 220); pdf.setLineWidth(0.3);
        pdf.line(20, 285, 190, 285);
        pdf.setFont("helvetica","normal"); pdf.setFontSize(7); pdf.setTextColor(130, 130, 130);
        pintarPieDelPatronJsPDF(pdf, 20, 290, 145, dpRep, fechaHoraLargaAxis());
        pdf.text(`${i} / ${totalPages}`, 190, 290, {align:"right"});
      }

      const nombreLimpio = (t.nombre || "Empleado").replace(/[^a-zA-Z0-9]/g, "_");
      pdf.save(`Reporte_${nombreLimpio}_${mesReporte}.pdf`);
    } catch (e) {
      console.error(e);
      alert("Error al generar el PDF. Revisa la consola del navegador (F12).");
    }
    setGenerandoPDF(false);
  };

    // Abre el MISMO formulario "Editar" cargando la ficha actual (una sola ruta de
    // captura/validación/persistencia). Reutilizado por el botón superior, la acción
    // "Completar datos" y los recuadros pendientes. `seleccionado` ya es este empleado.
    const abrirEditarFicha = () => {
      setForm({nombre:t.nombre,puesto:t.puesto,departamento:t.departamento,tipoContrato:t.tipoContrato,salarioDiario:salDiarioDe(t),salarioMensual:salMensualDe(t),salarioBase:(t.salarioBase||"mensual"),fechaIngreso:t.fechaIngreso,fechaVencimiento:t.fechaVencimiento||"",telefono:t.telefono||"",email:t.email||"",imss:t.imss||"",curp:t.curp||"",rfc:t.rfc||"",direccion:(t as any).direccion||"",status:t.status,notas:t.notas||""});
      setVista("form");
    };

    return (
      <>
      <div style={{minHeight:"100vh", background:T_LIGHT.canvas, fontFamily:fontSans}}>
        <div style={{background:T.navy, padding:"0 20px", height:58, display:"flex", alignItems:"center", gap:12, position:"sticky" as const, top:0, zIndex:100, borderBottom:"1px solid rgba(184,147,42,0.24)", boxShadow:"0 2px 16px rgba(22,36,71,0.12)"}}>
          <button onClick={()=>{setVista("lista");setSeleccionado(null);setTabActiva("datos");}} style={{background:"rgba(255,255,255,0.08)", border:"1px solid rgba(255,255,255,0.15)", color:"white", borderRadius:8, padding:"5px 12px", cursor:"pointer", fontSize:12}}>← Lista</button>
          <span style={{color:"white", fontWeight:600, fontSize:14, display:"inline-flex", alignItems:"center", gap:8}}><AxisIcon name="user_single" size={14} tone="gold" withBackdrop={false} strokeWidth={2}/>{t.nombre}</span>
          <div style={{marginLeft:"auto", display:"flex", gap:8}}>
            <button onClick={abrirEditarFicha}
              style={{background:"rgba(255,255,255,0.08)", border:"1px solid rgba(255,255,255,0.15)", color:"white", borderRadius:8, padding:"5px 12px", cursor:"pointer", fontSize:12}}>Editar ficha</button>
            {t.status==="activo" && <button onClick={()=>onIrNomina(t)} style={{background:"rgba(5,150,105,0.2)", border:"1px solid rgba(5,150,105,0.3)", color:"#6EE7B7", borderRadius:8, padding:"5px 12px", cursor:"pointer", fontSize:12, display:"inline-flex", alignItems:"center", gap:6}}><AxisIcon name="money" size={12} tone="gold" withBackdrop={false} strokeWidth={2}/>Generar recibo de nómina</button>}
            {t.status==="activo" && <button onClick={()=>darDeBaja(t)} style={{background:"rgba(220,38,38,0.2)", border:"1px solid rgba(220,38,38,0.3)", color:"#FCA5A5", borderRadius:8, padding:"5px 12px", cursor:"pointer", fontSize:12}}>Dar de baja</button>}
            {t.status==="baja" && <button onClick={()=>reactivarTrabajador(t)} title="Reingreso: vuelve a contar como activo y reactiva su cuenta del portal" style={{background:"rgba(5,150,105,0.22)", border:"1px solid rgba(5,150,105,0.35)", color:"#6EE7B7", borderRadius:8, padding:"5px 12px", cursor:"pointer", fontSize:12}}>↻ Reactivar</button>}
          </div>
        </div>

        <div style={{maxWidth:ANCHO_CONTENIDO, margin:"0 auto", padding:isMobile?"16px":"28px 24px"}}>
          {/* Alertas (siempre visibles, arriba de las pestañas) */}
          {alertas.length > 0 && (
            <div style={{background:"rgba(234,179,8,0.08)", border:"1px solid rgba(234,179,8,0.25)", borderRadius:12, padding:"12px 16px", marginBottom:16}}>
              {alertas.map((a,i) => <div key={i} style={{fontSize:13, color:"#92400E", fontWeight:600, marginBottom:i<alertas.length-1?6:0}}>{a}</div>)}
            </div>
          )}

          {/* Vínculo con la sección Actividades — solo si el empleado tiene cuenta.
              Muestra % de cumplimiento (confirmadas/total) y botón "Ver actividades". */}
          {(() => {
            const email = (seleccionado?.email||"").toLowerCase().trim();
            if (!email) return null;
            // SOLO la colección. El término `tieneAcceso===true` que iba aquí no
            // podía esconder a nadie —era un O— pero sí inventar: una ficha con la
            // bandera puesta y la cuenta ya suspendida seguía enseñando el panel.
            const hasCuenta = (cuentasTrab||[]).some((c:any)=>(c.email||"").toLowerCase()===email && c.activo!==false);
            if (!hasCuenta) return null;
            // % de actividades = SOLO mes actual (consistente con la lista de Empleados).
            const ymAct = mesActualYM();
            const tareasMesAct = tareasDelMes(tareasTrab, ymAct, ymAct);
            const suyas = tareasMesAct.filter((t:any)=>(t.trabajadorEmail||"").toLowerCase()===email);
            const ctB = calcularCumplimientoTareas(tareasMesAct, email);
            const total = ctB.total;
            const confirmadas = ctB.confirmadas;
            const porConfirmar = suyas.filter((t:any)=>t.marcadaPorTrabajador && !t.confirmadaPorPatron).length;
            const pct = ctB.porcentaje;
            const col = total===0 ? "#9A9AAA" : pct>=80 ? "#059669" : pct>=40 ? "#B8932A" : "#DC2626";
            // Checador (indicador APARTE, NO se mezcla con el % de actividades) — filtro en JS.
            const susChecadas = checadasTrab
              .filter((c:any)=>(c.trabajadorEmail||"").toLowerCase()===email)
              .sort((a:any,b:any)=>(b.timestamp?.toMillis?.()||0)-(a.timestamp?.toMillis?.()||0));
            const ult = susChecadas[0];
            const ultD = ult?.timestamp?.toDate?.();
            // `labelChecada` y no un ternario: aquí también un regreso de comer
            // se mostraba como "Salida", en la propia ficha de la persona.
            const ultTxt = ult ? `${labelChecada(ult.tipo)} · ${ultD?ultD.toLocaleString("es-MX",{day:"2-digit",month:"short",hour:"2-digit",minute:"2-digit"}):"—"}` : "Sin checadas aún";
            const fL = (d:Date)=>`${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`;
            const hoyL = fL(new Date());
            const checoHoy = susChecadas.some((c:any)=>{ const d=c.timestamp?.toDate?.(); return d && fL(d)===hoyL && c.tipo==="entrada"; });
            return (
              <div style={{background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderLeft:"4px solid #236478", borderRadius:12, padding:"12px 16px", marginBottom:14, display:"flex", alignItems:"center", justifyContent:"space-between", gap:12, flexWrap:"wrap" as const, boxShadow:T_LIGHT.shadow}}>
                <div style={{flex:1, minWidth:200}}>
                  <div style={{fontSize:12, fontWeight:700, color:T_LIGHT.textInk, marginBottom:5}}>Cuenta de trabajador · Actividades</div>
                  <div style={{height:8, background:"rgba(0,0,0,0.06)", borderRadius:4, overflow:"hidden", maxWidth:260, marginBottom:5}}>
                    <div style={{height:"100%", width:`${pct}%`, background:col, transition:"width 0.5s ease"}}/>
                  </div>
                  <div style={{fontSize:11, color:T_LIGHT.textInkSoft}}>
                    {total===0 ? "Sin actividades asignadas todavía" : `${confirmadas}/${total} confirmadas (${pct}%)${porConfirmar?` · ${porConfirmar} por confirmar`:""}`}
                  </div>
                  {/* Indicador de CHECADOR (aparte del % de actividades) */}
                  <div style={{marginTop:8, paddingTop:8, borderTop:`1px solid ${T_LIGHT.border}`, fontSize:11, color:T_LIGHT.textInkSoft, display:"flex", alignItems:"center", gap:8, flexWrap:"wrap" as const}}>
                    <span style={{fontWeight:700, color:T_LIGHT.textInk}}>Checador:</span>
                    <span>{ultTxt}</span>
                    <span style={{fontSize:10, fontWeight:700, padding:"2px 8px", borderRadius:999, background:checoHoy?"rgba(5,150,105,0.10)":"rgba(154,154,170,0.14)", color:checoHoy?"#059669":"#6B7280", border:`1px solid ${checoHoy?"rgba(5,150,105,0.30)":"rgba(154,154,170,0.4)"}`}}>{checoHoy?"Checó hoy":"Sin checada hoy"}</span>
                  </div>
                </div>
                <button onClick={()=>setTabActiva("tareas")} style={{background:"#236478", border:"none", color:"white", borderRadius:8, padding:"8px 14px", cursor:"pointer", fontSize:12, fontWeight:700, fontFamily:fontSans, flexShrink:0}}>
                  Ver actividades →
                </button>
              </div>
            );
          })()}

          {/* Reporte mensual completo (PDF) — desde la ficha del empleado */}
          <div style={{background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:12, padding:"14px 16px", marginBottom:14, boxShadow:T_LIGHT.shadow}}>
            <div style={{fontSize:11, color:T_LIGHT.textInkMut, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"1px", marginBottom:9}}>Registro mensual</div>
            <ReporteMensualBoton empleado={seleccionado} checadas={checadasTrab} correcciones={correccionesTrab} tareas={tareasTrab} accidentes={null} currentUser={currentUser} tema="light" fontSans={fontSans} />
          </div>

          {/* Barra de pestañas */}
          <div style={{display:"flex", gap:4, marginBottom:16, overflowX:"auto" as const, borderBottom:`1px solid ${T_LIGHT.border}`}}>
            {[
              {key:"datos" as const, label:"Datos", icon:"user_single"},
              {key:"tareas" as const, label:"Actividades", icon:"clipboard"},
              {key:"checador" as const, label:"Checador", icon:"clipboard"},
              {key:"acceso" as const, label:"Acceso", icon:"user_single"},
              {key:"cumplimiento" as const, label:"Expediente", icon:"scale_simple"},
              {key:"documentos" as const, label:"Documentos", icon:"document"},
              {key:"contratos" as const, label:"Contratos", icon:"document"},
              {key:"nomina" as const, label:"Nómina", icon:"money"},
            ].map(tab => (
              <button key={tab.key} onClick={()=>setTabActiva(tab.key)}
                style={{
                  display:"inline-flex", alignItems:"center", gap:6,
                  padding:"10px 14px",
                  border:"none",
                  borderBottom: tabActiva===tab.key ? "2px solid #B8932A" : "2px solid transparent",
                  background: tabActiva===tab.key ? T_LIGHT.goldSoft : "transparent",
                  color: tabActiva===tab.key ? T_LIGHT.gold : T_LIGHT.textInkSoft,
                  fontSize:13, fontWeight: tabActiva===tab.key ? 700 : 600,
                  cursor:"pointer", whiteSpace:"nowrap" as const, fontFamily:fontSans,
                  marginBottom:-1,
                }}>
                <AxisIcon name={tab.icon} size={13} color={tabActiva===tab.key?T_LIGHT.gold:T_LIGHT.textInkMut} withBackdrop={false} strokeWidth={2.5}/>
                {tab.label}
              </button>
            ))}
            <button onClick={()=>{ setMesReporte(mesTareasSel || mesActualYM()); setMostrarModalReporte(true); }} style={{marginLeft:"auto", padding:"8px 14px", borderRadius:10, background:"linear-gradient(135deg,#B8932A,#9A7820)", color:"#0F1D35", border:"none", cursor:"pointer", fontSize:12, fontWeight:700, fontFamily:fontSans, letterSpacing:"0.3px", whiteSpace:"nowrap" as const, alignSelf:"center"}}>
          Generar reporte
        </button>
          </div>

          {/* ─── PESTAÑA: CHECADOR ─── */}
          {tabActiva === "checador" && (() => {
            const email = (seleccionado?.email||"").toLowerCase().trim();
            const deEl = (x:any)=> (x.trabajadorEmail||"").toLowerCase()===email;
            // LA VISTA EFECTIVA (src/logica/correcciones.js): la misma que califican
            // la bitácora, el registro mensual y la pantalla del trabajador.
            const vista = vistaEfectiva({checadas: checadasTrab.filter(deEl), correcciones: correccionesTrab.filter(deEl), noConformidades: noConformesTrab.filter(deEl)});
            const suyas = vista.checadasQueCuentan;
            return (
              <div>
                {/* Horario personalizado del empleado (misma fuente que el móvil) */}
                <div style={{marginBottom:16}}>
                  {(()=>{
                    // SU CUENTA, ¿VE ESTA FICHA? El trabajador solo puede leer la
                    // ficha que lleva su cuentaUid (reglas de `trabajadores`). Si
                    // esta no lo lleva, en su checador se mide con el horario
                    // GENERAL aunque aquí tenga uno propio: dos horarios para la
                    // misma persona. Se dice, y se ofrece vincularla.
                    const em = (seleccionado?.email||"").toLowerCase().trim();
                    const cta = (cuentasTrab||[]).find((c:any)=>(c.email||"").toLowerCase().trim()===em && c.uid);
                    if (!em || !cta || seleccionado?.cuentaUid === cta.uid) return null;
                    const otra = otraFichaConLaCuenta(trabajadores, cta.uid, seleccionado?.id);
                    return (
                      <div style={{background:"rgba(184,147,42,0.10)", border:"1px solid rgba(184,147,42,0.35)", borderRadius:10, padding:"10px 12px", marginBottom:10, fontSize:12, color:"#7A5F12", lineHeight:1.5}}>
                        {otra
                          ? <>{textoCuentaEnOtraFicha(otra)}</>
                          : <>Su cuenta del portal no está vinculada a esta ficha: en su checador se mide con el horario general de la empresa, no con el de esta ficha.{" "}
                              <button onClick={()=>vincularFichaConCuenta(cta)} disabled={vinculandoFicha}
                                style={{marginLeft:4, fontSize:12, fontWeight:700, padding:"4px 10px", borderRadius:7, border:"1px solid rgba(184,147,42,0.5)", background:"white", color:"#7A5F12", cursor:vinculandoFicha?"wait":"pointer"}}>
                                {vinculandoFicha ? "Vinculando…" : "Vincular ficha y cuenta"}
                              </button></>}
                        {vincularError && <div style={{marginTop:6, color:"#B91C1C"}}>{vincularError}</div>}
                      </div>
                    );
                  })()}
                  <HorarioLaboralEditor modo="empleado" currentUser={currentUser} trabajador={seleccionado} tema="light" fontSans={fontSans} fontSerif={fontSerif}
                    onGuardado={(_h, propio, historial)=>{ if (propio !== undefined) setHorarioFichaLocal(propio); if (historial) setHistorialFichaLocal(historial); }} />
                </div>
                {/* SU SEDE DE TRABAJO Y SU RAZÓN SOCIAL (11-oct-2026), con historial. */}
                {(()=>{
                  const em = (seleccionado?.email||"").toLowerCase().trim();
                  const cta = em ? (cuentasTrab||[]).find((c:any)=>(c.email||"").toLowerCase().trim()===em && c.uid) : null;
                  // La misma condición que la pestaña Checador: si la cuenta ya está en
                  // otra ficha del patrón, no hay botón; se dice (13-oct-2026).
                  const otraCta = cta ? otraFichaConLaCuenta(trabajadores, cta.uid, seleccionado?.id) : null;
                  return (
                    <SedeYRazonDeLaFicha ficha={seleccionado} catalogos={catalogos} currentUser={currentUser}
                      cuentaParaVincular={(otraCta ? null : cta) || null} cuentaEnOtraFicha={otraCta} errorVincular={vincularError}
                      onVincular={()=>{ if (cta && !otraCta) vincularFichaConCuenta(cta); }} vinculando={vinculandoFicha}
                      onCambio={async ()=>{
                        try { const s = await getDoc(doc(db,"trabajadores",seleccionado.id)); if (s.exists()) setSeleccionado({id:s.id, ...(s.data() as any)}); } catch(e){ console.warn("ficha al día:", e); }
                        cargar();
                      }} fontSans={fontSans}/>
                  );
                })()}
                {/* Resumen de asistencia (últimos 14 días) — derivado en JS. Un día
                    laborable sin checada de ENTRADA es "Sin registro", nunca "falta". */}
                {(()=>{
                  // MISMO clasificador que los dos documentos y el panel de equipo.
                  // Este bloque tenía su propio recorrido de lunes a viernes, que era
                  // justo lo que dejaba fuera a quien trabaja sábados.
                  const he:any = horarioVigenteFicha;
                  // CATORCE DÍAS CON HOY INCLUIDO: los mismos que dice el título y que
                  // cuentan los contadores. Restar 14 daba quince.
                  const hoy0 = new Date();
                  const desde = new Date(hoy0.getFullYear(), hoy0.getMonth(), hoy0.getDate() - (DIAS_RESUMEN_FICHA - 1));
                  const rec = recorrerDiasChecador({
                    desde, hasta: hoy0, hoy: hoy0, horario: he, horarioGeneral: horarioGeneralEmpresa,
                    checadas: suyas, email: (seleccionado?.email||"").toLowerCase().trim(),
                    horarioEn: horarioFichaEn,
                    // Su ingreso y su baja, de la ficha: antes y después no se cuenta.
                    periodosLaborales: periodosLaboralesDe(seleccionado),
                    // Cada día sin checada, con la base del módulo (vacaciones, art. 74).
                    debeChecarEnDia: debeChecarEnDiaDe(fichaHorario, horarioGeneralEmpresa, historialGeneralEmpresa, vacacionesEmpresa),
                  });
                  if (!he || !he.entrada) {
                    return <div style={{background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:12, padding:"12px 14px", marginBottom:12, fontSize:12.5, color:T_LIGHT.textInkSoft, lineHeight:1.5}}>Configura el horario de este empleado para ver el resumen de asistencia.</div>;
                  }
                  const problemas = rec.dias.filter((x:any)=> x.est.estado==="retardo" || x.est.clasif==="retardo" || x.est.clasif==="tardia" || x.est.estado==="sin_registro").reverse();
                  const chip = (color:string, label:string, n:number)=>(<span style={{display:"inline-flex", alignItems:"center", gap:6, fontSize:12, fontWeight:700, color}}><span style={{width:8, height:8, borderRadius:"50%", background:color, display:"inline-block"}}/>{label}: {n}</span>);
                  return (
                    <div style={{background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:12, padding:"12px 14px", marginBottom:14, boxShadow:T_LIGHT.shadow}}>
                      <div style={{fontFamily:fontSerif, fontSize:14, fontWeight:700, color:T_LIGHT.textInk, marginBottom:8}}>Resumen de asistencia · últimos {DIAS_RESUMEN_FICHA} días</div>
                      <div style={{display:"flex", gap:16, flexWrap:"wrap" as const, marginBottom:problemas.length?10:0}}>
                        {chip("#059669","A tiempo",rec.aTiempo)}
                        {chip("#B8932A","Retardo",rec.retardos)}
                        {chip("#B45309","Entrada tardía",rec.tardias)}
                        {rec.hayLaborables && chip("#5B6784","Sin registro",rec.sinRegistro)}
                      </div>
                      {!rec.hayLaborables && (
                        <div style={{fontSize:11.5, color:T_LIGHT.textInkMut, lineHeight:1.5, marginBottom:problemas.length?10:0}}>
                          Sin días laborables configurados no se puede saber qué días debía trabajar, así que no se cuentan días sin registro.
                        </div>
                      )}
                      {rec.avisosRelacion.map((a:string)=>(
                        <div key={a} style={{fontSize:11.5, color:T_LIGHT.textInkMut, lineHeight:1.5, marginBottom:problemas.length?10:0}}>{a}</div>
                      ))}
                      {problemas.length>0 && (
                        <div style={{display:"flex", flexDirection:"column" as const, gap:4, borderTop:`1px solid ${T_LIGHT.border}`, paddingTop:8}}>
                          {/* LA LISTA ENSEÑA SOLO LOS DÍAS CON INCIDENCIA, y lo dice; si son
                              más de RENGLONES_RESUMEN_FICHA, "Ver todos" enseña el resto.
                              Antes cortaba en 8 sin decirlo, y los contadores no cuadraban. */}
                          <div style={{fontSize:11, color:T_LIGHT.textInkMut, marginBottom:2}}>{TEXTO_SOLO_INCIDENCIAS}</div>
                          {(verTodoResumen ? problemas : problemas.slice(0, RENGLONES_RESUMEN_FICHA)).map((x:any,i:number)=>{
                            const et = etiquetaDiaChecador(x.est);
                            const col = x.est.estado==="sin_registro" ? "#5B6784" : x.est.clasif==="tardia" ? "#B45309" : "#B8932A";
                            return (
                            <div key={i}>
                            <div style={{display:"flex", justifyContent:"space-between", fontSize:12, color:T_LIGHT.textInkSoft}}>
                              <span style={{textTransform:"capitalize" as const}}>{x.fecha.toLocaleDateString("es-MX",{weekday:"long", day:"numeric", month:"short"})}</span>
                              <span style={{fontWeight:700, color:col}}>{et}</span>
                            </div>
                            {x.notaRelacion && <div style={{fontSize:11, color:T_LIGHT.textInkMut}}>{x.notaRelacion}</div>}
                            </div>
                          ); })}
                          {problemas.length > RENGLONES_RESUMEN_FICHA && (
                            <button type="button" onClick={()=>setVerTodoResumen((v)=>!v)}
                              style={{alignSelf:"flex-start" as const, marginTop:4, background:"none", border:"none", padding:0, color:T_LIGHT.gold, cursor:"pointer", fontFamily:fontSans, fontSize:12, fontWeight:700, textDecoration:"underline"}}>
                              {verTodoResumen ? "Ver menos" : `Ver todos (${problemas.length})`}
                            </button>
                          )}
                        </div>
                      )}
                    </div>
                  );
                })()}
                <div style={{background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:12, padding:"14px 16px", marginBottom:14, boxShadow:T_LIGHT.shadow}}>
                  <div style={{fontSize:11, color:T_LIGHT.textInkMut, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"1px", marginBottom:9}}>Bitácora de asistencia</div>
                  <BitacoraBoton empleado={fichaHorario} checadas={checadasTrab} correcciones={correccionesTrab} currentUser={currentUser} tema="light" fontSans={fontSans} />
                </div>
                {/* LA LISTA CON SUS CORRECCIONES (fase 2b): anular, cambiar tipo, agregar
                    un registro faltante y revertir, cada una anotada. */}
                <ChecadasConCorrecciones vista={vista} horarioEn={horarioFichaEn} currentUser={currentUser} trabajadorEmail={email} ficha={seleccionado}
                  onCambio={recargarCorrecciones} fontSans={fontSans}/>
              </div>
            );
          })()}

          {/* ─── PESTAÑA: DATOS ─── */}
          {tabActiva === "datos" && (
            <>
              {/* Header del trabajador */}
              <div style={{background:T_LIGHT.cardLight, borderRadius:16, padding:"24px", marginBottom:14, border:`1px solid ${T_LIGHT.borderCard}`, boxShadow:T_LIGHT.shadow}}>
                <div style={{display:"flex", alignItems:"center", gap:16, marginBottom:16}}>
                  <div style={{width:60, height:60, background:"linear-gradient(135deg,#0EA5E9,#0284C7)", borderRadius:16, display:"flex", alignItems:"center", justifyContent:"center", fontSize:24, color:"white", fontWeight:700, fontFamily:fontSerif}}>
                    {t.nombre.charAt(0).toUpperCase()}
                  </div>
                  <div>
                    <h2 style={{fontFamily:fontSerif, fontSize:20, color:T_LIGHT.textInk, margin:"0 0 4px"}}>{t.nombre}</h2>
                    <div style={{fontSize:13, color:T_LIGHT.textInkSoft}}>{t.puesto}{t.departamento?` · ${t.departamento}`:""}</div>
                    <span style={{fontSize:10, fontWeight:700, padding:"3px 10px", borderRadius:20, marginTop:6, display:"inline-block",
                      background:t.status==="activo"?"rgba(5,150,105,0.10)":"rgba(220,38,38,0.10)",
                      color:t.status==="activo"?"#059669":"#DC2626",
                      border:`1px solid ${t.status==="activo"?"rgba(5,150,105,0.30)":"rgba(220,38,38,0.30)"}`}}>
                      {t.status==="activo"?"● ACTIVO":"● BAJA"}
                    </span>
                  </div>
                </div>
                {(()=>{
                  // Set CANÓNICO del expediente: SIEMPRE visible (nunca desaparece por vacío).
                  // Lleno = igual que antes. Vacío = "Sin registrar" + estado pendiente
                  // (rojo = obligatorio crítico; ámbar = opcional). Los pendientes son
                  // clickeables y abren el MISMO formulario "Editar" (abrirEditarFicha).
                  const tt:any = t;
                  const fFecha = (s:string)=> new Date(s).toLocaleDateString("es-MX",{day:"2-digit",month:"long",year:"numeric"});
                  const boxes:{label:string; val:string; estado:"ok"|"rojo"|"ambar"; sub?:string}[] = [
                    // La cifra NO se recalcula: sigue saliendo de `calcularAntiguedad`
                    // sobre la primera contratación. Lo que se agrega es el matiz,
                    // porque si tras un reingreso la antigüedad se acumula o se
                    // reinicia es cuestión de hecho y de prueba que resuelve el
                    // abogado caso por caso. La plataforma registra, no concluye.
                    {label:"Antigüedad", val:antig, estado:"ok",
                      sub: periodosDe(t).length > 1
                        ? `Desde la primera contratación · ${periodosDe(t).length} periodos con interrupción`
                        : undefined},
                    {label:"Tipo contrato", val:t.tipoContrato==="indefinido"?"Tiempo indefinido":t.tipoContrato==="determinado"?"Tiempo determinado":"Por obra", estado:"ok"},
                    {label:"Fecha de ingreso", val: t.fechaIngreso ? fFecha(t.fechaIngreso) : "", estado: t.fechaIngreso ? "ok":"rojo"},
                    {label:"Salario mensual", val: (t.salarioDiario>0) ? fmtMXN2(salMensual) : "", estado: (t.salarioDiario>0) ? "ok":"rojo", sub: (t.salarioDiario>0) ? `Salario diario ${fmtMXN2(salDiarioDe(t))}` : undefined},
                    ...(t.fechaVencimiento ? [{label:"Vencimiento contrato", val:fFecha(t.fechaVencimiento), estado:"ok" as const}] : []),
                    {label:"RFC", val:t.rfc||"", estado: t.rfc?"ok":"ambar"},
                    {label:"CURP", val:t.curp||"", estado: t.curp?"ok":"ambar"},
                    {label:"NSS IMSS", val:t.imss||"", estado: t.imss?"ok":"ambar"},
                    {label:"Teléfono", val:t.telefono||"", estado: t.telefono?"ok":"ambar"},
                    {label:"Correo", val:t.email||"", estado: t.email?"ok":"ambar"},
                    {label:"Dirección", val:tt.direccion||"", estado: tt.direccion?"ok":"ambar"},
                  ];
                  const nPend = boxes.filter(b=>b.estado!=="ok").length;
                  return (<>
                    {nPend>0 && (
                      <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", gap:10, flexWrap:"wrap" as const, marginBottom:12, background:"rgba(184,147,42,0.07)", border:`1px solid ${T_LIGHT.goldBorder}`, borderRadius:10, padding:"9px 13px"}}>
                        <div style={{fontSize:12, color:T_LIGHT.textInkSoft, lineHeight:1.4}}>Faltan <strong style={{color:T_LIGHT.textInk}}>{nPend}</strong> dato{nPend===1?"":"s"} por registrar. Puedes completarlos cuando quieras — o toca cualquier recuadro pendiente.</div>
                        <button onClick={abrirEditarFicha} style={{background:T_LIGHT.gold, color:"#0B1829", border:"none", borderRadius:9, padding:"8px 14px", fontSize:12.5, fontWeight:800, cursor:"pointer", fontFamily:fontSans, whiteSpace:"nowrap" as const}}>✎ Completar datos</button>
                      </div>
                    )}
                    <div style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap:10}}>
                      {boxes.map((d,i) => {
                        const pend = d.estado!=="ok"; const rojo = d.estado==="rojo";
                        const bg = rojo ? "rgba(220,38,38,0.05)" : d.estado==="ambar" ? "rgba(217,119,6,0.05)" : T_LIGHT.canvasSoft;
                        const bd = rojo ? "rgba(220,38,38,0.45)" : d.estado==="ambar" ? "rgba(217,119,6,0.45)" : T_LIGHT.borderCard;
                        return (
                          <div key={i} onClick={pend?abrirEditarFicha:undefined} title={pend?"Toca para completar este dato en el formulario Editar":undefined}
                            style={{padding:"10px 12px", background:bg, borderRadius:10, border:`1px solid ${bd}`, cursor:pend?"pointer":"default"}}>
                            <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", gap:6, marginBottom:3}}>
                              <div style={{fontSize:10, color:T_LIGHT.textInkMut, textTransform:"uppercase" as const, letterSpacing:"0.5px", fontWeight:700}}>{d.label}</div>
                              {d.estado==="ambar" && <span style={{fontSize:9, fontWeight:800, color:"#B45309", background:"rgba(217,119,6,0.12)", border:"1px solid rgba(217,119,6,0.35)", borderRadius:6, padding:"1px 6px", textTransform:"uppercase" as const}}>Pendiente</span>}
                            </div>
                            {pend ? (<>
                              <div style={{fontSize:13, fontWeight:600, color:"#AEB4C2", fontStyle:"italic" as const}}>Sin registrar</div>
                              <div style={{marginTop:4, fontSize:10.5, fontWeight:600, color:rojo?"#B91C1C":"#B45309", lineHeight:1.35}}>{rojo ? "⚠ Dato crítico faltante · afecta nómina y obligaciones" : "Puedes completarlo después"}</div>
                            </>) : (<>
                              <div style={{fontSize:13, fontWeight:600, color:T_LIGHT.textInk}}>{d.val}</div>
                              {d.sub && <div style={{marginTop:2, fontSize:11, color:T_LIGHT.textInkMut, fontWeight:500}}>{d.sub}</div>}
                            </>)}
                          </div>
                        );
                      })}
                    </div>
                    {/* HISTORIAL DE LA RELACIÓN LABORAL. Solo aparece cuando hubo
                        más de un periodo o cuando hay una salida registrada: en el
                        caso normal —una contratación y sigue vigente— no agrega
                        nada. Es un registro de hechos con sus fechas, sin conclusión
                        sobre cómo debe contarse la antigüedad. */}
                    {(()=>{
                      const per = periodosDe(t);
                      if (per.length < 2 && !per.some(p=>p.baja)) return null;
                      const fCorta = (s?:string)=> s ? _fechaCortaMX(s) : null;
                      return (
                        <div style={{marginTop:16, background:T_LIGHT.canvasSoft, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:12, padding:"14px 16px"}}>
                          <div style={{fontSize:10.5, color:"#9A9AAA", textTransform:"uppercase" as const, letterSpacing:"0.5px", fontWeight:700, marginBottom:10}}>
                            Historial de la relación laboral
                          </div>
                          {per.map((p,i)=>(
                            <div key={i} style={{display:"flex", gap:10, alignItems:"flex-start",
                              paddingTop: i===0?0:9, marginTop: i===0?0:9,
                              borderTop: i===0?"none":`1px solid ${T_LIGHT.borderCard}`}}>
                              <span style={{fontSize:10.5, fontWeight:700, color:"#9A9AAA", minWidth:20, paddingTop:1}}>{i+1}</span>
                              <div style={{flex:1, minWidth:0}}>
                                <div style={{fontSize:12.5, color:T_LIGHT.textInk, fontWeight:600}}>
                                  {fCorta(p.ingreso) || "Ingreso sin fecha"}
                                  {" — "}
                                  {p.baja ? fCorta(p.baja) : <span style={{color:"#0F7A52"}}>en curso</span>}
                                </div>
                                {p.razonBaja && (
                                  <div style={{fontSize:11.5, color:T_LIGHT.textInkSoft, marginTop:2}}>
                                    {_etiquetaRazonBaja(p.razonBaja)}
                                  </div>
                                )}
                                {p.notasBaja && (
                                  <div style={{fontSize:11, color:T_LIGHT.textInkMut, marginTop:2, lineHeight:1.45}}>
                                    {p.notasBaja}
                                  </div>
                                )}
                              </div>
                            </div>
                          ))}
                          {per.length > 1 && (
                            <div style={{fontSize:11, color:T_LIGHT.textInkSoft, marginTop:11, paddingTop:9, borderTop:`1px solid ${T_LIGHT.borderCard}`, lineHeight:1.5}}>
                              La relación tuvo interrupciones. Si la antigüedad se acumula o se reinicia
                              tras un reingreso depende de los hechos de cada caso; aquí solo queda el registro.
                            </div>
                          )}
                        </div>
                      );
                    })()}
                  </>);
                })()}
              </div>

              {/* Prestaciones calculadas */}
              <div style={{background:T_LIGHT.cardLight, borderRadius:16, padding:"24px", marginBottom:14, border:`1px solid ${T_LIGHT.borderCard}`, boxShadow:T_LIGHT.shadow}}>
                <h3 style={{fontFamily:fontSerif, fontSize:16, color:T_LIGHT.textInk, margin:"0 0 16px", display:"flex", alignItems:"center", gap:8}}><AxisIcon name="scale_simple" size={16} tone="gold" withBackdrop={false} strokeWidth={2.5}/>Prestaciones de ley calculadas</h3>
                <div style={{display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:10}}>
                  {[
                    // Antes del primer año no hay días cumplidos, y decir "0 días"
                    // a secas se lee como que no le tocan: le tocan al cumplir el año.
                    {label:"Días de vacaciones", val: _vacFicha?.yaAplica ? `${diasVac} días` : "—",
                      sub: _vacFicha?.valida === false ? "sin fecha de ingreso"
                        : _vacFicha?.futuro ? "su fecha de ingreso es futura"
                        : _vacFicha?.yaAplica ? `${aniosCumpl} año${aniosCumpl>1?"s":""} de antigüedad`
                        : "aún no cumple su primer año", color:"#0EA5E9"},
                    // `moneyMXN` y no un formato propio: el dinero se escribe en
                    // un solo sitio. Aquí salía "$2,786.685" —la prima es salario
                    // × días × 0.25, así que da tercios— porque este renglón fijaba
                    // el mínimo de decimales y no el tope.
                    {label:"Prima vacacional (25%)", val:moneyMXN(primaVac), sub:"Art. 80 LFT", color:"#059669"},
                    {label:"Aguinaldo mínimo", val:moneyMXN(aguinaldo), sub:"15 días · Art. 87 LFT", color:"#B8932A"},
                  ].map((p,i) => (
                    <div key={i} style={{padding:"14px 12px", background:`${p.color}10`, borderRadius:12, border:`1px solid ${p.color}40`, textAlign:"center" as const}}>
                      <div style={{fontSize:18, fontWeight:800, color:p.color, fontFamily:fontSerif, marginBottom:4}}>{p.val}</div>
                      <div style={{fontSize:11, fontWeight:600, color:T_LIGHT.textInk, marginBottom:2}}>{p.label}</div>
                      <div style={{fontSize:10, color:T_LIGHT.textInkSoft}}>{p.sub}</div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Contacto de emergencia */}
              {(t.contactoEmergenciaNombre||t.contactoEmergenciaTel) && (
                <div style={{background:"rgba(239,68,68,0.06)", borderRadius:14, padding:"16px 20px", marginBottom:14, boxShadow:T_LIGHT.shadow, border:"1px solid rgba(239,68,68,0.25)"}}>
                  <div style={{fontSize:12, fontWeight:700, color:T_LIGHT.danger, marginBottom:10, display:"flex", alignItems:"center", gap:6}}><AxisIcon name="alert" size={12} color={T_LIGHT.danger} withBackdrop={false} strokeWidth={2.5}/>Contacto de emergencia</div>
                  <div style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap:10}}>
                    {t.contactoEmergenciaNombre && (
                      <div><div style={{fontSize:10,color:T_LIGHT.textInkMut,marginBottom:2,fontWeight:700}}>NOMBRE</div><div style={{fontSize:13,fontWeight:600,color:T_LIGHT.textInk}}>{t.contactoEmergenciaNombre}</div></div>
                    )}
                    {t.contactoEmergenciaTel && (
                      <div><div style={{fontSize:10,color:T_LIGHT.textInkMut,marginBottom:2,fontWeight:700}}>TELÉFONO</div>
                        <a href={`tel:${t.contactoEmergenciaTel}`} style={{fontSize:13,fontWeight:600,color:T_LIGHT.danger,textDecoration:"none"}}>{t.contactoEmergenciaTel}</a>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* Notas */}
              {t.notas && (
                <div style={{background:T_LIGHT.cardLight, borderRadius:14, padding:"16px 20px", border:`1px solid ${T_LIGHT.borderCard}`, boxShadow:T_LIGHT.shadow}}>
                  <div style={{fontSize:12, fontWeight:700, color:T_LIGHT.textInk, marginBottom:8, display:"flex", alignItems:"center", gap:6}}><AxisIcon name="document" size={12} tone="gold" withBackdrop={false} strokeWidth={2.5}/>Notas</div>
                  <div style={{fontSize:13, color:T_LIGHT.textInkSoft, lineHeight:1.7}}>{t.notas}</div>
                </div>
              )}
            </>
          )}

{/* ─── PESTAÑA: ACTIVIDADES ─── */}
          {tabActiva === "tareas" && (() => {
            const email = (seleccionado?.email||"").toLowerCase().trim();
            const nombreEmp = seleccionado?.nombre || email;
            const ymActual = mesActualYM();
            // Meses con actividades para este empleado (últimos 12) + mes actual siempre.
            const susTodas = tareasTrab.filter((tar:any)=>(tar.trabajadorEmail||"").toLowerCase()===email);
            const mesesConTareas = Array.from(new Set(susTodas.map(mesDeTarea).filter(Boolean) as string[]));
            const opcionesMes = Array.from(new Set([ymActual, ...mesesConTareas])).sort().reverse().slice(0,12);
            // Mes seleccionado; si el guardado no aplica a este empleado, cae al actual.
            const mesSel = opcionesMes.includes(mesTareasSel) ? mesTareasSel : ymActual;
            const esMesActual = mesSel === ymActual;
            // Solo los meses PASADOS son historial cerrado (solo lectura). El mes
            // actual y los FUTUROS (tareas con vencimiento por venir) siguen activos.
            const esMesPasado = mesSel < ymActual;
            const esMesFuturo = mesSel > ymActual;
            const etiquetaMes = (ym:string) => { const [y,m]=ym.split("-").map(Number); const s=new Date(y,m-1,1).toLocaleString("es-MX",{month:"long",year:"numeric"}); return s.charAt(0).toUpperCase()+s.slice(1); };
            const suyas = tareasDelMes(susTodas, mesSel, ymActual)
              .sort((a:any,b:any)=>{
                const fa=a.fechaLimite||"9999-99-99", fb=b.fechaLimite||"9999-99-99";
                if(fa!==fb) return fa.localeCompare(fb);
                return (a.creadoEn?.toMillis?.()||0)-(b.creadoEn?.toMillis?.()||0);
              });
            // Medidor: % del MES SELECCIONADO (por defecto, el mes actual).
            const ct = calcularCumplimientoTareas(tareasDelMes(tareasTrab, mesSel, ymActual), email);
            const porConfirmar = suyas.filter((tar:any)=>tar.marcadaPorTrabajador && !tar.confirmadaPorPatron).length;
            const colPct = ct.total===0 ? "#9A9AAA" : ct.porcentaje>=80 ? "#059669" : ct.porcentaje>=40 ? "#B8932A" : "#DC2626";
            const estadoDe = (tar:any) => tar.confirmadaPorPatron ? "Confirmada" : (tar.marcadaPorTrabajador ? "Por confirmar" : "Pendiente");
            const inpTar = {width:"100%", padding:"10px 12px", border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:8, fontSize:13, outline:"none", boxSizing:"border-box" as const, fontFamily:fontSans, background:"white", color:T_LIGHT.textInk};
            const disTar = guardandoTar || !tarTitulo.trim() || !tarFecha;
            return (
              <div>
                {/* Selector de mes (historial) */}
                <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", gap:10, flexWrap:"wrap" as const, marginBottom:12}}>
                  <div style={{display:"flex", alignItems:"center", gap:8}}>
                    <label style={{fontSize:12, fontWeight:600, color:T_LIGHT.textInkSoft}}>Mes</label>
                    <select {...CAMPO_DE_PARAMETRO} value={mesSel} onChange={e=>setMesTareasSel(e.target.value)}
                      style={{padding:"7px 10px", border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:8, fontSize:13, fontFamily:fontSans, background:"white", color:T_LIGHT.textInk, cursor:"pointer"}}>
                      {opcionesMes.map(ym=>(<option key={ym} value={ym}>{etiquetaMes(ym)}{ym===ymActual?" (mes actual)":""}</option>))}
                    </select>
                  </div>
                  {esMesPasado && (
                    <span style={{fontSize:11, fontWeight:700, padding:"4px 10px", borderRadius:999, background:"rgba(184,147,42,0.12)", color:"#8A6D1A", border:"1px solid rgba(184,147,42,0.30)"}}>Historial · solo lectura</span>
                  )}
                  {esMesFuturo && (
                    <span style={{fontSize:11, fontWeight:700, padding:"4px 10px", borderRadius:999, background:"rgba(35,100,120,0.10)", color:"#236478", border:"1px solid rgba(35,100,120,0.30)"}}>Vencimiento futuro</span>
                  )}
                </div>

                {/* Medidor de cumplimiento (confirmadas/total — función unificada) */}
                <div style={{background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:14, padding:"16px 20px", marginBottom:14, boxShadow:T_LIGHT.shadow}}>
                  <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:8, flexWrap:"wrap" as const, gap:8}}>
                    <h3 style={{fontFamily:fontSerif, fontSize:15, color:T_LIGHT.textInk, margin:0}}>Actividades de {nombreEmp} · {etiquetaMes(mesSel)}</h3>
                    <span style={{fontFamily:fontSerif, fontSize:18, fontWeight:800, color:colPct}}>{ct.total?`${ct.porcentaje}%`:"—"}</span>
                  </div>
                  <div style={{height:8, background:"rgba(0,0,0,0.06)", borderRadius:4, overflow:"hidden" as const, marginBottom:6}}>
                    <div style={{height:"100%", width:`${ct.porcentaje}%`, background:colPct, transition:"width 0.5s ease"}}/>
                  </div>
                  <div style={{fontSize:11, color:T_LIGHT.textInkSoft}}>{ct.total===0?"Sin actividades en este mes":`${ct.confirmadas}/${ct.total} confirmadas${porConfirmar?` · ${porConfirmar} por confirmar`:""}`}</div>
                </div>

                {/* Asignar nueva actividad — SOLO desde el mes actual. La fecha límite
                    es obligatoria y define el mes de cumplimiento de la actividad. */}
                {esMesActual ? (
                <div {...ZONA_DE_CAPTURA} style={{background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderLeft:"4px solid #236478", borderRadius:12, padding:"14px 16px", marginBottom:14, boxShadow:T_LIGHT.shadow}}>
                  <div style={{fontSize:13, fontWeight:700, color:T_LIGHT.textInk, marginBottom:10}}>Asignar nueva actividad</div>
                  <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr":"2fr 1fr 1fr", gap:10, marginBottom:6}}>
                    <input value={tarTitulo} onChange={e=>setTarTitulo(e.target.value)} placeholder="Título de la actividad" style={inpTar}/>
                    <input type="date" value={tarFecha} onChange={e=>setTarFecha(e.target.value)} title="Fecha límite (obligatoria)" style={{...inpTar, borderColor: tarFecha ? T_LIGHT.border : "rgba(184,147,42,0.55)"}}/>
                    <input type="time" value={tarHorario} onChange={e=>setTarHorario(e.target.value)} title="Horario (opcional)" style={inpTar}/>
                  </div>
                  <div style={{fontSize:11, color:T_LIGHT.textInkMut, marginBottom:10}}>La <strong>fecha límite</strong> es obligatoria: define el mes en que se mide el cumplimiento. El horario es opcional.</div>
                  <textarea value={tarDesc} onChange={e=>setTarDesc(e.target.value)} rows={2} placeholder="Descripción (opcional)" style={{...inpTar, resize:"vertical" as const, marginBottom:10}}/>
                  <button onClick={()=>asignarTareaEmpleado(email, nombreEmp)} disabled={disTar}
                    style={{background:disTar?"rgba(0,0,0,0.08)":"#236478", border:"none", color:disTar?"#9A9AAA":"white", borderRadius:8, padding:"9px 16px", cursor:disTar?"not-allowed":"pointer", fontSize:13, fontWeight:700, fontFamily:fontSans}}>
                    {guardandoTar ? "Guardando…" : "Asignar actividad"}
                  </button>
                  {feedbackTar?.tipo==="ok" && (<div style={{marginTop:10, fontSize:12, color:"#059669", fontWeight:600}}>{feedbackTar.msg}</div>)}
                  {feedbackTar?.tipo==="err" && (<div style={{marginTop:10, fontSize:12, color:T_LIGHT.danger, fontWeight:600}}>{feedbackTar.msg}</div>)}
                </div>
                ) : esMesPasado ? (
                  <div style={{background:T_LIGHT.canvasSoft, border:`1px dashed ${T_LIGHT.border}`, borderRadius:12, padding:"12px 16px", marginBottom:14, fontSize:12, color:T_LIGHT.textInkSoft, lineHeight:1.5}}>
                    Estás viendo el historial de <strong>{etiquetaMes(mesSel)}</strong> (solo lectura). El botón <strong>Editar</strong> sigue disponible para corregir el texto de una actividad. Para asignar una actividad nueva, vuelve al <strong>mes actual</strong>.
                  </div>
                ) : (
                  <div style={{background:T_LIGHT.canvasSoft, border:`1px dashed ${T_LIGHT.border}`, borderRadius:12, padding:"12px 16px", marginBottom:14, fontSize:12, color:T_LIGHT.textInkSoft, lineHeight:1.5}}>
                    Actividades con <strong>vencimiento en {etiquetaMes(mesSel)}</strong>. Para asignar una nueva, créala desde el <strong>mes actual</strong> indicando esa fecha límite.
                  </div>
                )}

                {/* Lista de actividades del empleado (estados + confirmar) */}
                {suyas.length===0 ? (
                  <div style={{fontSize:13, color:T_LIGHT.textInkSoft, background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:12, padding:"20px 22px", boxShadow:T_LIGHT.shadow}}>{esMesActual?"Aún no le has asignado actividades.":"No hay actividades en este mes."}</div>
                ) : (
                  <div style={{display:"flex", flexDirection:"column" as const, gap:8}}>
                    {suyas.map((tar:any)=>{
                      const est = estadoDe(tar);
                      const col = est==="Confirmada"?"#059669":est==="Por confirmar"?"#B8932A":"#236478";
                      const fmod = tar.fechaModificacion?.toDate?.();
                      const fmodStr = fmod ? fmod.toLocaleDateString("es-MX",{day:"numeric",month:"short",year:"numeric"}) : null;
                      return (
                        <div key={tar.id} style={{background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderLeft:`3px solid ${col}`, borderRadius:10, padding:"10px 14px", display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:10, flexWrap:"wrap" as const, boxShadow:T_LIGHT.shadow}}>
                          <div style={{flex:1, minWidth:180}}>
                            <div style={{display:"flex", alignItems:"center", gap:8, flexWrap:"wrap" as const, marginBottom:2}}>
                              <span style={{fontWeight:700, fontSize:13, color:T_LIGHT.textInk}}>{tar.titulo}</span>
                              <span style={{fontSize:10, fontWeight:700, padding:"2px 8px", borderRadius:999, background:`${col}1A`, color:col}}>{est}</span>
                            </div>
                            {fmodStr && (<div style={{fontSize:10, color:"#B8932A", marginBottom:2, fontStyle:"italic" as const}}>Editada el {fmodStr}</div>)}
                            {tar.descripcion && (<div style={{fontSize:12, color:T_LIGHT.textInkSoft, marginBottom:2, whiteSpace:"pre-wrap" as const}}>{tar.descripcion}</div>)}
                            {(tar.fechaLimite||tar.horario) && (<div style={{fontSize:11, color:T_LIGHT.textInkMut}}>{tar.fechaLimite ? `Límite: ${tar.fechaLimite}${tar.horario?` · ${tar.horario}`:""}` : tar.horario}</div>)}
                          </div>
                          <div style={{display:"flex", alignItems:"center", gap:6, flexShrink:0, flexWrap:"wrap" as const}}>
                            {est==="Por confirmar" && !esMesPasado && (
                              <button onClick={()=>confirmarTareaEmpleado(tar.id)} disabled={confirmandoTarId===tar.id}
                                style={{fontSize:11, fontWeight:700, padding:"6px 12px", borderRadius:8, cursor:confirmandoTarId===tar.id?"wait":"pointer", fontFamily:fontSans, border:"1px solid rgba(5,150,105,0.30)", background:"rgba(5,150,105,0.08)", color:"#059669", whiteSpace:"nowrap" as const}}>
                                {confirmandoTarId===tar.id ? "Confirmando…" : "Confirmar"}
                              </button>
                            )}
                            {est==="Por confirmar" && esMesPasado && (
                              <span style={{fontSize:10, fontWeight:600, color:T_LIGHT.textInkMut, whiteSpace:"nowrap" as const}}>Por confirmar (mes cerrado)</span>
                            )}
                            <button onClick={()=>{ setEditTarea(tar); setEditTarTitulo(tar.titulo||""); setEditTarDesc(tar.descripcion||""); setEditTarFecha(tar.fechaLimite||""); setEditTarHorario(tar.horario||""); setEditTarError(null); }}
                              title="Editar actividad"
                              style={{fontSize:11, fontWeight:600, padding:"6px 12px", borderRadius:8, cursor:"pointer", fontFamily:fontSans, border:`1px solid ${T_LIGHT.borderCard}`, background:T_LIGHT.cardLight, color:T_LIGHT.textInkSoft, whiteSpace:"nowrap" as const}}>
                              Editar
                            </button>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })()}

          {/* ─── PESTAÑA: ACCESO ─── */}
          {tabActiva === "acceso" && (() => {
            const email = (seleccionado?.email||"").toLowerCase().trim();
            const cuenta = (cuentasTrab||[]).find((c:any)=>(c.email||"").toLowerCase()===email);
            return (
              <div style={{maxWidth:560}}>
                {cuenta ? (
                  <div style={{background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderLeft:`4px solid ${cuenta.activo===false?"#9A9AAA":"#236478"}`, borderRadius:12, padding:"16px 18px", boxShadow:T_LIGHT.shadow}}>
                    <div style={{fontSize:13, fontWeight:700, color:T_LIGHT.textInk, marginBottom:6}}>Cuenta de acceso</div>
                    <div style={{fontSize:13, color:T_LIGHT.textInkSoft, marginBottom:2}}>Correo: <strong style={{color:T_LIGHT.textInk}}>{cuenta.email}</strong></div>
                    <div style={{fontSize:12, color:T_LIGHT.textInkMut, marginBottom:12}}>
                      Estado: <span style={{fontWeight:700, color:cuenta.activo===false?"#B91C1C":"#059669"}}>{cuenta.activo===false?TEXTO_CUENTA_SUSPENDIDA:"Activa"}</span>
                      {cuenta.creadoEn?.toDate?.() ? ` · Creada ${cuenta.creadoEn.toDate().toLocaleDateString("es-MX")}` : ""}
                    </div>
                    <button onClick={()=>{ if (cuentaActiva(cuenta)) setPorSuspender(cuenta); else toggleAccesoEmpleado(cuenta); }} disabled={toglAcceso}
                      style={{fontSize:12, fontWeight:700, padding:"8px 14px", borderRadius:8, cursor:toglAcceso?"wait":"pointer", fontFamily:fontSans, border:`1px solid ${cuenta.activo===false?"rgba(5,150,105,0.30)":"rgba(154,154,170,0.4)"}`, background:cuenta.activo===false?"rgba(5,150,105,0.08)":"rgba(154,154,170,0.12)", color:cuenta.activo===false?"#059669":"#6B7280"}}>
                      {toglAcceso ? "Actualizando…" : (cuenta.activo===false ? BOTON_REACTIVAR_CUENTA : BOTON_SUSPENDER_CUENTA)}
                    </button>
                    {porSuspender && (
                      <ConfirmarSuspension nombre={seleccionado?.nombre || porSuspender.nombre || porSuspender.email} ocupado={toglAcceso} fontSans={fontSans}
                        onCancelar={()=>setPorSuspender(null)}
                        onSuspender={async ()=>{ await toggleAccesoEmpleado(porSuspender); setPorSuspender(null); }} />
                    )}
                    <div style={{fontSize:11, color:T_LIGHT.textInkMut, marginTop:10}}>El trabajador inicia sesión con este correo. Puede cambiar su contraseña con "¿Olvidaste tu contraseña?".</div>
                    {/* ── Biometría del checador ── */}
                    <div style={{borderTop:`1px solid ${T_LIGHT.borderCard}`, marginTop:14, paddingTop:12}}>
                      <div style={{fontSize:13, fontWeight:700, color:T_LIGHT.textInk, marginBottom:4}}>Verificación en el aparato (checador)</div>
                      <div style={{fontSize:12, color:T_LIGHT.textInkSoft, lineHeight:1.55, marginBottom:10}}>
                        {cuenta.bioRestablecidaEn?.toDate?.()
                          ? <>Verificación restablecida el <strong style={{color:T_LIGHT.textInk}}>{cuenta.bioRestablecidaEn.toDate().toLocaleString("es-MX",{day:"2-digit",month:"short",year:"numeric",hour:"2-digit",minute:"2-digit"})}</strong> por <strong style={{color:T_LIGHT.textInk}}>{cuenta.bioRestablecidaPor || "—"}</strong>.</>
                          : "Si el trabajador cambió de teléfono o su teléfono ya no lo reconoce, restablece la verificación: en su siguiente checada el teléfono le pedirá activarla de nuevo."}
                      </div>
                      <button onClick={()=>restablecerBiometria(cuenta)} disabled={restableciendoBio}
                        style={{fontSize:12, fontWeight:700, padding:"8px 14px", borderRadius:8, cursor:restableciendoBio?"wait":"pointer", fontFamily:fontSans, border:"1px solid rgba(35,100,120,0.35)", background:"rgba(35,100,120,0.08)", color:"#236478"}}>
                        {restableciendoBio ? "Restableciendo…" : "Restablecer verificación"}
                      </button>
                    </div>
                  </div>
                ) : (
                  <div style={{background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderLeft:"4px solid #B8932A", borderRadius:12, padding:"16px 18px", boxShadow:T_LIGHT.shadow}}>
                    <div style={{fontSize:13, fontWeight:700, color:T_LIGHT.textInk, marginBottom:6}}>Sin cuenta de acceso</div>
                    <div style={{fontSize:12, color:T_LIGHT.textInkSoft, marginBottom:12}}>Este empleado no tiene cuenta para iniciar sesión.{seleccionado?.email?` Crea una con su correo (${seleccionado.email}).`:" Captura primero su correo en la pestaña Datos."}</div>
                    <button onClick={()=>{ setRegNombre(seleccionado?.nombre||""); setRegCorreo(seleccionado?.email||""); setRegFeedback(null); setMostrarRegistro(true); }}
                      style={{background:"#236478", border:"none", color:"white", borderRadius:8, padding:"8px 14px", cursor:"pointer", fontSize:12, fontWeight:700, fontFamily:fontSans}}>
                      Crear acceso
                    </button>
                  </div>
                )}
              </div>
            );
          })()}

          {/* ─── PESTAÑA: EXPEDIENTE (antes "Cumplimiento") ─── */}
          {tabActiva === "cumplimiento" && (
            <>
              {/* Header con % global */}
              {(() => {
                const cumplGlobal = calcularCompliance((t as any).compliance);
                const colorGlobal = cumplGlobal.porcentaje >= 90 ? "#059669" : cumplGlobal.porcentaje >= 60 ? "#F4C075" : "#DC2626";
                const bgGlobal = cumplGlobal.porcentaje >= 90 ? "rgba(5,150,105,0.08)" : cumplGlobal.porcentaje >= 60 ? "rgba(184,147,42,0.08)" : "rgba(220,38,38,0.08)";
                const borderGlobal = cumplGlobal.porcentaje >= 90 ? "rgba(5,150,105,0.25)" : cumplGlobal.porcentaje >= 60 ? "rgba(184,147,42,0.3)" : "rgba(220,38,38,0.25)";
                return (
                  <div style={{background:bgGlobal, border:`1px solid ${borderGlobal}`, borderRadius:16, padding:"20px 24px", marginBottom:14, display:"flex", alignItems:"center", gap:18, flexWrap:"wrap" as const, boxShadow:T_LIGHT.shadow}}>
                    <div style={{display:"flex", alignItems:"center", justifyContent:"center", width:80, height:80, borderRadius:"50%", background:T_LIGHT.cardLight, border:`2px solid ${colorGlobal}`, flexShrink:0}}>
                      <div style={{fontSize:22, fontWeight:800, color:colorGlobal, fontFamily:fontSerif}}>{cumplGlobal.porcentaje}%</div>
                    </div>
                    <div style={{flex:1, minWidth:200}}>
                      <div style={{fontFamily:fontSerif, fontSize:16, color:T_LIGHT.textInk, marginBottom:4}}>Expediente capturado</div>
                      <div style={{fontSize:12, color:T_LIGHT.textInkSoft, lineHeight:1.5}}>
                        <strong style={{color:colorGlobal}}>{cumplGlobal.obligatoriosCumplidos} de {cumplGlobal.totalObligatorios}</strong> obligatorios · {cumplGlobal.cumplidos} de {cumplGlobal.aplicables} puntos aplicables
                      </div>
                      {/* La letra pequeña va JUNTO AL NÚMERO, no en Ayuda: esta es la
                          pantalla donde se marcan las casillas, así que aquí es donde
                          se entiende de un vistazo que el número las cuenta a ellas y
                          no a los archivos. En los renglones de abajo no se repite:
                          cada casilla ya dice qué es. */}
                      <div style={{fontSize:11, color:T_LIGHT.textInkMut, lineHeight:1.45, marginTop:5, fontStyle:"italic" as const}}>
                        según las casillas que has marcado en este expediente
                      </div>
                    </div>
                  </div>
                );
              })()}

              {/* Secciones */}
              {COMPLIANCE_SECCIONES.map(sec => {
                const itemsSec = COMPLIANCE_ITEMS.filter(it => it.seccion === sec.key);
                let secCumplidos = 0;
                let secAplicables = 0;
                itemsSec.forEach(item => {
                  const estado = (t as any).compliance?.[item.key] || "pendiente";
                  if (estado === "na") return;
                  const peso = item.tipo === "obligatorio" ? 2 : 1;
                  secAplicables += peso;
                  if (estado === "ok") secCumplidos += peso;
                });
                const secPorc = secAplicables === 0 ? 0 : Math.round((secCumplidos / secAplicables) * 100);
                const secColor = secPorc >= 90 ? "#059669" : secPorc >= 60 ? "#D97706" : "#DC2626";

                return (
                  <div key={sec.key} style={{background:T_LIGHT.cardLight, borderRadius:14, padding:"16px 20px", marginBottom:12, border:`1px solid ${T_LIGHT.borderCard}`, boxShadow:T_LIGHT.shadow}}>
                    <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:12, gap:10}}>
                      <div style={{display:"flex", alignItems:"center", gap:8}}>
                        <AxisIcon name={sec.iconName} size={14} tone="gold" withBackdrop={false} strokeWidth={2.5}/>
                        <span style={{fontFamily:fontSerif, fontSize:14, color:T_LIGHT.textInk, fontWeight:600}}>{sec.label}</span>
                      </div>
                      <span style={{fontSize:13, fontWeight:700, color:secColor, fontFamily:fontSerif}}>{secPorc}%</span>
                    </div>
                    <div style={{display:"flex", flexDirection:"column" as const, gap:8}}>
                      {itemsSec.map(item => {
                        const estado = (t as any).compliance?.[item.key] || "pendiente";
                        const tipoColor = item.tipo === "obligatorio" ? "#DC2626" : item.tipo === "condicional" ? "#D97706" : T_LIGHT.textInkMut;
                        const tipoBg = item.tipo === "obligatorio" ? "rgba(220,38,38,0.08)" : item.tipo === "condicional" ? "rgba(217,119,6,0.08)" : T_LIGHT.canvasSoft;
                        const tipoBorder = item.tipo === "obligatorio" ? "rgba(220,38,38,0.25)" : item.tipo === "condicional" ? "rgba(217,119,6,0.30)" : T_LIGHT.border;
                        const tipoLabel = item.tipo === "obligatorio" ? "Obligatorio" : item.tipo === "condicional" ? "Condicional" : "Recomendado";

                        return (
                          <div key={item.key} style={{background:T_LIGHT.canvasSoft, borderRadius:10, padding:"10px 12px", border:`1px solid ${T_LIGHT.borderCard}`, display:"flex", alignItems:"center", justifyContent:"space-between", gap:10, flexWrap:isMobile?"wrap" as const:"nowrap" as const}}>
                            <div style={{flex:1, minWidth:isMobile?"100%":200}}>
                              <div style={{display:"flex", alignItems:"center", gap:6, marginBottom:3, flexWrap:"wrap" as const}}>
                                <span style={{fontSize:13, color:T_LIGHT.textInk, fontWeight:600}}>{item.label}</span>
                                <span style={{fontSize:9, fontWeight:700, padding:"2px 7px", borderRadius:6, background:tipoBg, color:tipoColor, border:`1px solid ${tipoBorder}`, textTransform:"uppercase" as const, letterSpacing:"0.3px"}}>{tipoLabel}</span>
                              </div>
                              <div style={{fontSize:10, color:T_LIGHT.textInkMut}}>{item.baseLegal}</div>
                            </div>
                            <div style={{display:"flex", gap:4, flexShrink:0}}>
                              {([
                                {val:"ok" as const, label:"OK", color:"#059669", bg:"rgba(5,150,105,0.12)", border:"rgba(5,150,105,0.35)"},
                                {val:"pendiente" as const, label:"Pend", color:"#D97706", bg:"rgba(217,119,6,0.12)", border:"rgba(217,119,6,0.35)"},
                                {val:"na" as const, label:"N/A", color:T_LIGHT.textInkMut, bg:T_LIGHT.canvasSoft, border:T_LIGHT.border},
                              ]).map(opt => (
                                <button key={opt.val} onClick={()=>cambiarComplianceItem(item.key, opt.val)}
                                  style={{
                                    padding:"5px 10px",
                                    borderRadius:7,
                                    fontSize:11,
                                    fontWeight:700,
                                    cursor:"pointer",
                                    border:`1px solid ${estado===opt.val ? opt.border : T_LIGHT.border}`,
                                    background: estado===opt.val ? opt.bg : T_LIGHT.cardLight,
                                    color: estado===opt.val ? opt.color : T_LIGHT.textInkMut,
                                  }}>
                                  {opt.label}
                                </button>
                              ))}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </>
          )}
          
{/* ─── PESTAÑA: DOCUMENTOS ─── */}
          {tabActiva === "documentos" && (
            <div style={{background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:16, padding:"20px 24px", boxShadow:T_LIGHT.shadow}}>
              <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:16, flexWrap:"wrap" as const, gap:10}}>
                <h3 style={{fontFamily:fontSerif, fontSize:15, color:T_LIGHT.textInk, margin:0, display:"flex", alignItems:"center", gap:8}}><AxisIcon name="clipboard" size={15} tone="gold" withBackdrop={false} strokeWidth={2.5}/>Documentos del expediente</h3>
                <SubirArchivoBtn
                  userId={currentUser.uid}
                  carpeta="empleados"
                  label="Subir documento"
                  accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                  onLote={async (archivos) => {
                    const docsActuales = (t as any).documentos || [];
                    const hoy = new Date().toISOString().slice(0,10);
                    const nuevos = [...docsActuales, ...archivos.map((a)=>({nombre:a.nombre, url:a.url, fecha: hoy}))];
                    await updateDoc(doc(db,"trabajadores",t.id!), {documentos: nuevos});
                    setSeleccionado({...t, documentos: nuevos} as any);
                    setTrabajadores(prev => prev.map(x => x.id === t.id ? {...t, documentos: nuevos} as any : x));
                  }}
                />
              </div>
              {(!(t as any).documentos || (t as any).documentos.length === 0) ? (
                <div style={{textAlign:"center" as const, padding:"20px 0", color:T_LIGHT.textInkMut, fontSize:13}}>
                  Sin documentos — sube INE, contrato firmado, comprobante IMSS, etc.
                </div>
              ) : (
                <div style={{display:"flex", flexDirection:"column" as const, gap:8}}>
                  {((t as any).documentos || []).map((d: any, i: number) => (
                    <div key={i} style={{display:"flex", alignItems:"center", gap:10, background:T_LIGHT.canvasSoft, borderRadius:10, padding:"10px 14px", border:`1px solid ${T_LIGHT.borderCard}`}}>
                      <span style={{fontSize:16, flexShrink:0}}>
                        {d.nombre?.endsWith(".pdf") ? "📄" : d.nombre?.match(/\.(jpg|jpeg|png)$/i) ? "🖼️" : "📋"}
                      </span>
                      <div style={{flex:1, minWidth:0}}>
                        <div style={{fontSize:13, color:T_LIGHT.textInk, fontWeight:500, whiteSpace:"nowrap" as const, overflow:"hidden", textOverflow:"ellipsis"}}>{d.nombre}</div>
                        <div style={{fontSize:11, color:T_LIGHT.textInkMut}}>{d.fecha}</div>
                      </div>
                      <a href={(d.nombre?.match(/\.(doc|docx)$/i)) ? `https://docs.google.com/viewer?embedded=true&url=${encodeURIComponent(d.url)}` : d.url} target="_blank" rel="noreferrer"
                        style={{fontSize:11, color:T_LIGHT.gold, fontWeight:700, textDecoration:"none", flexShrink:0, padding:"4px 10px", background:T_LIGHT.goldSoft, borderRadius:6, border:`1px solid ${T_LIGHT.goldBorder}`}}>Ver →</a>
                      <button onClick={async () => {
                          await eliminarArchivo(d.url);
                          const nuevos = ((t as any).documentos || []).filter((_:any,j:number)=>j!==i);
                          await updateDoc(doc(db,"trabajadores",t.id!), {documentos:nuevos});
                          setSeleccionado({...t, documentos:nuevos} as any);
                          setTrabajadores(prev => prev.map(x => x.id === t.id ? {...t, documentos:nuevos} as any : x));
                        }}
                        style={{background:"transparent", border:"none", color:T_LIGHT.danger, cursor:"pointer", fontSize:14, flexShrink:0, padding:4, fontWeight:700}}>✕
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

{/* ─── PESTAÑA: CONTRATOS VINCULADOS ─── */}
          {tabActiva === "contratos" && (
            <SeccionContratosVinculados
              user={{uid: currentUser.uid}}
              entidadId={t.id!}
              entidadTipo="empleado"
              coleccion="trabajadores"
              contratos={(t as any).contratos || []}
              onContratosChange={(nuevos)=>{
                setSeleccionado({...t, contratos: nuevos} as any);
                setTrabajadores(prev => prev.map(x => x.id === t.id ? {...t, contratos: nuevos} as any : x));
              }}
              onGoContratos={onGoContratos}
              accentColor="#236478"
              fontSans={fontSans} fontSerif={fontSerif} gold={gold}
            />
          )}

{/* ─── PESTAÑA: NÓMINA ─── */}
          {tabActiva === "nomina" && (() => {
            const recibosFiltrados = recibosEmpleado
              .filter((r:any) => r.trabajadorId === t.id)
              .sort((a:any, b:any) => new Date(b.fechaPago || b.fechaInicio).getTime() - new Date(a.fechaPago || a.fechaInicio).getTime());
            const pagados = recibosFiltrados.filter((r:any) => r.status === "pagado").length;
            const pendientes = recibosFiltrados.length - pagados;

            return (
              <>
                {/* Header con stats y botón generar */}
                <div style={{background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:14, padding:"16px 20px", marginBottom:14, display:"flex", alignItems:"center", justifyContent:"space-between", gap:14, flexWrap:"wrap" as const, boxShadow:T_LIGHT.shadow}}>
                  <div style={{flex:1, minWidth:200}}>
                    <h3 style={{fontFamily:fontSerif, fontSize:15, color:T_LIGHT.textInk, margin:"0 0 4px", display:"flex", alignItems:"center", gap:8}}><AxisIcon name="money" size={14} tone="gold" withBackdrop={false} strokeWidth={2.5}/>Historial de nómina</h3>
                    <div style={{fontSize:12, color:T_LIGHT.textInkSoft}}>
                      <strong style={{color:T_LIGHT.textInk}}>{recibosFiltrados.length}</strong> recibo{recibosFiltrados.length===1?"":"s"} · <strong style={{color:"#059669"}}>{pagados}</strong> pagado{pagados===1?"":"s"} · <strong style={{color:T_LIGHT.warn}}>{pendientes}</strong> pendiente{pendientes===1?"":"s"}
                    </div>
                  </div>
                  {t.status === "activo" && (
                    <button onClick={()=>onIrNomina(t)} style={{background:T_LIGHT.goldSoft, border:`1px solid ${T_LIGHT.goldBorder}`, color:T_LIGHT.gold, borderRadius:10, padding:"8px 14px", cursor:"pointer", fontSize:12, fontWeight:700, display:"inline-flex", alignItems:"center", gap:6, flexShrink:0}}>
                      <AxisIcon name="money" size={12} tone="gold" withBackdrop={false} strokeWidth={2.5}/>
                      Generar recibo
                    </button>
                  )}
                </div>

                {/* Lista o empty state */}
                {recibosFiltrados.length === 0 ? (
                  <div style={{background:T_LIGHT.cardLight, borderRadius:16, padding:"40px 24px", border:`1px solid ${T_LIGHT.goldBorder}`, textAlign:"center" as const, boxShadow:T_LIGHT.shadow}}>
                    <div style={{marginBottom:14, display:"flex", justifyContent:"center"}}>
                      <div style={{width:64, height:64, borderRadius:"50%", background:"radial-gradient(circle, rgba(184,147,42,0.22) 0%, rgba(184,147,42,0) 70%)", display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <AxisIcon name="money" size={28} color="#B8932A" withBackdrop={false} strokeWidth={2.5}/>
                      </div>
                    </div>
                    <div style={{fontSize:14, color:T_LIGHT.textInk, fontFamily:fontSerif, marginBottom:6}}>Sin recibos todavía</div>
                    <div style={{fontSize:12, color:T_LIGHT.textInkSoft, lineHeight:1.6, maxWidth:340, margin:"0 auto"}}>
                      Los recibos generados para este empleado aparecerán aquí en orden cronológico.
                    </div>
                  </div>
                ) : (
                  <div style={{display:"flex", flexDirection:"column" as const, gap:8}}>
                    {recibosFiltrados.map((r:any) => {
                      const esPagado = r.status === "pagado";
                      const colorEstado = esPagado ? "#059669" : "#D97706";
                      const bgEstado = esPagado ? "rgba(5,150,105,0.10)" : "rgba(217,119,6,0.10)";
                      const borderEstado = esPagado ? "rgba(5,150,105,0.30)" : "rgba(217,119,6,0.30)";

                      return (
                        <div key={r.id} style={{background:T_LIGHT.cardLight, borderRadius:12, padding:"12px 16px", border:`1px solid ${T_LIGHT.borderCard}`, borderLeft:`3px solid ${colorEstado}`, display:"flex", alignItems:"center", justifyContent:"space-between", gap:12, flexWrap:isMobile?"wrap" as const:"nowrap" as const, boxShadow:T_LIGHT.shadow}}>
                          <div style={{flex:1, minWidth:isMobile?"100%":200}}>
                            <div style={{display:"flex", alignItems:"center", gap:8, marginBottom:3, flexWrap:"wrap" as const}}>
                              <span style={{fontSize:13, color:T_LIGHT.textInk, fontWeight:600, fontFamily:fontSerif}}>{r.folio}</span>
                              <span style={{fontSize:9, fontWeight:700, padding:"2px 8px", borderRadius:6, background:bgEstado, color:colorEstado, border:`1px solid ${borderEstado}`, textTransform:"uppercase" as const, letterSpacing:"0.4px"}}>
                                {esPagado ? "✓ Pagado" : "Pendiente"}
                              </span>
                            </div>
                            <div style={{fontSize:11, color:T_LIGHT.textInkSoft}}>
                              {r.periodo} · {r.fechaInicio} al {r.fechaFin}
                            </div>
                          </div>
                          <div style={{textAlign:"right" as const, flexShrink:0}}>
                            <div style={{fontSize:14, fontWeight:700, color:T_LIGHT.textInk, fontFamily:fontSerif}}>${(r.netoAPagar || 0).toLocaleString("es-MX", {minimumFractionDigits:2, maximumFractionDigits: 2})}</div>
                            <div style={{fontSize:10, color:T_LIGHT.textInkMut}}>Bruto ${(r.salarioBruto || 0).toLocaleString("es-MX", {minimumFractionDigits:2, maximumFractionDigits: 2})}</div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </>
            );
          })()}

        </div>
      </div>

    {showModalBaja && (
      <div style={{position:"fixed" as const,inset:0,background:"rgba(0,0,0,0.55)",zIndex:500,display:"flex",alignItems:"center",justifyContent:"center",padding:20,backdropFilter:"blur(4px)"}}>
        <div {...PANEL_DE_CAPTURA} onClick={e=>e.stopPropagation()} style={{background:"white",borderRadius:20,padding:"32px 36px",maxWidth:420,width:"100%",boxShadow:"0 20px 60px rgba(0,0,0,0.15)"}}>
          <div style={{textAlign:"center" as const,marginBottom:20}}>
            <div style={{fontSize:44,marginBottom:12}}>⚠️</div>
            <h3 style={{fontFamily:fontSerif,fontSize:18,color:T_LIGHT.textInk,margin:"0 0 10px"}}>¿Dar de baja a {showModalBaja.nombre}?</h3>
            <p style={{fontSize:13,color:"#4A4A60",lineHeight:1.7,margin:0}}>Al confirmar, recuerda que tienes <strong>5 días hábiles</strong> para presentar el aviso de baja ante el <strong>IMSS</strong>.</p>
          </div>
          <div style={{background:"rgba(239,68,68,0.06)",border:"1px solid rgba(239,68,68,0.2)",borderRadius:12,padding:"12px 16px",marginBottom:20}}>
            <div style={{fontSize:12,fontWeight:700,color:"#DC2626",marginBottom:4}}>⚖️ Art. 15 Fracc. I — Ley del Seguro Social</div>
            <div style={{fontSize:12,color:"#4A4A60",lineHeight:1.6}}>El patrón debe presentar el aviso de baja dentro de los <strong>5 días hábiles</strong> siguientes. El incumplimiento genera adeudos retroactivos de cuotas obrero-patronales.</div>
          </div>
          {/* CAUSA DE LA BAJA. Catálogo cerrado, no texto libre: así el motivo se
              puede contar y auditar después, y queda escrito en el periodo que se
              cierra. No es obligatorio —una baja urgente no debe frenarse por un
              campo—, pero se pide en el momento en que se sabe. */}
          <div style={{marginBottom:16}}>
            <label style={{fontSize:10,color:"#9A9AAA",display:"block",marginBottom:5,textTransform:"uppercase" as const,letterSpacing:"0.5px",fontWeight:700}}>Causa de la terminación</label>
            <select value={razonBaja} onChange={e=>setRazonBaja(e.target.value)}
              style={{width:"100%",padding:"11px 13px",background:T_LIGHT.canvasSoft,color:T_LIGHT.textInk,border:`1px solid ${T_LIGHT.borderCard}`,borderRadius:10,fontSize:13,outline:"none",boxSizing:"border-box" as const,cursor:"pointer",fontFamily:fontSans}}>
              <option value="">— Sin especificar —</option>
              {RAZONES_BAJA_TRABAJADOR.map(g=>(
                <optgroup key={g.grupo} label={g.grupo}>
                  {g.opciones.map(o=>(<option key={o.value} value={o.value}>{o.label}</option>))}
                </optgroup>
              ))}
            </select>
            <label style={{fontSize:10,color:"#9A9AAA",display:"block",margin:"12px 0 5px",textTransform:"uppercase" as const,letterSpacing:"0.5px",fontWeight:700}}>Notas (opcional)</label>
            <textarea value={notasBaja} onChange={e=>setNotasBaja(e.target.value)} rows={2}
              placeholder="Detalle que convenga dejar asentado en el expediente"
              style={{width:"100%",padding:"10px 13px",background:T_LIGHT.canvasSoft,color:T_LIGHT.textInk,border:`1px solid ${T_LIGHT.borderCard}`,borderRadius:10,fontSize:13,outline:"none",boxSizing:"border-box" as const,resize:"vertical" as const,fontFamily:fontSans}}/>
          </div>
          <div style={{display:"flex",gap:10}}>
            <button onClick={(ev)=>{ if (sePuedeCerrarElPanel(ev)) { setShowModalBaja(null); setRazonBaja(""); setNotasBaja(""); } }} style={{flex:1,background:"rgba(22,36,71,0.06)",border:"none",borderRadius:12,padding:"13px",cursor:"pointer",fontSize:13,fontWeight:600,color:"#4A4A60"}}>Cancelar</button>
            <button onClick={confirmarBaja} style={{flex:2,background:"linear-gradient(135deg,#DC2626,#B91C1C)",border:"none",borderRadius:12,padding:"13px",cursor:"pointer",fontSize:13,fontWeight:700,color:"white",boxShadow:"0 4px 16px rgba(220,38,38,0.3)"}}>
              Confirmar baja
            </button>
          </div>
        </div>
      </div>
    )}
    {editTarea && (
      <div style={{position:"fixed" as const, inset:0, background:"rgba(0,0,0,0.55)", zIndex:500, display:"flex", alignItems:"center", justifyContent:"center", padding:20, backdropFilter:"blur(4px)"}}>
        <div {...PANEL_DE_CAPTURA} onClick={e=>e.stopPropagation()} style={{background:"white", borderRadius:18, padding:"24px 28px", maxWidth:480, width:"100%", boxShadow:"0 20px 60px rgba(0,0,0,0.18)", fontFamily:fontSans}}>
          <h3 style={{fontFamily:fontSerif, fontSize:18, color:"#0F1D35", margin:"0 0 16px"}}>Editar actividad</h3>
          {(editTarea.marcadaPorTrabajador || editTarea.confirmadaPorPatron) && (
            <div style={{background:"rgba(184,147,42,0.10)", border:"1px solid rgba(184,147,42,0.35)", borderRadius:10, padding:"10px 14px", marginBottom:14, fontSize:12, color:"#8A6D1A", lineHeight:1.45}}>
              Esta actividad ya fue {editTarea.confirmadaPorPatron?"confirmada":"marcada"}. Editar el texto no afecta su estado de cumplimiento.
            </div>
          )}
          <div style={{marginBottom:12}}>
            <label style={{display:"block", fontSize:11, fontWeight:600, color:"#4A4A60", marginBottom:4}}>Título <span style={{color:"#DC2626"}}>*</span></label>
            <input value={editTarTitulo} onChange={e=>setEditTarTitulo(e.target.value)} style={{width:"100%", padding:"10px 12px", border:"1px solid rgba(0,0,0,0.12)", borderRadius:8, fontSize:13, outline:"none", boxSizing:"border-box" as const, fontFamily:fontSans}}/>
          </div>
          <div style={{marginBottom:12}}>
            <label style={{display:"block", fontSize:11, fontWeight:600, color:"#4A4A60", marginBottom:4}}>Descripción</label>
            <textarea value={editTarDesc} onChange={e=>setEditTarDesc(e.target.value)} rows={3} style={{width:"100%", padding:"10px 12px", border:"1px solid rgba(0,0,0,0.12)", borderRadius:8, fontSize:13, outline:"none", boxSizing:"border-box" as const, fontFamily:fontSans, resize:"vertical" as const, minHeight:64}}/>
          </div>
          <div style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:14}}>
            <div>
              <label style={{display:"block", fontSize:11, fontWeight:600, color:"#4A4A60", marginBottom:4}}>Fecha límite <span style={{color:"#DC2626"}}>*</span></label>
              <input type="date" value={editTarFecha} onChange={e=>setEditTarFecha(e.target.value)} style={{width:"100%", padding:"10px 12px", border:`1px solid ${editTarFecha?"rgba(0,0,0,0.12)":"rgba(184,147,42,0.55)"}`, borderRadius:8, fontSize:13, outline:"none", boxSizing:"border-box" as const, fontFamily:fontSans}}/>
            </div>
            <div>
              <label style={{display:"block", fontSize:11, fontWeight:600, color:"#4A4A60", marginBottom:4}}>Horario</label>
              <input type="time" value={editTarHorario} onChange={e=>setEditTarHorario(e.target.value)} style={{width:"100%", padding:"10px 12px", border:"1px solid rgba(0,0,0,0.12)", borderRadius:8, fontSize:13, outline:"none", boxSizing:"border-box" as const, fontFamily:fontSans}}/>
            </div>
          </div>
          {editTarError && (<div style={{background:"rgba(220,38,38,0.08)", border:"1px solid rgba(220,38,38,0.30)", borderRadius:10, padding:"10px 14px", marginBottom:12, fontSize:12, color:"#DC2626"}}>{editTarError}</div>)}
          <div style={{display:"flex", gap:10, justifyContent:"flex-end"}}>
            <button onClick={(ev)=>{ if (sePuedeCerrarElPanel(ev)) setEditTarea(null); }} disabled={editTarGuardando} style={{padding:"9px 16px", borderRadius:8, border:"1px solid rgba(0,0,0,0.12)", background:"white", color:"#4A4A60", fontSize:13, fontWeight:600, cursor:editTarGuardando?"wait":"pointer", fontFamily:fontSans}}>Cancelar</button>
            <button onClick={editarTareaEmpleado} disabled={editTarGuardando || !editTarTitulo.trim() || !editTarFecha} style={{padding:"9px 16px", borderRadius:8, border:"none", background:(editTarGuardando||!editTarTitulo.trim()||!editTarFecha)?"rgba(0,0,0,0.08)":"#236478", color:(editTarGuardando||!editTarTitulo.trim()||!editTarFecha)?"#9A9AAA":"white", fontSize:13, fontWeight:700, cursor:(editTarGuardando||!editTarTitulo.trim()||!editTarFecha)?"not-allowed":"pointer", fontFamily:fontSans}}>
              {editTarGuardando ? "Guardando…" : "Guardar cambios"}
            </button>
          </div>
        </div>
      </div>
    )}
    {altaSinFicha && (
      <ConfirmarCuentaSinFicha
        correo={altaSinFicha.correo} nombre={altaSinFicha.nombre} parecidas={altaSinFicha.parecidas}
        creando={regGenerando} fontSans={fontSans} fontSerif={fontSerif}
        onCrearNueva={()=>{ const a = altaSinFicha; if (a) crearCuentaYVincular(a.correo, a.nombre, null); }}
        onCorregir={()=>{ setAltaSinFicha(null); setMostrarRegistro(true); }}
        onUsarCorreo={(c:string)=>{ setRegCorreo(c); setAltaSinFicha(null); setMostrarRegistro(true); }}/>
    )}

    {mostrarRegistro && (
      <div style={{position:"fixed" as const, inset:0, background:"rgba(0,0,0,0.55)", zIndex:500, display:"flex", alignItems:"center", justifyContent:"center", padding:20, backdropFilter:"blur(4px)"}}>
        <div {...PANEL_DE_CAPTURA} onClick={e=>e.stopPropagation()} style={{background:"white", borderRadius:18, padding:"24px 28px", maxWidth:460, width:"100%", boxShadow:"0 20px 60px rgba(0,0,0,0.18)", fontFamily:fontSans}}>
          <h3 style={{fontFamily:fontSerif, fontSize:18, color:"#0F1D35", margin:"0 0 4px"}}>Registrar trabajador</h3>
          <div style={{fontSize:12, color:"#9A9AAA", marginBottom:16}}>Crea su cuenta de acceso sin cerrar tu sesión. Al terminar verás una contraseña temporal para compartirla.</div>
          <div style={{marginBottom:12}}>
            <label style={{fontSize:10, color:"#5F5E5A", display:"block", marginBottom:5, textTransform:"uppercase" as const, letterSpacing:"0.5px", fontWeight:600}}>Nombre del trabajador</label>
            <input value={regNombre} onChange={e=>setRegNombre(e.target.value)} placeholder="Nombre completo"
              style={{width:"100%", padding:"10px 12px", border:"1px solid rgba(0,0,0,0.15)", borderRadius:10, fontSize:13, outline:"none", boxSizing:"border-box" as const, fontFamily:fontSans}}/>
          </div>
          <div style={{marginBottom:16}}>
            <label style={{fontSize:10, color:"#5F5E5A", display:"block", marginBottom:5, textTransform:"uppercase" as const, letterSpacing:"0.5px", fontWeight:600}}>Correo</label>
            <input value={regCorreo} onChange={e=>setRegCorreo(e.target.value)} type="email" placeholder="correo@ejemplo.com"
              style={{width:"100%", padding:"10px 12px", border:"1px solid rgba(0,0,0,0.15)", borderRadius:10, fontSize:13, outline:"none", boxSizing:"border-box" as const, fontFamily:fontSans}}/>
          </div>
          {regFeedback?.tipo==="ok" ? (
            <div style={{background:"rgba(5,150,105,0.08)", border:"1px solid rgba(5,150,105,0.30)", borderRadius:10, padding:"12px 14px", marginBottom:14}}>
              <div style={{fontSize:13, color:"#059669", fontWeight:700, marginBottom:6}}>Cuenta creada para {regFeedback.correo}</div>
              <div style={{fontSize:12, color:"#4A4A60", marginBottom:6}}>Contraseña temporal para compartir:</div>
              <div style={{fontFamily:"monospace", fontSize:16, fontWeight:700, color:"#0B1829", background:"white", border:"1px dashed rgba(0,0,0,0.25)", borderRadius:8, padding:"8px 12px", letterSpacing:"1px", userSelect:"all" as const}}>{regFeedback.tempPass}</div>
              <div style={{fontSize:11, color:"#9A9AAA", marginTop:6}}>Puede cambiarla con "¿Olvidaste tu contraseña?" al iniciar sesión.</div>
            </div>
          ) : regFeedback?.tipo==="err" ? (
            <ErrorAltaTrabajador msg={regFeedback.msg} correo={regCorreo} fontSans={fontSans}
              style={{background:"rgba(220,38,38,0.08)", border:"1px solid rgba(220,38,38,0.30)", borderRadius:10, padding:"10px 14px", marginBottom:14, fontSize:13, color:"#DC2626", fontWeight:600}}/>
          ) : null}
          <div style={{display:"flex", gap:10}}>
            <button onClick={(ev)=>{ if (sePuedeCerrarElPanel(ev)) setMostrarRegistro(false); }} disabled={regGenerando}
              style={{flex:1, background:"rgba(22,36,71,0.06)", border:"none", borderRadius:12, padding:"12px", cursor:regGenerando?"not-allowed":"pointer", fontSize:13, fontWeight:600, color:"#4A4A60", fontFamily:fontSans}}>
              {regFeedback?.tipo==="ok" ? "Cerrar" : "Cancelar"}
            </button>
            {regFeedback?.tipo!=="ok" && (
              <button onClick={registrarTrabajador} disabled={regGenerando||!regNombre.trim()||!regCorreo.trim()}
                style={{flex:2, background:(regGenerando||!regNombre.trim()||!regCorreo.trim())?"rgba(0,0,0,0.08)":"#236478", border:"none", borderRadius:12, padding:"12px", cursor:(regGenerando||!regNombre.trim()||!regCorreo.trim())?"not-allowed":"pointer", fontSize:13, fontWeight:700, color:(regGenerando||!regNombre.trim()||!regCorreo.trim())?"#9A9AAA":"white", fontFamily:fontSans}}>
                {regGenerando ? "Creando cuenta..." : "Registrar"}
              </button>
            )}
          </div>
        </div>
      </div>
    )}
    {mostrarModalReporte && (()=>{
      // Cuarta copia de la misma fórmula, en la previa del PDF. Fuera: pregunta.
      const docsEmp = calcularCompliance((t as any).compliance);
      const pctDocs = docsEmp.porcentaje;
      const compliance = (t as any).compliance || {};   // solo para pintar las casillas
      // Actividades: MISMA fuente que la sección Actividades (colección `tareas`), acotadas
      // al MES DEL REPORTE (mesReporte) — reporte mensual, no histórico completo.
      const correoEmp = ((t as any).email || "").toLowerCase().trim();
      const tareasReporte = tareasDelMes(tareasTrab, mesReporte, mesActualYM());
      const susTareas = tareasReporte
        .filter((tar:any) => (tar.trabajadorEmail || "").toLowerCase() === correoEmp)
        .sort((a:any,b:any) => (a.fechaLimite||"9999-99-99").localeCompare(b.fechaLimite||"9999-99-99") || ((a.creadoEn?.toMillis?.()||0) - (b.creadoEn?.toMillis?.()||0)));
      const ctRep = calcularCumplimientoTareas(tareasReporte, correoEmp);
      const pctTareas = ctRep.porcentaje;
      const [yearStr, monthStr] = mesReporte.split("-");
      const nombreMesRaw = new Date(parseInt(yearStr), parseInt(monthStr)-1, 1).toLocaleString("es-MX",{month:"long",year:"numeric"});
      const nombreMes = nombreMesRaw.charAt(0).toUpperCase() + nombreMesRaw.slice(1);
      // La previa enseña la MISMA razón social que el PDF: la del trabajador en ese mes.
      const dpRepPrev = datosPatronDeRazon(razonSocialDelPeriodo(t, instanteDeMexico(parseInt(yearStr), parseInt(monthStr) - 1, new Date(parseInt(yearStr), parseInt(monthStr), 0).getDate(), 23, 59, 59, 999).getTime(), catalogos.razones), dpEmp);
      // Las mismas notas de la razón social que el PDF (12-oct-2026).
      const notasPrev = avisosDeRazonSocial(t, catalogos.razones, instanteDeMexico(parseInt(yearStr), parseInt(monthStr) - 1, 1, 0, 0, 0, 0).getTime(),
        instanteDeMexico(parseInt(yearStr), parseInt(monthStr) - 1, new Date(parseInt(yearStr), parseInt(monthStr), 0).getDate(), 23, 59, 59, 999).getTime());
      const hoy = new Date().toISOString().slice(0,10);
      const cerrar = ()=>!generandoPDF&&setMostrarModalReporte(false);

      return (
        <div style={{position:"fixed" as const, inset:0, background:"rgba(0,0,0,0.7)", display:"flex", alignItems:"flex-start", justifyContent:"center", zIndex:1000, padding:"24px 16px", overflowY:"auto" as const}}>
          <div {...PANEL_DE_CAPTURA} onClick={(e)=>e.stopPropagation()} style={{width:"100%", maxWidth:620, background:"#0F1D35", color:"#fff", borderRadius:16, border:"1px solid rgba(184,147,42,0.35)", overflow:"hidden" as const, fontFamily:fontSans}}>

            <div style={{padding:"16px 22px", borderBottom:"1px solid rgba(184,147,42,0.25)", display:"flex", alignItems:"center", justifyContent:"space-between"}}>
              <div>
                <p style={{margin:0, fontSize:14, fontWeight:600, color:"#F4C075"}}>Generar reporte individual</p>
                <p style={{margin:"2px 0 0", fontSize:11, color:"rgba(255,255,255,0.55)"}}>{t.nombre} · {t.puesto || "Sin puesto"}</p>
              </div>
              <button onClick={(ev)=>{ if (sePuedeCerrarElPanel(ev)) cerrar(); }} style={{background:"transparent", border:"none", color:"rgba(255,255,255,0.6)", fontSize:22, cursor:"pointer", padding:4, lineHeight:1}}>×</button>
            </div>

            <div style={{padding:"14px 22px", borderBottom:"1px solid rgba(184,147,42,0.15)", display:"flex", alignItems:"center", gap:10}}>
              <label style={{fontSize:10, textTransform:"uppercase" as const, letterSpacing:"0.5px", color:"rgba(255,255,255,0.6)", fontWeight:600}}>Periodo</label>
              <input {...CAMPO_DE_PARAMETRO} type="month" value={mesReporte} onChange={(e)=>setMesReporte(e.target.value)} style={{background:"rgba(255,255,255,0.06)", border:"1px solid rgba(184,147,42,0.3)", borderRadius:8, padding:"6px 10px", fontSize:12, color:"#F4C075", fontFamily:fontSans, colorScheme:"dark" as any}} />
            </div>

            <div style={{padding:"14px 22px", background:"rgba(0,0,0,0.18)", maxHeight:"55vh", overflowY:"auto" as const}}>
              <p style={{margin:"0 0 10px", fontSize:10, textTransform:"uppercase" as const, letterSpacing:"0.5px", color:"rgba(255,255,255,0.55)", fontWeight:600}}>Vista previa del PDF</p>

              <div style={{background:"#FFFFFF", color:"#1A1A1A", borderRadius:6, padding:"20px 22px"}}>

                <div style={{display:"flex", justifyContent:"space-between", alignItems:"flex-start", paddingBottom:10, borderBottom:"2px solid #B8932A"}}>
                  {/* La previa enseña el MISMO membrete que se va a imprimir. Si
                      aquí sale AXIS y en el papel sale la empresa, la previa deja
                      de servir para lo único que sirve. */}
                  <div>
                    {lineasMembretePatron(dpRepPrev) ? (<>
                      <p style={{margin:0, fontSize:12, color:"#0F172A", fontWeight:700}}>{lineasMembretePatron(dpRepPrev)!.denominacion}</p>
                      {lineasMembretePatron(dpRepPrev)!.rfc && <p style={{margin:"2px 0 0", fontSize:9, color:"#162447"}}>{lineasMembretePatron(dpRepPrev)!.rfc}</p>}
                      {lineasMembretePatron(dpRepPrev)!.domicilio && <p style={{margin:"2px 0 0", fontSize:8.5, color:"#6B7CB8", maxWidth:300, lineHeight:1.45}}>{lineasMembretePatron(dpRepPrev)!.domicilio}</p>}
                    </>) : null}
                    <p style={{margin:"2px 0 0", fontSize:9, color:"#555"}}>Reporte individual del empleado</p>
                  </div>
                  <div style={{textAlign:"right" as const, fontSize:9, color:"#555"}}>
                    <p style={{margin:0}}>Periodo: <strong style={{color:"#1A1A1A"}}>{nombreMes}</strong></p>
                    <p style={{margin:"2px 0 0"}}>Generado: {new Date().toLocaleDateString("es-MX",{day:"numeric",month:"short",year:"numeric"})}</p>
                  </div>
                </div>

                <div style={{margin:"12px 0 10px"}}>
                  <p style={{margin:0, fontSize:13, fontWeight:600, color:"#1A1A1A"}}>{t.nombre || "Sin nombre"}</p>
                  <p style={{margin:"2px 0 0", fontSize:10, color:"#666"}}>{t.puesto || "Sin puesto"}{t.fechaIngreso ? ` · Ingreso ${t.fechaIngreso}` : ""}</p>
                </div>

                <div style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap:8, margin:"12px 0"}}>
                  <div style={{background:"#F8F4E6", border:"1px solid #B8932A", borderRadius:4, padding:"9px 11px"}}>
                    <p style={{margin:"0 0 3px", fontSize:8, textTransform:"uppercase" as const, letterSpacing:"0.5px", color:"#6B5510", fontWeight:600}}>Expediente capturado</p>
                    <p style={{margin:0, fontSize:20, fontWeight:700, color:"#1A1A1A"}}>{pctDocs}%</p>
                    <div style={{height:4, background:"rgba(184,147,42,0.18)", borderRadius:2, marginTop:5, overflow:"hidden" as const}}>
                      <div style={{height:"100%", width:`${pctDocs}%`, background:"#B8932A"}}></div>
                    </div>
                    <p style={{margin:"4px 0 0", fontSize:9, color:"#555"}}>{docsEmp.obligatoriosCumplidos} de {docsEmp.totalObligatorios} obligatorios marcados</p>
                  </div>
                  <div style={{background:"#F4F8F4", border:"1px solid #4A7C4A", borderRadius:4, padding:"9px 11px"}}>
                    <p style={{margin:"0 0 3px", fontSize:8, textTransform:"uppercase" as const, letterSpacing:"0.5px", color:"#2C4A2C", fontWeight:600}}>Desempeño en actividades</p>
                    <p style={{margin:0, fontSize:20, fontWeight:700, color:"#1A1A1A"}}>{pctTareas}%</p>
                    <div style={{height:4, background:"rgba(74,124,74,0.18)", borderRadius:2, marginTop:5, overflow:"hidden" as const}}>
                      <div style={{height:"100%", width:`${pctTareas}%`, background:"#4A7C4A"}}></div>
                    </div>
                    <p style={{margin:"4px 0 0", fontSize:9, color:"#555"}}>{ctRep.confirmadas} de {ctRep.total} actividades confirmadas</p>
                  </div>
                </div>
                {/* La MISMA aclaración que va impresa en el PDF, en el MISMO sitio.
                    Si la previa y el papel no dicen lo mismo, la previa deja de
                    servir para lo único que sirve: ver qué vas a mandar. */}
                <p style={{margin:"0 0 10px", fontSize:8.5, color:"#777", lineHeight:1.4, fontStyle:"italic"}}>
                  {NOTA_EXPEDIENTE_CAPTURADO}
                </p>

                <div style={{margin:"14px 0 6px", paddingBottom:4, borderBottom:"1px solid #ddd"}}>
                  <p style={{margin:0, fontSize:11, fontWeight:600, color:"#B8932A", letterSpacing:"0.3px"}}>DOCUMENTOS LEGALES</p>
                </div>
                <div style={{fontSize:10, color:"#1A1A1A"}}>
                  {COMPLIANCE_ITEMS.slice(0, 5).map((item:any) => {
                    const estado = compliance[item.key] || "pendiente";
                    return (
                      <div key={item.key} style={{display:"flex", padding:"4px 0", borderBottom:"0.5px solid #eee"}}>
                        <span style={{width:16, color: estado === "ok" ? "#059669" : estado === "na" ? "#888" : "#B8932A", fontWeight:700}}>
                          {estado === "ok" ? "✓" : estado === "na" ? "—" : "○"}
                        </span>
                        <span style={{flex:1}}>{item.label}</span>
                        <span style={{color:"#888", fontSize:9}}>{item.baseLegal}</span>
                      </div>
                    );
                  })}
                  {COMPLIANCE_ITEMS.length > 5 && (
                    <p style={{margin:"6px 0 0", fontSize:9.5, color:"#888", fontStyle:"italic"}}>… {COMPLIANCE_ITEMS.length - 5} documentos más en el PDF completo</p>
                  )}
                </div>

                <div style={{margin:"14px 0 6px", paddingBottom:4, borderBottom:"1px solid #ddd"}}>
                  <p style={{margin:0, fontSize:11, fontWeight:600, color:"#B8932A", letterSpacing:"0.3px"}}>ACTIVIDADES ASIGNADAS</p>
                </div>
                <div style={{fontSize:10, color:"#1A1A1A"}}>
                  {susTareas.length === 0 ? (
                    <p style={{margin:"4px 0 0", fontSize:10, color:"#888", fontStyle:"italic"}}>Sin actividades asignadas.</p>
                  ) : susTareas.map((tar:any, idx:number) => {
                    const conf = !!tar.confirmadaPorPatron;
                    const marc = !!tar.marcadaPorTrabajador;
                    const vencida = !conf && tar.fechaLimite && tar.fechaLimite < hoy;
                    const estadoLabel = conf ? "Confirmada" : (marc ? "Por confirmar" : (vencida ? "Vencida" : "Pendiente"));
                    let badgeBg = "#F1F1F1", badgeTxt = "#6E6E6E";
                    if (conf) { badgeBg = "#E6F4EA"; badgeTxt = "#1B5E20"; }
                    else if (marc) { badgeBg = "#FBF1DA"; badgeTxt = "#6B5510"; }
                    else if (vencida) { badgeBg = "#FCE8E8"; badgeTxt = "#8B1414"; }
                    return (
                      <div key={idx} style={{padding:"5px 0", borderBottom:"0.5px solid #eee", display:"flex", gap:8, alignItems:"flex-start"}}>
                        <span style={{flex:1}}>
                          {tar.titulo || tar.descripcion}
                          <span style={{display:"block", color:"#777", fontSize:9}}>
                            {tar.fechaLimite ? `Límite ${tar.fechaLimite}` : "Sin fecha límite"}{tar.fechaConfirmada?.toDate?.() ? ` · Confirmada ${tar.fechaConfirmada.toDate().toLocaleDateString("es-MX")}` : ""}
                          </span>
                        </span>
                        <span style={{background:badgeBg, color:badgeTxt, padding:"2px 6px", borderRadius:3, fontSize:9, fontWeight:600, whiteSpace:"nowrap" as const}}>{estadoLabel}</span>
                      </div>
                    );
                  })}
                </div>

                {notasPrev.length > 0 && (
                  <div data-notas-razon-previa style={{margin:"14px 0 0"}}>
                    <p style={{margin:"0 0 4px", fontSize:11, fontWeight:600, color:"#B8932A", letterSpacing:"0.3px"}}>NOTAS</p>
                    {notasPrev.map((n:string, i:number)=> <p key={i} style={{margin:"2px 0", fontSize:9.5, color:"#444", lineHeight:1.45}}>{n}</p>)}
                  </div>
                )}

                <div style={{marginTop:16, paddingTop:8, borderTop:"1px solid #ddd", display:"flex", justifyContent:"space-between", fontSize:8.5, color:"#888"}}>
                  <span>{pieDelPatronTexto(dpRepPrev, fechaHoraLargaAxis())}</span>
                  <span>1 / 1</span>
                </div>
              </div>
            </div>

            <div style={{padding:"14px 22px", display:"flex", justifyContent:"flex-end", gap:10, borderTop:"1px solid rgba(184,147,42,0.15)"}}>
              <button onClick={(ev)=>{ if (sePuedeCerrarElPanel(ev)) cerrar(); }} disabled={generandoPDF} style={{padding:"10px 16px", borderRadius:10, background:"rgba(255,255,255,0.08)", color:"rgba(255,255,255,0.75)", fontSize:12, cursor:generandoPDF?"not-allowed":"pointer", fontFamily:fontSans, border:"1px solid rgba(255,255,255,0.1)"}}>Cerrar</button>
              <button onClick={generarReportePDF} disabled={generandoPDF} style={{padding:"10px 18px", borderRadius:10, background: generandoPDF ? "rgba(184,147,42,0.5)" : "linear-gradient(135deg,#B8932A,#F4C075)", color:"#0F1D35", fontSize:12, fontWeight:700, cursor:generandoPDF?"not-allowed":"pointer", border:"none", fontFamily:fontSans}}>{generandoPDF ? "Generando..." : "Descargar PDF"}</button>
            </div>

          </div>
        </div>
      );
    })()}
    </>
  );
  }
  
  // ── LISTA ──
  const statsGlobal = calcularComplianceGlobal(activos);
  return (
    <div style={{background:UI.fondo, minHeight:`calc(100vh - 100px - ${ZOCALO_FLOTANTES}px)`, fontFamily:fontSans}}>
    <style>{`
          .emp-card { transition: all 0.35s cubic-bezier(0.34, 1.56, 0.64, 1); }
          .emp-card:hover { transform: translateY(-4px); border-color: rgba(184,147,42,0.35) !important; box-shadow: 0 12px 32px rgba(184,147,42,0.14); }
            .emp-btn { transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1); }
            .emp-btn:hover { transform: translateY(-2px); box-shadow: 0 6px 18px rgba(184,147,42,0.35) !important; }
            .emp-btn:active { transform: translateY(0) scale(0.97); }
            .emp-step { transition: all 0.35s cubic-bezier(0.34, 1.56, 0.64, 1); padding: 4px 8px; border-radius: 8px; }
            .emp-step:hover { transform: translateY(-2px); background: rgba(184,147,42,0.06); }
            .emp-filter { transition: all 0.25s cubic-bezier(0.34, 1.56, 0.64, 1); }
            .emp-filter:hover { transform: translateY(-1px); border-color: rgba(184,147,42,0.45) !important; }
            .emp-card input::placeholder, .emp-card textarea::placeholder { color: #9CA3AF; }
            .emp-card input:focus, .emp-card textarea:focus { border-color: rgba(184,147,42,0.5) !important; background: #FFFFFF !important; }
        `}</style>
      {/* GUÍA DE ARRANQUE — orienta el día uno y estorba después: se pliega y la
          preferencia se recuerda. Los accesos reales (Agregar, Importar) viven en
          la barra de acciones, así que plegar esto no esconde ninguna función. */}
      <div style={{padding:isMobile?"10px 14px 0":"12px 18px 0"}}>
        <TiraPlegable abierto={guiaAbierta} onAlternar={alternarGuia} fontSans={fontSans} texto="Cómo funciona · 3 pasos"/>
      </div>
      {guiaAbierta && (
      <div style={{padding:isMobile?"12px 14px 0":"14px 18px 0"}}>
        <div style={{background:"linear-gradient(135deg,rgba(184,147,42,0.10),rgba(14,165,233,0.06))", border:`1px solid ${T_LIGHT.goldBorder}`, borderRadius:10, padding:isMobile?"10px 14px":"12px 16px", display:"flex", gap:isMobile?10:14, alignItems:isMobile?"stretch":"stretch" as const, flexDirection:isMobile?"column" as const:"row" as const}}>
          <div style={{display:"flex", flexDirection:"column" as const, justifyContent:"center", minWidth:isMobile?0:100, borderRight:isMobile?"none":`1px solid ${T_LIGHT.goldBorder}`, paddingRight:isMobile?0:14, paddingBottom:isMobile?8:0, borderBottom:isMobile?`1px solid ${T_LIGHT.goldBorder}`:"none"}}>
            <div style={{fontSize:10, color:T_LIGHT.gold, textTransform:"uppercase" as const, letterSpacing:1, fontWeight:700, marginBottom:3, fontFamily:fontSans}}>Cómo funciona</div>
            <div style={{fontSize:11, color:T_LIGHT.textInkSoft, lineHeight:1.4}}>3 pasos para tener el expediente en orden</div>
          </div>
          <div style={{display:"flex", gap:isMobile?8:14, flex:1, flexDirection:isMobile?"column" as const:"row" as const, alignItems:isMobile?"stretch":"center" as const}}>
            {[
              {num:"1", text:"Da de alta", desc:" a cada trabajador con sus datos"},
              {num:"2", text:"Sube documentos", desc:" y marca cada obligación legal"},
              {num:"3", text:"Revisa el expediente", desc:" y genera recibos de nómina"},
            ].map(s => (
              <div key={s.num} className="emp-step" style={{display:"flex", alignItems:"center", gap:10, flex:isMobile?"initial":1, width:isMobile?"100%":"auto"}}>
                <div style={{width:isMobile?24:22, height:isMobile?24:22, borderRadius:"50%", background:T_LIGHT.goldSoft, border:`1px solid ${T_LIGHT.goldBorder}`, color:T_LIGHT.gold, fontFamily:fontSerif, fontSize:isMobile?13:12, fontWeight:700, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0}}>{s.num}</div>
                <div style={{fontSize:isMobile?12:11, color:T_LIGHT.textInkSoft, lineHeight:1.4, flex:1, minWidth:0}}><strong style={{color:T_LIGHT.textInk, fontWeight:700}}>{s.text}</strong>{s.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      )}

      <div style={{maxWidth:ANCHO_CONTENIDO, margin:"0 auto", padding:isMobile?"16px":"18px 24px"}}>
        {/* ── INDICADORES ── filete superior por tipo, icono en cuadro tintado,
             número en serifa, etiqueta legible y micro-contexto REAL (sin gráficas
             decorativas: no hay historia detrás de estos números). */}
        {(()=>{
          const totalReg = trabajadores.length;
          const ymHoy = new Date();
          const altasMes = trabajadores.filter((t:any)=>{ const d=t.timestamp?.toDate?.(); return d && d.getFullYear()===ymHoy.getFullYear() && d.getMonth()===ymHoy.getMonth(); }).length;
          const nominaMes = activos.reduce((s,t)=>s+salMensualDe(t),0);
          const kpis = [
            {label:"Activos", val:String(activos.length), icon:"user_single", tono:UI.navy,
             micro: altasMes>0 ? `${altasMes} alta${altasMes===1?"":"s"} este mes` : `de ${totalReg} registrado${totalReg===1?"":"s"}`, pct:null as number|null},
            // Cumplimiento: si nadie tiene nada capturado no hay porcentaje que
            // dar — decirlo "0%" acusaría de incumplir a quien sólo no ha
            // registrado. Coincide con lo que dicen las filas de la tabla.
            // NO ES CUMPLIMIENTO LEGAL, Y LLAMARLO ASÍ AFIRMA ALGO QUE ESTA
            // PLATAFORMA NO PUEDE SABER. El número sale de `calcularCompliance`, que
            // cuenta cuántas casillas de la lista de veinte MARCÓ EL PATRÓN como
            // "ok" —marcas manuales, no documentos verificados— sobre los
            // empleados que tienen alguna marca puesta.
            //
            // O sea: mide cuánto se ha capturado aquí, y ni siquiera qué se
            // subió. Que un patrón tenga el expediente al 40% en la plataforma no
            // dice nada sobre si cumple la ley; puede tenerlo todo en papel en un
            // archivero. Decirle "Cumplimiento legal 40%" es una acusación que
            // nadie ha comprobado, y en rojo.
            {label:"Expediente capturado",
             val: statsGlobal.evaluados===0 ? "Sin registrar" : statsGlobal.porcentaje+"%",
             icon:"scale_simple",
             tono: statsGlobal.evaluados===0 ? UI.neutro : statsGlobal.porcentaje>=80?UI.ok:statsGlobal.porcentaje>=50?UI.ambar:UI.rojo,
             micro: statsGlobal.total===0 ? "sin empleados activos"
                  : statsGlobal.evaluados===0 ? "aún sin documentos capturados"
                  : statsGlobal.evaluados<statsGlobal.total ? `${statsGlobal.evaluados} de ${statsGlobal.total} con algo capturado`
                  : statsGlobal.enRiesgo>0 ? `${statsGlobal.enRiesgo} con menos del 70% capturado` : "todos con más del 70% capturado",
             // LA LETRA PEQUEÑA, A LA VISTA. "Expediente capturado" ya no acusa de
             // incumplir, pero todavía insinúa que hay algo cargado, y no lo hay:
             // el número sale de casillas que el patrón marca a mano. Quien lee el
             // número tiene que leer de dónde sale, en la misma tarjeta y sin
             // pasar por Ayuda.
             nota: "según las casillas que has marcado en cada expediente",
             pct: statsGlobal.evaluados===0 ? null : statsGlobal.porcentaje},
            {label:"Alertas", val:String(conAlerta.length), icon:"alert",
             tono: conAlerta.length>0?UI.ambar:UI.ok,
             micro: conAlerta.length>0 ? "empleados por atender" : "nada por atender", pct:null},
            {label:"Nómina mensual", val:"$"+nominaMes.toLocaleString("es-MX",{maximumFractionDigits:0}), icon:"money", tono:UI.navy,
             micro: activos.length>0 ? `${activos.length} sueldo${activos.length===1?"":"s"} activo${activos.length===1?"":"s"}` : "sin sueldos registrados", pct:null},
          ];
          return (
            <div style={{display:"grid", gridTemplateColumns:isMobile?"repeat(2,1fr)":"repeat(4,1fr)", gap:12, marginBottom:18}}>
              {kpis.map((s,i) => (
                <IndicadorTarjeta key={i}
                  etiqueta={s.label} valor={s.val} icono={s.icon} tono={s.tono}
                  micro={s.micro} nota={(s as any).nota} pct={s.pct} isMobile={isMobile} fontSerif={fontSerif}/>
              ))}
            </div>
          );
        })()}

        {/* ── FILTROS vs ACCIONES ── el segmentado FILTRA (navy), los botones con
             contorno EJECUTAN, y el dorado se reserva a la única acción principal. */}
        <div style={{display:"flex", gap:10, marginBottom:14, flexWrap:"wrap" as const, alignItems:"center"}}>
          <input {...CAMPO_DE_PARAMETRO} value={busqueda} onChange={e=>setBusqueda(e.target.value)} placeholder="Buscar por nombre o puesto…"
            style={{flex:1, minWidth:220, background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rControl, padding:"9px 13px", color:UI.texto, fontSize:UI.fsCuerpo, outline:"none", fontFamily:fontSans, boxSizing:"border-box" as const}} />

          {/* Control SEGMENTADO (filtro) */}
          <SegmentadoFiltro fontSans={fontSans} valor={filtroStatus} onCambio={setFiltroStatus}
            opciones={[{v:"todos" as const, t:"Todos"}, {v:"activo" as const, t:"Activos"}, {v:"baja" as const, t:"Bajas"}]}/>

          {/* Filtro por ÁREA (solo si hay áreas capturadas) */}
          {areasDisponibles.length>0 && (
            <select {...CAMPO_DE_PARAMETRO} value={filtroArea} onChange={e=>setFiltroArea(e.target.value)} title="Filtrar por área o departamento"
              style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rControl, padding:"8px 12px",
                fontSize:UI.fsEtiqueta, color:filtroArea?UI.texto:UI.textoTenue, fontWeight:filtroArea?700:600, fontFamily:fontSans, cursor:"pointer", outline:"none"}}>
              <option value="">Todas las áreas</option>
              {areasDisponibles.map(a=>(<option key={a} value={a}>{a}</option>))}
            </select>
          )}

          {/* ACCIONES secundarias: contorno navy + icono */}
          {[
            {t:"Resumen", fn:()=>{setVista("resumen"); setBusqueda("");}, ic:"scale_simple", ti:"Resumen general del equipo"},
            {t:"Importar Excel", fn:()=>setVerImportar(true), ic:"clipboard", ti:"Importar lista desde Excel o CSV"},
            {t:"Importar con IA", fn:()=>setVerImportarIA(true), ic:"document", ti:"La IA lee un PDF o Word y propone los empleados para que los revises antes de guardar"},
            // SEDES (11-oct-2026): dónde trabaja cada quien, y contra qué se mide su checada.
            {t:"Sedes", fn:()=>setVerSedes(true), ic:"pin", ti:"Las sedes de tu empresa: dónde checa cada trabajador"},
            {t:"Asignar sede", fn:()=>setVerAsignarSede(true), ic:"user_single", ti:"Asignar una sede a varios trabajadores a la vez"},
          ].map((b,i)=>(
            <BotonSecundario key={i} texto={b.t} onClick={b.fn} icono={b.ic} title={b.ti} fontSans={fontSans}/>
          ))}

          {/* ÚNICA acción principal: dorada */}
          <BotonPrimario className="emp-btn" texto="+ Agregar trabajador" fontSans={fontSans}
            onClick={()=>{setForm(formVacio);setSeleccionado(null);setCrearAcceso(false);setAltaAccesoError(null);setVista("form");}}/>
        </div>
        {/* CUENTAS SIN VINCULAR (11-oct-2026; pendiente de la fase 2c): trabajadores con
            cuenta del portal cuya ficha no lleva su cuentaUid. Su teléfono no lee su ficha:
            ni su sede ni su horario propio (mide contra la sede principal y el horario general). */}
        {(()=>{
          const correos = new Set<string>((cuentasTrab||[]).filter((c:any)=> c && c.activo !== false && c.uid).map((c:any)=> String(c.email||"").toLowerCase().trim()).filter(Boolean));
          const sinVinc = fichasConCuentaSinVincular(trabajadores, correos);
          if (!sinVinc.length) return null;
          return (
            <div data-cuentas-sin-vincular={sinVinc.length} title={sinVinc.map((f:any)=> f.nombre || f.email).join(", ")}
              style={{marginBottom:12, background:"rgba(184,147,42,0.10)", border:"1px solid rgba(184,147,42,0.35)", borderRadius:10, padding:"8px 12px", fontSize:12.5, color:"#7A5F12", lineHeight:1.5}}>
              <b>{sinVinc.length} trabajador{sinVinc.length===1?"":"es"} con cuenta sin vincular</b>
              {" · "}{sinVinc.slice(0, 4).map((f:any)=> f.nombre || f.email).join(", ")}{sinVinc.length > 4 ? "…" : ""}.
              {" Su teléfono no puede leer su ficha: mide contra la sede principal y con el horario general. Vincula cada una desde su ficha."}
            </div>
          );
        })()}
        {verSedes && <SedesEmpresa currentUser={currentUser} catalogos={catalogos} trabajadores={trabajadores} fontSans={fontSans} fontSerif={fontSerif}
          onCambio={()=> setTickCatalogos((n)=> n + 1)} onCerrar={()=> setVerSedes(false)}/>}
        {verAsignarSede && <AsignarSedeVarios currentUser={currentUser} catalogos={catalogos} trabajadores={trabajadores} fontSans={fontSans} fontSerif={fontSerif}
          onTerminar={()=>{ setVerAsignarSede(false); cargar(); }} onCerrar={()=> setVerAsignarSede(false)}/>}

        {verImportar && (
          <ImportadorLote
            titulo="Importar empleados"
            campos={camposImportEmpleado}
            existentes={trabajadores}
            firmaFila={firmaEmpleado}
            opcionesGlobales={opcSalario}
            columnaCalculada={colSalarioDiario}
            validarFilaExtra={validarSalarioLote}
            notaSuperior="Se guardan el salario mensual y el diario (el diario es la base legal de prestaciones/IMSS; factor ÷ 30, Art. 89 LFT). Elige en el paso de mapeo si tu columna es mensual o diaria; verás ambos en la previsualización. Los duplicados (por RFC, correo o nombre+fecha de ingreso) se detectan y avisan; desmarca los que no quieras importar."
            onGuardarFila={guardarEmpleadoImportado}
            onTerminar={()=>{ setVerImportar(false); cargar(); }}
            onCerrar={()=>setVerImportar(false)}
            fontSans={fontSans} fontSerif={fontSerif} gold={T_LIGHT.gold}
          />
        )}

        {verImportarIA && (
          <ImportadorIADocumento
            titulo="Importar empleados"
            campos={camposImportEmpleado}
            existentes={trabajadores}
            firmaFila={firmaEmpleado}
            opcionesGlobales={opcSalario}
            columnaCalculada={colSalarioDiario}
            validarFilaExtra={validarSalarioLote}
            onGuardarFila={guardarEmpleadoImportado}
            entidad={{singular:"empleado", plural:"empleados"}}
            onTerminar={()=>{ setVerImportarIA(false); cargar(); }}
            onCerrar={()=>setVerImportarIA(false)}
            fontSans={fontSans} fontSerif={fontSerif} gold={T_LIGHT.gold}
          />
        )}

        {/* ── TABLA DE EMPLEADOS ──────────────────────────────────────────────
             Scroll con encabezado FIJO (sin paginación): con 100+ empleados el
             scroll continuo escanea mejor que paginar, y los datos ya están en
             memoria — paginar solo añadiría clics. Una sola ruta por acción: la
             fila abre la ficha y desde ahí se actúa (mismo criterio que el
             expediente). Sin iconos repetidos por celda: serían ruido al escanear. */}
        {cargando ? (
          <div style={{textAlign:"center" as const, padding:60, color:UI.textoSuave, background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rPanel}}>Cargando expedientes…</div>
        ) : filtrados.length === 0 ? (
          <EstadoVacio
            titulo={trabajadores.length===0 ? "Aún no hay trabajadores" : "Ningún trabajador coincide"}
            texto={trabajadores.length===0
              ? "Da de alta a tu plantilla para llevar su expediente, sus prestaciones y su cumplimiento en un solo lugar. Puedes capturarlos uno por uno o importarlos de una lista que ya tengas."
              : "Prueba con otro texto de búsqueda, cambia el filtro de estado o quita el filtro de área."}
            acciones={trabajadores.length===0 ? [
              {t:"+ Agregar trabajador", principal:true, fn:()=>{setForm(formVacio);setSeleccionado(null);setCrearAcceso(false);setAltaAccesoError(null);setVista("form");}},
              {t:"Importar desde Excel", principal:false, fn:()=>setVerImportar(true)},
              {t:"Importar con IA", principal:false, fn:()=>setVerImportarIA(true)},
            ] : [
              // TODOS los filtros, no casi todos. Un botón que promete quitarlos y
              // deja uno puesto es peor que no tenerlo: el que quedaba era el del
              // checador, y encima era invisible.
              {t:"Quitar filtros", principal:false, fn:()=>{ setBusqueda(""); setFiltroArea(""); setFiltroStatus("todos"); }},
            ]}
            variante={trabajadores.length===0 ? "sin-datos" : "sin-coincidencias"}
            fontSans={fontSans} fontSerif={fontSerif}
          />
        ) : (
          <div>
          {/* ── LO QUE HUELE MAL, ANTES DE LA TABLA ─────────────────────────
              Se señala y se explica; no se arregla solo. Y va arriba porque el
              patrón tiene que verlo ANTES de creerse la lista. */}
          {(()=>{ const sosp = sospechasDeLaLista(trabajadores, cuentasTrab); if (!sosp.length) return null; return (
            <div style={{background:"rgba(184,147,42,0.08)", border:"1px solid rgba(184,147,42,0.32)", borderRadius:12, padding:"12px 15px", marginBottom:12}}>
              <div style={{fontSize:12.5, fontWeight:800, color:"#7A5F12", marginBottom:7}}>
                {sosp.length===1 ? "Hay algo que revisar en la lista" : `Hay ${sosp.length} cosas que revisar en la lista`}
              </div>
              <div style={{display:"flex", flexDirection:"column" as const, gap:5}}>
                {sosp.map((s:any, i:number)=>(
                  <div key={i} style={{fontSize:12, color:"#5A4A18", lineHeight:1.55}}>
                    <b style={{color:"#3F340F"}}>{s.nombre}</b>{" — "}{s.detalle}
                    {s.clase==="duplicada" && <span style={{color:"#7A5F12"}}>{". "}El checador solo ve la que tiene el correo de la cuenta.</span>}
                  </div>
                ))}
              </div>
              <div style={{fontSize:11, color:"#8A7434", marginTop:8, lineHeight:1.5}}>
                La plataforma no junta fichas por su cuenta: tocaría checadas, actividades, documentos y nómina. Revísalas tú.
              </div>
            </div>
          ); })()}
          {/* ── DÓNDE SE TOPA CON LA CONSECUENCIA ───────────────────────────
              Nadie con cuenta = el checador y la bitácora de flotilla no pueden
              funcionar. Se dice aquí, que es donde se ve la plantilla, y no en un
              manual. Si la colección no se ha leído, no se afirma nada. */}
          {cuentasTrab !== null && trabajadores.length > 0 && correosConCuentaActiva(cuentasTrab).size === 0 && (
            <div style={{background:"rgba(35,100,120,0.07)", border:"1px solid rgba(35,100,120,0.28)", borderRadius:12, padding:"12px 15px", marginBottom:12}}>
              <div style={{fontSize:12.5, fontWeight:800, color:"#1B4F5F", marginBottom:4}}>Nadie de tu equipo tiene cuenta todavía</div>
              <div style={{fontSize:12, color:"#2A5C6B", lineHeight:1.6}}>
                El enlace con el trabajador funciona <b>solo mediante su cuenta</b>: sin ella no puede checar entrada y salida,
                {" "}ni registrar movimientos de flotilla, ni marcar sus actividades. La ficha guarda su expediente; la cuenta es lo que lo conecta.
                {" "}Se crea desde su ficha, en la pestaña <b>Acceso</b>, con su correo.
              </div>
            </div>
          )}
          <div style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rPanel, boxShadow:UI.sombra, overflow:"hidden"}}>
            {/* Filete dorado de marca bajo el borde superior (ornamento, no dato) */}
            <div style={{height:2, background:`linear-gradient(90deg, ${UI.oro}, ${UI.oro}00)`}}/>
            {/* Se descuenta el zócalo de los flotantes: la última fila y su
                "Ver ficha ›" tienen que quedar por encima del búho. */}
            <div style={{maxHeight:`calc(100vh - 380px - ${ZOCALO_FLOTANTES}px)`, minHeight:220, overflowY:"auto" as const, overflowX:"auto" as const}}>
              <table style={{width:"100%", borderCollapse:"separate" as const, borderSpacing:0, minWidth:900}}>
                <EncabezadoTabla ordenCol={ordenCol} ordenDir={ordenDir}
                  onOrdenar={(col,dir)=>{ setOrdenCol(col as any); setOrdenDir(dir); }}
                  columnas={[
                    {k:"nombre", t:"Trabajador", orden:true, al:"left"},
                    ...(areasDisponibles.length>0 ? [{k:"area", t:"Área", orden:false, al:"left" as const}] : []),
                    {k:"antiguedad", t:"Antigüedad", orden:true, al:"left"},
                    {k:"salario", t:"Salario mensual", orden:false, al:"right"},
                    {k:"acceso", t:"Acceso", orden:false, al:"center"},
                    {k:"cumpl", t:"Expediente", orden:false, al:"left"},
                    {k:"acc", t:"", orden:false, al:"right"},
                  ]}/>
                <tbody>
                  {filtrados.map(t => {
                    const compCalc = calcularCompliance(t.compliance);
                    const pct = compCalc.porcentaje;
                    // Sin registro ≠ incumplido (mismo criterio que el estado documental
                    // de vehículos): si nunca se evaluó, no se pinta un 0% en rojo.
                    const sinRegistro = !t.compliance || Object.keys(t.compliance).length === 0;
                    const tonoPct = pct>=80?UI.ok : pct>=50?UI.ambar : UI.rojo;
                    const alertas = calcularAlertas(t);
                    const incompleto = t.datosCompletos === false || !t.puesto || !t.salarioDiario || !t.fechaIngreso;
                    const emailEmp = (t.email||"").toLowerCase().trim();
                    const cuentaEmp = emailEmp ? (cuentasTrab||[]).find((c:any)=>(c.email||"").toLowerCase()===emailEmp) : null;
                    const acceso = !cuentaEmp ? {texto:"Sin cuenta", tono:"neutro" as const}
                                 : cuentaEmp.activo===false ? {texto:TEXTO_CUENTA_SUSPENDIDA, tono:"critico" as const}
                                 : {texto:"Con cuenta", tono:"ok" as const};
                    const antig = t.fechaIngreso ? calcularAntiguedad(t.fechaIngreso) : "—";
                    return (
                      <tr key={t.id}
                        ref={t.id === _primerSinChecar ? _resSinChecar.ref : undefined}
                        onClick={()=>{setSeleccionado(t);setVista("detalle");setMesTareasSel("");}}
                        onMouseEnter={(e)=>{ e.currentTarget.style.background = UI.hover; }}
                        onMouseLeave={(e)=>{ e.currentTarget.style.background = "transparent"; }}
                        style={{cursor:"pointer",
                          ...estiloResaltado(t.id === _primerSinChecar && _resSinChecar.vivo, "fila")}}>
                        {/* Trabajador */}
                        <td style={{padding:"11px 14px", borderTop:`1px solid ${UI.divisor}`}}>
                          <div style={{display:"flex", alignItems:"center", gap:11, minWidth:0}}>
                            <AvatarPersona nombre={t.nombre||""} fotoUrl={(t as any).fotoPerfilUrl} size={34} fontSerif={fontSerif}/>
                            <div style={{minWidth:0}}>
                              <div style={{display:"flex", alignItems:"center", gap:7, minWidth:0}}>
                                <span style={{fontFamily:fontSerif, fontSize:UI.fsNombre, fontWeight:700, color:UI.texto,
                                  whiteSpace:"nowrap" as const, overflow:"hidden", textOverflow:"ellipsis"}}>{t.nombre}</span>
                                {/* La fecha va EN el chip: "Baja" a secas obliga a
                                    abrir el expediente para saber cuándo salió, que
                                    es justo lo que se necesita para distinguir a dos
                                    bajas entre sí. El dato ya se guardaba desde
                                    siempre; solo no se mostraba. */}
                                {/* SIN CHECAR HOY, en su propia fila y pulsable: abre
                                    su ficha, que es donde está su asistencia. Sale de
                                    la MISMA lista que alimenta el aviso de Inicio, así
                                    que las dos pantallas no pueden señalar a personas
                                    distintas. */}
                                {t.status!=="baja" && marcadosSinChecar.has((t.email||"").toLowerCase().trim()) && (
                                  <ChipEstado texto="Sin checar hoy" tono="ambar"
                                    title="Tiene cuenta y horario, hoy es día laborable para esta persona y su hora de entrada ya pasó."/>
                                )}
                                {t.status==="baja" && <ChipEstado
                                  texto={(t as any).fechaBaja ? `Baja · ${_fechaCortaMX((t as any).fechaBaja)}` : "Baja"}
                                  tono="neutro"
                                  title={(t as any).fechaBaja ? `Dado de baja el ${(t as any).fechaBaja}` : "Sin fecha de baja registrada"}/>}
                                {incompleto && t.status!=="baja" && <ChipEstado texto="Datos pendientes" tono="pendiente" title="Faltan datos del expediente"/>}
                                {alertas.length>0 && <ChipEstado texto="!" tono="critico" title={alertas[0]}/>}
                              </div>
                              <div style={{fontSize:UI.fsEtiqueta, color:UI.textoTenue, marginTop:2,
                                whiteSpace:"nowrap" as const, overflow:"hidden", textOverflow:"ellipsis"}}>{t.puesto || "Sin puesto"}</div>
                            </div>
                          </div>
                        </td>
                        {/* Área */}
                        {areasDisponibles.length>0 && (
                          <td style={{padding:"11px 14px", borderTop:`1px solid ${UI.divisor}`, fontSize:UI.fsCuerpo, color:UI.textoSuave, whiteSpace:"nowrap" as const}}>{t.departamento || "—"}</td>
                        )}
                        {/* Antigüedad */}
                        <td style={{padding:"11px 14px", borderTop:`1px solid ${UI.divisor}`, fontSize:UI.fsCuerpo, color:UI.textoSuave, whiteSpace:"nowrap" as const}}>{antig}</td>
                        {/* Salario */}
                        <td style={{padding:"11px 14px", borderTop:`1px solid ${UI.divisor}`, fontSize:UI.fsCuerpo, color:UI.texto, fontWeight:600, textAlign:"right" as const, whiteSpace:"nowrap" as const}}>
                          {t.salarioDiario>0 ? fmtMXN2(salMensualDe(t)) : <span style={{color:UI.textoTenue, fontWeight:400}}>Sin salario</span>}
                        </td>
                        {/* Acceso */}
                        <td style={{padding:"11px 14px", borderTop:`1px solid ${UI.divisor}`, textAlign:"center" as const}}>
                          <ChipEstado texto={acceso.texto} tono={acceso.tono}/>
                        </td>
                        {/* Expediente */}
                        <td style={{padding:"11px 14px", borderTop:`1px solid ${UI.divisor}`, minWidth:150}}>
                          {sinRegistro ? (
                            <span style={{fontSize:UI.fsEtiqueta, color:UI.textoTenue}}>Sin registrar</span>
                          ) : (
                            <div style={{display:"flex", alignItems:"center", gap:9}}>
                              <div style={{flex:1, height:6, background:UI.divisor, borderRadius:999, overflow:"hidden", minWidth:60}}>
                                <div style={{height:"100%", width:`${Math.max(0,Math.min(100,pct))}%`, background:tonoGrafico(tonoPct), borderRadius:999}}/>
                              </div>
                              <span style={{fontSize:UI.fsEtiqueta, fontWeight:700, color:tonoPct, minWidth:34, textAlign:"right" as const}}>{pct}%</span>
                            </div>
                          )}
                        </td>
                        {/* Acción única */}
                        <td style={{padding:"11px 14px", borderTop:`1px solid ${UI.divisor}`, textAlign:"right" as const, whiteSpace:"nowrap" as const}}>
                          <span style={{fontSize:UI.fsEtiqueta, fontWeight:700, color:UI.navy}}>Ver ficha ›</span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div style={{padding:"9px 14px", borderTop:`1px solid ${UI.divisor}`, fontSize:10.5, color:UI.textoTenue, background:UI.superficie}}>
              {/* DOS NÚMEROS QUE DICEN QUÉ CUENTAN. "Mostrando 2 de 15 registrados"
                  junto a un contador de "12 activos" eran tres cifras sobre la misma
                  gente sin decir cuál medía qué. */}
              Se ven {filtrados.length} de {trabajadores.length} ficha{trabajadores.length===1?"":"s"}
              {" "}({trabajadores.filter(t=>t.status==="activo").length} activa{trabajadores.filter(t=>t.status==="activo").length===1?"":"s"}
              {trabajadores.some(t=>t.status==="baja") ? ` y ${trabajadores.filter(t=>t.status==="baja").length} de baja` : ""})
              {filtroStatus==="activo" && trabajadores.some(t=>t.status==="baja") ? " · las bajas se ven con el filtro “Bajas”" : ""}
            </div>
          </div>
          </div>
        )}
      </div>

      {/* Resultado del alta con cuenta de acceso (contraseña temporal a compartir) */}
      {altaAccesoResult && (
        <div onClick={()=>setAltaAccesoResult(null)} style={{position:"fixed" as const, inset:0, background:"rgba(0,0,0,0.55)", zIndex:500, display:"flex", alignItems:"center", justifyContent:"center", padding:20, backdropFilter:"blur(4px)"}}>
          <div onClick={e=>e.stopPropagation()} style={{background:"white", borderRadius:18, padding:"24px 28px", maxWidth:460, width:"100%", boxShadow:"0 20px 60px rgba(0,0,0,0.18)", fontFamily:fontSans}}>
            <h3 style={{fontFamily:fontSerif, fontSize:18, color:"#0F1D35", margin:"0 0 4px"}}>Trabajador dado de alta</h3>
            <div style={{fontSize:12, color:"#9A9AAA", marginBottom:16}}>Se creó su ficha y su cuenta de acceso sin cerrar tu sesión. Comparte la contraseña temporal con el trabajador.</div>
            <div style={{background:"rgba(5,150,105,0.08)", border:"1px solid rgba(5,150,105,0.30)", borderRadius:10, padding:"12px 14px", marginBottom:14}}>
              <div style={{fontSize:13, color:"#059669", fontWeight:700, marginBottom:6}}>Cuenta creada para {altaAccesoResult.correo}</div>
              <div style={{fontSize:12, color:"#4A4A60", marginBottom:6}}>Contraseña temporal para compartir:</div>
              <div style={{fontFamily:"monospace", fontSize:16, fontWeight:700, color:"#0B1829", background:"white", border:"1px dashed rgba(0,0,0,0.25)", borderRadius:8, padding:"8px 12px", letterSpacing:"1px", userSelect:"all" as const}}>{altaAccesoResult.tempPass}</div>
              <div style={{fontSize:11, color:"#9A9AAA", marginTop:6}}>Puede cambiarla con "¿Olvidaste tu contraseña?" al iniciar sesión.</div>
            </div>
            <button onClick={()=>setAltaAccesoResult(null)} style={{width:"100%", background:"#236478", border:"none", borderRadius:12, padding:"12px", cursor:"pointer", fontSize:13, fontWeight:700, color:"white", fontFamily:fontSans}}>Entendido</button>
          </div>
        </div>
      )}
    </div>
  );
}

// #endregion
// ─── AQUÍ VIVÍA ModalCorreoContrato, Y SE RETIRÓ ─────────────────────────────
//
// Pedía el correo antes de dejar descargar un contrato generado, y escribía el
// lead en `contratos_leads`. Estaba declarado y NO SE MONTABA EN NINGUNA PANTALLA:
// código vivo que la aplicación ya no alcanzaba, como pasó con "Cuentas de
// trabajador".
//
// SE MIDIÓ ANTES DE DECIDIR, porque la respuesta cambiaba el trabajo: ¿es el
// Generador legal público como la Calculadora LFT? NO LO ES. En el menú lateral
// va con `restringido: !isProUser`, así que sin plan PRO su botón está deshabilitado
// —"Disponible en plan PRO"— y nunca llega a navegar. El acceso rápido de Inicio
// lleva `disp:isProUser`. Y los demás caminos hasta él salen de Empleados,
// Clientes, Créditos y Proveedores, que son módulos PRO. La Calculadora LFT y el
// Diagnóstico, en cambio, no llevan `restringido`: ésos sí son públicos, y por eso
// su hermano `ModalCorreoNomina` sí tiene sentido y sigue montado.
//
// CONSECUENCIA: a quien genera un contrato ya se le cobró. Pedirle el correo para
// dejarle descargar lo que acaba de pagar no es captar un lead, es un peaje. Es la
// misma razón que ya estaba escrita en `ModalCorreoNomina`: si la plataforma ya
// conoce tu correo, volver a pedirlo hace dudar de a quién se le está mandando.
//
// Por eso no se reactiva, y no se deja "por si acaso": un componente que no se
// monta parece montable y el siguiente que lo lea perderá el mismo rato. Está en
// el historial de git si algún día el generador se abre al público.
//
// `contratos_leads` se queda como está —tiene gente real que dejó su correo cuando
// el flujo funcionaba— y su pestaña del panel de administrador lo dice en la
// primera línea, para que nadie espere registros nuevos que no van a llegar.

// ─── COMPONENTE MARCO LEGAL ───────────────────────────────────────────────────
function RenderReg({r, bgCard, border, gold, textMut, textSec, textPrim}: {r: any; bgCard: string; border: string; gold: string; textMut: string; textSec: string; textPrim: string}) {
  return (
    <div style={{background:bgCard, border:"1px solid " + border, borderRadius:8, padding:"10px 14px", marginBottom:4, display:"flex", alignItems:"flex-start", gap:12}}>
      <span style={{fontSize:18, marginTop:1, flexShrink:0, opacity:0.5}}>📖</span>
      <div style={{flex:1}}>
        <div style={{display:"flex", alignItems:"center", gap:6, flexWrap:"wrap" as const, marginBottom:3}}>
          <span style={{fontSize:10, fontWeight:600, color:gold}}>{r.clave}</span>
          <span style={{fontSize:9, background:"rgba(184,147,42,0.08)", color:gold, padding:"2px 7px", borderRadius:10, border:"1px solid rgba(201,168,76,0.15)", fontWeight:600}}>REFERENCIA</span>
          <span style={{fontSize:9, color:textMut, marginLeft:"auto"}}>No requiere trámite</span>
        </div>
        <p style={{margin:0, fontSize:13, color:textPrim}}>{r.titulo}</p>
        <p style={{margin:"4px 0 0", fontSize:11, color:textSec, lineHeight:1.6}}>{r.descripcion}</p>
        <p style={{margin:"4px 0 0", fontSize:10, color:textMut}}>Autoridad: {r.autoridad}</p>
      </div>
    </div>
  );
}

function MarcoLegalSection({regs, border, gold, textMut, textSec, textPrim, bgCard, fontSerif, fontSans}: {
  regs: any[]; border: string; gold: string; textMut: string; textSec: string; textPrim: string; bgCard: string; fontSerif: string; fontSans: string;
}) {
  const [open, setOpen] = useState(false);

  return (
    <div style={{marginBottom:20}}>
      <button onClick={() => setOpen(!open)}
        style={{width:"100%", display:"flex", alignItems:"center", gap:10, padding:"14px 18px",
          background:open ? "rgba(184,147,42,0.08)" : "rgba(184,147,42,0.04)",
          border:"1px solid rgba(201,168,76,0.25)", borderRadius:open ? "10px 10px 0 0" : "10px",
          cursor:"pointer"}}>
        <span style={{fontSize:16}}>📜</span>
        <div style={{flex:1, textAlign:"left" as const}}>
          <div style={{fontSize:12, fontWeight:600, color:gold, textTransform:"uppercase" as const, letterSpacing:"1px"}}>Marco Legal Aplicable</div>
          <div style={{fontSize:11, color:textMut, marginTop:2}}>Leyes y reglamentos de referencia — {regs.length} ordenamientos</div>
        </div>
        <span style={{fontSize:12, color:gold, fontWeight:600}}>{open ? "▲ Cerrar" : "▼ Ver leyes aplicables"}</span>
      </button>
      {open && (
        <div style={{border:"1px solid rgba(201,168,76,0.2)", borderTop:"none", borderRadius:"0 0 10px 10px", padding:"12px", background:"rgba(184,147,42,0.02)"}}>
          <p style={{fontSize:11, color:textMut, margin:"0 0 12px 4px", fontStyle:"italic"}}>
            Ordenamientos que constituyen el marco normativo de tu sector. No son trámites a gestionar sino las leyes bajo las cuales opera tu empresa.
          </p>
          {regs.map((r: any, i: number) => <span key={i}><RenderReg r={r} bgCard={bgCard} border={border} gold={gold} textMut={textMut} textSec={textSec} textPrim={textPrim} /></span>)}
        </div>
      )}
    </div>
  );
}


// ─── ÍCONOS DE SECTOR — Arte lineal premium ───────────────────────────────────
const SECTOR_SVG: Record<string, JSX.Element> = {

  // Estetoscopio — Sector Médico
  medico: (
    <svg viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="20" cy="14" r="5"/>
      <circle cx="44" cy="14" r="5"/>
      <path d="M20 19 C20 30 26 36 32 36 C38 36 44 30 44 19"/>
      <path d="M32 36 C32 44 32 50 38 52"/>
      <circle cx="41" cy="53" r="4" strokeWidth="1.2"/>
      <circle cx="41" cy="53" r="1.5" fill="currentColor"/>
      <circle cx="20" cy="10" r="1.5" fill="currentColor"/>
      <circle cx="44" cy="10" r="1.5" fill="currentColor"/>
    </svg>
  ),

  // Copa de vino y tenedor — Restaurantes
  restaurante: (
    <svg viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 8 L22 24 Q22 36 32 36 Q42 36 42 24 L42 8"/>
      <line x1="32" y1="36" x2="32" y2="56"/>
      <line x1="26" y1="56" x2="38" y2="56"/>
      <line x1="22" y1="8" x2="42" y2="8"/>
      <line x1="10" y1="8" x2="10" y2="22"/>
      <path d="M8 8 Q8 18 10 22"/>
      <path d="M12 8 Q12 18 10 22"/>
      <line x1="10" y1="22" x2="10" y2="56"/>
      <line x1="52" y1="8" x2="52" y2="56"/>
      <path d="M49 8 Q49 18 52 22"/>
      <path d="M55 8 Q55 18 52 22"/>
    </svg>
  ),

  // Edificio con columnas — Construcción
  construccion: (
    <svg viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="8" y1="56" x2="56" y2="56"/>
      <line x1="12" y1="56" x2="12" y2="28"/>
      <line x1="52" y1="56" x2="52" y2="28"/>
      <line x1="22" y1="56" x2="22" y2="28"/>
      <line x1="32" y1="56" x2="32" y2="28"/>
      <line x1="42" y1="56" x2="42" y2="28"/>
      <rect x="10" y="22" width="44" height="6" rx="1"/>
      <path d="M14 22 L32 10 L50 22"/>
      <rect x="26" y="38" width="12" height="18"/>
    </svg>
  ),

  // Casa con llave — Inmobiliario
  inmobiliario: (
    <svg viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M8 30 L32 10 L56 30"/>
      <line x1="14" y1="25" x2="14" y2="56"/>
      <line x1="50" y1="25" x2="50" y2="56"/>
      <line x1="8" y1="56" x2="56" y2="56"/>
      <rect x="24" y="38" width="16" height="18"/>
      <circle cx="31" cy="47" r="2"/>
      <line x1="20" y1="10" x2="20" y2="22"/>
      <rect x="17" y="7" width="6" height="5" rx="1"/>
    </svg>
  ),

  // Balanza de justicia — Comercio
  comercio: (
    <svg viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="32" y1="8" x2="32" y2="56"/>
      <line x1="24" y1="56" x2="40" y2="56"/>
      <line x1="12" y1="18" x2="52" y2="18"/>
      <circle cx="32" cy="12" r="4"/>
      <line x1="12" y1="18" x2="12" y2="30"/>
      <path d="M6 30 Q12 38 18 30" strokeWidth="1.2"/>
      <line x1="52" y1="18" x2="52" y2="34"/>
      <path d="M46 34 Q52 42 58 34" strokeWidth="1.2"/>
      <line x1="8" y1="18" x2="16" y2="18"/>
      <line x1="48" y1="18" x2="56" y2="18"/>
    </svg>
  ),

  // Engranaje industrial — Manufactura
  manufactura: (
    <svg viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="32" cy="32" r="10"/>
      <circle cx="32" cy="32" r="4"/>
      <path d="M32 12 L30 8 L34 8 L32 12"/>
      <path d="M32 52 L30 56 L34 56 L32 52"/>
      <path d="M12 32 L8 30 L8 34 L12 32"/>
      <path d="M52 32 L56 30 L56 34 L52 32"/>
      <path d="M17.4 17.4 L14.6 14.6 L17.4 11.8 L20.2 14.6 Z"/>
      <path d="M46.6 46.6 L49.4 49.4 L46.6 52.2 L43.8 49.4 Z"/>
      <path d="M17.4 46.6 L14.6 49.4 L11.8 46.6 L14.6 43.8 Z"/>
      <path d="M46.6 17.4 L49.4 14.6 L52.2 17.4 L49.4 20.2 Z"/>
    </svg>
  ),

  // Birrete con pergamino — Educación
  educacion: (
    <svg viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="32,10 56,22 32,34 8,22"/>
      <path d="M44 27 L44 42 Q44 46 32 46 Q20 46 20 42 L20 27"/>
      <line x1="56" y1="22" x2="56" y2="38"/>
      <path d="M53 38 Q56 42 59 38"/>
      <line x1="26" y1="54" x2="38" y2="54"/>
      <line x1="32" y1="46" x2="32" y2="54"/>
    </svg>
  ),

  // Camión de carga — Transporte
  transporte: (
    <svg viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="4" y="22" width="36" height="24" rx="2"/>
      <path d="M40 30 L40 46 L58 46 L58 36 L52 30 Z"/>
      <line x1="52" y1="30" x2="40" y2="30"/>
      <circle cx="14" cy="50" r="6"/>
      <circle cx="14" cy="50" r="2" fill="currentColor"/>
      <circle cx="48" cy="50" r="6"/>
      <circle cx="48" cy="50" r="2" fill="currentColor"/>
      <line x1="4" y1="46" x2="8" y2="46"/>
      <line x1="20" y1="46" x2="42" y2="46"/>
      <line x1="54" y1="46" x2="58" y2="46"/>
      <line x1="16" y1="30" x2="16" y2="38"/>
      <line x1="24" y1="30" x2="24" y2="38"/>
    </svg>
  ),

  // Pluma notarial sobre papel — Servicios Profesionales
  servicios: (
    <svg viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M16 8 L16 56 L52 56 L52 18 L42 8 Z"/>
      <path d="M42 8 L42 18 L52 18"/>
      <line x1="24" y1="28" x2="44" y2="28"/>
      <line x1="24" y1="36" x2="44" y2="36"/>
      <line x1="24" y1="44" x2="36" y2="44"/>
      <path d="M30 52 Q26 46 30 40 Q36 32 42 24 Q46 18 50 14 L54 18 Q50 22 44 30 Q38 40 34 48 Z"/>
      <path d="M28 54 L30 52 L34 48 L32 50 Z" fill="currentColor" stroke="none"/>
    </svg>
  ),

  hoteleria:    (
    <svg viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="8" y="20" width="48" height="36" rx="2"/>
      <path d="M8 28 L56 28"/>
      <line x1="20" y1="20" x2="20" y2="8"/>
      <line x1="44" y1="20" x2="44" y2="8"/>
      <line x1="20" y1="8" x2="44" y2="8"/>
      <rect x="26" y="38" width="12" height="18"/>
      <rect x="14" y="34" width="8" height="8" rx="1"/>
      <rect x="42" y="34" width="8" height="8" rx="1"/>
      <path d="M32 14 L33.5 17 L37 17 L34.5 19 L35.5 22 L32 20 L28.5 22 L29.5 19 L27 17 L30.5 17 Z"/>
    </svg>
  ),
};

function SectorIcon({id, color, size=36}: {id:string; color:string; size?:number}) {
  const icon = SECTOR_SVG[id];
  if (!icon) return null;
  return (
    <div style={{width:size, height:size, color, display:"flex", alignItems:"center", justifyContent:"center"}}>
      {React.cloneElement(icon, {width:size, height:size} as any)}
    </div>
  );
}


// ─── MODAL LEGAL ──────────────────────────────────────────────────────────────
function ModalLegal({tipo, onClose}: {tipo:"disclaimer"|"privacidad"; onClose:()=>void}) {
  const gold = "#B8932A";
  const dark = "#1A1A2E";
  const gray = "#4A4A60";
  const fontS = "-apple-system, sans-serif";
  const fontR = "Georgia, serif";
  return (
    // ENCIMA DE TODO LO QUE PUEDA ABRIRLO. Se abre desde el pie de página y desde
    // el panel del correo del PDF, que estaba en el mismo 500 y se pinta después:
    // con la misma altura, el panel habría tapado al aviso. Este número solo tiene
    // que ser mayor que el de quien lo abre, nunca al revés.
    <div onClick={onClose} style={{position:"fixed" as const, inset:0, background:"rgba(0,0,0,0.55)", zIndex:900, display:"flex", alignItems:"center", justifyContent:"center", padding:20, backdropFilter:"blur(4px)"}}>
      <div onClick={e=>e.stopPropagation()} style={{background:"white", borderRadius:16, padding:"32px 36px", maxWidth:560, width:"100%", maxHeight:"85vh", overflowY:"auto" as const, fontFamily:fontS}}>
        {tipo==="disclaimer" ? (<>
          <h2 style={{fontFamily:fontR, fontSize:22, color:dark, margin:"0 0 16px"}}>Aviso Legal y Descargo de Responsabilidad</h2>
          <p style={{fontSize:13, color:gray, lineHeight:1.8, margin:"0 0 12px"}}>La información contenida en <strong>AXIS Legaltech</strong> es proporcionada por <strong>AXIS Asesoría Legal Corporativa</strong> con fines informativos y de orientación general únicamente.</p>
          <p style={{fontSize:13, color:gray, lineHeight:1.8, margin:"0 0 12px"}}>El contenido de esta herramienta <strong>no constituye asesoría jurídica</strong> y no debe ser utilizado como sustituto de la consulta con un abogado calificado. Las regulaciones aquí descritas están sujetas a cambios por parte de las autoridades competentes.</p>
          <p style={{fontSize:13, color:gray, lineHeight:1.8, margin:"0 0 12px"}}><strong>AXIS Asesoría Legal Corporativa no asume responsabilidad</strong> por decisiones tomadas con base en la información aquí presentada, ni por omisiones, inexactitudes o desactualizaciones del contenido.</p>
          <p style={{fontSize:13, color:gray, lineHeight:1.8, margin:"0 0 20px"}}>Para verificar el cumplimiento regulatorio de su empresa le recomendamos acudir con su abogado de confianza o contactar a <strong style={{color:gold}}>AXIS Asesoría Legal Corporativa</strong> para una consulta profesional personalizada.</p>
          <div style={{background:"rgba(184,147,42,0.08)", border:"1px solid rgba(184,147,42,0.2)", borderRadius:10, padding:"12px 16px", fontSize:12, color:gray, lineHeight:1.7}}>
            📞 449 425 11 28 · ✉️ contacto@axislegalags.com · 🌐 axislegalags.com<br/>Torre Plaza Bosques, Int. 909, Aguascalientes, México
          </div>
        </>) : (<>
        <h2 style={{fontFamily:fontR, fontSize:22, color:dark, margin:"0 0 8px"}}>Aviso de Privacidad</h2>
          <p style={{fontSize:11, color:"#9A9AAA", margin:"0 0 16px"}}>Última actualización: 12 de mayo de 2026</p>
          
          <p style={{fontSize:13, fontWeight:700, color:dark, margin:"0 0 6px"}}>1. Responsable del tratamiento</p>
          <p style={{fontSize:13, color:gray, lineHeight:1.8, margin:"0 0 12px"}}><strong>AXIS Asesoría Legal Corporativa</strong> ("AXIS"), con domicilio en Torre Plaza Bosques, Int. 909, Aguascalientes, México, es responsable del tratamiento de sus datos personales y de los datos personales de terceros (empleados, proveedores, contrapartes) que usted ingrese a la plataforma AXIS Legaltech ("la Plataforma"), conforme a la LFPDPPP, su Reglamento y los Lineamientos del INAI.</p>
          <p style={{fontSize:13, color:gray, lineHeight:1.8, margin:"0 0 16px"}}>Contacto del responsable: <strong style={{color:gold}}>contacto@axislegalags.com</strong></p>

          <p style={{fontSize:13, fontWeight:700, color:dark, margin:"0 0 6px"}}>2. Datos personales que recabamos</p>
          <p style={{fontSize:13, color:gray, lineHeight:1.8, margin:"0 0 6px"}}><strong>Del titular de la cuenta:</strong> nombre, correo, contraseña encriptada, datos de la empresa (razón social, RFC, domicilio fiscal).</p>
          <p style={{fontSize:13, color:gray, lineHeight:1.8, margin:"0 0 6px"}}><strong>De empleados del titular:</strong> nombre, fecha de nacimiento, CURP, RFC, NSS, domicilio, teléfono, datos laborales (puesto, departamento, salario), datos bancarios, documentos escaneados (INE, comprobantes, contratos, recibos de nómina).</p>
          <p style={{fontSize:13, color:gray, lineHeight:1.8, margin:"0 0 6px"}}><strong>De la empresa del titular:</strong> documentos legales, licencias, permisos, documentos fiscales.</p>
          <p style={{fontSize:13, color:gray, lineHeight:1.8, margin:"0 0 6px"}}><strong>De vehículos de flotilla:</strong> circulación, pólizas, verificaciones, fotografías.</p>
          <p style={{fontSize:13, color:gray, lineHeight:1.8, margin:"0 0 6px"}}><strong>De contratos y contrapartes:</strong> información contenida en contratos firmados.</p>
          <p style={{fontSize:13, color:gray, lineHeight:1.8, margin:"0 0 16px"}}><strong>De interacción con AXIOR:</strong> texto de consultas realizadas y respuestas generadas.</p>

          <p style={{fontSize:13, fontWeight:700, color:dark, margin:"0 0 6px"}}>3. Finalidades del tratamiento</p>
          <p style={{fontSize:13, color:gray, lineHeight:1.8, margin:"0 0 6px"}}><strong>Primarias:</strong> proveer acceso a la Plataforma, almacenar y gestionar empleados/documentos/contratos/nómina del titular, generar reportes y recibos, calcular cumplimiento legal, asistencia de AXIOR, soporte, cumplir obligaciones fiscales y legales de AXIS.</p>
          <p style={{fontSize:13, color:gray, lineHeight:1.8, margin:"0 0 16px"}}><strong>Secundarias (opcionales):</strong> envío de comunicaciones promocionales sobre servicios de AXIS y análisis estadísticos agregados. Si no las desea, escriba a <strong style={{color:gold}}>contacto@axislegalags.com</strong>.</p>

          <p style={{fontSize:13, fontWeight:700, color:dark, margin:"0 0 6px"}}>4. Transferencia de datos a terceros</p>
          <p style={{fontSize:13, color:gray, lineHeight:1.8, margin:"0 0 6px"}}>Para operar la Plataforma, AXIS transfiere datos a los siguientes proveedores tecnológicos sujetos a sus propias políticas de privacidad:</p>
          <p style={{fontSize:13, color:gray, lineHeight:1.8, margin:"0 0 6px"}}><strong>Google LLC (Firebase):</strong> almacenamiento de datos, autenticación, archivos. Servidores en EUA.</p>
          <p style={{fontSize:13, color:gray, lineHeight:1.8, margin:"0 0 6px"}}><strong>Google LLC (Google Docs Viewer):</strong> visualización de documentos Word. Al hacer clic en "Ver" sobre un Word, la URL del archivo se transmite a Google. Excel y PowerPoint se descargan directamente sin pasar por este servicio.</p>
          <p style={{fontSize:13, color:gray, lineHeight:1.8, margin:"0 0 6px"}}><strong>Vercel Inc.:</strong> hosting del frontend. Datos de navegación en servidores de EUA.</p>
          <p style={{fontSize:13, color:gray, lineHeight:1.8, margin:"0 0 6px"}}><strong>Anthropic PBC:</strong> modelo de IA detrás de AXIOR. Sus consultas se transmiten a Anthropic. Anthropic declara que NO usa estos datos para entrenar sus modelos.</p>
          <p style={{fontSize:13, color:gray, lineHeight:1.8, margin:"0 0 16px"}}><strong>WhatsApp Business (Meta):</strong> canal de atención al cliente, conforme a las políticas de Meta.</p>

          <p style={{fontSize:13, fontWeight:700, color:dark, margin:"0 0 6px"}}>5. Datos de terceros (empleados del titular)</p>
          <p style={{fontSize:13, color:gray, lineHeight:1.8, margin:"0 0 16px"}}>Si usted ingresa datos personales de empleados, proveedores o contrapartes, declara que ha obtenido su consentimiento previo, expreso e informado, o que cuenta con base legal suficiente (relación laboral o contractual) conforme al art. 10 de la LFPDPPP. AXIS actúa como encargado del tratamiento conforme al art. 50 del Reglamento. La responsabilidad principal sobre estos datos recae en el titular de la cuenta como patrón o contratante.</p>

          <p style={{fontSize:13, fontWeight:700, color:dark, margin:"0 0 6px"}}>6. Derechos ARCO</p>
          <p style={{fontSize:13, color:gray, lineHeight:1.8, margin:"0 0 16px"}}>Acceso, Rectificación, Cancelación y Oposición. Envíe solicitud a <strong style={{color:gold}}>contacto@axislegalags.com</strong> con: (i) nombre y correo, (ii) derecho que ejerce, (iii) documento de identidad. Plazo de respuesta: 20 días hábiles.</p>

          <p style={{fontSize:13, fontWeight:700, color:dark, margin:"0 0 6px"}}>7. Medidas de seguridad</p>
          <p style={{fontSize:13, color:gray, lineHeight:1.8, margin:"0 0 16px"}}>Contraseñas encriptadas, reglas de acceso por usuario en Firebase Storage, transmisión por HTTPS, acceso restringido a personal autorizado de AXIS.</p>

          <p style={{fontSize:13, fontWeight:700, color:dark, margin:"0 0 6px"}}>8. Conservación de los datos</p>
          <p style={{fontSize:13, color:gray, lineHeight:1.8, margin:"0 0 16px"}}>Mientras la cuenta esté activa. En caso de cancelación, se eliminan en 90 días, salvo aquellos que deban conservarse por obligaciones fiscales, contables o legales.</p>

          <p style={{fontSize:13, fontWeight:700, color:dark, margin:"0 0 6px"}}>9. Cookies</p>
          <p style={{fontSize:13, color:gray, lineHeight:1.8, margin:"0 0 16px"}}>La Plataforma utiliza únicamente cookies técnicas (no de seguimiento publicitario) para mantener la sesión del usuario.</p>

          <p style={{fontSize:13, fontWeight:700, color:dark, margin:"0 0 6px"}}>10. Cambios al Aviso</p>
          <p style={{fontSize:13, color:gray, lineHeight:1.8, margin:"0 0 16px"}}>AXIS puede modificar este Aviso. Los cambios se notifican en la Plataforma o por correo. La fecha de última actualización aparece al inicio.</p>

          <p style={{fontSize:13, fontWeight:700, color:dark, margin:"0 0 6px"}}>11. Autoridad de protección de datos</p>
          <p style={{fontSize:13, color:gray, lineHeight:1.8, margin:"0 0 16px"}}>Si considera vulnerados sus derechos, puede acudir al INAI: <strong style={{color:gold}}>www.inai.org.mx</strong></p>

          <p style={{fontSize:11, color:"#9A9AAA", margin:0, lineHeight:1.6}}>AXIS Asesoría Legal Corporativa · Torre Plaza Bosques, Int. 909, Aguascalientes, México · contacto@axislegalags.com</p>
          
          </>)}
        <button onClick={onClose} style={{marginTop:24, width:"100%", background:"#1B2B4B", border:"none", borderRadius:10, padding:"12px", cursor:"pointer", fontSize:13, fontWeight:600, color:"white", fontFamily:fontS}}>
          Entendido
        </button>
      </div>
    </div>
  );
}

// ─── APP ──────────────────────────────────────────────────────────────────────

// #region AXIOR
// ─── AXIOR — Asistente Legal IA de AXIS ──────────────────────────────────────
const AXIOR_SYSTEM_PROMPT = `Eres AXIOR, el asistente legal inteligente de AXIS Asesoría Legal Corporativa en Aguascalientes, México. Eres un búho elegante y profesional. Tu especialidad es la legislación mexicana: LFT, SAT, IMSS, INFONAVIT, normatividad de Aguascalientes y cumplimiento regulatorio para empresas PYME. Respondes de forma clara, amigable y directa, sin tecnicismos innecesarios, como si le explicaras a un empresario. Eres preciso, confiable y siempre orientas hacia el cumplimiento legal correcto. Cuando el caso requiera análisis específico recomienda: AXIS Asesoría Legal 449 425 11 28 o axislegalags.com. Mantén respuestas concisas, máximo 3-4 párrafos. Usa emojis ocasionalmente.`;



function AxiorSVG({size=56, expr="atento", eyeTrack=false, eyeOffset={x:0,y:0}, view="auto"}: {
  size?:number;
  expr?:"atento"|"pensando"|"explicando"|"confirmado"|"sorprendido";
  eyeTrack?: boolean;
  eyeOffset?: {x:number, y:number};
  view?: "auto" | "face" | "body";
}) {
  const [hover, setHover] = useState(false);
  const [bounce, setBounce] = useState(false);
  const [blink, setBlink] = useState(false);
  const prevExpr = useRef(expr);

  // Rebote cuando cambia la expresión
  useEffect(() => {
    if (expr !== prevExpr.current) {
      setBounce(true);
      const t = setTimeout(() => setBounce(false), 400);
      prevExpr.current = expr;
      return () => clearTimeout(t);
    }
  }, [expr]);

  // Parpadeo aleatorio cada 3-6 segundos (solo si eyeTrack está activo)
  useEffect(() => {
    if (!eyeTrack) return;
    const blinkLoop = () => {
      setBlink(true);
      setTimeout(() => setBlink(false), 160);
    };
    let timer = setTimeout(function loop(){
      blinkLoop();
      timer = setTimeout(loop, 3000 + Math.random()*3000);
    }, 2000 + Math.random()*2000);
    return () => clearTimeout(timer);
  }, [eyeTrack]);

  // Determinar vista efectiva:
  // - "face" → close-up de la cara (zoom 230%, ojos grandes y monóculo prominentes)
  // - "body" → cuerpo completo con traje (object-fit contain)
  // - "auto" → size-based default (chico → face crop suave, grande → body)
  const effectiveView = view === "auto" ? (size >= 50 ? "body" : "face-soft") : view;
  const isFaceClose = effectiveView === "face";        // close-up zoomed
  const isFaceSoft  = effectiveView === "face-soft";   // current head crop suave
  const isBody      = effectiveView === "body";

  const ringWidth = size >= 50 ? 2 : 1;

  // Posiciones de pupilas según vista
  // Face close-up zoomed: ojos en (25%, 41%) y (75%, 41%) — más separados, más grandes
  // Face soft (head crop): ojos en (39%, 27.5%) y (60%, 27.5%)
  // Body: no tracking
  const eyeLeftX  = isFaceClose ? "25%"  : "39%";
  const eyeRightX = isFaceClose ? "75%"  : "60%";
  const eyeY      = isFaceClose ? "41%"  : "27.5%";
  const pupilScale = isFaceClose ? 0.13 : 0.075;
  const pupilSize = Math.round(size * pupilScale);
  const pupilHl = Math.max(1, Math.round(size * pupilScale * 0.28));

  return (
    <div
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        overflow: "hidden",
        background: isBody ? "transparent" : "#0B1829",
        flexShrink: 0,
        boxShadow: isBody
          ? "none"
          : (hover
            ? `0 0 0 ${ringWidth}px #D4A843, 0 6px 24px rgba(212,168,67,0.45)`
            : `0 0 0 ${ringWidth}px rgba(212,168,67,0.45), 0 2px 10px rgba(0,0,0,0.35)`),
        transform: bounce ? "scale(1.12) translateY(-2px)" : (hover ? "scale(1.05)" : "scale(1)"),
        transition: "transform 0.3s cubic-bezier(0.34,1.56,0.64,1), box-shadow 0.3s ease",
        display: "block",
        position: "relative",
      }}
    >
      {/* La imagen — para 'face' uso background-image con zoom, para los demás un img normal */}
      {isFaceClose ? (
        <div style={{
          width: "100%",
          height: "100%",
          background: "url(/axior.png) 50% 18% / 230% no-repeat",
          animation: "axiorBreathe 4s ease-in-out infinite",
        }}/>
      ) : (
        <img
          src="/axior.png"
          alt="AXIOR"
          draggable={false}
          style={{
            width: "100%",
            height: "100%",
            objectFit: isBody ? "contain" : "cover",
            objectPosition: isBody ? "center center" : "50% 16%",
            display: "block",
            userSelect: "none",
            animation: isBody ? "axiorBreathe 4s ease-in-out infinite" : "none",
          }}
        />
      )}

      {/* Pupilas dinámicas que siguen el cursor (solo en face/face-close con eyeTrack) */}
      {eyeTrack && !isBody && (
        <>
          {/* Ojo izquierdo */}
          <div style={{
            position: "absolute",
            left: eyeLeftX, top: eyeY,
            width: pupilSize, height: blink ? 1 : pupilSize,
            marginLeft: -pupilSize/2, marginTop: -pupilSize/2,
            borderRadius: "50%",
            background: "radial-gradient(circle at 35% 30%, #1a1410 0%, #050505 70%)",
            transform: `translate(${eyeOffset.x}px, ${eyeOffset.y}px)`,
            transition: `transform 0.15s ease-out, height 0.08s ease`,
            pointerEvents: "none",
            boxShadow: blink ? "none" : "0 0 1px rgba(0,0,0,0.6)",
          }}/>
          {/* Reflejo ojo izq */}
          {!blink && (
            <div style={{
              position: "absolute",
              left: eyeLeftX, top: eyeY,
              width: pupilHl, height: pupilHl,
              marginLeft: -pupilSize*0.15, marginTop: -pupilSize*0.4,
              borderRadius: "50%",
              background: "rgba(255,250,240,0.92)",
              transform: `translate(${eyeOffset.x*0.7}px, ${eyeOffset.y*0.7}px)`,
              transition: "transform 0.15s ease-out",
              pointerEvents: "none",
            }}/>
          )}
          {/* Ojo derecho (con monóculo) */}
          <div style={{
            position: "absolute",
            left: eyeRightX, top: eyeY,
            width: pupilSize, height: blink ? 1 : pupilSize,
            marginLeft: -pupilSize/2, marginTop: -pupilSize/2,
            borderRadius: "50%",
            background: "radial-gradient(circle at 35% 30%, #1a1410 0%, #050505 70%)",
            transform: `translate(${eyeOffset.x}px, ${eyeOffset.y}px)`,
            transition: `transform 0.15s ease-out, height 0.08s ease`,
            pointerEvents: "none",
            boxShadow: blink ? "none" : "0 0 1px rgba(0,0,0,0.6)",
          }}/>
          {/* Reflejo ojo der */}
          {!blink && (
            <div style={{
              position: "absolute",
              left: eyeRightX, top: eyeY,
              width: pupilHl, height: pupilHl,
              marginLeft: -pupilSize*0.15, marginTop: -pupilSize*0.4,
              borderRadius: "50%",
              background: "rgba(255,250,240,0.92)",
              transform: `translate(${eyeOffset.x*0.7}px, ${eyeOffset.y*0.7}px)`,
              transition: "transform 0.15s ease-out",
              pointerEvents: "none",
            }}/>
          )}
        </>
      )}
      <style>{`
        @keyframes axiorBreathe {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.025); }
        }
      `}</style>
    </div>
  );
}


// LAS CABECERAS PARA /api/axior. El servidor ya no contesta sin sesión: comprueba
// el token y la puerta de acceso antes de llamar al modelo. Sin sesión no hay
// token, y el servidor contesta 401.
async function cabecerasAxior(): Promise<Record<string,string>> {
  const h: Record<string,string> = {"Content-Type":"application/json"};
  try { const t = await auth.currentUser?.getIdToken(); if (t) h.Authorization = "Bearer " + t; } catch(e){ /* sin token: el servidor dirá 401 */ }
  return h;
}
// Qué decirle a la persona según lo que contestó la puerta del servidor.
function mensajeRechazoAxior(status:number): string|null {
  if (status === 401) return "Tu sesión caducó. Cierra sesión y vuelve a entrar para seguir usando AXIOR.";
  if (status === 403) return "AXIOR está disponible cuando tu cuenta tiene acceso a la plataforma.";
  if (status === 503) return "No pude comprobar tu sesión en este momento. Intenta de nuevo en unos segundos.";
  return null;
}

function AxiorChat({fontSans, fontSerif, gold, ocultarLanzador=false}: {fontSans:string; fontSerif:string; gold:string; ocultarLanzador?:boolean}) {
  const isMobile = window.innerWidth < 768;
  const [open, setOpen] = useState(false);
  const [msgs, setMsgs] = useState<{role:"user"|"assistant"; content:string; ts?:string}[]>([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [expr, setExpr] = useState<"atento"|"pensando"|"explicando"|"confirmado"|"sorprendido">("atento");
  const bottomRef = useRef<HTMLDivElement>(null);
  const [showTooltip, setShowTooltip] = useState(() => {
    try { return !localStorage.getItem("axior_visto"); } catch { return true; }
  });
  // Permite OCULTAR el búho desde ciertas vistas (p. ej. el Portal del
  // trabajador) sin desmontar el componente ni tocar su lógica. La vista que
  // quiere esconderlo emite "axior:ocultar" al montar y "axior:mostrar" al salir.
  const [oculto, setOculto] = useState(false);
  // Ocultar SOLO el lanzador flotante (NO el panel) — opt-in por evento, usado por
  // el portal del patrón móvil que abre el chat desde un botón en su header. No
  // cambia el comportamiento por defecto en el resto de la app (default: visible).
  const [lanzadorOculto, setLanzadorOculto] = useState(false);

  // ── Dictado por voz (Web Speech API nativa; sin servicios externos) ──────────
  // Soporte: si el navegador no lo tiene, el botón de micrófono NO se muestra y el
  // chat sigue funcionando con texto. El dictado SOLO rellena el campo `input`.
  const SpeechRec = typeof window !== "undefined" ? ((window as any).SpeechRecognition || (window as any).webkitSpeechRecognition) : null;
  const vozSoportada = !!SpeechRec;
  const [escuchando, setEscuchando] = useState(false);
  const [vozError, setVozError] = useState<string|null>(null);
  const recognitionRef = useRef<any>(null);
  const baseTextRef = useRef("");   // texto del campo al iniciar el dictado (para concatenar)

  // Abrir AXIOR desde otras vistas (p. ej. el botón "Pregúntale a AXIOR" de
  // Ayuda) con una pregunta precargada, vía evento window. Reusa ESTE chat.
  useEffect(() => {
    const handler = (e: any) => {
      setOpen(true);
      const q = e?.detail?.pregunta;
      if (q) setInput(q);
    };
    window.addEventListener("axior:abrir", handler as EventListener);
    return () => window.removeEventListener("axior:abrir", handler as EventListener);
  }, []);

  // Ocultar/mostrar el búho según la vista activa (sin desmontarlo). El Portal
  // del trabajador lo oculta mientras está en pantalla; al salir vuelve a verse.
  useEffect(() => {
    const ocultar = () => setOculto(true);
    const mostrar = () => { setOculto(false); setOpen(false); };
    window.addEventListener("axior:ocultar", ocultar as EventListener);
    window.addEventListener("axior:mostrar", mostrar as EventListener);
    return () => {
      window.removeEventListener("axior:ocultar", ocultar as EventListener);
      window.removeEventListener("axior:mostrar", mostrar as EventListener);
    };
  }, []);

  // Ocultar/mostrar SOLO el lanzador flotante (sin afectar el panel ni el resto).
  useEffect(() => {
    const ocL = () => setLanzadorOculto(true);
    const moL = () => setLanzadorOculto(false);
    window.addEventListener("axior:ocultarLanzador", ocL as EventListener);
    window.addEventListener("axior:mostrarLanzador", moL as EventListener);
    return () => {
      window.removeEventListener("axior:ocultarLanzador", ocL as EventListener);
      window.removeEventListener("axior:mostrarLanzador", moL as EventListener);
    };
  }, []);

  // Detiene el reconocimiento de forma segura.
  const detenerDictado = () => { try { recognitionRef.current?.stop(); } catch (e) {} };

  // Inicia/detiene el dictado. Concatena lo dictado a lo que ya hay en el campo
  // (sin pisar lo escrito); el usuario revisa y envía como siempre (no auto-envía).
  const toggleDictado = () => {
    if (escuchando) { detenerDictado(); return; }
    if (!SpeechRec) return;
    setVozError(null);
    let rec: any;
    try { rec = new SpeechRec(); } catch (e) { setVozError("No se pudo activar el micrófono"); return; }
    rec.lang = "es-MX";          // español (México); respaldo del navegador si no está
    rec.continuous = false;
    rec.interimResults = true;   // el texto aparece mientras se habla
    baseTextRef.current = input; // base = lo ya escrito en el campo
    rec.onresult = (e: any) => {
      let dicho = "";
      for (let i = 0; i < e.results.length; i++) dicho += e.results[i][0].transcript;
      const base = baseTextRef.current;
      const sep = base && !base.endsWith(" ") ? " " : "";
      setInput((base + sep + dicho).replace(/^\s+/, ""));
    };
    rec.onerror = (e: any) => {
      setEscuchando(false);
      const err = e?.error;
      if (err === "not-allowed" || err === "service-not-allowed") setVozError("No se pudo activar el micrófono (permiso denegado)");
      else if (err === "no-speech") setVozError("No se detectó voz, intenta de nuevo");
      else if (err === "aborted") setVozError(null);
      else setVozError("No se pudo activar el micrófono");
    };
    rec.onend = () => { setEscuchando(false); recognitionRef.current = null; };
    recognitionRef.current = rec;
    try { rec.start(); setEscuchando(true); }
    catch (e) { setEscuchando(false); setVozError("No se pudo activar el micrófono"); }
  };

  // Si se cierra el búho mientras dicta, o al desmontar, detén el micrófono.
  useEffect(() => { if (!open) detenerDictado(); /* eslint-disable-next-line */ }, [open]);
  useEffect(() => () => detenerDictado(), []);

  // ── Sistema de posición arrastrable + tilt parallax ──
  const [pos, setPos] = useState<{right:number, bottom:number}>(() => {
    try {
      const saved = localStorage.getItem("axior_position");
      if (saved) {
        const p = JSON.parse(saved);
        if (p && typeof p.right === 'number' && typeof p.bottom === 'number') {
          // Validar que sigue dentro del viewport Y dentro de la franja reservada:
          // una posición vieja guardada a media pantalla se corrige sola al entrar,
          // en vez de quedarse encima de un botón para siempre.
          const maxR = window.innerWidth - 80;
          const maxB = flotanteBottomMax(isMobile);
          return {
            right: Math.max(8, Math.min(maxR, p.right)),
            bottom: Math.max(8, Math.min(maxB, p.bottom))
          };
        }
      }
    } catch {}
    // Default seguro: pegado al rincón inferior derecho para no tapar headers
    // sticky ni botones flotantes (campana de notificaciones del top bar).
    return isMobile ? { right: 12, bottom: 12 } : { right: 22, bottom: 22 };
  });
  const [tilt, setTilt] = useState<{x:number, y:number}>({x: 0, y: 0});
  const [eyeOffset, setEyeOffset] = useState<{x:number, y:number}>({x: 0, y: 0});
  const [dragging, setDragging] = useState(false);
  const [blink, setBlink] = useState(false);

  // Parpadeo natural del búho cada 3-6 segundos
  useEffect(() => {
    if (open) return;
    let timer = setTimeout(function loop(){
      setBlink(true);
      setTimeout(() => setBlink(false), 160);
      timer = setTimeout(loop, 3000 + Math.random()*3000);
    }, 2000 + Math.random()*2000);
    return () => clearTimeout(timer);
  }, [open]);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const posRef = useRef(pos);
  const dragInfoRef = useRef<{startX:number, startY:number, startRight:number, startBottom:number, moved:boolean} | null>(null);
  const justDraggedRef = useRef(false);

  // Sincronizar pos en ref para acceso en handlers globales
  useEffect(() => { posRef.current = pos; }, [pos]);

  // Tilt parallax + ojos siguiendo cursor: AXIOR "voltea" hacia donde está el cursor (efecto sutil 3D)
  useEffect(() => {
    if (open || dragging) {
      setTilt({x: 0, y: 0});
      setEyeOffset({x: 0, y: 0});
      return;
    }
    const handleMouseMove = (e: MouseEvent) => {
      if (!buttonRef.current) return;
      const rect = buttonRef.current.getBoundingClientRect();
      const cx = rect.left + rect.width / 2;
      const cy = rect.top + rect.height / 2;
      const dx = (e.clientX - cx) / 350;
      const dy = (e.clientY - cy) / 350;
      const tiltX = Math.max(-1, Math.min(1, -dy)) * 14;
      const tiltY = Math.max(-1, Math.min(1, dx)) * 14;
      setTilt({x: tiltX, y: tiltY});

      // Eye tracking: ojos siguen cursor en rango más amplio (cubre toda la pantalla)
      const eyeMag = 2.5; // px de movimiento máximo
      const fxFar = (e.clientX - cx) / Math.max(window.innerWidth/2, 200);
      const fyFar = (e.clientY - cy) / Math.max(window.innerHeight/2, 200);
      const eyeX = Math.max(-1, Math.min(1, fxFar)) * eyeMag;
      const eyeY = Math.max(-1, Math.min(1, fyFar)) * eyeMag;
      setEyeOffset({x: eyeX, y: eyeY});
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, [open, dragging]);

  // Drag global handlers (mouse + touch)
  useEffect(() => {
    const move = (clientX: number, clientY: number) => {
      if (!dragInfoRef.current) return;
      const dx = clientX - dragInfoRef.current.startX;
      const dy = clientY - dragInfoRef.current.startY;
      if (!dragInfoRef.current.moved && Math.sqrt(dx*dx + dy*dy) > 5) {
        dragInfoRef.current.moved = true;
        setDragging(true);
      }
      if (dragInfoRef.current.moved) {
        // Se arrastra libremente a lo ANCHO (para destapar lo que estorbe), pero
        // no sube por encima de la franja reservada: ahí empieza el contenido.
        const newRight = Math.max(8, Math.min(window.innerWidth - 80, dragInfoRef.current.startRight - dx));
        const newBottom = Math.max(8, Math.min(flotanteBottomMax(isMobile), dragInfoRef.current.startBottom - dy));
        setPos({right: newRight, bottom: newBottom});
      }
    };
    const end = () => {
      if (!dragInfoRef.current) return;
      if (dragInfoRef.current.moved) {
        try { localStorage.setItem("axior_position", JSON.stringify(posRef.current)); } catch {}
        justDraggedRef.current = true;
        setTimeout(() => { justDraggedRef.current = false; }, 250);
        setDragging(false);
      }
      dragInfoRef.current = null;
    };
    const handleMouseMove = (e: MouseEvent) => move(e.clientX, e.clientY);
    const handleTouchMove = (e: TouchEvent) => {
      if (e.touches.length > 0) move(e.touches[0].clientX, e.touches[0].clientY);
    };
    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("touchmove", handleTouchMove);
    window.addEventListener("mouseup", end);
    window.addEventListener("touchend", end);
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("touchmove", handleTouchMove);
      window.removeEventListener("mouseup", end);
      window.removeEventListener("touchend", end);
    };
  }, []);

  // Tooltip: aparece 4s y desaparece sola; se oculta al abrir el chat
  useEffect(() => {
    if (!showTooltip) return;
    const t = setTimeout(() => {
      setShowTooltip(false);
      try { localStorage.setItem("axior_visto","1"); } catch {}
    }, 5000);
    return () => clearTimeout(t);
  }, []);

  // ── Persistencia del chat en usuarios/{uid}.axiorHistorial ────────────────
  // El patrón es dueño de su doc → sin colección ni reglas nuevas. Va con
  // `updateDoc` y no con `setDoc` merge por el MISMO motivo que el contador de uso:
  // guardar una conversación tampoco es dar de alta una cuenta, y con merge una
  // sesión anónima que charlara con AXIOR dejaba un documento sin correo ni nombre.
  // Si el documento no existe, el chat sigue funcionando; solo no se persiste.
  // Se guardan los últimos AXIOR_TOPE_HISTORIAL mensajes (los docs de Firestore
  // tienen tope de 1MB; el historial crecería sin fin). `restaurado` evita que el
  // saludo pise una conversación recuperada.
  const AXIOR_TOPE_HISTORIAL = 30;
  const [restaurado, setRestaurado] = useState(false);
  const guardandoRef = useRef(false);
  const recortar = (arr:any[]) => arr.slice(-AXIOR_TOPE_HISTORIAL)
    .map(m => ({role:m.role, content:String(m.content||"").slice(0,4000), ts:m.ts||""}));

  const guardarHistorial = async (arr:any[]) => {
    const uid = auth.currentUser?.uid;
    if (!uid || guardandoRef.current) return;
    guardandoRef.current = true;
    try {
      const corto = recortar(arr);
      await updateDoc(doc(db,"usuarios",uid), { axiorHistorial: corto });
      // Sincroniza las otras instancias montadas de AXIOR (hay varias en el árbol).
      try { window.dispatchEvent(new CustomEvent("axior:historial", {detail:{uid, msgs:corto}})); } catch(e){}
    } catch(e){ console.error("axior historial write:", e); }
    finally { guardandoRef.current = false; }
  };

  // Carga inicial del historial (una vez que hay sesión).
  useEffect(() => {
    const uid = auth.currentUser?.uid;
    if (!uid) { setRestaurado(true); return; }
    let cancel = false;
    (async () => {
      try {
        const snap = await getDoc(doc(db,"usuarios",uid));
        if (cancel) return;
        const h = (snap.exists() ? (snap.data() as any)?.axiorHistorial : null);
        if (Array.isArray(h) && h.length) setMsgs(h.filter((m:any)=> m && (m.role==="user"||m.role==="assistant") && m.content));
      } catch(e){ /* sin historial → arranca limpio */ }
      finally { if (!cancel) setRestaurado(true); }
    })();
    return ()=>{ cancel = true; };
  }, [auth.currentUser?.uid]);

  // Otra instancia guardó: reflejarlo aquí para no divergir.
  useEffect(() => {
    const onHist = (e:any) => {
      const uid = auth.currentUser?.uid;
      if (!uid || e?.detail?.uid !== uid || !Array.isArray(e?.detail?.msgs)) return;
      setMsgs(e.detail.msgs);
    };
    window.addEventListener("axior:historial", onHist as any);
    return ()=> window.removeEventListener("axior:historial", onHist as any);
  }, []);

  const nuevaConversacion = () => {
    setMsgs([]); setInput(""); setExpr("atento");
    guardarHistorial([]);
  };

  useEffect(() => {
    if (open && restaurado && msgs.length === 0) {
      setExpr("explicando");
      setMsgs([{
        role:"assistant",
        content:"¡Hola! Soy **AXIOR**, tu copiloto legal 🦉\n\nEstoy aquí para orientarte sobre cumplimiento regulatorio, LFT, contratos, IMSS, SAT y normatividad de Aguascalientes.\n\n¿En qué puedo ayudarte hoy?",
        ts: new Date().toLocaleTimeString("es-MX",{hour:"2-digit",minute:"2-digit"})
      }]);
      setTimeout(() => setExpr("atento"), 2000);
    }
  }, [open, restaurado]);

  // AL ABRIR, EL ÚLTIMO MENSAJE. Esta bajada solo corría al cambiar los mensajes;
  // con una conversación guardada, abrir el chat no cambiaba nada y se veía desde
  // el primer mensaje. Ahora, al abrir, la lista se coloca abajo sin animación; y
  // solo baja (suave) cuando llega algo nuevo.
  const listaMsgsRef = useRef<HTMLDivElement>(null);
  React.useLayoutEffect(() => { if (!open) return; const el = listaMsgsRef.current; if (el) el.scrollTop = el.scrollHeight; }, [open]);
  useEffect(() => { bottomRef.current?.scrollIntoView({behavior:"smooth", block:"nearest"}); }, [msgs, loading]);

  const enviar = async () => {
    if (!input.trim() || loading) return;
    const userMsg = input.trim();
    const ts = new Date().toLocaleTimeString("es-MX",{hour:"2-digit",minute:"2-digit"});
    setInput(""); setLoading(true); setExpr("pensando");
    const conUser = [...msgs, {role:"user" as const, content:userMsg, ts}];
    setMsgs(conUser);
    try {
      // El historial guardado viaja limpio; el CONTEXTO de la cuenta se antepone solo
      // al mensaje actual (así siempre va fresco y sobrevive el recorte del servidor,
      // que conserva los últimos 10). El backend no se toca.
      const historial = msgs.slice(-9).map(m => ({role:m.role, content:m.content}));
      const ctx = leerContextoAxior(auth.currentUser?.uid || "");
      const contenido = ctx ? `${ctx}\n\n=== PREGUNTA DEL PATRÓN ===\n${userMsg}` : userMsg;
      const res = await fetch("/api/axior", {
        method:"POST",
        headers: await cabecerasAxior(),
        body: JSON.stringify({messages:[...historial,{role:"user",content:contenido}]})
      });
      const rechazo = mensajeRechazoAxior(res.status);
      const data = rechazo ? {} : await res.json();
      const reply = rechazo || data.text || "No pude procesar tu consulta. Intenta de nuevo 🦉";
      const replyTs = new Date().toLocaleTimeString("es-MX",{hour:"2-digit",minute:"2-digit"});
      const finales = [...conUser, {role:"assistant" as const, content:reply, ts:replyTs}];
      setMsgs(finales);
      guardarHistorial(finales);
      setExpr(reply.includes("cumpl")||reply.includes("correcto")?"confirmado":reply.includes("?")?"explicando":"atento");
    } catch {
      const errTs = new Date().toLocaleTimeString("es-MX",{hour:"2-digit",minute:"2-digit"});
      setMsgs(prev => [...prev, {role:"assistant", content:"Hubo un problema de conexión. Puedes consultarme en **axislegalags.com** o llamar al **449 425 11 28** 🦉", ts:errTs}]);
      setExpr("sorprendido");
    }
    setTimeout(() => { setLoading(false); setExpr("atento"); }, 300);
  };

  const renderMsg = (text:string) => text.split("\n").filter(Boolean).map((line,i) => (
    <p key={i} style={{margin:"0 0 4px"}} dangerouslySetInnerHTML={{__html:
      line.replace(/\*\*(.*?)\*\*/g,"<strong>$1</strong>").replace(/\*(.*?)\*/g,"<em>$1</em>")}}/>
  ));

  const W = isMobile ? "calc(100vw - 24px)" : "380px";
  const H = isMobile ? "72vh" : "540px";

  // Vista que pidió ocultar el búho (p. ej. Portal del trabajador): no renderiza
  // nada. La lógica/estado del chat queda intacta; solo no se pinta el flotante.
  if (oculto) return null;

  return (
    <>
      {open && (
        <div style={{position:"fixed" as const, bottom:isMobile?0:88, right:isMobile?0:24,
          width:W, height:H, background:"linear-gradient(180deg,#0D1E3A,#0B1829)",
          borderRadius:isMobile?"20px 20px 0 0":20, display:"flex", flexDirection:"column" as const,
          boxShadow:"0 24px 80px rgba(0,0,0,0.6), 0 0 0 1px rgba(184,147,42,0.25)", zIndex:Z_FLOTANTE-1,
          overflow:"hidden", fontFamily:fontSans}}>
          {/* Header */}
          <div style={{background:"linear-gradient(135deg,#162447,#1B3A66)", padding:"12px 16px",
            display:"flex", alignItems:"center", gap:10, borderBottom:"1px solid rgba(184,147,42,0.2)", flexShrink:0}}>
            <div style={{position:"relative" as const}}>
              <AxiorSVG size={44} expr={expr} view="body"/>
              <div style={{position:"absolute" as const, bottom:1, right:1, width:10, height:10,
                borderRadius:"50%", background:loading?"#F59E0B":"#10B981",
                border:"2px solid #0D1E3A", transition:"background 0.4s"}}/>
            </div>
            <div style={{flex:1}}>
              <div style={{fontFamily:fontSerif, fontWeight:700, fontSize:17, color:"#D4A843", lineHeight:1}}>AXIOR</div>
              <div style={{fontSize:11, color:"rgba(255,255,255,0.4)", marginTop:3}}>
                {loading?"✍️ Escribiendo...":"Copiloto legal de AXIS · En línea"}
              </div>
            </div>
            {msgs.length > 0 && (
              <button onClick={nuevaConversacion} title="Nueva conversación"
                style={{background:"rgba(255,255,255,0.08)", border:"none", color:"rgba(255,255,255,0.5)",
                  cursor:"pointer", height:28, borderRadius:8, fontSize:11, fontWeight:700, padding:"0 9px", marginRight:6,
                  display:"flex", alignItems:"center", justifyContent:"center", gap:5, whiteSpace:"nowrap" as const}}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"/></svg>
                Nueva
              </button>
            )}
            <button onClick={() => setOpen(false)}
              style={{background:"rgba(255,255,255,0.08)", border:"none", color:"rgba(255,255,255,0.5)",
                cursor:"pointer", width:28, height:28, borderRadius:8, fontSize:14,
                display:"flex", alignItems:"center", justifyContent:"center"}}>✕</button>
          </div>
          {/* Mensajes */}
          <div ref={listaMsgsRef} style={{flex:1, overflowY:"auto" as const, padding:"14px 14px 8px",
            display:"flex", flexDirection:"column" as const, gap:10}}>
            {msgs.map((m,i) => (
              <div key={i} style={{display:"flex", flexDirection:m.role==="user"?"row-reverse" as const:"row" as const, alignItems:"flex-end", gap:8}}>
                {m.role==="assistant" && <div style={{flexShrink:0}}><AxiorSVG size={28} expr={i===msgs.length-1?expr:"atento"}/></div>}
                <div style={{maxWidth:"82%"}}>
                  <div style={{background:m.role==="user"?"linear-gradient(135deg,#B8932A,#9A7020)":"rgba(255,255,255,0.07)",
                    borderRadius:m.role==="user"?"16px 4px 16px 16px":"4px 16px 16px 16px",
                    padding:"10px 13px", border:m.role==="user"?"none":"1px solid rgba(255,255,255,0.08)",
                    color:m.role==="user"?"white":"rgba(255,255,255,0.88)", fontSize:13, lineHeight:1.65}}>
                    {renderMsg(m.content)}
                  </div>
                  {m.ts && <div style={{fontSize:10, color:"rgba(255,255,255,0.22)", marginTop:3,
                    textAlign:m.role==="user"?"right" as const:"left" as const}}>{m.ts}</div>}
                </div>
              </div>
            ))}
            {loading && (
              <div style={{display:"flex", alignItems:"flex-end", gap:8}}>
                <AxiorSVG size={28} expr="pensando"/>
                <div style={{background:"rgba(255,255,255,0.07)", borderRadius:"4px 16px 16px 16px",
                  padding:"12px 16px", border:"1px solid rgba(255,255,255,0.08)"}}>
                  <div style={{display:"flex", gap:5}}>
                    {[0,1,2].map(j => <div key={j} style={{width:6, height:6, borderRadius:"50%",
                      background:"#D4A843", animation:`pulse ${1.2}s ${j*0.2}s ease-in-out infinite`}}/>)}
                  </div>
                </div>
              </div>
            )}
            <div ref={bottomRef}/>
          </div>
          {/* Input */}
          <div {...ZONA_DE_CAPTURA} style={{padding:"10px 12px 14px", borderTop:"1px solid rgba(255,255,255,0.07)", background:"rgba(0,0,0,0.2)", flexShrink:0}}>
            {msgs.length <= 1 && (
              <div style={{display:"flex", gap:6, flexWrap:"wrap" as const, marginBottom:8}}>
                {["¿Qué es el ISSEA?","¿Cuánto aguinaldo?","¿Necesito RIT?"].map(s => (
                  <button key={s} onClick={() => setInput(s)}
                    style={{fontSize:10, padding:"4px 10px", borderRadius:10,
                      background:"rgba(184,147,42,0.12)", border:"1px solid rgba(184,147,42,0.25)",
                      color:"#D4A843", cursor:"pointer", whiteSpace:"nowrap" as const}}>{s}</button>
                ))}
              </div>
            )}
            <div style={{display:"flex", gap:8, alignItems:"flex-end"}}>
              <textarea value={input} onChange={e => setInput(e.target.value)}
                onKeyDown={e => {if(e.key==="Enter"&&!e.shiftKey){e.preventDefault();enviar();}}}
                placeholder="Escribe tu consulta legal..." rows={1}
                style={{flex:1, background:"rgba(255,255,255,0.07)", border:"1px solid rgba(255,255,255,0.12)",
                  borderRadius:12, color:"white", fontSize:13, padding:"10px 13px",
                  outline:"none", resize:"none" as const, fontFamily:fontSans, lineHeight:1.5, maxHeight:80}}/>
              {vozSoportada && (<>
                <style>{`@keyframes axiorMicPulse{0%,100%{opacity:1}50%{opacity:0.4}}`}</style>
                <button onClick={toggleDictado} disabled={loading} title={escuchando?"Detener dictado":"Dictar por voz"} aria-label="Dictar por voz"
                  style={{width:40, height:40, borderRadius:12, flexShrink:0, cursor:loading?"not-allowed":"pointer",
                    border:`1px solid ${escuchando?"rgba(220,38,38,0.55)":"rgba(255,255,255,0.12)"}`,
                    background:escuchando?"rgba(220,38,38,0.18)":"rgba(255,255,255,0.07)",
                    display:"flex", alignItems:"center", justifyContent:"center", transition:"all 0.2s"}}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" style={{animation:escuchando?"axiorMicPulse 1.1s ease-in-out infinite":"none"}}>
                    <rect x="9" y="3" width="6" height="11" rx="3" stroke={escuchando?"#FCA5A5":"rgba(255,255,255,0.72)"} strokeWidth="1.7"/>
                    <path d="M5 11a7 7 0 0014 0M12 18v3" stroke={escuchando?"#FCA5A5":"rgba(255,255,255,0.72)"} strokeWidth="1.7" strokeLinecap="round"/>
                  </svg>
                </button>
              </>)}
              <button onClick={enviar} disabled={loading||!input.trim()}
                style={{width:40, height:40, borderRadius:12, border:"none", flexShrink:0,
                  background:(!input.trim()||loading)?"rgba(255,255,255,0.05)":"linear-gradient(135deg,#B8932A,#D4A843)",
                  cursor:(!input.trim()||loading)?"not-allowed":"pointer", fontSize:16,
                  display:"flex", alignItems:"center", justifyContent:"center",
                  boxShadow:(!input.trim()||loading)?"none":"0 4px 14px rgba(184,147,42,0.4)",
                  transition:"all 0.2s"}}>
                {loading?"⏳":"➤"}
              </button>
            </div>
            {escuchando && !vozError && (
              <div style={{textAlign:"center" as const, marginTop:6, fontSize:11, color:"#D4A843"}}>🎙️ Escuchando… habla ahora</div>
            )}
            {vozError && (
              <div style={{textAlign:"center" as const, marginTop:6, fontSize:11, color:"#FCA5A5"}}>{vozError}</div>
            )}
            <div style={{textAlign:"center" as const, marginTop:6, fontSize:10, color:"rgba(255,255,255,0.15)"}}>
              AXIOR · AXIS Asesoría Legal · axislegalags.com
            </div>
          </div>
        </div>
      )}
      {/* ── Tooltip bienvenida — aparece 3s al cargar, luego desaparece ── */}
      {/* El saludo flotante es parte del lanzador: si el lanzador está oculto
          (portal del patrón móvil), no debe aparecer huérfano desde abajo. */}
      {showTooltip && !open && !(ocultarLanzador || lanzadorOculto) && (
        <div style={{
          // Anclada al lanzador, no a la esquina: si el búho se movió, el saludo
          // lo sigue en vez de quedarse suelto encima del contenido.
          position:"fixed" as const, bottom: pos.bottom + (isMobile?68:FLOTANTE_ALTO) - 18, right: pos.right, zIndex:Z_FLOTANTE+1,
          display:"flex", flexDirection:"column" as const, alignItems:"flex-end", gap:6,
          animation:"fadeUp 0.4s ease both",
          pointerEvents:"none" as const,
        }}>
          {/* Burbuja */}
          <div style={{
            background:"linear-gradient(135deg,#162447,#1B3A66)",
            border:"1px solid rgba(184,147,42,0.35)",
            borderRadius:"16px 16px 4px 16px",
            padding:"10px 14px",
            boxShadow:"0 8px 32px rgba(0,0,0,0.4), 0 0 0 1px rgba(184,147,42,0.15)",
            maxWidth:200,
          }}>
            <div style={{display:"flex", alignItems:"center", gap:8, marginBottom:4}}>
              <AxiorSVG size={22} expr="explicando"/>
              <span style={{fontWeight:700, fontSize:12, color:"#D4A843", fontFamily:"'DM Sans',sans-serif"}}>
                AXIOR
              </span>
            </div>
            <p style={{margin:0, fontSize:11, color:"rgba(255,255,255,0.8)", lineHeight:1.55, fontFamily:"'DM Sans',sans-serif"}}>
              ¡Hola! Soy tu asistente legal.<br/>
              <span style={{color:"rgba(184,147,42,0.8)"}}>Tócame si tienes dudas 🦉</span>
            </p>
          </div>
          {/* Flecha dorada apuntando al botón */}
          <svg width="28" height="20" viewBox="0 0 28 20" style={{marginRight:22}}>
            <path d="M14 0 L24 12 L18 12 L18 20 L10 20 L10 12 L4 12 Z" fill="#D4A843" opacity="0.9"/>
          </svg>
        </div>
      )}

      {/* Botón flotante — composición premium: cara con penachos rompiendo el círculo.
          Se oculta por prop ocultarLanzador (render-gate del portal del patrón) o por
          evento; el panel sigue disponible para abrirse desde el botón del header. */}
      {!(ocultarLanzador || lanzadorOculto) && (() => {
        // Dimensiones responsivas: en móvil sustancialmente más compacto para
        // que no tape títulos sticky ni la campana de notificaciones.
        const FB = isMobile ? {
          W: 54, H: 68,
          circle: { size: 48, top: 16, left: 3 },
          face: { size: 86, top: -6, left: -16 },
          eye: 9, reflect: 2.5,
          dot: { top: 18, right: 5, size: 9, border: 1.8 },
        } : {
          W: 90, H: 115,
          circle: { size: 80, top: 25, left: 5 },
          face: { size: 140, top: -10, left: -25 },
          eye: 14, reflect: 4,
          dot: { top: 30, right: 8, size: 12, border: 2.5 },
        };
        return (
        <button
          ref={buttonRef}
          onClick={(e) => {
            if (justDraggedRef.current) {
              e.preventDefault();
              return;
            }
            setOpen(o => !o);
            setShowTooltip(false);
            try{localStorage.setItem('axior_visto','1');}catch{}
          }}
          onMouseDown={(e) => {
            dragInfoRef.current = {
              startX: e.clientX, startY: e.clientY,
              startRight: posRef.current.right, startBottom: posRef.current.bottom,
              moved: false,
            };
          }}
          onTouchStart={(e) => {
            if (e.touches.length === 0) return;
            dragInfoRef.current = {
              startX: e.touches[0].clientX, startY: e.touches[0].clientY,
              startRight: posRef.current.right, startBottom: posRef.current.bottom,
              moved: false,
            };
          }}
          title="Arrastra para reposicionar · Click para abrir"
          style={{position:"fixed" as const, bottom:pos.bottom, right:pos.right, zIndex:Z_FLOTANTE,
            width:FB.W, height:FB.H, border:"none", background:"transparent",
            cursor: dragging ? "grabbing" : "grab",
            padding:0,
            perspective: "600px",
            userSelect: "none" as const,
            touchAction: "none" as const,
          }}>
          {/* Frame circular dorado (la "moneda") */}
          <div style={{
            position: "absolute" as const,
            top: FB.circle.top, left: FB.circle.left,
            width: FB.circle.size, height: FB.circle.size,
            borderRadius: "50%",
            background: "linear-gradient(145deg,#162447,#0B1829)",
            boxShadow: open
              ? "0 0 0 3px #D4A843, 0 8px 32px rgba(184,147,42,0.55)"
              : "0 0 0 2px rgba(184,147,42,0.45), 0 8px 32px rgba(0,0,0,0.45)",
            transform: open ? "scale(1.05)" : (dragging ? "scale(1.08)" : "scale(1)"),
            transition: dragging ? "none" : "box-shadow 0.3s ease, transform 0.3s cubic-bezier(0.34,1.56,0.64,1)",
            pointerEvents: "none" as const,
          }}/>

          {/* Wrapper de tilt 3D que contiene la cara y los ojos */}
          <div style={{
            position: "absolute" as const,
            top: 0, left: 0,
            width: FB.W, height: FB.H,
            transform: `rotateX(${tilt.x}deg) rotateY(${tilt.y}deg)`,
            transformStyle: "preserve-3d" as const,
            transition: dragging ? "none" : "transform 0.18s ease-out",
            willChange: "transform",
            pointerEvents: "none" as const,
          }}>
            {/* Imagen de la cara — los penachos se extienden ARRIBA del círculo */}
            <img
              src="/axior-face.png"
              alt="AXIOR"
              draggable={false}
              style={{
                position: "absolute" as const,
                top: FB.face.top, left: FB.face.left,
                width: FB.face.size, height: FB.face.size,
                objectFit: "contain" as const,
                pointerEvents: "none" as const,
                userSelect: "none" as const,
                animation: "axiorBreathe 4s ease-in-out infinite",
                filter: "drop-shadow(0 4px 8px rgba(0,0,0,0.4))",
              }}
            />

            {/* Pupilas que siguen el cursor — solo en desktop. En móvil no hay cursor,
                los ojos pintados de la imagen son suficientes y se ven mejor sin overlay. */}
            {!open && !isMobile && (
              <>
                {/* Ojo izquierdo */}
                <div style={{
                  position: "absolute" as const,
                  left: "22%", top: "52%",
                  width: FB.eye, height: blink ? 1 : FB.eye,
                  marginLeft: -FB.eye/2, marginTop: -FB.eye/2,
                  borderRadius: "50%",
                  background: "radial-gradient(circle at 35% 30%, #1a1410 0%, #050505 70%)",
                  transform: `translate(${eyeOffset.x}px, ${eyeOffset.y}px)`,
                  transition: "transform 0.15s ease-out, height 0.08s ease",
                  pointerEvents: "none" as const,
                  boxShadow: blink ? "none" : "0 0 1px rgba(0,0,0,0.6)",
                }}/>
                {/* Reflejo ojo izq */}
                {!blink && (
                  <div style={{
                    position: "absolute" as const,
                    left: "22%", top: "52%",
                    width: FB.reflect, height: FB.reflect,
                    marginLeft: -1, marginTop: -FB.eye*0.35,
                    borderRadius: "50%",
                    background: "rgba(255,250,240,0.92)",
                    transform: `translate(${eyeOffset.x*0.7}px, ${eyeOffset.y*0.7}px)`,
                    transition: "transform 0.15s ease-out",
                    pointerEvents: "none" as const,
                  }}/>
                )}
                {/* Ojo derecho (con monóculo) */}
                <div style={{
                  position: "absolute" as const,
                  left: "69%", top: "52%",
                  width: FB.eye, height: blink ? 1 : FB.eye,
                  marginLeft: -FB.eye/2, marginTop: -FB.eye/2,
                  borderRadius: "50%",
                  background: "radial-gradient(circle at 35% 30%, #1a1410 0%, #050505 70%)",
                  transform: `translate(${eyeOffset.x}px, ${eyeOffset.y}px)`,
                  transition: "transform 0.15s ease-out, height 0.08s ease",
                  pointerEvents: "none" as const,
                  boxShadow: blink ? "none" : "0 0 1px rgba(0,0,0,0.6)",
                }}/>
                {/* Reflejo ojo der */}
                {!blink && (
                  <div style={{
                    position: "absolute" as const,
                    left: "69%", top: "52%",
                    width: FB.reflect, height: FB.reflect,
                    marginLeft: -1, marginTop: -FB.eye*0.35,
                    borderRadius: "50%",
                    background: "rgba(255,250,240,0.92)",
                    transform: `translate(${eyeOffset.x*0.7}px, ${eyeOffset.y*0.7}px)`,
                    transition: "transform 0.15s ease-out",
                    pointerEvents: "none" as const,
                  }}/>
                )}
              </>
            )}
          </div>

          {/* Status dot — verde en línea / amber pensando */}
          {!open && msgs.length===0 && (
            <div style={{position:"absolute" as const, top:FB.dot.top, right:FB.dot.right,
              width:FB.dot.size, height:FB.dot.size,
              borderRadius:"50%", background:"#10B981", border:`${FB.dot.border}px solid #0B1829`,
              animation:"pulse 2s ease-in-out infinite", pointerEvents:"none" as const, zIndex:2}}/>
          )}
        </button>
        );
      })()}
    </>
  );
}


// (Retirado) logUso escribía un doc en `eventos_uso` por cada apertura de módulo. La
// colección crecía sin techo y nadie la consumía: el panel admin ya no la lee. No se
// borran los datos existentes ni se tocan sus reglas; simplemente se dejó de escribir.
//
// EN SU LUGAR — contador ACOTADO de uso: un rollup por cuenta y por MES dentro del
// propio doc del patrón (`usuarios/{uid}.usoPorMes["YYYYMM"]`) con increment(). Como
// mucho 12 entradas al año por cuenta. Se eligió el mapa sobre una subcolección
// porque las reglas YA permiten al dueño escribir su doc (usuarios/{userId}) → sin
// reglas nuevas, y porque el panel admin ya lee `usuarios`, así que el uso no cuesta
// lecturas extra.
//
// UN CONTADOR NO DA DE ALTA A NADIE. Aquí decía "no crea documentos" y era falso:
// `setDoc` con merge sobre una ruta que no existe LA CREA. Cualquier sesión que
// abriera un módulo sin tener documento previo —incluidas las anónimas, que también
// pasan el isSignedIn() de las reglas— dejaba un `usuarios/{uid}` con el contador
// dentro y nada más: sin correo, sin nombre y sin último acceso. Filas en blanco en
// el panel, sobre las que no se puede decidir nada.
//
// `updateDoc` es la operación que hacía falta desde el principio: actualiza si el
// documento existe y falla si no. Y la clave va con punto —`usoPorMes.202609`— porque
// `updateDoc` con un objeto anidado REEMPLAZA el mapa entero y se llevaría por
// delante los meses anteriores.
async function registrarUsoMensual(user: any) {
  try {
    const uid = user?.uid; if (!uid || user?.isAnonymous) return;
    const d = new Date();
    const ym = `${d.getFullYear()}${String(d.getMonth()+1).padStart(2,"0")}`;
    await updateDoc(doc(db,"usuarios",uid), { [`usoPorMes.${ym}`]: increment(1) });
  } catch(e) { /* si el documento no existe, no se crea: no es un alta */ }
}

// ─── APP SHELL (Fase 2A — sidebar premium, solo desktop) ─────────────────────
// Envoltura visual para las pantallas "internas" (suite, módulos). Renderiza el
// sidebar navy a la izquierda y el contenido a la derecha. En isMobile devuelve
// children sin sidebar (el drawer móvil llega en el Paso 2B). No toca lógica:
// el ruteo sigue siendo setAppPantalla con los mismos strings de hoy.
const SIDEBAR_ACCENT: Record<string,string> = {
  suite:       "#B8932A",
  documentos:  "#B8932A",
  regulamx:    "#B8932A",
  nomina:      "#722F37",
  empleados:   "#236478",
  calendario:  "#A0522D",
  contratos:   "#1F4E3D",
  obligaciones:"#6B4E1E",
  flotilla:    "#5D4037",
  proveedores: "#3D3A6B",
  clientes:    "#8E3B6E",
  admin:       "#B8932A",
  planes:      "#B8932A",
  creditos:    "#1E3A8A",
  acerca_de:   "#B8932A",
};

function SidebarIcon({name}:{name:string}) {
  const c: React.CSSProperties = {display:"block"};
  switch (name) {
    case "home":       return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" style={c}><path d="M3 11l9-8 9 8" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/><path d="M5 9.5V20a1 1 0 001 1h4v-6h4v6h4a1 1 0 001-1V9.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/></svg>;
    case "documentos": return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" style={c}><path d="M4 6a2 2 0 012-2h4l2 2h6a2 2 0 012 2v10a2 2 0 01-2 2H6a2 2 0 01-2-2V6z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round"/><path d="M8 13h8M8 17h5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/></svg>;
    case "regulamx":   return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" style={c}><path d="M12 3l-8 4v5c0 5 3.5 8.5 8 10 4.5-1.5 8-5 8-10V7l-8-4z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round"/><path d="M8.5 12l2.3 2.3L15.5 9.5" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"/></svg>;
    case "nomina":     return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" style={c}><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.7"/><path d="M12 7v2m0 6v2m-3-5c0-1.1.9-2 2-2h2a2 2 0 010 4h-2a2 2 0 000 4h2a2 2 0 002-2" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/></svg>;
    case "empleados":  return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" style={c}><circle cx="9" cy="8" r="3.5" stroke="currentColor" strokeWidth="1.7"/><path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/><circle cx="18" cy="9" r="2.6" stroke="currentColor" strokeWidth="1.7"/><path d="M21 20c0-2.6-1.2-4.5-3-5.3" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/></svg>;
    case "calendario": return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" style={c}><rect x="3" y="5" width="18" height="16" rx="2.5" stroke="currentColor" strokeWidth="1.7"/><path d="M3 10h18" stroke="currentColor" strokeWidth="1.7"/><path d="M8 3v4M16 3v4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/></svg>;
    case "contratos":  return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" style={c}><path d="M7 3h7l5 5v11a2 2 0 01-2 2H7a2 2 0 01-2-2V5a2 2 0 012-2z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round"/><path d="M14 3v5h5" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round"/><path d="M8 13h8M8 17h5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/></svg>;
    case "flotilla":   return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" style={c}><rect x="2.5" y="10" width="19" height="8" rx="2.4" stroke="currentColor" strokeWidth="1.7"/><path d="M6 10V8a2 2 0 012-2h8a2 2 0 012 2v2" stroke="currentColor" strokeWidth="1.7"/><circle cx="7" cy="18.5" r="2" stroke="currentColor" strokeWidth="1.7"/><circle cx="17" cy="18.5" r="2" stroke="currentColor" strokeWidth="1.7"/></svg>;
    case "proveedores":return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" style={c}><rect x="3" y="7.5" width="18" height="12" rx="2" stroke="currentColor" strokeWidth="1.7"/><path d="M9 7.5V6a2.2 2.2 0 012.2-2.2h1.6A2.2 2.2 0 0115 6v1.5" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round"/><path d="M3 12h18" stroke="currentColor" strokeWidth="1.7"/></svg>;
    case "clientes":   return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" style={c}><circle cx="8.5" cy="8" r="3.3" stroke="currentColor" strokeWidth="1.7"/><path d="M3 20c0-3 2.5-5.5 5.5-5.5S14 17 14 20" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/><rect x="15.5" y="4" width="6" height="9" rx="1.2" stroke="currentColor" strokeWidth="1.7"/><path d="M17 7h3M17 9.5h3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>;
    case "creditos":   return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" style={c}><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.7"/><path d="M12 6.5v11" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/><path d="M15 9.5c-.7-1-1.9-1.5-3-1.5-1.5 0-3 .8-3 2.3 0 1.4 1.5 1.9 3 1.9s3 .4 3 1.8c0 1.5-1.5 2.3-3 2.3-1.1 0-2.3-.5-3-1.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/></svg>;
    case "ayuda":      return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" style={c}><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.7"/><path d="M9.3 9.2a2.8 2.8 0 015.4 1c0 1.9-2.7 2.3-2.7 4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/><path d="M12 17.3h.01" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"/></svg>;
    case "cuentas_trab": return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" style={c}><rect x="3" y="5" width="18" height="14" rx="2.5" stroke="currentColor" strokeWidth="1.7"/><circle cx="9" cy="11" r="2.2" stroke="currentColor" strokeWidth="1.7"/><path d="M5.5 16.5c0-1.7 1.6-3 3.5-3s3.5 1.3 3.5 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M14.5 10h4M14.5 13h4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/></svg>;
    case "tareas":     return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" style={c}><rect x="5" y="4" width="14" height="17" rx="2" stroke="currentColor" strokeWidth="1.7"/><path d="M9 3.5h6a1 1 0 011 1V6a1 1 0 01-1 1H9a1 1 0 01-1-1V4.5a1 1 0 011-1z" stroke="currentColor" strokeWidth="1.6"/><path d="M8.5 12l1.6 1.6L13 10.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/><path d="M8.5 17h7" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/></svg>;
    case "recibos":    return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" style={c}><path d="M6 3h9l3 3v13.6l-2-1.1-2 1.1-2-1.1-2 1.1-2-1.1-2 1.1V6a3 3 0 013-3z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round"/><path d="M14 3v4h4" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round"/><path d="M12 9.6v5m-1.7-3.9c.35-.5 1-.8 1.7-.8 1.1 0 1.7.55 1.7 1.2 0 .75-.75 1-1.7 1s-1.7.3-1.7 1.05c0 .65.6 1.2 1.7 1.2.7 0 1.35-.3 1.7-.8" stroke="currentColor" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round"/></svg>;
    case "obligaciones": return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" style={c}><path d="M12 3l7 3v5.5c0 4.3-3 7.4-7 8.5-4-1.1-7-4.2-7-8.5V6l7-3z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round"/><path d="M9 11.5l2.2 2.2L15.5 9.4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>;
    default:           return null;
  }
}

// ═══ LA MARCA DE VISTO ═══════════════════════════════════════════════════
//
// UNA marca de tiempo POR USUARIO, guardada en el servidor. Lo no leído es lo
// posterior a ella. No una bandera por notificación: eso multiplica escrituras y
// se desincroniza entre el teléfono y la computadora.
//
// Consecuencia buscada: VERLAS EN EL MÓVIL LAS APAGA EN EL ESCRITORIO.
//
// Antes había dos marcas y ninguna salía del navegador: la campana del patrón
// guardaba `{lastSeen, ids[]}` en `actividadVistaPor_{uid}` y el portal del
// trabajador un número suelto en `notificacionesVistasAt:{uid}`. Dos vocabularios
// para el mismo hecho, y los dos por dispositivo: verlas en el teléfono no las
// apagaba en la computadora, y un dominio distinto —cada despliegue de Preview lo
// es— las devolvía todas.
//
// Los `ids[]` se van con esto: con una marca de tiempo sobran, y eran los que se
// recortaban a 200 y se desincronizaban.
//
// DÓNDE: `usuarios/{uid}`, que el propio usuario puede escribir —patrón o
// trabajador— sin tocar una sola regla de Firestore.
//
// CON `updateDoc`, NUNCA `setDoc`: solo el alta crea ese documento y eso se
// comprueba con un grep (ver `asegurarDocUsuario`). Y si el documento no está
// —una cuenta anterior a esa función—, el fallo se traga y se cae al respaldo
// local: no poder leer una marca no puede dejar a nadie sin su pantalla.
const _claveMarcaLocal = (uid?:string)=> `notificacionesVistasAt:${uid||""}`;
const CAMPO_MARCA_VISTAS = "notificacionesVistasAt";

// EL ESTADO DE LA MARCA, con `null` de por medio a propósito: mientras no se sabe
// qué se vio, NO se afirma que algo es nuevo. Un contador que grita antes de
// saber es peor que uno que tarda medio segundo en encenderse.
function useMarcaVistas(uid?: string): {marca: number|null; marcarVistoAhora: ()=>void} {
  const [marca, setMarca] = useState<number|null>(null);
  useEffect(() => {
    if (!uid) { setMarca(null); return; }
    let vivo = true;
    const local = () => { try { return Number(localStorage.getItem(_claveMarcaLocal(uid))||0)||0; } catch { return 0; } };
    (async () => {
      try {
        const snap = await getDoc(doc(db, "usuarios", uid));
        if (!vivo) return;
        const guardada = Number((snap.data() as any)?.[CAMPO_MARCA_VISTAS] || 0) || 0;
        if (guardada > 0) { setMarca(guardada); return; }
        // PRIMERA VEZ: no se le entregan doscientas notificaciones viejas. Se le
        // pone la marca de AHORA, y a partir de aquí lo nuevo es lo posterior.
        const ahora = Date.now();
        setMarca(ahora);
        try { await updateDoc(doc(db, "usuarios", uid), {[CAMPO_MARCA_VISTAS]: ahora}); }
        catch(e) { /* sin documento o sin red: queda el respaldo local */ }
        try { localStorage.setItem(_claveMarcaLocal(uid), String(ahora)); } catch {}
      } catch(e) {
        // No se pudo leer el servidor: se usa lo último que sepa este navegador.
        if (vivo) setMarca(local());
      }
    })();
    return () => { vivo = false; };
  }, [uid]);
  const marcarVistoAhora = () => {
    const ahora = Date.now();
    setMarca(ahora);
    if (!uid) return;
    updateDoc(doc(db, "usuarios", uid), {[CAMPO_MARCA_VISTAS]: ahora}).catch(()=>{});
    try { localStorage.setItem(_claveMarcaLocal(uid), String(ahora)); } catch {}
  };
  return {marca, marcarVistoAhora};
}

// ─── CAMPANA DE NOTIFICACIONES (Fase 3B v2) ──────────────────────────────
// Vive en el top bar de AppShell — visible en TODAS las pantallas internas.
// Self-contained: estado open/cerrado, click-outside cierra, dropdown con
// los pendientes ordenados por urgencia y "Ver todas (N) ▾" para expandir.
// ═══ LOS PANELES DESPLEGABLES, POR ENCIMA DE CUALQUIER BARRA FIJA ════════════
// LA CAUSA (9-oct-2026, en Preview): en la ficha del empleado, el panel de la
// campana se dibujaba DEBAJO de la barra fija de la ficha y se cortaba. El panel
// vivía DENTRO de la barra superior de la plataforma, que es `sticky` con zIndex 60
// (70 en el teléfono) y por eso forma su propia capa: el zIndex 200 del panel solo
// competía DENTRO de esa barra. Las barras fijas de los módulos (la de la ficha,
// zIndex 100; otras, hasta 700) quedaban encima de la barra superior y, con ella,
// del panel.
// AHORA EL PANEL SE DIBUJA EN <body> (createPortal), con posición FIJA calculada
// desde el botón y una capa por encima de cualquier barra (CAPA_PANEL_DESPLEGABLE).
// Su alto se limita a lo que queda de ventana bajo el botón, con desplazamiento
// interno. Lo usan la campana (Actividad de trabajadores) y el escudo (Requieren
// tu atención), en escritorio y en el teléfono.
const CAPA_PANEL_DESPLEGABLE = 4500;
function usePosicionPanel(ancla: React.RefObject<HTMLElement>, abierto: boolean): {top:number; right:number}|null {
  const [pos, setPos] = useState<{top:number; right:number}|null>(null);
  useEffect(() => {
    if (!abierto) { setPos(null); return; }
    const medir = () => {
      const r = ancla.current?.getBoundingClientRect();
      if (r) setPos({top: Math.round(r.bottom + 8), right: Math.max(8, Math.round(window.innerWidth - r.right))});
    };
    medir();
    window.addEventListener("resize", medir); window.addEventListener("scroll", medir, true);
    return () => { window.removeEventListener("resize", medir); window.removeEventListener("scroll", medir, true); };
  }, [abierto]);   // eslint-disable-line
  return pos;
}
function estiloPanelSobreTodo(pos: {top:number; right:number}|null, isMobile: boolean): any {
  return {
    position: "fixed" as const, top: pos ? pos.top : -9999, right: isMobile ? 12 : (pos ? pos.right : 0),
    width: isMobile ? "min(360px, calc(100vw - 24px))" : 380,
    maxHeight: pos ? `min(560px, calc(100vh - ${pos.top + 12}px))` : "min(72vh, 560px)", overflowY: "auto" as const,
    zIndex: CAPA_PANEL_DESPLEGABLE, visibility: (pos ? "visible" : "hidden") as any,
  };
}

// ── Campana A: "Actividad de trabajadores" — actividades por confirmar + checadas +
//    flotilla recientes. Separada de "Alertas" (NotificationBell). ───────────
function ActividadBell({actividad, uid, isMobile, fontSerif, onIrModulo}: {
  actividad: { tareas:any[]; checadas:any[]; flotilla:any[]; accidentes:any[]; noConformes?:any[]; historial:any[]; total:number };
  uid?: string; isMobile: boolean; fontSerif: string; onIrModulo: (m: AppPantalla) => void;
}) {
  const [open, setOpen] = useState(false);
  const [tab, setTab] = useState<"avisos"|"historial">("avisos");
  // La MISMA marca que lee el portal del trabajador y la notificación del
  // navegador. Una sola fuente para el mismo hecho.
  const {marca, marcarVistoAhora} = useMarcaVistas(uid);
  // Snapshot de lo que estaba pendiente AL ABRIR: se muestra en "Pendientes" en
  // esta apertura aunque al abrir ya se marcaron como vistos (así no se vacía la
  // lista al instante). En la siguiente apertura ya no reaparecen.
  const [snapshotPend, setSnapshotPend] = useState<{checadas:any[]; flotilla:any[]; accidentes:any[]; noConformes:any[]}|null>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  // El panel va en <body> (ver usePosicionPanel): "fuera" también es fuera de él.
  const panelRef = useRef<HTMLDivElement>(null);
  const posPanel = usePosicionPanel(containerRef, open);
  useEffect(() => {
    if (!open) return;
    const handler = (e: MouseEvent | TouchEvent) => {
      if (containerRef.current && !containerRef.current.contains(e.target as Node) && !(panelRef.current && panelRef.current.contains(e.target as Node))) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    document.addEventListener("touchstart", handler);
    return () => { document.removeEventListener("mousedown", handler); document.removeEventListener("touchstart", handler); };
  }, [open]);

  const tareas = actividad?.tareas || [];
  const checadas = actividad?.checadas || [];
  const flotilla = actividad?.flotilla || [];
  const accidentes = actividad?.accidentes || [];
  const noConformes = actividad?.noConformes || [];
  const historial = actividad?.historial || [];
  const total = actividad?.total || 0;
  // NO VISTO = posterior a la marca. Sin `ids[]`: con una marca de tiempo sobran.
  //
  // Mientras la marca es `null` no se sabe qué se vio, y entonces NO se afirma
  // que algo sea nuevo: la campana se queda en cero medio segundo en vez de
  // gritar y desdecirse.
  const noVisto = (it:any) => marca !== null && it.ms > marca;
  //
  // LAS ACTIVIDADES POR CONFIRMAR YA NO ENTRAN EN LA CAMPANA. Eran las únicas que
  // contaban SIEMPRE —nunca se marcaban vistas, porque esperan un clic—, y eso
  // hacía que el contador no pudiera llegar a cero nunca. Una campana que siempre
  // trae número se deja de leer en una semana.
  //
  // Y no es un aviso: es una lista de pendientes. Su sitio es Actividades, donde
  // vive la acción, y allí tiene su propio distintivo. La campana se queda solo
  // con HECHOS QUE OCURRIERON, que se apagan al verlos.
  const count = checadas.filter(noVisto).length + flotilla.filter(noVisto).length + accidentes.filter(noVisto).length + noConformes.filter(noVisto).length;
  // Listas de "Pendientes": en una apertura usamos el snapshot tomado al abrir;
  // si no hay (estado inicial), filtramos por visto.
  const pendC = snapshotPend ? snapshotPend.checadas : checadas.filter(noVisto);
  const pendF = snapshotPend ? snapshotPend.flotilla : flotilla.filter(noVisto);
  const pendA = snapshotPend ? snapshotPend.accidentes : accidentes.filter(noVisto);
  const pendN = snapshotPend ? snapshotPend.noConformes : noConformes.filter(noVisto);
  // El renglón de "esperan tu confirmación" NO cuenta en la campana, pero sí
  // cuenta para no pintar "sin avisos" habiendo algo en el panel.
  const hayAvisos = pendC.length + pendF.length + pendA.length + pendN.length;
  const hayAlgoQueEnsenar = hayAvisos + tareas.length;
  // Al abrir el panel: 1) guarda snapshot de lo pendiente AHORA para mostrarlo;
  // 2) mueve la marca a este instante —EN EL SERVIDOR—, así que abrirla en el
  // teléfono la apaga también en la computadora.
  const abrir = () => {
    const nuevo = !open;
    setOpen(nuevo);
    if (nuevo) {
      setSnapshotPend({ checadas: checadas.filter(noVisto), flotilla: flotilla.filter(noVisto), accidentes: accidentes.filter(noVisto), noConformes: noConformes.filter(noVisto) });
      marcarVistoAhora();
    }
  };

  const fila = (key:string, color:string, titulo:string, sub:string, modulo:AppPantalla) => (
    <div key={key}
      onClick={()=>{ setOpen(false); onIrModulo(modulo); }}
      onMouseEnter={(e)=>{(e.currentTarget as HTMLDivElement).style.background = `${color}0d`;}}
      onMouseLeave={(e)=>{(e.currentTarget as HTMLDivElement).style.background = "transparent";}}
      style={{background:"transparent", borderLeft:`3px solid ${color}`, borderRadius:6, padding:"7px 10px", cursor:"pointer", display:"flex", alignItems:"center", gap:9, transition:"background 0.15s ease"}}>
      <div style={{flex:1, minWidth:0}}>
        <div style={{fontSize:12.5, fontWeight:600, color:T_LIGHT.textInk, lineHeight:1.2, whiteSpace:"nowrap" as const, overflow:"hidden", textOverflow:"ellipsis"}}>{titulo}</div>
        <div style={{fontSize:10, color:T_LIGHT.textInkMut, marginTop:1}}>{sub}</div>
      </div>
    </div>
  );

  return (
    <div ref={containerRef} style={{position:"relative" as const, display:"inline-block"}}>
      {/* La CAMPANA: eventos, que se apagan al verlos. El escudo de al lado son
         pendientes, que no. Los rótulos los distinguen a propósito. */}
      <button onClick={abrir}
        aria-label={count>0 ? `Actividad de trabajadores: ${count} sin ver` : "Actividad de trabajadores · nada nuevo"}
        title={count>0 ? `Actividad de trabajadores: ${count} sin ver` : "Actividad de trabajadores · nada nuevo"}
        style={{background: open?"rgba(255,255,255,0.12)":"rgba(255,255,255,0.06)", border:"1px solid rgba(255,255,255,0.14)", borderRadius:8, padding:"6px 9px", cursor:"pointer", color:"white", display:"flex", alignItems:"center", justifyContent:"center", position:"relative" as const, transition:"background 0.15s ease"}}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <circle cx="9" cy="8" r="3.2" stroke="currentColor" strokeWidth="1.7"/>
          <path d="M3.5 19c0-3 2.5-5 5.5-5s5.5 2 5.5 5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/>
          <path d="M16 6.5a2.8 2.8 0 010 5.4M17.5 19c0-2.2-1-3.8-2.5-4.6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
        </svg>
        {count > 0 && (
          <span style={{position:"absolute" as const, top:-5, right:-5, background:TONE_COLORS.ok, color:"white", fontSize:9, fontWeight:700, lineHeight:1.2, padding:"1px 5px", borderRadius:10, minWidth:17, textAlign:"center" as const, border:`1.5px solid ${T.bgSide}`, boxShadow:"0 1px 4px rgba(5,150,105,0.5)"}}>{count>99?"99+":count}</span>
        )}
      </button>

      {open && createPortal(
        <div ref={panelRef} data-panel="actividad" style={{...estiloPanelSobreTodo(posPanel, isMobile), background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:12, boxShadow:"0 18px 50px rgba(11,24,41,0.28)", padding:12, animation:"axisDropIn 0.18s ease"}}
          onMouseDown={(e)=>e.stopPropagation()}>
          <div style={{display:"flex", alignItems:"center", gap:8, paddingBottom:10, marginBottom:10, borderBottom:`1px solid ${T_LIGHT.border}`}}>
            <span style={{fontFamily:fontSerif, fontSize:14, fontWeight:700, color:T_LIGHT.textInk}}>Actividad de trabajadores</span>
            {count>0 && <span style={{marginLeft:"auto", fontSize:10, fontWeight:700, color:TONE_COLORS.ok, background:"rgba(5,150,105,0.10)", border:"1px solid rgba(5,150,105,0.25)", padding:"2px 7px", borderRadius:8}}>{count}</span>}
          </div>

          {/* Pestañas: Pendientes / Historial */}
          <div style={{display:"flex", gap:6, marginBottom:10}}>
            {([["avisos","Pendientes"],["historial","Historial"]] as const).map(([k,label])=>(
              <button key={k} onClick={()=>setTab(k)}
                style={{flex:1, fontSize:11, fontWeight:700, padding:"5px 8px", borderRadius:8, cursor:"pointer", fontFamily:"inherit",
                  border:`1px solid ${tab===k?"rgba(35,100,120,0.45)":T_LIGHT.border}`, background:tab===k?"rgba(35,100,120,0.10)":"transparent", color:tab===k?"#236478":T_LIGHT.textInkSoft}}>
                {label}
              </button>
            ))}
          </div>

          {tab === "avisos" && (hayAlgoQueEnsenar === 0 ? (
            <div style={{padding:"18px 8px 10px", textAlign:"center" as const, fontSize:12, color:T_LIGHT.textInkSoft}}>{total === 0 ? "Aún no hay actividad de trabajadores." : "No tienes avisos pendientes. Revisa el Historial."}</div>
          ) : (
            <div style={{display:"flex", flexDirection:"column" as const, gap:12}}>
              {pendA.length > 0 && (
                <div>
                  <div style={{fontSize:11, fontWeight:700, color:TONE_COLORS.alerta, textTransform:"uppercase" as const, letterSpacing:"0.5px", marginBottom:5, display:"flex", alignItems:"center", gap:5}}>
                    <span style={{color:TONE_COLORS.alerta, display:"inline-flex"}}>{ICON_ALR}</span> Accidentes registrados
                  </div>
                  <div style={{display:"flex", flexDirection:"column" as const, gap:4}}>
                    {pendA.map((a:any)=>fila(a.id, TONE_COLORS.alerta, `${a.nombre} · Accidente`, `${a.resumen||"Ver detalle"}${a.cuando?` · ${a.cuando}`:""}`, "flotilla"))}
                  </div>
                </div>
              )}
              {pendN.length > 0 && (
                <div>
                  <div style={{fontSize:11, fontWeight:700, color:"#8a6d1a", textTransform:"uppercase" as const, letterSpacing:"0.5px", marginBottom:5}}>No conformidades con correcciones</div>
                  <div style={{display:"flex", flexDirection:"column" as const, gap:4}}>
                    {pendN.map((n:any)=>fila(n.id, "#8a6d1a", `${n.nombre} no está conforme`, `${n.texto}${n.cuando?` · ${n.cuando}`:""}`, "empleados"))}
                  </div>
                </div>
              )}
              {/* Las actividades por confirmar salieron de aquí: son una lista de
                 pendientes, no avisos, y su sitio es Actividades. Se deja UN
                 renglón que lleva allá cuando las hay, sin contarlas en la
                 campana: la campana tiene que poder llegar a cero. */}
              {tareas.length > 0 && (
                <div
                  onClick={()=>{ setOpen(false); onIrModulo("tareas"); }}
                  role="button" tabIndex={0} title="Ir a Actividades"
                  onKeyDown={(ev:any)=>{ if(ev.key==="Enter"||ev.key===" "){ ev.preventDefault(); setOpen(false); onIrModulo("tareas"); } }}
                  style={{display:"flex", alignItems:"center", gap:8, cursor:"pointer", padding:"9px 10px",
                    borderRadius:8, border:`1px solid ${T_LIGHT.borderCard}`, background:T_LIGHT.canvasSoft}}>
                  <span aria-hidden style={{width:7, height:7, borderRadius:"50%", background:"#B8932A", flexShrink:0}}/>
                  <span style={{fontSize:12, color:T_LIGHT.textInkSoft, lineHeight:1.4}}>
                    <strong style={{color:T_LIGHT.textInk}}>{tareas.length} actividad{tareas.length===1?"":"es"}</strong>
                    {" "}espera{tareas.length===1?"":"n"} tu confirmación · <span style={{color:T_LIGHT.gold, fontWeight:700}}>ver en Actividades ›</span>
                  </span>
                </div>
              )}
              {pendC.length > 0 && (
                <div>
                  <div style={{fontSize:11, fontWeight:700, color:T_LIGHT.textInkSoft, textTransform:"uppercase" as const, letterSpacing:"0.5px", marginBottom:5}}>Checadas recientes</div>
                  <div style={{display:"flex", flexDirection:"column" as const, gap:4}}>
                    {pendC.map((c:any)=>fila(c.id, (c.esLlegada ?? esLlegadaChecada(c.tipo))?TONE_COLORS.ok:T_LIGHT.gold, `${c.nombre} · ${c.label||labelChecada(c.tipo)}`, c.cuando, "empleados"))}
                  </div>
                </div>
              )}
              {pendF.length > 0 && (
                <div>
                  <div style={{fontSize:11, fontWeight:700, color:T_LIGHT.textInkSoft, textTransform:"uppercase" as const, letterSpacing:"0.5px", marginBottom:5}}>Flotilla reciente</div>
                  <div style={{display:"flex", flexDirection:"column" as const, gap:4}}>
                    {pendF.map((f:any)=>fila(f.id, "#236478", `${f.nombre} registró ${f.tipo==="regreso"?"regreso":"salida"} de ${f.placa}`, f.cuando, "flotilla"))}
                  </div>
                </div>
              )}
            </div>
          ))}

          {tab === "historial" && (
            historial.length === 0 ? (
              <div style={{padding:"18px 8px 10px", textAlign:"center" as const, fontSize:12, color:T_LIGHT.textInkSoft}}>Aún no hay eventos en el historial.</div>
            ) : (
              <div style={{display:"flex", flexDirection:"column" as const, gap:4}}>
                {historial.map((h:any)=>(
                  <div key={h.id} style={{borderLeft:`3px solid ${T_LIGHT.border}`, borderRadius:6, padding:"7px 10px"}}>
                    <div style={{fontSize:12.5, fontWeight:600, color:T_LIGHT.textInk, lineHeight:1.25}}>
                      <span style={{color:"#236478"}}>{h.tipo}</span> · {h.nombre}
                    </div>
                    <div style={{fontSize:10.5, color:T_LIGHT.textInkSoft, marginTop:1}}>{h.desc}</div>
                    <div style={{fontSize:10, color:T_LIGHT.textInkMut, marginTop:1}}>{h.cuando}</div>
                  </div>
                ))}
              </div>
            )
          )}
          <style>{`@keyframes axisDropIn { from { opacity:0; transform: translateY(-4px); } to { opacity:1; transform: translateY(0); } }`}</style>
        </div>,
        document.body)}
    </div>
  );
}

function NotificationBell({items, accidentes, kpis, currentUser, isMobile, fontSerif, onIrModulo, onIrItem}: {
  items: ItemAtencion[];
  // Accidentes que REQUIEREN ATENCIÓN —con personas lesionadas o sin confirmar—.
  // Van aparte de `items` porque no son plazos: ver `accidentesPendientes` en
  // `useDashboardData`, donde está la razón entera.
  accidentes?: any[];
  kpis: DashboardKpis;
  currentUser: any; isMobile: boolean; fontSerif: string;
  onIrModulo: (m: AppPantalla) => void;
  // Destino CONCRETO del renglón. Si no viene, cae al módulo como antes.
  onIrItem?: (it: ItemAtencion) => void;
}) {
  const [open, setOpen] = useState(false);
  const [expandido, setExpandido] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  // El panel va en <body> (ver usePosicionPanel): "fuera" también es fuera de él.
  const panelRef = useRef<HTMLDivElement>(null);
  const posPanel = usePosicionPanel(containerRef, open);
  const INITIAL = 5;

  // La tarjeta "Requieren tu atención" del tablero abre ESTA lista en vez de
  // construir una propia: el desglose ya vive aquí, con su módulo por renglón.
  // Mismo idioma de evento global que usa AXIOR ("axior:abrir"), no un mecanismo
  // nuevo: la campana está en el top bar y el tablero en el cuerpo, así que no
  // comparten árbol de componentes.
  useEffect(() => {
    const abrir = () => setOpen(true);
    window.addEventListener("avisos:abrir", abrir as any);
    return () => window.removeEventListener("avisos:abrir", abrir as any);
  }, []);

  // Click fuera del componente → cerrar dropdown
  useEffect(() => {
    if (!open) return;
    const handler = (e: MouseEvent | TouchEvent) => {
      if (containerRef.current && !containerRef.current.contains(e.target as Node) && !(panelRef.current && panelRef.current.contains(e.target as Node))) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    document.addEventListener("touchstart", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
      document.removeEventListener("touchstart", handler);
    };
  }, [open]);

  // Reset expandido cuando se cierra
  useEffect(() => { if (!open) setExpandido(false); }, [open]);

  const pendAcc = accidentes || [];
  // LA MISMA SUMA QUE LA TARJETA DE INICIO, hecha en un solo sitio: mientras esto
  // tenga algo, ninguna pantalla puede decir "Todo al día". Ver `resumenDeAtencion`.
  const atencion = resumenDeAtencion(items, pendAcc);
  // Los renglones también salen de ahí: así el texto y la fecha de un pendiente se
  // escriben una vez y no pueden decir cosas distintas en la tarjeta y en el escudo.
  const filasAcc = atencion.filas.filter((f) => f.esAccidente);
  const filasPlazo = atencion.filas.filter((f) => !f.esAccidente);
  const visibles = expandido ? filasPlazo : filasPlazo.slice(0, INITIAL);
  // Los accidentes cuentan: el número de la pastilla es TODO lo que requiere
  // atención, no solo los plazos.
  const count = atencion.total;

  // Badge corto de días. Mismo tono que la lista de Inicio, decidido en el mismo
  // sitio: rojo solo para lo ya vencido.
  const badgeDias = (it: ItemAtencion) => {
    const tono = tonoDePlazo(it);
    const color = tono.color, bg = tono.bgSuave, borde = tono.borde;
    const texto = it.severidad === "vencido"
      ? (it.dias === 0 ? "hoy" : `hace ${Math.abs(it.dias)}d`)
      : (it.dias === 0 ? "hoy" : `en ${it.dias}d`);
    return (
      <span style={{
        fontSize: 10, fontWeight:700, color,
        background: bg, border: `1px solid ${borde}`,
        padding: "2px 7px", borderRadius:6,
        whiteSpace:"nowrap" as const, flexShrink:0,
      }}>{texto}</span>
    );
  };

  // ESTO NO ES UNA CAMPANA, Y NO DEBE PARECERLO.
  //
  // Al lado vive `ActividadBell`, que sí lo es: cuenta EVENTOS —una checada, un
  // movimiento, un accidente—, hechos que ocurrieron y que se extinguen al
  // verlos, y por eso su contador llega a cero.
  //
  // Esto otro es una lista de PENDIENTES VIGENTES: un seguro vencido, un contrato
  // por vencer, una cuota atrasada. Existen hasta que alguien los resuelve, y
  // mirarlos no los apaga. Por diseño este número NO llega a cero solo.
  //
  // Dos iconos de campana idénticos, uno al lado del otro, para dos cosas que se
  // comportan al revés, es la razón de que no se distinga cuál avisa de algo
  // nuevo. Aquí va un ESCUDO —lo que protege, lo que hay que atender— y el número
  // se lee como ESTADO, no como globo de "sin leer": una pastilla ancha, no un
  // círculo rojo pegado a la esquina.
  //
  // Y POR ESO `notificacionesVistasAt` NO SE CONECTA AQUÍ: un pendiente no se
  // apaga por mirarlo. Si algún día alguien lo intenta, el número diría cero con
  // la póliza igual de vencida, que es exactamente la mentira que se evita.
  //
  // Los VENCIDOS mandan sobre los por vencer: si hay uno solo vencido, la pastilla
  // va en rojo; si todo lo pendiente está aún vigente, en el ámbar del plazo.
  const nVencidos = atencion.nVencidos;
  // LOS ACCIDENTES CUENTAN EN EL NÚMERO, PERO NO CAMBIAN EL COLOR (4-oct): no se
  // clasifica su gravedad. La pastilla la deciden los plazos, como siempre.
  const tonoEstado = nVencidos > 0 ? TONE_COLORS.alerta : TONE_COLORS.warn;
  const rotuloAcc = pendAcc.length > 0 ? ` · ${pendAcc.length} accidente${pendAcc.length!==1?"s":""} por atender` : "";
  const rotulo = count === 0
    ? "Pendientes · nada por atender"
    : `Pendientes: ${count}${rotuloAcc}${nVencidos > 0 ? ` · ${nVencidos} vencido${nVencidos!==1?"s":""}` : " · ninguno vencido"}`;

  return (
    <div ref={containerRef} style={{position:"relative" as const, display:"inline-block"}}>
      {/* Botón de PENDIENTES (escudo). La campana de al lado es otra cosa. */}
      <button
        onClick={() => setOpen(v => !v)}
        aria-label={rotulo}
        title={rotulo}
        style={{
          background: open ? "rgba(255,255,255,0.12)" : "rgba(255,255,255,0.06)",
          border:"1px solid rgba(255,255,255,0.14)",
          borderRadius: 8,
          padding: "6px 9px",
          cursor: "pointer",
          color: "white",
          display:"flex", alignItems:"center", gap:6, justifyContent:"center",
          position: "relative" as const,
          transition: "background 0.15s ease",
        }}>
        {/* Escudo, no campana */}
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <path d="M12 3l7.5 3v5.6c0 4.6-3.2 7.9-7.5 9.1-4.3-1.2-7.5-4.5-7.5-9.1V6L12 3z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round"/>
          <path d="M12 9.2v3.6M12 15.6h.01" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
        </svg>
        {count > 0 && (
          // PASTILLA DE ESTADO, no globo de no leído: va EN LÍNEA junto al icono
          // —no flotando en la esquina— y sin el borde que la recorta del fondo.
          // Un globo en la esquina dice "algo nuevo llegó"; esto dice "esto es lo
          // que tienes pendiente", que es lo que de verdad significa.
          <span style={{
            background: tonoEstado, color: "white",
            fontSize: 10.5, fontWeight: 800, lineHeight: 1.2,
            padding: "2px 7px", borderRadius: 6,
            minWidth: 18, textAlign: "center" as const,
          }}>{count > 99 ? "99+" : count}</span>
        )}
      </button>

      {/* Dropdown */}
      {open && createPortal(
        <div ref={panelRef} data-panel="atencion" style={{
          ...estiloPanelSobreTodo(posPanel, isMobile),
          background: T_LIGHT.cardLight,
          border: `1px solid ${T_LIGHT.borderCard}`,
          borderRadius: 12,
          boxShadow: "0 18px 50px rgba(11,24,41,0.28)",
          padding: 12,
          animation: "axisDropIn 0.18s ease",
        }}
        onMouseDown={(e) => e.stopPropagation()}>
          {/* AQUÍ IBA LA TIRA DE AXIOR, Y SE RETIRÓ. No se borró: sigue en el
             archivo, en `DashboardAxiorStrip` y `_resumenAxior`, donde está
             escrita la razón entera. En corto: repetía el primer renglón de la
             lista que tiene justo debajo y el número que la tarjeta ya enseña al
             lado, con un botón que además navegaba peor. Un copiloto que repite
             lo que ya se ve deja de leerse.
             El prop `kpis` SE QUEDA en la firma aunque hoy no lo use nadie aquí:
             es lo único que la tira necesitaba y quitarlo obligaría a volver a
             enhebrarlo por tres componentes el día que vuelva.
             El chat del búho no se toca: AXIOR sigue viviendo ahí. */}

          {/* Header del panel */}
          <div style={{
            display:"flex", alignItems:"center", gap:8,
            paddingBottom: 10, marginBottom: 10,
            borderBottom: `1px solid ${T_LIGHT.border}`,
          }}>
            <span style={{color: TONE_COLORS.alerta, display:"inline-flex", alignItems:"center"}}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                <path d="M12 3L22 20H2L12 3z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round"/>
                <path d="M12 10v4M12 17h.01" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round"/>
              </svg>
            </span>
            <span style={{
              fontFamily: fontSerif, fontSize: 14, fontWeight: 700,
              color: T_LIGHT.textInk,
            }}>Requieren tu atención</span>
            {count > 0 && (
              <span style={{
                marginLeft: "auto",
                fontSize: 10, fontWeight: 700, color: TONE_COLORS.alerta,
                background: "rgba(220,38,38,0.10)", border: "1px solid rgba(220,38,38,0.25)",
                padding: "2px 7px", borderRadius: 8,
              }}>{count}</span>
            )}
          </div>

          {/* Estado vacío o lista */}
          {count === 0 ? (
            <div style={{padding: "20px 8px 12px", textAlign: "center" as const}}>
              <div style={{
                width:40, height:40, borderRadius:"50%",
                background:"rgba(5,150,105,0.10)", color: TONE_COLORS.ok,
                display:"flex", alignItems:"center", justifyContent:"center",
                margin:"0 auto 8px",
              }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M5 12l4 4 10-10" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div style={{fontFamily: fontSerif, fontSize: 14, fontWeight: 700, color: T_LIGHT.textInk, marginBottom: 2}}>
                Todo al día
              </div>
              <div style={{fontSize: 11, color: T_LIGHT.textInkSoft}}>
                Sin vencimientos pendientes.
              </div>
            </div>
          ) : (
            <>
              <div style={{display:"flex", flexDirection:"column" as const, gap:4}}>
                {/* LOS ACCIDENTES PENDIENTES, PRIMERO Y SIEMPRE A LA VISTA. No entran en el
                    recorte de "ver todas": un accidente con lesionados no puede quedar
                    escondido detrás de un botón por un seguro que vence en tres
                    semanas. Y el renglón se lee como algo que hacer —ver
                    `renglonPendienteDeAccidente`—, sin insignia de días: no es un plazo.
                    Encima, el contador; y todos del mismo color —el de accidente de
                    la Actividad—, en orden cronológico. */}
                {!!atencion.conteoAccidentes && (
                  <div style={{fontSize:11, fontWeight:700, color:UI.rojoVivo, padding:"0 2px 2px"}}>{atencion.conteoAccidentes}</div>
                )}
                {filasAcc.map((r) => {
                  const a:any = r.accidente;
                  const tA = {c: UI.rojoVivo, rgb: "220,38,38"};
                  return (
                    <div key={r.clave}
                      onClick={() => { setOpen(false); if (onIrItem) onIrItem({modulo:"flotilla", refId:a.id, refTipo:"accidente"} as any); else onIrModulo("flotilla"); }}
                      title="Abrir este accidente"
                      style={{
                        background: `rgba(${tA.rgb},0.05)`,
                        borderLeft: `3px solid ${tA.c}`,
                        borderRadius: 6, padding: "7px 10px", cursor: "pointer",
                        display: "flex", alignItems: "center", gap: 9,
                      }}>
                      <div style={{
                        display:"inline-flex", alignItems:"center", justifyContent:"center",
                        width:24, height:24, borderRadius:6,
                        background: `rgba(${tA.rgb},0.10)`, color: tA.c, flexShrink: 0,
                      }}>
                        <SidebarIcon name="flotilla"/>
                      </div>
                      <div style={{flex:1, minWidth:0}}>
                        <div style={{display:"flex", alignItems:"center", gap:6, minWidth:0}}>
                          <div style={{
                            fontSize: 12.5, fontWeight: 700, color: T_LIGHT.textInk, lineHeight: 1.2,
                            whiteSpace:"nowrap" as const, overflow:"hidden", textOverflow:"ellipsis", minWidth:0,
                          }}>{r.titulo}</div>
                          <EtiquetaLesionadosChip accidente={a} tema="claro"/>
                        </div>
                        {/* CUÁNDO OCURRIÓ, junto a quién y qué unidad. Salían dos
                            renglones idénticos —mismo trabajador, misma placa— sin
                            forma de saber cuál era cuál. Formato de `cuandoTexto`,
                            el mismo de la campana de actividad. */}
                        <div style={{fontSize: 10, color: T_LIGHT.textInkMut, marginTop: 1}}>
                          {r.detalle}{r.cuando ? " · " + r.cuando : ""}
                        </div>
                      </div>
                    </div>
                  );
                })}
                {visibles.map(fa => {
                  const it = fa.item as ItemAtencion;
                  const tono = tonoDePlazo(it);
                  const tintColor = tono.color;
                  const tintBg    = tono.bgTinte;
                  return (
                    <div key={fa.clave}
                      onClick={() => { setOpen(false); if (onIrItem) onIrItem(it); else onIrModulo(it.modulo); }}
                      title="Abrir este asunto"
                      onMouseEnter={(e)=>{(e.currentTarget as HTMLDivElement).style.background = `${tintColor}0d`;}}
                      onMouseLeave={(e)=>{(e.currentTarget as HTMLDivElement).style.background = "transparent";}}
                      style={{
                        background: "transparent",
                        borderLeft: `3px solid ${tintColor}`,
                        borderRadius: 6,
                        padding: "7px 10px",
                        cursor: "pointer",
                        display: "flex", alignItems: "center", gap: 9,
                        transition: "background 0.15s ease",
                      }}>
                      <div style={{
                        display:"inline-flex", alignItems:"center", justifyContent:"center",
                        width:24, height:24, borderRadius:6,
                        background: tintBg, color: tintColor, flexShrink: 0,
                      }}>
                        <SidebarIcon name={it.moduloIconName}/>
                      </div>
                      <div style={{flex:1, minWidth:0}}>
                        <div style={{
                          fontSize: 12.5, fontWeight: 600, color: T_LIGHT.textInk, lineHeight: 1.2,
                          whiteSpace:"nowrap" as const, overflow:"hidden", textOverflow:"ellipsis",
                        }}>{it.titulo}</div>
                        {/* El módulo y LA FECHA del plazo: "vence en 3 días" no dice
                            qué día, y dos documentos de la misma unidad salían
                            iguales. Sin hora: un papel vence un día, no a una hora. */}
                        <div style={{fontSize: 10, color: T_LIGHT.textInkMut, marginTop: 1}}>
                          {it.moduloLabel}{fa.cuando ? " · " + fa.cuando : ""}
                        </div>
                      </div>
                      {badgeDias(it)}
                    </div>
                  );
                })}
              </div>

              {/* Ver todas / Ver menos */}
              {filasPlazo.length > INITIAL && (
                <button
                  onClick={() => setExpandido(v => !v)}
                  style={{
                    marginTop: 10, width: "100%",
                    background: "transparent",
                    border: `1px dashed ${T_LIGHT.border}`,
                    borderRadius: 8, padding: "7px 10px",
                    cursor: "pointer",
                    fontSize: 11.5, fontWeight: 700, color: T_LIGHT.gold,
                    fontFamily: "inherit",
                    display: "flex", alignItems: "center", justifyContent: "center", gap: 6,
                  }}>
                  {expandido ? "Ver menos ▴" : `Ver todas (${filasPlazo.length}) ▾`}
                </button>
              )}
            </>
          )}

          <style>{`@keyframes axisDropIn { from { opacity:0; transform: translateY(-4px); } to { opacity:1; transform: translateY(0); } }`}</style>
        </div>,
        document.body)}
    </div>
  );
}

function AppShell({
  appPantalla, navKey, setAppPantalla, onIrItem, currentUser, isProUser, isMobile, fontSans, fontSerif, onLogout, onLogin, children,
}: {
  appPantalla: AppPantalla;
  navKey?: string;                              // cambia en cada navegación → remonta el módulo
  setAppPantalla: (p: AppPantalla) => void;     // App inyecta aquí `irAModulo` (resetea el destino)
  onIrItem?: (it: ItemAtencion) => void;        // App inyecta `irAItemAtencion` (abre el elemento)
  currentUser: any;
  isProUser: boolean;
  isMobile: boolean;
  fontSans: string;
  fontSerif: string;
  onLogout: () => void;
  onLogin: () => void;
  children: React.ReactNode;
}) {
  // Paso 2B: en móvil el sidebar se colapsa en un drawer que abre con hamburguesa.
  const [drawerOpen, setDrawerOpen] = useState(false);
  // Cerrar drawer cuando cambia la pantalla (navegación dentro del drawer).
  useEffect(() => { setDrawerOpen(false); }, [appPantalla]);

  const isUserAdmin = esAdmin(currentUser?.email);

  // ── Mi perfil del patrón (foto + puesto + empresa) sobre usuarios/{uid} ───────
  // Vive en el footer del sidebar: al tocar el nombre se abre un modal navy. El
  // patrón es dueño de su doc → sin cambio de reglas. La foto pinta el avatar del
  // sidebar y se propaga por el evento "perfil:foto" (p.ej. cambiada desde el móvil).
  const esRealPatron = !!(currentUser && !currentUser.isAnonymous && currentUser.uid);
  const [avatarFoto, setAvatarFoto] = useState<string>("");
  const [perfilOpen, setPerfilOpen] = useState(false);
  const [pfPuesto, setPfPuesto] = useState("");
  const [pfPuestoEdit, setPfPuestoEdit] = useState(false);
  const [pfPuestoInput, setPfPuestoInput] = useState("");
  const [pfPuestoSaving, setPfPuestoSaving] = useState(false);
  const [pfEmpresa, setPfEmpresa] = useState("");
  const [pfEmpresaEdit, setPfEmpresaEdit] = useState(false);
  const [pfEmpresaInput, setPfEmpresaInput] = useState("");
  const [pfEmpresaSaving, setPfEmpresaSaving] = useState(false);
  // WhatsApp de contacto del patrón (sus trabajadores lo usan desde Flotilla).
  const [pfWa, setPfWa] = useState("");
  const [pfWaEdit, setPfWaEdit] = useState(false);
  const [pfWaInput, setPfWaInput] = useState("");
  const [pfWaSaving, setPfWaSaving] = useState(false);
  const [pfDiasAg, setPfDiasAg] = useState(15);   // para el contexto de AXIOR
  useEffect(() => {
    if (!esRealPatron) { setAvatarFoto(""); return; }
    let cancel = false;
    (async () => {
      try {
        const snap = await getDoc(doc(db,"usuarios",currentUser.uid));
        if (cancel || !snap.exists()) return;
        const d:any = snap.data() || {};
        setAvatarFoto(d.fotoPerfilUrl || "");
        setPfPuesto((d.puesto || "").trim());
        setPfWa((d.whatsapp || "").trim());
        const nAg = Number(d.diasAguinaldo); if (Number.isFinite(nAg) && nAg > 0) setPfDiasAg(nAg);
      } catch(e){ /* silencioso: el avatar cae a la inicial */ }
    })();
    // LA DENOMINACIÓN YA NO SE LEE DE AQUÍ. Vivía en `usuarios/{uid}.empresa`
    // —un nombre corto de texto libre, con cuatro nombres de campo posibles— y
    // ahora es un dato de la empresa, en configuracion_empresa, que es lo que
    // imprimen los documentos firmados. El perfil la MUESTRA; se edita en su
    // pantalla. Dos editores del mismo campo es lo que acabamos de cerrar.
    (async () => {
      try { const cfg = await leerConfigEmpresa(currentUser.uid); if (!cancel) setPfEmpresa(datosPatronDe(cfg).denominacion); }
      catch(e){ /* silencioso: queda vacía y la pantalla de datos lo dice */ }
    })();
    const onFoto = (e:any)=>{ try { setAvatarFoto(e?.detail || ""); } catch(_){} };
    window.addEventListener("perfil:foto", onFoto as any);
    return ()=>{ cancel = true; window.removeEventListener("perfil:foto", onFoto as any); };
  }, [esRealPatron, currentUser?.uid]);

  const guardarPerfilFoto = async (url:string) => {
    setAvatarFoto(url);
    if (!esRealPatron) return;
    try { await updateDoc(doc(db,"usuarios",currentUser.uid), { fotoPerfilUrl: url }); }
    catch(e){ console.error("usuarios foto write (AppShell):", e); alert("La foto se subió pero no se pudo guardar. Intenta de nuevo."); }
  };
  const guardarPerfilPuesto = async () => {
    if (!esRealPatron) return;
    const val = pfPuestoInput.trim(); setPfPuestoSaving(true);
    try { await updateDoc(doc(db,"usuarios",currentUser.uid), { puesto: val }); setPfPuesto(val); setPfPuestoEdit(false); }
    catch(e){ console.error("usuarios puesto write (AppShell):", e); alert("No se pudo guardar el puesto. Intenta de nuevo."); }
    finally { setPfPuestoSaving(false); }
  };
  // AQUÍ YA NO SE ESCRIBE LA EMPRESA. El perfil la enseña; se edita en "Datos de
  // mi empresa", junto con el RFC, el domicilio y el correo de contacto, que son
  // los que se imprimen con ella en los documentos firmados. Un segundo editor
  // que solo tocara el nombre volvería a dejar dos copias del mismo hecho.
  // Guarda el WhatsApp y lo propaga a las cuentas de sus trabajadores.
  const guardarPerfilWa = async () => {
    if (!esRealPatron) return;
    const val = pfWaInput.replace(/\D/g, ""); setPfWaSaving(true);
    try { await guardarWhatsappPatron(currentUser.uid, val); setPfWa(val); setPfWaEdit(false); }
    catch(e){ console.error("whatsapp write (AppShell):", e); alert("No se pudo guardar el WhatsApp. Intenta de nuevo."); }
    finally { setPfWaSaving(false); }
  };

  // ── Datos para la campana de notificaciones (top bar global) ─────────
  // useDashboardData ya filtra por userId y se inactiva si no hay sesión real.
  // Vive aquí (en AppShell) para que la campana esté disponible en TODAS las
  // pantallas internas, no sólo en SuiteHome.
  const {atencionUrgente, accidentesPendientes, kpis, actividad, empleados, tareasPatron, checadasEfectivas, cumplimientoTareas, horarioGeneral, historialGeneral, registrosVacaciones, vehiculos} = useDashboardData(currentUser);
  const mostrarCampana = !!(currentUser && !currentUser.isAnonymous);

  // Publica para AXIOR el resumen de la cuenta con los datos YA cargados aquí
  // (no dispara consultas nuevas). Multi-tenant: se etiqueta con el uid del patrón.
  // Va DESPUÉS del useDashboardData para no leer sus variables en TDZ.
  useEffect(() => {
    if (!esRealPatron || !currentUser?.uid) { publicarContextoAxior("", ""); return; }
    try {
      publicarContextoAxior(currentUser.uid, construirContextoAxior({
        empresa: pfEmpresa, empleados: empleados||[], kpis, atencionUrgente: atencionUrgente||[],
        actividad, tareasPatron: tareasPatron||[], checadasPatron: checadasEfectivas||[],
        cumplimientoTareas, diasAg: pfDiasAg, hoy: new Date(), horarioGeneral, historialGeneral, registrosVacaciones,
      }));
    } catch(e){ console.error("contexto AXIOR:", e); }
  }, [esRealPatron, currentUser?.uid, empleados, kpis, atencionUrgente, actividad, tareasPatron, checadasEfectivas, cumplimientoTareas, pfDiasAg, pfEmpresa, horarioGeneral, historialGeneral, registrosVacaciones]);

  // ── LA PUERTA DE LOS AVISOS: AQUÍ SE LEE, NO SE POSEE ──────────────────────
  // El dueño es `ProveedorPuertaAvisos`, que envuelve a los DOS árboles del patrón
  // —este armazón y el portal móvil—. Estaba aquí dentro, y por eso el bloque no
  // aparecía en el teléfono: el portal móvil no es hijo de este componente.
  //
  // La fila del perfil, más abajo, lee de aquí. Si alguien activa los avisos desde
  // el teléfono, esta fila lo refleja sin recargar porque es el mismo estado.
  const avisosCtx = useContext(CtxPuertaAvisos);
  const estadoAvisos = avisosCtx ? avisosCtx.estado : "no_soportado";
  const activarAvisos = avisosCtx ? avisosCtx.activar : () => {};

  // AQUÍ IBA EL AVISO POR CADA HECHO, Y SE APAGÓ. No se borró: vive entero en
  // `useAvisoPorCadaHecho`, arriba, sin llamar, con las tres razones escritas.
  // En corto: avisaba de lo que el patrón ya estaba mirando, una notificación por
  // persona y por hecho, y de lo esperado en vez de lo excepcional.
  // Los mismos hechos siguen viéndose donde deben: la campana y el registro de
  // actividad, que no se tocan.

  // Navegación cross-módulos desde la campana — usa el mismo setAppPantalla.
  const onIrModuloDesdeCampana = (m: AppPantalla) => setAppPantalla(m);

  const navItems: Array<{id: AppPantalla; label: string; icon: string; restringido?: boolean}> = [
    {id:"suite",       label:"Inicio",          icon:"home"},
    // Va arriba y sin grupo porque no es un módulo: es quién eres tú, y sin ello
    // no se puede emitir ni un solo documento firmado.
    {id:"datos_empresa", label:"Datos de mi empresa", icon:"documentos"},
    // EQUIPO
    {id:"empleados",   label:"Empleados",       icon:"empleados",   restringido: !isProUser},
    {id:"tareas",      label:"Actividades",          icon:"tareas",      restringido: !isProUser},
    {id:"recibos",     label:"Nómina",          icon:"recibos",     restringido: !isProUser},
    // CUMPLIMIENTO / LEGAL
    {id:"documentos",  label:"Documentos",      icon:"documentos",  restringido: !isProUser},
    {id:"regulamx",    label:"Diagnóstico",     icon:"regulamx"},
    {id:"contratos",   label:"Generador legal", icon:"contratos",   restringido: !isProUser},
    {id:"nomina",      label:"Calculadora LFT", icon:"nomina"},
    {id:"obligaciones",label:"Obligaciones",    icon:"obligaciones",restringido: !isProUser},
    {id:"calendario",  label:"Calendario",      icon:"calendario",  restringido: !isProUser},
    // OPERACIÓN
    {id:"flotilla",    label:"Flotilla",        icon:"flotilla",    restringido: !isProUser},
    {id:"proveedores", label:"Proveedores",     icon:"proveedores", restringido: !isProUser},
    {id:"clientes",    label:"Clientes / Pacientes", icon:"clientes",    restringido: !isProUser},
    {id:"creditos",    label:"Créditos",        icon:"creditos",    restringido: !isProUser},
    // (cierre, sin grupo)
    {id:"ayuda",       label:"Ayuda",           icon:"ayuda"},
  ];
  // Título de grupo que se muestra ANTES del primer ítem de cada grupo.
  const GRUPO_ANTES: Record<string,string> = { empleados:"Equipo", documentos:"Cumplimiento / Legal", flotilla:"Operación" };

  const SIDEBAR_W = 232;
  const TOP_W = 50;
  const inicial = (currentUser?.email?.[0] || currentUser?.displayName?.[0] || "I").toUpperCase();
  const nombreUsuario = currentUser?.isAnonymous
    ? "Invitado"
    : (currentUser?.displayName || currentUser?.email?.split("@")[0] || "Usuario");

  // Contenido del sidebar reutilizado por desktop (fijo) y móvil (drawer).
  const sidebarBody = (
    <>
      {/* Logo + marca */}
      <button onClick={() => setAppPantalla("suite")} style={{
        background:"transparent", border:"none", cursor:"pointer",
        padding:"22px 18px 18px", display:"flex", alignItems:"center", gap:12,
        borderBottom:"1px solid rgba(184,147,42,0.14)", textAlign:"left" as const,
      }}>
        <div style={{width:38, height:38, background:"linear-gradient(135deg,#B8932A,#D4A843)", borderRadius:10,
          display:"flex", alignItems:"center", justifyContent:"center",
          boxShadow:"0 4px 14px rgba(184,147,42,0.40)", flexShrink:0}}>
          <span style={{fontFamily:fontSerif, fontSize:15, fontWeight:900, color:"#0B1829"}}>AX</span>
        </div>
        <div style={{minWidth:0}}>
          <div style={{fontFamily:fontSerif, fontSize:14, fontWeight:700, color:"white", letterSpacing:"0.2px", lineHeight:1.1}}>AXIS Legaltech</div>
          <div style={{fontSize:9, color:"rgba(184,147,42,0.72)", textTransform:"uppercase" as const, letterSpacing:"1.4px", marginTop:3}}>Gestión Empresarial</div>
        </div>
      </button>

      {/* Items de navegación */}
      <nav style={{flex:1, padding:"14px 10px", display:"flex", flexDirection:"column", gap:2, overflowY:"auto" as const}}>
        {navItems.map((it) => {
          const activo = appPantalla === it.id;
          const accent = SIDEBAR_ACCENT[it.id] || T.gold;
          const disabled = !!it.restringido;
          const tituloGrupo = GRUPO_ANTES[it.id];
          return (
            <React.Fragment key={it.id}>
              {tituloGrupo && (
                <div style={{fontSize:9, fontWeight:700, letterSpacing:"1.5px", textTransform:"uppercase" as const, color:"rgba(184,147,42,0.62)", padding:"12px 12px 4px"}}>{tituloGrupo}</div>
              )}
            <button
              onClick={() => { if (!disabled) setAppPantalla(it.id); }}
              disabled={disabled}
              title={disabled ? "Disponible en plan PRO" : undefined}
              style={{
                background: activo ? `${accent}24` : "transparent",
                border: "none",
                borderLeft: activo ? `3px solid ${accent}` : "3px solid transparent",
                color: activo ? "#FFFFFF" : (disabled ? "rgba(255,255,255,0.28)" : "rgba(255,255,255,0.72)"),
                textAlign:"left" as const,
                padding:"10px 12px",
                borderRadius: 8,
                cursor: disabled ? "not-allowed" : "pointer",
                display:"flex", alignItems:"center", gap:12,
                fontSize:13, fontWeight: activo ? 600 : 500,
                fontFamily: fontSans,
                transition:"background 0.15s, color 0.15s",
              }}
              onMouseEnter={(e) => { if (!activo && !disabled) (e.currentTarget as HTMLButtonElement).style.background = "rgba(255,255,255,0.04)"; }}
              onMouseLeave={(e) => { if (!activo && !disabled) (e.currentTarget as HTMLButtonElement).style.background = "transparent"; }}>
              <span style={{display:"flex", alignItems:"center", justifyContent:"center", width:22, color: activo ? accent : "currentColor"}}>
                <SidebarIcon name={it.icon}/>
              </span>
              <span style={{flex:1, whiteSpace:"nowrap" as const, overflow:"hidden", textOverflow:"ellipsis"}}>{it.label}</span>
              {disabled && <span style={{fontSize:8, fontWeight:700, color:"rgba(184,147,42,0.7)", border:"1px solid rgba(184,147,42,0.4)", padding:"2px 5px", borderRadius:4, letterSpacing:"0.5px"}}>PRO</span>}
            </button>
            </React.Fragment>
          );
        })}
      </nav>

      {/* Footer con usuario */}
      <div style={{padding:"14px 14px 18px", borderTop:"1px solid rgba(184,147,42,0.14)", display:"flex", flexDirection:"column", gap:10}}>
        {isUserAdmin && (
          <button onClick={() => setAppPantalla("admin")} style={{
            background: appPantalla === "admin" ? "rgba(184,147,42,0.18)" : "rgba(184,147,42,0.08)",
            border:"1px solid rgba(184,147,42,0.30)",
            color:"#D4A843", borderRadius:8, padding:"7px 10px", cursor:"pointer",
            fontSize:10, fontWeight:700, letterSpacing:"0.6px", textTransform:"uppercase" as const,
            fontFamily:fontSans, display:"flex", alignItems:"center", justifyContent:"center", gap:6,
          }}>⚙ Admin</button>
        )}
        {esRealPatron ? (
          /* El nombre es un acceso sutil a "Mi perfil" (foto + puesto + empresa). */
          <button onClick={()=>{ setPfPuestoEdit(false); setPfEmpresaEdit(false); setPerfilOpen(true); }} title="Ver perfil"
            style={{display:"flex", alignItems:"center", gap:10, width:"100%", background:"transparent", border:"none", padding:"6px", borderRadius:10, cursor:"pointer", textAlign:"left" as const, fontFamily:fontSans}}
            onMouseEnter={(e)=>{ (e.currentTarget as HTMLButtonElement).style.background = "rgba(255,255,255,0.05)"; }}
            onMouseLeave={(e)=>{ (e.currentTarget as HTMLButtonElement).style.background = "transparent"; }}>
            <div style={{width:34, height:34, borderRadius:"50%", overflow:"hidden", background:"rgba(184,147,42,0.18)", color:"#D4A843",
              display:"flex", alignItems:"center", justifyContent:"center", fontWeight:700, fontSize:13,
              border:"1px solid rgba(184,147,42,0.30)", flexShrink:0}}>
              {avatarFoto ? <img src={avatarFoto} alt="" style={{width:"100%", height:"100%", objectFit:"cover" as const, display:"block"}}/> : inicial}
            </div>
            <div style={{flex:1, minWidth:0}}>
              <div style={{fontSize:11.5, color:"rgba(255,255,255,0.88)", fontWeight:600, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" as const}}>{nombreUsuario}</div>
              <div style={{fontSize:9, color:"rgba(184,147,42,0.7)", textTransform:"uppercase" as const, letterSpacing:"1px", marginTop:2}}>{isProUser ? "Plan PRO · Ver perfil" : "Ver perfil"}</div>
            </div>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" style={{color:"rgba(184,147,42,0.7)", flexShrink:0}}><path d="M9 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
          </button>
        ) : (
          <div style={{display:"flex", alignItems:"center", gap:10}}>
            <div style={{width:34, height:34, borderRadius:"50%", overflow:"hidden", background:"rgba(184,147,42,0.18)", color:"#D4A843",
              display:"flex", alignItems:"center", justifyContent:"center", fontWeight:700, fontSize:13,
              border:"1px solid rgba(184,147,42,0.30)", flexShrink:0}}>
              {avatarFoto ? <img src={avatarFoto} alt="" style={{width:"100%", height:"100%", objectFit:"cover" as const, display:"block"}}/> : inicial}
            </div>
            <div style={{flex:1, minWidth:0}}>
              <div style={{fontSize:11.5, color:"rgba(255,255,255,0.88)", fontWeight:600, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" as const}}>
                {nombreUsuario}
              </div>
              <div style={{fontSize:9, color:"rgba(184,147,42,0.7)", textTransform:"uppercase" as const, letterSpacing:"1px", marginTop:2}}>
                {currentUser?.isAnonymous ? "Invitado" : (isProUser ? "Plan PRO" : "Acceso libre")}
              </div>
            </div>
          </div>
        )}
        {currentUser?.isAnonymous ? (
          <button onClick={onLogin} style={{
            background:"linear-gradient(135deg,#B8932A,#A07C30)", border:"none",
            color:"#0B1829", borderRadius:8, padding:"7px 10px", cursor:"pointer",
            fontSize:11, fontWeight:700, letterSpacing:"0.3px",
            fontFamily:fontSans, boxShadow:"0 2px 10px rgba(184,147,42,0.32)",
          }}>Iniciar sesión</button>
        ) : (
          <button onClick={onLogout} style={{
            background:"rgba(255,255,255,0.05)", border:"1px solid rgba(255,255,255,0.10)",
            color:"rgba(255,255,255,0.7)", borderRadius:8, padding:"7px 10px", cursor:"pointer",
            fontSize:11, fontWeight:600, letterSpacing:"0.3px",
            fontFamily:fontSans,
          }}>Salir</button>
        )}
      </div>
    </>
  );

  // ── Modal "Mi perfil" (patrón) — se abre desde el nombre del sidebar ─────────
  // Foto (avatar tocable), puesto y empresa. Mismos campos/doc que el portal móvil.
  const PF = { panel:"#11233F", line:"rgba(184,147,42,0.28)", gold:"#D4A843", iconBg:"rgba(184,147,42,0.14)", iconBd:"rgba(184,147,42,0.34)", ink:"#ECE6D8", inkSoft:"rgba(236,230,216,0.66)", inkMut:"rgba(236,230,216,0.42)" };
  const inicialesShell = (nombreUsuario||"").trim().split(/\s+/).slice(0,2).map((s:string)=>s[0]||"").join("").toUpperCase() || "AX";
  const campoPerfil = (etiqueta:string, valor:string, editando:boolean, input:string, setInput:(v:string)=>void, abrir:()=>void, cerrar:()=>void, guardar:()=>void, guardando:boolean, placeholder:string, ph2:string) => (
    <div style={{marginTop:14}}>
      <label style={{display:"block", fontSize:11, fontWeight:700, color:PF.inkSoft, marginBottom:5}}>{etiqueta}</label>
      {!editando ? (
        <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", gap:8, padding:"10px 12px", borderRadius:10, border:`1px solid ${PF.line}`, background:"rgba(255,255,255,0.03)"}}>
          <span style={{fontSize:13.5, color:valor?PF.ink:PF.inkMut, fontWeight:valor?700:500, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" as const}}>{valor || placeholder}</span>
          <button onClick={abrir} aria-label={`Editar ${etiqueta.toLowerCase()}`}
            style={{flexShrink:0, display:"inline-flex", alignItems:"center", justifyContent:"center", width:26, height:26, borderRadius:7, border:`1px solid ${PF.iconBd}`, background:"transparent", color:PF.gold, cursor:"pointer"}}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none"><path d="M4 20h4l10-10-4-4L4 16z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round"/><path d="M13.5 6.5l4 4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/></svg>
          </button>
        </div>
      ) : (
        <div {...ZONA_DE_CAPTURA}>
          <input value={input} onChange={e=>setInput(e.target.value)} placeholder={ph2} autoFocus
            style={{width:"100%", boxSizing:"border-box" as const, padding:"10px 12px", borderRadius:10, border:`1px solid ${PF.gold}`, background:"rgba(255,255,255,0.04)", color:PF.ink, fontSize:14, fontFamily:fontSans, outline:"none"}}/>
          <div style={{display:"flex", gap:8, marginTop:8}}>
            <button onClick={cerrar} style={{flex:1, padding:"9px", borderRadius:10, border:`1px solid ${PF.line}`, background:"transparent", color:PF.inkSoft, cursor:"pointer", fontFamily:fontSans, fontSize:13, fontWeight:700}}>Cancelar</button>
            <button onClick={guardar} disabled={guardando} style={{flex:2, padding:"9px", borderRadius:10, border:"none", background:PF.gold, color:"#0B1829", cursor:guardando?"wait":"pointer", fontFamily:fontSans, fontSize:13, fontWeight:800}}>{guardando ? "Guardando…" : "Guardar"}</button>
          </div>
        </div>
      )}
    </div>
  );
  // LAS ACTUALIZACIONES. El aviso solo en Inicio ("suite") y sin el perfil ni el
  // menú lateral abiertos; en cualquier otro módulo espera.
  const novedadesPatron = useNovedadesVistas(esRealPatron ? currentUser.uid : undefined);
  const tieneFlotillaPatron = (vehiculos || []).length > 0;
  const avisoNovedades = (
    <AvisoNovedades rol="patron" tieneFlotilla={tieneFlotillaPatron} altaMs={altaDeLaCuentaMs(currentUser)}
      vistas={novedadesPatron.vistas} onMarcar={novedadesPatron.marcarVistas}
      visible={esRealPatron && appPantalla === "suite" && !perfilOpen && !drawerOpen}
      posicion={isMobile ? "movil" : "escritorio"} abajo={isMobile ? "calc(16px + env(safe-area-inset-bottom, 0px))" : "20px"} fontSans={fontSans}/>
  );
  const perfilModal = (esRealPatron && perfilOpen) ? (
    <div onClick={()=>setPerfilOpen(false)} style={{position:"fixed" as const, inset:0, zIndex:1200, background:"rgba(3,10,22,0.66)", display:"flex", alignItems:"center", justifyContent:"center", padding:16, backdropFilter:"blur(3px)"}}>
      <div onClick={e=>e.stopPropagation()} style={{width:"100%", maxWidth:420, background:PF.panel, border:`1px solid ${PF.line}`, borderRadius:18, boxShadow:"0 24px 70px rgba(0,0,0,0.55)", padding:"20px 20px 22px", fontFamily:fontSans, maxHeight:"90vh", overflowY:"auto" as const}}>
        <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:10}}>
          <div style={{fontFamily:fontSerif, fontSize:18, fontWeight:700, color:PF.gold}}>Mi perfil</div>
          <button onClick={()=>setPerfilOpen(false)} aria-label="Cerrar" style={{width:32, height:32, borderRadius:"50%", border:`1px solid ${PF.iconBd}`, background:"transparent", color:PF.inkSoft, cursor:"pointer", fontSize:17, lineHeight:1}}>×</button>
        </div>
        {/* Avatar TOCABLE (tipo WhatsApp) */}
        <AvatarEditable url={avatarFoto} iniciales={inicialesShell} size={84} userId={currentUser.uid} carpeta="perfil"
          onSubido={(u:string)=>guardarPerfilFoto(u)} fontSans={fontSans}
          c={{gold:PF.gold, iconBg:PF.iconBg, iconBd:PF.iconBd, panel:PF.panel, inkSoft:PF.inkSoft}}/>
        <div style={{textAlign:"center" as const, fontFamily:fontSerif, fontSize:19, fontWeight:700, color:PF.gold, marginTop:14}}>{nombreUsuario}</div>
        {currentUser?.email && <div style={{textAlign:"center" as const, fontSize:12.5, color:PF.inkSoft, marginTop:2, wordBreak:"break-all" as const}}>{currentUser.email}</div>}
        {/* SE MUESTRA, NO SE EDITA AQUÍ: su sitio es "Datos de mi empresa", donde
            va con el RFC, el domicilio y el correo de contacto. */}
        <div style={{marginTop:14}}>
          <label style={{display:"block", fontSize:11, fontWeight:700, color:PF.inkSoft, marginBottom:5}}>Empresa</label>
          <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", gap:8, padding:"10px 12px", borderRadius:10, border:`1px solid ${PF.line}`, background:"rgba(255,255,255,0.03)"}}>
            <span style={{fontSize:13.5, color:pfEmpresa?PF.ink:PF.inkMut, fontWeight:pfEmpresa?700:500, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" as const}}>
              {pfEmpresa || "Sin capturar"}
            </span>
            <button onClick={()=>{ setPerfilOpen(false); abrirDatosDelPatron(); }}
              style={{flexShrink:0, background:"transparent", border:`1px solid ${PF.iconBd}`, color:PF.gold, borderRadius:8, padding:"5px 10px", cursor:"pointer", fontSize:11, fontWeight:700, fontFamily:fontSans}}>
              {pfEmpresa ? "Ver datos" : "Capturar"}
            </button>
          </div>
          <div style={{fontSize:10.5, color:PF.inkMut, margin:"5px 2px 0", lineHeight:1.45}}>
            Con su RFC, domicilio y correo de contacto se firman tus documentos.
          </div>
        </div>
        {campoPerfil("Puesto", pfPuesto, pfPuestoEdit, pfPuestoInput, setPfPuestoInput,
          ()=>{ setPfPuestoInput(pfPuesto); setPfPuestoEdit(true); }, ()=>setPfPuestoEdit(false), guardarPerfilPuesto, pfPuestoSaving, "Agrega tu puesto", "Ej. Director general")}
        {campoPerfil("WhatsApp de contacto", pfWa, pfWaEdit, pfWaInput, setPfWaInput,
          ()=>{ setPfWaInput(pfWa); setPfWaEdit(true); }, ()=>setPfWaEdit(false), guardarPerfilWa, pfWaSaving, "Agrega tu WhatsApp", "Ej. 449 123 4567")}
        <div style={{fontSize:10.5, color:PF.inkMut, margin:"6px 2px 0", lineHeight:1.45}}>Tus trabajadores podrán contactarte desde Flotilla. 10 dígitos (México).</div>
        {/* ── AVISOS: LA ENTRADA PERMANENTE ─────────────────────────────────
            La tarjeta de arriba desaparece en cuanto se pulsa "Ahora no", y el
            defecto de la versión vieja era justo ése: se iba para siempre y no
            quedaba ningún sitio donde volver a encontrarla ni saber cómo estaba.
            Aquí no desaparece nunca.
            VA EN EL PERFIL y no en un módulo porque los avisos no son un módulo:
            son de la cuenta y del dispositivo. El perfil se abre desde el avatar
            en cualquier pantalla, ya guarda lo de la cuenta —empresa, puesto,
            WhatsApp— y es el único sitio que cumple las dos cosas. */}
        <div style={{marginTop:16}}>
          <label style={{display:"block", fontSize:11, fontWeight:700, color:PF.inkSoft, marginBottom:5}}>Avisos</label>
          <PuertaDeAvisos estado={estadoAvisos} onActivar={activarAvisos} compacta fontSans={fontSans}
            c={{fondo: "rgba(255,255,255,0.03)", borde: PF.line, acento: PF.gold, botonTexto: "#0B1829",
                texto: PF.ink, textoSuave: PF.inkSoft}}/>
          {/* SIEMPRE A LA VISTA en Android; y, con los avisos activos, qué versión
              del service worker corre en este aparato. */}
          <NotaBateriaAndroid fontSans={fontSans} c={{fondo: "rgba(255,255,255,0.03)", borde: PF.line, texto: PF.ink, textoSuave: PF.inkSoft}}/>
          {estadoAvisos === "activos" && <EstadoSwAvisosLinea fontSans={fontSans} c={{textoSuave: PF.inkSoft}}/>}
        </div>
        {/* ACTUALIZACIONES: todas las que le aplican, con fecha. */}
        <div style={{marginTop:16}}>
          <label style={{display:"block", fontSize:11, fontWeight:700, color:PF.inkSoft, marginBottom:5}}>Actualizaciones</label>
          <ListaNovedades rol="patron" tieneFlotilla={tieneFlotillaPatron} fontSans={fontSans}
            c={{fondo: "rgba(255,255,255,0.03)", borde: PF.line, texto: PF.ink, textoSuave: PF.inkSoft, acento: PF.gold}}/>
        </div>
        <div style={{textAlign:"center" as const, marginTop:18}}>
          <span style={{display:"inline-block", fontSize:11, fontWeight:800, letterSpacing:"0.5px", color:"#0B1829", background:PF.gold, borderRadius:999, padding:"4px 12px"}}>PLAN PRO</span>
        </div>
      </div>
    </div>
  ) : null;

  // ── MÓVIL: top bar con hamburguesa + drawer deslizable ───────────────
  // Usamos 100dvh (no 100vh) para respetar la barra del navegador móvil
  // y evitar que el contenido quede tapado / se rompa el scroll.
  if (isMobile) {
    return (
      <div style={{minHeight:"100dvh", background:T_LIGHT.canvas, fontFamily:fontSans}}>
        {/* Top bar móvil: hamburguesa + marca */}
        <div style={{
          position:"sticky" as const, top:0, zIndex:70,
          // AREA SEGURA (iPhone con notch). Sin esto la barra se dibuja DEBAJO de la
          // barra de estado: el titulo se encima con la hora y los botones quedan
          // bajo la interfaz del sistema, que se queda los toques. En horizontal no
          // pasa porque ahi el inset superior es 0 — por eso el bug parecia
          // intermitente. `content-box` deja que el inset SUME al alto declarado en
          // vez de comerselo. En pantallas sin notch, env() vale 0 y no cambia nada.
          // El shorthand `padding` va PRIMERO: si fuera al reves anularia el
          // paddingTop del area segura, porque en un objeto gana la ultima clave.
          height: TOP_W, boxSizing:"content-box" as const,
          padding:"0 14px",
          paddingTop:"env(safe-area-inset-top, 0px)",
          background: T.bgSide,
          borderBottom:"1px solid rgba(184,147,42,0.18)",
          display:"flex", alignItems:"center", gap:12,
          boxShadow:"0 2px 12px rgba(11,24,41,0.20)",
        }}>
          <button
            onClick={() => setDrawerOpen(true)}
            aria-label="Abrir menú"
            style={{
              background:"rgba(255,255,255,0.06)", border:"1px solid rgba(255,255,255,0.10)",
              borderRadius:8, padding:"6px 9px", cursor:"pointer", color:"white",
              display:"flex", alignItems:"center", justifyContent:"center",
            }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M3 6h18M3 12h18M3 18h18" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round"/>
            </svg>
          </button>
          <div style={{display:"flex", alignItems:"center", gap:9}}>
            <div style={{width:28, height:28, background:"linear-gradient(135deg,#B8932A,#D4A843)", borderRadius:7,
              display:"flex", alignItems:"center", justifyContent:"center",
              boxShadow:"0 3px 10px rgba(184,147,42,0.40)"}}>
              <span style={{fontFamily:fontSerif, fontSize:11, fontWeight:900, color:"#0B1829"}}>AX</span>
            </div>
            <span style={{fontFamily:fontSerif, fontSize:13, fontWeight:700, color:"white", letterSpacing:"0.2px"}}>AXIS Legaltech</span>
          </div>
          {/* Spacer + campana de notificaciones (sólo con sesión real) */}
          <div style={{flex:1}}/>
          {mostrarCampana && (
            <div style={{display:"flex", alignItems:"center", gap:8}}>
              <ActividadBell actividad={actividad} uid={currentUser?.uid} isMobile={true} fontSerif={fontSerif} onIrModulo={onIrModuloDesdeCampana}/>
              <NotificationBell items={atencionUrgente} accidentes={accidentesPendientes} kpis={kpis} currentUser={currentUser} isMobile={true} fontSerif={fontSerif} onIrModulo={onIrModuloDesdeCampana} onIrItem={onIrItem}/>
            </div>
          )}
        </div>

        {/* Overlay oscuro (sólo cuando el drawer está abierto) */}
        {drawerOpen && (
          <div
            onClick={() => setDrawerOpen(false)}
            style={{
              position:"fixed" as const, inset:0, background:"rgba(8,14,28,0.55)",
              zIndex: 99, animation:"axisOverlayIn 0.18s ease forwards",
            }}/>
        )}

        {/* Drawer deslizable desde la izquierda */}
        <aside style={{
          position:"fixed" as const, top:0, bottom:0,
          left: drawerOpen ? 0 : -(SIDEBAR_W + 20),
          width: SIDEBAR_W,
          background: T.bgSide,
          borderRight: "1px solid rgba(184,147,42,0.20)",
          zIndex: 100,
          transition: "left 0.26s ease",
          boxShadow: drawerOpen ? "6px 0 24px rgba(0,0,0,0.40)" : "none",
          display:"flex", flexDirection:"column",
        }}>
          {sidebarBody}
        </aside>

        {/* Animación overlay (definida una sola vez por instancia) */}
        <style>{`@keyframes axisOverlayIn { from {opacity:0} to {opacity:1} }`}</style>

        {/* AQUÍ IBA LA PUERTA DE LOS AVISOS, AL PIE. Se subió a Inicio, dentro de
            "Prepara este dispositivo": al pie del contenido había que bajar hasta el
            final para encontrarla —una puerta que hay que buscar no es una puerta—
            y además se pintaba en TODAS las pantallas, que es perseguir al patrón
            por el producto. */}
        <main style={{background: T_LIGHT.canvas}}>
          {children}
        </main>
        {perfilModal}
        {avisoNovedades}
      </div>
    );
  }

  // ── DESKTOP: sidebar fijo a la izquierda + top bar con campana ───────
  return (
    <div style={{display:"flex", minHeight:"100vh", background:T_LIGHT.canvas, fontFamily:fontSans}}>
      {perfilModal}
      {avisoNovedades}
      <aside style={{
        width: SIDEBAR_W,
        background: T.bgSide,
        borderRight: "1px solid rgba(184,147,42,0.18)",
        display:"flex", flexDirection:"column",
        position:"fixed" as const, top:0, left:0, bottom:0,
        zIndex: 90,
        boxShadow: "2px 0 18px rgba(11,24,41,0.22)",
      }}>
        {sidebarBody}
        {/* Soporte — tarjeta discreta al pie del sidebar (solo escritorio; el
            drawer móvil usa `sidebarBody` y no se toca). No altera los grupos,
            el orden ni los iconos de la navegación. */}
        <div style={{padding:"10px 12px 14px", borderTop:"1px solid rgba(184,147,42,0.14)", marginTop:"auto"}}>
          <a href="https://wa.me/524494251128?text=Hola%2C%20necesito%20ayuda%20con%20AXIS%20Legaltech"
            target="_blank" rel="noopener noreferrer"
            style={{display:"block", textDecoration:"none", background:"rgba(255,255,255,0.05)",
              border:"1px solid rgba(184,147,42,0.22)", borderRadius:10, padding:"10px 12px"}}>
            <div style={{display:"flex", alignItems:"center", gap:9}}>
              <span style={{width:26, height:26, borderRadius:7, flexShrink:0, background:"rgba(184,147,42,0.14)",
                border:"1px solid rgba(184,147,42,0.30)", display:"flex", alignItems:"center", justifyContent:"center"}}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M4 19.5V6a2 2 0 012-2h12a2 2 0 012 2v8a2 2 0 01-2 2H8l-4 3.5z" stroke="#D4A843" strokeWidth="1.7" strokeLinejoin="round"/></svg>
              </span>
              <div style={{minWidth:0}}>
                <div style={{fontSize:11.5, fontWeight:700, color:"#ECE6D8", lineHeight:1.25}}>¿Necesitas ayuda?</div>
                <div style={{fontSize:10, color:"rgba(236,230,216,0.55)", marginTop:1}}>Escríbenos por WhatsApp</div>
              </div>
            </div>
          </a>
        </div>
      </aside>

      <div style={{flex:1, marginLeft: SIDEBAR_W, minHeight:"100vh", display:"flex", flexDirection:"column" as const, background: T_LIGHT.canvas}}>
        {/* Top bar global navy: alineado a la derecha — email/estado + campana + Salir */}
        <div style={{
          position:"sticky" as const, top:0, zIndex:60,
          height: 44, padding: "0 22px",
          background: T.bgSide,
          borderBottom: "1px solid rgba(184,147,42,0.18)",
          display:"flex", alignItems:"center", justifyContent:"flex-end", gap:12,
          boxShadow: "0 2px 10px rgba(11,24,41,0.14)",
        }}>
          {currentUser?.isAnonymous ? (
            <button onClick={onLogin} style={{
              background:"linear-gradient(135deg,#B8932A,#A07C30)", border:"none",
              color:"#0B1829", borderRadius:8, padding:"5px 14px", cursor:"pointer",
              fontSize:11, fontWeight:700, letterSpacing:"0.3px",
              boxShadow:"0 2px 10px rgba(184,147,42,0.32)",
              display:"flex", alignItems:"center", gap:6,
            }}>Iniciar sesión</button>
          ) : (
            <>
              <span style={{
                fontSize:11, color:"rgba(255,255,255,0.65)",
                whiteSpace:"nowrap" as const, overflow:"hidden", textOverflow:"ellipsis", maxWidth: 240,
              }}>{currentUser?.email || nombreUsuario}</span>
              {mostrarCampana && (
                <div style={{display:"flex", alignItems:"center", gap:8}}>
                  <ActividadBell actividad={actividad} uid={currentUser?.uid} isMobile={false} fontSerif={fontSerif} onIrModulo={onIrModuloDesdeCampana}/>
                  <NotificationBell items={atencionUrgente} accidentes={accidentesPendientes} kpis={kpis} currentUser={currentUser} isMobile={false} fontSerif={fontSerif} onIrModulo={onIrModuloDesdeCampana} onIrItem={onIrItem}/>
                </div>
              )}
              <button onClick={onLogout} style={{
                background:"rgba(255,255,255,0.06)", border:"1px solid rgba(255,255,255,0.12)",
                color:"rgba(255,255,255,0.7)", borderRadius:8, padding:"5px 14px", cursor:"pointer",
                fontSize:11, fontWeight:600, letterSpacing:"0.3px",
              }}>Salir</button>
            </>
          )}
        </div>
        {/* El zócalo reservado se aplica aquí, una sola vez, y no en cada
            pantalla: el flotante está acotado a esa franja, así que ninguna
            pantalla puede quedar tapada por él —tampoco las que se hagan
            después con este mismo molde. Va por dentro del último bloque de la
            pantalla (no como padding de <main>) para que la franja la pinte el
            fondo de esa pantalla y no aparezca una banda de otro color; con
            border-box no alarga la página cuando ya medía 100vh. */}
        <style>{`.axis-main > *:last-child { box-sizing: border-box; padding-bottom: ${ZOCALO_FLOTANTES}px; }`}</style>
        <main className="axis-main" style={{flex:1, background: T_LIGHT.canvas}}>
          {/* La llave de navegación va aquí y no en cada ruta: cualquier módulo
              —también los que se agreguen después— vuelve a su vista por
              defecto cuando se le entra desde el sidebar. Móvil sin cambios. */}
          {/* Ver la rama móvil: la puerta de avisos subió a Inicio y ya no se pinta
              al pie de todas las pantallas. */}
          <React.Fragment key={navKey}>{children}</React.Fragment>
        </main>
      </div>
    </div>
  );
}

// ─── GATE DE CONSENTIMIENTO (Términos y Condiciones + Aviso de Privacidad) ───
// Modal BLOQUEANTE que aparece tras iniciar sesión y antes de la suite. Guarda
// evidencia versionada en la colección owner-scoped `consentimientos` (doc id = uid).
// Para forzar re-aceptación, sube VERSION_AVISO / VERSION_TERMINOS.
const VERSION_AVISO = "2026-06";
const VERSION_TERMINOS = "2026-06";

const TEXTO_TERMINOS = `TÉRMINOS Y CONDICIONES DE USO — AXIS LEGALTECH
Versión: 2026-06

1. Objeto y aceptación
Los presentes Términos y Condiciones (los "Términos") regulan el acceso y uso de la plataforma AXIS Legaltech (la "Plataforma"), operada por AXIS Asesoría Legal Corporativa ("AXIS"). Al marcar la casilla de aceptación y acceder a la Plataforma, el usuario (el "Usuario") manifiesta que los ha leído y acepta obligarse en sus términos. Si no está de acuerdo, debe abstenerse de usar la Plataforma.

2. Naturaleza informativa y orientativa del servicio
La Plataforma y el asistente AXIOR tienen una finalidad informativa, orientativa y de apoyo operativo. La información, respuestas, modelos y documentos que ofrecen no constituyen asesoría jurídica, fiscal, contable ni profesional de ninguna clase, ni opinión legal vinculante, no crean una relación abogado-cliente y no sustituyen el juicio de un profesional.
Para una asesoría completa e integral sobre cualquier asunto, el Usuario debe acudir con un abogado con cédula profesional vigente o directamente con AXIS Asesoría Legal Corporativa.
El Usuario es el único responsable de las decisiones que adopte y reconoce que debe verificar y validar con un profesional cualquier información antes de actuar conforme a ella.

3. Definiciones
• Usuario: persona que accede a la Plataforma con una cuenta.
• Datos de Terceros: información de clientes, pacientes, empleados, proveedores o deudores que el Usuario incorpora a la Plataforma.
• AXIOR: asistente de inteligencia artificial integrado en la Plataforma.
• Documentos Generados: contratos, avisos, consentimientos, títulos de crédito y demás documentos producidos con las herramientas de la Plataforma.
• Plan: modalidad de contratación y de acceso a las funciones de la Plataforma.

4. Cuenta y acceso
El Usuario es responsable de la veracidad de sus datos de registro y del resguardo de sus credenciales. Todo acceso realizado con sus credenciales se entiende efectuado por el Usuario, quien debe notificar a AXIS cualquier uso no autorizado de su cuenta.

5. Uso permitido
El Usuario se obliga a utilizar la Plataforma conforme a la ley, a estos Términos y a la buena fe. Queda prohibido, de manera enunciativa: usar la Plataforma con fines ilícitos; vulnerar o intentar vulnerar su seguridad; reproducir, copiar, descompilar o explotar sus componentes sin autorización; revender el acceso; o incorporar Datos de Terceros sin contar con facultades para ello.

6. Contenido del Usuario y datos de terceros
El Usuario es el único responsable de los Datos de Terceros que incorpora a la Plataforma. Frente a esas personas, el Usuario actúa como responsable del tratamiento de sus datos personales y AXIS únicamente como encargado, conforme al Aviso de Privacidad de la Plataforma. Corresponde al Usuario contar con el consentimiento y las bases de licitud necesarias, emitir sus propios avisos de privacidad y atender los derechos ARCO de dichas personas. Tratándose de datos sensibles, el Usuario debe recabar el consentimiento expreso y por escrito que exige la ley.

7. Asistente AXIOR e inteligencia artificial
Conforme a la cláusula 2, AXIOR proporciona orientación general de carácter informativo. Sus respuestas no constituyen asesoría jurídica formal ni opinión vinculante, pueden contener imprecisiones y no sustituyen la consulta con un abogado con cédula profesional. El Usuario es responsable de verificar cualquier decisión basada en dichas respuestas.

8. Documentos Generados
Los Documentos Generados son borradores y modelos que requieren revisión y adaptación por un profesional del derecho antes de su uso o firma. AXIS no garantiza su idoneidad para un caso concreto y no es responsable del uso que el Usuario haga de ellos sin la revisión profesional correspondiente.

9. Propiedad intelectual
La Plataforma, su software, diseño, marcas (incluidas "AXIS Legaltech" y "AXIS Asesoría Legal Corporativa") y demás componentes son propiedad de AXIS o de sus titulares y están protegidos por la legislación aplicable. No se concede al Usuario más derecho que el de uso de la Plataforma conforme a estos Términos. El Usuario conserva la titularidad sobre los Datos de Terceros que incorpora.

10. Planes de pago y facturación
El acceso a determinadas funciones de la Plataforma puede estar sujeto a la contratación de un Plan de pago.
• Precios: los precios aplicables, su periodicidad (mensual, anual u otra) y los impuestos correspondientes se indican en la Plataforma o en la cotización vigente al momento de la contratación. Los precios se expresan en pesos mexicanos.
• Cobro y facturación: el cobro se realiza a través de un procesador de pagos; AXIS no almacena los datos completos de tarjetas. AXIS emitirá los comprobantes fiscales conforme a la información proporcionada por el Usuario.
• Renovación: salvo indicación en contrario, los Planes con periodicidad se renuevan automáticamente por periodos iguales, hasta que el Usuario cancele.
• Cancelación: el Usuario puede cancelar la renovación en cualquier momento; la cancelación surte efectos al término del periodo ya pagado.
• Falta de pago: AXIS puede suspender o limitar el acceso a las funciones de pago ante la falta de pago, previa notificación razonable.
• Cambios de precio: AXIS puede modificar los precios; los cambios se notificarán con anticipación razonable y aplicarán a partir del siguiente periodo de renovación.
• Reembolsos: salvo disposición legal en contrario, los pagos efectuados no son reembolsables.

11. Disponibilidad del servicio
AXIS procura la disponibilidad continua de la Plataforma, pero no garantiza que el servicio sea ininterrumpido o libre de errores. Puede realizar mantenimientos, actualizaciones o suspensiones temporales, así como modificar o descontinuar funciones, procurando avisar cuando sea razonablemente posible.

12. Limitación de responsabilidad
En la medida que permita la ley, AXIS no será responsable por daños indirectos, incidentales, especiales o consecuenciales derivados del uso o imposibilidad de uso de la Plataforma, ni por decisiones que el Usuario adopte con base en los Documentos Generados o en las respuestas de AXIOR sin la debida revisión profesional. La responsabilidad total de AXIS frente al Usuario, por cualquier concepto, no excederá del monto que el Usuario haya pagado por el uso de la Plataforma durante los tres (3) meses anteriores al hecho que origine la responsabilidad.

13. Indemnización
El Usuario mantendrá en paz y a salvo a AXIS, a sus socios y colaboradores, frente a cualquier reclamación, daño o responsabilidad de terceros que derive del uso indebido de la Plataforma, de la incorporación de Datos de Terceros sin las facultades necesarias, o del incumplimiento de estos Términos o de la normatividad aplicable.

14. Vigencia y terminación
Estos Términos rigen mientras el Usuario mantenga su cuenta. AXIS puede suspender o cancelar el acceso ante un incumplimiento. El Usuario puede dejar de usar la Plataforma en cualquier momento.

15. Modificaciones a los Términos
AXIS puede modificar estos Términos. Cuando ello ocurra, se actualizará el número de versión y se solicitará nuevamente la aceptación del Usuario al ingresar a la Plataforma.

16. Legislación aplicable y jurisdicción
Estos Términos se rigen por las leyes de los Estados Unidos Mexicanos. Para cualquier controversia, las partes se someten a la jurisdicción de los tribunales competentes de la ciudad de Aguascalientes, Aguascalientes, renunciando a cualquier otro fuero que pudiera corresponderles.

17. Contacto
Para cualquier asunto relacionado con estos Términos: contacto@axislegalags.com.`;

const TEXTO_AVISO = `AVISO DE PRIVACIDAD — PLATAFORMA AXIS LEGALTECH
Versión: 2026-06

1. Identidad y domicilio del responsable
AXIS Asesoría Legal Corporativa (en adelante, "AXIS"), con domicilio en Torre Plaza Bosques, Interior 909, Aguascalientes, Aguascalientes, México, y RFC [CONFIRMAR RFC], es responsable del tratamiento de los datos personales que se recaban a través de la plataforma AXIS Legaltech (en adelante, la "Plataforma"), en términos de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP), su Reglamento y demás disposiciones aplicables.
Para cualquier asunto relacionado con este Aviso o con tus datos personales, el contacto es: contacto@axislegalags.com.

2. Datos personales que se recaban del usuario
Para crear y operar tu cuenta, AXIS recaba directamente de ti:
• Identificación y contacto: nombre, correo electrónico y, en su caso, teléfono.
• Datos de cuenta: credenciales de acceso. La contraseña se almacena cifrada por el proveedor de autenticación; AXIS no tiene acceso a ella en texto claro.
• Datos de uso: registros de actividad, fecha y hora de acceso, y registro de la aceptación de términos y avisos (incluida la versión aceptada).
• Datos de facturación: los necesarios para procesar pagos de los planes contratados. AXIS no almacena los datos completos de tarjetas bancarias; el cobro se realiza a través de un procesador de pagos especializado.
AXIS no recaba datos personales sensibles del usuario titular para la operación de su cuenta.

3. Datos de terceros que el usuario incorpora a la Plataforma
La Plataforma permite al usuario capturar y administrar información de sus propios clientes, pacientes, empleados, proveedores y deudores ("Datos de Terceros").
Respecto de esos Datos de Terceros, el usuario actúa como responsable del tratamiento frente a dichas personas, y AXIS actúa únicamente como encargado, limitándose a almacenar y procesar la información conforme a las instrucciones del usuario y a lo previsto en los Términos y Condiciones. Corresponde al usuario obtener los consentimientos, emitir los avisos de privacidad y atender los derechos ARCO de las personas cuyos datos incorpore.
Si el usuario incorpora datos personales sensibles (por ejemplo, datos de salud en expedientes de pacientes), es su exclusiva responsabilidad contar con el consentimiento expreso y por escrito que exige la ley, así como cumplir la normatividad sectorial aplicable.

4. Finalidades del tratamiento
Finalidades primarias (necesarias para el servicio):
• Crear, autenticar y administrar tu cuenta.
• Prestar las funciones de la Plataforma (generación de documentos, expedientes, créditos, asistente AXIOR, alertas dentro de la app, entre otras).
• Procesar el pago de los planes contratados y emitir comprobantes.
• Atender solicitudes de soporte y enviar comunicaciones operativas.
• Cumplir obligaciones legales y conservar evidencia de la aceptación de este Aviso y de los Términos.
Finalidades secundarias (no necesarias para el servicio; puedes oponerte sin afectar tu uso de la Plataforma):
• Envío de comunicaciones sobre mejoras, capacitaciones y servicios de AXIS.
• Elaboración de estadísticas internas de uso, de forma agregada.
Puedes oponerte a las finalidades secundarias en cualquier momento escribiendo a contacto@axislegalags.com.

5. Transferencias y encargados
Para operar la Plataforma, AXIS se apoya en proveedores que actúan como encargados y pueden alojar o procesar datos, incluso fuera de México:
• Google (Firebase): autenticación, base de datos y almacenamiento.
• Vercel: alojamiento y entrega de la Plataforma.
• Anthropic: procesamiento de las consultas que el usuario formula al asistente AXIOR.
• Procesador de pagos: cobro y facturación de los planes contratados.
Estas relaciones no constituyen transferencias que requieran tu consentimiento adicional conforme al artículo 37 de la LFPDPPP, al tratarse de prestadores que tratan datos por cuenta de AXIS. Fuera de estos casos, AXIS no transfiere tus datos a terceros sin tu consentimiento, salvo los supuestos previstos por la ley.

6. Medios para ejercer los derechos ARCO
Tienes derecho a Acceder, Rectificar y Cancelar tus datos personales, así como a Oponerte a su tratamiento. Para ejercerlos, envía tu solicitud a contacto@axislegalags.com, indicando tu nombre, el derecho que deseas ejercer y la información necesaria para identificar tu cuenta. AXIS responderá en los plazos que marca la LFPDPPP.

7. Medios para limitar el uso o divulgación
Puedes limitar el uso o divulgación de tus datos enviando tu solicitud al correo de contacto, así como oponerte a las finalidades secundarias por el mismo medio.

8. Uso de cookies y tecnologías similares
La Plataforma utiliza tecnologías de sesión y almacenamiento estrictamente necesarias para mantener tu acceso autenticado y el correcto funcionamiento del servicio.

9. Conservación de los datos
AXIS conserva tus datos mientras mantengas una cuenta activa y, una vez dada de baja, durante el plazo necesario para cumplir obligaciones legales, fiscales y de defensa jurídica (de manera enunciativa, hasta cinco años), tras lo cual se bloquean y suprimen conforme a la ley.

10. Cambios al presente Aviso
AXIS puede modificar este Aviso. Cuando ello ocurra, se actualizará el número de versión y se te solicitará nuevamente tu aceptación al ingresar a la Plataforma. La versión vigente estará siempre disponible dentro de la Plataforma.

11. Consentimiento
Al marcar la casilla correspondiente y acceder a la Plataforma, manifiestas que has leído este Aviso de Privacidad y otorgas tu consentimiento para el tratamiento de tus datos en los términos aquí descritos. AXIS conserva registro de tu aceptación, su fecha y la versión aceptada como evidencia.`;

function GateConsentimiento({user, onAceptado, fontSans, fontSerif, gold}: {user:any; onAceptado:()=>void; fontSans:string; fontSerif:string; gold:string}) {
  const [okTerminos, setOkTerminos] = useState(false);
  const [okAviso, setOkAviso] = useState(false);
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState("");
  const isMobile = window.innerWidth < 768;
  const ambas = okTerminos && okAviso;

  const aceptar = async () => {
    if (!ambas || !user?.uid) return;
    setGuardando(true); setError("");
    try {
      await setDoc(doc(db, "consentimientos", user.uid), {
        uid: user.uid,
        email: user.email || null,
        versionAviso: VERSION_AVISO,
        versionTerminos: VERSION_TERMINOS,
        aceptado: true,
        timestamp: serverTimestamp(),
      });
      onAceptado();
    } catch(e:any) {
      console.error("Gate consentimiento — guardar:", e);
      setError("No se pudo guardar tu aceptación. Revisa tu conexión e intenta de nuevo.");
      setGuardando(false);
    }
  };

  const cajaTexto: React.CSSProperties = {
    maxHeight: isMobile ? 150 : 200, overflowY: "auto", border: `1px solid ${T_LIGHT.borderCard}`,
    borderRadius: 10, padding: "12px 14px", background: T_LIGHT.canvasSoft,
    fontSize: 11.5, color: T_LIGHT.textInkSoft, lineHeight: 1.65, whiteSpace: "pre-wrap" as const,
  };
  const lblCheck: React.CSSProperties = {display:"flex", alignItems:"flex-start", gap:9, marginTop:9, cursor:"pointer", fontSize:13, color:T_LIGHT.textInk, lineHeight:1.5};

  // Modal BLOQUEANTE: el overlay NO cierra al hacer clic; no hay botón X. Solo se
  // sale aceptando (o cerrando sesión por otros medios).
  return (
    <div style={{position:"fixed" as const, inset:0, background:"rgba(11,24,41,0.78)", zIndex:5000, display:"flex", alignItems:"center", justifyContent:"center", padding:isMobile?12:24, fontFamily:fontSans}}>
      <div style={{background:T_LIGHT.cardLight, borderRadius:18, padding:isMobile?"20px 18px":"28px 32px", maxWidth:680, width:"100%", maxHeight:"94vh", overflowY:"auto" as const, boxShadow:"0 20px 60px rgba(0,0,0,0.45)", display:"flex", flexDirection:"column" as const, gap:16}}>
        <div>
          <div style={{width:48, height:48, background:T.navy, borderRadius:12, display:"flex", alignItems:"center", justifyContent:"center", marginBottom:12}}>
            <span style={{fontFamily:fontSerif, fontSize:18, fontWeight:700, color:gold}}>AX</span>
          </div>
          <h2 style={{fontFamily:fontSerif, fontSize:isMobile?18:22, color:T_LIGHT.textInk, margin:"0 0 6px"}}>Antes de continuar</h2>
          <p style={{fontSize:13, color:T_LIGHT.textInkSoft, margin:0, lineHeight:1.6}}>Para usar AXIS Legaltech necesitas leer y aceptar nuestros Términos y Condiciones y el Aviso de Privacidad.</p>
        </div>

        <div>
          <div style={{fontSize:11, fontWeight:700, color:T_LIGHT.textInk, marginBottom:7, textTransform:"uppercase" as const, letterSpacing:"0.6px"}}>Términos y Condiciones</div>
          <div style={cajaTexto}>{TEXTO_TERMINOS}</div>
          <label style={lblCheck}>
            <input type="checkbox" checked={okTerminos} onChange={e=>setOkTerminos(e.target.checked)} style={{marginTop:3, width:16, height:16, flexShrink:0}}/>
            <span>He leído y acepto los <strong>Términos y Condiciones</strong>.</span>
          </label>
        </div>

        <div>
          <div style={{fontSize:11, fontWeight:700, color:T_LIGHT.textInk, marginBottom:7, textTransform:"uppercase" as const, letterSpacing:"0.6px"}}>Aviso de Privacidad</div>
          <div style={cajaTexto}>{TEXTO_AVISO}</div>
          <label style={lblCheck}>
            <input type="checkbox" checked={okAviso} onChange={e=>setOkAviso(e.target.checked)} style={{marginTop:3, width:16, height:16, flexShrink:0}}/>
            <span>He leído y acepto el <strong>Aviso de Privacidad</strong>.</span>
          </label>
        </div>

        {error && <div style={{background:"rgba(220,38,38,0.08)", border:"1px solid rgba(220,38,38,0.30)", borderRadius:8, padding:"9px 13px", fontSize:12, color:T_LIGHT.danger, fontWeight:600}}>{error}</div>}

        <button onClick={aceptar} disabled={!ambas || guardando}
          style={{width:"100%", background: ambas ? "linear-gradient(135deg,#B8932A,#A07C30)" : T_LIGHT.canvasSoft, border:"none", borderRadius:12, padding:"14px", cursor:(!ambas||guardando)?"not-allowed":"pointer", fontSize:14, fontWeight:700, color: ambas ? "white" : T_LIGHT.textInkMut, boxShadow: ambas ? "0 4px 16px rgba(184,147,42,0.35)" : "none", fontFamily:fontSans}}>
          {guardando ? "Guardando..." : "Acepto y continuar"}
        </button>
        <p style={{fontSize:10.5, color:T_LIGHT.textInkMut, textAlign:"center" as const, margin:0}}>Versión Términos {VERSION_TERMINOS} · Aviso {VERSION_AVISO}</p>
      </div>
    </div>
  );
}

// ─── AYUDA / MANUAL ──────────────────────────────────────────────────────────
// Guía corta por función, agrupada en 4 secciones, + bloque "¿No entiendes?".
// Reusa AxisIcon (sin emojis), el estilo de tarjetas/grupos y el AXIOR existente.
function AyudaManual({fontSans, fontSerif, gold}: {fontSans:string; fontSerif:string; gold:string}) {
  const isMobile = window.innerWidth < 768;
  const SECCIONES: Array<{titulo:string; items:Array<{icon:string; color:string; titulo:string; sirve:string; usa:string; tip:string}>}> = [
    {titulo:"Operación", items:[
      {icon:"suite_diagnostico", color:"#B8932A", titulo:"Diagnóstico Regulatorio",
        sirve:"Un check-up de las obligaciones que le aplican a tu empresa según su giro.",
        usa:"Entra al módulo, selecciona tu industria y responde el cuestionario; al final ves tu nivel de cumplimiento y qué te falta.",
        tip:"Repítelo cada vez que cambie tu operación (nuevos empleados, nueva actividad)."},
      {icon:"suite_contratos", color:"#1F4E3D", titulo:"Generador legal",
        sirve:"Crea documentos listos para revisión: contratos, avisos y consentimientos, y títulos de crédito.",
        usa:"Elige el tipo de documento, llena los campos y genera. El documento queda guardado en tu Banco de documentos.",
        tip:"Todo documento generado es un borrador; revísalo con un abogado antes de firmarlo."},
      {icon:"suite_documentos", color:"#B8932A", titulo:"Banco de documentos",
        sirve:"El archivo de todos los documentos que has generado.",
        usa:"Ábrelo para consultar, descargar o reabrir cualquier documento, y ver a qué cliente, paciente, empleado, proveedor o deudor está vinculado.",
        tip:"Usa los vínculos para llegar rápido desde el expediente de una persona a sus documentos."},
      {icon:"suite_flotilla", color:"#5D4037", titulo:"Flotilla",
        sirve:"Control de vehículos y de las salidas y regresos de tu flotilla.",
        usa:"Registra cada vehículo y lleva la bitácora de salidas/regresos.",
        tip:"Útil para deslindar responsabilidades por uso del vehículo."},
      {icon:"suite_calendario", color:"#A0522D", titulo:"Calendario",
        sirve:"Tus eventos y fechas importantes en un solo lugar.",
        usa:"Agrega eventos y consúltalos por fecha.",
        tip:"Apóyalo con las alertas para no perder vencimientos."},
    ]},
    {titulo:"Administración y registros", items:[
      // Disponible. Lo único que no tiene por ahora es la validación 69-B, que
      // se retiró de este módulo: no se anuncia.
      {icon:"user_single", color:"#8E3B6E", titulo:"Clientes / Pacientes",
        sirve:"Tu cartera de clientes (o pacientes), con su expediente y cumplimiento.",
        usa:"Registra a cada cliente/paciente, guarda sus datos y vincula sus documentos y contratos.",
        tip:"Mantén el Aviso de Privacidad y consentimientos ligados a cada expediente."},
      {icon:"suite_empleados", color:"#236478", titulo:"Empleados / Nómina",
        sirve:"Registro de tus trabajadores y sus recibos de nómina.",
        usa:"Da de alta a cada empleado y genera/consulta sus recibos.",
        tip:"El medidor de cumplimiento por empleado te muestra qué actividades tiene pendientes."},
      // PRÓXIMAMENTE: la validación 69-B se retiró hasta que la plataforma
      // revalide sola lo ya guardado. La ayuda no puede prometerla como
      // disponible mientras la pantalla diga lo contrario.
      {icon:"briefcase", color:"#3D3A6B", titulo:"Proveedores (69-B) · próximamente",
        sirve:"Control de proveedores con validación contra la lista 69-B del SAT. Todavía no está disponible.",
        usa:"Cuando se active, registrarás al proveedor y el sistema comprobará si aparece en la lista del SAT (EFOS/EDOS).",
        tip:"Mientras tanto, consulta las listas del Artículo 69-B directamente en el portal del SAT."},
      {icon:"suite_calculadora", color:"#722F37", titulo:"Calculadora LFT",
        sirve:"Calcula montos laborales conforme a la Ley Federal del Trabajo (finiquito, liquidación, aguinaldo, vacaciones y prima vacacional).",
        usa:"Captura los datos del trabajador (salario, antigüedad, fecha de baja) y obtienes los montos estimados.",
        tip:"Úsala como estimación; valida el cálculo final con un abogado antes de pagar o firmar."},
    ]},
    {titulo:"Finanzas", items:[
      {icon:"money", color:"#1E3A8A", titulo:"Créditos",
        sirve:"Control de créditos otorgados, sus deudores y pagos.",
        usa:"Registra el crédito y al deudor, lleva el seguimiento de pagos, y genera el pagaré (o una serie de pagarés) desde el mismo crédito.",
        tip:"El pagaré admite hasta dos avales y se enumera con folio y serie."},
    ]},
    {titulo:"En toda la app", items:[
      {icon:"alert", color:"#B8932A", titulo:"Alertas (campana)",
        sirve:"AXIOR te saluda, te resume tu actividad reciente y te avisa de pendientes.",
        usa:"Abre la campana para ver el resumen y los avisos.",
        tip:"Revísala al entrar para no perder vencimientos importantes."},
      {icon:"scale_simple", color:"#236478", titulo:"Medidores de captura",
        sirve:"Indicadores visuales de cuánto llevas capturado en la plataforma (cada uno indica qué mide).",
        usa:"Míralos en la home; un porcentaje alto significa más casillas del expediente marcadas aquí, no que cumplas o dejes de cumplir la ley.",
        tip:"Úsalos como semáforo para priorizar."},
      {icon:"rocket", color:"#722F37", titulo:"AXIOR",
        sirve:"Tu asistente. Orienta sobre normatividad de México, emprendimiento en Aguascalientes y uso de la app.",
        usa:"Escríbele tu duda en lenguaje normal.",
        tip:"AXIOR orienta, no sustituye a un abogado; para asesoría formal acércate a AXIS."},
    ]},
  ];

  const linea = (label:string, txt:string) => (
    <div style={{marginTop:7}}>
      <div style={{fontSize:9.5, fontWeight:700, color:T_LIGHT.textInkMut, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>{label}</div>
      <div style={{fontSize:12, color:T_LIGHT.textInkSoft, lineHeight:1.5, marginTop:1}}>{txt}</div>
    </div>
  );

  return (
    <div style={{minHeight:"100vh", background:T_LIGHT.canvas, fontFamily:fontSans}}>
      <div style={{maxWidth:1000, margin:"0 auto", padding:isMobile?"20px 16px":"28px 32px"}}>
        <div style={{marginBottom:isMobile?16:24}}>
          <div style={{fontSize:isMobile?9:11, color:gold, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:isMobile?"1.5px":"2.5px", marginBottom:6}}>Ayuda / Manual</div>
          <h2 style={{fontFamily:fontSerif, fontSize:isMobile?20:30, color:T_LIGHT.textInk, margin:"0 0 4px", fontWeight:700, lineHeight:1.1}}>¿Cómo se usa AXIS Legaltech?</h2>
          <p style={{fontSize:13, color:T_LIGHT.textInkSoft, margin:0, lineHeight:1.6}}>Una guía corta por función. Cada tarjeta te dice para qué sirve, cómo se usa y un tip.</p>
        </div>

        {SECCIONES.map(sec => (
          <div key={sec.titulo} style={{marginBottom:isMobile?16:24}}>
            <div style={{display:"flex", alignItems:"center", gap:10, margin:isMobile?"2px 0 10px":"4px 0 14px"}}>
              <div style={{width:4, height:isMobile?15:18, background:gold, borderRadius:2, flexShrink:0}}/>
              <h3 style={{fontFamily:fontSerif, fontSize:isMobile?15:18, color:T_LIGHT.textInk, margin:0, fontWeight:700}}>{sec.titulo}</h3>
            </div>
            <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr":"repeat(2,1fr)", gap:isMobile?10:14}}>
              {sec.items.map(it => (
                <div key={it.titulo} style={{background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:14, padding:isMobile?"14px":"16px 18px", boxShadow:T_LIGHT.shadow, borderLeft:`3px solid ${it.color}`}}>
                  <div style={{display:"flex", alignItems:"center", gap:11, marginBottom:4}}>
                    <div style={{width:38, height:38, borderRadius:10, background:`${it.color}1A`, border:`1px solid ${it.color}40`, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0}}>
                      <AxisIcon name={it.icon} size={20} color={it.color} withBackdrop={false} strokeWidth={2.5}/>
                    </div>
                    <div style={{fontFamily:fontSerif, fontWeight:700, fontSize:isMobile?14:15, color:T_LIGHT.textInk}}>{it.titulo}</div>
                  </div>
                  {linea("Para qué sirve", it.sirve)}
                  {linea("Cómo se usa", it.usa)}
                  {linea("Tip", it.tip)}
                </div>
              ))}
            </div>
          </div>
        ))}

        {/* Bloque "¿No entiendes?" */}
        <div style={{background:"linear-gradient(135deg,#0F1E3D,#142340)", border:"1px solid rgba(184,147,42,0.28)", borderRadius:16, padding:isMobile?"20px 18px":"26px 28px", marginTop:isMobile?8:16, marginBottom:24}}>
          <h3 style={{fontFamily:fontSerif, fontSize:isMobile?17:20, color:"white", margin:"0 0 6px"}}>¿No te quedó claro cómo usar la app?</h3>
          <p style={{fontSize:13, color:"rgba(255,255,255,0.7)", margin:"0 0 16px", lineHeight:1.6}}>Te ayudamos: agenda una capacitación con AXIS o pregúntale a AXIOR ahora mismo.</p>
          <div style={{display:"flex", gap:10, flexWrap:"wrap" as const}}>
            <button onClick={()=>window.open("https://wa.me/524494251128?text=Hola%2C%20quiero%20capacitaci%C3%B3n%20sobre%20AXIS%20Legaltech","_blank")}
              style={{background:"linear-gradient(135deg,#D4A843,#B8932A)", border:"none", color:"#0B1829", fontWeight:800, padding:"11px 18px", borderRadius:10, cursor:"pointer", fontSize:13, fontFamily:fontSans, display:"inline-flex", alignItems:"center", gap:8}}>
              <AxisIcon name="briefcase" size={16} color="#0B1829" withBackdrop={false} strokeWidth={2.6}/> Capacitación con AXIS
            </button>
            <button onClick={()=>window.dispatchEvent(new CustomEvent("axior:abrir", {detail:{pregunta:"¿Cómo funciona la app?"}}))}
              style={{background:"transparent", border:"1.5px solid rgba(184,147,42,0.6)", color:"#E8C766", fontWeight:700, padding:"11px 18px", borderRadius:10, cursor:"pointer", fontSize:13, fontFamily:fontSans, display:"inline-flex", alignItems:"center", gap:8}}>
              <AxisIcon name="rocket" size={16} color="#E8C766" withBackdrop={false} strokeWidth={2.6}/> Pregúntale a AXIOR
            </button>
          </div>
        </div>
      </div>

      {/* Reusa el asistente AXIOR existente (igual que la pantalla de Diagnóstico).
         El botón de arriba lo abre con la pregunta precargada vía evento window. */}
      <AxiorChat fontSans={fontSans} fontSerif={fontSerif} gold={gold}/>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// CUENTAS DE TRABAJADOR — vista del PATRÓN (cualquier usuario autenticado).
// Registra y lista ÚNICAMENTE las cuentas cuyo empleadorId == su propio uid.
// La cuenta del trabajador se crea con una instancia SECUNDARIA de Firebase
// (para NO cerrar la sesión del patrón); el documento se escribe con la
// conexión PRIMARIA (db), donde el patrón sigue autenticado.
// El listado GLOBAL de solo lectura vive aparte, en el panel de super-admin.
// ─────────────────────────────────────────────────────────────────────────────
function CuentasTrabajadorPatron({user, fontSans, fontSerif, gold}: {user:any; fontSans:string; fontSerif:string; gold:string}) {
  const isMobile = window.innerWidth < 768;
  const [cuentas, setCuentas] = useState<any[]>([]);
  // La cuenta que se va a suspender, mientras se pregunta (ConfirmarSuspension).
  const [porSuspender, setPorSuspender] = useState<any>(null);
  const [suspendiendo, setSuspendiendo] = useState(false);
  const [nombre, setNombre] = useState("");
  const [correo, setCorreo] = useState("");
  const [generando, setGenerando] = useState(false);
  const [feedback, setFeedback] = useState<any|null>(null);
  // MISMO GUARDIÁN QUE LA PUERTA DE EMPLEADOS. Esta pantalla crea cuentas igual
  // que aquella, así que si aquí no se pregunta, la puerta sigue abierta.
  const [altaSinFicha, setAltaSinFicha] = useState<{correo:string; nombre:string; parecidas:{ficha:any; porque:string}[]}|null>(null);

  const cargar = async () => {
    if (!user?.uid) return;
    try {
      const snap = await getDocs(query(collection(db,"cuentas_trabajador"), where("empleadorId","==",user.uid)));
      setCuentas(snap.docs.map(d=>({id:d.id,...d.data()})).sort((a:any,b:any)=>(a.nombre||"").localeCompare(b.nombre||"")));
    } catch(e){ console.error(e); }
  };
  useEffect(() => { cargar(); /* eslint-disable-next-line */ }, [user?.uid]);

  // Crea la cuenta sin cerrar la sesión del patrón (instancia secundaria) y
  // escribe el doc con la conexión PRIMARIA (db).
  // PRIMERO SE MIRA A QUIÉN PERTENECE EL CORREO. Mismo orden que la puerta de
  // Empleados: si no pertenece a nadie, aquí no se crea nada y se levanta el
  // aviso. Cancelar no deja ni cuenta de Auth ni ficha a medias.
  const registrar = async () => {
    const mail = correo.trim().toLowerCase();
    const nom = nombre.trim();
    if (!mail || !nom || !user?.uid) return;
    setGenerando(true); setFeedback(null);
    let fichas: any[] = [];
    try {
      const snapT = await getDocs(query(collection(db,"trabajadores"), where("userId","==",user.uid)));
      fichas = snapT.docs.map(d=>({id:d.id, ...(d.data() as any)}));
    } catch(eT){
      console.warn("fichas para el cotejo del correo:", eT);
      setGenerando(false);
      setFeedback({tipo:"err", msg:"No se pudieron leer tus fichas de empleados, así que no se puede saber de quién es este correo. No se creó ninguna cuenta; intenta de nuevo."});
      return;
    }
    const existente = fichaDelCorreo(fichas, mail);
    if (!existente) {
      setGenerando(false);
      setAltaSinFicha({correo:mail, nombre:nom, parecidas: fichasParecidas({fichas, email:mail, nombre:nom})});
      return;
    }
    await crearCuentaYVincular(mail, nom, existente);
  };

  // `existente` en null significa que el patrón CONFIRMÓ que es alguien nuevo.
  const crearCuentaYVincular = async (mail:string, nom:string, existente:any|null) => {
    setGenerando(true); setFeedback(null);
    const chars = "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789";
    const len = 10 + Math.floor(Math.random()*3);
    let tempPass = "";
    for (let i=0;i<len;i++) tempPass += chars[Math.floor(Math.random()*chars.length)];
    try {
      const secondaryApp = getApps().find(a => a.name === "Secondary") || initializeApp(firebaseConfig, "Secondary");
      const secondaryAuth = getAuth(secondaryApp);
      const cred = await createUserWithEmailAndPassword(secondaryAuth, mail, tempPass);
      const workerUid = cred.user.uid;
      await signOut(secondaryAuth);
      await setDoc(doc(db, "cuentas_trabajador", mail), {
        email: mail,
        nombre: nom,
        empleadorId: user.uid,
        empleadorEmail: (user.email||"").toLowerCase(), // patrón legible sin buscar a futuro
        uid: workerUid,
        activo: true,
        creadoPor: user.uid,
        creadoEn: serverTimestamp(),
      });
      // (1) Su ficha en Empleados. Si el correo coincidía con una, se vincula; si
      // no coincidía con ninguna, se llega aquí solo después de que el patrón lo
      // haya confirmado, y entonces sí nace una ficha mínima con datosCompletos
      // en false para que complete el resto en Empleados.
      try {
        await comprobarCuentaSinOtraFicha(user.uid, workerUid, existente?.id || null);
        if (existente?.id) {
          await updateDoc(doc(db,"trabajadores",existente.id), { tieneAcceso:true, cuentaUid:workerUid });
        } else {
          await addDoc(collection(db,"trabajadores"), {
            userId: user.uid,
            nombre: nom,
            email: mail,
            puesto: "", departamento: "", tipoContrato: "indefinido",
            salarioDiario: 0, fechaIngreso: "", status: "activo", notas: "",
            tieneAcceso: true,
            cuentaUid: workerUid,
            datosCompletos: false,
            timestamp: Timestamp.now(),
          });
        }
      } catch(eT){ console.warn("No se pudo crear/actualizar la ficha en Empleados:", eT); }
      setAltaSinFicha(null);
      setFeedback({tipo:"ok", correo: mail, tempPass});
      setNombre(""); setCorreo("");
      cargar();
    } catch(e:any) {
      const msg = e?.code === "auth/email-already-in-use" ? MSG_CORREO_CON_CUENTA_PROPIA
        : e?.code === "auth/invalid-email" ? "El correo no tiene un formato válido."
        : e?.code === "auth/weak-password" ? "La contraseña generada no fue aceptada; intenta de nuevo."
        : ("No se pudo registrar la cuenta: " + (e?.code || e?.message || "error"));
      setAltaSinFicha(null);
      setFeedback({tipo:"err", msg});
    } finally { setGenerando(false); }
  };

  const toggleActivo = async (c:any) => {
    try {
      // EL VALOR EXPLÍCITO (ver activoAlAlternar): sin el campo, la cuenta está activa.
      const nuevo = activoAlAlternar(c);
      await updateDoc(doc(db,"cuentas_trabajador",c.id), {activo: nuevo});
      setCuentas(prev => prev.map(x => x.id===c.id ? {...x, activo: nuevo} : x));
    } catch(e){ console.error(e); alert("No se pudo actualizar el estado de la cuenta."); }
  };

  const disabled = generando || !nombre.trim() || !correo.trim();

  return (
    <div {...ZONA_DE_CAPTURA} style={{maxWidth:ANCHO_CONTENIDO, margin:"0 auto", padding:isMobile?"4px 0 40px":"8px 0 60px"}}>
      {altaSinFicha && (
        <ConfirmarCuentaSinFicha
          correo={altaSinFicha.correo} nombre={altaSinFicha.nombre} parecidas={altaSinFicha.parecidas}
          creando={generando} fontSans={fontSans} fontSerif={fontSerif}
          onCrearNueva={()=>{ const a = altaSinFicha; if (a) crearCuentaYVincular(a.correo, a.nombre, null); }}
          onCorregir={()=>setAltaSinFicha(null)}
          onUsarCorreo={(c:string)=>{ setCorreo(c); setAltaSinFicha(null); }}/>
      )}
      <div style={{marginBottom:18}}>
        <div style={{display:"flex", alignItems:"center", gap:10, marginBottom:4}}>
          <SidebarIcon name="cuentas_trab"/>
          <h1 style={{fontFamily:fontSerif, fontSize:isMobile?22:26, fontWeight:700, color:"#0B1829", margin:0}}>Cuentas de trabajador</h1>
        </div>
        <p style={{fontSize:13, color:"#4A4A60", margin:0, maxWidth:640}}>
          Crea cuentas para tus trabajadores y administra su acceso. Solo verás y gestionarás las cuentas que tú registras.
        </p>
      </div>

      {/* Registrar */}
      <div style={{background:"white", border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:12, padding:"16px 18px", borderLeft:"4px solid #236478", marginBottom:18}}>
        <div style={{fontSize:14, fontWeight:700, color:"#0B1829", marginBottom:3}}>Registrar cuenta de trabajador</div>
        <div style={{fontSize:12, color:"#9A9AAA", marginBottom:12}}>Crea la cuenta sin cerrar tu sesión. Al terminar verás una contraseña temporal para compartirla con el trabajador.</div>
        <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr":"1fr 1fr", gap:10, marginBottom:10}}>
          <input value={nombre} onChange={e=>setNombre(e.target.value)} placeholder="Nombre del trabajador"
            style={{width:"100%", padding:"10px 12px", border:"1px solid rgba(0,0,0,0.12)", borderRadius:8, fontSize:13, outline:"none", boxSizing:"border-box" as const, fontFamily:fontSans}}/>
          <input value={correo} onChange={e=>setCorreo(e.target.value)} type="email" placeholder="correo@ejemplo.com"
            style={{width:"100%", padding:"10px 12px", border:"1px solid rgba(0,0,0,0.12)", borderRadius:8, fontSize:13, outline:"none", boxSizing:"border-box" as const, fontFamily:fontSans}}/>
        </div>
        <button onClick={registrar} disabled={disabled}
          style={{background:disabled?"rgba(0,0,0,0.08)":"#236478", border:"none", color:disabled?"#9A9AAA":"white", borderRadius:8, padding:"9px 16px", cursor:disabled?"not-allowed":"pointer", fontSize:13, fontWeight:700, fontFamily:fontSans}}>
          {generando ? "Creando cuenta..." : "Registrar trabajador"}
        </button>
        {feedback?.tipo === "ok" && (
          <div style={{marginTop:12, background:"rgba(5,150,105,0.08)", border:"1px solid rgba(5,150,105,0.30)", borderRadius:10, padding:"12px 14px"}}>
            <div style={{fontSize:13, color:"#059669", fontWeight:700, marginBottom:6}}>Cuenta creada para {feedback.correo}</div>
            <div style={{fontSize:12, color:"#4A4A60", marginBottom:6}}>Comparte esta contraseña temporal con el trabajador:</div>
            <div style={{fontFamily:"monospace", fontSize:16, fontWeight:700, color:"#0B1829", background:"white", border:"1px dashed rgba(0,0,0,0.25)", borderRadius:8, padding:"8px 12px", letterSpacing:"1px", userSelect:"all" as const}}>{feedback.tempPass}</div>
            <div style={{fontSize:11, color:"#9A9AAA", marginTop:6}}>El trabajador puede cambiarla con "¿Olvidaste tu contraseña?" en la pantalla de inicio de sesión.</div>
          </div>
        )}
        {feedback?.tipo === "err" && (
          <ErrorAltaTrabajador msg={feedback.msg} correo={correo} fontSans={fontSans}
            style={{marginTop:12, background:"rgba(220,38,38,0.08)", border:"1px solid rgba(220,38,38,0.30)", borderRadius:10, padding:"10px 14px", fontSize:13, color:"#DC2626", fontWeight:600}}/>
        )}
      </div>

      {porSuspender && (
        <ConfirmarSuspension nombre={porSuspender.nombre || porSuspender.email} ocupado={suspendiendo} fontSans={fontSans}
          onCancelar={()=>setPorSuspender(null)}
          onSuspender={async ()=>{ setSuspendiendo(true); try { await toggleActivo(porSuspender); } finally { setSuspendiendo(false); setPorSuspender(null); } }} />
      )}
      {/* Listado de TUS trabajadores */}
      <div style={{fontSize:13, fontWeight:700, color:"#0B1829", marginBottom:4}}>Tus trabajadores</div>
      <div style={{fontSize:12, color:"#9A9AAA", marginBottom:12}}>{cuentas.length} cuenta{cuentas.length===1?"":"s"} registrada{cuentas.length===1?"":"s"}</div>
      <div style={{display:"flex", flexDirection:"column" as const, gap:10}}>
        {cuentas.map((c:any) => (
          <div key={c.id} style={{background:"white", border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:12, padding:"12px 16px", borderLeft:`4px solid ${c.activo===false?"#9A9AAA":"#236478"}`}}>
            <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap" as const, gap:6, marginBottom:4}}>
              <div style={{display:"flex", alignItems:"center", gap:8}}>
                <AxisIcon name="suite_empleados" size={14} tone="gold" withBackdrop={false} strokeWidth={3}/>
                <span style={{fontWeight:700, fontSize:14, color:"#0B1829"}}>{c.nombre || c.email}</span>
              </div>
              <div style={{display:"flex", alignItems:"center", gap:8}}>
                <span style={{fontSize:11, fontWeight:700, color:c.activo===false?"#B91C1C":"#059669"}}>{c.activo===false ? TEXTO_CUENTA_SUSPENDIDA : "Activa"}</span>
                <button onClick={()=>{ if (cuentaActiva(c)) setPorSuspender(c); else toggleActivo(c); }}
                  style={{fontSize:11, fontWeight:700, padding:"3px 10px", borderRadius:999, cursor:"pointer", border:`1px solid ${c.activo===false?"rgba(5,150,105,0.30)":"rgba(185,28,28,0.30)"}`, background:"white", color:c.activo===false?"#059669":"#B91C1C", fontFamily:fontSans}}>
                  {c.activo===false ? BOTON_REACTIVAR_CUENTA : BOTON_SUSPENDER_CUENTA}
                </button>
              </div>
            </div>
            <div style={{fontSize:11, color:"#4A4A60"}}>{c.email} · Creada: {c.creadoEn?.toDate?.().toLocaleDateString("es-MX") || "—"}</div>
          </div>
        ))}
        {cuentas.length === 0 && (<div style={{fontSize:13, color:"#4A4A60"}}>Aún no has registrado cuentas de trabajador.</div>)}
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// ACTIVIDADES — vista del PATRÓN. Crea/asigna actividades a sus cuentas de trabajador y
// CONFIRMA las que el trabajador marca como hechas (doble validación). Doc en
// `tareas` acotado por empleadorId == uid del patrón. Campos EXACTOS a las reglas
// publicadas: empleadorId, trabajadorEmail (minúsculas), trabajadorNombre, titulo,
// descripcion, fechaLimite, marcadaPorTrabajador, fechaMarcada, confirmadaPorPatron,
// fechaConfirmada, creadoEn. (confirmadaPorPatron SIEMPRE en false al crear.)
// ─────────────────────────────────────────────────────────────────────────────
function TareasPatron({user, foco, tareaInicialId, fontSans, fontSerif, gold}: {user:any; foco?:string;
  // LA ACTIVIDAD CONCRETA a la que se llegó desde el feed, POR SU ID. Es distinto
  // de `foco`: `foco` es un correo y significa "voy a asignarle algo a esta
  // persona", así que abre el formulario de asignar. Una fila del feed habla de
  // una actividad QUE YA EXISTE, y mandarla al formulario de alta era llevarla a
  // crear otra cosa. Aquí se señala la suya y no se abre ningún formulario.
  tareaInicialId?: string|null;
  fontSans:string; fontSerif:string; gold:string}) {
  const isMobile = window.innerWidth < 768;
  const [trabajadores, setTrabajadores] = useState<any[]>([]);
  const [tareas, setTareas] = useState<any[]>([]);
  const [cargando, setCargando] = useState(true);
  const [trabajadorEmail, setTrabajadorEmail] = useState("");
  const [titulo, setTitulo] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [fechaLimite, setFechaLimite] = useState("");
  const [guardando, setGuardando] = useState(false);
  const [feedback, setFeedback] = useState<any|null>(null);
  const [confirmandoId, setConfirmandoId] = useState<string|null>(null);
  // Filtros de la vista central (combinables, en JS). Empleado preseleccionado si
  // venimos de la ficha de un trabajador (foco).
  const [filtroEmp, setFiltroEmp] = useState<string>(()=> (foco||"").toLowerCase().trim());
  // Arranca en ABIERTAS: una actividad confirmada ya cumplió su función y su
  // lugar es el historial, no la bandeja diaria. Las actividades se acumulan sin
  // techo, así que esto acota la tabla sin necesidad de paginar.
  //
  // SALVO QUE SE VENGA A UNA ACTIVIDAD CONCRETA. Si el feed manda aquí por el id
  // de una actividad ya confirmada, "Abiertas" la deja fuera: se pulsa un hecho y
  // se aterriza en una lista de otra cosa, con la fila señalada en ninguna parte.
  // El filtro por defecto es una comodidad de la bandeja diaria y no puede
  // esconder el renglón que se pidió ver.
  const [filtroEstado, setFiltroEstado] = useState<"abiertas"|"todos"|"pendiente"|"por_confirmar"|"confirmada">(
    tareaInicialId ? "todos" : "abiertas");
  // Si llegamos desde la ficha de un empleado, el formulario abre directo con ese
  // trabajador ya puesto; si no, la pantalla arranca en la tabla.
  const [verFormAsignar, setVerFormAsignar] = useState<boolean>(()=> !!(foco||"").trim());
  const [busqAct, setBusqAct] = useState("");
  // Por defecto la tabla se ordena por DE QUIÉN ES EL TURNO, no por fecha: lo que
  // espera al patrón va primero. Ordenar por fecha dejaba las recién marcadas hasta
  // abajo —su límite vence después que el de las vencidas— y desaparecían de la
  // vista aunque estuvieran contadas arriba. El orden manual por columna sigue
  // disponible para quien lo quiera cambiar.
  const [ordenAct, setOrdenAct] = useState<"turno"|"limite"|"trabajador">("turno");
  const [dirAct, setDirAct] = useState<"asc"|"desc">("asc");
  // Por MES, que es la unidad en la que se revisa esto; la semana era demasiado
  // fina. El mismo control lista los meses anteriores para mirar un periodo
  // pasado sin agregar un segundo selector que compita con este.
  const [filtroFecha, setFiltroFecha] = useState<string>("todas");   // todas | vencidas | YYYY-MM

  const lbl = {display:"block", fontSize:11, fontWeight:600, color:"#4A4A60", marginBottom:4} as const;
  const inp = {width:"100%", padding:"10px 12px", border:"1px solid rgba(0,0,0,0.12)", borderRadius:8, fontSize:13, outline:"none", boxSizing:"border-box" as const, fontFamily:fontSans, background:"white", color:"#0B1829"};

  const cargar = async () => {
    if (!user?.uid) return;
    setCargando(true);
    try {
      const [snapCuentas, snapTar] = await Promise.all([
        // Fuente del desplegable: las CUENTAS de trabajador del patrón (registro
        // autoritativo). Así se llena siempre, aunque la ficha de Empleados no
        // tenga aún el flag tieneAcceso (cuentas creadas antes de esa función).
        getDocs(query(collection(db,"cuentas_trabajador"), where("empleadorId","==",user.uid))),
        getDocs(query(collection(db,"tareas"), where("empleadorId","==",user.uid))),
      ]);
      const trabs = snapCuentas.docs.map(d=>({id:d.id,...(d.data() as any)}))
        .filter((c:any)=>c.activo!==false)
        .sort((a:any,b:any)=>(a.nombre||"").localeCompare(b.nombre||""));
      setTrabajadores(trabs);
      const tars = snapTar.docs.map(d=>({id:d.id,...(d.data() as any)})).sort((a:any,b:any)=>{
        // orden en JS (sin orderBy): por fechaLimite, luego por creadoEn
        const fa = a.fechaLimite||"9999-99-99", fb = b.fechaLimite||"9999-99-99";
        if (fa!==fb) return fa.localeCompare(fb);
        return (a.creadoEn?.toMillis?.()||0) - (b.creadoEn?.toMillis?.()||0);
      });
      setTareas(tars);
    } catch(e){ console.error(e); }
    finally { setCargando(false); }
  };
  useEffect(() => { cargar(); /* eslint-disable-next-line */ }, [user?.uid]);

  const crear = async () => {
    const tit = titulo.trim();
    const correo = trabajadorEmail.trim().toLowerCase();
    if (!tit || !correo || !user?.uid) return;
    const trab = trabajadores.find((x:any)=>(x.email||"").toLowerCase()===correo);
    if (!trab) { setFeedback({tipo:"err", msg:"Selecciona un trabajador válido."}); return; }
    // Una actividad sin plazo es una instrucción sin término: no se puede medir su
    // cumplimiento ni reprocharlo. Misma regla que en el expediente.
    if (!fechaLimite) { setFeedback({tipo:"err", msg:"La fecha límite es obligatoria (define el mes de cumplimiento)."}); return; }
    setGuardando(true); setFeedback(null);
    try {
      // Campos EXACTOS del create según el plan (sin fechaMarcada/fechaConfirmada:
      // esos se agregan luego con los updates de marcar/confirmar).
      await addDoc(collection(db,"tareas"), {
        empleadorId: user.uid,
        trabajadorEmail: correo,
        trabajadorNombre: trab.nombre || trab.email || "",
        titulo: tit,
        descripcion: descripcion.trim(),
        fechaLimite,
        marcadaPorTrabajador: false,
        confirmadaPorPatron: false,
        creadoEn: serverTimestamp(),
      });
      setTitulo(""); setDescripcion(""); setFechaLimite("");
      setVerFormAsignar(false);   // guardado: se cierra y se ve el resultado en la tabla
      setFeedback({tipo:"ok", msg:"Actividad asignada a "+(trab.nombre||trab.email)+"."});
      cargar();
    } catch(e:any) {
      console.error("asignar actividad:", e);
      setFeedback({tipo:"err", msg: mensajeDeFallo(e, {accion:"guardar la actividad", denegado: denegadoPatron("asignarle actividades a este trabajador")})});
    } finally { setGuardando(false); }
  };

  // Solo el patrón confirma: marca confirmadaPorPatron=true + fechaConfirmada.
  const confirmar = async (tarea:any) => {
    setConfirmandoId(tarea.id);
    try {
      await updateDoc(doc(db,"tareas",tarea.id), { confirmadaPorPatron:true, fechaConfirmada:serverTimestamp() });
      setTareas(prev=>prev.map(x=>x.id===tarea.id?{...x, confirmadaPorPatron:true}:x));
    } catch(e){ console.error(e); alert("No se pudo confirmar la actividad."); }
    finally { setConfirmandoId(null); }
  };

  const estadoDe = (t:any) => t.confirmadaPorPatron ? "Confirmada" : (t.marcadaPorTrabajador ? "Por confirmar" : "Pendiente");
  // VENCIDA es un estado DERIVADO, no una bandera: hay fecha límite, ya pasó y no
  // se ha confirmado. Sin fecha límite NO es vencida —es abierta—: la ausencia de
  // dato no se cuenta como incumplimiento.
  const estaVencida = (t:any) => !!t.fechaLimite && t.fechaLimite < new Date().toISOString().slice(0,10) && !t.confirmadaPorPatron;
  const esAbierta = (t:any) => !t.confirmadaPorPatron;

  // Centro de mando (lista filtrable): combina empleado + estado + fecha en JS,
  // sobre las actividades ya cargadas (sin índices ni múltiples where). `tareas` ya
  // viene ordenado por fechaLimite.
  const hoyStr = new Date().toISOString().slice(0,10);
  // Doce meses hacia atrás desde el actual, para revisar periodos pasados.
  const MESES_FILTRO = (()=>{ const out:{v:string; t:string}[] = []; const d = new Date();
    for (let i=0;i<12;i++){ const m = new Date(d.getFullYear(), d.getMonth()-i, 1);
      const v = `${m.getFullYear()}-${String(m.getMonth()+1).padStart(2,"0")}`;
      out.push({v, t: i===0 ? "Este mes" : m.toLocaleDateString("es-MX",{month:"long",year:"numeric"})}); }
    return out; })();
  const _bqAct = busqAct.trim().toLowerCase();
  // Se señala la actividad a la que se llegó, dentro de la lista completa. Si el
  // id ya no corresponde a ninguna —la borraron entre que se pintó la fila y se
  // pulsó— no se señala nada y la lista se ve como siempre.
  const _resTarea = useResaltado(tareaInicialId, tareas);
  const tareasFiltradas = tareas.filter((t:any)=>{
    if (filtroEmp && (t.trabajadorEmail||"").toLowerCase()!==filtroEmp) return false;
    if (_bqAct && !((t.titulo||"").toLowerCase().includes(_bqAct)
                 || (t.descripcion||"").toLowerCase().includes(_bqAct)
                 || (t.trabajadorNombre||"").toLowerCase().includes(_bqAct)
                 || (t.trabajadorEmail||"").toLowerCase().includes(_bqAct))) return false;
    if (filtroEstado!=="todos") {
      const e = estadoDe(t);
      if (filtroEstado==="abiertas"      && !esAbierta(t))         return false;
      if (filtroEstado==="pendiente"     && e!=="Pendiente")     return false;
      if (filtroEstado==="por_confirmar" && e!=="Por confirmar") return false;
      if (filtroEstado==="confirmada"    && e!=="Confirmada")    return false;
    }
    if (filtroFecha==="vencidas") { if (!estaVencida(t)) return false; }
    else if (filtroFecha!=="todas") { if ((t.fechaLimite||"").slice(0,7)!==filtroFecha) return false; }
    return true;
  }).slice().sort((a:any,b:any)=>{
    // Orden por TURNO: primero lo que espera al patrón, luego lo vencido, luego lo
    // pendiente y al final lo ya confirmado. Dentro de cada grupo, por fecha límite.
    if (ordenAct==="turno") {
      const rango = (t:any)=> t.confirmadaPorPatron ? 3
        : (t.marcadaPorTrabajador ? 0 : (estaVencida(t) ? 1 : 2));
      const r = rango(a) - rango(b); if (r!==0) return r;
      const fa=a.fechaLimite||"", fb=b.fechaLimite||"";
      if (!fa && !fb) return 0; if (!fa) return 1; if (!fb) return -1;
      return fa.localeCompare(fb);
    }
    const dir = dirAct==="asc" ? 1 : -1;
    if (ordenAct==="trabajador") return (a.trabajadorNombre||a.trabajadorEmail||"").localeCompare((b.trabajadorNombre||b.trabajadorEmail||""), "es") * dir;
    // Sin fecha límite al final siempre: no se finge un dato que no existe.
    const fa=a.fechaLimite||"", fb=b.fechaLimite||"";
    if (!fa && !fb) return 0; if (!fa) return 1; if (!fb) return -1;
    return fa.localeCompare(fb) * dir;
  });

  // INDICADORES: cuentan sobre TODAS las actividades cargadas, nunca sobre las
  // visibles. Si algún día se limita la consulta, hay que revisarlos aquí.
  const _mesAct = new Date().toISOString().slice(0,7);
  const nAbiertas = tareas.filter(esAbierta).length;
  const nVencidas = tareas.filter(estaVencida).length;
  const nPorConfirmar = tareas.filter((t:any)=> !t.confirmadaPorPatron && t.marcadaPorTrabajador).length;
  const nCumplidasMes = tareas.filter((t:any)=>{
    if (!t.confirmadaPorPatron) return false;
    const f = t.fechaConfirmada?.toDate?.();
    return !!f && f.toISOString().slice(0,7)===_mesAct;
  }).length;
  const _sinFechaConf = tareas.filter((t:any)=> t.confirmadaPorPatron && !t.fechaConfirmada?.toDate?.()).length;


  return (
    <div style={{maxWidth:ANCHO_CONTENIDO, margin:"0 auto", padding:isMobile?"4px 0 40px":"8px 0 60px"}}>
      <div style={{marginBottom:18}}>
        <div style={{display:"flex", alignItems:"center", gap:10, marginBottom:4}}>
          <SidebarIcon name="tareas"/>
          <h1 style={{fontFamily:fontSerif, fontSize:isMobile?22:26, fontWeight:700, color:"#0B1829", margin:0}}>Actividades</h1>
        </div>
        <p style={{fontSize:13, color:"#4A4A60", margin:0, maxWidth:640}}>
          Asigna actividades a tus trabajadores y confirma las que marquen como hechas.
        </p>
      </div>

      {!cargando && trabajadores.length === 0 ? (
        <div style={{background:"white", border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:12, padding:"20px 22px", borderLeft:"4px solid #B8932A"}}>
          <div style={{fontSize:14, fontWeight:700, color:"#0B1829", marginBottom:6}}>Primero registra a tus trabajadores</div>
          <div style={{fontSize:13, color:"#4A4A60"}}>Para asignar actividades necesitas al menos una cuenta de trabajador activa. Ve a la sección <strong>"Cuentas de trabajador"</strong> y registra a tu equipo.</div>
        </div>
      ) : (
      <>
      {/* ASIGNAR — un formulario no es una acción pendiente sino una herramienta
          que se usa de vez en cuando, así que no ocupa la pantalla: vive detrás
          del botón primario. El uso diario aquí es revisar y confirmar. */}
      <div style={{display:"flex", justifyContent:"flex-end", marginBottom:14}}>
        <BotonPrimario texto="+ Asignar actividad" fontSans={fontSans} onClick={()=>{ setFeedback(null); setVerFormAsignar(true); }}/>
      </div>
      {verFormAsignar && (
      <div style={{position:"fixed" as const, inset:0, zIndex:3000, background:"rgba(11,24,41,0.55)", display:"flex", alignItems:"flex-start", justifyContent:"center", padding:"6vh 16px 20px", overflowY:"auto" as const}}>
      <div {...PANEL_DE_CAPTURA} onClick={e=>e.stopPropagation()} style={{width:"100%", maxWidth:560, background:UI.superficie, borderRadius:UI.rPanel, boxShadow:"0 24px 70px rgba(0,0,0,0.35)", overflow:"hidden"}}>
        <div style={{background:UI.navy, padding:"13px 18px", display:"flex", alignItems:"center", justifyContent:"space-between", gap:12}}>
          <span style={{fontFamily:fontSerif, fontSize:15, fontWeight:700, color:"#FFFFFF"}}>Asignar actividad</span>
          <button onClick={(ev)=>{ if (sePuedeCerrarElPanel(ev)) setVerFormAsignar(false); }} aria-label="Cerrar" style={{background:"transparent", border:"none", color:"rgba(255,255,255,0.75)", cursor:"pointer", fontSize:20, lineHeight:1}}>×</button>
        </div>
        <div style={{padding:"16px 18px 18px"}}>
        <div style={{fontSize:14, fontWeight:700, color:"#0B1829", marginBottom:12}}>Asignar nueva actividad</div>
        <div style={{display:"grid", gridTemplateColumns:isMobile?"1fr":"1fr 1fr", gap:10, marginBottom:10}}>
          <div>
            <label style={lbl}>Trabajador</label>
            <select value={trabajadorEmail} onChange={e=>setTrabajadorEmail(e.target.value)} style={{...inp}}>
              <option value="">Selecciona…</option>
              {trabajadores.map((t:any)=>(<option key={t.id} value={(t.email||"").toLowerCase()}>{t.nombre||t.email}</option>))}
            </select>
          </div>
          <div>
            <label style={lbl}>Título de la actividad</label>
            <input value={titulo} onChange={e=>setTitulo(e.target.value)} placeholder="Ej. Entregar reporte mensual" style={inp}/>
          </div>
        </div>
        <div style={{marginBottom:10}}>
          <label style={lbl}>Descripción (opcional)</label>
          <textarea value={descripcion} onChange={e=>setDescripcion(e.target.value)} rows={3} placeholder="Detalles de la actividad…" style={{...inp, resize:"vertical" as const, minHeight:64}}/>
        </div>
        <div style={{marginBottom:12, maxWidth:isMobile?"100%":"50%"}}>
          <label style={lbl}>Fecha límite</label>
          <input type="date" value={fechaLimite} onChange={e=>setFechaLimite(e.target.value)} style={inp}/>
          <div style={{fontSize:11, color:UI.textoTenue, marginTop:4}}>La <strong>fecha límite</strong> es obligatoria: define el mes en que se mide el cumplimiento.</div>
        </div>
        <button onClick={crear} disabled={guardando || !titulo.trim() || !trabajadorEmail || !fechaLimite}
          style={{background:(guardando||!titulo.trim()||!trabajadorEmail||!fechaLimite)?"rgba(0,0,0,0.08)":"#236478", border:"none", color:(guardando||!titulo.trim()||!trabajadorEmail||!fechaLimite)?"#9A9AAA":"white", borderRadius:8, padding:"9px 16px", cursor:(guardando||!titulo.trim()||!trabajadorEmail||!fechaLimite)?"not-allowed":"pointer", fontSize:13, fontWeight:700, fontFamily:fontSans}}>
          {guardando ? "Guardando…" : "Asignar actividad"}
        </button>
        {feedback?.tipo==="ok" && (<div style={{marginTop:12, background:"rgba(5,150,105,0.08)", border:"1px solid rgba(5,150,105,0.30)", borderRadius:10, padding:"10px 14px", fontSize:13, color:"#059669", fontWeight:600}}>{feedback.msg}</div>)}
        {feedback?.tipo==="err" && (<div style={{marginTop:12, background:"rgba(220,38,38,0.08)", border:"1px solid rgba(220,38,38,0.30)", borderRadius:10, padding:"10px 14px", fontSize:13, color:"#DC2626", fontWeight:600}}>{feedback.msg}</div>)}
      </div>
        </div>
      </div>
      )}

      {/* Centro de mando: indicadores + filtros + tabla de TODAS las actividades */}
      {cargando ? (
        <div style={{textAlign:"center" as const, padding:60, color:UI.textoSuave, background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rPanel}}>Cargando…</div>
      ) : (
        <>
          {/* ── INDICADORES ── cuentan sobre TODAS las actividades, no sobre las
               visibles: filtrar no debe hacer que los números bajen en silencio. */}
          <div style={{display:"grid", gridTemplateColumns:isMobile?"repeat(2,1fr)":"repeat(4,1fr)", gap:12, marginBottom:18}}>
            <IndicadorTarjeta isMobile={isMobile} fontSerif={fontSerif}
              etiqueta="Abiertas" valor={tareas.length===0 ? "Sin registrar" : String(nAbiertas)}
              icono="clipboard" tono={UI.navy}
              micro={tareas.length===0 ? "aún no asignas actividades"
                   : nAbiertas===0 ? "todas confirmadas" : `de ${tareas.length} asignada${tareas.length===1?"":"s"}`}/>
            <IndicadorTarjeta isMobile={isMobile} fontSerif={fontSerif}
              etiqueta="Vencidas" valor={tareas.length===0 ? "Sin registrar" : String(nVencidas)}
              icono="alert" tono={nVencidas>0 ? UI.rojo : UI.ok}
              micro={nVencidas>0 ? "pasó su fecha límite sin confirmar" : "ninguna fuera de fecha"}/>
            {/* El que convierte la pantalla en bandeja de trabajo. */}
            <IndicadorTarjeta isMobile={isMobile} fontSerif={fontSerif}
              etiqueta="Esperan mi confirmación" valor={tareas.length===0 ? "Sin registrar" : String(nPorConfirmar)}
              icono="check" tono={nPorConfirmar>0 ? UI.ambar : UI.ok}
              micro={nPorConfirmar>0 ? "el trabajador ya las marcó como hechas" : "nada por revisar"}/>
            <IndicadorTarjeta isMobile={isMobile} fontSerif={fontSerif}
              etiqueta="Cumplidas este mes" valor={tareas.length===0 ? "Sin registrar" : String(nCumplidasMes)}
              icono="suite_calendario" tono={UI.navy}
              micro={_sinFechaConf>0 ? `${_sinFechaConf} confirmada${_sinFechaConf===1?"":"s"} sin fecha registrada`
                   : nCumplidasMes>0 ? "confirmadas por ti en el mes en curso" : "ninguna confirmada este mes"}/>
          </div>

          {/* FILTRA (no navega): segmentado por estado + selector por trabajador */}
          <div style={{display:"flex", gap:10, marginBottom:14, flexWrap:"wrap" as const, alignItems:"center"}}>
            <input {...CAMPO_DE_PARAMETRO} value={busqAct} onChange={e=>setBusqAct(e.target.value)} placeholder="Buscar por actividad o trabajador…"
              style={{flex:1, minWidth:220, background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rControl,
                padding:"9px 13px", color:UI.texto, fontSize:UI.fsCuerpo, outline:"none", fontFamily:fontSans, boxSizing:"border-box" as const}} />
            <SegmentadoFiltro fontSans={fontSans} valor={filtroEstado} onCambio={(v)=>setFiltroEstado(v)}
              opciones={[
                {v:"abiertas" as const, t:"Abiertas"},
                {v:"por_confirmar" as const, t:"Por confirmar"},
                {v:"confirmada" as const, t:"Confirmadas"},
                {v:"todos" as const, t:"Todas"},
              ]}/>
            {trabajadores.length>0 && (
              <select {...CAMPO_DE_PARAMETRO} value={filtroEmp} onChange={e=>setFiltroEmp(e.target.value)} title="Filtrar por trabajador"
                style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rControl, padding:"8px 12px",
                  fontSize:UI.fsEtiqueta, color:filtroEmp?UI.texto:UI.textoTenue, fontWeight:filtroEmp?700:600, fontFamily:fontSans, cursor:"pointer", outline:"none"}}>
                <option value="">Todos los trabajadores</option>
                {trabajadores.map((t:any)=>(<option key={t.id} value={(t.email||"").toLowerCase()}>{t.nombre||t.email}</option>))}
              </select>
            )}
            <select {...CAMPO_DE_PARAMETRO} value={filtroFecha} onChange={e=>setFiltroFecha(e.target.value as any)} title="Filtrar por vencimiento"
              style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rControl, padding:"8px 12px",
                fontSize:UI.fsEtiqueta, color:filtroFecha!=="todas"?UI.texto:UI.textoTenue, fontWeight:filtroFecha!=="todas"?700:600, fontFamily:fontSans, cursor:"pointer", outline:"none"}}>
              <option value="todas">Cualquier fecha</option>
              <option value="vencidas">Vencidas</option>
              {MESES_FILTRO.map(m=>(<option key={m.v} value={m.v}>{m.t}</option>))}
            </select>
          </div>

          {tareasFiltradas.length===0 ? (
            <EstadoVacio
              titulo={tareas.length===0 ? "Aún no hay actividades asignadas" : "Ninguna actividad coincide"}
              texto={tareas.length===0
                ? "Asigna actividades a tus trabajadores desde el formulario de arriba. Cuando el trabajador la marque como hecha, aparecerá aquí esperando tu confirmación: esa doble validación es la que deja constancia de que se cumplió."
                : "Prueba con otro texto de búsqueda o cambia los filtros. Recuerda que por omisión solo se muestran las actividades abiertas."}
              acciones={tareas.length===0 ? [] : [{t:"Quitar filtros", principal:false, fn:()=>{ setBusqAct(""); setFiltroEmp(""); setFiltroEstado("abiertas"); setFiltroFecha("todas"); }}]}
              icono="clipboard"
              variante={tareas.length===0 ? "sin-datos" : "sin-coincidencias"}
              fontSans={fontSans} fontSerif={fontSerif}
            />
          ) : (
            <div style={{background:UI.superficie, border:`1px solid ${UI.borde}`, borderRadius:UI.rPanel, boxShadow:UI.sombra, overflow:"hidden"}}>
              <div style={{height:2, background:`linear-gradient(90deg, ${UI.oro}, ${UI.oro}00)`}}/>
              <div style={{maxHeight:`calc(100vh - 460px - ${ZOCALO_FLOTANTES}px)`, minHeight:220, overflowY:"auto" as const}}>
                <table style={{width:"100%", borderCollapse:"separate" as const, borderSpacing:0}}>
                  <EncabezadoTabla ordenCol={ordenAct} ordenDir={dirAct}
                    onOrdenar={(col,dir)=>{ setOrdenAct(col as any); setDirAct(dir); }}
                    columnas={[
                      {k:"actividad", t:"Actividad", orden:false, al:"left"},
                      {k:"trabajador", t:"Trabajador", orden:true, al:"left"},
                      {k:"limite", t:"Fecha límite", orden:true, al:"left"},
                      {k:"estado", t:"Estado", orden:false, al:"left"},
                      {k:"acc", t:"", orden:false, al:"right"},
                    ]}/>
                  <tbody>
                    {tareasFiltradas.map((t:any)=>{
                      const estado = estadoDe(t);
                      const vencida = estaVencida(t);
                      const tdA:any = {padding:"11px 14px", borderTop:`1px solid ${UI.divisor}`, fontSize:UI.fsCuerpo, color:UI.textoSuave, verticalAlign:"top"};
                      const fMarcada = t.fechaMarcada?.toDate?.();
                      const fConfirmada = t.fechaConfirmada?.toDate?.();
                      const fCorta = (d:any)=> d ? d.toLocaleDateString("es-MX",{day:"2-digit",month:"short",year:"numeric"}) : "";
                      const senalada = !!tareaInicialId && t.id === tareaInicialId;
                      return (
                        <tr key={t.id}
                          ref={senalada ? _resTarea.ref : undefined}
                          onMouseEnter={(e)=>{ e.currentTarget.style.background = UI.hover; }}
                          onMouseLeave={(e)=>{ e.currentTarget.style.background = "transparent"; }}
                          style={estiloResaltado(senalada && _resTarea.vivo, "fila")}>
                          {/* Actividad */}
                          <td style={{...tdA, minWidth:220}}>
                            <div style={{fontFamily:fontSerif, fontSize:UI.fsNombre, fontWeight:700, color:UI.texto}}>{t.titulo}</div>
                            {t.descripcion && <div style={{fontSize:UI.fsEtiqueta, color:UI.textoTenue, marginTop:2, lineHeight:1.4, whiteSpace:"pre-wrap" as const}}>{t.descripcion}</div>}
                          </td>
                          {/* Trabajador */}
                          <td style={{...tdA, verticalAlign:"middle"}}>
                            <div style={{display:"flex", alignItems:"center", gap:10, minWidth:0}}>
                              <AvatarPersona nombre={t.trabajadorNombre||t.trabajadorEmail||""} size={30} fontSerif={fontSerif}/>
                              <span style={{fontSize:UI.fsCuerpo, color:UI.texto, whiteSpace:"nowrap" as const, overflow:"hidden", textOverflow:"ellipsis"}}>{t.trabajadorNombre||t.trabajadorEmail||"—"}</span>
                            </div>
                          </td>
                          {/* Fecha límite — sin fecha NO es incumplimiento, es abierta */}
                          <td style={{...tdA, whiteSpace:"nowrap" as const}}>
                            {t.fechaLimite
                              ? <span style={{color: vencida ? UI.rojo : UI.textoSuave, fontWeight: vencida ? 700 : 400}}>{t.fechaLimite}</span>
                              : <span style={{color:UI.textoTenue}}>Sin fecha límite</span>}
                          </td>
                          {/* Estado — la doble validación, con SUS FECHAS: son las que
                              dan valor probatorio al registro. */}
                          <td style={{...tdA, minWidth:250}}>
                            {estado==="Confirmada" ? (
                              <>
                                <ChipEstado texto="✓ Confirmada" tono="ok"/>
                                {/* No es lo mismo un reconocimiento de ambas partes que
                                    el dicho unilateral del patrón. Se enuncia como hecho. */}
                                {t.marcadaPorTrabajador
                                  ? <div style={{fontSize:UI.fsEtiqueta, color:UI.textoTenue, marginTop:4, lineHeight:1.45}}>
                                      Marcada por el trabajador{fMarcada ? ` el ${fCorta(fMarcada)}` : ""} · confirmada por ti{fConfirmada ? ` el ${fCorta(fConfirmada)}` : ""}
                                    </div>
                                  : <div style={{fontSize:UI.fsEtiqueta, color:UI.textoTenue, marginTop:4, lineHeight:1.45}}>
                                      Confirmada por ti{fConfirmada ? ` el ${fCorta(fConfirmada)}` : ""}, sin marca del trabajador
                                    </div>}
                              </>
                            ) : estado==="Por confirmar" ? (
                              <>
                                <ChipEstado texto="Esperando tu confirmación" tono="pendiente"/>
                                <div style={{fontSize:UI.fsEtiqueta, color:UI.textoTenue, marginTop:4, lineHeight:1.45}}>
                                  El trabajador la marcó como hecha{fMarcada ? ` el ${fCorta(fMarcada)}` : ""}
                                </div>
                              </>
                            ) : vencida ? (
                              <>
                                <ChipEstado texto="⚠ Vencida" tono="critico"/>
                                <div style={{fontSize:UI.fsEtiqueta, color:UI.textoTenue, marginTop:4, lineHeight:1.45}}>Pasó su fecha límite y el trabajador aún no la marca</div>
                              </>
                            ) : (
                              <>
                                <ChipEstado texto="Pendiente" tono="neutro"/>
                                <div style={{fontSize:UI.fsEtiqueta, color:UI.textoTenue, marginTop:4, lineHeight:1.45}}>Asignada; el trabajador aún no la marca</div>
                              </>
                            )}
                          </td>
                          {/* Acción única: confirmar, y solo cuando toca */}
                          <td style={{...tdA, textAlign:"right" as const, whiteSpace:"nowrap" as const, verticalAlign:"middle"}}>
                            {estado==="Por confirmar" ? (
                              <button onClick={()=>confirmar(t)} disabled={confirmandoId===t.id}
                                style={{background:"transparent", border:"none", cursor:confirmandoId===t.id?"wait":"pointer", fontFamily:fontSans,
                                  fontSize:UI.fsEtiqueta, fontWeight:700, color:UI.navy, padding:"2px 0"}}>
                                {confirmandoId===t.id ? "Confirmando…" : "Confirmar ›"}
                              </button>
                            ) : estado==="Confirmada" ? null : (
                              // Confirmada: no queda nada por hacer, celda vacía.
                              // Pendiente o vencida: el siguiente paso es del
                              // trabajador, y decirlo evita que parezca un hueco.
                              <span style={{fontSize:UI.fsEtiqueta, color:UI.textoTenue}}>Espera al trabajador</span>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <div style={{padding:"9px 14px", borderTop:`1px solid ${UI.divisor}`, fontSize:10.5, color:UI.textoTenue, background:UI.superficie}}>
                Mostrando {tareasFiltradas.length} de {tareas.length} actividad{tareas.length===1?"":"es"}
                {filtroEstado==="abiertas" && tareas.some((t:any)=>t.confirmadaPorPatron) ? " · las confirmadas se ven con el filtro “Confirmadas”" : ""}
              </div>
            </div>
          )}
        </>
      )}
      </>
      )}
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// ── Clasificación de asistencia (Ladrillo 2B) — solo entrada; salida sin clasificar ──
// LA TOLERANCIA QUE ENSEÑA EL FORMULARIO ES LA QUE USA EL CÁLCULO. Sin el campo,
// la clasificación usa 0 (`Math.max(0, Number(x)||0)`), y el formulario
// enseñaba 10: un número que no regía y que, al guardar cualquier otro cambio del
// horario, se escribía como si el patrón lo hubiera elegido. Ahora enseña el
// mismo número que usa la clasificación y, sin el campo, lo dice.
function toleranciaDelFormulario(h:any): {valor:string; sinConfigurar:boolean} {
  const v = h?.toleranciaMin;
  if (v === undefined || v === null || v === "") return {valor:"0", sinConfigurar:true};
  return {valor:String(Math.max(0, Number(v)||0)), sinConfigurar:false};
}
// EL UMBRAL DE FALTA, CON SU 0. `Number(x)||30` convertía un 0 guardado en 30: el
// patrón que decidió "sin margen entre retardo y entrada tardía" veía su horario
// leído con media hora. El valor por omisión (30) es SOLO para el campo que no
// existe (o que no es un número); cualquier número válido se respeta.
function umbralFaltaDe(h:any): number {
  const v = h?.umbralFaltaMin;
  if (v === undefined || v === null || v === "") return 30;
  const n = Number(v);
  return isFinite(n) ? Math.max(0, n) : 30;
}
// Compara la hora de la marca contra el horario que le toca —el que REGÍA en ese
// momento, ya resuelto (horarioQueRegia)—. Defensivo: sin horario o sin hora →
// "sin_horario" (no truena).
// `cuando` es el INSTANTE REAL, el del servidor, y su hora se lee EN MÉXICO
// (enHoraDeMexico), no en la zona del navegador que abre la pantalla.
function clasificarEntrada(he:any, cuando:Date): "a_tiempo"|"retardo"|"falta"|"sin_horario" {
  if (!he || !he.entrada || !cuando) return "sin_horario";
  const parts = String(he.entrada).split(":"); const hh=parseInt(parts[0],10), mm=parseInt(parts[1],10);
  if (isNaN(hh)||isNaN(mm)) return "sin_horario";
  const entradaMin = hh*60+mm;
  const tol = Math.max(0, Number(he.toleranciaMin)||0);
  const umbral = umbralFaltaDe(he);
  const mx = enHoraDeMexico(cuando);
  if (!mx) return "sin_horario";
  const marcaMin = mx.getHours()*60 + mx.getMinutes();
  const diff = marcaMin - entradaMin;               // minutos de retraso (negativo = llegó antes)
  if (diff <= tol) return "a_tiempo";
  if (diff < tol + umbral) return "retardo";
  return "falta";
}
// ── Biometría del dispositivo (WebAuthn) — Ladrillo 2C-3 ──────────────────────
// Confirma que es el dueño del dispositivo (huella/Face ID); NO identifica quién es.
// El dato biométrico NUNCA sale del teléfono; solo se guarda el credentialId público.
// Todo es defensivo: si no hay soporte / se cancela / falla, no truena.
// NUNCA BLOQUEA, Y SIEMPRE DICE POR QUÉ: los motivos, los navegadores internos,
// la etiqueta que ve el patrón y la regla de "Restablecer biometría" viven en
// `src/logica/biometria.js` (sin React ni Firebase, probados aparte).
import { MOTIVOS as MOTIVOS_BIO, detectarNavegadorInterno, etiquetaBiometria, motivoSinVerificacion, llaveAnteriorAlRestablecimiento } from "./logica/biometria";
const _bioClave = (uid:string)=> `axis_bio_cred:${uid||""}`;
function _b64urlFromBuf(buf:ArrayBuffer){ const b=new Uint8Array(buf); let s=""; for (let i=0;i<b.length;i++) s+=String.fromCharCode(b[i]); return btoa(s).replace(/\+/g,"-").replace(/\//g,"_").replace(/=+$/,""); }
function _bufFromB64url(str:string){ const s=str.replace(/-/g,"+").replace(/_/g,"/"); const pad=s.length%4?"=".repeat(4-s.length%4):""; const bin=atob(s+pad); const b=new Uint8Array(bin.length); for (let i=0;i<bin.length;i++) b[i]=bin.charCodeAt(i); return b.buffer; }
async function bioDisponible(): Promise<boolean> {
  try { if (typeof window==="undefined" || !(window as any).PublicKeyCredential) return false;
    return await (window as any).PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable(); } catch { return false; }
}
function bioEnrolada(uid:string): boolean { try { return !!localStorage.getItem(_bioClave(uid)); } catch { return false; } }
// Enrola (create): devuelve el credentialId o lanza. Guarda en localStorage (device).
async function bioEnrolar(user:any): Promise<string> {
  if (!(window as any).PublicKeyCredential) throw new Error("no_soporte");
  const challenge = crypto.getRandomValues(new Uint8Array(32));
  const userId = new TextEncoder().encode(String(user?.uid||"axis-user")).buffer;
  const cred:any = await navigator.credentials.create({ publicKey: {
    challenge,
    rp: { name: "AXIS Legaltech", id: window.location.hostname },
    user: { id: userId, name: (user?.email||user?.uid||"trabajador"), displayName: (user?.email||"Trabajador") },
    pubKeyCredParams: [{type:"public-key", alg:-7}, {type:"public-key", alg:-257}],
    authenticatorSelection: { authenticatorAttachment:"platform", userVerification:"required", residentKey:"preferred" },
    timeout: 60000, attestation: "none",
  }});
  if (!cred) throw new Error("cancelado");
  const id = _b64urlFromBuf(cred.rawId);
  try { localStorage.setItem(_bioClave(user?.uid), id); } catch {}
  // CUÁNDO SE CREÓ ESTA LLAVE. Es lo que se compara con "Restablecer biometría"
  // del patrón: si él restableció después, esta llave se olvida.
  try { localStorage.setItem(_bioFechaClave(user?.uid), String(Date.now())); } catch {}
  return id;
}
const _bioFechaClave = (uid:string)=> `axis_bio_cred_en:${uid||""}`;
function bioFechaLlave(uid:string): number { try { return Number(localStorage.getItem(_bioFechaClave(uid))) || 0; } catch { return 0; } }
// Olvida la llave de ESTE teléfono (no toca la del gestor de contraseñas): la
// siguiente checada registrará una nueva con el bloqueo del propio teléfono.
function bioOlvidar(uid:string): void {
  try { localStorage.removeItem(_bioClave(uid)); } catch {}
  try { localStorage.removeItem(_bioFechaClave(uid)); } catch {}
}
// Verifica (get): true si el usuario pasó la biometría del dispositivo.
async function bioVerificar(user:any): Promise<boolean> {
  if (!(window as any).PublicKeyCredential) return false;
  let id:string|null = null; try { id = localStorage.getItem(_bioClave(user?.uid)); } catch {}
  const challenge = crypto.getRandomValues(new Uint8Array(32));
  const pub:any = { challenge, timeout:60000, userVerification:"required", rpId: window.location.hostname };
  if (id) pub.allowCredentials = [{ id:_bufFromB64url(id), type:"public-key" }];
  const assertion = await navigator.credentials.get({ publicKey: pub });
  return !!assertion;
}

// Distancia en metros entre dos coordenadas (Haversine). Defensivo ante valores inválidos.
function distanciaMetros(lat1:any, lng1:any, lat2:any, lng2:any): number|null {
  const a1=Number(lat1), o1=Number(lng1), a2=Number(lat2), o2=Number(lng2);
  if ([a1,o1,a2,o2].some(v=>!isFinite(v))) return null;
  const R=6371000, toRad=(x:number)=>x*Math.PI/180;
  const dLat=toRad(a2-a1), dLng=toRad(o2-o1);
  const s=Math.sin(dLat/2)**2 + Math.cos(toRad(a1))*Math.cos(toRad(a2))*Math.sin(dLng/2)**2;
  return Math.round(2*R*Math.asin(Math.min(1, Math.sqrt(s))));
}
// UNA ENTRADA REGISTRADA NUNCA ES "FALTA". `clasificarEntrada` llama "falta" a la
// entrada que llega pasado el umbral; con registro, eso es una ENTRADA TARDÍA. La
// ficha decía "Falta" en la checada de las 09:10 mientras su resumen, del mismo
// día, decía "Entrada tardía". Ahora la traducción vive AQUÍ y la usan todos: la
// lista de la ficha, el resumen, la bitácora, el registro mensual, la Actividad
// del móvil, las incidencias del mes y el mensaje del trabajador al checar.
type ClasifEntrada = "a_tiempo"|"retardo"|"tardia"|"sin_horario";
function clasifDeEntradaRegistrada(cl:any): ClasifEntrada {
  return cl === "a_tiempo" ? "a_tiempo" : cl === "retardo" ? "retardo"
    : (cl === "falta" || cl === "tardia") ? "tardia" : "sin_horario";
}
// La de UNA checada de entrada, SIEMPRE contra el horario vigente. Antes mandaba
// la clasificación guardada en la checada si la tenía: un trabajador que checó con
// un horario propio de 15/30 que después se apagó seguía saliendo "Retardo" a las
// 09:28 aunque su ficha ya heredara el general. El campo `clasificacion` de la
// checada ya no se lee en ningún sitio (ni se escribe: ver guardarChecada).
function clasificacionDeChecada(c:any, horario:any): ClasifEntrada {
  const cuando = horaDeChecada(c);
  return clasifDeEntradaRegistrada(cuando ? clasificarEntrada(horario, cuando) : "sin_horario");
}
// EL TESTIGO EN PALABRAS: lo que tenía el teléfono al checar (`horarioAplicado`),
// para el título de la marca "El teléfono registró otro horario" de la ficha.
function detalleDelTestigo(c:any): string {
  const t = c?.horarioAplicado;
  const dicho = t ? `entrada ${t.entrada}, tolerancia ${t.toleranciaMin} min` : "ningún horario";
  return `Al checar, el teléfono tenía ${dicho}. La clasificación usa el horario que regía según el historial.`;
}
// Las palabras, una vez. "Registrada" es la entrada sin horario contra el que medirla.
const ETIQUETA_CLASIF_ENTRADA: Record<ClasifEntrada,string> = {
  a_tiempo:"A tiempo", retardo:"Retardo", tardia:"Entrada tardía", sin_horario:"Registrada",
};
function clasifAsistenciaMeta(c:any){
  const k = clasifDeEntradaRegistrada(c);
  if (k==="a_tiempo") return {patron:ETIQUETA_CLASIF_ENTRADA.a_tiempo, trabajador:ETIQUETA_CLASIF_ENTRADA.a_tiempo, color:"#34D399", rgb:"52,211,153"};
  if (k==="retardo")  return {patron:ETIQUETA_CLASIF_ENTRADA.retardo, trabajador:ETIQUETA_CLASIF_ENTRADA.retardo, color:"#E2B84A", rgb:"226,184,74"};
  if (k==="tardia")   return {patron:ETIQUETA_CLASIF_ENTRADA.tardia, trabajador:ETIQUETA_CLASIF_ENTRADA.tardia, color:"#E08A3C", rgb:"224,138,60"};
  return {patron:"Sin horario", trabajador:"", color:"#9AA4B2", rgb:"154,164,178"};
}

// Metadatos de gravedad de un accidente (color/etiqueta), SOLO PARA REGISTROS VIEJOS.
//
// ⚠️ NADIE LA LLAMA DIRECTAMENTE: solo `senalDeAccidente`, más abajo. La gravedad
// salió del formulario —un chofer en shock calificando el riesgo dejaba en el
// expediente del patrón una valoración sin criterio médico ni valor jurídico—,
// pero los accidentes que la tienen la siguen mostrando: la plataforma no
// reescribe lo que alguien declaró. Si un sitio nuevo la llamara por su cuenta, un
// accidente nuevo —sin gravedad— pintaría "Sin clasificar": un distintivo que no
// informa ocupando el sitio de uno que sí. `prueba-accidente-atencion` lo vigila.
function gravedadMeta(g:any){
  const v = (g||"").toString();
  if (v==="Grave")    return {label:"Grave",    color:"#FCA5A5", rgb:"220,38,38"};
  if (v==="Moderado") return {label:"Moderado", color:"#E2B84A", rgb:"226,184,74"};
  if (v==="Leve")     return {label:"Leve",     color:"#34D399", rgb:"52,211,153"};
  return {label:"Sin clasificar", color:"#9AA4B2", rgb:"154,164,178"};
}

// ═══ LESIONADOS: TRES RESPUESTAS EN UN CAMPO QUE PARECE BOOLEANO ════════════════
//
// ⚠️ NO LO "LIMPIES" A true/false. `huboLesionados` vale `true`, `false` o
// `"no_se"`, y el string raro está ahí a propósito.
//
// "No lo sé" es una respuesta legítima: en una escena confusa —tres coches, gente
// bajándose, nadie sabe nada— un chofer no siempre puede afirmar que no hay
// lesionados, y obligarlo a elegir entre sí y no mete en el expediente una
// adivinanza disfrazada de dato.
//
// Y SE ELIGIÓ ESTA REPRESENTACIÓN POR SU MODO DE FALLO. Hay lectores que hacen
// `a.huboLesionados ? "Sí" : "No"`. Si alguno se escapa de actualizarse:
//   · con "no_se" pinta "Sí" — el error empuja hacia la ATENCIÓN;
//   · con null pintaría "No" — el error empujaría hacia la TRANQUILIDAD.
// "No lo sé" cuenta como que SÍ requiere atención, así que el primer error es el
// que se puede tolerar y el segundo no. Por eso no es null, y por eso no se limpia.
const LESIONADOS_NO_SE = "no_se";

// La respuesta, en palabras. Vacío si el accidente no la trae.
function textoLesionados(a:any): string {
  if (!a) return "";
  if (a.huboLesionados === true) return "Sí";
  if (a.huboLesionados === LESIONADOS_NO_SE) return "No lo sé";
  if (a.huboLesionados === false) return "No";
  return "";
}

// ═══ ¿ESTE ACCIDENTE REQUIERE ATENCIÓN? ═════════════════════════════════════════
//
// UNA sola regla, y la usan las dos superficies persistentes: "Qué atender hoy" en
// el móvil y el escudo en el escritorio. Vivía dentro del portal móvil y el
// escritorio no tenía nada: un patrón que solo usara la computadora no se enteraba
// nunca de que un accidente pasó a tener lesionados.
//
// ⚠️ TODO ACCIDENTE AVISA AL PATRÓN (decisión de Iván, 2026-10-03), y desde el
// 4-oct SIN CLASIFICAR SU GRAVEDAD: todos con el mismo color, en orden
// cronológico, y nada sube por gravedad. Lo que dice si hubo lesionados es una
// ETIQUETA en el renglón —ver `etiquetaLesionadosAccidente`— y un contador encima
// de la lista, para que un accidente con lesionados que quede fuera de los
// renglones visibles no pase desapercibido.
// La ventana de 7 días se queda hasta que el bloque 4 traiga "Marcar como atendido".
function accidenteRequiereAtencion(a:any): boolean {
  return !!a;
}

// ═══ LA ETIQUETA DE LESIONADOS DE LAS LISTAS DE ATENCIÓN ═══════════════════════
// Los mismos textos que la Actividad del móvil. Lo nuevo por el HECHO; lo viejo
// por lo que declaró su autor: "Grave" cuenta como con lesionados. Un "Leve" o
// "Moderado" viejo sin el dato de lesionados no dice nada de lesionados, y por
// eso no lleva etiqueta: ausencia de dato, ausencia de etiqueta.
// `tono` y no un color: el escritorio es claro y el móvil oscuro, y cada uno pinta
// el tono con su paleta; el texto y la forma son los mismos.
type EtiquetaLesionados = { label: string; tono: "lesion"|"neutro"; clave: "con"|"sin_confirmar"|"sin" };
function etiquetaLesionadosAccidente(a:any): EtiquetaLesionados | null {
  if (!a) return null;
  if (a.huboLesionados === true) return {label:"Con personas lesionadas", tono:"lesion", clave:"con"};
  if (a.huboLesionados === LESIONADOS_NO_SE) return {label:"Lesionados sin confirmar", tono:"lesion", clave:"sin_confirmar"};
  if (a.gravedad === "Grave") return {label:"Con personas lesionadas", tono:"lesion", clave:"con"};
  if (a.huboLesionados === false) return {label:"Sin personas lesionadas", tono:"neutro", clave:"sin"};
  return null;
}

// ⚠️ LA VENTANA SE MIDE DESDE EL ÚLTIMO HECHO, NO DESDE EL REGISTRO.
// Si una lesión se descubre el día 8 —el otro conductor se queja del cuello—, la
// corrección tiene que reabrir la alerta. Medida desde el registro, se quedaba
// cerrada para siempre: la misma familia que un plazo calculado en UTC. Y la hora
// de la corrección la pone el SERVIDOR —firestore.rules exige `request.time`—,
// nunca el teléfono: si la pusiera el cliente, una fecha vieja cerraría la ventana
// y escondería una lesión.
const VENTANA_ATENCION_ACCIDENTE_MS = 7*86400000;
// Y desde la atención del patrón (4-oct), también la última entrada de su
// historial: un accidente viejo que se REABRE vuelve a contar desde que se reabrió.
function msDelUltimoHechoDeAccidente(a:any): number {
  const reg = a?.timestamp?.toMillis?.() || 0;
  const cor = a?.lesionadosCorregidoEn?.toMillis?.() || 0;
  const at = entradasDeAtencion(a).reduce((m:number, e:any) => Math.max(m, fechaDeCualquiera(e?.en)?.getTime() || 0), 0);
  return Math.max(reg, cor, at);
}
// ═══ ¿SIGUE PENDIENTE? ════════════════════════════════════════════════════════
// · ATENDIDO O CANCELADO: fuera de las listas de atención y de los contadores.
// · LOS NUEVOS —los que trae la marca `pendienteHastaAtender`, que solo escribe el
//   código de esta versión al registrar— siguen pendientes SIN IMPORTAR LA FECHA,
//   hasta que el patrón los atienda o los cancele.
// · LOS DE ANTES conservan la regla de 7 días desde el último hecho.
// EL CORTE NO ES UNA FECHA, Y A PROPÓSITO: es la versión del código que registró
// el accidente. No depende del reloj de nadie —ni del teléfono que registra ni de
// la computadora que mira—, ni de cuándo se haga el merge.
const PENDIENTE_HASTA_ATENDER = "pendienteHastaAtender";
function sigueEnAtencion(a:any, ahoraMs:number): boolean {
  if (!accidenteRequiereAtencion(a)) return false;
  if (estadoAtencionAccidente(a) !== "pendiente") return false;
  if (a?.[PENDIENTE_HASTA_ATENDER] === true) return true;
  const ms = msDelUltimoHechoDeAccidente(a);
  return ms > 0 && (ahoraMs - ms) <= VENTANA_ATENCION_ACCIDENTE_MS;
}
function accidentesQueRequierenAtencion(lista:any[], ahoraMs:number): any[] {
  return (lista||[])
    .filter((a:any)=> sigueEnAtencion(a, ahoraMs))
    .sort((x:any,y:any)=> msDelUltimoHechoDeAccidente(y) - msDelUltimoHechoDeAccidente(x));
}

// ═══ ATENDER, REABRIR O CANCELAR UN ACCIDENTE (el patrón), CON TRAZA ════════════
//
// EL HISTORIAL SOLO CRECE: `atencion` es un mapa con una entrada por acción —"e0",
// "e1", "e2"…—, cada una con { accion, en, por, porNombre?, nota?, motivo? }.
// UN MAPA Y NO UNA LISTA porque la hora tiene que ponerla el SERVIDOR
// (`serverTimestamp`), y Firestore no la admite dentro de una lista. La clave
// es el número de entradas que ya había: firestore.rules exige justo esa, así que
// solo se puede AÑADIR la siguiente, nunca cambiar ni quitar una anterior.
//   · pendiente → atendido o cancelado
//   · atendido  → reabierto o cancelado
//   · cancelado → nada (sin "descancelar" por ahora)
// Cancelar exige motivo. Nada se borra.
type AccionAtencion = "atendido"|"reabierto"|"cancelado";
type EstadoAtencion = "pendiente"|"atendido"|"cancelado";
function entradasDeAtencion(a:any): any[] {
  const m = (a && a.atencion && typeof a.atencion === "object" && !Array.isArray(a.atencion)) ? a.atencion : {};
  return Object.keys(m).filter((k) => /^e\d+$/.test(k))
    .sort((x, y) => Number(x.slice(1)) - Number(y.slice(1)))
    .map((k) => Object.assign({clave: k}, m[k]));
}
function siguienteClaveAtencion(a:any): string {
  const m = (a && a.atencion && typeof a.atencion === "object" && !Array.isArray(a.atencion)) ? a.atencion : {};
  return "e" + Object.keys(m).length;
}
function estadoAtencionAccidente(a:any): EstadoAtencion {
  const e = entradasDeAtencion(a);
  const u = e[e.length - 1];
  if (!u) return "pendiente";
  return u.accion === "atendido" ? "atendido" : u.accion === "cancelado" ? "cancelado" : "pendiente";
}
function accionesDeAtencionPermitidas(estado: EstadoAtencion): AccionAtencion[] {
  if (estado === "pendiente") return ["atendido", "cancelado"];
  if (estado === "atendido") return ["reabierto", "cancelado"];
  return [];
}
// La entrada que se escribe (sin `en`: ése lo pone el servidor al escribir). Si
// falta algo obligatorio —el motivo al cancelar—, devuelve el porqué.
// UN MOTIVO QUE NO SE PODRÁ CAMBIAR: al menos 10 caracteres (sin contar los
// espacios al principio y al final). La pantalla deshabilita el botón y lo dice;
// la función que arma la entrada lo vuelve a comprobar. Las reglas no cambian.
const MINIMO_MOTIVO_INALTERABLE = 10;
const TEXTO_MOTIVO_MINIMO = "Escribe el motivo (mínimo 10 caracteres). Quedará en el registro y no se podrá cambiar.";
function motivoSuficiente(m:any): boolean {
  return String(m || "").trim().length >= MINIMO_MOTIVO_INALTERABLE;
}
function entradaDeAtencion(accion: AccionAtencion, datos: {nota?:string; motivo?:string}, quien: {email:string; nombre?:string}): {entrada?: any; error?: string} {
  const por = String(quien?.email || "").trim();
  if (!por) return {error: "No sabemos con qué cuenta estás: vuelve a entrar."};
  const e:any = {accion, por};
  const nombre = String(quien?.nombre || "").trim();
  if (nombre) e.porNombre = nombre.slice(0, 120);
  if (accion === "cancelado") {
    const motivo = String(datos?.motivo || "").trim();
    if (!motivoSuficiente(motivo)) return {error: TEXTO_MOTIVO_MINIMO};
    e.motivo = motivo.slice(0, 500);
  } else {
    const nota = String(datos?.nota || "").trim();
    if (nota) e.nota = nota.slice(0, 1000);
  }
  return {entrada: e};
}
const _MESES_ATENCION = ["ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic"];
function fechaHoraDeAtencion(v:any): string {
  const d = fechaDeCualquiera(v);
  if (!d) return "";
  return d.getDate() + " " + _MESES_ATENCION[d.getMonth()] + " " + d.getFullYear() + ", "
    + String(d.getHours()).padStart(2, "0") + ":" + String(d.getMinutes()).padStart(2, "0");
}
// "Atendido el 18 oct 2026, 13:05 por Iván" / "Cancelado el … por …". Vacío si
// está pendiente.
function textoEstadoAtencion(a:any): string {
  const e = entradasDeAtencion(a);
  const u = e[e.length - 1];
  const estado = estadoAtencionAccidente(a);
  if (!u || estado === "pendiente") return "";
  const quien = String(u.porNombre || u.por || "").trim();
  const cuando = fechaHoraDeAtencion(u.en);
  return (estado === "atendido" ? "Atendido" : "Cancelado") + (cuando ? " el " + cuando : "") + (quien ? " por " + quien : "");
}
function textoAccionAtencion(accion:string): string {
  return accion === "atendido" ? "Marcado como atendido" : accion === "reabierto" ? "Reabierto" : accion === "cancelado" ? "Cancelado" : String(accion || "");
}
// LO QUE VE EL TRABAJADOR en "Mis accidentes".
function estadoAccidenteParaTrabajador(a:any): string {
  const estado = estadoAtencionAccidente(a);
  if (estado === "atendido") return "Tu patrón lo marcó como atendido";
  if (estado === "cancelado") return "Cancelado por tu patrón";
  return "";
}

// LA ATENCIÓN EN PANTALLA, la misma pieza en el escritorio y en el portal móvil:
// el estado, el historial, y los botones que permite el estado. Antes de escribir
// se relee el accidente (otra pantalla pudo cambiarlo); después, se relee otra vez
// y se avisa a las listas de atención para que se recalculen.
function AtencionDeAccidente({accidente, usuario, tema, fontSans, onCambio}: {
  accidente: any; usuario: {email:string; nombre?:string}; tema: "claro"|"oscuro"; fontSans: string; onCambio: (a:any) => void;
}) {
  const [modo, setModo] = useState<""|"atender"|"cancelar">("");
  const [nota, setNota] = useState("");
  const [motivo, setMotivo] = useState("");
  const [confirmando, setConfirmando] = useState(false);
  const [guardando, setGuardando] = useState(false);
  const [msg, setMsg] = useState<{tipo:"ok"|"err"; texto:string}|null>(null);
  const oscuro = tema === "oscuro";
  const P = oscuro
    ? {fondo: "rgba(255,255,255,0.04)", borde: "rgba(212,168,67,0.25)", texto: "#ECE6D8", suave: "rgba(236,230,216,0.66)", acento: "#D4A843", rojo: "#FCA5A5", verde: "#34D399", input: "rgba(255,255,255,0.06)"}
    : {fondo: "#fff", borde: "rgba(11,24,41,0.14)", texto: "#0B1829", suave: "#4A5568", acento: "#236478", rojo: "#B3261E", verde: "#047857", input: "#fff"};
  const estado = estadoAtencionAccidente(accidente);
  const permitidas = accionesDeAtencionPermitidas(estado);
  const historial = entradasDeAtencion(accidente);
  const reiniciar = () => { setModo(""); setNota(""); setMotivo(""); setConfirmando(false); };
  const aplicar = async (accion: AccionAtencion) => {
    if (guardando) return;
    const armado = entradaDeAtencion(accion, {nota, motivo}, usuario);
    if (armado.error) { setMsg({tipo: "err", texto: armado.error}); return; }
    setGuardando(true); setMsg(null);
    const ref = doc(db, "accidentes", String(accidente?.id || ""));
    try {
      const s0:any = await getDoc(ref);
      const fresco = {id: accidente.id, ...(s0.data() as any)};
      if (accionesDeAtencionPermitidas(estadoAtencionAccidente(fresco)).indexOf(accion) < 0) {
        onCambio(fresco); reiniciar();
        setMsg({tipo: "err", texto: "Este accidente cambió mientras lo veías. Te mostramos lo más reciente."});
        return;
      }
      await updateDoc(ref, {["atencion." + siguienteClaveAtencion(fresco)]: {...armado.entrada, en: serverTimestamp()}});
      const s1:any = await getDoc(ref);
      onCambio({id: accidente.id, ...(s1.data() as any)});
      avisarCambioDeAtencion();   // el accidente entró o salió de las listas de atención (atendido, reabierto, cancelado)
      reiniciar();
      setMsg({tipo: "ok", texto: accion === "atendido" ? "Marcado como atendido." : accion === "reabierto" ? "Reabierto: vuelve a estar pendiente." : "Accidente cancelado."});
    } catch (e:any) {
      console.error("accidente · atención:", e);
      const code = String(e?.code || "");
      setMsg({tipo: "err", texto: /unavailable|deadline|network/i.test(code)
        ? "No se pudo guardar por la conexión. Revisa tu señal e inténtalo de nuevo."
        : /permission-denied/.test(code)
          ? "Este accidente cambió mientras lo veías. Te mostramos lo más reciente."
          : "No se pudo guardar. Inténtalo de nuevo."});
      try { const s2:any = await getDoc(ref); onCambio({id: accidente.id, ...(s2.data() as any)}); } catch (e2) { /* sin red: se queda lo que había */ }
    } finally { setGuardando(false); }
  };
  const boton = (texto:string, onClick:()=>void, opts?: {primario?:boolean; peligro?:boolean; deshabilitado?:boolean}) => (
    <button type="button" onClick={onClick} disabled={guardando || !!opts?.deshabilitado}
      style={{padding: "8px 14px", borderRadius: 9, fontSize: 12.5, fontWeight: 700, fontFamily: fontSans,
        cursor: (guardando || opts?.deshabilitado) ? "not-allowed" : "pointer", opacity: (guardando || opts?.deshabilitado) ? 0.5 : 1,
        border: "1px solid " + (opts?.peligro ? P.rojo : P.acento),
        background: opts?.primario ? (opts?.peligro ? P.rojo : P.acento) : "transparent",
        color: opts?.primario ? (oscuro ? "#0B1829" : "#fff") : (opts?.peligro ? P.rojo : P.acento)}}>{guardando ? "Guardando…" : texto}</button>
  );
  const campo = (valor:string, set:(v:string)=>void, placeholder:string) => (
    <textarea value={valor} onChange={(ev) => set(ev.target.value)} rows={2} placeholder={placeholder}
      style={{width: "100%", boxSizing: "border-box" as const, marginTop: 8, padding: "9px 11px", borderRadius: 9, fontFamily: fontSans, fontSize: 12.5,
        border: "1px solid " + P.borde, background: P.input, color: P.texto, resize: "vertical" as const}}/>
  );
  const textoEstado = textoEstadoAtencion(accidente);
  return (
    <div {...ZONA_DE_CAPTURA} data-atencion="accidente" style={{marginTop: 14, background: P.fondo, border: "1px solid " + P.borde, borderRadius: 12, padding: "12px 14px", fontFamily: fontSans}}>
      <div style={{fontSize: 11, fontWeight: 700, color: P.suave, textTransform: "uppercase" as const, letterSpacing: "0.5px", marginBottom: 6}}>Atención del patrón</div>
      <div style={{fontSize: 13, fontWeight: 700, color: estado === "cancelado" ? P.rojo : estado === "atendido" ? P.verde : P.texto}}>
        {estado === "pendiente" ? "Pendiente" : textoEstado}
      </div>
      {historial.length > 0 && (
        <div style={{marginTop: 8, display: "flex", flexDirection: "column" as const, gap: 6}}>
          {historial.map((h:any) => (
            <div key={h.clave} style={{fontSize: 12, color: P.suave, lineHeight: 1.45}}>
              <span style={{fontWeight: 700, color: P.texto}}>{textoAccionAtencion(h.accion)}</span>
              {fechaHoraDeAtencion(h.en) ? " · " + fechaHoraDeAtencion(h.en) : ""}{(h.porNombre || h.por) ? " · " + (h.porNombre || h.por) : ""}
              {h.nota ? <div style={{whiteSpace: "pre-wrap" as const}}>Nota: {h.nota}</div> : null}
              {h.motivo ? <div style={{whiteSpace: "pre-wrap" as const}}>Motivo: {h.motivo}</div> : null}
            </div>
          ))}
        </div>
      )}
      {permitidas.length > 0 && modo === "" && (
        <div style={{display: "flex", gap: 8, flexWrap: "wrap" as const, marginTop: 12}}>
          {permitidas.indexOf("atendido") >= 0 && boton("Marcar como atendido", () => { setMsg(null); setModo("atender"); }, {primario: true})}
          {permitidas.indexOf("reabierto") >= 0 && boton("Reabrir", () => aplicar("reabierto"))}
          {permitidas.indexOf("cancelado") >= 0 && boton("Cancelar accidente", () => { setMsg(null); setModo("cancelar"); }, {peligro: true})}
        </div>
      )}
      {modo === "atender" && (
        <div style={{marginTop: 10}}>
          <div style={{fontSize: 12, color: P.suave}}>Nota (opcional)</div>
          {campo(nota, setNota, "Qué se hizo: llamada a la aseguradora, atención médica…")}
          <div style={{display: "flex", gap: 8, flexWrap: "wrap" as const, marginTop: 8}}>
            {boton("Marcar como atendido", () => aplicar("atendido"), {primario: true})}
            {boton("Volver", reiniciar)}
          </div>
        </div>
      )}
      {modo === "cancelar" && (
        <div style={{marginTop: 10}}>
          <div style={{fontSize: 12, color: P.suave}}>Motivo de la cancelación (obligatorio). Es para registros por error o de prueba; no se borra, queda en el historial.</div>
          {campo(motivo, (v) => { setMotivo(v); setConfirmando(false); }, "Ej. registro de prueba, accidente duplicado…")}
          {!motivoSuficiente(motivo) && <div style={{fontSize: 11.5, color: P.suave, marginTop: 4}}>{TEXTO_MOTIVO_MINIMO}</div>}
          <div style={{display: "flex", gap: 8, flexWrap: "wrap" as const, marginTop: 8}}>
            {!confirmando
              ? boton("Cancelar accidente", () => setConfirmando(true), {peligro: true, deshabilitado: !motivoSuficiente(motivo)})
              : boton("Sí, cancelar este accidente", () => aplicar("cancelado"), {primario: true, peligro: true, deshabilitado: !motivoSuficiente(motivo)})}
            {boton("Volver", reiniciar)}
          </div>
          {confirmando && <div style={{fontSize: 11.5, color: P.rojo, marginTop: 6}}>Saldrá de las listas de atención. No se puede deshacer por ahora.</div>}
        </div>
      )}
      {msg && <div style={{marginTop: 8, fontSize: 12, fontWeight: 600, color: msg.tipo === "ok" ? P.verde : P.rojo}}>{msg.texto}</div>}
    </div>
  );
}

// ═══ QUÉ CHIP SE ENSEÑA ═══════════════════════════════════════════════════════════
// Recibe el accidente ENTERO, no un campo: es la única forma de decidir entre un
// registro viejo y uno nuevo. Ausencia de los dos datos = ausencia de chip, nunca un
// chip que diga que no se sabe.
// ═══ LA LÍNEA QUE DICE QUÉ PASÓ ═══════════════════════════════════════════════
//
// La descripción escrita dejó de ser obligatoria: en el registro rápido no se
// escribe nada, y quizá no se escriba nunca. Las pantallas del patrón la usaban
// como línea principal y, sin ella, pintaban "—", "Accidente registrado" o un
// renglón en blanco sobre un accidente del que SÍ se sabe qué pasó: lo dice
// `tipoEvento`.
// DESDE EL 4-OCT, EL TIPO VA PRIMERO: es lo que encabeza las listas —Flotilla,
// Actividad, feed, escudo—, y el relato solo va en el detalle, con su etiqueta
// "Relato del trabajador" (ver `detalleDeAccidente`). Los antiguos sin tipo
// conservan lo que enseñaban: su descripción, o la frase genérica.
function resumenDeAccidente(a:any): string {
  const t = rotuloTipoAccidente(a?.tipoEvento);
  if (t) return t;
  const d = String(a?.descripcion || "").trim();
  if (d) return d;
  return "Accidente registrado";
}

// ═══ EL DETALLE DE UN ACCIDENTE, IGUAL EN ESCRITORIO Y EN MÓVIL ═══════════════
//
// Las dos vistas del patrón —Flotilla en escritorio y el portal móvil— armaban su
// detalle cada una a su manera, con etiquetas distintas, y a las dos les faltaban
// cosas del formulario nuevo: el relato con su propia etiqueta, la corrección de
// lesionados, el vídeo (el móvil no lo enseñaba nunca). Y el móvil pintaba "No"
// en ambulancia, detenidos, daños, parte de tránsito y grúa cuando el trabajador
// NO HABÍA CONTESTADO: un "No" que nadie dijo. Ahora las dos leen de aquí:
//   · mismas secciones y mismas etiquetas;
//   · NINGÚN CAMPO VACÍO: lo que no se contestó no aparece. Un Sí/No solo sale si
//     el valor es true o false de verdad;
//   · la fecha y hora de los hechos solo si son DISTINTAS de las del registro;
//   · el tipo de evento y el relato, cada uno con su etiqueta.
type SeccionDetalleAccidente = { titulo: string; filas: [string, string][] };
function _siNo(v:any): string { return v === true ? "Sí" : v === false ? "No" : ""; }
function _diaYHoraLocal(d: Date): {dia:string; hora:string} {
  return { dia: `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`,
           hora: `${String(d.getHours()).padStart(2,"0")}:${String(d.getMinutes()).padStart(2,"0")}` };
}
function detalleDeAccidente(a:any): SeccionDetalleAccidente[] {
  if (!a) return [];
  const sec = (titulo:string, pares:[string, any][]): SeccionDetalleAccidente => ({
    titulo,
    filas: pares.filter(([, v]) => v !== undefined && v !== null && String(v).trim() !== "").map(([l, v]) => [l, String(v)] as [string, string]),
  });
  // CUÁNDO PASÓ, solo si no es lo mismo que cuándo se registró.
  const reg = fechaDeCualquiera(a.timestamp);
  const r = reg ? _diaYHoraLocal(reg) : {dia:"", hora:""};
  const fh = String(a.fechaHechos || "").trim(), hh = String(a.horaHechos || "").trim();
  const distinta = (!!fh && fh !== r.dia) || (!!hh && hh !== r.hora);
  let cuandoHechos = "";
  if (distinta) {
    const m = fh.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    const diaTxt = m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])).toLocaleDateString("es-MX", {day:"numeric", month:"short", year:"numeric"}) : fh;
    cuandoHechos = [diaTxt, hh].filter(Boolean).join(" · ");
  }
  // LESIONADOS, CON SU CORRECCIÓN. Al registrar se pudo decir "No lo sé"; si
  // después se confirmó, se dice cuándo y desde qué respuesta.
  let lesionados = textoLesionados(a);
  if (lesionados === "Sí" && Number(a.numLesionados) > 0) lesionados += ` (${a.numLesionados})`;
  if (lesionados && a.lesionadosCorregidoEn) {
    const c = cuandoTexto(a.lesionadosCorregidoEn, true);
    lesionados += ` · confirmado después${c ? " (" + c + ")" : ""}; al registrar: «No lo sé»`;
  }
  const testigos = Array.isArray(a.testigos)
    ? a.testigos.map((t:any) => [t?.nombre, t?.telefono].filter(Boolean).join(" · ")).filter(Boolean).join(" / ") : "";
  const contraparteVeh = [a.contrapartePlaca, a.contraparteMarca, a.contraparteModelo, a.contraparteColor].filter(Boolean).join(" · ");
  const danos = a.danosTerceros === true ? (String(a.danosTercerosDesc || "").trim() || "Sí") : _siNo(a.danosTerceros);
  const parte = a.parteTransito === true ? (a.folioParte ? `Sí · folio ${a.folioParte}` : "Sí") : _siNo(a.parteTransito);
  const grua = a.vehiculoRetirado === true ? "Sí (grúa o corralón)" : _siNo(a.vehiculoRetirado);
  return [
    sec("Qué pasó", [
      ["Tipo de evento", rotuloTipoAccidente(a.tipoEvento)],
      ["Relato del trabajador", String(a.descripcion || "").trim()],
      ["Fecha y hora de los hechos", cuandoHechos],
      ["Lugar", a.lugarHechos],
      ["Personas involucradas", Number(a.numInvolucrados) > 0 ? a.numInvolucrados : ""],
    ]),
    sec("Lesionados", [["Lesionados", lesionados]]),
    sec("Vehículo de la empresa", [["Vehículo", a.vehiculo || a.placa]]),
    sec("Otro conductor", [
      ["Nombre", a.contraparteNombre],
      ["Teléfono", a.contraparteTelefono],
      ["Vehículo", contraparteVeh],
      ["Aseguradora", a.contraparteAseguradora || (a.contraparteSeguro === true ? "Tiene seguro" : "")],
      ["Póliza", a.contrapartePoliza],
    ]),
    sec("Daños a terceros", [["Daños a terceros", danos]]),
    sec("Testigos", [["Testigos", testigos]]),
    sec("Autoridades y grúa", [
      ["Parte de tránsito", parte],
      ["Ambulancia", _siNo(a.huboAmbulancia)],
      ["Detenidos", _siNo(a.huboDetenidos)],
      ["Retirado por grúa o autoridad", grua],
      ["Número de siniestro", a.numeroSiniestro],
    ]),
    sec("Registro", [["Registrado el", reg ? cuandoTexto(a.timestamp, true) : (a.fecha ? `${a.fecha}${a.hora ? ` ${a.hora}` : ""}` : "")]]),
  ].filter((s) => s.filas.length > 0);
}

// ═══ "MIS ACCIDENTES": LO QUE EL TRABAJADOR PUEDE SEGUIR COMPLETANDO ══════════
//
// La pantalla posterior solo existía justo después de registrar: si el trabajador
// salía, ya no podía volver, aunque firestore.rules le deja completar su accidente
// durante 7 días. Estas piezas deciden, en un solo sitio:
//   · qué accidentes ve: los SUYOS de su empresa actual, registrados hace menos de
//     7 días CONTADOS DESDE `timestamp` —la misma cuenta que la regla—, del más
//     reciente al más antiguo;
//   · hasta cuándo puede completar cada uno;
//   · qué se le dice si el plazo vence con la pantalla abierta;
//   · cómo se carga lo guardado en la pantalla posterior: lo que la regla solo deja
//     escribir una vez llega como declarado (y se enseña en solo lectura), las
//     fotos y los testigos como lo que ya hay (solo crecen), y lesionados tal
//     cual (solo se corrige si sigue en "No lo sé").
const VENTANA_COMPLETAR_ACCIDENTE_MS = 7*86400000;
function msRegistroAccidente(a:any): number {
  const d = fechaDeCualquiera(a?.timestamp);
  return d ? d.getTime() : 0;
}
// Hasta cuándo: la regla exige `request.time < timestamp + 7 días`. Sin fecha de
// registro, 0: no se puede afirmar que siga abierto.
function venceCompletarAccidenteMs(a:any): number {
  const ms = msRegistroAccidente(a);
  return ms > 0 ? ms + VENTANA_COMPLETAR_ACCIDENTE_MS : 0;
}
function misAccidentesAbiertos(lista:any[], empleadorId:string, ahoraMs:number): any[] {
  return (lista || [])
    .filter((a:any) => !!a && (!empleadorId || String(a.empleadorId || "") === empleadorId))
    .filter((a:any) => { const v = venceCompletarAccidenteMs(a); return v > 0 && ahoraMs < v; })
    .sort((x:any, y:any) => msRegistroAccidente(y) - msRegistroAccidente(x));
}
// EL GUARDADO QUE LLEGA TARDE NO FALLA EN SILENCIO. Pasado el plazo —o a menos de
// una hora, por si el reloj del teléfono va atrasado y el servidor ya cerró—, un
// rechazo de permisos se explica con su causa. Cualquier otro error, como siempre.
const TEXTO_PLAZO_ACCIDENTE_VENCIDO = "Ya pasaron los 7 días para completar este accidente, así que no se guardó. Lo que ya estaba guardado se queda; si falta algo, avísale a tu patrón.";
// ⚠️ NUNCA UN CÓDIGO TÉCNICO (4-oct). Decía "No se pudo guardar: permission-denied",
// y un trabajador en la carretera no sabe qué hacer con eso. Cada fallo se dice
// en palabras y con qué hacer:
//   · el plazo de 7 días, con su texto de siempre;
//   · un rechazo de permisos dentro del plazo casi siempre es que la pantalla
//     estaba atrasada —el dato ya se había guardado—: se relee y se dice así;
//   · la conexión, como conexión;
//   · lo demás, "inténtalo de nuevo".
// `que` dice qué se estaba haciendo: el registro no tiene plazo y su rechazo
// significa otra cosa (la cuenta no está ligada al patrón).
const TEXTO_DATO_YA_GUARDADO = "Este dato ya se había guardado antes. Te mostramos lo más reciente.";
function _esFalloDeConexion(code:string): boolean {
  return /unavailable|deadline-exceeded|network|retry-limit|offline|cancel/i.test(code);
}
function mensajeFalloGuardadoAccidente(e:any, venceMs:number, ahoraMs:number, que:"guardar"|"fotos"|"video"|"registro" = "guardar"): string {
  const code = String(e?.code || "");
  const rechazo = /permission-denied|unauthorized/.test(code);
  if (que !== "registro") {
    if (venceMs > 0 && ahoraMs >= venceMs) return TEXTO_PLAZO_ACCIDENTE_VENCIDO;
    if (rechazo && venceMs > 0 && ahoraMs >= venceMs - 3600000) return TEXTO_PLAZO_ACCIDENTE_VENCIDO;
  }
  if (_esFalloDeConexion(code)) {
    if (que === "registro") return "No se pudo registrar el accidente por la conexión. Revisa tu señal e inténtalo de nuevo.";
    if (que === "fotos") return "Las fotos no se guardaron por la conexión. Revisa tu señal e inténtalo de nuevo.";
    if (que === "video") return "El video no se guardó por la conexión. Revisa tu señal e inténtalo de nuevo.";
    return "No se pudo guardar por la conexión. Revisa tu señal e inténtalo de nuevo; lo que escribiste sigue aquí.";
  }
  if (rechazo) {
    if (que === "registro") return "No pudimos registrar el accidente con tu cuenta. Avísale a tu patrón por teléfono o mensaje.";
    if (que === "fotos") return "Las fotos no se pudieron guardar en el accidente. Te mostramos lo más reciente; si aún caben, inténtalo de nuevo.";
    if (que === "video") return "Este accidente ya tenía un video guardado. Te mostramos lo más reciente.";
    return TEXTO_DATO_YA_GUARDADO;
  }
  if (que === "registro") return "No se pudo registrar el accidente. Inténtalo de nuevo; si sigue fallando, avísale a tu patrón.";
  if (que === "fotos") return "Las fotos no se pudieron guardar en el accidente. Inténtalo de nuevo.";
  if (que === "video") return "El video no se pudo guardar. Inténtalo de nuevo; el accidente sigue registrado.";
  return "No se pudo guardar. Inténtalo de nuevo; si sigue fallando, avísale a tu patrón.";
}
// ⚠️ NINGÚN CÓDIGO TÉCNICO EN PANTALLA en el checador, el horario, la bitácora,
// el registro mensual, los datos de la empresa, las actividades y la flotilla.
// Decía "No se pudo guardar: permission-denied" o "Código: unavailable". El
// detalle va a la consola; a la persona se le dice qué pasó: sin señal, sin
// permiso (y qué hacer, según quién sea) o un fallo que se puede reintentar.
// Un error que la propia plataforma lanza con un texto para la persona lleva
// `paraMostrar` (ver `errorParaMostrar`): ese sí se enseña tal cual.
function errorParaMostrar(texto:string): Error {
  const e:any = new Error(texto); e.paraMostrar = true; return e;
}
function mensajeDeFallo(e:any, o:{accion:string; denegado:string; siSigue?:string}): string {
  if (e && e.paraMostrar === true && e.message) return String(e.message);
  const code = String(e?.code || "");
  const texto = String(e?.message || "");
  if (_esFalloDeConexion(code) || /network|failed to fetch|offline|unavailable/i.test(texto))
    return `No pudimos ${o.accion} por la conexión. Revisa tu señal e inténtalo de nuevo.`;
  if (/permission-denied|unauthorized|unauthenticated/.test(code)) return o.denegado;
  return `No pudimos ${o.accion}. Inténtalo de nuevo${o.siSigue ? "; " + o.siSigue : ""}.`;
}
// El "permiso denegado" del patrón: no hay a quién avisar dentro de su empresa;
// lo probable es que entró con otra cuenta.
function denegadoPatron(que:string): string {
  return `Esta cuenta no tiene permiso para ${que}. Revisa que entraste con la cuenta de tu empresa.`;
}
// LO GUARDADO, LISTO PARA LA PANTALLA POSTERIOR. Todo lo que no tiene valor llega
// vacío o null —sin contestar—, nunca con un valor por omisión.
function estadoPosteriorDeAccidente(a:any): {
  registro: {id:string; sinVehiculo:boolean; vehiculoId:string; lesionados:any; fechaReg:string; horaReg:string; venceMs:number; reabierto:boolean; resumen:string; estadoPatron:string};
  declarado: {descripcion?:string; fechaHechos?:string; horaHechos?:string};
  fotos: {nombre:string; url:string}[];
  testigos: {nombre:string; telefono:string}[];
  video: string;
  campos: {numeroSiniestro:string; contraparteNombre:string; contraparteTelefono:string; contrapartePlaca:string;
    contraparteAseguradora:string; contrapartePoliza:string; danosTerceros:boolean|null; danosTercerosDesc:string;
    parteTransito:boolean|null; folioParte:string; huboAmbulancia:boolean|null; huboDetenidos:boolean|null; vehiculoRetirado:boolean|null};
} {
  const reg = fechaDeCualquiera(a?.timestamp);
  const r = reg ? _diaYHoraLocal(reg) : {dia:"", hora:""};
  const txt = (v:any) => String(v ?? "").trim();
  const siNo = (v:any): boolean|null => (v === true || v === false) ? v : null;
  const declarado: {descripcion?:string; fechaHechos?:string; horaHechos?:string} = {};
  if (txt(a?.descripcion)) declarado.descripcion = txt(a.descripcion);
  if (txt(a?.fechaHechos)) { declarado.fechaHechos = txt(a.fechaHechos); declarado.horaHechos = txt(a?.horaHechos); }
  const unidad = txt(a?.vehiculo) || txt(a?.placa);
  return {
    registro: {
      id: String(a?.id || ""), sinVehiculo: !txt(a?.vehiculoId), vehiculoId: txt(a?.vehiculoId),
      lesionados: a?.huboLesionados, fechaReg: r.dia, horaReg: r.hora,
      venceMs: venceCompletarAccidenteMs(a), reabierto: true,
      // Lo que hizo el patrón con él, en palabras del trabajador ("" si pendiente).
      estadoPatron: estadoAccidenteParaTrabajador(a),
      resumen: [resumenDeAccidente(a), unidad, reg ? cuandoTexto(a.timestamp, true) : ""].filter(Boolean).join(" · "),
    },
    declarado,
    fotos: (Array.isArray(a?.fotos) ? a.fotos : [])
      .map((u:any) => typeof u === "string" ? u : (u && u.url) || "").filter(Boolean)
      .map((url:string, i:number) => ({nombre: "Foto " + (i + 1), url})),
    testigos: (Array.isArray(a?.testigos) ? a.testigos : [])
      .map((x:any) => ({nombre: txt(x?.nombre), telefono: txt(x?.telefono)})),
    video: txt(a?.video),
    campos: {
      numeroSiniestro: txt(a?.numeroSiniestro),
      contraparteNombre: txt(a?.contraparteNombre), contraparteTelefono: txt(a?.contraparteTelefono),
      contrapartePlaca: txt(a?.contrapartePlaca), contraparteAseguradora: txt(a?.contraparteAseguradora),
      contrapartePoliza: txt(a?.contrapartePoliza),
      danosTerceros: siNo(a?.danosTerceros), danosTercerosDesc: txt(a?.danosTercerosDesc),
      parteTransito: siNo(a?.parteTransito), folioParte: txt(a?.folioParte),
      huboAmbulancia: siNo(a?.huboAmbulancia), huboDetenidos: siNo(a?.huboDetenidos),
      vehiculoRetirado: siNo(a?.vehiculoRetirado),
    },
  };
}

// ═══ LA FECHA DEL ACCIDENTE EN UN PAPEL ═══════════════════════════════════════
// La DECLARADA si la hay —`fechaHechos`, "AAAA-MM-DD"—; si no, la del REGISTRO,
// en el día local. El registro rápido no escribe fecha declarada, y el reporte
// mensual imprimía `fechaHechos` a secas: un accidente en el papel sin fecha.
function fechaDelAccidente(a:any): string {
  const fh = String(a?.fechaHechos || "").trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(fh)) return fh;
  const d = fechaDeCualquiera(a?.timestamp);
  // El día LOCAL, armado con sus tres números: `toISOString()` daría el día en
  // UTC, y en México un accidente de las 19:00 saldría con la fecha de mañana.
  return d ? `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}` : "";
}

function senalDeAccidente(a:any): {label:string; color:string; rgb:string} | null {
  if (!a) return null;
  if (a.gravedad) return gravedadMeta(a.gravedad);
  const e = etiquetaLesionadosAccidente(a);
  if (!e) return null;
  return {label:e.label, ...colorEtiquetaLesionados(e.tono, "oscuro")};
}

// ═══ EL RENGLÓN DE UN ACCIDENTE PENDIENTE ═════════════════════════════════════════
//
// ⚠️ SE LEE COMO ALGO QUE HACER, NO COMO UNA NOTICIA.
//
// Y esto NO contradice lo que se decidió cuando salieron cosas del escudo. La regla
// es: lo que ocurrió y ya, va a la CAMPANA; lo que persiste hasta que alguien lo
// resuelve es PENDIENTE y vive en el ESCUDO. Un accidente a secas es un hecho
// ocurrido: campana. Un accidente con personas lesionadas, o sin confirmar si las
// hay, abre obligaciones que siguen abiertas hasta que el patrón actúa: por esa
// misma regla es un pendiente. El accidente no entra al escudo porque pasó; entra
// porque hay algo que hacer.
// Desde el 4-oct EL TÍTULO ES EL MISMO PARA TODOS: "Accidente: [tipo]", o
// "Accidente reportado" si es antiguo y no trae tipo. Lo de los lesionados va en
// la etiqueta, no en el título: un título distinto por gravedad era clasificar.
// Debajo, quién y qué unidad; la fecha y la hora las añade la fila (`cuando`).
function renglonPendienteDeAccidente(a:any): {titulo:string; detalle:string} {
  const quien = String(a?.trabajadorNombre || a?.trabajadorEmail || "Trabajador");
  const placa = String(a?.placa || "").trim();
  const detalle = quien + (placa ? " · " + placa : "");
  const tipo = rotuloTipoAccidente(a?.tipoEvento);
  return {titulo: tipo ? "Accidente: " + tipo : "Accidente reportado", detalle};
}

// LOS COLORES DE LA ETIQUETA, por tema. Oscuro: los de la Actividad del móvil.
// Claro: los mismos tonos con contraste suficiente sobre blanco.
function colorEtiquetaLesionados(tono: "lesion"|"neutro", tema: "claro"|"oscuro"): {color:string; rgb:string} {
  if (tema === "oscuro") return tono === "lesion" ? {color:"#FCA5A5", rgb:"220,38,38"} : {color:"#9AA4B2", rgb:"154,164,178"};
  return tono === "lesion" ? {color:"#B3261E", rgb:"220,38,38"} : {color:"#5B6472", rgb:"91,100,114"};
}
// LA ETIQUETA, PINTADA. La misma forma que la de la Actividad del móvil, en las
// tres superficies.
function EtiquetaLesionadosChip({accidente, tema}: {accidente:any; tema:"claro"|"oscuro"}) {
  const e = etiquetaLesionadosAccidente(accidente);
  if (!e) return null;
  const c = colorEtiquetaLesionados(e.tono, tema);
  return <span style={{fontSize:10, fontWeight:800, padding:"1px 7px", borderRadius:999, border:`1px solid ${c.color}`, color:c.color, background:`rgba(${c.rgb},0.16)`, whiteSpace:"nowrap" as const}}>{e.label}</span>;
}

// EL CONTADOR DE ENCIMA DE LA LISTA: "N accidentes · M con lesionados · K sin
// confirmar". M y K solo si no son cero. Cuenta TODOS los accidentes de la
// ventana, no solo los renglones que caben.
function conteoDeAccidentes(accidentes: any[]): {n:number; conLesionados:number; sinConfirmar:number; texto:string} {
  const lista = accidentes || [];
  const n = lista.length;
  let conLesionados = 0, sinConfirmar = 0;
  lista.forEach((a:any) => {
    const e = etiquetaLesionadosAccidente(a);
    if (e && e.clave === "con") conLesionados++;
    if (e && e.clave === "sin_confirmar") sinConfirmar++;
  });
  const partes = [n === 1 ? "1 accidente" : n + " accidentes"];
  if (conLesionados > 0) partes.push(conLesionados + " con lesionados");
  if (sinConfirmar > 0) partes.push(sinConfirmar + " sin confirmar");
  return {n, conLesionados, sinConfirmar, texto: n > 0 ? partes.join(" · ") : ""};
}

// ═══ CUÁNDO FUE EL ACCIDENTE ══════════════════════════════════════════════════
//
// DOS FECHAS DISTINTAS, Y NO DAN IGUAL: `fechaHechos`/`horaHechos` son lo que el
// trabajador declara que pasó —a las 17:20, en tal esquina—, y `timestamp` es
// cuándo se registró en la plataforma, que puede ser media hora después o al día
// siguiente si se quedó sin señal. El renglón dice CUÁNDO OCURRIÓ, porque es lo
// que el patrón necesita para llamar al ajustador; si el accidente no trae la hora
// declarada —los registros viejos podían no pedirla—, se cae al registro, que es
// lo único que siempre existe.
function momentoDelAccidente(a:any): any {
  const f = String(a?.fechaHechos || "").trim();
  const h = String(a?.horaHechos || "").trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(f)) {
    const [Y,M,D] = f.split("-").map(Number);
    const m = h.match(/^(\d{1,2}):(\d{2})/);
    // Día y hora LOCALES, armados número a número: `new Date("2026-09-22")` se
    // interpreta en UTC y en México retrocede un día.
    return m ? new Date(Y, M-1, D, Number(m[1]), Number(m[2])) : new Date(Y, M-1, D);
  }
  return a?.timestamp ?? null;
}

// ═══ UNA SOLA LISTA DE PENDIENTES PARA LAS TRES PANTALLAS ════════════════════
//
// ⚠️ LO QUE ESTO VIENE A IMPEDIR: QUE DOS PANTALLAS DE LA MISMA APLICACIÓN SE
// CONTRADIGAN A LA VISTA.
//
// Pasó, y en la misma pantalla de escritorio: el escudo decía "Requieren tu
// atención · 3" con tres accidentes con personas lesionadas, y la tarjeta de
// Inicio, a diez centímetros, decía "Todo al día · Nada vencido ni por vencer en
// los próximos 30 días". Las dos salían de `atencionUrgente` hasta que los
// accidentes se añadieron SOLO al escudo: `SuiteHome` no pedía la lista de
// accidentes al hook, así que su tarjeta seguía contando únicamente plazos.
//
// El arreglo no es "acordarse de tocar las dos": es que no haya dos cuentas. Quien
// quiera saber qué hay pendiente llama aquí, y aquí se decide el orden, el número,
// el texto y la fecha de cada renglón.
//
// EL ORDEN: los accidentes primero, ENTRE ELLOS EN ORDEN CRONOLÓGICO —el más
// reciente arriba, sin que nada suba por gravedad—, y detrás los plazos tal como
// ya venían ordenados (vencidos antes que por vencer). El bloque de plazos no se
// toca: el orden de los accidentes se decide dentro de su propio bloque.
type FilaAtencion = {
  clave: string;
  titulo: string;
  detalle: string;
  cuando: string;          // "" si no hay fecha legible; nunca inventada
  esAccidente: boolean;
  // Solo en los accidentes: la etiqueta de lesionados (o null si no hay dato).
  // Todos los accidentes se pintan del mismo color: esto NO decide un color.
  lesionados?: EtiquetaLesionados | null;
  item?: ItemAtencion;     // el pendiente original, para saber a dónde ir
  accidente?: any;
};
function msDeMomentoAccidente(a:any): number {
  const d = fechaDeCualquiera(momentoDelAccidente(a));
  return d ? d.getTime() : 0;
}
function filasDeAtencion(items: ItemAtencion[], accidentes: any[]): FilaAtencion[] {
  const filasAcc: FilaAtencion[] = (accidentes || []).map((a:any) => {
    const r = renglonPendienteDeAccidente(a);
    return { clave: "acc:" + String(a?.id || ""), titulo: r.titulo, detalle: r.detalle,
      // Con hora: un accidente ocurre a una hora, y dos del mismo trabajador y la
      // misma unidad solo se distinguen por ella.
      cuando: cuandoTexto(momentoDelAccidente(a), true), esAccidente: true, accidente: a,
      lesionados: etiquetaLesionadosAccidente(a) };
  })
  // ORDEN CRONOLÓGICO por el momento que el renglón ENSEÑA —la hora declarada, o
  // la del registro—, el más reciente primero: así las fechas que se leen van en
  // orden. Empates por la hora de registro. Nada sube por gravedad.
    .sort((x, y) => (msDeMomentoAccidente(y.accidente) - msDeMomentoAccidente(x.accidente))
      || ((y.accidente?.timestamp?.toMillis?.() || 0) - (x.accidente?.timestamp?.toMillis?.() || 0)));
  const filasPlazo: FilaAtencion[] = (items || []).map((it:any) => ({
    clave: "item:" + String(it?.id || ""), titulo: String(it?.titulo || ""), detalle: String(it?.detalle || ""),
    // Sin hora: un documento vence un día, y en el papel no hay hora.
    cuando: cuandoTexto(it?.fechaRef, false), esAccidente: false, item: it,
  }));
  return [...filasAcc, ...filasPlazo];
}

// EL RESUMEN QUE LEEN LAS TRES SUPERFICIES. Una sola suma: mientras el escudo
// tenga algo, `vacio` es falso y ninguna pantalla puede decir "Todo al día".
function resumenDeAtencion(items: ItemAtencion[], accidentes: any[]): {
  filas: FilaAtencion[]; total: number; nAccidentes: number; conteoAccidentes: string; nVencidos: number; vacio: boolean; frase: string;
} {
  const filas = filasDeAtencion(items, accidentes);
  const nAccidentes = (accidentes || []).length;
  // EL CONTADOR de encima de la lista de accidentes. Ningún accidente cambia el
  // color de nada: el contador es lo que hace visible a los que tienen lesionados.
  const conteoAccidentes = conteoDeAccidentes(accidentes).texto;
  const nVencidos = (items || []).filter((it:any) => it?.severidad === "vencido").length;
  const total = filas.length;
  // LA FRASE DEL ESTADO VACÍO TAMBIÉN SALE DE AQUÍ, y por la misma razón: decía
  // "Nada vencido ni por vencer en los próximos 30 días" en una lista que ahora
  // también puede traer accidentes. Si un día la lista tiene algo que esa frase no
  // nombra, el texto miente de nuevo — pero ya solo hay un sitio que cambiar.
  const frase = "Nada vencido ni por vencer, y ningún accidente por atender.";
  return { filas, total, nAccidentes, conteoAccidentes, nVencidos, vacio: total === 0, frase };
}

// VISTA DEL TRABAJADOR — pantalla limitada (sin AppShell ni otros módulos). Solo
// muestra SUS tareas (query por trabajadorEmail == su correo, orden en JS) y
// permite "Marcar como hecha" (update SOLO de marcadaPorTrabajador=true +
// fechaMarcada, como exige la regla). No puede confirmar.
// ─────────────────────────────────────────────────────────────────────────────
function VistaTrabajador({user, cuenta, onLogout, fontSans, fontSerif, gold}: {user:any; cuenta:any; onLogout:()=>void; fontSans:string; fontSerif:string; gold:string}) {
  // SIN PUERTA DE AVISOS, A PROPÓSITO. Aquí no se llama a `useNotificacionesPush`
  // porque no existe todavía ningún aviso dirigido al trabajador; el razonamiento
  // entero está donde se declara el hook. El punto de no leído de la pestaña
  // Notificaciones sigue siendo lo que tiene, y con eso no se le promete nada.
  const isMobile = window.innerWidth < 768;
  // RECARGA MANUAL. `tickTrab` entra en las dependencias de TODOS los efectos de
  // carga del portal, asi que subirlo vuelve a correr las mismas lecturas. No se
  // cambia como se lee: solo cuando.
  const [tickTrab, setTickTrab] = useState(0);
  const [refrescandoTrab, setRefrescandoTrab] = useState(false);
  const [errorRefrescoTrab, setErrorRefrescoTrab] = useState(false);
  const refrescarTrab = () => {
    setRefrescandoTrab(true); setErrorRefrescoTrab(false);
    setTickTrab(x=>x+1);
    // Las cargas son varias e independientes; se libera el indicador tras darles
    // margen. No se encadenan promesas para no tocar la logica de lectura.
    setTimeout(()=>setRefrescandoTrab(false), 1400);
  };

  const [tareas, setTareas] = useState<any[]>([]);
  const [avisos, setAvisos] = useState<any[]>([]);   // comunicados tipo='aviso' de su empresa
  const [eventos, setEventos] = useState<any[]>([]); // comunicados tipo='evento' de su empresa
  const [reportes, setReportes] = useState<any[]>([]); // reportes enviados por el patrón (Mis reportes)
  // Si la lectura falla, el trabajador NO debe ver una sección vacía: eso es
  // indistinguible de "mi patrón nunca me envió nada", que es justo lo que
  // estos documentos existen para desmentir.
  const [reportesError, setReportesError] = useState(false);
  // Regla del portal: el trabajador NUNCA debe ver una sección vacía cuando lo
  // que pasó fue que falló la lectura. Una lista vacía dice "tu patrón no te ha
  // mandado nada"; un error dice "no pudimos traerlo". No es lo mismo.
  const [avisosError, setAvisosError] = useState(false);
  const [vehiculosError, setVehiculosError] = useState(false);
  // Marca local (por uid) de la última vez que abrió Notificaciones — para el puntito de no leídos.
  // LA MISMA MARCA que la campana del patrón, y en el servidor: el trabajador
  // también puede escribir su propio `usuarios/{uid}`, así que no hace falta
  // tocar ninguna regla. Antes esto era un número en el `localStorage` de ESTE
  // teléfono: abrir las notificaciones aquí no las apagaba en ningún otro sitio.
  const {marca: notisVistasAt, marcarVistoAhora: marcarNotisVistas} = useMarcaVistas(user?.uid);
  const [cargando, setCargando] = useState(true);
  const [marcandoId, setMarcandoId] = useState<string|null>(null);
  const [errorMsg, setErrorMsg] = useState<string>(""); // diagnóstico temporal
  const correo = (user?.email||"").toLowerCase().trim();
  const nombre = cuenta?.nombre || (user?.email||"").split("@")[0];
  // Foto de perfil del trabajador. Sube a Storage 'perfil_trabajador/{uid}/' (ya permitido)
  // y la persiste en su propio doc cuentas_trabajador/{email}.fotoPerfilUrl. Persistir la URL
  // requiere una regla nueva (el trabajador solo puede tocar su fotoPerfilUrl); si aún no está
  // publicada, la foto se ve local pero no se guarda — no rompe el perfil (manejo defensivo).
  const [fotoPerfilTrab, setFotoPerfilTrab] = useState<string>(cuenta?.fotoPerfilUrl || "");
  const [fotoTrabErr, setFotoTrabErr] = useState<string>("");
  useEffect(()=>{ setFotoPerfilTrab(cuenta?.fotoPerfilUrl || ""); }, [cuenta?.fotoPerfilUrl]);
  const guardarFotoTrab = async (url:string) => {
    setFotoPerfilTrab(url); setFotoTrabErr("");
    if (!cuenta?.id) return;
    try {
      await setDoc(doc(db,"cuentas_trabajador", cuenta.id), { fotoPerfilUrl: url }, { merge:true });
    } catch(e:any){ console.error("cuentas_trabajador foto write:", e); setFotoTrabErr("La foto se subió pero aún no se pudo guardar. Si el permiso acaba de publicarse, intenta de nuevo."); }
  };

  // ── Contacto directo al WhatsApp del PATRÓN (nunca a AXIS) ─────────────────
  // El número lo configura el patrón en su Perfil y se propaga a cuentas_trabajador
  // (`empleadorWhatsapp`), que es lo único del patrón que el trabajador puede leer.
  // Si no está configurado, la UI muestra un aviso suave en vez del botón.
  const waPatronDigits = String(cuenta?.empleadorWhatsapp || "").replace(/\D/g, "");
  const waPatron = waPatronDigits ? (waPatronDigits.length === 10 ? `52${waPatronDigits}` : waPatronDigits) : "";
  const abrirWhatsAppPatron = () => {
    if (!waPatron) return;
    const url = `https://wa.me/${waPatron}?text=${encodeURIComponent("Hola, te contacto respecto a la flotilla/vehículo.")}`;
    try { window.open(url, "_blank", "noopener,noreferrer"); } catch(e){ window.location.href = url; }
  };

  const cargar = async () => {
    if (!correo) return;
    setCargando(true); setErrorMsg("");
    try {
      const snap = await getDocs(query(collection(db,"tareas"), where("trabajadorEmail","==",correo)));
      const tars = snap.docs.map(d=>({id:d.id,...(d.data() as any)})).sort((a:any,b:any)=>{
        const fa = a.fechaLimite||"9999-99-99", fb = b.fechaLimite||"9999-99-99";
        if (fa!==fb) return fa.localeCompare(fb);
        return (a.creadoEn?.toMillis?.()||0) - (b.creadoEn?.toMillis?.()||0);
      });
      setTareas(tars);
    } catch(e:any){ console.error(e); setErrorMsg(mensajeDeFallo(e, {accion:"cargar tus actividades", denegado:"Tu cuenta no tiene permiso para ver tus actividades. Avísale a tu patrón.", siSigue:"si sigue fallando, avísale a tu patrón"})); }
    finally { setCargando(false); }
  };
  useEffect(() => { cargar(); /* eslint-disable-next-line */ }, [correo, tickTrab]);

  // Avisos generales de su empresa (comunicados tipo='aviso'). Scope por empleadorId
  // del vínculo trabajador→empleador (cuenta.empleadorId), igual que checadas/flotilla.
  // Un solo where; filtra tipo y ordena por fecha en JS (sin índices compuestos).
  useEffect(() => {
    const empId = cuenta?.empleadorId || "";
    if (!empId) return;
    let cancel = false;
    (async () => {
      try {
        setAvisosError(false);
        const snap = await getDocs(query(collection(db,"comunicados"), where("empleadorId","==",empId)));
        if (cancel) return;
        const todos = snap.docs.map(d=>({id:d.id,...(d.data() as any)}));
        const porFechaCreado = (a:any,b:any)=>(b.createdAt?.toMillis?.()||0)-(a.createdAt?.toMillis?.()||0);
        setAvisos(todos.filter((c:any)=>c.tipo==="aviso").sort(porFechaCreado));
        // Eventos: ordenados por su fecha del evento ascendente.
        setEventos(todos.filter((c:any)=>c.tipo==="evento" && c.fecha).sort((a:any,b:any)=>String(a.fecha).localeCompare(String(b.fecha))));
      } catch(e){ console.error("comunicados read:", e); if(!cancel) setAvisosError(true); }
    })();
    return ()=>{ cancel = true; };
  }, [cuenta?.empleadorId, tickTrab]);

  // Mis reportes: los que el patrón le envió (bitácora quincenal / reporte mensual).
  // Un solo where por trabajadorEmail (coincide con el grant de la regla); ordena en JS.
  useEffect(() => {
    if (!correo) return;
    let cancel = false;
    (async () => {
      try {
        setReportesError(false);
        const snap = await getDocs(query(collection(db,"reportes"), where("trabajadorEmail","==",correo)));
        if (cancel) return;
        const arr = snap.docs.map(d=>({id:d.id,...(d.data() as any)}))
          .sort((a:any,b:any)=>(b.fechaEnvio?.toMillis?.()||0)-(a.fechaEnvio?.toMillis?.()||0));
        setReportes(arr);
      } catch(e){ console.error("reportes read:", e); if(!cancel) setReportesError(true); }
    })();
    return ()=>{ cancel = true; };
  }, [correo, tickTrab]);

  // Oculta el búho de AXIOR mientras el Portal del trabajador está en pantalla
  // (sigue intacto en la vista del patrón/super-admin). Al desmontar, lo muestra.
  useEffect(() => {
    try { window.dispatchEvent(new CustomEvent("axior:ocultar")); } catch(e){}
    return () => { try { window.dispatchEvent(new CustomEvent("axior:mostrar")); } catch(e){} };
  }, []);

  // El trabajador SOLO toca estos dos campos (la regla no permite tocar otros).
  const marcarHecha = async (tarea:any) => {
    setMarcandoId(tarea.id);
    try {
      await updateDoc(doc(db,"tareas",tarea.id), { marcadaPorTrabajador:true, fechaMarcada:serverTimestamp() });
      setTareas(prev=>prev.map(x=>x.id===tarea.id?{...x, marcadaPorTrabajador:true}:x));
    } catch(e){ console.error(e); alert("No se pudo marcar la actividad. Intenta de nuevo."); }
    finally { setMarcandoId(null); }
  };

  const estadoDe = (t:any) => t.confirmadaPorPatron ? "Confirmada" : (t.marcadaPorTrabajador ? "Por confirmar" : "Pendiente");
  const pendientes = tareas.filter((t:any)=>!t.marcadaPorTrabajador && !t.confirmadaPorPatron).length;

  // ── Exportar tareas al calendario nativo (.ics estándar, generado en cliente) ──
  // EXPORTA una vez (no es sincronización en vivo): si el patrón cambia una fecha,
  // el trabajador re-exporta. Solo lectura de las actividades ya cargadas; no toca su lógica.
  const [icsMsg, setIcsMsg] = useState<string>("");
  const exportarTareasICS = () => {
    // Actividades con fecha y aún vigentes (no confirmadas por el patrón).
    const exportables = tareas.filter((t:any)=> t.fechaLimite && !t.confirmadaPorPatron);
    if (exportables.length===0) { setIcsMsg("No tienes actividades con fecha para exportar."); return; }
    setIcsMsg("");
    const esc = (s:any)=> String(s||"").replace(/\\/g,"\\\\").replace(/;/g,"\\;").replace(/,/g,"\\,").replace(/\r?\n/g,"\\n");
    const pad = (n:number)=> String(n).padStart(2,"0");
    const fmtDate = (d:Date)=> `${d.getFullYear()}${pad(d.getMonth()+1)}${pad(d.getDate())}`;
    const fmtDateTime = (d:Date)=> `${fmtDate(d)}T${pad(d.getHours())}${pad(d.getMinutes())}00`;
    const dtstamp = new Date().toISOString().replace(/[-:]/g,"").replace(/\.\d{3}Z$/,"Z");
    const L:string[] = ["BEGIN:VCALENDAR","VERSION:2.0","PRODID:-//AXIS Legaltech//Portal del trabajador//ES","CALSCALE:GREGORIAN","METHOD:PUBLISH"];
    exportables.forEach((t:any)=>{
      const [y,mo,d] = String(t.fechaLimite).split("-").map((x:string)=>parseInt(x,10));
      if (!y||!mo||!d) return;
      const horaMatch = String(t.horario||"").match(/(\d{1,2}):(\d{2})/);
      L.push("BEGIN:VEVENT");
      L.push(`UID:tarea-${t.id}@axislegaltech`);
      L.push(`DTSTAMP:${dtstamp}`);
      if (horaMatch) {
        const ini = new Date(y, mo-1, d, parseInt(horaMatch[1],10), parseInt(horaMatch[2],10));
        const fin = new Date(ini.getTime() + 60*60*1000);   // +1 hora
        L.push(`DTSTART:${fmtDateTime(ini)}`);
        L.push(`DTEND:${fmtDateTime(fin)}`);
      } else {
        const ini = new Date(y, mo-1, d);
        const fin = new Date(ini.getTime() + 24*60*60*1000); // día siguiente (DTEND exclusivo)
        L.push(`DTSTART;VALUE=DATE:${fmtDate(ini)}`);
        L.push(`DTEND;VALUE=DATE:${fmtDate(fin)}`);
      }
      L.push(`SUMMARY:${esc(t.titulo||"Actividad")}`);
      if (t.descripcion) L.push(`DESCRIPTION:${esc(t.descripcion)}`);
      // Recordatorio 1 día antes
      L.push("BEGIN:VALARM","ACTION:DISPLAY",`DESCRIPTION:${esc(t.titulo||"Actividad")}`,"TRIGGER:-P1D","END:VALARM");
      L.push("END:VEVENT");
    });
    L.push("END:VCALENDAR");
    try {
      const blob = new Blob([L.join("\r\n")], {type:"text/calendar;charset=utf-8"});
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url; a.download = "mis-tareas-axis.ics";
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      setTimeout(()=>URL.revokeObjectURL(url), 2000);
      setIcsMsg(`Se exportaron ${exportables.length} actividad${exportables.length===1?"":"es"} a tu calendario.`);
    } catch(e:any){ console.error(e); setIcsMsg("No se pudo generar el archivo. Intenta de nuevo."); }
  };

  // Exporta UN evento de empresa a .ics (mismo mecanismo/format que las actividades).
  const exportarEventoICS = (ev:any) => {
    const [y,mo,d] = String(ev?.fecha||"").split("-").map((x:string)=>parseInt(x,10));
    if (!y||!mo||!d) { setIcsMsg("Este evento no tiene fecha válida."); return; }
    setIcsMsg("");
    const esc = (s:any)=> String(s||"").replace(/\\/g,"\\\\").replace(/;/g,"\\;").replace(/,/g,"\\,").replace(/\r?\n/g,"\\n");
    const pad = (n:number)=> String(n).padStart(2,"0");
    const fmtDate = (dt:Date)=> `${dt.getFullYear()}${pad(dt.getMonth()+1)}${pad(dt.getDate())}`;
    const fmtDateTime = (dt:Date)=> `${fmtDate(dt)}T${pad(dt.getHours())}${pad(dt.getMinutes())}00`;
    const dtstamp = new Date().toISOString().replace(/[-:]/g,"").replace(/\.\d{3}Z$/,"Z");
    const horaMatch = String(ev?.hora||"").match(/(\d{1,2}):(\d{2})/);
    const L:string[] = ["BEGIN:VCALENDAR","VERSION:2.0","PRODID:-//AXIS Legaltech//Portal del trabajador//ES","CALSCALE:GREGORIAN","METHOD:PUBLISH","BEGIN:VEVENT"];
    L.push(`UID:evento-${ev.id}@axislegaltech`);
    L.push(`DTSTAMP:${dtstamp}`);
    if (horaMatch) {
      const ini = new Date(y, mo-1, d, parseInt(horaMatch[1],10), parseInt(horaMatch[2],10));
      const fin = new Date(ini.getTime() + 60*60*1000);
      L.push(`DTSTART:${fmtDateTime(ini)}`);
      L.push(`DTEND:${fmtDateTime(fin)}`);
    } else {
      const ini = new Date(y, mo-1, d);
      const fin = new Date(ini.getTime() + 24*60*60*1000);
      L.push(`DTSTART;VALUE=DATE:${fmtDate(ini)}`);
      L.push(`DTEND;VALUE=DATE:${fmtDate(fin)}`);
    }
    L.push(`SUMMARY:${esc(ev.titulo||"Evento")}`);
    if (ev.lugar) L.push(`LOCATION:${esc(ev.lugar)}`);
    if (ev.mensaje) L.push(`DESCRIPTION:${esc(ev.mensaje)}`);
    L.push("BEGIN:VALARM","ACTION:DISPLAY",`DESCRIPTION:${esc(ev.titulo||"Evento")}`,"TRIGGER:-P1D","END:VALARM");
    L.push("END:VEVENT","END:VCALENDAR");
    try {
      const blob = new Blob([L.join("\r\n")], {type:"text/calendar;charset=utf-8"});
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url; a.download = `evento-axis-${ev.fecha}.ics`;
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      setTimeout(()=>URL.revokeObjectURL(url), 2000);
      setIcsMsg("Evento agregado a tu calendario.");
    } catch(e:any){ console.error(e); setIcsMsg("No se pudo generar el archivo. Intenta de nuevo."); }
  };

  // ── Checador ────────────────────────────────────────────────────────────
  // `TipoChecada` y la máquina de estados viven a nivel de módulo: de ellas
  // dependen a la vez lo que esta pantalla ofrece y lo que la bitácora imprime.
  const [checadas, setChecadas] = useState<any[]>([]);
  // ¿Falló la lectura de sus checadas? Entonces la lista está vacía (o vieja) y no
  // dice nada de hoy: se le avisa, y puede checar igual.
  const [cargaChecadasFallo, setCargaChecadasFallo] = useState(false);
  // La última marca que ESTE teléfono guardó: frena el doble toque aunque la
  // lista no haya podido recargarse.
  const ultimaGuardadaRef = useRef<any>(null);
  const [checando, setChecando] = useState<""|TipoChecada>("");
  const [checComentario, setChecComentario] = useState("");   // comentario opcional de la próxima checada
  const [checadaMsg, setChecadaMsg] = useState<{tipo:"ok"|"err"|"info"; texto:string}|null>(null);
  // ¿ACCESO DESACTIVADO? Primero lo que trajo la sesión; y al abrir, la cuenta
  // FRESCA: el patrón pudo desactivarla hace un minuto. Si no se puede leer, se
  // queda con lo de la sesión.
  const [accesoDesactivado, setAccesoDesactivado] = useState<boolean>(cuentaDesactivada(cuenta));
  const accesoDesactivadoAhora = async (): Promise<boolean> => {
    try { const s = await getDoc(doc(db,"cuentas_trabajador",correo)); return s.exists() && cuentaDesactivada(s.data()); }
    catch(e){ return false; }
  };
  useEffect(()=>{ let cancel=false; (async()=>{
    if (!correo) return;
    try { const s = await getDoc(doc(db,"cuentas_trabajador",correo)); if (!cancel && s.exists()) setAccesoDesactivado(cuentaDesactivada(s.data())); }
    catch(e){ /* se queda con lo de la sesión */ }
  })(); return ()=>{cancel=true;}; /* eslint-disable-next-line */ }, [correo]);
  // Biometría del dispositivo (WebAuthn): soporte + si ya está enrolada aquí.
  const [bioSoporte, setBioSoporte] = useState<boolean|null>(null);
  const [bioActiva, setBioActiva] = useState(false);
  const [bioTrabajando, setBioTrabajando] = useState(false);
  const [bioMsg, setBioMsg] = useState("");
  // La huella falló (o no se pudo registrar): se enseñan las dos salidas.
  const [bioFallo, setBioFallo] = useState<{tipo:TipoChecada; motivo:string; detalle?:string}|null>(null);
  // Abierta dentro de WhatsApp, Facebook…: se explica cómo abrir en Chrome.
  const [navInterno, setNavInterno] = useState<{tipo:TipoChecada; nombre:string}|null>(null);
  // UNA CHECADA EN CURSO NO SE INTERRUMPE (11-oct-2026): desde que toca el botón
  // hasta que se guarda —con la huella, o con una salida pendiente de elegir
  // tras un fallo de huella o en un navegador interno—, la actualización forzada
  // de la plataforma espera (FranjaVersionNueva). Primero su checada; luego actualiza.
  useEffect(()=>{ marcarChecadaEnCurso(!!checando || !!bioFallo || !!navInterno); }, [checando, bioFallo, navInterno]);
  useEffect(()=> ()=> marcarChecadaEnCurso(false), []);
  const navInternoAhora = detectarNavegadorInterno(typeof navigator !== "undefined" ? navigator.userAgent : "");
  useEffect(()=>{ let cancel=false; (async()=>{ const s=await bioDisponible(); if(!cancel){ setBioSoporte(s); setBioActiva(bioEnrolada(user?.uid)); } })(); return ()=>{cancel=true;}; /* eslint-disable-next-line */ }, [user?.uid]);
  const activarBiometria = async ()=>{
    setBioMsg(""); setBioTrabajando(true);
    try {
      const nid = await bioEnrolar(user);
      setBioActiva(true); setBioMsg("Verificación activada en este aparato.");
      try { await setDoc(doc(db,"credenciales_biometricas",user.uid), { credentialId:nid, email:(user?.email||"").toLowerCase(), creadoEn: serverTimestamp() }, {merge:true}); } catch(eF){ /* best-effort */ }
    } catch(e:any){ setBioMsg(e?.message==="no_soporte" ? "Tu teléfono no admite verificación en el aparato." : "No se completó (cancelado o no disponible). Puedes intentar de nuevo."); }
    finally { setBioTrabajando(false); }
  };
  // Etiqueta de tipo de checada: usa el helper GLOBAL labelChecada (mismo que el
  // patrón, para que las etiquetas sean idénticas). El color por tipo es local.
  const colorChecada = (t:string) => t==="entrada"?"#34D399":t==="salida_comer"?"#E2B84A":t==="regreso_comer"?"#4FA3C0":"#A66A35";

  const cargarChecadas = async () => {
    if (!correo) return;
    try {
      const snap = await getDocs(query(collection(db,"checadas"), where("trabajadorEmail","==",correo)));
      const arr = snap.docs.map(d=>({id:d.id,...(d.data() as any)}))
        .sort((a:any,b:any)=>(b.timestamp?.toMillis?.()||0)-(a.timestamp?.toMillis?.()||0)); // orden en JS
      setChecadas(arr);
      setCargaChecadasFallo(false);
    } catch(e){ console.error("checadas del trabajador:", e); setCargaChecadasFallo(true); }
  };
  useEffect(() => { cargarChecadas(); /* eslint-disable-next-line */ }, [correo, tickTrab]);
  // LAS CORRECCIONES DE SU PATRÓN A SUS REGISTROS, y sus notas "no conforme" (fase
  // 2b). Con ellas, lo que ve es la VISTA EFECTIVA, la misma que la ficha del patrón
  // y los documentos (src/logica/correcciones.js).
  const [correccionesMias, setCorreccionesMias] = useState<any[]>([]);
  const [notasMias, setNotasMias] = useState<any[]>([]);
  const cargarCorrecciones = async () => {
    if (!correo) return;
    try {
      const [sco, sno] = await Promise.all([
        getDocs(query(collection(db,"correcciones_checadas"), where("trabajadorEmail","==",correo))),
        getDocs(query(collection(db,"no_conformidades"), where("trabajadorEmail","==",correo))),
      ]);
      setCorreccionesMias(sco.docs.map(d=>({id:d.id,...(d.data() as any)})));
      setNotasMias(sno.docs.map(d=>({id:d.id,...(d.data() as any)})));
    } catch(e){ console.warn("correcciones a mis registros:", e); }
  };
  useEffect(() => { cargarCorrecciones(); /* eslint-disable-next-line */ }, [correo, tickTrab]);
  const vistaMia = vistaEfectiva({checadas, correcciones: correccionesMias, noConformidades: notasMias});
  // LO QUE YA VIO: en su cuenta (`usuarios/{uid}.correccionesVistas`), como las
  // actualizaciones. Mientras no se sabe (null), no se le avisa de nada.
  const correccionesVistas = useNovedadesVistas(user?.uid, CAMPO_CORRECCIONES_VISTAS);
  const correccionesSinVer = correccionesVistas.vistas === null ? [] : correccionesMias.filter((c:any)=> correccionesVistas.vistas!.indexOf(c.id) < 0);

  const registrarChecada = async (tipo:TipoChecada) => {
    if (accesoDesactivado) { setChecadaMsg({tipo:"err", texto: TEXTO_ACCESO_DESACTIVADO}); return; }
    if (checando) { setChecadaMsg({tipo:"info", texto: TEXTO_CHECADA_EN_CURSO}); return; }
    // ── EL DOBLE TOQUE, Y SOLO ÉL: la misma marca en menos de 2 minutos ──────
    // Antes se negaba cualquier segunda marca del mismo tipo en el día, y eso
    // dejaba sin entrada al que vuelve a entrar después de salir. Una segunda
    // marca más tarde se registra; el aviso la explica antes (ver pedirChecada).
    if (frenarDobleToque(tipo)) return;
    setChecando(tipo); setChecadaMsg(null); setBioFallo(null); setNavInterno(null);
    // ── Biometría del dispositivo (WebAuthn): NUNCA BLOQUEA ──────────────────
    // Antes, con soporte, era obligatoria: si fallaba o se cancelaba salía
    // "Necesitas confirmar tu biometría… Intenta de nuevo." y NO había salida.
    // Un trabajador de un cliente se quedó así sin poder checar. Ahora cada fallo
    // abre una salida, y la checada que sale sin huella lleva escrito el motivo.
    //
    // 1. NAVEGADOR INTERNO (WhatsApp, Facebook, Instagram…): ahí la huella casi
    //    nunca existe. Ni se intenta: se explica cómo abrir en Chrome y se deja
    //    checar, anotando "navegador_interno" y cuál era.
    const interno = detectarNavegadorInterno(typeof navigator !== "undefined" ? navigator.userAgent : "");
    if (interno) { setNavInterno({tipo, nombre: interno}); setChecando(""); return; }
    // 2. Sin biometría en el teléfono: se registra, como siempre, con su motivo.
    const soportaBio = await bioDisponible();
    if (!soportaBio) { await guardarChecada(tipo, {verif:false, motivo:MOTIVOS_BIO.DISPOSITIVO}); return; }
    // 3. Si el patrón restableció la biometría después de crear esta llave, se
    //    olvida: la siguiente verificación registrará una llave nueva.
    await aplicarRestablecimiento();
    // 4. Con llave: se verifica. Si falla o se cancela, se ofrecen las salidas.
    if (bioEnrolada(user?.uid)) {
      let ok = false;
      try { ok = await bioVerificar(user); } catch(eBio){ ok = false; }
      if (ok) { await guardarChecada(tipo, {verif:true}); return; }
      setBioFallo({tipo, motivo: MOTIVOS_BIO.FALLIDA}); setChecando(""); return;
    }
    // 5. Sin llave (primer uso, o recién restablecida): se registra una. Si no se
    //    puede, también se ofrecen las salidas.
    try { await enrolarHuella(); }
    catch(eBio){ setBioFallo({tipo, motivo: MOTIVOS_BIO.SIN_HUELLA}); setChecando(""); return; }
    await guardarChecada(tipo, {verif:true});
  };

  // Registra una llave nueva con el bloqueo del propio teléfono, la guarda en
  // este navegador (con su fecha) y en credenciales_biometricas. Lanza si no se pudo.
  const enrolarHuella = async () => {
    const nid = await bioEnrolar(user);
    if (!nid) throw new Error("cancelado");
    setBioActiva(true);
    try { await setDoc(doc(db,"credenciales_biometricas",user.uid), { credentialId:nid, email:correo, creadoEn: serverTimestamp() }, {merge:true}); } catch(eF){ /* localStorage ya guardó; Firestore es best-effort */ }
  };

  // "Restablecer biometría" del patrón: si su fecha es posterior a la de la llave
  // de este teléfono, la llave se olvida. Se lee la cuenta FRESCA (el patrón pudo
  // restablecer hace un minuto); si no se puede leer, se usa la que ya había.
  const aplicarRestablecimiento = async () => {
    let r:any = cuenta?.bioRestablecidaEn;
    try { const s = await getDoc(doc(db,"cuentas_trabajador",correo)); if (s.exists()) r = (s.data() as any)?.bioRestablecidaEn; } catch(e){ /* se queda con la de la sesión */ }
    const ms = r?.toMillis?.() || 0;
    if (bioEnrolada(user?.uid) && llaveAnteriorAlRestablecimiento(ms, bioFechaLlave(user?.uid))) { bioOlvidar(user?.uid); setBioActiva(false); }
  };

  // SALIDA 1: "Registrar mi huella de nuevo en este teléfono". Llave nueva con el
  // bloqueo del propio teléfono —el mismo que ya lo protege—, sustituye a la de
  // este navegador, se anota en credenciales_biometricas, y se registra la checada.
  const registrarHuellaDeNuevo = async () => {
    const f = bioFallo; if (!f || checando) return;
    setChecando(f.tipo);
    bioOlvidar(user?.uid); setBioActiva(false);
    try { await enrolarHuella(); }
    catch(e){
      setBioFallo({...f, detalle:"No se pudo registrar la huella en este teléfono. Puedes checar sin verificación en el aparato: tu patrón lo verá, con el motivo."});
      setChecando(""); return;
    }
    setBioFallo(null);
    await guardarChecada(f.tipo, {verif:true});
  };
  // SALIDA 2, el último recurso: "Checar sin biometría". Se registra, con el motivo.
  const checarSinBiometria = async () => {
    const f = bioFallo; if (!f || checando) return;
    setBioFallo(null);
    await guardarChecada(f.tipo, {verif:false, motivo:f.motivo});
  };
  // Desde un navegador interno, si aun así checa: se registra con su motivo y la app.
  const checarDesdeNavegadorInterno = async () => {
    const n = navInterno; if (!n || checando) return;
    setNavInterno(null);
    await guardarChecada(n.tipo, {verif:false, motivo:MOTIVOS_BIO.NAVEGADOR_INTERNO, navegador:n.nombre});
  };

  // GUARDAR LA CHECADA. Es lo único que escribe, y lo hace igual venga de donde
  // venga: con huella, sin ella y con cuál de los motivos.
  const guardarChecada = async (tipo:TipoChecada, bio:{verif:boolean; motivo?:string; navegador?:string}) => {
    setChecando(tipo);
    const verifBio = bio.verif === true;
    // Pide ubicación; si se niega o falla, registra IGUAL con ubicacionDisponible=false.
    // UNA POSICIÓN FRESCA: como mucho de hace 10 s (antes se aceptaba una de hace
    // un minuto, tomada quizá en otro sitio), con la misma espera de 10 s. Y con
    // su precisión en metros, que se GUARDA y todavía no decide nada: dentro o
    // fuera se sigue calculando igual.
    const obtenerPos = () => new Promise<{lat:number; lng:number; precision:number|null}|null>((resolve) => {
      if (!navigator.geolocation) { resolve(null); return; }
      navigator.geolocation.getCurrentPosition(
        (p)=>resolve({lat:p.coords.latitude, lng:p.coords.longitude, precision: isFinite(Number(p.coords.accuracy)) ? Number(p.coords.accuracy) : null}),
        ()=>resolve(null),
        {enableHighAccuracy:true, timeout:10000, maximumAge:10000}
      );
    });
    try {
      // La posición y el horario de AHORA, a la vez: el horario se relee de la
      // fuente (horarioDelTrabajadorAhora) y es el que va como testigo y el que
      // califica el mensaje. Si no se puede leer, el de la pantalla.
      // Y SU SEDE Y SU RAZÓN SOCIAL DE AHORA (sedeYRazonDelTrabajadorAhora), igual.
      const [pos, horarioAhora, lugarAhora] = await Promise.all([obtenerPos(),
        horarioDelTrabajadorAhora({uid: user?.uid || "", empleadorId: cuenta?.empleadorId || "", respaldo: miHorario}),
        sedeYRazonDelTrabajadorAhora({uid: user?.uid || "", empleadorId: cuenta?.empleadorId || "", respaldo: {sede: miSede, razon: miRazonSocial}})]);
      const base:any = {
        empleadorId: cuenta?.empleadorId || "",
        trabajadorEmail: correo,
        trabajadorNombre: cuenta?.nombre || nombre,
        tipo,
        comentario: checComentario.trim(),   // opcional; "" si no se puso (no rompe la checada normal)
        timestamp: serverTimestamp(),
        horaServidor: serverTimestamp(),      // HORA OFICIAL (servidor Firestore)
        horaDispositivo: new Date().toISOString(), // referencia local del dispositivo
        ubicacionDisponible: !!pos,
        verificacionBiometrica: verifBio,     // true si pasó biometría
        // EL TESTIGO: el horario que le resolvió horarioVigente al teléfono en este
        // momento, en la forma que exigen las reglas (null si no tiene uno válido).
        // NO decide la clasificación —la decide el historial—; sirve para ver si el
        // teléfono trabajaba con otro horario.
        horarioAplicado: horarioAplicadoDe(horarioAhora),
      };
      // SIN HUELLA, SIEMPRE CON SU PORQUÉ: el patrón lo ve en la ficha y en el
      // portal móvil (ver etiquetaBiometria en src/logica/biometria.js).
      if (!verifBio) base.motivoSinBiometria = bio.motivo || MOTIVOS_BIO.DISPOSITIVO;
      if (!verifBio && bio.navegador) base.navegadorInterno = bio.navegador;
      if (pos) { base.lat = pos.lat; base.lng = pos.lng; }
      if (pos && pos.precision != null) base.precisionMetros = Math.round(pos.precision);
      // GEOCERCA CONTRA SU SEDE VIGENTE (11-oct-2026), NO contra la ubicación
      // general: quien trabaja en otra planta ya no sale "Fuera" en cada checada.
      // NO BLOQUEA: solo marca. Sin GPS o sin sede, se registra igual, sin geocerca.
      const med = medirContraSede(pos, lugarAhora?.sede);
      if (med) { base.distanciaMetros = med.distanciaMetros; base.dentroDeUbicacion = med.dentroDeUbicacion; }
      // EL TESTIGO: la sede y la razón social que le resolvió el teléfono al checar
      // (forma validada por las reglas). Las checadas viejas no lo tienen y se
      // muestran como constan: nunca se reinterpretan con la sede de hoy.
      const sedeTestigo = sedeAplicadaDe(lugarAhora?.sede);
      if (sedeTestigo) base.sedeAplicada = sedeTestigo;
      const razonTestigo = razonSocialAplicadaDe(lugarAhora?.razon);
      if (razonTestigo) base.razonSocialAplicada = razonTestigo;
      const ref = await addDoc(collection(db,"checadas"), base);
      ultimaGuardadaRef.current = {tipo, horaDispositivo: base.horaDispositivo};
      // Hora OFICIAL = servidor: relee el doc para obtener el serverTimestamp resuelto.
      // Defensivo: si falla o aún es null, cae a la hora del dispositivo.
      let cuando:Date = new Date();
      try { const snap = await getDoc(ref); const d:any = snap.data(); const hs = d?.horaServidor?.toDate?.() || d?.timestamp?.toDate?.(); if (hs) cuando = hs; } catch(eR){ /* usa hora del dispositivo */ }
      // Clasifica SOLO la entrada contra su horario vigente (salida sin clasificar).
      let extraClasif = "";
      if (tipo==="entrada") {
        // Se le dice cómo quedó, con su horario de ahora. NO se guarda en la
        // checada: una clasificación guardada se quedaba ganándole al horario
        // aunque este cambiara (y las reglas no dejan al trabajador escribirla).
        const c = clasificarEntrada(horarioAhora, cuando);
        if (c!=="sin_horario") extraClasif = ` · ${clasifAsistenciaMeta(c).trabajador}`;
      }
      const lbl = labelChecada(tipo);
      const notaBio = verifBio ? ""
        : base.motivoSinBiometria === MOTIVOS_BIO.DISPOSITIVO ? " · sin verificación en el aparato: tu teléfono no la admite (registrada igual)"
        : base.motivoSinBiometria === MOTIVOS_BIO.NAVEGADOR_INTERNO ? " · sin verificación en el aparato, porque la abriste desde " + (bio.navegador || "otra app") + " (queda anotado)"
        : " · sin verificación en el aparato (queda anotado para tu patrón)";
      setChecadaMsg(pos
        ? {tipo:"ok",   texto:`${lbl} registrada${extraClasif}${notaBio}.`}
        : {tipo:"info", texto:`${lbl} registrada${extraClasif} · sin ubicación${notaBio}.`});
      setChecComentario("");
      cargarChecadas();
    } catch(e:any){
      console.error(e);
      // ¿LA RECHAZARON PORQUE SU ACCESO ESTÁ DESACTIVADO? Se mira la cuenta en ese
      // momento; si lo está, se dice eso y los botones se apagan.
      const negada = e?.code === "permission-denied" || /permission/i.test(String(e?.message||""));
      if (negada && await accesoDesactivadoAhora()) { setAccesoDesactivado(true); setChecadaMsg({tipo:"err", texto: TEXTO_ACCESO_DESACTIVADO}); }
      else setChecadaMsg({tipo:"err", texto: mensajeDeFallo(e, {accion:"registrar tu checada", denegado:"Tu cuenta no tiene permiso para registrar checadas. Avísale a tu patrón.", siSigue:"si sigue fallando, avísale a tu patrón"})});
    }
    finally { setChecando(""); }
  };
  // EL DOBLE TOQUE: la misma marca, otra vez, en menos de 2 minutos. Se mira la
  // lista y lo último que guardó este teléfono (por si la lista no se recargó).
  const frenarDobleToque = (tipo:TipoChecada): boolean => {
    const ultima = ultimaGuardadaRef.current;
    if (!esDobleToque(tipo, ultima ? [...(checadas||[]), ultima] : (checadas||[]), Date.now())) return false;
    setChecadaMsg({tipo:"info", texto:`Esa marca (${labelChecada(tipo).toLowerCase()}) ya quedó registrada hace menos de 2 minutos; no se registró otra vez.`});
    return true;
  };

  const fechaLocal = (d:Date) => `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`;
  const hoyLocal = fechaLocal(new Date());
  // La hora OFICIAL manda, igual que en el reporte: `horaServidor` primero y
  // `timestamp` de respaldo. Antes esta lista miraba solo `timestamp`, así que
  // una checada sin él quedaba fuera del día en esta pantalla y dentro en el
  // reporte — el mismo hecho, dos respuestas.
  const checadasHoy = checadas.filter((c:any)=>{ const d=horaDeChecada(c); return !!d && fechaLocal(d)===hoyLocal; });
  // EN QUÉ ESTADO ESTÁ AHORA MISMO. De aquí sale lo que el checador ofrece.
  const ultimaHoy = ultimaChecadaDe(checadasHoy);
  const checadaSugerida = siguienteChecadaSugerida(ultimaHoy ? ultimaHoy.tipo : null);
  // Lo que se va a registrar y lo que implica, para enseñarlo ANTES de guardar.
  const [confirmarChecada, setConfirmarChecada] = useState<{tipo:TipoChecada; texto:string}|null>(null);
  // Puerta única: si el movimiento encaja se registra; si no, se dice qué pasa y
  // se deja decidir. No se bloquea nada.
  const pedirChecada = (tipo:TipoChecada) => {
    if (accesoDesactivado) { setChecadaMsg({tipo:"err", texto: TEXTO_ACCESO_DESACTIVADO}); return; }
    if (checando) { setChecadaMsg({tipo:"info", texto: TEXTO_CHECADA_EN_CURSO}); return; }
    if (frenarDobleToque(tipo)) return;
    // Sin la lista de hoy no se sabe qué hubo antes: no se inventa un aviso.
    if (cargaChecadasFallo) { registrarChecada(tipo); return; }
    const aviso = consecuenciaDeChecar(tipo, ultimaHoy ? ultimaHoy.tipo : null, ultimaHoy ? ultimaHoy.cuando : null)
      || avisoDeSegundaMarca(tipo, checadasHoy);
    if (!aviso) { registrarChecada(tipo); return; }
    setConfirmarChecada({tipo, texto: aviso});
  };

  // ── Ficha propia del trabajador (SOLO LECTURA) para Perfil: Mi cumplimiento y
  // Mis documentos. Se lee por cuentaUid == su uid. Requiere la regla de Firestore
  // que permite al trabajador leer SU propia ficha; si aún no está publicada, la
  // lectura falla y la UI muestra un estado suave (no rompe el resto del portal).
  const [fichaPropia, setFichaPropia] = useState<any|null>(null);
  const [fichaEstado, setFichaEstado] = useState<"cargando"|"ok"|"vacia"|"error">("cargando");
  // EN VIVO (escucharFichaPropia): si el patrón le cambia o le apaga el horario
  // personalizado con la pantalla abierta, la pantalla lo ve sin recargar.
  useEffect(() => {
    if (!user?.uid) { setFichaEstado("vacia"); return; }
    setFichaEstado("cargando");
    return escucharFichaPropia(user.uid, (f, estado)=>{ setFichaPropia(f); setFichaEstado(estado); });
  }, [user?.uid, tickTrab]);

  // ── Flotilla — registro por ESTADO DE VIAJE ───────────────────────────────
  // Antes esta pantalla ofrecía un menú de tres botones —salida, llegada,
  // regreso— y dejaba que la persona eligiera. Eso pone la coherencia del viaje
  // en manos de quien está en la carretera con el motor prendido: se registraban
  // regresos sin salida, o dos salidas seguidas de la misma unidad.
  // Ahora la pantalla calcula si trae un viaje abierto y solo ofrece el paso que
  // toca. Menos decisiones, y un viaje que se puede armar al leerlo.
  const empleadorId = cuenta?.empleadorId || "";
  // LA CONFIGURACIÓN DE SU EMPRESA, leída de la fuente. Hasta ahora el horario le
  // llegaba como una COPIA en su propia ficha, escrita por el patrón al guardar; a
  // quien se daba de alta después no le llegaba nunca y se quedaba sin horario y
  // sin geocerca, sin que nada lo dijera.
  //
  // Mientras las reglas de `configuracion_empresa` no estén publicadas esta lectura
  // falla, y todo cae al respaldo de siempre: nadie se queda peor que antes.
  const [cfgEmpresa, setCfgEmpresa] = useState<any|null>(null);
  // EN VIVO (escucharConfigEmpresa): el horario general y el centro de trabajo.
  useEffect(()=>{
    if (!empleadorId) { setCfgEmpresa(null); return; }
    return escucharConfigEmpresa(empleadorId, (c)=>{ if (c) setCfgEmpresa(c); });
  }, [empleadorId, tickTrab]);
  // Su horario: el suyo si lo tiene, el general de su empresa si no, y la copia de
  // su ficha solo mientras la fuente no esté disponible. MISMA resolución que el
  // panel del patrón —horarioVigente—, para que no puedan decir cosas distintas.
  // DE LA FUENTE, y solo de la fuente. El respaldo a `fichaPropia.horarioEfectivo`
  // existía mientras la configuración de empresa no estuviera migrada ni sus reglas
  // publicadas. Ya lo están, así que el respaldo sobra: mantenerlo obligaba a
  // seguir copiando el horario a cada ficha, que es el defecto que se cierra aquí.
  const miHorario = horarioVigente(fichaPropia, cfgEmpresa?.horarioLaboral || null);
  // SU SEDE Y SU RAZÓN SOCIAL (11-oct-2026). La sede asignada en su ficha
  // (`sedeId`; sin asignar, la principal: la ubicación de la empresa de siempre) y
  // su documento del catálogo, EN VIVO. Contra ella se mide dentro/fuera; al checar
  // se relee (sedeYRazonDelTrabajadorAhora). Sin ficha vinculada no se puede leer
  // su sede: rige la principal (TEXTO_FICHA_SIN_VINCULAR).
  const miSedeId = String(fichaPropia?.sedeId || SEDE_PRINCIPAL);
  const miRazonId = String(fichaPropia?.razonSocialId || RAZON_PRINCIPAL);
  const [docMiSede, setDocMiSede] = useState<any|null>(null);
  const [docMiRazon, setDocMiRazon] = useState<any|null>(null);
  useEffect(()=>{
    setDocMiSede(null);
    if (!empleadorId || miSedeId === SEDE_PRINCIPAL) return;
    return onSnapshot(doc(db, COL_CONFIG_EMPRESA, empleadorId, "sedes", miSedeId),
      (d:any)=> setDocMiSede(d.exists() ? {id:d.id, ...d.data()} : null), (e:any)=> console.warn("mi sede (en vivo):", e));
  }, [empleadorId, miSedeId, tickTrab]);
  useEffect(()=>{
    setDocMiRazon(null);
    if (!empleadorId || miRazonId === RAZON_PRINCIPAL) return;
    return onSnapshot(doc(db, COL_CONFIG_EMPRESA, empleadorId, "razones_sociales", miRazonId),
      (d:any)=> setDocMiRazon(d.exists() ? {id:d.id, ...d.data()} : null), (e:any)=> console.warn("mi razón social (en vivo):", e));
  }, [empleadorId, miRazonId, tickTrab]);
  const miSede = sedeDeId(miSedeId, catalogoDeSedes(cfgEmpresa, docMiSede ? [docMiSede] : []));
  const miRazonSocial = razonSocialDeId(miRazonId, catalogoDeRazones(cfgEmpresa, docMiRazon ? [docMiRazon] : []));
  const [vehiculosPatron, setVehiculosPatron] = useState<any[]>([]);
  // Lo visto de las actualizaciones, en la cuenta (vale en todos los aparatos).
  const novedadesTrab = useNovedadesVistas(user?.uid);
  const [vehiculoFlota, setVehiculoFlota] = useState("");
  const [registrandoFlota, setRegistrandoFlota] = useState<""|"salida"|"llegada"|"regreso">("");
  const [flotaMsg, setFlotaMsg] = useState<{tipo:"ok"|"err"|"info"; texto:string}|null>(null);
  // Paso que se está capturando. `null` = no hay formulario abierto, solo los
  // botones de acción. No es un selector: lo fija el botón que se tocó.
  const [flotaPaso, setFlotaPaso] = useState<null|"salida"|"llegada"|"regreso">(null);
  const [flotaKm, setFlotaKm] = useState("");
  const [flotaDestino, setFlotaDestino] = useState("");
  const [flotaObs, setFlotaObs] = useState("");
  const [flotaEstado, setFlotaEstado] = useState<"normal"|"revision"|"incidente">("normal");
  // Fotos elegidas ANTES de guardar. Se pueden quitar mientras se compone el
  // movimiento; una vez guardado, no: un asiento de bitácora del que se pueden
  // borrar las pruebas deja de servir como prueba.
  const [flotaFotos, setFlotaFotos] = useState<{file:File; preview:string}[]>([]);
  // El progreso mientras se guarda: cual de cuantas y su porcentaje. Con `i:0` es
  // el video, que va despues de las fotos.
  const [flotaSubiendo, setFlotaSubiendo] = useState<{i:number; total:number; pct:number}|null>(null);
  // UN video por movimiento. Se elige aqui y se sube al guardar, junto a las fotos.
  const [flotaVideo, setFlotaVideo] = useState<File|null>(null);
  // Seis, no tres: con tres no caben los cuatro costados de un vehiculo mas el
  // odometro. Ver `MAX_FOTOS_MOVIMIENTO`, donde esta el porque junto al del
  // accidente, que necesita mas.
  const MAX_FOTOS_MOV = MAX_FOTOS_MOVIMIENTO;
  // Id de la salida cuyo viaje queda SIN REGRESO al abrir uno nuevo. Nadie
  // reescribe el asiento anterior: el hecho se declara desde la salida nueva,
  // que es un acto nuevo, fechado y atribuible a quien lo hizo.
  const [flotaCierraViaje, setFlotaCierraViaje] = useState<string>("");
  // Movimientos QUE ESTA PERSONA registró, para saber si trae un viaje abierto.
  const [misMovs, setMisMovs] = useState<any[]>([]);
  const [misMovsError, setMisMovsError] = useState(false);
  const [misMovsCargando, setMisMovsCargando] = useState(true);

  // Lectura de los movimientos propios.
  //
  // Se filtra por `registradoPorEmail` y no por `conductorEmail` porque la regla
  // de Firestore autoriza exactamente eso: quien capturó el movimiento puede
  // releerlo. El conductor puede ser otra persona; el capturista, no.
  //
  // Sin `orderBy`: dos igualdades más un orden por otro campo exigen índice
  // compuesto. Se ordena en JS, igual que ya hace la búsqueda de salida previa
  // del formulario del patrón.
  //
  // Los movimientos anteriores a este cambio no tienen `registradoPorEmail` y
  // quedan fuera. Es intencional: el viaje abierto es de hoy.
  useEffect(() => {
    if (!empleadorId || !correo) { setMisMovs([]); setMisMovsCargando(false); return; }
    let cancel = false;
    (async () => {
      setMisMovsCargando(true); setMisMovsError(false);
      try {
        const snap = await getDocs(query(collection(db,"flotilla"),
          where("userId","==",empleadorId),
          where("registradoPorEmail","==",correo)));
        if (cancel) return;
        const arr = snap.docs.map(d=>({id:d.id, ...(d.data() as any)}))
          .sort((a:any,b:any)=> ((b.timestamp?.toMillis?.()||0) - (a.timestamp?.toMillis?.()||0)));
        setMisMovs(arr);
      } catch(e){ if (!cancel) { console.error("mis movimientos de flotilla:", e); setMisMovsError(true); } }
      finally { if (!cancel) setMisMovsCargando(false); }
    })();
    return () => { cancel = true; };
  }, [empleadorId, correo, tickTrab]);

  // VIAJE ABIERTO = la salida más reciente sin un regreso posterior.
  // Se camina hacia atrás sobre los movimientos (ya ordenados de nuevo a viejo)
  // hasta encontrar la salida más reciente; si en el camino apareció un regreso,
  // ese viaje ya se cerró y no hay nada abierto.
  const viajeAbierto = (() => {
    let regresoVisto = false;
    for (const m of misMovs) {
      const t = String(m.tipo||"").toLowerCase();
      if (t === "regreso") { regresoVisto = true; continue; }
      if (t === "salida") {
        if (regresoVisto) return null;                 // la última salida ya se cerró
        const msSalida = m.timestamp?.toMillis?.() || 0;
        // Las paradas son las llegadas posteriores a esa salida.
        const paradas = misMovs.filter((x:any)=> String(x.tipo||"").toLowerCase()==="llegada"
          && (x.timestamp?.toMillis?.()||0) > msSalida).length;
        return {salida:m, msSalida, paradas};
      }
    }
    return null;
  })();
  useEffect(() => {
    if (!empleadorId) return;
    (async () => {
      try {
        setVehiculosError(false);
        // Unidades del patrón. La lectura la autoriza la rama de `vehiculos` que
        // comprueba en `cuentas_trabajador` que este correo pertenece a ESE patrón
        // (misma forma que `comunicados`). Antes decía "lectura pública permitida por
        // reglas": era cierto con acceso anónimo y dejó de serlo al cerrarlo.
        // Filtra/ordena en JS.
        const snap = await getDocs(query(collection(db,"vehiculos"), where("userId","==",empleadorId)));
        const arr = snap.docs.map(d=>({id:d.id,...(d.data() as any)}))
          .filter((v:any)=>(v.status||"activo")==="activo")
          .sort((a:any,b:any)=>(a.placa||"").localeCompare(b.placa||""));
        setVehiculosPatron(arr);
      } catch(e){ console.error("vehiculos del patron:", e); setVehiculosError(true); }
    })();
  }, [empleadorId, tickTrab]);

  // Fotos elegidas para el movimiento que se está componiendo. Se comprimen al
  // subir, no aquí: mientras se compone solo se guarda el archivo y una vista
  // previa local, para que quitar una foto no cueste una subida ya hecha.
  const agregarFotosFlota = (files: FileList|null) => {
    if (!files || files.length===0) return;
    setFlotaMsg(null);
    const libres = MAX_FOTOS_MOV - flotaFotos.length;
    if (libres <= 0) { setFlotaMsg({tipo:"info", texto:`Máximo ${MAX_FOTOS_MOV} fotos por movimiento.`}); return; }
    const nuevas: {file:File; preview:string}[] = [];
    const rechazadas: string[] = [];
    for (let i=0; i<files.length && nuevas.length<libres; i++) {
      const f = files[i];
      if (!f.type.startsWith("image/")) continue;
      // El peso, AL ELEGIR. Antes se descubria al guardar, con el formulario ya
      // lleno y en la carretera.
      const malo = motivoRechazo(f);
      if (malo) { rechazadas.push(f.name + " — " + malo); continue; }
      nuevas.push({file:f, preview:URL.createObjectURL(f)});
    }
    if (rechazadas.length) setFlotaMsg({tipo:"info", texto:"No se agregaron: " + rechazadas.join(", ") + "."});
    else if (files.length > nuevas.length) setFlotaMsg({tipo:"info", texto:`Se agregaron ${nuevas.length}; el máximo es ${MAX_FOTOS_MOV} fotos por movimiento.`});
    setFlotaFotos(prev=>[...prev, ...nuevas]);
  };
  const quitarFotoFlota = (i:number) => {
    setFlotaFotos(prev=>{
      const f = prev[i];
      if (f?.preview) { try { URL.revokeObjectURL(f.preview); } catch {} }
      return prev.filter((_,j)=>j!==i);
    });
  };
  const limpiarFormFlota = () => {
    flotaFotos.forEach(f=>{ try { URL.revokeObjectURL(f.preview); } catch {} });
    setFlotaFotos([]); setFlotaVideo(null); setFlotaSubiendo(null);
    setVehiculoFlota(""); setFlotaKm(""); setFlotaDestino("");
    setFlotaObs(""); setFlotaEstado("normal"); setFlotaPaso(null); setFlotaCierraViaje("");
  };

  // Último kilometraje conocido de una unidad, para avisar de una lectura rara.
  // Solo puede mirar lo que esta persona tiene derecho a leer —sus propios
  // movimientos— más el kilometraje que el patrón registró en la ficha de la
  // unidad. Si otro conductor capturó algo más reciente, aquí no se ve: por eso
  // el aviso NUNCA bloquea, solo pregunta.
  // Devuelve la lectura Y CUÁNDO se tomó: sin el cuándo no se puede calcular el
  // techo de kilómetros, porque el mismo salto es normal en tres días e imposible
  // en veinte minutos.
  const ultimoKmDeUnidad = (vehiculoId:string, placa:string): {km:number; ms:number}|null => {
    const pl = String(placa||"").toUpperCase().replace(/[^A-Z0-9]/g,"");
    let mejor: {km:number; ms:number}|null = null;
    misMovs.forEach((m:any)=>{
      const mismaUnidad = (m.vehiculoId && m.vehiculoId===vehiculoId)
        || (!m.vehiculoId && String(m.placa||"").toUpperCase().replace(/[^A-Z0-9]/g,"")===pl);
      if (!mismaUnidad) return;
      const km = [m.kmFinal, m.kmLlegada, m.kmInicial].map((x:any)=> (x===null||x===undefined||x==="") ? null : Number(x))
        .find((x:any)=> x!==null && Number.isFinite(x));
      if (km===undefined || km===null) return;
      const ms = m.timestamp?.toMillis?.() || 0;
      if (!mejor || ms > mejor.ms) mejor = {km: km as number, ms};
    });
    if (mejor) return mejor;
    // El kilometraje de la ficha no trae fecha: sirve para detectar que la lectura
    // retrocede, pero NO para juzgar el tamaño del salto. Va con ms:0 y quien lo
    // use tiene que mirarlo antes de hablar de techos.
    const veh = vehiculosPatron.find((v:any)=>v.id===vehiculoId);
    const kmFicha = veh?.kilometraje;
    if (kmFicha===null || kmFicha===undefined || kmFicha==="") return null;
    return {km: Number(kmFicha), ms: 0};
  };

  // Guarda UN movimiento. `paso` viene del botón que se tocó, no de un selector.
  // En llegada y regreso la unidad NO se vuelve a preguntar: se hereda de la
  // salida abierta, con su vehiculoId, para que el viaje entero quede ligado a
  // la misma unidad aunque la placa se escribiera distinto alguna vez.
  const registrarFlota = async (paso:"salida"|"llegada"|"regreso") => {
    if (registrandoFlota || !empleadorId) return;
    // Unidad: elegida en salida, heredada en los demás pasos.
    let vehId = "", placaMov = "";
    if (paso === "salida") {
      const veh = vehiculosPatron.find((v:any)=>v.id===vehiculoFlota);
      if (!veh) { setFlotaMsg({tipo:"err", texto:"Selecciona la unidad con la que sales."}); return; }
      vehId = veh.id; placaMov = String(veh.placa||"").toUpperCase();
    } else {
      if (!viajeAbierto) { setFlotaMsg({tipo:"err", texto:"Ya no tienes un viaje abierto. Vuelve a entrar a Flotilla."}); return; }
      vehId = viajeAbierto.salida.vehiculoId || "";
      placaMov = String(viajeAbierto.salida.placa||"").toUpperCase();
    }
    // KILOMETRAJE OPCIONAL. Solo se pide en salida y regreso, que es donde sirve
    // para calcular distancia. Si viene vacío la propiedad NO se escribe: un cero
    // o un NaN serían una lectura inventada, y la ausencia de dato no es una falta.
    const kmTexto = (paso === "llegada") ? "" : flotaKm.trim();
    const kmValor = kmTexto === "" ? null : Number(kmTexto);
    if (kmTexto !== "" && !Number.isFinite(kmValor)) {
      setFlotaMsg({tipo:"err", texto:"El kilometraje tiene que ser un número, o puedes dejarlo vacío."}); return;
    }
    setRegistrandoFlota(paso); setFlotaMsg(null);
    const obtenerPos = () => new Promise<{lat:number; lng:number}|null>((resolve) => {
      if (!navigator.geolocation) { resolve(null); return; }
      navigator.geolocation.getCurrentPosition(
        (p)=>resolve({lat:p.coords.latitude, lng:p.coords.longitude}),
        ()=>resolve(null),
        {enableHighAccuracy:true, timeout:10000, maximumAge:60000}
      );
    });
    // El id se genera ANTES de escribir para poder meterlo en la ruta de las
    // fotos. Se guarda con setDoc sobre ese id —que para las reglas sigue siendo
    // un create— y no con addDoc + update: el trabajador no tiene permiso de
    // actualizar movimientos, solo de crearlos.
    const refMov = doc(collection(db,"flotilla"));
    let fotosSubidas: {url:string; path:string}[] = [];
    let fallaronFotos = 0;
    try {
      const pos = await obtenerPos();
      // Las fotos suben ANTES del documento. Si algo falla, el movimiento se
      // guarda igual y se dice con todas sus letras cuál de las dos cosas quedó.
      for (let i=0; i<flotaFotos.length; i++) {
        try {
          // EL PROGRESO, FOTO POR FOTO. Antes solo decia "Guardando…" y en una
          // carretera con una barra de señal eso puede durar minutos sin que nadie
          // sepa si avanza o si se colgo.
          setFlotaSubiendo({i: i+1, total: flotaFotos.length, pct: 0});
          const r = await subirFotoMovimiento(user?.uid||"", empleadorId, refMov.id, i+1, flotaFotos[i].file,
            (p)=>setFlotaSubiendo({i: i+1, total: flotaFotos.length, pct: p}));
          fotosSubidas.push(r);
        } catch(e){ console.error("foto de movimiento:", e); fallaronFotos++; }
      }
      setFlotaSubiendo(null);
      const now = new Date();
      const base:any = {
        userId: empleadorId,
        tipo: paso,
        vehiculoId: vehId,
        placa: placaMov,
        conductor: cuenta?.nombre || nombre,
        conductorNombre: cuenta?.nombre || nombre,
        conductorEmail: correo,
        trabajadorEmail: correo,
        trabajadorNombre: cuenta?.nombre || nombre,
        empleadorId: empleadorId,
        empresaId: empleadorId,
        fecha: now.toLocaleDateString("es-MX"),
        hora: now.toLocaleTimeString("es-MX",{hour:"2-digit",minute:"2-digit"}),
        timestamp: Timestamp.now(),
        // IDENTIDAD del capturista. Además de hacer atribuible el registro, es el
        // campo por el que la regla de Firestore le deja releer lo suyo: por eso
        // no puede faltar nunca.
        registradoPorEmail: correo,
        registradoPorUid: user?.uid || "",
        registradoPorNombre: cuenta?.nombre || nombre || correo,
        registradoPorRol: "trabajador",
        observaciones: flotaObs.trim(),
      };
      if (pos) { base.lat = pos.lat; base.lng = pos.lng; }
      if (fotosSubidas.length) base.fotos = fotosSubidas;
      // El viaje se enlaza también por id de la salida: al leer no hay que
      // adivinar a qué recorrido pertenece esta parada.
      if (paso !== "salida" && viajeAbierto?.salida?.id) base.salidaId = viajeAbierto.salida.id;
      // CIERRE SIN REGRESO. Esta salida declara que el viaje anterior se quedó
      // sin cerrar. No se marca por tiempo transcurrido ni se inventa una hora de
      // regreso: se registra que la persona salió en otra unidad, que es lo único
      // que de verdad ocurrió.
      if (paso === "salida" && flotaCierraViaje) {
        base.cierraViajeId = flotaCierraViaje;
        base.cierraViajeMotivo = "salida_en_otra_unidad";
      }
      if (paso === "salida") {
        if (kmValor !== null) base.kmInicial = kmValor;
        if (flotaDestino.trim()) base.destino = flotaDestino.trim();
      } else if (paso === "llegada") {
        if (flotaDestino.trim()) base.destino = flotaDestino.trim();
      } else {
        if (kmValor !== null) base.kmFinal = kmValor;
        base.estado = flotaEstado;
      }
      // ═══ EL REGISTRO SE ESCRIBE AQUI, ANTES DEL VIDEO ═══════════════════
      //
      // Antes el video subia PRIMERO y el documento despues. Con 50 MB por 4G de
      // carretera eso son varios minutos mirando una barra, y lo que hace un
      // chofer es cerrar la pantalla: se quedaba sin video Y SIN REGISTRO, que es
      // lo peor de los dos mundos.
      //
      // La regla es la que ya fijamos: el registro es lo importante, el video es
      // evidencia añadida. Asi que el movimiento queda guardado primero y el video
      // se le engancha despues. Si la subida falla o la persona cierra la
      // pantalla, el registro ya esta y solo falta el video.
      await setDoc(refMov, base);
      const lbl = paso==="salida"?"Salida":paso==="llegada"?"Llegada":"Regreso";
      // Un solo mensaje que dice las tres cosas que pueden haber salido distinto:
      // si quedó el registro, si llevó ubicación y si las fotos subieron.
      if (fallaronFotos > 0) {
        setFlotaMsg({tipo:"err", texto:`${lbl} de ${placaMov}: el registro quedó guardado, la foto no subió`
          + (fallaronFotos>1?`s (${fallaronFotos})`:"") + ". Revisa tu conexión y vuelve a intentar con la foto en un movimiento nuevo, o avísale a tu patrón."});
      } else {
        setFlotaMsg(pos
          ? {tipo:"ok",   texto:`${lbl} de ${placaMov} registrada con ubicación.`}
          : {tipo:"info", texto:`${lbl} de ${placaMov} registrada SIN ubicación.`});
      }
      // EL VIDEO, CON EL REGISTRO YA A SALVO. Se guarda el archivo antes de
      // limpiar el formulario, porque `limpiarFormFlota` lo borra del estado.
      const videoPendiente = flotaVideo;
      limpiarFormFlota();
      // Releer: es lo que hace que la pantalla pase de "sin viaje" a "con viaje
      // abierto" —o al revés— sin que la persona tenga que salir y volver.
      setTickTrab(t=>t+1);
      // LA PANTALLA SE SUELTA AQUÍ, no al final. El registro ya está escrito, así
      // que el botón vuelve a estar vivo y se puede registrar el siguiente
      // movimiento mientras el vídeo termina de subir por detrás. Dejarlo en el
      // `finally` habría dejado el botón muerto los mismos minutos de antes.
      setRegistrandoFlota("");
      if (videoPendiente) {
        try {
          setFlotaSubiendo({i: 0, total: 0, pct: 0});
          const {url} = await subirVideoMovimiento(user?.uid||"", empleadorId, refMov.id, videoPendiente,
            (p)=>setFlotaSubiendo({i: 0, total: 0, pct: p}));
          // Solo el campo `video`, sobre un documento que acaba de crear esta
          // misma persona. Ver la regla de `flotilla` en firestore.rules: un
          // trabajador no puede tocar nada mas de un movimiento ya escrito.
          await updateDoc(refMov, {video: url});
          setFlotaMsg({tipo:"ok", texto:`${lbl} de ${placaMov} registrada, y el video quedó adjunto.`});
        } catch(e:any){
          console.error("video de movimiento:", e);
          setFlotaMsg({tipo:"info", texto:`${lbl} de ${placaMov} quedó registrada. ` + mensajeDeFallo(e, {accion:"subir el video", denegado:"Tu cuenta no tiene permiso para adjuntar el video; avísale a tu patrón."}) + " El registro ya está guardado."});
        } finally { setFlotaSubiendo(null); }
      }
    } catch(e:any){
      console.error(e);
      // El documento no se guardó. Si alguna foto sí subió queda huérfana en
      // Storage; se dice para no dejar la impresión de que no pasó nada.
      setFlotaMsg({tipo:"err", texto: mensajeDeFallo(e, {accion:"registrar el movimiento", denegado:"Tu cuenta no tiene permiso para registrar este movimiento. Avísale a tu patrón.", siSigue:"si sigue fallando, avísale a tu patrón"})
        + (fotosSubidas.length ? " (las fotos sí subieron, pero el movimiento no quedó: vuelve a intentarlo)" : "")});
    }
    finally { setRegistrandoFlota(""); }
  };

  // ── Contactar a AXIS ──────────────────────────────────────────────────────
  // Enlace directo a WhatsApp (sin colección ni datos). Mensaje prellenado con
  // el nombre del trabajador si está disponible.
  const abrirWhatsAppAXIS = () => {
    const msg = `Hola AXIS, soy ${cuenta?.nombre || nombre} y necesito apoyo.`;
    const url = `https://wa.me/524494251128?text=${encodeURIComponent(msg)}`;
    try { window.open(url, "_blank", "noopener,noreferrer"); } catch(e){ window.location.href = url; }
  };

  // ── Registrar accidente ───────────────────────────────────────────────────
  // Deja CONSTANCIA de un accidente YA OCURRIDO (no es alerta inmediata). Guarda
  // en la colección `accidentes`, vinculada al patrón por empleadorId (mismo
  // campo que usa el checador: cuenta?.empleadorId). Fotos a Storage; GPS opcional.
  const [accDescripcion, setAccDescripcion] = useState("");
  const [accVehiculo, setAccVehiculo] = useState("");                 // id de vehículo opcional (reusa vehiculosPatron)
  const [accFotos, setAccFotos] = useState<{nombre:string; url:string}[]>([]);
  const [accSubiendo, setAccSubiendo] = useState(false);
  // El progreso, foto por foto. Uno solo para toda la tanda no dice cual fallo.
  const [accProgreso, setAccProgreso] = useState<{nombre:string; pct:number; estado:string; detalle?:string}[]>([]);
  // UN video por accidente. Ver `MAX_MB_VIDEO`: no se puede comprimir en el
  // navegador, asi que el limite es el unico control y va antes de subir.
  //
  // GUARDA EL ARCHIVO, NO LA URL: ya no se sube al elegirlo, sino después de que
  // el accidente esté escrito. Ver `elegirVideoAccidente`.
  const [accVideo, setAccVideo] = useState<File|null>(null);
  const [accVideoSubiendo, setAccVideoSubiendo] = useState<number|null>(null);
  const [accGuardando, setAccGuardando] = useState(false);
  const [accMsg, setAccMsg] = useState<{tipo:"ok"|"err"|"info"; texto:string}|null>(null);
  // Cuando el aviso al teléfono del patrón NO salió, el mensaje tiene que traer
  // una salida y no solo una disculpa. Esto enciende el botón de WhatsApp bajo el
  // mensaje: "márcale o mándale un mensaje" sin un botón es una instrucción, no
  // una salida.
  const [accSinAviso, setAccSinAviso] = useState(false);

  // ═══ EL CONTEXTO CON EL QUE SE ABRIÓ EL ACCIDENTE ═════════════════════════
  //
  // UN SOLO OBJETO, NO CUATRO ESTADOS SUELTOS. Cuatro estados que solo tienen
  // sentido juntos son cuatro sitios donde uno puede quedarse sin limpiar: la
  // placa de un viaje y el id de otro es un accidente atribuido a la unidad
  // equivocada, y eso no lo nota nadie hasta que importa.
  //
  // `salidaId` SE LLAMA IGUAL QUE EN FLOTILLA, y a propósito: es el mismo campo
  // que escribe `registrarFlota` para enlazar las paradas con su salida. Dos
  // nombres para la misma cosa obligarían a que quien lea los datos sepa cuál de
  // los dos mirar según de dónde venga el documento.
  //
  // Y SE QUEDA AUNQUE NO HAYA VEHÍCULO. Si la persona corrige la unidad —o dice
  // que no hubo vehículo— el accidente sigue habiendo ocurrido durante ESE viaje,
  // que es un hecho aparte del vehículo y no deja de ser cierto.
  const [accContexto, setAccContexto] = useState<{salidaId:string; vehiculoId:string; placa:string; etiqueta:string; origen:"flotilla"|"menu"}|null>(null);
  // ¿Se abrió el selector para corregir el vehículo heredado? Mientras esté en
  // false, la unidad se muestra como un HECHO y no como un campo que rellenar.
  const [accCorrigeVehiculo, setAccCorrigeVehiculo] = useState(false);
  // Hora "HH:MM" actual: valor inicial de "¿Fue a otra hora?" en la pantalla
  // posterior. En el registro rápido NO se pregunta ni se escribe.
  const horaActualHHMM = () => { const d=new Date(); return `${String(d.getHours()).padStart(2,"0")}:${String(d.getMinutes()).padStart(2,"0")}`; };

  // ═══ EL REGISTRO RÁPIDO: DOS TOQUES Y UN BOTÓN ════════════════════════════
  //
  // En el momento de un accidente nadie llena un formulario largo. El formulario
  // de antes pedía una descripción escrita y una gravedad antes de dejar registrar,
  // y ahí se quedaba la gente: de pie en la carretera, escribiendo. Ahora se
  // registra con lo mínimo que hace útil el aviso —qué pasó, si hay personas
  // lesionadas, con qué unidad— y TODO lo demás se ofrece después, con el aviso ya
  // enviado. Nada de lo de después es obligatorio ni puede impedir el registro.
  //
  // LA GRAVEDAD SALIÓ DEL FORMULARIO. Pedirle a quien acaba de chocar que califique
  // "leve, moderado o grave" es pedirle un diagnóstico médico. Lo que sí sabe es si
  // hay alguien lesionado, y eso es lo que decide la atención. Los registros viejos
  // conservan su gravedad y se siguen leyendo igual; ver `senalDeAccidente`.
  const [accFase, setAccFase] = useState<"rapida"|"posterior">("rapida");
  // "No fue con vehículo" ES UNA RESPUESTA, no la ausencia de una. Sin esto no se
  // distinguiría "aún no eligió unidad" de "dijo que no hubo unidad".
  const [accSinVehiculo, setAccSinVehiculo] = useState(false);
  // La clave del catálogo compartido (src/logica/accidente.js). "" = sin elegir.
  const [accTipo, setAccTipo] = useState<string>("");
  // ⚠️ SIN VALOR POR OMISIÓN. El interruptor viejo arrancaba en "No", y quien no
  // lo tocaba dejaba escrito "sin lesionados" sin haberlo contestado. `null` es
  // "nadie ha contestado", y el botón no se activa hasta que alguien conteste.
  // "No lo sé" se guarda como `LESIONADOS_NO_SE`; ver su porqué junto a la constante.
  const [accLesionados, setAccLesionados] = useState<true|false|"no_se"|null>(null);
  const [accGps, setAccGps] = useState<{lat:number; lng:number}|null>(null);
  const [accGpsEstado, setAccGpsEstado] = useState<"tomando"|"ok"|"sin">("tomando");
  // La petición de ubicación en curso, para poder esperarla UN RATO al registrar.
  const accGpsPromesa = useRef<Promise<{lat:number; lng:number}|null>|null>(null);

  // ═══ LA PANTALLA POSTERIOR ════════════════════════════════════════════════
  // Aparece en cuanto el accidente está escrito. Cada bloque se guarda por su
  // cuenta: si la persona cierra a la mitad, lo guardado se queda.
  // `fechaReg`/`horaReg`: CUÁNDO SE REGISTRÓ, en la hora del teléfono. Es con lo
  // que se compara "¿Fue a otra hora?": guardar esa misma hora no declara nada.
  // `venceMs`: hasta cuándo deja la regla completarlo (7 días desde el registro).
  // `reabierto`: se abrió desde "Mis accidentes"; `resumen`, lo que se enseña arriba.
  const [accRegistro, setAccRegistro] = useState<{id:string; sinVehiculo:boolean; vehiculoId:string; lesionados:true|false|"no_se"; fechaReg?:string; horaReg?:string; venceMs?:number; reabierto?:boolean; resumen?:string; estadoPatron?:string}|null>(null);
  const [accBloqueGuardando, setAccBloqueGuardando] = useState("");
  const [accBloqueEstado, setAccBloqueEstado] = useState<Record<string,{tipo:"ok"|"err"; texto:string}>>({});
  const [accNumSiniestro, setAccNumSiniestro] = useState("");
  const [accContraparteNombre, setAccContraparteNombre] = useState("");
  const [accContraparteTel, setAccContraparteTel] = useState("");
  const [accContrapartePlaca, setAccContrapartePlaca] = useState("");
  const [accContraparteAseguradora, setAccContraparteAseguradora] = useState("");
  const [accContrapartePoliza, setAccContrapartePoliza] = useState("");
  // LOS SÍ/NO DE DESPUÉS TAMPOCO ARRANCAN EN "NO". `null` = sin contestar, y lo sin
  // contestar no se escribe: guardar el bloque no puede afirmar lo que nadie dijo.
  const [accDanosTerceros, setAccDanosTerceros] = useState<boolean|null>(null);
  const [accDanosTercerosTexto, setAccDanosTercerosTexto] = useState("");
  const [accTestigos, setAccTestigos] = useState<{nombre:string; telefono:string}[]>([{nombre:"", telefono:""}]);
  // LO QUE YA QUEDÓ ESCRITO Y NO SE REESCRIBE. firestore.rules no deja al
  // trabajador reescribir su relato ni su hora declarada, ni quitar un testigo:
  // la primera versión es la más valiosa. La pantalla no puede ofrecer lo que la
  // regla va a rechazar, así que lo guardado se enseña en solo lectura y de los
  // testigos solo se pueden añadir más.
  const [accTestigosGuardados, setAccTestigosGuardados] = useState<{nombre:string; telefono:string}[]>([]);
  const [accDeclarado, setAccDeclarado] = useState<{descripcion?:string; fechaHechos?:string; horaHechos?:string}>({});
  // EL VIDEO YA GUARDADO. La regla deja rellenar `video` UNA vez: si ya hay uno, la
  // pantalla no ofrece subir otro.
  const [accVideoGuardado, setAccVideoGuardado] = useState("");
  // "MIS ACCIDENTES": los suyos, de su empresa, de los últimos 7 días. Se leen con
  // la misma consulta por correo que las checadas; el filtro y el orden, en
  // `misAccidentesAbiertos`.
  const [misAccidentes, setMisAccidentes] = useState<any[]>([]);
  const [misAccEstado, setMisAccEstado] = useState<"cargando"|"ok"|"error">("cargando");
  // EL ACCIDENTE ABIERTO SE LEE DE LA BASE, no de la lista (4-oct). Mientras se lee,
  // la pantalla dice "Cargando…" y no ofrece ningún control. `accAperturaRef` es el
  // turno: si se sale o se abre otro antes de que llegue, la lectura vieja se tira.
  const [accCargando, setAccCargando] = useState(false);
  const accAperturaRef = useRef(0);
  const [misAccAvisoTxt, setMisAccAvisoTxt] = useState("");
  const [accParteTransito, setAccParteTransito] = useState<boolean|null>(null);
  const [accFolioParte, setAccFolioParte] = useState("");
  const [accAmbulancia, setAccAmbulancia] = useState<boolean|null>(null);
  const [accDetenidos, setAccDetenidos] = useState<boolean|null>(null);
  const [accVehiculoRetirado, setAccVehiculoRetirado] = useState<boolean|null>(null);
  const [accFechaHechos, setAccFechaHechos] = useState<string>(()=>fechaLocal(new Date()));
  const [accHoraHechos, setAccHoraHechos] = useState<string>(()=>horaActualHHMM());

  // ═══ LA UBICACIÓN SE PIDE SOLA, Y NUNCA BLOQUEA ═══════════════════════════
  // Al abrir la pantalla, sin preguntar nada más que el permiso del sistema. Si se
  // niega o falla, el accidente se registra igual, "sin ubicación". Antes era un
  // botón opcional, y un botón opcional en el peor momento es un botón que no se
  // pulsa.
  const tomarGpsAccidente = () => {
    setAccGps(null);
    if (typeof navigator === "undefined" || !navigator.geolocation) {
      setAccGpsEstado("sin");
      accGpsPromesa.current = Promise.resolve(null);
      return;
    }
    setAccGpsEstado("tomando");
    accGpsPromesa.current = new Promise((resolve) => {
      navigator.geolocation.getCurrentPosition(
        (p)=>{ const g = {lat:p.coords.latitude, lng:p.coords.longitude}; setAccGps(g); setAccGpsEstado("ok"); resolve(g); },
        ()=>{ setAccGpsEstado("sin"); resolve(null); },
        {enableHighAccuracy:true, timeout:10000, maximumAge:60000}
      );
    });
  };
  // SI AL PULSAR EL BOTÓN LA UBICACIÓN AÚN NO LLEGÓ, se espera como mucho esto y se
  // registra sin ella. Esperar más es justo lo que este formulario vino a quitar.
  const ESPERA_MAX_GPS_MS = 3000;
  const esperarGpsAccidente = async (): Promise<{lat:number; lng:number}|null> => {
    if (accGps) return accGps;
    const p = accGpsPromesa.current;
    if (!p) return null;
    return await Promise.race([p, new Promise<null>((r)=>setTimeout(()=>r(null), ESPERA_MAX_GPS_MS))]);
  };

  // Sube una o varias fotos a Storage (reusa el helper subirArchivo existente).
  // Ruta: accidentes/{uidDelTrabajador}/<archivo>. Se usa el uid del TRABAJADOR
  // logueado (no el empleadorId) para encajar con la regla de Storage existente
  // (uid()==userId). El vínculo al patrón vive en el documento de Firestore
  // (campo empleadorId), no en la carpeta física. Guarda las URLs de descarga.
  // ═══ LAS FOTOS DE UN ACCIDENTE ════════════════════════════════════════════
  //
  // ESTE ES EL PEOR SITIO DE LA PLATAFORMA PARA QUE ALGO FALLE: alguien parado en
  // la carretera, con una barra de señal, documentando un golpe. Aquí no se pierde
  // nada por comodidad de nadie.
  //
  // LO QUE ESTABA MAL Y NO ERA SOLO LA COMPRESIÓN. El bucle entero iba dentro de UN
  // try/catch: si la tercera de cinco fallaba, el `catch` saltaba y el
  // `setAccFotos` del final NUNCA se ejecutaba. Las dos que SÍ habían subido se
  // perdían de la lista —y se quedaban en Storage, huérfanas, pagándose—. Una foto
  // mala se llevaba por delante a las buenas.
  //
  // Ahora cada foto va por su cuenta: se comprime, se sube, y su resultado no toca
  // a las demás. Las que suben se guardan aunque otras fallen, y se dice CUÁL falló
  // por su nombre.
  const subirFotosAccidente = async (files: FileList|null) => {
    const lista = Array.from(files || []) as File[];
    if (!lista.length) return;
    setAccMsg(null);
    // Pasado el plazo, ni se suben: la regla no dejaría enlazarlas.
    if (plazoAccidenteVencido()) { setAccBloqueEstado(p=>({...p, fotos:{tipo:"err", texto: TEXTO_PLAZO_ACCIDENTE_VENCIDO}})); return; }

    const libres = MAX_FOTOS_ACCIDENTE - accFotos.length;
    if (libres <= 0) {
      setAccMsg({tipo:"err", texto:`Ya tienes ${MAX_FOTOS_ACCIDENTE} fotos, que es el máximo por accidente.`});
      return;
    }
    const elegidas = lista.slice(0, libres);
    const sobran = lista.length - elegidas.length;

    // El peso se comprueba ANTES de subir nada, y el que no pasa se dice por su
    // nombre en vez de morir a mitad de la subida.
    const cola = elegidas.map((f) => ({nombre: f.name, archivo: f, motivo: motivoRechazo(f)}));
    setAccProgreso(cola.map((c) => ({nombre: c.nombre, pct: 0, estado: c.motivo ? "error" : "espera", detalle: c.motivo})) as any);
    setAccSubiendo(true);

    const subidas: {nombre:string; url:string}[] = [];
    const fallidas: string[] = [];
    const uidTrabajador = user?.uid || cuenta?.uid || "";
    const marca = (i:number, cambio:any) => setAccProgreso((prev:any) => prev.map((p:any, j:number) => j === i ? {...p, ...cambio} : p));

    for (let i = 0; i < cola.length; i++) {
      if (cola[i].motivo) { fallidas.push(cola[i].nombre + " — " + cola[i].motivo); continue; }
      try {
        marca(i, {estado: "subiendo", pct: 0});
        // LA MISMA COMPRESIÓN QUE EL RESTO. Una foto de 12 MP baja de 5 MB a unos
        // 275 KB: la diferencia entre subir y no subir con una barra de señal.
        const listo = await prepararParaSubir(cola[i].archivo, LADO_DOCUMENTO);
        const url = await subirArchivo(uidTrabajador, "accidentes", listo, (p) => marca(i, {pct: p}));
        subidas.push({nombre: listo.name, url});
        marca(i, {estado: "hecho", pct: 100});
      } catch (e:any) {
        // UNA QUE FALLA NO SE LLEVA A LAS DEMÁS.
        fallidas.push(cola[i].nombre);
        marca(i, {estado: "error", detalle: "no se pudo subir"});
      }
    }

    // SE ENGANCHAN AL ACCIDENTE EN CUANTO SUBEN, sin esperar a un "Guardar". Una
    // foto subida que no queda enlazada es una foto perdida —está en el almacén y
    // nadie la ve—, y el sitio donde más fácil es olvidar un botón es este.
    //
    // ⚠️ CON `arrayUnion`, NO CON LA LISTA ENTERA (4-oct). Antes se mandaba
    // `[...accFotos, ...subidas]`: la lista que la PANTALLA creía que había. Con la
    // pantalla atrasada —abierta desde una copia vieja— esa lista no traía las fotos
    // ya guardadas, la regla ("solo crecen": la nueva tiene que contener la vieja)
    // la rechazaba, y la foto se quedaba huérfana. `arrayUnion` lo añade EN EL
    // SERVIDOR a lo que haya: una pantalla atrasada ya no puede intentar quitar nada.
    let enlazadas = false;
    if (subidas.length && accRegistro?.id) {
      try {
        await updateDoc(doc(db,"accidentes",accRegistro.id), {fotos: arrayUnion(...subidas.map((f)=>f.url))});
        enlazadas = true;
        setAccFotos(prev => [...prev, ...subidas.filter((s) => !prev.some((x) => x.url === s.url))]);
        setAccBloqueEstado(p=>({...p, fotos:{tipo:"ok", texto: subidas.length === 1 ? "Foto guardada en el accidente." : `${subidas.length} fotos guardadas en el accidente.`}}));
      } catch(e:any) {
        console.error("accidente · no se pudieron enlazar las fotos:", e);
        // LA HUÉRFANA SE BORRA: subió al almacén pero no quedó en el accidente, y
        // ahí nadie la vería. storage.rules deja al trabajador borrar lo suyo.
        for (const s of subidas) {
          try { await eliminarArchivo(s.url); }
          catch (err) { console.error("accidente · no se pudo borrar una foto que no se enlazó:", err); }
        }
        setAccBloqueEstado(p=>({...p, fotos:{tipo:"err", texto: mensajeFalloGuardadoAccidente(e, accRegistro?.venceMs || 0, Date.now(), "fotos")}}));
      }
      // LO QUE QUEDÓ EN LA BASE, salga bien o mal.
      refrescarAccidenteAbierto(accRegistro.id);
    }
    setAccSubiendo(false);

    const partes:string[] = [];
    if (enlazadas) partes.push(subidas.length === 1 ? "Se subió 1 foto." : `Se subieron ${subidas.length} fotos.`);
    if (fallidas.length) partes.push("No se pudo con: " + fallidas.join(", ") + ".");
    if (sobran > 0) partes.push(`Quedaron ${sobran} fuera: el máximo son ${MAX_FOTOS_ACCIDENTE}.`);
    if (partes.length) setAccMsg({tipo: fallidas.length ? "err" : "ok", texto: partes.join(" ")});
  };

  // ═══ EL VÍDEO DEL ACCIDENTE ═══════════════════════════════════════════════
  // UNO por registro, no varios: un vídeo dando la vuelta al vehículo cuenta lo
  // que quince fotos, y dos vídeos de 25 MB por accidente es una factura y una
  // espera que nadie pidió. Si ya hay uno, se reemplaza y se borra el anterior.
  // ELEGIR EL VÍDEO, y ahora sí subirlo en el acto. Antes el vídeo se elegía
  // ANTES de registrar y se subía después, porque subirlo antes tenía dos
  // problemas: si la persona pulsaba "Registrar" a media subida el accidente se
  // guardaba sin vídeo, y si cerraba la pantalla se perdían los dos. Esos dos
  // problemas desaparecen solos: el vídeo se ofrece en la pantalla POSTERIOR, con
  // el accidente ya escrito, así que subirlo ya no puede costar el registro.
  // El rechazo por peso o formato sigue yendo primero, antes de gastar datos.
  const elegirVideoAccidente = (files: FileList|null) => {
    const f = (files && files[0]) || null;
    if (!f) return;
    setAccMsg(null);
    // EL PLAZO TAMBIÉN AQUÍ, y aquí más que en ningún sitio: la rama del video de
    // firestore.rules no mira los 7 días, así que el servidor no lo frenaría.
    if (plazoAccidenteVencido()) { setAccBloqueEstado(p=>({...p, video:{tipo:"err", texto: TEXTO_PLAZO_ACCIDENTE_VENCIDO}})); return; }
    const malo = motivoRechazo(f);
    if (malo) { setAccBloqueEstado(p=>({...p, video:{tipo:"err", texto:"No se agregó el video: " + malo}})); return; }
    if (!esVideo(f)) { setAccBloqueEstado(p=>({...p, video:{tipo:"err", texto:"Ese archivo no es un video."}})); return; }
    setAccVideo(f);
    subirVideoAccidente(f);
  };
  // SOLO el campo `video`, y en su propia escritura: es la regla de siempre de
  // firestore.rules —el trabajador puede rellenar `video` una vez, si estaba
  // vacío—, y la que deja subir el vídeo aunque las reglas nuevas no estén
  // publicadas todavía.
  const subirVideoAccidente = async (f: File) => {
    if (!accRegistro?.id) return;
    let url = "";
    try {
      setAccVideoSubiendo(0);
      url = await subirArchivo(user?.uid || cuenta?.uid || "", "accidentes", f, (p)=>setAccVideoSubiendo(p));
      await updateDoc(doc(db,"accidentes",accRegistro.id), {video: url});
      setAccVideoGuardado(url);
      setAccBloqueEstado(p=>({...p, video:{tipo:"ok", texto:"Video guardado en el accidente."}}));
    } catch(e:any){
      console.error("accidente · el video no se pudo guardar:", e);
      // EL HUÉRFANO SE BORRA, igual que las fotos: subió pero no quedó enlazado.
      if (url) { try { await eliminarArchivo(url); } catch (err) { console.error("accidente · no se pudo borrar un video que no se enlazó:", err); } }
      setAccVideo(null);
      setAccBloqueEstado(p=>({...p, video:{tipo:"err", texto: mensajeFalloGuardadoAccidente(e, accRegistro?.venceMs || 0, Date.now(), "video")}}));
    } finally { setAccVideoSubiendo(null); }
    refrescarAccidenteAbierto(accRegistro.id);
  };

  // No hay nada que borrar de Storage: el vídeo todavía no ha subido.
  const quitarVideoAccidente = () => { setAccVideo(null); setAccMsg(null); };

  const quitarFotoAccidente = async (i:number) => {
    const f = accFotos[i];
    setAccFotos(prev=>prev.filter((_,j)=>j!==i));
    if (f?.url) { try { await eliminarArchivo(f.url); } catch(e){ /* archivo huérfano tolerable */ } }
  };

  // ═══ EL AVISO AL TELÉFONO DEL PATRÓN ══════════════════════════════════════
  //
  // VA DESPUÉS DEL addDoc Y NUNCA ANTES. El registro es lo que no se puede
  // perder; el aviso es lo que lo hace útil en los primeros diez minutos. Si se
  // llamara antes, un endpoint caído se llevaría por delante el registro entero,
  // que es exactamente el orden equivocado.
  //
  // POR ESO ESTA FUNCIÓN NO LANZA NUNCA. Devuelve un texto: vacío si el teléfono
  // del patrón sonó, y el mensaje CON SALIDA si no. Quien la llama no tiene que
  // acordarse de envolverla en un try.
  //
  // EL TEXTO DE LA NOTIFICACIÓN NO VIAJA AQUÍ. Solo el id del accidente: el
  // servidor lo compone leyendo el documento. Ver `api/aviso-accidente.js`.
  // NI AQUÍ. Decía "no pudimos avisar a tu patrón AL TELÉFONO", y si la
  // plataforma no sabe a qué aparato manda cuando acierta, tampoco lo sabe cuando
  // falla. La salida —márcale o mándale un mensaje— sigue entera, que es lo que
  // esta frase tiene que dar.
  const SIN_AVISO_TXT = "Tu accidente quedó registrado. No pudimos avisar a tu patrón — márcale o mándale un mensaje.";
  const avisarAccidenteAlPatron = async (accidenteId:string): Promise<string> => {
    try {
      const token = await (user?.getIdToken ? user.getIdToken() : Promise.resolve(""));
      if (!token) return SIN_AVISO_TXT;
      const r = await fetch("/api/aviso-accidente", {
        method: "POST",
        headers: {"Content-Type":"application/json", "Authorization":`Bearer ${token}`},
        body: JSON.stringify({accidenteId}),
      });
      // Un 401 o un 403 llegan con el cuerpo vacío a propósito; `json()` sobre eso
      // lanza, y ese fallo no puede confundirse con "no se pudo avisar".
      const d = await r.json().catch(()=>({} as any));
      if (r.ok && (d?.estado === "enviado" || d?.estado === "ya_avisado")) return "";
      console.warn("aviso de accidente:", r.status, d?.estado || "");
      return SIN_AVISO_TXT;
    } catch(e){
      console.warn("aviso de accidente:", e);
      return SIN_AVISO_TXT;
    }
  };

  // ═══ LESIONADOS CONFIRMADOS: OTRO AVISO, UNA SOLA VEZ ═════════════════════
  // Si "No lo sé" pasa a "Sí", el patrón tiene que enterarse ya: es la diferencia
  // entre un choque y un choque con alguien herido. Mismo endpoint y misma puerta
  // que el primer aviso; el texto lo compone el servidor leyendo el documento, y
  // la marca de "ya avisado" es OTRA (`avisoLesionadosEnviadoEn`), así que no choca
  // con la del primer aviso. Devuelve "" si salió, o el texto con salida si no.
  const SIN_AVISO_LESIONADOS_TXT = "Quedó anotado. No pudimos avisar a tu patrón de los lesionados — márcale o mándale un mensaje.";
  // Si el patrón CANCELÓ el accidente, el servidor no avisa (no es un fallo): se le
  // dice al trabajador tal cual, para que sepa por qué y pueda llamarle si importa.
  const LESIONADOS_CANCELADO_TXT = "Guardado. Tu patrón canceló este accidente, así que no le enviamos aviso; si es importante, márcale.";
  const avisarLesionadosAlPatron = async (accidenteId:string): Promise<string> => {
    try {
      const token = await (user?.getIdToken ? user.getIdToken() : Promise.resolve(""));
      if (!token) return SIN_AVISO_LESIONADOS_TXT;
      const r = await fetch("/api/aviso-accidente", {
        method: "POST",
        headers: {"Content-Type":"application/json", "Authorization":`Bearer ${token}`},
        body: JSON.stringify({accidenteId, aviso: "lesionados"}),
      });
      const d = await r.json().catch(()=>({} as any));
      if (r.ok && (d?.estado === "enviado" || d?.estado === "ya_avisado")) return "";
      if (r.ok && d?.estado === "cancelado") return LESIONADOS_CANCELADO_TXT;
      console.warn("aviso de lesionados:", r.status, d?.estado || "");
      return SIN_AVISO_LESIONADOS_TXT;
    } catch(e){
      console.warn("aviso de lesionados:", e);
      return SIN_AVISO_LESIONADOS_TXT;
    }
  };

  // ═══ ¿SE PUEDE REGISTRAR YA? ══════════════════════════════════════════════
  // Una sola función la decide y la usan el botón y el propio registro, para que
  // el botón no se active con algo que el registro luego rechace.
  //   · qué pasó: siempre;
  //   · si hay lesionados: siempre, salvo que el propio hecho ya lo diga;
  //   · la unidad: elegida, heredada del viaje, o "No fue con vehículo".
  const tipoAccElegido = tipoAccidente(accTipo);
  const lesionadosAcc: true|false|"no_se"|null = tipoAccElegido?.hayLesionados ? true : accLesionados;
  const faltaParaRegistrar = (): string => {
    if (!tipoAccElegido) return "Elige qué pasó.";
    if (lesionadosAcc === null) return "Contesta si hay personas lesionadas.";
    if (!accVehiculo && !accSinVehiculo) return "Elige la unidad, o «No fue con vehículo».";
    return "";
  };

  const registrarAccidente = async () => {
    if (accGuardando) return;
    const falta = faltaParaRegistrar();
    if (falta) { setAccMsg({tipo:"err", texto: falta}); return; }
    setAccGuardando(true); setAccMsg(null); setAccSinAviso(false);
    try {
      const gps = await esperarGpsAccidente();
      const now = new Date();
      const veh = accSinVehiculo ? null : vehiculosPatron.find((v:any)=>v.id===accVehiculo);
      // ⚠️ NI `fechaHechos` NI `horaHechos`, y a propósito. La hora del accidente no
      // se pregunta: es la del registro, que ya guarda `timestamp`. Si el accidente
      // fue antes, la pantalla posterior la corrige en esos dos campos, que son la
      // hora DECLARADA. Escribirlos aquí con la hora de ahora sería afirmar que el
      // accidente pasó en el momento del registro, y nadie lo dijo.
      //
      // ⚠️ NI `gravedad` NI `descripcion`. La primera salió del formulario; la
      // segunda es opcional y llega, si llega, en la pantalla posterior.
      const base:any = {
        trabajadorEmail: correo,
        trabajadorNombre: cuenta?.nombre || nombre,
        empleadorId: empleadorId,
        // QUÉ PASÓ, por su clave fija. El rótulo sale del catálogo al leer; ver
        // src/logica/accidente.js. Que el documento lo traiga es además lo que le
        // dice al servidor que este accidente se registró con el formulario nuevo.
        tipoEvento: tipoAccElegido!.clave,
        huboLesionados: lesionadosAcc,
        fotos: [],
        // Vacío a propósito: el vídeo se engancha después, si llega. Es la regla
        // de siempre de firestore.rules.
        video: "",
        ubicacionDisponible: !!gps,
        // Metadatos de registro: CUÁNDO SE REGISTRÓ, no cuándo pasó.
        fecha: now.toLocaleDateString("es-MX"),
        hora: now.toLocaleTimeString("es-MX",{hour:"2-digit",minute:"2-digit"}),
        timestamp: serverTimestamp(),
        registradoPorTrabajador: true,
        // PENDIENTE HASTA QUE EL PATRÓN LO ATIENDA O LO CANCELE (4-oct): los que
        // registra esta versión no caducan a los 7 días. Ver `sigueEnAtencion`.
        pendienteHastaAtender: true,
        // DE DÓNDE VINO ESTE REGISTRO. No es estadística: un accidente registrado
        // desde Flotilla trae un viaje detrás y otro registrado desde el menú no,
        // y al leerlos después esa diferencia explica por qué uno tiene salidaId
        // y el otro no.
        origenRegistro: accContexto?.origen || "menu",
      };
      // EL VIAJE, AUNQUE SE HAYA CORREGIDO EL VEHÍCULO. Mismo nombre de campo que
      // usa `registrarFlota` para enlazar las paradas con su salida.
      if (accContexto?.salidaId) base.salidaId = accContexto.salidaId;
      if (veh) {
        base.vehiculoId = veh.id;
        base.placa = (veh.placa||"").toUpperCase();
        base.vehiculo = `${veh.placa||""}${(veh.marca||veh.modelo)?` · ${[veh.marca,veh.modelo].filter(Boolean).join(" ")}`:""}`.trim();
      }
      if (gps) { base.lat = gps.lat; base.lng = gps.lng; }
      // ═══ EL ACCIDENTE SE ESCRIBE PRIMERO ══════════════════════════════════
      // El aviso y todo lo de después pueden fallar enteros sin quitarle nada a
      // esta línea.
      const refAcc = await addDoc(collection(db,"accidentes"), base);
      setAccGuardando(false);
      // LA PANTALLA POSTERIOR, YA. No se espera al aviso para enseñarla: el
      // accidente está escrito y lo que falta se puede ir añadiendo mientras el
      // servidor avisa.
      // "¿Fue a otra hora?" ARRANCA EN LA HORA DEL REGISTRO, no en la de cuando se
      // abrió esta pantalla, y su "Guardar" solo se habilita si se cambia. Como la
      // hora declarada se escribe UNA vez, guardar sin tocar nada fijaría para
      // siempre una hora que nadie declaró.
      const fechaReg = fechaLocal(now);
      const horaReg = `${String(now.getHours()).padStart(2,"0")}:${String(now.getMinutes()).padStart(2,"0")}`;
      setAccFechaHechos(fechaReg); setAccHoraHechos(horaReg);
      setAccRegistro({id: refAcc.id, sinVehiculo: !veh, vehiculoId: veh?.id || "", lesionados: lesionadosAcc as any, fechaReg, horaReg,
        venceMs: now.getTime() + VENTANA_COMPLETAR_ACCIDENTE_MS});
      setAccFase("posterior");
      setAccMsg({tipo:"info", texto:"Accidente registrado. Avisando a tu patrón…"});
      // ═══ EL AVISO, CON RED DEBAJO ═════════════════════════════════════════
      // Con `.catch` aunque `avisarAccidenteAlPatron` no lance nunca: que esto no
      // pueda romper el registro tiene que ser una propiedad de ESTE sitio. Sin él,
      // un fallo diría "No se pudo registrar" sobre un accidente QUE SÍ QUEDÓ
      // GUARDADO, y en esta pantalla ese es el peor mensaje posible.
      const avisoTxt = await avisarAccidenteAlPatron(refAcc.id).catch(()=>SIN_AVISO_TXT);
      setAccSinAviso(!!avisoTxt);
      setAccMsg(avisoTxt
        ? {tipo:"info", texto: avisoTxt}
        // NO SE DICE EN QUÉ APARATO. La plataforma no sabe si el patrón tiene
        // uno, tres o ningún dispositivo, ni si son teléfonos.
        : {tipo:"ok", texto:"Accidente registrado. Ya le avisamos a tu patrón."});
    } catch(e:any){ console.error(e); setAccMsg({tipo:"err", texto: mensajeFalloGuardadoAccidente(e, 0, Date.now(), "registro")}); }
    finally { setAccGuardando(false); }
  };

  // ═══ CADA BLOQUE DE DESPUÉS SE GUARDA POR SU CUENTA ════════════════════════
  // Solo los campos de ESE bloque: firestore.rules deja al trabajador tocar una
  // lista cerrada de campos de su propio accidente, durante 7 días, y nada más. Si
  // un bloque falla, los demás y el accidente siguen intactos, y se dice cuál.
  // Devuelve si se guardó: los bloques que se escriben UNA vez —el relato, la hora
  // declarada, los testigos— solo se cierran si de verdad quedaron escritos.
  // ¿Venció ya el plazo de 7 días? Con el reloj del teléfono; el servidor manda, y
  // si rechaza, `mensajeFalloGuardadoAccidente` explica la causa igual.
  const plazoAccidenteVencido = () => !!accRegistro?.venceMs && Date.now() >= accRegistro.venceMs;
  const guardarBloqueAccidente = async (bloque:string, datos:Record<string,any>): Promise<boolean> => {
    if (!accRegistro?.id) return false;
    if (plazoAccidenteVencido()) {
      setAccBloqueEstado(p=>({...p, [bloque]:{tipo:"err", texto: TEXTO_PLAZO_ACCIDENTE_VENCIDO}}));
      return false;
    }
    if (!Object.keys(datos).length) {
      setAccBloqueEstado(p=>({...p, [bloque]:{tipo:"err", texto:"No hay nada que guardar todavía."}}));
      return false;
    }
    setAccBloqueGuardando(bloque);
    const id = accRegistro.id;
    try {
      await updateDoc(doc(db,"accidentes",id), datos);
      setAccBloqueEstado(p=>({...p, [bloque]:{tipo:"ok", texto:"Guardado."}}));
      // Lo de este bloque ya está guardado: deja de detener la actualización forzada.
      try { marcarCamposComoGuardados(document.querySelector(`[data-bloque-acc="${bloque}"]`)); } catch (_e) {}
      // LO QUE QUEDÓ EN LA BASE, no lo que la pantalla cree.
      refrescarAccidenteAbierto(id);
      return true;
    } catch(e:any) {
      console.error("accidente · bloque " + bloque + ":", e);
      setAccBloqueEstado(p=>({...p, [bloque]:{tipo:"err", texto: mensajeFalloGuardadoAccidente(e, accRegistro?.venceMs || 0, Date.now())}}));
      // RECHAZADO: casi siempre la pantalla iba atrasada. Se relee y se enseña lo
      // que de verdad hay; el mensaje ya lo dice.
      refrescarAccidenteAbierto(id);
      return false;
    } finally { setAccBloqueGuardando(""); }
  };

  // ═══ EL ACCIDENTE ABIERTO, LEÍDO DE LA BASE ════════════════════════════════
  // Lo que solo crece o se escribe una vez —fotos, testigos, relato, hora
  // declarada, video— y lesionados, tal como están en la base. Los campos que se
  // pueden reescribir NO se tocan al releer: borrarían lo que la persona está
  // escribiendo en otro bloque.
  const leerAccidenteDeLaBase = async (id:string) => {
    const s:any = await getDoc(doc(db,"accidentes",id));
    if (!s || !s.exists()) return null;
    return {id, ...(s.data() as any)};
  };
  const aplicarLoGuardado = (a:any) => {
    const e = estadoPosteriorDeAccidente(a);
    setAccRegistro((r:any) => (r && r.id === e.registro.id)
      ? {...r, lesionados: e.registro.lesionados, venceMs: e.registro.venceMs || r.venceMs} : r);
    setAccDeclarado(e.declarado);
    setAccFotos(e.fotos);
    setAccTestigosGuardados(e.testigos);
    setAccVideoGuardado(e.video);
  };
  const refrescarAccidenteAbierto = async (id:string) => {
    if (!id) return;
    const turno = accAperturaRef.current;
    try {
      const a = await leerAccidenteDeLaBase(id);
      if (a && turno === accAperturaRef.current) aplicarLoGuardado(a);
    } catch (e) { console.error("accidente · no se pudo releer:", e); }
  };
  // "¿Ya sabes si hay personas lesionadas?" Solo aparece si se contestó "No lo sé",
  // y solo admite Sí o No: firestore.rules no deja cambiar lesionados de ningún
  // otro valor. La hora de la corrección la pone el SERVIDOR —`serverTimestamp`—:
  // es la que reabre la ventana de atención, y si la pusiera el teléfono una
  // fecha vieja podría cerrarla y esconder una lesión.
  // LOS TESTIGOS, CON `arrayUnion` (4-oct), por lo mismo que las fotos: antes se
  // mandaba la lista que la pantalla creía que había, y con la pantalla atrasada la
  // regla ("solo crecen") la rechazaba. Ahora se añaden en el servidor a lo que haya.
  const guardarTestigosAccidente = async () => {
    const nuevos = accTestigos.map(t=>({nombre:t.nombre.trim(), telefono:t.telefono.trim()})).filter(t=>t.nombre || t.telefono);
    if (!nuevos.length) { guardarBloqueAccidente("testigos", {}); return; }
    if (await guardarBloqueAccidente("testigos", {testigos: arrayUnion(...nuevos)})) {
      setAccTestigosGuardados(p => [...p, ...nuevos.filter(n => !p.some(x => x.nombre === n.nombre && x.telefono === n.telefono))]);
      setAccTestigos([{nombre:"", telefono:""}]);
    }
  };
  const confirmarLesionadosAccidente = async (v:boolean) => {
    // SOLO SI SE GUARDÓ. Antes se anotaba en pantalla aunque fallara: el trabajador
    // veía "Anotado" y el patrón seguía con "No lo sé".
    if (await guardarBloqueAccidente("lesionados", {huboLesionados: v, lesionadosCorregidoEn: serverTimestamp()})) {
      setAccRegistro(r=> r ? {...r, lesionados: v} : r);
      // CONFIRMADOS: el patrón recibe otro aviso, una sola vez por accidente.
      if (v === true && accRegistro?.id) {
        const txt = await avisarLesionadosAlPatron(accRegistro.id);
        setAccBloqueEstado(p=>({...p, lesionados: txt === LESIONADOS_CANCELADO_TXT ? {tipo:"ok", texto: txt}
          : txt ? {tipo:"err", texto: txt} : {tipo:"ok", texto:"Guardado. Avisamos a tu patrón."}}));
      }
    }
  };

  // TODO A SU ESTADO INICIAL. Se usa al abrir y al pulsar "Listo": un accidente no
  // puede heredar nada del anterior.
  const reiniciarAccidente = () => {
    accAperturaRef.current++; setAccCargando(false);
    setAccFase("rapida"); setAccRegistro(null); setAccBloqueEstado({}); setAccBloqueGuardando("");
    setAccTipo(""); setAccLesionados(null); setAccSinVehiculo(false);
    setAccDescripcion(""); setAccFotos([]); setAccProgreso([]); setAccVideo(null); setAccVideoSubiendo(null); setAccVideoGuardado("");
    setAccNumSiniestro("");
    setAccContraparteNombre(""); setAccContraparteTel(""); setAccContrapartePlaca(""); setAccContraparteAseguradora(""); setAccContrapartePoliza("");
    setAccDanosTerceros(null); setAccDanosTercerosTexto("");
    setAccTestigos([{nombre:"", telefono:""}]); setAccTestigosGuardados([]); setAccDeclarado({});
    setAccParteTransito(null); setAccFolioParte(""); setAccAmbulancia(null); setAccDetenidos(null); setAccVehiculoRetirado(null);
    setAccFechaHechos(fechaLocal(new Date())); setAccHoraHechos(horaActualHHMM());
    setAccMsg(null); setAccSinAviso(false);
  };
  const cerrarAccidente = () => {
    const volverALista = !!accRegistro?.reabierto;
    reiniciarAccidente();
    if (volverALista) { setPantalla("misAccidentes"); cargarMisAccidentes(); } else setPantalla("menu");
  };

  // ═══ MIS ACCIDENTES ═══════════════════════════════════════════════════════
  const cargarMisAccidentes = async () => {
    if (!correo) return;
    try {
      const snap = await getDocs(query(collection(db,"accidentes"), where("trabajadorEmail","==",correo)));
      setMisAccidentes(snap.docs.map(d=>({id:d.id, ...(d.data() as any)})));
      setMisAccEstado("ok");
    } catch(e){ console.error("mis accidentes:", e); setMisAccEstado("error"); }
  };
  useEffect(() => { cargarMisAccidentes(); /* eslint-disable-next-line */ }, [correo, tickTrab]);
  const misAccidentesVisibles = misAccidentesAbiertos(misAccidentes, empleadorId, Date.now());
  // ABRIR UNO: la MISMA pantalla posterior, con lo guardado cargado. Ver
  // `estadoPosteriorDeAccidente` para qué llega en solo lectura y qué no.
  //
  // ⚠️ SE LEE DE LA BASE, NO DE LA LISTA (4-oct). La lista es una copia de cuando
  // se cargó: si el trabajador completó el accidente después —en la pantalla
  // posterior inmediata—, abrir desde esa copia enseñaba "No lo sé" con botones y
  // sin la foto ni el testigo, y lo que guardaba desde ahí lo rechazaba la regla.
  const abrirAccidenteGuardado = async (a:any) => {
    reiniciarAccidente();
    const turno = ++accAperturaRef.current;
    setMisAccAvisoTxt("");
    setAccRegistro(estadoPosteriorDeAccidente(a).registro as any);
    setAccCargando(true);
    setAccFase("posterior");
    setPantalla("accidente");
    let fresco:any = null;
    try { fresco = await leerAccidenteDeLaBase(String(a?.id || "")); }
    catch (err) { console.error("accidente · no se pudo abrir:", err); }
    if (turno !== accAperturaRef.current) return;
    if (!fresco) {
      reiniciarAccidente();
      setMisAccAvisoTxt("No pudimos abrir el accidente. Revisa tu conexión e inténtalo de nuevo.");
      setPantalla("misAccidentes");
      return;
    }
    // La lista, al día con lo que se acaba de leer.
    setMisAccidentes((prev:any[]) => prev.map((x:any) => x.id === fresco.id ? fresco : x));
    const e = estadoPosteriorDeAccidente(fresco);
    setAccRegistro(e.registro as any);
    setAccDeclarado(e.declarado);
    // "¿Fue a otra hora?" arranca en la hora del registro, como al registrar.
    setAccFechaHechos(e.registro.fechaReg || fechaLocal(new Date()));
    setAccHoraHechos(e.registro.horaReg || horaActualHHMM());
    setAccFotos(e.fotos);
    setAccTestigosGuardados(e.testigos);
    setAccVideoGuardado(e.video);
    const c = e.campos;
    setAccNumSiniestro(c.numeroSiniestro);
    setAccContraparteNombre(c.contraparteNombre); setAccContraparteTel(c.contraparteTelefono);
    setAccContrapartePlaca(c.contrapartePlaca); setAccContraparteAseguradora(c.contraparteAseguradora); setAccContrapartePoliza(c.contrapartePoliza);
    setAccDanosTerceros(c.danosTerceros); setAccDanosTercerosTexto(c.danosTercerosDesc);
    setAccParteTransito(c.parteTransito); setAccFolioParte(c.folioParte);
    setAccAmbulancia(c.huboAmbulancia); setAccDetenidos(c.huboDetenidos); setAccVehiculoRetirado(c.vehiculoRetirado);
    setAccCargando(false);
  };

  // Badges legibles sobre navy: colores aclarados para buen contraste en oscuro.
  const badgeEstado = (estado:string) => {
    const c = estado==="Confirmada" ? {bg:"rgba(16,185,129,0.16)", bd:"rgba(16,185,129,0.40)", fg:"#34D399"}
      : estado==="Por confirmar" ? {bg:"rgba(184,147,42,0.18)", bd:"rgba(184,147,42,0.45)", fg:"#E2B84A"}
      : {bg:"rgba(255,255,255,0.08)", bd:"rgba(255,255,255,0.22)", fg:"rgba(255,255,255,0.7)"};
    return <span style={{fontSize:11, fontWeight:700, padding:"3px 10px", borderRadius:999, border:`1px solid ${c.bd}`, background:c.bg, color:c.fg}}>{estado}</span>;
  };

  // Resumen compacto de la última checada de hoy (para el chip del menú).
  const ultChecHoy = checadasHoy[0];
  const ultChecHoyTxt = ultChecHoy ? (() => {
    const d = ultChecHoy.timestamp?.toDate?.();
    const h = d ? d.toLocaleTimeString("es-MX",{hour:"2-digit",minute:"2-digit"}) : "—";
    return `${labelChecada(ultChecHoy.tipo)} ${h}`;
  })() : null;

  // ── Navegación interna del portal: menú de 3 entradas → función → volver ──
  // Solo presentación/navegación (useState local). NO toca la lógica de las funciones.
  const [pantalla, setPantalla] = useState<"menu"|"checador"|"flotilla"|"tareas"|"accidente"|"misAccidentes"|"notificaciones"|"perfil"|"calendario">("menu");
  // EL RECORDATORIO DE ENTRADA (13-oct-2026): solo si su patrón lo tiene encendido.
  const recordatorio = useRecordatorioTrabajador(user?.uid || "", cfgEmpresa?.recordatorioEntrada?.activo === true);
  // Al tocar el recordatorio: al checador.
  // VA ANTES DEL AVISO A PROPÓSITO: si llegan juntos ?vista= y ?abrir=checador, el
  // aviso se aplica después y gana (lo que se tocó es la notificación).
  // SU PANTALLA EN LA DIRECCIÓN: una recarga vuelve aquí y "atrás" a la anterior. Las
  // mismas entradas que el menú (con lo que cada una carga al abrirse). El registro
  // de un accidente no se restaura: sin su contexto sería un formulario vacío.
  useVistaEnLaDireccion({principal: "menu", mostrada: pantalla, listo: true, aplicar: (v) => {
    if (v === "menu") { setPantalla("menu"); return "ok"; }
    if (VISTAS_DEL_TRABAJADOR.indexOf(v) < 0) return "invalida";
    if (v === "misAccidentes") cargarMisAccidentes();
    if (v === "calendario") setWcalDiaSel(null);
    setPantalla(v as any);
    return "ok";
  }});
  useAbrirDesdeAviso("checador", true, () => setPantalla("checador"));

  // ═══ ABRIR EL ACCIDENTE ═══════════════════════════════════════════════════
  //
  // UNA SOLA PUERTA PARA LAS DOS ENTRADAS. Al accidente se llega desde el menú y
  // desde Flotilla, y hasta ahora las dos hacían lo mismo: `setPantalla`. Eso
  // significaba que quien entraba desde Flotilla —con un viaje abierto, con la
  // unidad delante en la pantalla anterior— tenía que volver a buscar su propia
  // placa en un desplegable, de pie en la carretera. La plataforma ya sabía cuál
  // era y se lo preguntaba igual.
  //
  // Si mañana aparece una tercera entrada, entra por aquí y hereda sola.
  const abrirAccidente = (desde:"flotilla"|"menu") => {
    // LA HERENCIA DEPENDE DE QUE HAYA VIAJE ABIERTO, NO DE POR DÓNDE SE ENTRÓ. Antes
    // solo heredaba la entrada de Flotilla: quien abría el accidente desde el menú
    // con un viaje abierto tenía que volver a buscar su propia placa. El accidente
    // ocurrió durante ese viaje igual. `desde` se sigue guardando, como dato de
    // origen, pero ya no decide nada.
    const sal = viajeAbierto ? viajeAbierto.salida : null;
    const vehId = String(sal?.vehiculoId || "");
    // La etiqueta se compone AL ABRIR, del catálogo de unidades, con la placa de
    // la salida como respaldo: es lo que la persona vio cuando entró.
    const veh = vehId ? vehiculosPatron.find((v:any)=>v.id===vehId) : null;
    const etiqueta = veh
      ? `${veh.placa||""}${(veh.marca||veh.modelo)?` · ${[veh.marca,veh.modelo].filter(Boolean).join(" ")}`:""}`.trim()
      : String(sal?.placa || "").toUpperCase();
    setAccContexto({
      salidaId: String(sal?.id || ""),
      vehiculoId: vehId,
      placa: String(sal?.placa || "").toUpperCase(),
      etiqueta,
      origen: desde,
    });
    // Cada accidente empieza de cero: nada del anterior puede colarse en éste.
    reiniciarAccidente();
    setAccVehiculo(vehId);
    setAccCorrigeVehiculo(false);
    // La ubicación se pide YA, al abrir: cuando la persona pulse el botón, lo más
    // probable es que haya llegado.
    tomarGpsAccidente();
    setPantalla("accidente");
  };
  // Calendario del trabajador (solo lectura): mes visible + día seleccionado.
  const [wcalY, setWcalY] = useState(()=> new Date().getFullYear());
  const [wcalM, setWcalM] = useState(()=> new Date().getMonth());
  const [wcalDiaSel, setWcalDiaSel] = useState<string|null>(null);
  const tituloFuncion = pantalla==="checador" ? "Checador" : pantalla==="flotilla" ? "Flotilla" : pantalla==="tareas" ? "Mis actividades" : pantalla==="accidente" ? (accRegistro?.reabierto ? "Completar accidente" : "Registrar accidente") : pantalla==="misAccidentes" ? "Mis accidentes" : pantalla==="notificaciones" ? "Notificaciones" : pantalla==="perfil" ? "Perfil" : pantalla==="calendario" ? "Calendario" : "";
  // Secciones RAÍZ de la barra inferior (sin botón Volver). Las funciones que se
  // abren desde Inicio (checador/flotilla/accidente) SÍ muestran Volver → "menu".
  const seccionRaiz = pantalla==="menu" || pantalla==="tareas" || pantalla==="notificaciones" || pantalla==="perfil";
  const barraActiva: "inicio"|"tareas"|"notificaciones"|"perfil" =
    pantalla==="tareas" ? "tareas" : pantalla==="notificaciones" ? "notificaciones" : pantalla==="perfil" ? "perfil" : "inicio";

  // Puntito de no leídos: hay algo NUEVO —posterior a la marca— si un aviso de
  // empresa, un evento, un reporte o una actividad recién asignada lo es.
  // Reutiliza avisos/tareas ya cargados; nada nuevo en backend.
  //
  // Mientras la marca es `null` no se sabe qué se vio, y el punto NO se enciende:
  // encenderlo y apagarlo medio segundo después es peor que tardar en encenderlo.
  const hayNoLeidos = notisVistasAt !== null && (
    avisos.some((a:any)=> (a.createdAt?.toMillis?.()||0) > notisVistasAt) ||
    eventos.some((e:any)=> (e.createdAt?.toMillis?.()||0) > notisVistasAt) ||
    reportes.some((r:any)=> (r.fechaEnvio?.toMillis?.()||0) > notisVistasAt) ||
    tareas.some((t:any)=> !t.marcadaPorTrabajador && !t.confirmadaPorPatron && (t.creadoEn?.toMillis?.()||0) > notisVistasAt));
  // Al ABRIR Notificaciones —no al cargar la pantalla— se mueve la marca a este
  // instante, en el servidor. Verlas aquí las apaga también en la computadora.
  useEffect(() => {
    if (pantalla !== "notificaciones") return;
    marcarNotisVistas();
    /* eslint-disable-next-line */
  }, [pantalla]);
  const iniciales = (nombre||"").trim().split(/\s+/).slice(0,2).map((s:string)=>s[0]||"").join("").toUpperCase() || "·";

  // ── Sub-paleta NAVY/GOLD del portal (boutique). El navy lleva el peso; el gold
  // se reserva para contornos, títulos y acentos. Texto crema con buen contraste. ──
  // ── Acento del portal del trabajador (personalización local por usuario) ──
  // Mismo mecanismo/curaduría que el portal del patrón. Solo cambia el acento; navy
  // y estructura intactos. Default = dorado (valores idénticos a los de hoy).
  const ACENTOS_TR: Record<string,{label:string; gold:string; goldDim:string; rgbDim:string; rgbBright:string}> = {
    dorado:    { label:"Dorado",    gold:"#D4A843", goldDim:"#B8932A", rgbDim:"184,147,42", rgbBright:"212,168,67" },
    esmeralda: { label:"Esmeralda", gold:"#3FBF8F", goldDim:"#2E9E74", rgbDim:"46,158,116", rgbBright:"63,191,143" },
    cobre:     { label:"Cobre",     gold:"#D98E5A", goldDim:"#BB7443", rgbDim:"187,116,67", rgbBright:"217,142,90" },
  };
  const claveAcentoTr = `axis_acento_trabajador:${user?.uid||""}`;
  const [acentoTr, setAcentoTr] = useState<string>(()=>{ try { const v=localStorage.getItem(claveAcentoTr); return v && ACENTOS_TR[v] ? v : "dorado"; } catch { return "dorado"; } });
  const elegirAcentoTr = (k:string)=>{ setAcentoTr(k); try { localStorage.setItem(claveAcentoTr, k); } catch {} };
  const ATR = ACENTOS_TR[acentoTr] || ACENTOS_TR.dorado;

  const NV = {
    bg:        "#0B1829",                  // fondo navy profundo de toda la vista
    panel:     "#11233F",                  // tarjeta/panel: navy un punto más claro (da profundidad)
    panelHov:  "#15294A",                  // hover del panel
    line:      `rgba(${ATR.rgbDim},0.22)`,    // contorno de acento fino en reposo
    lineHov:   `rgba(${ATR.rgbBright},0.55)`,  // contorno de acento intensificado en hover
    lineSoft:  "rgba(255,255,255,0.09)",   // divisor sutil claro sobre navy
    gold:      ATR.gold,                    // acento (títulos/saludo)
    goldDim:   ATR.goldDim,
    ink:       "#ECE6D8",                  // texto crema principal
    inkSoft:   "rgba(236,230,216,0.66)",   // texto secundario
    inkMut:    "rgba(236,230,216,0.42)",   // etiquetas/atenuado
    iconBg:    `rgba(${ATR.rgbDim},0.10)`,    // contenedor de ícono: acento sutil
    iconBd:    `rgba(${ATR.rgbDim},0.32)`,
    sombra:    "0 6px 20px rgba(0,0,0,0.35)",
    sombraHov: "0 12px 30px rgba(0,0,0,0.50)",
    glowHov:   `0 12px 30px rgba(0,0,0,0.50), 0 0 0 1px rgba(${ATR.rgbBright},0.20)`,
  };
  // Estilos de formulario sobre navy (labels y campos) — usados por Registrar accidente.
  const labelNV = {fontSize:11, fontWeight:700, color:NV.inkMut, textTransform:"uppercase" as const, letterSpacing:"0.4px", display:"block", marginBottom:6};
  const inputNV = {width:"100%", padding:"11px 12px", border:`1px solid ${NV.line}`, borderRadius:10, fontSize:13.5, outline:"none", boxSizing:"border-box" as const, fontFamily:fontSans, background:"rgba(255,255,255,0.06)", color:NV.ink};

  // Sección colapsable (acordeón) navy/gold para el formulario de accidente.
  // UN BLOQUE DE LA PANTALLA POSTERIOR: título, contenido, su propio "Guardar" y
  // lo que pasó al guardar. Sin acordeón: son pocos, están en orden de lo que
  // desaparece antes del lugar, y esconderlos sería otro toque en el peor momento.
  // Los bloques que se guardan solos —fotos y vídeo— no llevan botón.
  // "¿Fue a otra hora?" solo se puede guardar si la fecha o la hora NO son las del
  // registro. Sin la hora del registro a mano (no debería pasar), no se bloquea.
  const horaDistintaDelRegistro = !!accRegistro && (!accRegistro.fechaReg
    || accFechaHechos !== accRegistro.fechaReg || accHoraHechos !== accRegistro.horaReg);
  // `puedeGuardar` (opcional, por omisión sí): un bloque puede exigir que algo
  // haya cambiado antes de dejar guardar. Lo usa "¿Fue a otra hora?".
  const bloqueAcc = (clave:string, titulo:string, contenido:React.ReactNode, onGuardar?:()=>void, puedeGuardar:boolean = true, porQueNo?:string) => {
    const est = accBloqueEstado[clave];
    const guardando = accBloqueGuardando === clave;
    return (
      <div key={clave} data-bloque-acc={clave} style={{border:`1px solid ${NV.line}`, borderRadius:12, marginBottom:10, background:"rgba(255,255,255,0.02)",
        padding:isMobile?"13px 14px":"14px 16px"}}>
        <div style={{fontSize:13.5, fontWeight:700, color:NV.gold, fontFamily:fontSerif, marginBottom:10}}>{titulo}</div>
        {contenido}
        {onGuardar && (
          <button type="button" onClick={onGuardar} disabled={guardando || !puedeGuardar}
            style={{marginTop:12, padding:"9px 18px", borderRadius:10, cursor:guardando?"wait":(!puedeGuardar?"not-allowed":"pointer"), fontFamily:fontSans,
              fontSize:13, fontWeight:700, border:`1px solid ${NV.gold}`, background:"transparent", color:NV.gold, opacity:puedeGuardar?1:0.4}}>
            {guardando ? "Guardando…" : "Guardar"}
          </button>
        )}
        {onGuardar && !puedeGuardar && porQueNo && (
          <div style={{marginTop:7, fontSize:11, color:NV.inkMut}}>{porQueNo}</div>
        )}
        {onGuardar && est && (
          <div style={{marginTop:8, fontSize:11.5, fontWeight:600, color: est.tipo==="ok" ? "#34D399" : "#FCA5A5"}}>{est.texto}</div>
        )}
      </div>
    );
  };
  // Toggle Sí/No segmentado (navy/gold), fácil de tocar en móvil. `null` = sin
  // contestar: no se ilumina ninguna de las dos. El interruptor viejo siempre
  // tenía una encendida, y así "No" parecía una respuesta cuando era un valor
  // por omisión.
  const toggleSiNo = (valor:boolean|null, set:(v:boolean)=>void) => (
    <div style={{display:"inline-flex", borderRadius:9, overflow:"hidden", border:`1px solid ${NV.line}`}}>
      {[{v:true,l:"Sí"},{v:false,l:"No"}].map(o=>(
        <button key={o.l} type="button" onClick={()=>set(o.v)}
          style={{padding:"7px 18px", fontSize:13, fontWeight:700, cursor:"pointer", fontFamily:fontSans, border:"none",
            background: valor===o.v ? NV.gold : "transparent",
            color: valor===o.v ? "#0B1829" : NV.inkSoft}}>{o.l}</button>
      ))}
    </div>
  );
  // Fila etiqueta + control (para los toggles dentro de cada sección).
  const filaSiNo = (etiqueta:string, valor:boolean|null, set:(v:boolean)=>void) => (
    <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", gap:12, marginBottom:12, flexWrap:"wrap" as const}}>
      <span style={{fontSize:13, color:NV.ink, flex:1, minWidth:140}}>{etiqueta}</span>
      {toggleSiNo(valor, set)}
    </div>
  );

  // Realce de las tarjetas de acceso del portal (Inicio): contorno dorado fino MÁS
  // visible (mismo tono de marca rgba(184,147,42,…)) + panel un pelín más claro y un
  // glow dorado muy tenue, para que levanten del navy sin verse recargadas.
  const panelCard  = "#13284A";                                            // un punto más claro que NV.panel
  const bordeCard  = `rgba(${ATR.rgbDim},0.45)`;                              // contorno de acento fino visible
  const sombraCard = `0 6px 20px rgba(0,0,0,0.35), 0 2px 10px rgba(${ATR.rgbDim},0.07)`; // sombra + glow de acento sutil

  // Tarjeta del menú (boutique navy/gold). icono = SVG (en contenedor dorado sutil).
  const tarjetaMenu = (destino:"checador"|"flotilla"|"tareas", accent:string, icono:React.ReactNode, titulo:string, subtitulo:string, derecha:React.ReactNode) => (
    <button onClick={()=>setPantalla(destino)}
      onMouseEnter={(e)=>{ const t=e.currentTarget; t.style.transform="translateY(-2px)"; t.style.borderColor=NV.lineHov; t.style.boxShadow=NV.glowHov; t.style.background=NV.panelHov; }}
      onMouseLeave={(e)=>{ const t=e.currentTarget; t.style.transform="translateY(0)"; t.style.borderColor=bordeCard; t.style.boxShadow=sombraCard; t.style.background=panelCard; }}
      style={{display:"flex", alignItems:"center", gap:14, width:"100%", textAlign:"left" as const, fontFamily:"inherit",
        background:panelCard, border:`1px solid ${bordeCard}`, borderRadius:16, padding:isMobile?"16px 14px":"18px 18px",
        boxShadow:sombraCard, cursor:"pointer", transition:"transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease, background 0.2s ease"}}>
      <div style={{width:isMobile?50:54, height:isMobile?50:54, borderRadius:14, flexShrink:0, display:"flex", alignItems:"center", justifyContent:"center",
        background:NV.iconBg, border:`1px solid ${bordeCard}`, color:NV.gold}}>{icono}</div>
      <div style={{flex:1, minWidth:0}}>
        <div style={{fontFamily:fontSerif, fontSize:isMobile?17:18, fontWeight:700, color:NV.gold, lineHeight:1.15}}>{titulo}</div>
        <div style={{fontSize:12.5, color:NV.inkSoft, marginTop:2}}>{subtitulo}</div>
      </div>
      <div style={{display:"flex", alignItems:"center", gap:8, flexShrink:0}}>
        {derecha}
        <span style={{fontSize:22, color:NV.inkMut, fontWeight:400, lineHeight:1}}>›</span>
      </div>
    </button>
  );
  // Tarjeta de ACCIÓN del menú: MISMO formato que tarjetaMenu, pero ejecuta una
  // acción onClick (abrir WhatsApp / abrir formulario) en vez de mapear a una
  // sub-pantalla fija. Estilo idéntico para que se vea igual que las 3 actuales.
  const tarjetaMenuAccion = (onClick:()=>void, icono:React.ReactNode, titulo:string, subtitulo:string, derecha:React.ReactNode) => (
    <button onClick={onClick}
      onMouseEnter={(e)=>{ const t=e.currentTarget; t.style.transform="translateY(-2px)"; t.style.borderColor=NV.lineHov; t.style.boxShadow=NV.glowHov; t.style.background=NV.panelHov; }}
      onMouseLeave={(e)=>{ const t=e.currentTarget; t.style.transform="translateY(0)"; t.style.borderColor=bordeCard; t.style.boxShadow=sombraCard; t.style.background=panelCard; }}
      style={{display:"flex", alignItems:"center", gap:14, width:"100%", textAlign:"left" as const, fontFamily:"inherit",
        background:panelCard, border:`1px solid ${bordeCard}`, borderRadius:16, padding:isMobile?"16px 14px":"18px 18px",
        boxShadow:sombraCard, cursor:"pointer", transition:"transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease, background 0.2s ease"}}>
      <div style={{width:isMobile?50:54, height:isMobile?50:54, borderRadius:14, flexShrink:0, display:"flex", alignItems:"center", justifyContent:"center",
        background:NV.iconBg, border:`1px solid ${bordeCard}`, color:NV.gold}}>{icono}</div>
      <div style={{flex:1, minWidth:0}}>
        <div style={{fontFamily:fontSerif, fontSize:isMobile?17:18, fontWeight:700, color:NV.gold, lineHeight:1.15}}>{titulo}</div>
        <div style={{fontSize:12.5, color:NV.inkSoft, marginTop:2}}>{subtitulo}</div>
      </div>
      <div style={{display:"flex", alignItems:"center", gap:8, flexShrink:0}}>
        {derecha}
        <span style={{fontSize:22, color:NV.inkMut, fontWeight:400, lineHeight:1}}>›</span>
      </div>
    </button>
  );
  const icoReloj = <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.7"/><path d="M12 7.5v5l3 1.8" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/></svg>;
  const icoAuto  = <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M3.5 13l1.4-4.2A2 2 0 016.8 7.5h10.4a2 2 0 011.9 1.3L20.5 13v4.5a1 1 0 01-1 1h-1a1 1 0 01-1-1V17H6.5v.5a1 1 0 01-1 1h-1a1 1 0 01-1-1V13z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round"/><path d="M3.5 13h17" stroke="currentColor" strokeWidth="1.6"/><circle cx="7.5" cy="15.2" r="1.1" fill="currentColor"/><circle cx="16.5" cy="15.2" r="1.1" fill="currentColor"/></svg>;
  const icoChat  =<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M4 5.5A1.5 1.5 0 015.5 4h13A1.5 1.5 0 0120 5.5v8a1.5 1.5 0 01-1.5 1.5H9.5L5.5 19v-3.5A1.5 1.5 0 014 13.5z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round"/><path d="M8 8.5h8M8 11.3h5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/></svg>;
  const icoAlerta = <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 4.3l8.6 14.7a1 1 0 01-.87 1.5H4.27a1 1 0 01-.87-1.5z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round"/><path d="M12 10v4.2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/><circle cx="12" cy="17.3" r="0.5" fill="currentColor" stroke="currentColor" strokeWidth="0.9"/></svg>;

  return (
    <div style={{minHeight:"100vh", background:NV.bg, fontFamily:fontSans}}>
      <style>{`@keyframes portalFade{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:translateY(0)}}`}</style>
      {/* ── Encabezado compacto (navy/gold, sticky). En una función: botón ‹ Volver. ── */}
      <div style={{background:"#0B1829", paddingTop:isMobile?"calc(10px + env(safe-area-inset-top, 0px))":"calc(13px + env(safe-area-inset-top, 0px))", paddingBottom:isMobile?10:13, paddingLeft:isMobile?14:28, paddingRight:isMobile?14:28, display:"flex", justifyContent:"space-between", alignItems:"center", gap:10, position:"sticky" as const, top:0, zIndex:20, boxShadow:"0 2px 10px rgba(11,24,41,0.18)", borderBottom:`1px solid ${NV.lineSoft}`}}>
        <div style={{display:"flex", alignItems:"center", gap:8, minWidth:0}}>
          {pantalla==="menu" ? (
            <>
              <span style={{fontFamily:fontSerif, fontSize:16, fontWeight:800, color:NV.gold, letterSpacing:"0.5px"}}>AXIS</span>
              <span style={{fontSize:11, color:"rgba(255,255,255,0.55)", whiteSpace:"nowrap" as const}}>Portal del trabajador</span>
            </>
          ) : seccionRaiz ? (
            <span style={{fontFamily:fontSerif, fontSize:16, fontWeight:700, color:NV.gold, whiteSpace:"nowrap" as const}}>{tituloFuncion}</span>
          ) : (
            <button onClick={()=>setPantalla(pantalla==="accidente" && accRegistro?.reabierto ? "misAccidentes" : "menu")} style={{display:"inline-flex", alignItems:"center", gap:7, background:"rgba(255,255,255,0.08)", border:"1px solid rgba(255,255,255,0.16)", borderRadius:9, padding:"6px 12px 6px 9px", cursor:"pointer", fontFamily:fontSans}}>
              <span style={{fontSize:17, color:NV.gold, lineHeight:1}}>‹</span>
              <span style={{fontSize:13, fontWeight:700, color:"white", whiteSpace:"nowrap" as const}}>{tituloFuncion}</span>
            </button>
          )}
        </div>
        <div style={{display:"flex", alignItems:"center", gap:8, minWidth:0}}>
          {/* Recargar: el portal lee UNA vez al abrir, asi que un aviso nuevo o una
              actividad marcada no aparecian hasta cerrar y volver a abrir. */}
          <BotonRecargar onRecargar={refrescarTrab} cargando={refrescandoTrab} error={errorRefrescoTrab}
            color={NV.gold} borde="rgba(226,184,74,0.35)"/>
          {/* Avatar con iniciales → abre Perfil (donde está Cerrar sesión) */}
          <button onClick={()=>setPantalla("perfil")} aria-label="Perfil"
            style={{width:34, height:34, borderRadius:"50%", flexShrink:0, overflow:"hidden", padding:0, cursor:"pointer", fontFamily:fontSans, fontSize:12.5, fontWeight:800, letterSpacing:"0.5px",
              background:`rgba(${ATR.rgbDim},0.14)`, border:`1px solid ${NV.iconBd}`, color:NV.gold, display:"flex", alignItems:"center", justifyContent:"center"}}>
            {fotoPerfilTrab ? <img src={fotoPerfilTrab} alt="" style={{width:"100%", height:"100%", objectFit:"cover" as const, display:"block"}}/> : iniciales}
          </button>
        </div>
      </div>

      <div key={pantalla} style={{maxWidth:560, margin:"0 auto", padding:isMobile?"16px 14px 110px":"26px 24px 80px", animation:"portalFade 0.2s ease"}}>

        {/* ════ MENÚ DE 3 ENTRADAS ════ */}
        {pantalla==="menu" && (
          <>
            <div style={{marginBottom:isMobile?16:20}}>
              <div style={{fontSize:11, color:NV.gold, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"1.5px", marginBottom:4}}>Bienvenido</div>
              <h1 style={{fontFamily:fontSerif, fontSize:isMobile?23:28, fontWeight:700, color:NV.gold, margin:0, lineHeight:1.1}}>Hola, {nombre}</h1>
              <p style={{fontSize:13, color:NV.inkSoft, margin:"4px 0 0"}}>¿Qué quieres hacer hoy?</p>
            </div>
            {/* INSTALAR LA APP. Un trabajador la usa desde el celular todos los
                dias: tenerla en la pantalla de inicio es la diferencia entre que la
                use y que no. El banner se esconde solo si ya esta instalada. */}
            <div style={{marginBottom:isMobile?16:20}}>
              <InstallBanner fontSerif={fontSerif} gold={NV.gold} isMobile={isMobile} />
            </div>
            <div style={{display:"flex", flexDirection:"column" as const, gap:12}}>
              {tarjetaMenu("checador", "#236478", icoReloj, "Checador", "Registra tu entrada y salida",
                ultChecHoyTxt
                  ? <span style={{fontSize:11, fontWeight:700, padding:"3px 10px", borderRadius:999, background:`${colorChecada(ultChecHoy.tipo)}26`, color:colorChecada(ultChecHoy.tipo), whiteSpace:"nowrap" as const}}>{ultChecHoyTxt}</span>
                  : <span style={{fontSize:11, fontWeight:600, color:NV.inkMut, whiteSpace:"nowrap" as const}}>Sin registro hoy</span>
              )}
              {tarjetaMenu("flotilla", "#5D4037", icoAuto, "Flotilla", "Registra salida o regreso de vehículo", null)}
              {tarjetaMenuAccion(()=>{ setWcalDiaSel(null); setPantalla("calendario"); }, (<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><rect x="3.5" y="5" width="17" height="16" rx="2.5" stroke="currentColor" strokeWidth="1.7"/><path d="M3.5 9.5h17M8 3.2v3.2M16 3.2v3.2" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/></svg>), "Calendario", "Eventos de tu empresa y tus actividades con fecha", null)}
              {tarjetaMenuAccion(()=>abrirAccidente("menu"), icoAlerta, "Registrar accidente", "Deja constancia de un accidente ocurrido.", null)}
              {tarjetaMenuAccion(()=>{ cargarMisAccidentes(); setPantalla("misAccidentes"); }, icoAlerta, "Mis accidentes", "Completa fotos, testigos y lo que falte durante 7 días.",
                misAccidentesVisibles.length > 0
                  ? <span style={{fontSize:11, fontWeight:700, padding:"3px 10px", borderRadius:999, background:"rgba(252,165,165,0.16)", color:"#FCA5A5", whiteSpace:"nowrap" as const}}>{misAccidentesVisibles.length}</span>
                  : null)}
              {tarjetaMenuAccion(abrirWhatsAppAXIS, icoChat, "Contactar a AXIS", "¿Necesitas apoyo? Escríbenos por WhatsApp.", null)}
            </div>
          </>
        )}

        {/* ════ FUNCIÓN: CALENDARIO (solo lectura) ════ */}
        {pantalla==="calendario" && (() => {
          // Reutiliza eventos (comunicados tipo='evento') + tareas con fecha límite.
          // NO incluye fechas legales/fiscales (esas son del patrón). Todo en JS.
          const hoy = new Date(); hoy.setHours(0,0,0,0);
          const isoDe = (d:Date)=> `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`;
          const hoyISO = isoDe(hoy);
          const items:any[] = [];
          (eventos||[]).forEach((ev:any)=>{ if (ev.fecha) items.push({tipo:"evento", fecha:String(ev.fecha), titulo:ev.titulo||"Evento", hora:ev.hora||"", lugar:ev.lugar||"", mensaje:ev.mensaje||"", id:ev.id}); });
          (tareas||[]).forEach((t:any)=>{ if (t.fechaLimite) items.push({tipo:"tarea", fecha:String(t.fechaLimite), titulo:t.titulo||"Actividad", hora:t.horario||"", lugar:"", mensaje:t.descripcion||"", id:`tarea-${t.id}`, confirmada:!!t.confirmadaPorPatron}); });
          const colTipo = (tp:string)=> tp==="evento" ? "#7FD1C0" : NV.gold;
          const exportar = (it:any)=> exportarEventoICS({ id:it.id, titulo:it.titulo, fecha:it.fecha, hora:it.hora, lugar:it.lugar, mensaje:it.mensaje });

          const nombreMes = new Date(wcalY, wcalM, 1).toLocaleDateString("es-MX",{month:"long", year:"numeric"});
          const primerDia = new Date(wcalY, wcalM, 1).getDay();
          const diasEnMes = new Date(wcalY, wcalM+1, 0).getDate();
          const celdas:(number|null)[] = [...Array(primerDia).fill(null), ...Array.from({length:diasEnMes},(_,i)=>i+1)];
          const porDia:Record<string,any[]> = {};
          items.forEach((it:any)=>{ const [y,m]=it.fecha.split("-").map(Number); if (y===wcalY && m===wcalM+1) (porDia[it.fecha]=porDia[it.fecha]||[]).push(it); });
          const calPrev = ()=>{ setWcalDiaSel(null); if (wcalM===0){ setWcalM(11); setWcalY(y=>y-1);} else setWcalM(m=>m-1); };
          const calNext = ()=>{ setWcalDiaSel(null); if (wcalM===11){ setWcalM(0); setWcalY(y=>y+1);} else setWcalM(m=>m+1); };
          const itemsSel = wcalDiaSel ? (porDia[wcalDiaSel]||[]) : [];
          const diasDe = (iso:string)=>{ const [y,m,d]=iso.split("-").map(Number); return Math.round((new Date(y,m-1,d).getTime()-hoy.getTime())/86400000); };
          const enX = (n:number)=> n===0?"Hoy":n===1?"Mañana":`En ${n} días`;
          const proximos = items.map((it:any)=>({...it, dd:diasDe(it.fecha)})).filter((it:any)=>it.dd>=0 && it.dd<=60).sort((a:any,b:any)=>a.dd-b.dd);

          const tarjetaItem = (it:any, sufijo:string) => (
            <div key={`${it.id}-${sufijo}`} style={{background:NV.panel, border:`1px solid ${NV.line}`, borderLeft:`3px solid ${colTipo(it.tipo)}`, borderRadius:14, padding:"12px 13px", boxShadow:NV.sombra}}>
              <div style={{display:"flex", alignItems:"baseline", gap:8, flexWrap:"wrap" as const, marginBottom:3}}>
                <span style={{fontSize:10, fontWeight:800, padding:"2px 8px", borderRadius:999, border:`1px solid ${colTipo(it.tipo)}66`, color:colTipo(it.tipo), whiteSpace:"nowrap" as const}}>{it.tipo==="evento"?"Evento":"Actividad"}</span>
                <span style={{fontSize:13.5, fontWeight:700, color:NV.ink, flex:1, minWidth:0}}>{it.titulo}</span>
              </div>
              <div style={{fontSize:11.5, color:NV.inkMut}}>{it.tipo==="evento"?"Fecha: ":"Límite: "}{it.fecha}{it.hora?` · ${it.hora}`:""}{it.lugar?` · ${it.lugar}`:""}</div>
              {it.mensaje && <div style={{fontSize:12, color:NV.inkSoft, marginTop:3, lineHeight:1.4, whiteSpace:"pre-wrap" as const}}>{it.mensaje}</div>}
              <button onClick={()=>exportar(it)}
                style={{display:"inline-flex", alignItems:"center", gap:7, marginTop:10, padding:"8px 12px", borderRadius:10, border:`1px solid ${colTipo(it.tipo)}73`, background:`${colTipo(it.tipo)}1f`, color:colTipo(it.tipo), cursor:"pointer", fontFamily:fontSans, fontSize:12, fontWeight:700}}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><rect x="3.5" y="5" width="17" height="16" rx="2.5" stroke="currentColor" strokeWidth="1.7"/><path d="M3.5 9.5h17M8 3.2v3.2M16 3.2v3.2" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/><path d="M12 12.5v4M10 14.5h4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/></svg>
                Agregar a mi calendario
              </button>
            </div>
          );

          return (
            <div>
              <div style={{marginBottom:12}}>
                <h1 style={{fontFamily:fontSerif, fontSize:isMobile?22:24, fontWeight:700, color:NV.gold, margin:0, lineHeight:1.1}}>Calendario</h1>
                <p style={{fontSize:13, color:NV.inkSoft, margin:"3px 0 0"}}>Eventos de tu empresa y tus actividades con fecha.</p>
              </div>

              {/* Navegación de mes */}
              <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:10}}>
                <button onClick={calPrev} aria-label="Mes anterior" style={{width:38, height:38, borderRadius:10, border:`1px solid ${NV.line}`, background:NV.panel, color:NV.gold, cursor:"pointer", fontSize:18, fontFamily:fontSans}}>‹</button>
                <div style={{fontFamily:fontSerif, fontSize:17, fontWeight:700, color:NV.ink, textTransform:"capitalize" as const}}>{nombreMes}</div>
                <button onClick={calNext} aria-label="Mes siguiente" style={{width:38, height:38, borderRadius:10, border:`1px solid ${NV.line}`, background:NV.panel, color:NV.gold, cursor:"pointer", fontSize:18, fontFamily:fontSans}}>›</button>
              </div>

              {/* Cuadrícula */}
              <div style={{background:NV.panel, border:`1px solid ${NV.line}`, borderRadius:16, padding:"12px 10px", boxShadow:NV.sombra, marginBottom:14}}>
                <div style={{display:"grid", gridTemplateColumns:"repeat(7,1fr)", gap:2, marginBottom:4}}>
                  {["D","L","M","M","J","V","S"].map((d,i)=>(<div key={i} style={{textAlign:"center" as const, fontSize:10.5, fontWeight:700, color:NV.inkMut, padding:"2px 0"}}>{d}</div>))}
                </div>
                <div style={{display:"grid", gridTemplateColumns:"repeat(7,1fr)", gap:2}}>
                  {celdas.map((dia,i)=>{
                    if (dia===null) return <div key={`b${i}`}/>;
                    const iso = `${wcalY}-${String(wcalM+1).padStart(2,"0")}-${String(dia).padStart(2,"0")}`;
                    const evs = porDia[iso]||[];
                    const esHoy = iso===hoyISO;
                    const sel = iso===wcalDiaSel;
                    const colores = Array.from(new Set(evs.map((it:any)=>colTipo(it.tipo)))).slice(0,3);
                    return (
                      <button key={iso} onClick={()=>setWcalDiaSel(sel?null:iso)}
                        style={{aspectRatio:"1 / 1", display:"flex", flexDirection:"column" as const, alignItems:"center", justifyContent:"center", gap:3, borderRadius:9, cursor:"pointer", fontFamily:fontSans, padding:0,
                          border:`1px solid ${sel?NV.gold:esHoy?`rgba(${ATR.rgbBright},0.4)`:"transparent"}`,
                          background:sel?`rgba(${ATR.rgbBright},0.16)`:esHoy?`rgba(${ATR.rgbBright},0.07)`:"transparent"}}>
                        <span style={{fontSize:13, fontWeight:esHoy||sel?800:600, color:esHoy||sel?NV.gold:NV.ink}}>{dia}</span>
                        <span style={{display:"flex", gap:2, height:5, alignItems:"center"}}>
                          {colores.map((c:any,ci:number)=>(<span key={ci} style={{width:5, height:5, borderRadius:"50%", background:c}}/>))}
                        </span>
                      </button>
                    );
                  })}
                </div>
              </div>

              {/* Día seleccionado */}
              {!wcalDiaSel ? (
                <div style={{textAlign:"center" as const, padding:"20px", background:NV.panel, border:`1px solid ${NV.line}`, borderRadius:16, boxShadow:NV.sombra}}>
                  <div style={{fontSize:12.5, color:NV.inkSoft, lineHeight:1.5}}>Toca un día con marca para ver sus eventos y actividades.</div>
                </div>
              ) : itemsSel.length===0 ? (
                <div style={{textAlign:"center" as const, padding:"20px", background:NV.panel, border:`1px solid ${NV.line}`, borderRadius:16, boxShadow:NV.sombra}}>
                  <div style={{fontSize:12.5, color:NV.inkSoft, lineHeight:1.5}}>Nada este día.</div>
                </div>
              ) : (
                <>
                  <div style={{fontSize:11, color:NV.gold, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"0.8px", margin:"0 2px 8px"}}>
                    {new Date(wcalY, wcalM, Number(wcalDiaSel.slice(-2))).toLocaleDateString("es-MX",{weekday:"long", day:"numeric", month:"long"})}
                  </div>
                  <div style={{display:"flex", flexDirection:"column" as const, gap:9}}>{itemsSel.map((it:any)=>tarjetaItem(it,"dia"))}</div>
                </>
              )}

              {/* Próximos · 60 días */}
              <div style={{marginTop:20}}>
                <div style={{fontSize:11, color:NV.inkMut, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"1px", margin:"0 2px 10px"}}>Próximos · 60 días</div>
                {proximos.length===0 ? (
                  <div style={{textAlign:"center" as const, padding:"20px", background:NV.panel, border:`1px solid ${NV.line}`, borderRadius:16, boxShadow:NV.sombra}}>
                    <div style={{fontSize:12.5, color:NV.inkSoft, lineHeight:1.5}}>Nada en los próximos 60 días.</div>
                  </div>
                ) : (
                  <div style={{display:"flex", flexDirection:"column" as const, gap:9}}>{proximos.map((it:any)=>tarjetaItem(it,`prox-${it.dd}`))}</div>
                )}
              </div>

              {icsMsg && <div style={{fontSize:11.5, color:NV.inkSoft, textAlign:"center" as const, marginTop:12}}>{icsMsg}</div>}
            </div>
          );
        })()}

        {/* ════ FUNCIÓN: CHECADOR ════ */}
        {pantalla==="checador" && (
        <div {...ZONA_DE_CAPTURA} style={{background:NV.panel, border:`1px solid ${NV.line}`, borderRadius:INI.radio, padding:isMobile?"16px 14px":"20px 18px", borderLeft:`3px solid ${NV.gold}`, marginBottom:12, boxShadow:NV.sombra}}>
          {/* Encabezado: reloj grande centrado */}
          <div style={{textAlign:"center" as const, marginBottom:16}}>
            <div style={{width:64, height:64, borderRadius:"50%", margin:"0 auto 10px", display:"flex", alignItems:"center", justifyContent:"center", background:NV.iconBg, border:`1px solid ${NV.iconBd}`, color:NV.gold}}>
              <svg width="34" height="34" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.6"/><path d="M12 7v5l3.5 2" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/></svg>
            </div>
            <div style={{fontFamily:fontSerif, fontSize:isMobile?17:18, fontWeight:700, color:NV.gold}}>Registra tu entrada o salida</div>
            {ultChecHoyTxt && <div style={{fontSize:12, color:NV.inkSoft, marginTop:3}}>Último hoy: {ultChecHoyTxt}</div>}
          </div>

          {/* Tu horario: resuelto igual que en el panel del patrón. */}
          {(()=>{ const he:any = miHorario; const cfg = he && (he.entrada || he.salida);
            return (
              <div style={{display:"flex", alignItems:"center", gap:11, background:"rgba(255,255,255,0.03)", border:`1px solid ${NV.lineSoft}`, borderRadius:12, padding:"11px 13px", marginBottom:14}}>
                <div style={{width:34, height:34, borderRadius:9, flexShrink:0, display:"flex", alignItems:"center", justifyContent:"center", background:NV.iconBg, border:`1px solid ${NV.iconBd}`, color:NV.gold}}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.6"/><path d="M12 7.5V12l3 1.7" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/></svg>
                </div>
                <div style={{flex:1, minWidth:0}}>
                  <div style={{fontSize:10.5, fontWeight:700, color:NV.gold, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>Tu horario</div>
                  {cfg ? (
                    <div style={{fontSize:13, color:NV.ink, fontWeight:600, marginTop:2, lineHeight:1.45}}>
                      Entrada {he.entrada||"—"} · Salida {he.salida||"—"}{he.usaComida && he.comidaInicio && he.comidaFin ? ` · Comida ${he.comidaInicio}–${he.comidaFin}` : ""}
                      {typeof he.toleranciaMin==="number" ? <span style={{color:NV.inkMut, fontWeight:500}}>{"  ·  Tolerancia "}{he.toleranciaMin} min</span> : null}
                    </div>
                  ) : (
                    <div style={{fontSize:12.5, color:NV.inkMut, marginTop:2}}>Horario no configurado aún.</div>
                  )}
                  {/* SU LUGAR DE TRABAJO (11-oct-2026): contra esta sede se mide si checa dentro o fuera. */}
                  {/* Sin nombre (la principal que el patrón no ha nombrado) no hay línea, como antes. */}
                  {miSede && String(miSede.nombre||"").trim() && (
                    <div data-mi-sede={miSede.sedeId} style={{fontSize:12, color:NV.inkSoft, marginTop:4}}>
                      Tu lugar de trabajo: <span style={{color:NV.ink, fontWeight:700}}>{miSede.nombre}</span>
                    </div>
                  )}
                </div>
              </div>
            );
          })()}

          {/* Biometría del dispositivo (WebAuthn) — estado + activar */}
          {navInternoAhora && (
            <div style={{fontSize:12, color:NV.inkSoft, marginBottom:14, lineHeight:1.55, background:"rgba(184,147,42,0.08)", border:`1px solid ${NV.iconBd}`, borderRadius:12, padding:"11px 13px"}}>
              <strong style={{color:NV.gold}}>Estás dentro de {navInternoAhora === "otra app" ? "otra app" : navInternoAhora}.</strong> Para usar tu huella, abre la plataforma en Chrome. Puedes checar igual: quedará anotado que fue sin verificación en el aparato.
            </div>
          )}
          {!navInternoAhora && bioSoporte===true && (
            <div style={{display:"flex", alignItems:"center", gap:11, background:"rgba(255,255,255,0.03)", border:`1px solid ${NV.lineSoft}`, borderRadius:12, padding:"11px 13px", marginBottom:14}}>
              <div style={{width:34, height:34, borderRadius:9, flexShrink:0, display:"flex", alignItems:"center", justifyContent:"center", background:NV.iconBg, border:`1px solid ${NV.iconBd}`, color:NV.gold}}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M12 11c-1 0-2 .8-2 3v3M8.5 9.5a4 4 0 017 0M6 8.5a7 7 0 0112 0M9 13v3.5a3 3 0 006 0V13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
              </div>
              <div style={{flex:1, minWidth:0}}>
                <div style={{fontSize:10.5, fontWeight:700, color:NV.gold, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>Verificación en el aparato</div>
                <div style={{fontSize:12.5, color:NV.inkSoft, marginTop:1}}>{bioActiva ? "Activada · se te pedirá al checar." : "Se activará la primera vez que checes (o actívala ahora)."}</div>
                {bioMsg && <div style={{fontSize:11.5, color:NV.inkMut, marginTop:3}}>{bioMsg}</div>}
              </div>
              {!bioActiva && (
                <button onClick={activarBiometria} disabled={bioTrabajando}
                  style={{flexShrink:0, padding:"8px 12px", borderRadius:9, border:`1px solid ${NV.iconBd}`, background:NV.iconBg, color:NV.gold, cursor:bioTrabajando?"wait":"pointer", fontFamily:fontSans, fontSize:12, fontWeight:700}}>{bioTrabajando?"…":"Activar"}</button>
              )}
            </div>
          )}
          {!navInternoAhora && bioSoporte===false && (
            <div style={{fontSize:11.5, color:NV.inkMut, marginBottom:14, lineHeight:1.5, background:"rgba(255,255,255,0.03)", border:`1px solid ${NV.lineSoft}`, borderRadius:12, padding:"11px 13px"}}>Tu teléfono no admite verificación en el aparato; tus checadas se registran sin ella (queda anotado).</div>
          )}

          {/* Comentario opcional (se adjunta a la siguiente checada) */}
          <label style={labelNV}>Comentario (opcional)</label>
          <textarea value={checComentario} onChange={e=>setChecComentario(e.target.value)} rows={2}
            placeholder="Ej. llegué tarde por cita médica"
            style={{...inputNV, resize:"vertical" as const, marginBottom:5}} />
          <p style={{fontSize:11, color:NV.inkMut, margin:"0 0 14px", lineHeight:1.5}}>Se adjunta a la checada que registres a continuación. Es opcional.</p>

          {/* ACCESO DESACTIVADO: se dice desde que se abre, y los botones se apagan. */}
          {accesoDesactivado && (
            <div role="alert" style={{fontSize:13, fontWeight:700, color:"#FCA5A5", background:"rgba(220,38,38,0.10)", border:"1px solid rgba(220,38,38,0.35)", borderRadius:12, padding:"11px 13px", marginBottom:12, lineHeight:1.5}}>
              {TEXTO_ACCESO_DESACTIVADO}
            </div>
          )}
          {/* Tarjetas de acción (4 tipos) */}
          <div style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap:10}}>
            {([
              {v:"entrada" as const,       desc:"Inicio de jornada", ico:(<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M14 4h3a2 2 0 012 2v12a2 2 0 01-2 2h-3" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/><path d="M4 12h10M10 8l4 4-4 4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/></svg>)},
              {v:"salida_comer" as const,  desc:"Pausa de comida", ico:(<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M6 3v8M8 3v4a2 2 0 01-2 2 2 2 0 01-2-2V3M6 11v10" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/><path d="M16.5 3c-1.4 0-2.2 1.9-2.2 4.2s.8 3.6 2.2 3.6m0-7.8V21" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/></svg>)},
              {v:"regreso_comer" as const, desc:"Regresas de comer", ico:(<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M20 12a8 8 0 11-2.4-5.7" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/><path d="M20 4v4h-4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/></svg>)},
              {v:"salida" as const,        desc:"Fin de jornada", ico:(<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M10 4H7a2 2 0 00-2 2v12a2 2 0 002 2h3" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/><path d="M15 12h6M21 12l-4-4M21 12l-4 4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/></svg>)},
            ]).map(t => {
              const col = colorChecada(t.v);
              const activo = checando===t.v;
              // LA QUE TOCA SEGÚN EL ESTADO. Las demás siguen ahí: se ofrece lo
              // que sigue, no se prohíbe lo demás.
              const esLaQueToca = t.v === checadaSugerida;
              return (
                <button key={t.v} onClick={()=>pedirChecada(t.v)} disabled={!!checando || accesoDesactivado}
                  onMouseEnter={(e)=>{ if(!checando){ const x=e.currentTarget; x.style.borderColor=esLaQueToca?col:NV.lineHov; x.style.background=NV.panelHov; } }}
                  onMouseLeave={(e)=>{ const x=e.currentTarget; x.style.borderColor=esLaQueToca?`${col}88`:NV.line; x.style.background=esLaQueToca?`${col}14`:"rgba(255,255,255,0.03)"; }}
                  style={{display:"flex", flexDirection:"column" as const, alignItems:"flex-start", gap:9, textAlign:"left" as const, fontFamily:fontSans,
                    background:esLaQueToca?`${col}14`:"rgba(255,255,255,0.03)", border:`1px solid ${esLaQueToca?`${col}88`:NV.line}`, borderRadius:14, padding:"14px 13px",
                    cursor:accesoDesactivado?"not-allowed":checando?"wait":"pointer", minHeight:isMobile?100:96, opacity:accesoDesactivado?0.4:(checando&&!activo)?0.45:1,
                    transition:"border-color 0.2s ease, background 0.2s ease"}}>
                  <div style={{display:"flex", alignItems:"center", gap:8, width:"100%"}}>
                    <div style={{width:40, height:40, borderRadius:11, display:"flex", alignItems:"center", justifyContent:"center", background:`${col}1f`, border:`1px solid ${col}55`, color:col, flexShrink:0}}>{t.ico}</div>
                    {esLaQueToca && (
                      <span style={{marginLeft:"auto", fontSize:9.5, fontWeight:800, letterSpacing:"0.6px", textTransform:"uppercase" as const, color:col, background:`${col}1f`, border:`1px solid ${col}55`, borderRadius:6, padding:"2px 7px"}}>Te toca</span>
                    )}
                  </div>
                  <div>
                    <div style={{fontSize:13.5, fontWeight:700, color:NV.ink, lineHeight:1.2}}>{activo?"Registrando…":labelChecada(t.v)}</div>
                    <div style={{fontSize:11, color:NV.inkSoft, marginTop:2}}>{t.desc}</div>
                  </div>
                </button>
              );
            })}
          </div>

          {/* En qué estado está, dicho con todas sus letras. Sin esto, el marco
             de "Te toca" es una decoración que no explica de dónde sale. */}
          <div style={{marginTop:10, fontSize:11.5, color:NV.inkSoft, lineHeight:1.55}}>
            {cargaChecadasFallo
              ? <span style={{color:NV.gold, fontWeight:600}}>No pudimos cargar tus checadas de hoy. Puedes checar igual.</span>
              : ultimaHoy
              ? <>Tu última marca de hoy fue <strong style={{color:NV.ink}}>{labelChecada(ultimaHoy.tipo).toLowerCase()}</strong>{ultimaHoy.cuando ? ` a las ${_horaCortaChecada(ultimaHoy.cuando)}` : ""}.</>
              : <>Todavía no registras ninguna marca hoy.</>}
          </div>

          {/* LA CONSECUENCIA, ANTES DE GUARDAR. No es un "¿estás seguro?": dice
             qué va a pasar, y deja seguir. */}
          {confirmarChecada && (
            <div onClick={()=>setConfirmarChecada(null)}
              style={{position:"fixed" as const, inset:0, background:"rgba(6,12,24,0.72)", zIndex:600, display:"flex", alignItems:"center", justifyContent:"center", padding:20}}>
              <div onClick={e=>e.stopPropagation()}
                style={{background:NV.panel, border:`1px solid ${NV.line}`, borderRadius:16, padding:"22px 22px 18px", maxWidth:390, width:"100%", fontFamily:fontSans}}>
                <div style={{fontSize:15, fontWeight:800, color:NV.ink, marginBottom:9}}>
                  {labelChecada(confirmarChecada.tipo)}
                </div>
                <p style={{fontSize:12.5, color:NV.inkSoft, lineHeight:1.65, margin:"0 0 18px"}}>{confirmarChecada.texto}</p>
                <div style={{display:"flex", gap:9}}>
                  <button onClick={()=>setConfirmarChecada(null)}
                    style={{flex:1, background:"transparent", border:`1px solid ${NV.line}`, borderRadius:10, padding:"11px", cursor:"pointer", fontFamily:fontSans, fontSize:13, fontWeight:700, color:NV.inkSoft}}>
                    Mejor no
                  </button>
                  <button onClick={()=>{ const t = confirmarChecada.tipo; setConfirmarChecada(null); registrarChecada(t); }}
                    style={{flex:1, background:colorChecada(confirmarChecada.tipo), border:"none", borderRadius:10, padding:"11px", cursor:"pointer", fontFamily:fontSans, fontSize:13, fontWeight:700, color:"#0B1829"}}>
                    Registrar de todos modos
                  </button>
                </div>
              </div>
            </div>
          )}

          {checadaMsg && (
            <div style={{marginTop:12, fontSize:12, fontWeight:600, padding:"9px 12px", borderRadius:8,
              background: checadaMsg.tipo==="ok"?"rgba(16,185,129,0.14)":checadaMsg.tipo==="info"?"rgba(184,147,42,0.16)":"rgba(220,38,38,0.14)",
              border:`1px solid ${checadaMsg.tipo==="ok"?"rgba(16,185,129,0.38)":checadaMsg.tipo==="info"?"rgba(184,147,42,0.42)":"rgba(220,38,38,0.40)"}`,
              color: checadaMsg.tipo==="ok"?"#34D399":checadaMsg.tipo==="info"?"#E2B84A":"#FCA5A5"}}>{checadaMsg.texto}</div>
          )}

          {/* LA HUELLA FALLÓ: DOS SALIDAS, NUNCA NINGUNA. */}
          {bioFallo && (
            <div style={{marginTop:12, background:"rgba(184,147,42,0.08)", border:`1px solid ${NV.iconBd}`, borderRadius:12, padding:"13px 14px"}}>
              <div style={{fontSize:13.5, fontWeight:800, color:NV.ink, marginBottom:5}}>
                {bioFallo.motivo === MOTIVOS_BIO.FALLIDA ? "No se pudo confirmar tu huella" : "No se pudo registrar tu huella en este teléfono"}
              </div>
              <div style={{fontSize:12, color:NV.inkSoft, lineHeight:1.55, marginBottom:11}}>
                {bioFallo.motivo === MOTIVOS_BIO.FALLIDA
                  ? "Suele pasar si cambiaste de teléfono o de cuenta de Google, o si se borró la llave. Tu checada no se ha perdido: elige cómo registrarla."
                  : "Tu checada no se ha perdido: elige cómo registrarla."}
              </div>
              {bioFallo.detalle && <div style={{fontSize:11.5, color:"#FCA5A5", lineHeight:1.5, marginBottom:10}}>{bioFallo.detalle}</div>}
              <button onClick={registrarHuellaDeNuevo} disabled={!!checando}
                style={{width:"100%", background:`linear-gradient(135deg,${NV.gold},#B8932A)`, border:"none", borderRadius:10, padding:"11px", cursor:checando?"wait":"pointer", fontFamily:fontSans, fontSize:13, fontWeight:800, color:"#0B1829", marginBottom:8}}>
                {checando ? "Registrando…" : "Registrar mi huella de nuevo en este teléfono"}
              </button>
              <button onClick={checarSinBiometria} disabled={!!checando}
                style={{width:"100%", background:"transparent", border:`1px solid ${NV.line}`, borderRadius:10, padding:"10px", cursor:checando?"wait":"pointer", fontFamily:fontSans, fontSize:12.5, fontWeight:700, color:NV.inkSoft}}>
                Checar sin verificación en el aparato
              </button>
              <div style={{fontSize:11, color:NV.inkMut, marginTop:8, lineHeight:1.5}}>Si checas sin verificación en el aparato, tu patrón lo verá, con el motivo.</div>
            </div>
          )}

          {/* ABIERTA DENTRO DE WHATSAPP (U OTRA APP): CÓMO ABRIR EN CHROME, Y SIN BLOQUEAR. */}
          {navInterno && (
            <div style={{marginTop:12, background:"rgba(184,147,42,0.08)", border:`1px solid ${NV.iconBd}`, borderRadius:12, padding:"13px 14px"}}>
              <div style={{fontSize:13.5, fontWeight:800, color:NV.ink, marginBottom:6}}>Para usar tu huella, abre la plataforma en Chrome</div>
              <div style={{fontSize:12, color:NV.inkSoft, lineHeight:1.6, marginBottom:11}}>
                La abriste dentro de {navInterno.nombre === "otra app" ? "otra app" : navInterno.nombre}, y ahí el teléfono no deja usar la huella.
                <ol style={{margin:"7px 0 0", paddingLeft:18}}>
                  <li>Toca el menú de esta pantalla (⋮ o ···), arriba a la derecha.</li>
                  <li>Elige «Abrir en Chrome» o «Abrir en el navegador» (en iPhone, «Abrir en Safari»).</li>
                  <li>Entra a la plataforma y vuelve a checar: ahí sí te pedirá tu huella.</li>
                </ol>
              </div>
              <button onClick={()=>{ try { navigator.clipboard?.writeText(window.location.href); setChecadaMsg({tipo:"info", texto:"Enlace copiado. Pégalo en Chrome."}); } catch(e){} }}
                style={{width:"100%", background:"transparent", border:`1px solid ${NV.iconBd}`, borderRadius:10, padding:"10px", cursor:"pointer", fontFamily:fontSans, fontSize:12.5, fontWeight:700, color:NV.gold, marginBottom:8}}>
                Copiar el enlace para abrirlo en Chrome
              </button>
              <button onClick={checarDesdeNavegadorInterno} disabled={!!checando}
                style={{width:"100%", background:"transparent", border:`1px solid ${NV.line}`, borderRadius:10, padding:"10px", cursor:checando?"wait":"pointer", fontFamily:fontSans, fontSize:12.5, fontWeight:700, color:NV.inkSoft}}>
                {checando ? "Registrando…" : "Checar aquí de todos modos, sin verificación en el aparato"}
              </button>
              <div style={{fontSize:11, color:NV.inkMut, marginTop:8, lineHeight:1.5}}>Si checas aquí, tu patrón verá que fue sin verificación en el aparato porque la abriste desde {navInterno.nombre === "otra app" ? "otra app" : navInterno.nombre}.</div>
            </div>
          )}

          {/* EL RECORDATORIO DE ENTRADA, DEBAJO DE LOS BOTONES Y DE SUS MENSAJES (nunca
              encima ni en una ventana): solo si su patrón lo encendió y su cuenta está
              vinculada a su ficha. "Cambiar" lleva a Notificaciones. */}
          <TarjetaRecordatorioChecador r={recordatorio} vinculada={fichaEstado==="ok"} onCambiar={()=>setPantalla("notificaciones")} NV={NV} fontSans={fontSans}/>

          {/* Registro de hoy — línea de tiempo vertical */}
          <div style={{marginTop:16, paddingTop:14, borderTop:`1px solid ${NV.lineSoft}`}}>
            <div style={{fontSize:11, fontWeight:700, color:NV.inkMut, textTransform:"uppercase" as const, letterSpacing:"0.4px", marginBottom:12}}>Registro de hoy</div>
            {(()=>{
              // LO DE HOY, COMO QUEDÓ DESPUÉS DE LAS CORRECCIONES DE SU PATRÓN (la vista
              // efectiva): un registro anulado sigue a la vista, atenuado y anotado; uno
              // agregado por el patrón lo dice; un cambio de tipo dice cómo se registró.
              const deHoy = (vistaMia.registros||[]).filter((r:any)=> Number.isFinite(r.ms) && fechaLocal(new Date(r.ms))===hoyLocal);
              if (!deHoy.length) return <div style={{fontSize:12, color:NV.inkMut}}>Aún no registras movimientos hoy.</div>;
              return (
              <div style={{position:"relative" as const, paddingLeft:20}}>
                <div style={{position:"absolute" as const, left:5, top:5, bottom:5, width:2, background:NV.lineSoft}}/>
                {deHoy.map((r:any, i:number, arr:any[])=>{
                  const c:any = r.checada || {};
                  const col = colorChecada(r.tipo);
                  const hora = new Date(r.ms).toLocaleTimeString("es-MX",{hour:"2-digit",minute:"2-digit"});
                  return (
                    <div key={r.id} data-registro={r.origen} style={{position:"relative" as const, marginBottom:i<arr.length-1?14:0, opacity:r.cuenta?1:0.55}}>
                      <span style={{position:"absolute" as const, left:-20, top:3, width:12, height:12, borderRadius:"50%", background:col, boxShadow:`0 0 0 3px ${NV.panel}, 0 0 0 4px ${col}`}}/>
                      <div style={{display:"flex", alignItems:"center", gap:8, flexWrap:"wrap" as const}}>
                        <span style={{fontSize:12.5, fontWeight:700, color:col}}>{labelChecada(r.tipo)}</span>
                        <span style={{fontSize:12.5, fontWeight:600, color:NV.ink}}>{hora}</span>
                        <span style={{fontSize:10, fontWeight:700, color:NV.inkMut, textTransform:"uppercase" as const, letterSpacing:"0.3px"}}>Hoy</span>
                        {r.origen==="agregado" && <span style={{fontSize:10.5, fontWeight:700, color:NV.gold}}>Agregado por el patrón</span>}
                        {r.origen==="original" && !r.cuenta && <span style={{fontSize:10.5, fontWeight:700, color:NV.inkMut}}>Anulado</span>}
                        {c.ubicacionDisponible===false && <span style={{fontSize:10.5, color:NV.inkMut}}>sin ubic.</span>}
                      </div>
                      {anotacionesDeRegistro(r).map((txt:string, k:number)=> <div key={k} style={{fontSize:11.5, color:NV.inkSoft, marginTop:3, lineHeight:1.45}}>{txt}</div>)}
                      {c.comentario && (
                        <div style={{fontSize:11.5, color:NV.inkSoft, marginTop:3, lineHeight:1.45, display:"flex", gap:5, alignItems:"flex-start"}}>
                          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" style={{flexShrink:0, marginTop:1, color:NV.inkMut}}><path d="M4 5.5A1.5 1.5 0 015.5 4h13A1.5 1.5 0 0120 5.5v8a1.5 1.5 0 01-1.5 1.5H9.5L5.5 19v-3.5A1.5 1.5 0 014 13.5z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round"/></svg>
                          <span style={{fontStyle:"italic" as const}}>{c.comentario}</span>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
              );
            })()}
          </div>
          {/* LAS CORRECCIONES DE SU PATRÓN A SUS REGISTROS, con "No conforme" (fase 2b). */}
          <CorreccionesDelTrabajador vista={vistaMia} correoSesion={user?.email || ""} onCambio={cargarCorrecciones} NV={NV} fontSans={fontSans}/>
        </div>
        )}

        {/* ════ FUNCIÓN: FLOTILLA ════ */}
        {pantalla==="flotilla" && (<>
        <div {...ZONA_DE_CAPTURA} style={{background:NV.panel, border:`1px solid ${NV.line}`, borderRadius:INI.radio, padding:isMobile?"13px 14px":"16px 18px", borderLeft:`3px solid ${NV.gold}`, marginBottom:14, boxShadow:NV.sombra}}>
          <div style={{fontSize:15, fontWeight:700, color:NV.gold, marginBottom:8, fontFamily:fontSerif}}>Flotilla</div>
          {/* La lista de unidades solo hace falta para SALIR. Con un viaje ya
              abierto la unidad se hereda de la salida, así que ni una falla de
              conexión ni un catálogo vacío pueden dejar a alguien sin poder
              cerrar su viaje desde la carretera. */}
          {vehiculosError && !viajeAbierto ? (
            // No solo se queda sin lista: sin unidades NO puede registrar una
            // salida. Decirlo evita que crea que su patrón no tiene unidades.
            <div style={{background:"rgba(220,38,38,0.10)", border:`1px solid rgba(220,38,38,0.35)`, borderRadius:14, padding:"13px 14px"}}>
              <div style={{fontSize:12.5, fontWeight:700, color:"#FCA5A5"}}>No pudimos cargar las unidades</div>
              <div style={{fontSize:12, color:NV.inkSoft, marginTop:4, lineHeight:1.5}}>
                Falló la conexión al traer los vehículos de tu empresa, así que <b>por ahora no puedes registrar una salida</b>.
                No significa que tu patrón no tenga unidades. Revisa tu conexión y vuelve a entrar; si sigue igual, avísale.
              </div>
            </div>
          ) : vehiculosPatron.length===0 && !viajeAbierto ? (
            <div style={{fontSize:12, color:NV.inkMut}}>No hay vehículos disponibles. Pídele a tu patrón que registre vehículos en Flotilla.</div>
          ) : (
            <>
              {/* La pantalla NO ofrece un menú de tipos: calcula el estado del
                  viaje y muestra el paso que toca. Sin viaje abierto solo se
                  puede salir; con viaje abierto solo se puede llegar o regresar,
                  y la unidad ya no se vuelve a preguntar. */}
              {misMovsCargando ? (
                <div style={{fontSize:12.5, color:NV.inkMut, padding:"14px 0"}}>Revisando si traes un viaje abierto…</div>
              ) : (<>

                {misMovsError && (
                  // No poder leer los movimientos propios no es un detalle: sin
                  // eso no se sabe si trae un viaje abierto. Se dice, y se deja
                  // registrar una salida de todos modos — quedarse sin poder
                  // registrar en carretera es peor.
                  <div style={{background:"rgba(220,38,38,0.10)", border:"1px solid rgba(220,38,38,0.35)", borderRadius:12, padding:"11px 13px", marginBottom:12}}>
                    <div style={{fontSize:12.5, fontWeight:700, color:"#FCA5A5"}}>No pudimos revisar tus viajes</div>
                    <div style={{fontSize:12, color:NV.inkSoft, marginTop:3, lineHeight:1.5}}>
                      Falló la conexión, así que no sabemos si traes un viaje abierto. Puedes registrar una salida,
                      pero si ya andabas afuera avísale a tu patrón para que lo revise.
                    </div>
                  </div>
                )}

                {/* LO QUE TRAES. Es lo primero que se lee: unidad, hora de salida
                    y cuántas paradas lleva. Sin paradas, ese dato no se escribe:
                    "0 paradas" ocupa el mismo espacio y no dice nada. */}
                {viajeAbierto && (
                  <div style={{background:"rgba(226,184,74,0.10)", border:"1px solid rgba(226,184,74,0.42)", borderRadius:12, padding:"12px 13px", marginBottom:12}}>
                    <div style={{fontSize:10.5, fontWeight:800, color:"#E2B84A", letterSpacing:"0.6px", marginBottom:3}}>VIAJE EN CURSO</div>
                    <div style={{fontSize:14, fontWeight:700, color:NV.ink, lineHeight:1.45}}>
                      {`Traes ${viajeAbierto.salida.placa || "tu unidad"}`}
                      {viajeAbierto.msSalida ? ` · saliste ${new Date(viajeAbierto.msSalida).toLocaleTimeString("es-MX",{hour:"2-digit",minute:"2-digit"})}` : ""}
                      {viajeAbierto.paradas > 0 ? ` · ${viajeAbierto.paradas} ${viajeAbierto.paradas===1?"parada":"paradas"}` : ""}
                    </div>
                    {viajeAbierto.salida.destino && (
                      <div style={{fontSize:12, color:NV.inkSoft, marginTop:3}}>Salida hacia {viajeAbierto.salida.destino}</div>
                    )}
                  </div>
                )}

                {!flotaPaso ? (
                  // ACCIONES. Un botón cuando no hay viaje, dos cuando lo hay.
                  viajeAbierto ? (
                    <div style={{display:"flex", flexDirection:"column" as const, gap:9}}>
                      <button onClick={()=>{ setFlotaMsg(null); setFlotaPaso("llegada"); }}
                        style={{width:"100%", boxSizing:"border-box" as const, background:"transparent", border:`1px solid ${NV.gold}`, color:NV.gold,
                          borderRadius:12, padding:"14px 12px", cursor:"pointer", fontSize:14.5, fontWeight:700, fontFamily:fontSans}}>
                        Llegué a un destino
                      </button>
                      <button onClick={()=>{ setFlotaMsg(null); setFlotaPaso("regreso"); }}
                        style={{width:"100%", boxSizing:"border-box" as const, background:NV.gold, border:"none", color:"#0B1829",
                          borderRadius:12, padding:"14px 12px", cursor:"pointer", fontSize:14.5, fontWeight:700, fontFamily:fontSans}}>
                        Regresé
                      </button>
                      {/* LA SALIDA DEL VIAJE QUE NUNCA SE CIERRA. Si alguien olvida
                          registrar el regreso, sin esto su pantalla le pide llegadas
                          para siempre y no puede volver a salir, ni en otra unidad.
                          Va discreto porque es la excepción, no el camino normal. */}
                      <button onClick={()=>{ setFlotaMsg(null); setFlotaCierraViaje(viajeAbierto.salida.id||""); setFlotaPaso("salida"); }}
                        style={{width:"100%", boxSizing:"border-box" as const, background:"transparent", border:"none", color:NV.inkSoft,
                          borderRadius:12, padding:"10px 12px", cursor:"pointer", fontSize:12.5, fontWeight:700, fontFamily:fontSans,
                          textDecoration:"underline", textUnderlineOffset:"3px"}}>
                        ¿Saliste en otra unidad?
                      </button>
                    </div>
                  ) : (
                    <button onClick={()=>{ setFlotaMsg(null); setFlotaPaso("salida"); }}
                      style={{width:"100%", boxSizing:"border-box" as const, background:NV.gold, border:"none", color:"#0B1829",
                        borderRadius:12, padding:"14px 12px", cursor:"pointer", fontSize:14.5, fontWeight:700, fontFamily:fontSans}}>
                      Registrar salida
                    </button>
                  )
                ) : (<>

                  {/* UNIDAD: solo en la salida. En llegada y regreso se hereda de
                      la salida abierta —con su vehiculoId— para que el viaje
                      entero quede ligado a la misma unidad. */}
                  {flotaPaso === "salida" && flotaCierraViaje && (
                    <div style={{background:"rgba(220,38,38,0.10)", border:"1px solid rgba(220,38,38,0.35)", borderRadius:12, padding:"11px 13px", marginBottom:12}}>
                      <div style={{fontSize:12.5, fontWeight:700, color:"#FCA5A5"}}>El viaje anterior queda sin regreso</div>
                      <div style={{fontSize:12, color:NV.inkSoft, marginTop:3, lineHeight:1.5}}>
                        Al registrar esta salida, tu viaje en {viajeAbierto?.salida?.placa || "la otra unidad"} se marcará
                        {" "}<b>sin regreso registrado</b>. No se inventa una hora de regreso: queda constancia de que saliste en otra unidad.
                      </div>
                    </div>
                  )}
                  {flotaPaso === "salida" && (<>
                    <label style={labelNV}>¿Con qué unidad sales? *</label>
                    <select value={vehiculoFlota} onChange={e=>setVehiculoFlota(e.target.value)}
                      style={{...inputNV, marginBottom:12}}>
                      <option value="" style={{color:"#0B1829"}}>Selecciona un vehículo…</option>
                      {vehiculosPatron.map((v:any)=>(<option key={v.id} value={v.id} style={{color:"#0B1829"}}>{v.placa}{(v.marca||v.modelo)?` · ${[v.marca,v.modelo].filter(Boolean).join(" ")}`:""}</option>))}
                    </select>
                  </>)}

                  {/* DESTINO: a dónde va (salida) o a dónde llegó (parada). */}
                  {flotaPaso !== "regreso" && (<>
                    <label style={labelNV}>{flotaPaso==="salida" ? "Destino (opcional)" : "¿A dónde llegaste? (opcional)"}</label>
                    <input type="text" value={flotaDestino} onChange={e=>setFlotaDestino(e.target.value)}
                      placeholder={flotaPaso==="salida" ? "¿A dónde vas?" : "Nombre del cliente o lugar"}
                      style={{...inputNV, marginBottom:12}} />
                  </>)}

                  {/* KILOMETRAJE: solo en salida y regreso, que es donde sirve
                      para sacar la distancia del viaje. En una parada no se pide
                      ni se menciona. Es opcional de verdad. */}
                  {flotaPaso !== "llegada" && (<>
                    <label style={labelNV}>{flotaPaso==="salida"?"Kilometraje inicial (opcional)":"Kilometraje final (opcional)"}</label>
                    <input type="number" min="0" value={flotaKm} onChange={e=>setFlotaKm(e.target.value)} placeholder="Ej. 84200"
                      style={{...inputNV, marginBottom: 12}} />
                    {/* LA LECTURA QUE NO SE SOSTIENE: se pregunta, NUNCA se bloquea.
                        Un registro no se pierde por un número raro, y quien captura
                        puede tener razón. Misma regla que el guardián del reporte
                        —saltoKmSospechoso—, para que el formulario y el PDF no
                        puedan opinar distinto del mismo dedazo. */}
                    {(()=>{
                      if (!flotaKm.trim()) return null;
                      const n = Number(flotaKm);
                      if (!Number.isFinite(n)) return null;
                      const vehId = flotaPaso==="salida" ? vehiculoFlota : (viajeAbierto?.salida?.vehiculoId || "");
                      const placaRef = flotaPaso==="salida"
                        ? (vehiculosPatron.find((v:any)=>v.id===vehiculoFlota)?.placa || "")
                        : (viajeAbierto?.salida?.placa || "");
                      const ultimo = ultimoKmDeUnidad(vehId, placaRef);
                      if (!ultimo) return null;
                      const horas = ultimo.ms ? (Date.now() - ultimo.ms) / 3600000 : 0;
                      const malo = saltoKmSospechoso(ultimo.km, n, horas);
                      // Sin fecha de la lectura anterior no se puede juzgar el TAMAÑO
                      // del salto, solo que retroceda. Callar es mejor que inventar un
                      // techo sobre un tiempo que no se conoce.
                      if (!malo || (malo.motivo === "excesivo" && !ultimo.ms)) return null;
                      const texto = malo.motivo === "retrocede"
                        ? `El kilometraje es menor al último registrado (${ultimo.km.toLocaleString("es-MX")} km), ¿es correcto?`
                        : `Son ${malo.km.toLocaleString("es-MX")} km desde la última lectura (${ultimo.km.toLocaleString("es-MX")} km), y en ese tiempo caben unos ${malo.techo.toLocaleString("es-MX")}. ¿Le falta o le sobra un dígito?`;
                      return (
                        <div style={{marginTop:-4, marginBottom:12, fontSize:11.5, lineHeight:1.5, color:"#E2B84A",
                          background:"rgba(184,147,42,0.14)", border:"1px solid rgba(184,147,42,0.42)", borderRadius:9, padding:"8px 10px"}}>
                          {texto} Puedes guardarlo así si estás seguro.
                        </div>
                      );
                    })()}
                  </>)}

                  {/* FOTOS, POR DOS PUERTAS SEPARADAS.
                      Aquí había un solo botón sin `capture`, con la teoría de que el
                      teléfono preguntaría "cámara o galería". No lo hace: Android y
                      iOS abren el selector de fotos y ya, y para tomar una hay que
                      salirse de la app. Un movimiento de flotilla se registra al pie
                      de la unidad, así que la foto casi siempre NO existe todavía.
                      Se separan en dos botones porque son dos intenciones distintas:
                      "voy a tomarla ahora" y "ya la tengo". La de galería conserva
                      `multiple` —varias fotos de una vez—; la cámara toma de una en
                      una, que es como funciona una cámara. Las dos llaman a la misma
                      `agregarFotosFlota`, que ya recorta al tope. */}
                  <label style={labelNV}>Fotos (opcional · hasta {MAX_FOTOS_MOV})</label>
                  {(()=>{
                    const lleno = flotaFotos.length>=MAX_FOTOS_MOV;
                    const estiloFoto:any = {display:"inline-flex", alignItems:"center", gap:8, cursor: lleno ? "not-allowed" : "pointer",
                      fontSize:13, fontWeight:700, color: lleno ? NV.inkMut : NV.gold,
                      background:NV.iconBg, border:`1px dashed ${NV.iconBd}`, borderRadius:10, padding:"10px 14px"};
                    if (lleno) return (
                      <div style={{marginBottom: flotaFotos.length>0 ? 10 : 12}}>
                        <span style={estiloFoto}>{`Ya tienes ${MAX_FOTOS_MOV} fotos`}</span>
                      </div>
                    );
                    return (
                      <div style={{display:"flex", gap:8, flexWrap:"wrap" as const, marginBottom: flotaFotos.length>0 ? 10 : 12}}>
                        <label style={estiloFoto}>
                          📷 Tomar foto
                          <input type="file" accept="image/*" capture="environment" style={{display:"none"}}
                            onChange={e=>{ agregarFotosFlota(e.target.files); e.currentTarget.value=""; }} />
                        </label>
                        <label style={estiloFoto}>
                          📎 Elegir de la galería
                          <input type="file" accept="image/*" multiple style={{display:"none"}}
                            onChange={e=>{ agregarFotosFlota(e.target.files); e.currentTarget.value=""; }} />
                        </label>
                      </div>
                    );
                  })()}
                  {flotaFotos.length>0 && (
                    <div style={{display:"flex", flexWrap:"wrap" as const, gap:8, marginBottom:12}}>
                      {flotaFotos.map((f,i)=>(
                        <div key={i} style={{position:"relative" as const, width:64, height:64, borderRadius:8, overflow:"hidden", border:`1px solid ${NV.line}`}}>
                          <img src={f.preview} alt={`Foto ${i+1}`} style={{width:"100%", height:"100%", objectFit:"cover" as const, display:"block"}}/>
                          <button onClick={()=>quitarFotoFlota(i)} aria-label="Quitar foto"
                            style={{position:"absolute" as const, top:2, right:2, width:20, height:20, borderRadius:"50%", border:"none",
                              background:"rgba(11,24,41,0.82)", color:"#FCA5A5", cursor:"pointer", fontSize:13, lineHeight:1, fontWeight:800}}>×</button>
                        </div>
                      ))}
                    </div>
                  )}

                  {/* ─── VÍDEO ───────────────────────────────────────────────
                      UNO, corto, y solo aquí y en el accidente. Se elige ahora y se
                      sube al guardar, junto a las fotos. El peso se comprueba AL
                      ELEGIRLO: no se puede comprimir vídeo en el navegador, así que
                      el límite es el único control, y enterarse de que no cabe
                      después de llenar el formulario es la peor forma de enterarse. */}
                  <label style={labelNV}>Video (opcional · uno, hasta unos {SEGUNDOS_VIDEO} segundos)</label>
                  {flotaVideo ? (
                    <div style={{display:"flex", alignItems:"center", gap:10, background:NV.iconBg, border:`1px solid ${NV.iconBd}`,
                      borderRadius:10, padding:"9px 12px", marginBottom:12}}>
                      <span style={{fontSize:16}}>🎬</span>
                      <span style={{flex:1, minWidth:0, fontSize:12.5, color:NV.ink, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" as const}}>{flotaVideo.name}</span>
                      <button onClick={()=>setFlotaVideo(null)} aria-label="Quitar video"
                        style={{background:"transparent", border:"none", color:NV.inkMut, cursor:"pointer", fontSize:16, lineHeight:1, padding:2}}>×</button>
                    </div>
                  ) : (
                    (()=>{
                      // La misma comprobación para las dos puertas: se escribe una
                      // vez y las dos la usan, para que no puedan discrepar.
                      const tomarVideo = (e:any) => {
                        const v = e.target.files && e.target.files[0];
                        e.currentTarget.value = "";
                        if (!v) return;
                        const malo = motivoRechazo(v);
                        if (malo || !esVideo(v)) { setFlotaMsg({tipo:"info", texto:"No se agregó el video: " + (malo || "ese archivo no es un video") }); return; }
                        setFlotaVideo(v); setFlotaMsg(null);
                      };
                      const estiloVid:any = {display:"inline-flex", alignItems:"center", gap:8, cursor:"pointer", fontSize:13,
                        fontWeight:700, color:NV.gold, background:NV.iconBg, border:`1px dashed ${NV.iconBd}`, borderRadius:10, padding:"10px 14px"};
                      return (
                        <div style={{display:"flex", gap:8, flexWrap:"wrap" as const, marginBottom:12}}>
                          {/* GRABAR: abre la cámara en modo vídeo. Ver `ACEPTA_VIDEO_CAMARA`. */}
                          <label style={estiloVid}>
                            🎥 Grabar video
                            <input type="file" accept={ACEPTA_VIDEO_CAMARA} capture="environment" style={{display:"none"}}
                              onChange={tomarVideo} />
                          </label>
                          {/* ELEGIR: uno que ya está en el teléfono. */}
                          <label style={estiloVid}>
                            📎 Elegir un video
                            <input type="file" accept={ACEPTA_VIDEO} style={{display:"none"}}
                              onChange={tomarVideo} />
                          </label>
                        </div>
                      );
                    })()
                  )}

                  {/* EL PROGRESO MIENTRAS SE GUARDA. Antes solo decía "Guardando…",
                      y en carretera eso puede durar minutos sin que nadie sepa si
                      avanza o si se colgó. */}
                  {flotaSubiendo && (
                    <div style={{fontSize:12, color:NV.gold, marginBottom:12}}>
                      {flotaSubiendo.i === 0
                        ? `Subiendo video… ${flotaSubiendo.pct}%`
                        : `Subiendo foto ${flotaSubiendo.i} de ${flotaSubiendo.total}… ${flotaSubiendo.pct}%`}
                      <div style={{marginTop:4, height:4, background:"rgba(255,255,255,0.12)", borderRadius:2}}>
                        <div style={{height:"100%", width:`${flotaSubiendo.pct}%`, background:NV.gold, borderRadius:2, transition:"width 0.3s"}}/>
                      </div>
                    </div>
                  )}

                  <label style={labelNV}>Observaciones (opcional)</label>
                  <textarea value={flotaObs} onChange={e=>setFlotaObs(e.target.value)} rows={2} placeholder="Notas sobre el vehículo o el viaje…"
                    style={{...inputNV, resize:"vertical" as const, marginBottom:12}} />

                  {/* Estado del vehículo: se conserva en el regreso porque es lo
                      que el patrón lee para saber si la unidad volvió bien. */}
                  {flotaPaso === "regreso" && (
                    <div style={{marginBottom:12}}>
                      <label style={labelNV}>Estado del vehículo</label>
                      <div style={{display:"flex", gap:6}}>
                        {([["normal","Normal","#34D399"],["revision","Revisión","#E2B84A"],["incidente","Incidente","#FCA5A5"]] as const).map(([v,l,col])=>{
                          const activo = flotaEstado===v;
                          return <button key={v} type="button" onClick={()=>setFlotaEstado(v)}
                            style={{flex:1, padding:"9px 6px", borderRadius:9, border:`1px solid ${activo?col:NV.line}`, cursor:"pointer", fontSize:12.5, fontWeight:700, fontFamily:fontSans,
                              background: activo?`${col}22`:"transparent", color: activo?col:NV.inkSoft}}>{l}</button>;
                        })}
                      </div>
                    </div>
                  )}

                  <button onClick={()=>registrarFlota(flotaPaso)} disabled={!!registrandoFlota || (flotaPaso==="salida" && !vehiculoFlota)}
                    style={{width:"100%", boxSizing:"border-box" as const, borderRadius:12, padding:"14px 12px", border:"none",
                      background:(!!registrandoFlota || (flotaPaso==="salida" && !vehiculoFlota))?"rgba(255,255,255,0.08)":NV.gold,
                      color:(!!registrandoFlota || (flotaPaso==="salida" && !vehiculoFlota))?NV.inkMut:"#0B1829",
                      cursor:(!!registrandoFlota || (flotaPaso==="salida" && !vehiculoFlota))?"default":"pointer", fontSize:14.5, fontWeight:700, fontFamily:fontSans}}>
                    {registrandoFlota
                      ? (flotaFotos.length ? "Subiendo y registrando…" : "Registrando…")
                      : flotaPaso==="salida" ? "Registrar salida" : flotaPaso==="llegada" ? "Registrar llegada" : "Registrar regreso"}
                  </button>
                  <button onClick={limpiarFormFlota} disabled={!!registrandoFlota}
                    style={{width:"100%", boxSizing:"border-box" as const, background:"transparent", border:"none", color:NV.inkSoft,
                      borderRadius:12, padding:"11px 12px", marginTop:4, cursor:"pointer", fontSize:13, fontWeight:700, fontFamily:fontSans}}>
                    Cancelar
                  </button>
                  <p style={{fontSize:11, color:NV.inkMut, margin:"6px 0 0", lineHeight:1.5}}>Se guarda con fecha, hora y tu ubicación (si la autorizas).</p>
                </>)}
              </>)}
            </>
          )}
          {flotaMsg && (
            <div style={{marginTop:10, fontSize:12, fontWeight:600, padding:"9px 12px", borderRadius:8,
              background: flotaMsg.tipo==="ok"?"rgba(16,185,129,0.14)":flotaMsg.tipo==="info"?"rgba(184,147,42,0.16)":"rgba(220,38,38,0.14)",
              border:`1px solid ${flotaMsg.tipo==="ok"?"rgba(16,185,129,0.38)":flotaMsg.tipo==="info"?"rgba(184,147,42,0.42)":"rgba(220,38,38,0.40)"}`,
              color: flotaMsg.tipo==="ok"?"#34D399":flotaMsg.tipo==="info"?"#E2B84A":"#FCA5A5"}}>{flotaMsg.texto}</div>
          )}
        </div>

        {/* Contacto directo con el PATRÓN (nunca AXIS). Si no hay número configurado,
            se muestra un aviso suave en lugar del botón. */}
        {waPatron ? (
          <button onClick={abrirWhatsAppPatron}
            style={{width:"100%", display:"flex", alignItems:"center", justifyContent:"center", gap:9, boxSizing:"border-box" as const,
              background:"rgba(37,211,102,0.12)", border:"1px solid rgba(37,211,102,0.45)", color:"#4ADE80",
              borderRadius:12, padding:isMobile?"13px 12px":"12px 16px", cursor:"pointer", fontSize:13.5, fontWeight:700, fontFamily:fontSans, marginBottom:12}}>
            <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor"><path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.9 9.9 0 004.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0012.04 2zm0 18.15h-.01a8.2 8.2 0 01-4.19-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.19 8.19 0 01-1.26-4.38c0-4.54 3.7-8.23 8.25-8.23 2.2 0 4.27.86 5.83 2.41a8.18 8.18 0 012.41 5.83c0 4.54-3.7 8.23-8.24 8.23zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.13-.16.24-.64.8-.79.97-.14.16-.29.18-.54.06-.25-.13-1.05-.39-1.99-1.23-.74-.66-1.24-1.47-1.38-1.72-.15-.25-.02-.38.11-.5.11-.11.25-.29.37-.43.12-.15.16-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.48-.4-.42-.56-.43h-.47c-.17 0-.43.06-.66.31-.23.25-.86.85-.86 2.07s.89 2.4 1.01 2.56c.12.17 1.75 2.67 4.23 3.74.59.26 1.05.41 1.41.52.59.19 1.13.16 1.56.1.48-.07 1.47-.6 1.68-1.18.21-.58.21-1.07.14-1.18-.06-.11-.22-.17-.47-.29z"/></svg>
            Contactar a mi patrón
          </button>
        ) : (
          <div style={{fontSize:11.5, color:NV.inkMut, background:NV.panel, border:`1px solid ${NV.line}`, borderRadius:12, padding:"11px 13px", marginBottom:12, lineHeight:1.5}}>
            Tu patrón no ha configurado su WhatsApp.
          </div>
        )}

        {/* Acceso rápido: si el incidente fue un ACCIDENTE, va directo a reportarlo. */}
        <button onClick={()=>abrirAccidente("flotilla")}
          style={{width:"100%", display:"flex", alignItems:"center", gap:10, boxSizing:"border-box" as const, textAlign:"left" as const,
            background:"rgba(220,38,38,0.10)", border:"1px solid rgba(252,165,165,0.40)", color:"#FCA5A5",
            borderRadius:12, padding:isMobile?"12px 13px":"12px 16px", cursor:"pointer", fontFamily:fontSans, marginBottom:14}}>
          <span style={{fontSize:18, flexShrink:0}}>🚨</span>
          <span style={{flex:1, minWidth:0}}>
            <span style={{display:"block", fontSize:13, fontWeight:800}}>¿Tuviste un accidente?</span>
            <span style={{display:"block", fontSize:11.5, color:"rgba(236,230,216,0.55)", marginTop:1}}>Repórtalo aquí para dejar constancia.</span>
          </span>
          <span style={{fontSize:16, flexShrink:0}}>›</span>
        </button>

        {/* Marco jurídico + consejos: MISMO contenido del link público de flotilla
            (componente InfoLegalConductor), colapsable para no estorbar el registro. */}
        <InfoLegalConductor gold={NV.gold} fontSerif={fontSerif} fontSans={fontSans} />
        </>)}

        {/* ════ FUNCIÓN: MIS ACTIVIDADES — conteo destacado + lista ════ */}
        {pantalla==="tareas" && (<>
        <div style={{display:"flex", alignItems:"center", gap:12, marginBottom:12, marginTop:4}}>
          <div style={{width:46, height:46, borderRadius:13, flexShrink:0, display:"flex", alignItems:"center", justifyContent:"center",
            background: pendientes>0?"rgba(184,147,42,0.18)":"rgba(16,185,129,0.16)", border:`1px solid ${pendientes>0?"rgba(184,147,42,0.40)":"rgba(16,185,129,0.40)"}`}}>
            <span style={{fontFamily:fontSerif, fontSize:20, fontWeight:800, color:pendientes>0?"#E2B84A":"#34D399"}}>{cargando?"·":pendientes}</span>
          </div>
          <div style={{minWidth:0}}>
            <h1 style={{fontFamily:fontSerif, fontSize:isMobile?19:24, fontWeight:700, color:NV.gold, margin:0, lineHeight:1.1}}>Mis actividades</h1>
            <p style={{fontSize:12.5, color:NV.inkSoft, margin:"2px 0 0"}}>
              {cargando ? "Cargando…" : pendientes>0 ? `${pendientes} pendiente${pendientes===1?"":"s"} por hacer` : "Sin pendientes ✓"}
            </p>
          </div>
        </div>

        {!cargando && !errorMsg && tareas.length>0 && (
          <div style={{marginBottom:12}}>
            <button onClick={exportarTareasICS}
              style={{display:"inline-flex", alignItems:"center", justifyContent:"center", gap:8, width:"100%", background:NV.iconBg, border:`1px solid ${NV.iconBd}`, color:NV.gold, borderRadius:12, padding:"12px 14px", cursor:"pointer", fontSize:13.5, fontWeight:700, fontFamily:fontSans}}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><rect x="3.5" y="5" width="17" height="16" rx="2.5" stroke="currentColor" strokeWidth="1.7"/><path d="M3.5 9.5h17M8 3.2v3.2M16 3.2v3.2" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/><path d="M12 12.5v4M10 14.5h4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/></svg>
              Exportar a mi calendario
            </button>
            {/* Nota de ayuda (integrada, no es una advertencia) */}
            <div style={{display:"flex", alignItems:"flex-start", gap:8, marginTop:8, background:NV.iconBg, border:`1px solid ${NV.lineSoft}`, borderRadius:10, padding:"9px 11px"}}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" style={{flexShrink:0, marginTop:1, color:NV.gold}}><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.7"/><path d="M12 11v5M12 8h.01" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>
              <span style={{fontSize:11, color:NV.inkSoft, lineHeight:1.55}}>Se descargará un archivo. Ábrelo con tu app de calendario (Google Calendar, Apple Calendar, etc.) y confirma para guardar tus fechas. Aparecerán con recordatorio.</span>
            </div>
            {icsMsg && <div style={{marginTop:8, fontSize:12, fontWeight:600, textAlign:"center" as const, color: icsMsg.includes("exportaron")?"#34D399":"#E2B84A"}}>{icsMsg}</div>}
          </div>
        )}

        {errorMsg && (
          <div style={{background:"rgba(220,38,38,0.14)", border:"1px solid rgba(220,38,38,0.40)", borderRadius:12, padding:"14px 16px", marginBottom:12, fontSize:13, color:"#FCA5A5"}}>
            {errorMsg}
          </div>
        )}

        <div style={{display:"flex", flexDirection:"column" as const, gap:9}}>
          {tareas.map((t:any) => {
            const estado = estadoDe(t);
            const comp = t.confirmadaPorPatron;
            const borderColor = comp ? "#34D399" : t.marcadaPorTrabajador ? "#E2B84A" : NV.gold;
            return (
              <div key={t.id} style={{background:NV.panel, border:`1px solid ${NV.line}`, borderRadius:INI.radio, padding:"13px 15px", borderLeft:`3px solid ${borderColor}`, opacity:comp?0.7:1, boxShadow:NV.sombra}}>
                <div style={{display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:10, flexWrap:"wrap" as const}}>
                  <div style={{flex:1, minWidth:160}}>
                    <div style={{display:"flex", alignItems:"center", gap:8, flexWrap:"wrap" as const, marginBottom:3}}>
                      <span style={{fontWeight:700, fontSize:14, color:NV.ink}}>{t.titulo}</span>
                      {badgeEstado(estado)}
                    </div>
                    {t.descripcion && (<div style={{fontSize:12, color:NV.inkSoft, marginBottom:3, whiteSpace:"pre-wrap" as const}}>{t.descripcion}</div>)}
                    {(t.fechaLimite||t.horario) && (<div style={{fontSize:11, color:NV.inkMut}}>{t.fechaLimite ? `Límite: ${t.fechaLimite}${t.horario?` · ${t.horario}`:""}` : t.horario}</div>)}
                  </div>
                  {!t.marcadaPorTrabajador && !t.confirmadaPorPatron && (
                    <button onClick={()=>marcarHecha(t)} disabled={marcandoId===t.id}
                      style={{fontSize:12.5, fontWeight:700, padding:isMobile?"9px 14px":"7px 14px", borderRadius:9, cursor:marcandoId===t.id?"wait":"pointer", fontFamily:fontSans, border:"none", background:NV.gold, color:"#0B1829", whiteSpace:"nowrap" as const, flexShrink:0}}>
                      {marcandoId===t.id ? "Guardando…" : "Marcar hecha"}
                    </button>
                  )}
                  {t.marcadaPorTrabajador && !t.confirmadaPorPatron && (
                    <span style={{fontSize:11, color:"#E2B84A", fontWeight:600, alignSelf:"center", whiteSpace:"nowrap" as const}}>Esperando confirmación</span>
                  )}
                </div>
              </div>
            );
          })}
          {!cargando && !errorMsg && tareas.length===0 && (<div style={{fontSize:13, color:NV.inkSoft, background:NV.panel, border:`1px solid ${NV.line}`, borderRadius:INI.radio, padding:"20px 22px", boxShadow:NV.sombra}}>Aún no tienes actividades asignadas.</div>)}
        </div>
        </>)}

        {/* ════ FUNCIÓN: REGISTRAR ACCIDENTE ════ */}
        {/* ════ MIS ACCIDENTES ════
            Los suyos de los últimos 7 días, del más reciente al más antiguo. Tocar
            uno abre la MISMA pantalla posterior, con lo guardado cargado. Pasados
            los 7 días deja de aparecer: la regla ya no le dejaría guardar nada. */}
        {pantalla==="misAccidentes" && (
          <div>
            <p style={{fontSize:12.5, color:NV.inkSoft, margin:"0 0 12px", lineHeight:1.5}}>Los accidentes que registraste en los últimos 7 días. Toca uno para añadir fotos, testigos o lo que falte.</p>
            {misAccEstado === "error" && (
              <div style={{background:"rgba(220,38,38,0.10)", border:"1px solid rgba(220,38,38,0.35)", borderRadius:12, padding:"12px 14px", marginBottom:12, fontSize:12.5, color:"#FCA5A5", lineHeight:1.5}}>
                No pudimos cargar tus accidentes. Revisa tu conexión y vuelve a entrar.
              </div>
            )}
            {!!misAccAvisoTxt && (
              <div style={{background:"rgba(220,38,38,0.10)", border:"1px solid rgba(220,38,38,0.35)", borderRadius:12, padding:"12px 14px", marginBottom:12, fontSize:12.5, color:"#FCA5A5", lineHeight:1.5}}>{misAccAvisoTxt}</div>
            )}
            {misAccEstado === "cargando" && <div style={{fontSize:12.5, color:NV.inkMut, padding:"8px 2px"}}>Cargando…</div>}
            {misAccEstado === "ok" && misAccidentesVisibles.length === 0 && (
              <div style={{background:NV.panel, border:`1px solid ${NV.line}`, borderRadius:14, padding:"18px 16px", fontSize:13, color:NV.inkSoft, textAlign:"center" as const}}>
                No tienes accidentes de los últimos 7 días.
              </div>
            )}
            <div style={{display:"flex", flexDirection:"column" as const, gap:10}}>
              {misAccidentesVisibles.map((a:any)=>{
                const unidad = String(a.vehiculo || a.placa || "").trim();
                const vence = venceCompletarAccidenteMs(a);
                return (
                  <button key={a.id} onClick={()=>abrirAccidenteGuardado(a)}
                    style={{display:"flex", alignItems:"center", gap:12, width:"100%", textAlign:"left" as const, fontFamily:fontSans, cursor:"pointer",
                      background:NV.panel, border:`1px solid ${NV.line}`, borderLeft:"3px solid #FCA5A5", borderRadius:14, padding:"13px 14px", boxShadow:NV.sombra, minHeight:64}}>
                    <div style={{width:38, height:38, borderRadius:10, flexShrink:0, display:"flex", alignItems:"center", justifyContent:"center", background:"rgba(220,38,38,0.14)", border:"1px solid rgba(252,165,165,0.40)", color:"#FCA5A5"}}>{icoAlerta}</div>
                    <div style={{flex:1, minWidth:0}}>
                      <div style={{fontSize:14, fontWeight:700, color:NV.ink, lineHeight:1.25}}>{resumenDeAccidente(a)}</div>
                      <div style={{fontSize:12, color:NV.inkSoft, marginTop:3}}>{[unidad || "Sin unidad", cuandoTexto(a.timestamp, true)].filter(Boolean).join(" · ")}</div>
                      {vence > 0 && <div style={{fontSize:11, color:NV.inkMut, marginTop:3}}>Puedes completarlo hasta el {cuandoTexto(vence, true)}</div>}
                      {/* LO QUE HIZO EL PATRÓN: atendido o cancelado. */}
                      {!!estadoAccidenteParaTrabajador(a) && <div style={{fontSize:11.5, fontWeight:700, color: estadoAtencionAccidente(a) === "cancelado" ? "#FCA5A5" : "#34D399", marginTop:4}}>{estadoAccidenteParaTrabajador(a)}</div>}
                    </div>
                    <span style={{fontSize:22, color:NV.inkMut, lineHeight:1}}>›</span>
                  </button>
                );
              })}
            </div>
          </div>
        )}

        {pantalla==="accidente" && (
        <div {...ZONA_DE_CAPTURA} style={{background:NV.panel, border:`1px solid ${NV.line}`, borderRadius:INI.radio, padding:isMobile?"14px 14px":"16px 18px", borderLeft:`3px solid ${NV.gold}`, marginBottom:14, boxShadow:NV.sombra}}>
          {accFase === "rapida" ? (<>
          {/* ═══ LA PANTALLA RÁPIDA ═══════════════════════════════════════════
              Sin un solo campo de texto, a propósito: en el momento del accidente
              no se escribe. Qué pasó, si hay lesionados y con qué unidad, y un
              botón. Lo demás, después. `prueba-accidente-rapido` se pone roja si
              aquí vuelve a aparecer un campo que haya que teclear. */}
          <div style={{fontSize:15, fontWeight:700, color:NV.gold, marginBottom:4, fontFamily:fontSerif}}>Registrar accidente</div>
          <p style={{fontSize:12, color:NV.inkSoft, margin:"0 0 14px", lineHeight:1.5}}>Tu patrón recibe el aviso en cuanto registres. Lo demás lo puedes añadir después.</p>

          {/* LA UNIDAD, COMO HECHO Y NO COMO PREGUNTA, si hay viaje abierto. Si no
              lo hay —o si se pulsa "Corregir"—, una rejilla de botones: nada de
              desplegables, que en un teléfono son dos toques y una lista que hay
              que leer. */}
          {accContexto?.vehiculoId && !accCorrigeVehiculo ? (<>
            <label style={labelNV}>Unidad</label>
            <div style={{display:"flex", alignItems:"center", gap:10, background:"rgba(184,147,42,0.10)", border:`1px solid rgba(184,147,42,0.32)`,
              borderRadius:12, padding:"11px 13px", marginBottom:16}}>
              <span style={{fontSize:17, flexShrink:0}}>🚚</span>
              <div style={{flex:1, minWidth:0}}>
                <div style={{fontSize:13.5, fontWeight:800, color:NV.gold}}>{accContexto.etiqueta || accContexto.placa || "Tu unidad"}</div>
                <div style={{fontSize:11.5, color:NV.inkMut, marginTop:2}}>Del viaje que traes abierto.</div>
              </div>
              <button type="button" onClick={()=>setAccCorrigeVehiculo(true)}
                style={{flexShrink:0, background:"none", border:"none", padding:0, cursor:"pointer", fontFamily:fontSans,
                  fontSize:11.5, fontWeight:700, color:NV.inkSoft, textDecoration:"underline"}}>
                Corregir
              </button>
            </div>
          </>) : (<>
            <label style={labelNV}>¿Con qué unidad?</label>
            <div style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap:8, marginBottom:16}}>
              {vehiculosPatron.map((v:any)=>{
                const on = !accSinVehiculo && accVehiculo === v.id;
                return (
                  <button key={v.id} type="button" onClick={()=>{ setAccVehiculo(v.id); setAccSinVehiculo(false); }}
                    style={{textAlign:"left" as const, padding:"10px 11px", borderRadius:11, cursor:"pointer", fontFamily:fontSans,
                      border:`1px solid ${on?NV.gold:NV.line}`, background:on?"rgba(184,147,42,0.18)":"transparent"}}>
                    <div style={{fontSize:13.5, fontWeight:800, color:on?NV.gold:NV.ink}}>{v.placa || "Sin placa"}</div>
                    {(v.marca||v.modelo) && <div style={{fontSize:11, color:NV.inkMut, marginTop:2}}>{[v.marca,v.modelo].filter(Boolean).join(" ")}</div>}
                  </button>
                );
              })}
              {/* "No fue con vehículo" ocupa la fila entera: no es una unidad más. */}
              <button type="button"
                onClick={()=>{
                  setAccSinVehiculo(true); setAccVehiculo("");
                  // Si lo elegido antes no puede pasar sin vehículo, se deshace:
                  // no se puede guardar "choque con otro vehículo" sin vehículo.
                  if (accTipo && !tiposAccidenteVisibles(false).some((t:any)=>t.clave===accTipo)) setAccTipo("");
                }}
                style={{gridColumn:"span 2", padding:"11px", borderRadius:11, cursor:"pointer", fontFamily:fontSans, fontSize:13, fontWeight:700,
                  border:`1px solid ${accSinVehiculo?NV.gold:NV.line}`, background:accSinVehiculo?"rgba(184,147,42,0.18)":"transparent",
                  color:accSinVehiculo?NV.gold:NV.inkSoft}}>
                No fue con vehículo
              </button>
            </div>
          </>)}

          {/* ¿QUÉ PASÓ? El hecho, nunca quién tuvo la culpa. La lista vive en
              src/logica/accidente.js y la comparte el servidor, que la escribe en
              el aviso. Sin vehículo, solo lo que puede pasar sin vehículo. */}
          <label style={labelNV}>¿Qué pasó?</label>
          <div style={{display:"flex", flexDirection:"column" as const, gap:7, marginBottom:16}}>
            {tiposAccidenteVisibles(!accSinVehiculo).map((t:any)=>{
              const on = accTipo === t.clave;
              return (
                <button key={t.clave} type="button" onClick={()=>setAccTipo(t.clave)}
                  style={{textAlign:"left" as const, padding:"12px 13px", borderRadius:11, cursor:"pointer", fontFamily:fontSans,
                    fontSize:13.5, fontWeight:700, border:`1px solid ${on?NV.gold:NV.line}`,
                    background:on?"rgba(184,147,42,0.18)":"transparent", color:on?NV.gold:NV.ink}}>
                  {t.rotulo}
                </button>
              );
            })}
          </div>

          {/* ¿HAY PERSONAS LESIONADAS? Tres respuestas y ninguna marcada de salida.
              Si el hecho ya lo dice —una lesión sin vehículo— no se pregunta: se
              dice lo que se va a guardar, que es distinto de callarlo. */}
          {tipoAccElegido?.hayLesionados ? (
            <div style={{fontSize:12, color:NV.inkSoft, background:"rgba(220,38,38,0.08)", border:"1px solid rgba(252,165,165,0.30)",
              borderRadius:10, padding:"9px 12px", marginBottom:16, lineHeight:1.5}}>
              Se registra como accidente con una persona lesionada.
            </div>
          ) : (<>
            <label style={labelNV}>¿Hay personas lesionadas?</label>
            <div style={{display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:8, marginBottom:16}}>
              {([[true,"Sí"],[false,"No"],[LESIONADOS_NO_SE,"No lo sé"]] as const).map(([v,l])=>{
                const on = accLesionados === v;
                return (
                  <button key={l} type="button" onClick={()=>setAccLesionados(v as any)}
                    style={{padding:"12px 6px", borderRadius:11, cursor:"pointer", fontFamily:fontSans, fontSize:13.5, fontWeight:800,
                      border:`1px solid ${on?NV.gold:NV.line}`, background:on?"rgba(184,147,42,0.18)":"transparent", color:on?NV.gold:NV.ink}}>
                    {l}
                  </button>
                );
              })}
            </div>
          </>)}

          {/* LA UBICACIÓN, COMO ESTADO Y NO COMO PREGUNTA. Se pidió sola al abrir. */}
          <div style={{fontSize:11.5, marginBottom:12, fontWeight:600,
            color: accGpsEstado==="ok" ? "#34D399" : accGpsEstado==="sin" ? NV.inkMut : NV.gold}}>
            {accGpsEstado==="tomando" ? "Tomando tu ubicación…"
              : accGpsEstado==="ok" ? "Ubicación tomada ✓"
              : "Sin ubicación: el accidente se registra igual."}
          </div>

          {(()=>{
            const falta = faltaParaRegistrar();
            const apagado = accGuardando || !!falta;
            return (<>
              <button onClick={registrarAccidente} disabled={apagado}
                style={{width:"100%", background:apagado?"rgba(255,255,255,0.08)":NV.gold, border:"none",
                  color:apagado?"rgba(236,230,216,0.42)":"#0B1829", borderRadius:12, padding:isMobile?"15px 10px":"14px 16px",
                  cursor:apagado?"not-allowed":"pointer", fontSize:isMobile?15:14, fontWeight:700, fontFamily:fontSans, minHeight:isMobile?54:48}}>
                {accGuardando ? "Registrando…" : "Registrar y avisar al patrón"}
              </button>
              {!!falta && !accGuardando && <p style={{fontSize:11, color:NV.inkMut, margin:"8px 0 0", lineHeight:1.5}}>{falta}</p>}
            </>);
          })()}
          {accMsg && (
            <div style={{marginTop:12, fontSize:12, fontWeight:600, padding:"9px 12px", borderRadius:8,
              background: accMsg.tipo==="ok"?"rgba(16,185,129,0.14)":accMsg.tipo==="info"?"rgba(184,147,42,0.16)":"rgba(220,38,38,0.14)",
              border:`1px solid ${accMsg.tipo==="ok"?"rgba(16,185,129,0.38)":accMsg.tipo==="info"?"rgba(184,147,42,0.42)":"rgba(220,38,38,0.40)"}`,
              color: accMsg.tipo==="ok"?"#34D399":accMsg.tipo==="info"?"#E2B84A":"#FCA5A5"}}>{accMsg.texto}</div>
          )}
          </>) : accCargando ? (
            <div style={{padding:"28px 6px", textAlign:"center" as const, fontSize:13, color:NV.inkSoft}}>
              Cargando…{accRegistro?.resumen ? <div style={{fontSize:12, color:NV.inkMut, marginTop:6}}>{accRegistro.resumen}</div> : null}
            </div>
          ) : (<>
          {/* ═══ LA PANTALLA POSTERIOR ════════════════════════════════════════
              El accidente ya está escrito y el aviso, enviado o en camino. Cada
              bloque es opcional y se guarda por su cuenta: si la persona cierra a
              la mitad, lo guardado se queda. El orden es el de lo que desaparece
              antes del lugar del accidente. */}
          <div style={{fontSize:15, fontWeight:700, color:NV.gold, marginBottom:accRegistro?.reabierto ? 4 : 8, fontFamily:fontSerif}}>Accidente registrado</div>
          {accRegistro?.reabierto && !!accRegistro.estadoPatron && (
            <div style={{fontSize:12, fontWeight:700, color: accRegistro.estadoPatron === "Cancelado por tu patrón" ? "#FCA5A5" : "#34D399", marginBottom:8}}>{accRegistro.estadoPatron}</div>
          )}
          {accRegistro?.reabierto && !!accRegistro.resumen && (
            <div style={{fontSize:12.5, color:NV.ink, marginBottom:8, lineHeight:1.45}}>{accRegistro.resumen}</div>
          )}
          {/* EL PLAZO, A LA VISTA. Si vence con la pantalla abierta, cada guardado
              lo dice también; esto avisa antes de que alguien escriba de más. */}
          {accRegistro?.venceMs ? (Date.now() >= accRegistro.venceMs ? (
            <div style={{marginBottom:10, fontSize:12.5, fontWeight:600, padding:"10px 12px", borderRadius:8, background:"rgba(220,38,38,0.14)", border:"1px solid rgba(220,38,38,0.40)", color:"#FCA5A5", lineHeight:1.5}}>
              Pasaron los 7 días para completar este accidente: ya no se puede guardar nada nuevo. Lo guardado se queda; si falta algo, avísale a tu patrón.
            </div>
          ) : accRegistro.reabierto ? (
            <div style={{fontSize:11.5, color:NV.inkMut, marginBottom:10}}>Puedes completarlo hasta el {cuandoTexto(accRegistro.venceMs, true)}.</div>
          ) : null) : null}
          {accMsg && (
            <div style={{marginBottom:10, fontSize:12.5, fontWeight:600, padding:"10px 12px", borderRadius:8,
              background: accMsg.tipo==="ok"?"rgba(16,185,129,0.14)":accMsg.tipo==="info"?"rgba(184,147,42,0.16)":"rgba(220,38,38,0.14)",
              border:`1px solid ${accMsg.tipo==="ok"?"rgba(16,185,129,0.38)":accMsg.tipo==="info"?"rgba(184,147,42,0.42)":"rgba(220,38,38,0.40)"}`,
              color: accMsg.tipo==="ok"?"#34D399":accMsg.tipo==="info"?"#E2B84A":"#FCA5A5"}}>{accMsg.texto}</div>
          )}
          {/* LA SALIDA, NO SOLO LA DISCULPA. Es el mismo WhatsApp del patrón que ya
              usa la pantalla de Flotilla, no uno nuevo. */}
          {accSinAviso && waPatron && (
            <button onClick={abrirWhatsAppPatron}
              style={{width:"100%", marginBottom:12, display:"flex", alignItems:"center", justifyContent:"center", gap:9, boxSizing:"border-box" as const,
                background:"rgba(37,211,102,0.12)", border:"1px solid rgba(37,211,102,0.45)", color:"#4ADE80",
                borderRadius:12, padding:isMobile?"13px 12px":"12px 16px", cursor:"pointer", fontSize:13.5, fontWeight:700, fontFamily:fontSans}}>
              <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor"><path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.9 9.9 0 004.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0012.04 2zm0 18.15h-.01a8.2 8.2 0 01-4.19-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.19 8.19 0 01-1.26-4.38c0-4.54 3.7-8.23 8.25-8.23 2.2 0 4.27.86 5.83 2.41a8.18 8.18 0 012.41 5.83c0 4.54-3.7 8.23-8.24 8.23zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.13-.16.24-.64.8-.79.97-.14.16-.29.18-.54.06-.25-.13-1.05-.39-1.99-1.23-.74-.66-1.24-1.47-1.38-1.72-.15-.25-.02-.38.11-.5.11-.11.25-.29.37-.43.12-.15.16-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.48-.4-.42-.56-.43h-.47c-.17 0-.43.06-.66.31-.23.25-.86.85-.86 2.07s.89 2.4 1.01 2.56c.12.17 1.75 2.67 4.23 3.74.59.26 1.05.41 1.41.52.59.19 1.13.16 1.56.1.48-.07 1.47-.6 1.68-1.18.21-.58.21-1.07.14-1.18-.06-.11-.22-.17-.47-.29z"/></svg>
              Contactar a mi patrón
            </button>
          )}
          <p style={{fontSize:12, color:NV.inkSoft, margin:"0 0 12px", lineHeight:1.5}}>Si puedes, añade lo que falta. Cada parte se guarda sola.</p>

          {/* "NO LO SÉ" SE PUEDE ACLARAR, Y SOLO ESO. Arriba del todo, porque es lo
              que decide si el patrón tiene que atender a alguien. Una vez
              contestado no se vuelve a cambiar desde aquí: firestore.rules solo
              deja cambiar lesionados si lo guardado era "No lo sé". */}
          {/* Y SI EN LA BASE YA ES SÍ O NO, SOLO LECTURA (4-oct): sin botones. Es lo
              que hay después de releer, también cuando la pantalla iba atrasada. */}
          {accRegistro && (accRegistro.lesionados === LESIONADOS_NO_SE || accRegistro.lesionados === true || accRegistro.lesionados === false || accBloqueEstado.lesionados) &&
            bloqueAcc("lesionados", accRegistro.lesionados === LESIONADOS_NO_SE ? "¿Ya sabes si hay personas lesionadas?" : "Personas lesionadas", (<>
              {accRegistro.lesionados === LESIONADOS_NO_SE ? (
                <div style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap:8}}>
                  {([[true,"Sí"],[false,"No"]] as const).map(([v,l])=>(
                    <button key={l} type="button" disabled={accBloqueGuardando==="lesionados"} onClick={()=>confirmarLesionadosAccidente(v)}
                      style={{padding:"12px 6px", borderRadius:11, cursor:"pointer", fontFamily:fontSans, fontSize:13.5, fontWeight:800,
                        border:`1px solid ${NV.line}`, background:"transparent", color:NV.ink}}>{l}</button>
                  ))}
                </div>
              ) : (
                <div style={{fontSize:12.5, color:NV.ink}}>
                  {accRegistro.lesionados === true ? "Anotado: hay personas lesionadas." : "Anotado: no hay personas lesionadas."}
                </div>
              )}
              {/* EL FALLO SE VE, también después de releer. Este bloque no tiene botón
                  "Guardar", y por eso `bloqueAcc` no pintaba su mensaje. */}
              {accBloqueEstado.lesionados?.tipo === "err" && (
                <div style={{marginTop:8, fontSize:11.5, fontWeight:600, color:"#FCA5A5", lineHeight:1.45}}>{accBloqueEstado.lesionados.texto}</div>
              )}
            </>))}

          {/* 1) SEGURO DE LA UNIDAD. El botón de llamar solo existe si el patrón
              capturó el teléfono de siniestros en el expediente de la unidad; sin
              él, no se inventa uno. */}
          {accRegistro && !accRegistro.sinVehiculo && bloqueAcc("seguro", "Seguro de la unidad", (<>
            {(()=>{
              const v:any = vehiculosPatron.find((x:any)=>x.id===accRegistro.vehiculoId);
              const tel = String(v?.telefonoSiniestros || "").trim();
              if (!tel) return null;
              return (
                <div style={{marginBottom:12}}>
                  <a href={"tel:" + tel.replace(/[^\d+]/g, "")}
                    style={{display:"flex", alignItems:"center", justifyContent:"center", gap:8, textDecoration:"none",
                      background:NV.gold, color:"#0B1829", borderRadius:11, padding:"12px", fontSize:13.5, fontWeight:800, fontFamily:fontSans}}>
                    📞 Llamar a la aseguradora{v?.aseguradora ? ` · ${v.aseguradora}` : ""}
                  </a>
                  {v?.numeroPoliza && <div style={{fontSize:11.5, color:NV.inkMut, marginTop:6}}>Póliza de la unidad: {v.numeroPoliza}</div>}
                </div>
              );
            })()}
            <label style={labelNV}>Número de reporte o siniestro</label>
            <input type="text" value={accNumSiniestro} onChange={e=>setAccNumSiniestro(e.target.value)}
              placeholder="El que te dé la aseguradora" style={{...inputNV}} />
          </>), ()=>guardarBloqueAccidente("seguro", accNumSiniestro.trim() ? {numeroSiniestro: accNumSiniestro.trim()} : {}))}

          {/* 2) FOTOS O VIDEO. Lo que ya existía, tal cual: la cámara, la galería, la
              compresión y el progreso por foto. Se guardan solas en cuanto suben;
              una vez enlazadas no se quitan desde aquí, porque son evidencia. */}
          {accRegistro && bloqueAcc("fotos", "Fotos o video", (<>
            <p style={{fontSize:11.5, color:NV.inkMut, margin:"0 0 10px", lineHeight:1.5}}>La escena, los vehículos y las placas.</p>
            {(()=>{
              const estiloFotoAcc:any = {display:"inline-flex", alignItems:"center", gap:8, cursor:accSubiendo?"wait":"pointer",
                fontSize:13, fontWeight:700, color:NV.gold, background:NV.iconBg,
                border:`1px dashed ${NV.iconBd}`, borderRadius:10, padding:"10px 14px"};
              const lleno = accFotos.length >= MAX_FOTOS_ACCIDENTE;
              if (accSubiendo) return (<div style={{marginBottom:10}}><span style={estiloFotoAcc}>Subiendo…</span></div>);
              if (lleno) return (<div style={{marginBottom:10}}><span style={{...estiloFotoAcc, opacity:0.6, cursor:"not-allowed"}}>Ya tienes {MAX_FOTOS_ACCIDENTE} fotos</span></div>);
              return (
                <div style={{display:"flex", gap:8, flexWrap:"wrap" as const, marginBottom:10}}>
                  <label style={estiloFotoAcc}>
                    📷 Tomar foto
                    <input type="file" accept="image/*" capture="environment" style={{display:"none"}}
                      onChange={e=>{ subirFotosAccidente(e.target.files); e.currentTarget.value=""; }} />
                  </label>
                  <label style={estiloFotoAcc}>
                    📎 Elegir de la galería
                    <input type="file" accept="image/*" multiple style={{display:"none"}}
                      onChange={e=>{ subirFotosAccidente(e.target.files); e.currentTarget.value=""; }} />
                  </label>
                </div>
              );
            })()}
            {accProgreso.length>0 && (
              <div style={{display:"flex", flexDirection:"column" as const, gap:5, marginBottom:10}}>
                {accProgreso.map((p:any, i:number)=>(
                  <div key={i} style={{fontSize:11.5, lineHeight:1.45, color: p.estado==="error" ? "#FCA5A5" : p.estado==="hecho" ? "#7FD1C0" : NV.gold}}>
                    {p.estado==="error" ? "✕" : p.estado==="hecho" ? "✓" : "•"} {p.nombre} · {p.estado==="espera" ? "en cola" : p.estado==="subiendo" ? `${p.pct}%` : p.estado==="hecho" ? "lista" : (p.detalle || "no se pudo subir")}
                  </div>
                ))}
              </div>
            )}
            {accFotos.length>0 && (
              <div style={{display:"flex", flexWrap:"wrap" as const, gap:8, marginBottom:10}}>
                {accFotos.map((f,i)=>(
                  <div key={i} style={{width:64, height:64, borderRadius:8, overflow:"hidden", border:`1px solid ${NV.line}`}}>
                    <img src={f.url} alt={f.nombre} style={{width:"100%", height:"100%", objectFit:"cover" as const, display:"block"}}/>
                  </div>
                ))}
              </div>
            )}
            {accBloqueEstado.fotos && <div style={{fontSize:11.5, fontWeight:600, marginBottom:10, color:accBloqueEstado.fotos.tipo==="ok"?"#34D399":"#FCA5A5"}}>{accBloqueEstado.fotos.texto}</div>}
            <label style={{...labelNV, marginTop:4}}>Video (uno, hasta unos {SEGUNDOS_VIDEO} segundos)</label>
            {accVideoSubiendo !== null ? (
              <div style={{fontSize:12, color:NV.gold, marginBottom:8}}>
                Subiendo video… {accVideoSubiendo}%
                <div style={{marginTop:4, height:4, background:"rgba(255,255,255,0.12)", borderRadius:2}}>
                  <div style={{height:"100%", width:`${accVideoSubiendo}%`, background:NV.gold, borderRadius:2, transition:"width 0.3s"}}/>
                </div>
              </div>
            ) : accVideo ? (
              <div style={{fontSize:12.5, color:NV.ink, marginBottom:8}}>🎬 {accVideo.name}</div>
            ) : accVideoGuardado ? (
              <div style={{fontSize:12.5, color:NV.ink, marginBottom:8}}>✓ Este accidente ya tiene su video guardado.</div>
            ) : (
              <div style={{display:"flex", gap:8, flexWrap:"wrap" as const, marginBottom:8}}>
                <label style={{display:"inline-flex", alignItems:"center", gap:8, cursor:"pointer", fontSize:13, fontWeight:700,
                  color:NV.gold, background:NV.iconBg, border:`1px dashed ${NV.iconBd}`, borderRadius:10, padding:"10px 14px"}}>
                  🎥 Grabar video
                  <input type="file" accept={ACEPTA_VIDEO_CAMARA} capture="environment" style={{display:"none"}}
                    onChange={e=>{ elegirVideoAccidente(e.target.files); e.currentTarget.value=""; }} />
                </label>
                <label style={{display:"inline-flex", alignItems:"center", gap:8, cursor:"pointer", fontSize:13, fontWeight:700,
                  color:NV.gold, background:NV.iconBg, border:`1px dashed ${NV.iconBd}`, borderRadius:10, padding:"10px 14px"}}>
                  📎 Elegir un video
                  <input type="file" accept={ACEPTA_VIDEO} style={{display:"none"}}
                    onChange={e=>{ elegirVideoAccidente(e.target.files); e.currentTarget.value=""; }} />
                </label>
              </div>
            )}
            {accBloqueEstado.video && <div style={{fontSize:11.5, fontWeight:600, color:accBloqueEstado.video.tipo==="ok"?"#34D399":"#FCA5A5"}}>{accBloqueEstado.video.texto}</div>}
          </>))}

          {/* 3) OTRO CONDUCTOR. Solo lo que sirve para el trámite: marca, modelo y
              color salen de una foto de la placa mejor que de un teclado. */}
          {accRegistro && !accRegistro.sinVehiculo && bloqueAcc("contraparte", "Otro conductor", (<>
            <label style={labelNV}>Nombre</label>
            <input type="text" value={accContraparteNombre} onChange={e=>setAccContraparteNombre(e.target.value)} style={{...inputNV, marginBottom:10}} />
            <label style={labelNV}>Teléfono</label>
            <input type="tel" value={accContraparteTel} onChange={e=>setAccContraparteTel(e.target.value)} style={{...inputNV, marginBottom:10}} />
            <label style={labelNV}>Placa</label>
            <input type="text" value={accContrapartePlaca} onChange={e=>setAccContrapartePlaca(e.target.value)} style={{...inputNV, marginBottom:10}} />
            <label style={labelNV}>Aseguradora</label>
            <input type="text" value={accContraparteAseguradora} onChange={e=>setAccContraparteAseguradora(e.target.value)} style={{...inputNV, marginBottom:10}} />
            <label style={labelNV}>Número de póliza</label>
            <input type="text" value={accContrapartePoliza} onChange={e=>setAccContrapartePoliza(e.target.value)} style={{...inputNV, marginBottom:12}} />
            {filaSiNo("¿Hubo daños a otros bienes?", accDanosTerceros, setAccDanosTerceros)}
            {accDanosTerceros === true && (
              <textarea value={accDanosTercerosTexto} onChange={e=>setAccDanosTercerosTexto(e.target.value)} rows={2}
                placeholder="Ej. barda, poste, local…" style={{...inputNV, resize:"vertical" as const}} />
            )}
          </>), ()=>{
            const d:any = {};
            if (accContraparteNombre.trim()) d.contraparteNombre = accContraparteNombre.trim();
            if (accContraparteTel.trim()) d.contraparteTelefono = accContraparteTel.trim();
            if (accContrapartePlaca.trim()) d.contrapartePlaca = accContrapartePlaca.trim().toUpperCase();
            if (accContraparteAseguradora.trim()) d.contraparteAseguradora = accContraparteAseguradora.trim();
            if (accContrapartePoliza.trim()) d.contrapartePoliza = accContrapartePoliza.trim();
            if (accDanosTerceros !== null) {
              d.danosTerceros = accDanosTerceros;
              d.danosTercerosDesc = accDanosTerceros ? accDanosTercerosTexto.trim() : "";
            }
            guardarBloqueAccidente("contraparte", d);
          })}

          {/* 4) TESTIGOS. Nombre y teléfono; lo que digan, lo dirán a quien llame. */}
          {accRegistro && bloqueAcc("testigos", "Testigos", (<>
            {/* LOS YA GUARDADOS, FIJOS: la regla no deja quitar ni cambiar uno. */}
            {accTestigosGuardados.map((t, i)=>(
              <div key={"g"+i} style={{fontSize:12.5, color:NV.ink, marginBottom:6}}>
                ✓ {[t.nombre, t.telefono].filter(Boolean).join(" · ")}
              </div>
            ))}
            {accTestigosGuardados.length>0 && (
              <div style={{fontSize:11, color:NV.inkMut, margin:"0 0 10px"}}>Si necesitas corregir alguno, avísale a tu patrón.</div>
            )}
            {accTestigos.map((t, i)=>(
              <div key={i} style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap:8, marginBottom:8}}>
                <input type="text" value={t.nombre} placeholder="Nombre"
                  onChange={e=>{ const v=e.target.value; setAccTestigos(p=>p.map((x,j)=>j===i?{...x, nombre:v}:x)); }} style={{...inputNV}} />
                <input type="tel" value={t.telefono} placeholder="Teléfono"
                  onChange={e=>{ const v=e.target.value; setAccTestigos(p=>p.map((x,j)=>j===i?{...x, telefono:v}:x)); }} style={{...inputNV}} />
              </div>
            ))}
            <button type="button" onClick={()=>setAccTestigos(p=>[...p, {nombre:"", telefono:""}])}
              style={{background:"none", border:"none", padding:0, cursor:"pointer", fontFamily:fontSans, fontSize:12.5, fontWeight:700, color:NV.gold}}>
              + Añadir otro testigo
            </button>
          </>), guardarTestigosAccidente)}

          {/* 5) AUTORIDADES Y GRÚA. Cada pregunta arranca SIN contestar, y lo sin
              contestar no se guarda. La de la grúa solo si hubo unidad. */}
          {accRegistro && bloqueAcc("autoridades", "Autoridades y grúa", (<>
            {filaSiNo("¿Llegó tránsito o policía?", accParteTransito, setAccParteTransito)}
            {accParteTransito === true && (<>
              <label style={labelNV}>Número de parte o folio</label>
              <input type="text" value={accFolioParte} onChange={e=>setAccFolioParte(e.target.value)} style={{...inputNV, marginBottom:12}} />
            </>)}
            {filaSiNo("¿Llegó ambulancia?", accAmbulancia, setAccAmbulancia)}
            {filaSiNo("¿Alguien quedó detenido?", accDetenidos, setAccDetenidos)}
            {!accRegistro.sinVehiculo && filaSiNo("¿Se llevaron la unidad (grúa o corralón)?", accVehiculoRetirado, setAccVehiculoRetirado)}
          </>), ()=>{
            const d:any = {};
            if (accParteTransito !== null) { d.parteTransito = accParteTransito; d.folioParte = accParteTransito ? accFolioParte.trim() : ""; }
            if (accAmbulancia !== null) d.huboAmbulancia = accAmbulancia;
            if (accDetenidos !== null) d.huboDetenidos = accDetenidos;
            if (!accRegistro.sinVehiculo && accVehiculoRetirado !== null) d.vehiculoRetirado = accVehiculoRetirado;
            guardarBloqueAccidente("autoridades", d);
          })}

          {/* 6) ¿QUÉ PASÓ? EN SUS PALABRAS. La descripción de antes, ahora opcional. */}
          {/* SE ESCRIBE UNA VEZ. Una vez guardado, el relato queda en solo lectura:
              la primera versión es la más valiosa, y firestore.rules no deja
              reescribirla. Corregirlo, con traza, es del bloque 4. */}
          {accRegistro && bloqueAcc("descripcion", "¿Qué pasó? En tus palabras", (
            accDeclarado.descripcion ? (<>
              <div style={{fontSize:12.5, color:NV.ink, lineHeight:1.55, whiteSpace:"pre-wrap" as const}}>{accDeclarado.descripcion}</div>
              <div style={{fontSize:11, color:NV.inkMut, marginTop:8}}>Si necesitas corregirlo, avísale a tu patrón.</div>
            </>) : (
              <textarea value={accDescripcion} onChange={e=>setAccDescripcion(e.target.value)} rows={4}
                placeholder="Describe lo que viste: dónde, qué vehículos, qué pasó." style={{...inputNV, resize:"vertical" as const}} />
            )
          ), accDeclarado.descripcion ? undefined : async ()=>{
            const d = accDescripcion.trim();
            if (await guardarBloqueAccidente("descripcion", d ? {descripcion: d} : {})) setAccDeclarado(p=>({...p, descripcion: d}));
          })}

          {/* 7) ¿FUE A OTRA HORA? Escribe la hora DECLARADA —`fechaHechos` y
              `horaHechos`— y deja intacta la de registro, `timestamp`. */}
          {/* TAMBIÉN SE ESCRIBE UNA VEZ, por la misma razón que el relato. */}
          {accRegistro && bloqueAcc("hora", "¿Fue a otra hora?", (
            accDeclarado.fechaHechos ? (<>
              <div style={{fontSize:12.5, color:NV.ink}}>Hora declarada: {accDeclarado.fechaHechos} · {accDeclarado.horaHechos}</div>
              <div style={{fontSize:11, color:NV.inkMut, marginTop:8}}>Si necesitas corregirlo, avísale a tu patrón.</div>
            </>) : (
              <div style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap:10}}>
                <input type="date" value={accFechaHechos} onChange={e=>setAccFechaHechos(e.target.value)} style={{...inputNV, colorScheme:"dark" as any}} />
                <input type="time" value={accHoraHechos} onChange={e=>setAccHoraHechos(e.target.value)} style={{...inputNV, colorScheme:"dark" as any}} />
              </div>
            )
          ), accDeclarado.fechaHechos ? undefined : async ()=>{
            // La misma condición que habilita el botón, también aquí: si la fecha y
            // la hora son las del registro, no hay nada que declarar.
            if (!horaDistintaDelRegistro) return;
            if (!(accFechaHechos && accHoraHechos)) { guardarBloqueAccidente("hora", {}); return; }
            if (await guardarBloqueAccidente("hora", {fechaHechos: accFechaHechos, horaHechos: accHoraHechos}))
              setAccDeclarado(p=>({...p, fechaHechos: accFechaHechos, horaHechos: accHoraHechos}));
          }, horaDistintaDelRegistro, "Cambia la fecha o la hora si el accidente fue en otro momento; la del registro ya está guardada.")}

          <button onClick={cerrarAccidente}
            style={{width:"100%", marginTop:6, background:"transparent", border:`1px solid ${NV.gold}`, color:NV.gold,
              borderRadius:12, padding:isMobile?"14px 10px":"13px 16px", cursor:"pointer", fontSize:14, fontWeight:700, fontFamily:fontSans}}>
            Listo
          </button>
          </>)}
        </div>
        )}

        {/* ════ SECCIÓN: NOTIFICACIONES (placeholder; se llenará por fases) ════ */}
        {pantalla==="notificaciones" && (
          <div>
            <PanelRecordatorioEntrada r={recordatorio} NV={NV} fontSans={fontSans}/>
            {pendientes>0 && (
              <button onClick={()=>setPantalla("tareas")}
                style={{display:"flex", alignItems:"center", gap:12, width:"100%", textAlign:"left" as const, fontFamily:fontSans, marginBottom:12,
                  background:NV.panel, border:`1px solid ${NV.line}`, borderRadius:14, padding:"14px 14px", boxShadow:NV.sombra, cursor:"pointer"}}>
                <div style={{width:44, height:44, borderRadius:12, flexShrink:0, display:"flex", alignItems:"center", justifyContent:"center", background:"rgba(184,147,42,0.18)", border:"1px solid rgba(184,147,42,0.40)", color:"#E2B84A"}}>
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M6 9a6 6 0 1112 0c0 4.5 2 5.5 2 5.5H4S6 13.5 6 9z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round"/><path d="M10 19a2 2 0 004 0" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/></svg>
                </div>
                <div style={{flex:1, minWidth:0}}>
                  <div style={{fontSize:13.5, fontWeight:700, color:NV.ink}}>Tienes {pendientes} actividad{pendientes===1?"":"es"} pendiente{pendientes===1?"":"s"}</div>
                  <div style={{fontSize:12, color:NV.inkSoft, marginTop:2}}>Toca para ver tus actividades</div>
                </div>
                <span style={{fontSize:22, color:NV.inkMut, lineHeight:1}}>›</span>
              </button>
            )}
            {/* Eventos de la empresa (comunicados tipo='evento'; solo lectura + exportar .ics) */}
            {eventos.length>0 && (
              <div style={{display:"flex", flexDirection:"column" as const, gap:10, marginBottom:12}}>
                {eventos.map((ev:any)=>{
                  const [yy,mm,dd] = String(ev.fecha).split("-").map(Number);
                  const dt = new Date(yy, mm-1, dd);
                  const fechaTxt = dt.toLocaleDateString("es-MX",{weekday:"long", day:"numeric", month:"long"});
                  return (
                    <div key={ev.id} style={{background:NV.panel, border:`1px solid ${NV.line}`, borderLeft:"3px solid #7FD1C0", borderRadius:14, padding:"14px 14px", boxShadow:NV.sombra}}>
                      <div style={{display:"flex", alignItems:"center", gap:10, marginBottom:6}}>
                        <div style={{width:34, height:34, borderRadius:9, flexShrink:0, display:"flex", alignItems:"center", justifyContent:"center", background:"rgba(127,209,192,0.14)", border:"1px solid rgba(127,209,192,0.4)", color:"#7FD1C0"}}>
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><rect x="3.5" y="5" width="17" height="16" rx="2.5" stroke="currentColor" strokeWidth="1.7"/><path d="M3.5 9.5h17M8 3.2v3.2M16 3.2v3.2" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/></svg>
                        </div>
                        <div style={{flex:1, minWidth:0}}>
                          <div style={{fontSize:10.5, fontWeight:700, color:"#7FD1C0", textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>Evento de tu empresa</div>
                          <div style={{fontSize:14, fontWeight:700, color:NV.ink, marginTop:1}}>{ev.titulo||"Evento"}</div>
                        </div>
                      </div>
                      <div style={{fontSize:12.5, color:NV.gold, fontWeight:700, textTransform:"capitalize" as const, marginBottom:ev.mensaje?6:10}}>
                        {fechaTxt}{ev.hora?` · ${ev.hora}`:""}{ev.lugar?` · ${ev.lugar}`:""}
                      </div>
                      {ev.mensaje && <div style={{fontSize:13, color:NV.inkSoft, lineHeight:1.5, whiteSpace:"pre-wrap" as const, marginBottom:10}}>{ev.mensaje}</div>}
                      {/* Adjunto del evento (foto/PDF), si el patrón lo agregó */}
                      {ev.adjuntoUrl && (
                        <div style={{marginBottom:10}}>
                          {ev.adjuntoTipo==="imagen" ? (
                            <a href={ev.adjuntoUrl} target="_blank" rel="noopener noreferrer" style={{display:"block", textDecoration:"none"}}>
                              <img src={ev.adjuntoUrl} alt={ev.adjuntoNombre||"Adjunto"} style={{width:"100%", maxHeight:280, objectFit:"cover" as const, borderRadius:12, border:"1px solid rgba(127,209,192,0.4)", display:"block"}}/>
                              <span style={{display:"inline-block", fontSize:11, color:"#7FD1C0", fontWeight:700, marginTop:6}}>Toca para ampliar</span>
                            </a>
                          ) : (
                            <a href={ev.adjuntoUrl} target="_blank" rel="noopener noreferrer"
                              style={{display:"inline-flex", alignItems:"center", gap:7, padding:"9px 13px", borderRadius:10, border:"1px solid rgba(127,209,192,0.5)", background:"rgba(127,209,192,0.12)", color:"#7FD1C0", cursor:"pointer", fontFamily:fontSans, fontSize:12.5, fontWeight:700, textDecoration:"none"}}>
                              <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><path d="M12 3v12m0 0l-4-4m4 4l4-4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/><path d="M5 19h14" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/></svg>
                              Abrir / descargar adjunto
                            </a>
                          )}
                        </div>
                      )}
                      <button onClick={()=>exportarEventoICS(ev)}
                        style={{display:"inline-flex", alignItems:"center", gap:7, padding:"9px 13px", borderRadius:10, border:"1px solid rgba(127,209,192,0.5)", background:"rgba(127,209,192,0.12)", color:"#7FD1C0", cursor:"pointer", fontFamily:fontSans, fontSize:12.5, fontWeight:700}}>
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><rect x="3.5" y="5" width="17" height="16" rx="2.5" stroke="currentColor" strokeWidth="1.7"/><path d="M3.5 9.5h17M8 3.2v3.2M16 3.2v3.2" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/><path d="M12 12.5v4M10 14.5h4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/></svg>
                        Agregar a mi calendario
                      </button>
                    </div>
                  );
                })}
                {icsMsg && <div style={{fontSize:11.5, color:NV.inkSoft, textAlign:"center" as const, marginTop:2}}>{icsMsg}</div>}
              </div>
            )}

            {/* Mis reportes: bitácora quincenal / reporte mensual enviados por el patrón */}
            {reportesError && (
              <div style={{background:"rgba(220,38,38,0.10)", border:`1px solid rgba(220,38,38,0.35)`, borderRadius:14, padding:"13px 14px", marginBottom:12}}>
                <div style={{fontSize:12.5, fontWeight:700, color:"#FCA5A5"}}>No pudimos cargar tus documentos</div>
                <div style={{fontSize:12, color:NV.inkSoft, marginTop:4, lineHeight:1.5}}>Falló la conexión al traer los reportes y actas que te envió tu patrón. Esto NO significa que no te haya enviado nada: vuelve a entrar o revisa tu conexión.</div>
              </div>
            )}
            {reportes.length>0 && (
              <div style={{display:"flex", flexDirection:"column" as const, gap:10, marginBottom:12}}>
                <div style={{fontSize:11, color:NV.inkMut, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"0.6px", margin:"2px 2px 0"}}>Mis reportes</div>
                {reportes.map((r:any)=>{
                  const f = r.fechaEnvio?.toDate?.();
                  const tipoTxt = r.tipo==="quincenal" ? "Bitácora quincenal" : r.tipo==="mensual" ? "Registro mensual" : r.tipo==="acta_vacaciones" ? "Acta de vacaciones" : r.tipo==="constancia_aguinaldo" ? "Constancia de aguinaldo" : "Reporte";
                  return (
                    <div key={r.id} style={{background:NV.panel, border:`1px solid ${NV.line}`, borderLeft:`3px solid ${NV.gold}`, borderRadius:14, padding:"14px 14px", boxShadow:NV.sombra}}>
                      <div style={{display:"flex", alignItems:"center", gap:10, marginBottom:6}}>
                        <div style={{width:34, height:34, borderRadius:9, flexShrink:0, display:"flex", alignItems:"center", justifyContent:"center", background:NV.iconBg, border:`1px solid ${NV.iconBd}`, color:NV.gold}}>
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M6 3h8l4 4v13a1 1 0 01-1 1H6a1 1 0 01-1-1V4a1 1 0 011-1z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round"/><path d="M13 3v5h5M9 14h6M9 17h4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/></svg>
                        </div>
                        <div style={{flex:1, minWidth:0}}>
                          <div style={{fontSize:10.5, fontWeight:700, color:NV.gold, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>{tipoTxt}</div>
                          <div style={{fontSize:13.5, fontWeight:700, color:NV.ink, marginTop:1}}>{r.periodo||""}</div>
                        </div>
                      </div>
                      {r.mensaje && <div style={{fontSize:12.5, color:NV.inkSoft, lineHeight:1.5, whiteSpace:"pre-wrap" as const, marginBottom:10}}>{r.mensaje}</div>}
                      {reporteConLeyendaVieja(r) && <div style={{fontSize:11, color:NV.inkMut, fontStyle:"italic" as const, lineHeight:1.5, marginTop:-4, marginBottom:10}}>{NOTA_LEYENDA_VIEJA}</div>}
                      <div style={{display:"flex", alignItems:"center", gap:10, flexWrap:"wrap" as const}}>
                        {r.urlPDF && (
                          <a href={r.urlPDF} target="_blank" rel="noopener noreferrer"
                            style={{display:"inline-flex", alignItems:"center", gap:7, padding:"9px 13px", borderRadius:10, border:`1px solid ${NV.gold}`, background:`rgba(${ATR.rgbDim},0.12)`, color:NV.gold, cursor:"pointer", fontFamily:fontSans, fontSize:12.5, fontWeight:700, textDecoration:"none"}}>
                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><path d="M12 3v12m0 0l-4-4m4 4l4-4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/><path d="M5 19h14" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/></svg>
                            Abrir / descargar PDF
                          </a>
                        )}
                        {f && <span style={{fontSize:11, color:NV.inkMut}}>Enviado {f.toLocaleDateString("es-MX",{day:"numeric",month:"long"})} · {f.toLocaleTimeString("es-MX",{hour:"2-digit",minute:"2-digit"})}</span>}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {/* Avisos generales de la empresa (comunicados tipo='aviso'; solo lectura) */}
            {avisosError && (
              <div style={{background:"rgba(220,38,38,0.10)", border:`1px solid rgba(220,38,38,0.35)`, borderRadius:14, padding:"13px 14px", marginBottom:12}}>
                <div style={{fontSize:12.5, fontWeight:700, color:"#FCA5A5"}}>No pudimos cargar tus avisos</div>
                <div style={{fontSize:12, color:NV.inkSoft, marginTop:4, lineHeight:1.5}}>Falló la conexión al traer los avisos y eventos de tu empresa. No quiere decir que no haya ninguno. Revisa tu conexión y vuelve a entrar.</div>
              </div>
            )}
            {avisos.length>0 && (
              <div style={{display:"flex", flexDirection:"column" as const, gap:10, marginBottom:12}}>
                {avisos.map((a:any)=>{
                  const f = a.createdAt?.toDate?.();
                  return (
                    <div key={a.id} style={{background:NV.panel, border:`1px solid ${NV.line}`, borderRadius:14, padding:"14px 14px", boxShadow:NV.sombra}}>
                      <div style={{display:"flex", alignItems:"center", gap:10, marginBottom:a.titulo?6:8}}>
                        <div style={{width:34, height:34, borderRadius:9, flexShrink:0, display:"flex", alignItems:"center", justifyContent:"center", background:NV.iconBg, border:`1px solid ${NV.iconBd}`, color:NV.gold}}>
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M4 10v4a1 1 0 001 1h2l4 3.5V5.5L7 9H5a1 1 0 00-1 1z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round"/><path d="M15 8.5a4 4 0 010 7" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/></svg>
                        </div>
                        <div style={{flex:1, minWidth:0}}>
                          <div style={{fontSize:10.5, fontWeight:700, color:NV.gold, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>Aviso de tu empresa</div>
                          {a.titulo && <div style={{fontSize:14, fontWeight:700, color:NV.ink, marginTop:1}}>{a.titulo}</div>}
                        </div>
                      </div>
                      <div style={{fontSize:13, color:NV.inkSoft, lineHeight:1.5, whiteSpace:"pre-wrap" as const}}>{a.mensaje}</div>
                      {/* Adjunto del aviso (foto/PDF): imagen → preview tocable; PDF → abrir/descargar */}
                      {a.adjuntoUrl && (
                        <div style={{marginTop:10}}>
                          {a.adjuntoTipo==="imagen" ? (
                            <a href={a.adjuntoUrl} target="_blank" rel="noopener noreferrer" style={{display:"block", textDecoration:"none"}}>
                              <img src={a.adjuntoUrl} alt={a.adjuntoNombre||"Adjunto"} style={{width:"100%", maxHeight:280, objectFit:"cover" as const, borderRadius:12, border:`1px solid ${NV.line}`, display:"block"}}/>
                              <span style={{display:"inline-block", fontSize:11, color:NV.gold, fontWeight:700, marginTop:6}}>Toca para ampliar</span>
                            </a>
                          ) : (
                            <a href={a.adjuntoUrl} target="_blank" rel="noopener noreferrer"
                              style={{display:"inline-flex", alignItems:"center", gap:7, padding:"9px 13px", borderRadius:10, border:`1px solid ${NV.gold}`, background:`rgba(${ATR.rgbDim},0.12)`, color:NV.gold, cursor:"pointer", fontFamily:fontSans, fontSize:12.5, fontWeight:700, textDecoration:"none"}}>
                              <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><path d="M12 3v12m0 0l-4-4m4 4l4-4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/><path d="M5 19h14" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/></svg>
                              Abrir / descargar {a.adjuntoNombre ? "PDF" : "adjunto"}
                            </a>
                          )}
                        </div>
                      )}
                      {f && <div style={{fontSize:11, color:NV.inkMut, marginTop:8}}>{f.toLocaleDateString("es-MX",{day:"numeric",month:"long"})} · {f.toLocaleTimeString("es-MX",{hour:"2-digit",minute:"2-digit"})}</div>}
                    </div>
                  );
                })}
              </div>
            )}
            {!avisosError && !reportesError && avisos.length===0 && eventos.length===0 && reportes.length===0 && (
              <div style={{textAlign:"center" as const, padding:isMobile?"40px 16px":"56px 24px", background:NV.panel, border:`1px solid ${NV.line}`, borderRadius:16, boxShadow:NV.sombra}}>
                <div style={{width:64, height:64, borderRadius:"50%", margin:"0 auto 12px", display:"flex", alignItems:"center", justifyContent:"center", background:NV.iconBg, border:`1px solid ${NV.iconBd}`, color:NV.gold}}>
                  <svg width="30" height="30" viewBox="0 0 24 24" fill="none"><path d="M6 9a6 6 0 1112 0c0 4.5 2 5.5 2 5.5H4S6 13.5 6 9z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><path d="M10 19a2 2 0 004 0" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
                </div>
                <div style={{fontFamily:fontSerif, fontSize:16, fontWeight:700, color:NV.gold, marginBottom:4}}>No tienes notificaciones nuevas</div>
                <p style={{fontSize:12.5, color:NV.inkSoft, margin:0, lineHeight:1.5}}>Aquí verás avisos y eventos de tu empresa cuando los haya.</p>
              </div>
            )}
          </div>
        )}

        {/* ════ SECCIÓN: PERFIL ════ */}
        {pantalla==="perfil" && (
          <div>
            {/* Identidad */}
            <div style={{textAlign:"center" as const, background:NV.panel, border:`1px solid ${NV.line}`, borderRadius:16, padding:isMobile?"24px 16px":"28px 22px", boxShadow:NV.sombra, marginBottom:16}}>
              {/* Avatar TOCABLE (tipo WhatsApp): el trabajador toca su foto para cambiarla. */}
              <div style={{marginBottom:12}}>
                <AvatarEditable url={fotoPerfilTrab} iniciales={iniciales} size={72} userId={user.uid} carpeta="perfil_trabajador"
                  onSubido={(u:string)=>guardarFotoTrab(u)} fontSans={fontSans}
                  c={{gold:NV.gold, iconBg:`rgba(${ATR.rgbDim},0.14)`, iconBd:NV.iconBd, panel:NV.panel, inkSoft:NV.inkSoft}}/>
              </div>
              {fotoTrabErr && <div style={{fontSize:11, color:"#FCA5A5", marginBottom:8, lineHeight:1.4}}>{fotoTrabErr}</div>}
              <div style={{fontFamily:fontSerif, fontSize:20, fontWeight:700, color:NV.gold, lineHeight:1.15}}>{nombre}</div>
              {correo && <div style={{fontSize:12.5, color:NV.inkSoft, marginTop:3, wordBreak:"break-all" as const}}>{correo}</div>}
              {/* Puesto asignado por el patrón (expediente) — informativo, el trabajador NO lo edita. */}
              {fichaEstado==="ok" && (fichaPropia?.puesto||"").trim() && (
                <div style={{display:"inline-flex", alignItems:"center", gap:6, marginTop:8, padding:"5px 12px", borderRadius:999, background:`rgba(${ATR.rgbDim},0.12)`, border:`1px solid ${NV.iconBd}`}}>
                  <span style={{fontSize:12, color:NV.inkSoft}}>Puesto: <span style={{color:NV.ink, fontWeight:700}}>{fichaPropia.puesto}</span></span>
                </div>
              )}
            </div>

            {/* ── Color del portal (personalización local): una línea ── */}
            <SelectorColorPortal acentos={ACENTOS_TR} actual={acentoTr} onElegir={elegirAcentoTr} tinta={NV.ink} tintaSuave={NV.inkSoft} fontSans={fontSans}/>

            {/* ── Mi expediente ── */}
            <div style={{fontSize:11, fontWeight:700, color:NV.inkMut, textTransform:"uppercase" as const, letterSpacing:"0.5px", margin:"0 2px 8px"}}>Mi expediente</div>
            <div style={{background:NV.panel, border:`1px solid ${NV.line}`, borderRadius:16, padding:isMobile?"16px 14px":"18px 18px", boxShadow:NV.sombra, marginBottom:18}}>
              {fichaEstado==="ok" ? (()=>{
                const comp = calcularCompliance(fichaPropia.compliance);
                const pctDoc = comp.porcentaje;
                const ct = calcularCumplimientoTareas(tareas, correo);
                const hayTareas = ct.total>0;
                const pctTar = hayTareas ? ct.porcentaje : 0;
                const pendientesDocs = COMPLIANCE_ITEMS.filter((it:any)=>(fichaPropia.compliance?.[it.key]||"pendiente")==="pendiente");
                const colorPct = (p:number)=> p>=90?"#34D399":p>=60?"#E2B84A":"#FCA5A5";
                // Medidor (anillo) parejo, mismo tamaño/jerarquía para ambos números.
                const medidor = (titulo:string, pct:number, sub:string, activo:boolean) => {
                  const R=30, C=2*Math.PI*R, off=C*(1-(activo?pct:0)/100);
                  const col = activo ? colorPct(pct) : "rgba(255,255,255,0.18)";
                  return (
                    <div style={{display:"flex", flexDirection:"column" as const, alignItems:"center", textAlign:"center" as const, gap:9, background:"rgba(255,255,255,0.03)", border:`1px solid ${NV.lineSoft}`, borderRadius:14, padding:"16px 10px"}}>
                      <svg width="84" height="84" viewBox="0 0 84 84">
                        <circle cx="42" cy="42" r="30" fill="none" stroke="rgba(255,255,255,0.10)" strokeWidth="7"/>
                        <circle cx="42" cy="42" r="30" fill="none" stroke={col} strokeWidth="7" strokeLinecap="round" strokeDasharray={C} strokeDashoffset={off} transform="rotate(-90 42 42)"/>
                        <text x="42" y="42" textAnchor="middle" dominantBaseline="central" fontSize="18" fontWeight="800" fill={NV.ink} fontFamily={fontSerif}>{activo?`${pct}%`:"—"}</text>
                      </svg>
                      <div>
                        <div style={{fontSize:12.5, fontWeight:700, color:NV.gold, fontFamily:fontSerif, lineHeight:1.2}}>{titulo}</div>
                        <div style={{fontSize:11, color:NV.inkMut, marginTop:3}}>{sub}</div>
                      </div>
                    </div>
                  );
                };
                return (
                  <>
                    <div style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap:10}}>
                      {medidor("Expediente capturado", pctDoc, `${comp.obligatoriosCumplidos}/${comp.totalObligatorios} obligatorios`, true)}
                      {medidor("Cumplimiento de actividades", pctTar, hayTareas?`${ct.confirmadas}/${ct.total} confirmadas`:"Sin actividades asignadas", hayTareas)}
                    </div>
                    {pendientesDocs.length>0 && (
                      <div style={{marginTop:14, paddingTop:12, borderTop:`1px solid ${NV.lineSoft}`}}>
                        <div style={{fontSize:11.5, fontWeight:700, color:NV.inkSoft, marginBottom:3}}>Documentos pendientes en tu expediente:</div>
                        <div style={{fontSize:11, color:NV.inkMut, marginBottom:9, lineHeight:1.5}}>Completa tu expediente entregando o solicitando estos documentos según corresponda.</div>
                        <div style={{display:"flex", flexDirection:"column" as const, gap:6}}>
                          {pendientesDocs.map((it:any)=>(
                            <div key={it.key} style={{display:"flex", alignItems:"center", gap:8, fontSize:12.5, color:NV.inkSoft}}>
                              <span style={{width:6, height:6, borderRadius:"50%", background:"#E2B84A", flexShrink:0}}/>{it.label}
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </>
                );
              })() : fichaEstado==="cargando" ? (
                <div style={{fontSize:12.5, color:NV.inkMut, textAlign:"center" as const, padding:"8px 0"}}>Cargando tu expediente…</div>
              ) : fichaEstado==="vacia" ? (
                <div style={{fontSize:12.5, color:NV.inkSoft, lineHeight:1.5}}>Aún no se ha creado tu expediente. Tu patrón lo registrará pronto.</div>
              ) : (
                <div style={{fontSize:12.5, color:NV.inkSoft, lineHeight:1.5}}>No pudimos cargar tu expediente en este momento. Intenta más tarde.</div>
              )}
            </div>

            {/* ── Documentos en mi expediente (cargados; solo lectura) ── */}
            <div style={{fontSize:11, fontWeight:700, color:NV.inkMut, textTransform:"uppercase" as const, letterSpacing:"0.5px", margin:"0 2px 8px"}}>Documentos en mi expediente</div>
            <div style={{marginBottom:18}}>
              {fichaEstado==="ok" ? (()=>{
                const docs = Array.isArray(fichaPropia.documentos)?fichaPropia.documentos:[];
                const contratos = Array.isArray(fichaPropia.contratos)?fichaPropia.contratos:[];
                const cap = (s:string)=> s ? s.replace(/_/g," ").replace(/\b\w/g, (m:string)=>m.toUpperCase()) : "";
                const items = [
                  // El campo guardado es `url`, no `pdfUrl`: `pdfUrl` es una variable
                  // local del formulario de subida y nunca llegó a la base. Verificado
                  // en los TRES escritores del arreglo `contratos`. Como el filtro de
                  // abajo descarta lo que no tenga url, el portal tiraba en silencio
                  // todos los contratos. Se arregla el lector para que aparezcan
                  // también los ya guardados, no solo los futuros.
                  ...contratos.map((c:any)=>({nombre: c.tipo?`Contrato · ${cap(c.tipo)}`:"Contrato", fecha:c.fecha||"", url:c.url, tag:"Contrato"})),
                  ...docs.map((d:any)=>({nombre: d.nombre||"Documento", fecha:d.fecha||"", url:d.url, tag:"Documento"})),
                ]
                  .filter((x:any)=>x.url)
                  // El MISMO archivo puede estar en los dos arreglos de la ficha:
                  // `contratos` lo escribe "Guardar y vincular", `documentos` la
                  // subida al expediente y el archivado de actas. Ninguna acción
                  // escribe en ambos —verificado—, pero el portal los fusiona en una
                  // lista y el duplicado se ve como si el patrón lo hubiera mandado
                  // dos veces. Se deduplica por URL, que es la identidad real del
                  // archivo. Gana la primera aparición: los contratos van antes, así
                  // que conserva la etiqueta más informativa.
                  .filter((x:any, i:number, arr:any[])=> arr.findIndex((y:any)=>y.url===x.url) === i);
                if (items.length===0) return (
                  <div style={{background:NV.panel, border:`1px solid ${NV.line}`, borderRadius:14, padding:"24px 18px", textAlign:"center" as const, fontSize:12.5, color:NV.inkSoft, boxShadow:NV.sombra, lineHeight:1.5}}>Tu patrón aún no ha cargado documentos a tu expediente.</div>
                );
                return (
                  <div style={{display:"flex", flexDirection:"column" as const, gap:8}}>
                    {items.map((it:any,i:number)=>{
                      const visor = (/\.(doc|docx)$/i).test(it.nombre||"") ? `https://docs.google.com/viewer?embedded=true&url=${encodeURIComponent(it.url)}` : it.url;
                      return (
                        <div key={i} style={{display:"flex", alignItems:"center", gap:12, background:NV.panel, border:`1px solid ${NV.line}`, borderRadius:14, padding:"12px 14px", boxShadow:NV.sombra}}>
                          <div style={{width:40, height:40, borderRadius:10, flexShrink:0, display:"flex", alignItems:"center", justifyContent:"center", background:NV.iconBg, border:`1px solid ${NV.iconBd}`, color:NV.gold}}>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M6 3h7l5 5v13a1 1 0 01-1 1H6a1 1 0 01-1-1V4a1 1 0 011-1z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round"/><path d="M13 3v5h5M8.5 13h7M8.5 16.5h5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/></svg>
                          </div>
                          <div style={{flex:1, minWidth:0}}>
                            <div style={{fontSize:13, fontWeight:700, color:NV.ink, whiteSpace:"nowrap" as const, overflow:"hidden", textOverflow:"ellipsis"}}>{it.nombre}</div>
                            <div style={{fontSize:11, color:NV.inkMut, marginTop:1}}>{it.tag}{it.fecha?` · ${it.fecha}`:""}</div>
                          </div>
                          <a href={visor} target="_blank" rel="noreferrer" style={{flexShrink:0, fontSize:12, fontWeight:700, color:"#0B1829", background:NV.gold, borderRadius:9, padding:"7px 14px", textDecoration:"none"}}>Ver</a>
                        </div>
                      );
                    })}
                  </div>
                );
              })() : fichaEstado==="cargando" ? (
                <div style={{fontSize:12.5, color:NV.inkMut, textAlign:"center" as const, padding:"8px 0"}}>Cargando tus documentos…</div>
              ) : fichaEstado==="vacia" ? (
                <div style={{background:NV.panel, border:`1px solid ${NV.line}`, borderRadius:14, padding:"24px 18px", textAlign:"center" as const, fontSize:12.5, color:NV.inkSoft, boxShadow:NV.sombra, lineHeight:1.5}}>Tu patrón aún no ha cargado documentos a tu expediente.</div>
              ) : (
                <div style={{background:NV.panel, border:`1px solid ${NV.line}`, borderRadius:14, padding:"24px 18px", textAlign:"center" as const, fontSize:12.5, color:NV.inkSoft, boxShadow:NV.sombra, lineHeight:1.5}}>No pudimos cargar tus documentos en este momento.</div>
              )}
            </div>

            {/* ACTUALIZACIONES: todas las que le aplican, con fecha. */}
            <div style={{fontSize:11, color:NV.inkMut, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"1px", margin:"0 2px 8px"}}>Actualizaciones</div>
            <div style={{marginBottom:16}}>
              <ListaNovedades rol="trabajador" tieneFlotilla={vehiculosPatron.length > 0} fontSans={fontSans}
                c={{fondo: NV.panel, borde: NV.line, texto: NV.ink, textoSuave: NV.inkSoft, acento: NV.gold}}/>
            </div>

            {/* Cerrar sesión */}
            <button onClick={onLogout}
              style={{width:"100%", background:"rgba(255,255,255,0.05)", border:`1px solid ${NV.line}`, color:NV.ink, borderRadius:12, padding:"13px 16px", cursor:"pointer", fontSize:14, fontWeight:700, fontFamily:fontSans}}>
              Cerrar sesión
            </button>
            <p style={{fontSize:11, color:NV.inkMut, textAlign:"center" as const, margin:"14px 0 0"}}>AXIS Legaltech · Portal del trabajador</p>
          </div>
        )}
      </div>

      {/* LAS ACTUALIZACIONES: solo en el menú de inicio. Nunca en el checador, el
          registro de un accidente, "Completar accidente" ni ningún formulario: si
          entra directo a otra pantalla, el aviso espera a que vuelva al menú. */}
      {/* UNA CORRECCIÓN DE SU PATRÓN, al abrir su portal (fase 2b). Va antes que las
          actualizaciones: mientras esté, aquellas esperan. */}
      <AvisoCorreccion n={correccionesSinVer.length} visible={pantalla === "menu"}
        onVer={()=>{ correccionesVistas.marcarVistas(correccionesSinVer.map((c:any)=> c.id)); setPantalla("checador"); }}
        onCerrar={()=> correccionesVistas.marcarVistas(correccionesSinVer.map((c:any)=> c.id))}
        abajo="calc(78px + env(safe-area-inset-bottom, 0px))" fontSans={fontSans}/>
      <AvisoNovedades rol="trabajador" tieneFlotilla={vehiculosPatron.length > 0} altaMs={altaDeLaCuentaMs(user)}
        vistas={novedadesTrab.vistas} onMarcar={novedadesTrab.marcarVistas}
        visible={pantalla === "menu" && correccionesSinVer.length === 0}
        posicion="movil" abajo="calc(78px + env(safe-area-inset-bottom, 0px))" fontSans={fontSans}/>

      {/* ════ BARRA INFERIOR (navegación tipo app nativa) ════ */}
      {/* El inset INFERIOR levanta la barra por encima del indicador de inicio del
          iPhone; sin el, la fila de botones queda debajo de esa franja y los toques
          se los lleva el sistema. */}
      <div style={{position:"fixed" as const, left:0, right:0, bottom:0, zIndex:30, background:"#0B1829", borderTop:`1px solid ${NV.lineSoft}`, boxShadow:"0 -2px 16px rgba(0,0,0,0.35)", paddingBottom:"env(safe-area-inset-bottom, 0px)"}}>
        <div style={{maxWidth:560, margin:"0 auto", width:"100%", display:"flex", boxSizing:"border-box" as const}}>
          {([
            {key:"inicio",         target:"menu" as const,           label:"Inicio",         ico:(<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M3 11l9-7 9 7M5.5 9.5V19a1 1 0 001 1H9v-5.5h6V20h2.5a1 1 0 001-1V9.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/></svg>)},
            {key:"tareas",         target:"tareas" as const,         label:"Actividades",         ico:(<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M9 6.5h11M9 12h11M9 17.5h11" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/><path d="M4 6.2l1.3 1.3L7 5M4 11.7l1.3 1.3L7 10.5M4 17.2l1.3 1.3L7 16" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/></svg>)},
            {key:"notificaciones", target:"notificaciones" as const, label:"Notificaciones", ico:(<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M6 9a6 6 0 1112 0c0 4.5 2 5.5 2 5.5H4S6 13.5 6 9z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round"/><path d="M10 19a2 2 0 004 0" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/></svg>)},
            {key:"perfil",         target:"perfil" as const,         label:"Perfil",         ico:(<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="8" r="3.6" stroke="currentColor" strokeWidth="1.7"/><path d="M5 20c0-3.6 3.1-6.4 7-6.4s7 2.8 7 6.4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/></svg>)},
          ] as const).map(it => {
            const activo = barraActiva===it.key;
            return (
              <button key={it.key} onClick={()=>setPantalla(it.target)}
                style={{flex:1, display:"flex", flexDirection:"column" as const, alignItems:"center", gap:3, background:"transparent", border:"none", cursor:"pointer", padding:"8px 2px 10px", position:"relative" as const, fontFamily:fontSans}}>
                {activo && <span style={{position:"absolute" as const, top:0, width:24, height:3, borderRadius:"0 0 3px 3px", background:NV.gold}}/>}
                {it.key==="notificaciones" && hayNoLeidos && (
                  <span style={{position:"absolute" as const, top:5, left:"calc(50% + 7px)", width:9, height:9, borderRadius:"50%", background:NV.gold, border:"1.5px solid #0B1829"}}/>
                )}
                <span style={{color:activo?NV.gold:"rgba(236,230,216,0.5)", display:"inline-flex"}}>{it.ico}</span>
                <span style={{fontSize:9.5, fontWeight:activo?700:600, color:activo?NV.gold:"rgba(236,230,216,0.5)", letterSpacing:"0.2px"}}>{it.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}

// ─── PANTALLA DE BIENVENIDA ──────────────────────────────────────────────────
// Capa nueva y aislada: primera pantalla para no-logueados reales. Dos caminos:
// Empresa → landing freemium; Trabajador → login directo. No toca auth ni roles.
function BienvenidaScreen({onEmpresa, onTrabajador, fontSans, fontSerif, gold}: {
  onEmpresa:()=>void; onTrabajador:()=>void; fontSans:string; fontSerif:string; gold:string;
}) {
  const isMobile = window.innerWidth < 768;
  // Oculta el búho de AXIOR mientras la bienvenida está en pantalla (sigue intacto
  // en las demás vistas). Reusa el mismo mecanismo de eventos que el portal.
  useEffect(() => {
    try { window.dispatchEvent(new CustomEvent("axior:ocultar")); } catch(e){}
    return () => { try { window.dispatchEvent(new CustomEvent("axior:mostrar")); } catch(e){} };
  }, []);
  // Vitrina "Conoce la plataforma" (carrusel local; no toca el routing de App).
  const [verVitrina, setVerVitrina] = useState(false);
  const [vitSlide, setVitSlide] = useState(0);
  const vitTouch = useRef<number|null>(null);
  // Fondo EXACTO del logo.png (#05152E) para que su recuadro se funda sin borde.
  const FONDO = "#05152E";
  const NV = { bg:FONDO, panel:"#11233F", panelHov:"#15294A", line:"rgba(184,147,42,0.22)", lineHov:"rgba(212,168,67,0.55)",
    gold:"#D4A843", ink:"#ECE6D8", inkSoft:"rgba(236,230,216,0.66)", inkMut:"rgba(236,230,216,0.42)", iconBg:"rgba(184,147,42,0.10)", iconBd:"rgba(184,147,42,0.32)" };
  const waSoporte = (texto:string)=>{ const url=`https://wa.me/524494251128?text=${encodeURIComponent(texto)}`; try{ window.open(url,"_blank","noopener,noreferrer"); }catch(e){ window.location.href=url; } };

  const icoEmpresa = (<svg width="34" height="34" viewBox="0 0 24 24" fill="none"><path d="M4 21V6.5a1 1 0 011-1h7a1 1 0 011 1V21" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><path d="M13 21V10.5a1 1 0 011-1h5a1 1 0 011 1V21" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><path d="M2.5 21h19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M6.5 9h2.5M6.5 12h2.5M6.5 15h2.5M16 13h1.5M16 16h1.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>);
  const icoTrabajador = (<svg width="34" height="34" viewBox="0 0 24 24" fill="none"><rect x="3.5" y="4.5" width="17" height="15" rx="2.5" stroke="currentColor" strokeWidth="1.5"/><circle cx="9" cy="10.5" r="2.2" stroke="currentColor" strokeWidth="1.5"/><path d="M5.6 16c.4-1.7 1.8-2.6 3.4-2.6s3 .9 3.4 2.6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M14.5 9.5h3.5M14.5 12.5h3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>);
  const icoAyuda = (<svg width="26" height="26" viewBox="0 0 24 24" fill="none"><path d="M5 13a7 7 0 0114 0" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/><rect x="3.5" y="13" width="3.5" height="6" rx="1.5" stroke="currentColor" strokeWidth="1.6"/><rect x="17" y="13" width="3.5" height="6" rx="1.5" stroke="currentColor" strokeWidth="1.6"/><path d="M19 19v1a2.5 2.5 0 01-2.5 2.5H13" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/></svg>);

  // Destellos dorados sutiles alrededor del ícono (posición en % del halo).
  const destellos = [
    {t:"8%", l:"50%", s:2.5, o:0.55}, {t:"24%", l:"85%", s:2, o:0.4}, {t:"52%", l:"95%", s:3, o:0.5},
    {t:"80%", l:"82%", s:2, o:0.38}, {t:"88%", l:"42%", s:2.5, o:0.48}, {t:"60%", l:"6%", s:2, o:0.42}, {t:"24%", l:"14%", s:2.5, o:0.5},
  ];
  const tarjeta = (ico:React.ReactNode, titulo:string, desc:string, cta:string, onClick:()=>void) => {
    const btn = (
      <button onClick={onClick}
        onMouseEnter={(e)=>{ e.currentTarget.style.filter="brightness(1.08)"; }}
        onMouseLeave={(e)=>{ e.currentTarget.style.filter="none"; }}
        style={{width:"100%", display:"inline-flex", alignItems:"center", justifyContent:"center", gap:8, background:`linear-gradient(135deg,${NV.gold},#B8932A)`, color:"#0B1829", border:"none", borderRadius:11, padding:isMobile?"10px 12px":"13px 14px", cursor:"pointer", fontSize:12.5, fontWeight:800, letterSpacing:"0.5px", fontFamily:fontSans, textTransform:"uppercase" as const, boxShadow:"0 4px 16px rgba(184,147,42,0.30)"}}>
        {cta} <span style={{fontSize:15}}>→</span>
      </button>
    );
    // ── MÓVIL: layout horizontal compacto (ícono izq + texto der, botón abajo) ──
    if (isMobile) {
      return (
        <div style={{display:"flex", flexDirection:"column" as const, background:NV.panel, border:`1px solid ${NV.line}`, borderRadius:16, padding:"10px 12px", boxShadow:"0 8px 28px rgba(0,0,0,0.35)"}}>
          <div style={{display:"flex", alignItems:"center", gap:12, marginBottom:9}}>
            <div style={{position:"relative" as const, display:"flex", alignItems:"center", justifyContent:"center", width:56, height:56, flexShrink:0}}>
              <div style={{position:"absolute" as const, inset:0, borderRadius:"50%", background:"radial-gradient(circle, rgba(184,147,42,0.12) 0%, rgba(184,147,42,0.04) 52%, transparent 70%)"}}/>
              {destellos.map((d,i)=>(<span key={i} style={{position:"absolute" as const, top:d.t, left:d.l, width:d.s*0.7, height:d.s*0.7, borderRadius:"50%", background:NV.gold, opacity:d.o, transform:"translate(-50%,-50%)", boxShadow:`0 0 ${d.s}px rgba(212,168,67,0.5)`}}/>))}
              <div style={{position:"relative" as const, width:42, height:42, borderRadius:"50%", display:"flex", alignItems:"center", justifyContent:"center", background:NV.iconBg, border:`1px solid ${NV.iconBd}`, color:NV.gold}}>
                <span style={{display:"inline-flex", transform:"scale(0.6)"}}>{ico}</span>
              </div>
            </div>
            <div style={{flex:1, minWidth:0, textAlign:"left" as const}}>
              <div style={{fontFamily:fontSerif, fontSize:16, fontWeight:700, color:NV.ink, letterSpacing:"0.5px"}}>{titulo}</div>
              <p style={{fontSize:11.5, color:NV.inkSoft, lineHeight:1.4, margin:"3px 0 0"}}>{desc}</p>
            </div>
          </div>
          {btn}
        </div>
      );
    }
    // ── ESCRITORIO: layout vertical (sin cambios) ──
    return (
      <div style={{flex:1, minWidth:0, display:"flex", flexDirection:"column" as const, alignItems:"center", textAlign:"center" as const,
        background:NV.panel, border:`1px solid ${NV.line}`, borderRadius:18, padding:"26px 20px", boxShadow:"0 8px 28px rgba(0,0,0,0.35)"}}>
        <div style={{position:"relative" as const, display:"flex", alignItems:"center", justifyContent:"center", width:120, height:120, marginBottom:12}}>
          <div style={{position:"absolute" as const, inset:0, borderRadius:"50%", background:"radial-gradient(circle, rgba(184,147,42,0.12) 0%, rgba(184,147,42,0.04) 52%, transparent 70%)"}}/>
          {destellos.map((d,i)=>(<span key={i} style={{position:"absolute" as const, top:d.t, left:d.l, width:d.s, height:d.s, borderRadius:"50%", background:NV.gold, opacity:d.o, transform:"translate(-50%,-50%)", boxShadow:`0 0 ${d.s}px rgba(212,168,67,0.5)`}}/>))}
          <div style={{position:"relative" as const, width:78, height:78, borderRadius:"50%", display:"flex", alignItems:"center", justifyContent:"center",
            background:NV.iconBg, border:`1px solid ${NV.iconBd}`, color:NV.gold}}>
            <span style={{display:"inline-flex"}}>{ico}</span>
          </div>
        </div>
        <div style={{fontFamily:fontSerif, fontSize:22, fontWeight:700, color:NV.ink, letterSpacing:"0.5px"}}>{titulo}</div>
        <div style={{width:34, height:2, background:NV.gold, opacity:0.6, borderRadius:2, margin:"10px 0 12px"}}/>
        <p style={{fontSize:12.5, color:NV.inkSoft, lineHeight:1.45, margin:"0 0 20px", flex:1}}>{desc}</p>
        {btn}
      </div>
    );
  };

  // ════════════ VITRINA "Conoce la plataforma" (carrusel deslizable) ════════════
  // Reutiliza el copy de funciones (sin badges GRATIS/PRO ni lógica de planes).
  const SLIDES:any[] = [
    {buho:true, titulo:"Tu respaldo legal preventivo", desc:"AXIS Legaltech es la plataforma con aplicación móvil que mantiene tu empresa en orden y protegida: documentos, empleados y obligaciones bajo control, antes de que un descuido se vuelva un problema. Como tener a tu abogado dentro del teléfono."},
    {titulo:"Todo tu papeleo en un lugar", desc:"Expedientes de empleados, contratos y vehículos, siempre a la mano.",
      ico:(<svg width="40" height="40" viewBox="0 0 24 24" fill="none"><path d="M6 3h8l4 4v13a1 1 0 01-1 1H6a1 1 0 01-1-1V4a1 1 0 011-1z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><path d="M13 3v5h5M8.5 13h7M8.5 16.5h5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>)},
    {titulo:"Empleados y nómina", desc:"Expediente, recibos y cumplimiento de cada colaborador.",
      ico:(<svg width="40" height="40" viewBox="0 0 24 24" fill="none"><circle cx="9" cy="8" r="3" stroke="currentColor" strokeWidth="1.5"/><path d="M3.5 19c0-3 2.5-5 5.5-5s5.5 2 5.5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M16 6.5a2.7 2.7 0 010 5M17.5 19c0-2.2-.9-3.8-2.4-4.6" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/></svg>)},
    {titulo:"Calendario empresarial", desc:"Obligaciones fiscales y laborales, y los eventos de tu equipo.",
      ico:(<svg width="40" height="40" viewBox="0 0 24 24" fill="none"><rect x="3.5" y="5" width="17" height="16" rx="2.5" stroke="currentColor" strokeWidth="1.5"/><path d="M3.5 9.5h17M8 3.2v3.2M16 3.2v3.2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>)},
    {titulo:"Control de flotilla", desc:"Salidas, regresos e historial de tus vehículos.",
      ico:(<svg width="40" height="40" viewBox="0 0 24 24" fill="none"><path d="M3.5 13l1.4-4.2A2 2 0 016.8 7.5h10.4a2 2 0 011.9 1.3L20.5 13v4.5a1 1 0 01-1 1h-1a1 1 0 01-1-1V17H6.5v.5a1 1 0 01-1 1h-1a1 1 0 01-1-1z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><path d="M3.5 13h17" stroke="currentColor" strokeWidth="1.5"/><circle cx="7.5" cy="15.2" r="1" fill="currentColor"/><circle cx="16.5" cy="15.2" r="1" fill="currentColor"/></svg>)},
    {titulo:"Generador legal", desc:"Contratos, avisos, consentimientos y títulos de crédito.",
      ico:(<svg width="40" height="40" viewBox="0 0 24 24" fill="none"><path d="M7 3h7l4 4v14a1 1 0 01-1 1H7a1 1 0 01-1-1V4a1 1 0 011-1z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><path d="M13 3v5h5" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><path d="M9.5 14.5l1.7 1.7 3.3-3.4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>)},
    {titulo:"Calculadora LFT", desc:"Liquidación, finiquito, aguinaldo y vacaciones al instante.",
      ico:(<svg width="40" height="40" viewBox="0 0 24 24" fill="none"><rect x="5" y="3" width="14" height="18" rx="2" stroke="currentColor" strokeWidth="1.5"/><rect x="8" y="6" width="8" height="3" rx="0.6" stroke="currentColor" strokeWidth="1.4"/><path d="M8.5 13h.01M12 13h.01M15.5 13h.01M8.5 16.5h.01M12 16.5h.01M15.5 16.5h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>)},
    {titulo:"Diagnóstico regulatorio", desc:"Conoce tu nivel de cumplimiento por sector.",
      ico:(<svg width="40" height="40" viewBox="0 0 24 24" fill="none"><path d="M12 3l7 3v5c0 4.5-3 8.5-7 10-4-1.5-7-5.5-7-10V6z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>)},
    {buho:true, titulo:"AXIOR, tu asistente legal", desc:"Inteligencia artificial que responde tus dudas legales cuando las tengas."},
    {cta:true, titulo:"Empieza ahora", desc:"Gestiona tu empresa con respaldo legal, desde tu teléfono."},
  ];
  const vitTotal = SLIDES.length;
  const vitNext = ()=> setVitSlide(i=>Math.min(i+1, vitTotal-1));
  const vitPrev = ()=> setVitSlide(i=>Math.max(i-1, 0));
  const cerrarVitrina = ()=>{ setVerVitrina(false); setVitSlide(0); };

  if (verVitrina) {
    const s = SLIDES[Math.max(0, Math.min(vitSlide, vitTotal-1))];
    return (
      <div style={{position:"relative" as const, minHeight:"100vh", background:FONDO, fontFamily:fontSans, display:"flex", flexDirection:"column" as const, boxSizing:"border-box" as const, padding:"14px 16px 20px", overflow:"hidden"}}>
        {/* Líneas doradas MUY sutiles de fondo (como el header del portal) */}
        <svg style={{position:"absolute" as const, inset:0, width:"100%", height:"100%", opacity:0.5, pointerEvents:"none" as const}} viewBox="0 0 400 800" preserveAspectRatio="none" fill="none">
          <path d="M-20 120 Q 200 40 430 150" stroke="rgba(212,168,67,0.07)" strokeWidth="1"/>
          <path d="M-20 320 Q 180 240 430 350" stroke="rgba(212,168,67,0.05)" strokeWidth="1"/>
          <path d="M-20 560 Q 220 480 430 600" stroke="rgba(212,168,67,0.05)" strokeWidth="1"/>
        </svg>
        {/* Barra superior: volver (izq) + saltar directo al login (der) */}
        <div style={{position:"relative" as const, zIndex:1, display:"flex", alignItems:"center", justifyContent:"space-between", gap:10}}>
          <button onClick={cerrarVitrina}
            style={{display:"inline-flex", alignItems:"center", gap:6, background:"transparent", border:"none", color:NV.gold, cursor:"pointer", fontFamily:fontSans, fontSize:13, fontWeight:700, padding:0}}>
            <span style={{fontSize:16, lineHeight:1}}>‹</span> Volver
          </button>
          <button onClick={onEmpresa}
            style={{display:"inline-flex", alignItems:"center", gap:5, background:"transparent", border:`1px solid ${NV.line}`, color:NV.inkSoft, cursor:"pointer", fontFamily:fontSans, fontSize:12, fontWeight:700, borderRadius:999, padding:"6px 13px"}}>
            Saltar <span style={{fontSize:14, lineHeight:1}}>→</span>
          </button>
        </div>

        {/* Slide (una función por pantalla; swipe o flechas) */}
        <div
          onTouchStart={(e)=>{ vitTouch.current = e.touches[0]?.clientX ?? null; }}
          onTouchEnd={(e)=>{ const x0=vitTouch.current; const x1=e.changedTouches[0]?.clientX ?? null; if (x0!=null && x1!=null){ const dx=x1-x0; if (dx<-45) vitNext(); else if (dx>45) vitPrev(); } vitTouch.current=null; }}
          style={{position:"relative" as const, zIndex:1, flex:1, display:"flex", flexDirection:"column" as const, alignItems:"center", justifyContent:"center", textAlign:"center" as const, gap:2, padding:"8px 6px", minHeight:0}}>
          <div key={vitSlide} style={{display:"flex", flexDirection:"column" as const, alignItems:"center", gap:14, maxWidth:420, animation:"fadeUp 0.4s cubic-bezier(0.22,1,0.36,1) both"}}>
            {s.buho ? (
              <div style={{position:"relative" as const, display:"flex", alignItems:"center", justifyContent:"center"}}>
                <div style={{position:"absolute" as const, inset:-16, borderRadius:"50%", background:"radial-gradient(circle, rgba(212,168,67,0.16) 0%, transparent 66%)", pointerEvents:"none" as const}}/>
                <AxiorSVG size={isMobile?104:132} expr="atento" view="body"/>
              </div>
            ) : s.cta ? (
              <img src="/logo.png?v=4" alt="AXIS Legaltech" style={{width:isMobile?150:200, maxWidth:"70%", height:"auto", display:"block", margin:"-6px 0"}}/>
            ) : (
              <div style={{position:"relative" as const, display:"flex", alignItems:"center", justifyContent:"center"}}>
                <div style={{position:"absolute" as const, inset:-10, borderRadius:"50%", background:"radial-gradient(circle, rgba(212,168,67,0.18) 0%, transparent 68%)", pointerEvents:"none" as const}}/>
                <div style={{position:"relative" as const, width:96, height:96, borderRadius:"50%", display:"flex", alignItems:"center", justifyContent:"center", background:"linear-gradient(145deg, rgba(212,168,67,0.14), rgba(184,147,42,0.03))", border:`1px solid ${NV.iconBd}`, color:NV.gold, boxShadow:"inset 0 1px 0 rgba(212,168,67,0.25)"}}>{s.ico}</div>
              </div>
            )}
            <h2 style={{fontFamily:fontSerif, fontSize:isMobile?25:30, fontWeight:700, color:NV.ink, margin:"6px 0 0", lineHeight:1.15}}>{s.titulo}</h2>
            <div style={{width:40, height:2, background:NV.gold, opacity:0.6, borderRadius:2}}/>
            <p style={{fontSize:isMobile?14:15, color:NV.inkSoft, lineHeight:1.55, margin:0}}>{s.desc}</p>

            {s.cta && (
              <div style={{display:"flex", flexDirection:"column" as const, gap:10, width:"100%", marginTop:14}}>
                <button onClick={onEmpresa}
                  style={{width:"100%", display:"inline-flex", alignItems:"center", justifyContent:"center", gap:8, background:`linear-gradient(135deg,${NV.gold},#B8932A)`, color:"#0B1829", border:"none", borderRadius:12, padding:"14px 16px", cursor:"pointer", fontSize:13, fontWeight:800, letterSpacing:"0.5px", fontFamily:fontSans, textTransform:"uppercase" as const, boxShadow:"0 4px 16px rgba(184,147,42,0.30)"}}>
                  ¿Ya eres cliente? Entra como Empresa <span style={{fontSize:15}}>→</span>
                </button>
                <button onClick={cerrarVitrina}
                  style={{width:"100%", background:"transparent", border:`1px solid ${NV.line}`, color:NV.inkSoft, borderRadius:12, padding:"12px 16px", cursor:"pointer", fontSize:13, fontWeight:700, fontFamily:fontSans}}>
                  Volver al inicio
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Controles: flechas + puntitos */}
        <div style={{position:"relative" as const, zIndex:1, display:"flex", alignItems:"center", justifyContent:"space-between", gap:10, maxWidth:420, width:"100%", margin:"0 auto"}}>
          <button onClick={vitPrev} disabled={vitSlide===0} aria-label="Anterior"
            style={{width:42, height:42, borderRadius:12, border:`1px solid ${NV.line}`, background:NV.panel, color:NV.gold, cursor:vitSlide===0?"default":"pointer", opacity:vitSlide===0?0.3:1, fontSize:18, fontFamily:fontSans, flexShrink:0}}>‹</button>
          <div style={{display:"flex", alignItems:"center", justifyContent:"center", gap:6, flexWrap:"wrap" as const}}>
            {SLIDES.map((_,i)=>(
              <button key={i} onClick={()=>setVitSlide(i)} aria-label={`Ir al paso ${i+1}`}
                style={{width:i===vitSlide?18:8, height:8, borderRadius:999, border:"none", padding:0, cursor:"pointer", background:i===vitSlide?NV.gold:"rgba(236,230,216,0.28)", transition:"width 0.25s, background 0.25s"}}/>
            ))}
          </div>
          <button onClick={vitNext} disabled={vitSlide===vitTotal-1} aria-label="Siguiente"
            style={{width:42, height:42, borderRadius:12, border:`1px solid ${NV.line}`, background:NV.panel, color:NV.gold, cursor:vitSlide===vitTotal-1?"default":"pointer", opacity:vitSlide===vitTotal-1?0.3:1, fontSize:18, fontFamily:fontSans, flexShrink:0}}>›</button>
        </div>
      </div>
    );
  }

  return (
    <div style={{minHeight:"100vh", background:FONDO, fontFamily:fontSans, padding:isMobile?"6px 14px 16px":"40px 24px 48px", boxSizing:"border-box" as const}}>
      <div style={{maxWidth:680, margin:"0 auto"}}>
        {/* Logo (imagen real, sin recuadro: fondo de pantalla = #05152E del PNG) + intro */}
        <div style={{textAlign:"center" as const, marginBottom:isMobile?8:32}}>
          <img src="/logo.png?v=4" alt="AXIS Legaltech" style={{width:isMobile?132:268, maxWidth:"82%", height:"auto", display:"block", margin:isMobile?"-8px auto -8px":"-6px auto -8px"}}/>
          <h1 style={{fontFamily:fontSerif, fontSize:isMobile?20:32, fontWeight:700, color:NV.ink, margin:isMobile?"0 0 4px":"0 0 8px"}}>Bienvenido a AXIS</h1>
          <p style={{fontSize:isMobile?12.5:14, color:NV.inkSoft, margin:0, lineHeight:1.45, maxWidth:380, marginLeft:"auto", marginRight:"auto"}}>Tecnología jurídica para empresas y colaboradores.</p>
          <div style={{display:"flex", alignItems:"center", justifyContent:"center", gap:10, margin:isMobile?"8px auto 0":"22px auto 0", maxWidth:260}}>
            <div style={{flex:1, height:1, background:"linear-gradient(90deg,transparent,rgba(184,147,42,0.5))"}}/>
            <span style={{width:6, height:6, borderRadius:"50%", background:NV.gold, flexShrink:0}}/>
            <div style={{flex:1, height:1, background:"linear-gradient(90deg,rgba(184,147,42,0.5),transparent)"}}/>
          </div>
        </div>

        {/* Elige cómo acceder */}
        <div style={{textAlign:"center" as const, fontSize:isMobile?11:12, fontWeight:700, color:NV.gold, textTransform:"uppercase" as const, letterSpacing:"2px", marginBottom:isMobile?10:16}}>Elige cómo deseas acceder</div>
        <div style={{display:"flex", flexDirection:isMobile?"column" as const:"row" as const, gap:isMobile?9:14, marginBottom:isMobile?12:18}}>
          {tarjeta(icoEmpresa, "EMPRESA", "Gestión legal, empleados, contratos, flotilla, documentos y cumplimiento normativo.", "Acceder como empresa", onEmpresa)}
          {tarjeta(icoTrabajador, "TRABAJADOR", "Consulta actividades, registra asistencia, reporta incidentes y administra tu información.", "Acceder como trabajador", onTrabajador)}
        </div>

        {/* Tercera opción: NO es login, abre la vitrina (carrusel) */}
        <button onClick={()=>{ setVitSlide(0); setVerVitrina(true); }}
          style={{display:"flex", alignItems:"center", justifyContent:"center", gap:9, width:"100%", marginBottom:isMobile?12:18, background:"transparent", border:`1px solid ${NV.line}`, borderRadius:14, padding:isMobile?"12px 14px":"14px 16px", cursor:"pointer", fontFamily:fontSans, color:NV.gold, fontSize:isMobile?13:13.5, fontWeight:700}}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.6"/><path d="M12 11v5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/><circle cx="12" cy="7.6" r="1.1" fill="currentColor"/></svg>
          Conoce la plataforma AXIS Legaltech <span style={{fontSize:15}}>→</span>
        </button>

        {/* Ayuda */}
        <div style={{display:"flex", alignItems:"center", gap:14, background:NV.panel, border:`1px solid ${NV.line}`, borderRadius:16, padding:isMobile?"14px 14px":"16px 20px", flexWrap:"wrap" as const}}>
          <div style={{width:48, height:48, borderRadius:"50%", flexShrink:0, display:"flex", alignItems:"center", justifyContent:"center", background:NV.iconBg, border:`1px solid ${NV.iconBd}`, color:NV.gold}}>{icoAyuda}</div>
          <div style={{flex:1, minWidth:140}}>
            <div style={{fontFamily:fontSerif, fontSize:16, fontWeight:700, color:NV.ink}}>¿Necesitas ayuda?</div>
            <div style={{fontSize:12.5, color:NV.inkSoft, marginTop:1}}>Estamos para apoyarte.</div>
          </div>
          <div style={{display:"flex", alignItems:"center", flexShrink:0}}>
            <button onClick={()=>waSoporte("Hola AXIS, necesito ayuda.")} style={{display:"inline-flex", alignItems:"center", gap:7, background:NV.iconBg, border:`1px solid ${NV.iconBd}`, color:NV.gold, cursor:"pointer", fontFamily:fontSans, fontSize:13, fontWeight:700, borderRadius:10, padding:"9px 14px"}}>
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none"><path d="M5 13a7 7 0 0114 0" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/><rect x="3.5" y="13" width="3.2" height="5.5" rx="1.4" stroke="currentColor" strokeWidth="1.6"/><rect x="17.3" y="13" width="3.2" height="5.5" rx="1.4" stroke="currentColor" strokeWidth="1.6"/></svg> Soporte AXIS
            </button>
          </div>
        </div>

        {/* Pie */}
        <div style={{display:"flex", alignItems:"center", justifyContent:"center", gap:8, marginTop:28, color:NV.inkMut, fontSize:12}}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" style={{color:NV.gold}}><path d="M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6l7-3z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
          Seguro · Confiable · Profesional
        </div>
      </div>
    </div>
  );
}

// ─── PORTAL DEL PATRÓN — MÓVIL (esqueleto Bloque 1) ──────────────────────────
// Vista nativa para celular del usuario patrón/empresa (logueado, no trabajador,
// no anónimo). En escritorio el patrón sigue viendo la suite. Reutiliza
// useDashboardData(currentUser) para datos reales donde ya existen.

// ─── CONTROL DEL REPORTE DE FLOTILLA (app del patrón) ───────────────────────
// UNA implementación, dos puntos de entrada: el catálogo de unidades y la
// bitácora de movimientos. Duplicar sería escribirlo dos veces; esto es el
// mismo control puesto donde el patrón puede estar cuando lo necesita.
//
// El mes va ESCRITO en el propio control. En la bitácora queda a la vista de los
// filtros Desde/Hasta y cualquiera supondría que el reporte respeta ese filtro:
// no lo respeta, cubre un mes completo. Si el mes no se lee sin abrir nada, esa
// confusión se descubre cuando el documento ya salió de la empresa.
function ControlReporteFlotillaMovil({mes, setMes, generando, msg, onGenerar, C, fontSans}: {
  mes:"actual"|"anterior"; setMes:(v:"actual"|"anterior")=>void;
  generando:boolean; msg:string; onGenerar:()=>void; C:any; fontSans:string;
}) {
  const etiqueta = (desplaz:number) => {
    const h = new Date();
    const d = new Date(h.getFullYear(), h.getMonth() + desplaz, 1);
    return `${d.toLocaleDateString("es-MX",{month:"long"})} ${d.getFullYear()}`;
  };
  return (
    <>
      <div style={{display:"flex", alignItems:"center", gap:8, marginBottom:msg?6:14, flexWrap:"wrap" as const}}>
        <select {...CAMPO_DE_PARAMETRO} value={mes} onChange={e=>setMes(e.target.value as any)}
          aria-label="Mes que cubre el reporte"
          style={{flex:"1 1 190px", minWidth:0, boxSizing:"border-box" as const, background:C.panel, border:`1px solid ${C.gold}`,
            color:C.ink, borderRadius:11, padding:"11px 12px", fontSize:12.5, fontWeight:700, fontFamily:fontSans,
            outline:"none", textTransform:"capitalize" as const}}>
          <option value="actual" style={{color:"#0B1829"}}>{`Reporte mensual · ${etiqueta(0)}`}</option>
          <option value="anterior" style={{color:"#0B1829"}}>{`Reporte mensual · ${etiqueta(-1)}`}</option>
        </select>
        <button onClick={onGenerar} disabled={generando}
          style={{flex:"0 0 auto", background:C.gold, border:"none", color:"#0B1829", borderRadius:11, padding:"11px 16px",
            cursor:generando?"wait":"pointer", fontSize:13, fontWeight:700, fontFamily:fontSans, opacity:generando?0.7:1}}>
          {generando ? "Generando…" : "Descargar PDF"}
        </button>
      </div>
      {msg && <div style={{fontSize:12, color:C.inkSoft, margin:"0 0 12px", lineHeight:1.45}}>{msg}</div>}
    </>
  );
}

// EL COLOR DEL PORTAL, EN UNA LÍNEA. Eran tres tarjetas grandes al principio de
// Perfil para algo que se toca una vez. Ahora: "Color" y tres puntos; el actual
// lleva anillo y el nombre sale al pasar el cursor o al tocar. Lo comparten el
// portal del trabajador y el del patrón en el teléfono; cada uno pasa su paleta.
function SelectorColorPortal({acentos, actual, onElegir, tinta, tintaSuave, fontSans}:{acentos:Record<string,any>; actual:string; onElegir:(k:string)=>void; tinta:string; tintaSuave:string; fontSans:string}) {
  const [nombre, setNombre] = useState("");
  return (
    <div data-selector-color="1" style={{display:"flex", alignItems:"center", gap:10, flexWrap:"nowrap" as const, margin:"0 2px 16px", fontFamily:fontSans}}>
      <span style={{fontSize:12, fontWeight:700, color:tintaSuave}}>Color</span>
      <div role="radiogroup" aria-label="Color del portal" style={{display:"flex", alignItems:"center", gap:9}}>
        {Object.keys(acentos).map((k)=>{
          const p = acentos[k]; const on = actual===k;
          return (
            <button key={k} type="button" role="radio" aria-checked={on} aria-label={p.label} title={p.label}
              onClick={()=>{ onElegir(k); setNombre(p.label); }}
              onMouseEnter={()=>setNombre(p.label)} onMouseLeave={()=>setNombre("")}
              onFocus={()=>setNombre(p.label)} onBlur={()=>setNombre("")}
              style={{width:20, height:20, borderRadius:"50%", padding:0, cursor:"pointer", flexShrink:0, background:p.gold,
                border:"2px solid "+(on ? tinta : "transparent"), boxShadow:on ? `0 0 0 2px ${p.gold}` : "none"}}/>
          );
        })}
      </div>
      <span aria-live="polite" style={{fontSize:11.5, color:tintaSuave, whiteSpace:"nowrap" as const}}>{nombre}</span>
    </div>
  );
}

function PortalPatronMovil({currentUser, onLogout, fontSans, fontSerif, gold}: {
  currentUser:any; onLogout:()=>void; fontSans:string; fontSerif:string; gold:string;
}) {
  const [tab, setTab] = useState<"inicio"|"actividad"|"equipo"|"perfil">("inicio");
  useAbrirDesdeAviso("inicio", true, () => setTab("inicio"));
  // EL MISMO ESTADO QUE LA FILA DEL ESCRITORIO, no una copia. El dueño es
  // `ProveedorPuertaAvisos`, que envuelve los dos árboles del patrón; leerlo desde
  // aquí es lo que hace que activar los avisos en el teléfono deje al perfil de la
  // computadora diciendo la verdad en cuanto se abra, y al revés.
  const avisosCtxMv = useContext(CtxPuertaAvisos);
  const estadoAvisosMv = avisosCtxMv ? avisosCtxMv.estado : "no_soportado";
  const activarAvisosMv = avisosCtxMv ? avisosCtxMv.activar : () => {};
  const { refrescar, refrescando, errorRefresco, loading, kpis, atencionUrgente, actividad, cumplimientoTareas, checadasPatron, checadasEfectivas, correccionesPatron, noConformesPatron, flotillaPatron, accidentesPatron, accidentesPendientes, empleados, tareasPatron, vehiculos, horarioGeneral, historialGeneral, registrosVacaciones, cuentasTrab } = useDashboardData(currentUser);
  // Filtros de la pestaña Actividad (todo/orden/fecha en JS sobre lo ya cargado).
  const [actFiltro, setActFiltro] = useState<"todo"|"checadas"|"flotilla"|"accidentes">("todo");
  const [verAnteriores, setVerAnteriores] = useState(false);
  const [actVista, setActVista] = useState<"dia"|"empleado">("dia");
  // La bitácora de flotilla se lee POR VIAJE por defecto: con varios choferes, la
  // lista cronológica parte un viaje de tres días entre decenas de renglones
  // ajenos y deja de poder leerse. "Por movimiento" sigue ahí como vista de
  // AUDITORÍA —para ver captura por captura—, no como una lectura equivalente.
  const [bitVista, setBitVista] = useState<"movimiento"|"viaje">("viaje");
  // Filtros A NIVEL VIAJE: filtrar por conductor devuelve sus viajes completos,
  // no los renglones sueltos que coincidan.
  const [bitTexto, setBitTexto] = useState("");
  const [bitUnidad, setBitUnidad] = useState("");
  const [bitPersona, setBitPersona] = useState("");
  const [bitDesde, setBitDesde] = useState("");
  const [bitHasta, setBitHasta] = useState("");
  const [bitFiltrosAbiertos, setBitFiltrosAbiertos] = useState(false);
  // Detalle de accidente (solo lectura) + lightbox de foto.
  const [accidenteSel, setAccidenteSel] = useState<any|null>(null);
  // Movimiento de flotilla abierto en el detalle. Va como MODAL, no como pantalla,
  // para no meter una vista mas al arbol de navegacion de la app: se cierra
  // pulsando fuera y devuelve al usuario justo donde estaba en la lista.
  const [movFlotaSel, setMovFlotaSel] = useState<any|null>(null);
  // Correos a los que se acota la lista de Equipo al llegar desde el renglón del
  // checador. Vacío = lista completa.
  const [equipoFoco, setEquipoFoco] = useState<string[]>([]);
  // Los MISMOS tres hechos que el escritorio, de la MISMA funcion. Antes esta
  // pantalla calculaba y redactaba lo suyo, y por eso las dos llegaron a decir
  // cosas opuestas sobre el mismo dato.
  // MISMA PREGUNTA QUE EN EL ESCRITORIO —`cuentaVacia`—, sobre los mismos dos
  // contadores, para que las dos pantallas no puedan discrepar sobre si la cuenta
  // esta vacia.
  const cuentaVaciaMv = kpis.registrosActivos.empleados === 0 && kpis.registrosActivos.vehiculos === 0;
  const hechosEquipoMv = useMemo(
    () => hechosDelEquipo(empleados, tareasPatron, checadasEfectivas,
      kpis.registrosActivos.empleados, kpis.empleadosEvaluados, horarioGeneral, cuentasTrab, historialGeneral, registrosVacaciones),
    [empleados, tareasPatron, checadasEfectivas, kpis.registrosActivos.empleados, kpis.empleadosEvaluados, horarioGeneral, cuentasTrab, historialGeneral, registrosVacaciones]);
  const [accFotoAmpliada, setAccFotoAmpliada] = useState<string|null>(null);
  const [accLegalAbierto, setAccLegalAbierto] = useState(true);   // acordeón de pauta legal
  const [actEmpleadoSel, setActEmpleadoSel] = useState<string|null>(null);
  // Pestaña Equipo: empleado seleccionado (ficha), confirmaciones locales y estado de carga.
  const [equipoSel, setEquipoSel] = useState<string|null>(null);
  // SU PANTALLA EN LA DIRECCIÓN (fix/recarga-conserva-pantalla): la pestaña y, en Equipo,
  // la ficha abierta, por su id (nunca el correo en la dirección). Se decide cuando ya
  // hay fichas: una ficha que ya no existe cae a Inicio.
  const _fichaIdMv = (correo: any) => { const c = String(correo || "").toLowerCase(); const e = (empleados || []).find((x: any) => String(x?.email || "").toLowerCase() === c); return e ? String(e.id || "") : ""; };
  const vistaMv = tab === "equipo" && equipoSel && _fichaIdMv(equipoSel) ? "equipo/ficha/" + _fichaIdMv(equipoSel) : tab;
  const { restaurando: restaurandoVistaMv } = useVistaEnLaDireccion({principal: "inicio", mostrada: vistaMv, listo: !loading, aplicar: (v) => {
    const p = v.split("/");
    if (p.length === 1 && VISTAS_DEL_PATRON_MOVIL.indexOf(p[0]) >= 0) { irATab(p[0] as any); return "ok"; }
    if (p.length === 3 && p[0] === "equipo" && p[1] === "ficha") {
      // Si la carga falló, no se puede saber si la ficha sigue: a Inicio.
      if (errorRefresco) return "invalida";
      const e = (empleados || []).find((x: any) => String(x?.id || "") === p[2]);
      if (!e || !String(e.email || "").trim()) return "invalida";
      irATab("equipo"); setEquipoSel(String(e.email).toLowerCase());
      return "ok";
    }
    return "invalida";
  }});
  // Sub-vista dentro de EQUIPO: lista de empleados o gestión central de actividades.
  const [equipoVista, setEquipoVista] = useState<"empleados"|"tareas">("empleados");
  // Filtros de la vista central de actividades (móvil): empleado / estado / vencimiento.
  const [mvTFEmp, setMvTFEmp] = useState<string>("");
  const [mvTFEstado, setMvTFEstado] = useState<"todos"|"pendiente"|"por_confirmar"|"confirmada">("todos");
  const [mvTFFecha, setMvTFFecha] = useState<"todas"|"vencidas"|"semana">("todas");
  const [equipoConfirmadas, setEquipoConfirmadas] = useState<Record<string,boolean>>({});
  const [equipoConfirmando, setEquipoConfirmando] = useState<string|null>(null);
  // Crear/editar tareas desde la ficha (refresco local; useDashboardData carga una vez).
  const [tareasNuevas, setTareasNuevas] = useState<any[]>([]);
  const [tareasEditadas, setTareasEditadas] = useState<Record<string,any>>({});
  const [tareaForm, setTareaForm] = useState<null|{modo:"crear"|"editar"; id?:string; titulo:string; descripcion:string; fechaLimite:string; horario:string; trabajadorEmail?:string}>(null);
  const [tareaGuardando, setTareaGuardando] = useState(false);
  const [tareaErr, setTareaErr] = useState("");
  // Pantalla Calendario (solo lectura): mes visible, día seleccionado y filtro.
  const [verCalendario, setVerCalendario] = useState(false);
  const [verFlotilla, setVerFlotilla] = useState(false);          // ventana Flotilla (solo lectura)
  // REPORTE MENSUAL DE FLOTILLA, también aquí. El reporte mensual de empleados
  // ya se ofrece desde la app —vive en la ficha del empleado—, así que dejar el
  // de flotilla solo en escritorio sería una diferencia sin razón entre dos
  // documentos que se generan con el MISMO generador.
  const [mesRepFlotaMv, setMesRepFlotaMv] = useState<"actual"|"anterior">("actual");
  const [generandoRepFlotaMv, setGenerandoRepFlotaMv] = useState(false);
  const [msgRepFlotaMv, setMsgRepFlotaMv] = useState("");
  const etiquetaMesRepMv = (desplaz:number) => {
    const h = new Date();
    const d = new Date(h.getFullYear(), h.getMonth() + desplaz, 1);
    return `${d.toLocaleDateString("es-MX",{month:"long"})} ${d.getFullYear()}`;
  };
  const generarReporteFlotillaMv = async () => {
    if (generandoRepFlotaMv) return;
    setGenerandoRepFlotaMv(true); setMsgRepFlotaMv("");
    try {
      const hoy = new Date();
      const objetivo = mesRepFlotaMv === "actual"
        ? new Date(hoy.getFullYear(), hoy.getMonth(), 1)
        : new Date(hoy.getFullYear(), hoy.getMonth()-1, 1);
      const anio = objetivo.getFullYear(), mes = objetivo.getMonth();
      // Mismo candado y misma fuente que el reporte de escritorio.
      let cfgP:any = null;
      try { cfgP = await leerConfigEmpresa(currentUser.uid); } catch(e){}
      if (!datosPatronCompletos(cfgP)) {
        // En el telefono se dice DONDE se capturan, porque esa pantalla no existe aqui.
        setMsgRepFlotaMv("Faltan los datos de tu empresa. Se capturan desde una computadora, en Datos de mi empresa.");
        setGenerandoRepFlotaMv(false); return;
      }
      const empresa = datosPatronDe(cfgP).denominacion;
      const d = datosReporteFlotilla({registros: flotillaPatron||[], vehiculos: vehiculos||[], anio, mes});
      const html = construirReporteFlotillaHTML({
        empresa, rfc: datosPatronDe(cfgP).rfc, domicilio: domicilioPatronTexto(datosPatronDe(cfgP)),
        mes: mesLargoAxis(anio, mes),
        generadoPor: currentUser?.displayName || currentUser?.email || "—",
        generadoEn: fechaHoraLargaAxis(),
        d,
      });
      await generarPDFDesdeHTML(html, `reporte-flotilla-${anio}-${String(mes+1).padStart(2,"0")}.pdf`);
      setMsgRepFlotaMv("PDF generado (revisa tus descargas).");
    } catch(e:any) {
      console.error("reporte-flotilla (app):", e);
      setMsgRepFlotaMv("No se pudo generar: " + (e?.message || "error"));
    } finally { setGenerandoRepFlotaMv(false); }
  };
  const [flotillaFoco, setFlotillaFoco] = useState<string>("");   // id del vehículo a resaltar (desde la alerta)
  const [flotillaAbierto, setFlotillaAbierto] = useState<string>(""); // id del vehículo expandido (acordeón: uno a la vez)
  const [flotillaFiltro, setFlotillaFiltro] = useState<"todos"|"pendientes">("todos"); // filtro mínimo de la lista
  const flotillaFocoRef = useRef<HTMLDivElement|null>(null);      // tarjeta a la que hacer scroll al abrir con foco
  // Solo el apagado: el scroll lo hace el efecto de abajo, que espera a que la
  // tarjeta se expanda. Sin ref, `useResaltado` no desplaza nada.
  const _resUnidad = useResaltado(flotillaFoco || null);
  const [calY, setCalY] = useState(()=> new Date().getFullYear());
  const [calM, setCalM] = useState(()=> new Date().getMonth());
  const [calDiaSel, setCalDiaSel] = useState<string|null>(null);
  const [calFiltro, setCalFiltro] = useState<"todo"|"legal"|"vencimientos"|"empresa">("todo");
  const [verAsuetos, setVerAsuetos] = useState(false);   // hoja de días de descanso obligatorio
  // Compositor unificado de comunicados: aviso (sin fecha) o evento (con fecha).
  const [verAviso, setVerAviso] = useState(false);
  const [avisoModo, setAvisoModo] = useState<"aviso"|"evento">("aviso");
  const [avisoTitulo, setAvisoTitulo] = useState("");
  const [avisoMensaje, setAvisoMensaje] = useState("");
  const [avisoFecha, setAvisoFecha] = useState("");
  const [avisoHora, setAvisoHora] = useState("");
  const [avisoLugar, setAvisoLugar] = useState("");
  // Adjunto OPCIONAL del comunicado (foto/escaneo o PDF, p.ej. una circular).
  // Se sube a Storage 'comunicados/{empleadorId}/' con SubirArchivoBtn y se guardan
  // como campos nuevos del doc: adjuntoUrl / adjuntoTipo ("imagen"|"pdf") / adjuntoNombre.
  const [avisoAdjuntoUrl, setAvisoAdjuntoUrl] = useState("");
  const [avisoAdjuntoTipo, setAvisoAdjuntoTipo] = useState("");
  const [avisoAdjuntoNombre, setAvisoAdjuntoNombre] = useState("");
  const [avisoEnviando, setAvisoEnviando] = useState(false);
  const [avisoOk, setAvisoOk] = useState(false);
  const [avisoOkEvento, setAvisoOkEvento] = useState(false);   // tipo enviado (para el mensaje de éxito)
  const [avisoEditId, setAvisoEditId] = useState<string|null>(null);   // si != null, el compositor edita ese doc
  const [avisoOkEdit, setAvisoOkEdit] = useState(false);       // último guardado fue edición
  const [comunicadoBorrando, setComunicadoBorrando] = useState<string|null>(null);
  const [avisoErr, setAvisoErr] = useState("");
  // Comunicados del patrón (avisos + eventos) — un where por empleadorId, filtra en JS.
  const [comunicados, setComunicados] = useState<any[]>([]);
  // Acceso rápido a la Calculadora LFT (NominaModulo) como overlay del portal.
  const [verCalculadora, setVerCalculadora] = useState(false);
  const [verHorarioConfig, setVerHorarioConfig] = useState(false);   // ventana de horario+ubicación
  // Lo visto de las actualizaciones, en la cuenta (vale en todos los aparatos).
  const novedadesMv = useNovedadesVistas(currentUser?.uid);
  // Modal legal reutilizable (Aviso de Privacidad / Aviso legal) para el Perfil.
  const [legalModal, setLegalModal] = useState<null|"privacidad"|"disclaimer">(null);
  // Nombre de empresa, leído de usuarios/{uid}. Editable (setDoc merge).
  const [empresaNombre, setEmpresaNombre] = useState<string>("");
  // Perfil del patrón: foto (usuarios/{uid}.fotoPerfilUrl) y puesto (usuarios/{uid}.puesto).
  const [fotoPerfilUrl, setFotoPerfilUrl] = useState<string>("");
  const [diasAgMv, setDiasAgMv] = useState(15);   // para el contexto de AXIOR
  const [puesto, setPuesto] = useState<string>("");
  const [puestoEdit, setPuestoEdit] = useState(false);
  const [puestoInput, setPuestoInput] = useState("");
  const [puestoGuardando, setPuestoGuardando] = useState(false);
  const [puestoOk, setPuestoOk] = useState(false);
  // WhatsApp de contacto del patrón (lo usan sus trabajadores desde Flotilla).
  const [waPat, setWaPat] = useState<string>("");
  const [waEdit, setWaEdit] = useState(false);
  const [waInput, setWaInput] = useState("");
  const [waGuardando, setWaGuardando] = useState(false);
  const [waOk, setWaOk] = useState(false);
  // Oculta SOLO el lanzador flotante de AXIOR mientras este portal está montado
  // (el chat se abre desde el botón del header). Al salir, se restaura.
  useEffect(() => {
    try { window.dispatchEvent(new CustomEvent("axior:ocultarLanzador")); } catch(e){}
    return () => { try { window.dispatchEvent(new CustomEvent("axior:mostrarLanzador")); } catch(e){} };
  }, []);
  const abrirAxior = () => { try { window.dispatchEvent(new CustomEvent("axior:abrir")); } catch(e){} };
  // Flotilla: al abrir la ventana con un vehículo enfocado (desde la alerta "Qué
  // atender hoy"), ese vehículo llega EXPANDIDO y se hace scroll para que quede a la
  // vista. Sin foco (acceso desde el Inicio) la lista abre colapsada, filtro "Todos".
  useEffect(() => {
    if (!verFlotilla || !flotillaFoco) return;
    setFlotillaFiltro("todos");
    setFlotillaAbierto(flotillaFoco);
    const t = setTimeout(() => { try { flotillaFocoRef.current?.scrollIntoView({behavior:"smooth", block:"center"}); } catch(e){} }, 90);
    return () => clearTimeout(t);
  }, [verFlotilla, flotillaFoco]);
  // Contactar a AXIS por WhatsApp (mismo mecanismo y número que el portal del trabajador).
  const abrirWhatsAppAXIS = () => {
    const msg = `Hola AXIS, soy ${currentUser?.displayName || (currentUser?.email||"")} y necesito apoyo.`;
    const url = `https://wa.me/524494251128?text=${encodeURIComponent(msg)}`;
    try { window.open(url, "_blank", "noopener,noreferrer"); } catch(e){ window.location.href = url; }
  };

  // Carga los comunicados del patrón (avisos + eventos). Recargable tras publicar.
  const cargarComunicados = async () => {
    if (!currentUser?.uid) return;
    try {
      const snap = await getDocs(query(collection(db,"comunicados"), where("empleadorId","==",currentUser.uid)));
      setComunicados(snap.docs.map(d=>({id:d.id,...(d.data() as any)})));
    } catch(e){ console.error("comunicados patron read:", e); }
  };
  useEffect(() => { cargarComunicados(); /* eslint-disable-next-line */ }, [currentUser?.uid]);

  // Lee el doc del patrón (usuarios/{uid}) para el nombre de empresa, si está guardado.
  useEffect(() => {
    if (!currentUser?.uid) return;
    let cancel = false;
    (async () => {
      try {
        const snap = await getDoc(doc(db,"usuarios",currentUser.uid));
        if (cancel || !snap.exists()) return;
        const d:any = snap.data() || {};
        // La denominación ya no vive aquí: ver la nota del perfil de escritorio.
        setFotoPerfilUrl(d.fotoPerfilUrl || "");
        setPuesto((d.puesto || "").trim());
        setWaPat((d.whatsapp || "").trim());
        const nAg = Number(d.diasAguinaldo); if (Number.isFinite(nAg) && nAg > 0) setDiasAgMv(nAg);
      } catch(e){ console.error("usuarios read:", e); }
    })();
    // La denominación, de la fuente. AXIOR la sigue recibiendo por `empresaNombre`.
    (async () => {
      try { const cfg = await leerConfigEmpresa(currentUser.uid); if (!cancel) setEmpresaNombre(datosPatronDe(cfg).denominacion); }
      catch(e){ /* queda vacía */ }
    })();
    return ()=>{ cancel = true; };
  }, [currentUser?.uid]);

  // Publica para AXIOR el resumen de la cuenta con los datos YA cargados en el portal
  // (sin consultas nuevas). Multi-tenant: etiquetado con el uid del patrón.
  useEffect(() => {
    if (!currentUser?.uid) { publicarContextoAxior("", ""); return; }
    try {
      publicarContextoAxior(currentUser.uid, construirContextoAxior({
        empresa: empresaNombre, empleados: empleados||[], kpis, atencionUrgente: atencionUrgente||[],
        actividad, tareasPatron: tareasPatron||[], checadasPatron: checadasEfectivas||[],
        cumplimientoTareas, diasAg: diasAgMv, hoy: new Date(), horarioGeneral, historialGeneral, registrosVacaciones,
      }));
    } catch(e){ console.error("contexto AXIOR (móvil):", e); }
  }, [currentUser?.uid, empleados, kpis, atencionUrgente, actividad, tareasPatron, checadasEfectivas, cumplimientoTareas, diasAgMv, empresaNombre, horarioGeneral, historialGeneral, registrosVacaciones]);

  // AQUÍ TAMPOCO SE ESCRIBE LA EMPRESA, por lo mismo que en el perfil de
  // escritorio: la denominación va con el RFC, el domicilio y el correo de
  // contacto, y se capturan juntos en "Datos de mi empresa".
  //
  // PENDIENTE CONOCIDO: esta pantalla es el portal móvil del patrón, que no pasa
  // por las rutas de `appPantalla`, así que desde el teléfono la denominación se
  // VE pero no se captura. Está dicho en la propia pantalla.

  // Guarda el PUESTO del patrón (merge, no pisa otros campos de usuarios/{uid}).
  const guardarPuesto = async () => {
    if (!currentUser?.uid) return;
    const val = puestoInput.trim();
    setPuestoGuardando(true);
    try {
      await updateDoc(doc(db,"usuarios",currentUser.uid), { puesto: val });
      setPuesto(val); setPuestoEdit(false); setPuestoOk(true);
    } catch(e){ console.error("usuarios puesto write:", e); alert("No se pudo guardar el puesto. Intenta de nuevo."); }
    finally { setPuestoGuardando(false); }
  };
  // Guarda el WhatsApp y lo propaga a las cuentas de sus trabajadores (así lo ven
  // en Flotilla). Solo dígitos; 10 dígitos se asumen de México.
  const guardarWhatsapp = async () => {
    if (!currentUser?.uid) return;
    const val = waInput.replace(/\D/g, "");
    setWaGuardando(true);
    try {
      await guardarWhatsappPatron(currentUser.uid, val);
      setWaPat(val); setWaEdit(false); setWaOk(true);
    } catch(e){ console.error("whatsapp patron write:", e); alert("No se pudo guardar el WhatsApp. Intenta de nuevo."); }
    finally { setWaGuardando(false); }
  };
  // Persiste la foto de perfil del patrón (ya subida a Storage por SubirArchivoBtn).
  // Defensivo: si la escritura falla, la foto ya subió y se ve local; no rompe el perfil.
  const guardarFotoPerfil = async (url:string) => {
    setFotoPerfilUrl(url);
    if (!currentUser?.uid) return;
    try {
      await updateDoc(doc(db,"usuarios",currentUser.uid), { fotoPerfilUrl: url });
      try { window.dispatchEvent(new CustomEvent("perfil:foto", {detail:url})); } catch(e){}
    } catch(e){ console.error("usuarios foto write:", e); alert("La foto se subió pero no se pudo guardar. Intenta de nuevo."); }
  };

  const nombre = currentUser?.displayName || (currentUser?.email||"").split("@")[0] || "Patrón";
  const correo = (currentUser?.email||"");
  const iniciales = (nombre||"").trim().split(/\s+/).slice(0,2).map((s:string)=>s[0]||"").join("").toUpperCase() || "AX";

  // ── Acento del portal (personalización local por usuario) ───────────────────
  // Solo cambia el COLOR DE ACENTO; navy y estructura intactos. Default = dorado
  // (valores idénticos a los de hoy). Sin backend: se guarda en localStorage.
  const ACENTOS: Record<string,{label:string; gold:string; goldDim:string; rgbDim:string; rgbBright:string}> = {
    dorado:    { label:"Dorado",    gold:"#D4A843", goldDim:"#B8932A", rgbDim:"184,147,42", rgbBright:"212,168,67" },
    esmeralda: { label:"Esmeralda", gold:"#3FBF8F", goldDim:"#2E9E74", rgbDim:"46,158,116", rgbBright:"63,191,143" },
    cobre:     { label:"Cobre",     gold:"#D98E5A", goldDim:"#BB7443", rgbDim:"187,116,67", rgbBright:"217,142,90" },
  };
  const claveAcento = `axis_acento_patron:${currentUser?.uid||""}`;
  const [acento, setAcento] = useState<string>(()=>{ try { const v=localStorage.getItem(claveAcento); return v && ACENTOS[v] ? v : "dorado"; } catch { return "dorado"; } });
  const elegirAcento = (k:string)=>{ setAcento(k); try { localStorage.setItem(claveAcento, k); } catch {} };
  const A = ACENTOS[acento] || ACENTOS.dorado;

  const C = {
    // `line` = borde común de TODAS las tarjetas del portal móvil (centralizado).
    // Sube de 0.30 (apenas visible) a 0.60: dorado del acento, marcado sobre el navy.
    bg:"#05152E", panel:"#0F2138", panelHov:"#13284A", line:`rgba(${A.rgbDim},0.60)`,
    gold:A.gold, goldDim:A.goldDim, ink:"#ECE6D8", inkSoft:"rgba(236,230,216,0.62)",
    inkMut:"rgba(236,230,216,0.40)", iconBg:`rgba(${A.rgbDim},0.10)`, iconBd:`rgba(${A.rgbDim},0.32)`,
    sombra:"0 6px 20px rgba(0,0,0,0.35)",
  };


  // Datos reales (donde existen): cumplimiento documental y general; actividades por confirmar.
  const pctDoc = kpis?.cumplimientoEmpleados ?? 0;
  const tareasPorConfirmar = actividad?.tareas?.length || 0;
  // CRÉDITOS fuera del móvil: es gestión administrativa que se hace desde escritorio.
  // Se filtran sus ítems de "Qué atender hoy" / vencimientos. El hook y el escritorio
  // NO cambian (créditos sigue completo en la suite).
  const atencionMovil = (atencionUrgente||[]).filter((it:any)=> it.modulo!=="creditos");
  const urgente = atencionMovil.length ? atencionMovil[0] : null;
  const hayTareasMv = tareasDeActivos(tareasPatron, empleados).length > 0;   // solo actividades de activos

  // ── Feed de la pestaña Actividad (bitácora del día) ───────────────────────
  // Unifica checadas + flotilla + accidentes (colecciones crudas ya cargadas),
  // ordena por fecha desc y filtra por chip + fecha, todo en JS.
  const fmtHora = (d:Date|null) => d ? d.toLocaleTimeString("es-MX",{hour:"2-digit",minute:"2-digit"}) : "—";
  // Resolución de la unidad de un movimiento, con la MISMA prioridad y el mismo
  // guardián de ambigüedad que el escritorio: primero `vehiculoId` —el vínculo
  // duradero—, y si no lo hay, la placa normalizada como rescate de lo ya
  // registrado. Si dos unidades comparten placa no se elige ninguna: atribuir un
  // movimiento a la unidad equivocada es peor que no atribuirlo.
  const _vehPorIdMv: Record<string, any> = {};
  const _vehPorPlacaMv: Record<string, any> = {};
  (vehiculos||[]).forEach((v:any)=>{
    if (v?.id) _vehPorIdMv[v.id] = v;
    const pl = String(v?.placa||"").toUpperCase().replace(/[^A-Z0-9]/g,"");
    if (pl) _vehPorPlacaMv[pl] = (pl in _vehPorPlacaMv) ? null : v;
  });
  const vehiculoDeRegistroMv = (r:any) => {
    if (r?.vehiculoId && _vehPorIdMv[r.vehiculoId]) return _vehPorIdMv[r.vehiculoId];
    const pl = String(r?.placa||"").toUpperCase().replace(/[^A-Z0-9]/g,"");
    if (!pl) return undefined;
    return _vehPorPlacaMv[pl] || undefined;
  };
  const mismoDia = (d:Date|null, ref:Date) => !!d && d.getFullYear()===ref.getFullYear() && d.getMonth()===ref.getMonth() && d.getDate()===ref.getDate();
  // La ficha de cada correo, para clasificar cada entrada con el horario que REGÍA
  // cuando se hizo (horarioQueRegia, con su historial), no con el de hoy.
  const _empPorCorreoMv: Record<string,any> = {};
  (empleados||[]).forEach((e:any)=>{ const k=(e?.email||"").toLowerCase().trim(); if (k) _empPorCorreoMv[k] = e; });
  const itemsActividad = (() => {
    const arr:any[] = [];
    // CADA CHECADA, CON SU CORRECCIÓN SI LA TIENE (la vista efectiva del equipo): la
    // anulada lo dice y no se califica; la de tipo corregido se nombra con su tipo
    // de ahora. La Actividad sigue siendo de lo que el trabajador registró: un
    // registro agregado por el patrón no es un movimiento suyo y no sale aquí.
    const _vistaEquipoMv = vistaEfectiva({checadas: checadasPatron||[], correcciones: correccionesPatron||[], noConformidades: noConformesPatron||[]});
    const _registroMv: Record<string, any> = {}; (_vistaEquipoMv.registros||[]).forEach((r:any)=>{ if (r.origen === "original") _registroMv[r.id] = r; });
    (checadasPatron||[]).forEach((c:any)=>{ const d=c.timestamp?.toDate?.()||null; const _lu = lecturaUbicacionChecada(c, true); const ubiTxt = (_lu.estado==="dentro"||_lu.estado==="fuera"||_lu.estado==="imprecisa") ? _lu.texto : ""; const bioTxt = (etiquetaBiometria(c)?.texto) || "";
      const _r = _registroMv[c.id]; const _tipo = _r ? _r.tipo : c.tipo; const _anulada = !!(_r && !_r.cuenta);
      const _marca = _anulada ? "Anulada por el patrón" : (_r && _r.cambio) ? `Registrada como ${labelChecada(c.tipo)}; tipo corregido por el patrón` : "";
      arr.push({k:"checada", ms:c.timestamp?.toMillis?.()||0, d, email:(c.trabajadorEmail||"").toLowerCase(), nombre:c.trabajadorNombre||c.trabajadorEmail||"Trabajador", titulo:labelChecada(_tipo), detalle:[_marca, (c.comentario||"").trim(), ubiTxt, bioTxt].filter(Boolean).join(" · "), anulada:_anulada,
        clasif:(!_anulada && _tipo==="entrada"?clasificacionDeChecada({...c, tipo:_tipo}, horarioQueRegia(_empPorCorreoMv[(c.trabajadorEmail||"").toLowerCase()], horarioGeneral, historialGeneral, horaDeChecada(c) as any)):undefined)}); });
    // El movimiento carga su registro crudo y la unidad resuelta: con eso el
    // renglón puede dar el VEREDICTO documental y abrir el detalle completo, igual
    // que en escritorio. Antes el celular solo mostraba placa y kilometraje.
    (flotillaPatron||[]).forEach((f:any)=>{ const d=f.timestamp?.toDate?.()||null; const km=(f.kmFinal??f.kmLlegada??f.kmInicial); const lbl=f.tipo==="salida"?"Salida":f.tipo==="llegada"?"Llegada":"Regreso"; const det=[f.placa, f.destino, (km!=null&&km!==""?`${km} km`:null)].filter(Boolean).join(" · "); arr.push({k:"flotilla", ms:f.timestamp?.toMillis?.()||0, d, email:(f.conductorEmail||f.trabajadorEmail||"").toLowerCase(), nombre:f.conductorNombre||f.conductor||"Trabajador", titulo:`Flotilla · ${lbl}`, detalle:det, raw:f, veh:vehiculoDeRegistroMv(f)}); });
    (accidentesPatron||[]).forEach((a:any)=>{ const d=a.timestamp?.toDate?.()||null; const det=[a.lugarHechos, resumenDeAccidente(a)].filter(Boolean).join(" · ").slice(0,90); arr.push({k:"accidente", ms:a.timestamp?.toMillis?.()||0, d, email:(a.trabajadorEmail||"").toLowerCase(), nombre:a.trabajadorNombre||a.trabajadorEmail||"Trabajador", titulo:"Reportó accidente", detalle:det, raw:a}); });
    return arr;
  })();
  const hoyRef = new Date();
  const feedActividad = itemsActividad
    .filter((it:any)=> actFiltro==="todo" || (actFiltro==="checadas"&&it.k==="checada") || (actFiltro==="flotilla"&&it.k==="flotilla") || (actFiltro==="accidentes"&&it.k==="accidente"))
    .filter((it:any)=> verAnteriores ? true : mismoDia(it.d, hoyRef))
    .sort((a:any,b:any)=> b.ms - a.ms);
  const icoAutoAct = (<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M3.5 13l1.4-4.2A2 2 0 016.8 7.5h10.4a2 2 0 011.9 1.3L20.5 13v4.5a1 1 0 01-1 1h-1a1 1 0 01-1-1V17H6.5v.5a1 1 0 01-1 1h-1a1 1 0 01-1-1V13z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round"/><path d="M3.5 13h17" stroke="currentColor" strokeWidth="1.6"/><circle cx="7.5" cy="15.2" r="1" fill="currentColor"/><circle cx="16.5" cy="15.2" r="1" fill="currentColor"/></svg>);

  // Etiqueta de día: "Hoy · 23 jun", "Ayer · 22 jun" o "21 jun".
  // Las dos viven ahora a nivel de módulo, para que el feed de Inicio separe los
  // días exactamente igual que esta pantalla. Aquí solo se les pasa la fecha de
  // referencia y de dónde sacar la fecha de cada renglón.
  const etiquetaDia = (d:Date|null) => etiquetaDiaAxis(d, hoyRef);
  const agruparPorDia = (items:any[]) => agruparPorDiaAxis(items, (it:any)=> it.d || null);
  // Lista de empleados con actividad en el rango (filtrado por tipo+fecha), con conteo.
  const empleadosActividad = (() => {
    const map:Record<string,any> = {};
    feedActividad.forEach((it:any)=>{ const key = it.email || it.nombre; if (!map[key]) map[key]={key, nombre:it.nombre, items:[]}; map[key].items.push(it); });
    return Object.values(map).sort((a:any,b:any)=> b.items.length - a.items.length);
  })();

  // Tarjeta de un ítem de actividad (reutilizada en vista por día y por empleado).
  const itemActividadCard = (it:any, key:string|number) => {
    const esAcc = it.k==="accidente";
    const col = esAcc ? "#FCA5A5" : it.k==="flotilla" ? "#E2B84A" : "#34D399";
    const ico = esAcc ? icoAlerta : it.k==="flotilla" ? icoAutoAct : icoCheck;
    // Flotilla también abre su detalle: es donde vive el kilometraje, las
    // observaciones y la ubicación que el trabajador capturó.
    const esFlota = it.k==="flotilla";
    const clickable = (esAcc || esFlota) && !!it.raw;
    const cuerpo = (
      <>
        <div style={{width:38, height:38, borderRadius:10, flexShrink:0, display:"flex", alignItems:"center", justifyContent:"center", background:`${col}1f`, border:`1px solid ${col}55`, color:col}}>{ico}</div>
        <div style={{flex:1, minWidth:0}}>
          <div style={{display:"flex", alignItems:"baseline", gap:8, flexWrap:"wrap" as const}}>
            <span style={{fontSize:13.5, fontWeight:700, color:esAcc?"#FCA5A5":C.ink}}>{it.titulo}</span>
            {esAcc && it.raw && (()=>{ const gm=senalDeAccidente(it.raw); if (!gm) return null; return <span style={{fontSize:10, fontWeight:800, padding:"1px 7px", borderRadius:999, border:`1px solid ${gm.color}`, color:gm.color, background:`rgba(${gm.rgb},0.16)`}}>{gm.label}</span>; })()}
            {it.k==="checada" && it.clasif && it.clasif!=="sin_horario" && (()=>{ const cm=clasifAsistenciaMeta(it.clasif); return <span style={{fontSize:10, fontWeight:800, padding:"1px 7px", borderRadius:999, border:`1px solid ${cm.color}`, color:cm.color, background:`rgba(${cm.rgb},0.16)`}}>{cm.patron}</span>; })()}
            <span style={{fontSize:11.5, color:C.inkMut}}>{fmtHora(it.d)}</span>
          </div>
          <div style={{fontSize:12, color:C.inkSoft, marginTop:1}}>{it.nombre}</div>
          {it.detalle && <div style={{fontSize:11.5, color:esAcc?"rgba(252,165,165,0.85)":C.inkMut, marginTop:3, lineHeight:1.4, whiteSpace:"pre-wrap" as const}}>{it.detalle}</div>}
          {/* VEREDICTO DOCUMENTAL a la fecha del movimiento. Mismo texto y mismos
              colores que el escritorio, calculados con la MISMA función: no se
              duplica la lógica, se le pasa la unidad ya resuelta. */}
          {esFlota && it.raw && (()=>{
            const est = estadoDocumentalRegistro(it.raw, it.veh, it.d);
            if (est.tipo === "vencido") return (
              <div style={{fontSize:11, fontWeight:700, color:"#FCA5A5", background:"rgba(220,38,38,0.12)",
                border:"1px solid rgba(252,165,165,0.35)", borderRadius:8, padding:"5px 8px", marginTop:6, lineHeight:1.4}}>
                ⚠ Circuló con documento vencido: {est.documentos.join(", ")}
              </div>
            );
            if (est.tipo === "vigente") return (
              <div style={{fontSize:11, color:"#6EE7B7", marginTop:6}}>Documentación vigente a la fecha del registro</div>
            );
            if (est.tipo === "sin_datos") return (
              <div style={{fontSize:11, color:C.inkMut, marginTop:6}}>Sin registro documental del vehículo</div>
            );
            return (
              <div style={{fontSize:11, color:C.inkMut, marginTop:6}}>Documentación no verificable (registro sin vehículo vinculado)</div>
            );
          })()}
          {clickable && <div style={{fontSize:11, fontWeight:700, color:esAcc?"#FCA5A5":"#E2B84A", marginTop:6}}>Ver detalle ›</div>}
        </div>
      </>
    );
    const estiloBase = {display:"flex", alignItems:"flex-start", gap:11, width:"100%", textAlign:"left" as const, fontFamily:fontSans,
      background:esAcc?"rgba(220,38,38,0.10)":C.panel, border:`1px solid ${esAcc?"rgba(252,165,165,0.40)":C.line}`, borderLeft:`3px solid ${col}`, borderRadius:14, padding:"12px 13px", boxShadow:C.sombra};
    if (clickable) {
      const abrir = esFlota
        ? ()=> setMovFlotaSel({r: it.raw, veh: it.veh, fecha: it.d})
        : ()=>{ setAccFotoAmpliada(null); setAccidenteSel(it.raw); };
      return <button key={key} onClick={abrir} style={{...estiloBase, cursor:"pointer"}}>{cuerpo}</button>;
    }
    return <div key={key} style={estiloBase}>{cuerpo}</div>;
  };
  // Render de una lista agrupada por día (encabezado de fecha + ítems del día).
  const bloquesPorDia = (items:any[]) => {
    const grupos = agruparPorDia(items);
    if (grupos.length===0) return (
      <div style={{textAlign:"center" as const, padding:"40px 20px", background:C.panel, border:`1px solid ${C.line}`, borderRadius:16, boxShadow:C.sombra}}>
        <div style={{fontSize:13, color:C.inkSoft, lineHeight:1.5}}>{verAnteriores ? "Sin actividad registrada en el rango." : "Sin actividad registrada hoy."}</div>
      </div>
    );
    return grupos.map((g:any, gi:number)=>(
      <div key={g.key} style={{marginBottom:14}}>
        <div style={{fontSize:11, fontWeight:700, color:C.gold, textTransform:"uppercase" as const, letterSpacing:"0.8px", margin:"0 2px 8px"}}>{etiquetaDia(g.d)}</div>
        <div style={{display:"flex", flexDirection:"column" as const, gap:9}}>
          {g.items.map((it:any,i:number)=>itemActividadCard(it, `${gi}-${i}`))}
        </div>
      </div>
    ));
  };

  // ── VISTA POR VIAJE ───────────────────────────────────────────────────────
  // Los viajes NO se guardan en ningún lado: se ARMAN al leer. Nada cambia en
  // cómo se registra un movimiento; esto solo interpreta lo que ya está escrito.
  //
  // Se recorren los movimientos de UNA MISMA UNIDAD en orden cronológico:
  //   · una "Salida" abre el viaje;
  //   · cada "Llegada" posterior es UNA PARADA MÁS —pueden ser una o siete, quien
  //     usa esto hace varias paradas por viaje—;
  //   · el primer "Regreso" lo cierra.
  // Un "Regreso" (o una "Llegada") sin salida previa es un viaje SUELTO: se muestra
  // tal cual, sin pegarlo al viaje anterior ni inventar la salida que falta.
  // Y si aparece una salida nueva con un viaje todavía abierto, ese anterior se
  // cierra sin regreso: la unidad ya volvió a salir, nadie lo va a cerrar después.
  // Los viajes NO se arman aquí: los arma `armarViajesFlotilla`, la misma
  // función que usa el escritorio. Dos formas de agrupar la misma colección
  // producirían dos verdades sobre un registro que se presenta como prueba.
  const viajesTodos = armarViajesFlotilla(flotillaPatron||[], vehiculos||[]);
  const viajesFlotilla = filtrarViajesFlotilla(viajesTodos, {
    texto: bitTexto, unidad: bitUnidad, persona: bitPersona, desde: bitDesde, hasta: bitHasta,
  });
  // Las opciones salen de los viajes que hay, no del catálogo: un filtro que
  // ofrece unidades sin un solo viaje hace perder el tiempo.
  const bitOpciones = opcionesDeViajes(viajesTodos);
  const bitHayFiltro = !!(bitTexto || bitUnidad || bitPersona || bitDesde || bitHasta);

  // Tarjeta de un viaje: unidad y conductor arriba, la secuencia completa como
  // línea de tiempo, y abajo lo que se puede afirmar del recorrido.
  const tarjetaViaje = (v:any, key:string|number) => {
    const meta = estadoViajeMeta(v.estado);
    // El veredicto es UNO por viaje, al momento de la salida: la unidad sale con
    // los documentos que trae, no se revalida en cada parada. Misma función que
    // usan el escritorio y el renglón por movimiento.
    const ref = v.salida || v.momentos[0];
    const est = estadoDocumentalRegistro(ref.m, v.veh, ref.d);
    // Kilómetros SOLO con los dos kilometrajes. Si falta uno no se muestra nada:
    // "0 km" sería una distancia afirmada, no un dato ausente.
    const km = kmDeViaje(v);
    const dur = (v.salida && v.regreso) ? duracionViajeTexto(v.regreso.ms - v.salida.ms) : null;
    // Fotos de TODO el viaje, no de un movimiento: aquí solo se anuncia que las
    // hay y cuántas. Se ven al abrir el momento que las trae.
    const nFotos = fotosDeViaje(v);
    const unidad = [v.placa, v.veh ? [v.veh.marca, v.veh.modelo].filter(Boolean).join(" ") : ""].filter(Boolean).join(" · ") || "Unidad sin placa";
    const filas = momentosDeViaje(v);
    const dato = (txt:string) => (
      <span style={{fontSize:11, fontWeight:700, color:C.inkSoft, background:"rgba(255,255,255,0.05)",
        border:`1px solid ${C.line}`, borderRadius:999, padding:"3px 9px"}}>{txt}</span>
    );
    return (
      <div key={key} style={{background:C.panel, border:`1px solid ${C.line}`, borderLeft:`3px solid ${meta.color}`,
        borderRadius:14, padding:"12px 13px", boxShadow:C.sombra}}>
        <div style={{display:"flex", alignItems:"flex-start", gap:10, marginBottom:10}}>
          <div style={{width:34, height:34, borderRadius:9, flexShrink:0, display:"flex", alignItems:"center", justifyContent:"center",
            background:"rgba(226,184,74,0.12)", border:"1px solid rgba(226,184,74,0.33)", color:"#E2B84A"}}>{icoAutoAct}</div>
          <div style={{flex:1, minWidth:0}}>
            <div style={{fontSize:13.5, fontWeight:700, color:C.ink}}>{unidad}</div>
            <div style={{fontSize:12, color:C.inkSoft, marginTop:1}}>
              {v.conductor}{v.d ? ` · ${etiquetaDia(v.d)}` : ""}
            </div>
          </div>
          {/* Estado del viaje con LAS MISMAS PALABRAS en todas las pantallas. */}
          <span style={{fontSize:9.5, fontWeight:800, letterSpacing:"0.5px", padding:"2px 8px", borderRadius:999, flexShrink:0,
            maxWidth:118, textAlign:"right" as const, lineHeight:1.35,
            border:`1px solid ${meta.color}`, color:meta.color, background:`${meta.color}1f`}}>{meta.texto}</span>
        </div>

        {/* LA SECUENCIA. Cada momento abre el mismo detalle que en la vista por
            movimiento: aquí cambia la lectura, no la ficha. */}
        <div style={{display:"flex", flexDirection:"column" as const}}>
          {filas.map((fl:any, i:number)=>(
            <button key={i} type="button" onClick={()=> setMovFlotaSel({r: fl.mv.m, veh: v.veh, fecha: fl.mv.d})}
              style={{display:"flex", alignItems:"stretch", gap:9, width:"100%", textAlign:"left" as const, fontFamily:fontSans,
                background:"transparent", border:"none", padding:0, cursor:"pointer", WebkitTapHighlightColor:"transparent"}}>
              <div style={{width:11, display:"flex", flexDirection:"column" as const, alignItems:"center", flexShrink:0}}>
                <span style={{width:9, height:9, borderRadius:999, background:fl.color, marginTop:4, flexShrink:0}}/>
                {!fl.ultimo && <span style={{flex:1, width:1.5, background:C.line, marginTop:2}}/>}
              </div>
              <div style={{flex:1, minWidth:0, paddingBottom: fl.ultimo ? 0 : 9}}>
                <div style={{display:"flex", alignItems:"baseline", gap:8, flexWrap:"wrap" as const}}>
                  <span style={{fontSize:12.5, fontWeight:700, color:fl.color}}>{fl.etiqueta}</span>
                  <span style={{fontSize:11.5, color:C.inkMut}}>{fmtHora(fl.mv.d)}</span>
                </div>
                {fl.mv.m.destino && <div style={{fontSize:12, color:C.inkSoft, marginTop:1, lineHeight:1.35}}>{fl.mv.m.destino}</div>}
              </div>
            </button>
          ))}
        </div>

        {/* Lo que se puede afirmar del recorrido. Lo que no, no aparece. */}
        <div style={{display:"flex", flexWrap:"wrap" as const, gap:6, marginTop:10}}>
          {dato(v.paradas.length===0 ? "Sin paradas" : v.paradas.length===1 ? "1 parada" : `${v.paradas.length} paradas`)}
          {dur && dato(dur)}
          {km !== null && dato(`${km.toLocaleString("es-MX")} km`)}
          {nFotos > 0 && dato(nFotos===1 ? "1 foto" : `${nFotos} fotos`)}
        </div>

        {/* ABIERTO no es un reclamo de captura: o la unidad sigue afuera, o alguien
            olvidó cerrar el viaje. Las dos cosas se atienden, y para las dos hace
            falta saber desde cuándo. */}
        {v.estado === "abierto" && (
          <div style={{fontSize:11.5, fontWeight:700, color:"#E2B84A", marginTop:8}}>
            {v.salida ? `Salió ${desdeHaceTexto(v.salida.ms)}` : `Último movimiento ${desdeHaceTexto(v.msFin)}`} · sin regreso
          </div>
        )}
        {/* SIN REGRESO REGISTRADO no es lo mismo que abierto: esta unidad ya no
            está afuera, la persona salió en otra y lo declaró. No se inventó una
            hora de regreso, y por eso el viaje no se cuenta como cerrado. */}
        {v.estado === "sin_regreso" && (
          <div style={{fontSize:11.5, lineHeight:1.5, color:"#FCA5A5", marginTop:8}}>
            El regreso nunca se registró.{v.cierre?.d ? ` Se dio por terminado el ${v.cierre.d.toLocaleDateString("es-MX",{day:"numeric",month:"short"})}` : ""}
            {v.cierre?.motivo === "salida_en_otra_unidad" ? " porque el conductor salió en otra unidad." : "."}
          </div>
        )}
        {v.estado === "suelto" && (
          <div style={{fontSize:11, color:C.inkMut, marginTop:8, lineHeight:1.45}}>
            Movimiento suelto: no se pudo atribuir a ningún viaje con certeza, así que se muestra por su cuenta en vez de colgarlo del viaje de alguien.
          </div>
        )}

        {/* Veredicto documental del viaje, a la fecha de la salida. */}
        {est.tipo === "vencido" ? (
          <div style={{fontSize:11, fontWeight:700, color:"#FCA5A5", background:"rgba(220,38,38,0.12)",
            border:"1px solid rgba(252,165,165,0.35)", borderRadius:8, padding:"5px 8px", marginTop:8, lineHeight:1.4}}>
            ⚠ Salió con documento vencido: {est.documentos.join(", ")}
          </div>
        ) : est.tipo === "vigente" ? (
          <div style={{fontSize:11, color:"#6EE7B7", marginTop:8}}>Documentación vigente a la fecha de la salida</div>
        ) : est.tipo === "sin_datos" ? (
          <div style={{fontSize:11, color:C.inkMut, marginTop:8}}>Sin registro documental del vehículo</div>
        ) : (
          <div style={{fontSize:11, color:C.inkMut, marginTop:8}}>Documentación no verificable (registro sin vehículo vinculado)</div>
        )}
      </div>
    );
  };

  // Lista PLANA, en el orden que decide el armado: los viajes abiertos arriba
  // —son unidades en la calle ahora— y después el resto por fecha de salida
  // descendente. Agruparlos por día rompería ese orden, que es el que importa.
  const bloquesDeViajes = () => {
    if (viajesFlotilla.length === 0) return (
      <div style={{textAlign:"center" as const, padding:"40px 20px", background:C.panel, border:`1px solid ${C.line}`, borderRadius:16, boxShadow:C.sombra}}>
        <div style={{fontSize:13, color:C.inkSoft, lineHeight:1.5}}>
          {bitHayFiltro ? "Ningún viaje coincide con los filtros." : "Aún no hay viajes registrados."}
        </div>
      </div>
    );
    return (
      <div style={{display:"flex", flexDirection:"column" as const, gap:9}}>
        {viajesFlotilla.map((v:any,i:number)=>tarjetaViaje(v, v.id || i))}
      </div>
    );
  };

  // La vista por viaje solo existe dentro de la bitácora de flotilla: en "Todo"
  // o en "Checadas" no hay viaje que armar.
  const enViaje = actFiltro==="flotilla" && bitVista==="viaje";

  // ── Pestaña Equipo ────────────────────────────────────────────────────────
  // Reutiliza empleados (colección trabajadores) y calcularMetricasEmpleado(t, mes,
  // tareasColeccion) ya existentes; las actividades vienen de tareasPatron (ya cargado).
  // Confirmar reusa el MISMO write del módulo Actividades de la suite (confirmadaPorPatron).
  const mesEquipo = new Date().toISOString().slice(0,7);
  const hoyEquipoISO = new Date().toISOString().slice(0,10);
  // Base = colección + tareas creadas en esta sesión; se aplican ediciones y
  // confirmaciones locales para refresco inmediato (useDashboardData carga una vez).
  const tareasEquipoAjust = [...(tareasPatron||[]), ...tareasNuevas].map((t:any)=>{
    let x = t;
    if (tareasEditadas[t.id]) x = {...x, ...tareasEditadas[t.id]};
    if (equipoConfirmadas[t.id]) x = {...x, confirmadaPorPatron:true};
    return x;
  });
  // Actividades VENCIDAS/PENDIENTES desde la MISMA colección `tareas` que usa el portal
  // (no del arreglo embebido legacy t.tareas), para que el badge sea consistente con
  // la ficha y el medidor de Actividades. Abierta = sin confirmar por el patrón.
  const tareasStats = (email:string) => {
    const abiertas = tareasEquipoAjust.filter((t:any)=> (t.trabajadorEmail||"").toLowerCase()===email && !t.confirmadaPorPatron);
    const vencidas = abiertas.filter((t:any)=> t.fechaLimite && t.fechaLimite < hoyEquipoISO).length;
    return { vencidas, pendientes: abiertas.length - vencidas };
  };
  // Igual que en el escritorio: el aviso MARCA, no acota. Acotar dejaba al patrón
  // viendo dos personas de quince, con un filtro invisible que no se podia quitar.
  const marcadosSinChecar = new Set((equipoFoco||[]).map((m:string)=>String(m||"").toLowerCase().trim()).filter(Boolean));
  const empleadosEquipo = (empleados||[])
    .filter((e:any)=> e.status!=="baja")
    .map((e:any)=>({ e, m: calcularMetricasEmpleado(e, mesEquipo, tareasEquipoAjust), st: tareasStats((e.email||"").toLowerCase()) }))
    .sort((a:any,b:any)=> (a.e.nombre||"").localeCompare(b.e.nombre||""));
  // Lo mismo que en el escritorio y con la misma pieza: el aviso lleva a la
  // persona, no a la lista donde está la persona.
  const _primerSinChecarMv = ((empleadosEquipo.find((x:any)=>
    marcadosSinChecar.has(String(x.e.email||"").toLowerCase().trim())) || {}).e || {}).id || null;
  const _resSinChecarMv = useResaltado(_primerSinChecarMv, empleadosEquipo);
  const empSelData = equipoSel ? empleadosEquipo.find((x:any)=> (x.e.email||"").toLowerCase()===equipoSel) : null;
  const tareasEmpSel = empSelData ? tareasEquipoAjust
    .filter((t:any)=> (t.trabajadorEmail||"").toLowerCase()===equipoSel)
    .sort((a:any,b:any)=>{ const fa=a.fechaLimite||"9999-99-99", fb=b.fechaLimite||"9999-99-99"; return fa!==fb ? fa.localeCompare(fb) : (a.creadoEn?.toMillis?.()||0)-(b.creadoEn?.toMillis?.()||0); }) : [];

  // Solo el patrón confirma: marca confirmadaPorPatron=true + fechaConfirmada (igual que la suite).
  const confirmarTareaEquipo = async (id:string) => {
    setEquipoConfirmando(id);
    try {
      await updateDoc(doc(db,"tareas",id), { confirmadaPorPatron:true, fechaConfirmada:serverTimestamp() });
      setEquipoConfirmadas(prev=>({...prev, [id]:true}));
    } catch(e){ console.error(e); alert("No se pudo confirmar la actividad."); }
    finally { setEquipoConfirmando(null); }
  };

  // Crear / editar actividad — MISMOS campos y colección que la suite (no se reinventa la
  // lógica): create cumple la regla (empleadorId==uid, confirmadaPorPatron==false);
  // edit solo toca titulo/descripcion/fechaLimite/horario (no la doble validación).
  // `trabajadorEmail` SIEMPRE sale de aqui como cadena. `correo||""` no bastaba:
  // cualquier valor truthy —un evento de React, por ejemplo— pasaba tal cual y
  // reventaba mas adelante, lejos del origen. El tipo se garantiza donde el dato
  // nace, no se parchea donde se usa.
  const abrirCrearTarea  = (correo?:any)=>{ setTareaErr(""); setTareaForm({modo:"crear", titulo:"", descripcion:"", fechaLimite:"", horario:"", trabajadorEmail: typeof correo === "string" ? correo : ""}); };
  const abrirEditarTarea = (t:any)=>{ setTareaErr(""); setTareaForm({modo:"editar", id:t.id, titulo:t.titulo||"", descripcion:t.descripcion||"", fechaLimite:t.fechaLimite||"", horario:t.horario||""}); };
  const guardarTarea = async () => {
    if (!tareaForm || !currentUser?.uid) return;
    const tit = tareaForm.titulo.trim();
    if (!tit) { setTareaErr("Falta el título."); return; }
    if (!tareaForm.fechaLimite) { setTareaErr("La fecha límite es obligatoria (define el mes de cumplimiento)."); return; }
    setTareaGuardando(true); setTareaErr("");
    try {
      if (tareaForm.modo==="crear") {
        const correo = (tareaForm.trabajadorEmail || equipoSel || "").toLowerCase().trim();
        if (!correo) { setTareaErr("Selecciona un trabajador."); setTareaGuardando(false); return; }
        const nombreEmp = empleadosEquipo.find((x:any)=>(x.e.email||"").toLowerCase()===correo)?.e?.nombre || empSelData?.e?.nombre || correo;
        const ref = await addDoc(collection(db,"tareas"), {
          empleadorId: currentUser.uid,
          trabajadorEmail: correo,
          trabajadorNombre: nombreEmp,
          titulo: tit,
          descripcion: tareaForm.descripcion.trim(),
          fechaLimite: tareaForm.fechaLimite || "",
          horario: tareaForm.horario.trim() || "",
          marcadaPorTrabajador: false,
          confirmadaPorPatron: false,
          creadoEn: serverTimestamp(),
        });
        // Reflejo local inmediato (creadoEn local solo para ordenar en pantalla).
        setTareasNuevas(prev=>[...prev, { id:ref.id, empleadorId:currentUser.uid, trabajadorEmail:correo, trabajadorNombre:nombreEmp, titulo:tit, descripcion:tareaForm.descripcion.trim(), fechaLimite:tareaForm.fechaLimite||"", horario:tareaForm.horario.trim()||"", marcadaPorTrabajador:false, confirmadaPorPatron:false, creadoEn:{toMillis:()=>Date.now()} }]);
      } else {
        await updateDoc(doc(db,"tareas",tareaForm.id!), {
          titulo: tit,
          descripcion: tareaForm.descripcion.trim(),
          fechaLimite: tareaForm.fechaLimite || "",
          horario: tareaForm.horario.trim() || "",
          fechaModificacion: serverTimestamp(),
        });
        setTareasEditadas(prev=>({...prev, [tareaForm.id!]: {titulo:tit, descripcion:tareaForm.descripcion.trim(), fechaLimite:tareaForm.fechaLimite||"", horario:tareaForm.horario.trim()||""}}));
      }
      setTareaForm(null);
    } catch(e:any){
      console.error("tarea guardar:", e);
      // Al usuario se le dice QUE no se pudo hacer, en español. El mensaje tecnico
      // va a la consola: "toLowerCase is not a function" en pantalla no le dice
      // nada a un patron y parece que la aplicacion se rompio.
      const cod = String(e?.code||"");
      setTareaErr(
        cod.includes("permission-denied") ? "No tienes permiso para asignar esta actividad."
        : cod.includes("unavailable") || cod.includes("network") ? "Sin conexion. Revisa tu internet e intentalo de nuevo."
        : "No se pudo guardar la actividad. Intentalo de nuevo."
      );
    }
    finally { setTareaGuardando(false); }
  };

  const lblTarea = {display:"block", fontSize:11, fontWeight:700, color:C.inkSoft, margin:"0 0 5px"} as const;
  const inpTarea = {width:"100%", boxSizing:"border-box" as const, padding:"10px 12px", borderRadius:10, border:`1px solid ${C.line}`, background:"rgba(255,255,255,0.04)", color:C.ink, fontSize:14, fontFamily:fontSans, outline:"none", marginBottom:10} as const;

  const colPct = (p:number)=> p>=80 ? "#34D399" : p>=40 ? "#E2B84A" : "#FCA5A5";
  const inicialesDe = (n:string)=> (n||"").trim().split(/\s+/).slice(0,2).map((s:string)=>s[0]||"").join("").toUpperCase()||"·";
  // Medidor (barra + %): chico para la lista, grande para la ficha.
  const medidorEquipo = (label:string, pct:number, big?:boolean) => (
    <div style={{flex:1, minWidth:0}}>
      <div style={{display:"flex", justifyContent:"space-between", alignItems:"baseline", marginBottom:4}}>
        <span style={{fontSize:big?13:11.5, color:C.inkSoft}}>{label}</span>
        <span style={{fontSize:big?19:13.5, fontWeight:800, color:C.gold, fontFamily:fontSerif}}>{pct}%</span>
      </div>
      <div style={{height:big?9:6, background:"rgba(255,255,255,0.08)", borderRadius:5, overflow:"hidden"}}>
        <div style={{height:"100%", width:`${pct}%`, background:colPct(pct), borderRadius:5, transition:"width 0.5s ease"}}/>
      </div>
    </div>
  );
  // Badge de ACTIVIDADES vencidas/pendientes (rojo si hay vencidas, ámbar si solo pendientes).
  // Etiqueta explícita ("tareas") para no confundir con documentos.
  const badgeVenc = (st:any) => (st.vencidas>0 || st.pendientes>0) ? (
    <span style={{fontSize:11, fontWeight:800, padding:"3px 9px", borderRadius:999, whiteSpace:"nowrap" as const,
      border:`1px solid ${st.vencidas>0?"rgba(252,165,165,0.5)":"rgba(226,184,74,0.5)"}`,
      background:st.vencidas>0?"rgba(220,38,38,0.12)":"rgba(226,184,74,0.12)",
      color:st.vencidas>0?"#FCA5A5":"#E2B84A"}}>
      {st.vencidas>0 ? `${st.vencidas} actividad${st.vencidas===1?"":"es"} vencida${st.vencidas===1?"":"s"}` : `${st.pendientes} actividad${st.pendientes===1?"":"es"} pendiente${st.pendientes===1?"":"s"}`}
    </span>
  ) : null;
  // Badge de estado de actividad (navy).
  const badgeEstadoEq = (estado:string) => {
    const c = estado==="Confirmada" ? {fg:"#34D399", bd:"rgba(52,211,153,0.40)", bg:"rgba(52,211,153,0.12)"}
      : estado==="Por confirmar" ? {fg:"#E2B84A", bd:"rgba(226,184,74,0.45)", bg:"rgba(226,184,74,0.12)"}
      : {fg:C.inkMut, bd:C.line, bg:"transparent"};
    return <span style={{fontSize:10.5, fontWeight:800, padding:"3px 9px", borderRadius:999, border:`1px solid ${c.bd}`, background:c.bg, color:c.fg, whiteSpace:"nowrap" as const}}>{estado}</span>;
  };

  // ── Vista central de ACTIVIDADES (móvil) — todas las actividades + filtros + acciones ──
  // Reutiliza la MISMA colección/acciones que la ficha (guardarTarea, confirmarTareaEquipo,
  // abrirEditarTarea); filtra en JS sobre tareasEquipoAjust. Estilo navy/verde del móvil.
  const finSemanaISO = (()=>{ const d=new Date(); d.setDate(d.getDate()+7); return d.toISOString().slice(0,10); })();
  const tareasCentral = tareasEquipoAjust.filter((t:any)=>{
    if (mvTFEmp && (t.trabajadorEmail||"").toLowerCase()!==mvTFEmp) return false;
    const est = t.confirmadaPorPatron?"confirmada":t.marcadaPorTrabajador?"por_confirmar":"pendiente";
    if (mvTFEstado!=="todos" && est!==mvTFEstado) return false;
    if (mvTFFecha==="vencidas") { if (!(t.fechaLimite && t.fechaLimite<hoyEquipoISO && !t.confirmadaPorPatron)) return false; }
    else if (mvTFFecha==="semana") { if (!(t.fechaLimite && t.fechaLimite>=hoyEquipoISO && t.fechaLimite<=finSemanaISO)) return false; }
    return true;
  }).sort((a:any,b:any)=>{ const fa=a.fechaLimite||"9999-99-99", fb=b.fechaLimite||"9999-99-99"; return fa!==fb?fa.localeCompare(fb):(a.creadoEn?.toMillis?.()||0)-(b.creadoEn?.toMillis?.()||0); });
  const mvSelInp:any = {...inpTarea, marginBottom:0, colorScheme:"dark", cursor:"pointer"};
  const vistaTareasCentral = (
    <>
      <div style={{marginBottom:12}}>
        <h1 style={{fontFamily:fontSerif, fontSize:24, fontWeight:700, color:C.ink, margin:0, lineHeight:1.1}}>Actividades</h1>
        <p style={{fontSize:13, color:C.inkSoft, margin:"3px 0 0"}}>Todas las actividades de tu equipo</p>
      </div>
      {!tareaForm && (
        <button onClick={()=>abrirCrearTarea()}
          style={{display:"inline-flex", alignItems:"center", gap:6, marginBottom:12, padding:"10px 14px", borderRadius:12, border:`1px solid ${C.gold}`, background:`rgba(${A.rgbBright},0.12)`, color:C.gold, cursor:"pointer", fontFamily:fontSans, fontSize:13, fontWeight:800, boxShadow:C.sombra}}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
          Asignar actividad
        </button>
      )}
      {tareaForm && (
        <div {...ZONA_DE_CAPTURA} style={{background:C.panel, border:`1px solid ${C.gold}`, borderRadius:14, padding:"14px 14px", boxShadow:C.sombra, marginBottom:12}}>
          <div style={{fontFamily:fontSerif, fontSize:15, fontWeight:700, color:C.gold, marginBottom:10}}>{tareaForm.modo==="crear"?"Nueva actividad":"Editar actividad"}</div>
          {tareaForm.modo==="crear" && (<>
            <label style={lblTarea}>Trabajador</label>
            <select value={tareaForm.trabajadorEmail||""} onChange={e=>setTareaForm(f=>f?{...f, trabajadorEmail:e.target.value}:f)} style={{...inpTarea, colorScheme:"dark" as any}}>
              <option value="">Selecciona…</option>
              {empleadosEquipo.map(({e}:any)=>(<option key={e.id} value={(e.email||"").toLowerCase()}>{e.nombre||e.email}</option>))}
            </select>
          </>)}
          <label style={lblTarea}>Título</label>
          <input value={tareaForm.titulo} onChange={e=>setTareaForm(f=>f?{...f, titulo:e.target.value}:f)} placeholder="Ej. Entregar reporte mensual" style={inpTarea}/>
          <label style={lblTarea}>Descripción (opcional)</label>
          <textarea value={tareaForm.descripcion} onChange={e=>setTareaForm(f=>f?{...f, descripcion:e.target.value}:f)} rows={3} placeholder="Detalles de la actividad…" style={{...inpTarea, resize:"vertical" as const, minHeight:64}}/>
          <label style={lblTarea}>Fecha límite</label>
          <input type="date" value={tareaForm.fechaLimite} onChange={e=>setTareaForm(f=>f?{...f, fechaLimite:e.target.value}:f)} style={{...inpTarea, marginBottom:0, colorScheme:"dark" as any}}/>
          {tareaErr && <div style={{fontSize:12, color:"#FCA5A5", fontWeight:700, marginTop:8}}>{tareaErr}</div>}
          <div style={{display:"flex", gap:8, marginTop:12}}>
            <button onClick={()=>{ setTareaForm(null); setTareaErr(""); }} style={{flex:1, padding:"10px", borderRadius:10, border:`1px solid ${C.line}`, background:"transparent", color:C.inkSoft, cursor:"pointer", fontFamily:fontSans, fontSize:13, fontWeight:700}}>Cancelar</button>
            <button onClick={guardarTarea} disabled={tareaGuardando} style={{flex:2, padding:"10px", borderRadius:10, border:"none", background:C.gold, color:"#0B1829", cursor:tareaGuardando?"wait":"pointer", fontFamily:fontSans, fontSize:13, fontWeight:800}}>{tareaGuardando?"Guardando…":(tareaForm.modo==="crear"?"Asignar actividad":"Guardar cambios")}</button>
          </div>
        </div>
      )}
      <div style={{background:C.panel, border:`1px solid ${C.line}`, borderRadius:12, padding:"10px 12px", marginBottom:10, display:"flex", flexDirection:"column" as const, gap:8, boxShadow:C.sombra}}>
        <select {...CAMPO_DE_PARAMETRO} value={mvTFEmp} onChange={e=>setMvTFEmp(e.target.value)} style={mvSelInp}>
          <option value="">Todos los empleados</option>
          {empleadosEquipo.map(({e}:any)=>(<option key={e.id} value={(e.email||"").toLowerCase()}>{e.nombre||e.email}</option>))}
        </select>
        <div style={{display:"flex", gap:8}}>
          <select {...CAMPO_DE_PARAMETRO} value={mvTFEstado} onChange={e=>setMvTFEstado(e.target.value as any)} style={{...mvSelInp, flex:1}}>
            <option value="todos">Estado: todos</option>
            <option value="pendiente">Pendiente</option>
            <option value="por_confirmar">Por confirmar</option>
            <option value="confirmada">Confirmada</option>
          </select>
          <select {...CAMPO_DE_PARAMETRO} value={mvTFFecha} onChange={e=>setMvTFFecha(e.target.value as any)} style={{...mvSelInp, flex:1}}>
            <option value="todas">Vence: todas</option>
            <option value="vencidas">Vencidas</option>
            <option value="semana">Esta semana</option>
          </select>
        </div>
      </div>
      <div style={{fontSize:12, color:C.inkSoft, fontWeight:600, margin:"0 2px 10px"}}>Mostrando <span style={{color:C.ink, fontWeight:800}}>{tareasCentral.length}</span> de {tareasEquipoAjust.length} actividad{tareasEquipoAjust.length===1?"":"es"}</div>
      {tareasCentral.length===0 ? (
        <div style={{textAlign:"center" as const, padding:"30px 20px", background:C.panel, border:`1px solid ${C.line}`, borderRadius:16, boxShadow:C.sombra, fontSize:13, color:C.inkSoft}}>
          {tareasEquipoAjust.length===0 ? "Aún no hay actividades asignadas." : "Ninguna actividad coincide con los filtros."}
        </div>
      ) : (
        <div style={{display:"flex", flexDirection:"column" as const, gap:9}}>
          {tareasCentral.map((t:any)=>{
            const est = t.confirmadaPorPatron ? "Confirmada" : t.marcadaPorTrabajador ? "Por confirmar" : "Pendiente";
            return (
              <div key={t.id} style={{background:C.panel, border:`1px solid ${C.line}`, borderRadius:14, padding:"12px 14px", boxShadow:C.sombra}}>
                <div style={{display:"flex", alignItems:"baseline", gap:8, flexWrap:"wrap" as const, marginBottom:4}}>
                  <span style={{fontSize:13.5, fontWeight:700, color:C.ink, flex:1, minWidth:0}}>{t.titulo||"Actividad"}</span>
                  {badgeEstadoEq(est)}
                </div>
                <div style={{fontSize:11.5, color:C.gold, fontWeight:700, marginBottom:(t.descripcion||t.fechaLimite)?3:0}}>{t.trabajadorNombre||t.trabajadorEmail||"—"}</div>
                {t.descripcion && <div style={{fontSize:12, color:C.inkSoft, marginBottom:3, whiteSpace:"pre-wrap" as const}}>{t.descripcion}</div>}
                {t.fechaLimite && <div style={{fontSize:11.5, color:C.inkMut}}>Límite: {t.fechaLimite}</div>}
                <div style={{display:"flex", gap:8, marginTop:10}}>
                  <button onClick={()=>abrirEditarTarea(t)} style={{flex:1, padding:"8px 10px", borderRadius:9, border:`1px solid ${C.line}`, background:"transparent", color:C.gold, cursor:"pointer", fontFamily:fontSans, fontSize:12, fontWeight:700}}>Editar</button>
                  {est==="Por confirmar" && (
                    <button onClick={()=>confirmarTareaEquipo(t.id)} disabled={equipoConfirmando===t.id}
                      style={{flex:1, padding:"8px 10px", borderRadius:9, cursor:equipoConfirmando===t.id?"wait":"pointer", fontFamily:fontSans, fontSize:12, fontWeight:800, border:"1px solid rgba(52,211,153,0.45)", background:"rgba(52,211,153,0.14)", color:"#34D399"}}>
                      {equipoConfirmando===t.id ? "Confirmando…" : "Confirmar"}
                    </button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </>
  );

  // Medidor individual del Inicio (label + % + barra). pct null = sin dato (neutro).
  const medidorMv = (label:string, pct:number|null, sub:string) => (
    <div>
      <div style={{display:"flex", justifyContent:"space-between", alignItems:"baseline", gap:8, marginBottom:3}}>
        <span style={{fontSize:12.5, color:C.inkSoft}}>{label}</span>
        <span style={{fontSize:14.5, fontWeight:800, color: pct==null?C.inkMut:C.gold, fontFamily:fontSerif}}>{loading?"·":(pct==null?"—":`${pct}%`)}</span>
      </div>
      <div style={{height:6, background:"rgba(255,255,255,0.08)", borderRadius:5, overflow:"hidden"}}>
        <div style={{height:"100%", width:`${pct==null?0:pct}%`, background:pct==null?C.inkMut:colPct(pct), borderRadius:5, transition:"width 0.5s ease"}}/>
      </div>
      <div style={{fontSize:10.5, color:C.inkMut, marginTop:3}}>{sub}</div>
    </div>
  );

  // Fila de "Qué atender hoy".
  // Fila de "Qué atender hoy". Si recibe onClick navega a su pestaña; si no, no
  // hace nada (no truena) — p. ej. Calendario, que se conectará después.
  const filaAtender = (ico:React.ReactNode, titulo:string, sub:string, onClick?:()=>void) => (
    <button onClick={onClick} disabled={!onClick}
      style={{display:"flex", alignItems:"center", gap:11, width:"100%", textAlign:"left" as const, fontFamily:"inherit",
        background:C.panel, border:`1px solid ${C.line}`, borderRadius:13, padding:"10px 12px", boxShadow:C.sombra, marginBottom:8,
        cursor:onClick?"pointer":"default"}}>
      <div style={{width:36, height:36, borderRadius:10, flexShrink:0, display:"flex", alignItems:"center", justifyContent:"center", background:C.iconBg, border:`1px solid ${C.iconBd}`, color:C.gold}}>{ico}</div>
      <div style={{flex:1, minWidth:0}}>
        <div style={{fontSize:13, fontWeight:700, color:C.ink, lineHeight:1.2}}>{titulo}</div>
        {sub && <div style={{fontSize:11, color:C.inkSoft, marginTop:1}}>{sub}</div>}
      </div>
      {/* Sin onClick = fila informativa: sin chevron (no navega a ningún lado). */}
      {onClick && <span style={{fontSize:19, color:C.inkMut, lineHeight:1}}>›</span>}
    </button>
  );

  const icoAlerta = (<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M12 4.3l8.6 14.7a1 1 0 01-.87 1.5H4.27a1 1 0 01-.87-1.5z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round"/><path d="M12 10v4.2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>);
  const icoCheck  = (<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M9 6.5h11M9 12h11M9 17.5h11" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/><path d="M4 6.2l1.3 1.3L7 5M4 11.7l1.3 1.3L7 10.5M4 17.2l1.3 1.3L7 16" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/></svg>);
  const icoCal    = (<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><rect x="3.5" y="5" width="17" height="16" rx="2.5" stroke="currentColor" strokeWidth="1.7"/><path d="M3.5 9.5h17M8 3.2v3.2M16 3.2v3.2" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/></svg>);

  const barras = ([
    {k:"inicio" as const,    label:"Inicio",    ico:(<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M3 11l9-7 9 7M5.5 9.5V19a1 1 0 001 1H9v-5.5h6V20h2.5a1 1 0 001-1V9.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/></svg>)},
    {k:"actividad" as const, label:"Actividad", ico:(<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M9 6.5h11M9 12h11M9 17.5h11" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/><path d="M4 6.2l1.3 1.3L7 5M4 11.7l1.3 1.3L7 10.5M4 17.2l1.3 1.3L7 16" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/></svg>)},
    {k:"equipo" as const,    label:"Equipo",    ico:(<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><circle cx="9" cy="9" r="3" stroke="currentColor" strokeWidth="1.7"/><path d="M3.5 19c0-3 2.5-5 5.5-5s5.5 2 5.5 5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/><path d="M16 7.2a2.7 2.7 0 010 5.2M17.5 19c0-2.1-.9-3.7-2.4-4.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/></svg>)},
    {k:"perfil" as const,    label:"Perfil",    ico:(<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="8" r="3.6" stroke="currentColor" strokeWidth="1.7"/><path d="M5 20c0-3.6 3.1-6.4 7-6.4s7 2.8 7 6.4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/></svg>)},
  ]);

  // ── Navegación de la barra inferior (CENTRALIZADA) ──────────────────────────
  // Ir a una sección raíz (Inicio/Actividad/Equipo/Perfil) SIEMPRE cierra cualquier
  // ventana secundaria abierta para que la barra nunca deje al usuario atrapado.
  // Toda ventana/overlay del portal debe cerrarse aquí; así una ventana futura no
  // regresa el bug (antes faltaba cerrar Flotilla y por eso atrapaba, a diferencia
  // de Calendario que sí se cerraba). No toca datos: solo estado de navegación.
  const irATab = (k:"inicio"|"actividad"|"equipo"|"perfil") => {
    setTab(k);
    // Pantallas que se anteponen al contenido por pestaña (cadena ternaria):
    setVerFlotilla(false); setFlotillaFoco(""); setFlotillaAbierto("");
    setVerCalendario(false); setVerAviso(false); setVerCalculadora(false);
    setAccidenteSel(null); setAccFotoAmpliada(null);
    // Modales flotantes y sub-ventanas de sección (ficha/editor): a la raíz limpia.
    setVerAsuetos(false); setVerHorarioConfig(false); setLegalModal(null);
    setEquipoSel(null); setTareaForm(null);
  };

  const stub = (titulo:string, texto:string) => (
    <div style={{textAlign:"center" as const, padding:"54px 20px", background:C.panel, border:`1px solid ${C.line}`, borderRadius:16, boxShadow:C.sombra}}>
      <div style={{fontFamily:fontSerif, fontSize:17, fontWeight:700, color:C.gold, marginBottom:6}}>{titulo}</div>
      <p style={{fontSize:12.5, color:C.inkSoft, margin:0, lineHeight:1.5}}>{texto}</p>
    </div>
  );

  // ════════════ CALENDARIO (solo lectura) ════════════
  // Capa legal: fechas verificadas 2026 (descanso obligatorio art. 74 LFT +
  // obligaciones fiscales/patronales) + recurrente día 17 de cada mes.
  // Capa "Mis vencimientos": se derivan de atencionUrgente (ya cargado) usando
  // su fecha real = hoy + dias. NO se crean colecciones ni queries.
  const calHoy = new Date(); calHoy.setHours(0,0,0,0);
  const calHoyISO = `${calHoy.getFullYear()}-${String(calHoy.getMonth()+1).padStart(2,"0")}-${String(calHoy.getDate()).padStart(2,"0")}`;
  const isoDe = (d:Date)=> `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`;
  const LEGAL_2026 = [
    // Días de descanso obligatorio (art. 74 LFT)
    {f:"2026-01-01", t:"Año Nuevo", q:"Día de descanso obligatorio (art. 74 LFT).", cat:"descanso"},
    {f:"2026-02-02", t:"Día de la Constitución", q:"Descanso obligatorio; conmemora el 5 de febrero.", cat:"descanso"},
    {f:"2026-03-16", t:"Natalicio de Benito Juárez", q:"Descanso obligatorio; conmemora el 21 de marzo.", cat:"descanso"},
    {f:"2026-05-01", t:"Día del Trabajo", q:"Día de descanso obligatorio (art. 74 LFT).", cat:"descanso"},
    {f:"2026-09-16", t:"Independencia", q:"Día de descanso obligatorio (art. 74 LFT).", cat:"descanso"},
    {f:"2026-11-16", t:"Revolución Mexicana", q:"Descanso obligatorio; conmemora el 20 de noviembre.", cat:"descanso"},
    {f:"2026-12-25", t:"Navidad", q:"Día de descanso obligatorio (art. 74 LFT).", cat:"descanso"},
    // Obligaciones fiscales / patronales
    {f:"2026-02-28", t:"Prima de riesgo de trabajo (IMSS)", q:"Declaración anual de la prima de RT ante el IMSS.", cat:"fiscal"},
    {f:"2026-03-31", t:"Declaración anual personas morales", q:"Límite del anual de ISR para personas morales.", cat:"fiscal"},
    {f:"2026-04-30", t:"Declaración anual personas físicas", q:"Límite del anual de ISR para personas físicas.", cat:"fiscal"},
    {f:"2026-05-30", t:"Límite PTU (personas morales)", q:"Fecha límite de reparto de utilidades (morales).", cat:"fiscal"},
    {f:"2026-06-29", t:"Límite PTU (personas físicas)", q:"Fecha límite de reparto de utilidades (físicas).", cat:"fiscal"},
    {f:"2026-12-20", t:"Límite pago de aguinaldo", q:"Fecha límite para pagar el aguinaldo (art. 87 LFT).", cat:"fiscal"},
  ];
  const colorCat = (ev:any) => ev.tipo==="venc"
    ? (ev.cat==="vencido" ? "#FCA5A5" : "#E2B84A")
    : ev.tipo==="empresa" ? "#7FD1C0"
    : (ev.cat==="descanso" ? "#86C8A8" : "#8FB8D6");
  const etiquetaCat = (ev:any) => ev.tipo==="venc"
    ? (ev.cat==="vencido" ? "Vencido" : "Por vencer")
    : ev.tipo==="empresa" ? "Empresa"
    : (ev.cat==="descanso" ? "Descanso obligatorio" : "Fiscal/patronal");
  // Construye el mapa { iso → eventos[] } del mes visible (ya filtrado por chip).
  const eventosDelMes = (() => {
    const map:Record<string,any[]> = {};
    const add = (iso:string, ev:any)=>{ (map[iso] = map[iso]||[]).push(ev); };
    const incluyeLegal = calFiltro==="todo" || calFiltro==="legal";
    const incluyeVenc  = calFiltro==="todo" || calFiltro==="vencimientos";
    if (incluyeLegal) {
      LEGAL_2026.forEach(e=>{ const [yy,mm] = e.f.split("-").map(Number); if (yy===calY && mm===calM+1) add(e.f, {tipo:"legal", cat:e.cat, titulo:e.t, detalle:e.q}); });
      // Recurrente: día 17 de cada mes.
      const f17 = `${calY}-${String(calM+1).padStart(2,"0")}-17`;
      add(f17, {tipo:"legal", cat:"fiscal", titulo:"Pago provisional ISR/IVA y cuotas IMSS", detalle:"Pagos provisionales mensuales y cuotas obrero-patronales."});
    }
    if (incluyeVenc) {
      (atencionMovil||[]).forEach((it:any)=>{ const d=new Date(calHoy); d.setDate(d.getDate()+(it.dias||0)); if (d.getFullYear()===calY && d.getMonth()===calM) add(isoDe(d), {tipo:"venc", cat:it.severidad, titulo:it.titulo, detalle:`${it.moduloLabel} · ${it.detalle}`}); });
    }
    if (calFiltro==="todo" || calFiltro==="empresa") {
      comunicados.filter((c:any)=>c.tipo==="evento" && c.fecha).forEach((c:any)=>{ const [yy,mm]=String(c.fecha).split("-").map(Number); if (yy===calY && mm===calM+1) add(c.fecha, {tipo:"empresa", titulo:c.titulo||"Evento", detalle:[c.hora, c.lugar, c.mensaje].filter(Boolean).join(" · ")}); });
    }
    return map;
  })();
  const nombreMes = new Date(calY, calM, 1).toLocaleDateString("es-MX",{month:"long", year:"numeric"});
  const primerDiaSemana = new Date(calY, calM, 1).getDay();      // 0=Dom
  const diasEnMes = new Date(calY, calM+1, 0).getDate();
  const celdasCal:(number|null)[] = [...Array(primerDiaSemana).fill(null), ...Array.from({length:diasEnMes},(_,i)=>i+1)];
  const calPrev = ()=>{ setCalDiaSel(null); if (calM===0){ setCalM(11); setCalY(y=>y-1);} else setCalM(m=>m-1); };
  const calNext = ()=>{ setCalDiaSel(null); if (calM===11){ setCalM(0); setCalY(y=>y+1);} else setCalM(m=>m+1); };
  const eventosDiaSel = calDiaSel ? (eventosDelMes[calDiaSel]||[]) : [];

  // Lista "Próximos ~60 días": legal + vencimientos mezclados y ordenados por fecha
  // (independiente del mes visible). Respeta el filtro Legal / Mis vencimientos.
  const enXdias = (n:number)=> n===0?"Hoy":n===1?"Mañana":`en ${n} días`;
  const proximos = (() => {
    const arr:any[] = [];
    const diasDe = (d:Date)=> Math.round((d.getTime()-calHoy.getTime())/86400000);
    const incluyeLegal = calFiltro==="todo" || calFiltro==="legal";
    const incluyeVenc  = calFiltro==="todo" || calFiltro==="vencimientos";
    if (incluyeLegal) {
      LEGAL_2026.forEach(e=>{ const [y,m,d]=e.f.split("-").map(Number); const dt=new Date(y,m-1,d); const dd=diasDe(dt); if (dd>=0 && dd<=60) arr.push({f:dt, dd, tipo:"legal", cat:e.cat, titulo:e.t, detalle:e.q}); });
      // Recurrente día 17: genera los de la ventana (este mes y los 2 siguientes).
      for (let k=0;k<3;k++){ const dt=new Date(calHoy.getFullYear(), calHoy.getMonth()+k, 17); const dd=diasDe(dt); if (dd>=0 && dd<=60) arr.push({f:dt, dd, tipo:"legal", cat:"fiscal", titulo:"Pago provisional ISR/IVA y cuotas IMSS", detalle:"Pagos provisionales mensuales y cuotas obrero-patronales."}); }
    }
    if (incluyeVenc) {
      (atencionMovil||[]).forEach((it:any)=>{ const dd=it.dias||0; if (dd>=0 && dd<=60){ const dt=new Date(calHoy); dt.setDate(dt.getDate()+dd); arr.push({f:dt, dd, tipo:"venc", cat:it.severidad, titulo:it.titulo, detalle:`${it.moduloLabel} · ${it.detalle}`}); } });
    }
    if (calFiltro==="todo" || calFiltro==="empresa") {
      comunicados.filter((c:any)=>c.tipo==="evento" && c.fecha).forEach((c:any)=>{ const [y,m,d]=String(c.fecha).split("-").map(Number); const dt=new Date(y,m-1,d); const dd=diasDe(dt); if (dd>=0 && dd<=60) arr.push({f:dt, dd, tipo:"empresa", titulo:c.titulo||"Evento", detalle:[c.hora, c.lugar].filter(Boolean).join(" · ")}); });
    }
    return arr.sort((a:any,b:any)=> a.dd - b.dd);
  })();
  const feriadosAsueto = LEGAL_2026.filter(e=>e.cat==="descanso");

  // Conteo de fechas próximas (≤60 días) para la tarjeta de Inicio — independiente del
  // filtro del calendario: legal + recurrente día 17 + vencimientos + eventos de empresa.
  const conteoProximos = (() => {
    let n = 0;
    const diasDe = (d:Date)=> Math.round((d.getTime()-calHoy.getTime())/86400000);
    LEGAL_2026.forEach(e=>{ const [y,m,d]=e.f.split("-").map(Number); const dd=diasDe(new Date(y,m-1,d)); if (dd>=0 && dd<=60) n++; });
    for (let k=0;k<3;k++){ const dd=diasDe(new Date(calHoy.getFullYear(), calHoy.getMonth()+k, 17)); if (dd>=0 && dd<=60) n++; }
    (atencionMovil||[]).forEach((it:any)=>{ const dd=it.dias||0; if (dd>=0 && dd<=60) n++; });
    comunicados.filter((c:any)=>c.tipo==="evento" && c.fecha).forEach((c:any)=>{ const [y,m,d]=String(c.fecha).split("-").map(Number); const dd=diasDe(new Date(y,m-1,d)); if (dd>=0 && dd<=60) n++; });
    return n;
  })();

  // Fechas que YA urgen (≤7 días): eventos de empresa + fechas legales/fiscales.
  // Se muestran como ítems de alerta dentro de "Qué atender hoy" (tocar → calendario).
  const fechasAlerta = (() => {
    const arr:any[] = [];
    const diasDe = (d:Date)=> Math.round((d.getTime()-calHoy.getTime())/86400000);
    const cuandoDe = (dd:number)=> dd===0?"Hoy":dd===1?"Mañana":`En ${dd} días`;
    LEGAL_2026.forEach(e=>{ const [y,m,d]=e.f.split("-").map(Number); const dd=diasDe(new Date(y,m-1,d)); if (dd>=0 && dd<=7) arr.push({titulo:e.t, dd, cuando:cuandoDe(dd)}); });
    for (let k=0;k<2;k++){ const dd=diasDe(new Date(calHoy.getFullYear(), calHoy.getMonth()+k, 17)); if (dd>=0 && dd<=7) arr.push({titulo:"Pago provisional ISR/IVA y cuotas IMSS", dd, cuando:cuandoDe(dd)}); }
    comunicados.filter((c:any)=>c.tipo==="evento" && c.fecha).forEach((c:any)=>{ const [y,m,d]=String(c.fecha).split("-").map(Number); const dd=diasDe(new Date(y,m-1,d)); if (dd>=0 && dd<=7) arr.push({titulo:c.titulo||"Evento", dd, cuando:cuandoDe(dd)}); });
    return arr.sort((a:any,b:any)=> a.dd - b.dd);
  })();

  // ⚠️ YA NO SON "GRAVES": son los que REQUIEREN ATENCIÓN, y la lista no se calcula
  // aquí. Antes esto filtraba `gravedad === "Grave"` por su cuenta y la ventana de 7
  // días contaba desde el registro. Ahora es la MISMA lista que pinta el escudo del
  // escritorio —`accidentesPendientes`, calculada en `useDashboardData`—: con
  // lesionados, sin confirmar, o graves de los registros viejos, y la ventana desde
  // el último hecho.
  const accidentesAtender = accidentesPendientes || [];

  // ── Ventana FLOTILLA (móvil, SOLO LECTURA) ─────────────────────────────────
  // Vehículos: colección 'vehiculos' (v con sus fechas de documentos). Estado de
  // docs: calcularComplianceVehiculo (mismo cálculo que el escritorio y las alertas).
  // Movimientos: flotillaPatron (colección 'flotilla'), filtrados por placa en JS.
  const vehiculosMv = (vehiculos||[]).filter((v:any)=> (v.status||"activo")==="activo")
    .sort((a:any,b:any)=> (a.placa||"").localeCompare(b.placa||""));
  // UN DOCUMENTO SIN FECHA NO ESTÁ VIGENTE. Aquí caía en el `else` y salía en
  // verde diciendo "Vigente": la pantalla afirmaba que un seguro que nadie había
  // capturado estaba al corriente. Tampoco es una falta —nadie puede decir que la
  // unidad circule sin él—: es un pendiente de captura, y se dice así, en gris.
  const chipDocFlota = (d:any, fecha:string) => {
    const meta = d.estado==="vencido" ? {c:"#FCA5A5", bg:"rgba(220,38,38,0.12)", bd:"rgba(252,165,165,0.45)", txt: d.dias!=null?`Vencido · hace ${Math.abs(d.dias)}d`:"Vencido"}
      : d.estado==="por_vencer" ? {c:"#E2B84A", bg:"rgba(226,184,74,0.12)", bd:"rgba(226,184,74,0.45)", txt: d.dias!=null?`Por vencer · ${d.dias}d`:"Por vencer"}
      : d.estado==="sin_registro" ? {c:"#B9C0CF", bg:"rgba(255,255,255,0.06)", bd:"rgba(255,255,255,0.18)", txt:"Sin registrar"}
      : {c:"#34D399", bg:"rgba(52,211,153,0.12)", bd:"rgba(52,211,153,0.40)", txt:"Vigente"};
    return (
      <div key={d.key} style={{display:"flex", alignItems:"center", justifyContent:"space-between", gap:8, padding:"6px 0", borderTop:`1px solid ${C.lineSoft||"rgba(255,255,255,0.06)"}`}}>
        <div style={{minWidth:0}}>
          <div style={{fontSize:12.5, color:C.ink, fontWeight:600}}>{d.labelCorto||d.label}</div>
          {fecha && <div style={{fontSize:10.5, color:C.inkMut}}>{fecha}</div>}
        </div>
        <span style={{fontSize:10.5, fontWeight:800, padding:"3px 9px", borderRadius:999, whiteSpace:"nowrap" as const, border:`1px solid ${meta.bd}`, background:meta.bg, color:meta.c, flexShrink:0}}>{meta.txt}</span>
      </div>
    );
  };
  // Chip de estado GENERAL del vehículo. Sale de resumenDocumentalVehiculo, la
  // MISMA función que el expediente y la lista del escritorio: tres pantallas no
  // pueden decir cosas distintas del mismo vehículo. Antes esta decía "Al día"
  // cuando faltaba un documento por capturar, que es justo lo contrario.
  const chipGeneralFlota = (resumen:{corto:string; tono:string}) => {
    const meta = resumen.tono==="critico" ? {c:"#FCA5A5", bg:"rgba(220,38,38,0.14)", bd:"rgba(252,165,165,0.45)"}
      : resumen.tono==="pendiente" ? {c:"#E2B84A", bg:"rgba(226,184,74,0.14)", bd:"rgba(226,184,74,0.45)"}
      : {c:"#34D399", bg:"rgba(52,211,153,0.13)", bd:"rgba(52,211,153,0.40)"};
    return <span style={{fontSize:10.5, fontWeight:800, padding:"3px 10px", borderRadius:999, whiteSpace:"nowrap" as const, border:`1px solid ${meta.bd}`, background:meta.bg, color:meta.c, flexShrink:0}}>{resumen.corto}</span>;
  };
  // Lista con estado calculado, filtrada (Todos / Con pendientes) y ORDENADA:
  // vencidos primero, luego por vencer, al final al día (y por placa dentro de cada grupo).
  const rankFlota = (n:string)=> n==="critico"?0 : n==="pendiente"?1 : 2;
  const flotillaLista = vehiculosMv
    .map((v:any)=>{
      const docs = calcularComplianceVehiculo(v).documentos;
      const resumen = resumenDocumentalVehiculo(v);
      const nVenc = docs.filter((d:any)=>d.estado==="vencido").length;
      const nProx = docs.filter((d:any)=>d.estado==="por_vencer").length;
      // El nivel sale del resumen, así que "sin registrar" ya cuenta como
      // pendiente y la unidad sube en la lista en vez de esconderse entre las
      // que están al día.
      const nivel = resumen.tono;
      return {v, docs, resumen, nVenc, nProx, nivel};
    })
    .filter((x:any)=> flotillaFiltro==="todos" ? true : x.nivel!=="ok")
    .sort((a:any,b:any)=>{
      const r = rankFlota(a.nivel)-rankFlota(b.nivel);
      return r!==0 ? r : (a.v.placa||"").localeCompare(b.v.placa||"");
    });
  const flotillaScreen = (
    <>
      <button onClick={()=>{ setVerFlotilla(false); setFlotillaFoco(""); setFlotillaAbierto(""); }}
        style={{display:"inline-flex", alignItems:"center", gap:6, background:"transparent", border:"none", color:C.gold, cursor:"pointer", fontFamily:fontSans, fontSize:13, fontWeight:700, padding:"0 0 12px"}}>
        <span style={{fontSize:16, lineHeight:1}}>‹</span> Inicio
      </button>
      <div style={{marginBottom:12}}>
        <h1 style={{fontFamily:fontSerif, fontSize:24, fontWeight:700, color:C.ink, margin:0, lineHeight:1.1}}>Flotilla</h1>
        <p style={{fontSize:12.5, color:C.inkSoft, margin:"3px 0 0"}}>{loading?"Cargando…":`${vehiculosMv.length} vehículo${vehiculosMv.length===1?"":"s"} · solo lectura`}</p>
      </div>
      {/* Punto de entrada del reporte. Sin unidades no se ofrece: sería un
          documento sobre nada, justo encima del mensaje de que no hay flotilla. */}
      {vehiculosMv.length>0 && (
        <ControlReporteFlotillaMovil
          mes={mesRepFlotaMv} setMes={setMesRepFlotaMv}
          generando={generandoRepFlotaMv} msg={msgRepFlotaMv}
          onGenerar={generarReporteFlotillaMv} C={C} fontSans={fontSans}/>
      )}
      {vehiculosMv.length===0 ? (
        <div style={{textAlign:"center" as const, padding:"40px 20px", background:C.panel, border:`1px solid ${C.line}`, borderRadius:16, boxShadow:C.sombra}}>
          <div style={{fontFamily:fontSerif, fontSize:16, fontWeight:700, color:C.gold, marginBottom:6}}>Sin vehículos</div>
          <p style={{fontSize:12.5, color:C.inkSoft, margin:0, lineHeight:1.5}}>Registra tu flotilla desde la plataforma (escritorio).</p>
        </div>
      ) : (
        <>
          {/* Filtro mínimo: Todos / Con pendientes (los que tienen vencidos o por vencer) */}
          <div style={{display:"flex", gap:7, marginBottom:12}}>
            {([["todos","Todos"],["pendientes","Con pendientes"]] as const).map(([val,lbl])=>{
              const on = flotillaFiltro===val;
              return <button key={val} type="button" onClick={()=>setFlotillaFiltro(val)}
                style={{padding:"7px 13px", borderRadius:999, border:`1px solid ${on?C.gold:C.line}`, cursor:"pointer", fontSize:12, fontWeight:700, fontFamily:fontSans,
                  background:on?C.gold:"transparent", color:on?"#0B1829":C.inkSoft}}>{lbl}</button>;
            })}
          </div>
          {flotillaLista.length===0 ? (
            <div style={{textAlign:"center" as const, padding:"28px 20px", background:C.panel, border:`1px solid ${C.line}`, borderRadius:16, boxShadow:C.sombra}}>
              <div style={{fontSize:13, fontWeight:700, color:"#34D399", marginBottom:4}}>Todo al día ✓</div>
              <p style={{fontSize:12, color:C.inkSoft, margin:0}}>Ningún vehículo tiene documentos vencidos o por vencer.</p>
            </div>
          ) : (
          <div style={{display:"flex", flexDirection:"column" as const, gap:10}}>
            {flotillaLista.map(({v, docs, resumen, nivel}:any)=>{
              const abierto = flotillaAbierto===v.id;
              const focoOn = !!(flotillaFoco && v.id===flotillaFoco) && _resUnidad.vivo;
              const bordeCol = focoOn ? C.gold : nivel==="vencido" ? "rgba(252,165,165,0.45)" : C.line;
              const movs = (flotillaPatron||[])
                .filter((f:any)=> (f.placa||"").toUpperCase()===(v.placa||"").toUpperCase())
                .sort((a:any,b:any)=>(b.timestamp?.toMillis?.()||0)-(a.timestamp?.toMillis?.()||0))
                .slice(0,3);
              return (
                <div key={v.id} ref={focoOn ? flotillaFocoRef : undefined}
                  style={{background:C.panel, border:`1px solid ${bordeCol}`, borderRadius:14, boxShadow: focoOn ? `0 0 0 2px rgba(${A.rgbDim},0.35), ${C.sombra}` : C.sombra, overflow:"hidden"}}>
                  {/* Fila compacta (colapsada por defecto). Toda la fila alterna el acordeón. */}
                  <button onClick={()=>setFlotillaAbierto(abierto?"":v.id)}
                    style={{display:"flex", alignItems:"center", gap:10, width:"100%", padding:"12px 13px", background:"transparent", border:"none", cursor:"pointer", fontFamily:fontSans, textAlign:"left" as const}}>
                    <div style={{width:36, height:36, borderRadius:10, flexShrink:0, display:"flex", alignItems:"center", justifyContent:"center", background:C.iconBg, border:`1px solid ${C.iconBd}`, color:C.gold}}>
                      <svg width="19" height="19" viewBox="0 0 24 24" fill="none"><rect x="2.5" y="10" width="19" height="8" rx="2.4" stroke="currentColor" strokeWidth="1.7"/><path d="M6 10V8a2 2 0 012-2h8a2 2 0 012 2v2" stroke="currentColor" strokeWidth="1.7"/><circle cx="7" cy="18.5" r="2" stroke="currentColor" strokeWidth="1.7"/><circle cx="17" cy="18.5" r="2" stroke="currentColor" strokeWidth="1.7"/></svg>
                    </div>
                    <div style={{flex:1, minWidth:0}}>
                      <div style={{fontSize:14.5, fontWeight:800, color:C.ink, letterSpacing:"0.5px", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" as const}}>{v.placa||"Sin placa"}</div>
                      {[v.marca, v.modelo, v.anio].filter(Boolean).length>0 && (
                        <div style={{fontSize:11.5, color:C.inkSoft, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" as const}}>{[v.marca, v.modelo, v.anio].filter(Boolean).join(" · ")}</div>
                      )}
                    </div>
                    {chipGeneralFlota(resumen)}
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" style={{flexShrink:0, color:C.inkMut, transform:abierto?"rotate(180deg)":"none", transition:"transform 0.18s ease"}}>
                      <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
                  {/* Detalle (acordeón): documentos con fecha + chip, y últimos movimientos. */}
                  {abierto && (
                    <div style={{padding:"0 14px 13px"}}>
                      <div>{docs.map((d:any)=> chipDocFlota(d, (v as any)[d.key] || ""))}</div>
                      {movs.length>0 && (
                        <div style={{marginTop:10, paddingTop:9, borderTop:`1px solid ${C.line}`}}>
                          <div style={{fontSize:10.5, color:C.inkMut, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"0.6px", marginBottom:5}}>Últimos movimientos</div>
                          {movs.map((f:any,i:number)=>{
                            const d=f.timestamp?.toDate?.(); const cuando=d?d.toLocaleDateString("es-MX",{day:"2-digit",month:"short",hour:"2-digit",minute:"2-digit"}):"—";
                            const km=(f.kmFinal??f.kmLlegada??f.kmInicial); const lbl=f.tipo==="salida"?"Salida":f.tipo==="llegada"?"Llegada":"Regreso";
                            const det=[f.destino, (km!=null&&km!==""?`${km} km`:null)].filter(Boolean).join(" · ");
                            return <div key={i} style={{fontSize:11.5, color:C.inkSoft, marginBottom:2}}><span style={{color:C.gold, fontWeight:700}}>{lbl}</span> · {cuando}{det?` · ${det}`:""}</div>;
                          })}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
            <p style={{fontSize:11.5, color:C.inkMut, margin:"6px 2px 0", lineHeight:1.5}}>Vista de solo lectura. Gestiona la flotilla (alta, documentos, edición) desde la plataforma de escritorio.</p>
          </div>
          )}
        </>
      )}
    </>
  );

  const calendarioScreen = (
    <>
      <button onClick={()=>setVerCalendario(false)}
        style={{display:"inline-flex", alignItems:"center", gap:6, background:"transparent", border:"none", color:C.gold, cursor:"pointer", fontFamily:fontSans, fontSize:13, fontWeight:700, padding:"0 0 12px"}}>
        <span style={{fontSize:16, lineHeight:1}}>‹</span> Inicio
      </button>
      <div style={{display:"flex", alignItems:"flex-start", justifyContent:"space-between", gap:10, marginBottom:12}}>
        <div style={{minWidth:0}}>
          <h1 style={{fontFamily:fontSerif, fontSize:24, fontWeight:700, color:C.ink, margin:0, lineHeight:1.1}}>Calendario</h1>
          <p style={{fontSize:13, color:C.inkSoft, margin:"3px 0 0"}}>Fechas legales 2026 y tus vencimientos.</p>
        </div>
        <button onClick={()=>setVerAsuetos(true)}
          style={{flexShrink:0, display:"inline-flex", alignItems:"center", gap:6, marginTop:3, padding:"8px 11px", borderRadius:10, border:`1px solid ${C.line}`, background:C.panel, color:C.gold, cursor:"pointer", fontFamily:fontSans, fontSize:11.5, fontWeight:700, whiteSpace:"nowrap" as const, boxShadow:C.sombra}}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><rect x="3.5" y="5" width="17" height="16" rx="2.5" stroke="currentColor" strokeWidth="1.8"/><path d="M3.5 9.5h17M8 3.2v3.2M16 3.2v3.2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>
          Días de asueto
        </button>
      </div>

      {/* Filtros */}
      <div style={{display:"flex", gap:7, marginBottom:12, flexWrap:"wrap" as const}}>
        {([["todo","Todo"],["legal","Legal"],["vencimientos","Mis vencimientos"],["empresa","Empresa"]] as const).map(([v,l])=>{
          const on = calFiltro===v;
          return <button key={v} type="button" onClick={()=>{ setCalFiltro(v); setCalDiaSel(null); }}
            style={{padding:"7px 13px", borderRadius:999, border:`1px solid ${on?C.gold:C.line}`, cursor:"pointer", fontSize:12, fontWeight:700, fontFamily:fontSans,
              background:on?C.gold:"transparent", color:on?"#0B1829":C.inkSoft}}>{l}</button>;
        })}
      </div>

      {/* Crear evento de empresa (abre el compositor en modo evento).
          onClick diferido: abrirEvento se declara más abajo; envolverlo evita el TDZ
          que dejaba en blanco (solo navy) el portal del patrón en móvil. */}
      <button onClick={()=>abrirEvento()}
        style={{display:"flex", alignItems:"center", justifyContent:"center", gap:8, width:"100%", marginBottom:14, padding:"11px 14px", borderRadius:12, border:`1px solid ${C.gold}`, background:`rgba(${A.rgbBright},0.12)`, color:C.gold, cursor:"pointer", fontFamily:fontSans, fontSize:13, fontWeight:800}}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
        Crear evento de empresa
      </button>

      {(
        <>
          {/* Navegación de mes */}
          <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:10}}>
            <button onClick={calPrev} aria-label="Mes anterior" style={{width:38, height:38, borderRadius:10, border:`1px solid ${C.line}`, background:C.panel, color:C.gold, cursor:"pointer", fontSize:18, fontFamily:fontSans}}>‹</button>
            <div style={{fontFamily:fontSerif, fontSize:17, fontWeight:700, color:C.ink, textTransform:"capitalize" as const}}>{nombreMes}</div>
            <button onClick={calNext} aria-label="Mes siguiente" style={{width:38, height:38, borderRadius:10, border:`1px solid ${C.line}`, background:C.panel, color:C.gold, cursor:"pointer", fontSize:18, fontFamily:fontSans}}>›</button>
          </div>

          {/* Cuadrícula */}
          <div style={{background:C.panel, border:`1px solid ${C.line}`, borderRadius:16, padding:"12px 10px", boxShadow:C.sombra, marginBottom:14}}>
            <div style={{display:"grid", gridTemplateColumns:"repeat(7,1fr)", gap:2, marginBottom:4}}>
              {["D","L","M","M","J","V","S"].map((d,i)=>(<div key={i} style={{textAlign:"center" as const, fontSize:10.5, fontWeight:700, color:C.inkMut, padding:"2px 0"}}>{d}</div>))}
            </div>
            <div style={{display:"grid", gridTemplateColumns:"repeat(7,1fr)", gap:2}}>
              {celdasCal.map((dia,i)=>{
                if (dia===null) return <div key={`b${i}`}/>;
                const iso = `${calY}-${String(calM+1).padStart(2,"0")}-${String(dia).padStart(2,"0")}`;
                const evs = eventosDelMes[iso]||[];
                const esHoy = iso===calHoyISO;
                const sel = iso===calDiaSel;
                const colores = Array.from(new Set(evs.map(colorCat))).slice(0,3);
                return (
                  <button key={iso} onClick={()=>setCalDiaSel(sel?null:iso)}
                    style={{aspectRatio:"1 / 1", display:"flex", flexDirection:"column" as const, alignItems:"center", justifyContent:"center", gap:3,
                      borderRadius:9, cursor:"pointer", fontFamily:fontSans, padding:0,
                      border:`1px solid ${sel?C.gold:esHoy?`rgba(${A.rgbBright},0.4)`:"transparent"}`,
                      background:sel?`rgba(${A.rgbBright},0.16)`:esHoy?`rgba(${A.rgbBright},0.07)`:"transparent"}}>
                    <span style={{fontSize:13, fontWeight:esHoy||sel?800:600, color:esHoy||sel?C.gold:C.ink}}>{dia}</span>
                    <span style={{display:"flex", gap:2, height:5, alignItems:"center"}}>
                      {colores.map((c,ci)=>(<span key={ci} style={{width:5, height:5, borderRadius:"50%", background:c}}/>))}
                    </span>
                  </button>
                );
              })}
            </div>
          </div>

          {/* Eventos del día seleccionado */}
          {!calDiaSel ? (
            <div style={{textAlign:"center" as const, padding:"22px 20px", background:C.panel, border:`1px solid ${C.line}`, borderRadius:16, boxShadow:C.sombra}}>
              <div style={{fontSize:12.5, color:C.inkSoft, lineHeight:1.5}}>Toca un día con marca para ver sus eventos.</div>
            </div>
          ) : eventosDiaSel.length===0 ? (
            <div style={{textAlign:"center" as const, padding:"22px 20px", background:C.panel, border:`1px solid ${C.line}`, borderRadius:16, boxShadow:C.sombra}}>
              <div style={{fontSize:12.5, color:C.inkSoft, lineHeight:1.5}}>Sin eventos este día.</div>
            </div>
          ) : (
            <>
              <div style={{fontSize:11, color:C.gold, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"0.8px", margin:"0 2px 8px"}}>
                {new Date(calY, calM, Number(calDiaSel.slice(-2))).toLocaleDateString("es-MX",{weekday:"long", day:"numeric", month:"long"})}
              </div>
              <div style={{display:"flex", flexDirection:"column" as const, gap:9}}>
                {eventosDiaSel.map((ev:any,i:number)=>{
                  const col = colorCat(ev);
                  return (
                    <div key={i} style={{background:C.panel, border:`1px solid ${C.line}`, borderLeft:`3px solid ${col}`, borderRadius:14, padding:"12px 13px", boxShadow:C.sombra}}>
                      <div style={{display:"flex", alignItems:"baseline", gap:8, flexWrap:"wrap" as const, marginBottom:3}}>
                        <span style={{fontSize:13.5, fontWeight:700, color:C.ink, flex:1, minWidth:0}}>{ev.titulo}</span>
                        <span style={{fontSize:10, fontWeight:800, padding:"2px 8px", borderRadius:999, border:`1px solid ${col}66`, color:col, whiteSpace:"nowrap" as const}}>{etiquetaCat(ev)}</span>
                      </div>
                      {ev.detalle && <div style={{fontSize:12, color:C.inkSoft, lineHeight:1.4}}>{ev.detalle}</div>}
                    </div>
                  );
                })}
              </div>
            </>
          )}

          {/* Próximos ~60 días (legal + vencimientos mezclados, por fecha) */}
          <div style={{marginTop:20}}>
            <div style={{fontSize:11, color:C.inkMut, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"1px", margin:"0 2px 10px"}}>Próximos · 60 días</div>
            {proximos.length===0 ? (
              <div style={{textAlign:"center" as const, padding:"22px 20px", background:C.panel, border:`1px solid ${C.line}`, borderRadius:16, boxShadow:C.sombra}}>
                <div style={{fontSize:12.5, color:C.inkSoft, lineHeight:1.5}}>Nada en los próximos 60 días.</div>
              </div>
            ) : (
              <div style={{display:"flex", flexDirection:"column" as const, gap:8}}>
                {proximos.map((ev:any,i:number)=>{
                  const col = colorCat(ev);
                  return (
                    <div key={i} style={{display:"flex", alignItems:"center", gap:12, background:C.panel, border:`1px solid ${C.line}`, borderLeft:`3px solid ${col}`, borderRadius:13, padding:"10px 13px", boxShadow:C.sombra}}>
                      <div style={{flexShrink:0, textAlign:"center" as const, minWidth:38}}>
                        <div style={{fontSize:17, fontWeight:800, color:C.ink, fontFamily:fontSerif, lineHeight:1}}>{ev.f.getDate()}</div>
                        <div style={{fontSize:9.5, color:C.inkMut, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>{ev.f.toLocaleDateString("es-MX",{month:"short"})}</div>
                      </div>
                      <div style={{flex:1, minWidth:0}}>
                        <div style={{fontSize:13, fontWeight:700, color:C.ink}}>{ev.titulo}</div>
                        {ev.detalle && <div style={{fontSize:11.5, color:C.inkSoft, marginTop:1}}>{ev.detalle}</div>}
                      </div>
                      <div style={{flexShrink:0, fontSize:11, fontWeight:800, color:col, whiteSpace:"nowrap" as const}}>{enXdias(ev.dd)}</div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          {/* Leyenda */}
          <div style={{display:"flex", flexWrap:"wrap" as const, gap:"6px 14px", margin:"16px 2px 0"}}>
            {[["#86C8A8","Descanso obligatorio"],["#8FB8D6","Fiscal/patronal"],["#7FD1C0","Empresa"],["#E2B84A","Por vencer"],["#FCA5A5","Vencido"]].map(([c,l])=>(
              <span key={l} style={{display:"inline-flex", alignItems:"center", gap:6, fontSize:11, color:C.inkSoft}}>
                <span style={{width:8, height:8, borderRadius:"50%", background:c}}/>{l}
              </span>
            ))}
          </div>
        </>
      )}

      {/* Hoja: Días de asueto por ley (descanso obligatorio art. 74 LFT) */}
      {verAsuetos && (
        <div onClick={()=>setVerAsuetos(false)} style={{position:"fixed" as const, inset:0, zIndex:2000, background:"rgba(3,10,22,0.72)", display:"flex", alignItems:"flex-end", justifyContent:"center"}}>
          <div onClick={e=>e.stopPropagation()} style={{width:"100%", maxWidth:560, background:C.bg, borderTop:`1px solid ${C.line}`, borderRadius:"18px 18px 0 0", padding:"18px 16px 28px", maxHeight:"82vh", overflowY:"auto" as const, boxShadow:"0 -8px 40px rgba(0,0,0,0.5)"}}>
            <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", gap:10, marginBottom:3}}>
              <h2 style={{fontFamily:fontSerif, fontSize:19, fontWeight:700, color:C.gold, margin:0}}>Días de asueto por ley</h2>
              <button onClick={()=>setVerAsuetos(false)} aria-label="Cerrar" style={{width:32, height:32, borderRadius:"50%", border:`1px solid ${C.line}`, background:"transparent", color:C.ink, cursor:"pointer", fontSize:17, lineHeight:1, fontFamily:fontSans, flexShrink:0}}>×</button>
            </div>
            <p style={{fontSize:12, color:C.inkSoft, margin:"0 0 14px"}}>Descanso obligatorio 2026 (art. 74 LFT).</p>
            <div style={{display:"flex", flexDirection:"column" as const, gap:8}}>
              {feriadosAsueto.map((e:any,i:number)=>{
                const [y,m,d] = e.f.split("-").map(Number);
                const dt = new Date(y, m-1, d);
                return (
                  <div key={i} style={{display:"flex", alignItems:"center", gap:13, background:C.panel, border:`1px solid ${C.line}`, borderLeft:"3px solid #86C8A8", borderRadius:13, padding:"11px 13px"}}>
                    <div style={{flexShrink:0, textAlign:"center" as const, minWidth:40}}>
                      <div style={{fontSize:18, fontWeight:800, color:C.ink, fontFamily:fontSerif, lineHeight:1}}>{d}</div>
                      <div style={{fontSize:9.5, color:C.inkMut, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>{dt.toLocaleDateString("es-MX",{month:"short"})}</div>
                    </div>
                    <div style={{flex:1, minWidth:0}}>
                      <div style={{fontSize:13.5, fontWeight:700, color:C.ink}}>{e.t}</div>
                      <div style={{fontSize:11.5, color:C.inkSoft, textTransform:"capitalize" as const, marginTop:1}}>{dt.toLocaleDateString("es-MX",{weekday:"long"})}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </>
  );

  // ═══════ COMPOSITOR DE COMUNICADOS (aviso sin fecha · evento con fecha) ═══════
  const resetAviso = ()=>{ setAvisoOk(false); setAvisoErr(""); setAvisoEditId(null); setAvisoTitulo(""); setAvisoMensaje(""); setAvisoFecha(""); setAvisoHora(""); setAvisoLugar(""); setAvisoAdjuntoUrl(""); setAvisoAdjuntoTipo(""); setAvisoAdjuntoNombre(""); };
  const abrirAviso  = ()=>{ resetAviso(); setAvisoModo("aviso"); setVerAviso(true); };
  const abrirEvento = ()=>{ resetAviso(); setAvisoModo("evento"); setVerCalendario(false); setVerAviso(true); };
  // Abre el compositor en modo EDICIÓN de un comunicado ya publicado.
  const abrirEditarComunicado = (c:any)=>{
    setAvisoOk(false); setAvisoErr(""); setAvisoEditId(c.id);
    setAvisoModo(c.tipo==="evento" ? "evento" : "aviso");
    setAvisoTitulo(c.titulo||""); setAvisoMensaje(c.mensaje||"");
    setAvisoFecha(c.fecha||""); setAvisoHora(c.hora||""); setAvisoLugar(c.lugar||"");
    setAvisoAdjuntoUrl(c.adjuntoUrl||""); setAvisoAdjuntoTipo(c.adjuntoTipo||""); setAvisoAdjuntoNombre(c.adjuntoNombre||"");
    setVerAviso(true);
  };
  // Reglas de envío: en modo evento exige título + fecha; en aviso exige mensaje.
  const avisoListo = avisoModo==="evento" ? (!!avisoTitulo.trim() && !!avisoFecha) : !!avisoMensaje.trim();
  const enviarAviso = async () => {
    if (!avisoListo || !currentUser?.uid) return;
    // La fecha define el tipo: con fecha → evento (sale en el calendario); sin fecha → aviso.
    const esEvento = !!avisoFecha;
    setAvisoEnviando(true); setAvisoErr(""); setAvisoOk(false);
    try {
      if (avisoEditId) {
        // EDITAR: update sobre el mismo doc (regla update permite al dueño empleadorId==uid).
        await updateDoc(doc(db,"comunicados",avisoEditId), {
          tipo: esEvento ? "evento" : "aviso",
          titulo: avisoTitulo.trim(),
          mensaje: avisoMensaje.trim(),
          fecha: esEvento ? avisoFecha : "",
          hora: esEvento ? avisoHora.trim() : "",
          lugar: esEvento ? avisoLugar.trim() : "",
          adjuntoUrl: avisoAdjuntoUrl || "",
          adjuntoTipo: avisoAdjuntoUrl ? avisoAdjuntoTipo : "",
          adjuntoNombre: avisoAdjuntoUrl ? avisoAdjuntoNombre : "",
          editadoEn: serverTimestamp(),
        });
        setAvisoOkEdit(true);
      } else {
        await addDoc(collection(db,"comunicados"), {
          empleadorId: currentUser.uid,
          tipo: esEvento ? "evento" : "aviso",
          titulo: avisoTitulo.trim(),
          mensaje: avisoMensaje.trim(),
          ...(esEvento ? { fecha: avisoFecha, hora: avisoHora.trim(), lugar: avisoLugar.trim() } : {}),
          ...(avisoAdjuntoUrl ? { adjuntoUrl: avisoAdjuntoUrl, adjuntoTipo: avisoAdjuntoTipo, adjuntoNombre: avisoAdjuntoNombre } : {}),
          creadoPor: currentUser.uid,
          createdAt: serverTimestamp(),
        });
        setAvisoOkEdit(false);
      }
      setAvisoOk(true); setAvisoOkEvento(esEvento); setAvisoEditId(null);
      setAvisoTitulo(""); setAvisoMensaje(""); setAvisoFecha(""); setAvisoHora(""); setAvisoLugar("");
      setAvisoAdjuntoUrl(""); setAvisoAdjuntoTipo(""); setAvisoAdjuntoNombre("");
      cargarComunicados();   // refresca lista + calendario del patrón
    } catch(e:any){ console.error("comunicados guardar:", e); setAvisoErr(e?.code||e?.message||"No se pudo publicar."); }
    finally { setAvisoEnviando(false); }
  };
  // Eliminar un comunicado (con confirmación). Regla delete permite al dueño.
  const eliminarComunicado = async (c:any)=>{
    const etq = c.tipo==="evento" ? "evento" : "aviso";
    if (!window.confirm(`¿Eliminar este ${etq}? No se puede deshacer y dejará de verse en el portal de tus trabajadores.`)) return;
    setComunicadoBorrando(c.id);
    try {
      await deleteDoc(doc(db,"comunicados",c.id));
      if (avisoEditId===c.id) resetAviso();
      await cargarComunicados();
    } catch(e){ console.error("comunicados delete:", e); alert("No se pudo eliminar. Intenta de nuevo."); }
    finally { setComunicadoBorrando(null); }
  };

  const avisoScreen = (
    <>
      <button onClick={()=>setVerAviso(false)}
        style={{display:"inline-flex", alignItems:"center", gap:6, background:"transparent", border:"none", color:C.gold, cursor:"pointer", fontFamily:fontSans, fontSize:13, fontWeight:700, padding:"0 0 12px"}}>
        <span style={{fontSize:16, lineHeight:1}}>‹</span> Volver
      </button>
      <div style={{marginBottom:14}}>
        <h1 style={{fontFamily:fontSerif, fontSize:24, fontWeight:700, color:C.ink, margin:0, lineHeight:1.1}}>{avisoEditId ? (avisoModo==="evento" ? "Editar evento" : "Editar aviso") : (avisoModo==="evento" ? "Nuevo evento" : "Aviso general")}</h1>
        <p style={{fontSize:12.5, color:C.inkSoft, margin:"6px 0 0", lineHeight:1.5}}>
          {avisoModo==="evento"
            ? "Publica un evento para tu equipo. Aparece en el calendario y en sus Notificaciones (pueden agregarlo a su calendario)."
            : "Envía un aviso a todos tus trabajadores. Les llega a su portal; no pueden responder. Si le pones fecha, se vuelve un evento del calendario."}
        </p>
      </div>

      <div {...ZONA_DE_CAPTURA} style={{background:C.panel, border:`1px solid ${C.line}`, borderRadius:16, padding:"16px 16px", boxShadow:C.sombra}}>
        <label style={{display:"block", fontSize:11, fontWeight:700, color:C.inkSoft, marginBottom:5}}>Título{avisoModo==="evento" ? "" : " (opcional)"}</label>
        <input value={avisoTitulo} onChange={e=>{ setAvisoTitulo(e.target.value); setAvisoOk(false); }} placeholder={avisoModo==="evento" ? "Ej. Junta general" : "Ej. Recordatorio"}
          style={{width:"100%", boxSizing:"border-box" as const, padding:"11px 12px", borderRadius:10, border:`1px solid ${C.line}`, background:"rgba(255,255,255,0.04)", color:C.ink, fontSize:14, fontFamily:fontSans, outline:"none", marginBottom:12}}/>

        {/* Fecha: opcional en aviso (la convierte en evento) · obligatoria en evento */}
        <label style={{display:"block", fontSize:11, fontWeight:700, color:C.inkSoft, marginBottom:5}}>Fecha{avisoModo==="evento" ? "" : " (opcional — la vuelve evento)"}</label>
        <input type="date" value={avisoFecha} onChange={e=>{ setAvisoFecha(e.target.value); setAvisoOk(false); }}
          style={{width:"100%", boxSizing:"border-box" as const, padding:"11px 12px", borderRadius:10, border:`1px solid ${C.line}`, background:"rgba(255,255,255,0.04)", color:C.ink, fontSize:14, fontFamily:fontSans, outline:"none", marginBottom:12}}/>

        {/* Hora y lugar (solo aplican cuando hay fecha = evento) */}
        {avisoFecha && (
          <div style={{display:"flex", gap:10, marginBottom:12}}>
            <div style={{flex:1, minWidth:0}}>
              <label style={{display:"block", fontSize:11, fontWeight:700, color:C.inkSoft, marginBottom:5}}>Hora (opcional)</label>
              <input type="time" value={avisoHora} onChange={e=>setAvisoHora(e.target.value)}
                style={{width:"100%", boxSizing:"border-box" as const, padding:"11px 12px", borderRadius:10, border:`1px solid ${C.line}`, background:"rgba(255,255,255,0.04)", color:C.ink, fontSize:14, fontFamily:fontSans, outline:"none"}}/>
            </div>
            <div style={{flex:1, minWidth:0}}>
              <label style={{display:"block", fontSize:11, fontWeight:700, color:C.inkSoft, marginBottom:5}}>Lugar (opcional)</label>
              <input value={avisoLugar} onChange={e=>setAvisoLugar(e.target.value)} placeholder="Ej. Oficina"
                style={{width:"100%", boxSizing:"border-box" as const, padding:"11px 12px", borderRadius:10, border:`1px solid ${C.line}`, background:"rgba(255,255,255,0.04)", color:C.ink, fontSize:14, fontFamily:fontSans, outline:"none"}}/>
            </div>
          </div>
        )}

        <label style={{display:"block", fontSize:11, fontWeight:700, color:C.inkSoft, marginBottom:5}}>{avisoModo==="evento" ? "Descripción (opcional)" : "Mensaje"}</label>
        <textarea value={avisoMensaje} onChange={e=>{ setAvisoMensaje(e.target.value); setAvisoOk(false); }} rows={4} placeholder={avisoModo==="evento" ? "Detalles del evento…" : "Escribe el aviso para tu equipo…"}
          style={{width:"100%", boxSizing:"border-box" as const, padding:"11px 12px", borderRadius:10, border:`1px solid ${C.line}`, background:"rgba(255,255,255,0.04)", color:C.ink, fontSize:14, fontFamily:fontSans, outline:"none", resize:"vertical" as const, minHeight:96}}/>

        {/* Adjunto OPCIONAL: foto/escaneo (cámara) o PDF (elegir archivo). Reutiliza
            SubirArchivoBtn: sube a Storage 'comunicados/{uid}/' y devuelve la URL. */}
        <label style={{display:"block", fontSize:11, fontWeight:700, color:C.inkSoft, margin:"14px 0 7px"}}>Adjunto (opcional) — foto, escaneo o PDF</label>
        {avisoAdjuntoUrl ? (
          <div style={{display:"flex", alignItems:"center", gap:10, padding:"10px 12px", borderRadius:10, border:`1px solid ${C.line}`, background:"rgba(255,255,255,0.04)"}}>
            {avisoAdjuntoTipo==="imagen"
              ? <img src={avisoAdjuntoUrl} alt="Adjunto" style={{width:42, height:42, objectFit:"cover" as const, borderRadius:8, flexShrink:0, border:`1px solid ${C.line}`}}/>
              : <div style={{width:42, height:42, borderRadius:8, flexShrink:0, display:"flex", alignItems:"center", justifyContent:"center", background:C.iconBg, border:`1px solid ${C.iconBd}`, color:C.gold, fontSize:11, fontWeight:800}}>PDF</div>}
            <div style={{flex:1, minWidth:0}}>
              <div style={{fontSize:12.5, color:C.ink, fontWeight:700, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" as const}}>{avisoAdjuntoNombre||"Adjunto"}</div>
              <a href={avisoAdjuntoUrl} target="_blank" rel="noopener noreferrer" style={{fontSize:11, color:C.gold, textDecoration:"none", fontWeight:700}}>Ver adjunto</a>
            </div>
            <button onClick={()=>{ setAvisoAdjuntoUrl(""); setAvisoAdjuntoTipo(""); setAvisoAdjuntoNombre(""); }}
              style={{flexShrink:0, padding:"6px 11px", borderRadius:8, border:"1px solid rgba(252,165,165,0.45)", background:"rgba(220,38,38,0.12)", color:"#FCA5A5", cursor:"pointer", fontFamily:fontSans, fontSize:11.5, fontWeight:800}}>Quitar</button>
          </div>
        ) : (
          <SubirArchivoBtn userId={currentUser.uid} carpeta="comunicados" label="Elegir archivo" accept="image/*,application/pdf"
            onSubido={(url:string, nombre:string)=>{ setAvisoAdjuntoUrl(url); setAvisoAdjuntoNombre(nombre); setAvisoAdjuntoTipo(/\.pdf$/i.test(nombre)?"pdf":"imagen"); setAvisoOk(false); }}/>
        )}

        <button onClick={enviarAviso} disabled={avisoEnviando || !avisoListo}
          style={{marginTop:14, width:"100%", padding:"13px 16px", borderRadius:12, border:"none", cursor:(avisoEnviando||!avisoListo)?"not-allowed":"pointer", fontFamily:fontSans, fontSize:14, fontWeight:800,
            background:(avisoEnviando||!avisoListo)?`rgba(${A.rgbBright},0.25)`:C.gold, color:(avisoEnviando||!avisoListo)?C.inkMut:"#0B1829"}}>
          {avisoEnviando ? "Guardando…" : avisoEditId ? "Guardar cambios" : (avisoFecha ? "Publicar evento a todo el equipo" : "Enviar a todos los trabajadores")}
        </button>
        {avisoOk && (
          <div style={{marginTop:12, background:"rgba(52,211,153,0.12)", border:"1px solid rgba(52,211,153,0.4)", borderRadius:12, padding:"11px 13px", fontSize:13, color:"#34D399", fontWeight:700}}>
            ✓ {avisoOkEdit ? "Cambios guardados." : (avisoOkEvento ? "Evento publicado a tu equipo." : "Aviso enviado a todos tus trabajadores.")}
          </div>
        )}
        {avisoErr && (
          <div style={{marginTop:12, background:"rgba(220,38,38,0.12)", border:"1px solid rgba(252,165,165,0.4)", borderRadius:12, padding:"11px 13px", fontSize:13, color:"#FCA5A5", fontWeight:700}}>
            No se pudo publicar: {avisoErr}
          </div>
        )}
      </div>

      {/* Publicados — lista de comunicados del patrón (editar / eliminar) */}
      <div style={{marginTop:22}}>
        <div style={{fontSize:11, color:C.inkMut, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"1px", margin:"0 2px 10px"}}>Publicados · {comunicados.length}</div>
        {comunicados.length===0 ? (
          <div style={{textAlign:"center" as const, padding:"24px 20px", background:C.panel, border:`1px solid ${C.line}`, borderRadius:16, boxShadow:C.sombra}}>
            <div style={{fontSize:12.5, color:C.inkSoft, lineHeight:1.5}}>Aún no has publicado avisos ni eventos.</div>
          </div>
        ) : (
          <div style={{display:"flex", flexDirection:"column" as const, gap:9}}>
            {[...comunicados].sort((a:any,b:any)=>(b.createdAt?.toMillis?.()||0)-(a.createdAt?.toMillis?.()||0)).map((c:any)=>{
              const esEv = c.tipo==="evento";
              const col = esEv ? "#7FD1C0" : C.gold;
              const fechaTxt = esEv && c.fecha ? c.fecha : (c.createdAt?.toDate?.() ? c.createdAt.toDate().toLocaleDateString("es-MX",{day:"numeric",month:"short"}) : "");
              return (
                <div key={c.id} style={{background:C.panel, border:`1px solid ${C.line}`, borderLeft:`3px solid ${col}`, borderRadius:14, padding:"12px 13px", boxShadow:C.sombra}}>
                  <div style={{display:"flex", alignItems:"baseline", gap:8, flexWrap:"wrap" as const, marginBottom:c.mensaje||fechaTxt?3:0}}>
                    <span style={{fontSize:10, fontWeight:800, padding:"2px 8px", borderRadius:999, border:`1px solid ${col}66`, color:col, whiteSpace:"nowrap" as const}}>{esEv?"Evento":"Aviso"}</span>
                    {c.titulo && <span style={{fontSize:13.5, fontWeight:700, color:C.ink, flex:1, minWidth:0}}>{c.titulo}</span>}
                  </div>
                  {c.mensaje && <div style={{fontSize:12, color:C.inkSoft, lineHeight:1.4, whiteSpace:"pre-wrap" as const}}>{c.mensaje}</div>}
                  {fechaTxt && <div style={{fontSize:11, color:C.inkMut, marginTop:4}}>{esEv?"Fecha: ":"Publicado: "}{fechaTxt}{esEv&&c.hora?` · ${c.hora}`:""}{esEv&&c.lugar?` · ${c.lugar}`:""}</div>}
                  {c.adjuntoUrl && (
                    <a href={c.adjuntoUrl} target="_blank" rel="noopener noreferrer" style={{display:"inline-flex", alignItems:"center", gap:5, marginTop:6, fontSize:11, color:C.gold, fontWeight:700, textDecoration:"none"}}>
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M9 8.5v7a3.5 3.5 0 007 0V6a2 2 0 10-4 0v9a.5.5 0 001 0V8.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/></svg>
                      {c.adjuntoTipo==="imagen" ? "Foto adjunta" : "PDF adjunto"}{c.adjuntoNombre?` · ${c.adjuntoNombre}`:""}
                    </a>
                  )}
                  <div style={{display:"flex", gap:8, marginTop:10}}>
                    <button onClick={()=>abrirEditarComunicado(c)}
                      style={{flex:1, padding:"8px 10px", borderRadius:9, border:`1px solid ${C.line}`, background:"transparent", color:C.gold, cursor:"pointer", fontFamily:fontSans, fontSize:12, fontWeight:700}}>Editar</button>
                    <button onClick={()=>eliminarComunicado(c)} disabled={comunicadoBorrando===c.id}
                      style={{flex:1, padding:"8px 10px", borderRadius:9, border:"1px solid rgba(252,165,165,0.45)", background:"rgba(220,38,38,0.12)", color:"#FCA5A5", cursor:comunicadoBorrando===c.id?"wait":"pointer", fontFamily:fontSans, fontSize:12, fontWeight:800}}>
                      {comunicadoBorrando===c.id ? "Eliminando…" : "Eliminar"}
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </>
  );

  // ════════════ DETALLE DE ACCIDENTE (solo lectura) ════════════
  const detalleAccidenteScreen = accidenteSel ? (() => {
    const a:any = accidenteSel;
    const fotos:string[] = Array.isArray(a.fotos) ? a.fotos.filter(Boolean) : [];
    const tieneGps = !!a.ubicacionDisponible && a.lat!=null && a.lng!=null;
    const tieneVal = (v:any)=> v!==undefined && v!==null && String(v).trim()!=="";
    const fila = (label:string, val:any) => tieneVal(val) ? (
      <div style={{display:"flex", justifyContent:"space-between", gap:12, padding:"7px 0", borderBottom:"1px solid rgba(255,255,255,0.06)"}}>
        <span style={{fontSize:12, color:C.inkMut, flexShrink:0}}>{label}</span>
        <span style={{fontSize:12.5, color:C.ink, fontWeight:600, textAlign:"right" as const, minWidth:0, wordBreak:"break-word" as const}}>{String(val)}</span>
      </div>
    ) : null;
    const card = (titulo:string, hijos:React.ReactNode) => (
      <div style={{background:C.panel, border:`1px solid ${C.line}`, borderRadius:14, padding:"12px 14px", boxShadow:C.sombra, marginBottom:12}}>
        <div style={{fontFamily:fontSerif, fontSize:14, fontWeight:700, color:C.gold, marginBottom:4}}>{titulo}</div>
        {hijos}
      </div>
    );
    const fechaReg = a.timestamp?.toDate?.() ? a.timestamp.toDate().toLocaleString("es-MX",{day:"numeric",month:"long",hour:"2-digit",minute:"2-digit"}) : (a.fecha||"");
    return (
      <>
        <button onClick={()=>{ setAccidenteSel(null); setAccFotoAmpliada(null); }}
          style={{display:"inline-flex", alignItems:"center", gap:6, background:"transparent", border:"none", color:C.gold, cursor:"pointer", fontFamily:fontSans, fontSize:13, fontWeight:700, padding:"0 0 12px"}}>
          <span style={{fontSize:16, lineHeight:1}}>‹</span> Actividad
        </button>
        <div style={{marginBottom:14}}>
          <div style={{display:"flex", alignItems:"center", gap:8, flexWrap:"wrap" as const}}>
            <h1 style={{fontFamily:fontSerif, fontSize:23, fontWeight:700, color:"#FCA5A5", margin:0, lineHeight:1.1}}>Detalle de accidente</h1>
            {(()=>{ const gm=senalDeAccidente(a); if (!gm) return null; return <span style={{fontSize:11, fontWeight:800, padding:"3px 10px", borderRadius:999, border:`1px solid ${gm.color}`, color:gm.color, background:`rgba(${gm.rgb},0.16)`}}>{gm.label}</span>; })()}
          </div>
          <p style={{fontSize:12.5, color:C.inkSoft, margin:"4px 0 0"}}>{a.trabajadorNombre||a.trabajadorEmail||"Trabajador"}{fechaReg?` · Reportado ${fechaReg}`:""}</p>
          {!!textoEstadoAtencion(a) && <p style={{fontSize:12, fontWeight:700, margin:"4px 0 0", color: estadoAtencionAccidente(a) === "cancelado" ? "#FCA5A5" : "#34D399"}}>{textoEstadoAtencion(a)}</p>}
        </div>

        {/* EL MISMO DETALLE QUE EL ESCRITORIO, con las mismas etiquetas y sin
            campos vacíos: ver `detalleDeAccidente`. Antes cada tarjeta armaba lo
            suyo, y un Sí/No sin contestar salía como "No". */}
        {detalleDeAccidente(a).map((s) => (
          <React.Fragment key={s.titulo}>
            {card(s.titulo, (<>
              {s.filas.map(([l, v]) => (l === "Relato del trabajador"
                ? <div key={l} style={{padding:"7px 0", borderBottom:"1px solid rgba(255,255,255,0.06)"}}>
                    <div style={{fontSize:12, color:C.inkMut, marginBottom:3}}>{l}</div>
                    <div style={{fontSize:12.5, color:C.ink, lineHeight:1.5, whiteSpace:"pre-wrap" as const}}>{v}</div>
                  </div>
                : <React.Fragment key={l}>{fila(l, v)}</React.Fragment>))}
            </>))}
          </React.Fragment>
        ))}

        {/* LA ATENCIÓN DEL PATRÓN, la misma pieza que en el escritorio. */}
        <div style={{marginBottom:12}}>
          <AtencionDeAccidente accidente={a} tema="oscuro" fontSans={fontSans}
            usuario={{email: String(currentUser?.email || ""), nombre: String(currentUser?.displayName || "")}}
            onCambio={(nuevo:any)=> setAccidenteSel(nuevo)}/>
        </div>

        {/* Pauta legal (texto fijo informativo) */}
        <div style={{background:C.panel, border:`1px solid rgba(252,165,165,0.40)`, borderLeft:"3px solid #FCA5A5", borderRadius:14, boxShadow:C.sombra, marginBottom:12, overflow:"hidden"}}>
          <button onClick={()=>setAccLegalAbierto(v=>!v)}
            style={{display:"flex", alignItems:"center", justifyContent:"space-between", gap:10, width:"100%", textAlign:"left" as const, background:"transparent", border:"none", cursor:"pointer", fontFamily:fontSans, padding:"12px 14px"}}>
            <span style={{fontFamily:fontSerif, fontSize:14.5, fontWeight:700, color:"#FCA5A5"}}>Qué debes hacer (pauta legal)</span>
            <span style={{fontSize:16, color:C.inkMut, lineHeight:1, transform:accLegalAbierto?"rotate(180deg)":"none", transition:"transform 0.2s"}}>⌄</span>
          </button>
          {accLegalAbierto && (
            <div style={{padding:"0 14px 14px", display:"flex", flexDirection:"column" as const, gap:10}}>
              {[
                {t:"Aviso al IMSS — 24 horas", d:"El patrón debe dar aviso del riesgo de trabajo al IMSS dentro de las 24 horas siguientes (Art. 51 Ley del Seguro Social). El formato ST-7 (clave 3A21-009-047) lo emite el médico tratante del IMSS tras la atención inicial; el patrón completa el reverso con la versión patronal. Omitirlo: multa de 20 a 350 UMA y calificación automática como riesgo de trabajo (afecta tu prima)."},
                {t:"Aviso a la STPS — 72 horas", d:"Aviso a la STPS dentro de las 72 horas (Art. 504 LFT), cuando aplique."},
                {t:"Investigación", d:"El patrón debe investigar las causas del accidente y documentarlo (marco NOM-035 / obligaciones de seguridad y salud, según aplique)."},
              ].map((it,i)=>(
                <div key={i} style={{borderTop:i>0?"1px solid rgba(255,255,255,0.06)":"none", paddingTop:i>0?10:0}}>
                  <div style={{fontSize:12.5, fontWeight:800, color:C.ink, marginBottom:3}}>{it.t}</div>
                  <div style={{fontSize:11.5, color:C.inkSoft, lineHeight:1.5}}>{it.d}</div>
                </div>
              ))}
              <div style={{fontSize:11, color:C.inkMut, lineHeight:1.5, background:"rgba(255,255,255,0.04)", border:`1px solid ${C.line}`, borderRadius:10, padding:"10px 12px", marginTop:2}}>
                <strong style={{color:C.inkSoft}}>Aviso:</strong> Esta es una constancia interna de AXIS para que te enteres y documentes a tiempo. NO sustituye el trámite oficial ante el IMSS/STPS ni la asesoría de tu abogado.
              </div>
            </div>
          )}
        </div>

        {/* Fotos */}
        {fotos.length>0 && card(`Fotos (${fotos.length})`, (
          <div style={{display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:8, marginTop:4}}>
            {fotos.map((url,i)=>(
              <button key={i} onClick={()=>setAccFotoAmpliada(url)}
                style={{padding:0, border:`1px solid ${C.line}`, borderRadius:10, overflow:"hidden", cursor:"pointer", background:C.panel, aspectRatio:"1 / 1"}}>
                <img src={url} alt={`Foto ${i+1}`} style={{width:"100%", height:"100%", objectFit:"cover" as const, display:"block"}}/>
              </button>
            ))}
          </div>
        ))}

        {/* EL VÍDEO, que antes no salía en el móvil. */}
        {!!a.video && card("Video", (
          <video src={a.video} controls preload="metadata" playsInline
            style={{width:"100%", maxHeight:360, borderRadius:10, background:"#000", display:"block", marginTop:4}}/>
        ))}

        {/* Ubicación GPS */}
        {tieneGps && (
          <a href={`https://www.google.com/maps?q=${a.lat},${a.lng}`} target="_blank" rel="noopener noreferrer"
            style={{display:"flex", alignItems:"center", justifyContent:"center", gap:8, width:"100%", boxSizing:"border-box" as const, padding:"13px 16px", borderRadius:12, border:`1px solid ${C.gold}`, background:`rgba(${A.rgbBright},0.12)`, color:C.gold, textDecoration:"none", fontFamily:fontSans, fontSize:13.5, fontWeight:800, marginTop:4}}>
            <svg width="17" height="17" viewBox="0 0 24 24" fill="none"><path d="M12 21s7-6.3 7-11a7 7 0 10-14 0c0 4.7 7 11 7 11z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round"/><circle cx="12" cy="10" r="2.5" stroke="currentColor" strokeWidth="1.7"/></svg>
            Ver ubicación en Google Maps
          </a>
        )}

        {/* Lightbox de foto */}
        {accFotoAmpliada && (
          <div onClick={()=>setAccFotoAmpliada(null)} style={{position:"fixed" as const, inset:0, zIndex:2000, background:"rgba(3,10,22,0.92)", display:"flex", alignItems:"center", justifyContent:"center", padding:16}}>
            <img src={accFotoAmpliada} alt="Foto del accidente" style={{maxWidth:"100%", maxHeight:"90vh", objectFit:"contain" as const, borderRadius:8}}/>
            <button onClick={()=>setAccFotoAmpliada(null)} aria-label="Cerrar" style={{position:"fixed" as const, top:16, right:16, width:38, height:38, borderRadius:"50%", border:"1px solid rgba(255,255,255,0.25)", background:"rgba(0,0,0,0.4)", color:"#fff", cursor:"pointer", fontSize:18}}>×</button>
          </div>
        )}
      </>
    );
  })() : null;

  // RESTAURANDO LA PANTALLA DE LA DIRECCIÓN (una pestaña o una ficha): el indicador
  // de carga de siempre, no Inicio, hasta decidir (useVistaEnLaDireccion).
  if (restaurandoVistaMv) return <PantallaCargando fontSans={fontSans}/>;

  return (
    <div style={{minHeight:"100vh", background:C.bg, fontFamily:fontSans, paddingBottom:86}}>
      {/* Header premium con líneas doradas sutiles (fondo #05152E = el del logo PNG) */}
      <div style={{position:"relative" as const, overflow:"hidden", background:"#05152E", borderBottom:`1px solid ${C.line}`, padding:"10px 16px"}}>
        <svg style={{position:"absolute" as const, inset:0, width:"100%", height:"100%", opacity:0.6}} viewBox="0 0 400 120" preserveAspectRatio="none" fill="none">
          <path d="M-20 36 Q 150 -8 430 46" stroke={`rgba(${A.rgbBright},0.16)`} strokeWidth="1"/>
          <path d="M-20 64 Q 190 18 430 78" stroke={`rgba(${A.rgbBright},0.10)`} strokeWidth="1"/>
          <path d="M-20 92 Q 160 50 430 104" stroke={`rgba(${A.rgbBright},0.07)`} strokeWidth="1"/>
        </svg>
        <div style={{position:"relative" as const, display:"flex", alignItems:"center", justifyContent:"space-between", gap:10}}>
          <div style={{display:"flex", alignItems:"center", gap:8, minWidth:0}}>
            {/* Logo real (imagen). Fondo del header = #05152E del PNG → recuadro fundido. */}
            <img src="/logo.png?v=4" alt="AXIS Legaltech" style={{height:46, width:"auto", display:"block", margin:"-8px 0", flexShrink:0}}/>
            <span style={{fontSize:13, color:"rgba(255,255,255,0.6)"}}>Panel</span>
          </div>
          <div style={{display:"flex", alignItems:"center", gap:8, flexShrink:0}}>
            {/* Recargar: la app lee UNA vez al abrir, asi que sin esto un dato nuevo
                no aparecia hasta cerrar y volver a abrir. */}
            <BotonRecargar onRecargar={refrescar} cargando={refrescando} error={errorRefresco}
              color={C.gold} borde={C.iconBd}/>
            {/* Acceso a AXIOR: carita del búho + etiqueta, para que se lea como el asistente. */}
            <button onClick={abrirAxior} aria-label="Hablar con AXIOR" title="Hablar con AXIOR"
              style={{display:"inline-flex", alignItems:"center", gap:6, padding:"4px 10px 4px 5px", borderRadius:999, cursor:"pointer", fontFamily:fontSans,
                background:`rgba(${A.rgbDim},0.14)`, border:`1px solid ${C.iconBd}`}}>
              <AxiorSVG size={26} expr="atento" view="body"/>
              <span style={{fontSize:12.5, fontWeight:800, color:C.gold, letterSpacing:"0.3px"}}>AXIOR</span>
            </button>
            <button onClick={()=>irATab("perfil")} aria-label="Perfil"
              style={{width:38, height:38, borderRadius:"50%", overflow:"hidden", padding:0, cursor:"pointer", fontFamily:fontSans, fontSize:13, fontWeight:800, letterSpacing:"0.5px",
                background:`rgba(${A.rgbDim},0.14)`, border:`1px solid ${C.iconBd}`, color:C.gold, display:"flex", alignItems:"center", justifyContent:"center"}}>
              {fotoPerfilUrl ? <img src={fotoPerfilUrl} alt="" style={{width:"100%", height:"100%", objectFit:"cover" as const, display:"block"}}/> : iniciales}
            </button>
          </div>
        </div>
      </div>

      <div style={{maxWidth:560, margin:"0 auto", padding:"16px 14px"}}>
        {accidenteSel ? detalleAccidenteScreen : verCalculadora ? (
          <>
            {/* Encabezado del portal para la Calculadora (NominaModulo no trae back propio). */}
            <button onClick={()=>setVerCalculadora(false)}
              style={{display:"inline-flex", alignItems:"center", gap:6, background:"transparent", border:"none", color:C.gold, cursor:"pointer", fontFamily:fontSans, fontSize:13, fontWeight:700, padding:"0 0 10px"}}>
              <span style={{fontSize:16, lineHeight:1}}>‹</span> Inicio
            </button>
            <div style={{marginBottom:12}}>
              <h1 style={{fontFamily:fontSerif, fontSize:24, fontWeight:700, color:C.ink, margin:0, lineHeight:1.1}}>Calculadora LFT</h1>
              <p style={{fontSize:12.5, color:C.inkSoft, margin:"3px 0 0"}}>Liquidación, finiquito, aguinaldo y vacaciones.</p>
              <div style={{height:1, background:`linear-gradient(90deg, ${C.gold}, transparent)`, marginTop:10, opacity:0.6}}/>
            </div>
            {/* variant="portal": fondo transparente para integrarse al navy del portal. */}
            <NominaModulo onBack={()=>setVerCalculadora(false)} onGoLanding={()=>setVerCalculadora(false)} fontSans={fontSans} fontSerif={fontSerif} gold={C.gold} currentUser={currentUser} isProUser={true} variant="portal" />
          </>
        ) : verAviso ? avisoScreen : verFlotilla ? flotillaScreen : verCalendario ? calendarioScreen : (<>
        {/* ════ INICIO ════ */}
        {tab==="inicio" && (
          <>
            <div style={{marginBottom:12}}>
              <div style={{fontSize:11, color:C.gold, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"1.5px", marginBottom:2}}>Bienvenido</div>
              <h1 style={{fontFamily:fontSerif, fontSize:22, fontWeight:700, color:C.ink, margin:0, lineHeight:1.1}}>Hola, {nombre}</h1>
              <p style={{fontSize:12.5, color:C.inkSoft, margin:"2px 0 0"}}>Aquí tienes tu resumen del día.</p>
            </div>

            {/* PREPARA ESTE DISPOSITIVO — el MISMO bloque y el MISMO estado que el
               escritorio, no una copia: los dos leen del proveedor que envuelve a
               los dos árboles. Activar los avisos aquí deja la fila del perfil de
               escritorio de acuerdo sin recargar.
               ES EL SITIO QUE MÁS IMPORTA: la puerta sirve para que lleguen avisos
               al teléfono, y el teléfono es esto. Va debajo del saludo y antes del
               resumen, y desaparece del todo cuando no falta nada. */}
            <PrepararDispositivo isMobile={true} fontSerif={fontSerif} fontSans={fontSans} tema="navy"/>

            {/* ── POR DÓNDE EMPEZAR, EN EL TELÉFONO ─────────────────────────────
               NO son los mismos tres botones del escritorio, y es a propósito.
               Se midió: este portal NO puede hacer ninguno de los tres. No escribe
               en `trabajadores` ni en `vehiculos` —su Flotilla es de solo lectura—
               y los datos de la empresa ni siquiera tienen pantalla aquí; el propio
               portal ya lo dice al intentar generar un reporte: "se capturan desde
               una computadora".
               Poner los tres botones aquí sería repetir el defecto que esta rama
               arregla: renglones que parecen llevar a algún sitio y no llevan a
               ninguno. Así que se dice lo que hay, con las mismas tres cosas por
               nombre para que se reconozcan al llegar a la computadora. */}
            {cuentaVaciaMv && (
              <div style={{background:C.panel, border:`1px solid ${C.line}`, borderRadius:14,
                padding:"13px 14px", boxShadow:C.sombra, marginBottom:14}}>
                <div style={{fontFamily:fontSerif, fontSize:15, fontWeight:700, color:C.ink, marginBottom:3}}>
                  Tu cuenta está lista
                </div>
                <div style={{fontSize:12, color:C.inkSoft, lineHeight:1.55, marginBottom:9}}>
                  Falta cargar tu información, y eso se hace <strong style={{color:C.ink}}>una sola vez desde una computadora</strong>:
                </div>
                <div style={{display:"flex", flexDirection:"column" as const, gap:0}}>
                  {[
                    {n:"1", t:"Los datos de tu empresa", d:"Razón social, RFC y domicilio. Es con lo que se firman tus documentos."},
                    {n:"2", t:"Tus empleados", d:"De un archivo de Excel o uno por uno."},
                    {n:"3", t:"Tus unidades", d:"Si tienes flotilla. Si no, sáltalo."},
                  ].map((p:any, i:number)=>(
                    <div key={p.n} style={{display:"flex", alignItems:"flex-start", gap:10,
                      padding:"9px 0", borderTop: i===0 ? "none" : `1px solid ${C.line}`}}>
                      <span style={{width:20, height:20, borderRadius:"50%", flexShrink:0, marginTop:1,
                        background:C.gold, color:"#0B1829", display:"flex", alignItems:"center",
                        justifyContent:"center", fontSize:11, fontWeight:800, fontFamily:fontSerif}}>{p.n}</span>
                      <div style={{minWidth:0}}>
                        <div style={{fontSize:12.5, color:C.ink, fontWeight:700, lineHeight:1.3}}>{p.t}</div>
                        <div style={{fontSize:11.5, color:C.inkSoft, marginTop:1, lineHeight:1.45}}>{p.d}</div>
                      </div>
                    </div>
                  ))}
                </div>
                <div style={{fontSize:11.5, color:C.inkMut, marginTop:10, paddingTop:9,
                  borderTop:`1px solid ${C.line}`, lineHeight:1.5}}>
                  Después, el teléfono es para el día a día: quién checó, qué pasó con la flotilla y
                  qué te toca atender.
                </div>
              </div>
            )}

            {/* LOS TRES HECHOS DEL EQUIPO — los MISMOS que el escritorio, leídos de
               `hechosDelEquipo`. Aquí había tres barras de porcentaje que llegaron a
               contradecir a la otra pantalla en el mismo dato: el escritorio decía
               "1 de 11 expedientes con datos capturados" y el celular "Documental
               100% · Expedientes al día". No es que una estuviera mal calculada: eran
               dos cálculos distintos del mismo hecho. Ahora leen de la misma función,
               así que no pueden discrepar. */}
            <div style={{background:C.panel, border:`1px solid ${C.line}`, borderRadius:14, padding:"13px 14px", boxShadow:C.sombra, marginBottom:14}}>
              <div style={{fontFamily:fontSerif, fontSize:15, fontWeight:700, color:C.ink, marginBottom:3}}>Tu equipo</div>
              <div style={{fontSize:11, color:C.inkMut, marginBottom:9}}>Sobre tus empleados activos</div>
              <div style={{display:"flex", flexDirection:"column" as const, gap:0}}>
                {hechosEquipoMv.map((h:any, i:number)=>{
                  const ir = h.destino === "sin_checar" ? ()=>{ setEquipoFoco(h.emails||[]); setEquipoSel(""); setTab("equipo"); }
                    : h.destino === "empleados" ? ()=>{ setEquipoFoco([]); setTab("equipo"); }
                    : h.destino === "tareas" ? ()=>{ setActFiltro("todo"); setTab("actividad"); } : undefined;
                  const pulsable = !!ir;
                  return (
                    <div key={h.k}
                      onClick={pulsable ? ir : undefined}
                      role={pulsable ? "button" : undefined} tabIndex={pulsable ? 0 : undefined}
                      onKeyDown={pulsable ? (ev:any)=>{ if(ev.key==="Enter"||ev.key===" "){ ev.preventDefault(); ir!(); } } : undefined}
                      style={{display:"flex", alignItems:"baseline", gap:"2px 8px", flexWrap:"wrap" as const,
                        cursor: pulsable ? "pointer" : "default",
                        padding:"9px 6px", margin:"0 -6px", borderRadius:10,
                        borderTop: i===0 ? "none" : `1px solid ${C.line}`,
                        WebkitTapHighlightColor:"transparent"}}>
                      <span aria-hidden style={{width:6, height:6, borderRadius:"50%", flexShrink:0,
                        background:h.color, transform:"translateY(-2px)"}}/>
                      <span style={{fontSize:12.5, color:C.ink, fontWeight:700, minWidth:0}}>{h.texto}</span>
                      {h.detalle && (
                        <span style={{fontSize:11.5, color:C.inkSoft, fontWeight:600}}>{h.detalle}</span>
                      )}
                    </div>
                  );
                })}
              </div>
              <button onClick={()=>setTab("equipo")}
                style={{marginTop:11, padding:0, background:"transparent", border:"none", color:C.gold, cursor:"pointer", fontFamily:fontSans, fontSize:12, fontWeight:700}}>
                Ver detalle <span style={{fontSize:15, lineHeight:1}}>›</span>
              </button>
            </div>

            {/* Qué atender hoy — accionable + fechas que ya urgen (≤7 días) */}
            <div style={{fontSize:11, color:C.inkMut, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"1px", margin:"0 2px 8px"}}>Qué atender hoy</div>
            {/* MISMA LISTA Y MISMOS TEXTOS QUE EL ESCUDO Y LA TARJETA DE INICIO:
                `filasDeAtencion` decide título, detalle y cuándo fue. Aquí solo se
                pinta. Antes este árbol volvía a llamar a `renglonPendienteDeAccidente`
                por su cuenta y no enseñaba la fecha. */}
            {/* EL CONTADOR, encima de los accidentes; ver `conteoDeAccidentes`. */}
            {accidentesAtender.length > 0 && (
              <div style={{fontSize:11.5, fontWeight:700, color:"#FCA5A5", margin:"0 2px 8px"}}>{resumenDeAtencion([], accidentesAtender).conteoAccidentes}</div>
            )}
            {resumenDeAtencion([], accidentesAtender).filas.map((fa)=>{
              const a:any = fa.accidente;
              // TODOS DEL MISMO COLOR: el de accidente de la Actividad del móvil.
              const tM = {c:"#FCA5A5", fondo:"rgba(220,38,38,0.12)", borde:"rgba(252,165,165,0.45)", icono:"rgba(220,38,38,0.20)"};
              return (
              <button key={fa.clave} onClick={()=>{ setAccFotoAmpliada(null); setAccidenteSel(a); }}
                style={{display:"flex", alignItems:"center", gap:11, width:"100%", textAlign:"left" as const, fontFamily:fontSans, marginBottom:8,
                  background:tM.fondo, border:`1px solid ${tM.borde}`, borderLeft:`3px solid ${tM.c}`, borderRadius:13, padding:"10px 12px", boxShadow:C.sombra, cursor:"pointer"}}>
                <div style={{width:36, height:36, borderRadius:10, flexShrink:0, display:"flex", alignItems:"center", justifyContent:"center", background:tM.icono, border:`1px solid ${tM.borde}`, color:tM.c}}>{icoAlerta}</div>
                <div style={{flex:1, minWidth:0}}>
                  <div style={{display:"flex", alignItems:"center", gap:6, flexWrap:"wrap" as const}}>
                    <span style={{fontSize:13, fontWeight:800, color:tM.c, lineHeight:1.2}}>{fa.titulo}</span>
                    <EtiquetaLesionadosChip accidente={a} tema="oscuro"/>
                  </div>
                  <div style={{fontSize:11, color:C.inkSoft, marginTop:2}}>
                    {fa.detalle}{fa.cuando ? " · " + fa.cuando : ""}
                  </div>
                </div>
                <span style={{fontSize:19, color:C.inkMut, lineHeight:1}}>›</span>
              </button>
              );
            })}
            {/* Destino de la alerta según su módulo:
               · proveedores (69-B SAT) → INFORMATIVA, sin navegación (no hay módulo de
                 Proveedores en el móvil): se queda visible por su gravedad fiscal e indica
                 dónde atenderla.
               · calendario → ventana de Calendario del móvil.
               · empleados → Equipo (correcto).
               · flotilla → Equipo por ahora; se engancha al meter la vista de flotilla. */}
            {urgente && (urgente.modulo==="proveedores"
              ? filaAtender(icoAlerta, urgente.titulo, `${urgente.detalle} · Revísalo en la plataforma`)
              : filaAtender(icoAlerta, urgente.titulo, urgente.detalle,
                  urgente.modulo==="calendario" ? ()=>setVerCalendario(true)
                  : urgente.modulo==="flotilla" ? ()=>{ setFlotillaFoco(String(urgente.id||"").split(":")[1]||""); setVerFlotilla(true); }
                  : ()=>setTab("equipo")))}
            {tareasPorConfirmar>0 && filaAtender(icoCheck, `${tareasPorConfirmar} actividad${tareasPorConfirmar===1?"":"es"} espera${tareasPorConfirmar===1?"":"n"} tu confirmación`, "Toca para revisarlas", ()=>setTab("actividad"))}
            {fechasAlerta.map((fa:any,i:number)=>(
              <React.Fragment key={`fa-${i}`}>
                {filaAtender(icoCal, fa.titulo, `Fecha próxima · ${fa.cuando}`, ()=>setVerCalendario(true))}
              </React.Fragment>
            ))}
            {!loading && !urgente && tareasPorConfirmar===0 && fechasAlerta.length===0 && accidentesAtender.length===0 && (
              <div style={{fontSize:12.5, color:C.inkSoft, padding:"4px 2px"}}>Todo al día por ahora ✓</div>
            )}

            {/* Calendario — tarjeta propia con conteo de fechas próximas */}
            <div style={{fontSize:11, color:C.inkMut, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"1px", margin:"14px 2px 8px"}}>Calendario</div>
            {filaAtender(icoCal, "Calendario de la empresa", conteoProximos>0 ? `${conteoProximos} fecha${conteoProximos===1?"":"s"} próxima${conteoProximos===1?"":"s"} (60 días)` : "Sin fechas próximas", ()=>setVerCalendario(true))}

            {/* Flotilla — sección propia (mismo patrón que Calendario): tarjeta que abre la ventana */}
            <div style={{fontSize:11, color:C.inkMut, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"1px", margin:"14px 2px 8px"}}>Flotilla</div>
            {/* El titulo decia "Vehiculos de la empresa" y abria la BITACORA: mentia
                sobre su destino, y ademas se parecia al de abajo. Cada renglon dice
                ahora a donde va. El resumen documental que traia este subtitulo se
                fue con el: ese dato es del catalogo, y ahi lo anuncia el de abajo. */}
            {filaAtender(icoAutoAct, "Bitácora de movimientos",
              "Últimas salidas y regresos",
              // Lleva a Actividad con el filtro Flotilla ya aplicado: mismo patron
              // que en escritorio, donde la tarjeta de Inicio abre el modulo ya
              // filtrado. Sin pestana nueva en la barra inferior. La ventana del
              // CATALOGO de unidades sigue accesible desde el aviso de "Que atender",
              // que la abre enfocada en la unidad concreta.
              // Entra directo a la lectura por viaje: es la vista principal de la
              // bitacora, y la que responde a "que hicieron mis unidades".
              ()=>{ setActFiltro("flotilla"); setBitVista("viaje"); setVerAnteriores(true); setTab("actividad"); })}

            {/* Segunda fila: el CATALOGO de unidades. Antes solo se llegaba a el
                desde un aviso de "Que atender", asi que un patron con todo en regla
                no tenia manera de ver su flota. Una ruta que solo existe cuando algo
                esta mal no es una ruta. */}
            {filaAtender(icoAutoAct, "Catálogo de unidades",
              vehiculosMv.length ? "Placas, documentos y vencimientos" : "Aún no hay vehículos registrados",
              ()=>{ setFlotillaFoco(""); setVerFlotilla(true); })}

            {/* Accesos rápidos — fila de íconos (módulos que se ven bien en cel) */}
            <div style={{fontSize:11, color:C.inkMut, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"1px", margin:"14px 2px 8px"}}>Accesos rápidos</div>
            <div style={{display:"flex", gap:9}}>
              {([
                {label:"Calculadora LFT", on:()=>setVerCalculadora(true), ico:(<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><rect x="5" y="3" width="14" height="18" rx="2" stroke="currentColor" strokeWidth="1.6"/><rect x="8" y="6" width="8" height="3" rx="0.6" stroke="currentColor" strokeWidth="1.4"/><path d="M8.5 13h.01M12 13h.01M15.5 13h.01M8.5 16.5h.01M12 16.5h.01M15.5 16.5h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>)},
                {label:"Publicar aviso", on:abrirAviso, ico:(<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M4 10v4a1 1 0 001 1h2l4 3.5V5.5L7 9H5a1 1 0 00-1 1z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round"/><path d="M15 8.5a4 4 0 010 7" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/></svg>)},
                {label:"Crear evento", on:abrirEvento, ico:(<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><rect x="3.5" y="5" width="17" height="16" rx="2.5" stroke="currentColor" strokeWidth="1.6"/><path d="M3.5 9.5h17M8 3.2v3.2M16 3.2v3.2" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/><path d="M12 12.5v4M10 14.5h4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/></svg>)},
              ]).map((t,i)=>(
                <button key={i} onClick={()=>t.on()}
                  style={{flex:1, minWidth:0, display:"flex", flexDirection:"column" as const, alignItems:"center", gap:7, background:C.panel, border:`1px solid ${C.line}`, borderRadius:14, padding:"12px 6px", boxShadow:C.sombra, cursor:"pointer", fontFamily:fontSans}}>
                  <div style={{width:38, height:38, borderRadius:11, display:"flex", alignItems:"center", justifyContent:"center", background:C.iconBg, border:`1px solid ${C.iconBd}`, color:C.gold}}>{t.ico}</div>
                  <span style={{fontSize:10.5, fontWeight:700, color:C.ink, textAlign:"center" as const, lineHeight:1.2}}>{t.label}</span>
                </button>
              ))}
            </div>
          </>
        )}

        {/* ════ STUBS ════ */}
        {tab==="actividad" && (
          <>
            <div style={{marginBottom:12}}>
              <h1 style={{fontFamily:fontSerif, fontSize:24, fontWeight:700, color:C.ink, margin:0, lineHeight:1.1}}>Actividad diaria</h1>
              <p style={{fontSize:13, color:C.inkSoft, margin:"3px 0 0", textTransform:"capitalize" as const}}>{`Hoy · ${new Date().toLocaleDateString("es-MX",{day:"numeric",month:"long"})}`}</p>
            </div>

            {/* Toggle Por día / Por empleado. No se muestra en la vista por viaje:
                un viaje puede cruzar dos días y llevar más de un conductor, así que
                partirlo por día o por empleado lo rompería. */}
            {!enViaje && (
            <div style={{display:"flex", gap:6, marginBottom:10}}>
              {([["dia","Por día"],["empleado","Por empleado"]] as const).map(([v,l])=>{
                const on = actVista===v;
                return <button key={v} type="button" onClick={()=>{ setActVista(v); setActEmpleadoSel(null); }}
                  style={{flex:1, padding:"9px 6px", borderRadius:10, border:`1px solid ${on?C.gold:C.line}`, cursor:"pointer", fontSize:13, fontWeight:700, fontFamily:fontSans, background:on?C.gold:"transparent", color:on?"#0B1829":C.inkSoft}}>{l}</button>;
              })}
            </div>
            )}

            {/* Chips de filtro por tipo (aplican en ambas vistas).
                ESTA ESCALERA NO ES LA DEL ESCRITORIO, Y ES DELIBERADO.
                Allá son Todo · Flotilla · Checador · Actividades · Expedientes.
                Aquí faltan dos y sobra uno, por dos razones que no son de estilo:

                · ACTIVIDADES Y EXPEDIENTES NO EXISTEN EN ESTA PANTALLA. El feed
                  del móvil construye tres clases de fila —checada, flotilla y
                  accidente— y ninguna más. Poner esos dos botones sería poner dos
                  filtros que SIEMPRE llevan a una lista vacía: eso no es alinear,
                  son dos promesas rotas. Lo que faltaría es construir las filas,
                  no los botones.

                · ACCIDENTES CONSERVA SU BOTÓN. En el escritorio va dentro de
                  Flotilla y eso AGRUPA; aquí lo escondería, porque Flotilla abre
                  en la vista "Por viaje" y un accidente no pertenece a ningún
                  viaje: quedaría fuera de la vista por defecto de su propio
                  filtro. El mismo cambio hace cosas distintas porque las dos
                  pantallas no son iguales.

                Lo que SÍ se alineó es el nombre: "Checador", como en el
                escritorio y como se llama el módulo.

                PENDIENTE, ANOTADO: mientras esto siga así, "Todo" significa cosas
                distintas en cada pantalla —en el escritorio es todo; aquí es todo
                lo que ESTA pantalla construye—. Hoy no miente porque nadie mira
                las dos a la vez, pero es lo que resolvería traer las filas de
                actividades y expedientes al móvil. */}
            <div style={{display:"flex", gap:7, marginBottom:10, flexWrap:"wrap" as const}}>
              {([["todo","Todo"],["checadas","Checador"],["flotilla","Flotilla"],["accidentes","Accidentes"]] as const).map(([v,l])=>{
                const on = actFiltro===v;
                return <button key={v} type="button" onClick={()=>setActFiltro(v)}
                  style={{padding:"7px 14px", borderRadius:999, border:`1px solid ${on?C.gold:C.line}`, cursor:"pointer", fontSize:12.5, fontWeight:700, fontFamily:fontSans,
                    background:on?C.gold:"transparent", color:on?"#0B1829":C.inkSoft}}>{l}</button>;
              })}
            </div>

            {/* SELECTOR DE LA BITÁCORA. "Por viaje" es la vista por defecto y la
                que se lee; "Por movimiento" queda como AUDITORÍA, para revisar
                captura por captura. Es el mismo dato leído de dos maneras, no dos
                agrupaciones alternativas: no existe ni una tercera. */}
            {actFiltro==="flotilla" && (
              <div style={{display:"flex", gap:6, marginBottom:10}}>
                {([["movimiento","Por movimiento"],["viaje","Por viaje"]] as const).map(([v,l])=>{
                  const on = bitVista===v;
                  return <button key={v} type="button" onClick={()=>{ setBitVista(v); setActEmpleadoSel(null); }}
                    style={{flex:1, padding:"9px 6px", borderRadius:10, border:`1px solid ${on?C.gold:C.line}`, cursor:"pointer", fontSize:13, fontWeight:700, fontFamily:fontSans,
                      background:on?C.gold:"transparent", color:on?"#0B1829":C.inkSoft}}>{l}</button>;
                })}
              </div>
            )}

            {/* El MISMO control del reporte que en el catálogo de unidades: una
                implementación, dos puntos de entrada. Aquí es donde el mes escrito
                importa más, porque queda a la vista de los filtros Desde/Hasta y el
                reporte NO los respeta: cubre un mes completo. */}
            {actFiltro==="flotilla" && vehiculosMv.length>0 && (
              <ControlReporteFlotillaMovil
                mes={mesRepFlotaMv} setMes={setMesRepFlotaMv}
                generando={generandoRepFlotaMv} msg={msgRepFlotaMv}
                onGenerar={generarReporteFlotillaMv} C={C} fontSans={fontSans}/>
            )}

            {/* FILTROS A NIVEL VIAJE. Filtrar por conductor devuelve sus viajes
                COMPLETOS, no los renglones que coincidan: el viaje es la unidad de
                lectura, y partirlo al filtrar devolvería la lista cronológica que
                estorbaba. En esta vista sustituyen al control de "ver días
                anteriores": dos controles de fecha a la vez solo confunden. */}
            {enViaje && (<>
              <input {...CAMPO_DE_PARAMETRO} value={bitTexto} onChange={e=>setBitTexto(e.target.value)}
                placeholder="Buscar placa, conductor o destino…"
                style={{width:"100%", boxSizing:"border-box" as const, padding:"11px 12px", borderRadius:12, border:`1px solid ${C.line}`,
                  background:C.panel, color:C.ink, fontSize:13, fontFamily:fontSans, marginBottom:8}} />
              <button onClick={()=>setBitFiltrosAbiertos(v=>!v)}
                style={{width:"100%", marginBottom: bitFiltrosAbiertos?10:14, background:"transparent", border:`1px solid ${C.line}`,
                  color:C.gold, borderRadius:12, padding:"10px 14px", cursor:"pointer", fontSize:12.5, fontWeight:700, fontFamily:fontSans}}>
                {bitFiltrosAbiertos ? "Ocultar filtros" : bitHayFiltro ? "Filtros activos · ver" : "Filtrar por unidad, conductor o fecha"}
              </button>
              {bitFiltrosAbiertos && (
                <div style={{display:"flex", flexDirection:"column" as const, gap:10, marginBottom:14,
                  background:C.panel, border:`1px solid ${C.line}`, borderRadius:14, padding:"12px 13px"}}>
                  <div>
                    <div style={{fontSize:10.5, fontWeight:700, color:C.inkMut, textTransform:"uppercase" as const, letterSpacing:"0.4px", margin:"0 0 4px 2px"}}>Unidad</div>
                    <select {...CAMPO_DE_PARAMETRO} value={bitUnidad} onChange={e=>setBitUnidad(e.target.value)} style={{width:"100%", boxSizing:"border-box" as const, padding:"10px 11px", borderRadius:10, border:`1px solid ${C.line}`, background:C.panel, color:C.ink, fontSize:12.5, fontFamily:fontSans}}>
                      <option value="" style={{color:"#0B1829"}}>Todas las unidades</option>
                      {bitOpciones.unidades.map((o:any)=>(<option key={o.clave} value={o.clave} style={{color:"#0B1829"}}>{o.etiqueta}</option>))}
                    </select>
                  </div>
                  <div>
                    <div style={{fontSize:10.5, fontWeight:700, color:C.inkMut, textTransform:"uppercase" as const, letterSpacing:"0.4px", margin:"0 0 4px 2px"}}>Conductor</div>
                    <select {...CAMPO_DE_PARAMETRO} value={bitPersona} onChange={e=>setBitPersona(e.target.value)} style={{width:"100%", boxSizing:"border-box" as const, padding:"10px 11px", borderRadius:10, border:`1px solid ${C.line}`, background:C.panel, color:C.ink, fontSize:12.5, fontFamily:fontSans}}>
                      <option value="" style={{color:"#0B1829"}}>Todos los conductores</option>
                      {bitOpciones.personas.map((o:any)=>(<option key={o.clave} value={o.clave} style={{color:"#0B1829"}}>{o.etiqueta}</option>))}
                    </select>
                  </div>
                  <div style={{display:"flex", gap:8}}>
                    <div style={{flex:1, minWidth:0}}>
                      <div style={{fontSize:10.5, fontWeight:700, color:C.inkMut, textTransform:"uppercase" as const, letterSpacing:"0.4px", margin:"0 0 4px 2px"}}>Desde</div>
                      <input {...CAMPO_DE_PARAMETRO} type="date" value={bitDesde} onChange={e=>setBitDesde(e.target.value)} style={{width:"100%", boxSizing:"border-box" as const, padding:"10px 11px", borderRadius:10, border:`1px solid ${C.line}`, background:C.panel, color:C.ink, fontSize:12.5, fontFamily:fontSans}} />
                    </div>
                    <div style={{flex:1, minWidth:0}}>
                      <div style={{fontSize:10.5, fontWeight:700, color:C.inkMut, textTransform:"uppercase" as const, letterSpacing:"0.4px", margin:"0 0 4px 2px"}}>Hasta</div>
                      <input {...CAMPO_DE_PARAMETRO} type="date" value={bitHasta} onChange={e=>setBitHasta(e.target.value)} style={{width:"100%", boxSizing:"border-box" as const, padding:"10px 11px", borderRadius:10, border:`1px solid ${C.line}`, background:C.panel, color:C.ink, fontSize:12.5, fontFamily:fontSans}} />
                    </div>
                  </div>
                  {/* Los MISMOS atajos que el escritorio, con la misma mecánica:
                      escriben en Desde y Hasta, no filtran aparte. */}
                  <div style={{display:"flex", gap:6, flexWrap:"wrap" as const}}>
                    {([["semana","Esta semana"],["mes","Este mes"],["mes_pasado","Mes pasado"]] as const).map(([k,l2])=>(
                      <button key={k} type="button" onClick={()=>{ const r = rangoDeAtajo(k); setBitDesde(r.desde); setBitHasta(r.hasta); }}
                        style={{flex:"1 1 auto", background:"transparent", border:`1px solid ${C.line}`, color:C.inkSoft, borderRadius:999,
                          padding:"8px 10px", cursor:"pointer", fontSize:12, fontWeight:700, fontFamily:fontSans, whiteSpace:"nowrap" as const}}>{l2}</button>
                    ))}
                  </div>
                  {bitHayFiltro && (
                    <button onClick={()=>{ setBitTexto(""); setBitUnidad(""); setBitPersona(""); setBitDesde(""); setBitHasta(""); }}
                      style={{background:"transparent", border:"none", color:C.gold, cursor:"pointer", fontSize:12.5, fontWeight:700, fontFamily:fontSans, padding:"2px 0"}}>
                      Quitar todos los filtros
                    </button>
                  )}
                </div>
              )}
            </>)}

            {/* Control de fecha ARRIBA (solo en la vista por movimiento) */}
            {!enViaje && (
            <button onClick={()=>setVerAnteriores(v=>!v)}
              style={{width:"100%", marginBottom:14, background:"transparent", border:`1px solid ${C.line}`, color:C.gold, borderRadius:12, padding:"10px 14px", cursor:"pointer", fontSize:12.5, fontWeight:700, fontFamily:fontSans}}>
              {verAnteriores ? "Ver solo hoy" : "Ver días anteriores"}
            </button>
            )}

            {/* Contenido según vista */}
            {enViaje ? (
              <div>{bloquesDeViajes()}</div>
            ) : actVista==="dia" ? (
              <div>{bloquesPorDia(feedActividad)}</div>
            ) : actEmpleadoSel ? (
              <div>
                <button onClick={()=>setActEmpleadoSel(null)}
                  style={{display:"inline-flex", alignItems:"center", gap:6, background:"transparent", border:"none", color:C.gold, cursor:"pointer", fontFamily:fontSans, fontSize:13, fontWeight:700, padding:"0 0 10px"}}>
                  <span style={{fontSize:16, lineHeight:1}}>‹</span> Empleados
                </button>
                <div style={{fontFamily:fontSerif, fontSize:17, fontWeight:700, color:C.gold, marginBottom:12}}>{empleadosActividad.find((e:any)=>e.key===actEmpleadoSel)?.nombre || "Empleado"}</div>
                {bloquesPorDia(feedActividad.filter((it:any)=> (it.email||it.nombre)===actEmpleadoSel))}
              </div>
            ) : (
              empleadosActividad.length===0 ? (
                <div style={{textAlign:"center" as const, padding:"40px 20px", background:C.panel, border:`1px solid ${C.line}`, borderRadius:16, boxShadow:C.sombra}}>
                  <div style={{fontSize:13, color:C.inkSoft, lineHeight:1.5}}>{verAnteriores ? "Ningún empleado con actividad en el rango." : "Ningún empleado con actividad hoy."}</div>
                </div>
              ) : (
                <div style={{display:"flex", flexDirection:"column" as const, gap:9}}>
                  {empleadosActividad.map((e:any)=>(
                    <button key={e.key} onClick={()=>setActEmpleadoSel(e.key)}
                      style={{display:"flex", alignItems:"center", gap:12, width:"100%", textAlign:"left" as const, fontFamily:fontSans, background:C.panel, border:`1px solid ${C.line}`, borderRadius:14, padding:"13px 14px", boxShadow:C.sombra, cursor:"pointer"}}>
                      <div style={{width:40, height:40, borderRadius:"50%", flexShrink:0, display:"flex", alignItems:"center", justifyContent:"center", background:`rgba(${A.rgbDim},0.14)`, border:`1px solid ${C.iconBd}`, color:C.gold, fontSize:13, fontWeight:800}}>{(e.nombre||"").trim().split(/\s+/).slice(0,2).map((s:string)=>s[0]||"").join("").toUpperCase()||"·"}</div>
                      <div style={{flex:1, minWidth:0}}>
                        <div style={{fontSize:13.5, fontWeight:700, color:C.ink}}>{e.nombre}</div>
                        <div style={{fontSize:12, color:C.inkSoft, marginTop:1}}>{e.items.length} registro{e.items.length===1?"":"s"}</div>
                      </div>
                      <span style={{fontSize:20, color:C.inkMut, lineHeight:1}}>›</span>
                    </button>
                  ))}
                </div>
              )
            )}
          </>
        )}
        {/* ════ EQUIPO ════ */}
        {tab==="equipo" && (
          !empSelData ? (
            /* ── EQUIPO: sub-toggle Empleados / Actividades ── */
            <>
              <div style={{display:"flex", gap:6, marginBottom:14, background:C.panel, border:`1px solid ${C.line}`, borderRadius:12, padding:4, boxShadow:C.sombra}}>
                {([["empleados","Empleados"],["tareas","Actividades"]] as const).map(([k,lbl])=>(
                  <button key={k} onClick={()=>{ setEquipoVista(k); setTareaForm(null); setTareaErr(""); }}
                    style={{flex:1, padding:"9px", borderRadius:9, border:"none", cursor:"pointer", fontFamily:fontSans, fontSize:13, fontWeight:800, background: equipoVista===k?C.gold:"transparent", color: equipoVista===k?"#0B1829":C.inkSoft}}>{lbl}</button>
                ))}
              </div>
              {equipoVista==="tareas" ? vistaTareasCentral : (
              <>
              <div style={{marginBottom:14}}>
                <h1 style={{fontFamily:fontSerif, fontSize:24, fontWeight:700, color:C.ink, margin:0, lineHeight:1.1}}>Equipo</h1>
                {/* Los MISMOS dos hechos que el escritorio: cuántos hay y a cuántos
                    alcanza la plataforma. Sin la colección leída no se afirma. */}
                <p style={{fontSize:13, color:C.inkSoft, margin:"3px 0 0"}}>{loading?"Cargando…":(
                  `${empleadosEquipo.length} empleado${empleadosEquipo.length===1?"":"s"}` +
                  (cuentasTrab === null ? "" : ` · ${empleadosEquipo.filter(({e}:any)=> correosConCuentaActiva(cuentasTrab).has(String(e.email||"").toLowerCase().trim())).length} con cuenta`)
                )}</p>
              </div>
              {/* Acceso secundario: avisar a todos */}
              <button onClick={abrirAviso}
                style={{display:"inline-flex", alignItems:"center", gap:8, marginBottom:14, padding:"10px 14px", borderRadius:12, border:`1px solid ${C.line}`, background:C.panel, color:C.gold, cursor:"pointer", fontFamily:fontSans, fontSize:13, fontWeight:700, boxShadow:C.sombra}}>
                <svg width="17" height="17" viewBox="0 0 24 24" fill="none"><path d="M4 10v4a1 1 0 001 1h2l4 3.5V5.5L7 9H5a1 1 0 00-1 1z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round"/><path d="M15 8.5a4 4 0 010 7" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/></svg>
                Avisar a todos
              </button>
              {/* Entrada compacta al horario+ubicación (abre ventana; mantiene Equipo limpio) */}
              {filaAtender(
                (<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.6"/><path d="M12 7.5V12l3 1.7" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/></svg>),
                "Horario y ubicación de trabajo",
                "Entrada/salida, tolerancia y geocerca del equipo",
                ()=>setVerHorarioConfig(true)
              )}
              {empleadosEquipo.length===0 ? (
                <div style={{textAlign:"center" as const, padding:"44px 22px", background:C.panel, border:`1px solid ${C.line}`, borderRadius:16, boxShadow:C.sombra}}>
                  <div style={{fontFamily:fontSerif, fontSize:17, fontWeight:700, color:C.gold, marginBottom:6}}>Aún no tienes empleados</div>
                  <p style={{fontSize:12.5, color:C.inkSoft, margin:0, lineHeight:1.5}}>Registra a tu equipo desde la suite de escritorio (Empleados / Cuentas de trabajador) y aquí verás su cumplimiento.</p>
                </div>
              ) : (
                <div style={{display:"flex", flexDirection:"column" as const, gap:10}}>
                  {empleadosEquipo.map(({e,m,st}:any)=>{
                    const sub = [e.puesto, e.departamento].filter(Boolean).join(" · ");
                    return (
                      <button key={e.id} onClick={()=>{ setEquipoSel((e.email||"").toLowerCase()); setTareaForm(null); setTareaErr(""); }}
                        ref={e.id === _primerSinChecarMv ? _resSinChecarMv.ref : undefined}
                        style={{display:"block", width:"100%", textAlign:"left" as const, fontFamily:fontSans, background:C.panel, border:`1px solid ${C.line}`, borderRadius:14, padding:"13px 14px", boxShadow:C.sombra, cursor:"pointer",
                          ...estiloResaltado(e.id === _primerSinChecarMv && _resSinChecarMv.vivo, "tarjeta", "navy")}}>
                        <div style={{display:"flex", alignItems:"center", gap:12, marginBottom:12}}>
                          <div style={{width:40, height:40, borderRadius:"50%", flexShrink:0, display:"flex", alignItems:"center", justifyContent:"center", background:`rgba(${A.rgbDim},0.14)`, border:`1px solid ${C.iconBd}`, color:C.gold, fontSize:13, fontWeight:800}}>{inicialesDe(e.nombre)}</div>
                          <div style={{flex:1, minWidth:0}}>
                            <div style={{display:"flex", alignItems:"center", gap:7, minWidth:0}}>
                              <span style={{fontSize:14, fontWeight:700, color:C.ink, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" as const}}>{e.nombre||e.email||"Empleado"}</span>
                              {marcadosSinChecar.has((e.email||"").toLowerCase().trim()) && (
                                <span style={{flexShrink:0, fontSize:9.5, fontWeight:800, padding:"2px 7px", borderRadius:999, whiteSpace:"nowrap" as const,
                                  border:"1px solid rgba(226,184,74,0.45)", background:"rgba(226,184,74,0.14)", color:"#E2B84A"}}>Sin checar hoy</span>
                              )}
                            </div>
                            {sub && <div style={{fontSize:12, color:C.inkSoft, marginTop:1, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" as const}}>{sub}</div>}
                          </div>
                          {badgeVenc(st)}
                          <span style={{fontSize:20, color:C.inkMut, lineHeight:1}}>›</span>
                        </div>
                        <div style={{display:"flex", gap:16}}>
                          {medidorEquipo("Documental", m.pctDocs)}
                          {medidorEquipo("Actividades", m.pctTareas)}
                        </div>
                      </button>
                    );
                  })}
                </div>
              )}
              </>
              )}
            </>
          ) : (
            /* ── Ficha del empleado ── */
            <>
              <button onClick={()=>{ setEquipoSel(null); setTareaForm(null); setTareaErr(""); }}
                style={{display:"inline-flex", alignItems:"center", gap:6, background:"transparent", border:"none", color:C.gold, cursor:"pointer", fontFamily:fontSans, fontSize:13, fontWeight:700, padding:"0 0 12px"}}>
                <span style={{fontSize:16, lineHeight:1}}>‹</span> Equipo
              </button>

              {/* Encabezado de la ficha */}
              <div style={{display:"flex", alignItems:"center", gap:13, background:C.panel, border:`1px solid ${C.line}`, borderRadius:16, padding:"15px 16px", boxShadow:C.sombra, marginBottom:14}}>
                <div style={{width:54, height:54, borderRadius:"50%", flexShrink:0, display:"flex", alignItems:"center", justifyContent:"center", background:`rgba(${A.rgbDim},0.14)`, border:`1px solid ${C.iconBd}`, color:C.gold, fontSize:18, fontWeight:800}}>{inicialesDe(empSelData.e.nombre)}</div>
                <div style={{flex:1, minWidth:0}}>
                  <div style={{fontFamily:fontSerif, fontSize:19, fontWeight:700, color:C.ink, lineHeight:1.15}}>{empSelData.e.nombre||empSelData.e.email||"Empleado"}</div>
                  {[empSelData.e.puesto, empSelData.e.departamento].filter(Boolean).length>0 && (
                    <div style={{fontSize:12.5, color:C.inkSoft, marginTop:2}}>{[empSelData.e.puesto, empSelData.e.departamento].filter(Boolean).join(" · ")}</div>
                  )}
                  <div style={{marginTop:7}}>{badgeVenc(empSelData.st)}</div>
                </div>
              </div>

              {/* Medidores en grande */}
              <div style={{display:"flex", gap:18, background:C.panel, border:`1px solid ${C.line}`, borderRadius:16, padding:"16px 18px", boxShadow:C.sombra, marginBottom:16}}>
                {medidorEquipo("Documental", empSelData.m.pctDocs, true)}
                {medidorEquipo("Actividades", empSelData.m.pctTareas, true)}
              </div>

              {/* Horario personalizado del empleado (excepción sobre el general) */}
              <div style={{marginBottom:16}}>
                <HorarioLaboralEditor modo="empleado" currentUser={currentUser} trabajador={empSelData.e} tema="navy" fontSans={fontSans} fontSerif={fontSerif} />
              </div>

              {/* Documentos del expediente (subir con cámara/escáner o archivo) */}
              <div style={{marginBottom:16, padding:"14px 14px", borderRadius:12, border:`1px solid ${C.iconBd}`, background:`rgba(255,255,255,0.03)`}}>
                <div style={{fontSize:11, color:C.inkMut, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"1px", marginBottom:9}}>Documentos del expediente</div>
                <DocumentosEmpleadoBox empleado={empSelData.e} currentUser={currentUser} tema="navy" fontSans={fontSans} />
              </div>

              {/* Reporte mensual completo (PDF) */}
              <div style={{marginBottom:16, padding:"14px 14px", borderRadius:12, border:`1px solid ${C.iconBd}`, background:`rgba(255,255,255,0.03)`}}>
                <div style={{fontSize:11, color:C.inkMut, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"1px", marginBottom:9}}>Registro mensual</div>
                <ReporteMensualBoton empleado={empSelData.e} checadas={checadasPatron} correcciones={correccionesPatron} tareas={tareasPatron} accidentes={accidentesPatron} currentUser={currentUser} tema="navy" fontSans={fontSans} />
              </div>

              {/* Bitácora quincenal de checador (PDF) */}
              <div style={{marginBottom:16, padding:"14px 14px", borderRadius:12, border:`1px solid ${C.iconBd}`, background:`rgba(255,255,255,0.03)`}}>
                <div style={{fontSize:11, color:C.inkMut, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"1px", marginBottom:9}}>Bitácora de asistencia</div>
                <BitacoraBoton empleado={empSelData.e} checadas={checadasPatron} correcciones={correccionesPatron} currentUser={currentUser} tema="navy" fontSans={fontSans} />
              </div>

              {/* SU CHECADOR, COMO QUEDÓ DESPUÉS DE LAS CORRECCIONES (fase 2b): la misma
                  vista y las mismas anotaciones que la ficha de escritorio, con las
                  notas «no conforme»; aquí solo se ve (corregir, desde una computadora). */}
              <div data-movil="checador-empleado" style={{marginBottom:16, padding:"14px 14px", borderRadius:12, border:`1px solid ${C.iconBd}`, background:`rgba(255,255,255,0.03)`}}>
                <div style={{fontSize:11, color:C.inkMut, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"1px", marginBottom:9}}>Checador</div>
                {(()=>{
                  const correoEmp = String(empSelData.e.email||"").toLowerCase().trim();
                  const deEmp = (x:any)=> String(x?.trabajadorEmail||"").toLowerCase().trim() === correoEmp;
                  const vistaEmp = vistaEfectiva({checadas: (checadasPatron||[]).filter(deEmp), correcciones: (correccionesPatron||[]).filter(deEmp), noConformidades: (noConformesPatron||[]).filter(deEmp)});
                  return <ChecadasConCorrecciones vista={vistaEmp} ficha={empSelData.e} horarioEn={(t:Date|null)=> horarioQueRegia(empSelData.e, horarioGeneral, historialGeneral, t as any)}
                    currentUser={currentUser} trabajadorEmail={correoEmp} onCambio={()=>{}} fontSans={fontSans} soloLectura tema="navy"/>;
                })()}
              </div>

              {/* Actividades del empleado */}
              <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", margin:"0 2px 10px"}}>
                <span style={{fontSize:11, color:C.inkMut, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"1px"}}>Actividades · {tareasEmpSel.length}</span>
                  {/* `onClick={abrirCrearTarea}` pasaba el EVENTO del clic como
                      primer argumento, asi que `trabajadorEmail` acababa siendo un
                      objeto y al guardar reventaba con ".toLowerCase is not a
                      function". En escritorio no pasaba porque alli se llama con
                      flecha. */}
                {!tareaForm && (
                  <button onClick={()=>abrirCrearTarea()}
                    style={{display:"inline-flex", alignItems:"center", gap:5, padding:"6px 11px", borderRadius:9, border:`1px solid ${C.gold}`, background:`rgba(${A.rgbBright},0.12)`, color:C.gold, cursor:"pointer", fontFamily:fontSans, fontSize:12, fontWeight:800}}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
                    Asignar actividad
                  </button>
                )}
              </div>

              {/* Formulario crear / editar (misma colección y campos que la suite) */}
              {tareaForm && (
                <div {...ZONA_DE_CAPTURA} style={{background:C.panel, border:`1px solid ${C.gold}`, borderRadius:14, padding:"14px 14px", boxShadow:C.sombra, marginBottom:12}}>
                  <div style={{fontFamily:fontSerif, fontSize:15, fontWeight:700, color:C.gold, marginBottom:10}}>
                    {tareaForm.modo==="crear" ? `Nueva actividad · ${empSelData.e.nombre||empSelData.e.email||"Empleado"}` : "Editar actividad"}
                  </div>
                  <label style={lblTarea}>Título</label>
                  <input value={tareaForm.titulo} onChange={e=>setTareaForm(f=>f?{...f, titulo:e.target.value}:f)} placeholder="Ej. Entregar reporte mensual" style={inpTarea}/>
                  <label style={lblTarea}>Descripción (opcional)</label>
                  <textarea value={tareaForm.descripcion} onChange={e=>setTareaForm(f=>f?{...f, descripcion:e.target.value}:f)} rows={3} placeholder="Detalles de la actividad…" style={{...inpTarea, resize:"vertical" as const, minHeight:64}}/>
                  <label style={lblTarea}>Fecha límite</label>
                  <input type="date" value={tareaForm.fechaLimite} onChange={e=>setTareaForm(f=>f?{...f, fechaLimite:e.target.value}:f)} style={{...inpTarea, marginBottom:0}}/>
                  {tareaErr && <div style={{fontSize:12, color:"#FCA5A5", fontWeight:700, marginTop:8}}>{tareaErr}</div>}
                  <div style={{display:"flex", gap:8, marginTop:12}}>
                    <button onClick={()=>{ setTareaForm(null); setTareaErr(""); }}
                      style={{flex:1, padding:"10px", borderRadius:10, border:`1px solid ${C.line}`, background:"transparent", color:C.inkSoft, cursor:"pointer", fontFamily:fontSans, fontSize:13, fontWeight:700}}>Cancelar</button>
                    <button onClick={guardarTarea} disabled={tareaGuardando}
                      style={{flex:2, padding:"10px", borderRadius:10, border:"none", background:C.gold, color:"#0B1829", cursor:tareaGuardando?"wait":"pointer", fontFamily:fontSans, fontSize:13, fontWeight:800}}>
                      {tareaGuardando ? "Guardando…" : (tareaForm.modo==="crear" ? "Asignar actividad" : "Guardar cambios")}
                    </button>
                  </div>
                </div>
              )}

              {tareasEmpSel.length===0 ? (
                <div style={{textAlign:"center" as const, padding:"30px 20px", background:C.panel, border:`1px solid ${C.line}`, borderRadius:16, boxShadow:C.sombra}}>
                  <div style={{fontSize:13, color:C.inkSoft, lineHeight:1.5}}>Aún no le has asignado actividades. Usa "Asignar actividad" para crear la primera.</div>
                </div>
              ) : (
                <div style={{display:"flex", flexDirection:"column" as const, gap:9}}>
                  {tareasEmpSel.map((t:any)=>{
                    const est = t.confirmadaPorPatron ? "Confirmada" : t.marcadaPorTrabajador ? "Por confirmar" : "Pendiente";
                    return (
                      <div key={t.id} style={{background:C.panel, border:`1px solid ${C.line}`, borderRadius:14, padding:"12px 14px", boxShadow:C.sombra}}>
                        <div style={{display:"flex", alignItems:"baseline", gap:8, flexWrap:"wrap" as const, marginBottom:t.descripcion||t.fechaLimite?4:0}}>
                          <span style={{fontSize:13.5, fontWeight:700, color:C.ink, flex:1, minWidth:0}}>{t.titulo||"Actividad"}</span>
                          {badgeEstadoEq(est)}
                        </div>
                        {t.descripcion && <div style={{fontSize:12, color:C.inkSoft, marginBottom:3, whiteSpace:"pre-wrap" as const}}>{t.descripcion}</div>}
                        {t.fechaLimite && <div style={{fontSize:11.5, color:C.inkMut}}>Límite: {t.fechaLimite}</div>}
                        <div style={{display:"flex", gap:8, marginTop:10}}>
                          <button onClick={()=>abrirEditarTarea(t)}
                            style={{flex:1, padding:"8px 10px", borderRadius:9, border:`1px solid ${C.line}`, background:"transparent", color:C.gold, cursor:"pointer", fontFamily:fontSans, fontSize:12, fontWeight:700}}>Editar</button>
                          {est==="Por confirmar" && (
                            <button onClick={()=>confirmarTareaEquipo(t.id)} disabled={equipoConfirmando===t.id}
                              style={{flex:1, padding:"8px 10px", borderRadius:9, cursor:equipoConfirmando===t.id?"wait":"pointer", fontFamily:fontSans, fontSize:12, fontWeight:800,
                                border:"1px solid rgba(52,211,153,0.45)", background:"rgba(52,211,153,0.14)", color:"#34D399"}}>
                              {equipoConfirmando===t.id ? "Confirmando…" : "Confirmar"}
                            </button>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
              <p style={{fontSize:11.5, color:C.inkMut, margin:"14px 2px 0", lineHeight:1.5}}>Asigna actividades nuevas, edítalas y confirma las que tu empleado marque como hechas. Es la misma lógica (doble validación) que la suite.</p>
            </>
          )
        )}
        {tab==="perfil" && (
          <div>
            {/* Identidad + plan */}
            <div {...ZONA_DE_CAPTURA} style={{textAlign:"center" as const, background:C.panel, border:`1px solid ${C.line}`, borderRadius:16, padding:"24px 20px", boxShadow:C.sombra, marginBottom:14}}>
              {/* Avatar TOCABLE (tipo WhatsApp): tócalo para cambiar la foto. */}
              <div style={{marginBottom:12}}>
                <AvatarEditable url={fotoPerfilUrl} iniciales={iniciales} size={72} userId={currentUser.uid} carpeta="perfil"
                  onSubido={(u:string)=>guardarFotoPerfil(u)} fontSans={fontSans}
                  c={{gold:C.gold, iconBg:`rgba(${A.rgbDim},0.14)`, iconBd:C.iconBd, panel:C.panel, inkSoft:C.inkSoft}}/>
              </div>
              <div style={{fontFamily:fontSerif, fontSize:20, fontWeight:700, color:C.gold}}>{nombre}</div>
              {correo && <div style={{fontSize:12.5, color:C.inkSoft, marginTop:3, wordBreak:"break-all" as const}}>{correo}</div>}
              {/* SOLO LECTURA en el teléfono: se captura desde la computadora,
                  junto con el RFC, el domicilio y el correo de contacto. */}
              <div style={{marginTop:5}}>
                <span style={{fontSize:12.5, color:C.inkSoft}}>Empresa: <span style={{color:empresaNombre?C.ink:C.inkMut, fontWeight:700}}>{empresaNombre || "Sin capturar"}</span></span>
                {!empresaNombre && (
                  // DICE "DESDE UNA COMPUTADORA", no solo el nombre de la pantalla.
                  // En el teléfono esa pantalla no existe —el portal móvil no pasa
                  // por las rutas del armazón—, así que nombrarla a secas mandaría a
                  // buscar algo que no va a encontrar.
                  <div style={{fontSize:11, color:C.inkMut, marginTop:3, lineHeight:1.45, maxWidth:280, marginLeft:"auto", marginRight:"auto"}}>
                    Estos datos se capturan desde una computadora, en “Datos de mi empresa”. Mientras falten, no se pueden emitir los documentos que se firman.
                  </div>
                )}
              </div>
              {/* Puesto / rol del patrón (editable) */}
              {!puestoEdit ? (
                <div style={{display:"flex", alignItems:"center", justifyContent:"center", gap:8, marginTop:5}}>
                  <span style={{fontSize:12.5, color:C.inkSoft}}>Puesto: <span style={{color:puesto?C.ink:C.inkMut, fontWeight:700}}>{puesto || "Agrega tu puesto"}</span></span>
                  <button onClick={()=>{ setPuestoInput(puesto); setPuestoOk(false); setPuestoEdit(true); }} aria-label="Editar puesto"
                    style={{display:"inline-flex", alignItems:"center", justifyContent:"center", width:24, height:24, borderRadius:7, border:`1px solid ${C.line}`, background:"transparent", color:C.gold, cursor:"pointer", fontFamily:fontSans}}>
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none"><path d="M4 20h4l10-10-4-4L4 16z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round"/><path d="M13.5 6.5l4 4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/></svg>
                  </button>
                </div>
              ) : (
                <div style={{marginTop:8, textAlign:"left" as const}}>
                  <input value={puestoInput} onChange={e=>setPuestoInput(e.target.value)} placeholder="Ej. Director general" autoFocus
                    style={{width:"100%", boxSizing:"border-box" as const, padding:"10px 12px", borderRadius:10, border:`1px solid ${C.gold}`, background:"rgba(255,255,255,0.04)", color:C.ink, fontSize:14, fontFamily:fontSans, outline:"none"}}/>
                  <div style={{display:"flex", gap:8, marginTop:8}}>
                    <button onClick={()=>setPuestoEdit(false)}
                      style={{flex:1, padding:"9px", borderRadius:10, border:`1px solid ${C.line}`, background:"transparent", color:C.inkSoft, cursor:"pointer", fontFamily:fontSans, fontSize:13, fontWeight:700}}>Cancelar</button>
                    <button onClick={guardarPuesto} disabled={puestoGuardando}
                      style={{flex:2, padding:"9px", borderRadius:10, border:"none", background:C.gold, color:"#0B1829", cursor:puestoGuardando?"wait":"pointer", fontFamily:fontSans, fontSize:13, fontWeight:800}}>{puestoGuardando ? "Guardando…" : "Guardar"}</button>
                  </div>
                </div>
              )}
              {puestoOk && !puestoEdit && <div style={{fontSize:11, color:"#34D399", fontWeight:700, marginTop:6}}>✓ Puesto guardado</div>}
              {/* WhatsApp de contacto: lo usan tus trabajadores desde Flotilla */}
              {!waEdit ? (
                <div style={{display:"flex", alignItems:"center", justifyContent:"center", gap:8, marginTop:5}}>
                  <span style={{fontSize:12.5, color:C.inkSoft}}>WhatsApp: <span style={{color:waPat?C.ink:C.inkMut, fontWeight:700}}>{waPat || "Agrega tu WhatsApp"}</span></span>
                  <button onClick={()=>{ setWaInput(waPat); setWaOk(false); setWaEdit(true); }} aria-label="Editar WhatsApp"
                    style={{display:"inline-flex", alignItems:"center", justifyContent:"center", width:24, height:24, borderRadius:7, border:`1px solid ${C.line}`, background:"transparent", color:C.gold, cursor:"pointer", fontFamily:fontSans}}>
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none"><path d="M4 20h4l10-10-4-4L4 16z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round"/><path d="M13.5 6.5l4 4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/></svg>
                  </button>
                </div>
              ) : (
                <div style={{marginTop:8, textAlign:"left" as const}}>
                  <input value={waInput} onChange={e=>setWaInput(e.target.value)} inputMode="tel" placeholder="Ej. 449 123 4567" autoFocus
                    style={{width:"100%", boxSizing:"border-box" as const, padding:"10px 12px", borderRadius:10, border:`1px solid ${C.gold}`, background:"rgba(255,255,255,0.04)", color:C.ink, fontSize:14, fontFamily:fontSans, outline:"none"}}/>
                  <div style={{fontSize:10.5, color:C.inkMut, margin:"5px 2px 0", lineHeight:1.45}}>Tus trabajadores podrán contactarte desde Flotilla. 10 dígitos (México).</div>
                  <div style={{display:"flex", gap:8, marginTop:8}}>
                    <button onClick={()=>setWaEdit(false)}
                      style={{flex:1, padding:"9px", borderRadius:10, border:`1px solid ${C.line}`, background:"transparent", color:C.inkSoft, cursor:"pointer", fontFamily:fontSans, fontSize:13, fontWeight:700}}>Cancelar</button>
                    <button onClick={guardarWhatsapp} disabled={waGuardando}
                      style={{flex:2, padding:"9px", borderRadius:10, border:"none", background:C.gold, color:"#0B1829", cursor:waGuardando?"wait":"pointer", fontFamily:fontSans, fontSize:13, fontWeight:800}}>{waGuardando ? "Guardando…" : "Guardar"}</button>
                  </div>
                </div>
              )}
              {waOk && !waEdit && <div style={{fontSize:11, color:"#34D399", fontWeight:700, marginTop:6}}>✓ WhatsApp guardado y compartido con tus trabajadores</div>}
              <span style={{display:"inline-block", marginTop:10, fontSize:11, fontWeight:800, letterSpacing:"0.5px", color:"#0B1829", background:C.gold, borderRadius:999, padding:"4px 12px"}}>PLAN PRO</span>
            </div>

            {/* Color del portal (personalización local): una línea, cerca del inicio */}
            <SelectorColorPortal acentos={ACENTOS} actual={acento} onElegir={elegirAcento} tinta={C.ink} tintaSuave={C.inkSoft} fontSans={fontSans}/>

            {/* ── AVISOS: LA ENTRADA PERMANENTE, TAMBIÉN EN EL TELÉFONO ───────
                ⚠️ ESTA FILA FALTABA, Y ERA EL PEOR SITIO PARA QUE FALTARA.
                En el escritorio, la tarjeta de "Prepara este dispositivo" se cierra
                con una equis que se guarda en `localStorage` PARA SIEMPRE y por
                dispositivo — pero allí quedaba esta misma fila en el perfil, que no
                se puede cerrar. Aquí no había nada: un patrón que pulsara la equis
                una vez en su teléfono se quedaba sin NINGUNA superficie para
                activar los avisos, sin poder volver y sin enterarse de que se había
                quedado sin ellos.

                Y el teléfono es justo donde importa: es el aparato que va a sonar
                cuando uno de sus trabajadores registre un accidente.

                Es la MISMA pieza que en el escritorio —`PuertaDeAvisos` compacta— y
                el mismo estado, leído del mismo proveedor. Lo único propio es la
                paleta, porque este árbol pinta sobre navy y el otro sobre crema. */}
            <div style={{fontSize:11, color:C.inkMut, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"1px", margin:"0 2px 8px"}}>Avisos</div>
            <div style={{marginBottom:18}}>
              <PuertaDeAvisos estado={estadoAvisosMv} onActivar={activarAvisosMv} compacta fontSans={fontSans}
                c={{fondo: C.panel, borde: C.line, acento: C.gold, botonTexto: "#0B1829",
                    texto: C.ink, textoSuave: C.inkSoft}}/>
              <NotaBateriaAndroid fontSans={fontSans} c={{fondo: C.panel, borde: C.line, texto: C.ink, textoSuave: C.inkSoft}}/>
              {estadoAvisosMv === "activos" && <EstadoSwAvisosLinea fontSans={fontSans} c={{textoSuave: C.inkSoft}}/>}
            </div>
            {/* ACTUALIZACIONES: todas las que le aplican, con fecha. */}
            <div style={{fontSize:11, color:C.inkMut, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"1px", margin:"0 2px 8px"}}>Actualizaciones</div>
            <div style={{marginBottom:18}}>
              <ListaNovedades rol="patron" tieneFlotilla={(vehiculos || []).length > 0} fontSans={fontSans}
                c={{fondo: C.panel, borde: C.line, texto: C.ink, textoSuave: C.inkSoft, acento: C.gold}}/>
            </div>

            {/* AXIOR — tarjeta con vida */}
            <button onClick={abrirAxior}
              style={{display:"flex", alignItems:"center", gap:13, width:"100%", textAlign:"left" as const, fontFamily:fontSans, marginBottom:18,
                background:`linear-gradient(135deg, rgba(${A.rgbDim},0.16), rgba(15,33,56,0.4))`, border:`1px solid ${C.line}`, borderRadius:16, padding:"15px 15px", boxShadow:C.sombra, cursor:"pointer"}}>
              <AxiorSVG size={52} expr="atento" view="body"/>
              <div style={{flex:1, minWidth:0}}>
                <div style={{fontFamily:fontSerif, fontSize:16, fontWeight:700, color:C.gold, lineHeight:1.1}}>Pregúntale a AXIOR</div>
                <div style={{fontSize:12, color:C.inkSoft, marginTop:3, lineHeight:1.4}}>Tu asistente legal. Pregúntame lo que necesites.</div>
              </div>
              <span style={{fontSize:19, color:C.inkMut, lineHeight:1}}>›</span>
            </button>

            {/* Ayuda y legal */}
            <div style={{fontSize:11, color:C.inkMut, fontWeight:700, textTransform:"uppercase" as const, letterSpacing:"1px", margin:"0 2px 8px"}}>Ayuda y legal</div>
            {filaAtender(
              (<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M5 5.5A1.5 1.5 0 016.5 4h11A1.5 1.5 0 0119 5.5v8a1.5 1.5 0 01-1.5 1.5H9l-4 3.5v-3.5A1.5 1.5 0 015 13.5z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round"/></svg>),
              "Contactar a AXIS",
              "¿Necesitas apoyo? Escríbenos por WhatsApp.",
              abrirWhatsAppAXIS
            )}
            {filaAtender(
              (<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M12 3l7 3v5c0 4.4-3 8-7 10-4-2-7-5.6-7-10V6z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round"/><path d="M9.2 12.2l1.9 1.9 3.7-3.9" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/></svg>),
              "Aviso de Privacidad",
              "Cómo tratamos tus datos (LFPDPPP)",
              ()=>setLegalModal("privacidad")
            )}
            {filaAtender(
              (<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M6 3h8l4 4v14a1 1 0 01-1 1H6a1 1 0 01-1-1V4a1 1 0 011-1z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round"/><path d="M13 3v5h5M8.5 13h7M8.5 16.5h5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/></svg>),
              "Aviso legal y términos",
              "Términos de uso y descargo de responsabilidad",
              ()=>setLegalModal("disclaimer")
            )}
            {/* Espacio preparado para el tour guiado (aún no construido) */}
            {filaAtender(
              (<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.6"/><path d="M10 9l5 3-5 3z" fill="currentColor"/></svg>),
              "Ver tour guiado",
              "Próximamente"
            )}

            {/* LAS SEDES DE LA EMPRESA (11-oct-2026): en el teléfono se ven, no se editan. */}
            <SedesSoloLectura uidPatron={currentUser?.uid || ""} C={C} fontSans={fontSans}/>

            <button onClick={onLogout} style={{width:"100%", marginTop:8, background:"rgba(255,255,255,0.05)", border:`1px solid ${C.line}`, color:C.ink, borderRadius:12, padding:"13px 16px", cursor:"pointer", fontSize:14, fontWeight:700, fontFamily:fontSans}}>Cerrar sesión</button>
          </div>
        )}
        </>)}
      </div>

      {/* Modal legal reutilizado (Aviso de Privacidad / Aviso legal) */}
      {legalModal && <ModalLegal tipo={legalModal} onClose={()=>setLegalModal(null)} />}

      {/* Ventana de configuración: Horario y ubicación de trabajo (general) */}
      {verHorarioConfig && (
        <div style={{position:"fixed" as const, inset:0, zIndex:2000, background:"rgba(3,10,22,0.72)", display:"flex", alignItems:"flex-end", justifyContent:"center"}}>
          <div {...PANEL_DE_CAPTURA} onClick={e=>e.stopPropagation()} style={{width:"100%", maxWidth:560, maxHeight:"88vh", overflowY:"auto" as const, background:C.bg, borderTop:`1px solid ${C.line}`, borderRadius:"18px 18px 0 0", padding:"14px 14px 24px", boxShadow:"0 -8px 40px rgba(0,0,0,0.5)"}}>
            <div style={{display:"flex", justifyContent:"flex-end", marginBottom:4}}>
              <button onClick={(ev)=>{ if (sePuedeCerrarElPanel(ev)) setVerHorarioConfig(false); }} aria-label="Cerrar" style={{width:32, height:32, borderRadius:"50%", border:`1px solid ${C.line}`, background:"transparent", color:C.ink, cursor:"pointer", fontSize:17, lineHeight:1, fontFamily:fontSans}}>×</button>
            </div>
            <HorarioLaboralEditor modo="general" currentUser={currentUser} tema="navy" fontSans={fontSans} fontSerif={fontSerif} />
            <InterruptorRecordatorioEntrada uid={currentUser?.uid || ""} tema="navy" fontSans={fontSans}/>
          </div>
        </div>
      )}

      {/* LAS ACTUALIZACIONES: solo en Inicio, y sin ninguna ventana ni formulario
          encima (accidente, calculadora, aviso, flotilla, calendario, asuetos,
          actividad nueva o editada, horario). Por encima de la barra inferior. */}
      <AvisoNovedades rol="patron" tieneFlotilla={(vehiculos || []).length > 0} altaMs={altaDeLaCuentaMs(currentUser)}
        vistas={novedadesMv.vistas} onMarcar={novedadesMv.marcarVistas}
        visible={tab === "inicio" && !accidenteSel && !verCalculadora && !verAviso && !verFlotilla && !verCalendario && !verAsuetos && !tareaForm && !verHorarioConfig}
        posicion="movil" abajo="calc(78px + env(safe-area-inset-bottom, 0px))" fontSans={fontSans}/>

      {/* Barra inferior nativa */}
      {/* Ver nota del inset inferior en la barra del portal del trabajador. */}
      <div style={{position:"fixed" as const, left:0, right:0, bottom:0, zIndex:30, background:"#06182F", borderTop:`1px solid ${C.line}`, boxShadow:"0 -2px 16px rgba(0,0,0,0.35)", paddingBottom:"env(safe-area-inset-bottom, 0px)"}}>
        <div style={{maxWidth:560, margin:"0 auto", width:"100%", display:"flex", boxSizing:"border-box" as const}}>
          {barras.map(b => {
            const activo = tab===b.k;
            return (
              <button key={b.k} onClick={()=>irATab(b.k)}
                style={{flex:1, display:"flex", flexDirection:"column" as const, alignItems:"center", gap:3, background:"transparent", border:"none", cursor:"pointer", padding:"8px 2px 10px", position:"relative" as const, fontFamily:fontSans}}>
                {activo && <span style={{position:"absolute" as const, top:0, width:24, height:3, borderRadius:"0 0 3px 3px", background:C.gold}}/>}
                {/* ⚠️ AQUÍ HUBO UN PUNTO ROJO, Y SE QUITÓ POR LO QUE PROMETÍA.
                    Colgaba de `gravesRecientes`, que es "hay un accidente grave en
                    los últimos 7 días". Eso es un HECHO QUE PERSISTE, no un evento
                    que se ve y se apaga: el patrón entraba en Actividad, leía el
                    accidente, y el punto seguía encendido siete días. Un globo en
                    una pestaña promete "hay algo NUEVO aquí dentro"; si entras y
                    sigue ahí, la plataforma mintió, y a la semana se deja de mirar.

                    Es el mismo defecto que ya corregimos en el escritorio cuando la
                    campana dejó fuera las actividades por confirmar: contaban
                    siempre, porque esperan un clic, y el contador no llegaba a cero
                    nunca. Ver `ActividadBell`, donde está escrito.

                    LO QUE EL PATRÓN NECESITA SABER NO SE PIERDE: el accidente grave
                    sigue en "Qué atender hoy" —que es persistente A PROPÓSITO y no
                    promete apagarse—, el hecho nuevo llega por push en cuanto se
                    registra, y aparece en el registro de actividad.

                    LA REGLA, para que no vuelva: un punto sobre una pestaña solo
                    puede colgar de una marca de "visto" —como `useMarcaVistas`—.
                    Si lo que lo enciende es un hecho que dura, no es un punto: es
                    una fila en una lista de pendientes. */}
                <span style={{color:activo?C.gold:`rgba(${A.rgbBright},0.45)`, display:"inline-flex"}}>{b.ico}</span>
                <span style={{fontSize:10, fontWeight:activo?700:600, color:activo?C.gold:`rgba(${A.rgbBright},0.5)`}}>{b.label}</span>
              </button>
            );
          })}
        </div>
      </div>

      {/* Detalle de un movimiento de flotilla: MISMO componente que el escritorio.
          El unico ajuste por pantalla lo hace el propio componente con isMobile. */}
      {movFlotaSel && (
        <DetalleMovimientoFlotilla
          registro={movFlotaSel.r} vehiculo={movFlotaSel.veh} fecha={movFlotaSel.fecha}
          onClose={()=>setMovFlotaSel(null)}
          isMobile={true} fontSans={fontSans} fontSerif={fontSerif}/>
      )}
    </div>
  );
}

// ── Acceso rápido biométrico (login) — reutiliza WebAuthn del checador ────────
// Candado LOCAL sobre la sesión de Firebase ya guardada (persistencia). NO es
// verificación en servidor. El login normal (contraseña/Google) siempre disponible.
const _accesoRapidoClave = (uid:string)=> `axis_acceso_rapido:${uid||""}`;
// Marca de "esta PESTAÑA ya se desbloqueó". Va en sessionStorage a propósito:
// sobrevive a una recarga y muere al cerrar la pestaña, que es justo la línea
// entre "refresqué" y "abrí la app de nuevo". No lleva marca de tiempo porque no
// queremos una ventana en la que el candado esté apagado.
const _bioSesionClave = (uid:string)=> `axis_bio_sesion:${uid||""}`;

function BioLockScreen({user, onUnlock, onOtraCuenta, fontSans, fontSerif}:{user:any; onUnlock:()=>void; onOtraCuenta:()=>void; fontSans:string; fontSerif:string}) {
  const [cargando,setCargando]=useState(false); const [msg,setMsg]=useState("");
  const NV = {bg:"#05152E", ink:"#ECE6D8", inkSoft:"rgba(236,230,216,0.66)", inkMut:"rgba(236,230,216,0.42)", gold:"#D4A843", line:"rgba(184,147,42,0.30)", iconBg:"rgba(184,147,42,0.10)", iconBd:"rgba(184,147,42,0.32)"};
  const desbloquear = async ()=>{ setMsg(""); setCargando(true); try { const ok = await bioVerificar(user); if (ok) onUnlock(); else setMsg("No se pudo confirmar. Intenta de nuevo o entra con tu cuenta."); } catch(e){ setMsg("Cancelado. Intenta de nuevo o entra con tu cuenta."); } finally { setCargando(false); } };
  return (
    <div style={{minHeight:"100vh", background:NV.bg, fontFamily:fontSans, display:"flex", flexDirection:"column" as const, alignItems:"center", justifyContent:"center", padding:"24px 20px", boxSizing:"border-box" as const, textAlign:"center" as const}}>
      <img src="/logo.png?v=4" alt="AXIS Legaltech" style={{width:150, maxWidth:"60%", height:"auto", marginBottom:8}}/>
      <div style={{width:76, height:76, borderRadius:"50%", display:"flex", alignItems:"center", justifyContent:"center", background:NV.iconBg, border:`1px solid ${NV.iconBd}`, color:NV.gold, margin:"6px 0 14px"}}>
        <svg width="38" height="38" viewBox="0 0 24 24" fill="none"><path d="M12 11c-1 0-2 .8-2 3v3M8.5 9.5a4 4 0 017 0M6 8.5a7 7 0 0112 0M9 13v3.5a3 3 0 006 0V13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
      </div>
      <h1 style={{fontFamily:fontSerif, fontSize:24, fontWeight:700, color:NV.ink, margin:"0 0 4px"}}>Desbloquea AXIS</h1>
      <p style={{fontSize:13, color:NV.inkSoft, margin:"0 0 20px", maxWidth:320, lineHeight:1.5}}>Confirma tu identidad con la biometría de este dispositivo para entrar.{user?.email ? <><br/><span style={{color:NV.inkMut, fontSize:12}}>{user.email}</span></> : null}</p>
      <button onClick={desbloquear} disabled={cargando}
        style={{width:"100%", maxWidth:320, padding:"14px 16px", borderRadius:12, border:"none", background:`linear-gradient(135deg,${NV.gold},#B8932A)`, color:"#0B1829", cursor:cargando?"wait":"pointer", fontFamily:fontSans, fontSize:14, fontWeight:800}}>
        {cargando ? "Verificando…" : "Desbloquear con biometría"}
      </button>
      {msg && <div style={{fontSize:12.5, color:"#FCA5A5", marginTop:12, maxWidth:320}}>{msg}</div>}
      <button onClick={onOtraCuenta} style={{marginTop:18, background:"transparent", border:"none", color:NV.gold, cursor:"pointer", fontFamily:fontSans, fontSize:13, fontWeight:700, textDecoration:"underline"}}>Entrar con otra cuenta o contraseña</button>
    </div>
  );
}

function OfertaBioScreen({user, onActivar, onOmitir, fontSans, fontSerif}:{user:any; onActivar:()=>void; onOmitir:()=>void; fontSans:string; fontSerif:string}) {
  const [cargando,setCargando]=useState(false); const [msg,setMsg]=useState("");
  const NV = {bg:"#05152E", ink:"#ECE6D8", inkSoft:"rgba(236,230,216,0.66)", inkMut:"rgba(236,230,216,0.42)", gold:"#D4A843", line:"rgba(184,147,42,0.30)", iconBg:"rgba(184,147,42,0.10)", iconBd:"rgba(184,147,42,0.32)"};
  const activar = async ()=>{ setCargando(true); setMsg("");
    try { const nid = await bioEnrolar(user);
      try { localStorage.setItem(_accesoRapidoClave(user?.uid), "1"); } catch {}
      try { await setDoc(doc(db,"credenciales_biometricas",user.uid), { credentialId:nid, email:(user?.email||"").toLowerCase(), creadoEn: serverTimestamp() }, {merge:true}); } catch(eF){ /* best-effort */ }
      onActivar();
    } catch(e){ setMsg("No se activó (cancelado o no disponible). Puedes activarlo luego."); setCargando(false); }
  };
  return (
    <div style={{minHeight:"100vh", background:NV.bg, fontFamily:fontSans, display:"flex", flexDirection:"column" as const, alignItems:"center", justifyContent:"center", padding:"24px 20px", boxSizing:"border-box" as const, textAlign:"center" as const}}>
      <div style={{width:76, height:76, borderRadius:"50%", display:"flex", alignItems:"center", justifyContent:"center", background:NV.iconBg, border:`1px solid ${NV.iconBd}`, color:NV.gold, marginBottom:14}}>
        <svg width="38" height="38" viewBox="0 0 24 24" fill="none"><path d="M12 11c-1 0-2 .8-2 3v3M8.5 9.5a4 4 0 017 0M6 8.5a7 7 0 0112 0M9 13v3.5a3 3 0 006 0V13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
      </div>
      <h1 style={{fontFamily:fontSerif, fontSize:23, fontWeight:700, color:NV.ink, margin:"0 0 6px", maxWidth:340, lineHeight:1.15}}>¿Entrar más rápido la próxima vez?</h1>
      <p style={{fontSize:13, color:NV.inkSoft, margin:"0 0 22px", maxWidth:340, lineHeight:1.55}}>Activa tu <strong style={{color:NV.gold}}>huella o Face ID</strong> como candado de este dispositivo. Es el candado recomendado si mantienes tu sesión activa: solo tú podrás abrir la app. Tu biometría nunca sale del teléfono.</p>
      <button onClick={activar} disabled={cargando}
        style={{width:"100%", maxWidth:340, padding:"14px 16px", borderRadius:12, border:"none", background:`linear-gradient(135deg,${NV.gold},#B8932A)`, color:"#0B1829", cursor:cargando?"wait":"pointer", fontFamily:fontSans, fontSize:14, fontWeight:800}}>
        {cargando ? "Activando…" : "Activar huella / Face ID"}
      </button>
      {msg && <div style={{fontSize:12.5, color:"#FCA5A5", marginTop:12, maxWidth:340}}>{msg}</div>}
      <button onClick={onOmitir} style={{marginTop:16, background:"transparent", border:"none", color:NV.inkSoft, cursor:"pointer", fontFamily:fontSans, fontSize:13, fontWeight:700}}>Ahora no</button>
    </div>
  );
}

function App({ onAxiorOcultoChange, onAxiorLanzadorChange }: { onAxiorOcultoChange?: (v: boolean) => void; onAxiorLanzadorChange?: (v: boolean) => void } = {}) {


  const [sectorActivo, setSectorActivo] = useState<string|null>(null);
  const [pasoWizard, setPasoWizard] = useState<1|2|3>(1); // 1=industria 2=especialidad 3=checklist
  const [filtrosAvanzados, setFiltrosAvanzados] = useState(false);
  const [especialidad, setEspecialidad] = useState("Todas");
  const [nivelFiltro,  setNivelFiltro]  = useState("todos");
  const [estados, setEstados] = useState<Record<string,EstadoType>>(() => {
    try {
      const saved = localStorage.getItem("regulamx_estados");
      return saved ? JSON.parse(saved) : {};
    } catch { return {}; }
  });
  const [seleccionado, setSeleccionado] = useState<string|null>(null);
  const [busqueda, setBusqueda]         = useState("");
  const [soloPendientes, setSoloPendientes] = useState(false);
  const [vistaCompacta, setVistaCompacta]     = useState(false);

  // ── Persistir progreso en localStorage ──
  useEffect(() => {
    try { localStorage.setItem("regulamx_estados", JSON.stringify(estados)); }
    catch {}
  }, [estados]);

  // Contador animado
  // ── Estado global de la app ──
  // (Retirados) Los enlaces públicos "?conductor=<uid>" y "?calendario=<uid>" se
  // eliminaron: un registro anónimo no es atribuible a una persona y le resta valor
  // probatorio a la bitácora. Todo acceso exige cuenta. Cualquier URL con esos
  // parámetros simplemente cae en la bienvenida (login).
  const [appPantalla, setAppPantalla] = useState<AppPantalla>("bienvenida");
  // Por qué puerta de la bienvenida se llegó al acceso. La de trabajador solo
  // inicia sesión; cualquier otro camino al acceso es el de empresa.
  const [puertaLogin, setPuertaLogin] = useState<"empresa"|"trabajador">("empresa");
  // Al salir del acceso por donde sea, la puerta vuelve a ser la de empresa: así
  // los demás caminos al login (landing, suite, menú) no heredan la de trabajador.
  useEffect(() => { if (appPantalla !== "login") setPuertaLogin("empresa"); }, [appPantalla]);
  // EL CANDADO DE LOS DOCUMENTOS LLEVA AQUÍ. Los seis constructores viven en
  // cuatro componentes distintos que no comparten árbol con la navegación, así
  // que en vez de cablear una prop por los cuatro se dispara un evento —el mismo
  // idioma que ya usan "avisos:abrir" y "axior:abrir"—.
  //
  // Y limpia como cualquier otro salto: es el OCTAVO punto de navegación y se me
  // había quedado fuera de la lista —lo cazó `prueba-navegacion` al contar los
  // `setNavToken`—. Hoy no da la cara porque "Datos de mi empresa" no consume
  // ningún foco, pero un salto que no limpia es exactamente la forma del defecto
  // que se está cerrando aquí.
  useEffect(() => {
    const ir = (e: any) => {
      const m = (e && e.detail && e.detail.modulo) as AppPantalla;
      if (!m) return;
      _limpiarFocos(); setAppPantalla(m); setNavToken(n => n + 1);
    };
    window.addEventListener(EVT_IR_A_MODULO, ir as any);
    return () => window.removeEventListener(EVT_IR_A_MODULO, ir as any);
  }, []);   // eslint-disable-line
  // AppPantalla incluye "admin"
  const [currentUser, setCurrentUser] = useState<any>(null);
  // Acceso rápido biométrico: candado sobre la sesión restaurada + oferta tras login.
  const [bioBloqueado, setBioBloqueado] = useState(false);
  const [mostrarOfertaBio, setMostrarOfertaBio] = useState(false);
  const bioFrescoRef = useRef(false);      // true si el login fue de ESTA sesión (no bloquear)
  const bioDecididoRef = useRef(false);    // ya se decidió lock/no-lock para el usuario actual
  // Gate de consentimiento: null = leyendo, true = falta aceptar, false = ok/no aplica.
  const [consentNeeded, setConsentNeeded] = useState<boolean|null>(null);
  // Detección de rol: null = leyendo, true = es TRABAJADOR (vista limitada),
  // false = patrón/usuario normal. Se resuelve leyendo cuentas_trabajador/{correo}.
  const [esTrabajador, setEsTrabajador] = useState<boolean|null>(null);
  const [cuentaTrabajador, setCuentaTrabajador] = useState<any|null>(null);
  // Cuenta de trabajador EXISTENTE pero suspendida (activo:false) → acceso bloqueado.
  const [cuentaSuspendida, setCuentaSuspendida] = useState<any|null>(null);
  // Correo del trabajador a enfocar al abrir la sección Actividades desde Empleados.
  const [tareasFoco, setTareasFoco] = useState<string>("");
  // Al tocar el aviso "no ha checado": a Inicio (13-oct-2026). En el teléfono lo
  // atiende el portal móvil, que se monta antes.
  useAbrirDesdeAviso("inicio", !!currentUser && !currentUser.isAnonymous && esTrabajador === false, () => setAppPantalla("suite"));
  // La ACTIVIDAD concreta a la que se llegó desde el feed, por su id. Aparte de
  // `tareasFoco`, que es un correo y significa "voy a asignarle algo": esa vía
  // abre el formulario de alta y no sirve para llegar a una actividad que ya
  // existe.
  const [tareaFocoId, setTareaFocoId] = useState<string|null>(null);
  // Trabajador con el que abrir Nómina cuando el salto viene de su ficha.
  const [trabajadorNomina, setTrabajadorNomina] = useState<any>(null);
  // Filtro con el que Inicio abre Flotilla. Mismo patrón que `trabajadorNomina`.
  const [flotillaFiltro, setFlotillaFiltro] = useState<"vencida"|"por_vencer"|"sin_registro"|"en_regla"|null>(null);
  // Destino CONCRETO de un aviso. Mismo patrón que `trabajadorNomina`: estado
  // aquí, prop de valor inicial en el módulo, y limpieza al navegar por el
  // sidebar para que no se arrastre.
  const [flotillaVehiculoId, setFlotillaVehiculoId] = useState<string|null>(null);
  // Y en qué pestaña de su expediente: un aviso de documento lleva a Documentos.
  const [flotillaVehiculoTab, setFlotillaVehiculoTab] = useState<"datos"|"documentos"|"historial"|"mantenimientos"|null>(null);
  // EL HECHO CONCRETO DENTRO DE FLOTILLA, por su id: un viaje, un movimiento o
  // un accidente. Se direcciona por id y nunca por la lista transportada: si ya
  // no existe cuando Flotilla lee su colección, no se señala nada y no pasa más.
  const [flotillaFoco, setFlotillaFoco] = useState<{foco:"viaje"|"movimiento"|"accidente"; id:string}|null>(null);
  const [empleadoFocoId, setEmpleadoFocoId] = useState<string|null>(null);
  // Y en qué apartado de su ficha: la asistencia de una checada, los documentos
  // de un documento, los contratos de un contrato.
  const [empleadoFocoTab, setEmpleadoFocoTab] = useState<"datos"|"checador"|"documentos"|"contratos"|null>(null);
  const [empleadoFocoEmails, setEmpleadoFocoEmails] = useState<string[]>([]);
  const [creditoFoco, setCreditoFoco] = useState<{deudorId:string; creditoId:string|null}|null>(null);
  // Cambia en cada navegación del shell; sirve de `key` para remontar el módulo
  // destino. Va AQUÍ arriba y no junto a `conShell`: abajo quedaría después de
  // los `return` tempranos (bienvenida/landing/login) y el hook no correría en
  // esos renders — React #310, pantalla en negro.
  const [navToken, setNavToken] = useState(0);

  // Uso del producto por cuenta/mes (rollup con increment; no crea documentos).
  useEffect(() => {
    const noLog = ["login","landing","suite","admin"];
    if (currentUser && appPantalla && !noLog.includes(appPantalla)) { registrarUsoMensual(currentUser); }
  }, [appPantalla]);   // eslint-disable-line

  // ACCESO. Una sola comprobación —evaluarAcceso— para la puerta y para el menú.
  // `null` mientras no se ha resuelto: ni entra ni no entra todavía, y esa
  // diferencia importa para no parpadear una pantalla de "sin acceso" a alguien
  // que sí lo tiene.
  const [acceso, setAcceso] = useState<FaseAcceso>(ACCESO_EVALUANDO);
  // Los doce módulos del sidebar se apagan con esto mismo: una sola comprobación
  // para la puerta y para el menú. Mientras se evalúa NO es `true` —no se abre lo
  // que no se sabe— pero tampoco se pinta el rechazo: de eso se encarga el
  // render, que muestra carga hasta que hay respuesta.
  const isProUser = acceso.fase === "resuelto" && acceso.resultado.entra;

  // SESIÓN ANÓNIMA HEREDADA. Todo el que abrió la app antes del cierre tiene una
  // guardada en su navegador, y al volver la trae consigo. No es alguien a quien
  // rechazar —no hay nadie— así que enseñarle la pantalla de "tu cuenta no tiene
  // acceso" sería acusar a un visitante de algo que no hizo, encima sin correo que
  // mostrar. Se cierra la sesión y se le trata como a cualquier visitante nuevo.
  useEffect(() => {
    if (!currentUser?.isAnonymous) return;
    signOut(auth).catch((e)=>console.warn("cerrar sesion anonima heredada:", e));
  }, [currentUser?.isAnonymous]);

  // Cada evaluación lleva número. Si se encadenan dos cambios de sesión —cerrar y
  // entrar con otra cuenta— la primera puede resolverse DESPUÉS de la segunda y
  // dejar vigente el veredicto de la cuenta anterior. Solo contesta la última.
  const evaluacionRef = useRef(0);
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (u) => {
      // VUELVE A "EVALUANDO" ANTES DE NADA. Sin esto, al cambiar de cuenta el
      // resultado ANTERIOR seguiría vigente durante la evaluación de la nueva.
      const miTurno = ++evaluacionRef.current;
      setAcceso(ACCESO_EVALUANDO);
      setCurrentUser(u);
      try {
        const r = await evaluarAcceso(u);
        if (miTurno === evaluacionRef.current) setAcceso({fase:"resuelto", resultado:r});
      } catch(e){
        console.error("evaluarAcceso:", e);
        if (miTurno === evaluacionRef.current) setAcceso({fase:"resuelto", resultado:ACCESO_DENEGADO});
      }
    });
    return unsub;
  }, []);

  // Decide el candado biométrico UNA vez por usuario. Bloquea solo si: la sesión se
  // RESTAURÓ (no fue login fresco de esta sesión), el usuario activó acceso rápido y el
  // dispositivo soporta biometría. Defensivo: cualquier duda → no bloquea.
  useEffect(() => {
    if (!currentUser || currentUser.isAnonymous) {
      bioDecididoRef.current = false; bioFrescoRef.current = false;
      setBioBloqueado(false); setMostrarOfertaBio(false);
      return;
    }
    if (bioDecididoRef.current) return;
    bioDecididoRef.current = true;
    if (bioFrescoRef.current) return;   // login fresco → no bloquear
    // Una RECARGA no es una apertura nueva. `sessionStorage` vive mientras la
    // pestaña siga abierta y muere al cerrarla, así que sirve exactamente para
    // esa distinción, y sin ventana de tiempo: no queda ningún lapso con el
    // candado apagado. Abrir en pestaña nueva, o volver tras cerrar la app, sí
    // vuelve a pedir biometría, que es lo que el candado protege.
    // FALLA DEL LADO SEGURO: si sessionStorage no está disponible o se limpió,
    // `yaDesbloqueada` queda en false y se PIDE biometría.
    let yaDesbloqueada = false;
    try { yaDesbloqueada = sessionStorage.getItem(_bioSesionClave(currentUser.uid)) === "1"; } catch(e) { yaDesbloqueada = false; }
    if (yaDesbloqueada) return;
    let cancel = false;
    (async () => {
      let enrolado = false; try { enrolado = localStorage.getItem(`axis_acceso_rapido:${currentUser.uid}`)==="1"; } catch {}
      if (!enrolado) return;
      const sop = await bioDisponible();
      if (!cancel && sop) setBioBloqueado(true);
    })();
    return () => { cancel = true; };
  }, [currentUser]);

  // Tras un login FRESCO (contraseña/Google): entra directo y ofrece acceso rápido.
  const handleLoginSuccess = (u:any) => {
    bioFrescoRef.current = true; bioDecididoRef.current = true;
    // El login fresco también inaugura la pestaña como desbloqueada: si no,
    // recargar justo después de entrar con contraseña pediría biometría.
    try { sessionStorage.setItem(_bioSesionClave(u?.uid), "1"); } catch(e) {}
    setCurrentUser(u); setAppPantalla("suite");
    (async () => {
      try {
        let enrolado = false, omitido = false;
        try { enrolado = localStorage.getItem(`axis_acceso_rapido:${u?.uid}`)==="1"; } catch {}
        try { omitido = localStorage.getItem(`axis_acceso_rapido_omitido:${u?.uid}`)==="1"; } catch {}
        if (enrolado || omitido) return;
        const sop = await bioDisponible();
        if (sop) setMostrarOfertaBio(true);
      } catch {}
    })();
  };

  // Lee consentimientos/{uid} del usuario REAL para decidir si mostrar el gate.
  // fail-open: si la lectura falla (p. ej. reglas aún sin publicar) NO bloqueamos
  // (evita dejar fuera a todos antes de que se publiquen las reglas).
  useEffect(() => {
    let cancel = false;
    (async () => {
      if (!currentUser || currentUser.isAnonymous) { setConsentNeeded(false); return; }
      setConsentNeeded(null);
      try {
        const snap = await getDoc(doc(db, "consentimientos", currentUser.uid));
        const d: any = snap.exists() ? snap.data() : null;
        const ok = !!d && d.versionAviso === VERSION_AVISO && d.versionTerminos === VERSION_TERMINOS;
        if (!cancel) setConsentNeeded(!ok);
      } catch(e) {
        console.warn("Gate consentimiento: no se pudo leer (¿reglas sin publicar?). Se omite el gate.", e);
        if (!cancel) setConsentNeeded(false);
      }
    })();
    return () => { cancel = true; };
  }, [currentUser]);

  // ── Detección de rol (patrón vs trabajador) ──────────────────────────────
  // Lee cuentas_trabajador/{miCorreoEnMinúsculas}. Si existe y NO dice
  // `activo: false`, es TRABAJADOR (solo ve su vista limitada); con
  // `activo: false`, cuenta SUSPENDIDA. EL MISMO CRITERIO que la puerta
  // (acceso.js) y las reglas: una cuenta sin el campo está activa. Antes se pedía
  // `activo === true`, y una cuenta sin el campo quedaba suspendida aquí y activa
  // en todas partes. Si no existe, no es trabajador.
  //
  // SI LA LECTURA FALLA O TARDA MÁS DE 10 s, NO SE ADIVINA: se queda sin rol y se
  // enseña un error con "Reintentar". Antes se asumía patrón —una lectura fallida
  // dejaba entrar a un trabajador como patrón— y el "Cargando…" no tenía salida.
  const [rolError, setRolError] = useState(false);
  const [rolIntento, setRolIntento] = useState(0);
  useEffect(() => {
    let cancel = false;
    (async () => {
      if (!currentUser || currentUser.isAnonymous || !currentUser.email) {
        setEsTrabajador(false); setCuentaTrabajador(null); setCuentaSuspendida(null); setRolError(false); return;
      }
      setEsTrabajador(null); setRolError(false);
      const correo = currentUser.email.toLowerCase().trim();
      try {
        const snap: any = await conLimiteDeTiempo(getDoc(doc(db, "cuentas_trabajador", correo)), MS_DETECCION_DE_ROL);
        if (cancel) return;
        if (snap.exists() && cuentaActiva(snap.data())) {
          setCuentaTrabajador({ id: snap.id, ...snap.data() });
          setCuentaSuspendida(null);
          setEsTrabajador(true);
        } else if (snap.exists()) {
          // CANDADO: la cuenta EXISTE pero está suspendida (baja del trabajador). No se
          // le deja entrar al portal y —crítico— tampoco puede caer en la rama de patrón:
          // se marca como suspendida y la app muestra la pantalla de bloqueo.
          setCuentaTrabajador(null); setEsTrabajador(false);
          setCuentaSuspendida({ id: snap.id, ...snap.data() });
        } else {
          setCuentaTrabajador(null); setCuentaSuspendida(null); setEsTrabajador(false);
        }
      } catch(e) {
        console.warn("Detección de rol: no se pudo leer la cuenta.", e);
        if (!cancel) { setCuentaTrabajador(null); setCuentaSuspendida(null); setEsTrabajador(null); setRolError(true); }
      }
    })();
    return () => { cancel = true; };
  }, [currentUser, rolIntento]);
  const reintentarRol = () => setRolIntento((n) => n + 1);

  // Un PATRÓN logueado real (no anónimo, no trabajador) NUNCA debe quedar en la
  // pantalla de bienvenida: lo mandamos directo a su suite. (Los trabajadores ya
  // los intercepta el guard de rol; los no-logueados/anónimos sí ven la bienvenida.)
  useEffect(() => {
    if (currentUser && !currentUser.isAnonymous && esTrabajador === false && appPantalla === "bienvenida") {
      setAppPantalla("suite");
    }
  }, [currentUser, esTrabajador, appPantalla]);

  // Render-gate de AXIOR (fuente de verdad ÚNICA): NO montar el búho donde no
  // aporta — la BIENVENIDA (condición exacta que renderiza <BienvenidaScreen/>),
  // el FORMULARIO DE LOGIN (appPantalla === "login") y el PORTAL DEL TRABAJADOR
  // (misma condición exacta que renderiza <VistaTrabajador/>: usuario real con
  // esTrabajador===true). El landing freemium y la suite del patrón quedan FUERA
  // del gate: ahí AXIOR sí aparece. Cubre de un golpe búho de escritorio, FAB
  // móvil y panel — sin depender del evento axior:ocultar (que tenía race).
  const mostrandoBienvenida = appPantalla === "bienvenida" && (!currentUser || currentUser.isAnonymous);
  const mostrandoPortalTrabajador = !!currentUser && !currentUser.isAnonymous && esTrabajador === true;
  // AXIOR SOLO DESPUÉS DE LA PUERTA. Hasta esta rama se ocultaba en tres sitios
  // concretos y se pintaba en todos los demás, incluidos los que van ANTES de
  // entrar: "sin acceso", la carga de la puerta, el candado biométrico, el aviso
  // de privacidad y la cuenta suspendida. Ahora es al revés: solo se pinta si la
  // puerta ya dijo que sí Y la persona ya está dentro de la aplicación. Tampoco lo
  // ve un visitante sin sesión (landing, diagnóstico público): el servidor ya no
  // contesta sin sesión válida y con acceso.
  const puertaDijoQueSi = !!currentUser && !currentUser.isAnonymous
    && acceso.fase === "resuelto" && acceso.resultado.entra === true;
  const antesDeLaApp = !!currentUser && (bioBloqueado || mostrarOfertaBio || consentNeeded !== false
    || esTrabajador === null || !!cuentaSuspendida);
  const ocultarAxior = !puertaDijoQueSi || antesDeLaApp
    || mostrandoBienvenida || appPantalla === "login" || mostrandoPortalTrabajador;
  useEffect(() => {
    onAxiorOcultoChange?.(ocultarAxior);
  }, [ocultarAxior, onAxiorOcultoChange]);


  // ── Primera visita ──
  // SE RECUERDA POR CUENTA, NO POR NAVEGADOR. Estaba solo en localStorage, y eso
  // no dice "ya lo vio": dice "ya lo vio en ESTE navegador y en ESTE dominio".
  // Quien entra desde otra computadora, desde el teléfono o desde un despliegue
  // de prueba se comía la bienvenida otra vez, y cada vez.
  //
  // `null` es "todavía no sé". Mientras no se sepa no se enseña nada: sacar el
  // modal y quitarlo medio segundo después es peor que esperar a saberlo.
  const _uidBienvenida = (currentUser && !currentUser.isAnonymous) ? currentUser.uid : "";
  const [primeraVez, setPrimeraVez] = useState<boolean|null>(() => {
    if (currentUser && !currentUser.isAnonymous) return null;   // lo contesta la cuenta
    try { return !localStorage.getItem("regulamx_visitado"); }
    catch { return false; }
  });
  useEffect(() => {
    // Sin cuenta no hay dónde recordarlo más que en el navegador. Un visitante
    // sigue exactamente como estaba.
    if (!_uidBienvenida) {
      try { setPrimeraVez(!localStorage.getItem("regulamx_visitado")); } catch { setPrimeraVez(false); }
      return;
    }
    let vivo = true;
    (async () => {
      try {
        const snap = await getDoc(doc(db, "usuarios", _uidBienvenida));
        if (!vivo) return;
        setPrimeraVez(!(snap.exists() && !!(snap.data() as any)?.diagnosticoBienvenidaVista));
      } catch(e) {
        // Sin red o sin permiso no se sabe, y ante la duda no se interrumpe.
        if (vivo) setPrimeraVez(false);
      }
    })();
    return () => { vivo = false; };
  }, [_uidBienvenida]);
  const cerrarOnboarding = () => {
    setPrimeraVez(false);
    try { localStorage.setItem("regulamx_visitado", "1"); } catch {}
    // La cuenta es la que manda; el navegador se queda como respaldo por si la
    // escritura no llega.
    if (_uidBienvenida) {
      updateDoc(doc(db, "usuarios", _uidBienvenida), { diagnosticoBienvenidaVista: true }).catch(()=>{});
    }
  };

  // ── Responsive ──
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Portal del patrón móvil: AXIOR SÍ se monta (el botón del header abre el chat),
  // pero su lanzador FLOTANTE se apaga vía prop (render-gate del lanzador). Misma
  // condición EXACTA con la que se renderiza <PortalPatronMovil/>. Se declara DESPUÉS
  // de isMobile para no caer en la zona muerta temporal (TDZ).
  const mostrandoPortalPatronMovil = !!currentUser && !currentUser.isAnonymous && esTrabajador === false && isMobile;
  useEffect(() => {
    onAxiorLanzadorChange?.(mostrandoPortalPatronMovil);
  }, [mostrandoPortalPatronMovil, onAxiorLanzadorChange]);
  const [isTablet, setIsTablet] = useState(window.innerWidth < 1024);
  const [drawerOpen, setDrawerOpen] = useState(false);
  useEffect(() => {
    const handle = () => {
      setIsMobile(window.innerWidth < 768);
      setIsTablet(window.innerWidth < 1024);
    };
    window.addEventListener("resize", handle);
    return () => window.removeEventListener("resize", handle);
  }, []);

  const [countedRegs, setCountedRegs] = useState(0);
  const [countedSectors, setCountedSectors] = useState(0);
  useEffect(() => {
    if (sectorActivo) return;
    let frame = 0;
    const total = TOTAL_REGS;
    const sectors = SECTORES.filter(s=>s.disponible).length;
    const duration = 60;
    const timer = setInterval(() => {
      frame++;
      setCountedRegs(Math.min(Math.round((frame/duration)*total), total));
      setCountedSectors(Math.min(Math.round((frame/duration)*sectors), sectors));
      if (frame >= duration) clearInterval(timer);
    }, 16);
    return () => clearInterval(timer);
  }, [sectorActivo]);

  // Inyectar estilos globales + fuente premium
  useEffect(() => {
    const link = document.createElement("link");
    link.href = "https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;600;700&family=DM+Sans:wght@300;400;500;600&display=swap";
    link.rel = "stylesheet";
    document.head.appendChild(link);
    document.body.style.margin = "0";
    document.body.style.background = "#0B1829"; document.documentElement.style.background = "#0B1829"; document.body.style.minHeight = "100vh";
    document.body.style.color = T.textPrim;
    document.body.style.textAlign = "left";
    const style = document.createElement("style");
    style.innerHTML = `
      html, body, #root { background: #0B1829 !important; min-height: 100vh; } * { box-sizing: border-box; }
      @keyframes fadeSlideIn{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:translateY(0)}}
      @keyframes fadeIn{from{opacity:0}to{opacity:1}}
      @keyframes shimmer{0%{background-position:200% 0}100%{background-position:-200% 0}}
      @keyframes pulse{0%,100%{opacity:1;transform:scale(1)}50%{opacity:0.7;transform:scale(0.95)}}
      .anim-slide{animation:fadeSlideIn 0.30s ease forwards}
      .anim-fade{animation:fadeIn 0.22s ease forwards}
      .card-lift{transition:transform 0.25s cubic-bezier(0.34,1.56,0.64,1),box-shadow 0.25s ease!important;cursor:pointer}
      .card-lift:hover{transform:translateY(-6px) scale(1.01)!important;box-shadow:0 20px 48px rgba(22,36,71,0.35)!important}
      .card-lift:active{transform:translateY(-2px) scale(0.99)!important}
      .sector-card{transition:transform 0.25s cubic-bezier(0.34,1.56,0.64,1),box-shadow 0.25s ease!important}
      .sector-card:hover{transform:translateY(-6px)!important;box-shadow:0 20px 48px rgba(22,36,71,0.30)!important}
      .premium-card{transition:transform 0.25s cubic-bezier(0.34,1.56,0.64,1),box-shadow 0.25s ease,border-color 0.2s!important}
      .premium-card:hover{transform:translateY(-5px)!important;box-shadow:0 16px 40px rgba(22,36,71,0.25)!important;border-color:rgba(184,147,42,0.3)!important}
      .reg-item{transition:border-color 0.15s,background 0.15s}
      .reg-item:hover{border-color:rgba(184,147,42,0.35)!important;background:rgba(184,147,42,0.02)!important}
      button{transition:all 0.2s cubic-bezier(0.34,1.56,0.64,1)!important}
      button:active{transform:scale(0.97)!important}
      input:focus,textarea:focus,select:focus{border-color:rgba(184,147,42,0.5)!important;box-shadow:0 0 0 3px rgba(184,147,42,0.1)!important;outline:none!important}
      ::-webkit-scrollbar{width:6px}
      ::-webkit-scrollbar-track{background:rgba(22,36,71,0.15)}
      ::-webkit-scrollbar-thumb{background:rgba(184,147,42,0.35);border-radius:3px}
      ::-webkit-scrollbar-thumb:hover{background:rgba(184,147,42,0.55)}
      .gold-shimmer{background:linear-gradient(90deg,#B8932A 0%,#D4A843 40%,#F0C85A 50%,#D4A843 60%,#B8932A 100%);background-size:200% auto;-webkit-background-clip:text;-webkit-text-fill-color:transparent;animation:shimmer 3s linear infinite}
      .pulse-dot{animation:pulse 2s ease-in-out infinite}
      .glass{background:rgba(255,255,255,0.04)!important;backdrop-filter:blur(12px)!important;border:1px solid rgba(255,255,255,0.08)!important}
      /* ── Animación lift universal ── */
      @keyframes liftIn{from{opacity:0;transform:translateY(14px)}to{opacity:1;transform:translateY(0)}}
      .lift-card{transition:transform 0.28s cubic-bezier(0.34,1.56,0.64,1),box-shadow 0.25s ease,border-color 0.2s!important;cursor:pointer}
      .lift-card:hover{transform:translateY(-7px) scale(1.02)!important;box-shadow:0 20px 48px rgba(22,36,71,0.22)!important}
      .lift-card:active{transform:translateY(-2px) scale(0.99)!important}
      /* sector-card ya tiene hover pero le damos cubic bezier */
      .sector-card{transition:transform 0.28s cubic-bezier(0.34,1.56,0.64,1),box-shadow 0.25s ease!important}
      .sector-card:hover{transform:translateY(-7px) scale(1.01)!important;box-shadow:0 20px 48px rgba(22,36,71,0.18)!important}
      /* reg-item */
      .reg-item{transition:border-color 0.15s,background 0.15s,transform 0.2s!important}
      .reg-item:hover{border-color:rgba(184,147,42,0.35)!important;background:rgba(184,147,42,0.02)!important;transform:translateX(3px)!important}
      /* animación de entrada escalonada para cualquier grid */
      @keyframes fadeUp{from{opacity:0;transform:translateY(18px)}to{opacity:1;transform:translateY(0)}}
      .anim-grid>*:nth-child(1){animation:fadeUp 0.35s ease both}
      .anim-grid>*:nth-child(2){animation:fadeUp 0.35s 0.05s ease both}
      .anim-grid>*:nth-child(3){animation:fadeUp 0.35s 0.10s ease both}
      .anim-grid>*:nth-child(4){animation:fadeUp 0.35s 0.15s ease both}
      .anim-grid>*:nth-child(5){animation:fadeUp 0.35s 0.20s ease both}
      .anim-grid>*:nth-child(6){animation:fadeUp 0.35s 0.25s ease both}
      .anim-grid>*:nth-child(7){animation:fadeUp 0.35s 0.30s ease both}
      .anim-grid>*:nth-child(8){animation:fadeUp 0.35s 0.35s ease both}
      .anim-grid>*:nth-child(9){animation:fadeUp 0.35s 0.40s ease both}
      .anim-grid>*:nth-child(10){animation:fadeUp 0.35s 0.45s ease both}
    `;
    document.head.appendChild(style);
    return () => { document.head.removeChild(link); };
  }, []);

  const regsActivas    = sectorActivo ? SECTOR_DATA[sectorActivo].regs          : [];
  const especialidades = sectorActivo ? SECTOR_DATA[sectorActivo].especialidades : ["Todas"];
  const sectorInfo     = SECTORES.find(s => s.id === sectorActivo) ?? SECTORES[0];
  const nivelesUsados  = Object.keys(NIVEL_LABELS).filter(n => n !== "marco" && regsActivas.some(r => r.nivel === n));

  const filtradas = useMemo(() => {
    if (!sectorActivo) return [];
    return regsActivas.filter(r => {
      if (r.nivel === "marco") return false;
      if (soloPendientes && (estados[r.id] ?? "pendiente") === "cumplido") return false;
      const matchEsp   = especialidad === "Todas" || r.especialidades.includes("Todas") || r.especialidades.includes(especialidad);
      const matchNivel = nivelFiltro  === "todos" || r.nivel === nivelFiltro;
      const q          = busqueda.toLowerCase();
      const matchQ     = !q || r.clave.toLowerCase().includes(q) || r.titulo.toLowerCase().includes(q);
      return matchEsp && matchNivel && matchQ;
    });
  }, [sectorActivo, regsActivas, especialidad, nivelFiltro, busqueda, soloPendientes, estados]);

  const stats = useMemo(() => {
    const total      = filtradas.length;
    const cumplidas  = filtradas.filter(r => (estados[r.id]??"pendiente") === "cumplido").length;
    const enProceso  = 0;
    const pendientes = filtradas.filter(r => (estados[r.id]??"pendiente") === "pendiente").length;
    const pct        = total > 0 ? Math.round((cumplidas/total)*100) : 0;
    return {total,cumplidas,enProceso,pendientes,pct};
  }, [filtradas, estados]);

  const porNivel = useMemo(() => {
    const g: Record<string,Regulacion[]> = {};
    filtradas.forEach(r => { if (!g[r.nivel]) g[r.nivel]=[]; g[r.nivel].push(r); });
    return g;
  }, [filtradas]);

  // Marco legal: viene directo de regsActivas filtrado por especialidad, sin pasar por filtradas
  const marcoRegs = useMemo(() => {
    return regsActivas.filter(r => {
      if (r.nivel !== "marco") return false;
      return especialidad === "Todas" || r.especialidades.includes("Todas") || r.especialidades.includes(especialidad);
    });
  }, [regsActivas, especialidad]);

  const progresoPorSector = useMemo(() => {
    const map: Record<string,number> = {};
    SECTORES.forEach(s => {
      if (!s.disponible || !SECTOR_DATA[s.id]) { map[s.id]=0; return; }
      const d = SECTOR_DATA[s.id];
      const c = d.regs.filter(r => (estados[r.id]??"pendiente") === "cumplido").length;
      map[s.id] = d.regs.length > 0 ? Math.round((c/d.regs.length)*100) : 0;
    });
    return map;
  }, [estados]);

  const [modalContacto, setModalContacto] = useState(false);
  const [modalLegal, setModalLegal] = useState<"disclaimer"|"privacidad"|null>(null);
  const [modalCorreoPDF, setModalCorreoPDF] = useState(false);
  const [correoPDF, setCorreoPDF] = useState("");
  const [guardandoCorreo, setGuardandoCorreo] = useState(false);
  const [formNombre,    setFormNombre]    = useState("");
  const [formEmpresa,   setFormEmpresa]   = useState("");
  const [formTel,       setFormTel]       = useState("");
  const [formEmail,     setFormEmail]     = useState("");

  const getEstado        = (id:string):EstadoType => estados[id]??"pendiente";
  const cycleEstado      = (id:string) => { const idx=ESTADOS.indexOf(getEstado(id)); setEstados(p=>({...p,[id]:ESTADOS[(idx+1)%ESTADOS.length]})); };
  const setEstadoDirecto = (id:string, e:EstadoType) => setEstados(p=>({...p,[id]:e}));
  // ── Generar PDF de diagnóstico ──
  const guardarResultado = async (pct: number, cumplidas: number, pendientes: number) => {
    if (!currentUser || !sectorActivo) return;
    try {
      const sectorInfo = SECTORES.find(s => s.id === sectorActivo);
      await addDoc(collection(db, "diagnosticos"), {
        usuarioEmail: currentUser.email,
        usuarioId: currentUser.uid,
        sector: sectorInfo?.nombre || sectorActivo,
        sectorId: sectorActivo,
        especialidad,
        pct,
        cumplidas,
        pendientes,
        fecha: new Date().toLocaleDateString("es-MX"),
        hora: new Date().toLocaleTimeString("es-MX", {hour:"2-digit", minute:"2-digit"}),
        timestamp: Timestamp.now(),
        tipo: "resultado",
      });
    } catch(e) { /* silencioso */ }
  };

  const generarPDF = () => {
    const script = document.createElement("script");
    script.src = "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";
    script.onload = () => {
      const { jsPDF } = (window as any).jspdf;
      const doc = new jsPDF({ orientation:"portrait", unit:"mm", format:"a4" });
      const gold = [184, 147, 42];
      const dark = [11, 24, 41];
      const navy = [22, 36, 71];
      const gray = [80, 90, 110];
      const W = 210;

      // ── Header premium ──
      doc.setFillColor(11, 24, 41);
      doc.rect(0, 0, W, 42, "F");
      // Línea dorada inferior
      doc.setFillColor(...gold as [number,number,number]);
      doc.rect(0, 42, W, 1.2, "F");

      // AXIS
      doc.setFont("helvetica", "bold");
      doc.setFontSize(26);
      doc.setTextColor(184, 147, 42);
      doc.text("AXIS", 18, 20);

      // Chevrons AXIS — dibujados con líneas (evita problemas de encoding)
      doc.setDrawColor(184, 147, 42);
      doc.setLineWidth(1.2);
      // Chevron superior
      doc.line(44, 16, 48, 11); doc.line(48, 11, 52, 16);
      // Chevron inferior
      doc.line(44, 21, 48, 16); doc.line(48, 16, 52, 21);
      doc.setLineWidth(0.5);

      doc.setFont("helvetica", "normal");
      doc.setFontSize(7);
      doc.setTextColor(180, 180, 180);
      doc.text("ASESORÍA LEGAL CORPORATIVA", 18, 26);
      doc.setTextColor(120, 120, 120);
      doc.text("Torre Plaza Bosques, Int. 909 · Aguascalientes, Ags.", 18, 31);

      doc.setFontSize(8.5);
      doc.setTextColor(150, 150, 150);
      doc.text("Diagnóstico de Cumplimiento Regulatorio · AXIS Gestión Empresarial", 18, 38);

      // Fecha
      const fecha = new Date().toLocaleDateString("es-MX", {day:"2-digit", month:"long", year:"numeric"});
      doc.setFontSize(8);
      doc.setTextColor(150, 150, 150);
      doc.text(fecha, W - 18, 20, {align:"right"});
      doc.setFont("helvetica","bold");
      doc.setFontSize(9);
      doc.setTextColor(184,147,42);
      doc.text("AXIS Gestión Empresarial", W - 18, 28, {align:"right"});
      doc.setFont("helvetica","normal");
      doc.setFontSize(7);
      doc.setTextColor(100,100,100);
      doc.text("axislegalags.com", W - 18, 35, {align:"right"});

      // ── Sector / especialidad ──
      doc.setFillColor(240, 237, 228);
      doc.rect(0, 43, W, 26, "F");

      doc.setFont("helvetica", "bold");
      doc.setFontSize(16);
      doc.setTextColor(...dark as [number,number,number]);
      doc.text(sectorInfo.nombre, 18, 56);

      doc.setFont("helvetica", "normal");
      doc.setFontSize(10);
      doc.setTextColor(...gray as [number,number,number]);
      doc.text("Especialidad: " + especialidad + "  ·  AXIS Asesoría Legal Corporativa", 18, 64);

      // ── Semáforo de cumplimiento ──
      const semColor = stats.pct>=80 ? [5,150,105] : stats.pct>=40 ? [217,119,6] : [220,38,38];
      const semLabel = stats.pct>=80 ? "EN REGLA" : stats.pct>=40 ? "REQUIERE ATENCIÓN" : "ATENCIÓN URGENTE";
      const semDesc = stats.pct>=80
        ? "Tu empresa cumple con los requisitos regulatorios esenciales."
        : stats.pct>=40
        ? "Existen obligaciones pendientes que deben atenderse pronto."
        : "Se detectaron incumplimientos que representan riesgo legal.";

      doc.setFillColor(255,255,255);
      doc.roundedRect(14, 75, W-28, 32, 3, 3, "F");
      doc.setDrawColor(...semColor as [number,number,number]);
      doc.setLineWidth(0.6);
      doc.roundedRect(14, 75, 4, 32, 1, 1, "F");

      doc.setFillColor(...semColor as [number,number,number]);
      doc.roundedRect(14, 75, 4, 32, 1, 1, "F");

      // Porcentaje grande
      doc.setFont("helvetica", "bold");
      doc.setFontSize(28);
      doc.setTextColor(...semColor as [number,number,number]);
      doc.text(stats.pct + "%", 28, 94);

      doc.setFontSize(13);
      doc.setTextColor(...dark as [number,number,number]);
      doc.text(semLabel, 65, 87);

      doc.setFont("helvetica", "normal");
      doc.setFontSize(9);
      doc.setTextColor(...gray as [number,number,number]);
      doc.text(semDesc, 65, 94);

      // Stats mini
      const statItems = [
        {label:"Total", val:String(stats.total), color:[80,90,110]},
        {label:"Cumplidas", val:String(stats.cumplidas), color:[5,150,105]},
        {label:"Pendientes", val:String(stats.pendientes), color:[220,38,38]},
      ];
      statItems.forEach((s,i) => {
        const sx = 65 + i*42;
        doc.setFont("helvetica","bold"); doc.setFontSize(12); doc.setTextColor(...s.color as [number,number,number]);
        doc.text(s.val, sx, 103);
        doc.setFont("helvetica","normal"); doc.setFontSize(7); doc.setTextColor(...gray as [number,number,number]);
        doc.text(s.label, sx, 107);
      });

      // ── Caja de riesgo económico (multas) ──
      let y = 116;

      // Caja principal — rojo advertencia
      doc.setFillColor(120, 20, 20);
      doc.roundedRect(14, y, W-28, 28, 3, 3, "F");
      doc.setFillColor(220, 38, 38); doc.rect(14, y, 3, 28, "F");

      doc.setFont("helvetica","bold"); doc.setFontSize(9); doc.setTextColor(255, 180, 180);
      doc.text("⚠  RIESGO ECONÓMICO POR INCUMPLIMIENTO", 20, y+7);

      // Calcular multas estimadas basadas en UMA 2026 ($117.31/día)
      const UMA = 117.31;
      const pendCount = stats.pendientes;
      const multaMin = Math.round(pendCount * UMA * 50);   // 50 UMAs mínimo por infracción
      const multaMax = Math.round(pendCount * UMA * 500);  // 500 UMAs máximo
      const formatMXN = (n: number) => "$" + n.toLocaleString("es-MX");

      doc.setFont("helvetica","normal"); doc.setFontSize(8); doc.setTextColor(255, 210, 210);
      const multas1 = doc.splitTextToSize(
        "Con " + pendCount + " obligación(es) pendiente(s), tu empresa está expuesta a multas estimadas de entre " +
        formatMXN(multaMin) + " y " + formatMXN(multaMax) + " MXN (LFPA + LFT + COFEPRIS, según UMA 2026).",
        W-46
      );
      doc.text(multas1, 20, y+13);

      doc.setFont("helvetica","bold"); doc.setFontSize(8); doc.setTextColor(212, 168, 67);
      doc.text("Una consulta con AXIS es más barata que una multa. Contáctanos hoy.", 20, y+23);
      y += 33;

      // ── Caja de valor AXIS ──
      doc.setFillColor(22, 36, 71);
      doc.roundedRect(14, y, W-28, 20, 3, 3, "F");
      doc.setFillColor(184,147,42); doc.rect(14, y, 3, 20, "F");
      doc.setFont("helvetica","bold"); doc.setFontSize(9); doc.setTextColor(212,168,67);
      doc.text("¿Qué sigue ahora?", 20, y+7);
      doc.setFont("helvetica","normal"); doc.setFontSize(8); doc.setTextColor(200,200,220);
      const msgValor = stats.pct >= 80
        ? "Tu empresa está en buen camino. Te recomendamos mantener actualizadas tus licencias y contratos con AXIS."
        : stats.pct >= 40
        ? "AXIS puede ayudarte a regularizarte antes de la próxima inspección. Agenda tu consulta gratuita."
        : "Actúa hoy: cada día de incumplimiento aumenta el riesgo. AXIS tiene un plan de regularización para tu empresa.";
      const msgLines = doc.splitTextToSize(msgValor, W-44);
      doc.text(msgLines, 20, y+13);
      y += 26;

      // ── Sección: Acciones recomendadas ──
      const pendientes = filtradas.filter(r => (estados[r.id] ?? "pendiente") !== "cumplido");

      if (pendientes.length > 0) {
        doc.setFillColor(255, 247, 230);
        doc.roundedRect(14, y, W-28, 8, 2, 2, "F");
        doc.setFillColor(217, 119, 6);
        doc.rect(14, y, 3, 8, "F");
        doc.setFont("helvetica", "bold"); doc.setFontSize(9); doc.setTextColor(120, 60, 0);
        doc.text("⚡ ACCIONES PRIORITARIAS — Regulaciones pendientes de atender", 20, y+5.5);
        y += 12;

        pendientes.slice(0,5).forEach(r => {
          if (y > 265) { doc.addPage(); y = 20; }
          doc.setFillColor(255, 250, 240);
          doc.roundedRect(14, y, W-28, 12, 1.5, 1.5, "F");
          doc.setFillColor(220, 100, 30);
          doc.circle(20, y+6, 2, "F");
          doc.setFont("helvetica","bold"); doc.setFontSize(7.5); doc.setTextColor(...gold as [number,number,number]);
          doc.text(r.clave.substring(0,28), 25, y+5);
          doc.setFont("helvetica","normal"); doc.setFontSize(7.5); doc.setTextColor(...dark as [number,number,number]);
          const tit = doc.splitTextToSize(r.titulo, 130);
          doc.text(tit[0], 25, y+10);
          doc.setFont("helvetica","bold"); doc.setFontSize(7); doc.setTextColor(150,50,10);
          doc.text("PENDIENTE", W-18, y+7, {align:"right"});
          y += 14;
        });

        if (pendientes.length > 5) {
          doc.setFont("helvetica","italic"); doc.setFontSize(8); doc.setTextColor(...gray as [number,number,number]);
          doc.text(`... y ${pendientes.length-5} obligación(es) más. Consulta el diagnóstico completo en AXIS Gestión Empresarial.`, 18, y);
          y += 8;
        }
        y += 4;
      }

      // ── Tabla completa de regulaciones ──
      if (y > 230) { doc.addPage(); y = 20; }

      doc.setFillColor(...navy as [number,number,number]);
      doc.rect(14, y, W-28, 8, "F");
      doc.setFont("helvetica","bold"); doc.setFontSize(9); doc.setTextColor(255,255,255);
      doc.text("REPORTE COMPLETO DE CUMPLIMIENTO REGULATORIO", 18, y+5.5);
      y += 12;

      const niveles = ["federal","estatal","municipal","nom_universal","nom_especialidad","nom_complementaria","laboral","iso"];
      const nivelNombres: Record<string,string> = {
        federal:"Marco Federal", estatal:"Marco Estatal", municipal:"Trámites Municipales",
        nom_universal:"NOMs Universales", nom_especialidad:"NOMs por Especialidad",
        nom_complementaria:"NOMs Complementarias", laboral:"Obligaciones Laborales", iso:"Normas ISO",
      };

      const addPage = () => { doc.addPage(); y = 20; };

      niveles.forEach(nivel => {
        const regsNivel = filtradas.filter(r => r.nivel === nivel);
        if (regsNivel.length === 0) return;
        if (y > 250) addPage();

        doc.setFillColor(...gold as [number,number,number]);
        doc.rect(14, y, W-28, 7, "F");
        doc.setFont("helvetica","bold"); doc.setFontSize(8); doc.setTextColor(255,255,255);
        doc.text(nivelNombres[nivel].toUpperCase(), 18, y+5);
        y += 10;

        regsNivel.forEach((r,ri) => {
          if (y > 268) addPage();
          const est = estados[r.id] ?? "pendiente";
          const esCumplido = est === "cumplido";

          if (ri % 2 === 0) { doc.setFillColor(250,249,246); doc.rect(14, y-1, W-28, 9, "F"); }

          doc.setFillColor(esCumplido?5:220, esCumplido?150:38, esCumplido?105:38);
          doc.circle(20, y+3.5, 2.5, "F");

          doc.setFont("helvetica","bold"); doc.setFontSize(7); doc.setTextColor(...gold as [number,number,number]);
          doc.text(r.clave.substring(0,25), 25, y+4);
          doc.setFont("helvetica","normal"); doc.setFontSize(7.5); doc.setTextColor(...dark as [number,number,number]);
          doc.text(doc.splitTextToSize(r.titulo, 120)[0], 70, y+4);
          doc.setFont("helvetica","bold"); doc.setFontSize(6.5);
          doc.setTextColor(esCumplido?5:180, esCumplido?150:50, esCumplido?105:50);
          doc.text(esCumplido ? "✓ Cumplido" : "Pendiente", W-18, y+4, {align:"right"});
          y += 9;
        });
        y += 4;
      });

      // ── Sección CTA: AXIS ──
      if (y > 240) { doc.addPage(); y = 20; }
      y += 6;
      doc.setFillColor(11,24,41);
      doc.roundedRect(14, y, W-28, 40, 3, 3, "F");
      doc.setFillColor(...gold as [number,number,number]);
      doc.roundedRect(14, y, 3, 40, 1, 1, "F");

      doc.setFont("helvetica","bold"); doc.setFontSize(12); doc.setTextColor(184,147,42);
      doc.text("¿Tienes dudas sobre tu cumplimiento?", 22, y+12);
      doc.setFont("helvetica","normal"); doc.setFontSize(9); doc.setTextColor(200,200,200);
      doc.text("AXIS Asesoría Legal Corporativa te acompaña en cada trámite, contrato y", 22, y+20);
      doc.text("obligación regulatoria. Agenda una consulta gratuita con nuestros abogados.", 22, y+27);
      doc.setFont("helvetica","bold"); doc.setFontSize(9); doc.setTextColor(184,147,42);
      doc.text("449 425 11 28  ·  contacto@axislegalags.com  ·  axislegalags.com", 22, y+36);

      // ── Footer ──
      const pageCount = doc.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFillColor(15,23,42);
        doc.rect(0, 284, W, 13, "F");
        doc.setFont("helvetica","normal"); doc.setFontSize(7); doc.setTextColor(150,150,150);
        doc.text("AXIS Asesoría Legal Corporativa  ·  Aguascalientes, México", 18, 292);
        doc.setTextColor(...gold as [number,number,number]);
        doc.text("449 425 11 28  ·  contacto@axislegalags.com  ·  axislegalags.com", W-18, 292, {align:"right"});
        doc.setTextColor(100,100,100);
        doc.text("Página " + i + " de " + pageCount, W/2, 292, {align:"center"});
      }

      doc.save("Diagnostico_AXIS_" + sectorInfo.nombre.replace(/ /g,"_") + ".pdf");
    };
    document.head.appendChild(script);
  };

  // ── Guardar diagnóstico en Firestore si hay usuario logueado ──
  const guardarDiagnostico = async (sectorId: string) => {
    if (!currentUser) return;
    try {
      const sectorInfo = SECTORES.find(s => s.id === sectorId);
      if (!sectorInfo) return;
      await addDoc(collection(db, "diagnosticos"), {
        usuarioEmail: currentUser.email,
        usuarioId: currentUser.uid,
        sector: sectorInfo.nombre,
        sectorId,
        fecha: new Date().toLocaleDateString("es-MX"),
        hora: new Date().toLocaleTimeString("es-MX", {hour:"2-digit", minute:"2-digit"}),
        timestamp: Timestamp.now(),
      });
    } catch(e) { /* silencioso */ }
  };

  const entrarSector     = (id:string) => { setSectorActivo(id); setEspecialidad("Todas"); setNivelFiltro("todos"); setSeleccionado(null); setBusqueda(""); guardarDiagnostico(id); const esp = SECTOR_DATA[id]?.especialidades ?? []; setPasoWizard(esp.length > 1 ? 2 : 3); };
  const volverHome       = () => { setSectorActivo(null); setSeleccionado(null); setBusqueda(""); setPasoWizard(1); };

  const fontSans = "'DM Sans', -apple-system, sans-serif";
  const fontSerif = "'Cormorant Garamond', Georgia, serif";

  // ── Datos para modal de contacto (siempre calculados, nunca dentro de JSX) ──
  const pendientesOblig = regsActivas
    .filter(r => r.obligatorio && (estados[r.id] ?? "pendiente") === "pendiente")
    .slice(0, 4);
  const totalPend = regsActivas.filter(r => (estados[r.id] ?? "pendiente") === "pendiente").length;
  const totalCump = regsActivas.filter(r => (estados[r.id] ?? "pendiente") === "cumplido").length;

  const msgWA = sectorActivo ? encodeURIComponent(
    "Hola AXIS Abogados 👋\n\nMe contacto desde la plataforma *AXIS Legaltech*.\n\n" +
    "*Sector:* " + sectorInfo.nombre + "\n" +
    "*Especialidad:* " + especialidad + "\n" +
    "*Regulaciones pendientes:* " + totalPend + "\n" +
    "*Regulaciones cumplidas:* " + totalCump + "\n\n" +
    (pendientesOblig.length > 0
      ? "Principales obligaciones pendientes:\n" + pendientesOblig.map(r => "• " + r.clave + " — " + r.titulo).join("\n") + "\n\n"
      : "") +
    "Me gustaría solicitar una consulta.\n\n" +
    "Nombre: " + (formNombre || "(pendiente)") + "\nEmpresa: " + (formEmpresa || "(pendiente)")
  ) : "";

  const mailSubject = sectorActivo ? encodeURIComponent("Consulta AXIS Legaltech — " + sectorInfo.nombre) : "";
  const mailBody    = sectorActivo ? encodeURIComponent(
    "Hola AXIS Abogados,\n\nMe contacto desde la plataforma AXIS Legaltech.\n\n" +
    "Sector: " + sectorInfo.nombre + "\n" +
    "Especialidad: " + especialidad + "\n" +
    "Pendientes: " + totalPend + " | Cumplidas: " + totalCump + "\n\n" +
    "Nombre: " + (formNombre||"—") + "\n" +
    "Empresa: " + (formEmpresa||"—") + "\n" +
    "Tel: " + (formTel||"—") + "\n" +
    "Email: " + (formEmail||"—")
  ) : "";

  // ── HOME ──────────────────────────────────────────────────────────────────
  // ── Pantallas globales ──


  // ═══ LA PUERTA ═══════════════════════════════════════════════════════════
  // Va ANTES que ninguna otra pantalla, y eso importa: estaba montada después
  // del guard de rol, así que un TRABAJADOR sin autorización entraba a su portal
  // —lo dejaba pasar `esTrabajador === true`— y se encontraba las consultas
  // rechazadas por las reglas: pantallas vacías y errores de permisos en la
  // consola, que es exactamente lo que esta pantalla existe para evitar.
  //
  // 1) Mientras se evalúa, CARGA. Nunca el rechazo. Cubre también el instante
  //    inicial en el que todavía no se sabe si hay sesión, para no parpadear la
  //    bienvenida a alguien que la tiene guardada.
  // 2) Con sesión y respuesta negativa, la explicación.
  // 3) Sin sesión, no se corta nada: sigue el flujo normal hasta la bienvenida y
  //    el formulario de acceso.
  const shellLogout = async () => { await signOut(auth); setCurrentUser(null); setAppPantalla("bienvenida"); };
  const shellLogin = () => setAppPantalla("login");
  const _puerta = decidirPuerta(acceso, currentUser);
  // UN TRABAJADOR REGISTRADO NUNCA LEE "pídele a tu patrón que dé de alta tu
  // cuenta". La puerta lo rechaza igual (activo:false = cuenta suspendida, ver
  // acceso.js), pero se le enseña lo que pasa: su cuenta está suspendida. Y
  // mientras la detección de rol no contesta, se espera: si no, parpadeaba la
  // pantalla de alta y se anotaba como lead.
  const _rechazo = _puerta === "sin_acceso" ? pantallaDelRechazo(cuentaSuspendida, esTrabajador, rolError) : null;
  if (_puerta === "cargando" || _rechazo === "cargando") return (
    <div style={{minHeight:"100vh", background:T_LIGHT.canvas, display:"flex", alignItems:"center", justifyContent:"center",
      fontFamily:fontSans, color:T_LIGHT.textInkSoft, fontSize:14}}>Cargando…</div>
  );
  if (_rechazo === "error") return (
    <PantallaErrorDeCuenta onReintentar={reintentarRol} onSalir={shellLogout} fontSans={fontSans} fontSerif={fontSerif} gold={T.gold} />
  );
  if (_rechazo === "trabajador_sin_empresa") return (
    <PantallaTrabajadorSinAccesoDeEmpresa correo={currentUser?.email || ""} onSalir={shellLogout} fontSans={fontSans} fontSerif={fontSerif} gold={T.gold} />
  );
  if (_rechazo === "suspendida") return (
    <PantallaCuentaSuspendida correo={currentUser?.email || ""} fontSans={fontSans} fontSerif={fontSerif} gold={T.gold}
      onSalir={async ()=>{ try { await signOut(auth); } catch(_){} setCuentaSuspendida(null); setCurrentUser(null); setAppPantalla("bienvenida"); }} />
  );
  if (_puerta === "sin_acceso") return (
    <PantallaSinAcceso user={currentUser} onSalir={shellLogout} fontSans={fontSans} fontSerif={fontSerif} />
  );

  // ── Candado biométrico (acceso rápido) sobre la sesión restaurada ──
  if (currentUser && !currentUser.isAnonymous && bioBloqueado) return (
    <BioLockScreen user={currentUser}
      onUnlock={() => { try { sessionStorage.setItem(_bioSesionClave(currentUser?.uid), "1"); } catch(e) {} setBioBloqueado(false); }}
      onOtraCuenta={async () => { setBioBloqueado(false); try { await signOut(auth); } catch(e){} setCurrentUser(null); setAppPantalla("bienvenida"); }}
      fontSans={fontSans} fontSerif={fontSerif} />
  );
  // ── Oferta de acceso rápido tras un login fresco (una vez) ──
  if (currentUser && !currentUser.isAnonymous && mostrarOfertaBio) return (
    <OfertaBioScreen user={currentUser}
      onActivar={() => setMostrarOfertaBio(false)}
      onOmitir={() => { try { localStorage.setItem(`axis_acceso_rapido_omitido:${currentUser.uid}`,"1"); } catch(e){} setMostrarOfertaBio(false); }}
      fontSans={fontSans} fontSerif={fontSerif} />
  );

  // ── Rol TRABAJADOR: vista limitada ────────────────────────────────────────
  // ANTES de landing/login/suite: si el usuario autenticado es un trabajador
  // (cuentas_trabajador/{correo} que no dice activo:false), SOLO ve su lista de actividades,
  // sin el resto de módulos ni el menú — en cualquier appPantalla, incluida la
  // recarga sobre "landing". Mientras se resuelve el rol mostramos carga para no
  // parpadear la app. Los no autenticados/anónimos pasan de largo (guard).
  // ── Gate de consentimiento ───────────────────────────────────────────────
  // VA ANTES DEL GUARD DE ROL, no después. Estaba 136 líneas más abajo, así que
  // el trabajador salía por el `return` del portal y NUNCA llegaba aquí: entraba
  // a la aplicación sin haber visto un aviso de privacidad. El patrón sí lo veía.
  // El componente es agnóstico del rol y está listo para recibir un texto distinto
  // según quién entre; ese texto se decide aparte.
  if (currentUser && !currentUser.isAnonymous && consentNeeded !== false) {
    if (consentNeeded === null) {
      return <div style={{minHeight:"100vh", background:T_LIGHT.canvas, display:"flex", alignItems:"center", justifyContent:"center", fontFamily:fontSans, color:T_LIGHT.textInkSoft, fontSize:14}}>Cargando…</div>;
    }
    return <GateConsentimiento user={currentUser} onAceptado={()=>setConsentNeeded(false)} fontSans={fontSans} fontSerif={fontSerif} gold={T.gold} />;
  }

  if (currentUser && !currentUser.isAnonymous) {
    if (esTrabajador === null && rolError) return (
      <PantallaErrorDeCuenta onReintentar={reintentarRol} onSalir={async () => { await signOut(auth); setCurrentUser(null); setAppPantalla("bienvenida"); }} fontSans={fontSans} fontSerif={fontSerif} gold={T.gold} />
    );
    if (esTrabajador === null) {
      return <div style={{minHeight:"100vh", background:T_LIGHT.canvas, display:"flex", alignItems:"center", justifyContent:"center", fontFamily:fontSans, color:T_LIGHT.textInkSoft, fontSize:14}}>Cargando…</div>;
    }
    if (esTrabajador === true) {
      return <VistaTrabajador user={currentUser} cuenta={cuentaTrabajador} onLogout={async () => { await signOut(auth); setCurrentUser(null); setAppPantalla("bienvenida"); }} fontSans={fontSans} fontSerif={fontSerif} gold={T.gold} />;
    }
  }

  // ── BIENVENIDA — primera pantalla para NO logueados reales (capa nueva) ──
  // Solo aparece a no-logueados o anónimos (beta). A los trabajadores logueados ya
  // los interceptó el guard de rol; a los patrones logueados el efecto de arriba los
  // ── CANDADO DE ACCESO: cuenta de trabajador SUSPENDIDA ──────────────────────────
  // Se evalúa ANTES que cualquier otra pantalla: si el patrón dio de baja al
  // trabajador, su cuenta queda activo:false y aquí se corta el acceso. Importa que
  // vaya primero porque, sin esto, la detección de rol lo dejaría pasar como PATRÓN.
  // No se borra la cuenta ni se toca Firebase Auth: solo se le impide entrar.
  if (currentUser && !currentUser.isAnonymous && cuentaSuspendida) return (
    <PantallaCuentaSuspendida correo={currentUser.email || ""} fontSans={fontSans} fontSerif={fontSerif} gold={T.gold}
      onSalir={async ()=>{ try { await signOut(auth); } catch(_){} setCuentaSuspendida(null); setCurrentUser(null); setAppPantalla("bienvenida"); }} />
  );

  // manda a su suite. Salida segura: ambos botones llevan al acceso (login/landing).
  if (appPantalla === "bienvenida") {
    if (!currentUser || currentUser.isAnonymous) return (
      <BienvenidaScreen
        // "Empresa" va DIRECTO al login (antes pasaba por la pantalla freemium "landing").
        // LandingHome/planes NO se borra: sigue en el código y accesible por otros caminos
        // (p. ej. el CTA onGoLanding de la Calculadora en la suite). Solo se saca del flujo de entrada.
        onEmpresa={() => { setPuertaLogin("empresa"); setAppPantalla("login"); }}
        onTrabajador={() => { setPuertaLogin("trabajador"); setAppPantalla("login"); }}
        fontSans={fontSans} fontSerif={fontSerif} gold={T.gold}
      />
    );
    // Logueado real en transición (el efecto lo redirige a su suite): evita parpadeo.
    return <PantallaCargando fontSans={fontSans}/>;
  }

  // ── LANDING — home público con freemium (camino "Empresa"). Se reutiliza tal cual;
  //    se añade SOLO un botón flotante para regresar a la bienvenida (salida siempre). ──
  if (appPantalla === "landing") return (
    <LandingHome
      onEntrarDiagnostico={() => setAppPantalla("regulamx")}
      onLogin={() => setAppPantalla("login")}
      currentUser={currentUser}
      isProUser={isProUser}
      onGoSuite={() => setAppPantalla("suite")}
      onGoFiniquito={() => setAppPantalla("nomina")}
      onGoAcercaDe={() => setAppPantalla("acerca_de")}
      onGoPlanes={() => setAppPantalla("planes")}
      onVolver={() => setAppPantalla("bienvenida")}
      fontSans={fontSans} fontSerif={fontSerif} gold={T.gold}
    />
  );

  if (appPantalla === "login") return (
    <LoginScreen key={puertaLogin} puerta={puertaLogin}
      onBack={() => { setPuertaLogin("empresa"); setAppPantalla("bienvenida"); }} onSuccess={handleLoginSuccess} fontSans={fontSans} fontSerif={fontSerif} gold={T.gold} />
  );

  // Helper: envoltura del shell híbrido para las pantallas internas (suite + módulos).
  // Centraliza props comunes y mantiene legible el switch de abajo.
  // (shellLogout y shellLogin se definen arriba, junto a la puerta.)
  // ── REGLA DE NAVEGACIÓN ───────────────────────────────────────────────────
  // Un clic en el sidebar SIEMPRE abre la vista por defecto del módulo, aunque
  // ya estemos parados en él. React conserva el estado interno de un componente
  // que sigue montado, así que sin esto el usuario se queda atrapado en la
  // pestaña, el detalle o el filtro donde estuviera. `navToken` cambia en cada
  // navegación del shell y sirve de `key`: el módulo se vuelve a montar limpio.
  // Vale para todos los módulos, incluidos los que se agreguen después.
  // (El `useState` de `navToken` está arriba, con el resto de los hooks.)
  // ── QUIÉN DECIDIÓ MANDA ───────────────────────────────────────────────────
  //
  // Un clic del sidebar lleva a la VISTA POR DEFECTO del módulo; un enlace lleva
  // a LO QUE EL ENLACE PIDIÓ. Lo que hace que eso se cumpla solo es que TODOS
  // los saltos limpien lo mismo y luego pongan lo suyo: el sidebar no pone nada,
  // así que aterriza en limpio.
  //
  // Todo el estado que vive DENTRO de un módulo ya se reinicia por su cuenta: la
  // `navKey` cambia en cada navegación y React remonta la pantalla. Lo único que
  // sobrevive es este estado de App, porque vuelve a entrar como prop.
  //
  // POR ESO ESTA LISTA ES UNA SOLA. Estaba copiada en tres sitios y el tercero
  // se quedó sin `tareaFocoId`: entrar a Actividades por el menú conservaba el
  // filtro "Todas" de un salto anterior. Y la propia `_limpiarFocos` se quedó sin
  // `empleadoFocoEmails`, así que llegar a una ficha desde el feed arrastraba el
  // acotado por correos del renglón del checador. Dos listas de lo mismo dan dos
  // olvidos distintos; `prueba-navegacion` falla si aparece un foco nuevo que no
  // esté aquí.
  const _limpiarFocos = () => {
    setTrabajadorNomina(null); setTareasFoco(""); setTareaFocoId(null); setFlotillaFiltro(null);
    setFlotillaVehiculoId(null); setFlotillaVehiculoTab(null); setFlotillaFoco(null);
    setEmpleadoFocoId(null); setEmpleadoFocoTab(null); setEmpleadoFocoEmails([]); setCreditoFoco(null);
  };

  const irAModulo = (m: AppPantalla) => {
    _limpiarFocos();             // el sidebar no pide nada concreto: vista por defecto
    // Diagnóstico es el único módulo cuyo estado de vista vive AQUÍ y no dentro
    // de un componente, así que la llave de remontaje no lo alcanza: se reinicia
    // a mano al selector de industria. El progreso del checklist no se pierde
    // (vive en localStorage), sólo se vuelve a elegir el sector.
    if (m === "regulamx") {
      setSectorActivo(null); setPasoWizard(1); setSeleccionado(null);
      setBusqueda(""); setNivelFiltro("todos"); setSoloPendientes(false);
    }
    setAppPantalla(m);
    setNavToken(n => n + 1);
  };
  // Salto contextual desde la ficha: abre Nómina con ESE trabajador puesto.
  const irANominaDe = (t:any) => { _limpiarFocos(); setTrabajadorNomina(t); setAppPantalla("recibos"); setNavToken(n => n + 1); };
  // Un aviso lleva a SU asunto, no al módulo: pulsar una lista y obtener otra
  // lista de lo mismo no resuelve nada. Cuando el tipo no tiene una vista propia
  // del elemento —los eventos de calendario— cae en el módulo, que es su detalle.
  // EL RENGLÓN LLEVA AL LUGAR DONDE SE RESUELVE, no al módulo ni a la pestaña por
  // omisión. Un aviso que dice "Verificación · PQR-654-E" y aterriza en "Datos"
  // obliga a buscar dónde se arregla lo que la plataforma acaba de señalar.
  //   · documento de vehículo → su expediente, pestaña Documentos
  //   · contrato de empleado  → su ficha, pestaña Contratos (donde se renueva)
  //   · cuota de crédito      → el crédito, que es donde se registra el pago
  // Todo por el mecanismo de focos que ya existe; ninguna lista nueva.
  const irAItemAtencion = (it:any) => {
    _limpiarFocos();
    const m: AppPantalla = it?.modulo || "suite";
    // UN ACCIDENTE DEL ESCUDO LLEVA A ESE ACCIDENTE, no a la unidad: el renglón
    // prometía un accidente concreto, y abrir los documentos del vehículo sería
    // entregar otra lista.
    if (m === "flotilla" && it?.refTipo === "accidente" && it?.refId) setFlotillaFoco({foco:"accidente", id: it.refId});
    else if (m === "flotilla"  && it?.refId) { setFlotillaVehiculoId(it.refId); setFlotillaVehiculoTab("documentos"); }
    else if (m === "empleados" && it?.refId) { setEmpleadoFocoId(it.refId); setEmpleadoFocoTab("contratos"); }
    else if (m === "creditos"  && it?.refPadreId) setCreditoFoco({deudorId: it.refPadreId, creditoId: it.refId || null});
    setAppPantalla(m);
    setNavToken(n => n + 1);
  };
  // Empleados acotado a unos correos: mismo patrón que los demás saltos
  // contextuales —estado aquí, prop de valor inicial en el módulo, y la misma
  // limpieza que todos para que no arrastre el foco de un salto anterior—.
  const irAEmpleadosFoco = (emails:string[]) => {
    _limpiarFocos();
    setEmpleadoFocoEmails(emails); setAppPantalla("empleados"); setNavToken(n => n + 1);
  };
  const irAFlotillaCon = (fil:"vencida"|"por_vencer"|"sin_registro"|"en_regla") => { _limpiarFocos(); setFlotillaFiltro(fil); setAppPantalla("flotilla"); setNavToken(n => n + 1); };
  // Una unidad en la calle lleva a SU VIAJE, no al módulo. Se manda el id y
  // nada más: los datos del viaje los vuelve a leer Flotilla de su colección.
  const irAViajeFlotilla = (viajeId:string) => {
    _limpiarFocos();
    if (viajeId) setFlotillaFoco({foco:"viaje", id:viajeId});
    setAppPantalla("flotilla"); setNavToken(n => n + 1);
  };
  // UNA FILA DEL FEED LLEVA A SU HECHO. El destino ya viene resuelto y validado
  // desde donde se armó la fila: aquí solo se traduce a la navegación. Si la
  // fila no traía destino, nunca llega hasta aquí —no es clicable—.
  const irADestinoFeed = (d: DestinoFeed) => {
    if (!d) return;
    _limpiarFocos();
    if (d.modulo === "flotilla") {
      setFlotillaFoco({foco: d.foco, id: d.id});
      setAppPantalla("flotilla");
    } else if (d.modulo === "empleados") {
      setEmpleadoFocoId(d.id); setEmpleadoFocoTab(d.pestana);
      setAppPantalla("empleados");
    } else {
      // Sin `setTareasFoco`: ese es el salto "asignarle algo a esta persona" y
      // abre el formulario de alta. Aquí se va a UNA actividad que ya existe.
      setTareaFocoId(d.id);
      setAppPantalla("tareas");
    }
    setNavToken(n => n + 1);
  };
  // LOS DOS ÁRBOLES DEL PATRÓN VAN ENVUELTOS POR EL MISMO PROVEEDOR. Un trabajador
  // no llega aquí —lo intercepta su guard antes—, así que el hook de push sigue sin
  // montarse para él, que es la regla escrita donde se declara.
  const conShell = (contenido: React.ReactNode) => (
    <ProveedorPuertaAvisos currentUser={currentUser}>
    <AppShell
      appPantalla={appPantalla}
      navKey={`${appPantalla}:${navToken}`}
      setAppPantalla={irAModulo}
      onIrItem={irAItemAtencion}
      currentUser={currentUser}
      isProUser={isProUser}
      isMobile={isMobile}
      fontSans={fontSans}
      fontSerif={fontSerif}
      onLogout={shellLogout}
      onLogin={shellLogin}
    >
      {contenido}
    </AppShell>
    </ProveedorPuertaAvisos>
  );


  // ── PATRÓN logueado en MÓVIL → portal nativo del patrón. En ESCRITORIO el
  //    patrón sigue viendo la suite/módulos EXACTAMENTE como hoy. Va después del
  //    guard de trabajador y del gate de consentimiento (el trabajador ya quedó
  //    interceptado antes; aquí esTrabajador===false). No cambia auth ni roles.
  if (currentUser && !currentUser.isAnonymous && esTrabajador === false && isMobile) {
    return (
      <ProveedorPuertaAvisos currentUser={currentUser}>
        <PortalPatronMovil currentUser={currentUser} onLogout={shellLogout} fontSans={fontSans} fontSerif={fontSerif} gold={T.gold} />
      </ProveedorPuertaAvisos>
    );
  }

  if (appPantalla === "suite") return conShell(
    <SuiteHome user={currentUser} isProUser={isProUser} onLogout={shellLogout} onLogin={() => setAppPantalla("login")} onGoFlotilla={() => setAppPantalla("flotilla")} onGoRegula={() => setAppPantalla("regulamx")} onGoAdmin={() => setAppPantalla("admin")} onGoNomina={() => setAppPantalla("nomina")} onGoContratos={() => setAppPantalla("contratos")} onGoEmpleados={() => setAppPantalla("empleados")} onGoCalendario={() => setAppPantalla("calendario")} onGoDocumentos={() => setAppPantalla("documentos")} onGoProveedores={() => setAppPantalla("proveedores")} onGoClientes={() => setAppPantalla("clientes")} onGoCreditos={() => setAppPantalla("creditos")} onGoTareas={() => setAppPantalla("tareas")} onGoEmpleadosFoco={irAEmpleadosFoco} onGoFlotillaFiltrada={irAFlotillaCon} onIrItem={irAItemAtencion} onGoViaje={irAViajeFlotilla} onIrDestino={irADestinoFeed} fontSans={fontSans} fontSerif={fontSerif} gold={T.gold} />
  );

  if (appPantalla === "admin") return conShell(
    <AdminPanel user={currentUser} onBack={() => setAppPantalla("suite")} fontSans={fontSans} fontSerif={fontSerif} gold={T.gold} />
  );


  if (appPantalla === "empleados") return conShell(
    <EmpleadosModulo trabajadorInicialId={empleadoFocoId} trabajadorInicialTab={empleadoFocoTab} focoEmails={empleadoFocoEmails} onGoContratos={() => setAppPantalla("contratos")} onBack={() => setAppPantalla("suite")} fontSans={fontSans} fontSerif={fontSerif} gold={T.gold} currentUser={currentUser} onVerTareas={(email)=>{ setTareasFoco((email||"").toLowerCase()); setAppPantalla("tareas"); }} onGenerarRecibo={irANominaDe} />
  );

  // Nómina (recibos ISR/IMSS) — módulo propio del sidebar. Antes entraba como una
  // pestaña dentro de Empleados: dos caminos para lo mismo, y el clic del sidebar
  // no reiniciaba nada. `trabajadorNomina` sólo viene lleno si el salto se hizo
  // desde la ficha de un trabajador; entrando por el sidebar llega en null.
  if (appPantalla === "recibos") return conShell(
    <div style={{minHeight:"100vh", background:T_LIGHT.canvas}}>
      {/* Mismo candado que traía al vivir dentro de Empleados: los recibos se
          guardan por usuario, así que sin cuenta no hay módulo. */}
      {!currentUser ? (
        <div style={{padding:"48px 24px", textAlign:"center" as const, fontFamily:fontSans}}>
          <h2 style={{fontFamily:fontSerif, fontSize:22, color:T_LIGHT.textInk, margin:"0 0 10px"}}>Necesitas una cuenta</h2>
          <p style={{fontSize:14, color:T_LIGHT.textInkSoft, margin:"0 0 20px"}}>Nómina guarda los recibos de tus trabajadores de forma segura. Crea una cuenta gratuita para usar este módulo.</p>
          <button onClick={() => setAppPantalla("suite")}
            style={{background:T.gold, border:"none", color:"#0B1829", borderRadius:10, padding:"12px 28px",
              cursor:"pointer", fontSize:14, fontWeight:700, fontFamily:fontSans}}>← Volver a la Suite</button>
        </div>
      ) : (
        <NominaInner
          fontSans={fontSans} fontSerif={fontSerif} gold={T.gold} currentUser={currentUser}
          trabajadorInicial={trabajadorNomina}
          onIrExpediente={() => irAModulo("empleados")}
        />
      )}
    </div>
  );

  if (appPantalla === "documentos") return conShell(
    <DocumentosModulo onBack={() => setAppPantalla("suite")} currentUser={currentUser} fontSans={fontSans} fontSerif={fontSerif} gold={T.gold} />
  );

  if (appPantalla === "calendario") return conShell(
    <CalendarioModulo onBack={() => setAppPantalla("suite")} fontSans={fontSans} fontSerif={fontSerif} gold={T.gold} currentUser={currentUser} />
  );


  if (appPantalla === "contratos") return conShell(
    <ContratosModulo user={currentUser} onBack={() => setAppPantalla("suite")} fontSans={fontSans} fontSerif={fontSerif} gold={T.gold} />
  );

  if (appPantalla === "nomina") return conShell(
    <NominaModulo onBack={() => setAppPantalla("suite")} onGoLanding={() => setAppPantalla("landing")} fontSans={fontSans} fontSerif={fontSerif} gold={T.gold} currentUser={currentUser} isProUser={isProUser} />
  );

  if (appPantalla === "obligaciones") return conShell(
    <ObligacionesModulo onBack={() => setAppPantalla("suite")} currentUser={currentUser} fontSans={fontSans} fontSerif={fontSerif} gold={T.gold} />
  );

  if (appPantalla === "flotilla") return conShell(
    <FlotillaModulo user={currentUser} onBack={() => setAppPantalla("suite")} fontSans={fontSans} fontSerif={fontSerif} gold={T.gold} filtroInicial={flotillaFiltro} vehiculoInicialId={flotillaVehiculoId} vehiculoInicialTab={flotillaVehiculoTab} foco={flotillaFoco} />
  );

  // PROVEEDORES, EN "PRÓXIMAMENTE". El módulo existía para validar contra el
  // 69-B: sin esa validación no le queda razón de ser, así que se retira entero.
  // `ProveedoresModulo` SIGUE EN EL ARCHIVO y sin tocar —no se borra código ni
  // datos—; volver a encenderlo es cambiar esta línea.
  if (appPantalla === "proveedores") return conShell(
    <ProximamenteValidacion69B que="Proveedores" onBack={() => setAppPantalla("suite")} fontSans={fontSans} fontSerif={fontSerif} gold={T.gold} />
  );

  // CLIENTES SÍ VUELVE. Su razón de ser es dar de alta clientes y pacientes con
  // sus datos, su expediente y sus contratos; el 69-B era accesorio. Lo que no
  // vuelve es esa validación: dentro del módulo se retiró el `fetch` y todo lo
  // que afirmaba la situación fiscal de un cliente. Lo guardado sigue guardado.
  if (appPantalla === "clientes") return conShell(
    <ClientesModulo user={currentUser} onBack={() => setAppPantalla("suite")} onGoContratos={() => setAppPantalla("contratos")} fontSans={fontSans} fontSerif={fontSerif} gold={T.gold} />
  );

  if (appPantalla === "acerca_de") return conShell(
    <AcercaDeScreen onBack={() => setAppPantalla("landing")} fontSans={fontSans} fontSerif={fontSerif} gold={T.gold} />
  );

  if (appPantalla === "creditos") return conShell(
    <CreditosModulo user={currentUser} onBack={() => setAppPantalla("suite")} onGoContratos={() => setAppPantalla("contratos")} fontSans={fontSans} fontSerif={fontSerif} gold={T.gold} deudorInicialId={creditoFoco?.deudorId||null} creditoInicialId={creditoFoco?.creditoId||null} />
  );

  if (appPantalla === "ayuda") return conShell(
    <AyudaManual fontSans={fontSans} fontSerif={fontSerif} gold={T.gold} />
  );

  if (appPantalla === "datos_empresa") return conShell(
    <PantallaDatosEmpresa currentUser={currentUser} fontSans={fontSans} fontSerif={fontSerif}
      onGuardado={()=>setNavToken(n=>n+1)} />
  );

  if (appPantalla === "cuentas_trab") return conShell(
    <CuentasTrabajadorPatron user={currentUser} fontSans={fontSans} fontSerif={fontSerif} gold={T.gold} />
  );

  if (appPantalla === "tareas") return conShell(
    <TareasPatron user={currentUser} foco={tareasFoco} tareaInicialId={tareaFocoId} fontSans={fontSans} fontSerif={fontSerif} gold={T.gold} />
  );

  if (appPantalla === "planes") return conShell(
    <PaginaPlanes
      onBack={() => setAppPantalla("landing")}
      onContratar={(planId) => {
        if (planId === "emprendedor") {
          // Si no hay sesión real, mandamos a login
          if (!currentUser || currentUser.isAnonymous) return setAppPantalla("login");
          return setAppPantalla("regulamx");
        }
        // Para PyME y Crecimiento: si ya es Pro, va a Suite; sino a login para crear cuenta
        if (currentUser && !currentUser.isAnonymous) return setAppPantalla("suite");
        return setAppPantalla("login");
      }}
      onCotizar={() => {
        // Plan Corporativo abre WhatsApp con mensaje
        const wa = "https://wa.me/524494251128?text=" + encodeURIComponent(
          "Hola AXIS, me interesa cotizar el Plan Corporativo de AXIS Legaltech. Mi empresa es ___ y tenemos ___ empleados aproximadamente."
        );
        window.open(wa, "_blank");
      }}
      fontSans={fontSans} fontSerif={fontSerif} gold={T.gold}
    />
  );

  // ── HOME ──────────────────────────────────────────────────────────────────
  if (!sectorActivo) return conShell(
    <div style={{fontFamily:fontSans, minHeight:"100vh", background:T_LIGHT.canvas, color:T_LIGHT.textInk}}>
      {/* CSS premium diagnóstico */}
      <style>{`
        @keyframes cardIn { from{opacity:0;transform:translateY(16px)} to{opacity:1;transform:translateY(0)} }
        .sec-card { animation:cardIn 0.4s ease forwards; opacity:0; }
        .sec-card:nth-child(1){animation-delay:0.04s}
        .sec-card:nth-child(2){animation-delay:0.08s}
        .sec-card:nth-child(3){animation-delay:0.12s}
        .sec-card:nth-child(4){animation-delay:0.16s}
        .sec-card:nth-child(5){animation-delay:0.20s}
        .sec-card:nth-child(6){animation-delay:0.24s}
        .sec-card:nth-child(7){animation-delay:0.28s}
        .sec-card:nth-child(8){animation-delay:0.32s}
        .sec-card:nth-child(9){animation-delay:0.36s}
        .sec-card:nth-child(10){animation-delay:0.40s}
        .sec-card:hover { transform:translateY(-5px) !important; box-shadow:0 16px 48px rgba(22,36,71,0.15) !important; }
        .sec-card { transition:transform 0.25s, box-shadow 0.25s; }
      `}</style>

      {/* Onboarding — primera visita. Se cierra por el botón, por la ✕ o
         pulsando fuera: es una bienvenida, no una puerta. */}
      {primeraVez === true && (
        <div onClick={cerrarOnboarding} style={{position:"fixed" as const, inset:0, background:"rgba(15,23,42,0.92)", zIndex:500, display:"flex", alignItems:"center", justifyContent:"center", padding:24}}>
          <div onClick={e=>e.stopPropagation()} style={{background:"white", borderRadius:20, padding:isMobile?"28px 22px":"40px 48px", maxWidth:520, width:"100%", textAlign:"center" as const, position:"relative" as const}}>
            <button onClick={cerrarOnboarding} aria-label="Cerrar"
              style={{position:"absolute" as const, top:10, right:12, width:34, height:34, borderRadius:10, border:"1px solid rgba(0,0,0,0.10)", background:"transparent", cursor:"pointer", fontSize:18, lineHeight:1, color:"#6B6B7B"}}>✕</button>
            <img src={logo} alt="AXIS" style={{height:56, mixBlendMode:"multiply" as any, marginBottom:20}} />
            {/* El título estaba en blanco sobre una tarjeta blanca: no se leía. */}
            <h2 style={{fontFamily:fontSerif, fontSize:isMobile?22:28, color:"#0B1829", margin:"0 0 12px"}}>Bienvenido al Diagnóstico Regulatorio</h2>
            <p style={{fontSize:14, color:"#4A4A60", lineHeight:1.7, margin:"0 0 24px"}}>
              La herramienta de diagnóstico regulatorio para empresas en Aguascalientes.<br/>
              Selecciona tu sector, revisa tus obligaciones y marca tu cumplimiento.<br/>
              <strong style={{color:"#B8932A"}}>Tu progreso se guarda automáticamente.</strong>
            </p>
            <div style={{display:"flex", flexDirection:"column" as const, gap:10, marginBottom:20}}>
              {[
                {icon:"📋", text:"Más de 260 regulaciones verificadas en 10 sectores"},
                {icon:"✅", text:"Marca tu cumplimiento con un solo clic"},
                {icon:"🚦", text:"Semáforo de riesgo al finalizar tu diagnóstico"},
                {icon:"📄", text:"Descarga tu reporte en PDF con datos de contacto"},
              ].map(item => (
                <div key={item.icon} style={{display:"flex", alignItems:"center", gap:10, padding:"8px 14px", background:"#F7F5F0", borderRadius:8, textAlign:"left" as const}}>
                  <span style={{fontSize:18}}>{item.icon}</span>
                  <span style={{fontSize:13, color:"#4A4A60"}}>{item.text}</span>
                </div>
              ))}
            </div>
            <button onClick={cerrarOnboarding}
              style={{width:"100%", background:"linear-gradient(135deg,#B8932A,#A07C30)", border:"none", borderRadius:12, padding:"14px 28px", cursor:"pointer", fontFamily:fontSans, fontSize:15, fontWeight:700, color:"white"}}>
              Comenzar diagnóstico →
            </button>
            <p style={{fontSize:11, color:"#9A9AAA", marginTop:12}}>by AXIS Legaltech · Aguascalientes</p>
          </div>
        </div>
      )}

      {/* Header navy interno removido — la marca y la navegación a Suite las da
         el sidebar (incluyendo "Iniciar sesión" cuando el usuario es anónimo). */}

      {/* Hero */}
      <div style={{maxWidth:960, margin:"0 auto", padding:isMobile?"20px 18px 36px":"40px 32px 48px", position:"relative" as const}}>

        {/* Banner de instalación PWA (componente reutilizable) */}
        <InstallBanner fontSerif={fontSerif} gold={T.gold} isMobile={isMobile} />


        <div style={{marginBottom:56}}>
          <div style={{display:"flex", alignItems:"center", gap:12, marginBottom:20}}>
            <div style={{height:1, width:40, background:`linear-gradient(90deg, transparent, ${T.gold})`}} />
            <span style={{fontSize:11, color:T.gold, letterSpacing:"2px", textTransform:"uppercase" as const}}>Aguascalientes, México · 2026</span>
          </div>
          <h1 style={{fontFamily:fontSerif, fontSize:isMobile?26:42, fontWeight:700, color:T_LIGHT.textInk, margin:"0 0 14px", lineHeight:1.15}}>
            Cumplimiento regulatorio<br/><span style={{color:T.gold}}>para empresas.</span>
          </h1>
          <p style={{fontSize:15, color:T_LIGHT.textInkSoft, margin:0, maxWidth:540, lineHeight:1.7}}>
            Diagnóstico completo de las obligaciones legales de tu empresa según sector y giro. Basado en el Censo Económico INEGI 2024 y legislación vigente.
          </p>
        </div>

        {/* ── PASOS VISUALES ── */}
        <div style={{marginBottom:isMobile?20:32, marginTop:isMobile?4:8}}>
          {isMobile ? (
            // Móvil: pasos compactos en fila
            <div style={{display:"flex", gap:0, background:T_LIGHT.cardLight, borderRadius:14,
              border:`1px solid ${T_LIGHT.borderCard}`, overflow:"hidden", boxShadow:T_LIGHT.shadow}}>
              {[
                {num:"1", label:"Tu industria", icon:"🏭", desc:"Elige tu sector"},
                {num:"2", label:"Especialidad", icon:"🎯", desc:"Afina tu giro"},
                {num:"3", label:"Tu checklist", icon:"✅", desc:"Marca c/obligación"},
                {num:"4", label:"Tu resultado", icon:"📊", desc:"Ve tu cumplimiento"},
              ].map((p,i) => (
                <div key={p.num} style={{flex:1, padding:"10px 4px", textAlign:"center" as const,
                  borderRight:i<3?`1px solid ${T_LIGHT.border}`:"none",
                  background:i===0?T_LIGHT.goldSoft:"transparent"}}>
                  <div style={{fontSize:16, marginBottom:2}}>{p.icon}</div>
                  <div style={{fontSize:9, fontWeight:700, color:i===0?T_LIGHT.gold:T_LIGHT.textInkSoft,
                    textTransform:"uppercase" as const, letterSpacing:"0.3px", lineHeight:1.3}}>{p.label}</div>
                  {i===0 && <div style={{width:20, height:2, background:T_LIGHT.gold, borderRadius:1, margin:"4px auto 0"}}/>}
                </div>
              ))}
            </div>
          ) : (
            // Desktop: pasos en línea conectados
            <div style={{display:"flex", alignItems:"center", gap:0, padding:"0 8px"}}>
              {[
                {num:"1", label:"Indica tu industria", icon:"🏭", sub:"Elige el sector de tu empresa", active:true},
                {num:"2", label:"Selecciona tu especialidad", icon:"🎯", sub:"Afina según tu giro específico", active:false},
                {num:"3", label:"Revisa cada obligación", icon:"✅", sub:"Marca si cumples o no cada punto", active:false},
                {num:"4", label:"Ve tu resultado", icon:"📊", sub:"Obtén tu porcentaje de cumplimiento", active:false},
              ].map((p,i) => (
                <div key={p.num} style={{display:"flex", alignItems:"center", flex:1}}>
                  <div style={{flex:1, background:p.active?T_LIGHT.goldSoft:T_LIGHT.cardLight,
                    borderRadius:12, padding:"14px 16px", border:`1px solid ${p.active?T_LIGHT.goldBorder:T_LIGHT.border}`,
                    boxShadow:p.active?"0 4px 16px rgba(184,147,42,0.18)":T_LIGHT.shadow}}>
                    <div style={{display:"flex", alignItems:"center", gap:10}}>
                      <div style={{width:32, height:32, borderRadius:10, flexShrink:0,
                        background:p.active?"linear-gradient(135deg,#B8932A,#D4A843)":T_LIGHT.canvasSoft,
                        display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <span style={{fontWeight:900, fontSize:13, color:p.active?"#0B1829":T_LIGHT.textInkMut}}>{p.num}</span>
                      </div>
                      <div>
                        <div style={{fontWeight:700, fontSize:13, color:p.active?T_LIGHT.textInk:T_LIGHT.textInkMut, lineHeight:1.2}}>
                          {p.icon} {p.label}
                        </div>
                        <div style={{fontSize:11, color:p.active?T_LIGHT.textInkSoft:T_LIGHT.textInkMut, marginTop:2}}>{p.sub}</div>
                      </div>
                    </div>
                  </div>
                  {i < 3 && <div style={{width:24, height:2, background:T_LIGHT.border, flexShrink:0}}/>}
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Etiqueta de acción */}
        <div style={{marginBottom:16, display:"flex", alignItems:"center", gap:10}}>
          <div style={{width:4, height:24, background:"linear-gradient(180deg,#B8932A,#D4A843)", borderRadius:2}}/>
          <div>
            <div style={{fontWeight:700, fontSize:isMobile?14:16, color:T_LIGHT.textInk}}>
              Paso 1 — ¿Cuál es tu industria?
            </div>
            <div style={{fontSize:12, color:T_LIGHT.textInkSoft, marginTop:2}}>
              Selecciona el sector que mejor describe la actividad principal de tu empresa
            </div>
          </div>
        </div>

        {/* Grid sectores */}
        <div className="anim-grid" style={{display:"grid",
          gridTemplateColumns:isMobile?"repeat(2,1fr)":isTablet?"repeat(3,1fr)":"repeat(4,1fr)",
          gap:isMobile?10:12}}>
          {SECTORES.map((s, i) => {
            const pct = progresoPorSector[s.id] ?? 0;
            const GRADS: Record<string,string> = {
              medico:"linear-gradient(135deg,#4A9EFF,#2563EB)",
              restaurante:"linear-gradient(135deg,#F5A623,#E8820C)",
              construccion:"linear-gradient(135deg,#F0C85A,#B8932A)",
              inmobiliario:"linear-gradient(135deg,#FC5C7D,#6A3093)",
              comercio:"linear-gradient(135deg,#43E97B,#38F9D7)",
              manufactura:"linear-gradient(135deg,#667EEA,#764BA2)",
              educacion:"linear-gradient(135deg,#F093FB,#F5576C)",
              transporte:"linear-gradient(135deg,#4FACFE,#00F2FE)",
              servicios:"linear-gradient(135deg,#A18CD1,#FBC2EB)",
              hoteleria:"linear-gradient(135deg,#11998E,#38EF7D)",
            };
            const grad = GRADS[s.id] || `linear-gradient(135deg,${s.color},${s.color}AA)`;
            return (
              <div key={s.id} className="lift-card" onClick={() => s.disponible && entrarSector(s.id)}
                style={{
                  background: grad,
                  borderRadius:isMobile?14:16,
                  padding:isMobile?"14px 12px":"18px 16px",
                  cursor:s.disponible?"pointer":"default",
                  position:"relative" as const, overflow:"hidden",
                  boxShadow:"0 4px 20px rgba(0,0,0,0.35)",
                  opacity:s.disponible?1:0.5,
                  animationDelay:`${i*0.06}s`, animationFillMode:"both",
                }}>
                {/* Brillo decorativo */}
                <div style={{position:"absolute" as const, top:-24, right:-24, width:80, height:80,
                  borderRadius:"50%", background:"rgba(255,255,255,0.18)", pointerEvents:"none" as const}}/>
                {/* Badge normas */}
                <div style={{position:"absolute" as const, top:10, right:10,
                  background:"rgba(255,255,255,0.2)", backdropFilter:"blur(4px)",
                  borderRadius:20, padding:"2px 8px",
                  fontSize:9, fontWeight:700, color:"white"}}>
                  {s.totalRegs} normas
                </div>
                {/* Icono AXIS (line-art con backdrop translúcido) */}
                <div style={{marginBottom:8, position:"relative" as const, zIndex:1}}>
                  <AxisIcon name={s.id} size={isMobile?38:44} tone="white" />
                </div>
                {/* Nombre */}
                <div style={{fontWeight:700, fontSize:isMobile?12:13, color:"white",
                  lineHeight:1.3, marginBottom:isMobile?6:8,
                  position:"relative" as const, zIndex:1,
                  textShadow:"0 1px 4px rgba(0,0,0,0.25)"}}>
                  {s.nombre}
                </div>
                {/* Progreso si tiene */}
                {pct > 0 && (
                  <div style={{position:"relative" as const, zIndex:1}}>
                    <div style={{height:3, background:"rgba(255,255,255,0.25)", borderRadius:2, overflow:"hidden", marginBottom:3}}>
                      <div style={{height:"100%", width:`${pct}%`, background:"white", borderRadius:2}}/>
                    </div>
                    <div style={{fontSize:10, color:"rgba(255,255,255,0.9)", fontWeight:700}}>{pct}% completado</div>
                  </div>
                )}
                {pct === 0 && (
                  <div style={{fontSize:10, color:"rgba(255,255,255,0.65)",
                    position:"relative" as const, zIndex:1}}>
                    {s.disponible ? "Iniciar diagnóstico →" : "Próximamente"}
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* Footer legal */}
        <div style={{marginTop:48, paddingTop:24, borderTop:`1px solid ${T_LIGHT.border}`, display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap" as const, gap:10}}>
          <div>
            <span style={{fontFamily:fontSerif, fontSize:14, color:T_LIGHT.gold}}>AXIS Asesoría Legal Corporativa</span>
            <span style={{fontSize:12, color:T_LIGHT.textInkMut, marginLeft:12}}>Aguascalientes, México</span>
          </div>
          <div style={{display:"flex", gap:12, alignItems:"center", flexWrap:"wrap" as const}}>
            <span style={{fontSize:11, color:T_LIGHT.textInkMut}}>© 2026 AXIS Legaltech · Todos los derechos reservados</span>
            <button onClick={()=>setModalLegal("disclaimer")} style={{background:"none",border:"none",fontSize:11,color:T_LIGHT.textInkMut,cursor:"pointer",textDecoration:"underline",padding:0}}>Aviso Legal</button>
            <button onClick={()=>setModalLegal("privacidad")} style={{background:"none",border:"none",fontSize:11,color:T_LIGHT.textInkMut,cursor:"pointer",textDecoration:"underline",padding:0}}>Privacidad</button>
          </div>
        </div>
      </div>

      {/* Modal Legal — home */}
      {modalLegal && <ModalLegal tipo={modalLegal} onClose={() => setModalLegal(null)} />}
      {/* Esta pantalla (el diagnóstico) monta su propio AXIOR, además del global.
          Con la MISMA condición que el global: sin haber pasado la puerta —un
          visitante sin sesión— no se pinta. */}
      {!ocultarAxior && <AxiorChat fontSans={fontSans} fontSerif={fontSerif} gold={T.gold} />}
    </div>
  );


  // ── PASO 2: Selección de especialidad ─────────────────────────────────────
  if (sectorActivo && pasoWizard === 2) {
    const espDisponibles = SECTOR_DATA[sectorActivo]?.especialidades ?? ["Todas"];
    const sInfo = SECTORES.find(s => s.id === sectorActivo) ?? SECTORES[0];
    // Paleta premium — cada especialidad tiene color único
    const PALETA = [
      {bg:"linear-gradient(135deg,#667EEA,#764BA2)", txt:"#F3F0FF", icon:"🔍"},
      {bg:"linear-gradient(135deg,#11998E,#38EF7D)", txt:"#F0FFF4", icon:"🏥"},
      {bg:"linear-gradient(135deg,#F093FB,#F5576C)", txt:"#FFF0F3", icon:"🔬"},
      {bg:"linear-gradient(135deg,#4FACFE,#00F2FE)", txt:"#F0F8FF", icon:"🦷"},
      {bg:"linear-gradient(135deg,#43E97B,#38F9D7)", txt:"#F0FFF8", icon:"👶"},
      {bg:"linear-gradient(135deg,#FA709A,#FEE140)", txt:"#FFFBF0", icon:"🧠"},
      {bg:"linear-gradient(135deg,#A18CD1,#FBC2EB)", txt:"#FDF0FF", icon:"🩻"},
      {bg:"linear-gradient(135deg,#FCCB90,#D57EEB)", txt:"#FFF5F0", icon:"💉"},
      {bg:"linear-gradient(135deg,#96FBC4,#F9F586)", txt:"#FFFFF0", icon:"🧪"},
      {bg:"linear-gradient(135deg,#F77062,#FE5196)", txt:"#FFF0F5", icon:"🫀"},
      {bg:"linear-gradient(135deg,#30CFD0,#330867)", txt:"#F0FFFE", icon:"📱"},
      {bg:"linear-gradient(135deg,#B8932A,#D4A843)", txt:"#FFFBF0", icon:"⭐"},
    ];
    return conShell(
      <div style={{minHeight:"100vh", background:T_LIGHT.canvas, fontFamily:fontSans}}>
        {/* Header navy */}
        <div style={{padding:"0 20px", display:"flex", alignItems:"center", height:58, gap:14, background:T.navy,
          borderBottom:"1px solid rgba(184,147,42,0.24)", boxShadow:"0 2px 16px rgba(22,36,71,0.12)"}}>
          <button onClick={() => { setSectorActivo(null); setPasoWizard(1); }}
            style={{background:"rgba(255,255,255,0.08)", border:"1px solid rgba(255,255,255,0.15)",
              color:"white", cursor:"pointer", fontSize:13, padding:"6px 14px",
              borderRadius:8, flexShrink:0}}>
            ← Industria
          </button>
          <SectorIcon id={sInfo.id} color={sInfo.color} size={18} />
          <span style={{fontFamily:fontSerif, fontSize:15, fontWeight:700, color:T.gold}}>{sInfo.nombre}</span>
        </div>

        {/* Barra de pasos */}
        <div style={{background:T_LIGHT.cardLight, borderBottom:`1px solid ${T_LIGHT.border}`,
          padding:"10px 20px"}}>
          <div style={{maxWidth:560, margin:"0 auto", display:"flex", alignItems:"center", gap:0}}>
            {[
              {num:1, txt:"Industria", done:true},
              {num:2, txt:"Especialidad", done:false, active:true},
              {num:3, txt:"Checklist", done:false},
              {num:4, txt:"Resultado", done:false},
            ].map((p,i) => (
              <div key={p.num} style={{display:"flex", alignItems:"center", flex:1}}>
                <div style={{display:"flex", alignItems:"center", gap:6}}>
                  <div style={{width:20, height:20, borderRadius:"50%", flexShrink:0,
                    background:p.done?T_LIGHT.gold:p.active?T_LIGHT.goldSoft:T_LIGHT.canvasSoft,
                    border:`1.5px solid ${p.done||p.active?T_LIGHT.gold:T_LIGHT.border}`,
                    display:"flex", alignItems:"center", justifyContent:"center"}}>
                    <span style={{fontSize:9, fontWeight:800,
                      color:p.done?"white":p.active?T_LIGHT.gold:T_LIGHT.textInkMut}}>{p.done?"✓":p.num}</span>
                  </div>
                  <span style={{fontSize:isMobile?9:11, fontWeight:p.done||p.active?700:500,
                    color:p.done?T_LIGHT.gold:p.active?T_LIGHT.textInk:T_LIGHT.textInkMut,
                    whiteSpace:"nowrap" as const, display:isMobile&&!p.active&&!p.done?"none":"inline"}}>
                    {p.txt}
                  </span>
                </div>
                {i<3 && <div style={{flex:1, height:1, background:T_LIGHT.border, margin:"0 6px"}}/>}
              </div>
            ))}
          </div>
        </div>

        <div style={{maxWidth:560, margin:"0 auto", padding:isMobile?"20px 16px":"32px 20px"}}>
          {/* Título */}
          <div style={{marginBottom:20}}>
            <div style={{fontWeight:700, fontSize:isMobile?18:22, color:T_LIGHT.textInk, marginBottom:4}}>
              ¿Cuál es tu especialidad?
            </div>
            <div style={{fontSize:13, color:T_LIGHT.textInkSoft}}>
              Elige tu giro específico para un diagnóstico preciso
            </div>
          </div>

          {/* Grid de especialidades — estilo premium con colores únicos */}
          <div style={{display:"grid", gridTemplateColumns:isMobile?"repeat(2,1fr)":"repeat(2,1fr)", gap:10, marginBottom:14}}>
            {espDisponibles.filter(e => e !== "Todas").map((esp, i) => {
              const p = PALETA[i % PALETA.length];
              return (
                <div key={esp}
                  onClick={() => { setEspecialidad(esp); setPasoWizard(3); }}
                  style={{
                    background:p.bg,
                    borderRadius:14, padding:isMobile?"14px 12px":"16px",
                    cursor:"pointer", position:"relative" as const, overflow:"hidden",
                    boxShadow:"0 4px 20px rgba(0,0,0,0.25)",
                    transition:"transform 0.25s cubic-bezier(0.34,1.56,0.64,1), box-shadow 0.2s",
                  }}
                  className="lift-card"
                >
                  {/* Brillo decorativo */}
                  <div style={{position:"absolute" as const, top:-20, right:-20, width:80, height:80,
                    borderRadius:"50%", background:"rgba(255,255,255,0.15)", pointerEvents:"none" as const}}/>
                  <div style={{fontWeight:700, fontSize:isMobile?12:13, color:"white",
                    lineHeight:1.3, position:"relative" as const, zIndex:1, textShadow:"0 1px 4px rgba(0,0,0,0.2)"}}>
                    {esp}
                  </div>
                  <div style={{marginTop:6, fontSize:10, color:"rgba(255,255,255,0.7)",
                    position:"relative" as const, zIndex:1}}>
                    Ver mi checklist →
                  </div>
                </div>
              );
            })}
          </div>

          {/* Opción ver todo */}
          <div onClick={() => { setEspecialidad("Todas"); setPasoWizard(3); }}
            style={{background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`,
              borderRadius:12, padding:"14px 18px", cursor:"pointer",
              display:"flex", justifyContent:"space-between", alignItems:"center",
              transition:"background 0.2s", boxShadow:T_LIGHT.shadow}}>
            <div>
              <div style={{fontWeight:600, fontSize:13, color:T_LIGHT.textInk}}>Ver todo el sector</div>
              <div style={{fontSize:11, color:T_LIGHT.textInkSoft, marginTop:2}}>
                Muestra todas las obligaciones sin filtrar por especialidad
              </div>
            </div>
            <span style={{fontSize:18, color:T_LIGHT.textInkMut}}>→</span>
          </div>
        </div>
      </div>
    );
  }


  // ── CHECKLIST ─────────────────────────────────────────────────────────────
  return conShell(
    <div style={{fontFamily:fontSans, minHeight:"100vh", background:T_LIGHT.canvas, color:T_LIGHT.textInk, display:"flex", flexDirection:"column" as const}}>
      {/* Header navy */}
      <div style={{borderBottom:"1px solid rgba(184,147,42,0.24)", padding:"0 20px", display:"flex", alignItems:"center", height:54, background:T.navy, gap:14, flexShrink:0, boxShadow:"0 2px 16px rgba(22,36,71,0.12)"}}>
        <button onClick={volverHome} style={{background:"rgba(255,255,255,0.08)", border:"1px solid rgba(255,255,255,0.15)", color:"white", cursor:"pointer", fontSize:14, padding:"5px 10px", borderRadius:6, display:"flex", alignItems:"center", gap:4}}>
          ← Inicio
        </button>
        <div style={{width:1, height:24, background:"rgba(255,255,255,0.15)"}} />
        <SectorIcon id={sectorInfo.id} color={sectorInfo.color} size={20} />
        <span style={{fontFamily:fontSerif, fontSize:16, fontWeight:700, color:T.gold}}>{isMobile?sectorInfo.nombre.split(" ")[0]+"…":sectorInfo.nombre}</span>
        <div style={{marginLeft:"auto", display:"flex", alignItems:"center", gap:8}}>
          {isMobile && (
            <button onClick={() => setDrawerOpen(true)}
              style={{background:"rgba(255,255,255,0.1)", border:"1px solid rgba(255,255,255,0.2)", color:"white", borderRadius:8, padding:"5px 10px", cursor:"pointer", fontSize:11, display:"flex", alignItems:"center", gap:4}}>
              <svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
              Filtros
            </button>
          )}
          {!isMobile && (
            <div style={{height:4, width:80, background:"rgba(255,255,255,0.15)", borderRadius:2, overflow:"hidden"}}>
              <div style={{height:"100%", width:`${stats.pct}%`, background:`linear-gradient(90deg,${sectorInfo.color},${T.gold})`, transition:"width 0.4s"}} />
            </div>
          )}
          <span style={{fontSize:12, color:T.gold, fontWeight:700}}>{stats.pct}%</span>
          <span style={{fontSize:9, color:"rgba(255,255,255,0.55)", opacity:0.85}}>● guardado</span>
        </div>
      </div>

      <div style={{display:"flex", flex:1, overflow:"hidden", position:"relative" as const}}>
        {/* Sidebar — colapsable "Filtros avanzados" sobre crema soft */}
        {!isMobile && filtrosAvanzados && <div style={{width:220, background:T_LIGHT.canvasSoft, borderRight:`1px solid ${T_LIGHT.border}`, padding:"20px 10px", overflowY:"auto" as const, flexShrink:0}}>
          <p style={{fontSize:9, color:T_LIGHT.textInkMut, textTransform:"uppercase" as const, letterSpacing:"1.5px", marginBottom:8, padding:"0 10px", fontWeight:700}}>Especialidad</p>
          {especialidades.map(esp => (
            <button key={esp} onClick={() => setEspecialidad(esp)}
              style={{width:"100%", textAlign:"left" as const, padding:"7px 10px", borderRadius:6, border:"none", cursor:"pointer", fontSize:12, marginBottom:2,
                background:especialidad===esp ? T_LIGHT.goldSoft : T_LIGHT.cardLight,
                color:especialidad===esp ? T.gold : T_LIGHT.textInkSoft,
                borderLeft:especialidad===esp ? "3px solid " + T.gold : "3px solid transparent",
                fontWeight: especialidad===esp ? 700 : 500}}>
              {esp}
            </button>
          ))}
          <div style={{height:1, background:T_LIGHT.border, margin:"16px 10px"}} />
          <p style={{fontSize:9, color:T_LIGHT.textInkMut, textTransform:"uppercase" as const, letterSpacing:"1.5px", marginBottom:8, padding:"0 10px", fontWeight:700}}>Nivel regulatorio</p>
          {[["todos","Todos"],["federal","Federal"],["estatal","Estatal"],["municipal","Municipal"],["nom_universal","NOMs Universales"],["nom_especialidad","NOMs Especialidad"],["nom_complementaria","NOMs Complementarias"],["laboral","Laboral"],["iso","ISO"]].filter(([k]) => k==="todos" || nivelesUsados.includes(k)).map(([key,label]) => (
            <button key={key} onClick={() => setNivelFiltro(key)}
              style={{width:"100%", textAlign:"left" as const, padding:"6px 10px", borderRadius:6, border:"none", cursor:"pointer", fontSize:11, marginBottom:2,
                background:nivelFiltro===key ? T_LIGHT.goldSoft : "transparent",
                color:nivelFiltro===key ? T.gold : T_LIGHT.textInkMut,
                borderLeft:nivelFiltro===key ? "3px solid " + T.gold : "3px solid transparent",
                fontWeight: nivelFiltro===key ? 700 : 500}}>
              {label}
            </button>
          ))}
        </div>}

        {/* Drawer mobile — filtros desde abajo */}
        {isMobile && drawerOpen && (
          <div onClick={() => setDrawerOpen(false)}
            style={{position:"fixed" as const, inset:0, background:"rgba(0,0,0,0.4)", zIndex:200}}>
            <div onClick={e => e.stopPropagation()}
              style={{position:"absolute" as const, bottom:0, left:0, right:0, background:T_LIGHT.cardLight, borderRadius:"20px 20px 0 0", padding:24, maxHeight:"70vh", overflowY:"auto" as const, boxShadow:"0 -8px 32px rgba(22,36,71,0.18)"}}>
              <div style={{width:40, height:4, borderRadius:2, background:T_LIGHT.border, margin:"0 auto 20px"}} />
              <p style={{fontSize:11, fontWeight:700, color:T_LIGHT.textInkMut, textTransform:"uppercase" as const, letterSpacing:"1px", marginBottom:10}}>Especialidad</p>
              <div style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap:6, marginBottom:20}}>
                {especialidades.map(esp => (
                  <button key={esp} onClick={() => { setEspecialidad(esp); setDrawerOpen(false); }}
                    style={{padding:"8px 10px", borderRadius:8, border:`1px solid ${especialidad===esp?T_LIGHT.goldBorder:T_LIGHT.border}`, cursor:"pointer", fontSize:12, textAlign:"left" as const,
                      background:especialidad===esp ? T_LIGHT.goldSoft : T_LIGHT.canvasSoft,
                      color:especialidad===esp ? T.gold : T_LIGHT.textInkSoft,
                      fontWeight:especialidad===esp ? 700 : 500}}>
                    {esp}
                  </button>
                ))}
              </div>
              <p style={{fontSize:11, fontWeight:700, color:T_LIGHT.textInkMut, textTransform:"uppercase" as const, letterSpacing:"1px", marginBottom:10}}>Nivel regulatorio</p>
              <div style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap:6}}>
                {[["todos","Todos"],["federal","Federal"],["estatal","Estatal"],["municipal","Municipal"],["nom_universal","NOMs Univ."],["nom_especialidad","NOMs Esp."],["nom_complementaria","NOMs Comp."],["laboral","Laboral"],["iso","ISO"]].filter(([k]) => k==="todos" || nivelesUsados.includes(k)).map(([key,label]) => (
                  <button key={key} onClick={() => { setNivelFiltro(key); setDrawerOpen(false); }}
                    style={{padding:"8px 10px", borderRadius:8, border:`1px solid ${nivelFiltro===key?T_LIGHT.goldBorder:T_LIGHT.border}`, cursor:"pointer", fontSize:12, textAlign:"left" as const,
                      background:nivelFiltro===key ? T_LIGHT.goldSoft : T_LIGHT.canvasSoft,
                      color:nivelFiltro===key ? T.gold : T_LIGHT.textInkMut,
                      fontWeight:nivelFiltro===key ? 700 : 500}}>
                    {label}
                  </button>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Main */}
        <div style={{flex:1, overflowY:"auto" as const, padding:isMobile?12:20, display:"flex", flexDirection:"column" as const, gap:12}}>

          {/* ── BÚHO — instrucciones de uso (se oculta al marcar 3+ items) ── */}
          {(() => {
            const marcados = Object.values(estados).filter(v => v !== "pendiente").length;
            if (marcados > 3) return null;
            return (
              <div style={{
                background:"linear-gradient(135deg,#162447 0%,#1B3358 100%)",
                borderRadius:16, padding:isMobile?"14px":"18px 20px",
                border:"1px solid rgba(184,147,42,0.25)",
                boxShadow:"0 4px 20px rgba(0,0,0,0.15)",
                display:"flex", alignItems:"flex-start", gap:14, position:"relative" as const,
              }}>
                {/* Búho */}
                <div style={{
                  width:isMobile?44:52, height:isMobile?44:52, flexShrink:0,
                  background:"linear-gradient(135deg,#B8932A,#D4A843)",
                  borderRadius:16, display:"flex", alignItems:"center",
                  justifyContent:"center", fontSize:isMobile?22:26,
                  boxShadow:"0 4px 16px rgba(184,147,42,0.4)",
                }}>
                  🦉
                </div>
                <div style={{flex:1}}>
                  <div style={{fontWeight:700, fontSize:isMobile?13:14, color:"#D4A843", marginBottom:6}}>
                    Lex, tu asistente legal
                  </div>
                  {isMobile ? (
                    <div style={{fontSize:12, color:"rgba(255,255,255,0.75)", lineHeight:1.7}}>
                      Ve cada punto de la lista y tócalo si ya lo tienes en tu empresa.<br/>
                      <span style={{color:"rgba(184,147,42,0.8)"}}>Al final verás tu resultado. ¡Puedes hacerlo!</span>
                    </div>
                  ) : (
                    <div style={{display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:10}}>
                      {[
                        {n:"1", icon:"📋", txt:"Lee cada licencia, permiso o norma que aparece abajo"},
                        {n:"2", icon:"✅", txt:"Tócala si ya la tienes o la cumples en tu empresa"},
                        {n:"3", icon:"📊", txt:"Al terminar obtendrás tu porcentaje de cumplimiento"},
                      ].map(s => (
                        <div key={s.n} style={{background:"rgba(255,255,255,0.06)",
                          borderRadius:10, padding:"10px 12px",
                          border:"1px solid rgba(255,255,255,0.08)"}}>
                          <div style={{display:"flex", alignItems:"center", gap:6, marginBottom:5}}>
                            <div style={{width:18, height:18, borderRadius:"50%",
                              background:"rgba(184,147,42,0.3)", border:"1px solid rgba(184,147,42,0.5)",
                              display:"flex", alignItems:"center", justifyContent:"center",
                              fontSize:9, fontWeight:800, color:"#D4A843"}}>
                              {s.n}
                            </div>
                            <span style={{fontSize:15}}>{s.icon}</span>
                          </div>
                          <p style={{margin:0, fontSize:12, color:"rgba(255,255,255,0.7)", lineHeight:1.5}}>{s.txt}</p>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                {/* Cierre manual */}
                <button onClick={() => {
                    // Forzar que se oculte marcando un estado temporal
                    setEstados(prev => ({...prev, "__tip_dismissed__":"cumplido"}));
                  }}
                  style={{position:"absolute" as const, top:10, right:10,
                    background:"rgba(255,255,255,0.08)", border:"none",
                    color:"rgba(255,255,255,0.4)", cursor:"pointer",
                    width:22, height:22, borderRadius:6, fontSize:12,
                    display:"flex", alignItems:"center", justifyContent:"center"}}>
                  ✕
                </button>
              </div>
            );
          })()}

          {/* Stats row */}
          <div style={{display:"grid", gridTemplateColumns:isMobile?"repeat(2,1fr)":"repeat(4,1fr)", gap:10}}>
            {[
              {label:"Total",     val:stats.total,      color:sectorInfo.color},
              {label:"Cumplidas", val:stats.cumplidas,  color:"#10B981"},
              {label:"Pendientes",val:stats.pendientes, color:"#EF4444"},
              {label:"Avance",    val:stats.pct + "%",  color:stats.pct>=80?"#10B981":stats.pct>=40?"#F59E0B":"#EF4444"},
            ].map(s => (
              <div key={s.label} style={{background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:10, padding:"12px 16px", boxShadow:T_LIGHT.shadow, borderLeft:`3px solid ${s.color}`}}>
                <p style={{fontSize:11, color:T_LIGHT.textInkMut, margin:"0 0 6px", textTransform:"uppercase" as const, letterSpacing:"0.5px", fontWeight:700}}>{s.label}</p>
                <p style={{fontSize:26, fontWeight:700, color:s.color, margin:0, fontFamily:fontSerif}}>{s.val}</p>
              </div>
            ))}
          </div>

          {/* Barra de progreso */}
          <div style={{background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:10, padding:"14px 18px", boxShadow:T_LIGHT.shadow}}>
            <div style={{display:"flex", justifyContent:"space-between", fontSize:12, color:T_LIGHT.textInkSoft, marginBottom:10}}>
              <span>Progreso de cumplimiento regulatorio</span>
              <span style={{color:T.gold, fontWeight:700, fontFamily:fontSerif, fontSize:14}}>{stats.pct}%</span>
            </div>
            <div style={{height:6, background:T_LIGHT.canvasSoft, borderRadius:3, overflow:"hidden"}}>
              <div style={{height:"100%", width:`${stats.pct}%`, background:`linear-gradient(90deg,${sectorInfo.color},${T.gold})`, borderRadius:3, transition:"width 0.5s ease"}} />
            </div>
          </div>

          {/* Resumen por nivel */}
          {!isMobile && (
            <div style={{display:"flex", gap:8, flexWrap:"wrap" as const}}>
              {NIVEL_ORDEN.filter(n => n !== "marco" && porNivel[n]).map(nivel => {
                const regsNivel = porNivel[nivel] || [];
                const cumplNivel = regsNivel.filter(r => (estados[r.id]??"pendiente") === "cumplido").length;
                const pctNivel = regsNivel.length > 0 ? Math.round((cumplNivel/regsNivel.length)*100) : 0;
                const colorNivel = pctNivel>=80?"#059669":pctNivel>=40?"#D97706":"#DC2626";
                return (
                  <button key={nivel} onClick={() => setNivelFiltro(nivelFiltro===nivel?"todos":nivel)}
                    style={{display:"flex", alignItems:"center", gap:6, padding:"6px 10px", borderRadius:8, border:"1px solid " + (nivelFiltro===nivel?T.goldBorder:T_LIGHT.border), background:nivelFiltro===nivel?T_LIGHT.goldSoft:T_LIGHT.cardLight, cursor:"pointer", boxShadow:T_LIGHT.shadow}}>
                    <span style={{fontSize:11}}>{NIVEL_ICONS[nivel]}</span>
                    <div>
                      <div style={{fontSize:10, color:T_LIGHT.textInkMut, marginBottom:2, fontWeight:600}}>{NIVEL_LABELS[nivel].replace("Marco ","").replace("NOMs ","").replace("Obligaciones ","")}</div>
                      <div style={{height:3, width:50, background:T_LIGHT.canvasSoft, borderRadius:2}}>
                        <div style={{height:"100%", width:`${pctNivel}%`, background:colorNivel, borderRadius:2}} />
                      </div>
                    </div>
                    <span style={{fontSize:10, fontWeight:700, color:colorNivel}}>{pctNivel}%</span>
                  </button>
                );
              })}
            </div>
          )}

          {/* Búsqueda */}
          <div style={{display:"flex", gap:8, alignItems:"center", flexWrap:isMobile?"wrap" as const:"nowrap"}}>
            <div style={{position:"relative" as const, flex:1}}>
              <svg style={{position:"absolute" as const, left:12, top:"50%", transform:"translateY(-50%)", color:T_LIGHT.textInkMut}} width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>
              <input {...CAMPO_DE_PARAMETRO} value={busqueda} onChange={e=>setBusqueda(e.target.value)} placeholder="Buscar por clave o título..."
                style={{width:"100%", padding:"9px 12px 9px 34px", background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:8, fontSize:13, outline:"none", boxSizing:"border-box" as const, color:T_LIGHT.textInk, fontFamily:fontSans, boxShadow:T_LIGHT.shadow}} />
            </div>
            <button onClick={() => setSoloPendientes(!soloPendientes)}
              style={{
                padding:"9px 14px", borderRadius:8, fontSize:12, fontWeight:600, cursor:"pointer",
                fontFamily:fontSans, whiteSpace:"nowrap" as const, display:"flex", alignItems:"center", gap:6,
                background: soloPendientes ? "#DC2626" : T_LIGHT.cardLight,
                color: soloPendientes ? "white" : T_LIGHT.textInkSoft,
                border: soloPendientes ? "1px solid #DC2626" : `1px solid ${T_LIGHT.border}`,
                transition:"all 0.2s",
              }}>
              <svg width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                {soloPendientes ? <><circle cx="12" cy="12" r="10"/><path d="m15 9-6 6M9 9l6 6"/></> : <path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z"/>}
              </svg>
              {soloPendientes ? "Ver todas" : "Pendientes"}
            </button>
            <button onClick={() => setVistaCompacta(!vistaCompacta)}
              title={vistaCompacta ? "Vista detallada" : "Vista compacta"}
              style={{
                padding:"9px 14px", borderRadius:8, fontSize:12, fontWeight:600, cursor:"pointer",
                fontFamily:fontSans, whiteSpace:"nowrap" as const, display:"flex", alignItems:"center", gap:6,
                background: vistaCompacta ? T.gold : T_LIGHT.cardLight,
                color: vistaCompacta ? "white" : T_LIGHT.textInkSoft,
                border: vistaCompacta ? `1px solid ${T.gold}` : `1px solid ${T_LIGHT.border}`,
                transition:"all 0.2s",
              }}>
              {vistaCompacta
                ? <svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
                : <svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="16" y2="12"/><line x1="3" y1="18" x2="11" y2="18"/></svg>}
              {vistaCompacta ? "Detallada" : "Compacta"}
            </button>
          </div>

          {/* Lista por nivel */}
          {/* Marco Legal — sección colapsable de referencia */}
          {marcoRegs.length > 0 && (
            <MarcoLegalSection regs={marcoRegs} border={T.border} gold={T.gold} textMut={T.textMut} textSec={T.textSec} textPrim={T.textPrim} bgCard={T.bgCard} fontSerif={fontSerif} fontSans={fontSans} />
          )}

          {/* Checklist accionable — todos los niveles excepto marco */}
          {NIVEL_ORDEN.filter(n => n !== "marco" && porNivel[n]).map(nivel => (
            <div key={nivel}>
              <div style={{display:"flex", alignItems:"center", gap:10, marginBottom:10, paddingBottom:8, borderBottom:`1px solid ${T_LIGHT.border}`}}>
                <span style={{fontSize:14}}>{NIVEL_ICONS[nivel]}</span>
                <span style={{fontSize:12, fontWeight:700, color:T.gold, textTransform:"uppercase" as const, letterSpacing:"1px"}}>{NIVEL_LABELS[nivel]}</span>
                <span style={{fontSize:11, color:T_LIGHT.textInkMut, marginLeft:"auto"}}>{porNivel[nivel].length} regulaciones</span>
              </div>
              {porNivel[nivel].map(r => {
                const est = getEstado(r.id);
                const ec  = ESTADO_CFG[est];
                const sel = seleccionado === r.id;
                return (
                  <React.Fragment key={r.id}>
                  {vistaCompacta ? (
                    <div key={r.id}
                      style={{background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.borderCard}`, borderRadius:8, padding:"7px 12px", marginBottom:3, display:"flex", alignItems:"center", gap:10, opacity:est==="cumplido"?0.65:1, transition:"all 0.15s", boxShadow:T_LIGHT.shadow}}>
                      <button onClick={e=>{e.stopPropagation();setEstadoDirecto(r.id,est==="cumplido"?"pendiente":"cumplido");}}
                        style={{width:22,height:22,borderRadius:"50%",flexShrink:0,border:est==="cumplido"?"2px solid #059669":"2px solid #CBD5E1",background:est==="cumplido"?"#059669":"transparent",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",transition:"all 0.2s"}}>
                        {est==="cumplido" && <svg width="11" height="11" fill="none" stroke="white" strokeWidth="3" viewBox="0 0 24 24"><path d="M20 6 9 17l-5-5"/></svg>}
                      </button>
                      <span style={{fontSize:10,fontWeight:700,color:T.gold,flexShrink:0,width:110,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap" as const}}>{r.clave}</span>
                      <span style={{fontSize:12,color:est==="cumplido"?T_LIGHT.textInkMut:T_LIGHT.textInk,flex:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap" as const}}>{r.titulo}</span>
                      {r.obligatorio && <span style={{fontSize:9,color:"#DC2626",flexShrink:0,fontWeight:700}}>OBL</span>}
                    </div>
                  ) : (
                    <div key={r.id} onClick={() => setSeleccionado(sel?null:r.id)}
                      style={{background:sel?T_LIGHT.goldSoft:T_LIGHT.cardLight,border:"1px solid "+(sel?T.goldBorder:T_LIGHT.border),boxShadow:sel?"0 4px 16px rgba(184,147,42,0.16)":T_LIGHT.shadow,borderRadius:10,padding:"12px 14px",cursor:"pointer",display:"flex",alignItems:"flex-start",gap:12,marginBottom:6}}>
                      <button onClick={e=>{e.stopPropagation();setEstadoDirecto(r.id,est==="cumplido"?"pendiente":"cumplido");}}
                        title={est==="cumplido"?"Marcar como pendiente":"Marcar como cumplido"}
                        style={{width:28,height:28,borderRadius:"50%",flexShrink:0,marginTop:1,border:est==="cumplido"?"2px solid #059669":"2px solid #CBD5E1",background:est==="cumplido"?"#059669":"transparent",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",transition:"all 0.2s",boxShadow:est==="cumplido"?"0 0 8px rgba(5,150,105,0.3)":"none"}}>
                        {est==="cumplido"
                          ? <svg width="14" height="14" fill="none" stroke="white" strokeWidth="3" viewBox="0 0 24 24"><path d="M20 6 9 17l-5-5"/></svg>
                          : <div style={{width:8,height:8,borderRadius:"50%",border:"2px solid #CBD5E1"}} />}
                      </button>
                      <div style={{flex:1,minWidth:0}}>
                        <div style={{display:"flex",alignItems:"center",gap:6,flexWrap:"wrap" as const,marginBottom:4}}>
                          <span style={{fontSize:10,fontWeight:700,color:T.gold}}>{r.clave}</span>
                          {r.nuevo && <span style={{fontSize:9,background:T_LIGHT.goldSoft,color:T.gold,padding:"2px 7px",borderRadius:10,border:`1px solid ${T_LIGHT.goldBorder}`,fontWeight:700}}>✦ NUEVO 2025</span>}
                          {r.obligatorio
                            ? <span style={{fontSize:9,background:"rgba(220,38,38,0.08)",color:"#DC2626",padding:"2px 7px",borderRadius:10,border:"1px solid rgba(220,38,38,0.25)",fontWeight:700}}>OBLIGATORIO</span>
                            : <span style={{fontSize:9,background:T_LIGHT.canvasSoft,color:T_LIGHT.textInkMut,padding:"2px 7px",borderRadius:10,fontWeight:700,border:`1px solid ${T_LIGHT.borderCard}`}}>RECOMENDADO</span>}
                          <span style={{fontSize:9,background:ec.bg,color:ec.color,padding:"2px 7px",borderRadius:10,fontWeight:700,marginLeft:"auto"}}>{ec.label.toUpperCase()}</span>
                        </div>
                        <p style={{margin:0,fontSize:13,color:T_LIGHT.textInk,lineHeight:1.4}}>{r.titulo}</p>
                        {sel && (
                          <div style={{marginTop:12,paddingTop:12,borderTop:`1px solid ${T_LIGHT.border}`}}>
                            <p style={{fontSize:12,color:T_LIGHT.textInkSoft,lineHeight:1.75,margin:"0 0 10px"}}>{r.descripcion}</p>
                            <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:12}}>
                              <span style={{fontSize:10,color:T_LIGHT.textInkMut,textTransform:"uppercase" as const,letterSpacing:"0.5px", fontWeight:700}}>Autoridad:</span>
                              <span style={{fontSize:11,color:T.gold,fontWeight:700}}>{r.autoridad}</span>
                            </div>
                            <div style={{display:"flex",gap:10}}>
                              <button onClick={ev=>{ev.stopPropagation();setEstadoDirecto(r.id,"cumplido");}} style={{padding:"8px 20px",fontSize:12,borderRadius:8,border:"2px solid #059669",background:getEstado(r.id)==="cumplido"?"#059669":"transparent",color:getEstado(r.id)==="cumplido"?"white":"#059669",cursor:"pointer",fontWeight:600,display:"flex",alignItems:"center",gap:6}}>
                                <svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24"><path d="M20 6 9 17l-5-5"/></svg>Cumplido
                              </button>
                              <button onClick={ev=>{ev.stopPropagation();setEstadoDirecto(r.id,"pendiente");}} style={{padding:"8px 20px",fontSize:12,borderRadius:8,border:"2px solid #CBD5E1",background:getEstado(r.id)==="pendiente"?"#9A9AAA":"transparent",color:getEstado(r.id)==="pendiente"?"white":"#9A9AAA",cursor:"pointer",fontWeight:600}}>
                                Pendiente
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  </React.Fragment>
                );
              })}
            </div>
          ))}

          {filtradas.length === 0 && (
            <div style={{textAlign:"center" as const, padding:"60px 20px", background:T_LIGHT.cardLight, borderRadius:14, border:`1px dashed ${T_LIGHT.border}`}}>
              <p style={{color:T_LIGHT.textInkSoft, fontSize:14, margin:0}}>No se encontraron regulaciones con los filtros seleccionados.</p>
            </div>
          )}

          {/* ── SEMÁFORO DE CUMPLIMIENTO ── */}
          {filtradas.length > 0 && (
            <div style={{marginTop:24, border:`1px solid ${stats.pct>=80?'rgba(16,185,129,0.3)':stats.pct>=40?'rgba(245,158,11,0.3)':'rgba(239,68,68,0.3)'}`, borderRadius:16, padding:"28px 32px", background:stats.pct>=80?'rgba(16,185,129,0.05)':stats.pct>=40?'rgba(245,158,11,0.05)':'rgba(239,68,68,0.05)', textAlign:"center" as const}}>
              <div style={{marginBottom:16, display:"flex", justifyContent:"center"}}>
                <div style={{
                  width:72, height:72, borderRadius:"50%",
                  background:stats.pct>=80?"#10B981":stats.pct>=40?"#F59E0B":"#EF4444",
                  boxShadow:`0 0 32px ${stats.pct>=80?'rgba(16,185,129,0.4)':stats.pct>=40?'rgba(245,158,11,0.4)':'rgba(239,68,68,0.4)'}`,
                  display:"flex", alignItems:"center", justifyContent:"center",
                }}>
                  <AxisIcon name={stats.pct>=80?"check":stats.pct>=40?"alert":"x"} size={38} tone="white" withBackdrop={false} strokeWidth={4}/>
                </div>
              </div>
              <div style={{fontFamily:fontSerif, fontSize:28, fontWeight:700, color:stats.pct>=80?"#10B981":stats.pct>=40?"#F59E0B":"#EF4444", marginBottom:8}}>
                {stats.pct>=80?"En regla":stats.pct>=40?"Requiere atención":"Atención urgente"}
              </div>
              <div style={{fontSize:14, color:T_LIGHT.textInkSoft, marginBottom:20}}>
                {stats.pct>=80
                  ? "Tu empresa tiene un nivel de cumplimiento regulatorio óptimo. Mantén actualizados tus registros y renovaciones periódicas."
                  : stats.pct>=40
                  ? "Tienes obligaciones regulatorias pendientes que deben atenderse próximamente para evitar sanciones."
                  : "Existen obligaciones críticas sin cumplir que representan un riesgo legal y económico para tu empresa."}
              </div>
              <div style={{display:"flex", justifyContent:"center", gap:isMobile?16:32, marginBottom:24}}>
                {[
                  {label:"Cumplidas", val:stats.cumplidas, color:"#10B981"},
                  {label:"Pendientes", val:stats.pendientes, color:"#EF4444"},
                  {label:"Avance", val:stats.pct+"%", color:stats.pct>=80?"#10B981":stats.pct>=40?"#F59E0B":"#EF4444"},
                ].map(s => (
                  <div key={s.label} style={{textAlign:"center" as const}}>
                    <div style={{fontFamily:fontSerif, fontSize:32, fontWeight:700, color:s.color}}>{s.val}</div>
                    <div style={{fontSize:11, color:T_LIGHT.textInkMut, textTransform:"uppercase" as const, letterSpacing:"1px", fontWeight:700}}>{s.label}</div>
                  </div>
                ))}
              </div>
              <div style={{display:"flex", gap:12, justifyContent:"center", flexWrap:"wrap" as const}}>
                <button onClick={() => setModalContacto(true)}
                  style={{background:`linear-gradient(135deg, ${T.gold}, #A07C30)`, border:"none", borderRadius:10, padding:"12px 24px", cursor:"pointer", fontFamily:fontSans, fontSize:13, fontWeight:700, color:"#0A0A0A", display:"inline-flex", alignItems:"center", gap:8}}>
                  <AxisIcon name="scale_simple" size={15} tone="white" withBackdrop={false} strokeWidth={3}/>
                  Solicitar diagnóstico con AXIS Abogados
                </button>
                <button onClick={() => setModalCorreoPDF(true)}
                  style={{background:"transparent", border:`2px solid ${T.gold}`, borderRadius:10, padding:"12px 24px", cursor:"pointer", fontFamily:fontSans, fontSize:13, fontWeight:700, color:T.gold, display:"inline-flex", alignItems:"center", gap:8}}>
                  <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
                  Obtener reporte PDF
                </button>
              </div>
            </div>
          )}

          {/* ── LLAMADO A LA CONSULTA ── al cierre del listado, dentro del flujo.
               Antes era un flotante que perseguía al usuario y se peleaba la
               esquina con el búho: es un llamado de ESTA pantalla, no global. */}
          {sectorActivo && (
            <div style={{marginTop:18, background:T_LIGHT.cardLight, border:`1px solid ${T_LIGHT.goldBorder}`,
              borderRadius:14, padding:isMobile?"16px":"18px 22px", display:"flex", alignItems:"center",
              gap:14, flexWrap:"wrap" as const, boxShadow:"0 2px 14px rgba(22,36,71,0.06)"}}>
              <div style={{width:38, height:38, borderRadius:10, flexShrink:0, background:T_LIGHT.goldSoft,
                border:`1px solid ${T_LIGHT.goldBorder}`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:18}}>⚖️</div>
              <div style={{flex:1, minWidth:220}}>
                <div style={{fontFamily:fontSerif, fontSize:15, fontWeight:700, color:T_LIGHT.textInk}}>¿Necesitas ayuda para cumplir?</div>
                <div style={{fontSize:12, color:T_LIGHT.textInkSoft, marginTop:2}}>Consulta gratuita con AXIS Abogados</div>
              </div>
              <button onClick={() => setModalContacto(true)}
                style={{background:`linear-gradient(135deg, ${T.gold}, #A07C30)`, border:"none", borderRadius:10,
                  padding:"11px 20px", cursor:"pointer", fontFamily:fontSans, fontSize:13, fontWeight:700,
                  color:"#0A0A0A", whiteSpace:"nowrap" as const, boxShadow:"0 2px 12px rgba(201,168,76,0.32)"}}>
                Solicitar consulta
              </button>
            </div>
          )}

          {/* Footer */}
          <div style={{marginTop:16, paddingTop:16, borderTop:`1px solid ${T_LIGHT.border}`, display:"flex", justifyContent:"center", flexWrap:"wrap" as const, gap:8}}>
            <div style={{display:"flex", gap:16, alignItems:"center", flexWrap:"wrap" as const, justifyContent:"center"}}>
              <span style={{fontFamily:fontSerif, fontSize:13, color:T_LIGHT.textInkSoft}}>Diagnóstico Regulatorio · <span style={{color:T.gold, fontWeight:700}}>by AXIS Legaltech</span></span>
              <button onClick={()=>setModalLegal("disclaimer")} style={{background:"none",border:"none",fontSize:11,color:T_LIGHT.textInkMut,cursor:"pointer",textDecoration:"underline",padding:0}}>Aviso Legal</button>
              <button onClick={()=>setModalLegal("privacidad")} style={{background:"none",border:"none",fontSize:11,color:T_LIGHT.textInkMut,cursor:"pointer",textDecoration:"underline",padding:0}}>Privacidad</button>
              <span style={{fontSize:11,color:T_LIGHT.textInkMut}}>© 2026 AXIS · Todos los derechos reservados</span>
            </div>
            <button onClick={() => {
              if (window.confirm("¿Reiniciar todo el progreso de este sector?")) {
                const newEstados = {...estados};
                regsActivas.forEach(r => delete newEstados[r.id]);
                setEstados(newEstados);
              }
            }} style={{background:"transparent", border:"none", fontSize:11, color:T_LIGHT.textInkMut, cursor:"pointer", textDecoration:"underline"}}>
              Reiniciar progreso
            </button>
          </div>
        </div>
      </div>

      {/* El llamado a la consulta ya no flota: vive al cierre del listado. */}

      {/* ── MODAL DE CONTACTO AXIS ── */}
      {modalContacto && sectorActivo && (() => {
        // Paleta para fondo claro (T.* está calibrado para fondo oscuro)
        const M = {
          bg: "#FFFFFF",
          bgSoft: "#FAF6E8",
          textPrim: "#0B1829",      // Navy AXIS para títulos
          textSec: "#4A4A60",       // Gris azulado para texto normal
          textMut: "#8B8B95",       // Gris medio para labels/muted
          gold: "#B8932A",          // Dorado oscuro (contrasta sobre blanco)
          goldDark: "#8C6F1F",      // Dorado más oscuro para acentos importantes
          border: "rgba(0,0,0,0.08)",
          borderGold: "rgba(184,147,42,0.25)",
        };
        return (
          <div
            style={{position:"fixed" as const, inset:0, background:"rgba(0,0,0,0.75)", zIndex:300, display:"flex", alignItems:"center", justifyContent:"center", padding:20, backdropFilter:"blur(6px)"}}>
            <div {...PANEL_DE_CAPTURA} onClick={e => e.stopPropagation()}
              style={{background:M.bg, border:`1px solid ${M.borderGold}`, borderRadius:18, width:"100%", maxWidth:520, maxHeight:"90vh", overflowY:"auto" as const, boxShadow:"0 20px 60px rgba(0,0,0,0.3)"}}>

              {/* Header del modal */}
              <div style={{padding:"24px 28px 20px", borderBottom:`1px solid ${M.border}`}}>
                <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:16}}>
                  <div style={{display:"flex", alignItems:"center", gap:12}}>
                    <div style={{width:42, height:42, borderRadius:10, background:"rgba(184,147,42,0.12)", border:`1px solid ${M.borderGold}`, display:"flex", alignItems:"center", justifyContent:"center"}}>
                      <AxisIcon name="scale_simple" size={22} tone="gold" withBackdrop={false} strokeWidth={3}/>
                    </div>
                    <div>
                      <div style={{fontFamily:fontSerif, fontSize:18, fontWeight:700, color:M.textPrim}}>AXIS Abogados</div>
                      <div style={{fontSize:11, color:M.textMut}}>Asesoría Legal Corporativa · Aguascalientes</div>
                    </div>
                  </div>
                  <button onClick={(ev)=>{ if (sePuedeCerrarElPanel(ev)) setModalContacto(false); }}
                    style={{background:"transparent", border:`1px solid ${M.border}`, color:M.textMut, cursor:"pointer", borderRadius:6, width:30, height:30, display:"flex", alignItems:"center", justifyContent:"center", fontSize:18, lineHeight:1}}>
                    ×
                  </button>
                </div>
                <p style={{fontSize:13, color:M.textSec, margin:0, lineHeight:1.6}}>
                  Solicita una <strong style={{color:M.goldDark}}>consulta gratuita</strong>. Uno de nuestros abogados especialistas revisará tu situación regulatoria y te orientará sobre los pasos a seguir.
                </p>
              </div>

              {/* Diagnóstico automático */}
              <div style={{margin:"20px 28px", background:M.bgSoft, border:`1px solid ${M.borderGold}`, borderRadius:12, padding:16}}>
                <div style={{fontSize:10, color:M.gold, textTransform:"uppercase" as const, letterSpacing:"1px", marginBottom:12, fontWeight:700}}>Tu diagnóstico regulatorio</div>
                <div style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:12}}>
                  <div style={{background:"rgba(255,255,255,0.7)", borderRadius:8, padding:"10px 12px", border:"1px solid rgba(0,0,0,0.06)"}}>
                    <div style={{fontSize:10, color:M.textMut, marginBottom:4, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>Sector</div>
                    <div style={{fontSize:13, color:M.textPrim, fontWeight:600}}>{sectorInfo.icon} {sectorInfo.nombre}</div>
                  </div>
                  <div style={{background:"rgba(255,255,255,0.7)", borderRadius:8, padding:"10px 12px", border:"1px solid rgba(0,0,0,0.06)"}}>
                    <div style={{fontSize:10, color:M.textMut, marginBottom:4, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>Especialidad</div>
                    <div style={{fontSize:13, color:M.textPrim, fontWeight:600}}>{especialidad}</div>
                  </div>
                  <div style={{background:"rgba(239,68,68,0.08)", border:"1px solid rgba(239,68,68,0.25)", borderRadius:8, padding:"10px 12px"}}>
                    <div style={{fontSize:10, color:"#B91C1C", marginBottom:4, textTransform:"uppercase" as const, letterSpacing:"0.5px", fontWeight:600}}>Pendientes</div>
                    <div style={{fontSize:22, color:"#B91C1C", fontWeight:700, fontFamily:fontSerif}}>{totalPend}</div>
                  </div>
                  <div style={{background:"rgba(16,185,129,0.08)", border:"1px solid rgba(16,185,129,0.25)", borderRadius:8, padding:"10px 12px"}}>
                    <div style={{fontSize:10, color:"#047857", marginBottom:4, textTransform:"uppercase" as const, letterSpacing:"0.5px", fontWeight:600}}>Cumplidas</div>
                    <div style={{fontSize:22, color:"#047857", fontWeight:700, fontFamily:fontSerif}}>{totalCump}</div>
                  </div>
                </div>
                {pendientesOblig.length > 0 && (
                  <div>
                    <div style={{fontSize:10, color:M.textMut, marginBottom:8, textTransform:"uppercase" as const, letterSpacing:"0.5px", fontWeight:600}}>Principales obligaciones pendientes:</div>
                    {pendientesOblig.map(r => (
                      <div key={r.id} style={{display:"flex", alignItems:"flex-start", gap:8, marginBottom:6}}>
                        <span style={{fontSize:9, background:"rgba(239,68,68,0.15)", color:"#B91C1C", padding:"2px 6px", borderRadius:4, fontWeight:700, flexShrink:0, marginTop:1, letterSpacing:"0.3px"}}>OBL</span>
                        <span style={{fontSize:12, color:M.textSec, lineHeight:1.4}}><strong style={{color:M.textPrim}}>{r.clave}</strong> — {r.titulo}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Formulario */}
              <div style={{padding:"0 28px 28px"}}>
                <div style={{fontSize:11, color:M.textMut, textTransform:"uppercase" as const, letterSpacing:"1px", marginBottom:14, fontWeight:600}}>Tus datos de contacto</div>
                <div style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:10}}>
                  {[
                    {label:"Nombre completo", val:formNombre, set:setFormNombre, placeholder:"Lic. Juan Pérez"},
                    {label:"Empresa / Negocio", val:formEmpresa, set:setFormEmpresa, placeholder:"Mi Empresa SA de CV"},
                    {label:"Teléfono / WhatsApp", val:formTel, set:setFormTel, placeholder:"449 123 4567"},
                    {label:"Correo electrónico", val:formEmail, set:setFormEmail, placeholder:"juan@empresa.mx"},
                  ].map(f => (
                    <div key={f.label}>
                      <div style={{fontSize:10, color:M.textMut, marginBottom:5, textTransform:"uppercase" as const, letterSpacing:"0.5px", fontWeight:600}}>{f.label}</div>
                      <input value={f.val} onChange={e => f.set(e.target.value)} placeholder={f.placeholder}
                        style={{width:"100%", background:"#F7F5F0", border:"1px solid rgba(0,0,0,0.12)", borderRadius:8, padding:"9px 12px", fontSize:13, color:M.textPrim, fontFamily:fontSans, outline:"none", boxSizing:"border-box" as const}} />
                    </div>
                  ))}
                </div>

                {/* Botones de contacto */}
                <div style={{display:"flex", gap:10, marginTop:18}}>
                  <a href={`https://wa.me/524494251128?text=${msgWA}`} target="_blank" rel="noreferrer"
                    style={{flex:1, background:"#25D366", border:"none", borderRadius:10, padding:"13px 16px", cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", gap:8, textDecoration:"none"}}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="white"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
                    <span style={{fontSize:13, fontWeight:700, color:"white", fontFamily:fontSans}}>WhatsApp</span>
                  </a>
                </div>

                {/* Datos AXIS */}
                <div style={{marginTop:20, paddingTop:16, borderTop:`1px solid ${M.border}`, display:"flex", gap:20, flexWrap:"wrap" as const}}>
                  {[
                    {iconName:"globe", url:"https://axislegalags.com", text:"axislegalags.com"},
                    {iconName:"pin",   text:"Aguascalientes, AGS, México"},
                    {iconName:"phone", text:"449 425 11 28"},
                    {iconName:"mail",  text:"contacto@axislegalags.com"},
                  ].map(c => (
                    <div key={c.text} style={{display:"flex", alignItems:"center", gap:6}}>
                      <AxisIcon name={c.iconName} size={13} tone="gold" withBackdrop={false} strokeWidth={3}/>
                      {c.url
                        ? <a href={c.url} target="_blank" rel="noreferrer" style={{fontSize:11, color:M.gold, textDecoration:"none", fontWeight:600}}>{c.text}</a>
                        : <span style={{fontSize:11, color:M.textSec}}>{c.text}</span>}
                    </div>
                  ))}
                </div>
                <p style={{fontSize:10, color:M.textMut, margin:"12px 0 0", lineHeight:1.6}}>
                  La primera consulta es <strong style={{color:M.goldDark}}>sin costo</strong>. Tu información es confidencial y está protegida conforme a la LFPDPPP. AXIS Legaltech es una herramienta orientativa; las gestiones legales se ejecutan por nuestros abogados o por tu abogado de confianza.
                </p>
              </div>
            </div>
          </div>
        );
      })()}

      {/* Modal Legal */}
      {modalLegal && <ModalLegal tipo={modalLegal} onClose={() => setModalLegal(null)} />}

      {/* Modal correo para PDF */}
      {modalCorreoPDF && (
        <div
          style={{position:"fixed" as const, inset:0, background:"rgba(0,0,0,0.5)", zIndex:500, display:"flex", alignItems:"center", justifyContent:"center", padding:20, backdropFilter:"blur(4px)"}}>
          <div {...PANEL_DE_CAPTURA} onClick={e=>e.stopPropagation()}
            style={{background:"white", borderRadius:20, padding:"36px 40px", maxWidth:440, width:"100%", boxShadow:"0 20px 60px rgba(0,0,0,0.15)"}}>
            <div style={{textAlign:"center" as const, marginBottom:24}}>
              <div style={{fontSize:40, marginBottom:12}}>📄</div>
              <h3 style={{fontFamily:fontSerif, fontSize:22, color:"#0B1829", margin:"0 0 8px"}}>Tu reporte de cumplimiento</h3>
              <p style={{fontSize:13, color:"#4A4A60", margin:0, lineHeight:1.6}}>
                Ingresa tu correo y descarga tu diagnóstico regulatorio en PDF. <strong style={{color:T.gold}}>Descarga inmediata.</strong>
              </p>
            </div>
            <div style={{marginBottom:16}}>
              <label style={{fontSize:11, color:"#9A9AAA", display:"block", marginBottom:6, textTransform:"uppercase" as const, letterSpacing:"0.5px"}}>Correo electrónico</label>
              <input
                value={correoPDF}
                onChange={e => setCorreoPDF(e.target.value)}
                placeholder="correo@empresa.mx"
                type="email"
                autoFocus
                onKeyDown={e => {
                  if (e.key === "Enter" && correoPDF.includes("@")) {
                    // Guardar y generar PDF
                  }
                }}
                style={{width:"100%", padding:"12px 14px", border:"1px solid rgba(0,0,0,0.15)", borderRadius:10, fontSize:14, outline:"none", boxSizing:"border-box" as const, background:"#F7F5F0"}}
              />
            </div>
            <div style={{fontSize:11, color:"#6B7280", marginBottom:20, lineHeight:1.6}}>
              🔒 Tu correo es confidencial y está protegido conforme a nuestra{" "}
              {/* EL AVISO SE ABRE ENCIMA, no en lugar de este panel. Antes lo
                  cerraba para abrirse, y quien había escrito su correo lo perdía:
                  para quien lo usa eso es la misma pérdida que el clic fuera,
                  aunque en el código sea un "ir a" y no un "cerrar".
                  Se eligió no destruir el panel en vez de guardar lo escrito para
                  devolverlo después: no hay nada que recordar ni que restaurar, y
                  al cerrar el aviso el correo sigue donde estaba porque nunca se
                  fue. Lo único que hizo falta es que el aviso pinte por encima. */}
              <button onClick={() => setModalLegal("privacidad")}
                style={{background:"none", border:"none", color:"#D4A843", cursor:"pointer", fontSize:11, padding:0, textDecoration:"underline"}}>
                Política de Privacidad
              </button>.
            </div>
            <button
              disabled={!correoPDF.includes("@") || guardandoCorreo}
              onClick={async () => {
                setGuardandoCorreo(true);
                try {
                  // Guardar correo en Firestore
                  await addDoc(collection(db, "leads_pdf"), {
                    correo: correoPDF,
                    sector: sectorInfo.nombre,
                    sectorId: sectorActivo,
                    especialidad,
                    pct: stats.pct,
                    cumplidas: stats.cumplidas,
                    pendientes: stats.pendientes,
                    fecha: new Date().toLocaleDateString("es-MX"),
                    timestamp: Timestamp.now(),
                  });
                } catch(e) { /* silencioso */ }
                setModalCorreoPDF(false);
                setGuardandoCorreo(false);
                generarPDF();
              }}
              style={{
                width:"100%", background:correoPDF.includes("@")?"linear-gradient(135deg,#B8932A,#A07C30)":"rgba(0,0,0,0.06)",
                border:"none", borderRadius:12, padding:"14px", cursor:correoPDF.includes("@")?"pointer":"not-allowed",
                fontSize:14, fontWeight:700, color:correoPDF.includes("@")?"white":"#9A9AAA",
                transition:"all 0.2s"
              }}>
              {guardandoCorreo ? "Generando..." : "📥 Descargar mi reporte PDF"}
            </button>
            {/* LA SALIDA. Estaba escrita en blanco sobre una tarjeta blanca, así
                que existía en el archivo y no en la pantalla; mientras el fondo
                cerraba, nadie lo notó. Al dejar de cerrar, el panel se convirtió en
                una trampa de la que solo se salía recargando —y es un panel
                PÚBLICO, al final del Diagnóstico—. Mismo gris que el Cancelar de
                los otros dos paneles de correo. */}
            <button onClick={(ev)=>{ if (sePuedeCerrarElPanel(ev)) setModalCorreoPDF(false); }}
              style={{width:"100%", marginTop:10, background:"transparent", border:"none", color:"#9A9AAA", cursor:"pointer", fontSize:12, padding:"8px"}}>
              Cancelar
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

// #endregion
// ─── GATE DE ACCESO PÚBLICO ───────────────────────────────────────────────────

// ─── CUENTA TODAVÍA SIN ACCESO ──────────────────────────────────────────────
// Quien llega con cuenta y no está autorizado ve UNA PANTALLA, no un error de
// permisos, ni una aplicación en blanco, ni un giro infinito. Y su intento se
// registra como lead: alguien que se tomó el trabajo de crear una cuenta y
// entrar es información comercial, no un fallo que haya que esconder.
// LA CUENTA DE TRABAJADOR SUSPENDIDA (activo:false en cuentas_trabajador). La
// enseñan la puerta —que la rechaza— y el candado de cuenta suspendida: una sola
// pantalla, para que nadie registrado lea "pídele a tu patrón que dé de alta tu cuenta".
function PantallaCuentaSuspendida({correo, onSalir, fontSans, fontSerif, gold}:{correo:string; onSalir:()=>void; fontSans:string; fontSerif:string; gold:string}) {
  return (
    <div style={{minHeight:"100vh", background:"linear-gradient(160deg,#0B1829 0%,#0F2040 60%,#162447 100%)", display:"flex", alignItems:"center", justifyContent:"center", padding:"24px", fontFamily:fontSans}}>
      <div style={{width:"100%", maxWidth:420, background:"rgba(255,255,255,0.04)", border:"1px solid rgba(255,255,255,0.12)", borderRadius:18, padding:"30px 26px", textAlign:"center" as const, boxShadow:"0 24px 70px rgba(0,0,0,0.45)"}}>
        <div style={{width:56, height:56, margin:"0 auto 16px", borderRadius:"50%", background:"rgba(220,38,38,0.14)", border:"1px solid rgba(220,38,38,0.35)", display:"flex", alignItems:"center", justifyContent:"center"}}>
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none"><rect x="4.5" y="10.5" width="15" height="9.5" rx="2" stroke="#FCA5A5" strokeWidth="1.7"/><path d="M8 10.5V7.8a4 4 0 018 0v2.7" stroke="#FCA5A5" strokeWidth="1.7" strokeLinecap="round"/></svg>
        </div>
        <div style={{fontFamily:fontSerif, fontSize:20, fontWeight:700, color:"white", marginBottom:8}}>Tu cuenta está suspendida</div>
        <div style={{fontSize:13.5, color:"rgba(255,255,255,0.65)", lineHeight:1.6, marginBottom:20}}>
          Tu acceso al portal fue desactivado por tu empleador. Si crees que es un error, <strong style={{color:"rgba(255,255,255,0.85)"}}>contacta a tu empleador</strong> para que lo revise.
        </div>
        <div style={{fontSize:11.5, color:"rgba(255,255,255,0.35)", marginBottom:20}}>{correo}</div>
        <button onClick={onSalir}
          style={{width:"100%", background:gold, color:"#0B1829", border:"none", borderRadius:12, padding:"13px", cursor:"pointer", fontSize:14, fontWeight:800, fontFamily:fontSans}}>
          Cerrar sesión
        </button>
      </div>
    </div>
  );
}
// ¿QUÉ PANTALLA, SI LA PUERTA DICE QUE NO?
//   · la cuenta de trabajador existe con activo:false → "Tu cuenta está suspendida";
//   · la detección de rol falló o tardó → error con "Reintentar" (no se adivina);
//   · todavía no contesta → cargando;
//   · la cuenta de trabajador existe y está activa, pero la puerta no la deja
//     entrar (su empresa no tiene acceso, o no se pudo confirmar) → una pantalla
//     para trabajadores, sin "dé de alta tu cuenta";
//   · no hay cuenta de trabajador → "Tu cuenta todavía no tiene acceso". ES LA
//     ÚNICA que anota un prospecto (leads_acceso).
function pantallaDelRechazo(cuentaSuspendida:any, esTrabajador:boolean|null, rolError?:boolean): "suspendida"|"error"|"cargando"|"trabajador_sin_empresa"|"sin_acceso" {
  if (cuentaSuspendida) return "suspendida";
  if (rolError) return "error";
  if (esTrabajador === null) return "cargando";
  if (esTrabajador === true) return "trabajador_sin_empresa";
  return "sin_acceso";
}
// CUÁNTO SE ESPERA A LA DETECCIÓN DE ROL antes de decir que no se pudo: 10 s. Una
// lectura de un documento tarda menos de un segundo con red normal; con mala red,
// diez segundos dejan margen y no tienen a nadie mirando "Cargando…" sin salida.
const MS_DETECCION_DE_ROL = 10000;
function conLimiteDeTiempo<T>(p: Promise<T>, ms: number): Promise<T> {
  return new Promise<T>((resolver, rechazar) => {
    const t = setTimeout(() => rechazar(Object.assign(new Error("tiempo agotado"), {code: "deadline-exceeded"})), ms);
    p.then((v) => { clearTimeout(t); resolver(v); }, (e) => { clearTimeout(t); rechazar(e); });
  });
}
// NO SE PUDO COMPROBAR LA CUENTA (la lectura falló o tardó). Se dice y se ofrece
// reintentar; no se adivina el rol ni se anota como prospecto.
function PantallaErrorDeCuenta({onReintentar, onSalir, fontSans, fontSerif, gold}:{onReintentar:()=>void; onSalir:()=>void; fontSans:string; fontSerif:string; gold:string}) {
  return (
    <div style={{minHeight:"100vh", background:"linear-gradient(160deg,#0B1829 0%,#0F2040 60%,#162447 100%)", display:"flex", alignItems:"center", justifyContent:"center", padding:"24px", fontFamily:fontSans}}>
      <div role="alert" style={{width:"100%", maxWidth:420, background:"rgba(255,255,255,0.04)", border:"1px solid rgba(255,255,255,0.12)", borderRadius:18, padding:"30px 26px", textAlign:"center" as const}}>
        <div style={{fontFamily:fontSerif, fontSize:20, fontWeight:700, color:"white", marginBottom:8}}>No pudimos comprobar tu cuenta</div>
        <div style={{fontSize:13.5, color:"rgba(255,255,255,0.65)", lineHeight:1.6, marginBottom:20}}>Revisa tu conexión y vuelve a intentarlo.</div>
        <button onClick={onReintentar} style={{width:"100%", background:gold, color:"#0B1829", border:"none", borderRadius:12, padding:"13px", cursor:"pointer", fontSize:14, fontWeight:800, fontFamily:fontSans, marginBottom:10}}>Reintentar</button>
        <button onClick={onSalir} style={{width:"100%", background:"transparent", color:"rgba(255,255,255,0.7)", border:"1px solid rgba(255,255,255,0.18)", borderRadius:12, padding:"11px", cursor:"pointer", fontSize:13, fontWeight:700, fontFamily:fontSans}}>Cerrar sesión</button>
      </div>
    </div>
  );
}
// UN TRABAJADOR REGISTRADO CUYA EMPRESA NO TIENE ACCESO (o no se pudo confirmar).
// Nunca "pídele a tu patrón que dé de alta tu cuenta": su cuenta ya existe. Y no
// se anota como prospecto.
function PantallaTrabajadorSinAccesoDeEmpresa({correo, onSalir, fontSans, fontSerif, gold}:{correo:string; onSalir:()=>void; fontSans:string; fontSerif:string; gold:string}) {
  return (
    <div style={{minHeight:"100vh", background:"linear-gradient(160deg,#0B1829 0%,#0F2040 60%,#162447 100%)", display:"flex", alignItems:"center", justifyContent:"center", padding:"24px", fontFamily:fontSans}}>
      <div style={{width:"100%", maxWidth:420, background:"rgba(255,255,255,0.04)", border:"1px solid rgba(255,255,255,0.12)", borderRadius:18, padding:"30px 26px", textAlign:"center" as const}}>
        <div style={{fontFamily:fontSerif, fontSize:20, fontWeight:700, color:"white", marginBottom:8}}>Tu cuenta está registrada</div>
        <div style={{fontSize:13.5, color:"rgba(255,255,255,0.65)", lineHeight:1.6, marginBottom:20}}>
          Tu cuenta de trabajador existe, pero no pudimos confirmar que tu empresa tenga acceso a AXIS. Coméntalo con tu patrón.
        </div>
        <div style={{fontSize:11.5, color:"rgba(255,255,255,0.35)", marginBottom:20}}>{correo}</div>
        <button onClick={onSalir} style={{width:"100%", background:gold, color:"#0B1829", border:"none", borderRadius:12, padding:"13px", cursor:"pointer", fontSize:14, fontWeight:800, fontFamily:fontSans}}>Cerrar sesión</button>
      </div>
    </div>
  );
}
function PantallaSinAcceso({user, onSalir, fontSans, fontSerif}: {
  user:any; onSalir:()=>void; fontSans:string; fontSerif:string;
}) {
  const [avisado, setAvisado] = useState(false);
  useEffect(() => {
    const correo = String(user?.email||"").toLowerCase().trim();
    if (!correo || avisado) return;
    setAvisado(true);
    // Una sola vez por sesión y a prueba de fallos: si el registro del lead no
    // se puede escribir, la persona igual ve la pantalla. Nunca al revés.
    (async () => {
      try {
        await setDoc(doc(db, "leads_acceso", correo), {
          correo,
          nombre: user?.displayName || "",
          uid: user?.uid || "",
          intentos: increment(1),
          ultimoIntento: Timestamp.now(),
          timestamp: Timestamp.now(),
        }, {merge:true});
      } catch(e) { console.warn("lead de acceso:", e); }
    })();
  }, [user?.email]);   // eslint-disable-line

  return (
    <div style={{minHeight:"100vh", background:"linear-gradient(160deg,#0B1829 0%,#162447 50%,#1B3358 100%)",
      display:"flex", alignItems:"center", justifyContent:"center", padding:20, fontFamily:fontSans}}>
      <div style={{background:"rgba(255,255,255,0.04)", border:"1px solid rgba(184,147,42,0.22)", borderRadius:20,
        padding:"38px 40px", maxWidth:460, width:"100%", boxShadow:"0 24px 64px rgba(0,0,0,0.4)", textAlign:"center" as const}}>
        <div style={{width:58, height:58, background:"linear-gradient(135deg,#B8932A,#D4A843)", borderRadius:15,
          display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 18px"}}>
          <span style={{fontFamily:fontSerif, fontSize:24, fontWeight:900, color:"#0B1829"}}>AX</span>
        </div>
        <h2 style={{fontFamily:fontSerif, fontSize:23, color:"white", margin:"0 0 10px", lineHeight:1.25}}>
          Tu cuenta todavía no tiene acceso
        </h2>
        <p style={{fontSize:13.5, color:"rgba(255,255,255,0.72)", lineHeight:1.6, margin:"0 0 6px"}}>
          Entraste como <strong style={{color:"#E2B84A"}}>{user?.email}</strong>. La plataforma está
          {" "}disponible para clientes de AXIS, y esta cuenta aún no está dada de alta.
        </p>
        <p style={{fontSize:13.5, color:"rgba(255,255,255,0.72)", lineHeight:1.6, margin:"0 0 20px"}}>
          Ya avisamos de tu solicitud. Si quieres adelantarlo, escríbenos a{" "}
          <a href="mailto:contacto@axislegalags.com" style={{color:"#E2B84A", fontWeight:700}}>contacto@axislegalags.com</a>.
        </p>
        <p style={{fontSize:12, color:"rgba(255,255,255,0.5)", lineHeight:1.55, margin:"0 0 18px"}}>
          Si eres trabajador de una empresa que ya usa AXIS, pídele a tu patrón que dé de alta tu cuenta:
          {" "}el acceso de los trabajadores depende del de su empresa.
        </p>
        <button onClick={onSalir}
          style={{background:"rgba(255,255,255,0.08)", border:"1px solid rgba(255,255,255,0.18)", color:"white",
            borderRadius:10, padding:"11px 20px", cursor:"pointer", fontSize:13, fontWeight:700, fontFamily:fontSans}}>
          Cerrar sesión
        </button>
      </div>
    </div>
  );
}
// ═══ HAY UNA VERSIÓN NUEVA (11-oct-2026) ═════════════════════════════════════
// Una pestaña abierta, o la plataforma instalada que vuelve de segundo plano,
// sigue con el código con que se abrió: después de un despliegue nadie la
// recargaba. Ahora se pregunta a /version.json (sin caché) al abrir, al volver a
// primer plano y cada 15 minutos, y lo decide `decidirActualizacion`
// (src/logica/version.js):
//   · otra versión → franja "Hay una versión nueva…" con "Actualizar";
//   · por debajo de la versión mínima → "Actualizando la plataforma…" y recarga
//     sola, PERO nunca con un panel con algo sin guardar ("Guarda lo que estás
//     capturando para actualizar") ni con una checada a medias (espera a que se
//     guarde).
// La franja va en el flujo de la página, arriba de todo: empuja, no tapa nada.

// LA CHECADA EN CURSO, para toda la plataforma. La marca la pantalla del checador
// del trabajador; la lee la actualización forzada.
const _checadaEnCurso = {activa: false};
const EVT_CHECADA_EN_CURSO = "axis:checadaEnCurso";
function marcarChecadaEnCurso(v: boolean): void {
  const antes = _checadaEnCurso.activa; _checadaEnCurso.activa = !!v;
  if (antes !== _checadaEnCurso.activa) { try { window.dispatchEvent(new CustomEvent(EVT_CHECADA_EN_CURSO)); } catch (_e) {} }
}
function hayChecadaEnCurso(): boolean { return _checadaEnCurso.activa; }

async function leerVersionDelServidor(): Promise<any> {
  try {
    const r = await fetch(RUTA_VERSION + "?t=" + Date.now(), { cache: "no-store" } as any);
    if (!r || !r.ok) return null;
    return leerVersionServida(await r.json());
  } catch (_e) { return null; }   // sin red o sin archivo: no se afirma nada
}
// Cuántas veces ya se recargó a la fuerza por ESTA versión servida (en esta
// pestaña): si el navegador insiste en el código viejo, no se recarga en bucle.
function recargasForzadasPor(version: string): number {
  try { const g = JSON.parse(sessionStorage.getItem(CLAVE_RECARGAS) || "null"); return g && g.v === version ? Number(g.n) || 0 : 0; } catch (_e) { return 0; }
}
function anotarRecargaForzada(version: string): void {
  try { sessionStorage.setItem(CLAVE_RECARGAS, JSON.stringify({v: version, n: recargasForzadasPor(version) + 1})); } catch (_e) {}
}
function recargarPagina(): void { window.location.reload(); }
// ¿HAY UN SERVICE WORKER NUEVO ESPERANDO? (el de la página, /sw.js). Desde el
// 11-oct un service worker nuevo no se activa solo ni recarga la página: espera,
// y esta franja lo trata como una versión nueva. Solo cuenta si ya hay uno
// activo controlando la página: el PRIMERO de un navegador no espera.
async function swNuevoEsperando(buscar: boolean): Promise<boolean> {
  try {
    const sw: any = (navigator as any).serviceWorker;
    if (!sw || !sw.getRegistration || !sw.controller) return false;
    const reg: any = await sw.getRegistration("/");
    if (!reg) return false;
    if (buscar) { try { await reg.update(); } catch (_e) {} }
    return !!reg.waiting;
  } catch (_e) { return false; }
}
// ACTUALIZAR: que el service worker de la página (/sw.js) busque el suyo nuevo y,
// si hay uno esperando, que se active (y esperar a que tome control, con tope),
// borrar las cachés del código, y recargar. Nada de esto puede impedir la
// recarga: si algo falla, se recarga igual.
async function limpiarYRecargar(): Promise<void> {
  try {
    const sw: any = (navigator as any).serviceWorker;
    if (sw && sw.getRegistration) {
      const reg: any = await sw.getRegistration("/");
      if (reg) {
        try { await reg.update(); } catch (_e) {}
        const esperando: any = reg.waiting;
        if (esperando) await new Promise<void>((listo) => {
          const t = setTimeout(listo, 3000);
          try { sw.addEventListener("controllerchange", () => { clearTimeout(t); listo(); }, {once: true}); } catch (_e) {}
          esperando.postMessage("SKIP_WAITING");
        });
      }
    }
  } catch (_e) {}
  try {
    if (typeof caches !== "undefined") { const ks = await caches.keys(); await Promise.all(ks.map((k: string) => caches.delete(k))); }
  } catch (_e) {}
  recargarPagina();
}

function FranjaVersionNueva({fontSans}: {fontSans: string}) {
  const cargada = versionCargada();
  const [servida, setServida] = useState<any>(null);
  const [swEsperando, setSwEsperando] = useState(false);
  const [, setVuelta] = useState(0);
  const otraVuelta = () => setVuelta((n) => n + 1);
  const recargandoRef = useRef(false);

  // AL ABRIR, AL VOLVER A PRIMER PLANO Y CADA 15 MINUTOS: /version.json, y si hay
  // un service worker nuevo esperando.
  useEffect(() => {
    if (!cargada) return;
    let vivo = true;
    const revisar = async () => {
      const s = await leerVersionDelServidor(); if (vivo && s) setServida(s);
      const e = await swNuevoEsperando(true); if (vivo) setSwEsperando(e);
    };
    revisar();
    const alVolver = () => { if (document.visibilityState === "visible") revisar(); };
    document.addEventListener("visibilitychange", alVolver);
    const t = setInterval(revisar, INTERVALO_REVISION_MS);
    return () => { vivo = false; clearInterval(t); document.removeEventListener("visibilitychange", alVolver); };
  }, [cargada]);
  // Cuando la checada empieza o termina, se vuelve a decidir.
  useEffect(() => {
    window.addEventListener(EVT_CHECADA_EN_CURSO, otraVuelta);
    return () => window.removeEventListener(EVT_CHECADA_EN_CURSO, otraVuelta);
  }, []);

  const d = decidirActualizacion({cargada, nivelCargado: NIVEL_MINIMO, servida, swEsperando,
    hayCaptura: hayCapturaSinGuardar(), hayChecada: hayChecadaEnCurso(),
    recargasForzadas: servida ? recargasForzadasPor(servida.version) : 0});
  const pendiente = d.franja === "guarda" || (d.franja === "actualizando" && !d.recargar);

  // PENDIENTE (algo sin guardar, o una checada a medias): se vuelve a mirar cada
  // pocos segundos, sin red. En cuanto se guarda o se cierra, sigue sola.
  useEffect(() => {
    if (!pendiente) return;
    const t = setInterval(otraVuelta, INTERVALO_PENDIENTE_MS);
    return () => clearInterval(t);
  }, [pendiente]);
  // LA RECARGA FORZADA. Justo antes de recargar se pregunta OTRA VEZ: en esa
  // pausa pudo empezar una checada o escribirse algo.
  useEffect(() => {
    if (!d.recargar || recargandoRef.current || !servida) return;
    recargandoRef.current = true;
    setTimeout(() => {
      if (hayCapturaSinGuardar() || hayChecadaEnCurso()) { recargandoRef.current = false; otraVuelta(); return; }
      anotarRecargaForzada(servida.version);
      limpiarYRecargar();
    }, PAUSA_ANTES_DE_RECARGAR_MS);
  }, [d.recargar, servida]);

  if (!d.franja) return null;
  const actualizar = () => {
    if (hayCapturaSinGuardar() && !window.confirm(TEXTO_CONFIRMAR_ACTUALIZAR_CON_CAPTURA)) return;
    limpiarYRecargar();
  };
  return (
    <div role="status" data-franja-version={d.franja}
      style={{position: "relative" as const, display: "flex", alignItems: "center", justifyContent: "center", gap: 12, flexWrap: "wrap" as const,
        background: "#B8932A", color: "#0B1829", padding: "8px 14px", fontFamily: fontSans, fontSize: 13, fontWeight: 700, lineHeight: 1.4}}>
      <span>{textoDeFranja(d.franja)}</span>
      {d.franja === "nueva" && (
        <button type="button" onClick={actualizar}
          style={{background: "#0B1829", color: "#FFFFFF", border: "none", borderRadius: 8, padding: "6px 14px", fontFamily: fontSans, fontSize: 12.5, fontWeight: 800, cursor: "pointer"}}>
          {TEXTO_BOTON_ACTUALIZAR}
        </button>
      )}
    </div>
  );
}

function GateWrapper() {
  // LA REJA DE CONTRASENA COMPARTIDA SE RETIRO.
  //
  // Guardaba en localStorage la constante "axis2025" —no la contrasena que se
  // tecleaba—, asi que cambiarla desde el panel no revocaba a nadie: cualquier
  // navegador que hubiera pasado una vez seguia entrando para siempre. Y la
  // contrasena viajaba en claro dentro de configuracion/app, que tenia lectura
  // abierta: cualquiera sin sesion podia leerla desde la consola del navegador.
  //
  // Con cuenta real y lista de autorizados, esa capa no protegia nada y
  // confundia sobre cual de las dos estaba protegiendo que. Quien decide quien
  // entra es la lista, y quien lo hace cumplir son las reglas de Firestore.
  const fontSerif = "'Cormorant Garamond', Georgia, serif";
  // Render-gate del búho AXIOR controlado por App (no se monta en la bienvenida).
  // Arranca oculto si la entrada es la bienvenida (sin deep-link conductor/calendario),
  // para que NO parpadee en la carga inicial (móvil); App lo actualiza al navegar.
  // ARRANCA OCULTO SIEMPRE, también con enlace directo (conductor / calendario):
  // hasta que la puerta de acceso contesta, no se sabe si esta persona puede usar
  // AXIOR, y un búho visible durante la carga es un búho antes de la puerta. App
  // lo muestra en cuanto la puerta dice que sí.
  const [axiorOculto, setAxiorOculto] = useState(true);
  // Apaga SOLO el lanzador flotante de AXIOR (no el chat) — para el portal del
  // patrón móvil. Arranca según isMobile para no parpadear en la carga inicial;
  // App lo ajusta a la condición real. En escritorio queda visible como hoy.
  const [axiorLanzadorOff, setAxiorLanzadorOff] = useState(() => { try { return window.innerWidth < 768; } catch { return false; } });

  return (
    <div style={{minHeight:"100vh", background:"#0B1829"}}>
      {/* Arriba de todo y en el flujo: empuja la página, no tapa ningún botón. */}
      <FranjaVersionNueva fontSans={"'DM Sans', 'Inter', sans-serif"} />
      <App onAxiorOcultoChange={setAxiorOculto} onAxiorLanzadorChange={setAxiorLanzadorOff} />
      {/* El aviso que no se pudo mostrar como notificación del sistema. */}
      <AvisosEnPagina />

      {!axiorOculto && <AxiorChat fontSans={"'DM Sans', 'Inter', sans-serif"} fontSerif={"'Cormorant Garamond', Georgia, serif"} gold={"#B8932A"} ocultarLanzador={axiorLanzadorOff} />}
    </div>
  );
}

export default GateWrapper
